(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("k8vLt", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ea8d31cc9e1b6c4f$export$6503ec6e8aabbaf; }, function (v) { return $ea8d31cc9e1b6c4f$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ea8d31cc9e1b6c4f$export$f7ad0328861e2f03; }, function (v) { return $ea8d31cc9e1b6c4f$export$f7ad0328861e2f03 = v; });
var $ea8d31cc9e1b6c4f$export$6503ec6e8aabbaf;
var $ea8d31cc9e1b6c4f$export$f7ad0328861e2f03;
"use strict";
var $ea8d31cc9e1b6c4f$var$mapping = new Map();
function $ea8d31cc9e1b6c4f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ea8d31cc9e1b6c4f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ea8d31cc9e1b6c4f$var$resolve(id) {
    var resolved = $ea8d31cc9e1b6c4f$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ea8d31cc9e1b6c4f$export$6503ec6e8aabbaf = $ea8d31cc9e1b6c4f$var$register;
$ea8d31cc9e1b6c4f$export$f7ad0328861e2f03 = $ea8d31cc9e1b6c4f$var$resolve;

});

parcelRegister("4XRWO", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $39d684fad94a9a6e$export$bdfd709ae4826697; }, function (v) { return $39d684fad94a9a6e$export$bdfd709ae4826697 = v; });
var $39d684fad94a9a6e$export$bdfd709ae4826697;
var $39d684fad94a9a6e$export$c9e73fbda7da57b6;
var $39d684fad94a9a6e$export$5a759dc7a1cfb72a;
"use strict";
var $39d684fad94a9a6e$var$bundleURL = {};
function $39d684fad94a9a6e$var$getBundleURLCached(id) {
    var value = $39d684fad94a9a6e$var$bundleURL[id];
    if (!value) {
        value = $39d684fad94a9a6e$var$getBundleURL();
        $39d684fad94a9a6e$var$bundleURL[id] = value;
    }
    return value;
}
function $39d684fad94a9a6e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $39d684fad94a9a6e$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $39d684fad94a9a6e$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $39d684fad94a9a6e$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$39d684fad94a9a6e$export$bdfd709ae4826697 = $39d684fad94a9a6e$var$getBundleURLCached;
$39d684fad94a9a6e$export$c9e73fbda7da57b6 = $39d684fad94a9a6e$var$getBaseURL;
$39d684fad94a9a6e$export$5a759dc7a1cfb72a = $39d684fad94a9a6e$var$getOrigin;

});

parcelRegister("6CtE1", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4d1d4977434502db$export$ffb0004e005737fa; });
$parcel$export(module.exports, "jsx", function () { return $4d1d4977434502db$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $4d1d4977434502db$export$25062201e9e25d76; });

var $lI4rk = parcelRequire("lI4rk");
const $4d1d4977434502db$export$ffb0004e005737fa = $lI4rk.Fragment;
const $4d1d4977434502db$export$34b9dba7ce09269b = $lI4rk.jsx;
const $4d1d4977434502db$export$25062201e9e25d76 = $lI4rk.jsxs;

});
parcelRegister("lI4rk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g4qPx"));

});
parcelRegister("g4qPx", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $bb31d4ff2a2f5bbd$export$ffb0004e005737fa; }, function (v) { return $bb31d4ff2a2f5bbd$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $bb31d4ff2a2f5bbd$export$34b9dba7ce09269b; }, function (v) { return $bb31d4ff2a2f5bbd$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $bb31d4ff2a2f5bbd$export$25062201e9e25d76; }, function (v) { return $bb31d4ff2a2f5bbd$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb31d4ff2a2f5bbd$export$ffb0004e005737fa;
var $bb31d4ff2a2f5bbd$export$34b9dba7ce09269b;
var $bb31d4ff2a2f5bbd$export$25062201e9e25d76;
'use strict';

var $dNMDr = parcelRequire("dNMDr");
var $bb31d4ff2a2f5bbd$var$k = Symbol.for("react.element"), $bb31d4ff2a2f5bbd$var$l = Symbol.for("react.fragment"), $bb31d4ff2a2f5bbd$var$m = Object.prototype.hasOwnProperty, $bb31d4ff2a2f5bbd$var$n = $dNMDr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $bb31d4ff2a2f5bbd$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bb31d4ff2a2f5bbd$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$bb31d4ff2a2f5bbd$var$m.call(a, b) && !$bb31d4ff2a2f5bbd$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $bb31d4ff2a2f5bbd$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $bb31d4ff2a2f5bbd$var$n.current
    };
}
$bb31d4ff2a2f5bbd$export$ffb0004e005737fa = $bb31d4ff2a2f5bbd$var$l;
$bb31d4ff2a2f5bbd$export$34b9dba7ce09269b = $bb31d4ff2a2f5bbd$var$q;
$bb31d4ff2a2f5bbd$export$25062201e9e25d76 = $bb31d4ff2a2f5bbd$var$q;

});
parcelRegister("dNMDr", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7AHAl"));

});
parcelRegister("7AHAl", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $586db44cc863cfb9$export$dca3b0875bd9a954; }, function (v) { return $586db44cc863cfb9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $586db44cc863cfb9$export$16fa2f45be04daa8; }, function (v) { return $586db44cc863cfb9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $586db44cc863cfb9$export$ffb0004e005737fa; }, function (v) { return $586db44cc863cfb9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $586db44cc863cfb9$export$e2c29f18771995cb; }, function (v) { return $586db44cc863cfb9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $586db44cc863cfb9$export$221d75b3f55bb0bd; }, function (v) { return $586db44cc863cfb9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $586db44cc863cfb9$export$5f8d39834fd61797; }, function (v) { return $586db44cc863cfb9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $586db44cc863cfb9$export$74bf444e3cd11ea5; }, function (v) { return $586db44cc863cfb9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $586db44cc863cfb9$export$ae55be85d98224ed; }, function (v) { return $586db44cc863cfb9$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $586db44cc863cfb9$export$3ba232387fd5d6dd; }, function (v) { return $586db44cc863cfb9$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $586db44cc863cfb9$export$e530037191fcd5d7; }, function (v) { return $586db44cc863cfb9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $586db44cc863cfb9$export$fd42f52fd3ae1109; }, function (v) { return $586db44cc863cfb9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $586db44cc863cfb9$export$c8a8987d4410bf2d; }, function (v) { return $586db44cc863cfb9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $586db44cc863cfb9$export$d38cd72104c1f0e9; }, function (v) { return $586db44cc863cfb9$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $586db44cc863cfb9$export$7d1e3a5e95ceca43; }, function (v) { return $586db44cc863cfb9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $586db44cc863cfb9$export$257a8862b851cb5b; }, function (v) { return $586db44cc863cfb9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $586db44cc863cfb9$export$a8257692ac88316c; }, function (v) { return $586db44cc863cfb9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $586db44cc863cfb9$export$488013bae63b21da; }, function (v) { return $586db44cc863cfb9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $586db44cc863cfb9$export$7c73462e0d25e514; }, function (v) { return $586db44cc863cfb9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $586db44cc863cfb9$export$7568632d0d33d16d; }, function (v) { return $586db44cc863cfb9$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $586db44cc863cfb9$export$88948ce120ea2619; }, function (v) { return $586db44cc863cfb9$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $586db44cc863cfb9$export$35808ee640e87ca7; }, function (v) { return $586db44cc863cfb9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $586db44cc863cfb9$export$fae74005e78b1a27; }, function (v) { return $586db44cc863cfb9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $586db44cc863cfb9$export$dc8fbce3eb94dc1e; }, function (v) { return $586db44cc863cfb9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $586db44cc863cfb9$export$6a7bc4e911dc01cf; }, function (v) { return $586db44cc863cfb9$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $586db44cc863cfb9$export$6d9c69b0de29b591; }, function (v) { return $586db44cc863cfb9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $586db44cc863cfb9$export$f680877a34711e37; }, function (v) { return $586db44cc863cfb9$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $586db44cc863cfb9$export$d5a552a76deda3c2; }, function (v) { return $586db44cc863cfb9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $586db44cc863cfb9$export$aaabe4eda9ed9969; }, function (v) { return $586db44cc863cfb9$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $586db44cc863cfb9$export$e5c5a5f917a5871c; }, function (v) { return $586db44cc863cfb9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $586db44cc863cfb9$export$1538c33de8887b59; }, function (v) { return $586db44cc863cfb9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $586db44cc863cfb9$export$13e3392192263954; }, function (v) { return $586db44cc863cfb9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $586db44cc863cfb9$export$b8f5890fc79d6aca; }, function (v) { return $586db44cc863cfb9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $586db44cc863cfb9$export$60241385465d0a34; }, function (v) { return $586db44cc863cfb9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $586db44cc863cfb9$export$306c0aa65ff9ec16; }, function (v) { return $586db44cc863cfb9$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $586db44cc863cfb9$export$7b286972b8d8ccbf; }, function (v) { return $586db44cc863cfb9$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $586db44cc863cfb9$export$83d89fbfd8236492; }, function (v) { return $586db44cc863cfb9$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $586db44cc863cfb9$export$dca3b0875bd9a954;
var $586db44cc863cfb9$export$16fa2f45be04daa8;
var $586db44cc863cfb9$export$ffb0004e005737fa;
var $586db44cc863cfb9$export$e2c29f18771995cb;
var $586db44cc863cfb9$export$221d75b3f55bb0bd;
var $586db44cc863cfb9$export$5f8d39834fd61797;
var $586db44cc863cfb9$export$74bf444e3cd11ea5;
var $586db44cc863cfb9$export$ae55be85d98224ed;
var $586db44cc863cfb9$export$3ba232387fd5d6dd;
var $586db44cc863cfb9$export$e530037191fcd5d7;
var $586db44cc863cfb9$export$fd42f52fd3ae1109;
var $586db44cc863cfb9$export$c8a8987d4410bf2d;
var $586db44cc863cfb9$export$d38cd72104c1f0e9;
var $586db44cc863cfb9$export$7d1e3a5e95ceca43;
var $586db44cc863cfb9$export$257a8862b851cb5b;
var $586db44cc863cfb9$export$a8257692ac88316c;
var $586db44cc863cfb9$export$488013bae63b21da;
var $586db44cc863cfb9$export$7c73462e0d25e514;
var $586db44cc863cfb9$export$7568632d0d33d16d;
var $586db44cc863cfb9$export$88948ce120ea2619;
var $586db44cc863cfb9$export$35808ee640e87ca7;
var $586db44cc863cfb9$export$fae74005e78b1a27;
var $586db44cc863cfb9$export$dc8fbce3eb94dc1e;
var $586db44cc863cfb9$export$6a7bc4e911dc01cf;
var $586db44cc863cfb9$export$6d9c69b0de29b591;
var $586db44cc863cfb9$export$f680877a34711e37;
var $586db44cc863cfb9$export$d5a552a76deda3c2;
var $586db44cc863cfb9$export$aaabe4eda9ed9969;
var $586db44cc863cfb9$export$e5c5a5f917a5871c;
var $586db44cc863cfb9$export$1538c33de8887b59;
var $586db44cc863cfb9$export$13e3392192263954;
var $586db44cc863cfb9$export$b8f5890fc79d6aca;
var $586db44cc863cfb9$export$60241385465d0a34;
var $586db44cc863cfb9$export$306c0aa65ff9ec16;
var $586db44cc863cfb9$export$7b286972b8d8ccbf;
var $586db44cc863cfb9$export$83d89fbfd8236492;
'use strict';
var $586db44cc863cfb9$var$l = Symbol.for("react.element"), $586db44cc863cfb9$var$n = Symbol.for("react.portal"), $586db44cc863cfb9$var$p = Symbol.for("react.fragment"), $586db44cc863cfb9$var$q = Symbol.for("react.strict_mode"), $586db44cc863cfb9$var$r = Symbol.for("react.profiler"), $586db44cc863cfb9$var$t = Symbol.for("react.provider"), $586db44cc863cfb9$var$u = Symbol.for("react.context"), $586db44cc863cfb9$var$v = Symbol.for("react.forward_ref"), $586db44cc863cfb9$var$w = Symbol.for("react.suspense"), $586db44cc863cfb9$var$x = Symbol.for("react.memo"), $586db44cc863cfb9$var$y = Symbol.for("react.lazy"), $586db44cc863cfb9$var$z = Symbol.iterator;
function $586db44cc863cfb9$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $586db44cc863cfb9$var$z && a[$586db44cc863cfb9$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $586db44cc863cfb9$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $586db44cc863cfb9$var$C = Object.assign, $586db44cc863cfb9$var$D = {};
function $586db44cc863cfb9$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $586db44cc863cfb9$var$D;
    this.updater = e || $586db44cc863cfb9$var$B;
}
$586db44cc863cfb9$var$E.prototype.isReactComponent = {};
$586db44cc863cfb9$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$586db44cc863cfb9$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $586db44cc863cfb9$var$F() {}
$586db44cc863cfb9$var$F.prototype = $586db44cc863cfb9$var$E.prototype;
function $586db44cc863cfb9$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $586db44cc863cfb9$var$D;
    this.updater = e || $586db44cc863cfb9$var$B;
}
var $586db44cc863cfb9$var$H = $586db44cc863cfb9$var$G.prototype = new $586db44cc863cfb9$var$F;
$586db44cc863cfb9$var$H.constructor = $586db44cc863cfb9$var$G;
$586db44cc863cfb9$var$C($586db44cc863cfb9$var$H, $586db44cc863cfb9$var$E.prototype);
$586db44cc863cfb9$var$H.isPureReactComponent = !0;
var $586db44cc863cfb9$var$I = Array.isArray, $586db44cc863cfb9$var$J = Object.prototype.hasOwnProperty, $586db44cc863cfb9$var$K = {
    current: null
}, $586db44cc863cfb9$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $586db44cc863cfb9$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$586db44cc863cfb9$var$J.call(b, d) && !$586db44cc863cfb9$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $586db44cc863cfb9$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $586db44cc863cfb9$var$K.current
    };
}
function $586db44cc863cfb9$var$N(a, b) {
    return {
        $$typeof: $586db44cc863cfb9$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $586db44cc863cfb9$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $586db44cc863cfb9$var$l;
}
function $586db44cc863cfb9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $586db44cc863cfb9$var$P = /\/+/g;
function $586db44cc863cfb9$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $586db44cc863cfb9$var$escape("" + a.key) : b.toString(36);
}
function $586db44cc863cfb9$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $586db44cc863cfb9$var$l:
                case $586db44cc863cfb9$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $586db44cc863cfb9$var$Q(h, 0) : d, $586db44cc863cfb9$var$I(c) ? (e = "", null != a && (e = a.replace($586db44cc863cfb9$var$P, "$&/") + "/"), $586db44cc863cfb9$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($586db44cc863cfb9$var$O(c) && (c = $586db44cc863cfb9$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($586db44cc863cfb9$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($586db44cc863cfb9$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $586db44cc863cfb9$var$Q(k, g);
        h += $586db44cc863cfb9$var$R(k, b, e, f, c);
    }
    else if (f = $586db44cc863cfb9$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $586db44cc863cfb9$var$Q(k, g++), h += $586db44cc863cfb9$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $586db44cc863cfb9$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $586db44cc863cfb9$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $586db44cc863cfb9$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $586db44cc863cfb9$var$U = {
    current: null
}, $586db44cc863cfb9$var$V = {
    transition: null
}, $586db44cc863cfb9$var$W = {
    ReactCurrentDispatcher: $586db44cc863cfb9$var$U,
    ReactCurrentBatchConfig: $586db44cc863cfb9$var$V,
    ReactCurrentOwner: $586db44cc863cfb9$var$K
};
function $586db44cc863cfb9$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$586db44cc863cfb9$export$dca3b0875bd9a954 = {
    map: $586db44cc863cfb9$var$S,
    forEach: function(a, b, e) {
        $586db44cc863cfb9$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $586db44cc863cfb9$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $586db44cc863cfb9$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$586db44cc863cfb9$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$586db44cc863cfb9$export$16fa2f45be04daa8 = $586db44cc863cfb9$var$E;
$586db44cc863cfb9$export$ffb0004e005737fa = $586db44cc863cfb9$var$p;
$586db44cc863cfb9$export$e2c29f18771995cb = $586db44cc863cfb9$var$r;
$586db44cc863cfb9$export$221d75b3f55bb0bd = $586db44cc863cfb9$var$G;
$586db44cc863cfb9$export$5f8d39834fd61797 = $586db44cc863cfb9$var$q;
$586db44cc863cfb9$export$74bf444e3cd11ea5 = $586db44cc863cfb9$var$w;
$586db44cc863cfb9$export$ae55be85d98224ed = $586db44cc863cfb9$var$W;
$586db44cc863cfb9$export$3ba232387fd5d6dd = $586db44cc863cfb9$var$X;
$586db44cc863cfb9$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $586db44cc863cfb9$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $586db44cc863cfb9$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$586db44cc863cfb9$var$J.call(b, f) && !$586db44cc863cfb9$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $586db44cc863cfb9$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$586db44cc863cfb9$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $586db44cc863cfb9$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $586db44cc863cfb9$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$586db44cc863cfb9$export$c8a8987d4410bf2d = $586db44cc863cfb9$var$M;
$586db44cc863cfb9$export$d38cd72104c1f0e9 = function(a) {
    var b = $586db44cc863cfb9$var$M.bind(null, a);
    b.type = a;
    return b;
};
$586db44cc863cfb9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$586db44cc863cfb9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $586db44cc863cfb9$var$v,
        render: a
    };
};
$586db44cc863cfb9$export$a8257692ac88316c = $586db44cc863cfb9$var$O;
$586db44cc863cfb9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $586db44cc863cfb9$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $586db44cc863cfb9$var$T
    };
};
$586db44cc863cfb9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $586db44cc863cfb9$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$586db44cc863cfb9$export$7568632d0d33d16d = function(a) {
    var b = $586db44cc863cfb9$var$V.transition;
    $586db44cc863cfb9$var$V.transition = {};
    try {
        a();
    } finally{
        $586db44cc863cfb9$var$V.transition = b;
    }
};
$586db44cc863cfb9$export$88948ce120ea2619 = $586db44cc863cfb9$var$X;
$586db44cc863cfb9$export$35808ee640e87ca7 = function(a, b) {
    return $586db44cc863cfb9$var$U.current.useCallback(a, b);
};
$586db44cc863cfb9$export$fae74005e78b1a27 = function(a) {
    return $586db44cc863cfb9$var$U.current.useContext(a);
};
$586db44cc863cfb9$export$dc8fbce3eb94dc1e = function() {};
$586db44cc863cfb9$export$6a7bc4e911dc01cf = function(a) {
    return $586db44cc863cfb9$var$U.current.useDeferredValue(a);
};
$586db44cc863cfb9$export$6d9c69b0de29b591 = function(a, b) {
    return $586db44cc863cfb9$var$U.current.useEffect(a, b);
};
$586db44cc863cfb9$export$f680877a34711e37 = function() {
    return $586db44cc863cfb9$var$U.current.useId();
};
$586db44cc863cfb9$export$d5a552a76deda3c2 = function(a, b, e) {
    return $586db44cc863cfb9$var$U.current.useImperativeHandle(a, b, e);
};
$586db44cc863cfb9$export$aaabe4eda9ed9969 = function(a, b) {
    return $586db44cc863cfb9$var$U.current.useInsertionEffect(a, b);
};
$586db44cc863cfb9$export$e5c5a5f917a5871c = function(a, b) {
    return $586db44cc863cfb9$var$U.current.useLayoutEffect(a, b);
};
$586db44cc863cfb9$export$1538c33de8887b59 = function(a, b) {
    return $586db44cc863cfb9$var$U.current.useMemo(a, b);
};
$586db44cc863cfb9$export$13e3392192263954 = function(a, b, e) {
    return $586db44cc863cfb9$var$U.current.useReducer(a, b, e);
};
$586db44cc863cfb9$export$b8f5890fc79d6aca = function(a) {
    return $586db44cc863cfb9$var$U.current.useRef(a);
};
$586db44cc863cfb9$export$60241385465d0a34 = function(a) {
    return $586db44cc863cfb9$var$U.current.useState(a);
};
$586db44cc863cfb9$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $586db44cc863cfb9$var$U.current.useSyncExternalStore(a, b, e);
};
$586db44cc863cfb9$export$7b286972b8d8ccbf = function() {
    return $586db44cc863cfb9$var$U.current.useTransition();
};
$586db44cc863cfb9$export$83d89fbfd8236492 = "18.3.1";

});





parcelRegister("9ZCME", function(module, exports) {
'use strict';
function $7467e533e99cee6e$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7467e533e99cee6e$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7467e533e99cee6e$var$checkDCE();

module.exports = (parcelRequire("dkYE3"));

});
parcelRegister("dkYE3", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $9b5c2f7437668c86$export$ae55be85d98224ed; }, function (v) { return $9b5c2f7437668c86$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $9b5c2f7437668c86$export$d39a5bbd09211389; }, function (v) { return $9b5c2f7437668c86$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $9b5c2f7437668c86$export$882461b6382ed46c; }, function (v) { return $9b5c2f7437668c86$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $9b5c2f7437668c86$export$466bfc07425424d5; }, function (v) { return $9b5c2f7437668c86$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $9b5c2f7437668c86$export$cd75ccfd720a3cd4; }, function (v) { return $9b5c2f7437668c86$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $9b5c2f7437668c86$export$fa8d919ba61d84db; }, function (v) { return $9b5c2f7437668c86$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $9b5c2f7437668c86$export$757ceba2d55c277e; }, function (v) { return $9b5c2f7437668c86$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $9b5c2f7437668c86$export$b3890eb0ae9dca99; }, function (v) { return $9b5c2f7437668c86$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $9b5c2f7437668c86$export$502457920280e6be; }, function (v) { return $9b5c2f7437668c86$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $9b5c2f7437668c86$export$c78a37762a8d58e1; }, function (v) { return $9b5c2f7437668c86$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $9b5c2f7437668c86$export$dc54d992c10e8a18; }, function (v) { return $9b5c2f7437668c86$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $9b5c2f7437668c86$export$83d89fbfd8236492; }, function (v) { return $9b5c2f7437668c86$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $9b5c2f7437668c86$export$ae55be85d98224ed;
var $9b5c2f7437668c86$export$d39a5bbd09211389;
var $9b5c2f7437668c86$export$882461b6382ed46c;
var $9b5c2f7437668c86$export$466bfc07425424d5;
var $9b5c2f7437668c86$export$cd75ccfd720a3cd4;
var $9b5c2f7437668c86$export$fa8d919ba61d84db;
var $9b5c2f7437668c86$export$757ceba2d55c277e;
var $9b5c2f7437668c86$export$b3890eb0ae9dca99;
var $9b5c2f7437668c86$export$502457920280e6be;
var $9b5c2f7437668c86$export$c78a37762a8d58e1;
var $9b5c2f7437668c86$export$dc54d992c10e8a18;
var $9b5c2f7437668c86$export$83d89fbfd8236492;
'use strict';

var $dNMDr = parcelRequire("dNMDr");

var $7hIah = parcelRequire("7hIah");
function $9b5c2f7437668c86$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9b5c2f7437668c86$var$da = new Set, $9b5c2f7437668c86$var$ea = {};
function $9b5c2f7437668c86$var$fa(a, b) {
    $9b5c2f7437668c86$var$ha(a, b);
    $9b5c2f7437668c86$var$ha(a + "Capture", b);
}
function $9b5c2f7437668c86$var$ha(a, b) {
    $9b5c2f7437668c86$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$9b5c2f7437668c86$var$da.add(b[a]);
}
var $9b5c2f7437668c86$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $9b5c2f7437668c86$var$ja = Object.prototype.hasOwnProperty, $9b5c2f7437668c86$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9b5c2f7437668c86$var$la = {}, $9b5c2f7437668c86$var$ma = {};
function $9b5c2f7437668c86$var$oa(a) {
    if ($9b5c2f7437668c86$var$ja.call($9b5c2f7437668c86$var$ma, a)) return !0;
    if ($9b5c2f7437668c86$var$ja.call($9b5c2f7437668c86$var$la, a)) return !1;
    if ($9b5c2f7437668c86$var$ka.test(a)) return $9b5c2f7437668c86$var$ma[a] = !0;
    $9b5c2f7437668c86$var$la[a] = !0;
    return !1;
}
function $9b5c2f7437668c86$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $9b5c2f7437668c86$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $9b5c2f7437668c86$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $9b5c2f7437668c86$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $9b5c2f7437668c86$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9b5c2f7437668c86$var$z[a] = new $9b5c2f7437668c86$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9b5c2f7437668c86$var$z[b] = new $9b5c2f7437668c86$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9b5c2f7437668c86$var$z[a] = new $9b5c2f7437668c86$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9b5c2f7437668c86$var$z[a] = new $9b5c2f7437668c86$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9b5c2f7437668c86$var$z[a] = new $9b5c2f7437668c86$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9b5c2f7437668c86$var$z[a] = new $9b5c2f7437668c86$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9b5c2f7437668c86$var$z[a] = new $9b5c2f7437668c86$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9b5c2f7437668c86$var$z[a] = new $9b5c2f7437668c86$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9b5c2f7437668c86$var$z[a] = new $9b5c2f7437668c86$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9b5c2f7437668c86$var$ra = /[\-:]([a-z])/g;
function $9b5c2f7437668c86$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9b5c2f7437668c86$var$ra, $9b5c2f7437668c86$var$sa);
    $9b5c2f7437668c86$var$z[b] = new $9b5c2f7437668c86$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9b5c2f7437668c86$var$ra, $9b5c2f7437668c86$var$sa);
    $9b5c2f7437668c86$var$z[b] = new $9b5c2f7437668c86$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9b5c2f7437668c86$var$ra, $9b5c2f7437668c86$var$sa);
    $9b5c2f7437668c86$var$z[b] = new $9b5c2f7437668c86$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9b5c2f7437668c86$var$z[a] = new $9b5c2f7437668c86$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9b5c2f7437668c86$var$z.xlinkHref = new $9b5c2f7437668c86$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9b5c2f7437668c86$var$z[a] = new $9b5c2f7437668c86$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $9b5c2f7437668c86$var$ta(a, b, c, d) {
    var e = $9b5c2f7437668c86$var$z.hasOwnProperty(b) ? $9b5c2f7437668c86$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $9b5c2f7437668c86$var$qa(b, c, e, d) && (c = null), d || null === e ? $9b5c2f7437668c86$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $9b5c2f7437668c86$var$ua = $dNMDr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $9b5c2f7437668c86$var$va = Symbol.for("react.element"), $9b5c2f7437668c86$var$wa = Symbol.for("react.portal"), $9b5c2f7437668c86$var$ya = Symbol.for("react.fragment"), $9b5c2f7437668c86$var$za = Symbol.for("react.strict_mode"), $9b5c2f7437668c86$var$Aa = Symbol.for("react.profiler"), $9b5c2f7437668c86$var$Ba = Symbol.for("react.provider"), $9b5c2f7437668c86$var$Ca = Symbol.for("react.context"), $9b5c2f7437668c86$var$Da = Symbol.for("react.forward_ref"), $9b5c2f7437668c86$var$Ea = Symbol.for("react.suspense"), $9b5c2f7437668c86$var$Fa = Symbol.for("react.suspense_list"), $9b5c2f7437668c86$var$Ga = Symbol.for("react.memo"), $9b5c2f7437668c86$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $9b5c2f7437668c86$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $9b5c2f7437668c86$var$Ja = Symbol.iterator;
function $9b5c2f7437668c86$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9b5c2f7437668c86$var$Ja && a[$9b5c2f7437668c86$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9b5c2f7437668c86$var$A = Object.assign, $9b5c2f7437668c86$var$La;
function $9b5c2f7437668c86$var$Ma(a) {
    if (void 0 === $9b5c2f7437668c86$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $9b5c2f7437668c86$var$La = b && b[1] || "";
    }
    return "\n" + $9b5c2f7437668c86$var$La + a;
}
var $9b5c2f7437668c86$var$Na = !1;
function $9b5c2f7437668c86$var$Oa(a, b) {
    if (!a || $9b5c2f7437668c86$var$Na) return "";
    $9b5c2f7437668c86$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $9b5c2f7437668c86$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $9b5c2f7437668c86$var$Ma(a) : "";
}
function $9b5c2f7437668c86$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $9b5c2f7437668c86$var$Ma(a.type);
        case 16:
            return $9b5c2f7437668c86$var$Ma("Lazy");
        case 13:
            return $9b5c2f7437668c86$var$Ma("Suspense");
        case 19:
            return $9b5c2f7437668c86$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $9b5c2f7437668c86$var$Oa(a.type, !1), a;
        case 11:
            return a = $9b5c2f7437668c86$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $9b5c2f7437668c86$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $9b5c2f7437668c86$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9b5c2f7437668c86$var$ya:
            return "Fragment";
        case $9b5c2f7437668c86$var$wa:
            return "Portal";
        case $9b5c2f7437668c86$var$Aa:
            return "Profiler";
        case $9b5c2f7437668c86$var$za:
            return "StrictMode";
        case $9b5c2f7437668c86$var$Ea:
            return "Suspense";
        case $9b5c2f7437668c86$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9b5c2f7437668c86$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $9b5c2f7437668c86$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $9b5c2f7437668c86$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9b5c2f7437668c86$var$Ga:
            return b = a.displayName || null, null !== b ? b : $9b5c2f7437668c86$var$Qa(a.type) || "Memo";
        case $9b5c2f7437668c86$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $9b5c2f7437668c86$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $9b5c2f7437668c86$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $9b5c2f7437668c86$var$Qa(b);
        case 8:
            return b === $9b5c2f7437668c86$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $9b5c2f7437668c86$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $9b5c2f7437668c86$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $9b5c2f7437668c86$var$Ua(a) {
    var b = $9b5c2f7437668c86$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $9b5c2f7437668c86$var$Va(a) {
    a._valueTracker || (a._valueTracker = $9b5c2f7437668c86$var$Ua(a));
}
function $9b5c2f7437668c86$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $9b5c2f7437668c86$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $9b5c2f7437668c86$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $9b5c2f7437668c86$var$Ya(a, b) {
    var c = b.checked;
    return $9b5c2f7437668c86$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $9b5c2f7437668c86$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $9b5c2f7437668c86$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $9b5c2f7437668c86$var$ab(a, b) {
    b = b.checked;
    null != b && $9b5c2f7437668c86$var$ta(a, "checked", b, !1);
}
function $9b5c2f7437668c86$var$bb(a, b) {
    $9b5c2f7437668c86$var$ab(a, b);
    var c = $9b5c2f7437668c86$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $9b5c2f7437668c86$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $9b5c2f7437668c86$var$cb(a, b.type, $9b5c2f7437668c86$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $9b5c2f7437668c86$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $9b5c2f7437668c86$var$cb(a, b, c) {
    if ("number" !== b || $9b5c2f7437668c86$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $9b5c2f7437668c86$var$eb = Array.isArray;
function $9b5c2f7437668c86$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $9b5c2f7437668c86$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $9b5c2f7437668c86$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($9b5c2f7437668c86$var$p(91));
    return $9b5c2f7437668c86$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $9b5c2f7437668c86$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($9b5c2f7437668c86$var$p(92));
            if ($9b5c2f7437668c86$var$eb(c)) {
                if (1 < c.length) throw Error($9b5c2f7437668c86$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $9b5c2f7437668c86$var$Sa(c)
    };
}
function $9b5c2f7437668c86$var$ib(a, b) {
    var c = $9b5c2f7437668c86$var$Sa(b.value), d = $9b5c2f7437668c86$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $9b5c2f7437668c86$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $9b5c2f7437668c86$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $9b5c2f7437668c86$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $9b5c2f7437668c86$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $9b5c2f7437668c86$var$mb, $9b5c2f7437668c86$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $9b5c2f7437668c86$var$mb = $9b5c2f7437668c86$var$mb || document.createElement("div");
        $9b5c2f7437668c86$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $9b5c2f7437668c86$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $9b5c2f7437668c86$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $9b5c2f7437668c86$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9b5c2f7437668c86$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9b5c2f7437668c86$var$pb).forEach(function(a) {
    $9b5c2f7437668c86$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9b5c2f7437668c86$var$pb[b] = $9b5c2f7437668c86$var$pb[a];
    });
});
function $9b5c2f7437668c86$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $9b5c2f7437668c86$var$pb.hasOwnProperty(a) && $9b5c2f7437668c86$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $9b5c2f7437668c86$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $9b5c2f7437668c86$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $9b5c2f7437668c86$var$tb = $9b5c2f7437668c86$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $9b5c2f7437668c86$var$ub(a, b) {
    if (b) {
        if ($9b5c2f7437668c86$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($9b5c2f7437668c86$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($9b5c2f7437668c86$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($9b5c2f7437668c86$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($9b5c2f7437668c86$var$p(62));
    }
}
function $9b5c2f7437668c86$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $9b5c2f7437668c86$var$wb = null;
function $9b5c2f7437668c86$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $9b5c2f7437668c86$var$yb = null, $9b5c2f7437668c86$var$zb = null, $9b5c2f7437668c86$var$Ab = null;
function $9b5c2f7437668c86$var$Bb(a) {
    if (a = $9b5c2f7437668c86$var$Cb(a)) {
        if ("function" !== typeof $9b5c2f7437668c86$var$yb) throw Error($9b5c2f7437668c86$var$p(280));
        var b = a.stateNode;
        b && (b = $9b5c2f7437668c86$var$Db(b), $9b5c2f7437668c86$var$yb(a.stateNode, a.type, b));
    }
}
function $9b5c2f7437668c86$var$Eb(a) {
    $9b5c2f7437668c86$var$zb ? $9b5c2f7437668c86$var$Ab ? $9b5c2f7437668c86$var$Ab.push(a) : $9b5c2f7437668c86$var$Ab = [
        a
    ] : $9b5c2f7437668c86$var$zb = a;
}
function $9b5c2f7437668c86$var$Fb() {
    if ($9b5c2f7437668c86$var$zb) {
        var a = $9b5c2f7437668c86$var$zb, b = $9b5c2f7437668c86$var$Ab;
        $9b5c2f7437668c86$var$Ab = $9b5c2f7437668c86$var$zb = null;
        $9b5c2f7437668c86$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$9b5c2f7437668c86$var$Bb(b[a]);
    }
}
function $9b5c2f7437668c86$var$Gb(a, b) {
    return a(b);
}
function $9b5c2f7437668c86$var$Hb() {}
var $9b5c2f7437668c86$var$Ib = !1;
function $9b5c2f7437668c86$var$Jb(a, b, c) {
    if ($9b5c2f7437668c86$var$Ib) return a(b, c);
    $9b5c2f7437668c86$var$Ib = !0;
    try {
        return $9b5c2f7437668c86$var$Gb(a, b, c);
    } finally{
        if ($9b5c2f7437668c86$var$Ib = !1, null !== $9b5c2f7437668c86$var$zb || null !== $9b5c2f7437668c86$var$Ab) $9b5c2f7437668c86$var$Hb(), $9b5c2f7437668c86$var$Fb();
    }
}
function $9b5c2f7437668c86$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $9b5c2f7437668c86$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($9b5c2f7437668c86$var$p(231, b, typeof c));
    return c;
}
var $9b5c2f7437668c86$var$Lb = !1;
if ($9b5c2f7437668c86$var$ia) try {
    var $9b5c2f7437668c86$var$Mb = {};
    Object.defineProperty($9b5c2f7437668c86$var$Mb, "passive", {
        get: function() {
            $9b5c2f7437668c86$var$Lb = !0;
        }
    });
    window.addEventListener("test", $9b5c2f7437668c86$var$Mb, $9b5c2f7437668c86$var$Mb);
    window.removeEventListener("test", $9b5c2f7437668c86$var$Mb, $9b5c2f7437668c86$var$Mb);
} catch (a) {
    $9b5c2f7437668c86$var$Lb = !1;
}
function $9b5c2f7437668c86$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $9b5c2f7437668c86$var$Ob = !1, $9b5c2f7437668c86$var$Pb = null, $9b5c2f7437668c86$var$Qb = !1, $9b5c2f7437668c86$var$Rb = null, $9b5c2f7437668c86$var$Sb = {
    onError: function(a) {
        $9b5c2f7437668c86$var$Ob = !0;
        $9b5c2f7437668c86$var$Pb = a;
    }
};
function $9b5c2f7437668c86$var$Tb(a, b, c, d, e, f, g, h, k) {
    $9b5c2f7437668c86$var$Ob = !1;
    $9b5c2f7437668c86$var$Pb = null;
    $9b5c2f7437668c86$var$Nb.apply($9b5c2f7437668c86$var$Sb, arguments);
}
function $9b5c2f7437668c86$var$Ub(a, b, c, d, e, f, g, h, k) {
    $9b5c2f7437668c86$var$Tb.apply(this, arguments);
    if ($9b5c2f7437668c86$var$Ob) {
        if ($9b5c2f7437668c86$var$Ob) {
            var l = $9b5c2f7437668c86$var$Pb;
            $9b5c2f7437668c86$var$Ob = !1;
            $9b5c2f7437668c86$var$Pb = null;
        } else throw Error($9b5c2f7437668c86$var$p(198));
        $9b5c2f7437668c86$var$Qb || ($9b5c2f7437668c86$var$Qb = !0, $9b5c2f7437668c86$var$Rb = l);
    }
}
function $9b5c2f7437668c86$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $9b5c2f7437668c86$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $9b5c2f7437668c86$var$Xb(a) {
    if ($9b5c2f7437668c86$var$Vb(a) !== a) throw Error($9b5c2f7437668c86$var$p(188));
}
function $9b5c2f7437668c86$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $9b5c2f7437668c86$var$Vb(a);
        if (null === b) throw Error($9b5c2f7437668c86$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $9b5c2f7437668c86$var$Xb(e), a;
                if (f === d) return $9b5c2f7437668c86$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($9b5c2f7437668c86$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($9b5c2f7437668c86$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($9b5c2f7437668c86$var$p(190));
    }
    if (3 !== c.tag) throw Error($9b5c2f7437668c86$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $9b5c2f7437668c86$var$Zb(a) {
    a = $9b5c2f7437668c86$var$Yb(a);
    return null !== a ? $9b5c2f7437668c86$var$$b(a) : null;
}
function $9b5c2f7437668c86$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $9b5c2f7437668c86$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $9b5c2f7437668c86$var$ac = $7hIah.unstable_scheduleCallback, $9b5c2f7437668c86$var$bc = $7hIah.unstable_cancelCallback, $9b5c2f7437668c86$var$cc = $7hIah.unstable_shouldYield, $9b5c2f7437668c86$var$dc = $7hIah.unstable_requestPaint, $9b5c2f7437668c86$var$B = $7hIah.unstable_now, $9b5c2f7437668c86$var$ec = $7hIah.unstable_getCurrentPriorityLevel, $9b5c2f7437668c86$var$fc = $7hIah.unstable_ImmediatePriority, $9b5c2f7437668c86$var$gc = $7hIah.unstable_UserBlockingPriority, $9b5c2f7437668c86$var$hc = $7hIah.unstable_NormalPriority, $9b5c2f7437668c86$var$ic = $7hIah.unstable_LowPriority, $9b5c2f7437668c86$var$jc = $7hIah.unstable_IdlePriority, $9b5c2f7437668c86$var$kc = null, $9b5c2f7437668c86$var$lc = null;
function $9b5c2f7437668c86$var$mc(a) {
    if ($9b5c2f7437668c86$var$lc && "function" === typeof $9b5c2f7437668c86$var$lc.onCommitFiberRoot) try {
        $9b5c2f7437668c86$var$lc.onCommitFiberRoot($9b5c2f7437668c86$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $9b5c2f7437668c86$var$oc = Math.clz32 ? Math.clz32 : $9b5c2f7437668c86$var$nc, $9b5c2f7437668c86$var$pc = Math.log, $9b5c2f7437668c86$var$qc = Math.LN2;
function $9b5c2f7437668c86$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9b5c2f7437668c86$var$pc(a) / $9b5c2f7437668c86$var$qc | 0) | 0;
}
var $9b5c2f7437668c86$var$rc = 64, $9b5c2f7437668c86$var$sc = 4194304;
function $9b5c2f7437668c86$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $9b5c2f7437668c86$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $9b5c2f7437668c86$var$tc(h) : (f &= g, 0 !== f && (d = $9b5c2f7437668c86$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $9b5c2f7437668c86$var$tc(g) : 0 !== f && (d = $9b5c2f7437668c86$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $9b5c2f7437668c86$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $9b5c2f7437668c86$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $9b5c2f7437668c86$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $9b5c2f7437668c86$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $9b5c2f7437668c86$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $9b5c2f7437668c86$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $9b5c2f7437668c86$var$yc() {
    var a = $9b5c2f7437668c86$var$rc;
    $9b5c2f7437668c86$var$rc <<= 1;
    0 === ($9b5c2f7437668c86$var$rc & 4194240) && ($9b5c2f7437668c86$var$rc = 64);
    return a;
}
function $9b5c2f7437668c86$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $9b5c2f7437668c86$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $9b5c2f7437668c86$var$oc(b);
    a[b] = c;
}
function $9b5c2f7437668c86$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $9b5c2f7437668c86$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $9b5c2f7437668c86$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $9b5c2f7437668c86$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $9b5c2f7437668c86$var$C = 0;
function $9b5c2f7437668c86$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $9b5c2f7437668c86$var$Ec, $9b5c2f7437668c86$var$Fc, $9b5c2f7437668c86$var$Gc, $9b5c2f7437668c86$var$Hc, $9b5c2f7437668c86$var$Ic, $9b5c2f7437668c86$var$Jc = !1, $9b5c2f7437668c86$var$Kc = [], $9b5c2f7437668c86$var$Lc = null, $9b5c2f7437668c86$var$Mc = null, $9b5c2f7437668c86$var$Nc = null, $9b5c2f7437668c86$var$Oc = new Map, $9b5c2f7437668c86$var$Pc = new Map, $9b5c2f7437668c86$var$Qc = [], $9b5c2f7437668c86$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $9b5c2f7437668c86$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $9b5c2f7437668c86$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $9b5c2f7437668c86$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $9b5c2f7437668c86$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $9b5c2f7437668c86$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $9b5c2f7437668c86$var$Pc.delete(b.pointerId);
    }
}
function $9b5c2f7437668c86$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $9b5c2f7437668c86$var$Cb(b), null !== b && $9b5c2f7437668c86$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $9b5c2f7437668c86$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $9b5c2f7437668c86$var$Lc = $9b5c2f7437668c86$var$Tc($9b5c2f7437668c86$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $9b5c2f7437668c86$var$Mc = $9b5c2f7437668c86$var$Tc($9b5c2f7437668c86$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $9b5c2f7437668c86$var$Nc = $9b5c2f7437668c86$var$Tc($9b5c2f7437668c86$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $9b5c2f7437668c86$var$Oc.set(f, $9b5c2f7437668c86$var$Tc($9b5c2f7437668c86$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $9b5c2f7437668c86$var$Pc.set(f, $9b5c2f7437668c86$var$Tc($9b5c2f7437668c86$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $9b5c2f7437668c86$var$Vc(a) {
    var b = $9b5c2f7437668c86$var$Wc(a.target);
    if (null !== b) {
        var c = $9b5c2f7437668c86$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $9b5c2f7437668c86$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $9b5c2f7437668c86$var$Ic(a.priority, function() {
                        $9b5c2f7437668c86$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $9b5c2f7437668c86$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $9b5c2f7437668c86$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $9b5c2f7437668c86$var$wb = d;
            c.target.dispatchEvent(d);
            $9b5c2f7437668c86$var$wb = null;
        } else return b = $9b5c2f7437668c86$var$Cb(c), null !== b && $9b5c2f7437668c86$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $9b5c2f7437668c86$var$Zc(a, b, c) {
    $9b5c2f7437668c86$var$Xc(a) && c.delete(b);
}
function $9b5c2f7437668c86$var$$c() {
    $9b5c2f7437668c86$var$Jc = !1;
    null !== $9b5c2f7437668c86$var$Lc && $9b5c2f7437668c86$var$Xc($9b5c2f7437668c86$var$Lc) && ($9b5c2f7437668c86$var$Lc = null);
    null !== $9b5c2f7437668c86$var$Mc && $9b5c2f7437668c86$var$Xc($9b5c2f7437668c86$var$Mc) && ($9b5c2f7437668c86$var$Mc = null);
    null !== $9b5c2f7437668c86$var$Nc && $9b5c2f7437668c86$var$Xc($9b5c2f7437668c86$var$Nc) && ($9b5c2f7437668c86$var$Nc = null);
    $9b5c2f7437668c86$var$Oc.forEach($9b5c2f7437668c86$var$Zc);
    $9b5c2f7437668c86$var$Pc.forEach($9b5c2f7437668c86$var$Zc);
}
function $9b5c2f7437668c86$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $9b5c2f7437668c86$var$Jc || ($9b5c2f7437668c86$var$Jc = !0, $7hIah.unstable_scheduleCallback($7hIah.unstable_NormalPriority, $9b5c2f7437668c86$var$$c)));
}
function $9b5c2f7437668c86$var$bd(a) {
    function b(b) {
        return $9b5c2f7437668c86$var$ad(b, a);
    }
    if (0 < $9b5c2f7437668c86$var$Kc.length) {
        $9b5c2f7437668c86$var$ad($9b5c2f7437668c86$var$Kc[0], a);
        for(var c = 1; c < $9b5c2f7437668c86$var$Kc.length; c++){
            var d = $9b5c2f7437668c86$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $9b5c2f7437668c86$var$Lc && $9b5c2f7437668c86$var$ad($9b5c2f7437668c86$var$Lc, a);
    null !== $9b5c2f7437668c86$var$Mc && $9b5c2f7437668c86$var$ad($9b5c2f7437668c86$var$Mc, a);
    null !== $9b5c2f7437668c86$var$Nc && $9b5c2f7437668c86$var$ad($9b5c2f7437668c86$var$Nc, a);
    $9b5c2f7437668c86$var$Oc.forEach(b);
    $9b5c2f7437668c86$var$Pc.forEach(b);
    for(c = 0; c < $9b5c2f7437668c86$var$Qc.length; c++)d = $9b5c2f7437668c86$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $9b5c2f7437668c86$var$Qc.length && (c = $9b5c2f7437668c86$var$Qc[0], null === c.blockedOn);)$9b5c2f7437668c86$var$Vc(c), null === c.blockedOn && $9b5c2f7437668c86$var$Qc.shift();
}
var $9b5c2f7437668c86$var$cd = $9b5c2f7437668c86$var$ua.ReactCurrentBatchConfig, $9b5c2f7437668c86$var$dd = !0;
function $9b5c2f7437668c86$var$ed(a, b, c, d) {
    var e = $9b5c2f7437668c86$var$C, f = $9b5c2f7437668c86$var$cd.transition;
    $9b5c2f7437668c86$var$cd.transition = null;
    try {
        $9b5c2f7437668c86$var$C = 1, $9b5c2f7437668c86$var$fd(a, b, c, d);
    } finally{
        $9b5c2f7437668c86$var$C = e, $9b5c2f7437668c86$var$cd.transition = f;
    }
}
function $9b5c2f7437668c86$var$gd(a, b, c, d) {
    var e = $9b5c2f7437668c86$var$C, f = $9b5c2f7437668c86$var$cd.transition;
    $9b5c2f7437668c86$var$cd.transition = null;
    try {
        $9b5c2f7437668c86$var$C = 4, $9b5c2f7437668c86$var$fd(a, b, c, d);
    } finally{
        $9b5c2f7437668c86$var$C = e, $9b5c2f7437668c86$var$cd.transition = f;
    }
}
function $9b5c2f7437668c86$var$fd(a, b, c, d) {
    if ($9b5c2f7437668c86$var$dd) {
        var e = $9b5c2f7437668c86$var$Yc(a, b, c, d);
        if (null === e) $9b5c2f7437668c86$var$hd(a, b, d, $9b5c2f7437668c86$var$id, c), $9b5c2f7437668c86$var$Sc(a, d);
        else if ($9b5c2f7437668c86$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($9b5c2f7437668c86$var$Sc(a, d), b & 4 && -1 < $9b5c2f7437668c86$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $9b5c2f7437668c86$var$Cb(e);
                null !== f && $9b5c2f7437668c86$var$Ec(f);
                f = $9b5c2f7437668c86$var$Yc(a, b, c, d);
                null === f && $9b5c2f7437668c86$var$hd(a, b, d, $9b5c2f7437668c86$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $9b5c2f7437668c86$var$hd(a, b, d, null, c);
    }
}
var $9b5c2f7437668c86$var$id = null;
function $9b5c2f7437668c86$var$Yc(a, b, c, d) {
    $9b5c2f7437668c86$var$id = null;
    a = $9b5c2f7437668c86$var$xb(d);
    a = $9b5c2f7437668c86$var$Wc(a);
    if (null !== a) {
        if (b = $9b5c2f7437668c86$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $9b5c2f7437668c86$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $9b5c2f7437668c86$var$id = a;
    return null;
}
function $9b5c2f7437668c86$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($9b5c2f7437668c86$var$ec()){
                case $9b5c2f7437668c86$var$fc:
                    return 1;
                case $9b5c2f7437668c86$var$gc:
                    return 4;
                case $9b5c2f7437668c86$var$hc:
                case $9b5c2f7437668c86$var$ic:
                    return 16;
                case $9b5c2f7437668c86$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $9b5c2f7437668c86$var$kd = null, $9b5c2f7437668c86$var$ld = null, $9b5c2f7437668c86$var$md = null;
function $9b5c2f7437668c86$var$nd() {
    if ($9b5c2f7437668c86$var$md) return $9b5c2f7437668c86$var$md;
    var a, b = $9b5c2f7437668c86$var$ld, c = b.length, d, e = "value" in $9b5c2f7437668c86$var$kd ? $9b5c2f7437668c86$var$kd.value : $9b5c2f7437668c86$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $9b5c2f7437668c86$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $9b5c2f7437668c86$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $9b5c2f7437668c86$var$pd() {
    return !0;
}
function $9b5c2f7437668c86$var$qd() {
    return !1;
}
function $9b5c2f7437668c86$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $9b5c2f7437668c86$var$pd : $9b5c2f7437668c86$var$qd;
        this.isPropagationStopped = $9b5c2f7437668c86$var$qd;
        return this;
    }
    $9b5c2f7437668c86$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $9b5c2f7437668c86$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $9b5c2f7437668c86$var$pd);
        },
        persist: function() {},
        isPersistent: $9b5c2f7437668c86$var$pd
    });
    return b;
}
var $9b5c2f7437668c86$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $9b5c2f7437668c86$var$td = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$sd), $9b5c2f7437668c86$var$ud = $9b5c2f7437668c86$var$A({}, $9b5c2f7437668c86$var$sd, {
    view: 0,
    detail: 0
}), $9b5c2f7437668c86$var$vd = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$ud), $9b5c2f7437668c86$var$wd, $9b5c2f7437668c86$var$xd, $9b5c2f7437668c86$var$yd, $9b5c2f7437668c86$var$Ad = $9b5c2f7437668c86$var$A({}, $9b5c2f7437668c86$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $9b5c2f7437668c86$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $9b5c2f7437668c86$var$yd && ($9b5c2f7437668c86$var$yd && "mousemove" === a.type ? ($9b5c2f7437668c86$var$wd = a.screenX - $9b5c2f7437668c86$var$yd.screenX, $9b5c2f7437668c86$var$xd = a.screenY - $9b5c2f7437668c86$var$yd.screenY) : $9b5c2f7437668c86$var$xd = $9b5c2f7437668c86$var$wd = 0, $9b5c2f7437668c86$var$yd = a);
        return $9b5c2f7437668c86$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $9b5c2f7437668c86$var$xd;
    }
}), $9b5c2f7437668c86$var$Bd = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$Ad), $9b5c2f7437668c86$var$Cd = $9b5c2f7437668c86$var$A({}, $9b5c2f7437668c86$var$Ad, {
    dataTransfer: 0
}), $9b5c2f7437668c86$var$Dd = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$Cd), $9b5c2f7437668c86$var$Ed = $9b5c2f7437668c86$var$A({}, $9b5c2f7437668c86$var$ud, {
    relatedTarget: 0
}), $9b5c2f7437668c86$var$Fd = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$Ed), $9b5c2f7437668c86$var$Gd = $9b5c2f7437668c86$var$A({}, $9b5c2f7437668c86$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9b5c2f7437668c86$var$Hd = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$Gd), $9b5c2f7437668c86$var$Id = $9b5c2f7437668c86$var$A({}, $9b5c2f7437668c86$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $9b5c2f7437668c86$var$Jd = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$Id), $9b5c2f7437668c86$var$Kd = $9b5c2f7437668c86$var$A({}, $9b5c2f7437668c86$var$sd, {
    data: 0
}), $9b5c2f7437668c86$var$Ld = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$Kd), $9b5c2f7437668c86$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $9b5c2f7437668c86$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $9b5c2f7437668c86$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $9b5c2f7437668c86$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $9b5c2f7437668c86$var$Od[a]) ? !!b[a] : !1;
}
function $9b5c2f7437668c86$var$zd() {
    return $9b5c2f7437668c86$var$Pd;
}
var $9b5c2f7437668c86$var$Qd = $9b5c2f7437668c86$var$A({}, $9b5c2f7437668c86$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $9b5c2f7437668c86$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $9b5c2f7437668c86$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $9b5c2f7437668c86$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $9b5c2f7437668c86$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $9b5c2f7437668c86$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $9b5c2f7437668c86$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $9b5c2f7437668c86$var$Rd = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$Qd), $9b5c2f7437668c86$var$Sd = $9b5c2f7437668c86$var$A({}, $9b5c2f7437668c86$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $9b5c2f7437668c86$var$Td = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$Sd), $9b5c2f7437668c86$var$Ud = $9b5c2f7437668c86$var$A({}, $9b5c2f7437668c86$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $9b5c2f7437668c86$var$zd
}), $9b5c2f7437668c86$var$Vd = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$Ud), $9b5c2f7437668c86$var$Wd = $9b5c2f7437668c86$var$A({}, $9b5c2f7437668c86$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9b5c2f7437668c86$var$Xd = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$Wd), $9b5c2f7437668c86$var$Yd = $9b5c2f7437668c86$var$A({}, $9b5c2f7437668c86$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $9b5c2f7437668c86$var$Zd = $9b5c2f7437668c86$var$rd($9b5c2f7437668c86$var$Yd), $9b5c2f7437668c86$var$$d = [
    9,
    13,
    27,
    32
], $9b5c2f7437668c86$var$ae = $9b5c2f7437668c86$var$ia && "CompositionEvent" in window, $9b5c2f7437668c86$var$be = null;
$9b5c2f7437668c86$var$ia && "documentMode" in document && ($9b5c2f7437668c86$var$be = document.documentMode);
var $9b5c2f7437668c86$var$ce = $9b5c2f7437668c86$var$ia && "TextEvent" in window && !$9b5c2f7437668c86$var$be, $9b5c2f7437668c86$var$de = $9b5c2f7437668c86$var$ia && (!$9b5c2f7437668c86$var$ae || $9b5c2f7437668c86$var$be && 8 < $9b5c2f7437668c86$var$be && 11 >= $9b5c2f7437668c86$var$be), $9b5c2f7437668c86$var$ee = String.fromCharCode(32), $9b5c2f7437668c86$var$fe = !1;
function $9b5c2f7437668c86$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $9b5c2f7437668c86$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $9b5c2f7437668c86$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $9b5c2f7437668c86$var$ie = !1;
function $9b5c2f7437668c86$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $9b5c2f7437668c86$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $9b5c2f7437668c86$var$fe = !0;
            return $9b5c2f7437668c86$var$ee;
        case "textInput":
            return a = b.data, a === $9b5c2f7437668c86$var$ee && $9b5c2f7437668c86$var$fe ? null : a;
        default:
            return null;
    }
}
function $9b5c2f7437668c86$var$ke(a, b) {
    if ($9b5c2f7437668c86$var$ie) return "compositionend" === a || !$9b5c2f7437668c86$var$ae && $9b5c2f7437668c86$var$ge(a, b) ? (a = $9b5c2f7437668c86$var$nd(), $9b5c2f7437668c86$var$md = $9b5c2f7437668c86$var$ld = $9b5c2f7437668c86$var$kd = null, $9b5c2f7437668c86$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $9b5c2f7437668c86$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $9b5c2f7437668c86$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $9b5c2f7437668c86$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$9b5c2f7437668c86$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $9b5c2f7437668c86$var$ne(a, b, c, d) {
    $9b5c2f7437668c86$var$Eb(d);
    b = $9b5c2f7437668c86$var$oe(b, "onChange");
    0 < b.length && (c = new $9b5c2f7437668c86$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $9b5c2f7437668c86$var$pe = null, $9b5c2f7437668c86$var$qe = null;
function $9b5c2f7437668c86$var$re(a) {
    $9b5c2f7437668c86$var$se(a, 0);
}
function $9b5c2f7437668c86$var$te(a) {
    var b = $9b5c2f7437668c86$var$ue(a);
    if ($9b5c2f7437668c86$var$Wa(b)) return a;
}
function $9b5c2f7437668c86$var$ve(a, b) {
    if ("change" === a) return b;
}
var $9b5c2f7437668c86$var$we = !1;
if ($9b5c2f7437668c86$var$ia) {
    var $9b5c2f7437668c86$var$xe;
    if ($9b5c2f7437668c86$var$ia) {
        var $9b5c2f7437668c86$var$ye = "oninput" in document;
        if (!$9b5c2f7437668c86$var$ye) {
            var $9b5c2f7437668c86$var$ze = document.createElement("div");
            $9b5c2f7437668c86$var$ze.setAttribute("oninput", "return;");
            $9b5c2f7437668c86$var$ye = "function" === typeof $9b5c2f7437668c86$var$ze.oninput;
        }
        $9b5c2f7437668c86$var$xe = $9b5c2f7437668c86$var$ye;
    } else $9b5c2f7437668c86$var$xe = !1;
    $9b5c2f7437668c86$var$we = $9b5c2f7437668c86$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $9b5c2f7437668c86$var$Ae() {
    $9b5c2f7437668c86$var$pe && ($9b5c2f7437668c86$var$pe.detachEvent("onpropertychange", $9b5c2f7437668c86$var$Be), $9b5c2f7437668c86$var$qe = $9b5c2f7437668c86$var$pe = null);
}
function $9b5c2f7437668c86$var$Be(a) {
    if ("value" === a.propertyName && $9b5c2f7437668c86$var$te($9b5c2f7437668c86$var$qe)) {
        var b = [];
        $9b5c2f7437668c86$var$ne(b, $9b5c2f7437668c86$var$qe, a, $9b5c2f7437668c86$var$xb(a));
        $9b5c2f7437668c86$var$Jb($9b5c2f7437668c86$var$re, b);
    }
}
function $9b5c2f7437668c86$var$Ce(a, b, c) {
    "focusin" === a ? ($9b5c2f7437668c86$var$Ae(), $9b5c2f7437668c86$var$pe = b, $9b5c2f7437668c86$var$qe = c, $9b5c2f7437668c86$var$pe.attachEvent("onpropertychange", $9b5c2f7437668c86$var$Be)) : "focusout" === a && $9b5c2f7437668c86$var$Ae();
}
function $9b5c2f7437668c86$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $9b5c2f7437668c86$var$te($9b5c2f7437668c86$var$qe);
}
function $9b5c2f7437668c86$var$Ee(a, b) {
    if ("click" === a) return $9b5c2f7437668c86$var$te(b);
}
function $9b5c2f7437668c86$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $9b5c2f7437668c86$var$te(b);
}
function $9b5c2f7437668c86$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9b5c2f7437668c86$var$He = "function" === typeof Object.is ? Object.is : $9b5c2f7437668c86$var$Ge;
function $9b5c2f7437668c86$var$Ie(a, b) {
    if ($9b5c2f7437668c86$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$9b5c2f7437668c86$var$ja.call(b, e) || !$9b5c2f7437668c86$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $9b5c2f7437668c86$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $9b5c2f7437668c86$var$Ke(a, b) {
    var c = $9b5c2f7437668c86$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $9b5c2f7437668c86$var$Je(c);
    }
}
function $9b5c2f7437668c86$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $9b5c2f7437668c86$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $9b5c2f7437668c86$var$Me() {
    for(var a = window, b = $9b5c2f7437668c86$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $9b5c2f7437668c86$var$Xa(a.document);
    }
    return b;
}
function $9b5c2f7437668c86$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $9b5c2f7437668c86$var$Oe(a) {
    var b = $9b5c2f7437668c86$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $9b5c2f7437668c86$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $9b5c2f7437668c86$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $9b5c2f7437668c86$var$Ke(c, f);
                var g = $9b5c2f7437668c86$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $9b5c2f7437668c86$var$Pe = $9b5c2f7437668c86$var$ia && "documentMode" in document && 11 >= document.documentMode, $9b5c2f7437668c86$var$Qe = null, $9b5c2f7437668c86$var$Re = null, $9b5c2f7437668c86$var$Se = null, $9b5c2f7437668c86$var$Te = !1;
function $9b5c2f7437668c86$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $9b5c2f7437668c86$var$Te || null == $9b5c2f7437668c86$var$Qe || $9b5c2f7437668c86$var$Qe !== $9b5c2f7437668c86$var$Xa(d) || (d = $9b5c2f7437668c86$var$Qe, "selectionStart" in d && $9b5c2f7437668c86$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $9b5c2f7437668c86$var$Se && $9b5c2f7437668c86$var$Ie($9b5c2f7437668c86$var$Se, d) || ($9b5c2f7437668c86$var$Se = d, d = $9b5c2f7437668c86$var$oe($9b5c2f7437668c86$var$Re, "onSelect"), 0 < d.length && (b = new $9b5c2f7437668c86$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $9b5c2f7437668c86$var$Qe)));
}
function $9b5c2f7437668c86$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $9b5c2f7437668c86$var$We = {
    animationend: $9b5c2f7437668c86$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $9b5c2f7437668c86$var$Ve("Animation", "AnimationIteration"),
    animationstart: $9b5c2f7437668c86$var$Ve("Animation", "AnimationStart"),
    transitionend: $9b5c2f7437668c86$var$Ve("Transition", "TransitionEnd")
}, $9b5c2f7437668c86$var$Xe = {}, $9b5c2f7437668c86$var$Ye = {};
$9b5c2f7437668c86$var$ia && ($9b5c2f7437668c86$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $9b5c2f7437668c86$var$We.animationend.animation, delete $9b5c2f7437668c86$var$We.animationiteration.animation, delete $9b5c2f7437668c86$var$We.animationstart.animation), "TransitionEvent" in window || delete $9b5c2f7437668c86$var$We.transitionend.transition);
function $9b5c2f7437668c86$var$Ze(a) {
    if ($9b5c2f7437668c86$var$Xe[a]) return $9b5c2f7437668c86$var$Xe[a];
    if (!$9b5c2f7437668c86$var$We[a]) return a;
    var b = $9b5c2f7437668c86$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $9b5c2f7437668c86$var$Ye) return $9b5c2f7437668c86$var$Xe[a] = b[c];
    return a;
}
var $9b5c2f7437668c86$var$$e = $9b5c2f7437668c86$var$Ze("animationend"), $9b5c2f7437668c86$var$af = $9b5c2f7437668c86$var$Ze("animationiteration"), $9b5c2f7437668c86$var$bf = $9b5c2f7437668c86$var$Ze("animationstart"), $9b5c2f7437668c86$var$cf = $9b5c2f7437668c86$var$Ze("transitionend"), $9b5c2f7437668c86$var$df = new Map, $9b5c2f7437668c86$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $9b5c2f7437668c86$var$ff(a, b) {
    $9b5c2f7437668c86$var$df.set(a, b);
    $9b5c2f7437668c86$var$fa(b, [
        a
    ]);
}
for(var $9b5c2f7437668c86$var$gf = 0; $9b5c2f7437668c86$var$gf < $9b5c2f7437668c86$var$ef.length; $9b5c2f7437668c86$var$gf++){
    var $9b5c2f7437668c86$var$hf = $9b5c2f7437668c86$var$ef[$9b5c2f7437668c86$var$gf], $9b5c2f7437668c86$var$jf = $9b5c2f7437668c86$var$hf.toLowerCase(), $9b5c2f7437668c86$var$kf = $9b5c2f7437668c86$var$hf[0].toUpperCase() + $9b5c2f7437668c86$var$hf.slice(1);
    $9b5c2f7437668c86$var$ff($9b5c2f7437668c86$var$jf, "on" + $9b5c2f7437668c86$var$kf);
}
$9b5c2f7437668c86$var$ff($9b5c2f7437668c86$var$$e, "onAnimationEnd");
$9b5c2f7437668c86$var$ff($9b5c2f7437668c86$var$af, "onAnimationIteration");
$9b5c2f7437668c86$var$ff($9b5c2f7437668c86$var$bf, "onAnimationStart");
$9b5c2f7437668c86$var$ff("dblclick", "onDoubleClick");
$9b5c2f7437668c86$var$ff("focusin", "onFocus");
$9b5c2f7437668c86$var$ff("focusout", "onBlur");
$9b5c2f7437668c86$var$ff($9b5c2f7437668c86$var$cf, "onTransitionEnd");
$9b5c2f7437668c86$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$9b5c2f7437668c86$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$9b5c2f7437668c86$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$9b5c2f7437668c86$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$9b5c2f7437668c86$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$9b5c2f7437668c86$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$9b5c2f7437668c86$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$9b5c2f7437668c86$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$9b5c2f7437668c86$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$9b5c2f7437668c86$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $9b5c2f7437668c86$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $9b5c2f7437668c86$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($9b5c2f7437668c86$var$lf));
function $9b5c2f7437668c86$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $9b5c2f7437668c86$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $9b5c2f7437668c86$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9b5c2f7437668c86$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9b5c2f7437668c86$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($9b5c2f7437668c86$var$Qb) throw a = $9b5c2f7437668c86$var$Rb, $9b5c2f7437668c86$var$Qb = !1, $9b5c2f7437668c86$var$Rb = null, a;
}
function $9b5c2f7437668c86$var$D(a, b) {
    var c = b[$9b5c2f7437668c86$var$of];
    void 0 === c && (c = b[$9b5c2f7437668c86$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($9b5c2f7437668c86$var$pf(b, a, 2, !1), c.add(d));
}
function $9b5c2f7437668c86$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $9b5c2f7437668c86$var$pf(c, a, d, b);
}
var $9b5c2f7437668c86$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $9b5c2f7437668c86$var$sf(a) {
    if (!a[$9b5c2f7437668c86$var$rf]) {
        a[$9b5c2f7437668c86$var$rf] = !0;
        $9b5c2f7437668c86$var$da.forEach(function(b) {
            "selectionchange" !== b && ($9b5c2f7437668c86$var$mf.has(b) || $9b5c2f7437668c86$var$qf(b, !1, a), $9b5c2f7437668c86$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$9b5c2f7437668c86$var$rf] || (b[$9b5c2f7437668c86$var$rf] = !0, $9b5c2f7437668c86$var$qf("selectionchange", !1, b));
    }
}
function $9b5c2f7437668c86$var$pf(a, b, c, d) {
    switch($9b5c2f7437668c86$var$jd(b)){
        case 1:
            var e = $9b5c2f7437668c86$var$ed;
            break;
        case 4:
            e = $9b5c2f7437668c86$var$gd;
            break;
        default:
            e = $9b5c2f7437668c86$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$9b5c2f7437668c86$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $9b5c2f7437668c86$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $9b5c2f7437668c86$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $9b5c2f7437668c86$var$Jb(function() {
        var d = f, e = $9b5c2f7437668c86$var$xb(c), g = [];
        a: {
            var h = $9b5c2f7437668c86$var$df.get(a);
            if (void 0 !== h) {
                var k = $9b5c2f7437668c86$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $9b5c2f7437668c86$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $9b5c2f7437668c86$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $9b5c2f7437668c86$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $9b5c2f7437668c86$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $9b5c2f7437668c86$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $9b5c2f7437668c86$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $9b5c2f7437668c86$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $9b5c2f7437668c86$var$Vd;
                        break;
                    case $9b5c2f7437668c86$var$$e:
                    case $9b5c2f7437668c86$var$af:
                    case $9b5c2f7437668c86$var$bf:
                        k = $9b5c2f7437668c86$var$Hd;
                        break;
                    case $9b5c2f7437668c86$var$cf:
                        k = $9b5c2f7437668c86$var$Xd;
                        break;
                    case "scroll":
                        k = $9b5c2f7437668c86$var$vd;
                        break;
                    case "wheel":
                        k = $9b5c2f7437668c86$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $9b5c2f7437668c86$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $9b5c2f7437668c86$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $9b5c2f7437668c86$var$Kb(w, x), null != F && t.push($9b5c2f7437668c86$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $9b5c2f7437668c86$var$wb && (n = c.relatedTarget || c.fromElement) && ($9b5c2f7437668c86$var$Wc(n) || n[$9b5c2f7437668c86$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $9b5c2f7437668c86$var$Wc(n) : null, null !== n && (J = $9b5c2f7437668c86$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $9b5c2f7437668c86$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $9b5c2f7437668c86$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $9b5c2f7437668c86$var$ue(k);
                        u = null == n ? h : $9b5c2f7437668c86$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $9b5c2f7437668c86$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $9b5c2f7437668c86$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $9b5c2f7437668c86$var$vf(F))u++;
                            for(; 0 < w - u;)t = $9b5c2f7437668c86$var$vf(t), w--;
                            for(; 0 < u - w;)x = $9b5c2f7437668c86$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $9b5c2f7437668c86$var$vf(t);
                                x = $9b5c2f7437668c86$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $9b5c2f7437668c86$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $9b5c2f7437668c86$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $9b5c2f7437668c86$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $9b5c2f7437668c86$var$ve;
                else if ($9b5c2f7437668c86$var$me(h)) {
                    if ($9b5c2f7437668c86$var$we) na = $9b5c2f7437668c86$var$Fe;
                    else {
                        na = $9b5c2f7437668c86$var$De;
                        var xa = $9b5c2f7437668c86$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $9b5c2f7437668c86$var$Ee);
                if (na && (na = na(a, d))) {
                    $9b5c2f7437668c86$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $9b5c2f7437668c86$var$cb(h, "number", h.value);
            }
            xa = d ? $9b5c2f7437668c86$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($9b5c2f7437668c86$var$me(xa) || "true" === xa.contentEditable) $9b5c2f7437668c86$var$Qe = xa, $9b5c2f7437668c86$var$Re = d, $9b5c2f7437668c86$var$Se = null;
                    break;
                case "focusout":
                    $9b5c2f7437668c86$var$Se = $9b5c2f7437668c86$var$Re = $9b5c2f7437668c86$var$Qe = null;
                    break;
                case "mousedown":
                    $9b5c2f7437668c86$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $9b5c2f7437668c86$var$Te = !1;
                    $9b5c2f7437668c86$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($9b5c2f7437668c86$var$Pe) break;
                case "keydown":
                case "keyup":
                    $9b5c2f7437668c86$var$Ue(g, c, e);
            }
            var $a;
            if ($9b5c2f7437668c86$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $9b5c2f7437668c86$var$ie ? $9b5c2f7437668c86$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($9b5c2f7437668c86$var$de && "ko" !== c.locale && ($9b5c2f7437668c86$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $9b5c2f7437668c86$var$ie && ($a = $9b5c2f7437668c86$var$nd()) : ($9b5c2f7437668c86$var$kd = e, $9b5c2f7437668c86$var$ld = "value" in $9b5c2f7437668c86$var$kd ? $9b5c2f7437668c86$var$kd.value : $9b5c2f7437668c86$var$kd.textContent, $9b5c2f7437668c86$var$ie = !0)), xa = $9b5c2f7437668c86$var$oe(d, ba), 0 < xa.length && (ba = new $9b5c2f7437668c86$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $9b5c2f7437668c86$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $9b5c2f7437668c86$var$ce ? $9b5c2f7437668c86$var$je(a, c) : $9b5c2f7437668c86$var$ke(a, c)) d = $9b5c2f7437668c86$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $9b5c2f7437668c86$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $9b5c2f7437668c86$var$se(g, b);
    });
}
function $9b5c2f7437668c86$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $9b5c2f7437668c86$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $9b5c2f7437668c86$var$Kb(a, c), null != f && d.unshift($9b5c2f7437668c86$var$tf(a, f, e)), f = $9b5c2f7437668c86$var$Kb(a, b), null != f && d.push($9b5c2f7437668c86$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $9b5c2f7437668c86$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $9b5c2f7437668c86$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $9b5c2f7437668c86$var$Kb(c, f), null != k && g.unshift($9b5c2f7437668c86$var$tf(c, k, h))) : e || (k = $9b5c2f7437668c86$var$Kb(c, f), null != k && g.push($9b5c2f7437668c86$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $9b5c2f7437668c86$var$xf = /\r\n?/g, $9b5c2f7437668c86$var$yf = /\u0000|\uFFFD/g;
function $9b5c2f7437668c86$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($9b5c2f7437668c86$var$xf, "\n").replace($9b5c2f7437668c86$var$yf, "");
}
function $9b5c2f7437668c86$var$Af(a, b, c) {
    b = $9b5c2f7437668c86$var$zf(b);
    if ($9b5c2f7437668c86$var$zf(a) !== b && c) throw Error($9b5c2f7437668c86$var$p(425));
}
function $9b5c2f7437668c86$var$Bf() {}
var $9b5c2f7437668c86$var$Cf = null, $9b5c2f7437668c86$var$Df = null;
function $9b5c2f7437668c86$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $9b5c2f7437668c86$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $9b5c2f7437668c86$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $9b5c2f7437668c86$var$Hf = "function" === typeof Promise ? Promise : void 0, $9b5c2f7437668c86$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $9b5c2f7437668c86$var$Hf ? function(a) {
    return $9b5c2f7437668c86$var$Hf.resolve(null).then(a).catch($9b5c2f7437668c86$var$If);
} : $9b5c2f7437668c86$var$Ff;
function $9b5c2f7437668c86$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $9b5c2f7437668c86$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $9b5c2f7437668c86$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $9b5c2f7437668c86$var$bd(b);
}
function $9b5c2f7437668c86$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $9b5c2f7437668c86$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $9b5c2f7437668c86$var$Nf = Math.random().toString(36).slice(2), $9b5c2f7437668c86$var$Of = "__reactFiber$" + $9b5c2f7437668c86$var$Nf, $9b5c2f7437668c86$var$Pf = "__reactProps$" + $9b5c2f7437668c86$var$Nf, $9b5c2f7437668c86$var$uf = "__reactContainer$" + $9b5c2f7437668c86$var$Nf, $9b5c2f7437668c86$var$of = "__reactEvents$" + $9b5c2f7437668c86$var$Nf, $9b5c2f7437668c86$var$Qf = "__reactListeners$" + $9b5c2f7437668c86$var$Nf, $9b5c2f7437668c86$var$Rf = "__reactHandles$" + $9b5c2f7437668c86$var$Nf;
function $9b5c2f7437668c86$var$Wc(a) {
    var b = a[$9b5c2f7437668c86$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$9b5c2f7437668c86$var$uf] || c[$9b5c2f7437668c86$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $9b5c2f7437668c86$var$Mf(a); null !== a;){
                if (c = a[$9b5c2f7437668c86$var$Of]) return c;
                a = $9b5c2f7437668c86$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $9b5c2f7437668c86$var$Cb(a) {
    a = a[$9b5c2f7437668c86$var$Of] || a[$9b5c2f7437668c86$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $9b5c2f7437668c86$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($9b5c2f7437668c86$var$p(33));
}
function $9b5c2f7437668c86$var$Db(a) {
    return a[$9b5c2f7437668c86$var$Pf] || null;
}
var $9b5c2f7437668c86$var$Sf = [], $9b5c2f7437668c86$var$Tf = -1;
function $9b5c2f7437668c86$var$Uf(a) {
    return {
        current: a
    };
}
function $9b5c2f7437668c86$var$E(a) {
    0 > $9b5c2f7437668c86$var$Tf || (a.current = $9b5c2f7437668c86$var$Sf[$9b5c2f7437668c86$var$Tf], $9b5c2f7437668c86$var$Sf[$9b5c2f7437668c86$var$Tf] = null, $9b5c2f7437668c86$var$Tf--);
}
function $9b5c2f7437668c86$var$G(a, b) {
    $9b5c2f7437668c86$var$Tf++;
    $9b5c2f7437668c86$var$Sf[$9b5c2f7437668c86$var$Tf] = a.current;
    a.current = b;
}
var $9b5c2f7437668c86$var$Vf = {}, $9b5c2f7437668c86$var$H = $9b5c2f7437668c86$var$Uf($9b5c2f7437668c86$var$Vf), $9b5c2f7437668c86$var$Wf = $9b5c2f7437668c86$var$Uf(!1), $9b5c2f7437668c86$var$Xf = $9b5c2f7437668c86$var$Vf;
function $9b5c2f7437668c86$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $9b5c2f7437668c86$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $9b5c2f7437668c86$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $9b5c2f7437668c86$var$$f() {
    $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$Wf);
    $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$H);
}
function $9b5c2f7437668c86$var$ag(a, b, c) {
    if ($9b5c2f7437668c86$var$H.current !== $9b5c2f7437668c86$var$Vf) throw Error($9b5c2f7437668c86$var$p(168));
    $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$H, b);
    $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$Wf, c);
}
function $9b5c2f7437668c86$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($9b5c2f7437668c86$var$p(108, $9b5c2f7437668c86$var$Ra(a) || "Unknown", e));
    return $9b5c2f7437668c86$var$A({}, c, d);
}
function $9b5c2f7437668c86$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $9b5c2f7437668c86$var$Vf;
    $9b5c2f7437668c86$var$Xf = $9b5c2f7437668c86$var$H.current;
    $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$H, a);
    $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$Wf, $9b5c2f7437668c86$var$Wf.current);
    return !0;
}
function $9b5c2f7437668c86$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($9b5c2f7437668c86$var$p(169));
    c ? (a = $9b5c2f7437668c86$var$bg(a, b, $9b5c2f7437668c86$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$Wf), $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$H), $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$H, a)) : $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$Wf);
    $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$Wf, c);
}
var $9b5c2f7437668c86$var$eg = null, $9b5c2f7437668c86$var$fg = !1, $9b5c2f7437668c86$var$gg = !1;
function $9b5c2f7437668c86$var$hg(a) {
    null === $9b5c2f7437668c86$var$eg ? $9b5c2f7437668c86$var$eg = [
        a
    ] : $9b5c2f7437668c86$var$eg.push(a);
}
function $9b5c2f7437668c86$var$ig(a) {
    $9b5c2f7437668c86$var$fg = !0;
    $9b5c2f7437668c86$var$hg(a);
}
function $9b5c2f7437668c86$var$jg() {
    if (!$9b5c2f7437668c86$var$gg && null !== $9b5c2f7437668c86$var$eg) {
        $9b5c2f7437668c86$var$gg = !0;
        var a = 0, b = $9b5c2f7437668c86$var$C;
        try {
            var c = $9b5c2f7437668c86$var$eg;
            for($9b5c2f7437668c86$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $9b5c2f7437668c86$var$eg = null;
            $9b5c2f7437668c86$var$fg = !1;
        } catch (e) {
            throw null !== $9b5c2f7437668c86$var$eg && ($9b5c2f7437668c86$var$eg = $9b5c2f7437668c86$var$eg.slice(a + 1)), $9b5c2f7437668c86$var$ac($9b5c2f7437668c86$var$fc, $9b5c2f7437668c86$var$jg), e;
        } finally{
            $9b5c2f7437668c86$var$C = b, $9b5c2f7437668c86$var$gg = !1;
        }
    }
    return null;
}
var $9b5c2f7437668c86$var$kg = [], $9b5c2f7437668c86$var$lg = 0, $9b5c2f7437668c86$var$mg = null, $9b5c2f7437668c86$var$ng = 0, $9b5c2f7437668c86$var$og = [], $9b5c2f7437668c86$var$pg = 0, $9b5c2f7437668c86$var$qg = null, $9b5c2f7437668c86$var$rg = 1, $9b5c2f7437668c86$var$sg = "";
function $9b5c2f7437668c86$var$tg(a, b) {
    $9b5c2f7437668c86$var$kg[$9b5c2f7437668c86$var$lg++] = $9b5c2f7437668c86$var$ng;
    $9b5c2f7437668c86$var$kg[$9b5c2f7437668c86$var$lg++] = $9b5c2f7437668c86$var$mg;
    $9b5c2f7437668c86$var$mg = a;
    $9b5c2f7437668c86$var$ng = b;
}
function $9b5c2f7437668c86$var$ug(a, b, c) {
    $9b5c2f7437668c86$var$og[$9b5c2f7437668c86$var$pg++] = $9b5c2f7437668c86$var$rg;
    $9b5c2f7437668c86$var$og[$9b5c2f7437668c86$var$pg++] = $9b5c2f7437668c86$var$sg;
    $9b5c2f7437668c86$var$og[$9b5c2f7437668c86$var$pg++] = $9b5c2f7437668c86$var$qg;
    $9b5c2f7437668c86$var$qg = a;
    var d = $9b5c2f7437668c86$var$rg;
    a = $9b5c2f7437668c86$var$sg;
    var e = 32 - $9b5c2f7437668c86$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $9b5c2f7437668c86$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $9b5c2f7437668c86$var$rg = 1 << 32 - $9b5c2f7437668c86$var$oc(b) + e | c << e | d;
        $9b5c2f7437668c86$var$sg = f + a;
    } else $9b5c2f7437668c86$var$rg = 1 << f | c << e | d, $9b5c2f7437668c86$var$sg = a;
}
function $9b5c2f7437668c86$var$vg(a) {
    null !== a.return && ($9b5c2f7437668c86$var$tg(a, 1), $9b5c2f7437668c86$var$ug(a, 1, 0));
}
function $9b5c2f7437668c86$var$wg(a) {
    for(; a === $9b5c2f7437668c86$var$mg;)$9b5c2f7437668c86$var$mg = $9b5c2f7437668c86$var$kg[--$9b5c2f7437668c86$var$lg], $9b5c2f7437668c86$var$kg[$9b5c2f7437668c86$var$lg] = null, $9b5c2f7437668c86$var$ng = $9b5c2f7437668c86$var$kg[--$9b5c2f7437668c86$var$lg], $9b5c2f7437668c86$var$kg[$9b5c2f7437668c86$var$lg] = null;
    for(; a === $9b5c2f7437668c86$var$qg;)$9b5c2f7437668c86$var$qg = $9b5c2f7437668c86$var$og[--$9b5c2f7437668c86$var$pg], $9b5c2f7437668c86$var$og[$9b5c2f7437668c86$var$pg] = null, $9b5c2f7437668c86$var$sg = $9b5c2f7437668c86$var$og[--$9b5c2f7437668c86$var$pg], $9b5c2f7437668c86$var$og[$9b5c2f7437668c86$var$pg] = null, $9b5c2f7437668c86$var$rg = $9b5c2f7437668c86$var$og[--$9b5c2f7437668c86$var$pg], $9b5c2f7437668c86$var$og[$9b5c2f7437668c86$var$pg] = null;
}
var $9b5c2f7437668c86$var$xg = null, $9b5c2f7437668c86$var$yg = null, $9b5c2f7437668c86$var$I = !1, $9b5c2f7437668c86$var$zg = null;
function $9b5c2f7437668c86$var$Ag(a, b) {
    var c = $9b5c2f7437668c86$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $9b5c2f7437668c86$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $9b5c2f7437668c86$var$xg = a, $9b5c2f7437668c86$var$yg = $9b5c2f7437668c86$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $9b5c2f7437668c86$var$xg = a, $9b5c2f7437668c86$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $9b5c2f7437668c86$var$qg ? {
                id: $9b5c2f7437668c86$var$rg,
                overflow: $9b5c2f7437668c86$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $9b5c2f7437668c86$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $9b5c2f7437668c86$var$xg = a, $9b5c2f7437668c86$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $9b5c2f7437668c86$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $9b5c2f7437668c86$var$Eg(a) {
    if ($9b5c2f7437668c86$var$I) {
        var b = $9b5c2f7437668c86$var$yg;
        if (b) {
            var c = b;
            if (!$9b5c2f7437668c86$var$Cg(a, b)) {
                if ($9b5c2f7437668c86$var$Dg(a)) throw Error($9b5c2f7437668c86$var$p(418));
                b = $9b5c2f7437668c86$var$Lf(c.nextSibling);
                var d = $9b5c2f7437668c86$var$xg;
                b && $9b5c2f7437668c86$var$Cg(a, b) ? $9b5c2f7437668c86$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $9b5c2f7437668c86$var$I = !1, $9b5c2f7437668c86$var$xg = a);
            }
        } else {
            if ($9b5c2f7437668c86$var$Dg(a)) throw Error($9b5c2f7437668c86$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $9b5c2f7437668c86$var$I = !1;
            $9b5c2f7437668c86$var$xg = a;
        }
    }
}
function $9b5c2f7437668c86$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $9b5c2f7437668c86$var$xg = a;
}
function $9b5c2f7437668c86$var$Gg(a) {
    if (a !== $9b5c2f7437668c86$var$xg) return !1;
    if (!$9b5c2f7437668c86$var$I) return $9b5c2f7437668c86$var$Fg(a), $9b5c2f7437668c86$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$9b5c2f7437668c86$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $9b5c2f7437668c86$var$yg)) {
        if ($9b5c2f7437668c86$var$Dg(a)) throw $9b5c2f7437668c86$var$Hg(), Error($9b5c2f7437668c86$var$p(418));
        for(; b;)$9b5c2f7437668c86$var$Ag(a, b), b = $9b5c2f7437668c86$var$Lf(b.nextSibling);
    }
    $9b5c2f7437668c86$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($9b5c2f7437668c86$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $9b5c2f7437668c86$var$yg = $9b5c2f7437668c86$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $9b5c2f7437668c86$var$yg = null;
        }
    } else $9b5c2f7437668c86$var$yg = $9b5c2f7437668c86$var$xg ? $9b5c2f7437668c86$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $9b5c2f7437668c86$var$Hg() {
    for(var a = $9b5c2f7437668c86$var$yg; a;)a = $9b5c2f7437668c86$var$Lf(a.nextSibling);
}
function $9b5c2f7437668c86$var$Ig() {
    $9b5c2f7437668c86$var$yg = $9b5c2f7437668c86$var$xg = null;
    $9b5c2f7437668c86$var$I = !1;
}
function $9b5c2f7437668c86$var$Jg(a) {
    null === $9b5c2f7437668c86$var$zg ? $9b5c2f7437668c86$var$zg = [
        a
    ] : $9b5c2f7437668c86$var$zg.push(a);
}
var $9b5c2f7437668c86$var$Kg = $9b5c2f7437668c86$var$ua.ReactCurrentBatchConfig;
function $9b5c2f7437668c86$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($9b5c2f7437668c86$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($9b5c2f7437668c86$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($9b5c2f7437668c86$var$p(284));
        if (!c._owner) throw Error($9b5c2f7437668c86$var$p(290, a));
    }
    return a;
}
function $9b5c2f7437668c86$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($9b5c2f7437668c86$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $9b5c2f7437668c86$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $9b5c2f7437668c86$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $9b5c2f7437668c86$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $9b5c2f7437668c86$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $9b5c2f7437668c86$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $9b5c2f7437668c86$var$Ha && $9b5c2f7437668c86$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $9b5c2f7437668c86$var$Lg(a, b, c), d.return = a, d;
        d = $9b5c2f7437668c86$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $9b5c2f7437668c86$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $9b5c2f7437668c86$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $9b5c2f7437668c86$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $9b5c2f7437668c86$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $9b5c2f7437668c86$var$va:
                    return c = $9b5c2f7437668c86$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $9b5c2f7437668c86$var$Lg(a, null, b), c.return = a, c;
                case $9b5c2f7437668c86$var$wa:
                    return b = $9b5c2f7437668c86$var$Sg(b, a.mode, c), b.return = a, b;
                case $9b5c2f7437668c86$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($9b5c2f7437668c86$var$eb(b) || $9b5c2f7437668c86$var$Ka(b)) return b = $9b5c2f7437668c86$var$Tg(b, a.mode, c, null), b.return = a, b;
            $9b5c2f7437668c86$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $9b5c2f7437668c86$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $9b5c2f7437668c86$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $9b5c2f7437668c86$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($9b5c2f7437668c86$var$eb(c) || $9b5c2f7437668c86$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $9b5c2f7437668c86$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $9b5c2f7437668c86$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $9b5c2f7437668c86$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $9b5c2f7437668c86$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($9b5c2f7437668c86$var$eb(d) || $9b5c2f7437668c86$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $9b5c2f7437668c86$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $9b5c2f7437668c86$var$I && $9b5c2f7437668c86$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $9b5c2f7437668c86$var$I && $9b5c2f7437668c86$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $9b5c2f7437668c86$var$I && $9b5c2f7437668c86$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $9b5c2f7437668c86$var$Ka(h);
        if ("function" !== typeof l) throw Error($9b5c2f7437668c86$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($9b5c2f7437668c86$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $9b5c2f7437668c86$var$I && $9b5c2f7437668c86$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $9b5c2f7437668c86$var$I && $9b5c2f7437668c86$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $9b5c2f7437668c86$var$I && $9b5c2f7437668c86$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $9b5c2f7437668c86$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $9b5c2f7437668c86$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $9b5c2f7437668c86$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $9b5c2f7437668c86$var$Ha && $9b5c2f7437668c86$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $9b5c2f7437668c86$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $9b5c2f7437668c86$var$ya ? (d = $9b5c2f7437668c86$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $9b5c2f7437668c86$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $9b5c2f7437668c86$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $9b5c2f7437668c86$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $9b5c2f7437668c86$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $9b5c2f7437668c86$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($9b5c2f7437668c86$var$eb(f)) return n(a, d, f, h);
            if ($9b5c2f7437668c86$var$Ka(f)) return t(a, d, f, h);
            $9b5c2f7437668c86$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $9b5c2f7437668c86$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $9b5c2f7437668c86$var$Ug = $9b5c2f7437668c86$var$Og(!0), $9b5c2f7437668c86$var$Vg = $9b5c2f7437668c86$var$Og(!1), $9b5c2f7437668c86$var$Wg = $9b5c2f7437668c86$var$Uf(null), $9b5c2f7437668c86$var$Xg = null, $9b5c2f7437668c86$var$Yg = null, $9b5c2f7437668c86$var$Zg = null;
function $9b5c2f7437668c86$var$$g() {
    $9b5c2f7437668c86$var$Zg = $9b5c2f7437668c86$var$Yg = $9b5c2f7437668c86$var$Xg = null;
}
function $9b5c2f7437668c86$var$ah(a) {
    var b = $9b5c2f7437668c86$var$Wg.current;
    $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$Wg);
    a._currentValue = b;
}
function $9b5c2f7437668c86$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $9b5c2f7437668c86$var$ch(a, b) {
    $9b5c2f7437668c86$var$Xg = a;
    $9b5c2f7437668c86$var$Zg = $9b5c2f7437668c86$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($9b5c2f7437668c86$var$dh = !0), a.firstContext = null);
}
function $9b5c2f7437668c86$var$eh(a) {
    var b = a._currentValue;
    if ($9b5c2f7437668c86$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $9b5c2f7437668c86$var$Yg) {
            if (null === $9b5c2f7437668c86$var$Xg) throw Error($9b5c2f7437668c86$var$p(308));
            $9b5c2f7437668c86$var$Yg = a;
            $9b5c2f7437668c86$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $9b5c2f7437668c86$var$Yg = $9b5c2f7437668c86$var$Yg.next = a;
    }
    return b;
}
var $9b5c2f7437668c86$var$fh = null;
function $9b5c2f7437668c86$var$gh(a) {
    null === $9b5c2f7437668c86$var$fh ? $9b5c2f7437668c86$var$fh = [
        a
    ] : $9b5c2f7437668c86$var$fh.push(a);
}
function $9b5c2f7437668c86$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $9b5c2f7437668c86$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $9b5c2f7437668c86$var$ih(a, d);
}
function $9b5c2f7437668c86$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $9b5c2f7437668c86$var$jh = !1;
function $9b5c2f7437668c86$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $9b5c2f7437668c86$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $9b5c2f7437668c86$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $9b5c2f7437668c86$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($9b5c2f7437668c86$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $9b5c2f7437668c86$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $9b5c2f7437668c86$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $9b5c2f7437668c86$var$ih(a, c);
}
function $9b5c2f7437668c86$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9b5c2f7437668c86$var$Cc(a, c);
    }
}
function $9b5c2f7437668c86$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $9b5c2f7437668c86$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $9b5c2f7437668c86$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $9b5c2f7437668c86$var$A({}, q, r);
                            break a;
                        case 2:
                            $9b5c2f7437668c86$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $9b5c2f7437668c86$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $9b5c2f7437668c86$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($9b5c2f7437668c86$var$p(191, e));
            e.call(d);
        }
    }
}
var $9b5c2f7437668c86$var$th = {}, $9b5c2f7437668c86$var$uh = $9b5c2f7437668c86$var$Uf($9b5c2f7437668c86$var$th), $9b5c2f7437668c86$var$vh = $9b5c2f7437668c86$var$Uf($9b5c2f7437668c86$var$th), $9b5c2f7437668c86$var$wh = $9b5c2f7437668c86$var$Uf($9b5c2f7437668c86$var$th);
function $9b5c2f7437668c86$var$xh(a) {
    if (a === $9b5c2f7437668c86$var$th) throw Error($9b5c2f7437668c86$var$p(174));
    return a;
}
function $9b5c2f7437668c86$var$yh(a, b) {
    $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$wh, b);
    $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$vh, a);
    $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$uh, $9b5c2f7437668c86$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $9b5c2f7437668c86$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $9b5c2f7437668c86$var$lb(b, a);
    }
    $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$uh);
    $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$uh, b);
}
function $9b5c2f7437668c86$var$zh() {
    $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$uh);
    $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$vh);
    $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$wh);
}
function $9b5c2f7437668c86$var$Ah(a) {
    $9b5c2f7437668c86$var$xh($9b5c2f7437668c86$var$wh.current);
    var b = $9b5c2f7437668c86$var$xh($9b5c2f7437668c86$var$uh.current);
    var c = $9b5c2f7437668c86$var$lb(b, a.type);
    b !== c && ($9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$vh, a), $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$uh, c));
}
function $9b5c2f7437668c86$var$Bh(a) {
    $9b5c2f7437668c86$var$vh.current === a && ($9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$uh), $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$vh));
}
var $9b5c2f7437668c86$var$L = $9b5c2f7437668c86$var$Uf(0);
function $9b5c2f7437668c86$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $9b5c2f7437668c86$var$Dh = [];
function $9b5c2f7437668c86$var$Eh() {
    for(var a = 0; a < $9b5c2f7437668c86$var$Dh.length; a++)$9b5c2f7437668c86$var$Dh[a]._workInProgressVersionPrimary = null;
    $9b5c2f7437668c86$var$Dh.length = 0;
}
var $9b5c2f7437668c86$var$Fh = $9b5c2f7437668c86$var$ua.ReactCurrentDispatcher, $9b5c2f7437668c86$var$Gh = $9b5c2f7437668c86$var$ua.ReactCurrentBatchConfig, $9b5c2f7437668c86$var$Hh = 0, $9b5c2f7437668c86$var$M = null, $9b5c2f7437668c86$var$N = null, $9b5c2f7437668c86$var$O = null, $9b5c2f7437668c86$var$Ih = !1, $9b5c2f7437668c86$var$Jh = !1, $9b5c2f7437668c86$var$Kh = 0, $9b5c2f7437668c86$var$Lh = 0;
function $9b5c2f7437668c86$var$P() {
    throw Error($9b5c2f7437668c86$var$p(321));
}
function $9b5c2f7437668c86$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$9b5c2f7437668c86$var$He(a[c], b[c])) return !1;
    return !0;
}
function $9b5c2f7437668c86$var$Nh(a, b, c, d, e, f) {
    $9b5c2f7437668c86$var$Hh = f;
    $9b5c2f7437668c86$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $9b5c2f7437668c86$var$Fh.current = null === a || null === a.memoizedState ? $9b5c2f7437668c86$var$Oh : $9b5c2f7437668c86$var$Ph;
    a = c(d, e);
    if ($9b5c2f7437668c86$var$Jh) {
        f = 0;
        do {
            $9b5c2f7437668c86$var$Jh = !1;
            $9b5c2f7437668c86$var$Kh = 0;
            if (25 <= f) throw Error($9b5c2f7437668c86$var$p(301));
            f += 1;
            $9b5c2f7437668c86$var$O = $9b5c2f7437668c86$var$N = null;
            b.updateQueue = null;
            $9b5c2f7437668c86$var$Fh.current = $9b5c2f7437668c86$var$Qh;
            a = c(d, e);
        }while ($9b5c2f7437668c86$var$Jh);
    }
    $9b5c2f7437668c86$var$Fh.current = $9b5c2f7437668c86$var$Rh;
    b = null !== $9b5c2f7437668c86$var$N && null !== $9b5c2f7437668c86$var$N.next;
    $9b5c2f7437668c86$var$Hh = 0;
    $9b5c2f7437668c86$var$O = $9b5c2f7437668c86$var$N = $9b5c2f7437668c86$var$M = null;
    $9b5c2f7437668c86$var$Ih = !1;
    if (b) throw Error($9b5c2f7437668c86$var$p(300));
    return a;
}
function $9b5c2f7437668c86$var$Sh() {
    var a = 0 !== $9b5c2f7437668c86$var$Kh;
    $9b5c2f7437668c86$var$Kh = 0;
    return a;
}
function $9b5c2f7437668c86$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $9b5c2f7437668c86$var$O ? $9b5c2f7437668c86$var$M.memoizedState = $9b5c2f7437668c86$var$O = a : $9b5c2f7437668c86$var$O = $9b5c2f7437668c86$var$O.next = a;
    return $9b5c2f7437668c86$var$O;
}
function $9b5c2f7437668c86$var$Uh() {
    if (null === $9b5c2f7437668c86$var$N) {
        var a = $9b5c2f7437668c86$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $9b5c2f7437668c86$var$N.next;
    var b = null === $9b5c2f7437668c86$var$O ? $9b5c2f7437668c86$var$M.memoizedState : $9b5c2f7437668c86$var$O.next;
    if (null !== b) $9b5c2f7437668c86$var$O = b, $9b5c2f7437668c86$var$N = a;
    else {
        if (null === a) throw Error($9b5c2f7437668c86$var$p(310));
        $9b5c2f7437668c86$var$N = a;
        a = {
            memoizedState: $9b5c2f7437668c86$var$N.memoizedState,
            baseState: $9b5c2f7437668c86$var$N.baseState,
            baseQueue: $9b5c2f7437668c86$var$N.baseQueue,
            queue: $9b5c2f7437668c86$var$N.queue,
            next: null
        };
        null === $9b5c2f7437668c86$var$O ? $9b5c2f7437668c86$var$M.memoizedState = $9b5c2f7437668c86$var$O = a : $9b5c2f7437668c86$var$O = $9b5c2f7437668c86$var$O.next = a;
    }
    return $9b5c2f7437668c86$var$O;
}
function $9b5c2f7437668c86$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9b5c2f7437668c86$var$Wh(a) {
    var b = $9b5c2f7437668c86$var$Uh(), c = b.queue;
    if (null === c) throw Error($9b5c2f7437668c86$var$p(311));
    c.lastRenderedReducer = a;
    var d = $9b5c2f7437668c86$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($9b5c2f7437668c86$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $9b5c2f7437668c86$var$M.lanes |= m;
                $9b5c2f7437668c86$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $9b5c2f7437668c86$var$He(d, b.memoizedState) || ($9b5c2f7437668c86$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $9b5c2f7437668c86$var$M.lanes |= f, $9b5c2f7437668c86$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $9b5c2f7437668c86$var$Xh(a) {
    var b = $9b5c2f7437668c86$var$Uh(), c = b.queue;
    if (null === c) throw Error($9b5c2f7437668c86$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $9b5c2f7437668c86$var$He(f, b.memoizedState) || ($9b5c2f7437668c86$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $9b5c2f7437668c86$var$Yh() {}
function $9b5c2f7437668c86$var$Zh(a, b) {
    var c = $9b5c2f7437668c86$var$M, d = $9b5c2f7437668c86$var$Uh(), e = b(), f = !$9b5c2f7437668c86$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $9b5c2f7437668c86$var$dh = !0);
    d = d.queue;
    $9b5c2f7437668c86$var$$h($9b5c2f7437668c86$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $9b5c2f7437668c86$var$O && $9b5c2f7437668c86$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $9b5c2f7437668c86$var$bi(9, $9b5c2f7437668c86$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $9b5c2f7437668c86$var$Q) throw Error($9b5c2f7437668c86$var$p(349));
        0 !== ($9b5c2f7437668c86$var$Hh & 30) || $9b5c2f7437668c86$var$di(c, b, e);
    }
    return e;
}
function $9b5c2f7437668c86$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $9b5c2f7437668c86$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9b5c2f7437668c86$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $9b5c2f7437668c86$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $9b5c2f7437668c86$var$ei(b) && $9b5c2f7437668c86$var$fi(a);
}
function $9b5c2f7437668c86$var$ai(a, b, c) {
    return c(function() {
        $9b5c2f7437668c86$var$ei(b) && $9b5c2f7437668c86$var$fi(a);
    });
}
function $9b5c2f7437668c86$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$9b5c2f7437668c86$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $9b5c2f7437668c86$var$fi(a) {
    var b = $9b5c2f7437668c86$var$ih(a, 1);
    null !== b && $9b5c2f7437668c86$var$gi(b, a, 1, -1);
}
function $9b5c2f7437668c86$var$hi(a) {
    var b = $9b5c2f7437668c86$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $9b5c2f7437668c86$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $9b5c2f7437668c86$var$ii.bind(null, $9b5c2f7437668c86$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $9b5c2f7437668c86$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $9b5c2f7437668c86$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9b5c2f7437668c86$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $9b5c2f7437668c86$var$ji() {
    return $9b5c2f7437668c86$var$Uh().memoizedState;
}
function $9b5c2f7437668c86$var$ki(a, b, c, d) {
    var e = $9b5c2f7437668c86$var$Th();
    $9b5c2f7437668c86$var$M.flags |= a;
    e.memoizedState = $9b5c2f7437668c86$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $9b5c2f7437668c86$var$li(a, b, c, d) {
    var e = $9b5c2f7437668c86$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $9b5c2f7437668c86$var$N) {
        var g = $9b5c2f7437668c86$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $9b5c2f7437668c86$var$Mh(d, g.deps)) {
            e.memoizedState = $9b5c2f7437668c86$var$bi(b, c, f, d);
            return;
        }
    }
    $9b5c2f7437668c86$var$M.flags |= a;
    e.memoizedState = $9b5c2f7437668c86$var$bi(1 | b, c, f, d);
}
function $9b5c2f7437668c86$var$mi(a, b) {
    return $9b5c2f7437668c86$var$ki(8390656, 8, a, b);
}
function $9b5c2f7437668c86$var$$h(a, b) {
    return $9b5c2f7437668c86$var$li(2048, 8, a, b);
}
function $9b5c2f7437668c86$var$ni(a, b) {
    return $9b5c2f7437668c86$var$li(4, 2, a, b);
}
function $9b5c2f7437668c86$var$oi(a, b) {
    return $9b5c2f7437668c86$var$li(4, 4, a, b);
}
function $9b5c2f7437668c86$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $9b5c2f7437668c86$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $9b5c2f7437668c86$var$li(4, 4, $9b5c2f7437668c86$var$pi.bind(null, b, a), c);
}
function $9b5c2f7437668c86$var$ri() {}
function $9b5c2f7437668c86$var$si(a, b) {
    var c = $9b5c2f7437668c86$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9b5c2f7437668c86$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9b5c2f7437668c86$var$ti(a, b) {
    var c = $9b5c2f7437668c86$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9b5c2f7437668c86$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9b5c2f7437668c86$var$ui(a, b, c) {
    if (0 === ($9b5c2f7437668c86$var$Hh & 21)) return a.baseState && (a.baseState = !1, $9b5c2f7437668c86$var$dh = !0), a.memoizedState = c;
    $9b5c2f7437668c86$var$He(c, b) || (c = $9b5c2f7437668c86$var$yc(), $9b5c2f7437668c86$var$M.lanes |= c, $9b5c2f7437668c86$var$rh |= c, a.baseState = !0);
    return b;
}
function $9b5c2f7437668c86$var$vi(a, b) {
    var c = $9b5c2f7437668c86$var$C;
    $9b5c2f7437668c86$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $9b5c2f7437668c86$var$Gh.transition;
    $9b5c2f7437668c86$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $9b5c2f7437668c86$var$C = c, $9b5c2f7437668c86$var$Gh.transition = d;
    }
}
function $9b5c2f7437668c86$var$wi() {
    return $9b5c2f7437668c86$var$Uh().memoizedState;
}
function $9b5c2f7437668c86$var$xi(a, b, c) {
    var d = $9b5c2f7437668c86$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9b5c2f7437668c86$var$zi(a)) $9b5c2f7437668c86$var$Ai(b, c);
    else if (c = $9b5c2f7437668c86$var$hh(a, b, c, d), null !== c) {
        var e = $9b5c2f7437668c86$var$R();
        $9b5c2f7437668c86$var$gi(c, a, d, e);
        $9b5c2f7437668c86$var$Bi(c, b, d);
    }
}
function $9b5c2f7437668c86$var$ii(a, b, c) {
    var d = $9b5c2f7437668c86$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9b5c2f7437668c86$var$zi(a)) $9b5c2f7437668c86$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($9b5c2f7437668c86$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $9b5c2f7437668c86$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $9b5c2f7437668c86$var$hh(a, b, e, d);
        null !== c && (e = $9b5c2f7437668c86$var$R(), $9b5c2f7437668c86$var$gi(c, a, d, e), $9b5c2f7437668c86$var$Bi(c, b, d));
    }
}
function $9b5c2f7437668c86$var$zi(a) {
    var b = a.alternate;
    return a === $9b5c2f7437668c86$var$M || null !== b && b === $9b5c2f7437668c86$var$M;
}
function $9b5c2f7437668c86$var$Ai(a, b) {
    $9b5c2f7437668c86$var$Jh = $9b5c2f7437668c86$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $9b5c2f7437668c86$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9b5c2f7437668c86$var$Cc(a, c);
    }
}
var $9b5c2f7437668c86$var$Rh = {
    readContext: $9b5c2f7437668c86$var$eh,
    useCallback: $9b5c2f7437668c86$var$P,
    useContext: $9b5c2f7437668c86$var$P,
    useEffect: $9b5c2f7437668c86$var$P,
    useImperativeHandle: $9b5c2f7437668c86$var$P,
    useInsertionEffect: $9b5c2f7437668c86$var$P,
    useLayoutEffect: $9b5c2f7437668c86$var$P,
    useMemo: $9b5c2f7437668c86$var$P,
    useReducer: $9b5c2f7437668c86$var$P,
    useRef: $9b5c2f7437668c86$var$P,
    useState: $9b5c2f7437668c86$var$P,
    useDebugValue: $9b5c2f7437668c86$var$P,
    useDeferredValue: $9b5c2f7437668c86$var$P,
    useTransition: $9b5c2f7437668c86$var$P,
    useMutableSource: $9b5c2f7437668c86$var$P,
    useSyncExternalStore: $9b5c2f7437668c86$var$P,
    useId: $9b5c2f7437668c86$var$P,
    unstable_isNewReconciler: !1
}, $9b5c2f7437668c86$var$Oh = {
    readContext: $9b5c2f7437668c86$var$eh,
    useCallback: function(a, b) {
        $9b5c2f7437668c86$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $9b5c2f7437668c86$var$eh,
    useEffect: $9b5c2f7437668c86$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $9b5c2f7437668c86$var$ki(4194308, 4, $9b5c2f7437668c86$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $9b5c2f7437668c86$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $9b5c2f7437668c86$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $9b5c2f7437668c86$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $9b5c2f7437668c86$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $9b5c2f7437668c86$var$xi.bind(null, $9b5c2f7437668c86$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $9b5c2f7437668c86$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $9b5c2f7437668c86$var$hi,
    useDebugValue: $9b5c2f7437668c86$var$ri,
    useDeferredValue: function(a) {
        return $9b5c2f7437668c86$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $9b5c2f7437668c86$var$hi(!1), b = a[0];
        a = $9b5c2f7437668c86$var$vi.bind(null, a[1]);
        $9b5c2f7437668c86$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $9b5c2f7437668c86$var$M, e = $9b5c2f7437668c86$var$Th();
        if ($9b5c2f7437668c86$var$I) {
            if (void 0 === c) throw Error($9b5c2f7437668c86$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $9b5c2f7437668c86$var$Q) throw Error($9b5c2f7437668c86$var$p(349));
            0 !== ($9b5c2f7437668c86$var$Hh & 30) || $9b5c2f7437668c86$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $9b5c2f7437668c86$var$mi($9b5c2f7437668c86$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $9b5c2f7437668c86$var$bi(9, $9b5c2f7437668c86$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $9b5c2f7437668c86$var$Th(), b = $9b5c2f7437668c86$var$Q.identifierPrefix;
        if ($9b5c2f7437668c86$var$I) {
            var c = $9b5c2f7437668c86$var$sg;
            var d = $9b5c2f7437668c86$var$rg;
            c = (d & ~(1 << 32 - $9b5c2f7437668c86$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $9b5c2f7437668c86$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $9b5c2f7437668c86$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $9b5c2f7437668c86$var$Ph = {
    readContext: $9b5c2f7437668c86$var$eh,
    useCallback: $9b5c2f7437668c86$var$si,
    useContext: $9b5c2f7437668c86$var$eh,
    useEffect: $9b5c2f7437668c86$var$$h,
    useImperativeHandle: $9b5c2f7437668c86$var$qi,
    useInsertionEffect: $9b5c2f7437668c86$var$ni,
    useLayoutEffect: $9b5c2f7437668c86$var$oi,
    useMemo: $9b5c2f7437668c86$var$ti,
    useReducer: $9b5c2f7437668c86$var$Wh,
    useRef: $9b5c2f7437668c86$var$ji,
    useState: function() {
        return $9b5c2f7437668c86$var$Wh($9b5c2f7437668c86$var$Vh);
    },
    useDebugValue: $9b5c2f7437668c86$var$ri,
    useDeferredValue: function(a) {
        var b = $9b5c2f7437668c86$var$Uh();
        return $9b5c2f7437668c86$var$ui(b, $9b5c2f7437668c86$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $9b5c2f7437668c86$var$Wh($9b5c2f7437668c86$var$Vh)[0], b = $9b5c2f7437668c86$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9b5c2f7437668c86$var$Yh,
    useSyncExternalStore: $9b5c2f7437668c86$var$Zh,
    useId: $9b5c2f7437668c86$var$wi,
    unstable_isNewReconciler: !1
}, $9b5c2f7437668c86$var$Qh = {
    readContext: $9b5c2f7437668c86$var$eh,
    useCallback: $9b5c2f7437668c86$var$si,
    useContext: $9b5c2f7437668c86$var$eh,
    useEffect: $9b5c2f7437668c86$var$$h,
    useImperativeHandle: $9b5c2f7437668c86$var$qi,
    useInsertionEffect: $9b5c2f7437668c86$var$ni,
    useLayoutEffect: $9b5c2f7437668c86$var$oi,
    useMemo: $9b5c2f7437668c86$var$ti,
    useReducer: $9b5c2f7437668c86$var$Xh,
    useRef: $9b5c2f7437668c86$var$ji,
    useState: function() {
        return $9b5c2f7437668c86$var$Xh($9b5c2f7437668c86$var$Vh);
    },
    useDebugValue: $9b5c2f7437668c86$var$ri,
    useDeferredValue: function(a) {
        var b = $9b5c2f7437668c86$var$Uh();
        return null === $9b5c2f7437668c86$var$N ? b.memoizedState = a : $9b5c2f7437668c86$var$ui(b, $9b5c2f7437668c86$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $9b5c2f7437668c86$var$Xh($9b5c2f7437668c86$var$Vh)[0], b = $9b5c2f7437668c86$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9b5c2f7437668c86$var$Yh,
    useSyncExternalStore: $9b5c2f7437668c86$var$Zh,
    useId: $9b5c2f7437668c86$var$wi,
    unstable_isNewReconciler: !1
};
function $9b5c2f7437668c86$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $9b5c2f7437668c86$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $9b5c2f7437668c86$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9b5c2f7437668c86$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $9b5c2f7437668c86$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $9b5c2f7437668c86$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9b5c2f7437668c86$var$R(), e = $9b5c2f7437668c86$var$yi(a), f = $9b5c2f7437668c86$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9b5c2f7437668c86$var$nh(a, f, e);
        null !== b && ($9b5c2f7437668c86$var$gi(b, a, e, d), $9b5c2f7437668c86$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9b5c2f7437668c86$var$R(), e = $9b5c2f7437668c86$var$yi(a), f = $9b5c2f7437668c86$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9b5c2f7437668c86$var$nh(a, f, e);
        null !== b && ($9b5c2f7437668c86$var$gi(b, a, e, d), $9b5c2f7437668c86$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $9b5c2f7437668c86$var$R(), d = $9b5c2f7437668c86$var$yi(a), e = $9b5c2f7437668c86$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $9b5c2f7437668c86$var$nh(a, e, d);
        null !== b && ($9b5c2f7437668c86$var$gi(b, a, d, c), $9b5c2f7437668c86$var$oh(b, a, d));
    }
};
function $9b5c2f7437668c86$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$9b5c2f7437668c86$var$Ie(c, d) || !$9b5c2f7437668c86$var$Ie(e, f) : !0;
}
function $9b5c2f7437668c86$var$Gi(a, b, c) {
    var d = !1, e = $9b5c2f7437668c86$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $9b5c2f7437668c86$var$eh(f) : (e = $9b5c2f7437668c86$var$Zf(b) ? $9b5c2f7437668c86$var$Xf : $9b5c2f7437668c86$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $9b5c2f7437668c86$var$Yf(a, e) : $9b5c2f7437668c86$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $9b5c2f7437668c86$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $9b5c2f7437668c86$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $9b5c2f7437668c86$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $9b5c2f7437668c86$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $9b5c2f7437668c86$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $9b5c2f7437668c86$var$eh(f) : (f = $9b5c2f7437668c86$var$Zf(b) ? $9b5c2f7437668c86$var$Xf : $9b5c2f7437668c86$var$H.current, e.context = $9b5c2f7437668c86$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($9b5c2f7437668c86$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $9b5c2f7437668c86$var$Ei.enqueueReplaceState(e, e.state, null), $9b5c2f7437668c86$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $9b5c2f7437668c86$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $9b5c2f7437668c86$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $9b5c2f7437668c86$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $9b5c2f7437668c86$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $9b5c2f7437668c86$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $9b5c2f7437668c86$var$Ni(a, b, c) {
    c = $9b5c2f7437668c86$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $9b5c2f7437668c86$var$Oi || ($9b5c2f7437668c86$var$Oi = !0, $9b5c2f7437668c86$var$Pi = d);
        $9b5c2f7437668c86$var$Li(a, b);
    };
    return c;
}
function $9b5c2f7437668c86$var$Qi(a, b, c) {
    c = $9b5c2f7437668c86$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $9b5c2f7437668c86$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $9b5c2f7437668c86$var$Li(a, b);
        "function" !== typeof d && (null === $9b5c2f7437668c86$var$Ri ? $9b5c2f7437668c86$var$Ri = new Set([
            this
        ]) : $9b5c2f7437668c86$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $9b5c2f7437668c86$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $9b5c2f7437668c86$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $9b5c2f7437668c86$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $9b5c2f7437668c86$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $9b5c2f7437668c86$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $9b5c2f7437668c86$var$mh(-1, 1), b.tag = 2, $9b5c2f7437668c86$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $9b5c2f7437668c86$var$Wi = $9b5c2f7437668c86$var$ua.ReactCurrentOwner, $9b5c2f7437668c86$var$dh = !1;
function $9b5c2f7437668c86$var$Xi(a, b, c, d) {
    b.child = null === a ? $9b5c2f7437668c86$var$Vg(b, null, c, d) : $9b5c2f7437668c86$var$Ug(b, a.child, c, d);
}
function $9b5c2f7437668c86$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $9b5c2f7437668c86$var$ch(b, e);
    d = $9b5c2f7437668c86$var$Nh(a, b, c, d, f, e);
    c = $9b5c2f7437668c86$var$Sh();
    if (null !== a && !$9b5c2f7437668c86$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9b5c2f7437668c86$var$Zi(a, b, e);
    $9b5c2f7437668c86$var$I && c && $9b5c2f7437668c86$var$vg(b);
    b.flags |= 1;
    $9b5c2f7437668c86$var$Xi(a, b, d, e);
    return b.child;
}
function $9b5c2f7437668c86$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$9b5c2f7437668c86$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $9b5c2f7437668c86$var$bj(a, b, f, d, e);
        a = $9b5c2f7437668c86$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $9b5c2f7437668c86$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $9b5c2f7437668c86$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $9b5c2f7437668c86$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $9b5c2f7437668c86$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($9b5c2f7437668c86$var$Ie(f, d) && a.ref === b.ref) {
            if ($9b5c2f7437668c86$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($9b5c2f7437668c86$var$dh = !0);
            else return b.lanes = a.lanes, $9b5c2f7437668c86$var$Zi(a, b, e);
        }
    }
    return $9b5c2f7437668c86$var$cj(a, b, c, d, e);
}
function $9b5c2f7437668c86$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$ej, $9b5c2f7437668c86$var$fj), $9b5c2f7437668c86$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$ej, $9b5c2f7437668c86$var$fj), $9b5c2f7437668c86$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$ej, $9b5c2f7437668c86$var$fj);
            $9b5c2f7437668c86$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$ej, $9b5c2f7437668c86$var$fj), $9b5c2f7437668c86$var$fj |= d;
    $9b5c2f7437668c86$var$Xi(a, b, e, c);
    return b.child;
}
function $9b5c2f7437668c86$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $9b5c2f7437668c86$var$cj(a, b, c, d, e) {
    var f = $9b5c2f7437668c86$var$Zf(c) ? $9b5c2f7437668c86$var$Xf : $9b5c2f7437668c86$var$H.current;
    f = $9b5c2f7437668c86$var$Yf(b, f);
    $9b5c2f7437668c86$var$ch(b, e);
    c = $9b5c2f7437668c86$var$Nh(a, b, c, d, f, e);
    d = $9b5c2f7437668c86$var$Sh();
    if (null !== a && !$9b5c2f7437668c86$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9b5c2f7437668c86$var$Zi(a, b, e);
    $9b5c2f7437668c86$var$I && d && $9b5c2f7437668c86$var$vg(b);
    b.flags |= 1;
    $9b5c2f7437668c86$var$Xi(a, b, c, e);
    return b.child;
}
function $9b5c2f7437668c86$var$hj(a, b, c, d, e) {
    if ($9b5c2f7437668c86$var$Zf(c)) {
        var f = !0;
        $9b5c2f7437668c86$var$cg(b);
    } else f = !1;
    $9b5c2f7437668c86$var$ch(b, e);
    if (null === b.stateNode) $9b5c2f7437668c86$var$ij(a, b), $9b5c2f7437668c86$var$Gi(b, c, d), $9b5c2f7437668c86$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $9b5c2f7437668c86$var$eh(l) : (l = $9b5c2f7437668c86$var$Zf(c) ? $9b5c2f7437668c86$var$Xf : $9b5c2f7437668c86$var$H.current, l = $9b5c2f7437668c86$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $9b5c2f7437668c86$var$Hi(b, g, d, l);
        $9b5c2f7437668c86$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $9b5c2f7437668c86$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $9b5c2f7437668c86$var$Wf.current || $9b5c2f7437668c86$var$jh ? ("function" === typeof m && ($9b5c2f7437668c86$var$Di(b, c, m, d), k = b.memoizedState), (h = $9b5c2f7437668c86$var$jh || $9b5c2f7437668c86$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $9b5c2f7437668c86$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $9b5c2f7437668c86$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $9b5c2f7437668c86$var$eh(k) : (k = $9b5c2f7437668c86$var$Zf(c) ? $9b5c2f7437668c86$var$Xf : $9b5c2f7437668c86$var$H.current, k = $9b5c2f7437668c86$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $9b5c2f7437668c86$var$Hi(b, g, d, k);
        $9b5c2f7437668c86$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $9b5c2f7437668c86$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $9b5c2f7437668c86$var$Wf.current || $9b5c2f7437668c86$var$jh ? ("function" === typeof y && ($9b5c2f7437668c86$var$Di(b, c, y, d), n = b.memoizedState), (l = $9b5c2f7437668c86$var$jh || $9b5c2f7437668c86$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $9b5c2f7437668c86$var$jj(a, b, c, d, f, e);
}
function $9b5c2f7437668c86$var$jj(a, b, c, d, e, f) {
    $9b5c2f7437668c86$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $9b5c2f7437668c86$var$dg(b, c, !1), $9b5c2f7437668c86$var$Zi(a, b, f);
    d = b.stateNode;
    $9b5c2f7437668c86$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $9b5c2f7437668c86$var$Ug(b, a.child, null, f), b.child = $9b5c2f7437668c86$var$Ug(b, null, h, f)) : $9b5c2f7437668c86$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $9b5c2f7437668c86$var$dg(b, c, !0);
    return b.child;
}
function $9b5c2f7437668c86$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $9b5c2f7437668c86$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $9b5c2f7437668c86$var$ag(a, b.context, !1);
    $9b5c2f7437668c86$var$yh(a, b.containerInfo);
}
function $9b5c2f7437668c86$var$lj(a, b, c, d, e) {
    $9b5c2f7437668c86$var$Ig();
    $9b5c2f7437668c86$var$Jg(e);
    b.flags |= 256;
    $9b5c2f7437668c86$var$Xi(a, b, c, d);
    return b.child;
}
var $9b5c2f7437668c86$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $9b5c2f7437668c86$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $9b5c2f7437668c86$var$oj(a, b, c) {
    var d = b.pendingProps, e = $9b5c2f7437668c86$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$L, e & 1);
    if (null === a) {
        $9b5c2f7437668c86$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $9b5c2f7437668c86$var$pj(g, d, 0, null), a = $9b5c2f7437668c86$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $9b5c2f7437668c86$var$nj(c), b.memoizedState = $9b5c2f7437668c86$var$mj, a) : $9b5c2f7437668c86$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $9b5c2f7437668c86$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $9b5c2f7437668c86$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $9b5c2f7437668c86$var$Pg(h, f) : (f = $9b5c2f7437668c86$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $9b5c2f7437668c86$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $9b5c2f7437668c86$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $9b5c2f7437668c86$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $9b5c2f7437668c86$var$qj(a, b) {
    b = $9b5c2f7437668c86$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $9b5c2f7437668c86$var$sj(a, b, c, d) {
    null !== d && $9b5c2f7437668c86$var$Jg(d);
    $9b5c2f7437668c86$var$Ug(b, a.child, null, c);
    a = $9b5c2f7437668c86$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $9b5c2f7437668c86$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $9b5c2f7437668c86$var$Ki(Error($9b5c2f7437668c86$var$p(422))), $9b5c2f7437668c86$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $9b5c2f7437668c86$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $9b5c2f7437668c86$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $9b5c2f7437668c86$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $9b5c2f7437668c86$var$nj(g);
        b.memoizedState = $9b5c2f7437668c86$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $9b5c2f7437668c86$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($9b5c2f7437668c86$var$p(419));
        d = $9b5c2f7437668c86$var$Ki(f, d, void 0);
        return $9b5c2f7437668c86$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($9b5c2f7437668c86$var$dh || h) {
        d = $9b5c2f7437668c86$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $9b5c2f7437668c86$var$ih(a, e), $9b5c2f7437668c86$var$gi(d, a, e, -1));
        }
        $9b5c2f7437668c86$var$tj();
        d = $9b5c2f7437668c86$var$Ki(Error($9b5c2f7437668c86$var$p(421)));
        return $9b5c2f7437668c86$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $9b5c2f7437668c86$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $9b5c2f7437668c86$var$yg = $9b5c2f7437668c86$var$Lf(e.nextSibling);
    $9b5c2f7437668c86$var$xg = b;
    $9b5c2f7437668c86$var$I = !0;
    $9b5c2f7437668c86$var$zg = null;
    null !== a && ($9b5c2f7437668c86$var$og[$9b5c2f7437668c86$var$pg++] = $9b5c2f7437668c86$var$rg, $9b5c2f7437668c86$var$og[$9b5c2f7437668c86$var$pg++] = $9b5c2f7437668c86$var$sg, $9b5c2f7437668c86$var$og[$9b5c2f7437668c86$var$pg++] = $9b5c2f7437668c86$var$qg, $9b5c2f7437668c86$var$rg = a.id, $9b5c2f7437668c86$var$sg = a.overflow, $9b5c2f7437668c86$var$qg = b);
    b = $9b5c2f7437668c86$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $9b5c2f7437668c86$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $9b5c2f7437668c86$var$bh(a.return, b, c);
}
function $9b5c2f7437668c86$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $9b5c2f7437668c86$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $9b5c2f7437668c86$var$Xi(a, b, d.children, c);
    d = $9b5c2f7437668c86$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $9b5c2f7437668c86$var$vj(a, c, b);
            else if (19 === a.tag) $9b5c2f7437668c86$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $9b5c2f7437668c86$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $9b5c2f7437668c86$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $9b5c2f7437668c86$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $9b5c2f7437668c86$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $9b5c2f7437668c86$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $9b5c2f7437668c86$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $9b5c2f7437668c86$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $9b5c2f7437668c86$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($9b5c2f7437668c86$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $9b5c2f7437668c86$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $9b5c2f7437668c86$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $9b5c2f7437668c86$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $9b5c2f7437668c86$var$kj(b);
            $9b5c2f7437668c86$var$Ig();
            break;
        case 5:
            $9b5c2f7437668c86$var$Ah(b);
            break;
        case 1:
            $9b5c2f7437668c86$var$Zf(b.type) && $9b5c2f7437668c86$var$cg(b);
            break;
        case 4:
            $9b5c2f7437668c86$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$L, $9b5c2f7437668c86$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $9b5c2f7437668c86$var$oj(a, b, c);
                $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$L, $9b5c2f7437668c86$var$L.current & 1);
                a = $9b5c2f7437668c86$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$L, $9b5c2f7437668c86$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $9b5c2f7437668c86$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$L, $9b5c2f7437668c86$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $9b5c2f7437668c86$var$dj(a, b, c);
    }
    return $9b5c2f7437668c86$var$Zi(a, b, c);
}
var $9b5c2f7437668c86$var$zj, $9b5c2f7437668c86$var$Aj, $9b5c2f7437668c86$var$Bj, $9b5c2f7437668c86$var$Cj;
$9b5c2f7437668c86$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$9b5c2f7437668c86$var$Aj = function() {};
$9b5c2f7437668c86$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $9b5c2f7437668c86$var$xh($9b5c2f7437668c86$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $9b5c2f7437668c86$var$Ya(a, e);
                d = $9b5c2f7437668c86$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $9b5c2f7437668c86$var$A({}, e, {
                    value: void 0
                });
                d = $9b5c2f7437668c86$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $9b5c2f7437668c86$var$gb(a, e);
                d = $9b5c2f7437668c86$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $9b5c2f7437668c86$var$Bf);
        }
        $9b5c2f7437668c86$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($9b5c2f7437668c86$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($9b5c2f7437668c86$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $9b5c2f7437668c86$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$9b5c2f7437668c86$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $9b5c2f7437668c86$var$Dj(a, b) {
    if (!$9b5c2f7437668c86$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $9b5c2f7437668c86$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $9b5c2f7437668c86$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $9b5c2f7437668c86$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $9b5c2f7437668c86$var$S(b), null;
        case 1:
            return $9b5c2f7437668c86$var$Zf(b.type) && $9b5c2f7437668c86$var$$f(), $9b5c2f7437668c86$var$S(b), null;
        case 3:
            d = b.stateNode;
            $9b5c2f7437668c86$var$zh();
            $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$Wf);
            $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$H);
            $9b5c2f7437668c86$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $9b5c2f7437668c86$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $9b5c2f7437668c86$var$zg && ($9b5c2f7437668c86$var$Fj($9b5c2f7437668c86$var$zg), $9b5c2f7437668c86$var$zg = null));
            $9b5c2f7437668c86$var$Aj(a, b);
            $9b5c2f7437668c86$var$S(b);
            return null;
        case 5:
            $9b5c2f7437668c86$var$Bh(b);
            var e = $9b5c2f7437668c86$var$xh($9b5c2f7437668c86$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $9b5c2f7437668c86$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($9b5c2f7437668c86$var$p(166));
                    $9b5c2f7437668c86$var$S(b);
                    return null;
                }
                a = $9b5c2f7437668c86$var$xh($9b5c2f7437668c86$var$uh.current);
                if ($9b5c2f7437668c86$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$9b5c2f7437668c86$var$Of] = b;
                    d[$9b5c2f7437668c86$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $9b5c2f7437668c86$var$D("cancel", d);
                            $9b5c2f7437668c86$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $9b5c2f7437668c86$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $9b5c2f7437668c86$var$lf.length; e++)$9b5c2f7437668c86$var$D($9b5c2f7437668c86$var$lf[e], d);
                            break;
                        case "source":
                            $9b5c2f7437668c86$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $9b5c2f7437668c86$var$D("error", d);
                            $9b5c2f7437668c86$var$D("load", d);
                            break;
                        case "details":
                            $9b5c2f7437668c86$var$D("toggle", d);
                            break;
                        case "input":
                            $9b5c2f7437668c86$var$Za(d, f);
                            $9b5c2f7437668c86$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $9b5c2f7437668c86$var$D("invalid", d);
                            break;
                        case "textarea":
                            $9b5c2f7437668c86$var$hb(d, f), $9b5c2f7437668c86$var$D("invalid", d);
                    }
                    $9b5c2f7437668c86$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $9b5c2f7437668c86$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $9b5c2f7437668c86$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $9b5c2f7437668c86$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $9b5c2f7437668c86$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $9b5c2f7437668c86$var$Va(d);
                            $9b5c2f7437668c86$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $9b5c2f7437668c86$var$Va(d);
                            $9b5c2f7437668c86$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $9b5c2f7437668c86$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $9b5c2f7437668c86$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$9b5c2f7437668c86$var$Of] = b;
                    a[$9b5c2f7437668c86$var$Pf] = d;
                    $9b5c2f7437668c86$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $9b5c2f7437668c86$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $9b5c2f7437668c86$var$D("cancel", a);
                                $9b5c2f7437668c86$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $9b5c2f7437668c86$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $9b5c2f7437668c86$var$lf.length; e++)$9b5c2f7437668c86$var$D($9b5c2f7437668c86$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $9b5c2f7437668c86$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $9b5c2f7437668c86$var$D("error", a);
                                $9b5c2f7437668c86$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $9b5c2f7437668c86$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $9b5c2f7437668c86$var$Za(a, d);
                                e = $9b5c2f7437668c86$var$Ya(a, d);
                                $9b5c2f7437668c86$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $9b5c2f7437668c86$var$A({}, d, {
                                    value: void 0
                                });
                                $9b5c2f7437668c86$var$D("invalid", a);
                                break;
                            case "textarea":
                                $9b5c2f7437668c86$var$hb(a, d);
                                e = $9b5c2f7437668c86$var$gb(a, d);
                                $9b5c2f7437668c86$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $9b5c2f7437668c86$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $9b5c2f7437668c86$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $9b5c2f7437668c86$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $9b5c2f7437668c86$var$ob(a, k) : "number" === typeof k && $9b5c2f7437668c86$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($9b5c2f7437668c86$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $9b5c2f7437668c86$var$D("scroll", a) : null != k && $9b5c2f7437668c86$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $9b5c2f7437668c86$var$Va(a);
                                $9b5c2f7437668c86$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $9b5c2f7437668c86$var$Va(a);
                                $9b5c2f7437668c86$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $9b5c2f7437668c86$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $9b5c2f7437668c86$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $9b5c2f7437668c86$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $9b5c2f7437668c86$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $9b5c2f7437668c86$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $9b5c2f7437668c86$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($9b5c2f7437668c86$var$p(166));
                c = $9b5c2f7437668c86$var$xh($9b5c2f7437668c86$var$wh.current);
                $9b5c2f7437668c86$var$xh($9b5c2f7437668c86$var$uh.current);
                if ($9b5c2f7437668c86$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$9b5c2f7437668c86$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $9b5c2f7437668c86$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $9b5c2f7437668c86$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $9b5c2f7437668c86$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$9b5c2f7437668c86$var$Of] = b, b.stateNode = d;
            }
            $9b5c2f7437668c86$var$S(b);
            return null;
        case 13:
            $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($9b5c2f7437668c86$var$I && null !== $9b5c2f7437668c86$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $9b5c2f7437668c86$var$Hg(), $9b5c2f7437668c86$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $9b5c2f7437668c86$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($9b5c2f7437668c86$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($9b5c2f7437668c86$var$p(317));
                        f[$9b5c2f7437668c86$var$Of] = b;
                    } else $9b5c2f7437668c86$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $9b5c2f7437668c86$var$S(b);
                    f = !1;
                } else null !== $9b5c2f7437668c86$var$zg && ($9b5c2f7437668c86$var$Fj($9b5c2f7437668c86$var$zg), $9b5c2f7437668c86$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($9b5c2f7437668c86$var$L.current & 1) ? 0 === $9b5c2f7437668c86$var$T && ($9b5c2f7437668c86$var$T = 3) : $9b5c2f7437668c86$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $9b5c2f7437668c86$var$S(b);
            return null;
        case 4:
            return $9b5c2f7437668c86$var$zh(), $9b5c2f7437668c86$var$Aj(a, b), null === a && $9b5c2f7437668c86$var$sf(b.stateNode.containerInfo), $9b5c2f7437668c86$var$S(b), null;
        case 10:
            return $9b5c2f7437668c86$var$ah(b.type._context), $9b5c2f7437668c86$var$S(b), null;
        case 17:
            return $9b5c2f7437668c86$var$Zf(b.type) && $9b5c2f7437668c86$var$$f(), $9b5c2f7437668c86$var$S(b), null;
        case 19:
            $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$L);
            f = b.memoizedState;
            if (null === f) return $9b5c2f7437668c86$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $9b5c2f7437668c86$var$Dj(f, !1);
                else {
                    if (0 !== $9b5c2f7437668c86$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $9b5c2f7437668c86$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $9b5c2f7437668c86$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$L, $9b5c2f7437668c86$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $9b5c2f7437668c86$var$B() > $9b5c2f7437668c86$var$Gj && (b.flags |= 128, d = !0, $9b5c2f7437668c86$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $9b5c2f7437668c86$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $9b5c2f7437668c86$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$9b5c2f7437668c86$var$I) return $9b5c2f7437668c86$var$S(b), null;
                    } else 2 * $9b5c2f7437668c86$var$B() - f.renderingStartTime > $9b5c2f7437668c86$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $9b5c2f7437668c86$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $9b5c2f7437668c86$var$B(), b.sibling = null, c = $9b5c2f7437668c86$var$L.current, $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$L, d ? c & 1 | 2 : c & 1), b;
            $9b5c2f7437668c86$var$S(b);
            return null;
        case 22:
        case 23:
            return $9b5c2f7437668c86$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($9b5c2f7437668c86$var$fj & 1073741824) && ($9b5c2f7437668c86$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $9b5c2f7437668c86$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($9b5c2f7437668c86$var$p(156, b.tag));
}
function $9b5c2f7437668c86$var$Ij(a, b) {
    $9b5c2f7437668c86$var$wg(b);
    switch(b.tag){
        case 1:
            return $9b5c2f7437668c86$var$Zf(b.type) && $9b5c2f7437668c86$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $9b5c2f7437668c86$var$zh(), $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$Wf), $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$H), $9b5c2f7437668c86$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $9b5c2f7437668c86$var$Bh(b), null;
        case 13:
            $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($9b5c2f7437668c86$var$p(340));
                $9b5c2f7437668c86$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$L), null;
        case 4:
            return $9b5c2f7437668c86$var$zh(), null;
        case 10:
            return $9b5c2f7437668c86$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $9b5c2f7437668c86$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $9b5c2f7437668c86$var$Jj = !1, $9b5c2f7437668c86$var$U = !1, $9b5c2f7437668c86$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $9b5c2f7437668c86$var$V = null;
function $9b5c2f7437668c86$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $9b5c2f7437668c86$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $9b5c2f7437668c86$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $9b5c2f7437668c86$var$W(a, b, d);
    }
}
var $9b5c2f7437668c86$var$Nj = !1;
function $9b5c2f7437668c86$var$Oj(a, b) {
    $9b5c2f7437668c86$var$Cf = $9b5c2f7437668c86$var$dd;
    a = $9b5c2f7437668c86$var$Me();
    if ($9b5c2f7437668c86$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $9b5c2f7437668c86$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $9b5c2f7437668c86$var$dd = !1;
    for($9b5c2f7437668c86$var$V = b; null !== $9b5c2f7437668c86$var$V;)if (b = $9b5c2f7437668c86$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $9b5c2f7437668c86$var$V = a;
    else for(; null !== $9b5c2f7437668c86$var$V;){
        b = $9b5c2f7437668c86$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $9b5c2f7437668c86$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($9b5c2f7437668c86$var$p(163));
            }
        } catch (F) {
            $9b5c2f7437668c86$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $9b5c2f7437668c86$var$V = a;
            break;
        }
        $9b5c2f7437668c86$var$V = b.return;
    }
    n = $9b5c2f7437668c86$var$Nj;
    $9b5c2f7437668c86$var$Nj = !1;
    return n;
}
function $9b5c2f7437668c86$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $9b5c2f7437668c86$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $9b5c2f7437668c86$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $9b5c2f7437668c86$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $9b5c2f7437668c86$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $9b5c2f7437668c86$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$9b5c2f7437668c86$var$Of], delete b[$9b5c2f7437668c86$var$Pf], delete b[$9b5c2f7437668c86$var$of], delete b[$9b5c2f7437668c86$var$Qf], delete b[$9b5c2f7437668c86$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $9b5c2f7437668c86$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $9b5c2f7437668c86$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $9b5c2f7437668c86$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $9b5c2f7437668c86$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $9b5c2f7437668c86$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($9b5c2f7437668c86$var$Vj(a, b, c), a = a.sibling; null !== a;)$9b5c2f7437668c86$var$Vj(a, b, c), a = a.sibling;
}
function $9b5c2f7437668c86$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($9b5c2f7437668c86$var$Wj(a, b, c), a = a.sibling; null !== a;)$9b5c2f7437668c86$var$Wj(a, b, c), a = a.sibling;
}
var $9b5c2f7437668c86$var$X = null, $9b5c2f7437668c86$var$Xj = !1;
function $9b5c2f7437668c86$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$9b5c2f7437668c86$var$Zj(a, b, c), c = c.sibling;
}
function $9b5c2f7437668c86$var$Zj(a, b, c) {
    if ($9b5c2f7437668c86$var$lc && "function" === typeof $9b5c2f7437668c86$var$lc.onCommitFiberUnmount) try {
        $9b5c2f7437668c86$var$lc.onCommitFiberUnmount($9b5c2f7437668c86$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $9b5c2f7437668c86$var$U || $9b5c2f7437668c86$var$Lj(c, b);
        case 6:
            var d = $9b5c2f7437668c86$var$X, e = $9b5c2f7437668c86$var$Xj;
            $9b5c2f7437668c86$var$X = null;
            $9b5c2f7437668c86$var$Yj(a, b, c);
            $9b5c2f7437668c86$var$X = d;
            $9b5c2f7437668c86$var$Xj = e;
            null !== $9b5c2f7437668c86$var$X && ($9b5c2f7437668c86$var$Xj ? (a = $9b5c2f7437668c86$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $9b5c2f7437668c86$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $9b5c2f7437668c86$var$X && ($9b5c2f7437668c86$var$Xj ? (a = $9b5c2f7437668c86$var$X, c = c.stateNode, 8 === a.nodeType ? $9b5c2f7437668c86$var$Kf(a.parentNode, c) : 1 === a.nodeType && $9b5c2f7437668c86$var$Kf(a, c), $9b5c2f7437668c86$var$bd(a)) : $9b5c2f7437668c86$var$Kf($9b5c2f7437668c86$var$X, c.stateNode));
            break;
        case 4:
            d = $9b5c2f7437668c86$var$X;
            e = $9b5c2f7437668c86$var$Xj;
            $9b5c2f7437668c86$var$X = c.stateNode.containerInfo;
            $9b5c2f7437668c86$var$Xj = !0;
            $9b5c2f7437668c86$var$Yj(a, b, c);
            $9b5c2f7437668c86$var$X = d;
            $9b5c2f7437668c86$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$9b5c2f7437668c86$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $9b5c2f7437668c86$var$Mj(c, b, g) : 0 !== (f & 4) && $9b5c2f7437668c86$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $9b5c2f7437668c86$var$Yj(a, b, c);
            break;
        case 1:
            if (!$9b5c2f7437668c86$var$U && ($9b5c2f7437668c86$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $9b5c2f7437668c86$var$W(c, b, h);
            }
            $9b5c2f7437668c86$var$Yj(a, b, c);
            break;
        case 21:
            $9b5c2f7437668c86$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($9b5c2f7437668c86$var$U = (d = $9b5c2f7437668c86$var$U) || null !== c.memoizedState, $9b5c2f7437668c86$var$Yj(a, b, c), $9b5c2f7437668c86$var$U = d) : $9b5c2f7437668c86$var$Yj(a, b, c);
            break;
        default:
            $9b5c2f7437668c86$var$Yj(a, b, c);
    }
}
function $9b5c2f7437668c86$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $9b5c2f7437668c86$var$Kj);
        b.forEach(function(b) {
            var d = $9b5c2f7437668c86$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $9b5c2f7437668c86$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $9b5c2f7437668c86$var$X = h.stateNode;
                        $9b5c2f7437668c86$var$Xj = !1;
                        break a;
                    case 3:
                        $9b5c2f7437668c86$var$X = h.stateNode.containerInfo;
                        $9b5c2f7437668c86$var$Xj = !0;
                        break a;
                    case 4:
                        $9b5c2f7437668c86$var$X = h.stateNode.containerInfo;
                        $9b5c2f7437668c86$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $9b5c2f7437668c86$var$X) throw Error($9b5c2f7437668c86$var$p(160));
            $9b5c2f7437668c86$var$Zj(f, g, e);
            $9b5c2f7437668c86$var$X = null;
            $9b5c2f7437668c86$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $9b5c2f7437668c86$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$9b5c2f7437668c86$var$dk(b, a), b = b.sibling;
}
function $9b5c2f7437668c86$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $9b5c2f7437668c86$var$ck(b, a);
            $9b5c2f7437668c86$var$ek(a);
            if (d & 4) {
                try {
                    $9b5c2f7437668c86$var$Pj(3, a, a.return), $9b5c2f7437668c86$var$Qj(3, a);
                } catch (t) {
                    $9b5c2f7437668c86$var$W(a, a.return, t);
                }
                try {
                    $9b5c2f7437668c86$var$Pj(5, a, a.return);
                } catch (t) {
                    $9b5c2f7437668c86$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $9b5c2f7437668c86$var$ck(b, a);
            $9b5c2f7437668c86$var$ek(a);
            d & 512 && null !== c && $9b5c2f7437668c86$var$Lj(c, c.return);
            break;
        case 5:
            $9b5c2f7437668c86$var$ck(b, a);
            $9b5c2f7437668c86$var$ek(a);
            d & 512 && null !== c && $9b5c2f7437668c86$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $9b5c2f7437668c86$var$ob(e, "");
                } catch (t) {
                    $9b5c2f7437668c86$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $9b5c2f7437668c86$var$ab(e, f);
                    $9b5c2f7437668c86$var$vb(h, g);
                    var l = $9b5c2f7437668c86$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $9b5c2f7437668c86$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $9b5c2f7437668c86$var$nb(e, q) : "children" === m ? $9b5c2f7437668c86$var$ob(e, q) : $9b5c2f7437668c86$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $9b5c2f7437668c86$var$bb(e, f);
                            break;
                        case "textarea":
                            $9b5c2f7437668c86$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $9b5c2f7437668c86$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $9b5c2f7437668c86$var$fb(e, !!f.multiple, f.defaultValue, !0) : $9b5c2f7437668c86$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$9b5c2f7437668c86$var$Pf] = f;
                } catch (t) {
                    $9b5c2f7437668c86$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $9b5c2f7437668c86$var$ck(b, a);
            $9b5c2f7437668c86$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($9b5c2f7437668c86$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $9b5c2f7437668c86$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $9b5c2f7437668c86$var$ck(b, a);
            $9b5c2f7437668c86$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $9b5c2f7437668c86$var$bd(b.containerInfo);
            } catch (t) {
                $9b5c2f7437668c86$var$W(a, a.return, t);
            }
            break;
        case 4:
            $9b5c2f7437668c86$var$ck(b, a);
            $9b5c2f7437668c86$var$ek(a);
            break;
        case 13:
            $9b5c2f7437668c86$var$ck(b, a);
            $9b5c2f7437668c86$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($9b5c2f7437668c86$var$fk = $9b5c2f7437668c86$var$B()));
            d & 4 && $9b5c2f7437668c86$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($9b5c2f7437668c86$var$U = (l = $9b5c2f7437668c86$var$U) || m, $9b5c2f7437668c86$var$ck(b, a), $9b5c2f7437668c86$var$U = l) : $9b5c2f7437668c86$var$ck(b, a);
            $9b5c2f7437668c86$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($9b5c2f7437668c86$var$V = a, m = a.child; null !== m;){
                    for(q = $9b5c2f7437668c86$var$V = m; null !== $9b5c2f7437668c86$var$V;){
                        r = $9b5c2f7437668c86$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $9b5c2f7437668c86$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $9b5c2f7437668c86$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $9b5c2f7437668c86$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $9b5c2f7437668c86$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $9b5c2f7437668c86$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $9b5c2f7437668c86$var$V = y) : $9b5c2f7437668c86$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $9b5c2f7437668c86$var$rb("display", g));
                            } catch (t) {
                                $9b5c2f7437668c86$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $9b5c2f7437668c86$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $9b5c2f7437668c86$var$ck(b, a);
            $9b5c2f7437668c86$var$ek(a);
            d & 4 && $9b5c2f7437668c86$var$ak(a);
            break;
        case 21:
            break;
        default:
            $9b5c2f7437668c86$var$ck(b, a), $9b5c2f7437668c86$var$ek(a);
    }
}
function $9b5c2f7437668c86$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($9b5c2f7437668c86$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($9b5c2f7437668c86$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($9b5c2f7437668c86$var$ob(e, ""), d.flags &= -33);
                    var f = $9b5c2f7437668c86$var$Uj(a);
                    $9b5c2f7437668c86$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $9b5c2f7437668c86$var$Uj(a);
                    $9b5c2f7437668c86$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($9b5c2f7437668c86$var$p(161));
            }
        } catch (k) {
            $9b5c2f7437668c86$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $9b5c2f7437668c86$var$hk(a, b, c) {
    $9b5c2f7437668c86$var$V = a;
    $9b5c2f7437668c86$var$ik(a, b, c);
}
function $9b5c2f7437668c86$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $9b5c2f7437668c86$var$V;){
        var e = $9b5c2f7437668c86$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $9b5c2f7437668c86$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $9b5c2f7437668c86$var$U;
                h = $9b5c2f7437668c86$var$Jj;
                var l = $9b5c2f7437668c86$var$U;
                $9b5c2f7437668c86$var$Jj = g;
                if (($9b5c2f7437668c86$var$U = k) && !l) for($9b5c2f7437668c86$var$V = e; null !== $9b5c2f7437668c86$var$V;)g = $9b5c2f7437668c86$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $9b5c2f7437668c86$var$jk(e) : null !== k ? (k.return = g, $9b5c2f7437668c86$var$V = k) : $9b5c2f7437668c86$var$jk(e);
                for(; null !== f;)$9b5c2f7437668c86$var$V = f, $9b5c2f7437668c86$var$ik(f, b, c), f = f.sibling;
                $9b5c2f7437668c86$var$V = e;
                $9b5c2f7437668c86$var$Jj = h;
                $9b5c2f7437668c86$var$U = l;
            }
            $9b5c2f7437668c86$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $9b5c2f7437668c86$var$V = f) : $9b5c2f7437668c86$var$kk(a, b, c);
    }
}
function $9b5c2f7437668c86$var$kk(a) {
    for(; null !== $9b5c2f7437668c86$var$V;){
        var b = $9b5c2f7437668c86$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $9b5c2f7437668c86$var$U || $9b5c2f7437668c86$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$9b5c2f7437668c86$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $9b5c2f7437668c86$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $9b5c2f7437668c86$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $9b5c2f7437668c86$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $9b5c2f7437668c86$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($9b5c2f7437668c86$var$p(163));
                }
                $9b5c2f7437668c86$var$U || b.flags & 512 && $9b5c2f7437668c86$var$Rj(b);
            } catch (r) {
                $9b5c2f7437668c86$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $9b5c2f7437668c86$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9b5c2f7437668c86$var$V = c;
            break;
        }
        $9b5c2f7437668c86$var$V = b.return;
    }
}
function $9b5c2f7437668c86$var$gk(a) {
    for(; null !== $9b5c2f7437668c86$var$V;){
        var b = $9b5c2f7437668c86$var$V;
        if (b === a) {
            $9b5c2f7437668c86$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9b5c2f7437668c86$var$V = c;
            break;
        }
        $9b5c2f7437668c86$var$V = b.return;
    }
}
function $9b5c2f7437668c86$var$jk(a) {
    for(; null !== $9b5c2f7437668c86$var$V;){
        var b = $9b5c2f7437668c86$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $9b5c2f7437668c86$var$Qj(4, b);
                    } catch (k) {
                        $9b5c2f7437668c86$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $9b5c2f7437668c86$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $9b5c2f7437668c86$var$Rj(b);
                    } catch (k) {
                        $9b5c2f7437668c86$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $9b5c2f7437668c86$var$Rj(b);
                    } catch (k) {
                        $9b5c2f7437668c86$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $9b5c2f7437668c86$var$W(b, b.return, k);
        }
        if (b === a) {
            $9b5c2f7437668c86$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $9b5c2f7437668c86$var$V = h;
            break;
        }
        $9b5c2f7437668c86$var$V = b.return;
    }
}
var $9b5c2f7437668c86$var$lk = Math.ceil, $9b5c2f7437668c86$var$mk = $9b5c2f7437668c86$var$ua.ReactCurrentDispatcher, $9b5c2f7437668c86$var$nk = $9b5c2f7437668c86$var$ua.ReactCurrentOwner, $9b5c2f7437668c86$var$ok = $9b5c2f7437668c86$var$ua.ReactCurrentBatchConfig, $9b5c2f7437668c86$var$K = 0, $9b5c2f7437668c86$var$Q = null, $9b5c2f7437668c86$var$Y = null, $9b5c2f7437668c86$var$Z = 0, $9b5c2f7437668c86$var$fj = 0, $9b5c2f7437668c86$var$ej = $9b5c2f7437668c86$var$Uf(0), $9b5c2f7437668c86$var$T = 0, $9b5c2f7437668c86$var$pk = null, $9b5c2f7437668c86$var$rh = 0, $9b5c2f7437668c86$var$qk = 0, $9b5c2f7437668c86$var$rk = 0, $9b5c2f7437668c86$var$sk = null, $9b5c2f7437668c86$var$tk = null, $9b5c2f7437668c86$var$fk = 0, $9b5c2f7437668c86$var$Gj = Infinity, $9b5c2f7437668c86$var$uk = null, $9b5c2f7437668c86$var$Oi = !1, $9b5c2f7437668c86$var$Pi = null, $9b5c2f7437668c86$var$Ri = null, $9b5c2f7437668c86$var$vk = !1, $9b5c2f7437668c86$var$wk = null, $9b5c2f7437668c86$var$xk = 0, $9b5c2f7437668c86$var$yk = 0, $9b5c2f7437668c86$var$zk = null, $9b5c2f7437668c86$var$Ak = -1, $9b5c2f7437668c86$var$Bk = 0;
function $9b5c2f7437668c86$var$R() {
    return 0 !== ($9b5c2f7437668c86$var$K & 6) ? $9b5c2f7437668c86$var$B() : -1 !== $9b5c2f7437668c86$var$Ak ? $9b5c2f7437668c86$var$Ak : $9b5c2f7437668c86$var$Ak = $9b5c2f7437668c86$var$B();
}
function $9b5c2f7437668c86$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($9b5c2f7437668c86$var$K & 2) && 0 !== $9b5c2f7437668c86$var$Z) return $9b5c2f7437668c86$var$Z & -$9b5c2f7437668c86$var$Z;
    if (null !== $9b5c2f7437668c86$var$Kg.transition) return 0 === $9b5c2f7437668c86$var$Bk && ($9b5c2f7437668c86$var$Bk = $9b5c2f7437668c86$var$yc()), $9b5c2f7437668c86$var$Bk;
    a = $9b5c2f7437668c86$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $9b5c2f7437668c86$var$jd(a.type);
    return a;
}
function $9b5c2f7437668c86$var$gi(a, b, c, d) {
    if (50 < $9b5c2f7437668c86$var$yk) throw $9b5c2f7437668c86$var$yk = 0, $9b5c2f7437668c86$var$zk = null, Error($9b5c2f7437668c86$var$p(185));
    $9b5c2f7437668c86$var$Ac(a, c, d);
    if (0 === ($9b5c2f7437668c86$var$K & 2) || a !== $9b5c2f7437668c86$var$Q) a === $9b5c2f7437668c86$var$Q && (0 === ($9b5c2f7437668c86$var$K & 2) && ($9b5c2f7437668c86$var$qk |= c), 4 === $9b5c2f7437668c86$var$T && $9b5c2f7437668c86$var$Ck(a, $9b5c2f7437668c86$var$Z)), $9b5c2f7437668c86$var$Dk(a, d), 1 === c && 0 === $9b5c2f7437668c86$var$K && 0 === (b.mode & 1) && ($9b5c2f7437668c86$var$Gj = $9b5c2f7437668c86$var$B() + 500, $9b5c2f7437668c86$var$fg && $9b5c2f7437668c86$var$jg());
}
function $9b5c2f7437668c86$var$Dk(a, b) {
    var c = a.callbackNode;
    $9b5c2f7437668c86$var$wc(a, b);
    var d = $9b5c2f7437668c86$var$uc(a, a === $9b5c2f7437668c86$var$Q ? $9b5c2f7437668c86$var$Z : 0);
    if (0 === d) null !== c && $9b5c2f7437668c86$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $9b5c2f7437668c86$var$bc(c);
        if (1 === b) 0 === a.tag ? $9b5c2f7437668c86$var$ig($9b5c2f7437668c86$var$Ek.bind(null, a)) : $9b5c2f7437668c86$var$hg($9b5c2f7437668c86$var$Ek.bind(null, a)), $9b5c2f7437668c86$var$Jf(function() {
            0 === ($9b5c2f7437668c86$var$K & 6) && $9b5c2f7437668c86$var$jg();
        }), c = null;
        else {
            switch($9b5c2f7437668c86$var$Dc(d)){
                case 1:
                    c = $9b5c2f7437668c86$var$fc;
                    break;
                case 4:
                    c = $9b5c2f7437668c86$var$gc;
                    break;
                case 16:
                    c = $9b5c2f7437668c86$var$hc;
                    break;
                case 536870912:
                    c = $9b5c2f7437668c86$var$jc;
                    break;
                default:
                    c = $9b5c2f7437668c86$var$hc;
            }
            c = $9b5c2f7437668c86$var$Fk(c, $9b5c2f7437668c86$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $9b5c2f7437668c86$var$Gk(a, b) {
    $9b5c2f7437668c86$var$Ak = -1;
    $9b5c2f7437668c86$var$Bk = 0;
    if (0 !== ($9b5c2f7437668c86$var$K & 6)) throw Error($9b5c2f7437668c86$var$p(327));
    var c = a.callbackNode;
    if ($9b5c2f7437668c86$var$Hk() && a.callbackNode !== c) return null;
    var d = $9b5c2f7437668c86$var$uc(a, a === $9b5c2f7437668c86$var$Q ? $9b5c2f7437668c86$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $9b5c2f7437668c86$var$Ik(a, d);
    else {
        b = d;
        var e = $9b5c2f7437668c86$var$K;
        $9b5c2f7437668c86$var$K |= 2;
        var f = $9b5c2f7437668c86$var$Jk();
        if ($9b5c2f7437668c86$var$Q !== a || $9b5c2f7437668c86$var$Z !== b) $9b5c2f7437668c86$var$uk = null, $9b5c2f7437668c86$var$Gj = $9b5c2f7437668c86$var$B() + 500, $9b5c2f7437668c86$var$Kk(a, b);
        for(;;)try {
            $9b5c2f7437668c86$var$Lk();
            break;
        } catch (h) {
            $9b5c2f7437668c86$var$Mk(a, h);
        }
        $9b5c2f7437668c86$var$$g();
        $9b5c2f7437668c86$var$mk.current = f;
        $9b5c2f7437668c86$var$K = e;
        null !== $9b5c2f7437668c86$var$Y ? b = 0 : ($9b5c2f7437668c86$var$Q = null, $9b5c2f7437668c86$var$Z = 0, b = $9b5c2f7437668c86$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $9b5c2f7437668c86$var$xc(a), 0 !== e && (d = e, b = $9b5c2f7437668c86$var$Nk(a, e)));
        if (1 === b) throw c = $9b5c2f7437668c86$var$pk, $9b5c2f7437668c86$var$Kk(a, 0), $9b5c2f7437668c86$var$Ck(a, d), $9b5c2f7437668c86$var$Dk(a, $9b5c2f7437668c86$var$B()), c;
        if (6 === b) $9b5c2f7437668c86$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$9b5c2f7437668c86$var$Ok(e) && (b = $9b5c2f7437668c86$var$Ik(a, d), 2 === b && (f = $9b5c2f7437668c86$var$xc(a), 0 !== f && (d = f, b = $9b5c2f7437668c86$var$Nk(a, f))), 1 === b)) throw c = $9b5c2f7437668c86$var$pk, $9b5c2f7437668c86$var$Kk(a, 0), $9b5c2f7437668c86$var$Ck(a, d), $9b5c2f7437668c86$var$Dk(a, $9b5c2f7437668c86$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($9b5c2f7437668c86$var$p(345));
                case 2:
                    $9b5c2f7437668c86$var$Pk(a, $9b5c2f7437668c86$var$tk, $9b5c2f7437668c86$var$uk);
                    break;
                case 3:
                    $9b5c2f7437668c86$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $9b5c2f7437668c86$var$fk + 500 - $9b5c2f7437668c86$var$B(), 10 < b)) {
                        if (0 !== $9b5c2f7437668c86$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $9b5c2f7437668c86$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $9b5c2f7437668c86$var$Ff($9b5c2f7437668c86$var$Pk.bind(null, a, $9b5c2f7437668c86$var$tk, $9b5c2f7437668c86$var$uk), b);
                        break;
                    }
                    $9b5c2f7437668c86$var$Pk(a, $9b5c2f7437668c86$var$tk, $9b5c2f7437668c86$var$uk);
                    break;
                case 4:
                    $9b5c2f7437668c86$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $9b5c2f7437668c86$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $9b5c2f7437668c86$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $9b5c2f7437668c86$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $9b5c2f7437668c86$var$Ff($9b5c2f7437668c86$var$Pk.bind(null, a, $9b5c2f7437668c86$var$tk, $9b5c2f7437668c86$var$uk), d);
                        break;
                    }
                    $9b5c2f7437668c86$var$Pk(a, $9b5c2f7437668c86$var$tk, $9b5c2f7437668c86$var$uk);
                    break;
                case 5:
                    $9b5c2f7437668c86$var$Pk(a, $9b5c2f7437668c86$var$tk, $9b5c2f7437668c86$var$uk);
                    break;
                default:
                    throw Error($9b5c2f7437668c86$var$p(329));
            }
        }
    }
    $9b5c2f7437668c86$var$Dk(a, $9b5c2f7437668c86$var$B());
    return a.callbackNode === c ? $9b5c2f7437668c86$var$Gk.bind(null, a) : null;
}
function $9b5c2f7437668c86$var$Nk(a, b) {
    var c = $9b5c2f7437668c86$var$sk;
    a.current.memoizedState.isDehydrated && ($9b5c2f7437668c86$var$Kk(a, b).flags |= 256);
    a = $9b5c2f7437668c86$var$Ik(a, b);
    2 !== a && (b = $9b5c2f7437668c86$var$tk, $9b5c2f7437668c86$var$tk = c, null !== b && $9b5c2f7437668c86$var$Fj(b));
    return a;
}
function $9b5c2f7437668c86$var$Fj(a) {
    null === $9b5c2f7437668c86$var$tk ? $9b5c2f7437668c86$var$tk = a : $9b5c2f7437668c86$var$tk.push.apply($9b5c2f7437668c86$var$tk, a);
}
function $9b5c2f7437668c86$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$9b5c2f7437668c86$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $9b5c2f7437668c86$var$Ck(a, b) {
    b &= ~$9b5c2f7437668c86$var$rk;
    b &= ~$9b5c2f7437668c86$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $9b5c2f7437668c86$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $9b5c2f7437668c86$var$Ek(a) {
    if (0 !== ($9b5c2f7437668c86$var$K & 6)) throw Error($9b5c2f7437668c86$var$p(327));
    $9b5c2f7437668c86$var$Hk();
    var b = $9b5c2f7437668c86$var$uc(a, 0);
    if (0 === (b & 1)) return $9b5c2f7437668c86$var$Dk(a, $9b5c2f7437668c86$var$B()), null;
    var c = $9b5c2f7437668c86$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $9b5c2f7437668c86$var$xc(a);
        0 !== d && (b = d, c = $9b5c2f7437668c86$var$Nk(a, d));
    }
    if (1 === c) throw c = $9b5c2f7437668c86$var$pk, $9b5c2f7437668c86$var$Kk(a, 0), $9b5c2f7437668c86$var$Ck(a, b), $9b5c2f7437668c86$var$Dk(a, $9b5c2f7437668c86$var$B()), c;
    if (6 === c) throw Error($9b5c2f7437668c86$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $9b5c2f7437668c86$var$Pk(a, $9b5c2f7437668c86$var$tk, $9b5c2f7437668c86$var$uk);
    $9b5c2f7437668c86$var$Dk(a, $9b5c2f7437668c86$var$B());
    return null;
}
function $9b5c2f7437668c86$var$Qk(a, b) {
    var c = $9b5c2f7437668c86$var$K;
    $9b5c2f7437668c86$var$K |= 1;
    try {
        return a(b);
    } finally{
        $9b5c2f7437668c86$var$K = c, 0 === $9b5c2f7437668c86$var$K && ($9b5c2f7437668c86$var$Gj = $9b5c2f7437668c86$var$B() + 500, $9b5c2f7437668c86$var$fg && $9b5c2f7437668c86$var$jg());
    }
}
function $9b5c2f7437668c86$var$Rk(a) {
    null !== $9b5c2f7437668c86$var$wk && 0 === $9b5c2f7437668c86$var$wk.tag && 0 === ($9b5c2f7437668c86$var$K & 6) && $9b5c2f7437668c86$var$Hk();
    var b = $9b5c2f7437668c86$var$K;
    $9b5c2f7437668c86$var$K |= 1;
    var c = $9b5c2f7437668c86$var$ok.transition, d = $9b5c2f7437668c86$var$C;
    try {
        if ($9b5c2f7437668c86$var$ok.transition = null, $9b5c2f7437668c86$var$C = 1, a) return a();
    } finally{
        $9b5c2f7437668c86$var$C = d, $9b5c2f7437668c86$var$ok.transition = c, $9b5c2f7437668c86$var$K = b, 0 === ($9b5c2f7437668c86$var$K & 6) && $9b5c2f7437668c86$var$jg();
    }
}
function $9b5c2f7437668c86$var$Hj() {
    $9b5c2f7437668c86$var$fj = $9b5c2f7437668c86$var$ej.current;
    $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$ej);
}
function $9b5c2f7437668c86$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $9b5c2f7437668c86$var$Gf(c));
    if (null !== $9b5c2f7437668c86$var$Y) for(c = $9b5c2f7437668c86$var$Y.return; null !== c;){
        var d = c;
        $9b5c2f7437668c86$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $9b5c2f7437668c86$var$$f();
                break;
            case 3:
                $9b5c2f7437668c86$var$zh();
                $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$Wf);
                $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$H);
                $9b5c2f7437668c86$var$Eh();
                break;
            case 5:
                $9b5c2f7437668c86$var$Bh(d);
                break;
            case 4:
                $9b5c2f7437668c86$var$zh();
                break;
            case 13:
                $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$L);
                break;
            case 19:
                $9b5c2f7437668c86$var$E($9b5c2f7437668c86$var$L);
                break;
            case 10:
                $9b5c2f7437668c86$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $9b5c2f7437668c86$var$Hj();
        }
        c = c.return;
    }
    $9b5c2f7437668c86$var$Q = a;
    $9b5c2f7437668c86$var$Y = a = $9b5c2f7437668c86$var$Pg(a.current, null);
    $9b5c2f7437668c86$var$Z = $9b5c2f7437668c86$var$fj = b;
    $9b5c2f7437668c86$var$T = 0;
    $9b5c2f7437668c86$var$pk = null;
    $9b5c2f7437668c86$var$rk = $9b5c2f7437668c86$var$qk = $9b5c2f7437668c86$var$rh = 0;
    $9b5c2f7437668c86$var$tk = $9b5c2f7437668c86$var$sk = null;
    if (null !== $9b5c2f7437668c86$var$fh) {
        for(b = 0; b < $9b5c2f7437668c86$var$fh.length; b++)if (c = $9b5c2f7437668c86$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $9b5c2f7437668c86$var$fh = null;
    }
    return a;
}
function $9b5c2f7437668c86$var$Mk(a, b) {
    do {
        var c = $9b5c2f7437668c86$var$Y;
        try {
            $9b5c2f7437668c86$var$$g();
            $9b5c2f7437668c86$var$Fh.current = $9b5c2f7437668c86$var$Rh;
            if ($9b5c2f7437668c86$var$Ih) {
                for(var d = $9b5c2f7437668c86$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $9b5c2f7437668c86$var$Ih = !1;
            }
            $9b5c2f7437668c86$var$Hh = 0;
            $9b5c2f7437668c86$var$O = $9b5c2f7437668c86$var$N = $9b5c2f7437668c86$var$M = null;
            $9b5c2f7437668c86$var$Jh = !1;
            $9b5c2f7437668c86$var$Kh = 0;
            $9b5c2f7437668c86$var$nk.current = null;
            if (null === c || null === c.return) {
                $9b5c2f7437668c86$var$T = 1;
                $9b5c2f7437668c86$var$pk = b;
                $9b5c2f7437668c86$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $9b5c2f7437668c86$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $9b5c2f7437668c86$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $9b5c2f7437668c86$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $9b5c2f7437668c86$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $9b5c2f7437668c86$var$Si(f, l, b);
                            $9b5c2f7437668c86$var$tj();
                            break a;
                        }
                        k = Error($9b5c2f7437668c86$var$p(426));
                    }
                } else if ($9b5c2f7437668c86$var$I && h.mode & 1) {
                    var J = $9b5c2f7437668c86$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $9b5c2f7437668c86$var$Vi(J, g, h, f, b);
                        $9b5c2f7437668c86$var$Jg($9b5c2f7437668c86$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $9b5c2f7437668c86$var$Ji(k, h);
                4 !== $9b5c2f7437668c86$var$T && ($9b5c2f7437668c86$var$T = 2);
                null === $9b5c2f7437668c86$var$sk ? $9b5c2f7437668c86$var$sk = [
                    f
                ] : $9b5c2f7437668c86$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $9b5c2f7437668c86$var$Ni(f, k, b);
                            $9b5c2f7437668c86$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $9b5c2f7437668c86$var$Ri || !$9b5c2f7437668c86$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $9b5c2f7437668c86$var$Qi(f, h, b);
                                $9b5c2f7437668c86$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $9b5c2f7437668c86$var$Sk(c);
        } catch (na) {
            b = na;
            $9b5c2f7437668c86$var$Y === c && null !== c && ($9b5c2f7437668c86$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $9b5c2f7437668c86$var$Jk() {
    var a = $9b5c2f7437668c86$var$mk.current;
    $9b5c2f7437668c86$var$mk.current = $9b5c2f7437668c86$var$Rh;
    return null === a ? $9b5c2f7437668c86$var$Rh : a;
}
function $9b5c2f7437668c86$var$tj() {
    if (0 === $9b5c2f7437668c86$var$T || 3 === $9b5c2f7437668c86$var$T || 2 === $9b5c2f7437668c86$var$T) $9b5c2f7437668c86$var$T = 4;
    null === $9b5c2f7437668c86$var$Q || 0 === ($9b5c2f7437668c86$var$rh & 268435455) && 0 === ($9b5c2f7437668c86$var$qk & 268435455) || $9b5c2f7437668c86$var$Ck($9b5c2f7437668c86$var$Q, $9b5c2f7437668c86$var$Z);
}
function $9b5c2f7437668c86$var$Ik(a, b) {
    var c = $9b5c2f7437668c86$var$K;
    $9b5c2f7437668c86$var$K |= 2;
    var d = $9b5c2f7437668c86$var$Jk();
    if ($9b5c2f7437668c86$var$Q !== a || $9b5c2f7437668c86$var$Z !== b) $9b5c2f7437668c86$var$uk = null, $9b5c2f7437668c86$var$Kk(a, b);
    for(;;)try {
        $9b5c2f7437668c86$var$Tk();
        break;
    } catch (e) {
        $9b5c2f7437668c86$var$Mk(a, e);
    }
    $9b5c2f7437668c86$var$$g();
    $9b5c2f7437668c86$var$K = c;
    $9b5c2f7437668c86$var$mk.current = d;
    if (null !== $9b5c2f7437668c86$var$Y) throw Error($9b5c2f7437668c86$var$p(261));
    $9b5c2f7437668c86$var$Q = null;
    $9b5c2f7437668c86$var$Z = 0;
    return $9b5c2f7437668c86$var$T;
}
function $9b5c2f7437668c86$var$Tk() {
    for(; null !== $9b5c2f7437668c86$var$Y;)$9b5c2f7437668c86$var$Uk($9b5c2f7437668c86$var$Y);
}
function $9b5c2f7437668c86$var$Lk() {
    for(; null !== $9b5c2f7437668c86$var$Y && !$9b5c2f7437668c86$var$cc();)$9b5c2f7437668c86$var$Uk($9b5c2f7437668c86$var$Y);
}
function $9b5c2f7437668c86$var$Uk(a) {
    var b = $9b5c2f7437668c86$var$Vk(a.alternate, a, $9b5c2f7437668c86$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $9b5c2f7437668c86$var$Sk(a) : $9b5c2f7437668c86$var$Y = b;
    $9b5c2f7437668c86$var$nk.current = null;
}
function $9b5c2f7437668c86$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $9b5c2f7437668c86$var$Ej(c, b, $9b5c2f7437668c86$var$fj), null !== c) {
                $9b5c2f7437668c86$var$Y = c;
                return;
            }
        } else {
            c = $9b5c2f7437668c86$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $9b5c2f7437668c86$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $9b5c2f7437668c86$var$T = 6;
                $9b5c2f7437668c86$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $9b5c2f7437668c86$var$Y = b;
            return;
        }
        $9b5c2f7437668c86$var$Y = b = a;
    }while (null !== b);
    0 === $9b5c2f7437668c86$var$T && ($9b5c2f7437668c86$var$T = 5);
}
function $9b5c2f7437668c86$var$Pk(a, b, c) {
    var d = $9b5c2f7437668c86$var$C, e = $9b5c2f7437668c86$var$ok.transition;
    try {
        $9b5c2f7437668c86$var$ok.transition = null, $9b5c2f7437668c86$var$C = 1, $9b5c2f7437668c86$var$Wk(a, b, c, d);
    } finally{
        $9b5c2f7437668c86$var$ok.transition = e, $9b5c2f7437668c86$var$C = d;
    }
    return null;
}
function $9b5c2f7437668c86$var$Wk(a, b, c, d) {
    do $9b5c2f7437668c86$var$Hk();
    while (null !== $9b5c2f7437668c86$var$wk);
    if (0 !== ($9b5c2f7437668c86$var$K & 6)) throw Error($9b5c2f7437668c86$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($9b5c2f7437668c86$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $9b5c2f7437668c86$var$Bc(a, f);
    a === $9b5c2f7437668c86$var$Q && ($9b5c2f7437668c86$var$Y = $9b5c2f7437668c86$var$Q = null, $9b5c2f7437668c86$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $9b5c2f7437668c86$var$vk || ($9b5c2f7437668c86$var$vk = !0, $9b5c2f7437668c86$var$Fk($9b5c2f7437668c86$var$hc, function() {
        $9b5c2f7437668c86$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $9b5c2f7437668c86$var$ok.transition;
        $9b5c2f7437668c86$var$ok.transition = null;
        var g = $9b5c2f7437668c86$var$C;
        $9b5c2f7437668c86$var$C = 1;
        var h = $9b5c2f7437668c86$var$K;
        $9b5c2f7437668c86$var$K |= 4;
        $9b5c2f7437668c86$var$nk.current = null;
        $9b5c2f7437668c86$var$Oj(a, c);
        $9b5c2f7437668c86$var$dk(c, a);
        $9b5c2f7437668c86$var$Oe($9b5c2f7437668c86$var$Df);
        $9b5c2f7437668c86$var$dd = !!$9b5c2f7437668c86$var$Cf;
        $9b5c2f7437668c86$var$Df = $9b5c2f7437668c86$var$Cf = null;
        a.current = c;
        $9b5c2f7437668c86$var$hk(c, a, e);
        $9b5c2f7437668c86$var$dc();
        $9b5c2f7437668c86$var$K = h;
        $9b5c2f7437668c86$var$C = g;
        $9b5c2f7437668c86$var$ok.transition = f;
    } else a.current = c;
    $9b5c2f7437668c86$var$vk && ($9b5c2f7437668c86$var$vk = !1, $9b5c2f7437668c86$var$wk = a, $9b5c2f7437668c86$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($9b5c2f7437668c86$var$Ri = null);
    $9b5c2f7437668c86$var$mc(c.stateNode, d);
    $9b5c2f7437668c86$var$Dk(a, $9b5c2f7437668c86$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($9b5c2f7437668c86$var$Oi) throw $9b5c2f7437668c86$var$Oi = !1, a = $9b5c2f7437668c86$var$Pi, $9b5c2f7437668c86$var$Pi = null, a;
    0 !== ($9b5c2f7437668c86$var$xk & 1) && 0 !== a.tag && $9b5c2f7437668c86$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $9b5c2f7437668c86$var$zk ? $9b5c2f7437668c86$var$yk++ : ($9b5c2f7437668c86$var$yk = 0, $9b5c2f7437668c86$var$zk = a) : $9b5c2f7437668c86$var$yk = 0;
    $9b5c2f7437668c86$var$jg();
    return null;
}
function $9b5c2f7437668c86$var$Hk() {
    if (null !== $9b5c2f7437668c86$var$wk) {
        var a = $9b5c2f7437668c86$var$Dc($9b5c2f7437668c86$var$xk), b = $9b5c2f7437668c86$var$ok.transition, c = $9b5c2f7437668c86$var$C;
        try {
            $9b5c2f7437668c86$var$ok.transition = null;
            $9b5c2f7437668c86$var$C = 16 > a ? 16 : a;
            if (null === $9b5c2f7437668c86$var$wk) var d = !1;
            else {
                a = $9b5c2f7437668c86$var$wk;
                $9b5c2f7437668c86$var$wk = null;
                $9b5c2f7437668c86$var$xk = 0;
                if (0 !== ($9b5c2f7437668c86$var$K & 6)) throw Error($9b5c2f7437668c86$var$p(331));
                var e = $9b5c2f7437668c86$var$K;
                $9b5c2f7437668c86$var$K |= 4;
                for($9b5c2f7437668c86$var$V = a.current; null !== $9b5c2f7437668c86$var$V;){
                    var f = $9b5c2f7437668c86$var$V, g = f.child;
                    if (0 !== ($9b5c2f7437668c86$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($9b5c2f7437668c86$var$V = l; null !== $9b5c2f7437668c86$var$V;){
                                    var m = $9b5c2f7437668c86$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $9b5c2f7437668c86$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $9b5c2f7437668c86$var$V = q;
                                    else for(; null !== $9b5c2f7437668c86$var$V;){
                                        m = $9b5c2f7437668c86$var$V;
                                        var r = m.sibling, y = m.return;
                                        $9b5c2f7437668c86$var$Sj(m);
                                        if (m === l) {
                                            $9b5c2f7437668c86$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $9b5c2f7437668c86$var$V = r;
                                            break;
                                        }
                                        $9b5c2f7437668c86$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $9b5c2f7437668c86$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $9b5c2f7437668c86$var$V = g;
                    else b: for(; null !== $9b5c2f7437668c86$var$V;){
                        f = $9b5c2f7437668c86$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $9b5c2f7437668c86$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $9b5c2f7437668c86$var$V = x;
                            break b;
                        }
                        $9b5c2f7437668c86$var$V = f.return;
                    }
                }
                var w = a.current;
                for($9b5c2f7437668c86$var$V = w; null !== $9b5c2f7437668c86$var$V;){
                    g = $9b5c2f7437668c86$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $9b5c2f7437668c86$var$V = u;
                    else b: for(g = w; null !== $9b5c2f7437668c86$var$V;){
                        h = $9b5c2f7437668c86$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $9b5c2f7437668c86$var$Qj(9, h);
                            }
                        } catch (na) {
                            $9b5c2f7437668c86$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $9b5c2f7437668c86$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $9b5c2f7437668c86$var$V = F;
                            break b;
                        }
                        $9b5c2f7437668c86$var$V = h.return;
                    }
                }
                $9b5c2f7437668c86$var$K = e;
                $9b5c2f7437668c86$var$jg();
                if ($9b5c2f7437668c86$var$lc && "function" === typeof $9b5c2f7437668c86$var$lc.onPostCommitFiberRoot) try {
                    $9b5c2f7437668c86$var$lc.onPostCommitFiberRoot($9b5c2f7437668c86$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $9b5c2f7437668c86$var$C = c, $9b5c2f7437668c86$var$ok.transition = b;
        }
    }
    return !1;
}
function $9b5c2f7437668c86$var$Xk(a, b, c) {
    b = $9b5c2f7437668c86$var$Ji(c, b);
    b = $9b5c2f7437668c86$var$Ni(a, b, 1);
    a = $9b5c2f7437668c86$var$nh(a, b, 1);
    b = $9b5c2f7437668c86$var$R();
    null !== a && ($9b5c2f7437668c86$var$Ac(a, 1, b), $9b5c2f7437668c86$var$Dk(a, b));
}
function $9b5c2f7437668c86$var$W(a, b, c) {
    if (3 === a.tag) $9b5c2f7437668c86$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $9b5c2f7437668c86$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $9b5c2f7437668c86$var$Ri || !$9b5c2f7437668c86$var$Ri.has(d))) {
                a = $9b5c2f7437668c86$var$Ji(c, a);
                a = $9b5c2f7437668c86$var$Qi(b, a, 1);
                b = $9b5c2f7437668c86$var$nh(b, a, 1);
                a = $9b5c2f7437668c86$var$R();
                null !== b && ($9b5c2f7437668c86$var$Ac(b, 1, a), $9b5c2f7437668c86$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $9b5c2f7437668c86$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $9b5c2f7437668c86$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $9b5c2f7437668c86$var$Q === a && ($9b5c2f7437668c86$var$Z & c) === c && (4 === $9b5c2f7437668c86$var$T || 3 === $9b5c2f7437668c86$var$T && ($9b5c2f7437668c86$var$Z & 130023424) === $9b5c2f7437668c86$var$Z && 500 > $9b5c2f7437668c86$var$B() - $9b5c2f7437668c86$var$fk ? $9b5c2f7437668c86$var$Kk(a, 0) : $9b5c2f7437668c86$var$rk |= c);
    $9b5c2f7437668c86$var$Dk(a, b);
}
function $9b5c2f7437668c86$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $9b5c2f7437668c86$var$sc, $9b5c2f7437668c86$var$sc <<= 1, 0 === ($9b5c2f7437668c86$var$sc & 130023424) && ($9b5c2f7437668c86$var$sc = 4194304)));
    var c = $9b5c2f7437668c86$var$R();
    a = $9b5c2f7437668c86$var$ih(a, b);
    null !== a && ($9b5c2f7437668c86$var$Ac(a, b, c), $9b5c2f7437668c86$var$Dk(a, c));
}
function $9b5c2f7437668c86$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $9b5c2f7437668c86$var$Yk(a, c);
}
function $9b5c2f7437668c86$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($9b5c2f7437668c86$var$p(314));
    }
    null !== d && d.delete(b);
    $9b5c2f7437668c86$var$Yk(a, c);
}
var $9b5c2f7437668c86$var$Vk;
$9b5c2f7437668c86$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $9b5c2f7437668c86$var$Wf.current) $9b5c2f7437668c86$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $9b5c2f7437668c86$var$dh = !1, $9b5c2f7437668c86$var$yj(a, b, c);
            $9b5c2f7437668c86$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $9b5c2f7437668c86$var$dh = !1, $9b5c2f7437668c86$var$I && 0 !== (b.flags & 1048576) && $9b5c2f7437668c86$var$ug(b, $9b5c2f7437668c86$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $9b5c2f7437668c86$var$ij(a, b);
            a = b.pendingProps;
            var e = $9b5c2f7437668c86$var$Yf(b, $9b5c2f7437668c86$var$H.current);
            $9b5c2f7437668c86$var$ch(b, c);
            e = $9b5c2f7437668c86$var$Nh(null, b, d, a, e, c);
            var f = $9b5c2f7437668c86$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $9b5c2f7437668c86$var$Zf(d) ? (f = !0, $9b5c2f7437668c86$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $9b5c2f7437668c86$var$kh(b), e.updater = $9b5c2f7437668c86$var$Ei, b.stateNode = e, e._reactInternals = b, $9b5c2f7437668c86$var$Ii(b, d, a, c), b = $9b5c2f7437668c86$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $9b5c2f7437668c86$var$I && f && $9b5c2f7437668c86$var$vg(b), $9b5c2f7437668c86$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $9b5c2f7437668c86$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $9b5c2f7437668c86$var$Zk(d);
                a = $9b5c2f7437668c86$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $9b5c2f7437668c86$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $9b5c2f7437668c86$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $9b5c2f7437668c86$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $9b5c2f7437668c86$var$$i(null, b, d, $9b5c2f7437668c86$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($9b5c2f7437668c86$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b5c2f7437668c86$var$Ci(d, e), $9b5c2f7437668c86$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b5c2f7437668c86$var$Ci(d, e), $9b5c2f7437668c86$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $9b5c2f7437668c86$var$kj(b);
                if (null === a) throw Error($9b5c2f7437668c86$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $9b5c2f7437668c86$var$lh(a, b);
                $9b5c2f7437668c86$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $9b5c2f7437668c86$var$Ji(Error($9b5c2f7437668c86$var$p(423)), b);
                        b = $9b5c2f7437668c86$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $9b5c2f7437668c86$var$Ji(Error($9b5c2f7437668c86$var$p(424)), b);
                        b = $9b5c2f7437668c86$var$lj(a, b, d, c, e);
                        break a;
                    } else for($9b5c2f7437668c86$var$yg = $9b5c2f7437668c86$var$Lf(b.stateNode.containerInfo.firstChild), $9b5c2f7437668c86$var$xg = b, $9b5c2f7437668c86$var$I = !0, $9b5c2f7437668c86$var$zg = null, c = $9b5c2f7437668c86$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $9b5c2f7437668c86$var$Ig();
                    if (d === e) {
                        b = $9b5c2f7437668c86$var$Zi(a, b, c);
                        break a;
                    }
                    $9b5c2f7437668c86$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $9b5c2f7437668c86$var$Ah(b), null === a && $9b5c2f7437668c86$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $9b5c2f7437668c86$var$Ef(d, e) ? g = null : null !== f && $9b5c2f7437668c86$var$Ef(d, f) && (b.flags |= 32), $9b5c2f7437668c86$var$gj(a, b), $9b5c2f7437668c86$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $9b5c2f7437668c86$var$Eg(b), null;
        case 13:
            return $9b5c2f7437668c86$var$oj(a, b, c);
        case 4:
            return $9b5c2f7437668c86$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $9b5c2f7437668c86$var$Ug(b, null, d, c) : $9b5c2f7437668c86$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b5c2f7437668c86$var$Ci(d, e), $9b5c2f7437668c86$var$Yi(a, b, d, e, c);
        case 7:
            return $9b5c2f7437668c86$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $9b5c2f7437668c86$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $9b5c2f7437668c86$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $9b5c2f7437668c86$var$G($9b5c2f7437668c86$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($9b5c2f7437668c86$var$He(f.value, g)) {
                        if (f.children === e.children && !$9b5c2f7437668c86$var$Wf.current) {
                            b = $9b5c2f7437668c86$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $9b5c2f7437668c86$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $9b5c2f7437668c86$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($9b5c2f7437668c86$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $9b5c2f7437668c86$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $9b5c2f7437668c86$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $9b5c2f7437668c86$var$ch(b, c), e = $9b5c2f7437668c86$var$eh(e), d = d(e), b.flags |= 1, $9b5c2f7437668c86$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $9b5c2f7437668c86$var$Ci(d, b.pendingProps), e = $9b5c2f7437668c86$var$Ci(d.type, e), $9b5c2f7437668c86$var$$i(a, b, d, e, c);
        case 15:
            return $9b5c2f7437668c86$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b5c2f7437668c86$var$Ci(d, e), $9b5c2f7437668c86$var$ij(a, b), b.tag = 1, $9b5c2f7437668c86$var$Zf(d) ? (a = !0, $9b5c2f7437668c86$var$cg(b)) : a = !1, $9b5c2f7437668c86$var$ch(b, c), $9b5c2f7437668c86$var$Gi(b, d, e), $9b5c2f7437668c86$var$Ii(b, d, e, c), $9b5c2f7437668c86$var$jj(null, b, d, !0, a, c);
        case 19:
            return $9b5c2f7437668c86$var$xj(a, b, c);
        case 22:
            return $9b5c2f7437668c86$var$dj(a, b, c);
    }
    throw Error($9b5c2f7437668c86$var$p(156, b.tag));
};
function $9b5c2f7437668c86$var$Fk(a, b) {
    return $9b5c2f7437668c86$var$ac(a, b);
}
function $9b5c2f7437668c86$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $9b5c2f7437668c86$var$Bg(a, b, c, d) {
    return new $9b5c2f7437668c86$var$$k(a, b, c, d);
}
function $9b5c2f7437668c86$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $9b5c2f7437668c86$var$Zk(a) {
    if ("function" === typeof a) return $9b5c2f7437668c86$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $9b5c2f7437668c86$var$Da) return 11;
        if (a === $9b5c2f7437668c86$var$Ga) return 14;
    }
    return 2;
}
function $9b5c2f7437668c86$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $9b5c2f7437668c86$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $9b5c2f7437668c86$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $9b5c2f7437668c86$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $9b5c2f7437668c86$var$ya:
            return $9b5c2f7437668c86$var$Tg(c.children, e, f, b);
        case $9b5c2f7437668c86$var$za:
            g = 8;
            e |= 8;
            break;
        case $9b5c2f7437668c86$var$Aa:
            return a = $9b5c2f7437668c86$var$Bg(12, c, b, e | 2), a.elementType = $9b5c2f7437668c86$var$Aa, a.lanes = f, a;
        case $9b5c2f7437668c86$var$Ea:
            return a = $9b5c2f7437668c86$var$Bg(13, c, b, e), a.elementType = $9b5c2f7437668c86$var$Ea, a.lanes = f, a;
        case $9b5c2f7437668c86$var$Fa:
            return a = $9b5c2f7437668c86$var$Bg(19, c, b, e), a.elementType = $9b5c2f7437668c86$var$Fa, a.lanes = f, a;
        case $9b5c2f7437668c86$var$Ia:
            return $9b5c2f7437668c86$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $9b5c2f7437668c86$var$Ba:
                    g = 10;
                    break a;
                case $9b5c2f7437668c86$var$Ca:
                    g = 9;
                    break a;
                case $9b5c2f7437668c86$var$Da:
                    g = 11;
                    break a;
                case $9b5c2f7437668c86$var$Ga:
                    g = 14;
                    break a;
                case $9b5c2f7437668c86$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($9b5c2f7437668c86$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $9b5c2f7437668c86$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $9b5c2f7437668c86$var$Tg(a, b, c, d) {
    a = $9b5c2f7437668c86$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $9b5c2f7437668c86$var$pj(a, b, c, d) {
    a = $9b5c2f7437668c86$var$Bg(22, a, d, b);
    a.elementType = $9b5c2f7437668c86$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $9b5c2f7437668c86$var$Qg(a, b, c) {
    a = $9b5c2f7437668c86$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $9b5c2f7437668c86$var$Sg(a, b, c) {
    b = $9b5c2f7437668c86$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $9b5c2f7437668c86$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $9b5c2f7437668c86$var$zc(0);
    this.expirationTimes = $9b5c2f7437668c86$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $9b5c2f7437668c86$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $9b5c2f7437668c86$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $9b5c2f7437668c86$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $9b5c2f7437668c86$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $9b5c2f7437668c86$var$kh(f);
    return a;
}
function $9b5c2f7437668c86$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9b5c2f7437668c86$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $9b5c2f7437668c86$var$dl(a) {
    if (!a) return $9b5c2f7437668c86$var$Vf;
    a = a._reactInternals;
    a: {
        if ($9b5c2f7437668c86$var$Vb(a) !== a || 1 !== a.tag) throw Error($9b5c2f7437668c86$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($9b5c2f7437668c86$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($9b5c2f7437668c86$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($9b5c2f7437668c86$var$Zf(c)) return $9b5c2f7437668c86$var$bg(a, c, b);
    }
    return b;
}
function $9b5c2f7437668c86$var$el(a, b, c, d, e, f, g, h, k) {
    a = $9b5c2f7437668c86$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $9b5c2f7437668c86$var$dl(null);
    c = a.current;
    d = $9b5c2f7437668c86$var$R();
    e = $9b5c2f7437668c86$var$yi(c);
    f = $9b5c2f7437668c86$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $9b5c2f7437668c86$var$nh(c, f, e);
    a.current.lanes = e;
    $9b5c2f7437668c86$var$Ac(a, e, d);
    $9b5c2f7437668c86$var$Dk(a, d);
    return a;
}
function $9b5c2f7437668c86$var$fl(a, b, c, d) {
    var e = b.current, f = $9b5c2f7437668c86$var$R(), g = $9b5c2f7437668c86$var$yi(e);
    c = $9b5c2f7437668c86$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $9b5c2f7437668c86$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $9b5c2f7437668c86$var$nh(e, b, g);
    null !== a && ($9b5c2f7437668c86$var$gi(a, e, g, f), $9b5c2f7437668c86$var$oh(a, e, g));
    return g;
}
function $9b5c2f7437668c86$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $9b5c2f7437668c86$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $9b5c2f7437668c86$var$il(a, b) {
    $9b5c2f7437668c86$var$hl(a, b);
    (a = a.alternate) && $9b5c2f7437668c86$var$hl(a, b);
}
function $9b5c2f7437668c86$var$jl() {
    return null;
}
var $9b5c2f7437668c86$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $9b5c2f7437668c86$var$ll(a) {
    this._internalRoot = a;
}
$9b5c2f7437668c86$var$ml.prototype.render = $9b5c2f7437668c86$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($9b5c2f7437668c86$var$p(409));
    $9b5c2f7437668c86$var$fl(a, b, null, null);
};
$9b5c2f7437668c86$var$ml.prototype.unmount = $9b5c2f7437668c86$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $9b5c2f7437668c86$var$Rk(function() {
            $9b5c2f7437668c86$var$fl(null, a, null, null);
        });
        b[$9b5c2f7437668c86$var$uf] = null;
    }
};
function $9b5c2f7437668c86$var$ml(a) {
    this._internalRoot = a;
}
$9b5c2f7437668c86$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $9b5c2f7437668c86$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $9b5c2f7437668c86$var$Qc.length && 0 !== b && b < $9b5c2f7437668c86$var$Qc[c].priority; c++);
        $9b5c2f7437668c86$var$Qc.splice(c, 0, a);
        0 === c && $9b5c2f7437668c86$var$Vc(a);
    }
};
function $9b5c2f7437668c86$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $9b5c2f7437668c86$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $9b5c2f7437668c86$var$pl() {}
function $9b5c2f7437668c86$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $9b5c2f7437668c86$var$gl(g);
                f.call(a);
            };
        }
        var g = $9b5c2f7437668c86$var$el(b, d, a, 0, null, !1, !1, "", $9b5c2f7437668c86$var$pl);
        a._reactRootContainer = g;
        a[$9b5c2f7437668c86$var$uf] = g.current;
        $9b5c2f7437668c86$var$sf(8 === a.nodeType ? a.parentNode : a);
        $9b5c2f7437668c86$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $9b5c2f7437668c86$var$gl(k);
            h.call(a);
        };
    }
    var k = $9b5c2f7437668c86$var$bl(a, 0, !1, null, null, !1, !1, "", $9b5c2f7437668c86$var$pl);
    a._reactRootContainer = k;
    a[$9b5c2f7437668c86$var$uf] = k.current;
    $9b5c2f7437668c86$var$sf(8 === a.nodeType ? a.parentNode : a);
    $9b5c2f7437668c86$var$Rk(function() {
        $9b5c2f7437668c86$var$fl(b, k, c, d);
    });
    return k;
}
function $9b5c2f7437668c86$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $9b5c2f7437668c86$var$gl(g);
                h.call(a);
            };
        }
        $9b5c2f7437668c86$var$fl(b, g, a, e);
    } else g = $9b5c2f7437668c86$var$ql(c, b, a, e, d);
    return $9b5c2f7437668c86$var$gl(g);
}
$9b5c2f7437668c86$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $9b5c2f7437668c86$var$tc(b.pendingLanes);
                0 !== c && ($9b5c2f7437668c86$var$Cc(b, c | 1), $9b5c2f7437668c86$var$Dk(b, $9b5c2f7437668c86$var$B()), 0 === ($9b5c2f7437668c86$var$K & 6) && ($9b5c2f7437668c86$var$Gj = $9b5c2f7437668c86$var$B() + 500, $9b5c2f7437668c86$var$jg()));
            }
            break;
        case 13:
            $9b5c2f7437668c86$var$Rk(function() {
                var b = $9b5c2f7437668c86$var$ih(a, 1);
                if (null !== b) {
                    var c = $9b5c2f7437668c86$var$R();
                    $9b5c2f7437668c86$var$gi(b, a, 1, c);
                }
            }), $9b5c2f7437668c86$var$il(a, 1);
    }
};
$9b5c2f7437668c86$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $9b5c2f7437668c86$var$ih(a, 134217728);
        if (null !== b) {
            var c = $9b5c2f7437668c86$var$R();
            $9b5c2f7437668c86$var$gi(b, a, 134217728, c);
        }
        $9b5c2f7437668c86$var$il(a, 134217728);
    }
};
$9b5c2f7437668c86$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $9b5c2f7437668c86$var$yi(a), c = $9b5c2f7437668c86$var$ih(a, b);
        if (null !== c) {
            var d = $9b5c2f7437668c86$var$R();
            $9b5c2f7437668c86$var$gi(c, a, b, d);
        }
        $9b5c2f7437668c86$var$il(a, b);
    }
};
$9b5c2f7437668c86$var$Hc = function() {
    return $9b5c2f7437668c86$var$C;
};
$9b5c2f7437668c86$var$Ic = function(a, b) {
    var c = $9b5c2f7437668c86$var$C;
    try {
        return $9b5c2f7437668c86$var$C = a, b();
    } finally{
        $9b5c2f7437668c86$var$C = c;
    }
};
$9b5c2f7437668c86$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $9b5c2f7437668c86$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $9b5c2f7437668c86$var$Db(d);
                        if (!e) throw Error($9b5c2f7437668c86$var$p(90));
                        $9b5c2f7437668c86$var$Wa(d);
                        $9b5c2f7437668c86$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $9b5c2f7437668c86$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $9b5c2f7437668c86$var$fb(a, !!c.multiple, b, !1);
    }
};
$9b5c2f7437668c86$var$Gb = $9b5c2f7437668c86$var$Qk;
$9b5c2f7437668c86$var$Hb = $9b5c2f7437668c86$var$Rk;
var $9b5c2f7437668c86$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $9b5c2f7437668c86$var$Cb,
        $9b5c2f7437668c86$var$ue,
        $9b5c2f7437668c86$var$Db,
        $9b5c2f7437668c86$var$Eb,
        $9b5c2f7437668c86$var$Fb,
        $9b5c2f7437668c86$var$Qk
    ]
}, $9b5c2f7437668c86$var$tl = {
    findFiberByHostInstance: $9b5c2f7437668c86$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $9b5c2f7437668c86$var$ul = {
    bundleType: $9b5c2f7437668c86$var$tl.bundleType,
    version: $9b5c2f7437668c86$var$tl.version,
    rendererPackageName: $9b5c2f7437668c86$var$tl.rendererPackageName,
    rendererConfig: $9b5c2f7437668c86$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $9b5c2f7437668c86$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $9b5c2f7437668c86$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $9b5c2f7437668c86$var$tl.findFiberByHostInstance || $9b5c2f7437668c86$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $9b5c2f7437668c86$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$9b5c2f7437668c86$var$vl.isDisabled && $9b5c2f7437668c86$var$vl.supportsFiber) try {
        $9b5c2f7437668c86$var$kc = $9b5c2f7437668c86$var$vl.inject($9b5c2f7437668c86$var$ul), $9b5c2f7437668c86$var$lc = $9b5c2f7437668c86$var$vl;
    } catch (a) {}
}
$9b5c2f7437668c86$export$ae55be85d98224ed = $9b5c2f7437668c86$var$sl;
$9b5c2f7437668c86$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$9b5c2f7437668c86$var$nl(b)) throw Error($9b5c2f7437668c86$var$p(200));
    return $9b5c2f7437668c86$var$cl(a, b, null, c);
};
$9b5c2f7437668c86$export$882461b6382ed46c = function(a, b) {
    if (!$9b5c2f7437668c86$var$nl(a)) throw Error($9b5c2f7437668c86$var$p(299));
    var c = !1, d = "", e = $9b5c2f7437668c86$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $9b5c2f7437668c86$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$9b5c2f7437668c86$var$uf] = b.current;
    $9b5c2f7437668c86$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $9b5c2f7437668c86$var$ll(b);
};
$9b5c2f7437668c86$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($9b5c2f7437668c86$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($9b5c2f7437668c86$var$p(268, a));
    }
    a = $9b5c2f7437668c86$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$9b5c2f7437668c86$export$cd75ccfd720a3cd4 = function(a) {
    return $9b5c2f7437668c86$var$Rk(a);
};
$9b5c2f7437668c86$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$9b5c2f7437668c86$var$ol(b)) throw Error($9b5c2f7437668c86$var$p(200));
    return $9b5c2f7437668c86$var$rl(null, a, b, !0, c);
};
$9b5c2f7437668c86$export$757ceba2d55c277e = function(a, b, c) {
    if (!$9b5c2f7437668c86$var$nl(a)) throw Error($9b5c2f7437668c86$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $9b5c2f7437668c86$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $9b5c2f7437668c86$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$9b5c2f7437668c86$var$uf] = b.current;
    $9b5c2f7437668c86$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $9b5c2f7437668c86$var$ml(b);
};
$9b5c2f7437668c86$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$9b5c2f7437668c86$var$ol(b)) throw Error($9b5c2f7437668c86$var$p(200));
    return $9b5c2f7437668c86$var$rl(null, a, b, !1, c);
};
$9b5c2f7437668c86$export$502457920280e6be = function(a) {
    if (!$9b5c2f7437668c86$var$ol(a)) throw Error($9b5c2f7437668c86$var$p(40));
    return a._reactRootContainer ? ($9b5c2f7437668c86$var$Rk(function() {
        $9b5c2f7437668c86$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$9b5c2f7437668c86$var$uf] = null;
        });
    }), !0) : !1;
};
$9b5c2f7437668c86$export$c78a37762a8d58e1 = $9b5c2f7437668c86$var$Qk;
$9b5c2f7437668c86$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$9b5c2f7437668c86$var$ol(c)) throw Error($9b5c2f7437668c86$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($9b5c2f7437668c86$var$p(38));
    return $9b5c2f7437668c86$var$rl(a, b, c, !1, d);
};
$9b5c2f7437668c86$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("7hIah", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aJcAz"));

});
parcelRegister("aJcAz", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $7cf7df3d4706ad67$export$c4744153514ff05d; }, function (v) { return $7cf7df3d4706ad67$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $7cf7df3d4706ad67$export$3e506c1ccc9cc1a7; }, function (v) { return $7cf7df3d4706ad67$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $7cf7df3d4706ad67$export$e26fe2ed2fa76875; }, function (v) { return $7cf7df3d4706ad67$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $7cf7df3d4706ad67$export$502329bbf4b505b1; }, function (v) { return $7cf7df3d4706ad67$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $7cf7df3d4706ad67$export$6e3807111c4874c4; }, function (v) { return $7cf7df3d4706ad67$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $7cf7df3d4706ad67$export$c27134553091fb3a; }, function (v) { return $7cf7df3d4706ad67$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $7cf7df3d4706ad67$export$33ee1acdc04fd2a2; }, function (v) { return $7cf7df3d4706ad67$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $7cf7df3d4706ad67$export$b00a404bbd5edef2; }, function (v) { return $7cf7df3d4706ad67$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $7cf7df3d4706ad67$export$8352ce38b91d0c62; }, function (v) { return $7cf7df3d4706ad67$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $7cf7df3d4706ad67$export$d66a1c1c77bd778b; }, function (v) { return $7cf7df3d4706ad67$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $7cf7df3d4706ad67$export$d3dfb8e4810cb555; }, function (v) { return $7cf7df3d4706ad67$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $7cf7df3d4706ad67$export$839f9183b0465a69; }, function (v) { return $7cf7df3d4706ad67$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $7cf7df3d4706ad67$export$72fdf0e06517287b; }, function (v) { return $7cf7df3d4706ad67$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $7cf7df3d4706ad67$export$4b844e58a3e414b4; }, function (v) { return $7cf7df3d4706ad67$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $7cf7df3d4706ad67$export$816d2913ae6b83b1; }, function (v) { return $7cf7df3d4706ad67$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $7cf7df3d4706ad67$export$61bcfe829111a1d0; }, function (v) { return $7cf7df3d4706ad67$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $7cf7df3d4706ad67$export$7ee8c9beb337bc3f; }, function (v) { return $7cf7df3d4706ad67$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $7cf7df3d4706ad67$export$b5836b71941fa3ed; }, function (v) { return $7cf7df3d4706ad67$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $7cf7df3d4706ad67$export$cf845f2c119da08a; }, function (v) { return $7cf7df3d4706ad67$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7cf7df3d4706ad67$export$c4744153514ff05d;
var $7cf7df3d4706ad67$export$3e506c1ccc9cc1a7;
var $7cf7df3d4706ad67$export$e26fe2ed2fa76875;
var $7cf7df3d4706ad67$export$502329bbf4b505b1;
var $7cf7df3d4706ad67$export$6e3807111c4874c4;
var $7cf7df3d4706ad67$export$c27134553091fb3a;
var $7cf7df3d4706ad67$export$33ee1acdc04fd2a2;
var $7cf7df3d4706ad67$export$b00a404bbd5edef2;
var $7cf7df3d4706ad67$export$8352ce38b91d0c62;
var $7cf7df3d4706ad67$export$d66a1c1c77bd778b;
var $7cf7df3d4706ad67$export$d3dfb8e4810cb555;
var $7cf7df3d4706ad67$export$839f9183b0465a69;
var $7cf7df3d4706ad67$export$72fdf0e06517287b;
var $7cf7df3d4706ad67$export$4b844e58a3e414b4;
var $7cf7df3d4706ad67$export$816d2913ae6b83b1;
var $7cf7df3d4706ad67$export$61bcfe829111a1d0;
var $7cf7df3d4706ad67$export$7ee8c9beb337bc3f;
var $7cf7df3d4706ad67$export$b5836b71941fa3ed;
var $7cf7df3d4706ad67$export$cf845f2c119da08a;
'use strict';
function $7cf7df3d4706ad67$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $7cf7df3d4706ad67$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $7cf7df3d4706ad67$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $7cf7df3d4706ad67$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $7cf7df3d4706ad67$var$g(C, c)) n < e && 0 > $7cf7df3d4706ad67$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $7cf7df3d4706ad67$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $7cf7df3d4706ad67$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $7cf7df3d4706ad67$var$l = performance;
    $7cf7df3d4706ad67$export$c4744153514ff05d = function() {
        return $7cf7df3d4706ad67$var$l.now();
    };
} else {
    var $7cf7df3d4706ad67$var$p = Date, $7cf7df3d4706ad67$var$q = $7cf7df3d4706ad67$var$p.now();
    $7cf7df3d4706ad67$export$c4744153514ff05d = function() {
        return $7cf7df3d4706ad67$var$p.now() - $7cf7df3d4706ad67$var$q;
    };
}
var $7cf7df3d4706ad67$var$r = [], $7cf7df3d4706ad67$var$t = [], $7cf7df3d4706ad67$var$u = 1, $7cf7df3d4706ad67$var$v = null, $7cf7df3d4706ad67$var$y = 3, $7cf7df3d4706ad67$var$z = !1, $7cf7df3d4706ad67$var$A = !1, $7cf7df3d4706ad67$var$B = !1, $7cf7df3d4706ad67$var$D = "function" === typeof setTimeout ? setTimeout : null, $7cf7df3d4706ad67$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $7cf7df3d4706ad67$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $7cf7df3d4706ad67$var$G(a) {
    for(var b = $7cf7df3d4706ad67$var$h($7cf7df3d4706ad67$var$t); null !== b;){
        if (null === b.callback) $7cf7df3d4706ad67$var$k($7cf7df3d4706ad67$var$t);
        else if (b.startTime <= a) $7cf7df3d4706ad67$var$k($7cf7df3d4706ad67$var$t), b.sortIndex = b.expirationTime, $7cf7df3d4706ad67$var$f($7cf7df3d4706ad67$var$r, b);
        else break;
        b = $7cf7df3d4706ad67$var$h($7cf7df3d4706ad67$var$t);
    }
}
function $7cf7df3d4706ad67$var$H(a) {
    $7cf7df3d4706ad67$var$B = !1;
    $7cf7df3d4706ad67$var$G(a);
    if (!$7cf7df3d4706ad67$var$A) {
        if (null !== $7cf7df3d4706ad67$var$h($7cf7df3d4706ad67$var$r)) $7cf7df3d4706ad67$var$A = !0, $7cf7df3d4706ad67$var$I($7cf7df3d4706ad67$var$J);
        else {
            var b = $7cf7df3d4706ad67$var$h($7cf7df3d4706ad67$var$t);
            null !== b && $7cf7df3d4706ad67$var$K($7cf7df3d4706ad67$var$H, b.startTime - a);
        }
    }
}
function $7cf7df3d4706ad67$var$J(a, b) {
    $7cf7df3d4706ad67$var$A = !1;
    $7cf7df3d4706ad67$var$B && ($7cf7df3d4706ad67$var$B = !1, $7cf7df3d4706ad67$var$E($7cf7df3d4706ad67$var$L), $7cf7df3d4706ad67$var$L = -1);
    $7cf7df3d4706ad67$var$z = !0;
    var c = $7cf7df3d4706ad67$var$y;
    try {
        $7cf7df3d4706ad67$var$G(b);
        for($7cf7df3d4706ad67$var$v = $7cf7df3d4706ad67$var$h($7cf7df3d4706ad67$var$r); null !== $7cf7df3d4706ad67$var$v && (!($7cf7df3d4706ad67$var$v.expirationTime > b) || a && !$7cf7df3d4706ad67$var$M());){
            var d = $7cf7df3d4706ad67$var$v.callback;
            if ("function" === typeof d) {
                $7cf7df3d4706ad67$var$v.callback = null;
                $7cf7df3d4706ad67$var$y = $7cf7df3d4706ad67$var$v.priorityLevel;
                var e = d($7cf7df3d4706ad67$var$v.expirationTime <= b);
                b = $7cf7df3d4706ad67$export$c4744153514ff05d();
                "function" === typeof e ? $7cf7df3d4706ad67$var$v.callback = e : $7cf7df3d4706ad67$var$v === $7cf7df3d4706ad67$var$h($7cf7df3d4706ad67$var$r) && $7cf7df3d4706ad67$var$k($7cf7df3d4706ad67$var$r);
                $7cf7df3d4706ad67$var$G(b);
            } else $7cf7df3d4706ad67$var$k($7cf7df3d4706ad67$var$r);
            $7cf7df3d4706ad67$var$v = $7cf7df3d4706ad67$var$h($7cf7df3d4706ad67$var$r);
        }
        if (null !== $7cf7df3d4706ad67$var$v) var w = !0;
        else {
            var m = $7cf7df3d4706ad67$var$h($7cf7df3d4706ad67$var$t);
            null !== m && $7cf7df3d4706ad67$var$K($7cf7df3d4706ad67$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $7cf7df3d4706ad67$var$v = null, $7cf7df3d4706ad67$var$y = c, $7cf7df3d4706ad67$var$z = !1;
    }
}
var $7cf7df3d4706ad67$var$N = !1, $7cf7df3d4706ad67$var$O = null, $7cf7df3d4706ad67$var$L = -1, $7cf7df3d4706ad67$var$P = 5, $7cf7df3d4706ad67$var$Q = -1;
function $7cf7df3d4706ad67$var$M() {
    return $7cf7df3d4706ad67$export$c4744153514ff05d() - $7cf7df3d4706ad67$var$Q < $7cf7df3d4706ad67$var$P ? !1 : !0;
}
function $7cf7df3d4706ad67$var$R() {
    if (null !== $7cf7df3d4706ad67$var$O) {
        var a = $7cf7df3d4706ad67$export$c4744153514ff05d();
        $7cf7df3d4706ad67$var$Q = a;
        var b = !0;
        try {
            b = $7cf7df3d4706ad67$var$O(!0, a);
        } finally{
            b ? $7cf7df3d4706ad67$var$S() : ($7cf7df3d4706ad67$var$N = !1, $7cf7df3d4706ad67$var$O = null);
        }
    } else $7cf7df3d4706ad67$var$N = !1;
}
var $7cf7df3d4706ad67$var$S;
if ("function" === typeof $7cf7df3d4706ad67$var$F) $7cf7df3d4706ad67$var$S = function() {
    $7cf7df3d4706ad67$var$F($7cf7df3d4706ad67$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $7cf7df3d4706ad67$var$T = new MessageChannel, $7cf7df3d4706ad67$var$U = $7cf7df3d4706ad67$var$T.port2;
    $7cf7df3d4706ad67$var$T.port1.onmessage = $7cf7df3d4706ad67$var$R;
    $7cf7df3d4706ad67$var$S = function() {
        $7cf7df3d4706ad67$var$U.postMessage(null);
    };
} else $7cf7df3d4706ad67$var$S = function() {
    $7cf7df3d4706ad67$var$D($7cf7df3d4706ad67$var$R, 0);
};
function $7cf7df3d4706ad67$var$I(a) {
    $7cf7df3d4706ad67$var$O = a;
    $7cf7df3d4706ad67$var$N || ($7cf7df3d4706ad67$var$N = !0, $7cf7df3d4706ad67$var$S());
}
function $7cf7df3d4706ad67$var$K(a, b) {
    $7cf7df3d4706ad67$var$L = $7cf7df3d4706ad67$var$D(function() {
        a($7cf7df3d4706ad67$export$c4744153514ff05d());
    }, b);
}
$7cf7df3d4706ad67$export$3e506c1ccc9cc1a7 = 5;
$7cf7df3d4706ad67$export$e26fe2ed2fa76875 = 1;
$7cf7df3d4706ad67$export$502329bbf4b505b1 = 4;
$7cf7df3d4706ad67$export$6e3807111c4874c4 = 3;
$7cf7df3d4706ad67$export$c27134553091fb3a = null;
$7cf7df3d4706ad67$export$33ee1acdc04fd2a2 = 2;
$7cf7df3d4706ad67$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$7cf7df3d4706ad67$export$8352ce38b91d0c62 = function() {
    $7cf7df3d4706ad67$var$A || $7cf7df3d4706ad67$var$z || ($7cf7df3d4706ad67$var$A = !0, $7cf7df3d4706ad67$var$I($7cf7df3d4706ad67$var$J));
};
$7cf7df3d4706ad67$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $7cf7df3d4706ad67$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$7cf7df3d4706ad67$export$d3dfb8e4810cb555 = function() {
    return $7cf7df3d4706ad67$var$y;
};
$7cf7df3d4706ad67$export$839f9183b0465a69 = function() {
    return $7cf7df3d4706ad67$var$h($7cf7df3d4706ad67$var$r);
};
$7cf7df3d4706ad67$export$72fdf0e06517287b = function(a) {
    switch($7cf7df3d4706ad67$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $7cf7df3d4706ad67$var$y;
    }
    var c = $7cf7df3d4706ad67$var$y;
    $7cf7df3d4706ad67$var$y = b;
    try {
        return a();
    } finally{
        $7cf7df3d4706ad67$var$y = c;
    }
};
$7cf7df3d4706ad67$export$4b844e58a3e414b4 = function() {};
$7cf7df3d4706ad67$export$816d2913ae6b83b1 = function() {};
$7cf7df3d4706ad67$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $7cf7df3d4706ad67$var$y;
    $7cf7df3d4706ad67$var$y = a;
    try {
        return b();
    } finally{
        $7cf7df3d4706ad67$var$y = c;
    }
};
$7cf7df3d4706ad67$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $7cf7df3d4706ad67$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $7cf7df3d4706ad67$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $7cf7df3d4706ad67$var$f($7cf7df3d4706ad67$var$t, a), null === $7cf7df3d4706ad67$var$h($7cf7df3d4706ad67$var$r) && a === $7cf7df3d4706ad67$var$h($7cf7df3d4706ad67$var$t) && ($7cf7df3d4706ad67$var$B ? ($7cf7df3d4706ad67$var$E($7cf7df3d4706ad67$var$L), $7cf7df3d4706ad67$var$L = -1) : $7cf7df3d4706ad67$var$B = !0, $7cf7df3d4706ad67$var$K($7cf7df3d4706ad67$var$H, c - d))) : (a.sortIndex = e, $7cf7df3d4706ad67$var$f($7cf7df3d4706ad67$var$r, a), $7cf7df3d4706ad67$var$A || $7cf7df3d4706ad67$var$z || ($7cf7df3d4706ad67$var$A = !0, $7cf7df3d4706ad67$var$I($7cf7df3d4706ad67$var$J)));
    return a;
};
$7cf7df3d4706ad67$export$b5836b71941fa3ed = $7cf7df3d4706ad67$var$M;
$7cf7df3d4706ad67$export$cf845f2c119da08a = function(a) {
    var b = $7cf7df3d4706ad67$var$y;
    return function() {
        var c = $7cf7df3d4706ad67$var$y;
        $7cf7df3d4706ad67$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $7cf7df3d4706ad67$var$y = c;
        }
    };
};

});




parcelRegister("5BT2W", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cwktB"));

});
parcelRegister("cwktB", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $91d85b69236f8a99$export$306c0aa65ff9ec16; }, function (v) { return $91d85b69236f8a99$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $91d85b69236f8a99$export$306c0aa65ff9ec16;
"use strict";

var $dNMDr = parcelRequire("dNMDr");
function $91d85b69236f8a99$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $91d85b69236f8a99$var$objectIs = "function" === typeof Object.is ? Object.is : $91d85b69236f8a99$var$is, $91d85b69236f8a99$var$useState = $dNMDr.useState, $91d85b69236f8a99$var$useEffect = $dNMDr.useEffect, $91d85b69236f8a99$var$useLayoutEffect = $dNMDr.useLayoutEffect, $91d85b69236f8a99$var$useDebugValue = $dNMDr.useDebugValue;
function $91d85b69236f8a99$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $91d85b69236f8a99$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $91d85b69236f8a99$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $91d85b69236f8a99$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $91d85b69236f8a99$var$useEffect(function() {
        $91d85b69236f8a99$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $91d85b69236f8a99$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $91d85b69236f8a99$var$useDebugValue(value);
    return value;
}
function $91d85b69236f8a99$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$91d85b69236f8a99$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $91d85b69236f8a99$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $91d85b69236f8a99$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $91d85b69236f8a99$var$useSyncExternalStore$1 : $91d85b69236f8a99$var$useSyncExternalStore$2;
$91d85b69236f8a99$export$306c0aa65ff9ec16 = void 0 !== $dNMDr.useSyncExternalStore ? $dNMDr.useSyncExternalStore : $91d85b69236f8a99$var$shim;

});


parcelRegister("ebwKZ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $a53b809df8aaa5c2$export$bf730a2d8bf68b42; }, function (v) { return $a53b809df8aaa5c2$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a53b809df8aaa5c2$export$bf730a2d8bf68b42;
"use strict";

var $dNMDr = parcelRequire("dNMDr");

var $5BT2W = parcelRequire("5BT2W");
function $a53b809df8aaa5c2$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $a53b809df8aaa5c2$var$objectIs = "function" === typeof Object.is ? Object.is : $a53b809df8aaa5c2$var$is, $a53b809df8aaa5c2$var$useSyncExternalStore = $5BT2W.useSyncExternalStore, $a53b809df8aaa5c2$var$useRef = $dNMDr.useRef, $a53b809df8aaa5c2$var$useEffect = $dNMDr.useEffect, $a53b809df8aaa5c2$var$useMemo = $dNMDr.useMemo, $a53b809df8aaa5c2$var$useDebugValue = $dNMDr.useDebugValue;
$a53b809df8aaa5c2$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $a53b809df8aaa5c2$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $a53b809df8aaa5c2$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($a53b809df8aaa5c2$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $a53b809df8aaa5c2$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $a53b809df8aaa5c2$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $a53b809df8aaa5c2$var$useDebugValue(value);
    return value;
};

});

parcelRegister("bZyr5", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $8bb01a7622cbd4ee$export$2b8d127b894957b9; }, function (v) { return $8bb01a7622cbd4ee$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $8bb01a7622cbd4ee$export$cea3a54a6425200c; }, function (v) { return $8bb01a7622cbd4ee$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $8bb01a7622cbd4ee$export$a7c73072b1a182ae; }, function (v) { return $8bb01a7622cbd4ee$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $8bb01a7622cbd4ee$export$9f27bc3417b4524d; }, function (v) { return $8bb01a7622cbd4ee$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $8bb01a7622cbd4ee$export$db77ccec0bb4ccac; }, function (v) { return $8bb01a7622cbd4ee$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $8bb01a7622cbd4ee$export$8392c0c9d3dcbd35; }, function (v) { return $8bb01a7622cbd4ee$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8bb01a7622cbd4ee$export$ffb0004e005737fa; }, function (v) { return $8bb01a7622cbd4ee$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $8bb01a7622cbd4ee$export$b624eff549462981; }, function (v) { return $8bb01a7622cbd4ee$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $8bb01a7622cbd4ee$export$7897aa7841a5380c; }, function (v) { return $8bb01a7622cbd4ee$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $8bb01a7622cbd4ee$export$602eac185826482c; }, function (v) { return $8bb01a7622cbd4ee$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $8bb01a7622cbd4ee$export$e2c29f18771995cb; }, function (v) { return $8bb01a7622cbd4ee$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8bb01a7622cbd4ee$export$5f8d39834fd61797; }, function (v) { return $8bb01a7622cbd4ee$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8bb01a7622cbd4ee$export$74bf444e3cd11ea5; }, function (v) { return $8bb01a7622cbd4ee$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $8bb01a7622cbd4ee$export$92387174baf9b227; }, function (v) { return $8bb01a7622cbd4ee$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $8bb01a7622cbd4ee$export$ec112efeb987d9c6; }, function (v) { return $8bb01a7622cbd4ee$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $8bb01a7622cbd4ee$export$b706b080d889d2c9; }, function (v) { return $8bb01a7622cbd4ee$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $8bb01a7622cbd4ee$export$5be5a87408f70ddc; }, function (v) { return $8bb01a7622cbd4ee$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $8bb01a7622cbd4ee$export$45a5e7f76e0caa8d; }, function (v) { return $8bb01a7622cbd4ee$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $8bb01a7622cbd4ee$export$455c2e768291efa6; }, function (v) { return $8bb01a7622cbd4ee$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $8bb01a7622cbd4ee$export$9522e17588c12572; }, function (v) { return $8bb01a7622cbd4ee$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $8bb01a7622cbd4ee$export$2110ac352bb060b9; }, function (v) { return $8bb01a7622cbd4ee$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $8bb01a7622cbd4ee$export$56885ab8b9c456ab; }, function (v) { return $8bb01a7622cbd4ee$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $8bb01a7622cbd4ee$export$d927fcb6adf8f9de; }, function (v) { return $8bb01a7622cbd4ee$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $8bb01a7622cbd4ee$export$b82d16f27459e05a; }, function (v) { return $8bb01a7622cbd4ee$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $8bb01a7622cbd4ee$export$522c17b4f5e123e8; }, function (v) { return $8bb01a7622cbd4ee$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $8bb01a7622cbd4ee$export$1aabd8a0274ecfd6; }, function (v) { return $8bb01a7622cbd4ee$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $8bb01a7622cbd4ee$export$9b621391a187a31a; }, function (v) { return $8bb01a7622cbd4ee$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $8bb01a7622cbd4ee$export$f5bbd400c2f4426f; }, function (v) { return $8bb01a7622cbd4ee$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8bb01a7622cbd4ee$export$2b8d127b894957b9;
var $8bb01a7622cbd4ee$export$cea3a54a6425200c;
var $8bb01a7622cbd4ee$export$a7c73072b1a182ae;
var $8bb01a7622cbd4ee$export$9f27bc3417b4524d;
var $8bb01a7622cbd4ee$export$db77ccec0bb4ccac;
var $8bb01a7622cbd4ee$export$8392c0c9d3dcbd35;
var $8bb01a7622cbd4ee$export$ffb0004e005737fa;
var $8bb01a7622cbd4ee$export$b624eff549462981;
var $8bb01a7622cbd4ee$export$7897aa7841a5380c;
var $8bb01a7622cbd4ee$export$602eac185826482c;
var $8bb01a7622cbd4ee$export$e2c29f18771995cb;
var $8bb01a7622cbd4ee$export$5f8d39834fd61797;
var $8bb01a7622cbd4ee$export$74bf444e3cd11ea5;
var $8bb01a7622cbd4ee$export$92387174baf9b227;
var $8bb01a7622cbd4ee$export$ec112efeb987d9c6;
var $8bb01a7622cbd4ee$export$b706b080d889d2c9;
var $8bb01a7622cbd4ee$export$5be5a87408f70ddc;
var $8bb01a7622cbd4ee$export$45a5e7f76e0caa8d;
var $8bb01a7622cbd4ee$export$455c2e768291efa6;
var $8bb01a7622cbd4ee$export$9522e17588c12572;
var $8bb01a7622cbd4ee$export$2110ac352bb060b9;
var $8bb01a7622cbd4ee$export$56885ab8b9c456ab;
var $8bb01a7622cbd4ee$export$d927fcb6adf8f9de;
var $8bb01a7622cbd4ee$export$b82d16f27459e05a;
var $8bb01a7622cbd4ee$export$522c17b4f5e123e8;
var $8bb01a7622cbd4ee$export$1aabd8a0274ecfd6;
var $8bb01a7622cbd4ee$export$9b621391a187a31a;
var $8bb01a7622cbd4ee$export$f5bbd400c2f4426f;
'use strict';
var $8bb01a7622cbd4ee$var$b = "function" === typeof Symbol && Symbol.for, $8bb01a7622cbd4ee$var$c = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.element") : 60103, $8bb01a7622cbd4ee$var$d = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.portal") : 60106, $8bb01a7622cbd4ee$var$e = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.fragment") : 60107, $8bb01a7622cbd4ee$var$f = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.strict_mode") : 60108, $8bb01a7622cbd4ee$var$g = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.profiler") : 60114, $8bb01a7622cbd4ee$var$h = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.provider") : 60109, $8bb01a7622cbd4ee$var$k = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.context") : 60110, $8bb01a7622cbd4ee$var$l = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.async_mode") : 60111, $8bb01a7622cbd4ee$var$m = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.concurrent_mode") : 60111, $8bb01a7622cbd4ee$var$n = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.forward_ref") : 60112, $8bb01a7622cbd4ee$var$p = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.suspense") : 60113, $8bb01a7622cbd4ee$var$q = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.suspense_list") : 60120, $8bb01a7622cbd4ee$var$r = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.memo") : 60115, $8bb01a7622cbd4ee$var$t = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.lazy") : 60116, $8bb01a7622cbd4ee$var$v = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.block") : 60121, $8bb01a7622cbd4ee$var$w = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.fundamental") : 60117, $8bb01a7622cbd4ee$var$x = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.responder") : 60118, $8bb01a7622cbd4ee$var$y = $8bb01a7622cbd4ee$var$b ? Symbol.for("react.scope") : 60119;
function $8bb01a7622cbd4ee$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $8bb01a7622cbd4ee$var$c:
                switch(a = a.type, a){
                    case $8bb01a7622cbd4ee$var$l:
                    case $8bb01a7622cbd4ee$var$m:
                    case $8bb01a7622cbd4ee$var$e:
                    case $8bb01a7622cbd4ee$var$g:
                    case $8bb01a7622cbd4ee$var$f:
                    case $8bb01a7622cbd4ee$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8bb01a7622cbd4ee$var$k:
                            case $8bb01a7622cbd4ee$var$n:
                            case $8bb01a7622cbd4ee$var$t:
                            case $8bb01a7622cbd4ee$var$r:
                            case $8bb01a7622cbd4ee$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $8bb01a7622cbd4ee$var$d:
                return u;
        }
    }
}
function $8bb01a7622cbd4ee$var$A(a) {
    return $8bb01a7622cbd4ee$var$z(a) === $8bb01a7622cbd4ee$var$m;
}
$8bb01a7622cbd4ee$export$2b8d127b894957b9 = $8bb01a7622cbd4ee$var$l;
$8bb01a7622cbd4ee$export$cea3a54a6425200c = $8bb01a7622cbd4ee$var$m;
$8bb01a7622cbd4ee$export$a7c73072b1a182ae = $8bb01a7622cbd4ee$var$k;
$8bb01a7622cbd4ee$export$9f27bc3417b4524d = $8bb01a7622cbd4ee$var$h;
$8bb01a7622cbd4ee$export$db77ccec0bb4ccac = $8bb01a7622cbd4ee$var$c;
$8bb01a7622cbd4ee$export$8392c0c9d3dcbd35 = $8bb01a7622cbd4ee$var$n;
$8bb01a7622cbd4ee$export$ffb0004e005737fa = $8bb01a7622cbd4ee$var$e;
$8bb01a7622cbd4ee$export$b624eff549462981 = $8bb01a7622cbd4ee$var$t;
$8bb01a7622cbd4ee$export$7897aa7841a5380c = $8bb01a7622cbd4ee$var$r;
$8bb01a7622cbd4ee$export$602eac185826482c = $8bb01a7622cbd4ee$var$d;
$8bb01a7622cbd4ee$export$e2c29f18771995cb = $8bb01a7622cbd4ee$var$g;
$8bb01a7622cbd4ee$export$5f8d39834fd61797 = $8bb01a7622cbd4ee$var$f;
$8bb01a7622cbd4ee$export$74bf444e3cd11ea5 = $8bb01a7622cbd4ee$var$p;
$8bb01a7622cbd4ee$export$92387174baf9b227 = function(a) {
    return $8bb01a7622cbd4ee$var$A(a) || $8bb01a7622cbd4ee$var$z(a) === $8bb01a7622cbd4ee$var$l;
};
$8bb01a7622cbd4ee$export$ec112efeb987d9c6 = $8bb01a7622cbd4ee$var$A;
$8bb01a7622cbd4ee$export$b706b080d889d2c9 = function(a) {
    return $8bb01a7622cbd4ee$var$z(a) === $8bb01a7622cbd4ee$var$k;
};
$8bb01a7622cbd4ee$export$5be5a87408f70ddc = function(a) {
    return $8bb01a7622cbd4ee$var$z(a) === $8bb01a7622cbd4ee$var$h;
};
$8bb01a7622cbd4ee$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8bb01a7622cbd4ee$var$c;
};
$8bb01a7622cbd4ee$export$455c2e768291efa6 = function(a) {
    return $8bb01a7622cbd4ee$var$z(a) === $8bb01a7622cbd4ee$var$n;
};
$8bb01a7622cbd4ee$export$9522e17588c12572 = function(a) {
    return $8bb01a7622cbd4ee$var$z(a) === $8bb01a7622cbd4ee$var$e;
};
$8bb01a7622cbd4ee$export$2110ac352bb060b9 = function(a) {
    return $8bb01a7622cbd4ee$var$z(a) === $8bb01a7622cbd4ee$var$t;
};
$8bb01a7622cbd4ee$export$56885ab8b9c456ab = function(a) {
    return $8bb01a7622cbd4ee$var$z(a) === $8bb01a7622cbd4ee$var$r;
};
$8bb01a7622cbd4ee$export$d927fcb6adf8f9de = function(a) {
    return $8bb01a7622cbd4ee$var$z(a) === $8bb01a7622cbd4ee$var$d;
};
$8bb01a7622cbd4ee$export$b82d16f27459e05a = function(a) {
    return $8bb01a7622cbd4ee$var$z(a) === $8bb01a7622cbd4ee$var$g;
};
$8bb01a7622cbd4ee$export$522c17b4f5e123e8 = function(a) {
    return $8bb01a7622cbd4ee$var$z(a) === $8bb01a7622cbd4ee$var$f;
};
$8bb01a7622cbd4ee$export$1aabd8a0274ecfd6 = function(a) {
    return $8bb01a7622cbd4ee$var$z(a) === $8bb01a7622cbd4ee$var$p;
};
$8bb01a7622cbd4ee$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8bb01a7622cbd4ee$var$e || a === $8bb01a7622cbd4ee$var$m || a === $8bb01a7622cbd4ee$var$g || a === $8bb01a7622cbd4ee$var$f || a === $8bb01a7622cbd4ee$var$p || a === $8bb01a7622cbd4ee$var$q || "object" === typeof a && null !== a && (a.$$typeof === $8bb01a7622cbd4ee$var$t || a.$$typeof === $8bb01a7622cbd4ee$var$r || a.$$typeof === $8bb01a7622cbd4ee$var$h || a.$$typeof === $8bb01a7622cbd4ee$var$k || a.$$typeof === $8bb01a7622cbd4ee$var$n || a.$$typeof === $8bb01a7622cbd4ee$var$w || a.$$typeof === $8bb01a7622cbd4ee$var$x || a.$$typeof === $8bb01a7622cbd4ee$var$y || a.$$typeof === $8bb01a7622cbd4ee$var$v);
};
$8bb01a7622cbd4ee$export$f5bbd400c2f4426f = $8bb01a7622cbd4ee$var$z;

});

parcelRegister("6JeVJ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $4e6286de1ef8d6d6$export$a7c73072b1a182ae; }, function (v) { return $4e6286de1ef8d6d6$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $4e6286de1ef8d6d6$export$9f27bc3417b4524d; }, function (v) { return $4e6286de1ef8d6d6$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $4e6286de1ef8d6d6$export$db77ccec0bb4ccac; }, function (v) { return $4e6286de1ef8d6d6$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $4e6286de1ef8d6d6$export$8392c0c9d3dcbd35; }, function (v) { return $4e6286de1ef8d6d6$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $4e6286de1ef8d6d6$export$ffb0004e005737fa; }, function (v) { return $4e6286de1ef8d6d6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $4e6286de1ef8d6d6$export$b624eff549462981; }, function (v) { return $4e6286de1ef8d6d6$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $4e6286de1ef8d6d6$export$7897aa7841a5380c; }, function (v) { return $4e6286de1ef8d6d6$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $4e6286de1ef8d6d6$export$602eac185826482c; }, function (v) { return $4e6286de1ef8d6d6$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $4e6286de1ef8d6d6$export$e2c29f18771995cb; }, function (v) { return $4e6286de1ef8d6d6$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $4e6286de1ef8d6d6$export$5f8d39834fd61797; }, function (v) { return $4e6286de1ef8d6d6$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $4e6286de1ef8d6d6$export$74bf444e3cd11ea5; }, function (v) { return $4e6286de1ef8d6d6$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $4e6286de1ef8d6d6$export$998bcd577473dd93; }, function (v) { return $4e6286de1ef8d6d6$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $4e6286de1ef8d6d6$export$92387174baf9b227; }, function (v) { return $4e6286de1ef8d6d6$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $4e6286de1ef8d6d6$export$ec112efeb987d9c6; }, function (v) { return $4e6286de1ef8d6d6$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $4e6286de1ef8d6d6$export$b706b080d889d2c9; }, function (v) { return $4e6286de1ef8d6d6$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $4e6286de1ef8d6d6$export$5be5a87408f70ddc; }, function (v) { return $4e6286de1ef8d6d6$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $4e6286de1ef8d6d6$export$45a5e7f76e0caa8d; }, function (v) { return $4e6286de1ef8d6d6$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $4e6286de1ef8d6d6$export$455c2e768291efa6; }, function (v) { return $4e6286de1ef8d6d6$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $4e6286de1ef8d6d6$export$9522e17588c12572; }, function (v) { return $4e6286de1ef8d6d6$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $4e6286de1ef8d6d6$export$2110ac352bb060b9; }, function (v) { return $4e6286de1ef8d6d6$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $4e6286de1ef8d6d6$export$56885ab8b9c456ab; }, function (v) { return $4e6286de1ef8d6d6$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $4e6286de1ef8d6d6$export$d927fcb6adf8f9de; }, function (v) { return $4e6286de1ef8d6d6$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $4e6286de1ef8d6d6$export$b82d16f27459e05a; }, function (v) { return $4e6286de1ef8d6d6$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $4e6286de1ef8d6d6$export$522c17b4f5e123e8; }, function (v) { return $4e6286de1ef8d6d6$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $4e6286de1ef8d6d6$export$1aabd8a0274ecfd6; }, function (v) { return $4e6286de1ef8d6d6$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $4e6286de1ef8d6d6$export$3d6c20d97e46b957; }, function (v) { return $4e6286de1ef8d6d6$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $4e6286de1ef8d6d6$export$9b621391a187a31a; }, function (v) { return $4e6286de1ef8d6d6$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $4e6286de1ef8d6d6$export$f5bbd400c2f4426f; }, function (v) { return $4e6286de1ef8d6d6$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4e6286de1ef8d6d6$export$a7c73072b1a182ae;
var $4e6286de1ef8d6d6$export$9f27bc3417b4524d;
var $4e6286de1ef8d6d6$export$db77ccec0bb4ccac;
var $4e6286de1ef8d6d6$export$8392c0c9d3dcbd35;
var $4e6286de1ef8d6d6$export$ffb0004e005737fa;
var $4e6286de1ef8d6d6$export$b624eff549462981;
var $4e6286de1ef8d6d6$export$7897aa7841a5380c;
var $4e6286de1ef8d6d6$export$602eac185826482c;
var $4e6286de1ef8d6d6$export$e2c29f18771995cb;
var $4e6286de1ef8d6d6$export$5f8d39834fd61797;
var $4e6286de1ef8d6d6$export$74bf444e3cd11ea5;
var $4e6286de1ef8d6d6$export$998bcd577473dd93;
var $4e6286de1ef8d6d6$export$92387174baf9b227;
var $4e6286de1ef8d6d6$export$ec112efeb987d9c6;
var $4e6286de1ef8d6d6$export$b706b080d889d2c9;
var $4e6286de1ef8d6d6$export$5be5a87408f70ddc;
var $4e6286de1ef8d6d6$export$45a5e7f76e0caa8d;
var $4e6286de1ef8d6d6$export$455c2e768291efa6;
var $4e6286de1ef8d6d6$export$9522e17588c12572;
var $4e6286de1ef8d6d6$export$2110ac352bb060b9;
var $4e6286de1ef8d6d6$export$56885ab8b9c456ab;
var $4e6286de1ef8d6d6$export$d927fcb6adf8f9de;
var $4e6286de1ef8d6d6$export$b82d16f27459e05a;
var $4e6286de1ef8d6d6$export$522c17b4f5e123e8;
var $4e6286de1ef8d6d6$export$1aabd8a0274ecfd6;
var $4e6286de1ef8d6d6$export$3d6c20d97e46b957;
var $4e6286de1ef8d6d6$export$9b621391a187a31a;
var $4e6286de1ef8d6d6$export$f5bbd400c2f4426f;
'use strict';
var $4e6286de1ef8d6d6$var$b = Symbol.for("react.element"), $4e6286de1ef8d6d6$var$c = Symbol.for("react.portal"), $4e6286de1ef8d6d6$var$d = Symbol.for("react.fragment"), $4e6286de1ef8d6d6$var$e = Symbol.for("react.strict_mode"), $4e6286de1ef8d6d6$var$f = Symbol.for("react.profiler"), $4e6286de1ef8d6d6$var$g = Symbol.for("react.provider"), $4e6286de1ef8d6d6$var$h = Symbol.for("react.context"), $4e6286de1ef8d6d6$var$k = Symbol.for("react.server_context"), $4e6286de1ef8d6d6$var$l = Symbol.for("react.forward_ref"), $4e6286de1ef8d6d6$var$m = Symbol.for("react.suspense"), $4e6286de1ef8d6d6$var$n = Symbol.for("react.suspense_list"), $4e6286de1ef8d6d6$var$p = Symbol.for("react.memo"), $4e6286de1ef8d6d6$var$q = Symbol.for("react.lazy"), $4e6286de1ef8d6d6$var$t = Symbol.for("react.offscreen"), $4e6286de1ef8d6d6$var$u;
$4e6286de1ef8d6d6$var$u = Symbol.for("react.module.reference");
function $4e6286de1ef8d6d6$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $4e6286de1ef8d6d6$var$b:
                switch(a = a.type, a){
                    case $4e6286de1ef8d6d6$var$d:
                    case $4e6286de1ef8d6d6$var$f:
                    case $4e6286de1ef8d6d6$var$e:
                    case $4e6286de1ef8d6d6$var$m:
                    case $4e6286de1ef8d6d6$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $4e6286de1ef8d6d6$var$k:
                            case $4e6286de1ef8d6d6$var$h:
                            case $4e6286de1ef8d6d6$var$l:
                            case $4e6286de1ef8d6d6$var$q:
                            case $4e6286de1ef8d6d6$var$p:
                            case $4e6286de1ef8d6d6$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $4e6286de1ef8d6d6$var$c:
                return r;
        }
    }
}
$4e6286de1ef8d6d6$export$a7c73072b1a182ae = $4e6286de1ef8d6d6$var$h;
$4e6286de1ef8d6d6$export$9f27bc3417b4524d = $4e6286de1ef8d6d6$var$g;
$4e6286de1ef8d6d6$export$db77ccec0bb4ccac = $4e6286de1ef8d6d6$var$b;
$4e6286de1ef8d6d6$export$8392c0c9d3dcbd35 = $4e6286de1ef8d6d6$var$l;
$4e6286de1ef8d6d6$export$ffb0004e005737fa = $4e6286de1ef8d6d6$var$d;
$4e6286de1ef8d6d6$export$b624eff549462981 = $4e6286de1ef8d6d6$var$q;
$4e6286de1ef8d6d6$export$7897aa7841a5380c = $4e6286de1ef8d6d6$var$p;
$4e6286de1ef8d6d6$export$602eac185826482c = $4e6286de1ef8d6d6$var$c;
$4e6286de1ef8d6d6$export$e2c29f18771995cb = $4e6286de1ef8d6d6$var$f;
$4e6286de1ef8d6d6$export$5f8d39834fd61797 = $4e6286de1ef8d6d6$var$e;
$4e6286de1ef8d6d6$export$74bf444e3cd11ea5 = $4e6286de1ef8d6d6$var$m;
$4e6286de1ef8d6d6$export$998bcd577473dd93 = $4e6286de1ef8d6d6$var$n;
$4e6286de1ef8d6d6$export$92387174baf9b227 = function() {
    return !1;
};
$4e6286de1ef8d6d6$export$ec112efeb987d9c6 = function() {
    return !1;
};
$4e6286de1ef8d6d6$export$b706b080d889d2c9 = function(a) {
    return $4e6286de1ef8d6d6$var$v(a) === $4e6286de1ef8d6d6$var$h;
};
$4e6286de1ef8d6d6$export$5be5a87408f70ddc = function(a) {
    return $4e6286de1ef8d6d6$var$v(a) === $4e6286de1ef8d6d6$var$g;
};
$4e6286de1ef8d6d6$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4e6286de1ef8d6d6$var$b;
};
$4e6286de1ef8d6d6$export$455c2e768291efa6 = function(a) {
    return $4e6286de1ef8d6d6$var$v(a) === $4e6286de1ef8d6d6$var$l;
};
$4e6286de1ef8d6d6$export$9522e17588c12572 = function(a) {
    return $4e6286de1ef8d6d6$var$v(a) === $4e6286de1ef8d6d6$var$d;
};
$4e6286de1ef8d6d6$export$2110ac352bb060b9 = function(a) {
    return $4e6286de1ef8d6d6$var$v(a) === $4e6286de1ef8d6d6$var$q;
};
$4e6286de1ef8d6d6$export$56885ab8b9c456ab = function(a) {
    return $4e6286de1ef8d6d6$var$v(a) === $4e6286de1ef8d6d6$var$p;
};
$4e6286de1ef8d6d6$export$d927fcb6adf8f9de = function(a) {
    return $4e6286de1ef8d6d6$var$v(a) === $4e6286de1ef8d6d6$var$c;
};
$4e6286de1ef8d6d6$export$b82d16f27459e05a = function(a) {
    return $4e6286de1ef8d6d6$var$v(a) === $4e6286de1ef8d6d6$var$f;
};
$4e6286de1ef8d6d6$export$522c17b4f5e123e8 = function(a) {
    return $4e6286de1ef8d6d6$var$v(a) === $4e6286de1ef8d6d6$var$e;
};
$4e6286de1ef8d6d6$export$1aabd8a0274ecfd6 = function(a) {
    return $4e6286de1ef8d6d6$var$v(a) === $4e6286de1ef8d6d6$var$m;
};
$4e6286de1ef8d6d6$export$3d6c20d97e46b957 = function(a) {
    return $4e6286de1ef8d6d6$var$v(a) === $4e6286de1ef8d6d6$var$n;
};
$4e6286de1ef8d6d6$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $4e6286de1ef8d6d6$var$d || a === $4e6286de1ef8d6d6$var$f || a === $4e6286de1ef8d6d6$var$e || a === $4e6286de1ef8d6d6$var$m || a === $4e6286de1ef8d6d6$var$n || a === $4e6286de1ef8d6d6$var$t || "object" === typeof a && null !== a && (a.$$typeof === $4e6286de1ef8d6d6$var$q || a.$$typeof === $4e6286de1ef8d6d6$var$p || a.$$typeof === $4e6286de1ef8d6d6$var$g || a.$$typeof === $4e6286de1ef8d6d6$var$h || a.$$typeof === $4e6286de1ef8d6d6$var$l || a.$$typeof === $4e6286de1ef8d6d6$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$4e6286de1ef8d6d6$export$f5bbd400c2f4426f = $4e6286de1ef8d6d6$var$v;

});

parcelRegister("3Wc5s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2de02a20b790e653$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $affTb = parcelRequire("affTb");

var $dNMDr = parcelRequire("dNMDr");

var $hMip0 = parcelRequire("hMip0");

var $2Mjap = parcelRequire("2Mjap");

var $bhZXX = parcelRequire("bhZXX");
/**
 * Returns the appropriate circle stroke color.
 */ function $2de02a20b790e653$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $2Mjap.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $2Mjap.N0), ")");
}
var $2de02a20b790e653$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $2de02a20b790e653$var$loadIn = null;
var $2de02a20b790e653$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $2de02a20b790e653$var$useLayoutEffect = typeof window === 'undefined' ? (0, $dNMDr.useEffect) : (0, $dNMDr.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $2de02a20b790e653$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $bhZXX.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $2de02a20b790e653$var$getStrokeColor(appearance);
    var context = (0, $dNMDr.useContext)((0, $hMip0.default));
    $2de02a20b790e653$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $affTb.default)([
            $2de02a20b790e653$var$styles.wrapperStyles,
            $2de02a20b790e653$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $affTb.default)([
            $2de02a20b790e653$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $affTb.default)([
            $2de02a20b790e653$var$styles.circleStyles
        ])
    })));
}));
var $2de02a20b790e653$export$2e2bcd8739ae039 = $2de02a20b790e653$var$Spinner;

});
parcelRegister("affTb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7757a15178589fb1$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $7757a15178589fb1$var$ATOMIC_GROUP_LENGTH = 5;
function $7757a15178589fb1$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $7757a15178589fb1$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("hMip0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf1531b2528ff7c9$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");
var $cf1531b2528ff7c9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dNMDr.createContext)(null);

});

parcelRegister("2Mjap", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $205eee9f7fa97bb5$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R300", function () { return $205eee9f7fa97bb5$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $205eee9f7fa97bb5$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $205eee9f7fa97bb5$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $205eee9f7fa97bb5$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y500", function () { return $205eee9f7fa97bb5$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $205eee9f7fa97bb5$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G300", function () { return $205eee9f7fa97bb5$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $205eee9f7fa97bb5$export$a49394138f7b8e85; });
$parcel$export(module.exports, "G500", function () { return $205eee9f7fa97bb5$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $205eee9f7fa97bb5$export$226de0355ed012f8; });
$parcel$export(module.exports, "B200", function () { return $205eee9f7fa97bb5$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $205eee9f7fa97bb5$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $205eee9f7fa97bb5$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $205eee9f7fa97bb5$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $205eee9f7fa97bb5$export$363e4475840015bb; });
$parcel$export(module.exports, "P300", function () { return $205eee9f7fa97bb5$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P500", function () { return $205eee9f7fa97bb5$export$147899de772240ec; });
$parcel$export(module.exports, "N0", function () { return $205eee9f7fa97bb5$export$29a4f05edc054374; });
$parcel$export(module.exports, "N40", function () { return $205eee9f7fa97bb5$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N100", function () { return $205eee9f7fa97bb5$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $205eee9f7fa97bb5$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $205eee9f7fa97bb5$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N400", function () { return $205eee9f7fa97bb5$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $205eee9f7fa97bb5$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N600", function () { return $205eee9f7fa97bb5$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N700", function () { return $205eee9f7fa97bb5$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $205eee9f7fa97bb5$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $205eee9f7fa97bb5$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $205eee9f7fa97bb5$export$920c0d5c49070351; });
$parcel$export(module.exports, "N100A", function () { return $205eee9f7fa97bb5$export$486ab785e4bac3c6; });
// Reds
var $205eee9f7fa97bb5$export$4b84fd0e2c617bd = '#FFEBE6';
var $205eee9f7fa97bb5$export$b34b069eff244586 = '#FFBDAD';
var $205eee9f7fa97bb5$export$be802dd0d8b57f35 = '#FF8F73';
var $205eee9f7fa97bb5$export$60847d42f9da92a6 = '#FF7452';
var $205eee9f7fa97bb5$export$4a7404f376229999 = '#FF5630';
var $205eee9f7fa97bb5$export$2010d0fb4295b346 = '#DE350B';
var $205eee9f7fa97bb5$export$2837b5a1a71d5c02 = '#BF2600';
var $205eee9f7fa97bb5$export$8d9596b529bbb9cf = '#FFFAE6';
var $205eee9f7fa97bb5$export$41060a744ab0b7ae = '#FFF0B3';
var $205eee9f7fa97bb5$export$1cc05bbbf340e559 = '#FFE380';
var $205eee9f7fa97bb5$export$5aae31392d72caaa = '#FFC400';
var $205eee9f7fa97bb5$export$c6930421db9fa514 = '#FFAB00';
var $205eee9f7fa97bb5$export$59619663aa6500fb = '#FF991F';
var $205eee9f7fa97bb5$export$874739ea9e379ab6 = '#FF8B00';
var $205eee9f7fa97bb5$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $205eee9f7fa97bb5$export$69a3bf21b9686c2b = '#ABF5D1';
var $205eee9f7fa97bb5$export$afbce1382ec95f73 = '#79F2C0';
var $205eee9f7fa97bb5$export$747d86715d4175de = '#57D9A3';
var $205eee9f7fa97bb5$export$940e1f69e873f202 = '#36B37E';
var $205eee9f7fa97bb5$export$a49394138f7b8e85 = '#00875A';
var $205eee9f7fa97bb5$export$6fa04827ac68a4fb = '#006644';
var $205eee9f7fa97bb5$export$226de0355ed012f8 = '#DEEBFF';
var $205eee9f7fa97bb5$export$8c13c2ee36917869 = '#B3D4FF';
var $205eee9f7fa97bb5$export$ecfc1dff386a3e7a = '#4C9AFF';
var $205eee9f7fa97bb5$export$215b7063051591f1 = '#2684FF';
var $205eee9f7fa97bb5$export$e62e8919cca44969 = '#0065FF';
var $205eee9f7fa97bb5$export$b3de0ae08da2ce64 = '#0052CC';
var $205eee9f7fa97bb5$export$a6ee3d71bc067634 = '#0747A6';
var $205eee9f7fa97bb5$export$67f15409e87642a1 = '#669DF1';
var $205eee9f7fa97bb5$export$f0539dbc42dbb067 = '#8FB8F6';
var $205eee9f7fa97bb5$export$363e4475840015bb = '#EAE6FF';
var $205eee9f7fa97bb5$export$4b0a4417ed59760f = '#C0B6F2';
var $205eee9f7fa97bb5$export$6011520a64d9a187 = '#998DD9';
var $205eee9f7fa97bb5$export$a7175d4e9206bc80 = '#8777D9';
var $205eee9f7fa97bb5$export$b48405b95304b5a1 = '#6554C0';
var $205eee9f7fa97bb5$export$c71e4279dd54a18d = '#5243AA';
var $205eee9f7fa97bb5$export$147899de772240ec = '#403294';
var $205eee9f7fa97bb5$export$2cf711fe14c66f06 = '#E6FCFF';
var $205eee9f7fa97bb5$export$7a8f4d33f6f9772c = '#B3F5FF';
var $205eee9f7fa97bb5$export$776c9c497ef08533 = '#79E2F2';
var $205eee9f7fa97bb5$export$69cb3ca10c1e330e = '#00C7E6';
var $205eee9f7fa97bb5$export$9dc1ef0f3f48059b = '#00B8D9';
var $205eee9f7fa97bb5$export$7c835c78b6fcdef8 = '#00A3BF';
var $205eee9f7fa97bb5$export$6036577f95c3877e = '#008DA6';
var $205eee9f7fa97bb5$export$29a4f05edc054374 = '#FFFFFF';
var $205eee9f7fa97bb5$export$e655ef011c4aa1a2 = '#FAFBFC';
var $205eee9f7fa97bb5$export$9fdfb749e33cdf97 = '#F4F5F7';
var $205eee9f7fa97bb5$export$3e51e8f1440314ba = '#EBECF0';
var $205eee9f7fa97bb5$export$1ce2d1575d444ceb = '#DFE1E6';
var $205eee9f7fa97bb5$export$8754fc7e6d8b3000 = '#C1C7D0';
var $205eee9f7fa97bb5$export$c2e91cbeada39b8b = '#B3BAC5';
var $205eee9f7fa97bb5$export$5f71e19f3a7ad9de = '#A5ADBA';
var $205eee9f7fa97bb5$export$eaa8c8a70ac22806 = '#97A0AF';
var $205eee9f7fa97bb5$export$7c87d337fb91a97d = '#8993A4';
var $205eee9f7fa97bb5$export$d6447c357493214f = '#7A869A';
var $205eee9f7fa97bb5$export$f563ee71e9ee74cd = '#6B778C';
var $205eee9f7fa97bb5$export$e2ef2124cf4024b1 = '#5E6C84';
var $205eee9f7fa97bb5$export$eece5f492e429f08 = '#505F79';
var $205eee9f7fa97bb5$export$c39c0fe0f26207ae = '#42526E';
var $205eee9f7fa97bb5$export$7090862dc3038a9f = '#344563';
var $205eee9f7fa97bb5$export$ad0bacf983b7ddaa = '#253858';
var $205eee9f7fa97bb5$export$7d61b15e0da132af = '#172B4D';
var $205eee9f7fa97bb5$export$fbda843f0a27fe96 = '#091E42';
var $205eee9f7fa97bb5$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $205eee9f7fa97bb5$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $205eee9f7fa97bb5$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $205eee9f7fa97bb5$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $205eee9f7fa97bb5$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $205eee9f7fa97bb5$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $205eee9f7fa97bb5$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $205eee9f7fa97bb5$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $205eee9f7fa97bb5$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $205eee9f7fa97bb5$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $205eee9f7fa97bb5$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $205eee9f7fa97bb5$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $205eee9f7fa97bb5$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $205eee9f7fa97bb5$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $205eee9f7fa97bb5$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $205eee9f7fa97bb5$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $205eee9f7fa97bb5$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $205eee9f7fa97bb5$export$2f6319cf7d736c2a = '#E6EDFA';
var $205eee9f7fa97bb5$export$95126bc8884d6634 = '#DCE5F5';
var $205eee9f7fa97bb5$export$8338d8c35d44ff1 = '#CED9EB';
var $205eee9f7fa97bb5$export$5368d76ae4fbbda7 = '#B8C7E0';
var $205eee9f7fa97bb5$export$9f0a771d16ec8d36 = '#ABBBD6';
var $205eee9f7fa97bb5$export$abcf8c38338b4aa5 = '#9FB0CC';
var $205eee9f7fa97bb5$export$97e81faa16a182c7 = '#8C9CB8';
var $205eee9f7fa97bb5$export$bfe21c59123ecf33 = '#7988A3';
var $205eee9f7fa97bb5$export$ee82aa2ea6a1558 = '#67758F';
var $205eee9f7fa97bb5$export$682927c6ed76be02 = '#56637A';
var $205eee9f7fa97bb5$export$91fd9994c5be9757 = '#455166';
var $205eee9f7fa97bb5$export$d281fbfe3cff2df6 = '#3B475C';
var $205eee9f7fa97bb5$export$3902c91d8b98a753 = '#313D52';
var $205eee9f7fa97bb5$export$8e8133c1ba5845b5 = '#283447';
var $205eee9f7fa97bb5$export$33ff357f6620b39 = '#202B3D';
var $205eee9f7fa97bb5$export$633847cf062b69e0 = '#1B2638';
var $205eee9f7fa97bb5$export$9776a6e503bdbf76 = '#121A29';
var $205eee9f7fa97bb5$export$6c813d5160dff5db = '#0E1624';
var $205eee9f7fa97bb5$export$3d4f271a500072a = '#0D1424';
var $205eee9f7fa97bb5$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $205eee9f7fa97bb5$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $205eee9f7fa97bb5$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $205eee9f7fa97bb5$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $205eee9f7fa97bb5$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $205eee9f7fa97bb5$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $205eee9f7fa97bb5$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $205eee9f7fa97bb5$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $205eee9f7fa97bb5$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $205eee9f7fa97bb5$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $205eee9f7fa97bb5$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $205eee9f7fa97bb5$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $205eee9f7fa97bb5$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $205eee9f7fa97bb5$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $205eee9f7fa97bb5$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $205eee9f7fa97bb5$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $205eee9f7fa97bb5$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $205eee9f7fa97bb5$export$d2adc5dedf09fced = '#292A2E';
var $205eee9f7fa97bb5$export$f51762073d2bb381 = '#94C748';
var $205eee9f7fa97bb5$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("bhZXX", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $8381596b0ca4beb3$export$4e9f1640bbe7a1a8; });
var $8381596b0ca4beb3$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("cU73R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad52f0604dc02d3a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "BaseErrorPage", function () { return $ad52f0604dc02d3a$export$7ef2fc65256b3bd8; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $723m6 = parcelRequire("723m6");

var $8Cc4v = parcelRequire("8Cc4v");

var $4NPio = parcelRequire("4NPio");

var $hhYxc = parcelRequire("hhYxc");

var $8GnY0 = parcelRequire("8GnY0");
function $ad52f0604dc02d3a$export$2e2bcd8739ae039({ title: title, children: children }) {
    const anonymousId = (0, $4NPio.useAnalyticsAnonymousId)();
    return /*#__PURE__*/ (0, $6CtE1.jsxs)($ad52f0604dc02d3a$export$7ef2fc65256b3bd8, {
        title: title,
        anonymousId: anonymousId,
        children: [
            children,
            (0, $hhYxc.isFedM)() && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8GnY0.default), {
                context: "error-page"
            })
        ]
    });
}
function $ad52f0604dc02d3a$export$7ef2fc65256b3bd8({ title: title, anonymousId: anonymousId, children: children }) {
    return /*#__PURE__*/ (0, $6CtE1.jsxs)($ad52f0604dc02d3a$var$ErrorContainer, {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $723m6.AtlassianLogo), {
                size: "large",
                label: "Atlassian",
                appearance: "brand"
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8Cc4v))),
                    height: "150",
                    alt: "",
                    className: "error-image"
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("h2", {
                className: "error-title",
                children: title
            }),
            !!children && /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                className: "error-content",
                children: children
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("small", {
                className: "error-diagnostic-details",
                children: /*#__PURE__*/ (0, $6CtE1.jsx)("code", {
                    children: anonymousId || "\u2014"
                })
            })
        ]
    });
}
const $ad52f0604dc02d3a$var$ErrorContainer = (0, $fbSBq.default).div`
  margin-right: auto;
  margin-left: auto;
  max-width: 900px;
  padding: 100px 10px 0px 10px;
  text-align: center;

  .error-image {
    padding: 24px 0px;
  }

  .error-title {
    padding-top: 0px;
  }

  .error-content {
    padding-top: 16px;
  }

  .error-action {
    padding-top: 24px;
  }

  .error-diagnostic-details {
    display: block;
    padding-top: 24px;
  }
`;

});
parcelRegister("fbSBq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0f23d0c35dc8bf9$export$2e2bcd8739ae039; });

var $cahUz = parcelRequire("cahUz");
parcelRequire("aFyVI");

parcelRequire("jcrzR");
parcelRequire("c5hRo");
parcelRequire("dXyGF");
parcelRequire("dNMDr");
parcelRequire("1C7tH");
var $b0f23d0c35dc8bf9$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $b0f23d0c35dc8bf9$export$2e2bcd8739ae039 = (0, $cahUz.default).bind(null);
$b0f23d0c35dc8bf9$var$tags.forEach(function(tagName) {
    $b0f23d0c35dc8bf9$export$2e2bcd8739ae039[tagName] = $b0f23d0c35dc8bf9$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("cahUz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8db4500f73cc9068$export$2e2bcd8739ae039; });

var $lqyXr = parcelRequire("lqyXr");
parcelRequire("8Govx");
var $kR8hD = parcelRequire("kR8hD");

var $jcrzR = parcelRequire("jcrzR");

var $c5hRo = parcelRequire("c5hRo");

var $dXyGF = parcelRequire("dXyGF");

var $dNMDr = parcelRequire("dNMDr");

var $1C7tH = parcelRequire("1C7tH");
var $8db4500f73cc9068$var$isBrowser = typeof document !== 'undefined';
var $8db4500f73cc9068$var$isDevelopment = false;
var $8db4500f73cc9068$var$testOmitPropsOnStringTag = (0, $1C7tH.default);
var $8db4500f73cc9068$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $8db4500f73cc9068$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $8db4500f73cc9068$var$testOmitPropsOnStringTag : $8db4500f73cc9068$var$testOmitPropsOnComponent;
};
var $8db4500f73cc9068$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $8db4500f73cc9068$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dXyGF.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $c5hRo.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dXyGF.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$8db4500f73cc9068$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $dNMDr.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $8db4500f73cc9068$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $8db4500f73cc9068$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $8db4500f73cc9068$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $kR8hD.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $dNMDr.useContext((0, $kR8hD.T));
            }
            if (typeof props.className === 'string') className = (0, $dXyGF.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $jcrzR.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $8db4500f73cc9068$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $dNMDr.createElement($dNMDr.Fragment, null, /*#__PURE__*/ $dNMDr.createElement($8db4500f73cc9068$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $dNMDr.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $8db4500f73cc9068$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $lqyXr.default)({}, options, nextOptions, {
                shouldForwardProp: $8db4500f73cc9068$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("lqyXr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f997248ad41c9a15$export$2e2bcd8739ae039; });
function $f997248ad41c9a15$export$2e2bcd8739ae039() {
    return $f997248ad41c9a15$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f997248ad41c9a15$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("8Govx", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $652541aa4276ea9a$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $652541aa4276ea9a$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $652541aa4276ea9a$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ClassNames", function () { return $652541aa4276ea9a$export$9b9c0f9d9f3552b8; });
$parcel$export(module.exports, "jsx", function () { return $652541aa4276ea9a$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("kR8hD")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("kR8hD")).w; });

var $kR8hD = parcelRequire("kR8hD");

var $dNMDr = parcelRequire("dNMDr");

var $dXyGF = parcelRequire("dXyGF");

var $c5hRo = parcelRequire("c5hRo");

var $jcrzR = parcelRequire("jcrzR");
parcelRequire("gyDH5");
parcelRequire("aFyVI");
parcelRequire("2eIAA");

parcelRequire("cy8cW");
var $652541aa4276ea9a$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $kR8hD.h).call(props, 'css')) return $dNMDr.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $kR8hD.E);
    createElementArgArray[1] = (0, $kR8hD.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $dNMDr.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($652541aa4276ea9a$export$c8a8987d4410bf2d || ($652541aa4276ea9a$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $652541aa4276ea9a$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $kR8hD.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $jcrzR.serializeStyles)([
        styles
    ], undefined, $dNMDr.useContext((0, $kR8hD.T)));
    if (!(0, $kR8hD.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $dNMDr.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $dNMDr.useRef();
    (0, $c5hRo.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $c5hRo.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $dXyGF.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $652541aa4276ea9a$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $jcrzR.serializeStyles)(args);
}
function $652541aa4276ea9a$export$d25ddfdf17c3ad3e() {
    var insertable = $652541aa4276ea9a$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $652541aa4276ea9a$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $652541aa4276ea9a$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $dXyGF.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $652541aa4276ea9a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $c5hRo.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $dXyGF.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $kR8hD.i) && res !== undefined) rules += res;
        }
        if (!(0, $kR8hD.i)) return rules;
    });
    if (!(0, $kR8hD.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $dNMDr.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $652541aa4276ea9a$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $kR8hD.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $kR8hD.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $jcrzR.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $dXyGF.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $kR8hD.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $652541aa4276ea9a$var$merge(cache.registered, css, $652541aa4276ea9a$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $dNMDr.useContext((0, $kR8hD.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $dNMDr.createElement($dNMDr.Fragment, null, /*#__PURE__*/ $dNMDr.createElement($652541aa4276ea9a$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("kR8hD", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $f2ef2ecbcd2d7536$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $f2ef2ecbcd2d7536$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "w", function () { return $f2ef2ecbcd2d7536$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $f2ef2ecbcd2d7536$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $f2ef2ecbcd2d7536$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $f2ef2ecbcd2d7536$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $f2ef2ecbcd2d7536$export$a9c23c6ac3fc3eca; });

var $dNMDr = parcelRequire("dNMDr");

var $gyDH5 = parcelRequire("gyDH5");

var $lqyXr = parcelRequire("lqyXr");

var $2eIAA = parcelRequire("2eIAA");

var $lJ0pB = parcelRequire("lJ0pB");

var $dXyGF = parcelRequire("dXyGF");

var $jcrzR = parcelRequire("jcrzR");

var $c5hRo = parcelRequire("c5hRo");
var $f2ef2ecbcd2d7536$export$407448d2b89b1813 = false;
var $f2ef2ecbcd2d7536$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $f2ef2ecbcd2d7536$var$EmotionCacheContext = /* #__PURE__ */ $dNMDr.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $gyDH5.default)({
    key: 'css'
}) : null);
var $f2ef2ecbcd2d7536$export$e7094788287c5e9b = $f2ef2ecbcd2d7536$var$EmotionCacheContext.Provider;
var $f2ef2ecbcd2d7536$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $dNMDr.useContext)($f2ef2ecbcd2d7536$var$EmotionCacheContext);
};
var $f2ef2ecbcd2d7536$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $dNMDr.useContext)($f2ef2ecbcd2d7536$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$f2ef2ecbcd2d7536$export$23f2a1d2818174ef) $f2ef2ecbcd2d7536$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $dNMDr.useContext)($f2ef2ecbcd2d7536$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $gyDH5.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $dNMDr.createElement($f2ef2ecbcd2d7536$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $f2ef2ecbcd2d7536$export$971d5caa766a69d7 = /* #__PURE__ */ $dNMDr.createContext({});
var $f2ef2ecbcd2d7536$export$3b14a55fb2447963 = function useTheme() {
    return $dNMDr.useContext($f2ef2ecbcd2d7536$export$971d5caa766a69d7);
};
var $f2ef2ecbcd2d7536$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $lqyXr.default)({}, outerTheme, theme);
};
var $f2ef2ecbcd2d7536$var$createCacheWithTheme = /* #__PURE__ */ (0, $2eIAA.default)(function(outerTheme) {
    return (0, $2eIAA.default)(function(theme) {
        return $f2ef2ecbcd2d7536$var$getTheme(outerTheme, theme);
    });
});
var $f2ef2ecbcd2d7536$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $dNMDr.useContext($f2ef2ecbcd2d7536$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $f2ef2ecbcd2d7536$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $dNMDr.createElement($f2ef2ecbcd2d7536$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $f2ef2ecbcd2d7536$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $dNMDr.forwardRef(function render(props, ref) {
        var theme = $dNMDr.useContext($f2ef2ecbcd2d7536$export$971d5caa766a69d7);
        return /*#__PURE__*/ $dNMDr.createElement(Component, (0, $lqyXr.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $lJ0pB.default)(WithTheme, Component);
}
var $f2ef2ecbcd2d7536$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $f2ef2ecbcd2d7536$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $f2ef2ecbcd2d7536$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($f2ef2ecbcd2d7536$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$f2ef2ecbcd2d7536$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $f2ef2ecbcd2d7536$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dXyGF.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $c5hRo.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dXyGF.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$f2ef2ecbcd2d7536$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $dNMDr.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $f2ef2ecbcd2d7536$var$Emotion = /* #__PURE__ */ $f2ef2ecbcd2d7536$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$f2ef2ecbcd2d7536$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $dXyGF.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $jcrzR.serializeStyles)(registeredStyles, undefined, $dNMDr.useContext($f2ef2ecbcd2d7536$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($f2ef2ecbcd2d7536$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $f2ef2ecbcd2d7536$var$typePropName && !$f2ef2ecbcd2d7536$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $dNMDr.createElement($dNMDr.Fragment, null, /*#__PURE__*/ $dNMDr.createElement($f2ef2ecbcd2d7536$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $dNMDr.createElement(WrappedComponent, newProps));
});
var $f2ef2ecbcd2d7536$export$a9c23c6ac3fc3eca = $f2ef2ecbcd2d7536$var$Emotion;

});
parcelRegister("gyDH5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0de9cb5b7e63d02$export$2e2bcd8739ae039; });

var $fPfjF = parcelRequire("fPfjF");

var $aSdZP = parcelRequire("aSdZP");

var $2eIAA = parcelRequire("2eIAA");

var $8FxwN = parcelRequire("8FxwN");
var $c0de9cb5b7e63d02$var$isBrowser = typeof document !== 'undefined';
var $c0de9cb5b7e63d02$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $aSdZP.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $aSdZP.token)(character)) break;
        (0, $aSdZP.next)();
    }
    return (0, $aSdZP.slice)(begin, (0, $aSdZP.position));
};
var $c0de9cb5b7e63d02$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $aSdZP.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $aSdZP.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $c0de9cb5b7e63d02$var$identifierWithPointTracking((0, $aSdZP.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $aSdZP.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $aSdZP.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $aSdZP.from)(character);
    }
    while (character = (0, $aSdZP.next)());
    return parsed;
};
var $c0de9cb5b7e63d02$var$getRules = function getRules(value, points) {
    return (0, $aSdZP.dealloc)($c0de9cb5b7e63d02$var$toRules((0, $aSdZP.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $c0de9cb5b7e63d02$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $c0de9cb5b7e63d02$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$c0de9cb5b7e63d02$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $c0de9cb5b7e63d02$var$fixedElements.set(element, true);
    var points = [];
    var rules = $c0de9cb5b7e63d02$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $c0de9cb5b7e63d02$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $c0de9cb5b7e63d02$var$prefix(value, length) {
    switch((0, $aSdZP.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $aSdZP.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $aSdZP.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.MOZ) + value + (0, $aSdZP.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.MS) + value + value;
        // order
        case 6165:
            return (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.replace)(value, /(\w+).+(:[^]+)/, (0, $aSdZP.WEBKIT) + 'box-$1$2' + (0, $aSdZP.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.MS) + 'flex-item-' + (0, $aSdZP.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.MS) + 'flex-line-pack' + (0, $aSdZP.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.MS) + (0, $aSdZP.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.MS) + (0, $aSdZP.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $aSdZP.WEBKIT) + 'box-' + (0, $aSdZP.replace)(value, '-grow', '') + (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.MS) + (0, $aSdZP.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $aSdZP.WEBKIT) + (0, $aSdZP.replace)(value, /([^-])(transform)/g, '$1' + (0, $aSdZP.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $aSdZP.replace)((0, $aSdZP.replace)((0, $aSdZP.replace)(value, /(zoom-|grab)/, (0, $aSdZP.WEBKIT) + '$1'), /(image-set)/, (0, $aSdZP.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $aSdZP.replace)(value, /(image-set\([^]*)/, (0, $aSdZP.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $aSdZP.replace)((0, $aSdZP.replace)(value, /(.+:)(flex-)?(.*)/, (0, $aSdZP.WEBKIT) + 'box-pack:$3' + (0, $aSdZP.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $aSdZP.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $aSdZP.replace)(value, /(.+)-inline(.+)/, (0, $aSdZP.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $aSdZP.strlen)(value) - 1 - length > 6) switch((0, $aSdZP.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $aSdZP.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $aSdZP.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $aSdZP.WEBKIT) + '$2-$3' + '$1' + (0, $aSdZP.MOZ) + ((0, $aSdZP.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $aSdZP.indexof)(value, 'stretch') ? $c0de9cb5b7e63d02$var$prefix((0, $aSdZP.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $aSdZP.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $aSdZP.charat)(value, (0, $aSdZP.strlen)(value) - 3 - (~(0, $aSdZP.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $aSdZP.replace)(value, ':', ':' + (0, $aSdZP.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $aSdZP.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $aSdZP.WEBKIT) + ((0, $aSdZP.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $aSdZP.WEBKIT) + '$2$3' + '$1' + (0, $aSdZP.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $aSdZP.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.MS) + (0, $aSdZP.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.MS) + (0, $aSdZP.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.MS) + (0, $aSdZP.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $aSdZP.WEBKIT) + value + (0, $aSdZP.MS) + value + value;
    }
    return value;
}
var $c0de9cb5b7e63d02$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $aSdZP.DECLARATION:
                element["return"] = $c0de9cb5b7e63d02$var$prefix(element.value, element.length);
                break;
            case 0, $aSdZP.KEYFRAMES:
                return (0, $aSdZP.serialize)([
                    (0, $aSdZP.copy)(element, {
                        value: (0, $aSdZP.replace)(element.value, '@', '@' + (0, $aSdZP.WEBKIT))
                    })
                ], callback);
            case 0, $aSdZP.RULESET:
                if (element.length) return (0, $aSdZP.combine)(element.props, function(value) {
                    switch((0, $aSdZP.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $aSdZP.serialize)([
                                (0, $aSdZP.copy)(element, {
                                    props: [
                                        (0, $aSdZP.replace)(value, /:(read-\w+)/, ':' + (0, $aSdZP.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $aSdZP.serialize)([
                                (0, $aSdZP.copy)(element, {
                                    props: [
                                        (0, $aSdZP.replace)(value, /:(plac\w+)/, ':' + (0, $aSdZP.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $aSdZP.copy)(element, {
                                    props: [
                                        (0, $aSdZP.replace)(value, /:(plac\w+)/, ':' + (0, $aSdZP.MOZ) + '$1')
                                    ]
                                }),
                                (0, $aSdZP.copy)(element, {
                                    props: [
                                        (0, $aSdZP.replace)(value, /:(plac\w+)/, (0, $aSdZP.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $c0de9cb5b7e63d02$var$getServerStylisCache = $c0de9cb5b7e63d02$var$isBrowser ? undefined : (0, $2eIAA.default)(function() {
    return (0, $8FxwN.default)(function() {
        return {};
    });
});
var $c0de9cb5b7e63d02$var$defaultStylisPlugins = [
    $c0de9cb5b7e63d02$var$prefixer
];
var $c0de9cb5b7e63d02$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($c0de9cb5b7e63d02$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $c0de9cb5b7e63d02$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($c0de9cb5b7e63d02$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $c0de9cb5b7e63d02$var$compat,
        $c0de9cb5b7e63d02$var$removeLabel
    ];
    if (!$c0de9cb5b7e63d02$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $aSdZP.stringify),
            (0, $aSdZP.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $aSdZP.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $aSdZP.serialize)((0, $aSdZP.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $aSdZP.stringify)
        ];
        var _serializer = (0, $aSdZP.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $aSdZP.serialize)((0, $aSdZP.compile)(styles), _serializer);
        };
        var serverStylisCache = $c0de9cb5b7e63d02$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $fPfjF.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("fPfjF", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $b8577fee90f4773a$export$9d753cd7ae895cce; });
var $b8577fee90f4773a$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $b8577fee90f4773a$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $b8577fee90f4773a$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $b8577fee90f4773a$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$b8577fee90f4773a$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($b8577fee90f4773a$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $b8577fee90f4773a$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("aSdZP", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $a840be54f8e87906$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $a840be54f8e87906$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $a840be54f8e87906$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $a840be54f8e87906$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $a840be54f8e87906$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $a840be54f8e87906$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $a840be54f8e87906$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $a840be54f8e87906$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $a840be54f8e87906$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $a840be54f8e87906$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $a840be54f8e87906$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $a840be54f8e87906$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $a840be54f8e87906$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $a840be54f8e87906$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $a840be54f8e87906$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $a840be54f8e87906$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $a840be54f8e87906$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $a840be54f8e87906$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $a840be54f8e87906$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $a840be54f8e87906$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $a840be54f8e87906$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $a840be54f8e87906$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $a840be54f8e87906$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $a840be54f8e87906$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $a840be54f8e87906$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $a840be54f8e87906$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $a840be54f8e87906$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $a840be54f8e87906$export$38bcb760f1d4871c; });
var $a840be54f8e87906$export$71ad59f2e432cfe8 = "-ms-";
var $a840be54f8e87906$export$2c0f367103c8d01c = "-moz-";
var $a840be54f8e87906$export$39dfd62a25e0fe93 = "-webkit-";
var $a840be54f8e87906$export$a29989082612d0d9 = "comm";
var $a840be54f8e87906$export$aa3a2e812ca8570d = "rule";
var $a840be54f8e87906$export$527d108ccf083c2b = "decl";
var $a840be54f8e87906$export$d3d35020fa5b54f0 = "@page";
var $a840be54f8e87906$export$500415a86c544f73 = "@media";
var $a840be54f8e87906$export$a763edbf796b780a = "@import";
var $a840be54f8e87906$export$2790aeb8b4e5c826 = "@charset";
var $a840be54f8e87906$export$1cc683e23b84b133 = "@viewport";
var $a840be54f8e87906$export$9447a5efea57e862 = "@supports";
var $a840be54f8e87906$export$ef011b4e114b1fba = "@document";
var $a840be54f8e87906$export$6aad947bda0f3f46 = "@namespace";
var $a840be54f8e87906$export$b44a8529a35fcb60 = "@keyframes";
var $a840be54f8e87906$export$2c16de31893252e6 = "@font-face";
var $a840be54f8e87906$export$3d846dd52e150c6f = "@counter-style";
var $a840be54f8e87906$export$22314bfbb57653fe = "@font-feature-values";
var $a840be54f8e87906$export$d773506282b3cfe6 = "@layer";
var $a840be54f8e87906$export$2335f513bbd82c6d = Math.abs;
var $a840be54f8e87906$export$6788812c4e6611e6 = String.fromCharCode;
var $a840be54f8e87906$export$e6e34fd1f2686227 = Object.assign;
function $a840be54f8e87906$export$d6af199866bfb566(e, r) {
    return $a840be54f8e87906$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $a840be54f8e87906$export$a9db5e087081082d(e, 0)) << 2 ^ $a840be54f8e87906$export$a9db5e087081082d(e, 1)) << 2 ^ $a840be54f8e87906$export$a9db5e087081082d(e, 2)) << 2 ^ $a840be54f8e87906$export$a9db5e087081082d(e, 3) : 0;
}
function $a840be54f8e87906$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $a840be54f8e87906$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $a840be54f8e87906$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $a840be54f8e87906$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $a840be54f8e87906$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $a840be54f8e87906$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $a840be54f8e87906$export$36776f635604f274(e) {
    return e.length;
}
function $a840be54f8e87906$export$f9084667e487ed46(e) {
    return e.length;
}
function $a840be54f8e87906$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $a840be54f8e87906$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $a840be54f8e87906$export$53f1d5ea8de3d7c = 1;
var $a840be54f8e87906$export$4e0c71f277ca26b3 = 1;
var $a840be54f8e87906$export$f24224f1c91d8156 = 0;
var $a840be54f8e87906$export$5880b8b5730aff45 = 0;
var $a840be54f8e87906$export$c0306caf338ac095 = 0;
var $a840be54f8e87906$export$30a86d91af8ff6e6 = "";
function $a840be54f8e87906$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $a840be54f8e87906$export$53f1d5ea8de3d7c,
        column: $a840be54f8e87906$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $a840be54f8e87906$export$784d13d8ee351f07(e, r) {
    return $a840be54f8e87906$export$e6e34fd1f2686227($a840be54f8e87906$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $a840be54f8e87906$export$eba6f6f03b0a92e7() {
    return $a840be54f8e87906$export$c0306caf338ac095;
}
function $a840be54f8e87906$export$232faf9add678146() {
    $a840be54f8e87906$export$c0306caf338ac095 = $a840be54f8e87906$export$5880b8b5730aff45 > 0 ? $a840be54f8e87906$export$a9db5e087081082d($a840be54f8e87906$export$30a86d91af8ff6e6, --$a840be54f8e87906$export$5880b8b5730aff45) : 0;
    if ($a840be54f8e87906$export$4e0c71f277ca26b3--, $a840be54f8e87906$export$c0306caf338ac095 === 10) $a840be54f8e87906$export$4e0c71f277ca26b3 = 1, $a840be54f8e87906$export$53f1d5ea8de3d7c--;
    return $a840be54f8e87906$export$c0306caf338ac095;
}
function $a840be54f8e87906$export$48cfd1e771a65c4f() {
    $a840be54f8e87906$export$c0306caf338ac095 = $a840be54f8e87906$export$5880b8b5730aff45 < $a840be54f8e87906$export$f24224f1c91d8156 ? $a840be54f8e87906$export$a9db5e087081082d($a840be54f8e87906$export$30a86d91af8ff6e6, $a840be54f8e87906$export$5880b8b5730aff45++) : 0;
    if ($a840be54f8e87906$export$4e0c71f277ca26b3++, $a840be54f8e87906$export$c0306caf338ac095 === 10) $a840be54f8e87906$export$4e0c71f277ca26b3 = 1, $a840be54f8e87906$export$53f1d5ea8de3d7c++;
    return $a840be54f8e87906$export$c0306caf338ac095;
}
function $a840be54f8e87906$export$4d3fb11e950abb9e() {
    return $a840be54f8e87906$export$a9db5e087081082d($a840be54f8e87906$export$30a86d91af8ff6e6, $a840be54f8e87906$export$5880b8b5730aff45);
}
function $a840be54f8e87906$export$e88cb2efb12ae807() {
    return $a840be54f8e87906$export$5880b8b5730aff45;
}
function $a840be54f8e87906$export$58adb3bec8346d0f(e, r) {
    return $a840be54f8e87906$export$2f35ab04d2335697($a840be54f8e87906$export$30a86d91af8ff6e6, e, r);
}
function $a840be54f8e87906$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $a840be54f8e87906$export$2de70f21292aac9e(e) {
    return $a840be54f8e87906$export$53f1d5ea8de3d7c = $a840be54f8e87906$export$4e0c71f277ca26b3 = 1, $a840be54f8e87906$export$f24224f1c91d8156 = $a840be54f8e87906$export$36776f635604f274($a840be54f8e87906$export$30a86d91af8ff6e6 = e), $a840be54f8e87906$export$5880b8b5730aff45 = 0, [];
}
function $a840be54f8e87906$export$45918ac1574455b1(e) {
    return $a840be54f8e87906$export$30a86d91af8ff6e6 = "", e;
}
function $a840be54f8e87906$export$410ac95b9ec204b8(e) {
    return $a840be54f8e87906$export$87c2784dc9fc4ab($a840be54f8e87906$export$58adb3bec8346d0f($a840be54f8e87906$export$5880b8b5730aff45 - 1, $a840be54f8e87906$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $a840be54f8e87906$export$660b2ee2d4fb4eff(e) {
    return $a840be54f8e87906$export$45918ac1574455b1($a840be54f8e87906$export$5f8c09e3ae6f64e1($a840be54f8e87906$export$2de70f21292aac9e(e)));
}
function $a840be54f8e87906$export$7af1228ff777d175(e) {
    while($a840be54f8e87906$export$c0306caf338ac095 = $a840be54f8e87906$export$4d3fb11e950abb9e())if ($a840be54f8e87906$export$c0306caf338ac095 < 33) $a840be54f8e87906$export$48cfd1e771a65c4f();
    else break;
    return $a840be54f8e87906$export$9e1725a4cfeada27(e) > 2 || $a840be54f8e87906$export$9e1725a4cfeada27($a840be54f8e87906$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $a840be54f8e87906$export$5f8c09e3ae6f64e1(e) {
    while($a840be54f8e87906$export$48cfd1e771a65c4f())switch($a840be54f8e87906$export$9e1725a4cfeada27($a840be54f8e87906$export$c0306caf338ac095)){
        case 0:
            $a840be54f8e87906$export$10d8903dec122b9d($a840be54f8e87906$export$c2ab62c7bf24634($a840be54f8e87906$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $a840be54f8e87906$export$10d8903dec122b9d($a840be54f8e87906$export$410ac95b9ec204b8($a840be54f8e87906$export$c0306caf338ac095), e);
            break;
        default:
            $a840be54f8e87906$export$10d8903dec122b9d($a840be54f8e87906$export$6788812c4e6611e6($a840be54f8e87906$export$c0306caf338ac095), e);
    }
    return e;
}
function $a840be54f8e87906$export$955ba06d119e085e(e, r) {
    while(--r && $a840be54f8e87906$export$48cfd1e771a65c4f())if ($a840be54f8e87906$export$c0306caf338ac095 < 48 || $a840be54f8e87906$export$c0306caf338ac095 > 102 || $a840be54f8e87906$export$c0306caf338ac095 > 57 && $a840be54f8e87906$export$c0306caf338ac095 < 65 || $a840be54f8e87906$export$c0306caf338ac095 > 70 && $a840be54f8e87906$export$c0306caf338ac095 < 97) break;
    return $a840be54f8e87906$export$58adb3bec8346d0f(e, $a840be54f8e87906$export$e88cb2efb12ae807() + (r < 6 && $a840be54f8e87906$export$4d3fb11e950abb9e() == 32 && $a840be54f8e87906$export$48cfd1e771a65c4f() == 32));
}
function $a840be54f8e87906$export$c889f2fcc19dbf12(e) {
    while($a840be54f8e87906$export$48cfd1e771a65c4f())switch($a840be54f8e87906$export$c0306caf338ac095){
        case e:
            return $a840be54f8e87906$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $a840be54f8e87906$export$c889f2fcc19dbf12($a840be54f8e87906$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $a840be54f8e87906$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $a840be54f8e87906$export$48cfd1e771a65c4f();
            break;
    }
    return $a840be54f8e87906$export$5880b8b5730aff45;
}
function $a840be54f8e87906$export$4254d4e2b3745c4c(e, r) {
    while($a840be54f8e87906$export$48cfd1e771a65c4f())if (e + $a840be54f8e87906$export$c0306caf338ac095 === 57) break;
    else if (e + $a840be54f8e87906$export$c0306caf338ac095 === 84 && $a840be54f8e87906$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $a840be54f8e87906$export$58adb3bec8346d0f(r, $a840be54f8e87906$export$5880b8b5730aff45 - 1) + "*" + $a840be54f8e87906$export$6788812c4e6611e6(e === 47 ? e : $a840be54f8e87906$export$48cfd1e771a65c4f());
}
function $a840be54f8e87906$export$c2ab62c7bf24634(e) {
    while(!$a840be54f8e87906$export$9e1725a4cfeada27($a840be54f8e87906$export$4d3fb11e950abb9e()))$a840be54f8e87906$export$48cfd1e771a65c4f();
    return $a840be54f8e87906$export$58adb3bec8346d0f(e, $a840be54f8e87906$export$5880b8b5730aff45);
}
function $a840be54f8e87906$export$ef7acd7185315e22(e) {
    return $a840be54f8e87906$export$45918ac1574455b1($a840be54f8e87906$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $a840be54f8e87906$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $a840be54f8e87906$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $a840be54f8e87906$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $a840be54f8e87906$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($a840be54f8e87906$export$f8e21b1e77979a08(j += $a840be54f8e87906$export$77ad94ebf1c2b9ed($a840be54f8e87906$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $a840be54f8e87906$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $a840be54f8e87906$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $a840be54f8e87906$export$955ba06d119e085e($a840be54f8e87906$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($a840be54f8e87906$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $a840be54f8e87906$export$10d8903dec122b9d($a840be54f8e87906$export$4a34f930e789283c($a840be54f8e87906$export$4254d4e2b3745c4c($a840be54f8e87906$export$48cfd1e771a65c4f(), $a840be54f8e87906$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $a840be54f8e87906$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $a840be54f8e87906$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $a840be54f8e87906$export$36776f635604f274(j) - l) $a840be54f8e87906$export$10d8903dec122b9d(p > 32 ? $a840be54f8e87906$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $a840be54f8e87906$export$f8483753829ec8f3($a840be54f8e87906$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $a840be54f8e87906$export$10d8903dec122b9d(y = $a840be54f8e87906$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $a840be54f8e87906$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $a840be54f8e87906$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $a840be54f8e87906$export$98e6a39c04603d36(e, y, y, n && $a840be54f8e87906$export$10d8903dec122b9d($a840be54f8e87906$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $a840be54f8e87906$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $a840be54f8e87906$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $a840be54f8e87906$export$232faf9add678146() == 125) continue;
            }
            switch(j += $a840be54f8e87906$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($a840be54f8e87906$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($a840be54f8e87906$export$4d3fb11e950abb9e() === 45) j += $a840be54f8e87906$export$410ac95b9ec204b8($a840be54f8e87906$export$48cfd1e771a65c4f());
                    v = $a840be54f8e87906$export$4d3fb11e950abb9e(), o = l = $a840be54f8e87906$export$36776f635604f274(g = j += $a840be54f8e87906$export$c2ab62c7bf24634($a840be54f8e87906$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $a840be54f8e87906$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $a840be54f8e87906$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $a840be54f8e87906$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $a840be54f8e87906$export$2f35ab04d2335697(e, v + 1, v = $a840be54f8e87906$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $a840be54f8e87906$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $a840be54f8e87906$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $a840be54f8e87906$export$35059013cd4a06db(e, r, a, s === 0 ? $a840be54f8e87906$export$aa3a2e812ca8570d : i, f, o, l);
}
function $a840be54f8e87906$export$4a34f930e789283c(e, r, a) {
    return $a840be54f8e87906$export$35059013cd4a06db(e, r, a, $a840be54f8e87906$export$a29989082612d0d9, $a840be54f8e87906$export$6788812c4e6611e6($a840be54f8e87906$export$eba6f6f03b0a92e7()), $a840be54f8e87906$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $a840be54f8e87906$export$f8483753829ec8f3(e, r, a, n) {
    return $a840be54f8e87906$export$35059013cd4a06db(e, r, a, $a840be54f8e87906$export$527d108ccf083c2b, $a840be54f8e87906$export$2f35ab04d2335697(e, 0, n), $a840be54f8e87906$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $a840be54f8e87906$export$82e9f45cca5ba907(n, c, s) {
    switch($a840be54f8e87906$export$d6af199866bfb566(n, c)){
        case 5103:
            return $a840be54f8e87906$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $a840be54f8e87906$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $a840be54f8e87906$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $a840be54f8e87906$export$39dfd62a25e0fe93 + n + $a840be54f8e87906$export$2c0f367103c8d01c + n + $a840be54f8e87906$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($a840be54f8e87906$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $a840be54f8e87906$export$39dfd62a25e0fe93 + n + $a840be54f8e87906$export$71ad59f2e432cfe8 + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $a840be54f8e87906$export$39dfd62a25e0fe93 + n + $a840be54f8e87906$export$71ad59f2e432cfe8 + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $a840be54f8e87906$export$39dfd62a25e0fe93 + n + $a840be54f8e87906$export$71ad59f2e432cfe8 + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $a840be54f8e87906$export$39dfd62a25e0fe93 + n + $a840be54f8e87906$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $a840be54f8e87906$export$39dfd62a25e0fe93 + n + $a840be54f8e87906$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $a840be54f8e87906$export$39dfd62a25e0fe93 + n + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $a840be54f8e87906$export$39dfd62a25e0fe93 + "box-$1$2" + $a840be54f8e87906$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $a840be54f8e87906$export$39dfd62a25e0fe93 + n + $a840be54f8e87906$export$71ad59f2e432cfe8 + "flex-item-" + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$a840be54f8e87906$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $a840be54f8e87906$export$71ad59f2e432cfe8 + "grid-row-" + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $a840be54f8e87906$export$39dfd62a25e0fe93 + n + $a840be54f8e87906$export$71ad59f2e432cfe8 + "flex-line-pack" + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $a840be54f8e87906$export$39dfd62a25e0fe93 + n + $a840be54f8e87906$export$71ad59f2e432cfe8 + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $a840be54f8e87906$export$39dfd62a25e0fe93 + n + $a840be54f8e87906$export$71ad59f2e432cfe8 + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $a840be54f8e87906$export$39dfd62a25e0fe93 + "box-" + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, "-grow", "") + $a840be54f8e87906$export$39dfd62a25e0fe93 + n + $a840be54f8e87906$export$71ad59f2e432cfe8 + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $a840be54f8e87906$export$39dfd62a25e0fe93 + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $a840be54f8e87906$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $a840be54f8e87906$export$77ad94ebf1c2b9ed($a840be54f8e87906$export$77ad94ebf1c2b9ed($a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $a840be54f8e87906$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $a840be54f8e87906$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $a840be54f8e87906$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $a840be54f8e87906$export$77ad94ebf1c2b9ed($a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $a840be54f8e87906$export$39dfd62a25e0fe93 + "box-pack:$3" + $a840be54f8e87906$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $a840be54f8e87906$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$a840be54f8e87906$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $a840be54f8e87906$export$71ad59f2e432cfe8 + "grid-column-align" + $a840be54f8e87906$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $a840be54f8e87906$export$71ad59f2e432cfe8 + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $a840be54f8e87906$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$a840be54f8e87906$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $a840be54f8e87906$export$71ad59f2e432cfe8 + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $a840be54f8e87906$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$a840be54f8e87906$export$f8e21b1e77979a08(s, "span") ? $a840be54f8e87906$export$4659b591c19bdf3d(s, /\d+/) : +$a840be54f8e87906$export$4659b591c19bdf3d(s, /\d+/) - +$a840be54f8e87906$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $a840be54f8e87906$export$71ad59f2e432cfe8 + $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $a840be54f8e87906$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $a840be54f8e87906$export$71ad59f2e432cfe8 + $a840be54f8e87906$export$77ad94ebf1c2b9ed($a840be54f8e87906$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $a840be54f8e87906$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($a840be54f8e87906$export$36776f635604f274(n) - 1 - c > 6) switch($a840be54f8e87906$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($a840be54f8e87906$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $a840be54f8e87906$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $a840be54f8e87906$export$2c0f367103c8d01c + ($a840be54f8e87906$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$a840be54f8e87906$export$f8e21b1e77979a08(n, "stretch") ? $a840be54f8e87906$export$82e9f45cca5ba907($a840be54f8e87906$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $a840be54f8e87906$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $a840be54f8e87906$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($a840be54f8e87906$export$a9db5e087081082d(n, c + 6) === 121) return $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, ":", ":" + $a840be54f8e87906$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($a840be54f8e87906$export$a9db5e087081082d(n, $a840be54f8e87906$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $a840be54f8e87906$export$39dfd62a25e0fe93 + ($a840be54f8e87906$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $a840be54f8e87906$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $a840be54f8e87906$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, ":", ":" + $a840be54f8e87906$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $a840be54f8e87906$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $a840be54f8e87906$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $a840be54f8e87906$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $a840be54f8e87906$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $a840be54f8e87906$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $a840be54f8e87906$export$a763edbf796b780a:
        case $a840be54f8e87906$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $a840be54f8e87906$export$a29989082612d0d9:
            return "";
        case $a840be54f8e87906$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $a840be54f8e87906$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $a840be54f8e87906$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $a840be54f8e87906$export$36776f635604f274(a = $a840be54f8e87906$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $a840be54f8e87906$export$5a7767152ae0305f(e) {
    var r = $a840be54f8e87906$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $a840be54f8e87906$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $a840be54f8e87906$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $a840be54f8e87906$export$527d108ccf083c2b:
                n.return = $a840be54f8e87906$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $a840be54f8e87906$export$b44a8529a35fcb60:
                return $a840be54f8e87906$export$dfdc1655ccc5b9cb([
                    $a840be54f8e87906$export$784d13d8ee351f07(n, {
                        value: $a840be54f8e87906$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $a840be54f8e87906$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $a840be54f8e87906$export$aa3a2e812ca8570d:
                if (n.length) return $a840be54f8e87906$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($a840be54f8e87906$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $a840be54f8e87906$export$dfdc1655ccc5b9cb([
                                $a840be54f8e87906$export$784d13d8ee351f07(n, {
                                    props: [
                                        $a840be54f8e87906$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $a840be54f8e87906$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $a840be54f8e87906$export$dfdc1655ccc5b9cb([
                                $a840be54f8e87906$export$784d13d8ee351f07(n, {
                                    props: [
                                        $a840be54f8e87906$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $a840be54f8e87906$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $a840be54f8e87906$export$784d13d8ee351f07(n, {
                                    props: [
                                        $a840be54f8e87906$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $a840be54f8e87906$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $a840be54f8e87906$export$784d13d8ee351f07(n, {
                                    props: [
                                        $a840be54f8e87906$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $a840be54f8e87906$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $a840be54f8e87906$export$76a88f7de6507443(e) {
    switch(e.type){
        case $a840be54f8e87906$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $a840be54f8e87906$export$1be1fc439b849fdf($a840be54f8e87906$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($a840be54f8e87906$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $a840be54f8e87906$export$2f35ab04d2335697(r, 1, $a840be54f8e87906$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $a840be54f8e87906$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $a840be54f8e87906$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $a840be54f8e87906$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("2eIAA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a0f7a1182d29a02$export$2e2bcd8739ae039; });
var $1a0f7a1182d29a02$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("8FxwN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64fc290334590c56$export$2e2bcd8739ae039; });
function $64fc290334590c56$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("lJ0pB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd0e1ec123cfb66c$export$2e2bcd8739ae039; });

var $cy8cW = parcelRequire("cy8cW");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $fd0e1ec123cfb66c$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cy8cW)))(targetComponent, sourceComponent);
};

});
parcelRegister("cy8cW", function(module, exports) {
'use strict';

var $dxV3k = parcelRequire("dxV3k");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $922f06e68a045b77$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $922f06e68a045b77$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $922f06e68a045b77$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $922f06e68a045b77$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $922f06e68a045b77$var$TYPE_STATICS = {};
$922f06e68a045b77$var$TYPE_STATICS[$dxV3k.ForwardRef] = $922f06e68a045b77$var$FORWARD_REF_STATICS;
$922f06e68a045b77$var$TYPE_STATICS[$dxV3k.Memo] = $922f06e68a045b77$var$MEMO_STATICS;
function $922f06e68a045b77$var$getStatics(component) {
    // React v16.11 and below
    if ($dxV3k.isMemo(component)) return $922f06e68a045b77$var$MEMO_STATICS;
     // React v16.12 and above
    return $922f06e68a045b77$var$TYPE_STATICS[component['$$typeof']] || $922f06e68a045b77$var$REACT_STATICS;
}
var $922f06e68a045b77$var$defineProperty = Object.defineProperty;
var $922f06e68a045b77$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $922f06e68a045b77$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $922f06e68a045b77$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $922f06e68a045b77$var$getPrototypeOf = Object.getPrototypeOf;
var $922f06e68a045b77$var$objectPrototype = Object.prototype;
function $922f06e68a045b77$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($922f06e68a045b77$var$objectPrototype) {
            var inheritedComponent = $922f06e68a045b77$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $922f06e68a045b77$var$objectPrototype) $922f06e68a045b77$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $922f06e68a045b77$var$getOwnPropertyNames(sourceComponent);
        if ($922f06e68a045b77$var$getOwnPropertySymbols) keys = keys.concat($922f06e68a045b77$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $922f06e68a045b77$var$getStatics(targetComponent);
        var sourceStatics = $922f06e68a045b77$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$922f06e68a045b77$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $922f06e68a045b77$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $922f06e68a045b77$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $922f06e68a045b77$var$hoistNonReactStatics;

});
parcelRegister("dxV3k", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bZyr5"));

});



parcelRegister("dXyGF", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $a29bb137c74a7d9b$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $a29bb137c74a7d9b$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $a29bb137c74a7d9b$export$6f077d94b33a01aa; });
var $a29bb137c74a7d9b$var$isBrowser = typeof document !== 'undefined';
function $a29bb137c74a7d9b$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $a29bb137c74a7d9b$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $a29bb137c74a7d9b$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $a29bb137c74a7d9b$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $a29bb137c74a7d9b$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$a29bb137c74a7d9b$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$a29bb137c74a7d9b$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("jcrzR", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $dfa4879df761e9df$export$6321afa313b251b5; });

var $57CYa = parcelRequire("57CYa");

var $31FFD = parcelRequire("31FFD");

var $8FxwN = parcelRequire("8FxwN");
var $dfa4879df761e9df$var$isDevelopment = false;
var $dfa4879df761e9df$var$hyphenateRegex = /[A-Z]|^ms/g;
var $dfa4879df761e9df$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $dfa4879df761e9df$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $dfa4879df761e9df$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $dfa4879df761e9df$var$processStyleName = /* #__PURE__ */ (0, $8FxwN.default)(function(styleName) {
    return $dfa4879df761e9df$var$isCustomProperty(styleName) ? styleName : styleName.replace($dfa4879df761e9df$var$hyphenateRegex, '-$&').toLowerCase();
});
var $dfa4879df761e9df$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($dfa4879df761e9df$var$animationRegex, function(match, p1, p2) {
                $dfa4879df761e9df$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $dfa4879df761e9df$var$cursor
                };
                return p1;
            });
    }
    if ((0, $31FFD.default)[key] !== 1 && !$dfa4879df761e9df$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $dfa4879df761e9df$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $dfa4879df761e9df$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $dfa4879df761e9df$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $dfa4879df761e9df$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $dfa4879df761e9df$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $dfa4879df761e9df$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $dfa4879df761e9df$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $dfa4879df761e9df$var$cursor;
                var result = interpolation(mergedProps);
                $dfa4879df761e9df$var$cursor = previousCursor;
                return $dfa4879df761e9df$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $dfa4879df761e9df$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $dfa4879df761e9df$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($dfa4879df761e9df$var$isProcessableValue(asString)) string += $dfa4879df761e9df$var$processStyleName(key) + ":" + $dfa4879df761e9df$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $dfa4879df761e9df$var$isDevelopment) throw new Error($dfa4879df761e9df$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($dfa4879df761e9df$var$isProcessableValue(value[_i])) string += $dfa4879df761e9df$var$processStyleName(key) + ":" + $dfa4879df761e9df$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $dfa4879df761e9df$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $dfa4879df761e9df$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $dfa4879df761e9df$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $dfa4879df761e9df$var$cursor;
function $dfa4879df761e9df$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $dfa4879df761e9df$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $dfa4879df761e9df$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $dfa4879df761e9df$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $dfa4879df761e9df$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $dfa4879df761e9df$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $57CYa.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $dfa4879df761e9df$var$cursor
    };
}

});
parcelRegister("57CYa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3babd5b22afcd41d$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3babd5b22afcd41d$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("31FFD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2341c9fcff754ae1$export$2e2bcd8739ae039; });
var $2341c9fcff754ae1$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("c5hRo", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $8cc3ce573d6040ec$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $8cc3ce573d6040ec$export$811a713a7276cb9d; });

var $dNMDr = parcelRequire("dNMDr");
var $8cc3ce573d6040ec$var$isBrowser = typeof document !== 'undefined';
var $8cc3ce573d6040ec$var$syncFallback = function syncFallback(create) {
    return create();
};
var $8cc3ce573d6040ec$var$useInsertionEffect = $dNMDr.useInsertionEffect ? $dNMDr.useInsertionEffect : false;
var $8cc3ce573d6040ec$export$db21c7ffa21794e7 = !$8cc3ce573d6040ec$var$isBrowser ? $8cc3ce573d6040ec$var$syncFallback : $8cc3ce573d6040ec$var$useInsertionEffect || $8cc3ce573d6040ec$var$syncFallback;
var $8cc3ce573d6040ec$export$811a713a7276cb9d = $8cc3ce573d6040ec$var$useInsertionEffect || $dNMDr.useLayoutEffect;

});


parcelRegister("aFyVI", function(module, exports) {
function $7c48d40fbf536358$var$_extends() {
    return module.exports = $7c48d40fbf536358$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7c48d40fbf536358$var$_extends.apply(null, arguments);
}
module.exports = $7c48d40fbf536358$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1C7tH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12cf2406c13ee32a$export$2e2bcd8739ae039; });

var $8FxwN = parcelRequire("8FxwN");
// eslint-disable-next-line no-undef
var $12cf2406c13ee32a$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $12cf2406c13ee32a$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $8FxwN.default)(function(prop) {
    return $12cf2406c13ee32a$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("723m6", function(module, exports) {

$parcel$export(module.exports, "AtlassianLogo", function () { return $51eb52a6d5001694$export$765cacec8b0843f3; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $51eb52a6d5001694$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\">\n      <path fill=".concat(colors.iconColor, " d=\"M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"/>\n      <path fill=").concat(colors.atlassianLogoTextColor, " d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354\"/>\n    </svg>");
};
var $51eb52a6d5001694$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $51eb52a6d5001694$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("6RMty", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ffd4b8eab3f640f$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $3J65S = parcelRequire("3J65S");

var $5bLDB = parcelRequire("5bLDB");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $4ffd4b8eab3f640f$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $dNMDr.useState)((0, $3J65S.default)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $dNMDr.useEffect)(function() {
        var observer = new (0, $5bLDB.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $4ffd4b8eab3f640f$export$2e2bcd8739ae039 = $4ffd4b8eab3f640f$var$useThemeObserver;

});
parcelRegister("82V4i", function(module, exports) {

var $eIW5z = parcelRequire("eIW5z");

var $9HKOF = parcelRequire("9HKOF");

var $3CQum = parcelRequire("3CQum");

var $fGKvt = parcelRequire("fGKvt");
function $5dbac73852e9e30c$var$_slicedToArray(r, e) {
    return $eIW5z(r) || $9HKOF(r, e) || $3CQum(r, e) || $fGKvt();
}
module.exports = $5dbac73852e9e30c$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eIW5z", function(module, exports) {
function $ab823bf67070e8e2$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $ab823bf67070e8e2$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9HKOF", function(module, exports) {
function $710c71e9b1a71991$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $710c71e9b1a71991$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3CQum", function(module, exports) {

var $32vOX = parcelRequire("32vOX");
function $2a3da2e3870c3c08$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $32vOX(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $32vOX(r, a) : void 0;
    }
}
module.exports = $2a3da2e3870c3c08$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("32vOX", function(module, exports) {
function $236a3dfac2d9619d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $236a3dfac2d9619d$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fGKvt", function(module, exports) {
function $b6beda7d0f331675$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $b6beda7d0f331675$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3J65S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b6a4d29fb1459cb$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $a7eRo = parcelRequire("a7eRo");

var $58oBY = parcelRequire("58oBY");

var $aHxvj = parcelRequire("aHxvj");
function $2b6a4d29fb1459cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b6a4d29fb1459cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b6a4d29fb1459cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b6a4d29fb1459cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2b6a4d29fb1459cb$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $58oBY.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $2b6a4d29fb1459cb$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $a7eRo.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $a7eRo.THEME_DATA_ATTRIBUTE)) || '';
    return $2b6a4d29fb1459cb$var$_objectSpread($2b6a4d29fb1459cb$var$_objectSpread({}, (0, $aHxvj.themeStringToObject)(theme)), $2b6a4d29fb1459cb$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $2b6a4d29fb1459cb$export$2e2bcd8739ae039 = $2b6a4d29fb1459cb$var$getGlobalTheme;

});
parcelRegister("91FVG", function(module, exports) {

var $tDwVB = parcelRequire("tDwVB");
function $6924bb5eaf3c4c0e$var$_defineProperty(e, r, t) {
    return (r = $tDwVB(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $6924bb5eaf3c4c0e$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("tDwVB", function(module, exports) {

var $a3ftr = parcelRequire("a3ftr");
var $05915f670db4cfbe$var$_typeof = $a3ftr.default;

var $bJjgw = parcelRequire("bJjgw");
function $05915f670db4cfbe$var$toPropertyKey(t) {
    var i = $bJjgw(t, "string");
    return "symbol" == $05915f670db4cfbe$var$_typeof(i) ? i : i + "";
}
module.exports = $05915f670db4cfbe$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("a3ftr", function(module, exports) {
function $75162ffc3603ae68$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $75162ffc3603ae68$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $75162ffc3603ae68$var$_typeof(o);
}
module.exports = $75162ffc3603ae68$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bJjgw", function(module, exports) {

var $a3ftr = parcelRequire("a3ftr");
var $88a2d7655810e68b$var$_typeof = $a3ftr.default;
function $88a2d7655810e68b$var$toPrimitive(t, r) {
    if ("object" != $88a2d7655810e68b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $88a2d7655810e68b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $88a2d7655810e68b$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("a7eRo", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $75d615be944a5cba$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $75d615be944a5cba$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $75d615be944a5cba$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $75d615be944a5cba$export$352e418ed5b6193a; });
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $75d615be944a5cba$export$9d7b58831ae93caa; });
var $75d615be944a5cba$export$4ef52930e33717cd = 'data-theme';
var $75d615be944a5cba$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $75d615be944a5cba$export$a00eac3f8684bcd0 = 'data-color-mode';
var $75d615be944a5cba$export$2112803007239c61 = 'data-contrast-mode';
var $75d615be944a5cba$export$352e418ed5b6193a = 'data-custom-theme';
var $75d615be944a5cba$export$6f0c6fb8c80fcc92 = 'ds';
var $75d615be944a5cba$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $75d615be944a5cba$export$dddac1532e822863 = "--".concat($75d615be944a5cba$export$6f0c6fb8c80fcc92, "-token-not-found");
var $75d615be944a5cba$export$9d7b58831ae93caa = "--".concat($75d615be944a5cba$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("58oBY", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $3bd0ca6d24addb3f$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $3bd0ca6d24addb3f$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $3bd0ca6d24addb3f$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $3bd0ca6d24addb3f$export$2e2bcd8739ae039; });

var $gQLDR = parcelRequire("gQLDR");
var $3bd0ca6d24addb3f$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $3bd0ca6d24addb3f$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $3bd0ca6d24addb3f$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $3bd0ca6d24addb3f$var$themeOverrideIds = [];
var $3bd0ca6d24addb3f$export$92ba366331403db2 = [].concat($3bd0ca6d24addb3f$export$7d43e72a58e3283f, $3bd0ca6d24addb3f$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $3bd0ca6d24addb3f$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
/**
 * ThemeOptionsSchema: additional configuration options used to customize Atlassian's themes
 */ /**
 * ThemeState: the standard representation of an app's current theme and preferences
 */ /**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $3bd0ca6d24addb3f$var$getShapeDefault() {
    if ((0, $gQLDR.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $3bd0ca6d24addb3f$var$getMotionDefault() {
    if ((0, $gQLDR.fg)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
var $3bd0ca6d24addb3f$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $3bd0ca6d24addb3f$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $3bd0ca6d24addb3f$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $3bd0ca6d24addb3f$export$2e2bcd8739ae039 = $3bd0ca6d24addb3f$var$themeConfig;

});
parcelRegister("gQLDR", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $c446755da160ae0d$export$b40ec24ac8275656; });

var $fMU6U = parcelRequire("fMU6U");
function $c446755da160ae0d$export$ba05d765b8392e5e(flagResolver) {
    (0, $fMU6U.setBooleanResolver)(flagResolver);
}
function $c446755da160ae0d$export$470e5c2be1411c89(name) {
    return (0, $fMU6U.resolveBooleanFlag)(name);
}
function $c446755da160ae0d$export$b40ec24ac8275656(name) {
    return (0, $fMU6U.resolveBooleanFlag)(name);
}

});
parcelRegister("fMU6U", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $b7e6dd18b9ef0ab2$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $b7e6dd18b9ef0ab2$export$6333b6aff9fc6275; });

var $emS9l = parcelRequire("emS9l");

var $lsNCU = parcelRequire("lsNCU");

var $4ilBr = parcelRequire("4ilBr");
var $b7e6dd18b9ef0ab2$var$pkgName = '@atlaskit/platform-feature-flags';
var $b7e6dd18b9ef0ab2$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $b7e6dd18b9ef0ab2$var$hasProcessEnv = typeof $4ilBr !== 'undefined' && typeof $4ilBr.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $b7e6dd18b9ef0ab2$var$ENV_ENABLE_PLATFORM_FF = $b7e6dd18b9ef0ab2$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $b7e6dd18b9ef0ab2$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $b7e6dd18b9ef0ab2$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $b7e6dd18b9ef0ab2$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $b7e6dd18b9ef0ab2$var$ENV_ENABLE_PLATFORM_FF || $b7e6dd18b9ef0ab2$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $b7e6dd18b9ef0ab2$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $b7e6dd18b9ef0ab2$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$b7e6dd18b9ef0ab2$var$globalVar[$b7e6dd18b9ef0ab2$export$7e41b1b2bdee3f98] = $b7e6dd18b9ef0ab2$var$globalVar[$b7e6dd18b9ef0ab2$export$7e41b1b2bdee3f98] || $b7e6dd18b9ef0ab2$var$DEFAULT_PFF_GLOBAL;
function $b7e6dd18b9ef0ab2$export$f2b591175b3e424c(resolver) {
    $b7e6dd18b9ef0ab2$var$globalVar[$b7e6dd18b9ef0ab2$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $b7e6dd18b9ef0ab2$export$6333b6aff9fc6275(flagKey) {
    if ($b7e6dd18b9ef0ab2$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $lsNCU.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $b7e6dd18b9ef0ab2$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $b7e6dd18b9ef0ab2$var$globalVar[$b7e6dd18b9ef0ab2$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $b7e6dd18b9ef0ab2$var$globalVar[$b7e6dd18b9ef0ab2$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $emS9l.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $b7e6dd18b9ef0ab2$var$globalVar[$b7e6dd18b9ef0ab2$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("emS9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a75d1fcb69a4d9c8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CLIENT_VERSION", function () { return (parcelRequire("aXEvm")).CLIENT_VERSION; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $5ZMEG = parcelRequire("5ZMEG");

var $aXEvm = parcelRequire("aXEvm");



var $d1oup = parcelRequire("d1oup");
var $a75d1fcb69a4d9c8$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $a75d1fcb69a4d9c8$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$a75d1fcb69a4d9c8$var$_FeatureGates = $a75d1fcb69a4d9c8$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "client", new (0, $5ZMEG.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$a75d1fcb69a4d9c8$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $a75d1fcb69a4d9c8$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $a75d1fcb69a4d9c8$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$a75d1fcb69a4d9c8$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $a75d1fcb69a4d9c8$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $a75d1fcb69a4d9c8$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "initializeCalled", $a75d1fcb69a4d9c8$var$_FeatureGates.client.initializeCalled.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "initializeCompleted", $a75d1fcb69a4d9c8$var$_FeatureGates.client.initializeCompleted.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "waitUntilInitializeCompleted", $a75d1fcb69a4d9c8$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "initialize", $a75d1fcb69a4d9c8$var$_FeatureGates.client.initialize.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "initializeWithProvider", $a75d1fcb69a4d9c8$var$_FeatureGates.client.initializeWithProvider.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "initializeFromValues", $a75d1fcb69a4d9c8$var$_FeatureGates.client.initializeFromValues.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "manuallyLogGateExposure", $a75d1fcb69a4d9c8$var$_FeatureGates.client.manuallyLogGateExposure.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "getExperiment", $a75d1fcb69a4d9c8$var$_FeatureGates.client.getExperiment.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "manuallyLogExperimentExposure", $a75d1fcb69a4d9c8$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "manuallyLogLayerExposure", $a75d1fcb69a4d9c8$var$_FeatureGates.client.manuallyLogLayerExposure.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "shutdownStatsig", $a75d1fcb69a4d9c8$var$_FeatureGates.client.shutdownStatsig.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "overrideGate", $a75d1fcb69a4d9c8$var$_FeatureGates.client.overrideGate.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "clearGateOverride", $a75d1fcb69a4d9c8$var$_FeatureGates.client.clearGateOverride.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "overrideConfig", $a75d1fcb69a4d9c8$var$_FeatureGates.client.overrideConfig.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "clearConfigOverride", $a75d1fcb69a4d9c8$var$_FeatureGates.client.clearConfigOverride.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "setOverrides", $a75d1fcb69a4d9c8$var$_FeatureGates.client.setOverrides.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "getOverrides", $a75d1fcb69a4d9c8$var$_FeatureGates.client.getOverrides.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "clearAllOverrides", $a75d1fcb69a4d9c8$var$_FeatureGates.client.clearAllOverrides.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "isCurrentUser", $a75d1fcb69a4d9c8$var$_FeatureGates.client.isCurrentUser.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "onGateUpdated", $a75d1fcb69a4d9c8$var$_FeatureGates.client.onGateUpdated.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "onExperimentValueUpdated", $a75d1fcb69a4d9c8$var$_FeatureGates.client.onExperimentValueUpdated.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "onAnyUpdated", $a75d1fcb69a4d9c8$var$_FeatureGates.client.onAnyUpdated.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "updateUser", $a75d1fcb69a4d9c8$var$_FeatureGates.client.updateUser.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "updateUserWithProvider", $a75d1fcb69a4d9c8$var$_FeatureGates.client.updateUserWithProvider.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "updateUserWithValues", $a75d1fcb69a4d9c8$var$_FeatureGates.client.updateUserWithValues.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "getPackageVersion", $a75d1fcb69a4d9c8$var$_FeatureGates.client.getPackageVersion.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "getLayer", $a75d1fcb69a4d9c8$var$_FeatureGates.client.getLayer.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($a75d1fcb69a4d9c8$var$FeatureGates, "getLayerValue", $a75d1fcb69a4d9c8$var$_FeatureGates.client.getLayerValue.bind($a75d1fcb69a4d9c8$var$_FeatureGates.client));
var $a75d1fcb69a4d9c8$var$boundFGJS = $a75d1fcb69a4d9c8$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $a75d1fcb69a4d9c8$var$FeatureGates;
    else {
        var $a75d1fcb69a4d9c8$var$_boundFGJS, $a75d1fcb69a4d9c8$var$_boundFGJS$getPackage;
        $a75d1fcb69a4d9c8$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $a75d1fcb69a4d9c8$var$boundVersion = (($a75d1fcb69a4d9c8$var$_boundFGJS = $a75d1fcb69a4d9c8$var$boundFGJS) === null || $a75d1fcb69a4d9c8$var$_boundFGJS === void 0 || ($a75d1fcb69a4d9c8$var$_boundFGJS$getPackage = $a75d1fcb69a4d9c8$var$_boundFGJS.getPackageVersion) === null || $a75d1fcb69a4d9c8$var$_boundFGJS$getPackage === void 0 ? void 0 : $a75d1fcb69a4d9c8$var$_boundFGJS$getPackage.call($a75d1fcb69a4d9c8$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($a75d1fcb69a4d9c8$var$boundVersion !== (0, $aXEvm.CLIENT_VERSION)) {
            var $a75d1fcb69a4d9c8$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($a75d1fcb69a4d9c8$var$boundVersion, " when module version ").concat((0, $aXEvm.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($a75d1fcb69a4d9c8$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $a75d1fcb69a4d9c8$export$2e2bcd8739ae039 = $a75d1fcb69a4d9c8$var$boundFGJS;

});
parcelRegister("lPkGR", function(module, exports) {
function $fe3e690a2fb4a3d3$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $fe3e690a2fb4a3d3$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("c9XBY", function(module, exports) {

var $tDwVB = parcelRequire("tDwVB");
function $8da490dfcf66594f$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $tDwVB(o.key), o);
    }
}
function $8da490dfcf66594f$var$_createClass(e, r, t) {
    return r && $8da490dfcf66594f$var$_defineProperties(e.prototype, r), t && $8da490dfcf66594f$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $8da490dfcf66594f$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5ZMEG", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $45d8642c655cc4a1$export$1f2bb630327ac4b6; });

var $bM2vx = parcelRequire("bM2vx");

var $82V4i = parcelRequire("82V4i");

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $axdfd = parcelRequire("axdfd");

var $7i2Oo = parcelRequire("7i2Oo");

var $dlfVC = parcelRequire("dlfVC");

var $kkEAg = parcelRequire("kkEAg");

var $hfnjj = parcelRequire("hfnjj");

var $NtwyG = parcelRequire("NtwyG");

var $cdHC9 = parcelRequire("cdHC9");

var $lIsqo = parcelRequire("lIsqo");

var $cwYdj = parcelRequire("cwYdj");

var $d1oup = parcelRequire("d1oup");

var $8gOv4 = parcelRequire("8gOv4");

var $aXEvm = parcelRequire("aXEvm");
var $45d8642c655cc4a1$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $45d8642c655cc4a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45d8642c655cc4a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45d8642c655cc4a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45d8642c655cc4a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $45d8642c655cc4a1$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $45d8642c655cc4a1$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $45d8642c655cc4a1$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $cwYdj.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "subscriptions", new (0, $dlfVC.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "dataAdapter", new (0, $lIsqo.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $cwYdj.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $8gOv4.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $8gOv4.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $8gOv4.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $8gOv4.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $aXEvm.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $45d8642c655cc4a1$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $aXEvm.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $d1oup.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $8gOv4.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $8gOv4.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $8gOv4.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $cdHC9.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $kkEAg.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $kkEAg.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $NtwyG.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $8gOv4.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $8gOv4.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $45d8642c655cc4a1$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 5;
                                    break;
                                }
                                _context8.next = 4;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 4:
                                return _context8.abrupt("return");
                            case 5:
                                _context8.prev = 5;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $cdHC9.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $cdHC9.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 10;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 10:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 24;
                                break;
                            case 17:
                                _context8.prev = 17;
                                _context8.t0 = _context8["catch"](5);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 23;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 23:
                                throw _context8.t0;
                            case 24:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 25:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            5,
                            17
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $45d8642c655cc4a1$var$_objectSpread($45d8642c655cc4a1$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $8gOv4.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $45d8642c655cc4a1$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $45d8642c655cc4a1$var$_objectSpread($45d8642c655cc4a1$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $45d8642c655cc4a1$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $d1oup.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(newClientOptions, $45d8642c655cc4a1$var$_excluded);
                                frontendUser = (0, $8gOv4.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $8gOv4.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $45d8642c655cc4a1$var$_objectSpread($45d8642c655cc4a1$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $7i2Oo.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $7i2Oo.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 13;
                                this.statsigClient = new (0, $7i2Oo.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 18;
                                return this.statsigClient.initializeAsync();
                            case 18:
                                _context0.next = 30;
                                break;
                            case 20:
                                _context0.prev = 20;
                                _context0.t0 = _context0["catch"](13);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $7i2Oo.StatsigClient)($45d8642c655cc4a1$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 28;
                                return this.statsigClient.initializeAsync();
                            case 28:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 30:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            13,
                            20
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $8gOv4.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $8gOv4.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 14;
                                break;
                            case 9:
                                _context11.prev = 9;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 14:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 16;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 22;
                                    break;
                                }
                                _context11.next = 22;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 22:
                                _context11.next = 28;
                                break;
                            case 24:
                                _context11.prev = 24;
                                _context11.t1 = _context11["catch"](16);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 28:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 35;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 36;
                                break;
                            case 35:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 36:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            9
                        ],
                        [
                            16,
                            24
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $aXEvm.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $hfnjj.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $hfnjj.Layer).fromLayer((0, $7i2Oo._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("bM2vx", function(module, exports) {

var $kPyq1 = parcelRequire("kPyq1");
function $89261f66d72dcbd3$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $kPyq1(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $89261f66d72dcbd3$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kPyq1", function(module, exports) {
function $f2a344e1e823eeed$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $f2a344e1e823eeed$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("k7uol", function(module, exports) {
function $ea5c09446bbe85e4$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $ea5c09446bbe85e4$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $ea5c09446bbe85e4$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $ea5c09446bbe85e4$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $ea5c09446bbe85e4$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("axdfd", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $7ab7428022165525$var$runtime = (parcelRequire("5DhIS"))();
module.exports = $7ab7428022165525$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $7ab7428022165525$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7ab7428022165525$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7ab7428022165525$var$runtime);
}

});
parcelRegister("5DhIS", function(module, exports) {

var $lqJEM = parcelRequire("lqJEM");

var $7OROH = parcelRequire("7OROH");

var $g5ghg = parcelRequire("g5ghg");

var $bNhhX = parcelRequire("bNhhX");

var $b7pkT = parcelRequire("b7pkT");

var $53IGg = parcelRequire("53IGg");

var $g6mcO = parcelRequire("g6mcO");
function $419e57aa81706918$var$_regeneratorRuntime() {
    "use strict";
    var r = $7OROH(), e = r.m($419e57aa81706918$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $g6mcO(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $419e57aa81706918$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $lqJEM(r, e);
            },
            AsyncIterator: $b7pkT,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $bNhhX : $g5ghg)(a(r), e, t, o, u);
            },
            keys: $53IGg,
            values: $g6mcO
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $419e57aa81706918$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lqJEM", function(module, exports) {
function $f99f712d24ed2583$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $f99f712d24ed2583$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7OROH", function(module, exports) {

var $i4qlV = parcelRequire("i4qlV");
function $5b16f2cf11b01be1$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $i4qlV(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($i4qlV(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $i4qlV(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $i4qlV(u, "constructor", GeneratorFunctionPrototype), $i4qlV(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $i4qlV(GeneratorFunctionPrototype, o, "GeneratorFunction"), $i4qlV(u), $i4qlV(u, o, "Generator"), $i4qlV(u, n, function() {
        return this;
    }), $i4qlV(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $5b16f2cf11b01be1$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $5b16f2cf11b01be1$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("i4qlV", function(module, exports) {
function $d27d0acd1acbb213$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $d27d0acd1acbb213$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            $d27d0acd1acbb213$var$_regeneratorDefine(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d27d0acd1acbb213$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $d27d0acd1acbb213$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("g5ghg", function(module, exports) {

var $bNhhX = parcelRequire("bNhhX");
function $bb59bd5622e17bd6$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $bNhhX(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $bb59bd5622e17bd6$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bNhhX", function(module, exports) {

var $7OROH = parcelRequire("7OROH");

var $b7pkT = parcelRequire("b7pkT");
function $8961ae772a48b367$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $b7pkT($7OROH().w(r, e, t, o), n || Promise);
}
module.exports = $8961ae772a48b367$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("b7pkT", function(module, exports) {

var $lqJEM = parcelRequire("lqJEM");

var $i4qlV = parcelRequire("i4qlV");
function $8184005ba271dc22$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $lqJEM ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($i4qlV($8184005ba271dc22$var$AsyncIterator.prototype), $i4qlV($8184005ba271dc22$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $i4qlV(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $8184005ba271dc22$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("53IGg", function(module, exports) {
function $3aefe439841f08e4$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $3aefe439841f08e4$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("g6mcO", function(module, exports) {

var $a3ftr = parcelRequire("a3ftr");
var $bb8e6e72aa55864a$var$_typeof = $a3ftr.default;
function $bb8e6e72aa55864a$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($bb8e6e72aa55864a$var$_typeof(e) + " is not iterable");
}
module.exports = $bb8e6e72aa55864a$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("7i2Oo", function(module, exports) {
"use strict";
var $54ec653a96f8982e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $54ec653a96f8982e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $54ec653a96f8982e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $3A8ud = parcelRequire("3A8ud");
module.exports.StatsigClient = $3A8ud.default;

$54ec653a96f8982e$var$__exportStar((parcelRequire("5SovT")), module.exports);
const $54ec653a96f8982e$var$__STATSIG__ = Object.assign((0, (parcelRequire("5SovT"))._getStatsigGlobal)(), {
    StatsigClient: $3A8ud.default
});
module.exports.default = $54ec653a96f8982e$var$__STATSIG__;

});
parcelRegister("5SovT", function(module, exports) {
"use strict";
var $447502badca57d03$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $447502badca57d03$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $447502badca57d03$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("7lHaj")).Diagnostics;
    }
});

var $9n7uB = parcelRequire("9n7uB");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $9n7uB.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("4eyTY")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("1U3tc")).Storage;
    }
});

$447502badca57d03$var$__exportStar((parcelRequire("lc1Yh")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("lsCkt")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("cyN1n")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("lwUKx")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("7lHaj")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("ktpCg")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("4zVoZ")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("o204Q")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("91DxP")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("8Ywu8")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("zsqxF")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("4eyTY")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("keJhv")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("7eSIL")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("iCe1t")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("8RfNH")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("jMlYX")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("8L4K3")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("32SUK")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("kjI4J")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("ciCcP")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("bJwln")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("3Imi3")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("aWuDn")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("3p9cn")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("aiMrf")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("aOdQW")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("ekYEt")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("lf7T8")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("cOvMz")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("9fhNu")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("3ZLU1")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("1U3tc")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("avuBW")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("dQaWG")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("5ygvB")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("69ZmD")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("kpY2F")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("dmgUM")), module.exports);

$447502badca57d03$var$__exportStar((parcelRequire("bSQMM")), module.exports);
Object.assign((0, (parcelRequire("lc1Yh"))._getStatsigGlobal)(), {
    Log: (parcelRequire("4eyTY")).Log,
    SDK_VERSION: (parcelRequire("aOdQW")).SDK_VERSION
});

});
parcelRegister("lc1Yh", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $f6dc3f6f1095f2e5$var$_a, $f6dc3f6f1095f2e5$var$_b, $f6dc3f6f1095f2e5$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $4eyTY = parcelRequire("4eyTY");
const $f6dc3f6f1095f2e5$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $f6dc3f6f1095f2e5$var$statsigGlobal;
    } catch (e) {
        return $f6dc3f6f1095f2e5$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $f6dc3f6f1095f2e5$var$_getStatsigGlobal;
const $f6dc3f6f1095f2e5$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $f6dc3f6f1095f2e5$var$_getStatsigGlobalFlag;
const $f6dc3f6f1095f2e5$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $4eyTY.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $f6dc3f6f1095f2e5$var$_getInstance;
const $f6dc3f6f1095f2e5$var$GLOBAL_KEY = '__STATSIG__';
const $f6dc3f6f1095f2e5$var$_window = typeof window !== 'undefined' ? window : {};
const $f6dc3f6f1095f2e5$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $f6dc3f6f1095f2e5$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $f6dc3f6f1095f2e5$var$statsigGlobal = ($f6dc3f6f1095f2e5$var$_c = ($f6dc3f6f1095f2e5$var$_b = ($f6dc3f6f1095f2e5$var$_a = $f6dc3f6f1095f2e5$var$_window[$f6dc3f6f1095f2e5$var$GLOBAL_KEY]) !== null && $f6dc3f6f1095f2e5$var$_a !== void 0 ? $f6dc3f6f1095f2e5$var$_a : $f6dc3f6f1095f2e5$var$_global[$f6dc3f6f1095f2e5$var$GLOBAL_KEY]) !== null && $f6dc3f6f1095f2e5$var$_b !== void 0 ? $f6dc3f6f1095f2e5$var$_b : $f6dc3f6f1095f2e5$var$_globalThis[$f6dc3f6f1095f2e5$var$GLOBAL_KEY]) !== null && $f6dc3f6f1095f2e5$var$_c !== void 0 ? $f6dc3f6f1095f2e5$var$_c : {
    instance: module.exports._getInstance
};
$f6dc3f6f1095f2e5$var$_window[$f6dc3f6f1095f2e5$var$GLOBAL_KEY] = $f6dc3f6f1095f2e5$var$statsigGlobal;
$f6dc3f6f1095f2e5$var$_global[$f6dc3f6f1095f2e5$var$GLOBAL_KEY] = $f6dc3f6f1095f2e5$var$statsigGlobal;
$f6dc3f6f1095f2e5$var$_globalThis[$f6dc3f6f1095f2e5$var$GLOBAL_KEY] = $f6dc3f6f1095f2e5$var$statsigGlobal;

});
parcelRegister("4eyTY", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $31538af9c0d0fe6d$var$DEBUG = ' DEBUG ';
const $31538af9c0d0fe6d$var$_INFO = '  INFO ';
const $31538af9c0d0fe6d$var$_WARN = '  WARN ';
const $31538af9c0d0fe6d$var$ERROR = ' ERROR ';
function $31538af9c0d0fe6d$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $31538af9c0d0fe6d$var$Log {
    static info(...args) {
        if ($31538af9c0d0fe6d$var$Log.level >= module.exports.LogLevel.Info) console.info($31538af9c0d0fe6d$var$_INFO, ...$31538af9c0d0fe6d$var$addTag(args));
    }
    static debug(...args) {
        if ($31538af9c0d0fe6d$var$Log.level >= module.exports.LogLevel.Debug) console.debug($31538af9c0d0fe6d$var$DEBUG, ...$31538af9c0d0fe6d$var$addTag(args));
    }
    static warn(...args) {
        if ($31538af9c0d0fe6d$var$Log.level >= module.exports.LogLevel.Warn) console.warn($31538af9c0d0fe6d$var$_WARN, ...$31538af9c0d0fe6d$var$addTag(args));
    }
    static error(...args) {
        if ($31538af9c0d0fe6d$var$Log.level >= module.exports.LogLevel.Error) console.error($31538af9c0d0fe6d$var$ERROR, ...$31538af9c0d0fe6d$var$addTag(args));
    }
}
module.exports.Log = $31538af9c0d0fe6d$var$Log;
$31538af9c0d0fe6d$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("7lHaj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $559bfa4d8b8d094f$var$MARKER_MAP = new Map();
const $559bfa4d8b8d094f$var$ACT_START = 'start';
const $559bfa4d8b8d094f$var$ACT_END = 'end';
const $559bfa4d8b8d094f$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $559bfa4d8b8d094f$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $559bfa4d8b8d094f$var$_addMarker(sdkKey, $559bfa4d8b8d094f$var$_createMarker({}, $559bfa4d8b8d094f$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $559bfa4d8b8d094f$var$_addMarker(sdkKey, $559bfa4d8b8d094f$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $559bfa4d8b8d094f$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $559bfa4d8b8d094f$var$_addMarker(sdkKey, $559bfa4d8b8d094f$var$_createMarker(data, $559bfa4d8b8d094f$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $559bfa4d8b8d094f$var$_addMarker(sdkKey, $559bfa4d8b8d094f$var$_createMarker(data, $559bfa4d8b8d094f$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $559bfa4d8b8d094f$var$_addMarker(sdkKey, $559bfa4d8b8d094f$var$_createMarker({}, $559bfa4d8b8d094f$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $559bfa4d8b8d094f$var$_addMarker(sdkKey, $559bfa4d8b8d094f$var$_createMarker(data, $559bfa4d8b8d094f$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $559bfa4d8b8d094f$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $559bfa4d8b8d094f$var$_safeGetField(e, 'code'),
            name: $559bfa4d8b8d094f$var$_safeGetField(e, 'name'),
            message: $559bfa4d8b8d094f$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $559bfa4d8b8d094f$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $559bfa4d8b8d094f$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $559bfa4d8b8d094f$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $559bfa4d8b8d094f$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $559bfa4d8b8d094f$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $559bfa4d8b8d094f$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $559bfa4d8b8d094f$var$MARKER_MAP.set(sdkKey, markers);
}
function $559bfa4d8b8d094f$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("9n7uB", function(module, exports) {
"use strict";
var $6d2c12eb60852558$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $eXWwD = parcelRequire("eXWwD");

var $lsCkt = parcelRequire("lsCkt");

var $acuuF = parcelRequire("acuuF");

var $hJ9C7 = parcelRequire("hJ9C7");

var $8Ywu8 = parcelRequire("8Ywu8");

var $4eyTY = parcelRequire("4eyTY");

var $7eSIL = parcelRequire("7eSIL");

var $lbci3 = parcelRequire("lbci3");

var $8L4K3 = parcelRequire("8L4K3");

var $aiMrf = parcelRequire("aiMrf");

var $ekYEt = parcelRequire("ekYEt");

var $1U3tc = parcelRequire("1U3tc");

var $5ygvB = parcelRequire("5ygvB");

var $kpY2F = parcelRequire("kpY2F");
const $6d2c12eb60852558$var$MAX_DEDUPER_KEYS = 1000;
const $6d2c12eb60852558$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $6d2c12eb60852558$var$EVENT_LOGGER_MAP = {};
class $6d2c12eb60852558$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $6d2c12eb60852558$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    constructor(_sdkKey, _emitter, _network, _options, _errorBoundary){
        var _a;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._errorBoundary = _errorBoundary;
        this._pendingEvents = null;
        this._batchQueue = null;
        this._flushCoordinator = null;
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._isShuttingDown = false;
        this._storageKey = null;
        this._pendingCompressionMode = null;
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $ekYEt.LoggingEnabledOption.disabled : $ekYEt.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $4eyTY.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $5ygvB.UrlConfiguration($7eSIL.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        if (this._flushCoordinator) this._flushCoordinator.setLogEventCompressionMode(mode);
        else this._pendingCompressionMode = mode;
    }
    setLoggingEnabled(loggingEnabled) {
        const wasDisabled = this._loggingEnabled === 'disabled';
        const isNowEnabled = loggingEnabled !== 'disabled';
        this._loggingEnabled = loggingEnabled;
        if (this._flushCoordinator) this._flushCoordinator.setLoggingEnabled(loggingEnabled);
        if (wasDisabled && isNowEnabled) {
            const events = this._loadStoredEvents();
            $4eyTY.Log.debug(`Loaded ${events.length} stored event(s) from storage`);
            if (events.length > 0) {
                events.forEach((event)=>{
                    this._initFlushCoordinator().addEvent(event);
                });
                this.flush().catch((error)=>{
                    $4eyTY.Log.warn('Failed to flush events after enabling logging:', error);
                });
            }
        }
    }
    enqueue(event) {
        var _a;
        if (!this._shouldLogEvent(event)) return;
        const normalizedEvent = this._normalizeEvent(event);
        if (this._loggingEnabled === 'disabled') {
            this._storeEventToStorage(normalizedEvent);
            return;
        }
        this._initFlushCoordinator().addEvent(normalizedEvent);
        (_a = this._flushCoordinator) === null || _a === void 0 || _a.checkQuickFlush();
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $8L4K3._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        const flushCoordinator = this._initFlushCoordinator();
        $6d2c12eb60852558$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $kpY2F._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $6d2c12eb60852558$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') flushCoordinator.startScheduledFlushCycle();
        });
        flushCoordinator.loadAndRetryShutdownFailedEvents().catch((error)=>{
            $4eyTY.Log.warn('Failed to load failed shutdown events:', error);
        });
        flushCoordinator.startScheduledFlushCycle();
    }
    stop() {
        return $6d2c12eb60852558$var$__awaiter(this, void 0, void 0, function*() {
            this._isShuttingDown = true;
            if (this._flushCoordinator) yield this._flushCoordinator.processShutdown();
            delete $6d2c12eb60852558$var$EVENT_LOGGER_MAP[this._sdkKey];
            this._flushCoordinator = null;
            this._pendingEvents = null;
            this._batchQueue = null;
        });
    }
    flush() {
        return $6d2c12eb60852558$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._flushCoordinator) return;
            return this._flushCoordinator.processManualFlush();
        });
    }
    appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        const checks = Object.assign({}, this._nonExposedChecks);
        this._nonExposedChecks = {};
        const event = this._normalizeEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: checks
            }
        });
        if (!this._flushCoordinator) return;
        this._flushCoordinator.addEvent(event);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $8L4K3._isServerEnv)()) return false;
        if (!(0, $aiMrf._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $lsCkt._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $6d2c12eb60852558$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $6d2c12eb60852558$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $8L4K3._getCurrentPageUrlSafe)();
    }
    _getStorageKey() {
        if (!this._storageKey) this._storageKey = `statsig.pending_events.${(0, $8Ywu8._DJB2)(this._sdkKey)}`;
        return this._storageKey;
    }
    _initFlushCoordinator() {
        var _a, _b;
        if (this._flushCoordinator) return this._flushCoordinator;
        const batchSize = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $acuuF.EventRetryConstants.DEFAULT_BATCH_SIZE;
        this._pendingEvents = new $lbci3.PendingEvents(batchSize);
        this._batchQueue = new $eXWwD.BatchQueue(batchSize);
        this._flushCoordinator = new $hJ9C7.FlushCoordinator(this._batchQueue, this._pendingEvents, ()=>this.appendAndResetNonExposedChecks(), this._sdkKey, this._network, this._emitter, this._logEventUrlConfig, this._options, this._loggingEnabled, this._errorBoundary);
        if (this._pendingCompressionMode) {
            this._flushCoordinator.setLogEventCompressionMode(this._pendingCompressionMode);
            this._pendingCompressionMode = null;
        }
        return this._flushCoordinator;
    }
    _storeEventToStorage(event) {
        const storageKey = this._getStorageKey();
        try {
            let existingEvents = this._getEventsFromStorage(storageKey);
            existingEvents.push(event);
            if (existingEvents.length > $acuuF.EventRetryConstants.MAX_LOCAL_STORAGE) existingEvents = existingEvents.slice(-$acuuF.EventRetryConstants.MAX_LOCAL_STORAGE);
            (0, $1U3tc._setObjectInStorage)(storageKey, existingEvents);
        } catch (error) {
            $4eyTY.Log.warn('Unable to save events to storage');
        }
    }
    _getEventsFromStorage(storageKey) {
        try {
            const events = (0, $1U3tc._getObjectFromStorage)(storageKey);
            if (Array.isArray(events)) return events;
            return [];
        } catch (_a) {
            return [];
        }
    }
    _loadStoredEvents() {
        const storageKey = this._getStorageKey();
        const events = this._getEventsFromStorage(storageKey);
        if (events.length > 0) $1U3tc.Storage.removeItem(storageKey);
        return events;
    }
    _normalizeEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        return Object.assign(Object.assign({}, event), extras);
    }
}
module.exports.EventLogger = $6d2c12eb60852558$var$EventLogger;

});
parcelRegister("eXWwD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BatchQueue = void 0;

var $ba0md = parcelRequire("ba0md");

var $acuuF = parcelRequire("acuuF");
class $ae53f94d4992dc63$var$BatchQueue {
    constructor(batchSize = $acuuF.EventRetryConstants.DEFAULT_BATCH_SIZE){
        this._batches = [];
        this._batchSize = batchSize;
    }
    batchSize() {
        return this._batchSize;
    }
    requeueBatch(batch) {
        return this._enqueueBatch(batch);
    }
    hasFullBatch() {
        return this._batches.some((batch)=>batch.events.length >= this._batchSize);
    }
    takeNextBatch() {
        return this._batches.shift();
    }
    takeAllBatches() {
        const batches = this._batches;
        this._batches = [];
        return batches;
    }
    createBatches(events) {
        let i = 0;
        let droppedCount = 0;
        while(i < events.length){
            const chunk = events.slice(i, i + this._batchSize);
            droppedCount += this._enqueueBatch(new $ba0md.EventBatch(chunk));
            i += this._batchSize;
        }
        return droppedCount;
    }
    _enqueueBatch(batch) {
        this._batches.push(batch);
        let droppedEventCount = 0;
        while(this._batches.length > $acuuF.EventRetryConstants.MAX_PENDING_BATCHES){
            const dropped = this._batches.shift();
            if (dropped) droppedEventCount += dropped.events.length;
        }
        return droppedEventCount;
    }
}
module.exports.BatchQueue = $ae53f94d4992dc63$var$BatchQueue;

});
parcelRegister("ba0md", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventBatch = void 0;
class $8200e7dadbd778d8$var$EventBatch {
    constructor(events){
        this.attempts = 0;
        this.createdAt = Date.now();
        this.events = events;
    }
    incrementAttempts() {
        this.attempts++;
    }
}
module.exports.EventBatch = $8200e7dadbd778d8$var$EventBatch;

});

parcelRegister("acuuF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventRetryConstants = void 0;
module.exports.EventRetryConstants = {
    MAX_RETRY_ATTEMPTS: 5,
    DEFAULT_BATCH_SIZE: 100,
    MAX_PENDING_BATCHES: 30,
    TICK_INTERVAL_MS: 1000,
    QUICK_FLUSH_WINDOW_MS: 200,
    MAX_LOCAL_STORAGE: 500,
    get MAX_QUEUED_EVENTS () {
        return this.DEFAULT_BATCH_SIZE * this.MAX_PENDING_BATCHES;
    }
};

});


parcelRegister("lsCkt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $8Ywu8 = parcelRequire("8Ywu8");
function $f9f9f1ded01e0995$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $8Ywu8._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $f9f9f1ded01e0995$var$_getUserStorageKey;
function $f9f9f1ded01e0995$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $f9f9f1ded01e0995$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $8Ywu8._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $f9f9f1ded01e0995$var$_getStorageKey;

});
parcelRegister("8Ywu8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $dQaWG = parcelRequire("dQaWG");
const $688d202ce1f42334$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $688d202ce1f42334$var$_DJB2;
const $688d202ce1f42334$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $688d202ce1f42334$var$_DJB2Object;
const $688d202ce1f42334$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $dQaWG._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $688d202ce1f42334$var$_getSortedObject;

});
parcelRegister("dQaWG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $a1389f3e40676c68$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $a1389f3e40676c68$var$_typeOf;
function $a1389f3e40676c68$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $a1389f3e40676c68$var$_isTypeMatch;

});



parcelRegister("hJ9C7", function(module, exports) {
"use strict";
var $ce7e18c36f2148af$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushCoordinator = void 0;

var $acuuF = parcelRequire("acuuF");

var $0krQv = parcelRequire("0krQv");

var $it0CE = parcelRequire("it0CE");

var $9j9vO = parcelRequire("9j9vO");

var $8Ywu8 = parcelRequire("8Ywu8");

var $4eyTY = parcelRequire("4eyTY");

var $iCe1t = parcelRequire("iCe1t");

var $kjI4J = parcelRequire("kjI4J");

var $1U3tc = parcelRequire("1U3tc");
class $ce7e18c36f2148af$var$FlushCoordinator {
    constructor(batchQueue, pendingEvents, onPrepareFlush, // For Event Sender
    sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled, errorBoundary){
        this._cooldownTimer = null;
        this._maxIntervalTimer = null;
        this._hasRunQuickFlush = false;
        this._currentFlushPromise = null;
        this._creationTime = Date.now();
        this._isShuttingDown = false;
        this._storageKey = null;
        this._flushInterval = new $it0CE.FlushInterval();
        this._batchQueue = batchQueue;
        this._pendingEvents = pendingEvents;
        this._onPrepareFlush = onPrepareFlush;
        this._errorBoundary = errorBoundary;
        this._sdkKey = sdkKey;
        this._eventSender = new $0krQv.EventSender(sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled);
    }
    setLoggingEnabled(loggingEnabled) {
        this._eventSender.setLoggingEnabled(loggingEnabled);
    }
    setLogEventCompressionMode(mode) {
        this._eventSender.setLogEventCompressionMode(mode);
    }
    startScheduledFlushCycle() {
        this._scheduleNextFlush();
    }
    stopScheduledFlushCycle() {
        this._clearAllTimers();
    }
    addEvent(event) {
        this._pendingEvents.addToPendingEventsQueue(event);
        if (this._currentFlushPromise) return;
        if (this._pendingEvents.hasEventsForFullBatch()) this.processLimitFlush();
    }
    processManualFlush() {
        return $ce7e18c36f2148af$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentFlushPromise) yield this._currentFlushPromise;
            this._currentFlushPromise = this._executeFlush($9j9vO.FlushType.Manual).finally(()=>{
                this._currentFlushPromise = null;
                this._scheduleNextFlush();
            });
            return this._currentFlushPromise;
        });
    }
    processShutdown() {
        return $ce7e18c36f2148af$var$__awaiter(this, void 0, void 0, function*() {
            this._isShuttingDown = true;
            this._clearAllTimers();
            if (this._currentFlushPromise) yield this._currentFlushPromise;
            this._currentFlushPromise = this._executeFlush($9j9vO.FlushType.Shutdown).catch((error)=>{
                $4eyTY.Log.error(`Error during shutdown flush: ${error}`);
            }).finally(()=>{
                this._currentFlushPromise = null;
            });
            return this._currentFlushPromise;
        });
    }
    _executeFlush(flushType) {
        return $ce7e18c36f2148af$var$__awaiter(this, void 0, void 0, function*() {
            this._clearAllTimers();
            try {
                this._prepareQueueForFlush(flushType);
                const batches = this._batchQueue.takeAllBatches();
                if (batches.length === 0) return;
                yield Promise.all(batches.map((batch)=>this._processOneBatch(batch, flushType)));
            } finally{
                if (!this._isShuttingDown) this._scheduleNextFlush();
            }
        });
    }
    checkQuickFlush() {
        if (this._hasRunQuickFlush) return;
        if (Date.now() - this._creationTime > $acuuF.EventRetryConstants.QUICK_FLUSH_WINDOW_MS) return;
        this._hasRunQuickFlush = true;
        setTimeout(()=>{
            this.processManualFlush().catch((error)=>{
                $4eyTY.Log.warn('Quick flush failed:', error);
            });
        }, $acuuF.EventRetryConstants.QUICK_FLUSH_WINDOW_MS);
    }
    _attemptScheduledFlush() {
        if (this._currentFlushPromise) {
            this._scheduleNextFlush();
            return;
        }
        const shouldFlushBySize = this.containsAtLeastOneFullBatch();
        const shouldFlushByTime = this._flushInterval.hasReachedMaxInterval();
        if (!shouldFlushBySize && !shouldFlushByTime) {
            this._scheduleNoopPollTick();
            return;
        }
        this._flushInterval.markFlushAttempt();
        let flushType;
        if (shouldFlushBySize) flushType = $9j9vO.FlushType.ScheduledFullBatch;
        else flushType = $9j9vO.FlushType.ScheduledMaxTime;
        this._currentFlushPromise = this._processNextBatch(flushType).then(()=>{
        //This discards boolean result. Main goal here is to track completion
        }).catch((error)=>{
            $4eyTY.Log.error('Error during scheduled flush:', error);
        }).finally(()=>{
            this._currentFlushPromise = null;
            this._scheduleNextFlush();
        });
    }
    processLimitFlush() {
        if (!this._flushInterval.hasCompletelyRecoveredFromBackoff()) return;
        if (this._currentFlushPromise) return;
        this._currentFlushPromise = this._processLimitFlushInternal().catch((error)=>{
            $4eyTY.Log.error(`Error during limit flush`, error);
        }).finally(()=>{
            this._currentFlushPromise = null;
            this._scheduleNextFlush();
        });
    }
    _processLimitFlushInternal() {
        return $ce7e18c36f2148af$var$__awaiter(this, void 0, void 0, function*() {
            const success = yield this._processNextBatch($9j9vO.FlushType.Limit);
            if (!success) return;
            while(this._flushInterval.hasCompletelyRecoveredFromBackoff() && this.containsAtLeastOneFullBatch()){
                const success = yield this._processNextBatch($9j9vO.FlushType.Limit);
                if (!success) break;
            }
        });
    }
    _scheduleNextFlush() {
        this._clearAllTimers();
        if (this._isShuttingDown) return;
        const cooldownDelay = Math.max(0, this._flushInterval.getTimeUntilNextFlush());
        this._cooldownTimer = setTimeout(()=>{
            this._cooldownTimer = null;
            $kjI4J.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, cooldownDelay);
        const maxIntervalDelay = Math.max(0, this._flushInterval.getTimeTillMaxInterval());
        this._maxIntervalTimer = setTimeout(()=>{
            this._maxIntervalTimer = null;
            $kjI4J.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, maxIntervalDelay);
    }
    _clearAllTimers() {
        if (this._cooldownTimer !== null) {
            clearTimeout(this._cooldownTimer);
            this._cooldownTimer = null;
        }
        if (this._maxIntervalTimer !== null) {
            clearTimeout(this._maxIntervalTimer);
            this._maxIntervalTimer = null;
        }
    }
    _scheduleNoopPollTick() {
        this._clearAllTimers();
        if (this._isShuttingDown) return;
        this._cooldownTimer = setTimeout(()=>{
            this._cooldownTimer = null;
            $kjI4J.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, $acuuF.EventRetryConstants.TICK_INTERVAL_MS);
        const maxIntervalDelay = Math.max(0, this._flushInterval.getTimeTillMaxInterval());
        this._maxIntervalTimer = setTimeout(()=>{
            this._maxIntervalTimer = null;
            $kjI4J.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, maxIntervalDelay);
    }
    _processNextBatch(flushType) {
        return $ce7e18c36f2148af$var$__awaiter(this, void 0, void 0, function*() {
            this._prepareQueueForFlush(flushType);
            const batch = this._batchQueue.takeNextBatch();
            if (!batch) return false;
            return this._processOneBatch(batch, flushType);
        });
    }
    _processOneBatch(batch, flushType) {
        return $ce7e18c36f2148af$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._eventSender.sendBatch(batch);
            if (result.success) {
                this._flushInterval.adjustForSuccess();
                return true;
            }
            this._flushInterval.adjustForFailure();
            this._handleFailure(batch, flushType, result.statusCode);
            return false;
        });
    }
    _prepareQueueForFlush(flushType) {
        this._onPrepareFlush();
        const droppedCount = this.convertPendingEventsToBatches();
        if (droppedCount > 0) {
            $4eyTY.Log.warn(`Dropped ${droppedCount} events`);
            this._errorBoundary.logDroppedEvents(droppedCount, `Batch queue limit reached`, {
                loggingInterval: this._flushInterval.getCurrentIntervalMs(),
                batchSize: this._batchQueue.batchSize(),
                maxPendingBatches: $acuuF.EventRetryConstants.MAX_PENDING_BATCHES,
                flushType: flushType,
                retries: 'dropped before batching'
            });
        }
    }
    containsAtLeastOneFullBatch() {
        return this._pendingEvents.hasEventsForFullBatch() || this._batchQueue.hasFullBatch();
    }
    convertPendingEventsToBatches() {
        if (this._pendingEvents.isEmpty()) return 0;
        const allEvents = this._pendingEvents.takeAll();
        return this._batchQueue.createBatches(allEvents);
    }
    _handleFailure(batch, flushType, statusCode) {
        if (flushType === $9j9vO.FlushType.Shutdown) {
            $4eyTY.Log.warn(`${flushType} flush failed during shutdown. ` + `${batch.events.length} event(s) will be saved to storage for retry in next session.`);
            this._saveShutdownFailedEventsToStorage(batch.events);
            return;
        }
        if (!$iCe1t.RETRYABLE_CODES.has(statusCode)) {
            $4eyTY.Log.warn(`${flushType} flush failed after ${batch.attempts} attempt(s). ` + `${batch.events.length} event(s) will be dropped. Non-retryable error: ${statusCode}`);
            this._errorBoundary.logEventRequestFailure(batch.events.length, `non-retryable error`, flushType, statusCode, batch.attempts);
            return;
        }
        if (batch.attempts >= $acuuF.EventRetryConstants.MAX_RETRY_ATTEMPTS) {
            $4eyTY.Log.warn(`${flushType} flush failed after ${batch.attempts} attempt(s). ` + `${batch.events.length} event(s) will be dropped.`);
            this._errorBoundary.logEventRequestFailure(batch.events.length, `max retry attempts exceeded`, flushType, statusCode, batch.attempts);
            return;
        }
        batch.incrementAttempts();
        const droppedCount = this._batchQueue.requeueBatch(batch);
        if (droppedCount > 0) {
            $4eyTY.Log.warn(`Failed to requeue batch : dropped ${droppedCount} events due to full queue`);
            this._errorBoundary.logDroppedEvents(droppedCount, `Batch queue limit reached`, {
                loggingInterval: this._flushInterval.getCurrentIntervalMs(),
                batchSize: this._batchQueue.batchSize(),
                maxPendingBatches: $acuuF.EventRetryConstants.MAX_PENDING_BATCHES,
                flushType: flushType,
                retries: batch.attempts
            });
        }
    }
    loadAndRetryShutdownFailedEvents() {
        return $ce7e18c36f2148af$var$__awaiter(this, void 0, void 0, function*() {
            const storageKey = this._getStorageKey();
            try {
                if (!$1U3tc.Storage.isReady()) yield $1U3tc.Storage.isReadyResolver();
                const events = this._getShutdownFailedEventsFromStorage(storageKey);
                if (events.length === 0) return;
                $4eyTY.Log.debug(`Loading ${events.length} failed shutdown event(s) from storage for retry`);
                $1U3tc.Storage.removeItem(storageKey);
                events.forEach((event)=>{
                    this.addEvent(event);
                });
                yield this.processManualFlush();
            } catch (error) {
                $4eyTY.Log.warn('Failed to load and retry failed shutdown events:', error);
            }
        });
    }
    _getStorageKey() {
        if (!this._storageKey) this._storageKey = `statsig.failed_shutdown_events.${(0, $8Ywu8._DJB2)(this._sdkKey)}`;
        return this._storageKey;
    }
    _saveShutdownFailedEventsToStorage(events) {
        const storageKey = this._getStorageKey();
        try {
            const existingEvents = this._getShutdownFailedEventsFromStorage(storageKey);
            let allEvents = [
                ...existingEvents,
                ...events
            ];
            if (allEvents.length > $acuuF.EventRetryConstants.MAX_LOCAL_STORAGE) allEvents = allEvents.slice(-$acuuF.EventRetryConstants.MAX_LOCAL_STORAGE);
            (0, $1U3tc._setObjectInStorage)(storageKey, allEvents);
            $4eyTY.Log.debug(`Saved ${events.length} failed shutdown event(s) to storage (total stored: ${allEvents.length})`);
        } catch (error) {
            $4eyTY.Log.warn('Unable to save failed shutdown events to storage:', error);
        }
    }
    _getShutdownFailedEventsFromStorage(storageKey) {
        try {
            const events = (0, $1U3tc._getObjectFromStorage)(storageKey);
            if (Array.isArray(events)) return events;
            return [];
        } catch (_a) {
            return [];
        }
    }
}
module.exports.FlushCoordinator = $ce7e18c36f2148af$var$FlushCoordinator;

});
parcelRegister("0krQv", function(module, exports) {
"use strict";
var $000fdcc63895aee9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventSender = void 0;

var $4eyTY = parcelRequire("4eyTY");

var $7eSIL = parcelRequire("7eSIL");

var $kpY2F = parcelRequire("kpY2F");
class $000fdcc63895aee9$var$EventSender {
    constructor(sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled){
        this._sdkKey = sdkKey;
        this._network = network;
        this._emitter = emitter;
        this._options = options;
        this._logEventUrlConfig = logEventUrlConfig;
        this._loggingEnabled = loggingEnabled;
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(enabled) {
        this._loggingEnabled = enabled;
    }
    sendBatch(batch) {
        return $000fdcc63895aee9$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                const isClosing = (0, $kpY2F._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: batch.events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(batch) : yield this._sendEventsViaPost(batch);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: batch.events
                    });
                    return response;
                }
                return {
                    success: false,
                    statusCode: response.statusCode
                };
            } catch (error) {
                $4eyTY.Log.warn('Failed to send batch:', error);
                return {
                    success: false,
                    statusCode: -1
                };
            }
        });
    }
    _sendEventsViaPost(batch) {
        return $000fdcc63895aee9$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(batch));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300,
                statusCode: code
            };
        });
    }
    _sendEventsViaBeacon(batch) {
        const success = this._network.beacon(this._getRequestData(batch));
        return {
            success: success,
            statusCode: success ? 200 : -1
        };
    }
    _getRequestData(batch) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: batch.events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$7eSIL.NetworkParam.EventCount]: String(batch.events.length)
            },
            headers: {
                'statsig-event-count': String(batch.events.length),
                'statsig-retry-count': String(batch.attempts)
            },
            credentials: 'same-origin'
        };
    }
}
module.exports.EventSender = $000fdcc63895aee9$var$EventSender;

});
parcelRegister("7eSIL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("kpY2F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $8L4K3 = parcelRequire("8L4K3");
const $edd4b78c697d9641$var$FOREGROUND = 'foreground';
const $edd4b78c697d9641$var$BACKGROUND = 'background';
const $edd4b78c697d9641$var$LISTENERS = [];
let $edd4b78c697d9641$var$current = $edd4b78c697d9641$var$FOREGROUND;
let $edd4b78c697d9641$var$isUnloading = false;
const $edd4b78c697d9641$var$_isCurrentlyVisible = ()=>{
    return $edd4b78c697d9641$var$current === $edd4b78c697d9641$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $edd4b78c697d9641$var$_isCurrentlyVisible;
const $edd4b78c697d9641$var$_isUnloading = ()=>$edd4b78c697d9641$var$isUnloading;
module.exports._isUnloading = $edd4b78c697d9641$var$_isUnloading;
const $edd4b78c697d9641$var$_subscribeToVisiblityChanged = (listener)=>{
    $edd4b78c697d9641$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $edd4b78c697d9641$var$_subscribeToVisiblityChanged;
const $edd4b78c697d9641$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $edd4b78c697d9641$var$current) return;
    $edd4b78c697d9641$var$current = visibility;
    $edd4b78c697d9641$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $edd4b78c697d9641$var$_notifyVisibilityChanged;
(0, $8L4K3._addWindowEventListenerSafe)('focus', ()=>{
    $edd4b78c697d9641$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($edd4b78c697d9641$var$FOREGROUND);
});
(0, $8L4K3._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($edd4b78c697d9641$var$BACKGROUND));
(0, $8L4K3._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $edd4b78c697d9641$var$FOREGROUND : $edd4b78c697d9641$var$BACKGROUND);
});
(0, $8L4K3._addWindowEventListenerSafe)((0, $8L4K3._getUnloadEvent)(), ()=>{
    $edd4b78c697d9641$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($edd4b78c697d9641$var$BACKGROUND);
});

});
parcelRegister("8L4K3", function(module, exports) {

var $4ilBr = parcelRequire("4ilBr");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._cloneObject = module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;

var $4eyTY = parcelRequire("4eyTY");
const $6606642585d50d4c$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $6606642585d50d4c$var$_getWindowSafe;
const $6606642585d50d4c$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $6606642585d50d4c$var$_getDocumentSafe;
const $6606642585d50d4c$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $4ilBr !== 'undefined' && $4ilBr.versions != null && $4ilBr.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $6606642585d50d4c$var$_isServerEnv;
const $6606642585d50d4c$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $6606642585d50d4c$var$_addWindowEventListenerSafe;
const $6606642585d50d4c$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $6606642585d50d4c$var$_addDocumentEventListenerSafe;
const $6606642585d50d4c$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $6606642585d50d4c$var$_getCurrentPageUrlSafe;
const $6606642585d50d4c$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $6606642585d50d4c$var$_getUnloadEvent;
const $6606642585d50d4c$var$_cloneObject = (tag, obj)=>{
    try {
        return JSON.parse(JSON.stringify(obj));
    } catch (error) {
        $4eyTY.Log.error(`Failed to clone object ${tag}`);
        return null;
    }
};
module.exports._cloneObject = $6606642585d50d4c$var$_cloneObject;

});
parcelRegister("4ilBr", function(module, exports) {
// shim for using process in browser
var $320999c4901a106c$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $320999c4901a106c$var$cachedSetTimeout;
var $320999c4901a106c$var$cachedClearTimeout;
function $320999c4901a106c$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $320999c4901a106c$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $320999c4901a106c$var$cachedSetTimeout = setTimeout;
        else $320999c4901a106c$var$cachedSetTimeout = $320999c4901a106c$var$defaultSetTimout;
    } catch (e) {
        $320999c4901a106c$var$cachedSetTimeout = $320999c4901a106c$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $320999c4901a106c$var$cachedClearTimeout = clearTimeout;
        else $320999c4901a106c$var$cachedClearTimeout = $320999c4901a106c$var$defaultClearTimeout;
    } catch (e) {
        $320999c4901a106c$var$cachedClearTimeout = $320999c4901a106c$var$defaultClearTimeout;
    }
})();
function $320999c4901a106c$var$runTimeout(fun) {
    if ($320999c4901a106c$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($320999c4901a106c$var$cachedSetTimeout === $320999c4901a106c$var$defaultSetTimout || !$320999c4901a106c$var$cachedSetTimeout) && setTimeout) {
        $320999c4901a106c$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $320999c4901a106c$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $320999c4901a106c$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $320999c4901a106c$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $320999c4901a106c$var$runClearTimeout(marker) {
    if ($320999c4901a106c$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($320999c4901a106c$var$cachedClearTimeout === $320999c4901a106c$var$defaultClearTimeout || !$320999c4901a106c$var$cachedClearTimeout) && clearTimeout) {
        $320999c4901a106c$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $320999c4901a106c$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $320999c4901a106c$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $320999c4901a106c$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $320999c4901a106c$var$queue = [];
var $320999c4901a106c$var$draining = false;
var $320999c4901a106c$var$currentQueue;
var $320999c4901a106c$var$queueIndex = -1;
function $320999c4901a106c$var$cleanUpNextTick() {
    if (!$320999c4901a106c$var$draining || !$320999c4901a106c$var$currentQueue) return;
    $320999c4901a106c$var$draining = false;
    if ($320999c4901a106c$var$currentQueue.length) $320999c4901a106c$var$queue = $320999c4901a106c$var$currentQueue.concat($320999c4901a106c$var$queue);
    else $320999c4901a106c$var$queueIndex = -1;
    if ($320999c4901a106c$var$queue.length) $320999c4901a106c$var$drainQueue();
}
function $320999c4901a106c$var$drainQueue() {
    if ($320999c4901a106c$var$draining) return;
    var timeout = $320999c4901a106c$var$runTimeout($320999c4901a106c$var$cleanUpNextTick);
    $320999c4901a106c$var$draining = true;
    var len = $320999c4901a106c$var$queue.length;
    while(len){
        $320999c4901a106c$var$currentQueue = $320999c4901a106c$var$queue;
        $320999c4901a106c$var$queue = [];
        while(++$320999c4901a106c$var$queueIndex < len)if ($320999c4901a106c$var$currentQueue) $320999c4901a106c$var$currentQueue[$320999c4901a106c$var$queueIndex].run();
        $320999c4901a106c$var$queueIndex = -1;
        len = $320999c4901a106c$var$queue.length;
    }
    $320999c4901a106c$var$currentQueue = null;
    $320999c4901a106c$var$draining = false;
    $320999c4901a106c$var$runClearTimeout(timeout);
}
$320999c4901a106c$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $320999c4901a106c$var$queue.push(new $320999c4901a106c$var$Item(fun, args));
    if ($320999c4901a106c$var$queue.length === 1 && !$320999c4901a106c$var$draining) $320999c4901a106c$var$runTimeout($320999c4901a106c$var$drainQueue);
};
// v8 likes predictible objects
function $320999c4901a106c$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$320999c4901a106c$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$320999c4901a106c$var$process.title = 'browser';
$320999c4901a106c$var$process.browser = true;
$320999c4901a106c$var$process.env = {};
$320999c4901a106c$var$process.argv = [];
$320999c4901a106c$var$process.version = ''; // empty string to avoid regexp issues
$320999c4901a106c$var$process.versions = {};
function $320999c4901a106c$var$noop() {}
$320999c4901a106c$var$process.on = $320999c4901a106c$var$noop;
$320999c4901a106c$var$process.addListener = $320999c4901a106c$var$noop;
$320999c4901a106c$var$process.once = $320999c4901a106c$var$noop;
$320999c4901a106c$var$process.off = $320999c4901a106c$var$noop;
$320999c4901a106c$var$process.removeListener = $320999c4901a106c$var$noop;
$320999c4901a106c$var$process.removeAllListeners = $320999c4901a106c$var$noop;
$320999c4901a106c$var$process.emit = $320999c4901a106c$var$noop;
$320999c4901a106c$var$process.prependListener = $320999c4901a106c$var$noop;
$320999c4901a106c$var$process.prependOnceListener = $320999c4901a106c$var$noop;
$320999c4901a106c$var$process.listeners = function(name) {
    return [];
};
$320999c4901a106c$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$320999c4901a106c$var$process.cwd = function() {
    return '/';
};
$320999c4901a106c$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$320999c4901a106c$var$process.umask = function() {
    return 0;
};

});




parcelRegister("it0CE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushInterval = void 0;
const $d71b6b043179367e$var$MIN_FLUSH_INTERVAL_MS = 1000;
const $d71b6b043179367e$var$MAX_FLUSH_INTERVAL_MS = 60000;
class $d71b6b043179367e$var$FlushInterval {
    constructor(){
        this._currentIntervalMs = $d71b6b043179367e$var$MIN_FLUSH_INTERVAL_MS;
        this._lastFlushAttemptTime = Date.now();
    }
    getCurrentIntervalMs() {
        return this._currentIntervalMs;
    }
    markFlushAttempt() {
        this._lastFlushAttemptTime = Date.now();
    }
    getTimeSinceLastAttempt() {
        return Date.now() - this._lastFlushAttemptTime;
    }
    hasReachedMaxInterval() {
        return this.getTimeSinceLastAttempt() >= $d71b6b043179367e$var$MAX_FLUSH_INTERVAL_MS;
    }
    getTimeTillMaxInterval() {
        return $d71b6b043179367e$var$MAX_FLUSH_INTERVAL_MS - this.getTimeSinceLastAttempt();
    }
    hasCompletelyRecoveredFromBackoff() {
        return this._currentIntervalMs <= $d71b6b043179367e$var$MIN_FLUSH_INTERVAL_MS;
    }
    adjustForSuccess() {
        const current = this._currentIntervalMs;
        if (current === $d71b6b043179367e$var$MIN_FLUSH_INTERVAL_MS) return;
        this._currentIntervalMs = Math.max($d71b6b043179367e$var$MIN_FLUSH_INTERVAL_MS, Math.floor(current / 2));
    }
    adjustForFailure() {
        const current = this._currentIntervalMs;
        this._currentIntervalMs = Math.min($d71b6b043179367e$var$MAX_FLUSH_INTERVAL_MS, current * 2);
    }
    getTimeUntilNextFlush() {
        return this.getCurrentIntervalMs() - this.getTimeSinceLastAttempt();
    }
}
module.exports.FlushInterval = $d71b6b043179367e$var$FlushInterval;

});

parcelRegister("9j9vO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushType = void 0;
/* eslint-disable no-restricted-syntax */ var $6c6d4455377b613b$var$FlushType;
(function(FlushType) {
    FlushType["ScheduledMaxTime"] = "scheduled:max_time";
    FlushType["ScheduledFullBatch"] = "scheduled:full_batch";
    FlushType["Limit"] = "limit";
    FlushType["Manual"] = "manual";
    FlushType["Shutdown"] = "shutdown";
})($6c6d4455377b613b$var$FlushType || (module.exports.FlushType = $6c6d4455377b613b$var$FlushType = {}));

});

parcelRegister("iCe1t", function(module, exports) {
"use strict";
var $d8d6a73726d773ec$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = module.exports.RETRYABLE_CODES = void 0;

var $lc1Yh = parcelRequire("lc1Yh");

var $lc1Yh = parcelRequire("lc1Yh");

var $7lHaj = parcelRequire("7lHaj");

var $4eyTY = parcelRequire("4eyTY");

var $7eSIL = parcelRequire("7eSIL");

var $9Npvn = parcelRequire("9Npvn");

var $bSQMM = parcelRequire("bSQMM");

var $32SUK = parcelRequire("32SUK");

var $8L4K3 = parcelRequire("8L4K3");

var $kjI4J = parcelRequire("kjI4J");

var $bJwln = parcelRequire("bJwln");

var $aWuDn = parcelRequire("aWuDn");

var $aOdQW = parcelRequire("aOdQW");

var $ekYEt = parcelRequire("ekYEt");

var $kpY2F = parcelRequire("kpY2F");
const $d8d6a73726d773ec$var$DEFAULT_TIMEOUT_MS = 10000;
const $d8d6a73726d773ec$var$BACKOFF_BASE_MS = 500;
const $d8d6a73726d773ec$var$BACKOFF_MAX_MS = 30000;
const $d8d6a73726d773ec$var$RATE_LIMIT_WINDOW_MS = 1000;
const $d8d6a73726d773ec$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $d8d6a73726d773ec$var$LEAK_RATE = $d8d6a73726d773ec$var$RATE_LIMIT_MAX_REQ_COUNT / $d8d6a73726d773ec$var$RATE_LIMIT_WINDOW_MS;
module.exports.RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $d8d6a73726d773ec$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $d8d6a73726d773ec$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $9Npvn.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$d8d6a73726d773ec$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $d8d6a73726d773ec$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $d8d6a73726d773ec$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$d8d6a73726d773ec$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $4eyTY.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $kpY2F._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $d8d6a73726d773ec$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $d8d6a73726d773ec$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $d8d6a73726d773ec$var$_getErrorMessage(error);
                const timedOut = $d8d6a73726d773ec$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $d8d6a73726d773ec$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !module.exports.RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $aWuDn.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $4eyTY.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $d8d6a73726d773ec$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $ekYEt.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $ekYEt.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $d8d6a73726d773ec$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $d8d6a73726d773ec$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $7eSIL.Endpoint._initialize || args.urlConfig.endpoint === $7eSIL.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$7eSIL.NetworkParam.SdkKey]: args.sdkKey,
            [$7eSIL.NetworkParam.SdkType]: $32SUK.SDKType._get(args.sdkKey),
            [$7eSIL.NetworkParam.SdkVersion]: $aOdQW.SDK_VERSION,
            [$7eSIL.NetworkParam.Time]: String(Date.now()),
            [$7eSIL.NetworkParam.SessionID]: $kjI4J.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $8L4K3._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $lc1Yh._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$7eSIL.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $4eyTY.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $d8d6a73726d773ec$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$d8d6a73726d773ec$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($4eyTY.Log.error);
                writer.close().catch($4eyTY.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$7eSIL.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $4eyTY.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $d8d6a73726d773ec$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $d8d6a73726d773ec$var$NetworkCore;
const $d8d6a73726d773ec$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $4eyTY.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $d8d6a73726d773ec$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $bJwln.StableID.get(sdkKey);
    const sessionID = $kjI4J.SessionID.get(sdkKey);
    const sdkType = $32SUK.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $aOdQW.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $d8d6a73726d773ec$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $lc1Yh._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $bSQMM.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $ekYEt.LogEventCompressionMode.Disabled:
            return false;
        case $ekYEt.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $ekYEt.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $d8d6a73726d773ec$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $d8d6a73726d773ec$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $d8d6a73726d773ec$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $7eSIL.Endpoint._initialize) return;
    $7lHaj.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $d8d6a73726d773ec$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $7eSIL.Endpoint._initialize) return;
    $7lHaj.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $7lHaj.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $d8d6a73726d773ec$var$_exponentialBackoff(attempt) {
    return $d8d6a73726d773ec$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($d8d6a73726d773ec$var$BACKOFF_BASE_MS * (attempt * attempt), $d8d6a73726d773ec$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("9Npvn", function(module, exports) {
"use strict";
var $721c796da9bad8a0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $80mNy = parcelRequire("80mNy");

var $8Ywu8 = parcelRequire("8Ywu8");

var $4eyTY = parcelRequire("4eyTY");

var $1U3tc = parcelRequire("1U3tc");
const $721c796da9bad8a0$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $721c796da9bad8a0$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $721c796da9bad8a0$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $721c796da9bad8a0$var$DEFAULT_TTL_MS;
        $721c796da9bad8a0$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $721c796da9bad8a0$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $721c796da9bad8a0$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $721c796da9bad8a0$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$721c796da9bad8a0$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $721c796da9bad8a0$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $721c796da9bad8a0$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $721c796da9bad8a0$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $721c796da9bad8a0$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $80mNy._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $721c796da9bad8a0$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $721c796da9bad8a0$var$NetworkFallbackResolver;
function $721c796da9bad8a0$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $721c796da9bad8a0$var$_isDomainFailure;
function $721c796da9bad8a0$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $8Ywu8._DJB2)(sdkKey)}`;
}
function $721c796da9bad8a0$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $721c796da9bad8a0$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $1U3tc.Storage.removeItem(hashKey);
        return;
    }
    $1U3tc.Storage.setItem(hashKey, JSON.stringify(info));
}
function $721c796da9bad8a0$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $721c796da9bad8a0$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $1U3tc.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $4eyTY.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $721c796da9bad8a0$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("80mNy", function(module, exports) {
"use strict";
var $5d4002184f3e5941$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $5d4002184f3e5941$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $5d4002184f3e5941$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $5d4002184f3e5941$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $5d4002184f3e5941$var$MAX_START_LOOKUP = 200;
function $5d4002184f3e5941$var$_fetchTxtRecords(networkFunc) {
    return $5d4002184f3e5941$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($5d4002184f3e5941$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $5d4002184f3e5941$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $5d4002184f3e5941$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $5d4002184f3e5941$var$_fetchTxtRecords;
function $5d4002184f3e5941$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $5d4002184f3e5941$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $5d4002184f3e5941$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});

parcelRegister("1U3tc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $4eyTY = parcelRequire("4eyTY");

var $8L4K3 = parcelRequire("8L4K3");
const $162db674e94419df$var$inMemoryStore = {};
const $162db674e94419df$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$162db674e94419df$var$inMemoryStore[key] ? $162db674e94419df$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $162db674e94419df$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $162db674e94419df$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($162db674e94419df$var$inMemoryStore)
};
let $162db674e94419df$var$_localStorageProvider = null;
try {
    const win = (0, $8L4K3._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $162db674e94419df$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $4eyTY.Log.warn('Failed to setup localStorageProvider.');
}
let $162db674e94419df$var$_main = $162db674e94419df$var$_localStorageProvider !== null && $162db674e94419df$var$_localStorageProvider !== void 0 ? $162db674e94419df$var$_localStorageProvider : $162db674e94419df$var$_inMemoryProvider;
let $162db674e94419df$var$_current = $162db674e94419df$var$_main;
function $162db674e94419df$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($162db674e94419df$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$162db674e94419df$var$_current.isReady(),
    isReadyResolver: ()=>$162db674e94419df$var$_current.isReadyResolver(),
    getProviderName: ()=>$162db674e94419df$var$_current.getProviderName(),
    getItem: (key)=>$162db674e94419df$var$_inMemoryBreaker(()=>$162db674e94419df$var$_current.getItem(key)),
    setItem: (key, value)=>$162db674e94419df$var$_inMemoryBreaker(()=>$162db674e94419df$var$_current.setItem(key, value)),
    removeItem: (key)=>$162db674e94419df$var$_current.removeItem(key),
    getAllKeys: ()=>$162db674e94419df$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $162db674e94419df$var$_main = newProvider;
        $162db674e94419df$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $162db674e94419df$var$_current = $162db674e94419df$var$_inMemoryProvider;
        else $162db674e94419df$var$_current = $162db674e94419df$var$_main;
    }
};
function $162db674e94419df$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $4eyTY.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $162db674e94419df$var$_getObjectFromStorage;
function $162db674e94419df$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $162db674e94419df$var$_setObjectInStorage;

});


parcelRegister("bSQMM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $8a6daefc4d81bdb0$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $8a6daefc4d81bdb0$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $8a6daefc4d81bdb0$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("32SUK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $237c27d1b1f1a6cf$var$SDK_CLIENT = {};
let $237c27d1b1f1a6cf$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $237c27d1b1f1a6cf$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($237c27d1b1f1a6cf$var$suffix !== null && $237c27d1b1f1a6cf$var$suffix !== void 0 ? $237c27d1b1f1a6cf$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $237c27d1b1f1a6cf$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$237c27d1b1f1a6cf$var$suffix || $237c27d1b1f1a6cf$var$suffix === '-react') $237c27d1b1f1a6cf$var$suffix = '-' + binding;
    }
};

});

parcelRegister("kjI4J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $lsCkt = parcelRequire("lsCkt");

var $4eyTY = parcelRequire("4eyTY");

var $1U3tc = parcelRequire("1U3tc");

var $69ZmD = parcelRequire("69ZmD");

var $kpY2F = parcelRequire("kpY2F");
const $eca7c56f0945d3cd$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $eca7c56f0945d3cd$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $eca7c56f0945d3cd$var$PERSIST_THROTTLE_MS = 15000;
const $eca7c56f0945d3cd$var$SESSION_MAP = {};
(0, $kpY2F._subscribeToVisiblityChanged)((visibility)=>{
    if (visibility === 'background') Object.values($eca7c56f0945d3cd$var$SESSION_MAP).forEach((session)=>$eca7c56f0945d3cd$var$_persistNow(session));
});
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey, bumpSession = true)=>{
        if ($eca7c56f0945d3cd$var$SESSION_MAP[sdkKey] == null) $eca7c56f0945d3cd$var$SESSION_MAP[sdkKey] = $eca7c56f0945d3cd$var$_loadOrCreateSharedSession(sdkKey);
        const session = $eca7c56f0945d3cd$var$SESSION_MAP[sdkKey];
        return $eca7c56f0945d3cd$var$_maybeBumpSession(session, bumpSession);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        const now = Date.now();
        const session = {
            data: {
                sessionID: override,
                startTime: now,
                lastUpdate: now
            },
            sdkKey: sdkKey,
            lastPersistedAt: Date.now(),
            storageKey: $eca7c56f0945d3cd$var$_getSessionIDStorageKey(sdkKey)
        };
        $eca7c56f0945d3cd$var$_persistNow(session);
        $eca7c56f0945d3cd$var$SESSION_MAP[sdkKey] = session;
    },
    checkForIdleSession: (sdkKey)=>{
        const session = $eca7c56f0945d3cd$var$SESSION_MAP[sdkKey];
        if (!session) return;
        const sessionExpired = $eca7c56f0945d3cd$var$_checkForExpiredSession(session);
        if (sessionExpired) $eca7c56f0945d3cd$var$_persistNow(session);
    }
};
function $eca7c56f0945d3cd$var$_maybeBumpSession(session, allowSessionBump) {
    const now = Date.now();
    const sessionExpired = $eca7c56f0945d3cd$var$_checkForExpiredSession(session);
    if (sessionExpired) $eca7c56f0945d3cd$var$_persistNow(session);
    else if (allowSessionBump) {
        session.data.lastUpdate = now;
        $eca7c56f0945d3cd$var$_persistThrottled(session);
    }
    return session;
}
function $eca7c56f0945d3cd$var$_checkForExpiredSession(session) {
    var _a;
    const data = session.data;
    const sessionExpired = $eca7c56f0945d3cd$var$_isIdle(data) || $eca7c56f0945d3cd$var$_hasRunTooLong(data);
    if (sessionExpired) {
        session.data = $eca7c56f0945d3cd$var$_newSessionData();
        (_a = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(session.sdkKey)) === null || _a === void 0 || _a.$emt({
            name: 'session_expired'
        });
    }
    return sessionExpired;
}
function $eca7c56f0945d3cd$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $eca7c56f0945d3cd$var$MAX_SESSION_IDLE_TIME;
}
function $eca7c56f0945d3cd$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $eca7c56f0945d3cd$var$MAX_SESSION_AGE;
}
function $eca7c56f0945d3cd$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $lsCkt._getStorageKey)(sdkKey)}`;
}
function $eca7c56f0945d3cd$var$_persistNow(session) {
    try {
        (0, $1U3tc._setObjectInStorage)(session.storageKey, session.data);
        session.lastPersistedAt = Date.now();
    } catch (e) {
        $4eyTY.Log.warn('Failed to save SessionID');
    }
}
function $eca7c56f0945d3cd$var$_persistThrottled(session) {
    const now = Date.now();
    if (now - session.lastPersistedAt > $eca7c56f0945d3cd$var$PERSIST_THROTTLE_MS) $eca7c56f0945d3cd$var$_persistNow(session);
}
function $eca7c56f0945d3cd$var$_loadSessionFromStorage(storageKey) {
    const data = (0, $1U3tc._getObjectFromStorage)(storageKey);
    return data;
}
function $eca7c56f0945d3cd$var$_loadOrCreateSharedSession(sdkKey) {
    const storageKey = $eca7c56f0945d3cd$var$_getSessionIDStorageKey(sdkKey);
    const existing = $eca7c56f0945d3cd$var$_loadSessionFromStorage(storageKey);
    if (existing && existing.sessionID && existing.startTime && existing.lastUpdate) return {
        data: existing,
        sdkKey: sdkKey,
        lastPersistedAt: 0,
        storageKey: storageKey
    };
    return {
        data: $eca7c56f0945d3cd$var$_newSessionData(),
        sdkKey: sdkKey,
        lastPersistedAt: 0,
        storageKey: storageKey
    };
}
function $eca7c56f0945d3cd$var$_newSessionData() {
    return {
        sessionID: (0, $69ZmD.getUUID)(),
        startTime: Date.now(),
        lastUpdate: Date.now()
    };
}

});
parcelRegister("69ZmD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $47c32ef3e29f2060$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $47c32ef3e29f2060$var$getUUID;

});


parcelRegister("bJwln", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $lsCkt = parcelRequire("lsCkt");

var $4eyTY = parcelRequire("4eyTY");

var $8L4K3 = parcelRequire("8L4K3");

var $1U3tc = parcelRequire("1U3tc");

var $69ZmD = parcelRequire("69ZmD");
const $88acfc768c7cafc7$var$PROMISE_MAP = {};
const $88acfc768c7cafc7$var$COOKIE_ENABLED_MAP = {};
const $88acfc768c7cafc7$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($88acfc768c7cafc7$var$DISABLED_MAP[sdkKey]) return null;
        if ($88acfc768c7cafc7$var$PROMISE_MAP[sdkKey] != null) return $88acfc768c7cafc7$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $88acfc768c7cafc7$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $88acfc768c7cafc7$var$PROMISE_MAP[sdkKey] = stableID;
            $88acfc768c7cafc7$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $88acfc768c7cafc7$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $69ZmD.getUUID)();
        $88acfc768c7cafc7$var$_persistToStorage(stableID, sdkKey);
        $88acfc768c7cafc7$var$_persistToCookie(stableID, sdkKey);
        $88acfc768c7cafc7$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $88acfc768c7cafc7$var$PROMISE_MAP[sdkKey] = override;
        $88acfc768c7cafc7$var$_persistToStorage(override, sdkKey);
        $88acfc768c7cafc7$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $88acfc768c7cafc7$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $88acfc768c7cafc7$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $88acfc768c7cafc7$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $lsCkt._getStorageKey)(sdkKey)}`;
}
function $88acfc768c7cafc7$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $88acfc768c7cafc7$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $1U3tc._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $4eyTY.Log.warn('Failed to save StableID to storage');
    }
}
function $88acfc768c7cafc7$var$_loadFromStorage(sdkKey) {
    const storageKey = $88acfc768c7cafc7$var$_getStableIDStorageKey(sdkKey);
    return (0, $1U3tc._getObjectFromStorage)(storageKey);
}
function $88acfc768c7cafc7$var$_loadFromCookie(sdkKey) {
    if (!$88acfc768c7cafc7$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $8L4K3._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $88acfc768c7cafc7$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $88acfc768c7cafc7$var$_persistToCookie(stableID, sdkKey) {
    if (!$88acfc768c7cafc7$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $8L4K3._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$88acfc768c7cafc7$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $88acfc768c7cafc7$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $lsCkt._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $88acfc768c7cafc7$var$getCookieName;

});

parcelRegister("aWuDn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});

parcelRegister("aOdQW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.32.0';
let $7de951cf820f1965$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$7de951cf820f1965$var$metadata,
    add: (additions)=>{
        $7de951cf820f1965$var$metadata = Object.assign(Object.assign({}, $7de951cf820f1965$var$metadata), additions);
    }
};

});

parcelRegister("ekYEt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});



parcelRegister("lbci3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PendingEvents = void 0;

var $4eyTY = parcelRequire("4eyTY");
class $f6b428a200956243$var$PendingEvents {
    constructor(batchSize){
        this._pendingEvents = [];
        this._batchSize = batchSize;
    }
    addToPendingEventsQueue(event) {
        this._pendingEvents.push(event);
        $4eyTY.Log.debug('Enqueued Event:', event);
    }
    hasEventsForFullBatch() {
        return this._pendingEvents.length >= this._batchSize;
    }
    takeAll() {
        const events = this._pendingEvents;
        this._pendingEvents = [];
        return events;
    }
    isEmpty() {
        return this._pendingEvents.length === 0;
    }
}
module.exports.PendingEvents = $f6b428a200956243$var$PendingEvents;

});

parcelRegister("aiMrf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $780128b225429e8d$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $780128b225429e8d$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $780128b225429e8d$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $780128b225429e8d$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $780128b225429e8d$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $780128b225429e8d$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $780128b225429e8d$var$GATE_EXPOSURE_NAME || eventName === $780128b225429e8d$var$CONFIG_EXPOSURE_NAME || eventName === $780128b225429e8d$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $780128b225429e8d$var$_isExposureEvent;
const $780128b225429e8d$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $780128b225429e8d$var$_createExposure($780128b225429e8d$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $780128b225429e8d$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $780128b225429e8d$var$_createGateExposure;
function $780128b225429e8d$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $780128b225429e8d$var$_mapExposures;
const $780128b225429e8d$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $780128b225429e8d$var$_createExposure($780128b225429e8d$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $780128b225429e8d$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $780128b225429e8d$var$_createConfigExposure;
const $780128b225429e8d$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $780128b225429e8d$var$_createExposure($780128b225429e8d$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $780128b225429e8d$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $780128b225429e8d$var$_createLayerParameterExposure;
const $780128b225429e8d$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("5ygvB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $8Ywu8 = parcelRequire("8Ywu8");

var $7eSIL = parcelRequire("7eSIL");
const $40acef02013ff257$var$ENDPOINT_DNS_KEY_MAP = {
    [$7eSIL.Endpoint._initialize]: 'i',
    [$7eSIL.Endpoint._rgstr]: 'e',
    [$7eSIL.Endpoint._download_config_specs]: 'd'
};
class $40acef02013ff257$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $40acef02013ff257$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $7eSIL.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $8Ywu8._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $40acef02013ff257$var$UrlConfiguration;

});


parcelRegister("cyN1n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecomputedEvaluationsContextHandle = void 0;

var $4eyTY = parcelRequire("4eyTY");

var $8L4K3 = parcelRequire("8L4K3");

var $kjI4J = parcelRequire("kjI4J");

var $bJwln = parcelRequire("bJwln");
/**
 * A handle to the PrecomputedEvaluationsContext that computes fields lazily on access.
 * This avoids unnecessary computation (e.g., cloning the user) when only certain fields are needed.
 * The handle is created once and reused; individual getters fetch current values on each access.
 */ class $924eaf9f24acae74$var$PrecomputedEvaluationsContextHandle {
    constructor(sdkKey, getOptions, getErrorBoundary, getValues, getUser, getSdkInstanceID){
        this._sdkKey = sdkKey;
        this._getOptions = getOptions;
        this._getErrorBoundary = getErrorBoundary;
        this._getValues = getValues;
        this._getUser = getUser;
        this._getSdkInstanceID = getSdkInstanceID;
    }
    get sdkKey() {
        return this._sdkKey;
    }
    get options() {
        return this._getOptions();
    }
    get errorBoundary() {
        return this._getErrorBoundary();
    }
    get values() {
        return this._getValues();
    }
    get user() {
        let user = (0, $8L4K3._cloneObject)('StatsigUser', this._getUser());
        if (user == null) {
            $4eyTY.Log.error('Failed to clone user');
            user = {};
        }
        return user;
    }
    /**
     * Gets the current session.
     * @param {boolean} [bumpSession=true] - Whether to bump/update the session timing. Set to false to read without affecting session state.
     */ getSession(bumpSession = true) {
        return $kjI4J.StatsigSession.get(this._sdkKey, bumpSession);
    }
    get stableID() {
        return $bJwln.StableID.get(this._sdkKey);
    }
    get sdkInstanceID() {
        return this._getSdkInstanceID();
    }
    /**
     * Returns the full PrecomputedEvaluationsContext object.
     * Use this when you need all fields at once.
     * @param {boolean} [bumpSession=true] - Whether to bump the session when building the context.
     */ toContext(bumpSession = true) {
        return {
            sdkKey: this.sdkKey,
            options: this.options,
            values: this.values,
            user: this.user,
            errorBoundary: this.errorBoundary,
            session: this.getSession(bumpSession),
            stableID: this.stableID,
            sdkInstanceID: this.sdkInstanceID
        };
    }
}
module.exports.PrecomputedEvaluationsContextHandle = $924eaf9f24acae74$var$PrecomputedEvaluationsContextHandle;

});

parcelRegister("lwUKx", function(module, exports) {
"use strict";
var $fac89b6f8b8fc330$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $4eyTY = parcelRequire("4eyTY");

var $bJwln = parcelRequire("bJwln");

var $3ZLU1 = parcelRequire("3ZLU1");

var $1U3tc = parcelRequire("1U3tc");

var $avuBW = parcelRequire("avuBW");
const $fac89b6f8b8fc330$var$CACHE_LIMIT = 10;
const $fac89b6f8b8fc330$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $fac89b6f8b8fc330$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $fac89b6f8b8fc330$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $fac89b6f8b8fc330$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $3ZLU1._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $3ZLU1._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $fac89b6f8b8fc330$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $bJwln.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $fac89b6f8b8fc330$var$__awaiter(this, void 0, void 0, function*() {
            if (!$1U3tc.Storage.isReady()) yield $1U3tc.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $4eyTY.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $fac89b6f8b8fc330$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $3ZLU1._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $fac89b6f8b8fc330$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $4eyTY.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $avuBW._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $bJwln.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $fac89b6f8b8fc330$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $fac89b6f8b8fc330$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $4eyTY.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $1U3tc.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($1U3tc.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $avuBW._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $fac89b6f8b8fc330$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $1U3tc.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $1U3tc._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $fac89b6f8b8fc330$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $1U3tc.Storage.removeItem(evictable);
        }
        (0, $1U3tc._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $fac89b6f8b8fc330$var$DataAdapterCore;
function $fac89b6f8b8fc330$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $3ZLU1._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $fac89b6f8b8fc330$var$_makeDataAdapterResult;
class $fac89b6f8b8fc330$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $4eyTY.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $fac89b6f8b8fc330$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $fac89b6f8b8fc330$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("3ZLU1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnitIDFromUser = module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $8Ywu8 = parcelRequire("8Ywu8");

var $4eyTY = parcelRequire("4eyTY");

var $8L4K3 = parcelRequire("8L4K3");
function $2e8c3a118d245074$var$_normalizeUser(original, options, fallbackEnvironment) {
    const copy = (0, $8L4K3._cloneObject)('StatsigUser', original);
    if (copy == null) {
        $4eyTY.Log.error('Failed to clone user');
        return {
            statsigEnvironment: undefined
        };
    }
    if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
    else if (fallbackEnvironment != null) copy.statsigEnvironment = {
        tier: fallbackEnvironment
    };
    return copy;
}
module.exports._normalizeUser = $2e8c3a118d245074$var$_normalizeUser;
function $2e8c3a118d245074$var$_getFullUserHash(user) {
    return user ? (0, $8Ywu8._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $2e8c3a118d245074$var$_getFullUserHash;
function $2e8c3a118d245074$var$_getUnitIDFromUser(user, idType) {
    var _a, _b, _c;
    if (typeof idType !== 'string') return user.userID;
    const lowered = idType.toLowerCase();
    if (lowered !== 'userid') return (_b = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a[idType]) !== null && _b !== void 0 ? _b : (_c = user.customIDs) === null || _c === void 0 ? void 0 : _c[lowered];
    return user.userID;
}
module.exports._getUnitIDFromUser = $2e8c3a118d245074$var$_getUnitIDFromUser;

});

parcelRegister("avuBW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $4eyTY = parcelRequire("4eyTY");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $7a648b523933609e$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $4eyTY.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $7a648b523933609e$var$_typedJsonParse;

});


parcelRegister("ktpCg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4zVoZ", function(module, exports) {
"use strict";
var $3556f52a3f51d14a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $4eyTY = parcelRequire("4eyTY");

var $32SUK = parcelRequire("32SUK");

var $aOdQW = parcelRequire("aOdQW");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $3556f52a3f51d14a$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $3556f52a3f51d14a$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $3556f52a3f51d14a$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    logDroppedEvents(count, reason, metadata) {
        const extra = {
            eventCount: String(count)
        };
        if (metadata) Object.keys(metadata).forEach((key)=>{
            extra[key] = String(metadata[key]);
        });
        this._onError(`statsig::log_event_dropped_event_count`, new Error(reason), true, extra);
    }
    logEventRequestFailure(count, reason, flushType, statusCode, retries) {
        const extra = {
            eventCount: String(count),
            flushType: flushType,
            statusCode: String(statusCode),
            reason: reason,
            retries: String(retries)
        };
        this._onError(`statsig::log_event_failed`, new Error(reason), true, extra);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $3556f52a3f51d14a$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error, bypassDedupe = false, extra) {
        try {
            $4eyTY.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$3556f52a3f51d14a$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($3556f52a3f51d14a$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $3556f52a3f51d14a$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (!bypassDedupe && this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $32SUK.SDKType._get(this._sdkKey);
                    const statsigMetadata = $aOdQW.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $3556f52a3f51d14a$var$_getDescription(unwrapped);
                    const body = Object.assign(Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $3556f52a3f51d14a$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    })), extra !== null && extra !== void 0 ? extra : {});
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $3556f52a3f51d14a$var$ErrorBoundary;
function $3556f52a3f51d14a$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $3556f52a3f51d14a$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $3556f52a3f51d14a$var$UNKNOWN_ERROR;
    }
}
function $3556f52a3f51d14a$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $3556f52a3f51d14a$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});

parcelRegister("o204Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("91DxP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("zsqxF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("keJhv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $ebb83d5e33137a31$var$EXIST_KEYS = new Set([]);
const $ebb83d5e33137a31$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $ebb83d5e33137a31$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($ebb83d5e33137a31$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($ebb83d5e33137a31$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $ebb83d5e33137a31$var$createMemoKey;

});

parcelRegister("8RfNH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jMlYX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ciCcP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $8f44cd6469ca4f9e$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $8f44cd6469ca4f9e$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $8f44cd6469ca4f9e$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $8f44cd6469ca4f9e$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $8f44cd6469ca4f9e$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $8f44cd6469ca4f9e$var$_fastApproxSizeOf;

});

parcelRegister("3Imi3", function(module, exports) {
"use strict";
var $2b46c58539c696df$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $lc1Yh = parcelRequire("lc1Yh");

var $lc1Yh = parcelRequire("lc1Yh");

var $4zVoZ = parcelRequire("4zVoZ");

var $9n7uB = parcelRequire("9n7uB");

var $4eyTY = parcelRequire("4eyTY");

var $keJhv = parcelRequire("keJhv");

var $8L4K3 = parcelRequire("8L4K3");

var $kjI4J = parcelRequire("kjI4J");

var $bJwln = parcelRequire("bJwln");

var $ekYEt = parcelRequire("ekYEt");

var $1U3tc = parcelRequire("1U3tc");
const $2b46c58539c696df$var$MAX_MEMO_CACHE_SIZE = 3000;
class $2b46c58539c696df$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($4eyTY.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $1U3tc.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $kjI4J.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $1U3tc.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $bJwln.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $bJwln.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._errorBoundary = new $4zVoZ.ErrorBoundary(sdkKey, options, emitter);
        this._logger = new $9n7uB.EventLogger(sdkKey, emitter, network, options, this._errorBoundary);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $1U3tc.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $2b46c58539c696df$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $1U3tc.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $bJwln.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($ekYEt.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $2b46c58539c696df$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $4eyTY.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $keJhv.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $2b46c58539c696df$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $2b46c58539c696df$var$StatsigClientBase;
function $2b46c58539c696df$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $8L4K3._isServerEnv)()) return;
    const statsigGlobal = (0, $lc1Yh._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $4eyTY.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("3p9cn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("lf7T8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cOvMz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $4eyTY = parcelRequire("4eyTY");

var $dQaWG = parcelRequire("dQaWG");
function $9542cee3546b118f$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $9542cee3546b118f$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $9542cee3546b118f$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $9542cee3546b118f$var$_makeFeatureGate;
function $9542cee3546b118f$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $9542cee3546b118f$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $9542cee3546b118f$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $9542cee3546b118f$var$_makeDynamicConfig;
function $9542cee3546b118f$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $9542cee3546b118f$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $9542cee3546b118f$var$_makeExperiment;
function $9542cee3546b118f$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $9542cee3546b118f$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $9542cee3546b118f$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $9542cee3546b118f$var$_makeLayer;
function $9542cee3546b118f$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $9542cee3546b118f$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $9542cee3546b118f$var$_mergeOverride;
function $9542cee3546b118f$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $dQaWG._isTypeMatch)(found, fallback)) {
            $4eyTY.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $9542cee3546b118f$var$_makeTypedGet;

});

parcelRegister("9fhNu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dmgUM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $9b9a7357b4b99f7a$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $9b9a7357b4b99f7a$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("3A8ud", function(module, exports) {
"use strict";
var $29bb511d096d3e00$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5SovT = parcelRequire("5SovT");

var $et9Yj = parcelRequire("et9Yj");

var $3rHi6 = parcelRequire("3rHi6");

var $ltvXy = parcelRequire("ltvXy");

var $7mt7r = parcelRequire("7mt7r");
class $29bb511d096d3e00$var$StatsigClient extends $5SovT.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $5SovT._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $29bb511d096d3e00$var$StatsigClient) return instance;
        $5SovT.Log.warn((0, $5SovT._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $29bb511d096d3e00$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $5SovT.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $3rHi6.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $7mt7r.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($5SovT.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($5SovT.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($5SovT.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($5SovT.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($5SovT.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($5SovT.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $et9Yj.default(sdkKey, options !== null && options !== void 0 ? options : null);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $5SovT.getUUID)();
        this._contextHandle = new $5SovT.PrecomputedEvaluationsContextHandle(sdkKey, ()=>this._options, ()=>this._errorBoundary, ()=>this._store.getValues(), ()=>this._user, ()=>this._sdkInstanceID);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $5SovT.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $29bb511d096d3e00$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $5SovT.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $5SovT.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $29bb511d096d3e00$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $29bb511d096d3e00$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $5SovT.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $5SovT.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $5SovT.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $5SovT.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($5SovT.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $5SovT.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $5SovT.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $5SovT.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = (0, $5SovT._cloneObject)('StatsigUser', this._user);
        if (user == null) {
            $5SovT.Log.error('Failed to clone user');
            user = {};
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $5SovT.StatsigSession.get(this._sdkKey),
            stableID: $5SovT.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves a context handle that computes fields lazily on access.
     * This is more efficient than getContext() when you only need certain fields,
     *
     * @returns {PrecomputedEvaluationsContextHandle} A handle with lazy getters for context fields.
     */ getContextHandle() {
        return this._contextHandle;
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $29bb511d096d3e00$var$__awaiter(this, void 0, void 0, function*() {
            if (!$5SovT.Storage.isReady()) yield $5SovT.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $5SovT.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $5SovT.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $5SovT._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$5SovT.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$5SovT.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $5SovT.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Gate');
        this._checkInitializationStatus(details.reason);
        const gate = (0, $5SovT._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $5SovT._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Dynamic config');
        this._checkInitializationStatus(details.reason);
        const config = (0, $5SovT._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $5SovT._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Experiment');
        this._checkInitializationStatus(details.reason);
        const experiment = (0, $5SovT._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $5SovT._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $5SovT._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $5SovT._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $5SovT._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $5SovT._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $ltvXy._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $ltvXy._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    _checkUserHasIdForEvaluation(idType, name, type) {
        if (!idType) return;
        if (!(0, $5SovT._getUnitIDFromUser)(this._user, idType)) $5SovT.Log.warn(`The user does not have the required id_type "${idType}" for ${type} "${name}"`);
    }
    _checkInitializationStatus(reason) {
        if (reason === 'Uninitialized' || reason.startsWith('Loading')) $5SovT.Log.warn(`SDK initialization has not completed. Reason: ${reason}`);
    }
}
module.exports.default = $29bb511d096d3e00$var$StatsigClient;

});
parcelRegister("et9Yj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5SovT = parcelRequire("5SovT");

var $aE4Mx = parcelRequire("aE4Mx");

var $hnDNj = parcelRequire("hnDNj");
class $a88b824cf7d7b3a4$var$EvaluationStore {
    constructor(_sdkKey, _options){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._valuesForExternalUse = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._valuesForExternalUse = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        // we do not give out the actual _values object to avoid mutating it
        return this._valuesForExternalUse;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $5SovT._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._valuesForExternalUse = (0, $5SovT._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $hnDNj.V2InitializeContainer(values);
        else this._values = new $aE4Mx.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $5SovT.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b, _c;
        const stableID = $5SovT.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            let bootstrapUser = values['user'];
            let userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((_c = this._options) === null || _c === void 0 ? void 0 : _c.disableStableID) {
                userForComparison = Object.assign(Object.assign({}, userForComparison), {
                    customIDs: Object.assign(Object.assign({}, userForComparison.customIDs), {
                        stableID: undefined
                    })
                });
                bootstrapUser = Object.assign(Object.assign({}, bootstrapUser), {
                    customIDs: Object.assign(Object.assign({}, bootstrapUser.customIDs), {
                        stableID: undefined
                    })
                });
            }
            if ((0, $5SovT._getFullUserHash)(userForComparison) !== (0, $5SovT._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $a88b824cf7d7b3a4$var$EvaluationStore;

});
parcelRegister("aE4Mx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $5SovT = parcelRequire("5SovT");
class $7c015962478e3ad0$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $5SovT._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $7c015962478e3ad0$var$V1InitializeContainer;

});

parcelRegister("hnDNj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $5SovT = parcelRequire("5SovT");
class $ca7373f76e42e3d5$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $5SovT._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $ca7373f76e42e3d5$var$V2InitializeContainer;

});


parcelRegister("3rHi6", function(module, exports) {
"use strict";
var $282579602ef0076e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5SovT = parcelRequire("5SovT");

var $j1JbC = parcelRequire("j1JbC");
class $282579602ef0076e$var$StatsigNetwork extends $5SovT.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $5SovT.UrlConfiguration($5SovT.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $282579602ef0076e$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $5SovT._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $282579602ef0076e$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $j1JbC._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $282579602ef0076e$var$StatsigNetwork;

});
parcelRegister("j1JbC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $5SovT = parcelRequire("5SovT");
const $dda1295fa26f6766$var$MAX_DELTAS_SORT_DEPTH = 2;
function $dda1295fa26f6766$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $5SovT._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $dda1295fa26f6766$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $dda1295fa26f6766$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $5SovT._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $dda1295fa26f6766$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $dda1295fa26f6766$var$_resolveDeltasResponse;
function $dda1295fa26f6766$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $dda1295fa26f6766$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $dda1295fa26f6766$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $dda1295fa26f6766$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $dda1295fa26f6766$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $dda1295fa26f6766$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("ltvXy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $5SovT = parcelRequire("5SovT");
const $fa2518e252cfeff0$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $fa2518e252cfeff0$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $fa2518e252cfeff0$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $5SovT._isTypeMatch)(value, fallback);
}
function $fa2518e252cfeff0$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $fa2518e252cfeff0$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $fa2518e252cfeff0$var$_shouldLogExposure(options) ? undefined : $fa2518e252cfeff0$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $fa2518e252cfeff0$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $fa2518e252cfeff0$var$_shouldLogExposure(options) ? undefined : $fa2518e252cfeff0$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($fa2518e252cfeff0$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $fa2518e252cfeff0$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $fa2518e252cfeff0$var$_shouldLogExposure(options) ? undefined : $fa2518e252cfeff0$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($fa2518e252cfeff0$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $fa2518e252cfeff0$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $fa2518e252cfeff0$var$_shouldLogExposure(options) ? undefined : $fa2518e252cfeff0$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($fa2518e252cfeff0$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $fa2518e252cfeff0$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $5SovT._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $fa2518e252cfeff0$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $fa2518e252cfeff0$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $fa2518e252cfeff0$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $fa2518e252cfeff0$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $fa2518e252cfeff0$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $fa2518e252cfeff0$var$_makeParamStoreGetter;

});

parcelRegister("7mt7r", function(module, exports) {
"use strict";
var $55c12ce6e6db3206$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $5SovT = parcelRequire("5SovT");

var $3rHi6 = parcelRequire("3rHi6");
class $55c12ce6e6db3206$var$StatsigEvaluationsDataAdapter extends $5SovT.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $3rHi6.default) this._network = network;
        else this._network = new $3rHi6.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $5SovT._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $5SovT._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $5SovT.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $55c12ce6e6db3206$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $5SovT._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$5SovT.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $5SovT._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $55c12ce6e6db3206$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("dlfVC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b69978d4941b1b0$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $GPScL = parcelRequire("GPScL");
function $9b69978d4941b1b0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b69978d4941b1b0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b69978d4941b1b0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b69978d4941b1b0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9b69978d4941b1b0$export$a66cbd9b2289cd78 = '@all-features';
var $9b69978d4941b1b0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($GPScL)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $9b69978d4941b1b0$var$_objectSpread($9b69978d4941b1b0$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $9b69978d4941b1b0$var$_objectSpread($9b69978d4941b1b0$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $9b69978d4941b1b0$var$_objectSpread($9b69978d4941b1b0$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $9b69978d4941b1b0$var$_objectSpread($9b69978d4941b1b0$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($9b69978d4941b1b0$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($9b69978d4941b1b0$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($9b69978d4941b1b0$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $9b69978d4941b1b0$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("GPScL", function(module, exports) {
'use strict';
var $080c294f58f93d73$var$has = Object.prototype.hasOwnProperty, $080c294f58f93d73$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $080c294f58f93d73$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $080c294f58f93d73$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $080c294f58f93d73$var$Events().__proto__) $080c294f58f93d73$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $080c294f58f93d73$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $080c294f58f93d73$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $080c294f58f93d73$var$EE(fn, context || emitter, once), evt = $080c294f58f93d73$var$prefix ? $080c294f58f93d73$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $080c294f58f93d73$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $080c294f58f93d73$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $080c294f58f93d73$var$EventEmitter() {
    this._events = new $080c294f58f93d73$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $080c294f58f93d73$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($080c294f58f93d73$var$has.call(events, name)) names.push($080c294f58f93d73$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $080c294f58f93d73$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $080c294f58f93d73$var$prefix ? $080c294f58f93d73$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $080c294f58f93d73$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $080c294f58f93d73$var$prefix ? $080c294f58f93d73$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $080c294f58f93d73$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $080c294f58f93d73$var$prefix ? $080c294f58f93d73$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $080c294f58f93d73$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $080c294f58f93d73$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $080c294f58f93d73$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $080c294f58f93d73$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $080c294f58f93d73$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $080c294f58f93d73$var$prefix ? $080c294f58f93d73$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $080c294f58f93d73$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $080c294f58f93d73$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $080c294f58f93d73$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $080c294f58f93d73$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $080c294f58f93d73$var$prefix ? $080c294f58f93d73$var$prefix + event : event;
        if (this._events[evt]) $080c294f58f93d73$var$clearEvent(this, evt);
    } else {
        this._events = new $080c294f58f93d73$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$080c294f58f93d73$var$EventEmitter.prototype.off = $080c294f58f93d73$var$EventEmitter.prototype.removeListener;
$080c294f58f93d73$var$EventEmitter.prototype.addListener = $080c294f58f93d73$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$080c294f58f93d73$var$EventEmitter.prefixed = $080c294f58f93d73$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$080c294f58f93d73$var$EventEmitter.EventEmitter = $080c294f58f93d73$var$EventEmitter;
module.exports = $080c294f58f93d73$var$EventEmitter;

});


parcelRegister("kkEAg", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", function () { return $ecd5280162b71627$export$6dc24881a3d96325; });

var $a3ftr = parcelRequire("a3ftr");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $8gOv4 = parcelRequire("8gOv4");
var $ecd5280162b71627$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $8gOv4.migrateEvaluationDetails)(experiment.details), (0, $8gOv4.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("8gOv4", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $6056fd9b8df4a8b0$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $6056fd9b8df4a8b0$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $6056fd9b8df4a8b0$export$3dad1db244472f32; });
$parcel$export(module.exports, "deepAssign", function () { return $6056fd9b8df4a8b0$export$1148cb79ceecd5fa; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $6056fd9b8df4a8b0$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $6056fd9b8df4a8b0$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $6056fd9b8df4a8b0$export$55fd683752d01e67; });

var $bM2vx = parcelRequire("bM2vx");

var $a3ftr = parcelRequire("a3ftr");

var $62ppy = parcelRequire("62ppy");

var $82V4i = parcelRequire("82V4i");

var $91FVG = parcelRequire("91FVG");

var $6gjLm = parcelRequire("6gjLm");

var $NtwyG = parcelRequire("NtwyG");

var $d1oup = parcelRequire("d1oup");
var $6056fd9b8df4a8b0$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $6056fd9b8df4a8b0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6056fd9b8df4a8b0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6056fd9b8df4a8b0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6056fd9b8df4a8b0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6056fd9b8df4a8b0$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $6056fd9b8df4a8b0$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $6gjLm.isFedRamp)() ? (0, $d1oup.PerimeterType).FEDRAMP_MODERATE : (0, $d1oup.PerimeterType).COMMERCIAL
    }, options);
};
var $6056fd9b8df4a8b0$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $6056fd9b8df4a8b0$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $6056fd9b8df4a8b0$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $6056fd9b8df4a8b0$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $6056fd9b8df4a8b0$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $6056fd9b8df4a8b0$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(sources)));
}
var $6056fd9b8df4a8b0$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(options, $6056fd9b8df4a8b0$var$_excluded);
    return $6056fd9b8df4a8b0$var$_objectSpread($6056fd9b8df4a8b0$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $6056fd9b8df4a8b0$var$evaluationReasonMappings = Object.entries((0, $NtwyG.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $6056fd9b8df4a8b0$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $6056fd9b8df4a8b0$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $NtwyG.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $6056fd9b8df4a8b0$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("62ppy", function(module, exports) {

var $7ruBY = parcelRequire("7ruBY");

var $gKGBO = parcelRequire("gKGBO");

var $3CQum = parcelRequire("3CQum");

var $aSG9l = parcelRequire("aSG9l");
function $4656a41e42591a17$var$_toConsumableArray(r) {
    return $7ruBY(r) || $gKGBO(r) || $3CQum(r) || $aSG9l();
}
module.exports = $4656a41e42591a17$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7ruBY", function(module, exports) {

var $32vOX = parcelRequire("32vOX");
function $56b2ccce27e0ff3c$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $32vOX(r);
}
module.exports = $56b2ccce27e0ff3c$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gKGBO", function(module, exports) {
function $c321fe7542babb1e$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $c321fe7542babb1e$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aSG9l", function(module, exports) {
function $7ebfa49a926af05c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $7ebfa49a926af05c$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6gjLm", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $48f39134f1d40d04$export$64d6499adf9b2e51; });

var $7vq5H = parcelRequire("7vq5H");
function $48f39134f1d40d04$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $7vq5H.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("7vq5H", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $576faac686025671$export$ce553301d55c2fd8; });
var $576faac686025671$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $576faac686025671$export$f005e2e9f707cb5f = 'commercial';
var $576faac686025671$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $576faac686025671$export$a739cd5aac835909 = 'stg';
var $576faac686025671$export$42dd0cdd351a4a9 = 'prod';
var $576faac686025671$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("NtwyG", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", function () { return $094b7a98b82b655c$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $094b7a98b82b655c$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("d1oup", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $97ae5d7a2349d10e$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $97ae5d7a2349d10e$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $97ae5d7a2349d10e$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $97ae5d7a2349d10e$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $97ae5d7a2349d10e$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("hfnjj", function(module, exports) {

$parcel$export(module.exports, "Layer", function () { return $c8e5eb57e1262c7e$export$936d0764594b6eb3; });

var $a3ftr = parcelRequire("a3ftr");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $8gOv4 = parcelRequire("8gOv4");
var $c8e5eb57e1262c7e$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $8gOv4.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $8gOv4.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $8gOv4.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("cdHC9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e5887d28f01c734$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $axdfd = parcelRequire("axdfd");

var $d1oup = parcelRequire("d1oup");

var $aXEvm = parcelRequire("aXEvm");

var $lfjOp = parcelRequire("lfjOp");
function $8e5887d28f01c734$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e5887d28f01c734$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e5887d28f01c734$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e5887d28f01c734$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8e5887d28f01c734$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $8e5887d28f01c734$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $8e5887d28f01c734$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $8e5887d28f01c734$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $8e5887d28f01c734$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $8e5887d28f01c734$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $8e5887d28f01c734$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $8e5887d28f01c734$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $8e5887d28f01c734$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $8e5887d28f01c734$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $8e5887d28f01c734$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $lfjOp.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $lfjOp.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $8e5887d28f01c734$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $d1oup.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $d1oup.FeatureGateEnvironment).Production:
                        return $8e5887d28f01c734$export$18c93900db9358a4;
                    case (0, $d1oup.FeatureGateEnvironment).Staging:
                        return $8e5887d28f01c734$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $d1oup.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $d1oup.FeatureGateEnvironment).Development:
                        return $8e5887d28f01c734$export$f058dbf75c3bc647;
                    case (0, $d1oup.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $8e5887d28f01c734$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $8e5887d28f01c734$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $8e5887d28f01c734$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $8e5887d28f01c734$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $aXEvm.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $8e5887d28f01c734$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($8e5887d28f01c734$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($8e5887d28f01c734$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("aXEvm", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $7faed5763e5d7176$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $7faed5763e5d7176$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("lfjOp", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $f77a5df6513ecc65$export$286baf652d0b1206; });

var $c9XBY = parcelRequire("c9XBY");

var $lPkGR = parcelRequire("lPkGR");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $enV8I = parcelRequire("enV8I");

var $6Vj56 = parcelRequire("6Vj56");
function $f77a5df6513ecc65$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $f77a5df6513ecc65$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $f77a5df6513ecc65$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f77a5df6513ecc65$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f77a5df6513ecc65$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ResponseError);
        return $f77a5df6513ecc65$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Vj56)))(Error));

});
parcelRegister("icZb3", function(module, exports) {

var $a3ftr = parcelRequire("a3ftr");
var $036bc1402c35fa2d$var$_typeof = $a3ftr.default;

var $9cA6M = parcelRequire("9cA6M");
function $036bc1402c35fa2d$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $036bc1402c35fa2d$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $9cA6M(t);
}
module.exports = $036bc1402c35fa2d$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9cA6M", function(module, exports) {
function $6b313e67686fb973$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $6b313e67686fb973$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4yELe", function(module, exports) {
function $3519f4a4e162dc78$var$_getPrototypeOf(t) {
    return module.exports = $3519f4a4e162dc78$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $3519f4a4e162dc78$var$_getPrototypeOf(t);
}
module.exports = $3519f4a4e162dc78$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("enV8I", function(module, exports) {

var $lWHbQ = parcelRequire("lWHbQ");
function $a78f896b09834e3c$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $lWHbQ(t, e);
}
module.exports = $a78f896b09834e3c$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lWHbQ", function(module, exports) {
function $ffa08463a4687a00$var$_setPrototypeOf(t, e) {
    return module.exports = $ffa08463a4687a00$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ffa08463a4687a00$var$_setPrototypeOf(t, e);
}
module.exports = $ffa08463a4687a00$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6Vj56", function(module, exports) {

var $4yELe = parcelRequire("4yELe");

var $lWHbQ = parcelRequire("lWHbQ");

var $8wyux = parcelRequire("8wyux");

var $bl4SP = parcelRequire("bl4SP");
function $50a6de160ca499d9$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $50a6de160ca499d9$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$8wyux(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $bl4SP(t, arguments, $4yELe(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $lWHbQ(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $50a6de160ca499d9$var$_wrapNativeSuper(t);
}
module.exports = $50a6de160ca499d9$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8wyux", function(module, exports) {
function $634c112afe932fc2$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $634c112afe932fc2$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bl4SP", function(module, exports) {

var $4CZZC = parcelRequire("4CZZC");

var $lWHbQ = parcelRequire("lWHbQ");
function $841571994d2760c3$var$_construct(t, e, r) {
    if ($4CZZC()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $lWHbQ(p, r.prototype), p;
}
module.exports = $841571994d2760c3$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4CZZC", function(module, exports) {
function $35eacc86bf216e09$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $35eacc86bf216e09$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $35eacc86bf216e09$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("lIsqo", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $0414729b469175d6$export$55fffef3474104af; });

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $XdI2U = parcelRequire("XdI2U");

var $enV8I = parcelRequire("enV8I");

var $91FVG = parcelRequire("91FVG");

var $axdfd = parcelRequire("axdfd");

var $7i2Oo = parcelRequire("7i2Oo");
function $0414729b469175d6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0414729b469175d6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0414729b469175d6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0414729b469175d6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0414729b469175d6$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $0414729b469175d6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $0414729b469175d6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0414729b469175d6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0414729b469175d6$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($XdI2U)))((0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $0414729b469175d6$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, NoFetchDataAdapter);
        _this = $0414729b469175d6$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $7i2Oo.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $0414729b469175d6$var$_objectSpread($0414729b469175d6$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $7i2Oo._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $0414729b469175d6$var$_objectSpread($0414729b469175d6$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $7i2Oo._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $7i2Oo._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $7i2Oo.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $0414729b469175d6$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $0414729b469175d6$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $7i2Oo.DataAdapterCore));

});
parcelRegister("XdI2U", function(module, exports) {

var $jOWLt = parcelRequire("jOWLt");
function $0b20253516342255$var$_get() {
    return module.exports = $0b20253516342255$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $jOWLt(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0b20253516342255$var$_get.apply(null, arguments);
}
module.exports = $0b20253516342255$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jOWLt", function(module, exports) {

var $4yELe = parcelRequire("4yELe");
function $e6e045437e304435$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $4yELe(t)););
    return t;
}
module.exports = $e6e045437e304435$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("cwYdj", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $91f72e654e83fabe$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $91f72e654e83fabe$export$bcb28fbac1def494; });

var $91FVG = parcelRequire("91FVG");

var $82V4i = parcelRequire("82V4i");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $5SovT = parcelRequire("5SovT");
function $91f72e654e83fabe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91f72e654e83fabe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91f72e654e83fabe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91f72e654e83fabe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $91f72e654e83fabe$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $91f72e654e83fabe$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $91f72e654e83fabe$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $91f72e654e83fabe$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $91f72e654e83fabe$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $91f72e654e83fabe$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $91f72e654e83fabe$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $91f72e654e83fabe$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $91f72e654e83fabe$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $91f72e654e83fabe$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $91f72e654e83fabe$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $91f72e654e83fabe$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, PersistentOverrideAdapter);
        this._overrides = $91f72e654e83fabe$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $91f72e654e83fabe$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $91f72e654e83fabe$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $91f72e654e83fabe$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($91f72e654e83fabe$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($91f72e654e83fabe$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $91f72e654e83fabe$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $5SovT._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $91f72e654e83fabe$var$_objectSpread($91f72e654e83fabe$var$_objectSpread({}, $91f72e654e83fabe$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($91f72e654e83fabe$var$djb2MapKey((0, $5SovT._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($91f72e654e83fabe$var$djb2MapKey((0, $5SovT._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($91f72e654e83fabe$var$djb2MapKey((0, $5SovT._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($91f72e654e83fabe$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $91f72e654e83fabe$var$_objectSpread($91f72e654e83fabe$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $91f72e654e83fabe$var$_objectSpread($91f72e654e83fabe$var$_objectSpread({}, current.details), {}, {
                        reason: $91f72e654e83fabe$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($91f72e654e83fabe$var$djb2MapKey((0, $5SovT._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($91f72e654e83fabe$var$djb2MapKey((0, $5SovT._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($91f72e654e83fabe$var$djb2MapKey((0, $5SovT._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($91f72e654e83fabe$var$djb2MapKey((0, $5SovT._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($91f72e654e83fabe$var$djb2MapKey((0, $5SovT._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($91f72e654e83fabe$var$djb2MapKey((0, $5SovT._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $91f72e654e83fabe$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($91f72e654e83fabe$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $91f72e654e83fabe$var$_objectSpread($91f72e654e83fabe$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $5SovT._makeTypedGet)(current.name, overridden),
                    details: $91f72e654e83fabe$var$_objectSpread($91f72e654e83fabe$var$_objectSpread({}, current.details), {}, {
                        reason: $91f72e654e83fabe$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($91f72e654e83fabe$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $91f72e654e83fabe$var$_objectSpread($91f72e654e83fabe$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $5SovT._makeTypedGet)(current.name, overridden),
                    details: $91f72e654e83fabe$var$_objectSpread($91f72e654e83fabe$var$_objectSpread({}, current.details), {}, {
                        reason: $91f72e654e83fabe$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("lsNCU", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $fa02b54d7d539e8d$export$1c9f709888824e05; });
var $fa02b54d7d539e8d$var$_process, $fa02b54d7d539e8d$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $fa02b54d7d539e8d$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($fa02b54d7d539e8d$var$_process = globalThis.process) === null || $fa02b54d7d539e8d$var$_process === void 0 || ($fa02b54d7d539e8d$var$_process = $fa02b54d7d539e8d$var$_process.env) === null || $fa02b54d7d539e8d$var$_process === void 0 ? void 0 : $fa02b54d7d539e8d$var$_process.JEST_WORKER_ID) !== undefined;
var $fa02b54d7d539e8d$var$DEBUG_MODE = !$fa02b54d7d539e8d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($fa02b54d7d539e8d$var$_process2 = globalThis.process) === null || $fa02b54d7d539e8d$var$_process2 === void 0 || ($fa02b54d7d539e8d$var$_process2 = $fa02b54d7d539e8d$var$_process2.env) === null || $fa02b54d7d539e8d$var$_process2 === void 0 ? void 0 : $fa02b54d7d539e8d$var$_process2.NODE_ENV) !== 'production';
var $fa02b54d7d539e8d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$fa02b54d7d539e8d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("aHxvj", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $7ca7e8b9d41ed7bf$export$f19b488f7c0547ee; });
$parcel$export(module.exports, "themeObjectToString", function () { return $7ca7e8b9d41ed7bf$export$62c37ab81302621a; });

var $a3ftr = parcelRequire("a3ftr");

var $82V4i = parcelRequire("82V4i");

var $58oBY = parcelRequire("58oBY");
var $7ca7e8b9d41ed7bf$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $7ca7e8b9d41ed7bf$var$customThemeOptions = 'UNSAFE_themeOptions';
var $7ca7e8b9d41ed7bf$var$isThemeKind = function isThemeKind(themeKind) {
    return $7ca7e8b9d41ed7bf$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $7ca7e8b9d41ed7bf$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $58oBY.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $7ca7e8b9d41ed7bf$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $7ca7e8b9d41ed7bf$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $7ca7e8b9d41ed7bf$var$isColorMode(id)) themeObject[kind] = id;
        if ($7ca7e8b9d41ed7bf$var$isThemeKind(kind) && $7ca7e8b9d41ed7bf$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $7ca7e8b9d41ed7bf$var$customThemeOptions) try {
            themeObject[$7ca7e8b9d41ed7bf$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $7ca7e8b9d41ed7bf$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $7ca7e8b9d41ed7bf$var$isColorMode(id) || // custom theme state
        kind === $7ca7e8b9d41ed7bf$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(id) === 'object' || // other theme states
        $7ca7e8b9d41ed7bf$var$isThemeKind(kind) && typeof id === 'string' && $7ca7e8b9d41ed7bf$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});


parcelRegister("5bLDB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c72eeacaabef838$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $a7eRo = parcelRequire("a7eRo");

var $3J65S = parcelRequire("3J65S");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $3c72eeacaabef838$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $3J65S.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $a7eRo.THEME_DATA_ATTRIBUTE),
                            (0, $a7eRo.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($3c72eeacaabef838$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($3c72eeacaabef838$export$2e2bcd8739ae039, "callbacks", new Set());

});


parcelRegister("lCwoP", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", function () { return $fbd647745d395ab8$export$438460117ae6b7ee; });
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $fbd647745d395ab8$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $fbd647745d395ab8$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 

});

parcelRegister("9mSNu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d20acb5111e03f2$export$2e2bcd8739ae039; });
/* wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $91FVG = parcelRequire("91FVG");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
var $6d20acb5111e03f2$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $6d20acb5111e03f2$var$CSS_VAR_COLOR = '--logo-color';
var $6d20acb5111e03f2$var$CSS_VAR_FILL = '--logo-fill';
var $6d20acb5111e03f2$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $6d20acb5111e03f2$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $6d20acb5111e03f2$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $dNMDr.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        "data-testid": testId,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, $6d20acb5111e03f2$var$CSS_VAR_COLOR, iconColor), $6d20acb5111e03f2$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $affTb.default)([
            $6d20acb5111e03f2$var$styles.root,
            shouldApplyStopColor && $6d20acb5111e03f2$var$styles.stop,
            size && $6d20acb5111e03f2$var$styles[size]
        ])
    }));
};
var $6d20acb5111e03f2$export$2e2bcd8739ae039 = $6d20acb5111e03f2$var$Wrapper;

});

parcelRegister("68kpH", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", function () { return $47735324c19a488d$export$362a25f017e2bc8a; });
$parcel$export(module.exports, "getColorsFromAppearance", function () { return $47735324c19a488d$export$bbacc3980e0f3029; });
$parcel$export(module.exports, "getColorsForLoom", function () { return $47735324c19a488d$export$7818df200941dbbf; });

var $2Mjap = parcelRequire("2Mjap");
var $47735324c19a488d$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $2Mjap.B400);
            iconGradientStop = (0, $2Mjap.B200);
            iconColor = (0, $2Mjap.B200);
            textColor = "var(--ds-text, ".concat((0, $2Mjap.N800), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $2Mjap.B400);
            break;
        case 'neutral':
            iconGradientStart = (0, $2Mjap.N600);
            iconGradientStop = (0, $2Mjap.N100);
            iconColor = (0, $2Mjap.N100);
            textColor = (0, $2Mjap.N400);
            atlassianLogoTextColor = (0, $2Mjap.N400);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $47735324c19a488d$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $2Mjap.N0);
            textColor = (0, $2Mjap.N0);
            atlassianLogoTextColor = (0, $2Mjap.N0);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $47735324c19a488d$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $47735324c19a488d$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $47735324c19a488d$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});


parcelRegister("8Cc4v", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "Error.7c4adcd3.svg";

});

parcelRegister("4NPio", function(module, exports) {

$parcel$export(module.exports, "appendReferer", function () { return $770551915c3ff448$export$b75bb5b493e221ea; });
$parcel$export(module.exports, "appendReasonViewingScreen", function () { return $770551915c3ff448$export$b68d90d94a86fe33; });
$parcel$export(module.exports, "AnalyticsClientImpl", function () { return $770551915c3ff448$export$17499c710c4e1d; });
$parcel$export(module.exports, "AnalyticsClientContext", function () { return $770551915c3ff448$export$70089efe93d43959; });
$parcel$export(module.exports, "useAnalyticsClient", function () { return $770551915c3ff448$export$923054f18cb06572; });
$parcel$export(module.exports, "useAnalyticsAnonymousId", function () { return $770551915c3ff448$export$e126afa8615733f3; });
$parcel$export(module.exports, "useTrackingEvent", function () { return $770551915c3ff448$export$1397d31414038d5e; });
$parcel$export(module.exports, "usePageViewedEvent", function () { return $770551915c3ff448$export$a07d7c1ce880cd05; });
$parcel$export(module.exports, "useButtonClickedEvent", function () { return $770551915c3ff448$export$4fb7f377b48b9cbc; });
$parcel$export(module.exports, "useLinkClickedEvent", function () { return $770551915c3ff448$export$65af8b3e3ac7d8ee; });
$parcel$export(module.exports, "useFormSubmittedEvent", function () { return $770551915c3ff448$export$69c70ee0cb243a51; });
$parcel$export(module.exports, "useOperationalEvent", function () { return $770551915c3ff448$export$87ff6dcd457142b0; });

var $hhYxc = parcelRequire("hhYxc");

var $hqddj = parcelRequire("hqddj");

var $hVicB = parcelRequire("hVicB");
var $5mr0m = parcelRequire("5mr0m");

var $jjyqs = parcelRequire("jjyqs");

var $dNMDr = parcelRequire("dNMDr");

var $cuZAx = parcelRequire("cuZAx");

var $1xe2r = parcelRequire("1xe2r");

var $fcxz7 = parcelRequire("fcxz7");

var $8F1UY = parcelRequire("8F1UY");
parcelRequire("9mgZH");
var $4903M = parcelRequire("4903M");

var $9ULaf = parcelRequire("9ULaf");
const $770551915c3ff448$var$tags = [
    'identity'
];
function $770551915c3ff448$var$getEnv() {
    switch(0, $hhYxc.currentEnv){
        case 'local':
            return (0, $5mr0m.envType).LOCAL;
        case 'dev':
            return (0, $5mr0m.envType).DEV;
        case 'stg':
        case 'stg-fedm':
        case 'stg-ic':
            return (0, $5mr0m.envType).STAGING;
        case 'prod':
        case 'prod-fedm':
        case 'prod-ic':
            return (0, $5mr0m.envType).PROD;
        default:
            return (0, $5mr0m.envType).DEV;
    }
}
function $770551915c3ff448$export$b75bb5b493e221ea(eventAttributes) {
    try {
        const referer = new URL(document.referrer);
        referer.search = ''; // lets minimise possibility of tokens in referer by cleaning up query params
        return {
            ...eventAttributes,
            referer: referer.toString()
        };
    } catch (e) {
        return eventAttributes;
    }
}
function $770551915c3ff448$export$b68d90d94a86fe33(eventAttributes, userFlow) {
    if (userFlow) return {
        ...eventAttributes,
        reasonViewingScreen: userFlow
    };
    return eventAttributes;
}
function $770551915c3ff448$var$determinePlatform(microbranding) {
    if ((0, $cuZAx.isMobileOidc)(microbranding.oidcContext) || microbranding.isEmbedded) return (0, $5mr0m.platformType).MOBILE_WEB;
    return (0, $5mr0m.platformType).WEB;
}
let $770551915c3ff448$var$analyticsClient;
function $770551915c3ff448$export$77ce8f76f8d1e1d1({ microbranding: microbranding, locality: locality, tenantCloudId: tenantCloudId, userId: userId }) {
    const platform = $770551915c3ff448$var$determinePlatform(microbranding);
    const locale = locality || 'en';
    const env = $770551915c3ff448$var$getEnv();
    const apiHost = [
        'prod',
        'staging'
    ].includes((0, $hhYxc.currentEnvType)) ? window.location.host + '/gateway/api/gasv3/api/v1' : undefined;
    if (!$770551915c3ff448$var$analyticsClient) $770551915c3ff448$var$analyticsClient = new (0, $hVicB.default)({
        env: env,
        product: 'identity',
        origin: (0, $5mr0m.originType).WEB,
        platform: platform,
        locale: locale,
        perimeter: (0, $hhYxc.currentPerimeter)
    }, {
        apiHost: apiHost
    });
    if (userId) $770551915c3ff448$var$analyticsClient.setUserInfo((0, $5mr0m.userType).ATLASSIAN_ACCOUNT, userId);
    if (tenantCloudId) $770551915c3ff448$var$analyticsClient.setTenantInfo((0, $5mr0m.tenantType).CLOUD_ID, tenantCloudId);
    else $770551915c3ff448$var$analyticsClient.setTenantInfo((0, $5mr0m.tenantType).NONE);
    return $770551915c3ff448$var$analyticsClient;
}
class $770551915c3ff448$export$17499c710c4e1d {
    constructor(args){
        const { microbranding: microbranding, cobranding: cobranding, locale: locale, tenantCloudId: tenantCloudId, userId: userId, client: client = $770551915c3ff448$export$77ce8f76f8d1e1d1({
            microbranding: microbranding,
            locality: locale,
            tenantCloudId: tenantCloudId,
            userId: userId
        }) } = args;
        try {
            (0, $hqddj.setLocale)(locale);
            this.microbranding = microbranding;
            this.cobranding = cobranding;
            this.client = client;
            const loomAnonId = new URLSearchParams(window.location.search).get('loom_anon_id');
            if (loomAnonId) this.client._changeInternalUserId(this.client._userInfo.userId, loomAnonId);
        } catch (error) {
            (0, $hqddj.captureException)(error);
        }
    }
    formSubmittedEvent(page, formId, attributes) {
        return this.uiEvent({
            page: page,
            action: 'submitted',
            subject: 'form',
            subjectId: formId,
            attributes: attributes
        });
    }
    buttonClickedEvent(page, buttonId, attributes) {
        return this.uiEvent({
            page: page,
            action: 'clicked',
            subject: 'button',
            subjectId: buttonId,
            attributes: attributes
        });
    }
    linkClickedEvent(page, linkId, attributes) {
        return this.uiEvent({
            page: page,
            action: 'clicked',
            subject: 'link',
            subjectId: linkId,
            attributes: attributes
        });
    }
    checkboxChangedEvent(page, checkboxId, attributes) {
        return this.uiEvent({
            page: page,
            action: 'changed',
            subject: 'checkbox',
            subjectId: checkboxId,
            attributes: attributes
        });
    }
    trackingEvent(event) {
        const attributes = this.enrichAttributes(event.attributes);
        (0, $hqddj.addBreadcrumb)({
            category: 'tracking',
            message: `UI ${event.action} tracking event occured at ${event.subject} ${event.subjectId} on page ${event.page}`,
            data: {
                // this has to be a flat structure
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                ...attributes
            }
        });
        try {
            this.client.sendTrackEvent({
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                attributes: attributes,
                tags: $770551915c3ff448$var$tags
            });
        } catch (error) {
            (0, $hqddj.captureException)(error, {
                event: event
            });
        }
    }
    operationalEvent(event, callback) {
        const attributes = this.enrichAttributes(event.attributes);
        (0, $hqddj.addBreadcrumb)({
            category: 'operational',
            message: `${event.action} operational event occured at ${event.subject} ${event.subjectId} on page ${event.page}`,
            data: {
                // this has to be a flat structure
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                ...attributes
            }
        });
        try {
            this.client.sendOperationalEvent({
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                attributes: attributes,
                tags: $770551915c3ff448$var$tags
            }, callback);
        } catch (error) {
            (0, $hqddj.captureException)(error, {
                event: event
            });
            if (callback) callback(error);
        }
    }
    async pageViewedEvent(page, eventAttributes) {
        const attributes = this.enrichAttributes(eventAttributes);
        (0, $hqddj.addBreadcrumb)({
            category: 'pageViewed',
            message: 'Page viewed event of page id ' + page,
            data: {
                source: page,
                ...attributes
            }
        });
        try {
            const metric = (0, $4903M.getPageLoadMetric)(page);
            if (metric.getData().state !== 'finished') metric.stop();
        } catch (error) {
            (0, $hqddj.captureException)(error, {
                page: page
            });
        }
        try {
            await this.client.sendScreenEvent({
                name: page,
                attributes: attributes
            });
        } catch (error) {
            (0, $hqddj.captureException)(error, {
                page: page
            });
        }
    }
    errorShownEvent(page, subjectId, eventAttributes) {
        return this.uiEvent({
            page: page,
            action: 'shown',
            subject: 'error',
            subjectId: subjectId,
            attributes: eventAttributes
        });
    }
    uiEvent(event) {
        const attributes = this.enrichAttributes(event.attributes);
        (0, $hqddj.addBreadcrumb)({
            category: 'ui',
            message: `UI ${event.action} event occured at ${event.subject} ${event.subjectId} on page ${event.page}`,
            data: {
                // this has to be a flat structure
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                ...attributes
            }
        });
        return new Promise((resolve)=>{
            try {
                this.client.sendUIEvent({
                    source: event.page,
                    actionSubject: event.subject,
                    action: event.action,
                    actionSubjectId: event.subjectId,
                    attributes: attributes,
                    tags: $770551915c3ff448$var$tags
                }, ()=>resolve());
            } catch (error) {
                (0, $hqddj.captureException)(error, {
                    event: event
                });
                // error is already captured, no point in putting the burden upon consumers by rejecting since they likely want to proceed
                resolve();
            }
        });
    }
    stopApdexEvent(apdexEvent) {
        try {
            this.client.stopApdexEvent(apdexEvent);
        } catch (error) {
            (0, $hqddj.captureException)(error, {
                event: apdexEvent
            });
        }
    }
    stopInitialLoadApdexEvent(task) {
        this.stopApdexEvent({
            task: task,
            type: 'initialLoad',
            additionalAttributes: {
                properties: {
                    firstPaint: (0, $8F1UY.getFirstPaint)(),
                    firstContentfulPaint: (0, $8F1UY.getFirstContentfulPaint)()
                }
            }
        });
    }
    getInstance() {
        return this.client;
    }
    getAnonymousId() {
        return this.client.getAnonymousId();
    }
    setFfsId(ffsId) {
        this.ffsId = ffsId;
    }
    enrichAttributes(eventAttributes) {
        const originTracingProperties = (0, $1xe2r.default)(window.location.href, {
            mapAttribute: (value)=>typeof value === 'string' ? (0, $jjyqs.dangerouslyCreateSafeString)(value) : value
        });
        const queryParams = new URLSearchParams(window.location.search);
        const flowTraceId = queryParams.get('flowTraceId');
        const loomAnonId = queryParams.get('loom_anon_id');
        const applicationData = (0, $fcxz7.lookupApplication)(this.cobranding);
        const application = applicationData ? applicationData.coreApplication : 'unknown';
        const applicationAnalyticAttributes = {
            firstProductAccessed: application,
            experience: applicationData?.experience
        };
        return {
            ...applicationAnalyticAttributes,
            ...originTracingProperties,
            ...flowTraceId && {
                flowTraceId: flowTraceId
            },
            ...loomAnonId && {
                anonymousId: loomAnonId
            },
            isMobileApp: this.microbranding.isMobileApp,
            ...eventAttributes,
            ffsId: this.ffsId,
            isInPopup: Boolean(window.opener && window.opener !== window),
            isServedByBifrost: (0, $9ULaf.default)()
        };
    }
}
const $770551915c3ff448$export$70089efe93d43959 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createContext(null);
const $770551915c3ff448$export$923054f18cb06572 = ()=>{
    const context = (0, $dNMDr.useContext)($770551915c3ff448$export$70089efe93d43959);
    if (!context) throw new Error('useAnalyticsClient used outside of AnalyticsProvider.');
    return context;
};
const $770551915c3ff448$export$e126afa8615733f3 = ()=>{
    const analyticsClient = $770551915c3ff448$export$923054f18cb06572();
    return analyticsClient.getAnonymousId();
};
const $770551915c3ff448$export$1397d31414038d5e = (event)=>{
    const analyticsClient = $770551915c3ff448$export$923054f18cb06572();
    (0, $dNMDr.useEffect)(()=>{
        analyticsClient.trackingEvent(event);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
const $770551915c3ff448$export$a07d7c1ce880cd05 = (page, eventAttributes)=>{
    const analyticsClient = $770551915c3ff448$export$923054f18cb06572();
    (0, $dNMDr.useEffect)(()=>{
        analyticsClient.pageViewedEvent(page, eventAttributes);
    }, [
        page
    ]); // eslint-disable-line react-hooks/exhaustive-deps
};
const $770551915c3ff448$export$4fb7f377b48b9cbc = (page, buttonId, attributes)=>{
    const analyticsClient = $770551915c3ff448$export$923054f18cb06572();
    return (0, $dNMDr.useCallback)(()=>{
        analyticsClient.buttonClickedEvent(page, buttonId, attributes);
    }, [
        analyticsClient,
        page,
        buttonId,
        attributes
    ]);
};
const $770551915c3ff448$export$65af8b3e3ac7d8ee = (page, linkId, attributes)=>{
    const analyticsClient = $770551915c3ff448$export$923054f18cb06572();
    return (0, $dNMDr.useCallback)(()=>{
        analyticsClient.linkClickedEvent(page, linkId, attributes);
    }, [
        analyticsClient,
        page,
        linkId,
        attributes
    ]);
};
const $770551915c3ff448$export$69c70ee0cb243a51 = (page, formId, attributes)=>{
    const analyticsClient = $770551915c3ff448$export$923054f18cb06572();
    return (0, $dNMDr.useCallback)(()=>{
        analyticsClient.formSubmittedEvent(page, formId, attributes);
    }, [
        analyticsClient,
        page,
        formId,
        attributes
    ]);
};
const $770551915c3ff448$export$87ff6dcd457142b0 = (operationalEvent, callback)=>{
    const analyticsClient = $770551915c3ff448$export$923054f18cb06572();
    (0, $dNMDr.useEffect)(()=>{
        analyticsClient.operationalEvent(operationalEvent, callback);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

});
parcelRegister("hhYxc", function(module, exports) {

$parcel$export(module.exports, "currentEnv", function () { return $adcbf672e00e6241$export$d1418d82198b4abb; });
$parcel$export(module.exports, "getCurrentEnv", function () { return $adcbf672e00e6241$export$449f077783cda297; });
$parcel$export(module.exports, "currentEnvType", function () { return $adcbf672e00e6241$export$fc28d431ec5ff0ef; });
$parcel$export(module.exports, "idacOrigin", function () { return $adcbf672e00e6241$export$7fd1ab530687106; });
$parcel$export(module.exports, "currentCloudType", function () { return $adcbf672e00e6241$export$965b3f41be601b7a; });
$parcel$export(module.exports, "currentPerimeter", function () { return $adcbf672e00e6241$export$84a0517db04c70cb; });
$parcel$export(module.exports, "getCurrentCloudType", function () { return $adcbf672e00e6241$export$35199af7a1ed7e54; });
$parcel$export(module.exports, "isFedM", function () { return $adcbf672e00e6241$export$9db7980b9f442a4c; });
$parcel$export(module.exports, "isIsolatedCloud", function () { return $adcbf672e00e6241$export$9186ccba8effc5de; });
$parcel$export(module.exports, "getConfig", function () { return $adcbf672e00e6241$export$44487a86467333c3; });
function $adcbf672e00e6241$var$inferEnvFromHostname(hostname) {
    if (hostname === 'localhost') return 'local';
    if (hostname.endsWith('.dev.internal.atlassian.com') || hostname.endsWith('.dev.atlassian.com')) return 'dev';
    if (hostname.endsWith('.stg.internal.atlassian.com') || hostname.endsWith('.stg.atlassian.com')) return 'stg';
    if (hostname.endsWith('.stg.atlassian-us-gov-mod.com')) return 'stg-fedm';
    if (hostname.endsWith('.oasis-stg.com')) return 'stg-ic';
    if (hostname.endsWith('.atlassian-us-gov-mod.com')) return 'prod-fedm';
    if (hostname.endsWith('.atlassian.com')) return 'prod';
    if (hostname.endsWith('.atlassian-isolated.net')) return 'prod-ic';
    return 'unknown';
}
const $adcbf672e00e6241$export$d1418d82198b4abb = $adcbf672e00e6241$var$inferEnvFromHostname(window.location.hostname);
const $adcbf672e00e6241$export$449f077783cda297 = ()=>$adcbf672e00e6241$var$inferEnvFromHostname(window.location.hostname);
const $adcbf672e00e6241$var$envTypes = {
    local: 'dev',
    dev: 'dev',
    stg: 'staging',
    'stg-fedm': 'staging',
    'stg-ic': 'staging',
    prod: 'prod',
    'prod-fedm': 'prod',
    'prod-ic': 'prod',
    unknown: 'unknown'
};
const $adcbf672e00e6241$export$fc28d431ec5ff0ef = $adcbf672e00e6241$var$envTypes[$adcbf672e00e6241$export$d1418d82198b4abb];
const $adcbf672e00e6241$var$idacOrigins = {
    // The local proxy is created within Parcel on the frontend local step, and requests are proxied to staging
    // Using `window.location.protocol` means that we don't need to make a change here if we run using HTTPS or HTTP.
    local: `${window.location.protocol}//localhost:3000`,
    dev: 'https://id.dev.internal.atlassian.com',
    stg: 'https://id.stg.internal.atlassian.com',
    'stg-fedm': 'https://id.stg.atlassian-us-gov-mod.com',
    'stg-ic': window.location.origin,
    prod: 'https://id.atlassian.com',
    'prod-fedm': 'https://id.atlassian-us-gov-mod.com',
    'prod-ic': window.location.origin,
    unknown: 'https://id.atlassian.com'
};
const $adcbf672e00e6241$export$7fd1ab530687106 = $adcbf672e00e6241$var$idacOrigins[$adcbf672e00e6241$export$d1418d82198b4abb];
const $adcbf672e00e6241$var$atlassianCloudType = {
    local: 'commercial',
    dev: 'commercial',
    stg: 'commercial',
    'stg-fedm': 'fedramp-moderate',
    'stg-ic': 'isolated-cloud',
    prod: 'commercial',
    'prod-fedm': 'fedramp-moderate',
    'prod-ic': 'isolated-cloud',
    unknown: 'commercial'
};
const $adcbf672e00e6241$var$perimeter = {
    local: 'commercial',
    dev: 'commercial',
    stg: 'commercial',
    'stg-fedm': 'fedramp-moderate',
    'stg-ic': 'commercial',
    prod: 'commercial',
    'prod-fedm': 'fedramp-moderate',
    'prod-ic': 'commercial',
    unknown: 'commercial'
};
const $adcbf672e00e6241$var$config = {
    dev: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
            smsEnrollmentRecaptchaEnterpriseNewKey: '6Ld_RrgpAAAAAC6NtADmI_b9uTwxyDieSQbL0A4O'
        }
    },
    staging: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
            smsEnrollmentRecaptchaEnterpriseNewKey: '6Ld_RrgpAAAAAC6NtADmI_b9uTwxyDieSQbL0A4O'
        }
    },
    prod: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: '6LeLRz0kAAAAAPIWGnreLcE0BJaZ17REyxkFhM0E',
            smsEnrollmentRecaptchaEnterpriseNewKey: '6LcjUrgpAAAAANvg2hgPsYsHNO9F21kQVCQwUPoF'
        }
    },
    unknown: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
            smsEnrollmentRecaptchaEnterpriseNewKey: '6Ld_RrgpAAAAAC6NtADmI_b9uTwxyDieSQbL0A4O'
        }
    }
};
const $adcbf672e00e6241$export$965b3f41be601b7a = $adcbf672e00e6241$var$atlassianCloudType[$adcbf672e00e6241$export$d1418d82198b4abb];
const $adcbf672e00e6241$export$84a0517db04c70cb = $adcbf672e00e6241$var$perimeter[$adcbf672e00e6241$export$d1418d82198b4abb];
const $adcbf672e00e6241$export$35199af7a1ed7e54 = ()=>$adcbf672e00e6241$var$atlassianCloudType[$adcbf672e00e6241$export$d1418d82198b4abb];
const $adcbf672e00e6241$export$9db7980b9f442a4c = ()=>$adcbf672e00e6241$export$35199af7a1ed7e54() === 'fedramp-moderate';
const $adcbf672e00e6241$export$9186ccba8effc5de = ()=>$adcbf672e00e6241$export$35199af7a1ed7e54() === 'isolated-cloud';
const $adcbf672e00e6241$export$44487a86467333c3 = ()=>$adcbf672e00e6241$var$config[$adcbf672e00e6241$export$fc28d431ec5ff0ef];

});

parcelRegister("hqddj", function(module, exports) {

$parcel$export(module.exports, "initClient", function () { return $082c78405adc64cb$export$c4b69426a5efa3b7; });
$parcel$export(module.exports, "setUserId", function () { return $082c78405adc64cb$export$7f5abdb7f5093137; });
$parcel$export(module.exports, "setAppStateInitializationContext", function () { return $082c78405adc64cb$export$61af809167ad3e63; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $082c78405adc64cb$export$efda9a273d7a036d; });
$parcel$export(module.exports, "setContext", function () { return $082c78405adc64cb$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setLocale", function () { return $082c78405adc64cb$export$c8aadf3621e41efb; });
$parcel$export(module.exports, "setAnonymousIdTag", function () { return $082c78405adc64cb$export$3e771dfee3cb28cd; });
$parcel$export(module.exports, "captureTaggedException", function () { return $082c78405adc64cb$export$2e97319d952475e; });
$parcel$export(module.exports, "captureTaggedReactException", function () { return $082c78405adc64cb$export$8d72b01fb282cc43; });
$parcel$export(module.exports, "captureException", function () { return $082c78405adc64cb$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureRecaptchaException", function () { return $082c78405adc64cb$export$ddf087afa206091f; });
$parcel$export(module.exports, "captureCobrandingException", function () { return $082c78405adc64cb$export$5ec83ab111bbcd41; });
$parcel$export(module.exports, "captureMalformedError", function () { return $082c78405adc64cb$export$b6c309bc746f6dbf; });
$parcel$export(module.exports, "captureCobrandingError", function () { return $082c78405adc64cb$export$2fb60ea2fe20385b; });
$parcel$export(module.exports, "captureMessage", function () { return $082c78405adc64cb$export$45654777c133ae80; });
$parcel$export(module.exports, "captureErrorMessage", function () { return $082c78405adc64cb$export$53b98cb085651af4; });
$parcel$export(module.exports, "captureRecaptchaMessage", function () { return $082c78405adc64cb$export$8a94d1afc2068093; });

var $1cBgb = parcelRequire("1cBgb");
var $g5j9r = parcelRequire("g5j9r");
var $flsBa = parcelRequire("flsBa");
var $dFb2H = parcelRequire("dFb2H");
var $bkLxn = parcelRequire("bkLxn");
var $5S891 = parcelRequire("5S891");

var $hhYxc = parcelRequire("hhYxc");

var $cuZAx = parcelRequire("cuZAx");

var $iGVRQ = parcelRequire("iGVRQ");
// Only turn on debug for non production and non test runs (i.e. Jest);
const $082c78405adc64cb$var$debug = (0, $hhYxc.currentEnv) !== 'prod' && true;
// https://hello.atlassian.net/wiki/spaces/OBSERVABILITY/pages/3370131692/Sentry+FedRAMP+-+Getting+Started#Sentry-DSN-in-FedRAMP
const $082c78405adc64cb$var$fedMSentryDSN = 'https://1c864dd6ac671ce6296e7cc6710a21a0@sentry.atlassian-us-gov-mod.com/22';
const $082c78405adc64cb$var$commercialSentryDSN = 'https://1271fcf5ddad45a1846153219eb726bd@o55978.ingest.sentry.io/4504172801622016';
$5S891.init({
    dsn: (0, $hhYxc.isFedM)() ? $082c78405adc64cb$var$fedMSentryDSN : $082c78405adc64cb$var$commercialSentryDSN,
    debug: $082c78405adc64cb$var$debug,
    environment: (0, $hhYxc.currentEnv),
    release: "8339-d2cc2cf89de54f0df83ee83e15c99bbf9f11373a",
    enabled: (0, $hhYxc.currentEnv) !== 'local',
    sampleRate: 0.1,
    beforeSend (event) {
        // Remove URL queryparams, they can contain PII
        if (event.request?.url) {
            event.request.url = event.request.url.split('?')[0];
            delete event.request.query_string;
        }
        // Ensure we have at least some best-guess tags for which capability might be affected
        const inferredCapabilities = (0, $iGVRQ.inferCapabilitiesFromPathname)(window.location.pathname);
        const capabilityTags = $082c78405adc64cb$var$capabilitiesToTags(inferredCapabilities);
        const existingTags = event.tags || {};
        event.tags = {
            // order matters, we don't want to override any tags that were deliberately and specifically
            // set on the event already
            ...capabilityTags,
            ...existingTags
        };
        return event;
    },
    beforeBreadcrumb (breadcrumb) {
        // Don't send breadcrumbs that may contain PII
        if ([
            'navigation',
            'fetch',
            'xhr'
        ].includes(breadcrumb.category || '')) return null;
        return breadcrumb;
    },
    denyUrls: [
        /^chrome:\/\//,
        /^chrome-extension:\/\//,
        /accounts\.google\.com/,
        /recaptcha.net/
    ],
    ignoreErrors: [
        /^null/,
        /^undefined/,
        /Loading chunk.\d+.failed/,
        /^[^.]+\w+ is not defined/,
        'Load Failed',
        'NetworkError',
        'Failed to fetch',
        'SecurityError',
        'Object Not Found Matching Id',
        'Non-Error promise rejection captured with value:',
        'ResizeObserver loop limit exceeded'
    ],
    integrations: [
        // extracts all non-native attributes from the error object and attaches them to the event as extra data
        $dFb2H.extraErrorDataIntegration()
    ]
});
function $082c78405adc64cb$export$c4b69426a5efa3b7(microbranding) {
    $bkLxn.getCurrentScope().setExtra('isEmbedded', microbranding.isEmbedded);
    $bkLxn.getCurrentScope().setExtra('isMobileOidc', (0, $cuZAx.isMobileOidc)(microbranding.oidcContext));
}
function $082c78405adc64cb$export$7f5abdb7f5093137(anonymousId) {
    $bkLxn.getCurrentScope().setUser({
        id: anonymousId
    });
}
function $082c78405adc64cb$export$61af809167ad3e63(contextValue) {
    $g5j9r.setContext('appStateInitialization', contextValue);
}
function $082c78405adc64cb$export$efda9a273d7a036d(breadcrumb) {
    if (!breadcrumb.level) breadcrumb.level = 'info';
    $1cBgb.addBreadcrumb(breadcrumb);
}
function $082c78405adc64cb$export$2f04de43fe27971a(name, value) {
    $g5j9r.setContext(name, value);
}
function $082c78405adc64cb$export$c8aadf3621e41efb(locale) {
    if (locale) $bkLxn.getCurrentScope().setTag('locale', locale);
}
function $082c78405adc64cb$export$3e771dfee3cb28cd(anonymousId) {
    $bkLxn.getCurrentScope().setTag('anonymousId', anonymousId);
}
function $082c78405adc64cb$export$2e97319d952475e(ex, options) {
    const { capabilities: capabilities, tags: tags = {}, extraProperties: extraProperties = {} } = options;
    $bkLxn.withScope((scope)=>{
        const capabilityTags = $082c78405adc64cb$var$capabilitiesToTags(capabilities);
        scope.setTags({
            ...tags,
            ...capabilityTags
        });
        scope.setExtras(extraProperties);
        $g5j9r.captureException(ex);
    });
}
function $082c78405adc64cb$export$8d72b01fb282cc43(ex, errorInfo, options) {
    const { capabilities: capabilities, tags: tags = {}, extraProperties: extraProperties = {} } = options;
    $bkLxn.withScope((scope)=>{
        const capabilityTags = $082c78405adc64cb$var$capabilitiesToTags(capabilities);
        const otherTags = {
            ...tags,
            // These errors always affect rendering. Meaning that, if left unhandled, they would
            // crash the app. We always want to include this tag to designate them as such.
            errorKind: 'rendering'
        };
        scope.setTags({
            ...otherTags,
            ...capabilityTags
        });
        scope.setExtras(extraProperties);
        $flsBa.captureReactException(ex, errorInfo);
    });
}
function $082c78405adc64cb$export$f5282963edea4a68(ex, payload = {}, tags) {
    if (payload) $bkLxn.withScope((scope)=>{
        Object.entries(payload).forEach(([key, value])=>{
            scope.setExtra(key, value);
        });
        if (tags) $g5j9r.setTags(tags);
        $g5j9r.captureException(ex);
    });
    else $g5j9r.captureException(ex);
}
const $082c78405adc64cb$export$ddf087afa206091f = (ex, payload = {}, tag)=>{
    $082c78405adc64cb$export$f5282963edea4a68(ex, payload, {
        recaptcha: tag
    });
};
const $082c78405adc64cb$export$5ec83ab111bbcd41 = (ex, payload = {}, tag)=>{
    $082c78405adc64cb$export$f5282963edea4a68(ex, payload, {
        coBranding: tag
    });
};
const $082c78405adc64cb$export$b6c309bc746f6dbf = (ex, payload = {}, tag)=>{
    $082c78405adc64cb$export$f5282963edea4a68(ex, payload, {
        malformedError: tag
    });
};
const $082c78405adc64cb$export$2fb60ea2fe20385b = (msg, payload = {}, tag)=>{
    $082c78405adc64cb$export$45654777c133ae80(msg, payload, 'error', {
        coBranding: tag
    });
};
function $082c78405adc64cb$export$53b98cb085651af4(msg, payload = {}) {
    $082c78405adc64cb$export$45654777c133ae80(msg, payload, 'error');
}
const $082c78405adc64cb$export$8a94d1afc2068093 = (msg, payload = {}, tag)=>{
    $082c78405adc64cb$export$45654777c133ae80(msg, payload, 'error', {
        recaptcha: tag
    });
};
function $082c78405adc64cb$export$45654777c133ae80(msg, payload, severity, tags) {
    if (payload) $bkLxn.withScope((scope)=>{
        Object.entries(payload).forEach(([key, value])=>{
            scope.setExtra(key, value);
        });
        if (tags) $g5j9r.setTags(tags);
        $g5j9r.captureMessage(msg, severity);
    });
    else $g5j9r.captureMessage(msg, severity);
}
/**
 * Sentry only allows primitives for tag values.
 *
 * Since an error may be related to more than one capability group/subgroup/name, we need the
 * option to assign multiple different capability tags.
 *
 * For example, an error during check-username could impact both password+username login as well
 * as SSO login - both cases will need to be represented with their own tag.
 *
 * i.e. we can't include an array of affected capabilities under a single tag, so we include
 * them all individually as both the key and the value, like:
 *
 * { 'capability-group:login': 'capability-group:login' };
 */ const $082c78405adc64cb$var$capabilitiesToTags = (capabilities)=>capabilities.reduce((acc, current)=>{
        return {
            ...acc,
            [current]: current
        };
    }, {});

});
parcelRegister("1cBgb", function(module, exports) {

$parcel$export(module.exports, "addBreadcrumb", function () { return $0e03d0856ff7e17a$export$efda9a273d7a036d; });

var $bkLxn = parcelRequire("bkLxn");

var $lEIJP = parcelRequire("lEIJP");

var $aGoK9 = parcelRequire("aGoK9");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $0e03d0856ff7e17a$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $0e03d0856ff7e17a$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $bkLxn.getClient)();
    const isolationScope = (0, $bkLxn.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $0e03d0856ff7e17a$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $aGoK9.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $lEIJP.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

});
parcelRegister("bkLxn", function(module, exports) {

$parcel$export(module.exports, "getCurrentScope", function () { return $84066fe43354d951$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getIsolationScope", function () { return $84066fe43354d951$export$68f3af03034c9e90; });
$parcel$export(module.exports, "getGlobalScope", function () { return $84066fe43354d951$export$aa55d5ab8e05984f; });
$parcel$export(module.exports, "withScope", function () { return $84066fe43354d951$export$ec58d9285c204497; });
$parcel$export(module.exports, "withIsolationScope", function () { return $84066fe43354d951$export$9a4fed82c350c2bd; });
$parcel$export(module.exports, "getClient", function () { return $84066fe43354d951$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "getTraceContextFromScope", function () { return $84066fe43354d951$export$1e83db7ee4876dc4; });

var $lfn2O = parcelRequire("lfn2O");

var $cKggp = parcelRequire("cKggp");

var $1qKJR = parcelRequire("1qKJR");

var $a56dT = parcelRequire("a56dT");
/**
 * Get the currently active scope.
 */ function $84066fe43354d951$export$c7be4b0125a10cba() {
    const carrier = (0, $cKggp.getMainCarrier)();
    const acs = (0, $lfn2O.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $84066fe43354d951$export$68f3af03034c9e90() {
    const carrier = (0, $cKggp.getMainCarrier)();
    const acs = (0, $lfn2O.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $84066fe43354d951$export$aa55d5ab8e05984f() {
    return (0, $cKggp.getGlobalSingleton)('globalScope', ()=>new (0, $1qKJR.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $84066fe43354d951$export$ec58d9285c204497(...rest) {
    const carrier = (0, $cKggp.getMainCarrier)();
    const acs = (0, $lfn2O.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $84066fe43354d951$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $cKggp.getMainCarrier)();
    const acs = (0, $lfn2O.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $84066fe43354d951$export$6bb76d6eba7e258c() {
    return $84066fe43354d951$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $84066fe43354d951$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $a56dT.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

});
parcelRegister("lfn2O", function(module, exports) {

$parcel$export(module.exports, "getAsyncContextStrategy", function () { return $f77cdfd1a48da359$export$f639b0c2752203be; });

var $cKggp = parcelRequire("cKggp");

var $7Z808 = parcelRequire("7Z808");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $f77cdfd1a48da359$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $cKggp.getMainCarrier)();
    const sentry = (0, $cKggp.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $f77cdfd1a48da359$export$f639b0c2752203be(carrier) {
    const sentry = (0, $cKggp.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $7Z808.getStackAsyncContextStrategy)();
}

});
parcelRegister("cKggp", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $9476658d84674049$export$19eade501500c6c1; });
$parcel$export(module.exports, "getSentryCarrier", function () { return $9476658d84674049$export$c8bfa33e4e8ae492; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $9476658d84674049$export$7e223ec222791509; });

var $9QvbA = parcelRequire("9QvbA");

var $e5cgV = parcelRequire("e5cgV");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $9476658d84674049$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $9476658d84674049$export$c8bfa33e4e8ae492((0, $e5cgV.GLOBAL_OBJ));
    return 0, $e5cgV.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $9476658d84674049$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $9QvbA.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $9QvbA.SDK_VERSION] = __SENTRY__[0, $9QvbA.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $9476658d84674049$export$7e223ec222791509(name, creator, obj = (0, $e5cgV.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $9QvbA.SDK_VERSION] = __SENTRY__[0, $9QvbA.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("9QvbA", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $72b129467004ebe2$export$31499a9cd224b78c; });
// This is a magic string replaced by rollup
const $72b129467004ebe2$export$31499a9cd224b78c = "9.47.1";

});

parcelRegister("e5cgV", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $a40b0d4c8095e9ad$export$f1a6cdb1459e81d1; });
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $a40b0d4c8095e9ad$export$f1a6cdb1459e81d1 = globalThis;

});


parcelRegister("7Z808", function(module, exports) {

$parcel$export(module.exports, "getStackAsyncContextStrategy", function () { return $5d046fc6841934c3$export$329d4d4d54e42710; });

var $aSIor = parcelRequire("aSIor");

var $1qKJR = parcelRequire("1qKJR");

var $3TywK = parcelRequire("3TywK");

var $cKggp = parcelRequire("cKggp");
/**
 * This is an object that holds a stack of scopes.
 */ class $5d046fc6841934c3$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $1qKJR.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $1qKJR.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $3TywK.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $5d046fc6841934c3$var$getAsyncContextStack() {
    const registry = (0, $cKggp.getMainCarrier)();
    const sentry = (0, $cKggp.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $5d046fc6841934c3$export$d36ec451f120cfba((0, $aSIor.getDefaultCurrentScope)(), (0, $aSIor.getDefaultIsolationScope)());
}
function $5d046fc6841934c3$var$withScope(callback) {
    return $5d046fc6841934c3$var$getAsyncContextStack().withScope(callback);
}
function $5d046fc6841934c3$var$withSetScope(scope, callback) {
    const stack = $5d046fc6841934c3$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $5d046fc6841934c3$var$withIsolationScope(callback) {
    return $5d046fc6841934c3$var$getAsyncContextStack().withScope(()=>{
        return callback($5d046fc6841934c3$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $5d046fc6841934c3$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $5d046fc6841934c3$var$withIsolationScope,
        withScope: $5d046fc6841934c3$var$withScope,
        withSetScope: $5d046fc6841934c3$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $5d046fc6841934c3$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$5d046fc6841934c3$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$5d046fc6841934c3$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("aSIor", function(module, exports) {

$parcel$export(module.exports, "getDefaultCurrentScope", function () { return $7ec1621ec5cf2045$export$6f1b9191db9c4d5; });
$parcel$export(module.exports, "getDefaultIsolationScope", function () { return $7ec1621ec5cf2045$export$de9862929b76bf57; });

var $cKggp = parcelRequire("cKggp");

var $1qKJR = parcelRequire("1qKJR");
/** Get the default current scope. */ function $7ec1621ec5cf2045$export$6f1b9191db9c4d5() {
    return (0, $cKggp.getGlobalSingleton)('defaultCurrentScope', ()=>new (0, $1qKJR.Scope)());
}
/** Get the default isolation scope. */ function $7ec1621ec5cf2045$export$de9862929b76bf57() {
    return (0, $cKggp.getGlobalSingleton)('defaultIsolationScope', ()=>new (0, $1qKJR.Scope)());
}

});
parcelRegister("1qKJR", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $10ac798006da646a$export$775b6bb06e53a214; });

var $eAxGy = parcelRequire("eAxGy");

var $jo5k0 = parcelRequire("jo5k0");

var $lEIJP = parcelRequire("lEIJP");

var $3TywK = parcelRequire("3TywK");

var $dOEnU = parcelRequire("dOEnU");

var $75eh7 = parcelRequire("75eh7");

var $a56dT = parcelRequire("a56dT");

var $3VljW = parcelRequire("3VljW");

var $ew86D = parcelRequire("ew86D");

var $aGoK9 = parcelRequire("aGoK9");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $10ac798006da646a$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $10ac798006da646a$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $a56dT.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $10ac798006da646a$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $3VljW._setSpanForScope)(newScope, (0, $3VljW._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $jo5k0.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $10ac798006da646a$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $3TywK.isPlainObject)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $3VljW._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $a56dT.generateTraceId)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $10ac798006da646a$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $aGoK9.dateTimestampInSeconds)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $ew86D.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $3VljW._getSpanForScope)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $dOEnU.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $75eh7.uuid4)();
        if (!this._client) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $75eh7.uuid4)();
        if (!this._client) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $75eh7.uuid4)();
        if (!this._client) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}

});
parcelRegister("eAxGy", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $a9ee8eb584fe05d1$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a9ee8eb584fe05d1$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("jo5k0", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $e1d462f8bbd3571b$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $e1d462f8bbd3571b$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $e1d462f8bbd3571b$export$56521d9ba90f62ee; });

var $75eh7 = parcelRequire("75eh7");

var $aGoK9 = parcelRequire("aGoK9");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $e1d462f8bbd3571b$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $aGoK9.timestampInSeconds)();
    const session = {
        sid: (0, $75eh7.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$e1d462f8bbd3571b$var$sessionToJSON(session)
    };
    if (context) $e1d462f8bbd3571b$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $e1d462f8bbd3571b$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $aGoK9.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $75eh7.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $e1d462f8bbd3571b$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $e1d462f8bbd3571b$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $e1d462f8bbd3571b$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

});
parcelRegister("75eh7", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $528412bfde9232e2$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $528412bfde9232e2$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $528412bfde9232e2$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $528412bfde9232e2$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $528412bfde9232e2$export$6de4ffac6a2f1098; });

var $7WT4q = parcelRequire("7WT4q");

var $ew86D = parcelRequire("ew86D");

var $e5cgV = parcelRequire("e5cgV");
function $528412bfde9232e2$var$getCrypto() {
    const gbl = (0, $e5cgV.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $528412bfde9232e2$export$19f53698e68b2496(crypto = $528412bfde9232e2$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch  {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $528412bfde9232e2$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $528412bfde9232e2$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $528412bfde9232e2$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $528412bfde9232e2$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $528412bfde9232e2$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $528412bfde9232e2$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $528412bfde9232e2$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $528412bfde9232e2$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $528412bfde9232e2$export$d364f2020ab30578(input) {
    const match = input.match($528412bfde9232e2$var$SEMVER_REGEXP) || [];
    const major = $528412bfde9232e2$var$_parseInt(match[1]);
    const minor = $528412bfde9232e2$var$_parseInt(match[2]);
    const patch = $528412bfde9232e2$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $528412bfde9232e2$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $ew86D.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $ew86D.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $ew86D.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $528412bfde9232e2$export$6de4ffac6a2f1098(exception) {
    if ($528412bfde9232e2$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $7WT4q.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch  {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $528412bfde9232e2$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}

});
parcelRegister("7WT4q", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $5c98ab04afcef461$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $5c98ab04afcef461$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $5c98ab04afcef461$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $5c98ab04afcef461$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $5c98ab04afcef461$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $5c98ab04afcef461$export$b0244d5063c0b61b; });

var $eAxGy = parcelRequire("eAxGy");

var $dOTpB = parcelRequire("dOTpB");

var $lEIJP = parcelRequire("lEIJP");

var $3TywK = parcelRequire("3TywK");

var $ew86D = parcelRequire("ew86D");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $5c98ab04afcef461$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $5c98ab04afcef461$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $5c98ab04afcef461$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $5c98ab04afcef461$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $5c98ab04afcef461$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch  {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $5c98ab04afcef461$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $5c98ab04afcef461$export$62ff257738bf57f5(value) {
    if ((0, $3TywK.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$5c98ab04afcef461$var$getOwnProperties(value)
    };
    else if ((0, $3TywK.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $5c98ab04afcef461$var$serializeEventTarget(value.target),
            currentTarget: $5c98ab04afcef461$var$serializeEventTarget(value.currentTarget),
            ...$5c98ab04afcef461$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $3TywK.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $5c98ab04afcef461$var$serializeEventTarget(target) {
    try {
        return (0, $3TywK.isElement)(target) ? (0, $dOTpB.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch  {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $5c98ab04afcef461$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $5c98ab04afcef461$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($5c98ab04afcef461$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $ew86D.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $ew86D.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $5c98ab04afcef461$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $5c98ab04afcef461$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $5c98ab04afcef461$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($5c98ab04afcef461$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($5c98ab04afcef461$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $5c98ab04afcef461$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $5c98ab04afcef461$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $5c98ab04afcef461$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $3TywK.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("dOTpB", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $a0faed8afe1090bf$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $a0faed8afe1090bf$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getComponentName", function () { return $a0faed8afe1090bf$export$26727cfcc4d7e0fc; });

var $3TywK = parcelRequire("3TywK");

var $e5cgV = parcelRequire("e5cgV");
const $a0faed8afe1090bf$var$WINDOW = (0, $e5cgV.GLOBAL_OBJ);
const $a0faed8afe1090bf$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a0faed8afe1090bf$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $a0faed8afe1090bf$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $a0faed8afe1090bf$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a0faed8afe1090bf$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($a0faed8afe1090bf$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $3TywK.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $a0faed8afe1090bf$export$1cfafeee2987818b() {
    try {
        return $a0faed8afe1090bf$var$WINDOW.document.location.href;
    } catch  {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $a0faed8afe1090bf$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$a0faed8afe1090bf$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("3TywK", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $2d614a8645918123$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $2d614a8645918123$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $2d614a8645918123$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $2d614a8645918123$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $2d614a8645918123$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $2d614a8645918123$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $2d614a8645918123$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $2d614a8645918123$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $2d614a8645918123$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $2d614a8645918123$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $2d614a8645918123$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $2d614a8645918123$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $2d614a8645918123$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $2d614a8645918123$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isVueViewModel", function () { return $2d614a8645918123$export$7916fad0ebc23f48; });
$parcel$export(module.exports, "isRequest", function () { return $2d614a8645918123$export$6d3d1f317d7cda57; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $2d614a8645918123$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$e6127cc7fe7395c3(wat) {
    switch($2d614a8645918123$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $2d614a8645918123$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$var$isBuiltin(wat, className) {
    return $2d614a8645918123$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$9f9636d330b71954(wat) {
    return $2d614a8645918123$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$ef9e2056653f0c8e(wat) {
    return $2d614a8645918123$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$12e869b2a583f783(wat) {
    return $2d614a8645918123$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$844ec244b1367d54(wat) {
    return $2d614a8645918123$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$c3825b437cbdea5c(wat) {
    return wat === null || $2d614a8645918123$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$53b83ca8eaab0383(wat) {
    return $2d614a8645918123$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $2d614a8645918123$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $2d614a8645918123$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$49841c62b9eff15(wat) {
    return $2d614a8645918123$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $2d614a8645918123$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$bc2894c7158efbac(wat) {
    return $2d614a8645918123$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $2d614a8645918123$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $2d614a8645918123$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $2d614a8645918123$export$49034edbe6b62415(request, Request);
}

});


parcelRegister("lEIJP", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $fc4009799adab44f$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $fc4009799adab44f$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $fc4009799adab44f$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "debug", function () { return $fc4009799adab44f$export$1c9f709888824e05; });

var $cKggp = parcelRequire("cKggp");

var $eAxGy = parcelRequire("eAxGy");

var $e5cgV = parcelRequire("e5cgV");
/**
 * A Sentry Logger instance.
 *
 * @deprecated Use {@link debug} instead with the {@link SentryDebugLogger} type.
 */ const $fc4009799adab44f$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $fc4009799adab44f$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $fc4009799adab44f$export$77c4ce905194557b = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $fc4009799adab44f$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $e5cgV.GLOBAL_OBJ))) return callback();
    const console = (0, $e5cgV.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($fc4009799adab44f$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $fc4009799adab44f$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $fc4009799adab44f$var$enable() {
    $fc4009799adab44f$var$_getLoggerSettings().enabled = true;
}
function $fc4009799adab44f$var$disable() {
    $fc4009799adab44f$var$_getLoggerSettings().enabled = false;
}
function $fc4009799adab44f$var$isEnabled() {
    return $fc4009799adab44f$var$_getLoggerSettings().enabled;
}
function $fc4009799adab44f$var$log(...args) {
    $fc4009799adab44f$var$_maybeLog('log', ...args);
}
function $fc4009799adab44f$var$info(...args) {
    $fc4009799adab44f$var$_maybeLog('info', ...args);
}
function $fc4009799adab44f$var$warn(...args) {
    $fc4009799adab44f$var$_maybeLog('warn', ...args);
}
function $fc4009799adab44f$var$error(...args) {
    $fc4009799adab44f$var$_maybeLog('error', ...args);
}
function $fc4009799adab44f$var$_debug(...args) {
    $fc4009799adab44f$var$_maybeLog('debug', ...args);
}
function $fc4009799adab44f$var$assert(...args) {
    $fc4009799adab44f$var$_maybeLog('assert', ...args);
}
function $fc4009799adab44f$var$trace(...args) {
    $fc4009799adab44f$var$_maybeLog('trace', ...args);
}
function $fc4009799adab44f$var$_maybeLog(level, ...args) {
    if (!(0, $eAxGy.DEBUG_BUILD)) return;
    if ($fc4009799adab44f$var$isEnabled()) $fc4009799adab44f$export$cda52e2a8927a2ca(()=>{
        (0, $e5cgV.GLOBAL_OBJ).console[level](`${$fc4009799adab44f$var$PREFIX}[${level}]:`, ...args);
    });
}
function $fc4009799adab44f$var$_getLoggerSettings() {
    if (!(0, $eAxGy.DEBUG_BUILD)) return {
        enabled: false
    };
    return (0, $cKggp.getGlobalSingleton)('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 *
 * @deprecated Use {@link debug} instead.
 */ const $fc4009799adab44f$export$af88d00dbe7f521 = {
    enable: /** Enable logging. */ $fc4009799adab44f$var$enable,
    disable: /** Disable logging. */ $fc4009799adab44f$var$disable,
    isEnabled: /** Check if logging is enabled. */ $fc4009799adab44f$var$isEnabled,
    log: /** Log a message. */ $fc4009799adab44f$var$log,
    info: /** Log level info */ $fc4009799adab44f$var$info,
    warn: /** Log a warning. */ $fc4009799adab44f$var$warn,
    error: /** Log an error. */ $fc4009799adab44f$var$error,
    /** Log a debug message. */ debug: $fc4009799adab44f$var$_debug,
    assert: /** Log an assertion. */ $fc4009799adab44f$var$assert,
    trace: /** Log a trace. */ $fc4009799adab44f$var$trace
};
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $fc4009799adab44f$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $fc4009799adab44f$var$enable,
    disable: /** Disable logging. */ $fc4009799adab44f$var$disable,
    isEnabled: /** Check if logging is enabled. */ $fc4009799adab44f$var$isEnabled,
    log: /** Log a message. */ $fc4009799adab44f$var$log,
    warn: /** Log a warning. */ $fc4009799adab44f$var$warn,
    error: /** Log an error. */ $fc4009799adab44f$var$error
};

});

parcelRegister("ew86D", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $a91a578df898d068$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $a91a578df898d068$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $a91a578df898d068$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $a91a578df898d068$export$a7a5ec66062ea5d; });

var $3TywK = parcelRequire("3TywK");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $a91a578df898d068$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $a91a578df898d068$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $a91a578df898d068$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $3TywK.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch  {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $a91a578df898d068$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $3TywK.isString)(value)) return false;
    if ((0, $3TywK.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $3TywK.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $a91a578df898d068$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$a91a578df898d068$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("aGoK9", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $7c710521ed699362$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $7c710521ed699362$export$ee52dced521e3e18; });

var $e5cgV = parcelRequire("e5cgV");
const $7c710521ed699362$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $7c710521ed699362$export$7740643b9eeaf0c4() {
    return Date.now() / $7c710521ed699362$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $7c710521ed699362$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $e5cgV.GLOBAL_OBJ);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!performance?.now || !performance.timeOrigin) return $7c710521ed699362$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $7c710521ed699362$var$ONE_SECOND_IN_MS;
    };
}
let $7c710521ed699362$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $7c710521ed699362$export$ee52dced521e3e18() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $7c710521ed699362$var$_cachedTimestampInSeconds ?? ($7c710521ed699362$var$_cachedTimestampInSeconds = $7c710521ed699362$var$createUnixTimestampInSecondsFunc());
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $7c710521ed699362$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $7c710521ed699362$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $e5cgV.GLOBAL_OBJ);
    if (!performance?.now) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $7c710521ed699362$export$baf075a948ffc0bf() {
    if (!$7c710521ed699362$var$cachedTimeOrigin) $7c710521ed699362$var$cachedTimeOrigin = $7c710521ed699362$var$getBrowserTimeOrigin();
    return $7c710521ed699362$var$cachedTimeOrigin[0];
}

});


parcelRegister("dOEnU", function(module, exports) {

$parcel$export(module.exports, "merge", function () { return $a0ef456c1b34661f$export$4950aa0f605343fb; });
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $a0ef456c1b34661f$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $a0ef456c1b34661f$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("a56dT", function(module, exports) {

$parcel$export(module.exports, "generateTraceId", function () { return $756f32cc6228a2f8$export$dc6d7ea554bcce10; });
$parcel$export(module.exports, "generateSpanId", function () { return $756f32cc6228a2f8$export$295213bc4d0c54ad; });

var $75eh7 = parcelRequire("75eh7");
/**
 * Generate a random, valid trace ID.
 */ function $756f32cc6228a2f8$export$dc6d7ea554bcce10() {
    return (0, $75eh7.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $756f32cc6228a2f8$export$295213bc4d0c54ad() {
    return (0, $75eh7.uuid4)().substring(16);
}

});

parcelRegister("3VljW", function(module, exports) {

$parcel$export(module.exports, "_setSpanForScope", function () { return $2db73bd253f9192c$export$3f25fa50c18e20ca; });
$parcel$export(module.exports, "_getSpanForScope", function () { return $2db73bd253f9192c$export$91f063ebb8eff307; });

var $7WT4q = parcelRequire("7WT4q");
const $2db73bd253f9192c$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $2db73bd253f9192c$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $7WT4q.addNonEnumerableProperty)(scope, $2db73bd253f9192c$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$2db73bd253f9192c$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $2db73bd253f9192c$export$91f063ebb8eff307(scope) {
    return scope[$2db73bd253f9192c$var$SCOPE_SPAN_FIELD];
}

});







parcelRegister("g5j9r", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $bb5bf8026e50fa24$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $bb5bf8026e50fa24$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $bb5bf8026e50fa24$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "setContext", function () { return $bb5bf8026e50fa24$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setTags", function () { return $bb5bf8026e50fa24$export$74a8fb34822092e6; });
$parcel$export(module.exports, "startSession", function () { return $bb5bf8026e50fa24$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $bb5bf8026e50fa24$export$667e7b4d445d566b; });

var $bkLxn = parcelRequire("bkLxn");

var $eAxGy = parcelRequire("eAxGy");

var $jo5k0 = parcelRequire("jo5k0");

var $lEIJP = parcelRequire("lEIJP");

var $3TywK = parcelRequire("3TywK");

var $75eh7 = parcelRequire("75eh7");

var $in9oF = parcelRequire("in9oF");

var $aGoK9 = parcelRequire("aGoK9");

var $e5cgV = parcelRequire("e5cgV");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $bb5bf8026e50fa24$export$f5282963edea4a68(exception, hint) {
    return (0, $bkLxn.getCurrentScope)().captureException(exception, (0, $in9oF.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $bb5bf8026e50fa24$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $bkLxn.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $bb5bf8026e50fa24$export$1462b974fdcf6ba2(event, hint) {
    return (0, $bkLxn.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $bb5bf8026e50fa24$export$2f04de43fe27971a(name, context) {
    (0, $bkLxn.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $bb5bf8026e50fa24$export$bb4922da0dd51b92(extras) {
    (0, $bkLxn.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $bb5bf8026e50fa24$export$8e8e7789d42ed61d(key, extra) {
    (0, $bkLxn.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $bb5bf8026e50fa24$export$74a8fb34822092e6(tags) {
    (0, $bkLxn.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $bb5bf8026e50fa24$export$a37d07ee78eb4569(key, value) {
    (0, $bkLxn.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $bb5bf8026e50fa24$export$8b6bb3dd62a01be2(user) {
    (0, $bkLxn.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $bb5bf8026e50fa24$export$5d4e9fd7fac8e617() {
    return (0, $bkLxn.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $bb5bf8026e50fa24$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $bkLxn.getCurrentScope)();
    const client = (0, $bkLxn.getClient)();
    if (!client) (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $75eh7.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $bb5bf8026e50fa24$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $bb5bf8026e50fa24$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $aGoK9.timestampInSeconds)();
    function finishCheckIn(status) {
        $bb5bf8026e50fa24$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $aGoK9.timestampInSeconds)() - now
        });
    }
    return (0, $bkLxn.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $3TywK.isThenable)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn('ok');
            return r;
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $bb5bf8026e50fa24$export$4909b86c8034bf73(timeout) {
    const client = (0, $bkLxn.getClient)();
    if (client) return client.flush(timeout);
    (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $bb5bf8026e50fa24$export$8360e631d277ea4d(timeout) {
    const client = (0, $bkLxn.getClient)();
    if (client) return client.close(timeout);
    (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $bb5bf8026e50fa24$export$3f95c6f800b78024() {
    return !!(0, $bkLxn.getClient)();
}
/** If the SDK is initialized & enabled. */ function $bb5bf8026e50fa24$export$3b029eb57ac4d562() {
    const client = (0, $bkLxn.getClient)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $bb5bf8026e50fa24$export$9aac0b9f77928fbf(callback) {
    (0, $bkLxn.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $bb5bf8026e50fa24$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $bkLxn.getIsolationScope)();
    const currentScope = (0, $bkLxn.getCurrentScope)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $e5cgV.GLOBAL_OBJ).navigator || {};
    const session = (0, $jo5k0.makeSession)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $jo5k0.updateSession)(currentSession, {
        status: 'exited'
    });
    $bb5bf8026e50fa24$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $bb5bf8026e50fa24$export$17a5be43989a0bc1() {
    const isolationScope = (0, $bkLxn.getIsolationScope)();
    const currentScope = (0, $bkLxn.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $jo5k0.closeSession)(session);
    $bb5bf8026e50fa24$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $bb5bf8026e50fa24$var$_sendSessionUpdate() {
    const isolationScope = (0, $bkLxn.getIsolationScope)();
    const client = (0, $bkLxn.getClient)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $bb5bf8026e50fa24$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $bb5bf8026e50fa24$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $bb5bf8026e50fa24$var$_sendSessionUpdate();
}

});
parcelRegister("in9oF", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $d601a9f9f9427e59$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $d601a9f9f9427e59$export$76b5f966996d1653; });

var $eKyOP = parcelRequire("eKyOP");

var $bkLxn = parcelRequire("bkLxn");

var $eQtim = parcelRequire("eQtim");

var $1qKJR = parcelRequire("1qKJR");

var $j7PfY = parcelRequire("j7PfY");

var $8pf92 = parcelRequire("8pf92");

var $75eh7 = parcelRequire("75eh7");

var $5k1Xv = parcelRequire("5k1Xv");

var $ew86D = parcelRequire("ew86D");

var $aGoK9 = parcelRequire("aGoK9");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $d601a9f9f9427e59$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $75eh7.uuid4)(),
        timestamp: event.timestamp || (0, $aGoK9.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $d601a9f9f9427e59$export$d7e04067a6fbc882(prepared, options);
    $d601a9f9f9427e59$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $d601a9f9f9427e59$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $d601a9f9f9427e59$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $75eh7.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $bkLxn.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $j7PfY.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $j7PfY.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $j7PfY.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $eQtim.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $d601a9f9f9427e59$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $d601a9f9f9427e59$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $d601a9f9f9427e59$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $eKyOP.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $ew86D.truncate)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $d601a9f9f9427e59$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $8pf92.getFilenameToDebugIdMap)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $d601a9f9f9427e59$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $d601a9f9f9427e59$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $d601a9f9f9427e59$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $5k1Xv.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $5k1Xv.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $5k1Xv.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $5k1Xv.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $5k1Xv.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $5k1Xv.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $5k1Xv.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $d601a9f9f9427e59$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $1qKJR.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $d601a9f9f9427e59$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($d601a9f9f9427e59$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($d601a9f9f9427e59$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $d601a9f9f9427e59$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $1qKJR.Scope) || typeof hint === 'function';
}
const $d601a9f9f9427e59$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $d601a9f9f9427e59$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$d601a9f9f9427e59$var$captureContextKeys.includes(key));
}

});
parcelRegister("eKyOP", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $abd05edd92cdbbd8$export$849dbeeeda01ae98; });
const $abd05edd92cdbbd8$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("eQtim", function(module, exports) {

$parcel$export(module.exports, "notifyEventProcessors", function () { return $aceca56ec8a4f8c1$export$bf2a096c3e883e79; });

var $eAxGy = parcelRequire("eAxGy");

var $lEIJP = parcelRequire("lEIJP");

var $3TywK = parcelRequire("3TywK");

var $2C0zV = parcelRequire("2C0zV");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $aceca56ec8a4f8c1$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $2C0zV.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $eAxGy.DEBUG_BUILD) && processor.id && result === null && (0, $lEIJP.debug).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $3TywK.isThenable)(result)) result.then((final)=>$aceca56ec8a4f8c1$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $aceca56ec8a4f8c1$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("2C0zV", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $1e6f9443729e605e$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $1e6f9443729e605e$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $1e6f9443729e605e$export$78e43115b553f358; });

var $3TywK = parcelRequire("3TywK");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const $1e6f9443729e605e$var$STATE_PENDING = 0;
const $1e6f9443729e605e$var$STATE_RESOLVED = 1;
const $1e6f9443729e605e$var$STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $1e6f9443729e605e$export$1fda8aa4d135f8aa(value) {
    return new $1e6f9443729e605e$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $1e6f9443729e605e$export$78e43115b553f358(reason) {
    return new $1e6f9443729e605e$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $1e6f9443729e605e$export$6f292d4960313241 {
    constructor(executor){
        this._state = $1e6f9443729e605e$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $1e6f9443729e605e$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $1e6f9443729e605e$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $1e6f9443729e605e$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $1e6f9443729e605e$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $1e6f9443729e605e$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $1e6f9443729e605e$var$STATE_PENDING) return;
            if ((0, $3TywK.isThenable)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($1e6f9443729e605e$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($1e6f9443729e605e$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}

});


parcelRegister("j7PfY", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $dec66e4123a06ed2$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $dec66e4123a06ed2$export$25ac7e259a513db4; });

var $6eH4L = parcelRequire("6eH4L");

var $dOEnU = parcelRequire("dOEnU");

var $iSrLD = parcelRequire("iSrLD");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $dec66e4123a06ed2$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $dec66e4123a06ed2$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $dec66e4123a06ed2$var$applySpanToEvent(event, span);
    $dec66e4123a06ed2$var$applyFingerprintToEvent(event, fingerprint);
    $dec66e4123a06ed2$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $dec66e4123a06ed2$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $dec66e4123a06ed2$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $dec66e4123a06ed2$export$b1a120a2871faa46(data, 'extra', extra);
    $dec66e4123a06ed2$export$b1a120a2871faa46(data, 'tags', tags);
    $dec66e4123a06ed2$export$b1a120a2871faa46(data, 'user', user);
    $dec66e4123a06ed2$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $dOEnU.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $dec66e4123a06ed2$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $dOEnU.merge)(data[prop], mergeVal, 1);
}
function $dec66e4123a06ed2$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $dec66e4123a06ed2$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $dec66e4123a06ed2$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $dec66e4123a06ed2$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $iSrLD.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $6eH4L.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $iSrLD.getRootSpan)(span);
    const transactionName = (0, $iSrLD.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $dec66e4123a06ed2$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("6eH4L", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromScope", function () { return $48a576d572771acf$export$89ef1736f08c6b2b; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $48a576d572771acf$export$a117f995597e25df; });

var $eKyOP = parcelRequire("eKyOP");

var $bkLxn = parcelRequire("bkLxn");

var $ktN3S = parcelRequire("ktN3S");

var $2y9N9 = parcelRequire("2y9N9");

var $lxbnR = parcelRequire("lxbnR");

var $810i2 = parcelRequire("810i2");

var $7WT4q = parcelRequire("7WT4q");

var $iSrLD = parcelRequire("iSrLD");

var $3Al8K = parcelRequire("3Al8K");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $48a576d572771acf$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $48a576d572771acf$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $7WT4q.addNonEnumerableProperty)(spanWithMaybeDsc, $48a576d572771acf$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $48a576d572771acf$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key, host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = (0, $lxbnR.extractOrgIdFromDsnHost)(host);
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $eKyOP.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: org_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $48a576d572771acf$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $48a576d572771acf$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $48a576d572771acf$export$a117f995597e25df(span) {
    const client = (0, $bkLxn.getClient)();
    if (!client) return {};
    const rootSpan = (0, $iSrLD.getRootSpan)(span);
    const rootSpanJson = (0, $iSrLD.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $ktN3S.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[0, $ktN3S.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$48a576d572771acf$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $2y9N9.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $48a576d572771acf$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $ktN3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $810i2.hasSpansEnabled)()) {
        dsc.sampled = String((0, $iSrLD.spanIsSampled)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $3Al8K.getCapturedScopesOnSpan)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $48a576d572771acf$export$95cf936fdacaff7b(span) {
    const dsc = $48a576d572771acf$export$a117f995597e25df(span);
    return (0, $2y9N9.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("ktN3S", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $ee8c92ab98386fff$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $ee8c92ab98386fff$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", function () { return $ee8c92ab98386fff$export$889fb736668e1ecc; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $ee8c92ab98386fff$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $ee8c92ab98386fff$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function () { return $ee8c92ab98386fff$export$165ce9a229f6f050; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $ee8c92ab98386fff$export$1efec95406bbe327; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function () { return $ee8c92ab98386fff$export$fea48ba9f4550879; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", function () { return $ee8c92ab98386fff$export$be7a251980e7e946; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_URL_FULL", function () { return $ee8c92ab98386fff$export$25dfd73e0e32c6e1; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $ee8c92ab98386fff$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $ee8c92ab98386fff$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $ee8c92ab98386fff$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $ee8c92ab98386fff$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $ee8c92ab98386fff$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $ee8c92ab98386fff$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $ee8c92ab98386fff$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $ee8c92ab98386fff$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $ee8c92ab98386fff$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $ee8c92ab98386fff$export$1efec95406bbe327 = 'sentry.profile_id';
const $ee8c92ab98386fff$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $ee8c92ab98386fff$export$b016f89ac1066ec = 'cache.hit';
const $ee8c92ab98386fff$export$3110e4c3f4386399 = 'cache.key';
const $ee8c92ab98386fff$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $ee8c92ab98386fff$export$be7a251980e7e946 = 'http.request.method';
const $ee8c92ab98386fff$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $ee8c92ab98386fff$export$ff77b5fd5b2d627b = 'sentry.link.type';

});

parcelRegister("2y9N9", function(module, exports) {

$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $1db65a2bad05e151$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $1db65a2bad05e151$export$56766feef403f365; });

var $eAxGy = parcelRequire("eAxGy");

var $lEIJP = parcelRequire("lEIJP");

var $3TywK = parcelRequire("3TywK");
const $1db65a2bad05e151$export$6e69537d67fa20f = 'sentry-';
const $1db65a2bad05e151$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $1db65a2bad05e151$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $1db65a2bad05e151$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $1db65a2bad05e151$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($1db65a2bad05e151$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($1db65a2bad05e151$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $1db65a2bad05e151$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$1db65a2bad05e151$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $1db65a2bad05e151$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $1db65a2bad05e151$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $3TywK.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $1db65a2bad05e151$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $1db65a2bad05e151$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $1db65a2bad05e151$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        })).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $1db65a2bad05e151$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $1db65a2bad05e151$export$bdd844ddb2def819) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});

parcelRegister("lxbnR", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $fad582a684696688$export$44d472fbb931a776; });
$parcel$export(module.exports, "extractOrgIdFromDsnHost", function () { return $fad582a684696688$export$5914f4e7748c29c9; });
$parcel$export(module.exports, "makeDsn", function () { return $fad582a684696688$export$128827c3562ec0cb; });

var $eAxGy = parcelRequire("eAxGy");

var $lEIJP = parcelRequire("lEIJP");
/** Regular expression used to extract org ID from a DSN host. */ const $fad582a684696688$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $fad582a684696688$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $fad582a684696688$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $fad582a684696688$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $fad582a684696688$export$b892860177f70a30(str) {
    const match = $fad582a684696688$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $lEIJP.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $fad582a684696688$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $fad582a684696688$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $fad582a684696688$var$validateDsn(dsn) {
    if (!(0, $eAxGy.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $lEIJP.debug).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $lEIJP.debug).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$fad582a684696688$var$isValidProtocol(protocol)) {
        (0, $lEIJP.debug).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $lEIJP.debug).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $fad582a684696688$export$5914f4e7748c29c9(host) {
    const match = host.match($fad582a684696688$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $fad582a684696688$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $fad582a684696688$export$b892860177f70a30(from) : $fad582a684696688$var$dsnFromComponents(from);
    if (!components || !$fad582a684696688$var$validateDsn(components)) return undefined;
    return components;
}

});

parcelRegister("810i2", function(module, exports) {

$parcel$export(module.exports, "hasSpansEnabled", function () { return $5d5ea447a78366f0$export$1f70765132c3c225; });

var $bkLxn = parcelRequire("bkLxn");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $5d5ea447a78366f0$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $bkLxn.getClient)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $5d5ea447a78366f0$export$5008da00b1b6dee6 = $5d5ea447a78366f0$export$1f70765132c3c225;

});

parcelRegister("iSrLD", function(module, exports) {

$parcel$export(module.exports, "spanToJSON", function () { return $dbe2cf2442618e0d$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $dbe2cf2442618e0d$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanIsSampled", function () { return $dbe2cf2442618e0d$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "getRootSpan", function () { return $dbe2cf2442618e0d$export$c4c6a79b1260ca1b; });
$parcel$export(module.exports, "getActiveSpan", function () { return $dbe2cf2442618e0d$export$1be426a8e585c83e; });
$parcel$export(module.exports, "showSpanDropWarning", function () { return $dbe2cf2442618e0d$export$d11691ff45a3e535; });

var $lfn2O = parcelRequire("lfn2O");

var $cKggp = parcelRequire("cKggp");

var $bkLxn = parcelRequire("bkLxn");

var $ktN3S = parcelRequire("ktN3S");

var $2UU5P = parcelRequire("2UU5P");

var $3Al8K = parcelRequire("3Al8K");

var $7WT4q = parcelRequire("7WT4q");

var $a56dT = parcelRequire("a56dT");

var $aGoK9 = parcelRequire("aGoK9");

var $juM3Y = parcelRequire("juM3Y");

var $lEIJP = parcelRequire("lEIJP");

var $3VljW = parcelRequire("3VljW");
// These are aligned with OpenTelemetry trace flags
const $dbe2cf2442618e0d$export$208d5b368507fb8b = 0x0;
const $dbe2cf2442618e0d$export$eb571cd9b5d98de8 = 0x1;
let $dbe2cf2442618e0d$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $dbe2cf2442618e0d$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $dbe2cf2442618e0d$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $dbe2cf2442618e0d$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $dbe2cf2442618e0d$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $3Al8K.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $a56dT.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $dbe2cf2442618e0d$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $dbe2cf2442618e0d$export$5caecac1caaf3a71(span);
    return (0, $juM3Y.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $dbe2cf2442618e0d$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $dbe2cf2442618e0d$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $dbe2cf2442618e0d$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $dbe2cf2442618e0d$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $dbe2cf2442618e0d$var$ensureTimestampInSeconds(input.getTime());
    return (0, $aGoK9.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $dbe2cf2442618e0d$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $dbe2cf2442618e0d$export$92d8c23565496537(span) {
    if ($dbe2cf2442618e0d$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($dbe2cf2442618e0d$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $dbe2cf2442618e0d$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $dbe2cf2442618e0d$export$3f7581298f56c6d7(endTime) || undefined,
            status: $dbe2cf2442618e0d$export$e238a77ea3a8cd66(status),
            op: attributes[0, $ktN3S.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, $ktN3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $dbe2cf2442618e0d$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $dbe2cf2442618e0d$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $dbe2cf2442618e0d$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $dbe2cf2442618e0d$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $dbe2cf2442618e0d$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $dbe2cf2442618e0d$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $2UU5P.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $2UU5P.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'unknown_error';
}
const $dbe2cf2442618e0d$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $dbe2cf2442618e0d$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $dbe2cf2442618e0d$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$dbe2cf2442618e0d$var$ROOT_SPAN_FIELD] || span;
    (0, $7WT4q.addNonEnumerableProperty)(childSpan, $dbe2cf2442618e0d$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$dbe2cf2442618e0d$var$CHILD_SPANS_FIELD]) span[$dbe2cf2442618e0d$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $7WT4q.addNonEnumerableProperty)(span, $dbe2cf2442618e0d$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $dbe2cf2442618e0d$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$dbe2cf2442618e0d$var$CHILD_SPANS_FIELD]) span[$dbe2cf2442618e0d$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $dbe2cf2442618e0d$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($dbe2cf2442618e0d$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$dbe2cf2442618e0d$var$CHILD_SPANS_FIELD] ? Array.from(span[$dbe2cf2442618e0d$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $dbe2cf2442618e0d$export$c4c6a79b1260ca1b(span) {
    return span[$dbe2cf2442618e0d$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $dbe2cf2442618e0d$export$1be426a8e585c83e() {
    const carrier = (0, $cKggp.getMainCarrier)();
    const acs = (0, $lfn2O.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $3VljW._getSpanForScope)((0, $bkLxn.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $dbe2cf2442618e0d$export$d11691ff45a3e535() {
    if (!$dbe2cf2442618e0d$var$hasShownSpanDropWarning) {
        (0, $lEIJP.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $dbe2cf2442618e0d$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $dbe2cf2442618e0d$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $ktN3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
        [(0, $ktN3S.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("2UU5P", function(module, exports) {

$parcel$export(module.exports, "SPAN_STATUS_UNSET", function () { return $21fc52a57a0a400f$export$136e25984ba4a383; });
$parcel$export(module.exports, "SPAN_STATUS_OK", function () { return $21fc52a57a0a400f$export$58f7963109c806fc; });
const $21fc52a57a0a400f$export$136e25984ba4a383 = 0;
const $21fc52a57a0a400f$export$58f7963109c806fc = 1;
const $21fc52a57a0a400f$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $21fc52a57a0a400f$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $21fc52a57a0a400f$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $21fc52a57a0a400f$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $21fc52a57a0a400f$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $21fc52a57a0a400f$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $21fc52a57a0a400f$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $21fc52a57a0a400f$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $21fc52a57a0a400f$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $21fc52a57a0a400f$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $21fc52a57a0a400f$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $21fc52a57a0a400f$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $21fc52a57a0a400f$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $21fc52a57a0a400f$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $21fc52a57a0a400f$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $21fc52a57a0a400f$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $21fc52a57a0a400f$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $21fc52a57a0a400f$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

});

parcelRegister("3Al8K", function(module, exports) {

$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $29c521dd5fa8de5b$export$c08fbc656a245d03; });

var $7WT4q = parcelRequire("7WT4q");
const $29c521dd5fa8de5b$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $29c521dd5fa8de5b$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $29c521dd5fa8de5b$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $7WT4q.addNonEnumerableProperty)(span, $29c521dd5fa8de5b$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $7WT4q.addNonEnumerableProperty)(span, $29c521dd5fa8de5b$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $29c521dd5fa8de5b$export$c08fbc656a245d03(span) {
    return {
        scope: span[$29c521dd5fa8de5b$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$29c521dd5fa8de5b$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});

parcelRegister("juM3Y", function(module, exports) {

$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $e31619ff3563b8bd$export$f35d907436da45cf; });

var $2y9N9 = parcelRequire("2y9N9");

var $g8XY1 = parcelRequire("g8XY1");

var $a56dT = parcelRequire("a56dT");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $e31619ff3563b8bd$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $e31619ff3563b8bd$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($e31619ff3563b8bd$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $e31619ff3563b8bd$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $e31619ff3563b8bd$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $2y9N9.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $a56dT.generateTraceId)(),
        sampleRand: Math.random()
    };
    const sampleRand = $e31619ff3563b8bd$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $e31619ff3563b8bd$export$f35d907436da45cf(traceId = (0, $a56dT.generateTraceId)(), spanId = (0, $a56dT.generateSpanId)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $e31619ff3563b8bd$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $g8XY1.parseSampleRate)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $g8XY1.parseSampleRate)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}

});
parcelRegister("g8XY1", function(module, exports) {

$parcel$export(module.exports, "parseSampleRate", function () { return $bc0be8e6fdd763b7$export$a5bd2d81656d9546; });
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $bc0be8e6fdd763b7$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

});





parcelRegister("8pf92", function(module, exports) {

$parcel$export(module.exports, "getFilenameToDebugIdMap", function () { return $61ec67fa7dbdc20c$export$e069fee9c632ed00; });

var $e5cgV = parcelRequire("e5cgV");
let $61ec67fa7dbdc20c$var$parsedStackResults;
let $61ec67fa7dbdc20c$var$lastKeysCount;
let $61ec67fa7dbdc20c$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $61ec67fa7dbdc20c$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $e5cgV.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($61ec67fa7dbdc20c$var$cachedFilenameDebugIds && debugIdKeys.length === $61ec67fa7dbdc20c$var$lastKeysCount) return $61ec67fa7dbdc20c$var$cachedFilenameDebugIds;
    $61ec67fa7dbdc20c$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $61ec67fa7dbdc20c$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$61ec67fa7dbdc20c$var$parsedStackResults) $61ec67fa7dbdc20c$var$parsedStackResults = {};
        const result = $61ec67fa7dbdc20c$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $61ec67fa7dbdc20c$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $61ec67fa7dbdc20c$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $61ec67fa7dbdc20c$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $61ec67fa7dbdc20c$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}

});

parcelRegister("5k1Xv", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $3e0056fa64456ee2$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $3e0056fa64456ee2$export$23fbbb20bed71033; });

var $3TywK = parcelRequire("3TywK");

var $7WT4q = parcelRequire("7WT4q");

var $iqbKv = parcelRequire("iqbKv");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3e0056fa64456ee2$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $3e0056fa64456ee2$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $3e0056fa64456ee2$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $3e0056fa64456ee2$export$a3295358bff77e(object, depth);
    if ($3e0056fa64456ee2$var$jsonSize(normalized) > maxSize) return $3e0056fa64456ee2$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $3e0056fa64456ee2$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $3e0056fa64456ee2$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $3e0056fa64456ee2$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $3e0056fa64456ee2$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $7WT4q.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $3e0056fa64456ee2$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $3e0056fa64456ee2$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $3TywK.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $3TywK.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $iqbKv.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $3e0056fa64456ee2$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $3e0056fa64456ee2$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $3e0056fa64456ee2$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3e0056fa64456ee2$var$jsonSize(value) {
    return $3e0056fa64456ee2$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $3e0056fa64456ee2$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $3e0056fa64456ee2$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});
parcelRegister("iqbKv", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_FUNCTION", function () { return $d693c4cf9f953038$export$27c7e15d453fc0ac; });
$parcel$export(module.exports, "createStackParser", function () { return $d693c4cf9f953038$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $d693c4cf9f953038$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $d693c4cf9f953038$export$aad197c7121a6651; });
$parcel$export(module.exports, "getFramesFromEvent", function () { return $d693c4cf9f953038$export$91d8ca51bd9f6a47; });
const $d693c4cf9f953038$var$STACKTRACE_FRAME_LIMIT = 50;
const $d693c4cf9f953038$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $d693c4cf9f953038$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $d693c4cf9f953038$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $d693c4cf9f953038$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $d693c4cf9f953038$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($d693c4cf9f953038$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $d693c4cf9f953038$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $d693c4cf9f953038$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $d693c4cf9f953038$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $d693c4cf9f953038$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $d693c4cf9f953038$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($d693c4cf9f953038$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($d693c4cf9f953038$var$STRIP_FRAME_REGEXP.test($d693c4cf9f953038$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($d693c4cf9f953038$var$STRIP_FRAME_REGEXP.test($d693c4cf9f953038$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $d693c4cf9f953038$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $d693c4cf9f953038$var$getLastStackFrame(localStack).filename,
            function: frame.function || $d693c4cf9f953038$export$27c7e15d453fc0ac
        }));
}
function $d693c4cf9f953038$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $d693c4cf9f953038$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $d693c4cf9f953038$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $d693c4cf9f953038$var$defaultFunctionName;
        return fn.name || $d693c4cf9f953038$var$defaultFunctionName;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $d693c4cf9f953038$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $d693c4cf9f953038$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return undefined;
        }
    }
    return undefined;
}

});




parcelRegister("flsBa", function(module, exports) {

$parcel$export(module.exports, "captureReactException", function () { return $b2bf00383d1efd84$export$270be4195468cda9; });

var $g5j9r = parcelRequire("g5j9r");
var $bkLxn = parcelRequire("bkLxn");

var $3TywK = parcelRequire("3TywK");

var $dNMDr = parcelRequire("dNMDr");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $b2bf00383d1efd84$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $b2bf00383d1efd84$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $b2bf00383d1efd84$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($b2bf00383d1efd84$export$a87138b73900f5b((0, $dNMDr.version)) && (0, $3TywK.isError)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $b2bf00383d1efd84$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $bkLxn.withScope)((scope)=>{
        scope.setContext('react', {
            componentStack: componentStack
        });
        return (0, $g5j9r.captureException)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $b2bf00383d1efd84$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $b2bf00383d1efd84$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}

});

parcelRegister("dFb2H", function(module, exports) {

$parcel$export(module.exports, "extraErrorDataIntegration", function () { return $9f27ab8869ece19f$export$6e0872131894301d; });

var $eAxGy = parcelRequire("eAxGy");

var $12L9I = parcelRequire("12L9I");

var $lEIJP = parcelRequire("lEIJP");

var $3TywK = parcelRequire("3TywK");

var $5k1Xv = parcelRequire("5k1Xv");

var $7WT4q = parcelRequire("7WT4q");

var $ew86D = parcelRequire("ew86D");
const $9f27ab8869ece19f$var$INTEGRATION_NAME = 'ExtraErrorData';
/**
 * Extract additional data for from original exceptions.
 */ const $9f27ab8869ece19f$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $9f27ab8869ece19f$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength = 250 } = client.getOptions();
            return $9f27ab8869ece19f$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $9f27ab8869ece19f$export$6e0872131894301d = (0, $12L9I.defineIntegration)($9f27ab8869ece19f$var$_extraErrorDataIntegration);
function $9f27ab8869ece19f$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !(0, $3TywK.isError)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $9f27ab8869ece19f$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, $5k1Xv.normalize)(errorData, depth);
        if ((0, $3TywK.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $7WT4q.addNonEnumerableProperty)(normalizedErrorData, '__sentry_skip_normalization__', true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $9f27ab8869ece19f$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $3TywK.isError)(value) || typeof value === 'string' ? (0, $ew86D.truncate)(`${value}`, maxValueLength) : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, $3TywK.isError)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $3TywK.isError)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}

});
parcelRegister("12L9I", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $0c2a8e7aa41303a8$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $0c2a8e7aa41303a8$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $0c2a8e7aa41303a8$export$e7390a03b70a6f2f; });
$parcel$export(module.exports, "afterSetupIntegrations", function () { return $0c2a8e7aa41303a8$export$35abcfd71227c6ca; });
$parcel$export(module.exports, "defineIntegration", function () { return $0c2a8e7aa41303a8$export$2323046b9414659f; });

var $bkLxn = parcelRequire("bkLxn");

var $eAxGy = parcelRequire("eAxGy");

var $lEIJP = parcelRequire("lEIJP");
const $0c2a8e7aa41303a8$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $0c2a8e7aa41303a8$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $0c2a8e7aa41303a8$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $0c2a8e7aa41303a8$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $0c2a8e7aa41303a8$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $0c2a8e7aa41303a8$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $0c2a8e7aa41303a8$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $0c2a8e7aa41303a8$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($0c2a8e7aa41303a8$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $0c2a8e7aa41303a8$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $0c2a8e7aa41303a8$export$2d8f5188773bcddd(integration) {
    const client = (0, $bkLxn.getClient)();
    if (!client) {
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $0c2a8e7aa41303a8$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRegister("5S891", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $446850399d235946$export$2cd8252107eb640b; });

var $iCb37 = parcelRequire("iCb37");
var $g5j9r = parcelRequire("g5j9r");

var $33wEm = parcelRequire("33wEm");

var $dNMDr = parcelRequire("dNMDr");
/**
 * Inits the React SDK
 */ function $446850399d235946$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $33wEm.applySdkMetadata)(opts, 'react');
    (0, $g5j9r.setContext)('react', {
        version: $dNMDr.version
    });
    return (0, $iCb37.init)(opts);
}

});
parcelRegister("iCb37", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $d8d458bd8aa19a87$export$2cd8252107eb640b; });

var $iOXP6 = parcelRequire("iOXP6");
var $7OYq2 = parcelRequire("7OYq2");
var $12L9I = parcelRequire("12L9I");
var $kAPB1 = parcelRequire("kAPB1");
var $fSg7F = parcelRequire("fSg7F");
var $iqbKv = parcelRequire("iqbKv");

var $44Axp = parcelRequire("44Axp");

var $cRHaM = parcelRequire("cRHaM");

var $j9DiD = parcelRequire("j9DiD");

var $1QkPc = parcelRequire("1QkPc");

var $5zKjx = parcelRequire("5zKjx");

var $l8IWF = parcelRequire("l8IWF");

var $jlfRh = parcelRequire("jlfRh");

var $7x6G7 = parcelRequire("7x6G7");

var $5QgHo = parcelRequire("5QgHo");

var $7NwmU = parcelRequire("7NwmU");
/** Get the default integrations for the browser SDK. */ function $d8d458bd8aa19a87$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $kAPB1.inboundFiltersIntegration)(),
        (0, $7OYq2.functionToStringIntegration)(),
        (0, $j9DiD.browserApiErrorsIntegration)(),
        (0, $cRHaM.breadcrumbsIntegration)(),
        (0, $5zKjx.globalHandlersIntegration)(),
        (0, $jlfRh.linkedErrorsIntegration)(),
        (0, $iOXP6.dedupeIntegration)(),
        (0, $l8IWF.httpContextIntegration)(),
        (0, $1QkPc.browserSessionIntegration)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $d8d458bd8aa19a87$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $7NwmU.checkAndWarnIfIsEmbeddedBrowserExtension)();
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $iqbKv.stackParserFromStackParserOptions)(options.stackParser || (0, $7x6G7.defaultStackParser)),
        integrations: (0, $12L9I.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: options.defaultIntegrations == null ? $d8d458bd8aa19a87$export$5783b2920b1d62b9() : options.defaultIntegrations
        }),
        transport: options.transport || (0, $5QgHo.makeFetchTransport)
    };
    return (0, $fSg7F.initAndBind)((0, $44Axp.BrowserClient), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $d8d458bd8aa19a87$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $d8d458bd8aa19a87$export$4e4d8b287d028b6b(callback) {
    callback();
}

});
parcelRegister("iOXP6", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", function () { return $db3b4d289d85672c$export$6d39aa44cd0c7567; });

var $eAxGy = parcelRequire("eAxGy");

var $12L9I = parcelRequire("12L9I");

var $lEIJP = parcelRequire("lEIJP");

var $iqbKv = parcelRequire("iqbKv");
const $db3b4d289d85672c$var$INTEGRATION_NAME = 'Dedupe';
const $db3b4d289d85672c$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $db3b4d289d85672c$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($db3b4d289d85672c$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch  {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $db3b4d289d85672c$export$6d39aa44cd0c7567 = (0, $12L9I.defineIntegration)($db3b4d289d85672c$var$_dedupeIntegration);
/** only exported for tests. */ function $db3b4d289d85672c$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($db3b4d289d85672c$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($db3b4d289d85672c$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $db3b4d289d85672c$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$db3b4d289d85672c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$db3b4d289d85672c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $db3b4d289d85672c$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $db3b4d289d85672c$var$_getExceptionFromEvent(previousEvent);
    const currentException = $db3b4d289d85672c$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$db3b4d289d85672c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$db3b4d289d85672c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $db3b4d289d85672c$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $iqbKv.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $iqbKv.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $db3b4d289d85672c$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch  {
        return false;
    }
}
function $db3b4d289d85672c$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}

});

parcelRegister("7OYq2", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", function () { return $5b1c11d7be4d0c1f$export$7918117e9202e4fb; });

var $bkLxn = parcelRequire("bkLxn");

var $12L9I = parcelRequire("12L9I");

var $7WT4q = parcelRequire("7WT4q");
let $5b1c11d7be4d0c1f$var$originalFunctionToString;
const $5b1c11d7be4d0c1f$var$INTEGRATION_NAME = 'FunctionToString';
const $5b1c11d7be4d0c1f$var$SETUP_CLIENTS = new WeakMap();
const $5b1c11d7be4d0c1f$var$_functionToStringIntegration = ()=>{
    return {
        name: $5b1c11d7be4d0c1f$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $5b1c11d7be4d0c1f$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $7WT4q.getOriginalFunction)(this);
                    const context = $5b1c11d7be4d0c1f$var$SETUP_CLIENTS.has((0, $bkLxn.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $5b1c11d7be4d0c1f$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $5b1c11d7be4d0c1f$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $5b1c11d7be4d0c1f$export$7918117e9202e4fb = (0, $12L9I.defineIntegration)($5b1c11d7be4d0c1f$var$_functionToStringIntegration);

});

parcelRegister("kAPB1", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", function () { return $efdf3157a91525a6$export$cb3c5c2ceb9818ba; });

var $eAxGy = parcelRequire("eAxGy");

var $12L9I = parcelRequire("12L9I");

var $lEIJP = parcelRequire("lEIJP");

var $1lHwO = parcelRequire("1lHwO");

var $75eh7 = parcelRequire("75eh7");

var $ew86D = parcelRequire("ew86D");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $efdf3157a91525a6$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $efdf3157a91525a6$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $efdf3157a91525a6$export$9a84f518c163c552 = (0, $12L9I.defineIntegration)((options = {})=>{
    let mergedOptions;
    return {
        name: $efdf3157a91525a6$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $efdf3157a91525a6$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $efdf3157a91525a6$var$_mergeOptions(options, clientOptions);
            }
            return $efdf3157a91525a6$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $efdf3157a91525a6$export$cb3c5c2ceb9818ba = (0, $12L9I.defineIntegration)((options = {})=>{
    return {
        ...$efdf3157a91525a6$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $efdf3157a91525a6$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $efdf3157a91525a6$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $efdf3157a91525a6$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($efdf3157a91525a6$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $75eh7.getEventDescription)(event)}`);
            return true;
        }
        if ($efdf3157a91525a6$var$_isUselessError(event)) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $75eh7.getEventDescription)(event)}`);
            return true;
        }
        if ($efdf3157a91525a6$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $75eh7.getEventDescription)(event)}.\nUrl: ${$efdf3157a91525a6$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$efdf3157a91525a6$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $75eh7.getEventDescription)(event)}.\nUrl: ${$efdf3157a91525a6$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($efdf3157a91525a6$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $75eh7.getEventDescription)(event)}`);
            return true;
        }
    }
    return false;
}
function $efdf3157a91525a6$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $1lHwO.getPossibleEventMessages)(event).some((message)=>(0, $ew86D.stringMatchesSomePattern)(message, ignoreErrors));
}
function $efdf3157a91525a6$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $ew86D.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $efdf3157a91525a6$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $efdf3157a91525a6$var$_getEventFilterUrl(event);
    return !url ? false : (0, $ew86D.stringMatchesSomePattern)(url, denyUrls);
}
function $efdf3157a91525a6$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $efdf3157a91525a6$var$_getEventFilterUrl(event);
    return !url ? true : (0, $ew86D.stringMatchesSomePattern)(url, allowUrls);
}
function $efdf3157a91525a6$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $efdf3157a91525a6$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $efdf3157a91525a6$var$_getLastValidUrl(frames) : null;
    } catch  {
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).error(`Cannot extract url for event ${(0, $75eh7.getEventDescription)(event)}`);
        return null;
    }
}
function $efdf3157a91525a6$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}

});
parcelRegister("1lHwO", function(module, exports) {

$parcel$export(module.exports, "getPossibleEventMessages", function () { return $0fb9846e953e1811$export$d55a97c329cacfcc; });
/**
 * Get a list of possible event messages from a Sentry event.
 */ function $0fb9846e953e1811$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {
    // ignore errors here
    }
    return possibleMessages;
}

});


parcelRegister("fSg7F", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $b8e867c5664e224e$export$5333c3f1c58d9bc1; });

var $bkLxn = parcelRequire("bkLxn");

var $eAxGy = parcelRequire("eAxGy");

var $lEIJP = parcelRequire("lEIJP");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $b8e867c5664e224e$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $eAxGy.DEBUG_BUILD) (0, $lEIJP.debug).enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        (0, $lEIJP.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $bkLxn.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $b8e867c5664e224e$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $b8e867c5664e224e$export$ecb76f41d43c0e43(client) {
    (0, $bkLxn.getCurrentScope)().setClient(client);
}

});

parcelRegister("44Axp", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $2f73e0ce9b9e0be1$export$1df9218a526d318d; });

var $d2RDP = parcelRequire("d2RDP");
var $cfqN7 = parcelRequire("cfqN7");
var $33wEm = parcelRequire("33wEm");
var $9JNZx = parcelRequire("9JNZx");
var $h6c6a = parcelRequire("h6c6a");

var $hCF4L = parcelRequire("hCF4L");

var $4p9Jt = parcelRequire("4p9Jt");
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ const $2f73e0ce9b9e0be1$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $2f73e0ce9b9e0be1$export$1df9218a526d318d extends (0, $9JNZx.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $2f73e0ce9b9e0be1$export$4e107b20a7f977(options);
        const sdkSource = (0, $4p9Jt.WINDOW).SENTRY_SDK_SOURCE || (0, $h6c6a.getSDKSource)();
        (0, $33wEm.applySdkMetadata)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments } = this._options;
        // eslint-disable-next-line deprecation/deprecation
        const shouldEnableLogs = enableLogs ?? _experiments?.enableLogs;
        if ((0, $4p9Jt.WINDOW).document && (sendClientReports || shouldEnableLogs)) (0, $4p9Jt.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $4p9Jt.WINDOW).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (shouldEnableLogs) (0, $d2RDP._INTERNAL_flushLogsBuffer)(this);
            }
        });
        if (shouldEnableLogs) {
            this.on('flush', ()=>{
                (0, $d2RDP._INTERNAL_flushLogsBuffer)(this);
            });
            this.on('afterCaptureLog', ()=>{
                if (this._logFlushIdleTimeout) clearTimeout(this._logFlushIdleTimeout);
                this._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $d2RDP._INTERNAL_flushLogsBuffer)(this);
                }, $2f73e0ce9b9e0be1$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            this.on('postprocessEvent', (0, $cfqN7.addAutoIpAddressToUser));
            this.on('beforeSendSession', (0, $cfqN7.addAutoIpAddressToSession));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $hCF4L.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $hCF4L.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $2f73e0ce9b9e0be1$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $4p9Jt.WINDOW).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}

});
parcelRegister("d2RDP", function(module, exports) {

$parcel$export(module.exports, "_INTERNAL_flushLogsBuffer", function () { return $97f51259d9be1f0f$export$f8ed83d3b6a0b504; });

var $cKggp = parcelRequire("cKggp");

var $9JNZx = parcelRequire("9JNZx");

var $bkLxn = parcelRequire("bkLxn");

var $eAxGy = parcelRequire("eAxGy");

var $j7PfY = parcelRequire("j7PfY");

var $lEIJP = parcelRequire("lEIJP");

var $3TywK = parcelRequire("3TywK");

var $3VljW = parcelRequire("3VljW");

var $aGoK9 = parcelRequire("aGoK9");

var $ZGlZU = parcelRequire("ZGlZU");

var $jFg1D = parcelRequire("jFg1D");
const $97f51259d9be1f0f$var$MAX_LOG_BUFFER_SIZE = 100;
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $97f51259d9be1f0f$export$84cb46f4adfc5d14(value) {
    switch(typeof value){
        case 'number':
            if (Number.isInteger(value)) return {
                value: value,
                type: 'integer'
            };
            return {
                value: value,
                type: 'double'
            };
        case 'boolean':
            return {
                value: value,
                type: 'boolean'
            };
        case 'string':
            return {
                value: value,
                type: 'string'
            };
        default:
            {
                let stringValue = '';
                try {
                    stringValue = JSON.stringify(value) ?? '';
                } catch  {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: 'string'
                };
            }
    }
}
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $97f51259d9be1f0f$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $97f51259d9be1f0f$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $97f51259d9be1f0f$var$_getBufferMap();
    const logBuffer = $97f51259d9be1f0f$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $97f51259d9be1f0f$var$MAX_LOG_BUFFER_SIZE) {
        $97f51259d9be1f0f$export$f8ed83d3b6a0b504(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $97f51259d9be1f0f$export$3ab3d16b9eebd986(beforeLog, client = (0, $bkLxn.getClient)(), currentScope = (0, $bkLxn.getCurrentScope)(), captureSerializedLog = $97f51259d9be1f0f$export$743ba6f7ec19225f) {
    if (!client) {
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('No client available to capture log.');
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs, beforeSendLog: beforeSendLog, _experiments: _experiments } = client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    const shouldEnableLogs = enableLogs ?? _experiments?.enableLogs;
    if (!shouldEnableLogs) {
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('logging option not enabled, log will not be captured.');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const actualBeforeSendLog = beforeSendLog ?? _experiments?.beforeSendLog;
    const [, traceContext] = (0, $9JNZx._getTraceInfoFromScope)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username } } = $97f51259d9be1f0f$var$getMergedScopeData(currentScope);
    $97f51259d9be1f0f$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
    $97f51259d9be1f0f$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
    $97f51259d9be1f0f$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    $97f51259d9be1f0f$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $97f51259d9be1f0f$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $97f51259d9be1f0f$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $97f51259d9be1f0f$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const beforeLogMessage = beforeLog.message;
    if ((0, $3TywK.isParameterizedString)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $3VljW._getSpanForScope)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $97f51259d9be1f0f$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = actualBeforeSendLog ? (0, $lEIJP.consoleSandbox)(()=>actualBeforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        timestamp: (0, $aGoK9.timestampInSeconds)(),
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $ZGlZU.SEVERITY_TEXT_TO_SEVERITY_NUMBER)[level],
        attributes: Object.keys(attributes).reduce((acc, key)=>{
            acc[key] = $97f51259d9be1f0f$export$84cb46f4adfc5d14(attributes[key]);
            return acc;
        }, {})
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $97f51259d9be1f0f$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $97f51259d9be1f0f$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $jFg1D.createLogEnvelope)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    $97f51259d9be1f0f$var$_getBufferMap().set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $97f51259d9be1f0f$export$5365c9902fb9e770(client) {
    return $97f51259d9be1f0f$var$_getBufferMap().get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $97f51259d9be1f0f$var$getMergedScopeData(currentScope) {
    const scopeData = (0, $bkLxn.getGlobalScope)().getScopeData();
    (0, $j7PfY.mergeScopeData)(scopeData, (0, $bkLxn.getIsolationScope)().getScopeData());
    (0, $j7PfY.mergeScopeData)(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $97f51259d9be1f0f$var$_getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return (0, $cKggp.getGlobalSingleton)('clientToLogBufferMap', ()=>new WeakMap());
}

});
parcelRegister("9JNZx", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $716f18540e0f69ce$export$1f2bb630327ac4b6; });
$parcel$export(module.exports, "_getTraceInfoFromScope", function () { return $716f18540e0f69ce$export$fb7d833b3fdedf5f; });

var $fKoWM = parcelRequire("fKoWM");

var $eKyOP = parcelRequire("eKyOP");

var $bkLxn = parcelRequire("bkLxn");

var $eAxGy = parcelRequire("eAxGy");

var $gKibx = parcelRequire("gKibx");

var $12L9I = parcelRequire("12L9I");

var $jo5k0 = parcelRequire("jo5k0");

var $6eH4L = parcelRequire("6eH4L");

var $40s5Z = parcelRequire("40s5Z");

var $lEIJP = parcelRequire("lEIJP");

var $lxbnR = parcelRequire("lxbnR");

var $fnDBy = parcelRequire("fnDBy");

var $1lHwO = parcelRequire("1lHwO");

var $3TywK = parcelRequire("3TywK");

var $dOEnU = parcelRequire("dOEnU");

var $75eh7 = parcelRequire("75eh7");

var $g8XY1 = parcelRequire("g8XY1");

var $in9oF = parcelRequire("in9oF");

var $iSrLD = parcelRequire("iSrLD");

var $2C0zV = parcelRequire("2C0zV");

var $g2Ooa = parcelRequire("g2Ooa");
/* eslint-disable max-lines */ const $716f18540e0f69ce$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $716f18540e0f69ce$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $716f18540e0f69ce$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $716f18540e0f69ce$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $716f18540e0f69ce$var$_makeInternalError(message) {
    return {
        message: message,
        [$716f18540e0f69ce$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $716f18540e0f69ce$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$716f18540e0f69ce$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $716f18540e0f69ce$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $716f18540e0f69ce$var$INTERNAL_ERROR_SYMBOL in error;
}
function $716f18540e0f69ce$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $716f18540e0f69ce$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $716f18540e0f69ce$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $lxbnR.makeDsn)(options.dsn);
        else (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $fKoWM.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $75eh7.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $75eh7.checkOrSetAlreadyCaught)(exception)) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).log($716f18540e0f69ce$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $75eh7.uuid4)(),
            ...hint
        };
        const eventMessage = (0, $3TywK.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $3TywK.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $75eh7.uuid4)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $75eh7.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).log($716f18540e0f69ce$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $jo5k0.updateSession)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $2C0zV.resolvedSyncPromise)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $12L9I.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $12L9I.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $gKibx.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $fnDBy.addItemToEnvelope)(env, (0, $fnDBy.createAttachmentEnvelopeItem)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $eKyOP.DEFAULT_ENVIRONMENT) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn($716f18540e0f69ce$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn($716f18540e0f69ce$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $gKibx.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).error('Transport disabled');
        return (0, $2C0zV.resolvedSyncPromise)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $12L9I.setupIntegrations)(this, integrations);
        (0, $12L9I.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $jo5k0.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $2C0zV.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $in9oF.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: (0, $bkLxn.getTraceContextFromScope)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $6eH4L.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $bkLxn.getCurrentScope)(), isolationScope = (0, $bkLxn.getIsolationScope)()) {
        if ((0, $eAxGy.DEBUG_BUILD) && $716f18540e0f69ce$var$isErrorEvent(event)) (0, $lEIJP.debug).log(`Captured error event \`${(0, $1lHwO.getPossibleEventMessages)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $eAxGy.DEBUG_BUILD) {
                if ($716f18540e0f69ce$var$_isDoNotSendEventError(reason)) (0, $lEIJP.debug).log(reason.message);
                else if ($716f18540e0f69ce$var$_isInternalError(reason)) (0, $lEIJP.debug).warn(reason.message);
                else (0, $lEIJP.debug).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $716f18540e0f69ce$var$isTransactionEvent(event);
        const isError = $716f18540e0f69ce$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $g8XY1.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $2C0zV.rejectedSyncPromise)($716f18540e0f69ce$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $716f18540e0f69ce$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $716f18540e0f69ce$var$processBeforeSend(this, options, prepared, hint);
            return $716f18540e0f69ce$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $716f18540e0f69ce$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($716f18540e0f69ce$var$_isDoNotSendEventError(reason) || $716f18540e0f69ce$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $716f18540e0f69ce$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).log('Sending outcomes:', outcomes);
        const envelope = (0, $40s5Z.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $lxbnR.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $716f18540e0f69ce$export$4f22f74eddb7716a = $716f18540e0f69ce$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $716f18540e0f69ce$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $3TywK.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $3TywK.isPlainObject)(event) && event !== null) throw $716f18540e0f69ce$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $716f18540e0f69ce$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $3TywK.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw $716f18540e0f69ce$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $716f18540e0f69ce$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($716f18540e0f69ce$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($716f18540e0f69ce$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $g2Ooa.convertTransactionEventToSpanJson)(processedEvent));
            if (!processedRootSpanJson) (0, $iSrLD.showSpanDropWarning)();
            else // update event with processed root span values
            processedEvent = (0, $dOEnU.merge)(event, (0, $g2Ooa.convertSpanJsonToTransactionEvent)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $iSrLD.showSpanDropWarning)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $716f18540e0f69ce$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $716f18540e0f69ce$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $716f18540e0f69ce$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $bkLxn.withScope)(scope, ()=>{
        const span = (0, $iSrLD.getActiveSpan)();
        const traceContext = span ? (0, $iSrLD.spanToTraceContext)(span) : (0, $bkLxn.getTraceContextFromScope)(scope);
        const dynamicSamplingContext = span ? (0, $6eH4L.getDynamicSamplingContextFromSpan)(span) : (0, $6eH4L.getDynamicSamplingContextFromScope)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}

});
parcelRegister("fKoWM", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $b76e80d70605d582$export$9964600bfe84e6a3; });

var $lxbnR = parcelRequire("lxbnR");
const $b76e80d70605d582$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $b76e80d70605d582$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $b76e80d70605d582$var$_getIngestEndpoint(dsn) {
    return `${$b76e80d70605d582$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $b76e80d70605d582$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $b76e80d70605d582$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $b76e80d70605d582$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$b76e80d70605d582$var$_getIngestEndpoint(dsn)}?${$b76e80d70605d582$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $b76e80d70605d582$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $lxbnR.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$b76e80d70605d582$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $lxbnR.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});

parcelRegister("gKibx", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $c30f0c68b3e21ed9$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $c30f0c68b3e21ed9$export$c31057337a18010f; });

var $6eH4L = parcelRequire("6eH4L");

var $lxbnR = parcelRequire("lxbnR");

var $fnDBy = parcelRequire("fnDBy");

var $iSrLD = parcelRequire("iSrLD");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $c30f0c68b3e21ed9$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $c30f0c68b3e21ed9$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $fnDBy.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $lxbnR.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $fnDBy.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $c30f0c68b3e21ed9$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $fnDBy.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $c30f0c68b3e21ed9$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $fnDBy.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $fnDBy.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $c30f0c68b3e21ed9$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $6eH4L.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $lxbnR.dsnToString)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $iSrLD.spanToJSON)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $iSrLD.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $iSrLD.spanToJSON);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $fnDBy.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $fnDBy.createEnvelope)(headers, items);
}

});
parcelRegister("fnDBy", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $b327b9acaea0aa8e$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $b327b9acaea0aa8e$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $b327b9acaea0aa8e$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $b327b9acaea0aa8e$export$32f9b428425aac85; });
$parcel$export(module.exports, "createSpanEnvelopeItem", function () { return $b327b9acaea0aa8e$export$655cf139bc8b8afd; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $b327b9acaea0aa8e$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $b327b9acaea0aa8e$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $b327b9acaea0aa8e$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $b327b9acaea0aa8e$export$92b6093782fe661b; });

var $cKggp = parcelRequire("cKggp");

var $lxbnR = parcelRequire("lxbnR");

var $5k1Xv = parcelRequire("5k1Xv");

var $e5cgV = parcelRequire("e5cgV");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $b327b9acaea0aa8e$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $b327b9acaea0aa8e$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $b327b9acaea0aa8e$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $b327b9acaea0aa8e$export$604a45d95a155e2b(envelope, types) {
    return $b327b9acaea0aa8e$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $b327b9acaea0aa8e$var$encodeUTF8(input) {
    const carrier = (0, $cKggp.getSentryCarrier)((0, $e5cgV.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $b327b9acaea0aa8e$var$decodeUTF8(input) {
    const carrier = (0, $cKggp.getSentryCarrier)((0, $e5cgV.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $b327b9acaea0aa8e$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $b327b9acaea0aa8e$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $b327b9acaea0aa8e$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $5k1Xv.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $b327b9acaea0aa8e$var$concatBuffers(parts);
}
function $b327b9acaea0aa8e$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $b327b9acaea0aa8e$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $b327b9acaea0aa8e$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($b327b9acaea0aa8e$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $b327b9acaea0aa8e$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $b327b9acaea0aa8e$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $b327b9acaea0aa8e$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $b327b9acaea0aa8e$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $b327b9acaea0aa8e$export$b11169581eeaf237(type) {
    return $b327b9acaea0aa8e$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $b327b9acaea0aa8e$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $b327b9acaea0aa8e$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $lxbnR.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}

});


parcelRegister("40s5Z", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $2eacf4b7e86b2ae3$export$f3b9ed77c03eeb00; });

var $fnDBy = parcelRequire("fnDBy");

var $aGoK9 = parcelRequire("aGoK9");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $2eacf4b7e86b2ae3$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $aGoK9.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $fnDBy.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("g2Ooa", function(module, exports) {

$parcel$export(module.exports, "convertTransactionEventToSpanJson", function () { return $bae3eb664046143c$export$d9c6b2464b0a687e; });
$parcel$export(module.exports, "convertSpanJsonToTransactionEvent", function () { return $bae3eb664046143c$export$f2d8fce5ae150e92; });

var $ktN3S = parcelRequire("ktN3S");
/**
 * Converts a transaction event to a span JSON object.
 */ function $bae3eb664046143c$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $ktN3S.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[0, $ktN3S.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $bae3eb664046143c$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $ktN3S.SEMANTIC_ATTRIBUTE_PROFILE_ID)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $ktN3S.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}

});


parcelRegister("ZGlZU", function(module, exports) {

$parcel$export(module.exports, "SEVERITY_TEXT_TO_SEVERITY_NUMBER", function () { return $0b968d33c0000a83$export$4fb50c0840d636d1; });
/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $0b968d33c0000a83$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};

});

parcelRegister("jFg1D", function(module, exports) {

$parcel$export(module.exports, "createLogEnvelope", function () { return $e50e46f99af69ebe$export$cdcd668e6516443f; });

var $lxbnR = parcelRequire("lxbnR");

var $fnDBy = parcelRequire("fnDBy");
/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $e50e46f99af69ebe$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $e50e46f99af69ebe$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $lxbnR.dsnToString)(dsn);
    return (0, $fnDBy.createEnvelope)(headers, [
        $e50e46f99af69ebe$export$efdf3b13edb1118e(logs)
    ]);
}

});


parcelRegister("cfqN7", function(module, exports) {

$parcel$export(module.exports, "addAutoIpAddressToUser", function () { return $8eabaaef16bb1cbb$export$3e12ad68afa434ac; });
$parcel$export(module.exports, "addAutoIpAddressToSession", function () { return $8eabaaef16bb1cbb$export$e8e2d07ba63e2b6c; });
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $8eabaaef16bb1cbb$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $8eabaaef16bb1cbb$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}

});

parcelRegister("33wEm", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", function () { return $239afa820510b67e$export$b9f95b027256052c; });

var $9QvbA = parcelRequire("9QvbA");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $239afa820510b67e$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $9QvbA.SDK_VERSION)
            })),
        version: (0, $9QvbA.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("h6c6a", function(module, exports) {

$parcel$export(module.exports, "getSDKSource", function () { return $c72c61b20a1cb9a9$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $c72c61b20a1cb9a9$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $c72c61b20a1cb9a9$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

});

parcelRegister("hCF4L", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $cd45d912b264e61b$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $cd45d912b264e61b$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $cd45d912b264e61b$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $cd45d912b264e61b$export$5425b53185d13d6c; });

var $75eh7 = parcelRequire("75eh7");
var $7WT4q = parcelRequire("7WT4q");
var $bkLxn = parcelRequire("bkLxn");
var $3TywK = parcelRequire("3TywK");
var $5k1Xv = parcelRequire("5k1Xv");
var $2C0zV = parcelRequire("2C0zV");
/**
 * This function creates an exception from a JavaScript Error
 */ function $cd45d912b264e61b$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $cd45d912b264e61b$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $cd45d912b264e61b$export$2e9ae379995d99e3(ex),
        value: $cd45d912b264e61b$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $cd45d912b264e61b$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $bkLxn.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $cd45d912b264e61b$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $5k1Xv.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $cd45d912b264e61b$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $3TywK.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $cd45d912b264e61b$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $cd45d912b264e61b$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $cd45d912b264e61b$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $cd45d912b264e61b$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $cd45d912b264e61b$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $cd45d912b264e61b$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $cd45d912b264e61b$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $cd45d912b264e61b$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $cd45d912b264e61b$var$getSkipFirstStackStringLines(ex) {
    if (ex && $cd45d912b264e61b$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $cd45d912b264e61b$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $cd45d912b264e61b$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $cd45d912b264e61b$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $cd45d912b264e61b$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $cd45d912b264e61b$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($cd45d912b264e61b$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $cd45d912b264e61b$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $cd45d912b264e61b$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $75eh7.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $2C0zV.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $cd45d912b264e61b$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $cd45d912b264e61b$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $2C0zV.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $cd45d912b264e61b$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $3TywK.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $cd45d912b264e61b$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $3TywK.isDOMError)(exception) || (0, $3TywK.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $cd45d912b264e61b$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $3TywK.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $cd45d912b264e61b$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $75eh7.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $3TywK.isError)(exception)) // we have a real Error object, do nothing
    return $cd45d912b264e61b$var$eventFromError(stackParser, exception);
    if ((0, $3TywK.isPlainObject)(exception) || (0, $3TywK.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $cd45d912b264e61b$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $75eh7.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $cd45d912b264e61b$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $75eh7.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $75eh7.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $cd45d912b264e61b$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $cd45d912b264e61b$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $75eh7.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $3TywK.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $cd45d912b264e61b$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $7WT4q.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $3TywK.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $3TywK.isEvent)(exception)) {
        const className = $cd45d912b264e61b$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $cd45d912b264e61b$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $cd45d912b264e61b$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}

});

parcelRegister("4p9Jt", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $33510be47cf248a1$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $33510be47cf248a1$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $33510be47cf248a1$export$4997ffc0176396a6; });
$parcel$export(module.exports, "getHttpRequestData", function () { return $33510be47cf248a1$export$a3c4a8453e8936f0; });

var $75eh7 = parcelRequire("75eh7");
var $7WT4q = parcelRequire("7WT4q");
var $g5j9r = parcelRequire("g5j9r");
var $dOTpB = parcelRequire("dOTpB");
var $e5cgV = parcelRequire("e5cgV");
var $bkLxn = parcelRequire("bkLxn");
const $33510be47cf248a1$export$56d8a8a25bd48b81 = (0, $e5cgV.GLOBAL_OBJ);
let $33510be47cf248a1$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $33510be47cf248a1$export$b79738ab10c590b2() {
    return $33510be47cf248a1$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $33510be47cf248a1$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $33510be47cf248a1$var$ignoreOnError++;
    setTimeout(()=>{
        $33510be47cf248a1$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $33510be47cf248a1$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $7WT4q.getOriginalFunction)(fn)) return fn;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$33510be47cf248a1$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $33510be47cf248a1$export$1265a142ff5ba165();
            (0, $bkLxn.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $75eh7.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $75eh7.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $g5j9r.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $7WT4q.markFunctionWrapped)(sentryWrapped, fn);
    (0, $7WT4q.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $33510be47cf248a1$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $dOTpB.getLocationHref)();
    const { referrer: referrer } = $33510be47cf248a1$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $33510be47cf248a1$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            'User-Agent': userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}

});


parcelRegister("cRHaM", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $95dbec81cf692b3c$export$c079d904b326663a; });

var $1cBgb = parcelRequire("1cBgb");
var $7Y1ay = parcelRequire("7Y1ay");
var $cQob3 = parcelRequire("cQob3");
var $lEIJP = parcelRequire("lEIJP");
var $12L9I = parcelRequire("12L9I");
var $5KLpb = parcelRequire("5KLpb");
var $bkLxn = parcelRequire("bkLxn");
var $dOTpB = parcelRequire("dOTpB");
var $75eh7 = parcelRequire("75eh7");
var $63xM0 = parcelRequire("63xM0");
var $ew86D = parcelRequire("ew86D");
var $4zF5t = parcelRequire("4zF5t");

var $2Bfqu = parcelRequire("2Bfqu");
var $2rlqn = parcelRequire("2rlqn");
var $4cZAn = parcelRequire("4cZAn");

var $cQXNX = parcelRequire("cQXNX");

var $4p9Jt = parcelRequire("4p9Jt");
/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $95dbec81cf692b3c$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $95dbec81cf692b3c$var$INTEGRATION_NAME = 'Breadcrumbs';
const $95dbec81cf692b3c$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $95dbec81cf692b3c$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $7Y1ay.addConsoleInstrumentationHandler)($95dbec81cf692b3c$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $2Bfqu.addClickKeypressInstrumentationHandler)($95dbec81cf692b3c$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $4cZAn.addXhrInstrumentationHandler)($95dbec81cf692b3c$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $cQob3.addFetchInstrumentationHandler)($95dbec81cf692b3c$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $2rlqn.addHistoryInstrumentationHandler)($95dbec81cf692b3c$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $95dbec81cf692b3c$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $95dbec81cf692b3c$export$c079d904b326663a = (0, $12L9I.defineIntegration)($95dbec81cf692b3c$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $95dbec81cf692b3c$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $bkLxn.getClient)() !== client) return;
        (0, $1cBgb.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $75eh7.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $95dbec81cf692b3c$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $bkLxn.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $95dbec81cf692b3c$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $cQXNX.DEBUG_BUILD) && (0, $lEIJP.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$95dbec81cf692b3c$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$95dbec81cf692b3c$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $95dbec81cf692b3c$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $95dbec81cf692b3c$var$_isEvent(event) ? event.target : event;
            target = (0, $dOTpB.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $dOTpB.getComponentName)(element);
        } catch  {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $1cBgb.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $95dbec81cf692b3c$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $bkLxn.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $4zF5t.severityLevelFromString)(handlerData.level),
            message: (0, $ew86D.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $ew86D.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $1cBgb.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $95dbec81cf692b3c$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $bkLxn.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $4cZAn.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $5KLpb.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $1cBgb.addBreadcrumb)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $95dbec81cf692b3c$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $bkLxn.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $1cBgb.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $5KLpb.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $1cBgb.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $95dbec81cf692b3c$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $bkLxn.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $63xM0.parseUrl)((0, $4p9Jt.WINDOW).location.href);
        let parsedFrom = from ? (0, $63xM0.parseUrl)(from) : undefined;
        const parsedTo = (0, $63xM0.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $1cBgb.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $95dbec81cf692b3c$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("7Y1ay", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", function () { return $5ccf0b2eb80f5c03$export$1d6e0d073f9e6723; });

var $lEIJP = parcelRequire("lEIJP");

var $7WT4q = parcelRequire("7WT4q");

var $e5cgV = parcelRequire("e5cgV");

var $1ypZO = parcelRequire("1ypZO");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5ccf0b2eb80f5c03$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $1ypZO.addHandler)(type, handler);
    (0, $1ypZO.maybeInstrument)(type, $5ccf0b2eb80f5c03$var$instrumentConsole);
}
function $5ccf0b2eb80f5c03$var$instrumentConsole() {
    if (!('console' in (0, $e5cgV.GLOBAL_OBJ))) return;
    (0, $lEIJP.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $e5cgV.GLOBAL_OBJ).console)) return;
        (0, $7WT4q.fill)((0, $e5cgV.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $lEIJP.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $1ypZO.triggerHandlers)('console', handlerData);
                const log = (0, $lEIJP.originalConsoleMethods)[level];
                log?.apply((0, $e5cgV.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});
parcelRegister("1ypZO", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $121d21ab05cb883d$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $121d21ab05cb883d$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $121d21ab05cb883d$export$b18c893e424d3127; });

var $eAxGy = parcelRequire("eAxGy");

var $lEIJP = parcelRequire("lEIJP");

var $iqbKv = parcelRequire("iqbKv");
// We keep the handlers globally
const $121d21ab05cb883d$var$handlers = {};
const $121d21ab05cb883d$var$instrumented = {};
/** Add a handler function. */ function $121d21ab05cb883d$export$a4e09611e30da72e(type, handler) {
    $121d21ab05cb883d$var$handlers[type] = $121d21ab05cb883d$var$handlers[type] || [];
    $121d21ab05cb883d$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $121d21ab05cb883d$export$b17eab759a1cb5fe() {
    Object.keys($121d21ab05cb883d$var$handlers).forEach((key)=>{
        $121d21ab05cb883d$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $121d21ab05cb883d$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$121d21ab05cb883d$var$instrumented[type]) {
        $121d21ab05cb883d$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $121d21ab05cb883d$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $121d21ab05cb883d$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $iqbKv.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("cQob3", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", function () { return $959d18780a966920$export$f75d3c772c923df0; });

var $3TywK = parcelRequire("3TywK");

var $7WT4q = parcelRequire("7WT4q");

var $gDmZ9 = parcelRequire("gDmZ9");

var $aGoK9 = parcelRequire("aGoK9");

var $e5cgV = parcelRequire("e5cgV");

var $1ypZO = parcelRequire("1ypZO");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $959d18780a966920$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $1ypZO.addHandler)(type, handler);
    (0, $1ypZO.maybeInstrument)(type, ()=>$959d18780a966920$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $959d18780a966920$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $1ypZO.addHandler)(type, handler);
    (0, $1ypZO.maybeInstrument)(type, ()=>$959d18780a966920$var$instrumentFetch($959d18780a966920$var$streamHandler));
}
function $959d18780a966920$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $gDmZ9.supportsNativeFetch)()) return;
    (0, $7WT4q.fill)((0, $e5cgV.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $959d18780a966920$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $aGoK9.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $959d18780a966920$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $1ypZO.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $e5cgV.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $1ypZO.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $aGoK9.timestampInSeconds)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $1ypZO.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $aGoK9.timestampInSeconds)() * 1000,
                    error: error
                });
                if ((0, $3TywK.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $7WT4q.addNonEnumerableProperty)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $959d18780a966920$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $959d18780a966920$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $959d18780a966920$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $1ypZO.triggerHandlers)('fetch-body-resolved', {
            endTimestamp: (0, $aGoK9.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $959d18780a966920$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $959d18780a966920$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($959d18780a966920$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $959d18780a966920$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $959d18780a966920$var$getUrlFromResource(url),
            method: $959d18780a966920$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $959d18780a966920$var$getUrlFromResource(arg),
        method: $959d18780a966920$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $959d18780a966920$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $3TywK.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

});
parcelRegister("gDmZ9", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $c1c21e47c6c8d212$export$67fc34576016d6ec; });
$parcel$export(module.exports, "isNativeFunction", function () { return $c1c21e47c6c8d212$export$d5f608b368e73f38; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $c1c21e47c6c8d212$export$c82d238e23c40b21; });

var $eAxGy = parcelRequire("eAxGy");

var $lEIJP = parcelRequire("lEIJP");

var $e5cgV = parcelRequire("e5cgV");
const $c1c21e47c6c8d212$var$WINDOW = (0, $e5cgV.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $c1c21e47c6c8d212$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $c1c21e47c6c8d212$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $c1c21e47c6c8d212$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $c1c21e47c6c8d212$export$67fc34576016d6ec() {
    return 'history' in $c1c21e47c6c8d212$var$WINDOW && !!$c1c21e47c6c8d212$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $c1c21e47c6c8d212$export$edf3cb81fd7d2a3e = $c1c21e47c6c8d212$var$_isFetchSupported;
function $c1c21e47c6c8d212$var$_isFetchSupported() {
    if (!('fetch' in $c1c21e47c6c8d212$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch  {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c1c21e47c6c8d212$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $c1c21e47c6c8d212$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$c1c21e47c6c8d212$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($c1c21e47c6c8d212$export$d5f608b368e73f38($c1c21e47c6c8d212$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $c1c21e47c6c8d212$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $c1c21e47c6c8d212$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $c1c21e47c6c8d212$export$531055a6c684a70a() {
    return 'ReportingObserver' in $c1c21e47c6c8d212$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $c1c21e47c6c8d212$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$c1c21e47c6c8d212$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch  {
        return false;
    }
}

});


parcelRegister("5KLpb", function(module, exports) {

$parcel$export(module.exports, "getBreadcrumbLogLevelFromHttpStatusCode", function () { return $43060549757d1e26$export$b8cfcc4175694bcc; });
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $43060549757d1e26$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

});

parcelRegister("63xM0", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $468d38959ebaf49f$export$7a5253c0f62e0150; });

var $ktN3S = parcelRequire("ktN3S");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $468d38959ebaf49f$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $468d38959ebaf49f$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $468d38959ebaf49f$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $468d38959ebaf49f$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $468d38959ebaf49f$export$5339fcdc8e2a427c(url) {
    if ($468d38959ebaf49f$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $468d38959ebaf49f$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $468d38959ebaf49f$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $468d38959ebaf49f$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $ktN3S.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, $ktN3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $ktN3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request?.method) attributes[0, $ktN3S.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $ktN3S.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!$468d38959ebaf49f$export$e258e13805402ba7(urlObject)) {
            attributes[0, $ktN3S.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $468d38959ebaf49f$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $468d38959ebaf49f$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $468d38959ebaf49f$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $468d38959ebaf49f$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("4zF5t", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", function () { return $354a4d6454639ae0$export$d771ef054122c30a; });
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $354a4d6454639ae0$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}

});

parcelRegister("2Bfqu", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $1e4b00d27ac7318f$export$5aeffd3db2cf9df7; });

var $1ypZO = parcelRequire("1ypZO");
var $7WT4q = parcelRequire("7WT4q");
var $75eh7 = parcelRequire("75eh7");

var $lSiV6 = parcelRequire("lSiV6");
const $1e4b00d27ac7318f$var$DEBOUNCE_DURATION = 1000;
let $1e4b00d27ac7318f$var$debounceTimerID;
let $1e4b00d27ac7318f$var$lastCapturedEventType;
let $1e4b00d27ac7318f$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $1e4b00d27ac7318f$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $1ypZO.addHandler)(type, handler);
    (0, $1ypZO.maybeInstrument)(type, $1e4b00d27ac7318f$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $1e4b00d27ac7318f$export$3014bbf0af0e1d4a() {
    if (!(0, $lSiV6.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $1ypZO.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $1e4b00d27ac7318f$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $lSiV6.WINDOW).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $lSiV6.WINDOW).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $lSiV6.WINDOW);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $7WT4q.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $1e4b00d27ac7318f$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $7WT4q.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $1e4b00d27ac7318f$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $1e4b00d27ac7318f$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $1e4b00d27ac7318f$var$lastCapturedEventTargetId) return false;
    } catch  {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $1e4b00d27ac7318f$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $1e4b00d27ac7318f$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $1e4b00d27ac7318f$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($1e4b00d27ac7318f$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $7WT4q.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $7WT4q.addNonEnumerableProperty)(target, '_sentryId', (0, $75eh7.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$1e4b00d27ac7318f$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $1e4b00d27ac7318f$var$lastCapturedEventType = event.type;
            $1e4b00d27ac7318f$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($1e4b00d27ac7318f$var$debounceTimerID);
        $1e4b00d27ac7318f$var$debounceTimerID = (0, $lSiV6.WINDOW).setTimeout(()=>{
            $1e4b00d27ac7318f$var$lastCapturedEventTargetId = undefined;
            $1e4b00d27ac7318f$var$lastCapturedEventType = undefined;
        }, $1e4b00d27ac7318f$var$DEBOUNCE_DURATION);
    };
}
function $1e4b00d27ac7318f$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});
parcelRegister("lSiV6", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $fecd5142b3aa5fba$export$56d8a8a25bd48b81; });

var $e5cgV = parcelRequire("e5cgV");
const $fecd5142b3aa5fba$export$56d8a8a25bd48b81 = (0, $e5cgV.GLOBAL_OBJ);

});


parcelRegister("2rlqn", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $1c6eb8d3782405ed$export$3f18c56c58114e75; });

var $1ypZO = parcelRequire("1ypZO");
var $7WT4q = parcelRequire("7WT4q");
var $gDmZ9 = parcelRequire("gDmZ9");

var $lSiV6 = parcelRequire("lSiV6");
let $1c6eb8d3782405ed$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $1c6eb8d3782405ed$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $1ypZO.addHandler)(type, handler);
    (0, $1ypZO.maybeInstrument)(type, $1c6eb8d3782405ed$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $1c6eb8d3782405ed$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $lSiV6.WINDOW).addEventListener('popstate', ()=>{
        const to = (0, $lSiV6.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $1c6eb8d3782405ed$var$lastHref;
        $1c6eb8d3782405ed$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $1ypZO.triggerHandlers)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $gDmZ9.supportsHistory)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $1c6eb8d3782405ed$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $1c6eb8d3782405ed$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $1c6eb8d3782405ed$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $1ypZO.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $7WT4q.fill)((0, $lSiV6.WINDOW).history, 'pushState', historyReplacementFunction);
    (0, $7WT4q.fill)((0, $lSiV6.WINDOW).history, 'replaceState', historyReplacementFunction);
}
function $1c6eb8d3782405ed$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $lSiV6.WINDOW).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}

});

parcelRegister("4cZAn", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $31080e09a167781b$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $31080e09a167781b$export$26ace48dd54c9aea; });

var $1ypZO = parcelRequire("1ypZO");
var $3TywK = parcelRequire("3TywK");
var $aGoK9 = parcelRequire("aGoK9");

var $lSiV6 = parcelRequire("lSiV6");
const $31080e09a167781b$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $31080e09a167781b$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $1ypZO.addHandler)(type, handler);
    (0, $1ypZO.maybeInstrument)(type, $31080e09a167781b$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $31080e09a167781b$export$c67d533bf77cbf54() {
    if (!(0, $lSiV6.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $aGoK9.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $3TywK.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $31080e09a167781b$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$31080e09a167781b$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$31080e09a167781b$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $aGoK9.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $1ypZO.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$31080e09a167781b$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $3TywK.isString)(header) && (0, $3TywK.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$31080e09a167781b$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $aGoK9.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $1ypZO.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $31080e09a167781b$var$parseXhrUrlArg(url) {
    if ((0, $3TywK.isString)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("cQXNX", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $95b8bb5385809809$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $95b8bb5385809809$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("j9DiD", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $df1d57ae9553b461$export$59bfe9f1c76150e; });

var $12L9I = parcelRequire("12L9I");
var $7WT4q = parcelRequire("7WT4q");
var $iqbKv = parcelRequire("iqbKv");

var $4p9Jt = parcelRequire("4p9Jt");
const $df1d57ae9553b461$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $df1d57ae9553b461$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $df1d57ae9553b461$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $df1d57ae9553b461$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $7WT4q.fill)((0, $4p9Jt.WINDOW), 'setTimeout', $df1d57ae9553b461$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $7WT4q.fill)((0, $4p9Jt.WINDOW), 'setInterval', $df1d57ae9553b461$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $7WT4q.fill)((0, $4p9Jt.WINDOW), 'requestAnimationFrame', $df1d57ae9553b461$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $4p9Jt.WINDOW)) (0, $7WT4q.fill)(XMLHttpRequest.prototype, 'send', $df1d57ae9553b461$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $df1d57ae9553b461$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$df1d57ae9553b461$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $df1d57ae9553b461$export$59bfe9f1c76150e = (0, $12L9I.defineIntegration)($df1d57ae9553b461$var$_browserApiErrorsIntegration);
function $df1d57ae9553b461$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $4p9Jt.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $iqbKv.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $df1d57ae9553b461$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $4p9Jt.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $iqbKv.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $df1d57ae9553b461$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $7WT4q.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $iqbKv.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $7WT4q.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $iqbKv.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $4p9Jt.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $df1d57ae9553b461$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $4p9Jt.WINDOW);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $7WT4q.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($df1d57ae9553b461$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $4p9Jt.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $iqbKv.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $df1d57ae9553b461$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $4p9Jt.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $iqbKv.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $7WT4q.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch  {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $df1d57ae9553b461$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $df1d57ae9553b461$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}

});

parcelRegister("1QkPc", function(module, exports) {

$parcel$export(module.exports, "browserSessionIntegration", function () { return $157acd253478efae$export$1baa7880e357371c; });

var $g5j9r = parcelRequire("g5j9r");
var $lEIJP = parcelRequire("lEIJP");
var $12L9I = parcelRequire("12L9I");

var $2rlqn = parcelRequire("2rlqn");

var $cQXNX = parcelRequire("cQXNX");

var $4p9Jt = parcelRequire("4p9Jt");
/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $157acd253478efae$export$1baa7880e357371c = (0, $12L9I.defineIntegration)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $4p9Jt.WINDOW).document === 'undefined') {
                (0, $cQXNX.DEBUG_BUILD) && (0, $lEIJP.debug).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $g5j9r.startSession)({
                ignoreDuration: true
            });
            (0, $g5j9r.captureSession)();
            // We want to create a session for every navigation as well
            (0, $2rlqn.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $g5j9r.startSession)({
                        ignoreDuration: true
                    });
                    (0, $g5j9r.captureSession)();
                }
            });
        }
    };
});

});

parcelRegister("5zKjx", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", function () { return $40f425add850fe89$export$66acc70e8cf2b71a; });

var $8FGRZ = parcelRequire("8FGRZ");
var $vMuW3 = parcelRequire("vMuW3");
var $g5j9r = parcelRequire("g5j9r");
var $lEIJP = parcelRequire("lEIJP");
var $12L9I = parcelRequire("12L9I");
var $bkLxn = parcelRequire("bkLxn");
var $dOTpB = parcelRequire("dOTpB");
var $3TywK = parcelRequire("3TywK");
var $iqbKv = parcelRequire("iqbKv");

var $cQXNX = parcelRequire("cQXNX");

var $hCF4L = parcelRequire("hCF4L");

var $4p9Jt = parcelRequire("4p9Jt");
const $40f425add850fe89$var$INTEGRATION_NAME = 'GlobalHandlers';
const $40f425add850fe89$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $40f425add850fe89$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $40f425add850fe89$var$_installGlobalOnErrorHandler(client);
                $40f425add850fe89$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $40f425add850fe89$var$_installGlobalOnUnhandledRejectionHandler(client);
                $40f425add850fe89$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $40f425add850fe89$export$66acc70e8cf2b71a = (0, $12L9I.defineIntegration)($40f425add850fe89$var$_globalHandlersIntegration);
function $40f425add850fe89$var$_installGlobalOnErrorHandler(client) {
    (0, $8FGRZ.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $40f425add850fe89$var$getOptions();
        if ((0, $bkLxn.getClient)() !== client || (0, $4p9Jt.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $40f425add850fe89$var$_enhanceEventWithInitialFrame((0, $hCF4L.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $g5j9r.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $40f425add850fe89$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $vMuW3.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $40f425add850fe89$var$getOptions();
        if ((0, $bkLxn.getClient)() !== client || (0, $4p9Jt.shouldIgnoreOnError)()) return;
        const error = $40f425add850fe89$var$_getUnhandledRejectionError(e);
        const event = (0, $3TywK.isPrimitive)(error) ? $40f425add850fe89$var$_eventFromRejectionWithPrimitive(error) : (0, $hCF4L.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $g5j9r.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $40f425add850fe89$var$_getUnhandledRejectionError(error) {
    if ((0, $3TywK.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $40f425add850fe89$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $40f425add850fe89$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $3TywK.isString)(url) && url.length > 0 ? url : (0, $dOTpB.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $iqbKv.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $40f425add850fe89$var$globalHandlerLog(type) {
    (0, $cQXNX.DEBUG_BUILD) && (0, $lEIJP.debug).log(`Global Handler attached: ${type}`);
}
function $40f425add850fe89$var$getOptions() {
    const client = (0, $bkLxn.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("8FGRZ", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $01a116532448531e$export$55b5c3ba2194f0c6; });

var $e5cgV = parcelRequire("e5cgV");

var $1ypZO = parcelRequire("1ypZO");
let $01a116532448531e$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $01a116532448531e$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $1ypZO.addHandler)(type, handler);
    (0, $1ypZO.maybeInstrument)(type, $01a116532448531e$var$instrumentError);
}
function $01a116532448531e$var$instrumentError() {
    $01a116532448531e$var$_oldOnErrorHandler = (0, $e5cgV.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $e5cgV.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $1ypZO.triggerHandlers)('error', handlerData);
        if ($01a116532448531e$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $01a116532448531e$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $e5cgV.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("vMuW3", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $05f8840c9d9a79d5$export$8bf4fc6858821a4e; });

var $e5cgV = parcelRequire("e5cgV");

var $1ypZO = parcelRequire("1ypZO");
let $05f8840c9d9a79d5$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $05f8840c9d9a79d5$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $1ypZO.addHandler)(type, handler);
    (0, $1ypZO.maybeInstrument)(type, $05f8840c9d9a79d5$var$instrumentUnhandledRejection);
}
function $05f8840c9d9a79d5$var$instrumentUnhandledRejection() {
    $05f8840c9d9a79d5$var$_oldOnUnhandledRejectionHandler = (0, $e5cgV.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $e5cgV.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $1ypZO.triggerHandlers)('unhandledrejection', handlerData);
        if ($05f8840c9d9a79d5$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $05f8840c9d9a79d5$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $e5cgV.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("l8IWF", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", function () { return $f63d3581a3c23aaa$export$1378794447170364; });

var $12L9I = parcelRequire("12L9I");

var $4p9Jt = parcelRequire("4p9Jt");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $f63d3581a3c23aaa$export$1378794447170364 = (0, $12L9I.defineIntegration)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $4p9Jt.WINDOW).navigator && !(0, $4p9Jt.WINDOW).location && !(0, $4p9Jt.WINDOW).document) return;
            const reqData = (0, $4p9Jt.getHttpRequestData)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        }
    };
});

});

parcelRegister("jlfRh", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $e14c479b0751455b$export$ebabb00eb7f3a395; });

var $3r71C = parcelRequire("3r71C");
var $12L9I = parcelRequire("12L9I");

var $hCF4L = parcelRequire("hCF4L");
const $e14c479b0751455b$var$DEFAULT_KEY = 'cause';
const $e14c479b0751455b$var$DEFAULT_LIMIT = 5;
const $e14c479b0751455b$var$INTEGRATION_NAME = 'LinkedErrors';
const $e14c479b0751455b$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $e14c479b0751455b$var$DEFAULT_LIMIT;
    const key = options.key || $e14c479b0751455b$var$DEFAULT_KEY;
    return {
        name: $e14c479b0751455b$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $3r71C.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $hCF4L.exceptionFromError), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $e14c479b0751455b$export$ebabb00eb7f3a395 = (0, $12L9I.defineIntegration)($e14c479b0751455b$var$_linkedErrorsIntegration);

});
parcelRegister("3r71C", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $280957c4f2395267$export$b91c38ed7d8ae9b2; });

var $3TywK = parcelRequire("3TywK");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $280957c4f2395267$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $3TywK.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $280957c4f2395267$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $280957c4f2395267$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $3TywK.isInstanceOf)(error[key], Error)) {
        $280957c4f2395267$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $280957c4f2395267$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $280957c4f2395267$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $3TywK.isInstanceOf)(childError, Error)) {
            $280957c4f2395267$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $280957c4f2395267$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $280957c4f2395267$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $280957c4f2395267$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $280957c4f2395267$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}

});


parcelRegister("7x6G7", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", function () { return $57c0cbac50558149$export$2b2b997d81bf3907; });

var $iqbKv = parcelRequire("iqbKv");
const $57c0cbac50558149$var$OPERA10_PRIORITY = 10;
const $57c0cbac50558149$var$OPERA11_PRIORITY = 20;
const $57c0cbac50558149$var$CHROME_PRIORITY = 30;
const $57c0cbac50558149$var$WINJS_PRIORITY = 40;
const $57c0cbac50558149$var$GECKO_PRIORITY = 50;
function $57c0cbac50558149$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $iqbKv.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $57c0cbac50558149$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $57c0cbac50558149$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $57c0cbac50558149$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $57c0cbac50558149$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $57c0cbac50558149$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $57c0cbac50558149$var$createFrame(filename, (0, $iqbKv.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $57c0cbac50558149$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $57c0cbac50558149$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $57c0cbac50558149$var$extractSafariExtensionDetails(parts[1] || (0, $iqbKv.UNKNOWN_FUNCTION), parts[2]);
        return $57c0cbac50558149$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $57c0cbac50558149$export$263a749fff749872 = [
    $57c0cbac50558149$var$CHROME_PRIORITY,
    $57c0cbac50558149$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $57c0cbac50558149$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $57c0cbac50558149$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $57c0cbac50558149$var$gecko = (line)=>{
    const parts = $57c0cbac50558149$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $57c0cbac50558149$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $iqbKv.UNKNOWN_FUNCTION);
        [func, filename] = $57c0cbac50558149$var$extractSafariExtensionDetails(func, filename);
        return $57c0cbac50558149$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $57c0cbac50558149$export$cdba47a5dd2804d = [
    $57c0cbac50558149$var$GECKO_PRIORITY,
    $57c0cbac50558149$var$gecko
];
const $57c0cbac50558149$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $57c0cbac50558149$var$winjs = (line)=>{
    const parts = $57c0cbac50558149$var$winjsRegex.exec(line);
    return parts ? $57c0cbac50558149$var$createFrame(parts[2], parts[1] || (0, $iqbKv.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $57c0cbac50558149$export$179460296da408e8 = [
    $57c0cbac50558149$var$WINJS_PRIORITY,
    $57c0cbac50558149$var$winjs
];
const $57c0cbac50558149$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $57c0cbac50558149$var$opera10 = (line)=>{
    const parts = $57c0cbac50558149$var$opera10Regex.exec(line);
    return parts ? $57c0cbac50558149$var$createFrame(parts[2], parts[3] || (0, $iqbKv.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $57c0cbac50558149$export$f892b52c880ffc7a = [
    $57c0cbac50558149$var$OPERA10_PRIORITY,
    $57c0cbac50558149$var$opera10
];
const $57c0cbac50558149$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $57c0cbac50558149$var$opera11 = (line)=>{
    const parts = $57c0cbac50558149$var$opera11Regex.exec(line);
    return parts ? $57c0cbac50558149$var$createFrame(parts[5], parts[3] || parts[4] || (0, $iqbKv.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $57c0cbac50558149$export$af11af13f09fb0dc = [
    $57c0cbac50558149$var$OPERA11_PRIORITY,
    $57c0cbac50558149$var$opera11
];
const $57c0cbac50558149$export$7197c0fe6554c079 = [
    $57c0cbac50558149$export$263a749fff749872,
    $57c0cbac50558149$export$cdba47a5dd2804d
];
const $57c0cbac50558149$export$2b2b997d81bf3907 = (0, $iqbKv.createStackParser)(...$57c0cbac50558149$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $57c0cbac50558149$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $iqbKv.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("5QgHo", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $440ec3257c2f09ab$export$b2311068c46d7cc8; });

var $3NXXD = parcelRequire("3NXXD");
var $2C0zV = parcelRequire("2C0zV");

var $7HPjC = parcelRequire("7HPjC");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $440ec3257c2f09ab$export$b2311068c46d7cc8(options, nativeFetch = (0, $7HPjC.getNativeImplementation)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $7HPjC.clearCachedImplementation)('fetch');
            return (0, $2C0zV.rejectedSyncPromise)('No fetch implementation available');
        }
        try {
            // Note: We do not need to suppress tracing here, becasue we are using the native fetch, instead of our wrapped one.
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $7HPjC.clearCachedImplementation)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $2C0zV.rejectedSyncPromise)(e);
        }
    }
    return (0, $3NXXD.createTransport)(options, makeRequest);
}

});
parcelRegister("3NXXD", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $2c5475a9fc616aba$export$d09f50d9ab7f7b69; });

var $eAxGy = parcelRequire("eAxGy");

var $lEIJP = parcelRequire("lEIJP");

var $fnDBy = parcelRequire("fnDBy");

var $jby6V = parcelRequire("jby6V");

var $gQI6I = parcelRequire("gQI6I");

var $2C0zV = parcelRequire("2C0zV");
const $2c5475a9fc616aba$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $2c5475a9fc616aba$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $jby6V.makePromiseBuffer)(options.bufferSize || $2c5475a9fc616aba$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $fnDBy.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $fnDBy.envelopeItemTypeToDataCategory)(type);
            if ((0, $gQI6I.isRateLimited)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $2C0zV.resolvedSyncPromise)({});
        const filteredEnvelope = (0, $fnDBy.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $fnDBy.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $fnDBy.envelopeItemTypeToDataCategory)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $fnDBy.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $gQI6I.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $jby6V.SENTRY_BUFFER_FULL_ERROR)) {
                (0, $eAxGy.DEBUG_BUILD) && (0, $lEIJP.debug).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $2C0zV.resolvedSyncPromise)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}

});
parcelRegister("jby6V", function(module, exports) {

$parcel$export(module.exports, "SENTRY_BUFFER_FULL_ERROR", function () { return $df798112fc624870$export$c8667f1887a128dc; });
$parcel$export(module.exports, "makePromiseBuffer", function () { return $df798112fc624870$export$85a4f67f852183e6; });

var $2C0zV = parcelRequire("2C0zV");
const $df798112fc624870$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $df798112fc624870$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $2C0zV.rejectedSyncPromise)($df798112fc624870$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $2C0zV.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $2C0zV.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});

parcelRegister("gQI6I", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", function () { return $c443b77431232967$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $c443b77431232967$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $c443b77431232967$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $c443b77431232967$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $c443b77431232967$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $c443b77431232967$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $c443b77431232967$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $c443b77431232967$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $c443b77431232967$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $c443b77431232967$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});


parcelRegister("7HPjC", function(module, exports) {

$parcel$export(module.exports, "getNativeImplementation", function () { return $59c45ab8f39b4623$export$e464f4a514ac28a8; });
$parcel$export(module.exports, "clearCachedImplementation", function () { return $59c45ab8f39b4623$export$8aa36702e8c8978; });

var $lEIJP = parcelRequire("lEIJP");
var $gDmZ9 = parcelRequire("gDmZ9");

var $6e47Y = parcelRequire("6e47Y");

var $lSiV6 = parcelRequire("lSiV6");
/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $59c45ab8f39b4623$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $59c45ab8f39b4623$export$e464f4a514ac28a8(name) {
    const cached = $59c45ab8f39b4623$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $lSiV6.WINDOW)[name];
    // Fast path to avoid DOM I/O
    if ((0, $gDmZ9.isNativeFunction)(impl)) return $59c45ab8f39b4623$var$cachedImplementations[name] = impl.bind((0, $lSiV6.WINDOW));
    const document = (0, $lSiV6.WINDOW).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $6e47Y.DEBUG_BUILD) && (0, $lEIJP.debug).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $59c45ab8f39b4623$var$cachedImplementations[name] = impl.bind((0, $lSiV6.WINDOW));
}
/** Clear a cached implementation. */ function $59c45ab8f39b4623$export$8aa36702e8c8978(name) {
    $59c45ab8f39b4623$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $59c45ab8f39b4623$export$e7aa7bc5c1b3cfb3(...rest) {
    return $59c45ab8f39b4623$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $59c45ab8f39b4623$export$831dc9f2ab0a617b(...rest) {
    return $59c45ab8f39b4623$export$e464f4a514ac28a8('setTimeout')(...rest);
}

});
parcelRegister("6e47Y", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $4887408cff635ee6$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $4887408cff635ee6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});



parcelRegister("7NwmU", function(module, exports) {

$parcel$export(module.exports, "checkAndWarnIfIsEmbeddedBrowserExtension", function () { return $5ad637b14023a233$export$dc236a86065879fc; });

var $lEIJP = parcelRequire("lEIJP");
var $dOTpB = parcelRequire("dOTpB");

var $cQXNX = parcelRequire("cQXNX");

var $4p9Jt = parcelRequire("4p9Jt");
/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $5ad637b14023a233$export$dc236a86065879fc() {
    if ($5ad637b14023a233$var$_isEmbeddedBrowserExtension()) {
        if (0, $cQXNX.DEBUG_BUILD) (0, $lEIJP.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $5ad637b14023a233$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $4p9Jt.WINDOW).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $4p9Jt.WINDOW);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $dOTpB.getLocationHref)();
    const extensionProtocols = [
        'chrome-extension',
        'moz-extension',
        'ms-browser-extension',
        'safari-web-extension'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $4p9Jt.WINDOW) === (0, $4p9Jt.WINDOW).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}://`));
    return !isDedicatedExtensionPage;
}

});



parcelRegister("cuZAx", function(module, exports) {

$parcel$export(module.exports, "isOidcDisplayMode", function () { return $37aaac3c24961a96$export$62d34b9f4d1e3978; });
$parcel$export(module.exports, "isMobileOidc", function () { return $37aaac3c24961a96$export$eb7f7bf9cc131875; });
function $37aaac3c24961a96$export$62d34b9f4d1e3978(context, ...display) {
    if (!context || !context.display) return false;
    return display.includes(context.display);
}
function $37aaac3c24961a96$export$eb7f7bf9cc131875(context) {
    // currently we assume that any oidc with proper display param is a mobile oidc
    return !!context && !!context.display;
}

});

parcelRegister("iGVRQ", function(module, exports) {

$parcel$export(module.exports, "inferCapabilitiesFromPathname", function () { return $3b9dc9b5f26ecc5d$export$6c4138d23bab6961; });
const $3b9dc9b5f26ecc5d$export$6c4138d23bab6961 = (pathname)=>{
    if (pathname.includes('login')) return [
        'capability-group--login'
    ];
    if (pathname.includes('signup')) return [
        'capability-group--signup'
    ];
    if (pathname.includes('logout')) return [
        'capability-group--logout'
    ];
    return [
        'unknown'
    ];
};

});


parcelRegister("hVicB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0c5e12800e45076$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $l3ahi = parcelRequire("l3ahi");

var $5mr0m = parcelRequire("5mr0m");

var $gIHGP = parcelRequire("gIHGP");

var $2uZeu = parcelRequire("2uZeu");

var $jiYgI = parcelRequire("jiYgI");

var $BJozj = parcelRequire("BJozj");

var $4HhDD = parcelRequire("4HhDD");

var $5mTtQ = parcelRequire("5mTtQ");

var $9EEYq = parcelRequire("9EEYq");

var $5Fldv = parcelRequire("5Fldv");

var $7V8tZ = parcelRequire("7V8tZ");

var $gbvon = parcelRequire("gbvon");

var $8ye4T = parcelRequire("8ye4T");

var $lizWL = parcelRequire("lizWL");

var $3K6ly = parcelRequire("3K6ly");

var $lh6MU = parcelRequire("lh6MU");

var $j04Ve = parcelRequire("j04Ve");

var $j0YI2 = parcelRequire("j0YI2");

var $k1sRe = parcelRequire("k1sRe");

var $hzBJL = parcelRequire("hzBJL");
function $d0c5e12800e45076$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d0c5e12800e45076$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d0c5e12800e45076$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d0c5e12800e45076$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d0c5e12800e45076$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $d0c5e12800e45076$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $d0c5e12800e45076$export$48361b6ed38f1b0 {
    static callback(response) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) {
            if (response.getEventResponseList().length === 0) // eslint-disable-next-line no-console
            console.debug('Event(s) submitted to GASv3');
            else response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else if (statusCode === 400 || statusCode === 404) {
            // eslint-disable-next-line no-console
            console.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            // eslint-disable-next-line no-console
            console.info('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $d0c5e12800e45076$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_endsWith", (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_createSubproductGetter", (subproduct)=>(0, $2uZeu.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.'));
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $2uZeu.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.'));
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($d0c5e12800e45076$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (err) {
                this._safeSessionStorage.removeItem($d0c5e12800e45076$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($d0c5e12800e45076$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $5mr0m.eventType).UI:
                case (0, $5mr0m.eventType).OPERATIONAL:
                case (0, $5mr0m.eventType).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $5mr0m.eventType).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $5mr0m.eventType).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "clearEmbeddedProduct", ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setSubproduct", (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $5mr0m.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $5mr0m.isType)((0, $5mr0m.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $5mr0m.objectValues)((0, $5mr0m.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setUserInfo", (userIdType, userId)=>{
            (0, $4HhDD.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $5mr0m.isType)((0, $5mr0m.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $5mr0m.objectValues)((0, $5mr0m.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $5mr0m.isType)((0, $5mr0m.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $5mr0m.objectValues)((0, $5mr0m.groupType))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = $d0c5e12800e45076$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $5mr0m.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $4HhDD.validateScreenEvent)(screenName);
            (0, $4HhDD.validateContainers)(screenContainers);
            const builtEvent = (0, $jiYgI.buildScreenEvent)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $d0c5e12800e45076$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $k1sRe.default)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "sendTrackEvent", (event, callback)=>{
            (0, $4HhDD.validateTrackEvent)(event);
            const builtEvent = (0, $jiYgI.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $5mr0m.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $jiYgI.buildActionName)(event), builtEvent, this._context, (0, $k1sRe.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "sendUIEvent", (event, callback)=>{
            (0, $4HhDD.validateUIEvent)(event);
            const builtEvent = (0, $jiYgI.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $5mr0m.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $jiYgI.buildActionName)(event), builtEvent, this._context, (0, $k1sRe.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "sendOperationalEvent", (event, callback)=>{
            (0, $4HhDD.validateOperationalEvent)(event);
            const builtEvent = (0, $jiYgI.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $5mr0m.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $jiYgI.buildActionName)(event), builtEvent, this._context, (0, $k1sRe.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $j04Ve.default)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "stopLowPriorityEventDelay", ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $5mr0m.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $5mr0m.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $5mr0m.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $5mr0m.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $5mr0m.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $5mr0m.objectValues)((0, $5mr0m.eventType))}]`);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setResponseCallback", (responseCallback)=>{
            this.eventProcessor.setResponseCallback(responseCallback);
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $5mr0m.isType)((0, $5mr0m.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $5mr0m.objectValues)((0, $5mr0m.envType))}]`);
        if (productInfo.perimeter && !(0, $5mr0m.isType)((0, $5mr0m.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $5mr0m.objectValues)((0, $5mr0m.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $5mr0m.originType).WEB;
        else if (!(0, $5mr0m.isType)((0, $5mr0m.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $5mr0m.objectValues)((0, $5mr0m.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $5mr0m.originType).WEB ? (0, $5mr0m.platformType).WEB : (0, $5mr0m.platformType).DESKTOP;
        else (0, $4HhDD.validatePlatform)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = $d0c5e12800e45076$var$_objectSpread($d0c5e12800e45076$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        this._context = (0, $jiYgI.buildContext)(this._productInfo);
        this._safeSessionStorage = new (0, $8ye4T.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $7V8tZ.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $hzBJL.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        this.eventProcessor = new (0, $5mTtQ.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $d0c5e12800e45076$export$48361b6ed38f1b0.callback
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $5Fldv.default)();
        this._tabTracking = new (0, $lizWL.default)();
        this._sessionTracking = new (0, $gbvon.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $3K6ly.default)();
        this.originTracing = new (0, $9EEYq.default)();
        // Init Apdex
        this._apdexEvent = new (0, $gIHGP.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $j0YI2.defaultHistoryReplaceFn);
        this.eventDelayQueue = new (0, $BJozj.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $lh6MU.default)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($l3ahi)))();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
}

});
parcelRegister("l3ahi", function(module, exports) {

var $goQdG = parcelRequire("goQdG");

var $lhNLT = parcelRequire("lhNLT");
function $f531d9c35955e73e$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $goQdG)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $lhNLT(rnds);
}
module.exports = $f531d9c35955e73e$var$v4;

});
parcelRegister("goQdG", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $bf0764fe9f74dbda$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($bf0764fe9f74dbda$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $bf0764fe9f74dbda$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $bf0764fe9f74dbda$var$getRandomValues($bf0764fe9f74dbda$var$rnds8);
        return $bf0764fe9f74dbda$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $bf0764fe9f74dbda$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $bf0764fe9f74dbda$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $bf0764fe9f74dbda$var$rnds;
    };
}

});

parcelRegister("lhNLT", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $f7f1cb0f8e0a82df$var$byteToHex = [];
for(var $f7f1cb0f8e0a82df$var$i = 0; $f7f1cb0f8e0a82df$var$i < 256; ++$f7f1cb0f8e0a82df$var$i)$f7f1cb0f8e0a82df$var$byteToHex[$f7f1cb0f8e0a82df$var$i] = ($f7f1cb0f8e0a82df$var$i + 0x100).toString(16).substr(1);
function $f7f1cb0f8e0a82df$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $f7f1cb0f8e0a82df$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $f7f1cb0f8e0a82df$var$bytesToUuid;

});


parcelRegister("5mr0m", function(module, exports) {

$parcel$export(module.exports, "envType", function () { return $3e73f46641a4306c$export$56ac8ebc9870b1b9; });
$parcel$export(module.exports, "eventType", function () { return $3e73f46641a4306c$export$4c045e605d532c98; });
$parcel$export(module.exports, "platformType", function () { return $3e73f46641a4306c$export$6b4f396210e539f3; });
$parcel$export(module.exports, "originType", function () { return $3e73f46641a4306c$export$f73e9fcd368bb695; });
$parcel$export(module.exports, "tenantType", function () { return $3e73f46641a4306c$export$496f06ac2a964da2; });
$parcel$export(module.exports, "userType", function () { return $3e73f46641a4306c$export$1827adfd178b4870; });
$parcel$export(module.exports, "apdexType", function () { return $3e73f46641a4306c$export$99b37380a464d794; });
$parcel$export(module.exports, "desktopPlatforms", function () { return $3e73f46641a4306c$export$809831be6c4c6227; });
$parcel$export(module.exports, "webPlatforms", function () { return $3e73f46641a4306c$export$19c579398ad213e7; });
$parcel$export(module.exports, "originTracingType", function () { return $3e73f46641a4306c$export$62a500c02dc63ee; });
$parcel$export(module.exports, "objectValues", function () { return $3e73f46641a4306c$export$ad1854f4a08c15f8; });
$parcel$export(module.exports, "isType", function () { return $3e73f46641a4306c$export$26b9f946b448f23e; });
$parcel$export(module.exports, "perimeterType", function () { return $3e73f46641a4306c$export$bdd41749d2096e4b; });
$parcel$export(module.exports, "aliasType", function () { return $3e73f46641a4306c$export$a8c99e46b781d936; });
$parcel$export(module.exports, "groupType", function () { return $3e73f46641a4306c$export$e73680b18d9b7c6e; });
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $3e73f46641a4306c$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $3e73f46641a4306c$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $3e73f46641a4306c$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $3e73f46641a4306c$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $3e73f46641a4306c$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $3e73f46641a4306c$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
let $3e73f46641a4306c$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $3e73f46641a4306c$export$809831be6c4c6227 = Object.freeze([
    $3e73f46641a4306c$export$6b4f396210e539f3.DESKTOP,
    $3e73f46641a4306c$export$6b4f396210e539f3.MAC,
    $3e73f46641a4306c$export$6b4f396210e539f3.LINUX,
    $3e73f46641a4306c$export$6b4f396210e539f3.WINDOWS
]);
const $3e73f46641a4306c$export$19c579398ad213e7 = Object.freeze([
    $3e73f46641a4306c$export$6b4f396210e539f3.WEB,
    $3e73f46641a4306c$export$6b4f396210e539f3.MOBILE_WEB
]);
let $3e73f46641a4306c$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $3e73f46641a4306c$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $3e73f46641a4306c$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $3e73f46641a4306c$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $3e73f46641a4306c$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $3e73f46641a4306c$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $3e73f46641a4306c$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("gIHGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c2a54c8603961d$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $5mr0m = parcelRequire("5mr0m");

var $5Fldv = parcelRequire("5Fldv");

var $6dqVa = parcelRequire("6dqVa");
function $c2c2a54c8603961d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2c2a54c8603961d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2c2a54c8603961d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2c2a54c8603961d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $c2c2a54c8603961d$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $c2c2a54c8603961d$var$_objectSpread($c2c2a54c8603961d$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $5mr0m.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $5mr0m.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $5mr0m.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $5mr0m.isType)((0, $5mr0m.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $5mr0m.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: $c2c2a54c8603961d$var$_objectSpread($c2c2a54c8603961d$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $5Fldv.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $6dqVa.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($c2c2a54c8603961d$var$_objectSpread($c2c2a54c8603961d$var$_objectSpread($c2c2a54c8603961d$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("5Fldv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42013d533109bb7e$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");
class $42013d533109bb7e$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("6dqVa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4868d6ef12b05238$export$2e2bcd8739ae039; });
class $4868d6ef12b05238$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("2uZeu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d1de1a73ce2e9fc$export$2e2bcd8739ae039; });
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $1d1de1a73ce2e9fc$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $1d1de1a73ce2e9fc$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($1d1de1a73ce2e9fc$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("jiYgI", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", function () { return $e0de72d3f3bf6a2b$export$655ecf7241feac42; });
$parcel$export(module.exports, "buildScreenEvent", function () { return $e0de72d3f3bf6a2b$export$c7d9a5f56acc4b19; });
$parcel$export(module.exports, "buildActionName", function () { return $e0de72d3f3bf6a2b$export$9c5623a792efc9b0; });
$parcel$export(module.exports, "buildContext", function () { return $e0de72d3f3bf6a2b$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "buildActionEvent", function () { return $e0de72d3f3bf6a2b$export$7bf451af4a8e3dd9; });

var $91FVG = parcelRequire("91FVG");

var $5mr0m = parcelRequire("5mr0m");

var $fhqFj = parcelRequire("fhqFj");
function $e0de72d3f3bf6a2b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e0de72d3f3bf6a2b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e0de72d3f3bf6a2b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e0de72d3f3bf6a2b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e0de72d3f3bf6a2b$var$libraryVersion = "4.27.1";
function $e0de72d3f3bf6a2b$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $e0de72d3f3bf6a2b$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $e0de72d3f3bf6a2b$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $e0de72d3f3bf6a2b$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $e0de72d3f3bf6a2b$var$buildAliases(aliases) {
    if ($e0de72d3f3bf6a2b$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $e0de72d3f3bf6a2b$var$buildGroups(groups) {
    if ($e0de72d3f3bf6a2b$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $e0de72d3f3bf6a2b$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $e0de72d3f3bf6a2b$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $e0de72d3f3bf6a2b$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $e0de72d3f3bf6a2b$var$getProductField(productInfo.env, overrides.env);
    const product = $e0de72d3f3bf6a2b$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $e0de72d3f3bf6a2b$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $e0de72d3f3bf6a2b$var$getProductField(productInfo.version, overrides.version);
    const origin = $e0de72d3f3bf6a2b$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $e0de72d3f3bf6a2b$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $e0de72d3f3bf6a2b$var$isNotEmptyObject(obj) {
    return (0, $fhqFj.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $e0de72d3f3bf6a2b$var$buildAttributesWithName(name, attrObject) {
    return $e0de72d3f3bf6a2b$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $e0de72d3f3bf6a2b$var$buildAttributes(attributes) {
    return $e0de72d3f3bf6a2b$var$buildAttributesWithName('attributes', attributes);
}
function $e0de72d3f3bf6a2b$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $e0de72d3f3bf6a2b$export$f045f238d77c002a(containers) {
    if ($e0de72d3f3bf6a2b$var$isNotEmptyObject(containers)) {
        const validContainers = $e0de72d3f3bf6a2b$export$3f5115a568819c1a(containers);
        return $e0de72d3f3bf6a2b$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $e0de72d3f3bf6a2b$export$655ecf7241feac42(event, actionEventType) {
    return $e0de72d3f3bf6a2b$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $e0de72d3f3bf6a2b$export$f045f238d77c002a(event.containers));
}
function $e0de72d3f3bf6a2b$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $e0de72d3f3bf6a2b$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $e0de72d3f3bf6a2b$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $e0de72d3f3bf6a2b$var$buildProductFields(productInfo);
    const tenantFields = $e0de72d3f3bf6a2b$var$buildTenantFields(tenantInfo);
    const userFields = $e0de72d3f3bf6a2b$var$buildUserFields(userInfo);
    const orgFields = $e0de72d3f3bf6a2b$var$buildOrgFields(orgInfo);
    const workspaceFields = $e0de72d3f3bf6a2b$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $5mr0m.eventType).SCREEN
    };
    return $e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $e0de72d3f3bf6a2b$var$buildAttributes(attributes)), $e0de72d3f3bf6a2b$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $e0de72d3f3bf6a2b$export$f045f238d77c002a(containers)), $e0de72d3f3bf6a2b$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $e0de72d3f3bf6a2b$var$buildAliases(aliases)), $e0de72d3f3bf6a2b$var$buildGroups(groups));
}
function $e0de72d3f3bf6a2b$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
let $e0de72d3f3bf6a2b$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $e0de72d3f3bf6a2b$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return $e0de72d3f3bf6a2b$export$fbd92247fb4d6159.QUIET;
    if (environment.includes('prod')) return $e0de72d3f3bf6a2b$export$fbd92247fb4d6159.QUIET;
    return $e0de72d3f3bf6a2b$export$fbd92247fb4d6159.COMPLETE;
}
function $e0de72d3f3bf6a2b$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $e0de72d3f3bf6a2b$var$libraryVersion
            },
            validationMode: $e0de72d3f3bf6a2b$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $e0de72d3f3bf6a2b$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $e0de72d3f3bf6a2b$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $e0de72d3f3bf6a2b$var$buildProductFields(productInfo, $e0de72d3f3bf6a2b$export$e3d99b4bfec06f6e(event));
    const tenantFields = $e0de72d3f3bf6a2b$var$buildTenantFields(tenantInfo);
    const orgFields = $e0de72d3f3bf6a2b$var$buildOrgFields(orgInfo);
    const workspaceFields = $e0de72d3f3bf6a2b$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $e0de72d3f3bf6a2b$var$buildUserFields(userInfo);
    const actionFields = $e0de72d3f3bf6a2b$export$655ecf7241feac42(event, actionEventType);
    return $e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread($e0de72d3f3bf6a2b$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $e0de72d3f3bf6a2b$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $e0de72d3f3bf6a2b$var$buildAliases(aliases)), $e0de72d3f3bf6a2b$var$buildGroups(groups));
}

});
parcelRegister("fhqFj", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $b1fd20bf129f3e78$export$53b83ca8eaab0383; });
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $b1fd20bf129f3e78$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $b1fd20bf129f3e78$var$isObjectObject(o) {
    return $b1fd20bf129f3e78$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $b1fd20bf129f3e78$export$53b83ca8eaab0383(o) {
    if ($b1fd20bf129f3e78$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($b1fd20bf129f3e78$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("BJozj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0716ab5eec222b24$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $uRYfE = parcelRequire("uRYfE");

var $lYEpi = parcelRequire("lYEpi");

var $kk7z3 = parcelRequire("kk7z3");
class $0716ab5eec222b24$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "startLowPriorityEventDelay", (timeout = (0, $uRYfE.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $uRYfE.MAX_DELAY_TIMEOUT)) : (0, $uRYfE.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $kk7z3.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "stopLowPriorityEventDelay", (reason = (0, $kk7z3.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $lYEpi.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("uRYfE", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", function () { return $05ccaaeedce1c137$export$cf090d5281b5ae06; });
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", function () { return $05ccaaeedce1c137$export$8575e30be0feb909; });
const $05ccaaeedce1c137$export$cf090d5281b5ae06 = 10000;
const $05ccaaeedce1c137$export$8575e30be0feb909 = 30000;

});

parcelRegister("lYEpi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fffe8b8bb622f08d$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $jiYgI = parcelRequire("jiYgI");

var $jg3rL = parcelRequire("jg3rL");

var $1tUO4 = parcelRequire("1tUO4");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $fffe8b8bb622f08d$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $fffe8b8bb622f08d$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $fffe8b8bb622f08d$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "size", ()=>this.eventArgs.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $fffe8b8bb622f08d$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $fffe8b8bb622f08d$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $jg3rL.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $jg3rL.equals)(group.userInfo, args.userInfo) && (0, $jg3rL.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $jiYgI.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $1tUO4.default)(compressionRules);
    }
}

});
parcelRegister("jg3rL", function(module, exports) {

$parcel$export(module.exports, "mapKeys", function () { return $e0522f628ba8646a$export$781522908e4e76a1; });
$parcel$export(module.exports, "pick", function () { return $e0522f628ba8646a$export$357523c63a2253b9; });
$parcel$export(module.exports, "omitBy", function () { return $e0522f628ba8646a$export$d7a617dda645b4e3; });
$parcel$export(module.exports, "pickBy", function () { return $e0522f628ba8646a$export$b460b275d6c6aa0; });
$parcel$export(module.exports, "omit", function () { return $e0522f628ba8646a$export$30a06c8d3562193f; });
$parcel$export(module.exports, "equals", function () { return $e0522f628ba8646a$export$e9bab7fafb253603; });
$parcel$export(module.exports, "partition", function () { return $e0522f628ba8646a$export$b29f828819edca8d; });
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $e0522f628ba8646a$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $e0522f628ba8646a$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $e0522f628ba8646a$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $e0522f628ba8646a$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $e0522f628ba8646a$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $e0522f628ba8646a$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$e0522f628ba8646a$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $e0522f628ba8646a$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});

parcelRegister("1tUO4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1144907c3ba3d03f$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $jiYgI = parcelRequire("jiYgI");

var $jg3rL = parcelRequire("jg3rL");

var $64mXM = parcelRequire("64mXM");
function $1144907c3ba3d03f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1144907c3ba3d03f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1144907c3ba3d03f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1144907c3ba3d03f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $1144907c3ba3d03f$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $jiYgI.buildActionFields)(event, event.eventType);
                    contextFields = (0, $jg3rL.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $jg3rL.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$1144907c3ba3d03f$var$_objectSpread($1144907c3ba3d03f$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $64mXM.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("64mXM", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", function () { return $46b4edd604a439a7$export$89b3253ddfd2e6e8; });

var $91FVG = parcelRequire("91FVG");

var $4HhDD = parcelRequire("4HhDD");

var $jg3rL = parcelRequire("jg3rL");
class $46b4edd604a439a7$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "canCompress", (event)=>{
            try {
                return event && (0, $4HhDD.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $jg3rL.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $4HhDD.validateActionEventType)(event.eventType);
                (0, $4HhDD.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("4HhDD", function(module, exports) {

$parcel$export(module.exports, "validateContainers", function () { return $36b8dc29aceed600$export$e63ea5d8477971d3; });
$parcel$export(module.exports, "isActionEventType", function () { return $36b8dc29aceed600$export$d19cebda16f7579a; });
$parcel$export(module.exports, "validateActionEventType", function () { return $36b8dc29aceed600$export$4a8d7476662aebcc; });
$parcel$export(module.exports, "validateActionEvent", function () { return $36b8dc29aceed600$export$e0c121325c66ed4c; });
$parcel$export(module.exports, "validateScreenEvent", function () { return $36b8dc29aceed600$export$dc993432a592dc27; });
$parcel$export(module.exports, "validateTrackEvent", function () { return $36b8dc29aceed600$export$8c014fd74b0c8b99; });
$parcel$export(module.exports, "validateUIEvent", function () { return $36b8dc29aceed600$export$e5bac0930c812e90; });
$parcel$export(module.exports, "validateOperationalEvent", function () { return $36b8dc29aceed600$export$1e561554275607ef; });
$parcel$export(module.exports, "validateIdentifyEvent", function () { return $36b8dc29aceed600$export$c16a4e16aa4026c0; });
$parcel$export(module.exports, "validatePlatform", function () { return $36b8dc29aceed600$export$801b46c35394d316; });

var $5mr0m = parcelRequire("5mr0m");

var $fhqFj = parcelRequire("fhqFj");
const $36b8dc29aceed600$var$actionEventTypes = Object.freeze([
    (0, $5mr0m.eventType).OPERATIONAL,
    (0, $5mr0m.eventType).TRACK,
    (0, $5mr0m.eventType).UI
]);
function $36b8dc29aceed600$export$df8ff30e3c960006(container) {
    if (!(0, $fhqFj.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $36b8dc29aceed600$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$36b8dc29aceed600$export$df8ff30e3c960006(container));
}
function $36b8dc29aceed600$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $5mr0m.eventType).OPERATIONAL:
        case (0, $5mr0m.eventType).TRACK:
        case (0, $5mr0m.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $36b8dc29aceed600$export$4a8d7476662aebcc(type) {
    if (!$36b8dc29aceed600$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$36b8dc29aceed600$var$actionEventTypes}]`);
    return true;
}
function $36b8dc29aceed600$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $36b8dc29aceed600$export$e63ea5d8477971d3(event.containers);
}
function $36b8dc29aceed600$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $36b8dc29aceed600$export$8c014fd74b0c8b99(event) {
    $36b8dc29aceed600$export$e0c121325c66ed4c(event);
}
function $36b8dc29aceed600$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $36b8dc29aceed600$export$e5bac0930c812e90(event) {
    $36b8dc29aceed600$export$e0c121325c66ed4c(event);
}
function $36b8dc29aceed600$export$1e561554275607ef(event) {
    $36b8dc29aceed600$export$e0c121325c66ed4c(event);
}
function $36b8dc29aceed600$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $5mr0m.isType)((0, $5mr0m.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $5mr0m.objectValues)((0, $5mr0m.userType))}]`);
}
function $36b8dc29aceed600$export$801b46c35394d316(productInfo) {
    if (!(0, $5mr0m.isType)((0, $5mr0m.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $5mr0m.objectValues)((0, $5mr0m.platformType))}]`);
    if (productInfo.origin === (0, $5mr0m.originType).DESKTOP && !(0, $5mr0m.isType)((0, $5mr0m.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $5mr0m.originType).WEB && !(0, $5mr0m.isType)((0, $5mr0m.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("kk7z3", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", function () { return $ecbb8b089b967550$export$fa6e3729c21cb8f; });
let $ecbb8b089b967550$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("5mTtQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e8a0b17b8c9ef3a$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $l3ahi = parcelRequire("l3ahi");

var $2XTk1 = parcelRequire("2XTk1");

var $hOBfw = parcelRequire("hOBfw");

var $1GphQ = parcelRequire("1GphQ");

var $963uz = parcelRequire("963uz");

var $gP9Py = parcelRequire("gP9Py");

var $eBqkD = parcelRequire("eBqkD");

var $ldxtO = parcelRequire("ldxtO");

var $1H6rb = parcelRequire("1H6rb");

var $f6sCE = parcelRequire("f6sCE");
function $3e8a0b17b8c9ef3a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e8a0b17b8c9ef3a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e8a0b17b8c9ef3a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e8a0b17b8c9ef3a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $3e8a0b17b8c9ef3a$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports;
    }
}
class $3e8a0b17b8c9ef3a$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $3e8a0b17b8c9ef3a$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $3e8a0b17b8c9ef3a$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}
class $3e8a0b17b8c9ef3a$var$EventResponse {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}
class $3e8a0b17b8c9ef3a$var$EventValidationResult {
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
}
class $3e8a0b17b8c9ef3a$export$2e2bcd8739ae039 {
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "sendEvents", async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = $3e8a0b17b8c9ef3a$var$_objectSpread($3e8a0b17b8c9ef3a$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount
            });
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            const localResponseCallback = this.responseCallback;
            try {
                const response = await (0, $eBqkD.sendEvents)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                if (localResponseCallback !== null && response !== null) {
                    const analyticsAPIResponse = await response.clone().json();
                    const analyticsResponse = $3e8a0b17b8c9ef3a$var$BatchInterceptor.toAnalyticsResponse(items, null, analyticsAPIResponse);
                    localResponseCallback(analyticsResponse);
                }
            } catch (error) {
                callback(error, null);
                if (localResponseCallback !== null && error !== null) {
                    const analyticsResponse = $3e8a0b17b8c9ef3a$var$BatchInterceptor.toAnalyticsResponse(items, error, null);
                    localResponseCallback(analyticsResponse);
                }
            }
        });
        this.options = $3e8a0b17b8c9ef3a$var$_objectSpread($3e8a0b17b8c9ef3a$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $963uz.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false
        });
        this.user = new (0, $1H6rb.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $hOBfw.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $2XTk1.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $ldxtO.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = $3e8a0b17b8c9ef3a$var$_objectSpread($3e8a0b17b8c9ef3a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $ldxtO.SegmentEventTypes).TRACK,
            properties: (0, $f6sCE.prepareEventProperties)(builtEvent),
            event: eventName
        });
        const event = $3e8a0b17b8c9ef3a$var$_objectSpread($3e8a0b17b8c9ef3a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $ldxtO.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = $3e8a0b17b8c9ef3a$var$_objectSpread($3e8a0b17b8c9ef3a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $ldxtO.SegmentEventTypes).PAGE,
            properties: (0, $f6sCE.prepareEventProperties)(builtEvent),
            name: eventName
        });
        const event = $3e8a0b17b8c9ef3a$var$_objectSpread($3e8a0b17b8c9ef3a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $ldxtO.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $3e8a0b17b8c9ef3a$var$_objectSpread($3e8a0b17b8c9ef3a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $ldxtO.SegmentEventTypes).IDENTIFY,
            traits: (0, $f6sCE.prepareEventProperties)(builtEvent)
        });
        const event = $3e8a0b17b8c9ef3a$var$_objectSpread($3e8a0b17b8c9ef3a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $f6sCE.prepareEventProperties)(context);
        const segmentContext = (0, $f6sCE.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($l3ahi)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $1GphQ.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
}
class $3e8a0b17b8c9ef3a$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $3e8a0b17b8c9ef3a$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $3e8a0b17b8c9ef3a$export$133650fcdde1b226(success, statusCode, (0, $gP9Py.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $gP9Py.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $gP9Py.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $gP9Py.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $3e8a0b17b8c9ef3a$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $3e8a0b17b8c9ef3a$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error.message !== null) {
            const match = error.message.match($3e8a0b17b8c9ef3a$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $3e8a0b17b8c9ef3a$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $3e8a0b17b8c9ef3a$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $3e8a0b17b8c9ef3a$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $3e8a0b17b8c9ef3a$export$133650fcdde1b226(false, -1, (0, $gP9Py.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($3e8a0b17b8c9ef3a$var$BatchInterceptor, "http_error_regex", /HTTP Error\s([0-9]{3})\s\((.+)\)/);

});
parcelRegister("2XTk1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $228c013f329acb0b$export$2e2bcd8739ae039; });

var $j74OC = parcelRequire("j74OC");

var $228c013f329acb0b$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $j74OC.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("j74OC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dea26807fd436453$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $f5shy = parcelRequire("f5shy");
var $kpQoD = parcelRequire("kpQoD");

var $kKwNi = parcelRequire("kKwNi");
var $dT9RQ = parcelRequire("dT9RQ");
var $7huu1 = parcelRequire("7huu1");

var $hOBfw = parcelRequire("hOBfw");

var $4s5qf = parcelRequire("4s5qf");

var $j6h2q = parcelRequire("j6h2q");
var $6te8u = parcelRequire("6te8u");

var $hPCpN = parcelRequire("hPCpN");
function $dea26807fd436453$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dea26807fd436453$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dea26807fd436453$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dea26807fd436453$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $dea26807fd436453$var$ONE_MINUTE = 60000;
const $dea26807fd436453$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $dea26807fd436453$var$ONE_MINUTE,
    minRetryDelay: $dea26807fd436453$var$ONE_MINUTE,
    maxRetryDelay: $dea26807fd436453$var$ONE_MINUTE
};
const $dea26807fd436453$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $dea26807fd436453$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $dT9RQ.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $j6h2q.default)($dea26807fd436453$var$_objectSpread($dea26807fd436453$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $j6h2q.default)($dea26807fd436453$var$_objectSpread($dea26807fd436453$var$_objectSpread({}, $dea26807fd436453$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $dea26807fd436453$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $hOBfw.default)();
        this.networkStatus = new (0, $4s5qf.default)((status)=>{
            if (status === (0, $hPCpN.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $7huu1.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $hPCpN.NetworkStatusEnum).OFFLINE) {
            done((0, $6te8u.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $kKwNi.CallbackProcessingErrorName)) {
                done((0, $6te8u.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $f5shy.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $kpQoD.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $7huu1.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $6te8u.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $6te8u.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $6te8u.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $dea26807fd436453$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $dea26807fd436453$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $dea26807fd436453$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $dea26807fd436453$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $dea26807fd436453$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $dea26807fd436453$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $dea26807fd436453$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $dea26807fd436453$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $dea26807fd436453$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("f5shy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afbd42e0d8c31bfe$export$2e2bcd8739ae039; });

var $82897 = parcelRequire("82897");

var $2ktfL = parcelRequire("2ktfL");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $afbd42e0d8c31bfe$var$validSuffixs = Object.values((0, $82897.LocalStorageKeySuffix));
var $afbd42e0d8c31bfe$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $afbd42e0d8c31bfe$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $82897.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $2ktfL.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("82897", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", function () { return $5d94d44af878f799$export$ecfa71cbc9b28241; });
$parcel$export(module.exports, "Timers", function () { return $5d94d44af878f799$export$8bb2c1fb2b1765a9; });
let $5d94d44af878f799$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $5d94d44af878f799$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("2ktfL", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", function () { return $1b2424204798372b$export$8433d54f767cbec5; });

var $82897 = parcelRequire("82897");
const $1b2424204798372b$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $82897.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $82897.LocalStorageKeySuffix).ACK}`,
        [(0, $82897.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $82897.LocalStorageKeySuffix).QUEUE}`,
        [(0, $82897.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $82897.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $82897.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $82897.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $82897.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $82897.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("kpQoD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edcec9493d8f6ddb$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $l3ahi = parcelRequire("l3ahi");

var $82897 = parcelRequire("82897");

var $2ktfL = parcelRequire("2ktfL");
function $edcec9493d8f6ddb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $edcec9493d8f6ddb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $edcec9493d8f6ddb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $edcec9493d8f6ddb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $edcec9493d8f6ddb$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $edcec9493d8f6ddb$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $82897.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $82897.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $edcec9493d8f6ddb$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $edcec9493d8f6ddb$var$promisedSetTimeout((0, $82897.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $82897.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $edcec9493d8f6ddb$var$promisedSetTimeout((0, $82897.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $82897.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $edcec9493d8f6ddb$var$reclaim(options, callback);
};
const $edcec9493d8f6ddb$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $edcec9493d8f6ddb$var$_objectSpread($edcec9493d8f6ddb$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $edcec9493d8f6ddb$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $edcec9493d8f6ddb$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $edcec9493d8f6ddb$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $edcec9493d8f6ddb$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($l3ahi)))();
    const queuesToReclaim = $edcec9493d8f6ddb$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$edcec9493d8f6ddb$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $2ktfL.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("kKwNi", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", function () { return $f1b18abadf1fbe34$export$a409c8de90e11e14; });
$parcel$export(module.exports, "default", function () { return $f1b18abadf1fbe34$export$2e2bcd8739ae039; });
const $f1b18abadf1fbe34$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $f1b18abadf1fbe34$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $f1b18abadf1fbe34$export$2e2bcd8739ae039.prototype);
        this.name = $f1b18abadf1fbe34$export$a409c8de90e11e14;
    }
}

});

parcelRegister("dT9RQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1c810e25c3b6471$export$2e2bcd8739ae039; });

var $eLe7M = parcelRequire("eLe7M");

var $7huu1 = parcelRequire("7huu1");

var $kKwNi = parcelRequire("kKwNi");
var $a1c810e25c3b6471$export$2e2bcd8739ae039 = (0, $eLe7M.default);

});
parcelRegister("eLe7M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abf0694b264f5890$export$2e2bcd8739ae039; });

var $7huu1 = parcelRequire("7huu1");

var $a00x8 = parcelRequire("a00x8");
var $h65W6 = parcelRequire("h65W6");

var $kVHNj = parcelRequire("kVHNj");

var $90igo = parcelRequire("90igo");

var $dcry0 = parcelRequire("dcry0");
class $abf0694b264f5890$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $dcry0.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $kVHNj.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $a00x8.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
        }
        return new (0, $90igo.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $7huu1.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $7huu1.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $h65W6.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $7huu1.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $90igo.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $7huu1.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("7huu1", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", function () { return $54d1c4492cdcf72b$export$d21fbb25eb37b5bf; });
$parcel$export(module.exports, "RESILIENCE_DB_NAME", function () { return $54d1c4492cdcf72b$export$8cad224051643259; });
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", function () { return $54d1c4492cdcf72b$export$3d8420be07b276ab; });
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", function () { return $54d1c4492cdcf72b$export$a512a65455fce2a6; });
$parcel$export(module.exports, "TIME_ADDED_INDEX", function () { return $54d1c4492cdcf72b$export$89d9c1ff8ac91862; });
$parcel$export(module.exports, "RETRY_INDEX", function () { return $54d1c4492cdcf72b$export$a37d385bcd713809; });
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", function () { return $54d1c4492cdcf72b$export$6d8635fed0e4b14d; });
$parcel$export(module.exports, "StoreType", function () { return $54d1c4492cdcf72b$export$39337ab5872e9457; });
$parcel$export(module.exports, "GuardPolicy", function () { return $54d1c4492cdcf72b$export$7710d69e6f450f20; });
const $54d1c4492cdcf72b$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $54d1c4492cdcf72b$export$8cad224051643259 = 'analytics-web-client';
const $54d1c4492cdcf72b$export$3d8420be07b276ab = 'analytics-resilience';
const $54d1c4492cdcf72b$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $54d1c4492cdcf72b$export$89d9c1ff8ac91862 = 'timeAdded';
const $54d1c4492cdcf72b$export$a37d385bcd713809 = 'retryAttempts';
const $54d1c4492cdcf72b$export$6d8635fed0e4b14d = 15000;
let $54d1c4492cdcf72b$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $54d1c4492cdcf72b$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("a00x8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $747a516189849ee7$export$2e2bcd8739ae039; });
const $747a516189849ee7$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $747a516189849ee7$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $747a516189849ee7$export$2e2bcd8739ae039.prototype);
        this.name = $747a516189849ee7$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("h65W6", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", function () { return $c7279a053eefe8b3$export$74101021e0969375; });

var $kEiwW = parcelRequire("kEiwW");

var $kKwNi = parcelRequire("kKwNi");

var $hFbEn = parcelRequire("hFbEn");
const $c7279a053eefe8b3$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $kEiwW.AbandonWriteErrorName) || errorWithName.name === (0, $kKwNi.CallbackProcessingErrorName) || errorWithName.name === (0, $hFbEn.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("kEiwW", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", function () { return $f085eace77055fc3$export$ba95206613c96b28; });
$parcel$export(module.exports, "default", function () { return $f085eace77055fc3$export$2e2bcd8739ae039; });
const $f085eace77055fc3$export$ba95206613c96b28 = 'AbandonWriteError';
class $f085eace77055fc3$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $f085eace77055fc3$export$2e2bcd8739ae039.prototype);
        this.name = $f085eace77055fc3$export$ba95206613c96b28;
    }
}

});

parcelRegister("hFbEn", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", function () { return $cdbf4d7f034972a4$export$7e7aee9a953465ec; });
$parcel$export(module.exports, "default", function () { return $cdbf4d7f034972a4$export$2e2bcd8739ae039; });
const $cdbf4d7f034972a4$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $cdbf4d7f034972a4$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $cdbf4d7f034972a4$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("kVHNj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3cb1a2755a5aeb8$export$2e2bcd8739ae039; });

var $bM2vx = parcelRequire("bM2vx");

var $91FVG = parcelRequire("91FVG");

var $7huu1 = parcelRequire("7huu1");

var $huKiZ = parcelRequire("huKiZ");

var $kKwNi = parcelRequire("kKwNi");
var $hFbEn = parcelRequire("hFbEn");
var $a00x8 = parcelRequire("a00x8");
var $h65W6 = parcelRequire("h65W6");

var $5Zxcn = parcelRequire("5Zxcn");

var $dcry0 = parcelRequire("dcry0");
const $f3cb1a2755a5aeb8$var$_excluded = [
    "item"
], $f3cb1a2755a5aeb8$var$_excluded2 = [
    "items"
];
function $f3cb1a2755a5aeb8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f3cb1a2755a5aeb8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f3cb1a2755a5aeb8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f3cb1a2755a5aeb8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $f3cb1a2755a5aeb8$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $a00x8.default)());
                    }, (0, $7huu1.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $7huu1.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $7huu1.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $7huu1.TIME_TO_PROCESS_AFTER_INDEX), (0, $7huu1.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $7huu1.RETRY_INDEX), (0, $7huu1.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $7huu1.TIME_ADDED_INDEX), (0, $7huu1.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $7huu1.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $a00x8.default)());
                    };
                    try {
                        await (0, $dcry0.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $a00x8.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $a00x8.default)());
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "addItem", async (item, options = {}, policy = (0, $7huu1.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $dcry0.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $7huu1.GuardPolicy).IGNORE) throw new (0, $hFbEn.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $h65W6.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "bulkAddItem", async (itemOptions, policy = (0, $7huu1.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $f3cb1a2755a5aeb8$var$_excluded);
                return (0, $dcry0.convertToItemWrapper)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $h65W6.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getItems", async (count = (0, $huKiZ.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $huKiZ.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $7huu1.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $f3cb1a2755a5aeb8$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $huKiZ.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $dcry0.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $dcry0.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $dcry0.commitTransaction)(transaction, this.logger);
            return getResult;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $dcry0.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $7huu1.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $dcry0.requestToPromise)(request);
            await (0, $dcry0.commitTransaction)(transaction, this.logger);
            return event.target.result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "processItems", async (processFn, count = (0, $huKiZ.GET_ITEM_COUNT))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_await$this$getItems, $f3cb1a2755a5aeb8$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $kKwNi.default)(error);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $dcry0.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $7huu1.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $7huu1.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $dcry0.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $a00x8.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $5Zxcn.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $7huu1.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("huKiZ", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", function () { return $cbc928444ce9d770$export$b6df3d334cec060f; });
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", function () { return $cbc928444ce9d770$export$14ef152a03a4b6ee; });
$parcel$export(module.exports, "MAX_ATTEMPTS", function () { return $cbc928444ce9d770$export$da9ab7b2fd5998e8; });
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", function () { return $cbc928444ce9d770$export$1188664dfff364c8; });
const $cbc928444ce9d770$export$b6df3d334cec060f = 7;
const $cbc928444ce9d770$export$14ef152a03a4b6ee = 60000;
const $cbc928444ce9d770$export$da9ab7b2fd5998e8 = 10;
const $cbc928444ce9d770$export$1188664dfff364c8 = 5000;

});

parcelRegister("5Zxcn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45cc66cd8f5a0bdf$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $7huu1 = parcelRequire("7huu1");

var $kEiwW = parcelRequire("kEiwW");

var $dcry0 = parcelRequire("dcry0");
class $45cc66cd8f5a0bdf$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $7huu1.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $dcry0.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $7huu1.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $7huu1.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $7huu1.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $7huu1.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $dcry0.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $dcry0.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $kEiwW.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $7huu1.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $dcry0.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("dcry0", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", function () { return $99c1c3b3807b063b$export$aec476f33d77be11; });
$parcel$export(module.exports, "createOptionsWithDefaults", function () { return $99c1c3b3807b063b$export$ddc6718318090f71; });
$parcel$export(module.exports, "requestToPromise", function () { return $99c1c3b3807b063b$export$85ceed0783e42041; });
$parcel$export(module.exports, "commitTransaction", function () { return $99c1c3b3807b063b$export$feab8418f018df89; });
$parcel$export(module.exports, "monitorErrorsOnRequest", function () { return $99c1c3b3807b063b$export$342d941b6f724995; });

var $l3ahi = parcelRequire("l3ahi");

var $huKiZ = parcelRequire("huKiZ");
const $99c1c3b3807b063b$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($l3ahi)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $99c1c3b3807b063b$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $huKiZ.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $huKiZ.EVENT_COUNT_LIMIT)
    });
const $99c1c3b3807b063b$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $99c1c3b3807b063b$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $99c1c3b3807b063b$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $99c1c3b3807b063b$export$2a5213bce1720b42(transaction);
};
const $99c1c3b3807b063b$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("90igo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68e247df40ee4736$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $bM2vx = parcelRequire("bM2vx");

var $7huu1 = parcelRequire("7huu1");

var $huKiZ = parcelRequire("huKiZ");

var $kKwNi = parcelRequire("kKwNi");
var $hFbEn = parcelRequire("hFbEn");

var $h6R20 = parcelRequire("h6R20");

var $dcry0 = parcelRequire("dcry0");
const $68e247df40ee4736$var$_excluded = [
    "item"
], $68e247df40ee4736$var$_excluded2 = [
    "items"
];
function $68e247df40ee4736$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68e247df40ee4736$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68e247df40ee4736$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68e247df40ee4736$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $68e247df40ee4736$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $dcry0.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $h6R20.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $7huu1.GuardPolicy).ABANDON) {
        if (policy === (0, $7huu1.GuardPolicy).IGNORE) throw new (0, $hFbEn.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $dcry0.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $7huu1.GuardPolicy).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $68e247df40ee4736$var$_excluded);
            return (0, $dcry0.convertToItemWrapper)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $7huu1.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $huKiZ.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $huKiZ.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $huKiZ.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($68e247df40ee4736$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $huKiZ.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_this$synchronousGetI, $68e247df40ee4736$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $kKwNi.default)(error);
        }
    }
    storeType() {
        return (0, $7huu1.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("h6R20", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c74c221a49e3c073$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $7huu1 = parcelRequire("7huu1");

var $kEiwW = parcelRequire("kEiwW");
class $c74c221a49e3c073$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $7huu1.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $7huu1.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $7huu1.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $kEiwW.default)((0, $7huu1.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("hOBfw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf840025e161d6e0$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $hPCpN = parcelRequire("hPCpN");
class $cf840025e161d6e0$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "resilienceMechanism", (0, $hPCpN.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}
let $cf840025e161d6e0$var$cachedMetricsClient = null;
var $cf840025e161d6e0$export$2e2bcd8739ae039 = ()=>{
    if (!$cf840025e161d6e0$var$cachedMetricsClient) $cf840025e161d6e0$var$cachedMetricsClient = new $cf840025e161d6e0$export$4b62ee5120ab50a8();
    return $cf840025e161d6e0$var$cachedMetricsClient;
};

});
parcelRegister("hPCpN", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", function () { return $cfb4ff811de3e762$export$c75161629e3ec34e; });
$parcel$export(module.exports, "NetworkStatusEnum", function () { return $cfb4ff811de3e762$export$ee138fa712d11b84; });
let $cfb4ff811de3e762$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $cfb4ff811de3e762$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("4s5qf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33ddfbbcf3ea19db$export$2e2bcd8739ae039; });

var $hPCpN = parcelRequire("hPCpN");
class $33ddfbbcf3ea19db$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>networkChangeCallback((0, $hPCpN.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>networkChangeCallback((0, $hPCpN.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $hPCpN.NetworkStatusEnum).ONLINE;
        return (0, $hPCpN.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("j6h2q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de7bcb4a5f0ae799$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $eP3tW = parcelRequire("eP3tW");

var $6te8u = parcelRequire("6te8u");
const $de7bcb4a5f0ae799$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $de7bcb4a5f0ae799$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $de7bcb4a5f0ae799$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "schedule", ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $de7bcb4a5f0ae799$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $de7bcb4a5f0ae799$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $de7bcb4a5f0ae799$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $de7bcb4a5f0ae799$export$8bb92baee001fc60.NONE;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getFailureCount", ()=>this.failureCount);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "clearTimeout", ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $6te8u.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $6te8u.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $eP3tW.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $6te8u.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $de7bcb4a5f0ae799$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $de7bcb4a5f0ae799$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $de7bcb4a5f0ae799$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $de7bcb4a5f0ae799$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $de7bcb4a5f0ae799$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $de7bcb4a5f0ae799$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $de7bcb4a5f0ae799$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $de7bcb4a5f0ae799$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $de7bcb4a5f0ae799$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $de7bcb4a5f0ae799$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $eP3tW.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("eP3tW", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", function () { return $aca8878bf51d0778$export$ef3353088fca369c; });
$parcel$export(module.exports, "CallbackWithTimeout", function () { return $aca8878bf51d0778$export$590a718599f8f8b3; });

var $91FVG = parcelRequire("91FVG");
let $aca8878bf51d0778$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $aca8878bf51d0778$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $aca8878bf51d0778$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "callbackStatus", $aca8878bf51d0778$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $aca8878bf51d0778$export$ef3353088fca369c.IDLE:
            case $aca8878bf51d0778$export$ef3353088fca369c.TIMED_OUT:
            case $aca8878bf51d0778$export$ef3353088fca369c.COMPLETED:
                if (event === $aca8878bf51d0778$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $aca8878bf51d0778$export$ef3353088fca369c.RUNNING;
                break;
            case $aca8878bf51d0778$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $aca8878bf51d0778$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $aca8878bf51d0778$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $aca8878bf51d0778$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $aca8878bf51d0778$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, $aca8878bf51d0778$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $aca8878bf51d0778$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $aca8878bf51d0778$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $aca8878bf51d0778$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("6te8u", function(module, exports) {

$parcel$export(module.exports, "DoneState", function () { return $4b606aa008d6018d$export$f93c40fda808dd0c; });
// Clients can optionally provide the callbackTimeoutPeriod parameter
let $4b606aa008d6018d$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("1GphQ", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", function () { return $139d5424216069f1$export$c21270cab66ab290; });

var $91FVG = parcelRequire("91FVG");

var $ldxtO = parcelRequire("ldxtO");
function $139d5424216069f1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $139d5424216069f1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $139d5424216069f1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $139d5424216069f1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $139d5424216069f1$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $ldxtO.SegmentEventTypes).PAGE || item.msg.type === (0, $ldxtO.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $139d5424216069f1$var$_objectSpread($139d5424216069f1$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $ldxtO.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $139d5424216069f1$var$_objectSpread($139d5424216069f1$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $139d5424216069f1$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$139d5424216069f1$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("ldxtO", function(module, exports) {

$parcel$export(module.exports, "SegmentEventTypes", function () { return $f724c8446be50ae0$export$ddf929981dc6feb3; });
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
let $f724c8446be50ae0$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $f724c8446be50ae0$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $f724c8446be50ae0$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});

});


parcelRegister("963uz", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", function () { return $69f762065787561e$export$9175ce0e1c95daf2; });
const $69f762065787561e$export$9175ce0e1c95daf2 = 10000; // 10 seconds

});

parcelRegister("gP9Py", function(module, exports) {

$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", function () { return $c3f908e9c5180dce$export$ba118f9de1e5ac63; });
const $c3f908e9c5180dce$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("eBqkD", function(module, exports) {

$parcel$export(module.exports, "sendEvents", function () { return $aa18f2525a8f8048$export$8e8f0180c1b41fad; });

var $91FVG = parcelRequire("91FVG");

var $92vrF = parcelRequire("92vrF");
function $aa18f2525a8f8048$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aa18f2525a8f8048$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aa18f2525a8f8048$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aa18f2525a8f8048$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $aa18f2525a8f8048$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $aa18f2525a8f8048$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $aa18f2525a8f8048$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $aa18f2525a8f8048$var$_objectSpread({
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $aa18f2525a8f8048$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $aa18f2525a8f8048$var$getCorsForUrl = (0, $92vrF.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("92vrF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $694cb15982c76b67$export$2e2bcd8739ae039; });
var $694cb15982c76b67$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $694cb15982c76b67$var$isEqual(first, second) {
    if (first === second) return true;
    if ($694cb15982c76b67$var$safeIsNaN(first) && $694cb15982c76b67$var$safeIsNaN(second)) return true;
    return false;
}
function $694cb15982c76b67$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$694cb15982c76b67$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $694cb15982c76b67$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $694cb15982c76b67$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("1H6rb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13beccf49aebb939$export$2e2bcd8739ae039; });

var $agWUt = parcelRequire("agWUt");

var $l3ahi = parcelRequire("l3ahi");

var $dPQ0y = parcelRequire("dPQ0y");
var $fJhoG = parcelRequire("fJhoG");

var $2ymUt = parcelRequire("2ymUt");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $13beccf49aebb939$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $13beccf49aebb939$var$SAFE = 'SAFE';
const $13beccf49aebb939$var$UNSAFE = 'UNSAFE';
const $13beccf49aebb939$var$NOT_FOUND = 'NOT_FOUND';
const $13beccf49aebb939$var$COOKIE = 'COOKIE';
const $13beccf49aebb939$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $13beccf49aebb939$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $2ymUt.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $fJhoG.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $dPQ0y.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $dPQ0y.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $13beccf49aebb939$var$LOCAL_STORAGE ? this.store.getItem((0, $dPQ0y.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $dPQ0y.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $13beccf49aebb939$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $13beccf49aebb939$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $13beccf49aebb939$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($13beccf49aebb939$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $agWUt.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $13beccf49aebb939$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $13beccf49aebb939$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $13beccf49aebb939$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $13beccf49aebb939$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($13beccf49aebb939$var$COOKIE);
        switch(cookieValue.type){
            case $13beccf49aebb939$var$SAFE:
            case $13beccf49aebb939$var$UNSAFE:
                this.store.setItem((0, $dPQ0y.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $13beccf49aebb939$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($l3ahi)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("agWUt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77a9184a109a1b63$export$2e2bcd8739ae039; });

var $8kDQ6 = parcelRequire("8kDQ6");

var $hrZnB = parcelRequire("hrZnB");

var $58XrX = parcelRequire("58XrX");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $77a9184a109a1b63$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $77a9184a109a1b63$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $58XrX.default)(2, arguments);
    var dateLeft = (0, $8kDQ6.default)(dirtyDateLeft);
    var dateRight = (0, $8kDQ6.default)(dirtyDateRight);
    var sign = $77a9184a109a1b63$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $hrZnB.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($77a9184a109a1b63$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("8kDQ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $610f183f798c949b$export$2e2bcd8739ae039; });

var $4PLSn = parcelRequire("4PLSn");

var $58XrX = parcelRequire("58XrX");
function $610f183f798c949b$export$2e2bcd8739ae039(argument) {
    (0, $58XrX.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $4PLSn.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("4PLSn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $385110042b218c0c$export$2e2bcd8739ae039; });
function $385110042b218c0c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $385110042b218c0c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $385110042b218c0c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("58XrX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bebd0a16d89c6e7$export$2e2bcd8739ae039; });
function $3bebd0a16d89c6e7$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("hrZnB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb4491fd2617a000$export$2e2bcd8739ae039; });

var $21cU6 = parcelRequire("21cU6");

var $7lJw2 = parcelRequire("7lJw2");

var $58XrX = parcelRequire("58XrX");
var $cb4491fd2617a000$var$MILLISECONDS_IN_DAY = 86400000;
function $cb4491fd2617a000$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $58XrX.default)(2, arguments);
    var startOfDayLeft = (0, $7lJw2.default)(dirtyDateLeft);
    var startOfDayRight = (0, $7lJw2.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $21cU6.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $21cU6.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $cb4491fd2617a000$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("21cU6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1785af3a6971d9eb$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $1785af3a6971d9eb$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("7lJw2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $559dcd0c6aa37cbc$export$2e2bcd8739ae039; });

var $8kDQ6 = parcelRequire("8kDQ6");

var $58XrX = parcelRequire("58XrX");
function $559dcd0c6aa37cbc$export$2e2bcd8739ae039(dirtyDate) {
    (0, $58XrX.default)(1, arguments);
    var date = (0, $8kDQ6.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("dPQ0y", function(module, exports) {

$parcel$export(module.exports, "AWCCookiesKeys", function () { return $a12861753ba2df51$export$202d555a5dbfd90c; });
$parcel$export(module.exports, "AllAnalyticsCookies", function () { return $a12861753ba2df51$export$d4cb17942ea57c95; });
let $a12861753ba2df51$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $a12861753ba2df51$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $a12861753ba2df51$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $a12861753ba2df51$export$d4cb17942ea57c95 = {
    [$a12861753ba2df51$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $a12861753ba2df51$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $a12861753ba2df51$var$isSecure(),
        path: '/'
    }),
    [$a12861753ba2df51$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $a12861753ba2df51$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $a12861753ba2df51$var$isSecure(),
        path: '/'
    }),
    [$a12861753ba2df51$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $a12861753ba2df51$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $a12861753ba2df51$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("fJhoG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7388db3c9602a07$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $aEip0 = parcelRequire("aEip0");

var $dPQ0y = parcelRequire("dPQ0y");

var $jdKvW = parcelRequire("jdKvW");

var $l0qwM = parcelRequire("l0qwM");
function $b7388db3c9602a07$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b7388db3c9602a07$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b7388db3c9602a07$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b7388db3c9602a07$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $b7388db3c9602a07$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $l0qwM.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($aEip0))) : new (0, $jdKvW.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $dPQ0y.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $dPQ0y.AllAnalyticsCookies)[name].getKey(), value, $b7388db3c9602a07$var$_objectSpread($b7388db3c9602a07$var$_objectSpread({}, (0, $dPQ0y.AllAnalyticsCookies)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $l0qwM.getTld)()
        }, options));
    }
    get(name) {
        if (!(0, $dPQ0y.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $dPQ0y.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $dPQ0y.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $dPQ0y.AllAnalyticsCookies)[name].getKey(), $b7388db3c9602a07$var$_objectSpread({}, options));
    }
}

});
parcelRegister("aEip0", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("jdKvW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfe34ff92d522506$export$2e2bcd8739ae039; });

var $2ymUt = parcelRequire("2ymUt");
class $dfe34ff92d522506$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $2ymUt.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("2ymUt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dc08725dc9db33b$export$2e2bcd8739ae039; });

var $9dZbC = parcelRequire("9dZbC");

var $7C9n4 = parcelRequire("7C9n4");
class $1dc08725dc9db33b$export$2e2bcd8739ae039 extends (0, $7C9n4.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $9dZbC.default);
        } catch (err) {
            storageToUse = (0, $9dZbC.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("9dZbC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b74ca4ee8ea9559$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");
class $6b74ca4ee8ea9559$export$90e3e001bcac59c7 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_data", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "length", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$6b74ca4ee8ea9559$export$2e2bcd8739ae039 = new $6b74ca4ee8ea9559$export$90e3e001bcac59c7();

});

parcelRegister("7C9n4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58b359f03b0cb67b$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $5mr0m = parcelRequire("5mr0m");

var $9dZbC = parcelRequire("9dZbC");
const $58b359f03b0cb67b$export$41c06fdd37b7e9a5 = 'awc';
const $58b359f03b0cb67b$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $58b359f03b0cb67b$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $58b359f03b0cb67b$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $58b359f03b0cb67b$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getStore", ()=>this._store);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($58b359f03b0cb67b$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "swapToInMemory", ()=>{
            if (this._store === (0, $9dZbC.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($58b359f03b0cb67b$export$48c17662a6902497(window[$58b359f03b0cb67b$export$770aa8bc07b3de03])) inMemoryStorage = window[$58b359f03b0cb67b$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $9dZbC.default);
                if (!window[$58b359f03b0cb67b$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$58b359f03b0cb67b$export$770aa8bc07b3de03] = (0, $9dZbC.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "clear", ()=>this._store.clear());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "key", (index)=>this._store.key(index));
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getPrefix", ()=>this._prefix);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($58b359f03b0cb67b$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $5mr0m.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($58b359f03b0cb67b$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("l0qwM", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", function () { return $f4ae2ce576330a3f$export$a9330601ee8f4d95; });
$parcel$export(module.exports, "getTld", function () { return $f4ae2ce576330a3f$export$de6821eed3d5f32d; });

var $aEip0 = parcelRequire("aEip0");

var $92vrF = parcelRequire("92vrF");

var $dPQ0y = parcelRequire("dPQ0y");
const $f4ae2ce576330a3f$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $f4ae2ce576330a3f$export$eb80e1beaa8dacf8 = (0, $dPQ0y.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $f4ae2ce576330a3f$export$19164982d36535d8 = 'tld_test';
const $f4ae2ce576330a3f$export$de6821eed3d5f32d = (0, $92vrF.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($aEip0))).set($f4ae2ce576330a3f$export$eb80e1beaa8dacf8, $f4ae2ce576330a3f$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($aEip0))).get($f4ae2ce576330a3f$export$eb80e1beaa8dacf8) === $f4ae2ce576330a3f$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($aEip0))).remove($f4ae2ce576330a3f$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("f6sCE", function(module, exports) {

$parcel$export(module.exports, "buildContext", function () { return $afed9e59b412a1b4$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "prepareEventProperties", function () { return $afed9e59b412a1b4$export$44d22e5fb02cc68e; });

var $91FVG = parcelRequire("91FVG");

var $cj6Yu = parcelRequire("cj6Yu");
function $afed9e59b412a1b4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $afed9e59b412a1b4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $afed9e59b412a1b4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $afed9e59b412a1b4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $afed9e59b412a1b4$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $afed9e59b412a1b4$var$_objectSpread($afed9e59b412a1b4$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $afed9e59b412a1b4$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $afed9e59b412a1b4$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cj6Yu)))(propertiesWithoutUndefined);
};
const $afed9e59b412a1b4$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== 'object') return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $afed9e59b412a1b4$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$afed9e59b412a1b4$export$2250ccecd1e040fd(i));
            else if (typeof value === 'object' && value !== null) clone[key] = $afed9e59b412a1b4$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $afed9e59b412a1b4$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};

});
parcelRegister("cj6Yu", function(module, exports) {
'use strict';

var $gsPW7 = parcelRequire("gsPW7");
/**
 * Expose `traverse`.
 */ module.exports = $8f5cab686783489c$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $8f5cab686783489c$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $8f5cab686783489c$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $8f5cab686783489c$var$traverseArray(input, strict);
    else if ($gsPW7.is(input, strict)) return $gsPW7.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $8f5cab686783489c$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $8f5cab686783489c$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $8f5cab686783489c$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $8f5cab686783489c$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("gsPW7", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $bfc78c5d48a36331$export$98e6a39c04603d36; }, function (v) { return $bfc78c5d48a36331$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "is", function () { return $bfc78c5d48a36331$export$226b3eccf92c9ed9; }, function (v) { return $bfc78c5d48a36331$export$226b3eccf92c9ed9 = v; });
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $bfc78c5d48a36331$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $bfc78c5d48a36331$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $bfc78c5d48a36331$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$bfc78c5d48a36331$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $bfc78c5d48a36331$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$bfc78c5d48a36331$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $bfc78c5d48a36331$var$matcher.test(string);
};

});




parcelRegister("9EEYq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7077a20020816a78$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $5mr0m = parcelRequire("5mr0m");

var $j0YI2 = parcelRequire("j0YI2");
class $7077a20020816a78$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $5mr0m.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $j0YI2.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}

});
parcelRegister("j0YI2", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", function () { return $dd7d1bff470a2233$export$600dd5bf1b049f11; });
$parcel$export(module.exports, "default", function () { return $dd7d1bff470a2233$export$2e2bcd8739ae039; });

var $9ISSh = parcelRequire("9ISSh");

var $jg3rL = parcelRequire("jg3rL");
const $dd7d1bff470a2233$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $dd7d1bff470a2233$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $dd7d1bff470a2233$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $9ISSh.parseUrl)(removedFragmentURL);
    const captureParams = (0, $jg3rL.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $jg3rL.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $9ISSh.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $dd7d1bff470a2233$export$2e2bcd8739ae039 = $dd7d1bff470a2233$var$urlParamExtractor;

});
parcelRegister("9ISSh", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $7142ca0b4618a479$export$f9380c9a627682d3; }, function (v) { return $7142ca0b4618a479$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $7142ca0b4618a479$export$98e6a39c04603d36; }, function (v) { return $7142ca0b4618a479$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $7142ca0b4618a479$export$fac44ee5b035f737; }, function (v) { return $7142ca0b4618a479$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $7142ca0b4618a479$export$7a5253c0f62e0150; }, function (v) { return $7142ca0b4618a479$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $7142ca0b4618a479$export$a8c1621ea79325d3; }, function (v) { return $7142ca0b4618a479$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $7142ca0b4618a479$export$357523c63a2253b9; }, function (v) { return $7142ca0b4618a479$export$357523c63a2253b9 = v; });
var $7142ca0b4618a479$export$f9380c9a627682d3;
var $7142ca0b4618a479$export$98e6a39c04603d36;
var $7142ca0b4618a479$export$fac44ee5b035f737;
var $7142ca0b4618a479$export$7a5253c0f62e0150;
var $7142ca0b4618a479$export$a8c1621ea79325d3;
var $7142ca0b4618a479$export$357523c63a2253b9;
var $7142ca0b4618a479$export$44c361b8ec72ef7f;
'use strict';

var $5lF1i = parcelRequire("5lF1i");

var $8HHgV = parcelRequire("8HHgV");

var $4hUZM = parcelRequire("4hUZM");

var $womgM = parcelRequire("womgM");
const $7142ca0b4618a479$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $7142ca0b4618a479$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $7142ca0b4618a479$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $7142ca0b4618a479$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $7142ca0b4618a479$var$encode(key, options),
                            '[',
                            $7142ca0b4618a479$var$encode(index, options),
                            ']=',
                            $7142ca0b4618a479$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $7142ca0b4618a479$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $7142ca0b4618a479$var$encode(key, options),
                            '[]=',
                            $7142ca0b4618a479$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $7142ca0b4618a479$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $7142ca0b4618a479$var$encode(key, options),
                            ':list=',
                            $7142ca0b4618a479$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $7142ca0b4618a479$var$encode(key, options),
                                keyValueSep,
                                $7142ca0b4618a479$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $7142ca0b4618a479$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $7142ca0b4618a479$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $7142ca0b4618a479$var$encode(key, options),
                            '=',
                            $7142ca0b4618a479$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $7142ca0b4618a479$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $7142ca0b4618a479$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $7142ca0b4618a479$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$7142ca0b4618a479$var$decode(item, options)) : value === null ? value : $7142ca0b4618a479$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $7142ca0b4618a479$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$7142ca0b4618a479$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $7142ca0b4618a479$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $7142ca0b4618a479$var$encode(value, options) {
    if (options.encode) return options.strict ? $5lF1i(value) : encodeURIComponent(value);
    return value;
}
function $7142ca0b4618a479$var$decode(value, options) {
    if (options.decode) return $8HHgV(value);
    return value;
}
function $7142ca0b4618a479$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $7142ca0b4618a479$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $7142ca0b4618a479$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $7142ca0b4618a479$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $7142ca0b4618a479$var$extract(input) {
    input = $7142ca0b4618a479$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $7142ca0b4618a479$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $7142ca0b4618a479$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $7142ca0b4618a479$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $7142ca0b4618a479$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $4hUZM(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $7142ca0b4618a479$var$decode(value, options);
        formatter($7142ca0b4618a479$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $7142ca0b4618a479$var$parseValue(value[k], options);
        else ret[key] = $7142ca0b4618a479$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $7142ca0b4618a479$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$7142ca0b4618a479$export$f9380c9a627682d3 = $7142ca0b4618a479$var$extract;
$7142ca0b4618a479$export$98e6a39c04603d36 = $7142ca0b4618a479$var$parse;
$7142ca0b4618a479$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $7142ca0b4618a479$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $7142ca0b4618a479$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $7142ca0b4618a479$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $7142ca0b4618a479$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $7142ca0b4618a479$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $7142ca0b4618a479$var$encode(key, options) + '=' + $7142ca0b4618a479$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$7142ca0b4618a479$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $4hUZM(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $7142ca0b4618a479$var$parse($7142ca0b4618a479$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $7142ca0b4618a479$var$decode(hash, options)
    } : {});
};
$7142ca0b4618a479$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$7142ca0b4618a479$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $7142ca0b4618a479$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $7142ca0b4618a479$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $7142ca0b4618a479$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $7142ca0b4618a479$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $7142ca0b4618a479$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$7142ca0b4618a479$var$encodeFragmentIdentifier] ? $7142ca0b4618a479$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$7142ca0b4618a479$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$7142ca0b4618a479$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $7142ca0b4618a479$export$7a5253c0f62e0150(input, options);
    return $7142ca0b4618a479$export$a8c1621ea79325d3({
        url: url,
        query: $womgM(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$7142ca0b4618a479$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $7142ca0b4618a479$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("5lF1i", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("8HHgV", function(module, exports) {
'use strict';
var $6563e7ca22b946e6$var$token = '%[a-f0-9]{2}';
var $6563e7ca22b946e6$var$singleMatcher = new RegExp('(' + $6563e7ca22b946e6$var$token + ')|([^%]+?)', 'gi');
var $6563e7ca22b946e6$var$multiMatcher = new RegExp('(' + $6563e7ca22b946e6$var$token + ')+', 'gi');
function $6563e7ca22b946e6$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $6563e7ca22b946e6$var$decodeComponents(left), $6563e7ca22b946e6$var$decodeComponents(right));
}
function $6563e7ca22b946e6$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($6563e7ca22b946e6$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $6563e7ca22b946e6$var$decodeComponents(tokens, i).join('');
            tokens = input.match($6563e7ca22b946e6$var$singleMatcher) || [];
        }
        return input;
    }
}
function $6563e7ca22b946e6$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $6563e7ca22b946e6$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $6563e7ca22b946e6$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $6563e7ca22b946e6$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $6563e7ca22b946e6$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("4hUZM", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("womgM", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});




parcelRegister("7V8tZ", function(module, exports) {

$parcel$export(module.exports, "selectHost", function () { return $5c446fc14c43290a$export$18c0b81944902eae; });

var $5mr0m = parcelRequire("5mr0m");
const $5c446fc14c43290a$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $5c446fc14c43290a$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $5c446fc14c43290a$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $5c446fc14c43290a$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $5c446fc14c43290a$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $5c446fc14c43290a$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $5c446fc14c43290a$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $5c446fc14c43290a$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $5c446fc14c43290a$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $5c446fc14c43290a$var$handleFedRampStagingDirect = ()=>{
    return $5c446fc14c43290a$var$FEDRAMP_STAGING_HOST;
};
const $5c446fc14c43290a$var$handleFedRampStagingStargate = ()=>{
    return $5c446fc14c43290a$var$STARGATE_FEDRAMP_STAGING_HOST;
};
const $5c446fc14c43290a$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $5mr0m.envType).LOCAL || env === (0, $5mr0m.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $5mr0m.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $5mr0m.envType).PROD ? $5c446fc14c43290a$var$FEDRAMP_PROD_HOST : $5c446fc14c43290a$var$handleFedRampStagingDirect();
    if (useLegacyUrl) return env === (0, $5mr0m.envType).PROD ? $5c446fc14c43290a$var$STARGATE_FEDRAMP_PROD_HOST : $5c446fc14c43290a$var$handleFedRampStagingStargate();
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $5c446fc14c43290a$var$STARGATE_PROXY_PATH;
};
const $5c446fc14c43290a$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $5mr0m.envType).PROD ? $5c446fc14c43290a$var$PROD_HOST : $5c446fc14c43290a$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $5mr0m.envType).PROD ? $5c446fc14c43290a$var$STARGATE_PROD_HOST : $5c446fc14c43290a$var$STARGATE_STAGING_HOST;
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $5c446fc14c43290a$var$STARGATE_PROXY_PATH;
};
function $5c446fc14c43290a$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
    if (perimeter === (0, $5mr0m.perimeterType).FEDRAMP_MODERATE) return $5c446fc14c43290a$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $5c446fc14c43290a$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});

parcelRegister("gbvon", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc86064183bd6efa$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $2ymUt = parcelRequire("2ymUt");
const $bc86064183bd6efa$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $bc86064183bd6efa$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $bc86064183bd6efa$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $bc86064183bd6efa$export$285f6bddd927a06d = 1800000; // 30 minutes
const $bc86064183bd6efa$export$a92e915d70316eb2 = 5000; // 5 seconds
const $bc86064183bd6efa$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $bc86064183bd6efa$export$5702a91a6f42969f = ()=>{};
class $bc86064183bd6efa$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($bc86064183bd6efa$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($bc86064183bd6efa$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $bc86064183bd6efa$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $bc86064183bd6efa$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $bc86064183bd6efa$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $bc86064183bd6efa$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $2ymUt.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($bc86064183bd6efa$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($bc86064183bd6efa$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$bc86064183bd6efa$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});

parcelRegister("8ye4T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $639c6b4e2801d918$export$2e2bcd8739ae039; });

var $9dZbC = parcelRequire("9dZbC");

var $7C9n4 = parcelRequire("7C9n4");
class $639c6b4e2801d918$export$2e2bcd8739ae039 extends (0, $7C9n4.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $9dZbC.default);
        } catch (err) {
            storageToUse = (0, $9dZbC.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("lizWL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f81729acd5efb4a3$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $l3ahi = parcelRequire("l3ahi");

var $8ye4T = parcelRequire("8ye4T");
const $f81729acd5efb4a3$var$STORAGE_KEY = 'tab.id';
class $f81729acd5efb4a3$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_generateNewTabId", ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($l3ahi)))();
            this._safeSessionStorage.setItem($f81729acd5efb4a3$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $8ye4T.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($f81729acd5efb4a3$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("3K6ly", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b9a974f857207fd$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $9ISSh = parcelRequire("9ISSh");

var $l3ahi = parcelRequire("l3ahi");

var $5mr0m = parcelRequire("5mr0m");

var $jg3rL = parcelRequire("jg3rL");

var $8ye4T = parcelRequire("8ye4T");

var $j0YI2 = parcelRequire("j0YI2");
function $2b9a974f857207fd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b9a974f857207fd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b9a974f857207fd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b9a974f857207fd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $2b9a974f857207fd$var$STORAGE_KEY = 'taskSessions';
const $2b9a974f857207fd$var$INIT_KEY = 'taskSessionsInit';
const $2b9a974f857207fd$var$AWC_PARAM_PREFIX = 'awc.';
const $2b9a974f857207fd$var$TASK_SESSION_RELOAD_TIME = 3000;
class $2b9a974f857207fd$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($2b9a974f857207fd$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($2b9a974f857207fd$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($2b9a974f857207fd$var$INIT_KEY) || '0', 10) < currentTimestamp - $2b9a974f857207fd$var$TASK_SESSION_RELOAD_TIME);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($2b9a974f857207fd$var$AWC_PARAM_PREFIX)[1]);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($2b9a974f857207fd$var$AWC_PARAM_PREFIX));
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($2b9a974f857207fd$var$STORAGE_KEY) || '');
            } catch (e) {
                return {};
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($2b9a974f857207fd$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($l3ahi)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $9ISSh.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $jg3rL.pick)(currentState, includedTaskSessions) : (0, $jg3rL.omit)(currentState, Object.values((0, $5mr0m.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $2b9a974f857207fd$var$_objectSpread($2b9a974f857207fd$var$_objectSpread({}, (0, $jg3rL.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$2b9a974f857207fd$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $9ISSh.stringify)(queryWithTaskSessions)}`;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $jg3rL.mapKeys)((0, $j0YI2.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $8ye4T.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($2b9a974f857207fd$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("lh6MU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7d0736b73e78e49$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $aEip0 = parcelRequire("aEip0");

var $dPQ0y = parcelRequire("dPQ0y");
const $f7d0736b73e78e49$var$MAX_CACHE_SIZE = 100;
const $f7d0736b73e78e49$var$COOKIE_NAME = (0, $dPQ0y.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $f7d0736b73e78e49$var$DEBUG_TAG = 'synthetic';
const $f7d0736b73e78e49$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($aEip0))).get($f7d0736b73e78e49$var$COOKIE_NAME) || 'false');
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($aEip0))).remove($f7d0736b73e78e49$var$COOKIE_NAME);
    }
    return false;
};
class $f7d0736b73e78e49$var$TestingCache {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_bind", ()=>{
            if (typeof window === 'undefined' || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem('awc.ui.viewed.last.sent');
                        localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                        localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                        localStorage.removeItem('awc-local.ui.viewed.last.sent');
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_cache", (event)=>{
            if (typeof window === 'undefined') return;
            if (window.testAnalytics.eventCache.length >= $f7d0736b73e78e49$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_shouldCacheEvent", ()=>this._isDebugCookieEnabled);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "saveEvent", (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($f7d0736b73e78e49$var$DEBUG_TAG);
                else event.tags = [
                    $f7d0736b73e78e49$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        });
        this._isDebugCookieEnabled = $f7d0736b73e78e49$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $f7d0736b73e78e49$export$2e2bcd8739ae039 = $f7d0736b73e78e49$var$TestingCache;

});

parcelRegister("j04Ve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd51d5d3750e86dc$export$2e2bcd8739ae039; });

var $bM2vx = parcelRequire("bM2vx");

var $91FVG = parcelRequire("91FVG");

var $5mr0m = parcelRequire("5mr0m");

var $2ymUt = parcelRequire("2ymUt");
const $dd51d5d3750e86dc$var$_excluded = [
    "embeddedProduct"
];
function $dd51d5d3750e86dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd51d5d3750e86dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd51d5d3750e86dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd51d5d3750e86dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $dd51d5d3750e86dc$var$DEFAULT_DELAY = 2000; // 2 seconds
const $dd51d5d3750e86dc$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $dd51d5d3750e86dc$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
class $dd51d5d3750e86dc$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_bindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_unbindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_parseLocalStorageData", ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $5mr0m.tenantType).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_this$_getContext, $dd51d5d3750e86dc$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: 'ui',
                action: 'viewed',
                actionSubject: 'ui',
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $dd51d5d3750e86dc$var$_objectSpread($dd51d5d3750e86dc$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $dd51d5d3750e86dc$var$_objectSpread($dd51d5d3750e86dc$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $dd51d5d3750e86dc$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $dd51d5d3750e86dc$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $dd51d5d3750e86dc$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $2ymUt.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});

parcelRegister("k1sRe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e93a49271ec261d6$export$2e2bcd8739ae039; });
function $e93a49271ec261d6$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("hzBJL", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", function () { return $ccb2fa5e74fb783c$export$fbe53bbbe682bcdd; });

var $a1afT = parcelRequire("a1afT");
const $ccb2fa5e74fb783c$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $a1afT.createTimeoutXid)()), (0, $a1afT.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $a1afT.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("a1afT", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", function () { return $74b1f3dd64f1f1e9$export$545bcbd53afabfa3; });
$parcel$export(module.exports, "createTimeoutXid", function () { return $74b1f3dd64f1f1e9$export$af4087e36d63846; });
$parcel$export(module.exports, "createUnknownXid", function () { return $74b1f3dd64f1f1e9$export$fa341d0c750d705b; });

var $hpgw2 = parcelRequire("hpgw2");
const $74b1f3dd64f1f1e9$export$545bcbd53afabfa3 = 5000;
const $74b1f3dd64f1f1e9$export$af4087e36d63846 = ()=>[
        {
            type: (0, $hpgw2.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $hpgw2.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $74b1f3dd64f1f1e9$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $hpgw2.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $hpgw2.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("hpgw2", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", function () { return $cac195261d19f0fb$export$92ca0438bcb0d396; });
let $cac195261d19f0fb$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $cac195261d19f0fb$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("jjyqs", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    module.exports = factory();
})(module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 7);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GAS_BULK_URL = exports.GAS_BULK_URL = 'https://mgas.prod.public.atl-paas.net/v1/events';
            var CLOUD_ANALYTICS_URL = exports.CLOUD_ANALYTICS_URL = '/rest/analytics/1.0/publish/bulk';
            var CONFLUENCE_URL_PREFIX = exports.CONFLUENCE_URL_PREFIX = '/wiki';
            var BATCH_INTERVAL_MS = exports.BATCH_INTERVAL_MS = 5000;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var SafeString = exports.SafeString = function SafeString(value) {
                var _this = this;
                _classCallCheck(this, SafeString);
                this.value = value;
                this.valueOf = this.toString = this.toJSON = function() {
                    return _this.value;
                };
            };
            /**
 * Use this when you explicitly need to collect user entered data. Such as NPS survey responses.
 * @param value
 */ var dangerouslyCreateSafeString = exports.dangerouslyCreateSafeString = function dangerouslyCreateSafeString(value) {
                return new SafeString(value);
            };
            var isSafeString = exports.isSafeString = function isSafeString(value) {
                return value instanceof SafeString;
            };
            /**
 * Provide a list of acceptable values to ensure we do not unintentionally capture user data
 * @param {Array} allowedStrings - Static string values representing allowed words for this property
 * @returns {SafeString}
 */ var markAsSafe = exports.markAsSafe = function markAsSafe() {
                for(var _len = arguments.length, allowedStrings = Array(_len), _key = 0; _key < _len; _key++)allowedStrings[_key] = arguments[_key];
                return function(value) {
                    return allowedStrings.includes(value) ? Object.freeze(new SafeString(value)) : value;
                };
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.BaseAnalytics = undefined;
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _Beacon = __webpack_require__(8);
            var _PrivacySafeString = __webpack_require__(1);
            var _AnalyticsLogger = __webpack_require__(9);
            var _AnalyticsLogger2 = _interopRequireDefault(_AnalyticsLogger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var isNumberOrNumericString = function isNumberOrNumericString(value) {
                return !isNaN(value);
            };
            var isNull = function isNull(value) {
                return value === null;
            };
            var isBoolean = function isBoolean(value) {
                return value === true || value === false;
            };
            /**
 * Is of a type that will not reveal any PII
 * OR
 * is explicitly marked as being safe of PII
 * @param value
 */ var isPrivacySafe = function isPrivacySafe(value) {
                return isNull(value) || isBoolean(value) || isNumberOrNumericString(value) || (0, _PrivacySafeString.isSafeString)(value);
            };
            /**
 * Extend this to include "whitelisted" keys where the values will be deemed safe
 * @param key
 */ var isPrivacySafeAttributeKey = function isPrivacySafeAttributeKey(key) {
                return key === 'spaceKey';
            };
            /*eslint no-unused-vars: ["error", { "argsIgnorePattern": "name|properties|events" }]*/ /**
 * Abstract analytics client implementation
 */ var BaseAnalytics = exports.BaseAnalytics = function() {
                function BaseAnalytics() {
                    var _this = this;
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    _classCallCheck(this, BaseAnalytics);
                    this.eventPrefix = options.eventPrefix || '';
                    this.devMode = options.devMode;
                    this.batch_interval_ms = options.batchIntervalMs || _default.BATCH_INTERVAL_MS;
                    this.options = options;
                    this._requestQueue = [];
                    if (typeof window !== "undefined" && window.addEventListener) window.addEventListener("unload", function() {
                        _this.handlePageUnload();
                    });
                }
                _createClass(BaseAnalytics, [
                    {
                        key: 'url',
                        value: function url() {
                            throw new Error('override url()');
                        }
                    },
                    {
                        key: 'createRequest',
                        value: function createRequest(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            throw new Error('You must override createRequest().');
                        }
                    },
                    {
                        key: 'trigger',
                        value: function trigger(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                                immediate: false
                            };
                            if (!name) throw new Error("Name must be provided when sending an event.");
                            var eventName = '' + (this.eventPrefix ? this.eventPrefix + "." : "") + name;
                            var request = this.createRequest(eventName, this.sanitizeAnalyticsData(properties));
                            if (this.devMode) _AnalyticsLogger2.default.log(JSON.stringify(request, null, 2));
                            if (options.immediate) this.sendEventsToRemote([
                                request
                            ]);
                            else {
                                this.pushToQueue(request);
                                this.startInterval();
                            }
                        }
                    },
                    {
                        key: 'setQueue',
                        value: function setQueue(newQueue) {
                            this._requestQueue = newQueue;
                        }
                    },
                    {
                        key: 'getQueue',
                        value: function getQueue() {
                            return this._requestQueue;
                        }
                    },
                    {
                        key: 'pushToQueue',
                        value: function pushToQueue(request) {
                            this.getQueue().push(request);
                        }
                    },
                    {
                        key: 'processQueue',
                        value: function processQueue() {
                            var events = this.getQueue().splice(0);
                            if (events.length > 0) this.sendEventsToRemote(events);
                        }
                    },
                    {
                        key: 'handlePageUnload',
                        value: function handlePageUnload() {
                            this.processQueue();
                            this.stopInterval();
                        }
                    },
                    {
                        key: 'startInterval',
                        value: function startInterval() {
                            var _this2 = this;
                            if (typeof this._intervalId === "number") return;
                            this._intervalId = setInterval(function() {
                                return _this2.processQueue();
                            }, this.batch_interval_ms);
                        }
                    },
                    {
                        key: 'stopInterval',
                        value: function stopInterval() {
                            if (typeof this._intervalId === "number") {
                                clearInterval(this._intervalId);
                                this._intervalId = null;
                            }
                        }
                    },
                    {
                        key: 'emptyQueue',
                        value: function emptyQueue() {
                            this._requestQueue = [];
                        }
                    },
                    {
                        key: 'sendEventsToRemote',
                        value: function sendEventsToRemote(events) {
                            var payload = this.constructor.createPayload(events);
                            if (this.devMode) {
                                _AnalyticsLogger2.default.log('sending ' + events.length + ' events.');
                                return;
                            }
                            var successfullyQueued = false;
                            if (_Beacon.Beacon.isSupported()) successfullyQueued = _Beacon.Beacon.sendAsJson(this.url(), payload);
                            if (!successfullyQueued) this.doPost(payload);
                        }
                    },
                    {
                        key: 'doPost',
                        value: function doPost(postBody) {
                            var xhr = void 0;
                            if (typeof window !== "undefined" && window.XMLHttpRequest) // IE7+, Firefox, Chrome, Opera, Safari
                            xhr = new window.XMLHttpRequest();
                            else return;
                            xhr.open("POST", this.url(), true);
                            if (typeof xhr.setRequestHeader !== 'undefined') {
                                xhr.setRequestHeader("Content-Type", "application/json");
                                xhr.setRequestHeader("Accept", "application/json, text/javascript, */*;");
                            }
                            var decoratedPostBody = this.decorateEventsWithType(postBody);
                            xhr.send(JSON.stringify(decoratedPostBody));
                        }
                    },
                    {
                        key: 'decorateEventsWithType',
                        value: function decorateEventsWithType(postBody) {
                            return postBody.map(function(event) {
                                event.properties = event.properties || {};
                                event.properties._type = "xhr";
                                return event;
                            });
                        }
                    },
                    {
                        key: 'sanitizeAnalyticsData',
                        value: function sanitizeAnalyticsData(data) {
                            var _this3 = this;
                            if (isNull(data) || typeof data === 'undefined') return data;
                            if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') return {};
                            // return the data with privacy unsafe data filtered out
                            return Object.keys(data).reduce(function(filteredData, key) {
                                var value = data[key];
                                if (isPrivacySafeAttributeKey(key) || isPrivacySafe(value)) filteredData[key] = value;
                                else if (_this3.devMode) _AnalyticsLogger2.default.warn('Stripping out potentially privacy-unsafe analytics attribute: \'' + key + '\' -> \'' + value + '\'');
                                return filteredData;
                            }, {});
                        }
                    },
                    {
                        key: 'updateOptions',
                        value: function updateOptions(newOptions) {
                            this.options = _extends({}, this.options, newOptions);
                        }
                    }
                ], [
                    {
                        key: 'createPayload',
                        value: function createPayload(events) {
                            throw new Error('You must override createPayload().');
                        }
                    }
                ]);
                return BaseAnalytics;
            }();
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.CloudAnalytics = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _BaseAnalytics2 = __webpack_require__(2);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Common code for cloud, shared by JiraAnalytics and ConfluenceAnalytics
 */ var CloudAnalytics = exports.CloudAnalytics = function(_BaseAnalytics) {
                _inherits(CloudAnalytics, _BaseAnalytics);
                function CloudAnalytics() {
                    _classCallCheck(this, CloudAnalytics);
                    return _possibleConstructorReturn(this, (CloudAnalytics.__proto__ || Object.getPrototypeOf(CloudAnalytics)).apply(this, arguments));
                }
                _createClass(CloudAnalytics, [
                    {
                        key: 'createRequest',
                        value: function createRequest(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            return {
                                name: name,
                                properties: properties,
                                serverTime: Date.now()
                            };
                        }
                    }
                ], [
                    {
                        key: 'createPayload',
                        value: function createPayload(events) {
                            return this.adjustEventTimings(events);
                        }
                    },
                    {
                        key: 'adjustEventTimings',
                        value: function adjustEventTimings(events) {
                            var now = Date.now();
                            return events.map(function(event) {
                                return {
                                    name: event.name,
                                    properties: event.properties,
                                    timeDelta: event.serverTime - now
                                };
                            });
                        }
                    }
                ]);
                return CloudAnalytics;
            }(_BaseAnalytics2.BaseAnalytics);
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ConfluenceAnalytics = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _CloudAnalytics2 = __webpack_require__(3);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Analytics client for Confluence
 * Defaults to /wiki
 */ var ConfluenceAnalytics = exports.ConfluenceAnalytics = function(_CloudAnalytics) {
                _inherits(ConfluenceAnalytics, _CloudAnalytics);
                function ConfluenceAnalytics() {
                    _classCallCheck(this, ConfluenceAnalytics);
                    return _possibleConstructorReturn(this, (ConfluenceAnalytics.__proto__ || Object.getPrototypeOf(ConfluenceAnalytics)).apply(this, arguments));
                }
                _createClass(ConfluenceAnalytics, [
                    {
                        key: 'url',
                        /**
     * Override if context path changes
     * @param baseUrl
     * @returns {string}
     */ value: function url() {
                            var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname + _default.CONFLUENCE_URL_PREFIX;
                            return baseUrl + _default.CLOUD_ANALYTICS_URL;
                        }
                    }
                ]);
                return ConfluenceAnalytics;
            }(_CloudAnalytics2.CloudAnalytics);
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.GasAnalytics = undefined;
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _BaseAnalytics2 = __webpack_require__(2);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Analytics client for the GAS API ({@link https://extranet.atlassian.com/display/MOD/Public+Analytics+aka+GAS})
 */ var GasAnalytics = exports.GasAnalytics = function(_BaseAnalytics) {
                _inherits(GasAnalytics, _BaseAnalytics);
                /**
    * @constructor
    * @param {object} options - Required: server, product, user.
    */ function GasAnalytics(options) {
                    _classCallCheck(this, GasAnalytics);
                    var _this = _possibleConstructorReturn(this, (GasAnalytics.__proto__ || Object.getPrototypeOf(GasAnalytics)).call(this, options));
                    if (!options.server) throw new Error("You must specify a GAS server value.");
                    if (!options.product) throw new Error("You must specify a GAS product value.");
                    if (!options.user && !options.user_id) throw new Error("You must specify a GAS user or user_id value.");
                    return _this;
                }
                _createClass(GasAnalytics, [
                    {
                        key: "url",
                        value: function url() {
                            return _default.GAS_BULK_URL;
                        }
                    },
                    {
                        key: "createRequest",
                        value: function createRequest(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            return {
                                name: name,
                                server: this.options.server,
                                product: this.options.product,
                                user: this.options.user,
                                serverTime: Date.now(),
                                cloud_id: this.options.cloud_id || null,
                                user_id: this.options.user_id || null,
                                user_id_type: this.options.user_id_type || null,
                                properties: properties
                            };
                        }
                    },
                    {
                        key: "decorateEventsWithType",
                        value: function decorateEventsWithType(postBody) {
                            if (!postBody.events) return;
                            postBody.events = postBody.events.map(function(event) {
                                event.properties = event.properties || {};
                                event.properties._type = "xhr";
                                return event;
                            });
                            return postBody;
                        }
                    },
                    {
                        key: "updateOptions",
                        value: function updateOptions(newOptions) {
                            this.options = _extends({}, this.options, newOptions);
                            this.setQueue(this.getQueue().map(function(queuedEvent) {
                                return _extends({}, queuedEvent, newOptions);
                            }));
                        }
                    }
                ], [
                    {
                        key: "createPayload",
                        value: function createPayload(events) {
                            return {
                                events: events
                            };
                        }
                    }
                ]);
                return GasAnalytics;
            }(_BaseAnalytics2.BaseAnalytics);
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.JiraAnalytics = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _CloudAnalytics2 = __webpack_require__(3);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Analytics client for JIRA
 */ var JiraAnalytics = exports.JiraAnalytics = function(_CloudAnalytics) {
                _inherits(JiraAnalytics, _CloudAnalytics);
                function JiraAnalytics() {
                    _classCallCheck(this, JiraAnalytics);
                    return _possibleConstructorReturn(this, (JiraAnalytics.__proto__ || Object.getPrototypeOf(JiraAnalytics)).apply(this, arguments));
                }
                _createClass(JiraAnalytics, [
                    {
                        key: 'url',
                        /**
     * Override if context path changes
     * @param baseUrl
     * @returns {string}
     */ value: function url() {
                            var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
                            return baseUrl + _default.CLOUD_ANALYTICS_URL;
                        }
                    }
                ]);
                return JiraAnalytics;
            }(_CloudAnalytics2.CloudAnalytics);
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.dangerouslyCreateSafeString = exports.isSafeString = exports.markAsSafe = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _GasAnalytics = __webpack_require__(5);
            var _JiraAnalytics = __webpack_require__(6);
            var _ConfluenceAnalytics = __webpack_require__(4);
            var _PrivacySafeString = __webpack_require__(1);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /**
 * Get singleton Analytics Client that is appropriate for your product or app.
 */ var AnalyticsClientFactory = function() {
                function AnalyticsClientFactory() {
                    _classCallCheck(this, AnalyticsClientFactory);
                }
                _createClass(AnalyticsClientFactory, [
                    {
                        key: 'getGasClient',
                        /**
     * Get a Gas Analytics Client.
     * @param {object} options - {
     *  server: "String - required",
     *  product: "String - required",
     *  user: "String - required",
     *  eventPrefix: "String - optional - default: ''",
     *  devMode: "Boolean - optional - default: false",
     *  batchIntervalMs: "Integer - optional - default: 5000"
     * }
     * @returns {GasAnalytics}
     */ value: function getGasClient(options) {
                            if (this._gasClient) return this._gasClient;
                            return this._gasClient = new _GasAnalytics.GasAnalytics(options);
                        }
                    },
                    {
                        key: 'getJiraClient',
                        value: function getJiraClient(options) {
                            if (this._jiraClient) return this._jiraClient;
                            return this._jiraClient = new _JiraAnalytics.JiraAnalytics(options);
                        }
                    },
                    {
                        key: 'getConfluenceClient',
                        value: function getConfluenceClient(options) {
                            if (this._confluenceClient) return this._confluenceClient;
                            return this._confluenceClient = new _ConfluenceAnalytics.ConfluenceAnalytics(options);
                        }
                    }
                ]);
                return AnalyticsClientFactory;
            }();
            exports.default = new AnalyticsClientFactory();
            /**
 * Provide a list of acceptable values to ensure we do not unintentionally capture user data
 * @param {...String} allowedStrings - Static string values representing allowed words for this property
 * @returns {SafeString} - a function that will check if the value (argument) is in the list of allowedStrings
 */ var markAsSafe = exports.markAsSafe = _PrivacySafeString.markAsSafe;
            var isSafeString = exports.isSafeString = _PrivacySafeString.isSafeString;
            var dangerouslyCreateSafeString = exports.dangerouslyCreateSafeString = _PrivacySafeString.dangerouslyCreateSafeString;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var _isSupported = null;
            /**
 * Light wrapper around navigator.sendBeacon()
 */ var Beacon = exports.Beacon = function() {
                function Beacon() {
                    _classCallCheck(this, Beacon);
                }
                _createClass(Beacon, null, [
                    {
                        key: 'sendAsJson',
                        /**
         * Send the specified object as JSON using Beacon API.
         *
         * See:
         * - https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API
         * - https://w3c.github.io/beacon/#dom-navigator-sendbeacon
         *
         * Returns a boolean to indicate that the data was successfully queued.
         *
         * If we've exceeded our quota for sendBeacon on this page, this method
         * will return false.
         *
         * See: https://www.w3.org/TR/beacon/#sec-sendBeacon-method
         *
         * @param url
         * @param object
         * @returns {boolean}
         */ value: function sendAsJson(url, object) {
                            var blob = new Blob([
                                JSON.stringify(object)
                            ], {
                                type: 'text/plain'
                            });
                            return navigator.sendBeacon(url, blob);
                        }
                    },
                    {
                        key: 'isSupported',
                        value: function isSupported() {
                            if (typeof _isSupported !== 'boolean') _isSupported = this.isSendBeaconSupported() && this.isBlobSupported();
                            return _isSupported;
                        }
                    },
                    {
                        key: 'isSendBeaconSupported',
                        value: function isSendBeaconSupported() {
                            // Modified from: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/network/beacon.js
                            return 'sendBeacon' in navigator && typeof navigator.sendBeacon === 'function';
                        }
                    },
                    {
                        key: 'isBlobSupported',
                        value: function isBlobSupported() {
                            // Source: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/blob.js
                            try {
                                return new Blob(), true;
                            } catch (e) {
                                return false;
                            }
                        }
                    }
                ]);
                return Beacon;
            }();
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /**
 * Prettifier with a standard prefix for all log messages
 */ /*eslint no-console: 0*/ exports.default = {
                log: function log(message) {
                    console.log("%cAnalytics: " + message, "color: #0052CC; font-size: small");
                },
                warn: function warn(message) {
                    console.warn("%cAnalytics: " + message, "color: #DE350B; font-size: small");
                },
                error: function error(message) {
                    // This might not work in some browsers... but ignore this for now.
                    console.error("%cAnalytics: " + message, "color: #FF5630; font-size: small");
                }
            };
        /***/ }
    ]);
});

});

parcelRegister("1xe2r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efe9ca9d9cb09b68$export$2e2bcd8739ae039; });

var $1JRGy = parcelRequire("1JRGy");

var $hvOXy = parcelRequire("hvOXy");
const $efe9ca9d9cb09b68$var$cache = new Map();
var $efe9ca9d9cb09b68$export$2e2bcd8739ae039 = (url, options)=>{
    if (!$efe9ca9d9cb09b68$var$cache.has(url)) $efe9ca9d9cb09b68$var$cache.set(url, $efe9ca9d9cb09b68$var$getOriginTracingAttributesFromUrl(url, options));
    return $efe9ca9d9cb09b68$var$cache.get(url);
};
function $efe9ca9d9cb09b68$var$getOriginTracingAttributesFromUrl(url, options) {
    let mapAttribute = (v)=>v;
    if (options && options.mapAttribute) mapAttribute = options.mapAttribute;
    let origin = (0, $hvOXy.default).createEmpty();
    try {
        const urlOrigin = (0, $hvOXy.default).fromUrl(url);
        const continueUrl = $efe9ca9d9cb09b68$var$getQueryParam(url, 'continue');
        const continueOrigin = (0, $hvOXy.default).fromUrl(continueUrl);
        // @ts-ignore Argument of type 'string | string[]' is not assignable to parameter of type 'string'.
        const destUrl = $efe9ca9d9cb09b68$var$getQueryParam(continueUrl, 'dest-url');
        const destOrigin = (0, $hvOXy.default).fromUrl(destUrl);
        // @ts-ignore Argument of type 'string | string[]' is not assignable to parameter of type 'string'.
        const nestedContinueUrl = $efe9ca9d9cb09b68$var$getQueryParam(continueUrl, 'continue');
        const nestedContinueOrigin = (0, $hvOXy.default).fromUrl(nestedContinueUrl);
        origin = !urlOrigin.isEmpty() && urlOrigin || !continueOrigin.isEmpty() && continueOrigin || !destOrigin.isEmpty() && destOrigin || !nestedContinueOrigin.isEmpty() && nestedContinueOrigin || (0, $hvOXy.default).createEmpty();
    } catch (e) {
    //will fail only on malformed urls, we don't care about that
    }
    return origin.toAnalyticsAttributes({
        transformValue: mapAttribute
    });
}
function $efe9ca9d9cb09b68$var$getQueryParam(url, paramName) {
    if (!url) return undefined;
    // Base is only needed for URL() to resolve relative paths. It could be arbitrary.
    const BASE = 'http://atlassian.com/';
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(new URL(url, BASE).search);
    return query[paramName] || undefined;
}

});
parcelRegister("1JRGy", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $1443a33531b0c550$export$f9380c9a627682d3; }, function (v) { return $1443a33531b0c550$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $1443a33531b0c550$export$98e6a39c04603d36; }, function (v) { return $1443a33531b0c550$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $1443a33531b0c550$export$fac44ee5b035f737; }, function (v) { return $1443a33531b0c550$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $1443a33531b0c550$export$7a5253c0f62e0150; }, function (v) { return $1443a33531b0c550$export$7a5253c0f62e0150 = v; });
var $1443a33531b0c550$export$f9380c9a627682d3;
var $1443a33531b0c550$export$98e6a39c04603d36;
var $1443a33531b0c550$export$fac44ee5b035f737;
var $1443a33531b0c550$export$7a5253c0f62e0150;
'use strict';

var $70xa4 = parcelRequire("70xa4");

var $48q3c = parcelRequire("48q3c");

var $8HHgV = parcelRequire("8HHgV");
function $1443a33531b0c550$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $1443a33531b0c550$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $1443a33531b0c550$var$encode(key, opts),
                    '[',
                    $1443a33531b0c550$var$encode(index, opts),
                    ']=',
                    $1443a33531b0c550$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $1443a33531b0c550$var$encode(key, opts) : [
                    $1443a33531b0c550$var$encode(key, opts),
                    '[]=',
                    $1443a33531b0c550$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $1443a33531b0c550$var$encode(key, opts) : [
                    $1443a33531b0c550$var$encode(key, opts),
                    '=',
                    $1443a33531b0c550$var$encode(value, opts)
                ].join('');
            };
    }
}
function $1443a33531b0c550$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $1443a33531b0c550$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $70xa4(value) : encodeURIComponent(value);
    return value;
}
function $1443a33531b0c550$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $1443a33531b0c550$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $1443a33531b0c550$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $1443a33531b0c550$var$parse(str, opts) {
    opts = $48q3c({
        arrayFormat: 'none'
    }, opts);
    var formatter = $1443a33531b0c550$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $8HHgV(val);
        formatter($8HHgV(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $1443a33531b0c550$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$1443a33531b0c550$export$f9380c9a627682d3 = $1443a33531b0c550$var$extract;
$1443a33531b0c550$export$98e6a39c04603d36 = $1443a33531b0c550$var$parse;
$1443a33531b0c550$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $48q3c(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $1443a33531b0c550$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $1443a33531b0c550$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $1443a33531b0c550$var$encode(key, opts) + '=' + $1443a33531b0c550$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$1443a33531b0c550$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $1443a33531b0c550$var$parse($1443a33531b0c550$var$extract(str), opts)
    };
};

});
parcelRegister("70xa4", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("48q3c", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $302c1de7526e8e73$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $302c1de7526e8e73$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $302c1de7526e8e73$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $302c1de7526e8e73$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $302c1de7526e8e73$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $302c1de7526e8e73$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $302c1de7526e8e73$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($302c1de7526e8e73$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($302c1de7526e8e73$var$getOwnPropertySymbols) {
            symbols = $302c1de7526e8e73$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($302c1de7526e8e73$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("hvOXy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbfcdc6ae83edea6$export$2e2bcd8739ae039; });

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $enV8I = parcelRequire("enV8I");

var $91FVG = parcelRequire("91FVG");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $aza3U = parcelRequire("aza3U");

var $gLCoA = parcelRequire("gLCoA");

var $71FbG = parcelRequire("71FbG");
function $cbfcdc6ae83edea6$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $cbfcdc6ae83edea6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $cbfcdc6ae83edea6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cbfcdc6ae83edea6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $cbfcdc6ae83edea6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cbfcdc6ae83edea6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cbfcdc6ae83edea6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cbfcdc6ae83edea6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cbfcdc6ae83edea6$var$packageVersion = "0.0.0-development";
var $cbfcdc6ae83edea6$var$originParamName = 'atlOrigin';
var $cbfcdc6ae83edea6$var$originVersioningAttributes = {
    originLibrary: "origin-tracing.js@".concat($cbfcdc6ae83edea6$var$packageVersion)
};
var $cbfcdc6ae83edea6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function OriginTracer(_ref) {
        var _ref$id = _ref.id, id = _ref$id === void 0 ? OriginTracer.generateId() : _ref$id, product = _ref.product, _ref$dangerouslySkipV = _ref.dangerouslySkipValidation, dangerouslySkipValidation = _ref$dangerouslySkipV === void 0 ? false : _ref$dangerouslySkipV;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, OriginTracer);
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(OriginTracer, [
        {
            key: "encode",
            value: function encode() {
                return (0, $gLCoA.encode)({
                    id: this.id,
                    product: this.product
                });
            }
        },
        {
            key: "addToUrl",
            value: function addToUrl(url) {
                var _this = this;
                return $cbfcdc6ae83edea6$var$replaceQuery(url, function(originalQueryString) {
                    var params = new ((0, $71FbG.getEnv)()).URLSearchParams(originalQueryString);
                    params.set($cbfcdc6ae83edea6$var$originParamName, _this.encode());
                    return params.toString();
                });
            }
        },
        {
            key: "containsOrigin",
            value: function containsOrigin(urlString) {
                var url = new ((0, $71FbG.getEnv)()).URL(urlString);
                var params = new URLSearchParams(url.search);
                return params.has($cbfcdc6ae83edea6$var$originParamName);
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            key: "isMalformed",
            value: function isMalformed() {
                return !this.isEmpty() && !this.isValid();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return true;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$transformValue = _ref2.transformValue, transformValue = _ref2$transformValue === void 0 ? function(v) {
                    return v === null ? undefined : v;
                } : _ref2$transformValue, _ref2$hasGeneratedId = _ref2.hasGeneratedId, hasGeneratedId = _ref2$hasGeneratedId === void 0 ? false : _ref2$hasGeneratedId;
                // `originIdGenerated` should be used in analytic events that generated this originId.
                // Subsequent events should use `originId`.
                // No two events should have the same value of originIdGenerated.
                var originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
                return $cbfcdc6ae83edea6$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, originIdProp, transformValue(this.id)), "originProduct", transformValue(this.product)), $cbfcdc6ae83edea6$var$originVersioningAttributes);
            }
        },
        {
            key: "validate",
            value: function validate() {
                if (!OriginTracer.isValidId(this.id)) throw new TypeError('Invalid Origin id');
                if (!OriginTracer.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
            }
        }
    ], [
        {
            key: "isValidId",
            value: function isValidId(value) {
                return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
            }
        },
        {
            key: "isValidProduct",
            value: function isValidProduct(value) {
                return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
            }
        },
        {
            key: "generateId",
            value: function generateId() {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                var id = (0, $aza3U.v4)();
                // Dash positions are fixed so they don't add to uniqueness.
                // Remove them to save space in the encoded form.
                return id.replace(/-/g, '');
            }
        },
        {
            key: "createEmpty",
            value: function createEmpty() {
                return new $cbfcdc6ae83edea6$var$EmptyOriginTracer();
            }
        },
        {
            key: "createMalformed",
            value: function createMalformed() {
                return new $cbfcdc6ae83edea6$var$MalformedOriginTracer();
            }
        },
        {
            key: "fromUrl",
            value: function fromUrl(url) {
                var params = new ((0, $71FbG.getEnv)()).URLSearchParams();
                $cbfcdc6ae83edea6$var$replaceQuery(url, function(queryString) {
                    params = new ((0, $71FbG.getEnv)()).URLSearchParams(queryString);
                });
                return OriginTracer.fromEncoded(params.get($cbfcdc6ae83edea6$var$originParamName));
            }
        },
        {
            key: "fromEncoded",
            value: function fromEncoded(encoded) {
                if (!encoded) return OriginTracer.createEmpty();
                try {
                    return OriginTracer.decode(encoded);
                } catch (e) {
                    return OriginTracer.createMalformed();
                }
            }
        },
        {
            key: "removeFromUrl",
            value: function removeFromUrl(url) {
                return $cbfcdc6ae83edea6$var$replaceQuery(url, function(queryString) {
                    var params = new ((0, $71FbG.getEnv)()).URLSearchParams(queryString);
                    params.delete($cbfcdc6ae83edea6$var$originParamName);
                    return params.toString();
                });
            }
        },
        {
            key: "decode",
            value: function decode(encodedOrigin) {
                var originData = (0, $gLCoA.decode)(encodedOrigin);
                return new OriginTracer(originData);
            }
        }
    ]);
}();
var $cbfcdc6ae83edea6$var$EmptyOriginTracer = /*#__PURE__*/ function(_OriginTracer) {
    function EmptyOriginTracer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, EmptyOriginTracer);
        return $cbfcdc6ae83edea6$var$_callSuper(this, EmptyOriginTracer, [
            {
                id: null,
                product: null,
                dangerouslySkipValidation: true
            }
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(EmptyOriginTracer, _OriginTracer);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(EmptyOriginTracer, [
        {
            key: "isValid",
            value: function isValid() {
                return false;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return true;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                return $cbfcdc6ae83edea6$var$_objectSpread({}, $cbfcdc6ae83edea6$var$originVersioningAttributes);
            }
        }
    ]);
}($cbfcdc6ae83edea6$export$2e2bcd8739ae039);
var $cbfcdc6ae83edea6$var$MalformedOriginTracer = /*#__PURE__*/ function(_OriginTracer2) {
    function MalformedOriginTracer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, MalformedOriginTracer);
        return $cbfcdc6ae83edea6$var$_callSuper(this, MalformedOriginTracer, [
            {
                id: null,
                product: null,
                dangerouslySkipValidation: true
            }
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(MalformedOriginTracer, _OriginTracer2);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(MalformedOriginTracer, [
        {
            key: "isValid",
            value: function isValid() {
                return false;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                return $cbfcdc6ae83edea6$var$_objectSpread({
                    originMalformed: true
                }, $cbfcdc6ae83edea6$var$originVersioningAttributes);
            }
        }
    ]);
}($cbfcdc6ae83edea6$export$2e2bcd8739ae039);
function $cbfcdc6ae83edea6$var$replaceQuery(url, replacer) {
    var urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    var urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, function(_wholeMatch, beforeQuery, queryString, afterQuery) {
        var newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = "?".concat(newQueryString);
        return "".concat(beforeQuery).concat(newQueryString).concat(afterQuery);
    });
}

});
parcelRegister("aza3U", function(module, exports) {

var $fKFEw = parcelRequire("fKFEw");

var $l3ahi = parcelRequire("l3ahi");
var $7b14fa64114932dd$var$uuid = $l3ahi;
$7b14fa64114932dd$var$uuid.v1 = $fKFEw;
$7b14fa64114932dd$var$uuid.v4 = $l3ahi;
module.exports = $7b14fa64114932dd$var$uuid;

});
parcelRegister("fKFEw", function(module, exports) {

var $goQdG = parcelRequire("goQdG");

var $lhNLT = parcelRequire("lhNLT");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $b77b7636713e0b50$var$_nodeId;
var $b77b7636713e0b50$var$_clockseq;
// Previous uuid creation time
var $b77b7636713e0b50$var$_lastMSecs = 0;
var $b77b7636713e0b50$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $b77b7636713e0b50$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $b77b7636713e0b50$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $b77b7636713e0b50$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $goQdG();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $b77b7636713e0b50$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $b77b7636713e0b50$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $b77b7636713e0b50$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $b77b7636713e0b50$var$_lastMSecs + (nsecs - $b77b7636713e0b50$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $b77b7636713e0b50$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $b77b7636713e0b50$var$_lastMSecs = msecs;
    $b77b7636713e0b50$var$_lastNSecs = nsecs;
    $b77b7636713e0b50$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $lhNLT(b);
}
module.exports = $b77b7636713e0b50$var$v1;

});


parcelRegister("gLCoA", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $c34ed1afcc02c8f1$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $c34ed1afcc02c8f1$export$2f872c0f2117be69; });

var $eszod = parcelRequire("eszod");

var $71FbG = parcelRequire("71FbG");
var $c34ed1afcc02c8f1$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $c34ed1afcc02c8f1$export$c564cdbbe6da493(originData) {
    var json = JSON.stringify($c34ed1afcc02c8f1$export$4bc4b533a565aabe(originData));
    var base64 = (0, $71FbG.getEnv)().btoa(json);
    return (0, $eszod.base64ToBase64Url)(base64);
}
function $c34ed1afcc02c8f1$export$2f872c0f2117be69(encodedOriginString) {
    var base64 = (0, $eszod.base64UrlToBase64)(encodedOriginString);
    var json = (0, $71FbG.getEnv)().atob(base64);
    return $c34ed1afcc02c8f1$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $c34ed1afcc02c8f1$export$4bc4b533a565aabe(_ref) {
    var id = _ref.id, product = _ref.product;
    return {
        i: id,
        p: product && product in $c34ed1afcc02c8f1$var$productShorthands ? $c34ed1afcc02c8f1$var$productShorthands[product] : product
    };
}
function $c34ed1afcc02c8f1$export$46d5cda6b884b7ab(originJSONObject) {
    var originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $c34ed1afcc02c8f1$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $c34ed1afcc02c8f1$var$expandProductShorthand(maybeShorthand) {
    var products = Object.keys($c34ed1afcc02c8f1$var$productShorthands);
    for(var i = 0; i < products.length; i++){
        var product = products[i];
        var shorthand = $c34ed1afcc02c8f1$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

});
parcelRegister("eszod", function(module, exports) {

$parcel$export(module.exports, "base64ToBase64Url", function () { return $a86f21db1e10af45$export$3b91e21dac1023c6; });
$parcel$export(module.exports, "base64UrlToBase64", function () { return $a86f21db1e10af45$export$47c5265a25535d02; });
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $a86f21db1e10af45$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $a86f21db1e10af45$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    var base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    var padLength = (4 - base64url.length % 4) % 4;
    var pad = '==='.slice(0, padLength);
    return base64 + pad;
}

});

parcelRegister("71FbG", function(module, exports) {

$parcel$export(module.exports, "getEnv", function () { return $51d8935a8b3c0ffb$export$4bd44a2aa29d3d6e; });

var $6xzda = parcelRequire("6xzda");


var $51d8935a8b3c0ffb$export$d3cd91e0fdbfdbc0 = function getEnvGlobals() {
    return {
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $6xzda.Buffer) !== 'undefined' && function(encoded) {
            return (0, $6xzda.Buffer).from(encoded, 'base64').toString();
        },
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $6xzda.Buffer) !== 'undefined' && function(str) {
            return (0, $6xzda.Buffer).from(str).toString('base64');
        },
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("5aakc")).URLSearchParams),
        URL: typeof URL === 'function' && URL || (0, (parcelRequire("5aakc")).URL)
    };
};
var $51d8935a8b3c0ffb$var$env;
var $51d8935a8b3c0ffb$export$4bd44a2aa29d3d6e = function getEnv() {
    return $51d8935a8b3c0ffb$var$env || ($51d8935a8b3c0ffb$var$env = $51d8935a8b3c0ffb$var$validateEnv($51d8935a8b3c0ffb$export$d3cd91e0fdbfdbc0()));
};
var $51d8935a8b3c0ffb$var$validateEnv = function validateEnv(env) {
    if (!(env.atob && env.btoa && env.URLSearchParams && env.URL)) throw new TypeError("Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).");
    return env;
};

});
parcelRegister("6xzda", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $4c31235d54ca37e2$export$a143d493d941bafc; }, function (v) { return $4c31235d54ca37e2$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $4c31235d54ca37e2$export$f99ded8fe4b79145; }, function (v) { return $4c31235d54ca37e2$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $4c31235d54ca37e2$export$a143d493d941bafc;
var $4c31235d54ca37e2$export$e4cf37d7f6fb9e0a;
var $4c31235d54ca37e2$export$f99ded8fe4b79145;
var $4c31235d54ca37e2$export$599f31c3813fae4d;
'use strict';

var $lkwSx = parcelRequire("lkwSx");

var $41jYZ = parcelRequire("41jYZ");
const $4c31235d54ca37e2$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$4c31235d54ca37e2$export$a143d493d941bafc = $4c31235d54ca37e2$var$Buffer;
$4c31235d54ca37e2$export$e4cf37d7f6fb9e0a = $4c31235d54ca37e2$var$SlowBuffer;
$4c31235d54ca37e2$export$f99ded8fe4b79145 = 50;
const $4c31235d54ca37e2$var$K_MAX_LENGTH = 0x7fffffff;
$4c31235d54ca37e2$export$599f31c3813fae4d = $4c31235d54ca37e2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $4c31235d54ca37e2$var$Buffer.TYPED_ARRAY_SUPPORT = $4c31235d54ca37e2$var$typedArraySupport();
if (!$4c31235d54ca37e2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $4c31235d54ca37e2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($4c31235d54ca37e2$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$4c31235d54ca37e2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($4c31235d54ca37e2$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$4c31235d54ca37e2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $4c31235d54ca37e2$var$createBuffer(length) {
    if (length > $4c31235d54ca37e2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $4c31235d54ca37e2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $4c31235d54ca37e2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $4c31235d54ca37e2$var$allocUnsafe(arg);
    }
    return $4c31235d54ca37e2$var$from(arg, encodingOrOffset, length);
}
$4c31235d54ca37e2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $4c31235d54ca37e2$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $4c31235d54ca37e2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $4c31235d54ca37e2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($4c31235d54ca37e2$var$isInstance(value, ArrayBuffer) || value && $4c31235d54ca37e2$var$isInstance(value.buffer, ArrayBuffer)) return $4c31235d54ca37e2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($4c31235d54ca37e2$var$isInstance(value, SharedArrayBuffer) || value && $4c31235d54ca37e2$var$isInstance(value.buffer, SharedArrayBuffer))) return $4c31235d54ca37e2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $4c31235d54ca37e2$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $4c31235d54ca37e2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $4c31235d54ca37e2$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $4c31235d54ca37e2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $4c31235d54ca37e2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($4c31235d54ca37e2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($4c31235d54ca37e2$var$Buffer, Uint8Array);
function $4c31235d54ca37e2$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $4c31235d54ca37e2$var$alloc(size, fill, encoding) {
    $4c31235d54ca37e2$var$assertSize(size);
    if (size <= 0) return $4c31235d54ca37e2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $4c31235d54ca37e2$var$createBuffer(size).fill(fill, encoding) : $4c31235d54ca37e2$var$createBuffer(size).fill(fill);
    return $4c31235d54ca37e2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $4c31235d54ca37e2$var$Buffer.alloc = function(size, fill, encoding) {
    return $4c31235d54ca37e2$var$alloc(size, fill, encoding);
};
function $4c31235d54ca37e2$var$allocUnsafe(size) {
    $4c31235d54ca37e2$var$assertSize(size);
    return $4c31235d54ca37e2$var$createBuffer(size < 0 ? 0 : $4c31235d54ca37e2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $4c31235d54ca37e2$var$Buffer.allocUnsafe = function(size) {
    return $4c31235d54ca37e2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $4c31235d54ca37e2$var$Buffer.allocUnsafeSlow = function(size) {
    return $4c31235d54ca37e2$var$allocUnsafe(size);
};
function $4c31235d54ca37e2$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$4c31235d54ca37e2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $4c31235d54ca37e2$var$byteLength(string, encoding) | 0;
    let buf = $4c31235d54ca37e2$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $4c31235d54ca37e2$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $4c31235d54ca37e2$var$checked(array.length) | 0;
    const buf = $4c31235d54ca37e2$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $4c31235d54ca37e2$var$fromArrayView(arrayView) {
    if ($4c31235d54ca37e2$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $4c31235d54ca37e2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $4c31235d54ca37e2$var$fromArrayLike(arrayView);
}
function $4c31235d54ca37e2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $4c31235d54ca37e2$var$Buffer.prototype);
    return buf;
}
function $4c31235d54ca37e2$var$fromObject(obj) {
    if ($4c31235d54ca37e2$var$Buffer.isBuffer(obj)) {
        const len = $4c31235d54ca37e2$var$checked(obj.length) | 0;
        const buf = $4c31235d54ca37e2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $4c31235d54ca37e2$var$numberIsNaN(obj.length)) return $4c31235d54ca37e2$var$createBuffer(0);
        return $4c31235d54ca37e2$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $4c31235d54ca37e2$var$fromArrayLike(obj.data);
}
function $4c31235d54ca37e2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $4c31235d54ca37e2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $4c31235d54ca37e2$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $4c31235d54ca37e2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $4c31235d54ca37e2$var$Buffer.alloc(+length);
}
$4c31235d54ca37e2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $4c31235d54ca37e2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$4c31235d54ca37e2$var$Buffer.compare = function compare(a, b) {
    if ($4c31235d54ca37e2$var$isInstance(a, Uint8Array)) a = $4c31235d54ca37e2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($4c31235d54ca37e2$var$isInstance(b, Uint8Array)) b = $4c31235d54ca37e2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$4c31235d54ca37e2$var$Buffer.isBuffer(a) || !$4c31235d54ca37e2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$4c31235d54ca37e2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$4c31235d54ca37e2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $4c31235d54ca37e2$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $4c31235d54ca37e2$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($4c31235d54ca37e2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$4c31235d54ca37e2$var$Buffer.isBuffer(buf)) buf = $4c31235d54ca37e2$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$4c31235d54ca37e2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $4c31235d54ca37e2$var$byteLength(string, encoding) {
    if ($4c31235d54ca37e2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $4c31235d54ca37e2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $4c31235d54ca37e2$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $4c31235d54ca37e2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $4c31235d54ca37e2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$4c31235d54ca37e2$var$Buffer.byteLength = $4c31235d54ca37e2$var$byteLength;
function $4c31235d54ca37e2$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $4c31235d54ca37e2$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $4c31235d54ca37e2$var$utf8Slice(this, start, end);
        case 'ascii':
            return $4c31235d54ca37e2$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $4c31235d54ca37e2$var$latin1Slice(this, start, end);
        case 'base64':
            return $4c31235d54ca37e2$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $4c31235d54ca37e2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$4c31235d54ca37e2$var$Buffer.prototype._isBuffer = true;
function $4c31235d54ca37e2$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$4c31235d54ca37e2$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$4c31235d54ca37e2$var$swap(this, i, i + 1);
    return this;
};
$4c31235d54ca37e2$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $4c31235d54ca37e2$var$swap(this, i, i + 3);
        $4c31235d54ca37e2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$4c31235d54ca37e2$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $4c31235d54ca37e2$var$swap(this, i, i + 7);
        $4c31235d54ca37e2$var$swap(this, i + 1, i + 6);
        $4c31235d54ca37e2$var$swap(this, i + 2, i + 5);
        $4c31235d54ca37e2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$4c31235d54ca37e2$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $4c31235d54ca37e2$var$utf8Slice(this, 0, length);
    return $4c31235d54ca37e2$var$slowToString.apply(this, arguments);
};
$4c31235d54ca37e2$var$Buffer.prototype.toLocaleString = $4c31235d54ca37e2$var$Buffer.prototype.toString;
$4c31235d54ca37e2$var$Buffer.prototype.equals = function equals(b) {
    if (!$4c31235d54ca37e2$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $4c31235d54ca37e2$var$Buffer.compare(this, b) === 0;
};
$4c31235d54ca37e2$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $4c31235d54ca37e2$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($4c31235d54ca37e2$var$customInspectSymbol) $4c31235d54ca37e2$var$Buffer.prototype[$4c31235d54ca37e2$var$customInspectSymbol] = $4c31235d54ca37e2$var$Buffer.prototype.inspect;
$4c31235d54ca37e2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($4c31235d54ca37e2$var$isInstance(target, Uint8Array)) target = $4c31235d54ca37e2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$4c31235d54ca37e2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $4c31235d54ca37e2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($4c31235d54ca37e2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $4c31235d54ca37e2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($4c31235d54ca37e2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $4c31235d54ca37e2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $4c31235d54ca37e2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $4c31235d54ca37e2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$4c31235d54ca37e2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$4c31235d54ca37e2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $4c31235d54ca37e2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$4c31235d54ca37e2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $4c31235d54ca37e2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $4c31235d54ca37e2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($4c31235d54ca37e2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $4c31235d54ca37e2$var$utf8Write(buf, string, offset, length) {
    return $4c31235d54ca37e2$var$blitBuffer($4c31235d54ca37e2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $4c31235d54ca37e2$var$asciiWrite(buf, string, offset, length) {
    return $4c31235d54ca37e2$var$blitBuffer($4c31235d54ca37e2$var$asciiToBytes(string), buf, offset, length);
}
function $4c31235d54ca37e2$var$base64Write(buf, string, offset, length) {
    return $4c31235d54ca37e2$var$blitBuffer($4c31235d54ca37e2$var$base64ToBytes(string), buf, offset, length);
}
function $4c31235d54ca37e2$var$ucs2Write(buf, string, offset, length) {
    return $4c31235d54ca37e2$var$blitBuffer($4c31235d54ca37e2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$4c31235d54ca37e2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $4c31235d54ca37e2$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $4c31235d54ca37e2$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $4c31235d54ca37e2$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $4c31235d54ca37e2$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $4c31235d54ca37e2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$4c31235d54ca37e2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $4c31235d54ca37e2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $lkwSx.fromByteArray(buf);
    else return $lkwSx.fromByteArray(buf.slice(start, end));
}
function $4c31235d54ca37e2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $4c31235d54ca37e2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $4c31235d54ca37e2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $4c31235d54ca37e2$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $4c31235d54ca37e2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $4c31235d54ca37e2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $4c31235d54ca37e2$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $4c31235d54ca37e2$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $4c31235d54ca37e2$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $4c31235d54ca37e2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $4c31235d54ca37e2$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$4c31235d54ca37e2$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $4c31235d54ca37e2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $4c31235d54ca37e2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$4c31235d54ca37e2$var$Buffer.prototype.readUintLE = $4c31235d54ca37e2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$4c31235d54ca37e2$var$Buffer.prototype.readUintBE = $4c31235d54ca37e2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$4c31235d54ca37e2$var$Buffer.prototype.readUint8 = $4c31235d54ca37e2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$4c31235d54ca37e2$var$Buffer.prototype.readUint16LE = $4c31235d54ca37e2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$4c31235d54ca37e2$var$Buffer.prototype.readUint16BE = $4c31235d54ca37e2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$4c31235d54ca37e2$var$Buffer.prototype.readUint32LE = $4c31235d54ca37e2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$4c31235d54ca37e2$var$Buffer.prototype.readUint32BE = $4c31235d54ca37e2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$4c31235d54ca37e2$var$Buffer.prototype.readBigUInt64LE = $4c31235d54ca37e2$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $4c31235d54ca37e2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4c31235d54ca37e2$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$4c31235d54ca37e2$var$Buffer.prototype.readBigUInt64BE = $4c31235d54ca37e2$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $4c31235d54ca37e2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4c31235d54ca37e2$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$4c31235d54ca37e2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4c31235d54ca37e2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4c31235d54ca37e2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$4c31235d54ca37e2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4c31235d54ca37e2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4c31235d54ca37e2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$4c31235d54ca37e2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$4c31235d54ca37e2$var$Buffer.prototype.readBigInt64LE = $4c31235d54ca37e2$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $4c31235d54ca37e2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4c31235d54ca37e2$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$4c31235d54ca37e2$var$Buffer.prototype.readBigInt64BE = $4c31235d54ca37e2$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $4c31235d54ca37e2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4c31235d54ca37e2$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$4c31235d54ca37e2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 4, this.length);
    return $41jYZ.read(this, offset, true, 23, 4);
};
$4c31235d54ca37e2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 4, this.length);
    return $41jYZ.read(this, offset, false, 23, 4);
};
$4c31235d54ca37e2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 8, this.length);
    return $41jYZ.read(this, offset, true, 52, 8);
};
$4c31235d54ca37e2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkOffset(offset, 8, this.length);
    return $41jYZ.read(this, offset, false, 52, 8);
};
function $4c31235d54ca37e2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$4c31235d54ca37e2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$4c31235d54ca37e2$var$Buffer.prototype.writeUintLE = $4c31235d54ca37e2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4c31235d54ca37e2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeUintBE = $4c31235d54ca37e2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4c31235d54ca37e2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeUint8 = $4c31235d54ca37e2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeUint16LE = $4c31235d54ca37e2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeUint16BE = $4c31235d54ca37e2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeUint32LE = $4c31235d54ca37e2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeUint32BE = $4c31235d54ca37e2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $4c31235d54ca37e2$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $4c31235d54ca37e2$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $4c31235d54ca37e2$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $4c31235d54ca37e2$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$4c31235d54ca37e2$var$Buffer.prototype.writeBigUInt64LE = $4c31235d54ca37e2$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $4c31235d54ca37e2$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$4c31235d54ca37e2$var$Buffer.prototype.writeBigUInt64BE = $4c31235d54ca37e2$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $4c31235d54ca37e2$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$4c31235d54ca37e2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $4c31235d54ca37e2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $4c31235d54ca37e2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$4c31235d54ca37e2$var$Buffer.prototype.writeBigInt64LE = $4c31235d54ca37e2$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $4c31235d54ca37e2$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$4c31235d54ca37e2$var$Buffer.prototype.writeBigInt64BE = $4c31235d54ca37e2$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $4c31235d54ca37e2$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $4c31235d54ca37e2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $4c31235d54ca37e2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $41jYZ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$4c31235d54ca37e2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $4c31235d54ca37e2$var$writeFloat(this, value, offset, true, noAssert);
};
$4c31235d54ca37e2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $4c31235d54ca37e2$var$writeFloat(this, value, offset, false, noAssert);
};
function $4c31235d54ca37e2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c31235d54ca37e2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $41jYZ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$4c31235d54ca37e2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $4c31235d54ca37e2$var$writeDouble(this, value, offset, true, noAssert);
};
$4c31235d54ca37e2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $4c31235d54ca37e2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$4c31235d54ca37e2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$4c31235d54ca37e2$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$4c31235d54ca37e2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$4c31235d54ca37e2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $4c31235d54ca37e2$var$Buffer.isBuffer(val) ? val : $4c31235d54ca37e2$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $4c31235d54ca37e2$var$errors = {};
function $4c31235d54ca37e2$var$E(sym, getMessage, Base) {
    $4c31235d54ca37e2$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$4c31235d54ca37e2$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$4c31235d54ca37e2$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$4c31235d54ca37e2$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $4c31235d54ca37e2$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $4c31235d54ca37e2$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $4c31235d54ca37e2$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $4c31235d54ca37e2$var$checkBounds(buf, offset, byteLength) {
    $4c31235d54ca37e2$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $4c31235d54ca37e2$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $4c31235d54ca37e2$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $4c31235d54ca37e2$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $4c31235d54ca37e2$var$checkBounds(buf, offset, byteLength);
}
function $4c31235d54ca37e2$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $4c31235d54ca37e2$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $4c31235d54ca37e2$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $4c31235d54ca37e2$var$validateNumber(value, type);
        throw new $4c31235d54ca37e2$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $4c31235d54ca37e2$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $4c31235d54ca37e2$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $4c31235d54ca37e2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $4c31235d54ca37e2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($4c31235d54ca37e2$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $4c31235d54ca37e2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $4c31235d54ca37e2$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $4c31235d54ca37e2$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $4c31235d54ca37e2$var$base64ToBytes(str) {
    return $lkwSx.toByteArray($4c31235d54ca37e2$var$base64clean(str));
}
function $4c31235d54ca37e2$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $4c31235d54ca37e2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $4c31235d54ca37e2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $4c31235d54ca37e2$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $4c31235d54ca37e2$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $4c31235d54ca37e2$var$BufferBigIntNotDefined : fn;
}
function $4c31235d54ca37e2$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("lkwSx", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $f874f83e0333656b$export$d622b2ad8d90c771; }, function (v) { return $f874f83e0333656b$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $f874f83e0333656b$export$6100ba28696e12de; }, function (v) { return $f874f83e0333656b$export$6100ba28696e12de = v; });
var $f874f83e0333656b$export$a48f0734ac7c2329;
var $f874f83e0333656b$export$d622b2ad8d90c771;
var $f874f83e0333656b$export$6100ba28696e12de;
'use strict';
$f874f83e0333656b$export$a48f0734ac7c2329 = $f874f83e0333656b$var$byteLength;
$f874f83e0333656b$export$d622b2ad8d90c771 = $f874f83e0333656b$var$toByteArray;
$f874f83e0333656b$export$6100ba28696e12de = $f874f83e0333656b$var$fromByteArray;
var $f874f83e0333656b$var$lookup = [];
var $f874f83e0333656b$var$revLookup = [];
var $f874f83e0333656b$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $f874f83e0333656b$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $f874f83e0333656b$var$i = 0, $f874f83e0333656b$var$len = $f874f83e0333656b$var$code.length; $f874f83e0333656b$var$i < $f874f83e0333656b$var$len; ++$f874f83e0333656b$var$i){
    $f874f83e0333656b$var$lookup[$f874f83e0333656b$var$i] = $f874f83e0333656b$var$code[$f874f83e0333656b$var$i];
    $f874f83e0333656b$var$revLookup[$f874f83e0333656b$var$code.charCodeAt($f874f83e0333656b$var$i)] = $f874f83e0333656b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$f874f83e0333656b$var$revLookup['-'.charCodeAt(0)] = 62;
$f874f83e0333656b$var$revLookup['_'.charCodeAt(0)] = 63;
function $f874f83e0333656b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $f874f83e0333656b$var$byteLength(b64) {
    var lens = $f874f83e0333656b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $f874f83e0333656b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $f874f83e0333656b$var$toByteArray(b64) {
    var tmp;
    var lens = $f874f83e0333656b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $f874f83e0333656b$var$Arr($f874f83e0333656b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $f874f83e0333656b$var$revLookup[b64.charCodeAt(i)] << 18 | $f874f83e0333656b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $f874f83e0333656b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $f874f83e0333656b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $f874f83e0333656b$var$revLookup[b64.charCodeAt(i)] << 2 | $f874f83e0333656b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $f874f83e0333656b$var$revLookup[b64.charCodeAt(i)] << 10 | $f874f83e0333656b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $f874f83e0333656b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $f874f83e0333656b$var$tripletToBase64(num) {
    return $f874f83e0333656b$var$lookup[num >> 18 & 0x3F] + $f874f83e0333656b$var$lookup[num >> 12 & 0x3F] + $f874f83e0333656b$var$lookup[num >> 6 & 0x3F] + $f874f83e0333656b$var$lookup[num & 0x3F];
}
function $f874f83e0333656b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($f874f83e0333656b$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $f874f83e0333656b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($f874f83e0333656b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($f874f83e0333656b$var$lookup[tmp >> 2] + $f874f83e0333656b$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($f874f83e0333656b$var$lookup[tmp >> 10] + $f874f83e0333656b$var$lookup[tmp >> 4 & 0x3F] + $f874f83e0333656b$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("41jYZ", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $2ed6c18fd56957c9$export$aafa59e2e03f2942; }, function (v) { return $2ed6c18fd56957c9$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $2ed6c18fd56957c9$export$68d8715fc104d294; }, function (v) { return $2ed6c18fd56957c9$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $2ed6c18fd56957c9$export$aafa59e2e03f2942;
var $2ed6c18fd56957c9$export$68d8715fc104d294;
$2ed6c18fd56957c9$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$2ed6c18fd56957c9$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("5aakc", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $jOzBz = parcelRequire("jOzBz");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $doXgg = parcelRequire("doXgg");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $doXgg.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $jOzBz.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $doXgg.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $doXgg.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("jOzBz", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("doXgg", function(module, exports) {
'use strict';

var $clsmo = parcelRequire("clsmo");

var $4r3rp = parcelRequire("4r3rp");

var $8W977 = parcelRequire("8W977");
module.exports = {
    formats: $8W977,
    parse: $4r3rp,
    stringify: $clsmo
};

});
parcelRegister("clsmo", function(module, exports) {
'use strict';

var $jMWQY = parcelRequire("jMWQY");

var $9NVGg = parcelRequire("9NVGg");

var $8W977 = parcelRequire("8W977");
var $8fcd71eb920504a7$var$has = Object.prototype.hasOwnProperty;
var $8fcd71eb920504a7$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $8fcd71eb920504a7$var$isArray = Array.isArray;
var $8fcd71eb920504a7$var$push = Array.prototype.push;
var $8fcd71eb920504a7$var$pushToArray = function(arr, valueOrArray) {
    $8fcd71eb920504a7$var$push.apply(arr, $8fcd71eb920504a7$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $8fcd71eb920504a7$var$toISO = Date.prototype.toISOString;
var $8fcd71eb920504a7$var$defaultFormat = $8W977.default;
var $8fcd71eb920504a7$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $9NVGg.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $8fcd71eb920504a7$var$defaultFormat,
    formatter: $8W977.formatters[$8fcd71eb920504a7$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $8fcd71eb920504a7$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $8fcd71eb920504a7$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $8fcd71eb920504a7$var$sentinel = {};
var $8fcd71eb920504a7$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($8fcd71eb920504a7$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($8fcd71eb920504a7$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $8fcd71eb920504a7$var$isArray(obj)) obj = $9NVGg.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $8fcd71eb920504a7$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($8fcd71eb920504a7$var$isNonNullishPrimitive(obj) || $9NVGg.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $8fcd71eb920504a7$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $8fcd71eb920504a7$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $8fcd71eb920504a7$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $9NVGg.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($8fcd71eb920504a7$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $8fcd71eb920504a7$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $8fcd71eb920504a7$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $8fcd71eb920504a7$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $jMWQY();
        valueSideChannel.set($8fcd71eb920504a7$var$sentinel, sideChannel);
        $8fcd71eb920504a7$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $8fcd71eb920504a7$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $8fcd71eb920504a7$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $8fcd71eb920504a7$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $8fcd71eb920504a7$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $8W977.default;
    if (typeof opts.format !== 'undefined') {
        if (!$8fcd71eb920504a7$var$has.call($8W977.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $8W977.formatters[format];
    var filter = $8fcd71eb920504a7$var$defaults.filter;
    if (typeof opts.filter === 'function' || $8fcd71eb920504a7$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $8fcd71eb920504a7$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $8fcd71eb920504a7$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $8fcd71eb920504a7$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $8fcd71eb920504a7$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $8fcd71eb920504a7$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $8fcd71eb920504a7$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $8fcd71eb920504a7$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $8fcd71eb920504a7$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $8fcd71eb920504a7$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $8fcd71eb920504a7$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $8fcd71eb920504a7$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $8fcd71eb920504a7$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $8fcd71eb920504a7$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $8fcd71eb920504a7$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $8fcd71eb920504a7$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($8fcd71eb920504a7$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $8fcd71eb920504a7$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $jMWQY();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $8fcd71eb920504a7$var$pushToArray(keys, $8fcd71eb920504a7$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("jMWQY", function(module, exports) {
'use strict';

var $b0sZj = parcelRequire("b0sZj");

var $bDROc = parcelRequire("bDROc");

var $1xUSh = parcelRequire("1xUSh");

var $aWykl = parcelRequire("aWykl");

var $9DDyW = parcelRequire("9DDyW");
var $e6802718b48c26da$var$makeChannel = $9DDyW || $aWykl || $1xUSh;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $b0sZj('Side channel does not contain ' + $bDROc(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $e6802718b48c26da$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("b0sZj", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("bDROc", function(module, exports) {
var $879d138410cb19e8$var$hasMap = typeof Map === 'function' && Map.prototype;
var $879d138410cb19e8$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $879d138410cb19e8$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $879d138410cb19e8$var$mapSize = $879d138410cb19e8$var$hasMap && $879d138410cb19e8$var$mapSizeDescriptor && typeof $879d138410cb19e8$var$mapSizeDescriptor.get === 'function' ? $879d138410cb19e8$var$mapSizeDescriptor.get : null;
var $879d138410cb19e8$var$mapForEach = $879d138410cb19e8$var$hasMap && Map.prototype.forEach;
var $879d138410cb19e8$var$hasSet = typeof Set === 'function' && Set.prototype;
var $879d138410cb19e8$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $879d138410cb19e8$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $879d138410cb19e8$var$setSize = $879d138410cb19e8$var$hasSet && $879d138410cb19e8$var$setSizeDescriptor && typeof $879d138410cb19e8$var$setSizeDescriptor.get === 'function' ? $879d138410cb19e8$var$setSizeDescriptor.get : null;
var $879d138410cb19e8$var$setForEach = $879d138410cb19e8$var$hasSet && Set.prototype.forEach;
var $879d138410cb19e8$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $879d138410cb19e8$var$weakMapHas = $879d138410cb19e8$var$hasWeakMap ? WeakMap.prototype.has : null;
var $879d138410cb19e8$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $879d138410cb19e8$var$weakSetHas = $879d138410cb19e8$var$hasWeakSet ? WeakSet.prototype.has : null;
var $879d138410cb19e8$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $879d138410cb19e8$var$weakRefDeref = $879d138410cb19e8$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $879d138410cb19e8$var$booleanValueOf = Boolean.prototype.valueOf;
var $879d138410cb19e8$var$objectToString = Object.prototype.toString;
var $879d138410cb19e8$var$functionToString = Function.prototype.toString;
var $879d138410cb19e8$var$$match = String.prototype.match;
var $879d138410cb19e8$var$$slice = String.prototype.slice;
var $879d138410cb19e8$var$$replace = String.prototype.replace;
var $879d138410cb19e8$var$$toUpperCase = String.prototype.toUpperCase;
var $879d138410cb19e8$var$$toLowerCase = String.prototype.toLowerCase;
var $879d138410cb19e8$var$$test = RegExp.prototype.test;
var $879d138410cb19e8$var$$concat = Array.prototype.concat;
var $879d138410cb19e8$var$$join = Array.prototype.join;
var $879d138410cb19e8$var$$arrSlice = Array.prototype.slice;
var $879d138410cb19e8$var$$floor = Math.floor;
var $879d138410cb19e8$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $879d138410cb19e8$var$gOPS = Object.getOwnPropertySymbols;
var $879d138410cb19e8$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $879d138410cb19e8$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $879d138410cb19e8$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $879d138410cb19e8$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $879d138410cb19e8$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $879d138410cb19e8$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $879d138410cb19e8$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $879d138410cb19e8$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$879d138410cb19e8$var$$floor(-num) : $879d138410cb19e8$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $879d138410cb19e8$var$$slice.call(str, intStr.length + 1);
            return $879d138410cb19e8$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $879d138410cb19e8$var$$replace.call($879d138410cb19e8$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $879d138410cb19e8$var$$replace.call(str, sepRegex, '$&_');
}

var $kQzce = parcelRequire("kQzce");
var $879d138410cb19e8$var$inspectCustom = $kQzce.custom;
var $879d138410cb19e8$var$inspectSymbol = $879d138410cb19e8$var$isSymbol($879d138410cb19e8$var$inspectCustom) ? $879d138410cb19e8$var$inspectCustom : null;
var $879d138410cb19e8$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $879d138410cb19e8$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($879d138410cb19e8$var$has(opts, 'quoteStyle') && !$879d138410cb19e8$var$has($879d138410cb19e8$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($879d138410cb19e8$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $879d138410cb19e8$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($879d138410cb19e8$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($879d138410cb19e8$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $879d138410cb19e8$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $879d138410cb19e8$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $879d138410cb19e8$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $879d138410cb19e8$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $879d138410cb19e8$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($879d138410cb19e8$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $879d138410cb19e8$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($879d138410cb19e8$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$879d138410cb19e8$var$isRegExp(obj)) {
        var name = $879d138410cb19e8$var$nameOf(obj);
        var keys = $879d138410cb19e8$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $879d138410cb19e8$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($879d138410cb19e8$var$isSymbol(obj)) {
        var symString = $879d138410cb19e8$var$hasShammedSymbols ? $879d138410cb19e8$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $879d138410cb19e8$var$symToString.call(obj);
        return typeof obj === 'object' && !$879d138410cb19e8$var$hasShammedSymbols ? $879d138410cb19e8$var$markBoxed(symString) : symString;
    }
    if ($879d138410cb19e8$var$isElement(obj)) {
        var s = '<' + $879d138410cb19e8$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $879d138410cb19e8$var$wrapQuotes($879d138410cb19e8$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $879d138410cb19e8$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($879d138410cb19e8$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $879d138410cb19e8$var$arrObjKeys(obj, inspect);
        if (indent && !$879d138410cb19e8$var$singleLineValues(xs)) return '[' + $879d138410cb19e8$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $879d138410cb19e8$var$$join.call(xs, ', ') + ' ]';
    }
    if ($879d138410cb19e8$var$isError(obj)) {
        var parts = $879d138410cb19e8$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$879d138410cb19e8$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $879d138410cb19e8$var$$join.call($879d138410cb19e8$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $879d138410cb19e8$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($879d138410cb19e8$var$inspectSymbol && typeof obj[$879d138410cb19e8$var$inspectSymbol] === 'function' && $kQzce) return $kQzce(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($879d138410cb19e8$var$isMap(obj)) {
        var mapParts = [];
        if ($879d138410cb19e8$var$mapForEach) $879d138410cb19e8$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $879d138410cb19e8$var$collectionOf('Map', $879d138410cb19e8$var$mapSize.call(obj), mapParts, indent);
    }
    if ($879d138410cb19e8$var$isSet(obj)) {
        var setParts = [];
        if ($879d138410cb19e8$var$setForEach) $879d138410cb19e8$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $879d138410cb19e8$var$collectionOf('Set', $879d138410cb19e8$var$setSize.call(obj), setParts, indent);
    }
    if ($879d138410cb19e8$var$isWeakMap(obj)) return $879d138410cb19e8$var$weakCollectionOf('WeakMap');
    if ($879d138410cb19e8$var$isWeakSet(obj)) return $879d138410cb19e8$var$weakCollectionOf('WeakSet');
    if ($879d138410cb19e8$var$isWeakRef(obj)) return $879d138410cb19e8$var$weakCollectionOf('WeakRef');
    if ($879d138410cb19e8$var$isNumber(obj)) return $879d138410cb19e8$var$markBoxed(inspect(Number(obj)));
    if ($879d138410cb19e8$var$isBigInt(obj)) return $879d138410cb19e8$var$markBoxed(inspect($879d138410cb19e8$var$bigIntValueOf.call(obj)));
    if ($879d138410cb19e8$var$isBoolean(obj)) return $879d138410cb19e8$var$markBoxed($879d138410cb19e8$var$booleanValueOf.call(obj));
    if ($879d138410cb19e8$var$isString(obj)) return $879d138410cb19e8$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$879d138410cb19e8$var$isDate(obj) && !$879d138410cb19e8$var$isRegExp(obj)) {
        var ys = $879d138410cb19e8$var$arrObjKeys(obj, inspect);
        var isPlainObject = $879d138410cb19e8$var$gPO ? $879d138410cb19e8$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $879d138410cb19e8$var$toStringTag && Object(obj) === obj && $879d138410cb19e8$var$toStringTag in obj ? $879d138410cb19e8$var$$slice.call($879d138410cb19e8$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $879d138410cb19e8$var$$join.call($879d138410cb19e8$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $879d138410cb19e8$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $879d138410cb19e8$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $879d138410cb19e8$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $879d138410cb19e8$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $879d138410cb19e8$var$quote(s) {
    return $879d138410cb19e8$var$$replace.call(String(s), /"/g, '&quot;');
}
function $879d138410cb19e8$var$canTrustToString(obj) {
    return !$879d138410cb19e8$var$toStringTag || !(typeof obj === 'object' && ($879d138410cb19e8$var$toStringTag in obj || typeof obj[$879d138410cb19e8$var$toStringTag] !== 'undefined'));
}
function $879d138410cb19e8$var$isArray(obj) {
    return $879d138410cb19e8$var$toStr(obj) === '[object Array]' && $879d138410cb19e8$var$canTrustToString(obj);
}
function $879d138410cb19e8$var$isDate(obj) {
    return $879d138410cb19e8$var$toStr(obj) === '[object Date]' && $879d138410cb19e8$var$canTrustToString(obj);
}
function $879d138410cb19e8$var$isRegExp(obj) {
    return $879d138410cb19e8$var$toStr(obj) === '[object RegExp]' && $879d138410cb19e8$var$canTrustToString(obj);
}
function $879d138410cb19e8$var$isError(obj) {
    return $879d138410cb19e8$var$toStr(obj) === '[object Error]' && $879d138410cb19e8$var$canTrustToString(obj);
}
function $879d138410cb19e8$var$isString(obj) {
    return $879d138410cb19e8$var$toStr(obj) === '[object String]' && $879d138410cb19e8$var$canTrustToString(obj);
}
function $879d138410cb19e8$var$isNumber(obj) {
    return $879d138410cb19e8$var$toStr(obj) === '[object Number]' && $879d138410cb19e8$var$canTrustToString(obj);
}
function $879d138410cb19e8$var$isBoolean(obj) {
    return $879d138410cb19e8$var$toStr(obj) === '[object Boolean]' && $879d138410cb19e8$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $879d138410cb19e8$var$isSymbol(obj) {
    if ($879d138410cb19e8$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$879d138410cb19e8$var$symToString) return false;
    try {
        $879d138410cb19e8$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $879d138410cb19e8$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$879d138410cb19e8$var$bigIntValueOf) return false;
    try {
        $879d138410cb19e8$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $879d138410cb19e8$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $879d138410cb19e8$var$has(obj, key) {
    return $879d138410cb19e8$var$hasOwn.call(obj, key);
}
function $879d138410cb19e8$var$toStr(obj) {
    return $879d138410cb19e8$var$objectToString.call(obj);
}
function $879d138410cb19e8$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $879d138410cb19e8$var$$match.call($879d138410cb19e8$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $879d138410cb19e8$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $879d138410cb19e8$var$isMap(x) {
    if (!$879d138410cb19e8$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $879d138410cb19e8$var$mapSize.call(x);
        try {
            $879d138410cb19e8$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $879d138410cb19e8$var$isWeakMap(x) {
    if (!$879d138410cb19e8$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $879d138410cb19e8$var$weakMapHas.call(x, $879d138410cb19e8$var$weakMapHas);
        try {
            $879d138410cb19e8$var$weakSetHas.call(x, $879d138410cb19e8$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $879d138410cb19e8$var$isWeakRef(x) {
    if (!$879d138410cb19e8$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $879d138410cb19e8$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $879d138410cb19e8$var$isSet(x) {
    if (!$879d138410cb19e8$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $879d138410cb19e8$var$setSize.call(x);
        try {
            $879d138410cb19e8$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $879d138410cb19e8$var$isWeakSet(x) {
    if (!$879d138410cb19e8$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $879d138410cb19e8$var$weakSetHas.call(x, $879d138410cb19e8$var$weakSetHas);
        try {
            $879d138410cb19e8$var$weakMapHas.call(x, $879d138410cb19e8$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $879d138410cb19e8$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $879d138410cb19e8$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $879d138410cb19e8$var$inspectString($879d138410cb19e8$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $879d138410cb19e8$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $879d138410cb19e8$var$$replace.call($879d138410cb19e8$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $879d138410cb19e8$var$lowbyte);
    return $879d138410cb19e8$var$wrapQuotes(s, 'single', opts);
}
function $879d138410cb19e8$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $879d138410cb19e8$var$$toUpperCase.call(n.toString(16));
}
function $879d138410cb19e8$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $879d138410cb19e8$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $879d138410cb19e8$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $879d138410cb19e8$var$indentedJoin(entries, indent) : $879d138410cb19e8$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $879d138410cb19e8$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($879d138410cb19e8$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $879d138410cb19e8$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $879d138410cb19e8$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $879d138410cb19e8$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $879d138410cb19e8$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $879d138410cb19e8$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $879d138410cb19e8$var$arrObjKeys(obj, inspect) {
    var isArr = $879d138410cb19e8$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $879d138410cb19e8$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $879d138410cb19e8$var$gOPS === 'function' ? $879d138410cb19e8$var$gOPS(obj) : [];
    var symMap;
    if ($879d138410cb19e8$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$879d138410cb19e8$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($879d138410cb19e8$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($879d138410cb19e8$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $879d138410cb19e8$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($879d138410cb19e8$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("kQzce", function(module, exports) {
"use strict";

});


parcelRegister("1xUSh", function(module, exports) {
'use strict';

var $bDROc = parcelRequire("bDROc");

var $b0sZj = parcelRequire("b0sZj");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $1204fd9da11fc914$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $1204fd9da11fc914$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $1204fd9da11fc914$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $1204fd9da11fc914$var$listSet = function(objects, key, value) {
    var node = $1204fd9da11fc914$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $1204fd9da11fc914$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$1204fd9da11fc914$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $1204fd9da11fc914$var$listDelete = function(objects, key) {
    if (objects) return $1204fd9da11fc914$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $b0sZj('Side channel does not contain ' + $bDROc(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $1204fd9da11fc914$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $1204fd9da11fc914$var$listGet($o, key);
        },
        has: function(key) {
            return $1204fd9da11fc914$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $1204fd9da11fc914$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("aWykl", function(module, exports) {
'use strict';

var $j54Ns = parcelRequire("j54Ns");

var $78ENc = parcelRequire("78ENc");

var $bDROc = parcelRequire("bDROc");

var $b0sZj = parcelRequire("b0sZj");
var $7f79f2cf2a6783f2$var$$Map = $j54Ns('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $7f79f2cf2a6783f2$var$$mapGet = $78ENc('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $7f79f2cf2a6783f2$var$$mapSet = $78ENc('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $7f79f2cf2a6783f2$var$$mapHas = $78ENc('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $7f79f2cf2a6783f2$var$$mapDelete = $78ENc('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $7f79f2cf2a6783f2$var$$mapSize = $78ENc('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$7f79f2cf2a6783f2$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $b0sZj('Side channel does not contain ' + $bDROc(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $7f79f2cf2a6783f2$var$$mapDelete($m, key);
                if ($7f79f2cf2a6783f2$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $7f79f2cf2a6783f2$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $7f79f2cf2a6783f2$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $7f79f2cf2a6783f2$var$$Map();
            $7f79f2cf2a6783f2$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("j54Ns", function(module, exports) {
'use strict';
var $de423478bb75cddb$var$undefined1;

var $8ml4q = parcelRequire("8ml4q");

var $l65iW = parcelRequire("l65iW");

var $5bnXa = parcelRequire("5bnXa");

var $8apCN = parcelRequire("8apCN");

var $icdqH = parcelRequire("icdqH");

var $1e6UN = parcelRequire("1e6UN");

var $b0sZj = parcelRequire("b0sZj");

var $d94am = parcelRequire("d94am");

var $TBv55 = parcelRequire("TBv55");

var $3iaLs = parcelRequire("3iaLs");

var $2CJ2k = parcelRequire("2CJ2k");

var $dl1iJ = parcelRequire("dl1iJ");

var $9jMLi = parcelRequire("9jMLi");

var $jkKuU = parcelRequire("jkKuU");

var $lO0EV = parcelRequire("lO0EV");
var $de423478bb75cddb$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $de423478bb75cddb$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $de423478bb75cddb$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $gLDcD = parcelRequire("gLDcD");

var $gI2bB = parcelRequire("gI2bB");
var $de423478bb75cddb$var$throwTypeError = function() {
    throw new $b0sZj();
};
var $de423478bb75cddb$var$ThrowTypeError = $gLDcD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $de423478bb75cddb$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gLDcD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $de423478bb75cddb$var$throwTypeError;
        }
    }
}() : $de423478bb75cddb$var$throwTypeError;

var $de423478bb75cddb$var$hasSymbols = (parcelRequire("hmeaW"))();

var $5WhrV = parcelRequire("5WhrV");

var $4Kply = parcelRequire("4Kply");

var $9EmmL = parcelRequire("9EmmL");

var $dfeAb = parcelRequire("dfeAb");

var $hZa1S = parcelRequire("hZa1S");
var $de423478bb75cddb$var$needsEval = {};
var $de423478bb75cddb$var$TypedArray = typeof Uint8Array === 'undefined' || !$5WhrV ? undefined : $5WhrV(Uint8Array);
var $de423478bb75cddb$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $de423478bb75cddb$var$hasSymbols && $5WhrV ? $5WhrV([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $de423478bb75cddb$var$needsEval,
    '%AsyncGenerator%': $de423478bb75cddb$var$needsEval,
    '%AsyncGeneratorFunction%': $de423478bb75cddb$var$needsEval,
    '%AsyncIteratorPrototype%': $de423478bb75cddb$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $l65iW,
    '%eval%': eval,
    '%EvalError%': $5bnXa,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $de423478bb75cddb$var$$Function,
    '%GeneratorFunction%': $de423478bb75cddb$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $de423478bb75cddb$var$hasSymbols && $5WhrV ? $5WhrV($5WhrV([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$de423478bb75cddb$var$hasSymbols || !$5WhrV ? undefined : $5WhrV(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $8ml4q,
    '%Object.getOwnPropertyDescriptor%': $gLDcD,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $8apCN,
    '%ReferenceError%': $icdqH,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$de423478bb75cddb$var$hasSymbols || !$5WhrV ? undefined : $5WhrV(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $de423478bb75cddb$var$hasSymbols && $5WhrV ? $5WhrV(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $de423478bb75cddb$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $1e6UN,
    '%ThrowTypeError%': $de423478bb75cddb$var$ThrowTypeError,
    '%TypedArray%': $de423478bb75cddb$var$TypedArray,
    '%TypeError%': $b0sZj,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $d94am,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $hZa1S,
    '%Function.prototype.apply%': $dfeAb,
    '%Object.defineProperty%': $gI2bB,
    '%Object.getPrototypeOf%': $4Kply,
    '%Math.abs%': $TBv55,
    '%Math.floor%': $3iaLs,
    '%Math.max%': $2CJ2k,
    '%Math.min%': $dl1iJ,
    '%Math.pow%': $9jMLi,
    '%Math.round%': $jkKuU,
    '%Math.sign%': $lO0EV,
    '%Reflect.getPrototypeOf%': $9EmmL
};
if ($5WhrV) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $de423478bb75cddb$var$errorProto = $5WhrV($5WhrV(e));
    $de423478bb75cddb$var$INTRINSICS['%Error.prototype%'] = $de423478bb75cddb$var$errorProto;
}
var $de423478bb75cddb$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $de423478bb75cddb$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $de423478bb75cddb$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $de423478bb75cddb$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $5WhrV) value = $5WhrV(gen.prototype);
    }
    $de423478bb75cddb$var$INTRINSICS[name] = value;
    return value;
};
var $de423478bb75cddb$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $9XFZk = parcelRequire("9XFZk");

var $75TcY = parcelRequire("75TcY");
var $de423478bb75cddb$var$$concat = $9XFZk.call($hZa1S, Array.prototype.concat);
var $de423478bb75cddb$var$$spliceApply = $9XFZk.call($dfeAb, Array.prototype.splice);
var $de423478bb75cddb$var$$replace = $9XFZk.call($hZa1S, String.prototype.replace);
var $de423478bb75cddb$var$$strSlice = $9XFZk.call($hZa1S, String.prototype.slice);
var $de423478bb75cddb$var$$exec = $9XFZk.call($hZa1S, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $de423478bb75cddb$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $de423478bb75cddb$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $de423478bb75cddb$var$stringToPath = function stringToPath(string) {
    var first = $de423478bb75cddb$var$$strSlice(string, 0, 1);
    var last = $de423478bb75cddb$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $1e6UN('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $1e6UN('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $de423478bb75cddb$var$$replace(string, $de423478bb75cddb$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $de423478bb75cddb$var$$replace(subString, $de423478bb75cddb$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $de423478bb75cddb$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($75TcY($de423478bb75cddb$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $de423478bb75cddb$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($75TcY($de423478bb75cddb$var$INTRINSICS, intrinsicName)) {
        var value = $de423478bb75cddb$var$INTRINSICS[intrinsicName];
        if (value === $de423478bb75cddb$var$needsEval) value = $de423478bb75cddb$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $b0sZj('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1e6UN('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $b0sZj('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $b0sZj('"allowMissing" argument must be a boolean');
    if ($de423478bb75cddb$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $1e6UN('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $de423478bb75cddb$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $de423478bb75cddb$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $de423478bb75cddb$var$$spliceApply(parts, $de423478bb75cddb$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $de423478bb75cddb$var$$strSlice(part, 0, 1);
        var last = $de423478bb75cddb$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $1e6UN('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($75TcY($de423478bb75cddb$var$INTRINSICS, intrinsicRealName)) value = $de423478bb75cddb$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $b0sZj('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($gLDcD && i + 1 >= parts.length) {
                var desc = $gLDcD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $75TcY(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $de423478bb75cddb$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("8ml4q", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("l65iW", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("5bnXa", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("8apCN", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("icdqH", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("1e6UN", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("d94am", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("TBv55", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("3iaLs", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("2CJ2k", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("dl1iJ", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("9jMLi", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("jkKuU", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("lO0EV", function(module, exports) {
'use strict';

var $eVCWd = parcelRequire("eVCWd");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($eVCWd(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("eVCWd", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("gLDcD", function(module, exports) {
'use strict';

var $krk9F = parcelRequire("krk9F");
var $c34f71fd5fd1b13e$require$$gOPD = $krk9F;
if ($c34f71fd5fd1b13e$require$$gOPD) try {
    $c34f71fd5fd1b13e$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $c34f71fd5fd1b13e$require$$gOPD = null;
}
module.exports = $c34f71fd5fd1b13e$require$$gOPD;

});
parcelRegister("krk9F", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("gI2bB", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $c2a27387fec2bd3b$var$$defineProperty = Object.defineProperty || false;
if ($c2a27387fec2bd3b$var$$defineProperty) try {
    $c2a27387fec2bd3b$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $c2a27387fec2bd3b$var$$defineProperty = false;
}
module.exports = $c2a27387fec2bd3b$var$$defineProperty;

});

parcelRegister("hmeaW", function(module, exports) {
'use strict';
var $ca2f7cb480490cb1$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $evgbF = parcelRequire("evgbF");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $ca2f7cb480490cb1$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $ca2f7cb480490cb1$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $evgbF();
};

});
parcelRegister("evgbF", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("5WhrV", function(module, exports) {
'use strict';

var $9EmmL = parcelRequire("9EmmL");

var $4Kply = parcelRequire("4Kply");

var $jDvBG = parcelRequire("jDvBG");
/** @type {import('.')} */ module.exports = $9EmmL ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $9EmmL(O);
} : $4Kply ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $4Kply(O);
} : $jDvBG ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $jDvBG(O);
} : null;

});
parcelRegister("9EmmL", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("4Kply", function(module, exports) {
'use strict';

var $8ml4q = parcelRequire("8ml4q");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $8ml4q.getPrototypeOf || null;

});

parcelRegister("jDvBG", function(module, exports) {
'use strict';

var $6o8nf = parcelRequire("6o8nf");

var $gLDcD = parcelRequire("gLDcD");
var $e4ba2d441dc929f9$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $e4ba2d441dc929f9$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $e4ba2d441dc929f9$var$desc = !!$e4ba2d441dc929f9$var$hasProtoAccessor && $gLDcD && $gLDcD(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $e4ba2d441dc929f9$var$$Object = Object;
var $e4ba2d441dc929f9$var$$getPrototypeOf = $e4ba2d441dc929f9$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $e4ba2d441dc929f9$var$desc && typeof $e4ba2d441dc929f9$var$desc.get === 'function' ? $6o8nf([
    $e4ba2d441dc929f9$var$desc.get
]) : typeof $e4ba2d441dc929f9$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $e4ba2d441dc929f9$var$$getPrototypeOf(value == null ? value : $e4ba2d441dc929f9$var$$Object(value));
} : false;

});
parcelRegister("6o8nf", function(module, exports) {
'use strict';

var $9XFZk = parcelRequire("9XFZk");

var $b0sZj = parcelRequire("b0sZj");

var $hZa1S = parcelRequire("hZa1S");

var $igo3S = parcelRequire("igo3S");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $b0sZj('a function is required');
    return $igo3S($9XFZk, $hZa1S, args);
};

});
parcelRegister("9XFZk", function(module, exports) {
'use strict';

var $knrdW = parcelRequire("knrdW");
module.exports = Function.prototype.bind || $knrdW;

});
parcelRegister("knrdW", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $ed5b12b320453323$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $ed5b12b320453323$var$toStr = Object.prototype.toString;
var $ed5b12b320453323$var$max = Math.max;
var $ed5b12b320453323$var$funcType = '[object Function]';
var $ed5b12b320453323$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $ed5b12b320453323$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $ed5b12b320453323$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $ed5b12b320453323$var$toStr.apply(target) !== $ed5b12b320453323$var$funcType) throw new TypeError($ed5b12b320453323$var$ERROR_MESSAGE + target);
    var args = $ed5b12b320453323$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $ed5b12b320453323$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $ed5b12b320453323$var$concatty(args, arguments));
    };
    var boundLength = $ed5b12b320453323$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $ed5b12b320453323$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("hZa1S", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("igo3S", function(module, exports) {
'use strict';

var $9XFZk = parcelRequire("9XFZk");

var $dfeAb = parcelRequire("dfeAb");

var $hZa1S = parcelRequire("hZa1S");

var $4unSX = parcelRequire("4unSX");
/** @type {import('./actualApply')} */ module.exports = $4unSX || $9XFZk.call($hZa1S, $dfeAb);

});
parcelRegister("dfeAb", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("4unSX", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("75TcY", function(module, exports) {
'use strict';
var $52a3d3437bb7950c$var$call = Function.prototype.call;
var $52a3d3437bb7950c$var$$hasOwn = Object.prototype.hasOwnProperty;

var $9XFZk = parcelRequire("9XFZk");
/** @type {import('.')} */ module.exports = $9XFZk.call($52a3d3437bb7950c$var$call, $52a3d3437bb7950c$var$$hasOwn);

});


parcelRegister("78ENc", function(module, exports) {
'use strict';

var $j54Ns = parcelRequire("j54Ns");

var $6o8nf = parcelRequire("6o8nf");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $5328ec4df7f12631$var$$indexOf = $6o8nf([
    $j54Ns('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $j54Ns(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $5328ec4df7f12631$var$$indexOf(name, '.prototype.') > -1) return $6o8nf(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("9DDyW", function(module, exports) {
'use strict';

var $j54Ns = parcelRequire("j54Ns");

var $78ENc = parcelRequire("78ENc");

var $bDROc = parcelRequire("bDROc");

var $aWykl = parcelRequire("aWykl");

var $b0sZj = parcelRequire("b0sZj");
var $704671e4cc9151ae$var$$WeakMap = $j54Ns('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $704671e4cc9151ae$var$$weakMapGet = $78ENc('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $704671e4cc9151ae$var$$weakMapSet = $78ENc('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $704671e4cc9151ae$var$$weakMapHas = $78ENc('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $704671e4cc9151ae$var$$weakMapDelete = $78ENc('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $704671e4cc9151ae$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $b0sZj('Side channel does not contain ' + $bDROc(key));
        },
        'delete': function(key) {
            if ($704671e4cc9151ae$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $704671e4cc9151ae$var$$weakMapDelete($wm, key);
            } else if ($aWykl) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($704671e4cc9151ae$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $704671e4cc9151ae$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($704671e4cc9151ae$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $704671e4cc9151ae$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($704671e4cc9151ae$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $704671e4cc9151ae$var$$WeakMap();
                $704671e4cc9151ae$var$$weakMapSet($wm, key, value);
            } else if ($aWykl) {
                if (!$m) $m = $aWykl();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $aWykl;

});


parcelRegister("9NVGg", function(module, exports) {
'use strict';

var $8W977 = parcelRequire("8W977");

var $jMWQY = parcelRequire("jMWQY");
var $72356ed165ccee8d$var$has = Object.prototype.hasOwnProperty;
var $72356ed165ccee8d$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $72356ed165ccee8d$var$overflowChannel = $jMWQY();
var $72356ed165ccee8d$var$markOverflow = function markOverflow(obj, maxIndex) {
    $72356ed165ccee8d$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $72356ed165ccee8d$var$isOverflow = function isOverflow(obj) {
    return $72356ed165ccee8d$var$overflowChannel.has(obj);
};
var $72356ed165ccee8d$var$getMaxIndex = function getMaxIndex(obj) {
    return $72356ed165ccee8d$var$overflowChannel.get(obj);
};
var $72356ed165ccee8d$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $72356ed165ccee8d$var$overflowChannel.set(obj, maxIndex);
};
var $72356ed165ccee8d$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $72356ed165ccee8d$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($72356ed165ccee8d$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $72356ed165ccee8d$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $72356ed165ccee8d$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($72356ed165ccee8d$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex > options.arrayLimit) return $72356ed165ccee8d$var$markOverflow($72356ed165ccee8d$var$arrayToObject(target.concat(source), options), nextIndex);
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($72356ed165ccee8d$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $72356ed165ccee8d$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $72356ed165ccee8d$var$setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) return [
                target,
                source
            ];
            else if (options && (options.plainObjects || options.allowPrototypes) || !$72356ed165ccee8d$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($72356ed165ccee8d$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $72356ed165ccee8d$var$markOverflow(result, $72356ed165ccee8d$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) return $72356ed165ccee8d$var$markOverflow($72356ed165ccee8d$var$arrayToObject(combined, options), combined.length - 1);
        return combined;
    }
    var mergeTarget = target;
    if ($72356ed165ccee8d$var$isArray(target) && !$72356ed165ccee8d$var$isArray(source)) mergeTarget = $72356ed165ccee8d$var$arrayToObject(target, options);
    if ($72356ed165ccee8d$var$isArray(target) && $72356ed165ccee8d$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($72356ed165ccee8d$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($72356ed165ccee8d$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        if ($72356ed165ccee8d$var$isOverflow(source) && !$72356ed165ccee8d$var$isOverflow(acc)) $72356ed165ccee8d$var$markOverflow(acc, $72356ed165ccee8d$var$getMaxIndex(source));
        if ($72356ed165ccee8d$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $72356ed165ccee8d$var$getMaxIndex(acc)) $72356ed165ccee8d$var$setMaxIndex(acc, keyNum);
        }
        return acc;
    }, mergeTarget);
};
var $72356ed165ccee8d$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $72356ed165ccee8d$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $72356ed165ccee8d$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $72356ed165ccee8d$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $72356ed165ccee8d$var$limit){
        var segment = string.length >= $72356ed165ccee8d$var$limit ? string.slice(j, j + $72356ed165ccee8d$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $8W977.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $72356ed165ccee8d$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $72356ed165ccee8d$var$hexTable[0xC0 | c >> 6] + $72356ed165ccee8d$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $72356ed165ccee8d$var$hexTable[0xE0 | c >> 12] + $72356ed165ccee8d$var$hexTable[0x80 | c >> 6 & 0x3F] + $72356ed165ccee8d$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $72356ed165ccee8d$var$hexTable[0xF0 | c >> 18] + $72356ed165ccee8d$var$hexTable[0x80 | c >> 12 & 0x3F] + $72356ed165ccee8d$var$hexTable[0x80 | c >> 6 & 0x3F] + $72356ed165ccee8d$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $72356ed165ccee8d$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs[refs.length] = val;
            }
        }
    }
    $72356ed165ccee8d$var$compactQueue(queue);
    return value;
};
var $72356ed165ccee8d$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $72356ed165ccee8d$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $72356ed165ccee8d$var$combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if ($72356ed165ccee8d$var$isOverflow(a)) {
        var newIndex = $72356ed165ccee8d$var$getMaxIndex(a) + 1;
        a[newIndex] = b;
        $72356ed165ccee8d$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) return $72356ed165ccee8d$var$markOverflow($72356ed165ccee8d$var$arrayToObject(result, {
        plainObjects: plainObjects
    }), result.length - 1);
    return result;
};
var $72356ed165ccee8d$var$maybeMap = function maybeMap(val, fn) {
    if ($72356ed165ccee8d$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $72356ed165ccee8d$var$arrayToObject,
    assign: $72356ed165ccee8d$var$assign,
    combine: $72356ed165ccee8d$var$combine,
    compact: $72356ed165ccee8d$var$compact,
    decode: $72356ed165ccee8d$var$decode,
    encode: $72356ed165ccee8d$var$encode,
    isBuffer: $72356ed165ccee8d$var$isBuffer,
    isOverflow: $72356ed165ccee8d$var$isOverflow,
    isRegExp: $72356ed165ccee8d$var$isRegExp,
    markOverflow: $72356ed165ccee8d$var$markOverflow,
    maybeMap: $72356ed165ccee8d$var$maybeMap,
    merge: $72356ed165ccee8d$var$merge
};

});
parcelRegister("8W977", function(module, exports) {
'use strict';
var $681acf4e16405af7$var$replace = String.prototype.replace;
var $681acf4e16405af7$var$percentTwenties = /%20/g;
var $681acf4e16405af7$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $681acf4e16405af7$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $681acf4e16405af7$var$replace.call(value, $681acf4e16405af7$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $681acf4e16405af7$var$Format.RFC1738,
    RFC3986: $681acf4e16405af7$var$Format.RFC3986
};

});



parcelRegister("4r3rp", function(module, exports) {
'use strict';

var $9NVGg = parcelRequire("9NVGg");
var $33ac5a63a5910067$var$has = Object.prototype.hasOwnProperty;
var $33ac5a63a5910067$var$isArray = Array.isArray;
var $33ac5a63a5910067$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $9NVGg.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $33ac5a63a5910067$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $33ac5a63a5910067$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $33ac5a63a5910067$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $33ac5a63a5910067$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $33ac5a63a5910067$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $33ac5a63a5910067$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $33ac5a63a5910067$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $33ac5a63a5910067$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $33ac5a63a5910067$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $9NVGg.maybeMap($33ac5a63a5910067$var$parseArrayValue(part.slice(pos + 1), options, $33ac5a63a5910067$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $33ac5a63a5910067$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $33ac5a63a5910067$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $33ac5a63a5910067$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $33ac5a63a5910067$var$isArray(val) && val.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            val = $9NVGg.combine([], val, options.arrayLimit, options.plainObjects);
        }
        if (key !== null) {
            var existing = $33ac5a63a5910067$var$has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) obj[key] = $9NVGg.combine(obj[key], val, options.arrayLimit, options.plainObjects);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $33ac5a63a5910067$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $33ac5a63a5910067$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($9NVGg.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $9NVGg.combine([], leaf, options.arrayLimit, options.plainObjects);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $9NVGg.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $33ac5a63a5910067$var$splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    if (options.depth <= 0) {
        if (!options.plainObjects && $33ac5a63a5910067$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    var keys = [];
    if (parent) {
        if (!options.plainObjects && $33ac5a63a5910067$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys[keys.length] = parent;
    }
    var i = 0;
    while((segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && $33ac5a63a5910067$var$has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) return;
        }
        keys[keys.length] = segment[1];
    }
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys[keys.length] = '[' + key.slice(segment.index) + ']';
    }
    return keys;
};
var $33ac5a63a5910067$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $33ac5a63a5910067$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $33ac5a63a5910067$var$parseObject(keys, val, options, valuesParsed);
};
var $33ac5a63a5910067$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $33ac5a63a5910067$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $33ac5a63a5910067$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $33ac5a63a5910067$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $33ac5a63a5910067$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $33ac5a63a5910067$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $33ac5a63a5910067$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $33ac5a63a5910067$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $33ac5a63a5910067$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $33ac5a63a5910067$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $33ac5a63a5910067$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $33ac5a63a5910067$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $33ac5a63a5910067$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $9NVGg.isRegExp(opts.delimiter) ? opts.delimiter : $33ac5a63a5910067$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $33ac5a63a5910067$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $33ac5a63a5910067$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $33ac5a63a5910067$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $33ac5a63a5910067$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $33ac5a63a5910067$var$defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : $33ac5a63a5910067$var$defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $33ac5a63a5910067$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $33ac5a63a5910067$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $33ac5a63a5910067$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $33ac5a63a5910067$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $9NVGg.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $9NVGg.compact(obj);
};

});







parcelRegister("fcxz7", function(module, exports) {

$parcel$export(module.exports, "applicationsMetadata", function () { return $3624b480c880bc9c$export$cf56fc31502f6a64; });
$parcel$export(module.exports, "applicationSelector", function () { return $3624b480c880bc9c$export$5b2ad1bf581a1d7b; });
$parcel$export(module.exports, "lookupApplication", function () { return $3624b480c880bc9c$export$105c92f8798550c7; });
$parcel$export(module.exports, "cobrandingURLParams", function () { return $3624b480c880bc9c$export$5a5f77d52a5485dc; });
$parcel$export(module.exports, "getMicrobrandingFromUrl", function () { return $3624b480c880bc9c$export$dace4fb1afc7ad6b; });
$parcel$export(module.exports, "isTrelloDesktop", function () { return $3624b480c880bc9c$export$5824ecd2b22a2ece; });
$parcel$export(module.exports, "replaceQueryParam", function () { return $3624b480c880bc9c$export$70c3f4404feb54c5; });

var $1JRGy = parcelRequire("1JRGy");
parcelRequire("65XXq");
var $aMRBJ = parcelRequire("aMRBJ");
const $3624b480c880bc9c$export$cf56fc31502f6a64 = {
    admin: {
        name: 'Adminhub',
        useInLoginPrompt: false
    },
    access: {
        name: 'Adminhub',
        useInLoginPrompt: false
    },
    ace: {
        name: 'Atlassian Community Events',
        useInLoginPrompt: false
    },
    atlas: {
        name: 'Atlas',
        useInLoginPrompt: true
    },
    bitbucket: {
        name: 'Bitbucket',
        useInLoginPrompt: true
    },
    community: {
        name: 'Community',
        useInLoginPrompt: true
    },
    cac: {
        name: 'Documentation',
        useInLoginPrompt: true
    },
    dac: {
        name: 'Developer Portal',
        useInLoginPrompt: true
    },
    experts: {
        name: 'Partner Program',
        useInLoginPrompt: true
    },
    'itap-uat-backend': {
        name: 'itap-uat-backend',
        useInLoginPrompt: false
    },
    jac: {
        name: 'Atlassian Bug Reporting & Feature Requests'
    },
    mpac: {
        name: 'Marketplace',
        useInLoginPrompt: true
    },
    profile: {
        name: 'Atlassian'
    },
    prt: {
        name: 'Primary Refresh Token Test'
    },
    'manage-profile': {
        name: 'Atlassian account',
        useInLoginPrompt: false
    },
    sac: {
        name: 'Support',
        useInLoginPrompt: true
    },
    teamcentral: {
        name: 'Team Central',
        useInLoginPrompt: false
    },
    trello: {
        name: 'Trello',
        useInLoginPrompt: true
    },
    mac: {
        name: 'My Atlassian',
        useInLoginPrompt: true
    },
    jira: {
        name: 'Jira',
        useInLoginPrompt: true
    },
    loom: {
        name: 'Loom',
        useInLoginPrompt: true
    },
    'jira-align': {
        name: 'Jira Align',
        useInLoginPrompt: true
    },
    confluence: {
        name: 'Confluence',
        useInLoginPrompt: true
    },
    ondemand: {
        name: 'Atlassian Cloud',
        useInLoginPrompt: false
    },
    opsgenie: {
        name: 'Opsgenie',
        useInLoginPrompt: true
    },
    rovo: {
        name: 'Rovo',
        useInLoginPrompt: false
    },
    start: {
        name: 'Start',
        useInLoginPrompt: false
    },
    megamanzero: {
        name: 'MegamanZero',
        useInLoginPrompt: false
    },
    pollinator: {
        // for functional testing
        name: 'Pollinator',
        useInLoginPrompt: false
    },
    wac: {
        name: 'Atlassian',
        useInLoginPrompt: false
    },
    compass: {
        name: 'Compass',
        useInLoginPrompt: true
    },
    sourcetree: {
        name: 'Sourcetree',
        useInLoginPrompt: false
    },
    statuspage: {
        name: 'Statuspage'
    },
    uac: {
        name: 'UAC',
        useInLoginPrompt: false
    },
    support: {
        name: 'Support',
        useInLoginPrompt: true
    }
};
const $3624b480c880bc9c$export$5b2ad1bf581a1d7b = (0, $aMRBJ.createSelector)((state)=>state.cobranding, (cobranding)=>$3624b480c880bc9c$export$105c92f8798550c7(cobranding));
function $3624b480c880bc9c$export$105c92f8798550c7(cobranding) {
    const applicationFromContinue = $3624b480c880bc9c$var$coreApplicationFromContinueUrl();
    const { coreApplication: coreApplicationFromQueryParameter, experience: experienceFromQueryParameter } = $3624b480c880bc9c$var$getAndParseApplicationSearchParam();
    const coreApplication = cobranding.derivedApplication || applicationFromContinue || coreApplicationFromQueryParameter;
    const experience = cobranding.experience || experienceFromQueryParameter;
    if (coreApplication) {
        const appData = $3624b480c880bc9c$export$cf56fc31502f6a64[coreApplication];
        if (appData) return {
            coreApplication: coreApplication,
            experience: experience,
            ...appData
        };
    }
    return null;
}
const $3624b480c880bc9c$export$5a5f77d52a5485dc = (location, productHint)=>{
    const params = $1JRGy.parse(location.search);
    const allParams = productHint !== undefined && productHint !== null ? {
        ...params,
        productHint: productHint
    } : {
        ...params
    };
    const filteredCobrandingParams = Object.keys(allParams).filter((key)=>[
            'continue',
            'application',
            'display',
            'productHint'
        ].includes(key)).reduce((o, key)=>{
        o[key] = allParams[key];
        return o;
    }, {});
    const cobrandingURLParams = filteredCobrandingParams && Object.keys(filteredCobrandingParams).length ? {
        ...filteredCobrandingParams
    } : '';
    return cobrandingURLParams;
};
function $3624b480c880bc9c$export$dace4fb1afc7ad6b(location) {
    const params = $1JRGy.parse(location.search);
    return Object.keys(params).filter((key)=>[
            'application',
            'continue',
            'tenant'
        ].includes(key)).reduce((o, key)=>{
        o[key] = params[key];
        return o;
    }, {});
}
const $3624b480c880bc9c$export$ae5bd94b7585e9d5 = [
    '/admin',
    '/login',
    '/logout',
    '/impersonate',
    '/home',
    '/people',
    '/trusted-admin',
    '/forge-apps'
];
/**
 * Determine the cobranding application from the `?continue=...` URL param as a last resort.
 *
 * **This code should _only_ be relied upon for situations where passing an `?application=...`
 * param or product hint is not possible**, such as within Slack's direct initiate flow. In OIDC
 * flows applications should pass a product hint, and in all other flows applications should pass
 * an `?application=...` param to id.a.c.
 */ function $3624b480c880bc9c$var$coreApplicationFromContinueUrl() {
    const params = $1JRGy.parse(window.location.search);
    const continueParam = params.continue;
    if (!continueParam) return null;
    try {
        const continueUrl = new URL(continueParam, window.location.origin);
        const { hostname: hostname, pathname: pathname, searchParams: searchParams } = continueUrl;
        if ([
            'bitbucket.org',
            'integration.bb-inf.net'
        ].includes(hostname)) return 'bitbucket';
        else if ([
            '.opsgenie.com',
            '.opsgeni.us'
        ].some((domain)=>hostname.endsWith(domain))) return 'opsgenie';
        else if ([
            'manage.statuspage.io',
            'manage.statuspagestaging.com'
        ].includes(hostname)) return 'statuspage';
        else if ([
            'trello.com',
            'trellis.coffee'
        ].includes(hostname)) return 'trello';
        else if ([
            'atlassian.com',
            'www.atlassian.com',
            'wac.stg.internal.atlassian.com'
        ].includes(hostname)) return 'wac';
        else if ([
            'team.atlassian.com',
            'team.stg.atlassian.com'
        ].includes(hostname)) return 'atlas';
        else if ([
            '.atlassian.net',
            'atlassian-fex.net',
            '.jira-dev.com'
        ].some((domain)=>hostname.endsWith(domain))) {
            const unwrappedContinueUrl = pathname === '/login' && searchParams.get('dest-url') ? new URL(searchParams.get('dest-url'), continueUrl) : continueUrl;
            const { pathname: unwrappedPathname } = unwrappedContinueUrl;
            if (unwrappedPathname === '/wiki' || unwrappedPathname.startsWith('/wiki/')) return 'confluence';
            else if (unwrappedPathname === '/compass' || unwrappedPathname.startsWith('/compass/')) return 'compass';
            else if (// Root could be Jira or Conflience
            unwrappedPathname !== '/' && !$3624b480c880bc9c$export$ae5bd94b7585e9d5.some((prefix)=>unwrappedPathname === prefix || unwrappedPathname.startsWith(`${prefix}/`))) return 'jira';
        }
    } catch (error) {
    // Malformed URL, ignore
    }
    return null;
}
function $3624b480c880bc9c$var$getAndParseApplicationSearchParam() {
    try {
        const [coreApplication, experience] = new URLSearchParams(window.location.search).get('application')?.split('--') || [];
        if (coreApplication && $3624b480c880bc9c$var$isValidApplication(coreApplication)) return {
            coreApplication: coreApplication,
            experience: experience
        };
    } catch (error) {
    // Malformed query parameter, ignore
    }
    return {
        coreApplication: null,
        experience: null
    };
}
function $3624b480c880bc9c$export$5824ecd2b22a2ece() {
    const userAgent = window.navigator.userAgent;
    return userAgent.includes('TrelloDesktop');
}
const $3624b480c880bc9c$export$e248db7c9a3cd59 = (app)=>app && $3624b480c880bc9c$export$cf56fc31502f6a64[app] ? $3624b480c880bc9c$export$cf56fc31502f6a64[app].name : 'Atlassian';
const $3624b480c880bc9c$var$isValidApplication = (application)=>Object.keys($3624b480c880bc9c$export$cf56fc31502f6a64).includes(application);
function $3624b480c880bc9c$export$70c3f4404feb54c5(paramName, paramValue) {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set(paramName, paramValue);
    const queryString = queryParams.toString();
    return queryString ? `?${queryString}` : '';
}

});
parcelRegister("65XXq", function(module, exports) {

$parcel$export(module.exports, "configureStore", function () { return $4701b7fe8a289f17$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createSelector", function () { return (parcelRequire("aMRBJ")).createSelector; });

var $lJr9B = parcelRequire("lJr9B");

var $ka48w = parcelRequire("ka48w");

var $aMRBJ = parcelRequire("aMRBJ");

var $7Kr3u = parcelRequire("7Kr3u");

var $4ilBr = parcelRequire("4ilBr");
var $4701b7fe8a289f17$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4701b7fe8a289f17$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4701b7fe8a289f17$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $4701b7fe8a289f17$var$__defProp = Object.defineProperty;
var $4701b7fe8a289f17$var$__defProps = Object.defineProperties;
var $4701b7fe8a289f17$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4701b7fe8a289f17$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4701b7fe8a289f17$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4701b7fe8a289f17$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4701b7fe8a289f17$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $4701b7fe8a289f17$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $4701b7fe8a289f17$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($4701b7fe8a289f17$var$__hasOwnProp.call(b, prop)) $4701b7fe8a289f17$var$__defNormalProp(a, prop, b[prop]);
    if ($4701b7fe8a289f17$var$__getOwnPropSymbols) for(var _i = 0, _c = $4701b7fe8a289f17$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($4701b7fe8a289f17$var$__propIsEnum.call(b, prop)) $4701b7fe8a289f17$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4701b7fe8a289f17$var$__spreadProps = function(a, b) {
    return $4701b7fe8a289f17$var$__defProps(a, $4701b7fe8a289f17$var$__getOwnPropDescs(b));
};
var $4701b7fe8a289f17$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $4701b7fe8a289f17$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $aMRBJ.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $4701b7fe8a289f17$var$__spreadArray([
            (0, $lJr9B.isDraft)(value) ? (0, $lJr9B.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $4701b7fe8a289f17$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $ka48w.compose;
    return (0, $ka48w.compose).apply(null, arguments);
};
var $4701b7fe8a289f17$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $4701b7fe8a289f17$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $4701b7fe8a289f17$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $4701b7fe8a289f17$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $4701b7fe8a289f17$var$__spreadValues($4701b7fe8a289f17$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $4701b7fe8a289f17$export$b956e38827fca970(action) {
    return $4701b7fe8a289f17$export$53b83ca8eaab0383(action) && "type" in action;
}
function $4701b7fe8a289f17$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $4701b7fe8a289f17$var$hasMatchFunction(action);
}
function $4701b7fe8a289f17$export$ebd532f9034651f3(action) {
    return $4701b7fe8a289f17$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($4701b7fe8a289f17$var$isValidKey);
}
function $4701b7fe8a289f17$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $4701b7fe8a289f17$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $4701b7fe8a289f17$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $4701b7fe8a289f17$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $4701b7fe8a289f17$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $4701b7fe8a289f17$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $4701b7fe8a289f17$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $4701b7fe8a289f17$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $4701b7fe8a289f17$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $4701b7fe8a289f17$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $4701b7fe8a289f17$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $4701b7fe8a289f17$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $4701b7fe8a289f17$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $4701b7fe8a289f17$var$freezeDraftable(val) {
    return (0, $lJr9B.isDraftable)(val) ? (0, $lJr9B.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $4701b7fe8a289f17$var$isProduction = true;
var $4701b7fe8a289f17$var$prefix = "Invariant failed";
function $4701b7fe8a289f17$var$invariant(condition, message) {
    if (condition) return;
    if ($4701b7fe8a289f17$var$isProduction) throw new Error($4701b7fe8a289f17$var$prefix);
    throw new Error($4701b7fe8a289f17$var$prefix + ": " + (message || ""));
}
function $4701b7fe8a289f17$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $4701b7fe8a289f17$var$getSerialize(serializer, decycler), indent);
}
function $4701b7fe8a289f17$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $4701b7fe8a289f17$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $4701b7fe8a289f17$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $4701b7fe8a289f17$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $4701b7fe8a289f17$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $4701b7fe8a289f17$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $4701b7fe8a289f17$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $4701b7fe8a289f17$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $4701b7fe8a289f17$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $4701b7fe8a289f17$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $4701b7fe8a289f17$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $4701b7fe8a289f17$export$53b83ca8eaab0383(val);
}
function $4701b7fe8a289f17$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $4701b7fe8a289f17$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $4701b7fe8a289f17$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $4701b7fe8a289f17$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $4701b7fe8a289f17$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$4701b7fe8a289f17$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $4701b7fe8a289f17$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $4701b7fe8a289f17$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $4701b7fe8a289f17$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $4701b7fe8a289f17$export$36c1185aeee5b0a6(options);
    };
}
function $4701b7fe8a289f17$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $4701b7fe8a289f17$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($4701b7fe8a289f17$var$isBoolean(thunk)) middlewareArray.push((0, $7Kr3u.default));
        else middlewareArray.push((0, $7Kr3u.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $4701b7fe8a289f17$var$IS_PRODUCTION = true;
function $4701b7fe8a289f17$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $4701b7fe8a289f17$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($4701b7fe8a289f17$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $ka48w.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$4701b7fe8a289f17$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$4701b7fe8a289f17$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $ka48w.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $ka48w.compose);
    if (devTools) finalCompose = $4701b7fe8a289f17$var$composeWithDevTools($4701b7fe8a289f17$var$__spreadValues({
        trace: !$4701b7fe8a289f17$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $4701b7fe8a289f17$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $4701b7fe8a289f17$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $ka48w.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $4701b7fe8a289f17$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $4701b7fe8a289f17$var$isStateFunction(x) {
    return typeof x === "function";
}
var $4701b7fe8a289f17$var$hasWarnedAboutObjectNotation = false;
function $4701b7fe8a289f17$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $4701b7fe8a289f17$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($4701b7fe8a289f17$var$isStateFunction(initialState)) getInitialState = function() {
        return $4701b7fe8a289f17$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $4701b7fe8a289f17$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $4701b7fe8a289f17$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $lJr9B.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $lJr9B.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $lJr9B.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $4701b7fe8a289f17$var$hasWarnedAboutObjectNotation2 = false;
function $4701b7fe8a289f17$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $4701b7fe8a289f17$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $4ilBr;
    var initialState = typeof options.initialState == "function" ? options.initialState : $4701b7fe8a289f17$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $4701b7fe8a289f17$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $4701b7fe8a289f17$export$309c7a02b0b0bc62(type, prepareCallback) : $4701b7fe8a289f17$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $4701b7fe8a289f17$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $4701b7fe8a289f17$var$__spreadValues($4701b7fe8a289f17$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $4701b7fe8a289f17$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $4701b7fe8a289f17$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $4701b7fe8a289f17$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($4701b7fe8a289f17$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $4701b7fe8a289f17$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $4701b7fe8a289f17$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $4701b7fe8a289f17$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $4701b7fe8a289f17$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $4701b7fe8a289f17$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $4701b7fe8a289f17$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $4701b7fe8a289f17$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $4701b7fe8a289f17$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $4701b7fe8a289f17$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $4701b7fe8a289f17$var$createSingleArgumentStateOperator(mutator) {
    var operator = $4701b7fe8a289f17$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $4701b7fe8a289f17$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $4701b7fe8a289f17$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $lJr9B.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $lJr9B.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $4701b7fe8a289f17$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $4701b7fe8a289f17$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $4701b7fe8a289f17$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $4701b7fe8a289f17$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $4701b7fe8a289f17$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $4701b7fe8a289f17$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $4701b7fe8a289f17$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $4701b7fe8a289f17$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $4701b7fe8a289f17$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $4701b7fe8a289f17$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $4701b7fe8a289f17$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $4701b7fe8a289f17$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $4701b7fe8a289f17$var$__spreadValues($4701b7fe8a289f17$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $4701b7fe8a289f17$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $4701b7fe8a289f17$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $4701b7fe8a289f17$var$createStateOperator(addOneMutably),
        addMany: $4701b7fe8a289f17$var$createStateOperator(addManyMutably),
        setOne: $4701b7fe8a289f17$var$createStateOperator(setOneMutably),
        setMany: $4701b7fe8a289f17$var$createStateOperator(setManyMutably),
        setAll: $4701b7fe8a289f17$var$createStateOperator(setAllMutably),
        updateOne: $4701b7fe8a289f17$var$createStateOperator(updateOneMutably),
        updateMany: $4701b7fe8a289f17$var$createStateOperator(updateManyMutably),
        upsertOne: $4701b7fe8a289f17$var$createStateOperator(upsertOneMutably),
        upsertMany: $4701b7fe8a289f17$var$createStateOperator(upsertManyMutably),
        removeOne: $4701b7fe8a289f17$var$createStateOperator(removeOneMutably),
        removeMany: $4701b7fe8a289f17$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $4701b7fe8a289f17$var$createSortedStateAdapter(selectId, sort) {
    var _c = $4701b7fe8a289f17$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $4701b7fe8a289f17$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($4701b7fe8a289f17$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $4701b7fe8a289f17$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $4701b7fe8a289f17$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $4701b7fe8a289f17$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $4701b7fe8a289f17$var$createStateOperator(addOneMutably),
        updateOne: $4701b7fe8a289f17$var$createStateOperator(updateOneMutably),
        upsertOne: $4701b7fe8a289f17$var$createStateOperator(upsertOneMutably),
        setOne: $4701b7fe8a289f17$var$createStateOperator(setOneMutably),
        setMany: $4701b7fe8a289f17$var$createStateOperator(setManyMutably),
        setAll: $4701b7fe8a289f17$var$createStateOperator(setAllMutably),
        addMany: $4701b7fe8a289f17$var$createStateOperator(addManyMutably),
        updateMany: $4701b7fe8a289f17$var$createStateOperator(updateManyMutably),
        upsertMany: $4701b7fe8a289f17$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $4701b7fe8a289f17$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $4701b7fe8a289f17$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $4701b7fe8a289f17$var$createInitialStateFactory();
    var selectorsFactory = $4701b7fe8a289f17$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $4701b7fe8a289f17$var$createSortedStateAdapter(selectId, sortComparer) : $4701b7fe8a289f17$var$createUnsortedStateAdapter(selectId);
    return $4701b7fe8a289f17$var$__spreadValues($4701b7fe8a289f17$var$__spreadValues($4701b7fe8a289f17$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $4701b7fe8a289f17$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $4701b7fe8a289f17$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $4701b7fe8a289f17$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $4701b7fe8a289f17$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $4701b7fe8a289f17$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $4701b7fe8a289f17$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $4701b7fe8a289f17$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $4701b7fe8a289f17$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $4701b7fe8a289f17$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $4701b7fe8a289f17$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $4701b7fe8a289f17$var$__spreadProps($4701b7fe8a289f17$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $4701b7fe8a289f17$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $4701b7fe8a289f17$var$__spreadProps($4701b7fe8a289f17$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $4701b7fe8a289f17$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $4701b7fe8a289f17$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $4701b7fe8a289f17$var$__spreadProps($4701b7fe8a289f17$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $4701b7fe8a289f17$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $4701b7fe8a289f17$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $4701b7fe8a289f17$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$4701b7fe8a289f17$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $4701b7fe8a289f17$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $4701b7fe8a289f17$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $4701b7fe8a289f17$var$RejectWithValue) throw result;
                                                if (result instanceof $4701b7fe8a289f17$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $4701b7fe8a289f17$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($4701b7fe8a289f17$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $4701b7fe8a289f17$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $4701b7fe8a289f17$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $4701b7fe8a289f17$var$matches = function(matcher, action) {
    if ($4701b7fe8a289f17$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $4701b7fe8a289f17$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $4701b7fe8a289f17$var$matches(matcher, action);
        });
    };
}
function $4701b7fe8a289f17$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $4701b7fe8a289f17$var$matches(matcher, action);
        });
    };
}
function $4701b7fe8a289f17$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $4701b7fe8a289f17$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $4701b7fe8a289f17$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $4701b7fe8a289f17$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$4701b7fe8a289f17$var$isAsyncThunkArray(asyncThunks)) return $4701b7fe8a289f17$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $4701b7fe8a289f17$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $4701b7fe8a289f17$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $4701b7fe8a289f17$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$4701b7fe8a289f17$var$isAsyncThunkArray(asyncThunks)) return $4701b7fe8a289f17$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $4701b7fe8a289f17$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $4701b7fe8a289f17$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $4701b7fe8a289f17$export$9dd1fb32974da385($4701b7fe8a289f17$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$4701b7fe8a289f17$var$isAsyncThunkArray(asyncThunks)) return $4701b7fe8a289f17$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $4701b7fe8a289f17$export$9dd1fb32974da385($4701b7fe8a289f17$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $4701b7fe8a289f17$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $4701b7fe8a289f17$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$4701b7fe8a289f17$var$isAsyncThunkArray(asyncThunks)) return $4701b7fe8a289f17$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $4701b7fe8a289f17$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $4701b7fe8a289f17$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $4701b7fe8a289f17$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$4701b7fe8a289f17$var$isAsyncThunkArray(asyncThunks)) return $4701b7fe8a289f17$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $4701b7fe8a289f17$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $4701b7fe8a289f17$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $4701b7fe8a289f17$var$noop = function() {};
var $4701b7fe8a289f17$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $4701b7fe8a289f17$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $4701b7fe8a289f17$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $4701b7fe8a289f17$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $4701b7fe8a289f17$var$task = "task";
var $4701b7fe8a289f17$var$listener = "listener";
var $4701b7fe8a289f17$var$completed = "completed";
var $4701b7fe8a289f17$var$cancelled = "cancelled";
var $4701b7fe8a289f17$var$taskCancelled = "task-" + $4701b7fe8a289f17$var$cancelled;
var $4701b7fe8a289f17$var$taskCompleted = "task-" + $4701b7fe8a289f17$var$completed;
var $4701b7fe8a289f17$var$listenerCancelled = $4701b7fe8a289f17$var$listener + "-" + $4701b7fe8a289f17$var$cancelled;
var $4701b7fe8a289f17$var$listenerCompleted = $4701b7fe8a289f17$var$listener + "-" + $4701b7fe8a289f17$var$completed;
var $4701b7fe8a289f17$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $4701b7fe8a289f17$var$task + " " + $4701b7fe8a289f17$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $4701b7fe8a289f17$var$validateActive = function(signal) {
    if (signal.aborted) throw new $4701b7fe8a289f17$export$cb1bdac908fed7f(signal.reason);
};
function $4701b7fe8a289f17$var$raceWithSignal(signal, promise2) {
    var cleanup = $4701b7fe8a289f17$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $4701b7fe8a289f17$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $4701b7fe8a289f17$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $4701b7fe8a289f17$var$noop;
    });
}
var $4701b7fe8a289f17$var$runTask = function(task2, cleanUp) {
    return $4701b7fe8a289f17$var$__async(void 0, null, function() {
        var value, error_1;
        return $4701b7fe8a289f17$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $4701b7fe8a289f17$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $4701b7fe8a289f17$var$createPause = function(signal) {
    return function(promise2) {
        return $4701b7fe8a289f17$var$catchRejection($4701b7fe8a289f17$var$raceWithSignal(signal, promise2).then(function(output) {
            $4701b7fe8a289f17$var$validateActive(signal);
            return output;
        }));
    };
};
var $4701b7fe8a289f17$var$createDelay = function(signal) {
    var pause = $4701b7fe8a289f17$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $4701b7fe8a289f17$var$assign = Object.assign;
var $4701b7fe8a289f17$var$INTERNAL_NIL_TOKEN = {};
var $4701b7fe8a289f17$var$alm = "listenerMiddleware";
var $4701b7fe8a289f17$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $4701b7fe8a289f17$var$addAbortSignalListener(parentAbortSignal, function() {
            return $4701b7fe8a289f17$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $4701b7fe8a289f17$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $4701b7fe8a289f17$var$runTask(function() {
            return $4701b7fe8a289f17$var$__async(void 0, null, function() {
                var result2;
                return $4701b7fe8a289f17$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $4701b7fe8a289f17$var$validateActive(parentAbortSignal);
                            $4701b7fe8a289f17$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $4701b7fe8a289f17$var$createPause(childAbortController.signal),
                                    delay: $4701b7fe8a289f17$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $4701b7fe8a289f17$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $4701b7fe8a289f17$var$abortControllerWithReason(childAbortController, $4701b7fe8a289f17$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $4701b7fe8a289f17$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $4701b7fe8a289f17$var$abortControllerWithReason(childAbortController, $4701b7fe8a289f17$var$taskCancelled);
            }
        };
    };
};
var $4701b7fe8a289f17$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $4701b7fe8a289f17$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $4701b7fe8a289f17$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $4701b7fe8a289f17$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $4701b7fe8a289f17$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $4701b7fe8a289f17$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $4701b7fe8a289f17$var$catchRejection(take(predicate, timeout));
    };
};
var $4701b7fe8a289f17$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $4701b7fe8a289f17$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $4701b7fe8a289f17$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $4701b7fe8a289f17$var$createListenerEntry = function(options) {
    var _c = $4701b7fe8a289f17$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $4701b7fe8a289f17$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $4701b7fe8a289f17$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $4701b7fe8a289f17$var$abortControllerWithReason(controller, $4701b7fe8a289f17$var$listenerCancelled);
    });
};
var $4701b7fe8a289f17$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($4701b7fe8a289f17$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $4701b7fe8a289f17$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $4701b7fe8a289f17$export$f03a6b845d3fb58b = $4701b7fe8a289f17$export$309c7a02b0b0bc62($4701b7fe8a289f17$var$alm + "/add");
var $4701b7fe8a289f17$export$b1b8022855fb2b71 = $4701b7fe8a289f17$export$309c7a02b0b0bc62($4701b7fe8a289f17$var$alm + "/removeAll");
var $4701b7fe8a289f17$export$b03e9483f936dccb = $4701b7fe8a289f17$export$309c7a02b0b0bc62($4701b7fe8a289f17$var$alm + "/remove");
var $4701b7fe8a289f17$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $4701b7fe8a289f17$var$__spreadArray([
        $4701b7fe8a289f17$var$alm + "/error"
    ], args));
};
function $4701b7fe8a289f17$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $4701b7fe8a289f17$var$defaultErrorHandler : _c;
    $4701b7fe8a289f17$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $4701b7fe8a289f17$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $4701b7fe8a289f17$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $4701b7fe8a289f17$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $4701b7fe8a289f17$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $4701b7fe8a289f17$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $4701b7fe8a289f17$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $4701b7fe8a289f17$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $4701b7fe8a289f17$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $4701b7fe8a289f17$var$createDelay(internalTaskController.signal),
                                pause: $4701b7fe8a289f17$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $4701b7fe8a289f17$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $4701b7fe8a289f17$var$abortControllerWithReason(controller, $4701b7fe8a289f17$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $4701b7fe8a289f17$export$cb1bdac908fed7f)) $4701b7fe8a289f17$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $4701b7fe8a289f17$var$abortControllerWithReason(internalTaskController, $4701b7fe8a289f17$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $4701b7fe8a289f17$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$4701b7fe8a289f17$export$b956e38827fca970(action)) return next(action);
                if ($4701b7fe8a289f17$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($4701b7fe8a289f17$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($4701b7fe8a289f17$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $4701b7fe8a289f17$var$INTERNAL_NIL_TOKEN) throw new Error($4701b7fe8a289f17$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $4701b7fe8a289f17$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $4701b7fe8a289f17$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $4701b7fe8a289f17$export$8fb31c0f05df007b = "RTK_autoBatch";
var $4701b7fe8a289f17$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$4701b7fe8a289f17$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $4701b7fe8a289f17$var$promise;
var $4701b7fe8a289f17$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($4701b7fe8a289f17$var$promise || ($4701b7fe8a289f17$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $4701b7fe8a289f17$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $4701b7fe8a289f17$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $4701b7fe8a289f17$var$createQueueWithTimer(10);
var $4701b7fe8a289f17$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $4701b7fe8a289f17$var$queueMicrotaskShim : options.type === "raf" ? $4701b7fe8a289f17$var$rAF : options.type === "callback" ? options.queueNotification : $4701b7fe8a289f17$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$4701b7fe8a289f17$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $lJr9B.enableES5)();

});
parcelRegister("lJr9B", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $fd22dd25f7b1d175$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(_n) {
                            void 0 !== o[_n] || u(o, _n) || (f[_n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $fd22dd25f7b1d175$export$2e2bcd8739ae039 = fn;

});

parcelRegister("ka48w", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $ead7f3420519defc$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $ead7f3420519defc$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $ead7f3420519defc$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $ead7f3420519defc$export$9ff26e0402cc7b7; });

var $8FbFQ = parcelRequire("8FbFQ");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ead7f3420519defc$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $ead7f3420519defc$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ead7f3420519defc$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $ead7f3420519defc$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ead7f3420519defc$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ead7f3420519defc$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ead7f3420519defc$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ead7f3420519defc$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ead7f3420519defc$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($ead7f3420519defc$var$isDate(val)) return 'date';
    if ($ead7f3420519defc$var$isError(val)) return 'error';
    var constructorName = $ead7f3420519defc$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $ead7f3420519defc$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $ead7f3420519defc$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $ead7f3420519defc$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $ead7f3420519defc$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ead7f3420519defc$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($ead7f3420519defc$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($ead7f3420519defc$var$formatProdErrorMessage(1));
        return enhancer($ead7f3420519defc$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($ead7f3420519defc$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ead7f3420519defc$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($ead7f3420519defc$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ead7f3420519defc$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ead7f3420519defc$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ead7f3420519defc$var$isPlainObject(action)) throw new Error($ead7f3420519defc$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($ead7f3420519defc$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ead7f3420519defc$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($ead7f3420519defc$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ead7f3420519defc$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($ead7f3420519defc$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ead7f3420519defc$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ead7f3420519defc$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ead7f3420519defc$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ead7f3420519defc$export$8928921ea2d3b126 = $ead7f3420519defc$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ead7f3420519defc$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ead7f3420519defc$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ead7f3420519defc$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ead7f3420519defc$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $ead7f3420519defc$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ead7f3420519defc$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $ead7f3420519defc$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ead7f3420519defc$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($ead7f3420519defc$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ead7f3420519defc$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($ead7f3420519defc$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ead7f3420519defc$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ead7f3420519defc$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($ead7f3420519defc$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ead7f3420519defc$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ead7f3420519defc$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $ead7f3420519defc$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($ead7f3420519defc$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $ead7f3420519defc$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ead7f3420519defc$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ead7f3420519defc$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ead7f3420519defc$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ead7f3420519defc$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $8FbFQ.default)((0, $8FbFQ.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("8FbFQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64eb3547280027f0$export$2e2bcd8739ae039; });

var $dlog4 = parcelRequire("dlog4");
function $64eb3547280027f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $64eb3547280027f0$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $64eb3547280027f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dlog4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $64eb3547280027f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("dlog4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b700db4a523c929$export$2e2bcd8739ae039; });

var $biQDl = parcelRequire("biQDl");
function $9b700db4a523c929$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $biQDl.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("biQDl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83aa3412b7217589$export$2e2bcd8739ae039; });

var $4PLSn = parcelRequire("4PLSn");

var $bICjl = parcelRequire("bICjl");
function $83aa3412b7217589$export$2e2bcd8739ae039(t) {
    var i = (0, $bICjl.default)(t, "string");
    return "symbol" == (0, $4PLSn.default)(i) ? i : i + "";
}

});
parcelRegister("bICjl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8881858dd549b806$export$2e2bcd8739ae039; });

var $4PLSn = parcelRequire("4PLSn");
function $8881858dd549b806$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4PLSn.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4PLSn.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("aMRBJ", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $7da7f869165b2a6c$export$595d22ed68ca2841; });

var $g1j6C = parcelRequire("g1j6C");
function $7da7f869165b2a6c$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $7da7f869165b2a6c$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $7da7f869165b2a6c$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $7da7f869165b2a6c$export$595d22ed68ca2841 = /* #__PURE__ */ $7da7f869165b2a6c$export$5943f4447f6ef248((0, $g1j6C.defaultMemoize));
var $7da7f869165b2a6c$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $7da7f869165b2a6c$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("g1j6C", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", function () { return $ba9b8f51a5f55985$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $ba9b8f51a5f55985$var$NOT_FOUND = 'NOT_FOUND';
function $ba9b8f51a5f55985$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $ba9b8f51a5f55985$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $ba9b8f51a5f55985$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $ba9b8f51a5f55985$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $ba9b8f51a5f55985$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $ba9b8f51a5f55985$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $ba9b8f51a5f55985$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $ba9b8f51a5f55985$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $ba9b8f51a5f55985$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $ba9b8f51a5f55985$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $ba9b8f51a5f55985$var$createSingletonCache(comparator) : $ba9b8f51a5f55985$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $ba9b8f51a5f55985$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("7Kr3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a41d0df8633aab8$export$2e2bcd8739ae039; });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $5a41d0df8633aab8$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $5a41d0df8633aab8$var$thunk = $5a41d0df8633aab8$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$5a41d0df8633aab8$var$thunk.withExtraArgument = $5a41d0df8633aab8$var$createThunkMiddleware;
var $5a41d0df8633aab8$export$2e2bcd8739ae039 = $5a41d0df8633aab8$var$thunk;

});



parcelRegister("8F1UY", function(module, exports) {

$parcel$export(module.exports, "getFirstPaint", function () { return $c9eb210a2d355cc5$export$819e7a0b13f5961; });
$parcel$export(module.exports, "getFirstContentfulPaint", function () { return $c9eb210a2d355cc5$export$3086fa1a9fb7f683; });
const $c9eb210a2d355cc5$var$perf = typeof window !== 'undefined' ? window.performance : null;
function $c9eb210a2d355cc5$export$819e7a0b13f5961() {
    try {
        if (!$c9eb210a2d355cc5$var$perf) return null;
        const fp = $c9eb210a2d355cc5$var$perf.getEntriesByType('paint').find(({ name: name })=>name === 'first-paint');
        return fp ? Math.round(fp.startTime) : null;
    } catch (err) {
        return null;
    }
}
function $c9eb210a2d355cc5$export$3086fa1a9fb7f683() {
    try {
        if (!$c9eb210a2d355cc5$var$perf) return null;
        const fcp = $c9eb210a2d355cc5$var$perf.getEntriesByType('paint').find(({ name: name })=>name === 'first-contentful-paint');
        return fcp ? Math.round(fcp.startTime) : null;
    } catch (err) {
        return null;
    }
}

});

parcelRegister("9mgZH", function(module, exports) {
$parcel$export(module.exports, "BrowserMetricsBoundary", function () { return (parcelRequire("9UUcJ")).BrowserMetricsBoundary; });
$parcel$export(module.exports, "startBrowserMetrics", function () { return (parcelRequire("lxj18")).startBrowserMetrics; });
$parcel$export(module.exports, "getPageLoadMetric", function () { return (parcelRequire("4903M")).getPageLoadMetric; });
parcelRequire("9UUcJ");
parcelRequire("lxj18");
parcelRequire("4903M");

});
parcelRegister("9UUcJ", function(module, exports) {

$parcel$export(module.exports, "BrowserMetricsBoundary", function () { return $727b1e6927dcefcf$export$e338054fa926c14d; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $2xC28 = parcelRequire("2xC28");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");
const $727b1e6927dcefcf$export$e338054fa926c14d = ({ children: children })=>{
    const prevPathname = (0, $dNMDr.useRef)();
    const { pathname: pathname } = (0, $cVnBY.useLocation)();
    /*
   * Here we only want to capture transition page loads (i.e. clientside route changes).
   *
   * Initial page loads (with a full trip to the server) are already recorded separately,
   * by calling startPageLoad before the react app is bootstrapped.
   *
   * And if startPageLoad were called again here, that initial page load will be overridden
   * and incorrectly recorded as a transition.
   */ (0, $dNMDr.useLayoutEffect)(()=>{
        if (!pathname) return;
        if (!prevPathname.current) {
            prevPathname.current = pathname;
            return;
        }
        // `isInitial: false` is the default, but made explicit here for clarity
        (0, $2xC28.browserMetrics).startPageLoad({
            isInitial: false
        });
    }, [
        pathname,
        prevPathname
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6CtE1.Fragment), {
        children: children
    });
};

});
parcelRegister("2xC28", function(module, exports) {

$parcel$export(module.exports, "browserMetrics", function () { return $1d9c2a7a91909add$export$c08e7affcf78b064; });

var $91FVG = parcelRequire("91FVG");

var $i6ikd = parcelRequire("i6ikd");

var $1grIu = parcelRequire("1grIu");

var $hougm = parcelRequire("hougm");

var $3X43W = parcelRequire("3X43W");

var $5lzfy = parcelRequire("5lzfy");

var $4WJqA = parcelRequire("4WJqA");

var $9Ut6b = parcelRequire("9Ut6b");

var $bo0Gu = parcelRequire("bo0Gu");
function $1d9c2a7a91909add$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d9c2a7a91909add$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d9c2a7a91909add$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d9c2a7a91909add$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1d9c2a7a91909add$var$makeBrowserMetrics = function makeBrowserMetrics() {
    var bm = {
        init: function init(config) {
            var _config$events$BMEven, _config$ssr;
            (0, $3X43W.visibilityChangeObserver).start();
            if ((_config$events$BMEven = config.events[(0, $bo0Gu.BMEventsType).WEB_VITALS]) !== null && _config$events$BMEven !== void 0 && _config$events$BMEven.enabled) (0, $5lzfy.webVitalsObserver).start();
            if (config.debug) {
                (0, $1grIu.logger).enable();
                (0, $9Ut6b.submitter).setDebug(true);
                (0, $hougm.pageLoadMetaMetric).setDebug(true);
            }
            (0, $9Ut6b.submitter).configure(config);
            if ((_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getDoneMark) (0, $i6ikd.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute: function setRoute(newRoute) {
            (0, $4WJqA.Route).setRoute(newRoute);
        },
        startPageLoad: function startPageLoad(params) {
            (0, $hougm.pageLoadMetaMetric).startPageLoad($1d9c2a7a91909add$var$_objectSpread({
                isInitial: false,
                cancelStarted: true
            }, params));
        },
        getPageLoadMetric: function getPageLoadMetric() {
            return 0, $hougm.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks: function experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark) {
            var initialOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            if (initialOnly && !(0, $hougm.pageLoadMetaMetric).isInitialLoad()) return;
            var start = performance.getEntriesByName(startMark);
            var stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $hougm.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                var pageLoadData = (0, $hougm.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    var _startMark = start[start.length - 1];
                    var timing = {
                        startTime: Math.round(_startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - _startMark.startTime)
                    };
                    (0, $hougm.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
var $1d9c2a7a91909add$export$c08e7affcf78b064 = $1d9c2a7a91909add$var$makeBrowserMetrics();

});
parcelRegister("i6ikd", function(module, exports) {

$parcel$export(module.exports, "SSRGetDoneMark", function () { return $d2d70081e7b9fab5$export$9e87a201397ac0a9; });
var $d2d70081e7b9fab5$export$9e87a201397ac0a9 = {
    getDoneMark: function() {
        return null;
    },
    setGetDoneMark: function setGetDoneMark(fn) {
        $d2d70081e7b9fab5$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("1grIu", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $0ebcc8fd8e85f446$export$af88d00dbe7f521; });
var $0ebcc8fd8e85f446$export$af88d00dbe7f521 = {
    enabled: false,
    enable: function enable() {
        this.enabled = true;
    },
    log: function log() {
        if (this.enabled) {
            var _console;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            // eslint-disable-next-line no-console
            (_console = console).log.apply(_console, [
                'BM log: '
            ].concat(args));
        }
    },
    logCond: function logCond(condition) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        if (this.enabled && condition && args.length > 1) this.log.apply(this, args);
    }
};

});

parcelRegister("hougm", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetaMetric", function () { return $ca9c271f50d5ae80$export$24b7a1a311eb05dc; });

var $bM2vx = parcelRequire("bM2vx");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $XdI2U = parcelRequire("XdI2U");

var $enV8I = parcelRequire("enV8I");

var $91FVG = parcelRequire("91FVG");

var $bo0Gu = parcelRequire("bo0Gu");

var $1nojc = parcelRequire("1nojc");

var $hDoVW = parcelRequire("hDoVW");
var $ca9c271f50d5ae80$var$_excluded = [
    "cancelStarted"
];
function $ca9c271f50d5ae80$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $ca9c271f50d5ae80$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $ca9c271f50d5ae80$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ca9c271f50d5ae80$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ca9c271f50d5ae80$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($XdI2U)))((0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $ca9c271f50d5ae80$export$9609608c00ea5077 = /*#__PURE__*/ function(_BasePageLoadMetric) {
    function PageLoadMetaMetric() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, PageLoadMetaMetric);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $ca9c271f50d5ae80$var$_callSuper(this, PageLoadMetaMetric, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(_this, "activePageLoadMetric", null);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(PageLoadMetaMetric, _BasePageLoadMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(PageLoadMetaMetric, [
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false,
                    cancelStarted: false
                };
                var cancelStarted = _ref.cancelStarted, startPageLoadParams = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $ca9c271f50d5ae80$var$_excluded);
                if (cancelStarted || this.state !== (0, $1nojc.MetricState).STARTED) $ca9c271f50d5ae80$var$_superPropGet(PageLoadMetaMetric, "startPageLoad", this, 3)([
                    startPageLoadParams
                ]);
            }
        },
        {
            key: "setActive",
            value: function setActive(metric) {
                this.activePageLoadMetric = metric;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(debug) {
                this.config.debug = debug;
            }
        },
        {
            key: "isDebugMode",
            value: function isDebugMode() {
                return this.config.debug;
            }
        },
        {
            key: "isInitialLoad",
            value: function isInitialLoad() {
                return this.isInitial;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.activePageLoadMetric && this.activePageLoadMetric.cancel();
                $ca9c271f50d5ae80$var$_superPropGet(PageLoadMetaMetric, "clear", this, 3)([]);
            }
        },
        {
            key: "include",
            value: function include(metric) {
                if (!this.config.include) this.config.include = [
                    metric
                ];
                else this.config.include.push(metric);
            }
        },
        {
            key: "experimental__addExplicitTiming",
            value: function experimental__addExplicitTiming(name, timing) {
                if (this.explicitTimings === null) this.explicitTimings = {};
                this.explicitTimings[name] = timing;
            }
        }
    ]);
}((0, $hDoVW.BasePageLoadMetric));
var $ca9c271f50d5ae80$export$24b7a1a311eb05dc = new $ca9c271f50d5ae80$export$9609608c00ea5077({
    type: (0, $bo0Gu.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("bo0Gu", function(module, exports) {

$parcel$export(module.exports, "BMEventsType", function () { return $84a2777b5f5ac333$export$9c73e297d4be9159; });
$parcel$export(module.exports, "StorableBMEventsType", function () { return $84a2777b5f5ac333$export$9b7037ec30489597; });
$parcel$export(module.exports, "BMPageLoadMetrics", function () { return $84a2777b5f5ac333$export$74c1fb0997d51e2a; });
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", function () { return $84a2777b5f5ac333$export$88195ac8200d03a6; });
$parcel$export(module.exports, "BMInteractionMetrics", function () { return $84a2777b5f5ac333$export$6e28252a002afdb2; });
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", function () { return $84a2777b5f5ac333$export$474154836bfd8dd9; });
$parcel$export(module.exports, "PageVisibleFields", function () { return $84a2777b5f5ac333$export$e89802082dab5633; });
$parcel$export(module.exports, "PageVisibleValueOrigin", function () { return $84a2777b5f5ac333$export$983b017156c2aee2; });
$parcel$export(module.exports, "isDetailedPageLoadSlo", function () { return $84a2777b5f5ac333$export$5866f95702a15142; });
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", function () { return $84a2777b5f5ac333$export$f087a59bd717e49d; });
$parcel$export(module.exports, "isInteractionMetricsSlo", function () { return $84a2777b5f5ac333$export$b10c1d9a7db7765b; });
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", function () { return $84a2777b5f5ac333$export$60c0193054fc3040; });

var $1nojc = parcelRequire("1nojc");
var $84a2777b5f5ac333$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $84a2777b5f5ac333$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $84a2777b5f5ac333$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $84a2777b5f5ac333$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $84a2777b5f5ac333$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $84a2777b5f5ac333$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $84a2777b5f5ac333$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $84a2777b5f5ac333$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
var $84a2777b5f5ac333$export$5866f95702a15142 = function isDetailedPageLoadSlo(data) {
    return Boolean(data.initial);
};
var $84a2777b5f5ac333$export$f087a59bd717e49d = function isDetailedPageSegmentLoadSlo(data) {
    return Boolean(data.initial);
};
var $84a2777b5f5ac333$export$153c4c72fa5eeece = function isPageLoadMetricsSlo(data) {
    var obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
var $84a2777b5f5ac333$export$b10c1d9a7db7765b = function isInteractionMetricsSlo(data) {
    var obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $84a2777b5f5ac333$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("1nojc", function(module, exports) {

$parcel$export(module.exports, "MetricState", function () { return $100acb9b4854445b$export$1e458f18c0c7bfe3; });
$parcel$export(module.exports, "PageVisibleState", function () { return $100acb9b4854445b$export$a12c67b37a306b13; });
$parcel$export(module.exports, "BaseMetric", function () { return $100acb9b4854445b$export$2bce4ffdd840e878; });

var $62ppy = parcelRequire("62ppy");

var $82V4i = parcelRequire("82V4i");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $h38tX = parcelRequire("h38tX");

var $1grIu = parcelRequire("1grIu");

var $3X43W = parcelRequire("3X43W");

var $cpCpz = parcelRequire("cpCpz");
function $100acb9b4854445b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $100acb9b4854445b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $100acb9b4854445b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $100acb9b4854445b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $100acb9b4854445b$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $100acb9b4854445b$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $100acb9b4854445b$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? $100acb9b4854445b$export$a12c67b37a306b13.VISIBLE : $100acb9b4854445b$export$a12c67b37a306b13.HIDDEN;
}
var $100acb9b4854445b$export$2bce4ffdd840e878 = /*#__PURE__*/ function() {
    function BaseMetric(config) {
        var _this = this, _this$config$timings;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, BaseMetric);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "state", $100acb9b4854445b$export$1e458f18c0c7bfe3.NOT_STARTED);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "startTime", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "stopTime", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "marks", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "onStopCallbacks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "custom", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "submetrics", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "route", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "untilOnStopCallback", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "pageVisibleState", $100acb9b4854445b$var$getPageVisibleState());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = $100acb9b4854445b$export$a12c67b37a306b13.MIXED;
        });
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        (_this$config$timings = this.config.timings) === null || _this$config$timings === void 0 || _this$config$timings.forEach(function(entry) {
            if ((0, $h38tX.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn("Entry ".concat(entry.key, " is restricted and has been renamed to custom__").concat(entry.key));
                entry.key = "custom__".concat(entry.key);
            }
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(BaseMetric, [
        {
            key: "untilMetrics",
            get: function get() {
                var until = this.config.until;
                if (!until) return [];
                else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
                return this.getConfiguredUntilMetricArray([
                    until
                ]);
            }
        },
        {
            key: "start",
            value: function start() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$startTime = _ref.startTime, startTime = _ref$startTime === void 0 ? window.performance.now() : _ref$startTime;
                this.clear();
                (0, $1grIu.logger).logCond(!!this.config.debug, this.key, startTime);
                this.state = $100acb9b4854445b$export$1e458f18c0c7bfe3.STARTED;
                this.startTime = startTime;
                this.pageVisibleState = $100acb9b4854445b$var$getPageVisibleState();
                (0, $3X43W.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                this.watchUntil();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var stopArguments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _stopArguments$stopTi = stopArguments.stopTime, stopTime = _stopArguments$stopTi === void 0 ? window.performance.now() : _stopArguments$stopTi;
                if (this.state !== $100acb9b4854445b$export$1e458f18c0c7bfe3.STARTED || this.startTime === null) {
                    (0, $1grIu.logger).log("metric ".concat(this.config.key, " has been stopped while not being started before; current state: ").concat(this.state));
                    return false;
                }
                if (stopTime < this.startTime) {
                    (0, $1grIu.logger).log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(this.startTime, "; stopTime: ").concat(stopTime));
                    return false;
                }
                this.stopTime = stopTime;
                this.state = $100acb9b4854445b$export$1e458f18c0c7bfe3.FINISHED;
                this.handleStop(stopArguments);
                (0, $3X43W.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return true;
            }
        },
        {
            key: "handleStop",
            value: function handleStop(stopArguments) {
                var _this2 = this;
                var _stopArguments$custom = stopArguments.customData, customData = _stopArguments$custom === void 0 ? null : _stopArguments$custom;
                if (customData) this.custom = $100acb9b4854445b$var$_objectSpread($100acb9b4854445b$var$_objectSpread({}, this.custom), customData);
                this.config.include && this.config.include.forEach(function(metric) {
                    var included = metric.getData();
                    if (included.state === $100acb9b4854445b$export$1e458f18c0c7bfe3.FINISHED && included.start !== null && included.start >= (_this2.startTime || 0)) _this2.addSubMetric(metric.getData());
                });
                this.onStopCallbacks.forEach(function(_ref2) {
                    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref2, 1), success = _ref3[0];
                    success(stopArguments);
                });
                this.onStopCallbacks = [];
                (0, $1grIu.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                this.marks[_mark] = timestamp;
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.state !== $100acb9b4854445b$export$1e458f18c0c7bfe3.STARTED) return;
                this.state = $100acb9b4854445b$export$1e458f18c0c7bfe3.CANCELLED;
                this.cancelUntil();
                this.onStopCallbacks.forEach(function(_ref4) {
                    var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref4, 2), cancel = _ref5[1];
                    cancel();
                });
                this.onStopCallbacks = [];
                (0, $3X43W.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                this.state = mergeData.state;
                this.pageVisibleState = mergeData.pageVisibleState;
                this.startTime = mergeData.start;
                this.stopTime = mergeData.stop;
                this.marks = $100acb9b4854445b$var$_objectSpread($100acb9b4854445b$var$_objectSpread({}, this.marks), mergeData.marks);
                this.submetrics = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(this.submetrics), (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(mergeData.submetrics));
                this.onStopCallbacks = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(this.onStopCallbacks), (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(mergeData.onStopCallbacks));
            }
        },
        {
            key: "onStop",
            value: function onStop(success, cancel) {
                this.onStopCallbacks.push([
                    success,
                    cancel
                ]);
            }
        },
        {
            key: "removeOnStopCallback",
            value: function removeOnStopCallback(success) {
                var index = this.onStopCallbacks.findIndex(function(_ref6) {
                    var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref6, 1), successCallback = _ref7[0];
                    return success === successCallback;
                });
                if (index > -1) this.onStopCallbacks.splice(index, 1);
            }
        },
        {
            key: "getData",
            value: function getData() {
                return {
                    key: this.key,
                    state: this.state,
                    start: this.startTime,
                    stop: this.stopTime,
                    //todo ranges
                    // ranges: this.makeRanges()
                    marks: this.marks,
                    // todo make copy
                    custom: this.custom,
                    submetrics: this.submetrics,
                    config: this.config,
                    route: this.route,
                    pageVisibleState: this.pageVisibleState,
                    type: this.config.type
                };
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $100acb9b4854445b$var$_objectSpread($100acb9b4854445b$var$_objectSpread({}, this.getData()), {}, {
                    onStopCallbacks: this.onStopCallbacks
                });
            }
        },
        {
            key: "addSubMetric",
            value: function addSubMetric(data) {
                this.submetrics.push(data);
            }
        },
        {
            key: "getConfiguredUntilMetric",
            value: function getConfiguredUntilMetric(metricOrConfig) {
                return metricOrConfig instanceof BaseMetric ? (0, $cpCpz.UntilExperience).fromMetric(metricOrConfig) : (0, $cpCpz.UntilExperience).fromConfig(metricOrConfig);
            }
        },
        {
            key: "getConfiguredUntilMetricArray",
            value: function getConfiguredUntilMetricArray(metricArray) {
                var _this3 = this;
                if (!metricArray.length) return [];
                return metricArray.map(function(metric) {
                    return _this3.getConfiguredUntilMetric(metric);
                });
            }
        },
        {
            key: "isUntilFinished",
            value: function isUntilFinished() {
                return this.untilMetrics.every(function(metric) {
                    return metric.experience.getData().state === $100acb9b4854445b$export$1e458f18c0c7bfe3.FINISHED;
                });
            }
        },
        {
            key: "handleAllUntilFinished",
            value: function handleAllUntilFinished() {
                // Order by ascending stop time
                var sorted = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(this.untilMetrics).sort(function(m1, m2) {
                    return m1.getDependencyStopTime() - m2.getDependencyStopTime();
                });
                // Find the latest page segment to become fully interactive
                var latestFullyInteractiveSegment = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(this.untilMetrics).reduce(function(currentLatestSegment, metric) {
                    var _currentLatestSegment, _metric$getFullyInter;
                    var currentLatestStopTime = (_currentLatestSegment = currentLatestSegment === null || currentLatestSegment === void 0 ? void 0 : currentLatestSegment.getFullyInteractiveStopTime()) !== null && _currentLatestSegment !== void 0 ? _currentLatestSegment : 0;
                    var metricStopTime = (_metric$getFullyInter = metric.getFullyInteractiveStopTime()) !== null && _metric$getFullyInter !== void 0 ? _metric$getFullyInter : 0;
                    return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
                }, undefined);
                // Accumulate the custom data from each metric, later metrics take priority
                var accumulatedCustomData = {};
                sorted.forEach(function(metric) {
                    Object.assign(accumulatedCustomData, metric.experience.getData().custom);
                });
                var latestSegment = sorted[sorted.length - 1];
                var latestFullyInteractiveStopTime = latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getFullyInteractiveStopTime();
                this.stop({
                    stopTime: latestSegment.getDependencyStopTime(),
                    customData: $100acb9b4854445b$var$_objectSpread($100acb9b4854445b$var$_objectSpread({}, accumulatedCustomData), {}, {
                        segment: latestSegment.getKey(),
                        segmentOverrided: latestSegment.getIsSegmentLoadOverrided()
                    }, latestFullyInteractiveStopTime ? {
                        latestFullyInteractiveSegment: latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getKey(),
                        latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                    } : {})
                });
            }
        },
        {
            key: "watchUntil",
            value: function watchUntil() {
                var _this4 = this;
                if (!this.untilMetrics.length) return;
                if (this.isUntilFinished()) {
                    // Already finished, handle it immediately
                    this.handleAllUntilFinished();
                    return;
                }
                // If not currently finished, register stop callbacks to re-check
                this.untilOnStopCallback = function() {
                    if (_this4.isUntilFinished()) _this4.handleAllUntilFinished();
                };
                this.untilMetrics.forEach(function(metric) {
                    if (metric.experience.getData().state !== $100acb9b4854445b$export$1e458f18c0c7bfe3.FINISHED) metric.experience.onStop(_this4.untilOnStopCallback, function() {
                        return _this4.cancel();
                    });
                });
            }
        },
        {
            key: "cancelUntil",
            value: function cancelUntil() {
                var _this5 = this;
                this.untilMetrics.forEach(function(metric) {
                    if (metric.experience.getData().state !== $100acb9b4854445b$export$1e458f18c0c7bfe3.CANCELLED && _this5.untilOnStopCallback) metric.experience.removeOnStopCallback(_this5.untilOnStopCallback);
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
                this.cancelUntil();
                this.state = $100acb9b4854445b$export$1e458f18c0c7bfe3.NOT_STARTED;
                this.startTime = null;
                this.stopTime = null;
                this.marks = {};
                this.custom = null;
                this.submetrics = [];
                this.route = null;
                this.pageVisibleState = $100acb9b4854445b$var$getPageVisibleState();
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($100acb9b4854445b$export$2bce4ffdd840e878, "FMP", 'fmp');

});
parcelRegister("h38tX", function(module, exports) {

$parcel$export(module.exports, "restrictedTimingKeys", function () { return $c6994bdd46ab1555$export$1d17377365286b00; });
$parcel$export(module.exports, "clsWaitTimeMs", function () { return $c6994bdd46ab1555$export$df21d285cfcda81e; });
var $c6994bdd46ab1555$export$1d17377365286b00 = [
    'ssr'
];
var $c6994bdd46ab1555$export$df21d285cfcda81e = 7500;

});

parcelRegister("3X43W", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", function () { return $2e0a088cf3d70b8b$export$13e680397ec8f3eb; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");
var $2e0a088cf3d70b8b$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                document.addEventListener('visibilitychange', this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ window.addEventListener('pagehide', this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
}();
var $2e0a088cf3d70b8b$export$13e680397ec8f3eb = new $2e0a088cf3d70b8b$var$VisibilityChangeObserver();

});

parcelRegister("cpCpz", function(module, exports) {

$parcel$export(module.exports, "UntilExperience", function () { return $90959d8a5ea09b27$export$3fcc0936ee2cc852; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");
var $90959d8a5ea09b27$export$3fcc0936ee2cc852 = /*#__PURE__*/ function() {
    function UntilExperience(experience, useFmpAsUntilStopTime) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, UntilExperience);
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(UntilExperience, [
        {
            key: "getFmp",
            value: function getFmp() {
                var _marks$UntilExperienc;
                var _this$experience$getD = this.experience.getData(), marks = _this$experience$getD.marks, stop = _this$experience$getD.stop;
                return (_marks$UntilExperienc = marks[UntilExperience.FMP]) !== null && _marks$UntilExperienc !== void 0 ? _marks$UntilExperienc : stop;
            }
        },
        {
            key: "getDependencyStopTime",
            value: function getDependencyStopTime() {
                if (this.useFmpAsUntilStopTime) return this.getFmp();
                return this.experience.getData().stop;
            }
        },
        {
            key: "getFullyInteractiveStopTime",
            value: function getFullyInteractiveStopTime() {
                return this.experience.getData().stop;
            }
        },
        {
            key: "getIsSegmentLoadOverrided",
            value: function getIsSegmentLoadOverrided() {
                if (this.useFmpAsUntilStopTime) {
                    var _this$experience$getD2 = this.experience.getData(), marks = _this$experience$getD2.marks;
                    return marks[UntilExperience.FMP] ? true : false;
                }
                return false;
            }
        },
        {
            key: "getKey",
            value: function getKey() {
                return this.experience.getData().key;
            }
        }
    ], [
        {
            key: "fromConfig",
            value: function fromConfig(config) {
                return new UntilExperience(config.experience, config.useFmpAsUntilStopTime);
            }
        },
        {
            key: "fromMetric",
            value: function fromMetric(metric) {
                return new UntilExperience(metric);
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($90959d8a5ea09b27$export$3fcc0936ee2cc852, "FMP", 'fmp');

});



parcelRegister("hDoVW", function(module, exports) {

$parcel$export(module.exports, "BasePageLoadMetric", function () { return $cd696b7a633f0fc1$export$fd1447b187f590fe; });

var $62ppy = parcelRequire("62ppy");

var $bsGeH = parcelRequire("bsGeH");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $XdI2U = parcelRequire("XdI2U");

var $enV8I = parcelRequire("enV8I");

var $91FVG = parcelRequire("91FVG");

var $1grIu = parcelRequire("1grIu");

var $1nojc = parcelRequire("1nojc");
function $cd696b7a633f0fc1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd696b7a633f0fc1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd696b7a633f0fc1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd696b7a633f0fc1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cd696b7a633f0fc1$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $cd696b7a633f0fc1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $cd696b7a633f0fc1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cd696b7a633f0fc1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $cd696b7a633f0fc1$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($XdI2U)))((0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $cd696b7a633f0fc1$export$fd1447b187f590fe = /*#__PURE__*/ function(_BaseMetric) {
    function BasePageLoadMetric(args) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, BasePageLoadMetric);
        _this = $cd696b7a633f0fc1$var$_callSuper(this, BasePageLoadMetric, [
            args
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(_this, "isInitial", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(_this, "explicitTimings", null);
        _this.config = args;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(BasePageLoadMetric, _BaseMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(BasePageLoadMetric, [
        {
            key: "start",
            value: function start() {
                (0, (/*@__PURE__*/$parcel$interopDefault($bsGeH)))(arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {});
                // please use startPageLoad
                return;
            }
        },
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false
                };
                // todo this should update meta page load metric
                this.isInitial = params.isInitial;
                if (params.isInitial) $cd696b7a633f0fc1$var$_superPropGet(BasePageLoadMetric, "start", this, 3)([
                    {
                        startTime: 0
                    }
                ]);
                else $cd696b7a633f0fc1$var$_superPropGet(BasePageLoadMetric, "start", this, 3)([
                    params
                ]);
                (0, $1grIu.logger).logCond(!!this.config.debug, this.key, this.startTime);
            }
        },
        {
            key: "stopPageLoad",
            value: function stopPageLoad(pageLoadMetaMetricData) {
                var stopArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    stopTime: window.performance.now()
                };
                if (pageLoadMetaMetricData.state !== (0, $1nojc.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
                    (0, $1grIu.logger).log("meta metric has been stopped while not being started before; current state: ".concat(this.state));
                    return false;
                }
                if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
                    (0, $1grIu.logger).log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(pageLoadMetaMetricData.start, "; stopTime: ").concat(stopArguments.stopTime));
                    return false;
                }
                this.merge(pageLoadMetaMetricData);
                this.stopTime = stopArguments.stopTime;
                this.state = (0, $1nojc.MetricState).FINISHED;
                this.handleStop(stopArguments);
                return true;
            }
        },
        {
            key: "handleStop",
            value: function handleStop(stopArguments) {
                var until = this.config.until;
                var fmpWasMarked = BasePageLoadMetric.FMP in this.marks;
                if (!fmpWasMarked && until) {
                    // Extract the maximum FMP value from the until metrics
                    var untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                        until
                    ]);
                    var untilFmpMarks = untilArr.map(function(metric) {
                        return metric.getFmp();
                    });
                    if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(untilFmpMarks)));
                }
                $cd696b7a633f0fc1$var$_superPropGet(BasePageLoadMetric, "handleStop", this, 3)([
                    stopArguments
                ]);
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                if (_mark === BasePageLoadMetric.FMP) return;
                $cd696b7a633f0fc1$var$_superPropGet(BasePageLoadMetric, "mark", this, 3)([
                    _mark,
                    timestamp
                ]);
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                $cd696b7a633f0fc1$var$_superPropGet(BasePageLoadMetric, "merge", this, 3)([
                    mergeData
                ]);
                this.isInitial = mergeData.isInitial;
                this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? $cd696b7a633f0fc1$var$_objectSpread($cd696b7a633f0fc1$var$_objectSpread({}, mergeData.explicitTimings), this.explicitTimings) : null;
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                $cd696b7a633f0fc1$var$_superPropGet(BasePageLoadMetric, "mark", this, 3)([
                    BasePageLoadMetric.FMP,
                    timestamp
                ]);
            }
        },
        {
            key: "getPageLoadData",
            value: function getPageLoadData() {
                return {
                    isInitial: this.isInitial,
                    explicitTimings: this.explicitTimings
                };
            }
        },
        {
            key: "getData",
            value: function getData() {
                return $cd696b7a633f0fc1$var$_objectSpread($cd696b7a633f0fc1$var$_objectSpread({}, $cd696b7a633f0fc1$var$_superPropGet(BasePageLoadMetric, "getData", this, 3)([])), this.getPageLoadData());
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $cd696b7a633f0fc1$var$_objectSpread($cd696b7a633f0fc1$var$_objectSpread({}, $cd696b7a633f0fc1$var$_superPropGet(BasePageLoadMetric, "getDataToMerge", this, 3)([])), this.getPageLoadData());
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.explicitTimings = null;
                $cd696b7a633f0fc1$var$_superPropGet(BasePageLoadMetric, "clear", this, 3)([]);
            }
        }
    ]);
}((0, $1nojc.BaseMetric));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($cd696b7a633f0fc1$export$fd1447b187f590fe, "FMP", 'fmp');

});
parcelRegister("bsGeH", function(module, exports) {
function $85831271b81083bc$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
module.exports = $85831271b81083bc$var$_objectDestructuringEmpty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("5lzfy", function(module, exports) {

$parcel$export(module.exports, "webVitalsObserver", function () { return $3e4a41c8c3a71e1b$export$253d38dccbb37615; });

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $axdfd = parcelRequire("axdfd");


var $3e4a41c8c3a71e1b$var$WebVitalsObserver = /*#__PURE__*/ function() {
    function WebVitalsObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, WebVitalsObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "data", {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(WebVitalsObserver, [
        {
            key: "start",
            value: function start() {
                this.ttciDetermined = this.registerTTCI();
                this.webVitalsDetermined = this.registerWebVitals();
            }
        },
        {
            key: "registerWebVitals",
            value: function() {
                var _registerWebVitals = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee() {
                    var _this = this;
                    var _yield$import, getCLS, getFCP, getFID, getLCP, getTTFB;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return (parcelRequire("ZSsR4"));
                            case 3:
                                _yield$import = _context.sent;
                                getCLS = _yield$import.getCLS;
                                getFCP = _yield$import.getFCP;
                                getFID = _yield$import.getFID;
                                getLCP = _yield$import.getLCP;
                                getTTFB = _yield$import.getTTFB;
                                _context.next = 11;
                                return Promise.all([
                                    getTTFB,
                                    getFID,
                                    getFCP,
                                    getLCP,
                                    getCLS
                                ].map(function(fx) {
                                    return new Promise(function(resolve) {
                                        fx(function(_ref) {
                                            var name = _ref.name, value = _ref.value;
                                            // round FCP, FID, LCP, TTFB to nearest integer.
                                            // CLS is rounded to two decimal places.
                                            var metricName = name.toLowerCase();
                                            var metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                                            _this.data["metric:".concat(metricName)] = metricValue;
                                            resolve();
                                        });
                                    });
                                }));
                            case 11:
                                _context.next = 15;
                                break;
                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context["catch"](0);
                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            13
                        ]
                    ]);
                }));
                function registerWebVitals() {
                    return _registerWebVitals.apply(this, arguments);
                }
                return registerWebVitals;
            }()
        },
        {
            key: "registerTTCI",
            value: function() {
                var _registerTTCI = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2() {
                    var _this2 = this;
                    var ttiPolyfill;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return (parcelRequire("3pGTx"));
                            case 3:
                                ttiPolyfill = _context2.sent;
                                _context2.next = 6;
                                return ttiPolyfill.getFirstConsistentlyInteractive().then(function(value) {
                                    // according to the docs:
                                    // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                                    // the promise resolves to null.
                                    _this2.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                                    return true;
                                });
                            case 6:
                                _context2.next = 10;
                                break;
                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2["catch"](0);
                            case 10:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, null, [
                        [
                            0,
                            8
                        ]
                    ]);
                }));
                function registerTTCI() {
                    return _registerTTCI.apply(this, arguments);
                }
                return registerTTCI;
            }()
        }
    ]);
}();
var $3e4a41c8c3a71e1b$export$253d38dccbb37615 = new $3e4a41c8c3a71e1b$var$WebVitalsObserver();

});
parcelRegister("ZSsR4", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("bwi3C")).then(()=>parcelRequire('jbEXJ'));

});
parcelRegister("44cko", function(module, exports) {
"use strict";

var $5m3U2 = parcelRequire("5m3U2");
module.exports = $5m3U2(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("5m3U2", function(module, exports) {
"use strict";
var $3e6208d8a06741f7$var$cachedBundles = {};
var $3e6208d8a06741f7$var$cachedPreloads = {};
var $3e6208d8a06741f7$var$cachedPrefetches = {};
function $3e6208d8a06741f7$var$getCache(type) {
    switch(type){
        case 'preload':
            return $3e6208d8a06741f7$var$cachedPreloads;
        case 'prefetch':
            return $3e6208d8a06741f7$var$cachedPrefetches;
        default:
            return $3e6208d8a06741f7$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $3e6208d8a06741f7$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("3pGTx", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("lJ1c6")).then(()=>parcelRequire('1zWWR'));

});


parcelRegister("4WJqA", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $399fd13257585bc8$export$e7b0ac011bb776c6; });
var $399fd13257585bc8$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute: function setRoute(newRoute) {
        this.route = newRoute;
    },
    getRoute: function getRoute() {
        return this.route;
    }
};

});

parcelRegister("9Ut6b", function(module, exports) {

$parcel$export(module.exports, "submitter", function () { return $736fea6de0c80546$export$c21a25872e3f5a2b; });

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");

var $ehSVF = parcelRequire("ehSVF");

var $bo0Gu = parcelRequire("bo0Gu");

var $eCX8C = parcelRequire("eCX8C");

var $jCFxN = parcelRequire("jCFxN");
var $736fea6de0c80546$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure: function configure(config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $jCFxN.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $bo0Gu.PageVisibleFields).pageVisibleState;
    },
    setDebug: function setDebug(debug) {
        this.debug = debug;
    },
    queue: function queue(data) {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee() {
            var chunk, payload, client, attributes;
            return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (_this.config.enableReactUFOTracker) (0, $ehSVF.addBrowserMetricEvent)(data);
                        if (_this.config.configChunk) {
                            _context.next = 4;
                            break;
                        }
                        // eslint-disable-next-line no-console
                        _this.debug && console.warn('Submitter is not configured');
                        return _context.abrupt("return", null);
                    case 4:
                        _context.next = 6;
                        return _this.config.configChunk;
                    case 6:
                        chunk = _context.sent;
                        _context.next = 9;
                        return (0, $eCX8C.eventDataProcessor)(chunk[data.config.type], data);
                    case 9:
                        payload = _context.sent;
                        if (!(payload === null)) {
                            _context.next = 12;
                            break;
                        }
                        return _context.abrupt("return");
                    case 12:
                        if (!(_this.config.gasv3 !== undefined)) {
                            _context.next = 18;
                            break;
                        }
                        _context.next = 15;
                        return _this.config.gasv3;
                    case 15:
                        client = _context.sent;
                        attributes = {
                            task: payload['event:key'],
                            properties: payload
                        };
                        client && client.sendOperationalEvent({
                            actionSubject: 'performance',
                            attributes: attributes,
                            source: 'performance',
                            action: 'measured'
                        });
                    case 18:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }))();
    }
};

});
parcelRegister("ehSVF", function(module, exports) {

$parcel$export(module.exports, "getActiveInteraction", function () { return $a66d42fcd925f6c6$export$2b3954d2e8509985; });
$parcel$export(module.exports, "addBrowserMetricEvent", function () { return $a66d42fcd925f6c6$export$4a759336b50e86e3; });

var $k7uol = parcelRequire("k7uol");

var $82V4i = parcelRequire("82V4i");

var $91FVG = parcelRequire("91FVG");

var $62ppy = parcelRequire("62ppy");

var $axdfd = parcelRequire("axdfd");

var $aza3U = parcelRequire("aza3U");

var $gQLDR = parcelRequire("gQLDR");

var $ieNoo = parcelRequire("ieNoo");

var $i6899 = parcelRequire("i6899");

var $fmYzr = parcelRequire("fmYzr");

var $50Vt1 = parcelRequire("50Vt1");

var $4OLmu = parcelRequire("4OLmu");

var $cjKHH = parcelRequire("cjKHH");

var $2nvs7 = parcelRequire("2nvs7");

var $8cJqz = parcelRequire("8cJqz");

var $6PSIg = parcelRequire("6PSIg");
function $a66d42fcd925f6c6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a66d42fcd925f6c6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a66d42fcd925f6c6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a66d42fcd925f6c6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a66d42fcd925f6c6$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a66d42fcd925f6c6$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a66d42fcd925f6c6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a66d42fcd925f6c6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a66d42fcd925f6c6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a66d42fcd925f6c6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $a66d42fcd925f6c6$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
var $a66d42fcd925f6c6$export$d8f52e8f804021e8 = new (0, $6PSIg.default)();
var $a66d42fcd925f6c6$var$interactionQueue = [];
var $a66d42fcd925f6c6$var$segmentCache = new Map();
var $a66d42fcd925f6c6$var$CLEANUP_TIMEOUT = 60000;
var $a66d42fcd925f6c6$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
var $a66d42fcd925f6c6$var$segmentObservers = [];
function $a66d42fcd925f6c6$export$2b3954d2e8509985() {
    var interactionId = (0, $cjKHH.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $8cJqz.interactions).get(interactionId.current);
}
function $a66d42fcd925f6c6$var$isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $i6899.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
var $a66d42fcd925f6c6$var$performanceEventObserver;
var $a66d42fcd925f6c6$export$17afbba0f16b4b19 = function getPerformanceObserver() {
    $a66d42fcd925f6c6$var$performanceEventObserver = $a66d42fcd925f6c6$var$performanceEventObserver || new PerformanceObserver(function(entries) {
        var list = entries.getEntries();
        var _iterator = $a66d42fcd925f6c6$var$_createForOfIteratorHelper(list), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.name === 'click') $a66d42fcd925f6c6$export$e6be05b411ce21a6(entry);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return $a66d42fcd925f6c6$var$performanceEventObserver;
};
var $a66d42fcd925f6c6$export$e6be05b411ce21a6 = function setInteractionPerformanceEvent(entry) {
    var interaction = $a66d42fcd925f6c6$export$2b3954d2e8509985();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $a66d42fcd925f6c6$var$labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join('/');
}
function $a66d42fcd925f6c6$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return 'segmentId' in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join('/');
}
function $a66d42fcd925f6c6$var$addSegmentObserver(observer) {
    $a66d42fcd925f6c6$var$segmentObservers.push(observer);
    var _iterator2 = $a66d42fcd925f6c6$var$_createForOfIteratorHelper($a66d42fcd925f6c6$var$segmentCache.values()), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var segmentInfo = _step2.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $a66d42fcd925f6c6$var$removeSegmentObserver(observer) {
    var index = $a66d42fcd925f6c6$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $a66d42fcd925f6c6$var$segmentObservers.splice(index, 1);
}
function $a66d42fcd925f6c6$export$cd7f480d6b8286c3(interactionId) {
    (0, $8cJqz.interactions).delete(interactionId);
}
function $a66d42fcd925f6c6$export$f6f1cf5bedf83c71(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = $a66d42fcd925f6c6$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $a66d42fcd925f6c6$export$12f2b6cb85d59904(interactionId, data) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function $a66d42fcd925f6c6$export$e4380431c2bdabee(interactionId, labelStack, data) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, i, data[i])
        });
    });
}
function $a66d42fcd925f6c6$export$20265b12c6625451(interactionId, key, value) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $a66d42fcd925f6c6$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($a66d42fcd925f6c6$var$isPerformanceTracingEnabled()) for(var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], timingData = _Object$entries$_i[1];
            var startTime = timingData.startTime, endTime = timingData.endTime;
            try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($a66d42fcd925f6c6$var$labelStackToString(labelStack, key), " [custom_timing]"), {
                    start: startTime,
                    end: endTime
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
function $a66d42fcd925f6c6$export$728e28c22a0fba4(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($a66d42fcd925f6c6$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($a66d42fcd925f6c6$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $a66d42fcd925f6c6$export$c4b23cc624bd2fb(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $8cJqz.interactions).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($a66d42fcd925f6c6$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($a66d42fcd925f6c6$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $a66d42fcd925f6c6$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($a66d42fcd925f6c6$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat($a66d42fcd925f6c6$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
}
function $a66d42fcd925f6c6$export$943a8b2b5d6b1809(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $8cJqz.interactions).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($a66d42fcd925f6c6$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($a66d42fcd925f6c6$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
            start: start,
            end: end
        });
    } catch (e) {
    // do nothing
    }
}
function $a66d42fcd925f6c6$export$9e04fe1a58571ec(moduleId, timestamp) {
    $a66d42fcd925f6c6$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $a66d42fcd925f6c6$export$6f228d1fdc911d7(identifier, start, end) {
    $a66d42fcd925f6c6$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
var $a66d42fcd925f6c6$var$moduleLoadingRequests = {};
function $a66d42fcd925f6c6$export$f5a8f10de74904da(input) {
    var result = input !== null && input !== void 0 ? input : '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $a66d42fcd925f6c6$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $a66d42fcd925f6c6$var$labelStackToString(labelStack), name, startTime);
}
function $a66d42fcd925f6c6$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $a66d42fcd925f6c6$export$7606887303596f82(interactionId, labelStack, name, experimental) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    var id = (0, $aza3U.v4)();
    if (interaction != null) {
        var _getConfig2;
        var start = performance.now();
        var holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ((_getConfig2 = (0, $i6899.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.experimentalInteractionMetrics) !== null && _getConfig2 !== void 0 && _getConfig2.enabled && experimental) interaction.holdExpActive.set(id, $a66d42fcd925f6c6$var$_objectSpread($a66d42fcd925f6c6$var$_objectSpread({}, holdActive), {}, {
            start: start
        }));
        if (!experimental) interaction.holdActive.set(id, $a66d42fcd925f6c6$var$_objectSpread($a66d42fcd925f6c6$var$_objectSpread({}, holdActive), {}, {
            start: start
        }));
        $a66d42fcd925f6c6$var$addHoldCriterion(id, labelStack, name, start);
        return function() {
            var end = performance.now();
            if ($a66d42fcd925f6c6$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($a66d42fcd925f6c6$var$labelStackToString(labelStack, name), " [hold]"), {
                    start: start,
                    end: end
                });
            } catch (e) {
            // do nothing
            }
            $a66d42fcd925f6c6$var$removeHoldCriterion(id);
            var currentInteraction = (0, $8cJqz.interactions).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            var expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push($a66d42fcd925f6c6$var$_objectSpread($a66d42fcd925f6c6$var$_objectSpread({}, currentHold), {}, {
                        end: end
                    }));
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push($a66d42fcd925f6c6$var$_objectSpread($a66d42fcd925f6c6$var$_objectSpread({}, expHold), {}, {
                        end: end
                    }));
                    interaction.holdExpActive.delete(id);
                }
            }
        };
    }
    return function() {};
}
function $a66d42fcd925f6c6$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
        $a66d42fcd925f6c6$var$addHoldCriterion(id, labelStack, name, start);
    }
    return function() {};
}
function $a66d42fcd925f6c6$export$4983dfbbb996f7ae(interactionId, id) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $8cJqz.interactions).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push($a66d42fcd925f6c6$var$_objectSpread($a66d42fcd925f6c6$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
            $a66d42fcd925f6c6$var$removeHoldCriterion(id);
        }
    }
}
function $a66d42fcd925f6c6$export$2df109852219d16e(interactionId) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
var $a66d42fcd925f6c6$export$9591b52b33ccc510 = {
    onPreload: function onPreload(moduleId, _priority) {
        $a66d42fcd925f6c6$export$9e04fe1a58571ec($a66d42fcd925f6c6$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart: function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $a66d42fcd925f6c6$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $a66d42fcd925f6c6$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function onLoadComplete(info) {
        var request = $a66d42fcd925f6c6$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $a66d42fcd925f6c6$var$moduleLoadingRequests[info.identifier];
            $a66d42fcd925f6c6$export$6f228d1fdc911d7($a66d42fcd925f6c6$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $cjKHH.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $a66d42fcd925f6c6$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $cjKHH.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $a66d42fcd925f6c6$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $a66d42fcd925f6c6$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
}
function $a66d42fcd925f6c6$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $8cJqz.interactions).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
}
function $a66d42fcd925f6c6$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig3;
    if ($a66d42fcd925f6c6$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($a66d42fcd925f6c6$var$labelStackToString(labelStack), " [react-profiler] ").concat(type), {
            start: startTime,
            duration: actualDuration
        });
    } catch (e) {
    // do nothing
    }
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig3 = (0, $i6899.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.postInteractionLog) !== null && _getConfig3 !== void 0 && _getConfig3.enabled) $a66d42fcd925f6c6$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $a66d42fcd925f6c6$var$pushToQueue(id, data) {
    $a66d42fcd925f6c6$var$interactionQueue.push({
        id: id,
        data: data
    });
}
var $a66d42fcd925f6c6$var$handleInteraction = $a66d42fcd925f6c6$var$pushToQueue;
function $a66d42fcd925f6c6$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
function $a66d42fcd925f6c6$var$finishInteraction(id, data) {
    var _getConfig4, _getConfig5;
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 [".concat(data.type, "] ").concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $4OLmu.currentFeatureFlagsAccessed));
    (0, $50Vt1.clearActiveTrace)();
    $a66d42fcd925f6c6$var$callCleanUpCallbacks(data);
    if ((_getConfig4 = (0, $i6899.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.vc) !== null && _getConfig4 !== void 0 && _getConfig4.stopVCAtInteractionFinish) {
        // Use per-interaction VC observer if available, otherwise fall back to global
        var observer = data.vcObserver || (0, $2nvs7.getVCObserver)();
        data.vc = observer.getVCRawData();
    }
    if (!((_getConfig5 = (0, $i6899.getConfig)()) !== null && _getConfig5 !== void 0 && (_getConfig5 = _getConfig5.experimentalInteractionMetrics) !== null && _getConfig5 !== void 0 && _getConfig5.enabled)) $a66d42fcd925f6c6$export$cd7f480d6b8286c3(id);
    $a66d42fcd925f6c6$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
    $a66d42fcd925f6c6$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) $a66d42fcd925f6c6$var$handleInteraction(id, data);
    if ($a66d42fcd925f6c6$var$isPerformanceTracingEnabled()) {
        var profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach(function(profilerTiming) {
            var labelStackId = $a66d42fcd925f6c6$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap$ge, _timing$start, _timing$end;
                var timing = (_profilerTimingMap$ge = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap$ge !== void 0 ? _profilerTimingMap$ge : {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < ((_timing$start = timing.start) !== null && _timing$start !== void 0 ? _timing$start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > ((_timing$end = timing.end) !== null && _timing$end !== void 0 ? _timing$end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            var _iterator3 = $a66d42fcd925f6c6$var$_createForOfIteratorHelper(profilerTimingMap.entries()), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _step3$value = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_step3.value, 2), _step3$value$ = _step3$value[1], labelStack = _step3$value$.labelStack, start = _step3$value$.start, end = _step3$value$.end;
                    performance.measure("\uD83D\uDEF8 ".concat($a66d42fcd925f6c6$var$labelStackToString(labelStack), " [segment_ttai]"), {
                        start: start,
                        end: end
                    });
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
}
function $a66d42fcd925f6c6$export$9e614a29a1ac213e(sinkFn) {
    if ($a66d42fcd925f6c6$var$handleInteraction === $a66d42fcd925f6c6$var$pushToQueue) {
        $a66d42fcd925f6c6$var$handleInteraction = sinkFn;
        $a66d42fcd925f6c6$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $a66d42fcd925f6c6$var$interactionQueue.length = 0;
    }
}
function $a66d42fcd925f6c6$export$8a1ba7bef607358a(sinkFn) {
    $a66d42fcd925f6c6$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
var $a66d42fcd925f6c6$var$activeSubmitted = false;
function $a66d42fcd925f6c6$export$673be905888f8839(interactionId, endTime) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) {
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var noMoreExpHolds = interaction.holdExpActive.size === 0;
        var postInteraction = /*#__PURE__*/ function() {
            var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee() {
                var _getConfig6, _getConfig8;
                var _getConfig7, experimentalVC90, experimentalTTAI, _yield$getExperimenta, start, end;
                return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!((_getConfig6 = (0, $i6899.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.postInteractionLog) !== null && _getConfig6 !== void 0 && _getConfig6.enabled)) {
                                _context.next = 17;
                                break;
                            }
                            if (!((_getConfig7 = (0, $i6899.getConfig)()) !== null && _getConfig7 !== void 0 && (_getConfig7 = _getConfig7.experimentalInteractionMetrics) !== null && _getConfig7 !== void 0 && _getConfig7.enabled)) {
                                _context.next = 16;
                                break;
                            }
                            _context.next = 4;
                            return (0, $fmYzr.getExperimentalVCMetrics)(interaction);
                        case 4:
                            _context.t1 = _yield$getExperimenta = _context.sent;
                            _context.t0 = _context.t1 === null;
                            if (_context.t0) {
                                _context.next = 8;
                                break;
                            }
                            _context.t0 = _yield$getExperimenta === void 0;
                        case 8:
                            if (!_context.t0) {
                                _context.next = 12;
                                break;
                            }
                            _context.t2 = void 0;
                            _context.next = 13;
                            break;
                        case 12:
                            _context.t2 = _yield$getExperimenta['metric:experimental:vc90'];
                        case 13:
                            experimentalVC90 = _context.t2;
                            start = interaction.start, end = interaction.end;
                            experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                        case 16:
                            $a66d42fcd925f6c6$export$d8f52e8f804021e8.onInteractionComplete($a66d42fcd925f6c6$var$_objectSpread($a66d42fcd925f6c6$var$_objectSpread({}, interaction), {}, {
                                experimentalTTAI: experimentalTTAI,
                                experimentalVC90: experimentalVC90
                            }));
                        case 17:
                            if ((_getConfig8 = (0, $i6899.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.experimentalInteractionMetrics) !== null && _getConfig8 !== void 0 && _getConfig8.enabled) $a66d42fcd925f6c6$export$cd7f480d6b8286c3(interactionId);
                            $a66d42fcd925f6c6$var$activeSubmitted = false;
                        case 19:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function postInteraction() {
                return _ref.apply(this, arguments);
            };
        }();
        if (noMoreActiveHolds) {
            if (!$a66d42fcd925f6c6$var$activeSubmitted) {
                $a66d42fcd925f6c6$var$finishInteraction(interactionId, interaction, endTime);
                $a66d42fcd925f6c6$var$activeSubmitted = true;
            }
            if (noMoreExpHolds) {
                var _getConfig9;
                if ((_getConfig9 = (0, $i6899.getConfig)()) !== null && _getConfig9 !== void 0 && (_getConfig9 = _getConfig9.experimentalInteractionMetrics) !== null && _getConfig9 !== void 0 && _getConfig9.enabled) (0, $fmYzr.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                postInteraction();
            }
        }
    }
}
function $a66d42fcd925f6c6$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function $a66d42fcd925f6c6$export$5def58af4fd46132(interactionId, abortReason) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) {
        var _getConfig0;
        $a66d42fcd925f6c6$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $a66d42fcd925f6c6$var$finishInteraction(interactionId, interaction);
        if ((_getConfig0 = (0, $i6899.getConfig)()) !== null && _getConfig0 !== void 0 && (_getConfig0 = _getConfig0.experimentalInteractionMetrics) !== null && _getConfig0 !== void 0 && _getConfig0.enabled) {
            (0, $fmYzr.onExperimentalInteractionComplete)(interactionId, interaction);
            $a66d42fcd925f6c6$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $a66d42fcd925f6c6$export$c4a545284f55edf2(interactionId, interactionName) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) {
        var _getConfig1;
        $a66d42fcd925f6c6$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $a66d42fcd925f6c6$var$finishInteraction(interactionId, interaction);
        if ((_getConfig1 = (0, $i6899.getConfig)()) !== null && _getConfig1 !== void 0 && (_getConfig1 = _getConfig1.experimentalInteractionMetrics) !== null && _getConfig1 !== void 0 && _getConfig1.enabled) {
            (0, $fmYzr.onExperimentalInteractionComplete)(interactionId, interaction);
            $a66d42fcd925f6c6$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $a66d42fcd925f6c6$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    (0, $8cJqz.interactions).forEach(function(interaction, interactionId) {
        var _getConfig10;
        var noMoreHolds = interaction.holdActive.size === 0;
        if (!noMoreHolds) {
            $a66d42fcd925f6c6$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $a66d42fcd925f6c6$var$finishInteraction(interactionId, interaction);
        if ((_getConfig10 = (0, $i6899.getConfig)()) !== null && _getConfig10 !== void 0 && (_getConfig10 = _getConfig10.experimentalInteractionMetrics) !== null && _getConfig10 !== void 0 && _getConfig10.enabled) {
            (0, $fmYzr.onExperimentalInteractionComplete)(interactionId, interaction);
            $a66d42fcd925f6c6$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $a66d42fcd925f6c6$export$7b9261a96cfe427b(id, cancelCallback) {
    var interaction = (0, $8cJqz.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $a66d42fcd925f6c6$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var _getConfig11;
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    if ((_getConfig11 = (0, $i6899.getConfig)()) !== null && _getConfig11 !== void 0 && (_getConfig11 = _getConfig11.postInteractionLog) !== null && _getConfig11 !== void 0 && _getConfig11.enabled) $a66d42fcd925f6c6$export$d8f52e8f804021e8.reset();
    var vcObserver;
    var previousTime = startTime;
    var timeoutTime = (0, $gQLDR.fg)('platform_ufo_enable_timeout_config') ? (0, $i6899.getInteractionTimeout)(ufoName) : $a66d42fcd925f6c6$var$CLEANUP_TIMEOUT;
    var timerID = setTimeout(function() {
        $a66d42fcd925f6c6$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $a66d42fcd925f6c6$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $ieNoo.default)((0, $i6899.getCapabilityRate)('feature_flag_access'));
    var config = (0, $i6899.getConfig)();
    if (config && config.vc) {
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            disableSizeAndPositionCheck: config.vc.disableSizeAndPositionCheck
        };
        vcObserver = (0, $gQLDR.fg)('platform_ufo_enable_vc_observer_per_interaction') ? (0, $2nvs7.newVCObserver)(vcOptions) : undefined;
    }
    // Create per-interaction VC observer when feature flag is enabled
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $a66d42fcd925f6c6$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $a66d42fcd925f6c6$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $4OLmu.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver
    };
    if (addFeatureFlagsToInteraction) (0, $4OLmu.currentFeatureFlagsAccessed).clear();
    (0, $8cJqz.interactions).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $a66d42fcd925f6c6$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $a66d42fcd925f6c6$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(function() {
        vcObserver.stop(ufoName);
    });
    var awaitBM3TTIList = (0, $i6899.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $a66d42fcd925f6c6$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        var _getConfig12;
        // Use per-interaction VC observer if available, otherwise fall back to global
        var observer = vcObserver || (0, $2nvs7.getVCObserver)();
        observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        $a66d42fcd925f6c6$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((_getConfig12 = (0, $i6899.getConfig)()) !== null && _getConfig12 !== void 0 && (_getConfig12 = _getConfig12.experimentalInteractionMetrics) !== null && _getConfig12 !== void 0 && _getConfig12.enabled) (0, $fmYzr.experimentalVC).start({
            startTime: startTime
        });
    }
    if (type === 'press' && (0, $gQLDR.fg)('platform_ufo_enable_vc_press_interactions')) {
        // Use per-interaction VC observer if available, otherwise fall back to global
        var _observer = vcObserver || (0, $2nvs7.getVCObserver)();
        _observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $a66d42fcd925f6c6$export$4a759336b50e86e3(event) {
    var interaction = $a66d42fcd925f6c6$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === 'PAGE_LOAD') {
            if (!(0, $gQLDR.fg)('platform_ufo_timeout_simplification')) interaction.changeTimeout($a66d42fcd925f6c6$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $a66d42fcd925f6c6$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
}
function $a66d42fcd925f6c6$export$ad216cc25852d44b(apdex) {
    (0, $8cJqz.interactions).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            if (!(0, $gQLDR.fg)('platform_ufo_timeout_simplification')) interaction.changeTimeout($a66d42fcd925f6c6$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $a66d42fcd925f6c6$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
}
function $a66d42fcd925f6c6$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            if (!(0, $gQLDR.fg)('platform_ufo_timeout_simplification')) interaction.changeTimeout($a66d42fcd925f6c6$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $a66d42fcd925f6c6$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
}
function $a66d42fcd925f6c6$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($a66d42fcd925f6c6$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
}
function $a66d42fcd925f6c6$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $a66d42fcd925f6c6$var$getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($a66d42fcd925f6c6$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join('|');
}
function $a66d42fcd925f6c6$export$1c43f9ac826b6462(labelStack) {
    var key = $a66d42fcd925f6c6$var$getSegmentCacheKey(labelStack);
    var existingSegment = $a66d42fcd925f6c6$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $a66d42fcd925f6c6$var$segmentCache.set(key, segmentInfo);
        $a66d42fcd925f6c6$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function $a66d42fcd925f6c6$export$d0365e48b58231c3(labelStack) {
    var key = $a66d42fcd925f6c6$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $a66d42fcd925f6c6$var$segmentCache.get(key);
    if (segmentInfo) {
        $a66d42fcd925f6c6$var$segmentCache.delete(JSON.stringify(labelStack));
        $a66d42fcd925f6c6$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function $a66d42fcd925f6c6$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $8cJqz.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($a66d42fcd925f6c6$var$isPerformanceTracingEnabled()) {
            var prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect$time;
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(nextUfoName, " [redirect]"), {
                    start: (_prevRedirect$time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect$time !== void 0 ? _prevRedirect$time : interaction.start,
                    end: time
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
var $a66d42fcd925f6c6$export$6ce04c7ca6810a7e = [];
var $a66d42fcd925f6c6$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $a66d42fcd925f6c6$export$5342dcad19138a1c(name, start) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var labelStack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $a66d42fcd925f6c6$var$defaultLabelStack;
    var customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $a66d42fcd925f6c6$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("ieNoo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d46fd91f3cb8d0f3$export$2e2bcd8739ae039; });
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $d46fd91f3cb8d0f3$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $d46fd91f3cb8d0f3$export$2e2bcd8739ae039 = $d46fd91f3cb8d0f3$var$coinflip;

});

parcelRegister("i6899", function(module, exports) {

$parcel$export(module.exports, "getConfig", function () { return $d2cf1b47ca35450d$export$44487a86467333c3; });
$parcel$export(module.exports, "isVCRevisionEnabled", function () { return $d2cf1b47ca35450d$export$4babcefc81a3ef0b; });
$parcel$export(module.exports, "getCapabilityRate", function () { return $d2cf1b47ca35450d$export$29b9ffb14861a1d; });
$parcel$export(module.exports, "getAwaitBM3TTIList", function () { return $d2cf1b47ca35450d$export$2d311b3fd18dcab1; });
$parcel$export(module.exports, "getInteractionTimeout", function () { return $d2cf1b47ca35450d$export$c681731847989445; });

var $62ppy = parcelRequire("62ppy");

var $91FVG = parcelRequire("91FVG");

var $a3ftr = parcelRequire("a3ftr");
function $d2cf1b47ca35450d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d2cf1b47ca35450d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d2cf1b47ca35450d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d2cf1b47ca35450d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d2cf1b47ca35450d$var$config;
var $d2cf1b47ca35450d$var$DEFAULT_TTVC_REVISION = 'fy25.02';
function $d2cf1b47ca35450d$export$10d6139a8fb42158(newConfig) {
    var _newConfig$vc;
    // Handle edge cases with `enabledVCRevisions`
    var _ref = (_newConfig$vc = newConfig === null || newConfig === void 0 ? void 0 : newConfig.vc) !== null && _newConfig$vc !== void 0 ? _newConfig$vc : {}, enabledVCRevisions = _ref.enabledVCRevisions;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience) === 'object') $d2cf1b47ca35450d$var$config = $d2cf1b47ca35450d$var$_objectSpread($d2cf1b47ca35450d$var$_objectSpread({}, newConfig), {}, {
        vc: $d2cf1b47ca35450d$var$_objectSpread($d2cf1b47ca35450d$var$_objectSpread({}, newConfig.vc), {}, {
            enabledVCRevisions: {
                // enforce axiom about `enabledVCRevisions.all` config
                all: Array.from(new Set([
                    $d2cf1b47ca35450d$var$DEFAULT_TTVC_REVISION
                ].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all), (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(Object.values(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience).flat())))),
                byExperience: $d2cf1b47ca35450d$var$_objectSpread({}, enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience)
            }
        })
    });
    else $d2cf1b47ca35450d$var$config = newConfig;
}
function $d2cf1b47ca35450d$export$44487a86467333c3() {
    return $d2cf1b47ca35450d$var$config;
}
var $d2cf1b47ca35450d$var$isValidConfigArray = function isValidConfigArray(array) {
    return Array.isArray(array) && array.length > 0;
};
function $d2cf1b47ca35450d$export$87fbc8e01b137811() {
    var experienceKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    try {
        var _config$vc;
        if (!$d2cf1b47ca35450d$var$config) return [];
        if ((_config$vc = $d2cf1b47ca35450d$var$config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
            var _config$vc2, _enabledVCRevisions$b;
            var _ref2 = (_config$vc2 = $d2cf1b47ca35450d$var$config.vc) !== null && _config$vc2 !== void 0 ? _config$vc2 : {}, enabledVCRevisions = _ref2.enabledVCRevisions;
            if ($d2cf1b47ca35450d$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 || (_enabledVCRevisions$b = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b === void 0 ? void 0 : _enabledVCRevisions$b[experienceKey])) {
                var _enabledVCRevisions$b2;
                return (_enabledVCRevisions$b2 = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b2 === void 0 ? void 0 : _enabledVCRevisions$b2[experienceKey];
            }
            if ($d2cf1b47ca35450d$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all)) return enabledVCRevisions.all;
            return [
                $d2cf1b47ca35450d$var$DEFAULT_TTVC_REVISION
            ];
        }
        return [];
    } catch (_unused) {
        return [];
    }
}
function $d2cf1b47ca35450d$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $d2cf1b47ca35450d$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $d2cf1b47ca35450d$export$70184d6e2c753893() {
    var experienceKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var enabledVCRevisions = $d2cf1b47ca35450d$export$87fbc8e01b137811(experienceKey);
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $d2cf1b47ca35450d$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$d2cf1b47ca35450d$var$config) return 0;
        var _config = $d2cf1b47ca35450d$var$config, killswitch = _config.killswitch, rates = _config.rates, rules = _config.rules, kind = _config.kind, autoGeneratedRate = _config.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $d2cf1b47ca35450d$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$d2cf1b47ca35450d$var$config) return 0;
        var _config2 = $d2cf1b47ca35450d$var$config, experimentalInteractionMetrics = _config2.experimentalInteractionMetrics;
        if (!(experimentalInteractionMetrics !== null && experimentalInteractionMetrics !== void 0 && experimentalInteractionMetrics.enabled)) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $d2cf1b47ca35450d$export$1d459f020c06ae34(name, interactionType) {
    try {
        if (!$d2cf1b47ca35450d$var$config) return 0;
        var _config3 = $d2cf1b47ca35450d$var$config, postInteractionLog = _config3.postInteractionLog;
        if (!(postInteractionLog !== null && postInteractionLog !== void 0 && postInteractionLog.enabled)) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (postInteractionLog.rates && typeof postInteractionLog.rates[name] === 'number') return postInteractionLog.rates[name];
        if (postInteractionLog.kind && typeof postInteractionLog.kind[interactionType] === 'number') return postInteractionLog.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $d2cf1b47ca35450d$export$29b9ffb14861a1d(capability) {
    try {
        if (!$d2cf1b47ca35450d$var$config) return 0;
        var _config4 = $d2cf1b47ca35450d$var$config, capabilityRate = _config4.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused2) {
        return 0;
    }
}
var $d2cf1b47ca35450d$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $d2cf1b47ca35450d$export$7e32aae12bf9b50f() {
    var defaultMethod = 'timeout';
    try {
        if (!$d2cf1b47ca35450d$var$config) return defaultMethod;
        var _config5 = $d2cf1b47ca35450d$var$config, typingMethod = _config5.typingMethod;
        if (typingMethod != null && $d2cf1b47ca35450d$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $d2cf1b47ca35450d$export$2d311b3fd18dcab1() {
    try {
        if (!$d2cf1b47ca35450d$var$config) return [];
        var _config6 = $d2cf1b47ca35450d$var$config, awaitBM3TTI = _config6.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $d2cf1b47ca35450d$export$e2ea675800536898() {
    try {
        if (!$d2cf1b47ca35450d$var$config) return false;
        var _config7 = $d2cf1b47ca35450d$var$config, removePageSegmentsUFOPrefixes = _config7.removePageSegmentsUFOPrefixes;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $d2cf1b47ca35450d$export$525ba53ca98e9db() {
    try {
        if (!$d2cf1b47ca35450d$var$config) return false;
        var _config8 = $d2cf1b47ca35450d$var$config, removeInteractionsUFOPrefixes = _config8.removeInteractionsUFOPrefixes;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $d2cf1b47ca35450d$export$4f4649ef27b6f5d6() {
    try {
        if (!$d2cf1b47ca35450d$var$config) return undefined;
        var _config9 = $d2cf1b47ca35450d$var$config, ufoNameOverrides = _config9.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $d2cf1b47ca35450d$export$3c170167645a0eff() {
    try {
        if (!$d2cf1b47ca35450d$var$config) return undefined;
        var _config0 = $d2cf1b47ca35450d$var$config, doNotAbortActivePressInteraction = _config0.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $d2cf1b47ca35450d$export$d6dc9444bd15f70f() {
    try {
        if (!$d2cf1b47ca35450d$var$config) return undefined;
        var _config1 = $d2cf1b47ca35450d$var$config, doNotAbortActivePressInteractionOnTransition = _config1.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
var $d2cf1b47ca35450d$export$2a8604960d7d23d9 = 60000;
function $d2cf1b47ca35450d$export$c681731847989445(ufoName) {
    try {
        if (!$d2cf1b47ca35450d$var$config) return $d2cf1b47ca35450d$export$2a8604960d7d23d9;
        var _config10 = $d2cf1b47ca35450d$var$config, interactionTimeout = _config10.interactionTimeout;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $d2cf1b47ca35450d$export$2a8604960d7d23d9;
    } catch (e) {
        return $d2cf1b47ca35450d$export$2a8604960d7d23d9;
    }
}

});

parcelRegister("fmYzr", function(module, exports) {

$parcel$export(module.exports, "onExperimentalInteractionComplete", function () { return $b307e52637d6c8b1$export$1aed449484dedf63; });
$parcel$export(module.exports, "experimentalVC", function () { return $b307e52637d6c8b1$export$81b28dca2587ec47; });
$parcel$export(module.exports, "getExperimentalVCMetrics", function () { return $b307e52637d6c8b1$export$d17d2b5c5e8d732e; });

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $axdfd = parcelRequire("axdfd");

var $j2UxD = parcelRequire("j2UxD");

var $jvA0h = parcelRequire("jvA0h");
function $b307e52637d6c8b1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b307e52637d6c8b1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b307e52637d6c8b1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b307e52637d6c8b1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b307e52637d6c8b1$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b307e52637d6c8b1$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b307e52637d6c8b1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b307e52637d6c8b1$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b307e52637d6c8b1$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b307e52637d6c8b1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b307e52637d6c8b1$var$interactionBuffer = [];
var $b307e52637d6c8b1$var$bufferInteractionData = function bufferInteractionData(interactionId, data) {
    $b307e52637d6c8b1$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $b307e52637d6c8b1$var$clearInteractionBuffer() {
    $b307e52637d6c8b1$var$interactionBuffer.length = 0;
}
function $b307e52637d6c8b1$var$appendInteractionData(interactionId, data) {
    $b307e52637d6c8b1$var$bufferInteractionData(interactionId, data);
}
function $b307e52637d6c8b1$export$c8a9e17ae62a073d(handler) {
    var _iterator = $b307e52637d6c8b1$var$_createForOfIteratorHelper($b307e52637d6c8b1$var$interactionBuffer), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, _interactionId = _step$value.interactionId, data = _step$value.data;
            handler(_interactionId, data);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    $b307e52637d6c8b1$var$clearInteractionBuffer();
    $b307e52637d6c8b1$var$bufferInteractionData = handler;
}
function $b307e52637d6c8b1$export$7aa99c40634ac65f(sinkFn) {
    $b307e52637d6c8b1$export$c8a9e17ae62a073d(sinkFn);
}
function $b307e52637d6c8b1$export$1aed449484dedf63(interactionId, data) {
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    if (data.ufoName) {
        data.end = endTime;
        $b307e52637d6c8b1$var$appendInteractionData(interactionId, data);
        $b307e52637d6c8b1$var$clearInteractionBuffer();
    }
}
var $b307e52637d6c8b1$export$f9a59f57e0282541 = /*#__PURE__*/ function() {
    function ExperimentalVCMetrics() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ExperimentalVCMetrics);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "vcObserver", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ExperimentalVCMetrics, [
        {
            key: "initialize",
            value: function initialize(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, $jvA0h.VCObserver)($b307e52637d6c8b1$var$_objectSpread($b307e52637d6c8b1$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
                return this;
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        }
    ]);
}();
var $b307e52637d6c8b1$export$81b28dca2587ec47 = new $b307e52637d6c8b1$export$f9a59f57e0282541();
function $b307e52637d6c8b1$export$d17d2b5c5e8d732e(_x) {
    return $b307e52637d6c8b1$var$_getExperimentalVCMetrics.apply(this, arguments);
}
function $b307e52637d6c8b1$var$_getExperimentalVCMetrics() {
    $b307e52637d6c8b1$var$_getExperimentalVCMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(interaction) {
        var vcObserver, _interaction$apdex, prefix, result, VC, pageVisibilityUpToTTAI;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    // Use per-interaction VC observer if available, otherwise fall back to global experimentalVC
                    vcObserver = interaction.experimentalVCObserver || $b307e52637d6c8b1$export$81b28dca2587ec47.vcObserver;
                    if (!vcObserver) {
                        _context.next = 13;
                        break;
                    }
                    prefix = 'ufo-experimental';
                    _context.next = 5;
                    return vcObserver.getVCResult({
                        start: interaction.start,
                        stop: interaction.end,
                        tti: (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime,
                        isEventAborted: !!interaction.abortReason,
                        prefix: prefix,
                        vc: interaction.vc,
                        experienceKey: interaction.ufoName,
                        interactionId: interaction.id
                    });
                case 5:
                    result = _context.sent;
                    VC = result === null || result === void 0 ? void 0 : result['metrics:vc'];
                    if (!(!VC || !(result !== null && result !== void 0 && result["".concat(prefix, ":vc:clean")]))) {
                        _context.next = 9;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 9:
                    pageVisibilityUpToTTAI = (0, $j2UxD.getPageVisibilityState)(interaction.start, interaction.end);
                    if (!(interaction.abortReason || pageVisibilityUpToTTAI !== 'visible')) {
                        _context.next = 12;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 12:
                    return _context.abrupt("return", $b307e52637d6c8b1$var$_objectSpread($b307e52637d6c8b1$var$_objectSpread({}, result), {}, {
                        'metric:experimental:vc90': VC['90']
                    }));
                case 13:
                    return _context.abrupt("return", null);
                case 14:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $b307e52637d6c8b1$var$_getExperimentalVCMetrics.apply(this, arguments);
}

});
parcelRegister("j2UxD", function(module, exports) {

$parcel$export(module.exports, "getPageVisibilityState", function () { return $ddda103422ed845d$export$768b2008623433e1; });

var $40QgJ = parcelRequire("40QgJ");
var $ddda103422ed845d$var$timings = [];
var $ddda103422ed845d$var$wasHiddenFlag;
var $ddda103422ed845d$var$setupFlag = false;
function $ddda103422ed845d$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
var $ddda103422ed845d$var$SIZE = 50;
var $ddda103422ed845d$var$insertIndex = 0;
function $ddda103422ed845d$var$pushHidden(isPageHiddenFlag, time) {
    $ddda103422ed845d$var$timings[$ddda103422ed845d$var$insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    $ddda103422ed845d$var$insertIndex = ($ddda103422ed845d$var$insertIndex + 1) % $ddda103422ed845d$var$SIZE;
    $ddda103422ed845d$var$wasHiddenFlag = isPageHiddenFlag;
}
function $ddda103422ed845d$var$handleChange() {
    var isPageHiddenFlag = $ddda103422ed845d$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$ddda103422ed845d$var$wasHiddenFlag) $ddda103422ed845d$var$pushHidden(isPageHiddenFlag);
        $ddda103422ed845d$var$wasHiddenFlag = true;
    } else {
        if ($ddda103422ed845d$var$wasHiddenFlag) $ddda103422ed845d$var$pushHidden(isPageHiddenFlag);
        $ddda103422ed845d$var$wasHiddenFlag = false;
    }
}
function $ddda103422ed845d$var$setup() {
    (0, $40QgJ.bind)(window, {
        type: 'pageshow',
        listener: $ddda103422ed845d$var$handleChange
    });
    (0, $40QgJ.bind)(window, {
        type: 'pagehide',
        listener: $ddda103422ed845d$var$handleChange
    });
    (0, $40QgJ.bind)(document, {
        type: 'visibilitychange',
        listener: $ddda103422ed845d$var$handleChange
    });
}
function $ddda103422ed845d$export$554cefe0f0373da4() {
    if (!$ddda103422ed845d$var$setupFlag) {
        var isPageHiddenFlag = $ddda103422ed845d$var$isPageHidden();
        $ddda103422ed845d$var$pushHidden(isPageHiddenFlag, 0);
        $ddda103422ed845d$var$setup();
        $ddda103422ed845d$var$setupFlag = true;
    }
}
function $ddda103422ed845d$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($ddda103422ed845d$var$timings.length === 0) return 'visible';
    var currentSize = $ddda103422ed845d$var$timings.length;
    var hiddenState = 'mixed';
    var startIdx = $ddda103422ed845d$var$insertIndex;
    var endIdx = $ddda103422ed845d$var$insertIndex;
    // currentSize is capped at SIZE.
    for(var i = 0; i < currentSize; i++){
        var tmpIdx = ($ddda103422ed845d$var$insertIndex + i) % currentSize;
        if ($ddda103422ed845d$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($ddda103422ed845d$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    if (endIdx - startIdx === 0) {
        if ($ddda103422ed845d$var$timings[startIdx].hidden) hiddenState = 'hidden';
        else hiddenState = 'visible';
    }
    return hiddenState;
}

});
parcelRegister("40QgJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $fSr3Z = parcelRequire("fSr3Z");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $fSr3Z.bind;
    }
});

var $jEJ2f = parcelRequire("jEJ2f");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $jEJ2f.bindAll;
    }
});

});
parcelRegister("fSr3Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $b8f0e45f19d44f03$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $b8f0e45f19d44f03$var$bind;

});

parcelRegister("jEJ2f", function(module, exports) {
"use strict";
var $03b15daca019b586$var$__assign = module.exports && module.exports.__assign || function() {
    $03b15daca019b586$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $03b15daca019b586$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $fSr3Z = parcelRequire("fSr3Z");
function $03b15daca019b586$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $03b15daca019b586$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $03b15daca019b586$var$__assign($03b15daca019b586$var$__assign({}, original), {
        options: $03b15daca019b586$var$__assign($03b15daca019b586$var$__assign({}, $03b15daca019b586$var$toOptions(sharedOptions)), $03b15daca019b586$var$toOptions(original.options))
    });
    return binding;
}
function $03b15daca019b586$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $03b15daca019b586$var$getBinding(original, sharedOptions);
        return (0, $fSr3Z.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $03b15daca019b586$var$bindAll;

});



parcelRegister("jvA0h", function(module, exports) {

$parcel$export(module.exports, "VCObserver", function () { return $e33cd71b266b7a2d$export$1f70d263701b1d01; });

var $62ppy = parcelRequire("62ppy");

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $bM2vx = parcelRequire("bM2vx");

var $82V4i = parcelRequire("82V4i");

var $axdfd = parcelRequire("axdfd");

var $gQLDR = parcelRequire("gQLDR");

var $i6899 = parcelRequire("i6899");

var $ehSVF = parcelRequire("ehSVF");

var $ki4AK = parcelRequire("ki4AK");

var $4wmCK = parcelRequire("4wmCK");

var $5UIMO = parcelRequire("5UIMO");

var $h2wAx = parcelRequire("h2wAx");

var $dNoxG = parcelRequire("dNoxG");
var $e33cd71b266b7a2d$var$_excluded = [
    "__debug__element"
];
function $e33cd71b266b7a2d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e33cd71b266b7a2d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e33cd71b266b7a2d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e33cd71b266b7a2d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e33cd71b266b7a2d$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
var $e33cd71b266b7a2d$var$UNUSED_SECTOR = 0;
function $e33cd71b266b7a2d$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), timestamp = _ref2[0], entries = _ref2[1];
        return [
            Number(timestamp),
            entries.map(function(entry) {
                var __debug__element = entry.__debug__element, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(entry, $e33cd71b266b7a2d$var$_excluded);
                return rest;
            })
        ];
    }));
}
var $e33cd71b266b7a2d$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, VCObserver);
        /* abort logic */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "abortReason", {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "outOfBoundaryInfo", '');
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "arraySize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "componentsLog", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "vcRatios", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "active", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "startTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "ssr", {
            reactRendered: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "unbind", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getAbortReasonInfo", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== '' ? " ".concat(_this.abortReason.info) : '';
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getVCRawData", function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: $e33cd71b266b7a2d$var$_objectSpread({}, _this.abortReason),
                heatmap: _this.heatmap,
                heatmapNext: _this.heatmapNext,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: $e33cd71b266b7a2d$var$_objectSpread({}, _this.componentsLog),
                viewport: $e33cd71b266b7a2d$var$_objectSpread({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled,
                ratios: _this.vcRatios
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getVCResult", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(_ref3) {
                var start, stop, tti, prefix, ssr, vc, isEventAborted, experienceKey, interactionId, includeSSRRatio, startTime, fullPrefix, rawData, abortReason, abortReasonInfo, heatmap, heatmapNext, outOfBoundaryInfo, totalTime, componentsLog, viewport, devToolsEnabled, ratios, isTTVCv1Disabled, vcAbortedResultWithRevisions, ttvcV1Result, VC, VCBox, VCEntries, totalPainted, _componentsLog, vcNext, outOfBoundary, stopTime, ttvcV1DevToolInfo, ttvcV2DevToolInfo, shouldCreateDebugDetails, v1RevisionDebugDetails, v2RevisionDebugDetails, _window$__ufo_devtool2, _window2, _window$__ufo_devtool, _window, _window$__on_ufo_vc_d2, _window4, _window$__on_ufo_vc_d, _window3, isVCClean, revisionsData, speedIndex, SSRRatio, SSRRatioNext, SSRRatioPayload, isTTVCv3Enabled;
                return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            start = _ref3.start, stop = _ref3.stop, tti = _ref3.tti, prefix = _ref3.prefix, ssr = _ref3.ssr, vc = _ref3.vc, isEventAborted = _ref3.isEventAborted, experienceKey = _ref3.experienceKey, interactionId = _ref3.interactionId, includeSSRRatio = _ref3.includeSSRRatio;
                            startTime = performance.now(); // add local measurement
                            fullPrefix = prefix !== undefined && prefix !== '' ? "".concat(prefix, ":") : '';
                            rawData = vc !== undefined ? vc : _this.getVCRawData();
                            if (!(rawData === null)) {
                                _context.next = 6;
                                break;
                            }
                            return _context.abrupt("return", {});
                        case 6:
                            abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, heatmapNext = rawData.heatmapNext, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, devToolsEnabled = rawData.devToolsEnabled, ratios = rawData.ratios;
                            isTTVCv1Disabled = !(0, $i6899.isVCRevisionEnabled)('fy25.01', experienceKey);
                            if (!(abortReasonInfo !== null)) {
                                _context.next = 13;
                                break;
                            }
                            // exposing data to devtools
                            try {
                                if (devToolsEnabled && !_this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                            } catch (e) {}
                            vcAbortedResultWithRevisions = (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, "".concat(fullPrefix, "vc:state"), false), "".concat(fullPrefix, "vc:abort:reason"), abortReason.reason), "".concat(fullPrefix, "vc:abort:timestamp"), abortReason.timestamp), "".concat(fullPrefix, "vc:rev"), [
                                {
                                    revision: 'fy25.02',
                                    clean: false,
                                    'metric:vc90': null,
                                    abortReason: abortReason.reason
                                }
                            ]);
                            if (!isTTVCv1Disabled) vcAbortedResultWithRevisions["".concat(fullPrefix, "vc:rev")].push({
                                revision: 'fy25.01',
                                clean: false,
                                'metric:vc90': null,
                                abortReason: abortReason.reason
                            });
                            return _context.abrupt("return", vcAbortedResultWithRevisions);
                        case 13:
                            ttvcV1Result = isTTVCv1Disabled ? {
                                VC: {},
                                VCBox: {},
                                VCEntries: {
                                    abs: [],
                                    rel: [],
                                    speedIndex: -1
                                },
                                totalPainted: -1
                            } : VCObserver.calculateVC({
                                heatmap: heatmap,
                                ssr: ssr,
                                componentsLog: $e33cd71b266b7a2d$var$_objectSpread({}, componentsLog),
                                viewport: viewport,
                                fixSSRAttribution: includeSSRRatio
                            });
                            VC = ttvcV1Result.VC, VCBox = ttvcV1Result.VCBox, VCEntries = ttvcV1Result.VCEntries, totalPainted = ttvcV1Result.totalPainted;
                            _componentsLog = {};
                            Object.entries(_this.componentsLog).forEach(function(_ref5) {
                                var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref5, 2), _timestamp = _ref6[0], value = _ref6[1];
                                var timestamp = Number(_timestamp);
                                if (stop > timestamp) _componentsLog[timestamp] = value;
                            });
                            vcNext = VCObserver.calculateVC({
                                heatmap: heatmapNext,
                                ssr: ssr,
                                componentsLog: _componentsLog,
                                viewport: viewport,
                                fixSSRAttribution: includeSSRRatio
                            });
                            try {
                                if (!_this.isPostInteraction) VCObserver.VCParts.forEach(function(key) {
                                    if (isTTVCv1Disabled) {
                                        var duration = vcNext.VC[key];
                                        if (duration !== null && duration !== undefined) {
                                            performance.measure("VC".concat(key), {
                                                start: start,
                                                duration: duration
                                            });
                                            performance.measure("VC_Next".concat(key), {
                                                start: start,
                                                duration: duration
                                            });
                                        }
                                    } else {
                                        var ttvcV1duration = VC[key];
                                        if (ttvcV1duration !== null && ttvcV1duration !== undefined) performance.measure("VC".concat(key), {
                                            start: start,
                                            duration: ttvcV1duration
                                        });
                                        var ttvcV2duration = vcNext.VC[key];
                                        if (ttvcV2duration !== null && ttvcV2duration !== undefined) performance.measure("VC_Next".concat(key), {
                                            start: start,
                                            duration: ttvcV2duration
                                        });
                                    }
                                });
                            } catch (e) {
                            /* empty */ }
                            outOfBoundary = outOfBoundaryInfo ? (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {}; //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
                            stopTime = performance.now(); // exposing data to devtools
                            try {
                                if (!_this.isPostInteraction && devToolsEnabled) {
                                    ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                                        entries: VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': VC['75'],
                                            '80': VC['80'],
                                            '85': VC['85'],
                                            '90': VC['90'],
                                            '95': VC['95'],
                                            '98': VC['98'],
                                            '99': VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmap,
                                        ratios: ratios
                                    };
                                    ttvcV2DevToolInfo = {
                                        entries: vcNext.VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': vcNext.VC['75'],
                                            '80': vcNext.VC['80'],
                                            '85': vcNext.VC['85'],
                                            '90': vcNext.VC['90'],
                                            '95': vcNext.VC['95'],
                                            '98': vcNext.VC['98'],
                                            '99': vcNext.VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmapNext,
                                        ratios: ratios
                                    };
                                    if (isTTVCv1Disabled) {
                                        window.__vc = ttvcV2DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    } else {
                                        window.__vc = ttvcV1DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    }
                                    // Emitting a custom event to make it available in the Chrome extension
                                    window.dispatchEvent(new CustomEvent('vcReady', {
                                        detail: {
                                            log: $e33cd71b266b7a2d$var$filterComponentsLog(componentsLog),
                                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                                        }
                                    }));
                                }
                                if (!_this.isPostInteraction) {
                                    // Only create revision debug details if callbacks exist
                                    shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function' && (0, $gQLDR.fg)('platform_ufo_emit_vc_debug_data');
                                    if (shouldCreateDebugDetails) {
                                        v1RevisionDebugDetails = (0, $4wmCK.getVCRevisionDebugDetails)({
                                            revision: 'fy25.01',
                                            isClean: !abortReasonInfo,
                                            abortReason: abortReason.reason,
                                            VCEntries: VCEntries.rel,
                                            componentsLog: componentsLog,
                                            interactionId: interactionId
                                        });
                                        v2RevisionDebugDetails = (0, $4wmCK.getVCRevisionDebugDetails)({
                                            revision: 'fy25.02',
                                            isClean: !abortReasonInfo,
                                            abortReason: abortReason.reason,
                                            VCEntries: vcNext.VCEntries.rel,
                                            componentsLog: componentsLog,
                                            interactionId: interactionId
                                        }); // Add devtool callback for both v1 and v2
                                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                                            // Handle v1 if not disabled
                                            if (!isTTVCv1Disabled) (_window$__ufo_devtool = (_window = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool === void 0 || _window$__ufo_devtool.call(_window, v1RevisionDebugDetails);
                                            // Handle v2
                                            (_window$__ufo_devtool2 = (_window2 = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool2 === void 0 || _window$__ufo_devtool2.call(_window2, v2RevisionDebugDetails);
                                        }
                                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function' && (0, $gQLDR.fg)('platform_ufo_emit_vc_debug_data')) {
                                            if (!isTTVCv1Disabled) (_window$__on_ufo_vc_d = (_window3 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d === void 0 || _window$__on_ufo_vc_d.call(_window3, v1RevisionDebugDetails);
                                            (_window$__on_ufo_vc_d2 = (_window4 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d2 === void 0 || _window$__on_ufo_vc_d2.call(_window4, v2RevisionDebugDetails);
                                        }
                                    }
                                }
                            } catch (e) {
                            /*  do nothing */ }
                            isVCClean = !abortReasonInfo;
                            revisionsData = (0, $5UIMO.getVCRevisionsData)({
                                fullPrefix: fullPrefix,
                                interaction: {
                                    start: start,
                                    end: stop
                                },
                                isVCClean: isVCClean,
                                calculatedVC: {
                                    VC: VC,
                                    VCBox: VCBox
                                },
                                calculatedVCNext: {
                                    VC: vcNext.VC,
                                    VCBox: vcNext.VCBox
                                },
                                isEventAborted: isEventAborted,
                                experienceKey: experienceKey,
                                ratios: ratios
                            });
                            speedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, "ufo:speedIndex", isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex), "ufo:next:speedIndex", vcNext.VCEntries.speedIndex);
                            SSRRatio = VCObserver.getSSRRatio(VCEntries.rel, ssr);
                            SSRRatioNext = VCObserver.getSSRRatio(vcNext.VCEntries.rel, ssr);
                            SSRRatioPayload = includeSSRRatio ? (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, "".concat(fullPrefix, "vc:ssrRatio"), isTTVCv1Disabled ? SSRRatioNext : SSRRatio), "".concat(fullPrefix, "vc:next:ssrRatio"), SSRRatioNext) : {};
                            if (!isTTVCv1Disabled) {
                                _context.next = 30;
                                break;
                            }
                            return _context.abrupt("return", $e33cd71b266b7a2d$var$_objectSpread($e33cd71b266b7a2d$var$_objectSpread($e33cd71b266b7a2d$var$_objectSpread($e33cd71b266b7a2d$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:ratios"), ratios), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), SSRRatioPayload), {}, (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, "".concat(fullPrefix, "vc:ssrRatio"), SSRRatioNext), revisionsData), speedIndex));
                        case 30:
                            isTTVCv3Enabled = (0, $i6899.isVCRevisionEnabled)('fy25.03', experienceKey);
                            return _context.abrupt("return", $e33cd71b266b7a2d$var$_objectSpread($e33cd71b266b7a2d$var$_objectSpread($e33cd71b266b7a2d$var$_objectSpread($e33cd71b266b7a2d$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({
                                'metrics:vc': VC
                            }, "".concat(fullPrefix, "vc:state"), true), "".concat(fullPrefix, "vc:clean"), isVCClean), "".concat(fullPrefix, "vc:dom"), VCBox), "".concat(fullPrefix, "vc:updates"), isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:total"), totalPainted), "".concat(fullPrefix, "vc:ratios"), ratios), "".concat(fullPrefix, "vc:ssrRatio"), SSRRatio), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, "".concat(fullPrefix, "vc:next"), vcNext.VC), "".concat(fullPrefix, "vc:next:updates"), isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:next:dom"), vcNext.VCBox), SSRRatioPayload), {}, (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), revisionsData), speedIndex));
                        case 32:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue) {
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.vcRatios[targetName] = _this.getElementRatio(mappedValues);
                if (!ignoreReason) _this.applyChangesToHeatMap(mappedValues, time, _this.heatmapNext);
                var interaction = (0, $ehSVF.getActiveInteraction)();
                var isTTVCv1Disabled = !(0, $i6899.isVCRevisionEnabled)('fy25.01', interaction === null || interaction === void 0 ? void 0 : interaction.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === '') {
                var outOfBoundaryInfo = '';
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize * _this.arraySize);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "abortReasonCallback", function(key, time) {
            switch(key){
                case 'wheel':
                    _this.setAbortReason($e33cd71b266b7a2d$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    _this.setAbortReason($e33cd71b266b7a2d$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    _this.setAbortReason($e33cd71b266b7a2d$var$abortReason.resize, time);
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "attachAbortListeners", function() {
            var _window5;
            _this.detachAbortListeners();
            var unbinds = (0, $ki4AK.attachAbortListeners)(window, _this.viewport, _this.abortReasonCallback);
            if ((_window5 = window) !== null && _window5 !== void 0 && _window5.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(function(_ref9) {
                var _ref0 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref9, 2), key = _ref0[0], time = _ref0[1];
                if (time) _this.abortReasonCallback(key, time);
            });
            _this.unbind = unbinds;
        });
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        var ssrEnablePageLayoutPlaceholder = options.ssrEnablePageLayoutPlaceholder, disableSizeAndPositionCheck = options.disableSizeAndPositionCheck, ssrPlaceholderHandler = options.ssrPlaceholderHandler;
        this.observers = new (0, $dNoxG.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            },
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false,
                disableSizeAndPositionCheck: disableSizeAndPositionCheck
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $i6899.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(VCObserver, [
        {
            key: "start",
            value: function start(_ref1) {
                var startTime = _ref1.startTime;
                this.active = true;
                if (this.observers.isBrowserSupported()) {
                    this.setViewportSize();
                    this.resetState();
                    this.startTime = startTime;
                    this.attachAbortListeners();
                    this.observers.subscribeResults(this.handleUpdate);
                    this.observers.observe();
                } else this.setAbortReason('not-supported', startTime);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "getIgnoredElements",
            value: function getIgnoredElements(componentsLog) {
                return Object.values(componentsLog).flat().filter(function(_ref10) {
                    var ignoreReason = _ref10.ignoreReason;
                    return Boolean(ignoreReason);
                }).map(function(_ref11) {
                    var targetName = _ref11.targetName, ignoreReason = _ref11.ignoreReason;
                    return {
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    };
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $e33cd71b266b7a2d$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: '',
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = !(0, $i6899.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
                this.heatmapNext = this.getCleanHeatmap();
                this.totalTime = 0;
                this.componentsLog = {};
                this.vcRatios = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this2 = this;
                return Array(this.arraySize).fill('').map(function() {
                    return Array(_this2.arraySize).fill($e33cd71b266b7a2d$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = (0, $h2wAx.getViewportWidth)();
                this.viewport.h = (0, $h2wAx.getViewportHeight)();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($e33cd71b266b7a2d$var$abortReason.error, time, "index - ".concat(row));
                        } catch (e) {
                            this.setAbortReason($e33cd71b266b7a2d$var$abortReason.error, time, 'row error');
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                if (this.unbind) {
                    var unbind = this.unbind;
                    for(var i = 0; i < unbind.length; i++)unbind[i]();
                    this.unbind.length = 0;
                }
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ], [
        {
            key: "getSSRRatio",
            value: function getSSRRatio(entries, ssr) {
                if (ssr === undefined || entries.length === 0) return undefined;
                var maybeSSR = entries[0];
                if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
                return 0;
            }
        },
        {
            key: "calculateVC",
            value: function calculateVC(_ref12) {
                var heatmap = _ref12.heatmap, _ref12$ssr = _ref12.ssr, ssr = _ref12$ssr === void 0 ? $e33cd71b266b7a2d$var$UNUSED_SECTOR : _ref12$ssr, componentsLog = _ref12.componentsLog, viewport = _ref12.viewport, fixSSRAttribution = _ref12.fixSSRAttribution;
                var lastUpdate = {};
                var totalPainted = 0;
                var ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
                if (ssrTime !== $e33cd71b266b7a2d$var$UNUSED_SECTOR) {
                    var _window$document;
                    var element = {
                        __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                        intersectionRect: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            x: 0,
                            y: 0,
                            width: viewport.w,
                            height: viewport.h,
                            toJSON: function toJSON() {
                                return {};
                            }
                        },
                        targetName: 'SSR'
                    };
                    if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
                    componentsLog[ssrTime].push(element);
                }
                heatmap.forEach(function(line) {
                    line.forEach(function(entry) {
                        var rounded = Math.floor(entry === $e33cd71b266b7a2d$var$UNUSED_SECTOR && ssrTime !== $e33cd71b266b7a2d$var$UNUSED_SECTOR ? ssrTime : entry);
                        totalPainted += rounded !== $e33cd71b266b7a2d$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $e33cd71b266b7a2d$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    });
                });
                var entries = Object.entries(lastUpdate).map(function(a) {
                    return [
                        parseInt(a[0], 10),
                        a[1]
                    ];
                }).sort(function(a, b) {
                    return a[0] > b[0] ? 1 : -1;
                });
                var VC = VCObserver.makeVCReturnObj();
                var VCBox = VCObserver.makeVCReturnObj();
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var currRatio = v[1] / totalPainted;
                    var VCRatio = currRatio + acc;
                    var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                    var preciseAccRatio = Math.round(acc * 100);
                    VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
                    var time = v[0];
                    VCObserver.VCParts.forEach(function(key) {
                        var value = parseInt(key, 10);
                        if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[key] = time;
                            VCBox[key] = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.filter(function(v) {
                                return !v.ignoreReason;
                            }).map(function(v) {
                                return v.targetName;
                            })));
                        }
                    });
                    return VCRatio;
                }, 0);
                var VCEntries = entries.reduce(function(acc, _ref13, i) {
                    var _acc$abs, _componentsLog$timest, _acc$rel$vc, _acc$rel;
                    var _ref14 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref13, 2), timestamp = _ref14[0], entryPainted = _ref14[1];
                    var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                    var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                    var logEntry = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.filter(function(v) {
                        return !v.ignoreReason;
                    }).map(function(v) {
                        return v.targetName;
                    })));
                    var ratioDelta = (currentlyPaintedRatio - ((_acc$rel$vc = (_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) !== null && _acc$rel$vc !== void 0 ? _acc$rel$vc : 0)) / 100;
                    var speedIndex = timestamp * ratioDelta;
                    acc.speedIndex += speedIndex;
                    acc.abs.push([
                        timestamp,
                        currentlyPainted
                    ]);
                    acc.rel.push({
                        time: timestamp,
                        vc: currentlyPaintedRatio,
                        elements: logEntry
                    });
                    return acc;
                }, {
                    abs: [],
                    rel: [],
                    speedIndex: 0
                });
                VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
                return {
                    VC: VC,
                    VCBox: VCBox,
                    VCEntries: VCEntries,
                    totalPainted: totalPainted
                };
            }
        },
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj() {
                var vc = {};
                VCObserver.VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        }
    ]);
}();
/** config * */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($e33cd71b266b7a2d$export$1f70d263701b1d01, "VCParts", [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
]);

});
parcelRegister("ki4AK", function(module, exports) {

$parcel$export(module.exports, "attachAbortListeners", function () { return $ec590cedbb886136$export$9010aa71841a6887; });

var $40QgJ = parcelRequire("40QgJ");

var $akKrM = parcelRequire("akKrM");

var $h2wAx = parcelRequire("h2wAx");
function $ec590cedbb886136$export$9010aa71841a6887(window, initialViewPort, callback) {
    var unbindWheel = (0, $40QgJ.bind)(window, {
        type: (0, $akKrM.AbortEvent).wheel,
        listener: function listener(e) {
            callback((0, $akKrM.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    var unbindKeydown = (0, $40QgJ.bind)(window, {
        type: (0, $akKrM.AbortEvent).keydown,
        listener: function listener(e) {
            callback((0, $akKrM.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    var unbindResize = (0, $40QgJ.bind)(window, {
        type: (0, $akKrM.AbortEvent).resize,
        listener: function listener(e) {
            if ((0, $h2wAx.getViewportWidth)() !== initialViewPort.w || (0, $h2wAx.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $akKrM.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("akKrM", function(module, exports) {

$parcel$export(module.exports, "AbortEvent", function () { return $785fcd11efe13bdc$export$199edc0307b5587f; });
var $785fcd11efe13bdc$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("h2wAx", function(module, exports) {

$parcel$export(module.exports, "getViewportWidth", function () { return $c67be6f5b885df22$export$a497a1dcb4408212; });
$parcel$export(module.exports, "getViewportHeight", function () { return $c67be6f5b885df22$export$4f01c15d21ef9cc6; });
function $c67be6f5b885df22$export$a497a1dcb4408212() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $c67be6f5b885df22$export$4f01c15d21ef9cc6() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("4wmCK", function(module, exports) {

$parcel$export(module.exports, "getVCRevisionDebugDetails", function () { return $34abb33cd6343324$export$72e6dda9d5859230; });

var $82V4i = parcelRequire("82V4i");

var $62ppy = parcelRequire("62ppy");
function $34abb33cd6343324$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $34abb33cd6343324$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $34abb33cd6343324$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $34abb33cd6343324$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $34abb33cd6343324$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $34abb33cd6343324$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $34abb33cd6343324$export$72e6dda9d5859230(_ref) {
    var revision = _ref.revision, isClean = _ref.isClean, abortReason = _ref.abortReason, VCEntries = _ref.VCEntries, componentsLog = _ref.componentsLog, interactionId = _ref.interactionId;
    // Pre-sort VCEntries by time for efficient lookups
    var sortedVCEntries = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(VCEntries).sort(function(a, b) {
        return a.time - b.time;
    });
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    var maxViewportPercentageAtTime = new Map();
    var maxSoFar = 0;
    var _iterator = $34abb33cd6343324$var$_createForOfIteratorHelper(sortedVCEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var entry = _step.value;
            maxSoFar = Math.max(maxSoFar, entry.vc);
            maxViewportPercentageAtTime.set(entry.time, maxSoFar);
        }
    // Helper function to find the biggest previous viewport percentage
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
        // Binary search for the largest time <= targetTime
        var left = 0;
        var right = sortedVCEntries.length - 1;
        var result = -1;
        while(left <= right){
            var mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    var allVcLogs = [];
    // Add regular VC entries
    var _iterator2 = $34abb33cd6343324$var$_createForOfIteratorHelper(VCEntries), _step2;
    try {
        var _loop = function _loop() {
            var entry = _step2.value;
            var timeLogEntries = componentsLog[entry.time];
            allVcLogs.push({
                time: entry.time,
                viewportPercentage: entry.vc,
                entries: entry.elements.map(function(element) {
                    var logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find(function(log) {
                        return log.targetName === element;
                    });
                    return {
                        elementName: element,
                        type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
                        rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
                        visible: true,
                        attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
                        oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
                        newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
                        ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
                    };
                })
            });
        };
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;)_loop();
    // Add ignored elements - only process timestamps that have ignored elements
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    for(var _i = 0, _Object$entries = Object.entries(componentsLog); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries[_i], 2), timestamp = _Object$entries$_i[0], timeLogEntries = _Object$entries$_i[1];
        var ignoredElements = timeLogEntries.filter(function(log) {
            return log.ignoreReason;
        });
        if (ignoredElements.length === 0) continue;
        var time = Number(timestamp);
        var viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map(function(logEntry) {
                return {
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                };
            })
        });
    }
    // Sort once at the end
    allVcLogs.sort(function(a, b) {
        return a.time - b.time;
    });
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("5UIMO", function(module, exports) {

$parcel$export(module.exports, "getVCRevisionsData", function () { return $44e4ec5354ea2a8c$export$5c86a34c9becd6d0; });

var $91FVG = parcelRequire("91FVG");

var $gQLDR = parcelRequire("gQLDR");

var $i6899 = parcelRequire("i6899");

var $j2UxD = parcelRequire("j2UxD");
function $44e4ec5354ea2a8c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $44e4ec5354ea2a8c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $44e4ec5354ea2a8c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $44e4ec5354ea2a8c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $44e4ec5354ea2a8c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $44e4ec5354ea2a8c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $44e4ec5354ea2a8c$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
var $44e4ec5354ea2a8c$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $44e4ec5354ea2a8c$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    var details = {};
    var VC = calculatedVC.VC, VCBox = calculatedVC.VCBox; // Destructure once to avoid repeated property access
    var _iterator = $44e4ec5354ea2a8c$var$_createForOfIteratorHelper($44e4ec5354ea2a8c$var$VCParts), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            details[key] = {
                t: VC[key] || -1,
                e: VCBox[key] || $44e4ec5354ea2a8c$var$READONLY_EMPTY_ARRAY
            };
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return details;
}
function $44e4ec5354ea2a8c$export$5c86a34c9becd6d0(_ref) {
    var fullPrefix = _ref.fullPrefix, interaction = _ref.interaction, isVCClean = _ref.isVCClean, isEventAborted = _ref.isEventAborted, calculatedVC = _ref.calculatedVC, calculatedVCNext = _ref.calculatedVCNext, experienceKey = _ref.experienceKey, ratios = _ref.ratios;
    var pageVisibilityUpToTTAI = (0, $j2UxD.getPageVisibilityState)(interaction.start, interaction.end);
    var isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    var shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    var availableVCRevisionPayloads = [];
    if ((0, $i6899.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        var revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $44e4ec5354ea2a8c$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric && (0, $gQLDR.fg)('platform_ufo_rev_ratios')) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $i6899.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        var _revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $44e4ec5354ea2a8c$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric && (0, $gQLDR.fg)('platform_ufo_rev_ratios')) _revision.ratios = ratios;
        availableVCRevisionPayloads.push(_revision);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, "".concat(fullPrefix, "vc:rev"), availableVCRevisionPayloads);
}

});

parcelRegister("dNoxG", function(module, exports) {

$parcel$export(module.exports, "Observers", function () { return $a0b2e38ddda4cf11$export$b65d046240060e78; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $63mGt = parcelRequire("63mGt");

var $4T0v1 = parcelRequire("4T0v1");

var $8akC3 = parcelRequire("8akC3");

var $3P708 = parcelRequire("3P708");
function $a0b2e38ddda4cf11$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0b2e38ddda4cf11$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0b2e38ddda4cf11$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0b2e38ddda4cf11$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a0b2e38ddda4cf11$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $a0b2e38ddda4cf11$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    var isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
var $a0b2e38ddda4cf11$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, Observers);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "observedMutations", new WeakMap());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "elementsInView", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "callbacks", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "ssr", {
            state: $a0b2e38ddda4cf11$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "observeElement", function(node, mutation, type, ignoreReason, attributeName) {
            var _this$intersectionObs;
            var oldValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var newValue = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        });
        this.selectorConfig = $a0b2e38ddda4cf11$var$_objectSpread($a0b2e38ddda4cf11$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else {
            var _opts$SSRConfig, _opts$SSRConfig2;
            this.ssrPlaceholderHandler = new (0, $3P708.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_opts$SSRConfig = opts.SSRConfig) === null || _opts$SSRConfig === void 0 ? void 0 : _opts$SSRConfig.enablePageLayoutPlaceholder,
                disableSizeAndPositionCheck: (_opts$SSRConfig2 = opts.SSRConfig) === null || _opts$SSRConfig2 === void 0 ? void 0 : _opts$SSRConfig2.disableSizeAndPositionCheck
            });
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(Observers, [
        {
            key: "isBrowserSupported",
            value: function isBrowserSupported() {
                return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
            }
        },
        {
            key: "observe",
            value: function observe() {
                var _this$mutationObserve;
                this.totalTime = 0;
                this.ssr = {
                    state: $a0b2e38ddda4cf11$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeFilter: [
                        'hidden',
                        'style',
                        'src',
                        'class'
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this$mutationObserve2, _this$intersectionObs2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.disconnect();
                this.observedMutations = new WeakMap();
                this.elementsInView.clear();
                this.callbacks.clear();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $a0b2e38ddda4cf11$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                if (!this.isBrowserSupported()) return null;
                return new MutationObserver(function(mutations) {
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignoreReason = '';
                        if (_this2.ssr.state === $a0b2e38ddda4cf11$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $a0b2e38ddda4cf11$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignoreReason = 'ssr-hydration';
                        }
                        if (_this2.ssr.state === $a0b2e38ddda4cf11$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignoreReason = 'ssr-hydration';
                            else _this2.ssr.state = $a0b2e38ddda4cf11$var$state.normal;
                        }
                        if (mutation.type === 'childList') {
                            mutation.addedNodes.forEach(function(node) {
                                if ((0, $63mGt.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    _this2.observeElement(node, mutation, 'html', ignoreReason);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === 'attributes') {
                            if (mutation.target instanceof HTMLElement) {
                                var _mutation$oldValue;
                                var attributeName = mutation.attributeName;
                                /*
              	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
              	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
              	Conceptually there is after all a mutation: there is an old value replaced with a new one,
              	and whether or not they are the same doesn't really matter.
              	And Custom elements should work the same way as MutationObserver."
              	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
              */ var oldValue = (_mutation$oldValue = mutation.oldValue) !== null && _mutation$oldValue !== void 0 ? _mutation$oldValue : undefined;
                                var newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                                if (oldValue !== newValue) {
                                    if ((0, $4T0v1.default)(mutation)) ignoreReason = 'non-visual-style';
                                    if ((0, $63mGt.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                                    _this2.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                                }
                            }
                        }
                    });
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute('data-vc');
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? "[data-vc=\"".concat(dataVCAttr, "\"]") : '';
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : '';
                    var testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
                    testId = testId ? "[testid=".concat(testId, "]") : '';
                    var role = this.selectorConfig.role ? element.getAttribute('role') : '';
                    role = role ? "[role=".concat(role, "]") : '';
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
                    classList = classList === '' ? '' : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join('');
                    var idString = '';
                    if (attrs === '' && classList === '') {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join('');
                    return idString;
                } catch (e) {
                    return 'error';
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                if (!this.isBrowserSupported()) return null;
                return new IntersectionObserver(function(entries) {
                    _this3.measureStart();
                    entries.forEach(function(_ref) {
                        var isIntersecting = _ref.isIntersecting, ir = _ref.intersectionRect, target = _ref.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            if (!$a0b2e38ddda4cf11$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                            if ((0, $8akC3.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (e) {
                                    elementName = 'error';
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                });
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
}();

});
parcelRegister("63mGt", function(module, exports) {

$parcel$export(module.exports, "isContainedWithinMediaWrapper", function () { return $46849e75eb87c85f$export$f61fbc3b9c4a9019; });

var $k8BSt = parcelRequire("k8BSt");
function $46849e75eb87c85f$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $k8BSt.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("k8BSt", function(module, exports) {

$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", function () { return $ea91efb050ab4181$export$7674290405cc25b0; });

var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");
var $ea91efb050ab4181$export$7674290405cc25b0 = 'data-media-vc-wrapper';
var $ea91efb050ab4181$export$7028e9efe569888c = (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, $ea91efb050ab4181$export$7674290405cc25b0, true);
function $ea91efb050ab4181$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", $ea91efb050ab4181$export$7028e9efe569888c, children);
}

});


parcelRegister("4T0v1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ecafa31c797306$export$2e2bcd8739ae039; });
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $38ecafa31c797306$var$isNonVisualStyleMutation(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName;
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $38ecafa31c797306$export$2e2bcd8739ae039 = $38ecafa31c797306$var$isNonVisualStyleMutation;

});

parcelRegister("8akC3", function(module, exports) {

$parcel$export(module.exports, "RLLPlaceholderHandlers", function () { return $5f1f3f2e2491267c$export$166779fc0f49d4df; });

var $62ppy = parcelRequire("62ppy");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $gQLDR = parcelRequire("gQLDR");
var $5f1f3f2e2491267c$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
var $5f1f3f2e2491267c$export$166779fc0f49d4df = /*#__PURE__*/ function() {
    function RLLPlaceholderHandlers() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, RLLPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "placeholders", []);
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(RLLPlaceholderHandlers, [
        {
            key: "reset",
            value: function reset() {
                this.placeholders = [];
            }
        },
        {
            key: "collectRLLPlaceholders",
            value: function collectRLLPlaceholders() {
                if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
                if (!(0, $gQLDR.fg)('platform_ufo_rll_placeholder_ignore')) return;
                var beginElements = document.querySelectorAll('input[data-lazy-begin]');
                var beginCount = beginElements.length;
                if (beginCount === 0) return;
                // Performance optimization: pre-allocate array with estimated size
                var allElements = [];
                // Performance optimization: use traditional for loop instead of forEach
                for(var i = 0; i < beginCount; i++){
                    var beginEl = beginElements[i];
                    var id = beginEl.getAttribute('data-lazy-begin');
                    if (!id) continue;
                    var elements = this.refElements(beginEl, id);
                    if (elements.length > 0) allElements.push.apply(allElements, (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(elements));
                }
                // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
                var allElementsLength = allElements.length;
                if (allElementsLength > 0) {
                    // Performance optimization: pre-allocate array with exact size
                    var intersectingRects = [];
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    for(var _i = 0; _i < allElementsLength; _i++){
                        var rect = allElements[_i].getBoundingClientRect();
                        // Performance optimization: inline intersection calculation to avoid function call overhead
                        var left = Math.max(rect.left, 0);
                        var top = Math.max(rect.top, 0);
                        var right = Math.min(rect.right, windowWidth);
                        var bottom = Math.min(rect.bottom, windowHeight);
                        // Check if there's a valid intersection with non-zero width and height
                        if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
                    }
                    this.placeholders = intersectingRects;
                }
            }
        },
        {
            key: "refElements",
            value: function refElements(fromEl, id) {
                var result = [];
                var el = fromEl.nextSibling;
                // Performance optimization: use while loop instead of recursive calls
                while(el){
                    var _el$dataset;
                    if (((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.lazyEnd) === id) break;
                    if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
                    el = el.nextSibling;
                }
                return result;
            }
        },
        {
            key: "getPlaceholders",
            value: function getPlaceholders() {
                return this.placeholders;
            }
        },
        {
            key: "isRLLPlaceholderHydration",
            value: function isRLLPlaceholderHydration(intersectingRect) {
                var placeholdersLength = this.placeholders.length;
                if (placeholdersLength === 0) return false;
                // Performance optimization: cache array length and use traditional for loop
                for(var i = 0; i < placeholdersLength; i++){
                    var placeholderRect = this.placeholders[i];
                    if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
                }
                return false;
            }
        },
        {
            key: "areRectsEqual",
            value: function areRectsEqual(rect1, rect2) {
                // Early exit for exact matches (most common case)
                if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
                // Performance optimization: check largest differences first for early exit
                var leftDiff = rect1.left - rect2.left;
                if (leftDiff > 1 || leftDiff < -1) return false;
                var rightDiff = rect1.right - rect2.right;
                if (rightDiff > 1 || rightDiff < -1) return false;
                var topDiff = rect1.top - rect2.top;
                if (topDiff > 1 || topDiff < -1) return false;
                var bottomDiff = rect1.bottom - rect2.bottom;
                if (bottomDiff > 1 || bottomDiff < -1) return false;
                return true;
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (typeof globalThis !== 'undefined') {
                    if (!globalThis[$5f1f3f2e2491267c$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$5f1f3f2e2491267c$var$GLOBAL_RLL_HANDLERS_KEY] = new RLLPlaceholderHandlers();
                    return globalThis[$5f1f3f2e2491267c$var$GLOBAL_RLL_HANDLERS_KEY];
                }
                // Fallback for environments without globalThis (should be rare)
                return new RLLPlaceholderHandlers();
            }
        }
    ]);
}();

});

parcelRegister("3P708", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", function () { return $2c8b90ca5ceed52a$export$c0102f1a1198d10f; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");
var $2c8b90ca5ceed52a$var$ANCESTOR_LOOKUP_LIMIT = 10;
var $2c8b90ca5ceed52a$var$PAGE_LAYOUT_ID = 'page-layout.root';
var $2c8b90ca5ceed52a$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers(_ref) {
        var _this = this;
        var _ref$enablePageLayout = _ref.enablePageLayoutPlaceholder, enablePageLayoutPlaceholder = _ref$enablePageLayout === void 0 ? false : _ref$enablePageLayout, _ref$disableSizeAndPo = _ref.disableSizeAndPositionCheck, disableSizeAndPositionCheck = _ref$disableSizeAndPo === void 0 ? {
            v: false,
            h: false
        } : _ref$disableSizeAndPo;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, SSRPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "staticPlaceholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "callbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "reactValidateCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "EQUALITY_THRESHOLD", 1);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getPlaceholderId", function(el) {
            var _el$dataset;
            var ssrPlaceholderId = el === null || el === void 0 || (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $2c8b90ca5ceed52a$var$PAGE_LAYOUT_ID) return $2c8b90ca5ceed52a$var$PAGE_LAYOUT_ID;
            return '';
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "getPlaceholderReplacementId", function(el) {
            var _el$dataset2;
            var ssrPlaceholderReplaceId = el === null || el === void 0 || (_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $2c8b90ca5ceed52a$var$PAGE_LAYOUT_ID) return $2c8b90ca5ceed52a$var$PAGE_LAYOUT_ID;
            return '';
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "intersectionObserverCallback", function(_ref2) {
            var _this$intersectionObs;
            var target = _ref2.target, boundingClientRect = _ref2.boundingClientRect;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = _this.getPlaceholderId(target);
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || _this.isDummyRect(rect)) _resolve(hasSameSizePosition);
                    else requestAnimationFrame(function() {
                        var targetRect = target.getBoundingClientRect();
                        var hasSameSizePosition = _this.hasSameSizePosition(rect, targetRect);
                        _resolve(hasSameSizePosition);
                    });
                    _this.callbacks.delete(staticKey);
                }
            } else {
                var key = _this.getPlaceholderReplacementId(target);
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _this.hasSameSizePosition(_rect, boundingClientRect);
                if (_hasSameSizePosition || _this.isDummyRect(_rect)) _resolve2(_hasSameSizePosition);
                else requestAnimationFrame(function() {
                    var targetRect = target.getBoundingClientRect();
                    var hasSameSizePosition = _this.hasSameSizePosition(_rect, targetRect);
                    _resolve2(hasSameSizePosition);
                });
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        this.disableSizeAndPositionCheck = disableSizeAndPositionCheck;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "collectPlaceholdersInternal",
            value: function collectPlaceholdersInternal() {
                var _this2 = this;
                var selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
                var existingElements = document.querySelectorAll(selector);
                existingElements.forEach(function(el) {
                    var placeholderId = el instanceof HTMLElement && _this2.getPlaceholderId(el);
                    if (placeholderId && !_this2.staticPlaceholders.has(placeholderId)) {
                        var _window$__SSR_PLACEHO, _this2$intersectionOb;
                        var width = -1;
                        var height = -1;
                        var x = -1;
                        var y = -1;
                        // Use SSR dimensions from window global if available
                        var boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[placeholderId];
                        if (boundingClientRect) {
                            width = boundingClientRect.width;
                            height = boundingClientRect.height;
                            x = boundingClientRect.x;
                            y = boundingClientRect.y;
                        } else {
                            // Fallback to current bounding rect if SSR dimensions not available
                            var rect = el.getBoundingClientRect();
                            width = rect.width;
                            height = rect.height;
                            x = rect.x;
                            y = rect.y;
                        }
                        _this2.staticPlaceholders.set(placeholderId, {
                            width: width,
                            height: height,
                            x: x,
                            y: y
                        });
                        (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "collectExistingPlaceholders",
            value: function collectExistingPlaceholders() {
                if (!window.document) return;
                try {
                    // Collect placeholders using SSR dimensions or fallback to live dimensions
                    this.collectPlaceholdersInternal();
                } catch (e) {
                // Silently fail if there are any issues
                } finally{
                    delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
                }
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return Boolean(this.getPlaceholderId(element));
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return Boolean(this.getPlaceholderReplacementId(element));
            }
        },
        {
            key: "isPlaceholderIgnored",
            value: function isPlaceholderIgnored(element) {
                // data-ssr-placeholder-ignored doesn't have a value.
                return 'ssrPlaceholderIgnored' in element.dataset;
            }
        },
        {
            key: "findNearestPlaceholderContainerIfIgnored",
            value: function findNearestPlaceholderContainerIfIgnored(element) {
                if (!this.isPlaceholderIgnored(element)) return element;
                var ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < $2c8b90ca5ceed52a$var$ANCESTOR_LOOKUP_LIMIT){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    ancestor = ancestor.parentElement;
                    i++;
                }
                return element;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this3 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                return new Promise(function(resolve) {
                    if (!_this3.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this3$intersectionOb;
                        _this3.callbacks.set(id, resolve);
                        (_this3$intersectionOb = _this3.intersectionObserver) === null || _this3$intersectionOb === void 0 || _this3$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this4 = this;
                return new Promise(function(resolve) {
                    var _this4$intersectionOb;
                    _this4.getSizeCallbacks.set(_this4.getPlaceholderId(el), resolve);
                    (_this4$intersectionOb = _this4.intersectionObserver) === null || _this4$intersectionOb === void 0 || _this4$intersectionOb.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this5 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderReplacementId(el);
                return new Promise(function(resolve) {
                    if (!_this5.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this5$intersectionOb;
                        _this5.reactValidateCallbacks.set(id, resolve);
                        (_this5$intersectionOb = _this5.intersectionObserver) === null || _this5$intersectionOb === void 0 || _this5$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                var _this$disableSizeAndP, _this$disableSizeAndP2;
                if ((_this$disableSizeAndP = this.disableSizeAndPositionCheck) !== null && _this$disableSizeAndP !== void 0 && _this$disableSizeAndP.v && (_this$disableSizeAndP2 = this.disableSizeAndPositionCheck) !== null && _this$disableSizeAndP2 !== void 0 && _this$disableSizeAndP2.h) return true;
                if (!rect) return false;
                var horizontalCheck = this.disableSizeAndPositionCheck.h ? true : Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
                var verticalCheck = this.disableSizeAndPositionCheck.v ? true : Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
                return horizontalCheck && verticalCheck || false;
            }
        },
        {
            key: "isDummyRect",
            value: function isDummyRect(rect) {
                return rect && rect.width < 0 && rect.height < 0 || false;
            }
        }
    ]);
}();

});




parcelRegister("50Vt1", function(module, exports) {

$parcel$export(module.exports, "clearActiveTrace", function () { return $3a698796593a1c06$export$17ab21d7be720b; });

var $bvUNl = parcelRequire("bvUNl");
var $3a698796593a1c06$var$state = {
    context: null
};
function $3a698796593a1c06$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
}
function $3a698796593a1c06$export$f2e521e495a88544(interactionId, experienceType) {
    $3a698796593a1c06$export$a1002be327997103(interactionId.replace(/-/g, ''), $3a698796593a1c06$export$295213bc4d0c54ad(), experienceType);
}
function $3a698796593a1c06$export$a1002be327997103(traceId, spanId, type) {
    $3a698796593a1c06$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $3a698796593a1c06$export$b6ac780db3a3cc77() {
    return $3a698796593a1c06$var$state.context || undefined;
}
function $3a698796593a1c06$export$17ab21d7be720b() {
    $3a698796593a1c06$var$state.context = null;
}
function $3a698796593a1c06$export$6e17cce6446848f9(_url) {
    if ($3a698796593a1c06$var$state.context === null) return null;
    var _state$context = $3a698796593a1c06$var$state.context, traceId = _state$context.traceId, spanId = _state$context.spanId;
    return (0, $bvUNl.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function $3a698796593a1c06$export$a1e7396778592551(_url) {
    var traceHeaders = $3a698796593a1c06$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

});
parcelRegister("bvUNl", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", function () { return $861ea5425289b3c8$export$1115c5277eb10d5e; });
function $861ea5425289b3c8$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("4OLmu", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", function () { return $382091fbffcba0fd$export$5b78c989c8db2561; });
$parcel$export(module.exports, "currentFeatureFlagsAccessed", function () { return $382091fbffcba0fd$export$2a5c8df26bb89760; });

var $3fMJP = parcelRequire("3fMJP");
var $382091fbffcba0fd$export$5b78c989c8db2561 = new Map();
var $382091fbffcba0fd$export$2a5c8df26bb89760 = new Map();
function $382091fbffcba0fd$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $3fMJP.redactValue)(featureFlagValue);
    $382091fbffcba0fd$export$5b78c989c8db2561.set(featureFlagName, value);
    $382091fbffcba0fd$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("3fMJP", function(module, exports) {

$parcel$export(module.exports, "redactValue", function () { return $25e894337744f658$export$fcc03ee4c944962f; });

var $a3ftr = parcelRequire("a3ftr");

var $gJQk9 = parcelRequire("gJQk9");
function $25e894337744f658$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
}
function $25e894337744f658$var$isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(value) === 'object' && value.constructor === Object;
}
function $25e894337744f658$var$isString(input) {
    var result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $25e894337744f658$export$7b4abba432e57989(value) {
    return $25e894337744f658$var$isString(value) && $25e894337744f658$var$startsAsObject(value) || $25e894337744f658$var$isObject(value);
}
function $25e894337744f658$export$fcc03ee4c944962f(featureFlagValue) {
    return $25e894337744f658$export$7b4abba432e57989(featureFlagValue) ? (0, $gJQk9.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("gJQk9", function(module, exports) {

$parcel$export(module.exports, "NON_BOOLEAN_VALUE", function () { return $c2f96fc544c2f2a5$export$42f4885608027d0c; });
var $c2f96fc544c2f2a5$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("cjKHH", function(module, exports) {

$parcel$export(module.exports, "getInteractionId", function () { return $8f7b7cce9d81f48f$export$37bca3107733ac1e; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");
// Same structure as react's useRef.
// This allows modals to use a ref to scope their value
// const id = useRef(null);
// <InteractionIDContext.Provider value={id}>...<
// Subscription system for interaction ID changes
var $8f7b7cce9d81f48f$var$listeners = new Set();
// Observable interaction ID implementation
var $8f7b7cce9d81f48f$var$ObservableInteractionID = /*#__PURE__*/ function() {
    function ObservableInteractionID() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ObservableInteractionID);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_current", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ObservableInteractionID, [
        {
            key: "current",
            get: function get() {
                return this._current;
            },
            set: function set(newId) {
                var oldId = this._current;
                this._current = newId;
                // Notify all listeners if the ID actually changed
                if (oldId !== newId) $8f7b7cce9d81f48f$var$listeners.forEach(function(listener) {
                    return listener(newId);
                });
            }
        }
    ]);
}(); // Type declaration for globalThis extension
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
var $8f7b7cce9d81f48f$var$initializeGlobalDefaultInteractionID = function initializeGlobalDefaultInteractionID() {
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    var instance = new $8f7b7cce9d81f48f$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
var $8f7b7cce9d81f48f$export$3109542b68df9ba1 = $8f7b7cce9d81f48f$var$initializeGlobalDefaultInteractionID();
var $8f7b7cce9d81f48f$export$3e0c3023952f6774 = function subscribeToInteractionIdChanges(listener) {
    $8f7b7cce9d81f48f$var$listeners.add(listener);
    return function() {
        $8f7b7cce9d81f48f$var$listeners.delete(listener);
    };
};
var // We use a context to allow modals to have their own lifecycle
$8f7b7cce9d81f48f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dNMDr.createContext)($8f7b7cce9d81f48f$export$3109542b68df9ba1);
var $8f7b7cce9d81f48f$export$37bca3107733ac1e = function getInteractionId() {
    return $8f7b7cce9d81f48f$export$3109542b68df9ba1;
};
var $8f7b7cce9d81f48f$export$9f6000531b78127e = function useInteractionId() {
    return $8f7b7cce9d81f48f$export$3109542b68df9ba1;
};

});

parcelRegister("2nvs7", function(module, exports) {

$parcel$export(module.exports, "VCObserverWrapper", function () { return VCObserverWrapper; });
$parcel$export(module.exports, "getVCObserver", function () { return getVCObserver; });
$parcel$export(module.exports, "newVCObserver", function () { return newVCObserver; });

var $62ppy = parcelRequire("62ppy");

var $k7uol = parcelRequire("k7uol");

var $91FVG = parcelRequire("91FVG");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $axdfd = parcelRequire("axdfd");

var $i6899 = parcelRequire("i6899");

var $73swo = parcelRequire("73swo");

var $jvA0h = parcelRequire("jvA0h");

var $gtAla = parcelRequire("gtAla");

var $8akC3 = parcelRequire("8akC3");

var $3P708 = parcelRequire("3P708");

var $4ilBr = parcelRequire("4ilBr");
var _process;
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var VCObserverWrapper = /*#__PURE__*/ function() {
    function VCObserverWrapper() {
        var _opts$ssrEnablePageLa, _opts$disableSizeAndP;
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, VCObserverWrapper);
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $3P708.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: (_opts$ssrEnablePageLa = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts$ssrEnablePageLa !== void 0 ? _opts$ssrEnablePageLa : false,
            disableSizeAndPositionCheck: (_opts$disableSizeAndP = opts.disableSizeAndPositionCheck) !== null && _opts$disableSizeAndP !== void 0 ? _opts$disableSizeAndP : {
                v: false,
                h: false
            }
        });
        if ((0, $i6899.isVCRevisionEnabled)('fy25.03')) {
            var _opts$ssrEnablePageLa2, _opts$disableSizeAndP2;
            this.newVCObserver = new (0, $gtAla.default)({
                selectorConfig: opts.selectorConfig,
                isPostInteraction: opts.isPostInteraction,
                SSRConfig: {
                    enablePageLayoutPlaceholder: (_opts$ssrEnablePageLa2 = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts$ssrEnablePageLa2 !== void 0 ? _opts$ssrEnablePageLa2 : false,
                    disableSizeAndPositionCheck: (_opts$disableSizeAndP2 = opts.disableSizeAndPositionCheck) !== null && _opts$disableSizeAndP2 !== void 0 ? _opts$disableSizeAndP2 : {
                        v: false,
                        h: false
                    }
                },
                ssrPlaceholderHandler: this.ssrPlaceholderHandler
            });
        }
        if ((0, $i6899.isVCRevisionEnabled)('fy25.01') || (0, $i6899.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $jvA0h.VCObserver)(_objectSpread(_objectSpread({}, opts), {}, {
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        }));
    }
    // Helper method to process SSR abort listeners
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(VCObserverWrapper, [
        {
            key: "processSsrAbortListeners",
            value: function processSsrAbortListeners() {
                var _window;
                // Process any SSR abort listeners that remain
                if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                    // Clean up any event listeners that may have been registered during SSR
                    // This is centralized here so only the wrapper handles unbinding, not individual observers
                    if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach(function(unbind) {
                        if (typeof unbind === 'function') unbind();
                    });
                    // After all observers had a chance to process abort events,
                    // we can safely delete the SSR_ABORT_LISTENERS object
                    delete window.__SSR_ABORT_LISTENERS__;
                }
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var startTime = _ref.startTime, experienceKey = _ref.experienceKey;
                if ((0, $i6899.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $i6899.isVCRevisionEnabled)('fy25.02', experienceKey)) {
                    var _this$oldVCObserver;
                    (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start({
                        startTime: startTime
                    });
                }
                if ((0, $i6899.isVCRevisionEnabled)('fy25.03', experienceKey)) {
                    var _this$newVCObserver;
                    (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
                        startTime: startTime
                    });
                }
                // Clean up any remaining SSR abort listeners after all observers have been started
                this.processSsrAbortListeners();
            }
        },
        {
            key: "stop",
            value: function stop(experienceKey) {
                if ((0, $i6899.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $i6899.isVCRevisionEnabled)('fy25.02', experienceKey)) {
                    var _this$oldVCObserver2;
                    (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
                }
                if ((0, $i6899.isVCRevisionEnabled)('fy25.03', experienceKey)) {
                    var _this$newVCObserver2;
                    (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
                }
                (0, $8akC3.RLLPlaceholderHandlers).getInstance().reset();
                // Clear shared SSR placeholder handler
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                var _this$oldVCObserver$g, _this$oldVCObserver3;
                return (_this$oldVCObserver$g = (_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) !== null && _this$oldVCObserver$g !== void 0 ? _this$oldVCObserver$g : null;
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(param) {
                    var _this$oldVCObserver4, _this$newVCObserver3, _ref2;
                    var experienceKey, v1v2Result, v3Result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                experienceKey = param.experienceKey;
                                if (!((0, $i6899.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $i6899.isVCRevisionEnabled)('fy25.02', experienceKey))) {
                                    _context.next = 7;
                                    break;
                                }
                                _context.next = 4;
                                return (_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param);
                            case 4:
                                _context.t0 = _context.sent;
                                _context.next = 8;
                                break;
                            case 7:
                                _context.t0 = {};
                            case 8:
                                v1v2Result = _context.t0;
                                if (!(0, $i6899.isVCRevisionEnabled)('fy25.03', experienceKey)) {
                                    _context.next = 15;
                                    break;
                                }
                                _context.next = 12;
                                return (_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
                                    start: param.start,
                                    stop: param.stop,
                                    interactionId: param.interactionId,
                                    ssr: param.includeSSRInV3 ? param.ssr : undefined
                                });
                            case 12:
                                _context.t1 = _context.sent;
                                _context.next = 16;
                                break;
                            case 15:
                                _context.t1 = [];
                            case 16:
                                v3Result = _context.t1;
                                if (v3Result) {
                                    _context.next = 19;
                                    break;
                                }
                                return _context.abrupt("return", v1v2Result !== null && v1v2Result !== void 0 ? v1v2Result : {});
                            case 19:
                                return _context.abrupt("return", _objectSpread(_objectSpread({}, v1v2Result), {}, {
                                    'ufo:vc:rev': [].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))((_ref2 = v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result['ufo:vc:rev']) !== null && _ref2 !== void 0 ? _ref2 : []), (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(v3Result !== null && v3Result !== void 0 ? v3Result : []))
                                }));
                            case 20:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                var _this$oldVCObserver5, _this$newVCObserver4;
                (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
                (_this$newVCObserver4 = this.newVCObserver) === null || _this$newVCObserver4 === void 0 || _this$newVCObserver4.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {
                var _this$oldVCObserver6, _this$newVCObserver5;
                (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
                (_this$newVCObserver5 = this.newVCObserver) === null || _this$newVCObserver5 === void 0 || _this$newVCObserver5.setReactRootRenderStart(startTime || performance.now());
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {
                var _this$oldVCObserver7, _this$newVCObserver6;
                (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
                (_this$newVCObserver6 = this.newVCObserver) === null || _this$newVCObserver6 === void 0 || _this$newVCObserver6.setReactRootRenderStop(stopTime || performance.now());
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
                this.ssrPlaceholderHandler.collectExistingPlaceholders();
            }
        }
    ]);
}();
// Some products set this variable to indicate it is running in SSR
var isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
var isReactSSR = typeof $4ilBr !== 'undefined' && Boolean(((_process = $4ilBr) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR) || false);
function isEnvironmentSupported() {
    // SSR environment aren't supported
    if (isReactSSR || isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') return false;
    return true;
}
function getVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!globalThis.__vcObserver) {
        var shouldMockVCObserver = !isEnvironmentSupported();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $73swo.VCObserverNOOP)() : new VCObserverWrapper(opts);
    }
    return globalThis.__vcObserver;
}
function newVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var shouldMockVCObserver = !isEnvironmentSupported();
    var observer = shouldMockVCObserver ? new (0, $73swo.VCObserverNOOP)() : new VCObserverWrapper(opts);
    return observer;
}

});
parcelRegister("73swo", function(module, exports) {

$parcel$export(module.exports, "VCObserverNOOP", function () { return $522eeffd5b4340fe$export$24d07287b49da906; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");
var $522eeffd5b4340fe$export$24d07287b49da906 = /*#__PURE__*/ function() {
    function VCObserverNOOP() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, VCObserverNOOP);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(VCObserverNOOP, [
        {
            key: "start",
            value: function start(startArg) {}
        },
        {
            key: "stop",
            value: function stop() {}
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                return null;
            }
        },
        {
            key: "getVCResult",
            value: function getVCResult(param) {
                return Promise.resolve({
                    'ufo:vc:noop': true
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {}
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {}
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {}
        }
    ]);
}();

});

parcelRegister("gtAla", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfeb8b38728dfc4d$export$2e2bcd8739ae039; });

var $k7uol = parcelRequire("k7uol");

var $82V4i = parcelRequire("82V4i");

var $a3ftr = parcelRequire("a3ftr");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $axdfd = parcelRequire("axdfd");

var $3P708 = parcelRequire("3P708");

var $hGMmw = parcelRequire("hGMmw");

var $46DtA = parcelRequire("46DtA");

var $k01Fd = parcelRequire("k01Fd");

var $6mFWe = parcelRequire("6mFWe");

var $4AKNU = parcelRequire("4AKNU");

var $e91D6 = parcelRequire("e91D6");

var $2XaCz = parcelRequire("2XaCz");
var $bfeb8b38728dfc4d$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var $bfeb8b38728dfc4d$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
var $bfeb8b38728dfc4d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function VCObserverNew(config) {
        var _config$isPostInterac, _config$selectorConfi, _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, VCObserverNew);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "viewportObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "windowEventObserver", null);
        // SSR related properties
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "ssrPlaceholderHandler", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "ssr", {
            state: $bfeb8b38728dfc4d$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        this.entriesTimeline = new (0, $hGMmw.default)();
        this.isPostInteraction = (_config$isPostInterac = config.isPostInteraction) !== null && _config$isPostInterac !== void 0 ? _config$isPostInterac : false;
        this.selectorConfig = (_config$selectorConfi = config.selectorConfig) !== null && _config$selectorConfi !== void 0 ? _config$selectorConfi : $bfeb8b38728dfc4d$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else {
            var _config$SSRConfig$ena, _config$SSRConfig, _config$SSRConfig$dis, _config$SSRConfig2;
            this.ssrPlaceholderHandler = new (0, $3P708.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_config$SSRConfig$ena = (_config$SSRConfig = config.SSRConfig) === null || _config$SSRConfig === void 0 ? void 0 : _config$SSRConfig.enablePageLayoutPlaceholder) !== null && _config$SSRConfig$ena !== void 0 ? _config$SSRConfig$ena : false,
                disableSizeAndPositionCheck: (_config$SSRConfig$dis = (_config$SSRConfig2 = config.SSRConfig) === null || _config$SSRConfig2 === void 0 ? void 0 : _config$SSRConfig2.disableSizeAndPositionCheck) !== null && _config$SSRConfig$dis !== void 0 ? _config$SSRConfig$dis : {
                    v: false,
                    h: false
                }
            });
        }
        this.viewportObserver = new (0, $e91D6.default)({
            onChange: function onChange(onChangeArg) {
                var time = onChangeArg.time, type = onChangeArg.type, elementRef = onChangeArg.elementRef, visible = onChangeArg.visible, rect = onChangeArg.rect, previousRect = onChangeArg.previousRect, mutationData = onChangeArg.mutationData;
                var elementName = 'unknown';
                var element = elementRef.deref();
                if (element) elementName = _this.getElementName(element);
                _this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: type,
                        elementName: elementName,
                        rect: rect,
                        previousRect: previousRect,
                        visible: visible,
                        attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
                        oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
                        newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue
                    }
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: function getSSRState() {
                return _this.getSSRState();
            },
            getSSRPlaceholderHandler: function getSSRPlaceholderHandler() {
                return _this.getSSRPlaceholderHandler();
            }
        });
        this.windowEventObserver = new (0, $2XaCz.default)({
            onEvent: function onEvent(_ref) {
                var time = _ref.time, type = _ref.type;
                _this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type
                    }
                });
            }
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(VCObserverNew, [
        {
            key: "start",
            value: function start(_ref2) {
                var _this$viewportObserve, _window, _this2 = this, _this$windowEventObse;
                var startTime = _ref2.startTime;
                // Reset SSR state on start (matches old VCObserver behavior)
                this.ssr = {
                    state: $bfeb8b38728dfc4d$var$SSRState.normal,
                    reactRootElement: null,
                    // Reset to null (matches old VCObserver)
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
                if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                    var abortListeners = window.__SSR_ABORT_LISTENERS__;
                    var aborts = abortListeners.aborts;
                    if (aborts && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(aborts) === 'object') Object.entries(aborts).forEach(function(_ref3) {
                        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref3, 2), key = _ref4[0], time = _ref4[1];
                        if (typeof time === 'number') _this2.entriesTimeline.push({
                            time: time,
                            data: {
                                type: 'window:event',
                                eventType: key
                            }
                        });
                    });
                }
                (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
                this.entriesTimeline.clear();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$viewportObserve2, _this$windowEventObse2;
                (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
                (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.stop();
                // Clear SSR state on stop (matches old VCObserver behavior)
                this.ssr.reactRootElement = null;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $bfeb8b38728dfc4d$var$SSRState.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "getSSRState",
            value: function getSSRState() {
                return this.ssr;
            }
        },
        {
            key: "getSSRPlaceholderHandler",
            value: function getSSRPlaceholderHandler() {
                return this.ssrPlaceholderHandler;
            }
        },
        {
            key: "addSSR",
            value: function addSSR(ssr) {
                this.entriesTimeline.push({
                    time: ssr,
                    data: {
                        elementName: 'SSR',
                        type: 'mutation:element',
                        rect: {
                            height: (0, $6mFWe.default)(),
                            width: (0, $4AKNU.default)(),
                            left: 0,
                            top: 0,
                            x: 0,
                            y: 0,
                            bottom: (0, $6mFWe.default)(),
                            right: (0, $4AKNU.default)(),
                            toJSON: function toJSON() {
                                return null;
                            }
                        },
                        visible: true
                    }
                });
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(param) {
                    var start, stop, interactionId, results, calculator_fy25_03, orderedEntries, fy25_03;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                start = param.start, stop = param.stop, interactionId = param.interactionId;
                                results = [];
                                this.addStartEntry(start);
                                calculator_fy25_03 = new (0, $k01Fd.default)();
                                if (param.ssr) this.addSSR(param.ssr);
                                orderedEntries = this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: stop
                                });
                                _context.next = 8;
                                return calculator_fy25_03.calculate({
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    interactionId: interactionId,
                                    isPostInteraction: this.isPostInteraction
                                });
                            case 8:
                                fy25_03 = _context.sent;
                                if (fy25_03) results.push(fy25_03);
                                return _context.abrupt("return", results);
                            case 11:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "addStartEntry",
            value: function addStartEntry(startTime) {
                this.entriesTimeline.push({
                    time: startTime,
                    data: {
                        type: 'mutation:element',
                        elementName: 'START',
                        visible: true,
                        rect: {
                            x: 0,
                            y: 0,
                            width: window.innerWidth,
                            height: window.innerHeight,
                            top: 0,
                            left: 0,
                            bottom: window.innerHeight,
                            right: window.innerWidth,
                            toJSON: function toJSON() {
                                return {
                                    x: this.x,
                                    y: this.y,
                                    width: this.width,
                                    height: this.height,
                                    top: this.top,
                                    left: this.left,
                                    bottom: this.bottom,
                                    right: this.right
                                };
                            }
                        }
                    }
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                return (0, $46DtA.default)(this.selectorConfig, element);
            }
        }
    ]);
}();

});
parcelRegister("hGMmw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce0bdfa87ab13f5e$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");
var $ce0bdfa87ab13f5e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function EntriesTimeline() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, EntriesTimeline);
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(EntriesTimeline, [
        {
            key: "push",
            value: function push(entry) {
                this.unorderedEntries.push(entry);
                this.sortedEntriesCache.clear();
            }
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(start, stop) {
                return "".concat(start !== null && start !== void 0 ? start : 'null', "_").concat(stop !== null && stop !== void 0 ? stop : 'null');
            }
        },
        {
            key: "getOrderedEntries",
            value: function getOrderedEntries(_ref) {
                var _this$sortedEntriesCa;
                var start = _ref.start, stop = _ref.stop;
                var cacheKey = this.getCacheKey(start, stop);
                var cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
                if (cachedSortedEntries) return cachedSortedEntries;
                var filteredEntries = this.unorderedEntries.filter(function(e) {
                    return e.time >= (start !== null && start !== void 0 ? start : 0) && e.time <= (stop !== null && stop !== void 0 ? stop : performance.now());
                });
                var sortedEntries = filteredEntries.sort(function(a, b) {
                    return a.time - b.time;
                });
                this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
                return sortedEntries;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.unorderedEntries = [];
                this.sortedEntriesCache.clear();
            }
        }
    ]);
}();

});

parcelRegister("46DtA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fd6582322518301$export$2e2bcd8739ae039; });
var $2fd6582322518301$var$nameCache = new WeakMap();
function $2fd6582322518301$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    var cachedName = $2fd6582322518301$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    var tagName = element.localName;
    var encodeValue = function encodeValue(s) {
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    var getAttributeSelector = function getAttributeSelector(attributeName) {
        var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (element && typeof element.getAttribute !== 'function') return '';
        var attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        var encondedAttrValue = encodeValue(attrValue);
        return "".concat(prefix, "[").concat(attributeName, "=\"").concat(encondedAttrValue, "\"]");
    };
    // Construct the data-vc attribute selector if specified in the config.
    var dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    var id = selectorConfig.id && element.id ? "#".concat(encodeValue(element.id)) : '';
    // Construct the test ID selector if specified in the config.
    var testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    var role = selectorConfig.role ? getAttributeSelector('role') : '';
    var classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    var classList = selectorConfig.className && classNames ? ".".concat(classNames) : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    var primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    var attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        var parentName = element.parentElement ? $2fd6582322518301$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return "".concat(parentName, " > ").concat(tagName);
    }
    // Return the final constructed name: tagName + attributes or classList.
    var name = "".concat(tagName).concat(attributes || classList);
    $2fd6582322518301$var$nameCache.set(element, name);
    return name;
}
var $2fd6582322518301$export$2e2bcd8739ae039 = $2fd6582322518301$var$getElementName;

});

parcelRegister("k01Fd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8f519200af7cba4$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $enV8I = parcelRequire("enV8I");

var $gQLDR = parcelRequire("gQLDR");

var $eBw6c = parcelRequire("eBw6c");

var $cUobC = parcelRequire("cUobC");
function $e8f519200af7cba4$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $e8f519200af7cba4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $e8f519200af7cba4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e8f519200af7cba4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $e8f519200af7cba4$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var $e8f519200af7cba4$var$REVISION_NO = 'fy25.03';
var $e8f519200af7cba4$var$getConsideredEntryTypes = function getConsideredEntryTypes() {
    var entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'window:event'
    ];
    // If not exclude 3p elements from ttvc,
    // including the tags into the ConsideredEntryTypes so that it won't be ignored for TTVC calculation
    if (!(0, $gQLDR.fg)('platform_ufo_exclude_3p_elements_from_ttvc')) entryTypes.push('mutation:third-party-element');
    if ((0, $gQLDR.fg)('platform_ufo_enable_media_for_ttvc_v3')) entryTypes.push('mutation:media');
    return entryTypes;
};
var $e8f519200af7cba4$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable'
];
var $e8f519200af7cba4$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
var $e8f519200af7cba4$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractVCCalculator) {
    function VCCalculator_FY25_03() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, VCCalculator_FY25_03);
        return $e8f519200af7cba4$var$_callSuper(this, VCCalculator_FY25_03, [
            $e8f519200af7cba4$var$REVISION_NO
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(VCCalculator_FY25_03, _AbstractVCCalculator);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(VCCalculator_FY25_03, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry) {
                if (!$e8f519200af7cba4$var$getConsideredEntryTypes().includes(entry.data.type)) return false;
                if (entry.data.type === 'mutation:attribute') {
                    var entryData = entry.data;
                    var attributeName = entryData.attributeName;
                    if (!attributeName || $e8f519200af7cba4$export$98812f4e79596e2b.includes(attributeName)) return false;
                    if (attributeName.startsWith('data-test') && (0, $gQLDR.fg)('platform_ufo_ttvc_exclude_data_test_attribute') || attributeName === 'data-aui-version' || attributeName === 'data-testid' || attributeName === 'data-vc' || attributeName === 'data-ssr-placeholder' || attributeName === 'data-ssr-placeholder-replace' || attributeName === 'data-vc-nvs' || attributeName === 'data-media-vc-wrapper' || (attributeName === 'data-renderer-start-pos' || attributeName === 'data-table-local-id' || attributeName === 'spellcheck') && (0, $gQLDR.fg)('platform_ufo_ignore_extra_attributes') || attributeName === 'data-auto-scrollable' || attributeName === 'id' || attributeName === 'tabindex' || $e8f519200af7cba4$export$44331555a87fcd9e.includes(attributeName)) return false;
                    return true;
                }
                if ((0, $cUobC.default)(entry.data) && !entry.data.visible) return false;
                return true;
            }
        },
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        if ($e8f519200af7cba4$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) {
                            dirtyReason = data.eventType === 'keydown' ? 'keypress' : data.eventType;
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason
                };
                return {
                    isVCClean: true
                };
            }
        }
    ]);
}((0, $eBw6c.default));

});
parcelRegister("eBw6c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa1d6b97a9ea16ff$export$2e2bcd8739ae039; });

var $62ppy = parcelRequire("62ppy");

var $91FVG = parcelRequire("91FVG");

var $k7uol = parcelRequire("k7uol");

var $82V4i = parcelRequire("82V4i");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $axdfd = parcelRequire("axdfd");

var $gQLDR = parcelRequire("gQLDR");

var $huYU4 = parcelRequire("huYU4");

var $6mFWe = parcelRequire("6mFWe");

var $4AKNU = parcelRequire("4AKNU");
function $aa1d6b97a9ea16ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aa1d6b97a9ea16ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aa1d6b97a9ea16ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aa1d6b97a9ea16ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $aa1d6b97a9ea16ff$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $aa1d6b97a9ea16ff$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $aa1d6b97a9ea16ff$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $aa1d6b97a9ea16ff$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $aa1d6b97a9ea16ff$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $aa1d6b97a9ea16ff$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Create comprehensive debug details including ignored entries
var $aa1d6b97a9ea16ff$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AbstractVCCalculatorBase(revisionNo) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, AbstractVCCalculatorBase);
        this.revisionNo = revisionNo;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(AbstractVCCalculatorBase, [
        {
            key: "filterViewportEntries",
            value: function filterViewportEntries(entries) {
                return entries.filter(function(entry) {
                    return 'rect' in entry.data;
                });
            }
        },
        {
            key: "calculateRatios",
            value: function calculateRatios(filteredEntries) {
                var ratios = {};
                var viewportWidth = (0, $4AKNU.default)();
                var viewportHeight = (0, $6mFWe.default)();
                var totalViewportArea = viewportWidth * viewportHeight;
                if (totalViewportArea === 0) return ratios;
                var elementRects = new Map();
                var _iterator = $aa1d6b97a9ea16ff$var$_createForOfIteratorHelper(filteredEntries), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _entry = _step.value;
                        if ('rect' in _entry.data) {
                            var viewportEntry = _entry.data;
                            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                var _iterator2 = $aa1d6b97a9ea16ff$var$_createForOfIteratorHelper(elementRects), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var _step2$value = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_step2.value, 2), elementName = _step2$value[0], rect = _step2$value[1];
                        var elementArea = rect.width * rect.height;
                        ratios[elementName] = elementArea / totalViewportArea;
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return ratios;
            }
        },
        {
            key: "calculateWithDebugInfo",
            value: function() {
                var _calculateWithDebugInfo = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionId, dirtyReason, allEntries) {
                    var _window, _window2, _window3, _window5;
                    var percentiles, viewportEntries, vcLogs, vcDetails, percentileIndex, entryDataBuffer, _iterator3, _step3, _entry2, time, viewportPercentage, entries, elementNames, previousResult, i, percentile, enhancedVcLogs, shouldCalculateDebugDetails, sortedVcLogs, maxViewportPercentageAtTime, maxSoFar, _iterator4, _step4, log, getBiggestPreviousViewportPercentage, ignoredEntriesByTime, _iterator5, _step5, _entry3, _ignoredEntriesByTime, viewportData, timestamp, additionalVcLogs, _iterator6, _step6, _step6$value, _timestamp, ignoredEntries, _viewportPercentage, v3RevisionDebugDetails, _window4, _window4$__ufo_devtoo, _window6, _window6$__on_ufo_vc_;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                percentiles = [
                                    25,
                                    50,
                                    75,
                                    80,
                                    85,
                                    90,
                                    95,
                                    98,
                                    99
                                ];
                                viewportEntries = this.filterViewportEntries(filteredEntries);
                                _context.next = 4;
                                return (0, $huYU4.calculateTTVCPercentilesWithDebugInfo)({
                                    viewport: {
                                        width: (0, $4AKNU.default)(),
                                        height: (0, $6mFWe.default)()
                                    },
                                    startTime: startTime,
                                    stopTime: stopTime,
                                    orderedEntries: viewportEntries
                                });
                            case 4:
                                vcLogs = _context.sent;
                                vcDetails = {};
                                percentileIndex = 0;
                                entryDataBuffer = new Set();
                                if (!vcLogs) {
                                    _context.next = 28;
                                    break;
                                }
                                _iterator3 = $aa1d6b97a9ea16ff$var$_createForOfIteratorHelper(vcLogs);
                                _context.prev = 10;
                                _iterator3.s();
                            case 12:
                                if ((_step3 = _iterator3.n()).done) {
                                    _context.next = 20;
                                    break;
                                }
                                _entry2 = _step3.value;
                                time = _entry2.time, viewportPercentage = _entry2.viewportPercentage, entries = _entry2.entries; // Only process entries if we haven't reached all percentiles
                                if (!(percentileIndex >= percentiles.length)) {
                                    _context.next = 17;
                                    break;
                                }
                                return _context.abrupt("break", 20);
                            case 17:
                                // Check if this entry matches any checkpoint percentiles
                                if (viewportPercentage >= percentiles[percentileIndex]) {
                                    elementNames = entries.map(function(e) {
                                        return e.elementName;
                                    }); // Process all matching percentiles in one go
                                    while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                                        vcDetails["".concat(percentiles[percentileIndex])] = {
                                            t: Math.round(time),
                                            e: elementNames
                                        };
                                        percentileIndex++;
                                    }
                                    // Clear buffer after processing all matching percentiles
                                    entryDataBuffer.clear();
                                } else // Only add to buffer if we haven't reached all percentiles
                                entries.forEach(function(e) {
                                    return entryDataBuffer.add(e);
                                });
                            case 18:
                                _context.next = 12;
                                break;
                            case 20:
                                _context.next = 25;
                                break;
                            case 22:
                                _context.prev = 22;
                                _context.t0 = _context["catch"](10);
                                _iterator3.e(_context.t0);
                            case 25:
                                _context.prev = 25;
                                _iterator3.f();
                                return _context.finish(25);
                            case 28:
                                // Fill in any missing percentiles with the last known values
                                previousResult = {
                                    t: 0,
                                    e: []
                                };
                                for(i = 0; i < percentiles.length; i++){
                                    percentile = percentiles[i];
                                    if (!(percentile in vcDetails)) vcDetails["".concat(percentile)] = previousResult;
                                    else previousResult = vcDetails["".concat(percentile)];
                                }
                                enhancedVcLogs = vcLogs ? vcLogs.map(function(log) {
                                    return $aa1d6b97a9ea16ff$var$_objectSpread($aa1d6b97a9ea16ff$var$_objectSpread({}, log), {}, {
                                        viewportPercentage: log.viewportPercentage
                                    });
                                }) : []; // Only calculate enhanced debug details if devtool callbacks exist
                                shouldCalculateDebugDetails = !isPostInteraction && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__on_ufo_vc_debug_data_ready) === 'function' && (0, $gQLDR.fg)('platform_ufo_emit_vc_debug_data'));
                                if (shouldCalculateDebugDetails && allEntries && vcLogs) {
                                    // Pre-sort vcLogs by time for efficient lookups
                                    sortedVcLogs = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(vcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    }); // Pre-calculate max viewport percentage up to each time for efficient lookups
                                    maxViewportPercentageAtTime = new Map();
                                    maxSoFar = 0;
                                    _iterator4 = $aa1d6b97a9ea16ff$var$_createForOfIteratorHelper(sortedVcLogs);
                                    try {
                                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                            log = _step4.value;
                                            if (log.viewportPercentage !== null) {
                                                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                                                maxViewportPercentageAtTime.set(log.time, maxSoFar);
                                            }
                                        }
                                    // Helper function to find the biggest previous viewport percentage
                                    } catch (err) {
                                        _iterator4.e(err);
                                    } finally{
                                        _iterator4.f();
                                    }
                                    getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
                                        // Binary search for the largest time <= targetTime
                                        var left = 0;
                                        var right = sortedVcLogs.length - 1;
                                        var result = -1;
                                        while(left <= right){
                                            var mid = Math.floor((left + right) / 2);
                                            if (sortedVcLogs[mid].time <= targetTime) {
                                                result = mid;
                                                left = mid + 1;
                                            } else right = mid - 1;
                                        }
                                        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
                                    }; // Group ignored entries by timestamp
                                    ignoredEntriesByTime = new Map();
                                    _iterator5 = $aa1d6b97a9ea16ff$var$_createForOfIteratorHelper(allEntries);
                                    try {
                                        for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                            _entry3 = _step5.value;
                                            if ('rect' in _entry3.data && !this.isEntryIncluded(_entry3)) {
                                                viewportData = _entry3.data;
                                                timestamp = Math.round(_entry3.time);
                                                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                                                (_ignoredEntriesByTime = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime === void 0 || _ignoredEntriesByTime.push($aa1d6b97a9ea16ff$var$_objectSpread($aa1d6b97a9ea16ff$var$_objectSpread({}, viewportData), {}, {
                                                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                                                }));
                                            }
                                        }
                                    // Add ignored entries to vcLogs
                                    } catch (err) {
                                        _iterator5.e(err);
                                    } finally{
                                        _iterator5.f();
                                    }
                                    additionalVcLogs = [];
                                    _iterator6 = $aa1d6b97a9ea16ff$var$_createForOfIteratorHelper(ignoredEntriesByTime);
                                    try {
                                        for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                            _step6$value = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_step6.value, 2), _timestamp = _step6$value[0], ignoredEntries = _step6$value[1];
                                            if (ignoredEntries.length > 0) {
                                                _viewportPercentage = getBiggestPreviousViewportPercentage(_timestamp);
                                                additionalVcLogs.push({
                                                    time: _timestamp,
                                                    viewportPercentage: _viewportPercentage,
                                                    entries: ignoredEntries
                                                });
                                            }
                                        }
                                    // Combine and sort all vcLogs
                                    } catch (err) {
                                        _iterator6.e(err);
                                    } finally{
                                        _iterator6.f();
                                    }
                                    enhancedVcLogs = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(enhancedVcLogs), additionalVcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    });
                                }
                                // Only create debug details if callbacks exist
                                v3RevisionDebugDetails = null;
                                if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
                                    revision: this.revisionNo,
                                    isClean: isVCClean,
                                    abortReason: dirtyReason,
                                    vcLogs: enhancedVcLogs,
                                    interactionId: interactionId
                                };
                                // Handle devtool callback
                                if (v3RevisionDebugDetails && typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_onVCRevisionReady__) === 'function') try {
                                    (_window4 = window) === null || _window4 === void 0 || (_window4$__ufo_devtoo = _window4.__ufo_devtool_onVCRevisionReady__) === null || _window4$__ufo_devtoo === void 0 || _window4$__ufo_devtoo.call(_window4, v3RevisionDebugDetails);
                                } catch (e) {
                                    // if any error communicating with devtool, we don't want to break the app
                                    // eslint-disable-next-line no-console
                                    console.error('Error in onVCRevisionReady', e);
                                }
                                if (v3RevisionDebugDetails && typeof ((_window5 = window) === null || _window5 === void 0 ? void 0 : _window5.__on_ufo_vc_debug_data_ready) === 'function' && (0, $gQLDR.fg)('platform_ufo_emit_vc_debug_data')) try {
                                    (_window6 = window) === null || _window6 === void 0 || (_window6$__on_ufo_vc_ = _window6.__on_ufo_vc_debug_data_ready) === null || _window6$__on_ufo_vc_ === void 0 || _window6$__on_ufo_vc_.call(_window6, v3RevisionDebugDetails);
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error('Error in onVCRevisionReady', e);
                                }
                                return _context.abrupt("return", vcDetails);
                            case 38:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            10,
                            22,
                            25,
                            28
                        ]
                    ]);
                }));
                function calculateWithDebugInfo(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
                    return _calculateWithDebugInfo.apply(this, arguments);
                }
                return calculateWithDebugInfo;
            }()
        },
        {
            key: "calculate",
            value: function() {
                var _calculate = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(_ref) {
                    var _this = this, _vcDetails$90$t, _vcDetails$;
                    var startTime, stopTime, orderedEntries, interactionId, isPostInteraction, filteredEntries, isVCClean, dirtyReason, getVCCleanStatusResult, vcDetails, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                startTime = _ref.startTime, stopTime = _ref.stopTime, orderedEntries = _ref.orderedEntries, interactionId = _ref.interactionId, isPostInteraction = _ref.isPostInteraction;
                                filteredEntries = orderedEntries.filter(function(entry) {
                                    return _this.isEntryIncluded(entry);
                                });
                                getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
                                isVCClean = getVCCleanStatusResult.isVCClean;
                                dirtyReason = getVCCleanStatusResult.dirtyReason;
                                if (isVCClean) {
                                    _context2.next = 7;
                                    break;
                                }
                                return _context2.abrupt("return", {
                                    revision: this.revisionNo,
                                    'metric:vc90': null,
                                    clean: false,
                                    abortReason: dirtyReason
                                });
                            case 7:
                                _context2.next = 9;
                                return this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionId, dirtyReason, orderedEntries);
                            case 9:
                                vcDetails = _context2.sent;
                                result = {
                                    revision: this.revisionNo,
                                    clean: true,
                                    'metric:vc90': (_vcDetails$90$t = vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) !== null && _vcDetails$90$t !== void 0 ? _vcDetails$90$t : null,
                                    vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined
                                };
                                if ((0, $gQLDR.fg)('platform_ufo_rev_ratios')) result.ratios = this.calculateRatios(filteredEntries);
                                return _context2.abrupt("return", result);
                            case 13:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function calculate(_x9) {
                    return _calculate.apply(this, arguments);
                }
                return calculate;
            }()
        }
    ]);
}();

});
parcelRegister("huYU4", function(module, exports) {

$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", function () { return $cbd47b298076de9a$export$96ea73435089b05a; });

var $82V4i = parcelRequire("82V4i");

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");

var $gQLDR = parcelRequire("gQLDR");

var $ay416 = parcelRequire("ay416");
function $cbd47b298076de9a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $cbd47b298076de9a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $cbd47b298076de9a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cbd47b298076de9a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cbd47b298076de9a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $cbd47b298076de9a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $cbd47b298076de9a$var$calculateTTVCPercentiles(_x) {
    return $cbd47b298076de9a$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $cbd47b298076de9a$var$_calculateTTVCPercentiles() {
    $cbd47b298076de9a$var$_calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(_ref) {
        var viewport, orderedEntries, percentiles, startTime, canvas, elementMap, _iterator2, _step2, entry, rect, elementName, timePixelCounts, canvasDimenstions, totalPixels;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    viewport = _ref.viewport, orderedEntries = _ref.orderedEntries, percentiles = _ref.percentiles, startTime = _ref.startTime;
                    canvas = new (0, $ay416.ViewportCanvas)(viewport, (0, $gQLDR.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator2 = $cbd47b298076de9a$var$_createForOfIteratorHelper(orderedEntries);
                    _context.prev = 4;
                    _iterator2.s();
                case 6:
                    if ((_step2 = _iterator2.n()).done) {
                        _context.next = 17;
                        break;
                    }
                    entry = _step2.value;
                    if ('rect' in entry.data) {
                        _context.next = 10;
                        break;
                    }
                    return _context.abrupt("continue", 15);
                case 10:
                    rect = entry.data.rect;
                    elementName = entry.data.elementName;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
                    elementMap.get(entry.time).add(elementName);
                case 15:
                    _context.next = 6;
                    break;
                case 17:
                    _context.next = 22;
                    break;
                case 19:
                    _context.prev = 19;
                    _context.t0 = _context["catch"](4);
                    _iterator2.e(_context.t0);
                case 22:
                    _context.prev = 22;
                    _iterator2.f();
                    return _context.finish(22);
                case 25:
                    _context.next = 27;
                    return canvas.getPixelCounts();
                case 27:
                    timePixelCounts = _context.sent;
                    canvasDimenstions = canvas.getScaledDimensions();
                    totalPixels = canvasDimenstions.width * canvasDimenstions.height;
                    return _context.abrupt("return", $cbd47b298076de9a$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime));
                case 31:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                19,
                22,
                25
            ]
        ]);
    }));
    return $cbd47b298076de9a$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $cbd47b298076de9a$export$96ea73435089b05a(_x2) {
    return $cbd47b298076de9a$var$_calculateTTVCPercentilesWithDebugInfo.apply(this, arguments);
}
function $cbd47b298076de9a$var$_calculateTTVCPercentilesWithDebugInfo() {
    $cbd47b298076de9a$var$_calculateTTVCPercentilesWithDebugInfo = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(_ref2) {
        var viewport, orderedEntries, startTime, canvas, elementMap, _iterator3, _step3, entry, rect, timePixelCounts, canvasDimensions, totalPixels;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    viewport = _ref2.viewport, orderedEntries = _ref2.orderedEntries, startTime = _ref2.startTime;
                    canvas = new (0, $ay416.ViewportCanvas)(viewport, (0, $gQLDR.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator3 = $cbd47b298076de9a$var$_createForOfIteratorHelper(orderedEntries);
                    _context2.prev = 4;
                    _iterator3.s();
                case 6:
                    if ((_step3 = _iterator3.n()).done) {
                        _context2.next = 16;
                        break;
                    }
                    entry = _step3.value;
                    if ('rect' in entry.data) {
                        _context2.next = 10;
                        break;
                    }
                    return _context2.abrupt("continue", 14);
                case 10:
                    rect = entry.data.rect;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
                    elementMap.get(entry.time).push(entry.data);
                case 14:
                    _context2.next = 6;
                    break;
                case 16:
                    _context2.next = 21;
                    break;
                case 18:
                    _context2.prev = 18;
                    _context2.t0 = _context2["catch"](4);
                    _iterator3.e(_context2.t0);
                case 21:
                    _context2.prev = 21;
                    _iterator3.f();
                    return _context2.finish(21);
                case 24:
                    _context2.next = 26;
                    return canvas.getPixelCounts();
                case 26:
                    timePixelCounts = _context2.sent;
                    canvasDimensions = canvas.getScaledDimensions();
                    totalPixels = canvasDimensions.width * canvasDimensions.height;
                    return _context2.abrupt("return", $cbd47b298076de9a$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime));
                case 30:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                4,
                18,
                21,
                24
            ]
        ]);
    }));
    return $cbd47b298076de9a$var$_calculateTTVCPercentilesWithDebugInfo.apply(this, arguments);
}
var $cbd47b298076de9a$export$2e2bcd8739ae039 = $cbd47b298076de9a$var$calculateTTVCPercentiles;
function $cbd47b298076de9a$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    var results = {};
    var cumulativePixels = 0;
    var percentiles = unorderedPercentiles.sort(function(a, b) {
        return a - b;
    });
    // Sort entries by timestamp for consistent processing
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref3, _ref4) {
        var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref3, 1), timeA = _ref5[0];
        var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref4, 1), timeB = _ref6[0];
        return Number(timeA) - Number(timeB);
    });
    var percentileIndex = 0;
    var domElementsBuffer = new Set();
    var _iterator = $cbd47b298076de9a$var$_createForOfIteratorHelper(sortedEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_step.value, 2), time = _step$value[0], pixelCount = _step$value[1];
            cumulativePixels += pixelCount;
            var percentCovered = cumulativePixels / totalPixels * 100;
            var elementNames = elementMap.get(time) || new Set();
            elementNames.forEach(function(elName) {
                return domElementsBuffer.add(elName);
            });
            var matchesAnyCheckpoints = false;
            while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
                results["".concat(percentiles[percentileIndex])] = {
                    t: Math.round(Number(time - startTime)),
                    e: Array.from(domElementsBuffer)
                };
                percentileIndex++;
                matchesAnyCheckpoints = true;
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (percentileIndex >= percentiles.length) break;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var previousResult = {
        t: 0,
        e: []
    };
    for(var i = 0; i < percentiles.length; i++){
        var percentile = percentiles[i];
        if (!(percentile in results)) results["".concat(percentile)] = previousResult;
        previousResult = results["".concat(percentile)];
    }
    return results;
}
function $cbd47b298076de9a$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    var results = new Array(elementMap.size);
    var cumulativePixels = 0;
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref7, _ref8) {
        var _ref9 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref7, 1), timeA = _ref9[0];
        var _ref0 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref8, 1), timeB = _ref0[0];
        return Number(timeA) - Number(timeB);
    });
    for(var i = 0; i < sortedEntries.length; i++){
        var _sortedEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(sortedEntries[i], 2), time = _sortedEntries$i[0], pixelCount = _sortedEntries$i[1];
        cumulativePixels += pixelCount;
        var percentCovered = cumulativePixels / totalPixels * 100;
        var entryDatas = elementMap.get(time) || [];
        results[i] = {
            time: Math.round(Number(time - startTime)),
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
    }
    return results;
}

});
parcelRegister("ay416", function(module, exports) {

$parcel$export(module.exports, "ViewportCanvas", function () { return $7ae031fece7b7c62$export$3e59ac9de7402fb1; });

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $axdfd = parcelRequire("axdfd");

var $9MZbf = parcelRequire("9MZbf");
var $7ae031fece7b7c62$export$3e59ac9de7402fb1 = /*#__PURE__*/ function() {
    /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ /** The 2D rendering context of the canvas */ /** Scale factor applied to the canvas (affects final pixel counts) */ /** Maps unique colors to their corresponding timestamps */ /** Counter used to generate unique colors */ /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ function ViewportCanvas(viewport) {
        var scaleFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ViewportCanvas);
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        var safeViewportWidth = Math.max(viewport.width, 1);
        var safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        var ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ViewportCanvas, [
        {
            key: "createCanvas",
            value: function createCanvas(width, height) {
                if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                return canvas;
            }
        },
        {
            key: "getScaledDimensions",
            value: function getScaledDimensions() {
                return {
                    width: this.scaledWidth,
                    height: this.scaledHeight
                };
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
        },
        {
            key: "generateColor",
            value: function generateColor() {
                // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
                var rgbColor = this.colorCounter++ % 0x00ffffff;
                return $7ae031fece7b7c62$export$54591583ed0b20ce(rgbColor);
            }
        },
        {
            key: "drawRect",
            value: function drawRect(rect, timestamp) {
                var color = this.generateColor();
                this.colorTimeMap.set(color, timestamp);
                this.ctx.fillStyle = color;
                if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
            }
        },
        {
            key: "getPixelCounts",
            value: function() {
                var _getPixelCounts = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee() {
                    var imageData, timestampsAmount, pixelCounts, timePixelCounts, i, count, color, rgbColor, timestamp;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
                                timestampsAmount = this.colorTimeMap.size;
                                _context.next = 4;
                                return $7ae031fece7b7c62$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
                            case 4:
                                pixelCounts = _context.sent;
                                // Convert color counts to timestamp counts
                                timePixelCounts = new Map();
                                i = 0;
                            case 7:
                                if (!(i < pixelCounts.length)) {
                                    _context.next = 18;
                                    break;
                                }
                                count = pixelCounts[i];
                                if (!(typeof count !== 'number')) {
                                    _context.next = 11;
                                    break;
                                }
                                return _context.abrupt("continue", 15);
                            case 11:
                                color = i + 1;
                                rgbColor = $7ae031fece7b7c62$export$54591583ed0b20ce(color);
                                timestamp = this.colorTimeMap.get(rgbColor);
                                if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
                            case 15:
                                i++;
                                _context.next = 7;
                                break;
                            case 18:
                                return _context.abrupt("return", timePixelCounts);
                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getPixelCounts() {
                    return _getPixelCounts.apply(this, arguments);
                }
                return getPixelCounts;
            }()
        }
    ]);
}();
function $7ae031fece7b7c62$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    var blue = n & 0xff;
    // Extract green component (bits 8-15)
    var green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    var red = n >> 16 & 0xff;
    return "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
}
function $7ae031fece7b7c62$export$fafc9be44839f9c8(_x, _x2, _x3) {
    return $7ae031fece7b7c62$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}
function $7ae031fece7b7c62$var$_calculateDrawnPixelsRaw() {
    $7ae031fece7b7c62$var$_calculateDrawnPixelsRaw = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(imageData, scaleFactor, arraySize) {
        var data, arr, i, color, colorIndex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    data = imageData.data;
                    arr = new Uint32Array(arraySize);
                    i = 0;
                case 3:
                    if (!(i < data.length)) {
                        _context2.next = 11;
                        break;
                    }
                    // Check alpha
                    if (data[i + 3] !== 0) {
                        // Combine RGB components into a single 24-bit color value:
                        // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
                        // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
                        // data[i + 2]       - Blue component stays as is         (bits 0-7)
                        // The | operator combines all bits together
                        color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        colorIndex = color - 1;
                        arr[colorIndex] = (arr[colorIndex] || 0) + 1;
                    }
                    if (!(i % 10000 === 0)) {
                        _context2.next = 8;
                        break;
                    }
                    _context2.next = 8;
                    return (0, $9MZbf.default)();
                case 8:
                    i += 4;
                    _context2.next = 3;
                    break;
                case 11:
                    return _context2.abrupt("return", arr);
                case 12:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $7ae031fece7b7c62$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}

});
parcelRegister("9MZbf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72080de6660e1ac8$export$2e2bcd8739ae039; });

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
function $72080de6660e1ac8$var$taskYield() {
    return $72080de6660e1ac8$var$_taskYield.apply(this, arguments);
}
function $72080de6660e1ac8$var$_taskYield() {
    $72080de6660e1ac8$var$_taskYield = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee() {
        var resolve, p;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!('scheduler' in globalThis && // @ts-ignore
                    'yield' in globalThis.scheduler)) {
                        _context.next = 4;
                        break;
                    }
                    _context.next = 3;
                    return scheduler.yield();
                case 3:
                    return _context.abrupt("return");
                case 4:
                    resolve = function resolve() {};
                    p = new Promise(function(a) {
                        resolve = a;
                    });
                    setTimeout(resolve, 0);
                    _context.next = 9;
                    return p;
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $72080de6660e1ac8$var$_taskYield.apply(this, arguments);
}
var $72080de6660e1ac8$export$2e2bcd8739ae039 = $72080de6660e1ac8$var$taskYield;

});



parcelRegister("6mFWe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a2554343fd036d4$export$2e2bcd8739ae039; });
function $4a2554343fd036d4$var$getViewportHeight() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $4a2554343fd036d4$export$2e2bcd8739ae039 = $4a2554343fd036d4$var$getViewportHeight;

});

parcelRegister("4AKNU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $357ed484f97daaec$export$2e2bcd8739ae039; });
function $357ed484f97daaec$var$getViewportWidth() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $357ed484f97daaec$export$2e2bcd8739ae039 = $357ed484f97daaec$var$getViewportWidth;

});


parcelRegister("cUobC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $965d79e7173871f6$export$2e2bcd8739ae039; });
function $965d79e7173871f6$var$isViewportEntryData(data) {
    if (data) {
        var hasElementName = typeof data.elementName === 'string';
        var hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $965d79e7173871f6$export$2e2bcd8739ae039 = $965d79e7173871f6$var$isViewportEntryData;

});


parcelRegister("e91D6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4c32b9958b6e33c$export$2e2bcd8739ae039; });

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $axdfd = parcelRequire("axdfd");

var $gQLDR = parcelRequire("gQLDR");

var $63mGt = parcelRequire("63mGt");

var $4T0v1 = parcelRequire("4T0v1");

var $8akC3 = parcelRequire("8akC3");

var $5taqr = parcelRequire("5taqr");

var $6vg2J = parcelRequire("6vg2J");

var $43qpp = parcelRequire("43qpp");

var $14F5Y = parcelRequire("14F5Y");

var $ihvsG = parcelRequire("ihvsG");
function $a4c32b9958b6e33c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a4c32b9958b6e33c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a4c32b9958b6e33c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a4c32b9958b6e33c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a4c32b9958b6e33c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a4c32b9958b6e33c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $a4c32b9958b6e33c$var$isElementVisible(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        var visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}
function $a4c32b9958b6e33c$var$sameRectSize(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height;
}
function $a4c32b9958b6e33c$var$sameRectDimensions(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height && a.x === b.x && a.y === b.y;
}
var $a4c32b9958b6e33c$var$createElementMutationsWatcher = function createElementMutationsWatcher(removedNodeRects) {
    return function(_ref) {
        var target = _ref.target, rect = _ref.rect;
        var isNoLsMarkerEnabled = (0, $gQLDR.fg)('platform_vc_ignore_no_ls_mutation_marker');
        var isInIgnoreLsMarker = (0, $ihvsG.default)(target);
        if (!isInIgnoreLsMarker && isNoLsMarkerEnabled) return 'mutation:element';
        var isRLLPlaceholder = (0, $8akC3.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && (!isNoLsMarkerEnabled || isInIgnoreLsMarker)) return 'mutation:rll-placeholder';
        var wasDeleted = removedNodeRects.some(function(nr) {
            return $a4c32b9958b6e33c$var$sameRectDimensions(nr, rect);
        });
        // When fg('platform_vc_ignore_no_ls_mutation_marker') is not enabled,
        // no layout shift mutation is excluded as per existing fy25.03 logic
        if (wasDeleted && (!isNoLsMarkerEnabled || isInIgnoreLsMarker)) return 'mutation:element-replacement';
        return 'mutation:element';
    };
};
var $a4c32b9958b6e33c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // SSR context functions
    function ViewportObserver(_ref2) {
        var _this = this;
        var onChange = _ref2.onChange, getSSRState = _ref2.getSSRState, getSSRPlaceholderHandler = _ref2.getSSRPlaceholderHandler;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ViewportObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "handleIntersectionEntry", function(_ref3) {
            var target = _ref3.target, rect = _ref3.rect, time = _ref3.time, type = _ref3.type, mutationData = _ref3.mutationData;
            if (!target) return;
            var visible = $a4c32b9958b6e33c$var$isElementVisible(target);
            var lastElementRect = _this.mapVisibleNodeRects.get(target);
            _this.mapVisibleNodeRects.set(target, rect);
            _this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "handleChildListMutation", /*#__PURE__*/ function() {
            var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(_ref4) {
                var target, addedNodes, removedNodes, timestamp, removedNodeRects, targetNode, _iterator, _step, _loop, _ret;
                return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            target = _ref4.target, addedNodes = _ref4.addedNodes, removedNodes = _ref4.removedNodes, timestamp = _ref4.timestamp;
                            removedNodeRects = removedNodes.map(function(ref) {
                                var n = ref.deref();
                                if (!n) return;
                                return _this.mapVisibleNodeRects.get(n);
                            });
                            targetNode = target.deref();
                            _iterator = $a4c32b9958b6e33c$var$_createForOfIteratorHelper(addedNodes);
                            _context2.prev = 4;
                            _loop = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _loop() {
                                var _this$intersectionObs8;
                                var addedNodeRef, addedNode, ssrState, SSRStateEnum, _this$intersectionObs, _this$intersectionObs2, ssrPlaceholderHandler, result, _this$intersectionObs3, _result, _this$intersectionObs4, sameDeletedNode, isInIgnoreLsMarker, isNoLsMarkerEnabled, _this$intersectionObs5, _this$intersectionObs6, _checkThirdPartySegme, isWithinThirdPartySegment, ignoredReason, _this$intersectionObs7, assignedReason;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _loop$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            addedNodeRef = _step.value;
                                            addedNode = addedNodeRef.deref();
                                            if (addedNode) {
                                                _context.next = 4;
                                                break;
                                            }
                                            return _context.abrupt("return", 0);
                                        case 4:
                                            if (!(_this.getSSRState && (0, $gQLDR.fg)('platform_ufo_vc_v3_ssr_placeholder'))) {
                                                _context.next = 19;
                                                break;
                                            }
                                            ssrState = _this.getSSRState();
                                            SSRStateEnum = {
                                                normal: 1,
                                                waitingForFirstRender: 2,
                                                ignoring: 3
                                            };
                                            if (!(ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && targetNode === ssrState.reactRootElement)) {
                                                _context.next = 12;
                                                break;
                                            }
                                            ssrState.state = SSRStateEnum.ignoring;
                                            if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                                            ssrState.renderStop = timestamp + 500;
                                            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, 'ssr-hydration');
                                            return _context.abrupt("return", 0);
                                        case 12:
                                            if (!(ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && targetNode === ssrState.reactRootElement)) {
                                                _context.next = 19;
                                                break;
                                            }
                                            if (!(timestamp <= ssrState.renderStop)) {
                                                _context.next = 18;
                                                break;
                                            }
                                            (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(addedNode, 'ssr-hydration');
                                            return _context.abrupt("return", 0);
                                        case 18:
                                            ssrState.state = SSRStateEnum.normal;
                                        case 19:
                                            if (!(_this.getSSRPlaceholderHandler && (0, $gQLDR.fg)('platform_ufo_vc_v3_ssr_placeholder'))) {
                                                _context.next = 36;
                                                break;
                                            }
                                            ssrPlaceholderHandler = _this.getSSRPlaceholderHandler();
                                            if (!ssrPlaceholderHandler) {
                                                _context.next = 36;
                                                break;
                                            }
                                            if (!(ssrPlaceholderHandler.isPlaceholder(addedNode) || ssrPlaceholderHandler.isPlaceholderIgnored(addedNode))) {
                                                _context.next = 29;
                                                break;
                                            }
                                            _context.next = 25;
                                            return ssrPlaceholderHandler.checkIfExistedAndSizeMatching(addedNode);
                                        case 25:
                                            result = _context.sent;
                                            if (!(result !== false)) {
                                                _context.next = 29;
                                                break;
                                            }
                                            (_this$intersectionObs3 = _this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.watchAndTag(addedNode, 'mutation:ssr-placeholder');
                                            return _context.abrupt("return", 0);
                                        case 29:
                                            if (!(ssrPlaceholderHandler.isPlaceholderReplacement(addedNode) || ssrPlaceholderHandler.isPlaceholderIgnored(addedNode))) {
                                                _context.next = 36;
                                                break;
                                            }
                                            _context.next = 32;
                                            return ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(addedNode);
                                        case 32:
                                            _result = _context.sent;
                                            if (!(_result !== false)) {
                                                _context.next = 36;
                                                break;
                                            }
                                            (_this$intersectionObs4 = _this.intersectionObserver) === null || _this$intersectionObs4 === void 0 || _this$intersectionObs4.watchAndTag(addedNode, 'mutation:ssr-placeholder');
                                            return _context.abrupt("return", 0);
                                        case 36:
                                            sameDeletedNode = removedNodes.find(function(ref) {
                                                var n = ref.deref();
                                                if (!n || !addedNode) return false;
                                                return n.isEqualNode(addedNode);
                                            });
                                            isInIgnoreLsMarker = (0, $ihvsG.default)(addedNode);
                                            isNoLsMarkerEnabled = (0, $gQLDR.fg)('platform_vc_ignore_no_ls_mutation_marker'); // When fg('platform_vc_ignore_no_ls_mutation_marker') is not enabled,
                                            // no layout shift mutation is excluded as per existing fy25.03 logic
                                            if (!(sameDeletedNode && (!isNoLsMarkerEnabled || isInIgnoreLsMarker))) {
                                                _context.next = 42;
                                                break;
                                            }
                                            (_this$intersectionObs5 = _this.intersectionObserver) === null || _this$intersectionObs5 === void 0 || _this$intersectionObs5.watchAndTag(addedNode, 'mutation:remount');
                                            return _context.abrupt("return", 0);
                                        case 42:
                                            if (!(0, $63mGt.isContainedWithinMediaWrapper)(addedNode)) {
                                                _context.next = 45;
                                                break;
                                            }
                                            (_this$intersectionObs6 = _this.intersectionObserver) === null || _this$intersectionObs6 === void 0 || _this$intersectionObs6.watchAndTag(addedNode, 'mutation:media');
                                            return _context.abrupt("return", 0);
                                        case 45:
                                            _checkThirdPartySegme = (0, $14F5Y.checkThirdPartySegmentWithIgnoreReason)(addedNode), isWithinThirdPartySegment = _checkThirdPartySegme.isWithinThirdPartySegment, ignoredReason = _checkThirdPartySegme.ignoredReason;
                                            if (!isWithinThirdPartySegment) {
                                                _context.next = 50;
                                                break;
                                            }
                                            assignedReason = (0, $14F5Y.createMutationTypeWithIgnoredReason)(ignoredReason || 'third-party-element');
                                            (_this$intersectionObs7 = _this.intersectionObserver) === null || _this$intersectionObs7 === void 0 || _this$intersectionObs7.watchAndTag(addedNode, assignedReason);
                                            return _context.abrupt("return", 0);
                                        case 50:
                                            (_this$intersectionObs8 = _this.intersectionObserver) === null || _this$intersectionObs8 === void 0 || _this$intersectionObs8.watchAndTag(addedNode, $a4c32b9958b6e33c$var$createElementMutationsWatcher(removedNodeRects));
                                        case 51:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _loop);
                            });
                            _iterator.s();
                        case 7:
                            if ((_step = _iterator.n()).done) {
                                _context2.next = 14;
                                break;
                            }
                            return _context2.delegateYield(_loop(), "t0", 9);
                        case 9:
                            _ret = _context2.t0;
                            if (!(_ret === 0)) {
                                _context2.next = 12;
                                break;
                            }
                            return _context2.abrupt("continue", 12);
                        case 12:
                            _context2.next = 7;
                            break;
                        case 14:
                            _context2.next = 19;
                            break;
                        case 16:
                            _context2.prev = 16;
                            _context2.t1 = _context2["catch"](4);
                            _iterator.e(_context2.t1);
                        case 19:
                            _context2.prev = 19;
                            _iterator.f();
                            return _context2.finish(19);
                        case 22:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        16,
                        19,
                        22
                    ]
                ]);
            }));
            return function(_x) {
                return _ref5.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "handleAttributeMutation", function(_ref6) {
            var _this$intersectionObs9;
            var target = _ref6.target, attributeName = _ref6.attributeName, oldValue = _ref6.oldValue, newValue = _ref6.newValue;
            (_this$intersectionObs9 = _this.intersectionObserver) === null || _this$intersectionObs9 === void 0 || _this$intersectionObs9.watchAndTag(target, function(_ref7) {
                var target = _ref7.target, rect = _ref7.rect;
                if ((0, $63mGt.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $4T0v1.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                var isRLLPlaceholder = (0, $8akC3.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                var _checkThirdPartySegme2 = (0, $14F5Y.checkThirdPartySegmentWithIgnoreReason)(target), isWithinThirdPartySegment = _checkThirdPartySegme2.isWithinThirdPartySegment, ignoredReason = _checkThirdPartySegme2.ignoredReason;
                if (isWithinThirdPartySegment) {
                    var assignedReason = (0, $14F5Y.createMutationTypeWithIgnoredReason)(ignoredReason || 'third-party-element');
                    return {
                        type: assignedReason,
                        mutationData: {
                            attributeName: attributeName,
                            oldValue: oldValue,
                            newValue: newValue
                        }
                    };
                }
                var lastElementRect = _this.mapVisibleNodeRects.get(target);
                if (lastElementRect && $a4c32b9958b6e33c$var$sameRectSize(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "handleLayoutShift", function(_ref8) {
            var time = _ref8.time, changedRects = _ref8.changedRects;
            var _iterator2 = $a4c32b9958b6e33c$var$_createForOfIteratorHelper(changedRects), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var changedRect = _step2.value;
                    var target = changedRect.node;
                    if (target) _this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: 'layout-shift'
                    });
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        });
        this.mapVisibleNodeRects = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ViewportObserver, [
        {
            key: "initializeObservers",
            value: function initializeObservers() {
                if (this.isStarted) return;
                this.intersectionObserver = (0, $5taqr.createIntersectionObserver)({
                    onEntry: this.handleIntersectionEntry
                });
                this.mutationObserver = (0, $6vg2J.default)({
                    onChildListMutation: this.handleChildListMutation,
                    onAttributeMutation: this.handleAttributeMutation
                });
                this.performanceObserver = (0, $43qpp.default)({
                    onLayoutShift: this.handleLayoutShift
                });
            }
        },
        {
            key: "start",
            value: function start() {
                var _this$mutationObserve, _this$performanceObse;
                if (this.isStarted) return;
                this.initializeObservers();
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
                (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
                    type: 'layout-shift',
                    buffered: true,
                    // @ts-ignore-error
                    durationThreshold: 30
                });
                this.isStarted = true;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$mutationObserve2, _this$intersectionObs0, _this$performanceObse2;
                if (!this.isStarted) return;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs0 = this.intersectionObserver) === null || _this$intersectionObs0 === void 0 || _this$intersectionObs0.disconnect();
                (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
                this.isStarted = false;
            }
        }
    ]);
}();

});
parcelRegister("5taqr", function(module, exports) {

$parcel$export(module.exports, "createIntersectionObserver", function () { return $3fb7bf764fa7f594$export$c3799d33e0ae80a5; });
function $3fb7bf764fa7f594$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $3fb7bf764fa7f594$export$c3799d33e0ae80a5(_ref) {
    var onEntry = _ref.onEntry, onObserved = _ref.onObserved;
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var callbacksPerElement = new WeakMap();
    var intersectionObserverCallback = function intersectionObserverCallback(entries) {
        var validEntries = [];
        var startTime = performance.now();
        entries.forEach(function(entry) {
            if (!(entry.target instanceof HTMLElement) || !$3fb7bf764fa7f594$var$isValidEntry(entry)) return;
            var mutationTag = null;
            var mutationData = null;
            var tagOrCallback = callbacksPerElement.get(entry.target);
            if (typeof tagOrCallback === 'function') {
                var tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag !== null && mutationTag !== void 0 ? mutationTag : 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 || onObserved({
            time: startTime,
            elements: validEntries
        });
    };
    var observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: function disconnect() {
            observer.disconnect();
        },
        unobserve: function unobserve(target) {
            observer.unobserve(target);
        },
        watchAndTag: function watchAndTag(target, tagOrCallback) {
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});

parcelRegister("6vg2J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bc215243e757763$export$2e2bcd8739ae039; });
function $4bc215243e757763$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $4bc215243e757763$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $4bc215243e757763$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4bc215243e757763$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4bc215243e757763$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4bc215243e757763$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Batched mutation data for performance optimization
function $4bc215243e757763$var$createMutationObserver(_ref) {
    var onAttributeMutation = _ref.onAttributeMutation, onChildListMutation = _ref.onChildListMutation, onMutationFinished = _ref.onMutationFinished;
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var mutationObserverCallback = function mutationObserverCallback(mutations) {
        var targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        var batchedMutations = new Map();
        var _iterator = $4bc215243e757763$var$_createForOfIteratorHelper(mutations), _step;
        try {
            var _loop = function _loop() {
                var mut = _step.value;
                if (!(mut.target instanceof HTMLElement)) return 0; // continue
                if (mut.type === 'attributes') {
                    var _mut$oldValue;
                    /*
            			"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            			I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            			Conceptually there is after all a mutation: there is an old value replaced with a new one,
            			and whether or not they are the same doesn't really matter.
            			And Custom elements should work the same way as MutationObserver."
            			https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            		*/ var oldValue = (_mut$oldValue = mut.oldValue) !== null && _mut$oldValue !== void 0 ? _mut$oldValue : undefined;
                    var newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                    if (oldValue !== newValue) {
                        var _mut$attributeName;
                        onAttributeMutation({
                            target: mut.target,
                            attributeName: (_mut$attributeName = mut.attributeName) !== null && _mut$attributeName !== void 0 ? _mut$attributeName : 'unknown',
                            oldValue: oldValue,
                            newValue: newValue
                        });
                    }
                    return 0; // continue
                } else if (mut.type === 'childList') {
                    var _mut$addedNodes, _mut$removedNodes;
                    // In chromium browser MutationRecord has timestamp field, which we should use.
                    var timestamp = Math.round(mut.timestamp || performance.now());
                    // Get or create timestamp bucket
                    var timestampBucket = batchedMutations.get(timestamp);
                    if (!timestampBucket) {
                        timestampBucket = new Map();
                        batchedMutations.set(timestamp, timestampBucket);
                    }
                    // Get or create target batch within timestamp bucket
                    var batch = timestampBucket.get(mut.target);
                    if (!batch) {
                        batch = {
                            target: new WeakRef(mut.target),
                            addedNodes: [],
                            removedNodes: [],
                            timestamp: timestamp
                        };
                        timestampBucket.set(mut.target, batch);
                    }
                    // Accumulate added nodes
                    ((_mut$addedNodes = mut.addedNodes) !== null && _mut$addedNodes !== void 0 ? _mut$addedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                    });
                    // Accumulate removed nodes
                    ((_mut$removedNodes = mut.removedNodes) !== null && _mut$removedNodes !== void 0 ? _mut$removedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                    });
                }
                targets.push(mut.target);
            }, _ret;
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                _ret = _loop();
                if (_ret === 0) continue;
            }
        // Process all batched childList mutations
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        var _iterator2 = $4bc215243e757763$var$_createForOfIteratorHelper(batchedMutations.values()), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var timestampBucket = _step2.value;
                var _iterator3 = $4bc215243e757763$var$_createForOfIteratorHelper(timestampBucket.values()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var batch = _step3.value;
                        onChildListMutation({
                            target: batch.target,
                            addedNodes: batch.addedNodes,
                            removedNodes: batch.removedNodes,
                            timestamp: batch.timestamp
                        });
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    };
    var observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $4bc215243e757763$export$2e2bcd8739ae039 = $4bc215243e757763$var$createMutationObserver;

});

parcelRegister("43qpp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f3bed76092c97a7$export$2e2bcd8739ae039; });
function $2f3bed76092c97a7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2f3bed76092c97a7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $2f3bed76092c97a7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2f3bed76092c97a7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2f3bed76092c97a7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2f3bed76092c97a7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $2f3bed76092c97a7$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $2f3bed76092c97a7$var$createPerformanceObserver(_ref) {
    var onLayoutShift = _ref.onLayoutShift;
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    var performanceObserverCallback = function performanceObserverCallback(entries) {
        var _iterator = $2f3bed76092c97a7$var$_createForOfIteratorHelper(entries.getEntries()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.entryType === 'layout-shift' && 'sources' in entry) {
                    // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
                    var changedRects = entry.sources.reduceRight(function(acc, attr) {
                        acc.push({
                            rect: $2f3bed76092c97a7$export$5e3f54cad8cb65e2(attr.currentRect),
                            previousRect: $2f3bed76092c97a7$export$5e3f54cad8cb65e2(attr.previousRect),
                            node: attr.node
                        });
                        return acc;
                    }, []);
                    onLayoutShift({
                        time: entry.startTime,
                        changedRects: changedRects
                    });
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    var observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $2f3bed76092c97a7$export$2e2bcd8739ae039 = $2f3bed76092c97a7$var$createPerformanceObserver;

});

parcelRegister("14F5Y", function(module, exports) {

$parcel$export(module.exports, "checkThirdPartySegmentWithIgnoreReason", function () { return $0c860ade5be670a7$export$f12ab50a13775c1e; });
$parcel$export(module.exports, "createMutationTypeWithIgnoredReason", function () { return $0c860ade5be670a7$export$67f1472efd91484d; });

var $91FVG = parcelRequire("91FVG");

var $a3ftr = parcelRequire("a3ftr");

var $gQLDR = parcelRequire("gQLDR");
function $0c860ade5be670a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c860ade5be670a7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c860ade5be670a7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c860ade5be670a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Helper function to find React fiber on an element
var $0c860ade5be670a7$var$findReactFiber = function findReactFiber(element) {
    var key = Object.keys(element).find(function(key) {
        return key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$');
    });
    return key ? element[key] : null;
};
function $0c860ade5be670a7$export$ed6593e641f2783a(node, targetComponentName, childComponentConfig) {
    var fiber = null;
    if ((0, $gQLDR.fg)('platform_ufo_handle_non_react_element_for_3p')) {
        // Walk up the DOM tree to find React fiber (handles non-React-rendered elements)
        var currentElement = node;
        while(currentElement && !fiber){
            fiber = $0c860ade5be670a7$var$findReactFiber(currentElement);
            if (!fiber) currentElement = currentElement.parentElement;
        }
    } else fiber = $0c860ade5be670a7$var$findReactFiber(node);
    // If no React fiber found, return false
    if (!fiber) return {
        isWithin: false
    };
    // Traverse up the fiber tree
    var currentFiber = fiber;
    var childProp;
    while(currentFiber){
        var componentName = void 0;
        if (currentFiber.type) {
            if (typeof currentFiber.type === 'function') componentName = currentFiber.type.displayName || currentFiber.type.name;
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(currentFiber.type) === 'object' && (currentFiber.type.displayName || currentFiber.type.name)) componentName = currentFiber.type.displayName || currentFiber.type.name;
        }
        // Check if this is a child component we're looking for
        if (childComponentConfig && componentName === childComponentConfig.componentName) {
            var props = currentFiber.memoizedProps || currentFiber.pendingProps;
            if (props && props[childComponentConfig.propName] !== undefined) // Overwrite with the nearest child prop (closest to the target component)
            childProp = childComponentConfig.extractValue ? childComponentConfig.extractValue(props) : props[childComponentConfig.propName];
        }
        // Check if we found the target component
        if (componentName === targetComponentName) return $0c860ade5be670a7$var$_objectSpread({
            isWithin: true
        }, childComponentConfig && {
            childProp: childProp
        });
        currentFiber = currentFiber.return;
    }
    return {
        isWithin: false
    };
}
function $0c860ade5be670a7$export$f12ab50a13775c1e(node) {
    var result = $0c860ade5be670a7$export$ed6593e641f2783a(node, 'UFOThirdPartySegment', {
        componentName: 'UFOIgnoreHolds',
        propName: 'reason'
    });
    return {
        isWithinThirdPartySegment: result.isWithin,
        ignoredReason: result.childProp
    };
}
function $0c860ade5be670a7$export$67f1472efd91484d(reason) {
    return "mutation:".concat(reason);
}

});

parcelRegister("ihvsG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4f23824373709c0$export$2e2bcd8739ae039; });
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $d4f23824373709c0$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $d4f23824373709c0$export$2e2bcd8739ae039(element.parentElement);
}

});


parcelRegister("2XaCz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2269549530f54f90$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $40QgJ = parcelRequire("40QgJ");
var $2269549530f54f90$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WindowEventObserver(opts) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, WindowEventObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "unbindFns", []);
        this.onEvent = opts.onEvent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(WindowEventObserver, [
        {
            key: "bindEvent",
            value: function bindEvent(type) {
                var _this = this;
                var unbindCallback = (0, $40QgJ.bind)(window, {
                    type: type,
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this.onEvent({
                            time: event.timeStamp,
                            type: type,
                            event: event
                        });
                    },
                    options: {
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "start",
            value: function start() {
                this.bindEvent('wheel');
                this.bindEvent('scroll');
                this.bindEvent('keydown');
                this.bindEvent('resize');
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.unbindFns.forEach(function(cb) {
                    cb();
                });
                this.unbindFns = [];
            }
        }
    ]);
}();

});



parcelRegister("8cJqz", function(module, exports) {

$parcel$export(module.exports, "interactions", function () { return $5f92aeaeceb75f60$export$cc97b17ef9aeb088; });
var $5f92aeaeceb75f60$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("6PSIg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fa1f259b415c89d$export$2e2bcd8739ae039; });

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $axdfd = parcelRequire("axdfd");

var $i6899 = parcelRequire("i6899");

var $2nvs7 = parcelRequire("2nvs7");
function $4fa1f259b415c89d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4fa1f259b415c89d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4fa1f259b415c89d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4fa1f259b415c89d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4fa1f259b415c89d$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var $4fa1f259b415c89d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PostInteractionLog() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, PostInteractionLog);
        /**
     * Basic info about interaction that has just finished
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "lastInteractionFinish", null);
        /**
     * Array of observed react render timings
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "reactProfilerTimings", []);
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "sinkTimeoutId", null);
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "vcObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "vcObserverSSRConfig", null);
        /**
     * Handler function to process / send the observation data
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "sinkHandlerFn", function() {});
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(PostInteractionLog, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                this.vcObserver = new (0, $2nvs7.VCObserverWrapper)($4fa1f259b415c89d$var$_objectSpread($4fa1f259b415c89d$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "setVCObserverSSRConfig",
            value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
                this.vcObserverSSRConfig = vcObserverSSRConfig;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: /**
     * Set the fn that would be invoked to process / send the observation data
     */ function sinkHandler(sinkHandlerFn) {
                this.sinkHandlerFn = sinkHandlerFn;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.lastInteractionFinish = null;
                this.reactProfilerTimings = [];
                if (this.sinkTimeoutId != null) {
                    clearTimeout(this.sinkTimeoutId);
                    this.sinkTimeoutId = null;
                }
                this.setVCObserverSSRConfig(null);
            }
        },
        {
            key: "hasData",
            value: function hasData() {
                var _this$reactProfilerTi;
                return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
            }
        },
        {
            key: "sendPostInteractionLog",
            value: function() {
                var _sendPostInteractionLog = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee() {
                    var _this$vcObserver3, _getConfig2;
                    var _getConfig, _this$vcObserver2, postInteractionFinishVCResult, _this$vcObserver4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn)) {
                                    _context.next = 4;
                                    break;
                                }
                                this.reset();
                                if ((_getConfig = (0, $i6899.getConfig)()) !== null && _getConfig !== void 0 && (_getConfig = _getConfig.experimentalInteractionMetrics) !== null && _getConfig !== void 0 && _getConfig.enabled) (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
                                return _context.abrupt("return");
                            case 4:
                                _context.next = 6;
                                return (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 ? void 0 : _this$vcObserver3.getVCResult($4fa1f259b415c89d$var$_objectSpread($4fa1f259b415c89d$var$_objectSpread({
                                    start: this.lastInteractionFinish.start,
                                    stop: performance.now(),
                                    tti: -1,
                                    // no need for TTI value here
                                    isEventAborted: !!this.lastInteractionFinish.abortReason,
                                    prefix: 'ufo'
                                }, this.vcObserverSSRConfig), {}, {
                                    experienceKey: this.lastInteractionFinish.ufoName
                                }));
                            case 6:
                                postInteractionFinishVCResult = _context.sent;
                                if ((_getConfig2 = (0, $i6899.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.experimentalInteractionMetrics) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) (_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 || _this$vcObserver4.stop();
                                this.sinkHandlerFn({
                                    lastInteractionFinish: this.lastInteractionFinish,
                                    reactProfilerTimings: this.reactProfilerTimings,
                                    // NOTE: invoking `getVCResult` at latest possible point in time here (not earlier) to get the most accurate result (from performance.now())
                                    postInteractionFinishVCResult: postInteractionFinishVCResult,
                                    lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
                                });
                                this.reset();
                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function sendPostInteractionLog() {
                    return _sendPostInteractionLog.apply(this, arguments);
                }
                return sendPostInteractionLog;
            }()
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(_ref2) {
                var _getConfig3, _this = this;
                var ufoName = _ref2.ufoName, start = _ref2.start, end = _ref2.end, id = _ref2.id, abortReason = _ref2.abortReason, abortedByInteractionName = _ref2.abortedByInteractionName, routeName = _ref2.routeName, type = _ref2.type, experimentalTTAI = _ref2.experimentalTTAI, experimentalVC90 = _ref2.experimentalVC90, errors = _ref2.errors;
                this.lastInteractionFinish = {
                    ufoName: ufoName,
                    start: start,
                    end: end,
                    id: id,
                    abortReason: abortReason,
                    abortedByInteractionName: abortedByInteractionName,
                    routeName: routeName,
                    type: type,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90,
                    errors: errors
                };
                var timeout = ((_getConfig3 = (0, $i6899.getConfig)()) === null || _getConfig3 === void 0 ? void 0 : _getConfig3.timeWindowForLateMutationsInMilliseconds) || $4fa1f259b415c89d$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
                this.sinkTimeoutId = window.setTimeout(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return _this.sendPostInteractionLog();
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                })), timeout);
            }
        },
        {
            key: "addProfilerTimings",
            value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
                if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                    type: type,
                    actualDuration: actualDuration,
                    baseDuration: baseDuration,
                    startTime: startTime,
                    commitTime: commitTime,
                    labelStack: labelStack
                });
            }
        }
    ]);
}();

});


parcelRegister("eCX8C", function(module, exports) {

$parcel$export(module.exports, "eventDataProcessor", function () { return $aa627ce07aad9a02$export$896b6e121bbaec25; });

var $k7uol = parcelRequire("k7uol");

var $62ppy = parcelRequire("62ppy");

var $axdfd = parcelRequire("axdfd");

var $h38tX = parcelRequire("h38tX");

var $1grIu = parcelRequire("1grIu");

var $jXhOd = parcelRequire("jXhOd");

var $4CDrt = parcelRequire("4CDrt");

var $hBtbF = parcelRequire("hBtbF");

var $al0Ty = parcelRequire("al0Ty");

var $chz3m = parcelRequire("chz3m");

var $fe0j5 = parcelRequire("fe0j5");

var $lheF8 = parcelRequire("lheF8");

var $d2oLX = parcelRequire("d2oLX");

var $iExJ0 = parcelRequire("iExJ0");

var $h6Ifu = parcelRequire("h6Ifu");

var $8AWkx = parcelRequire("8AWkx");

var $7QRzP = parcelRequire("7QRzP");

var $gV7yx = parcelRequire("gV7yx");

var $12dvS = parcelRequire("12dvS");

var $AGx9M = parcelRequire("AGx9M");

var $epDRR = parcelRequire("epDRR");

var $8kFR1 = parcelRequire("8kFR1");

var $c9dn3 = parcelRequire("c9dn3");

var $f30KO = parcelRequire("f30KO");

var $hJp5I = parcelRequire("hJp5I");

var $27KSL = parcelRequire("27KSL");

var $gFrEF = parcelRequire("gFrEF");

var $4LG0h = parcelRequire("4LG0h");

var $gTBp0 = parcelRequire("gTBp0");

var $9Md7z = parcelRequire("9Md7z");

var $c2rsA = parcelRequire("c2rsA");

var $8Ma28 = parcelRequire("8Ma28");

var $i6n26 = parcelRequire("i6n26");

var $a2Ljb = parcelRequire("a2Ljb");

var $jYdDg = parcelRequire("jYdDg");

var $79KsK = parcelRequire("79KsK");

var $5rxCO = parcelRequire("5rxCO");

var $eIUDE = parcelRequire("eIUDE");

var $7EdFT = parcelRequire("7EdFT");

var $bo0Gu = parcelRequire("bo0Gu");
function $aa627ce07aad9a02$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $aa627ce07aad9a02$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $aa627ce07aad9a02$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $aa627ce07aad9a02$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $aa627ce07aad9a02$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $aa627ce07aad9a02$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $aa627ce07aad9a02$var$defaultSet = [
    (0, $d2oLX.eventKey),
    (0, $gV7yx.eventType),
    (0, $h6Ifu.eventProduct),
    (0, $7QRzP.eventRoute),
    (0, $fe0j5.eventId),
    (0, $iExJ0.eventLocalTime),
    (0, $8AWkx.eventRegion),
    (0, $4CDrt.appFramework),
    (0, $hBtbF.appVersion),
    (0, $al0Ty.bmVersion),
    (0, $i6n26.telemetryBrowser),
    (0, $a2Ljb.telemetryCpu),
    (0, $jYdDg.telemetryMemory),
    (0, $79KsK.telemetryNetwork),
    (0, $chz3m.customData),
    (0, $12dvS.featureFlags),
    (0, $AGx9M.hostname),
    (0, $9Md7z.productCustomData),
    (0, $5rxCO.appTimings),
    (0, $7EdFT.resourceTimings)
];
var $aa627ce07aad9a02$var$pageLoadCommon = [].concat($aa627ce07aad9a02$var$defaultSet, [
    (0, $4LG0h.pageVisibleState),
    (0, $gTBp0.pageVisibleValue),
    (0, $lheF8.eventInitial),
    (0, $hJp5I.pageLoadMetrics),
    (0, $eIUDE.bundleEvalTimings)
]);
var $aa627ce07aad9a02$var$initialPageLoadSet = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))($aa627ce07aad9a02$var$pageLoadCommon), [
    (0, $8kFR1.initialPageLoadMetrics),
    (0, $f30KO.navigationMetrics),
    (0, $8Ma28.ssrSuccess),
    (0, $c2rsA.ssrFeatureFlags)
]);
var $aa627ce07aad9a02$var$spaTransitionSet = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))($aa627ce07aad9a02$var$pageLoadCommon);
var $aa627ce07aad9a02$var$pageSegmentLoadSet = [].concat($aa627ce07aad9a02$var$defaultSet, [
    (0, $27KSL.pageSegmentLoadMetrics),
    (0, $4LG0h.pageVisibleState),
    (0, $gTBp0.pageVisibleValue),
    (0, $lheF8.eventInitial),
    (0, $eIUDE.bundleEvalTimings)
]);
var $aa627ce07aad9a02$var$interactionSet = [].concat($aa627ce07aad9a02$var$defaultSet, [
    (0, $4LG0h.pageVisibleState),
    (0, $gTBp0.pageVisibleValue),
    (0, $c9dn3.interactionMetrics)
]);
var $aa627ce07aad9a02$var$customMetricSet = [].concat($aa627ce07aad9a02$var$defaultSet, [
    (0, $4LG0h.pageVisibleState),
    (0, $gTBp0.pageVisibleValue),
    (0, $epDRR.customEventMetrics)
]);
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
var $aa627ce07aad9a02$var$webVitalsMetricSet = [].concat($aa627ce07aad9a02$var$defaultSet, [
    (0, $gFrEF.webVitalsMetrics)
]);
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
var $aa627ce07aad9a02$var$waitForCLS = function waitForCLS() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $h38tX.clsWaitTimeMs) + 500;
    return new Promise(function(resolve) {
        return setTimeout(resolve, delay);
    });
};
var $aa627ce07aad9a02$export$896b6e121bbaec25 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(globalConfig, data) {
        var set, plugins, _iterator, _step, plugin, result, pluginResults, generated;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(data.start === null || data.stop === null)) {
                        _context.next = 3;
                        break;
                    }
                    (0, $1grIu.logger).log("eventDataProcessor: Metric \"".concat(data.key, "\" start or stop are incorrect; start: ").concat(data.start, "; stop: ").concat(data.stop));
                    return _context.abrupt("return", null);
                case 3:
                    set = [];
                    if (data.config.type === (0, $bo0Gu.BMEventsType).PAGE_LOAD && (0, $jXhOd.isPageLoadMetricData)(data) && data.isInitial) set = $aa627ce07aad9a02$var$initialPageLoadSet;
                    if (data.config.type === (0, $bo0Gu.BMEventsType).PAGE_LOAD && (0, $jXhOd.isPageLoadMetricData)(data) && !data.isInitial) set = $aa627ce07aad9a02$var$spaTransitionSet;
                    if (data.config.type === (0, $bo0Gu.BMEventsType).PAGE_SEGMENT_LOAD && (0, $jXhOd.isPageSegmentLoadMetricData)(data)) set = $aa627ce07aad9a02$var$pageSegmentLoadSet;
                    if (data.config.type === (0, $bo0Gu.BMEventsType).INLINE_RESULT) set = $aa627ce07aad9a02$var$interactionSet;
                    if (data.config.type === (0, $bo0Gu.BMEventsType).CUSTOM) set = $aa627ce07aad9a02$var$customMetricSet;
                    if (!(data.config.type === (0, $bo0Gu.BMEventsType).WEB_VITALS)) {
                        _context.next = 13;
                        break;
                    }
                    set = $aa627ce07aad9a02$var$webVitalsMetricSet;
                    // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
                    _context.next = 13;
                    return $aa627ce07aad9a02$var$waitForCLS();
                case 13:
                    //TODO if type is different - do not send at all
                    plugins = [];
                    _iterator = $aa627ce07aad9a02$var$_createForOfIteratorHelper(set);
                    _context.prev = 15;
                    _iterator.s();
                case 17:
                    if ((_step = _iterator.n()).done) {
                        _context.next = 25;
                        break;
                    }
                    plugin = _step.value;
                    _context.next = 21;
                    return plugin(data.config, data, // some plugins support page load specific data with special check
                    globalConfig);
                case 21:
                    result = _context.sent;
                    if (result) plugins.push(result);
                case 23:
                    _context.next = 17;
                    break;
                case 25:
                    _context.next = 30;
                    break;
                case 27:
                    _context.prev = 27;
                    _context.t0 = _context["catch"](15);
                    _iterator.e(_context.t0);
                case 30:
                    _context.prev = 30;
                    _iterator.f();
                    return _context.finish(30);
                case 33:
                    _context.next = 35;
                    return Promise.all(plugins);
                case 35:
                    pluginResults = _context.sent;
                    generated = {};
                    pluginResults.forEach(function(pluginResult) {
                        if (pluginResult === null) return;
                        Object.keys(pluginResult).forEach(function(key) {
                            var keyResult = pluginResult[key];
                            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
                        });
                    });
                    return _context.abrupt("return", generated);
                case 39:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                15,
                27,
                30,
                33
            ]
        ]);
    }));
    return function eventDataProcessor(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("jXhOd", function(module, exports) {

$parcel$export(module.exports, "isPageLoadMetricData", function () { return $e8715780b201646a$export$b0e12e7abb0bff11; });
$parcel$export(module.exports, "isPageSegmentLoadMetricData", function () { return $e8715780b201646a$export$83d0099ee6dbb5b0; });
$parcel$export(module.exports, "isPageLoadConfig", function () { return $e8715780b201646a$export$8672fa27ba8bba88; });
$parcel$export(module.exports, "isPageSegmentLoadConfig", function () { return $e8715780b201646a$export$abe063537ef4987b; });
$parcel$export(module.exports, "isInteractionConfig", function () { return $e8715780b201646a$export$ae68674b6a9353be; });
$parcel$export(module.exports, "isCustomConfig", function () { return $e8715780b201646a$export$b493eb8b2ba87421; });

var $bo0Gu = parcelRequire("bo0Gu");
var $e8715780b201646a$export$b0e12e7abb0bff11 = function isPageLoadMetricData(data) {
    return data.type === (0, $bo0Gu.BMEventsType).PAGE_LOAD;
};
var $e8715780b201646a$export$83d0099ee6dbb5b0 = function isPageSegmentLoadMetricData(data) {
    return data.type === (0, $bo0Gu.BMEventsType).PAGE_SEGMENT_LOAD;
};
var $e8715780b201646a$export$8672fa27ba8bba88 = function isPageLoadConfig(data) {
    return data.type === (0, $bo0Gu.BMEventsType).PAGE_LOAD;
};
var $e8715780b201646a$export$abe063537ef4987b = function isPageSegmentLoadConfig(data) {
    return data.type === (0, $bo0Gu.BMEventsType).PAGE_SEGMENT_LOAD;
};
var $e8715780b201646a$export$ae68674b6a9353be = function isInteractionConfig(data) {
    return data.type === (0, $bo0Gu.BMEventsType).INLINE_RESULT;
};
var $e8715780b201646a$export$b493eb8b2ba87421 = function isCustomConfig(data) {
    return data.type === (0, $bo0Gu.BMEventsType).CUSTOM;
};

});

parcelRegister("4CDrt", function(module, exports) {

$parcel$export(module.exports, "appFramework", function () { return $35d94e675e96093e$export$e34e4529b979f74c; });
var $35d94e675e96093e$export$e34e4529b979f74c = function appFramework(_config, _data, globalConfig) {
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("hBtbF", function(module, exports) {

$parcel$export(module.exports, "appVersion", function () { return $cd0c885ac20e7d2a$export$82ae485178b37419; });
var $cd0c885ac20e7d2a$export$82ae485178b37419 = function appVersion(_config, _data, globalConfig) {
    var pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("al0Ty", function(module, exports) {

$parcel$export(module.exports, "bmVersion", function () { return $786c8f49e6dfbf45$export$5cafa465fc876895; });
var $786c8f49e6dfbf45$export$5cafa465fc876895 = function bmVersion() {
    return {
        'bm:version': 3
    };
};

});

parcelRegister("chz3m", function(module, exports) {

$parcel$export(module.exports, "customData", function () { return $8f1243610830ff0a$export$f7e743c7db162193; });

var $82V4i = parcelRequire("82V4i");
var $8f1243610830ff0a$export$f7e743c7db162193 = function customData(_config, data) {
    var custom = {};
    var changed = false;
    if (data.custom) Object.entries(data.custom).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        changed = true;
        custom["custom:".concat(key)] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("fe0j5", function(module, exports) {

$parcel$export(module.exports, "eventId", function () { return $b15866c311f02449$export$aed28df7ac07d79a; });
var $b15866c311f02449$export$aed28df7ac07d79a = function eventId(config) {
    return {
        'event:id': config.key
    };
};

});

parcelRegister("lheF8", function(module, exports) {

$parcel$export(module.exports, "eventInitial", function () { return $f7d68f2a8586a96d$export$fa8e91d436b3ef8b; });

var $jXhOd = parcelRequire("jXhOd");
var $f7d68f2a8586a96d$export$fa8e91d436b3ef8b = function eventInitial(_config, data) {
    if (!(0, $jXhOd.isPageLoadMetricData)(data) && !(0, $jXhOd.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("d2oLX", function(module, exports) {

$parcel$export(module.exports, "eventKey", function () { return $97dead8ed6a7dca4$export$10be2d3a558d3f88; });

var $9DIRT = parcelRequire("9DIRT");
var $97dead8ed6a7dca4$export$10be2d3a558d3f88 = function eventKey(config, _data, globalConfig) {
    return {
        'event:key': "".concat(globalConfig.product, ".fe.").concat((0, $9DIRT.mapEventType)(config.type), ".").concat(config.key)
    };
};

});
parcelRegister("9DIRT", function(module, exports) {

$parcel$export(module.exports, "mapEventType", function () { return $704a8f72f999aa95$export$b334d07f11140768; });

var $bo0Gu = parcelRequire("bo0Gu");
var $704a8f72f999aa95$export$b334d07f11140768 = function mapEventType(type) {
    switch(type){
        case (0, $bo0Gu.BMEventsType).CUSTOM:
            return (0, $bo0Gu.StorableBMEventsType).CUSTOM;
        case (0, $bo0Gu.BMEventsType).INLINE_RESULT:
            return (0, $bo0Gu.StorableBMEventsType).INLINE_RESULT;
        case (0, $bo0Gu.BMEventsType).PAGE_LOAD:
            return (0, $bo0Gu.StorableBMEventsType).PAGE_LOAD;
        case (0, $bo0Gu.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $bo0Gu.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $bo0Gu.BMEventsType).WEB_VITALS:
            return (0, $bo0Gu.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("iExJ0", function(module, exports) {

$parcel$export(module.exports, "eventLocalTime", function () { return $d9461f78384cd780$export$5219854ae7ec45da; });

var $fLR7B = parcelRequire("fLR7B");
var $d9461f78384cd780$export$5219854ae7ec45da = function eventLocalTime() {
    return {
        'event:localHour': parseInt((0, $fLR7B.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $fLR7B.default)(new Date(), 'i'), 10)
    };
};

});
parcelRegister("fLR7B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7b473a447574936$export$2e2bcd8739ae039; });

var $1xZUC = parcelRequire("1xZUC");

var $9OUEr = parcelRequire("9OUEr");

var $8kDQ6 = parcelRequire("8kDQ6");

var $hNQkO = parcelRequire("hNQkO");

var $lfAJG = parcelRequire("lfAJG");

var $21cU6 = parcelRequire("21cU6");

var $bwYc5 = parcelRequire("bwYc5");

var $drG3N = parcelRequire("drG3N");

var $58XrX = parcelRequire("58XrX");

var $3RXku = parcelRequire("3RXku");

var $irlOH = parcelRequire("irlOH");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $b7b473a447574936$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $b7b473a447574936$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $b7b473a447574936$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $b7b473a447574936$var$doubleQuoteRegExp = /''/g;
var $b7b473a447574936$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $b7b473a447574936$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $58XrX.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $3RXku.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $irlOH.default);
    var firstWeekContainsDate = (0, $drG3N.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $drG3N.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $8kDQ6.default)(dirtyDate);
    if (!(0, $1xZUC.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $21cU6.default)(originalDate);
    var utcDate = (0, $9OUEr.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($b7b473a447574936$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $lfAJG.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($b7b473a447574936$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $b7b473a447574936$var$cleanEscapedString(substring);
        var formatter = (0, $hNQkO.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $bwYc5.isProtectedWeekYearToken)(substring)) (0, $bwYc5.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $bwYc5.isProtectedDayOfYearToken)(substring)) (0, $bwYc5.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($b7b473a447574936$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $b7b473a447574936$var$cleanEscapedString(input) {
    var matched = input.match($b7b473a447574936$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($b7b473a447574936$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("1xZUC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1208e5f61c5cae50$export$2e2bcd8739ae039; });

var $8WSBs = parcelRequire("8WSBs");

var $8kDQ6 = parcelRequire("8kDQ6");

var $58XrX = parcelRequire("58XrX");
function $1208e5f61c5cae50$export$2e2bcd8739ae039(dirtyDate) {
    (0, $58XrX.default)(1, arguments);
    if (!(0, $8WSBs.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $8kDQ6.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("8WSBs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $683e18892f3b6cf7$export$2e2bcd8739ae039; });

var $4PLSn = parcelRequire("4PLSn");

var $58XrX = parcelRequire("58XrX");
function $683e18892f3b6cf7$export$2e2bcd8739ae039(value) {
    (0, $58XrX.default)(1, arguments);
    return value instanceof Date || (0, $4PLSn.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("9OUEr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7264ba5b604e68a4$export$2e2bcd8739ae039; });

var $louqH = parcelRequire("louqH");

var $58XrX = parcelRequire("58XrX");

var $drG3N = parcelRequire("drG3N");
function $7264ba5b604e68a4$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $58XrX.default)(2, arguments);
    var amount = (0, $drG3N.default)(dirtyAmount);
    return (0, $louqH.default)(dirtyDate, -amount);
}

});
parcelRegister("louqH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f933718c23960067$export$2e2bcd8739ae039; });

var $drG3N = parcelRequire("drG3N");

var $8kDQ6 = parcelRequire("8kDQ6");

var $58XrX = parcelRequire("58XrX");
function $f933718c23960067$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $58XrX.default)(2, arguments);
    var timestamp = (0, $8kDQ6.default)(dirtyDate).getTime();
    var amount = (0, $drG3N.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("drG3N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c9e6c4363abcf2f$export$2e2bcd8739ae039; });
function $9c9e6c4363abcf2f$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("hNQkO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf5f9bd7267409dc$export$2e2bcd8739ae039; });

var $lNO58 = parcelRequire("lNO58");

var $iHdHu = parcelRequire("iHdHu");

var $cTNiG = parcelRequire("cTNiG");

var $5cLek = parcelRequire("5cLek");

var $fuotl = parcelRequire("fuotl");

var $gtUIS = parcelRequire("gtUIS");

var $a833g = parcelRequire("a833g");
var $cf5f9bd7267409dc$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $cf5f9bd7267409dc$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $a833g.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $fuotl.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $gtUIS.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $gtUIS.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $cTNiG.default)(date);
        // Padding
        return (0, $gtUIS.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $gtUIS.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $gtUIS.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $gtUIS.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $a833g.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $gtUIS.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $5cLek.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $gtUIS.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $iHdHu.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $gtUIS.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $a833g.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $lNO58.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $gtUIS.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $gtUIS.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $gtUIS.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $gtUIS.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $cf5f9bd7267409dc$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $cf5f9bd7267409dc$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $cf5f9bd7267409dc$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $cf5f9bd7267409dc$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $cf5f9bd7267409dc$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $cf5f9bd7267409dc$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $a833g.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $a833g.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $gtUIS.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $gtUIS.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $a833g.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $a833g.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $a833g.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $cf5f9bd7267409dc$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $cf5f9bd7267409dc$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $cf5f9bd7267409dc$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $cf5f9bd7267409dc$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $cf5f9bd7267409dc$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $cf5f9bd7267409dc$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $cf5f9bd7267409dc$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $cf5f9bd7267409dc$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $cf5f9bd7267409dc$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $cf5f9bd7267409dc$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $gtUIS.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $gtUIS.default)(timestamp, token.length);
    }
};
function $cf5f9bd7267409dc$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $gtUIS.default)(minutes, 2);
}
function $cf5f9bd7267409dc$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $gtUIS.default)(Math.abs(offset) / 60, 2);
    }
    return $cf5f9bd7267409dc$var$formatTimezone(offset, dirtyDelimiter);
}
function $cf5f9bd7267409dc$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $gtUIS.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $gtUIS.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $cf5f9bd7267409dc$export$2e2bcd8739ae039 = $cf5f9bd7267409dc$var$formatters;

});
parcelRegister("lNO58", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdf505ccf971b19f$export$2e2bcd8739ae039; });

var $8kDQ6 = parcelRequire("8kDQ6");

var $58XrX = parcelRequire("58XrX");
var $fdf505ccf971b19f$var$MILLISECONDS_IN_DAY = 86400000;
function $fdf505ccf971b19f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $58XrX.default)(1, arguments);
    var date = (0, $8kDQ6.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $fdf505ccf971b19f$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("iHdHu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9c6dec76a239ebe$export$2e2bcd8739ae039; });

var $8kDQ6 = parcelRequire("8kDQ6");

var $6m6VO = parcelRequire("6m6VO");

var $j5K9b = parcelRequire("j5K9b");

var $58XrX = parcelRequire("58XrX");
var $d9c6dec76a239ebe$var$MILLISECONDS_IN_WEEK = 604800000;
function $d9c6dec76a239ebe$export$2e2bcd8739ae039(dirtyDate) {
    (0, $58XrX.default)(1, arguments);
    var date = (0, $8kDQ6.default)(dirtyDate);
    var diff = (0, $6m6VO.default)(date).getTime() - (0, $j5K9b.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $d9c6dec76a239ebe$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("6m6VO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a0a2c9c094a227d$export$2e2bcd8739ae039; });

var $8kDQ6 = parcelRequire("8kDQ6");

var $58XrX = parcelRequire("58XrX");
function $4a0a2c9c094a227d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $58XrX.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $8kDQ6.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("j5K9b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de6247d2da2af42e$export$2e2bcd8739ae039; });

var $cTNiG = parcelRequire("cTNiG");

var $6m6VO = parcelRequire("6m6VO");

var $58XrX = parcelRequire("58XrX");
function $de6247d2da2af42e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $58XrX.default)(1, arguments);
    var year = (0, $cTNiG.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $6m6VO.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("cTNiG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9640dd1c00d35e4b$export$2e2bcd8739ae039; });

var $8kDQ6 = parcelRequire("8kDQ6");

var $58XrX = parcelRequire("58XrX");

var $6m6VO = parcelRequire("6m6VO");
function $9640dd1c00d35e4b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $58XrX.default)(1, arguments);
    var date = (0, $8kDQ6.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $6m6VO.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $6m6VO.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("5cLek", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ca2b5a613805c1e$export$2e2bcd8739ae039; });

var $8kDQ6 = parcelRequire("8kDQ6");

var $ccU3x = parcelRequire("ccU3x");

var $72xva = parcelRequire("72xva");

var $58XrX = parcelRequire("58XrX");
var $3ca2b5a613805c1e$var$MILLISECONDS_IN_WEEK = 604800000;
function $3ca2b5a613805c1e$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $58XrX.default)(1, arguments);
    var date = (0, $8kDQ6.default)(dirtyDate);
    var diff = (0, $ccU3x.default)(date, options).getTime() - (0, $72xva.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $3ca2b5a613805c1e$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("ccU3x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e32169d9aac3c3c$export$2e2bcd8739ae039; });

var $8kDQ6 = parcelRequire("8kDQ6");

var $58XrX = parcelRequire("58XrX");

var $drG3N = parcelRequire("drG3N");

var $3RXku = parcelRequire("3RXku");
function $8e32169d9aac3c3c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $58XrX.default)(1, arguments);
    var defaultOptions = (0, $3RXku.getDefaultOptions)();
    var weekStartsOn = (0, $drG3N.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $8kDQ6.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("3RXku", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $2d1457ec5bd30309$export$430a3269e24b912e; });
var $2d1457ec5bd30309$var$defaultOptions = {};
function $2d1457ec5bd30309$export$430a3269e24b912e() {
    return $2d1457ec5bd30309$var$defaultOptions;
}
function $2d1457ec5bd30309$export$95365be1b0704abc(newOptions) {
    $2d1457ec5bd30309$var$defaultOptions = newOptions;
}

});


parcelRegister("72xva", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5202b50fe2f4fb06$export$2e2bcd8739ae039; });

var $fuotl = parcelRequire("fuotl");

var $58XrX = parcelRequire("58XrX");

var $ccU3x = parcelRequire("ccU3x");

var $drG3N = parcelRequire("drG3N");

var $3RXku = parcelRequire("3RXku");
function $5202b50fe2f4fb06$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $58XrX.default)(1, arguments);
    var defaultOptions = (0, $3RXku.getDefaultOptions)();
    var firstWeekContainsDate = (0, $drG3N.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $fuotl.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $ccU3x.default)(firstWeek, options);
    return date;
}

});
parcelRegister("fuotl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b46ca407c5559382$export$2e2bcd8739ae039; });

var $8kDQ6 = parcelRequire("8kDQ6");

var $58XrX = parcelRequire("58XrX");

var $ccU3x = parcelRequire("ccU3x");

var $drG3N = parcelRequire("drG3N");

var $3RXku = parcelRequire("3RXku");
function $b46ca407c5559382$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $58XrX.default)(1, arguments);
    var date = (0, $8kDQ6.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $3RXku.getDefaultOptions)();
    var firstWeekContainsDate = (0, $drG3N.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $ccU3x.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $ccU3x.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("gtUIS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bffb5ac151492e00$export$2e2bcd8739ae039; });
function $bffb5ac151492e00$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("a833g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75fd04b5283e304c$export$2e2bcd8739ae039; });

var $gtUIS = parcelRequire("gtUIS");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $75fd04b5283e304c$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $gtUIS.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $gtUIS.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $gtUIS.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $gtUIS.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $gtUIS.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $gtUIS.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $gtUIS.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $gtUIS.default)(fractionalSeconds, token.length);
    }
};
var $75fd04b5283e304c$export$2e2bcd8739ae039 = $75fd04b5283e304c$var$formatters;

});


parcelRegister("lfAJG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7877eabb69454a2$export$2e2bcd8739ae039; });
var $f7877eabb69454a2$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $f7877eabb69454a2$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $f7877eabb69454a2$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $f7877eabb69454a2$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $f7877eabb69454a2$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $f7877eabb69454a2$var$timeLongFormatter(timePattern, formatLong));
};
var $f7877eabb69454a2$var$longFormatters = {
    p: $f7877eabb69454a2$var$timeLongFormatter,
    P: $f7877eabb69454a2$var$dateTimeLongFormatter
};
var $f7877eabb69454a2$export$2e2bcd8739ae039 = $f7877eabb69454a2$var$longFormatters;

});

parcelRegister("bwYc5", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $8651601ffcf2972a$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $8651601ffcf2972a$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $8651601ffcf2972a$export$8073c1ae88f0e727; });
var $8651601ffcf2972a$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $8651601ffcf2972a$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $8651601ffcf2972a$export$c6cc36aa33304772(token) {
    return $8651601ffcf2972a$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $8651601ffcf2972a$export$c6b49d6dceb604a1(token) {
    return $8651601ffcf2972a$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $8651601ffcf2972a$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("irlOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6cbabf1a70d2855$export$2e2bcd8739ae039; });

var $ePSHp = parcelRequire("ePSHp");
var $d6cbabf1a70d2855$export$2e2bcd8739ae039 = (0, $ePSHp.default);

});
parcelRegister("ePSHp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acd042341eee1062$export$2e2bcd8739ae039; });

var $eYVF9 = parcelRequire("eYVF9");

var $fpV23 = parcelRequire("fpV23");

var $cFfzN = parcelRequire("cFfzN");

var $9hkv4 = parcelRequire("9hkv4");

var $3hGwR = parcelRequire("3hGwR");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $acd042341eee1062$var$locale = {
    code: 'en-US',
    formatDistance: (0, $eYVF9.default),
    formatLong: (0, $fpV23.default),
    formatRelative: (0, $cFfzN.default),
    localize: (0, $9hkv4.default),
    match: (0, $3hGwR.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $acd042341eee1062$export$2e2bcd8739ae039 = $acd042341eee1062$var$locale;

});
parcelRegister("eYVF9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae8365e1b244f131$export$2e2bcd8739ae039; });
var $ae8365e1b244f131$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $ae8365e1b244f131$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ae8365e1b244f131$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $ae8365e1b244f131$export$2e2bcd8739ae039 = $ae8365e1b244f131$var$formatDistance;

});

parcelRegister("fpV23", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3956e3a4d825f88$export$2e2bcd8739ae039; });

var $fQiZR = parcelRequire("fQiZR");
var $b3956e3a4d825f88$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $b3956e3a4d825f88$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $b3956e3a4d825f88$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b3956e3a4d825f88$var$formatLong = {
    date: (0, $fQiZR.default)({
        formats: $b3956e3a4d825f88$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fQiZR.default)({
        formats: $b3956e3a4d825f88$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fQiZR.default)({
        formats: $b3956e3a4d825f88$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b3956e3a4d825f88$export$2e2bcd8739ae039 = $b3956e3a4d825f88$var$formatLong;

});
parcelRegister("fQiZR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b88a72b067fd2372$export$2e2bcd8739ae039; });
function $b88a72b067fd2372$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("cFfzN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9385658948e8ab97$export$2e2bcd8739ae039; });
var $9385658948e8ab97$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $9385658948e8ab97$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9385658948e8ab97$var$formatRelativeLocale[token];
};
var $9385658948e8ab97$export$2e2bcd8739ae039 = $9385658948e8ab97$var$formatRelative;

});

parcelRegister("9hkv4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c159a776070b5bd$export$2e2bcd8739ae039; });

var $HXpXY = parcelRequire("HXpXY");
var $6c159a776070b5bd$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $6c159a776070b5bd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $6c159a776070b5bd$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $6c159a776070b5bd$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $6c159a776070b5bd$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $6c159a776070b5bd$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $6c159a776070b5bd$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $6c159a776070b5bd$var$localize = {
    ordinalNumber: $6c159a776070b5bd$var$ordinalNumber,
    era: (0, $HXpXY.default)({
        values: $6c159a776070b5bd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $HXpXY.default)({
        values: $6c159a776070b5bd$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $HXpXY.default)({
        values: $6c159a776070b5bd$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $HXpXY.default)({
        values: $6c159a776070b5bd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $HXpXY.default)({
        values: $6c159a776070b5bd$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $6c159a776070b5bd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $6c159a776070b5bd$export$2e2bcd8739ae039 = $6c159a776070b5bd$var$localize;

});
parcelRegister("HXpXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08421b6835407629$export$2e2bcd8739ae039; });
function $08421b6835407629$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("3hGwR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2643f3034471f6c2$export$2e2bcd8739ae039; });

var $2mB0S = parcelRequire("2mB0S");

var $jDB1g = parcelRequire("jDB1g");
var $2643f3034471f6c2$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $2643f3034471f6c2$var$parseOrdinalNumberPattern = /\d+/i;
var $2643f3034471f6c2$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $2643f3034471f6c2$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $2643f3034471f6c2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $2643f3034471f6c2$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2643f3034471f6c2$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $2643f3034471f6c2$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $2643f3034471f6c2$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $2643f3034471f6c2$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $2643f3034471f6c2$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $2643f3034471f6c2$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $2643f3034471f6c2$var$match = {
    ordinalNumber: (0, $jDB1g.default)({
        matchPattern: $2643f3034471f6c2$var$matchOrdinalNumberPattern,
        parsePattern: $2643f3034471f6c2$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $2mB0S.default)({
        matchPatterns: $2643f3034471f6c2$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2643f3034471f6c2$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $2mB0S.default)({
        matchPatterns: $2643f3034471f6c2$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2643f3034471f6c2$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $2mB0S.default)({
        matchPatterns: $2643f3034471f6c2$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2643f3034471f6c2$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $2mB0S.default)({
        matchPatterns: $2643f3034471f6c2$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2643f3034471f6c2$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $2mB0S.default)({
        matchPatterns: $2643f3034471f6c2$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2643f3034471f6c2$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2643f3034471f6c2$export$2e2bcd8739ae039 = $2643f3034471f6c2$var$match;

});
parcelRegister("2mB0S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b8a58e3ad6c53eb$export$2e2bcd8739ae039; });
function $1b8a58e3ad6c53eb$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $1b8a58e3ad6c53eb$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $1b8a58e3ad6c53eb$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $1b8a58e3ad6c53eb$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $1b8a58e3ad6c53eb$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("jDB1g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4be601adaf65d5d$export$2e2bcd8739ae039; });
function $e4be601adaf65d5d$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});






parcelRegister("h6Ifu", function(module, exports) {

$parcel$export(module.exports, "eventProduct", function () { return $c745521d4d7b94de$export$a7df4e8088db8843; });
var $c745521d4d7b94de$export$a7df4e8088db8843 = function eventProduct(_config, _data, globalConfig) {
    return {
        'event:product': "".concat(globalConfig.product)
    };
};

});

parcelRegister("8AWkx", function(module, exports) {

$parcel$export(module.exports, "eventRegion", function () { return $641eeeb7d1732abe$export$d0117b71adcdebc0; });
var $641eeeb7d1732abe$export$d0117b71adcdebc0 = function eventRegion(_config, _data, globalConfig) {
    return {
        'event:region': "".concat(globalConfig.region)
    };
};

});

parcelRegister("7QRzP", function(module, exports) {

$parcel$export(module.exports, "eventRoute", function () { return $5b76f2fbe112ac41$export$44d3627af289ca16; });
var $5b76f2fbe112ac41$export$44d3627af289ca16 = function eventRoute(_config, data) {
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("gV7yx", function(module, exports) {

$parcel$export(module.exports, "eventType", function () { return $c517d4ac67445817$export$4c045e605d532c98; });

var $9DIRT = parcelRequire("9DIRT");
var $c517d4ac67445817$export$4c045e605d532c98 = function eventType(config) {
    return {
        'event:type': (0, $9DIRT.mapEventType)(config.type)
    };
};

});

parcelRegister("12dvS", function(module, exports) {

$parcel$export(module.exports, "featureFlags", function () { return $0c1075cc0567cd4a$export$e62953d023125748; });

var $91FVG = parcelRequire("91FVG");
function $0c1075cc0567cd4a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c1075cc0567cd4a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c1075cc0567cd4a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c1075cc0567cd4a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0c1075cc0567cd4a$export$e62953d023125748 = function featureFlags(config, _data, globalConfig) {
    var _config$featureFlags;
    var localFeatureFlags = ((_config$featureFlags = config.featureFlags) === null || _config$featureFlags === void 0 ? void 0 : _config$featureFlags.reduce(function(acc, ffName) {
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {})) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: $0c1075cc0567cd4a$var$_objectSpread($0c1075cc0567cd4a$var$_objectSpread({}, localFeatureFlags), globalConfig.featureFlags)
    };
};

});

parcelRegister("AGx9M", function(module, exports) {

$parcel$export(module.exports, "hostname", function () { return $06e45b3b3ed5dead$export$640106f6dc7d2706; });
var $06e45b3b3ed5dead$export$640106f6dc7d2706 = function hostname(_config, _data, globalConfig) {
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("epDRR", function(module, exports) {

$parcel$export(module.exports, "customEventMetrics", function () { return $a7e25364ed613295$export$cab039265c52a2e9; });

var $jXhOd = parcelRequire("jXhOd");
var $a7e25364ed613295$export$cab039265c52a2e9 = function customEventMetrics(config, data, globalConfig) {
    var _config$slo, _config$histogram;
    if (!(0, $jXhOd.isCustomConfig)(config)) return null;
    var payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (((_config$slo = config.slo) === null || _config$slo === void 0 ? void 0 : _config$slo.threshold) !== undefined) {
        var _config$slo2, _config$slo3;
        payload['metric:duration:slo'] = payload['metric:duration'] <= ((_config$slo2 = config.slo) === null || _config$slo2 === void 0 ? void 0 : _config$slo2.threshold);
        payload['metric:duration:slo:threshold'] = (_config$slo3 = config.slo) === null || _config$slo3 === void 0 ? void 0 : _config$slo3.threshold;
    }
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("8kFR1", function(module, exports) {

$parcel$export(module.exports, "initialPageLoadMetrics", function () { return $6110a85cf1ce3d59$export$cc95aa3f6ea8e5cb; });
var $6110a85cf1ce3d59$export$cc95aa3f6ea8e5cb = function initialPageLoadMetrics() {
    var metrics = {};
    performance.getEntriesByType('paint').forEach(function(entry) {
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("c9dn3", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", function () { return $8d80b27ca586d9ea$export$86db56030b57ba34; });

var $jXhOd = parcelRequire("jXhOd");

var $bo0Gu = parcelRequire("bo0Gu");
var $8d80b27ca586d9ea$export$86db56030b57ba34 = function interactionMetrics(config, data, globalConfig) {
    var _config$histogram;
    if (!(0, $jXhOd.isInteractionConfig)(config)) return null;
    var result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $bo0Gu.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $bo0Gu.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        var _config$histogram2;
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if ((_config$histogram2 = config.histogram) !== null && _config$histogram2 !== void 0 && _config$histogram2.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $bo0Gu.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            var _histogram = globalConfig.histogram;
            if (_histogram.result !== undefined) result['metric:response:histogramBuckets'] = _histogram[(0, $bo0Gu.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $bo0Gu.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("f30KO", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", function () { return $af47b8919a7cec95$export$b88d990436be0f8a; });
var $af47b8919a7cec95$export$b88d990436be0f8a = function navigationMetrics() {
    var entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    var navigation = entries[0];
    var metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("hJp5I", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", function () { return $ce8a1a381417fb7c$export$2878bf482e539059; });

var $jXhOd = parcelRequire("jXhOd");

var $bo0Gu = parcelRequire("bo0Gu");
var $ce8a1a381417fb7c$var$getThreshold = function getThreshold(isInitial, metric) {
    return (0, $bo0Gu.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
var $ce8a1a381417fb7c$var$getHistogram = function getHistogram(isInitial, metric, histogram) {
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
var $ce8a1a381417fb7c$export$2878bf482e539059 = function pageLoadMetrics(config, data, globalConfig) {
    if (!(0, $jXhOd.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    var fmp = data.marks[(0, $bo0Gu.BMPageLoadMetrics).fmp] || data.stop;
    var result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $ce8a1a381417fb7c$var$getHistogram(data.isInitial, (0, $bo0Gu.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $ce8a1a381417fb7c$var$getHistogram(data.isInitial, (0, $bo0Gu.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $ce8a1a381417fb7c$var$getHistogram(data.isInitial, (0, $bo0Gu.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $ce8a1a381417fb7c$var$getHistogram(data.isInitial, (0, $bo0Gu.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        var threshold = $ce8a1a381417fb7c$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        var _threshold = $ce8a1a381417fb7c$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= _threshold;
        result['metric:tti:slo:threshold'] = _threshold;
    }
    return result;
};

});

parcelRegister("27KSL", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoadMetrics", function () { return $18c09a0da88a1d6f$export$ba86cb47f2f22db5; });

var $hougm = parcelRequire("hougm");

var $jXhOd = parcelRequire("jXhOd");

var $bo0Gu = parcelRequire("bo0Gu");
var $18c09a0da88a1d6f$var$getThreshold = function getThreshold(isInitial, metric) {
    return (0, $bo0Gu.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
var $18c09a0da88a1d6f$var$getHistogram = function getHistogram(isInitial, metric, histogram) {
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
var $18c09a0da88a1d6f$export$ba86cb47f2f22db5 = function pageSegmentLoadMetrics(config, data, globalConfig) {
    var _config$slo, _config$slo2;
    if (!(0, $jXhOd.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    var fmp = data.marks[(0, $bo0Gu.BMPageSegmentLoadMetrics).fmp] || data.stop;
    var result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $18c09a0da88a1d6f$var$getHistogram(data.isInitial, (0, $bo0Gu.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $18c09a0da88a1d6f$var$getHistogram(data.isInitial, (0, $bo0Gu.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $18c09a0da88a1d6f$var$getHistogram(data.isInitial, (0, $bo0Gu.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $18c09a0da88a1d6f$var$getHistogram(data.isInitial, (0, $bo0Gu.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if ((_config$slo = config.slo) !== null && _config$slo !== void 0 && _config$slo.fmp) {
        var threshold = $18c09a0da88a1d6f$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if ((_config$slo2 = config.slo) !== null && _config$slo2 !== void 0 && _config$slo2.tti) {
        var _threshold = $18c09a0da88a1d6f$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= _threshold;
        result['metric:tti:slo:threshold'] = _threshold;
    }
    if (config.includePageLoadTimings === (0, $bo0Gu.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $bo0Gu.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        var pageLoadData = (0, $hougm.pageLoadMetaMetric).getData();
        var _fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $bo0Gu.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        var tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: _fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("gFrEF", function(module, exports) {

$parcel$export(module.exports, "webVitalsMetrics", function () { return $c225ed5adc3c63f1$export$3731db279f590f30; });

var $91FVG = parcelRequire("91FVG");

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");

var $1nojc = parcelRequire("1nojc");

var $3X43W = parcelRequire("3X43W");

var $5lzfy = parcelRequire("5lzfy");

var $gTBp0 = parcelRequire("gTBp0");
function $c225ed5adc3c63f1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c225ed5adc3c63f1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c225ed5adc3c63f1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c225ed5adc3c63f1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c225ed5adc3c63f1$export$3731db279f590f30 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(config, data, globalConfig) {
        var _globalConfig$webVita, _globalConfig$webVita2, _globalConfig$webVita3;
        var pageVisibleState, setPageVisibleStateToMixed, ttciEnabled, webVitalMetrics;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    pageVisibleState = data.pageVisibleState;
                    setPageVisibleStateToMixed = function setPageVisibleStateToMixed() {
                        pageVisibleState = (0, $1nojc.PageVisibleState).MIXED;
                    };
                    (0, $3X43W.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
                    ttciEnabled = ((_globalConfig$webVita = globalConfig.webVitals) === null || _globalConfig$webVita === void 0 ? void 0 : _globalConfig$webVita.ttciEnabled) !== undefined ? (_globalConfig$webVita2 = globalConfig.webVitals) === null || _globalConfig$webVita2 === void 0 ? void 0 : _globalConfig$webVita2.ttciEnabled : true;
                    _context.next = 6;
                    return $c225ed5adc3c63f1$export$193ae490b52081dd(ttciEnabled, ((_globalConfig$webVita3 = globalConfig.webVitals) === null || _globalConfig$webVita3 === void 0 ? void 0 : _globalConfig$webVita3.timeout) || 30000);
                case 6:
                    webVitalMetrics = _context.sent;
                    (0, $3X43W.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
                    return _context.abrupt("return", $c225ed5adc3c63f1$var$_objectSpread($c225ed5adc3c63f1$var$_objectSpread({}, webVitalMetrics), {}, {
                        'pageVisible:state': pageVisibleState
                    }, (0, $gTBp0.pageVisibleValue)(config, data, globalConfig)));
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function webVitalsMetrics(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
var $c225ed5adc3c63f1$export$193ae490b52081dd = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(ttciEnabled, timeout) {
        var timeoutWindow;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return ttciEnabled ? (0, $5lzfy.webVitalsObserver).ttciDetermined : Promise.resolve();
                case 2:
                    // wait up to $timeout ms longer for web-vitals until returning
                    timeoutWindow = new Promise(function(resolve) {
                        return setTimeout(resolve, timeout);
                    });
                    _context2.next = 5;
                    return Promise.race([
                        timeoutWindow,
                        (0, $5lzfy.webVitalsObserver).webVitalsDetermined
                    ]);
                case 5:
                    return _context2.abrupt("return", (0, $5lzfy.webVitalsObserver).data);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function webVitalsMetricCustomTimeout(_x4, _x5) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("gTBp0", function(module, exports) {

$parcel$export(module.exports, "pageVisibleValue", function () { return $c4cecbb5cfaf94bb$export$177b923114656380; });

var $1nojc = parcelRequire("1nojc");
var $bo0Gu = parcelRequire("bo0Gu");
var $c4cecbb5cfaf94bb$export$177b923114656380 = function pageVisibleValue(_config, data, globalConfig) {
    var value = globalConfig.pageVisibleValueOrigin === (0, $bo0Gu.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $1nojc.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});


parcelRegister("4LG0h", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", function () { return $378c223de21fcd6f$export$723b4c298aca63af; });
var $378c223de21fcd6f$export$723b4c298aca63af = function pageVisibleState(_config, data) {
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("9Md7z", function(module, exports) {

$parcel$export(module.exports, "productCustomData", function () { return $71e2c653c719179e$export$fa2af6e412815a74; });

var $82V4i = parcelRequire("82V4i");

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");
var $71e2c653c719179e$export$fa2af6e412815a74 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(_config, data, globalConfig) {
        var result, pluginOutputs;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(!globalConfig.custom && !globalConfig.plugins)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 2:
                    result = {};
                    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(function(_ref2) {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref2, 2), key = _ref3[0], value = _ref3[1];
                        result["".concat(globalConfig.product, ":").concat(key)] = value;
                    });
                    if (!globalConfig.plugins) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 7;
                    return Promise.all(globalConfig.plugins.map(function(plugin) {
                        return plugin({
                            start: data.start,
                            stop: data.stop,
                            key: data.key
                        });
                    }));
                case 7:
                    pluginOutputs = _context.sent;
                    pluginOutputs.forEach(function(pluginOutput) {
                        if (pluginOutput === null) return;
                        Object.entries(pluginOutput).forEach(function(_ref4) {
                            var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref4, 2), key = _ref5[0], value = _ref5[1];
                            result["".concat(globalConfig.product, ":").concat(key)] = value;
                        });
                    });
                case 9:
                    return _context.abrupt("return", result);
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function productCustomData(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

});

parcelRegister("c2rsA", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", function () { return $8c3af8f40534c66c$export$fdbea518c19dfa8; });

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");

var $bo0Gu = parcelRequire("bo0Gu");
var $8c3af8f40534c66c$var$retrieveFeatureFlags = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(getFeatureFlags) {
        var featureFlags;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return getFeatureFlags();
                case 3:
                    featureFlags = _context.sent;
                    if (!featureFlags) {
                        _context.next = 6;
                        break;
                    }
                    return _context.abrupt("return", {
                        'ssr:featureFlags': featureFlags
                    });
                case 6:
                    _context.next = 10;
                    break;
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](0);
                case 10:
                    return _context.abrupt("return", null);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function retrieveFeatureFlags(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $8c3af8f40534c66c$export$fdbea518c19dfa8 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(config, _data, globalConfig) {
        var _globalConfig$ssr, _config$ssr, _globalConfig$ssr2, _config$ssr2;
        var includeFeatureFlags;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((_globalConfig$ssr = globalConfig.ssr) !== null && _globalConfig$ssr !== void 0 && _globalConfig$ssr.getFeatureFlags) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 2:
                    includeFeatureFlags = ((_config$ssr = config.ssr) === null || _config$ssr === void 0 ? void 0 : _config$ssr.includeFeatureFlags) || ((_globalConfig$ssr2 = globalConfig.ssr) === null || _globalConfig$ssr2 === void 0 ? void 0 : _globalConfig$ssr2.includeFeatureFlags) || (0, $bo0Gu.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
                    if (!(includeFeatureFlags === (0, $bo0Gu.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.doneAsFmp && includeFeatureFlags === (0, $bo0Gu.IncludeSSRFeatureFlagsConfig).WHEN_FMP)) {
                        _context2.next = 7;
                        break;
                    }
                    _context2.next = 6;
                    return $8c3af8f40534c66c$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
                case 6:
                    return _context2.abrupt("return", _context2.sent);
                case 7:
                    return _context2.abrupt("return", null);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function ssrFeatureFlags(_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

});

parcelRegister("8Ma28", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", function () { return $663a96dfe75d454a$export$a3dc8251cf55b2e0; });
var $663a96dfe75d454a$export$a3dc8251cf55b2e0 = function ssrSuccess(config, _data, globalConfig) {
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("i6n26", function(module, exports) {

$parcel$export(module.exports, "telemetryBrowser", function () { return $d2daa7618065aa82$export$386b10ac64a50b1; });

var $l8r8K = parcelRequire("l8r8K");
var $d2daa7618065aa82$export$386b10ac64a50b1 = function telemetryBrowser() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($l8r8K))).getParser) return null;
    var browser = (0, (/*@__PURE__*/$parcel$interopDefault($l8r8K))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});
parcelRegister("l8r8K", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("a2Ljb", function(module, exports) {

$parcel$export(module.exports, "telemetryCpu", function () { return $74fec9c0c2a715cc$export$9f84cb359ed29139; });
var $74fec9c0c2a715cc$export$9f84cb359ed29139 = function telemetryCpu() {
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("jYdDg", function(module, exports) {

$parcel$export(module.exports, "telemetryMemory", function () { return $e89e3204616f96f1$export$496c14d72b257e07; });
var $e89e3204616f96f1$export$496c14d72b257e07 = function telemetryMemory() {
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("79KsK", function(module, exports) {

$parcel$export(module.exports, "telemetryNetwork", function () { return $535d6a35ac4f3014$export$88bf7b55f7fc4e8e; });
var $535d6a35ac4f3014$export$88bf7b55f7fc4e8e = function telemetryNetwork() {
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("5rxCO", function(module, exports) {

$parcel$export(module.exports, "appTimings", function () { return $3f698e943416bbe1$export$e952f50a4f2d02da; });

var $91FVG = parcelRequire("91FVG");

var $bo0Gu = parcelRequire("bo0Gu");

var $1LPMm = parcelRequire("1LPMm");

var $jh95u = parcelRequire("jh95u");
function $3f698e943416bbe1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f698e943416bbe1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f698e943416bbe1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f698e943416bbe1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f698e943416bbe1$export$e952f50a4f2d02da = function appTimings(config, data, globalConfig) {
    var explicitTimings = config.type === (0, $bo0Gu.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    var timings = (0, $1LPMm.customTimings)(config, data);
    var ssr = config.type === (0, $bo0Gu.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $jh95u.ssrTimings)(config, data, globalConfig) : null;
    var timingsApp = (explicitTimings || timings || ssr) && $3f698e943416bbe1$var$_objectSpread($3f698e943416bbe1$var$_objectSpread($3f698e943416bbe1$var$_objectSpread({}, explicitTimings), timings), ssr);
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("1LPMm", function(module, exports) {

$parcel$export(module.exports, "customTimings", function () { return $14a25877247b3a61$export$6126f85083a72c6e; });

var $c4OjZ = parcelRequire("c4OjZ");
var $14a25877247b3a61$var$retrieveTimings = function retrieveTimings(config, data) {
    var relativeTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var configTimings = config.timings || [];
    var timings = configTimings.reduce(function(entries, timing) {
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        var startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        var duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries["".concat(prefix).concat(timing.key)] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
var $14a25877247b3a61$export$6126f85083a72c6e = function customTimings(config, data) {
    if (!config.timings && data.submetrics.length === 0) return null;
    var timings = $14a25877247b3a61$var$retrieveTimings(config, data);
    data.submetrics.forEach(function(submetric) {
        if (submetric.start !== null && submetric.stop !== null) {
            var submetricPrefix = "include:".concat(submetric.config.key);
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $14a25877247b3a61$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $c4OjZ.NESTED_METRIC_SEPARATOR)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
parcelRegister("c4OjZ", function(module, exports) {

$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", function () { return $8cace4892d52aeb6$export$b98e411ae80c806f; });
var $8cace4892d52aeb6$export$b98e411ae80c806f = '/';

});


parcelRegister("jh95u", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", function () { return $e086a76dc3c82f93$export$130f411261a599c5; });

var $a3ftr = parcelRequire("a3ftr");

var $c4OjZ = parcelRequire("c4OjZ");
var $e086a76dc3c82f93$var$filterEntry = function filterEntry(entry) {
    return !(!entry || (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(entry) !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
var $e086a76dc3c82f93$var$mapEntry = function mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
var $e086a76dc3c82f93$var$SSR_PREFIX = 'ssr';
var $e086a76dc3c82f93$var$mapKey = function mapKey(key) {
    if (key === 'total') return $e086a76dc3c82f93$var$SSR_PREFIX;
    return "".concat($e086a76dc3c82f93$var$SSR_PREFIX).concat((0, $c4OjZ.NESTED_METRIC_SEPARATOR)).concat(key);
};
var $e086a76dc3c82f93$export$130f411261a599c5 = function ssrTimings(_config, _data, globalConfig) {
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    var timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    var ssrTimings = Object.entries(timings).reduce(function(acc, entry) {
        if ($e086a76dc3c82f93$var$filterEntry(entry[1])) acc[$e086a76dc3c82f93$var$mapKey(entry[0])] = $e086a76dc3c82f93$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("eIUDE", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", function () { return $ab811c01ab5ba772$export$1a2bb347935fc536; });

var $82V4i = parcelRequire("82V4i");
var $ab811c01ab5ba772$var$bundleEvalTimingsInternal = function bundleEvalTimingsInternal(_config, data, globalConfig) {
    var _globalConfig$enableB;
    var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;
    var started = {};
    var timings = {};
    var enableBundleEvalTimings = (_globalConfig$enableB = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.enableBundleEvalTimings) !== null && _globalConfig$enableB !== void 0 ? _globalConfig$enableB : true;
    performance.getEntriesByType('mark').forEach(function(mark) {
        if (!globalConfig.bundleEvalTimings) return;
        var result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        var type = result.type, name = result.name;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        var result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(function(_ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
var $ab811c01ab5ba772$export$1a2bb347935fc536 = function bundleEvalTimings() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return new Promise(function(resolve) {
        setTimeout(function() {
            resolve($ab811c01ab5ba772$var$bundleEvalTimingsInternal.apply(void 0, args));
        });
    });
};

});

parcelRegister("7EdFT", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", function () { return $5916e058f93e24d9$export$81a7d52441a06b50; });

var $91FVG = parcelRequire("91FVG");
function $5916e058f93e24d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5916e058f93e24d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5916e058f93e24d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5916e058f93e24d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5916e058f93e24d9$var$cacheableTypes = [
    'script',
    'link'
];
var $5916e058f93e24d9$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
var $5916e058f93e24d9$var$CACHE_NETWORK = 'network';
var $5916e058f93e24d9$var$CACHE_MEMORY = 'memory';
var $5916e058f93e24d9$var$CACHE_DISK = 'disk';
var $5916e058f93e24d9$var$calculateTransferType = function calculateTransferType(type, duration, size) {
    if (!$5916e058f93e24d9$var$cacheableTypes.includes(type)) return $5916e058f93e24d9$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $5916e058f93e24d9$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $5916e058f93e24d9$var$CACHE_DISK;
    if (size === undefined) return null;
    return $5916e058f93e24d9$var$CACHE_NETWORK;
};
var $5916e058f93e24d9$var$hasAccessToResourceSize = function hasAccessToResourceSize(url, type, hasTimingHeaders) {
    return !$5916e058f93e24d9$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
var $5916e058f93e24d9$var$getReportedInitiatorTypes = function getReportedInitiatorTypes(xhrEnabled) {
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
var $5916e058f93e24d9$var$withoutHeaders = function withoutHeaders() {
    return false;
};
var $5916e058f93e24d9$var$evaluateAccessToResourceTimings = function evaluateAccessToResourceTimings(entry) {
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
var $5916e058f93e24d9$var$getEvaluatedTimingHeader = function getEvaluatedTimingHeader(entry) {
    var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $5916e058f93e24d9$var$withoutHeaders;
    if (!enabled) return null;
    var manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    var autoResolution = $5916e058f93e24d9$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
var $5916e058f93e24d9$var$getSizeObject = function getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
};
var $5916e058f93e24d9$var$getNetworkData = function getNetworkData(item, eventStart) {
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $5916e058f93e24d9$var$withoutHeaders;
    var name = item.name, duration = item.duration, size = item.transferSize, type = item.initiatorType, responseStart = item.responseStart;
    var ttfb = Math.round(responseStart - eventStart);
    if (!$5916e058f93e24d9$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($5916e058f93e24d9$var$cacheableTypes.includes(type)) {
        var transferType = $5916e058f93e24d9$var$calculateTransferType(type, duration, size);
        if (!transferType) return $5916e058f93e24d9$var$_objectSpread({
            ttfb: ttfb
        }, $5916e058f93e24d9$var$getSizeObject(size));
        if (transferType !== $5916e058f93e24d9$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return $5916e058f93e24d9$var$_objectSpread({
            ttfb: ttfb,
            transferType: transferType
        }, $5916e058f93e24d9$var$getSizeObject(size));
    }
    return $5916e058f93e24d9$var$_objectSpread({
        ttfb: ttfb
    }, $5916e058f93e24d9$var$getSizeObject(size));
};
var $5916e058f93e24d9$export$81a7d52441a06b50 = function resourceTimings(_config, data, globalConfig) {
    var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;
    if (data.start === null) return null;
    var resources = performance.getEntriesByType('resource').filter(function(entry) {
        return entry.startTime >= data.start;
    });
    if (!resources.length) return null;
    var resourceTiming = {};
    var xhrFilter = globalConfig.resourceTimings.xhrFilter;
    var reportedInitiatorTypes = $5916e058f93e24d9$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach(function(item) {
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        var name = item.name, startTime = item.startTime, duration = item.duration, workerStart = item.workerStart, fetchStart = item.fetchStart, type = item.initiatorType;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        var url = $5916e058f93e24d9$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = $5916e058f93e24d9$var$_objectSpread($5916e058f93e24d9$var$_objectSpread({
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type
        }, $5916e058f93e24d9$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders)), $5916e058f93e24d9$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders));
    });
    return {
        'timings:resource': resourceTiming
    };
};

});


parcelRegister("jCFxN", function(module, exports) {

$parcel$export(module.exports, "makeShareableGlobalConfig", function () { return $e491caba2a333af2$export$5b4fb14409a2a825; });

var $k7uol = parcelRequire("k7uol");

var $91FVG = parcelRequire("91FVG");

var $62ppy = parcelRequire("62ppy");

var $axdfd = parcelRequire("axdfd");

var $bo0Gu = parcelRequire("bo0Gu");
function $e491caba2a333af2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e491caba2a333af2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e491caba2a333af2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e491caba2a333af2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e491caba2a333af2$var$makeFeatureFlags = function makeFeatureFlags(allFeatureFlags, eventTypeFeatureFlags) {
    var featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push.apply(featureFlagsForType, (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(allFeatureFlags));
    if (eventTypeFeatureFlags) featureFlagsForType.push.apply(featureFlagsForType, (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(eventTypeFeatureFlags));
    return featureFlagsForType;
};
var $e491caba2a333af2$var$makeGlobalConfigPerType = function makeGlobalConfigPerType(global, ffClient, allEventsConfig, eventConfig) {
    var _ref, _eventConfig$pageVisi;
    var allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    var eventConfigCustom = eventConfig && eventConfig.custom;
    var custom = (allEventsConfigCustom || eventConfigCustom) && $e491caba2a333af2$var$_objectSpread($e491caba2a333af2$var$_objectSpread({}, allEventsConfigCustom), eventConfigCustom) || undefined;
    var allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    var eventConfigPlugins = eventConfig && eventConfig.plugins;
    var plugins = (allEventsConfigPlugins || eventConfigPlugins) && [].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(allEventsConfigPlugins || []), (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(eventConfigPlugins || [])) || undefined;
    var pageVisibleValueOrigin = (_ref = (_eventConfig$pageVisi = eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.pageVisibleValueOrigin) !== null && _eventConfig$pageVisi !== void 0 ? _eventConfig$pageVisi : allEventsConfig === null || allEventsConfig === void 0 ? void 0 : allEventsConfig.pageVisibleValueOrigin) !== null && _ref !== void 0 ? _ref : (0, $bo0Gu.PageVisibleValueOrigin).documentHidden;
    return Object.freeze($e491caba2a333af2$var$_objectSpread($e491caba2a333af2$var$_objectSpread({}, global), {}, {
        featureFlags: Object.freeze($e491caba2a333af2$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce(function(acc, value) {
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.enableBundleEvalTimings
    }));
};
var $e491caba2a333af2$export$5b4fb14409a2a825 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(globalConfig) {
        var _globalConfig$events$, _globalConfig$events$2, _globalConfig$events$3;
        var ffClient, global;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return globalConfig.plugins.featureFlags.client;
                case 2:
                    ffClient = _context.sent;
                    global = {
                        app: globalConfig.info.app,
                        product: globalConfig.info.product,
                        region: globalConfig.info.region,
                        resourceTimings: globalConfig.plugins.resourceTimings,
                        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
                        ffClient: ffClient,
                        hostname: globalConfig.info.hostname || window.location.hostname,
                        ssr: globalConfig.ssr,
                        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
                        webVitals: {
                            enabled: (_globalConfig$events$ = globalConfig.events[(0, $bo0Gu.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$ === void 0 ? void 0 : _globalConfig$events$.enabled,
                            timeout: (_globalConfig$events$2 = globalConfig.events[(0, $bo0Gu.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$2 === void 0 ? void 0 : _globalConfig$events$2.timeout,
                            ttciEnabled: (_globalConfig$events$3 = globalConfig.events[(0, $bo0Gu.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$3 === void 0 ? void 0 : _globalConfig$events$3.ttciEnabled
                        }
                    };
                    return _context.abrupt("return", (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $bo0Gu.BMEventsType).PAGE_LOAD, $e491caba2a333af2$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $bo0Gu.BMEventsType).PAGE_LOAD])), (0, $bo0Gu.BMEventsType).PAGE_SEGMENT_LOAD, $e491caba2a333af2$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $bo0Gu.BMEventsType).PAGE_SEGMENT_LOAD])), (0, $bo0Gu.BMEventsType).INLINE_RESULT, $e491caba2a333af2$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $bo0Gu.BMEventsType).INLINE_RESULT])), (0, $bo0Gu.BMEventsType).CUSTOM, $e491caba2a333af2$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $bo0Gu.BMEventsType).CUSTOM])), (0, $bo0Gu.BMEventsType).WEB_VITALS, $e491caba2a333af2$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $bo0Gu.BMEventsType).WEB_VITALS])));
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function makeShareableGlobalConfig(_x) {
        return _ref2.apply(this, arguments);
    };
}();

});



parcelRegister("lwrli", function(module, exports) {

$parcel$export(module.exports, "createSearchParams", function () { return $fab1cbc429343e69$export$a2e4e2dcc7b1f22f; });
$parcel$export(module.exports, "createBrowserRouter", function () { return $fab1cbc429343e69$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "RouterProvider", function () { return $fab1cbc429343e69$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Link", function () { return $fab1cbc429343e69$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $fab1cbc429343e69$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("cVnBY")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("cVnBY")).useNavigate; });
/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $9ZCME = parcelRequire("9ZCME");

var $9sFLW = parcelRequire("9sFLW");parcelRequire("cVnBY");
var $9sFLW = parcelRequire("9sFLW");
var $cVnBY = parcelRequire("cVnBY");

var $9sFLW = parcelRequire("9sFLW");
function $fab1cbc429343e69$var$_extends() {
    $fab1cbc429343e69$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fab1cbc429343e69$var$_extends.apply(this, arguments);
}
function $fab1cbc429343e69$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $fab1cbc429343e69$var$defaultMethod = "get";
const $fab1cbc429343e69$var$defaultEncType = "application/x-www-form-urlencoded";
function $fab1cbc429343e69$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $fab1cbc429343e69$var$isButtonElement(object) {
    return $fab1cbc429343e69$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fab1cbc429343e69$var$isFormElement(object) {
    return $fab1cbc429343e69$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fab1cbc429343e69$var$isInputElement(object) {
    return $fab1cbc429343e69$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fab1cbc429343e69$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fab1cbc429343e69$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fab1cbc429343e69$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $fab1cbc429343e69$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fab1cbc429343e69$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $fab1cbc429343e69$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $fab1cbc429343e69$var$_formDataSupportsSubmitter = null;
function $fab1cbc429343e69$var$isFormDataSubmitterSupported() {
    if ($fab1cbc429343e69$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fab1cbc429343e69$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fab1cbc429343e69$var$_formDataSupportsSubmitter = true;
    }
    return $fab1cbc429343e69$var$_formDataSupportsSubmitter;
}
const $fab1cbc429343e69$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fab1cbc429343e69$var$getFormEncType(encType) {
    if (encType != null && !$fab1cbc429343e69$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $fab1cbc429343e69$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($fab1cbc429343e69$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $9sFLW.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $fab1cbc429343e69$var$defaultMethod;
        encType = $fab1cbc429343e69$var$getFormEncType(target.getAttribute("enctype")) || $fab1cbc429343e69$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fab1cbc429343e69$var$isButtonElement(target) || $fab1cbc429343e69$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $9sFLW.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fab1cbc429343e69$var$defaultMethod;
        encType = $fab1cbc429343e69$var$getFormEncType(target.getAttribute("formenctype")) || $fab1cbc429343e69$var$getFormEncType(form.getAttribute("enctype")) || $fab1cbc429343e69$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$fab1cbc429343e69$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fab1cbc429343e69$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $fab1cbc429343e69$var$defaultMethod;
        action = null;
        encType = $fab1cbc429343e69$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $fab1cbc429343e69$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $fab1cbc429343e69$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $fab1cbc429343e69$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $fab1cbc429343e69$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $fab1cbc429343e69$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $fab1cbc429343e69$export$1f3f55432a00e06d(routes, opts) {
    return (0, $9sFLW.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fab1cbc429343e69$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9sFLW.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fab1cbc429343e69$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $cVnBY.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fab1cbc429343e69$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $9sFLW.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fab1cbc429343e69$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9sFLW.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fab1cbc429343e69$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $cVnBY.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fab1cbc429343e69$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $fab1cbc429343e69$var$_extends({}, state, {
        errors: $fab1cbc429343e69$var$deserializeErrors(state.errors)
    });
    return state;
}
function $fab1cbc429343e69$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $9sFLW.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $fab1cbc429343e69$export$7ad602f0e94e62d1 = /*#__PURE__*/ $dNMDr.createContext({
    isTransitioning: false
});
const $fab1cbc429343e69$export$148fd98d095596d4 = /*#__PURE__*/ $dNMDr.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $fab1cbc429343e69$var$START_TRANSITION = "startTransition";
const $fab1cbc429343e69$var$startTransitionImpl = $dNMDr[$fab1cbc429343e69$var$START_TRANSITION];
const $fab1cbc429343e69$var$FLUSH_SYNC = "flushSync";
const $fab1cbc429343e69$var$flushSyncImpl = $9ZCME[$fab1cbc429343e69$var$FLUSH_SYNC];
const $fab1cbc429343e69$var$USE_ID = "useId";
const $fab1cbc429343e69$var$useIdImpl = $dNMDr[$fab1cbc429343e69$var$USE_ID];
function $fab1cbc429343e69$var$startTransitionSafe(cb) {
    if ($fab1cbc429343e69$var$startTransitionImpl) $fab1cbc429343e69$var$startTransitionImpl(cb);
    else cb();
}
function $fab1cbc429343e69$var$flushSyncSafe(cb) {
    if ($fab1cbc429343e69$var$flushSyncImpl) $fab1cbc429343e69$var$flushSyncImpl(cb);
    else cb();
}
class $fab1cbc429343e69$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $fab1cbc429343e69$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $dNMDr.useState(router.state);
    let [pendingState, setPendingState] = $dNMDr.useState();
    let [vtContext, setVtContext] = $dNMDr.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $dNMDr.useState();
    let [transition, setTransition] = $dNMDr.useState();
    let [interruption, setInterruption] = $dNMDr.useState();
    let fetcherData = $dNMDr.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $dNMDr.useCallback((cb)=>{
        if (v7_startTransition) $fab1cbc429343e69$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $dNMDr.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $fab1cbc429343e69$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $fab1cbc429343e69$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $fab1cbc429343e69$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $fab1cbc429343e69$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $fab1cbc429343e69$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dNMDr.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $dNMDr.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $fab1cbc429343e69$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $dNMDr.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $dNMDr.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $dNMDr.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $dNMDr.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $dNMDr.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dNMDr.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $dNMDr.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $dNMDr.useEffect(()=>(0, $cVnBY.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dNMDr.createElement($dNMDr.Fragment, null, /*#__PURE__*/ $dNMDr.createElement((0, $cVnBY.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dNMDr.createElement((0, $cVnBY.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $dNMDr.createElement($fab1cbc429343e69$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $dNMDr.createElement($fab1cbc429343e69$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $dNMDr.createElement((0, $cVnBY.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dNMDr.createElement($fab1cbc429343e69$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $fab1cbc429343e69$var$MemoizedDataRoutes = /*#__PURE__*/ $dNMDr.memo($fab1cbc429343e69$var$DataRoutes);
function $fab1cbc429343e69$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $cVnBY.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $fab1cbc429343e69$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $dNMDr.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9sFLW.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dNMDr.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dNMDr.useCallback((newState)=>{
        v7_startTransition && $fab1cbc429343e69$var$startTransitionImpl ? $fab1cbc429343e69$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dNMDr.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $dNMDr.useEffect(()=>(0, $cVnBY.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $dNMDr.createElement((0, $cVnBY.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $fab1cbc429343e69$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $dNMDr.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9sFLW.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dNMDr.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dNMDr.useCallback((newState)=>{
        v7_startTransition && $fab1cbc429343e69$var$startTransitionImpl ? $fab1cbc429343e69$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dNMDr.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $dNMDr.useEffect(()=>(0, $cVnBY.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $dNMDr.createElement((0, $cVnBY.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $fab1cbc429343e69$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $dNMDr.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dNMDr.useCallback((newState)=>{
        v7_startTransition && $fab1cbc429343e69$var$startTransitionImpl ? $fab1cbc429343e69$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dNMDr.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $dNMDr.useEffect(()=>(0, $cVnBY.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $dNMDr.createElement((0, $cVnBY.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $fab1cbc429343e69$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $fab1cbc429343e69$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $fab1cbc429343e69$export$a6c7ac8248d6e38a = /*#__PURE__*/ $dNMDr.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $fab1cbc429343e69$var$_objectWithoutPropertiesLoose(_ref7, $fab1cbc429343e69$var$_excluded);
    let { basename: basename } = $dNMDr.useContext((0, $cVnBY.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $fab1cbc429343e69$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($fab1cbc429343e69$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $9sFLW.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $cVnBY.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $fab1cbc429343e69$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $dNMDr.createElement("a", $fab1cbc429343e69$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $fab1cbc429343e69$export$b0d92dbee9b5b60d = /*#__PURE__*/ $dNMDr.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $fab1cbc429343e69$var$_objectWithoutPropertiesLoose(_ref8, $fab1cbc429343e69$var$_excluded2);
    let path = (0, $cVnBY.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $cVnBY.useLocation)();
    let routerState = $dNMDr.useContext((0, $cVnBY.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $dNMDr.useContext((0, $cVnBY.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fab1cbc429343e69$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $9sFLW.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $dNMDr.createElement($fab1cbc429343e69$export$a6c7ac8248d6e38a, $fab1cbc429343e69$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $fab1cbc429343e69$export$a7fed597f4b8afd8 = /*#__PURE__*/ $dNMDr.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $fab1cbc429343e69$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $fab1cbc429343e69$var$_objectWithoutPropertiesLoose(_ref9, $fab1cbc429343e69$var$_excluded3);
    let submit = $fab1cbc429343e69$export$47c85c6e3a081d3();
    let formAction = $fab1cbc429343e69$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $dNMDr.createElement("form", $fab1cbc429343e69$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $fab1cbc429343e69$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $fab1cbc429343e69$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $fab1cbc429343e69$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($fab1cbc429343e69$var$DataRouterHook || ($fab1cbc429343e69$var$DataRouterHook = {}));
var $fab1cbc429343e69$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($fab1cbc429343e69$var$DataRouterStateHook || ($fab1cbc429343e69$var$DataRouterStateHook = {}));
// Internal hooks
function $fab1cbc429343e69$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $fab1cbc429343e69$var$useDataRouterContext(hookName) {
    let ctx = $dNMDr.useContext((0, $cVnBY.UNSAFE_DataRouterContext));
    !ctx && (0, $9sFLW.UNSAFE_invariant)(false);
    return ctx;
}
function $fab1cbc429343e69$var$useDataRouterState(hookName) {
    let state = $dNMDr.useContext((0, $cVnBY.UNSAFE_DataRouterStateContext));
    !state && (0, $9sFLW.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $fab1cbc429343e69$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $cVnBY.useNavigate)();
    let location = (0, $cVnBY.useLocation)();
    let path = (0, $cVnBY.useResolvedPath)(to, {
        relative: relative
    });
    return $dNMDr.useCallback((event)=>{
        if ($fab1cbc429343e69$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $9sFLW.createPath)(location) === (0, $9sFLW.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $fab1cbc429343e69$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $dNMDr.useRef($fab1cbc429343e69$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $dNMDr.useRef(false);
    let location = (0, $cVnBY.useLocation)();
    let searchParams = $dNMDr.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fab1cbc429343e69$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $cVnBY.useNavigate)();
    let setSearchParams = $dNMDr.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $fab1cbc429343e69$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $fab1cbc429343e69$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $fab1cbc429343e69$var$fetcherId = 0;
let $fab1cbc429343e69$var$getUniqueFetcherId = ()=>"__" + String(++$fab1cbc429343e69$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $fab1cbc429343e69$export$47c85c6e3a081d3() {
    let { router: router } = $fab1cbc429343e69$var$useDataRouterContext($fab1cbc429343e69$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $dNMDr.useContext((0, $cVnBY.UNSAFE_NavigationContext));
    let currentRouteId = (0, $cVnBY.UNSAFE_useRouteId)();
    return $dNMDr.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $fab1cbc429343e69$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $fab1cbc429343e69$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $fab1cbc429343e69$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $fab1cbc429343e69$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $dNMDr.useContext((0, $cVnBY.UNSAFE_NavigationContext));
    let routeContext = $dNMDr.useContext((0, $cVnBY.UNSAFE_RouteContext));
    !routeContext && (0, $9sFLW.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $fab1cbc429343e69$var$_extends({}, (0, $cVnBY.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $cVnBY.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9sFLW.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $9sFLW.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $fab1cbc429343e69$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $fab1cbc429343e69$var$useDataRouterContext($fab1cbc429343e69$var$DataRouterHook.UseFetcher);
    let state = $fab1cbc429343e69$var$useDataRouterState($fab1cbc429343e69$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $dNMDr.useContext($fab1cbc429343e69$export$148fd98d095596d4);
    let route = $dNMDr.useContext((0, $cVnBY.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $9sFLW.UNSAFE_invariant)(false);
    !route && (0, $9sFLW.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $9sFLW.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $fab1cbc429343e69$var$useIdImpl ? $fab1cbc429343e69$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $dNMDr.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($fab1cbc429343e69$var$getUniqueFetcherId());
    // Registration/cleanup
    $dNMDr.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $dNMDr.useCallback((href, opts)=>{
        !routeId && (0, $9sFLW.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $fab1cbc429343e69$export$47c85c6e3a081d3();
    let submit = $dNMDr.useCallback((target, opts)=>{
        submitImpl(target, $fab1cbc429343e69$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $dNMDr.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $dNMDr.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $dNMDr.createElement($fab1cbc429343e69$export$a7fed597f4b8afd8, $fab1cbc429343e69$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $9sFLW.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $dNMDr.useMemo(()=>$fab1cbc429343e69$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $fab1cbc429343e69$export$fa996778a3a31087() {
    let state = $fab1cbc429343e69$var$useDataRouterState($fab1cbc429343e69$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $fab1cbc429343e69$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $fab1cbc429343e69$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $fab1cbc429343e69$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $fab1cbc429343e69$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $fab1cbc429343e69$var$useDataRouterContext($fab1cbc429343e69$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $fab1cbc429343e69$var$useDataRouterState($fab1cbc429343e69$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $dNMDr.useContext((0, $cVnBY.UNSAFE_NavigationContext));
    let location = (0, $cVnBY.useLocation)();
    let matches = (0, $cVnBY.useMatches)();
    let navigation = (0, $cVnBY.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $dNMDr.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $fab1cbc429343e69$var$usePageHide($dNMDr.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $fab1cbc429343e69$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $fab1cbc429343e69$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fab1cbc429343e69$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dNMDr.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $fab1cbc429343e69$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fab1cbc429343e69$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dNMDr.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($fab1cbc429343e69$var$_extends({}, location, {
                    pathname: (0, $9sFLW.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($fab1cbc429343e69$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dNMDr.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fab1cbc429343e69$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $dNMDr.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fab1cbc429343e69$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $dNMDr.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $fab1cbc429343e69$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $cVnBY.useBlocker)(when);
    $dNMDr.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $dNMDr.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $fab1cbc429343e69$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $dNMDr.useContext($fab1cbc429343e69$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $9sFLW.UNSAFE_invariant)(false);
    let { basename: basename } = $fab1cbc429343e69$var$useDataRouterContext($fab1cbc429343e69$var$DataRouterHook.useViewTransitionState);
    let path = (0, $cVnBY.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $9sFLW.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $9sFLW.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $9sFLW.matchPath)(path.pathname, nextPath) != null || (0, $9sFLW.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("9sFLW", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $6e3721b26ba435e6$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $6e3721b26ba435e6$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $6e3721b26ba435e6$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $6e3721b26ba435e6$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $6e3721b26ba435e6$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $6e3721b26ba435e6$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $6e3721b26ba435e6$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $6e3721b26ba435e6$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $6e3721b26ba435e6$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $6e3721b26ba435e6$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $6e3721b26ba435e6$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $6e3721b26ba435e6$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $6e3721b26ba435e6$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $6e3721b26ba435e6$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $6e3721b26ba435e6$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $6e3721b26ba435e6$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $6e3721b26ba435e6$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $6e3721b26ba435e6$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $6e3721b26ba435e6$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $6e3721b26ba435e6$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $6e3721b26ba435e6$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $6e3721b26ba435e6$var$_extends() {
    $6e3721b26ba435e6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6e3721b26ba435e6$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $6e3721b26ba435e6$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($6e3721b26ba435e6$export$e19cd5f9376f8cee || ($6e3721b26ba435e6$export$e19cd5f9376f8cee = {}));
const $6e3721b26ba435e6$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $6e3721b26ba435e6$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $6e3721b26ba435e6$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $6e3721b26ba435e6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $6e3721b26ba435e6$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $6e3721b26ba435e6$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $6e3721b26ba435e6$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $6e3721b26ba435e6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $6e3721b26ba435e6$export$fe53371bee54353d(to);
    }
    return $6e3721b26ba435e6$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $6e3721b26ba435e6$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $6e3721b26ba435e6$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $6e3721b26ba435e6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $6e3721b26ba435e6$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $6e3721b26ba435e6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $6e3721b26ba435e6$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $6e3721b26ba435e6$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $6e3721b26ba435e6$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $6e3721b26ba435e6$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $6e3721b26ba435e6$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $6e3721b26ba435e6$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $6e3721b26ba435e6$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $6e3721b26ba435e6$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $6e3721b26ba435e6$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $6e3721b26ba435e6$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $6e3721b26ba435e6$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $6e3721b26ba435e6$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($6e3721b26ba435e6$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Push;
        let location = $6e3721b26ba435e6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $6e3721b26ba435e6$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Replace;
        let location = $6e3721b26ba435e6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $6e3721b26ba435e6$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $6e3721b26ba435e6$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $6e3721b26ba435e6$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($6e3721b26ba435e6$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($6e3721b26ba435e6$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $6e3721b26ba435e6$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($6e3721b26ba435e6$var$ResultType || ($6e3721b26ba435e6$var$ResultType = {}));
const $6e3721b26ba435e6$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $6e3721b26ba435e6$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $6e3721b26ba435e6$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $6e3721b26ba435e6$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $6e3721b26ba435e6$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($6e3721b26ba435e6$var$isIndexRoute(route)) {
            let indexRoute = $6e3721b26ba435e6$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $6e3721b26ba435e6$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $6e3721b26ba435e6$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $6e3721b26ba435e6$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $6e3721b26ba435e6$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $6e3721b26ba435e6$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $6e3721b26ba435e6$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $6e3721b26ba435e6$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $6e3721b26ba435e6$var$flattenRoutes(routes);
    $6e3721b26ba435e6$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $6e3721b26ba435e6$export$30d21fd6d7295f52(pathname);
        matches = $6e3721b26ba435e6$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $6e3721b26ba435e6$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $6e3721b26ba435e6$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $6e3721b26ba435e6$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $6e3721b26ba435e6$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $6e3721b26ba435e6$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $6e3721b26ba435e6$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $6e3721b26ba435e6$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $6e3721b26ba435e6$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $6e3721b26ba435e6$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $6e3721b26ba435e6$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $6e3721b26ba435e6$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $6e3721b26ba435e6$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $6e3721b26ba435e6$var$paramRe = /^:[\w-]+$/;
const $6e3721b26ba435e6$var$dynamicSegmentValue = 3;
const $6e3721b26ba435e6$var$indexRouteValue = 2;
const $6e3721b26ba435e6$var$emptySegmentValue = 1;
const $6e3721b26ba435e6$var$staticSegmentValue = 10;
const $6e3721b26ba435e6$var$splatPenalty = -2;
const $6e3721b26ba435e6$var$isSplat = (s)=>s === "*";
function $6e3721b26ba435e6$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($6e3721b26ba435e6$var$isSplat)) initialScore += $6e3721b26ba435e6$var$splatPenalty;
    if (index) initialScore += $6e3721b26ba435e6$var$indexRouteValue;
    return segments.filter((s)=>!$6e3721b26ba435e6$var$isSplat(s)).reduce((score, segment)=>score + ($6e3721b26ba435e6$var$paramRe.test(segment) ? $6e3721b26ba435e6$var$dynamicSegmentValue : segment === "" ? $6e3721b26ba435e6$var$emptySegmentValue : $6e3721b26ba435e6$var$staticSegmentValue), initialScore);
}
function $6e3721b26ba435e6$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $6e3721b26ba435e6$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $6e3721b26ba435e6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $6e3721b26ba435e6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $6e3721b26ba435e6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $6e3721b26ba435e6$export$a5c6d149b50c1d86($6e3721b26ba435e6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $6e3721b26ba435e6$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $6e3721b26ba435e6$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $6e3721b26ba435e6$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $6e3721b26ba435e6$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $6e3721b26ba435e6$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $6e3721b26ba435e6$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $6e3721b26ba435e6$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $6e3721b26ba435e6$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $6e3721b26ba435e6$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $6e3721b26ba435e6$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $6e3721b26ba435e6$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $6e3721b26ba435e6$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $6e3721b26ba435e6$var$isAbsoluteUrl = (url)=>$6e3721b26ba435e6$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $6e3721b26ba435e6$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $6e3721b26ba435e6$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($6e3721b26ba435e6$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $6e3721b26ba435e6$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $6e3721b26ba435e6$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $6e3721b26ba435e6$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $6e3721b26ba435e6$var$normalizeSearch(search),
        hash: $6e3721b26ba435e6$var$normalizeHash(hash)
    };
}
function $6e3721b26ba435e6$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $6e3721b26ba435e6$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $6e3721b26ba435e6$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $6e3721b26ba435e6$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $6e3721b26ba435e6$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $6e3721b26ba435e6$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $6e3721b26ba435e6$export$8ccf933b0513f8d0(toArg);
    else {
        to = $6e3721b26ba435e6$var$_extends({}, toArg);
        $6e3721b26ba435e6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $6e3721b26ba435e6$var$getInvalidPathError("?", "pathname", "search", to));
        $6e3721b26ba435e6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $6e3721b26ba435e6$var$getInvalidPathError("#", "pathname", "hash", to));
        $6e3721b26ba435e6$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $6e3721b26ba435e6$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $6e3721b26ba435e6$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $6e3721b26ba435e6$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $6e3721b26ba435e6$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $6e3721b26ba435e6$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $6e3721b26ba435e6$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $6e3721b26ba435e6$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $6e3721b26ba435e6$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $6e3721b26ba435e6$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $6e3721b26ba435e6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $6e3721b26ba435e6$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $6e3721b26ba435e6$export$4051a07651545597(data, init) {
    return new $6e3721b26ba435e6$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $6e3721b26ba435e6$export$42a99a7a4bc0e76a extends Error {
}
class $6e3721b26ba435e6$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $6e3721b26ba435e6$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $6e3721b26ba435e6$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $6e3721b26ba435e6$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $6e3721b26ba435e6$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $6e3721b26ba435e6$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $6e3721b26ba435e6$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $6e3721b26ba435e6$var$unwrapTrackedPromise(value) {
    if (!$6e3721b26ba435e6$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $6e3721b26ba435e6$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $6e3721b26ba435e6$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6e3721b26ba435e6$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $6e3721b26ba435e6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6e3721b26ba435e6$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $6e3721b26ba435e6$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6e3721b26ba435e6$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $6e3721b26ba435e6$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $6e3721b26ba435e6$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $6e3721b26ba435e6$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $6e3721b26ba435e6$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $6e3721b26ba435e6$var$validMutationMethods = new Set($6e3721b26ba435e6$var$validMutationMethodsArr);
const $6e3721b26ba435e6$var$validRequestMethodsArr = [
    "get",
    ...$6e3721b26ba435e6$var$validMutationMethodsArr
];
const $6e3721b26ba435e6$var$validRequestMethods = new Set($6e3721b26ba435e6$var$validRequestMethodsArr);
const $6e3721b26ba435e6$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $6e3721b26ba435e6$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $6e3721b26ba435e6$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $6e3721b26ba435e6$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $6e3721b26ba435e6$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $6e3721b26ba435e6$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $6e3721b26ba435e6$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $6e3721b26ba435e6$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $6e3721b26ba435e6$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $6e3721b26ba435e6$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $6e3721b26ba435e6$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $6e3721b26ba435e6$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $6e3721b26ba435e6$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $6e3721b26ba435e6$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $6e3721b26ba435e6$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $6e3721b26ba435e6$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $6e3721b26ba435e6$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$6e3721b26ba435e6$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$6e3721b26ba435e6$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $6e3721b26ba435e6$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $6e3721b26ba435e6$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $6e3721b26ba435e6$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $6e3721b26ba435e6$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$6e3721b26ba435e6$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($6e3721b26ba435e6$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $6e3721b26ba435e6$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $6e3721b26ba435e6$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $6e3721b26ba435e6$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $6e3721b26ba435e6$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $6e3721b26ba435e6$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $6e3721b26ba435e6$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $6e3721b26ba435e6$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $6e3721b26ba435e6$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $6e3721b26ba435e6$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($6e3721b26ba435e6$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $6e3721b26ba435e6$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $6e3721b26ba435e6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $6e3721b26ba435e6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $6e3721b26ba435e6$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $6e3721b26ba435e6$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $6e3721b26ba435e6$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $6e3721b26ba435e6$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $6e3721b26ba435e6$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $6e3721b26ba435e6$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $6e3721b26ba435e6$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $6e3721b26ba435e6$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $6e3721b26ba435e6$var$findNearestBoundary(matches).route.id,
            {
                type: $6e3721b26ba435e6$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $6e3721b26ba435e6$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($6e3721b26ba435e6$var$isErrorResult(result) && $6e3721b26ba435e6$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $6e3721b26ba435e6$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $6e3721b26ba435e6$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $6e3721b26ba435e6$var$_extends({
            matches: updatedMatches || matches
        }, $6e3721b26ba435e6$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $6e3721b26ba435e6$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $6e3721b26ba435e6$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $6e3721b26ba435e6$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $6e3721b26ba435e6$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $6e3721b26ba435e6$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $6e3721b26ba435e6$var$ResultType.error,
            error: $6e3721b26ba435e6$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($6e3721b26ba435e6$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $6e3721b26ba435e6$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($6e3721b26ba435e6$var$isDeferredResult(result)) throw $6e3721b26ba435e6$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($6e3721b26ba435e6$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $6e3721b26ba435e6$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $6e3721b26ba435e6$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $6e3721b26ba435e6$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $6e3721b26ba435e6$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($6e3721b26ba435e6$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $6e3721b26ba435e6$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $6e3721b26ba435e6$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $6e3721b26ba435e6$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $6e3721b26ba435e6$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $6e3721b26ba435e6$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $6e3721b26ba435e6$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $6e3721b26ba435e6$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $6e3721b26ba435e6$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $6e3721b26ba435e6$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $6e3721b26ba435e6$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$6e3721b26ba435e6$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $6e3721b26ba435e6$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $6e3721b26ba435e6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $6e3721b26ba435e6$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $6e3721b26ba435e6$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $6e3721b26ba435e6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $6e3721b26ba435e6$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $6e3721b26ba435e6$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $6e3721b26ba435e6$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6e3721b26ba435e6$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $6e3721b26ba435e6$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $6e3721b26ba435e6$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $6e3721b26ba435e6$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($6e3721b26ba435e6$var$isRedirectResult(actionResult) || $6e3721b26ba435e6$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $6e3721b26ba435e6$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($6e3721b26ba435e6$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $6e3721b26ba435e6$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $6e3721b26ba435e6$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($6e3721b26ba435e6$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($6e3721b26ba435e6$var$isDeferredResult(actionResult)) throw $6e3721b26ba435e6$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $6e3721b26ba435e6$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $6e3721b26ba435e6$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $6e3721b26ba435e6$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $6e3721b26ba435e6$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $6e3721b26ba435e6$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $6e3721b26ba435e6$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $6e3721b26ba435e6$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $6e3721b26ba435e6$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $6e3721b26ba435e6$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $6e3721b26ba435e6$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $6e3721b26ba435e6$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $6e3721b26ba435e6$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6e3721b26ba435e6$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $6e3721b26ba435e6$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $6e3721b26ba435e6$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $6e3721b26ba435e6$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($6e3721b26ba435e6$var$isDeferredResult(result)) result = await $6e3721b26ba435e6$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $6e3721b26ba435e6$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($6e3721b26ba435e6$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $6e3721b26ba435e6$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($6e3721b26ba435e6$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $6e3721b26ba435e6$export$3e9cee6b33872309(!$6e3721b26ba435e6$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $6e3721b26ba435e6$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $6e3721b26ba435e6$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $6e3721b26ba435e6$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $6e3721b26ba435e6$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($6e3721b26ba435e6$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $6e3721b26ba435e6$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $6e3721b26ba435e6$export$e19cd5f9376f8cee.Replace : $6e3721b26ba435e6$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $6e3721b26ba435e6$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($6e3721b26ba435e6$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $6e3721b26ba435e6$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $6e3721b26ba435e6$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $6e3721b26ba435e6$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $6e3721b26ba435e6$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $6e3721b26ba435e6$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($6e3721b26ba435e6$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $6e3721b26ba435e6$var$ResultType.redirect,
                response: $6e3721b26ba435e6$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $6e3721b26ba435e6$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $6e3721b26ba435e6$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $6e3721b26ba435e6$var$ResultType.error,
                    error: $6e3721b26ba435e6$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $6e3721b26ba435e6$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $6e3721b26ba435e6$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $6e3721b26ba435e6$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $6e3721b26ba435e6$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $6e3721b26ba435e6$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $6e3721b26ba435e6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $6e3721b26ba435e6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $6e3721b26ba435e6$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $6e3721b26ba435e6$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $6e3721b26ba435e6$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $6e3721b26ba435e6$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $6e3721b26ba435e6$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $6e3721b26ba435e6$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $6e3721b26ba435e6$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$6e3721b26ba435e6$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $6e3721b26ba435e6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $6e3721b26ba435e6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $6e3721b26ba435e6$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $6e3721b26ba435e6$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $6e3721b26ba435e6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $6e3721b26ba435e6$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $6e3721b26ba435e6$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $6e3721b26ba435e6$export$4d0306f8f6a4585b = Symbol("deferred");
function $6e3721b26ba435e6$export$3336b097a6fbc59a(routes, opts) {
    $6e3721b26ba435e6$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $6e3721b26ba435e6$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $6e3721b26ba435e6$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $6e3721b26ba435e6$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $6e3721b26ba435e6$var$createLocation("", $6e3721b26ba435e6$export$fe53371bee54353d(url), null, "default");
        let matches = $6e3721b26ba435e6$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$6e3721b26ba435e6$var$isValidMethod(method) && method !== "HEAD") {
            let error = $6e3721b26ba435e6$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $6e3721b26ba435e6$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $6e3721b26ba435e6$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $6e3721b26ba435e6$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($6e3721b26ba435e6$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $6e3721b26ba435e6$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $6e3721b26ba435e6$var$createLocation("", $6e3721b26ba435e6$export$fe53371bee54353d(url), null, "default");
        let matches = $6e3721b26ba435e6$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$6e3721b26ba435e6$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $6e3721b26ba435e6$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $6e3721b26ba435e6$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $6e3721b26ba435e6$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $6e3721b26ba435e6$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $6e3721b26ba435e6$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($6e3721b26ba435e6$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$6e3721b26ba435e6$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $6e3721b26ba435e6$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($6e3721b26ba435e6$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $6e3721b26ba435e6$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $6e3721b26ba435e6$var$isResponse(result) ? result : $6e3721b26ba435e6$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($6e3721b26ba435e6$var$isDataStrategyResult(e) && $6e3721b26ba435e6$var$isResponse(e.result)) {
                if (e.type === $6e3721b26ba435e6$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($6e3721b26ba435e6$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $6e3721b26ba435e6$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $6e3721b26ba435e6$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $6e3721b26ba435e6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($6e3721b26ba435e6$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($6e3721b26ba435e6$var$isDeferredResult(result)) {
            let error = $6e3721b26ba435e6$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $6e3721b26ba435e6$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($6e3721b26ba435e6$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($6e3721b26ba435e6$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $6e3721b26ba435e6$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $6e3721b26ba435e6$var$_extends({}, context, {
                statusCode: $6e3721b26ba435e6$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $6e3721b26ba435e6$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $6e3721b26ba435e6$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $6e3721b26ba435e6$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $6e3721b26ba435e6$var$isErrorResult(pendingActionResult[1]) ? $6e3721b26ba435e6$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $6e3721b26ba435e6$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $6e3721b26ba435e6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $6e3721b26ba435e6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $6e3721b26ba435e6$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $6e3721b26ba435e6$var$callDataStrategyImpl(dataStrategy || $6e3721b26ba435e6$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($6e3721b26ba435e6$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $6e3721b26ba435e6$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($6e3721b26ba435e6$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $6e3721b26ba435e6$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $6e3721b26ba435e6$export$fec11da027c70692(routes, context, error) {
    let newContext = $6e3721b26ba435e6$var$_extends({}, context, {
        statusCode: $6e3721b26ba435e6$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $6e3721b26ba435e6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $6e3721b26ba435e6$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $6e3721b26ba435e6$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $6e3721b26ba435e6$export$cae722b0cc860f13(to ? to : ".", $6e3721b26ba435e6$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $6e3721b26ba435e6$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $6e3721b26ba435e6$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $6e3721b26ba435e6$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $6e3721b26ba435e6$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $6e3721b26ba435e6$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$6e3721b26ba435e6$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$6e3721b26ba435e6$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $6e3721b26ba435e6$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $6e3721b26ba435e6$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $6e3721b26ba435e6$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$6e3721b26ba435e6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$6e3721b26ba435e6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $6e3721b26ba435e6$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $6e3721b26ba435e6$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $6e3721b26ba435e6$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $6e3721b26ba435e6$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $6e3721b26ba435e6$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($6e3721b26ba435e6$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $6e3721b26ba435e6$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $6e3721b26ba435e6$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $6e3721b26ba435e6$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $6e3721b26ba435e6$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $6e3721b26ba435e6$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $6e3721b26ba435e6$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $6e3721b26ba435e6$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $6e3721b26ba435e6$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $6e3721b26ba435e6$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $6e3721b26ba435e6$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($6e3721b26ba435e6$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $6e3721b26ba435e6$var$shouldRevalidateLoader(match, $6e3721b26ba435e6$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $6e3721b26ba435e6$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $6e3721b26ba435e6$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $6e3721b26ba435e6$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $6e3721b26ba435e6$var$shouldRevalidateLoader(fetcherMatch, $6e3721b26ba435e6$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $6e3721b26ba435e6$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $6e3721b26ba435e6$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $6e3721b26ba435e6$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $6e3721b26ba435e6$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $6e3721b26ba435e6$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $6e3721b26ba435e6$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$6e3721b26ba435e6$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $6e3721b26ba435e6$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $6e3721b26ba435e6$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$6e3721b26ba435e6$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $6e3721b26ba435e6$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $6e3721b26ba435e6$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $6e3721b26ba435e6$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$6e3721b26ba435e6$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $6e3721b26ba435e6$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $6e3721b26ba435e6$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $6e3721b26ba435e6$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $6e3721b26ba435e6$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $6e3721b26ba435e6$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $6e3721b26ba435e6$var$ResultType.data,
                result: undefined
            });
        };
        return $6e3721b26ba435e6$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $6e3721b26ba435e6$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $6e3721b26ba435e6$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $6e3721b26ba435e6$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $6e3721b26ba435e6$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $6e3721b26ba435e6$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $6e3721b26ba435e6$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $6e3721b26ba435e6$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($6e3721b26ba435e6$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $6e3721b26ba435e6$var$ResultType.error,
                error: e
            };
        }
        if (type === $6e3721b26ba435e6$var$ResultType.error) return {
            type: $6e3721b26ba435e6$var$ResultType.error,
            error: new $6e3721b26ba435e6$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $6e3721b26ba435e6$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $6e3721b26ba435e6$var$ResultType.error) {
        if ($6e3721b26ba435e6$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $6e3721b26ba435e6$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $6e3721b26ba435e6$var$ResultType.error,
                error: new $6e3721b26ba435e6$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $6e3721b26ba435e6$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $6e3721b26ba435e6$var$ResultType.error,
            error: result,
            statusCode: $6e3721b26ba435e6$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($6e3721b26ba435e6$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $6e3721b26ba435e6$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($6e3721b26ba435e6$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $6e3721b26ba435e6$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $6e3721b26ba435e6$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $6e3721b26ba435e6$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $6e3721b26ba435e6$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$6e3721b26ba435e6$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $6e3721b26ba435e6$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $6e3721b26ba435e6$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($6e3721b26ba435e6$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $6e3721b26ba435e6$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $6e3721b26ba435e6$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($6e3721b26ba435e6$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $6e3721b26ba435e6$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $6e3721b26ba435e6$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $6e3721b26ba435e6$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $6e3721b26ba435e6$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $6e3721b26ba435e6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $6e3721b26ba435e6$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $6e3721b26ba435e6$export$3e9cee6b33872309(!$6e3721b26ba435e6$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($6e3721b26ba435e6$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $6e3721b26ba435e6$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $6e3721b26ba435e6$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($6e3721b26ba435e6$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $6e3721b26ba435e6$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $6e3721b26ba435e6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $6e3721b26ba435e6$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($6e3721b26ba435e6$var$isErrorResult(result)) {
            let boundaryMatch = $6e3721b26ba435e6$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $6e3721b26ba435e6$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($6e3721b26ba435e6$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $6e3721b26ba435e6$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($6e3721b26ba435e6$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $6e3721b26ba435e6$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $6e3721b26ba435e6$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $6e3721b26ba435e6$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $6e3721b26ba435e6$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $6e3721b26ba435e6$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $6e3721b26ba435e6$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $6e3721b26ba435e6$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $6e3721b26ba435e6$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $6e3721b26ba435e6$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $6e3721b26ba435e6$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $6e3721b26ba435e6$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($6e3721b26ba435e6$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $6e3721b26ba435e6$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $6e3721b26ba435e6$export$8ccf933b0513f8d0(path) : path;
    return $6e3721b26ba435e6$export$fe53371bee54353d($6e3721b26ba435e6$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $6e3721b26ba435e6$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $6e3721b26ba435e6$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $6e3721b26ba435e6$var$ResultType.data || result.type === $6e3721b26ba435e6$var$ResultType.error);
}
function $6e3721b26ba435e6$var$isRedirectDataStrategyResultResult(result) {
    return $6e3721b26ba435e6$var$isResponse(result.result) && $6e3721b26ba435e6$var$redirectStatusCodes.has(result.result.status);
}
function $6e3721b26ba435e6$var$isDeferredResult(result) {
    return result.type === $6e3721b26ba435e6$var$ResultType.deferred;
}
function $6e3721b26ba435e6$var$isErrorResult(result) {
    return result.type === $6e3721b26ba435e6$var$ResultType.error;
}
function $6e3721b26ba435e6$var$isRedirectResult(result) {
    return (result && result.type) === $6e3721b26ba435e6$var$ResultType.redirect;
}
function $6e3721b26ba435e6$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $6e3721b26ba435e6$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $6e3721b26ba435e6$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $6e3721b26ba435e6$var$isRedirectResponse(result) {
    if (!$6e3721b26ba435e6$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $6e3721b26ba435e6$var$isValidMethod(method) {
    return $6e3721b26ba435e6$var$validRequestMethods.has(method.toLowerCase());
}
function $6e3721b26ba435e6$var$isMutationMethod(method) {
    return $6e3721b26ba435e6$var$validMutationMethods.has(method.toLowerCase());
}
async function $6e3721b26ba435e6$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$6e3721b26ba435e6$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($6e3721b26ba435e6$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $6e3721b26ba435e6$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $6e3721b26ba435e6$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($6e3721b26ba435e6$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $6e3721b26ba435e6$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $6e3721b26ba435e6$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $6e3721b26ba435e6$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $6e3721b26ba435e6$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $6e3721b26ba435e6$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $6e3721b26ba435e6$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $6e3721b26ba435e6$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $6e3721b26ba435e6$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $6e3721b26ba435e6$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $6e3721b26ba435e6$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $6e3721b26ba435e6$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $6e3721b26ba435e6$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $6e3721b26ba435e6$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $6e3721b26ba435e6$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $6e3721b26ba435e6$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $6e3721b26ba435e6$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $6e3721b26ba435e6$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $6e3721b26ba435e6$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($6e3721b26ba435e6$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $6e3721b26ba435e6$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($6e3721b26ba435e6$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $6e3721b26ba435e6$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("cVnBY", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $968d1facee310a71$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $968d1facee310a71$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $968d1facee310a71$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $968d1facee310a71$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $968d1facee310a71$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $968d1facee310a71$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $968d1facee310a71$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $968d1facee310a71$export$9770f232ac06a008; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $968d1facee310a71$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "useRouteError", function () { return $968d1facee310a71$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $968d1facee310a71$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $968d1facee310a71$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $968d1facee310a71$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useLoaderData", function () { return $968d1facee310a71$export$1448a5050d252c4d; });
$parcel$export(module.exports, "useBlocker", function () { return $968d1facee310a71$export$b273b3273281a049; });
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", function () { return $968d1facee310a71$export$db5148ec97d6af7a; });
$parcel$export(module.exports, "Router", function () { return $968d1facee310a71$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $968d1facee310a71$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $968d1facee310a71$export$910ae8079b2c2852; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $968d1facee310a71$export$52b333d321859367; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return (parcelRequire("9sFLW")).isRouteErrorResponse; });
/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $9sFLW = parcelRequire("9sFLW");
function $968d1facee310a71$var$_extends() {
    $968d1facee310a71$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $968d1facee310a71$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $968d1facee310a71$export$3add0d5dce533e2e = /*#__PURE__*/ $dNMDr.createContext(null);
const $968d1facee310a71$export$145dfa71566a64dc = /*#__PURE__*/ $dNMDr.createContext(null);
const $968d1facee310a71$var$AwaitContext = /*#__PURE__*/ $dNMDr.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $968d1facee310a71$export$26749e8557646306 = /*#__PURE__*/ $dNMDr.createContext(null);
const $968d1facee310a71$export$c7914228fb69b0f5 = /*#__PURE__*/ $dNMDr.createContext(null);
const $968d1facee310a71$export$9072aa6dd1f93057 = /*#__PURE__*/ $dNMDr.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $968d1facee310a71$var$RouteErrorContext = /*#__PURE__*/ $dNMDr.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $968d1facee310a71$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$968d1facee310a71$export$9c954a9d03d32f4a() && (0, $9sFLW.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $dNMDr.useContext($968d1facee310a71$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $968d1facee310a71$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $9sFLW.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $968d1facee310a71$export$9c954a9d03d32f4a() {
    return $dNMDr.useContext($968d1facee310a71$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $968d1facee310a71$export$45d76561a5302f2b() {
    !$968d1facee310a71$export$9c954a9d03d32f4a() && (0, $9sFLW.UNSAFE_invariant)(false);
    return $dNMDr.useContext($968d1facee310a71$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $968d1facee310a71$export$1b3f31771c5d07c() {
    return $dNMDr.useContext($968d1facee310a71$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $968d1facee310a71$export$6c330e8992e8a295(pattern) {
    !$968d1facee310a71$export$9c954a9d03d32f4a() && (0, $9sFLW.UNSAFE_invariant)(false);
    let { pathname: pathname } = $968d1facee310a71$export$45d76561a5302f2b();
    return $dNMDr.useMemo(()=>(0, $9sFLW.matchPath)(pattern, (0, $9sFLW.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $968d1facee310a71$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $968d1facee310a71$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $dNMDr.useContext($968d1facee310a71$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $dNMDr.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $968d1facee310a71$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $dNMDr.useContext($968d1facee310a71$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $968d1facee310a71$var$useNavigateStable() : $968d1facee310a71$var$useNavigateUnstable();
}
function $968d1facee310a71$var$useNavigateUnstable() {
    !$968d1facee310a71$export$9c954a9d03d32f4a() && (0, $9sFLW.UNSAFE_invariant)(false);
    let dataRouterContext = $dNMDr.useContext($968d1facee310a71$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $dNMDr.useContext($968d1facee310a71$export$26749e8557646306);
    let { matches: matches } = $dNMDr.useContext($968d1facee310a71$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $968d1facee310a71$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $9sFLW.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $dNMDr.useRef(false);
    $968d1facee310a71$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dNMDr.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $9sFLW.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9sFLW.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $968d1facee310a71$var$OutletContext = /*#__PURE__*/ $dNMDr.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $968d1facee310a71$export$4138103a3ae699cc() {
    return $dNMDr.useContext($968d1facee310a71$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $968d1facee310a71$export$a3be3530d8e40d0b(context) {
    let outlet = $dNMDr.useContext($968d1facee310a71$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $968d1facee310a71$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $dNMDr.useContext($968d1facee310a71$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $968d1facee310a71$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $dNMDr.useContext($968d1facee310a71$export$26749e8557646306);
    let { matches: matches } = $dNMDr.useContext($968d1facee310a71$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $968d1facee310a71$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $9sFLW.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $dNMDr.useMemo(()=>(0, $9sFLW.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $968d1facee310a71$export$5d3fca4a98652595(routes, locationArg) {
    return $968d1facee310a71$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $968d1facee310a71$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$968d1facee310a71$export$9c954a9d03d32f4a() && (0, $9sFLW.UNSAFE_invariant)(false);
    let { navigator: navigator } = $dNMDr.useContext($968d1facee310a71$export$26749e8557646306);
    let { matches: parentMatches } = $dNMDr.useContext($968d1facee310a71$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $968d1facee310a71$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $9sFLW.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $9sFLW.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $9sFLW.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $968d1facee310a71$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $9sFLW.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $9sFLW.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $968d1facee310a71$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $9sFLW.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $968d1facee310a71$var$DefaultErrorComponent() {
    let error = $968d1facee310a71$export$ed527bf60f6e05f2();
    let message = (0, $9sFLW.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $dNMDr.createElement($dNMDr.Fragment, null, /*#__PURE__*/ $dNMDr.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $dNMDr.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $dNMDr.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $968d1facee310a71$var$defaultErrorElement = /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$var$DefaultErrorComponent, null);
class $968d1facee310a71$var$RenderErrorBoundary extends $dNMDr.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $968d1facee310a71$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $dNMDr.useContext($968d1facee310a71$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $968d1facee310a71$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $9sFLW.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $968d1facee310a71$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $968d1facee310a71$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $dNMDr.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $968d1facee310a71$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($968d1facee310a71$var$DataRouterHook || {});
var $968d1facee310a71$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($968d1facee310a71$var$DataRouterStateHook || {});
function $968d1facee310a71$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $968d1facee310a71$var$useDataRouterContext(hookName) {
    let ctx = $dNMDr.useContext($968d1facee310a71$export$3add0d5dce533e2e);
    !ctx && (0, $9sFLW.UNSAFE_invariant)(false);
    return ctx;
}
function $968d1facee310a71$var$useDataRouterState(hookName) {
    let state = $dNMDr.useContext($968d1facee310a71$export$145dfa71566a64dc);
    !state && (0, $9sFLW.UNSAFE_invariant)(false);
    return state;
}
function $968d1facee310a71$var$useRouteContext(hookName) {
    let route = $dNMDr.useContext($968d1facee310a71$export$9072aa6dd1f93057);
    !route && (0, $9sFLW.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $968d1facee310a71$var$useCurrentRouteId(hookName) {
    let route = $968d1facee310a71$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $9sFLW.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $968d1facee310a71$export$5fc8298006ad9e58() {
    return $968d1facee310a71$var$useCurrentRouteId($968d1facee310a71$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $968d1facee310a71$export$d0fd4b7106de2769() {
    let state = $968d1facee310a71$var$useDataRouterState($968d1facee310a71$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $968d1facee310a71$export$600dc272ed516c15() {
    let dataRouterContext = $968d1facee310a71$var$useDataRouterContext($968d1facee310a71$var$DataRouterHook.UseRevalidator);
    let state = $968d1facee310a71$var$useDataRouterState($968d1facee310a71$var$DataRouterStateHook.UseRevalidator);
    return $dNMDr.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $968d1facee310a71$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $968d1facee310a71$var$useDataRouterState($968d1facee310a71$var$DataRouterStateHook.UseMatches);
    return $dNMDr.useMemo(()=>matches.map((m)=>(0, $9sFLW.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $968d1facee310a71$export$1448a5050d252c4d() {
    let state = $968d1facee310a71$var$useDataRouterState($968d1facee310a71$var$DataRouterStateHook.UseLoaderData);
    let routeId = $968d1facee310a71$var$useCurrentRouteId($968d1facee310a71$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $968d1facee310a71$export$fd5d37484eab868d(routeId) {
    let state = $968d1facee310a71$var$useDataRouterState($968d1facee310a71$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $968d1facee310a71$export$fdc00f3f26066d5e() {
    let state = $968d1facee310a71$var$useDataRouterState($968d1facee310a71$var$DataRouterStateHook.UseActionData);
    let routeId = $968d1facee310a71$var$useCurrentRouteId($968d1facee310a71$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $968d1facee310a71$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $dNMDr.useContext($968d1facee310a71$var$RouteErrorContext);
    let state = $968d1facee310a71$var$useDataRouterState($968d1facee310a71$var$DataRouterStateHook.UseRouteError);
    let routeId = $968d1facee310a71$var$useCurrentRouteId($968d1facee310a71$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $968d1facee310a71$export$78a72ddb39bdd145() {
    let value = $dNMDr.useContext($968d1facee310a71$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $968d1facee310a71$export$17f53340677d5831() {
    let value = $dNMDr.useContext($968d1facee310a71$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $968d1facee310a71$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $968d1facee310a71$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $968d1facee310a71$var$useDataRouterContext($968d1facee310a71$var$DataRouterHook.UseBlocker);
    let state = $968d1facee310a71$var$useDataRouterState($968d1facee310a71$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $dNMDr.useState("");
    let blockerFunction = $dNMDr.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $968d1facee310a71$var$_extends({}, currentLocation, {
                pathname: (0, $9sFLW.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $968d1facee310a71$var$_extends({}, nextLocation, {
                pathname: (0, $9sFLW.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $dNMDr.useEffect(()=>{
        let key = String(++$968d1facee310a71$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $dNMDr.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $9sFLW.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $968d1facee310a71$var$useNavigateStable() {
    let { router: router } = $968d1facee310a71$var$useDataRouterContext($968d1facee310a71$var$DataRouterHook.UseNavigateStable);
    let id = $968d1facee310a71$var$useCurrentRouteId($968d1facee310a71$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $dNMDr.useRef(false);
    $968d1facee310a71$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dNMDr.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $968d1facee310a71$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $968d1facee310a71$var$alreadyWarned$1 = {};
function $968d1facee310a71$var$warningOnce(key, cond, message) {
    if (!cond && !$968d1facee310a71$var$alreadyWarned$1[key]) $968d1facee310a71$var$alreadyWarned$1[key] = true;
}
const $968d1facee310a71$var$alreadyWarned = {};
function $968d1facee310a71$var$warnOnce(key, message) {}
const $968d1facee310a71$var$logDeprecation = (flag, msg, link)=>$968d1facee310a71$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $968d1facee310a71$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $968d1facee310a71$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $968d1facee310a71$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $968d1facee310a71$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $968d1facee310a71$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $968d1facee310a71$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $968d1facee310a71$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $968d1facee310a71$var$START_TRANSITION = "startTransition";
const $968d1facee310a71$var$startTransitionImpl = $dNMDr[$968d1facee310a71$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $968d1facee310a71$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $dNMDr.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dNMDr.useCallback((newState)=>{
        if (v7_startTransition && $968d1facee310a71$var$startTransitionImpl) $968d1facee310a71$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dNMDr.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $dNMDr.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $dNMDr.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dNMDr.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $dNMDr.useEffect(()=>$968d1facee310a71$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dNMDr.createElement($dNMDr.Fragment, null, /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $968d1facee310a71$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $968d1facee310a71$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $968d1facee310a71$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $dNMDr.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9sFLW.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dNMDr.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dNMDr.useCallback((newState)=>{
        v7_startTransition && $968d1facee310a71$var$startTransitionImpl ? $968d1facee310a71$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dNMDr.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $dNMDr.useEffect(()=>$968d1facee310a71$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $968d1facee310a71$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$968d1facee310a71$export$9c954a9d03d32f4a() && (0, $9sFLW.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $dNMDr.useContext($968d1facee310a71$export$26749e8557646306);
    let { matches: matches } = $dNMDr.useContext($968d1facee310a71$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $968d1facee310a71$export$45d76561a5302f2b();
    let navigate = $968d1facee310a71$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $9sFLW.resolveTo)(to, (0, $9sFLW.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $dNMDr.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $968d1facee310a71$export$910ae8079b2c2852(props) {
    return $968d1facee310a71$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $968d1facee310a71$export$e7b0ac011bb776c6(_props) {
    (0, $9sFLW.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $968d1facee310a71$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $9sFLW.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$968d1facee310a71$export$9c954a9d03d32f4a() && (0, $9sFLW.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $dNMDr.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $968d1facee310a71$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $9sFLW.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $dNMDr.useMemo(()=>{
        let trailingPathname = (0, $9sFLW.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $968d1facee310a71$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $968d1facee310a71$export$5d3fca4a98652595($968d1facee310a71$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $968d1facee310a71$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$var$ResolveAwait, null, children));
}
var $968d1facee310a71$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($968d1facee310a71$var$AwaitRenderStatus || {});
const $968d1facee310a71$var$neverSettledPromise = new Promise(()=>{});
class $968d1facee310a71$var$AwaitErrorBoundary extends $dNMDr.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $968d1facee310a71$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $968d1facee310a71$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $968d1facee310a71$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $968d1facee310a71$var$AwaitRenderStatus.error : "_data" in promise ? $968d1facee310a71$var$AwaitRenderStatus.success : $968d1facee310a71$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $968d1facee310a71$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $968d1facee310a71$var$AwaitRenderStatus.error && promise._error instanceof (0, $9sFLW.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $968d1facee310a71$var$neverSettledPromise;
        if (status === $968d1facee310a71$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $968d1facee310a71$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $968d1facee310a71$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $dNMDr.createElement($968d1facee310a71$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $968d1facee310a71$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $968d1facee310a71$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $dNMDr.createElement($dNMDr.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $968d1facee310a71$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $dNMDr.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $dNMDr.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $dNMDr.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $968d1facee310a71$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $968d1facee310a71$export$e7b0ac011bb776c6) && (0, $9sFLW.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $9sFLW.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $968d1facee310a71$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $968d1facee310a71$export$daf73786167a7f72(matches) {
    return $968d1facee310a71$var$_renderMatches(matches);
}
function $968d1facee310a71$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $dNMDr.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $dNMDr.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $dNMDr.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $968d1facee310a71$export$f30f7e456d254e83(routes, opts) {
    return (0, $9sFLW.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $968d1facee310a71$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9sFLW.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $968d1facee310a71$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});



parcelRegister("lxj18", function(module, exports) {

$parcel$export(module.exports, "startBrowserMetrics", function () { return $71ecd51f4461f183$export$7cf313435eb9a801; });

var $2xC28 = parcelRequire("2xC28");

var $bo0Gu = parcelRequire("bo0Gu");

var $dNMDr = parcelRequire("dNMDr");

var $hhYxc = parcelRequire("hhYxc");

var $84ZjZ = parcelRequire("84ZjZ");
const $71ecd51f4461f183$export$7cf313435eb9a801 = (analyticsClient)=>{
    const info = {
        app: {
            version: {
                web: "8339-d2cc2cf89de54f0df83ee83e15c99bbf9f11373a" ?? 'no-version'
            },
            framework: {
                name: 'react',
                version: $dNMDr.version
            }
        },
        product: 'identity',
        // Region is used for "Split by" in Perf Portal.
        region: 'unknown'
    };
    const endpoints = {
        eventPipelineClient: Promise.resolve(analyticsClient.getInstance())
    };
    const events = {
        [(0, $bo0Gu.BMEventsType).WEB_VITALS]: {
            enabled: true
        }
    };
    const plugins = {
        featureFlags: {
            client: Promise.resolve({
                getValue: (gate)=>(0, $84ZjZ.checkFeatureGate)(gate)
            })
        },
        resourceTimings: {
            /**
       * Browser Metrics track all the network calls and add them automatically to the performance events.
       * To ensure we're not recording any UGC / PII, we need to provide a sanitise method.
       */ sanitiseEndpoints: (url)=>{
                // Remove sensitive PII data (i.e. all URL params)
                return url.split('?')[0];
            },
            /**
       * Takes a URL and removes hashes, cache busting parameters, versioning, and other unique identifiers specific to the build of the app.
       * This is so that URLs that exist as a part of a browser metrics payload will not be deemed unique due to having different hashes.
       *
       * * For example, when `url` is:
       * - `https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.449/static/js/login.28848bff.chunk.js`
       * - `https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.450/static/js/login.66eb7699.chunk.js`
       *
       * Then both of the above should be cleaned to `login.js`, which will be treated as the same URL for reporting purposes.
       */ mapResources: (url)=>{
                // url = https://aid-frontend.prod.atl-paas.net/.../static/js/login.28848bff.chunk.js
                if (!url.includes('aid-frontend')) // This is an external URL where we can't guarantee the URL structure, therefore cannot do any mapping.
                return url;
                // hashedFileName = login.28848bff.chunk.js
                const hashedFileName = url.split('/').pop() ?? 'unknown';
                const parts = hashedFileName.split('.');
                const ext = parts.length > 1 ? parts.pop() : 'unknown';
                // Returning login.js
                return `${parts[0]}.${ext}`;
            },
            // If url supports TimingAllowOrigin header, then BM calculates cache status of static resources:
            hasTimingHeaders: ()=>false
        }
    };
    (0, $2xC28.browserMetrics).init({
        info: info,
        endpoints: endpoints,
        plugins: plugins,
        events: events,
        debug: (0, $hhYxc.currentEnvType) !== 'prod'
    });
    (0, $2xC28.browserMetrics).startPageLoad({
        isInitial: true
    });
};

});
parcelRegister("84ZjZ", function(module, exports) {

$parcel$export(module.exports, "checkFeatureGate", function () { return $479771df2dee1b27$export$bd360271f9be3afb; });
$parcel$export(module.exports, "checkFeatureGateOnceInitialized", function () { return $479771df2dee1b27$export$169cc76505f776d4; });

var $emS9l = parcelRequire("emS9l");
parcelRequire("98ins");
var $33fjn = parcelRequire("33fjn");
const $479771df2dee1b27$export$bd360271f9be3afb = (key)=>{
    return (0, $emS9l.default).checkGate(key);
};
const $479771df2dee1b27$export$169cc76505f776d4 = async (key)=>{
    await (0, $33fjn.isFeatureGateProviderReady);
    return (0, $emS9l.default).checkGate(key);
};

});
parcelRegister("98ins", function(module, exports) {
$parcel$export(module.exports, "FeatureGateProvider", function () { return (parcelRequire("33fjn")).FeatureGateProvider; });
$parcel$export(module.exports, "isFeatureGateProviderReady", function () { return (parcelRequire("33fjn")).isFeatureGateProviderReady; });
parcelRequire("33fjn");

});
parcelRegister("33fjn", function(module, exports) {

$parcel$export(module.exports, "isFeatureGateProviderReady", function () { return $ec82088cd224e054$export$e64f903d3c37e234; });
$parcel$export(module.exports, "FeatureGateProvider", function () { return $ec82088cd224e054$export$d9e6d91f1f7e3282; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $aMBBA = parcelRequire("aMBBA");

var $fRBl4 = parcelRequire("fRBl4");

var $jknxz = parcelRequire("jknxz");

var $4NPio = parcelRequire("4NPio");

var $3Wc5s = parcelRequire("3Wc5s");

var $ko1o6 = parcelRequire("ko1o6");

var $ei3NI = parcelRequire("ei3NI");

var $hqddj = parcelRequire("hqddj");

var $50wm1 = parcelRequire("50wm1");
/**
 * Feature Gates are currently created within React (ticket to move this outside in KIRBY-9193)
 * There are cases where FGs may be needed to used by entities outside of React components
 * The example this was written for is the react-router v6 loader function,
 * which gets called at the top-level on initialization of createBrowserRouter is called.
 */ const $ec82088cd224e054$var$deferredPromise = (0, $50wm1.default)();
const $ec82088cd224e054$export$e64f903d3c37e234 = $ec82088cd224e054$var$deferredPromise.promise;
const $ec82088cd224e054$export$d9e6d91f1f7e3282 = ({ children: children })=>{
    const [isFeatureGatesClientReady, setIsFeatureGatesClientReady] = (0, $dNMDr.useState)(false);
    const [dynamicConfigsClient, setDynamicConfigsCollection] = (0, $dNMDr.useState)(undefined);
    const tenantId = (0, $aMBBA.useAppSelector)((state)=>state.context?.tenantCloudId);
    const atlassianAccountId = (0, $aMBBA.useAppSelector)((state)=>state.context?.userId);
    const ffsId = (0, $fRBl4.getFfsId)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsAnonymousId = (0, $4NPio.useAnalyticsAnonymousId)();
    const featureGatesIdentifiers = (0, $dNMDr.useMemo)(()=>({
            tenantId: tenantId,
            atlassianAccountId: atlassianAccountId,
            randomizationId: ffsId,
            analyticsAnonymousId: analyticsAnonymousId
        }), [
        tenantId,
        atlassianAccountId,
        ffsId,
        analyticsAnonymousId
    ]);
    (0, $dNMDr.useEffect)(()=>{
        (0, $ei3NI.initializeDynamicConfigs)(analyticsAnonymousId).then((dynamicConfigs)=>setDynamicConfigsCollection(dynamicConfigs));
    }, [
        analyticsAnonymousId
    ]);
    const onFeatureGatesReady = (0, $dNMDr.useCallback)((err)=>{
        setIsFeatureGatesClientReady(true);
        $ec82088cd224e054$var$captureStatsigFeatureGateError(err);
        $ec82088cd224e054$var$deferredPromise.resolve();
    }, []);
    const areClientsReady = isFeatureGatesClientReady && !!dynamicConfigsClient;
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $jknxz.FeatureGatesInit), {
                identifiers: featureGatesIdentifiers,
                onReady: onFeatureGatesReady
            }),
            !areClientsReady && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3Wc5s.default), {
                label: formatMessage({
                    id: 'statsig.clients.loading',
                    defaultMessage: 'Loading feature flags...',
                    description: 'Label text for loading spinner when Statsig clients are being initialized'
                })
            }),
            areClientsReady && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ei3NI.DynamicConfigsContext).Provider, {
                value: dynamicConfigsClient,
                children: children
            })
        ]
    });
};
const $ec82088cd224e054$var$captureStatsigFeatureGateError = (err)=>{
    if (!err) return;
    (0, $hqddj.captureException)(err, undefined, {
        statsigFeatureGate: 'statsig_feature_gate_client_init'
    });
};

});
parcelRegister("aMBBA", function(module, exports) {

$parcel$export(module.exports, "RESET_APP_STATE", function () { return $0f4dd31cfe5d83b4$export$83323797e38f210e; });
$parcel$export(module.exports, "createAppStore", function () { return $0f4dd31cfe5d83b4$export$38e7b01cdeec369; });
$parcel$export(module.exports, "useAppDispatch", function () { return $0f4dd31cfe5d83b4$export$f51d452c10d5b956; });
$parcel$export(module.exports, "useAppSelector", function () { return $0f4dd31cfe5d83b4$export$a7347740d65f620b; });

var $ka48w = parcelRequire("ka48w");
var $65XXq = parcelRequire("65XXq");

var $iNoYC = parcelRequire("iNoYC");

var $ef8oR = parcelRequire("ef8oR");
parcelRequire("a09DY");
var $e98UA = parcelRequire("e98UA");
var $d9nZl = parcelRequire("d9nZl");
const $0f4dd31cfe5d83b4$export$83323797e38f210e = 'RESET_APP_STATE';
const $0f4dd31cfe5d83b4$var$rootReducer = (state, action)=>{
    const shouldResetAppState = action.type === $0f4dd31cfe5d83b4$export$83323797e38f210e;
    const stateToUpdate = shouldResetAppState ? action.data : state;
    return (0, $ka48w.combineReducers)((0, $iNoYC.getReducers)())(stateToUpdate, action);
};
const $0f4dd31cfe5d83b4$export$38e7b01cdeec369 = (preloadedState = {})=>(0, $65XXq.configureStore)({
        reducer: $0f4dd31cfe5d83b4$var$rootReducer,
        devTools: false,
        preloadedState: preloadedState,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat((0, $ef8oR.idAuthMfaMiddleware))
    });
const $0f4dd31cfe5d83b4$export$f51d452c10d5b956 = (0, $e98UA.useDispatch);
const $0f4dd31cfe5d83b4$export$a7347740d65f620b = (0, $d9nZl.useSelector);

});
parcelRegister("iNoYC", function(module, exports) {

$parcel$export(module.exports, "getReducers", function () { return $5dfa7b08b8280099$export$cf167d5dfe57ae0e; });

var $36GwR = parcelRequire("36GwR");

var $3sEAr = parcelRequire("3sEAr");

var $7RSan = parcelRequire("7RSan");

var $54ReC = parcelRequire("54ReC");

var $gpD2g = parcelRequire("gpD2g");

var $hPcAx = parcelRequire("hPcAx");

var $29JDH = parcelRequire("29JDH");

var $8GZWa = parcelRequire("8GZWa");

var $9KKyn = parcelRequire("9KKyn");

var $1Joqt = parcelRequire("1Joqt");

var $eI4qM = parcelRequire("eI4qM");

var $die0r = parcelRequire("die0r");

var $5OLki = parcelRequire("5OLki");

var $dzQfr = parcelRequire("dzQfr");

var $8eSaq = parcelRequire("8eSaq");

var $jlAVx = parcelRequire("jlAVx");

var $dHF4q = parcelRequire("dHF4q");

var $jNklE = parcelRequire("jNklE");

var $aj0hD = parcelRequire("aj0hD");

var $1LqeZ = parcelRequire("1LqeZ");

var $2ndZA = parcelRequire("2ndZA");

var $1iewS = parcelRequire("1iewS");

var $aIMSK = parcelRequire("aIMSK");

var $aeGK4 = parcelRequire("aeGK4");

var $bA2c5 = parcelRequire("bA2c5");

var $9Q29C = parcelRequire("9Q29C");

var $5Hkcm = parcelRequire("5Hkcm");

var $9l9WD = parcelRequire("9l9WD");

var $izmR9 = parcelRequire("izmR9");

var $V66bb = parcelRequire("V66bb");

var $24WP5 = parcelRequire("24WP5");

var $7RHgH = parcelRequire("7RHgH");

var $rHxo3 = parcelRequire("rHxo3");

var $6Klxu = parcelRequire("6Klxu");

var $bMGeG = parcelRequire("bMGeG");

var $i5FQ3 = parcelRequire("i5FQ3");

var $cE672 = parcelRequire("cE672");

var $bj8lu = parcelRequire("bj8lu");

var $lqjQ7 = parcelRequire("lqjQ7");

var $47SQU = parcelRequire("47SQU");
const $5dfa7b08b8280099$export$cf167d5dfe57ae0e = ()=>({
        appConfig: $36GwR.default,
        csrfToken: $9KKyn.csrfToken,
        hashedCsrfToken: $9KKyn.hashedCsrfToken,
        globalStateLoading: $bj8lu.default,
        login: $dzQfr.default,
        logout: $8eSaq.default,
        marketingConsent: $jlAVx.default,
        mfaEnrollment: $dHF4q.default,
        mfaPromote: $jNklE.default,
        microbranding: $aj0hD.default,
        multiFactor: $2ndZA.default,
        recovery: $aIMSK.default,
        resetPassword: $aeGK4.default,
        signup: $5Hkcm.default,
        signupOnboard: $9l9WD.default,
        user: $7RHgH.default,
        flags: $eI4qM.default,
        continueAs: $29JDH.default,
        selectAccount: $bA2c5.default,
        cancelDeletion: $3sEAr.default,
        expiredPassword: $1Joqt.default,
        googleOneTap: $die0r.default,
        changePassword: $54ReC.default,
        changeEmail: $7RSan.default,
        createAccount: $8GZWa.default,
        welcome: $i5FQ3.default,
        context: $hPcAx.default,
        migrateConfirmation: $1LqeZ.default,
        socialLoginRecovery: $izmR9.default,
        verifyEmail: $rHxo3.default,
        verifyEmailSent: $bMGeG.default,
        serverError: $9Q29C.default,
        cobranding: $gpD2g.default,
        stepUp: $V66bb.default,
        stepUpSso: $24WP5.default,
        welcomeSent: $1iewS.default,
        locale: $5OLki.default,
        verifyEmailOtp: $6Klxu.default,
        loginConsent: $cE672.default,
        orgLoginConfig: $lqjQ7.default,
        awsCaptcha: $47SQU.default
    });

});
parcelRegister("36GwR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c09e9dd7f7d18e2$export$2e2bcd8739ae039; });
const $3c09e9dd7f7d18e2$export$49d5fc8cba920a0 = {
    googleAuthClientId: '596149463257-9oquqfivs9on8t8erq23c8qso6vk3cp1.apps.googleusercontent.com',
    isSamlEnabled: true,
    recaptchaEnable: true,
    recaptchaEnterpriseCheckboxKeySite: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    recaptchaEnterpriseInvisibleKeySite: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    recaptchaEnterpriseScoreKeySite: '6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN',
    smsEnrollmentRecaptchaEnabled: true,
    smsEnrollmentRecaptchaEnterpriseInvisibleKeySite: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    auth0Config: {
        domain: 'auth-domain.dev.atlassian.com',
        clientId: 'RJH00Zs94cwksZuhhkM133mJvmBA0NoQ',
        callbackUrl: 'http://localhost:3000/login/callback',
        deferRules: {
            apple: {
                callbackUrl: 'https://id.dev.internal.atlassian.com/login/apple/callback',
                clientId: 'EtITLqX61hS0sxFzgMEwYYWHosfYHjgY'
            },
            microsoft: {
                callbackUrl: 'https://id.dev.internal.atlassian.com/login/microsoft/callback',
                clientId: '3LDSJPtWZnovKS1gMCnKmp9Hk3iXlVEZ'
            },
            slack: {
                callbackUrl: 'https://id.dev.internal.atlassian.com/login/slack/callback',
                clientId: 'zKYyRODwsh165L0h41wALWAeqVfqDs0i'
            }
        }
    },
    segmentIoKey: '',
    castlePublishableApiKey: ''
};
const $3c09e9dd7f7d18e2$var$appConfig = (state = $3c09e9dd7f7d18e2$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $3c09e9dd7f7d18e2$export$2e2bcd8739ae039 = $3c09e9dd7f7d18e2$var$appConfig;

});

parcelRegister("3sEAr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb94231d197bd02e$export$2e2bcd8739ae039; });
const $fb94231d197bd02e$export$49d5fc8cba920a0 = {
    deleteOn: ''
};
const $fb94231d197bd02e$var$cancelDeletion = (state = $fb94231d197bd02e$export$49d5fc8cba920a0)=>{
    return state;
};
var $fb94231d197bd02e$export$2e2bcd8739ae039 = $fb94231d197bd02e$var$cancelDeletion;

});

parcelRegister("7RSan", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f242fb4762be8a98$export$2e2bcd8739ae039; });
const $f242fb4762be8a98$export$49d5fc8cba920a0 = {
    email: '',
    newEmail: '',
    error: null,
    isLoading: false,
    redirectTo: null
};
const $f242fb4762be8a98$var$changeEmail = (state = $f242fb4762be8a98$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'CHANGE_EMAIL_RESET_STATE':
            return $f242fb4762be8a98$export$49d5fc8cba920a0;
        case 'CHANGE_EMAIL_REQUEST':
            return {
                ...state,
                error: null,
                isLoading: true
            };
        case 'CHANGE_EMAIL_REQUEST_FAILED':
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
        case 'CHANGE_EMAIL_REQUEST_SUCCEEDED':
            return {
                ...state,
                redirectTo: action.redirectTo,
                isLoading: false
            };
        case 'CHANGE_EMAIL_STATE_UPDATE':
            return {
                ...state,
                ...action.backendState
            };
        default:
            return state;
    }
};
var $f242fb4762be8a98$export$2e2bcd8739ae039 = $f242fb4762be8a98$var$changeEmail;

});

parcelRegister("54ReC", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $9ac2cc633fb0a808$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $9ac2cc633fb0a808$export$2e2bcd8739ae039; });
const $9ac2cc633fb0a808$export$49d5fc8cba920a0 = {
    email: '',
    displayName: '',
    fieldErrors: {},
    isLoading: false
};
const $9ac2cc633fb0a808$var$changePassword = (state = $9ac2cc633fb0a808$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'CHANGE_PASSWORD_REQUEST_INITIATE':
            return {
                ...state,
                fieldErrors: {},
                isLoading: true,
                error: undefined
            };
        case 'CHANGE_PASSWORD_REQUEST_SUCCESS':
            return {
                ...state,
                isLoading: false,
                error: undefined
            };
        case 'CHANGE_PASSWORD_REQUEST_FAILED':
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        case 'CHANGE_PASSWORD_REQUEST_FIELD_ERRORS':
            return {
                ...state,
                isLoading: false,
                fieldErrors: action.fieldErrors
            };
        default:
            return state;
    }
};
var $9ac2cc633fb0a808$export$2e2bcd8739ae039 = $9ac2cc633fb0a808$var$changePassword;

});

parcelRegister("gpD2g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84a8c13aed0e9f14$export$2e2bcd8739ae039; });
const $84a8c13aed0e9f14$export$49d5fc8cba920a0 = {};
const $84a8c13aed0e9f14$var$cobranding = (state = $84a8c13aed0e9f14$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $84a8c13aed0e9f14$export$2e2bcd8739ae039 = $84a8c13aed0e9f14$var$cobranding;

});

parcelRegister("hPcAx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7208f4a7ab06e93$export$2e2bcd8739ae039; });
const $f7208f4a7ab06e93$export$49d5fc8cba920a0 = {
    tenantCloudId: undefined
};
const $f7208f4a7ab06e93$var$appConfig = (state = $f7208f4a7ab06e93$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $f7208f4a7ab06e93$export$2e2bcd8739ae039 = $f7208f4a7ab06e93$var$appConfig;

});

parcelRegister("29JDH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59308f04b292a5bd$export$2e2bcd8739ae039; });
const $59308f04b292a5bd$export$49d5fc8cba920a0 = {
    displayName: '',
    email: '',
    avatarUrl: '',
    continueUrl: ''
};
const $59308f04b292a5bd$var$continueAs = (state = $59308f04b292a5bd$export$49d5fc8cba920a0)=>{
    return state;
};
var $59308f04b292a5bd$export$2e2bcd8739ae039 = $59308f04b292a5bd$var$continueAs;

});

parcelRegister("8GZWa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e75bb8e9482926cf$export$2e2bcd8739ae039; });
const $e75bb8e9482926cf$export$49d5fc8cba920a0 = {
    formError: undefined,
    fieldErrors: {},
    redirectTo: null,
    isLoading: false,
    source: undefined,
    loginType: undefined,
    displayName: undefined,
    email: undefined,
    accessToken: undefined,
    idToken: undefined,
    createNeeded: undefined,
    verifyNeeded: undefined,
    confirmationToken: undefined,
    mfaToken: undefined
};
const $e75bb8e9482926cf$var$createAccount = (state = $e75bb8e9482926cf$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'CONFIRMATION_RESET':
            return $e75bb8e9482926cf$export$49d5fc8cba920a0;
        case 'CONFIRMATION_REQUEST':
            return {
                ...state,
                fieldErrors: {},
                formError: undefined,
                isLoading: true
            };
        case 'CONFIRMATION_REQUEST_SUCCESS':
            return {
                ...state,
                fieldErrors: {},
                isLoading: false,
                redirectTo: action.redirectTo
            };
        case 'CONFIRMATION_RESEND_SUCCESS':
            return {
                ...state,
                mfaToken: action.mfaToken
            };
        case 'CONFIRMATION_REQUEST_FAILED':
            return {
                ...state,
                formError: action.error,
                isLoading: false
            };
        case 'CONFIRMATION_SHOW_FIELD_ERROR':
            return {
                ...state,
                fieldErrors: action.errors,
                isLoading: false
            };
        case 'CONFIRMATION_STATE_UPDATE':
            return {
                ...state,
                ...action.backendState
            };
        default:
            return state;
    }
};
var $e75bb8e9482926cf$export$2e2bcd8739ae039 = $e75bb8e9482926cf$var$createAccount;

});

parcelRegister("9KKyn", function(module, exports) {

$parcel$export(module.exports, "csrfToken", function () { return $d22c7f3b4e36f142$export$c077d53e8672d0e9; });
$parcel$export(module.exports, "hashedCsrfToken", function () { return $d22c7f3b4e36f142$export$e9eff156dd8b992; });
const $d22c7f3b4e36f142$export$49d5fc8cba920a0 = '';
const $d22c7f3b4e36f142$export$c077d53e8672d0e9 = (state = $d22c7f3b4e36f142$export$49d5fc8cba920a0, action)=>{
    if (action.type === 'CSRF_TOKEN_UPDATE') return action.csrfToken;
    return state;
};
const $d22c7f3b4e36f142$export$e9eff156dd8b992 = (state = $d22c7f3b4e36f142$export$49d5fc8cba920a0, action)=>{
    if (action.type === 'HASHED_CSRF_TOKEN_UPDATE') return action.hashedCsrfToken;
    return state;
};

});

parcelRegister("1Joqt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62b74f3dbdccda68$export$2e2bcd8739ae039; });
const $62b74f3dbdccda68$export$49d5fc8cba920a0 = {
    error: null,
    isLoading: false,
    isComplete: false
};
const $62b74f3dbdccda68$var$expiredPassword = (state = $62b74f3dbdccda68$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'EXPIRED_PASSWORD_RESET_REQUEST_INITIATE':
            return {
                ...state,
                error: null,
                isLoading: true,
                isComplete: false
            };
        case 'EXPIRED_PASSWORD_RESET_REQUEST_SUCCESS':
            return {
                ...state,
                error: null,
                isLoading: false,
                isComplete: true
            };
        case 'EXPIRED_PASSWORD_RESET_REQUEST_FAILED':
            return {
                ...state,
                error: action.error,
                isLoading: false,
                isComplete: true
            };
        default:
            return state;
    }
};
var $62b74f3dbdccda68$export$2e2bcd8739ae039 = $62b74f3dbdccda68$var$expiredPassword;

});

parcelRegister("eI4qM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $755fb907c1ed833f$export$2e2bcd8739ae039; });
const $755fb907c1ed833f$export$49d5fc8cba920a0 = {
    flags: []
};
var $755fb907c1ed833f$export$2e2bcd8739ae039 = (state = $755fb907c1ed833f$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'FLAG_ADD':
            return {
                ...state,
                flags: [
                    action.flag,
                    ...state.flags
                ]
            };
        case 'FLAG_DISMISS':
            return {
                ...state,
                flags: state.flags.slice(1)
            };
        default:
            return state;
    }
};

});

parcelRegister("die0r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5109a6e3edefbbb$export$2e2bcd8739ae039; });
const $d5109a6e3edefbbb$export$49d5fc8cba920a0 = {
    dismissed: false
};
const $d5109a6e3edefbbb$var$googleOneTap = (state = $d5109a6e3edefbbb$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'GOOGLE_ONE_TAP_DISMISS':
            return {
                ...state,
                dismissed: true
            };
        default:
            return state;
    }
};
var $d5109a6e3edefbbb$export$2e2bcd8739ae039 = $d5109a6e3edefbbb$var$googleOneTap;

});

parcelRegister("5OLki", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d32d685470af2d5$export$2e2bcd8739ae039; });
const $5d32d685470af2d5$export$49d5fc8cba920a0 = 'en';
const $5d32d685470af2d5$var$locale = (state = $5d32d685470af2d5$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $5d32d685470af2d5$export$2e2bcd8739ae039 = $5d32d685470af2d5$var$locale;

});

parcelRegister("dzQfr", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $5f96aaab5b96788a$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $5f96aaab5b96788a$export$2e2bcd8739ae039; });

var $chJxj = parcelRequire("chJxj");
const $5f96aaab5b96788a$export$49d5fc8cba920a0 = {
    isUsernameChecked: false,
    isIsolatedCloudUsernameChecked: false,
    isIsolatedCloudCheckingUsername: false,
    passwordless: (0, $chJxj.CheckUserNamePasswordlessType).Disallowed,
    isCaptchaRequired: false,
    isCheckingUsername: false,
    isErrorShown: false,
    fieldErrors: {},
    isLoggingIn: false,
    redirectUrl: '',
    redirectType: null,
    restrictedEmail: false,
    nextAttempt: 1,
    showResetHint: false,
    usernameExists: false,
    isSocialBlocked: false,
    rememberMeEnabled: false,
    rememberedAccounts: [],
    isRememberMeChecked: false,
    rememberedAccountsResponseCodes: [],
    checkUsernameUserActions: [],
    selectedCheckUsernameUserAction: null
};
const $5f96aaab5b96788a$var$login = (state = $5f96aaab5b96788a$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'LOGIN_REQUEST_CHECK_USERNAME':
            return {
                ...state,
                isCheckingUsername: true,
                isErrorShown: false,
                fieldErrors: {},
                identities: undefined
            };
        case 'LOGIN_REQUEST_ISOLATED_CLOUD_CHECK_USERNAME':
            return {
                ...state,
                isIsolatedCloudCheckingUsername: true,
                isCheckingUsername: true,
                isErrorShown: false,
                fieldErrors: {},
                checkUsernameUserActions: []
            };
        case 'LOGIN_REQUEST_ISOLATED_CLOUD_CHECK_USERNAME_SUCCEEDED':
            return {
                ...state,
                isIsolatedCloudCheckingUsername: false,
                isIsolatedCloudUsernameChecked: true,
                checkUsernameUserActions: action.userActions,
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: true,
                redirectUrl: '',
                redirectType: null
            };
        case 'LOGIN_REQUEST_CHECK_USERNAME_REDIRECT':
            return {
                ...state,
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: false,
                usernameExists: true,
                redirectUrl: action.redirectUrl,
                redirectType: action.redirectType,
                passwordless: (0, $chJxj.CheckUserNamePasswordlessType).Disallowed,
                isSocialBlocked: false
            };
        case 'LOGIN_REQUEST_CHECK_USERNAME_ISOLATED_CLOUD_REDIRECT':
            return {
                ...state,
                isIsolatedCloudCheckingUsername: false,
                isIsolatedCloudUsernameChecked: true,
                redirectUrl: action.redirect_uri
            };
        case 'LOGIN_REQUEST_CHECK_USERNAME_SIGNUP':
            return {
                ...state,
                isCheckingUsername: false,
                isIsolatedCloudCheckingUsername: false,
                isIsolatedCloudUsernameChecked: true,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: false,
                redirectUrl: '',
                redirectType: null,
                passwordless: (0, $chJxj.CheckUserNamePasswordlessType).Disallowed,
                isSocialBlocked: false
            };
        case 'LOGIN_REQUEST_CHECK_USERNAME_NO_ACTION':
            return {
                ...state,
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: true,
                redirectUrl: '',
                redirectType: null,
                passwordless: action.passwordless,
                isSocialBlocked: action.social === 'disallowed'
            };
        case 'LOGIN_REQUEST_CHECK_USERNAME_SOCIAL_LOGIN':
            return {
                ...state,
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: true,
                redirectUrl: '',
                redirectType: null,
                passwordless: action.passwordless,
                identities: action.identities,
                isSocialBlocked: false
            };
        case 'LOGIN_REQUEST_CHECK_USERNAME_FAILED':
            return {
                ...state,
                isErrorShown: false,
                isCheckingUsername: false,
                fieldErrors: {
                    email: action.error
                }
            };
        case 'LOGIN_REQUEST_CHECK_USERNAME_ERROR':
            return {
                ...state,
                isCheckingUsername: false,
                isErrorShown: true,
                error: action.error
            };
        case 'LOGIN_SELECT_CHECK_USERNAME_USER_ACTION':
            return {
                ...state,
                selectedCheckUsernameUserAction: action.userAction
            };
        case 'LOGIN_RESET':
            return {
                ...state,
                isCaptchaRequired: false,
                isSocialBlocked: false,
                isUsernameChecked: false,
                usernameExists: false,
                isIsolatedCloudUsernameChecked: false,
                isIsolatedCloudCheckingUsername: false,
                isErrorShown: false,
                nextAttempt: 1,
                fieldErrors: {},
                identities: undefined,
                checkUsernameUserActions: [],
                selectedCheckUsernameUserAction: null
            };
        case 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN':
            return {
                ...state,
                isErrorShown: false,
                isLoggingIn: true,
                fieldErrors: {}
            };
        case 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_FAILED':
            return {
                ...state,
                isErrorShown: true,
                isLoggingIn: false,
                error: action.error
            };
        case 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_SUCCESS':
            return {
                ...state,
                isErrorShown: false,
                isLoggingIn: false,
                fieldErrors: {},
                redirectUrl: action.redirectUrl
            };
        case 'LOGIN_REQUEST_PASSWORDLESS_LOGIN':
            return {
                ...state,
                isErrorShown: false,
                isLoggingIn: true,
                fieldErrors: {}
            };
        case 'LOGIN_REQUEST_PASSWORDLESS_LOGIN_FAILED':
            return {
                ...state,
                isErrorShown: true,
                isLoggingIn: false,
                error: action.error
            };
        case 'LOGIN_REQUEST_PASSWORDLESS_LOGIN_SUCCESS':
            return {
                ...state,
                isErrorShown: false,
                isLoggingIn: false,
                fieldErrors: {}
            };
        case 'LOGIN_REDIRECT_USER':
            return {
                ...state,
                isErrorShown: false,
                isLoggingIn: false,
                fieldErrors: {},
                redirectUrl: action.redirectUrl
            };
        case 'LOGIN_SHOW_LOGIN_FORM_ERRORS':
            return {
                ...state,
                fieldErrors: action.errors
            };
        case 'UPDATE_LOGIN_ATTEMPT_DETAILS':
            return {
                ...state,
                nextAttempt: action.nextAttempt
            };
        case 'LOGIN_UPDATE_CAPTCHA_REQUIREMENT':
            return {
                ...state,
                isCaptchaRequired: action.isCaptchaRequired
            };
        case 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_INITIATE':
            {
                const { accountIds: accountIds } = action.payload;
                return {
                    ...state,
                    rememberedAccounts: state.rememberedAccounts.filter((account)=>!accountIds.includes(account.accountId))
                };
            }
        case 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_SUCCESS':
        case 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_FAILED':
            // Update the state based on the response from the backend, which updates the UI.
            return {
                ...state,
                rememberedAccountsResponseCodes: [
                    ...state.rememberedAccountsResponseCodes || [],
                    action.payload.response
                ]
            };
        case 'RESET_REMEMBERED_ACCOUNT_RESPONSE_CODES':
            return {
                ...state,
                rememberedAccountsResponseCodes: []
            };
        case 'REMEMBER_ME_CHECKBOX_UPDATE':
            return {
                ...state,
                isRememberMeChecked: action.payload.enabled
            };
        case 'REMEMBER_ME_CHECKBOX_TOGGLE':
            return {
                ...state,
                isRememberMeChecked: !state.isRememberMeChecked
            };
        case 'RESET_REMEMBER_ME_STATE':
            return {
                ...state,
                isRememberMeChecked: false,
                isCheckingUsername: false,
                isUsernameChecked: false
            };
        default:
            return state;
    }
};
var $5f96aaab5b96788a$export$2e2bcd8739ae039 = $5f96aaab5b96788a$var$login;

});
parcelRegister("chJxj", function(module, exports) {

$parcel$export(module.exports, "CheckUserNameRedirectType", function () { return $d57993c08fa7ab24$export$8ef54b27f2e9d22a; });
$parcel$export(module.exports, "CheckUserNamePasswordlessType", function () { return $d57993c08fa7ab24$export$b660b4f2246928fd; });
$parcel$export(module.exports, "SocialProvider", function () { return $d57993c08fa7ab24$export$9368509e79aec5d3; });
$parcel$export(module.exports, "OidcDisplay", function () { return $d57993c08fa7ab24$export$979d11be6cba8f4d; });
$parcel$export(module.exports, "VerificationType", function () { return $d57993c08fa7ab24$export$ca9df54f128b4fc3; });
$parcel$export(module.exports, "VerifyOrReverifyEmailError", function () { return $d57993c08fa7ab24$export$900620e02700dc8d; });
$parcel$export(module.exports, "WelcomeError", function () { return $d57993c08fa7ab24$export$b3e1628b2fcac0ef; });
$parcel$export(module.exports, "WelcomeSentError", function () { return $d57993c08fa7ab24$export$8681a4e3b8216bf1; });
$parcel$export(module.exports, "RedirectType", function () { return $d57993c08fa7ab24$export$901f7b7cba88b6fd; });
$parcel$export(module.exports, "MfaFlow", function () { return $d57993c08fa7ab24$export$dfa50caeee289030; });
$parcel$export(module.exports, "KnownRecoveryEmailErrorReasons", function () { return $d57993c08fa7ab24$export$617703099de92392; });
var $d57993c08fa7ab24$export$8ef54b27f2e9d22a = /*#__PURE__*/ function(CheckUserNameRedirectType) {
    CheckUserNameRedirectType["Sso"] = "sso";
    CheckUserNameRedirectType["EmailSent"] = "email_sent";
    return CheckUserNameRedirectType;
}({});
var $d57993c08fa7ab24$export$b660b4f2246928fd = /*#__PURE__*/ function(CheckUserNamePasswordlessType) {
    CheckUserNamePasswordlessType["Disallowed"] = "disallowed";
    CheckUserNamePasswordlessType["Allowed"] = "allowed";
    return CheckUserNamePasswordlessType;
}({});
var $d57993c08fa7ab24$export$9368509e79aec5d3 = /*#__PURE__*/ function(SocialProvider) {
    SocialProvider["Google"] = "google";
    SocialProvider["Microsoft"] = "microsoft";
    SocialProvider["Apple"] = "apple";
    SocialProvider["Slack"] = "slack";
    return SocialProvider;
}({});
var $d57993c08fa7ab24$export$963a69fd10acd5fa = /*#__PURE__*/ function(MfaSecurityKeyProtectionType) {
    MfaSecurityKeyProtectionType["Software"] = "Software";
    MfaSecurityKeyProtectionType["Hardware"] = "Hardware";
    MfaSecurityKeyProtectionType["Tee"] = "TEE";
    MfaSecurityKeyProtectionType["SecureElement"] = "SecureElement";
    MfaSecurityKeyProtectionType["RemoteHandle"] = "RemoteHandle";
    return MfaSecurityKeyProtectionType;
}({});
var $d57993c08fa7ab24$export$979d11be6cba8f4d = /*#__PURE__*/ function(OidcDisplay) {
    OidcDisplay["Login"] = "login";
    OidcDisplay["Signup"] = "signup";
    OidcDisplay["Continue"] = "continue";
    OidcDisplay["LoginWithRedirect"] = "login_with_redirect";
    OidcDisplay["Reverify"] = "reverify";
    OidcDisplay["ManageSessions"] = "manage_sessions";
    return OidcDisplay;
}({});
var $d57993c08fa7ab24$export$ca9df54f128b4fc3 = /*#__PURE__*/ function(VerificationType) {
    VerificationType["Verify"] = "verify";
    VerificationType["VerifyWithSoftSession"] = "verifyWithSoftSession";
    VerificationType["Reverify"] = "reverify";
    return VerificationType;
}({});
var $d57993c08fa7ab24$export$900620e02700dc8d = /*#__PURE__*/ function(VerifyOrReverifyEmailError) {
    VerifyOrReverifyEmailError["ExpiredToken"] = "expired_token_error";
    VerifyOrReverifyEmailError["InvalidToken"] = "invalid_token_error";
    VerifyOrReverifyEmailError["RateLimitExceeded"] = "ratelimit_exceeded_error";
    return VerifyOrReverifyEmailError;
}({});
var $d57993c08fa7ab24$export$b3e1628b2fcac0ef = /*#__PURE__*/ function(WelcomeError) {
    WelcomeError["RateLimitExceeded"] = "rate_limit_exceeded";
    return WelcomeError;
}({});
var $d57993c08fa7ab24$export$8681a4e3b8216bf1 = /*#__PURE__*/ function(WelcomeSentError) {
    WelcomeSentError["ExpiredToken"] = "expired_token";
    WelcomeSentError["InvalidToken"] = "invalid_token";
    return WelcomeSentError;
}({});
var $d57993c08fa7ab24$export$901f7b7cba88b6fd = /*#__PURE__*/ function(RedirectType) {
    RedirectType["ResumeMigration"] = "resume_migration";
    RedirectType["Migration"] = "migration";
    RedirectType["Signup"] = "signup";
    RedirectType["ResumeSignup"] = "resume_signup";
    RedirectType["Invite"] = "invite";
    return RedirectType;
}({});
const $d57993c08fa7ab24$export$af8c96aed1523ade = [
    'internal_server_error',
    'bad_request',
    'not_found',
    'csrf_token_mismatch'
];
function $d57993c08fa7ab24$export$390d5c1cc6047864(error) {
    // Need to typecast because T[].includes(X) -> X always needs to be of type T
    return $d57993c08fa7ab24$export$af8c96aed1523ade.includes(error);
}
var $d57993c08fa7ab24$export$12df27b025e392f8 = /*#__PURE__*/ function(SecurityKeyAuthenticatorAttachment) {
    SecurityKeyAuthenticatorAttachment["Platform"] = "platform";
    SecurityKeyAuthenticatorAttachment["CrossPlatform"] = "cross-platform";
    return SecurityKeyAuthenticatorAttachment;
}({});
var $d57993c08fa7ab24$export$dfa50caeee289030 = /*#__PURE__*/ function(MfaFlow) {
    MfaFlow["Sms"] = "sms";
    MfaFlow["Totp"] = "totp";
    MfaFlow["SecurityKey"] = "security_key";
    return MfaFlow;
}({});
const $d57993c08fa7ab24$export$617703099de92392 = [
    'userNotFound',
    'userIsManaged',
    'alreadyRequested'
];

});


parcelRegister("8eSaq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1e568bc6789a04c$export$2e2bcd8739ae039; });
const $d1e568bc6789a04c$export$49d5fc8cba920a0 = {
    autoSubmit: false
};
const $d1e568bc6789a04c$var$logout = (state = $d1e568bc6789a04c$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $d1e568bc6789a04c$export$2e2bcd8739ae039 = $d1e568bc6789a04c$var$logout;

});

parcelRegister("jlAVx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0f13703b8e0ff70$export$2e2bcd8739ae039; });
const $f0f13703b8e0ff70$export$49d5fc8cba920a0 = {
    config: undefined
};
const $f0f13703b8e0ff70$var$marketingConsent = (state = $f0f13703b8e0ff70$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'UPDATE_MARKETING_CONSENT_CONFIG':
            return {
                ...state,
                config: action.config
            };
        default:
            return state;
    }
};
var $f0f13703b8e0ff70$export$2e2bcd8739ae039 = $f0f13703b8e0ff70$var$marketingConsent;

});

parcelRegister("dHF4q", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $da70be15d936a76d$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $da70be15d936a76d$export$2e2bcd8739ae039; });

var $chJxj = parcelRequire("chJxj");
const $da70be15d936a76d$export$49d5fc8cba920a0 = {
    invalid: false,
    enrollStarted: false,
    enrollConfirmed: false,
    token: '',
    redirectUrl: null,
    recoveryCode: null,
    transactionToken: null,
    unsupportedCountries: []
};
var $da70be15d936a76d$export$2e2bcd8739ae039 = (state = $da70be15d936a76d$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'START_ENROLL':
            return {
                ...state,
                token: action.token,
                mfaFlow: (0, $chJxj.MfaFlow).Totp
            };
        case 'START_ENROLL_RESPONSE':
            return {
                ...state,
                enrollStarted: true,
                transactionToken: action.transactionToken,
                emailAddress: action.emailAddress,
                totpSecret: action.totpSecret,
                recoveryCode: action.recoveryCode,
                totpUri: action.totpUri
            };
        case 'CONFIRM_ENROLL':
            return {
                ...state,
                confirmingEnroll: true,
                invalid: false
            };
        case 'CONFIRM_ENROLL_RESPONSE':
            return {
                ...state,
                enrollConfirmed: true,
                confirmingEnroll: false,
                redirectUrl: action.redirectUrl
            };
        case 'CONFIRM_ENROLL_ERROR':
            return {
                ...state,
                confirmingEnroll: false,
                invalid: true
            };
        case 'START_SMS_ENROLL':
            return {
                ...state,
                token: action.token,
                phoneNumber: action.phoneNumber,
                mfaFlow: (0, $chJxj.MfaFlow).Sms
            };
        case 'START_SMS_ENROLL_RESPONSE':
            return {
                ...state,
                transactionToken: action.transactionToken,
                recoveryCode: action.recoveryCode,
                smsEnrollError: null,
                phoneNumber: action.phoneNumber
            };
        case 'START_SMS_ENROLL_ERROR':
            return {
                ...state,
                smsEnrollError: action.smsEnrollError,
                transactionToken: null,
                recoveryCode: null
            };
        case 'UPDATE_SMS_ENROLLMENT_UNSUPPORTED_COUNTRIES':
            return {
                ...state,
                unsupportedCountries: action.unsupportedCountries
            };
        case 'RESET_SMS_ENROLL_ERROR':
            return {
                ...state,
                smsEnrollError: null
            };
        case 'START_SECURITY_KEY_ENROLL':
            return {
                ...state,
                token: action.token,
                mfaFlow: (0, $chJxj.MfaFlow).SecurityKey
            };
        case 'CONFIRM_SECURITY_KEY_ENROLLMENT':
            return {
                ...state,
                recoveryCode: action.recoveryCode
            };
        default:
            return state;
    }
};

});

parcelRegister("jNklE", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $96a6845a88e7bf22$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $96a6845a88e7bf22$export$2e2bcd8739ae039; });
const $96a6845a88e7bf22$export$49d5fc8cba920a0 = {
    redirectTo: null,
    hasPasskeys: false
};
var $96a6845a88e7bf22$export$2e2bcd8739ae039 = (state = $96a6845a88e7bf22$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'MFA_PROMOTE_REDIRECT':
            return {
                ...state,
                redirectTo: action.redirectTo
            };
        default:
            return state;
    }
};

});

parcelRegister("aj0hD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $033e98a5046e8506$export$2e2bcd8739ae039; });
const $033e98a5046e8506$export$49d5fc8cba920a0 = {
    oidcContext: undefined,
    isEmbedded: false,
    isAnyMobile: false,
    isMobileApp: false,
    screenSize: 'unknown'
};
const $033e98a5046e8506$var$microbranding = (state = $033e98a5046e8506$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'MICROBRANDING_UPDATE':
            return {
                ...state,
                ...action.microbranding
            };
        case 'SCREEN_SIZE_UPDATED':
            return {
                ...state,
                screenSize: action.screenSize
            };
        default:
            return state;
    }
};
var $033e98a5046e8506$export$2e2bcd8739ae039 = $033e98a5046e8506$var$microbranding;

});

parcelRegister("1LqeZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cae65465adda5948$export$2e2bcd8739ae039; });
const $cae65465adda5948$export$49d5fc8cba920a0 = {
    redirectTo: ''
};
const $cae65465adda5948$var$migrateConfirmation = (state = $cae65465adda5948$export$49d5fc8cba920a0)=>{
    return state;
};
var $cae65465adda5948$export$2e2bcd8739ae039 = $cae65465adda5948$var$migrateConfirmation;

});

parcelRegister("2ndZA", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $bda2d719017fdc64$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $bda2d719017fdc64$export$2e2bcd8739ae039; });
const $bda2d719017fdc64$export$49d5fc8cba920a0 = {
    email: '',
    fieldErrors: {},
    isLoading: false,
    isManaged: null,
    isRecoveryEmailSent: false
};
var $bda2d719017fdc64$export$2e2bcd8739ae039 = (state = $bda2d719017fdc64$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'MFA_VERIFICATION_VERIFY':
            return {
                ...state,
                fieldErrors: {},
                isLoading: true
            };
        case 'MFA_VERIFICATION_RECOVER':
            return {
                ...state,
                fieldErrors: {},
                isLoading: true
            };
        case 'MFA_VERIFICATION_RECOVER_RESPONSE':
            return {
                ...state,
                recoveryCode: action.recoveryCode
            };
        case 'MFA_VERIFICATION_VERIFY_ERROR':
            return {
                ...state,
                isLoading: false,
                fieldErrors: {
                    otpCode: {
                        errorCode: action.errorCode,
                        message: action.message
                    }
                }
            };
        case 'MFA_VERIFICATION_RECOVER_ERROR':
            return {
                ...state,
                isLoading: false,
                fieldErrors: {
                    recoveryCode: {
                        errorCode: action.errorCode,
                        message: action.message
                    }
                }
            };
        case 'RECOVERY_EMAIL_SENT':
            return {
                ...state,
                isRecoveryEmailSent: true
            };
        case 'RECOVERY_EMAIL_START':
            return {
                ...state,
                recoveryEmailError: undefined
            };
        case 'RECOVERY_EMAIL_ERROR':
            return {
                ...state,
                recoveryEmailError: action.reason
            };
        case 'USER_MANAGED_STATUS':
            return {
                ...state,
                isManaged: action.isManaged
            };
        case 'MFA_RESET_OTP_INPUT':
            return {
                ...state,
                clearInputTrigger: Date.now(),
                fieldErrors: {}
            };
        default:
            return state;
    }
};

});

parcelRegister("1iewS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4bbb15d817f3b3b$export$2e2bcd8739ae039; });

var $chJxj = parcelRequire("chJxj");
const $a4bbb15d817f3b3b$export$49d5fc8cba920a0 = {
    error: null,
    email: '',
    redirectType: (0, $chJxj.RedirectType).ResumeMigration,
    showBrowserWarning: false
};
const $a4bbb15d817f3b3b$var$welcomeSent = (state = $a4bbb15d817f3b3b$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $a4bbb15d817f3b3b$export$2e2bcd8739ae039 = $a4bbb15d817f3b3b$var$welcomeSent;

});

parcelRegister("aIMSK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eefa6125ea6ada1$export$2e2bcd8739ae039; });
const $6eefa6125ea6ada1$export$49d5fc8cba920a0 = {
    error: null,
    fieldErrors: {},
    redirectTo: null,
    isLoading: false
};
const $6eefa6125ea6ada1$var$recovery = (state = $6eefa6125ea6ada1$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'TSV_RECOVERY_RESET':
            return $6eefa6125ea6ada1$export$49d5fc8cba920a0;
        case 'TSV_RECOVERY_LOGIN_REQUEST_LINK_REDIRECT':
            return {
                ...state,
                fieldErrors: {},
                error: null,
                redirectTo: action.redirectTo,
                isLoading: true
            };
        case 'TSV_RECOVERY_REQUEST_FAILED':
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
        case 'TSV_RECOVERY_SHOW_FIELD_ERRORS':
            return {
                ...state,
                fieldErrors: action.error,
                isLoading: false
            };
        default:
            return state;
    }
};
var $6eefa6125ea6ada1$export$2e2bcd8739ae039 = $6eefa6125ea6ada1$var$recovery;

});

parcelRegister("aeGK4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b817219a4cac6f7d$export$2e2bcd8739ae039; });
const $b817219a4cac6f7d$export$49d5fc8cba920a0 = {
    error: undefined,
    fieldErrors: {},
    isLoading: false,
    isSent: false
};
const $b817219a4cac6f7d$var$resetPassword = (state = $b817219a4cac6f7d$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'RESET_PASSWORD_RESET':
            return {
                ...state,
                error: undefined,
                isLoading: false,
                isSent: false
            };
        case 'RESET_PASSWORD_REQUEST_LINK':
            return {
                ...state,
                error: undefined,
                isLoading: true,
                isSent: false
            };
        case 'RESET_PASSWORD_REQUEST_LINK_SUCCESS':
            return {
                ...state,
                error: undefined,
                isLoading: false,
                isSent: true
            };
        case 'RESET_PASSWORD_REQUEST_LINK_REDIRECT':
            return {
                ...state,
                error: undefined,
                isLoading: true,
                isSent: false,
                redirectTo: action.redirectTo
            };
        case 'RESET_PASSWORD_ERROR':
            return {
                ...state,
                error: action.error,
                isLoading: false,
                isSent: false
            };
        case 'RESET_PASSWORD_REQUEST_LINK_FAILED_WITH_FIELD_ERRORS':
            return {
                ...state,
                fieldErrors: action.fieldErrors,
                isLoading: false,
                isSent: false
            };
        default:
            return state;
    }
};
var $b817219a4cac6f7d$export$2e2bcd8739ae039 = $b817219a4cac6f7d$var$resetPassword;

});

parcelRegister("bA2c5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10fb45c46ee0f003$export$2e2bcd8739ae039; });
const $10fb45c46ee0f003$export$49d5fc8cba920a0 = {
    sessions: null
};
const $10fb45c46ee0f003$var$selectAccount = (state = $10fb45c46ee0f003$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'SESSION_REQUEST':
            return {
                ...state,
                isLoading: true
            };
        default:
            return state;
    }
};
var $10fb45c46ee0f003$export$2e2bcd8739ae039 = $10fb45c46ee0f003$var$selectAccount;

});

parcelRegister("9Q29C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b67b7830f394ec92$export$2e2bcd8739ae039; });
const $b67b7830f394ec92$export$49d5fc8cba920a0 = null;
const $b67b7830f394ec92$var$serverErrorReducer = (state = $b67b7830f394ec92$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'SERVER_ERROR_UPDATE':
            return action.error;
        default:
            return state;
    }
};
var $b67b7830f394ec92$export$2e2bcd8739ae039 = $b67b7830f394ec92$var$serverErrorReducer;

});

parcelRegister("5Hkcm", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $834e5399448d4c64$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $834e5399448d4c64$export$2e2bcd8739ae039; });
const $834e5399448d4c64$export$49d5fc8cba920a0 = {
    error: null,
    fieldErrors: {},
    isLoading: false,
    redirectTo: null,
    autoSubmit: false
};
const $834e5399448d4c64$var$signup = (state = $834e5399448d4c64$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'SIGNUP_RESET':
            return $834e5399448d4c64$export$49d5fc8cba920a0;
        case 'SIGNUP_REQUEST':
            return {
                ...state,
                error: null,
                fieldErrors: {},
                isLoading: true
            };
        case 'SIGNUP_REQUEST_SUCCESS':
            return {
                ...state,
                isLoading: false,
                fieldErrors: {},
                redirectTo: action.redirectTo
            };
        case 'SIGNUP_REQUEST_FAILED':
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
        case 'SIGNUP_SHOW_FIELD_ERRORS':
            return {
                ...state,
                fieldErrors: action.errors,
                isLoading: false
            };
        default:
            return state;
    }
};
var $834e5399448d4c64$export$2e2bcd8739ae039 = $834e5399448d4c64$var$signup;

});

parcelRegister("9l9WD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e57f135a1a13fb67$export$2e2bcd8739ae039; });
const $e57f135a1a13fb67$export$49d5fc8cba920a0 = {
    error: null,
    fieldErrors: {},
    isLoading: false,
    redirectTo: null,
    autoSubmit: false
};
const $e57f135a1a13fb67$var$signupOnboard = (state = $e57f135a1a13fb67$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'SIGNUP_ONBOARD_RESET':
            return $e57f135a1a13fb67$export$49d5fc8cba920a0;
        case 'SIGNUP_ONBOARD_REQUEST':
            return {
                ...state,
                error: null,
                fieldErrors: {},
                isLoading: true
            };
        case 'SIGNUP_ONBOARD_REQUEST_SUCCESS':
            return {
                ...state,
                isLoading: false,
                fieldErrors: {},
                redirectTo: action.redirectTo
            };
        case 'SIGNUP_ONBOARD_REQUEST_FAILED':
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
        case 'SIGNUP_ONBOARD_SHOW_FIELD_ERRORS':
            return {
                ...state,
                fieldErrors: action.errors,
                isLoading: false
            };
        default:
            return state;
    }
};
var $e57f135a1a13fb67$export$2e2bcd8739ae039 = $e57f135a1a13fb67$var$signupOnboard;

});

parcelRegister("izmR9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c022d02be8c784e$export$2e2bcd8739ae039; });
const $4c022d02be8c784e$export$49d5fc8cba920a0 = {};
const $4c022d02be8c784e$var$socialLoginRecovery = (state = $4c022d02be8c784e$export$49d5fc8cba920a0)=>state;
var $4c022d02be8c784e$export$2e2bcd8739ae039 = $4c022d02be8c784e$var$socialLoginRecovery;

});

parcelRegister("V66bb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcaded125273483b$export$2e2bcd8739ae039; });
const $fcaded125273483b$export$49d5fc8cba920a0 = {
    email: '',
    mfaToken: '',
    orgName: null,
    token: null
};
const $fcaded125273483b$var$stepUp = (state = $fcaded125273483b$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'STEP_UP_RESEND_CODE_SUCCESS':
            return {
                ...state,
                mfaToken: action.mfaToken
            };
        case 'STEP_UP_SEND_CODE_SUCCESS':
            return {
                ...state,
                mfaToken: action.mfaToken
            };
        case 'STEP_UP_MFA_TOKEN_LOAD_FROM_SESSION_STORAGE':
            return {
                ...state,
                mfaToken: action.mfaToken
            };
        default:
            return state;
    }
};
var $fcaded125273483b$export$2e2bcd8739ae039 = $fcaded125273483b$var$stepUp;

});

parcelRegister("24WP5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b6930579f67913e$export$2e2bcd8739ae039; });
const $8b6930579f67913e$export$49d5fc8cba920a0 = {
    ssoRedirectUrl: undefined,
    idp: {
        trusted: false,
        humanReadableRedirectLocation: undefined
    }
};
const $8b6930579f67913e$var$stepUpSso = (state = $8b6930579f67913e$export$49d5fc8cba920a0, _action)=>{
    return state;
};
var $8b6930579f67913e$export$2e2bcd8739ae039 = $8b6930579f67913e$var$stepUpSso;

});

parcelRegister("7RHgH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1aeccba797e71822$export$2e2bcd8739ae039; });
const $1aeccba797e71822$export$49d5fc8cba920a0 = {
    email: ''
};
const $1aeccba797e71822$var$user = (state = $1aeccba797e71822$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $1aeccba797e71822$export$2e2bcd8739ae039 = $1aeccba797e71822$var$user;

});

parcelRegister("rHxo3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a2ce388fa11d7c3$export$2e2bcd8739ae039; });

var $chJxj = parcelRequire("chJxj");
const $7a2ce388fa11d7c3$export$49d5fc8cba920a0 = {
    verificationType: (0, $chJxj.VerificationType).Verify,
    url: '#',
    error: (0, $chJxj.VerifyOrReverifyEmailError).ExpiredToken
};
const $7a2ce388fa11d7c3$var$verifyEmail = (state = $7a2ce388fa11d7c3$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $7a2ce388fa11d7c3$export$2e2bcd8739ae039 = $7a2ce388fa11d7c3$var$verifyEmail;

});

parcelRegister("6Klxu", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $be17956681a66b82$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $be17956681a66b82$export$2e2bcd8739ae039; });

var $chJxj = parcelRequire("chJxj");
const $be17956681a66b82$export$49d5fc8cba920a0 = {
    email: '',
    isLoading: false,
    redirectType: (0, $chJxj.RedirectType).Signup
};
const $be17956681a66b82$var$verifyEmailOtp = (state = $be17956681a66b82$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'VERIFY_EMAIL_OTP_REQUEST':
            return {
                ...state,
                isLoading: true,
                error: undefined,
                redirectTo: undefined
            };
        case 'VERIFY_EMAIL_OTP_SUCCESS':
            return {
                ...state,
                redirectTo: action.redirectTo
            };
        case 'VERIFY_EMAIL_OTP_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        default:
            return state;
    }
};
var $be17956681a66b82$export$2e2bcd8739ae039 = $be17956681a66b82$var$verifyEmailOtp;

});

parcelRegister("bMGeG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d01931b487883cf0$export$2e2bcd8739ae039; });

var $chJxj = parcelRequire("chJxj");
const $d01931b487883cf0$export$49d5fc8cba920a0 = {
    verificationType: (0, $chJxj.VerificationType).Verify,
    showBrowserWarning: false
};
const $d01931b487883cf0$var$verifyEmailSent = (state = $d01931b487883cf0$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $d01931b487883cf0$export$2e2bcd8739ae039 = $d01931b487883cf0$var$verifyEmailSent;

});

parcelRegister("i5FQ3", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $9b11e2974b4a2e1f$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $9b11e2974b4a2e1f$export$2e2bcd8739ae039; });

var $chJxj = parcelRequire("chJxj");

var $cH3Z0 = parcelRequire("cH3Z0");
const $9b11e2974b4a2e1f$export$49d5fc8cba920a0 = {
    error: null,
    formError: null,
    fieldErrors: {},
    isLoading: false,
    isMobile: (0, $cH3Z0.detectClient)().atlassianMobileApp,
    redirectTo: null,
    redirectType: (0, $chJxj.RedirectType).Migration,
    email: '',
    shouldSkipCaptcha: false
};
const $9b11e2974b4a2e1f$var$welcome = (state = $9b11e2974b4a2e1f$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'WELCOME_SIGNUP_RESET':
            return $9b11e2974b4a2e1f$export$49d5fc8cba920a0;
        case 'WELCOME_SIGNUP_REQUEST':
            return {
                ...state,
                error: null,
                formError: null,
                fieldErrors: {},
                isLoading: true
            };
        case 'WELCOME_SIGNUP_REQUEST_SUCCESS':
            return {
                ...state,
                isLoading: false,
                fieldErrors: {},
                redirectTo: action.redirectTo
            };
        case 'WELCOME_SIGNUP_REQUEST_FAILED':
            return {
                ...state,
                error: null,
                formError: action.formError,
                isLoading: false
            };
        case 'WELCOME_SIGNUP_SHOW_FIELD_ERRORS':
            return {
                ...state,
                fieldErrors: action.errors,
                isLoading: false
            };
        default:
            return state;
    }
};
var $9b11e2974b4a2e1f$export$2e2bcd8739ae039 = $9b11e2974b4a2e1f$var$welcome;

});
parcelRegister("cH3Z0", function(module, exports) {

$parcel$export(module.exports, "detectClient", function () { return $31146109381e44c2$export$dbd7930c526235a3; });
const $31146109381e44c2$var$userAgent = navigator.userAgent || navigator.vendor || window.opera;
const $31146109381e44c2$export$b7eb5c075a7422f3 = ()=>{
    if (/windows phone/i.test($31146109381e44c2$var$userAgent)) return 'windows phone';
    if (/android/i.test($31146109381e44c2$var$userAgent)) return 'android';
    if (/iPad|iPhone|iPod/.test($31146109381e44c2$var$userAgent) && !window.MSStream) return 'ios';
    return 'unknown';
};
const $31146109381e44c2$export$dbd7930c526235a3 = ()=>{
    return {
        platform: $31146109381e44c2$export$b7eb5c075a7422f3(),
        atlassianMobileApp: /AtlassianMobileApp/i.test($31146109381e44c2$var$userAgent)
    };
};

});


parcelRegister("cE672", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $dd49693ded844925$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $dd49693ded844925$export$2e2bcd8739ae039; });
const $dd49693ded844925$export$49d5fc8cba920a0 = {
    consentType: undefined
};
const $dd49693ded844925$var$loginConsent = (state = $dd49693ded844925$export$49d5fc8cba920a0)=>{
    return state;
};
var $dd49693ded844925$export$2e2bcd8739ae039 = $dd49693ded844925$var$loginConsent;

});

parcelRegister("bj8lu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $370cd13501ed11e5$export$2e2bcd8739ae039; });
const $370cd13501ed11e5$var$globalStateLoading = (state = false, action)=>{
    if (action.type === 'SET_GLOBAL_STATE_LOADING') return action.isLoading;
    return state;
};
var $370cd13501ed11e5$export$2e2bcd8739ae039 = $370cd13501ed11e5$var$globalStateLoading;

});

parcelRegister("lqjQ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc7fff2e69032ee7$export$2e2bcd8739ae039; });
const $fc7fff2e69032ee7$export$49d5fc8cba920a0 = {};
const $fc7fff2e69032ee7$var$orgLoginConfig = (state = $fc7fff2e69032ee7$export$49d5fc8cba920a0)=>state;
var $fc7fff2e69032ee7$export$2e2bcd8739ae039 = $fc7fff2e69032ee7$var$orgLoginConfig;

});

parcelRegister("47SQU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99b3ffa099a453bf$export$2e2bcd8739ae039; });
const $99b3ffa099a453bf$export$49d5fc8cba920a0 = {
    isCaptchaPuzzleModalOpen: false
};
const $99b3ffa099a453bf$var$awsCaptcha = (state = $99b3ffa099a453bf$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'OPEN_AWS_CAPTCHA_MODAL':
            return {
                ...state,
                isCaptchaPuzzleModalOpen: true
            };
        case 'CLOSE_AWS_CAPTCHA_MODAL':
            return {
                ...state,
                isCaptchaPuzzleModalOpen: false
            };
        default:
            return state;
    }
};
var $99b3ffa099a453bf$export$2e2bcd8739ae039 = $99b3ffa099a453bf$var$awsCaptcha;

});


parcelRegister("ef8oR", function(module, exports) {

$parcel$export(module.exports, "idAuthMfaMiddleware", function () { return $6cfb373adcb92a72$export$9c3b774af0e8f6c4; });

var $lwrli = parcelRequire("lwrli");

var $1JRGy = parcelRequire("1JRGy");

var $doMYO = parcelRequire("doMYO");

var $hqddj = parcelRequire("hqddj");

var $7lC8o = parcelRequire("7lC8o");

var $737na = parcelRequire("737na");

var $iy2Wm = parcelRequire("iy2Wm");

var $76XtE = parcelRequire("76XtE");

var $fcxz7 = parcelRequire("fcxz7");

var $dJpcp = parcelRequire("dJpcp");
const $6cfb373adcb92a72$export$9c3b774af0e8f6c4 = ({ dispatch: dispatch })=>(next)=>(action)=>{
            switch(action.type){
                case 'MFA_VERIFICATION_VERIFY':
                    next(action);
                    // The action that calls fetch (/verify) and redirects
                    return dispatch($6cfb373adcb92a72$export$5d2dfc489f5d5678(action));
                case 'MFA_VERIFICATION_RESEND_OTP':
                    next(action);
                    // The action that calls fetch to resend OTP code
                    // Transport (i.e. via SMS or Email) is determined by the mfa token.
                    return dispatch($6cfb373adcb92a72$export$6a7404e2291306ab(action));
                case 'MFA_VERIFICATION_RECOVER':
                    next(action);
                    // The action that verifies recovery code
                    return dispatch($6cfb373adcb92a72$export$d76d4fe28235a83(action));
                case 'MFA_VERIFICATION_CONFIRMED_RECOVER':
                    next(action);
                    // The action that calls /mfa/authorize and redirects
                    return dispatch($6cfb373adcb92a72$export$8cfa5c421bdc24ae(action));
                case 'MFA_VERIFICATION_CHANGE_FACTOR':
                    next(action);
                    // The action that calls /mfa/change to switch MFA factors
                    return dispatch($6cfb373adcb92a72$export$38c17aec706fc109(action));
                default:
                    next(action);
            }
        };
const $6cfb373adcb92a72$export$6a7404e2291306ab = ({ params: params, analyticsClient: analyticsClient, navigate: navigate, mfaMethod: mfaMethod })=>async (dispatch, getState)=>{
        try {
            const response = await fetch(`/rest/mfa/resend${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getState().csrfToken
                }
            });
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(params);
            switch(response.status){
                case 200:
                    const { transactionToken: transactionToken } = await response.json();
                    navigate({
                        search: `?${new URLSearchParams({
                            transactionToken: transactionToken
                        })}`
                    }, {
                        replace: true
                    });
                    if (mfaMethod === 'email-otp') dispatch((0, $7lC8o.addFlag)('success', (0, $737na.default).mfEmailResentSuccessTitle, (0, $737na.default).mfEmailResentSuccessDesc));
                    else dispatch((0, $7lC8o.addFlag)('success', (0, $737na.default).mfRecoverySMSResentSuccessTitle, (0, $737na.default).mfRecoverySMSResentSuccessDesc));
                    break;
                case 400:
                    $6cfb373adcb92a72$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: '2svChallengeScreen',
                        subjectId: '2svIncorrectToken',
                        currentQueryParams: queryParams,
                        navigate: navigate
                    });
                    break;
                case 422:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svInvalidPhoneNumber');
                    return dispatch((0, $7lC8o.addFlag)('error', (0, $737na.default).mfVerifyErrorTitle, (0, $737na.default).mfSmsInvalidPhoneNumberDesc));
                case 429:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svTooManySms');
                    $6cfb373adcb92a72$var$handleError(dispatch);
                    break;
                default:
                    const error = await response.text();
                    throw new Error(error || response.statusText);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svChallengeScreen', '2svUnknownError');
            $6cfb373adcb92a72$var$handleError(dispatch);
            (0, $hqddj.captureException)(error);
        }
    };
const $6cfb373adcb92a72$export$5d2dfc489f5d5678 = ({ params: params, otpCode: otpCode, analyticsClient: analyticsClient, maybeHardRedirect: maybeHardRedirect })=>async (dispatch, getState)=>{
        try {
            const token = await (0, $dJpcp.getCastleRequestToken)([
                'capability-group--login',
                'capability-name--mfa'
            ]);
            const response = await fetch(`/rest/mfa/verify${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getState().csrfToken
                },
                body: JSON.stringify({
                    otpCode: otpCode,
                    ...token && {
                        token: token
                    }
                })
            });
            switch(response.status){
                case 200:
                    {
                        const { transactionToken: transactionToken } = await response.json();
                        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(params);
                        queryParams.transactionToken = transactionToken;
                        const authorizeResponse = await fetch(`/rest/mfa/authorize?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(queryParams)}`);
                        if (!authorizeResponse.ok) {
                            const error = await authorizeResponse.text();
                            throw new Error(error || authorizeResponse.statusText);
                        }
                        const { redirectUri: redirectUri } = await authorizeResponse.json();
                        maybeHardRedirect(redirectUri);
                        break;
                    }
                case 400:
                    {
                        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(params);
                        $6cfb373adcb92a72$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                            analyticsClient: analyticsClient,
                            page: '2svChallengeScreen',
                            subjectId: '2svIncorrectToken',
                            currentQueryParams: queryParams,
                            navigate: maybeHardRedirect
                        });
                        break;
                    }
                case 403:
                case 429:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svIncorrectCode');
                    dispatch((0, $doMYO.mfaVerifyError)({
                        errorCode: 'invalid_otp',
                        message: 'invalid otp code'
                    }));
                    break;
                default:
                    const error = await response.text();
                    throw new Error(error || response.statusText);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svChallengeScreen', '2svUnknownError');
            $6cfb373adcb92a72$var$handleError(dispatch);
            (0, $hqddj.captureException)(error);
        }
    };
const $6cfb373adcb92a72$export$d76d4fe28235a83 = ({ params: params, recoveryCode: recoveryCode, analyticsClient: analyticsClient, navigate: navigate })=>async (dispatch, getState)=>{
        try {
            const response = await fetch(`/rest/mfa/verify/recoverycode${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getState().csrfToken
                },
                body: JSON.stringify({
                    recoveryCode: recoveryCode
                })
            });
            switch(response.status){
                case 200:
                    const { recoveryCode: recoveryCode1, transactionToken: transactionToken } = await response.json();
                    const newParams = {
                        continue: (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(params).continue,
                        transactionToken: transactionToken.toString()
                    };
                    navigate({
                        search: `?${(0, $lwrli.createSearchParams)(newParams)}`
                    }, {
                        replace: true
                    });
                    dispatch((0, $doMYO.mfaRecoverResponse)({
                        recoveryCode: recoveryCode1
                    }));
                    break;
                case 400:
                    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(params);
                    $6cfb373adcb92a72$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: '2svRecoveryKeyScreen',
                        subjectId: '2svIncorrectToken',
                        currentQueryParams: queryParams,
                        navigate: navigate
                    });
                    break;
                case 403:
                case 429:
                    analyticsClient.errorShownEvent('2svRecoveryKeyScreen', '2svIncorrectCode');
                    dispatch((0, $doMYO.mfaRecoverError)({
                        errorCode: 'invalid_recovery_code',
                        message: 'invalid recovery code'
                    }));
                    break;
                default:
                    const error = await response.text();
                    throw new Error(`Unexpected response from POST /rest/mfa/verify/recoverycode: ${error || response.statusText}`);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svRecoveryKeyScreen', '2svUnknownError');
            $6cfb373adcb92a72$var$handleError(dispatch);
            (0, $hqddj.captureException)(error);
        }
    };
const $6cfb373adcb92a72$export$8cfa5c421bdc24ae = ({ params: params, analyticsClient: analyticsClient, maybeHardRedirect: maybeHardRedirect })=>async (dispatch)=>{
        try {
            const response = await fetch(`/rest/mfa/authorize${params}`);
            switch(response.status){
                case 200:
                    const { redirectUri: redirectUri } = await response.json();
                    maybeHardRedirect(redirectUri);
                    break;
                case 400:
                case 403:
                    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(params);
                    $6cfb373adcb92a72$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: '2svSavedNewRecoveryKey',
                        subjectId: '2svIncorrectToken',
                        currentQueryParams: queryParams,
                        navigate: maybeHardRedirect
                    });
                    break;
                default:
                    const error = await response.text();
                    throw new Error(`Unexpected response from GET /rest/mfa/authorize: ${error || response.statusText}`);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svSavedNewRecoveryKey', '2svUnknownError');
            $6cfb373adcb92a72$var$handleError(dispatch);
            (0, $hqddj.captureException)(error);
        }
    };
const $6cfb373adcb92a72$var$getSwitchMfaFactorErrorFlagMessages = (reason)=>{
    if (reason) switch(reason){
        case 'invalid_factor_type':
        case 'user_not_enrolled':
            return {
                title: (0, $737na.default).mfSwitchFactorInvalidFactorTypeTitle,
                description: (0, $737na.default).mfSwitchFactorInvalidFactorTypeDesc
            };
        case 'invalid_transaction_token':
            return {
                title: (0, $737na.default).mfSwitchFactorInvalidTokenTitle,
                description: (0, $737na.default).mfSwitchFactorInvalidTokenDesc
            };
        case 'expired_transaction_token':
            return {
                title: (0, $737na.default).mfSwitchFactorTransactionExpiredTitle,
                description: (0, $737na.default).mfSwitchFactorTransactionExpiredDesc
            };
    }
    return {
        title: (0, $737na.default).mfSwitchFactorErrorTitle,
        description: (0, $737na.default).mfSwitchFactorErrorDesc
    };
};
const $6cfb373adcb92a72$export$38c17aec706fc109 = ({ params: params, factor: factor, analyticsClient: analyticsClient, navigate: navigate })=>async (dispatch)=>{
        try {
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(params);
            const transactionToken = queryParams.transactionToken;
            if (!transactionToken) throw new Error('No transaction token found');
            const response = await fetch(`/rest/mfa/change?transactionToken=${transactionToken}&factor=${factor}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            switch(response.status){
                case 200:
                    {
                        const { token: newTransactionToken } = await response.json();
                        const updatedQueryParamString = (0, $fcxz7.replaceQueryParam)('transactionToken', newTransactionToken);
                        try {
                            const newStateResponse = await fetch(`/rest/login/mfa/state${updatedQueryParamString}`);
                            switch(newStateResponse.status){
                                case 200:
                                    {
                                        // This updates the search query params in the address bar, but does not trigger
                                        // a page reload due to the pathname remains unchanged
                                        // Setting this would ensure the user loads the page with the updated token should
                                        // they refresh (eg. F5) the page
                                        navigate({
                                            search: updatedQueryParamString
                                        });
                                        const newState = await newStateResponse.json();
                                        const transformedState = await (0, $iy2Wm.buildInitialState)(newState);
                                        dispatch((0, $76XtE.resetAppState)(transformedState.initialStoreState));
                                        dispatch((0, $doMYO.resetMfaOtpInput)());
                                        break;
                                    }
                                default:
                                    throw Error(`Unexpected status code when fetching new state after switching MFA factor: ${response.status}`);
                            }
                        } catch (error) {
                            dispatch((0, $7lC8o.addFlag)('error', (0, $737na.default).mfSwitchFactorErrorTitle, (0, $737na.default).mfSwitchFactorErrorDesc));
                            (0, $hqddj.captureException)(error);
                        }
                        break;
                    }
                case 400:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svSwitchFactorBadRequest');
                    try {
                        const errorResponse = await response.json();
                        const { title: title, description: description } = $6cfb373adcb92a72$var$getSwitchMfaFactorErrorFlagMessages(errorResponse?.context?.reason);
                        dispatch((0, $7lC8o.addFlag)('error', title, description));
                    } catch (error) {
                        dispatch((0, $7lC8o.addFlag)('error', (0, $737na.default).mfSwitchFactorErrorTitle, (0, $737na.default).mfSwitchFactorErrorDesc));
                        (0, $hqddj.captureException)(error);
                    }
                    break;
                case 429:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svSwitchFactorTooManyAttempts');
                    dispatch((0, $7lC8o.addFlag)('error', (0, $737na.default).mfSwitchFactorTooManyAttemptsTitle, (0, $737na.default).mfSwitchFactorTooManyAttemptsDesc));
                    break;
                default:
                    const error = await response.text();
                    throw new Error(error || response.statusText);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svChallengeScreen', '2svSwitchFactorUnknownError');
            dispatch((0, $7lC8o.addFlag)('error', (0, $737na.default).mfSwitchFactorErrorTitle, (0, $737na.default).mfSwitchFactorErrorDesc));
            (0, $hqddj.captureException)(error);
        }
    };
function $6cfb373adcb92a72$var$handleError(dispatch) {
    return dispatch((0, $7lC8o.addFlag)('error', (0, $737na.default).mfVerifyErrorTitle, (0, $737na.default).mfVerifyErrorDesc));
}
function $6cfb373adcb92a72$var$redirectToLoginErrorOn400IncorrectTokenResponse({ analyticsClient: analyticsClient, page: page, subjectId: subjectId, currentQueryParams: currentQueryParams, navigate: navigate }) {
    analyticsClient.errorShownEvent(page, subjectId);
    delete currentQueryParams.transactionToken;
    delete currentQueryParams.errorCode;
    const currentQueryString = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(currentQueryParams);
    const extraParamsString = currentQueryString === '' ? '' : `&${currentQueryString}`;
    navigate(`/login?prompt=true&errorCode=login.form.token.expired${extraParamsString}`);
}

});
parcelRegister("doMYO", function(module, exports) {

$parcel$export(module.exports, "confirmedRecoveryCode", function () { return $9386fa2d2ce52997$export$9d6418e9b0c5e37; });
$parcel$export(module.exports, "verifyOtpCode", function () { return $9386fa2d2ce52997$export$a5c568dd7addf7ae; });
$parcel$export(module.exports, "resendOtp", function () { return $9386fa2d2ce52997$export$fa0ba0eb6a79519c; });
$parcel$export(module.exports, "recoverAccount", function () { return $9386fa2d2ce52997$export$5e6ce816cc4182a; });
$parcel$export(module.exports, "mfaRecoverResponse", function () { return $9386fa2d2ce52997$export$9034102f3c89e717; });
$parcel$export(module.exports, "mfaVerifyError", function () { return $9386fa2d2ce52997$export$2026ab15e46bd57d; });
$parcel$export(module.exports, "mfaRecoverError", function () { return $9386fa2d2ce52997$export$3652b92f5dbdf874; });
$parcel$export(module.exports, "switchMfaFactor", function () { return $9386fa2d2ce52997$export$3c9096ff6f777303; });
$parcel$export(module.exports, "resetMfaOtpInput", function () { return $9386fa2d2ce52997$export$c82f9f96ca3abc9d; });
$parcel$export(module.exports, "sendRecoveryEmail", function () { return $9386fa2d2ce52997$export$ad7f1a4d46b544fc; });

var $chJxj = parcelRequire("chJxj");

var $hhYxc = parcelRequire("hhYxc");

var $hqddj = parcelRequire("hqddj");
const $9386fa2d2ce52997$export$9d6418e9b0c5e37 = (params, analyticsClient, maybeHardRedirect)=>({
        type: 'MFA_VERIFICATION_CONFIRMED_RECOVER',
        params: params,
        analyticsClient: analyticsClient,
        maybeHardRedirect: maybeHardRedirect
    });
const $9386fa2d2ce52997$export$a5c568dd7addf7ae = (params, otpCode, analyticsClient, maybeHardRedirect)=>({
        type: 'MFA_VERIFICATION_VERIFY',
        params: params,
        otpCode: otpCode,
        analyticsClient: analyticsClient,
        maybeHardRedirect: maybeHardRedirect
    });
const $9386fa2d2ce52997$export$fa0ba0eb6a79519c = (params, analyticsClient, navigate, mfaMethod)=>({
        type: 'MFA_VERIFICATION_RESEND_OTP',
        params: params,
        analyticsClient: analyticsClient,
        navigate: navigate,
        mfaMethod: mfaMethod
    });
const $9386fa2d2ce52997$export$5e6ce816cc4182a = (params, recoveryCode, analyticsClient, navigate)=>({
        type: 'MFA_VERIFICATION_RECOVER',
        params: params,
        recoveryCode: recoveryCode,
        analyticsClient: analyticsClient,
        navigate: navigate
    });
const $9386fa2d2ce52997$export$9034102f3c89e717 = ({ recoveryCode: recoveryCode })=>({
        type: 'MFA_VERIFICATION_RECOVER_RESPONSE',
        recoveryCode: recoveryCode
    });
const $9386fa2d2ce52997$export$2026ab15e46bd57d = ({ errorCode: errorCode, message: message })=>({
        type: 'MFA_VERIFICATION_VERIFY_ERROR',
        errorCode: errorCode,
        message: message
    });
const $9386fa2d2ce52997$export$3652b92f5dbdf874 = ({ errorCode: errorCode, message: message })=>({
        type: 'MFA_VERIFICATION_RECOVER_ERROR',
        errorCode: errorCode,
        message: message
    });
const $9386fa2d2ce52997$export$b147b2e1028c65fa = ()=>({
        type: 'RECOVERY_EMAIL_SENT'
    });
const $9386fa2d2ce52997$export$cc7dfbcab13c5eea = ()=>({
        type: 'RECOVERY_EMAIL_START'
    });
const $9386fa2d2ce52997$export$b760122b98e1a9be = (reason)=>({
        type: 'RECOVERY_EMAIL_ERROR',
        reason: reason
    });
const $9386fa2d2ce52997$export$3c9096ff6f777303 = (params, factor, analyticsClient, navigate)=>({
        type: 'MFA_VERIFICATION_CHANGE_FACTOR',
        params: params,
        factor: factor,
        analyticsClient: analyticsClient,
        navigate: navigate
    });
const $9386fa2d2ce52997$export$c82f9f96ca3abc9d = ()=>({
        type: 'MFA_RESET_OTP_INPUT'
    });
const $9386fa2d2ce52997$export$ad7f1a4d46b544fc = (email)=>async (dispatch)=>{
        dispatch($9386fa2d2ce52997$export$cc7dfbcab13c5eea());
        try {
            const response = await fetch(`${(0, $hhYxc.idacOrigin)}/rest/tsv-recovery/trigger`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email
                })
            });
            const body = await response.json();
            const errorReason = body?.error?.reason;
            // Note that sing-in-service may return an error reason with a 200 response, in cases where
            // a non-200 response could introduce an account enumeration vulnerability.
            if (response.ok && !errorReason) dispatch($9386fa2d2ce52997$export$b147b2e1028c65fa());
            else {
                const narrowedReason = $9386fa2d2ce52997$var$narrowErrorReason(errorReason);
                dispatch($9386fa2d2ce52997$export$b760122b98e1a9be(narrowedReason));
            }
        } catch (e) {
            (0, $hqddj.captureException)(e);
            dispatch($9386fa2d2ce52997$export$b760122b98e1a9be('unknown'));
        }
    };
const $9386fa2d2ce52997$var$isKnownRecoveryEmailErrorReason = (reason)=>(0, $chJxj.KnownRecoveryEmailErrorReasons).includes(reason);
/** Maps arbitrary string returned by API to a type-safe value compatible with the redux state */ const $9386fa2d2ce52997$var$narrowErrorReason = (reason)=>{
    if (reason && $9386fa2d2ce52997$var$isKnownRecoveryEmailErrorReason(reason)) return reason;
    return 'unknown';
};

});

parcelRegister("7lC8o", function(module, exports) {

$parcel$export(module.exports, "addFlag", function () { return $2a107d8a204de44b$export$820a1da46c7a4303; });
$parcel$export(module.exports, "dismissFlag", function () { return $2a107d8a204de44b$export$900a08a292ad23cd; });

var $aza3U = parcelRequire("aza3U");
const $2a107d8a204de44b$export$820a1da46c7a4303 = (type, title, description)=>({
        type: 'FLAG_ADD',
        flag: {
            type: type,
            title: title,
            description: description,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($aza3U))).v4()
        }
    });
const $2a107d8a204de44b$export$900a08a292ad23cd = ()=>({
        type: 'FLAG_DISMISS'
    });

});

parcelRegister("737na", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca5f65643d94af85$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $ca5f65643d94af85$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    loginHeadTitle: {
        id: 'mf.login.head.title',
        defaultMessage: 'Continue with multi-factor authentication',
        description: ''
    },
    // Flags
    mfRecoveryEmailResentSuccessTitle: {
        id: 'mf.recoveryemailresentsuccess.title',
        defaultMessage: 'Recovery email resent!',
        description: ''
    },
    mfRecoveryEmailResentSuccessDesc: {
        id: 'mf.recoveryemailresentsuccess',
        defaultMessage: 'A recovery email has been resent to you!',
        description: ''
    },
    mfRecoveryEmailResentErrorTitle: {
        id: 'mf.recoveryemailresenterror.title',
        defaultMessage: 'Something went wrong.',
        description: ''
    },
    mfRecoveryEmailResentErrorDesc: {
        id: 'mf.recoveryemailresenterror',
        defaultMessage: "We couldn\u2019t send the recovery email. Please try again later.",
        description: ''
    },
    mfRecoverySMSResentSuccessTitle: {
        id: 'mf.recoverysmsresentsuccess.title',
        defaultMessage: 'SMS resent!',
        description: ''
    },
    mfRecoverySMSResentSuccessDesc: {
        id: 'mf.recoverysmsresentsuccess',
        defaultMessage: 'A SMS has been resent to you!',
        description: ''
    },
    mfEmailResentSuccessTitle: {
        id: 'mf.emailresentsuccess.title',
        defaultMessage: 'Email resent!',
        description: ''
    },
    mfEmailResentSuccessDesc: {
        id: 'mf.emailresentsuccess',
        defaultMessage: 'An Email has been resent to you!',
        description: ''
    },
    mfVerifyErrorTitle: {
        id: 'guardian.error.default.flag.title',
        defaultMessage: "Oops, that didn't work!"
    },
    mfVerifyErrorDesc: {
        id: 'guardian.error.default.flag.description',
        defaultMessage: 'Try that again in a moment.'
    },
    // eg. if Twilio deprecates service in the country
    mfSmsInvalidPhoneNumberDesc: {
        id: 'mf.sms.invalidphonenumber.description',
        defaultMessage: 'Unable to send verification code to the registered phone number. Try again later, or navigate to the recovery code screen and use your recovery code to continue.'
    },
    mfSwitchToSms: {
        id: 'mf.switch-to.sms',
        defaultMessage: 'Use SMS',
        description: 'Button text to switch to SMS verification'
    },
    mfSwitchToTotp: {
        id: 'mf.switch-to.authenticator',
        defaultMessage: 'Use authenticator app',
        description: 'Button text to switch to authenticator verification'
    },
    mfSwitchToSecurityKey: {
        id: 'mf.switch-to.security.key',
        defaultMessage: 'Use security key',
        description: 'Button text to switch to security key verification'
    },
    mfSwitchFactorInvalidFactorTypeTitle: {
        id: 'mf.switch-factor.invalid-factor-type.title',
        defaultMessage: 'Invalid method',
        description: 'Title for invalid factor type error when switching MFA factors'
    },
    mfSwitchFactorInvalidFactorTypeDesc: {
        id: 'mf.switch-factor.invalid-factor-type.description',
        defaultMessage: 'The selected verification method is not supported. Try a different option.',
        description: 'Description for invalid factor type error when switching MFA factors'
    },
    mfSwitchFactorInvalidTokenTitle: {
        id: 'mf.switch-factor.invalid-transaction-token.title',
        defaultMessage: 'Invalid request',
        description: 'Title for invalid transaction token error when switching MFA factors'
    },
    mfSwitchFactorInvalidTokenDesc: {
        id: 'mf.switch-factor.invalid-transaction-token.description',
        defaultMessage: 'Your request cannot be processed.',
        description: 'Description for invalid token error when switching MFA factors'
    },
    mfSwitchFactorTransactionExpiredTitle: {
        id: 'mf.switch-factor.expired_transaction_token.title',
        defaultMessage: 'Request expired',
        description: 'Title for expired transaction error when switching MFA factors'
    },
    mfSwitchFactorTransactionExpiredDesc: {
        id: 'mf.switch-factor.expired-transaction-token.description',
        defaultMessage: 'Your login request has expired',
        description: 'Description for expired transaction when switching MFA factors'
    },
    mfSwitchFactorTooManyAttemptsTitle: {
        id: 'mf.switch-factor.too-many-attempts.title',
        defaultMessage: 'Too many requests',
        description: 'Title for reaching rate limit when switching MFA factors'
    },
    mfSwitchFactorTooManyAttemptsDesc: {
        id: 'mf.switch-factor.too-many-attempts.description',
        defaultMessage: "You've reached your rate limit. Try again in a few minutes.",
        description: 'Description for reaching rate limit when switching MFA factors'
    },
    mfSwitchFactorErrorTitle: {
        id: 'mf.switch-factor.error.title',
        defaultMessage: 'Unable to change method',
        description: 'Title for generic factor switching error'
    },
    mfSwitchFactorErrorDesc: {
        id: 'mf.switch-factor.error.description',
        defaultMessage: 'We encountered an issue while changing your verification method. Try again later.',
        description: 'Description for generic factor switching error'
    },
    // recovery code
    mfSwitchToRecoveryCode: {
        id: 'mf.switch-to.recovery-code',
        defaultMessage: 'Use recovery key',
        description: 'Button text to switch to solving MFA challenge with recovery key'
    }
});

});
parcelRegister("2CYmK", function(module, exports) {

$parcel$export(module.exports, "defineMessages", function () { return $1e9df4cc6463ac28$export$1adfeb024f5185b; });
$parcel$export(module.exports, "defineMessage", function () { return $1e9df4cc6463ac28$export$747d244ee58120dd; });

var $61LJF = parcelRequire("61LJF");


var $ko1o6 = parcelRequire("ko1o6");

var $aC9Kp = parcelRequire("aC9Kp");




var $3YSXY = parcelRequire("3YSXY");


function $1e9df4cc6463ac28$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $1e9df4cc6463ac28$export$747d244ee58120dd(msg) {
    return msg;
}
var $1e9df4cc6463ac28$export$40ae3194919d16b = (0, $61LJF.createFormattedComponent)('formatDate');
var $1e9df4cc6463ac28$export$5b390a54f8a846f7 = (0, $61LJF.createFormattedComponent)('formatTime');
var $1e9df4cc6463ac28$export$db80edc1e6b2f63d = (0, $61LJF.createFormattedComponent)('formatNumber');
var $1e9df4cc6463ac28$export$f52b44e459e6e71d = (0, $61LJF.createFormattedComponent)('formatList');
var $1e9df4cc6463ac28$export$c2336ea5aaab92fa = (0, $61LJF.createFormattedComponent)('formatDisplayName');
var $1e9df4cc6463ac28$export$7fdc7d2c91ce149b = (0, $61LJF.createFormattedDateTimePartsComponent)('formatDate');
var $1e9df4cc6463ac28$export$ec35873761676c2a = (0, $61LJF.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("61LJF", function(module, exports) {

$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $4637dd5c0db628de$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $4637dd5c0db628de$export$b37e14176d001dec; });

var $hwth3 = parcelRequire("hwth3");

var $dNMDr = parcelRequire("dNMDr");

var $ko1o6 = parcelRequire("ko1o6");
var $4637dd5c0db628de$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($4637dd5c0db628de$var$DisplayName || ($4637dd5c0db628de$var$DisplayName = {}));
var $4637dd5c0db628de$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($4637dd5c0db628de$var$DisplayNameParts || ($4637dd5c0db628de$var$DisplayNameParts = {}));
var $4637dd5c0db628de$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $ko1o6.default)();
    var value = props.value, children = props.children, formatProps = (0, $hwth3.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$4637dd5c0db628de$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $4637dd5c0db628de$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $ko1o6.default)();
    var value = props.value, children = props.children, formatProps = (0, $hwth3.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$4637dd5c0db628de$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $4637dd5c0db628de$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $ko1o6.default)();
        var value = props.value, children = props.children, formatProps = (0, $hwth3.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $4637dd5c0db628de$var$DisplayNameParts[name];
    return ComponentParts;
}
function $4637dd5c0db628de$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $ko1o6.default)();
        var value = props.value, children = props.children, formatProps = (0, $hwth3.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $dNMDr.Fragment;
        return $dNMDr.createElement(Text, null, formattedValue);
    };
    Component.displayName = $4637dd5c0db628de$var$DisplayName[name];
    return Component;
}

});
parcelRegister("hwth3", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $cc1c22122b19190a$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $cc1c22122b19190a$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $cc1c22122b19190a$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $cc1c22122b19190a$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $cc1c22122b19190a$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spreadArray", function () { return $cc1c22122b19190a$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $cc1c22122b19190a$var$extendStatics = function(d, b) {
    $cc1c22122b19190a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $cc1c22122b19190a$var$extendStatics(d, b);
};
function $cc1c22122b19190a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $cc1c22122b19190a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $cc1c22122b19190a$export$18ce0697a983be9b = function() {
    $cc1c22122b19190a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cc1c22122b19190a$export$18ce0697a983be9b.apply(this, arguments);
};
function $cc1c22122b19190a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $cc1c22122b19190a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $cc1c22122b19190a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $cc1c22122b19190a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $cc1c22122b19190a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $cc1c22122b19190a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $cc1c22122b19190a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $cc1c22122b19190a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $cc1c22122b19190a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $cc1c22122b19190a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $cc1c22122b19190a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $cc1c22122b19190a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $cc1c22122b19190a$export$45d3717a4c69092e(o, m, p);
}
function $cc1c22122b19190a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $cc1c22122b19190a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $cc1c22122b19190a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($cc1c22122b19190a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $cc1c22122b19190a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $cc1c22122b19190a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $cc1c22122b19190a$export$10c90e4f7922046c(v) {
    return this instanceof $cc1c22122b19190a$export$10c90e4f7922046c ? (this.v = v, this) : new $cc1c22122b19190a$export$10c90e4f7922046c(v);
}
function $cc1c22122b19190a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $cc1c22122b19190a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $cc1c22122b19190a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $cc1c22122b19190a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $cc1c22122b19190a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $cc1c22122b19190a$export$19a8beecd37a4c45 === "function" ? $cc1c22122b19190a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $cc1c22122b19190a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $cc1c22122b19190a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $cc1c22122b19190a$var$ownKeys = function(o) {
    $cc1c22122b19190a$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $cc1c22122b19190a$var$ownKeys(o);
};
function $cc1c22122b19190a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $cc1c22122b19190a$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $cc1c22122b19190a$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $cc1c22122b19190a$var$__setModuleDefault(result, mod);
    return result;
}
function $cc1c22122b19190a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $cc1c22122b19190a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $cc1c22122b19190a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $cc1c22122b19190a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $cc1c22122b19190a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $cc1c22122b19190a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $cc1c22122b19190a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $cc1c22122b19190a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $cc1c22122b19190a$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $cc1c22122b19190a$export$2e2bcd8739ae039 = {
    __extends: $cc1c22122b19190a$export$a8ba968b8961cb8a,
    __assign: $cc1c22122b19190a$export$18ce0697a983be9b,
    __rest: $cc1c22122b19190a$export$3c9a16f847548506,
    __decorate: $cc1c22122b19190a$export$29e00dfd3077644b,
    __param: $cc1c22122b19190a$export$d5ad3fd78186038f,
    __esDecorate: $cc1c22122b19190a$export$3a84e1ae4e97e9b0,
    __runInitializers: $cc1c22122b19190a$export$d831c04e792af3d,
    __propKey: $cc1c22122b19190a$export$6a2a36740a146cb8,
    __setFunctionName: $cc1c22122b19190a$export$d1a06452d3489bc7,
    __metadata: $cc1c22122b19190a$export$f1db080c865becb9,
    __awaiter: $cc1c22122b19190a$export$1050f835b63b671e,
    __generator: $cc1c22122b19190a$export$67ebef60e6f28a6,
    __createBinding: $cc1c22122b19190a$export$45d3717a4c69092e,
    __exportStar: $cc1c22122b19190a$export$f33643c0debef087,
    __values: $cc1c22122b19190a$export$19a8beecd37a4c45,
    __read: $cc1c22122b19190a$export$8d051b38c9118094,
    __spread: $cc1c22122b19190a$export$afc72e2116322959,
    __spreadArrays: $cc1c22122b19190a$export$6388937ca91ccae8,
    __spreadArray: $cc1c22122b19190a$export$1216008129fb82ed,
    __await: $cc1c22122b19190a$export$10c90e4f7922046c,
    __asyncGenerator: $cc1c22122b19190a$export$e427f37a30a4de9b,
    __asyncDelegator: $cc1c22122b19190a$export$bbd80228419bb833,
    __asyncValues: $cc1c22122b19190a$export$e3b29a3d6162315f,
    __makeTemplateObject: $cc1c22122b19190a$export$4fb47efe1390b86f,
    __importStar: $cc1c22122b19190a$export$c21735bcef00d192,
    __importDefault: $cc1c22122b19190a$export$da59b14a69baef04,
    __classPrivateFieldGet: $cc1c22122b19190a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $cc1c22122b19190a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $cc1c22122b19190a$export$81fdc39f203e4e04,
    __addDisposableResource: $cc1c22122b19190a$export$88ac25d8e944e405,
    __disposeResources: $cc1c22122b19190a$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $cc1c22122b19190a$export$889dfb5d17574b0b
};

});

parcelRegister("ko1o6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed77202131ae1e7c$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $2klZT = parcelRequire("2klZT");

var $e8qF3 = parcelRequire("e8qF3");
function $ed77202131ae1e7c$export$2e2bcd8739ae039() {
    var intl = $dNMDr.useContext((0, $e8qF3.Context));
    (0, $2klZT.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("2klZT", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $1b1e833a713fdc7e$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $1b1e833a713fdc7e$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $1b1e833a713fdc7e$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $1b1e833a713fdc7e$export$d36bdfa510afb180; });

var $hwth3 = parcelRequire("hwth3");

var $dNMDr = parcelRequire("dNMDr");

var $iCqeG = parcelRequire("iCqeG");

var $g1A3N = parcelRequire("g1A3N");
function $1b1e833a713fdc7e$export$45c4bbf6e55bba1f(intl) {
    (0, $iCqeG.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $1b1e833a713fdc7e$export$b52f8d6fc0d47415 = (0, $hwth3.__assign)((0, $hwth3.__assign)({}, (0, $g1A3N.DEFAULT_INTL_CONFIG)), {
    textComponent: $dNMDr.Fragment
});
function $1b1e833a713fdc7e$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($dNMDr.Children.toArray(parts));
    };
}
function $1b1e833a713fdc7e$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("iCqeG", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $d8e02078cb72ff15$export$f5708dca728d7177; });

var $hwth3 = parcelRequire("hwth3");

var $i1d8M = parcelRequire("i1d8M");
function $d8e02078cb72ff15$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $d8e02078cb72ff15$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $d8e02078cb72ff15$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $d8e02078cb72ff15$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $d8e02078cb72ff15$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $d8e02078cb72ff15$export$3fae2929ed23c202(map, pl, field) {
    return $d8e02078cb72ff15$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $d8e02078cb72ff15$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $d8e02078cb72ff15$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $d8e02078cb72ff15$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $d8e02078cb72ff15$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $d8e02078cb72ff15$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $d8e02078cb72ff15$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
var $d8e02078cb72ff15$export$a99e4aaac79eeead = (0, $i1d8M.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $hwth3.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $i1d8M.strategies).variadic
});
var $d8e02078cb72ff15$export$b479a1a2d8754359 = (0, $i1d8M.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $hwth3.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $i1d8M.strategies).variadic
});
var $d8e02078cb72ff15$export$569bb3095db8432e = (0, $i1d8M.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $hwth3.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $i1d8M.strategies).variadic
});
var $d8e02078cb72ff15$export$e124bc7d23dd0e5a = (0, $i1d8M.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.Locale).bind.apply(_a, (0, $hwth3.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $i1d8M.strategies).variadic
});
var $d8e02078cb72ff15$export$a1209f8c6068edc3 = (0, $i1d8M.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.ListFormat).bind.apply(_a, (0, $hwth3.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $i1d8M.strategies).variadic
});

});
parcelRegister("i1d8M", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $d1e2837603e62328$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $d1e2837603e62328$export$c5491a8691a23b9e; });
//
// Main
//
function $d1e2837603e62328$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $d1e2837603e62328$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $d1e2837603e62328$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $d1e2837603e62328$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $d1e2837603e62328$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $d1e2837603e62328$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $d1e2837603e62328$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $d1e2837603e62328$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $d1e2837603e62328$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $d1e2837603e62328$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $d1e2837603e62328$var$monadic : $d1e2837603e62328$var$variadic;
    return $d1e2837603e62328$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $d1e2837603e62328$var$strategyVariadic(fn, options) {
    return $d1e2837603e62328$var$assemble(fn, this, $d1e2837603e62328$var$variadic, options.cache.create(), options.serializer);
}
function $d1e2837603e62328$var$strategyMonadic(fn, options) {
    return $d1e2837603e62328$var$assemble(fn, this, $d1e2837603e62328$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $d1e2837603e62328$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $d1e2837603e62328$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$d1e2837603e62328$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$d1e2837603e62328$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $d1e2837603e62328$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $d1e2837603e62328$var$ObjectWithoutPrototypeCache();
    }
};
var $d1e2837603e62328$export$c5491a8691a23b9e = {
    variadic: $d1e2837603e62328$var$strategyVariadic,
    monadic: $d1e2837603e62328$var$strategyMonadic
};

});


parcelRegister("g1A3N", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $baa8b62764da4204$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $baa8b62764da4204$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $baa8b62764da4204$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $baa8b62764da4204$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $baa8b62764da4204$export$4ee1db8ce44a209b; });

var $hwth3 = parcelRequire("hwth3");
parcelRequire("aI3d0");
var $dMkYi = parcelRequire("dMkYi");

var $i1d8M = parcelRequire("i1d8M");

var $iTGck = parcelRequire("iTGck");
function $baa8b62764da4204$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $baa8b62764da4204$var$defaultErrorHandler = function(error) {};
var $baa8b62764da4204$var$defaultWarnHandler = function(warning) {};
var $baa8b62764da4204$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $baa8b62764da4204$var$defaultErrorHandler,
    onWarn: $baa8b62764da4204$var$defaultWarnHandler
};
function $baa8b62764da4204$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $baa8b62764da4204$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $baa8b62764da4204$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $baa8b62764da4204$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $i1d8M.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $hwth3.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $baa8b62764da4204$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $i1d8M.strategies).variadic
    });
    var getNumberFormat = (0, $i1d8M.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $hwth3.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $baa8b62764da4204$var$createFastMemoizeCache(cache.number),
        strategy: (0, $i1d8M.strategies).variadic
    });
    var getPluralRules = (0, $i1d8M.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $hwth3.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $baa8b62764da4204$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $i1d8M.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $i1d8M.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $dMkYi.IntlMessageFormat)(message, locales, overrideFormats, (0, $hwth3.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $baa8b62764da4204$var$createFastMemoizeCache(cache.message),
            strategy: (0, $i1d8M.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $i1d8M.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $hwth3.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $baa8b62764da4204$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $i1d8M.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $i1d8M.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $hwth3.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $baa8b62764da4204$var$createFastMemoizeCache(cache.list),
            strategy: (0, $i1d8M.strategies).variadic
        }),
        getDisplayNames: (0, $i1d8M.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $hwth3.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $baa8b62764da4204$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $i1d8M.strategies).variadic
        })
    };
}
function $baa8b62764da4204$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $iTGck.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("aI3d0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", function () { return (parcelRequire("fclNO")).ErrorCode; });
$parcel$export(module.exports, "FormatError", function () { return (parcelRequire("fclNO")).FormatError; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return (parcelRequire("cy0YZ")).isFormatXMLElementFn; });

$parcel$export(module.exports, "IntlMessageFormat", function () { return (parcelRequire("dMkYi")).IntlMessageFormat; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $dMkYi = parcelRequire("dMkYi");
parcelRequire("fclNO");
parcelRequire("cy0YZ");
var $7cc0809d153af33a$export$2e2bcd8739ae039 = (0, $dMkYi.IntlMessageFormat);

});
parcelRegister("dMkYi", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $a0800691f35f04c3$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $hwth3 = parcelRequire("hwth3");

var $i1d8M = parcelRequire("i1d8M");

var $jZS82 = parcelRequire("jZS82");

var $cy0YZ = parcelRequire("cy0YZ");
// -- MessageFormat --------------------------------------------------------
function $a0800691f35f04c3$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $hwth3.__assign)((0, $hwth3.__assign)((0, $hwth3.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $hwth3.__assign)((0, $hwth3.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $a0800691f35f04c3$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $a0800691f35f04c3$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $hwth3.__assign)({}, defaultConfig));
}
function $a0800691f35f04c3$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $a0800691f35f04c3$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $i1d8M.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $hwth3.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $a0800691f35f04c3$var$createFastMemoizeCache(cache.number),
            strategy: (0, $i1d8M.strategies).variadic
        }),
        getDateTimeFormat: (0, $i1d8M.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $hwth3.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $a0800691f35f04c3$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $i1d8M.strategies).variadic
        }),
        getPluralRules: (0, $i1d8M.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $hwth3.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $a0800691f35f04c3$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $i1d8M.strategies).variadic
        })
    };
}
var $a0800691f35f04c3$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $cy0YZ.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $cy0YZ.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $hwth3.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $hwth3.__assign)((0, $hwth3.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $a0800691f35f04c3$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $a0800691f35f04c3$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $jZS82.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("jZS82", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("jiR5e")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("jiR5e")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("jiR5e")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("jiR5e")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("jiR5e")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("jiR5e")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("jiR5e")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("jiR5e")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("jiR5e")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("jiR5e")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("jiR5e")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("jiR5e")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $e8edb3a9dcdee313$export$98e6a39c04603d36; });

var $hwth3 = parcelRequire("hwth3");

var $fWMAE = parcelRequire("fWMAE");

var $fUuVp = parcelRequire("fUuVp");

var $jiR5e = parcelRequire("jiR5e");
function $e8edb3a9dcdee313$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $jiR5e.isSelectElement)(el) || (0, $jiR5e.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $e8edb3a9dcdee313$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $jiR5e.isNumberElement)(el) && (0, $jiR5e.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $jiR5e.isDateElement)(el) || (0, $jiR5e.isTimeElement)(el)) && (0, $jiR5e.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $jiR5e.isTagElement)(el)) $e8edb3a9dcdee313$var$pruneLocation(el.children);
    });
}
function $e8edb3a9dcdee313$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $hwth3.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $fUuVp.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $fWMAE.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $e8edb3a9dcdee313$var$pruneLocation(result.val);
    return result.val;
}
var $e8edb3a9dcdee313$export$d3c1bfa0f7d806e9 = (0, $fUuVp.Parser);

});
parcelRegister("fWMAE", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $b9c1f6c7ff0a238b$export$896afd8541959ee5; });
var $b9c1f6c7ff0a238b$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($b9c1f6c7ff0a238b$export$896afd8541959ee5 || ($b9c1f6c7ff0a238b$export$896afd8541959ee5 = {}));

});

parcelRegister("fUuVp", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $02fd3a1d1a84c092$export$7acfa6ed01010e37; });

var $hwth3 = parcelRequire("hwth3");

var $fWMAE = parcelRequire("fWMAE");

var $jiR5e = parcelRequire("jiR5e");

var $l4Au2 = parcelRequire("l4Au2");
parcelRequire("l7RTP");
var $dtG8l = parcelRequire("dtG8l");
var $gHGS6 = parcelRequire("gHGS6");

var $37sl8 = parcelRequire("37sl8");
var $02fd3a1d1a84c092$var$_a;
var $02fd3a1d1a84c092$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $l4Au2.SPACE_SEPARATOR_REGEX).source, "*"));
var $02fd3a1d1a84c092$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $l4Au2.SPACE_SEPARATOR_REGEX).source, "*$"));
function $02fd3a1d1a84c092$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $02fd3a1d1a84c092$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $02fd3a1d1a84c092$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $02fd3a1d1a84c092$var$hasNativeFromEntries = !!Object.fromEntries;
var $02fd3a1d1a84c092$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $02fd3a1d1a84c092$var$hasTrimStart = !!String.prototype.trimStart;
var $02fd3a1d1a84c092$var$hasTrimEnd = !!String.prototype.trimEnd;
var $02fd3a1d1a84c092$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $02fd3a1d1a84c092$var$isSafeInteger = $02fd3a1d1a84c092$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $02fd3a1d1a84c092$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $02fd3a1d1a84c092$var$re = $02fd3a1d1a84c092$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $02fd3a1d1a84c092$var$REGEX_SUPPORTS_U_AND_Y = (($02fd3a1d1a84c092$var$_a = $02fd3a1d1a84c092$var$re.exec('a')) === null || $02fd3a1d1a84c092$var$_a === void 0 ? void 0 : $02fd3a1d1a84c092$var$_a[0]) === 'a';
} catch (_) {
    $02fd3a1d1a84c092$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $02fd3a1d1a84c092$var$startsWith = $02fd3a1d1a84c092$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $02fd3a1d1a84c092$var$fromCodePoint = $02fd3a1d1a84c092$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $02fd3a1d1a84c092$var$fromEntries = // native
$02fd3a1d1a84c092$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $02fd3a1d1a84c092$var$codePointAt = $02fd3a1d1a84c092$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $02fd3a1d1a84c092$var$trimStart = $02fd3a1d1a84c092$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($02fd3a1d1a84c092$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $02fd3a1d1a84c092$var$trimEnd = $02fd3a1d1a84c092$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($02fd3a1d1a84c092$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $02fd3a1d1a84c092$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $02fd3a1d1a84c092$var$matchIdentifierAtIndex;
if ($02fd3a1d1a84c092$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $02fd3a1d1a84c092$var$IDENTIFIER_PREFIX_RE_1 = $02fd3a1d1a84c092$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $02fd3a1d1a84c092$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $02fd3a1d1a84c092$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $02fd3a1d1a84c092$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$02fd3a1d1a84c092$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $02fd3a1d1a84c092$var$codePointAt(s, index);
        if (c === undefined || $02fd3a1d1a84c092$var$_isWhiteSpace(c) || $02fd3a1d1a84c092$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $02fd3a1d1a84c092$var$fromCodePoint.apply(void 0, match);
};
var $02fd3a1d1a84c092$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $jiR5e.TYPE).pound,
                    location: $02fd3a1d1a84c092$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $fWMAE.ErrorKind).UNMATCHED_CLOSING_TAG, $02fd3a1d1a84c092$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $02fd3a1d1a84c092$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $jiR5e.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $02fd3a1d1a84c092$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$02fd3a1d1a84c092$var$_isAlpha(this.char())) return this.error((0, $fWMAE.ErrorKind).INVALID_TAG, $02fd3a1d1a84c092$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $fWMAE.ErrorKind).UNMATCHED_CLOSING_TAG, $02fd3a1d1a84c092$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $fWMAE.ErrorKind).INVALID_TAG, $02fd3a1d1a84c092$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $jiR5e.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $02fd3a1d1a84c092$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $fWMAE.ErrorKind).UNCLOSED_TAG, $02fd3a1d1a84c092$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $fWMAE.ErrorKind).INVALID_TAG, $02fd3a1d1a84c092$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $02fd3a1d1a84c092$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $02fd3a1d1a84c092$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $jiR5e.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$02fd3a1d1a84c092$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $02fd3a1d1a84c092$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $02fd3a1d1a84c092$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $fWMAE.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $02fd3a1d1a84c092$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $fWMAE.ErrorKind).EMPTY_ARGUMENT, $02fd3a1d1a84c092$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $fWMAE.ErrorKind).MALFORMED_ARGUMENT, $02fd3a1d1a84c092$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $fWMAE.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $02fd3a1d1a84c092$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $jiR5e.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $02fd3a1d1a84c092$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $fWMAE.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $02fd3a1d1a84c092$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $fWMAE.ErrorKind).MALFORMED_ARGUMENT, $02fd3a1d1a84c092$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $02fd3a1d1a84c092$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $02fd3a1d1a84c092$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $fWMAE.ErrorKind).EXPECT_ARGUMENT_TYPE, $02fd3a1d1a84c092$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $02fd3a1d1a84c092$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $fWMAE.ErrorKind).EXPECT_ARGUMENT_STYLE, $02fd3a1d1a84c092$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $02fd3a1d1a84c092$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $02fd3a1d1a84c092$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $02fd3a1d1a84c092$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $02fd3a1d1a84c092$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $jiR5e.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $fWMAE.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $37sl8.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $jiR5e.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $dtG8l.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $jiR5e.TYPE).date : (0, $jiR5e.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $jiR5e.TYPE).number : argType === 'date' ? (0, $jiR5e.TYPE).date : (0, $jiR5e.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $fWMAE.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $02fd3a1d1a84c092$var$createLocation(typeEndPosition_1, (0, $hwth3.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $fWMAE.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $02fd3a1d1a84c092$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $fWMAE.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $fWMAE.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $02fd3a1d1a84c092$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $jiR5e.TYPE).select,
                        value: value,
                        options: $02fd3a1d1a84c092$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $jiR5e.TYPE).plural,
                        value: value,
                        options: $02fd3a1d1a84c092$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $fWMAE.ErrorKind).INVALID_ARGUMENT_TYPE, $02fd3a1d1a84c092$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $fWMAE.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $02fd3a1d1a84c092$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $fWMAE.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $02fd3a1d1a84c092$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $gHGS6.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $fWMAE.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $jiR5e.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $gHGS6.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $fWMAE.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $fWMAE.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $02fd3a1d1a84c092$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $fWMAE.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $fWMAE.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $fWMAE.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $fWMAE.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $02fd3a1d1a84c092$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $02fd3a1d1a84c092$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $fWMAE.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $fWMAE.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $02fd3a1d1a84c092$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $fWMAE.ErrorKind).MISSING_OTHER_CLAUSE, $02fd3a1d1a84c092$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $02fd3a1d1a84c092$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$02fd3a1d1a84c092$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $02fd3a1d1a84c092$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($02fd3a1d1a84c092$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $02fd3a1d1a84c092$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $02fd3a1d1a84c092$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $02fd3a1d1a84c092$var$_isAlphaOrSlash(codepoint) {
    return $02fd3a1d1a84c092$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $02fd3a1d1a84c092$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $02fd3a1d1a84c092$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $02fd3a1d1a84c092$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("jiR5e", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $e0d8e0089cf683fc$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $e0d8e0089cf683fc$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $e0d8e0089cf683fc$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $e0d8e0089cf683fc$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $e0d8e0089cf683fc$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $e0d8e0089cf683fc$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $e0d8e0089cf683fc$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $e0d8e0089cf683fc$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $e0d8e0089cf683fc$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $e0d8e0089cf683fc$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $e0d8e0089cf683fc$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $e0d8e0089cf683fc$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $e0d8e0089cf683fc$export$7680c41f1a55f4cf; });
var $e0d8e0089cf683fc$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($e0d8e0089cf683fc$export$b87f371cbc396fcf || ($e0d8e0089cf683fc$export$b87f371cbc396fcf = {}));
var $e0d8e0089cf683fc$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($e0d8e0089cf683fc$export$906452485466fa53 || ($e0d8e0089cf683fc$export$906452485466fa53 = {}));
function $e0d8e0089cf683fc$export$cfa10c5697238752(el) {
    return el.type === $e0d8e0089cf683fc$export$b87f371cbc396fcf.literal;
}
function $e0d8e0089cf683fc$export$4f55724281bdfaf9(el) {
    return el.type === $e0d8e0089cf683fc$export$b87f371cbc396fcf.argument;
}
function $e0d8e0089cf683fc$export$e11187b219e191e1(el) {
    return el.type === $e0d8e0089cf683fc$export$b87f371cbc396fcf.number;
}
function $e0d8e0089cf683fc$export$32d811605da75f40(el) {
    return el.type === $e0d8e0089cf683fc$export$b87f371cbc396fcf.date;
}
function $e0d8e0089cf683fc$export$34ec46f596b1702f(el) {
    return el.type === $e0d8e0089cf683fc$export$b87f371cbc396fcf.time;
}
function $e0d8e0089cf683fc$export$dcfe1c11d168b5a1(el) {
    return el.type === $e0d8e0089cf683fc$export$b87f371cbc396fcf.select;
}
function $e0d8e0089cf683fc$export$6c796d116f0a4fbc(el) {
    return el.type === $e0d8e0089cf683fc$export$b87f371cbc396fcf.plural;
}
function $e0d8e0089cf683fc$export$c0ece297bdd0c082(el) {
    return el.type === $e0d8e0089cf683fc$export$b87f371cbc396fcf.pound;
}
function $e0d8e0089cf683fc$export$5c83de34745812b(el) {
    return el.type === $e0d8e0089cf683fc$export$b87f371cbc396fcf.tag;
}
function $e0d8e0089cf683fc$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $e0d8e0089cf683fc$export$906452485466fa53.number);
}
function $e0d8e0089cf683fc$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $e0d8e0089cf683fc$export$906452485466fa53.dateTime);
}
function $e0d8e0089cf683fc$export$f0ac572c1121c662(value) {
    return {
        type: $e0d8e0089cf683fc$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $e0d8e0089cf683fc$export$425e864b0ba114f1(value, style) {
    return {
        type: $e0d8e0089cf683fc$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("l4Au2", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $f576458a9b50d3ce$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $f576458a9b50d3ce$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $f576458a9b50d3ce$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("l7RTP", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("dtG8l")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("gHGS6")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("gHGS6")).parseNumberSkeletonFromString; });
parcelRequire("dtG8l");
parcelRequire("gHGS6");

});
parcelRegister("dtG8l", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $9cfeaaa3cfe77697$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $9cfeaaa3cfe77697$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $9cfeaaa3cfe77697$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($9cfeaaa3cfe77697$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("gHGS6", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $c291eae4adbce8bd$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $c291eae4adbce8bd$export$47c6f8480bda3e11; });

var $hwth3 = parcelRequire("hwth3");

var $hv4R7 = parcelRequire("hv4R7");
function $c291eae4adbce8bd$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $hv4R7.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $c291eae4adbce8bd$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $c291eae4adbce8bd$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $c291eae4adbce8bd$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $c291eae4adbce8bd$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $c291eae4adbce8bd$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $c291eae4adbce8bd$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($c291eae4adbce8bd$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $c291eae4adbce8bd$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $c291eae4adbce8bd$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$c291eae4adbce8bd$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $c291eae4adbce8bd$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $c291eae4adbce8bd$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $c291eae4adbce8bd$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $c291eae4adbce8bd$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $hwth3.__assign)((0, $hwth3.__assign)((0, $hwth3.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $hwth3.__assign)((0, $hwth3.__assign)({}, all), $c291eae4adbce8bd$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $hwth3.__assign)((0, $hwth3.__assign)((0, $hwth3.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $hwth3.__assign)((0, $hwth3.__assign)({}, all), $c291eae4adbce8bd$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($c291eae4adbce8bd$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($c291eae4adbce8bd$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($c291eae4adbce8bd$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($c291eae4adbce8bd$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $hwth3.__assign)((0, $hwth3.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $hwth3.__assign)((0, $hwth3.__assign)({}, result), $c291eae4adbce8bd$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($c291eae4adbce8bd$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $hwth3.__assign)((0, $hwth3.__assign)({}, result), $c291eae4adbce8bd$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $c291eae4adbce8bd$var$parseSign(token.stem);
        if (signOpts) result = (0, $hwth3.__assign)((0, $hwth3.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $c291eae4adbce8bd$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $hwth3.__assign)((0, $hwth3.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("hv4R7", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $cbd9192975166e31$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $cbd9192975166e31$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("37sl8", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $24580247688f2e71$export$29c5368be8904d27; });

var $16Moe = parcelRequire("16Moe");
function $24580247688f2e71$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $24580247688f2e71$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $24580247688f2e71$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $16Moe.timeData)[regionTag || ''] || (0, $16Moe.timeData)[languageTag || ''] || (0, $16Moe.timeData)["".concat(languageTag, "-001")] || (0, $16Moe.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("16Moe", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $0cebe3382e6cd827$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $0cebe3382e6cd827$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("cy0YZ", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $92296c267ddfa73e$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $92296c267ddfa73e$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $92296c267ddfa73e$export$275d4a3bb5f66fda; });
parcelRequire("jZS82");
var $jiR5e = parcelRequire("jiR5e");

var $fclNO = parcelRequire("fclNO");
var $92296c267ddfa73e$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($92296c267ddfa73e$export$49694c2877b44c57 || ($92296c267ddfa73e$export$49694c2877b44c57 = {}));
function $92296c267ddfa73e$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $92296c267ddfa73e$export$49694c2877b44c57.literal || part.type !== $92296c267ddfa73e$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $92296c267ddfa73e$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $92296c267ddfa73e$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $jiR5e.isLiteralElement)(els[0])) return [
        {
            type: $92296c267ddfa73e$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $jiR5e.isLiteralElement)(el)) {
            result.push({
                type: $92296c267ddfa73e$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $jiR5e.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $92296c267ddfa73e$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $fclNO.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $jiR5e.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $92296c267ddfa73e$export$49694c2877b44c57.literal : $92296c267ddfa73e$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $jiR5e.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $jiR5e.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $92296c267ddfa73e$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jiR5e.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $jiR5e.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $92296c267ddfa73e$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jiR5e.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $jiR5e.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $92296c267ddfa73e$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jiR5e.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$92296c267ddfa73e$export$df0c12a2d414a163(formatFn)) throw new (0, $fclNO.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $92296c267ddfa73e$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $92296c267ddfa73e$export$49694c2877b44c57.literal : $92296c267ddfa73e$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $jiR5e.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $fclNO.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $92296c267ddfa73e$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $jiR5e.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $fclNO.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $fclNO.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $fclNO.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $92296c267ddfa73e$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $92296c267ddfa73e$var$mergeLiteral(result);
}

});
parcelRegister("fclNO", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $b108e38293dda1f5$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $b108e38293dda1f5$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $b108e38293dda1f5$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $b108e38293dda1f5$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $b108e38293dda1f5$export$8bfc137e4d23fdf0; });

var $hwth3 = parcelRequire("hwth3");
var $b108e38293dda1f5$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($b108e38293dda1f5$export$d4e71bc0b80dc0fb || ($b108e38293dda1f5$export$d4e71bc0b80dc0fb = {}));
var $b108e38293dda1f5$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $hwth3.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $b108e38293dda1f5$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $hwth3.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $b108e38293dda1f5$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($b108e38293dda1f5$export$7369836851cc1329);
var $b108e38293dda1f5$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $hwth3.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $b108e38293dda1f5$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($b108e38293dda1f5$export$7369836851cc1329);
var $b108e38293dda1f5$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $hwth3.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $b108e38293dda1f5$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($b108e38293dda1f5$export$7369836851cc1329);

});




parcelRegister("iTGck", function(module, exports) {

$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $dc1e18a54473ad5b$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $dc1e18a54473ad5b$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $dc1e18a54473ad5b$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $dc1e18a54473ad5b$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $dc1e18a54473ad5b$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $dc1e18a54473ad5b$export$2ddcb436d0aa3688; });

var $hwth3 = parcelRequire("hwth3");
var $dc1e18a54473ad5b$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($dc1e18a54473ad5b$export$557d6acb76e8a244 || ($dc1e18a54473ad5b$export$557d6acb76e8a244 = {}));
var $dc1e18a54473ad5b$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $hwth3.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $dc1e18a54473ad5b$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $hwth3.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $dc1e18a54473ad5b$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($dc1e18a54473ad5b$export$c016d36112f6ddf8);
var $dc1e18a54473ad5b$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $hwth3.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $dc1e18a54473ad5b$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($dc1e18a54473ad5b$export$c016d36112f6ddf8);
var $dc1e18a54473ad5b$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $hwth3.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $dc1e18a54473ad5b$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($dc1e18a54473ad5b$export$c016d36112f6ddf8);
var $dc1e18a54473ad5b$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $hwth3.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $dc1e18a54473ad5b$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($dc1e18a54473ad5b$export$c016d36112f6ddf8);
var $dc1e18a54473ad5b$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $hwth3.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($dc1e18a54473ad5b$export$e3b7eee1dbc44895);
var $dc1e18a54473ad5b$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $hwth3.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $dc1e18a54473ad5b$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($dc1e18a54473ad5b$export$c016d36112f6ddf8);

});



parcelRegister("e8qF3", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $a4a67e661d5219c7$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $a4a67e661d5219c7$export$841858b892ce1f4c; });

var $hwth3 = parcelRequire("hwth3");

var $cy8cW = parcelRequire("cy8cW");

var $dNMDr = parcelRequire("dNMDr");

var $2klZT = parcelRequire("2klZT");
function $a4a67e661d5219c7$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $a4a67e661d5219c7$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $dNMDr.createContext(null)) : $dNMDr.createContext(null);
var $a4a67e661d5219c7$var$IntlConsumer = $a4a67e661d5219c7$var$IntlContext.Consumer, $a4a67e661d5219c7$var$IntlProvider = $a4a67e661d5219c7$var$IntlContext.Provider;
var $a4a67e661d5219c7$export$2881499e37b75b9a = $a4a67e661d5219c7$var$IntlProvider;
var $a4a67e661d5219c7$export$841858b892ce1f4c = $a4a67e661d5219c7$var$IntlContext;
function $a4a67e661d5219c7$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $dNMDr.createElement($a4a67e661d5219c7$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $2klZT.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $dNMDr.createElement(WrappedComponent, (0, $hwth3.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($a4a67e661d5219c7$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($cy8cW)))(// @ts-expect-error
    $dNMDr.forwardRef(function(props, ref) {
        return $dNMDr.createElement(WithIntl, (0, $hwth3.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cy8cW)))(WithIntl, WrappedComponent);
}

});



parcelRegister("aC9Kp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ba503a943725813$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $hwth3 = parcelRequire("hwth3");

var $g1A3N = parcelRequire("g1A3N");

var $dNMDr = parcelRequire("dNMDr");

var $2klZT = parcelRequire("2klZT");

var $e8qF3 = parcelRequire("e8qF3");

var $f70sr = parcelRequire("f70sr");
function $7ba503a943725813$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $7ba503a943725813$var$IntlProvider = /** @class */ function(_super) {
    (0, $hwth3.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $g1A3N.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $f70sr.createIntl)($7ba503a943725813$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $7ba503a943725813$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $7ba503a943725813$var$processIntlConfig(props);
        if (!(0, $2klZT.shallowEqual)(prevConfig, config)) return {
            intl: (0, $f70sr.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $2klZT.invariantIntlContext)(this.state.intl);
        return $dNMDr.createElement((0, $e8qF3.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $2klZT.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($dNMDr.PureComponent);
var $7ba503a943725813$export$2e2bcd8739ae039 = $7ba503a943725813$var$IntlProvider;

});
parcelRegister("f70sr", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $b007dd5821406fb9$export$7e4cbedfdd7b4c0d; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $hwth3 = parcelRequire("hwth3");

var $e2574 = parcelRequire("e2574");
var $gqBgL = parcelRequire("gqBgL");

var $dNMDr = parcelRequire("dNMDr");

var $2klZT = parcelRequire("2klZT");

var $cy0YZ = parcelRequire("cy0YZ");
function $b007dd5821406fb9$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $cy0YZ.isFormatXMLElementFn)(v) ? (0, $2klZT.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $b007dd5821406fb9$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $b007dd5821406fb9$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $gqBgL.formatMessage).apply(void 0, (0, $hwth3.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $dNMDr.Children.toArray(chunks);
    return chunks;
};
var $b007dd5821406fb9$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $hwth3.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $b007dd5821406fb9$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $e2574.createIntl)((0, $hwth3.__assign)((0, $hwth3.__assign)((0, $hwth3.__assign)({}, (0, $2klZT.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $hwth3.__assign)((0, $hwth3.__assign)({}, coreIntl), {
        formatMessage: $b007dd5821406fb9$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $b007dd5821406fb9$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("e2574", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $a37537eabf12a2b5$export$7e4cbedfdd7b4c0d; });

var $hwth3 = parcelRequire("hwth3");

var $g1A3N = parcelRequire("g1A3N");

var $iTGck = parcelRequire("iTGck");

var $1yPo7 = parcelRequire("1yPo7");

var $ecqit = parcelRequire("ecqit");

var $arVbL = parcelRequire("arVbL");

var $llTPr = parcelRequire("llTPr");

var $gqBgL = parcelRequire("gqBgL");

var $2QN0k = parcelRequire("2QN0k");

var $diYAF = parcelRequire("diYAF");
function $a37537eabf12a2b5$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $a37537eabf12a2b5$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $a37537eabf12a2b5$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $a37537eabf12a2b5$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $g1A3N.createFormatters)(cache);
    var resolvedConfig = (0, $hwth3.__assign)((0, $hwth3.__assign)({}, (0, $g1A3N.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $iTGck.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $iTGck.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $iTGck.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $a37537eabf12a2b5$var$verifyConfigMessages(resolvedConfig);
    return (0, $hwth3.__assign)((0, $hwth3.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $1yPo7.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $1yPo7.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $ecqit.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $arVbL.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $arVbL.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $arVbL.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $arVbL.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $arVbL.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $llTPr.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $gqBgL.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $gqBgL.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $2QN0k.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $2QN0k.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $diYAF.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("1yPo7", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $1230d4031a6cf362$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $1230d4031a6cf362$export$6871080848f10b2f; });

var $iTGck = parcelRequire("iTGck");

var $g1A3N = parcelRequire("g1A3N");
var $1230d4031a6cf362$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $1230d4031a6cf362$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $g1A3N.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $g1A3N.filterProps)(options, $1230d4031a6cf362$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $1230d4031a6cf362$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $1230d4031a6cf362$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $iTGck.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $1230d4031a6cf362$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $1230d4031a6cf362$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $iTGck.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("ecqit", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $a56695b5d6a30879$export$b4ea3b48dcf921f6; });

var $g1A3N = parcelRequire("g1A3N");

var $fclNO = parcelRequire("fclNO");

var $iTGck = parcelRequire("iTGck");
var $a56695b5d6a30879$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $a56695b5d6a30879$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $g1A3N.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $g1A3N.filterProps)(options, $a56695b5d6a30879$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $a56695b5d6a30879$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $fclNO.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $fclNO.ErrorCode).MISSING_INTL_API));
    try {
        return $a56695b5d6a30879$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $iTGck.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("arVbL", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $79b8c97cea8bf320$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $79b8c97cea8bf320$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $79b8c97cea8bf320$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $79b8c97cea8bf320$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $79b8c97cea8bf320$export$af6e5d7a5c73edeb; });

var $hwth3 = parcelRequire("hwth3");

var $g1A3N = parcelRequire("g1A3N");

var $iTGck = parcelRequire("iTGck");
var $79b8c97cea8bf320$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $79b8c97cea8bf320$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $hwth3.__assign)((0, $hwth3.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $g1A3N.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $g1A3N.filterProps)(options, $79b8c97cea8bf320$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $hwth3.__assign)((0, $hwth3.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $79b8c97cea8bf320$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $79b8c97cea8bf320$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $iTGck.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $79b8c97cea8bf320$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $79b8c97cea8bf320$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $iTGck.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $79b8c97cea8bf320$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $g1A3N.filterProps)(options, $79b8c97cea8bf320$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $iTGck.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $79b8c97cea8bf320$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $79b8c97cea8bf320$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $iTGck.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $79b8c97cea8bf320$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $79b8c97cea8bf320$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $iTGck.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("llTPr", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $f8b6dd9428fa247d$export$bbbd05c900f3568d; });

var $g1A3N = parcelRequire("g1A3N");

var $iTGck = parcelRequire("iTGck");

var $fclNO = parcelRequire("fclNO");
var $f8b6dd9428fa247d$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $f8b6dd9428fa247d$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $fclNO.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $fclNO.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $g1A3N.filterProps)(options, $f8b6dd9428fa247d$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $iTGck.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("gqBgL", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $bf5bfbf9e79e06f5$export$25868d1e8e76735f; });

var $hwth3 = parcelRequire("hwth3");

var $iCqeG = parcelRequire("iCqeG");
parcelRequire("aI3d0");
var $dMkYi = parcelRequire("dMkYi");

var $iTGck = parcelRequire("iTGck");
parcelRequire("jZS82");
var $jiR5e = parcelRequire("jiR5e");
function $bf5bfbf9e79e06f5$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $hwth3.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $bf5bfbf9e79e06f5$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $hwth3.__assign)((0, $hwth3.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $hwth3.__assign)((0, $hwth3.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $bf5bfbf9e79e06f5$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $dMkYi.IntlMessageFormat).formats;
    return (0, $hwth3.__assign)((0, $hwth3.__assign)((0, $hwth3.__assign)({}, mfFormats), f1), {
        date: $bf5bfbf9e79e06f5$var$deepMergeOptions($bf5bfbf9e79e06f5$var$setTimeZoneInOptions(mfFormats.date, timeZone), $bf5bfbf9e79e06f5$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $bf5bfbf9e79e06f5$var$deepMergeOptions($bf5bfbf9e79e06f5$var$setTimeZoneInOptions(mfFormats.time, timeZone), $bf5bfbf9e79e06f5$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $bf5bfbf9e79e06f5$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $iCqeG.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $jiR5e.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $hwth3.__assign)((0, $hwth3.__assign)({}, defaultRichTextElements), values || {});
    formats = $bf5bfbf9e79e06f5$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $bf5bfbf9e79e06f5$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $iTGck.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $iTGck.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $hwth3.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $iTGck.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $iTGck.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("2QN0k", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $21367354aaf34424$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $21367354aaf34424$export$6f284aad1934db69; });

var $hwth3 = parcelRequire("hwth3");

var $g1A3N = parcelRequire("g1A3N");

var $fclNO = parcelRequire("fclNO");

var $iTGck = parcelRequire("iTGck");
var $21367354aaf34424$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $21367354aaf34424$var$now = Date.now();
function $21367354aaf34424$var$generateToken(i) {
    return "".concat($21367354aaf34424$var$now, "_").concat(i, "_").concat($21367354aaf34424$var$now);
}
function $21367354aaf34424$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $21367354aaf34424$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $21367354aaf34424$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $fclNO.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $fclNO.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $g1A3N.filterProps)(options, $21367354aaf34424$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $21367354aaf34424$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $hwth3.__assign)((0, $hwth3.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $iTGck.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("diYAF", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $9afbf4d1487c8844$export$62fe1a4d9e891fa2; });

var $g1A3N = parcelRequire("g1A3N");

var $fclNO = parcelRequire("fclNO");

var $iTGck = parcelRequire("iTGck");
var $9afbf4d1487c8844$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $9afbf4d1487c8844$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $fclNO.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $fclNO.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $g1A3N.filterProps)(options, $9afbf4d1487c8844$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $iTGck.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});




parcelRegister("3YSXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e619cd7b4cfb463$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $hwth3 = parcelRequire("hwth3");

var $dNMDr = parcelRequire("dNMDr");

var $2klZT = parcelRequire("2klZT");

var $ko1o6 = parcelRequire("ko1o6");
function $2e619cd7b4cfb463$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $hwth3.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $hwth3.__rest)(nextProps, [
        "values"
    ]);
    return (0, $2klZT.shallowEqual)(nextValues, values) && (0, $2klZT.shallowEqual)(otherProps, nextOtherProps);
}
function $2e619cd7b4cfb463$var$FormattedMessage(props) {
    var intl = (0, $ko1o6.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $dNMDr.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $dNMDr.createElement(Component, null, $dNMDr.Children.toArray(nodes));
    return $dNMDr.createElement($dNMDr.Fragment, null, nodes);
}
$2e619cd7b4cfb463$var$FormattedMessage.displayName = 'FormattedMessage';
var $2e619cd7b4cfb463$var$MemoizedFormattedMessage = $dNMDr.memo($2e619cd7b4cfb463$var$FormattedMessage, $2e619cd7b4cfb463$var$areEqual);
$2e619cd7b4cfb463$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $2e619cd7b4cfb463$export$2e2bcd8739ae039 = $2e619cd7b4cfb463$var$MemoizedFormattedMessage;

});



parcelRegister("iy2Wm", function(module, exports) {

$parcel$export(module.exports, "preloadAppState", function () { return $02e0698b39925f98$export$b2d23fea71dbec1b; });
$parcel$export(module.exports, "buildInitialState", function () { return $02e0698b39925f98$export$2a115e4c5d766179; });
$parcel$export(module.exports, "createAnalyticsClient", function () { return $02e0698b39925f98$export$3d970ca206012d6b; });
$parcel$export(module.exports, "startupAnalyticEvent", function () { return $02e0698b39925f98$export$514076659add65b6; });
$parcel$export(module.exports, "pushGlobals", function () { return $02e0698b39925f98$export$fac9d5c57cee7357; });

var $jNklE = parcelRequire("jNklE");

var $j0VD5 = parcelRequire("j0VD5");

var $dzQfr = parcelRequire("dzQfr");

var $cuZAx = parcelRequire("cuZAx");

var $54ReC = parcelRequire("54ReC");

var $5Hkcm = parcelRequire("5Hkcm");

var $i5FQ3 = parcelRequire("i5FQ3");

var $6Klxu = parcelRequire("6Klxu");

var $4NPio = parcelRequire("4NPio");

var $2ndZA = parcelRequire("2ndZA");

var $dHF4q = parcelRequire("dHF4q");

var $hhYxc = parcelRequire("hhYxc");

var $hqddj = parcelRequire("hqddj");

var $cE672 = parcelRequire("cE672");
function $02e0698b39925f98$export$b2d23fea71dbec1b() {
    try {
        const el = document.body;
        return JSON.parse(el && el.getAttribute('data-app-state') || 'null');
    } catch (e) {
        return null;
    }
}
async function $02e0698b39925f98$var$attemptFetchAppState() {
    try {
        const res = await fetch(`${(0, $hhYxc.idacOrigin)}/frontend/state`, {
            mode: 'cors',
            credentials: 'include'
        });
        if (!res.ok) {
            const statusCode = res.status;
            const statusText = res.statusText;
            (0, $hqddj.setAppStateInitializationContext)({
                fetchResult: 'failed',
                statusCode: statusCode,
                statusText: statusText
            });
            (0, $hqddj.addBreadcrumb)({
                message: `AppState: fetch failed with status ${statusCode}`,
                data: {
                    statusCode: statusCode,
                    statusText: statusText
                }
            });
            // client errors - don't retry
            if (statusCode >= 400 && statusCode < 500) {
                (0, $hqddj.captureTaggedException)(new Error(`Client error fetching app state: ${statusCode} ${statusText}`), {
                    capabilities: [],
                    tags: {
                        appStateInitialization: 'app_state_client_error'
                    },
                    extraProperties: {
                        status_code: statusCode.toString()
                    }
                });
                return {
                    status: 'client_error',
                    statusCode: statusCode,
                    message: `Client error fetching app state: ${statusCode} ${statusText}`
                };
            }
            // 5xx server errors - retryable
            return {
                status: 'server_error',
                statusCode: statusCode,
                message: `Server error: ${statusCode} ${statusText}`
            };
        }
        try {
            const data = await res.json();
            (0, $hqddj.addBreadcrumb)({
                message: 'AppState: fetch succeeded'
            });
            (0, $hqddj.setAppStateInitializationContext)({
                fetchResult: 'succeeded'
            });
            return {
                status: 'success',
                data: data
            };
        } catch (parseError) {
            // JSON parsing failed - retryable
            const message = parseError instanceof Error ? parseError.message : 'Unknown parse error';
            (0, $hqddj.addBreadcrumb)({
                message: `AppState: parse error - ${message}`,
                level: 'error'
            });
            return {
                status: 'parse_error',
                message: `Failed to parse app state response: ${message}`
            };
        }
    } catch (e) {
        // Network errors (DNS, connection, CORS, timeout, etc.) - retryable
        const errorMessage = e instanceof Error ? e.message : 'Unknown error';
        (0, $hqddj.addBreadcrumb)({
            message: `AppState: network error - ${errorMessage}`,
            level: 'error'
        });
        (0, $hqddj.setAppStateInitializationContext)({
            fetchResult: 'network_error',
            errorMessage: errorMessage
        });
        return {
            status: 'network_error',
            message: `Network error: ${errorMessage}`
        };
    }
}
async function $02e0698b39925f98$var$fetchAppStateWithRetry(attempt, maxRetries, delay) {
    (0, $hqddj.addBreadcrumb)({
        message: `AppState: fetch attempt ${attempt}/${maxRetries}`
    });
    const result = await $02e0698b39925f98$var$attemptFetchAppState();
    // Success - return immediately
    if (result.status === 'success') {
        (0, $hqddj.setAppStateInitializationContext)({
            fetchResult: 'succeeded',
            attempt: attempt
        });
        return result;
    }
    // Non-retryable errors - return immediately
    if (result.status === 'client_error') return result;
    // Retryable errors - recurse if attempts remain
    if (attempt < maxRetries) {
        await delay(attempt);
        return $02e0698b39925f98$var$fetchAppStateWithRetry(attempt + 1, maxRetries, delay);
    }
    // All retries exhausted - log and return final error with attempt count
    const appStateTag = (()=>{
        switch(result.status){
            case 'server_error':
                return 'app_state_server_error';
            case 'network_error':
                return 'app_state_network_error';
            case 'parse_error':
                return 'app_state_parse_error';
            default:
                // Fallback - shouldn't reach here
                return 'app_state_server_error';
        }
    })();
    (0, $hqddj.captureTaggedException)(new Error(result.message), {
        capabilities: [],
        tags: {
            appStateInitialization: appStateTag
        },
        extraProperties: {
            retry_attempts: maxRetries.toString(),
            status_code: 'statusCode' in result ? result.statusCode.toString() : undefined
        }
    });
    return {
        ...result,
        attempts: maxRetries
    };
}
const $02e0698b39925f98$export$617a9918ddf235db = (baseDelayMs = 1000)=>{
    return async (attemptNumber)=>{
        const delayMs = baseDelayMs * Math.pow(2, attemptNumber - 1);
        (0, $hqddj.addBreadcrumb)({
            message: `AppState: retrying after ${delayMs}ms`,
            data: {
                delayMs: delayMs,
                attemptNumber: attemptNumber
            }
        });
        await new Promise((resolve)=>setTimeout(resolve, delayMs));
    };
};
async function $02e0698b39925f98$export$1f5cc2b3ab680cae(options = {}) {
    const maxRetries = options.maxRetries ?? 3;
    const delay = options.delay ?? $02e0698b39925f98$export$617a9918ddf235db();
    return $02e0698b39925f98$var$fetchAppStateWithRetry(1, maxRetries, delay);
}
function $02e0698b39925f98$export$4cd70f9ecbebfa45(oidcContext) {
    const isEmbedded = /AtlassianMobileApp|HipChat/.test(navigator.userAgent);
    const isMobileApp = isEmbedded || (0, $cuZAx.isMobileOidc)(oidcContext) || false;
    return {
        isEmbedded: isEmbedded,
        isAnyMobile: (0, $j0VD5.screenSize)() === 'mobile' || isMobileApp,
        isMobileApp: isMobileApp,
        screenSize: (0, $j0VD5.screenSize)(),
        oidcContext: oidcContext
    };
}
async function $02e0698b39925f98$export$2a115e4c5d766179(preloaded) {
    const microbranding = $02e0698b39925f98$export$4cd70f9ecbebfa45(preloaded?.oidcContext);
    if (!preloaded) {
        (0, $hqddj.setAppStateInitializationContext)({
            source: 'fetched'
        });
        (0, $hqddj.addBreadcrumb)({
            message: 'AppState: fetching from API'
        });
        const result = await $02e0698b39925f98$export$1f5cc2b3ab680cae();
        // Handle errors - throw to let index.tsx catch and render error page
        if (result.status !== 'success') throw new Error(result.message);
        const fetched = result.data;
        return {
            initialStoreState: {
                csrfToken: fetched.csrfToken,
                user: undefined,
                login: undefined,
                logout: undefined,
                appConfig: fetched.appConfig,
                locale: fetched.locale,
                continueAs: undefined,
                cancelDeletion: undefined,
                selectAccount: undefined,
                microbranding: $02e0698b39925f98$export$4cd70f9ecbebfa45(fetched.oidcContext),
                createAccount: undefined,
                context: {
                    tenantCloudId: fetched.tenantCloudId,
                    userId: undefined
                },
                migrateConfirmation: undefined,
                welcome: undefined,
                socialLoginRecovery: undefined,
                verifyEmail: undefined,
                verifyEmailSent: undefined,
                changeEmail: undefined,
                changePassword: undefined,
                welcomeSent: undefined,
                serverError: undefined,
                cobranding: fetched.cobranding,
                stepUp: undefined,
                stepUpSso: undefined,
                verifyEmailOtp: undefined,
                loginConsent: undefined,
                orgLoginConfig: undefined
            },
            cspNonce: fetched.cspNonce || ''
        };
    }
    (0, $hqddj.setAppStateInitializationContext)({
        source: 'preloaded'
    });
    (0, $hqddj.addBreadcrumb)({
        message: 'AppState: using preloaded value'
    });
    const loginState = preloaded.login && {
        ...(0, $dzQfr.defaultState),
        ...preloaded.login
    };
    return {
        initialStoreState: {
            csrfToken: preloaded.csrfToken,
            hashedCsrfToken: preloaded.hashedCsrfToken,
            user: preloaded.user,
            login: loginState,
            logout: preloaded.logout,
            appConfig: preloaded.appConfig,
            locale: preloaded.locale,
            continueAs: preloaded.continueAs,
            cancelDeletion: preloaded.cancelDeletion,
            selectAccount: preloaded.selectAccount,
            microbranding: microbranding,
            createAccount: preloaded.createAccount,
            context: {
                tenantCloudId: preloaded.tenantCloudId,
                userId: preloaded.userId
            },
            migrateConfirmation: preloaded.migrateConfirmation,
            signup: {
                ...(0, $5Hkcm.defaultState),
                ...preloaded.signup
            },
            welcome: {
                ...(0, $i5FQ3.defaultState),
                ...preloaded.welcome
            },
            socialLoginRecovery: preloaded.socialLoginRecovery,
            verifyEmail: preloaded.verifyEmail,
            verifyEmailSent: preloaded.verifyEmailSent,
            changeEmail: preloaded.changeEmail,
            changePassword: {
                ...(0, $54ReC.defaultState),
                ...preloaded.changePassword
            },
            welcomeSent: preloaded.welcomeSent,
            serverError: preloaded.error,
            cobranding: preloaded.cobranding,
            multiFactor: {
                ...(0, $2ndZA.defaultState),
                ...preloaded.multiFactor
            },
            mfaEnrollment: {
                ...(0, $dHF4q.defaultState),
                ...preloaded.enrollment
            },
            stepUp: preloaded.stepUp,
            stepUpSso: preloaded.stepUpSso,
            verifyEmailOtp: {
                ...(0, $6Klxu.defaultState),
                ...preloaded.verifyEmailOtp
            },
            loginConsent: {
                ...(0, $cE672.defaultState),
                ...preloaded.loginConsent
            },
            orgLoginConfig: preloaded.orgLoginConfig,
            mfaPromote: {
                ...(0, $jNklE.defaultState),
                ...preloaded.mfaPromote
            }
        },
        cspNonce: preloaded.cspNonce
    };
}
function $02e0698b39925f98$export$3d970ca206012d6b(initialState) {
    const { microbranding: microbranding, cobranding: cobranding, context: context } = initialState.initialStoreState;
    const locale = undefined;
    return new (0, $4NPio.AnalyticsClientImpl)({
        microbranding: microbranding,
        cobranding: cobranding || {},
        locale: locale,
        tenantCloudId: context.tenantCloudId,
        userId: context.userId,
        client: undefined
    });
}
function $02e0698b39925f98$export$514076659add65b6(analyticsClient) {
    analyticsClient.operationalEvent({
        page: 'unknown',
        action: 'loadPage',
        subject: 'sli'
    });
}
function $02e0698b39925f98$export$fac9d5c57cee7357(appConfig, cspNonce) {
    window.segmentIoKey = appConfig && appConfig.segmentIoKey;
    window.cspNonce = cspNonce;
}

});
parcelRegister("j0VD5", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $f8a7280e4327e408$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "screenSizeMatcher", function () { return $f8a7280e4327e408$export$417d65d80b205866; });
$parcel$export(module.exports, "screenSize", function () { return $f8a7280e4327e408$export$463d066e8ee12fba; });

var $8Govx = parcelRequire("8Govx");

var $68HQw = parcelRequire("68HQw");
const $f8a7280e4327e408$var$mobileMaxWidth = `${(0, $68HQw.gridSize)() * 100}px`;
const $f8a7280e4327e408$var$mediaQueryCss = (query)=>(...args)=>{
        // @ts-ignore
        const inner = (0, $8Govx.css)(...args);
        return (0, $8Govx.css)`
      @media ${query} {
        ${inner}
      }
    `;
    };
const $f8a7280e4327e408$var$mediaQuery = {
    handheldQuery: `(max-width: ${$f8a7280e4327e408$var$mobileMaxWidth})`
};
const $f8a7280e4327e408$export$987d49ffe1b0900f = {
    handheld: $f8a7280e4327e408$var$mediaQueryCss($f8a7280e4327e408$var$mediaQuery.handheldQuery),
    ...$f8a7280e4327e408$var$mediaQuery
};
const $f8a7280e4327e408$export$417d65d80b205866 = window.matchMedia && window.matchMedia($f8a7280e4327e408$export$987d49ffe1b0900f.handheldQuery);
const $f8a7280e4327e408$export$463d066e8ee12fba = ()=>$f8a7280e4327e408$export$417d65d80b205866 ? $f8a7280e4327e408$export$417d65d80b205866.matches ? 'mobile' : 'desktop' : 'unknown';
const $f8a7280e4327e408$var$maxWidth = (screenSize)=>{
    switch(screenSize){
        case 'mobile':
            return $f8a7280e4327e408$var$mobileMaxWidth;
        default:
            return '100%';
    }
};
const $f8a7280e4327e408$export$d7b7311ec04a3e8f = (screenSize, name)=>{
    const viewport = {};
    viewport[screenSize] = {
        name: name ? name : screenSize,
        styles: {
            width: $f8a7280e4327e408$var$maxWidth(screenSize),
            height: '100%'
        }
    };
    return viewport;
};

});
parcelRegister("68HQw", function(module, exports) {

$parcel$export(module.exports, "borderRadius", function () { return $4785805851d7976d$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $4785805851d7976d$export$6d8204c2cb2e06b8; });

var $ejTTJ = parcelRequire("ejTTJ");

var $l4KzN = parcelRequire("l4KzN");
var $4785805851d7976d$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $4785805851d7976d$export$c93026a968943f95 = 'light';
var $4785805851d7976d$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $4785805851d7976d$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $4785805851d7976d$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $4785805851d7976d$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $l4KzN.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $4785805851d7976d$export$6d8204c2cb2e06b8() / 4;
    (0, $ejTTJ.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $4785805851d7976d$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $4785805851d7976d$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $4785805851d7976d$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $ejTTJ.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $4785805851d7976d$export$ba1d834b86d72a09 = $4785805851d7976d$export$a1b3edb637fb4f35;
var $4785805851d7976d$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $l4KzN.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $l4KzN.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $l4KzN.N30A), ")")
            }
        }
    };
};

});
parcelRegister("ejTTJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6ce332ca778d770$export$2e2bcd8739ae039; });

var $kCRAo = parcelRequire("kCRAo");

var $4ilBr = parcelRequire("4ilBr");
function $a6ce332ca778d770$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $kCRAo.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $a6ce332ca778d770$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $4ilBr;
}

});
parcelRegister("kCRAo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f040ec516b0b49ef$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $f040ec516b0b49ef$var$printed = {};
function $f040ec516b0b49ef$export$2e2bcd8739ae039(message) {
    if ($f040ec516b0b49ef$var$printed[message]) return;
    $f040ec516b0b49ef$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("l4KzN", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $f57e19ceedfbd367$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $f57e19ceedfbd367$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $f57e19ceedfbd367$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R200", function () { return $f57e19ceedfbd367$export$60847d42f9da92a6; });
$parcel$export(module.exports, "R300", function () { return $f57e19ceedfbd367$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $f57e19ceedfbd367$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $f57e19ceedfbd367$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $f57e19ceedfbd367$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $f57e19ceedfbd367$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y100", function () { return $f57e19ceedfbd367$export$1cc05bbbf340e559; });
$parcel$export(module.exports, "Y200", function () { return $f57e19ceedfbd367$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $f57e19ceedfbd367$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $f57e19ceedfbd367$export$59619663aa6500fb; });
$parcel$export(module.exports, "Y500", function () { return $f57e19ceedfbd367$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $f57e19ceedfbd367$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $f57e19ceedfbd367$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G100", function () { return $f57e19ceedfbd367$export$afbce1382ec95f73; });
$parcel$export(module.exports, "G200", function () { return $f57e19ceedfbd367$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $f57e19ceedfbd367$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $f57e19ceedfbd367$export$a49394138f7b8e85; });
$parcel$export(module.exports, "G500", function () { return $f57e19ceedfbd367$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $f57e19ceedfbd367$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $f57e19ceedfbd367$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $f57e19ceedfbd367$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $f57e19ceedfbd367$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $f57e19ceedfbd367$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $f57e19ceedfbd367$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $f57e19ceedfbd367$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "B600", function () { return $f57e19ceedfbd367$export$67f15409e87642a1; });
$parcel$export(module.exports, "B700", function () { return $f57e19ceedfbd367$export$f0539dbc42dbb067; });
$parcel$export(module.exports, "P50", function () { return $f57e19ceedfbd367$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $f57e19ceedfbd367$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $f57e19ceedfbd367$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $f57e19ceedfbd367$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $f57e19ceedfbd367$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P400", function () { return $f57e19ceedfbd367$export$c71e4279dd54a18d; });
$parcel$export(module.exports, "P500", function () { return $f57e19ceedfbd367$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $f57e19ceedfbd367$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $f57e19ceedfbd367$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $f57e19ceedfbd367$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $f57e19ceedfbd367$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $f57e19ceedfbd367$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T400", function () { return $f57e19ceedfbd367$export$7c835c78b6fcdef8; });
$parcel$export(module.exports, "T500", function () { return $f57e19ceedfbd367$export$6036577f95c3877e; });
$parcel$export(module.exports, "N0", function () { return $f57e19ceedfbd367$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $f57e19ceedfbd367$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $f57e19ceedfbd367$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $f57e19ceedfbd367$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $f57e19ceedfbd367$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N50", function () { return $f57e19ceedfbd367$export$8754fc7e6d8b3000; });
$parcel$export(module.exports, "N60", function () { return $f57e19ceedfbd367$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N70", function () { return $f57e19ceedfbd367$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $f57e19ceedfbd367$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N90", function () { return $f57e19ceedfbd367$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N100", function () { return $f57e19ceedfbd367$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $f57e19ceedfbd367$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $f57e19ceedfbd367$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N400", function () { return $f57e19ceedfbd367$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $f57e19ceedfbd367$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N600", function () { return $f57e19ceedfbd367$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N700", function () { return $f57e19ceedfbd367$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $f57e19ceedfbd367$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N900", function () { return $f57e19ceedfbd367$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N10A", function () { return $f57e19ceedfbd367$export$791e57b27ca738ef; });
$parcel$export(module.exports, "N20A", function () { return $f57e19ceedfbd367$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $f57e19ceedfbd367$export$920c0d5c49070351; });
$parcel$export(module.exports, "N40A", function () { return $f57e19ceedfbd367$export$46987b49aab6d1a8; });
$parcel$export(module.exports, "N50A", function () { return $f57e19ceedfbd367$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $f57e19ceedfbd367$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "N70A", function () { return $f57e19ceedfbd367$export$6e5e7499ff054f6d; });
$parcel$export(module.exports, "N80A", function () { return $f57e19ceedfbd367$export$59264b346c877fa7; });
$parcel$export(module.exports, "N90A", function () { return $f57e19ceedfbd367$export$d092757d7c64925c; });
$parcel$export(module.exports, "N100A", function () { return $f57e19ceedfbd367$export$486ab785e4bac3c6; });
$parcel$export(module.exports, "N200A", function () { return $f57e19ceedfbd367$export$fba592bbc6419fea; });
$parcel$export(module.exports, "N300A", function () { return $f57e19ceedfbd367$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N400A", function () { return $f57e19ceedfbd367$export$fbae4efaa892d883; });
$parcel$export(module.exports, "N500A", function () { return $f57e19ceedfbd367$export$f13946d26f440ce6; });
$parcel$export(module.exports, "N600A", function () { return $f57e19ceedfbd367$export$19f58225ac52a306; });
$parcel$export(module.exports, "N700A", function () { return $f57e19ceedfbd367$export$6384f09da70e7b62; });
$parcel$export(module.exports, "N800A", function () { return $f57e19ceedfbd367$export$d0dccc730683edc2; });
$parcel$export(module.exports, "DN900", function () { return $f57e19ceedfbd367$export$2f6319cf7d736c2a; });
$parcel$export(module.exports, "DN800", function () { return $f57e19ceedfbd367$export$95126bc8884d6634; });
$parcel$export(module.exports, "DN700", function () { return $f57e19ceedfbd367$export$8338d8c35d44ff1; });
$parcel$export(module.exports, "DN600", function () { return $f57e19ceedfbd367$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN500", function () { return $f57e19ceedfbd367$export$9f0a771d16ec8d36; });
$parcel$export(module.exports, "DN400", function () { return $f57e19ceedfbd367$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $f57e19ceedfbd367$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN200", function () { return $f57e19ceedfbd367$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN100", function () { return $f57e19ceedfbd367$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN90", function () { return $f57e19ceedfbd367$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN80", function () { return $f57e19ceedfbd367$export$91fd9994c5be9757; });
$parcel$export(module.exports, "DN70", function () { return $f57e19ceedfbd367$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $f57e19ceedfbd367$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN50", function () { return $f57e19ceedfbd367$export$8e8133c1ba5845b5; });
$parcel$export(module.exports, "DN40", function () { return $f57e19ceedfbd367$export$33ff357f6620b39; });
$parcel$export(module.exports, "DN30", function () { return $f57e19ceedfbd367$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN20", function () { return $f57e19ceedfbd367$export$9776a6e503bdbf76; });
$parcel$export(module.exports, "DN10", function () { return $f57e19ceedfbd367$export$6c813d5160dff5db; });
$parcel$export(module.exports, "DN0", function () { return $f57e19ceedfbd367$export$3d4f271a500072a; });
$parcel$export(module.exports, "DN800A", function () { return $f57e19ceedfbd367$export$fe151285c22759ec; });
$parcel$export(module.exports, "DN700A", function () { return $f57e19ceedfbd367$export$a101c6190d0da34; });
$parcel$export(module.exports, "DN600A", function () { return $f57e19ceedfbd367$export$4b16f52932fda51; });
$parcel$export(module.exports, "DN500A", function () { return $f57e19ceedfbd367$export$a74bcd7b9845b0d8; });
$parcel$export(module.exports, "DN400A", function () { return $f57e19ceedfbd367$export$9209c179316d1751; });
$parcel$export(module.exports, "DN300A", function () { return $f57e19ceedfbd367$export$88f55133f636c8dd; });
$parcel$export(module.exports, "DN200A", function () { return $f57e19ceedfbd367$export$51126f85d1009512; });
$parcel$export(module.exports, "DN100A", function () { return $f57e19ceedfbd367$export$a069b547bd23af78; });
$parcel$export(module.exports, "DN90A", function () { return $f57e19ceedfbd367$export$40cce05af3b2600a; });
$parcel$export(module.exports, "DN80A", function () { return $f57e19ceedfbd367$export$b78942185925a0d; });
$parcel$export(module.exports, "DN70A", function () { return $f57e19ceedfbd367$export$e058fb44b8eaafca; });
$parcel$export(module.exports, "DN60A", function () { return $f57e19ceedfbd367$export$92b0b8de26920c18; });
$parcel$export(module.exports, "DN50A", function () { return $f57e19ceedfbd367$export$67564f7459d3fc9e; });
$parcel$export(module.exports, "DN40A", function () { return $f57e19ceedfbd367$export$77868e1ca884ffa3; });
$parcel$export(module.exports, "DN30A", function () { return $f57e19ceedfbd367$export$2afd71d7d3ea2cd5; });
$parcel$export(module.exports, "DN20A", function () { return $f57e19ceedfbd367$export$f2a0acaab9972c70; });
$parcel$export(module.exports, "DN10A", function () { return $f57e19ceedfbd367$export$9ab70e67d6475361; });
$parcel$export(module.exports, "T30", function () { return $f57e19ceedfbd367$export$d2adc5dedf09fced; });
$parcel$export(module.exports, "L50", function () { return $f57e19ceedfbd367$export$f51762073d2bb381; });
$parcel$export(module.exports, "L75", function () { return $f57e19ceedfbd367$export$95e26d54def96891; });
// Reds
var $f57e19ceedfbd367$export$4b84fd0e2c617bd = '#FFEBE6';
var $f57e19ceedfbd367$export$b34b069eff244586 = '#FFBDAD';
var $f57e19ceedfbd367$export$be802dd0d8b57f35 = '#FF8F73';
var $f57e19ceedfbd367$export$60847d42f9da92a6 = '#FF7452';
var $f57e19ceedfbd367$export$4a7404f376229999 = '#FF5630';
var $f57e19ceedfbd367$export$2010d0fb4295b346 = '#DE350B';
var $f57e19ceedfbd367$export$2837b5a1a71d5c02 = '#BF2600';
var $f57e19ceedfbd367$export$8d9596b529bbb9cf = '#FFFAE6';
var $f57e19ceedfbd367$export$41060a744ab0b7ae = '#FFF0B3';
var $f57e19ceedfbd367$export$1cc05bbbf340e559 = '#FFE380';
var $f57e19ceedfbd367$export$5aae31392d72caaa = '#FFC400';
var $f57e19ceedfbd367$export$c6930421db9fa514 = '#FFAB00';
var $f57e19ceedfbd367$export$59619663aa6500fb = '#FF991F';
var $f57e19ceedfbd367$export$874739ea9e379ab6 = '#FF8B00';
var $f57e19ceedfbd367$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $f57e19ceedfbd367$export$69a3bf21b9686c2b = '#ABF5D1';
var $f57e19ceedfbd367$export$afbce1382ec95f73 = '#79F2C0';
var $f57e19ceedfbd367$export$747d86715d4175de = '#57D9A3';
var $f57e19ceedfbd367$export$940e1f69e873f202 = '#36B37E';
var $f57e19ceedfbd367$export$a49394138f7b8e85 = '#00875A';
var $f57e19ceedfbd367$export$6fa04827ac68a4fb = '#006644';
var $f57e19ceedfbd367$export$226de0355ed012f8 = '#DEEBFF';
var $f57e19ceedfbd367$export$8c13c2ee36917869 = '#B3D4FF';
var $f57e19ceedfbd367$export$ecfc1dff386a3e7a = '#4C9AFF';
var $f57e19ceedfbd367$export$215b7063051591f1 = '#2684FF';
var $f57e19ceedfbd367$export$e62e8919cca44969 = '#0065FF';
var $f57e19ceedfbd367$export$b3de0ae08da2ce64 = '#0052CC';
var $f57e19ceedfbd367$export$a6ee3d71bc067634 = '#0747A6';
var $f57e19ceedfbd367$export$67f15409e87642a1 = '#669DF1';
var $f57e19ceedfbd367$export$f0539dbc42dbb067 = '#8FB8F6';
var $f57e19ceedfbd367$export$363e4475840015bb = '#EAE6FF';
var $f57e19ceedfbd367$export$4b0a4417ed59760f = '#C0B6F2';
var $f57e19ceedfbd367$export$6011520a64d9a187 = '#998DD9';
var $f57e19ceedfbd367$export$a7175d4e9206bc80 = '#8777D9';
var $f57e19ceedfbd367$export$b48405b95304b5a1 = '#6554C0';
var $f57e19ceedfbd367$export$c71e4279dd54a18d = '#5243AA';
var $f57e19ceedfbd367$export$147899de772240ec = '#403294';
var $f57e19ceedfbd367$export$2cf711fe14c66f06 = '#E6FCFF';
var $f57e19ceedfbd367$export$7a8f4d33f6f9772c = '#B3F5FF';
var $f57e19ceedfbd367$export$776c9c497ef08533 = '#79E2F2';
var $f57e19ceedfbd367$export$69cb3ca10c1e330e = '#00C7E6';
var $f57e19ceedfbd367$export$9dc1ef0f3f48059b = '#00B8D9';
var $f57e19ceedfbd367$export$7c835c78b6fcdef8 = '#00A3BF';
var $f57e19ceedfbd367$export$6036577f95c3877e = '#008DA6';
var $f57e19ceedfbd367$export$29a4f05edc054374 = '#FFFFFF';
var $f57e19ceedfbd367$export$e655ef011c4aa1a2 = '#FAFBFC';
var $f57e19ceedfbd367$export$9fdfb749e33cdf97 = '#F4F5F7';
var $f57e19ceedfbd367$export$3e51e8f1440314ba = '#EBECF0';
var $f57e19ceedfbd367$export$1ce2d1575d444ceb = '#DFE1E6';
var $f57e19ceedfbd367$export$8754fc7e6d8b3000 = '#C1C7D0';
var $f57e19ceedfbd367$export$c2e91cbeada39b8b = '#B3BAC5';
var $f57e19ceedfbd367$export$5f71e19f3a7ad9de = '#A5ADBA';
var $f57e19ceedfbd367$export$eaa8c8a70ac22806 = '#97A0AF';
var $f57e19ceedfbd367$export$7c87d337fb91a97d = '#8993A4';
var $f57e19ceedfbd367$export$d6447c357493214f = '#7A869A';
var $f57e19ceedfbd367$export$f563ee71e9ee74cd = '#6B778C';
var $f57e19ceedfbd367$export$e2ef2124cf4024b1 = '#5E6C84';
var $f57e19ceedfbd367$export$eece5f492e429f08 = '#505F79';
var $f57e19ceedfbd367$export$c39c0fe0f26207ae = '#42526E';
var $f57e19ceedfbd367$export$7090862dc3038a9f = '#344563';
var $f57e19ceedfbd367$export$ad0bacf983b7ddaa = '#253858';
var $f57e19ceedfbd367$export$7d61b15e0da132af = '#172B4D';
var $f57e19ceedfbd367$export$fbda843f0a27fe96 = '#091E42';
var $f57e19ceedfbd367$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $f57e19ceedfbd367$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $f57e19ceedfbd367$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $f57e19ceedfbd367$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $f57e19ceedfbd367$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $f57e19ceedfbd367$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $f57e19ceedfbd367$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $f57e19ceedfbd367$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $f57e19ceedfbd367$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $f57e19ceedfbd367$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $f57e19ceedfbd367$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $f57e19ceedfbd367$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $f57e19ceedfbd367$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $f57e19ceedfbd367$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $f57e19ceedfbd367$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $f57e19ceedfbd367$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $f57e19ceedfbd367$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $f57e19ceedfbd367$export$2f6319cf7d736c2a = '#E6EDFA';
var $f57e19ceedfbd367$export$95126bc8884d6634 = '#DCE5F5';
var $f57e19ceedfbd367$export$8338d8c35d44ff1 = '#CED9EB';
var $f57e19ceedfbd367$export$5368d76ae4fbbda7 = '#B8C7E0';
var $f57e19ceedfbd367$export$9f0a771d16ec8d36 = '#ABBBD6';
var $f57e19ceedfbd367$export$abcf8c38338b4aa5 = '#9FB0CC';
var $f57e19ceedfbd367$export$97e81faa16a182c7 = '#8C9CB8';
var $f57e19ceedfbd367$export$bfe21c59123ecf33 = '#7988A3';
var $f57e19ceedfbd367$export$ee82aa2ea6a1558 = '#67758F';
var $f57e19ceedfbd367$export$682927c6ed76be02 = '#56637A';
var $f57e19ceedfbd367$export$91fd9994c5be9757 = '#455166';
var $f57e19ceedfbd367$export$d281fbfe3cff2df6 = '#3B475C';
var $f57e19ceedfbd367$export$3902c91d8b98a753 = '#313D52';
var $f57e19ceedfbd367$export$8e8133c1ba5845b5 = '#283447';
var $f57e19ceedfbd367$export$33ff357f6620b39 = '#202B3D';
var $f57e19ceedfbd367$export$633847cf062b69e0 = '#1B2638';
var $f57e19ceedfbd367$export$9776a6e503bdbf76 = '#121A29';
var $f57e19ceedfbd367$export$6c813d5160dff5db = '#0E1624';
var $f57e19ceedfbd367$export$3d4f271a500072a = '#0D1424';
var $f57e19ceedfbd367$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $f57e19ceedfbd367$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $f57e19ceedfbd367$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $f57e19ceedfbd367$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $f57e19ceedfbd367$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $f57e19ceedfbd367$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $f57e19ceedfbd367$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $f57e19ceedfbd367$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $f57e19ceedfbd367$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $f57e19ceedfbd367$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $f57e19ceedfbd367$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $f57e19ceedfbd367$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $f57e19ceedfbd367$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $f57e19ceedfbd367$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $f57e19ceedfbd367$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $f57e19ceedfbd367$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $f57e19ceedfbd367$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $f57e19ceedfbd367$export$d2adc5dedf09fced = '#292A2E';
var $f57e19ceedfbd367$export$f51762073d2bb381 = '#94C748';
var $f57e19ceedfbd367$export$95e26d54def96891 = '#B3DF72';

});




parcelRegister("76XtE", function(module, exports) {

$parcel$export(module.exports, "resetAppState", function () { return $029da9ff48854adb$export$10d871c0f32f1a89; });
$parcel$export(module.exports, "setGlobalStateLoading", function () { return $029da9ff48854adb$export$5bd83014b5b74a54; });

var $aMBBA = parcelRequire("aMBBA");
const $029da9ff48854adb$export$10d871c0f32f1a89 = (data)=>({
        type: (0, $aMBBA.RESET_APP_STATE),
        data: data
    });
const $029da9ff48854adb$export$5bd83014b5b74a54 = (isLoading)=>({
        type: 'SET_GLOBAL_STATE_LOADING',
        isLoading: isLoading
    });

});

parcelRegister("dJpcp", function(module, exports) {

$parcel$export(module.exports, "initCastle", function () { return $5ef2e649a2e16025$export$22e481f8c6e85dea; });
$parcel$export(module.exports, "getCastleRequestToken", function () { return $5ef2e649a2e16025$export$8cbdca1a2ad79c4e; });

var $6D6a3 = parcelRequire("6D6a3");

var $hhYxc = parcelRequire("hhYxc");

var $hqddj = parcelRequire("hqddj");
function $5ef2e649a2e16025$export$22e481f8c6e85dea(appConfig) {
    if ((0, $hhYxc.currentCloudType) !== 'commercial') return; // Castle is not enabled for FedRAMP
    if (!appConfig?.castlePublishableApiKey) {
        (0, $hqddj.captureMessage)('castlePublishableApiKey is not present in appConfig during initCastle', {}, 'error', {
            castle: 'castle_config_error'
        });
        return;
    }
    try {
        (0, $6D6a3.configure)({
            pk: appConfig.castlePublishableApiKey
        });
    } catch (e) {
        (0, $hqddj.captureTaggedException)(e, {
            capabilities: [],
            tags: {
                castle: 'castle_init_error'
            }
        });
    }
}
async function $5ef2e649a2e16025$export$8cbdca1a2ad79c4e(capabilities = []) {
    if ((0, $hhYxc.currentCloudType) !== 'commercial') return undefined;
    try {
        return await (0, $6D6a3.createRequestToken)();
    } catch (e) {
        console.error('castle error', e);
        (0, $hqddj.captureTaggedException)(e, {
            capabilities: capabilities,
            tags: {
                castle: 'castle_request_token_error'
            }
        });
        return undefined;
    }
}

});
parcelRegister("6D6a3", function(module, exports) {
var $4d3b2a13d1f459bf$var$n;
var $4d3b2a13d1f459bf$var$r;
$4d3b2a13d1f459bf$var$n = module.exports, $4d3b2a13d1f459bf$var$r = function(n) {
    function r() {
        return parseInt.apply(null, arguments);
    }
    function i() {
        return parseFloat.apply(null, arguments);
    }
    function t() {
        return Number.parseInt.apply(Number, arguments);
    }
    function o(n) {
        var r = [];
        return o.A || (o.A = {}), o.O || (o.O = u(new Uint8Array([
            115,
            98,
            96,
            96,
            40,
            103,
            100,
            96,
            16,
            100,
            98,
            96,
            176,
            97,
            97,
            96,
            16,
            103,
            101,
            96,
            224,
            224,
            100,
            96,
            0,
            0
        ]))), r[0] = o.A[n], void 0 !== r[0] ? r[0] : o.A[n] = o.O[0 | n];
    }
    function u(n) {
        u.V || (u.V = function() {
            function n() {
                this.q = new Uint16Array(16), this.nn = new Uint16Array(288);
            }
            function r(r, i) {
                this.tn = r, this.un = 0, this.fn = 0, this.vn = 0, this.en = i, this.cn = 0, this.dn = new n, this.an = new n;
            }
            function i(n, r, i, t) {
                var o = [];
                o[0] = 0;
                for(; o[0] < i; ++o[0])n[o[0]] = 0;
                o[0] = 0;
                for(; o[0] < 30 - i; ++o[0])n[o[0] + i] = o[0] / i | 0;
                o[1] = t, o[0] = 0;
                for(; 30 > o[0]; ++o[0])r[o[0]] = o[1], o[1] += 1 << n[o[0]];
            }
            function t(n, r, i, t) {
                var o = [];
                o[0] = 0;
                for(; 16 > o[0]; ++o[0])n.q[o[0]] = 0;
                o[0] = 0;
                for(; o[0] < t; ++o[0])n.q[r[i + o[0]]]++;
                n.q[0] = 0, o[1] = 0, o[0] = 0;
                for(; 16 > o[0]; ++o[0])M[o[0]] = o[1], o[1] += n.q[o[0]];
                o[0] = 0;
                for(; o[0] < t; ++o[0])r[i + o[0]] && (n.nn[M[r[i + o[0]]]++] = o[0]);
            }
            function o(n) {
                var r = [];
                return n.vn-- || (n.fn = n.tn[n.un++], n.vn = 7), r[0] = 1 & n.fn, n.fn >>>= 1, r[0];
            }
            function u(n, r, i) {
                var t = [];
                if (!r) return i;
                for(; 24 > n.vn;)n.fn |= n.tn[n.un++] << n.vn, n.vn += 8;
                return t[0] = n.fn & 65535 >>> 16 - r, n.fn >>>= r, n.vn -= r, t[0] + i;
            }
            function f(n, r) {
                var i = [];
                i[0] = 0, i[1] = 0, i[2] = 0;
                for(; 24 > n.vn;)n.fn |= n.tn[n.un++] << n.vn, n.vn += 8;
                i[3] = n.fn;
                do i[1] = 2 * i[1] + (1 & i[3]), i[3] >>>= 1, ++i[2], i[0] += r.q[i[2]], i[1] -= r.q[i[2]];
                while (i[1] >= 0);
                return n.fn = i[3], n.vn -= i[2], r.nn[i[0] + i[1]];
            }
            function v(n, r, i) {
                var o = [];
                o[0] = u(n, 5, 257), o[1] = u(n, 5, 1), o[2] = u(n, 4, 4), o[3] = 0;
                for(; 19 > o[3]; ++o[3])p[o[3]] = 0;
                o[3] = 0;
                for(; o[3] < o[2]; ++o[3])o[6] = u(n, 3, 0), p[m[o[3]]] = o[6];
                t(b, p, 0, 19), o[4] = 0;
                for(; o[4] < o[0] + o[1];)switch(o[7] = f(n, b), o[7]){
                    case 16:
                        o[8] = p[o[4] - 1], o[5] = u(n, 2, 3);
                        for(; o[5]; --o[5])p[o[4]++] = o[8];
                        break;
                    case 17:
                        o[5] = u(n, 3, 3);
                        for(; o[5]; --o[5])p[o[4]++] = 0;
                        break;
                    case 18:
                        o[5] = u(n, 7, 11);
                        for(; o[5]; --o[5])p[o[4]++] = 0;
                        break;
                    default:
                        p[o[4]++] = o[7];
                }
                t(r, p, 0, o[0]), t(i, p, o[0], o[1]);
            }
            function e(n, r, i) {
                var t = [];
                for(;;){
                    if (t[0] = f(n, r), 256 === t[0]) return 0;
                    if (256 > t[0]) n.en[n.cn++] = t[0];
                    else {
                        t[0] -= 257, t[1] = u(n, s[t[0]], h[t[0]]), t[2] = f(n, i), t[3] = n.cn - u(n, y[t[2]], N[t[2]]), t[4] = t[3];
                        for(; t[4] < t[3] + t[1]; ++t[4])n.en[n.cn++] = n.en[t[4]];
                    }
                }
            }
            function c(n) {
                var r = [];
                for(; n.vn > 8;)n.un--, n.vn -= 8;
                if (r[0] = n.tn[n.un + 1], r[0] = 256 * r[0] + n.tn[n.un], r[1] = n.tn[n.un + 3], r[1] = 256 * r[1] + n.tn[n.un + 2], r[0] !== (65535 & ~r[1])) return -3;
                n.un += 4, r[2] = r[0];
                for(; r[2]; --r[2])n.en[n.cn++] = n.tn[n.un++];
                return n.vn = 0, 0;
            }
            var d = {
                exports: {}
            };
            var a = (d.exports, new n);
            var l = new n;
            var s = new Uint8Array(30);
            var h = new Uint16Array(30);
            var y = new Uint8Array(30);
            var N = new Uint16Array(30);
            var m = new Uint8Array([
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ]);
            var b = new n;
            var p = new Uint8Array(320);
            var M = new Uint16Array(16);
            !function(n, r) {
                var i = [];
                i[0] = 0;
                for(; 7 > i[0]; ++i[0])n.q[i[0]] = 0;
                n.q[7] = 24, n.q[8] = 152, n.q[9] = 112, i[0] = 0;
                for(; 24 > i[0]; ++i[0])n.nn[i[0]] = 256 + i[0];
                i[0] = 0;
                for(; 144 > i[0]; ++i[0])n.nn[24 + i[0]] = i[0];
                i[0] = 0;
                for(; 8 > i[0]; ++i[0])n.nn[168 + i[0]] = 280 + i[0];
                i[0] = 0;
                for(; 112 > i[0]; ++i[0])n.nn[176 + i[0]] = 144 + i[0];
                i[0] = 0;
                for(; 5 > i[0]; ++i[0])r.q[i[0]] = 0;
                r.q[5] = 32, i[0] = 0;
                for(; 32 > i[0]; ++i[0])r.nn[i[0]] = i[0];
            }(a, l), i(s, h, 4, 3), i(y, N, 2, 1), s[28] = 0, h[28] = 258, d.exports = function(n, i) {
                var t = [];
                t[0] = new r(n, i);
                do {
                    switch(t[1] = o(t[0]), t[2] = u(t[0], 2, 0), t[2]){
                        case 0:
                            t[3] = c(t[0]);
                            break;
                        case 1:
                            t[3] = e(t[0], a, l);
                            break;
                        case 2:
                            v(t[0], t[0].dn, t[0].an), t[3] = e(t[0], t[0].dn, t[0].an);
                            break;
                        default:
                            t[3] = -3;
                    }
                    if (0 !== t[3]) throw Error("Data error");
                }while (!t[1]);
                return t[0].cn < t[0].en.length ? "function" == typeof t[0].en.slice ? t[0].en.slice(0, t[0].cn) : t[0].en.subarray(0, t[0].cn) : t[0].en;
            };
            var w = d.exports;
            return function(n) {
                return new Uint8Array(w(n, []));
            };
        }());
        var r = u.V(n);
        var i = r.length >>> 2;
        var t = new Int32Array(i);
        var o = new DataView(r.buffer, r.byteOffset, r.byteLength);
        var f = 0;
        for(; i > f; f++)t[f] = o.getInt32(f << 2, !0);
        return t;
    }
    function f(n, r) {
        var i = [];
        return f.H || (f.H = {}), f.L || (f.L = v(new Uint8Array([
            X,
            j,
            g,
            T,
            Z,
            L,
            H,
            k,
            J,
            W,
            _,
            G,
            x,
            R,
            U,
            S,
            I,
            B,
            D,
            7,
            q,
            z,
            7,
            $,
            $,
            K,
            V,
            I,
            C,
            P,
            Q,
            Y,
            nn,
            rn,
            H,
            tn,
            on,
            un,
            fn,
            g,
            vn,
            6,
            un,
            j,
            en,
            cn,
            dn,
            an,
            ln,
            sn,
            hn,
            yn,
            Nn,
            mn,
            bn,
            pn,
            Mn,
            wn,
            T,
            An,
            Fn,
            W,
            En,
            On,
            I,
            Xn,
            C,
            jn,
            gn,
            j,
            Tn,
            en,
            Zn,
            Ln,
            Hn,
            kn,
            Jn,
            g,
            Wn,
            _n,
            L,
            Gn,
            xn,
            Mn,
            Rn,
            Un,
            mn,
            T,
            Sn,
            In,
            Bn,
            Dn,
            fn,
            qn,
            zn,
            $n,
            Kn,
            Vn,
            Cn,
            Pn,
            Qn,
            Yn,
            g,
            nr,
            cn,
            rr,
            sn,
            T,
            Un,
            Sn,
            Yn,
            mn,
            ir,
            Mn,
            cn,
            tr,
            Kn,
            or,
            ur,
            Sn,
            fr,
            Fn,
            9,
            _n,
            K,
            ur,
            vr,
            $n,
            er,
            cr,
            dr,
            fr,
            ar,
            yn,
            lr,
            sr,
            hr,
            yr,
            Nr,
            U,
            mr,
            L,
            Vn,
            br,
            sn,
            I,
            sn,
            9,
            L,
            pr,
            Un,
            Mr,
            On,
            Ln,
            rr,
            sr,
            wr,
            $n,
            un,
            5,
            Ar,
            Fr,
            Er,
            Mn,
            U,
            Or,
            Kn,
            fn,
            Xr,
            jr,
            gr,
            Dn,
            Tr,
            un,
            In,
            Zr,
            Yn,
            T,
            Lr,
            rr,
            Hr,
            Kn,
            kr,
            Jr,
            rr,
            Or,
            Kn,
            Wr,
            on,
            _r,
            X,
            gn,
            Gr,
            kn,
            Q,
            xr,
            Dn,
            V,
            mn,
            dn,
            C,
            J,
            zn,
            Rr,
            gr,
            Ur,
            wn,
            K,
            Sr,
            hr,
            On,
            Ir,
            U,
            W,
            Dn,
            rn,
            qn,
            Br,
            Dr,
            qr,
            zr,
            $r,
            zn,
            Hr,
            Wr,
            Er,
            Kr,
            lr,
            sr,
            Zn,
            8,
            Sn,
            cr,
            jn,
            Vr,
            On,
            Sn,
            X,
            Cr,
            Fr,
            Pr,
            G,
            jr,
            Qr,
            Dn,
            Jn,
            Yr,
            zn,
            ni,
            Dn,
            ri,
            Mn,
            j,
            ii,
            hr,
            T,
            Cn,
            rr,
            zn,
            mn,
            ti,
            Kn,
            dn,
            oi,
            Wr,
            8,
            Lr,
            ui,
            W,
            On,
            xn,
            In,
            fi,
            wr,
            vi,
            rr,
            vi,
            Vr,
            ei,
            Xn,
            ci,
            Bn,
            vr,
            T,
            Ir,
            zn,
            Zr,
            W,
            di,
            ri,
            V,
            vr,
            an,
            Fn,
            Pr,
            ai,
            vr,
            ti,
            ar,
            Cn,
            Mr,
            ui,
            Un,
            yr,
            T,
            li,
            si,
            Tn,
            hi,
            yi,
            g,
            Hn,
            si,
            Ni,
            ui,
            en,
            En,
            mi,
            Wr,
            vi,
            cn,
            bi,
            vr,
            Er,
            er,
            $,
            rr,
            pi,
            Mi,
            dn,
            Ar,
            Fn,
            $n,
            wi,
            jr,
            Ai,
            Yr,
            Gr,
            Fi,
            Ei,
            Un,
            2,
            Oi,
            qr,
            fi,
            di,
            Xi,
            $n,
            Mn,
            In,
            pr,
            Wr,
            V,
            Nr,
            ji,
            I,
            Xi,
            On,
            Lr,
            Pn,
            X,
            qr,
            Bn,
            cn,
            kr,
            Y,
            gi,
            Ti,
            Zi,
            Li,
            Xi,
            kr,
            X,
            Q,
            Rr,
            Hi,
            ri,
            wn,
            cr,
            Qn,
            ki,
            ar,
            _n,
            _r,
            Hi,
            Fn,
            Ji,
            on,
            jr,
            C,
            Vr,
            Wi,
            pi,
            bn,
            kn,
            X,
            ii,
            Kn,
            _i,
            Gi,
            xi,
            hi,
            Fn,
            bn,
            Ar,
            xi,
            Jn,
            Dn,
            Ri,
            er,
            Sn,
            zr,
            Kn,
            8,
            Ui,
            Sn,
            Si,
            vr,
            Ii,
            L,
            ci,
            Gi,
            Bi,
            qr,
            g,
            Ar,
            Sn,
            Di,
            Mi,
            Ei,
            _n,
            In,
            qi,
            Rn,
            S,
            tr,
            In,
            zi,
            W,
            Cn,
            Q,
            ii,
            Q,
            rn,
            un,
            _r,
            Ai,
            $i,
            ui,
            Zn,
            An,
            qr,
            gi,
            Ti,
            lr,
            Ki,
            vr,
            pi,
            L,
            Oi,
            Un,
            Wr,
            Vi,
            Ti,
            j,
            Qn,
            Fn,
            Ci,
            wi,
            jr,
            Di,
            L,
            _i,
            L,
            Vn,
            ur,
            Yn,
            Jn,
            Pi,
            Qi,
            qn,
            yi,
            kr,
            sr,
            Vn,
            I,
            Rn,
            Yi,
            U,
            nt,
            sr,
            fr,
            Ii,
            Qr,
            lr,
            rt,
            Vr,
            T,
            _n,
            Vn,
            it,
            W,
            Fi,
            Oi,
            Ai,
            Yr,
            8,
            On,
            Bn,
            Dr,
            sn,
            _i,
            Mi,
            Kn,
            Hr,
            Ni,
            8,
            Xr,
            tt,
            Sr,
            ki,
            pi,
            xi,
            ot,
            Ui,
            Or,
            kr,
            Ni,
            ti,
            Mi,
            wr,
            qn,
            Ni,
            Gn,
            ei,
            Ei,
            ut,
            $r,
            T,
            Hn,
            Pn,
            X,
            Ni,
            or,
            _n,
            V,
            _n,
            nr,
            4,
            Bn,
            Ki,
            si,
            q,
            I,
            fr,
            _i,
            ur,
            Cn,
            Fr,
            ar,
            wi,
            Oi,
            6,
            Gr,
            Bn,
            ft,
            vt,
            un,
            lr,
            fr,
            hr,
            wn,
            Bn,
            Di,
            Kn,
            pi,
            Hn,
            Tn,
            Ar,
            Ni,
            ui,
            et,
            jr,
            Hi,
            sn,
            9,
            en,
            Pn,
            C,
            Ni,
            T,
            _n,
            5,
            it,
            Yn,
            Ci,
            Ui,
            zn,
            sr,
            ct,
            $n,
            kn,
            cn,
            dt,
            ft,
            fn,
            at,
            Xn,
            R,
            xi,
            zr,
            mn,
            kr,
            lt,
            Pn,
            Pr,
            Fr,
            T,
            Pi,
            q,
            Sr,
            Wr,
            kr,
            Ar,
            Pn,
            rt,
            vr,
            Vn,
            et,
            q,
            nt,
            Q,
            st,
            Mi,
            ht,
            nt,
            Yn,
            st,
            ji,
            Kr,
            nt,
            Mr,
            st,
            Ln,
            Sn,
            Un,
            Mi,
            qn,
            yt,
            cr,
            tn,
            In,
            $n,
            ki,
            Gr,
            Pi,
            cr,
            qn,
            L,
            kr,
            Un,
            Pn,
            I,
            vr,
            Jn,
            K,
            xr,
            Jr,
            si,
            vr,
            _i,
            Sn,
            Sn,
            $r,
            Nt,
            Ai,
            hr,
            _i,
            Ui,
            j,
            sr,
            Dn,
            $n,
            wi,
            cn,
            Bi,
            bn,
            Ir,
            Kr,
            4,
            zi,
            Fr,
            ar,
            R,
            X,
            oi,
            mn,
            gi,
            wn,
            Br,
            mi,
            yi,
            pi,
            Xi,
            mt,
            Mi,
            Nr,
            Ui,
            vn,
            nt,
            Yr,
            gi,
            yn,
            En,
            ot,
            dr,
            0,
            tn,
            Q,
            Nr,
            Fr,
            Yr,
            Rn,
            mn,
            cr,
            Wi,
            Y,
            bn,
            Mn,
            Q,
            qi,
            ht,
            8,
            xn,
            In,
            Sr,
            Yn,
            yn,
            ii,
            U,
            qi,
            Br,
            pn,
            bn,
            bt,
            Mn,
            Sn,
            Or,
            Zn,
            ir,
            hr,
            _n,
            Wi,
            Y,
            ir,
            ar,
            oi,
            pt,
            X,
            Wi,
            mn,
            ir,
            wn,
            _r,
            mi,
            Fn,
            pi,
            Pi,
            dr,
            On,
            Vr,
            8,
            k,
            ji,
            ht,
            Y,
            Er,
            yn,
            Sn,
            dr,
            Kn,
            bn,
            Jr,
            K,
            lt,
            Qi,
            En,
            In,
            Mt,
            qr,
            oi,
            Xr,
            9,
            Ar,
            In,
            rt,
            qr,
            Vn,
            Nr,
            jr,
            wt,
            K,
            Bi,
            nn,
            fr,
            fn,
            vn,
            Tn,
            pt,
            wr,
            8,
            Ci,
            ji,
            mr,
            Mr,
            T,
            An,
            Sn,
            wt,
            Zn,
            oi,
            sr,
            T,
            q,
            gn,
            zi,
            qr,
            ar,
            qn,
            X,
            $n,
            mn,
            Vn,
            On,
            mn,
            Pi,
            pi,
            en,
            In,
            Un,
            qr,
            pi,
            qn,
            vn,
            En,
            cr,
            dn,
            Yn,
            rn,
            K,
            qi,
            Kr,
            tt,
            zi,
            Yn,
            ar,
            Lr,
            X,
            Wi,
            ki,
            Hn,
            tr,
            j,
            Mr,
            yi,
            tn,
            0,
            Ri,
            xn,
            Qi,
            Li,
            V,
            lr,
            Y,
            Cr,
            K,
            Hn,
            At,
            $i,
            X,
            gr,
            kn,
            Lr,
            fi,
            Dn,
            gi,
            Nr,
            Wr,
            Gn,
            Ft,
            Q,
            Et,
            zi,
            Ei,
            ar,
            jr,
            Et,
            An,
            Pn,
            Et,
            Ot,
            _r,
            tt,
            Xt,
            tt,
            Nr,
            Ui,
            jr,
            vi,
            K,
            Yi,
            Wi,
            gi,
            ci,
            fr,
            yr,
            nr,
            Tn,
            vi,
            Kn,
            Ji,
            Jr,
            Zi,
            Gi,
            tn,
            Rr,
            Y,
            Ii,
            Q,
            ti,
            nr,
            mr,
            rr,
            Ci,
            nr,
            j,
            Si,
            gi,
            Mt,
            gi,
            mn,
            Wr,
            Cr,
            _r,
            gi,
            xn,
            zn,
            rr,
            ct,
            qn,
            wn,
            Gi,
            Rn,
            Vr,
            mn,
            g,
            un,
            U,
            qn,
            W,
            hn,
            tt,
            Ci,
            _r,
            rt,
            Hi,
            jt,
            Ji,
            6,
            jr,
            R,
            xn,
            hr,
            Xt,
            Er,
            vn,
            xi,
            Mr,
            6,
            I,
            ri,
            Nt,
            xn,
            xi,
            Li,
            Mr,
            Nr,
            6,
            fn,
            $r,
            Ui,
            Xi,
            zr,
            gi,
            ui,
            Ni,
            Vr,
            g,
            Zi,
            Hi,
            T,
            Oi,
            Ir,
            wi,
            fi,
            ti,
            Vr,
            bn,
            Pi,
            j,
            X,
            mn,
            Vr,
            fn,
            T,
            Hn,
            j,
            In,
            $r,
            An,
            Hi,
            9,
            Xn,
            X,
            Dr,
            mn,
            gt,
            wn,
            cr,
            at,
            Pi,
            ur,
            Ni,
            ar,
            Xn,
            jr,
            Qn,
            Tn,
            Fn,
            Sn,
            Tt,
            Fr,
            vt,
            An,
            ui,
            W,
            g,
            _n,
            dr,
            gr,
            _n,
            Ji,
            ft,
            Hn,
            U,
            ht,
            Wr,
            Cr,
            $i,
            yn,
            Zi,
            zn,
            gi,
            Hi,
            wn,
            Xn,
            mr,
            rr,
            Ar,
            bn,
            qr,
            2,
            Ri,
            Xn,
            Pr,
            Pn,
            wr,
            Nt,
            xn,
            zn,
            Qn,
            Mr,
            Er,
            kn,
            xi,
            C,
            ti,
            Zn,
            un,
            lr,
            Zr,
            ki,
            rn,
            Xi,
            Vr,
            Kr,
            dr,
            Mi,
            K,
            Zt,
            U,
            Br,
            $r,
            yi,
            Ji,
            sr,
            pr,
            I,
            ki,
            ht,
            yr,
            K,
            Gr,
            yi,
            Dr,
            fn,
            Er,
            ji,
            ar,
            ur,
            ni,
            C,
            xi,
            Lt,
            Vr,
            xn,
            Oi,
            I,
            bt,
            wn,
            Oi,
            Cn,
            Wr,
            sr,
            gi,
            rr,
            Br,
            Yr,
            Qn,
            Ln,
            Pn,
            Mr,
            Tr,
            tr,
            pr,
            wr,
            st,
            Nr,
            $n,
            Ei,
            En,
            jt,
            V,
            xr,
            Rn,
            3,
            V,
            x,
            pn,
            pr,
            or,
            Yr,
            ir,
            Xn,
            _r,
            Qn,
            Tr,
            Bi,
            Un,
            Rn,
            wn,
            0,
            pt,
            Kr,
            Lt,
            pr,
            $,
            Ri,
            Sr,
            Mr,
            ei,
            hi,
            ji,
            fr,
            Si,
            $,
            rr,
            $r,
            Fn,
            Ji,
            An,
            Tn,
            nn,
            L,
            Jn,
            U,
            Sn,
            fr,
            Zn,
            Hn,
            Ht,
            hi,
            Ln,
            kt,
            dr,
            Qn,
            Ci,
            Sn,
            rr,
            jn,
            J,
            Wr,
            Gr,
            U,
            Jt,
            wt,
            Wt,
            sn,
            Ei,
            _t,
            C,
            An,
            bt,
            zi,
            Yr,
            ri,
            Ni,
            Ln,
            bn,
            Qr,
            dr,
            j,
            Fn,
            Vn,
            Qr,
            jr,
            Ki,
            K,
            kn,
            Ci,
            yt,
            ni,
            Ti,
            _n,
            fi,
            J,
            Pn,
            mi,
            Mr,
            En,
            lt,
            Tn,
            W,
            wr,
            ar,
            br,
            rr,
            Ar,
            Fn,
            Nr,
            W,
            tn,
            V,
            T,
            Vr,
            Ei,
            lt,
            sn,
            W,
            L,
            ar,
            Un,
            rr,
            ur,
            Fn,
            T,
            An,
            ji,
            H,
            fr,
            ui,
            U,
            jr,
            ht,
            Dn,
            ir,
            G,
            U,
            Gt,
            ui,
            Lt,
            yr,
            at,
            $r,
            Ar,
            2,
            Gi,
            Yn,
            ar,
            Pi,
            X,
            C,
            ht,
            Jn,
            on,
            Qi,
            it,
            wt,
            ii,
            Rn,
            zi,
            Sr,
            Ht,
            vi,
            Hn,
            Br,
            Gr,
            lt,
            Nr,
            _n,
            jr,
            hr,
            Nr,
            qn,
            Br,
            Rr,
            ft,
            st,
            Nt,
            ot,
            Br,
            li,
            ht,
            On,
            6,
            er,
            jt,
            ar,
            an,
            X,
            Rr,
            Nt,
            at,
            Pr,
            Ii,
            K,
            Mn,
            Lt,
            Pr,
            at,
            $n,
            ot,
            gi,
            sr,
            Pr,
            Cr,
            Vr,
            tr,
            yt,
            Sn,
            Yr,
            tr,
            or,
            xi,
            Er,
            T,
            xi,
            pi,
            ei,
            Ft,
            Cn,
            ni,
            wr,
            wn,
            kn,
            rt,
            In,
            Ci,
            Lt,
            rt,
            qi,
            $n,
            Br,
            xt,
            Ir,
            Pr,
            Fr,
            mn,
            Ci,
            Ar,
            zn,
            R,
            an,
            nr,
            k,
            at,
            Wt,
            zn,
            2,
            zi,
            Ui,
            Ji,
            di,
            qr,
            Nt,
            kn,
            Pr,
            Oi,
            ct,
            or,
            Ti,
            V,
            Xi,
            Tt,
            mi,
            Br,
            Rt,
            Kn,
            qn,
            Cr,
            L,
            bn,
            ur,
            zn,
            T,
            ct,
            ui,
            Ti,
            Qi,
            bi,
            Ni,
            _i,
            yn,
            rn,
            Kn,
            rr,
            bi,
            Vr,
            _i,
            lt,
            j,
            ii,
            Dn,
            Hn,
            un,
            Oi,
            Ar,
            gi,
            ft,
            Xi,
            oi,
            C,
            rn,
            ji,
            Rt,
            oi,
            Yr,
            gi,
            _t,
            Lr,
            Ut,
            jr,
            R,
            Ji,
            Yr,
            Oi,
            kt,
            mi,
            kn,
            oi,
            x,
            Sn,
            qn,
            L,
            tn,
            hn,
            kr,
            V,
            hi,
            fn,
            Rt,
            ji,
            Un,
            ji,
            ei,
            Tt,
            mn,
            Vn,
            3,
            Er,
            at,
            Xn,
            St,
            Xr,
            Mr,
            ct,
            oi,
            Mi,
            Vr,
            at,
            Qi,
            An,
            Oi,
            6,
            jn,
            St,
            1,
            Et,
            Br,
            Gt,
            ti,
            It,
            Qn,
            Wn,
            Zi,
            ft,
            yt,
            wi,
            hi,
            Jn,
            bn,
            Bi,
            Bt,
            ui,
            xi,
            Kr,
            Ai,
            mn,
            Er,
            gn,
            wn,
            L,
            bn,
            G,
            Qr,
            5,
            Zr,
            Or,
            V,
            gi,
            J,
            qr,
            V,
            Ar,
            xi,
            Vi,
            Yr,
            oi,
            Mi,
            Nr,
            Ui,
            rt,
            2,
            Ht,
            z,
            Mr,
            $,
            kt,
            Ar,
            Sn,
            rt,
            L,
            fn,
            wi,
            Rn,
            Gi,
            Cr,
            Hr,
            wt,
            Fn,
            W,
            cn,
            Gt,
            Mi,
            On,
            Ar,
            qn,
            It,
            $n,
            at,
            U,
            L,
            ht,
            rt,
            Yr,
            Cr,
            gi,
            yr,
            J,
            xr,
            Vr,
            g,
            ur,
            Sn,
            Bn,
            wr,
            Er,
            br,
            zn,
            Di,
            $n,
            pi,
            Tn,
            Zr,
            Mi,
            rn,
            En,
            fn,
            Xi,
            yn,
            Qi,
            Qi,
            Vi,
            yi,
            gt,
            sr,
            Rn,
            I,
            xt,
            _t,
            Dt,
            bn,
            lr,
            Hn,
            yn,
            Yi,
            Xr,
            I,
            Ft,
            rn,
            C,
            ct,
            hn,
            Ni,
            ht,
            Yr,
            Kn,
            Ci,
            Qi,
            Gr,
            H,
            Oi,
            qt,
            or,
            Z,
            Sn,
            zt,
            Di,
            Hi,
            et,
            mt,
            nt,
            ln,
            Ai,
            Zn,
            ki,
            et,
            Gn,
            C,
            _t,
            T,
            Kn,
            L,
            I,
            St,
            Cr,
            Si,
            Qn,
            nn,
            Qi,
            dn,
            Hi,
            Lr,
            ai,
            ln,
            C,
            L,
            wn,
            lt,
            Nn,
            j,
            S,
            Un,
            nt,
            Ui,
            bn,
            D,
            Wt,
            ei,
            Fi,
            wt,
            Zn,
            $t,
            it,
            $i,
            si,
            tr,
            nt,
            x,
            $i,
            Fi,
            Di,
            Sr,
            g,
            ut,
            ct,
            Gt,
            li,
            zt,
            I,
            Dr,
            Pr,
            Gt,
            At,
            tr,
            ot,
            j,
            rn,
            ut,
            yn,
            Qi,
            ii,
            Hi,
            Cn,
            xn,
            Zt,
            Kt,
            yi,
            Kn,
            Ai,
            Cn,
            $i,
            Vr,
            Yi,
            L,
            nt,
            Sn,
            Xt,
            U,
            et,
            Rr,
            Yn,
            Et,
            9,
            wr,
            ft,
            Qi,
            jn,
            vt,
            fi,
            it,
            wn,
            8,
            vt,
            Qn,
            Di,
            pr,
            Rt,
            Jn,
            br,
            Un,
            g,
            $t,
            ft,
            Hn,
            Vt,
            zt,
            Gn,
            Tr,
            2,
            pt,
            gr,
            On,
            cr,
            _n,
            zn,
            mn,
            It,
            ti,
            X,
            Kn,
            Bt,
            Rt,
            ot,
            Lr,
            I,
            hi,
            Ui,
            fn,
            en,
            Nn,
            B,
            ui,
            Ct,
            yi,
            cr,
            wt,
            Xn,
            Di,
            vi,
            mt,
            nn,
            Pt,
            9,
            bt,
            ft,
            qn,
            kt,
            vt,
            st,
            ui,
            $r,
            Z,
            j,
            It,
            Jr,
            Vr,
            j,
            wn,
            zn,
            D,
            7,
            kr,
            Kn,
            ti,
            it,
            Wr,
            Ln,
            J,
            R,
            gt,
            _,
            Or,
            ni,
            zi,
            ot,
            Mi,
            Sn,
            Cr,
            Qn,
            lt,
            Wn,
            I,
            Ni,
            ht,
            mn,
            At,
            Gi,
            Cr,
            Ui,
            dn,
            bn,
            vn,
            _,
            Qi,
            mt,
            B,
            pi,
            Yi,
            Yn,
            Lt,
            er,
            wr,
            Mt,
            an,
            bn,
            Ur,
            Rr,
            ut,
            Jn,
            Xt,
            on,
            dn,
            mn,
            k,
            Xn,
            pt,
            it,
            Ii,
            j,
            fn,
            ot,
            on,
            cr,
            it,
            lr,
            mr,
            Di,
            Ft,
            Vt,
            zn,
            ut,
            Kn,
            Bi,
            I,
            Ei,
            Wt,
            Sn,
            Pn,
            li,
            dr,
            x,
            en,
            Xi,
            Bn,
            _n,
            St,
            $t,
            G,
            Rt,
            Mt,
            Ri,
            Ci,
            Jr,
            dn,
            Wt,
            Hn,
            Zt,
            cr,
            Qn,
            yi,
            S,
            Yi,
            Pi,
            6,
            wi,
            Ti,
            W,
            Lt,
            fi,
            Or,
            tt,
            Ht,
            on,
            Kn,
            ln,
            zt,
            Di,
            X,
            Ct,
            Tt,
            wi,
            Wt,
            Bi,
            kt,
            Lt,
            Ct,
            J,
            li,
            G,
            Wn,
            Yi,
            B,
            Rr,
            ei,
            ii,
            bn,
            Un,
            Di,
            _,
            Q,
            on,
            g,
            Gr,
            Ai,
            xi,
            Rt,
            jn,
            J,
            $,
            Jr,
            7,
            xi,
            Un,
            En,
            Wt,
            Fi,
            Qi,
            Zn,
            Ar,
            fn,
            mt,
            Nn,
            ct,
            er,
            Oi,
            Xr,
            An,
            lr,
            ei,
            wi,
            Tn,
            vt,
            L,
            ur,
            xi,
            an,
            st,
            Ai,
            xi,
            er,
            ui,
            j,
            Hi,
            jr,
            Gt,
            Tt,
            Nr,
            nn,
            Hn,
            lr,
            tr,
            Jn,
            Qn,
            J,
            Qt,
            ci,
            Wt,
            dr,
            pn,
            Mt,
            dt,
            Gt,
            Q,
            Ii,
            gn,
            g,
            X,
            Kt,
            V,
            3,
            Ii,
            ht,
            Q,
            Yn,
            ui,
            mt,
            Oi,
            ut,
            Tt,
            Zn,
            $t,
            R,
            Yt,
            yi,
            Jn,
            q,
            Q,
            et,
            q,
            it,
            Ai,
            bt,
            Di,
            fn,
            Zt,
            W,
            Zt,
            I,
            Ft,
            Zt,
            ji,
            An,
            _t,
            Ei,
            Ui,
            qt,
            dr,
            mr,
            g,
            Jr,
            U,
            rt,
            zi,
            ur,
            ar,
            q,
            7,
            V,
            or,
            5,
            I,
            0,
            _t,
            Ci,
            cr,
            kr,
            W,
            Sn,
            hi,
            sn,
            0,
            Ti,
            sn,
            H,
            xt,
            sr,
            Or,
            Ar,
            Qn,
            Ar,
            ui,
            Ki,
            W,
            xt,
            Nn,
            mt,
            st,
            en,
            zr,
            Vi,
            Wi,
            Q,
            qn,
            oi,
            kn,
            sn,
            at,
            Qr,
            z,
            xr,
            z,
            fi,
            Ui,
            Qn,
            hi,
            L,
            hn,
            9,
            Zt,
            qt,
            Zt,
            kn,
            bi,
            Rr,
            Ht,
            zt,
            qn,
            cn,
            yi,
            Er,
            $i,
            br,
            ji,
            hr,
            Jt,
            Yn,
            Vn,
            tr,
            sn,
            Qr,
            B,
            B,
            Tn,
            In,
            Ui,
            nn,
            Yr,
            g,
            _t,
            fn,
            Fn,
            or,
            St,
            Lr,
            tt,
            sn,
            zi,
            rr,
            on,
            wn,
            x,
            bn,
            C,
            Er,
            Nt,
            en,
            Zr,
            I,
            k,
            ut,
            X,
            Ut,
            Li,
            hr,
            yi,
            Gr,
            an,
            yr,
            J,
            ji,
            Y,
            V,
            xi,
            Zi,
            Nt,
            vt,
            Ur,
            zi,
            wt,
            no,
            yi,
            ti,
            hr,
            on,
            Qn,
            K,
            L,
            nt,
            Un,
            jr,
            Z,
            zr,
            an,
            Gr,
            tr,
            Lr,
            Jn,
            Qt,
            nt,
            V,
            Kn,
            0,
            Tt,
            Rn,
            Nr,
            0,
            Rn,
            hn,
            Ji,
            Mr,
            Jt,
            Oi,
            zt,
            en,
            zi,
            dn,
            Z,
            ar,
            or,
            I,
            Hr,
            Er,
            ht,
            Nr,
            G,
            qn,
            vi,
            Ei,
            mt,
            Zn,
            zt,
            Sr,
            ct,
            Ei,
            Fi,
            Lr,
            mi,
            I,
            Hr,
            Vn,
            ui,
            kr,
            St,
            jr,
            vi,
            Qn,
            qt,
            Dn,
            Ri,
            Gi,
            Lr,
            1,
            z,
            Sr,
            fr,
            An,
            $n,
            Qr,
            fi,
            T,
            Fi,
            Hn,
            Wt,
            hr,
            Gr,
            P,
            Cn,
            zi,
            it,
            Xi,
            oi,
            rr,
            Ln,
            Qt,
            xt,
            tr,
            At,
            ur,
            ht,
            fn,
            vt,
            In,
            it,
            Hi,
            Er,
            ht,
            ni,
            K,
            mt,
            $,
            In,
            Li,
            W,
            _t,
            ni,
            S,
            fn,
            Ti,
            Pn,
            it,
            K,
            _t,
            Zi,
            Sr,
            W,
            L,
            Br,
            Ki,
            6,
            pi,
            Er,
            L,
            Bt,
            Zt,
            ii,
            Dn,
            Wr,
            Tn,
            wi,
            wr,
            ti,
            br,
            si,
            fn,
            Ht,
            oi,
            tn,
            In,
            xn,
            _t,
            An,
            ci,
            Mr,
            kn,
            Mi,
            $i,
            dt,
            Zn,
            Cr,
            no,
            fi,
            Rr,
            jt,
            B,
            pt,
            jr,
            Tn,
            Qt,
            bt,
            Mt,
            Kn,
            st,
            Kr,
            Cn,
            2,
            Kr,
            Zn,
            Er,
            R,
            U,
            Zr,
            Yr,
            Ai,
            Lt,
            Ei,
            Ar,
            K,
            rt,
            ir,
            Rt,
            Rn,
            Yr,
            _r,
            Ki,
            bt,
            et,
            ni,
            Tn,
            $i,
            Gn,
            nn,
            Ii,
            qn,
            vn,
            Er,
            sr,
            si,
            bt,
            Mt,
            En,
            Rn,
            vi,
            Ln,
            Vn,
            Y,
            k,
            Ti,
            Zt,
            sn,
            Wr,
            In,
            Rt,
            W,
            Mi,
            Mn,
            An,
            xi,
            Bt,
            lt,
            At,
            P,
            8,
            Mt,
            qi,
            T,
            W,
            Fi,
            zn,
            at,
            Ur,
            tt,
            Qr,
            rr,
            On,
            Mi,
            D,
            mi,
            Cn,
            Ur,
            an,
            pt,
            In,
            Rn,
            8,
            En,
            qi,
            hi,
            ro,
            gt,
            oi,
            vr,
            zt,
            U,
            zi,
            Bn,
            Wt,
            rr,
            tt,
            vr,
            T,
            V,
            bn,
            Xn,
            Ui,
            Ft,
            rn,
            cn,
            Hi,
            It,
            Zr,
            no,
            g,
            xr,
            li,
            ei,
            un,
            mt,
            Qn,
            Pi,
            ui,
            vt,
            rr,
            ot,
            Kn,
            Rr,
            it,
            no,
            H,
            Jn,
            Ti,
            $,
            Qn,
            Bn,
            Yi,
            Vi,
            fr,
            cn,
            Sn,
            ji,
            un,
            Fi,
            I,
            Ln,
            B,
            S,
            L,
            Ai,
            Qn,
            Ft,
            Sn,
            gn,
            I,
            dt,
            or,
            Yi,
            an,
            li,
            Ii,
            ei,
            Y,
            it,
            kr,
            Un,
            Ln,
            it,
            $t,
            Ni,
            Xr,
            _t,
            rn,
            it,
            it,
            Ct,
            K,
            wn,
            ji,
            wt,
            ti,
            pt,
            hr,
            $n,
            pt,
            1,
            Bt,
            ii,
            jr,
            Fn,
            Pr,
            Ci,
            qr,
            On,
            Ir,
            4,
            ji,
            0,
            fr,
            Br,
            Ji,
            dn,
            Yr,
            gi,
            vn,
            hi,
            2,
            dn,
            br,
            4,
            yt,
            si,
            jt,
            5,
            qi,
            Lr,
            Hn,
            Yr,
            Qi,
            mr,
            sn,
            g,
            en,
            Pr,
            Xi,
            yi,
            R,
            ni,
            Yn,
            Rn,
            Gt,
            Oi,
            Ai,
            8,
            Gt,
            Fr,
            Ei,
            En,
            tt,
            V,
            Dt,
            En,
            In,
            ki,
            8,
            oi,
            dr,
            et,
            Zn,
            W,
            Zi,
            T,
            Y,
            ri,
            lt,
            Ei,
            I,
            sr,
            bt,
            T,
            Hn,
            rr,
            U,
            dn,
            Br,
            I,
            un,
            Br,
            Ci,
            ct,
            tr,
            hn,
            D,
            An,
            Mn,
            ei,
            ki,
            sr,
            Xt,
            Vr,
            Jr,
            Ki,
            Rt,
            Ri,
            Dt,
            Li,
            I,
            Un,
            X,
            Dt,
            $r,
            Tt,
            St,
            tt,
            qn,
            yi,
            st,
            Bt,
            Pn,
            Or,
            rt,
            qi,
            St,
            Qt,
            gt,
            Cr,
            Yn,
            zi,
            wi,
            9,
            Yi,
            Et,
            wn,
            Kr,
            xi,
            at,
            zi,
            hr,
            Yi,
            Mr,
            St,
            on,
            ai,
            _r,
            bt,
            an,
            ht,
            ki,
            st,
            xr,
            T,
            Gn,
            Qt,
            jt,
            K,
            xr,
            Ot,
            Mn,
            nn,
            Yt,
            qi,
            St,
            Wi,
            Ft,
            wt,
            $n,
            Tr,
            qr,
            ur,
            Pi,
            xr,
            jn,
            Qt,
            vi,
            tn,
            qi,
            I,
            Wr,
            Hn,
            Ar,
            si,
            jt,
            ir,
            ji,
            ii,
            Yr,
            tn,
            Xt,
            nn,
            Yr,
            8,
            P,
            Sr,
            sn,
            Ci,
            Bn,
            W,
            Rr,
            2,
            ct,
            0,
            X,
            Nr,
            Pn,
            $n,
            ni,
            G,
            ji,
            g,
            oi,
            q,
            di,
            ti,
            Mi,
            ti,
            Yn,
            Ai,
            it,
            $i,
            Ir,
            lr,
            Hr,
            Mr,
            Bn,
            zn,
            wt,
            pt,
            et,
            Ft,
            8,
            Jr,
            9,
            en,
            rt,
            P,
            Ar,
            hi,
            St,
            Yi,
            Fr,
            gi,
            mi,
            br,
            Kr,
            Ht,
            jn,
            Qt,
            Ft,
            4,
            Jt,
            8,
            hi,
            qn,
            Jn,
            Ir,
            Rr,
            ai,
            Tn,
            At,
            oi,
            mi,
            Pr,
            Kr,
            sr,
            ot,
            Gn,
            Ft,
            qr,
            tt,
            qi,
            Rr,
            3,
            si,
            fi,
            Tr,
            rt,
            ki,
            tr,
            fr,
            Ci,
            St,
            ir,
            Gt,
            T,
            R,
            K,
            ut,
            Mr,
            pi,
            En,
            J,
            8,
            mr,
            ui,
            Q,
            dr,
            Bt,
            Qt,
            g,
            jr,
            Ki,
            ro,
            ai,
            3,
            Pi,
            Rn,
            gn,
            tn,
            $n,
            P,
            Oi,
            2,
            Mt,
            Nn,
            qr,
            dn,
            Br,
            Qt,
            Lr,
            oi,
            Ci,
            xr,
            Vr,
            kr,
            Mn,
            xr,
            Xr,
            ir,
            Xr,
            lr,
            qn,
            Y,
            ct,
            Gr,
            fn,
            or,
            K,
            Dr,
            Mn,
            ci,
            Sr,
            gr,
            yn,
            hi,
            lt,
            $n,
            Vr,
            0,
            ut,
            $n,
            z,
            ro,
            In,
            Bt,
            wi,
            xt,
            bn,
            9,
            It,
            Tt,
            _n,
            Z,
            Q,
            zr,
            Dn,
            1,
            Ar,
            2,
            ot,
            Fr,
            pn,
            _n,
            Tr,
            En,
            pi,
            et,
            Ur,
            Sr,
            bt,
            Ot,
            0,
            io,
            Ei,
            Xr,
            yr,
            an,
            io,
            Mi,
            jt,
            qi,
            Or,
            Ur,
            Li,
            K,
            bn,
            ki,
            nr,
            Tr,
            Et,
            ji,
            bt,
            Ur,
            Ji,
            xr,
            dn,
            Ci,
            ur,
            jr,
            Jn,
            Vr,
            Vi,
            Ki,
            Zi,
            gr,
            Vi,
            Ri,
            qr,
            io,
            Xr,
            0,
            1,
            Vi,
            nr,
            qi,
            Qi,
            st,
            7,
            tt,
            R,
            Ir,
            In,
            Mn,
            En,
            xi,
            wn,
            Ar,
            xi,
            Di,
            Y,
            Gi,
            Ct,
            bi,
            W,
            D,
            ri,
            ht,
            pi,
            ti,
            Ar,
            gr,
            Sn,
            wi,
            yr,
            Lt,
            qr,
            mr,
            4,
            tn,
            at,
            wt,
            pi,
            T,
            tn,
            ro,
            di,
            P,
            Ct,
            Cr,
            Fr,
            Bn,
            cn,
            In,
            Di,
            wr,
            $i,
            rt,
            Ii,
            B,
            Jn,
            5,
            an,
            rn,
            Gi,
            cr,
            dt,
            wt,
            _i,
            sn,
            dr,
            ro,
            Qn,
            gt,
            yi,
            G,
            Et,
            V,
            W,
            bt,
            ro,
            Bt,
            dr,
            Rn,
            Kr,
            hr,
            1,
            ni,
            at,
            yt,
            nr,
            Ni,
            Wn,
            ft,
            St,
            Vr,
            Yn,
            vi,
            U,
            vi,
            bt,
            Pn,
            Wr,
            ii,
            R,
            Y,
            Ii,
            K,
            C,
            Lr,
            j,
            Ci,
            Ft,
            ut,
            ct,
            xt,
            Bi,
            Zn,
            W,
            Sn,
            Ri,
            Wr,
            Ji,
            it,
            en,
            $n,
            Tr,
            ki,
            zr,
            lt,
            En,
            zt,
            Ai,
            Dt,
            Cn,
            Hr,
            nr,
            Yn,
            pt,
            Vr,
            dt,
            $n,
            Dn,
            Ei,
            $t,
            Ar,
            Ot,
            Ei,
            S,
            qn,
            I,
            wi,
            qt,
            _n,
            Ai,
            Gt,
            ei,
            An,
            nr,
            nr,
            Ki,
            mr,
            nn,
            Bt,
            Ai,
            Zi,
            Er,
            C,
            Zi,
            Ni,
            7,
            io,
            hi,
            Pt,
            0,
            At,
            Br,
            Y,
            fn,
            Xr,
            1,
            Ai,
            0,
            lr,
            io,
            Q,
            ki,
            Bt,
            vn,
            Nr,
            Pr,
            V,
            sn,
            g,
            At,
            D,
            6,
            R,
            ci,
            Li,
            Wr,
            D,
            St,
            cn,
            vi,
            8,
            bi,
            hi,
            Xi,
            bt,
            7,
            Rr,
            tt,
            Xn,
            _i,
            Ot,
            ct,
            Nt,
            Ur,
            qn,
            Oi,
            Vn,
            J,
            qt,
            Wr,
            sr,
            br,
            Qt,
            Mi,
            yr,
            nr,
            vn,
            Li,
            ft,
            Vn,
            xi,
            0,
            Yr,
            kr,
            nr,
            Zt,
            0,
            Mn,
            0,
            St,
            Ni,
            Nt,
            Ui,
            Nr,
            Zt,
            lr,
            rn,
            Hr,
            J,
            2,
            Jr,
            z,
            Sr,
            L,
            yr,
            mn,
            Sn,
            nn,
            Tn,
            ki,
            Xr,
            Zi,
            8,
            Mt,
            Pn,
            Si,
            Kn,
            Gr,
            ro,
            Ci,
            wt,
            3,
            bt,
            P,
            cr,
            Cn,
            Cr,
            pr,
            ar,
            ro,
            Fr,
            Ni,
            Vn,
            6,
            In,
            8,
            ti,
            ni,
            Yt,
            Xi,
            Nr,
            Q,
            oi,
            vr,
            ui,
            2,
            $i,
            gi,
            sr,
            U,
            Ri,
            hi,
            $n,
            cn,
            Ai,
            bt,
            8,
            hr,
            z,
            nr,
            pr,
            4,
            wi,
            Qt,
            En,
            Un,
            K,
            Mn,
            zi,
            ji,
            Zi,
            $n,
            Hi,
            ar,
            Gt,
            ji,
            Jt,
            Gt,
            Dn,
            gi,
            qt,
            ji,
            Lt,
            Ft,
            er,
            oi,
            ni,
            sr,
            ai,
            fn,
            at,
            gi,
            Tr,
            Mt,
            hr,
            Et,
            Pi,
            hi,
            gi,
            qi,
            Yr,
            sn,
            pn,
            Tr,
            An,
            cr,
            it,
            fr,
            Bn,
            rt,
            En,
            gt,
            ei,
            ht,
            ni,
            bn,
            nr,
            5,
            Or,
            Ui,
            ni,
            T,
            tn,
            kn,
            oi,
            yn,
            5,
            P,
            Sr,
            Un,
            xi,
            Lt,
            gt,
            kn,
            U,
            tn,
            ut,
            fn,
            An,
            Yr,
            ei,
            At,
            Zr,
            pr,
            pr,
            Kt,
            Jn,
            Hn,
            Tn,
            on,
            Un,
            Yn,
            0,
            qi,
            Pn,
            dn,
            gn,
            _i,
            di,
            R,
            Vi,
            ro,
            Ni,
            gr,
            qt,
            gt,
            6,
            7,
            bt,
            on,
            Bn,
            Zi,
            ur,
            Fn,
            Vn,
            lt,
            Oi,
            qr,
            5,
            kn,
            sn,
            T,
            Kn,
            vi,
            j,
            oi,
            fr,
            Cr,
            Ki,
            Vi,
            Xn,
            Si,
            ni,
            6,
            Ft,
            zr,
            gt,
            W,
            Qn,
            jn,
            Bt,
            vn,
            J,
            k,
            D,
            fn,
            Pi,
            U,
            Ln,
            hi,
            0,
            Ht,
            _t,
            At,
            tr,
            Pn,
            Cr,
            gn,
            wn,
            hr,
            Wn,
            1,
            Ft,
            0,
            $,
            7,
            Ut,
            $r,
            wn,
            Hn,
            Nr,
            wn,
            U,
            hi,
            gn,
            1,
            kr,
            $n,
            $n,
            Ai,
            Br,
            zr,
            nn,
            Tr,
            sn,
            qr,
            yr,
            Br,
            qt,
            D,
            io,
            Kn,
            yr,
            ar,
            Pn,
            fr,
            $n,
            qt,
            V,
            0,
            Ni,
            Et,
            Wt,
            xt,
            rn,
            pr,
            2,
            rn,
            Hn,
            gi,
            Dt,
            U,
            tn,
            q,
            W,
            Mr,
            Jn,
            er,
            V,
            kt,
            pr,
            Bn,
            An,
            jt,
            Un,
            0,
            bn,
            qr,
            yi,
            Hn,
            br,
            cr,
            1,
            Tr,
            Ir,
            ai,
            W,
            Hn,
            Ir,
            qi,
            W,
            Ci,
            4,
            ut,
            $n,
            hi,
            Q,
            nt,
            Fn,
            yr,
            _t,
            pn,
            Lt,
            Pt,
            Tt,
            it,
            Wt,
            Ft,
            Mr,
            kr,
            Qr,
            zr,
            Ft,
            bn,
            _n,
            dr,
            gn,
            8,
            7,
            4,
            it,
            ct,
            Vi,
            ji,
            ti,
            pr,
            Ci,
            jt,
            yt,
            B,
            Mi,
            en,
            ot,
            Ni,
            Lr,
            Qi,
            Ji,
            Ni,
            ir,
            at,
            jn,
            Qr,
            wt,
            B,
            bt,
            Mn,
            X,
            si,
            qr,
            ai,
            ro,
            Nt,
            Li,
            W,
            xt,
            D,
            dr,
            Vr,
            un,
            Ft,
            rr,
            pi,
            U,
            rr,
            Mn,
            Dt,
            yn,
            sn,
            Un,
            Vr,
            g,
            6,
            nt,
            ki,
            oi,
            ei,
            zr,
            oi,
            z,
            Mr,
            rt,
            hr,
            ro,
            Fr,
            xn,
            Bn,
            Tt,
            z,
            ur,
            Ci,
            un,
            zr,
            Ii,
            Dn,
            Zr,
            vi,
            qr,
            Zi,
            Gt,
            In,
            io,
            qr,
            St,
            dr,
            4,
            $n,
            Jn,
            zr,
            Vr,
            jt,
            Pr,
            Hn,
            Zi,
            2,
            zr,
            Sn,
            U,
            li,
            mt,
            xn,
            G,
            ct,
            sr,
            no,
            wt,
            Ri,
            ui,
            Rr,
            st,
            Qi,
            Tt,
            Cr,
            Hr,
            rn,
            At,
            zr,
            Jr,
            Nr,
            yi,
            Ki,
            Qn,
            $,
            U,
            Nt,
            Li,
            Tt,
            yt,
            gt,
            q,
            Bn,
            Sn,
            en,
            yr,
            On,
            br,
            Xi,
            Wn,
            x,
            Jr,
            jn,
            yt,
            Sn,
            on,
            ut,
            Gi,
            Xn,
            T,
            br,
            U,
            xi,
            Ar,
            Zt,
            Sn,
            pi,
            mr,
            gt,
            g,
            $,
            Ji,
            ur,
            Ar,
            ii,
            Nn,
            _n,
            Dn,
            Ji,
            Sr,
            Nn,
            Z,
            Qr,
            gn,
            tt,
            Rn,
            J,
            X,
            fi,
            P,
            D,
            cr,
            tr,
            Vr,
            ct,
            pi,
            In,
            Rt,
            vt,
            Yn,
            I,
            Wr,
            gt,
            ji,
            Ti,
            Qi,
            Ui,
            ir,
            7,
            pi,
            Xi,
            cn,
            oi,
            nt,
            or,
            dn,
            Z,
            X,
            It,
            Lt,
            Gi,
            Kr,
            Mn,
            oi,
            tr,
            Nt,
            pn,
            rr,
            Cr,
            P,
            _i,
            0,
            vn,
            $n,
            Sn,
            tt,
            Pt,
            wn,
            4,
            Xr,
            mt,
            it,
            Ii,
            wr,
            Qi,
            bi,
            xr,
            Ar,
            Zi,
            L,
            Un,
            wi,
            Ni,
            wn,
            rr,
            Zn,
            en,
            Di,
            $n,
            Ri,
            Yi,
            Gn,
            $n,
            Un,
            Pr,
            Mi,
            ft,
            Bi,
            xi,
            g,
            Mn,
            0,
            Lr,
            Ar,
            pn,
            ar,
            V,
            pt,
            oi,
            mr,
            Xt,
            dt,
            Mr,
            Di,
            Sr,
            Sr,
            at,
            an,
            j,
            Xi,
            Vn,
            2,
            Vi,
            J,
            Zr,
            Tn,
            Hi,
            Jt,
            wr,
            Ft,
            Xt,
            dn,
            Hi,
            Qn,
            Zi,
            Mn,
            It,
            _r,
            dr,
            6,
            An,
            Ai,
            $i,
            ci,
            Zr,
            ur,
            g,
            Vr,
            Rt,
            yi,
            Tt,
            qn,
            Xn,
            Gr,
            ct,
            _,
            zi,
            vr,
            di,
            1,
            Ni,
            Mt,
            Bn,
            ki,
            Ri,
            Z,
            Xn,
            Ii,
            Un,
            bi,
            Cn,
            Gt,
            4,
            Yn,
            Lt,
            J,
            vt,
            ct,
            On,
            wn,
            x,
            yn,
            ot,
            Pt,
            Xr,
            It,
            _t,
            sr,
            Ci,
            qr,
            zn,
            ht,
            lt,
            En,
            Jt,
            g,
            nt,
            Ai,
            Pr,
            hr,
            Ci,
            ro,
            ci,
            Pn,
            9,
            z,
            pi,
            Gi,
            cn,
            jn,
            si,
            6,
            pi,
            St,
            8,
            Ki,
            rr,
            Tr,
            Wt,
            xi,
            z,
            or,
            Qn,
            lt,
            x,
            ei,
            Zn,
            yt,
            Yi,
            kr,
            0,
            ar,
            Rn,
            vt,
            Fr,
            Kr,
            bn,
            yr,
            Ht,
            pr,
            Wi,
            ki,
            An,
            gi,
            xr,
            Ni,
            Gi,
            Vr,
            fn,
            Ui,
            Zi,
            Qi,
            Zi,
            z,
            ii,
            In,
            ht,
            3,
            Gn,
            An,
            L,
            Jn,
            Un,
            Gn,
            at,
            x,
            ro,
            Ut,
            er,
            qi,
            Li,
            oi,
            dr,
            0,
            Z,
            bi,
            Fr,
            3,
            jr,
            Ai,
            bt,
            Wi,
            li,
            6,
            sn,
            en,
            Oi,
            Ar,
            Hr,
            Q,
            Vn,
            Sn,
            X,
            I,
            L,
            1,
            br,
            6,
            vr,
            1,
            Hr,
            gr,
            rn,
            xr,
            dn,
            qr,
            $n,
            0,
            bi,
            6,
            Mn,
            1,
            Yn,
            7,
            2,
            xn,
            ro,
            $n,
            Tr,
            $i,
            k,
            0,
            Gr,
            lr,
            $r,
            Y,
            ut,
            Gi,
            Nr,
            ni,
            qr,
            Fr,
            yi,
            Q,
            Mt,
            Dn,
            Bn,
            xr,
            z,
            Ei,
            tr,
            Qi,
            Dr,
            z,
            8,
            K,
            sr,
            Ki,
            Di,
            Mr,
            st,
            Ur,
            bn,
            vr,
            7,
            G,
            ji,
            g,
            Mi,
            In,
            4,
            Q,
            _n,
            Ir,
            Bi,
            V,
            li,
            Mr,
            zr,
            Mi,
            Ir,
            st,
            ji,
            Rr,
            pr,
            _i,
            On,
            it,
            Cn,
            no,
            Ln,
            Ln,
            di,
            Zi,
            Ur,
            _,
            xi,
            0,
            Pn,
            Sn,
            Or,
            X,
            Gn,
            $n,
            pt,
            Or,
            Bt,
            kr,
            qr,
            yr,
            Fi,
            at,
            br,
            Ir,
            Bt,
            zn,
            3,
            $,
            7,
            Dr,
            pn,
            cn,
            Gt,
            hr,
            dr,
            qi,
            V,
            vt,
            on,
            g,
            $n,
            _t,
            hi,
            Kt,
            zn,
            In,
            Pi,
            Yr,
            Tr,
            K,
            On,
            Mi,
            fn,
            Kr,
            Pn,
            On,
            mn,
            $n,
            ur,
            tt,
            Bi,
            mn,
            zn,
            Fi,
            Pn,
            li,
            z,
            st,
            9,
            pi,
            qn,
            K,
            di,
            2,
            5,
            Vt,
            D,
            Tr,
            Er,
            G,
            Dt,
            1,
            C,
            Rt,
            Et,
            zr,
            tt,
            wt,
            Ar,
            Pn,
            fn,
            Ki,
            Wr,
            cn,
            rn,
            z,
            x,
            ht,
            ui,
            Ur,
            G,
            Ur,
            Jr,
            qn,
            ni,
            Bi,
            Zn,
            Ai,
            Ji,
            Gn,
            wt,
            _n,
            Ir,
            Zi,
            Et,
            Ut,
            fi,
            zr,
            fn,
            Zr,
            Zt,
            2,
            wn,
            ai,
            kn,
            K,
            Yi,
            Zr,
            Rn,
            Yr,
            Mi,
            vr,
            hi,
            Xr,
            8,
            D,
            Br,
            Kr,
            Lr,
            Ri,
            bt,
            Ai,
            Er,
            Sn,
            wr,
            U,
            pi,
            q,
            Ft,
            Yn,
            Wr,
            It,
            pi,
            Ln,
            br,
            1,
            ci,
            ui,
            vn,
            ni,
            Nr,
            5,
            Ur,
            Un,
            Bn,
            Vr,
            q,
            di,
            x,
            St,
            Xi,
            Sr,
            Zr,
            vr,
            an,
            U,
            Vn,
            Fi,
            Gn,
            5,
            Gn,
            Xi,
            fn,
            jn,
            Ir,
            X,
            nn,
            2,
            dt,
            Ut,
            pi,
            V,
            mn,
            Nr,
            z,
            Nt,
            Wr,
            Gi,
            j,
            $n,
            R,
            Gt,
            lr,
            ro,
            qi,
            L,
            Oi,
            Cr,
            P,
            er,
            j,
            Dr,
            zt,
            Zt,
            zi,
            qn,
            pt,
            Sn,
            Yr,
            Dt,
            _n,
            mt,
            zi,
            lr,
            S,
            lr,
            mi,
            z,
            Sr,
            en,
            rr,
            $r,
            mi,
            G,
            P,
            Gt,
            kn,
            Dt,
            di,
            $,
            Zt,
            $t,
            Si,
            lt,
            lr,
            J,
            ui,
            H,
            Li,
            B,
            tn,
            st,
            Gi,
            xi,
            vt,
            _r,
            I,
            gt,
            yn,
            pt,
            no,
            di,
            cn,
            ii,
            Dt,
            ii,
            xi,
            L,
            di,
            pt,
            xt,
            Wr,
            Zt,
            zt,
            Sr,
            ti,
            rr,
            g,
            Yi,
            Hn,
            Bt,
            C,
            sn,
            bi,
            Li,
            Hn,
            Cn,
            Bi,
            Lt,
            wi,
            gn,
            Ai,
            mt,
            sn,
            it,
            x,
            C,
            cr,
            lt,
            lt,
            cr,
            nt,
            wn,
            Wt,
            U,
            Vr,
            Ni,
            Xr,
            Pi,
            Yi,
            q,
            G,
            Mi,
            Bi,
            $t,
            vn,
            Li,
            pt,
            Zr,
            cr,
            Oi,
            Li,
            mt,
            Xn,
            xi,
            W,
            g,
            ot,
            Lt,
            on,
            cr,
            G,
            tt,
            Ci,
            Un,
            on,
            xi,
            _,
            kr,
            Or,
            2,
            Vt,
            Vn,
            gt,
            Xr,
            Wn,
            ln,
            Nn,
            Sr,
            Yi,
            di,
            Wt,
            nn,
            on,
            Yn,
            ht,
            _i,
            Ht,
            C,
            cr,
            Qr,
            j,
            ii,
            Zn,
            ft,
            Di,
            ur,
            Ht,
            On,
            tn,
            at,
            Mi,
            zn,
            tt,
            Mn,
            zr,
            lt,
            Tt,
            kt,
            et,
            cr,
            Ht,
            or,
            Vn,
            Lr,
            Dr,
            Cn,
            un,
            9,
            8,
            Hn,
            zn,
            ur,
            $t,
            zn,
            $i,
            pt,
            gi,
            $,
            x,
            kt,
            Pt,
            Kn,
            Lt,
            $t,
            Lr,
            lr,
            cr,
            no,
            mn,
            St,
            B,
            pn,
            K,
            Mt,
            L,
            Oi,
            Rn,
            Lt,
            sn,
            Oi,
            Pn,
            Bn,
            2,
            Mt,
            Zi,
            Rt,
            Yr,
            Fn,
            Ir,
            zn,
            jt,
            Br,
            Gt,
            Ei,
            Fi,
            rr,
            Rt,
            Ut,
            Q,
            q,
            xr,
            dr,
            st,
            Fi,
            Zi,
            U,
            7,
            0,
            Mr,
            st,
            In,
            Ot,
            xt,
            oi,
            Ji,
            qi,
            pi,
            Ci,
            qi,
            Rr,
            Ai,
            It,
            4,
            Ot,
            ri,
            ai,
            $n,
            lr,
            Hn,
            Zt,
            Y,
            dt,
            un,
            K,
            _,
            Qt,
            Q,
            Li,
            V,
            nt,
            Fr,
            Mn,
            Lr,
            In,
            En,
            mi,
            Ai,
            In,
            ut,
            _i,
            oi,
            ut,
            ht,
            gi,
            lr,
            sn,
            V,
            Hi,
            li,
            L,
            ti,
            yt,
            Xr,
            zi,
            Mn,
            bn,
            Fn,
            xt,
            I,
            ht,
            Mt,
            pt,
            gi,
            Zr,
            Xt,
            Cr,
            Kt,
            0,
            C,
            ni,
            0,
            9,
            3,
            wt,
            Li,
            8,
            En,
            $r,
            Q,
            st,
            1,
            7,
            gn,
            gr,
            g,
            ri,
            Fr,
            Gn,
            Ot,
            Ut,
            Xi,
            ei,
            D,
            4,
            Fr,
            9,
            ci,
            wr,
            Ei,
            Fr,
            or,
            ir,
            vr,
            Gr,
            Ti,
            Hn,
            x,
            zt,
            k,
            7,
            Pi,
            bi,
            Ri,
            xr,
            ri,
            Nt,
            rn,
            qn,
            4,
            mi,
            $n,
            Yt,
            Br,
            oi,
            Yn,
            Vt,
            Zr,
            hi,
            Oi,
            jr,
            Wr,
            un,
            Rt,
            ni,
            Ai,
            tt,
            Mt,
            Q,
            D,
            kt,
            Nr,
            Wn,
            _,
            ft,
            j,
            $n,
            Tn,
            R,
            ti,
            Un,
            Rn,
            fn,
            Pi,
            K,
            hn,
            Hi,
            Ri,
            Nt,
            I,
            X,
            j,
            Fn,
            $n,
            jr,
            Xn,
            Pt,
            g,
            Vn,
            en,
            xt,
            ut,
            T,
            $i,
            jn,
            or,
            gt,
            2,
            Nr,
            Vn,
            It,
            On,
            mt,
            Bt,
            kr,
            xi,
            _,
            Rn,
            5,
            Dr,
            kt,
            Xn,
            U,
            Oi,
            sn,
            nt,
            zr,
            Hn,
            ct,
            L,
            Wn,
            Bt,
            5,
            xr,
            pr,
            yt,
            Jr,
            Or,
            Xn,
            Yr,
            Yt,
            Mr,
            _,
            br,
            cn,
            qr,
            rn,
            On,
            vn,
            Fi,
            ln,
            _,
            nt,
            ln,
            Ii,
            x,
            V,
            Ki,
            R,
            _,
            Ei,
            ii,
            mr,
            lt,
            Wt,
            zt,
            $i,
            Gt,
            Wn,
            qn,
            $t,
            yt,
            _i,
            ii,
            et,
            K,
            Li,
            at,
            Sr,
            Ni,
            Yi,
            Et,
            6,
            er,
            bi,
            ki,
            Wi,
            Dt,
            Yi,
            G,
            H,
            ti,
            Et,
            Qt,
            Pn,
            Lr,
            Hi,
            Zi,
            gt,
            tt,
            Dr,
            In,
            Rt,
            Ln,
            jr,
            bi,
            En,
            G,
            Ti,
            An,
            Vi,
            Dn,
            jn,
            Zn,
            Ot,
            Ot,
            Dr,
            wr,
            pr,
            ur,
            Fi,
            un,
            Jn,
            Tt,
            qt,
            Pr,
            Yt,
            kr,
            pi,
            Wr,
            Q,
            Ai,
            Z,
            Dr,
            Br,
            ii,
            gi,
            Ar,
            Zr,
            Mr,
            Cr,
            Pt,
            Kn,
            Dt,
            Nn,
            z,
            st,
            Gr,
            yt,
            I,
            rr,
            Ni,
            4,
            kr,
            Oi,
            Fi,
            Bn,
            en,
            Ot,
            $t,
            et,
            ct,
            et,
            0,
            Nn,
            ir,
            ki,
            sr,
            Nt,
            it,
            Ct,
            zr,
            Zr,
            S,
            Gr,
            dn,
            Sn,
            Zn,
            Gt,
            on,
            Wt,
            no,
            T,
            Cn,
            Zt,
            ii,
            S,
            cn,
            $,
            Bn,
            Vr,
            Y,
            It,
            Ni,
            Gn,
            ut,
            Er,
            Jt,
            Jt,
            li,
            q,
            Gi,
            Jt,
            Jr,
            Kr,
            _t,
            Ft,
            Pr,
            Zt,
            ii,
            Sr,
            Wt,
            Tn,
            9,
            jr,
            Dt,
            nn,
            tn,
            Di,
            Xr,
            rr,
            yt,
            ft,
            Ai,
            _n,
            br,
            Ln,
            zi,
            di,
            rt,
            Di,
            $n,
            Di,
            br,
            Zr,
            Nn,
            ut,
            Un,
            Jr,
            Wn,
            mt,
            Rt,
            Li,
            or,
            Di,
            mt,
            pi,
            bi,
            Lt,
            Wn,
            Jr,
            zt,
            Ut,
            Pn,
            Jr,
            sr,
            nt,
            rt,
            ci,
            $i,
            9,
            Jr,
            q,
            Rt,
            _i,
            Ji,
            x,
            Zt,
            g,
            li,
            _,
            Tt,
            Zt,
            at,
            Qr,
            q,
            vt,
            en,
            zi,
            $,
            Kn,
            en,
            xi,
            dt,
            yr,
            Q,
            _,
            H,
            Dn,
            g,
            on,
            H,
            B,
            Di,
            br,
            un,
            jt,
            Tr,
            Ot,
            bi,
            Zr,
            mt,
            Pi,
            pt,
            Yi,
            ln,
            Gr,
            Dn,
            Ot,
            wi,
            Yi,
            Vt,
            ft,
            Lt,
            Lr,
            Wn,
            ln,
            At,
            Mi,
            xn,
            er,
            nt,
            Fn,
            tr,
            fr,
            Bi,
            mt,
            Ht,
            Ti,
            X,
            Jt,
            yn,
            Er,
            Un,
            Pt,
            ei,
            q,
            dt,
            Vr,
            Ti,
            ar,
            oi,
            Di,
            gt,
            En,
            di,
            T,
            Rn,
            7,
            S,
            Xt,
            ii,
            Ji,
            Wt,
            rr,
            bt,
            an,
            Jt,
            Lr,
            Yn,
            L,
            _t,
            an,
            3,
            _t,
            _t,
            bi,
            $t,
            ii,
            xi,
            ln,
            Xi,
            tr,
            hn,
            _r,
            On,
            Xt,
            ot,
            ot,
            zr,
            di,
            Oi,
            vr,
            Rt,
            qr,
            st,
            Lt,
            $i,
            vi,
            I,
            qt,
            en,
            rt,
            Pi,
            gt,
            rr,
            sr,
            Sn,
            Fi,
            vt,
            Xr,
            jn,
            yt,
            Wt,
            6,
            tr,
            H,
            cn,
            Hi,
            jr,
            xn,
            pi,
            mt,
            Ti,
            9,
            pi,
            Dn,
            Dt,
            Ai,
            yr,
            Yr,
            Nr,
            _i,
            D,
            C,
            zi,
            no,
            Gt,
            Ci,
            hi,
            ii,
            xi,
            Lr,
            li,
            Jt,
            Xn,
            Zt,
            $,
            ot,
            Kn,
            Rt,
            mr,
            Wt,
            Zi,
            Ni,
            vt,
            zn,
            bt,
            ci,
            xi,
            zt,
            wr,
            Ar,
            yt,
            Vt,
            $i,
            Jr,
            It,
            Hn,
            vr,
            tn,
            g,
            Kt,
            Rr,
            wt,
            Y,
            Hi,
            ti,
            cn,
            et,
            Gn,
            q,
            Lt,
            Jr,
            It,
            Ot,
            Gi,
            ti,
            vt,
            Xi,
            Ot,
            kt,
            Fi,
            Lt,
            tt,
            ar,
            L,
            hi,
            no,
            Z,
            Sn,
            I,
            Gt,
            ii,
            un,
            En,
            Yr,
            rr,
            Mr,
            vi,
            Sn,
            Ui,
            Kt,
            hi,
            ci,
            wr,
            Qn,
            Ct,
            An,
            $,
            Ni,
            Rr,
            $t,
            At,
            Fi,
            Pt,
            Zn,
            Ot,
            zn,
            $i,
            ht,
            or,
            ut,
            Dt,
            Wn,
            nr,
            on,
            Tt,
            $i,
            Di,
            Br,
            br,
            Ht,
            on,
            Fi,
            B,
            Zr,
            en,
            $i,
            kn,
            Zr,
            dn,
            j,
            pr,
            8,
            3,
            sr,
            Qt,
            Pi,
            Sn,
            er,
            ui,
            j,
            Ni,
            j,
            Ji,
            Pi,
            pt,
            zn,
            yt,
            ct,
            Wt,
            ri,
            ir,
            Zr,
            wt,
            L,
            Ii,
            rr,
            Dn,
            Li,
            si,
            Ct,
            $,
            Gt,
            Xn,
            Un,
            Z,
            at,
            ct,
            Bi,
            Ht,
            Nn,
            Wn,
            Yn,
            Si,
            Rn,
            Jn,
            xn,
            rr,
            Wr,
            gt,
            wr,
            kr,
            Xt,
            G,
            st,
            1,
            Vt,
            wi,
            ni,
            mi,
            tt,
            Sn,
            z,
            Zr,
            Ln,
            Zi,
            Qt,
            tt,
            ai,
            H,
            Dr,
            _r,
            Qn,
            _i,
            Ii,
            wr,
            Yi,
            Ti,
            U,
            G,
            wt,
            kn,
            yt,
            Mr,
            $i,
            Qn,
            yi,
            Hn,
            Ot,
            zi,
            on,
            Sr,
            ri,
            Wr,
            tn,
            fi,
            Hn,
            qt,
            Z,
            Un,
            di,
            un,
            en,
            Yt,
            cn,
            Mt,
            kt,
            Zn,
            Lt,
            q,
            Vn,
            Zt,
            Ei,
            Lr,
            Dr,
            fi,
            Et,
            Y,
            ot,
            ft,
            Bn,
            Gn,
            U,
            At,
            pr,
            Et,
            Zr,
            Qr,
            vt,
            xr,
            Gt,
            qi,
            mr,
            kr,
            Yn,
            or,
            Xn,
            Jt,
            en,
            Qn,
            ut,
            wi,
            Di,
            Dr,
            z,
            ji,
            vn,
            Vn,
            Zr,
            ei,
            Vi,
            S,
            it,
            Sr,
            Gi,
            cn,
            Bt,
            lt,
            yt,
            Cn,
            bi,
            On,
            st,
            Sn,
            0,
            zt,
            Ni,
            mt,
            zi,
            it,
            wr,
            J,
            4,
            ui,
            _t,
            ei,
            Qr,
            di,
            lr,
            Di,
            ui,
            ot,
            $,
            xi,
            It,
            xr,
            Si,
            mr,
            ki,
            Pr,
            Yn,
            0,
            ht,
            Vr,
            j,
            ui,
            gt,
            Wt,
            zn,
            Fi,
            Qn,
            Nr,
            Bn,
            Un,
            g,
            Vr,
            ln,
            ji,
            ur,
            _,
            Ct,
            $i,
            Cn,
            Si,
            At,
            un,
            Ht,
            fn,
            Tt,
            Kt,
            Bi,
            Ot,
            at,
            Oi,
            Mi,
            ot,
            Sr,
            Sr,
            Ln,
            zt,
            It,
            Dt,
            at,
            Ir,
            Er,
            zn,
            Pi,
            Lt,
            Mi,
            li,
            zt,
            rt,
            1,
            io,
            Yt,
            Yr,
            sr,
            _t,
            hi,
            In,
            ur,
            qt,
            rt,
            k,
            tt,
            gr,
            kr,
            Gn,
            _,
            G,
            $,
            Bn,
            7,
            ft,
            _t,
            Kr,
            pr,
            Ht,
            Bt,
            Bi,
            lt,
            rn,
            Nn,
            jr,
            V,
            H,
            vt,
            gi,
            Yr,
            Nt,
            Un,
            er,
            Un,
            Gn,
            At,
            Cn,
            Di,
            or,
            Dn,
            et,
            cr,
            Kn,
            oi,
            T,
            ki,
            cr,
            dn,
            Qn,
            Et,
            Yn,
            an,
            vt,
            U,
            Zn,
            ot,
            on,
            Ti,
            Dr,
            fn,
            Gt,
            nt,
            Rr,
            Jr,
            qn,
            Dn,
            In,
            Kt,
            ft,
            I,
            kt,
            Fr,
            en,
            kr,
            On,
            tr,
            D,
            H,
            Cr,
            ii,
            yt,
            ur,
            bi,
            Zn,
            Ei,
            kn,
            Wi,
            vr,
            g,
            jr,
            Si,
            Z,
            C,
            Vn,
            _i,
            En,
            Z,
            it,
            hi,
            Yr,
            Nr,
            Gt,
            Dn,
            ln,
            Tt,
            mn,
            br,
            jr,
            Mr,
            vr,
            Ln,
            sn,
            Wi,
            Bt,
            rt,
            Yn,
            Di,
            Y,
            Wi,
            ht,
            In,
            Br,
            on,
            mr,
            gt,
            $r,
            Sr,
            Wt,
            g,
            lt,
            Vn,
            cr,
            si,
            Ct,
            ln,
            nr,
            Lr,
            fi,
            $i,
            Yr,
            sr,
            Ct,
            Fn,
            Et,
            qr,
            wi,
            ui,
            Yr,
            ln,
            ut,
            ei,
            Zn,
            Ci,
            xi,
            gr,
            Dn,
            Tt,
            $t,
            Ot,
            wr,
            On,
            on,
            Zt,
            rr,
            Ni,
            Qn,
            Xi,
            ci,
            tr,
            un,
            Tr,
            Yi,
            _i,
            Ti,
            U,
            Tn,
            ur,
            bn,
            $i,
            Si,
            Zt,
            Zt,
            Gi,
            ti,
            Si,
            Zt,
            rr,
            $,
            tr,
            wi,
            wi,
            Ot,
            rn,
            _n,
            Ut,
            Gi,
            Kt,
            0,
            zt,
            Fi,
            _,
            T,
            xt,
            9,
            Kr,
            zn,
            oi,
            gr,
            P,
            D,
            Zi,
            z,
            bt,
            At,
            Yr,
            Gn,
            ci,
            ft,
            vi,
            Zn,
            at,
            mr,
            qr,
            tn,
            Qn,
            oi,
            Tr,
            no,
            $n,
            Yr,
            P,
            rn,
            Cr,
            qr,
            qr,
            9,
            Gt,
            0,
            Ei,
            4,
            Bt,
            Pn,
            ai,
            ar,
            3,
            et,
            er,
            2,
            dt,
            pi,
            Fr,
            Yn,
            W,
            yi,
            gi,
            kn,
            io,
            ni,
            Yn,
            2,
            Rn,
            9,
            Ht,
            Mt,
            x,
            7,
            nr,
            Ft,
            Bt,
            si,
            sr,
            pr,
            Fr,
            Zn,
            en,
            R,
            ur,
            oi,
            pt,
            g,
            vt,
            6,
            wr,
            ei,
            0,
            Qi,
            Pn,
            Tt,
            Fr,
            yr,
            vn,
            V,
            R,
            Gr,
            tn,
            Sn,
            rr,
            bi,
            Fr,
            yr,
            zi,
            Zn,
            K,
            ir,
            pt,
            ut,
            ai,
            2,
            ni,
            Kn,
            Ot,
            no,
            ar,
            Jt,
            mn,
            li,
            st,
            qi,
            Mn,
            At,
            Ci,
            Ar,
            Cn,
            tn,
            1,
            R,
            k,
            Si,
            ht,
            Vr,
            2,
            hn,
            k,
            hn,
            Ni,
            P,
            _n,
            Or,
            Ai,
            7,
            qr,
            Ti,
            zr,
            cr,
            Hi,
            no,
            ro,
            3,
            Bt,
            Vi,
            lr,
            Or,
            br,
            7,
            Yn,
            6,
            tt,
            8,
            Lt,
            Ft,
            pr,
            ci,
            _t,
            Kr,
            ro,
            yi,
            5,
            pr,
            pt,
            wi,
            R,
            pr,
            qn,
            ro,
            Bi,
            X,
            Yr,
            cr,
            oi,
            Yt,
            Yr,
            K,
            Wt,
            hn,
            tn,
            xr,
            ft,
            ro,
            ut,
            Hr,
            Un,
            gr,
            Jt,
            Hi,
            on,
            ft,
            tr,
            ut,
            yr,
            Ci,
            Yr,
            T,
            fi,
            tt,
            ii,
            St,
            Et,
            ti,
            q,
            Bn,
            Nn,
            Ct,
            Xn,
            Bn,
            or,
            lt,
            Zr,
            ot,
            Ui,
            ur,
            jn,
            Ot,
            wi,
            Un,
            Mn,
            Tn,
            Sn,
            kr,
            at,
            qi,
            Er,
            Xi,
            Gr,
            Kn,
            ai,
            7,
            X,
            Gr,
            Yn,
            Sr,
            _r,
            oi,
            ro,
            kt,
            vr,
            Ji,
            oi,
            vt,
            zr,
            wn,
            z,
            qr,
            qn,
            si,
            hr,
            V,
            In,
            B,
            lt,
            R,
            hr,
            Qn,
            6,
            cn,
            kt,
            pi,
            Hr,
            gn,
            9,
            6,
            Yi,
            Zn,
            g,
            Nr,
            0,
            rt,
            g,
            6,
            Ii,
            at,
            6,
            Yt,
            Gt,
            9,
            Kn,
            Yi,
            Tt,
            z,
            at,
            5,
            pn,
            Kn,
            1,
            Fn,
            sr,
            Qt,
            tn,
            Tn,
            jt,
            Rr,
            V,
            $n,
            Zr,
            Jt,
            mi,
            lr,
            Ur,
            Br,
            jn,
            hi,
            Rn,
            Wn,
            Yn,
            In,
            Ut,
            $n,
            V,
            Zt,
            xt,
            z,
            V,
            Kn,
            W,
            Sn,
            6,
            Tn,
            it,
            vr,
            X,
            ct,
            Ai,
            tt,
            Zt,
            st,
            Z,
            Lr,
            Bn,
            Yn,
            vr,
            Ar,
            C,
            er,
            Kn,
            Dn,
            Sn,
            Xi,
            Kr,
            J,
            g,
            br,
            U,
            lt,
            Ai,
            Lr,
            H,
            li,
            ft,
            wr,
            $n,
            9,
            Si,
            Wi,
            sn,
            0,
            _,
            Et,
            R,
            Oi,
            Nr,
            oi,
            Tt,
            Hn,
            lr,
            Gr,
            K,
            tn,
            7,
            wt,
            vi,
            P,
            tr,
            wt,
            ht,
            Gr,
            pi,
            H,
            4,
            7,
            Hn,
            5,
            Rn,
            5,
            qi,
            Yi,
            Or,
            D,
            Gi,
            Er,
            Vi,
            gi,
            Dt,
            dr,
            Vi,
            Tr,
            wi,
            Rt,
            X,
            Yt,
            Wr,
            Fr,
            2,
            Fn,
            X,
            Kn,
            0,
            lr,
            ai,
            Kt,
            1,
            Dn,
            Or,
            Jn,
            ro,
            dt,
            Vn,
            Bn,
            Zi,
            Y,
            Ar,
            Tn,
            Hn,
            D,
            D,
            Qt,
            Et,
            hi,
            0,
            _,
            k,
            tn,
            Yi,
            On,
            yr,
            ot,
            qn,
            tt,
            xn,
            Pn,
            vn,
            ei,
            ai,
            jt,
            Mn,
            lr,
            qi,
            Xi,
            g,
            7,
            an,
            Xt,
            pt,
            V,
            vi,
            Fr,
            Ei,
            br,
            R,
            z,
            Ai,
            4,
            Cr,
            qi,
            Ur,
            Ri,
            Ri,
            zr,
            jt,
            3,
            7,
            Dn,
            Nt,
            8,
            Ii,
            oi,
            Qi,
            ei,
            Jt,
            Nn,
            io,
            $i,
            Vr,
            Ni,
            7,
            ot,
            Ct,
            er,
            lr,
            pi,
            wt,
            kn,
            xt,
            oi,
            Rt,
            Zr,
            2,
            vt,
            Cr,
            q,
            Ri,
            Ct,
            ri,
            Kn,
            9,
            K,
            Bn,
            yn,
            _r,
            rt,
            ht,
            at,
            mt,
            4,
            fr,
            cr,
            Ir,
            Cr,
            ci,
            Ri,
            Si,
            V,
            Ut,
            Et,
            Mi,
            Jn,
            Dn,
            Wr,
            Ui,
            yr,
            g,
            Rn,
            x,
            Ln,
            jt,
            di,
            Fr,
            yt,
            j,
            k,
            Kr,
            Zr,
            Rr,
            Ft,
            Qn,
            qi,
            ri,
            Fn,
            Ii,
            D,
            wt,
            Y,
            V,
            5,
            _,
            xn,
            jt,
            Nr,
            Dr,
            yr,
            tr,
            Or,
            z,
            mi,
            oi,
            Qi,
            qi,
            li,
            Kt,
            Xi,
            ii,
            st,
            Wi,
            kr,
            Tn,
            zi,
            2,
            In,
            2,
            Wi,
            qn,
            ir,
            wi,
            Z,
            zn,
            0,
            br,
            ht,
            Ri,
            Zn,
            Zi,
            bt,
            9,
            Zn,
            hr,
            Kt,
            cr,
            Gt,
            Mi,
            L,
            _r,
            K,
            ir,
            xt,
            pi,
            Qi,
            V,
            Y,
            Xn,
            Oi,
            Ui,
            Ni,
            _r,
            rr,
            9,
            ai,
            Rr,
            Ji,
            gn,
            ji,
            Hn,
            Sn,
            g,
            ni,
            I,
            en,
            Gr,
            G,
            Vt,
            xr,
            Jn,
            Bn,
            Bt,
            cr,
            wn,
            tt,
            ri,
            Bt,
            oi,
            5,
            2,
            On,
            Mr,
            vt,
            ct,
            Zn,
            Qr,
            xi,
            Li,
            Fi,
            0,
            Q,
            wn,
            io,
            ei,
            Nt,
            z,
            qn,
            Fn,
            Fr,
            g,
            Qt,
            lr,
            H,
            Y,
            Ii,
            Gn,
            Z,
            Fr,
            ai,
            4,
            ot,
            vr,
            Vn,
            Wt,
            sn,
            G,
            Hi,
            ln,
            no,
            Bi,
            gn,
            zn,
            qt,
            jn,
            I,
            it,
            Di,
            Dr,
            J,
            H,
            Yi,
            Vi,
            Kr,
            _,
            it,
            Ot,
            8,
            Ht,
            _,
            it,
            Ot,
            wt,
            Ot,
            Di,
            It,
            Kt,
            Ot,
            io,
            Zn,
            ri,
            Hn,
            Ar,
            cr,
            Ot,
            Wn,
            It,
            sr,
            Ai,
            di,
            Qr,
            Gt,
            Tn,
            Ai,
            nt,
            Di,
            br,
            st,
            $t,
            Dn,
            yi,
            Ai,
            G,
            Fn,
            J,
            mn,
            er,
            St,
            tt,
            ei,
            br,
            Qt,
            Si,
            Jr,
            P,
            Wt,
            ti,
            ri,
            Yn,
            Bi,
            Br,
            ut,
            Ei,
            Rt,
            ct,
            cr,
            $n,
            Dt,
            Er,
            D,
            nt,
            Gt,
            $n,
            yr,
            yi,
            ci,
            Mr,
            dr,
            io,
            tt,
            Dr,
            z,
            _,
            z,
            Wi,
            2,
            yn,
            5,
            Mr,
            un,
            Vr,
            Ci,
            Ri,
            Pr,
            Ii,
            V,
            J,
            xn,
            Mn,
            I,
            io,
            Xr,
            Tr,
            Vi,
            g,
            8,
            zn,
            K,
            dr,
            vr,
            6,
            er,
            tt,
            Ot,
            K,
            Si,
            G,
            Lt,
            tt,
            Qi,
            qn,
            vt,
            un,
            tn,
            Cr,
            zn,
            xt,
            Rn,
            Tr,
            Zi,
            tn,
            Yn,
            Gt,
            ui,
            B,
            Hr,
            Tr,
            zn,
            _n,
            nn,
            hi,
            At,
            _,
            Fn,
            Bi,
            R,
            un,
            Ar,
            Ri,
            Ar,
            _t,
            ln,
            Pt,
            Nr,
            vt,
            ni,
            Li,
            ki,
            Gn,
            C,
            nt,
            Ni,
            Kr,
            dn,
            xr,
            On,
            En,
            yr,
            Oi,
            On,
            Si,
            Nr,
            kr,
            kr,
            pi,
            or,
            ti,
            Li,
            Ai,
            ci,
            mt,
            Yt,
            vn,
            q,
            Dn,
            St,
            Ni,
            Er,
            Gr,
            yi,
            xn,
            Sn,
            Pr,
            0,
            Zr,
            g,
            tn,
            Di,
            ti,
            Lt,
            on,
            ar,
            ct,
            1,
            nr,
            zr,
            Yi,
            Pn,
            Qt,
            Qr,
            8,
            Xi,
            at,
            Dr,
            Dt,
            Yr,
            un,
            ur,
            ti,
            Dn,
            vn,
            $,
            _t,
            yt,
            ln,
            In,
            R,
            Tr,
            dr,
            Cr,
            5,
            si,
            Y,
            yi,
            bt,
            ni,
            on,
            pi,
            cr,
            gr,
            fn,
            Ai,
            Ft,
            2,
            Y,
            ln,
            Ur,
            z,
            3,
            Ci,
            Et,
            Ft,
            K,
            qt,
            8,
            $n,
            Lr,
            Ii,
            _n,
            Zi,
            dt,
            bn,
            br,
            Tr,
            oi,
            mt,
            Gn,
            Wn,
            4,
            ft,
            z,
            Kt,
            Pt,
            Bn,
            Yn,
            di,
            ni,
            7,
            Br,
            Kr,
            bn,
            Sr,
            qr,
            Si,
            vn,
            vr,
            Ki,
            sr,
            Xt,
            li,
            D,
            _,
            kt,
            Yr,
            Hi,
            Vr,
            ro,
            4,
            P,
            Y,
            Tn,
            Pr,
            Gt,
            j,
            _,
            Nt,
            yr,
            Cn,
            dr,
            C,
            Rr,
            Wn,
            Vt,
            ui,
            ot,
            mn,
            Yi,
            I,
            ln,
            Rn,
            _r,
            _t,
            Lr,
            jn,
            _i,
            En,
            io,
            zt,
            ht,
            Vt,
            br,
            _t,
            ei,
            jn,
            wi,
            x,
            En,
            Lr,
            U,
            g,
            cr,
            ur,
            G,
            Hn,
            Dt,
            _n,
            C,
            zi,
            $,
            Zn,
            Xn,
            Jt,
            3,
            z,
            Ri,
            rr,
            on,
            wn,
            Si,
            qr,
            jn,
            Pn,
            Zr,
            Ci,
            Rn,
            mt,
            hi,
            Kn,
            Hr,
            4,
            K,
            cr,
            _t,
            zr,
            $t,
            Ht,
            Ur,
            wt,
            Ui,
            ai,
            pt,
            ut,
            qr,
            Tt,
            gn,
            Gr,
            Q,
            G,
            bt,
            Ni,
            Yn,
            sn,
            on,
            Pn,
            wi,
            nt,
            4,
            zn,
            bt,
            Yn,
            lr,
            Rt,
            X,
            pt,
            or,
            Li,
            Gt,
            Pn,
            Fr,
            ft,
            On,
            Nt,
            Ci,
            xt,
            6,
            Cr,
            jr,
            dr,
            Vt,
            st,
            Pn,
            xr,
            ei,
            $i,
            Mi,
            cr,
            C,
            hi,
            vt,
            Fi,
            Gi,
            Vn,
            ci,
            Gr,
            Sn,
            gt,
            ui,
            0,
            Ln,
            jt,
            Nr,
            _r,
            lr,
            it,
            T,
            zn,
            ai,
            hn,
            Pr,
            x,
            oi,
            $,
            it,
            st,
            5,
            zr,
            Hr,
            q,
            Lt,
            tn,
            k,
            Ui,
            gr,
            J,
            Dr,
            Sn,
            Ln,
            Ft,
            Qn,
            Ln,
            hi,
            yn,
            Vi,
            Cr,
            0,
            kt,
            G,
            ar,
            Qi,
            jn,
            jt,
            ti,
            Bi,
            Ei,
            nn,
            xt,
            $i,
            ln,
            Oi,
            Yi,
            on,
            pr,
            di,
            wn,
            xi,
            I,
            4,
            Et,
            kn,
            xn,
            U,
            Hi,
            wr,
            pt,
            Pi,
            Bi,
            Z,
            Ii,
            ai,
            z,
            br,
            Ui,
            di,
            k,
            0,
            H,
            Cn,
            Qt,
            oi,
            $n,
            I,
            gt,
            j,
            2,
            Ot,
            yi,
            At,
            lr,
            Bt,
            Si,
            Tn,
            oi,
            W,
            Tn,
            4,
            ro,
            vn,
            si,
            kr,
            Q,
            Mr,
            qn,
            io,
            Jr,
            $t,
            mt,
            Sn,
            Cr,
            _r,
            tn,
            Jt,
            sn,
            Di,
            Tt,
            Kr,
            ut,
            Tt,
            xt,
            Wi,
            Fi,
            Fr,
            ut,
            nt,
            xt,
            Bn,
            nr,
            H,
            an,
            ii,
            Z,
            ot,
            Xt,
            Gt,
            V,
            Xt,
            en,
            br,
            yt,
            Nt,
            qr,
            $i,
            gi,
            _n,
            sr,
            kn,
            Pn,
            jr,
            Nn,
            J,
            vr,
            Zn,
            ft,
            X,
            It,
            Jt,
            Ci,
            cr,
            zt,
            br,
            Di,
            Un,
            Rr,
            X,
            ct,
            T,
            Pn,
            st,
            Nr,
            ei,
            Ot,
            Wr,
            Yn,
            mn,
            Nt,
            ct,
            gi,
            G,
            ei,
            ft,
            Xt,
            bn,
            Yt,
            Fn,
            4,
            Ar,
            nt,
            fr,
            $t,
            jt,
            lt,
            ti,
            Sn,
            ii,
            Bn,
            fi,
            tt,
            Fr,
            er,
            wr,
            ui,
            Ft,
            et,
            dr,
            C,
            yr,
            Mr,
            _t,
            dr,
            C,
            Ci,
            hn,
            Tr,
            _,
            At,
            Q,
            Rt,
            Ir,
            tt,
            ir,
            Sn,
            hi,
            Hi,
            ar,
            Yr,
            si,
            Yn,
            Gt,
            Zn,
            L,
            qi,
            qt,
            Ct,
            9,
            Ui,
            V,
            no,
            er,
            mi,
            or,
            At,
            Hr,
            Ur,
            4,
            Ki,
            Vi,
            nt,
            _i,
            no,
            Nr,
            Yi,
            Hn,
            an,
            G,
            ci,
            Q,
            Fn,
            gi,
            Ct,
            q,
            z,
            xn,
            yt,
            at,
            kn,
            vr,
            ki,
            Hn,
            st,
            Wr,
            un,
            _,
            br,
            un,
            Gi,
            Wr,
            Br,
            fn,
            br,
            Cr,
            4,
            P,
            Pn,
            8,
            mi,
            Nr,
            kt,
            hr,
            Li,
            Er,
            Ln,
            Bt,
            ki,
            Lr,
            At,
            At,
            xi,
            _i,
            sn,
            er,
            Ei,
            no,
            un,
            Jn,
            Z,
            Lr,
            ni,
            Cr,
            Hr,
            xn,
            oi,
            xn,
            Gi,
            Nr,
            sn,
            J,
            J,
            vr,
            ui,
            Ft,
            gi,
            dr,
            wr,
            ui,
            wr,
            Xi,
            Lt,
            $t,
            Z,
            pt,
            jt,
            wn,
            Kr,
            di,
            tt,
            Xt,
            zi,
            R,
            gn,
            Qr,
            rn,
            ar,
            gr,
            6,
            mr,
            zr,
            an,
            k,
            Ct,
            P,
            io,
            ar,
            ht,
            kt,
            $t,
            Tr,
            6,
            et,
            mi,
            Oi,
            ct,
            Nt,
            bn,
            on,
            ct,
            _r,
            Hr,
            q,
            Ni,
            Ci,
            j,
            fn,
            wr,
            qn,
            Jn,
            Bi,
            Sr,
            Cn,
            vn,
            Mi,
            zi,
            Ti,
            H,
            Qi,
            Kr,
            ft,
            Pi,
            ai,
            It,
            Jr,
            2,
            Vt,
            wi,
            mr,
            $i,
            cr,
            vi,
            L,
            Vt,
            Rr,
            or,
            j,
            vr,
            Gn,
            Ei,
            Zn,
            Or,
            ct,
            Yr,
            T,
            Bt,
            pi,
            Sr,
            Ai,
            Yt,
            R,
            B,
            oi,
            rt,
            ft,
            Cn,
            K,
            Rt,
            jr,
            On,
            Yi,
            Zn,
            en,
            Qt,
            Ri,
            j,
            ai,
            sn,
            ni,
            tr,
            q,
            Ri,
            zr,
            gi,
            fr,
            tn,
            V,
            bt,
            dr,
            nr,
            lt,
            yr,
            ct,
            Hn,
            3,
            It,
            H,
            on,
            at,
            tr,
            Zt,
            ct,
            Ki,
            st,
            yr,
            ci,
            Yi,
            Bi,
            kr,
            G,
            Dr,
            no,
            Mt,
            xn,
            Zi,
            Xn,
            Pt,
            yr,
            6,
            pr,
            Dn,
            zt,
            gi,
            At,
            yt,
            bi,
            jt,
            ur,
            vn,
            Ir,
            yr,
            7,
            wi,
            br,
            Z,
            wn,
            ar,
            Oi,
            Kr,
            Zt,
            dn,
            B,
            _n,
            Cn,
            et,
            Fr,
            yr,
            Di,
            Q,
            fn,
            gi,
            Kn,
            xt,
            xr,
            fi,
            vi,
            g,
            9,
            Yr,
            rt,
            hi,
            Hr,
            lt,
            Pn,
            ri,
            qi,
            At,
            Ur,
            tn,
            ot,
            Br,
            ut,
            Kn,
            9,
            Xn,
            Lt,
            jt,
            0,
            Sr,
            yi,
            tt,
            Mt,
            Br,
            q,
            jt,
            $n,
            _r,
            mt,
            1,
            yr,
            Xi,
            B,
            Wr,
            V,
            sr,
            zn,
            ht,
            Ei,
            vr,
            Gi,
            Pr,
            Ui,
            qn,
            q,
            Mi,
            Yi,
            Yi,
            ki,
            Yi,
            Nn,
            Yr,
            en,
            Ji,
            vt,
            qt,
            G,
            Ln,
            an,
            q,
            Yr,
            Hn,
            hi,
            ki,
            zt,
            wn,
            j,
            Nn,
            Vr,
            gn,
            Ai,
            qn,
            yr,
            ci,
            qt,
            tr,
            un,
            g,
            ui,
            ot,
            dr,
            _r,
            St,
            tt,
            nr,
            jr,
            V,
            gt,
            $i,
            Et,
            Wn,
            qt,
            Ui,
            tr,
            gi,
            Dn,
            nt,
            qt,
            $i,
            qt,
            pi,
            On,
            Jt,
            An,
            X,
            xr,
            Mi,
            fi,
            ln,
            br,
            J,
            Jt,
            Jn,
            Dn,
            Ot,
            q,
            vt,
            Dn,
            Et,
            tr,
            Ji,
            Dn,
            nt,
            ft,
            X,
            qr,
            I,
            sn,
            Sn,
            ft,
            Vn,
            _t,
            Un,
            nt,
            Fi,
            ai,
            Pn,
            Zn,
            q,
            Wn,
            pt,
            Li,
            jr,
            _t,
            Pn,
            vi,
            Jr,
            Gn,
            Jt,
            Hi,
            Dt,
            B,
            jr,
            on,
            rn,
            Wr,
            zt,
            Et,
            I,
            qt,
            tr,
            rt,
            nt,
            _t,
            Dn,
            Gi,
            $r,
            ht,
            Fr,
            ui,
            lt,
            yr,
            Gt,
            On,
            Yn,
            St,
            Qt,
            kt,
            Xr,
            ct,
            Bt,
            Tt,
            Vi,
            Mt,
            hr,
            en,
            q,
            $i,
            Zr,
            gr,
            Yi,
            Rt,
            ir,
            g,
            k,
            ei,
            vt,
            dr,
            Gi,
            yt,
            Zt,
            lr,
            bt,
            Sr,
            Nr,
            pr,
            W,
            bt,
            Rn,
            xr,
            Wr,
            ar,
            Wr,
            ui,
            ri,
            qi,
            ui,
            xt,
            an,
            Xn,
            ct,
            cr,
            lt,
            In,
            1,
            W,
            Lr,
            ct,
            et,
            di,
            Ki,
            Y,
            li,
            Yr,
            gi,
            Lt,
            R,
            Zn,
            Pi,
            Hn,
            or,
            cr,
            Gn,
            mn,
            Et,
            jr,
            Q,
            C,
            qn,
            wn,
            li,
            4,
            Sn,
            Xt,
            Cn,
            En,
            qi,
            Cr,
            Vt,
            Hn,
            Wt,
            Xi,
            tt,
            kr,
            ri,
            4,
            en,
            In,
            Xi,
            Fi,
            gt,
            Ki,
            fr,
            It,
            pi,
            gi,
            Vn,
            Hn,
            Pi,
            Ir,
            _i,
            Bn,
            qr,
            kr,
            B,
            S,
            jt,
            Hi,
            ti,
            9,
            pn,
            Vi,
            mn,
            br,
            vr,
            Pi,
            Nr,
            Nt,
            gr,
            cr,
            9,
            I,
            2,
            Wn,
            yn,
            Jt,
            ei,
            Kr,
            G,
            pn,
            zt,
            bi,
            Ri,
            J,
            g,
            dt,
            V,
            zr,
            7,
            Vr,
            Tt,
            Qt,
            Et,
            6,
            Jn,
            9,
            Ot,
            z,
            Yi,
            sr,
            Hr,
            dn,
            kt,
            cr,
            Un,
            zn,
            ht,
            fn,
            Vt,
            dt,
            Pt,
            Si,
            vr,
            _t,
            oi,
            x,
            Fr,
            Nt,
            wt,
            sn,
            gt,
            An,
            vi,
            cn,
            ri,
            at,
            wi,
            St,
            Di,
            Qr,
            gr,
            it,
            wi,
            Tr,
            Lr,
            Ci,
            Rr,
            At,
            Qn,
            cn,
            Qn,
            mi,
            xi,
            W,
            8,
            mt,
            zn,
            Wn,
            ar,
            Sr,
            ut,
            Hi,
            Bt,
            Et,
            _t,
            ii,
            Or,
            ti,
            3,
            bi,
            Nt,
            rn,
            Lr,
            ln,
            $,
            Zn,
            Hn,
            5,
            Q,
            Hn,
            st,
            mn,
            $r,
            Mt,
            at,
            q,
            _t,
            xt,
            Ir,
            Ei,
            bt,
            ft,
            Wt,
            br,
            pi,
            ut,
            ln,
            Gn,
            it,
            Fr,
            Zn,
            Et,
            br,
            Sr,
            it,
            Di,
            ft,
            P,
            vt,
            vn,
            Hn,
            tr,
            jn,
            Ni,
            Tt,
            jr,
            Zr,
            no,
            wn,
            Jt,
            _,
            jt,
            Ir,
            I,
            tt,
            _,
            Wt,
            Ji,
            bt,
            st,
            xi,
            B,
            Wt,
            Ji,
            vt,
            Dn,
            Et,
            Ar,
            Jn,
            $i,
            qt,
            cn,
            kt,
            D,
            un,
            _t,
            Kn,
            Pn,
            et,
            Vi,
            Ht,
            ft,
            fn,
            G,
            en,
            mn,
            dt,
            Xt,
            pt,
            Wt,
            B,
            Dt,
            br,
            J,
            Zr,
            Hi,
            1,
            Ji,
            cr,
            Vr,
            Dr,
            gi,
            mr,
            qr,
            dt,
            cr,
            zi,
            Ir,
            H,
            mr,
            xt,
            Er,
            Pn,
            Bi,
            q,
            nt,
            St,
            Mi,
            Wr,
            Vr,
            zr,
            ln,
            Ki,
            Yt,
            Hn,
            lr,
            L,
            ui,
            si,
            gi,
            gn,
            Lt,
            7,
            ut,
            an,
            Tt,
            kt,
            Kr,
            q,
            vt,
            Fr,
            Zi,
            sr,
            Yn,
            $,
            Zn,
            Cn,
            8,
            kn,
            Yt,
            ci,
            ti,
            zr,
            Q,
            bi,
            Qt,
            Ur,
            wt,
            Er,
            zt,
            wi,
            _i,
            wt,
            _n,
            ci,
            Ei,
            ft,
            kr,
            un,
            Pn,
            Wn,
            gr,
            hr,
            6,
            Ln,
            Yr,
            vt,
            Nn,
            Cr,
            Ii,
            U,
            Jn,
            g,
            Hi,
            yn,
            Vr,
            Wt,
            Tr,
            sn,
            xn,
            Ft,
            Ci,
            6,
            gi,
            tr,
            3,
            kt,
            Lt,
            Rn,
            P,
            zt,
            Vi,
            qi,
            it,
            or,
            Ji,
            Xn,
            Ln,
            vt,
            kn,
            x,
            ji,
            vt,
            on,
            P,
            Fr,
            Fr,
            $n,
            di,
            Wt,
            q,
            Wn,
            Yr,
            zr,
            Q,
            br,
            4,
            Zt,
            Ct,
            it,
            Ei,
            Kr,
            qi,
            Pr,
            Pn,
            Ln,
            An,
            zr,
            Ir,
            li,
            Jr,
            Kt,
            Zt,
            J,
            br,
            er,
            Un,
            Fn,
            _t,
            ii,
            Hn,
            It,
            Ci,
            nn,
            ut,
            xn,
            gt,
            ji,
            Ir,
            Bi,
            lt,
            bi,
            Kn,
            Ti,
            no,
            Qn,
            pi,
            at,
            Di,
            pr,
            Un,
            Ui,
            Pt,
            Ot,
            pt,
            zt,
            qn,
            yn,
            8,
            kn,
            wn,
            Ir,
            Un,
            V,
            ei,
            Zn,
            Gn,
            It,
            Tr,
            Rr,
            _,
            ei,
            en,
            Wt,
            0,
            et,
            vt,
            Dr,
            Qi,
            Cn,
            hr,
            Bt,
            4,
            Q,
            8,
            Qi,
            at,
            Rr,
            Ir,
            j,
            Bi,
            ui,
            Dr,
            3,
            Yi,
            It,
            xr,
            Pt,
            bn,
            Vr,
            Qi,
            ot,
            vi,
            S,
            L,
            zt,
            tr,
            X,
            _n,
            Li,
            $i,
            5,
            yn,
            Fr,
            st,
            Z,
            nr,
            Si,
            wt,
            Yt,
            mt,
            qn,
            Qt,
            Ri,
            3,
            dt,
            Er,
            jt,
            xi,
            Dn,
            rn,
            lr,
            En,
            5,
            Vn,
            q,
            vi,
            0,
            fn,
            Di,
            Q,
            ti,
            ui,
            hr,
            er,
            Fn,
            J,
            K,
            nt,
            Jt,
            _t,
            Jr,
            dr,
            _t,
            bn,
            Hi,
            kn,
            xr,
            _,
            li,
            Q,
            zt,
            dn,
            fi,
            I,
            W,
            Nt,
            Mi,
            U,
            st,
            cn,
            ar,
            2,
            D,
            Ct,
            _t,
            Ht,
            Di,
            hi,
            $i,
            Yi,
            Bn,
            jn,
            Et,
            yt,
            ro,
            Fr,
            pt,
            nt,
            qn,
            Pn,
            jt,
            at,
            wt,
            pt,
            en,
            lt,
            ft,
            qn,
            Bt,
            Ki,
            sr,
            1,
            j,
            Ii,
            ji,
            br,
            I,
            J,
            Ni,
            zn,
            J,
            ui,
            V,
            G,
            hi,
            ui,
            un,
            ar,
            Pr,
            _r,
            $,
            tr,
            Ei,
            Pi,
            ti,
            k,
            tt,
            Zi,
            $n,
            xi,
            g,
            kt,
            wr,
            Vi,
            di,
            Pi,
            Qt,
            ot,
            T,
            xr,
            en,
            Xt,
            rr,
            Un,
            dn,
            Fi,
            ft,
            di,
            zt,
            J,
            ui,
            Er,
            G,
            vi,
            Dr,
            Gn,
            j,
            3,
            8,
            oi,
            jt,
            Ar,
            k,
            _r,
            fr,
            D,
            yn,
            Vi,
            er,
            Ni,
            sn,
            1,
            Jr,
            7,
            $i,
            W,
            Ei,
            gt,
            Vt,
            Bi,
            $i,
            z,
            et,
            at,
            Ht,
            It,
            Mn,
            Ai,
            Zt,
            dt,
            Vr,
            sn,
            Hr,
            U,
            Dt,
            Lt,
            P,
            ln,
            Mt,
            zi,
            di,
            0,
            Mt,
            Jr,
            2,
            gn,
            Er,
            qr,
            Gt,
            gn,
            U,
            Vr,
            Fi,
            Xi,
            Kr,
            3,
            ut,
            io,
            Di,
            xr,
            si,
            bt,
            bn,
            Jr,
            qn,
            bt,
            _i,
            2,
            en,
            rr,
            $t,
            5,
            an,
            no,
            qi,
            yi,
            ft,
            oi,
            Zr,
            K,
            Tr,
            _,
            io,
            Er,
            en,
            ri,
            Pt,
            en,
            Bi,
            bt,
            Wi,
            Fi,
            Bn,
            $i,
            Fi,
            x,
            Wt,
            Mt,
            Pt,
            ui,
            D,
            7,
            en,
            Pn,
            en,
            lt,
            en,
            Zi,
            Or,
            Pn,
            qi,
            ht,
            Qt,
            vi,
            Jn,
            Ut,
            Dn,
            ii,
            Mt,
            Pi,
            wt,
            Ur,
            Rr,
            ar,
            Nn,
            P,
            g,
            zt,
            wn,
            lt,
            lr,
            sn,
            yr,
            hi,
            et,
            Bt,
            dt,
            Gi,
            Ct,
            gn,
            Yr,
            qi,
            H,
            Sn,
            bt,
            Mr,
            cr,
            ni,
            Y,
            ei,
            yt,
            Ut,
            gi,
            $i,
            G,
            fn,
            qr,
            fn,
            Fr,
            et,
            X,
            Vr,
            cr,
            Gi,
            Gi,
            q,
            zr,
            Er,
            Kt,
            Gi,
            pn,
            gi,
            Ct,
            ut,
            Tt,
            5,
            jr,
            er,
            Ui,
            An,
            Rn,
            ui,
            ut,
            tr,
            qi,
            fi,
            Mn,
            ei,
            sr,
            Sn,
            zr,
            ei,
            Ht,
            at,
            vi,
            It,
            q,
            tt,
            Dt,
            An,
            Lt,
            Tn,
            nn,
            0,
            mt,
            Y,
            Bt,
            lt,
            In,
            Tr,
            Ft,
            si,
            Y,
            Tt,
            et,
            mi,
            Gr,
            di,
            5,
            Ln,
            Ei,
            Ur,
            Rr,
            Qt,
            or,
            jn,
            Wt,
            pt,
            di,
            Lt,
            dr,
            Kn,
            er,
            j,
            U,
            Zt,
            Ct,
            qn,
            mn,
            6,
            pt,
            Zi,
            kn,
            4,
            Rr,
            ui,
            _r,
            jr,
            nn,
            Kr,
            qt,
            ft,
            nt,
            Ct,
            fn,
            Y,
            Y,
            $n,
            P,
            K,
            S,
            xt,
            Mr,
            Cr,
            Tr,
            Vi,
            en,
            Mt,
            Xn,
            Lr,
            br,
            Hn,
            It,
            ht,
            Ji,
            sn,
            gr,
            wi,
            3,
            Ut,
            pt,
            Ri,
            ot,
            ft,
            Ci,
            ln,
            Oi,
            wi,
            J,
            hi,
            Vr,
            nr,
            Xt,
            Gi,
            Vi,
            ni,
            ut,
            ht,
            7,
            pi,
            si,
            Ut,
            er,
            Jr,
            or,
            Ji,
            En,
            zn,
            Vt,
            Ei,
            dr,
            Qn,
            Li,
            bn,
            Ur,
            Ii,
            St,
            Pr,
            5,
            Sn,
            pt,
            Vt,
            ui,
            Dn,
            z,
            er,
            Vi,
            Y,
            Cn,
            io,
            fr,
            G,
            mi,
            Hr,
            _n,
            sn,
            ro,
            nt,
            Nr,
            2,
            W,
            L,
            Yr,
            Dr,
            Rn,
            _r,
            Yi,
            It,
            Ai,
            Qn,
            no,
            an,
            sn,
            X,
            pr,
            Nt,
            L,
            zt,
            st,
            Bn,
            Vt,
            $t,
            yt,
            Nr,
            x,
            En,
            fn,
            Z,
            Cn,
            et,
            Y,
            En,
            4,
            Zi,
            yi,
            Hn,
            yi,
            Sn,
            Or,
            At,
            Bn,
            9,
            Tr,
            Ln,
            tn,
            Di,
            Ki,
            Rr,
            qn,
            Nr,
            P,
            1,
            Jn,
            hn,
            In,
            wt,
            Qr,
            It,
            ti,
            Jr,
            zr,
            ln,
            jr,
            Ui,
            Sr,
            Yi,
            Cn,
            on,
            Sn,
            Ai,
            $r,
            ri,
            Jn,
            nn,
            Sr,
            ri,
            Zi,
            $r,
            ri,
            In,
            Er,
            Nr,
            Hn,
            Rt,
            Vr,
            gr,
            ar,
            St,
            or,
            wn,
            Xi,
            D,
            7,
            Z,
            pr,
            Xt,
            Ur,
            wn,
            1,
            Hr,
            st,
            Sr,
            zi,
            Gt,
            En,
            Nr,
            zt,
            vi,
            Gr,
            Ai,
            Gi,
            Yn,
            Mt,
            qn,
            gn,
            Hn,
            Gr,
            ln,
            Mi,
            nr,
            sn,
            R,
            Nr,
            xn,
            Tt,
            It,
            Oi,
            Z,
            6,
            Jr,
            Ri,
            io,
            xn,
            I,
            mt,
            Z,
            Hr,
            gr,
            Dt,
            Ji,
            $t,
            on,
            Mn,
            Pi,
            hn,
            $i,
            nr,
            _,
            gi,
            Pn,
            Tr,
            hi,
            ei,
            Kr,
            rn,
            Xi,
            Yt,
            Z,
            di,
            Ui,
            _,
            Vi,
            et,
            ro,
            U,
            sn,
            Cn,
            ht,
            yr,
            Nt,
            mr,
            Mr,
            en,
            In,
            Zr,
            kt,
            cr,
            St,
            Qr,
            di,
            Gr,
            Ur,
            On,
            _n,
            Vt,
            Jr,
            Vt,
            Sr,
            Pr,
            Rt,
            K,
            V,
            Jn,
            Oi,
            $t,
            Qt,
            Ht,
            St,
            Fn,
            V,
            cr,
            rr,
            Vn,
            ei,
            Cn,
            j,
            Vn,
            $t,
            bi,
            Mt,
            Gr,
            fi,
            9,
            yi,
            tt,
            K,
            Tn,
            ln,
            Ut,
            yt,
            Vr,
            Et,
            tr,
            Gt,
            Hr,
            ir,
            W,
            Zn,
            X,
            et,
            Jt,
            L,
            zt,
            ir,
            cr,
            J,
            Ei,
            Yi,
            an,
            $n,
            8,
            zi,
            V,
            Xr,
            ji,
            xn,
            Q,
            U,
            0,
            Xr,
            Hi,
            $t,
            ut,
            9,
            Hn,
            hn,
            7,
            Lt,
            ct,
            8,
            It,
            Lt,
            Sr,
            z,
            Z,
            br,
            pr,
            Ut,
            sn,
            sn,
            Un,
            Xt,
            dt,
            $i,
            Bt,
            xn,
            g,
            z,
            sr,
            gi,
            Ni,
            gr,
            tr,
            un,
            lt,
            Zi,
            Nt,
            Z,
            un,
            en,
            di,
            Ir,
            Ft,
            Wn,
            Vi,
            $,
            oi,
            g,
            Dn,
            Jt,
            Wn,
            Hi,
            xi,
            X,
            Li,
            Ii,
            En,
            Ni,
            Or,
            gr,
            P,
            kn,
            hr,
            Wt,
            bn,
            U,
            Vt,
            B,
            ri,
            Ur,
            Yi,
            $r,
            Xn,
            li,
            pn,
            Fi,
            or,
            bi,
            jt,
            4,
            et,
            Ai,
            Qt,
            9,
            mr,
            rr,
            Pn,
            Br,
            di,
            yn,
            ar,
            Zr,
            Di,
            Qi,
            Jr,
            st,
            Mn,
            tn,
            li,
            Wr,
            at,
            tr,
            Ai,
            mt,
            Rt,
            Gi,
            ci,
            Oi,
            Wr,
            Fr,
            V,
            mi,
            Xi,
            kn,
            Oi,
            Kr,
            Gi,
            sr,
            $n,
            Tr,
            Xr,
            B,
            Dt,
            ln,
            hi,
            Xi,
            I,
            mr,
            Ni,
            er,
            jn,
            Ti,
            An,
            mr,
            tr,
            Nr,
            Ei,
            Vn,
            Ct,
            Nn,
            qn,
            B,
            zn,
            at,
            yr,
            pi,
            On,
            kn,
            ct,
            Gt,
            ei,
            At,
            xt,
            jn,
            z,
            ti,
            C,
            Di,
            Rr,
            qi,
            ei,
            lt,
            $i,
            Mr,
            L,
            z,
            Ir,
            H,
            6,
            q,
            ui,
            br,
            3,
            lt,
            $r,
            nt,
            ln,
            zt,
            In,
            Ni,
            nn,
            fi,
            Dt,
            Bi,
            Xi,
            Cn,
            Tn,
            Li,
            li,
            Pr,
            Vt,
            Ei,
            Ft,
            yr,
            kr,
            C,
            X,
            ai,
            Qt,
            Kn,
            qn,
            g,
            ar,
            yr,
            Cr,
            Un,
            kn,
            Wr,
            2,
            Zr,
            Yt,
            U,
            Ut,
            Bn,
            7,
            At,
            Ii,
            zr,
            K,
            ai,
            Xn,
            ki,
            9,
            Ti,
            at,
            Et,
            bi,
            Jt,
            vt,
            fr,
            Qi,
            ti,
            Jt,
            ei,
            Kn,
            Ti,
            U,
            Kn,
            Gr,
            Pt,
            Ar,
            br,
            ki,
            jt,
            0,
            On,
            qi,
            ir,
            gn,
            Ct,
            Kt,
            4,
            Jn,
            Lt,
            wn,
            Bt,
            si,
            B,
            ri,
            Wt,
            $t,
            Wr,
            ir,
            ti,
            Dn,
            _n,
            Bt,
            Ut,
            2,
            j,
            tt,
            dr,
            Jt,
            0,
            ur,
            xr,
            tn,
            1,
            yn,
            $i,
            Bt,
            C,
            ht,
            G,
            lt,
            7,
            qi,
            pr,
            ft,
            C,
            Ur,
            Qn,
            bt,
            V,
            kn,
            dt,
            6,
            Rr,
            wt,
            Er,
            Pr,
            Qi,
            Xt,
            ci,
            V,
            Nr,
            bi,
            pn,
            Nr,
            no,
            Ct,
            Ai,
            g,
            oi,
            en,
            x,
            Q,
            Xn,
            ir,
            ki,
            gi,
            gr,
            Ot,
            ln,
            zn,
            vi,
            Hi,
            or,
            ft,
            Pr,
            wi,
            Ht,
            fi,
            Vr,
            ln,
            Qi,
            di,
            Rt,
            Zi,
            Nn,
            Pi,
            Hr,
            Zn,
            In,
            ln,
            9,
            Tn,
            Br,
            Qt,
            K,
            Mi,
            K,
            li,
            _t,
            tn,
            Rr,
            ln,
            Wr,
            Gi,
            j,
            st,
            An,
            Tt,
            ii,
            Lt,
            Xn,
            un,
            er,
            ht,
            J,
            ln,
            ei,
            di,
            Gr,
            Rn,
            Gt,
            di,
            Jt,
            Rn,
            ur,
            Oi,
            G,
            Yi,
            qt,
            rr,
            Vt,
            zt,
            hr,
            Bi,
            Hn,
            S,
            Rr,
            Xn,
            Br,
            Ui,
            Wn,
            Yi,
            Yr,
            Bi,
            st,
            Ui,
            br,
            U,
            ur,
            Bt,
            ar,
            Vn,
            jt,
            Zr,
            Sn,
            Ln,
            Wn,
            Bi,
            Fn,
            ln,
            qt,
            ut,
            $n,
            zt,
            H,
            Ei,
            Ct,
            Oi,
            Ii,
            Un,
            yt,
            jr,
            wi,
            Vr,
            ln,
            Ht,
            un,
            R,
            nt,
            Qn,
            D,
            an,
            j,
            Ui,
            Er,
            Hr,
            Xn,
            bn,
            pt,
            cr,
            Tn,
            En,
            Yr,
            R,
            Qn,
            cn,
            Er,
            It,
            Ar,
            ci,
            Ln,
            ji,
            _n,
            Gn,
            ui,
            _t,
            Yn,
            dn,
            ti,
            Di,
            Yt,
            Yi,
            7,
            ln,
            7,
            Ln,
            pr,
            bn,
            qi,
            yi,
            gi,
            yi,
            1,
            Ht,
            Ei,
            jr,
            qn,
            ln,
            $,
            _,
            ct,
            Tr,
            Wn,
            at,
            wi,
            ki,
            I,
            z,
            Nn,
            dr,
            un,
            L,
            en,
            qr,
            un,
            Xr,
            Zn,
            ft,
            ri,
            C,
            tr,
            Un,
            gr,
            C,
            Yt,
            tn,
            En,
            vr,
            Qt,
            Et,
            q,
            Ei,
            en,
            Dt,
            Gr,
            4,
            En,
            wt,
            $,
            wi,
            Xr,
            jr,
            It,
            Jt,
            ri,
            Yn,
            xi,
            gr,
            Cr,
            S,
            Gi,
            Mt,
            Lr,
            jn,
            Ii,
            Ji,
            P,
            Nn,
            mn,
            6,
            vi,
            _t,
            gr,
            Nr,
            4,
            4,
            io,
            nt,
            q,
            Oi,
            kn,
            $r,
            At,
            Lt,
            hr,
            In,
            ro,
            fr,
            rt,
            ht,
            Dt,
            En,
            li,
            W,
            br,
            Qt,
            sn,
            Yn,
            Ui,
            nt,
            _i,
            jt,
            Ln,
            Ln,
            ti,
            lr,
            Yn,
            L,
            at,
            Hi,
            Q,
            Vt,
            tn,
            Zt,
            no,
            di,
            Li,
            tn,
            wr,
            ut,
            ut,
            yr,
            Br,
            Wi,
            hi,
            kr,
            U,
            St,
            ht,
            Fr,
            Dt,
            vn,
            Li,
            yn,
            mi,
            Lt,
            st,
            Yr,
            Ar,
            H,
            Nn,
            wn,
            Vi,
            Vi,
            st,
            dr,
            T,
            cn,
            Br,
            Ar,
            Jr,
            Bt,
            Ii,
            Gn,
            Ni,
            1,
            X,
            7,
            dr,
            Ei,
            Qi,
            It,
            W,
            ut,
            On,
            H,
            D,
            pt,
            rn,
            $r,
            dr,
            In,
            Bn,
            H,
            or,
            rn,
            pn,
            sn,
            Wn,
            Xn,
            ht,
            $i,
            Zi,
            Bi,
            Gt,
            gt,
            or,
            k,
            It,
            Pr,
            sn,
            vi,
            L,
            qt,
            Ar,
            _,
            hi,
            4,
            J,
            rr,
            Tt,
            9,
            5,
            B,
            pr,
            Yt,
            xt,
            Tt,
            Ft,
            fi,
            Ki,
            tt,
            _n,
            ht,
            Vi,
            Jt,
            Vi,
            8,
            Br,
            ki,
            It,
            Yn,
            Sr,
            Ct,
            kn,
            vt,
            1,
            Mi,
            Wr,
            Yr,
            Ai,
            Vt,
            jr,
            xi,
            er,
            ht,
            or,
            Bi,
            Br,
            ei,
            wn,
            j,
            ct,
            ei,
            Hr,
            $r,
            dn,
            Hi,
            xr,
            rt,
            rn,
            Bt,
            ur,
            Mr,
            Tn,
            er,
            z,
            ur,
            Fr,
            zi,
            T,
            yn,
            Dt,
            In,
            5,
            dt,
            mr,
            lr,
            $i,
            xn,
            Xn,
            xi,
            an,
            H,
            vr,
            Yi,
            Vi,
            V,
            G,
            Ar,
            Dt,
            hn,
            ht,
            Jt,
            Wr,
            Nt,
            Et,
            Si,
            ri,
            It,
            Xr,
            kt,
            pi,
            rr,
            Jt,
            C,
            Ir,
            Q,
            ai,
            Vr,
            D,
            Qt,
            Ut,
            Yi,
            In,
            mi,
            Wr,
            H,
            hn,
            ct,
            4,
            Xi,
            Ni,
            en,
            qn,
            Vi,
            ot,
            Ar,
            Si,
            Bi,
            Sr,
            Ai,
            Jr,
            X,
            no,
            In,
            Yr,
            L,
            ji,
            $t,
            j,
            sn,
            k,
            Or,
            Sn,
            Jt,
            ot,
            oi,
            Yr,
            Fr,
            zi,
            Ur,
            yi,
            Or,
            Rn,
            yr,
            En,
            di,
            Ti,
            Hn,
            Ki,
            ut,
            rr,
            ft,
            0,
            U,
            li,
            8,
            ir,
            gr,
            ci,
            Ci,
            Sn,
            $r,
            Xt,
            Yr,
            Gt,
            Tt,
            yt,
            zt,
            ur,
            yt,
            di,
            di,
            Wi,
            9,
            Un,
            Wt,
            Gn,
            Zr,
            _r,
            Wt,
            Sr,
            zi,
            hi,
            Xt,
            Fn,
            Ai,
            ii,
            fi,
            Un,
            I,
            zn,
            Kn,
            ln,
            er,
            jn,
            Mr,
            4,
            0,
            dn,
            _i,
            Rn,
            ro,
            dr,
            Wt,
            9,
            tt,
            Gn,
            Zr,
            ft,
            Cn,
            ln,
            Yn,
            er,
            Gt,
            mn,
            mi,
            Kr,
            Kr,
            ni,
            Fi,
            tr,
            fn,
            g,
            Rt,
            wi,
            jr,
            pt,
            ci,
            at,
            ei,
            di,
            ln,
            Ki,
            Zi,
            Nt,
            Hn,
            Wn,
            xt,
            At,
            pi,
            Ei,
            Lr,
            g,
            rn,
            _,
            z,
            I,
            rn,
            nr,
            0,
            it,
            mn,
            Yi,
            on,
            Ai,
            oi,
            Nr,
            qr,
            hn,
            Tn,
            qn,
            x,
            qt,
            Ot,
            jr,
            vt,
            7,
            tr,
            Fr,
            ti,
            Vn,
            Xn,
            Wr,
            _t,
            kn,
            Dn,
            Xi,
            xn,
            I,
            wt,
            lr,
            St,
            Qt,
            jt,
            ci,
            gi,
            ai,
            xr,
            Tr,
            k,
            Jn,
            hi,
            Mr,
            x,
            Xr,
            At,
            ti,
            Xi,
            Z,
            Yi,
            jt,
            tr,
            tr,
            Qt,
            Oi,
            ji,
            Fi,
            Sn,
            Cr,
            Ni,
            io,
            4,
            Hi,
            Q,
            4,
            Rr,
            Vt,
            q,
            G,
            Vt,
            kn,
            g,
            vr,
            lr,
            Rr,
            sr,
            g,
            q,
            Yi,
            ni,
            ln,
            mn,
            Ui,
            ot,
            ar,
            L,
            K,
            Jt,
            qt,
            sn,
            5,
            _t,
            ht,
            cn,
            8,
            T,
            rr,
            gr,
            gr,
            Ct,
            mr,
            Zn,
            Q,
            $i,
            Di,
            mt,
            Oi,
            qn,
            kn,
            Br,
            br,
            Dt,
            rt,
            Wt,
            Yn,
            5,
            Ln,
            X,
            4,
            tn,
            gt,
            Lt,
            8,
            Jn,
            Gi,
            Jn,
            x,
            Hr,
            In,
            vn,
            ro,
            gn,
            gt,
            Tn,
            xi,
            In,
            S,
            ei,
            Vi,
            4,
            nt,
            H,
            1,
            V,
            2,
            Kt,
            6,
            ji,
            hn,
            Dr,
            tt,
            Xi,
            sr,
            1,
            dt,
            Ji,
            kt,
            li,
            At,
            xt,
            wn,
            vn,
            Ft,
            ir,
            Ei,
            rr,
            Z,
            tn,
            qn,
            ki,
            Mn,
            mr,
            Dr,
            li,
            _,
            ht,
            yi,
            Xr,
            tr,
            wi,
            9,
            yi,
            at,
            St,
            Vt,
            Yn,
            Dr,
            tt,
            q,
            Xn,
            1,
            Ut,
            T,
            Pn,
            7,
            qn,
            bt,
            ti,
            Ht,
            Fi,
            ur,
            Vn,
            dt,
            qr,
            Jn,
            _r,
            un,
            Qi,
            jn,
            Fi,
            Yt,
            Ki,
            Mt,
            Z,
            lt,
            Yt,
            9,
            Ct,
            $n,
            kr,
            Rn,
            1,
            Or,
            S,
            Y,
            V,
            bt,
            zt,
            _i,
            pt,
            un,
            Zt,
            Ji,
            zt,
            yn,
            Sr,
            Fi,
            9,
            Cr,
            Zt,
            at,
            pt,
            ji,
            ui,
            Mi,
            Bi,
            Yi,
            G,
            ur,
            jr,
            Yr,
            qt,
            Ht,
            Di,
            B,
            _r,
            $t,
            di,
            An,
            Hn,
            Pn,
            H,
            gt,
            vt,
            Fi,
            Et,
            pt,
            Xt,
            Et,
            Vt,
            Yi,
            Yr,
            Wn,
            Sr,
            Jr,
            Ei,
            cr,
            Bi,
            bt,
            It,
            dn,
            Ar,
            vr,
            Dr,
            Yi,
            zr,
            X,
            xr,
            B,
            dr,
            Lr,
            bt,
            Zr,
            Vi,
            Qn,
            Zi,
            g,
            er,
            St,
            J,
            Xt,
            Ln,
            H,
            Vr,
            Pr,
            Ii,
            Mt,
            Zi,
            Zn,
            Jr,
            zt,
            B,
            hr,
            Wn,
            ui,
            4,
            Sr,
            An,
            cn,
            cr,
            _i,
            $t,
            un,
            ot,
            pt,
            Er,
            Ti,
            fr,
            Ki,
            pn,
            Gn,
            Ei,
            dt,
            ii,
            on,
            Z,
            Mn,
            yi,
            or,
            Fn,
            Ai,
            Bt,
            rr,
            zn,
            In,
            Tt,
            zn,
            io,
            Wr,
            V,
            Kn,
            C,
            pr,
            S,
            Ut,
            Gn,
            Vi,
            or,
            _r,
            vn,
            qn,
            Wt,
            Zi,
            Ui,
            Hi,
            Lr,
            Bn,
            Rn,
            k,
            Si,
            An,
            Pr,
            lt,
            Bi,
            yn,
            Pi,
            Fi,
            Gn,
            Vt,
            ur,
            fi,
            Pn,
            jt,
            kn,
            Qn,
            W,
            nn,
            An,
            Jr,
            Cn,
            I,
            nt,
            Un,
            Dt,
            j,
            en,
            Dr,
            Ni,
            Zi,
            Ii,
            Pi,
            ft,
            8,
            li,
            Ti,
            Cr,
            Wi,
            tr,
            lt,
            Ar,
            ti,
            Tr,
            Nn,
            yn,
            ai,
            ur,
            I,
            V,
            _n,
            q,
            oi,
            Yr,
            kt,
            Un,
            no,
            Sr,
            sn,
            $n,
            It,
            Lr,
            On,
            In,
            Q,
            Or,
            Pn,
            at,
            nn,
            lt,
            li,
            Gr,
            g,
            In,
            W,
            J,
            _i,
            _t,
            gt,
            D,
            ar,
            qr,
            nn,
            yt,
            gt,
            Ri,
            xr,
            hr,
            Kn,
            bi,
            Tt,
            Jt,
            wi,
            Lr,
            fn,
            Dr,
            8,
            x,
            Fi,
            ui,
            Qn,
            Er,
            V,
            Ar,
            Tr,
            Kn,
            bi,
            _r,
            Hi,
            Ti,
            mr,
            Rn,
            S,
            Dr,
            qr,
            Hn,
            In,
            Dn,
            en,
            nt,
            $n,
            Vn,
            Bn,
            X,
            si,
            Bi,
            nr,
            Si,
            Ar,
            dt,
            z,
            sr,
            $r,
            si,
            _,
            tn,
            or,
            j,
            Wi,
            Mt,
            An,
            ni,
            1,
            Kn,
            pr,
            or,
            mn,
            Ht,
            Ii,
            lt,
            sn,
            Ui,
            bn,
            xn,
            Tn,
            P,
            Ut,
            Yr,
            $r,
            Kt,
            Er,
            B,
            Bt,
            ei,
            Ci,
            di,
            In,
            Bi,
            en,
            dt,
            rt,
            bi,
            J,
            tt,
            lr,
            Pt,
            Gi,
            Pn,
            Pn,
            Et,
            Z,
            Ii,
            P,
            ei,
            ri,
            un,
            oi,
            W,
            jn,
            xr,
            yt,
            4,
            st,
            mi,
            bn,
            En,
            fn,
            Yr,
            Ti,
            mr,
            ht,
            at,
            Gt,
            Rn,
            Y,
            Ln,
            tr,
            li,
            z,
            I,
            I,
            dr,
            sn,
            wr,
            Ai,
            Cn,
            $i,
            bt,
            at,
            Pi,
            pi,
            Ur,
            vn,
            hr,
            Jt,
            mr,
            wt,
            wt,
            rt,
            gn,
            Dn,
            Ir,
            T,
            ri,
            Mr,
            ur,
            4,
            kt,
            5,
            en,
            ct,
            Ti,
            Pt,
            Q,
            wt,
            lt,
            $i,
            an,
            Zr,
            at,
            Ir,
            vt,
            Vt,
            Jn,
            Nt,
            Z,
            9,
            Zt,
            X,
            Un,
            hi,
            Ei,
            bn,
            br,
            tr,
            ur,
            Fi,
            ci,
            an,
            Dt,
            jn,
            Vt,
            qn,
            W,
            Zr,
            tn,
            gi,
            2,
            bt,
            mn,
            pt,
            xi,
            V,
            Ni,
            mt,
            Bn,
            ei,
            Jn,
            Hi,
            It,
            Ii,
            B,
            Mn,
            Vt,
            br,
            Xn,
            yt,
            Rn,
            Ct,
            pr,
            6,
            Un,
            R,
            Cn,
            qr,
            Ji,
            hr,
            ni,
            X,
            Si,
            gi,
            Yn,
            An,
            Br,
            In,
            Kt,
            Er,
            Qr,
            Ai,
            ir,
            pn,
            Tr,
            wn,
            Q,
            q,
            Br,
            Dt,
            ln,
            W,
            qr,
            nn,
            Ar,
            ki,
            In,
            H,
            $,
            wn,
            Rn,
            _t,
            K,
            hi,
            xi,
            bt,
            bn,
            yr,
            Qr,
            Wr,
            Mn,
            bi,
            Pr,
            Mr,
            ir,
            gr,
            P,
            jr,
            Yt,
            pn,
            Xi,
            ri,
            wi,
            Zn,
            Qi,
            Or,
            nt,
            Pn,
            kn,
            Un,
            Rn,
            Tn,
            an,
            Qn,
            fi,
            $r,
            Yi,
            Gi,
            Gr,
            En,
            mn,
            pi,
            Z,
            zi,
            Ln,
            Mi,
            ot,
            Bt,
            Zi,
            bt,
            Gt,
            Cr,
            fi,
            si,
            Ri,
            et,
            Hi,
            Un,
            Fn,
            J,
            Wr,
            ln,
            St,
            tt,
            no,
            Ii,
            xi,
            Yt,
            Z,
            Qr,
            hi,
            ii,
            Ft,
            sn,
            St,
            rr,
            zr,
            vt,
            _,
            4,
            wn,
            Zr,
            jr,
            Ut,
            Kn,
            Ut,
            Ir,
            Lr,
            Un,
            mr,
            Fr,
            Mn,
            8,
            Ct,
            9,
            hi,
            G,
            lt,
            gn,
            Vr,
            Tr,
            Xr,
            Rr,
            ar,
            bn,
            ro,
            Ai,
            Vn,
            Un,
            Er,
            ft,
            Sr,
            J,
            Hi,
            Gi,
            Nt,
            ui,
            On,
            er,
            V,
            qi,
            Qt,
            ir,
            mi,
            Ui,
            ot,
            kn,
            Rr,
            or,
            Xn,
            z,
            W,
            cn,
            ir,
            qn,
            hr,
            Pn,
            2,
            R,
            Jn,
            $r,
            Jr,
            Bt,
            Mt,
            mt,
            bi,
            5,
            qi,
            Ui,
            Pi,
            _n,
            In,
            Xr,
            yi,
            cr,
            ei,
            sn,
            Er,
            Lt,
            rt,
            Wt,
            $t,
            Mt,
            j,
            ui,
            mi,
            Pt,
            wt,
            wi,
            fi,
            _i,
            io,
            bt,
            Ui,
            qi,
            qi,
            9,
            Hi,
            hi,
            Pt,
            yn,
            Ln,
            P,
            ar,
            J,
            D,
            nn,
            fi,
            pt,
            z,
            Gn,
            Mt,
            io,
            Yt,
            Ti,
            ki,
            zi,
            wi,
            pr,
            Qr,
            xi,
            nt,
            B,
            Kn,
            qi,
            pi,
            Kt,
            zr,
            _r,
            Lr,
            Ir,
            Dn,
            xn,
            G,
            tr,
            xi,
            sr,
            Mi,
            _t,
            bt,
            Nn,
            Sn,
            Fr,
            nr,
            jt,
            pr,
            K,
            Sr,
            z,
            An,
            Hi,
            mi,
            gi,
            g,
            pn,
            kt,
            fn,
            Fi,
            Hn,
            xr,
            Ai,
            j,
            Zr,
            Rn,
            Ji,
            gr,
            Mr,
            en,
            wi,
            V,
            Jr,
            wn,
            Nt,
            pi,
            pr,
            Dr,
            Zn,
            tr,
            T,
            6,
            C,
            si,
            ct,
            In,
            0,
            Ri,
            C,
            Dr,
            Gn,
            Fn,
            hr,
            zn,
            An,
            vr,
            C,
            zn,
            Yi,
            Rr,
            6,
            Zt,
            mi,
            zi,
            Vr,
            L,
            br,
            V,
            Ct,
            Wn,
            Pt,
            Rr,
            Wn,
            nr,
            Wr,
            Li,
            Pr,
            Cn,
            ti,
            At,
            nn,
            Ii,
            xi,
            dt,
            cr,
            Qr,
            Bt,
            an,
            _r,
            Gt,
            sr,
            Qr,
            mi,
            Wr,
            Sr,
            at,
            Sr,
            fr,
            ct,
            X,
            ni,
            Di,
            ui,
            wi,
            Bi,
            vt,
            Jn,
            ct,
            Mn,
            Fn,
            Cr,
            Gt,
            dt,
            Zn,
            Wn,
            Bt,
            an,
            Y,
            _r,
            yn,
            Ei,
            Vt,
            $r,
            $i,
            Qt,
            Ti,
            qr,
            _r,
            J,
            Kt,
            Wn,
            ft,
            It,
            Ui,
            mi,
            xn,
            si,
            L,
            vt,
            xt,
            dt,
            Lr,
            li,
            Ft,
            Hr,
            jr,
            bt,
            Ri,
            I,
            I,
            dn,
            ki,
            Xr,
            wr,
            Nr,
            di,
            0,
            or,
            Gi,
            ut,
            ji,
            Ei,
            Zt,
            _t,
            en,
            Kn,
            Wt,
            mt,
            Di,
            Wi,
            Ln,
            $i,
            yr,
            Fr,
            Dn,
            Or,
            ut,
            pi,
            yr,
            Qn,
            J,
            Gr,
            tn,
            S,
            _r,
            $r,
            Tr,
            $i,
            Ei,
            Kt,
            Si,
            En,
            or,
            un,
            kt,
            qr,
            Gt,
            Vt,
            rn,
            J,
            ar,
            tn,
            Ir,
            nn,
            Un,
            Hn,
            oi,
            Tr,
            qi,
            Kr,
            sn,
            Zt,
            Fi,
            5,
            Jt,
            or,
            R,
            Ai,
            Ur,
            ni,
            3,
            Dr,
            ci,
            5,
            6,
            vt,
            ti,
            Un,
            Qt,
            jr,
            Gt,
            0,
            gi,
            Z,
            rt,
            S,
            Wr,
            Gr,
            ot,
            Hn,
            ur,
            Vi,
            Wt,
            it,
            li,
            Pr,
            _t,
            Pn,
            Hn,
            L,
            6,
            Et,
            Mi,
            fn,
            dr,
            Br,
            Qt,
            Wi,
            ur,
            Wr,
            ii,
            Yt,
            In,
            Ln,
            L,
            Gn,
            Dt,
            Pr,
            hn,
            9,
            vi,
            Zi,
            J,
            8,
            Ft,
            ii,
            2,
            Ar,
            0,
            li,
            2,
            gi,
            Fi,
            Er,
            Ft,
            ii,
            tt,
            Rr,
            pt,
            Ai,
            Dn,
            L,
            ln,
            Ti,
            Ui,
            rn,
            ui,
            $r,
            yr,
            Ur,
            Ir,
            Kr,
            vr,
            Mi,
            $i,
            ti,
            Ft,
            zt,
            Tn,
            Yt,
            ut,
            hi,
            tn,
            Hn,
            Ar,
            kt,
            _n,
            1,
            Gr,
            sr,
            oi,
            Jr,
            4,
            Xt,
            or,
            cr,
            Mi,
            gn,
            J,
            $i,
            Si,
            cr,
            J,
            Zt,
            Yr,
            Sr,
            Ui,
            Di,
            er,
            ht,
            Lr,
            P,
            ri,
            _t,
            jt,
            qn,
            wr,
            zr,
            U,
            Lt,
            Ir,
            at,
            sn,
            Yr,
            U,
            Mr,
            no,
            zt,
            nn,
            oi,
            mn,
            br,
            ei,
            B,
            Mi,
            Li,
            Di,
            Yn,
            _,
            yt,
            br,
            Y,
            ur,
            vt,
            st,
            Ki,
            Xr,
            on,
            $r,
            _t,
            At,
            Ri,
            mr,
            Ai,
            Ar,
            wr,
            ln,
            jn,
            Hi,
            cr,
            Nt,
            Hn,
            qi,
            hi,
            bn,
            lr,
            mi,
            ni,
            Fi,
            Zt,
            Kr,
            Gr,
            yr,
            Mn,
            R,
            an,
            X,
            An,
            Sr,
            D,
            Cn,
            ar,
            sn,
            Sr,
            Ji,
            pi,
            jn,
            fn,
            un,
            mt,
            wr,
            yn,
            Hi,
            D,
            Q,
            Wt,
            Yi,
            ut,
            no,
            g,
            vn,
            Hr,
            ut,
            Ln,
            z,
            dn,
            vn,
            yt,
            tr,
            pr,
            nr,
            $r,
            2,
            jt,
            tt,
            Sn,
            Cr,
            Nt,
            $t,
            Qn,
            X,
            en,
            hi,
            rt,
            Yt,
            bn,
            Wt,
            ft,
            Xi,
            ln,
            ft,
            _t,
            ii,
            An,
            Hi,
            ro,
            Ci,
            Er,
            Kt,
            Fi,
            nt,
            gt,
            Ln,
            gn,
            V,
            wn,
            Wi,
            Fn,
            rt,
            Yi,
            li,
            st,
            Ct,
            at,
            Ti,
            wn,
            Ti,
            ni,
            xi,
            nt,
            fr,
            rt,
            Tr,
            vt,
            R,
            Di,
            q,
            mn,
            Mr,
            Kn,
            k,
            gn,
            T,
            Yt,
            Zr,
            lt,
            Wr,
            hr,
            gi,
            Li,
            jt,
            bi,
            ti,
            Ei,
            Yi,
            Kr,
            Zi,
            on,
            Ut,
            bt,
            Vi,
            Sn,
            zr,
            tr,
            $n,
            gi,
            Pt,
            ar,
            H,
            Tr,
            jt,
            qr,
            lr,
            Zi,
            Ri,
            Mn,
            Wt,
            en,
            Qn,
            Si,
            Er,
            Pn,
            g,
            V,
            ln,
            ri,
            dt,
            yn,
            Ji,
            Yt,
            Et,
            Ji,
            at,
            yt,
            Rn,
            It,
            zi,
            ci,
            ln,
            Zi,
            q,
            st,
            G,
            Fn,
            Fi,
            or,
            Hn,
            k,
            sr,
            pt,
            jn,
            wt,
            Jr,
            oi,
            mi,
            R,
            li,
            z,
            ht,
            bi,
            er,
            Yr,
            fr,
            Et,
            Qi,
            Jr,
            Ct,
            z,
            Br,
            Tt,
            Hn,
            X,
            It,
            Xt,
            Br,
            Gr,
            or,
            Lt,
            St,
            ki,
            3,
            H,
            Lt,
            On,
            nn,
            kt,
            jt,
            Ht,
            jt,
            Nt,
            ar,
            nn,
            ui,
            Lt,
            V,
            Yi,
            2,
            or,
            bt,
            nn,
            qi,
            zn,
            Zi,
            Gi,
            Vn,
            ii,
            Ri,
            dr,
            Qi,
            zn,
            yi,
            Xn,
            Bi,
            wr,
            6,
            qt,
            Xr,
            gi,
            Nr,
            ri,
            P,
            Z,
            An,
            it,
            Pn,
            dn,
            wt,
            Ar,
            vn,
            An,
            Tt,
            Ut,
            qr,
            ln,
            k,
            J,
            L,
            G,
            U,
            ir,
            Xr,
            dr,
            li,
            jt,
            Kn,
            B,
            vi,
            9,
            Vn,
            qi,
            di,
            wt,
            Ui,
            Wt,
            di,
            nr,
            Pn,
            Yi,
            Wi,
            Vt,
            _t,
            yi,
            W,
            $i,
            Dt,
            Lr,
            wt,
            Zi,
            ui,
            Ui,
            Vn,
            pn,
            pr,
            tr,
            K,
            ni,
            bt,
            rr,
            Qt,
            Sn,
            3,
            K,
            _n,
            pr,
            tr,
            hr,
            _,
            g,
            Un,
            X,
            _n,
            qi,
            kt,
            ot,
            Xn,
            Rt,
            Ui,
            si,
            K,
            en,
            ht,
            C,
            R,
            Mt,
            Cn,
            Fn,
            ot,
            On,
            si,
            ct,
            Hi,
            an,
            Vt,
            Kn,
            St,
            no,
            Br,
            Qt,
            Rn,
            J,
            fr,
            Wt,
            di,
            bn,
            cr,
            _n,
            yt,
            B,
            Pn,
            wr,
            gn,
            Br,
            S,
            Yr,
            Br,
            Qt,
            L,
            $r,
            B,
            br,
            nr,
            Nn,
            Fr,
            Jt,
            St,
            tn,
            7,
            pr,
            Ji,
            yn,
            pr,
            at,
            fr,
            mt,
            ri,
            _t,
            vi,
            $r,
            ct,
            nr,
            ci,
            I,
            Xi,
            io,
            _t,
            tn,
            Ei,
            wt,
            wi,
            yr,
            Pr,
            Yn,
            cr,
            In,
            qr,
            K,
            Si,
            $r,
            pn,
            4,
            pr,
            H,
            K,
            Kn,
            Hn,
            Ft,
            W,
            3,
            dr,
            _t,
            zi,
            Mi,
            gt,
            ot,
            Rr,
            nn,
            Ai,
            Y,
            Wi,
            G,
            lr,
            gr,
            lr,
            Z,
            cr,
            mn,
            S,
            Jn,
            J,
            bi,
            ir,
            bi,
            Tn,
            6,
            R,
            gr,
            Cn,
            D,
            Hn,
            vn,
            D,
            At,
            bn,
            Wi,
            Jr,
            Sn,
            X,
            Ii,
            Yr,
            Or,
            li,
            _r,
            Wn,
            Qt,
            Ln,
            zn,
            yr,
            nr,
            Ci,
            Wt,
            Tn,
            cn,
            Yr,
            ai,
            K,
            wt,
            Gt,
            Hi,
            un,
            Qi,
            io,
            Ot,
            Jn,
            On,
            W,
            Gr,
            on,
            T,
            yn,
            wr,
            xn,
            Mn,
            dt,
            Qt,
            Mn,
            U,
            qn,
            ei,
            qn,
            ji,
            _i,
            Sn,
            wr,
            rt,
            4,
            ji,
            vt,
            er,
            un,
            qn,
            8,
            yi,
            xt,
            cn,
            X,
            yn,
            di,
            Gn,
            Vt,
            Vt,
            Ot,
            sr,
            X,
            bt,
            Jt,
            Jr,
            Nr,
            ft,
            oi,
            Ut,
            Kn,
            qr,
            z,
            Q,
            Or,
            5,
            Qn,
            Zt,
            dt,
            ii,
            Ei,
            dt,
            Rn,
            bn,
            pn,
            R,
            _n,
            it,
            dr,
            q,
            g,
            Zt,
            Di,
            lr,
            R,
            nt,
            xn,
            Xn,
            6,
            Xr,
            Er,
            Ri,
            Ki,
            Tt,
            Br,
            pr,
            2,
            xt,
            5,
            Mn,
            Si,
            pi,
            Ei,
            Ur,
            Ut,
            Mn,
            an,
            mi,
            Fn,
            An,
            _i,
            Ki,
            Ar,
            ii,
            Kt,
            Gi,
            hi,
            Qt,
            St,
            xr,
            J,
            nn,
            Tr,
            ut,
            Vi,
            mt,
            Bn,
            _i,
            Sr,
            qn,
            Jr,
            Vt,
            io,
            Cr,
            Pt,
            nr,
            kr,
            yn,
            Dn,
            Gr,
            Ht,
            Nr,
            Y,
            Vt,
            Et,
            ot,
            ro,
            Yt,
            Wr,
            q,
            Nr,
            Jn,
            8,
            Fn,
            bn,
            $t,
            Xi,
            zr,
            vn,
            pr,
            D,
            kt,
            wr,
            3,
            5,
            Lt,
            pn,
            on,
            bt,
            yt,
            R,
            si,
            Tr,
            Ti,
            ni,
            pr,
            pi,
            Gr,
            Hi,
            Ur,
            xr,
            ir,
            Di,
            pt,
            Lt,
            Ut,
            it,
            Pr,
            kt,
            9,
            bn,
            Rn,
            Mn,
            _t,
            Ct,
            Kr,
            kr,
            vt,
            Rt,
            li,
            Rr,
            kn,
            Tn,
            qi,
            gn,
            ai,
            Dn,
            ii,
            Hn,
            sn,
            Bi,
            sn,
            rn,
            pn,
            Qi,
            or,
            ir,
            rn,
            Yt,
            _,
            In,
            Gr,
            8,
            pn,
            Cr,
            tt,
            ht,
            Sn,
            at,
            ri,
            9,
            Wr,
            un,
            yn,
            G,
            qn,
            4,
            Lr,
            Ur,
            er,
            mn,
            Qr,
            Cr,
            hi,
            Er,
            an,
            qt,
            Oi,
            oi,
            Mr,
            Ki,
            An,
            Fi,
            lt,
            xr,
            on,
            yt,
            Nr,
            Dt,
            _,
            ni,
            Hr,
            cr,
            Un,
            j,
            J,
            _,
            An,
            qr,
            kr,
            Bt,
            z,
            Ar,
            Mi,
            Yn,
            jn,
            ni,
            3,
            mt,
            Wi,
            ni,
            ci,
            5,
            ht,
            Mn,
            Sr,
            Vn,
            wi,
            Li,
            Dr,
            q,
            ft,
            Ti,
            ro,
            no,
            Fi,
            Qi,
            vr,
            Yr,
            Tr,
            gr,
            Vr,
            Gr,
            nn,
            Pi,
            x,
            Rn,
            Li,
            rr,
            $r,
            Gr,
            ht,
            xn,
            Qi,
            qi,
            dn,
            5,
            Nn,
            1,
            nn,
            gt,
            ro,
            C,
            U,
            un,
            $r,
            Ct,
            Jt,
            Rt,
            Ci,
            Cr,
            pn,
            Hn,
            Vt,
            Ln,
            wi,
            Ur,
            rn,
            ot,
            Qi,
            I,
            Dr,
            dt,
            P,
            An,
            Dn,
            Mn,
            rt,
            Bn,
            Vt,
            ut,
            Fr,
            Gn,
            Lt,
            ji,
            Ii,
            R,
            _n,
            Zn,
            qt,
            tt,
            g,
            _r,
            Ni,
            Ni,
            Gi,
            Yi,
            vn,
            Qn,
            dn,
            j,
            _t,
            rr,
            Rt,
            Zr,
            Gr,
            _r,
            C,
            Mr,
            U,
            It,
            Pr,
            Vt,
            Si,
            Et,
            ar,
            Cn,
            on,
            Di,
            Pn,
            Fi,
            z,
            Xt,
            Vi,
            mi,
            Ar,
            Xn,
            ln,
            Jt,
            En,
            Zt,
            Gi,
            Ei,
            Ri,
            ct,
            Jt,
            Nt,
            Q,
            B,
            At,
            ri,
            Nr,
            qi,
            li,
            Kn,
            qt,
            S,
            Gt,
            ni,
            cr,
            Rr,
            Wt,
            jt,
            ni,
            Wi,
            Ai,
            st,
            hn,
            cn,
            tn,
            nn,
            Mn,
            st,
            or,
            kr,
            Mi,
            ti,
            k,
            qn,
            Xi,
            Jn,
            Oi,
            Pr,
            Ri,
            mt,
            Rr,
            St,
            Yn,
            q,
            L,
            St,
            ri,
            Mi,
            Kr,
            Si,
            fi,
            Or,
            Hr,
            3,
            qn,
            ut,
            Mn,
            ei,
            Fi,
            tr,
            En,
            st,
            bt,
            C,
            cr,
            T,
            si,
            ji,
            I,
            R,
            Gi,
            Jr,
            Ir,
            rt,
            B,
            Jt,
            Vi,
            Ft,
            9,
            L,
            ur,
            Vr,
            Xn,
            3,
            ot,
            Zi,
            Q,
            tt,
            X,
            Qt,
            zr,
            sr,
            On,
            Zt,
            rt,
            Pt,
            Ht,
            Hr,
            Tr,
            Zi,
            B,
            sr,
            Mn,
            Wr,
            I,
            Wt,
            nt,
            Kt,
            fn,
            Gr,
            $,
            rr,
            ci,
            ai,
            In,
            mt,
            Z,
            7,
            wi,
            At,
            In,
            Xn,
            Yt,
            Yn,
            Rn,
            Pi,
            _,
            Tn,
            $i,
            Mr,
            $,
            q,
            Ri,
            ki,
            X,
            ct,
            pn,
            Zt,
            St,
            Un,
            sn,
            8,
            B,
            In,
            xn,
            Ir,
            Ui,
            Di,
            wr,
            Ni,
            j,
            Zi,
            an,
            Li,
            Jt,
            Tr,
            lr,
            Qt,
            pr,
            8,
            Wi,
            In,
            W,
            _t,
            ir,
            Wr,
            fn,
            Pr,
            Un,
            kn,
            ti,
            K,
            B,
            Vn,
            $r,
            Cn,
            Ei,
            wn,
            cn,
            It,
            Gi,
            zr,
            Hn,
            Cr,
            D,
            gr,
            Un,
            br,
            8,
            1,
            ft,
            Fi,
            ki,
            7,
            Ji,
            Mt,
            Ar,
            Dr,
            zt,
            bt,
            Tn,
            Q,
            In,
            Wt,
            Ir,
            mr,
            yr,
            _t,
            Nt,
            yi,
            Ei,
            ht,
            U,
            Hi,
            tn,
            Pr,
            jt,
            mr,
            Or,
            Kn,
            ji,
            ut,
            Kt,
            Qt,
            Oi,
            Sr,
            bn,
            Et,
            En,
            gi,
            Tn,
            Ri,
            Mt,
            Lt,
            ir,
            Qn,
            9,
            ji,
            Gt,
            U,
            jt,
            Si,
            Cn,
            Zt,
            Bn,
            Ui,
            xn,
            Zt,
            jt,
            vt,
            X,
            Ai,
            8,
            li,
            Ti,
            _t,
            Tt,
            pi,
            hi,
            yi,
            gt,
            On,
            wi,
            ar,
            qt,
            9,
            Pn,
            8,
            Ui,
            Bi,
            vi,
            bn,
            Vn,
            xt,
            Mn,
            Wi,
            9,
            Ci,
            Kt,
            x,
            $t,
            wt,
            K,
            L,
            Ct,
            4,
            z,
            Gi,
            Pi,
            At,
            Gi,
            dn,
            xi,
            xi,
            Kn,
            pr,
            wr,
            ui,
            hr,
            Y,
            jr,
            Ft,
            oi,
            Lr,
            Ir,
            vi,
            g,
            xt,
            bi,
            Ii,
            En,
            St,
            H,
            cr,
            dr,
            G,
            Bt,
            ai,
            Sn,
            Di,
            ki,
            at,
            Wr,
            Jt,
            rn,
            Qi,
            gn,
            vt,
            K,
            vr,
            Li,
            ro,
            Ki,
            qi,
            zn,
            En,
            K,
            Rr,
            er,
            ht,
            z,
            Or,
            Lt,
            Ir,
            St,
            wt,
            Dr,
            gi,
            Pr,
            2,
            ro,
            jt,
            ot,
            vr,
            ur,
            Ir,
            4,
            Ur,
            vn,
            x,
            Ti,
            Ri,
            wr,
            Oi,
            vr,
            mn,
            et,
            Pn,
            z,
            pn,
            xr,
            ar,
            Qt,
            mt,
            fi,
            Q,
            pi,
            tn,
            C,
            yn,
            ri,
            bt,
            Gt,
            Kt,
            Wt,
            it,
            D,
            S,
            Ui,
            an,
            W,
            L,
            sn,
            pn,
            Ln,
            B,
            si,
            Vn,
            ro,
            ci,
            Wn,
            ro,
            Et,
            an,
            jr,
            et,
            wt,
            Yr,
            Nt,
            H,
            L,
            K,
            $t,
            Nt,
            yi,
            br,
            Ji,
            Qn,
            $i,
            cn,
            ii,
            Wi,
            pt,
            Bt,
            In,
            Zt,
            yi,
            Ir,
            Et,
            qn,
            pr,
            ai,
            an,
            yn,
            jn,
            vn,
            zn,
            ai,
            rt,
            qi,
            Si,
            Xt,
            ro,
            Ui,
            7,
            Ei,
            j,
            ct,
            qt,
            pt,
            yr,
            qr,
            Rn,
            Wi,
            ei,
            Pt,
            en,
            qn,
            Ci,
            q,
            Gt,
            Rn,
            rn,
            no,
            zi,
            pt,
            Wn,
            Ar,
            li,
            5,
            or,
            ai,
            xr,
            Ki,
            Oi,
            Tt,
            Ln,
            Gi,
            Z,
            Ii,
            dr,
            vn,
            _r,
            dt,
            K,
            Yn,
            Wn,
            si,
            Ji,
            yn,
            Hi,
            6,
            ci,
            tr,
            Ji,
            Hr,
            ft,
            $r,
            _n,
            Hr,
            Wr,
            L,
            Xn,
            3,
            sn,
            mn,
            Zt,
            Lr,
            er,
            en,
            _i,
            Rt,
            ot,
            Ti,
            lt,
            Nn,
            Fn,
            Rr,
            mt,
            U,
            rr,
            bi,
            Gi,
            Nt,
            Oi,
            Hi,
            7,
            Rn,
            zt,
            wt,
            hn,
            Si,
            ni,
            4,
            Qn,
            Ct,
            ci,
            zn,
            Wt,
            ft,
            Zr,
            1,
            Kt,
            gt,
            pi,
            ei,
            j,
            gr,
            Qn,
            di,
            tr,
            un,
            zn,
            zr,
            Er,
            4,
            Z,
            S,
            hr,
            Kt,
            Ri,
            S,
            Jr,
            J,
            Tr,
            Xr,
            gt,
            Ni,
            Xr,
            gt,
            U,
            Wn,
            un,
            Rt,
            Tt,
            Bt,
            Fn,
            8,
            Ot,
            Pn,
            Xr,
            cr,
            Sr,
            Z,
            dt,
            Kr,
            no,
            un,
            Ui,
            Fr,
            vt,
            Bi,
            Or,
            Y,
            Fn,
            Ji,
            Xn,
            yt,
            K,
            Ki,
            Fn,
            ln,
            Wi,
            Ri,
            Yn,
            pt,
            Pi,
            D,
            Yn,
            Rr,
            G,
            R,
            Vr,
            Oi,
            Gt,
            Bi,
            qi,
            Lt,
            Er,
            Hi,
            dt,
            Un,
            R,
            Pt,
            Zt,
            ro,
            J,
            0,
            vr,
            ji,
            Tn,
            _r,
            tt,
            Hn,
            Zi,
            Ft,
            Ct,
            Ri,
            P,
            Fn,
            at,
            Dr,
            Bt,
            ri,
            zn,
            Rt,
            Pr,
            C,
            qi,
            Wi,
            Xr,
            Kr,
            Wn,
            qi,
            fr,
            Ii,
            ft,
            yr,
            xt,
            Mn,
            Ur,
            fr,
            Wi,
            Rt,
            rr,
            xn,
            gt,
            Kn,
            P,
            Pi,
            ct,
            Ri,
            on,
            Q,
            Ri,
            W,
            an,
            xn,
            yn,
            ki,
            xr,
            gr,
            Y,
            pt,
            ji,
            st,
            pn,
            yt,
            Yt,
            yn,
            U,
            Zr,
            lr,
            W,
            tt,
            yn,
            vn,
            qr,
            ei,
            qr,
            6,
            5,
            At,
            Wi,
            Hi,
            nt,
            Tr,
            an,
            tt,
            Kn,
            Ei,
            Ut,
            Fr,
            ei,
            An,
            _r,
            ji,
            li,
            Or,
            gr,
            qi,
            Xn,
            zi,
            Xi,
            Ri,
            Qr,
            Cn,
            Mr,
            Jn,
            8,
            Ln,
            wn,
            W,
            An,
            ir,
            Dn,
            hi,
            ti,
            B,
            D,
            Jt,
            ji,
            or,
            Jn,
            bn,
            St,
            Y,
            Cn,
            On,
            Wr,
            q,
            Yn,
            Wi,
            Or,
            Sr,
            R,
            Zr,
            qi,
            gi,
            Ri,
            Wi,
            gt,
            ji,
            Lt,
            0,
            cn,
            mt,
            3,
            Hn,
            kt,
            U,
            $r,
            yr,
            Ci,
            Pn,
            Hr,
            pn,
            rr,
            pr,
            Or,
            Ct,
            lt,
            Jt,
            En,
            D,
            rt,
            Ht,
            $r,
            Nn,
            ar,
            yn,
            R,
            9,
            rr,
            qi,
            L,
            ui,
            rr,
            Z,
            qt,
            Mn,
            ar,
            6,
            nr,
            Nn,
            On,
            Z,
            Y,
            qi,
            An,
            xr,
            X,
            vn,
            hr,
            St,
            nn,
            gr,
            pr,
            lr,
            cr,
            Cn,
            Yn,
            oi,
            li,
            vi,
            pt,
            qr,
            ui,
            sr,
            jt,
            dn,
            pt,
            W,
            zi,
            wt,
            _,
            U,
            ci,
            Cr,
            In,
            Fi,
            g,
            Qi,
            tn,
            io,
            Ir,
            hr,
            Pi,
            U,
            tn,
            K,
            Hr,
            Et,
            Vn,
            Wt,
            lr,
            Hi,
            si,
            bi,
            et,
            fr,
            Jr,
            ti,
            Wr,
            Cn,
            yn,
            It,
            9,
            ti,
            Ft,
            B,
            fi,
            Wn,
            Qt,
            Lr,
            an,
            G,
            Mn,
            B,
            ht,
            Q,
            dt,
            Y,
            _i,
            xi,
            bn,
            hi,
            en,
            Yi,
            rr,
            wi,
            rr,
            yr,
            Ht,
            Or,
            fi,
            fn,
            Q,
            er,
            Fn,
            Ar,
            ki,
            Lr,
            Oi,
            Gn,
            hn,
            qi,
            un,
            Yn,
            Qi,
            _t,
            Qi,
            Wr,
            Wi,
            yn,
            Lt,
            Wr,
            cr,
            yt,
            9,
            $r,
            Nn,
            Rr,
            P,
            Ri,
            Ht,
            x,
            bt,
            ni,
            Xn,
            hr,
            Y,
            Nt,
            jr,
            Nr,
            zt,
            Or,
            Qi,
            S,
            Sn,
            dt,
            Tr,
            Ai,
            pr,
            Or,
            Wi,
            Y,
            Yi,
            Fn,
            mr,
            xi,
            Fi,
            ro,
            Gr,
            Nr,
            Xn,
            ir,
            lt,
            Pi,
            3,
            6,
            Nr,
            g,
            tr,
            mt,
            Kn,
            jn,
            Ft,
            vr,
            xr,
            Ri,
            Z,
            Fn,
            Ri,
            fr,
            zn,
            Sn,
            kr,
            _r,
            di,
            Y,
            Cn,
            Rn,
            ln,
            Y,
            vi,
            $r,
            di,
            _t,
            Ti,
            mn,
            oi,
            Gi,
            hi,
            _,
            Vi,
            ir,
            ft,
            Bi,
            Ir,
            Vr,
            dn,
            At,
            q,
            Si,
            Xr,
            Mn,
            ai,
            Rt,
            $t,
            wt,
            hn,
            pi,
            Gi,
            Qn,
            Kt,
            ar,
            tt,
            Tr,
            Kn,
            ro,
            it,
            Fr,
            _r,
            Mi,
            hi,
            K,
            ct,
            U,
            lr,
            X,
            6,
            9,
            On,
            On,
            _t,
            ti,
            Mi,
            8,
            Ar,
            At,
            wi,
            Zt,
            Mt,
            zn,
            io,
            Ln,
            Gi,
            C,
            bt,
            ft,
            dt,
            Zn,
            X,
            at,
            H,
            V,
            vr,
            6,
            ut,
            Yr,
            Er,
            _t,
            Zt,
            vi,
            Q,
            In,
            4,
            D,
            dn,
            Tr,
            kr,
            it,
            dr,
            Zi,
            fn,
            Rn,
            gi,
            H,
            Li,
            bn,
            3,
            si,
            ti,
            8,
            en,
            Qr,
            q,
            lr,
            Fi,
            ni,
            7,
            Tr,
            0,
            tt,
            En,
            fn,
            Fn,
            ui,
            Wt,
            jt,
            Ir,
            Mi,
            Xt,
            Qn,
            li,
            ft,
            Vn,
            k,
            ii,
            U,
            Ot,
            mi,
            St,
            ut,
            br,
            Br,
            $,
            Ui,
            xt,
            Pt,
            ti,
            Wn,
            ji,
            Ut,
            Wr,
            Yi,
            sr,
            xi,
            _,
            bt,
            Wt,
            xi,
            zr,
            di,
            Wn,
            un,
            Tr,
            Nn,
            at,
            Wn,
            Qn,
            g,
            an,
            Hi,
            on,
            Ir,
            or,
            Mr,
            I,
            H,
            I,
            Mn,
            Un,
            ct,
            cr,
            In,
            Fr,
            nn,
            un,
            q,
            Ot,
            En,
            Tt,
            3,
            fn,
            si,
            ln,
            er,
            jn,
            ui,
            St,
            P,
            L,
            ln,
            Mi,
            Ji,
            jt,
            Vi,
            xi,
            ht,
            Qn,
            wn,
            Y,
            L,
            It,
            an,
            Qr,
            Un,
            er,
            Un,
            si,
            Fr,
            gi,
            Ei,
            Si,
            Et,
            bi,
            sn,
            L,
            Hn,
            qr,
            zn,
            Gi,
            Hr,
            Ai,
            Yn,
            W,
            ei,
            q,
            Sr,
            Fn,
            jr,
            an,
            Wr,
            an,
            In,
            Y,
            Ii,
            Rt,
            Fn,
            Lt,
            hn,
            Yr,
            tn,
            Ui,
            Qn,
            Hn,
            1,
            ui,
            Li,
            Yr,
            no,
            Kt,
            ci,
            Xr,
            Vr,
            rt,
            P,
            tt,
            Dr,
            B,
            Bi,
            Xi,
            tn,
            Er,
            Cn,
            ot,
            nn,
            I,
            dn,
            Ni,
            Rn,
            kr,
            yt,
            dr,
            R,
            Et,
            xt,
            3,
            hn,
            Kt,
            0,
            rr,
            j,
            yi,
            ro,
            bt,
            C,
            ht,
            vi,
            at,
            B,
            Mr,
            Vi,
            li,
            Ii,
            D,
            Er,
            jt,
            Oi,
            io,
            D,
            Z,
            Ut,
            Wi,
            Nr,
            G,
            kn,
            Ni,
            pr,
            Fn,
            et,
            Qi,
            ji,
            ii,
            P,
            io,
            rn,
            K,
            ni,
            dt,
            Ci,
            R,
            Kn,
            pr,
            Or,
            ft,
            Fr,
            ki,
            Jn,
            kn,
            xt,
            qi,
            wn,
            Zi,
            si,
            Et,
            Fn,
            vn,
            U,
            en,
            Vt,
            gr,
            0,
            Zr,
            Wn,
            0,
            Zr,
            Ir,
            kr,
            et,
            $n,
            $t,
            Ir,
            hn,
            kn,
            Lt,
            qn,
            Zi,
            $r,
            Oi,
            Pt,
            Fr,
            on,
            W,
            jt,
            _t,
            yr,
            pn,
            ci,
            Yt,
            q,
            rr,
            Nr,
            ji,
            Bi,
            W,
            pn,
            g,
            Y,
            oi,
            Dn,
            Ki,
            yt,
            yr,
            ht,
            zt,
            hr,
            Ki,
            Tr,
            mi,
            It,
            it,
            Qt,
            Xt,
            tr,
            nr,
            fr,
            Gn,
            no,
            qn,
            un,
            W,
            ri,
            L,
            qr,
            Nr,
            tn,
            Fi,
            ro,
            pt,
            Er,
            Ei,
            ti,
            Rr,
            B,
            Ji,
            Ln,
            Xi,
            ii,
            Or,
            Et,
            Zi,
            g,
            fr,
            Cn,
            cn,
            X,
            Vn,
            ct,
            Ji,
            jn,
            Ht,
            Bt,
            0,
            si,
            zi,
            lr,
            fr,
            7,
            Pt,
            Ar,
            ft,
            ii,
            an,
            Br,
            Li,
            no,
            si,
            ht,
            Wi,
            jn,
            Ai,
            Rr,
            Xr,
            dr,
            Ni,
            Gt,
            bn,
            Wi,
            Ki,
            X,
            L,
            Nr,
            Lt,
            mi,
            at,
            Ai,
            Wi,
            mr,
            xt,
            yr,
            Gt,
            Tn,
            Tr,
            jr,
            Tr,
            An,
            $,
            di,
            Dn,
            an,
            $r,
            ni,
            si,
            hn,
            mr,
            An,
            hi,
            wt,
            C,
            yr,
            an,
            Sr,
            yi,
            Ci,
            Kt,
            Wi,
            ro,
            rr,
            Di,
            Un,
            fi,
            rt,
            j,
            rn,
            fr,
            Y,
            Hr,
            si,
            Qi,
            hr,
            Zr,
            nr,
            an,
            ct,
            qi,
            Fn,
            $r,
            Nr,
            it,
            V,
            8,
            ht,
            Ci,
            Hi,
            Vi,
            _n,
            or,
            yn,
            En,
            dt,
            Zt,
            z,
            an,
            Rn,
            jn,
            vn,
            qr,
            xr,
            Hi,
            it,
            K,
            H,
            it,
            vi,
            tt,
            Jr,
            yn,
            ut,
            K,
            Di,
            Ji,
            Yn,
            Zn,
            at,
            Ri,
            Jr,
            si,
            nr,
            rt,
            cr,
            at,
            Tn,
            2,
            4,
            Bt,
            ro,
            nr,
            Ur,
            U,
            Qn,
            K,
            ct,
            Q,
            tn,
            bt,
            wt,
            bt,
            Nr,
            dn,
            Qi,
            Ji,
            xi,
            tt,
            ji,
            ci,
            ar,
            si,
            B,
            $n,
            Q,
            mi,
            ct,
            Dr,
            0,
            Hr,
            li,
            Si,
            R,
            rr,
            en,
            On,
            Lt,
            _r,
            Oi,
            Vn,
            Mi,
            On,
            Br,
            St,
            Yn,
            U,
            on,
            Jt,
            Ar,
            qr,
            Bi,
            yi,
            q,
            ti,
            jr,
            W,
            Ur,
            vn,
            qt,
            An,
            rr,
            vn,
            fn,
            Zr,
            D,
            ki,
            xr,
            Qr,
            It,
            Si,
            hi,
            ut,
            kn,
            Jt,
            io,
            dr,
            dn,
            fr,
            Yi,
            _t,
            Ft,
            ro,
            Hr,
            Si,
            lt,
            Ki,
            Q,
            jt,
            ft,
            en,
            oi,
            or,
            mn,
            Hi,
            Fn,
            Fi,
            T,
            Dt,
            Kn,
            dr,
            Si,
            z,
            Di,
            Ki,
            Or,
            Yn,
            yi,
            ui,
            Wr,
            q,
            Ri,
            Hi,
            Hn,
            Jt,
            Qt,
            Ot,
            j,
            Di,
            dr,
            Ft,
            Ni,
            Xi,
            mt,
            jr,
            Kt,
            Hi,
            Vr,
            Vr,
            dn,
            ct,
            _r,
            Mr,
            dr,
            xi,
            Nr,
            pt,
            kt,
            Pt,
            H,
            un,
            G,
            q,
            lr,
            X,
            Y,
            ii,
            wn,
            xr,
            k,
            Ii,
            fi,
            T,
            nt,
            on,
            Xn,
            Pi,
            z,
            qi,
            xr,
            Mn,
            Xn,
            D,
            Ji,
            ur,
            K,
            vt,
            Ar,
            Hn,
            Wi,
            X,
            4,
            Rr,
            Z,
            qr,
            rt,
            pr,
            C,
            8,
            gi,
            An,
            g,
            vn,
            gi,
            ur,
            Lr,
            hn,
            Jt,
            vn,
            Yi,
            Wn,
            L,
            Lr,
            ui,
            gi,
            ki,
            Vt,
            Vi,
            nt,
            1,
            pt,
            3,
            li,
            3,
            Ur,
            pi,
            L,
            rt,
            Gn,
            K,
            kr,
            si,
            gr,
            Vr,
            Dn,
            Zn,
            st,
            Zn,
            zn,
            ir,
            kr,
            Bi,
            X,
            On,
            rr,
            Fr,
            ro,
            zt,
            I,
            ki,
            J,
            ji,
            _,
            4,
            Gt,
            U,
            6,
            8,
            J,
            li,
            Zi,
            Qt,
            Ir,
            En,
            Hi,
            Lr,
            Bn,
            pn,
            vr,
            Ui,
            Zr,
            hi,
            zi,
            7,
            Pr,
            V,
            zi,
            7,
            Vn,
            ar,
            qr,
            ui,
            Qn,
            Rn,
            _r,
            Nt,
            xt,
            un,
            3,
            Cn,
            R,
            R,
            Ti,
            hr,
            X,
            It,
            Gt,
            hr,
            4,
            Mi,
            Ft,
            qi,
            st,
            ht,
            hn,
            hn,
            3,
            ln,
            dt,
            oi,
            at,
            xt,
            Oi,
            z,
            Q,
            Ar,
            Dt,
            qi,
            Pn,
            gi,
            0,
            er,
            ro,
            Ti,
            jt,
            Wt,
            Tn,
            Pn,
            qr,
            Xi,
            at,
            Ht,
            ir,
            Dr,
            Vn,
            bn,
            Yt,
            En,
            Pr,
            ar,
            mn,
            Er,
            Hi,
            Yn,
            1,
            $t,
            Cr,
            Jr,
            I,
            or,
            Ci,
            Ki,
            yt,
            K,
            Jt,
            Li,
            Ht,
            en,
            0,
            Sn,
            4,
            J,
            Sr,
            Vt,
            st,
            $n,
            Si,
            fr,
            $n,
            g,
            ri,
            at,
            Ht,
            Y,
            ut,
            k,
            On,
            Wt,
            mr,
            zt,
            Wn,
            1,
            nr,
            K,
            $t,
            Xr,
            qt,
            Mn,
            sn,
            3,
            Ii,
            Bt,
            ct,
            Et,
            vi,
            ro,
            3,
            Zn,
            Mn,
            Pi,
            rr,
            mr,
            Kn,
            kt,
            xt,
            Ji,
            sr,
            Fr,
            St,
            qi,
            ci,
            Pi,
            zt,
            er,
            kt,
            wr,
            Nt,
            Jr,
            zr,
            wt,
            Ur,
            P,
            qt,
            rr,
            jn,
            un,
            on,
            zi,
            gn,
            wr,
            xn,
            ui,
            Sn,
            Br,
            yi,
            hi,
            lt,
            vi,
            Si,
            Yt,
            Ct,
            yt,
            vt,
            Vt,
            gn,
            vr,
            Kt,
            $,
            Ot,
            $r,
            6,
            Yi,
            Ht,
            It,
            gn,
            Mn,
            On,
            1,
            Sn,
            si,
            Zt,
            1,
            no,
            Xi,
            mr,
            it,
            $r,
            Er,
            ri,
            L,
            br,
            qi,
            Ii,
            Ln,
            Kr,
            pt,
            gi,
            ii,
            hn,
            $n,
            Ui,
            Ki,
            ro,
            Ei,
            Nr,
            rt,
            Qr,
            zi,
            Yr,
            nn,
            Ft,
            Rn,
            ot,
            Qi,
            qr,
            Kn,
            Ft,
            Mi,
            zi,
            pr,
            ji,
            Fr,
            qr,
            Dt,
            Gt,
            Ni,
            Ei,
            On,
            Pn,
            Yr,
            st,
            Zt,
            Br,
            Pt,
            Wi,
            li,
            Xi,
            Zi,
            6,
            Di,
            Br,
            On,
            q,
            xi,
            $r,
            gt,
            rr,
            rt,
            zi,
            Lt,
            ni,
            H,
            ut,
            Ur,
            Vi,
            Ui,
            Y,
            U,
            k,
            gi,
            xt,
            H,
            kt,
            jt,
            ur,
            rt,
            an,
            vn,
            Ht,
            ii,
            Dt,
            Gt,
            Jt,
            wt,
            it,
            0,
            li,
            Zt,
            tt,
            ei,
            W,
            ui,
            En,
            B,
            ki,
            kt,
            W,
            xi,
            Oi,
            Vn,
            In,
            H,
            ln,
            Si,
            R,
            ir,
            io,
            Ui,
            S,
            ii,
            Y,
            T,
            Dn,
            Nr,
            un,
            qi,
            Pi,
            yt,
            or,
            Bi,
            U,
            mt,
            Ar,
            Di,
            J,
            si,
            9,
            Lr,
            xi,
            cn,
            Vr,
            Cr,
            qn,
            jr,
            ut,
            Qt,
            Mi,
            $,
            tn,
            Di,
            Fr,
            bn,
            Rr,
            z,
            ai,
            lr,
            Fi,
            ii,
            Di,
            Lr,
            si,
            ri,
            Gr,
            ji,
            li,
            Oi,
            P,
            In,
            vt,
            X,
            pi,
            Bt,
            Rt,
            Hn,
            Un,
            Ai,
            Ct,
            X,
            I,
            yn,
            Dn,
            St,
            I,
            jr,
            ii,
            J,
            Y,
            Mn,
            Xn,
            9,
            Et,
            an,
            $t,
            ai,
            Sn,
            It,
            sr,
            Er,
            mt,
            ki,
            ei,
            Oi,
            ci,
            Ji,
            R,
            dn,
            ht,
            ti,
            An,
            gi,
            qt,
            8,
            fr,
            _,
            li,
            K,
            tr,
            Sr,
            Xn,
            Yt,
            lr,
            Kn,
            Et,
            Zt,
            rr,
            mt,
            $,
            Ct,
            er,
            wi,
            yi,
            I,
            Wt,
            sr,
            Tr,
            vn,
            tt,
            lr,
            2,
            kn,
            Jn,
            fn,
            Jr,
            Y,
            at,
            xr,
            Vt,
            si,
            bi,
            Yn,
            gn,
            zn,
            4,
            Qt,
            Yr,
            Sn,
            z,
            ni,
            In,
            Ri,
            Q,
            wt,
            Ot,
            5,
            Y,
            Fn,
            Zt,
            $r,
            kn,
            pt,
            Hi,
            Hn,
            ci,
            jt,
            yt,
            Pt,
            jn,
            pn,
            gr,
            ni,
            Or,
            Tn,
            jn,
            rn,
            ji,
            Nt,
            pr,
            8,
            hi,
            ot,
            Zr,
            dt,
            Dr,
            Qi,
            z,
            Sr,
            Wi,
            $,
            Wn,
            At,
            Qr,
            tt,
            Mt,
            Hi,
            qt,
            Ui,
            pr,
            Fr,
            si,
            St,
            sr,
            vi,
            dt,
            mi,
            Zt,
            Gn,
            Di,
            Qt,
            Gr,
            Hn,
            Di,
            _n,
            ar,
            tr,
            2,
            j,
            D,
            Cr,
            Zt,
            dn,
            Wn,
            Qr,
            si,
            nr,
            ti,
            jr,
            Qi,
            ii,
            pn,
            Fr,
            tr,
            ot,
            Xt,
            Yi,
            Wi,
            jn,
            tr,
            zi,
            qi,
            bi,
            P,
            gr,
            Wn,
            En,
            Ot,
            Dt,
            xi,
            Vi,
            xt,
            ct,
            dn,
            an,
            Ii,
            _t,
            Br,
            At,
            Ci,
            Pi,
            _r,
            Pr,
            Y,
            Ei,
            ur,
            Mn,
            Br,
            Fn,
            wt,
            On,
            pt,
            pt,
            Wr,
            j,
            On,
            Mr,
            Qn,
            Rr,
            D,
            fi,
            qi,
            Ii,
            Ti,
            st,
            4,
            di,
            en,
            2,
            Tn,
            T,
            Ln,
            Qn,
            Ct,
            no,
            X,
            zt,
            Zn,
            q,
            xn,
            U,
            Bn,
            ut,
            Tr,
            ur,
            It,
            0,
            wi,
            Bi,
            ri,
            wt,
            _n,
            R,
            Bt,
            Qi,
            Yn,
            zi,
            Xr,
            k,
            dt,
            vi,
            xr,
            x,
            fn,
            q,
            Zr,
            Lt,
            k,
            Rt,
            wr,
            Ot,
            J,
            Gr,
            At,
            V,
            Hn,
            Ar,
            wt,
            Ln,
            4,
            jn,
            $t,
            tn,
            dt,
            ti,
            Q,
            st,
            on,
            Zi,
            nn,
            Or,
            zr,
            ln,
            K,
            x,
            q,
            ro,
            xi,
            j,
            Cn,
            ft,
            Ot,
            Yt,
            Xt,
            Xn,
            gn,
            $n,
            Ei,
            si,
            2,
            ui,
            Ur,
            5,
            Ot,
            er,
            fn,
            nr,
            $r,
            ii,
            hn,
            H,
            2,
            Nr,
            Ct,
            Kn,
            Cr,
            zr,
            di,
            q,
            ti,
            ji,
            zr,
            wt,
            Dr,
            Ht,
            Jt,
            fr,
            pn,
            lt,
            di,
            Ti,
            Fr,
            H,
            _n,
            Et,
            Lt,
            Nr,
            Pi,
            Wi,
            ot,
            zr,
            Xt,
            Mn,
            Ni,
            Mi,
            Tn,
            wt,
            gr,
            St,
            Tn,
            yt,
            Sr,
            At,
            Ti,
            6,
            Vr,
            B,
            ri,
            Cn,
            xt,
            R,
            yn,
            yt,
            An,
            K,
            Y,
            It,
            $,
            Ki,
            dr,
            xi,
            Kn,
            _n,
            _t,
            Ar,
            lt,
            di,
            ar,
            Pr,
            Er,
            ri,
            xi,
            Yt,
            j,
            rr,
            qn,
            ct,
            en,
            io,
            Ei,
            ct,
            zt,
            Br,
            ln,
            Vn,
            at,
            Dt,
            ai,
            R,
            On,
            Wi,
            fn,
            bn,
            7,
            Rr,
            Nr,
            Bn,
            8,
            ui,
            vi,
            B,
            Rt,
            Tr,
            Er,
            xt,
            Ct,
            xn,
            Hn,
            $,
            _n,
            _r,
            Kn,
            Dn,
            Dr,
            vn,
            en,
            cn,
            z,
            Kn,
            zn,
            nn,
            Vr,
            _r,
            Or,
            k,
            U,
            1,
            Xt,
            I,
            dt,
            Ei,
            8,
            nr,
            Qi,
            Cr,
            or,
            $n,
            Bn,
            5,
            On,
            ar,
            bi,
            P,
            st,
            ro,
            $t,
            Wi,
            $r,
            Ur,
            nr,
            dt,
            fr,
            wi,
            Pi,
            ii,
            Ln,
            Lr,
            kt,
            pi,
            $n,
            $n,
            ii,
            Ni,
            ot,
            j,
            yt,
            ai,
            Wn,
            bt,
            it,
            Ci,
            Tr,
            V,
            2,
            jn,
            Zr,
            ji,
            Un,
            kn,
            Ui,
            _r,
            Ot,
            Pn,
            Zi,
            Wr,
            pr,
            Fn,
            ut,
            X,
            rt,
            ot,
            ci,
            Q,
            Di,
            mr,
            Tn,
            Nt,
            kn,
            Xi,
            Z,
            Xn,
            g,
            _i,
            ui,
            Nt,
            jr,
            W,
            ri,
            Kr,
            Ar,
            x,
            rt,
            br,
            jt,
            Fr,
            Ti,
            Hi,
            Kt,
            Mn,
            oi,
            ui,
            Kr,
            Fn,
            bi,
            q,
            On,
            ei,
            dr,
            fi,
            Nr,
            Ei,
            D,
            yi,
            yi,
            Nt,
            2,
            G,
            Mn,
            Yt,
            T,
            rr,
            Mi,
            St,
            hn,
            ji,
            Fr,
            Tr,
            Un,
            3,
            zn,
            or,
            Q,
            Vi,
            Rt,
            yr,
            pr,
            Ji,
            ci,
            Rt,
            oi,
            X,
            Rn,
            _r,
            zr,
            Kr,
            Rr,
            Nt,
            Or,
            Ji,
            Hi,
            yi,
            dr,
            Mi,
            ti,
            _n,
            _r,
            Qn,
            bn,
            Et,
            an,
            at,
            Ri,
            yt,
            Mn,
            B,
            P,
            Gn,
            ot,
            pr,
            Rt,
            gi,
            Cr,
            Ur,
            jn,
            Ir,
            Ir,
            Br,
            Cr,
            tr,
            Tt,
            ci,
            Q,
            at,
            q,
            Fi,
            Qt,
            kt,
            Xr,
            Nr,
            Yn,
            Lt,
            en,
            ro,
            rr,
            xr,
            Vn,
            Dn,
            It,
            rt,
            Bt,
            Fr,
            Ni,
            ei,
            $n,
            $i,
            Dr,
            Wi,
            Xi,
            En,
            Ln,
            Hn,
            wr,
            9,
            jr,
            $t,
            fn,
            Xr,
            T,
            0,
            Cr,
            Mr,
            Ui,
            Er,
            X,
            Ji,
            Yn,
            T,
            Ki,
            Ar,
            bt,
            Vt,
            tr,
            ot,
            U,
            q,
            yi,
            Gt,
            U,
            vi,
            ei,
            Yt,
            Xn,
            I,
            ur,
            vt,
            7,
            mn,
            H,
            nn,
            mi,
            sn,
            sn,
            un,
            On,
            Rn,
            en,
            Qt,
            Xi,
            I,
            mi,
            ni,
            cr,
            7,
            Qr,
            pr,
            Q,
            ct,
            kt,
            Q,
            Nt,
            Vt,
            Ii,
            Lt,
            bi,
            In,
            ar,
            Ut,
            Nt,
            Y,
            Fi,
            Ur,
            Ki,
            Yn,
            hn,
            rn,
            ur,
            xr,
            An,
            Ji,
            en,
            Yt,
            Hi,
            0,
            Dr,
            Rt,
            Fr,
            Ht,
            Gr,
            I,
            Ct,
            Qr,
            ai,
            Rn,
            Dt,
            Mt,
            K,
            Vi,
            Nt,
            1,
            hr,
            X,
            j,
            an,
            $r,
            Yn,
            nn,
            Li,
            Di,
            P,
            J,
            dr,
            $t,
            fi,
            qi,
            Wr,
            S,
            qn,
            x,
            ii,
            _i,
            hr,
            un,
            si,
            V,
            H,
            An,
            D,
            1,
            Cr,
            qr,
            _i,
            Jr,
            P,
            vr,
            wi,
            Di,
            cr,
            K,
            ci,
            rr,
            Yr,
            sr,
            er,
            R,
            ar,
            jn,
            Di,
            Ei,
            Yn,
            Jn,
            Oi,
            Ki,
            yn,
            er,
            bi,
            Ki,
            it,
            zt,
            dt,
            ei,
            G,
            Di,
            Zt,
            Mi,
            ft,
            Ai,
            ri,
            dr,
            ri,
            Ct,
            g,
            sn,
            Rr,
            ki,
            Fi,
            Pr,
            di,
            at,
            Xi,
            gr,
            gr,
            mi,
            Jr,
            fi,
            Qi,
            6,
            Vn,
            xt,
            Gn,
            Y,
            Ft,
            In,
            li,
            gi,
            Ci,
            Dt,
            fi,
            Zr,
            xi,
            Gi,
            br,
            ci,
            It,
            Ct,
            Fi,
            yr,
            hn,
            Lt,
            In,
            Ai,
            ii,
            xr,
            yn,
            ir,
            li,
            Nn,
            9,
            8,
            qi,
            At,
            lt,
            ht,
            Xr,
            Z,
            Or,
            Ci,
            Zr,
            $i,
            nn,
            Lr,
            fr,
            X,
            Lt,
            7,
            jn,
            yi,
            R,
            vt,
            Ri,
            K,
            Gr,
            Ur,
            P,
            Xt,
            Tr,
            Ki,
            Ft,
            fr,
            Or,
            4,
            Ri,
            Ni,
            Rt,
            C,
            Lr,
            Dt,
            In,
            _,
            gn,
            xt,
            Wi,
            ni,
            nn,
            Jn,
            In,
            T,
            7,
            qn,
            Kr,
            Kt,
            dt,
            Ht,
            Cn,
            hn,
            en,
            pr,
            1,
            ni,
            Or,
            Xr,
            Gi,
            yn,
            Zr,
            L,
            S,
            br,
            an,
            Kn,
            jn,
            zn,
            Si,
            ct,
            sn,
            un,
            dt,
            Qi,
            Ki,
            vn,
            _i,
            gi,
            jn,
            gr,
            Qn,
            Qt,
            bi,
            ci,
            Hi,
            xi,
            yr,
            yr,
            Ft,
            rr,
            wi,
            j,
            ci,
            Jn,
            si,
            Rr,
            9,
            kt,
            7,
            Tn,
            Ni,
            Si,
            Xn,
            $i,
            Jt,
            wt,
            vn,
            x,
            yt,
            Ji,
            ur,
            U,
            qr,
            wt,
            wi,
            x,
            gt,
            At,
            Ni,
            vt,
            Fr,
            Fi,
            yt,
            oi,
            Sn,
            K,
            en,
            at,
            xt,
            6,
            Ji,
            rn,
            tn,
            Qt,
            P,
            Fi,
            Mn,
            mn,
            Un,
            Gi,
            ht,
            gi,
            k,
            gr,
            Pt,
            _n,
            mi,
            $,
            en,
            hi,
            Yr,
            _,
            5,
            ui,
            ni,
            Z,
            C,
            dr,
            En,
            at,
            et,
            jn,
            Wt,
            Vt,
            Bn,
            Sn,
            Qr,
            qi,
            nt,
            Un,
            si,
            bt,
            ii,
            Ci,
            vt,
            ir,
            Zi,
            ct,
            pi,
            Ai,
            Gr,
            Wi,
            Zn,
            At,
            Kr,
            vn,
            On,
            si,
            Wi,
            _i,
            U,
            Qr,
            It,
            It,
            Ft,
            Rt,
            Sr,
            Hr,
            3,
            Vi,
            xn,
            Hr,
            li,
            Rn,
            $r,
            Qr,
            1,
            It,
            St,
            It,
            Or,
            Wt,
            ji,
            Cr,
            nr,
            Yn,
            g,
            $,
            tn,
            Cr,
            Bn,
            Dr,
            D,
            bn,
            X,
            Rn,
            Qr,
            ot,
            Ur,
            bn,
            io,
            hn,
            fr,
            Ui,
            gi,
            bn,
            Tn,
            Xn,
            Yt,
            Gt,
            li,
            Bn,
            Yr,
            gi,
            Ti,
            Yr,
            Pn,
            Sr,
            Fn,
            _i,
            Wr,
            Yr,
            ei,
            g,
            Ji,
            Di,
            bt,
            wi,
            S,
            Qn,
            Y,
            kr,
            Qn,
            Jn,
            Kn,
            qi,
            gi,
            Ir,
            Cr,
            ft,
            qr,
            wn,
            zi,
            R,
            _n,
            kr,
            mr,
            Ct,
            q,
            fn,
            Zn,
            Hi,
            un,
            S,
            hr,
            gi,
            Si,
            K,
            $r,
            yn,
            Ei,
            At,
            Pt,
            ln,
            1,
            di,
            B,
            io,
            Kt,
            T,
            Bi,
            ir,
            wt,
            Yt,
            gn,
            Wn,
            Nr,
            2,
            Xi,
            2,
            On,
            Vn,
            wt,
            yt,
            ar,
            Zt,
            Ki,
            hi,
            Nn,
            Xn,
            Mi,
            Bt,
            I,
            Jt,
            Ut,
            Dn,
            wn,
            Ln,
            R,
            $r,
            Xn,
            Bn,
            dr,
            Gt,
            ui,
            Yt,
            Br,
            ht,
            _t,
            Dn,
            B,
            Mn,
            lt,
            Ht,
            di,
            xi,
            Ii,
            Lt,
            jn,
            yn,
            er,
            Wr,
            Mn,
            ln,
            gi,
            Yr,
            Fn,
            rt,
            St,
            Zt,
            G,
            Pn,
            Bi,
            mn,
            Rn,
            Or,
            J,
            Yi,
            Li,
            Cn,
            Yn,
            Di,
            no,
            Bn,
            nr,
            gi,
            Pr,
            fn,
            en,
            Yr,
            Mn,
            Pt,
            ji,
            Pi,
            2,
            wr,
            D,
            Mi,
            ot,
            rr,
            Mr,
            kn,
            zt,
            or,
            Vn,
            At,
            Cr,
            Jn,
            Un,
            rt,
            Vn,
            3,
            Ei,
            un,
            lt,
            Vt,
            An,
            Ar,
            an,
            9,
            Ur,
            Ir,
            rr,
            bn,
            Pn,
            Vt,
            gi,
            br,
            jt,
            kr,
            pr,
            7,
            Ri,
            Bt,
            Xt,
            tt,
            bi,
            fr,
            xn,
            Vt,
            zi,
            bn,
            Pt,
            ir,
            Ni,
            ft,
            wr,
            pn,
            Q,
            Li,
            Fi,
            Hn,
            Bn,
            wi,
            Br,
            Rn,
            on,
            Wt,
            ii,
            Sr,
            Ei,
            ki,
            no,
            Zn,
            _n,
            ln,
            Ot,
            ft,
            Zr,
            ci,
            _r,
            Ur,
            Zr,
            ar,
            rt,
            cn,
            lt,
            Br,
            Wt,
            Nn,
            Wt,
            vt,
            G,
            et,
            Sn,
            Ir,
            Zi,
            no,
            yn,
            8,
            g,
            Ti,
            sr,
            yn,
            Wi,
            ai,
            ar,
            $n,
            J,
            Yt,
            vt,
            Wt,
            2,
            Bt,
            Vt,
            $i,
            Ht,
            Zi,
            Wr,
            an,
            wt,
            rn,
            Ei,
            dt,
            un,
            D,
            Ir,
            Mr,
            wn,
            ri,
            $,
            xn,
            or,
            6,
            gr,
            Xn,
            q,
            It,
            or,
            wr,
            Jt,
            Pt,
            nn,
            yn,
            io,
            g,
            _n,
            gi,
            An,
            bt,
            Ii,
            yr,
            li,
            Ot,
            zr,
            R,
            en,
            Tr,
            Er,
            rn,
            Ti,
            sr,
            Hr,
            Lr,
            _n,
            vr,
            Ni,
            Li,
            yt,
            Rn,
            j,
            ir,
            g,
            Kn,
            3,
            Ut,
            P,
            un,
            8,
            Er,
            D,
            _,
            Xr,
            vi,
            vr,
            Ot,
            Wi,
            vn,
            Wn,
            j,
            H,
            Ot,
            Wt,
            Mi,
            $i,
            Ci,
            At,
            Yr,
            Vt,
            ii,
            tn,
            7,
            Xr,
            qi,
            Hn,
            X,
            Si,
            Br,
            9,
            7,
            Pt,
            it,
            fr,
            _,
            Oi,
            1,
            Wr,
            Un,
            cr,
            an,
            Wi,
            Gn,
            Y,
            cr,
            Tn,
            ki,
            pn,
            vt,
            pr,
            Fn,
            Qr,
            $r,
            R,
            rn,
            q,
            ii,
            Sr,
            vi,
            Hn,
            z,
            ln,
            Sn,
            Dn,
            Hi,
            dt,
            jt,
            Kr,
            Wr,
            cn,
            Ei,
            Mi,
            Jt,
            oi,
            yr,
            dt,
            mn,
            nr,
            Yn,
            ai,
            Ht,
            Ar,
            Ut,
            ui,
            yn,
            Yn,
            Ai,
            Qt,
            Ln,
            ni,
            kr,
            ji,
            it,
            Xn,
            ir,
            yr,
            Gi,
            Mt,
            9,
            gi,
            Vn,
            Ei,
            qi,
            Sr,
            rr,
            $r,
            Ri,
            Hn,
            Lt,
            ir,
            nr,
            P,
            q,
            Q,
            Bn,
            hi,
            z,
            Ei,
            vn,
            di,
            ct,
            ar,
            pi,
            pi,
            ei,
            Di,
            Dt,
            ir,
            rr,
            tn,
            at,
            0,
            gt,
            Dn,
            vn,
            Er,
            H,
            5,
            an,
            Rt,
            _r,
            8,
            $r,
            U,
            Cr,
            B,
            Si,
            mt,
            qi,
            Ht,
            Li,
            tn,
            Vt,
            pi,
            Vr,
            Yi,
            $i,
            U,
            Qr,
            Vr,
            j,
            Tr,
            no,
            ar,
            Kt,
            dr,
            pi,
            Kr,
            St,
            4,
            ot,
            Yr,
            sn,
            xn,
            j,
            $,
            Wr,
            Xn,
            Kn,
            mi,
            bt,
            5,
            Ut,
            Ut,
            Yr,
            An,
            ln,
            Xr,
            qt,
            Wt,
            Mn,
            4,
            mi,
            fr,
            Tn,
            Hr,
            sn,
            Or,
            Wi,
            Fn,
            qt,
            wr,
            lr,
            kt,
            Ei,
            bn,
            zn,
            Jn,
            kr,
            Cr,
            Ji,
            G,
            Gt,
            Tr,
            mt,
            ei,
            ln,
            Er,
            io,
            xi,
            Ai,
            hn,
            hi,
            1,
            Xt,
            Et,
            Qi,
            X,
            bi,
            S,
            et,
            lr,
            zr,
            cn,
            Tt,
            K,
            Zi,
            dt,
            j,
            Zt,
            Yt,
            et,
            nn,
            Cn,
            Rr,
            en,
            lt,
            Oi,
            pi,
            Or,
            Gt,
            j,
            vi,
            q,
            P,
            zi,
            lt,
            an,
            Zn,
            gn,
            fn,
            Tt,
            Wn,
            Xt,
            X,
            Ut,
            bt,
            Vi,
            $,
            ri,
            Z,
            Cn,
            Mi,
            g,
            Sn,
            vn,
            Ti,
            L,
            pi,
            Qi,
            Yt,
            L,
            ti,
            k,
            sr,
            J,
            Xr,
            Hi,
            Lr,
            ro,
            or,
            Ot,
            mn,
            Ot,
            Xr,
            Mt,
            T,
            ai,
            bn,
            Tn,
            5,
            H,
            ro,
            Mr,
            Y,
            Qt,
            pi,
            Vt,
            bn,
            zi,
            Un,
            It,
            Sn,
            tn,
            S,
            Ii,
            lr,
            R,
            yr,
            Zt,
            at,
            li,
            Mi,
            st,
            Un,
            Ot,
            ct,
            7,
            zi,
            kr,
            xi,
            et,
            cr,
            Bi,
            0,
            Lr,
            ti,
            Ut,
            qr,
            Mi,
            $t,
            z,
            et,
            gt,
            Ut,
            S,
            vt,
            cr,
            Un,
            It,
            Ui,
            J,
            xt,
            Or,
            Ft,
            Mt,
            Kn,
            Zn,
            P,
            Xr,
            _i,
            kn,
            U,
            en,
            ai,
            z,
            Cn,
            Q,
            un,
            Or,
            ln,
            Xt,
            0,
            Vr,
            Nr,
            Ri,
            Ot,
            ct,
            Ti,
            x,
            Ri,
            Nt,
            $r,
            Ei,
            Gt,
            Nt,
            kr,
            ji,
            Qn,
            _i,
            ct,
            er,
            vn,
            ii,
            fn,
            hr,
            bn,
            mt,
            Sr,
            Vt,
            ai,
            vn,
            rn,
            Wt,
            vt,
            S,
            In,
            Vt,
            Ot,
            dn,
            rt,
            St,
            Kn,
            gn,
            Zn,
            Ui,
            ir,
            Ki,
            yn,
            x,
            Qt,
            Jr,
            _t,
            Di,
            9,
            9,
            wn,
            Vt,
            Ot,
            _i,
            qt,
            nr,
            kt,
            tt,
            1,
            di,
            Jt,
            Ur,
            Si,
            $,
            8,
            H,
            Hr,
            Rn,
            Zr,
            nr,
            En,
            qi,
            Ri,
            Wn,
            tr,
            j,
            xn,
            Ut,
            Qi,
            et,
            Xt,
            cn,
            Hn,
            xi,
            wn,
            ro,
            er,
            Wt,
            pr,
            tr,
            2,
            yn,
            dt,
            ht,
            9,
            Un,
            Di,
            Ai,
            $n,
            Zn,
            3,
            Wt,
            Vi,
            z,
            pr,
            dt,
            dr,
            Mi,
            vn,
            It,
            On,
            mi,
            gr,
            Zr,
            ki,
            Wt,
            Z,
            et,
            Gn,
            T,
            8,
            ai,
            Mn,
            vt,
            gr,
            Mr,
            x,
            un,
            V,
            ji,
            $,
            it,
            Dt,
            br,
            sr,
            rr,
            at,
            br,
            6,
            ft,
            Ci,
            hr,
            ui,
            yr,
            kr,
            jr,
            br,
            P,
            at,
            D,
            An,
            Ei,
            kn,
            bn,
            Jn,
            Lr,
            Vt,
            Wi,
            Ui,
            ar,
            nt,
            io,
            ct,
            br,
            pi,
            rr,
            Dn,
            An,
            T,
            G,
            L,
            qr,
            T,
            Ar,
            cn,
            en,
            Yt,
            qn,
            ir,
            xr,
            gr,
            Ai,
            _t,
            Wi,
            xt,
            jt,
            Un,
            xi,
            Ut,
            tt,
            Hn,
            q,
            hr,
            dt,
            Mn,
            Si,
            I,
            4,
            X,
            _t,
            hi,
            Ln,
            Di,
            nr,
            lr,
            ki,
            Kt,
            qr,
            pn,
            ui,
            J,
            _,
            Z,
            B,
            Wt,
            Xn,
            Jt,
            Fr,
            Ci,
            B,
            Wi,
            Kt,
            dt,
            Vt,
            an,
            Vt,
            Ot,
            et,
            zt,
            fi,
            Vt,
            tt,
            vr,
            qr,
            _i,
            dr,
            T,
            Xr,
            an,
            L,
            Pr,
            Tn,
            zn,
            zi,
            at,
            zi,
            $r,
            br,
            G,
            Or,
            D,
            mr,
            $,
            Vt,
            nt,
            Wr,
            gn,
            St,
            bi,
            K,
            tr,
            cr,
            ut,
            Gr,
            Hr,
            _n,
            Ot,
            or,
            vt,
            no,
            vr,
            Ti,
            wr,
            Yi,
            _i,
            et,
            yi,
            xn,
            q,
            en,
            Hr,
            ni,
            Ti,
            dn,
            G,
            _n,
            en,
            K,
            ln,
            xt,
            Mr,
            ri,
            et,
            Or,
            4,
            an,
            ro,
            un,
            xn,
            6,
            Rt,
            Jn,
            ro,
            j,
            7,
            Pr,
            ti,
            g,
            bi,
            ei,
            Ti,
            nr,
            en,
            Gi,
            Jt,
            jt,
            di,
            hi,
            si,
            Nr,
            vr,
            Di,
            Ai,
            Pr,
            Qi,
            _n,
            Ni,
            sr,
            g,
            5,
            Gn,
            Zi,
            Pi,
            Ni,
            U,
            Ar,
            Bt,
            Zr,
            It,
            gr,
            L,
            8,
            oi,
            3,
            ei,
            g,
            er,
            Fn,
            pn,
            Yt,
            fr,
            Ii,
            Hn,
            zr,
            0,
            Q,
            Ir,
            Li,
            zr,
            jn,
            Fn,
            Kn,
            Lt,
            Ar,
            L,
            Ot,
            2,
            In,
            ur,
            Nt,
            en,
            Nr,
            Gr,
            $i,
            _t,
            Tr,
            sr,
            Wt,
            gi,
            qi,
            Jr,
            Wn,
            un,
            Bt,
            sn,
            W,
            X,
            wt,
            no,
            en,
            vt,
            q,
            $i,
            Ti,
            Ut,
            gn,
            En,
            bi,
            7,
            x,
            dn,
            ro,
            Ut,
            Si,
            ln,
            nt,
            Ft,
            ro,
            kn,
            lt,
            $n,
            j,
            fi,
            S,
            dr,
            $t,
            Tr,
            un,
            Rt,
            yt,
            Jr,
            Or,
            ct,
            Kn,
            Gi,
            Jt,
            Ot,
            Qr,
            ur,
            Ni,
            tt,
            lt,
            Dn,
            pr,
            lt,
            xt,
            ct,
            Pi,
            D,
            Jt,
            vt,
            zr,
            pt,
            5,
            et,
            qr,
            Ur,
            q,
            St,
            Fn,
            2,
            un,
            fi,
            Mi,
            Un,
            lr,
            I,
            An,
            jn,
            Wn,
            io,
            Di,
            jt,
            Vr,
            In,
            ui,
            Qn,
            T,
            Nn,
            sr,
            xr,
            Vi,
            Mn,
            Cr,
            Yi,
            pt,
            Qr,
            Yi,
            Mi,
            et,
            bn,
            St,
            Ht,
            Wr,
            bn,
            St,
            Ot,
            B,
            Rn,
            at,
            dr,
            en,
            Nr,
            un,
            Dn,
            Un,
            Wr,
            V,
            dn,
            Dr,
            Zn,
            Qi,
            li,
            di,
            mn,
            _i,
            on,
            Tr,
            bi,
            ur,
            hn,
            Tr,
            un,
            mt,
            9,
            $n,
            Pt,
            Lr,
            St,
            rt,
            qt,
            er,
            dt,
            Lr,
            lt,
            bi,
            Xn,
            gi,
            Qt,
            _,
            Rr,
            bt,
            wt,
            st,
            yt,
            or,
            ji,
            en,
            En,
            cr,
            Wi,
            Dt,
            Nn,
            Zt,
            Yi,
            ti,
            Ot,
            2,
            un,
            Yi,
            Bt,
            Un,
            si,
            En,
            Or,
            rn,
            jt,
            Zr,
            Yt,
            ln,
            Xr,
            oi,
            Sr,
            Mi,
            ot,
            On,
            hn,
            5,
            Ei,
            di,
            tr,
            j,
            G,
            ct,
            Di,
            Gr,
            Ln,
            jr,
            Lt,
            qn,
            di,
            Kn,
            gt,
            _,
            tn,
            un,
            pi,
            Ji,
            ii,
            ot,
            di,
            q,
            Qi,
            In,
            dt,
            7,
            rn,
            vt,
            xi,
            Jt,
            hi,
            Wn,
            Fr,
            x,
            Ur,
            sn,
            Yn,
            zt,
            wr,
            ft,
            Kr,
            lr,
            Sn,
            Yt,
            Dt,
            At,
            an,
            Si,
            Bn,
            Ti,
            sr,
            Rt,
            St,
            Wi,
            Er,
            Qn,
            Ct,
            Zr,
            Qr,
            _,
            qi,
            Ti,
            5,
            Xn,
            Tn,
            ji,
            bi,
            Fi,
            Et,
            no,
            jn,
            z,
            Wt,
            Ir,
            2,
            _,
            qt,
            Kt,
            kr,
            Sn,
            mr,
            $,
            Vt,
            S,
            Qr,
            xn,
            It,
            J,
            V,
            Gi,
            In,
            8,
            ht,
            tn,
            _n,
            qt,
            6,
            gi,
            ji,
            Zi,
            Gi,
            di,
            Si,
            H,
            ti,
            Zn,
            6,
            Yn,
            Vi,
            7,
            tr,
            ut,
            pt,
            un,
            yt,
            dt,
            $,
            Ri,
            9,
            Qi,
            pt,
            yi,
            it,
            en,
            Ar,
            Gr,
            hr,
            qr,
            Yt,
            q,
            Nn,
            Gi,
            ti,
            io,
            H,
            Mt,
            Kt,
            Yi,
            Oi,
            Un,
            5,
            cn,
            wn,
            Hi,
            En,
            cn,
            xi,
            dt,
            X,
            nn,
            br,
            xn,
            Ei,
            K,
            I,
            Jr,
            $n,
            Nr,
            bn,
            sn,
            Ni,
            lr,
            1,
            En,
            Vi,
            Sn,
            at,
            Qn,
            dn,
            Di,
            Bi,
            ti,
            wi,
            gn,
            nt,
            Rr,
            Zn,
            lt,
            Er,
            X,
            Ln,
            Ot,
            wr,
            no,
            Qr,
            qn,
            Wn,
            lt,
            Vi,
            On,
            br,
            Ai,
            yr,
            li,
            Ot,
            Xn,
            St,
            un,
            Wn,
            T,
            D,
            U,
            4,
            Xr,
            Pr,
            mr,
            er,
            H,
            T,
            Gn,
            bi,
            Xi,
            _n,
            Gn,
            ln,
            Wt,
            Vr,
            Sr,
            Fn,
            _,
            xt,
            Wn,
            Ot,
            Zr,
            jr,
            Nn,
            Yi,
            Fi,
            Ri,
            Vr,
            or,
            Fr,
            Di,
            un,
            Xr,
            Mr,
            G,
            Ai,
            J,
            hn,
            _r,
            Er,
            mn,
            nt,
            dt,
            Ti,
            ln,
            at,
            _,
            Ut,
            oi,
            Sr,
            8,
            Ft,
            Gi,
            $t,
            Mr,
            St,
            vt,
            2,
            ut,
            _t,
            Di,
            $i,
            Lr,
            di,
            jt,
            Qi,
            Bn,
            $i,
            Nn,
            Fn,
            Un,
            ar,
            mi,
            nn,
            Jr,
            $i,
            Xt,
            sn,
            Fi,
            Tr,
            ot,
            Fn,
            bi,
            Pt,
            S,
            Wn,
            mi,
            fr,
            ln,
            rr,
            er,
            q,
            G,
            vt,
            mn,
            xn,
            Oi,
            br,
            Ut,
            7,
            xr,
            vi,
            pn,
            Or,
            zr,
            Lt,
            Wn,
            Wn,
            no,
            Jr,
            tr,
            mr,
            di,
            dn,
            ln,
            _,
            cr,
            Nn,
            Ct,
            Zr,
            tr,
            Ti,
            cr,
            Gr,
            fn,
            it,
            er,
            ui,
            et,
            0,
            Wn,
            Ai,
            or,
            _t,
            vi,
            mi,
            Sn,
            _i,
            Lt,
            z,
            bt,
            bn,
            li,
            pi,
            Er,
            di,
            9,
            gt,
            wi,
            q,
            Mi,
            br,
            Ri,
            Vi,
            lr,
            _,
            lt,
            Hr,
            R,
            Zr,
            Zt,
            wr,
            rn,
            Z,
            nt,
            It,
            ln,
            no,
            Ot,
            br,
            Un,
            bt,
            cr,
            Wt,
            Ot,
            fi,
            vr,
            ur,
            Pn,
            Ur,
            nr,
            Xi,
            ri,
            Ti,
            4,
            An,
            er,
            Fn,
            ct,
            Tr,
            ti,
            qn,
            z,
            Pr,
            Kn,
            qn,
            vn,
            St,
            Ut,
            li,
            li,
            at,
            J,
            wr,
            $,
            P,
            ar,
            Z,
            an,
            bt,
            li,
            7,
            $,
            6,
            Di,
            H,
            fi,
            Ui,
            zr,
            $,
            Bi,
            vt,
            ri,
            gr,
            on,
            Ti,
            Q,
            L,
            St,
            z,
            Nt,
            gr,
            io,
            Qr,
            hi,
            B,
            Hi,
            Jn,
            it,
            0,
            z,
            It,
            wt,
            zi,
            dr,
            Gt,
            6,
            yt,
            Dr,
            Gn,
            mi,
            Wn,
            yt,
            4,
            Cn,
            nn,
            mi,
            ai,
            Pr,
            wi,
            pn,
            kn,
            ut,
            $,
            Lt,
            C,
            xi,
            dt,
            vr,
            ui,
            Mn,
            tt,
            Vi,
            Dn,
            ut,
            un,
            Sr,
            at,
            Li,
            bi,
            kr,
            z,
            br,
            Wn,
            2,
            _t,
            Kr,
            vr,
            dn,
            Ut,
            kr,
            mt,
            dt,
            Dt,
            or,
            Xt,
            Br,
            Kt,
            rn,
            Tt,
            Yr,
            Ai,
            kr,
            dr,
            Gi,
            T,
            li,
            Ni,
            K,
            Z,
            rt,
            pt,
            Z,
            Dr,
            on,
            _i,
            pt,
            li,
            Lt,
            Ui,
            un,
            x,
            Kn,
            Zr,
            gr,
            En,
            qt,
            vr,
            ur,
            Zi,
            _t,
            Zr,
            Pt,
            ai,
            Hr,
            Gi,
            St,
            lr,
            $r,
            P,
            $n,
            _,
            tt,
            yn,
            hr,
            br,
            x,
            Et,
            br,
            Wt,
            Bi,
            Hi,
            Ii,
            Vn,
            Yi,
            yr,
            en,
            on,
            ir,
            ir,
            jt,
            Fn,
            Et,
            cr,
            Y,
            Fr,
            $t,
            ro,
            yt,
            Yt,
            g,
            Xi,
            Br,
            Ir,
            si,
            Ii,
            ur,
            wi,
            xi,
            rn,
            Ur,
            Ti,
            I,
            Q,
            gt,
            er,
            $n,
            cr,
            1,
            _n,
            I,
            Rr,
            pi,
            1,
            Zr,
            q,
            Gr,
            ai,
            bn,
            6,
            xi,
            St,
            Zn,
            ct,
            $,
            Jr,
            Lt,
            Ar,
            gr,
            Q,
            tt,
            nr,
            or,
            rn,
            Fn,
            $t,
            3,
            or,
            I,
            Mr,
            U,
            qi,
            zi,
            Yt,
            Wn,
            Rn,
            ei,
            Si,
            Gt,
            Ti,
            _t,
            cr,
            Nr,
            Ln,
            nr,
            Ai,
            $i,
            ct,
            hi,
            gt,
            mr,
            Kt,
            Ai,
            Fi,
            ln,
            wi,
            Sr,
            3,
            or,
            _n,
            en,
            jt,
            Fi,
            Tn,
            Ki,
            S,
            k,
            Gi,
            xn,
            ut,
            Qr,
            rr,
            U,
            Ji,
            ot,
            7,
            io,
            Ut,
            Ci,
            jn,
            oi,
            Pn,
            It,
            Lr,
            In,
            Ct,
            g,
            Yi,
            gn,
            ji,
            ut,
            Dt,
            Pt,
            kr,
            z,
            Zr,
            9,
            Fn,
            pi,
            rn,
            Ii,
            Et,
            Kn,
            Wi,
            Yt,
            ct,
            7,
            li,
            Mi,
            ln,
            vr,
            un,
            rr,
            gr,
            dn,
            hn,
            fi,
            Z,
            ri,
            Fn,
            jr,
            Rn,
            St,
            Ur,
            Rr,
            Vt,
            4,
            Un,
            Mr,
            mr,
            on,
            zn,
            J,
            vr,
            vi,
            Ur,
            On,
            Gr,
            vi,
            k,
            br,
            Wt,
            it,
            K,
            fr,
            Kn,
            Vt,
            ti,
            bt,
            ji,
            dt,
            kt,
            ft,
            U,
            I,
            $i,
            j,
            Gi,
            ot,
            I,
            zt,
            Ti,
            ii,
            ci,
            dt,
            X,
            or,
            At,
            Un,
            nr,
            ti,
            bt,
            hi,
            ii,
            0,
            wn,
            Wn,
            Et,
            _,
            Xt,
            Yr,
            Zr,
            K,
            Hi,
            Zn,
            x,
            R,
            un,
            Un,
            ei,
            nr,
            Nn,
            Ki,
            Dr,
            Pt,
            Zn,
            zn,
            Bi,
            $r,
            un,
            Ci,
            Zt,
            Ut,
            U,
            Li,
            Di,
            sr,
            vn,
            Mi,
            B,
            wr,
            Ui,
            L,
            fn,
            yr,
            dt,
            Dn,
            Wr,
            rn,
            It,
            Ki,
            or,
            ut,
            Bt,
            en,
            qn,
            cn,
            ti,
            ti,
            _n,
            Q,
            ct,
            Hn,
            Ot,
            j,
            ct,
            hi,
            $i,
            Jr,
            B,
            Dn,
            it,
            hn,
            rr,
            An,
            at,
            sr,
            Mn,
            mt,
            er,
            Un,
            ot,
            _t,
            en,
            cr,
            Gn,
            cn,
            xn,
            hi,
            vt,
            pn,
            It,
            9,
            Lr,
            st,
            k,
            Gi,
            un,
            C,
            En,
            di,
            _n,
            G,
            Un,
            di,
            ln,
            J,
            vt,
            R,
            Jt,
            Vt,
            Fn,
            no,
            li,
            7,
            Y,
            Er,
            Pn,
            en,
            Ii,
            Ei,
            Br,
            Et,
            ui,
            Xi,
            tr,
            Ji,
            wt,
            no,
            Z,
            Mt,
            si,
            an,
            Bi,
            I,
            nt,
            qt,
            Ji,
            $,
            H,
            ci,
            ai,
            R,
            Qt,
            Cr,
            ct,
            Ct,
            Cn,
            Bi,
            C,
            Mn,
            mr,
            yr,
            In,
            Yn,
            bn,
            Zn,
            xt,
            $t,
            at,
            ei,
            En,
            Ir,
            Ei,
            lt,
            In,
            ni,
            Fi,
            Dt,
            $t,
            pi,
            tr,
            Vn,
            tn,
            J,
            An,
            q,
            on,
            _r,
            Et,
            $r,
            Ii,
            Mn,
            _i,
            pi,
            tr,
            mr,
            dn,
            zt,
            jn,
            Pn,
            Zn,
            Li,
            L,
            _t,
            ar,
            Q,
            St,
            Zn,
            si,
            Ar,
            _i,
            mr,
            _i,
            sr,
            Er,
            Un,
            mt,
            ft,
            jr,
            _t,
            R,
            tt,
            H,
            hi,
            Hn,
            Dn,
            di,
            nt,
            no,
            In,
            si,
            0,
            Ni,
            ur,
            L,
            6,
            nt,
            Rr,
            bt,
            Ot,
            Gr,
            Un,
            Lt,
            Ri,
            di,
            Wt,
            Zi,
            Ht,
            vn,
            ki,
            bi,
            Yn,
            sr,
            W,
            Tt,
            j,
            gt,
            yt,
            _i,
            Hi,
            Di,
            ri,
            St,
            0,
            gr,
            Dt,
            Pn,
            et,
            ri,
            Ti,
            Kn,
            Qt,
            or,
            Vi,
            hr,
            no,
            jn,
            st,
            xt,
            Dn,
            dt,
            tt,
            Vi,
            Ft,
            Hi,
            Ar,
            Ft,
            D,
            Ir,
            _t,
            or,
            ct,
            bn,
            ur,
            Nt,
            Wt,
            Jn,
            xn,
            ht,
            Nn,
            Kt,
            zt,
            vt,
            Yt,
            Z,
            hr,
            Kt,
            Pt,
            Tr,
            bi,
            ei,
            Wn,
            Nr,
            q,
            Yi,
            di,
            on,
            Un,
            k,
            ln,
            mr,
            rr,
            yn,
            cr,
            6,
            Nr,
            q,
            si,
            un,
            Vn,
            bt,
            Vt,
            dr,
            et,
            Oi,
            Ii,
            dn,
            $i,
            Zn,
            Gn,
            Ei,
            er,
            Vi,
            zn,
            Q,
            tr,
            fi,
            ar,
            On,
            Un,
            lr,
            Et,
            S,
            mt,
            Jr,
            _i,
            ki,
            Kt,
            qt,
            Ei,
            ot,
            zt,
            bi,
            I,
            Z,
            Nt,
            un,
            Di,
            Bt,
            un,
            ur,
            ai,
            Jt,
            ki,
            I,
            $r,
            wi,
            xt,
            un,
            I,
            ut,
            nt,
            ln,
            kt,
            wt,
            io,
            Vi,
            ti,
            cr,
            ui,
            dt,
            kt,
            ci,
            $t,
            Wn,
            Hn,
            tr,
            _,
            Qr,
            It,
            wi,
            Ct,
            no,
            x,
            qn,
            kt,
            an,
            Vt,
            j,
            Wt,
            gn,
            mt,
            Nn,
            K,
            Gr,
            dr,
            Pr,
            mr,
            An,
            qn,
            Vt,
            Sr,
            Sr,
            qn,
            j,
            qr,
            I,
            ii,
            Gi,
            mr,
            Mi,
            Vt,
            St,
            L,
            st,
            rt,
            at,
            I,
            oi,
            Bn,
            Mr,
            Ln,
            zt,
            Rt,
            ln,
            un,
            er,
            mr,
            qn,
            Jn,
            ct,
            Dt,
            Sr,
            yi,
            ln,
            rn,
            mt,
            on,
            Br,
            dn,
            tr,
            or,
            Fn,
            yn,
            fn,
            ai,
            br,
            Wi,
            wt,
            nt,
            vn,
            On,
            Tt,
            4,
            Rt,
            Yt,
            x,
            ur,
            X,
            wn,
            7,
            bi,
            cn,
            At,
            fi,
            Qn,
            kt,
            rn,
            bn,
            Kt,
            Vt,
            _i,
            pt,
            $i,
            dn,
            Nn,
            St,
            ui,
            Dt,
            st,
            Li,
            Vt,
            Fr,
            Z,
            Zr,
            Nn,
            gt,
            D,
            An,
            ti,
            U,
            br,
            Wt,
            bt,
            Yi,
            An,
            ti,
            Ot,
            er,
            $t,
            Ot,
            pt,
            ct,
            1,
            yr,
            3,
            hn,
            Wt,
            ii,
            Pr,
            L,
            ei,
            xi,
            cr,
            ci,
            xt,
            Wt,
            Vr,
            bi,
            zt,
            St,
            ci,
            Ht,
            _,
            ut,
            kn,
            St,
            Gi,
            ui,
            Ii,
            it,
            li,
            hn,
            Bt,
            Or,
            7,
            _i,
            Zi,
            er,
            an,
            j,
            Wt,
            T,
            Wt,
            Hn,
            zr,
            Bi,
            Nr,
            Dn,
            kt,
            un,
            Dn,
            Zr,
            Xn,
            ri,
            Lt,
            T,
            z,
            Un,
            Pn,
            Ui,
            L,
            _t,
            qi,
            Dr,
            Zt,
            S,
            pn,
            _t,
            Lr,
            Tn,
            Pt,
            Ii,
            Or,
            Hi,
            Pi,
            Hn,
            pr,
            ht,
            ci,
            z,
            xt,
            yi,
            ri,
            ur,
            an,
            q,
            ur,
            rt,
            yn,
            ci,
            _t,
            rt,
            Gt,
            pr,
            dt,
            Or,
            or,
            ri,
            gr,
            $,
            ti,
            En,
            j,
            Ri,
            gr,
            ln,
            qr,
            z,
            nt,
            _t,
            Pi,
            Dt,
            Ei,
            Jn,
            xt,
            Rn,
            Pr,
            Fi,
            Nn,
            g,
            on,
            Ri,
            ni,
            X,
            Sr,
            z,
            jt,
            yt,
            $t,
            5,
            Mi,
            un,
            Bt,
            gr,
            Er,
            bi,
            nt,
            z,
            Ri,
            Er,
            Vn,
            Nn,
            rt,
            Cr,
            6,
            ro,
            I,
            yn,
            fn,
            Ln,
            gt,
            pt,
            T,
            _n,
            $r,
            ft,
            Wr,
            _,
            Dn,
            Vi,
            Nr,
            kn,
            Lr,
            Si,
            lt,
            Y,
            Bn,
            Pt,
            Ei,
            _r,
            dr,
            9,
            an,
            Tn,
            rt,
            B,
            an,
            Si,
            ji,
            Ni,
            mn,
            ki,
            Xr,
            Ct,
            vn,
            Wn,
            G,
            Lt,
            Tt,
            Sr,
            Hr,
            ii,
            U,
            ri,
            Y,
            _r,
            wt,
            li,
            6,
            Qr,
            sr,
            lr,
            En,
            Zi,
            Tr,
            oi,
            ut,
            di,
            pt,
            5,
            $,
            Rt,
            ln,
            Zn,
            z,
            Y,
            Gt,
            Tr,
            nr,
            nr,
            fn,
            ri,
            bt,
            Hi,
            Vr,
            It,
            io,
            nr,
            $n,
            Un,
            Rt,
            xn,
            vn,
            $r,
            $i,
            J,
            Tn,
            I,
            Zn,
            $n,
            kt,
            Dn,
            br,
            Bt,
            cn,
            Wi,
            Fi,
            Li,
            $r,
            Et,
            j,
            gr,
            Dn,
            Hn,
            _t,
            cr,
            Pn,
            zr,
            Li,
            qr,
            Et,
            fn,
            pn,
            Ir,
            Tt,
            gi,
            pi,
            yi,
            lt,
            Gi,
            si,
            Ut,
            wt,
            j,
            vr,
            nt,
            Ii,
            Jr,
            sr,
            nt,
            Et,
            jn,
            J,
            Xn,
            In,
            Vn,
            Ut,
            mt,
            H,
            G,
            j,
            P,
            pi,
            vn,
            Ot,
            Ar,
            io,
            er,
            Jn,
            ni,
            Ot,
            Nn,
            z,
            bi,
            ai,
            ei,
            on,
            ct,
            xt,
            wt,
            V,
            qi,
            Zr,
            Mi,
            an,
            vr,
            It,
            hi,
            Zt,
            Bn,
            Nr,
            xn,
            Z,
            jt,
            Dt,
            Li,
            ji,
            Hr,
            pn,
            Ki,
            lr,
            Hr,
            0,
            tt,
            li,
            Ot,
            ir,
            Ui,
            Z,
            Xn,
            Ur,
            lr,
            S,
            lt,
            oi,
            En,
            L,
            x,
            wi,
            jt,
            rt,
            Pr,
            Nn,
            qi,
            fr,
            Fi,
            jr,
            zi,
            oi,
            tn,
            ut,
            It,
            ii,
            bn,
            C,
            q,
            qr,
            Un,
            vi,
            Xn,
            vi,
            Ur,
            tr,
            Ti,
            Vn,
            zi,
            nr,
            Ar,
            Tr,
            en,
            yt,
            rr,
            Yr,
            it,
            ri,
            en,
            Pt,
            Lr,
            fn,
            Li,
            _i,
            Lt,
            Rn,
            ri,
            St,
            x,
            z,
            Fi,
            Qn,
            Dr,
            Ft,
            Kt,
            Jn,
            _r,
            xi,
            Mt,
            gi,
            Yt,
            kt,
            Rt,
            $,
            Xt,
            V,
            ri,
            qi,
            Ai,
            jn,
            In,
            mt,
            $i,
            At,
            _,
            Ir,
            2,
            Br,
            _,
            Et,
            gr,
            Si,
            vr,
            Z,
            kr,
            ut,
            hr,
            k,
            ct,
            pt,
            qi,
            G,
            yt,
            j,
            Si,
            En,
            9,
            ro,
            sr,
            Ji,
            Lr,
            $i,
            mr,
            mr,
            tr,
            Rn,
            lr,
            zt,
            Rn,
            Wn,
            Jr,
            vt,
            Gt,
            di,
            ir,
            cn,
            Ki,
            Zt,
            tt,
            5,
            Ft,
            rn,
            Rt,
            Fr,
            bi,
            Z,
            $r,
            xr,
            Ui,
            zt,
            Ui,
            yt,
            Yi,
            xr,
            Q,
            Oi,
            yt,
            ct,
            Un,
            wi,
            rn,
            Mn,
            pr,
            Yr,
            Ji,
            kn,
            Jr,
            Sr,
            Di,
            qn,
            Yi,
            tr,
            vt,
            Sr,
            Vi,
            Ar,
            wn,
            qr,
            Qr,
            Yt,
            q,
            Zn,
            Yr,
            Cn,
            ei,
            U,
            ur,
            jn,
            qi,
            $i,
            ar,
            no,
            pi,
            wi,
            Vn,
            _n,
            Ki,
            Wn,
            ki,
            ir,
            Jr,
            z,
            mi,
            St,
            H,
            cn,
            Vr,
            _r,
            Ii,
            xn,
            Yr,
            ct,
            mt,
            K,
            Kn,
            L,
            lt,
            mi,
            Gt,
            pt,
            vi,
            Y,
            z,
            B,
            qn,
            ot,
            $n,
            Wn,
            Fr,
            $n,
            Gi,
            rr,
            $t,
            yt,
            _i,
            Bt,
            on,
            vt,
            Y,
            Qt,
            ot,
            hi,
            bt,
            ar,
            ti,
            no,
            ai,
            Vt,
            Mr,
            Kn,
            G,
            xi,
            2,
            Er,
            $t,
            S,
            H,
            ji,
            On,
            Pi,
            it,
            It,
            nr,
            Vr,
            Yn,
            Hi,
            gi,
            Dt,
            _,
            xi,
            jn,
            Xn,
            Bi,
            g,
            qn,
            Kn,
            7,
            dt,
            nt,
            Ft,
            Vt,
            vi,
            ii,
            mt,
            tn,
            Ei,
            rn,
            Nr,
            Ot,
            $i,
            Vt,
            2,
            Vt,
            Et,
            Wr,
            In,
            pr,
            x,
            Wr,
            Pr,
            Mr,
            Qi,
            ri,
            tn,
            ci,
            8,
            Nt,
            Ln,
            Kt,
            An,
            T,
            pr,
            L,
            pn,
            Nr,
            Ni,
            S,
            Rt,
            pt,
            zr,
            Ji,
            Mr,
            Ir,
            ht,
            dt,
            Ui,
            B,
            Xn,
            S,
            ri,
            Gt,
            mt,
            pr,
            ki,
            ai,
            Lr,
            _,
            rr,
            Pn,
            Mn,
            Tt,
            Bt,
            rt,
            ri,
            Qr,
            ki,
            Hn,
            xr,
            Vi,
            G,
            vt,
            oi,
            wr,
            an,
            j,
            G,
            Lr,
            Cr,
            Xn,
            S,
            D,
            U,
            Jt,
            Xi,
            Mr,
            I,
            Ln,
            qn,
            U,
            dt,
            er,
            Qr,
            Ki,
            kn,
            mt,
            Vr,
            mr,
            I,
            vr,
            qt,
            sn,
            Kn,
            Fi,
            Z,
            xn,
            si,
            qt,
            Hn,
            mt,
            Ji,
            Di,
            Lt,
            tt,
            Lr,
            Kr,
            3,
            br,
            Sr,
            Ft,
            Pr,
            jr,
            Yi,
            Ei,
            I,
            no,
            U,
            pn,
            Ft,
            $i,
            zi,
            ei,
            rn,
            li,
            0,
            bi,
            _,
            vi,
            Bt,
            oi,
            ai,
            yi,
            Nr,
            Or,
            k,
            Mi,
            W,
            Mi,
            Dt,
            In,
            Gn,
            Xi,
            Yi,
            sn,
            St,
            Jt,
            Bt,
            ot,
            En,
            bi,
            ir,
            gt,
            nn,
            R,
            et,
            it,
            it,
            Nr,
            cr,
            D,
            Hi,
            7,
            Ji,
            Pn,
            no,
            Jt,
            K,
            nn,
            Hn,
            3,
            Pr,
            pn,
            Ln,
            St,
            wt,
            fi,
            Zi,
            jn,
            wt,
            vt,
            z,
            vr,
            st,
            or,
            Sr,
            Jn,
            $t,
            In,
            Ot,
            sn,
            Mn,
            _,
            on,
            Vi,
            yr,
            Et,
            C,
            Wr,
            gr,
            fr,
            g,
            _,
            $r,
            ct,
            Ei,
            yi,
            Hn,
            $,
            nr,
            V,
            Tt,
            sr,
            7,
            _r,
            ct,
            Vr,
            Hi,
            sn,
            Ur,
            Ai,
            Zi,
            nn,
            Rr,
            Fn,
            Ot,
            Un,
            fi,
            vn,
            Ot,
            J,
            Ur,
            on,
            Y,
            $t,
            hn,
            Kt,
            gr,
            un,
            Pi,
            it,
            ro,
            tt,
            si,
            Cr,
            x,
            bi,
            fi,
            hi,
            Hn,
            Qt,
            S,
            Y,
            sr,
            Nn,
            Ct,
            Kr,
            qi,
            On,
            Si,
            rn,
            6,
            $r,
            Di,
            $r,
            Xr,
            Oi,
            Qi,
            G,
            St,
            fn,
            Ci,
            wt,
            lr,
            x,
            Mi,
            Zi,
            Xi,
            kt,
            Jr,
            pt,
            Hn,
            Kn,
            At,
            Ki,
            Tt,
            it,
            Rt,
            Ji,
            nt,
            pt,
            ut,
            br,
            mr,
            tn,
            Lr,
            Y,
            kr,
            $t,
            vr,
            nr,
            Yn,
            Dr,
            ii,
            0,
            Xt,
            Dn,
            3,
            li,
            br,
            Qt,
            Zt,
            Mt,
            Rt,
            _n,
            Li,
            _t,
            S,
            io,
            B,
            Z,
            it,
            Wn,
            un,
            wi,
            Wr,
            Vt,
            xn,
            Ki,
            Gr,
            ki,
            hi,
            lr,
            Xi,
            Sr,
            xr,
            nn,
            Ir,
            fi,
            Bn,
            fr,
            Ki,
            Tn,
            7,
            Ft,
            Ht,
            Dn,
            Zt,
            Qn,
            W,
            qr,
            Ki,
            1,
            xr,
            Ct,
            Yr,
            Ci,
            H,
            Un,
            Ei,
            k,
            mr,
            Nt,
            Bi,
            Ii,
            Mn,
            g,
            at,
            Zn,
            _t,
            Ht,
            ei,
            gn,
            li,
            Z,
            Fi,
            dt,
            bi,
            _,
            Un,
            no,
            Bi,
            Z,
            no,
            tt,
            ft,
            dr,
            lr,
            cr,
            $n,
            Pi,
            er,
            ir,
            Yt,
            Or,
            on,
            io,
            at,
            nr,
            pt,
            Vt,
            lt,
            cr,
            Mi,
            Ot,
            Un,
            H,
            Qr,
            Yt,
            nr,
            un,
            wt,
            Hn,
            k,
            tt,
            ct,
            qr,
            mn,
            rn,
            Ct,
            j,
            J,
            It,
            Vt,
            rt,
            j,
            Mr,
            Bi,
            rt,
            dr,
            Rt,
            dn,
            hr,
            xr,
            Ii,
            ir,
            Bi,
            Yn,
            Ji,
            Z,
            Hn,
            vr,
            Tn,
            nn,
            Kn,
            fr,
            Ar,
            Dt,
            Ot,
            Fi,
            un,
            qt,
            rt,
            vr,
            Fr,
            Qr,
            Ot,
            Zr,
            or,
            vr,
            X,
            Ai,
            ft,
            ri,
            Pi,
            Kt,
            qr,
            kn,
            Zt,
            Wi,
            Cn,
            vt,
            Q,
            bt,
            Ui,
            Hn,
            Dr,
            er,
            Zn,
            Nr,
            yn,
            Xr,
            jn,
            Et,
            ui,
            lr,
            Vt,
            Yn,
            lr,
            L,
            zn,
            Vr,
            ii,
            an,
            yi,
            St,
            4,
            ct,
            V,
            $t,
            Sn,
            gr,
            Bi,
            gt,
            wn,
            W,
            yr,
            vt,
            Yi,
            Ot,
            ut,
            er,
            Er,
            Ji,
            ur,
            R,
            dt,
            zt,
            zn,
            K,
            Jn,
            at,
            $t,
            wt,
            sn,
            j,
            lt,
            cr,
            En,
            Ft,
            k,
            Fn,
            ct,
            Tn,
            lt,
            rr,
            vt,
            Vt,
            Vi,
            xn,
            3,
            vi,
            wr,
            G,
            ht,
            rr,
            ct,
            St,
            Ji,
            et,
            2,
            tr,
            Q,
            Y,
            yi,
            jn,
            ii,
            Nt,
            xn,
            Bi,
            Dt,
            H,
            ut,
            z,
            di,
            ii,
            Gn,
            Tt,
            Ft,
            bi,
            yr,
            lr,
            tt,
            Z,
            gi,
            $,
            rt,
            si,
            Nr,
            hn,
            Y,
            Rt,
            nt,
            xi,
            qn,
            2,
            j,
            x,
            en,
            ir,
            Ti,
            Zi,
            K,
            wr,
            ot,
            pi,
            Rr,
            Yr,
            mn,
            Ut,
            Ht,
            5,
            Ri,
            Wi,
            $i,
            6,
            ci,
            bn,
            an,
            En,
            Y,
            Jr,
            Br,
            q,
            $i,
            Zn,
            fn,
            Pr,
            on,
            hn,
            jt,
            it,
            yi,
            dt,
            bt,
            Y,
            8,
            fi,
            Bi,
            en,
            ur,
            Gn,
            ki,
            I,
            mi,
            Xn,
            K,
            Jn,
            Fr,
            Qr,
            Gn,
            Gr,
            Ft,
            at,
            Si,
            Mn,
            lr,
            hn,
            Wr,
            ii,
            xi,
            Ut,
            rn,
            Yi,
            tt,
            2,
            Br,
            sn,
            xi,
            Lr,
            gn,
            mt,
            Fr,
            q,
            gr,
            ut,
            Ut,
            Et,
            ii,
            Jr,
            ji,
            Cr,
            jn,
            ui,
            Ar,
            Mn,
            Tn,
            kt,
            x,
            Sr,
            ln,
            vn,
            lt,
            Pn,
            si,
            rr,
            Qt,
            Mi,
            vn,
            Ui,
            Y,
            qr,
            Ai,
            Xt,
            xr,
            Vi,
            ft,
            hi,
            Ut,
            ci,
            ar,
            $,
            yn,
            Ai,
            xt,
            Kt,
            j,
            ro,
            ar,
            Yi,
            Pt,
            Ji,
            Zt,
            Hi,
            B,
            Fi,
            D,
            W,
            z,
            Qn,
            Nn,
            Yr,
            Fn,
            di,
            ar,
            ri,
            Hi,
            Si,
            ci,
            Kt,
            bt,
            ct,
            Fr,
            K,
            Fn,
            W,
            Nn,
            Ri,
            fn,
            Xt,
            Pn,
            fi,
            5,
            ui,
            Er,
            Yi,
            wr,
            vt,
            un,
            ir,
            bt,
            wi,
            Gr,
            xi,
            C,
            Yn,
            S,
            lr,
            Pi,
            Ki,
            ct,
            tt,
            fn,
            ki,
            Ft,
            si,
            en,
            it,
            Rt,
            H,
            hi,
            hi,
            ni,
            nt,
            Ai,
            Jr,
            Rt,
            si,
            xr,
            Ut,
            $t,
            5,
            yn,
            Fn,
            Vt,
            Wt,
            $r,
            ai,
            Z,
            xn,
            Qr,
            Dt,
            Lr,
            Ct,
            Oi,
            Pt,
            Tr,
            ti,
            _t,
            tt,
            er,
            J,
            Nt,
            ei,
            gr,
            An,
            et,
            Hn,
            no,
            kr,
            Wi,
            H,
            G,
            Ci,
            $r,
            et,
            Mn,
            Zt,
            Br,
            Nn,
            br,
            S,
            Hr,
            oi,
            Tt,
            B,
            vr,
            Bt,
            R,
            bn,
            ri,
            vt,
            Nn,
            or,
            dr,
            Bt,
            Tt,
            at,
            Ft,
            Ht,
            qn,
            xr,
            Mt,
            yr,
            ut,
            Ni,
            ni,
            vr,
            ei,
            k,
            $r,
            vr,
            Ci,
            Wi,
            _,
            Qr,
            K,
            zi,
            fr,
            Ot,
            ht,
            Li,
            It,
            Cn,
            lr,
            Ai,
            Vn,
            nn,
            Ii,
            io,
            Fr,
            H,
            nt,
            ct,
            kt,
            bt,
            Ct,
            ir,
            tn,
            rn,
            vr,
            T,
            k,
            zn,
            X,
            vr,
            kr,
            en,
            pr,
            An,
            _t,
            Fr,
            J,
            g,
            cn,
            mr,
            Ji,
            ar,
            Br,
            Lt,
            gi,
            er,
            Kn,
            pt,
            tn,
            no,
            Xt,
            ut,
            Dt,
            mi,
            Fn,
            Jr,
            Yt,
            Dn,
            Gn,
            Ci,
            dn,
            zi,
            An,
            jn,
            Sr,
            2,
            vi,
            Rt,
            An,
            yr,
            Oi,
            Jt,
            si,
            Xn,
            fn,
            _r,
            _i,
            Ht,
            Yn,
            zn,
            lt,
            Z,
            ki,
            Zi,
            kn,
            L,
            on,
            Dn,
            Lr,
            ui,
            cn,
            xi,
            ln,
            Yt,
            Jr,
            lt,
            tr,
            2,
            hr,
            en,
            Ur,
            Ti,
            Dt,
            Fr,
            Ki,
            lr,
            Yn,
            Ti,
            On,
            9,
            ki,
            fr,
            Qi,
            Z,
            tn,
            tt,
            z,
            wr,
            _,
            _i,
            Ar,
            Vn,
            gi,
            dt,
            P,
            rr,
            Ht,
            5,
            st,
            bt,
            Jr,
            ki,
            X,
            Cr,
            Or,
            si,
            st,
            ri,
            Vn,
            fr,
            qr,
            An,
            P,
            vr,
            _,
            Lt,
            Vt,
            Ot,
            gr,
            cn,
            Ot,
            j,
            xn,
            bn,
            Yi,
            Lt,
            wt,
            io,
            jr,
            yr,
            pt,
            nr,
            fr,
            U,
            tn,
            Ft,
            or,
            Zt,
            pi,
            L,
            et,
            Ar,
            Ft,
            yi,
            tr,
            Wr,
            un,
            Xt,
            Fr,
            k,
            Tr,
            bt,
            zr,
            P,
            Ti,
            bi,
            an,
            _,
            Ti,
            zr,
            Mr,
            Xt,
            wn,
            ji,
            Y,
            Di,
            fr,
            Wn,
            an,
            cn,
            Rt,
            Ji,
            Ct,
            $r,
            ji,
            C,
            nt,
            at,
            Ui,
            jn,
            pt,
            ji,
            Ot,
            wr,
            Mi,
            sr,
            bt,
            ct,
            P,
            Nt,
            yt,
            at,
            Fn,
            B,
            lt,
            Hi,
            In,
            qn,
            gr,
            rn,
            $t,
            mn,
            Tn,
            _n,
            ct,
            g,
            ci,
            V,
            Dr,
            Tr,
            Tn,
            yn,
            Pi,
            6,
            Li,
            jt,
            Xn,
            ln,
            tn,
            Zn,
            Li,
            Er,
            Et,
            hn,
            W,
            ct,
            Ni,
            pr,
            rr,
            it,
            Wn,
            Di,
            Li,
            Ot,
            zn,
            T,
            Rt,
            cn,
            Yt,
            Ui,
            Wn,
            li,
            Jr,
            er,
            Xi,
            nn,
            Yi,
            ar,
            Jn,
            ar,
            5,
            ut,
            Er,
            rr,
            x,
            Vi,
            Zr,
            nt,
            Cn,
            at,
            Wn,
            W,
            $t,
            en,
            ct,
            Rt,
            Lr,
            ui,
            kr,
            si,
            bt,
            ci,
            fn,
            It,
            Qt,
            Xt,
            on,
            lt,
            qn,
            ti,
            jr,
            Vr,
            L,
            Un,
            I,
            g,
            $i,
            Mi,
            qt,
            St,
            Cn,
            $,
            Zi,
            en,
            Ki,
            Pt,
            br,
            ti,
            rt,
            Rn,
            Lt,
            hr,
            gi,
            Jt,
            Nr,
            It,
            zt,
            yr,
            Vn,
            rt,
            st,
            Ut,
            fn,
            X,
            Si,
            vr,
            di,
            qn,
            kr,
            Hn,
            er,
            cr,
            wi,
            bi,
            Kn,
            _i,
            Wi,
            Si,
            mr,
            rt,
            Wt,
            er,
            Cr,
            xi,
            9,
            qi,
            cn,
            yt,
            vr,
            Cn,
            et,
            bt,
            3,
            hi,
            ct,
            Pn,
            Pr,
            vt,
            Gi,
            hi,
            Vn,
            Q,
            St,
            Oi,
            Ji,
            Or,
            yi,
            ci,
            Ht,
            Cr,
            Tt,
            tt,
            Nn,
            dn,
            it,
            ir,
            fr,
            Ui,
            sr,
            Li,
            hn,
            mi,
            _,
            rt,
            ii,
            Dt,
            Bt,
            Xn,
            at,
            si,
            Er,
            vi,
            W,
            $i,
            at,
            Yn,
            fn,
            hn,
            st,
            bt,
            Gr,
            hr,
            q,
            W,
            tn,
            Dt,
            x,
            Y,
            Ui,
            T,
            qi,
            G,
            Hr,
            fn,
            dt,
            yn,
            Z,
            Kr,
            io,
            Yn,
            ri,
            _i,
            fn,
            ot,
            nt,
            rr,
            pn,
            H,
            ji,
            Vt,
            Mn,
            Vn,
            ji,
            Yr,
            gi,
            hi,
            pn,
            rt,
            ei,
            5,
            ei,
            Ii,
            kt,
            Rt,
            ji,
            rt,
            K,
            I,
            Cr,
            In,
            Ft,
            Qt,
            xr,
            Rr,
            Jr,
            Bt,
            J,
            Wn,
            Ln,
            xi,
            On,
            Un,
            $r,
            kn,
            Xr,
            Rr,
            tt,
            Bi,
            Qt,
            At,
            At,
            ji,
            Ri,
            an,
            D,
            ai,
            zn,
            ar,
            Fn,
            tt,
            vt,
            Br,
            Er,
            lr,
            kr,
            Tt,
            8,
            Hr,
            Qn,
            vn,
            Xn,
            Jt,
            lt,
            kt,
            Vi,
            Hn,
            On,
            Ui,
            Xt,
            Xt,
            $i,
            An,
            ir,
            ki,
            tt,
            mr,
            _n,
            fr,
            fi,
            Or,
            Dr,
            Zn,
            hi,
            nr,
            Vt,
            Lr,
            fn,
            Hi,
            Wi,
            pt,
            Et,
            dt,
            Ar,
            W,
            di,
            kn,
            vr,
            Bn,
            Rn,
            zn,
            Hi,
            x,
            q,
            Ni,
            Sr,
            ki,
            ur,
            hn,
            Ai,
            bn,
            ni,
            ni,
            Hi,
            Y,
            ui,
            Rr,
            cn,
            Ki,
            Si,
            7,
            Mr,
            Qr,
            P,
            Y,
            Qr,
            Or,
            pr,
            Br,
            4,
            ni,
            mt,
            Ji,
            G,
            Xi,
            rt,
            jr,
            pt,
            Hr,
            ji,
            fr,
            P,
            j,
            vr,
            un,
            tr,
            ln,
            pt,
            Tr,
            $n,
            3,
            $n,
            io,
            On,
            Ar,
            zt,
            ut,
            io,
            nt,
            En,
            2,
            sr,
            zr,
            hr,
            Ti,
            cn,
            ii,
            qt,
            Wi,
            Xi,
            Ir,
            hi,
            qt,
            Et,
            U,
            cn,
            rt,
            Tt,
            Oi,
            dt,
            qi,
            Tt,
            ci,
            Qr,
            nr,
            Hi,
            xt,
            bn,
            yr,
            Ai,
            et,
            Wr,
            Wt,
            ro,
            T,
            Fr,
            ro,
            kn,
            Br,
            G,
            Sr,
            Dt,
            Kt,
            fn,
            8,
            Qt,
            ro,
            1,
            Hi,
            _t,
            Qi,
            wt,
            mn,
            En,
            4,
            Kr,
            2,
            di,
            _i,
            At,
            dr,
            Zr,
            qr,
            _,
            Gi,
            zt,
            Di,
            It,
            bi,
            ki,
            on,
            S,
            $n,
            jt,
            4,
            jn,
            Kn,
            io,
            Kr,
            Ar,
            Wi,
            er,
            _r,
            xn,
            ro,
            9,
            Mt,
            sr,
            Di,
            wt,
            Zi,
            Wr,
            Nt,
            $r,
            Pt,
            fi,
            rn,
            wr,
            Lt,
            at,
            Yn,
            Gr,
            In,
            Wt,
            $r,
            H,
            P,
            vn,
            pt,
            Ji,
            Xt,
            zt,
            no,
            vt,
            qt,
            Qn,
            xr,
            _r,
            tr,
            Fr,
            gt,
            $n,
            Jn,
            0,
            gi,
            bn,
            Ai,
            bn,
            Wn,
            ei,
            zn,
            Mt,
            $,
            Pt,
            An,
            Hi,
            Kt,
            vi,
            gr,
            Gr,
            Nn,
            zr,
            Qi,
            en,
            On,
            mr,
            Ui,
            x,
            $i,
            un,
            Mt,
            cr,
            Bn,
            6,
            ft,
            X,
            Nn,
            U,
            ci,
            sr,
            Di,
            ht,
            D,
            nn,
            Dn,
            Ln,
            In,
            _,
            xr,
            io,
            Ti,
            br,
            kt,
            7,
            Kt,
            Dr,
            Cr,
            oi,
            ri,
            Ar,
            mt,
            xr,
            fi,
            Kt,
            1,
            In,
            Pn,
            lt,
            Jt,
            cn,
            Dn,
            br,
            Hn,
            vn,
            si,
            jn,
            B,
            Ut,
            Ft,
            q,
            Hi,
            Sr,
            7,
            Ji,
            bt,
            S,
            qr,
            zi,
            ft,
            Ii,
            Lr,
            Vn,
            dn,
            Ci,
            Sn,
            Hi,
            Zi,
            pi,
            Xt,
            1,
            Nn,
            ar,
            ci,
            Hi,
            qr,
            V,
            dn,
            Un,
            k,
            Zi,
            Hr,
            1,
            kt,
            vr,
            Lt,
            ki,
            B,
            Dn,
            An,
            xt,
            io,
            T,
            an,
            wn,
            Ar,
            Kn,
            Kt,
            tt,
            Dt,
            $i,
            et,
            2,
            Wt,
            nn,
            Vi,
            Ur,
            $t,
            Ti,
            pt,
            Ci,
            0,
            vi,
            sn,
            qn,
            wr,
            qi,
            fn,
            yt,
            ki,
            si,
            Vi,
            zi,
            wr,
            ir,
            Q,
            mn,
            vn,
            Zt,
            Dt,
            Hi,
            lr,
            qi,
            di,
            dt,
            yn,
            Pn,
            di,
            Mr,
            U,
            en,
            V,
            ur,
            Er,
            Ki,
            Zi,
            Yi,
            U,
            Vr,
            _t,
            Ut,
            ar,
            wi,
            ai,
            D,
            un,
            nn,
            V,
            Vi,
            qi,
            si,
            Dn,
            D,
            zt,
            Xr,
            nn,
            Gr,
            Sr,
            Un,
            jn,
            Fi,
            Rt,
            ht,
            2,
            ji,
            Gi,
            ht,
            ti,
            en,
            Nr,
            vr,
            oi,
            An,
            Tr,
            ai,
            Sr,
            ki,
            wt,
            Fr,
            wn,
            pr,
            nr,
            Pr,
            yt,
            vi,
            br,
            K,
            $t,
            bi,
            Wt,
            U,
            vn,
            S,
            ut,
            Di,
            H,
            Xn,
            ot,
            $t,
            wr,
            Si,
            br,
            kr,
            jn,
            ro,
            Zr,
            bn,
            L,
            Bi,
            T,
            Wt,
            oi,
            7,
            yn,
            Zn,
            ir,
            7,
            hn,
            G,
            ln,
            kr,
            It,
            Vn,
            ei,
            Jt,
            ai,
            yn,
            Ui,
            Kr,
            B,
            Zt,
            Oi,
            Ti,
            Dt,
            ci,
            jn,
            kr,
            Kr,
            rn,
            gt,
            ki,
            sr,
            8,
            gi,
            _i,
            An,
            io,
            Ft,
            ln,
            3,
            yt,
            k,
            Ji,
            H,
            ii,
            Yt,
            $r,
            S,
            cn,
            Gr,
            tr,
            K,
            Ci,
            Ei,
            0,
            lt,
            Qt,
            dr,
            Ht,
            Lt,
            Hi,
            $r,
            fn,
            T,
            g,
            T,
            nt,
            Pt,
            Ft,
            5,
            Bt,
            Pn,
            yt,
            Si,
            9,
            Yi,
            zr,
            q,
            sn,
            Er,
            Dn,
            _i,
            8,
            Ot,
            lt,
            vi,
            xi,
            x,
            ur,
            Jn,
            zn,
            wi,
            Dr,
            1,
            Ii,
            an,
            0,
            jr,
            li,
            Yt,
            Pr,
            Ci,
            rn,
            wn,
            dr,
            xi,
            I,
            _,
            ft,
            di,
            rn,
            Ur,
            ji,
            zr,
            Ot,
            qn,
            kt,
            Hi,
            ht,
            D,
            x,
            Cn,
            or,
            7,
            Ci,
            gr,
            sr,
            Pi,
            Ei,
            1,
            Ci,
            Nr,
            Jr,
            jt,
            U,
            vn,
            tn,
            nn,
            mi,
            Qn,
            tt,
            P,
            2,
            Zn,
            Qt,
            er,
            Wi,
            $t,
            Ti,
            Cn,
            En,
            In,
            1,
            yn,
            B,
            Ui,
            Ir,
            pi,
            Wn,
            Q,
            Z,
            Ui,
            1,
            Ni,
            Si,
            3,
            Rt,
            Er,
            fi,
            Qn,
            Hi,
            Pi,
            Kn,
            R,
            dn,
            Rr,
            Vt,
            un,
            zn,
            si,
            qr,
            L,
            Kn,
            _r,
            Ft,
            Xt,
            lt,
            Qt,
            Jr,
            pn,
            g,
            it,
            ar,
            yi,
            ln,
            In,
            D,
            fr,
            D,
            Gn,
            Un,
            Tt,
            rn,
            Kt,
            Vi,
            _i,
            Zt,
            Jt,
            hr,
            H,
            Z,
            Oi,
            0,
            lt,
            Mr,
            Rr,
            Ci,
            Kt,
            Lr,
            Vr,
            ur,
            Wr,
            Hi,
            ur,
            yn,
            $t,
            _t,
            Pt,
            Gr,
            Ii,
            Ft,
            bt,
            Hn,
            ur,
            Ei,
            Rr,
            1,
            zi,
            L,
            ht,
            Tn,
            Pn,
            Tr,
            zn,
            xn,
            wt,
            yr,
            xi,
            cr,
            Ki,
            Ji,
            Qt,
            sr,
            br,
            pn,
            ot,
            Rr,
            Ai,
            k,
            ir,
            on,
            Mt,
            Sn,
            9,
            or,
            mi,
            Qr,
            k,
            xn,
            yn,
            V,
            bn,
            Li,
            fn,
            Ri,
            Nn,
            io,
            Ki,
            Pi,
            et,
            G,
            2,
            di,
            ci,
            li,
            Bn,
            pr,
            Di,
            ro,
            ro,
            At,
            pr,
            vr,
            P,
            Ni,
            g,
            un,
            jt,
            zi,
            Rr,
            un,
            xn,
            br,
            0,
            2,
            $r,
            ir,
            qi,
            Zr,
            bn,
            $,
            Ur,
            3,
            Zt,
            li,
            Tt,
            9,
            dt,
            Jr,
            Fi,
            Gi,
            Bn,
            si,
            or,
            pt,
            cr,
            Dt,
            wt,
            nt,
            yt,
            I,
            Mr,
            sr,
            Yt,
            oi,
            At,
            3,
            Dr,
            ln,
            $r,
            Ui,
            Cr,
            _,
            mn,
            _,
            wi,
            0,
            Ln,
            Rr,
            Gn,
            ot,
            Er,
            ii,
            Vr,
            Gr,
            2,
            fn,
            ai,
            ht,
            Fr,
            Lt,
            dn,
            At,
            Nt,
            ar,
            An,
            Dn,
            Rn,
            Hr,
            Ai,
            Yn,
            Ii,
            3,
            Bn,
            Yn,
            rn,
            Jr,
            hi,
            In,
            Vi,
            D,
            Bi,
            Gi,
            Rr,
            Ft,
            Rr,
            I,
            dn,
            Sn,
            Ri,
            pr,
            cr,
            Br,
            ri,
            jn,
            xn,
            gr,
            hn,
            wn,
            Ri,
            Xr,
            An,
            $t,
            $i,
            T,
            pn,
            L,
            fr,
            vn,
            Dr,
            cn,
            Xt,
            it,
            4,
            Qi,
            lr,
            Gi,
            xi,
            tn,
            Ct,
            ui,
            Er,
            Dn,
            Dn,
            _,
            di,
            Qr,
            Jr,
            Kr,
            9,
            ct,
            Ut,
            Ni,
            rr,
            5,
            S,
            vn,
            zi,
            tr,
            Qr,
            Bn,
            Ir,
            mi,
            Ji,
            bi,
            Si,
            cn,
            7,
            io,
            hn,
            It,
            fi,
            Qi,
            P,
            Qr,
            Qn,
            dn,
            ni,
            Lt,
            k,
            zt,
            On,
            Ui,
            Kt,
            Nn,
            Q,
            ci,
            ri,
            pr,
            Dr,
            pn,
            jn,
            Li,
            Fn,
            Mn,
            wn,
            Ur,
            rr,
            0,
            ht,
            jn,
            wi,
            ii,
            Gr,
            Kt,
            tt,
            li,
            xn,
            yr,
            gi,
            T,
            vi,
            _n,
            $n,
            X,
            Ai,
            Er,
            Ot,
            ai,
            Ft,
            gt,
            ar,
            Xt,
            mi,
            io,
            Fn,
            ai,
            Fr,
            pn,
            5,
            no,
            Zt,
            Kt,
            cn,
            ri,
            dt,
            rt,
            vr,
            tr,
            rn,
            Cn,
            on,
            Pt,
            Xr,
            1,
            Ki,
            On,
            Dn,
            _r,
            yn,
            lt,
            G,
            H,
            5,
            gn,
            Ki,
            _,
            Pr,
            Li,
            Ct,
            Tt,
            Zn,
            Y,
            qn,
            Rn,
            Qr,
            Ln,
            Wr,
            Or,
            j,
            q,
            Ot,
            Bt,
            qi,
            Kr,
            j,
            wn,
            Yt,
            xi,
            Qr,
            qi,
            ln,
            Ft,
            Lr,
            Pi,
            Kr,
            Z,
            wt,
            $,
            bi,
            _i,
            Vr,
            Or,
            Lt,
            Ct,
            et,
            q,
            C,
            Dt,
            cn,
            Yi,
            Wi,
            Ri,
            yt,
            Nr,
            oi,
            W,
            Ci,
            Mn,
            R,
            Gt,
            wi,
            Ui,
            fr,
            Ut,
            Ki,
            Ut,
            ir,
            tn,
            kr,
            rn,
            ir,
            9,
            Tn,
            zr,
            qt,
            Er,
            $,
            lr,
            Ur,
            Ot,
            fn,
            Vn,
            Ii,
            Dt,
            ro,
            Un,
            ri,
            Rn,
            et,
            vr,
            Fr,
            Nr,
            Ni,
            Ln,
            D,
            si,
            vi,
            hi,
            Er,
            ai,
            2,
            _,
            $i,
            ki,
            Tt,
            Li,
            3,
            Q,
            Xt,
            wn,
            xn,
            In,
            pi,
            pr,
            j,
            Wn,
            jr,
            In,
            Mn,
            At,
            ii,
            Vr,
            vr,
            tn,
            cn,
            En,
            pt,
            ir,
            Sr,
            di,
            Lt,
            Ut,
            Rn,
            Dr,
            Vi,
            Qt,
            4,
            Xn,
            rn,
            Vn,
            nr,
            yr,
            qn,
            qi,
            U,
            Ut,
            Dn,
            nn,
            on,
            gr,
            an,
            pt,
            Pi,
            Zr,
            kr,
            Xt,
            U,
            Ar,
            Vr,
            _t,
            hn,
            mt,
            ar,
            wi,
            Ct,
            xi,
            or,
            xr,
            io,
            H,
            no,
            en,
            gr,
            _,
            Vt,
            qr,
            Bt,
            ar,
            ir,
            ri,
            Cn,
            En,
            S,
            Ln,
            x,
            ii,
            I,
            Zt,
            Xt,
            rn,
            yr,
            rr,
            at,
            Ei,
            et,
            k,
            X,
            xi,
            zt,
            Gr,
            yt,
            J,
            yi,
            Gn,
            rt,
            En,
            Un,
            K,
            fr,
            ln,
            mi,
            Vr,
            sn,
            Hn,
            Wi,
            mi,
            wr,
            kr,
            Xt,
            di,
            Mr,
            K,
            k,
            _t,
            xn,
            Fn,
            $t,
            Si,
            8,
            mt,
            yr,
            wn,
            sn,
            tr,
            Sn,
            9,
            kn,
            ur,
            S,
            wi,
            Di,
            et,
            zi,
            xi,
            Gn,
            Y,
            Ui,
            Oi,
            jt,
            hi,
            nn,
            S,
            cr,
            Si,
            qt,
            Ir,
            vi,
            pi,
            qt,
            sn,
            ft,
            wt,
            rn,
            xr,
            Sr,
            T,
            ri,
            Ot,
            Ni,
            Vn,
            Er,
            ot,
            On,
            $r,
            Rr,
            B,
            cn,
            Yn,
            $i,
            Hi,
            ui,
            Fi,
            hi,
            Rn,
            mt,
            Ht,
            qn,
            ft,
            en,
            tr,
            Vt,
            Un,
            Vn,
            Zn,
            mt,
            ht,
            Bn,
            Ir,
            gt,
            sr,
            er,
            Oi,
            S,
            It,
            Bn,
            Vn,
            nn,
            Kr,
            er,
            kn,
            Nn,
            9,
            $r,
            mr,
            Ir,
            _i,
            zn,
            tt,
            Ei,
            Qr,
            _,
            st,
            Ai,
            rt,
            Ki,
            Rr,
            zn,
            $n,
            zt,
            mi,
            $t,
            en,
            ei,
            Ti,
            br,
            _t,
            L,
            en,
            Hn,
            mi,
            5,
            vn,
            Hr,
            st,
            kt,
            _n,
            br,
            $n,
            Wn,
            Fn,
            it,
            Bn,
            J,
            $,
            ro,
            J,
            Lr,
            vr,
            wn,
            vt,
            Yi,
            Zt,
            Lr,
            $i,
            bt,
            Xn,
            li,
            er,
            Rt,
            Rn,
            Jr,
            Kr,
            no,
            J,
            ur,
            gn,
            tt,
            Vt,
            x,
            Fn,
            I,
            Zi,
            mn,
            St,
            vt,
            qi,
            T,
            Hr,
            An,
            Dr,
            st,
            En,
            ro,
            fn,
            Zt,
            g,
            or,
            0,
            Fn,
            Vt,
            S,
            dn,
            li,
            xt,
            Un,
            Qi,
            ti,
            yi,
            Lt,
            Xn,
            ln,
            Kt,
            Fi,
            St,
            vt,
            it,
            Mr,
            Bn,
            Zi,
            di,
            Wt,
            In,
            Ui,
            un,
            Ct,
            fi,
            ln,
            Zn,
            J,
            li,
            Ir,
            ot,
            rt,
            Bi,
            x,
            Si,
            zn,
            no,
            9,
            un,
            ui,
            no,
            gt,
            U,
            Zr,
            pr,
            Gt,
            or,
            Vt,
            Ci,
            Pt,
            Jt,
            8,
            Un,
            yr,
            or,
            _n,
            Xi,
            zr,
            Wt,
            fi,
            Rn,
            ti,
            Wn,
            un,
            Fi,
            Lr,
            Bn,
            Pn,
            Zn,
            Zn,
            Ei,
            on,
            en,
            vt,
            V,
            $i,
            nt,
            k,
            $i,
            pn,
            ci,
            H,
            zi,
            vt,
            ti,
            L,
            J,
            bt,
            ci,
            Nr,
            pn,
            j,
            Pn,
            $,
            dr,
            ln,
            ln,
            Ht,
            Ht,
            br,
            Zt,
            Ut,
            sn,
            L,
            Gr,
            $r,
            it,
            Rr,
            Yi,
            li,
            Er,
            Ct,
            W,
            an,
            j,
            _n,
            xn,
            er,
            Bi,
            hr,
            cr,
            Y,
            Bt,
            At,
            Pr,
            Un,
            Tn,
            ji,
            en,
            dn,
            Sr,
            rr,
            q,
            X,
            Vt,
            Z,
            hr,
            ji,
            Un,
            Mt,
            fi,
            ui,
            $i,
            L,
            Xn,
            j,
            kr,
            or,
            Zn,
            vr,
            Lt,
            Sr,
            ut,
            x,
            hr,
            br,
            kr,
            fi,
            qi,
            ut,
            j,
            Bt,
            I,
            dn,
            ki,
            At,
            Ur,
            gt,
            Yi,
            Pt,
            gt,
            Ur,
            it,
            ci,
            ji,
            br,
            Xr,
            Un,
            Pn,
            et,
            ar,
            Rn,
            Nn,
            Mr,
            Wn,
            ot,
            qi,
            hn,
            kn,
            8,
            I,
            1,
            Xi,
            zi,
            _i,
            Br,
            xr,
            Nn,
            vr,
            On,
            Ur,
            g,
            Rn,
            Ui,
            Rn,
            ai,
            Wr,
            4,
            X,
            Nr,
            U,
            St,
            fr,
            En,
            Xn,
            En,
            Z,
            Un,
            kt,
            jn,
            Dn,
            Dt,
            En,
            zn,
            3,
            R,
            Yi,
            Gr,
            Mi,
            _n,
            g,
            Zt,
            $,
            Ft,
            pr,
            kr,
            xn,
            An,
            ht,
            An,
            An,
            wr,
            Dt,
            Qr,
            ni,
            Nt,
            oi,
            lr,
            Pt,
            R,
            Ki,
            Wi,
            rr,
            vr,
            rn,
            br,
            yn,
            nr,
            Yr,
            rr,
            Rr,
            Q,
            Ei,
            _n,
            Er,
            Ti,
            sn,
            Ni,
            Bi,
            Ji,
            et,
            un,
            yt,
            wn,
            yt,
            Xr,
            Qr,
            Wi,
            Fr,
            En,
            S,
            Nr,
            gr,
            Gt,
            on,
            Oi,
            Ki,
            Ln,
            Yt,
            gr,
            J,
            Xr,
            mn,
            Dt,
            Ft,
            Bn,
            qi,
            Qt,
            ot,
            zi,
            Ui,
            D,
            xi,
            tt,
            9,
            Y,
            Z,
            Ai,
            nn,
            Zt,
            j,
            z,
            Kn,
            Yr,
            $n,
            U,
            En,
            Ei,
            Ji,
            Bi,
            Hi,
            tr,
            Zn,
            ar,
            _n,
            ji,
            Et,
            nn,
            $t,
            K,
            Fn,
            Yt,
            yi,
            On,
            Xr,
            Vn,
            jn,
            Hn,
            mr,
            Mr,
            ei,
            bn,
            fn,
            Ei,
            Kn,
            Ki,
            yt,
            ht,
            Fr,
            oi,
            zr,
            zn,
            z,
            tn,
            Qi,
            Nr,
            vr,
            Vi,
            ji,
            Ii,
            Cr,
            qn,
            vn,
            Ct,
            xn,
            x,
            on,
            9,
            Zr,
            pt,
            zn,
            rr,
            $,
            Lt,
            Z,
            Vr,
            ki,
            2,
            Ht,
            Qt,
            Wr,
            ti,
            tt,
            Or,
            ft,
            tr,
            Dn,
            Lr,
            Ot,
            nt,
            X,
            Ci,
            Xn,
            Wr,
            Si,
            st,
            gn,
            It,
            jt,
            Ui,
            mr,
            Wn,
            Bi,
            ii,
            z,
            1,
            an,
            zr,
            at,
            et,
            ai,
            io,
            Mt,
            Qi,
            Tr,
            8,
            pr,
            an,
            Rt,
            Et,
            bi,
            H,
            br,
            Wn,
            ni,
            Qi,
            cn,
            _t,
            Y,
            ln,
            Tn,
            Gr,
            J,
            6,
            j,
            bn,
            ui,
            vi,
            $r,
            Ui,
            vt,
            Si,
            mn,
            mn,
            mn,
            Rr,
            yn,
            G,
            lr,
            qi,
            V,
            Kt,
            ci,
            X,
            ct,
            Fi,
            H,
            fi,
            cn,
            Oi,
            lr,
            At,
            ct,
            Ui,
            zi,
            dt,
            J,
            kn,
            Ur,
            Mt,
            _r,
            on,
            qr,
            Bt,
            k,
            2,
            Li,
            Hn,
            Bn,
            at,
            Yi,
            wn,
            ln,
            Ot,
            Jr,
            Bi,
            k,
            Z,
            Ni,
            Ft,
            Qr,
            Yi,
            D,
            On,
            mn,
            Gi,
            br,
            yi,
            An,
            Fi,
            Dt,
            ft,
            ii,
            Ar,
            Xn,
            Ln,
            yi,
            ji,
            Wn,
            C,
            vn,
            _n,
            Xn,
            zt,
            Mn,
            hr,
            Gr,
            an,
            _,
            Hr,
            Hi,
            mr,
            6,
            x,
            dt,
            Ir,
            bi,
            nt,
            qr,
            dn,
            ei,
            kr,
            $i,
            Mn,
            at,
            Tr,
            rt,
            Ki,
            Qi,
            rn,
            yr,
            In,
            ct,
            xt,
            Kt,
            J,
            sr,
            Ti,
            Tr,
            br,
            vn,
            lr,
            q,
            gn,
            Ni,
            oi,
            gt,
            Cr,
            Vn,
            nr,
            T,
            8,
            Rt,
            Un,
            io,
            Un,
            ui,
            Tn,
            Er,
            U,
            pn,
            Xn,
            k,
            ft,
            Lt,
            Ct,
            gi,
            R,
            xt,
            dr,
            7,
            Ei,
            Z,
            $i,
            Lr,
            Cn,
            cr,
            yr,
            4,
            ut,
            qt,
            li,
            mn,
            Ui,
            ar,
            Ut,
            fn,
            Ar,
            Or,
            Lr,
            ut,
            0,
            tn,
            $i,
            dr,
            Fn,
            nn,
            dt,
            Yi,
            $t,
            Ui,
            zt,
            Ti,
            Qn,
            Fn,
            qt,
            Lt,
            Li,
            Rt,
            zn,
            qt,
            Ft,
            Zr,
            Di,
            g,
            Ni,
            Mn,
            En,
            q,
            gt,
            Ji,
            vt,
            Di,
            et,
            sn,
            ln,
            ut,
            Ni,
            jn,
            nt,
            at,
            mi,
            Yi,
            kr,
            Di,
            Hi,
            Fi,
            Wt,
            Nt,
            Dt,
            Ir,
            st,
            Xi,
            Xn,
            q,
            Lt,
            ai,
            Nt,
            Dt,
            V,
            j,
            yn,
            st,
            Pt,
            Un,
            ro,
            Lr,
            vr,
            Gn,
            Pn,
            it,
            ro,
            ui,
            no,
            jn,
            ri,
            mt,
            qt,
            nt,
            fi,
            an,
            Jn,
            4,
            ei,
            ar,
            _n,
            P,
            Kr,
            Z,
            qi,
            ui,
            pt,
            Lt,
            Ln,
            jn,
            ri,
            ai,
            Xt,
            st,
            Yi,
            K,
            Hi,
            er,
            br,
            mr,
            rn,
            1,
            g,
            bn,
            Bt,
            tr,
            qr,
            ti,
            7,
            Vt,
            Bi,
            yt,
            j,
            un,
            Nn,
            ti,
            cr,
            Ut,
            Zn,
            Ar,
            Tr,
            st,
            et,
            Vi,
            S,
            X,
            On,
            Wn,
            at,
            vi,
            X,
            Zn,
            qn,
            no,
            Oi,
            L,
            at,
            ct,
            ar,
            q,
            yt,
            Ti,
            xt,
            Wt,
            Nt,
            1,
            di,
            7,
            ct,
            9,
            yr,
            kr,
            Qi,
            ri,
            V,
            Xi,
            Hn,
            Or,
            io,
            ti,
            gn,
            zr,
            dr,
            Yn,
            Ot,
            Ft,
            Or,
            0,
            yt,
            pr,
            C,
            Fn,
            Hn,
            Cr,
            Ft,
            qr,
            sr,
            Gt,
            In,
            Pi,
            Rt,
            un,
            vn,
            Fn,
            zt,
            qr,
            Pt,
            xi,
            lr,
            zi,
            lr,
            q,
            zi,
            D,
            ji,
            ki,
            G,
            Un,
            dt,
            dr,
            Cr,
            ft,
            bn,
            hn,
            Qt,
            tr,
            8,
            Fr,
            Hr,
            Gn,
            Gn,
            gn,
            qr,
            bi,
            si,
            Wi,
            j,
            Br,
            fi,
            Kt,
            4,
            Bi,
            wr,
            Hi,
            gn,
            Kn,
            Mt,
            gr,
            D,
            ir,
            Xn,
            _t,
            an,
            I,
            R,
            8,
            lt,
            Ln,
            xr,
            L,
            mn,
            J,
            ct,
            Lr,
            an,
            Ii,
            Gr,
            Vn,
            dt,
            Jr,
            xn,
            z,
            Dr,
            L,
            pn,
            pi,
            ht,
            Et,
            Pt,
            Yi,
            tn,
            pr,
            Rr,
            Ur,
            Ui,
            Wt,
            Er,
            _r,
            Kr,
            xn,
            Cn,
            li,
            ct,
            $n,
            En,
            zt,
            It,
            U,
            9,
            ri,
            sr,
            li,
            Bn,
            er,
            G,
            Et,
            un,
            Mn,
            ri,
            st,
            tt,
            or,
            nt,
            at,
            Ar,
            Wn,
            no,
            _,
            Dn,
            Jn,
            Br,
            8,
            Nn,
            ct,
            no,
            Ti,
            Wn,
            Ai,
            R,
            ln,
            gt,
            zr,
            Wi,
            P,
            Sn,
            Ci,
            Ir,
            sn,
            B,
            cn,
            tn,
            3,
            Hr,
            Ut,
            Lr,
            nn,
            Bt,
            xi,
            ct,
            B,
            Mt,
            li,
            It,
            J,
            Sr,
            Ir,
            lr,
            xn,
            sn,
            ot,
            et,
            mi,
            ur,
            D,
            qi,
            zi,
            gr,
            Ii,
            Pn,
            An,
            Mr,
            Fi,
            Rn,
            Mn,
            ft,
            fr,
            D,
            Kr,
            In,
            sr,
            Nn,
            ro,
            kt,
            Wt,
            Tt,
            Cr,
            ri,
            Ci,
            9,
            an,
            wr,
            er,
            rn,
            Vr,
            Ln,
            Gt,
            Ln,
            Jr,
            qt,
            Ln,
            On,
            rt,
            kn,
            Bi,
            g,
            ri,
            Yt,
            En,
            Yr,
            yi,
            Dr,
            ct,
            _n,
            Y,
            6,
            Qn,
            bn,
            dt,
            ir,
            L,
            H,
            rn,
            Vt,
            Di,
            Qn,
            gn,
            ri,
            $,
            Ui,
            ti,
            Rt,
            Hr,
            tn,
            Cr,
            Ni,
            Er,
            Mi,
            Xn,
            fn,
            pn,
            yi,
            Et,
            $r,
            $r,
            lr,
            Vi,
            _r,
            Yr,
            Rt,
            qt,
            Hi,
            Pr,
            Xn,
            Ui,
            Yn,
            no,
            tt,
            vi,
            Sn,
            Vr,
            jn,
            Ur,
            D,
            st,
            Wr,
            9,
            qt,
            Ut,
            qt,
            Mr,
            Ai,
            rn,
            P,
            nt,
            L,
            k,
            en,
            Zn,
            mn,
            Ct,
            Mn,
            Xt,
            Qt,
            Kt,
            Ft,
            Sn,
            yi,
            Bt,
            U,
            ln,
            dt,
            hn,
            dt,
            Rt,
            Hr,
            Tn,
            ut,
            Qt,
            hr,
            ir,
            Xi,
            Zn,
            en,
            tt,
            or,
            x,
            G,
            Ci,
            Fi,
            _i,
            D,
            _,
            dn,
            Zn,
            Dn,
            2,
            Qt,
            Fi,
            Pr,
            Qn,
            At,
            vt,
            Bn,
            pr,
            Sn,
            9,
            Mi,
            pr,
            ni,
            bi,
            Fr,
            Ut,
            Ci,
            $t,
            jr,
            St,
            6,
            gi,
            zr,
            kt,
            Zi,
            x,
            9,
            En,
            hn,
            xr,
            cn,
            ri,
            Wr,
            zn,
            hn,
            0,
            ur,
            yi,
            Sn,
            _n,
            4,
            _i,
            zi,
            Nr,
            Oi,
            R,
            Cn,
            C,
            Ln,
            Zt,
            C,
            rr,
            bt,
            Pi,
            Pt,
            ht,
            Fi,
            xn,
            Dr,
            J,
            Lt,
            pi,
            ot,
            6,
            Wt,
            Yi,
            Wt,
            Er,
            T,
            gt,
            Jt,
            Un,
            Gr,
            nr,
            _n,
            Kr,
            ei,
            0,
            Vn,
            ii,
            pt,
            $,
            $n,
            Et,
            sn,
            vn,
            tn,
            U,
            ir,
            ri,
            T,
            lt,
            Jn,
            Pn,
            Gr,
            Oi,
            Z,
            lt,
            lr,
            _,
            ro,
            wr,
            ct,
            U,
            br,
            nn,
            Gr,
            lr,
            W,
            Kr,
            Xn,
            Vr,
            Pr,
            Ni,
            D,
            Un,
            Kr,
            Er,
            sr,
            Jn,
            wt,
            Ir,
            $,
            kn,
            ti,
            un,
            ct,
            Mr,
            ai,
            Lr,
            Ei,
            ni,
            Wn,
            V,
            Jn,
            Rn,
            En,
            Zr,
            li,
            z,
            Tn,
            tn,
            Xt,
            8,
            G,
            Gt,
            dn,
            Vn,
            un,
            Wt,
            nr,
            Z,
            Wr,
            In,
            tn,
            Yi,
            _i,
            Jt,
            Sn,
            Yr,
            kn,
            qn,
            Zi,
            Jt,
            z,
            Vn,
            Xi,
            jr,
            on,
            fr,
            Vi,
            Fi,
            Mr,
            Nr,
            Pr,
            $n,
            S,
            H,
            Dr,
            ht,
            nt,
            Ai,
            Ur,
            lr,
            Dt,
            En,
            yn,
            fi,
            st,
            q,
            Yi,
            Vt,
            Fn,
            Kn,
            bi,
            Wr,
            mn,
            Yn,
            jt,
            Ai,
            yt,
            nr,
            Bt,
            un,
            I,
            L,
            P,
            Li,
            q,
            hi,
            xn,
            Z,
            ui,
            ln,
            tr,
            Dt,
            Yr,
            Yi,
            jn,
            wi,
            Cn,
            St,
            Pi,
            jr,
            _,
            J,
            wt,
            Zn,
            mt,
            Vt,
            dn,
            Ki,
            S,
            Yn,
            z,
            Nt,
            Lt,
            Xr,
            xi,
            Ti,
            D,
            Ui,
            P,
            In,
            z,
            wr,
            Ai,
            qn,
            on,
            _t,
            0,
            4,
            St,
            Ar,
            dt,
            sn,
            Fi,
            Hn,
            Nr,
            P,
            vn,
            Mr,
            Lr,
            Hi,
            yt,
            jn,
            Ki,
            Ar,
            Cn,
            fr,
            Ni,
            Di,
            ln,
            $n,
            q,
            Xr,
            br,
            Fi,
            vr,
            Yr,
            rn,
            Gr,
            0,
            Mr,
            ar,
            Qi,
            Li,
            Mt,
            Gi,
            cn,
            Qi,
            Qi,
            H,
            Bi,
            ro,
            oi,
            3,
            wn,
            Rr,
            jn,
            Wt,
            an,
            Tt,
            ki,
            gt,
            rt,
            S,
            Ai,
            Wr,
            Or,
            gn,
            pn,
            zt,
            yt,
            B,
            Cr,
            Sn,
            Yr,
            Jn,
            yr,
            Ft,
            Nn,
            H,
            J,
            ro,
            bi,
            ai,
            Jn,
            1,
            Or,
            gt,
            vn,
            z,
            Et,
            wr,
            ci,
            X,
            Ar,
            bi,
            ui,
            Hr,
            H,
            $,
            Zn,
            di,
            2,
            B,
            T,
            Y,
            yt,
            Wn,
            Kr,
            tn,
            xt,
            qt,
            br,
            Nn,
            xr,
            nt,
            oi,
            Gt,
            _n,
            K,
            qi,
            Hi,
            Yn,
            Xr,
            rn,
            6,
            Sn,
            ht,
            2,
            $i,
            mi,
            B,
            B,
            sn,
            tt,
            ct,
            bn,
            vn,
            gr,
            sr,
            zr,
            Ni,
            Br,
            fn,
            ni,
            ar,
            _i,
            z,
            wr,
            Hn,
            X,
            Jr,
            on,
            En,
            Bi,
            ei,
            yi,
            an,
            Si,
            Hn,
            Yt,
            dt,
            Nr,
            U,
            _i,
            dt,
            Ei,
            Gt,
            $t,
            X,
            Z,
            Lr,
            En,
            Hr,
            Et,
            jr,
            rt,
            Xn,
            rt,
            Zi,
            xt,
            Lr,
            R,
            qn,
            T,
            fn,
            ui,
            bn,
            ur,
            di,
            Ct,
            wi,
            ei,
            Nt,
            Kn,
            $r,
            dt,
            xi,
            ln,
            Si,
            x,
            Qr,
            Ht,
            Vt,
            Ln,
            1,
            si,
            Ht,
            un,
            Rn,
            jr,
            Vi,
            Sr,
            Dn,
            Tn,
            $t,
            st,
            Hi,
            Ji,
            Rt,
            ut,
            Bt,
            K,
            gt,
            Kr,
            Jt,
            Di,
            hi,
            $i,
            Ki,
            Wt,
            ti,
            Yn,
            an,
            tt,
            Un,
            sn,
            Xn,
            q,
            7,
            Lt,
            Ai,
            Un,
            ti,
            Li,
            _i,
            Kt,
            Zt,
            ni,
            Ki,
            Vr,
            Ft,
            Vn,
            Lt,
            Un,
            2,
            Wr,
            ut,
            Ft,
            Ot,
            Cr,
            Vt,
            ot,
            mn,
            Ei,
            $n,
            ir,
            P,
            Hn,
            or,
            zt,
            no,
            bi,
            q,
            Sn,
            xt,
            Si,
            ji,
            Ln,
            pt,
            3,
            vi,
            Wt,
            Qr,
            dt,
            wr,
            bi,
            Ln,
            mr,
            Qr,
            Rt,
            Dr,
            un,
            ot,
            Fn,
            g,
            cr,
            Qn,
            Qt,
            x,
            Xt,
            pr,
            Qi,
            Mi,
            Qr,
            bi,
            At,
            En,
            Nn,
            en,
            ct,
            Bn,
            1,
            Fi,
            Ot,
            Ri,
            Yi,
            Vn,
            Li,
            un,
            yr,
            Tr,
            Rn,
            Hn,
            Ui,
            xn,
            On,
            In,
            ci,
            Zt,
            Ot,
            I,
            Dn,
            T,
            xn,
            ii,
            Ar,
            Hn,
            Rr,
            Vr,
            fr,
            Ci,
            ti,
            Li,
            Ni,
            pt,
            Tn,
            Ei,
            Y,
            Ui,
            Br,
            st,
            Vt,
            _t,
            $,
            ct,
            $t,
            an,
            Cr,
            ji,
            z,
            kt,
            3,
            an,
            Qn,
            kt,
            $n,
            1,
            Qi,
            S,
            Ut,
            Mt,
            xi,
            Cr,
            St,
            mn,
            R,
            Qi,
            hi,
            jr,
            gi,
            ur,
            7,
            st,
            Nr,
            $r,
            $i,
            ln,
            Qi,
            Wi,
            _i,
            wt,
            st,
            xr,
            Gi,
            xt,
            D,
            Vn,
            Tt,
            mt,
            vn,
            mi,
            Vr,
            mr,
            Mt,
            9,
            ni,
            Hi,
            bi,
            hi,
            mi,
            $,
            Ir,
            ar,
            hr,
            vt,
            nt,
            _n,
            Mn,
            Un,
            H,
            4,
            zr,
            Jn,
            P,
            Kn,
            Gr,
            ei,
            fr,
            St,
            Jt,
            Yn,
            Vt,
            ft,
            W,
            B,
            Yn,
            ct,
            B,
            Bt,
            Qt,
            xn,
            gn,
            T,
            0,
            Vt,
            ir,
            Rr,
            7,
            ti,
            Tr,
            or,
            Sr,
            Hn,
            gn,
            qi,
            Tt,
            zi,
            $,
            Fi,
            6,
            Rn,
            $r,
            Wi,
            Dr,
            W,
            mn,
            st,
            oi,
            Pn,
            dt,
            Hn,
            li,
            Nt,
            Mt,
            on,
            Kr,
            pt,
            bt,
            9,
            Ot,
            ri,
            Dr,
            vn,
            x,
            H,
            vi,
            $,
            Kn,
            Dt,
            qn,
            Bn,
            zn,
            _i,
            ui,
            jn,
            Y,
            Pr,
            lr,
            Kr,
            S,
            bi,
            4,
            kr,
            gt,
            er,
            sr,
            3,
            pr,
            mr,
            qn,
            jr,
            0,
            Gt,
            nt,
            7,
            D,
            $,
            Vr,
            Nn,
            Ii,
            Cr,
            Nr,
            rn,
            br,
            rt,
            X,
            Bn,
            ki,
            mn,
            9,
            lr,
            on,
            pn,
            oi,
            H,
            Ut,
            Gr,
            ct,
            qt,
            an,
            Lt,
            Tt,
            Qt,
            Tr,
            Br,
            ri,
            K,
            W,
            ar,
            Wr,
            qn,
            hn,
            Fr,
            Mt,
            fi,
            Bi,
            Et,
            Xr,
            Fn,
            $r,
            x,
            _,
            cn,
            Vr,
            Pt,
            Jt,
            St,
            it,
            li,
            j,
            qt,
            $,
            yn,
            si,
            br,
            Ut,
            Yt,
            cn,
            Cn,
            Gr,
            Cr,
            or,
            qt,
            Wn,
            It,
            wi,
            ar,
            or,
            3,
            Wi,
            Ei,
            ct,
            Cn,
            dt,
            pn,
            vn,
            Sr,
            U,
            R,
            Hn,
            Pt,
            Dr,
            qt,
            Dn,
            P,
            Ui,
            Er,
            Zt,
            pt,
            Yi,
            bn,
            ur,
            Kt,
            pt,
            Bi,
            qr,
            Jt,
            Nr,
            er,
            on,
            C,
            lt,
            q,
            ot,
            Xn,
            nn,
            ht,
            jt,
            6,
            Xn,
            ui,
            ct,
            Mn,
            Hn,
            ci,
            Si,
            On,
            Yt,
            Hi,
            ar,
            Ui,
            Vr,
            G,
            zn,
            en,
            ri,
            Vr,
            dt,
            X,
            Si,
            pt,
            An,
            Fi,
            Jt,
            S,
            Er,
            ot,
            Ki,
            ci,
            Ir,
            J,
            Rt,
            ir,
            J,
            xt,
            Dn,
            Nr,
            _t,
            fn,
            At,
            gr,
            un,
            q,
            Er,
            hi,
            wn,
            ai,
            9,
            H,
            Yi,
            ln,
            Ti,
            Zt,
            jt,
            fr,
            wn,
            or,
            q,
            Y,
            Ii,
            ri,
            yi,
            ii,
            2,
            g,
            ti,
            Ji,
            Kt,
            Rn,
            Tn,
            Pr,
            Qr,
            yn,
            at,
            Yr,
            rn,
            tn,
            Ot,
            It,
            xn,
            _t,
            dn,
            Fn,
            X,
            Nn,
            Sr,
            Nr,
            _i,
            mr,
            Ti,
            Bn,
            Vi,
            mr,
            Ni,
            Dt,
            ui,
            Vi,
            Ct,
            ki,
            8,
            ir,
            Yr,
            Jr,
            Xt,
            ai,
            un,
            di,
            An,
            Ir,
            Pi,
            Ft,
            ai,
            Lr,
            $i,
            An,
            Pt,
            Ut,
            Fr,
            Et,
            Vt,
            Yi,
            pt,
            wi,
            an,
            wi,
            I,
            Bt,
            Di,
            1,
            Yi,
            Ai,
            Zt,
            ji,
            Ni,
            K,
            Wt,
            xt,
            yi,
            jr,
            It,
            vt,
            Ni,
            ci,
            mt,
            Lt,
            Ri,
            nn,
            ni,
            kt,
            io,
            _t,
            Fr,
            Ct,
            nt,
            et,
            Sn,
            Pr,
            gr,
            9,
            Mt,
            on,
            jn,
            T,
            hn,
            z,
            mn,
            D,
            D,
            mt,
            K,
            zr,
            B,
            W,
            ct,
            xr,
            H,
            Un,
            Yn,
            ti,
            gr,
            zn,
            Ji,
            kt,
            ei,
            er,
            Vt,
            zi,
            B,
            un,
            bn,
            Ti,
            Vr,
            Kt,
            rr,
            er,
            ir,
            ct,
            _i,
            ji,
            pt,
            Nr,
            Rn,
            T,
            bi,
            6,
            Fr,
            6,
            Sr,
            Or,
            Y,
            Z,
            ai,
            $i,
            Ri,
            fn,
            zt,
            8,
            Kr,
            9,
            Nn,
            U,
            8,
            K,
            0,
            dt,
            k,
            Sn,
            Xn,
            zi,
            Vt,
            ft,
            pr,
            x,
            oi,
            Lt,
            gi,
            Gr,
            Lr,
            yi,
            tt,
            si,
            Yt,
            On,
            3,
            xi,
            U,
            Di,
            Hr,
            It,
            x,
            Xn,
            Kt,
            lt,
            Ei,
            Pt,
            dr,
            Di,
            Bi,
            Qr,
            Oi,
            Gi,
            Rn,
            ar,
            Pt,
            li,
            T,
            Fn,
            pn,
            pn,
            Pn,
            Hi,
            Sn,
            _,
            vt,
            5,
            st,
            vt,
            ei,
            Hr,
            gn,
            ct,
            tn,
            gt,
            U,
            Zi,
            Q,
            tr,
            Jt,
            Nr,
            Sn,
            Yr,
            Si,
            st,
            Bi,
            nt,
            Gn,
            ft,
            Br,
            ki,
            Cr,
            Ut,
            bt,
            en,
            wr,
            ar,
            T,
            Qi,
            xt,
            Ut,
            Gi,
            Ir,
            Or,
            cr,
            nr,
            gi,
            sr,
            dn,
            Qr,
            Mn,
            Vi,
            It,
            Yi,
            C,
            Ut,
            6,
            ut,
            jt,
            yi,
            wr,
            Wn,
            yn,
            xr,
            Pn,
            ji,
            gn,
            Ni,
            Yi,
            zt,
            rr,
            yn,
            fn,
            ut,
            Ui,
            T,
            St,
            En,
            Ki,
            jt,
            zr,
            $r,
            Qi,
            Zr,
            Et,
            _n,
            mt,
            un,
            ji,
            ii,
            hn,
            Un,
            vt,
            k,
            no,
            Qi,
            ei,
            an,
            zr,
            wt,
            ti,
            lt,
            Kt,
            nr,
            gt,
            Un,
            er,
            zn,
            Q,
            zn,
            rr,
            Tr,
            B,
            lt,
            Zn,
            U,
            xi,
            xr,
            ji,
            Wt,
            wi,
            Ci,
            ai,
            Zr,
            Xt,
            Si,
            Wn,
            $r,
            Ji,
            gr,
            li,
            Xi,
            qr,
            an,
            qr,
            Pn,
            It,
            $i,
            ri,
            ai,
            Pi,
            ir,
            ht,
            Rt,
            Vn,
            oi,
            ji,
            Si,
            Sr,
            tr,
            Jt,
            St,
            Gi,
            io,
            er,
            Si,
            Qt,
            sn,
            dr,
            wi,
            Yn,
            En,
            or,
            Gt,
            Mt,
            In,
            En,
            6,
            wn,
            bn,
            Rr,
            Lr,
            $i,
            Ot,
            yr,
            H,
            fn,
            it,
            ot,
            Vr,
            Oi,
            Ft,
            yt,
            wi,
            pr,
            lr,
            jt,
            Wi,
            vn,
            fr,
            g,
            pn,
            Un,
            Dn,
            An,
            cn,
            ii,
            ct,
            io,
            Yn,
            _i,
            Ur,
            Xi,
            Ot,
            hr,
            D,
            hi,
            Gt,
            Dt,
            ur,
            Cn,
            Ui,
            ri,
            2,
            _t,
            Qr,
            Hn,
            Zn,
            wi,
            Mn,
            no,
            Sn,
            Sn,
            L,
            Ri,
            J,
            jt,
            P,
            _n,
            $r,
            7,
            U,
            xi,
            G,
            xr,
            L,
            xr,
            Vn,
            vt,
            et,
            j,
            ki,
            Si,
            ot,
            $t,
            st,
            zt,
            Zr,
            $i,
            pt,
            Si,
            fr,
            Tr,
            gi,
            Er,
            Ii,
            di,
            mn,
            yn,
            $n,
            Nr,
            x,
            io,
            Ei,
            Zn,
            lr,
            wr,
            Wr,
            tr,
            jr,
            bi,
            ji,
            oi,
            wi,
            Sr,
            Kn,
            $r,
            Mi,
            nn,
            oi,
            Mn,
            vn,
            Ri,
            zr,
            ni,
            yn,
            Ln,
            ki,
            rt,
            Cn,
            fi,
            pt,
            Nt,
            x,
            ht,
            ii,
            cr,
            Ai,
            ct,
            Un,
            R,
            Er,
            3,
            J,
            Mt,
            rr,
            Yi,
            k,
            _n,
            Hi,
            Qr,
            jn,
            Nt,
            An,
            fi,
            Ur,
            Ji,
            Fi,
            gt,
            3,
            Vt,
            9,
            Ut,
            vi,
            Wi,
            mn,
            5,
            Pn,
            gn,
            g,
            Vn,
            Xt,
            yr,
            ni,
            ro,
            1,
            zt,
            Er,
            ni,
            rr,
            $r,
            xr,
            pt,
            rn,
            cn,
            Fn,
            Ft,
            B,
            Ct,
            St,
            ni,
            Cn,
            H,
            io,
            $n,
            Dt,
            mt,
            Hr,
            ht,
            bi,
            H,
            Kt,
            Ur,
            Jt,
            Mi,
            ti,
            Z,
            Y,
            Rn,
            Hr,
            Ui,
            zt,
            Sr,
            $,
            jn,
            ut,
            Nr,
            P,
            un,
            Sr,
            Mt,
            Ki,
            Mn,
            oi,
            Xi,
            vi,
            Wt,
            R,
            kr,
            Xt,
            Ni,
            or,
            pi,
            fn,
            kt,
            er,
            ot,
            kt,
            Lr,
            3,
            Fi,
            Ti,
            wr,
            G,
            $r,
            5,
            Mi,
            gt,
            Hi,
            On,
            Y,
            _n,
            Vn,
            zt,
            ot,
            k,
            Pr,
            vn,
            _,
            hn,
            Xt,
            Pi,
            Mn,
            Tn,
            kt,
            ot,
            cr,
            sn,
            Cr,
            Xi,
            Hi,
            Vn,
            gt,
            _i,
            vt,
            Cn,
            cr,
            jr,
            Yn,
            U,
            k,
            dr,
            W,
            di,
            zt,
            gt,
            On,
            bt,
            Un,
            dn,
            Ct,
            sr,
            Or,
            q,
            ui,
            gt,
            x,
            Li,
            dn,
            di,
            Wn,
            bt,
            j,
            zn,
            Mn,
            Br,
            oi,
            ar,
            kr,
            ln,
            tt,
            zn,
            Xr,
            _n,
            vi,
            wt,
            Kr,
            Wi,
            Ar,
            xi,
            $r,
            jr,
            Tt,
            Ci,
            nt,
            Jt,
            Ii,
            Hr,
            Rr,
            qt,
            Fr,
            Yr,
            Nr,
            Ln,
            nn,
            Zr,
            ur,
            I,
            Kn,
            un,
            yn,
            Vt,
            D,
            Dn,
            hr,
            Vr,
            Sr,
            j,
            Rt,
            Oi,
            Xr,
            Bi,
            L,
            Gr,
            j,
            zi,
            C,
            ut,
            6,
            er,
            Dn,
            wi,
            ii,
            ro,
            3,
            Tn,
            lt,
            en,
            Di,
            4,
            kt,
            di,
            Nn,
            Xi,
            L,
            Un,
            mn,
            x,
            hn,
            vr,
            st,
            ri,
            Gn,
            It,
            On,
            Zr,
            mt,
            mi,
            Qt,
            dt,
            Or,
            si,
            zt,
            ni,
            Bn,
            Ut,
            Bt,
            Rr,
            on,
            hn,
            ri,
            Zi,
            rn,
            Kt,
            Ri,
            un,
            an,
            nt,
            Fn,
            ai,
            Wi,
            Ii,
            qt,
            Or,
            gt,
            Qn,
            pr,
            Zi,
            Mn,
            D,
            li,
            xi,
            k,
            $i,
            vi,
            Xt,
            ar,
            nr,
            An,
            Hi,
            it,
            Tn,
            Zr,
            Rr,
            Br,
            Rr,
            fr,
            pn,
            dn,
            Xn,
            rr,
            Kn,
            Mi,
            Kt,
            Kr,
            Ut,
            zr,
            Rr,
            Mr,
            br,
            lt,
            Nn,
            2,
            Br,
            q,
            bi,
            tn,
            ni,
            Mt,
            Ht,
            Fr,
            It,
            Hr,
            xt,
            J,
            Dt,
            lr,
            Nr,
            li,
            Wr,
            Gn,
            St,
            R,
            Tn,
            W,
            Rn,
            jt,
            Tt,
            Dn,
            Cn,
            Vn,
            pn,
            bi,
            Kn,
            Vr,
            Et,
            rr,
            ki,
            ui,
            X,
            Xr,
            V,
            on,
            et,
            An,
            Oi,
            zt,
            Cr,
            cr,
            or,
            Zi,
            An,
            Wn,
            br,
            xr,
            L,
            xn,
            wr,
            Un,
            Xr,
            pn,
            D,
            $,
            $i,
            Gr,
            S,
            Ci,
            rt,
            it,
            ln,
            P,
            Dn,
            Tr,
            on,
            q,
            Er,
            Z,
            Xr,
            C,
            Wr,
            Un,
            ot,
            gn,
            Xn,
            Xn,
            Zt,
            Si,
            sn,
            wi,
            qi,
            hr,
            gr,
            wi,
            xr,
            xi,
            ci,
            _r,
            mn,
            zn,
            ri,
            pr,
            _r,
            S,
            It,
            _t,
            ln,
            lr,
            Xi,
            ut,
            mt,
            ei,
            ii,
            k,
            Yr,
            Xi,
            Ln,
            xi,
            T,
            dr,
            ri,
            Zr,
            mr,
            Rt,
            Dr,
            Fn,
            _n,
            Vn,
            Ui,
            ln,
            Rt,
            kt,
            Ht,
            ot,
            tt,
            sn,
            mt,
            Fi,
            St,
            Qr,
            St,
            Pn,
            B,
            ki,
            bn,
            Yn,
            Ri,
            Li,
            Et,
            S,
            Wn,
            Wi,
            Ln,
            Cr,
            gn,
            Et,
            Un,
            qr,
            Mt,
            Qi,
            ki,
            Mr,
            oi,
            Gt,
            wt,
            ii,
            Dr,
            _,
            nr,
            $,
            Xt,
            Ur,
            H,
            di,
            Vi,
            ar,
            j,
            st,
            xr,
            bi,
            di,
            Ot,
            vt,
            zt,
            Un,
            mn,
            tr,
            V,
            cr,
            rt,
            _r,
            Tr,
            Dt,
            cn,
            B,
            zt,
            Pn,
            Ar,
            Jt,
            Vt,
            Nr,
            Dn,
            mn,
            ci,
            Dt,
            kr,
            Nn,
            gr,
            Zt,
            Zn,
            li,
            ur,
            rt,
            Wn,
            wi,
            I,
            Ct,
            Xn,
            Rt,
            nr,
            Vn,
            zr,
            Zt,
            gt,
            mi,
            Li,
            kr,
            sn,
            ar,
            tt,
            Sn,
            Un,
            wn,
            Xr,
            ir,
            Wi,
            St,
            or,
            gr,
            hi,
            Jt,
            Qi,
            Bn,
            S,
            _t,
            wn,
            Mi,
            Vt,
            nr,
            Jn,
            g,
            Y,
            mr,
            Wn,
            gr,
            Zr,
            Gn,
            Si,
            $r,
            mr,
            dr,
            fn,
            lr,
            Wn,
            Lr,
            Vr,
            xn,
            cr,
            zn,
            zt,
            Oi,
            Rt,
            Vi,
            xt,
            gt,
            Yi,
            Vi,
            S,
            _r,
            U,
            yt,
            lr,
            Zt,
            Zr,
            q,
            Lr,
            hn,
            k,
            Bi,
            wt,
            Mn,
            G,
            Tt,
            lr,
            Sn,
            Kn,
            yn,
            q,
            Ei,
            Pi,
            Li,
            Yn,
            Q,
            _r,
            C,
            j,
            Tr,
            Ot,
            Ht,
            wn,
            Zr,
            gt,
            mi,
            ot,
            pr,
            Lr,
            Di,
            Ot,
            br,
            rt,
            It,
            ar,
            Qr,
            ir,
            Er,
            G,
            0,
            li,
            Nr,
            _i,
            Er,
            jr,
            jn,
            Fi,
            ai,
            hn,
            Q,
            In,
            Qr,
            Y,
            Hr,
            gt,
            q,
            fi,
            Dr,
            Qi,
            Yt,
            mn,
            wn,
            Zn,
            Kr,
            Rn,
            ht,
            Zr,
            Ut,
            _t,
            Ei,
            cn,
            k,
            I,
            dt,
            ki,
            $n,
            Hr,
            X,
            an,
            sr,
            Zr,
            Xr,
            kt,
            Er,
            Gn,
            Ir,
            $r,
            Nt,
            ot,
            Xt,
            xn,
            ei,
            H,
            T,
            rn,
            Di,
            Er,
            wr,
            Yn,
            Dt,
            Xn,
            Gt,
            tr,
            Kn,
            Nt,
            Nn,
            zi,
            tr,
            ar,
            at,
            ei,
            Ri,
            Ht,
            0,
            st,
            z,
            Pr,
            ut,
            lr,
            Ei,
            ai,
            on,
            6,
            U,
            Qt,
            ui,
            Ct,
            vr,
            xn,
            Ot,
            zi,
            nn,
            Wi,
            yn,
            wi,
            er,
            L,
            Ni,
            it,
            ri,
            vn,
            Zr,
            cn,
            Tn,
            vn,
            Vn,
            Bn,
            Ii,
            Or,
            Wr,
            Cn,
            q,
            S,
            On,
            dt,
            X,
            Kn,
            Ni,
            nt,
            _r,
            bt,
            ki,
            S,
            3,
            fi,
            Ur,
            1,
            Yr,
            an,
            fi,
            un,
            hr,
            Ni,
            Ur,
            at,
            Ut,
            Qi,
            Ri,
            Ln,
            ii,
            ai,
            Wi,
            gt,
            Y,
            dr,
            xt,
            Vi,
            en,
            zi,
            Nt,
            Vt,
            $r,
            Ci,
            Jn,
            Ln,
            Yt,
            di,
            J,
            Gn,
            er,
            Ln,
            vt,
            lt,
            rn,
            gn,
            Ri,
            Xn,
            Di,
            mt,
            G,
            5,
            J,
            Gr,
            zn,
            Lr,
            ar,
            An,
            Gt,
            mi,
            An,
            Dt,
            nn,
            ir,
            ir,
            ot,
            an,
            Ln,
            sn,
            Hr,
            $i,
            Gt,
            En,
            Xn,
            D,
            8,
            ft,
            mt,
            wr,
            lr,
            qi,
            Ut,
            Ji,
            dn,
            ni,
            Ft,
            B,
            q,
            Si,
            Xr,
            Hr,
            L,
            it,
            xi,
            nn,
            Pr,
            Nt,
            Ti,
            k,
            ht,
            Ji,
            C,
            cr,
            tn,
            Dn,
            Lr,
            Si,
            Or,
            Xi,
            si,
            7,
            U,
            j,
            bi,
            Pr,
            Ui,
            $t,
            At,
            Kn,
            ur,
            Pr,
            Ji,
            st,
            nt,
            R,
            Ji,
            zi,
            An,
            qi,
            cn,
            Ur,
            J,
            pn,
            W,
            mr,
            wi,
            yn,
            Rr,
            zt,
            ui,
            hn,
            C,
            pn,
            8,
            Jr,
            Ji,
            Sr,
            br,
            R,
            Qi,
            Br,
            5,
            Lt,
            En,
            di,
            an,
            an,
            zn,
            wr,
            fn,
            Qt,
            $r,
            an,
            qr,
            xn,
            ft,
            rn,
            6,
            mi,
            ii,
            br,
            ln,
            Si,
            Sn,
            Ft,
            Jt,
            5,
            un,
            Cr,
            zn,
            Sn,
            j,
            H,
            wt,
            oi,
            Qn,
            pn,
            Kr,
            tr,
            Br,
            Ji,
            Tt,
            Qi,
            Rr,
            tr,
            Vt,
            Si,
            Wt,
            mr,
            H,
            Bi,
            wi,
            Qn,
            qt,
            Vr,
            Si,
            on,
            H,
            Bi,
            st,
            bt,
            yn,
            qn,
            br,
            Yt,
            pt,
            Ni,
            bt,
            sr,
            fr,
            Hi,
            Lt,
            Er,
            An,
            at,
            xi,
            ui,
            pt,
            Tt,
            jt,
            tr,
            C,
            Vr,
            ii,
            zn,
            hr,
            Vr,
            D,
            Fn,
            Ri,
            kn,
            Cr,
            B,
            Ji,
            pn,
            Br,
            Ai,
            vt,
            bi,
            vr,
            bn,
            Dr,
            z,
            Gn,
            di,
            1,
            Gn,
            Ui,
            Ct,
            3,
            yn,
            2,
            Dr,
            Si,
            Un,
            kr,
            zi,
            Ct,
            Ni,
            Ui,
            Ti,
            g,
            xi,
            Kn,
            _n,
            ni,
            ti,
            Hi,
            Rr,
            Kn,
            Tn,
            kr,
            Ci,
            j,
            ii,
            ot,
            tn,
            Y,
            xt,
            Zr,
            Dr,
            Gr,
            ft,
            Lr,
            j,
            Ui,
            Wt,
            Hi,
            Yr,
            _i,
            dn,
            Wt,
            Jt,
            ei,
            mt,
            Sn,
            Qr,
            un,
            ri,
            In,
            Ni,
            H,
            it,
            Ar,
            Di,
            Bi,
            Ut,
            6,
            Er,
            un,
            vt,
            Lr,
            ii,
            Yn,
            J,
            tt,
            Qr,
            Kr,
            jr,
            rr,
            sn,
            Fn,
            xn,
            Jr,
            An,
            un,
            Ni,
            nr,
            Ni,
            Un,
            ht,
            Hn,
            fr,
            Sn,
            tt,
            mr,
            Wr,
            q,
            rr,
            zi,
            Gi,
            4,
            Ni,
            pr,
            Xi,
            K,
            jn,
            $t,
            dr,
            br,
            jr,
            Pr,
            er,
            ir,
            At,
            cn,
            qi,
            S,
            wt,
            Ct,
            sr,
            k,
            Zt,
            T,
            Kr,
            2,
            un,
            zn,
            Nt,
            It,
            qr,
            fn,
            wr,
            ur,
            R,
            P,
            dn,
            Ri,
            it,
            Pr,
            4,
            pi,
            tr,
            3,
            pi,
            pi,
            k,
            ur,
            Xi,
            Et,
            zn,
            V,
            Ri,
            Yn,
            Zi,
            ct,
            V,
            zi,
            Ut,
            mi,
            Bi,
            kt,
            Nr,
            mr,
            Et,
            S,
            Pr,
            _i,
            ni,
            hn,
            Vi,
            Kn,
            z,
            or,
            $t,
            pi,
            ui,
            et,
            Yt,
            pt,
            zn,
            Lr,
            Z,
            Kr,
            _t,
            Kn,
            Un,
            Qi,
            wr,
            mr,
            lt,
            Ft,
            tt,
            on,
            gi,
            Qr,
            X,
            rt,
            mn,
            Er,
            ur,
            hi,
            jr,
            Ar,
            En,
            yi,
            jr,
            oi,
            hi,
            at,
            I,
            R,
            bi,
            R,
            V,
            jn,
            en,
            8,
            ai,
            Lt,
            fn,
            br,
            Yn,
            en,
            gn,
            Lr,
            $i,
            ii,
            Tn,
            hn,
            Mt,
            Ni,
            ki,
            ct,
            pn,
            Sn,
            q,
            Rt,
            Sn,
            Mn,
            Lr,
            Vn,
            ft,
            Ii,
            _n,
            8,
            Tr,
            an,
            j,
            Vt,
            An,
            Si,
            Fn,
            Bt,
            C,
            hr,
            Ni,
            Cn,
            oi,
            S,
            Ht,
            Ri,
            Ti,
            Ji,
            $n,
            Sn,
            Wn,
            En,
            no,
            On,
            4,
            mr,
            jn,
            zr,
            Jn,
            Br,
            Mt,
            Y,
            hi,
            En,
            dt,
            Ft,
            yi,
            an,
            Tt,
            Kr,
            6,
            vr,
            Z,
            $t,
            xi,
            wt,
            Ki,
            ji,
            G,
            W,
            Wi,
            ot,
            Or,
            Ln,
            _n,
            Bi,
            Fn,
            ui,
            7,
            Ot,
            Ji,
            Rn,
            bt,
            nn,
            ri,
            ot,
            Rr,
            Nr,
            mr,
            U,
            xi,
            Ur,
            gt,
            C,
            _n,
            xt,
            Di,
            mt,
            Er,
            kt,
            dr,
            gt,
            ut,
            oi,
            $,
            Dr,
            Kn,
            yt,
            on,
            mt,
            On,
            Ft,
            Ht,
            vi,
            Nt,
            C,
            Ji,
            st,
            Rt,
            X,
            lr,
            Yn,
            bi,
            bt,
            Z,
            io,
            ct,
            Ln,
            8,
            nt,
            an,
            V,
            Ji,
            wr,
            er,
            _r,
            T,
            Dr,
            On,
            j,
            ui,
            it,
            jt,
            R,
            Ai,
            or,
            Ft,
            B,
            yr,
            Yt,
            xi,
            Un,
            Cr,
            Y,
            it,
            Li,
            zr,
            Gr,
            Vi,
            tn,
            nr,
            0,
            Ki,
            br,
            _n,
            zt,
            ht,
            _t,
            on,
            Cr,
            Vt,
            At,
            $t,
            un,
            _r,
            Hr,
            di,
            In,
            7,
            ci,
            Zi,
            kr,
            D,
            it,
            ri,
            si,
            ut,
            In,
            en,
            hi,
            Er,
            Oi,
            qr,
            Ii,
            g,
            An,
            si,
            xr,
            Jt,
            ot,
            Xr,
            Wt,
            ot,
            Wt,
            st,
            Ri,
            yn,
            cr,
            Mt,
            7,
            Gi,
            g,
            Lr,
            ji,
            Ui,
            Ui,
            wt,
            Ft,
            Ui,
            Tn,
            vi,
            Kn,
            Yi,
            Ln,
            Si,
            ri,
            Dr,
            vn,
            Ji,
            Kr,
            H,
            _i,
            1,
            Vt,
            hn,
            si,
            er,
            tn,
            et,
            Vt,
            Vt,
            Vi,
            zr,
            Gn,
            mn,
            Kr,
            nt,
            Kt,
            gi,
            $n,
            ot,
            Qr,
            _t,
            Qi,
            Ur,
            qn,
            Yi,
            Hi,
            ui,
            $r,
            Vn,
            vr,
            _,
            jr,
            nr,
            rn,
            sr,
            7,
            wr,
            fn,
            pr,
            Ii,
            kr,
            cn,
            bt,
            Jr,
            ur,
            kr,
            ki,
            St,
            Ki,
            ur,
            nt,
            ai,
            Fi,
            Nt,
            nr,
            ji,
            tr,
            ni,
            vi,
            J,
            W,
            _i,
            si,
            qn,
            Ji,
            Er,
            gi,
            nt,
            Q,
            $r,
            ki,
            Dt,
            ur,
            kt,
            6,
            Ai,
            Ki,
            ft,
            Q,
            H,
            L,
            Si,
            rn,
            Ai,
            g,
            ci,
            Hr,
            Tr,
            Sr,
            _r,
            rt,
            Ir,
            g,
            yr,
            on,
            on,
            G,
            X,
            fr,
            wr,
            qn,
            tr,
            zr,
            Q,
            dn,
            ct,
            Ir,
            wn,
            at,
            U,
            Tt,
            er,
            Ki,
            Ur,
            ui,
            Li,
            Mi,
            Br,
            yt,
            Vr,
            Er,
            V,
            nr,
            tn,
            on,
            mt,
            5,
            fn,
            yr,
            Ui,
            vr,
            ht,
            vi,
            Mt,
            yn,
            $t,
            Jt,
            ai,
            Di,
            zn,
            en,
            ii,
            Qt,
            yn,
            Xr,
            Hr,
            ri,
            Fr,
            sn,
            Q,
            Or,
            et,
            Dr,
            ro,
            cr,
            ln,
            sr,
            Dt,
            hi,
            Cr,
            mn,
            Hn,
            Qt,
            ci,
            pr,
            k,
            ot,
            L,
            Z,
            Ht,
            it,
            Wn,
            D,
            kn,
            sn,
            Dn,
            Zr,
            ei,
            jt,
            Z,
            ot,
            $r,
            qr,
            ln,
            fr,
            j,
            Fi,
            kt,
            ft,
            Xt,
            In,
            ai,
            $r,
            Br,
            Hi,
            Fi,
            Di,
            en,
            Qi,
            si,
            en,
            Vt,
            on,
            kt,
            Zn,
            bn,
            tr,
            li,
            hi,
            $t,
            un,
            qt,
            J,
            Xt,
            Ir,
            nr,
            er,
            $i,
            En,
            Dn,
            or,
            Wt,
            Xr,
            Ji,
            K,
            ft,
            fr,
            Qn,
            lt,
            zi,
            an,
            vn,
            Qt,
            li,
            dn,
            fr,
            7,
            $,
            xr,
            Zt,
            cr,
            Y,
            Xn,
            Mn,
            li,
            nt,
            Wi,
            ei,
            nr,
            xt,
            br,
            Xt,
            P,
            kr,
            Jr,
            Bn,
            Kt,
            sn,
            kt,
            st,
            nn,
            Nt,
            Lr,
            ln,
            pn,
            ht,
            zn,
            5,
            ki,
            P,
            it,
            Vi,
            x,
            Vi,
            Ui,
            jt,
            An,
            nn,
            Gr,
            xn,
            yt,
            br,
            z,
            Fi,
            xi,
            Wn,
            Pr,
            Rr,
            Qi,
            Ji,
            0,
            Br,
            9,
            Jt,
            Zn,
            Kn,
            or,
            Un,
            Yi,
            In,
            L,
            dr,
            _r,
            ln,
            R,
            dt,
            or,
            Br,
            9,
            bn,
            k,
            Nr,
            ut,
            3,
            _n,
            qt,
            dr,
            fn,
            Cr,
            Wn,
            R,
            hn,
            Bi,
            Fi,
            _i,
            D,
            Et,
            Qt,
            x,
            yn,
            ln,
            In,
            Kn,
            Zi,
            cn,
            Mi,
            Di,
            Wn,
            q,
            Wn,
            vr,
            Cn,
            Ar,
            xn,
            qr,
            7,
            Mr,
            it,
            Nn,
            Un,
            ji,
            k,
            Xt,
            dr,
            Tt,
            Xn,
            jr,
            Qn,
            Dt,
            zi,
            1,
            kt,
            pi,
            Pt,
            Ar,
            mi,
            H,
            Wn,
            Wt,
            pi,
            Ii,
            ht,
            5,
            xi,
            zn,
            At,
            C,
            Nr,
            bn,
            Oi,
            Gt,
            x,
            cr,
            Wi,
            Wn,
            wr,
            Bt,
            Jt,
            ci,
            _n,
            Wn,
            ai,
            Vt,
            jn,
            V,
            Rt,
            dn,
            hn,
            cn,
            Tr,
            Qt,
            sn,
            sn,
            Ot,
            q,
            Ot,
            ei,
            Nt,
            Jr,
            X,
            fr,
            8,
            Y,
            Y,
            nn,
            $n,
            k,
            cn,
            _n,
            pt,
            mr,
            vn,
            Xr,
            _t,
            pt,
            Fi,
            Ln,
            Gr,
            bt,
            Jr,
            Bn,
            _,
            2,
            zt,
            Dt,
            kt,
            fi,
            pt,
            tr,
            ft,
            kr,
            Oi,
            hi,
            zn,
            Ui,
            zt,
            xn,
            Bn,
            Oi,
            Rn,
            Lt,
            yt,
            8,
            Gr,
            Zt,
            ot,
            Dt,
            An,
            9,
            It,
            Hi,
            Pn,
            Gi,
            un,
            Q,
            Wi,
            Xi,
            bn,
            tn,
            j,
            _,
            An,
            dn,
            Et,
            st,
            fi,
            Pn,
            li,
            fn,
            J,
            bi,
            Ki,
            bn,
            U,
            fi,
            li,
            Ot,
            x,
            mn,
            Qt,
            _t,
            Jr,
            Qt,
            Ai,
            Wt,
            _t,
            zt,
            ni,
            Bt,
            io,
            Pr,
            gt,
            pn,
            mt,
            Ur,
            gi,
            bt,
            Ln,
            7,
            Gn,
            ii,
            j,
            _,
            vn,
            pn,
            Pi,
            fr,
            Wn,
            Yr,
            ti,
            Ir,
            ct,
            br,
            Zi,
            Wt,
            bt,
            zt,
            di,
            dn,
            $t,
            $,
            nr,
            On,
            I,
            Q,
            Ti,
            pt,
            Vi,
            vt,
            bi,
            Ht,
            Zn,
            $,
            ar,
            Dt,
            Ln,
            Vn,
            on,
            $i,
            ln,
            Qt,
            lr,
            Wi,
            Tt,
            _n,
            Lr,
            fr,
            tn,
            4,
            br,
            zr,
            Fr,
            nr,
            Bt,
            Di,
            V,
            Nn,
            T,
            Gt,
            Bi,
            qi,
            lt,
            Ht,
            j,
            On,
            Gi,
            Z,
            vn,
            T,
            Ei,
            Dr,
            nr,
            Nr,
            Rr,
            Gn,
            S,
            In,
            x,
            lt,
            si,
            st,
            Ti,
            Nr,
            hn,
            Z,
            T,
            Ar,
            Xi,
            et,
            Q,
            mr,
            Yr,
            z,
            qt,
            Ar,
            T,
            Ar,
            sn,
            Kr,
            Ct,
            en,
            D,
            Jn,
            lt,
            Zi,
            kt,
            V,
            xi,
            Vi,
            R,
            V,
            Li,
            Ar,
            Ot,
            It,
            zr,
            Ki,
            Vt,
            di,
            hi,
            Zt,
            _i,
            zi,
            jr,
            Cn,
            Or,
            gr,
            Yr,
            Ot,
            or,
            Ot,
            Vi,
            ii,
            Xn,
            ut,
            ti,
            mn,
            Kr,
            j,
            0,
            Nt,
            nn,
            Hi,
            ct,
            $t,
            ai,
            qt,
            L,
            Wr,
            K,
            ro,
            Hi,
            Fr,
            Wr,
            Wi,
            Y,
            tt,
            H,
            Mi,
            rn,
            R,
            V,
            mi,
            $,
            mi,
            gi,
            Si,
            gr,
            kn,
            vn,
            k,
            vt,
            Hr,
            ro,
            un,
            Ci,
            Tr,
            Nr,
            sn,
            Qn,
            W,
            qi,
            lr,
            Fn,
            Zt,
            Ir,
            Xn,
            Di,
            R,
            Mr,
            9,
            Nr,
            zn,
            Ti,
            Qn,
            $i,
            Et,
            Wt,
            Wi,
            oi,
            Li,
            Yn,
            Ir,
            bi,
            Qt,
            Cn,
            Rn,
            kt,
            Hr,
            xt,
            In,
            Yr,
            no,
            Pr,
            Zr,
            dr,
            ji,
            Zt,
            ti,
            U,
            hi,
            At,
            mr,
            wn,
            Hi,
            Br,
            6,
            Tr,
            ut,
            L,
            pn,
            Dt,
            Br,
            Bt,
            Ht,
            Mr,
            qi,
            fr,
            ui,
            nt,
            _t,
            bi,
            Dt,
            vi,
            V,
            mi,
            Ui,
            Rn,
            X,
            Jr,
            Br,
            zn,
            Et,
            $,
            ir,
            At,
            bi,
            Cn,
            hi,
            lt,
            Dr,
            U,
            Nr,
            Z,
            fn,
            et,
            ir,
            Ti,
            J,
            Et,
            qi,
            ri,
            Kr,
            L,
            sn,
            Xi,
            Ti,
            Ii,
            zi,
            Ft,
            Ri,
            Sr,
            ri,
            ki,
            xn,
            X,
            kr,
            S,
            io,
            Hn,
            C,
            dt,
            Ui,
            Rn,
            it,
            j,
            Lt,
            I,
            bi,
            kr,
            sr,
            mt,
            dt,
            Ui,
            Zt,
            jr,
            vi,
            T,
            Or,
            Lr,
            Ni,
            ci,
            bn,
            yt,
            Mi,
            Or,
            er,
            Fn,
            6,
            Br,
            Ii,
            jn,
            mr,
            4,
            $n,
            cn,
            jn,
            Dn,
            yt,
            Ar,
            rr,
            Jn,
            pt,
            mn,
            Rt,
            wt,
            $,
            en,
            ni,
            $,
            gi,
            hi,
            $,
            mi,
            Ft,
            hr,
            En,
            tn,
            sr,
            Xr,
            mr,
            vn,
            V,
            Et,
            bt,
            ht,
            _i,
            cn,
            Dr,
            $,
            Ir,
            et,
            Pt,
            Jt,
            li,
            Li,
            xt,
            k,
            pr,
            yi,
            8,
            Qn,
            rt,
            L,
            7,
            Cn,
            bn,
            Vi,
            Xn,
            Xr,
            wr,
            Hn,
            Hi,
            Mt,
            zi,
            Wi,
            Ui,
            sr,
            xt,
            _n,
            at,
            ui,
            K,
            wt,
            T,
            hi,
            wr,
            ti,
            hn,
            T,
            Or,
            zt,
            Mt,
            Wn,
            wn,
            Xt,
            kr,
            J,
            Kn,
            Mi,
            U,
            qt,
            ut,
            yn,
            Xi,
            dt,
            cn,
            Ht,
            Br,
            $,
            In,
            li,
            Wn,
            _,
            Tt,
            bt,
            Z,
            Bn,
            En,
            x,
            Ui,
            mr,
            Gn,
            vi,
            Yi,
            io,
            Cr,
            ri,
            et,
            G,
            ct,
            Hr,
            xt,
            ro,
            Jr,
            ui,
            an,
            Li,
            On,
            ro,
            Zr,
            Ot,
            Tt,
            Qn,
            er,
            Vt,
            vn,
            vi,
            kr,
            hn,
            R,
            ut,
            En,
            Yr,
            _r,
            Qi,
            ar,
            Nr,
            Xr,
            Gt,
            ft,
            Qt,
            yr,
            g,
            x,
            An,
            Pr,
            _i,
            yi,
            R,
            cr,
            K,
            hn,
            Wn,
            ir,
            zt,
            hi,
            gr,
            Dn,
            Ft,
            Dn,
            Ct,
            Or,
            wi,
            tn,
            Kn,
            ii,
            Lt,
            ti,
            pr,
            Ut,
            ki,
            5,
            zi,
            xt,
            Vn,
            nr,
            cn,
            qi,
            Ai,
            qi,
            ro,
            xn,
            Rn,
            dt,
            Ii,
            Wn,
            Wr,
            xn,
            An,
            _,
            Ni,
            H,
            En,
            Bi,
            Wn,
            wt,
            tn,
            Q,
            kr,
            Vr,
            oi,
            Q,
            mr,
            Fn,
            8,
            Wt,
            Er,
            Zt,
            Qi,
            ot,
            4,
            hn,
            In,
            wn,
            Ci,
            Tn,
            W,
            gt,
            Si,
            ct,
            Z,
            bn,
            qn,
            tr,
            8,
            St,
            Jn,
            Lt,
            Q,
            ct,
            ii,
            gi,
            si,
            7,
            br,
            Xn,
            un,
            Xr,
            yt,
            ir,
            ar,
            mn,
            lr,
            ci,
            no,
            T,
            rt,
            lt,
            ut,
            Pi,
            bn,
            Pr,
            _,
            It
        ]))), i[0] = n + "," + r, i[1] = f.H[i[0]], void 0 !== i[1] ? i[1] : f.H[i[0]] = f.L.slice(n, r);
    }
    function v(n) {
        v.T || (v.T = function() {
            function n() {
                this.q = new Uint16Array(qi), this.nn = new Uint16Array(288);
            }
            function r(r, i) {
                this.tn = r, this.un = 0, this.fn = 0, this.vn = 0, this.en = i, this.cn = 0, this.dn = new n, this.an = new n;
            }
            function i(n, r, i, t) {
                var o = [];
                o[0] = 0;
                for(; o[0] < i; ++o[0])n[o[0]] = 0;
                o[0] = 0;
                for(; o[0] < bt - i; ++o[0])n[o[0] + i] = o[0] / i | 0;
                o[1] = t, o[0] = 0;
                for(; o[0] < bt; ++o[0])r[o[0]] = o[1], o[1] += 1 << n[o[0]];
            }
            function t(n, r, i, t) {
                var o = [];
                o[0] = 0;
                for(; o[0] < qi; ++o[0])n.q[o[0]] = 0;
                o[0] = 0;
                for(; o[0] < t; ++o[0])n.q[r[i + o[0]]]++;
                n.q[0] = 0, o[1] = 0, o[0] = 0;
                for(; o[0] < qi; ++o[0])M[o[0]] = o[1], o[1] += n.q[o[0]];
                o[0] = 0;
                for(; o[0] < t; ++o[0])r[i + o[0]] && (n.nn[M[r[i + o[0]]]++] = o[0]);
            }
            function o(n) {
                var r = [];
                return n.vn-- || (n.fn = n.tn[n.un++], n.vn = 7), r[0] = 1 & n.fn, n.fn >>>= 1, r[0];
            }
            function u(n, r, i) {
                var t = [];
                if (!r) return i;
                for(; n.vn < V;)n.fn |= n.tn[n.un++] << n.vn, n.vn += 8;
                return t[0] = n.fn & 65535 >>> qi - r, n.fn >>>= r, n.vn -= r, t[0] + i;
            }
            function f(n, r) {
                var i = [];
                for(; n.vn < V;)n.fn |= n.tn[n.un++] << n.vn, n.vn += 8;
                i[0] = 0, i[1] = 0, i[2] = 0, i[3] = n.fn;
                do i[1] = 2 * i[1] + (1 & i[3]), i[3] >>>= 1, ++i[2], i[0] += r.q[i[2]], i[1] -= r.q[i[2]];
                while (i[1] >= 0);
                return n.fn = i[3], n.vn -= i[2], r.nn[i[0] + i[1]];
            }
            function v(n, r, i) {
                var o = [];
                o[0] = u(n, 5, 257), o[1] = u(n, 5, 1), o[2] = u(n, 4, 4), o[3] = 0;
                for(; o[3] < mi; ++o[3])p[o[3]] = 0;
                o[3] = 0;
                for(; o[3] < o[2]; ++o[3])o[6] = u(n, 3, 0), p[m[o[3]]] = o[6];
                t(b, p, 0, mi), o[4] = 0;
                for(; o[4] < o[0] + o[1];)switch(o[7] = f(n, b), o[7]){
                    case qi:
                        o[8] = p[o[4] - 1], o[5] = u(n, 2, 3);
                        for(; o[5]; --o[5])p[o[4]++] = o[8];
                        break;
                    case xr:
                        o[5] = u(n, 3, 3);
                        for(; o[5]; --o[5])p[o[4]++] = 0;
                        break;
                    case gr:
                        o[5] = u(n, 7, pi);
                        for(; o[5]; --o[5])p[o[4]++] = 0;
                        break;
                    default:
                        p[o[4]++] = o[7];
                }
                t(r, p, 0, o[0]), t(i, p, o[0], o[1]);
            }
            function e(n, r, i) {
                var t = [];
                for(;;){
                    if (t[0] = f(n, r), t[0] === to) return 0;
                    if (t[0] < to) n.en[n.cn++] = t[0];
                    else {
                        t[0] -= 257, t[1] = u(n, s[t[0]], h[t[0]]), t[2] = f(n, i), t[3] = n.cn - u(n, y[t[2]], N[t[2]]), t[4] = t[3];
                        for(; t[4] < t[3] + t[1]; ++t[4])n.en[n.cn++] = n.en[t[4]];
                    }
                }
            }
            function c(n) {
                var r = [];
                for(; n.vn > 8;)n.un--, n.vn -= 8;
                if (r[0] = n.tn[n.un + 1], r[0] = to * r[0] + n.tn[n.un], r[1] = n.tn[n.un + 3], r[1] = to * r[1] + n.tn[n.un + 2], r[0] !== (65535 & ~r[1])) return -3;
                n.un += 4, r[2] = r[0];
                for(; r[2]; --r[2])n.en[n.cn++] = n.tn[n.un++];
                return n.vn = 0, 0;
            }
            var d = {
                exports: {}
            };
            var a = (d.exports, new n);
            var l = new n;
            var s = new Uint8Array(bt);
            var h = new Uint16Array(bt);
            var y = new Uint8Array(bt);
            var N = new Uint16Array(bt);
            var m = new Uint8Array([
                qi,
                xr,
                gr,
                0,
                8,
                7,
                9,
                6,
                Tr,
                5,
                pi,
                4,
                K,
                3,
                Oi,
                2,
                xt,
                1,
                Ur
            ]);
            var b = new n;
            var p = new Uint8Array(320);
            var M = new Uint16Array(qi);
            !function(n, r) {
                var i = [];
                i[0] = 0;
                for(; 7 > i[0]; ++i[0])n.q[i[0]] = 0;
                n.q[7] = V, n.q[8] = Br, n.q[9] = $n, i[0] = 0;
                for(; i[0] < V; ++i[0])n.nn[i[0]] = to + i[0];
                i[0] = 0;
                for(; i[0] < Or; ++i[0])n.nn[V + i[0]] = i[0];
                i[0] = 0;
                for(; 8 > i[0]; ++i[0])n.nn[168 + i[0]] = 280 + i[0];
                i[0] = 0;
                for(; i[0] < $n; ++i[0])n.nn[176 + i[0]] = Or + i[0];
                i[0] = 0;
                for(; 5 > i[0]; ++i[0])r.q[i[0]] = 0;
                r.q[5] = ro, i[0] = 0;
                for(; i[0] < ro; ++i[0])r.nn[i[0]] = i[0];
            }(a, l), i(s, h, 4, 3), i(y, N, 2, 1), s[28] = 0, h[28] = 258, d.exports = function(n, i) {
                var t = [];
                t[0] = new r(n, i);
                do {
                    switch(t[1] = o(t[0]), t[2] = u(t[0], 2, 0), t[2]){
                        case 0:
                            t[3] = c(t[0]);
                            break;
                        case 1:
                            t[3] = e(t[0], a, l);
                            break;
                        case 2:
                            v(t[0], t[0].dn, t[0].an), t[3] = e(t[0], t[0].dn, t[0].an);
                            break;
                        default:
                            t[3] = -3;
                    }
                    if (0 !== t[3]) throw Error("Data error");
                }while (!t[1]);
                return t[0].cn < t[0].en.length ? "function" == typeof t[0].en.slice ? t[0].en.slice(0, t[0].cn) : t[0].en.subarray(0, t[0].cn) : t[0].en;
            };
            var w = d.exports;
            return function(n) {
                return new Uint8Array(w(n, []));
            };
        }());
        var r = v.T(n);
        return function() {
            var n = [];
            n[0] = "", n[1] = 0;
            for(; n[1] < r.length; n[1]++)n[0] = n[0] + String.fromCharCode(r[n[1]]);
            return n[0];
        }();
    }
    function e(n) {
        var r = [];
        return e[ao] || (e[ao] = {}), r[1] = e[ao][n], void 0 !== r[1] ? r[1] : e[ao][n] = (r[0] = n, (function(n) {
            return n = n | wo, (n = (n = (n = (Math[lo]((n = (n = n >>> wo) + Ao & Fo) - Eo & Fo, Oo) >>> wo & Fo) >>> wo) + Xo & Fo) + jo & Fo) - -go & Fo;
        })[so](void 0, r[0]));
    }
    function c(n) {
        var r = [];
        return c[ho] || (c[ho] = {}), r[Au] = c[ho][n], void 0 !== r[Au] ? r[Au] : c[ho][n] = (r[wo] = n, (function(n) {
            return n = n | wo, (n = (n = (n = (Math[lo]((n = (n = n >>> wo) + Ao & Fo) - Eo & Fo, Oo) >>> wo & Fo) >>> wo) + Xo & Fo) + jo & Fo) - -go & Fo;
        })[so](void 0, r[wo]));
    }
    function d(n) {
        var r = [];
        var i = [];
        return d[yo] || (d[yo] = {}), i[wo] = d[yo][n], void 0 !== i[wo] ? i[wo] : d[yo][n] = (r[wo] = n, (function(n) {
            return n = n | wo, (n = (n = (n = (Math[lo]((n = (n = n >>> wo) + Ao & Fo) - Eo & Fo, Oo) >>> wo & Fo) >>> wo) + Xo & Fo) + jo & Fo) - -go & Fo;
        })[so](void 0, r[wo]));
    }
    function a(n) {
        var r = [];
        var i = [];
        return a[No] || (a[No] = {}), i[wo] = a[No][n], i[wo] !== void d(xu) ? i[c(xu)] : a[No][n] = (r[0] = n, (function(n) {
            var r = [];
            r[Ru] = _o, r[wo] = n, r[Au] = atob(r[wo]);
            var i = wo;
            for(; i < r[Au][mo]; i = i + Ru){
                var t = ((r[Au][bo](i) & Uu) << Su | r[Au][bo](i + Au) & Uu) >>> wo;
                n = ((n = (n = (Math[lo]((n = ((n = ((n = ((n = t) >>> Iu | n << Zo - Iu) & Bu) >>> Du | n << Zo - Du) & Bu) ^ qu) & Bu) - zu & Bu, $u) >>> wo & Bu) >>> wo) + Ku & Bu) >>> Iu | n << Zo - Iu) & Bu, r[Ru] += String[po](n & Bu);
            }
            return r[Ru];
        })[so](void 0, r[0]));
    }
    function l(n) {
        var r = [];
        var i = [];
        return l[Mo] || (l[Mo] = {}), i[wo] = l[Mo][n], i[wo] !== void d(xu) ? i[wo] : l[Mo][n] = (r[0] = n, (function(n) {
            var r = [];
            r[Ru] = _o, r[wo] = n, r[Au] = atob(r[wo]);
            var i = wo;
            for(; i < r[Au][mo]; i = i + Ru){
                var t = ((r[Au][bo](i) & Uu) << Su | r[Au][bo](i + Au) & Uu) >>> wo;
                n = ((n = (n = (Math[lo]((n = t) - Vu & Bu, Cu) >>> wo & Bu) >>> wo) - Pu & Bu) >>> To | n << Zo - To) & Bu, r[Ru] += String[po](n & Bu);
            }
            return r[Ru];
        })[so](void 0, r[0]));
    }
    function s(n) {
        var r = [];
        var i = [];
        return s[ao] || (s[ao] = {}), i[wo] = s[ao][n], i[wo] !== void d(xu) ? i[wo] : s[ao][n] = (r[0] = n, (function(n) {
            var r = [];
            r[Ru] = _o, r[wo] = n, r[Au] = atob(r[wo]);
            var i = wo;
            for(; i < r[Au][mo]; i = i + Ru){
                var t = ((r[Au][bo](i) & Uu) << Su | r[Au][bo](i + Au) & Uu) >>> wo;
                n = (n = ((n = ((n = (Math[lo]((n = t) - Qu & Bu, Yu) >>> wo & Bu) >>> wo) ^ nf) & Bu) >>> Su | n << Zo - Su) & Bu) - rf & Bu, r[Ru] += String[po](n & Bu);
            }
            return r[Ru];
        })[so](void 0, r[0]));
    }
    function h(n, r, i) {
        var t = [];
        if (i || arguments[CG[Kf]] === CG[Df]) {
            t[wo] = CG[ko], t[Au] = r[CG[Kf]];
            for(; t[wo] < t[Au]; t[wo]++)!t[Ru] && t[wo] in r || (t[Ru] || (t[Ru] = Array[CG[Mf]][CG[iv]][CG[qf]](r, CG[ko], t[wo])), t[Ru][t[wo]] = r[t[wo]]);
        }
        return n[CG[bf]](t[Ru] || Array[CG[Mf]][CG[iv]][CG[qf]](r));
    }
    function y(n, r) {
        var i = [];
        var t = [];
        if (t[wo] = CG[vw](n), t[Au] = t[wo][CG[Kf]] - CG[Zf], t[Au] < CG[Zf]) return t[wo];
        t[Ru] = CG[ko], t[yb] = t[wo][t[Au]], t[Du] = t[wo][CG[ko]], t[mb] = ~~(CG[gf] + d(oA) / (t[Au] + CG[Zf]));
        for(; t[mb]-- > CG[ko];){
            t[c(af)] = t[Ru] + (i[Su] = PG[We], (function(n) {
                return (n[CG[ko]] >>> PG[xv]) + (n[CG[Zf]] >>> PG[xv]) + (n[CG[Df]] >>> PG[e(SM)]);
            })[so](void 0, i[Su])) >>> CG[ko], t[Iu] = t[Ru] >>> CG[Df] & CG[yv], t[Nb] = CG[ko];
            for(; t[Nb] < t[Au]; t[Nb]++)t[Du] = t[wo][t[Nb] + CG[Zf]], t[yb] = t[wo][t[Nb]] = t[wo][t[Nb]] + ((t[yb] >>> CG[re] ^ t[Du] << CG[Df]) + (t[c(vf)] >>> CG[yv] ^ t[yb] << CG[Xv]) ^ (t[Ru] ^ t[c(vf)]) + (r[t[Nb] & CG[yv] ^ t[Iu]] ^ t[yb])) >>> CG[ko];
            t[Du] = t[wo][CG[ko]], t[yb] = t[wo][t[Au]] = t[wo][t[Au]] + ((t[yb] >>> CG[re] ^ t[Du] << CG[Df]) + (t[Du] >>> CG[yv] ^ t[yb] << CG[Xv]) ^ (t[Ru] ^ t[Du]) + (r[t[c(Tf)] & CG[yv] ^ t[Iu]] ^ t[yb])) >>> CG[ko];
        }
        return t[wo];
    }
    function N(n, r) {
        var i = [];
        var t = [];
        if (!(n && r && n[CG[Kf]] && r[CG[Kf]])) return null;
        t[wo] = CG[gM](n[CG[Kf]], r[CG[Kf]]), t[Au] = CG[YX]() || CG[Zf], t[Ru] = [], t[yb] = CG[ko], t[Du] = CG[ko], t[Iu] = CG[ko];
        for(; t[Iu] < t[wo]; t[c(of)]++)t[Nb] = n[t[Iu]], t[mb] = r[t[Iu]], null != t[Nb] && null != t[mb] && (t[Su] = t[c(ge)] > PG[Da] ? t[c(ge)] : PG[Da], t[hf] = Math[CG[fv]](Math[CG[ev]](t[Nb]) * t[Au], CG[Df]), t[Ru][CG[Cf]](t[hf]), t[yb] += t[hf] * t[Su], t[Du] += t[Su]);
        return t[Du] ? (t[To] = t[yb] / t[Du], t[yf] = t[Ru][CG[iv]]()[CG[id]](function(n, r) {
            return n - r;
        }), t[Nf] = (function(n, r) {
            var i = [];
            return n[CG[Kf]] ? (i[wo] = Math[CG[cv]](CG[ko], Math[CG[dv]](n[CG[Kf]] - CG[Zf], Math[CG[wb]](r * (n[CG[Kf]] - CG[Zf])))), n[i[wo]]) : CG[ko];
        })[so](void 0, t[yf], CG[vu]), t[mf] = t[Nf] > CG[ko] ? PG[qa] / t[Nf] : CG[ja], i[wo] = Math[CG[uv]](t[To] * t[mf]), i[wo] > CG[ko] ? i[wo] < CG[ga] ? i[wo] | CG[ko] : CG[ga] : CG[Zf]) : null;
    }
    function m() {
        var n = [];
        if (n[Ru] = CG[dj](PG[c(Mj)]), n[yb] = CG[dj](PG[Pd]), n[Du] = CG[dj](PG[c(uj)]), !(n[e(af)] && n[yb] && n[Du] && n[Ru][CG[Kf]] && n[yb][CG[Kf]] && n[c(vf)][CG[Kf]])) return null;
        n[Iu] = CG[gM](CG[gM](n[Ru][CG[Kf]], n[yb][CG[Kf]]), n[Du][CG[Kf]]), n[Nb] = CG[YX]() || CG[Zf], n[mb] = Array(n[c(of)] + CG[Zf])[CG[ya]](CG[ko]), n[Su] = Array(n[Iu] + CG[Zf])[CG[ya]](CG[ko]), n[hf] = Array(n[Iu] + CG[Zf])[CG[ya]](CG[ko]), n[To] = Array(n[Iu])[CG[ya]](CG[ko]), n[yf] = CG[ko], n[Nf] = CG[ko];
        for(; n[Nf] < n[Iu]; n[c(Pv)]++)n[mf] = (null !== (n[c(xu)] = n[Ru][n[Nf]]) && n[c(xu)] !== void CG[ko] ? n[wo] : CG[ko]) * n[c(Tf)], n[bf] = (null !== (n[Au] = n[yb][n[Nf]]) && n[Au] !== void CG[ko] ? n[Au] : CG[ko]) * n[c(Tf)], n[mb][n[Nf] + CG[Zf]] = n[mb][n[Nf]] + n[mf], n[Su][n[Nf] + CG[Zf]] = n[c(ef)][n[Nf]] + n[bf], n[pf] = null != n[Du][n[Nf]] && n[Du][n[Nf]] > PG[Da] ? n[e(vf)][n[Nf]] : PG[Da], n[hf][n[Nf] + CG[Zf]] = n[hf][n[Nf]] + n[pf], n[Zo] = CG[kM](n[mf] * n[c(Je)] + n[bf] * n[bf]), n[To][n[Nf]] = n[Zo], n[c(He)] += n[Zo];
        return {
            x: n[mb],
            y: n[c(ef)],
            Xt: n[hf],
            s: n[c(sf)],
            L: n[yf]
        };
    }
    function b() {
        var n = [];
        var r = [];
        if (r[c(af)] = CG[dj](PG[ou]), r[e(Nv)] = (function() {
            var n = [];
            if (n[Ru] = CG[e(Xj)](PG[da]), n[yb] = CG[dj](PG[Sd]), !n[Ru] || !n[yb]) return null;
            n[c(vf)] = CG[gM](n[Ru][CG[Kf]], n[yb][CG[Kf]]), n[Iu] = Array(n[Du]), n[Nb] = CG[au], n[mb] = CG[YX]() || CG[Zf], n[Su] = CG[ko];
            for(; n[c(ef)] < n[Du]; n[Su]++)n[c(Ze)] = Math[CG[ev]](null !== (n[wo] = n[yb][n[c(ef)]]) && n[wo] !== void CG[e(Yl)] ? n[wo] : CG[ko]) * n[mb], n[To] = Math[CG[ev]](null !== (n[Au] = n[Ru][n[Su]]) && n[Au] !== void CG[ko] ? n[Au] : CG[ko]) * (CG[ZM]() / CG[Ce]), n[Iu][n[c(ef)]] = n[hf] > n[Nb] ? n[To] / n[hf] : CG[ko];
            return n[Iu];
        })[so](void 0), !r[Ru] || !r[yb]) return {
            beta: null,
            r2: null
        };
        r[Du] = CG[gM](r[Ru][CG[Kf]], r[yb][CG[Kf]]), r[Iu] = [], r[Nb] = [], r[mb] = CG[au], r[Su] = CG[YX]() || CG[Zf], r[hf] = CG[ko];
        for(; r[hf] < r[Du]; r[e(Ze)]++)r[To] = Math[CG[cv]](Math[CG[e(UX)]](null !== (r[wo] = r[Ru][r[e(Ze)]]) && r[c(xu)] !== void CG[e(Yl)] ? r[wo] : CG[ko]) * r[Su], r[mb]), r[yf] = Math[CG[cv]](Math[CG[ev]](null !== (r[Au] = r[yb][r[hf]]) && r[Au] !== void CG[ko] ? r[Au] : CG[ko]), r[mb]), 1E-4 > r[yf] || (r[Iu][CG[Cf]](Math[CG[So]](r[To])), r[Nb][CG[Cf]](Math[CG[So]](r[yf])));
        if (r[Iu][CG[Kf]] < CG[wv]) return {
            beta: null,
            r2: null
        };
        r[Nf] = CG[ko], r[mf] = CG[ko], r[bf] = CG[ko], r[pf] = CG[ko], r[Zo] = CG[ko], r[hf] = CG[ko];
        for(; r[hf] < r[Iu][CG[Kf]]; r[hf]++)r[Lo] = r[Nb][r[hf]], r[Ho] = r[Iu][r[hf]], r[Nf] += r[Lo], r[mf] += r[Ho], r[bf] += r[Lo] * r[Lo], r[c(bX)] += r[Lo] * r[Ho], r[c(uf)] += r[Ho] * r[Ho];
        return r[Mf] = r[Iu][CG[Kf]], r[wf] = r[Mf] * r[c(Zv)] - r[Nf] * r[Nf], r[wf] === CG[ko] ? {
            beta: null,
            r2: null
        } : (r[Af] = (r[Mf] * r[pf] - r[Nf] * r[mf]) / r[wf], r[Ff] = r[mf] / r[Mf], r[Ef] = r[Nf] / r[Mf], r[Of] = r[Zo] - r[Mf] * r[Ff] * r[Ff], r[ko] = r[Af] * r[Af] * (r[bf] - r[Mf] * r[Ef] * r[Ef]), r[Xf] = r[Of] > CG[ko] ? Math[CG[cv]](CG[ko], Math[CG[dv]](CG[Zf], r[ko] / r[Of])) : null, r[jf] = r[Af] + CG[Zf], {
            beta: (n[wo] = CG[yv], (function(n, r) {
                var i = [];
                return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
            })[so](void 0, r[jf], n[wo])),
            r2: null == r[Xf] ? null : (n[Au] = CG[yv], (function(n, r) {
                var i = [];
                return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
            })[so](void 0, r[Xf], n[Au]))
        });
    }
    function p(n$jscomp$1) {
        var r = [];
        if (r[wo] = (function(n) {
            var r = [];
            if (n === void CG[ko] && (n = CG[gv]), r[Au] = null === (r[wo] = PG[Ta][CG[Zc]]) || r[c(xu)] === void CG[ko] ? void CG[ko] : r[wo][CG[qv]](), r[Au] && r[Au][CG[Kf]] >= CG[wv]) {
                r[Ru] = CG[gM](n, r[c(df)][CG[Kf]]), r[yb] = r[Au][CG[Kf]] - r[c(af)], r[Du] = Array(r[Ru]), r[Iu] = Array(r[c(af)]), r[Nb] = CG[ko];
                for(; r[c(Tf)] < r[Ru]; r[Nb]++)r[Du][r[Nb]] = r[Au][r[yb] + r[Nb]][CG[Yo]], r[Iu][r[Nb]] = r[Au][r[yb] + r[Nb]][CG[nu]];
                r[c(ge)] = CG[YX]() || CG[Zf], r[Nb] = CG[ko];
                for(; r[c(Tf)] < r[Ru]; r[Nb]++)r[Du][r[Nb]] *= r[mb], r[Iu][r[Nb]] *= r[mb];
                return {
                    x: r[Du],
                    y: r[Iu]
                };
            }
            return r[Su] = m(), r[Su] ? {
                x: r[Su][CG[Yo]],
                y: r[Su][CG[nu]]
            } : null;
        })[so](void 0, void 0), !r[wo]) return null;
        if (r[Au] = r[wo][CG[Yo]], r[Ru] = r[wo][CG[nu]], r[yb] = r[c(df)][CG[Kf]], r[yb] < (n$jscomp$1 === CG[Df] ? CG[gf] : CG[wv])) return null;
        if (r[Du] = r[Au][CG[ko]], r[Iu] = r[Ru][CG[ko]], r[e(Tf)] = r[Au][r[yb] - CG[Zf]], r[mb] = r[Ru][r[c(Nv)] - CG[Zf]], r[c(ef)] = (function(n, r) {
            var i = [];
            i[wo] = n[CG[Kf]], i[Au] = Array(i[wo])[CG[e(jj)]](CG[ko]), i[Ru] = CG[ko], i[yb] = CG[Zf];
            for(; i[yb] < i[wo]; i[yb]++)i[Du] = n[i[yb]] - n[i[yb] - CG[Zf]], i[Iu] = r[i[yb]] - r[i[yb] - CG[Zf]], i[Nb] = CG[kM](i[c(vf)] * i[Du] + i[Iu] * i[Iu]), i[Ru] += i[c(Tf)], i[Au][i[c(Nv)]] = i[Ru];
            if (i[e(af)] === CG[ko]) return i[Au][CG[ya]](CG[ko]);
            i[yb] = CG[ko];
            for(; i[yb] < i[wo]; i[yb]++)i[c(df)][i[c(Nv)]] /= i[Ru];
            return i[Au];
        })[so](void 0, r[Au], r[Ru]), n$jscomp$1 === CG[Df]) {
            r[hf] = CG[ko], r[To] = CG[ko], r[yf] = CG[ko], r[Nf] = CG[e(Yl)];
            for(; r[Nf] < r[yb]; r[Nf]++)r[mf] = r[Su][r[Nf]], r[bf] = CG[Zf] - r[mf], r[pf] = CG[Df] * r[bf] * r[mf], r[Zo] = r[c(df)][r[Nf]] - (r[bf] * r[bf] * r[Du] + r[mf] * r[mf] * r[Nb]), r[e(vl)] = r[c(af)][r[Nf]] - (r[bf] * r[bf] * r[c(of)] + r[mf] * r[mf] * r[mb]), r[hf] += r[pf] * r[pf], r[To] += r[pf] * r[Zo], r[yf] += r[pf] * r[c(vl)];
            if (r[hf] === CG[ko]) return null;
            r[Ho] = r[c(sf)] / r[c(Ze)], r[Mf] = r[yf] / r[hf], r[wf] = CG[ko], r[Nf] = CG[ko];
            for(; r[Nf] < r[yb]; r[Nf]++)r[mf] = r[Su][r[Nf]], r[bf] = CG[Zf] - r[mf], r[Af] = r[bf] * r[bf] * r[Du] + CG[Df] * r[bf] * r[mf] * r[Ho] + r[mf] * r[mf] * r[Nb], r[Ff] = r[bf] * r[bf] * r[Iu] + CG[Df] * r[bf] * r[mf] * r[Mf] + r[mf] * r[mf] * r[mb], r[Ef] = r[Af] - r[Au][r[Nf]], r[Of] = r[Ff] - r[Ru][r[Nf]], r[wf] += r[Ef] * r[Ef] + r[Of] * r[Of];
            var n = Math[CG[lv]](r[wf] / r[c(Nv)]);
            var t$jscomp$0 = CG[gf];
            var i = [];
            return t$jscomp$0 === void CG[ko] && (t$jscomp$0 = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], t$jscomp$0), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        }
        r[c(Yl)] = CG[ko], r[Xf] = CG[ko], r[jf] = CG[ko], r[gf] = CG[ko], r[Zf] = CG[ko], r[Hf] = CG[ko], r[kf] = CG[ko], r[Nf] = CG[ko];
        for(; r[Nf] < r[yb]; r[Nf]++)r[mf] = r[Su][r[Nf]], r[bf] = CG[Zf] - r[mf], r[Jf] = CG[yv] * r[bf] * r[c(Zv)] * r[mf], r[Wf] = CG[yv] * r[bf] * r[mf] * r[mf], r[Jo] = r[e(Zv)] * r[c(Zv)] * r[bf] * r[Du] + r[mf] * r[c(Je)] * r[mf] * r[Nb], r[c(AX)] = r[bf] * r[e(Zv)] * r[bf] * r[c(of)] + r[c(Je)] * r[mf] * r[e(Je)] * r[mb], r[Gf] = r[Au][r[Nf]] - r[Jo], r[xf] = r[c(af)][r[Nf]] - r[_f], r[c(e(t(f(26951, 26960), Tr)))] += r[Jf] * r[Jf], r[c(fw)] += r[Jf] * r[e(GX)], r[jf] += r[Wf] * r[c(GX)], r[gf] += r[Jf] * r[Gf], r[Zf] += r[Wf] * r[Gf], r[Hf] += r[Jf] * r[xf], r[kf] += r[Wf] * r[xf];
        if (r[Rf] = r[ko] * r[jf] - r[Xf] * r[Xf], 1E-9 > Math[CG[ev]](r[c(pb)])) return null;
        r[Uf] = r[jf] / r[Rf], r[Sf] = -r[Xf] / r[Rf], r[If] = r[ko] / r[Rf], r[c(ne)] = r[Uf] * r[gf] + r[Sf] * r[Zf], r[Wo] = r[Sf] * r[gf] + r[If] * r[Zf], r[Mf] = r[Uf] * r[Hf] + r[Sf] * r[kf], r[Go] = r[Sf] * r[Hf] + r[c(gj)] * r[c(ql)], r[wf] = CG[ko], r[Nf] = CG[ko];
        for(; r[c(Pv)] < r[yb]; r[Nf]++)r[mf] = r[Su][r[Nf]], r[bf] = CG[Zf] - r[mf], r[Af] = r[bf] * r[bf] * r[bf] * r[Du] + CG[yv] * r[bf] * r[bf] * r[mf] * r[Ho] + CG[yv] * r[bf] * r[mf] * r[mf] * r[Wo] + r[mf] * r[mf] * r[mf] * r[Nb], r[Ff] = r[bf] * r[bf] * r[bf] * r[Iu] + CG[yv] * r[bf] * r[bf] * r[mf] * r[Mf] + CG[yv] * r[bf] * r[mf] * r[mf] * r[c(OX)] + r[mf] * r[mf] * r[mf] * r[mb], r[Ef] = r[Af] - r[c(df)][r[c(Pv)]], r[Of] = r[Ff] - r[Ru][r[Nf]], r[c(WX)] += r[c(Pl)] * r[Ef] + r[Of] * r[Of];
        var n$jscomp$0 = Math[CG[lv]](r[wf] / r[yb]);
        var t$jscomp$1 = CG[gf];
        return i = [], t$jscomp$1 === void CG[ko] && (t$jscomp$1 = CG[yv]), CG[jb](n$jscomp$0) && isFinite(n$jscomp$0) ? (i[wo] = CG[XM](CG[mv], t$jscomp$1), CG[AM](n$jscomp$0 * i[wo]) / i[wo]) : PG[Eu];
    }
    function M(n, r, i) {
        var o = [];
        var u = [];
        if (u[Nb] = .3, n === void CG[ko] && (n = CG[Cv]), r === void CG[ko] && (r = CG[gf]), i === void CG[e(Yl)] && (i = .6), u[c(xu)] = (function(n) {
            var r = [];
            if (n === void CG[ko] && (n = CG[gv]), r[Au] = null === (r[wo] = PG[Ta][CG[Zc]]) || r[c(xu)] === void CG[ko] ? void CG[ko] : r[wo][CG[qv]](), r[Au] && r[Au][CG[Kf]] >= CG[wv]) {
                r[Ru] = CG[gM](n, r[c(df)][CG[Kf]]), r[yb] = r[Au][CG[Kf]] - r[c(af)], r[Du] = Array(r[Ru]), r[Iu] = Array(r[c(af)]), r[Nb] = CG[ko];
                for(; r[c(Tf)] < r[Ru]; r[Nb]++)r[Du][r[Nb]] = r[Au][r[yb] + r[Nb]][CG[Yo]], r[Iu][r[Nb]] = r[Au][r[yb] + r[Nb]][CG[nu]];
                r[c(ge)] = CG[YX]() || CG[Zf], r[Nb] = CG[ko];
                for(; r[c(Tf)] < r[Ru]; r[Nb]++)r[Du][r[Nb]] *= r[mb], r[Iu][r[Nb]] *= r[mb];
                return {
                    x: r[Du],
                    y: r[Iu]
                };
            }
            return r[Su] = m(), r[Su] ? {
                x: r[Su][CG[Yo]],
                y: r[Su][CG[nu]]
            } : null;
        })[so](void 0, void 0), !u[wo]) return null;
        if (u[Au] = u[wo][CG[Yo]], u[Ru] = u[wo][CG[nu]], u[yb] = u[Au][CG[Kf]], u[c(Nv)] < n) return null;
        u[Du] = CG[ko], u[Iu] = CG[ko], u[mb] = CG[ko];
        for(; u[mb] + n <= u[c(Nv)]; u[mb] += r){
            u[Su] = CG[ko], u[c(Ze)] = CG[ko], u[To] = u[mb];
            for(; u[To] < u[mb] + n; u[To]++)u[Su] += u[Au][u[To]], u[hf] += u[c(af)][u[To]];
            u[Su] /= n, u[hf] /= n, u[yf] = CG[ko], u[Nf] = CG[ko], u[mf] = CG[ko], u[bf] = CG[ko], u[pf] = CG[ko], u[Zo] = CG[ko], u[Lo] = CG[ko], u[To] = u[mb];
            for(; u[To] < u[mb] + n; u[To]++)u[e(ne)] = u[Au][u[To]] - u[Su], u[Mf] = u[Ru][u[To]] - u[hf], u[c(WX)] = u[Ho] * u[Ho], u[c(Cl)] = u[Mf] * u[Mf], u[yf] += u[wf], u[c(Pv)] += u[Af], u[mf] += u[Ho] * u[Mf], u[bf] += u[wf] * u[c(ne)], u[pf] += u[Af] * u[Mf], u[Zo] += u[c(WX)] * u[Mf], u[Lo] += u[Ho] * u[Af];
            if (u[c(wj)] = CG[Df] * (u[yf] * u[c(Pv)] - u[mf] * u[mf]), u[Ef] = u[yf] + u[Nf], u[Of] = 1E-14 * (u[c(Pl)] * u[Ef] + 1E-30), isFinite(u[Ff]) && Math[CG[ev]](u[Ff]) >= u[Of]) {
                if (u[Fu] = u[bf] + u[Lo], u[qf] = u[c(bX)] + u[Zo], u[zf] = (u[Fu] * u[Nf] - u[qf] * u[mf]) / u[c(wj)], u[$f] = (u[qf] * u[yf] - u[Fu] * u[mf]) / u[e(wj)], u[Kf] = CG[kM](u[zf] * u[zf] + u[$f] * u[$f] + (u[yf] + u[Nf]) / n), isFinite(u[Kf]) && u[Kf] > CG[ko]) {
                    u[xo] = [], u[To] = u[mb];
                    for(; u[To] < u[mb] + n; u[To]++)u[c(Zj)][CG[Cf]](Math[CG[sv]](u[Ru][u[To]] - u[hf] - u[$f], u[c(df)][u[To]] - u[Su] - u[zf]));
                    u[xo][CG[id]](function(n, r) {
                        return n - r;
                    }), u[Vf] = -1 / 0, u[To] = CG[Zf];
                    for(; u[To] < u[xo][CG[Kf]]; u[c(sf)]++)u[Vf] = Math[CG[cv]](u[Vf], u[xo][u[To]] - u[xo][u[To] - CG[Zf]]);
                    if (u[xo][CG[Kf]] && (u[Vf] = Math[CG[cv]](u[Vf], u[xo][CG[ko]] + CG[Df] * Math[CG[av]] - u[c(Zj)][u[xo][CG[Kf]] - CG[Zf]])), u[Cf] = u[xo][CG[Kf]] ? CG[Df] * Math[CG[e(vh)]] - u[Vf] : CG[ko], u[Cf] < u[Nb]) u[c(of)]++;
                    else {
                        u[c(zp)] = [], u[c(sf)] = u[mb];
                        for(; u[To] < u[mb] + n; u[To]++)u[Qf] = CG[kM](Math[CG[fv]](u[Au][u[To]] - u[Su] - u[zf], CG[Df]) + Math[CG[fv]](u[Ru][u[e(sf)]] - u[hf] - u[e(Lj)], CG[Df])), u[e(zp)][CG[Cf]](Math[CG[ev]](u[Qf] - u[Kf]));
                        u[Pf][CG[id]](function(n, r) {
                            return n - r;
                        }), u[Yf] = u[Pf][CG[Kf]] ? u[Pf][u[Pf][CG[Kf]] - CG[Zf] >> CG[Zf]] : d(t(f(26960, 26970), Tr)), u[nv] = CG[e(fs)] - Math[CG[dv]](CG[Zf], u[Yf] / (u[Kf] + CG[au])), u[Iu]++, u[c(oF)] < i || u[Du]++;
                    }
                }
            } else {
                u[ko] = u[Au][u[mb]], u[Xf] = u[Ru][u[c(ge)]], u[jf] = CG[ko], u[gf] = CG[ko], u[Zf] = CG[ko], u[Hf] = CG[ko], u[To] = u[mb] + CG[Zf];
                for(; u[To] < u[mb] + n - CG[Zf]; u[To]++)u[kf] = u[Au][u[To]] - u[ko], u[Jf] = u[c(af)][u[To]] - u[Xf], u[Wf] = u[c(df)][u[To] + CG[Zf]] - u[Au][u[To]], u[c(Tj)] = u[Ru][u[To] + CG[Zf]] - u[c(af)][u[To]], u[_f] = CG[kM](u[c(ql)] * u[kf] + u[Jf] * u[Jf]), u[c(bb)] = CG[kM](u[Wf] * u[Wf] + u[Jo] * u[c(Tj)]), u[_f] !== CG[ko] && u[Gf] !== CG[ko] && (u[xf] = u[kf] * u[Jo] - u[Jf] * u[Wf], u[c(pb)] = u[kf] * u[Wf] + u[Jf] * u[Jo], u[Uf] = Math[CG[ev]](CG[_M](u[xf], u[Rf])), u[Sf] = CG[Qo] * (u[_f] + u[e(bb)]), u[c(gj)] = u[c(Ts)] > CG[ko] ? u[Uf] / u[Sf] : CG[ko], u[jf] += u[If], u[gf] += u[If] * u[c(gj)], u[Zf]++, u[Hf] += u[Uf], u[ko] = u[Au][u[To]], u[Xf] = u[c(af)][u[To]]);
                u[Zf] > CG[yv] && (u[Iu]++, u[Wo] = u[jf] / u[Zf], u[Go] = Math[CG[cv]](CG[ko], u[gf] / u[Zf] - u[Wo] * u[Wo]), u[e(EX)] = CG[e(aj)](u[Go]), u[Df] = u[Wo] > CG[au] ? u[Bf] / u[Wo] : 1 / 0, u[Hf] >= u[Nb] && .4 > u[Df] && u[Du]++);
            }
        }
        return u[Iu] ? (o[wo] = u[c(vf)] / u[Iu], o[Au] = CG[yv], (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        })[so](void 0, o[wo], o[Au])) : null;
    }
    function w(n, r) {
        var i = [];
        var t = [];
        return r === void CG[ko] && (r = CG[gf]), t[wo] = CG[YX](), null != n && t[wo] ? (i[wo] = r, (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        })[so](void 0, n * t[wo], i[wo])) : null !== n && n !== void CG[ko] ? n : null;
    }
    function A(n, r, i) {
        var t = [];
        var o = [];
        return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[$a]), o[wo] = CG[YX](), null != n && o[wo] ? (t[wo] = n * o[c(xu)] * i, t[e(df)] = r, (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        })[so](void 0, t[wo], t[Au])) : null !== n && n !== void CG[ko] ? n : null;
    }
    function F(n$jscomp$0, r, i$jscomp$0) {
        var t = [];
        t[5] = i$jscomp$0;
        var o = [];
        o[Iu] = t[5];
        var u = [];
        if (r === void CG[ko] && (r = CG[gf]), o[Iu] === void CG[ko] && (o[Iu] = PG[ju]), u[wo] = CG[YX](), u[Au] = CG[dj](n$jscomp$0), !u[wo] || !u[Au] || !u[Au][CG[Kf]]) return null;
        if (u[Ru] = u[Au][CG[td]](function(n) {
            var t = n * u[wo];
            var o = r;
            var i = [];
            return o === void CG[ko] && (o = CG[yv]), CG[jb](t) && isFinite(t) ? (i[wo] = CG[XM](CG[mv], o), CG[AM](t * i[wo]) / i[wo]) : PG[Eu];
        })[CG[fd]](function(n) {
            return null != n;
        }), u[yb] = u[Ru][CG[fd]](function(n) {
            return n >= o[Iu];
        }), !u[yb][CG[Kf]]) return null;
        u[Du] = CG[jM]()[CG[$v]](null, u[c(Nv)]);
        var n = u[Du];
        var i = r;
        var f = [];
        return i === void CG[ko] && (i = CG[yv]), CG[jb](n) && isFinite(n) ? (f[wo] = CG[XM](CG[mv], i), CG[AM](n * f[wo]) / f[wo]) : PG[Eu];
    }
    function E(n, r, i) {
        var t = [];
        var o = [];
        if (o[Du] = null, r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), o[wo] = CG[YX](), o[Au] = CG[dj](n), !o[wo] || !o[Au] || !o[Au][CG[Kf]]) return null;
        o[Ru] = o[wo] * PG[$a], o[yb] = o[Au][CG[td]](function(n) {
            var t = n * o[c(af)];
            var u = r;
            var i = [];
            return u === void CG[e(Yl)] && (u = CG[yv]), CG[jb](t) && isFinite(t) ? (i[wo] = CG[XM](CG[mv], u), CG[AM](t * i[wo]) / i[wo]) : PG[Eu];
        })[CG[fd]](function(n) {
            return null != n;
        }), o[Iu] = 1 / 0, o[Nb] = CG[ko], o[mb] = o[yb];
        for(; o[Nb] < o[mb][CG[Kf]]; o[c(Tf)]++)o[Su] = o[mb][o[Nb]], o[c(Ze)] = Math[CG[ev]](o[Su]), o[hf] >= i && o[hf] < o[Iu] && (o[Iu] = o[hf], o[Du] = o[Su]);
        return null == o[Du] ? null : (t[wo] = r, (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        })[so](void 0, o[Du], t[wo]));
    }
    function O(n, r, i, t, o, u) {
        var f = [];
        if ((function(n, r, i, t) {
            n[CG[Fl]](r, i, t);
        })[so](void 0, n, r, i, t), f[wo] = CG[Gg](n, o, u, CG[Zf], CG[Zf]), f[c(xu)]) return [
            f[wo][CG[ko]],
            f[wo][CG[Zf]],
            f[wo][CG[Df]],
            f[wo][CG[yv]]
        ];
    }
    var X = 180;
    var j = 189;
    var g = 89;
    var T = 115;
    var Z = 234;
    var L = 206;
    var H = 242;
    var k = 45;
    var J = 248;
    var W = 85;
    var _ = 254;
    var G = 143;
    var x = 221;
    var R = 193;
    var U = 165;
    var S = 93;
    var I = 243;
    var B = 240;
    var D = 160;
    var q = 60;
    var z = 128;
    var $ = 108;
    var K = 12;
    var V = 24;
    var C = 102;
    var P = 64;
    var Q = 140;
    var Y = o(0);
    var nn = 182;
    var rn = 49;
    var tn = 192;
    var on = 167;
    var un = 239;
    var fn = 88;
    var vn = 37;
    var en = 207;
    var cn = 185;
    var dn = 55;
    var an = 162;
    var ln = 251;
    var sn = 156;
    var hn = 216;
    var yn = 161;
    var Nn = 31;
    var mn = 70;
    var bn = 104;
    var pn = 168;
    var Mn = 33;
    var wn = 43;
    var An = 229;
    var Fn = 202;
    var En = 44;
    var On = 75;
    var Xn = 233;
    var jn = 54;
    var gn = 154;
    var Tn = 172;
    var Zn = 94;
    var Ln = 199;
    var Hn = 105;
    var kn = 109;
    var Jn = 51;
    var Wn = 191;
    var _n = 174;
    var Gn = 226;
    var xn = 39;
    var Rn = 28;
    var Un = 231;
    var Sn = 173;
    var In = 132;
    var Bn = 87;
    var Dn = 222;
    var qn = 225;
    var zn = 181;
    var $n = 112;
    var Kn = 78;
    var Vn = 56;
    var Cn = 171;
    var Pn = 184;
    var Qn = 244;
    var Yn = 146;
    var nr = 169;
    var rr = 149;
    var ir = 40;
    var tr = 227;
    var or = 122;
    var ur = 103;
    var fr = 82;
    var vr = 220;
    var er = 203;
    var cr = 157;
    var dr = 208;
    var ar = 41;
    var lr = 164;
    var sr = 230;
    var hr = 134;
    var yr = 25;
    var Nr = 97;
    var mr = 117;
    var br = 235;
    var pr = 20;
    var Mr = 150;
    var wr = 214;
    var Ar = 99;
    var Fr = 130;
    var Er = 27;
    var Or = 144;
    var Xr = 46;
    var jr = 188;
    var gr = 18;
    var Tr = 10;
    var Zr = 247;
    var Lr = 201;
    var Hr = 228;
    var kr = 114;
    var Jr = 47;
    var Wr = 74;
    var _r = 148;
    var Gr = 59;
    var xr = 17;
    var Rr = 212;
    var Ur = 15;
    var Sr = 23;
    var Ir = 35;
    var Br = 152;
    var Dr = 116;
    var qr = 194;
    var zr = 224;
    var $r = 81;
    var Kr = 38;
    var Vr = 90;
    var Cr = 98;
    var Pr = 209;
    var Qr = 101;
    var Yr = 198;
    var ni = 21;
    var ri = 72;
    var ii = 213;
    var ti = 120;
    var oi = 96;
    var ui = 121;
    var fi = 241;
    var vi = 84;
    var ei = 73;
    var ci = 29;
    var di = 252;
    var ai = 68;
    var li = 190;
    var si = 170;
    var hi = 52;
    var yi = 204;
    var Ni = 92;
    var mi = 19;
    var bi = 246;
    var pi = 11;
    var Mi = 142;
    var wi = 111;
    var Ai = 211;
    var Fi = 238;
    var Ei = 57;
    var Oi = 13;
    var Xi = 76;
    var ji = 133;
    var gi = 48;
    var Ti = 237;
    var Zi = 53;
    var Li = 151;
    var Hi = 210;
    var ki = 138;
    var Ji = 42;
    var Wi = 80;
    var _i = 123;
    var Gi = 195;
    var xi = 141;
    var Ri = 50;
    var Ui = 197;
    var Si = 100;
    var Ii = 106;
    var Bi = 119;
    var Di = 245;
    var qi = 16;
    var zi = 147;
    var $i = 158;
    var Ki = 178;
    var Vi = 113;
    var Ci = 107;
    var Pi = 205;
    var Qi = 153;
    var Yi = 127;
    var nt = 183;
    var rt = 177;
    var it = 215;
    var tt = 36;
    var ot = 62;
    var ut = 250;
    var ft = 232;
    var vt = 126;
    var et = 110;
    var ct = 218;
    var dt = 118;
    var at = 131;
    var lt = 163;
    var st = 91;
    var ht = 86;
    var yt = 69;
    var Nt = 26;
    var mt = 79;
    var bt = 30;
    var pt = 22;
    var Mt = 145;
    var wt = 176;
    var At = 137;
    var Ft = 77;
    var Et = 196;
    var Ot = 255;
    var Xt = 155;
    var jt = 136;
    var gt = 58;
    var Tt = 179;
    var Zt = 61;
    var Lt = 175;
    var Ht = 166;
    var kt = 124;
    var Jt = 125;
    var Wt = 253;
    var _t = 139;
    var Gt = 83;
    var xt = 14;
    var Rt = 71;
    var Ut = 200;
    var St = 135;
    var It = 63;
    var Bt = 129;
    var Dt = 187;
    var qt = 95;
    var zt = 159;
    var $t = 186;
    var Kt = 236;
    var Vt = 223;
    var Ct = 219;
    var Pt = 217;
    var Qt = 34;
    var Yt = 67;
    var no = 249;
    var ro = 32;
    var io = 65;
    var to = 256;
    var oo = o(1);
    var uo = o(2);
    var fo = o(3);
    var vo = o(4);
    var eo = o(5);
    var co = f(0, 1);
    t(co, Tr);
    var ao = "b";
    var lo = "imul";
    var so = "call";
    var ho = "p";
    var yo = "T";
    var No = "c";
    var mo = f(1, 7);
    var bo = f(7, xr);
    var po = f(xr, ci);
    var Mo = "X";
    var wo = t(co, Tr);
    var Ao = t(f(ci, Kr), Tr);
    var Fo = t(f(Kr, gi), Tr);
    var Eo = t(f(gi, gt), Tr);
    var Oo = t(f(gt, ai), Tr);
    var Xo = t(f(ai, Kn), Tr);
    var jo = t(f(Kn, Bn), Tr);
    var go = t(f(Bn, oi), Tr);
    var To = t(f(oi, Cr), Tr);
    var Zo = t(f(Cr, Si), Tr);
    var Lo = t(f(Si, C), Tr);
    var Ho = t(f(C, bn), Tr);
    var ko = t(f(bn, Ii), Tr);
    var Jo = t(f(Ii, $), Tr);
    var Wo = t(f($, et), Tr);
    var _o = "";
    var Go = t(f(et, $n), Tr);
    var xo = t(f($n, kr), Tr);
    var Ro = t(f(kr, Dr), Tr);
    var Uo = t(f(Dr, dt), Tr);
    var So = t(f(dt, ti), Tr);
    var Io = t(f(ti, or), Tr);
    var Bo = t(f(or, kt), Tr);
    var Do = t(f(kt, vt), Tr);
    var qo = t(f(vt, z), Tr);
    var zo = t(f(z, Fr), Tr);
    var $o = t(f(Fr, ji), Tr);
    var Ko = t(f(ji, jt), Tr);
    var Vo = t(f(jt, _t), Tr);
    var Co = t(f(_t, Mi), Tr);
    var Po = t(f(Mi, Mt), Tr);
    var Qo = t(f(Mt, _r), Tr);
    var Yo = t(f(_r, Li), Tr);
    var nu = t(f(Li, gn), Tr);
    var ru = t(f(gn, cr), Tr);
    var iu = t(f(cr, D), Tr);
    var tu = t(f(D, lt), Tr);
    var ou = t(f(lt, Ht), Tr);
    var uu = t(f(Ht, nr), Tr);
    var fu = t(f(nr, Tn), Tr);
    var vu = t(f(Tn, Lt), Tr);
    var eu = t(f(Lt, Ki), Tr);
    var cu = t(f(Ki, zn), Tr);
    var du = t(f(zn, Pn), Tr);
    var au = t(f(Pn, Dt), Tr);
    var lu = t(f(Dt, li), Tr);
    var su = t(f(li, R), Tr);
    var hu = o(1);
    var yu = t(f(R, Et), Tr);
    var Nu = t(f(Et, Ln), Tr);
    var mu = t(f(Ln, Fn), Tr);
    var bu = t(f(Fn, Pi), Tr);
    var pu = t(f(Pi, dr), Tr);
    var Mu = t(f(dr, Ai), Tr);
    var wu = t(f(Ai, wr), Tr);
    var Au = t(f(wr, it), Tr);
    var Fu = t(f(it, Pt), Tr);
    var Eu = t(f(Pt, vr), Tr);
    var Ou = t(f(vr, Vt), Tr);
    var Xu = t(f(Vt, Gn), Tr);
    var ju = t(f(Gn, An), Tr);
    var gu = t(f(An, ft), Tr);
    var Tu = t(f(ft, br), Tr);
    var Zu = t(f(br, Fi), Tr);
    var Lu = t(f(Fi, fi), Tr);
    var Hu = t(f(fi, Qn), Tr);
    var ku = t(f(Qn, Zr), Tr);
    var Ju = t(f(Zr, ut), Tr);
    var Wu = t(f(ut, Wt), Tr);
    var _u = t(f(Wt, to), Tr);
    var Gu = t(f(to, 259), Tr);
    var xu = t(f(259, 269), Tr);
    var Ru = t(f(269, 270), Tr);
    var Uu = t(f(270, 273), Tr);
    var Su = t(f(273, 274), Tr);
    var Iu = t(f(274, 275), Tr);
    var Bu = t(f(275, 280), Tr);
    var Du = t(f(280, 281), Tr);
    var qu = t(f(281, 286), Tr);
    var zu = t(f(286, 291), Tr);
    var $u = t(f(291, 295), Tr);
    var Ku = t(f(295, 299), Tr);
    var Vu = t(f(299, 304), Tr);
    var Cu = t(f(304, 309), Tr);
    var Pu = t(f(309, 314), Tr);
    var Qu = t(f(314, 319), Tr);
    var Yu = t(f(319, 324), Tr);
    var nf = t(f(324, 329), Tr);
    var rf = t(f(329, 334), Tr);
    var tf = t(f(334, 344), Tr);
    var of = t(f(344, 354), Tr);
    var uf = t(f(354, 364), Tr);
    var ff = t(f(364, oo), Tr);
    var vf = t(f(oo, 386), Tr);
    var ef = t(f(386, 396), Tr);
    var cf = t(f(396, 406), Tr);
    var df = t(f(406, 417), Tr);
    var af = t(f(417, 427), Tr);
    var lf = t(f(427, 438), Tr);
    var sf = t(f(438, 448), Tr);
    var hf = t(f(448, 449), Tr);
    var yf = t(f(449, 451), Tr);
    var Nf = t(f(451, 453), Tr);
    var mf = t(f(453, 455), Tr);
    var bf = t(f(455, 457), Tr);
    var pf = t(f(457, 459), Tr);
    var Mf = t(f(459, 461), Tr);
    var wf = t(f(461, 463), Tr);
    var Af = t(f(463, 465), Tr);
    var Ff = t(f(465, 467), Tr);
    var Ef = t(f(467, 469), Tr);
    var Of = t(f(469, 471), Tr);
    var Xf = t(f(471, 473), Tr);
    var jf = t(f(473, 475), Tr);
    var gf = t(f(475, 477), Tr);
    var Tf = t(f(477, 486), Tr);
    var Zf = t(f(486, 488), Tr);
    var Lf = t(f(488, 499), Tr);
    var Hf = t(f(499, 501), Tr);
    var kf = t(f(501, 503), Tr);
    var Jf = t(f(503, 505), Tr);
    var Wf = t(f(505, 507), Tr);
    var _f = t(f(507, 509), Tr);
    var Gf = t(f(509, 511), Tr);
    var xf = t(f(511, 513), Tr);
    var Rf = t(f(513, 515), Tr);
    var Uf = t(f(515, 517), Tr);
    var Sf = t(f(517, 519), Tr);
    var If = t(f(519, 521), Tr);
    var Bf = t(f(521, 523), Tr);
    var Df = t(f(523, 525), Tr);
    var qf = t(f(525, 527), Tr);
    var zf = t(f(527, uo), Tr);
    var $f = t(f(uo, 531), Tr);
    var Kf = t(f(531, 533), Tr);
    var Vf = t(f(533, 535), Tr);
    var Cf = t(f(535, 537), Tr);
    var Pf = t(f(537, 539), Tr);
    var Qf = t(f(539, 541), Tr);
    var Yf = t(f(541, 543), Tr);
    var nv = t(f(543, 545), Tr);
    var rv = t(f(545, 547), Tr);
    var iv = t(f(547, 549), Tr);
    var tv = t(f(549, 551), Tr);
    var ov = t(f(551, 553), Tr);
    var uv = t(f(553, 555), Tr);
    var fv = t(f(555, 557), Tr);
    var vv = o(0);
    var ev = t(f(557, 559), Tr);
    var cv = t(f(559, 561), Tr);
    var dv = t(f(561, 563), Tr);
    var av = t(f(563, 565), Tr);
    var lv = t(f(565, 567), Tr);
    var sv = t(f(567, 569), Tr);
    var hv = t(f(569, 579), Tr);
    var yv = t(f(579, 581), Tr);
    var Nv = t(f(581, 591), Tr);
    var mv = t(f(591, 593), Tr);
    var bv = t(f(593, 595), Tr);
    var pv = t(f(595, 597), Tr);
    var Mv = t(f(597, 599), Tr);
    var wv = t(f(599, 601), Tr);
    var Av = t(f(601, 610), Tr);
    var Fv = t(f(610, 612), Tr);
    var Ev = t(f(612, 614), Tr);
    var Ov = t(f(614, 624), Tr);
    var Xv = t(f(624, 626), Tr);
    var jv = t(f(626, 628), Tr);
    var gv = t(f(628, 630), Tr);
    var Tv = t(f(630, 632), Tr);
    var Zv = t(f(632, 643), Tr);
    var Lv = t(f(643, 645), Tr);
    var Hv = t(f(645, 655), Tr);
    var kv = t(f(655, 657), Tr);
    var Jv = t(f(657, 659), Tr);
    var Wv = t(f(659, 661), Tr);
    var _v = t(f(661, 663), Tr);
    var Gv = t(f(663, 665), Tr);
    var xv = t(f(665, 667), Tr);
    var Rv = t(f(667, 669), Tr);
    var Uv = t(f(669, 672), Tr);
    var Sv = t(f(672, 675), Tr);
    var Iv = t(f(675, 678), Tr);
    var Bv = t(f(678, 681), Tr);
    var Dv = t(f(681, 684), Tr);
    var qv = t(f(684, 687), Tr);
    var zv = t(f(687, 690), Tr);
    var $v = t(f(690, 693), Tr);
    var Kv = t(f(693, 696), Tr);
    var Vv = t(f(696, 699), Tr);
    var Cv = t(f(699, 702), Tr);
    var Pv = t(f(702, 711), Tr);
    var Qv = t(f(711, 714), Tr);
    var Yv = t(f(714, 717), Tr);
    var ne = t(f(717, 727), Tr);
    var re = t(f(727, 730), Tr);
    var ie = t(f(730, 733), Tr);
    var te = t(f(733, 736), Tr);
    var oe = t(f(736, 739), Tr);
    var ue = t(f(739, 742), Tr);
    var fe = t(f(742, 745), Tr);
    var ve = t(f(745, 748), Tr);
    var ee = t(f(748, 751), Tr);
    var ce = t(f(751, 754), Tr);
    var de = t(f(754, 757), Tr);
    var ae = t(f(757, 760), Tr);
    var le = t(f(760, 763), Tr);
    var se = t(f(763, 766), Tr);
    var he = t(f(766, 769), Tr);
    var ye = t(f(769, 772), Tr);
    var Ne = t(f(772, 775), Tr);
    var me = t(f(775, 778), Tr);
    var be = t(f(778, 781), Tr);
    var pe = t(f(781, 784), Tr);
    var Me = t(f(784, 787), Tr);
    var we = t(f(787, 790), Tr);
    var Ae = t(f(790, 793), Tr);
    var Fe = t(f(793, 796), Tr);
    var Ee = t(f(796, 799), Tr);
    var Oe = t(f(799, 802), Tr);
    var Xe = t(f(802, 805), Tr);
    var je = t(f(805, 815), Tr);
    var ge = t(f(815, 826), Tr);
    var Te = t(f(826, 829), Tr);
    var Ze = t(f(829, 838), Tr);
    var Le = t(f(838, 841), Tr);
    var He = t(f(841, 851), Tr);
    var ke = t(f(851, 854), Tr);
    var Je = t(f(854, 864), Tr);
    var We = t(f(864, 867), Tr);
    var _e = t(f(867, 870), Tr);
    var Ge = t(f(870, 873), Tr);
    var xe = t(f(873, 876), Tr);
    var Re = t(f(876, 879), Tr);
    var Ue = t(f(879, 882), Tr);
    var Se = t(f(882, 885), Tr);
    var Ie = t(f(885, 888), Tr);
    var Be = t(f(888, 891), Tr);
    var De = t(f(891, 894), Tr);
    var qe = t(f(894, 897), Tr);
    var ze = t(f(897, 900), Tr);
    var $e = t(f(900, 903), Tr);
    var Ke = t(f(903, 906), Tr);
    var Ve = t(f(906, 909), Tr);
    var Ce = t(f(909, 912), Tr);
    var Pe = t(f(912, 922), Tr);
    var Qe = t(f(922, 925), Tr);
    var Ye = t(f(925, 928), Tr);
    var nc = t(f(928, 931), Tr);
    var rc = t(f(931, 934), Tr);
    var ic = t(f(934, 937), Tr);
    var tc = t(f(937, 940), Tr);
    var oc = t(f(940, 943), Tr);
    var uc = t(f(943, 946), Tr);
    var fc = t(f(946, 949), Tr);
    var vc = t(f(949, 952), Tr);
    var ec = t(f(952, 955), Tr);
    var cc = t(f(955, 958), Tr);
    var dc = t(f(958, 961), Tr);
    var ac = t(f(961, 964), Tr);
    var lc = t(f(964, 967), Tr);
    var sc = t(f(967, 970), Tr);
    var hc = t(f(970, 973), Tr);
    var yc = t(f(973, 976), Tr);
    var Nc = t(f(976, 979), Tr);
    var mc = t(f(979, 982), Tr);
    var bc = t(f(982, 985), Tr);
    var pc = t(f(985, 988), Tr);
    var Mc = t(f(988, 991), Tr);
    var wc = t(f(991, 994), Tr);
    var Ac = t(f(994, 997), Tr);
    var Fc = t(f(997, 1E3), Tr);
    var Ec = t(f(1E3, 1011), Tr);
    var Oc = t(f(1011, 1014), Tr);
    var Xc = t(f(1014, 1017), Tr);
    var jc = t(f(1017, 1020), Tr);
    var gc = t(f(1020, 1023), Tr);
    var Tc = t(f(1023, 1026), Tr);
    var Zc = t(f(1026, 1029), Tr);
    var Lc = t(f(1029, 1032), Tr);
    var Hc = t(f(1032, 1035), Tr);
    var kc = t(f(1035, 1038), Tr);
    var Jc = t(f(1038, 1041), Tr);
    var Wc = t(f(1041, 1044), Tr);
    var _c = t(f(1044, 1047), Tr);
    var Gc = t(f(1047, 1050), Tr);
    var xc = t(f(1050, 1053), Tr);
    var Rc = t(f(1053, 1056), Tr);
    var Uc = t(f(1056, 1059), Tr);
    var Sc = t(f(1059, 1062), Tr);
    var Ic = t(f(1062, 1065), Tr);
    var Bc = t(f(1065, 1068), Tr);
    var Dc = t(f(1068, 1078), Tr);
    var qc = t(f(1078, 1081), Tr);
    var zc = t(f(1081, fo), Tr);
    var $c = t(f(fo, 1087), Tr);
    var Kc = t(f(1087, 1090), Tr);
    var Vc = t(f(1090, 1093), Tr);
    var Cc = t(f(1093, 1096), Tr);
    var Pc = t(f(1096, 1099), Tr);
    var Qc = t(f(1099, 1102), Tr);
    var Yc = t(f(1102, 1105), Tr);
    var nd = t(f(1105, 1108), Tr);
    var rd = t(f(1108, 1111), Tr);
    var id = t(f(1111, 1114), Tr);
    var td = t(f(1114, 1117), Tr);
    var od = t(f(1117, 1120), Tr);
    var ud = t(f(1120, 1123), Tr);
    var fd = t(f(1123, 1126), Tr);
    var vd = t(f(1126, 1129), Tr);
    var ed = t(f(1129, 1132), Tr);
    var cd = t(f(1132, 1135), Tr);
    var dd = t(f(1135, 1138), Tr);
    var ad = t(f(1138, 1141), Tr);
    var ld = t(f(1141, 1144), Tr);
    var sd = t(f(1144, 1147), Tr);
    var hd = t(f(1147, 1150), Tr);
    var yd = t(f(1150, 1153), Tr);
    var Nd = t(f(1153, 1156), Tr);
    var md = t(f(1156, 1159), Tr);
    var bd = t(f(1159, 1162), Tr);
    var pd = t(f(1162, 1165), Tr);
    var Md = t(f(1165, 1168), Tr);
    var wd = t(f(1168, 1171), Tr);
    var Ad = t(f(1171, 1174), Tr);
    var Fd = t(f(1174, 1177), Tr);
    var Ed = t(f(1177, 1180), Tr);
    var Od = t(f(1180, 1183), Tr);
    var Xd = t(f(1183, 1186), Tr);
    var jd = t(f(1186, 1189), Tr);
    var gd = t(f(1189, 1192), Tr);
    var Td = t(f(1192, 1195), Tr);
    var Zd = t(f(1195, 1198), Tr);
    var Ld = t(f(1198, 1201), Tr);
    var Hd = t(f(1201, 1204), Tr);
    var kd = t(f(1204, 1207), Tr);
    var Jd = t(f(1207, 1210), Tr);
    var Wd = t(f(1210, 1213), Tr);
    var _d = t(f(1213, 1216), Tr);
    var Gd = t(f(1216, 1219), Tr);
    var xd = t(f(1219, 1222), Tr);
    var Rd = t(f(1222, 1225), Tr);
    var Ud = t(f(1225, 1228), Tr);
    var Sd = t(f(1228, 1231), Tr);
    var Id = t(f(1231, 1234), Tr);
    var Bd = t(f(1234, 1237), Tr);
    var Dd = t(f(1237, 1240), Tr);
    var qd = t(f(1240, 1243), Tr);
    var zd = t(f(1243, 1246), Tr);
    var $d = t(f(1246, 1249), Tr);
    var Kd = t(f(1249, 1258), Tr);
    var Vd = t(f(1258, 1261), Tr);
    var Cd = t(f(1261, 1264), Tr);
    var Pd = t(f(1264, 1267), Tr);
    var Qd = t(f(1267, 1270), Tr);
    var Yd = t(f(1270, 1273), Tr);
    var na = t(f(1273, 1276), Tr);
    var ra = t(f(1276, 1279), Tr);
    var ia = t(f(1279, 1282), Tr);
    var ta = t(f(1282, 1285), Tr);
    var oa = t(f(1285, 1288), Tr);
    var ua = t(f(1288, 1291), Tr);
    var fa = t(f(1291, 1294), Tr);
    var va = t(f(1294, 1297), Tr);
    var ea = t(f(1297, 1300), Tr);
    var ca = t(f(1300, vo), Tr);
    var da = t(f(vo, 1306), Tr);
    var aa = t(f(1306, 1309), Tr);
    var la = t(f(1309, 1312), Tr);
    var sa = t(f(1312, 1315), Tr);
    var ha = t(f(1315, 1318), Tr);
    var ya = t(f(1318, 1321), Tr);
    var Na = t(f(1321, 1324), Tr);
    var ma = t(f(1324, 1327), Tr);
    var ba = t(f(1327, 1336), Tr);
    var pa = t(f(1336, 1339), Tr);
    var Ma = t(f(1339, 1342), Tr);
    var wa = t(f(1342, 1345), Tr);
    var Aa = t(f(1345, 1348), Tr);
    var Fa = t(f(1348, 1351), Tr);
    var Ea = t(f(1351, 1354), Tr);
    var Oa = t(f(1354, 1357), Tr);
    var Xa = t(f(1357, 1360), Tr);
    var ja = t(f(1360, 1363), Tr);
    var ga = t(f(1363, 1366), Tr);
    var Ta = t(f(1366, 1369), Tr);
    var Za = t(f(1369, 1372), Tr);
    var La = t(f(1372, 1375), Tr);
    var Ha = t(f(1375, 1378), Tr);
    var ka = t(f(1378, 1381), Tr);
    var Ja = t(f(1381, 1384), Tr);
    var Wa = t(f(1384, 1387), Tr);
    var _a = t(f(1387, 1390), Tr);
    var Ga = t(f(1390, 1393), Tr);
    var xa = t(f(1393, 1396), Tr);
    var Ra = t(f(1396, 1399), Tr);
    var Ua = t(f(1399, 1402), Tr);
    var Sa = t(f(1402, 1405), Tr);
    var Ia = t(f(1405, 1408), Tr);
    var Ba = t(f(1408, 1411), Tr);
    var Da = t(f(1411, 1414), Tr);
    var qa = t(f(1414, 1417), Tr);
    var za = t(f(1417, 1420), Tr);
    var $a = t(f(1420, 1423), Tr);
    var Ka = t(f(1423, 1426), Tr);
    var Va = t(f(1426, 1429), Tr);
    var Ca = t(f(1429, 1432), Tr);
    var Pa = t(f(1432, 1435), Tr);
    var Qa = t(f(1435, 1438), Tr);
    var Ya = t(f(1438, 1441), Tr);
    var nl = t(f(1441, 1444), Tr);
    var rl = t(f(1444, 1447), Tr);
    var il = t(f(1447, 1450), Tr);
    var tl = t(f(1450, 1453), Tr);
    var ol = t(f(1453, 1456), Tr);
    var ul = t(f(1456, 1459), Tr);
    var fl = t(f(1459, 1462), Tr);
    var vl = t(f(1462, 1473), Tr);
    var el = t(f(1473, 1476), Tr);
    var cl = t(f(1476, 1486), Tr);
    var dl = t(f(1486, 1489), Tr);
    var al = t(f(1489, 1492), Tr);
    var ll = t(f(1492, 1495), Tr);
    var sl = t(f(1495, 1498), Tr);
    var hl = t(f(1498, 1507), Tr);
    var yl = t(f(1507, 1510), Tr);
    var Nl = t(f(1510, 1520), Tr);
    var ml = t(f(1520, 1523), Tr);
    var bl = t(f(1523, 1534), Tr);
    var pl = t(f(1534, 1537), Tr);
    var Ml = t(f(1537, 1540), Tr);
    var wl = t(f(1540, 1543), Tr);
    var Al = t(f(1543, 1546), Tr);
    var Fl = t(f(1546, 1549), Tr);
    var El = t(f(1549, 1552), Tr);
    var Ol = t(f(1552, 1555), Tr);
    var Xl = t(f(1555, 1558), Tr);
    var jl = t(f(1558, 1561), Tr);
    var gl = t(f(1561, 1564), Tr);
    var Tl = t(f(1564, 1575), Tr);
    var Zl = t(f(1575, 1578), Tr);
    var Ll = t(f(1578, 1587), Tr);
    var Hl = t(f(1587, 1590), Tr);
    var kl = t(f(1590, 1599), Tr);
    var Jl = t(f(1599, 1602), Tr);
    var Wl = t(f(1602, 1605), Tr);
    var _l = t(f(1605, 1608), Tr);
    var Gl = t(f(1608, 1611), Tr);
    var xl = t(f(1611, 1614), Tr);
    var Rl = t(f(1614, 1617), Tr);
    var Ul = t(f(1617, 1620), Tr);
    var Sl = t(f(1620, 1623), Tr);
    var Il = t(f(1623, 1626), Tr);
    var Bl = t(f(1626, 1629), Tr);
    var Dl = t(f(1629, 1632), Tr);
    var ql = t(f(1632, 1640), Tr);
    var zl = t(f(1640, 1643), Tr);
    var $l = t(f(1643, 1646), Tr);
    var Kl = t(f(1646, 1656), Tr);
    var Vl = t(f(1656, 1659), Tr);
    var Cl = t(f(1659, 1669), Tr);
    var Pl = t(f(1669, 1680), Tr);
    var Ql = t(f(1680, 1683), Tr);
    var Yl = t(f(1683, 1692), Tr);
    var ns = t(f(1692, 1695), Tr);
    var rs = t(f(1695, 1698), Tr);
    var is = t(f(1698, 1709), Tr);
    var ts = t(f(1709, 1712), Tr);
    var os = t(f(1712, 1721), Tr);
    var us = t(f(1721, 1724), Tr);
    var fs = t(f(1724, 1734), Tr);
    var vs = t(f(1734, 1737), Tr);
    var es = t(f(1737, 1740), Tr);
    var cs = t(f(1740, 1743), Tr);
    var ds = t(f(1743, 1746), Tr);
    var as = t(f(1746, 1749), Tr);
    var ls = t(f(1749, 1752), Tr);
    var ss = t(f(1752, 1755), Tr);
    var hs = t(f(1755, 1758), Tr);
    var ys = t(f(1758, 1761), Tr);
    var Ns = t(f(1761, 1764), Tr);
    var ms = t(f(1764, 1767), Tr);
    var bs = t(f(1767, 1770), Tr);
    var ps = t(f(1770, 1773), Tr);
    var Ms = t(f(1773, 1776), Tr);
    var ws = t(f(1776, 1779), Tr);
    var As = t(f(1779, 1782), Tr);
    var Fs = t(f(1782, 1785), Tr);
    var Es = t(f(1785, 1788), Tr);
    var Os = t(f(1788, 1791), Tr);
    var Xs = t(f(1791, 1794), Tr);
    var js = t(f(1794, 1797), Tr);
    var gs = t(f(1797, 1800), Tr);
    var Ts = t(f(1800, 1810), Tr);
    var Zs = t(f(1810, 1813), Tr);
    var Ls = t(f(1813, 1823), Tr);
    var Hs = t(f(1823, 1826), Tr);
    var ks = t(f(1826, 1829), Tr);
    var Js = t(f(1829, 1832), Tr);
    var Ws = t(f(1832, 1835), Tr);
    var _s = t(f(1835, 1838), Tr);
    var Gs = t(f(1838, 1841), Tr);
    var xs = t(f(1841, 1844), Tr);
    var Rs = t(f(1844, 1847), Tr);
    var Us = t(f(1847, 1850), Tr);
    var Ss = t(f(1850, 1853), Tr);
    var Is = t(f(1853, 1856), Tr);
    var Bs = t(f(1856, 1859), Tr);
    var Ds = t(f(1859, 1862), Tr);
    var qs = t(f(1862, 1865), Tr);
    var zs = t(f(1865, 1868), Tr);
    var $s = t(f(1868, 1871), Tr);
    var Ks = t(f(1871, 1874), Tr);
    var Vs = t(f(1874, 1877), Tr);
    var Cs = t(f(1877, 1880), Tr);
    var Ps = t(f(1880, 1883), Tr);
    var Qs = t(f(1883, 1893), Tr);
    var Ys = t(f(1893, 1896), Tr);
    var nh = t(f(1896, 1905), Tr);
    var rh = t(f(1905, 1908), Tr);
    var ih = t(f(1908, 1911), Tr);
    var th = t(f(1911, 1914), Tr);
    var oh = t(f(1914, 1917), Tr);
    var uh = t(f(1917, 1920), Tr);
    var fh = t(f(1920, 1923), Tr);
    var vh = t(f(1923, 1932), Tr);
    var eh = t(f(1932, 1935), Tr);
    var ch = t(f(1935, 1938), Tr);
    var dh = t(f(1938, 1941), Tr);
    var ah = t(f(1941, 1944), Tr);
    var lh = t(f(1944, 1947), Tr);
    var sh = t(f(1947, 1950), Tr);
    var hh = t(f(1950, 1953), Tr);
    var yh = t(f(1953, 1956), Tr);
    var Nh = t(f(1956, 1959), Tr);
    var mh = t(f(1959, 1962), Tr);
    var bh = t(f(1962, 1965), Tr);
    var ph = t(f(1965, 1968), Tr);
    var Mh = t(f(1968, 1971), Tr);
    var wh = t(f(1971, 1981), Tr);
    var Ah = t(f(1981, 1984), Tr);
    var Fh = t(f(1984, 1987), Tr);
    var Eh = t(f(1987, 1990), Tr);
    var Oh = t(f(1990, 1993), Tr);
    var Xh = t(f(1993, 1996), Tr);
    var jh = t(f(1996, 1999), Tr);
    var gh = t(f(1999, 2002), Tr);
    var Th = t(f(2002, 2005), Tr);
    var Zh = t(f(2005, 2008), Tr);
    var Lh = t(f(2008, 2011), Tr);
    var Hh = t(f(2011, 2014), Tr);
    var kh = t(f(2014, 2024), Tr);
    var Jh = t(f(2024, 2027), Tr);
    var Wh = t(f(2027, 2030), Tr);
    var _h = t(f(2030, 2033), Tr);
    var Gh = t(f(2033, 2036), Tr);
    var xh = t(f(2036, 2039), Tr);
    var Rh = t(f(2039, 2042), Tr);
    var Uh = t(f(2042, 2045), Tr);
    var Sh = t(f(2045, 2048), Tr);
    var Ih = t(f(2048, 2051), Tr);
    var Bh = t(f(2051, 2054), Tr);
    var Dh = t(f(2054, 2057), Tr);
    var qh = t(f(2057, 2060), Tr);
    var zh = t(f(2060, 2063), Tr);
    var $h = t(f(2063, 2066), Tr);
    var Kh = t(f(2066, 2069), Tr);
    var Vh = t(f(2069, 2072), Tr);
    var Ch = t(f(2072, 2075), Tr);
    var Ph = t(f(2075, 2078), Tr);
    var Qh = t(f(2078, 2081), Tr);
    var Yh = t(f(2081, 2084), Tr);
    var ny = t(f(2084, 2087), Tr);
    var ry = t(f(2087, 2090), Tr);
    var iy = t(f(2090, 2093), Tr);
    var ty = t(f(2093, 2096), Tr);
    var oy = t(f(2096, 2099), Tr);
    var uy = t(f(2099, 2102), Tr);
    var fy = t(f(2102, 2105), Tr);
    var vy = t(f(2105, 2108), Tr);
    var ey = t(f(2108, 2111), Tr);
    var cy = t(f(2111, 2114), Tr);
    var dy = t(f(2114, 2117), Tr);
    var ay = t(f(2117, 2120), Tr);
    var ly = t(f(2120, 2123), Tr);
    var sy = t(f(2123, 2126), Tr);
    var hy = t(f(2126, 2129), Tr);
    var yy = t(f(2129, 2132), Tr);
    var Ny = t(f(2132, 2135), Tr);
    var my = t(f(2135, 2138), Tr);
    var by = t(f(2138, 2141), Tr);
    var py = t(f(2141, 2144), Tr);
    var My = t(f(2144, 2147), Tr);
    var wy = t(f(2147, 2150), Tr);
    var Ay = t(f(2150, 2153), Tr);
    var Fy = t(f(2153, 2156), Tr);
    var Ey = t(f(2156, 2159), Tr);
    var Oy = t(f(2159, 2162), Tr);
    var Xy = t(f(2162, 2165), Tr);
    var jy = t(f(2165, 2168), Tr);
    var gy = t(f(2168, 2171), Tr);
    var Ty = t(f(2171, 2174), Tr);
    var Zy = t(f(2174, 2177), Tr);
    var Ly = o(2);
    var Hy = t(f(2177, 2180), Tr);
    var ky = t(f(2180, 2183), Tr);
    var Jy = t(f(2183, 2186), Tr);
    var Wy = t(f(2186, 2189), Tr);
    var _y = t(f(2189, 2192), Tr);
    var Gy = t(f(2192, 2195), Tr);
    var xy = t(f(2195, 2198), Tr);
    var Ry = t(f(2198, 2201), Tr);
    var Uy = t(f(2201, 2204), Tr);
    var Sy = t(f(2204, 2207), Tr);
    var Iy = t(f(2207, 2210), Tr);
    var By = t(f(2210, 2213), Tr);
    var Dy = t(f(2213, 2216), Tr);
    var qy = t(f(2216, 2219), Tr);
    var zy = t(f(2219, 2222), Tr);
    var $y = t(f(2222, 2225), Tr);
    var Ky = t(f(2225, 2228), Tr);
    var Vy = t(f(2228, 2231), Tr);
    var Cy = t(f(2231, 2234), Tr);
    var Py = t(f(2234, 2237), Tr);
    var Qy = t(f(2237, 2240), Tr);
    var Yy = t(f(2240, 2243), Tr);
    var nN = t(f(2243, 2246), Tr);
    var rN = t(f(2246, 2249), Tr);
    var iN = t(f(2249, 2252), Tr);
    var tN = t(f(2252, 2255), Tr);
    var oN = t(f(2255, 2258), Tr);
    var uN = t(f(2258, 2261), Tr);
    var fN = t(f(2261, 2264), Tr);
    var vN = t(f(2264, 2267), Tr);
    var eN = t(f(2267, 2270), Tr);
    var cN = t(f(2270, 2273), Tr);
    var dN = t(f(2273, 2276), Tr);
    var aN = t(f(2276, 2279), Tr);
    var lN = t(f(2279, 2282), Tr);
    var sN = t(f(2282, 2285), Tr);
    var hN = t(f(2285, 2288), Tr);
    var yN = t(f(2288, 2291), Tr);
    var NN = t(f(2291, 2294), Tr);
    var mN = t(f(2294, 2297), Tr);
    var bN = t(f(2297, 2300), Tr);
    var pN = t(f(2300, 2303), Tr);
    var MN = t(f(2303, 2306), Tr);
    var wN = t(f(2306, 2309), Tr);
    var AN = t(f(2309, eo), Tr);
    var FN = t(f(eo, 2315), Tr);
    var EN = t(f(2315, 2318), Tr);
    var ON = t(f(2318, 2321), Tr);
    var XN = t(f(2321, 2324), Tr);
    var jN = t(f(2324, 2327), Tr);
    var gN = t(f(2327, 2330), Tr);
    var TN = t(f(2330, 2333), Tr);
    var ZN = t(f(2333, 2336), Tr);
    var LN = t(f(2336, 2339), Tr);
    var HN = t(f(2339, 2342), Tr);
    var kN = t(f(2342, 2345), Tr);
    var JN = t(f(2345, 2348), Tr);
    var WN = t(f(2348, 2351), Tr);
    var _N = t(f(2351, 2354), Tr);
    var GN = t(f(2354, 2357), Tr);
    var xN = t(f(2357, 2360), Tr);
    var RN = t(f(2360, 2363), Tr);
    var UN = t(f(2363, 2366), Tr);
    var SN = t(f(2366, 2369), Tr);
    var IN = t(f(2369, 2372), Tr);
    var BN = t(f(2372, 2375), Tr);
    var DN = t(f(2375, 2378), Tr);
    var qN = t(f(2378, 2381), Tr);
    var zN = t(f(2381, 2384), Tr);
    var $N = t(f(2384, 2387), Tr);
    var KN = t(f(2387, 2390), Tr);
    var VN = t(f(2390, 2393), Tr);
    var CN = t(f(2393, 2396), Tr);
    var PN = t(f(2396, 2399), Tr);
    var QN = t(f(2399, 2402), Tr);
    var YN = t(f(2402, 2405), Tr);
    var nm = t(f(2405, 2408), Tr);
    var rm = t(f(2408, 2411), Tr);
    var im = t(f(2411, 2414), Tr);
    var tm = t(f(2414, 2417), Tr);
    var om = t(f(2417, 2420), Tr);
    var um = t(f(2420, 2423), Tr);
    var fm = t(f(2423, 2426), Tr);
    var vm = t(f(2426, 2429), Tr);
    var em = t(f(2429, 2432), Tr);
    var cm = t(f(2432, 2435), Tr);
    var dm = t(f(2435, 2438), Tr);
    var am = t(f(2438, 2441), Tr);
    var lm = t(f(2441, 2444), Tr);
    var sm = t(f(2444, 2447), Tr);
    var hm = t(f(2447, 2450), Tr);
    var ym = t(f(2450, 2453), Tr);
    var Nm = t(f(2453, 2456), Tr);
    var mm = t(f(2456, 2459), Tr);
    var bm = t(f(2459, 2462), Tr);
    var pm = t(f(2462, 2465), Tr);
    var Mm = t(f(2465, 2468), Tr);
    var wm = t(f(2468, 2471), Tr);
    var Am = t(f(2471, 2474), Tr);
    var Fm = t(f(2474, 2477), Tr);
    var Em = t(f(2477, 2480), Tr);
    var Om = t(f(2480, 2483), Tr);
    var Xm = t(f(2483, 2486), Tr);
    var jm = t(f(2486, 2489), Tr);
    var gm = t(f(2489, 2492), Tr);
    var Tm = t(f(2492, 2495), Tr);
    var Zm = t(f(2495, 2498), Tr);
    var Lm = t(f(2498, 2501), Tr);
    var Hm = t(f(2501, 2504), Tr);
    var km = t(f(2504, 2507), Tr);
    var Jm = t(f(2507, 2510), Tr);
    var Wm = t(f(2510, 2513), Tr);
    var _m = t(f(2513, 2516), Tr);
    var Gm = t(f(2516, 2519), Tr);
    var xm = t(f(2519, 2522), Tr);
    var Rm = t(f(2522, 2525), Tr);
    var Um = t(f(2525, 2528), Tr);
    var Sm = t(f(2528, 2531), Tr);
    var Im = t(f(2531, 2534), Tr);
    var Bm = t(f(2534, 2537), Tr);
    var Dm = t(f(2537, 2540), Tr);
    var qm = t(f(2540, 2543), Tr);
    var zm = t(f(2543, 2546), Tr);
    var $m = t(f(2546, 2549), Tr);
    var Km = t(f(2549, 2552), Tr);
    var Vm = t(f(2552, 2555), Tr);
    var Cm = t(f(2555, 2558), Tr);
    var Pm = t(f(2558, 2561), Tr);
    var Qm = t(f(2561, 2564), Tr);
    var Ym = t(f(2564, 2567), Tr);
    var nb = t(f(2567, 2570), Tr);
    var rb = t(f(2570, 2573), Tr);
    var ib = t(f(2573, 2576), Tr);
    var tb = t(f(2576, 2579), Tr);
    var ob = t(f(2579, 2582), Tr);
    var ub = t(f(2582, 2585), Tr);
    var fb = t(f(2585, 2588), Tr);
    var vb = t(f(2588, 2591), Tr);
    var eb = t(f(2591, 2594), Tr);
    var cb = t(f(2594, 2597), Tr);
    var db = t(f(2597, 2600), Tr);
    var ab = t(f(2600, 2603), Tr);
    var lb = t(f(2603, 2606), Tr);
    var sb = t(f(2606, 2609), Tr);
    var hb = t(f(2609, 2612), Tr);
    var yb = t(f(2612, 2613), Tr);
    var Nb = t(f(2613, 2614), Tr);
    var mb = t(f(2614, 2615), Tr);
    var bb = t(f(2615, 2626), Tr);
    var pb = t(f(2626, 2635), Tr);
    var Mb = t(f(2635, 2646), Tr);
    var wb = t(f(2646, 2648), Tr);
    var Ab = t(f(2648, 2651), Tr);
    var Fb = t(f(2651, 2654), Tr);
    var Eb = t(f(2654, 2657), Tr);
    var Ob = t(f(2657, 2660), Tr);
    var Xb = t(f(2660, 2663), Tr);
    var jb = t(f(2663, 2666), Tr);
    var gb = t(f(2666, 2669), Tr);
    var Tb = t(f(2669, 2672), Tr);
    var Zb = t(f(2672, 2675), Tr);
    var Lb = t(f(2675, 2678), Tr);
    var Hb = t(f(2678, 2681), Tr);
    var kb = t(f(2681, 2684), Tr);
    var Jb = t(f(2684, 2687), Tr);
    var Wb = t(f(2687, 2690), Tr);
    var _b = t(f(2690, 2693), Tr);
    var Gb = t(f(2693, 2696), Tr);
    var xb = t(f(2696, 2699), Tr);
    var Rb = t(f(2699, 2702), Tr);
    var Ub = f(2702, 2726);
    var Sb = t(f(2726, 2729), Tr);
    var Ib = t(f(2729, 2732), Tr);
    var Bb = f(2732, 2748);
    var Db = t(f(2748, 2751), Tr);
    var qb = t(f(2751, 2754), Tr);
    var zb = f(2754, 2794);
    var $b = t(f(2794, 2797), Tr);
    var Kb = t(f(2797, 2800), Tr);
    var Vb = f(2800, 2828);
    var Cb = t(f(2828, 2831), Tr);
    var Pb = f(2831, 2863);
    var Qb = t(f(2863, 2866), Tr);
    var Yb = f(2866, 2894);
    var np = t(f(2894, 2897), Tr);
    var rp = f(2897, 2929);
    var ip = t(f(2929, 2932), Tr);
    var tp = t(f(2932, 2935), Tr);
    var op = t(f(2935, 2938), Tr);
    var up = t(f(2938, 2941), Tr);
    var fp = f(2941, 2973);
    var vp = t(f(2973, 2976), Tr);
    var ep = f(2976, 3008);
    var cp = t(f(3008, 3011), Tr);
    var dp = t(f(3011, 3014), Tr);
    var ap = f(3014, 3050);
    var lp = t(f(3050, 3053), Tr);
    var sp = t(f(3053, 3056), Tr);
    var hp = f(3056, 3080);
    var yp = t(f(3080, 3083), Tr);
    var Np = f(3083, 3111);
    var mp = f(3111, 3131);
    var bp = f(3131, 3147);
    var pp = t(f(3147, 3150), Tr);
    var Mp = f(3150, 3174);
    var wp = f(3174, 3206);
    var Ap = t(f(3206, 3209), Tr);
    var Fp = f(3209, 3225);
    var Ep = f(3225, 3249);
    var Op = t(f(3249, 3252), Tr);
    var Xp = f(3252, 3276);
    var jp = f(3276, 3292);
    var gp = t(f(3292, 3295), Tr);
    var Tp = f(3295, 3315);
    var Zp = f(3315, 3355);
    var Lp = t(f(3355, 3358), Tr);
    var Hp = t(f(3358, 3361), Tr);
    var kp = t(f(3361, 3364), Tr);
    var Jp = f(3364, 3380);
    var Wp = t(f(3380, 3383), Tr);
    var _p = t(f(3383, 3386), Tr);
    var Gp = t(f(3386, 3389), Tr);
    var xp = t(f(3389, 3392), Tr);
    var Rp = t(f(3392, 3395), Tr);
    var Up = t(f(3395, 3398), Tr);
    var Sp = t(f(3398, 3401), Tr);
    var Ip = t(f(3401, 3411), Tr);
    var Bp = t(f(3411, 3414), Tr);
    var Dp = t(f(3414, 3417), Tr);
    var qp = t(f(3417, 3420), Tr);
    var zp = t(f(3420, 3429), Tr);
    var $p = t(f(3429, 3439), Tr);
    var Kp = t(f(3439, 3442), Tr);
    var Vp = t(f(3442, 3445), Tr);
    var Cp = t(f(3445, 3448), Tr);
    var Pp = t(f(3448, 3451), Tr);
    var Qp = t(f(3451, 3454), Tr);
    var Yp = t(f(3454, 3457), Tr);
    var nM = t(f(3457, 3460), Tr);
    var rM = t(f(3460, 3463), Tr);
    var iM = t(f(3463, 3466), Tr);
    var tM = t(f(3466, 3469), Tr);
    var oM = t(f(3469, 3472), Tr);
    var uM = t(f(3472, 3475), Tr);
    var fM = f(3475, 3507);
    var vM = t(f(3507, 3510), Tr);
    var eM = t(f(3510, 3513), Tr);
    var cM = t(f(3513, 3516), Tr);
    var dM = t(f(3516, 3519), Tr);
    var aM = t(f(3519, 3522), Tr);
    var lM = t(f(3522, 3525), Tr);
    var sM = t(f(3525, 3528), Tr);
    var hM = t(f(3528, 3531), Tr);
    var yM = t(f(3531, 3534), Tr);
    var NM = t(f(3534, 3537), Tr);
    var mM = t(f(3537, 3540), Tr);
    var bM = t(f(3540, 3543), Tr);
    var pM = f(3543, 3567);
    var MM = t(f(3567, 3570), Tr);
    var wM = t(f(3570, 3573), Tr);
    var AM = t(f(3573, 3576), Tr);
    var FM = t(f(3576, 3579), Tr);
    var EM = t(f(3579, 3588), Tr);
    var OM = t(f(3588, 3591), Tr);
    var XM = t(f(3591, 3594), Tr);
    var jM = t(f(3594, 3597), Tr);
    var gM = t(f(3597, 3600), Tr);
    var TM = t(f(3600, 3603), Tr);
    var ZM = t(f(3603, 3606), Tr);
    var LM = t(f(3606, 3609), Tr);
    var HM = t(f(3609, 3612), Tr);
    var kM = t(f(3612, 3615), Tr);
    var JM = t(f(3615, 3625), Tr);
    var WM = t(f(3625, 3628), Tr);
    var _M = t(f(3628, 3631), Tr);
    var GM = t(f(3631, 3634), Tr);
    var xM = t(f(3634, 3637), Tr);
    var RM = t(f(3637, 3646), Tr);
    var UM = t(f(3646, 3649), Tr);
    var SM = t(f(3649, 3659), Tr);
    var IM = t(f(3659, 3662), Tr);
    var BM = t(f(3662, 3665), Tr);
    var DM = t(f(3665, 3668), Tr);
    var qM = t(f(3668, 3671), Tr);
    var zM = t(f(3671, 3674), Tr);
    var $M = t(f(3674, 3677), Tr);
    var KM = t(f(3677, 3687), Tr);
    var VM = t(f(3687, 3690), Tr);
    var CM = t(f(3690, 3693), Tr);
    var PM = t(f(3693, 3696), Tr);
    var QM = t(f(3696, 3699), Tr);
    var YM = t(f(3699, 3702), Tr);
    var nw = t(f(3702, 3705), Tr);
    var rw = t(f(3705, 3708), Tr);
    var iw = t(f(3708, 3711), Tr);
    var tw = t(f(3711, 3714), Tr);
    var ow = t(f(3714, 3717), Tr);
    var uw = t(f(3717, 3720), Tr);
    var fw = t(f(3720, 3730), Tr);
    var vw = t(f(3730, 3733), Tr);
    var ew = t(f(3733, 3736), Tr);
    var cw = t(f(3736, 3739), Tr);
    var dw = t(f(3739, 3750), Tr);
    var aw = t(f(3750, 3753), Tr);
    var lw = t(f(3753, 3756), Tr);
    var sw = t(f(3756, 3759), Tr);
    var hw = t(f(3759, 3762), Tr);
    var yw = t(f(3762, 3765), Tr);
    var Nw = t(f(3765, 3768), Tr);
    var mw = t(f(3768, 3778), Tr);
    var bw = t(f(3778, 3788), Tr);
    var pw = t(f(3788, 3791), Tr);
    var Mw = t(f(3791, 3794), Tr);
    var ww = t(f(3794, 3797), Tr);
    var Aw = t(f(3797, 3808), Tr);
    var Fw = t(f(3808, 3818), Tr);
    var Ew = t(f(3818, 3828), Tr);
    var Ow = t(f(3828, 3839), Tr);
    var Xw = t(f(3839, 3842), Tr);
    var jw = t(f(3842, 3845), Tr);
    var gw = t(f(3845, 3848), Tr);
    var Tw = t(f(3848, 3851), Tr);
    var Zw = t(f(3851, 3854), Tr);
    var Lw = t(f(3854, 3857), Tr);
    var Hw = t(f(3857, 3860), Tr);
    var kw = t(f(3860, 3870), Tr);
    var Jw = t(f(3870, 3873), Tr);
    var Ww = t(f(3873, 3876), Tr);
    var _w = t(f(3876, 3879), Tr);
    var Gw = t(f(3879, 3882), Tr);
    var xw = t(f(3882, 3885), Tr);
    var Rw = t(f(3885, 3894), Tr);
    var Uw = t(f(3894, 3897), Tr);
    var Sw = t(f(3897, 3900), Tr);
    var Iw = t(f(3900, 3903), Tr);
    var Bw = t(f(3903, 3906), Tr);
    var Dw = t(f(3906, 3917), Tr);
    var qw = t(f(3917, 3928), Tr);
    var zw = t(f(3928, 3931), Tr);
    var $w = t(f(3931, 3934), Tr);
    var Kw = t(f(3934, 3937), Tr);
    var Vw = t(f(3937, 3941), Tr);
    var Cw = "eRG5QPliOKl4rri6ORg=";
    var Pw = t(f(3941, 3945), Tr);
    var Qw = t(f(3945, 3955), Tr);
    var Yw = t(f(3955, 3966), Tr);
    var nA = t(f(3966, 3975), Tr);
    var rA = t(f(3975, 3985), Tr);
    var iA = t(f(3985, 3994), Tr);
    var tA = t(f(3994, 4003), Tr);
    var oA = t(f(4003, 4014), Tr);
    var uA = t(f(4014, 4018), Tr);
    var fA = t(f(4018, 4022), Tr);
    var vA = t(f(4022, 4026), Tr);
    var eA = t(f(4026, 4037), Tr);
    var cA = t(f(4037, 4048), Tr);
    var dA = t(f(4048, 4052), Tr);
    var aA = t(f(4052, 4056), Tr);
    var lA = t(f(4056, 4060), Tr);
    var sA = t(f(4060, 4064), Tr);
    var hA = t(f(4064, 4068), Tr);
    var yA = t(f(4068, 4072), Tr);
    var NA = f(4072, 4080);
    var mA = t(f(4080, 4090), Tr);
    var bA = f(4090, 4106);
    var pA = f(4106, 4134);
    var MA = f(4134, 4166);
    var wA = f(4166, 4182);
    var AA = f(4182, 4198);
    var FA = t(f(4198, 4208), Tr);
    var EA = t(f(4208, 4219), Tr);
    var OA = t(f(4219, 4230), Tr);
    var XA = t(f(4230, 4239), Tr);
    var jA = t(f(4239, 4250), Tr);
    var gA = t(f(4250, 4260), Tr);
    var TA = t(f(4260, 4270), Tr);
    var ZA = t(f(4270, 4274), Tr);
    var LA = t(f(4274, 4278), Tr);
    var HA = t(f(4278, 4282), Tr);
    var kA = t(f(4282, 4286), Tr);
    var JA = t(f(4286, 4290), Tr);
    var WA = o(3);
    var _A = t(f(4290, 4294), Tr);
    var GA = t(f(4294, 4298), Tr);
    var xA = t(f(4298, 4302), Tr);
    var RA = t(f(4302, 4306), Tr);
    var UA = t(f(4306, 4310), Tr);
    var SA = t(f(4310, 4314), Tr);
    var IA = t(f(4314, 4318), Tr);
    var BA = t(f(4318, 4322), Tr);
    var DA = t(f(4322, 4326), Tr);
    var qA = t(f(4326, 4330), Tr);
    var zA = t(f(4330, 4339), Tr);
    var $A = t(f(4339, 4343), Tr);
    var KA = f(4343, 4375);
    var VA = f(4375, 4399);
    var CA = t(f(4399, 4403), Tr);
    var PA = t(f(4403, 4406), Tr);
    var QA = t(f(4406, 4410), Tr);
    var YA = t(f(4410, 4414), Tr);
    var nF = t(f(4414, 4418), Tr);
    var rF = t(f(4418, 4422), Tr);
    var iF = t(f(4422, 4426), Tr);
    var tF = t(f(4426, 4430), Tr);
    var oF = t(f(4430, 4439), Tr);
    var uF = t(f(4439, 4443), Tr);
    var fF = t(f(4443, 4447), Tr);
    var vF = t(f(4447, 4451), Tr);
    var eF = t(f(4451, 4455), Tr);
    var cF = t(f(4455, 4459), Tr);
    var dF = t(f(4459, 4463), Tr);
    var aF = t(f(4463, 4467), Tr);
    var lF = t(f(4467, 4471), Tr);
    var sF = t(f(4471, 4475), Tr);
    var hF = t(f(4475, 4479), Tr);
    var yF = t(f(4479, 4483), Tr);
    var NF = t(f(4483, 4487), Tr);
    var mF = t(f(4487, 4491), Tr);
    var bF = t(f(4491, 4495), Tr);
    var pF = t(f(4495, 4499), Tr);
    var MF = t(f(4499, 4503), Tr);
    var wF = t(f(4503, 4507), Tr);
    var AF = t(f(4507, 4510), Tr);
    var FF = t(f(4510, 4520), Tr);
    var EF = t(f(4520, 4529), Tr);
    var OF = t(f(4529, 4540), Tr);
    var XF = t(f(4540, 4551), Tr);
    var jF = t(f(4551, 4555), Tr);
    var gF = t(f(4555, 4565), Tr);
    var TF = t(f(4565, 4569), Tr);
    var ZF = t(f(4569, 4573), Tr);
    var LF = t(f(4573, 4584), Tr);
    var HF = t(f(4584, 4588), Tr);
    var kF = t(f(4588, 4592), Tr);
    var JF = t(f(4592, 4596), Tr);
    var WF = t(f(4596, 4600), Tr);
    var _F = t(f(4600, 4604), Tr);
    var GF = t(f(4604, 4608), Tr);
    var xF = t(f(4608, 4618), Tr);
    var RF = t(f(4618, 4622), Tr);
    var UF = t(f(4622, 4626), Tr);
    var SF = t(f(4626, 4630), Tr);
    var IF = t(f(4630, 4634), Tr);
    var BF = t(f(4634, 4638), Tr);
    var DF = t(f(4638, 4642), Tr);
    var qF = t(f(4642, 4646), Tr);
    var zF = t(f(4646, 4650), Tr);
    var $F = t(f(4650, 4654), Tr);
    var KF = t(f(4654, 4658), Tr);
    var VF = t(f(4658, 4662), Tr);
    var CF = t(f(4662, 4666), Tr);
    var PF = t(f(4666, 4670), Tr);
    var QF = t(f(4670, 4674), Tr);
    var YF = t(f(4674, 4678), Tr);
    var nE = t(f(4678, 4682), Tr);
    var rE = t(f(4682, 4686), Tr);
    var iE = t(f(4686, 4690), Tr);
    var tE = t(f(4690, 4694), Tr);
    var oE = t(f(4694, 4698), Tr);
    var uE = t(f(4698, 4702), Tr);
    var fE = t(f(4702, 4706), Tr);
    var vE = t(f(4706, 4717), Tr);
    var eE = t(f(4717, 4721), Tr);
    var cE = t(f(4721, 4725), Tr);
    var dE = t(f(4725, 4729), Tr);
    var aE = t(f(4729, 4733), Tr);
    var lE = t(f(4733, 4737), Tr);
    var sE = t(f(4737, 4741), Tr);
    var hE = t(f(4741, 4745), Tr);
    var yE = t(f(4745, 4753), Tr);
    var NE = t(f(4753, 4757), Tr);
    var mE = t(f(4757, 4761), Tr);
    var bE = t(f(4761, 4765), Tr);
    var pE = t(f(4765, 4769), Tr);
    var ME = t(f(4769, 4773), Tr);
    var wE = t(f(4773, 4777), Tr);
    var AE = t(f(4777, 4781), Tr);
    var FE = t(f(4781, 4785), Tr);
    var EE = t(f(4785, 4789), Tr);
    var OE = t(f(4789, 4793), Tr);
    var XE = t(f(4793, 4797), Tr);
    var jE = t(f(4797, 4801), Tr);
    var gE = t(f(4801, 4805), Tr);
    var TE = t(f(4805, 4809), Tr);
    var ZE = t(f(4809, 4813), Tr);
    var LE = t(f(4813, 4817), Tr);
    var HE = f(4817, 4825);
    var kE = t(f(4825, 4829), Tr);
    var JE = t(f(4829, 4833), Tr);
    var WE = t(f(4833, 4837), Tr);
    var _E = t(f(4837, 4841), Tr);
    var GE = t(f(4841, 4845), Tr);
    var xE = t(f(4845, 4855), Tr);
    var RE = t(f(4855, 4865), Tr);
    var UE = t(f(4865, 4868), Tr);
    var SE = t(f(4868, 4878), Tr);
    var IE = t(f(4878, 4887), Tr);
    var BE = t(f(4887, 4896), Tr);
    var DE = t(f(4896, 4900), Tr);
    var qE = t(f(4900, 4904), Tr);
    var zE = t(f(4904, 4908), Tr);
    var $E = t(f(4908, 4912), Tr);
    var KE = t(f(4912, 4916), Tr);
    var VE = t(f(4916, 4920), Tr);
    var CE = o(4);
    var PE = t(f(4920, 4924), Tr);
    var QE = t(f(4924, 4928), Tr);
    var YE = t(f(4928, 4932), Tr);
    var nO = t(f(4932, 4942), Tr);
    var rO = t(f(4942, 4946), Tr);
    var iO = t(f(4946, 4956), Tr);
    var tO = t(f(4956, 4960), Tr);
    var oO = t(f(4960, 4971), Tr);
    var uO = t(f(4971, 4975), Tr);
    var fO = t(f(4975, 4986), Tr);
    var vO = t(f(4986, 4995), Tr);
    var eO = t(f(4995, 5005), Tr);
    var cO = t(f(5005, 5014), Tr);
    var dO = t(f(5014, 5024), Tr);
    var aO = t(f(5024, 5034), Tr);
    var lO = t(f(5034, 5044), Tr);
    var sO = t(f(5044, 5054), Tr);
    var hO = t(f(5054, 5064), Tr);
    var yO = t(f(5064, 5075), Tr);
    var NO = t(f(5075, 5086), Tr);
    var mO = t(f(5086, 5096), Tr);
    var bO = t(f(5096, 5106), Tr);
    var pO = t(f(5106, 5117), Tr);
    var MO = t(f(5117, 5126), Tr);
    var wO = "Qued5w==";
    var AO = t(f(5126, 5137), Tr);
    var FO = f(5137, 5145);
    var EO = t(f(5145, 5154), Tr);
    var OO = t(f(5154, 5164), Tr);
    var XO = t(f(5164, 5168), Tr);
    var jO = f(5168, 5188);
    var gO = f(5188, 5208);
    var TO = f(5208, 5224);
    var ZO = f(5224, 5240);
    var LO = f(5240, 5260);
    var HO = f(5260, 5280);
    var kO = t(f(5280, 5284), Tr);
    var JO = 684170617;
    var WO = t(f(5284, 5288), Tr);
    var _O = t(f(5288, 5292), Tr);
    var GO = t(f(5292, 5296), Tr);
    var xO = t(f(5296, 5300), Tr);
    var RO = t(f(5300, 5304), Tr);
    var UO = t(f(5304, 5308), Tr);
    var SO = t(f(5308, 5312), Tr);
    var IO = t(f(5312, 5316), Tr);
    var BO = t(f(5316, 5320), Tr);
    var DO = t(f(5320, 5329), Tr);
    var qO = t(f(5329, 5333), Tr);
    var zO = t(f(5333, 5337), Tr);
    var $O = t(f(5337, 5341), Tr);
    var KO = t(f(5341, 5345), Tr);
    var VO = t(f(5345, 5349), Tr);
    var CO = t(f(5349, 5353), Tr);
    var PO = t(f(5353, 5357), Tr);
    var QO = t(f(5357, 5361), Tr);
    var YO = t(f(5361, 5365), Tr);
    var nX = f(5365, 5389);
    var rX = t(f(5389, 5393), Tr);
    var iX = t(f(5393, 5397), Tr);
    var tX = t(f(5397, 5401), Tr);
    var oX = .254829592;
    var uX = 1.421413741;
    var fX = 1.061405429;
    var vX = .3275911;
    var eX = .284496736;
    var cX = 1.453152027;
    var dX = t(f(5401, 5405), Tr);
    var aX = t(f(5405, 5409), Tr);
    var lX = t(f(5409, 5413), Tr);
    var sX = t(f(5413, 5417), Tr);
    var hX = t(f(5417, 5421), Tr);
    var yX = t(f(5421, 5425), Tr);
    var NX = t(f(5425, 5429), Tr);
    var mX = t(f(5429, 5433), Tr);
    var bX = t(f(5433, 5441), Tr);
    var pX = t(f(5441, 5451), Tr);
    var MX = t(f(5451, 5461), Tr);
    var wX = t(f(5461, 5471), Tr);
    var AX = t(f(5471, 5481), Tr);
    var FX = t(f(5481, 5492), Tr);
    var EX = t(f(5492, 5501), Tr);
    var OX = t(f(5501, 5512), Tr);
    var XX = t(f(5512, 5522), Tr);
    var jX = t(f(5522, 5532), Tr);
    var gX = t(f(5532, 5542), Tr);
    var TX = t(f(5542, 5553), Tr);
    var ZX = t(f(5553, 5562), Tr);
    var LX = t(f(5562, 5571), Tr);
    var HX = t(f(5571, 5581), Tr);
    var kX = t(f(5581, 5591), Tr);
    var JX = 371964006;
    var WX = t(f(5591, 5602), Tr);
    var _X = t(f(5602, 5610), Tr);
    var GX = t(f(5610, 5621), Tr);
    var xX = t(f(5621, 5630), Tr);
    var RX = t(f(5630, 5640), Tr);
    var UX = t(f(5640, 5650), Tr);
    var SX = t(f(5650, 5661), Tr);
    var IX = t(f(5661, 5672), Tr);
    var BX = t(f(5672, 5682), Tr);
    var DX = t(f(5682, 5693), Tr);
    var qX = t(f(5693, 5703), Tr);
    var zX = t(f(5703, 5707), Tr);
    var $X = t(f(5707, 5711), Tr);
    var KX = t(f(5711, 5720), Tr);
    var VX = t(f(5720, 5724), Tr);
    var CX = t(f(5724, 5728), Tr);
    var PX = t(f(5728, 5732), Tr);
    var QX = t(f(5732, 5736), Tr);
    var YX = t(f(5736, 5740), Tr);
    var nj = t(f(5740, 5744), Tr);
    var rj = t(f(5744, 5754), Tr);
    var ij = t(f(5754, 5765), Tr);
    var tj = t(f(5765, 5775), Tr);
    var oj = t(f(5775, 5779), Tr);
    var uj = t(f(5779, 5789), Tr);
    var fj = t(f(5789, 5800), Tr);
    var vj = t(f(5800, 5804), Tr);
    var ej = t(f(5804, 5808), Tr);
    var cj = t(f(5808, 5812), Tr);
    var dj = t(f(5812, 5816), Tr);
    var aj = -1984865456;
    var lj = t(f(5816, 5820), Tr);
    var sj = t(f(5820, 5824), Tr);
    var hj = t(f(5824, 5828), Tr);
    var yj = t(f(5828, 5832), Tr);
    var Nj = t(f(5832, 5836), Tr);
    var mj = t(f(5836, 5840), Tr);
    var bj = t(f(5840, 5844), Tr);
    var pj = t(f(5844, 5853), Tr);
    var Mj = t(f(5853, 5864), Tr);
    var wj = t(f(5864, 5873), Tr);
    var Aj = t(f(5873, 5883), Tr);
    var Fj = 1269518501;
    var Ej = 994171810;
    var Oj = t(f(5883, 5893), Tr);
    var Xj = t(f(5893, 5903), Tr);
    var jj = t(f(5903, 5913), Tr);
    var gj = t(f(5913, 5922), Tr);
    var Tj = t(f(5922, 5932), Tr);
    var Zj = t(f(5932, 5942), Tr);
    var Lj = t(f(5942, 5953), Tr);
    var Hj = t(f(5953, 5963), Tr);
    var kj = t(f(5963, 5967), Tr);
    var Jj = t(f(5967, 5977), Tr);
    var Wj = t(f(5977, 5981), Tr);
    var _j = t(f(5981, 5992), Tr);
    var Gj = t(f(5992, 5996), Tr);
    var xj = f(5996, 6004);
    var Rj = t(f(6004, 6008), Tr);
    var Uj = t(f(6008, 6012), Tr);
    var Sj = t(f(6012, 6016), Tr);
    var Ij = t(f(6016, 6027), Tr);
    var Bj = t(f(6027, 6031), Tr);
    var Dj = t(f(6031, 6039), Tr);
    var qj = t(f(6039, 6043), Tr);
    var zj = t(f(6043, 6047), Tr);
    var $j = t(f(6047, 6051), Tr);
    var Kj = t(f(6051, 6055), Tr);
    var Vj = t(f(6055, 6066), Tr);
    var Cj = t(f(6066, 6076), Tr);
    var Pj = t(f(6076, 6086), Tr);
    var Qj = t(f(6086, 6097), Tr);
    var Yj = t(f(6097, 6108), Tr);
    var ng = t(f(6108, 6112), Tr);
    var rg = t(f(6112, 6122), Tr);
    var ig = t(f(6122, 6126), Tr);
    var tg = t(f(6126, 6130), Tr);
    var og = t(f(6130, 6134), Tr);
    var ug = t(f(6134, 6138), Tr);
    var fg = t(f(6138, 6142), Tr);
    var vg = f(6142, 6162);
    var eg = t(f(6162, 6166), Tr);
    var cg = t(f(6166, 6170), Tr);
    var dg = t(f(6170, 6174), Tr);
    var ag = t(f(6174, 6178), Tr);
    var lg = t(f(6178, 6182), Tr);
    var sg = t(f(6182, 6186), Tr);
    var hg = t(f(6186, 6190), Tr);
    var yg = t(f(6190, 6194), Tr);
    var Ng = t(f(6194, 6198), Tr);
    var mg = t(f(6198, 6202), Tr);
    var bg = f(6202, 6226);
    var pg = t(f(6226, 6235), Tr);
    var Mg = f(6235, 6299);
    var wg = t(f(6299, 6303), Tr);
    var Ag = t(f(6303, 6312), Tr);
    var Fg = t(f(6312, 6316), Tr);
    var Eg = f(6316, 6340);
    var Og = t(f(6340, 6344), Tr);
    var Xg = f(6344, 6368);
    var jg = t(f(6368, 6372), Tr);
    var gg = t(f(6372, 6376), Tr);
    var Tg = t(f(6376, 6380), Tr);
    var Zg = t(f(6380, 6384), Tr);
    var Lg = t(f(6384, 6388), Tr);
    var Hg = f(6388, 6412);
    var kg = t(f(6412, 6416), Tr);
    var Jg = f(6416, 6424);
    var Wg = t(f(6424, 6428), Tr);
    var _g = t(f(6428, 6432), Tr);
    var Gg = t(f(6432, 6436), Tr);
    var xg = t(f(6436, 6440), Tr);
    var Rg = t(f(6440, 6451), Tr);
    var Ug = t(f(6451, 6460), Tr);
    var Sg = f(6460, 6472);
    var Ig = t(f(6472, 6482), Tr);
    var Bg = f(6482, 6494);
    var Dg = t(f(6494, 6502), Tr);
    var qg = t(f(6502, 6506), Tr);
    var zg = f(6506, 6570);
    var $g = f(6570, 6582);
    var Kg = t(f(6582, 6586), Tr);
    var Vg = f(6586, 6595);
    var Cg = t(f(6595, 6599), Tr);
    var Pg = t(f(6599, 6603), Tr);
    var Qg = t(f(6603, 6607), Tr);
    var Yg = t(f(6607, 6611), Tr);
    var nT = t(f(6611, 6615), Tr);
    var rT = f(6615, 6639);
    var iT = t(f(6639, 6649), Tr);
    var tT = t(f(6649, 6653), Tr);
    var oT = t(f(6653, 6657), Tr);
    var uT = t(f(6657, 6666), Tr);
    var fT = t(f(6666, 6670), Tr);
    var vT = t(f(6670, 6674), Tr);
    var eT = t(f(6674, 6678), Tr);
    var cT = t(f(6678, 6682), Tr);
    var dT = t(f(6682, 6686), Tr);
    var aT = t(f(6686, 6690), Tr);
    var lT = t(f(6690, 6694), Tr);
    var sT = t(f(6694, 6698), Tr);
    var hT = t(f(6698, 6707), Tr);
    var yT = f(6707, 6727);
    var NT = t(f(6727, 6731), Tr);
    var mT = t(f(6731, 6735), Tr);
    var bT = t(f(6735, 6739), Tr);
    var pT = t(f(6739, 6743), Tr);
    var MT = t(f(6743, 6747), Tr);
    var wT = t(f(6747, 6751), Tr);
    var AT = t(f(6751, 6755), Tr);
    var FT = t(f(6755, 6759), Tr);
    var ET = t(f(6759, 6768), Tr);
    var OT = t(f(6768, 6772), Tr);
    var XT = t(f(6772, 6776), Tr);
    var jT = t(f(6776, 6780), Tr);
    var gT = t(f(6780, 6784), Tr);
    var TT = t(f(6784, 6788), Tr);
    var ZT = t(f(6788, 6792), Tr);
    var LT = t(f(6792, 6796), Tr);
    var HT = t(f(6796, 6805), Tr);
    var kT = t(f(6805, 6809), Tr);
    var JT = t(f(6809, 6812), Tr);
    var WT = t(f(6812, 6815), Tr);
    var _T = t(f(6815, 6826), Tr);
    var GT = t(f(6826, 6837), Tr);
    var xT = t(f(6837, 6846), Tr);
    var RT = t(f(6846, 6856), Tr);
    var UT = t(f(6856, 6865), Tr);
    var ST = t(f(6865, 6869), Tr);
    var IT = t(f(6869, 6873), Tr);
    var BT = t(f(6873, 6877), Tr);
    var DT = t(f(6877, 6881), Tr);
    var qT = t(f(6881, 6885), Tr);
    var zT = t(f(6885, 6889), Tr);
    var $T = t(f(6889, 6893), Tr);
    var KT = t(f(6893, 6897), Tr);
    var VT = t(f(6897, 6901), Tr);
    var CT = t(f(6901, 6905), Tr);
    var PT = t(f(6905, 6909), Tr);
    var QT = t(f(6909, 6913), Tr);
    var YT = t(f(6913, 6917), Tr);
    var nZ = f(6917, 6927);
    var rZ = t(f(6927, 6931), Tr);
    var iZ = t(f(6931, 6935), Tr);
    var tZ = t(f(6935, 6939), Tr);
    var oZ = t(f(6939, 6943), Tr);
    var uZ = t(f(6943, 6947), Tr);
    var fZ = t(f(6947, 6951), Tr);
    var vZ = t(f(6951, 6955), Tr);
    var eZ = t(f(6955, 6958), Tr);
    var cZ = t(f(6958, 6962), Tr);
    var dZ = t(f(6962, 6966), Tr);
    var aZ = t(f(6966, 6970), Tr);
    var lZ = t(f(6970, 6974), Tr);
    var sZ = t(f(6974, 6978), Tr);
    var hZ = t(f(6978, 6982), Tr);
    var yZ = t(f(6982, 6986), Tr);
    var NZ = t(f(6986, 6990), Tr);
    var mZ = t(f(6990, 6994), Tr);
    var bZ = t(f(6994, 6998), Tr);
    var pZ = t(f(6998, 7002), Tr);
    var MZ = t(f(7002, 7006), Tr);
    var wZ = t(f(7006, 7010), Tr);
    var AZ = t(f(7010, 7014), Tr);
    var FZ = t(f(7014, 7018), Tr);
    var EZ = t(f(7018, 7022), Tr);
    var OZ = t(f(7022, 7026), Tr);
    var XZ = t(f(7026, 7030), Tr);
    var jZ = t(f(7030, 7034), Tr);
    var gZ = t(f(7034, 7038), Tr);
    var TZ = f(7038, 7046);
    var ZZ = t(f(7046, 7050), Tr);
    var LZ = t(f(7050, 7054), Tr);
    var HZ = t(f(7054, 7058), Tr);
    var kZ = t(f(7058, 7062), Tr);
    var JZ = t(f(7062, 7073), Tr);
    var WZ = t(f(7073, 7077), Tr);
    var _Z = t(f(7077, 7086), Tr);
    var GZ = t(f(7086, 7090), Tr);
    var xZ = t(f(7090, 7101), Tr);
    var RZ = t(f(7101, 7110), Tr);
    var UZ = t(f(7110, 7114), Tr);
    var SZ = t(f(7114, 7118), Tr);
    var IZ = t(f(7118, 7122), Tr);
    var BZ = t(f(7122, 7126), Tr);
    var DZ = t(f(7126, 7130), Tr);
    var qZ = t(f(7130, 7134), Tr);
    var zZ = t(f(7134, 7138), Tr);
    var $Z = t(f(7138, 7142), Tr);
    var KZ = t(f(7142, 7146), Tr);
    var VZ = t(f(7146, 7150), Tr);
    var CZ = t(f(7150, 7154), Tr);
    var PZ = t(f(7154, 7158), Tr);
    var QZ = t(f(7158, 7162), Tr);
    var YZ = t(f(7162, 7166), Tr);
    var nL = t(f(7166, 7170), Tr);
    var rL = f(7170, 7178);
    var iL = f(7178, 7186);
    var tL = f(7186, 7194);
    var oL = f(7194, 7202);
    var uL = f(7202, 7210);
    var fL = f(7210, 7218);
    var vL = f(7218, 7226);
    var eL = f(7226, 7234);
    var cL = f(7234, 7242);
    var dL = t(f(7242, 7246), Tr);
    var aL = t(f(7246, 7250), Tr);
    var lL = t(f(7250, 7254), Tr);
    var sL = t(f(7254, 7258), Tr);
    var hL = t(f(7258, 7262), Tr);
    var yL = t(f(7262, 7266), Tr);
    var NL = t(f(7266, 7270), Tr);
    var mL = t(f(7270, 7273), Tr);
    var bL = t(f(7273, 7282), Tr);
    var pL = t(f(7282, 7286), Tr);
    var ML = t(f(7286, 7297), Tr);
    var wL = t(f(7297, 7301), Tr);
    var AL = t(f(7301, 7305), Tr);
    var FL = t(f(7305, 7309), Tr);
    var EL = t(f(7309, 7313), Tr);
    var OL = t(f(7313, 7317), Tr);
    var XL = t(f(7317, 7321), Tr);
    var jL = t(f(7321, 7325), Tr);
    var gL = f(7325, 7333);
    var TL = f(7333, 7341);
    var ZL = f(7341, 7357);
    var LL = f(7357, 7369);
    var HL = f(7369, 7377);
    var kL = t(f(7377, 7381), Tr);
    var JL = f(7381, 7421);
    var WL = f(7421, 7529);
    var _L = f(7529, 7581);
    var GL = f(7581, 7613);
    var xL = f(7613, 7657);
    var RL = f(7657, 7681);
    var UL = t(f(7681, 7685), Tr);
    var SL = t(f(7685, 7689), Tr);
    var IL = t(f(7689, 7693), Tr);
    var BL = t(f(7693, 7697), Tr);
    var DL = t(f(7697, 7701), Tr);
    var qL = t(f(7701, 7705), Tr);
    var zL = t(f(7705, 7709), Tr);
    var $L = t(f(7709, 7713), Tr);
    var KL = t(f(7713, 7717), Tr);
    var VL = t(f(7717, 7721), Tr);
    var CL = t(f(7721, 7725), Tr);
    var PL = t(f(7725, 7728), Tr);
    var QL = t(f(7728, 7731), Tr);
    var YL = t(f(7731, 7735), Tr);
    var nH = t(f(7735, 7739), Tr);
    var rH = t(f(7739, 7742), Tr);
    var iH = t(f(7742, 7745), Tr);
    var tH = t(f(7745, 7748), Tr);
    var oH = t(f(7748, 7751), Tr);
    var uH = t(f(7751, 7755), Tr);
    var fH = t(f(7755, 7759), Tr);
    var vH = t(f(7759, 7763), Tr);
    var eH = t(f(7763, 7766), Tr);
    var cH = t(f(7766, 7770), Tr);
    var dH = t(f(7770, 7774), Tr);
    var aH = t(f(7774, 7778), Tr);
    var lH = t(f(7778, 7781), Tr);
    var sH = t(f(7781, 7784), Tr);
    var hH = t(f(7784, 7787), Tr);
    var yH = t(f(7787, 7791), Tr);
    var NH = t(f(7791, 7795), Tr);
    var mH = t(f(7795, 7799), Tr);
    var bH = t(f(7799, 7803), Tr);
    var pH = t(f(7803, 7814), Tr);
    var MH = t(f(7814, 7818), Tr);
    var wH = t(f(7818, 7822), Tr);
    var AH = t(f(7822, 7826), Tr);
    var FH = t(f(7826, 7829), Tr);
    var EH = t(f(7829, 7832), Tr);
    var OH = t(f(7832, 7835), Tr);
    var XH = f(7835, 7871);
    var jH = t(f(7871, 7875), Tr);
    var gH = t(f(7875, 7879), Tr);
    var TH = t(f(7879, 7883), Tr);
    var ZH = t(f(7883, 7886), Tr);
    var LH = t(f(7886, 7890), Tr);
    var HH = t(f(7890, 7894), Tr);
    var kH = t(f(7894, 7898), Tr);
    var JH = t(f(7898, 7902), Tr);
    var WH = t(f(7902, 7906), Tr);
    var _H = t(f(7906, 7910), Tr);
    var GH = f(7910, 7938);
    var xH = t(f(7938, 7942), Tr);
    var RH = t(f(7942, 7946), Tr);
    var UH = t(f(7946, 7950), Tr);
    var SH = t(f(7950, 7954), Tr);
    var IH = t(f(7954, 7958), Tr);
    var BH = f(7958, 7966);
    var DH = f(7966, 7974);
    var qH = t(f(7974, 7983), Tr);
    var zH = f(7983, 8399);
    var $H = f(8399, 9255);
    var KH = f(9255, 9291);
    var VH = f(9291, 9331);
    var CH = f(9331, 9367);
    var PH = f(9367, 9399);
    var QH = f(9399, 9451);
    var YH = f(9451, 9483);
    var nk = f(9483, 9511);
    var rk = f(9511, 9535);
    var ik = f(9535, 9567);
    var tk = f(9567, 9595);
    var ok = f(9595, 9623);
    var uk = f(9623, 9655);
    var fk = f(9655, 9703);
    var vk = f(9703, 9731);
    var ek = f(9731, 9747);
    var ck = f(9747, 9763);
    var dk = f(9763, 9779);
    var ak = f(9779, 9795);
    var lk = f(9795, 9811);
    var sk = f(9811, 9875);
    var hk = f(9875, 9927);
    var yk = f(9927, 9943);
    var Nk = f(9943, 9971);
    var mk = f(9971, 10015);
    var bk = f(10015, 10043);
    var pk = f(10043, 10059);
    var Mk = f(10059, 10087);
    var wk = f(10087, 10099);
    var Ak = f(10099, 10135);
    var Fk = f(10135, 10167);
    var Ek = f(10167, 10203);
    var Ok = t(f(10203, 10207), Tr);
    var Xk = t(f(10207, 10211), Tr);
    var jk = t(f(10211, 10215), Tr);
    var gk = t(f(10215, 10218), Tr);
    var Tk = t(f(10218, 10229), Tr);
    var Zk = t(f(10229, 10238), Tr);
    var Lk = t(f(10238, 10241), Tr);
    var Hk = t(f(10241, 10244), Tr);
    var kk = t(f(10244, 10247), Tr);
    var Jk = t(f(10247, 10250), Tr);
    var Wk = t(f(10250, 10253), Tr);
    var _k = t(f(10253, 10256), Tr);
    var Gk = t(f(10256, 10259), Tr);
    var xk = t(f(10259, 10263), Tr);
    var Rk = t(f(10263, 10266), Tr);
    var Uk = t(f(10266, 10270), Tr);
    var Sk = t(f(10270, 10274), Tr);
    var Ik = t(f(10274, 10278), Tr);
    var Bk = t(f(10278, 10282), Tr);
    var Dk = t(f(10282, 10286), Tr);
    var qk = t(f(10286, 10290), Tr);
    var zk = t(f(10290, 10300), Tr);
    var $k = t(f(10300, 10304), Tr);
    var Kk = t(f(10304, 10308), Tr);
    var Vk = t(f(10308, 10312), Tr);
    var Ck = t(f(10312, 10316), Tr);
    var Pk = 25.5;
    var Qk = t(f(10316, 10327), Tr);
    var Yk = t(f(10327, 10331), Tr);
    var nJ = t(f(10331, 10341), Tr);
    var rJ = t(f(10341, 10345), Tr);
    var iJ = t(f(10345, 10356), Tr);
    var tJ = t(f(10356, 10360), Tr);
    var oJ = t(f(10360, 10364), Tr);
    var uJ = t(f(10364, 10374), Tr);
    var fJ = t(f(10374, 10378), Tr);
    var vJ = f(10378, 10386);
    var eJ = f(10386, 10394);
    var cJ = f(10394, 10402);
    var dJ = t(f(10402, 10405), Tr);
    var aJ = t(f(10405, 10408), Tr);
    var lJ = t(f(10408, 10412), Tr);
    var sJ = t(f(10412, 10416), Tr);
    var hJ = t(f(10416, 10424), Tr);
    var yJ = t(f(10424, 10428), Tr);
    var NJ = t(f(10428, 10431), Tr);
    var mJ = t(f(10431, 10434), Tr);
    var bJ = t(f(10434, 10437), Tr);
    var pJ = t(f(10437, 10440), Tr);
    var MJ = t(f(10440, 10443), Tr);
    var wJ = t(f(10443, 10446), Tr);
    var AJ = t(f(10446, 10449), Tr);
    var FJ = t(f(10449, 10452), Tr);
    var EJ = t(f(10452, 10455), Tr);
    var OJ = t(f(10455, 10458), Tr);
    var XJ = t(f(10458, 10461), Tr);
    var jJ = t(f(10461, 10464), Tr);
    var gJ = t(f(10464, 10467), Tr);
    var TJ = t(f(10467, 10470), Tr);
    var ZJ = t(f(10470, 10473), Tr);
    var LJ = t(f(10473, 10476), Tr);
    var HJ = t(f(10476, 10479), Tr);
    var kJ = t(f(10479, 10482), Tr);
    var JJ = t(f(10482, 10485), Tr);
    var WJ = t(f(10485, 10488), Tr);
    var _J = t(f(10488, 10491), Tr);
    var GJ = t(f(10491, 10494), Tr);
    var xJ = t(f(10494, 10497), Tr);
    var RJ = t(f(10497, 10500), Tr);
    var UJ = t(f(10500, 10503), Tr);
    var SJ = t(f(10503, 10506), Tr);
    var IJ = t(f(10506, 10509), Tr);
    var BJ = t(f(10509, 10512), Tr);
    var DJ = t(f(10512, 10515), Tr);
    var qJ = f(10515, 10539);
    var zJ = f(10539, 10555);
    var $J = f(10555, 10587);
    var KJ = f(10587, 10627);
    var VJ = t(f(10627, 10631), Tr);
    var CJ = t(f(10631, 10641), Tr);
    var PJ = t(f(10641, 10650), Tr);
    var QJ = t(f(10650, 10654), Tr);
    var YJ = t(f(10654, 10658), Tr);
    var nW = t(f(10658, 10662), Tr);
    var rW = t(f(10662, 10666), Tr);
    var iW = t(f(10666, 10669), Tr);
    var tW = t(f(10669, 10672), Tr);
    var oW = t(f(10672, 10675), Tr);
    var uW = t(f(10675, 10678), Tr);
    var fW = t(f(10678, 10681), Tr);
    var vW = t(f(10681, 10691), Tr);
    var eW = t(f(10691, 10702), Tr);
    var cW = t(f(10702, 10705), Tr);
    var dW = t(f(10705, 10715), Tr);
    var aW = t(f(10715, 10718), Tr);
    var lW = t(f(10718, 10722), Tr);
    var sW = t(f(10722, 10725), Tr);
    var hW = t(f(10725, 10734), Tr);
    var yW = t(f(10734, 10738), Tr);
    var NW = t(f(10738, 10742), Tr);
    var mW = t(f(10742, 10746), Tr);
    var bW = t(f(10746, 10750), Tr);
    var pW = t(f(10750, 10754), Tr);
    var MW = t(f(10754, 10758), Tr);
    var wW = t(f(10758, 10762), Tr);
    var AW = t(f(10762, 10766), Tr);
    var FW = t(f(10766, 10770), Tr);
    var EW = t(f(10770, 10774), Tr);
    var OW = f(10774, 10798);
    var XW = t(f(10798, 10802), Tr);
    var jW = t(f(10802, 10813), Tr);
    var gW = t(f(10813, 10817), Tr);
    var TW = f(10817, 10829);
    var ZW = f(10829, 10837);
    var LW = f(10837, 10853);
    var HW = f(10853, 10865);
    var kW = t(f(10865, 10869), Tr);
    var JW = t(f(10869, 10873), Tr);
    var WW = t(f(10873, 10877), Tr);
    var _W = t(f(10877, 10881), Tr);
    var GW = t(f(10881, 10884), Tr);
    var xW = t(f(10884, 10887), Tr);
    var RW = t(f(10887, 10890), Tr);
    var UW = t(f(10890, 10894), Tr);
    var SW = t(f(10894, 10898), Tr);
    var IW = t(f(10898, 10901), Tr);
    var BW = t(f(10901, 10904), Tr);
    var DW = t(f(10904, 10907), Tr);
    var qW = t(f(10907, 10910), Tr);
    var zW = t(f(10910, 10913), Tr);
    var $W = t(f(10913, 10916), Tr);
    var KW = t(f(10916, 10919), Tr);
    var VW = t(f(10919, 10922), Tr);
    var CW = t(f(10922, 10925), Tr);
    var PW = t(f(10925, 10928), Tr);
    var QW = t(f(10928, 10931), Tr);
    var YW = t(f(10931, 10934), Tr);
    var n_ = t(f(10934, 10937), Tr);
    var r_ = t(f(10937, 10940), Tr);
    var i_ = t(f(10940, 10943), Tr);
    var t_ = t(f(10943, 10946), Tr);
    var o_ = t(f(10946, 10949), Tr);
    var u_ = t(f(10949, 10952), Tr);
    var f_ = t(f(10952, 10955), Tr);
    var v_ = t(f(10955, 10958), Tr);
    var e_ = t(f(10958, 10961), Tr);
    var c_ = t(f(10961, 10964), Tr);
    var d_ = t(f(10964, 10967), Tr);
    var a_ = t(f(10967, 10978), Tr);
    var l_ = t(f(10978, 10981), Tr);
    var s_ = t(f(10981, 10984), Tr);
    var h_ = t(f(10984, 10987), Tr);
    var y_ = t(f(10987, 10997), Tr);
    var N_ = t(f(10997, 11E3), Tr);
    var m_ = t(f(11E3, 11004), Tr);
    var b_ = t(f(11004, 11008), Tr);
    var p_ = t(f(11008, 11012), Tr);
    var M_ = t(f(11012, 11016), Tr);
    var w_ = t(f(11016, 11025), Tr);
    var A_ = f(11025, 11033);
    var F_ = t(f(11033, 11037), Tr);
    var E_ = t(f(11037, 11041), Tr);
    var O_ = t(f(11041, 11045), Tr);
    var X_ = t(f(11045, 11048), Tr);
    var j_ = t(f(11048, 11052), Tr);
    var g_ = t(f(11052, 11056), Tr);
    var T_ = t(f(11056, 11060), Tr);
    var Z_ = t(f(11060, 11063), Tr);
    var L_ = t(f(11063, 11067), Tr);
    var H_ = t(f(11067, 11071), Tr);
    var k_ = t(f(11071, 11075), Tr);
    var J_ = t(f(11075, 11079), Tr);
    var W_ = t(f(11079, 11083), Tr);
    var __ = t(f(11083, 11087), Tr);
    var G_ = t(f(11087, 11091), Tr);
    var x_ = t(f(11091, 11095), Tr);
    var R_ = t(f(11095, 11099), Tr);
    var U_ = t(f(11099, 11103), Tr);
    var S_ = f(11103, 11123);
    var I_ = f(11123, 11147);
    var B_ = t(f(11147, 11151), Tr);
    var D_ = t(f(11151, 11155), Tr);
    var q_ = t(f(11155, 11159), Tr);
    var z_ = t(f(11159, 11168), Tr);
    var $_ = t(f(11168, 11172), Tr);
    var K_ = t(f(11172, 11176), Tr);
    var V_ = t(f(11176, 11180), Tr);
    var C_ = t(f(11180, 11184), Tr);
    var P_ = t(f(11184, 11188), Tr);
    var Q_ = t(f(11188, 11197), Tr);
    var Y_ = f(11197, 11221);
    var nG = t(f(11221, 11225), Tr);
    var rG = t(f(11225, 11229), Tr);
    var iG = t(f(11229, 11233), Tr);
    var tG = t(f(11233, 11236), Tr);
    var oG = t(f(11236, 11240), Tr);
    var uG = t(f(11240, 11251), Tr);
    var fG = t(f(11251, 11255), Tr);
    var vG = t(f(11255, 11259), Tr);
    var eG = t(f(11259, 11263), Tr);
    var cG = t(f(11263, 11267), Tr);
    var dG = t(f(11267, 11271), Tr);
    var aG = t(f(11271, 11281), Tr);
    var lG = t(f(11281, 11285), Tr);
    var sG = t(f(11285, 11289), Tr);
    var hG = t(f(11289, 11293), Tr);
    var yG = t(f(11293, 11297), Tr);
    var NG = t(f(11297, 11301), Tr);
    var mG = t(f(11301, 11305), Tr);
    var bG = t(f(11305, 11315), Tr);
    var pG = t(f(11315, 11324), Tr);
    var MG = t(f(11324, 11328), Tr);
    var wG = t(f(11328, 11332), Tr);
    var AG = t(f(11332, 11336), Tr);
    var FG = o(5);
    var EG = t(f(11336, 11340), Tr);
    var OG = t(f(11340, 11344), Tr);
    var XG = t(f(11344, 11348), Tr);
    var jG = t(f(11348, 11352), Tr);
    var gG = t(f(11352, 11356), Tr);
    var TG = t(f(11356, 11360), Tr);
    var ZG = t(f(11360, 11370), Tr);
    var LG = t(f(11370, 11380), Tr);
    var HG = t(f(11380, 11384), Tr);
    var kG = t(f(11384, 11388), Tr);
    var JG = t(f(11388, 11392), Tr);
    var WG = t(f(11392, 11396), Tr);
    var _G = t(f(11396, 11400), Tr);
    var GG = t(f(11400, 11404), Tr);
    var xG = t(f(11404, 11408), Tr);
    var RG = f(11408, 11416);
    var UG = t(f(11416, 11420), Tr);
    var SG = t(f(11420, 11424), Tr);
    var IG = t(f(11424, 11428), Tr);
    var BG = t(f(11428, 11432), Tr);
    var DG = t(f(11432, 11436), Tr);
    var qG = t(f(11436, 11440), Tr);
    var zG = t(f(11440, 11444), Tr);
    var $G = t(f(11444, 11448), Tr);
    var KG = t(f(11448, 11452), Tr);
    var VG = t(f(11452, 11456), Tr);
    var CG = [];
    CG[To] = "9", CG[Zo] = "p", CG[Lo] = "[", CG[Ho] = "]", CG[ko] = t(co, Tr), CG[Jo] = "o", CG[Wo] = "", CG[Go] = "=", CG[xo] = ",", CG[Ro] = ".", CG[Uo] = " ", CG[So] = "log", CG[Io] = "0", CG[Bo] = "T", CG[Do] = "a", CG[qo] = "b", CG[zo] = "e", CG[$o] = "q", CG[Ko] = 2.3283064365386963E-10, CG[Vo] = "4", CG[Co] = "1", CG[Po] = "s", CG[Qo] = .5, CG[Yo] = "x", CG[nu] = "y", CG[ru] = "_", CG[iu] = "v", CG[tu] = "|", CG[ou] = "W", CG[uu] = "@", CG[fu] = .9, CG[vu] = .95, CG[eu] = .99, CG[cu] = "L", CG[du] = .05, CG[au] = 1E-6, CG[lu] = .999999, CG[su] = "-", CG[hu] = ")", CG[yu] = '"', CG[Nu] = "/", CG[mu] = "yi", CG[bu] = "i", CG[pu] = "3", CG[Mu] = ";", CG[wu] = ":";
    var PG = [];
    PG[wo] = "8", PG[Fu] = f(11456, 11472), PG[Eu] = null, PG[Ou] = !1, PG[Xu] = null, PG[ju] = .01, PG[gu] = f(11472, 11503), PG[Tu] = !1, PG[Zu] = !1, PG[Lu] = !1, PG[Hu] = !1, PG[ku] = !1, PG[Ju] = !1, PG[Wu] = f(11503, 11512), PG[_u] = f(11512, 11522), PG[Gu] = !0, CG[hf] = a(f(11522, 11530)), CG[yf] = a(f(11530, 11546)), CG[Nf] = l(f(11546, 11570)), CG[mf] = l(f(11570, 11586)), CG[bf] = a(f(11586, 11602)), CG[pf] = s(f(11602, 11618)), CG[Mf] = s(f(11618, 11642)), CG[wf] = s(f(11642, 11658)), CG[Af] = l(f(11658, 11682)), CG[Ff] = a(f(11682, 11698)), CG[Ef] = s(f(11698, 11722)), CG[Of] = s(f(11722, 11746)), CG[Xf] = d(cf), CG[jf] = a(f(11746, 11758)), CG[gf] = d(Tf), CG[Zf] = d(e(Lf)), CG[Hf] = a("OKl4mPli+BH5D7lAOBe5bfl5OX94hbltORh5Og=="), CG[kf] = l(f(11758, 11790)), CG[Jf] = l(f(11790, 11802)), CG[Wf] = s(f(11802, 11826)), CG[_f] = l(f(11826, 11842)), CG[Gf] = l(f(11842, 11874)), CG[xf] = s(f(11874, 11906)), CG[Rf] = a(f(11906, 11934)), CG[Uf] = a(f(11934, 11966)), CG[Sf] = a(f(11966, 11982)), CG[If] = s(f(11982, 11998)), CG[Bf] = s(f(11998, 12014)), CG[Df] = d(af), CG[Fu] = l(f(12014, 12038)), CG[qf] = l(f(12038, 12050)), CG[zf] = a(f(12050, 12074)), CG[$f] = l(f(12074, 12090)), CG[Kf] = s(f(12090, 12106)), CG[Vf] = a(f(12106, 12122)), CG[Cf] = a(f(12122, 12134)), CG[Pf] = a(f(12134, 12150)), CG[Qf] = a(f(12150, 12162)), CG[Yf] = l(f(12162, 12178)), CG[nv] = s(f(12178, 12210)), CG[rv] = l(f(12210, 12226)), CG[iv] = a(f(12226, 12242)), CG[tv] = l(f(12242, 12262)), CG[ov] = s(f(12262, 12282)), CG[uv] = s(f(12282, 12298)), CG[fv] = s(f(12298, 12306)), CG[vv] = a(f(12306, 12318)), CG[ev] = a(f(12318, 12326)), CG[cv] = a(f(12326, 12334)), CG[dv] = s(f(12334, 12342)), CG[av] = s(f(12342, 12350)), CG[lv] = a(f(12350, 12362)), CG[sv] = s(f(12362, 12378)), CG[e(hv)] = l(f(12378, 12394)), CG[yv] = d(Nv), CG[mv] = d(sf), CG[bv] = d(uf), CG[pv] = l(f(12394, 12422)), CG[Mv] = d(e(t(f(12422, 12433), Tr))), CG[wv] = d(c(Av)), CG[Fv] = a(f(12433, 12465)), CG[Ev] = d(Ov), CG[Xv] = d(vf), CG[jv] = s(f(12465, 12473)), CG[gv] = d(c(t(f(12473, 12484), Tr))), CG[Tv] = d(Zv), CG[Lv] = d(Hv), CG[kv] = d(e(t(f(12484, 12494), Tr))), CG[Jv] = s(f(12494, 12502)), CG[Wv] = a("+WJ4hTkYeEY5GHiFeUs="), CG[_v] = s(f(12502, 12522)), CG[Gv] = a(f(12522, 12550)), CG[xv] = a(f(12550, 12574)), CG[Rv] = a(f(12574, 12590)), CG[Eu] = a(f(12590, 12622)), CG[Uv] = s(f(12622, 12630)), CG[Sv] = s(f(12630, 12638)), CG[Iv] = l(f(12638, 12646)), CG[Bv] = s(f(12646, 12654)), CG[Dv] = s(f(12654, 12666)), CG[qv] = a(f(12666, 12686)), CG[zv] = l(f(12686, 12702)), CG[$v] = s(f(12702, 12718)), CG[Kv] = d(c(t(f(12718, 12728), Tr))), CG[Vv] = d(t(f(12728, 12737), Tr)), CG[Cv] = d(Pv), CG[Qv] = d(t(f(12737, 12747), Tr)), CG[Yv] = d(ne), CG[re] = d(of), CG[ie] = a(f(12747, 12759)), CG[te] = a(f(12759, 12791)), CG[oe] = a(f(12791, 12807)), CG[ue] = s(f(12807, 12831)), CG[fe] = s(f(12831, 12867)), CG[ve] = s(f(12867, 12891)), CG[ee] = a(f(12891, 12943)), CG[ce] = a(f(12943, 12967)), CG[de] = l(f(12967, 12987)), CG[ae] = a(f(12987, 13007)), CG[le] = l(f(13007, 13035)), CG[se] = a(f(13035, 13063)), CG[he] = a(f(13063, 13103)), CG[ye] = a(f(13103, 13135)), CG[Ne] = s(f(13135, 13143)), CG[me] = l(f(13143, 13155)), CG[be] = a(f(13155, 13171)), CG[pe] = s(f(13171, 13199)), CG[Me] = s(f(13199, 13231)), CG[we] = l(f(13231, 13243)), CG[Ae] = a(f(13243, 13271)), CG[Fe] = a(f(13271, 13291)), CG[Ee] = a(f(13291, 13299)), CG[Oe] = s(f(13299, 13323)), CG[Xe] = l(f(13323, 13347)), CG[e(t(f(13347, 13357), Tr))] = l(f(13357, 13369)), CG[e(je)] = d(ge), CG[Te] = d(Ze), CG[Le] = d(He), CG[ke] = d(Je), CG[We] = d(t(f(13369, 13379), Tr)), CG[_e] = d(e(t(f(13379, 13389), Tr))), CG[Ge] = s(f(13389, 13397)), CG[xe] = s(f(13397, 13405)), CG[Re] = s(f(13405, 13413)), CG[Ue] = l(f(13413, 13421)), CG[Se] = s(f(13421, 13429)), CG[Ie] = s(f(13429, 13437)), CG[Be] = s(f(13437, 13445)), CG[De] = l(f(13445, 13453)), CG[qe] = l(f(13453, 13461)), CG[ze] = l(f(13461, 13469)), CG[$e] = s(f(13469, 13477)), CG[Ke] = l(f(13477, 13485)), CG[Ve] = a(f(13485, 13493)), CG[Ce] = d(Pe), CG[Qe] = a(f(13493, 13501)), CG[Ye] = s(f(13501, 13509)), CG[nc] = l(f(13509, 13517)), CG[rc] = a(f(13517, 13525)), CG[ic] = a(f(13525, 13533)), CG[tc] = l(f(13533, 13541)), CG[oc] = l(f(13541, 13549)), CG[uc] = s(f(13549, 13557)), CG[fc] = l(f(13557, 13565)), CG[vc] = a(f(13565, 13573)), CG[ec] = a(f(13573, 13581)), CG[cc] = s(f(13581, 13589)), CG[dc] = l(f(13589, 13597)), CG[ac] = s(f(13597, 13605)), CG[lc] = a("eXS5bQ=="), CG[sc] = l(f(13605, 13613)), CG[hc] = l(f(13613, 13621)), CG[yc] = s(f(13621, 13629)), CG[Nc] = a(f(13629, 13637)), CG[mc] = a(f(13637, 13645)), CG[bc] = s(f(13645, 13653)), CG[pc] = a(f(13653, 13661)), CG[Mc] = l(f(13661, 13669)), CG[wc] = l("OV5VXg=="), CG[Ac] = s(f(13669, 13685)), CG[Fc] = d(Ec), CG[Oc] = s(f(13685, 13693)), CG[Xc] = a(f(13693, 13701)), CG[jc] = l(f(13701, 13709)), CG[gc] = l(f(13709, 13717)), CG[Tc] = l(f(13717, 13725)), CG[Zc] = l(f(13725, 13733)), CG[Lc] = l(f(13733, 13741)), CG[Hc] = s(f(13741, 13749)), CG[kc] = a(f(13749, 13757)), CG[Jc] = s(f(13757, 13765)), CG[Wc] = a(f(13765, 13773)), CG[_c] = s(f(13773, 13781)), CG[Gc] = s(f(13781, 13789)), CG[xc] = l(f(13789, 13797)), CG[Rc] = a(f(13797, 13805)), CG[Uc] = l(f(13805, 13825)), CG[Sc] = a(f(13825, 13841)), CG[Ic] = s(f(13841, 13849)), CG[Bc] = l(f(13849, 13861)), CG[e(t(f(13861, 13870), Tr))] = s(f(13870, 13878)), CG[e(Dc)] = s(f(13878, 13886)), CG[qc] = l(f(13886, 13902)), CG[zc] = s(f(13902, 13914)), CG[$c] = l(f(13914, 13922)), CG[Kc] = l(f(13922, 13942)), CG[Vc] = s(f(13942, 13966)), CG[Cc] = s(f(13966, 13982)), CG[Pc] = a(f(13982, 13994)), CG[Qc] = a(f(13994, 14010)), CG[Yc] = l(f(14010, 14026)), CG[nd] = a(f(14026, 14042)), CG[rd] = s(f(14042, 14066)), CG[id] = a(f(14066, 14078)), CG[td] = s(f(14078, 14086)), CG[od] = s(f(14086, 14094)), CG[ud] = s(f(14094, 14102)), CG[fd] = a(f(14102, 14118)), CG[vd] = a(f(14118, 14126)), CG[ed] = s(f(14126, 14134)), CG[cd] = l(f(14134, 14142)), CG[dd] = s(f(14142, 14154)), CG[ad] = l(f(14154, 14162)), CG[ld] = a(f(14162, 14170)), CG[sd] = l(f(14170, 14178)), CG[hd] = l(f(14178, 14186)), CG[yd] = d(t(f(14186, 14195), Tr)), CG[Nd] = l(f(14195, 14203)), CG[md] = l(f(14203, 14211)), CG[bd] = a(f(14211, 14219)), CG[pd] = a(f(14219, 14235)), CG[Md] = a(f(14235, 14243)), CG[wd] = s(f(14243, 14251)), CG[Ad] = a(f(14251, 14259)), CG[Fd] = s(f(14259, 14267)), CG[Ed] = s(f(14267, 14275)), CG[Od] = a(f(14275, 14283)), CG[Xd] = s(f(14283, 14299)), CG[Uu] = l(f(14299, 14307)), CG[jd] = a(f(14307, 14319)), CG[gd] = a(f(14319, 14327)), CG[Td] = l(f(14327, 14335)), CG[Zd] = a(f(14335, 14343)), CG[Ld] = s(f(14343, 14351)), CG[Hd] = l(f(14351, 14359)), CG[kd] = l(f(14359, 14367)), CG[Jd] = a(f(14367, 14375)), CG[Wd] = l(f(14375, 14383)), CG[_d] = l(f(14383, 14391)), CG[Gd] = s(f(14391, 14399)), CG[xd] = a(f(14399, 14407)), CG[Rd] = a(f(14407, 14415)), CG[Ud] = a(f(14415, 14423)), CG[Sd] = s(f(14423, 14431)), CG[Id] = l(f(14431, 14447)), CG[Bd] = s(f(14447, 14455)), CG[Dd] = a(f(14455, 14475)), CG[qd] = s(f(14475, 14515)), CG[zd] = s(f(14515, 14531)), CG[$d] = l(f(14531, 14543)), CG[e(Kd)] = a(f(14543, 14551)), CG[Vd] = a(f(14551, 14567)), CG[Cd] = s(f(14567, 14591)), CG[Pd] = l(f(14591, 14607)), CG[Qd] = s(f(14607, 14619)), CG[Yd] = s(f(14619, 14643)), CG[na] = l(f(14643, 14675)), CG[ra] = a(f(14675, 14711)), CG[ia] = l(f(14711, 14731)), CG[ta] = s(f(14731, 14739)), CG[oa] = a(f(14739, 14747)), CG[ua] = s(f(14747, 14775)), CG[fa] = s(f(14775, 14791)), CG[va] = l(f(14791, 14799)), CG[ea] = a(f(14799, 14855)), CG[ca] = a(f(14855, 14863)), CG[da] = s(f(14863, 14871)), CG[aa] = s(f(14871, 14879)), CG[la] = l(f(14879, 14887)), CG[sa] = a(f(14887, 14895)), CG[ha] = d(t(f(14895, 14905), Tr)), CG[ya] = l(f(14905, 14917)), CG[Na] = d(c(t(f(14917, 14927), Tr))), CG[ma] = d(ba), CG[pa] = d(c(t(f(14927, 14937), Tr))), CG[Ma] = s(f(14937, 14945)), CG[wa] = a(f(14945, 14985)), CG[Aa] = s(f(14985, 15005)), CG[Fa] = l(f(15005, 15017)), CG[Ea] = d(t(f(15017, 15027), Tr)), CG[Oa] = d(c(t(f(15027, 15037), Tr))), CG[Xa] = d(1063150255), CG[ja] = d(t(f(15037, 15046), Tr)), CG[ga] = d(tf), CG[Ta] = d(t(f(15046, 15056), Tr)), CG[Za] = s(f(15056, 15064)), CG[La] = s(f(15064, 15072)), CG[Ha] = l(f(15072, 15080)), CG[ka] = s(f(15080, 15088)), CG[Ja] = l(f(15088, 15096)), CG[Wa] = s(f(15096, 15104)), CG[_a] = s(f(15104, 15112)), CG[Ga] = s(f(15112, 15136)), CG[xa] = l(f(15136, 15144)), CG[Ra] = l(f(15144, 15152)), CG[Ua] = a(f(15152, 15160)), CG[Ou] = a(f(15160, 15168)), CG[Sa] = s(f(15168, 15176)), CG[Ia] = l(f(15176, 15184)), CG[Xu] = a(f(15184, 15192)), CG[Ba] = a(f(15192, 15200)), CG[Da] = s(f(15200, 15208)), CG[qa] = s(f(15208, 15216)), CG[za] = s(f(15216, 15224)), CG[$a] = s(f(15224, 15232)), CG[ju] = a(f(15232, 15244)), CG[Ka] = s(f(15244, 15252)), CG[Va] = l(f(15252, 15260)), CG[Ca] = a(f(15260, 15268)), CG[Pa] = s(f(15268, 15276)), CG[Qa] = s(f(15276, 15284)), CG[Ya] = s(f(15284, 15292)), CG[nl] = l(f(15292, 15300)), CG[rl] = l(f(15300, 15308)), CG[il] = a(f(15308, 15316)), CG[tl] = l(f(15316, 15324)), CG[ol] = l(f(15324, 15332)), CG[ul] = d(t(f(15332, 15341), Tr)), CG[fl] = d(vl), CG[el] = d(cl), CG[dl] = d(t(f(15341, 15352), Tr)), CG[al] = d(t(f(15352, 15361), Tr)), CG[ll] = l(f(15361, 15381)), CG[sl] = d(hl), CG[yl] = d(Nl), CG[ml] = c(bl), CG[pl] = l(f(15381, 15409)), CG[Ml] = s(f(15409, 15433)), CG[wl] = s(f(15433, 15465)), CG[Al] = l(f(15465, 15497)), CG[Fl] = a(f(15497, 15521)), CG[El] = l(f(15521, 15533)), CG[Ol] = l(f(15533, 15557)), CG[Xl] = s(f(15557, 15589)), CG[jl] = a(f(15589, 15621)), CG[gl] = d(Tl), CG[Zl] = d(c(Ll)), CG[Hl] = d(kl), CG[Jl] = a(f(15621, 15629)), CG[Wl] = s(f(15629, 15641)), CG[_l] = a(f(15641, 15665)), CG[Gl] = l(f(15665, 15693)), CG[xl] = a(f(15693, 15725)), CG[Rl] = a(f(15725, 15753)), CG[Ul] = a(f(15753, 15769)), CG[Sl] = s(f(15769, 15777)), CG[Il] = a(f(15777, 15785)), CG[Bl] = a(f(15785, 15801)), CG[Dl] = d(ql), CG[zl] = d(t(f(15801, 15811), Tr)), CG[$l] = d(Kl), CG[Vl] = d(Cl), CG[gu] = d(Pl), CG[Ql] = d(Yl), CG[ns] = d(c(t(f(15811, 15821), Tr))), CG[rs] = d(is), CG[ts] = d(os), CG[us] = d(fs), CG[vs] = l(f(15821, 15829)), CG[es] = l(f(15829, 15853)), CG[cs] = s(f(15853, 15897)), CG[ds] = s(f(15897, 15913)), CG[as] = s(f(15913, 15925)), CG[ls] = a(f(15925, 15941)), CG[ss] = l(f(15941, 15989)), CG[hs] = d(c(1145293344)), CG[ys] = l(f(15989, 16025)), CG[Ns] = s(f(16025, 16057)), CG[ms] = s(f(16057, 16077)), CG[bs] = s(f(16077, 16085)), CG[ps] = s(f(16085, 16093)), CG[Ms] = a(f(16093, 16101)), CG[ws] = a(f(16101, 16109)), CG[As] = s(f(16109, 16117)), CG[Fs] = a(f(16117, 16125)), CG[Es] = l(f(16125, 16133)), CG[Os] = a(f(16133, 16161)), CG[Xs] = s(f(16161, 16169)), CG[js] = l(f(16169, 16181)), CG[gs] = d(Ts), CG[Zs] = d(Ls), CG[Hs] = d(t(f(16181, 16190), Tr)), CG[ks] = a(f(16190, 16222)), CG[Js] = l(f(16222, 16238)), CG[Ws] = a(f(16238, 16274)), CG[_s] = s(f(16274, 16290)), CG[Gs] = s(f(16290, 16306)), CG[xs] = l(f(16306, 16338)), CG[Rs] = s(f(16338, 16382)), CG[Us] = a(f(16382, 16410)), CG[Ss] = a(f(16410, 16466)), CG[Is] = s(f(16466, 16498)), CG[Bs] = s(f(16498, 16526)), CG[Ds] = a(f(16526, 16558)), CG[qs] = l(f(16558, 16582)), CG[zs] = l(f(16582, 16590)), CG[$s] = l(f(16590, 16598)), CG[Ks] = s(f(16598, 16606)), CG[Vs] = a(f(16606, 16622)), CG[Cs] = a(f(16622, 16630)), CG[Ps] = d(Qs), CG[Ys] = d(c(nh)), CG[rh] = s(f(16630, 16646)), CG[ih] = a(f(16646, 16670)), CG[th] = s(f(16670, 16678)), CG[oh] = l(f(16678, 16698)), CG[uh] = s(f(16698, 16718)), CG[fh] = d(vh), CG[eh] = l(f(16718, 16738)), CG[ch] = d(t(f(16738, 16748), Tr)), CG[dh] = s(f(16748, 16768)), CG[ah] = a(f(16768, 16788)), CG[lh] = s(f(16788, 16820)), CG[sh] = s(f(16820, 16876)), CG[hh] = l(f(16876, 16896)), CG[yh] = l(f(16896, 16916)), CG[Nh] = l(f(16916, 16948)), CG[mh] = l(f(16948, 16964)), CG[bh] = l(f(16964, 17E3)), CG[ph] = s(f(17E3, 17016)), CG[Mh] = d(wh), CG[Ah] = a(f(17016, 17080)), CG[Fh] = a(f(17080, 17124)), CG[Eh] = s(f(17124, 17136)), CG[Oh] = l(f(17136, 17148)), CG[Xh] = a(f(17148, 17156)), CG[jh] = l(f(17156, 17164)), CG[gh] = l(f(17164, 17172)), CG[Th] = a(f(17172, 17180)), CG[Zh] = l(f(17180, 17224)), CG[Lh] = l(f(17224, 17232)), CG[Hh] = a(f(17232, 17240)), CG[e(kh)] = a(f(17240, 17248)), CG[Jh] = s(f(17248, 17256)), CG[Wh] = l("yV6hXg=="), CG[_h] = l(f(17256, 17292)), CG[Gh] = a(f(17292, 17300)), CG[xh] = l(f(17300, 17308)), CG[Rh] = s(f(17308, 17348)), CG[Uh] = a(f(17348, 17356)), CG[Sh] = l(f(17356, 17364)), CG[Ih] = a(f(17364, 17372)), CG[Bh] = s(f(17372, 17380)), CG[484] = l(f(17380, 17388)), CG[Dh] = a(f(17388, 17396)), CG[qh] = s(f(17396, 17404)), CG[zh] = l(f(17404, 17412)), CG[$h] = a(f(17412, 17420)), CG[Kh] = s(f(17420, 17428)), CG[Vh] = l(f(17428, 17436)), CG[Ch] = l(f(17436, 17444)), CG[Ph] = a(f(17444, 17452)), CG[Qh] = a(f(17452, 17460)), CG[Yh] = l(f(17460, 17468)), CG[ny] = s(f(17468, 17476)), CG[ry] = s(f(17476, 17484)), CG[iy] = a(f(17484, 17492)), CG[ty] = s(f(17492, 17500)), CG[oy] = s(f(17500, 17508)), CG[uy] = l(f(17508, 17516)), CG[fy] = a(f(17516, 17524)), CG[vy] = l(f(17524, 17532)), CG[ey] = a(f(17532, 17540)), CG[cy] = s(f(17540, 17548)), CG[dy] = a(f(17548, 17556)), CG[e(t(f(17556, 17565), Tr))] = s(f(17565, 17573)), CG[ay] = s(f(17573, 17581)), CG[ly] = l(f(17581, 17589)), CG[sy] = s(f(17589, 17597)), CG[hy] = l(f(17597, 17605)), CG[yy] = a(f(17605, 17613)), CG[Ny] = s(f(17613, 17621)), CG[my] = l(f(17621, 17629)), CG[by] = a(f(17629, 17637)), CG[py] = a(f(17637, 17645)), CG[My] = l(f(17645, 17653)), CG[wy] = a(f(17653, 17669)), CG[Ay] = s(f(17669, 17677)), CG[Fy] = a(f(17677, 17685)), CG[Ey] = a(f(17685, 17693)), CG[Oy] = a(f(17693, 17701)), CG[Xy] = a(f(17701, 17709)), CG[jy] = s(f(17709, 17749)), CG[gy] = s(f(17749, 17757)), CG[Ty] = a(f(17757, 17765)), CG[Zy] = a(f(17765, 17773)), CG[528] = d(c(t(f(17773, 17784), Tr))), CG[Ly] = a(f(17784, 17792)), CG[Hy] = a(f(17792, 17800)), CG[ky] = a(f(17800, 17808)), CG[Jy] = s(f(17808, 17816)), CG[e(t(f(17816, 17827), Tr))] = s(f(17827, 17835)), CG[Wy] = a(f(17835, 17843)), CG[_y] = l(f(17843, 17851)), CG[Gy] = l(f(17851, 17859)), CG[xy] = l(f(17859, 17867)), CG[Ry] = s(f(17867, 17899)), CG[Uy] = a(f(17899, 17923)), CG[Sy] = s(f(17923, 17947)), CG[Iy] = l(f(17947, 17955)), CG[By] = s(f(17955, 17987)), CG[Dy] = a(f(17987, 17995)), CG[qy] = s(f(17995, 18011)), CG[zy] = a(f(18011, 18035)), CG[$y] = l(f(18035, 18051)), CG[Ky] = a(f(18051, 18067)), CG[Vy] = l(f(18067, 18083)), CG[Cy] = a(f(18083, 18115)), CG[Py] = a(f(18115, 18127)), CG[Qy] = s(f(18127, 18159)), CG[Yy] = l(f(18159, 18167)), CG[nN] = s(f(18167, 18207)), CG[rN] = s(f(18207, 18219)), CG[iN] = a(f(18219, 18235)), CG[tN] = a(f(18235, 18251)), CG[oN] = a(f(18251, 18263)), CG[uN] = a(f(18263, 18271)), CG[fN] = s(f(18271, 18311)), CG[vN] = a(f(18311, 18359)), CG[eN] = s(f(18359, 18383)), CG[cN] = a(f(18383, 18407)), CG[dN] = a(f(18407, 18451)), CG[aN] = l(f(18451, 18467)), CG[lN] = a(f(18467, 18475)), CG[sN] = a(f(18475, 18483)), CG[hN] = s(f(18483, 18491)), CG[yN] = a(f(18491, 18499)), CG[NN] = s(f(18499, 18507)), CG[mN] = a(f(18507, 18515)), CG[bN] = a(f(18515, 18547)), CG[pN] = a(f(18547, 18579)), CG[MN] = s(f(18579, 18615)), CG[wN] = l(f(18615, 18663)), CG[AN] = s(f(18663, 18703)), CG[FN] = l(f(18703, 18735)), CG[EN] = s(f(18735, 18767)), CG[ON] = l(f(18767, 18815)), CG[XN] = s(f(18815, 18839)), CG[jN] = l(f(18839, 18847)), CG[gN] = a(f(18847, 18879)), CG[TN] = a(f(18879, 18887)), CG[ZN] = l(f(18887, 18895)), CG[LN] = s(f(18895, 18903)), CG[HN] = s(f(18903, 18911)), CG[kN] = a(f(18911, 18919)), CG[JN] = a(f(18919, 18927)), CG[WN] = a(f(18927, 18935)), CG[_N] = s(f(18935, 18943)), CG[GN] = a(f(18943, 18951)), CG[xN] = l(f(18951, 18959)), CG[RN] = a(f(18959, 18987)), CG[UN] = l(f(18987, 18995)), CG[SN] = a(f(18995, 19019)), CG[IN] = a(f(19019, 19027)), CG[BN] = a(f(19027, 19035)), CG[DN] = s(f(19035, 19043)), CG[qN] = s(f(19043, 19051)), CG[zN] = a(f(19051, 19059)), CG[$N] = s(f(19059, 19067)), CG[KN] = l(f(19067, 19075)), CG[VN] = s(f(19075, 19099)), CG[CN] = s(f(19099, 19127)), CG[PN] = l(f(19127, 19135)), CG[QN] = a(f(19135, 19143)), CG[YN] = a(f(19143, 19151)), CG[nm] = a(f(19151, 19159)), CG[rm] = s(f(19159, 19167)), CG[im] = a(f(19167, 19175)), CG[tm] = a(f(19175, 19183)), CG[Tu] = a(f(19183, 19191)), CG[Zu] = a(f(19191, 19235)), CG[om] = a(f(19235, 19243)), CG[um] = s(f(19243, 19251)), CG[fm] = l(f(19251, 19259)), CG[vm] = l(f(19259, 19267)), CG[em] = a(f(19267, 19275)), CG[e(t(f(19275, 19285), Tr))] = s(f(19285, 19293)), CG[cm] = l(f(19293, 19301)), CG[dm] = s(f(19301, 19309)), CG[am] = a(f(19309, 19317)), CG[lm] = l(f(19317, 19325)), CG[sm] = a(f(19325, 19333)), CG[hm] = l(f(19333, 19341)), CG[ym] = s(f(19341, 19349)), CG[Nm] = s(f(19349, 19357)), CG[mm] = l(f(19357, 19365)), CG[bm] = a(f(19365, 19373)), CG[pm] = l(f(19373, 19381)), CG[Mm] = l(f(19381, 19401)), CG[Lu] = a(f(19401, 19425)), CG[wm] = l(f(19425, 19433)), CG[Am] = l(f(19433, 19441)), CG[Fm] = a(f(19441, 19461)), CG[Em] = s(f(19461, 19477)), CG[Om] = l(f(19477, 19485)), CG[Xm] = a(f(19485, 19493)), CG[jm] = s(f(19493, 19505)), CG[gm] = a(f(19505, 19549)), CG[Tm] = l(f(19549, 19557)), CG[Zm] = l(f(19557, 19581)), CG[Lm] = l(f(19581, 19601)), CG[Hm] = s(f(19601, 19609)), CG[km] = a(f(19609, 19617)), CG[Jm] = a(f(19617, 19625)), CG[Wm] = s(f(19625, 19633)), CG[_m] = s(f(19633, 19641)), CG[Gm] = s(f(19641, 19649)), CG[xm] = l(f(19649, 19657)), CG[Rm] = a("+WJ5EbiReUt4rjkY"), CG[Um] = a(f(19657, 19705)), CG[Sm] = l(f(19705, 19745)), CG[Im] = s(f(19745, 19777)), CG[Bm] = s(f(19777, 19829)), CG[Dm] = s(f(19829, 19841)), CG[qm] = l(f(19841, 19897)), CG[zm] = a(f(19897, 19917)), CG[$m] = a(f(19917, 19933)), CG[Km] = l(f(19933, 19953)), CG[Vm] = a(f(19953, 19997)), CG[Cm] = s(f(19997, 20061)), CG[Pm] = a(f(20061, 20125)), CG[Qm] = a(f(20125, 20157)), CG[Ym] = l("KV4ZXhleyV6hXlFevV4ZXvFeAV6hXgVe"), CG[nb] = l(f(20157, 20165)), CG[rb] = l(f(20165, 20177)), CG[ib] = a("+WL5D3gpuW05Ug=="), CG[tb] = l(f(20177, 20193)), CG[ob] = s(f(20193, 20241)), CG[ub] = l(f(20241, 20253)), CG[fb] = a(f(20253, 20265)), CG[vb] = l(f(20265, 20273)), CG[eb] = l(f(20273, 20289)), CG[cb] = a(f(20289, 20309)), CG[db] = a(f(20309, 20329)), CG[ab] = l(f(20329, 20357)), CG[lb] = l(f(20357, 20405)), CG[sb] = a(f(20405, 20417)), CG[hb] = a(f(20417, 20433)), PG[Au] = s(f(20433, 20441)), PG[Ru] = CG[hf], PG[yb] = l(f(20441, 20449)), PG[c(vf)] = CG[To], PG[Iu] = a(f(20449, 20457)), PG[Nb] = s(f(20457, 20465)), PG[mb] = a(f(20465, 20473)), PG[Su] = a(f(20473, 20481)), PG[hf] = a(f(20481, 20489)), PG[c(sf)] = a(f(20489, 20497)), PG[yf] = s(f(20497, 20505)), PG[Nf] = a(f(20505, 20513)), PG[mf] = a(f(20513, 20537)), PG[bf] = l(f(20537, 20553)), PG[pf] = s(f(20553, 20569)), PG[Zo] = CG[yf], PG[c(vl)] = l(f(20569, 20577)), PG[Ho] = l(f(20577, 20593)), PG[e(cl)] = CG[Nf], PG[wf] = CG[mf], PG[Af] = a(f(20593, 20601)), PG[Ff] = s(f(20601, 20613)), PG[Ef] = s(f(20613, 20625)), PG[Of] = [
        PG[mf],
        PG[bf],
        PG[wo],
        PG[Au]
    ], PG[ko] = PG[Of][CG[bf]]([
        PG[pf],
        PG[Zo],
        PG[Lo],
        PG[Ru],
        PG[yb],
        PG[Du]
    ]), PG[Xf] = a(f(20625, 20669)), PG[jf] = l(f(20669, 20693)), PG[gf] = l(f(20693, 20725)), PG[Zf] = s(f(20725, 20737)), PG[Hf] = l(f(20737, 20753)), PG[c(ql)] = CG[pf], PG[Jf] = l(f(20753, 20769)), PG[Wf] = s(f(20769, 20777)), PG[Jo] = CG[Zo], PG[_f] = a(f(20777, 20793)), PG[c(bb)] = s(f(20793, 20801)), PG[xf] = s(f(20801, 20825)), PG[c(pb)] = s(f(20825, 20841)), PG[e(Mb)] = s(f(20841, 20857)), PG[c(Ts)] = l(f(20857, 20889)), PG[If] = CG[Lo][CG[bf]](PG[Sf], CG[Ho]), PG[Wo] = CG[Mf], PG[Go] = a(f(20889, 20905)), PG[Bf] = s("W+dj5w=="), PG[Df] = CG[wf], PG[qf] = l(f(20905, 20945)), PG[zf] = a(f(20945, 20997)), PG[$f] = s(f(20997, 21037)), PG[c(Nl)] = l(f(21037, 21077)), PG[xo] = l(f(21077, 21141)), PG[Vf] = a(f(21141, 21181)), PG[Cf] = a(f(21181, 21201)), PG[Pf] = a(f(21201, 21241)), PG[Qf] = l(f(21241, 21273)), PG[Yf] = a(f(21273, 21305)), PG[nv] = CG[Af], PG[rv] = CG[Ff], PG[iv] = CG[Ef], PG[Ro] = a(f(21305, 21361)), PG[tv] = a(f(21361, 21413)), PG[Uo] = l(f(21413, 21493)), PG[ov] = a(f(21493, 21525)), PG[uv] = l(f(21525, 21549)), PG[fv] = s(f(21549, 21629)), PG[vv] = s(f(21629, 21669)), PG[ev] = a(f(21669, 21701)), PG[cv] = a(f(21701, 21717)), PG[dv] = l(f(21717, 21753)), PG[av] = s(f(21753, 21785)), PG[lv] = a(f(21785, 21801)), PG[sv] = s(f(21801, 21857)), PG[So] = s(f(21857, 21881)), PG[wb] = a(f(21881, 21945)), PG[c(bl)] = l(f(21945, 21969)), PG[mv] = CG[Of], PG[bv] = a(f(21969, 21993)), PG[Io] = a(f(21993, 22037)), PG[pv] = s(f(22037, 22069)), PG[Mv] = a(f(22069, 22093)), PG[wv] = l(f(22093, 22125)), PG[Fv] = l(f(22125, 22133)), PG[Ev] = s(f(22133, 22157)), PG[Xv] = a(f(22157, 22189)), PG[jv] = l(f(22189, 22213)), PG[Bo] = s(f(22213, 22269)), PG[Do] = s(f(22269, 22293)), PG[qo] = l(f(22293, 22309)), PG[zo] = l(f(22309, 22341)), PG[gv] = s(f(22341, 22365)), PG[Tv] = a(f(22365, 22373)), PG[Lv] = a(f(22373, 22385))[CG[bf]](PG[Tv], s(f(22385, 22417))), PG[kv] = s(f(22417, 22449)), PG[Jv] = a(f(22449, 22473)), PG[Wv] = a(f(22473, 22497)), PG[_v] = s(f(22497, 22525)), PG[Gv] = s(f(22525, 22541)), PG[xv] = CG[ko], PG[Zl] = PG[xv], PG[Rv] = void PG[xv], PG[Ab] = PG[Rv], PG[Uv] = CG[Xf], PG[$o] = [][CG[jf]](), PG[Sv] = d(t(f(22541, 22551), Tr)), CG[Fb] = function() {}, PG[Ko] = [], PG[Iv] = CG[gf], PG[Bv] = [
        d(t(f(22551, 22561), Tr)),
        d(t(f(22561, 22572), Tr)),
        d(t(f(22572, 22581), Tr)),
        d(t(f(22581, 22591), Tr))
    ], PG[Dv] = d(t(f(22591, 22602), Tr)), PG[qv] = d(t(f(22602, 22612), Tr)), PG[zv] = d(c(t(f(22612, 22622), Tr))), CG[Eb] = function(n) {
        var r = [];
        return r[wo] = n, CG[Ob](r[wo]) && r[wo] !== PG[Eu] && n !== PG[$o];
    }, CG[Xb] = function(n) {
        return n === PG[Rv];
    }, CG[Ob] = function(n) {
        return !(n === PG[Rv]);
    }, CG[jb] = function(n) {
        return !CG[Xb](n) && n !== PG[Eu];
    }, CG[gb] = function(n) {
        return n || PG[Rv];
    }, CG[Tb] = function(n) {
        return n ? CG[Zf] : CG[ko];
    }, CG[Zb] = function(n, r) {
        var i = [];
        return i[wo] = n, !(!CG[Ob](i[wo]) || i[wo] === PG[Eu] || !(CG[Hf] in n)) && n[CG[Hf]](r);
    }, CG[Lb] = function(n, r) {
        return r in n && !!n[r];
    }, CG[ku] = function(n) {
        return Object[PG[e(Qs)]](n);
    }, CG[Ju] = function(n) {
        return Object[PG[$f]](n);
    }, CG[Hb] = function(n, r) {
        return Object[PG[xo]](n, r);
    }, CG[kb] = function() {
        var n = [];
        return n[wo] = Object, (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, n[wo], PG[zf]) && (n[Au] = Object, (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, n[Au], PG[$f])) && (n[Ru] = Object, (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, n[Ru], PG[xo]));
    }, CG[Jb] = function(n) {
        var r = [];
        if (r[wo] = n, CG[Ob](r[wo]) && r[wo] !== PG[Eu]) return n[CG[kf]][CG[Jf]];
    }, CG[Wb] = function(n) {
        try {
            return n();
        } catch (n) {}
    }, CG[_b] = function(n) {
        setTimeout(n, CG[ko]);
    }, CG[Gb] = function(n) {
        return {
            o: function(r) {
                return CG[Gb](r(n));
            },
            _: function(r) {
                return function(n) {
                    return r(n), CG[Gb](n);
                }(n);
            },
            p: function() {
                return n;
            }
        };
    }, CG[xb] = function(n, r) {
        var i = [];
        var t;
        for(t in r)i[wo] = r, CG[jb](i[wo]) && CG[Hf] in i[wo] && i[wo][CG[Hf]](t) && (n[t] = r[t]);
        return n;
    }, PG[$v] = Object[l(f(22622, 22638))] || CG[xb], CG[Rb] = function(n) {
        return n[s(Ub)];
    }, CG[Sb] = function(n) {
        return n[CG[Ef]];
    }, CG[Ib] = function(n) {
        return n[l(Bb)];
    }, CG[Db] = function(n) {
        return n[CG[Wf]];
    }, CG[qb] = function(n) {
        return n[CG[Ef]][s(zb)];
    }, CG[$b] = function(n) {
        return n[CG[Ef]][l(f(22638, 22650))];
    }, CG[Kb] = function(n) {
        return n[l(Vb)] || CG[ko];
    }, CG[Cb] = function(n) {
        return n[a(Pb)] || CG[ko];
    }, CG[Qb] = function(n) {
        return n[l(Yb)] || CG[ko];
    }, CG[np] = function(n) {
        return n[l(rp)] || CG[ko];
    }, CG[ip] = function(n) {
        return n[PG[qf]];
    }, CG[tp] = function(n) {
        return n[PG[Fu]];
    }, CG[op] = function(n) {
        return CG[Gb](n[PG[qf]])[CG[Jo]](function(r) {
            return r ? r[CG[_f]] : n[a(Pb)] || CG[ko];
        })[CG[Zo]]();
    }, CG[up] = function(n, r, i) {
        return n[s(fp)](r, i);
    }, CG[Wu] = function(n, r) {
        if (n[CG[Gf]]) return n[CG[Gf]](r);
    }, CG[vp] = function(n, r) {
        n && n[a(ep)](r);
    }, CG[cp] = function(n, r) {
        n && n[CG[xf]](r);
    }, CG[dp] = function(n, r) {
        return n[CG[e(Pl)]][s(ap)](r);
    }, CG[lp] = function(n) {
        n && n[CG[Rf]] && n[CG[Rf]][CG[xf]](n);
    }, CG[sp] = function(n, r, i) {
        n[CG[pf]][CG[Uf]](r, i, s(hp));
    }, CG[yp] = function(n) {
        var r = [];
        r[wo] = a(Np), (function(n, r, i) {
            n[CG[pf]][CG[Uf]](r, i, s(hp));
        })[so](void 0, n, r[wo], CG[Sf]), r[Au] = a(mp), r[Ru] = a(bp), (function(n, r, i) {
            n[CG[pf]][CG[Uf]](r, i, s(hp));
        })[so](void 0, n, r[Au], r[Ru]);
    }, CG[pp] = function(n, r, i, t) {
        var o = [];
        o[wo] = CG[Sb](n);
        try {
            o[wo][CG[If]] = CG[Wo][CG[bf]](r, CG[Go])[CG[bf]](i, l(Mp))[CG[bf]](t)[CG[bf]](l(wp));
        } catch (n) {}
    }, CG[Ap] = function(n, r) {
        var i = [];
        i[wo] = CG[Sb](n);
        try {
            return (i[wo][CG[If]][CG[Bf]](l(Fp)[CG[bf]](r, l(Ep))) || CG[ko])[CG[Df]];
        } catch (n) {
            return null;
        }
    }, CG[835] = function(n) {
        return !isNaN(n - i(n));
    }, CG[Op] = function(n) {
        var r = [];
        var i = [];
        return i[wo] = Number[a(Xp)], r[wo] = i[c(xu)], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, r[wo]) ? i[wo](n) : typeof n === s(jp) && isFinite(n) && ~~n === n;
    }, CG[gp] = function(n) {
        var r = [];
        return r[c(xu)] = Array[s(Tp)], (function(n) {
            return typeof n === CG[zf];
        })[so](void 0, r[wo]) ? r[c(xu)](n) : Object[PG[Wo]][CG[Fu]][CG[qf]](n) === l(Zp);
    }, CG[Lp] = function(n) {
        return typeof n === CG[zf];
    }, CG[_u] = function(n) {
        return typeof n === CG[$f];
    }, CG[Hp] = function(n) {
        return typeof n === CG[$f] && !(function(n) {
            var r = [];
            return r[c(xu)] = Array[s(Tp)], CG[Lp](r[wo]) ? r[c(xu)](n) : Object[PG[Wo]][CG[Fu]][CG[qf]](n) === l(Zp);
        })[so](void 0, n);
    }, CG[kp] = function(n) {
        return typeof n === l(Jp);
    }, CG[Wp] = function(n) {
        return typeof n == typeof PG[Rv];
    }, CG[_p] = function(n, r) {
        var i = [];
        if (i[wo] = n instanceof Object ? n : Object(n), i[Au] = isFinite(i[wo][CG[Kf]]) ? ~~i[wo][CG[Kf]] : CG[ko], i[c(af)] = CG[ko], void 0 === r) {
            do if (i[Ru] in i[wo] && void 0 === i[e(xu)][i[Ru]]) return i[e(af)];
            while (++i[Ru] < i[Au]);
        } else {
            do if (i[wo][i[Ru]] === r) return i[Ru];
            while (++i[Ru] < i[Au]);
        }
        return -CG[Zf];
    }, CG[Gp] = function(n) {
        if ((function(n) {
            var r = [];
            return r[c(xu)] = Array[s(Tp)], CG[Lp](r[wo]) ? r[c(xu)](n) : Object[PG[Wo]][CG[Fu]][CG[qf]](n) === l(Zp);
        })[so](void 0, n) && n[CG[Kf]]) return n[CG[jf]](CG[xo]);
    }, CG[xp] = function(n) {
        n[CG[Vf]](CG[ko], n[CG[Kf]]);
    }, CG[Rp] = function(n, r) {
        var i = [];
        i[wo] = [], i[c(df)] = CG[ko], i[Ru] = n;
        for(; i[Au] < i[c(af)][CG[Kf]]; i[c(df)]++)i[e(Nv)] = i[Ru][i[Au]], r(i[yb]) && i[wo][CG[Cf]](i[yb]);
        return i[wo];
    }, CG[Up] = function(n, r) {
        var i = [];
        i[wo] = CG[ko], i[Au] = n;
        for(; i[wo] < i[Au][CG[Kf]]; i[c(xu)]++)if (i[Ru] = i[Au][i[e(xu)]], r(i[Ru])) return !0;
        return !1;
    }, CG[Sp] = function(n) {
        var r = [];
        r[wo] = [], r[c(df)] = CG[ko], r[Ru] = n;
        for(; r[Au] < r[c(af)][CG[Kf]]; r[c(df)]++)r[yb] = r[Ru][r[Au]], function(n) {
            return n;
        }(r[yb]) && r[wo][CG[e(Ip)]](r[yb]);
        return r[wo];
    }, CG[Bp] = function(n, r) {
        var i = [];
        i[wo] = [], i[Au] = CG[e(Yl)], i[Ru] = n;
        for(; i[Au] < i[Ru][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[c(df)]], i[wo][CG[Cf]](r(i[yb]));
        return i[wo];
    }, CG[Dp] = function(n, r) {
        var i = [];
        i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
        for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
    }, CG[qp] = function(n) {
        var r = [];
        var i = [];
        if (CG[Pf] in Object) return Object[CG[e(zp)]](n);
        var t;
        for(t in i[wo] = [], n)r[Au] = n, CG[e($p)](r[Au]) && CG[Hf] in r[Au] && r[Au][CG[Hf]](t) && i[wo][CG[Cf]](n[t]);
        return i[wo];
    }, CG[Kp] = function(n) {
        var r = [];
        var i = [];
        if (CG[Qf] in Object) return Object[CG[Qf]](n);
        var t;
        for(t in i[wo] = [], n)r[Au] = n, CG[jb](r[Au]) && CG[Hf] in r[Au] && r[Au][CG[Hf]](t) && i[wo][CG[Cf]](t);
        return i[wo];
    }, CG[Gu] = function(n, r, i) {
        var t = [];
        t[wo] = i, t[Au] = CG[ko], t[Ru] = CG[ko], t[yb] = n;
        for(; t[Ru] < t[c(Nv)][CG[Kf]]; t[Ru]++)t[Du] = t[c(Nv)][t[Ru]], t[wo] = r(t[c(xu)], t[Du], t[Au]), t[c(df)]++;
        return t[wo];
    }, CG[Ab] = function(n, r) {
        var i = [];
        i[wo] = Array(n), i[Au] = i[wo][CG[Kf]] - CG[Zf];
        for(; i[Au] >= CG[ko]; i[Au]--)i[wo][i[Au]] = r(i[Au]);
        return i[wo];
    }, CG[Vp] = function(n, r) {
        return n || r ? r ? n ? n[CG[bf]](r) : r : n : [];
    }, CG[Cp] = function(n) {
        var r = [];
        if (Object(n) === n) {
            var i;
            for(i in n)r[wo] = n[i], (function(n) {
                return CG[jb](n) && n !== PG[$o];
            })[so](void 0, r[wo]) || delete n[i];
            return n;
        }
        return {};
    }, CG[Pp] = function(n, r) {
        return !!n && (function(n, r) {
            var i = [];
            if (i[wo] = n instanceof Object ? n : Object(n), i[Au] = isFinite(i[wo][CG[Kf]]) ? ~~i[wo][CG[Kf]] : CG[ko], i[c(af)] = CG[ko], void 0 === r) {
                do if (i[Ru] in i[wo] && void 0 === i[wo][i[Ru]]) return i[Ru];
                while (++i[Ru] < i[Au]);
            } else {
                do if (i[wo][i[Ru]] === r) return i[Ru];
                while (++i[Ru] < i[Au]);
            }
            return -CG[Zf];
        })[so](void 0, n, r) >= CG[ko];
    }, CG[Qp] = function(n) {
        var r = [];
        r[wo] = {
            k: {},
            number: {},
            string: {}
        }, r[Au] = [];
        var t = function(n) {
            var i = [];
            var t = [];
            return t[wo] = typeof n, t[wo] in r[wo] ? (i[Au] = r[wo][t[wo]], !(function(n, r) {
                return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
            })[so](void 0, i[Au], n) && (r[wo][t[wo]][n] = !0)) : (i[Ru] = r[Au], !(function(n, r) {
                return !!n && CG[_p](n, r) >= CG[ko];
            })[so](void 0, i[Ru], n) && (r[c(df)][CG[Cf]](n), !0));
        };
        var i = [];
        i[wo] = [], i[c(df)] = CG[ko], i[Ru] = n;
        for(; i[Au] < i[c(af)][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[Au]], t(i[yb]) && i[wo][CG[Cf]](i[yb]);
        return i[wo];
    }, CG[t(f(22650, 22653), Tr)] = function(n, r) {
        var i = [];
        i[wo] = CG[ko];
        for(; i[wo] < n[CG[Kf]]; i[wo]++)if (n[i[wo]] === r) return !0;
        return !1;
    }, CG[Yp] = function(n, r) {
        var i = [];
        i[wo] = CG[ko];
        for(; i[wo] < n[CG[Kf]];)n[i[wo]] === r ? n[CG[Vf]](i[wo], CG[Zf]) : i[wo]++;
        return n;
    }, CG[nM] = function(n) {
        var r = [];
        r[wo] = n[CG[Kf]], r[Au] = Array(r[wo]), r[c(af)] = CG[ko];
        for(; r[Ru] < r[c(xu)]; r[c(af)]++)r[Au][r[Ru]] = n[r[wo] - CG[Zf] - r[c(af)]];
        return r[Au];
    }, CG[rM] = function(n) {
        var r = [];
        var i = [];
        i[wo] = [], i[Au] = CG[ko];
        for(; i[Au] < n[CG[Kf]]; i[Au]++)!(function(n) {
            var r = [];
            return r[c(xu)] = Array[s(Tp)], CG[Lp](r[wo]) ? r[c(xu)](n) : Object[PG[Wo]][CG[Fu]][CG[qf]](n) === l(Zp);
        })[so](void 0, n[i[Au]]) ? i[c(xu)][CG[Cf]](n[i[Au]]) : (r[Ru] = function(n) {
            return i[wo][CG[Cf]](n);
        }, (function(n, r) {
            var i = [];
            i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
        })[so](void 0, n[i[Au]], r[Ru]));
        return i[wo];
    }, CG[e(t(f(22653, 22664), Tr))] = function(n) {
        var r = [];
        r[wo] = [], r[Au] = CG[ko], r[Ru] = n;
        for(; r[Au] < r[Ru][CG[Kf]]; r[c(df)]++)r[yb] = r[Ru][r[c(df)]], r[wo][CG[Cf]](function(n) {
            return !!n;
        }(r[yb]));
        return r[wo];
    }, CG[iM] = function(n) {
        var r = [];
        var i = [];
        i[wo] = {}, i[Au] = CG[ko], i[Ru] = CG[ko], i[yb] = n;
        for(; i[Ru] < i[c(Nv)][CG[Kf]]; i[Ru]++)i[Du] = i[c(Nv)][i[Ru]], i[wo] = (r[4] = i[c(xu)], (function(n, r, i) {
            var t = [];
            return t[wo] = r, CG[jb](t[wo]) && t[wo] !== PG[$o] && (n[r] = i), n;
        })[so](void 0, r[4], i[Du], i[Au])), i[c(df)]++;
        return i[wo];
    }, CG[tM] = function(n, r) {
        return CG[iM](n[CG[Yf]](r || CG[xo]));
    }, CG[oM] = function(n) {
        return n[CG[nv]]();
    }, CG[uM] = function(n) {
        return n[l(fM)]();
    }, CG[vM] = function(n) {
        return n[CG[Kf]];
    }, PG[Kv] = CG[rv], CG[eM] = function(n, r) {
        return n[PG[c(e(t(f(22664, 22675), Tr)))]](r);
    }, CG[cM] = function(n) {
        var r = [];
        return r[wo] = CG[eM](n, PG[xv]), r[wo][l(fM)]() + n[CG[iv]](CG[Zf]);
    }, CG[t(f(22675, 22678), Tr)] = function(n, r) {
        var i = [];
        return n + (i[wo] = r, CG[uM](CG[eM](i[e(xu)], PG[xv])) + i[wo][CG[iv]](CG[Zf]));
    }, CG[dM] = function(n, r) {
        return n + CG[Ro] + r;
    }, CG[aM] = function(n) {
        return n[CG[tv]](/[\x00-\x08\x0E-\x1F\x7F-\x9F]/g, PG[$o]);
    }, CG[t(f(22678, 22681), Tr)] = function(n) {
        return n[CG[tv]](/\s/g, CG[Uo]);
    }, CG[lM] = function(n) {
        return n[CG[tv]](/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, CG[Uo]);
    }, CG[sM] = function(n) {
        var r = [];
        return r[wo] = CG[aM](CG[lM](n + PG[$o])), r[wo][CG[tv]](/\s/g, CG[Uo]);
    }, CG[hM] = function(n) {
        return n[CG[tv]](/^\s+|\s+$/g, CG[Wo]);
    }, CG[yM] = function(n) {
        return typeof n === l(Jp) && n[CG[Kf]] === CG[Zf] && n === n[l(fM)]() && n !== n[CG[nv]]();
    }, CG[NM] = function(n) {
        return n[CG[Fu]]();
    }, CG[e(t(f(22681, 22690), Tr))] = function() {
        var n = [];
        var r = [];
        r[wo] = [], r[Au] = CG[ko];
        for(; r[e(df)] < arguments[CG[Kf]]; r[Au]++)r[wo][r[Au]] = arguments[r[Au]];
        return n[Ru] = function(n, r) {
            return n + r;
        }, n[yb] = function(r, i, t) {
            var o = [];
            var u = [];
            return i === t ? r[i] : (u[wo] = ~~((i + t) / CG[Df]), o[wo] = n[yb](r, i, u[wo]), o[Au] = n[yb](r, u[wo] + CG[Zf], t), o[wo] + o[Au]);
        }, n[yb](r[wo], CG[ko], r[wo][CG[Kf]] - CG[Zf]);
    }, CG[mM] = function(n, r) {
        return n[CG[ov]](r) > -CG[Zf];
    }, CG[bM] = function(n) {
        return JSON[a(pM)](n);
    }, CG[MM] = function(n) {
        return JSON[l(f(22690, 22706))](n);
    }, PG[Vv] = CG[uv], PG[Cv] = a(f(22706, 22722)), PG[Qv] = CG[fv], PG[Yv] = CG[vv], PG[re] = CG[ev], PG[Vo] = CG[cv], PG[ie] = CG[dv], PG[te] = CG[av], PG[oe] = CG[lv], PG[ue] = s(f(22722, 22734)), PG[fe] = CG[sv], PG[ve] = l(f(22734, 22750)), PG[ee] = CG[So], PG[ce] = CG[wb], CG[wM] = function() {
        return Math;
    }, CG[AM] = function(n) {
        return CG[wM]()[PG[Vv]](n);
    }, CG[FM] = function(n) {
        return CG[wM]()[PG[c(EM)]](n);
    }, CG[OM] = function(n) {
        return CG[wM]()[PG[re]](n);
    }, CG[XM] = function(n, r) {
        return CG[wM]()[PG[Qv]](n, r);
    }, CG[jM] = function() {
        return CG[wM]()[PG[ie]];
    }, CG[t(f(22750, 22753), Tr)] = function() {
        return CG[wM]()[PG[Vo]];
    }, CG[gM] = function(n, r) {
        return CG[wM]()[PG[ie]](n, r);
    }, CG[TM] = function(n, r) {
        return CG[wM]()[PG[Vo]](n, r);
    }, CG[ZM] = function() {
        return CG[wM]()[PG[te]];
    }, CG[LM] = function(n) {
        return CG[wM]()[PG[ee]](n);
    }, CG[HM] = function() {
        return CG[wM]()[PG[ve]];
    }, CG[kM] = function(n) {
        return CG[e(JM)]()[PG[oe]](n);
    }, CG[WM] = function(n) {
        return CG[wM]()[PG[ue]](n);
    }, CG[_M] = function(n, r) {
        return CG[wM]()[PG[fe]](n, r);
    }, CG[GM] = function(n) {
        return CG[wM]()[PG[ce]](n);
    }, CG[xM] = function(n, r) {
        var i = [];
        var t = [];
        return r === void CG[ko] && (r = CG[yv]), i[wo] = n, CG[Ob](i[wo]) && i[wo] !== PG[Eu] && isFinite(n) ? (t[wo] = CG[XM](CG[e(RM)], r), CG[wM]()[PG[Vv]](n * t[wo]) / t[wo]) : PG[Eu];
    }, CG[UM] = function(n, r) {
        return r !== PG[c(SM)] ? n / r : PG[Eu];
    }, CG[IM] = function() {
        return CG[wM]()[PG[Cv]]();
    }, CG[BM] = function(n) {
        return CG[wM]()[PG[Cv]]() * n | PG[xv];
    }, CG[DM] = function(n, r) {
        return CG[wM]()[PG[re]](n - r);
    }, CG[qM] = function(n, r, i) {
        return r > n ? r : n > i ? i : n;
    }, CG[zM] = function(n) {
        var r = [];
        return r[wo] = n, CG[Ob](r[wo]) && r[wo] !== PG[Eu] ? n > PG[xv] ? CG[Zf] : n < PG[c(SM)] ? -CG[Zf] : PG[xv] : PG[xv];
    }, CG[$M] = function(n) {
        var r = [];
        return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
    }, CG[VM] = function(n) {
        var r = [];
        r[wo] = PG[$o], r[Au] = CG[ko];
        for(; r[Au] < n[CG[Kf]]; r[Au]++)r[c(xu)] += (n[CG[pv]](r[Au]) & CG[Mv])[CG[Fu]](CG[bv]);
        return r[wo];
    }, CG[CM] = function(n) {
        var r = [];
        r[wo] = [], r[c(df)] = CG[ko];
        for(; r[Au] < n[CG[Kf]]; r[Au]++)r[wo][CG[Cf]](n[CG[pv]](r[Au]) & PG[Uv]);
        return r[wo];
    }, CG[PM] = function(n) {
        var i = CG[CM](n);
        var t = function(n, r) {
            return CG[QM](n, (function(n) {
                var r = [];
                return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
            })[so](void 0, r));
        };
        var o = PG[$o];
        var r = [];
        r[wo] = o, r[Au] = CG[ko], r[Ru] = CG[ko], r[yb] = i;
        for(; r[e(af)] < r[c(Nv)][CG[Kf]]; r[Ru]++)r[Du] = r[c(Nv)][r[Ru]], r[wo] = t(r[c(xu)], r[Du], r[e(df)]), r[c(df)]++;
        return r[wo];
    }, CG[e(t(f(22753, 22762), Tr))] = function(n) {
        var r = [];
        return r[c(e(ff))] = (n & CG[yv])[CG[Fu]](CG[Df]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
    }, CG[YM] = function(n) {
        return (n & CG[Mv])[CG[Fu]](CG[bv]);
    }, CG[nw] = function(n, r) {
        var i = [];
        i[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * r) - CG[Zf], n), i[Au] = PG[$o], i[Ru] = r * CG[Df];
        for(; i[wo] > CG[ko];)i[Au] = (function(n) {
            var r = [];
            return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
        })[so](void 0, i[wo]) + i[Au], i[wo] = i[wo] >>> CG[wv];
        if (i[Ru]) for(; i[Au][CG[Kf]] < i[e(af)];)i[Au] = CG[QM](CG[Io], i[Au]);
        return i[Au];
    }, CG[t(f(22762, 22765), Tr)] = function(n, r) {
        var i = [];
        i[c(xu)] = (CG[Zf] << r * CG[wv] - CG[e(fs)]) - CG[Zf], i[Au] = CG[Zf] << r * CG[wv] - CG[Zf], i[Ru] = CG[qM](n, -i[wo], i[wo]);
        var o = (n < PG[c(SM)] ? i[Au] : PG[xv]) | (function(n) {
            return CG[wM]()[PG[re]](n);
        })[so](void 0, i[Ru]);
        var u = r;
        var t = [];
        t[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * u) - CG[Zf], o), t[Au] = PG[$o], t[Ru] = u * CG[Df];
        for(; t[wo] > CG[ko];)t[Au] = CG[$M](t[wo]) + t[Au], t[e(xu)] = t[wo] >>> CG[wv];
        if (t[Ru]) for(; t[Au][CG[Kf]] < t[Ru];)t[Au] = CG[QM](CG[Io], t[Au]);
        return t[Au];
    }, CG[rw] = function(n) {
        var i = [];
        var o = n[CG[Bf]](/.{2}/g) || [];
        var u = PG[$o];
        var t = [];
        t[wo] = u, t[Au] = CG[ko], t[Ru] = CG[ko], t[yb] = o;
        for(; t[Ru] < t[c(Nv)][CG[Kf]]; t[Ru]++)t[Du] = t[c(Nv)][t[Ru]], t[wo] = (i[4] = t[c(xu)], (function(n, i) {
            return CG[QM](n, String[CG[Fv]](r(i, CG[bv]) & PG[Uv]));
        })[so](void 0, i[4], t[Du], t[Au])), t[c(df)]++;
        return t[wo];
    }, CG[iw] = function(n) {
        var t = n[CG[Bf]](/.{2}/g) || [];
        var i = [];
        i[wo] = [], i[Au] = CG[ko], i[Ru] = t;
        for(; i[e(df)] < i[Ru][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[c(df)]], i[wo][CG[Cf]]((function(n) {
            return r(n, CG[bv]) & PG[c(KM)];
        })[so](void 0, i[yb]));
        return i[wo];
    }, CG[tw] = function(n) {
        var i = function(n, r) {
            return CG[QM](n, (function(n) {
                var r = [];
                return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
            })[so](void 0, r));
        };
        var t = PG[$o];
        var r = [];
        r[wo] = t, r[Au] = CG[ko], r[Ru] = CG[ko], r[yb] = n;
        for(; r[e(af)] < r[c(Nv)][CG[Kf]]; r[Ru]++)r[Du] = r[c(Nv)][r[Ru]], r[wo] = i(r[c(xu)], r[Du], r[Au]), r[c(df)]++;
        return r[wo];
    }, CG[ow] = function(n, r) {
        var i = [];
        i[c(xu)] = CG[ko], i[Au] = r && n[CG[Kf]] > r ? n[CG[iv]](CG[ko], r) : n, i[Ru] = i[Au][CG[Kf]], i[yb] = i[Ru] - CG[Zf];
        for(; i[yb] >= CG[ko]; i[yb]--)i[wo] |= (i[Au][i[yb]] ? CG[Zf] : CG[ko]) << i[Ru] - i[yb] - CG[Zf];
        return r && i[Ru] < r && (i[wo] = i[wo] << r - i[Ru]), i[wo];
    }, CG[uw] = function(n) {
        var r = [];
        r[wo] = [], r[c(df)] = CG[ko];
        for(; r[Au] < n[CG[Kf]]; r[Au]++)r[Ru] = n[r[Au]] >>> CG[ko], r[wo][CG[Cf]](r[Ru] & CG[e(fw)], r[Ru] >> CG[wv] & CG[Xf], r[Ru] >> CG[bv] & CG[Xf], r[Ru] >> CG[Ev] & CG[Xf]);
        return r[wo];
    }, CG[vw] = function(n) {
        var r = [];
        r[wo] = [], r[Au] = CG[ko];
        for(; r[e(df)] < CG[wM]()[PG[c(EM)]](n[CG[Kf]] / CG[Xv]); r[Au]++)r[wo][CG[Cf]](((n[r[Au] * CG[Xv]] || CG[ko]) | (n[r[Au] * CG[Xv] + CG[Zf]] || CG[ko]) << CG[wv] | (n[r[Au] * CG[Xv] + CG[Df]] || CG[ko]) << CG[bv] | (n[r[Au] * CG[Xv] + CG[yv]] || CG[ko]) << CG[Ev]) >>> CG[ko]);
        return r[wo];
    }, CG[ew] = function(n) {
        var r = [];
        r[c(xu)] = CG[ko], r[Au] = CG[ko];
        for(; r[Au] < n[CG[Kf]]; r[e(df)]++)r[wo] ^= n[CG[pv]](r[Au]);
        return r[wo] & CG[Xf];
    }, CG[cw] = function(n, i) {
        var t = [];
        var o = [];
        o[wo] = CG[ko];
        var f = n[CG[Yf]](PG[$o]);
        var v = PG[$o];
        var u = [];
        u[wo] = v, u[Au] = CG[ko], u[Ru] = CG[ko], u[yb] = f;
        for(; u[Ru] < u[c(Nv)][CG[Kf]]; u[Ru]++)u[Du] = u[c(Nv)][u[Ru]], u[wo] = (t[5] = u[c(xu)], (function(n, t) {
            var u = [];
            return u[wo] = r(t, CG[bv]) ^ r(CG[eM](i, o[wo]), CG[bv]), o[wo] = (o[wo] + CG[Zf]) % i[CG[Kf]], CG[QM](n, u[wo][CG[Fu]](CG[bv]));
        })[so](void 0, t[5], u[Du], u[Au])), u[c(e(Lf))]++;
        return u[wo];
    }, PG[c(dw)] = CG[Xv], PG[c(Kl)] = CG[yv], CG[aw] = function(n) {
        var r = [];
        if (r[wo] = CG[Df], r[Au] = PG[xv], r[Ru] = PG[e(SM)], n === CG[ko]) return {
            s: PG[xv],
            m: PG[xv],
            e: PG[xv]
        };
        n < PG[xv] && (r[c(df)] = CG[Zf], n = -n);
        for(; n >= r[wo];)n = n / r[wo], r[c(af)]++;
        for(; n < CG[Zf];)n = n * r[wo], r[Ru]--;
        return {
            s: r[Au],
            m: n,
            e: r[Ru]
        };
    }, CG[lw] = function(n, r) {
        var i = [];
        if (i[c(xu)] = ~~n, i[Au] = n - i[wo], i[Du] = i[Au], i[Ru] = PG[xv], i[Au] > CG[ko]) {
            i[yb] = CG[Zf];
            for(; i[Du] !== CG[ko] && i[yb] <= r;)i[Du] *= CG[Df], i[Iu] = ~~i[Du], i[Ru] = i[Ru] | i[Iu] << r - i[yb], i[c(vf)] -= i[Iu], i[c(Nv)]++;
        }
        return i[c(af)];
    }, CG[t(f(22765, 22768), Tr)] = function(n, r) {
        return n / CG[wM]()[PG[Qv]](CG[Df], r) + CG[e(fs)];
    }, CG[sw] = function(n, r$jscomp$0) {
        var i = [];
        i[wo] = (CG[Zf] << r$jscomp$0) - CG[Zf];
        var r = i[wo];
        return CG[jM]()(n, r);
    }, PG[le] = function() {
        function n(n, r) {
            this[CG[jv]] = n, this[CG[Bo]] = r, this[CG[Do]] = (CG[Zf] << n) - CG[Zf], this[CG[qo]] = (CG[Zf] << r) - CG[Zf];
        }
        return n[CG[Mf]][CG[zo]] = function(n) {
            var r = [];
            return r[wo] = CG[aw](n), r[Au] = CG[sw](r[wo][CG[zo]], this[CG[jv]]), r[Ru] = CG[lw](r[c(xu)].m, this[CG[Bo]]), r[Au] << this[CG[Bo]] | r[Ru];
        }, n[CG[Mf]].d = function(n) {
            var r = [];
            return r[wo] = n >> this[CG[Bo]] & this[CG[Do]], r[Au] = n & this[CG[qo]], (function(n, r) {
                return n / CG[XM](CG[Df], r) + CG[Zf];
            })[so](void 0, r[Au], this[CG[Bo]]) * (function(n, r) {
                return CG[wM]()[PG[Qv]](n, r);
            })[so](void 0, CG[Df], r[wo]);
        }, n;
    }(), PG[se] = new PG[le](PG[de], PG[ae]), PG[he] = new PG[le](PG[de] - CG[Df], PG[ae] + CG[Zf]), PG[ye] = CG[XM](CG[Df], CG[bv]), CG[hw] = function(n) {
        var r = [];
        var t = [];
        return r[wo] = n, isNaN(r[e(xu)] - i(r[wo])) ? CG[ko] : (t[c(xu)] = CG[TM](n, CG[ko]), t[wo] > CG[Mv] ? PG[se][CG[zo]]((function(n, r) {
            return CG[jM]()(n, r);
        })[so](void 0, t[wo], PG[ye]) - CG[Tv]) | CG[Lv] : PG[he][CG[zo]](t[wo] + CG[Zf]) | CG[gv]);
    }, CG[yw] = function(n) {
        var i = function(n, r) {
            var i = [];
            return CG[QM](n, (i[wo] = CG[hw](r), (function(n) {
                var r = [];
                return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
            })[so](void 0, i[wo])));
        };
        var t = PG[$o];
        var r = [];
        r[wo] = t, r[Au] = CG[ko], r[Ru] = CG[ko], r[yb] = n;
        for(; r[Ru] < r[c(Nv)][CG[Kf]]; r[Ru]++)r[Du] = r[c(Nv)][r[Ru]], r[wo] = i(r[c(xu)], r[Du], r[Au]), r[c(df)]++;
        return r[wo];
    }, CG[Nw] = function(n) {
        return CG[Gb](~~(n / CG[kv] - PG[c(mw)]))[CG[Jo]](function(n) {
            return CG[tw]([
                n >> CG[Ev],
                n >> CG[bv],
                n >> CG[wv],
                n
            ]);
        })[CG[Zo]]();
    }, CG[t(f(22768, 22771), Tr)] = function(n) {
        var i = CG[Df];
        var r = [];
        r[wo] = CG[gM](CG[XM](CG[e(bw)], CG[wv] * i) - CG[Zf], n % CG[kv]), r[Au] = PG[$o], r[Ru] = i * CG[Df];
        for(; r[wo] > CG[ko];)r[Au] = CG[$M](r[wo]) + r[Au], r[wo] = r[wo] >>> CG[wv];
        if (r[Ru]) for(; r[Au][CG[Kf]] < r[Ru];)r[Au] = CG[QM](CG[Io], r[Au]);
        return r[Au];
    }, CG[pw] = function(n) {
        var r = [];
        return r[wo] = CG[YM](CG[BM](CG[bv])), CG[cw](n[CG[iv]](CG[Zf]), r[wo]) + r[wo];
    }, CG[Mw] = function(n, r, i) {
        var t = [];
        return CG[Gb]((t[wo] = i || CG[BM](CG[bv]), (t[wo] & CG[Mv])[CG[Fu]](CG[bv])))[CG[Jo]](function(i) {
            var t = [];
            return CG[QM]((t[wo] = i, CG[cw](n[CG[iv]](CG[Zf]), t[wo]) + t[wo]), (t[Au] = i, CG[cw](r[CG[iv]](CG[Zf]), t[Au]) + t[Au]));
        })[CG[Zo]]();
    }, CG[t(f(22771, 22774), Tr)] = function(n, r) {
        return CG[cw](r[CG[iv]](CG[Zf]), n) + n;
    }, PG[Ne] = s("rufP58/n0uch5zLnGeff53fntucA59/nMucZ5zLnnec="), PG[me] = s(f(22774, 22806)), PG[be] = s(f(22806, 22838)), PG[pe] = s(f(22838, 22890)), PG[Me] = CG[Jv], CG[ww] = function(n, r, i, t) {
        n[PG[c(Aw)]] ? n[PG[Ne]](r, i, !t) : n[PG[c(Fw)]] && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
    }, CG[t(f(22890, 22893), Tr)] = function(n, r, i, t) {
        n[PG[c(Aw)]] ? n[PG[c(Ew)]](r, i, !t) : n[PG[c(Fw)]] && n[PG[be]](CG[Wo][CG[bf]](PG[c(Ow)])[CG[bf]](r), i);
    }, CG[Xw] = function(n) {
        return !!n[PG[c(Aw)]];
    }, CG[jw] = function(n) {
        return !!n[PG[c(Fw)]];
    }, PG[we] = l(f(22893, 22925)), CG[gw] = function(n, r, i, t) {
        var o = [];
        try {
            o[wo] = n[PG[we]], o[wo] || t(), o[wo][CG[Wv]](r, i), o[wo][CG[_v]](r) !== i && (o[wo][CG[Gv]](r), t());
        } catch (n) {
            t();
        }
    }, CG[t(f(22925, 22928), Tr)] = function(n, r) {
        var i = [];
        try {
            return i[wo] = n[PG[we]], i[wo] ? i[wo][CG[_v]](r) : PG[c(Ec)];
        } catch (n) {
            return PG[Eu];
        }
    }, CG[t(f(22928, 22931), Tr)] = function(n, r) {
        var i = [];
        try {
            if (i[wo] = n[PG[we]], !i[wo]) return;
            return i[wo][CG[Gv]](r);
        } catch (n) {}
    }, PG[Co] = CG[xv], PG[Ae] = l(f(22931, 22951)), PG[Fe] = s(f(22951, 22963)), PG[Ee] = CG[Rv], CG[t(f(22963, 22966), Tr)] = function(n, r, i) {
        (function(n, r, i) {
            var t = [];
            CG[Zb](n, PG[Ae]) && (t[wo] = n[PG[Ae]], CG[Zb](t[wo], r) && t[wo][r](i));
        })[so](void 0, n, r, PG[Co] + i);
    }, CG[Tw] = function(n, r, i) {
        var t = [];
        var o = [];
        t[wo] = n, (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, t[wo], PG[Ae]) && (o[wo] = n[PG[Ae]], t[Au] = o[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, t[Au], r) && o[wo][r](i));
    }, CG[Zw] = function() {
        return new Date;
    }, CG[t(f(22966, 22969), Tr)] = function(n) {
        return new Date(n, CG[Zf], CG[Zf], PG[xv], PG[xv], CG[Zf])[CG[Eu]]();
    }, CG[Lw] = function(n) {
        return new Date(n);
    }, PG[c(t(f(22969, 22980), Tr))] = Date[CG[Uv]] || function() {
        return (new Date)[s(f(22980, 23E3))]();
    }, CG[Hw] = function(n) {
        var r = [];
        r[wo] = PG[Sv] * CG[kv], r[Au] = r[wo] + d(kw) * CG[kv];
        var i = n;
        var t = r[wo];
        var o = r[Au];
        return t > i ? t : i > o ? o : i;
    }, CG[Jw] = function() {
        var r = PG[Oe]();
        var n = [];
        return n[wo] = PG[Sv] * CG[kv], n[Au] = n[wo] + d(kw) * CG[kv], CG[qM](r, n[wo], n[Au]);
    }, CG[Ww] = function(n) {
        var r = [];
        return r[wo] = CG[Zw](), r[wo][a(f(23E3, 23028))](r[wo][a(f(23028, 23056))]() + n), r[wo][CG[Eu]]();
    }, PG[Xe] = {}, CG[t(f(23056, 23059), Tr)] = function() {
        PG[Xe][CG[$o]] || (PG[Xe][CG[$o]] = CG[Hw](PG[Oe]()));
    }, CG[_w] = function() {
        return PG[Xe][CG[$o]];
    }, CG[t(f(23059, 23062), Tr)] = function() {
        return PG[Xe][CG[Sv]] || (PG[Xe][CG[Sv]] = CG[IM]() * CG[bv] | PG[xv]), PG[Xe][CG[Sv]];
    }, PG[Gw] = l(f(23062, 23094)), PG[Po] = CG[Uv], PG[xw] = l(f(23094, 23122)), PG[c(Rw)] = l(f(23122, 23138)), CG[Uw] = function(n) {
        return n[PG[Gw]];
    }, CG[Sw] = function(n) {
        var r = [];
        return r[wo] = CG[Uw](n), !(!r[c(xu)] || !(function(n) {
            return typeof n === CG[zf];
        })[so](void 0, r[wo][PG[Po]]));
    }, CG[t(f(23138, 23141), Tr)] = function(n) {
        var r = [];
        return r[wo] = CG[Uw](n), !(!r[c(xu)] || !r[wo][PG[c(Rw)]]);
    }, CG[Iw] = function(n) {
        if ((function(n) {
            var r = [];
            return r[wo] = CG[Uw](n), !(!r[c(xu)] || !r[wo][PG[c(Rw)]]);
        })[so](void 0, n)) return n[PG[Gw]][PG[Te]];
    }, CG[Bw] = function(n) {
        return (function(n) {
            var r = [];
            return r[wo] = CG[Uw](n), !(!r[c(xu)] || !CG[e(Dw)](r[wo][PG[Po]]));
        })[so](void 0, n) ? n[PG[Gw]][PG[Po]]() : PG[Oe]();
    }, CG[t(f(23141, 23144), Tr)] = function(n) {
        var r = [];
        return r[wo] = CG[Uw](n), r[wo] && r[wo][PG[xw]];
    }, PG[c(qw)] = d(xu), CG[zw] = function() {
        var n = [];
        var r = [];
        return r[wo] = d(t(f(23144, 23154), Tr)), n[Au] = function(n) {
            var i = [];
            n = n[CG[Fu]](), i[wo] = CG[ko];
            for(; i[wo] < n[CG[Kf]]; i[wo]++)r[c(xu)] += n[CG[pv]](i[c(xu)]), i[Au] = .02519603282416938 * r[wo], r[wo] = i[Au] >>> CG[ko], i[Au] -= r[wo], i[Au] *= r[wo], r[wo] = i[Au] >>> CG[ko], i[Au] -= r[wo], r[wo] += i[Au] * PG[c(qw)];
            return (r[wo] >>> CG[ko]) * CG[Ko];
        }, n[Au];
    }, CG[$w] = function(n) {
        var r = [];
        r[wo] = CG[ko], r[Au] = CG[ko], r[Ru] = CG[ko], r[yb] = CG[Zf], r[Du] = CG[zw](), r[wo] = r[Du](CG[Uo]), r[Au] = r[Du](CG[Uo]), r[Ru] = r[Du](CG[Uo]), r[Iu] = CG[ko];
        for(; r[Iu] < n[CG[Kf]]; r[Iu]++)r[wo] -= r[Du](n[r[Iu]]), r[wo] < CG[ko] && (r[wo] += CG[Zf]), r[Au] -= r[Du](n[r[Iu]]), r[Au] < CG[ko] && (r[Au] += CG[Zf]), r[Ru] -= r[Du](n[r[c(of)]]), r[Ru] < CG[ko] && (r[c(af)] += CG[Zf]);
        return r[Du] = null, function() {
            var n = [];
            return n[wo] = d(t(f(23154, 23165), Tr)) * r[wo] + r[yb] * CG[Ko], r[wo] = r[Au], r[Au] = r[Ru], r[Ru] = n[wo] - (r[yb] = n[c(xu)] | CG[ko]);
        };
    }, CG[Kw] = function(n) {
        return n() * PG[Le];
    }, typeof SuppressedError === CG[zf] && SuppressedError, PG[ke] = function() {
        function n(n) {
            this[CG[Iv]] = n, this[CG[Bv]] = Array(n), this[CG[Dv]] = CG[ko], this[CG[Kf]] = CG[ko];
        }
        return n[CG[Mf]][CG[Cf]] = function(n) {
            this[CG[Bv]][this[CG[Dv]]] = n, this[CG[Dv]] = (this[CG[Dv]] + CG[Zf]) % this[CG[Iv]], this[CG[Kf]] < this[CG[Iv]] && this[CG[Kf]]++;
        }, n[CG[Mf]][CG[qv]] = function() {
            return this[CG[Kf]] === CG[ko] ? [] : this[CG[Kf]] < this[CG[Iv]] ? this[CG[Bv]][CG[iv]](CG[ko], this[CG[Kf]]) : h(h([], this[CG[Bv]][CG[iv]](this[CG[Dv]]), !0), this[CG[Bv]][CG[iv]](CG[ko], this[CG[Dv]]), !0);
        }, n[CG[Mf]][CG[zv]] = function() {
            this[CG[Dv]] = CG[ko], this[CG[Kf]] = CG[ko];
        }, n;
    }(), CG[Vw] = function(n, r) {
        var i = [];
        return i[wo] = n[CG[Kf]], Array[PG[Wo]][a(Cw)][CG[$v]](n, Array[PG[Wo]][CG[Vf]][CG[qf]](n, r % i[wo], i[wo])), n;
    }, CG[1001] = function(n, r) {
        var i = [];
        return (i[wo] = n[CG[Yf]](PG[$o]), (function(n, r) {
            var i = [];
            return i[wo] = n[CG[Kf]], Array[PG[Wo]][a(Cw)][CG[$v]](n, Array[PG[Wo]][CG[Vf]][CG[qf]](n, r % i[wo], i[wo])), n;
        })[so](void 0, i[wo], r))[CG[jf]](PG[$o]);
    }, CG[t(f(23229, 23233), Tr)] = function(n, i, t, o) {
        var u = [];
        return CG[cw](n, (u[wo] = i[CG[iv]](CG[ko], t), u[Au] = r(o, CG[bv]), CG[Vw](u[wo][CG[Yf]](PG[$o]), u[Au])[CG[jf]](PG[$o])));
    }, CG[Pw] = function(n, r) {
        var i = [];
        i[Ru] = CG[ko], i[yb] = [], i[Du] = CG[ko];
        for(; i[Du] < n[CG[Kf]] && (i[c(xu)] = [], i[Au] = n[CG[pv]](i[c(vf)]), i[Au] < CG[Lv] ? i[wo][CG[Cf]](i[Au]) : i[Au] < CG[Kv] ? i[wo][CG[Cf]](d(Qw) | i[Au] >> CG[gf], CG[Lv] | i[Au] & CG[Vv]) : i[Au] < d(Yw) || i[Au] >= d(c(nA)) ? i[wo][CG[Cf]](d(c(rA)) | i[Au] >> CG[Cv], CG[Lv] | i[Au] >> CG[gf] & CG[Vv], CG[Lv] | i[e(df)] & CG[Vv]) : (i[Du]++, i[Au] = d(iA) + ((i[Au] & CG[Qv]) << CG[mv] | n[CG[pv]](i[Du]) & CG[Qv]), i[wo][CG[e(Ip)]](d(tA) | i[Au] >> CG[Yv], CG[Lv] | i[Au] >> CG[Cv] & CG[Vv], CG[Lv] | i[Au] >> CG[gf] & CG[Vv], CG[Lv] | i[Au] & CG[Vv])), !r || i[e(af)] + i[wo][CG[Kf]] <= r); i[c(vf)]++)i[Ru] += i[wo][CG[Kf]], i[yb][CG[Cf]][CG[$v]](i[yb], i[wo]);
        return i[yb];
    }, PG[We] = [
        d(t(f(23233, 23244), Tr)),
        d(t(f(23244, 23255), Tr)),
        d(t(f(23255, 23265), Tr))
    ], CG[t(f(23265, 23269), Tr)] = function(n) {
        return (n[CG[ko]] >>> PG[xv]) + (n[CG[Zf]] >>> PG[xv]) + (n[CG[Df]] >>> PG[xv]);
    }, CG[uA] = function(n) {
        var r = [];
        r[wo] = PG[xv];
        for(; n != PG[xv];)n = n >> CG[wv], r[e(xu)]++;
        return r[wo];
    }, CG[fA] = function(n, r) {
        var i = [];
        return CG[Gb]((i[wo] = CG[sM](n), (function(n, r) {
            var i = [];
            i[Ru] = CG[ko], i[yb] = [], i[Du] = CG[ko];
            for(; i[Du] < n[CG[Kf]] && (i[c(xu)] = [], i[Au] = n[CG[pv]](i[c(vf)]), i[Au] < CG[Lv] ? i[wo][CG[Cf]](i[Au]) : i[Au] < CG[Kv] ? i[wo][CG[Cf]](d(Qw) | i[Au] >> CG[gf], CG[Lv] | i[Au] & CG[Vv]) : i[Au] < d(Yw) || i[Au] >= d(c(nA)) ? i[wo][CG[Cf]](d(c(rA)) | i[Au] >> CG[Cv], CG[Lv] | i[Au] >> CG[gf] & CG[Vv], CG[Lv] | i[Au] & CG[Vv]) : (i[Du]++, i[Au] = d(iA) + ((i[Au] & CG[Qv]) << CG[mv] | n[CG[pv]](i[Du]) & CG[Qv]), i[wo][CG[Cf]](d(tA) | i[Au] >> CG[Yv], CG[Lv] | i[Au] >> CG[Cv] & CG[Vv], CG[Lv] | i[Au] >> CG[gf] & CG[Vv], CG[Lv] | i[Au] & CG[Vv])), !r || i[Ru] + i[wo][CG[Kf]] <= r); i[c(vf)]++)i[Ru] += i[wo][CG[Kf]], i[yb][CG[Cf]][CG[$v]](i[yb], i[wo]);
            return i[yb];
        })[so](void 0, i[e(xu)], r ? PG[Uv] - CG[Xv] : PG[Uv])))[CG[Jo]](function(n) {
            var i = [];
            return i[c(xu)] = r ? CG[uw](y(n, CG[Vp](r, PG[Bv])[CG[bf]]([
                PG[Dv]
            ]))) : n, CG[QM]((function(n) {
                var r = [];
                return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
            })[so](void 0, i[wo][CG[Kf]]), CG[e(t(f(23269, 23278), Tr))](i[wo]));
        })[CG[Zo]]();
    }, CG[vA] = function(n$jscomp$0, r, i) {
        var t = [];
        t[3] = r;
        var o = [];
        o[yb] = t[3];
        var u = [];
        u[yb] = o[yb];
        var f = [];
        if (f[wo] = CG[Pw](CG[sM](n$jscomp$0), u[yb] && i ? i - CG[e(eA)] : i), f[Au] = u[yb] ? CG[uw](y(f[wo], CG[Vp](u[yb], PG[Bv])[CG[bf]]([
            PG[Dv]
        ]))) : f[wo], f[Ru] = CG[uA](f[Au][CG[Kf]]), f[Ru] > PG[Iv]) {
            var n = PG[xv];
            var v = [];
            return v[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + v[wo])[CG[iv]](-CG[Df]);
        }
        return CG[QM]((function(n) {
            var r = [];
            return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
        })[so](void 0, f[Ru]), (function(n, r) {
            var i = [];
            i[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * r) - CG[Zf], n), i[Au] = PG[$o], i[Ru] = r * CG[Df];
            for(; i[wo] > CG[ko];)i[Au] = CG[$M](i[wo]) + i[Au], i[wo] = i[wo] >>> CG[wv];
            if (i[Ru]) for(; i[Au][CG[Kf]] < i[Ru];)i[Au] = CG[QM](CG[Io], i[Au]);
            return i[Au];
        })[so](void 0, f[Au][CG[Kf]], f[Ru]), CG[tw](f[c(df)]));
    }, PG[_e] = s(f(23278, 23294)), PG[Ge] = s(f(23294, 23334)), PG[xe] = l(f(23334, 23362)), PG[Re] = a(f(23362, 23378)), PG[c(cA)] = a(f(23378, 23394)), CG[dA] = function(n) {
        var i = CG[Kw](n);
        var t = CG[Xv];
        var r = [];
        r[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * t) - CG[Zf], i), r[Au] = PG[$o], r[Ru] = t * CG[Df];
        for(; r[wo] > CG[ko];)r[Au] = CG[$M](r[wo]) + r[Au], r[wo] = r[wo] >>> CG[wv];
        if (r[Ru]) for(; r[Au][CG[Kf]] < r[Ru];)r[Au] = CG[QM](CG[Io], r[Au]);
        return r[Au];
    }, CG[aA] = function() {
        var n = [];
        var r = [];
        return r[wo] = CG[$w]([
            CG[IM](),
            PG[Oe](),
            CG[IM](),
            CG[IM]()
        ]), CG[QM]((n[wo] = r[c(xu)], (function(n) {
            return CG[nw](CG[Kw](n), CG[Xv]);
        })[so](void 0, n[wo])), (function(n) {
            return CG[nw](CG[e(t(f(23394, 23405), Tr))](n), CG[Xv]);
        })[so](void 0, r[wo]), (function(n) {
            return CG[nw](CG[Kw](n), CG[Xv]);
        })[so](void 0, r[wo]), (function(n) {
            return CG[nw](CG[Kw](n), CG[Xv]);
        })[so](void 0, r[wo]));
    }, CG[lA] = function(n) {
        var r = [];
        var i = [];
        return i[wo] = new Uint32Array(CG[Xv]), n[PG[Re]][PG[Ge]](i[wo]), (r[wo] = function(n) {
            return CG[nw](n, CG[Xv]);
        }, (function(n, r) {
            var i = [];
            i[wo] = [], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[c(df)]], i[wo][CG[Cf]](r(i[yb]));
            return i[wo];
        })[so](void 0, i[wo], r[wo]))[CG[jf]](PG[$o])[CG[Yf]](PG[$o]);
    }, CG[sA] = function(n) {
        return n[PG[Re]][PG[xe]]()[CG[tv]](/-/g, PG[$o]);
    }, CG[hA] = function(n) {
        var i = [];
        var t = [];
        if (n[PG[Re]]) {
            if (n[PG[Re]][PG[Ue]] && n[PG[Re]][PG[xe]]) return n[PG[Re]][PG[xe]]()[CG[tv]](/-/g, PG[$o]);
            n[PG[Re]][PG[Ge]] && (t[wo] = CG[lA](n));
        }
        return t[wo] || (t[wo] = (function() {
            var n = [];
            return n[wo] = CG[$w]([
                CG[IM](),
                PG[Oe](),
                CG[IM](),
                CG[IM]()
            ]), CG[QM](CG[dA](n[c(xu)]), CG[dA](n[wo]), CG[dA](n[wo]), CG[dA](n[wo]));
        })[so](void 0)[CG[Yf]](PG[$o])), t[wo][CG[Cv]] = CG[Vo], t[wo][CG[bv]] = (i[wo] = r(t[wo][CG[bv]], CG[bv]) & CG[yv] | CG[wv], (i[wo] & CG[Mv])[CG[Fu]](CG[bv])), t[wo][CG[jf]](PG[$o]);
    }, CG[yA] = function(n) {
        return !!n && RegExp(s(NA)[CG[bf]](PG[c(mA)], s(bA))[CG[bf]](PG[_e], a(pA))[CG[bf]](PG[_e], a(MA))[CG[bf]](PG[_e], s(wA))[CG[bf]](PG[_e], a(AA)))[CG[ie]](n);
    }, PG[Se] = s(f(23405, 23421)), PG[c(FA)] = CG[te], PG[c(EA)] = s(f(23421, 23445)), PG[De] = CG[oe], PG[qe] = CG[ue], PG[ze] = CG[fe], PG[$e] = a(f(23445, 23473)), PG[Ke] = a(f(23473, 23505)), PG[Ve] = l(f(23505, 23525)), PG[Ce] = a(f(23525, 23553)), PG[Qe] = CG[ve], PG[Ye] = CG[ee], PG[nc] = CG[ce], PG[rc] = s(f(23553, 23585)), PG[ic] = l(f(23585, 23621)), PG[tc] = l(f(23621, 23653)), PG[oc] = CG[de], PG[uc] = a(f(23653, 23689)), PG[fc] = s(f(23689, 23717)), PG[vc] = CG[ae], PG[c(t(f(23717, 23727), Tr))] = s(f(23727, 23747)), PG[c(OA)] = CG[le], PG[cc] = CG[se], PG[dc] = a(f(23747, 23763)), PG[ac] = l(f(23763, 23795)), PG[lc] = l(f(23795, 23811)), PG[sc] = a(f(23811, 23827)), PG[hc] = s(f(23827, 23843)), PG[yc] = a(f(23843, 23851)), PG[c(XA)] = l(f(23851, 23891)), PG[mc] = a(f(23891, 23915)), PG[bc] = l(f(23915, 23931)), PG[pc] = l(f(23931, 23955)), PG[Mc] = a(f(23955, 23979)), PG[c(jA)] = l(f(23979, 24011)), PG[Ac] = CG[he], PG[Fc] = a(f(24011, 24071)), PG[Oc] = s(f(24071, 24135)), PG[Xc] = CG[e(t(f(24135, 24144), Tr))], PG[jc] = s(f(24144, 24164)), PG[e(gA)] = s(f(24164, 24180)), PG[Tc] = a(f(24180, 24220)), PG[Zc] = l(f(24220, 24236)), PG[Yo] = l(f(24236, 24272)), PG[nu] = a(f(24272, 24288)), PG[Lc] = l(f(24288, 24304)), PG[Hc] = l(f(24304, 24312)), PG[kc] = l(f(24312, 24352)), PG[Jc] = CG[Wo][CG[bf]](PG[Lc], CG[Uo])[CG[bf]](PG[c(t(f(24352, 24362), Tr))], CG[Ro]), PG[c(TA)] = CG[Wo][CG[bf]](PG[kc], CG[Ne])[CG[bf]](PG[Hc], CG[Ro]), PG[_c] = a(f(24362, 24370)), PG[Gc] = l(f(24370, 24386)), PG[xc] = s(f(24386, 24402)), PG[Rc] = s(f(24402, 24422)), PG[Uc] = a(f(24422, 24442)), PG[Sc] = s(f(24442, 24458)), PG[c(t(f(24458, 24468), Tr))] = l(f(24468, 24488)), PG[Bc] = l(f(24488, 24512)), CG[ZA] = function(n) {
        return n[s(Ub)][PG[Be]];
    }, CG[LA] = function(n) {
        return n[s(Ub)][PG[De]];
    }, CG[HA] = function(n) {
        return n[s(Ub)][PG[Ce]];
    }, CG[kA] = function(n) {
        return n[s(Ub)][PG[qe]];
    }, CG[t(f(24512, 24516), Tr)] = function(n) {
        return n[s(Ub)][PG[$e]];
    }, CG[JA] = function(n) {
        var r = [];
        var i = [];
        return i[wo] = CG[Rb](n), i[wo][PG[Qe]] || i[wo][(function(n, r) {
            return n + CG[cM](r);
        })[so](void 0, CG[me], PG[Qe])] || i[wo][r[wo] = l(f(24516, 24536)), (function(n, r) {
            return n + CG[cM](r);
        })[so](void 0, r[wo], PG[Qe])] || i[wo][r[Au] = l(f(24536, 24552)), r[Ru] = PG[c(t(f(24552, 24561), Tr))], (function(n, r) {
            return n + CG[cM](r);
        })[so](void 0, r[Au], r[Ru])];
    }, CG[WA] = function(n) {
        var r = [];
        var i = [];
        return i[c(xu)] = CG[Ib](n), r[wo] = i[wo][PG[c(OA)]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, r[wo]) ? i[wo][PG[ec]] : i[wo][PG[cc]];
    }, CG[_A] = function(n) {
        return n[l(Bb)][CG[be]] || CG[ko];
    }, CG[GA] = function(n) {
        return n[l(Bb)][CG[_f]] || CG[ko];
    }, CG[xA] = function(n) {
        return n[l(Bb)][CG[pe]] || CG[ko];
    }, CG[RA] = function(n) {
        return n[l(Bb)][CG[Me]] || CG[ko];
    }, CG[UA] = function(n) {
        return n[s(Ub)][PG[Ye]] || PG[Rv];
    }, CG[SA] = function(n) {
        return n[s(Ub)][PG[Ie]] || PG[Rv];
    }, CG[IA] = function(n) {
        return n[s(Ub)][PG[nc]];
    }, CG[BA] = function(n) {
        var i = CG[IA](n);
        var r = [];
        r[wo] = [], r[Au] = CG[ko], r[Ru] = i;
        for(; r[Au] < r[Ru][CG[Kf]]; r[c(df)]++)r[yb] = r[Ru][r[c(df)]], r[wo][CG[Cf]](function(n) {
            return n && n[CG[we]];
        }(r[yb]));
        return r[wo];
    }, CG[DA] = function(n) {
        return n[s(Ub)][PG[ze]];
    }, CG[qA] = function(n) {
        return n[s(Ub)][PG[vc]];
    }, CG[t(f(24561, 24565), Tr)] = function(n) {
        return n[s(Ub)][PG[c(zA)]];
    }, CG[$A] = function(n) {
        var r = [];
        var t = CG[qA](n);
        var i = [];
        i[wo] = [], i[Au] = CG[ko], i[Ru] = t;
        for(; i[Au] < i[Ru][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[c(df)]], i[wo][CG[Cf]]((r[3] = i[yb], (function(n) {
            return n[CG[Jf]] + n[l(KA)] + n[CG[Kf]] + n[a(VA)];
        })[so](void 0, r[3])));
        return i[wo];
    }, CG[CA] = function(n) {
        var r = [];
        if (r[c(xu)] = CG[Rb](n), (function(n) {
            return typeof n === CG[zf];
        })[so](void 0, r[wo][PG[rc]]) && r[wo][PG[rc]]()) return !0;
    }, CG[e(t(f(24565, 24575), Tr))] = function(n) {
        return n === CG[Co] || n !== CG[Io] && PG[Eu];
    }, PG[PA] = CG[Ae], CG[QA] = function(n) {
        try {
            return !(!n[CG[Fe]] || !n[CG[Fe]][PG[PA]]);
        } catch (n) {}
    }, CG[YA] = function(n$jscomp$1) {
        var r = [];
        if (r[wo] = CG[Rb](n$jscomp$1), PG[e(t(f(24575, 24586), Tr))] in r[c(xu)]) {
            var n = r[wo][PG[fc]];
            return n === CG[e(t(f(24586, 24596), Tr))] || n !== CG[Io] && PG[Eu];
        }
        if (PG[fc] in n$jscomp$1) {
            var r$jscomp$0 = n$jscomp$1[PG[fc]];
            return r$jscomp$0 === CG[Co] || r$jscomp$0 !== CG[Io] && PG[Eu];
        }
        if ((function(n, r) {
            return n + CG[cM](r);
        })[so](void 0, CG[Ee], PG[fc]) in r[c(xu)]) {
            var n$jscomp$0 = r[wo][(function(n, r) {
                return n + CG[cM](r);
            })[so](void 0, CG[Ee], PG[fc])];
            return n$jscomp$0 === CG[Co] || n$jscomp$0 !== CG[Io] && PG[Eu];
        }
    }, CG[nF] = function(n) {
        return n[s(Ub)][PG[ic]];
    }, CG[rF] = function(n) {
        return n[s(Ub)][PG[c(t(f(24596, 24607), Tr))]];
    }, CG[iF] = function(n) {
        return n[s(Ub)][PG[oc]];
    }, CG[tF] = function(n) {
        return n[s(Ub)][(function(n) {
            return n[CG[e(oF)]]();
        })[so](void 0, PG[Yf])];
    }, CG[uF] = function(n) {
        return n[s(Ub)][PG[c(t(f(24607, 24617), Tr))]];
    }, CG[fF] = function(n) {
        return n[s(Ub)][PG[Qo]];
    }, CG[vF] = function(n) {
        return n[s(Ub)][PG[dc]];
    }, CG[eF] = function(n) {
        return n[CG[Ef]][PG[ac]];
    }, CG[cF] = function(n) {
        return n[PG[Mc]];
    }, CG[dF] = function(n) {
        return n[PG[wc]];
    }, CG[aF] = function(n) {
        return n[s(Ub)][PG[Fc]];
    }, CG[lF] = function(n) {
        return n[PG[Oc]];
    }, CG[sF] = function() {
        var n = [];
        return n[wo] = CG[Zw](), n[wo][s(f(24617, 24637))](CG[ko]), n[wo][CG[Oe]](n[wo][CG[Xe]]() + CG[Df]), n[wo][a(f(24637, 24677))]();
    }, CG[hF] = function(n) {
        try {
            return n[CG[Gw]][a(f(24677, 24717))]()[PG[Nc]]();
        } catch (n) {
            return;
        }
    }, CG[yF] = function(n) {
        var r = [];
        if (r[wo] = CG[hF](n), r[wo]) return r[wo][PG[mc]];
    }, CG[NF] = function(n) {
        var r = [];
        if (r[wo] = CG[hF](n), r[wo]) return r[c(xu)][PG[bc]];
    }, CG[mF] = function(n) {
        return n[s(Ub)][PG[c(e(t(f(24717, 24726), Tr)))] + CG[Po]] || [];
    }, CG[bF] = function(n) {
        var r = CG[mF](n);
        if (CG[gp](r) && r[CG[Kf]]) return r[CG[jf]](CG[xo]);
    }, CG[pF] = function(n) {
        var r = n;
        var i = PG[lc];
        return i in r && !!r[i];
    }, CG[MF] = function(n) {
        var r = n;
        var i = PG[sc];
        return i in r && !!r[i];
    }, CG[wF] = function(n) {
        var r = [];
        return r[wo] = n, r[Au] = PG[yc], (function(n, r) {
            return r in n && !!n[r];
        })[so](void 0, r[wo], r[Au]) || (r[Ru] = n, r[yb] = PG[hc], (function(n, r) {
            return r in n && !!n[r];
        })[so](void 0, r[Ru], r[yb]));
    }, PG[AF] = CG[ko], PG[ru] = CG[Zf], PG[qc] = CG[Df], PG[zc] = CG[yv], PG[$c] = CG[Xv], PG[Kc] = CG[re], PG[c(FF)] = CG[gf], PG[Cc] = CG[xw], PG[Pc] = CG[wv], PG[Qc] = CG[Te], PG[Yc] = CG[mv], PG[c(e(t(f(24726, 24736), Tr)))] = CG[Le], PG[rd] = CG[Cv], PG[id] = CG[ke], PG[c(t(f(24736, 24746), Tr))] = CG[Tv], PG[od] = s(f(24746, 25102)), PG[ud] = CG[xo], PG[fd] = PG[od][CG[Yf]](PG[ud]), PG[iu] = CG[ko], PG[vd] = CG[Zf], PG[ed] = CG[Df], PG[cd] = CG[yv], PG[dd] = CG[Xv], PG[tu] = CG[re], PG[ad] = CG[gf], PG[ld] = CG[xw], PG[sd] = [
        {
            tr: PG[iu]
        },
        {
            tr: PG[e(EF)]
        },
        {
            tr: PG[vd],
            ur: !0
        },
        {
            tr: PG[vd],
            ur: !0
        },
        {
            tr: PG[vd],
            ur: !0
        },
        {
            tr: PG[c(OF)],
            ur: !0
        },
        {
            tr: PG[ed],
            ur: !0
        },
        {
            tr: PG[ed],
            ur: !0
        },
        {
            ir: !0,
            tr: PG[vd]
        },
        {
            ir: !0,
            tr: PG[c(OF)]
        },
        {
            tr: PG[cd],
            vr: !0
        },
        {
            tr: PG[dd],
            vr: !0
        },
        {
            tr: PG[c(XF)],
            vr: !0
        },
        {
            tr: PG[ad],
            vr: !0
        },
        {
            tr: PG[ld],
            vr: !0
        }
    ], PG[hd] = CG[We], PG[yd] = CG[kv], PG[Nd] = CG[_e], PG[md] = CG[kv], PG[c(t(f(25102, 25111), Tr))] = CG[e(t(f(25111, 25121), Tr))], PG[pd] = CG[ke], PG[Ca] = PG[pd], CG[t(f(25121, 25125), Tr)] = function() {
        PG[Md] = (function(n, r) {
            var i = [];
            i[wo] = Array(n), i[Au] = i[wo][CG[Kf]] - CG[Zf];
            for(; i[Au] >= CG[ko]; i[Au]--)i[wo][i[Au]] = r(i[Au]);
            return i[wo];
        })[so](void 0, PG[fd][CG[Kf]], function() {
            return PG[xv];
        });
    }, CG[jF] = function(n) {
        return PG[Md][n]++;
    }, CG[e(gF)] = function(n) {
        return PG[Md][n];
    }, CG[TF] = function() {
        return (function(n) {
            return PG[Md][n];
        })[so](void 0, PG[Kc]) > PG[xv] || (function(n) {
            return PG[Md][n];
        })[so](void 0, PG[Vc]) > PG[xv] || (function(n) {
            return PG[Md][n];
        })[so](void 0, PG[Cc]) > PG[xv];
    }, CG[ZF] = function(n, r) {
        var i = [];
        i[wo] = n[CG[e(LF)]], i[c(df)] = n[CG[xe]], i[Ru] = CG[835](i[Au]) && i[Au] > CG[ko] ? i[Au] : i[wo][CG[Kf]], i[yb] = i[Ru] - CG[Zf];
        for(; i[yb] > CG[ko]; i[c(Nv)]--)i[wo][i[yb]] = i[wo][i[c(Nv)] - CG[Zf]];
        i[c(xu)][CG[ko]] = r;
    }, CG[t(f(25125, 25129), Tr)] = function(n, r, i, t, o) {
        return o === void CG[ko] && (o = CG[Zf]), {
            _r: n,
            hr: i,
            pr: t,
            mr: r,
            lr: Array(o),
            sr: o,
            yr: PG[xv]
        };
    }, CG[HF] = function(n, r) {
        var i = [];
        n[CG[Re]] && !n[CG[Re]](n, r) || n[CG[Ue]] && (function(n, r) {
            var i = [];
            if (i[wo] = n instanceof Object ? n : Object(n), i[Au] = isFinite(i[wo][CG[Kf]]) ? ~~i[wo][CG[Kf]] : CG[ko], i[c(af)] = CG[ko], void 0 === r) {
                do if (i[Ru] in i[wo] && void 0 === i[wo][i[Ru]]) return i[Ru];
                while (++i[Ru] < i[Au]);
            } else {
                do if (i[wo][i[Ru]] === r) return i[e(af)];
                while (++i[Ru] < i[Au]);
            }
            return -CG[Zf];
        })[so](void 0, n[CG[Ue]], r[CG[Se]]) < PG[c(SM)] || ((function(n, r) {
            var i = [];
            i[wo] = n[CG[Ge]], i[c(df)] = n[CG[xe]], i[Ru] = CG[835](i[Au]) && i[Au] > CG[ko] ? i[Au] : i[wo][CG[Kf]], i[yb] = i[Ru] - CG[Zf];
            for(; i[yb] > CG[ko]; i[c(Nv)]--)i[wo][i[yb]] = i[wo][i[c(Nv)] - CG[Zf]];
            i[c(xu)][CG[ko]] = r;
        })[so](void 0, n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (i[wo] = n[CG[Be]], i[wo] && !i[wo][CG[$v]](PG[Eu], n[CG[Ge]]) || n[CG[De]]++));
    }, CG[t(f(25129, 25133), Tr)] = function(n, r) {
        return !n || !r;
    }, CG[t(f(25133, 25137), Tr)] = function(n, r, i) {
        return !n || !r || !i;
    }, CG[t(f(25137, 25141), Tr)] = function(n, r) {
        return n[CG[qe]] - r[CG[qe]] === CG[ko];
    }, CG[kF] = function(n, r) {
        var i = [];
        if (n !== CG[ko] || r !== CG[ko]) return i[wo] = CG[XM](n, CG[Df]) + CG[XM](r, CG[Df]), CG[wM]()[PG[oe]](i[wo]);
    }, CG[JF] = function(n, r) {
        var i = n[CG[qe]];
        var t = r[CG[qe]];
        return CG[OM](i - t);
    }, CG[WF] = function(n) {
        var r = [];
        if (r[c(xu)] = CG[jb](n[CG[ze]]) ? n[CG[ze]] : n[CG[$e]], r[Au] = CG[jb](n[CG[Ke]]) ? n[CG[Ke]] : n[CG[Ve]], r[wo] !== PG[Eu] && r[Au] !== PG[c(Ec)] && void 0 !== r[wo] && void 0 !== r[Au]) return [
            r[wo],
            r[Au]
        ];
    }, CG[_F] = function(n$jscomp$0, r$jscomp$0) {
        var i = [];
        if (i[wo] = CG[WF](n$jscomp$0), i[Au] = CG[WF](r$jscomp$0), i[wo] && i[Au]) {
            i[c(af)] = i[wo][CG[ko]] - i[Au][CG[ko]], i[yb] = i[wo][CG[Zf]] - i[c(df)][CG[Zf]];
            var n = i[Ru];
            var r = i[yb];
            if (n === CG[ko] && r === CG[ko]) return;
            return CG[kM](CG[XM](n, CG[Df]) + CG[XM](r, CG[Df]));
        }
    }, CG[GF] = function(n, r, i) {
        var t = [];
        var o = [];
        if (n && r && i && (o[e(xu)] = i[CG[$e]] - r[CG[$e]], o[Au] = i[CG[Ve]] - r[CG[Ve]], o[Ru] = n[CG[$e]] - r[CG[e(xF)]], o[yb] = n[CG[Ve]] - r[CG[Ve]], o[Du] = o[wo] * o[Ru] + o[Au] * o[yb], o[Iu] = CG[kF](o[wo], o[Au]), o[Nb] = CG[kF](o[Ru], o[yb]), o[Iu] && o[Nb] && (o[mb] = CG[xM](o[Du] / (o[c(of)] * o[Nb]), CG[mv]), t[wo] = o[c(ge)], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, t[wo])))) return o[Su] = CG[WM](o[mb]), o[Su] * CG[Ce] / CG[wM]()[PG[te]];
    }, CG[RF] = function(n, r, i) {
        var t = [];
        if (n && r && i && n[CG[$e]] !== PG[Eu] && n[CG[Ve]] !== PG[Eu] && n[CG[Qe]] !== PG[Eu] && r[CG[$e]] !== PG[Eu] && r[CG[Ve]] !== PG[Eu] && r[CG[Qe]] !== PG[Eu]) return t[wo] = i[CG[$e]] - r[CG[$e]], t[Au] = i[CG[Ve]] - r[CG[Ve]], t[Ru] = n[CG[$e]] - r[CG[$e]], t[yb] = n[CG[Ve]] - r[CG[Ve]], t[c(vf)] = CG[DM](t[wo] * t[yb], t[Ru] * t[Au]), t[Iu] = CG[kF](t[wo] - t[Ru], t[Au] - t[yb]), t[Iu] ? t[Du] / t[Iu] : CG[ko];
    }, CG[UF] = function(n, r) {
        var i = [];
        if (n && r && n[CG[qe]] - r[CG[qe]] !== CG[ko] && (function(n, r) {
            var i = [];
            if (i[wo] = CG[WF](n), i[Au] = CG[WF](r), i[wo] && i[Au]) return i[c(af)] = i[wo][CG[ko]] - i[Au][CG[ko]], i[yb] = i[wo][CG[Zf]] - i[c(df)][CG[Zf]], CG[kF](i[Ru], i[yb]);
        })[so](void 0, n, r)) return i[wo] = r[CG[$e]] - n[CG[$e]], i[Au] = r[CG[Ve]] - n[CG[Ve]], (function(n, r) {
            return CG[wM]()[PG[fe]](n, r);
        })[so](void 0, i[Au], i[wo]) * CG[Ce] / CG[wM]()[PG[te]] + CG[Ce];
    }, CG[SF] = function(n, r) {
        if (n && r) {
            var i = [];
            if (i[wo] = CG[WF](n), i[Au] = CG[WF](r), i[wo] && i[Au]) return i[c(af)] = i[wo][CG[ko]] - i[Au][CG[ko]], i[yb] = i[wo][CG[Zf]] - i[c(df)][CG[Zf]], CG[kF](i[Ru], i[yb]);
        }
    }, CG[IF] = function(n, r) {
        if (n && r && n[CG[$e]] !== PG[Eu] && n[CG[Ve]] !== PG[Eu] && n[CG[Qe]] !== PG[Eu] && r[CG[$e]] !== PG[Eu] && r[CG[Ve]] !== PG[Eu] && r[CG[Qe]] !== PG[Eu]) return CG[e(JM)]()[PG[re]](n[CG[$e]] * CG[mv]) + CG[wM]()[PG[re]](n[CG[Ve]] * CG[mv]) + CG[wM]()[PG[re]](n[CG[Qe]] * CG[mv]);
    }, CG[BF] = function(n, r) {
        if (n && r) return CG[DM](n[CG[qe]], r[CG[qe]]);
    }, CG[DF] = function(n, r) {
        if (n && r) return n[CG[Ye]] === r[CG[Ye]] ? CG[DM](n[CG[qe]], r[CG[qe]]) : void 0;
    }, CG[qF] = function(n, r) {
        if (n && r) return n[CG[Ye]] !== r[CG[Ye]] ? CG[DM](n[CG[qe]], r[CG[qe]]) : void 0;
    }, CG[zF] = function(n) {
        return (function(n, r) {
            var i = [];
            if (i[wo] = n instanceof Object ? n : Object(n), i[Au] = isFinite(i[wo][CG[Kf]]) ? ~~i[wo][CG[e(Nl)]] : CG[ko], i[c(af)] = CG[ko], void 0 === r) {
                do if (i[Ru] in i[wo] && void 0 === i[wo][i[Ru]]) return i[Ru];
                while (++i[Ru] < i[Au]);
            } else {
                do if (i[wo][i[Ru]] === r) return i[Ru];
                while (++i[Ru] < i[Au]);
            }
            return -CG[Zf];
        })[so](void 0, PG[Of], n[CG[Ye]]) >= PG[xv];
    }, CG[$F] = function(n) {
        return !1 === n[CG[nc]];
    }, CG[t(f(25141, 25145), Tr)] = function(n, r) {
        var i = [];
        return n !== r && (i[wo] = n, (CG[jb](i[wo]) ? i[wo] > PG[xv] ? CG[Zf] : i[wo] < PG[c(SM)] ? -CG[Zf] : PG[xv] : PG[xv]) + (i[Au] = r, CG[jb](i[Au]) ? i[Au] > PG[xv] ? CG[Zf] : i[Au] < PG[c(SM)] ? -CG[Zf] : PG[xv] : PG[xv]) === PG[xv]);
    }, CG[KF] = function(n, r) {
        var i = [];
        return !(!n || !r) && n[CG[rc]] !== PG[Eu] && n[CG[ic]] !== PG[Eu] && r[CG[rc]] !== PG[Eu] && r[CG[ic]] !== PG[Eu] && (i[wo] = n[CG[rc]], i[Au] = r[CG[rc]], (function(n, r) {
            return n !== r && CG[zM](n) + CG[zM](r) === PG[xv];
        })[so](void 0, i[wo], i[Au]) || (i[Ru] = n[CG[ic]], i[yb] = r[CG[ic]], (function(n, r) {
            return n !== r && CG[zM](n) + CG[zM](r) === PG[xv];
        })[so](void 0, i[Ru], i[yb])));
    }, CG[VF] = function(n, r) {
        return !(!n || !r || n[CG[tc]] === PG[Eu] || n[CG[oc]] === PG[Eu] || n[CG[tc]] > PG[xv] && n[CG[tc]] < n[CG[oc]]);
    }, CG[CF] = function(n, r) {
        var i = [];
        if (n && r && (i[wo] = CG[_F](n, r), i[Au] = CG[JF](n, r), i[wo] && i[Au] !== CG[ko])) return i[wo] / i[Au] * CG[kv];
    }, CG[PF] = function(n, r) {
        var i = [];
        if (n && r && (i[wo] = CG[jb](n[CG[ze]]) ? n[CG[ze]] : n[CG[$e]], i[Au] = CG[jb](r[CG[ze]]) ? r[CG[ze]] : r[CG[$e]], i[wo] !== PG[Eu] && i[Au] !== PG[Eu] && void 0 !== i[wo] && void 0 !== i[c(df)] && (i[Ru] = CG[OM](i[Au] - i[wo]), i[Ru] !== CG[ko]))) return i[Ru];
    }, CG[QF] = function(n, r) {
        var i = [];
        if (n && r && (i[wo] = CG[jb](n[CG[Ke]]) ? n[CG[Ke]] : n[CG[Ve]], i[Au] = CG[jb](r[CG[Ke]]) ? r[CG[Ke]] : r[CG[Ve]], i[wo] !== PG[Eu] && i[Au] !== PG[Eu] && void 0 !== i[c(xu)] && void 0 !== i[Au] && (i[Ru] = CG[OM](i[Au] - i[wo]), i[Ru] !== CG[ko]))) return i[c(e(lf))];
    }, CG[YF] = function(n, r) {
        var i = [];
        if (i[wo] = CG[PF](n, r), i[wo] && (i[Au] = CG[JF](n, r), i[Au] !== CG[ko])) return i[wo] / i[Au] * CG[kv];
    }, CG[nE] = function(n, r) {
        var i = [];
        if (i[wo] = CG[QF](n, r), i[wo] && (i[Au] = CG[JF](n, r), i[Au] !== CG[ko])) return i[wo] / i[Au] * CG[kv];
    }, CG[rE] = function(n, r, i) {
        var t = [];
        if (n && r && i && (t[wo] = CG[CF](n, r), t[Au] = CG[CF](r, i), void 0 !== t[wo] && void 0 !== t[c(df)])) return t[Ru] = t[Au] - t[wo], t[c(af)] === CG[ko] ? void 0 : t[c(af)];
    }, CG[iE] = function(n, r, i) {
        var t = [];
        if (n && r && i && (t[wo] = CG[YF](n, r), t[c(df)] = CG[YF](r, i), void 0 !== t[c(xu)] && void 0 !== t[Au])) return t[Ru] = t[Au] - t[wo], t[Ru] === CG[ko] ? void 0 : t[Ru];
    }, CG[tE] = function(n, r, i) {
        var t = [];
        if (n && r && i && (t[wo] = CG[nE](n, r), t[Au] = CG[nE](r, i), void 0 !== t[wo] && void 0 !== t[Au])) return t[Ru] = t[c(df)] - t[wo], t[Ru] === CG[ko] ? void 0 : t[Ru];
    }, CG[oE] = function(n, r, i, t) {
        var o = [];
        if (n && r && i && t && (o[wo] = CG[rE](n, r, i), o[Au] = CG[rE](r, i, t), void 0 !== o[wo] && void 0 !== o[Au])) return o[Ru] = CG[OM](o[Au] - o[wo]), o[Ru] === CG[ko] ? void 0 : o[Ru];
    }, CG[uE] = function(n, r, i, t) {
        var o = [];
        if (n && r && i && t && (o[wo] = CG[iE](n, r, i), o[Au] = CG[iE](r, i, t), void 0 !== o[wo] && void 0 !== o[Au])) return o[Ru] = CG[OM](o[Au] - o[wo]), o[Ru] === CG[ko] ? void 0 : o[Ru];
    }, CG[fE] = function(n, r, i, t) {
        var o = [];
        if (n && r && i && t && (o[wo] = CG[tE](n, r, i), o[Au] = CG[tE](r, i, t), void 0 !== o[wo] && void 0 !== o[Au])) return o[Ru] = CG[OM](o[Au] - o[wo]), o[Ru] === CG[ko] ? void 0 : o[Ru];
    }, PG[wd] = CG[ko], PG[Ad] = CG[Zf], PG[c(vE)] = CG[Df], PG[Od] = CG[ko], PG[c(t(f(25145, 25156), Tr))] = CG[Zf], PG[Uu] = CG[Df], PG[jd] = CG[yv], PG[c(t(f(25156, 25167), Tr))] = CG[Xv], PG[Td] = CG[re], CG[eE] = function() {
        PG[c(t(f(25167, 25177), Tr))] = (function(n, r) {
            var i = [];
            i[wo] = Array(n), i[Au] = i[wo][CG[Kf]] - CG[Zf];
            for(; i[Au] >= CG[ko]; i[Au]--)i[wo][i[Au]] = r(i[Au]);
            return i[wo];
        })[so](void 0, CG[re], function() {
            return PG[Eu];
        });
    }, CG[cE] = function(n, r) {
        return PG[Ed][n] = r;
    }, CG[dE] = function(n) {
        return PG[Ed][n];
    }, CG[aE] = function(n) {
        return n[CG[uc]] === PG[xv] || n[CG[uc]] == CG[Zf] && n[CG[Se]] === PG[Vc];
    }, CG[lE] = function(n) {
        var r = [];
        return !!n[CG[fc]] || (r[wo] = CG[dE](PG[Uu]), !r[wo] || n[CG[qe]] - r[wo][CG[qe]] > PG[hd]);
    }, CG[sE] = function(n, r) {
        return !!r[CG[uc]] && r[CG[uc]] > CG[Zf];
    }, CG[hE] = function(n) {
        return !!n[CG[Ge]][CG[Zf]] && !!n[CG[Ue]] && n[CG[Ge]][CG[ko]][CG[Se]] === n[CG[Ue]][CG[Zf]] && n[CG[Ge]][CG[Zf]][CG[e(yE)]] === n[CG[Ue]][CG[ko]];
    }, CG[NE] = function(n) {
        return !!n[CG[Ge]][CG[Zf]] && n[CG[e(LF)]][CG[Zf]][CG[Se]] === PG[Vc] && n[CG[Ge]][CG[ko]][CG[Se]] != PG[Vc];
    }, CG[mE] = function(n) {
        return !!n[CG[Ge]][CG[Zf]] && n[CG[Ge]][CG[e(Yl)]][CG[Se]] === PG[e(FF)] && n[CG[Ge]][CG[Zf]][CG[Se]] != PG[Vc];
    }, CG[bE] = function(n) {
        return !!n[CG[Ge]][CG[Zf]] && n[CG[Ge]][CG[Zf]][CG[vc]] == PG[c(t(f(25177, 25185), Tr))] && n[CG[Ge]][CG[ko]][CG[vc]] == PG[Ad];
    }, CG[pE] = function(n) {
        return !!n[CG[Ge]][CG[Zf]] && n[CG[Ge]][CG[Zf]][CG[vc]] == PG[Ad] && n[CG[Ge]][CG[ko]][CG[vc]] == PG[Fd];
    }, CG[ME] = function(n) {
        return !!n[CG[Ge]][CG[Zf]] && n[CG[Ge]][CG[Zf]][CG[vc]] == PG[Fd] && n[CG[Ge]][CG[ko]][CG[vc]] == PG[Fd];
    }, CG[1217] = function(n) {
        return !!n[CG[Ge]][CG[Zf]] && n[CG[Ge]][CG[Zf]][CG[vc]] == PG[wd] && n[CG[Ge]][CG[ko]][CG[vc]] == PG[wd];
    }, CG[wE] = function() {
        var n = [];
        PG[Zd] = (function(n, r, i, t, o) {
            return o === void CG[ko] && (o = CG[Zf]), {
                _r: n,
                hr: i,
                pr: t,
                mr: r,
                lr: Array(o),
                sr: o,
                yr: PG[xv]
            };
        })[so](void 0, CG[zF], [
            PG[ru]
        ], void 0, void 0, void 0), PG[c(t(f(25185, 25196), Tr))] = (n[wo] = CG[Df], (function(n, r, i, t, o) {
            return o === void CG[ko] && (o = CG[Zf]), {
                _r: n,
                hr: i,
                pr: t,
                mr: r,
                lr: Array(o),
                sr: o,
                yr: PG[xv]
            };
        })[so](void 0, CG[KF], void 0, void 0, void 0, n[wo])), PG[Ld] = (n[e(df)] = CG[Df], (function(n, r, i, t, o) {
            return o === void CG[ko] && (o = CG[Zf]), {
                _r: n,
                hr: i,
                pr: t,
                mr: r,
                lr: Array(o),
                sr: o,
                yr: PG[xv]
            };
        })[so](void 0, CG[VF], void 0, void 0, void 0, n[Au])), PG[Jd] = (function(n, r, i, t, o) {
            return o === void CG[ko] && (o = CG[Zf]), {
                _r: n,
                hr: i,
                pr: t,
                mr: r,
                lr: Array(o),
                sr: o,
                yr: PG[xv]
            };
        })[so](void 0, PG[Eu], [
            PG[Vc]
        ], CG[sE], void 0, void 0), PG[kd] = (function(n, r, i, t, o) {
            return o === void CG[ko] && (o = CG[Zf]), {
                _r: n,
                hr: i,
                pr: t,
                mr: r,
                lr: Array(o),
                sr: o,
                yr: PG[xv]
            };
        })[so](void 0, PG[Eu], void 0, void 0, void 0, void 0), PG[Wd] = (function(n, r, i, t, o) {
            return o === void CG[ko] && (o = CG[Zf]), {
                _r: n,
                hr: i,
                pr: t,
                mr: r,
                lr: Array(o),
                sr: o,
                yr: PG[xv]
            };
        })[so](void 0, CG[$F], void 0, void 0, void 0, void 0), (function() {
            PG[Md] = CG[Ab](PG[fd][CG[Kf]], function() {
                return PG[xv];
            });
        })[so](void 0);
    }, PG[_d] = CG[Qo], CG[AE] = function(n) {
        var r = [];
        r[c(xu)] = CG[BM](n[CG[Kf]] - CG[Df]) + CG[Zf], n[CG[Vf]](r[wo], CG[Zf]);
    }, CG[t(f(25196, 25200), Tr)] = function(n, r) {
        var i = [];
        return n[CG[Kf]] ? (i[e(xu)] = CG[jb](r) ? r : PG[_d], i[Au] = (n[CG[Kf]] - CG[Zf]) * i[wo], (function(n) {
            var r = [];
            return r[wo] = Number[a(Xp)], CG[jb](r[c(xu)]) ? r[wo](n) : typeof n === s(jp) && isFinite(n) && ~~n === n;
        })[so](void 0, i[Au]) ? n[i[Au]] : (i[Ru] = ~~i[Au], i[Ru] + CG[Zf] > n[CG[Kf]] ? n[i[Ru]] : (n[i[Ru]] + n[i[Ru] + CG[Zf]]) / CG[Df])) : PG[c(Ec)];
    }, CG[FE] = function(n, r) {
        var i = [];
        n[CG[Cf]](r), i[wo] = n[CG[Kf]] - CG[Zf], i[Au] = n[i[wo]];
        for(; i[c(xu)] > CG[ko] && i[Au] < n[i[wo] - CG[Zf]];)n[i[c(xu)]] = n[i[wo] - CG[Zf]], i[wo] -= CG[Zf];
        n[i[wo]] = i[Au];
    }, CG[EE] = function(n) {
        var r = [];
        return {
            Or: [],
            Pr: (r[wo] = n, CG[Ob](r[wo]) && r[wo] !== PG[Eu] ? n : PG[Nd])
        };
    }, CG[OE] = function(n$jscomp$0) {
        var r = [];
        var i = [];
        if (n$jscomp$0[CG[ec]][CG[Kf]] < CG[Df]) return PG[Eu];
        if (i[wo] = CG[XE](n$jscomp$0, PG[_d]), i[wo] == PG[Eu]) return PG[Eu];
        i[Au] = [], i[Ru] = CG[ko], i[yb] = n$jscomp$0[CG[ec]];
        for(; i[Ru] < i[yb][CG[Kf]]; i[Ru]++)i[Du] = i[yb][i[e(af)]], r[Du] = CG[DM](i[Du], i[wo]), (function(n, r) {
            var i = [];
            n[CG[e(Ip)]](r), i[wo] = n[CG[Kf]] - CG[Zf], i[Au] = n[i[wo]];
            for(; i[c(xu)] > CG[e(Yl)] && i[Au] < n[i[wo] - CG[Zf]];)n[i[c(xu)]] = n[i[e(xu)] - CG[Zf]], i[wo] -= CG[Zf];
            n[i[wo]] = i[Au];
        })[so](void 0, i[Au], r[Du]);
        var n = i[Au];
        var r$jscomp$0 = PG[_d];
        var t = [];
        return n[CG[Kf]] ? (t[wo] = CG[jb](r$jscomp$0) ? r$jscomp$0 : PG[_d], t[Au] = (n[CG[Kf]] - CG[Zf]) * t[wo], CG[Op](t[Au]) ? n[t[Au]] : (t[Ru] = ~~t[Au], t[Ru] + CG[Zf] > n[CG[Kf]] ? n[t[Ru]] : (n[t[Ru]] + n[t[Ru] + CG[Zf]]) / CG[Df])) : PG[c(Ec)];
    }, CG[XE] = function(n, r) {
        var t = n[CG[ec]];
        var o = r;
        var i = [];
        return t[CG[Kf]] ? (i[wo] = CG[jb](o) ? o : PG[_d], i[Au] = (t[CG[Kf]] - CG[Zf]) * i[wo], CG[Op](i[Au]) ? t[i[Au]] : (i[Ru] = ~~i[Au], i[Ru] + CG[Zf] > t[CG[Kf]] ? t[i[Ru]] : (t[i[Ru]] + t[i[Ru] + CG[Zf]]) / CG[Df])) : PG[c(Ec)];
    }, CG[jE] = function(n, r) {
        var i = [];
        i[wo] = n[CG[ec]], i[wo][CG[Kf]] < n[CG[cc]] || (function(n) {
            var r = [];
            r[c(xu)] = CG[BM](n[CG[Kf]] - CG[Df]) + CG[Zf], n[CG[Vf]](r[wo], CG[Zf]);
        })[so](void 0, i[wo]), (function(n, r) {
            var i = [];
            n[CG[Cf]](r), i[wo] = n[CG[Kf]] - CG[Zf], i[Au] = n[i[wo]];
            for(; i[c(xu)] > CG[ko] && i[Au] < n[i[wo] - CG[Zf]];)n[i[c(xu)]] = n[i[wo] - CG[Zf]], i[wo] -= CG[Zf];
            n[i[wo]] = i[Au];
        })[so](void 0, i[wo], r);
    }, CG[gE] = function(n, r) {
        var i = [];
        var t = [];
        return t[wo] = {
            jr: PG[Eu],
            Hr: CG[EE](r),
            yr: PG[xv],
            Br: PG[xv],
            qr: PG[c(SM)],
            Kr: PG[xv],
            Ur: PG[Rv],
            zr: PG[Rv]
        }, n && (t[wo][CG[dc]] = (i[Au] = r, {
            Or: [],
            Pr: CG[jb](i[Au]) ? i[Au] : PG[Nd]
        })), t[wo];
    }, CG[TE] = function(n, r) {
        var i = [];
        var t = [];
        n[CG[De]]++, n[CG[ac]] += r, n[CG[lc]] += r * r, (function(n, r) {
            var i = [];
            i[wo] = n[CG[ec]], i[wo][CG[Kf]] < n[CG[cc]] || CG[AE](i[wo]), CG[FE](i[wo], r);
        })[so](void 0, n[CG[sc]], r), i[wo] = n[CG[hc]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, i[wo]) ? (t[wo] = CG[DM](r, n[CG[hc]]), n[CG[yc]] += t[wo], n[CG[dc]] && (t[Au] = n[CG[hc]] + r, (function(n, r) {
            var i = [];
            i[wo] = n[CG[ec]], i[wo][CG[Kf]] < n[CG[cc]] || CG[AE](i[wo]), CG[FE](i[wo], r);
        })[so](void 0, n[CG[dc]], t[Au] == PG[xv] ? PG[xv] : t[wo] / n[CG[hc]] + r)), r > n[CG[Nc]] && (n[CG[Nc]] = r), r < n[CG[mc]] && (n[CG[mc]] = r)) : n[CG[mc]] = n[CG[Nc]] = r, n[CG[hc]] = r;
    }, CG[t(f(25200, 25204), Tr)] = function(n, r, i, t, o, u, f, v, e) {
        return u === void CG[ko] && (u = CG[Df]), {
            _r: n,
            hr: t,
            pr: o,
            mr: i,
            lr: Array(u),
            Gr: r,
            Wr: CG[ko],
            sr: u,
            Xr: (function(n, r) {
                var i = [];
                return i[wo] = {
                    jr: PG[Eu],
                    Hr: CG[EE](r),
                    yr: PG[xv],
                    Br: PG[xv],
                    qr: PG[c(SM)],
                    Kr: PG[xv],
                    Ur: PG[Rv],
                    zr: PG[Rv]
                }, n && (i[wo][CG[dc]] = CG[EE](r)), i[wo];
            })[so](void 0, f, v),
            Jr: e,
            Zr: e ? [] : void 0
        };
    }, CG[ZE] = function(n) {
        var r = [];
        if (r[wo] = n, r[wo][CG[bc]]) {
            n[CG[pc]] = (function(n, r) {
                var i = [];
                return i[e(xu)] = {
                    jr: PG[Eu],
                    Hr: CG[EE](r),
                    yr: PG[xv],
                    Br: PG[xv],
                    qr: PG[c(SM)],
                    Kr: PG[xv],
                    Ur: PG[Rv],
                    zr: PG[Rv]
                }, n && (i[wo][CG[dc]] = CG[EE](r)), i[wo];
            })[so](void 0, !!n[CG[pc]][CG[dc]], n[CG[pc]][CG[sc]][CG[cc]]), r[Au] = CG[ko], r[Ru] = r[wo][CG[bc]];
            for(; r[Au] < r[Ru][CG[Kf]]; r[Au]++)r[yb] = r[Ru][r[Au]], (function(n, r) {
                var i = [];
                n[CG[De]]++, n[CG[ac]] += r, n[CG[lc]] += r * r, CG[jE](n[CG[sc]], r), CG[jb](n[CG[hc]]) ? (i[wo] = CG[DM](r, n[CG[hc]]), n[CG[yc]] += i[wo], n[CG[dc]] && (i[Au] = n[CG[hc]] + r, CG[jE](n[CG[dc]], i[Au] == PG[xv] ? PG[xv] : i[e(xu)] / n[CG[hc]] + r)), r > n[CG[Nc]] && (n[CG[Nc]] = r), r < n[CG[mc]] && (n[CG[mc]] = r)) : n[CG[mc]] = n[CG[Nc]] = r, n[CG[hc]] = r;
            })[so](void 0, n[CG[pc]], r[yb]);
        }
    }, CG[LE] = function(n, r) {
        var o = [];
        var u = [];
        n[CG[Ue]] && (function(n, r) {
            var i = [];
            if (i[wo] = n instanceof Object ? n : Object(n), i[Au] = isFinite(i[wo][CG[Kf]]) ? ~~i[wo][CG[Kf]] : CG[ko], i[c(af)] = CG[ko], void 0 === r) {
                do if (i[Ru] in i[wo] && void 0 === i[wo][i[Ru]]) return i[Ru];
                while (++i[Ru] < i[Au]);
            } else {
                do if (i[wo][i[Ru]] === r) return i[Ru];
                while (++i[Ru] < i[Au]);
            }
            return -CG[Zf];
        })[so](void 0, n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), (function(n, r) {
            var i = [];
            i[wo] = n[CG[Ge]], i[c(df)] = n[CG[xe]], i[Ru] = CG[835](i[Au]) && i[Au] > CG[ko] ? i[Au] : i[wo][CG[Kf]], i[yb] = i[Ru] - CG[Zf];
            for(; i[yb] > CG[ko]; i[c(Nv)]--)i[wo][i[yb]] = i[wo][i[c(Nv)] - CG[Zf]];
            i[c(xu)][CG[ko]] = r;
        })[so](void 0, n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (u[wo] = n[CG[Be]][CG[e(t(f(25204, 25215), Tr))]](PG[Eu], n[CG[Ge]]), o[wo] = u[wo], (function(n) {
            return !isNaN(n - i(n));
        })[so](void 0, o[wo]) && (u[Au] = n, u[Au][CG[bc]] ? (u[Au][CG[bc]][CG[Cf]](u[wo]), u[Au][CG[bc]][CG[Kf]] > u[Au][s(HE)] && u[Au][CG[bc]][CG[Ac]](), (function(n) {
            var r = [];
            if (r[wo] = n, r[wo][CG[bc]]) {
                n[CG[pc]] = CG[gE](!!n[CG[pc]][CG[dc]], n[CG[pc]][CG[sc]][CG[cc]]), r[Au] = CG[ko], r[Ru] = r[wo][CG[bc]];
                for(; r[Au] < r[Ru][CG[Kf]]; r[Au]++)r[yb] = r[Ru][r[Au]], CG[TE](n[CG[pc]], r[yb]);
            }
        })[so](void 0, n)) : (function(n, r) {
            var i = [];
            n[CG[De]]++, n[CG[e(Pe)]] += r, n[CG[lc]] += r * r, CG[jE](n[CG[sc]], r), CG[jb](n[CG[hc]]) ? (i[wo] = CG[DM](r, n[CG[hc]]), n[CG[yc]] += i[wo], n[CG[dc]] && (i[Au] = n[CG[hc]] + r, CG[jE](n[CG[dc]], i[Au] == PG[xv] ? PG[xv] : i[wo] / n[CG[hc]] + r)), r > n[CG[Nc]] && (n[CG[Nc]] = r), r < n[CG[mc]] && (n[CG[e(t(f(25215, 25225), Tr))]] = r)) : n[CG[mc]] = n[CG[e(XA)]] = r, n[CG[hc]] = r;
        })[so](void 0, n[CG[pc]], u[wo])))));
    }, CG[kE] = function(n) {
        n[CG[Ge]] = Array(n[CG[xe]]), n[CG[pc]] = (function(n, r) {
            var i = [];
            return i[wo] = {
                jr: PG[Eu],
                Hr: CG[EE](r),
                yr: PG[xv],
                Br: PG[xv],
                qr: PG[c(SM)],
                Kr: PG[xv],
                Ur: PG[Rv],
                zr: PG[Rv]
            }, n && (i[wo][CG[dc]] = CG[EE](r)), i[wo];
        })[so](void 0, !!n[CG[pc]][CG[dc]], n[CG[pc]][CG[sc]][CG[cc]]), n[CG[wc]] = CG[ko], n[CG[bc]] && (n[CG[bc]][CG[Kf]] = CG[ko]);
    }, CG[JE] = function(n) {
        return function(r, i) {
            if (r && i) return r[CG[qe]] - i[CG[qe]] > n;
        };
    }, CG[WE] = function(n, r) {
        var i = [];
        if (n && r) {
            if ((function(n, r) {
                var i = [];
                if (i[wo] = n instanceof Object ? n : Object(n), i[Au] = isFinite(i[wo][CG[Kf]]) ? ~~i[wo][CG[Kf]] : CG[ko], i[c(af)] = CG[ko], void 0 === r) {
                    do if (i[Ru] in i[wo] && void 0 === i[e(xu)][i[Ru]]) return i[Ru];
                    while (++i[e(af)] < i[Au]);
                } else {
                    do if (i[wo][i[Ru]] === r) return i[Ru];
                    while (++i[Ru] < i[Au]);
                }
                return -CG[Zf];
            })[so](void 0, PG[ko], n[CG[Ye]]) >= PG[xv] || (function(n, r) {
                var i = [];
                if (i[wo] = n instanceof Object ? n : Object(n), i[Au] = isFinite(i[wo][CG[Kf]]) ? ~~i[wo][CG[Kf]] : CG[ko], i[c(af)] = CG[ko], void 0 === r) {
                    do if (i[Ru] in i[wo] && void 0 === i[wo][i[Ru]]) return i[Ru];
                    while (++i[Ru] < i[Au]);
                } else {
                    do if (i[wo][i[Ru]] === r) return i[Ru];
                    while (++i[Ru] < i[Au]);
                }
                return -CG[Zf];
            })[so](void 0, PG[ko], r[CG[Ye]]) > PG[xv]) return !0;
            if (i[wo] = CG[dE](PG[Xd]), i[wo] && i[wo][CG[qe]] > r[CG[qe]]) return !0;
        }
    }, CG[_E] = CG[WE], PG[Gd] = CG[JE](PG[hd]), PG[xd] = CG[JE](PG[yd]), CG[GE] = function() {
        var n = [];
        PG[Rd] = (n[wo] = PG[c(xE)], n[Au] = CG[Df], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[BF], n[wo], PG[Eu], PG[Eu], PG[Eu], n[Au], !0, CG[Fc], CG[Fc])), PG[Ud] = (n[Ru] = PG[c(xE)], n[yb] = CG[Df], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[UF], n[Ru], PG[Eu], PG[Eu], PG[Eu], n[yb], !0, CG[Fc], CG[Fc])), PG[c(RE)] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[BF], PG[Gd], void 0, void 0, void 0, void 0, void 0, void 0, void 0), PG[Yd] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[UF], PG[e(xE)], void 0, void 0, void 0, void 0, void 0, void 0, void 0), PG[na] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[SF], PG[Gd], void 0, void 0, void 0, void 0, void 0, void 0, void 0), PG[Sd] = (n[Du] = PG[c(Ec)], n[Iu] = CG[Df], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[SF], PG[Gd], PG[Eu], n[Du], PG[Eu], n[Iu], !0, PG[md], CG[Fc])), PG[ou] = (n[Nb] = CG[Df], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[CF], PG[Gd], PG[Eu], PG[Eu], PG[Eu], n[Nb], !0, CG[Fc], CG[e(Qw)])), PG[Id] = (n[mb] = CG[Df], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void e(xu), CG[YF], PG[Gd], PG[Eu], PG[Eu], PG[Eu], n[mb], !0, CG[Fc], CG[Fc])), PG[Bd] = (n[Su] = PG[c(xE)], n[hf] = CG[Df], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[nE], n[Su], PG[Eu], PG[Eu], PG[Eu], n[hf], !0, CG[Fc], CG[Fc])), PG[Dd] = (n[To] = PG[c(xE)], n[yf] = CG[yv], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[rE], n[To], PG[Eu], PG[e(Ec)], PG[Eu], n[yf], !0, CG[Fc], CG[Fc])), PG[qd] = (n[Nf] = PG[c(Ec)], n[mf] = CG[yv], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[iE], PG[Gd], n[Nf], PG[Eu], PG[Eu], n[mf], !0, CG[Fc], CG[Fc])), PG[zd] = (n[bf] = PG[c(Ec)], n[pf] = CG[yv], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[tE], PG[Gd], n[bf], PG[Eu], PG[Eu], n[pf], !0, CG[Fc], CG[Fc])), PG[$d] = (n[Zo] = CG[Xv], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[oE], PG[Gd], PG[Eu], PG[Eu], PG[Eu], n[Zo], !0, CG[Fc], CG[Fc])), PG[UE] = (n[Lo] = PG[c(xE)], n[Ho] = CG[Xv], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[uE], n[Lo], PG[Eu], PG[Eu], PG[Eu], n[Ho], !0, CG[Fc], CG[Fc])), PG[Vd] = (n[Mf] = CG[Xv], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[fE], PG[Gd], PG[Eu], PG[Eu], PG[Eu], n[Mf], !0, CG[Fc], CG[Fc])), PG[Cd] = (n[wf] = PG[c(e(t(f(25225, 25235), Tr)))], n[Af] = CG[Df], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[PF], n[wf], PG[Eu], PG[Eu], PG[Eu], n[Af], !0, CG[Fc], CG[Fc])), PG[Pd] = (n[Ff] = CG[Df], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void e(xu), CG[QF], PG[Gd], PG[Eu], PG[Eu], PG[Eu], n[Ff], !0, CG[Fc], CG[Fc])), PG[ma] = (function(n, r) {
            var i = [];
            return i[wo] = {
                jr: PG[Eu],
                Hr: CG[EE](r),
                yr: PG[xv],
                Br: PG[xv],
                qr: PG[c(SM)],
                Kr: PG[xv],
                Ur: PG[Rv],
                zr: PG[Rv]
            }, n && (i[wo][CG[dc]] = CG[EE](r)), i[wo];
        })[so](void 0, !1, PG[md]), PG[pa] = (n[Ef] = PG[c(t(f(25235, 25245), Tr))], (function(n, r) {
            var i = [];
            return i[wo] = {
                jr: PG[Eu],
                Hr: CG[EE](r),
                yr: PG[xv],
                Br: PG[xv],
                qr: PG[c(SM)],
                Kr: PG[xv],
                Ur: PG[Rv],
                zr: PG[Rv]
            }, n && (i[wo][CG[dc]] = CG[EE](r)), i[wo];
        })[so](void 0, !1, n[Ef])), PG[c(t(f(25245, 25254), Tr))] = (function(n, r) {
            var i = [];
            return i[wo] = {
                jr: PG[Eu],
                Hr: CG[EE](r),
                yr: PG[xv],
                Br: PG[xv],
                qr: PG[c(SM)],
                Kr: PG[xv],
                Ur: PG[Rv],
                zr: PG[Rv]
            }, n && (i[wo][CG[dc]] = CG[EE](r)), i[wo];
        })[so](void 0, !1, PG[md]), PG[wa] = (function(n, r) {
            var i = [];
            return i[wo] = {
                jr: PG[Eu],
                Hr: CG[EE](r),
                yr: PG[xv],
                Br: PG[xv],
                qr: PG[c(SM)],
                Kr: PG[xv],
                Ur: PG[Rv],
                zr: PG[Rv]
            }, n && (i[wo][CG[dc]] = CG[EE](r)), i[wo];
        })[so](void 0, !1, PG[md]), PG[Aa] = (function(n, r) {
            var i = [];
            return i[wo] = {
                jr: PG[Eu],
                Hr: CG[EE](r),
                yr: PG[xv],
                Br: PG[xv],
                qr: PG[c(e(SE))],
                Kr: PG[xv],
                Ur: PG[Rv],
                zr: PG[Rv]
            }, n && (i[wo][CG[dc]] = CG[EE](r)), i[wo];
        })[so](void 0, !1, PG[md]), PG[Fa] = (n[Of] = PG[c(e(t(f(25254, 25263), Tr)))], (function(n, r) {
            var i = [];
            return i[wo] = {
                jr: PG[Eu],
                Hr: CG[EE](r),
                yr: PG[xv],
                Br: PG[xv],
                qr: PG[c(SM)],
                Kr: PG[xv],
                Ur: PG[Rv],
                zr: PG[Rv]
            }, n && (i[wo][CG[dc]] = CG[EE](r)), i[wo];
        })[so](void 0, !1, n[Of])), PG[cu] = (function(n, r) {
            var i = [];
            return i[wo] = {
                jr: PG[Eu],
                Hr: CG[EE](r),
                yr: PG[xv],
                Br: PG[xv],
                qr: PG[c(SM)],
                Kr: PG[xv],
                Ur: PG[e(IE)],
                zr: PG[e(IE)]
            }, n && (i[wo][CG[dc]] = CG[EE](r)), i[wo];
        })[so](void 0, !1, PG[md]), PG[Ea] = (n[ko] = CG[e(bw)], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[SF], PG[Eu], PG[Eu], PG[Eu], PG[Eu], n[ko], !0, PG[md], void 0)), PG[Oa] = (n[Xf] = PG[c(Ec)], n[jf] = CG[Df], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[e(t(f(25263, 25272), Tr))], PG[Eu], PG[Eu], n[Xf], PG[Eu], n[jf], !0, PG[md], void 0)), PG[ra] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[BF], PG[Eu], [
            PG[$c],
            PG[zc]
        ], PG[Eu], CG[hE], void 0, void 0, void 0, void 0), PG[du] = (function(n, r, i, t, o, u, f, v, c) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[e(BE)](f, v),
                Jr: c,
                Zr: c ? [] : void 0
            };
        })[so](void 0, CG[BF], PG[Eu], [
            PG[$c]
        ], void 0, void 0, void 0, void 0, void 0, void 0), PG[Xa] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[BF], PG[Eu], [
            PG[zc]
        ], void 0, void 0, void 0, void 0, void 0, void 0), PG[ia] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[qF], PG[xd], [
            PG[ru],
            PG[AF]
        ], PG[Eu], CG[hE], void 0, void 0, void 0, void 0), PG[ta] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[DF], PG[xd], [
            PG[ru],
            PG[AF]
        ], PG[Eu], CG[hE], void 0, void 0, void 0, void 0), PG[fa] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[BF], CG[_E], [
            PG[ru]
        ], void 0, void 0, void 0, void 0, void 0, void 0), PG[va] = (n[gf] = [
            PG[c(Dc)]
        ], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[BF], CG[_E], n[gf], void 0, void 0, void 0, void 0, void 0, void 0)), PG[c(e(t(f(25272, 25282), Tr)))] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[BF], CG[_E], [
            PG[ru],
            PG[AF]
        ], PG[Eu], CG[hE], void 0, void 0, void 0, void 0), PG[ua] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[BF], CG[_E], [
            PG[AF],
            PG[ru]
        ], PG[Eu], CG[hE], void 0, void 0, void 0, void 0), PG[vu] = (n[Zf] = [
            PG[Vc],
            PG[Kc],
            PG[c(t(f(25282, 25293), Tr))]
        ], (function(n, r, i, t, o, u, f, v, c) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[e(BE)](f, v),
                Jr: c,
                Zr: c ? [] : void 0
            };
        })[so](void 0, CG[BF], PG[Eu], n[Zf], CG[aE], CG[mE], void 0, void 0, void 0, void 0)), PG[eu] = (n[Hf] = [
            PG[Vc],
            PG[c(t(f(25293, 25303), Tr))],
            PG[Cc]
        ], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[BF], PG[Eu], n[Hf], CG[aE], CG[NE], void 0, void 0, void 0, void 0)), PG[ea] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[IF], void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0), PG[ca] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[BF], PG[Eu], [
            PG[qc]
        ], void 0, void 0, void 0, void 0, void 0, void 0), PG[ja] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[SF], PG[Eu], [
            PG[qc]
        ], void 0, void 0, void 0, void 0, void 0, void 0), PG[ga] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[SF], PG[Eu], [
            PG[$c]
        ], void 0, void 0, void 0, void 0, void 0, void 0), PG[au] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[SF], PG[Eu], [
            PG[zc]
        ], void 0, void 0, void 0, void 0, void 0, void 0), PG[da] = (n[kf] = CG[yv], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[e(t(f(25303, 25314), Tr))], PG[Eu], PG[Eu], PG[Eu], PG[Eu], n[kf], !1, PG[md], CG[Fc])), PG[aa] = (n[Jf] = CG[yv], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[GF], PG[Gd], PG[Eu], PG[Eu], PG[Eu], n[Jf], !1, PG[md], CG[Fc])), PG[fu] = (n[Wf] = CG[yv], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[RF], PG[Eu], PG[Eu], PG[Eu], PG[Eu], n[Wf], !1, PG[md], void 0)), PG[uu] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[BF], PG[Eu], [
            PG[qc],
            PG[ru]
        ], PG[Eu], CG[hE], void 0, void 0, void 0, void 0), PG[la] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[qF], PG[Eu], [
            PG[ru]
        ], PG[Eu], CG[1217], void 0, void 0, void 0, void 0), PG[sa] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[qF], PG[Eu], [
            PG[ru]
        ], PG[Eu], CG[bE], void 0, void 0, void 0, void 0), PG[c(t(f(25314, 25325), Tr))] = (n[Jo] = [
            PG[c(t(f(25325, 25336), Tr))]
        ], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[qF], PG[Eu], n[Jo], PG[Eu], CG[pE], void 0, void 0, void 0, void 0)), PG[ya] = (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[qF], PG[Eu], [
            PG[ru]
        ], PG[Eu], CG[ME], void 0, void 0, void 0, void 0), PG[Na] = (n[_f] = CG[Df], (function(n, r, i, t, o, u, f, v, e) {
            return u === void CG[ko] && (u = CG[Df]), {
                _r: n,
                hr: t,
                pr: o,
                mr: i,
                lr: Array(u),
                Gr: r,
                Wr: CG[ko],
                sr: u,
                Xr: CG[gE](f, v),
                Jr: e,
                Zr: e ? [] : void 0
            };
        })[so](void 0, CG[BF], PG[Eu], PG[Eu], PG[Eu], PG[Eu], n[_f], !0, PG[bd], void 0));
    }, CG[DE] = function(n) {
        var r = [];
        return n[CG[De]] > CG[Zf] ? (r[wo] = CG[UM](n[CG[yc]], n[CG[De]] - CG[Zf]), (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        })[so](void 0, r[wo], void 0)) : PG[Eu];
    }, CG[qE] = function(n) {
        var r = [];
        return r[wo] = CG[UM](n[CG[ac]], n[CG[De]]), (function(n, r) {
            var i = [];
            return r === void CG[e(Yl)] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        })[so](void 0, r[wo], void 0);
    }, CG[zE] = function(n, r) {
        r === void CG[ko] && (r = CG[Df]);
        var t = CG[XE](n[CG[sc]]);
        var o = r;
        var i = [];
        return o === void CG[ko] && (o = CG[yv]), CG[jb](t) && isFinite(t) ? (i[wo] = CG[XM](CG[mv], o), CG[AM](t * i[wo]) / i[wo]) : PG[Eu];
    }, CG[e(t(f(25336, 25347), Tr))] = function(n, r) {
        var i = [];
        return r === void CG[ko] && (r = CG[Df]), n[CG[dc]] && (i[wo] = CG[XE](n[CG[dc]]), i[Au] = r, (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        })[so](void 0, i[wo], i[Au]));
    }, CG[$E] = function(n, r) {
        r === void CG[ko] && (r = CG[Df]);
        var t = CG[OE](n[CG[sc]]);
        var o = r;
        var i = [];
        return o === void CG[ko] && (o = CG[yv]), CG[jb](t) && isFinite(t) ? (i[wo] = CG[XM](CG[mv], o), CG[AM](t * i[wo]) / i[wo]) : PG[Eu];
    }, CG[KE] = function(n, r) {
        var i = [];
        return r === void CG[ko] && (r = CG[Df]), n[CG[dc]] && (i[wo] = CG[OE](n[CG[dc]]), i[Au] = r, (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        })[so](void 0, i[wo], i[Au]));
    }, CG[VE] = function(n) {
        return (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        })[so](void 0, n[CG[Nc]], void 0);
    }, CG[CE] = function(n) {
        return (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[e(xu)]) / i[wo]) : PG[Eu];
        })[so](void 0, n[CG[mc]], void 0);
    }, CG[PE] = function(n) {
        return (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        })[so](void 0, n[CG[ac]], void 0);
    }, CG[QE] = function(n$jscomp$0, r) {
        var i = [];
        if (r === void CG[ko] && (r = CG[Df]), n$jscomp$0[CG[De]] <= CG[Zf]) return PG[Eu];
        i[wo] = n$jscomp$0[CG[ac]] / n$jscomp$0[CG[De]], i[c(df)] = n$jscomp$0[CG[lc]] / n$jscomp$0[CG[De]] - CG[XM](i[wo], CG[e(bw)]);
        var n = CG[kM](i[Au]);
        var o = r;
        var t = [];
        return o === void CG[ko] && (o = CG[yv]), CG[jb](n) && isFinite(n) ? (t[wo] = CG[XM](CG[mv], o), CG[AM](n * t[wo]) / t[wo]) : PG[Eu];
    }, CG[YE] = function(n, r) {
        if (r === void CG[ko] && (r = CG[Df]), !n[CG[e(nO)]]) return PG[c(Ec)];
        var t = CG[kM](n[CG[lc]] / n[CG[De]]);
        var o = r;
        var i = [];
        return o === void CG[ko] && (o = CG[yv]), CG[jb](t) && isFinite(t) ? (i[wo] = CG[XM](CG[mv], o), CG[AM](t * i[wo]) / i[wo]) : PG[Eu];
    }, CG[rO] = function(n, r, i$jscomp$0) {
        var t = [];
        t[0] = i$jscomp$0;
        var o = [];
        o[wo] = t[0];
        var u = [];
        u[wo] = o[wo], u[wo] === void CG[ko] && (u[wo] = CG[Df]);
        var i = CG[XE](n[CG[sc]], r);
        var t$jscomp$0 = u[wo];
        var f = [];
        return t$jscomp$0 === void CG[ko] && (t$jscomp$0 = CG[yv]), CG[e($p)](i) && isFinite(i) ? (f[wo] = CG[XM](CG[mv], t$jscomp$0), CG[AM](i * f[wo]) / f[e(xu)]) : PG[Eu];
    }, PG[lu] = d(c(t(f(25347, 25356), Tr))), PG[Ta] = {
        $r: PG[xv],
        Qr: !1,
        Yr: PG[xv],
        rn: new PG[ke](PG[lu])
    }, CG[t(f(25356, 25360), Tr)] = function(n) {
        PG[Ta][CG[Oc]] = CG[op](n), PG[Ta][CG[Xc]] = n[l(Vb)] || CG[ko], PG[Ta][CG[jc]] = n[PG[Fu]];
    }, PG[c(iO)] = CG[ko], CG[tO] = function(n) {
        var r = [];
        var o = [];
        (function(n) {
            var r = [];
            return !!n[CG[fc]] || (r[wo] = CG[dE](PG[Uu]), !r[wo] || n[CG[qe]] - r[wo][CG[e(wh)]] > PG[hd]);
        })[so](void 0, n) && ((function(n, r) {
            var i = [];
            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
        })[so](void 0, PG[fu], n), o[wo] = CG[$E](PG[Ea][CG[pc]]), r[wo] = o[wo], (function(n) {
            return !isNaN(n - i(n));
        })[so](void 0, r[wo]) && (function(n, r) {
            var i = [];
            n[CG[De]]++, n[CG[ac]] += r, n[CG[lc]] += r * r, CG[e(oO)](n[CG[sc]], r), CG[jb](n[CG[hc]]) ? (i[wo] = CG[DM](r, n[CG[hc]]), n[CG[yc]] += i[wo], n[CG[e(t(f(25360, 25369), Tr))]] && (i[Au] = n[CG[hc]] + r, CG[jE](n[CG[dc]], i[Au] == PG[xv] ? PG[xv] : i[wo] / n[CG[hc]] + r)), r > n[CG[Nc]] && (n[CG[Nc]] = r), r < n[CG[mc]] && (n[CG[mc]] = r)) : n[CG[mc]] = n[CG[Nc]] = r, n[CG[hc]] = r;
        })[so](void 0, PG[ma], o[wo]), o[Au] = CG[zE](PG[Ea][CG[pc]]), r[Au] = o[Au], (function(n) {
            return !isNaN(n - i(n));
        })[so](void 0, r[Au]) && (function(n, r) {
            var i = [];
            n[CG[e(nO)]]++, n[CG[ac]] += r, n[CG[lc]] += r * r, CG[jE](n[CG[sc]], r), CG[jb](n[CG[hc]]) ? (i[wo] = CG[DM](r, n[CG[hc]]), n[CG[yc]] += i[wo], n[CG[dc]] && (i[Au] = n[CG[hc]] + r, CG[jE](n[CG[dc]], i[Au] == PG[xv] ? PG[xv] : i[wo] / n[CG[hc]] + r)), r > n[CG[Nc]] && (n[CG[Nc]] = r), r < n[CG[mc]] && (n[CG[mc]] = r)) : n[CG[mc]] = n[CG[Nc]] = r, n[CG[hc]] = r;
        })[so](void 0, PG[pa], o[Au]), o[c(af)] = CG[KE](PG[Ea][CG[pc]]), r[Ru] = o[Ru], (function(n) {
            return !isNaN(n - i(n));
        })[so](void 0, r[Ru]) && (function(n, r) {
            var i = [];
            n[CG[De]]++, n[CG[ac]] += r, n[CG[lc]] += r * r, CG[jE](n[CG[sc]], r), CG[jb](n[CG[hc]]) ? (i[wo] = CG[DM](r, n[CG[hc]]), n[CG[yc]] += i[wo], n[CG[dc]] && (i[Au] = n[CG[hc]] + r, CG[jE](n[CG[dc]], i[Au] == PG[xv] ? PG[xv] : i[wo] / n[CG[hc]] + r)), r > n[CG[Nc]] && (n[CG[Nc]] = r), r < n[CG[mc]] && (n[CG[mc]] = r)) : n[CG[mc]] = n[CG[Nc]] = r, n[CG[hc]] = r;
        })[so](void 0, PG[Ma], o[Ru]), o[yb] = CG[uO](PG[Ea][CG[pc]]), r[yb] = o[yb], (function(n) {
            return !isNaN(n - i(n));
        })[so](void 0, r[yb]) && (function(n, r) {
            var i = [];
            n[CG[De]]++, n[CG[ac]] += r, n[CG[lc]] += r * r, CG[jE](n[CG[sc]], r), CG[jb](n[CG[hc]]) ? (i[wo] = CG[DM](r, n[CG[hc]]), n[CG[yc]] += i[wo], n[CG[dc]] && (i[Au] = n[CG[hc]] + r, CG[jE](n[CG[dc]], i[Au] == PG[xv] ? PG[xv] : i[wo] / n[CG[hc]] + r)), r > n[CG[Nc]] && (n[CG[Nc]] = r), r < n[CG[mc]] && (n[CG[mc]] = r)) : n[CG[mc]] = n[CG[Nc]] = r, n[CG[hc]] = r;
        })[so](void 0, PG[wa], o[yb]), o[Du] = CG[PE](PG[Ea][CG[pc]]), r[Du] = o[Du], (function(n) {
            return !isNaN(n - i(n));
        })[so](void 0, r[Du]) && (r[mf] = PG[c(fO)], (function(n, r) {
            var i = [];
            n[CG[De]]++, n[CG[ac]] += r, n[CG[lc]] += r * r, CG[jE](n[CG[sc]], r), CG[jb](n[CG[hc]]) ? (i[wo] = CG[DM](r, n[CG[hc]]), n[CG[yc]] += i[e(xu)], n[CG[dc]] && (i[Au] = n[CG[hc]] + r, CG[jE](n[CG[dc]], i[Au] == PG[xv] ? PG[xv] : i[wo] / n[CG[hc]] + r)), r > n[CG[Nc]] && (n[CG[Nc]] = r), r < n[CG[mc]] && (n[CG[mc]] = r)) : n[CG[mc]] = n[CG[Nc]] = r, n[CG[hc]] = r;
        })[so](void 0, r[mf], o[e(vf)])), o[c(of)] = CG[PE](PG[Oa][CG[pc]]), r[Iu] = o[Iu], (function(n) {
            return !isNaN(n - i(n));
        })[so](void 0, r[Iu]) && (r[pf] = PG[c(vO)], r[Zo] = o[c(of)], (function(n, r) {
            var i = [];
            n[CG[De]]++, n[CG[ac]] += r, n[CG[lc]] += r * r, CG[jE](n[CG[sc]], r), CG[jb](n[CG[hc]]) ? (i[wo] = CG[DM](r, n[CG[hc]]), n[CG[yc]] += i[wo], n[CG[dc]] && (i[Au] = n[CG[hc]] + r, CG[jE](n[CG[dc]], i[Au] == PG[xv] ? PG[xv] : i[wo] / n[CG[hc]] + r)), r > n[CG[Nc]] && (n[CG[Nc]] = r), r < n[CG[mc]] && (n[CG[mc]] = r)) : n[CG[mc]] = n[CG[Nc]] = r, n[CG[hc]] = r;
        })[so](void 0, r[pf], r[Zo])), r[Nb] = o[Du], (function(n) {
            return !isNaN(n - i(n));
        })[so](void 0, r[Nb]) && (r[mb] = o[Iu], (function(n) {
            return !isNaN(n - i(n));
        })[so](void e(xu), r[mb])) && o[Iu] > CG[ko] && (function(n, r) {
            var i = [];
            n[CG[De]]++, n[CG[ac]] += r, n[CG[lc]] += r * r, CG[jE](n[CG[sc]], r), CG[jb](n[CG[e(t(f(25369, 25379), Tr))]]) ? (i[wo] = CG[DM](r, n[CG[hc]]), n[CG[yc]] += i[wo], n[CG[dc]] && (i[Au] = n[CG[hc]] + r, CG[jE](n[CG[dc]], i[Au] == PG[xv] ? PG[xv] : i[wo] / n[CG[hc]] + r)), r > n[CG[Nc]] && (n[CG[e(XA)]] = r), r < n[CG[mc]] && (n[CG[mc]] = r)) : n[CG[mc]] = n[CG[Nc]] = r, n[CG[hc]] = r;
        })[so](void 0, PG[cu], o[Du] / o[e(of)]), (function(n) {
            n[CG[Ge]] = Array(n[CG[xe]]), n[CG[pc]] = CG[gE](!!n[CG[pc]][CG[dc]], n[CG[pc]][CG[sc]][CG[cc]]), n[CG[wc]] = CG[ko], n[CG[bc]] && (n[CG[bc]][CG[Kf]] = CG[ko]);
        })[so](void 0, PG[Ea]), (function(n) {
            n[CG[Ge]] = Array(n[CG[xe]]), n[CG[pc]] = CG[gE](!!n[CG[pc]][CG[dc]], n[CG[pc]][CG[sc]][CG[cc]]), n[CG[wc]] = CG[ko], n[CG[bc]] && (n[CG[bc]][CG[Kf]] = CG[ko]);
        })[so](void 0, PG[Oa]));
    }, CG[t(f(25379, 25383), Tr)] = function(n, r, o, u) {
        var v = [];
        var d = [];
        if (d[wo] = r[CG[Se]], v[wo] = d[e(xu)], (function(n) {
            return !isNaN(n - i(n));
        })[so](void 0, v[wo])) {
            switch(d[Au] = o[d[wo]], d[Ru] = CG[dE](PG[jd]), (function(n, r) {
                var i = [];
                n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
            })[so](void 0, PG[Na], r), (function(n, r) {
                var i = [];
                n[CG[Re]] && !n[CG[Re]](n, r) || n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[c(SM)] || (CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (i[wo] = n[CG[Be]], i[wo] && !i[wo][CG[$v]](PG[Eu], n[CG[Ge]]) || n[CG[De]]++));
            })[so](void 0, PG[Wd], r), d[Au][CG[gc]]){
                case PG[iu]:
                    v[Au] = r[CG[Ye]], (function(n) {
                        return CG[Ob](n) && n !== PG[Eu];
                    })[so](void 0, v[Au]) ? ((function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[e(df)][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[e(t(f(25383, 25394), Tr))], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[e(eO)](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[ta], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[uu], r), v[Su] = PG[c(cO)], (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[e(LF)]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, v[Su], r), v[hf] = PG[c(dO)], (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, v[hf], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[va], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[e(FA)]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[e(LF)]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[ua], r), v[To] = PG[c(e(t(f(25394, 25405), Tr)))], (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[e(df)][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void e(xu), v[To], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[e(SM)] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[e(zA)]], i[wo])))));
                    })[so](void 0, PG[sa], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[e(aO)]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[ha], r), (function(n, r) {
                        var i = [];
                        n[CG[e(cA)]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[ya], r), (function(n, r) {
                        var i = [];
                        n[CG[Re]] && !n[CG[Re]](n, r) || n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[c(SM)] || (CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (i[wo] = n[CG[Be]], i[wo] && !i[wo][CG[$v]](PG[Eu], n[CG[Ge]]) || n[CG[De]]++));
                    })[so](void 0, PG[Zd], r)) : (function(n, r) {
                        var i = [];
                        n[CG[Re]] && !n[CG[Re]](n, r) || n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[c(SM)] || (CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (i[wo] = n[CG[Be]], i[wo] && !i[wo][CG[$v]](PG[Eu], n[CG[Ge]]) || n[CG[De]]++));
                    })[so](void 0, PG[kd], r);
                    break;
                case PG[c(lO)]:
                    (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[e(t(f(25405, 25415), Tr))], r);
                    break;
                case PG[ad]:
                    d[yb] = CG[op](n), d[yb] < .7 * PG[Ta][CG[Oc]] && (function(n, r) {
                        return PG[Ed][n] = r;
                    })[so](void 0, PG[Td], r), PG[Ta][CG[Oc]] = d[yb], PG[Ta][CG[Xc]] = n[l(Vb)] || CG[ko];
                    break;
                case PG[dd]:
                    (function(n, r) {
                        var i = [];
                        n[CG[Re]] && !n[CG[Re]](n, r) || n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[e(yE)]]) < PG[c(SM)] || (CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (i[wo] = n[CG[Be]], i[wo] && !i[wo][CG[$v]](PG[Eu], n[CG[Ge]]) || n[CG[De]]++));
                    })[so](void 0, PG[Hd], r);
                    break;
                case PG[tu]:
                    v[Ru] = PG[c(sO)], (function(n, r) {
                        var i = [];
                        n[CG[Re]] && !n[CG[Re]](n, r) || n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[c(SM)] || (CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (i[wo] = n[CG[Be]], i[wo] && !i[wo][CG[$v]](PG[Eu], n[CG[e(LF)]]) || n[CG[De]]++));
                    })[so](void 0, v[Ru], r);
                    break;
                case PG[ed]:
                    d[Au][CG[Tc]] ? ((function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[e(xu)]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[Qd], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[Yd], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[na], r)) : ((function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[vu], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[eu], r), (function(n, r) {
                        var i = [];
                        n[CG[Re]] && !n[CG[Re]](n, r) || n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[c(e(SE))] || (CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (i[wo] = n[CG[Be]], i[wo] && !i[wo][CG[$v]](PG[Eu], n[CG[Ge]]) || n[CG[De]]++));
                    })[so](void 0, PG[Jd], r));
                    break;
                case PG[c(hO)]:
                    if (d[Au][CG[Tc]]) {
                        if ((function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[e(df)][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[Rd], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[e(t(f(25415, 25426), Tr))](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[e(yO)]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[Ud], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[Sd], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[ou], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[e(xu)]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[Id], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[e(xu)]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[Bd], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[Dd], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[e(xu)]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[e(xu)])))));
                        })[so](void 0, PG[e(t(f(25426, 25435), Tr))], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[e(Ec)], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[zd], r), v[Nf] = PG[c(NO)], (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[e(jA)]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, v[Nf], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[e(LF)]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[UE], r), v[mf] = PG[c(mO)], (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[e(yE)]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, v[mf], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[e(bO)]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[e(t(f(25435, 25445), Tr))](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[Cd], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[Pd], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[da], r), v[bf] = PG[c(pO)], (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[e(bO)]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, v[bf], r), (function(n) {
                            var r = [];
                            CG[lE](n) && (CG[LE](PG[fu], n), r[wo] = CG[$E](PG[Ea][CG[pc]]), CG[835](r[wo]) && CG[TE](PG[ma], r[wo]), r[Au] = CG[zE](PG[Ea][CG[pc]]), CG[835](r[Au]) && CG[TE](PG[pa], r[Au]), r[c(af)] = CG[KE](PG[Ea][CG[pc]]), CG[835](r[Ru]) && CG[TE](PG[Ma], r[Ru]), r[yb] = CG[uO](PG[Ea][CG[pc]]), CG[835](r[yb]) && CG[TE](PG[wa], r[yb]), r[Du] = CG[PE](PG[Ea][CG[pc]]), CG[835](r[Du]) && CG[TE](PG[c(fO)], r[Du]), r[c(of)] = CG[PE](PG[Oa][CG[pc]]), CG[835](r[Iu]) && CG[TE](PG[c(vO)], r[c(of)]), CG[835](r[Du]) && CG[835](r[Iu]) && r[Iu] > CG[ko] && CG[TE](PG[cu], r[Du] / r[Iu]), CG[kE](PG[Ea]), CG[kE](PG[Oa]));
                        })[so](void 0, r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[e(yO)]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[Ea], r), (function(n, r) {
                            var i = [];
                            n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[e(FA)]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                        })[so](void 0, PG[Oa], r), null != r[CG[ze]] && null != r[CG[Ke]] ? (d[Du] = r[CG[ze]], d[c(of)] = r[CG[Ke]], PG[Ta][CG[Zc]][CG[Cf]]({
                            x: d[Du],
                            y: d[Iu]
                        })) : null != r[CG[$e]] && null != r[CG[Ve]] && (d[c(vf)] = r[CG[$e]], d[Iu] = r[CG[Ve]], PG[Ta][CG[Zc]][CG[Cf]]({
                            x: d[Du],
                            y: d[Iu]
                        })), d[Nb] = r[CG[qe]], !PG[Za] || d[Nb] - PG[Za] >= CG[kv]) {
                            if (d[mb] = PG[Ta][CG[Zc]][CG[qv]](), d[mb][CG[Kf]]) {
                                d[Su] = 1 / 0, d[hf] = -1 / 0, d[e(sf)] = 1 / 0, d[yf] = -1 / 0, d[Nf] = CG[ko];
                                for(; d[Nf] < d[mb][CG[Kf]]; d[Nf]++)d[mf] = d[mb][d[Nf]], d[mf][CG[Yo]] < d[Su] && (d[Su] = d[mf][CG[Yo]]), d[mf][CG[Yo]] > d[hf] && (d[hf] = d[mf][CG[Yo]]), d[mf][CG[nu]] < d[To] && (d[c(sf)] = d[mf][CG[nu]]), d[mf][CG[nu]] > d[yf] && (d[yf] = d[mf][CG[nu]]);
                                PG[Ta][CG[Lc]] = d[Su], PG[e(MO)][CG[Hc]] = d[hf], PG[Ta][CG[kc]] = d[To], PG[Ta][CG[Jc]] = d[yf];
                            }
                            PG[c(iO)] = d[Nb];
                        }
                        PG[Ta][CG[Wc]] || (PG[c(MO)][CG[Wc]] = r[CG[qe]]), PG[Ta][CG[_c]] = r[CG[qe]];
                    }
                    o[d[wo]][s(wO)] && ((function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[e(aO)]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[ra], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[du], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[Xa], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[e(AO)], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[uu], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[ja], r), (function(n, r) {
                        var i = [];
                        n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[ga], r), (function(n, r) {
                        var i = [];
                        n[CG[e(cA)]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[wc]]++ : (i[e(xu)] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[Au][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[e(xu)]), i[Au][CG[e(yO)]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
                    })[so](void 0, PG[au], r));
            }
            u && u[a(FO)](r), d[Au][CG[gc]] != PG[iu] && (function(n, r) {
                return PG[Ed][n] = r;
            })[so](void 0, PG[Xd], r), d[Ru] && (v[yb] = d[Ru][CG[Se]], (function(n) {
                return !isNaN(n - i(n));
            })[so](void 0, v[yb])) && d[Ru][CG[fc]] && (d[bf] = o[d[Ru][CG[Se]]], d[bf][CG[gc]] == PG[vd] && d[bf][CG[Tc]] && (function(n) {
                var r = [];
                CG[lE](n) && (CG[LE](PG[fu], n), r[wo] = CG[$E](PG[Ea][CG[pc]]), CG[835](r[wo]) && CG[TE](PG[ma], r[wo]), r[Au] = CG[zE](PG[Ea][CG[pc]]), CG[835](r[Au]) && CG[TE](PG[pa], r[Au]), r[c(af)] = CG[KE](PG[Ea][CG[pc]]), CG[835](r[Ru]) && CG[TE](PG[Ma], r[Ru]), r[yb] = CG[uO](PG[Ea][CG[pc]]), CG[835](r[yb]) && CG[TE](PG[wa], r[yb]), r[Du] = CG[PE](PG[Ea][CG[pc]]), CG[835](r[Du]) && CG[TE](PG[c(fO)], r[Du]), r[c(of)] = CG[PE](PG[Oa][CG[pc]]), CG[835](r[Iu]) && CG[TE](PG[c(vO)], r[c(of)]), CG[835](r[Du]) && CG[835](r[Iu]) && r[Iu] > CG[ko] && CG[TE](PG[cu], r[Du] / r[Iu]), CG[kE](PG[Ea]), CG[kE](PG[Oa]));
            })[so](void 0, d[Ru])), d[Au][CG[gc]] == PG[c(hO)] && d[Au][CG[Tc]] && ((function(n, r) {
                return PG[Ed][n] = r;
            })[so](void 0, PG[Uu], r), (function(n) {
                return PG[Ed][n];
            })[so](void 0, PG[Od]) || ((function(n, r) {
                return PG[Ed][n] = r;
            })[so](void 0, PG[Od], r), v[Xf] = PG[c(EO)], (function(n, r) {
                var i = [];
                n[CG[Ue]] && CG[_p](n[CG[Ue]], r[CG[Se]]) < PG[xv] || n[CG[Re]] && !n[CG[Re]](r) || (n[CG[Mc]] && !n[CG[wc]] && (n[CG[wc]] = CG[Zf]), CG[ZF](n, r), (!n[CG[Ie]] || n[CG[Ie]](n)) && (n[CG[Mc]] && n[CG[Mc]][CG[$v]](PG[Eu], n[CG[Ge]]) ? n[CG[e(jA)]]++ : (i[wo] = n[CG[Be]][CG[$v]](PG[Eu], n[CG[Ge]]), CG[835](i[wo]) && (i[Au] = n, i[e(df)][CG[bc]] ? (i[Au][CG[bc]][CG[Cf]](i[wo]), i[Au][CG[bc]][CG[Kf]] > i[Au][s(HE)] && i[Au][CG[bc]][CG[Ac]](), CG[ZE](n)) : CG[TE](n[CG[pc]], i[wo])))));
            })[so](void 0, v[Xf], r))), d[Au][CG[Tc]] && r[CG[nc]] && ((function(n) {
                return PG[Ed][n];
            })[so](void 0, PG[gd]) || (function(n, r) {
                return PG[Ed][n] = r;
            })[so](void 0, PG[gd], r)), v[Du] = PG[c(hl)], (function(n, r) {
                return PG[Ed][n] = r;
            })[so](void 0, v[Du], r);
        }
    }, PG[La] = /[a-zA-Z]/, PG[Ha] = /\d/, CG[t(f(25445, 25449), Tr)] = function(n) {
        var r = [];
        return r[wo] = n, !CG[Ob](r[wo]) || r[wo] === PG[Eu] || n[CG[Kf]] > CG[Zf] ? PG[c(vE)] : PG[c(OO)][CG[ie]](n) ? PG[wd] : PG[Ha][CG[ie]](n) ? PG[Ad] : PG[Fd];
    }, PG[ka] = l(f(25449, 25469)), PG[Ja] = a(f(25469, 25501)), CG[XO] = function(n) {
        var i = PG[fd];
        var t = n && n[CG[we]];
        var r = [];
        if (r[wo] = i instanceof Object ? i : Object(i), r[Au] = isFinite(r[wo][CG[Kf]]) ? ~~r[wo][CG[Kf]] : CG[ko], r[c(af)] = CG[ko], void 0 === t) {
            do if (r[Ru] in r[wo] && void 0 === r[wo][r[Ru]]) return r[Ru];
            while (++r[Ru] < r[Au]);
        } else {
            do if (r[wo][r[Ru]] === t) return r[Ru];
            while (++r[Ru] < r[Au]);
        }
        return -CG[Zf];
    }, CG[t(f(25501, 25505), Tr)] = function(n, r) {
        var i = [];
        var t = [];
        r && (t[wo] = r[s(jO)], t[Au] = r[a(gO)]), n[CG[$e]] = (i[wo] = t[wo], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, i[wo]) ? t[wo] : PG[Eu]), n[CG[Ve]] = (i[Au] = t[wo], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, i[Au]) ? t[Au] : PG[Eu]);
    }, CG[t(f(25505, 25509), Tr)] = function(n, r) {
        var i = [];
        var t = [];
        r && (t[c(xu)] = r[s(TO)], t[Au] = r[s(ZO)], t[Ru] = r[l(LO)], t[yb] = r[a(HO)]), n[CG[ze]] = (i[wo] = t[wo], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, i[wo]) ? t[wo] : PG[Eu]), n[CG[Ke]] = (i[Au] = t[Au], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, i[Au]) ? t[c(df)] : PG[Eu]), n[CG[Gc]] = (i[Ru] = t[e(af)], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, i[Ru]) ? t[Ru] : PG[Eu]), n[CG[xc]] = (i[yb] = t[yb], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, i[yb]) ? t[yb] : PG[Eu]);
    }, CG[kO] = function(n, r, i, t) {
        var o = [];
        var u = [];
        switch(u[wo] = CG[XO](r), u[Au] = {
            gr: u[wo],
            br: i,
            Er: r[l(f(25509, 25533))]
        }, PG[sd][u[wo]][CG[gc]]){
            case PG[vd]:
                (function(n, r) {
                    var i = [];
                    r && (i[wo] = r[s(jO)], i[Au] = r[a(gO)]), n[CG[$e]] = CG[jb](i[wo]) ? i[wo] : PG[Eu], n[CG[Ve]] = CG[jb](i[wo]) ? i[Au] : PG[Eu];
                })[so](void 0, u[Au], r), (function(n, r) {
                    var i = [];
                    r && (i[c(xu)] = r[s(TO)], i[Au] = r[s(ZO)], i[Ru] = r[l(LO)], i[yb] = r[a(HO)]), n[CG[ze]] = CG[jb](i[wo]) ? i[wo] : PG[Eu], n[CG[Ke]] = CG[e($p)](i[Au]) ? i[c(df)] : PG[Eu], n[CG[Gc]] = CG[jb](i[Ru]) ? i[Ru] : PG[Eu], n[CG[xc]] = CG[jb](i[yb]) ? i[yb] : PG[Eu];
                })[so](void 0, u[Au], r), u[Ru] = CG[Kb](n) || CG[Zf], u[yb] = CG[Cb](n) || CG[Zf], u[Du] = u[Ru] / u[yb], o[Ru] = u[Au][CG[$e]], (function(n) {
                    return CG[Ob](n) && n !== PG[Eu];
                })[so](void 0, o[Ru]) && u[Au][CG[$e]] !== PG[Eu] && (o[yb] = u[Au][CG[Ve]], (function(n) {
                    return CG[Ob](n) && n !== PG[e(Ec)];
                })[so](void 0, o[yb])) && u[Au][CG[Ve]] !== PG[c(Ec)] && (u[Au][CG[$e]] = u[c(df)][CG[$e]] / u[Ru], u[Au][CG[Ve]] = u[Au][CG[Ve]] / u[c(Nv)] * u[Du]), u[c(df)][CG[Ye]] = r[s(f(25533, 25549))];
                break;
            case PG[c(EF)]:
                u[Au][CG[Rc]] = (o[mb] = r[CG[Uc]], (function(n) {
                    return CG[Ob](n) && n !== PG[Eu];
                })[so](void 0, o[mb]) ? r[CG[Uc]] : r[CG[Sc]]), u[Au][CG[Ic]] = r[CG[Bc]], u[Au][CG[Ye]] = (o[Su] = u[Au][CG[Ic]], (function(n) {
                    return CG[Ob](n) && n !== PG[Eu];
                })[so](void 0, o[Su]) ? u[Au][CG[Ic]] : (o[hf] = u[Au][CG[Rc]], (function(n) {
                    return CG[Ob](n) && n !== PG[Eu];
                })[so](void 0, o[hf]) ? u[c(df)][CG[Rc]] + PG[c(JO)] : PG[e(Ec)])), u[Au][CG[PA]] = (o[To] = r[CG[AF]], (function(n) {
                    return CG[Ob](n) && n !== PG[Eu];
                })[so](void 0, o[To]) ? r[CG[AF]] : (o[yf] = u[Au][CG[Rc]], (function(n) {
                    return CG[Ob](n) && n !== PG[Eu];
                })[so](void 0, o[yf]) ? String[CG[Fv]](u[c(e(Lf))][CG[Rc]]) : PG[Eu])), u[Au][CG[vc]] = (function(n) {
                    return !CG[jb](n) || n[CG[Kf]] > CG[Zf] ? PG[c(vE)] : PG[c(OO)][CG[ie]](n) ? PG[wd] : PG[Ha][CG[ie]](n) ? PG[Ad] : PG[Fd];
                })[so](void 0, u[Au][CG[PA]]);
                break;
            case PG[tu]:
                u[Au][CG[tc]] = n[s(f(25549, 25569))], CG[Gb](CG[Sb](n)[s(zb)])[CG[Jo]](function(r) {
                    var i = [];
                    return i[wo] = r, CG[Ob](i[wo]) && i[wo] !== PG[Eu] ? r[l(f(25569, 25601))] - (n[a(Pb)] || CG[ko]) : PG[Eu];
                })[CG[ru]](function(n) {
                    return u[Au][CG[oc]] = n;
                })[CG[Zo]]();
                break;
            case PG[dd]:
                u[c(df)][CG[rc]] = r[a(f(25601, 25617))], u[Au][CG[ic]] = r[s(f(25617, 25633))];
                break;
            case PG[ed]:
                u[Iu] = r[PG[ka]], o[Nf] = u[Iu], (function(n) {
                    return CG[Ob](n) && n !== PG[Eu];
                })[so](void 0, o[Nf]) && (u[Nb] = u[Iu][CG[ko]], (function(n, r) {
                    var i = [];
                    r && (i[wo] = r[s(jO)], i[Au] = r[a(gO)]), n[CG[$e]] = CG[jb](i[wo]) ? i[wo] : PG[Eu], n[CG[Ve]] = CG[jb](i[wo]) ? i[Au] : PG[Eu];
                })[so](void 0, u[Au], u[Nb]), o[bf] = u[c(Tf)], (function(n, r) {
                    var i = [];
                    r && (i[c(xu)] = r[s(TO)], i[Au] = r[s(ZO)], i[Ru] = r[l(LO)], i[yb] = r[a(HO)]), n[CG[ze]] = CG[jb](i[wo]) ? i[wo] : PG[Eu], n[CG[Ke]] = CG[e($p)](i[Au]) ? i[c(df)] : PG[Eu], n[CG[Gc]] = CG[jb](i[Ru]) ? i[Ru] : PG[Eu], n[CG[xc]] = CG[jb](i[yb]) ? i[yb] : PG[Eu];
                })[so](void 0, u[Au], o[bf]), u[Au][CG[uc]] = u[Iu][CG[Kf]], u[Ru] = CG[Kb](n) || CG[Zf], u[yb] = CG[Cb](n) || CG[Zf], u[Du] = u[Ru] / u[yb], o[pf] = u[Au][CG[$e]], (function(n) {
                    return CG[Ob](n) && n !== PG[Eu];
                })[so](void 0, o[pf]) && u[Au][CG[$e]] !== PG[c(Ec)] && (o[Zo] = u[Au][CG[Ve]], (function(n) {
                    return CG[Ob](n) && n !== PG[Eu];
                })[so](void 0, o[Zo])) && u[Au][CG[Ve]] !== PG[Eu] && (u[Au][CG[$e]] = u[e(df)][CG[e(xF)]] / u[Ru], u[Au][CG[Ve]] = u[Au][CG[Ve]] / u[yb] * u[Du]));
                break;
            case PG[cd]:
                u[mb] = r[PG[Ja]], u[mb] ? (u[Au][CG[$e]] = u[mb][CG[qc]], u[Au][CG[Ve]] = u[mb][CG[zc]], u[Au][CG[Qe]] = u[c(ge)][s(f(25633, 25649))]) : u[Au][CG[$e]] = u[Au][CG[Ve]] = u[Au][CG[Qe]] = PG[Eu];
        }
        return t && t[a(f(25649, 25657))](u[c(df)], r), u[Su] = CG[dE](PG[jd]), u[c(ef)] && u[Su][CG[e(yE)]] != u[Au][CG[Se]] && (u[e(ef)][CG[fc]] = !0), u[Au];
    }, CG[WO] = function(n) {
        var r = [];
        if (typeof ResizeObserver != typeof PG[Rv]) try {
            r[wo] = new ResizeObserver(function() {
                n[PG[Fu]] != PG[Ta][CG[jc]] && (PG[Ta][CG[jc]] = n[PG[Fu]], PG[c(MO)][CG[$c]] = !0);
            }), r[wo][CG[Kc]](CG[Sb](n)[s(zb)]);
        } catch (n) {}
    }, CG[_O] = function(n, r, i) {
        return i[r][s(f(25657, 25665))] ? n : n[CG[Ef]];
    }, CG[t(f(25665, 25669), Tr)] = function(n, r, i, t, o) {
        var u = [];
        u[wo] = CG[GO](n, r, t, o), u[wo][CG[Se]] < PG[xv] || (function(n) {
            return PG[Md][n]++;
        })[so](void 0, u[wo][CG[Se]]);
    }, CG[GO] = function(n, r, i, o) {
        var u = [];
        return u[wo] = CG[835](null === r || r === void CG[ko] ? void CG[ko] : r[CG[Vc]]) ? r[CG[Vc]] : CG[Bw](n), u[Au] = CG[kO](n, r, u[wo], o), (function(n, r, i, o) {
            var u = [];
            if (u[wo] = r[CG[Se]], CG[835](u[wo])) {
                switch(u[Au] = i[u[wo]], u[Ru] = CG[dE](PG[jd]), CG[LE](PG[Na], r), CG[HF](PG[Wd], r), u[Au][CG[gc]]){
                    case PG[iu]:
                        CG[jb](r[CG[Ye]]) ? (CG[LE](PG[ia], r), CG[LE](PG[ta], r), CG[LE](PG[uu], r), CG[LE](PG[c(cO)], r), CG[LE](PG[c(dO)], r), CG[LE](PG[va], r), CG[LE](PG[ua], r), CG[LE](PG[c(Ls)], r), CG[LE](PG[sa], r), CG[LE](PG[ha], r), CG[e(t(f(25669, 25679), Tr))](PG[ya], r), CG[HF](PG[Zd], r)) : CG[HF](PG[kd], r);
                        break;
                    case PG[c(lO)]:
                        CG[LE](PG[ea], r);
                        break;
                    case PG[ad]:
                        u[yb] = CG[op](n), u[yb] < .7 * PG[Ta][CG[Oc]] && CG[cE](PG[Td], r), PG[Ta][CG[Oc]] = u[yb], PG[Ta][CG[Xc]] = CG[Kb](n);
                        break;
                    case PG[dd]:
                        CG[HF](PG[Hd], r);
                        break;
                    case PG[e(XF)]:
                        CG[HF](PG[c(sO)], r);
                        break;
                    case PG[ed]:
                        u[Au][CG[Tc]] ? (CG[LE](PG[Qd], r), CG[LE](PG[Yd], r), CG[LE](PG[na], r)) : (CG[LE](PG[vu], r), CG[LE](PG[eu], r), CG[HF](PG[Jd], r));
                        break;
                    case PG[c(hO)]:
                        if (u[Au][CG[Tc]]) {
                            if (CG[LE](PG[Rd], r), CG[LE](PG[Ud], r), CG[LE](PG[Sd], r), CG[LE](PG[ou], r), CG[LE](PG[Id], r), CG[LE](PG[Bd], r), CG[LE](PG[Dd], r), CG[LE](PG[qd], r), CG[LE](PG[zd], r), CG[LE](PG[c(NO)], r), CG[LE](PG[UE], r), CG[LE](PG[c(mO)], r), CG[LE](PG[Cd], r), CG[LE](PG[Pd], r), CG[LE](PG[da], r), CG[LE](PG[c(pO)], r), CG[tO](r), CG[LE](PG[Ea], r), CG[LE](PG[Oa], r), null != r[CG[ze]] && null != r[CG[Ke]] ? (u[Du] = r[CG[ze]], u[c(of)] = r[CG[Ke]], PG[Ta][CG[Zc]][CG[Cf]]({
                                x: u[Du],
                                y: u[Iu]
                            })) : null != r[CG[$e]] && null != r[CG[Ve]] && (u[c(vf)] = r[CG[$e]], u[Iu] = r[CG[Ve]], PG[Ta][CG[Zc]][CG[Cf]]({
                                x: u[Du],
                                y: u[Iu]
                            })), u[e(Tf)] = r[CG[qe]], !PG[Za] || u[Nb] - PG[Za] >= CG[kv]) {
                                if (u[mb] = PG[Ta][CG[Zc]][CG[qv]](), u[mb][CG[Kf]]) {
                                    u[Su] = 1 / 0, u[hf] = -1 / 0, u[To] = 1 / 0, u[yf] = -1 / 0, u[Nf] = CG[ko];
                                    for(; u[Nf] < u[mb][CG[Kf]]; u[Nf]++)u[mf] = u[mb][u[Nf]], u[mf][CG[Yo]] < u[Su] && (u[Su] = u[mf][CG[Yo]]), u[mf][CG[Yo]] > u[hf] && (u[hf] = u[mf][CG[Yo]]), u[mf][CG[nu]] < u[To] && (u[c(sf)] = u[mf][CG[nu]]), u[mf][CG[nu]] > u[yf] && (u[yf] = u[mf][CG[nu]]);
                                    PG[Ta][CG[Lc]] = u[Su], PG[Ta][CG[Hc]] = u[hf], PG[Ta][CG[kc]] = u[To], PG[Ta][CG[Jc]] = u[yf];
                                }
                                PG[c(iO)] = u[Nb];
                            }
                            PG[Ta][CG[Wc]] || (PG[c(MO)][CG[Wc]] = r[CG[qe]]), PG[Ta][CG[_c]] = r[CG[qe]];
                        }
                        i[u[wo]][s(wO)] && (CG[LE](PG[ra], r), CG[LE](PG[du], r), CG[LE](PG[Xa], r), CG[LE](PG[ca], r), CG[LE](PG[uu], r), CG[LE](PG[ja], r), CG[LE](PG[ga], r), CG[LE](PG[au], r));
                }
                o && o[a(FO)](r), u[Au][CG[gc]] != PG[iu] && CG[cE](PG[Xd], r), u[Ru] && CG[835](u[Ru][CG[Se]]) && u[Ru][CG[fc]] && (u[bf] = i[u[Ru][CG[Se]]], u[bf][CG[gc]] == PG[vd] && u[bf][CG[Tc]] && CG[tO](u[Ru])), u[Au][CG[gc]] == PG[c(hO)] && u[e(df)][CG[Tc]] && (CG[cE](PG[Uu], r), CG[dE](PG[Od]) || (CG[cE](PG[Od], r), CG[LE](PG[c(EO)], r))), u[Au][CG[Tc]] && r[CG[nc]] && (CG[dE](PG[gd]) || CG[cE](PG[gd], r)), CG[cE](PG[c(hl)], r);
            }
        })[so](void 0, n, u[Au], i, o), u[Au];
    }, PG[_a] = a(f(25679, 25715)), PG[Ga] = l(f(25715, 25739)), PG[xa] = s(f(25739, 25771)), PG[Ra] = s(f(25771, 25791)), PG[Ua] = [
        PG[_a],
        PG[e(t(f(25791, 25802), Tr))],
        PG[c(t(f(25802, 25812), Tr))]
    ], CG[xO] = function(n, r, i, t, o) {
        r[CG[Cc]]({
            name: n
        })[CG[Pc]](function(n) {
            var r = [];
            r[c(xu)] = n[CG[Qc]], PG[Ou] || r[wo] === PG[Ra] && (PG[Ou] = !0, (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i, t, o, void 0));
        })[CG[Yc]](CG[Fb]);
    }, CG[t(f(25812, 25816), Tr)] = function(n, r, i, o) {
        var u = [];
        u[wo] = CG[tF](n), u[Au] = i[CG[Kf]] - CG[Zf];
        for(; u[Au] >= CG[ko]; u[Au]--)if (u[Ru] = CG[_O](n, u[c(df)], o), u[Au] === PG[Yc] && u[wo] && u[wo][CG[Cc]]) {
            u[yb] = PG[Ua][CG[Kf]] - CG[Zf];
            for(; u[yb] >= CG[ko]; u[yb]--)CG[xO](PG[e(t(f(25816, 25827), Tr))][u[yb]], u[wo], u[Ru], i[u[c(df)]], r);
        } else (function(n, r, i, t) {
            CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
        })[so](void 0, u[Ru], i[u[Au]], r, void 0);
    }, CG[RO] = function(n, r, i, t) {
        PG[Wa] = function(r) {
            var o = [];
            o[wo] = CG[GO](n, r, i, t), o[wo][CG[Se]] < PG[xv] || CG[jF](o[wo][CG[Se]]);
        }, (function(n) {
            PG[e(MO)][CG[Oc]] = CG[op](n), PG[Ta][CG[Xc]] = CG[Kb](n), PG[Ta][CG[jc]] = CG[tp](n);
        })[so](void 0, n), CG[WO](n), (function(n, r, i, t) {
            var o = [];
            o[wo] = CG[tF](n), o[Au] = i[CG[Kf]] - CG[Zf];
            for(; o[Au] >= CG[ko]; o[Au]--)if (o[Ru] = CG[_O](n, o[c(df)], t), o[Au] === PG[Yc] && o[wo] && o[wo][CG[Cc]]) {
                o[yb] = PG[Ua][CG[Kf]] - CG[Zf];
                for(; o[yb] >= CG[ko]; o[yb]--)CG[xO](PG[Ua][o[yb]], o[wo], o[Ru], i[o[c(df)]], r);
            } else CG[ww](o[Ru], i[o[Au]], r);
        })[so](void 0, n, PG[Wa], r, i);
    }, CG[UO] = function(n) {
        return n[CG[nd]](function(n, r) {
            return n + r;
        }, CG[ko]);
    }, CG[SO] = function(n) {
        return n[CG[Kf]] ? CG[UO](n) / n[CG[Kf]] : NaN;
    }, CG[IO] = function(n) {
        var r = [];
        return n[CG[Kf]] < CG[Df] ? NaN : (r[c(xu)] = CG[SO](n), n[CG[nd]](function(n, i) {
            return n + (i - r[wo]) * (i - r[wo]);
        }, CG[ko]) / (n[CG[Kf]] - CG[Zf]));
    }, CG[BO] = function(n) {
        var r = [];
        return r[wo] = CG[IO](n), Number[CG[e(DO)]](r[wo]) ? (function(n) {
            return CG[wM]()[PG[oe]](n);
        })[so](void 0, r[wo]) : NaN;
    }, CG[qO] = function(n, r) {
        var i = [];
        return n[CG[Kf]] ? (i[wo] = n[CG[iv]]()[CG[id]](function(n, r) {
            return n - r;
        }), i[Au] = (i[wo][CG[Kf]] - CG[Zf]) * r, i[Ru] = CG[GM](i[Au]), i[yb] = CG[FM](i[Au]), i[Ru] === i[yb] ? i[e(xu)][i[c(af)]] : (i[Du] = i[Au] - i[Ru], i[wo][i[Ru]] * (CG[Zf] - i[Du]) + i[wo][i[yb]] * i[Du])) : NaN;
    }, CG[zO] = function(n) {
        return CG[qO](n, CG[Qo]);
    }, CG[$O] = function(n) {
        var r = [];
        var i = [];
        return n[CG[Kf]] ? (i[wo] = CG[zO](n), r[wo] = n[CG[td]](function(n) {
            return CG[OM](n - i[c(xu)]);
        }), CG[qO](r[wo], CG[Qo])) : NaN;
    }, CG[KO] = function(n) {
        return n[CG[Kf]] ? Math[CG[dv]][CG[$v]](Math, n) : NaN;
    }, CG[VO] = function(n) {
        return n[CG[Kf]] ? Math[CG[cv]][CG[$v]](Math, n) : NaN;
    }, CG[CO] = function(n) {
        return n[CG[iv]](CG[Zf])[CG[td]](function(r, i) {
            return r - n[i];
        });
    }, CG[PO] = function(n, r) {
        var i = [];
        if (!n[CG[Kf]] || n[CG[Kf]] !== r[CG[Kf]]) return NaN;
        if (i[wo] = CG[SO](n), i[Au] = CG[SO](r), i[Ru] = CG[BO](n), i[c(Nv)] = CG[BO](r), !Number[CG[rd]](i[Ru]) || !Number[CG[rd]](i[yb]) || i[Ru] === CG[ko] || i[yb] === CG[ko]) return NaN;
        i[Du] = CG[ko], i[Iu] = CG[ko];
        for(; i[Iu] < n[CG[Kf]]; i[Iu]++)i[Du] += (n[i[Iu]] - i[wo]) * (r[i[Iu]] - i[Au]);
        return i[c(vf)] / ((n[CG[Kf]] - CG[Zf]) * i[Ru] * i[yb]);
    }, CG[QO] = function(n) {
        var r = [];
        return r[wo] = n[CG[Kf]], r[wo] < CG[yv] ? NaN : (r[Au] = CG[SO](n), r[Ru] = CG[BO](n), Number[CG[rd]](r[c(af)]) && r[Ru] !== CG[ko] ? n[CG[nd]](function(n, i) {
            return n + Math[CG[fv]](i - r[Au], CG[yv]);
        }, CG[ko]) / ((r[e(xu)] - CG[Zf]) * Math[CG[fv]](r[c(af)], CG[yv])) : NaN);
    }, CG[YO] = function(n) {
        var r = [];
        return r[wo] = n[CG[Kf]], r[wo] < CG[Xv] ? NaN : (r[Au] = CG[SO](n), r[Ru] = CG[BO](n), Number[CG[rd]](r[e(af)]) && r[Ru] !== CG[ko] ? n[CG[nd]](function(n, i) {
            return n + Math[CG[fv]](i - r[Au], CG[Xv]);
        }, CG[ko]) / ((r[wo] - CG[Zf]) * Math[CG[fv]](r[Ru], CG[Xv])) - CG[yv] : NaN);
    }, CG[t(f(25827, 25831), Tr)] = function(n) {
        return !!n && n[CG[Kf]] === CG[Zf] && /[A-Za-z]/[CG[ie]](n);
    }, CG[t(f(25831, 25835), Tr)] = function(n) {
        return !!n && n[CG[Kf]] === CG[Zf] && /[0-9]/[CG[ie]](n);
    }, CG[t(f(25835, 25839), Tr)] = function(n) {
        return n === CG[Uo] || n === s(nX);
    }, CG[rX] = function(n, r) {
        var i = [];
        if (!n[CG[Kf]]) return NaN;
        i[wo] = CG[Df] * CG[ZM]() / r, i[Au] = CG[ko], i[Ru] = CG[ko], i[yb] = CG[ko], i[Du] = CG[ko], i[Iu] = n;
        for(; i[Du] < i[Iu][CG[Kf]]; i[c(vf)]++)i[Nb] = i[Iu][i[Du]], Number[CG[rd]](i[Nb]) && (i[mb] = (i[Nb] % r + r) % r * i[wo], i[c(df)] += Math[CG[od]](i[mb]), i[Ru] += Math[CG[ud]](i[mb]), i[yb]++);
        return i[yb] ? Math[s(f(25839, 25855))](i[Au], i[Ru]) / i[yb] : NaN;
    }, CG[iX] = function(n, r, i) {
        var t = [];
        if (!n[CG[Kf]]) return NaN;
        t[wo] = CG[ko], t[c(df)] = CG[ko], t[e(af)] = n;
        for(; t[Au] < t[Ru][CG[Kf]]; t[Au]++)t[yb] = t[Ru][t[Au]], t[Du] = CG[OM](CG[AM](t[yb] / r) * r - t[yb]), t[Du] > i || t[wo]++;
        return t[c(xu)] / n[CG[Kf]];
    }, CG[tX] = function(n, r) {
        var i = [];
        i[wo] = CG[ko], i[Au] = n[CG[Kf]] - CG[Zf], i[Ru] = -CG[Zf];
        for(; i[c(xu)] <= i[c(df)];)i[yb] = i[wo] + i[Au] >> CG[Zf], n[i[yb]] > r ? i[Au] = i[e(Nv)] - CG[Zf] : (i[Ru] = i[e(Nv)], i[wo] = i[yb] + CG[Zf]);
        return i[Ru];
    }, CG[t(f(25855, 25859), Tr)] = function(n) {
        var r = [];
        return r[Au] = oX, r[yb] = uX, r[Iu] = fX, r[Nb] = vX, r[c(xu)] = n, r[c(af)] = -eX, r[Du] = -cX, r[mb] = r[wo] < CG[ko] ? -CG[Zf] : CG[Zf], r[wo] = (function(n) {
            return CG[wM]()[PG[e(t(f(25859, 25870), Tr))]](n);
        })[so](void 0, r[wo]), r[Su] = CG[Zf] / (CG[Zf] + r[Nb] * r[wo]), r[hf] = CG[Zf] - ((((r[Iu] * r[Su] + r[Du]) * r[Su] + r[yb]) * r[c(ef)] + r[Ru]) * r[Su] + r[c(df)]) * r[Su] * Math[CG[jv]](-r[wo] * r[wo]), r[mb] * r[hf];
    }, CG[dX] = function(n) {
        var r = [];
        var i = [];
        if (i[wo] = n[CG[fd]](function(n) {
            return n > CG[ko];
        }), i[wo][CG[Kf]] < CG[re]) return NaN;
        if (i[Au] = i[wo][CG[td]](CG[LM]), i[Ru] = CG[SO](i[Au]), i[yb] = CG[BO](i[Au]), !Number[CG[rd]](i[yb]) || i[yb] === CG[ko]) return NaN;
        r[Du] = function(n) {
            var r = [];
            return CG[Qo] + CG[Qo] * (r[wo] = (CG[LM](n) - i[Ru]) / (Math[l(f(25870, 25886))] * i[yb]), (function(n) {
                var r = [];
                return r[Au] = oX, r[yb] = uX, r[Iu] = fX, r[Nb] = vX, r[c(xu)] = n, r[c(af)] = -eX, r[Du] = -cX, r[mb] = r[wo] < CG[ko] ? -CG[Zf] : CG[Zf], r[wo] = CG[OM](r[wo]), r[Su] = CG[Zf] / (CG[Zf] + r[Nb] * r[wo]), r[hf] = CG[Zf] - ((((r[Iu] * r[Su] + r[Du]) * r[Su] + r[yb]) * r[c(ef)] + r[Ru]) * r[Su] + r[c(df)]) * r[Su] * Math[CG[jv]](-r[wo] * r[wo]), r[mb] * r[hf];
            })[so](void 0, r[wo]));
        }, i[Du] = i[wo][CG[iv]]()[CG[id]](function(n, r) {
            return n - r;
        }), i[c(of)] = CG[ko], i[Nb] = CG[ko];
        for(; i[Nb] < i[Du][CG[Kf]]; i[Nb]++)i[mb] = r[Du](i[Du][i[Nb]]), i[Su] = (i[Nb] + CG[Zf]) / i[c(vf)][CG[Kf]], i[hf] = i[Nb] / i[c(vf)][CG[Kf]], i[Iu] = Math[CG[cv]](i[Iu], (r[Su] = i[c(ef)] - i[mb], CG[wM]()[PG[re]](r[Su])), CG[wM]()[PG[re]](i[mb] - i[hf]));
        return i[Iu];
    }, CG[1358] = function(n, r) {
        var i = [];
        if (r === void CG[ko] && (r = CG[yv]), i[wo] = n[CG[Kf]], i[wo] < r) return NaN;
        i[Au] = new Map, i[Ru] = CG[ko];
        for(; i[Ru] <= i[wo] - r; i[c(af)]++)i[yb] = n[CG[iv]](i[Ru], i[Ru] + r)[CG[td]](function(n, r) {
            return {
                v: n,
                mn: r
            };
        }), i[yb][CG[id]](function(n, r) {
            return n[CG[iu]] === r[CG[iu]] ? n[CG[vd]] - r[CG[vd]] : n[CG[iu]] - r[CG[iu]];
        }), i[Du] = i[yb][CG[td]](function(n) {
            return n[CG[vd]];
        })[CG[jf]](CG[xo]), i[Au][CG[ed]](i[c(vf)], (i[c(df)][CG[cd]](i[c(vf)]) || CG[ko]) + CG[Zf]);
        return i[Iu] = Array[CG[dd]](i[Au][CG[Pf]]())[CG[nd]](function(n, r) {
            return n + r;
        }, CG[ko]), i[Nb] = Array[CG[dd]](i[Au][CG[Pf]]())[CG[td]](function(n) {
            return n / i[Iu];
        }), i[mb] = -CG[UO](i[Nb][CG[td]](function(n) {
            return n > CG[ko] ? n * CG[wM]()[PG[ee]](n) : CG[ko];
        })), i[Su] = CG[LM](CG[aX](r)), i[c(ef)] > CG[ko] ? i[c(ge)] / i[Su] : NaN;
    }, CG[aX] = function(n) {
        var r = [];
        r[wo] = CG[Zf], r[Au] = CG[Df];
        for(; r[Au] <= n; r[c(df)]++)r[wo] *= r[Au];
        return r[wo];
    }, CG[t(f(25886, 25890), Tr)] = function(n) {
        var r = [];
        if (r[c(of)] = !1, r[c(xu)] = n[CG[Kf]], r[wo] === CG[ko]) return NaN;
        r[Au] = CG[ko], r[Ru] = CG[Zf], r[c(Nv)] = CG[Zf];
        for(;;){
            if (r[Au] + r[Ru] > r[c(xu)]) {
                r[c(Nv)]++;
                break;
            }
            r[Du] = n[CG[iv]](r[Au], r[c(df)] + r[Ru])[CG[jf]](CG[tu]), r[Nb] = CG[ko];
            for(; r[Nb] < r[Au]; r[e(Tf)]++)if (r[mb] = n[CG[iv]](r[Nb], r[c(Tf)] + r[Ru])[CG[jf]](CG[tu]), r[Du] === r[c(ge)]) {
                r[Iu] = !0;
                break;
            }
            if (r[Iu] ? r[Ru]++ : (r[yb]++, r[Au] += r[c(af)], r[Ru] = CG[Zf]), r[Au] + r[Ru] > r[c(xu)]) break;
        }
        return r[yb];
    }, CG[lX] = function(n, r) {
        var i = [];
        return r === void CG[ko] && (r = CG[gf]), n[CG[Kf]] ? (i[c(xu)] = Array[CG[dd]]({
            length: r - CG[Zf]
        }, function(n, i) {
            return (i + CG[Zf]) / r;
        }), i[Au] = i[wo][CG[td]](function(r) {
            return CG[qO](n, r);
        }), n[CG[td]](function(n) {
            var r = [];
            r[wo] = CG[ko];
            for(; r[wo] < i[Au][CG[Kf]] && n > i[Au][r[wo]];)r[wo]++;
            return r[wo];
        })) : [];
    }, CG[t(f(25890, 25894), Tr)] = function(n, r) {
        var i = [];
        i[wo] = CG[OM](n), i[Au] = CG[OM](r);
        for(; i[Au];)i[Ru] = i[c(xu)] % i[Au], i[wo] = i[e(df)], i[Au] = i[Ru];
        return i[wo];
    }, CG[sX] = function(n, r) {
        var i = [];
        if (r === void CG[ko] && (r = CG[Fc]), i[wo] = n[CG[td]](function(n) {
            return CG[wM]()[PG[Vv]](n * CG[kv] / r) * r;
        })[CG[fd]](function(n) {
            return n > CG[ko];
        }), i[wo][CG[Kf]] < CG[e(bw)]) return NaN;
        i[Au] = i[wo][CG[ko]], i[Ru] = CG[Zf];
        for(; i[Ru] < i[wo][CG[Kf]] && (i[Au] = (function(n, r) {
            var i = [];
            i[wo] = CG[OM](n), i[Au] = CG[OM](r);
            for(; i[Au];)i[Ru] = i[c(xu)] % i[Au], i[wo] = i[Au], i[Au] = i[Ru];
            return i[wo];
        })[so](void 0, i[e(df)], i[wo][i[Ru]]), i[Au] !== CG[Zf]); i[Ru]++);
        return i[Au];
    }, CG[hX] = function(n) {
        var r = [];
        if (r[wo] = n[CG[iv]]()[CG[id]](function(n, r) {
            return n - r;
        }), r[Au] = r[wo][CG[Kf]], !r[Au]) return NaN;
        if (r[Ru] = CG[UO](r[wo]), !r[Ru]) return NaN;
        r[yb] = CG[ko], r[c(vf)] = CG[ko];
        for(; r[Du] < r[Au]; r[c(vf)]++)r[yb] += (CG[Df] * (r[Du] + CG[Zf]) - r[Au] - CG[Zf]) * r[wo][r[Du]];
        return r[yb] / (r[Au] * r[Ru]);
    }, CG[yX] = function(n) {
        var r = [];
        if (r[wo] = n[CG[Kf]], r[wo] < CG[Df]) return {
            b: NaN,
            a: NaN,
            r2: NaN,
            yn: []
        };
        r[c(df)] = Array[CG[dd]]({
            length: r[wo]
        }, function(n, r) {
            return r + CG[Zf];
        }), r[c(af)] = CG[SO](r[e(df)]), r[yb] = CG[SO](n), r[Du] = CG[ko], r[Iu] = CG[ko], r[c(Tf)] = CG[ko], r[mb] = CG[ko];
        for(; r[mb] < r[wo]; r[mb]++)r[Du] += (r[Au][r[c(ge)]] - r[Ru]) * (n[r[mb]] - r[yb]), r[Iu] += Math[CG[fv]](r[Au][r[mb]] - r[Ru], CG[Df]), r[Nb] += Math[CG[fv]](n[r[mb]] - r[yb], CG[Df]);
        return r[Iu] === CG[ko] ? {
            b: NaN,
            a: NaN,
            r2: NaN,
            yn: []
        } : (r[c(ef)] = r[Du] / r[Iu], r[c(Ze)] = r[yb] - r[c(ef)] * r[Ru], r[c(sf)] = n[CG[td]](function(n, i) {
            return n - (r[hf] + r[Su] * (i + CG[Zf]));
        }), r[c(He)] = r[Nb] - r[To][CG[e(t(f(25894, 25904), Tr))]](function(n, r) {
            return n + r * r;
        }, CG[ko]), r[Nf] = r[Nb] > CG[ko] ? r[yf] / r[Nb] : NaN, {
            b: r[Su],
            a: r[hf],
            r2: r[Nf],
            yn: r[To]
        });
    }, CG[NX] = function(n) {
        var r = [];
        return n[CG[Kf]] < CG[e(bw)] ? NaN : (r[wo] = n[CG[iv]](CG[Zf])[CG[nd]](function(r, i, t) {
            return r + Math[CG[fv]](i - n[t], CG[Df]);
        }, CG[ko]), r[Au] = n[CG[nd]](function(n, r) {
            return n + r * r;
        }, CG[ko]), r[Au] > CG[ko] ? r[wo] / r[Au] : NaN);
    }, CG[mX] = function(n) {
        return CG[Zf] << Math[CG[vv]](Math[l(f(25904, 25916))](Math[CG[cv]](CG[Zf], n)));
    }, PG[Sa] = {
        gn: CG[ko],
        bn: CG[ko],
        wn: CG[ko],
        Nn: CG[ko],
        Mn: CG[ko],
        Tab: CG[ko],
        kn: CG[ko],
        xn: CG[ko],
        An: CG[Zf],
        Sn: CG[Zf],
        En: CG[Zf],
        Fn: CG[Zf],
        Cn: CG[Df],
        Tn: CG[Df],
        In: CG[Df],
        Dn: CG[Df],
        Ln: CG[yv],
        Rn: CG[yv],
        On: CG[yv],
        Pn: CG[yv],
        jn: CG[yv],
        Hn: CG[yv],
        Bn: CG[yv],
        qn: CG[yv],
        Kn: CG[Xv],
        Un: CG[Xv],
        zn: CG[Xv],
        Vn: CG[e(eA)],
        Gn: CG[Xv],
        Wn: CG[Xv],
        Xn: CG[Xv],
        Jn: CG[Xv],
        Zn: CG[re],
        $n: CG[re],
        Qn: CG[re],
        Yn: CG[re],
        ea: CG[gf],
        ia: CG[gf],
        oa: CG[gf],
        ca: CG[gf],
        _a: CG[xw],
        pa: CG[xw],
        ma: CG[xw],
        ya: CG[xw],
        ga: CG[xw],
        Na: CG[xw],
        ja: CG[xw],
        Va: CG[xw],
        $a: CG[xw],
        rt: CG[xw],
        nt: CG[xw]
    }, CG[t(f(25916, 25920), Tr)] = function(n) {
        return n > CG[yv] ? CG[Zf] : CG[ko];
    }, PG[Ia] = function() {
        function n(n) {
            var r = [];
            n === void CG[ko] && (n = {}), this[CG[ad]] = new Map, this[CG[ld]] = null !== (r[wo] = n[a(f(25920, 25928))]) && r[wo] !== void CG[ko] ? r[wo] : d(t(f(25928, 25938), Tr)), this[CG[sd]] = null !== (r[Au] = n[a(f(25938, 25946))]) && r[Au] !== void CG[ko] ? r[Au] : CG[mv], this[CG[hd]] = null !== (r[Ru] = n[a(f(25946, 25954))]) && r[Ru] !== void CG[e(Yl)] ? r[Ru] : CG[yd], this[CG[Nd]] = CG[Fc], this[CG[md]] = new PG[ke](this[CG[Nd]]), this[CG[bd]] = new PG[ke](this[CG[Nd]]), this[CG[pd]] = new PG[ke](this[CG[Nd]]), this[CG[Md]] = new PG[ke](this[CG[Nd]]), this[CG[wd]] = new PG[ke](this[CG[Nd]]), this[CG[Ad]] = new PG[ke](this[CG[Nd]]), this[CG[Fd]] = new PG[ke](this[CG[Nd]]), this[CG[Ed]] = new PG[ke](this[CG[Nd]]), this[CG[Od]] = new PG[ke](this[CG[e(t(f(25954, 25964), Tr))]]), this[CG[Xd]] = {
                kd: this[CG[Uu]][CG[jd]](this),
                Nt: this[CG[gd]][CG[jd]](this),
                kt: this[CG[Td]][CG[jd]](this),
                At: this[CG[Zd]][CG[jd]](this),
                Et: this[CG[Ld]][CG[jd]](this),
                Ct: this[CG[Hd]][CG[e(hl)]](this),
                ce: this[CG[kd]][CG[jd]](this),
                Dt: this[CG[Jd]][CG[jd]](this),
                Rt: this[CG[e(t(f(25964, 25975), Tr))]][CG[jd]](this),
                Pt: this[CG[_d]][CG[jd]](this),
                Ht: this[CG[Gd]][CG[jd]](this),
                qt: this[CG[xd]][CG[jd]](this),
                Ut: this[CG[Rd]][CG[jd]](this),
                mm: this[CG[e(pX)]][CG[jd]](this)
            };
        }
        return n[CG[Mf]][CG[Sd]] = function(n, r, i) {
            var t = [];
            t[wo] = n[CG[cd]](r), t[wo] || (t[wo] = new PG[ke](this[CG[Nd]]), n[CG[ed]](r, t[wo])), t[wo][CG[Cf]](i);
        }, n[CG[Mf]][CG[Uv]] = function() {
            var n = this[CG[ou]];
            return CG[Sw](n) ? CG[Uw](n)[PG[Po]]() : PG[Oe]();
        }, n[CG[Mf]][CG[Id]] = function(n) {
            var r = [];
            var i = [];
            this[CG[Bd]] || (this[CG[ou]] = n, this[CG[Bd]] = !0, i[wo] = n[CG[Ef]], r[wo] = i[c(xu)], r[Au] = this[CG[Xd]][a(f(25975, 25983))], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[e(Ow)])[CG[bf]](r), i);
            })[so](void 0, r[wo], CG[Dd], r[Au], void 0), r[Ru] = l(f(25983, 25999)), r[yb] = this[CG[Xd]][s(f(25999, 26007))], (function(n, r, i, o) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !o) : CG[jw](n) && n[PG[c(e(t(f(26007, 26015), Tr)))]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i[wo], r[Ru], r[yb], void 0), r[Du] = a(f(26015, 26047)), r[Iu] = this[CG[Xd]][a(f(26047, 26055))], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i[wo], r[Du], r[Iu], void 0), r[e(Tf)] = this[CG[Xd]][l(f(26055, 26063))], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[e(Zv)]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i[wo], CG[wf], r[Nb], void 0), r[mb] = s(f(26063, 26107)), r[Su] = this[CG[Xd]][l(f(26107, 26115))], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i[wo], r[mb], r[Su], void 0), r[hf] = l(f(26115, 26163)), r[To] = this[CG[Xd]][l(f(26163, 26171))], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i[wo], r[hf], r[To], void 0), r[yf] = this[CG[Xd]][a(f(26171, 26179))], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i[wo], CG[qd], r[yf], void 0), r[Nf] = this[CG[Xd]][l(f(26179, 26187))], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i[wo], CG[zd], r[Nf], void 0), (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i[wo], CG[$d], this[CG[Xd]].Rt, void 0), r[mf] = this[CG[Xd]][a(f(26187, 26195))], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i[wo], CG[UE], r[mf], void 0), r[bf] = this[CG[Xd]][l(f(26195, 26203))], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, n, CG[Vd], r[bf], void 0), r[pf] = s(f(26203, 26227)), r[Zo] = this[CG[Xd]][s(f(26227, 26235))], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[e(Zv)]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i[wo], r[pf], r[Zo], void 0), r[Lo] = a(f(26235, 26255)), r[Ho] = this[CG[Xd]][a(f(26255, 26263))], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i[wo], r[Lo], r[Ho], void 0), r[Mf] = this[CG[Xd]][s(f(26263, 26271))], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, i[wo], CG[Cd], r[Mf], void 0));
        }, n[CG[Mf]][CG[Pd]] = function() {
            this[CG[md]][CG[zv]](), this[CG[bd]][CG[zv]](), this[CG[pd]][CG[zv]](), this[CG[Md]][CG[zv]](), this[CG[wd]][CG[zv]](), this[CG[ad]][CG[zv]](), this[CG[Ad]][CG[zv]](), this[CG[Fd]][CG[zv]](), this[CG[Ed]][CG[zv]](), this[CG[Od]][CG[zv]]();
        }, n[CG[Mf]][CG[Uu]] = function(n) {
            var r = [];
            r[wo] = this[CG[Uv]](), r[Au] = {
                Xt: r[c(xu)],
                key: n[CG[AF]],
                code: n[CG[Bc]],
                Jt: n[CG[Wf]] | CG[ko]
            }, this[CG[md]][CG[Cf]](r[Au]), n[a(f(26271, 26287))] && this[CG[Sd]](this[CG[e(t(f(26287, 26297), Tr))]], n[CG[Bc]], r[wo]);
        }, n[CG[Mf]][CG[gd]] = function(n) {
            this[CG[bd]][CG[Cf]]({
                Xt: this[CG[Uv]](),
                key: n[CG[AF]],
                code: n[CG[Bc]],
                Jt: n[CG[Wf]] | CG[ko]
            });
        }, n[CG[Mf]][CG[Td]] = function(n) {
            var r = [];
            r[Au] = null !== (r[wo] = n[CG[Qd]]) && r[wo] !== void CG[ko] ? r[wo] : CG[Wo], this[CG[pd]][CG[Cf]]({
                Xt: this[CG[Uv]](),
                mn: CG[ko],
                type: n[CG[Yd]] || CG[Wo],
                Zt: r[c(df)][CG[Kf]],
                $t: n[CG[na]] ? CG[Zf] : CG[ko],
                ch: r[c(df)] && r[Au][CG[Kf]] === CG[e(fs)] ? r[Au] : void 0
            });
        }, n[CG[Mf]][CG[Zd]] = function(n) {
            var r = [];
            r[Au] = null !== (r[c(xu)] = n[CG[e(RE)]]) && r[wo] !== void CG[ko] ? r[wo] : CG[Wo], this[CG[pd]][CG[Cf]]({
                Xt: this[CG[Uv]](),
                mn: CG[Zf],
                type: n[CG[Yd]] || CG[Wo],
                Zt: r[Au][CG[Kf]],
                $t: n[CG[na]] ? CG[Zf] : CG[ko],
                ch: r[Au] && r[Au][CG[Kf]] === CG[Zf] ? r[Au] : void 0
            });
        }, n[CG[Mf]][CG[Ld]] = function() {
            this[CG[Md]][CG[Cf]]({
                Xt: this[CG[Uv]](),
                mn: CG[ko]
            });
        }, n[CG[Mf]][CG[Hd]] = function() {
            this[CG[Md]][CG[Cf]]({
                Xt: this[CG[Uv]](),
                mn: CG[Zf]
            });
        }, n[CG[Mf]][CG[kd]] = function() {
            this[CG[Md]][CG[Cf]]({
                Xt: this[CG[Uv]](),
                mn: CG[Df]
            });
        }, n[CG[Mf]][CG[Jd]] = function(n) {
            var r = [];
            this[CG[wd]][CG[Cf]]({
                Xt: this[CG[Uv]](),
                mn: CG[Zf],
                Zt: ((null === (r[wo] = n[CG[ra]]) || r[wo] === void CG[ko] ? void CG[ko] : r[wo][CG[ia]](a(f(26297, 26309)))) || CG[Wo])[CG[Kf]]
            });
        }, n[CG[Mf]][CG[Wd]] = function() {
            this[CG[wd]][CG[Cf]]({
                Xt: this[CG[Uv]](),
                mn: CG[Df]
            });
        }, n[CG[Mf]][CG[_d]] = function() {
            this[CG[wd]][CG[Cf]]({
                Xt: this[CG[Uv]](),
                mn: CG[yv]
            });
        }, n[CG[Mf]][CG[Gd]] = function() {
            this[CG[Ad]][CG[Cf]]({
                Xt: this[CG[Uv]]()
            });
        }, n[CG[Mf]][CG[xd]] = function() {
            this[CG[Fd]][CG[Cf]]({
                Xt: this[CG[Uv]]()
            });
        }, n[CG[Mf]][CG[Rd]] = function() {
            this[CG[Ed]][CG[Cf]]({
                Xt: this[CG[Uv]]()
            });
        }, n[CG[Mf]][CG[Ud]] = function() {
            this[CG[Od]][CG[Cf]]({
                Xt: this[CG[Uv]]()
            });
        }, n[CG[Mf]][CG[ta]] = function(n) {
            var r;
            var i;
            var o;
            var u;
            var v;
            var y;
            var N;
            var m;
            var b;
            var p;
            var M;
            var w;
            var A;
            var F;
            var E;
            var O;
            var X;
            var j;
            var g = [];
            var T = [];
            T[wo] = this, n === void CG[ko] && (n = !0), T[e(Ip)] = this[CG[md]][CG[qv]](), T[Pf] = this[CG[bd]][CG[qv]](), T[Qf] = this[CG[pd]][CG[qv]](), T[Yf] = this[CG[Md]][CG[qv]](), T[nv] = this[CG[wd]][CG[qv]](), T[rv] = this[CG[Ad]][CG[qv]](), T[iv] = this[CG[Fd]][CG[qv]](), T[Ro] = this[CG[Ed]][CG[qv]](), T[c(t(f(26309, 26319), Tr))] = this[CG[Od]][CG[qv]](), T[e(Tl)] = Math[CG[dv]](null !== (T[Ru] = null === (T[Au] = T[Cf][CG[ko]]) || T[Au] === void CG[ko] ? void CG[ko] : T[Au][CG[oa]]) && T[c(af)] !== void CG[ko] ? T[Ru] : 1 / 0, null !== (T[Du] = null === (T[yb] = T[Pf][CG[ko]]) || T[yb] === void CG[ko] ? void CG[ko] : T[yb][CG[oa]]) && T[Du] !== void CG[ko] ? T[Du] : 1 / 0, null !== (T[Nb] = null === (T[Iu] = T[Qf][CG[ko]]) || T[Iu] === void CG[ko] ? void CG[ko] : T[Iu][CG[oa]]) && T[Nb] !== void CG[ko] ? T[Nb] : 1 / 0, null !== (T[Su] = null === (T[mb] = T[c(MX)][CG[ko]]) || T[c(ge)] === void CG[ko] ? void CG[ko] : T[mb][CG[oa]]) && T[Su] !== void CG[ko] ? T[Su] : 1 / 0, null !== (T[To] = null === (T[hf] = T[nv][CG[ko]]) || T[hf] === void CG[ko] ? void CG[ko] : T[hf][CG[oa]]) && T[To] !== void CG[ko] ? T[To] : 1 / 0), T[ov] = Math[CG[cv]](null !== (T[Nf] = null === (T[yf] = T[Cf][T[Cf][CG[Kf]] - CG[Zf]]) || T[yf] === void CG[ko] ? void CG[ko] : T[yf][CG[oa]]) && T[Nf] !== void CG[ko] ? T[Nf] : -1 / 0, null !== (T[bf] = null === (T[mf] = T[Pf][T[Pf][CG[Kf]] - CG[Zf]]) || T[e(Je)] === void CG[ko] ? void CG[ko] : T[mf][CG[oa]]) && T[bf] !== void CG[ko] ? T[bf] : -1 / 0, null !== (T[Zo] = null === (T[pf] = T[Qf][T[Qf][CG[Kf]] - CG[Zf]]) || T[pf] === void CG[e(Yl)] ? void CG[ko] : T[pf][CG[oa]]) && T[Zo] !== void CG[ko] ? T[Zo] : -1 / 0, null !== (T[Ho] = null === (T[Lo] = T[Yf][T[Yf][CG[Kf]] - CG[Zf]]) || T[Lo] === void CG[ko] ? void CG[ko] : T[Lo][CG[oa]]) && T[Ho] !== void CG[ko] ? T[c(ne)] : -1 / 0, null !== (T[wf] = null === (T[Mf] = T[nv][T[nv][CG[Kf]] - CG[Zf]]) || T[c(cl)] === void CG[ko] ? void CG[ko] : T[Mf][CG[oa]]) && T[wf] !== void CG[ko] ? T[wf] : -1 / 0), T[uv] = T[Cf][CG[iv]]()[CG[id]](function(n, r) {
                return n[CG[oa]] - r[CG[oa]];
            }), T[c(t(f(26319, 26330), Tr))] = T[Qf][CG[fd]](function(n) {
                return n[CG[vd]] === CG[Zf];
            }), g[vv] = function(n) {
                return Number[CG[rd]](n) ? n : CG[ko];
            }, g[ev] = function(n, r, i) {
                var t = [];
                r === void CG[ko] && (r = T[c(wX)]), i === void CG[ko] && (i = T[fv]), t[wo] = [], t[Au] = CG[ko];
                for(; t[Au] < r[CG[Kf]] - CG[Zf]; t[Au]++)r[t[Au] + CG[Zf]][CG[AF]] === n && t[wo][CG[Cf]](r[t[Au] + CG[Zf]][CG[oa]] - r[t[Au]][CG[oa]]);
                if (t[wo][CG[Kf]]) return t[wo];
                if (t[Ru] = i[CG[fd]](function(n) {
                    return n[CG[we]] && n[CG[we]][CG[ua]](CG[fa]) && n[CG[va]] === CG[Zf];
                }), t[Ru][CG[Kf]] < CG[Df]) return t[wo];
                t[Au] = CG[Zf];
                for(; t[Au] < t[Ru][CG[Kf]]; t[Au]++)if (t[yb] = t[Ru][t[Au]], t[yb][CG[we]] !== CG[ea] && (t[c(vf)] = t[yb][CG[ca]], t[Du] === n)) {
                    t[Iu] = t[c(df)] - CG[Zf];
                    for(; t[Iu] >= CG[ko]; t[Iu]--)if (t[Nb] = t[Ru][t[Iu]], t[Nb][CG[va]] === CG[Zf]) {
                        t[wo][CG[Cf]](t[yb][CG[oa]] - t[Nb][CG[oa]]);
                        break;
                    }
                }
                return t[wo];
            }, T[vv] = g[ev](CG[uu]), T[ev] = g[ev](CG[Ro]), g[av] = function(n, r) {
                var i = [];
                if (!n[CG[Kf]] || !r[CG[Kf]]) return [];
                i[wo] = n[CG[iv]]()[CG[id]](function(n, r) {
                    return n - r;
                }), i[Au] = r[CG[iv]]()[CG[id]](function(n, r) {
                    return n - r;
                }), i[Ru] = [], i[yb] = CG[ko], i[Du] = CG[ko];
                for(; i[Du] < i[wo][CG[Kf]]; i[Du]++){
                    for(; i[yb] + CG[Zf] < i[Au][CG[Kf]] && Math[CG[ev]](i[Au][i[yb] + CG[Zf]] - i[wo][i[Du]]) <= Math[CG[ev]](i[Au][i[yb]] - i[wo][i[c(vf)]]);)i[yb]++;
                    i[Ru][CG[Cf]](Math[CG[ev]](i[Au][i[yb]] - i[wo][i[Du]]));
                }
                return i[Ru];
            }, g[lv] = function(n, r, i, o, u, v, h) {
                var y;
                var N = [];
                var m = [];
                m[Bo] = null, m[Ru] = [], m[c(Nv)] = new Map, m[Du] = CG[ko], m[Iu] = n;
                for(; m[Du] < m[Iu][CG[Kf]]; m[Du]++)m[Nb] = m[Iu][m[Du]], m[mb] = m[yb][CG[cd]](m[Nb][CG[Bc]]) || [], m[mb][CG[Cf]](m[Nb]), m[yb][CG[ed]](m[Nb][CG[Bc]], m[mb]);
                m[Su] = CG[ko], m[hf] = r;
                for(; m[Su] < m[hf][CG[Kf]]; m[Su]++)m[To] = m[hf][m[Su]], m[mb] = m[yb][CG[cd]](m[To][CG[e(t(f(26330, 26340), Tr))]]) || [], m[Nb] = m[mb] && m[mb][CG[Kf]] ? m[mb][CG[Ac]]() : null, m[Nb] && m[Ru][CG[Cf]]({
                    Yt: m[Nb][CG[oa]],
                    ue: m[To][CG[oa]],
                    key: m[Nb][CG[AF]],
                    code: m[Nb][CG[Bc]]
                });
                m[Ru][CG[id]](function(n, r) {
                    return n[CG[da]] - r[CG[da]];
                }), m[yf] = m[Ru][CG[td]](function(n) {
                    return n[CG[aa]] - n[CG[da]];
                })[CG[fd]](function(n) {
                    return n >= CG[ko];
                }), m[Nf] = n[CG[td]](function(n) {
                    return n[CG[oa]];
                }), m[Vv] = m[Nf], m[mf] = m[Nf][CG[iv]](CG[Zf])[CG[td]](function(n, r) {
                    return n - m[Nf][r];
                }), m[bf] = r[CG[td]](function(n) {
                    return n[CG[oa]];
                }), m[pf] = [], m[Zo] = CG[ko];
                for(; m[e(uf)] < Math[CG[dv]](m[bf][CG[Kf]], m[Nf][CG[Kf]] - CG[Zf]); m[Zo]++)m[pf][CG[Cf]](m[c(Pv)][m[Zo] + CG[Zf]] - m[bf][m[Zo]]);
                m[Lo] = CG[KO](m[mf]), m[Ho] = CG[SO](m[mf]), m[Mf] = CG[VO](m[c(Je)]), m[wf] = CG[qO](m[mf], CG[fu]), m[Af] = CG[qO](m[mf], CG[vu]), m[Ff] = CG[qO](m[mf], CG[eu]), m[Ef] = CG[ko], m[Of] = CG[ko], m[ko] = CG[ko], m[Xf] = CG[ko], m[jf] = CG[e(Yl)], m[gf] = n;
                for(; m[jf] < m[gf][CG[Kf]]; m[jf]++)m[Nb] = m[gf][m[jf]], N[Qo] = m[Nb][CG[AF]], (function(n) {
                    return !!n && n[CG[Kf]] === CG[Zf] && /[A-Za-z]/[CG[ie]](n);
                })[so](void 0, N[Qo]) ? m[Ef]++ : (N[ec] = m[Nb][CG[AF]], (function(n) {
                    return !!n && n[CG[Kf]] === CG[Zf] && /[0-9]/[CG[ie]](n);
                })[so](void 0, N[ec]) ? m[Of]++ : (N[cc] = m[Nb][CG[AF]], (function(n) {
                    return n === CG[Uo] || n === s(nX);
                })[so](void 0, N[cc]) ? m[ko]++ : m[c(fw)]++));
                m[Zf] = m[Ru][CG[fd]](function(n) {
                    var r = n[CG[AF]];
                    return !!r && r[CG[Kf]] === CG[Zf] && /[A-Za-z]/[CG[ie]](r);
                }), m[Hf] = n[CG[fd]](function(n) {
                    return n[CG[AF]] === CG[mf];
                }), m[kf] = [], N[sc] = function(n, r) {
                    var i = [];
                    i[c(df)] = CG[ko], i[Ru] = n;
                    for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], i[c(Nv)][CG[oa]] > r || i[wo] && i[yb][CG[oa]] <= i[c(xu)][CG[oa]] || (i[wo] = i[c(Nv)]);
                    return i[wo];
                }, m[Jf] = CG[ko], m[Wf] = m[Zf];
                for(; m[Jf] < m[Wf][CG[Kf]]; m[Jf]++)m[Jo] = m[Wf][m[Jf]], m[_f] = N[sc](m[Hf], m[Jo][CG[da]]), m[_f] && m[kf][CG[Cf]](m[Jo][CG[da]] - m[e(AX)][CG[oa]]);
                m[Gf] = m[pf][CG[Kf]] ? m[pf][CG[fd]](function(n) {
                    return n < CG[ko];
                })[CG[e(Nl)]] / m[pf][CG[Kf]] : NaN, m[c(t(f(26340, 26350), Tr))] = m[c(fs)][CG[Kf]] ? m[Zf][CG[fd]](function(n) {
                    var r = [];
                    return r[wo] = m[c(FX)], (function(n, r) {
                        var i = [];
                        i[c(df)] = CG[ko], i[Ru] = n;
                        for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], i[c(Nv)][CG[oa]] > r || i[wo] && i[yb][CG[oa]] <= i[c(xu)][CG[oa]] || (i[wo] = i[c(Nv)]);
                        return i[wo];
                    })[so](void 0, r[wo], n[CG[da]]) && n[CG[da]] - (function(n, r) {
                        var i = [];
                        i[c(df)] = CG[ko], i[Ru] = n;
                        for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], i[c(Nv)][CG[oa]] > r || i[wo] && i[yb][CG[oa]] <= i[c(xu)][CG[oa]] || (i[wo] = i[c(Nv)]);
                        return i[wo];
                    })[so](void 0, m[Hf], n[CG[da]])[CG[oa]] >= CG[ko];
                })[CG[Kf]] / m[Zf][CG[Kf]] : NaN, m[Rf] = m[e(ql)][CG[Kf]] ? m[c(ql)][CG[fd]](function(n) {
                    return CG[wM]()[PG[re]](n) <= CG[re];
                })[CG[Kf]] / m[kf][CG[Kf]] : NaN, m[Uf] = n[CG[fd]](function(n) {
                    return n[CG[Bc]] === a(f(26350, 26374));
                })[CG[Kf]], m[Sf] = n[CG[fd]](function(n) {
                    return n[CG[Bc]] === a(f(26374, 26402));
                })[CG[Kf]], m[If] = m[Sf] ? m[Uf] / m[Sf] : NaN, m[Wo] = [], m[Go] = [], m[c(EX)] = CG[ko], m[c(bw)] = n;
                for(; m[Bf] < m[Df][CG[Kf]]; m[Bf]++)m[Nb] = m[Df][m[Bf]], m[Nb][CG[AF]] === CG[Nf] && m[c(OX)][CG[Cf]](m[Nb]);
                m[Fu] = CG[ko], m[qf] = r;
                for(; m[Fu] < m[qf][CG[Kf]]; m[Fu]++)m[c(sf)] = m[qf][m[Fu]], m[To][CG[AF]] === CG[Nf] && (m[Nb] = m[Go][CG[Ac]](), m[Nb] && m[c(XX)][CG[Cf]]({
                    Yt: m[Nb][CG[oa]],
                    ue: m[c(sf)][CG[oa]]
                }));
                m[zf] = CG[zO](m[Wo][CG[td]](function(n) {
                    return n[CG[aa]] - n[CG[da]];
                })), m[$f] = n[CG[Kf]] ? m[Wo][CG[Kf]] / n[CG[Kf]] * CG[Fc] : NaN, m[Kf] = [], m[xo] = [], m[Vf] = [], m[Cf] = [], m[Pf] = [], m[Qf] = [], m[Yf] = [], N[xc] = function(n) {
                    var r = [];
                    r[wo] = CG[CO](n[CG[fd]](function(n) {
                        return n >= v && h >= n;
                    }))[CG[fd]](function(n) {
                        return n > CG[ko];
                    }), r[wo][CG[Kf]] && (m[c(Nl)][CG[Cf]][CG[$v]](m[Kf], r[wo]), m[xo][CG[Cf]](r[wo][CG[ko]]), r[c(df)] = CG[SO](r[wo]), r[Ru] = CG[BO](r[c(xu)]), m[Vf][CG[Cf]](r[Au]), m[Cf][CG[Cf]](r[Ru]), m[c(zp)][CG[Cf]](r[Ru] / r[Au]), m[c(jX)][CG[Cf]]((function(n) {
                        var i = [];
                        i[wo] = 1 / 0, i[Au] = CG[Zf];
                        for(; i[Au] <= CG[wv]; i[Au]++)i[wo] = Math[CG[dv]](i[wo], CG[OM](r[Au] - i[Au] * n));
                        return i[wo];
                    })[so](void 0, 16.6667)), m[Yf][CG[e(Ip)]]((function(n) {
                        var i = [];
                        i[wo] = 1 / 0, i[Au] = CG[Zf];
                        for(; i[Au] <= CG[wv]; i[Au]++)i[wo] = Math[CG[dv]](i[wo], CG[OM](r[Au] - i[Au] * n));
                        return i[wo];
                    })[so](void 0, 8.3333)));
                }, m[nv] = CG[ko], m[rv] = Array[CG[dd]](u[CG[Pf]]());
                for(; m[nv] < m[rv][CG[Kf]]; m[e(oF)]++)m[iv] = m[e(gX)][m[c(oF)]], N[xc](m[iv]);
                if (m[Ro] = m[mf][CG[td]](function(n) {
                    return CG[kv] / n;
                })[CG[fd]](function(n) {
                    return Number[CG[rd]](n);
                }), m[tv] = CG[CO](m[c(ba)]), m[Uo] = CG[CO](m[tv]), m[ov] = CG[CO](m[c(Je)]), m[uv] = isFinite(v) && isFinite(h) ? Math[CG[cv]](CG[Zf], h - v) : CG[yd], m[fv] = m[Nf][CG[Kf]] ? m[Nf][CG[Kf]] / (m[uv] / CG[kv]) : NaN, m[vv] = Number[CG[rd]](CG[zO](m[mf])) ? CG[kv] / CG[zO](m[mf]) : NaN, m[ev] = Number[CG[rd]](CG[SO](m[mf])) ? CG[kv] / CG[SO](m[mf]) : NaN, m[e(TX)] = null !== (m[c(xu)] = m[Nf][CG[ko]]) && m[wo] !== void CG[ko] ? m[wo] : NaN, m[dv] = null !== (m[Au] = m[Nf][m[Nf][CG[Kf]] - CG[Zf]]) && m[Au] !== void CG[ko] ? m[Au] : NaN, m[av] = Number[CG[rd]](m[c(TX)]) && Number[CG[rd]](m[dv]) ? m[dv] - m[c(TX)] : NaN, m[lv] = n[CG[td]](function(n, r) {
                    return n[CG[AF]] === CG[yf] ? r : -CG[Zf];
                })[CG[fd]](function(n) {
                    return n >= CG[ko];
                }), m[sv] = m[lv][CG[td]](function(r) {
                    return r > CG[ko] ? n[r][CG[oa]] - n[r - CG[Zf]][CG[oa]] : NaN;
                })[CG[fd]](function(n) {
                    return Number[CG[rd]](n);
                }), m[So] = CG[zO](m[sv]), m[c(hv)] = T[rv][CG[td]](function(n) {
                    return n[CG[oa]];
                })[CG[fd]](function(n) {
                    return n >= v && h >= n;
                })[CG[e(t(f(26402, 26412), Tr))]](function(n, r) {
                    return n - r;
                }), m[yv] = NaN, m[wb][CG[Kf]] && m[Nf][CG[Kf]] && (m[mv] = m[wb][m[wb][CG[Kf]] - CG[Zf]], m[Nf][CG[ko]] < m[mv] || (m[yv] = m[Nf][CG[ko]] - m[c(RM)])), m[bv] = CG[PO](m[mf][CG[iv]](CG[Zf]), m[c(Je)][CG[iv]](CG[ko], -CG[Zf])), m[Io] = CG[PO](m[c(Je)][CG[iv]](CG[Df]), m[c(Je)][CG[iv]](CG[ko], -CG[Df])), m[pv] = CG[PO](m[yf][CG[iv]](CG[Zf]), m[c(He)][CG[iv]](CG[ko], -CG[Zf])), m[Mv] = CG[BO](m[mf]) / CG[SO](m[mf]), m[wv] = CG[$O](m[mf]) / CG[zO](m[mf]), m[Fv] = ((y = [])[wo] = CG[SO](m[c(Je)]), y[Au] = CG[BO](m[mf]), Number[CG[rd]](y[wo]) && Number[CG[rd]](y[e(df)]) && y[wo] + y[Au] !== CG[ko] ? (y[Au] - y[wo]) / (y[Au] + y[wo]) : NaN), m[c(t(f(26412, 26421), Tr))] = CG[zO](m[mf]), m[Xv] = [], m[jv] = [], Number[CG[rd]](m[Ev])) {
                    m[Do] = CG[ko], m[qo] = m[mf];
                    for(; m[Do] < m[qo][CG[Kf]]; m[c(t(f(26421, 26431), Tr))]++)m[Nb] = m[c(t(f(26431, 26441), Tr))][m[Do]], m[mb] = m[Nb] < m[Ev] ? CG[Zf] : CG[ko], m[Bo] ? m[mb] === m[c(ZX)][CG[Qc]] ? m[c(ZX)][CG[va]]++ : ((m[Bo][CG[Qc]] ? m[Xv] : m[jv])[CG[Cf]](m[Bo][CG[va]]), m[c(ZX)] = {
                        state: m[mb],
                        Zt: CG[Zf]
                    }) : m[Bo] = {
                        state: m[mb],
                        Zt: CG[Zf]
                    };
                    m[c(ZX)] && (m[Bo][CG[Qc]] ? m[Xv] : m[jv])[CG[Cf]](m[Bo][CG[va]]);
                }
                m[c(LX)] = CG[SO](m[Xv]), m[gv] = CG[SO](m[jv]), m[Tv] = CG[qO](m[c(t(f(26441, 26451), Tr))], CG[vu]), m[Lv] = CG[qO](m[jv], CG[eu]), m[kv] = CG[hX](m[mf]), m[Jv] = [], m[c(t(f(26451, 26461), Tr))] = [], m[_v] = CG[ko], m[Gv] = CG[ko], m[Zo] = CG[ko];
                for(; m[Zo] < n[CG[Kf]] - CG[Zf]; m[Zo]++)m[xv] = n[m[Zo]], m[Rv] = n[m[Zo] + CG[Zf]], m[e(Ec)] = PG[Sa][m[xv][CG[Bc]]], m[Uv] = PG[Sa][m[Rv][CG[Bc]]], null != m[Eu] && null != m[Uv] && (m[$o] = n[m[Zo] + CG[Zf]][CG[oa]] - n[m[Zo]][CG[oa]], m[Eu] === m[Uv] && m[c(t(f(26461, 26472), Tr))][CG[Cf]](m[$o]), (function(n) {
                    return n > CG[yv] ? CG[Zf] : CG[ko];
                })[so](void 0, m[e(Ec)]) !== (function(n) {
                    return n > CG[yv] ? CG[Zf] : CG[ko];
                })[so](void 0, m[Uv]) && (m[Wv][CG[Cf]](m[e(JO)]), m[_v]++), m[Gv]++);
                m[Sv] = m[c(t(f(26472, 26483), Tr))] ? m[_v] / m[Gv] : NaN, m[Ko] = {
                    alpha: [],
                    le: [],
                    _e: []
                }, m[Zo] = CG[ko];
                for(; m[Zo] < n[CG[Kf]] - CG[Zf]; m[Zo]++)m[Iv] = n[m[Zo] + CG[Zf]][CG[AF]], m[Bv] = n[m[Zo] + CG[Zf]][CG[oa]] - n[m[Zo]][CG[oa]], N[gd] = m[Iv], (function(n) {
                    return !!n && n[CG[Kf]] === CG[Zf] && /[A-Za-z]/[CG[ie]](n);
                })[so](void 0, N[gd]) ? m[c(HX)][CG[qc]][CG[Cf]](m[Bv]) : (N[Td] = m[Iv], (function(n) {
                    return !!n && n[CG[Kf]] === CG[Zf] && /[0-9]/[CG[ie]](n);
                })[so](void 0, N[Td]) ? m[Ko][CG[la]][CG[Cf]](m[c(e(t(f(26483, 26493), Tr)))]) : m[Ko][CG[sa]][CG[Cf]](m[Bv]));
                m[Dv] = CG[zO](m[Ko][CG[qc]]), m[qv] = CG[zO](m[Ko][CG[la]]), m[zv] = CG[zO](m[Ko][CG[sa]]), m[$v] = Number[CG[rd]](m[Dv]) && Number[CG[rd]](m[qv]) ? m[Dv] - m[qv] : NaN, m[Kv] = Number[CG[rd]](m[Dv]) && Number[CG[rd]](m[zv]) ? m[Dv] - m[zv] : NaN, m[Cv] = o[CG[fd]](function(n) {
                    return n[CG[e(hO)]] === CG[Df];
                })[CG[td]](function(n) {
                    return n[CG[oa]];
                })[CG[id]](function(n, r) {
                    return n - r;
                }), m[Qv] = i[CG[fd]](function(n) {
                    return n[CG[vd]] === CG[ko];
                }), m[Yv] = i[CG[fd]](function(n) {
                    return n[CG[vd]] === CG[Zf];
                }), m[re] = [], m[Vo] = CG[ko], m[ie] = m[Qv];
                for(; m[Vo] < m[ie][CG[Kf]]; m[Vo]++)m[te] = m[ie][m[Vo]], m[c(kX)] = CG[tX](m[Vv], m[te][CG[oa]]), m[oe] < CG[ko] || m[c(t(f(26493, 26503), Tr))][CG[oa]] - m[Vv][m[e(kX)]] > T[wo][CG[ld]] || m[re][CG[Cf]](m[te][CG[oa]] - m[Vv][m[c(kX)]]);
                m[ue] = [], m[fe] = CG[ko], m[ve] = m[Yv];
                for(; m[fe] < m[ve][CG[Kf]]; m[fe]++)m[te] = m[ve][m[fe]], m[oe] = CG[tX](m[Vv], m[te][CG[oa]]), m[oe] < CG[ko] || m[te][CG[oa]] - m[Vv][m[oe]] > T[wo][CG[ld]] || m[ue][CG[Cf]](m[te][CG[oa]] - m[Vv][m[oe]]);
                m[ee] = [], m[ce] = CG[ko], m[de] = m[Yv];
                for(; m[ce] < m[e(dw)][CG[Kf]]; m[ce]++)m[te] = m[de][m[ce]], m[oe] = CG[tX](m[Cv], m[te][CG[e(cO)]]), m[oe] < CG[ko] || m[te][CG[oa]] - m[Cv][m[oe]] > T[wo][CG[ld]] || m[ee][CG[Cf]](m[te][CG[e(cO)]] - m[Cv][m[oe]]);
                m[ae] = m[e(JX)][CG[Kf]] ? m[ue][CG[fd]](function(n) {
                    return n >= CG[re] && n <= CG[ha];
                })[CG[Kf]] / m[ue][CG[Kf]] : NaN, m[le] = function() {
                    var n = [];
                    var r = [];
                    if (!m[Nf][CG[Kf]]) return NaN;
                    r[wo] = m[Nf][CG[ko]], r[Au] = m[Nf][m[Nf][CG[Kf]] - CG[Zf]], r[Ru] = Math[CG[cv]](CG[Zf], CG[FM]((r[Au] - r[wo]) / CG[kv])), r[e(Nv)] = Array(r[Ru])[CG[ya]](CG[ko]), r[Du] = CG[ko], r[Iu] = m[Nf];
                    for(; r[c(vf)] < r[Iu][CG[Kf]]; r[Du]++)r[Nb] = r[Iu][r[Du]], r[yb][Math[CG[dv]](r[Ru] - CG[Zf], (n[Nb] = (r[c(Tf)] - r[wo]) / CG[kv], CG[wM]()[PG[ce]](n[Nb])))]++;
                    return r[mb] = CG[SO](r[yb]), r[Su] = CG[IO](r[yb]), Number[CG[rd]](r[mb]) && r[mb] > CG[ko] ? r[Su] / r[mb] : NaN;
                }(), m[se] = function() {
                    var r = [];
                    var i = [];
                    if (i[c(xu)] = h, i[Au] = v, i[Ru] = isFinite(i[Au]) && isFinite(i[wo]) ? Math[CG[cv]](i[Au], i[wo] - T[wo][CG[hd]]) : i[Au], !isFinite(i[Ru]) || !isFinite(i[wo]) || i[wo] <= i[Ru]) return {
                        he: NaN,
                        we: NaN,
                        Ne: NaN,
                        Me: NaN,
                        Se: NaN,
                        slope: NaN,
                        Te: NaN
                    };
                    i[yb] = T[wo][CG[sd]], i[Du] = CG[kv] / i[yb], i[Iu] = CG[FM]((i[wo] - i[Ru]) / i[yb]), i[Nb] = CG[mX](i[e(of)]), i[mb] = Array(i[Nb])[CG[ya]](CG[ko]), i[Su] = Array(i[Nb])[CG[ya]](CG[ko]), i[c(Ze)] = CG[ko], i[To] = n;
                    for(; i[hf] < i[To][CG[Kf]]; i[hf]++)i[yf] = i[c(sf)][i[hf]], i[yf][CG[oa]] >= i[Ru] && i[yf][CG[oa]] < i[wo] && (i[c(Pv)] = Math[CG[dv]](i[Nb] - CG[Zf], CG[GM]((i[e(He)][CG[oa]] - i[Ru]) / i[yb])), i[mb][i[Nf]] += CG[Zf]);
                    if ((function(n, r) {
                        var i = [];
                        i[wo] = n[CG[e(Nl)]], i[Au] = CG[ko], i[Ru] = CG[ko];
                        for(; i[Au] < i[wo]; i[Au]++){
                            i[c(df)] < i[Ru] && (i[yb] = n[i[Au]], n[i[Au]] = n[i[Ru]], n[i[Ru]] = i[yb], i[Du] = r[i[e(df)]], r[i[c(df)]] = r[i[Ru]], r[i[Ru]] = i[Du]), i[Iu] = i[wo] >> CG[Zf];
                            for(; i[Iu] && i[Ru] >= i[Iu];)i[Ru] -= i[Iu], i[Iu] >>= CG[Zf];
                            i[Ru] += i[Iu];
                        }
                        i[Nb] = CG[e(bw)];
                        for(; i[e(Tf)] <= i[wo]; i[Nb] <<= CG[Zf]){
                            i[mb] = -CG[Df] * CG[ZM]() / i[Nb], i[Su] = Math[CG[od]](i[mb]), i[hf] = Math[CG[ud]](i[mb]), i[Au] = CG[ko];
                            for(; i[Au] < i[wo]; i[Au] += i[Nb]){
                                i[To] = CG[Zf], i[yf] = CG[ko], i[Ru] = CG[ko];
                                for(; i[Ru] < i[Nb] / CG[Df]; i[Ru]++)i[Nf] = n[i[Au] + i[Ru]], i[mf] = r[i[Au] + i[c(af)]], i[bf] = n[i[Au] + i[Ru] + i[Nb] / CG[Df]] * i[To] - r[i[Au] + i[Ru] + i[Nb] / CG[Df]] * i[c(He)], i[c(bX)] = n[i[Au] + i[c(af)] + i[Nb] / CG[Df]] * i[yf] + r[i[Au] + i[Ru] + i[Nb] / CG[Df]] * i[To], n[i[Au] + i[Ru]] = i[Nf] + i[bf], r[i[c(df)] + i[e(af)]] = i[mf] + i[pf], n[i[c(df)] + i[Ru] + i[Nb] / CG[Df]] = i[Nf] - i[bf], r[i[c(df)] + i[Ru] + i[Nb] / CG[Df]] = i[mf] - i[pf], i[Zo] = i[To] * i[Su] - i[c(He)] * i[hf], i[yf] = i[To] * i[hf] + i[yf] * i[Su], i[To] = i[Zo];
                            }
                        }
                    })[so](void 0, i[mb], i[Su]), i[mf] = i[mb][CG[td]](function(n, r) {
                        return (n * n + i[Su][r] * i[Su][r]) / i[Nb];
                    }), i[bf] = CG[GM](i[Nb] / CG[Df]), i[pf] = i[mf][CG[iv]](CG[e(fs)], i[bf]), !i[pf][CG[Kf]] || CG[UO](i[pf]) === CG[ko]) return {
                        he: NaN,
                        we: NaN,
                        Ne: NaN,
                        Me: NaN,
                        Se: NaN,
                        slope: NaN,
                        Te: NaN
                    };
                    i[Zo] = CG[ko], i[Lo] = CG[Zf];
                    for(; i[Lo] < i[pf][CG[Kf]]; i[Lo]++)i[pf][i[Lo]] > i[pf][i[Zo]] && (i[e(uf)] = i[c(vl)]);
                    i[Ho] = i[pf][CG[td]](function(n, r) {
                        return (r + CG[e(fs)]) * (i[Du] / i[Nb]);
                    }), i[Mf] = i[c(ne)][i[Zo]], i[wf] = i[pf][i[Zo]], i[Af] = CG[UO](i[pf][CG[td]](function(n, r) {
                        return n * i[Ho][r];
                    })) / CG[UO](i[pf]), i[Ff] = Math[CG[jv]](CG[SO](i[pf][CG[td]](function(n) {
                        return CG[wM]()[PG[ee]](n + 1E-12);
                    }))), i[Ef] = i[Ff] / (CG[SO](i[pf]) || CG[Zf]), i[Of] = i[pf][CG[td]](function(n) {
                        return n / CG[UO](i[pf]);
                    }), i[ko] = -CG[UO](i[Of][CG[td]](function(n) {
                        return n > CG[ko] ? n * CG[wM]()[PG[ve]] * CG[wM]()[PG[ee]](n) : CG[ko];
                    })) / (CG[HM]() * CG[LM](i[pf][CG[Kf]])), i[Xf] = [], i[jf] = [], i[Lo] = CG[ko];
                    for(; i[Lo] < i[Ho][CG[e(Nl)]]; i[c(vl)]++)i[Ho][i[Lo]] < CG[Df] || i[Ho][i[Lo]] > CG[Na] || i[pf][i[Lo]] <= CG[ko] || (i[Xf][CG[Cf]]((r[gf] = i[c(ne)][i[Lo]], (function(n) {
                        return CG[wM]()[PG[ee]](n);
                    })[so](void 0, r[gf]))), i[jf][CG[Cf]]((function(n) {
                        return CG[wM]()[PG[ee]](n);
                    })[so](void 0, i[pf][i[Lo]])));
                    return i[gf] = function() {
                        var n = [];
                        if (i[Xf][CG[Kf]] < CG[Df]) return NaN;
                        n[wo] = CG[SO](i[Xf]), n[Au] = CG[SO](i[jf]), n[Ru] = CG[ko], n[yb] = CG[ko], n[c(vf)] = CG[ko];
                        for(; n[Du] < i[Xf][CG[Kf]]; n[Du]++)n[Ru] += (i[Xf][n[Du]] - n[wo]) * (i[jf][n[Du]] - n[Au]), n[yb] += Math[CG[fv]](i[Xf][n[Du]] - n[wo], CG[Df]);
                        return n[yb] > CG[ko] ? n[Ru] / n[yb] : NaN;
                    }(), i[Zf] = (i[pf][i[Zo] - CG[Zf]] || CG[ko]) + i[pf][i[Zo]] + (i[pf][i[Zo] + CG[Zf]] || CG[ko]), i[Hf] = i[Zf] / CG[UO](i[pf]), {
                        he: i[c(cl)],
                        we: i[c(WX)],
                        Ne: i[Af],
                        Me: i[Ef],
                        Se: i[ko],
                        slope: i[gf],
                        Te: i[Hf]
                    };
                }(), m[he] = CG[rX](m[mf], CG[kv] / CG[ma]), m[ye] = CG[rX](m[e(Je)], CG[kv] / CG[pa]), m[Ne] = CG[rX](m[mf], CG[kv] / d(kX)), m[me] = CG[iX](m[mf], CG[Zf], .02), m[be] = m[c(Je)][CG[td]](function(n) {
                    return (n % CG[Zf] + CG[Zf]) % CG[Zf];
                }), m[pe] = CG[YO](m[be]), m[Me] = CG[yX](m[mf]), m[we] = m[Me][CG[qo]], m[Co] = m[Me][CG[Ma]], m[Ae] = m[Me][l(f(26503, 26511))], m[Fe] = CG[NX](m[c(t(f(26511, 26522), Tr))]), m[Ee] = CG[PO](m[mf][CG[iv]](CG[Zf]), m[mf][CG[iv]](CG[ko], -CG[Zf])), m[Oe] = CG[PO](m[yf][CG[iv]](CG[Zf]), m[yf][CG[iv]](CG[ko], -CG[Zf])), m[Xe] = CG[dX](m[mf]), m[Gw] = function() {
                    var n = [];
                    if (!m[mf][CG[Kf]]) return NaN;
                    n[wo] = Math[CG[cv]](CG[Xv], Math[CG[dv]](CG[Cv], CG[GM](CG[kM](m[mf][CG[Kf]])))), n[Au] = Array[CG[dd]]({
                        length: n[wo] - CG[Zf]
                    }, function(r, i) {
                        return (i + CG[Zf]) / n[wo];
                    })[CG[td]](function(n) {
                        return CG[qO](m[mf], n);
                    }), n[Ru] = Array(n[wo])[CG[ya]](CG[ko]), n[c(Nv)] = CG[ko], n[Du] = m[mf];
                    for(; n[yb] < n[Du][CG[Kf]]; n[yb]++){
                        n[Iu] = n[Du][n[yb]], n[Nb] = CG[ko];
                        for(; n[Nb] < n[Au][CG[Kf]] && n[Iu] > n[Au][n[Nb]];)n[Nb]++;
                        n[Ru][n[Nb]]++;
                    }
                    return n[c(ge)] = m[mf][CG[Kf]], n[Su] = n[Ru][CG[td]](function(r) {
                        return r / n[mb];
                    }), n[hf] = -CG[UO](n[Su][CG[td]](function(n) {
                        return n > CG[ko] ? n * CG[wM]()[PG[ve]] * CG[wM]()[PG[ee]](n) : CG[e(Yl)];
                    })), n[hf] / (CG[wM]()[PG[ve]] * (function(n) {
                        return CG[wM]()[PG[e(_X)]](n);
                    })[so](void 0, n[wo]));
                }(), m[Po] = CG[1358](m[mf], CG[yv]), m[xw] = CG[1358](m[mf], CG[Xv]), m[Te] = function() {
                    var n = [];
                    n[wo] = CG[lX](m[mf], CG[gf]);
                    var i = n[wo];
                    var r = [];
                    if (r[c(of)] = !1, r[c(xu)] = i[CG[Kf]], r[wo] === CG[ko]) return NaN;
                    r[Au] = CG[ko], r[Ru] = CG[Zf], r[c(Nv)] = CG[Zf];
                    for(;;){
                        if (r[Au] + r[Ru] > r[c(xu)]) {
                            r[c(Nv)]++;
                            break;
                        }
                        r[Du] = i[CG[iv]](r[Au], r[c(df)] + r[Ru])[CG[jf]](CG[tu]), r[Nb] = CG[ko];
                        for(; r[Nb] < r[Au]; r[Nb]++)if (r[mb] = i[CG[iv]](r[Nb], r[c(Tf)] + r[Ru])[CG[jf]](CG[tu]), r[Du] === r[c(ge)]) {
                            r[Iu] = !0;
                            break;
                        }
                        if (r[Iu] ? r[Ru]++ : (r[yb]++, r[Au] += r[c(af)], r[Ru] = CG[Zf]), r[Au] + r[Ru] > r[c(xu)]) break;
                    }
                    return r[yb];
                }(), m[Le] = i[CG[fd]](function(n) {
                    return n[CG[vd]] === CG[Zf];
                }), m[ke] = m[e(qw)][CG[fd]](function(n) {
                    return n[CG[we]] && n[CG[we]][CG[ua]](CG[fa]);
                }), m[We] = m[Le][CG[fd]](function(n) {
                    return n[CG[we]] && n[CG[we]][CG[ua]](s(f(26522, 26538)));
                }), m[_e] = m[ke][CG[fd]](function(n) {
                    return n[CG[we]] === CG[ea];
                }), m[Ge] = m[Le][CG[fd]](function(n) {
                    return n[CG[we]] === CG[wa];
                }), m[xe] = m[ke][CG[td]](function(n) {
                    var r = [];
                    return r[wo] = CG[tX](m[Vv], n[CG[oa]]), r[wo] < CG[ko] || n[CG[oa]] - m[Vv][r[wo]] > T[c(xu)][CG[ld]] ? CG[ko] : CG[Zf];
                }), m[Re] = m[ke][CG[fd]](function(n) {
                    var r = [];
                    return r[wo] = CG[tX](m[Vv], n[CG[oa]]), !(r[wo] >= CG[ko] && n[CG[oa]] - m[Vv][r[wo]] <= T[wo][CG[ld]]) && n[CG[we]] !== CG[wa] && n[CG[we]] !== CG[ea];
                }), m[c(cA)] = m[ke][CG[td]](function(r) {
                    var i = [];
                    i[wo] = CG[ko], i[e(df)] = CG[ko], i[Ru] = n;
                    for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], CG[wM]()[PG[re]](r[CG[oa]] - i[e(Nv)][CG[oa]]) > T[wo][CG[ld]] || i[wo]++;
                    return i[wo];
                }), m[c(yE)] = m[ke][CG[td]](function(n) {
                    return n[CG[va]] | CG[ko];
                }), m[Ie] = m[Le][CG[td]](function(n) {
                    return n[CG[we]] === l(f(26538, 26594)) ? CG[Zf] : CG[ko];
                }), m[c(EA)] = [], m[De] = CG[ko], m[c(wh)] = CG[ko], m[ze] = m[Ie];
                for(; m[qe] < m[c(t(f(26594, 26605), Tr))][CG[Kf]]; m[qe]++)m[$e] = m[ze][m[c(wh)]], m[$e] ? m[De]++ : m[De] && (m[Be][CG[e(Ip)]](m[De]), m[De] = CG[ko]);
                return m[De] && m[Be][CG[Cf]](m[c(nO)]), m[Ke] = m[Ko][CG[la]][CG[td]](function(n) {
                    return CG[kv] / n;
                })[CG[fd]](function(n) {
                    return Number[CG[rd]](n);
                }), m[Ve] = CG[CO](m[c(t(f(26605, 26614), Tr))]), m[Ce] = CG[CO](m[Ve]), N[Ta] = function(n) {
                    return Number[CG[rd]](n) ? n : CG[ko];
                }, [
                    (N[wo] = m[c(wX)], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[wo])),
                    n[CG[Kf]],
                    r[CG[Kf]],
                    m[Le][CG[Kf]],
                    i[CG[fd]](function(n) {
                        return n[CG[vd]] === CG[ko];
                    })[CG[Kf]],
                    T[nv][CG[fd]](function(n) {
                        return n[CG[oa]] >= v && n[CG[oa]] <= h && n[CG[vd]] === CG[Zf];
                    })[CG[Kf]],
                    o[CG[fd]](function(n) {
                        return n[CG[vd]] === CG[ko] && n[CG[oa]] >= v && n[CG[oa]] <= h;
                    })[CG[Kf]],
                    (N[Au] = n[CG[Kf]] ? r[CG[Kf]] / n[CG[Kf]] : NaN, Number[CG[rd]](N[Au]) ? N[Au] : CG[ko]),
                    m[Ef],
                    m[Of],
                    m[ko],
                    m[Xf],
                    (N[Ru] = m[c(He)][CG[e(Nl)]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Ru])),
                    (N[yb] = CG[zO](m[yf]), Number[CG[rd]](N[yb]) ? N[yb] : CG[ko]),
                    (N[Du] = CG[$O](m[yf]), Number[CG[rd]](N[Du]) ? N[Du] : CG[ko]),
                    (N[Iu] = CG[SO](m[yf]), Number[CG[rd]](N[Iu]) ? N[Iu] : CG[ko]),
                    (N[Nb] = CG[BO](m[yf]), Number[CG[rd]](N[Nb]) ? N[Nb] : CG[ko]),
                    (N[mb] = CG[e(t(f(26614, 26625), Tr))](m[yf], CG[fu]), Number[CG[rd]](N[mb]) ? N[mb] : CG[ko]),
                    (N[Su] = CG[qO](m[yf], CG[vu]), Number[CG[rd]](N[Su]) ? N[Su] : CG[ko]),
                    (N[hf] = CG[qO](m[yf], CG[eu]), Number[CG[rd]](N[hf]) ? N[hf] : CG[ko]),
                    (N[To] = m[mf][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[To])),
                    (N[yf] = m[Lo], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[yf])),
                    (N[Nf] = m[Ho], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Nf])),
                    (N[mf] = m[Mf], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[mf])),
                    (N[bf] = m[wf], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[bf])),
                    (N[pf] = m[Af], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[pf])),
                    (N[Zo] = m[Ff], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Zo])),
                    (N[Lo] = CG[zO](m[mf]), Number[CG[rd]](N[Lo]) ? N[Lo] : CG[ko]),
                    (N[Ho] = CG[$O](m[c(Je)]), Number[CG[rd]](N[Ho]) ? N[Ho] : CG[ko]),
                    (N[Mf] = CG[BO](m[mf]), Number[CG[rd]](N[Mf]) ? N[Mf] : CG[ko]),
                    (N[wf] = CG[QO](m[c(Je)]), Number[CG[rd]](N[wf]) ? N[wf] : CG[ko]),
                    (N[Af] = CG[YO](m[mf]), Number[CG[rd]](N[Af]) ? N[Af] : CG[ko]),
                    (N[Ff] = m[pf][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Ff])),
                    (N[Ef] = CG[zO](m[pf]), Number[CG[rd]](N[Ef]) ? N[Ef] : CG[ko]),
                    (N[Of] = CG[$O](m[pf]), Number[CG[rd]](N[Of]) ? N[Of] : CG[ko]),
                    (N[ko] = CG[SO](m[pf]), Number[CG[rd]](N[ko]) ? N[ko] : CG[ko]),
                    (N[Xf] = CG[BO](m[c(bX)]), Number[CG[rd]](N[Xf]) ? N[Xf] : CG[ko]),
                    (N[jf] = m[Gf], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[jf])),
                    (N[gf] = m[xf], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[gf])),
                    (N[Zf] = m[Rf], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Zf])),
                    (N[Hf] = m[If], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Hf])),
                    (N[kf] = CG[zO](m[kf]), Number[CG[rd]](N[kf]) ? N[kf] : CG[ko]),
                    (N[Jf] = CG[$O](m[kf]), Number[CG[rd]](N[Jf]) ? N[Jf] : CG[ko]),
                    (N[e(GX)] = m[e(Qs)], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Wf])),
                    (N[Jo] = m[$f], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Jo])),
                    (N[_f] = m[Ro][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[_f])),
                    (N[Gf] = CG[e(xX)](m[Ro]), Number[CG[rd]](N[Gf]) ? N[Gf] : CG[ko]),
                    (N[xf] = CG[SO](m[Ro]), Number[CG[rd]](N[xf]) ? N[xf] : CG[ko]),
                    (N[Rf] = CG[BO](m[Ro]), Number[CG[rd]](N[Rf]) ? N[Rf] : CG[ko]),
                    (N[Uf] = m[tv][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Uf])),
                    (N[Sf] = CG[SO](m[tv]), Number[CG[rd]](N[Sf]) ? N[Sf] : CG[ko]),
                    (N[If] = CG[BO](m[tv]), Number[CG[rd]](N[If]) ? N[If] : CG[ko]),
                    (N[Wo] = m[Uo][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Wo])),
                    (N[Go] = CG[BO](m[Uo]), Number[CG[rd]](N[Go]) ? N[Go] : CG[ko]),
                    (N[Bf] = CG[BO](m[ov]), Number[CG[rd]](N[Bf]) ? N[Bf] : CG[ko]),
                    (N[Df] = m[fv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[e(Yl)];
                    })[so](void 0, N[Df])),
                    (N[Fu] = m[vv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Fu])),
                    (N[qf] = m[ev], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[qf])),
                    (N[zf] = m[cv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[zf])),
                    (N[$f] = m[c(RX)], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[$f])),
                    (N[Kf] = m[av], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Kf])),
                    (N[xo] = m[So], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[xo])),
                    (N[Vf] = m[c(bl)], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Vf])),
                    (N[Cf] = m[bv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Cf])),
                    (N[Pf] = m[Io], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Pf])),
                    (N[Qf] = m[pv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Qf])),
                    (N[Yf] = m[Mv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[e(MX)])),
                    (N[nv] = m[wv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[e(Yl)];
                    })[so](void 0, N[nv])),
                    (N[e(gX)] = m[Fv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[rv])),
                    (N[iv] = m[le], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[iv])),
                    (N[e(ba)] = m[zo], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Ro])),
                    (N[tv] = m[gv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[tv])),
                    (N[Uo] = m[Tv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[e(Yl)];
                    })[so](void 0, N[Uo])),
                    (N[ov] = m[Lv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[ov])),
                    (N[uv] = m[kv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[uv])),
                    (N[fv] = CG[zO](m[Jv]), Number[CG[rd]](N[fv]) ? N[fv] : CG[ko]),
                    (N[vv] = CG[e(xX)](m[Wv]), Number[CG[rd]](N[vv]) ? N[vv] : CG[ko]),
                    (N[ev] = m[Sv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[ev])),
                    (N[cv] = m[Dv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[cv])),
                    (N[dv] = m[qv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void e(xu), N[dv])),
                    (N[av] = m[zv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[av])),
                    (N[lv] = m[$v], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[lv])),
                    (N[sv] = m[Kv], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[sv])),
                    (N[So] = m[Kf][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[So])),
                    (N[wb] = CG[zO](m[Kf]), Number[CG[rd]](N[wb]) ? N[wb] : CG[ko]),
                    (N[yv] = CG[SO](m[Kf]), Number[CG[rd]](N[yv]) ? N[yv] : CG[ko]),
                    (N[e(RM)] = CG[BO](m[Kf]) / CG[SO](m[Kf]), Number[CG[rd]](N[mv]) ? N[mv] : CG[ko]),
                    (N[bv] = CG[zO](m[xo]), Number[CG[rd]](N[bv]) ? N[bv] : CG[ko]),
                    (N[Io] = CG[zO](m[Vf]), Number[CG[rd]](N[Io]) ? N[Io] : CG[ko]),
                    (N[pv] = CG[zO](m[Cf]), Number[CG[e(DO)]](N[pv]) ? N[pv] : CG[ko]),
                    (N[Mv] = CG[zO](m[Pf]), Number[CG[rd]](N[Mv]) ? N[Mv] : CG[ko]),
                    (N[wv] = CG[zO](m[Qf]), Number[CG[rd]](N[wv]) ? N[wv] : CG[ko]),
                    (N[Fv] = CG[zO](m[Yf]), Number[CG[rd]](N[Fv]) ? N[Fv] : CG[e(Yl)]),
                    (N[Ev] = m[re][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Ev])),
                    (N[Xv] = CG[zO](m[re]), Number[CG[rd]](N[Xv]) ? N[Xv] : CG[ko]),
                    (N[jv] = CG[SO](m[re]), Number[CG[rd]](N[jv]) ? N[jv] : CG[ko]),
                    (N[Bo] = CG[BO](m[re]), Number[CG[rd]](N[Bo]) ? N[Bo] : CG[ko]),
                    (N[Do] = m[ue][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Do])),
                    (N[qo] = CG[zO](m[ue]), Number[CG[rd]](N[qo]) ? N[qo] : CG[ko]),
                    (N[zo] = CG[SO](m[ue]), Number[CG[rd]](N[zo]) ? N[zo] : CG[ko]),
                    (N[gv] = CG[BO](m[c(JX)]), Number[CG[rd]](N[gv]) ? N[gv] : CG[ko]),
                    (N[Tv] = m[ee][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Tv])),
                    (N[Lv] = CG[zO](m[ee]), Number[CG[rd]](N[Lv]) ? N[Lv] : CG[ko]),
                    (N[kv] = CG[SO](m[ee]), Number[CG[rd]](N[kv]) ? N[kv] : CG[ko]),
                    (N[Jv] = CG[BO](m[c(_X)]), Number[CG[rd]](N[Jv]) ? N[Jv] : CG[ko]),
                    (N[Wv] = m[ae], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Wv])),
                    (N[_v] = m[se][l(f(26625, 26633))], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[_v])),
                    (N[Gv] = m[se][a("+Q94hQ==")], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Gv])),
                    (N[xv] = m[se][a(f(26633, 26641))], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[xv])),
                    (N[Rv] = m[se][s("2ucy5w==")], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[e(IE)])),
                    (N[Eu] = m[se][l(f(26641, 26649))], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Eu])),
                    (N[Uv] = m[se][s(f(26649, 26665))], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Uv])),
                    (N[$o] = m[se][l(f(26665, 26673))], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[$o])),
                    (N[Sv] = m[he], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[e(mw)])),
                    (N[Ko] = m[ye], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Ko])),
                    (N[Iv] = m[Ne], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Iv])),
                    (N[Bv] = m[me], (function(n) {
                        return Number[CG[e(DO)]](n) ? n : CG[ko];
                    })[so](void 0, N[Bv])),
                    (N[Dv] = m[pe], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Dv])),
                    (N[qv] = CG[sX](m[mf], CG[Fc]), Number[CG[rd]](N[qv]) ? N[qv] : CG[ko]),
                    (N[zv] = m[we], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[zv])),
                    (N[$v] = m[Co], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[$v])),
                    (N[Kv] = m[Fe], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Kv])),
                    (N[Vv] = m[Ee], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Vv])),
                    (N[Cv] = m[Oe], (function(n) {
                        return Number[CG[e(DO)]](n) ? n : CG[ko];
                    })[so](void 0, N[Cv])),
                    (N[Qv] = m[Xe], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Qv])),
                    (N[Yv] = m[Gw], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Yv])),
                    (N[re] = m[Po], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[re])),
                    (N[Vo] = m[e(je)], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Vo])),
                    (N[ie] = m[Te], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[ie])),
                    (N[te] = m[ke][CG[Kf]] / Math[CG[cv]](CG[Zf], m[Le][CG[Kf]]), Number[CG[rd]](N[te]) ? N[te] : CG[ko]),
                    (N[oe] = m[We][CG[Kf]] / Math[CG[cv]](CG[Zf], m[Le][CG[Kf]]), Number[CG[rd]](N[oe]) ? N[oe] : CG[ko]),
                    (N[ue] = m[ke][CG[Kf]] ? m[c(LF)][CG[Kf]] / m[ke][CG[Kf]] : NaN, Number[CG[rd]](N[ue]) ? N[ue] : CG[ko]),
                    (N[fe] = m[ke][CG[Kf]] ? m[_e][CG[Kf]] / m[c(t(f(26673, 26683), Tr))][CG[Kf]] : NaN, Number[CG[rd]](N[fe]) ? N[fe] : CG[ko]),
                    (N[ve] = CG[SO](m[xe]) || CG[ko], Number[CG[rd]](N[ve]) ? N[ve] : CG[ko]),
                    (N[ee] = m[ke][CG[Kf]] ? m[Re][CG[Kf]] / m[ke][CG[Kf]] : CG[ko], Number[CG[rd]](N[ee]) ? N[ee] : CG[ko]),
                    (N[ce] = CG[SO](m[e(cA)]), Number[CG[rd]](N[ce]) ? N[ce] : CG[ko]),
                    (N[de] = CG[BO](m[Ue]), Number[CG[rd]](N[de]) ? N[de] : CG[ko]),
                    (N[ae] = CG[zO](m[c(yE)]), Number[CG[rd]](N[ae]) ? N[ae] : CG[ko]),
                    (N[e(Hv)] = CG[SO](m[Be]), Number[CG[rd]](N[le]) ? N[le] : CG[ko]),
                    (N[se] = CG[qO](m[Be], CG[vu]), Number[CG[rd]](N[se]) ? N[se] : CG[ko]),
                    (N[he] = CG[VO](m[Be]), Number[CG[rd]](N[he]) ? N[he] : CG[ko]),
                    (N[ye] = m[Ke][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[ye])),
                    (N[Ne] = CG[e(xX)](m[Ke]), Number[CG[rd]](N[Ne]) ? N[Ne] : CG[ko]),
                    (N[me] = CG[SO](m[Ke]), Number[CG[rd]](N[me]) ? N[me] : CG[ko]),
                    (N[be] = CG[BO](m[Ke]), Number[CG[rd]](N[be]) ? N[be] : CG[ko]),
                    (N[pe] = m[Ve][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[pe])),
                    (N[Me] = CG[SO](m[Ve]), Number[CG[rd]](N[Me]) ? N[Me] : CG[ko]),
                    (N[we] = CG[BO](m[Ve]), Number[CG[rd]](N[we]) ? N[we] : CG[ko]),
                    (N[Co] = m[Ce][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Co])),
                    (N[Ae] = CG[BO](m[Ce]), Number[CG[rd]](N[Ae]) ? N[Ae] : CG[ko]),
                    (N[Fe] = m[c(HX)][CG[la]][CG[Kf]], (function(n) {
                        return Number[CG[rd]](n) ? n : CG[ko];
                    })[so](void 0, N[Fe])),
                    (N[Ee] = CG[zO](m[Ko][CG[la]]), Number[CG[rd]](N[Ee]) ? N[Ee] : CG[ko]),
                    (N[Oe] = CG[$O](m[Ko][CG[la]]), Number[CG[rd]](N[Oe]) ? N[Oe] : CG[ko]),
                    (N[Xe] = CG[SO](m[Ko][CG[la]]), Number[CG[rd]](N[Xe]) ? N[Xe] : CG[ko]),
                    (N[Gw] = CG[BO](m[Ko][CG[la]]), Number[CG[rd]](N[Gw]) ? N[Gw] : CG[ko]),
                    (N[Po] = CG[KO](m[yf]), Number[CG[rd]](N[Po]) ? N[Po] : CG[ko]),
                    (N[xw] = CG[VO](m[c(He)]), Number[CG[rd]](N[xw]) ? N[xw] : CG[ko])
                ];
            }, T[cv] = new Map, T[c(RX)] = CG[ko], T[av] = Array[CG[dd]](this[CG[ad]][CG[Aa]]());
            for(; T[dv] < T[c(e(110058310))][CG[Kf]]; T[dv]++)T[c(t(f(26683, 26693), Tr))] = T[c(vh)][T[dv]], T[sv] = T[lv][CG[ko]], T[So] = T[lv][CG[Zf]], T[e(TX)][CG[ed]](T[sv], T[So][CG[qv]]());
            if (T[wb] = g[lv](T[uv], T[Pf][CG[iv]]()[CG[id]](function(n, r) {
                return n[CG[oa]] - r[CG[oa]];
            }), T[Qf], T[Yf], T[cv], T[Uo], T[ov]), T[yv] = h(h([], T[wb], !0), [
                g[vv](CG[KO](T[vv])),
                g[vv](CG[SO](T[vv])),
                g[vv](CG[VO](T[vv])),
                g[vv](CG[KO](T[ev])),
                g[vv](CG[SO](T[ev])),
                g[vv](CG[VO](T[c(UX)])),
                (j = [], j[wo] = T[c(wX)][CG[td]](function(n) {
                    return n[CG[oa]];
                }), j[Au] = g[av](j[wo], T[tv][CG[td]](function(n) {
                    return n[CG[oa]];
                })), X = CG[KO](j[Au]), Number[CG[rd]](X) ? X : CG[ko]),
                (O = [], O[wo] = T[uv][CG[td]](function(n) {
                    return n[CG[oa]];
                }), O[Au] = g[av](O[wo], T[tv][CG[td]](function(n) {
                    return n[CG[oa]];
                })), E = CG[SO](O[Au]), Number[CG[rd]](E) ? E : CG[ko]),
                (F = [], F[wo] = T[c(wX)][CG[td]](function(n) {
                    return n[CG[oa]];
                }), F[Au] = g[av](F[c(xu)], T[tv][CG[td]](function(n) {
                    return n[CG[oa]];
                })), A = CG[VO](F[Au]), Number[CG[rd]](A) ? A : CG[ko]),
                (w = [], w[wo] = T[uv][CG[td]](function(n) {
                    return n[CG[oa]];
                }), w[Au] = g[av](w[wo], T[iv][CG[td]](function(n) {
                    return n[CG[oa]];
                })), M = CG[KO](w[Au]), Number[CG[e(DO)]](M) ? M : CG[ko]),
                (p = [], p[wo] = T[uv][CG[td]](function(n) {
                    return n[CG[oa]];
                }), p[Au] = g[av](p[wo], T[iv][CG[td]](function(n) {
                    return n[CG[oa]];
                })), b = CG[SO](p[c(df)]), Number[CG[rd]](b) ? b : CG[ko]),
                (m = [], m[wo] = T[uv][CG[td]](function(n) {
                    return n[CG[oa]];
                }), m[Au] = g[e(vh)](m[wo], T[iv][CG[td]](function(n) {
                    return n[CG[oa]];
                })), N = CG[VO](m[Au]), Number[CG[rd]](N) ? N : CG[ko]),
                (y = [], y[wo] = T[uv][CG[td]](function(n) {
                    return n[CG[oa]];
                }), y[Au] = g[av](y[wo], T[Ro][CG[td]](function(n) {
                    return n[CG[oa]];
                })), v = CG[KO](y[Au]), Number[CG[rd]](v) ? v : CG[ko]),
                (u = [], u[wo] = T[uv][CG[td]](function(n) {
                    return n[CG[oa]];
                }), u[Au] = g[av](u[wo], T[Ro][CG[td]](function(n) {
                    return n[CG[oa]];
                })), o = CG[SO](u[Au]), Number[CG[rd]](o) ? o : CG[ko]),
                (i = [], i[wo] = T[c(wX)][CG[td]](function(n) {
                    return n[CG[oa]];
                }), i[Au] = g[av](i[wo], T[Ro][CG[td]](function(n) {
                    return n[CG[oa]];
                })), r = CG[VO](i[Au]), Number[CG[rd]](r) ? r : CG[ko])
            ], !1), T[mv] = T[Qf][CG[Fa]](function(n) {
                return n[CG[vd]] === CG[Zf] && n[CG[we]] && n[CG[we]][CG[ua]](CG[fa]) && n[CG[va]] === CG[Zf] && n[CG[e(AO)]] === CG[uu];
            }), T[bv] = T[Pf][CG[iv]]()[CG[id]](function(n, r) {
                return n[CG[oa]] - r[CG[oa]];
            }), T[mv]) {
                T[e(SX)] = T[mv][CG[oa]], T[pv] = T[uv][CG[fd]](function(n) {
                    return n[CG[oa]] <= T[Io];
                }), T[Mv] = T[uv][CG[e(IX)]](function(n) {
                    return n[CG[oa]] > T[c(SX)];
                }), T[wv] = T[bv][CG[fd]](function(n) {
                    return n[CG[oa]] <= T[Io];
                }), T[Fv] = T[bv][CG[fd]](function(n) {
                    return n[CG[oa]] > T[Io];
                }), T[Ev] = T[Qf][CG[fd]](function(n) {
                    return n[CG[oa]] <= T[c(SX)];
                }), T[Xv] = T[Qf][CG[fd]](function(n) {
                    return n[CG[oa]] > T[Io];
                }), T[jv] = T[Yf][CG[e(IX)]](function(n) {
                    return n[CG[oa]] <= T[Io];
                }), T[Bo] = T[Yf][CG[fd]](function(n) {
                    return n[CG[oa]] > T[Io];
                }), T[Do] = new Map, T[qo] = new Map, T[c(LX)] = CG[ko], T[gv] = Array[CG[dd]](T[cv][CG[Aa]]());
                for(; T[zo] < T[gv][CG[Kf]]; T[zo]++)T[Tv] = T[gv][T[zo]], T[c(BX)] = T[Tv][CG[ko]], T[Lv] = T[Tv][CG[Zf]], T[Do][CG[ed]](T[c(BX)], T[Lv][CG[fd]](function(n) {
                    return n <= T[Io];
                })), T[qo][CG[ed]](T[sv], T[Lv][CG[fd]](function(n) {
                    return n > T[Io];
                }));
                T[kv] = Math[CG[dv]](null !== (T[Ff] = null === (T[Af] = T[pv][CG[ko]]) || T[Af] === void CG[ko] ? void CG[ko] : T[Af][CG[oa]]) && T[Ff] !== void CG[ko] ? T[Ff] : 1 / 0, null !== (T[c(Ov)] = null === (T[Ef] = T[wv][CG[e(Yl)]]) || T[Ef] === void CG[ko] ? void CG[e(Yl)] : T[Ef][CG[oa]]) && T[Of] !== void CG[ko] ? T[Of] : 1 / 0, null !== (T[Xf] = null === (T[ko] = T[Ev][CG[ko]]) || T[ko] === void CG[ko] ? void CG[ko] : T[ko][CG[oa]]) && T[c(fw)] !== void CG[ko] ? T[Xf] : 1 / 0, null !== (T[gf] = null === (T[jf] = T[jv][CG[ko]]) || T[jf] === void CG[ko] ? void CG[ko] : T[jf][CG[oa]]) && T[gf] !== void CG[ko] ? T[gf] : 1 / 0), T[Jv] = Math[CG[cv]](null !== (T[Hf] = null === (T[Zf] = T[pv][T[pv][CG[e(Nl)]] - CG[Zf]]) || T[Zf] === void CG[ko] ? void CG[ko] : T[Zf][CG[oa]]) && T[Hf] !== void CG[ko] ? T[Hf] : -1 / 0, null !== (T[Jf] = null === (T[kf] = T[c(DX)][T[wv][CG[Kf]] - CG[Zf]]) || T[kf] === void CG[ko] ? void CG[ko] : T[kf][CG[oa]]) && T[Jf] !== void CG[ko] ? T[c(qX)] : -1 / 0, null !== (T[Jo] = null === (T[Wf] = T[Ev][T[Ev][CG[Kf]] - CG[Zf]]) || T[Wf] === void CG[ko] ? void CG[ko] : T[Wf][CG[oa]]) && T[Jo] !== void CG[ko] ? T[Jo] : -1 / 0, null !== (T[Gf] = null === (T[_f] = T[jv][T[jv][CG[e(Nl)]] - CG[Zf]]) || T[_f] === void CG[ko] ? void CG[e(Yl)] : T[_f][CG[oa]]) && T[Gf] !== void CG[ko] ? T[Gf] : -1 / 0), T[Wv] = Math[CG[dv]](null !== (T[Rf] = null === (T[xf] = T[Mv][CG[ko]]) || T[xf] === void CG[ko] ? void CG[ko] : T[xf][CG[oa]]) && T[Rf] !== void CG[ko] ? T[Rf] : 1 / 0, null !== (T[Sf] = null === (T[Uf] = T[Fv][CG[ko]]) || T[Uf] === void CG[ko] ? void CG[ko] : T[c(Mb)][CG[oa]]) && T[Sf] !== void CG[ko] ? T[c(Ts)] : 1 / 0, null !== (T[Wo] = null === (T[If] = T[Xv][CG[ko]]) || T[If] === void CG[ko] ? void CG[ko] : T[If][CG[oa]]) && T[Wo] !== void CG[ko] ? T[Wo] : 1 / 0, null !== (T[Bf] = null === (T[Go] = T[Bo][CG[ko]]) || T[Go] === void CG[ko] ? void CG[ko] : T[Go][CG[oa]]) && T[Bf] !== void CG[ko] ? T[Bf] : 1 / 0), T[_v] = Math[CG[cv]](null !== (T[Fu] = null === (T[Df] = T[Mv][T[Mv][CG[Kf]] - CG[Zf]]) || T[Df] === void CG[ko] ? void CG[ko] : T[Df][CG[oa]]) && T[Fu] !== void CG[ko] ? T[Fu] : -1 / 0, null !== (T[zf] = null === (T[qf] = T[Fv][T[Fv][CG[Kf]] - CG[Zf]]) || T[qf] === void CG[ko] ? void CG[ko] : T[qf][CG[oa]]) && T[zf] !== void CG[ko] ? T[zf] : -1 / 0, null !== (T[Kf] = null === (T[$f] = T[Xv][T[Xv][CG[Kf]] - CG[Zf]]) || T[$f] === void CG[ko] ? void CG[ko] : T[$f][CG[oa]]) && T[Kf] !== void CG[ko] ? T[Kf] : -1 / 0, null !== (T[Vf] = null === (T[xo] = T[Bo][T[Bo][CG[Kf]] - CG[Zf]]) || T[xo] === void CG[ko] ? void CG[ko] : T[xo][CG[oa]]) && T[Vf] !== void CG[ko] ? T[Vf] : -1 / 0), T[Gv] = g[lv](T[pv], T[wv], T[Ev], T[jv], T[Do], T[kv], T[Jv]), T[xv] = g[lv](T[Mv], T[Fv], T[Xv], T[Bo], T[qo], T[Wv], T[_v]), T[yv][CG[Cf]][CG[$v]](T[yv], h(h([], T[Gv], !1), T[xv], !1));
            } else T[Rv] = [], T[Eu] = [], T[Uv] = [], T[$o] = [], T[Sv] = new Map, T[Ko] = g[lv](T[Rv], T[Eu], T[Uv], T[$o], T[Sv], NaN, NaN), T[Iv] = g[lv](T[Rv], T[c(Ec)], T[Uv], T[$o], T[c(mw)], NaN, NaN), T[yv][CG[Cf]][CG[$v]](T[yv], h(h([], T[Ko], !1), T[Iv], !1));
            return n && this[CG[e(t(f(26693, 26700), Tr))]](), T[yv];
        }, n;
    }(), CG[zX] = function(n) {
        PG[Xu] || (PG[Xu] = new PG[Ia], PG[Xu][CG[Id]](n));
    }, CG[$X] = function(n) {
        return n === void CG[ko] && (n = !0), PG[Xu] ? PG[c(t(f(26700, 26710), Tr))][CG[ta]](n) : [];
    }, PG[Ba] = CG[mv], CG[t(f(26710, 26714), Tr)] = function() {
        var n = [];
        var r = [];
        return (function(n) {
            return PG[Md][n];
        })[so](void 0, PG[Yc]) > PG[Ba] && (null !== (r[wo] = (n[wo] = PG[ea][CG[pc]], (function(n) {
            return n[CG[De]] > CG[Zf] ? CG[xM](CG[UM](n[CG[yc]], n[CG[De]] - CG[Zf])) : PG[e(Ec)];
        })[so](void 0, n[wo]))) && r[wo] !== void CG[ko] ? r[wo] : PG[xv]) > PG[c(KX)];
    }, CG[t(f(26714, 26718), Tr)] = function() {
        var n = [];
        return n[wo] = CG[dE](PG[gd]), !!n[wo] && n[wo][CG[$e]] === PG[xv] && n[wo][CG[Ve]] === PG[c(SM)];
    }, CG[t(f(26718, 26722), Tr)] = function() {
        var n = [];
        var r = [];
        return r[wo] = CG[e(t(f(26722, 26732), Tr))](PG[gd]), !!(r[wo] && (n[wo] = r[wo][CG[ze]], (function(n) {
            return !isNaN(n - i(n));
        })[so](void 0, n[wo])) && (n[Au] = r[wo][CG[Ke]], (function(n) {
            return !isNaN(n - i(n));
        })[so](void 0, n[Au]))) && r[wo][CG[ze]] === r[wo][CG[Gc]] && r[wo][CG[Ke]] === r[wo][CG[xc]];
    }, CG[VX] = function() {
        return [
            PG[ia][CG[pc]][CG[De]] > PG[xv],
            CG[CX](PG[Kc]) > PG[xv] || CG[CX](PG[Vc]) > PG[xv] || CG[CX](PG[Cc]) > PG[xv],
            (function(n) {
                return PG[Md][n];
            })[so](void 0, PG[qc]) > PG[xv],
            PG[c(t(f(26732, 26741), Tr))][CG[De]] > PG[xv],
            (function() {
                var n = [];
                return CG[CX](PG[Yc]) > PG[Ba] && (null !== (n[wo] = CG[DE](PG[ea][CG[pc]])) && n[wo] !== void CG[ko] ? n[wo] : PG[xv]) > PG[c(KX)];
            })[so](void 0),
            PG[Zd][CG[De]] > PG[xv],
            PG[Jd][CG[De]] > PG[xv],
            (function() {
                var n = [];
                return n[wo] = CG[dE](PG[gd]), !!n[wo] && n[wo][CG[$e]] === PG[xv] && n[wo][CG[Ve]] === PG[c(SM)];
            })[so](void 0),
            (function() {
                var n = [];
                return n[wo] = CG[dE](PG[gd]), !!(n[wo] && CG[835](n[wo][CG[ze]]) && CG[835](n[wo][CG[Ke]])) && n[wo][CG[ze]] === n[wo][CG[Gc]] && n[wo][CG[Ke]] === n[wo][CG[xc]];
            })[so](void 0),
            (function(n) {
                return PG[Md][n];
            })[so](void 0, PG[rd]) > PG[xv],
            (function(n) {
                return PG[Md][n];
            })[so](void 0, PG[td]) > PG[c(SM)],
            (function(n) {
                return PG[Md][n];
            })[so](void 0, PG[nd]) > PG[c(SM)],
            (function(n) {
                return PG[Md][n];
            })[so](void 0, PG[id]) > PG[xv],
            PG[Ta][CG[$c]],
            !!(function(n) {
                return PG[Ed][n];
            })[so](void 0, PG[Td])
        ];
    }, CG[PX] = function() {
        var n = [];
        return n[wo] = PG[e(MO)][CG[Xc]], n[wo] ? CG[Zf] / n[c(xu)] : null;
    }, CG[QX] = function() {
        var n = [];
        return n[wo] = PG[Ta][CG[Oc]], n[wo] ? CG[Zf] / n[c(xu)] : null;
    }, CG[YX] = function() {
        var n = [];
        return n[wo] = PG[Ta][CG[Xc]], n[Au] = PG[Ta][CG[Oc]], n[wo] && n[Au] ? CG[Zf] / CG[wM]()[PG[oe]](n[wo] * n[wo] + n[Au] * n[e(df)]) : null;
    }, CG[nj] = function() {
        var n;
        var r;
        var i;
        var o;
        var u;
        var v;
        var d;
        var h;
        var y;
        var m;
        var O;
        var X;
        var j;
        var g;
        var T;
        var Z;
        var L;
        var H;
        var k;
        var J;
        var W;
        var _;
        var G;
        var x;
        var R;
        var U;
        var S;
        var I;
        var B;
        var D;
        var q;
        var z;
        var $;
        var K;
        var V = [];
        var C = [];
        var P = [];
        return P[wo] = CG[TF](), P[Au] = P[wo] ? PG[Qd] : PG[Rd], P[Ru] = CG[zE](PG[la][CG[pc]]), P[yb] = CG[$E](PG[la][CG[pc]]), Array[PG[Wo]][CG[bf]][CG[$v]]([
            (C[wo] = PG[Ud][CG[pc]], (function(n) {
                return n[CG[De]] > CG[Zf] ? CG[xM](CG[UM](n[CG[e(t(f(26741, 26752), Tr))]], n[CG[De]] - CG[Zf])) : PG[Eu];
            })[so](void 0, C[wo])),
            (C[Au] = PG[Yd][CG[pc]], (function(n) {
                return n[CG[De]] > CG[Zf] ? CG[xM](CG[UM](n[CG[yc]], n[CG[De]] - CG[Zf])) : PG[Eu];
            })[so](void 0, C[Au])),
            (C[Ru] = PG[c(t(f(26752, 26762), Tr))][CG[pc]], (function(n) {
                return CG[xM](CG[UM](n[CG[ac]], n[CG[De]]));
            })[so](void 0, C[Ru])),
            (C[yb] = PG[va][CG[pc]], (function(n) {
                return CG[xM](CG[UM](n[CG[ac]], n[CG[De]]));
            })[so](void 0, C[yb])),
            (C[Du] = PG[ra][CG[pc]], (function(n) {
                return CG[xM](CG[UM](n[CG[ac]], n[CG[De]]));
            })[so](void 0, C[Du])),
            (C[Iu] = P[Au][CG[pc]], (function(n) {
                return n[CG[De]] > CG[Zf] ? CG[xM](CG[UM](n[CG[yc]], n[CG[De]] - CG[Zf])) : PG[Eu];
            })[so](void 0, C[Iu])),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[ca][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[ca][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[ra][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[ra][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[uu][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[uu][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[fa][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[fa][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[va][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[e(bw)]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[va][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[oa][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[oa][CG[pc]], void 0),
            (C[Nb] = PG[c(t(f(26762, 26772), Tr))][CG[pc]], (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, C[Nb], void 0)),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[ua][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[da][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[da][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[aa][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[aa][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[fu][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[fu][CG[pc]], void 0),
            (function(n) {
                return CG[xM](n[CG[mc]]);
            })[so](void 0, PG[fu][CG[pc]]),
            (function(n) {
                return CG[xM](n[CG[Nc]]);
            })[so](void 0, PG[fu][CG[pc]]),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[eu][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[eu][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[vu][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[vu][CG[pc]], void 0),
            (C[mb] = CG[zE](PG[sa][CG[pc]]), (function(n, r) {
                return CG[OM](n - r);
            })[so](void 0, C[mb], P[Ru])),
            (C[Su] = CG[$E](PG[sa][CG[pc]]), (function(n, r) {
                return CG[OM](n - r);
            })[so](void 0, C[Su], P[yb])),
            (C[hf] = CG[zE](PG[ha][CG[pc]]), (function(n, r) {
                return CG[OM](n - r);
            })[so](void 0, C[hf], P[Ru])),
            (C[To] = CG[$E](PG[ha][CG[pc]]), (function(n, r) {
                return CG[OM](n - r);
            })[so](void 0, C[e(sf)], P[yb])),
            (C[yf] = CG[zE](PG[ya][CG[pc]]), (function(n, r) {
                return CG[OM](n - r);
            })[so](void 0, C[yf], P[Ru])),
            (C[e(Pv)] = CG[$E](PG[ya][CG[pc]]), (function(n, r) {
                return CG[OM](n - r);
            })[so](void 0, C[Nf], P[yb])),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[pa], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[ma], void 0),
            (C[mf] = PG[c(t(f(26772, 26782), Tr))], (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, C[mf], void 0)),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[Ma], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), n[CG[dc]] && CG[xM](CG[XE](n[CG[dc]]), r);
            })[so](void 0, PG[Sd][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), n[CG[dc]] && CG[xM](CG[OE](n[CG[dc]]), r);
            })[so](void 0, PG[Sd][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[Fa], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[Fa], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[Aa], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[e(bw)]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[Aa], void 0),
            (C[bf] = CG[zE](PG[c(rj)][CG[pc]]), (function(n, r) {
                var i = [];
                return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
            })[so](void 0, C[bf], void 0)),
            (C[pf] = CG[$E](PG[ou][CG[pc]]), (function(n, r) {
                var i = [];
                return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
            })[so](void 0, C[pf], void 0)),
            (C[Zo] = CG[PE](PG[Sd][CG[e(zA)]]), (function(n, r) {
                var i = [];
                return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
            })[so](void 0, C[Zo], void 0)),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[Na][CG[pc]], void 0),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
            })[so](void 0, PG[Na][CG[pc]], void 0),
            PG[c(MO)][CG[Wc]],
            PG[Ta][CG[_c]],
            (C[Lo] = w(CG[zE](PG[Id][CG[pc]])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
            })[so](void 0, C[Lo], void 0, void 0)),
            (C[Ho] = w(CG[$E](PG[Id][CG[pc]])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
            })[so](void 0, C[Ho], void 0, void 0)),
            (C[Mf] = w(CG[zE](PG[Bd][CG[pc]])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
            })[so](void 0, C[Mf], void 0, void 0)),
            (C[wf] = w(CG[$E](PG[Bd][CG[pc]])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
            })[so](void 0, C[wf], void 0, void 0)),
            (K = [], K[c(xu)] = F(PG[Id], CG[gf]), null != K[wo] ? K[wo] : ($ = w(CG[CE](PG[Id][CG[pc]])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
            })[so](void 0, $, void 0, void 0))),
            (C[Af] = CG[VE](PG[Id][CG[pc]]), (function(n, r) {
                var i = [];
                return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
            })[so](void 0, C[Af], void 0)),
            (z = [], z[wo] = F(PG[Bd], CG[gf]), null != z[c(xu)] ? z[wo] : (q = w(CG[CE](PG[c(ij)][CG[pc]])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
            })[so](void 0, q, void 0, void 0))),
            (C[Ff] = CG[VE](PG[c(ij)][CG[pc]]), (function(n, r) {
                var i = [];
                return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
            })[so](void 0, C[Ff], void 0)),
            (D = [], D[wo] = F(PG[ou], CG[gf]), null != D[wo] ? D[wo] : (B = w(CG[CE](PG[ou][CG[pc]])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
            })[so](void 0, B, void 0, void 0))),
            (C[Ef] = CG[VE](PG[ou][CG[pc]]), (function(n, r) {
                var i = [];
                return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
            })[so](void 0, C[Ef], void 0)),
            (C[Of] = A(CG[zE](PG[qd][CG[pc]], CG[Xv])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[e(UX)]](n), t[wo] === CG[ko] || t[wo] < i ? CG[e(tj)](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, C[Of], void 0, void 0)),
            (C[ko] = A(CG[$E](PG[qd][CG[pc]], CG[Xv])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, C[ko], void 0, void 0)),
            (C[Xf] = A(CG[zE](PG[zd][CG[pc]], CG[Xv])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, C[Xf], void 0, void 0)),
            (C[jf] = A(CG[$E](PG[zd][CG[pc]], CG[Xv])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, C[jf], void 0, void 0)),
            (I = [], I[wo] = E(PG[qd], CG[Xv]), null != I[wo] ? I[wo] : (S = A(PG[qd][CG[pc]][CG[mc]]), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[e(UX)]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, S, void 0, void 0))),
            (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[$a]), t[wo] = CG[YX](), null != n && t[wo] ? CG[xM](n * t[c(xu)] * i, r) : null !== n && n !== void CG[ko] ? n : null;
            })[so](void 0, PG[qd][CG[pc]][CG[Nc]], void 0, void 0),
            (U = [], U[wo] = E(PG[zd], CG[Xv]), null != U[c(xu)] ? U[wo] : (R = A(PG[zd][CG[pc]][CG[mc]]), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[e(Yl)] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, R, void 0, void 0))),
            (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[$a]), t[wo] = CG[YX](), null != n && t[wo] ? CG[xM](n * t[c(xu)] * i, r) : null !== n && n !== void CG[ko] ? n : null;
            })[so](void 0, PG[zd][CG[pc]][CG[Nc]], void 0, void 0),
            (x = [], x[wo] = E(PG[Dd], CG[Xv]), null != x[wo] ? x[wo] : (G = A(PG[Dd][CG[pc]][CG[mc]]), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, G, void 0, void 0))),
            (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[$a]), t[wo] = CG[YX](), null != n && t[wo] ? CG[xM](n * t[c(xu)] * i, r) : null !== n && n !== void CG[ko] ? n : null;
            })[so](void 0, PG[Dd][CG[pc]][CG[Nc]], void 0, void 0),
            (C[gf] = A(CG[zE](PG[c(Kd)][CG[pc]], CG[Xv])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, C[gf], void 0, void 0)),
            (C[Zf] = A(CG[$E](PG[UE][CG[pc]], CG[Xv])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, C[Zf], void 0, void 0)),
            (C[Hf] = A(CG[zE](PG[Vd][CG[pc]], CG[Xv])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, C[Hf], void 0, void 0)),
            (C[e(ql)] = A(CG[$E](PG[Vd][CG[pc]], CG[Xv])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, C[kf], void 0, void 0)),
            (_ = [], _[c(xu)] = E(PG[UE], CG[Xv]), null != _[wo] ? _[wo] : (W = A(PG[UE][CG[pc]][CG[mc]]), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, W, void 0, void 0))),
            (C[Jf] = PG[c(Kd)][CG[pc]][CG[e(XA)]], (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[$a]), t[wo] = CG[YX](), null != n && t[wo] ? CG[xM](n * t[c(xu)] * i, r) : null !== n && n !== void CG[ko] ? n : null;
            })[so](void 0, C[Jf], void 0, void 0)),
            (J = [], J[wo] = E(PG[Vd], CG[Xv]), null != J[wo] ? J[wo] : (k = A(PG[Vd][CG[pc]][CG[mc]]), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[e(Yl)] || t[e(xu)] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, k, void 0, void 0))),
            (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[$a]), t[wo] = CG[YX](), null != n && t[wo] ? CG[xM](n * t[c(xu)] * i, r) : null !== n && n !== void CG[e(Yl)] ? n : null;
            })[so](void 0, PG[Vd][CG[pc]][CG[Nc]], void 0, void 0),
            (H = [], H[wo] = E(PG[$d], CG[Xv]), null != H[wo] ? H[c(xu)] : (L = A(PG[$d][CG[pc]][CG[mc]]), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
            })[so](void 0, L, void 0, void 0))),
            (function(n, r, i) {
                var o = [];
                return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[e(t(f(26782, 26792), Tr))]), o[wo] = CG[YX](), null != n && o[wo] ? CG[xM](n * o[c(xu)] * i, r) : null !== n && n !== void CG[ko] ? n : null;
            })[so](void 0, PG[$d][CG[pc]][CG[Nc]], void 0, void 0),
            (function(n) {
                return CG[xM](n[CG[ac]]);
            })[so](void 0, PG[Cd][CG[pc]]),
            (function(n) {
                return CG[xM](n[CG[ac]]);
            })[so](void 0, PG[Pd][CG[pc]]),
            (function(n) {
                return CG[xM](n[CG[ac]]);
            })[so](void 0, PG[Sd][CG[pc]]),
            (C[Wf] = CG[Xv], (function(n, r) {
                var i = [];
                return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
            })[so](void 0, PG[Sd][CG[pc]][CG[mc]], C[Wf])),
            (C[Jo] = CG[Xv], (function(n, r) {
                var i = [];
                return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
            })[so](void 0, PG[Sd][CG[pc]][CG[Nc]], C[Jo])),
            (function() {
                var n = [];
                return n[wo] = CG[oj](CG[dE](PG[Od])), n[Au] = CG[oj](CG[dE](PG[Uu])), n[wo] && n[Au] ? n[Au][CG[ko]] - n[wo][CG[ko]] : null;
            })[so](void 0),
            (function() {
                var n = [];
                return n[wo] = CG[oj](CG[dE](PG[Od])), n[Au] = CG[oj](CG[dE](PG[Uu])), n[wo] && n[c(df)] ? n[Au][CG[Zf]] - n[wo][CG[Zf]] : null;
            })[so](void 0),
            (function() {
                var n = [];
                return n[wo] = CG[oj](CG[dE](PG[Od])), n[Au] = CG[oj](CG[dE](PG[Uu])), n[wo] && n[c(df)] ? (n[Ru] = n[c(df)][CG[ko]] - n[wo][CG[ko]], n[yb] = n[Au][CG[Zf]] - n[wo][CG[Zf]], CG[kM](n[Ru] * n[Ru] + n[yb] * n[c(Nv)])) : null;
            })[so](void 0),
            (function() {
                var n = [];
                return n[wo] = CG[oj](CG[dE](PG[Od])), n[Au] = CG[oj](CG[dE](PG[Uu])), n[wo] && n[Au] ? (n[Ru] = n[c(df)][CG[ko]] - n[wo][CG[ko]], n[yb] = n[Au][CG[Zf]] - n[wo][CG[Zf]], n[Du] = CG[_M](n[yb], n[Ru]) * CG[Ce] / CG[ZM](), CG[xM]((n[c(vf)] + CG[Oa]) % CG[Oa], CG[yv])) : null;
            })[so](void 0),
            (function() {
                var n = [];
                return n[wo] = CG[PE](PG[Sd][CG[pc]]), n[Au] = CG[oj](CG[dE](PG[Od])), n[Ru] = CG[oj](CG[dE](PG[Uu])), n[wo] && n[Au] && n[Ru] ? (n[yb] = n[Ru][CG[ko]] - n[Au][CG[ko]], n[Du] = n[Ru][CG[Zf]] - n[c(df)][CG[Zf]], n[Iu] = CG[kM](n[yb] * n[yb] + n[Du] * n[Du]), n[Iu] ? CG[xM](n[Iu] / n[wo], CG[gf]) : null) : null;
            })[so](void 0),
            (function(n) {
                return CG[xM](n[CG[mc]]);
            })[so](void 0, PG[Ud][CG[pc]]),
            (function(n) {
                return CG[xM](n[CG[Nc]]);
            })[so](void 0, PG[Ud][CG[pc]]),
            (function(n, r) {
                return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
            })[so](void 0, PG[Ud][CG[pc]], void 0),
            (C[_f] = w(CG[rO](PG[ou][CG[pc]], CG[Qo], CG[yv])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
            })[so](void 0, C[_f], void 0, void 0)),
            (C[Gf] = w(CG[rO](PG[ou][CG[pc]], CG[fu], CG[yv])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
            })[so](void 0, C[Gf], void 0, void 0)),
            (C[xf] = w(CG[rO](PG[ou][CG[pc]], CG[vu], CG[yv])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
            })[so](void 0, C[xf], void 0, void 0)),
            (C[Rf] = w(CG[rO](PG[ou][CG[pc]], CG[eu], CG[yv])), (function(n, r, i) {
                var t = [];
                return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
            })[so](void 0, C[Rf], void 0, void 0))
        ], [
            (function() {
                var n = [];
                var r = [];
                if (r[wo] = PG[ou], r[Au] = [], !r[wo][CG[bc]] || r[wo][CG[bc]][CG[Kf]] < CG[Xv]) return CG[Ab](CG[Xv], function() {
                    return null;
                });
                r[Ru] = r[wo][CG[bc]], r[yb] = CG[GM](r[Ru][CG[Kf]] / CG[Xv]), r[Du] = CG[ko];
                for(; r[Du] < CG[Xv]; r[Du]++)r[Iu] = r[Ru][CG[iv]](r[Du] * r[e(Nv)], r[Du] === CG[yv] ? r[Ru][CG[Kf]] : (r[Du] + CG[Zf]) * r[yb]), r[Iu][CG[Kf]] ? (r[Nb] = CG[jM]()[CG[$v]](null, r[Iu]), r[Au][CG[Cf]]((n[6] = w(r[Nb], CG[Xv]), n[7] = CG[Xv], (function(n$jscomp$0, r, i$jscomp$0) {
                    var t = [];
                    t[1] = i$jscomp$0;
                    var o = [];
                    o[Au] = t[1];
                    var u = [];
                    if (r === void CG[ko] && (r = CG[gf]), o[Au] === void CG[ko] && (o[Au] = PG[ju]), null == n$jscomp$0) return n$jscomp$0;
                    if (u[c(xu)] = Math[CG[ev]](n$jscomp$0), u[wo] === CG[ko] || u[wo] < o[Au]) {
                        var n = o[Au];
                        var i = r;
                        var f = [];
                        return i === void CG[ko] && (i = CG[yv]), CG[jb](n) && isFinite(n) ? (f[wo] = CG[XM](CG[mv], i), CG[AM](n * f[wo]) / f[wo]) : PG[Eu];
                    }
                    return n$jscomp$0;
                })[so](void 0, n[6], n[7], void 0)))) : r[Au][CG[Cf]](null);
                return r[Au];
            })[so](void 0),
            [
                (function() {
                    var n = [];
                    return null == PG[Ta][CG[Lc]] || null == PG[Ta][CG[Hc]] || null == PG[Ta][CG[kc]] || null == PG[Ta][CG[Jc]] ? null : (n[wo] = PG[Ta][CG[Hc]] - PG[c(MO)][CG[Lc]], w(n[wo]));
                })[so](void 0),
                (function() {
                    var n = [];
                    return null == PG[Ta][CG[Lc]] || null == PG[c(MO)][CG[Hc]] || null == PG[Ta][CG[kc]] || null == PG[Ta][CG[Jc]] ? null : (n[wo] = PG[Ta][CG[Jc]] - PG[Ta][CG[kc]], w(n[wo]));
                })[so](void 0),
                (function() {
                    var n = [];
                    return null == PG[Ta][CG[Lc]] || null == PG[Ta][CG[Hc]] || null == PG[Ta][CG[kc]] || null == PG[e(MO)][CG[Jc]] ? null : (n[wo] = PG[Ta][CG[Hc]] - PG[Ta][CG[Lc]], n[c(df)] = PG[Ta][CG[Jc]] - PG[c(MO)][CG[kc]], n[Ru] = n[c(xu)] * n[Au], n[yb] = CG[YX](), n[e(Nv)] ? CG[xM](n[Ru] * n[yb] * n[yb], CG[gf]) : null);
                })[so](void 0),
                (function() {
                    var n = [];
                    return null == PG[Ta][CG[Lc]] || null == PG[Ta][CG[Hc]] || null == PG[e(MO)][CG[kc]] || null == PG[Ta][CG[Jc]] ? null : (n[wo] = PG[Ta][CG[Hc]] - PG[Ta][CG[Lc]], n[Au] = PG[Ta][CG[Jc]] - PG[c(MO)][CG[kc]], n[Au] === CG[ko] ? null : CG[xM](n[wo] / n[Au], CG[gf]));
                })[so](void 0),
                (C[Uf] = PG[c(uj)][CG[pc]], (function(n) {
                    return CG[xM](CG[UM](n[CG[ac]], n[CG[De]]));
                })[so](void 0, C[Uf])),
                (function(n, r) {
                    return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
                })[so](void 0, PG[Rd][CG[pc]], void 0),
                (C[Sf] = PG[c(uj)][CG[pc]], (function(n) {
                    return CG[xM](n[CG[mc]]);
                })[so](void 0, C[Sf])),
                (function(n) {
                    return CG[xM](n[CG[Nc]]);
                })[so](void 0, PG[Rd][CG[pc]]),
                (C[If] = PG[Sd][CG[pc]], (function(n) {
                    return CG[xM](CG[UM](n[CG[ac]], n[CG[De]]));
                })[so](void 0, C[If])),
                (function(n, r) {
                    return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
                })[so](void 0, PG[Sd][CG[pc]], void 0),
                (C[Wo] = w(CG[qE](PG[Id][CG[pc]])), (function(n, r, i) {
                    var t = [];
                    return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(e(ff))] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
                })[so](void 0, C[Wo], void 0, void 0)),
                (C[Go] = w(CG[qE](PG[Bd][CG[pc]])), (function(n, r, i) {
                    var t = [];
                    return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
                })[so](void 0, C[Go], void 0, void 0)),
                (C[Bf] = w(CG[qE](PG[ou][CG[pc]])), (function(n, r, i) {
                    var t = [];
                    return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
                })[so](void 0, C[Bf], void 0, void 0)),
                (C[Df] = w(CG[QE](PG[Id][CG[pc]])), (function(n, r, i) {
                    var t = [];
                    return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
                })[so](void 0, C[Df], void 0, void 0)),
                (C[e(fj)] = w(CG[QE](PG[c(ij)][CG[pc]])), (function(n, r, i) {
                    var t = [];
                    return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
                })[so](void 0, C[Fu], void 0, void 0)),
                (C[qf] = w(CG[QE](PG[ou][CG[pc]])), (function(n, r, i) {
                    var t = [];
                    return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[ju]), null == n ? n : (t[c(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](i, r) : n);
                })[so](void 0, C[qf], void 0, void 0)),
                (C[zf] = A(CG[qE](PG[$d][CG[pc]])), (function(n, r, i) {
                    var t = [];
                    return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[e(xu)] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
                })[so](void 0, C[zf], void 0, void 0)),
                (C[$f] = A(CG[QE](PG[$d][CG[pc]])), (function(n, r, i) {
                    var t = [];
                    return r === void CG[ko] && (r = CG[Xv]), i === void CG[ko] && (i = PG[su]), null == n ? n : (t[wo] = Math[CG[ev]](n), t[wo] === CG[ko] || t[wo] < i ? CG[xM](n < CG[ko] ? -i : i, r) : n);
                })[so](void e(xu), C[$f], void 0, void 0)),
                (C[Kf] = CG[PE](PG[Sd][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[Kf], void 0)),
                (function() {
                    var n = [];
                    return n[wo] = CG[PE](PG[Sd][CG[e(zA)]]), n[Au] = CG[vj](), null == n[c(xu)] || null == n[Au] || n[Au] === CG[ko] ? null : CG[xM](n[wo] / n[c(df)], CG[yv]);
                })[so](void e(xu)),
                (C[xo] = PG[da][CG[pc]], (function(n) {
                    return CG[xM](CG[UM](n[CG[ac]], n[CG[De]]));
                })[so](void 0, C[xo])),
                (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[Df]), n[CG[De]] > CG[Zf] ? (i[wo] = n[CG[ac]] / n[CG[De]], i[c(df)] = n[CG[lc]] / n[CG[De]] - CG[XM](i[wo], CG[Df]), CG[xM](CG[kM](i[Au]), r)) : PG[Eu];
                })[so](void 0, PG[da][CG[pc]], void 0),
                (C[Vf] = CG[YE](PG[Dd][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[Vf], void 0)),
                (C[Cf] = CG[YE](PG[$d][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[e(xu)] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[Cf], void 0)),
                CG[ej]((function(n) {
                    return n[CG[bc]];
                })[so](void 0, PG[ou])),
                CG[cj]((function(n) {
                    return n[CG[bc]];
                })[so](void 0, PG[ou])),
                (C[Pf] = PG[da][CG[pc]], (function(n) {
                    return CG[xM](CG[UM](n[CG[ac]], n[CG[De]]));
                })[so](void 0, C[Pf])),
                (Z = [], Z[wo] = CG[dj](PG[Ud]), Z[wo] && Z[wo][CG[Kf]] ? (T = CG[Df], (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                })[so](void 0, Z[e(xu)][Z[wo][CG[Kf]] - CG[Zf]], T)) : null),
                (g = [], g[wo] = CG[PE](PG[da][CG[pc]]), g[Au] = CG[PE](PG[Rd][CG[pc]]), g[Au] && null != g[wo] ? (j = CG[yv], (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                })[so](void 0, g[wo] / g[Au], j)) : null),
                (C[Qf] = PG[da][CG[pc]], (function(n) {
                    return CG[xM](CG[UM](n[CG[ac]], n[CG[De]]));
                })[so](void 0, C[Qf])),
                (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[Df]), n[CG[De]] > CG[Zf] ? (i[wo] = n[CG[ac]] / n[CG[De]], i[c(df)] = n[CG[lc]] / n[CG[De]] - CG[XM](i[wo], CG[Df]), CG[xM](CG[e(aj)](i[Au]), r)) : PG[Eu];
                })[so](void 0, PG[da][CG[pc]], void 0),
                CG[lj]((function(n) {
                    return n[CG[bc]];
                })[so](void 0, PG[ou])),
                CG[sj]((C[Yf] = PG[c(t(f(26792, 26803), Tr))], (function(n) {
                    return n[CG[bc]];
                })[so](void 0, C[Yf])), (function(n) {
                    return n[CG[bc]];
                })[so](void 0, PG[Rd])),
                (C[nv] = CG[dj](PG[ou]), (function(n) {
                    var r = [];
                    if (!n || n[CG[Kf]] < CG[yv]) return null;
                    r[wo] = CG[ko], r[Au] = CG[Zf];
                    for(; r[Au] < n[CG[Kf]] - CG[Zf]; r[Au]++)n[r[c(df)]] > n[r[Au] - CG[Zf]] && n[r[Au]] > n[r[Au] + CG[Zf]] && r[wo]++;
                    return r[wo];
                })[so](void 0, C[nv])),
                (C[rv] = CG[dj](PG[c(t(f(26803, 26813), Tr))]), (function(n) {
                    var r = [];
                    if (!n || n[CG[Kf]] < CG[yv]) return null;
                    r[wo] = CG[ko], r[Au] = CG[Zf];
                    for(; r[Au] < n[CG[Kf]] - CG[Zf]; r[Au]++)n[r[c(df)]] > n[r[Au] - CG[Zf]] && n[r[Au]] > n[r[Au] + CG[Zf]] && r[wo]++;
                    return r[wo];
                })[so](void 0, C[rv])),
                (O = CG[dj](PG[Dd]), X = CG[dj](PG[Rd]), (function(n, r) {
                    var i = [];
                    if (!n || !r || n[CG[Kf]] === CG[ko] || r[CG[Kf]] === CG[ko]) return [
                        null,
                        null
                    ];
                    i[wo] = CG[gM](n[CG[Kf]], r[CG[Kf]]), i[Au] = CG[ko], i[Ru] = CG[ko], i[yb] = CG[ko];
                    for(; i[yb] < i[wo]; i[yb]++)i[Du] = r[i[yb]] || CG[ko], i[Iu] = n[i[yb]], i[Iu] > CG[ko] ? i[Au] += i[Du] : i[Iu] < CG[ko] && (i[Ru] += i[Du]);
                    return [
                        CG[xM](i[Au], CG[yv]),
                        CG[xM](i[Ru], CG[yv])
                    ];
                })[so](void 0, O, X))[CG[ko]],
                (y = CG[dj](PG[Dd]), m = CG[dj](PG[Rd]), (function(n, r) {
                    var i = [];
                    if (!n || !r || n[CG[Kf]] === CG[ko] || r[CG[Kf]] === CG[ko]) return [
                        null,
                        null
                    ];
                    i[wo] = CG[gM](n[CG[Kf]], r[CG[Kf]]), i[Au] = CG[ko], i[Ru] = CG[ko], i[yb] = CG[ko];
                    for(; i[yb] < i[wo]; i[yb]++)i[Du] = r[i[yb]] || CG[e(Yl)], i[Iu] = n[i[yb]], i[Iu] > CG[ko] ? i[Au] += i[Du] : i[Iu] < CG[ko] && (i[Ru] += i[Du]);
                    return [
                        CG[xM](i[Au], CG[yv]),
                        CG[xM](i[e(af)], CG[yv])
                    ];
                })[so](void 0, y, m))[CG[Zf]],
                (C[iv] = PG[Rd][CG[pc]], (function(n) {
                    return CG[xM](CG[UM](n[CG[ac]], n[CG[De]]));
                })[so](void 0, C[iv])),
                (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[Df]), n[CG[De]] > CG[Zf] ? (i[wo] = n[CG[ac]] / n[CG[De]], i[c(df)] = n[CG[lc]] / n[CG[De]] - CG[XM](i[wo], CG[Df]), CG[xM](CG[kM](i[Au]), r)) : PG[Eu];
                })[so](void 0, PG[Rd][CG[pc]], void 0)
            ],
            (C[Ro] = CG[hj](CG[dj](PG[ou]), CG[yj]), C[tv] = function(n) {
                return w(n, CG[Xv]);
            }, (function(n, r) {
                var i = [];
                i[wo] = [], i[Au] = CG[ko], i[Ru] = n;
                for(; i[Au] < i[Ru][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[c(df)]], i[wo][CG[Cf]](r(i[yb]));
                return i[wo];
            })[so](void 0, C[Ro], C[tv])),
            (C[Uo] = CG[hj](CG[dj](PG[ou]), CG[Nj]), C[ov] = function(n) {
                return w(n, CG[Xv]);
            }, (function(n, r) {
                var i = [];
                i[wo] = [], i[Au] = CG[ko], i[Ru] = n;
                for(; i[Au] < i[Ru][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[c(df)]], i[wo][CG[Cf]](r(i[yb]));
                return i[wo];
            })[so](void 0, C[Uo], C[ov])),
            (C[uv] = CG[hj](CG[dj](PG[e(rj)]), CG[mj]), C[fv] = function(n) {
                return w(n, CG[Xv]);
            }, (function(n, r) {
                var i = [];
                i[wo] = [], i[Au] = CG[ko], i[Ru] = n;
                for(; i[Au] < i[Ru][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[c(df)]], i[wo][CG[Cf]](r(i[yb]));
                return i[wo];
            })[so](void 0, C[uv], C[fv])),
            (C[vv] = CG[hj](CG[dj](PG[$d]), CG[yj]), C[ev] = function(n) {
                return w(n, CG[Xv]);
            }, (function(n, r) {
                var i = [];
                i[wo] = [], i[Au] = CG[ko], i[Ru] = n;
                for(; i[Au] < i[Ru][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[c(df)]], i[wo][CG[Cf]](r(i[yb]));
                return i[wo];
            })[so](void 0, C[vv], C[ev])),
            (C[cv] = CG[dj](PG[da]), (function(n, r, i) {
                var t = [];
                if (i === void CG[ko] && (i = CG[Xv]), !n || n[CG[Kf]] < i) return CG[Ab](i, function() {
                    return null;
                });
                t[wo] = CG[GM](n[CG[Kf]] / i), t[Au] = [], t[c(af)] = CG[ko];
                for(; t[Ru] < i; t[Ru]++)t[yb] = t[Ru] * t[wo], t[Du] = t[Ru] === i - CG[Zf] ? n[CG[Kf]] : (t[Ru] + CG[Zf]) * t[wo], t[Iu] = n[CG[iv]](t[yb], t[Du]), t[Au][CG[Cf]](t[Iu][CG[Kf]] ? r(t[Iu]) : null);
                return t[Au];
            })[so](void 0, C[cv], CG[e(t(f(26813, 26823), Tr))], void 0)),
            (C[dv] = CG[dj](PG[c(pX)]), (function(n, r, i) {
                var t = [];
                if (i === void CG[ko] && (i = CG[Xv]), !n || n[CG[Kf]] < i) return CG[Ab](i, function() {
                    return null;
                });
                t[wo] = CG[GM](n[CG[Kf]] / i), t[Au] = [], t[c(af)] = CG[ko];
                for(; t[Ru] < i; t[Ru]++)t[yb] = t[Ru] * t[wo], t[Du] = t[Ru] === i - CG[Zf] ? n[CG[Kf]] : (t[Ru] + CG[Zf]) * t[wo], t[Iu] = n[CG[iv]](t[yb], t[Du]), t[Au][CG[Cf]](t[Iu][CG[Kf]] ? r(t[Iu]) : null);
                return t[Au];
            })[so](void 0, C[dv], CG[bj], void 0)),
            (C[av] = CG[dj](PG[Ud]), (function(n, r, i) {
                var t = [];
                if (i === void CG[ko] && (i = CG[Xv]), !n || n[CG[Kf]] < i) return CG[Ab](i, function() {
                    return null;
                });
                t[wo] = CG[GM](n[CG[Kf]] / i), t[Au] = [], t[c(af)] = CG[ko];
                for(; t[Ru] < i; t[Ru]++)t[yb] = t[Ru] * t[wo], t[Du] = t[Ru] === i - CG[Zf] ? n[CG[Kf]] : (t[Ru] + CG[Zf]) * t[wo], t[Iu] = n[CG[iv]](t[yb], t[Du]), t[Au][CG[Cf]](t[Iu][CG[Kf]] ? r(t[Iu]) : null);
                return t[Au];
            })[so](void 0, C[av], CG[Nj], void 0)),
            (C[lv] = CG[dj](PG[Ud]), C[sv] = function(n) {
                var r = [];
                return r[wo] = n[CG[iv]]()[CG[id]](function(n, r) {
                    return n - r;
                }), r[Au] = CG[GM](r[wo][CG[Kf]] / CG[Df]), CG[xM](r[wo][CG[Kf]] % CG[Df] ? r[wo][r[Au]] : (r[wo][r[Au] - CG[Zf]] + r[wo][r[Au]]) / CG[Df], CG[yv]);
            }, (function(n, r, i) {
                var t = [];
                if (i === void CG[ko] && (i = CG[Xv]), !n || n[CG[Kf]] < i) return CG[Ab](i, function() {
                    return null;
                });
                t[wo] = CG[GM](n[CG[Kf]] / i), t[Au] = [], t[c(af)] = CG[ko];
                for(; t[Ru] < i; t[Ru]++)t[yb] = t[Ru] * t[wo], t[Du] = t[Ru] === i - CG[Zf] ? n[CG[Kf]] : (t[Ru] + CG[Zf]) * t[e(xu)], t[Iu] = n[CG[iv]](t[yb], t[Du]), t[Au][CG[Cf]](t[Iu][CG[Kf]] ? r(t[Iu]) : null);
                return t[Au];
            })[so](void 0, C[lv], C[sv], void 0)),
            [
                (C[So] = CG[Xv], (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                })[so](void 0, PG[Cd][CG[pc]][CG[mc]], C[e(pj)])),
                (C[wb] = CG[Xv], (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                })[so](void 0, PG[Cd][CG[pc]][CG[Nc]], C[wb])),
                (h = [], h[wo] = PG[Cd][CG[pc]], h[wo][CG[De]] ? (v = h[wo][CG[ac]] / h[c(xu)][CG[De]], d = CG[e(eA)], (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                })[so](void 0, v, d)) : null),
                (C[yv] = CG[Xv], (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                })[so](void 0, PG[Pd][CG[pc]][CG[mc]], C[yv])),
                (C[mv] = CG[Xv], (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                })[so](void 0, PG[Pd][CG[pc]][CG[Nc]], C[mv])),
                (u = [], u[wo] = PG[Pd][CG[pc]], u[wo][CG[De]] ? (o = CG[Xv], (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                })[so](void 0, u[wo][CG[ac]] / u[wo][CG[De]], o)) : null)
            ],
            [
                N(CG[dj](PG[Dd]), CG[dj](PG[e(uj)])),
                N(CG[dj](PG[$d]), CG[dj](PG[Rd])),
                N(CG[dj](PG[ou]), CG[dj](PG[Rd])),
                (i = [], i[wo] = function() {
                    var n = [];
                    var r = [];
                    if (r[wo] = (function() {
                        var n = [];
                        if (n[Ru] = CG[dj](PG[c(Mj)]), n[yb] = CG[dj](PG[Pd]), n[Du] = CG[dj](PG[c(uj)]), !(n[e(af)] && n[yb] && n[Du] && n[Ru][CG[Kf]] && n[yb][CG[Kf]] && n[c(vf)][CG[Kf]])) return null;
                        n[Iu] = CG[gM](CG[gM](n[Ru][CG[Kf]], n[yb][CG[Kf]]), n[Du][CG[Kf]]), n[Nb] = CG[YX]() || CG[Zf], n[mb] = Array(n[c(of)] + CG[Zf])[CG[ya]](CG[ko]), n[Su] = Array(n[Iu] + CG[Zf])[CG[ya]](CG[ko]), n[hf] = Array(n[Iu] + CG[Zf])[CG[ya]](CG[ko]), n[To] = Array(n[Iu])[CG[ya]](CG[ko]), n[yf] = CG[ko], n[Nf] = CG[ko];
                        for(; n[Nf] < n[Iu]; n[c(Pv)]++)n[mf] = (null !== (n[c(xu)] = n[Ru][n[Nf]]) && n[c(xu)] !== void CG[ko] ? n[wo] : CG[ko]) * n[c(Tf)], n[bf] = (null !== (n[Au] = n[yb][n[Nf]]) && n[Au] !== void CG[ko] ? n[Au] : CG[ko]) * n[c(Tf)], n[mb][n[Nf] + CG[Zf]] = n[mb][n[Nf]] + n[mf], n[Su][n[Nf] + CG[Zf]] = n[c(ef)][n[Nf]] + n[bf], n[pf] = null != n[Du][n[Nf]] && n[Du][n[Nf]] > PG[Da] ? n[e(vf)][n[Nf]] : PG[Da], n[hf][n[Nf] + CG[Zf]] = n[hf][n[Nf]] + n[pf], n[Zo] = CG[kM](n[mf] * n[c(Je)] + n[bf] * n[bf]), n[To][n[Nf]] = n[Zo], n[c(He)] += n[Zo];
                        return {
                            x: n[mb],
                            y: n[c(ef)],
                            Xt: n[hf],
                            s: n[c(sf)],
                            L: n[yf]
                        };
                    })[so](void 0), !r[wo]) return {
                        Eb: null,
                        Oe: null,
                        Be: null,
                        He: null,
                        L: null
                    };
                    if (r[Au] = r[wo][CG[Yo]], r[Ru] = r[wo][CG[nu]], r[yb] = r[wo][CG[cu]], r[c(vf)] = r[Au][CG[Kf]], r[Du] < CG[yv] || r[yb] === CG[ko]) return {
                        Eb: null,
                        Oe: null,
                        Be: null,
                        He: null,
                        L: r[yb]
                    };
                    r[Iu] = CG[ko], r[Nb] = CG[ko], r[c(ge)] = CG[ko], r[Su] = CG[Zf];
                    for(; r[Su] < r[Du] - CG[e(fs)]; r[Su]++)r[hf] = r[Au][r[Su]] - r[c(df)][r[Su] - CG[Zf]], r[To] = r[Ru][r[Su]] - r[Ru][r[Su] - CG[Zf]], r[yf] = r[Au][r[Su] + CG[Zf]] - r[Au][r[Su]], r[Nf] = r[Ru][r[Su] + CG[Zf]] - r[Ru][r[Su]], r[mf] = CG[kM](r[hf] * r[hf] + r[To] * r[c(sf)]), r[c(Zv)] = CG[kM](r[yf] * r[yf] + r[Nf] * r[Nf]), r[mf] !== CG[ko] && r[bf] !== CG[ko] && (r[pf] = r[hf] * r[Nf] - r[To] * r[yf], r[Lo] = r[pf], r[Zo] = r[hf] * r[yf] + r[c(sf)] * r[Nf], r[Ho] = r[mf] * r[bf] * CG[kM](Math[CG[fv]](r[yf] + r[hf], CG[Df]) + Math[CG[fv]](r[Nf] + r[To], CG[Df])), r[Mf] = r[Ho] ? Math[CG[ev]](r[Lo]) / r[Ho] : CG[ko], r[wf] = CG[Qo] * (r[mf] + r[bf]), r[Iu] += r[Mf] * r[Mf] * r[wf], r[Nb] += Math[CG[ev]](r[c(cl)]) * r[c(WX)], r[Af] = CG[_M](r[pf], r[Zo]), r[mb] += Math[CG[ev]](r[Af]));
                    return r[Ff] = r[yb] ? r[c(Nv)] * r[c(of)] : null, {
                        Eb: (n[wo] = CG[gf], (function(n, r) {
                            var i = [];
                            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                        })[so](void 0, r[Iu], n[wo])),
                        Oe: (n[Au] = null !== r[Ff] && r[Ff] !== void CG[ko] ? r[c(e(Ll))] : null, n[Ru] = CG[gf], (function(n, r) {
                            var i = [];
                            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                        })[so](void 0, n[Au], n[Ru])),
                        Be: (n[yb] = CG[gf], (function(n, r) {
                            var i = [];
                            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                        })[so](void 0, r[mb], n[yb])),
                        He: (n[Du] = CG[gf], (function(n, r) {
                            var i = [];
                            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                        })[so](void 0, r[Nb], n[Du])),
                        L: (n[Iu] = CG[gf], (function(n, r) {
                            var i = [];
                            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
                        })[so](void 0, r[yb], n[Iu]))
                    };
                }(), i[e(xu)][a(f(26823, 26831))]),
                (function() {
                    var n = [];
                    if (n[wo] = (function() {
                        var n = [];
                        if (n[Ru] = CG[dj](PG[c(Mj)]), n[yb] = CG[dj](PG[Pd]), n[Du] = CG[dj](PG[c(uj)]), !(n[e(af)] && n[yb] && n[Du] && n[Ru][CG[Kf]] && n[yb][CG[Kf]] && n[c(vf)][CG[Kf]])) return null;
                        n[Iu] = CG[gM](CG[gM](n[Ru][CG[Kf]], n[yb][CG[Kf]]), n[Du][CG[Kf]]), n[Nb] = CG[YX]() || CG[Zf], n[mb] = Array(n[c(of)] + CG[Zf])[CG[ya]](CG[ko]), n[Su] = Array(n[Iu] + CG[Zf])[CG[ya]](CG[ko]), n[hf] = Array(n[Iu] + CG[Zf])[CG[ya]](CG[ko]), n[To] = Array(n[Iu])[CG[ya]](CG[ko]), n[yf] = CG[ko], n[Nf] = CG[ko];
                        for(; n[Nf] < n[Iu]; n[c(Pv)]++)n[mf] = (null !== (n[c(xu)] = n[Ru][n[Nf]]) && n[c(xu)] !== void CG[ko] ? n[wo] : CG[ko]) * n[c(Tf)], n[bf] = (null !== (n[Au] = n[yb][n[Nf]]) && n[Au] !== void CG[ko] ? n[Au] : CG[ko]) * n[c(Tf)], n[mb][n[Nf] + CG[Zf]] = n[mb][n[Nf]] + n[mf], n[Su][n[Nf] + CG[Zf]] = n[c(ef)][n[Nf]] + n[bf], n[pf] = null != n[Du][n[Nf]] && n[Du][n[Nf]] > PG[Da] ? n[e(vf)][n[Nf]] : PG[Da], n[hf][n[Nf] + CG[Zf]] = n[hf][n[Nf]] + n[pf], n[Zo] = CG[kM](n[mf] * n[c(Je)] + n[bf] * n[bf]), n[To][n[Nf]] = n[Zo], n[c(He)] += n[Zo];
                        return {
                            x: n[mb],
                            y: n[c(ef)],
                            Xt: n[hf],
                            s: n[c(sf)],
                            L: n[yf]
                        };
                    })[so](void 0), !n[wo]) return {
                        Eb: null,
                        Oe: null,
                        Be: null,
                        He: null,
                        L: null
                    };
                    if (n[Au] = n[wo][CG[Yo]], n[Ru] = n[wo][CG[nu]], n[yb] = n[wo][CG[cu]], n[c(vf)] = n[Au][CG[Kf]], n[Du] < CG[yv] || n[yb] === CG[ko]) return {
                        Eb: null,
                        Oe: null,
                        Be: null,
                        He: null,
                        L: n[yb]
                    };
                    n[Iu] = CG[ko], n[Nb] = CG[ko], n[c(ge)] = CG[ko], n[Su] = CG[Zf];
                    for(; n[Su] < n[Du] - CG[Zf]; n[Su]++)n[hf] = n[Au][n[Su]] - n[c(df)][n[e(ef)] - CG[e(fs)]], n[To] = n[Ru][n[Su]] - n[Ru][n[Su] - CG[Zf]], n[yf] = n[Au][n[Su] + CG[Zf]] - n[Au][n[Su]], n[Nf] = n[Ru][n[Su] + CG[Zf]] - n[Ru][n[Su]], n[mf] = CG[kM](n[hf] * n[hf] + n[To] * n[c(sf)]), n[c(Zv)] = CG[kM](n[yf] * n[yf] + n[Nf] * n[Nf]), n[mf] !== CG[ko] && n[bf] !== CG[ko] && (n[pf] = n[hf] * n[Nf] - n[To] * n[yf], n[Lo] = n[pf], n[Zo] = n[hf] * n[yf] + n[c(sf)] * n[Nf], n[Ho] = n[mf] * n[bf] * CG[kM](Math[CG[fv]](n[yf] + n[hf], CG[Df]) + Math[CG[fv]](n[Nf] + n[e(sf)], CG[Df])), n[Mf] = n[Ho] ? Math[CG[ev]](n[Lo]) / n[Ho] : CG[ko], n[wf] = CG[Qo] * (n[mf] + n[bf]), n[Iu] += n[Mf] * n[Mf] * n[wf], n[Nb] += Math[CG[ev]](n[c(cl)]) * n[c(WX)], n[Af] = CG[_M](n[pf], n[Zo]), n[mb] += Math[CG[ev]](n[Af]));
                    return n[Ff] = n[yb] ? n[c(Nv)] * n[c(of)] : null, {
                        Eb: CG[xM](n[Iu], CG[gf]),
                        Oe: CG[xM](null !== n[Ff] && n[Ff] !== void CG[ko] ? n[c(wj)] : null, CG[gf]),
                        Be: CG[xM](n[mb], CG[gf]),
                        He: CG[xM](n[e(Tf)], CG[gf]),
                        L: CG[xM](n[yb], CG[gf])
                    };
                })[so](void 0)[s(f(26831, 26839))],
                (function() {
                    var n = [];
                    if (n[wo] = (function() {
                        var n = [];
                        if (n[Ru] = CG[dj](PG[c(Mj)]), n[yb] = CG[dj](PG[Pd]), n[Du] = CG[dj](PG[c(uj)]), !(n[e(af)] && n[yb] && n[Du] && n[Ru][CG[Kf]] && n[yb][CG[Kf]] && n[c(vf)][CG[Kf]])) return null;
                        n[Iu] = CG[gM](CG[gM](n[Ru][CG[Kf]], n[yb][CG[Kf]]), n[Du][CG[Kf]]), n[Nb] = CG[YX]() || CG[Zf], n[mb] = Array(n[c(of)] + CG[Zf])[CG[ya]](CG[ko]), n[Su] = Array(n[Iu] + CG[Zf])[CG[ya]](CG[ko]), n[hf] = Array(n[Iu] + CG[Zf])[CG[ya]](CG[ko]), n[To] = Array(n[Iu])[CG[ya]](CG[ko]), n[yf] = CG[ko], n[Nf] = CG[ko];
                        for(; n[Nf] < n[Iu]; n[c(Pv)]++)n[mf] = (null !== (n[c(xu)] = n[Ru][n[Nf]]) && n[c(xu)] !== void CG[ko] ? n[wo] : CG[ko]) * n[c(Tf)], n[bf] = (null !== (n[Au] = n[yb][n[Nf]]) && n[Au] !== void CG[ko] ? n[Au] : CG[ko]) * n[c(Tf)], n[mb][n[Nf] + CG[Zf]] = n[mb][n[Nf]] + n[mf], n[Su][n[Nf] + CG[Zf]] = n[c(ef)][n[Nf]] + n[bf], n[pf] = null != n[Du][n[Nf]] && n[Du][n[Nf]] > PG[Da] ? n[e(vf)][n[Nf]] : PG[Da], n[hf][n[Nf] + CG[Zf]] = n[hf][n[Nf]] + n[pf], n[Zo] = CG[kM](n[mf] * n[c(Je)] + n[bf] * n[bf]), n[To][n[Nf]] = n[Zo], n[c(He)] += n[Zo];
                        return {
                            x: n[mb],
                            y: n[c(ef)],
                            Xt: n[hf],
                            s: n[c(sf)],
                            L: n[yf]
                        };
                    })[so](void 0), !n[wo]) return {
                        Eb: null,
                        Oe: null,
                        Be: null,
                        He: null,
                        L: null
                    };
                    if (n[Au] = n[wo][CG[Yo]], n[Ru] = n[wo][CG[nu]], n[yb] = n[wo][CG[cu]], n[c(vf)] = n[Au][CG[Kf]], n[Du] < CG[e(bl)] || n[yb] === CG[ko]) return {
                        Eb: null,
                        Oe: null,
                        Be: null,
                        He: null,
                        L: n[yb]
                    };
                    n[Iu] = CG[ko], n[Nb] = CG[ko], n[c(e(t(f(26839, 26848), Tr)))] = CG[ko], n[Su] = CG[Zf];
                    for(; n[Su] < n[Du] - CG[Zf]; n[Su]++)n[hf] = n[Au][n[Su]] - n[c(df)][n[Su] - CG[Zf]], n[To] = n[Ru][n[Su]] - n[Ru][n[Su] - CG[Zf]], n[yf] = n[Au][n[Su] + CG[Zf]] - n[Au][n[Su]], n[Nf] = n[e(af)][n[Su] + CG[Zf]] - n[Ru][n[Su]], n[mf] = CG[kM](n[hf] * n[hf] + n[To] * n[c(sf)]), n[c(Zv)] = CG[kM](n[yf] * n[yf] + n[Nf] * n[Nf]), n[mf] !== CG[ko] && n[bf] !== CG[ko] && (n[pf] = n[hf] * n[Nf] - n[To] * n[yf], n[Lo] = n[pf], n[Zo] = n[hf] * n[yf] + n[c(sf)] * n[Nf], n[Ho] = n[e(Je)] * n[bf] * CG[kM](Math[CG[fv]](n[yf] + n[hf], CG[Df]) + Math[CG[fv]](n[Nf] + n[To], CG[Df])), n[Mf] = n[Ho] ? Math[CG[ev]](n[Lo]) / n[Ho] : CG[ko], n[wf] = CG[Qo] * (n[mf] + n[bf]), n[Iu] += n[Mf] * n[Mf] * n[wf], n[Nb] += Math[CG[ev]](n[c(cl)]) * n[c(WX)], n[Af] = CG[_M](n[pf], n[Zo]), n[mb] += Math[CG[ev]](n[Af]));
                    return n[Ff] = n[yb] ? n[c(Nv)] * n[c(of)] : null, {
                        Eb: CG[xM](n[Iu], CG[gf]),
                        Oe: CG[xM](null !== n[Ff] && n[Ff] !== void CG[ko] ? n[c(wj)] : null, CG[gf]),
                        Be: CG[xM](n[mb], CG[gf]),
                        He: CG[xM](n[Nb], CG[gf]),
                        L: CG[xM](n[yb], CG[gf])
                    };
                })[so](void 0)[l(f(26848, 26856))],
                (function() {
                    var n = [];
                    if (n[wo] = (function() {
                        var n = [];
                        if (n[Ru] = CG[dj](PG[c(Mj)]), n[yb] = CG[dj](PG[Pd]), n[Du] = CG[dj](PG[c(uj)]), !(n[e(af)] && n[yb] && n[Du] && n[Ru][CG[Kf]] && n[yb][CG[Kf]] && n[c(vf)][CG[Kf]])) return null;
                        n[Iu] = CG[gM](CG[gM](n[Ru][CG[Kf]], n[yb][CG[Kf]]), n[Du][CG[Kf]]), n[Nb] = CG[YX]() || CG[Zf], n[mb] = Array(n[c(of)] + CG[Zf])[CG[ya]](CG[ko]), n[Su] = Array(n[Iu] + CG[Zf])[CG[ya]](CG[ko]), n[hf] = Array(n[Iu] + CG[Zf])[CG[ya]](CG[ko]), n[To] = Array(n[Iu])[CG[ya]](CG[ko]), n[yf] = CG[ko], n[Nf] = CG[ko];
                        for(; n[Nf] < n[Iu]; n[c(Pv)]++)n[mf] = (null !== (n[c(xu)] = n[Ru][n[Nf]]) && n[c(xu)] !== void CG[ko] ? n[wo] : CG[ko]) * n[c(Tf)], n[bf] = (null !== (n[Au] = n[yb][n[Nf]]) && n[Au] !== void CG[ko] ? n[Au] : CG[ko]) * n[c(Tf)], n[mb][n[Nf] + CG[Zf]] = n[mb][n[Nf]] + n[mf], n[Su][n[Nf] + CG[Zf]] = n[c(ef)][n[Nf]] + n[bf], n[pf] = null != n[Du][n[Nf]] && n[Du][n[Nf]] > PG[Da] ? n[e(vf)][n[Nf]] : PG[Da], n[hf][n[Nf] + CG[Zf]] = n[hf][n[Nf]] + n[pf], n[Zo] = CG[kM](n[mf] * n[c(Je)] + n[bf] * n[bf]), n[To][n[Nf]] = n[Zo], n[c(He)] += n[Zo];
                        return {
                            x: n[mb],
                            y: n[c(ef)],
                            Xt: n[hf],
                            s: n[c(sf)],
                            L: n[yf]
                        };
                    })[so](void 0), !n[wo]) return {
                        Eb: null,
                        Oe: null,
                        Be: null,
                        He: null,
                        L: null
                    };
                    if (n[Au] = n[wo][CG[Yo]], n[Ru] = n[wo][CG[nu]], n[yb] = n[wo][CG[cu]], n[c(vf)] = n[Au][CG[Kf]], n[Du] < CG[yv] || n[yb] === CG[ko]) return {
                        Eb: null,
                        Oe: null,
                        Be: null,
                        He: null,
                        L: n[yb]
                    };
                    n[Iu] = CG[ko], n[Nb] = CG[ko], n[c(ge)] = CG[ko], n[Su] = CG[Zf];
                    for(; n[Su] < n[Du] - CG[Zf]; n[Su]++)n[hf] = n[Au][n[Su]] - n[c(df)][n[Su] - CG[Zf]], n[To] = n[Ru][n[Su]] - n[e(af)][n[Su] - CG[Zf]], n[yf] = n[Au][n[Su] + CG[Zf]] - n[Au][n[Su]], n[Nf] = n[Ru][n[Su] + CG[Zf]] - n[Ru][n[Su]], n[mf] = CG[kM](n[hf] * n[hf] + n[To] * n[c(sf)]), n[c(Zv)] = CG[kM](n[yf] * n[yf] + n[Nf] * n[Nf]), n[e(Je)] !== CG[ko] && n[bf] !== CG[ko] && (n[pf] = n[hf] * n[Nf] - n[To] * n[yf], n[Lo] = n[pf], n[Zo] = n[hf] * n[yf] + n[c(e(t(f(26856, 26865), Tr)))] * n[Nf], n[Ho] = n[mf] * n[e(Zv)] * CG[kM](Math[CG[fv]](n[yf] + n[hf], CG[Df]) + Math[CG[fv]](n[Nf] + n[To], CG[Df])), n[Mf] = n[Ho] ? Math[CG[ev]](n[Lo]) / n[Ho] : CG[ko], n[wf] = CG[Qo] * (n[mf] + n[bf]), n[Iu] += n[Mf] * n[Mf] * n[wf], n[Nb] += Math[CG[ev]](n[c(cl)]) * n[c(WX)], n[Af] = CG[_M](n[pf], n[Zo]), n[mb] += Math[CG[ev]](n[Af]));
                    return n[Ff] = n[yb] ? n[c(Nv)] * n[c(of)] : null, {
                        Eb: CG[xM](n[Iu], CG[gf]),
                        Oe: CG[xM](null !== n[Ff] && n[Ff] !== void CG[ko] ? n[c(wj)] : null, CG[gf]),
                        Be: CG[xM](n[mb], CG[gf]),
                        He: CG[xM](n[Nb], CG[gf]),
                        L: CG[xM](n[yb], CG[gf])
                    };
                })[so](void 0)[s(f(26865, 26873))],
                (function() {
                    var n = [];
                    if (n[wo] = (function() {
                        var n = [];
                        if (n[Ru] = CG[dj](PG[c(Mj)]), n[yb] = CG[dj](PG[Pd]), n[Du] = CG[dj](PG[c(uj)]), !(n[e(af)] && n[yb] && n[Du] && n[Ru][CG[Kf]] && n[yb][CG[Kf]] && n[c(vf)][CG[Kf]])) return null;
                        n[Iu] = CG[gM](CG[gM](n[Ru][CG[Kf]], n[yb][CG[Kf]]), n[Du][CG[Kf]]), n[Nb] = CG[YX]() || CG[Zf], n[mb] = Array(n[c(of)] + CG[Zf])[CG[ya]](CG[ko]), n[Su] = Array(n[Iu] + CG[Zf])[CG[ya]](CG[ko]), n[hf] = Array(n[Iu] + CG[Zf])[CG[ya]](CG[ko]), n[To] = Array(n[Iu])[CG[ya]](CG[ko]), n[yf] = CG[ko], n[Nf] = CG[ko];
                        for(; n[Nf] < n[Iu]; n[c(Pv)]++)n[mf] = (null !== (n[c(xu)] = n[Ru][n[Nf]]) && n[c(xu)] !== void CG[ko] ? n[wo] : CG[ko]) * n[c(Tf)], n[bf] = (null !== (n[Au] = n[yb][n[Nf]]) && n[Au] !== void CG[ko] ? n[Au] : CG[ko]) * n[c(Tf)], n[mb][n[Nf] + CG[Zf]] = n[mb][n[Nf]] + n[mf], n[Su][n[Nf] + CG[Zf]] = n[c(ef)][n[Nf]] + n[bf], n[pf] = null != n[Du][n[Nf]] && n[Du][n[Nf]] > PG[Da] ? n[e(vf)][n[Nf]] : PG[Da], n[hf][n[Nf] + CG[Zf]] = n[hf][n[Nf]] + n[pf], n[Zo] = CG[kM](n[mf] * n[c(Je)] + n[bf] * n[bf]), n[To][n[Nf]] = n[Zo], n[c(He)] += n[Zo];
                        return {
                            x: n[mb],
                            y: n[c(ef)],
                            Xt: n[hf],
                            s: n[c(sf)],
                            L: n[yf]
                        };
                    })[so](void 0), !n[wo]) return {
                        Eb: null,
                        Oe: null,
                        Be: null,
                        He: null,
                        L: null
                    };
                    if (n[Au] = n[wo][CG[Yo]], n[Ru] = n[wo][CG[nu]], n[yb] = n[wo][CG[cu]], n[c(vf)] = n[Au][CG[Kf]], n[Du] < CG[yv] || n[yb] === CG[ko]) return {
                        Eb: null,
                        Oe: null,
                        Be: null,
                        He: null,
                        L: n[yb]
                    };
                    n[Iu] = CG[ko], n[Nb] = CG[ko], n[c(ge)] = CG[ko], n[Su] = CG[Zf];
                    for(; n[Su] < n[Du] - CG[Zf]; n[Su]++)n[hf] = n[Au][n[Su]] - n[c(df)][n[Su] - CG[Zf]], n[To] = n[Ru][n[Su]] - n[Ru][n[Su] - CG[Zf]], n[yf] = n[Au][n[Su] + CG[Zf]] - n[Au][n[Su]], n[Nf] = n[Ru][n[Su] + CG[Zf]] - n[Ru][n[Su]], n[mf] = CG[kM](n[hf] * n[hf] + n[To] * n[c(sf)]), n[c(Zv)] = CG[kM](n[yf] * n[yf] + n[Nf] * n[Nf]), n[mf] !== CG[ko] && n[bf] !== CG[ko] && (n[pf] = n[hf] * n[Nf] - n[To] * n[yf], n[Lo] = n[pf], n[Zo] = n[hf] * n[yf] + n[c(sf)] * n[Nf], n[Ho] = n[mf] * n[bf] * CG[kM](Math[CG[fv]](n[yf] + n[hf], CG[Df]) + Math[CG[fv]](n[Nf] + n[To], CG[Df])), n[Mf] = n[Ho] ? Math[CG[ev]](n[Lo]) / n[Ho] : CG[ko], n[wf] = CG[Qo] * (n[mf] + n[bf]), n[Iu] += n[Mf] * n[Mf] * n[wf], n[Nb] += Math[CG[ev]](n[c(cl)]) * n[c(WX)], n[Af] = CG[_M](n[pf], n[Zo]), n[mb] += Math[CG[ev]](n[Af]));
                    return n[Ff] = n[yb] ? n[c(e(Aj))] * n[c(of)] : null, {
                        Eb: CG[xM](n[Iu], CG[gf]),
                        Oe: CG[xM](null !== n[Ff] && n[Ff] !== void CG[ko] ? n[c(wj)] : null, CG[gf]),
                        Be: CG[xM](n[mb], CG[gf]),
                        He: CG[xM](n[Nb], CG[gf]),
                        L: CG[xM](n[yb], CG[gf])
                    };
                })[so](void 0)[CG[cu]],
                (r = [], r[c(xu)] = b(), r[wo] ? r[wo][CG[zc]] : null),
                (n = [], n[wo] = b(), n[wo] ? n[wo][CG[Ma]] : null),
                (C[bv] = (V[0] = p(CG[Df]), V[1] = CG[Ea], (function(n, r, i$jscomp$0) {
                    var t = [];
                    t[0] = i$jscomp$0;
                    var o = [];
                    if (o[wo] = t[0], r === void CG[ko] && (r = CG[kv]), o[wo] === void CG[ko] && (o[wo] = CG[yv]), null == n) return null;
                    var i = n * r;
                    var t$jscomp$0 = o[wo];
                    var u = [];
                    return t$jscomp$0 === void CG[ko] && (t$jscomp$0 = CG[yv]), CG[jb](i) && isFinite(i) ? (u[wo] = CG[XM](CG[mv], t$jscomp$0), CG[AM](i * u[wo]) / u[e(xu)]) : PG[Eu];
                })[so](void 0, V[0], V[1], void 0)), (function(n, r) {
                    return r === void CG[ko] && (r = PG[za]), null == n ? null : n > CG[e(Yl)] && r > n ? CG[xM](r, CG[Xv]) : n;
                })[so](void 0, C[bv], void 0)),
                (C[Io] = (V[2] = p(CG[yv]), V[3] = CG[Ea], (function(n, r, i$jscomp$0) {
                    var t = [];
                    t[0] = i$jscomp$0;
                    var o = [];
                    if (o[wo] = t[0], r === void CG[ko] && (r = CG[kv]), o[wo] === void CG[ko] && (o[wo] = CG[yv]), null == n) return null;
                    var i = n * r;
                    var t$jscomp$0 = o[wo];
                    var u = [];
                    return t$jscomp$0 === void CG[ko] && (t$jscomp$0 = CG[yv]), CG[jb](i) && isFinite(i) ? (u[wo] = CG[XM](CG[mv], t$jscomp$0), CG[AM](i * u[wo]) / u[e(xu)]) : PG[Eu];
                })[so](void 0, V[2], V[3], void 0)), (function(n, r) {
                    return r === void CG[ko] && (r = PG[za]), null == n ? null : n > CG[ko] && r > n ? CG[xM](r, CG[Xv]) : n;
                })[so](void 0, C[Io], void 0)),
                (C[pv] = (V[4] = M(), (function(n, r, i$jscomp$0) {
                    var t = [];
                    t[0] = i$jscomp$0;
                    var o = [];
                    if (o[wo] = t[0], r === void CG[ko] && (r = CG[kv]), o[wo] === void CG[ko] && (o[wo] = CG[yv]), null == n) return null;
                    var i = n * r;
                    var t$jscomp$0 = o[wo];
                    var u = [];
                    return t$jscomp$0 === void CG[ko] && (t$jscomp$0 = CG[yv]), CG[jb](i) && isFinite(i) ? (u[wo] = CG[XM](CG[mv], t$jscomp$0), CG[AM](i * u[wo]) / u[e(xu)]) : PG[Eu];
                })[so](void 0, V[4], void 0, void 0)), (function(n, r) {
                    return r === void CG[ko] && (r = PG[za]), null == n ? null : n > CG[ko] && r > n ? CG[xM](r, CG[e(eA)]) : n;
                })[so](void 0, C[pv], void 0)),
                (function() {
                    var n = [];
                    return n[Au] = null === (n[wo] = PG[Ta][CG[Zc]]) || n[wo] === void CG[ko] ? void CG[ko] : n[wo][CG[qv]](), n[Au] && n[Au][CG[Kf]] ? n[Au][CG[Kf]] : null;
                })[so](void 0)
            ],
            [
                (C[Mv] = PG[ra][CG[pc]], (function(n) {
                    return CG[xM](CG[UM](n[CG[ac]], n[CG[De]]));
                })[so](void 0, C[Mv])),
                (function(n, r) {
                    return r === void CG[ko] && (r = CG[e(bw)]), CG[xM](CG[XE](n[CG[sc]]), r);
                })[so](void 0, PG[ra][CG[pc]], void 0),
                (function(n, r) {
                    return r === void CG[ko] && (r = CG[e(bw)]), CG[xM](CG[OE](n[CG[sc]]), r);
                })[so](void 0, PG[ra][CG[pc]], void 0),
                (function(n) {
                    return CG[xM](n[CG[mc]]);
                })[so](void 0, PG[ra][CG[pc]]),
                (function(n) {
                    return CG[xM](n[CG[Nc]]);
                })[so](void 0, PG[ra][CG[pc]]),
                (C[wv] = PG[du][CG[e(zA)]], (function(n) {
                    return CG[xM](CG[UM](n[CG[ac]], n[CG[De]]));
                })[so](void 0, C[wv])),
                (C[Fv] = PG[c(Fj)][CG[pc]], (function(n, r) {
                    return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[XE](n[CG[sc]]), r);
                })[so](void 0, C[Fv], void 0)),
                (C[Ev] = PG[c(Fj)][CG[pc]], (function(n, r) {
                    return r === void CG[ko] && (r = CG[Df]), CG[xM](CG[OE](n[CG[sc]]), r);
                })[so](void 0, C[Ev], void 0)),
                (function(n) {
                    return CG[xM](n[CG[mc]]);
                })[so](void 0, PG[du][CG[pc]]),
                (C[Xv] = PG[c(Fj)][CG[pc]], (function(n) {
                    return CG[xM](n[CG[Nc]]);
                })[so](void 0, C[Xv])),
                (C[jv] = PG[Xa][CG[pc]], (function(n) {
                    return CG[xM](CG[UM](n[CG[ac]], n[CG[De]]));
                })[so](void 0, C[jv])),
                (function(n, r) {
                    return r === void CG[ko] && (r = CG[Df]), CG[e(tj)](CG[XE](n[CG[sc]]), r);
                })[so](void 0, PG[Xa][CG[pc]], void 0),
                (function(n, r) {
                    return r === void CG[ko] && (r = CG[Df]), CG[e(tj)](CG[OE](n[CG[sc]]), r);
                })[so](void 0, PG[Xa][CG[pc]], void 0),
                (function(n) {
                    return CG[xM](n[CG[mc]]);
                })[so](void 0, PG[Xa][CG[pc]]),
                (function(n) {
                    return CG[xM](n[CG[Nc]]);
                })[so](void 0, PG[Xa][CG[pc]]),
                (C[Bo] = CG[qE](PG[c(t(f(26873, 26883), Tr))][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[Bo], void 0)),
                (C[Do] = CG[zE](PG[ja][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void e(xu), C[Do], void 0)),
                (C[qo] = CG[CE](PG[ja][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[e(os)]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[qo], void 0)),
                (C[zo] = CG[VE](PG[ja][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[zo], void 0)),
                (C[gv] = CG[qE](PG[ga][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[gv], void 0)),
                (C[Tv] = CG[zE](PG[ga][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[Tv], void 0)),
                (C[Lv] = CG[CE](PG[c(Ej)][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[Lv], void 0)),
                (C[kv] = CG[VE](PG[ga][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[kv], void 0)),
                (C[Jv] = CG[qE](PG[au][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[Jv], void 0)),
                (C[Wv] = CG[zE](PG[au][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[Wv], void 0)),
                (C[_v] = CG[CE](PG[au][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[_v], void 0)),
                (C[Gv] = CG[VE](PG[c(t(f(26883, 26894), Tr))][CG[pc]]), (function(n, r) {
                    var i = [];
                    return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
                })[so](void 0, C[Gv], void 0))
            ],
            (function() {
                var n = [];
                if (n[c(Nv)] = Array(CG[bv])[CG[ya]](CG[ko]), n[Du] = null === (n[c(xu)] = PG[Ta][CG[Zc]]) || n[wo] === void CG[ko] ? void CG[ko] : n[wo][CG[qv]](), !n[Du] || n[Du][CG[Kf]] === CG[ko]) return n[yb];
                if (n[Iu] = CG[PX](), n[Nb] = CG[QX](), !n[Iu] || !n[Nb]) return n[yb];
                n[mb] = CG[ko];
                for(; n[mb] < n[Du][CG[Kf]]; n[c(ge)]++)n[Su] = n[Du][n[mb]], n[Su] && (n[hf] = Math[CG[cv]](CG[ko], Math[CG[dv]](CG[lu], (null !== (n[Au] = n[Su][CG[e(Oj)]]) && n[Au] !== void CG[ko] ? n[c(df)] : CG[ko]) * n[Iu])), n[To] = Math[CG[cv]](CG[ko], Math[CG[dv]](CG[lu], (null !== (n[Ru] = n[Su][CG[nu]]) && n[Ru] !== void CG[ko] ? n[Ru] : CG[ko]) * n[Nb])), n[yf] = Math[CG[dv]](CG[yv], CG[GM](n[hf] * CG[Xv])), n[Nf] = Math[CG[dv]](CG[yv], CG[GM](n[To] * CG[Xv])), n[mf] = n[Nf] * CG[Xv] + n[yf], n[yb][n[mf]]++);
                if (n[bf] = n[Du][CG[Kf]], n[bf] > CG[ko]) {
                    n[pf] = CG[ko];
                    for(; n[pf] < CG[bv]; n[pf]++)n[yb][n[c(bX)]] = CG[xM](n[yb][n[pf]] / n[bf], CG[gf]);
                }
                return n[yb];
            })[so](void 0)
        ]);
    }, CG[oj] = function(n) {
        var r = [];
        return n ? (r[wo] = null != n[CG[ze]] ? n[CG[ze]] : n[CG[$e]], r[Au] = null != n[CG[Ke]] ? n[CG[Ke]] : n[CG[Ve]], null != r[wo] && null != r[Au] ? [
            r[wo],
            r[Au]
        ] : null) : null;
    }, CG[1384] = function() {
        var n = [];
        return n[wo] = CG[oj](CG[dE](PG[Od])), n[Au] = CG[oj](CG[dE](PG[Uu])), n[wo] && n[Au] ? n[Au][CG[ko]] - n[wo][CG[ko]] : null;
    }, CG[t(f(26894, 26898), Tr)] = function() {
        var n = [];
        return n[wo] = CG[oj](CG[dE](PG[Od])), n[Au] = CG[e(t(f(26898, 26908), Tr))](CG[dE](PG[Uu])), n[wo] && n[c(df)] ? n[Au][CG[Zf]] - n[wo][CG[Zf]] : null;
    }, CG[vj] = function() {
        var n = [];
        var r = [];
        return r[wo] = CG[oj](CG[dE](PG[Od])), r[Au] = CG[oj](CG[dE](PG[Uu])), r[wo] && r[c(df)] ? (r[Ru] = r[c(df)][CG[ko]] - r[wo][CG[ko]], r[yb] = r[Au][CG[Zf]] - r[e(xu)][CG[Zf]], n[wo] = r[Ru] * r[Ru] + r[yb] * r[c(Nv)], CG[wM]()[PG[oe]](n[wo])) : null;
    }, CG[t(f(26908, 26912), Tr)] = function() {
        var n = [];
        if (n[wo] = CG[oj](CG[dE](PG[Od])), n[Au] = CG[oj](CG[dE](PG[Uu])), !n[wo] || !n[Au]) return null;
        n[Ru] = n[c(df)][CG[ko]] - n[wo][CG[ko]], n[yb] = n[Au][CG[Zf]] - n[wo][CG[Zf]], n[Du] = CG[_M](n[yb], n[Ru]) * CG[Ce] / CG[ZM]();
        var i = (n[c(vf)] + CG[Oa]) % CG[Oa];
        var t = CG[yv];
        var r = [];
        return t === void CG[ko] && (t = CG[yv]), CG[jb](i) && isFinite(i) ? (r[wo] = CG[XM](CG[mv], t), CG[AM](i * r[wo]) / r[wo]) : PG[Eu];
    }, CG[t(f(26912, 26916), Tr)] = function() {
        var n = [];
        var r = [];
        return r[wo] = CG[PE](PG[Sd][CG[pc]]), r[Au] = CG[oj](CG[dE](PG[Od])), r[Ru] = CG[oj](CG[dE](PG[Uu])), r[wo] && r[Au] && r[Ru] ? (r[yb] = r[Ru][CG[ko]] - r[Au][CG[ko]], r[Du] = r[Ru][CG[Zf]] - r[c(df)][CG[Zf]], r[Iu] = CG[kM](r[yb] * r[yb] + r[Du] * r[Du]), r[Iu] ? (n[wo] = CG[gf], (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        })[so](void 0, r[Iu] / r[wo], n[wo])) : null) : null;
    }, CG[t(f(26916, 26920), Tr)] = function() {
        var n = [];
        return null == PG[Ta][CG[Lc]] || null == PG[Ta][CG[Hc]] || null == PG[Ta][CG[kc]] || null == PG[Ta][CG[Jc]] ? null : (n[wo] = PG[Ta][CG[Hc]] - PG[c(MO)][CG[Lc]], (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
        })[so](void 0, n[wo], void 0));
    }, CG[t(f(26920, 26924), Tr)] = function() {
        var n = [];
        return null == PG[Ta][CG[Lc]] || null == PG[c(MO)][CG[Hc]] || null == PG[Ta][CG[kc]] || null == PG[Ta][CG[Jc]] ? null : (n[wo] = PG[Ta][CG[Jc]] - PG[Ta][CG[kc]], (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[gf]), i[wo] = CG[YX](), null != n && i[wo] ? CG[xM](n * i[wo], r) : null !== n && n !== void CG[ko] ? n : null;
        })[so](void 0, n[wo], void 0));
    }, CG[t(f(26924, 26928), Tr)] = function() {
        var n = [];
        var r = [];
        return null == PG[Ta][CG[Lc]] || null == PG[Ta][CG[Hc]] || null == PG[Ta][CG[kc]] || null == PG[Ta][CG[Jc]] ? null : (r[wo] = PG[Ta][CG[Hc]] - PG[Ta][CG[Lc]], r[c(df)] = PG[Ta][CG[Jc]] - PG[c(MO)][CG[kc]], r[Ru] = r[c(xu)] * r[Au], r[yb] = CG[YX](), r[yb] ? (n[wo] = CG[gf], (function(n, r) {
            var i = [];
            return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        })[so](void 0, r[Ru] * r[yb] * r[yb], n[wo])) : null);
    }, CG[t(f(26928, 26932), Tr)] = function() {
        var n = [];
        if (null == PG[Ta][CG[Lc]] || null == PG[Ta][CG[Hc]] || null == PG[Ta][CG[kc]] || null == PG[Ta][CG[Jc]]) return null;
        if (n[wo] = PG[Ta][CG[Hc]] - PG[Ta][CG[Lc]], n[Au] = PG[Ta][CG[Jc]] - PG[c(MO)][CG[kc]], n[Au] === CG[ko]) return null;
        var i = n[wo] / n[Au];
        var t = CG[gf];
        var r = [];
        return t === void CG[ko] && (t = CG[yv]), CG[jb](i) && isFinite(i) ? (r[wo] = CG[XM](CG[mv], t), CG[AM](i * r[wo]) / r[wo]) : PG[Eu];
    }, CG[t(f(26932, 26936), Tr)] = function() {
        var n = [];
        var r = [];
        if (r[wo] = PG[ou], r[Au] = [], !r[wo][CG[bc]] || r[wo][CG[bc]][CG[Kf]] < CG[Xv]) {
            var i = [];
            i[wo] = Array(CG[Xv]), i[Au] = i[wo][CG[e(Nl)]] - CG[Zf];
            for(; i[Au] >= CG[ko]; i[Au]--)i[wo][i[Au]] = function() {
                return null;
            }(i[Au]);
            return i[wo];
        }
        r[Ru] = r[wo][CG[bc]], r[yb] = CG[GM](r[Ru][CG[Kf]] / CG[Xv]), r[Du] = CG[ko];
        for(; r[Du] < CG[Xv]; r[Du]++)r[Iu] = r[Ru][CG[iv]](r[Du] * r[yb], r[Du] === CG[yv] ? r[Ru][CG[Kf]] : (r[Du] + CG[Zf]) * r[yb]), r[Iu][CG[Kf]] ? (r[Nb] = CG[jM]()[CG[$v]](null, r[Iu]), r[Au][CG[Cf]]((n[Nb] = w(r[Nb], CG[Xv]), n[mb] = CG[Xv], (function(n, r, i) {
            var o = [];
            return r === void CG[ko] && (r = CG[gf]), i === void CG[ko] && (i = PG[e(t(f(26936, 26947), Tr))]), null == n ? n : (o[c(e(ff))] = Math[CG[ev]](n), o[wo] === CG[ko] || o[wo] < i ? CG[xM](i, r) : n);
        })[so](void 0, n[Nb], n[mb], void 0)))) : r[Au][CG[Cf]](null);
        return r[Au];
    }, CG[t(f(26947, 26951), Tr)] = function() {
        var n = [];
        if (n[wo] = CG[PE](PG[Sd][CG[pc]]), n[Au] = CG[vj](), null == n[c(xu)] || null == n[Au] || n[Au] === CG[ko]) return null;
        var i = n[wo] / n[c(df)];
        var t = CG[yv];
        var r = [];
        return t === void CG[ko] && (t = CG[yv]), CG[jb](i) && isFinite(i) ? (r[wo] = CG[XM](CG[mv], t), CG[AM](i * r[wo]) / r[wo]) : PG[Eu];
    }, CG[ej] = function(n$jscomp$0, r) {
        var i = [];
        if (r === void CG[ko] && (r = CG[yv]), !n$jscomp$0 || n$jscomp$0[CG[Kf]] < CG[yv]) return null;
        if (i[wo] = n$jscomp$0[CG[Kf]], i[Au] = CG[Gu](n$jscomp$0, function(n, r) {
            return n + r;
        }, CG[ko]) / i[wo], i[Ru] = CG[kM](CG[Gu](n$jscomp$0, function(n, r) {
            return n + Math[CG[fv]](r - i[Au], CG[Df]);
        }, CG[ko]) / i[wo]), !i[c(af)]) return null;
        i[c(Nv)] = CG[Gu](n$jscomp$0, function(n, r) {
            return n + Math[CG[fv]]((r - i[c(df)]) / i[Ru], CG[yv]);
        }, CG[ko]) / i[wo];
        var n = i[yb];
        var o = r;
        var t = [];
        return o === void CG[ko] && (o = CG[yv]), CG[jb](n) && isFinite(n) ? (t[wo] = CG[XM](CG[mv], o), CG[AM](n * t[wo]) / t[wo]) : PG[Eu];
    }, CG[cj] = function(n$jscomp$0, r) {
        var i = [];
        if (r === void CG[ko] && (r = CG[yv]), !n$jscomp$0 || n$jscomp$0[CG[Kf]] < CG[Xv]) return null;
        if (i[wo] = n$jscomp$0[CG[Kf]], i[c(df)] = CG[Gu](n$jscomp$0, function(n, r) {
            return n + r;
        }, CG[ko]) / i[wo], i[Ru] = CG[kM](CG[Gu](n$jscomp$0, function(n, r) {
            return n + Math[CG[fv]](r - i[Au], CG[Df]);
        }, CG[ko]) / i[wo]), !i[Ru]) return null;
        i[yb] = CG[Gu](n$jscomp$0, function(n, r) {
            return n + Math[CG[fv]]((r - i[Au]) / i[Ru], CG[Xv]);
        }, CG[ko]) / i[wo] - CG[yv];
        var n = i[yb];
        var o = r;
        var t = [];
        return o === void CG[ko] && (o = CG[yv]), CG[jb](n) && isFinite(n) ? (t[wo] = CG[XM](CG[mv], o), CG[AM](n * t[wo]) / t[wo]) : PG[Eu];
    }, CG[lj] = function(n$jscomp$0, r) {
        var i = [];
        if (r === void CG[ko] && (r = CG[yv]), !n$jscomp$0 || !n$jscomp$0[CG[Kf]]) return null;
        if (i[wo] = CG[Gu](n$jscomp$0, function(n, r) {
            return n + r;
        }, CG[ko]), !i[wo]) return null;
        i[Au] = CG[ko], i[Ru] = CG[ko], i[yb] = n$jscomp$0;
        for(; i[c(af)] < i[yb][CG[Kf]]; i[Ru]++)i[Du] = i[yb][i[c(af)]], i[c(of)] = i[Du] / i[wo], i[Iu] > CG[ko] && (i[Au] += i[Iu] * (function(n) {
            return CG[wM]()[PG[ee]](n);
        })[so](void 0, i[Iu]));
        var n = -i[Au] * CG[wM]()[PG[ve]];
        var o = r;
        var t = [];
        return o === void CG[ko] && (o = CG[yv]), CG[jb](n) && isFinite(n) ? (t[wo] = CG[XM](CG[mv], o), CG[AM](n * t[wo]) / t[wo]) : PG[Eu];
    }, CG[sj] = function(n, r) {
        var i = [];
        if (!(n && r && n[CG[Kf]] && r[CG[Kf]])) return null;
        i[wo] = Math[CG[dv]](n[CG[Kf]], r[CG[Kf]]), i[Au] = CG[YX]() || CG[Zf], i[c(af)] = CG[Zf], i[yb] = Array(i[wo]), i[Du] = Array(i[wo]), i[Iu] = CG[ko], i[Nb] = [], i[mb] = CG[ko];
        for(; i[mb] < i[wo]; i[mb]++)i[Su] = n[i[mb]], i[hf] = r[i[mb]], null != i[Su] && null != i[hf] && i[Nb][CG[e(Ip)]](Math[CG[ev]](i[Su]) * i[Au]);
        if (!i[Nb][CG[Kf]]) return null;
        i[Nb][CG[id]](function(n, r) {
            return n - r;
        }), i[To] = i[c(Tf)][Math[CG[wb]](i[c(Tf)][CG[Kf]] / CG[Df])] || CG[ko], i[yf] = CG[du] * i[To], i[mb] = CG[ko], i[Nf] = CG[ko];
        for(; i[mb] < i[wo]; i[mb]++)i[Su] = n[i[mb]], i[hf] = r[i[mb]], null != i[c(ef)] && null != i[hf] && (i[mf] = Math[CG[ev]](i[Su]) * i[Au], i[mf] < i[yf] || (i[bf] = i[hf] > i[Ru] ? i[hf] : i[Ru], i[pf] = i[c(Je)] / i[bf], i[yb][i[Nf]] = i[pf] * i[pf], i[Du][i[Nf]] = i[bf], i[Iu] += i[bf], i[Nf]++));
        if (!i[Iu]) return null;
        i[c(uf)] = CG[ko], i[mb] = CG[ko];
        for(; i[mb] < i[c(Nv)][CG[Kf]] && null != i[Du][i[c(ge)]]; i[mb]++)i[Zo] += i[yb][i[mb]] * i[Du][i[mb]];
        return i[Zo] /= i[Iu], i[Lo] = i[yb][CG[fd]](function(n) {
            return null != n;
        })[CG[id]](function(n, r) {
            return n - r;
        }), i[Ho] = Math[CG[cv]](CG[ko], Math[CG[dv]](i[Lo][CG[Kf]] - CG[Zf], Math[CG[wb]](CG[vu] * (i[Lo][CG[Kf]] - CG[Zf])))), i[c(cl)] = i[Lo][CG[Kf]] ? i[Lo][i[Ho]] : CG[ko], i[c(WX)] = i[Mf] > CG[ko] ? CG[Xa] / i[Mf] : CG[ja], i[Af] = Math[CG[uv]](i[c(uf)] * i[wf]), i[Af] > CG[ko] ? i[Af] < CG[ga] ? i[Af] : CG[ga] : CG[Zf];
    }, PG[Da] = CG[Zf], PG[qa] = CG[Xa], PG[za] = CG[Zf] / CG[bv], CG[t(f(26970, 26974), Tr)] = function(n) {
        var r = [];
        if (!n || n[CG[Kf]] < CG[yv]) return null;
        r[wo] = CG[ko], r[Au] = CG[Zf];
        for(; r[Au] < n[CG[Kf]] - CG[Zf]; r[Au]++)n[r[c(df)]] > n[r[Au] - CG[Zf]] && n[r[Au]] > n[r[Au] + CG[Zf]] && r[wo]++;
        return r[wo];
    }, CG[t(f(26974, 26978), Tr)] = function(n, r) {
        var i = [];
        var t = [];
        if (!n || !r || n[CG[Kf]] === CG[ko] || r[CG[Kf]] === CG[ko]) return [
            null,
            null
        ];
        t[wo] = CG[gM](n[CG[Kf]], r[CG[Kf]]), t[Au] = CG[ko], t[Ru] = CG[ko], t[yb] = CG[ko];
        for(; t[yb] < t[wo]; t[e(Nv)]++)t[Du] = r[t[yb]] || CG[ko], t[Iu] = n[t[yb]], t[Iu] > CG[e(Yl)] ? t[Au] += t[Du] : t[Iu] < CG[ko] && (t[Ru] += t[Du]);
        return [
            (i[wo] = CG[yv], (function(n, r) {
                var i = [];
                return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
            })[so](void 0, t[Au], i[wo])),
            (i[Au] = CG[yv], (function(n, r) {
                var i = [];
                return r === void CG[ko] && (r = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], r), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
            })[so](void 0, t[Ru], i[Au]))
        ];
    }, CG[dj] = function(n) {
        return n[CG[bc]];
    }, CG[hj] = function(n, r, i) {
        var t = [];
        t[0] = i;
        var o = [];
        o[wo] = t[0];
        var u = [];
        u[wo] = o[wo];
        var f = [];
        if (u[wo] === void CG[ko] && (u[wo] = CG[Xv]), !n || n[CG[Kf]] < u[wo]) {
            var v = [];
            v[wo] = Array(u[wo]), v[Au] = v[wo][CG[Kf]] - CG[Zf];
            for(; v[Au] >= CG[ko]; v[e(df)]--)v[wo][v[Au]] = function() {
                return null;
            }(v[Au]);
            return v[wo];
        }
        f[wo] = CG[GM](n[CG[Kf]] / u[wo]), f[Au] = [], f[c(af)] = CG[ko];
        for(; f[Ru] < u[wo]; f[Ru]++)f[yb] = f[Ru] * f[wo], f[Du] = f[Ru] === u[wo] - CG[Zf] ? n[CG[Kf]] : (f[Ru] + CG[Zf]) * f[wo], f[Iu] = n[CG[iv]](f[yb], f[Du]), f[Au][CG[Cf]](f[Iu][CG[Kf]] ? r(f[Iu]) : null);
        return f[Au];
    }, CG[yj] = function(n) {
        var i = (function(n, r, i) {
            var t = [];
            t[wo] = i, t[Au] = CG[ko], t[Ru] = CG[ko], t[yb] = n;
            for(; t[e(af)] < t[c(Nv)][CG[Kf]]; t[Ru]++)t[Du] = t[c(Nv)][t[Ru]], t[wo] = r(t[c(xu)], t[Du], t[Au]), t[c(df)]++;
            return t[wo];
        })[so](void 0, n, function(n, r) {
            return n + r;
        }, CG[ko]) / n[CG[Kf]];
        var t = CG[yv];
        var r = [];
        return t === void CG[ko] && (t = CG[yv]), CG[jb](i) && isFinite(i) ? (r[wo] = CG[XM](CG[mv], t), CG[AM](i * r[wo]) / r[wo]) : PG[Eu];
    }, CG[Nj] = function(n) {
        var i = CG[wM]()[PG[Vo]][CG[$v]](null, n);
        var t = CG[yv];
        var r = [];
        return t === void CG[ko] && (t = CG[yv]), CG[jb](i) && isFinite(i) ? (r[wo] = CG[XM](CG[mv], t), CG[AM](i * r[wo]) / r[wo]) : PG[Eu];
    }, CG[bj] = function(n) {
        var i = CG[wM]()[PG[ie]][CG[$v]](null, n);
        var t = CG[yv];
        var r = [];
        return t === void CG[ko] && (t = CG[yv]), CG[jb](i) && isFinite(i) ? (r[wo] = CG[XM](CG[mv], t), CG[AM](i * r[wo]) / r[wo]) : PG[Eu];
    }, CG[mj] = function(n$jscomp$0) {
        var r = [];
        r[wo] = CG[Gu](n$jscomp$0, function(n, r) {
            return n + r;
        }, CG[ko]) / n$jscomp$0[CG[Kf]], r[Au] = CG[Gu](n$jscomp$0, function(n, i) {
            return n + Math[CG[fv]](i - r[wo], CG[Df]);
        }, CG[ko]) / n$jscomp$0[CG[Kf]];
        var n = CG[kM](r[c(df)]);
        var t = CG[yv];
        var i = [];
        return t === void CG[ko] && (t = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], t), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
    }, PG[$a] = CG[Fc], PG[su] = CG[du], PG[Ka] = CG[wv], PG[Va] = PG[Ka] - CG[Zf], PG[c(Hj)] = CG[XM](CG[Df], PG[Va]), PG[c(t(f(26978, 26989), Tr))] = CG[XM](CG[Df], PG[Ka]) - CG[Zf], PG[Ya] = PG[Ca] - PG[Va], PG[nl] = PG[Qa] - PG[Pa], PG[rl] = PG[nl] / PG[Ya], CG[t(f(26989, 26993), Tr)] = function(n) {
        var r = [];
        return n < PG[c(Hj)] ? n : (r[wo] = ~~((CG[LM](n) * CG[HM]() - PG[Va]) * PG[rl] + PG[Pa]), (function(n, r) {
            return CG[jM]()(n, r);
        })[so](void 0, PG[Qa], r[wo]));
    }, CG[kj] = function() {
        var n = [];
        return [
            (n[wo] = CG[CX](PG[Pc]), n[wo] < PG[c(Hj)] ? n[wo] : CG[gM](PG[Qa], ~~((CG[LM](n[wo]) * CG[HM]() - PG[Va]) * PG[rl] + PG[Pa]))),
            (n[Au] = CG[CX](PG[AF]), n[Au] < PG[c(Hj)] ? n[Au] : CG[gM](PG[Qa], ~~((CG[LM](n[Au]) * CG[HM]() - PG[Va]) * PG[rl] + PG[Pa]))),
            (n[Ru] = CG[CX](PG[qc]), n[Ru] < PG[c(Hj)] ? n[Ru] : CG[gM](PG[Qa], ~~((CG[LM](n[Ru]) * CG[HM]() - PG[Va]) * PG[rl] + PG[Pa]))),
            (n[yb] = CG[CX](PG[Vc]), n[yb] < PG[c(Hj)] ? n[yb] : CG[gM](PG[Qa], ~~((CG[LM](n[yb]) * CG[HM]() - PG[Va]) * PG[rl] + PG[Pa]))),
            (n[Du] = CG[CX](PG[ru]), n[Du] < PG[c(Hj)] ? n[Du] : CG[gM](PG[Qa], ~~((CG[LM](n[Du]) * CG[HM]() - PG[Va]) * PG[rl] + PG[Pa]))),
            (n[Iu] = CG[CX](PG[Qc]), n[Iu] < PG[c(Hj)] ? n[Iu] : CG[gM](PG[Qa], ~~((CG[LM](n[Iu]) * CG[HM]() - PG[Va]) * PG[rl] + PG[Pa]))),
            (n[Nb] = CG[DM](CG[CX](PG[$c]), CG[e(gF)](PG[zc])), n[Nb] < PG[c(Hj)] ? n[Nb] : CG[gM](PG[Qa], ~~((CG[LM](n[Nb]) * CG[HM]() - PG[Va]) * PG[rl] + PG[Pa]))),
            (n[mb] = PG[Aa][CG[De]] > CG[Zf] ? PG[Aa][CG[De]] - CG[Zf] : PG[xv], n[mb] < PG[c(Hj)] ? n[mb] : CG[gM](PG[Qa], ~~((CG[LM](n[mb]) * CG[HM]() - PG[e(t(f(26993, 27004), Tr))]) * PG[rl] + PG[Pa]))),
            (n[Su] = PG[Hd][CG[De]], (function(n) {
                return n < PG[c(Hj)] ? n : CG[gM](PG[Qa], ~~((CG[LM](n) * CG[HM]() - PG[Va]) * PG[rl] + PG[Pa]));
            })[so](void 0, n[Su])),
            (n[hf] = PG[Wd][CG[De]], (function(n) {
                return n < PG[c(Hj)] ? n : CG[gM](PG[Qa], ~~((CG[LM](n) * CG[HM]() - PG[Va]) * PG[rl] + PG[Pa]));
            })[so](void 0, n[hf])),
            (n[To] = PG[Ld][CG[De]], (function(n) {
                return n < PG[c(Hj)] ? n : CG[gM](PG[Qa], ~~((CG[LM](n) * CG[HM]() - PG[Va]) * PG[rl] + PG[e(Hj)]));
            })[so](void 0, n[To]))
        ];
    }, PG[c(t(f(27004, 27014), Tr))] = d(sO), PG[tl] = CG[ko], PG[ol] = l(f(27014, 27074)), PG[c(t(f(27074, 27084), Tr))] = a(f(27084, 27140)), PG[fl] = a(f(27140, 27156)), PG[el] = a(f(27156, 27172)), PG[dl] = l(f(27172, 27188)), PG[al] = Array(CG[Ta])[CG[jf]](CG[Yo]), PG[ll] = CG[xv], PG[sl] = a(f(27188, 27208)), PG[yl] = PG[ll] + l(f(27208, 27292)), PG[ml] = PG[ll] + s(f(27292, 27364)), PG[pl] = PG[ll] + s(f(27364, 27420)), PG[Ml] = d(t(f(27420, 27430), Tr)), CG[wo] = d(t(f(27430, 27440), Tr)), new Date(CG[wo], CG[e(fs)], CG[Zf], PG[xv], PG[xv], CG[Zf])[CG[Eu]](), PG[wl] = CG[We], PG[Al] = CG[Fc], PG[c(t(f(27440, 27450), Tr))] = CG[$M](CG[ke]), PG[El] = CG[gf], PG[c(t(f(27450, 27460), Tr))] = s(f(27460, 27540)), PG[Xl] = {
        Ge: !1,
        Je: !0,
        Ze: PG[Ol],
        $e: CG[kv],
        Ye: {
            ru: PG[el],
            nu: PG[c(Jj)]
        },
        au: !0
    }, CG[Wj] = function(n) {
        return CG[Gb](PG[Xl][CG[Za]][CG[iv]](CG[yv]))[CG[Jo]](function(r) {
            return n ? CG[PM](r) : r;
        })[CG[Zo]]();
    }, CG[t(f(27540, 27544), Tr)] = function(n) {
        n && (PG[Xl][CG[La]][CG[Ha]] = n);
    }, CG[t(f(27544, 27548), Tr)] = function(n) {
        PG[Xl][CG[ka]] = n;
    }, CG[e(t(f(27548, 27558), Tr))] = function(n) {
        PG[c(e(t(f(27558, 27567), Tr)))][CG[Ja]] = n;
    }, CG[t(f(27567, 27571), Tr)] = function(n) {
        PG[Xl][CG[Wa]] = n;
    }, CG[t(f(27571, 27575), Tr)] = function(n) {
        PG[Xl][CG[_a]] = n;
    }, CG[t(f(27575, 27579), Tr)] = function(n) {
        n && (n[CG[Jf]] && (PG[Xl][CG[La]][CG[Ha]] = n[CG[Jf]]), (function(n) {
            var r = [];
            return r[wo] = Number[a(Xp)], CG[jb](r[c(xu)]) ? r[wo](n) : typeof n === s(jp) && isFinite(n) && ~~n === n;
        })[so](void 0, n[CG[Ga]]) && (PG[Xl][CG[La]][CG[xa]] = n[CG[Ga]]));
    }, CG[t(f(27579, 27583), Tr)] = function(n) {
        PG[Xl][CG[Ra]] = n;
    }, CG[t(f(27583, 27587), Tr)] = function(n) {
        PG[Xl][CG[Ua]] = n;
    }, CG[t(f(27587, 27591), Tr)] = function(n) {
        n && (PG[Xl][CG[Ou]] = n);
    }, CG[t(f(27591, 27595), Tr)] = function(n) {
        var r = [];
        r[wo] = n, isNaN(r[wo] - i(r[wo])) || (PG[c(_j)][CG[Sa]] = n);
    }, CG[t(f(27595, 27599), Tr)] = function(n) {
        var r = [];
        r[wo] = n, CG[Ob](r[wo]) && r[wo] !== PG[Eu] && (PG[Xl][CG[Ia]] = n);
    }, CG[t(f(27599, 27603), Tr)] = function(n) {
        var r = [];
        r[wo] = n, CG[Ob](r[wo]) && r[wo] !== PG[Eu] && (PG[Xl][CG[Xu]] = n);
    }, CG[t(f(27603, 27607), Tr)] = function(n) {
        var r = [];
        r[wo] = n, CG[Ob](r[wo]) && r[wo] !== PG[Eu] && (PG[Xl][CG[Ba]] = n);
    }, CG[t(f(27607, 27611), Tr)] = function(n) {
        var r = [];
        r[wo] = n, CG[Ob](r[wo]) && r[wo] !== PG[Eu] && (PG[Xl][CG[Da]] = n);
    }, CG[t(f(27611, 27615), Tr)] = function(n) {
        PG[Xl][CG[qa]] = n;
    }, CG[t(f(27615, 27619), Tr)] = function(n) {
        var r = [];
        r[wo] = n, CG[Ob](r[wo]) && r[wo] !== PG[Eu] && (PG[Xl][CG[za]] = n);
    }, CG[t(f(27619, 27623), Tr)] = function(n) {
        var r = [];
        r[wo] = n, CG[Ob](r[wo]) && r[wo] !== PG[Eu] && (PG[Xl][CG[$a]] = n);
    }, CG[Gj] = function() {
        return PG[Xl];
    }, CG[t(f(27623, 27627), Tr)] = function(n) {
        var r = [];
        if (r[wo] = n, !CG[jb](r[wo]) || r[wo] === PG[$o] || n[CG[Kf]] !== d(AX) || n[CG[iv]](CG[ko], CG[yv]) !== l(xj)) throw Error(PG[yl]);
        PG[Xl][CG[Za]] = n;
    }, PG[jl] = s(f(27627, 27803)), CG[Rj] = function(n, r) {
        var i = [];
        if (n[CG[ju]]) return n[CG[ju]](r);
        i[wo] = PG[jl], i[Au] = CG[Wo], i[c(af)] = CG[ko], i[yb] = void CG[ko], i[c(vf)] = CG[ko], i[Iu] = i[wo];
        for(; r[CG[rv]](i[Du] | CG[ko]) || (i[Iu] = CG[Go], i[Du] % CG[Zf]); i[Au] += i[Iu][CG[rv]](CG[Vv] & i[Ru] >> CG[wv] - i[Du] % CG[Zf] * CG[wv])){
            if (i[yb] = r[CG[pv]](i[Du] += CG[yv] / CG[Xv]), i[yb] > CG[Xf]) return null;
            i[Ru] = i[Ru] << CG[wv] | i[yb];
        }
        return i[Au];
    }, CG[Uj] = function(n, r) {
        var i = [];
        return i[wo] = CG[Rj](n, r), null == i[wo] ? null : i[wo][CG[tv]](/\+/g, CG[su])[CG[tv]](/\//g, CG[ru])[CG[tv]](/=+$/, CG[Wo]);
    }, PG[gl] = a(f(27803, 27859)), CG[t(f(27859, 27863), Tr)] = function(n) {
        return !(!n || !(function(n) {
            return typeof n === CG[zf];
        })[so](void 0, n[PG[gl]]));
    }, CG[Sj] = function(n) {
        var r = [];
        var i = [];
        try {
            if (r[wo] = n, !r[wo] || !CG[Lp](r[wo][PG[gl]])) return;
            i[wo] = CG[Bw](n), n[PG[c(t(f(27863, 27873), Tr))]](function() {
                n[PG[gl]](function() {
                    var r = [];
                    PG[Zl] || (PG[Zl] = (r[wo] = CG[Bw](n) - i[wo], CG[wM]()[PG[Vv]](r[wo])));
                });
            });
        } catch (n) {}
    }, CG[t(f(27873, 27877), Tr)] = function() {
        return PG[c(Ij)];
    }, PG[Hl] = {
        du: CG[ko],
        hu: CG[ko],
        pu: CG[ko]
    }, CG[t(f(27877, 27881), Tr)] = function(n) {
        var r = [];
        PG[Hl][CG[Ka]] = (r[wo] = CG[Bw](n), CG[wM]()[PG[Vv]](r[wo]));
    }, CG[Bj] = function(n) {
        var r = [];
        PG[Hl][CG[Va]] = (r[wo] = CG[Bw](n), CG[wM]()[PG[Vv]](r[wo]));
    }, CG[t(f(27881, 27885), Tr)] = function(n) {
        var r = [];
        PG[c(Dj)][CG[Ca]] = (r[wo] = CG[Bw](n), CG[wM]()[PG[Vv]](r[wo]));
    }, CG[t(f(27885, 27889), Tr)] = function(n) {
        var r = [];
        PG[Hl][CG[Pa]] = (r[wo] = CG[Bw](n), CG[wM]()[PG[Vv]](r[wo]));
    }, CG[t(f(27889, 27893), Tr)] = function(n) {
        var r = [];
        PG[Hl][CG[Qa]] = (r[wo] = CG[Bw](n), CG[wM]()[PG[Vv]](r[e(xu)]));
    }, CG[t(f(27893, 27897), Tr)] = function(n) {
        var r = [];
        PG[Hl][CG[Ya]] = (r[e(xu)] = CG[Bw](n), CG[wM]()[PG[Vv]](r[wo]));
    }, CG[qj] = function(n) {
        var r = [];
        PG[Hl][CG[nl]] = (r[wo] = CG[Bw](n), CG[wM]()[PG[Vv]](r[wo]));
    }, CG[zj] = function(n) {
        var r = [];
        PG[Hl][CG[rl]] = (r[wo] = CG[Bw](n), CG[wM]()[PG[Vv]](r[wo]));
    }, CG[t(f(27897, 27901), Tr)] = function(n) {
        var r = [];
        PG[Hl][CG[il]] = (r[wo] = CG[Bw](n), CG[wM]()[PG[Vv]](r[wo]));
    }, CG[t(f(27901, 27905), Tr)] = function(n) {
        PG[c(Dj)][CG[tl]] || (PG[Hl][CG[tl]] = CG[wM]()[PG[Vv]](n));
    }, CG[t(f(27905, 27909), Tr)] = function(n) {
        PG[Hl][CG[ol]] || (PG[Hl][CG[ol]] = CG[wM]()[PG[Vv]](n));
    }, CG[t(f(27909, 27913), Tr)] = function() {
        return PG[Hl][CG[tl]] || PG[xv];
    }, CG[t(f(27913, 27917), Tr)] = function() {
        return PG[Hl][CG[ol]] || PG[xv];
    }, CG[$j] = function(n, r) {
        var i = [];
        return [
            PG[Hl][CG[Ka]],
            (i[wo] = PG[Hl][CG[Ya]], (function(n) {
                return CG[Ob](n) && n !== PG[Eu];
            })[so](void 0, i[wo]) && (i[Au] = PG[Hl][CG[Qa]], (function(n) {
                return CG[Ob](n) && n !== PG[Eu];
            })[so](void 0, i[Au])) ? PG[Hl][CG[Ya]] - PG[Hl][CG[Qa]] : CG[ko]),
            (i[Ru] = PG[Hl][CG[Pa]], (function(n) {
                return CG[Ob](n) && n !== PG[Eu];
            })[so](void 0, i[Ru]) && (i[yb] = PG[Hl][CG[Ca]], (function(n) {
                return CG[Ob](n) && n !== PG[Eu];
            })[so](void 0, i[yb])) ? PG[Hl][CG[Pa]] - PG[Hl][CG[Ca]] : CG[ko]),
            PG[Hl][CG[Va]],
            CG[wM]()[PG[Vv]](r - n)
        ];
    }, CG[Kj] = function() {
        var n = [];
        return [
            (n[wo] = PG[Hl][CG[il]], (function(n) {
                return CG[Ob](n) && n !== PG[Eu];
            })[so](void 0, n[wo]) && (n[Au] = PG[Hl][CG[Ka]], (function(n) {
                return CG[Ob](n) && n !== PG[Eu];
            })[so](void 0, n[Au])) ? PG[c(Dj)][CG[il]] - PG[Hl][CG[Ka]] : CG[ko]),
            (n[Ru] = PG[Hl][CG[rl]], (function(n) {
                return CG[Ob](n) && n !== PG[Eu];
            })[so](void 0, n[Ru]) && (n[yb] = PG[Hl][CG[nl]], (function(n) {
                return CG[Ob](n) && n !== PG[Eu];
            })[so](void 0, n[yb])) ? PG[Hl][CG[rl]] - PG[Hl][CG[nl]] : CG[ko]),
            PG[c(Ij)],
            PG[Hl][CG[ol]] || PG[xv],
            PG[Hl][CG[tl]] || PG[xv]
        ];
    }, CG[t(f(27917, 27921), Tr)] = function(n, r$jscomp$0, i) {
        var t = [];
        t[2] = i;
        var o = [];
        o[Ru] = t[2];
        var u = [];
        u[Ru] = o[Ru];
        var f = [];
        f[wo] = CG[$j](r$jscomp$0, u[Ru]), f[Au] = CG[bM]([
            f[wo]
        ]);
        var r = f[Au];
        var v = [];
        return v[wo] = CG[Rj](n, r), null == v[wo] ? null : v[wo][CG[tv]](/\+/g, CG[su])[CG[tv]](/\//g, CG[ru])[CG[tv]](/=+$/, CG[Wo]);
    }, CG[1488] = function(n, r) {
        var i = [];
        i[wo] = n[CG[Kf]] & CG[yv], i[Au] = n[CG[Kf]] - i[wo], i[Ru] = r, i[yb] = d(Vj), i[Du] = d(Cj), i[Iu] = CG[ko], i[Nb] = CG[ko];
        for(; i[Iu] < i[Au];)i[Nb] = n[CG[pv]](i[Iu]) & CG[Xf] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[wv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[bv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[Ev], ++i[Iu], i[Nb] = (i[Nb] & CG[ga]) * i[yb] + (((i[Nb] >>> CG[bv]) * i[yb] & CG[ga]) << CG[bv]) & CG[ul], i[Nb] = i[Nb] << CG[Mv] | i[Nb] >>> CG[fl], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb], i[Ru] = i[Ru] << CG[ke] | i[Ru] >>> CG[el], i[mb] = (i[c(af)] & CG[ga]) * CG[re] + (((i[Ru] >>> CG[bv]) * CG[re] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] = (i[mb] & CG[ga]) + d(Pj) + (((i[e(ge)] >>> CG[bv]) + d(c(Qj)) & CG[ga]) << CG[bv]);
        switch(i[Nb] = CG[ko], i[wo]){
            case CG[yv]:
                i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Df]) & CG[Xf]) << CG[bv];
            case CG[Df]:
                i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Zf]) & CG[Xf]) << CG[wv];
            case CG[Zf]:
                i[e(Tf)] ^= n[CG[pv]](i[Iu]) & CG[Xf], i[Nb] = (i[Nb] & CG[ga]) * i[yb] + (((i[c(Tf)] >>> CG[bv]) * i[yb] & CG[ga]) << CG[bv]) & CG[ul], i[Nb] = i[Nb] << CG[Mv] | i[Nb] >>> CG[fl], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb];
        }
        return i[Ru] ^= n[CG[Kf]], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] = (i[Ru] & CG[ga]) * CG[dl] + (((i[Ru] >>> CG[bv]) * CG[e(Yj)] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[c(af)] >>> CG[ke], i[c(af)] = (i[Ru] & CG[ga]) * CG[al] + (((i[Ru] >>> CG[bv]) * CG[al] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] >>> CG[ko];
    }, CG[ng] = function(n) {
        var r = [];
        r[wo] = CG[Bp](n, function(n) {
            return n ? CG[Zf] : CG[ko];
        }), r[Au] = CG[Wo], r[Ru] = CG[Ev], r[yb] = CG[ko];
        for(; r[yb] < r[wo][CG[Kf]]; r[yb] += r[Ru])r[Du] = r[wo][CG[iv]](r[yb], r[yb] + r[Ru]), r[Iu] = CG[ow](r[Du], PG[Rv]), r[Nb] = r[Du][CG[Kf]] === r[Ru] ? CG[yv] : CG[FM](r[c(vf)][CG[Kf]] / CG[wv]), r[Au] += (function(n, r) {
            var i = [];
            i[e(xu)] = CG[gM](CG[XM](CG[Df], CG[wv] * r) - CG[Zf], n), i[Au] = PG[$o], i[Ru] = r * CG[Df];
            for(; i[wo] > CG[ko];)i[Au] = CG[$M](i[wo]) + i[Au], i[wo] = i[wo] >>> CG[wv];
            if (i[Ru]) for(; i[Au][CG[Kf]] < i[Ru];)i[Au] = CG[QM](CG[Io], i[Au]);
            return i[Au];
        })[so](void 0, r[Iu], r[Nb]);
        return CG[QM]((function(n) {
            var r = [];
            return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[e(rg)]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
        })[so](void 0, n[CG[Kf]]), r[Au]);
    }, PG[hu] = l(f(27921, 27945)), CG[ig] = function(n) {
        return n[s(Ub)][PG[hu]];
    }, PG[Jl] = l(f(27945, 27961)), PG[Wl] = s(f(27961, 27985)), PG[_l] = a(f(27985, 28025)), PG[Gl] = PG[Jl] + CG[Po], PG[c(t(f(28025, 28035), Tr))] = RegExp(PG[Wl]), CG[tg] = function(n$jscomp$0) {
        var r = [];
        var i = [];
        if (i[wo] = CG[Bp](n$jscomp$0[PG[Gl]] || [], function(n) {
            return n[PG[c(t(f(28035, 28046), Tr))]];
        }), i[Au] = CG[Rp](i[wo], function(n) {
            return !/Not/[CG[ie]](n);
        }), i[Au][CG[Kf]]) {
            var n = i[Au][CG[Kf]] > CG[Zf] ? (r[Ru] = function(n) {
                return !PG[xl][CG[ie]](n);
            }, (function(n, r) {
                var i = [];
                i[wo] = [], i[c(df)] = CG[ko], i[Ru] = n;
                for(; i[Au] < i[c(af)][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[Au]], r(i[yb]) && i[wo][CG[Cf]](i[yb]);
                return i[wo];
            })[so](void 0, i[Au], r[Ru])) : i[Au];
            if (CG[gp](n) && n[CG[Kf]]) return n[CG[jf]](CG[xo]);
        }
    }, PG[Rl] = [
        PG[Wl],
        CG[Wo][CG[bf]](PG[Lc], CG[Uo])[CG[bf]](CG[cM](PG[lc])),
        CG[cM](PG[hc]),
        CG[cM](PG[sc]),
        PG[_l]
    ], CG[og] = function(n$jscomp$0) {
        var r = [];
        if (!n$jscomp$0) return PG[Rv];
        try {
            r[wo] = CG[MM](n$jscomp$0), r[Au] = CG[Bp](r[c(xu)][PG[Gl]] || [], function(n) {
                return n[PG[Jl]];
            });
            var n = r[c(df)];
            if (CG[gp](n) && n[CG[Kf]]) return n[CG[jf]](CG[xo]);
        } catch (n) {
            return PG[Rv];
        }
    }, PG[Ul] = s(f(28046, 28058)), CG[ug] = function(n) {
        return n[PG[Ul]] ? n[PG[Ul]][CG[Fu]]()[CG[Kf]] : CG[ko];
    }, CG[fg] = function() {
        var n = [];
        var r = [];
        try {
            r[wo] = [][CG[kf]];
            try {
                return (-CG[Zf])[l(vg)](-CG[Zf]), CG[ko];
            } catch (i) {
                return (function(n) {
                    return n[CG[Kf]];
                })[so](void 0, i[CG[ll]]) + (n[Au] = (r[c(xu)] + PG[$o])[CG[Yf]](r[wo][CG[Jf]])[CG[jf]](PG[$o]), n[Au][CG[Kf]]);
            }
        } catch (n) {
            return null;
        }
    }, CG[eg] = function() {
        return (function(n) {
            return n === PG[Rv];
        })[so](void 0, PG[yu]) && (PG[yu] = (function() {
            var n = [];
            try {
                n[wo] = [][CG[kf]];
                try {
                    return (-CG[Zf])[l(vg)](-CG[Zf]), CG[ko];
                } catch (r) {
                    return CG[vM](r[CG[ll]]) + CG[vM]((n[c(xu)] + PG[$o])[CG[Yf]](n[wo][CG[Jf]])[CG[jf]](PG[$o]));
                }
            } catch (n) {
                return null;
            }
        })[so](void 0)), PG[yu];
    }, PG[Nu] = CG[ha], PG[Sl] = d(gX), PG[Il] = d(rg), PG[Bl] = d(Mb), CG[cg] = function() {
        return (function() {
            return CG[Xb](PG[yu]) && (PG[yu] = CG[fg]()), PG[yu];
        })[so](void 0) === PG[Nu];
    }, CG[dg] = function() {
        return (function() {
            return CG[Xb](PG[yu]) && (PG[yu] = CG[fg]()), PG[yu];
        })[so](void 0) === PG[Sl];
    }, CG[t(f(28058, 28062), Tr)] = function() {
        return (function() {
            return CG[Xb](PG[yu]) && (PG[yu] = CG[fg]()), PG[e(t(f(28062, 28072), Tr))];
        })[so](void 0) === PG[Il];
    }, CG[t(f(28072, 28076), Tr)] = function(n) {
        var r = [];
        return r[wo] = n, (r[wo][PG[Ul]] ? r[wo][PG[Ul]][CG[Fu]]()[CG[Kf]] : CG[ko]) === PG[Bl];
    }, PG[Dl] = a(f(28076, 28180)), PG[zl] = s(f(28180, 28196)), PG[$l] = s(f(28196, 28248)), PG[Vl] = l(f(28248, 28276)), PG[Ql] = l(f(28276, 28296)), PG[ns] = l(f(28296, 28304)), PG[rs] = s(f(28304, 28320)), PG[ts] = a(f(28320, 28356)), PG[us] = l(f(28356, 28424)), PG[c(t(f(28424, 28435), Tr))] = s("rufX51vnU+eu543nMuff57bn8Oc="), PG[es] = a(f(28435, 28459)), PG[c(kl)] = CG[sl], PG[ds] = a(f(28459, 28499)), PG[as] = CG[ZM]() * CG[Df], PG[ls] = [
        [
            s(f(28499, 28511)),
            CG[yl],
            CG[yl]
        ],
        [
            s(f(28511, 28523)),
            CG[Fc],
            CG[yl]
        ],
        [
            s(f(28523, 28535)),
            CG[ml],
            CG[Fc]
        ]
    ], CG[ag] = function(n) {
        var r = PG[zl];
        return CG[Sb](n)[s(ap)](r);
    }, CG[lg] = function(n, r, i) {
        return new n[PG[ds]](r, i);
    }, CG[sg] = function(n) {
        var r = [];
        try {
            PG[ds] in n && (r[wo] = (function(n, r, i) {
                return new n[PG[ds]](r, i);
            })[so](void 0, n, PG[cs], PG[cs]));
        } catch (n) {} finally{
            r[c(xu)] || (r[wo] = CG[dp](n, PG[zl]));
        }
        return r[wo];
    }, CG[hg] = function(n) {
        return !(!n || !n[CG[pl]]);
    }, CG[yg] = function(n) {
        var r = [];
        return r[wo] = n, !(!r[wo] || !r[wo][CG[pl]] || !(CG[Ml] in n));
    }, CG[Ng] = function(n) {
        try {
            return n[CG[pl]](PG[ts] + PG[rs]);
        } catch (n) {}
    }, CG[mg] = function(n) {
        var r = [];
        var i = [];
        if (i[wo] = CG[sg](n), r[wo] = i[wo], (function(n) {
            return !(!n || !n[CG[pl]]);
        })[so](void 0, r[wo])) return i[e(df)] = i[wo][CG[pl]](PG[rs]) || CG[Ng](i[wo]), CG[eg]() === PG[Sl] ? i[Au][CG[wl]](i[Au][s(bg)]) : (i[Ru] = i[e(df)] && i[Au][CG[Al]](PG[c(pg)]), i[Ru] ? i[Au][CG[wl]](i[Ru][a(Mg)]) : void 0);
    }, CG[wg] = function(n) {
        var r = [];
        if (r[c(xu)] = n[CG[Ml]](), r[wo]) return (function(n, r) {
            var i = [];
            i[e(xu)] = n[CG[Kf]] & CG[yv], i[Au] = n[CG[Kf]] - i[wo], i[Ru] = r, i[yb] = d(Vj), i[Du] = d(Cj), i[Iu] = CG[ko], i[Nb] = CG[ko];
            for(; i[Iu] < i[Au];)i[Nb] = n[CG[pv]](i[Iu]) & CG[Xf] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[wv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[bv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[Ev], ++i[Iu], i[Nb] = (i[Nb] & CG[ga]) * i[yb] + (((i[Nb] >>> CG[bv]) * i[yb] & CG[ga]) << CG[bv]) & CG[ul], i[Nb] = i[Nb] << CG[Mv] | i[Nb] >>> CG[fl], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb], i[Ru] = i[Ru] << CG[ke] | i[Ru] >>> CG[el], i[mb] = (i[c(af)] & CG[ga]) * CG[re] + (((i[Ru] >>> CG[bv]) * CG[re] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] = (i[mb] & CG[ga]) + d(Pj) + (((i[mb] >>> CG[bv]) + d(c(Qj)) & CG[ga]) << CG[bv]);
            switch(i[Nb] = CG[ko], i[wo]){
                case CG[yv]:
                    i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Df]) & CG[Xf]) << CG[bv];
                case CG[Df]:
                    i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Zf]) & CG[Xf]) << CG[wv];
                case CG[Zf]:
                    i[Nb] ^= n[CG[pv]](i[Iu]) & CG[Xf], i[Nb] = (i[Nb] & CG[ga]) * i[yb] + (((i[c(Tf)] >>> CG[bv]) * i[e(Nv)] & CG[ga]) << CG[e(rg)]) & CG[ul], i[Nb] = i[Nb] << CG[Mv] | i[Nb] >>> CG[e(Ag)], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb];
            }
            return i[e(af)] ^= n[CG[Kf]], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] = (i[Ru] & CG[ga]) * CG[e(Yj)] + (((i[Ru] >>> CG[bv]) * CG[dl] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[c(af)] >>> CG[ke], i[c(af)] = (i[Ru] & CG[ga]) * CG[al] + (((i[Ru] >>> CG[bv]) * CG[al] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] >>> CG[ko];
        })[so](void 0, r[wo], void 0)[CG[Fu]](CG[bv]);
    }, CG[Fg] = function(n, r) {
        n[s(Eg)] = r;
    }, CG[Og] = function(n, r, i, t, o) {
        n[a(Xg)](r, i, t, o);
    }, CG[jg] = function(n, r, i, t) {
        n[CG[Fl]](r, i, t);
    }, CG[gg] = function(n, r) {
        n[CG[El]] = r;
    }, CG[Tg] = function(n, r, i) {
        n[CG[be]] = r, n[CG[_f]] = i;
    }, CG[Zg] = function(n) {
        n[CG[Ol]]();
    }, CG[Lg] = function(n) {
        n[a(Hg)]();
    }, CG[kg] = function(n) {
        n[a(Jg)](CG[ml], CG[ml], CG[ml], CG[ko], PG[as], !0);
    }, CG[Wg] = function(n, r) {
        r ? n[CG[ya]](r) : n[CG[ya]]();
    }, CG[_g] = function(n, r, i, t) {
        var o = [];
        return t === void CG[ko] && (t = {}), o[wo] = n[CG[pl]](PG[ns], t), (function(n, r, i) {
            n[CG[be]] = r, n[CG[_f]] = i;
        })[so](void 0, n, r, i), o[wo];
    }, CG[Gg] = function(n, r, i, t, o) {
        if (n) try {
            return n[CG[Xl]](r, i, t, o)[CG[Qd]];
        } catch (n) {
            return;
        }
    }, CG[xg] = function(n, r) {
        var i = [];
        i[5] = r;
        var t = [];
        t[Iu] = i[5];
        var o = [];
        o[Iu] = t[Iu];
        var u = [];
        (function(n, r, i) {
            n[CG[be]] = r, n[CG[_f]] = i;
        })[so](void 0, n, CG[We], CG[Fc]), u[wo] = PG[Dl] + String[CG[Fv]](d(Rg), d(Ug)), o[Iu][CG[jl]] = PG[vs], o[wo] = l(Sg), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, o[Iu], o[wo]), o[Au] = d(Ig), (function(n, r, i, t, o) {
            n[a(Xg)](r, i, t, o);
        })[so](void 0, o[Iu], o[Au], CG[Zf], CG[gl], CG[Na]), o[Ru] = a(Bg), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, o[Iu], o[Ru]), o[yb] = PG[c(Dg)], (function(n, r) {
            n[CG[El]] = r;
        })[so](void 0, o[Iu], o[yb]), (function(n, r, i, t) {
            n[CG[Fl]](r, i, t);
        })[so](void 0, o[Iu], u[wo], CG[Df], CG[Na]), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, o[Iu], PG[gu]), (function(n, r) {
            n[CG[El]] = r;
        })[so](void 0, o[Iu], PG[Vl]), (function(n, r, i, t) {
            n[CG[Fl]](r, i, t);
        })[so](void 0, o[Iu], u[wo], CG[Xv], CG[Zl]);
        var f = [];
        if (f[c(xu)] = n[CG[Ml]](), f[wo]) return CG[1488](f[wo])[CG[Fu]](CG[bv]);
    }, CG[qg] = function(n, r) {
        var i = [];
        i[6] = r;
        var o = [];
        o[Nb] = i[6];
        var u = [];
        u[Nb] = o[Nb];
        var v = [];
        (function(n, r, i) {
            n[CG[be]] = r, n[CG[_f]] = i;
        })[so](void 0, n, CG[Hl], CG[_e]), u[Nb][l(zg)] = PG[es], v[wo] = CG[ko], v[Au] = PG[e(t(f(28535, 28544), Tr))];
        for(; v[wo] < v[Au][CG[Kf]]; v[wo]++)v[Ru] = v[Au][v[wo]], v[yb] = v[Ru][CG[ko]], v[c(af)][CG[Zf]], v[Ru][CG[Df]], (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, u[e(Tf)], v[yb]), (function(n) {
            n[CG[Ol]]();
        })[so](void 0, u[Nb]), (function(n) {
            n[a(Jg)](CG[ml], CG[ml], CG[ml], CG[ko], PG[as], !0);
        })[so](void 0, u[Nb], void 0, void 0, void 0, void 0), (function(n) {
            n[a(Hg)]();
        })[so](void 0, u[Nb]), u[yb] = PG[c(IE)], (function(n, r) {
            r ? n[CG[ya]](r) : n[CG[ya]]();
        })[so](void 0, u[Nb], u[yb]);
        u[wo] = a($g), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, u[Nb], u[wo]), (function(n) {
            n[a(Jg)](CG[ml], CG[ml], CG[ml], CG[ko], PG[as], !0);
        })[so](void 0, u[Nb], void 0, void 0, void 0, void 0), (function(n) {
            n[a(Jg)](CG[ml], CG[ml], CG[ml], CG[ko], PG[as], !0);
        })[so](void 0, u[Nb], void 0, void 0, void 0, void 0), (function(n, r) {
            r ? n[CG[ya]](r) : n[CG[ya]]();
        })[so](void 0, u[Nb], PG[Ql]);
        var d = [];
        if (d[c(xu)] = n[CG[Ml]](), d[wo]) return CG[1488](d[wo])[CG[Fu]](CG[bv]);
    }, CG[t(f(28544, 28548), Tr)] = function(n) {
        var r = [];
        if (r[wo] = CG[ag](n), r[Au] = CG[yg](r[wo]) ? r[wo][CG[pl]](PG[ns]) : PG[Rv], r[Au]) return {
            Au: (function(n, r) {
                var i = [];
                return CG[Tg](n, CG[We], CG[Fc]), i[wo] = PG[Dl] + String[CG[Fv]](d(Rg), d(Ug)), r[CG[jl]] = PG[vs], CG[Fg](r, l(Sg)), CG[Og](r, d(Ig), CG[Zf], CG[gl], CG[Na]), CG[Fg](r, a(Bg)), CG[gg](r, PG[c(Dg)]), CG[jg](r, i[wo], CG[Df], CG[Na]), CG[Fg](r, PG[gu]), CG[gg](r, PG[Vl]), CG[jg](r, i[wo], CG[Xv], CG[Zl]), CG[wg](n);
            })[so](void 0, r[wo], r[Au]),
            Su: (function(n, r) {
                var i = [];
                CG[Tg](n, CG[Hl], CG[_e]), r[l(zg)] = PG[es], i[wo] = CG[ko], i[Au] = PG[ls];
                for(; i[wo] < i[Au][CG[Kf]]; i[wo]++)i[Ru] = i[Au][i[wo]], i[yb] = i[Ru][CG[ko]], i[c(af)][CG[Zf]], i[Ru][CG[Df]], CG[Fg](r, i[yb]), CG[Zg](r), CG[kg](r), CG[Lg](r), CG[Wg](r, PG[c(IE)]);
                return CG[Fg](r, a($g)), CG[kg](r), CG[e(t(f(28548, 28556), Tr))](r), CG[Wg](r, PG[Ql]), CG[wg](n);
            })[so](void 0, r[wo], r[Au])
        };
    }, PG[c(t(f(28556, 28566), Tr))] = CG[wv], PG[hs] = CG[Xf], PG[ys] = {
        willReadFrequently: !0,
        Eu: !0
    }, CG[Kg] = function() {
        return CG[IM]() * (PG[Uv] + CG[Zf]) | PG[xv];
    }, CG[t(f(28566, 28570), Tr)] = function(n, r) {
        n[Vg](CG[ko], CG[ko], r, r);
    }, CG[Cg] = function(n) {
        var r = [];
        var i = [];
        i[wo] = [], i[Au] = CG[ko];
        for(; i[Au] < PG[ss]; i[e(df)]++){
            i[Ru] = CG[ko];
            for(; i[Ru] < PG[ss]; i[Ru]++)i[c(Nv)] = CG[Wo][CG[bf]](CG[Kg](), CG[Ne])[CG[bf]](CG[Kg](), CG[Ne])[CG[bf]](CG[Kg](), CG[Ne])[CG[bf]](PG[hs]), r[yb] = l(f(28570, 28586))[CG[bf]](i[yb], CG[hu]), (function(n, r) {
                n[s(Eg)] = r;
            })[so](void 0, n, r[yb]), (function(n, r, i, t, o) {
                n[a(Xg)](r, i, t, o);
            })[so](void 0, n, i[Au], i[Ru], CG[Zf], CG[Zf]), i[c(xu)][CG[e(Ip)]](i[yb]);
        }
        return i[wo];
    }, CG[Pg] = function(n) {
        var r = [];
        r[wo] = [], r[Au] = CG[ko];
        for(; r[Au] < PG[ss]; r[Au]++){
            r[Ru] = CG[ko];
            for(; r[Ru] < PG[ss]; r[Ru]++)r[yb] = CG[Gg](n, r[Au], r[Ru], CG[Zf], CG[Zf]), r[yb] ? (r[Du] = r[yb][CG[ko]], r[Iu] = r[yb][CG[Zf]], r[Nb] = r[yb][CG[Df]], r[mb] = r[yb][CG[yv]], r[Su] = CG[Wo][CG[e(Zv)]](r[Du], CG[Ne])[CG[bf]](r[Iu], CG[Ne])[CG[bf]](r[Nb], CG[Ne])[CG[bf]](r[mb]), r[wo][CG[Cf]](r[Su])) : r[wo][CG[Cf]](CG[Wo]);
        }
        return r[wo];
    }, CG[Qg] = function(n) {
        var r = [];
        var i = [];
        if (i[c(xu)] = CG[sg](n), r[wo] = i[c(xu)], !(function(n) {
            return !(!n || !n[CG[pl]]);
        })[so](void 0, r[wo])) return !1;
        if (i[e(df)] = CG[_g](i[wo], PG[ss], PG[ss], PG[ys]), !i[Au]) return !1;
        i[Ru] = CG[Cg](i[Au]), i[yb] = CG[Pg](i[Au]), (function(n, r) {
            n[Vg](CG[ko], CG[ko], r, r);
        })[so](void 0, i[Au], PG[ss]), i[Du] = CG[ko];
        for(; i[Du] < i[c(af)][CG[Kf]]; i[Du]++)if (i[Ru][i[Du]] != i[yb][i[Du]]) return !0;
        return !1;
    }, PG[Ns] = a(f(28586, 28614)), PG[ms] = l(f(28614, 28646)), CG[Yg] = function(n$jscomp$0) {
        var r = [];
        var i = [];
        if (i[wo] = CG[Ib](n$jscomp$0), r[wo] = i[wo][PG[c(t(f(28646, 28656), Tr))]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, r[wo]) && (r[Au] = i[wo][PG[ms]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, r[Au])) && i[wo][PG[Ns]] > i[wo][PG[ms]]) {
            var n = i[wo][PG[Ns]];
            var r$jscomp$0 = i[wo][PG[ms]];
            return r$jscomp$0 !== PG[c(SM)] ? n / r$jscomp$0 : PG[Eu];
        }
        return r[Ru] = CG[tp](n$jscomp$0), CG[Ob](r[Ru]) && r[Ru] !== PG[e(Ec)] ? n$jscomp$0[PG[Fu]] : CG[Zf];
    }, PG[bs] = s(f(28656, 28688)), PG[ps] = s(f(28688, 28716)), CG[nT] = function(n, r) {
        return n[PG[bs]] ? n[PG[c(iT)]](r) : !(!n[PG[ps]][r] || !n[PG[ps]][r][s(rT)]);
    }, PG[Ms] = [
        PG[pv],
        PG[Mv],
        PG[wv]
    ], CG[t(f(28716, 28720), Tr)] = function(n) {
        return (function(n, r) {
            var i = [];
            if (i[wo] = n instanceof Object ? n : Object(n), i[Au] = isFinite(i[wo][CG[Kf]]) ? ~~i[wo][CG[Kf]] : CG[e(Yl)], i[c(af)] = CG[ko], void 0 === r) {
                do if (i[Ru] in i[wo] && void 0 === i[wo][i[Ru]]) return i[Ru];
                while (++i[Ru] < i[Au]);
            } else {
                do if (i[wo][i[Ru]] === r) return i[Ru];
                while (++i[Ru] < i[Au]);
            }
            return -CG[Zf];
        })[so](void 0, n, !0) > -CG[Zf];
    }, CG[e(t(f(28720, 28729), Tr))] = function(n) {
        return !!n[CG[Jl][CG[bf]](PG[bv])];
    }, CG[tT] = function(n) {
        return CG[_p]([
            PG[Ms][CG[ko]] in n,
            PG[Ms][CG[Zf]] in n,
            PG[Ms][CG[Df]] in n
        ], !0) > -CG[Zf];
    }, CG[oT] = function(n) {
        return n[s(Ub)][PG[c(RM)]];
    }, CG[t(f(28729, 28733), Tr)] = function(n) {
        var r = [];
        var i;
        for(i in r[c(xu)] = RegExp(PG[c(uT)]), n)if (r[wo][CG[ie]](i)) return !0;
    }, CG[fT] = function(n) {
        var r = [];
        var i = [];
        return i[wo] = CG[Sb](n), i[Au] = CG[qb](n), !(!(function(n) {
            var r = [];
            var i;
            for(i in r[c(xu)] = RegExp(PG[c(uT)]), n)if (r[wo][CG[ie]](i)) return !0;
        })[so](void 0, n) && !(function(n) {
            var r = [];
            var i;
            for(i in r[c(xu)] = RegExp(PG[c(uT)]), n)if (r[wo][CG[ie]](i)) return !0;
        })[so](void 0, i[wo])) || (r[wo] = [
            PG[mv] in n,
            CG[ru][CG[bf]](PG[Bo]) in n,
            PG[ov] in n,
            CG[ru][CG[bf]](PG[jv]) in n,
            CG[Jl][CG[bf]](PG[mv], CG[ru])[CG[bf]](PG[Ev]) in i[wo],
            CG[Jl][CG[bf]](PG[lv], CG[ru])[CG[bf]](PG[c(pj)]) in i[wo],
            CG[Jl][CG[bf]](PG[mv], CG[ru])[CG[bf]](PG[So]) in i[wo],
            CG[Jl][CG[bf]](PG[jv], CG[ru])[CG[bf]](PG[So]) in i[wo],
            CG[Wl][CG[bf]](PG[lv], CG[ru])[CG[bf]](PG[So]) in i[wo],
            CG[Jl][CG[bf]](PG[lv], CG[ru])[CG[bf]](PG[c(t(f(28733, 28743), Tr))]) in i[wo],
            CG[Jl][CG[bf]](PG[c(RM)], CG[ru])[CG[bf]](PG[gv]) in i[wo],
            CG[Jl][CG[bf]](PG[jv], CG[ru])[CG[bf]](PG[gv]) in i[wo],
            CG[Wl][CG[bf]](PG[lv], CG[ru])[CG[bf]](PG[gv]) in i[wo],
            CG[Jl][CG[bf]](PG[mv], CG[ru])[CG[bf]](PG[Ev]) in i[c(xu)],
            CG[Jl][CG[bf]](PG[mv], CG[ru])[CG[bf]](PG[Xv]) in i[wo],
            CG[nT](i[Au], PG[jv]),
            CG[nT](i[Au], PG[mv]),
            CG[nT](i[c(df)], PG[lv])
        ], CG[_p](r[e(xu)], !0) > -CG[Zf]);
    }, CG[vT] = function(n) {
        var r = [];
        return !!n[CG[_l]] && (function(n) {
            return typeof n === CG[zf];
        })[so](void 0, n[CG[_l]][CG[Fu]]) && (r[wo] = n[CG[_l]][CG[Fu]](), (function(n, r) {
            return n[CG[ov]](r) > -CG[Zf];
        })[so](void 0, r[wo], PG[Do]));
    }, CG[eT] = function(n) {
        return !(!n[PG[dv]] && !n[CG[Wo][CG[bf]](PG[e(RX)], a(f(28743, 28771)))]);
    }, CG[cT] = function(n) {
        return !!n[a(f(28771, 28779))];
    }, CG[dT] = function(n) {
        return !!n[l(f(28779, 28791))];
    }, CG[aT] = function(n) {
        return !!n[s(f(28791, 28799))];
    }, CG[lT] = function(n) {
        var r = [];
        return r[wo] = RegExp(PG[yv]), r[c(xu)][CG[ie]](CG[Rb](n)[PG[qe]]) || r[wo][CG[ie]](CG[Rb](n)[PG[$e]]);
    }, PG[c(t(f(28799, 28809), Tr))] = a(f(28809, 28849)), PG[As] = s(f(28849, 28877)), PG[Fs] = CG[Gl], CG[sT] = function(n) {
        var r = [];
        var i = [];
        i[wo] = CG[Rb](n), i[Au] = CG[Sb](n), i[Ru] = CG[ko], r[wo] = i[wo][PG[ws]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, r[wo]) ? i[e(af)] = i[wo][PG[ws]] : (i[Du] = i[e(xu)][CG[Ee][CG[bf]](CG[cM](PG[ws]))], r[e(of)] = i[Du], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, r[Iu]) && (i[Ru] = i[Du]));
        try {
            i[Au][l(f(28877, 28909))](PG[As]), i[yb] = !0;
        } catch (n) {
            i[yb] = !1;
        }
        return i[Iu] = CG[Jv][CG[bf]](PG[Fs]) in n, {
            Tu: i[Ru],
            Iu: i[yb],
            Du: i[Iu]
        };
    }, PG[c(t(f(28909, 28919), Tr))] = PG[Uf] + PG[Df], PG[c(t(f(28919, 28928), Tr))] = PG[Rf] + PG[Df], PG[Xs] = CG[ko], PG[js] = CG[Zf], PG[c(hT)] = CG[Df], PG[Zs] = l(f(28928, 28972)), PG[Hs] = CG[xl], CG[1589] = function(n, r, i) {
        return (function(n) {
            return typeof n === CG[zf];
        })[so](void 0, n[CG[Rl]]) && i != n[CG[Rl]](r)[l(yT)];
    }, CG[NT] = function(n, r) {
        var i = [];
        var t = [];
        t[wo] = CG[Rb](n), t[Au] = [];
        try {
            t[c(af)] = CG[kA](n), t[c(Nv)] = CG[mM](t[Ru], PG[sl]) || CG[dg](), t[Du] = t[yb] && CG[mM](t[Ru], PG[Ic]), t[Iu] = t[wo][PG[Hs]], t[Iu] && t[Iu][PG[Zs]] && !t[Du] ? (i[mb] = function(n) {
                var i = [];
                i[wo] = t[Iu][PG[Zs]](), i[wo] && i[wo][CG[Pc]] ? i[c(xu)][CG[Pc]](n, function() {
                    return r(t[Au]);
                }) : r(t[Au]);
            }, t[Au] = [
                !1,
                !1,
                !1
            ], i[Nb] = function(n) {
                var i = [];
                if (n) {
                    i[wo] = CG[ko], i[Au] = n;
                    for(; i[wo] < i[Au][CG[Kf]]; i[wo]++)i[Ru] = i[Au][i[wo]], i[yb] = i[Ru][l(f(28972, 28984))], i[yb] !== PG[Os] && i[yb] !== PG[Rf] || (t[Au][PG[Xs]] = !0), i[yb] === PG[Os] && (t[Au][PG[js]] = !0), i[yb] !== PG[Es] && i[yb] !== PG[Uf] || (t[Au][PG[gs]] = !0);
                }
                r(t[Au]);
            }, (function(n) {
                var i = [];
                i[wo] = t[Iu][PG[Zs]](), i[wo] && i[wo][CG[Pc]] ? i[c(xu)][CG[Pc]](n, function() {
                    return r(t[Au]);
                }) : r(t[Au]);
            })[so](void 0, i[Nb])) : r(t[Au]);
        } catch (n) {
            r(t[Au]);
        }
    }, PG[ks] = s(f(28984, 29032)), CG[mT] = function() {
        return (new Date)[PG[ks]]();
    }, CG[bT] = function() {
        var n = [];
        n[wo] = CG[Zw](), n[wo][l(f(29032, 29052))](CG[Zf]), n[wo][CG[Oe]](CG[ko]), n[Au] = n[wo][PG[ks]](), n[wo][CG[Oe]](CG[gf]);
        var r = n[Au];
        var i = n[wo][PG[ks]]();
        return CG[OM](r - i);
    }, CG[pT] = function(n) {
        var r = [];
        if (r[wo] = CG[e(t(f(29052, 29062), Tr))](n), void 0 !== r[wo]) return CG[Gb](r[wo] + (function(n) {
            return CG[Sw](n) ? CG[Uw](n)[PG[Po]]() : PG[Oe]();
        })[so](void 0, n))[CG[Jo]](function(n) {
            return CG[wM]()[PG[Vv]](n);
        })[CG[Jo]](function(n) {
            var r = [];
            return r[wo] = CG[OM](n - PG[Oe]()) / CG[kv], CG[wM]()[PG[c(EM)]](r[wo]);
        })[CG[Zo]]();
    }, CG[MT] = function(n) {
        var r = [];
        var i = [];
        if (i[c(xu)] = [], !(CG[Zb](Object, PG[zf]) && CG[Zb](Object, PG[$f]) && CG[Zb](Object, PG[xo]))) return i[wo];
        i[Au] = CG[Rb](n), i[Ru] = i[Au];
        do {
            i[yb] = CG[ko], i[Du] = CG[ku](i[Ru]);
            for(; i[yb] < i[Du][CG[Kf]]; i[yb]++)i[Iu] = i[Du][i[yb]], i[wo][CG[Cf]](i[Iu]);
            i[Ru] = (r[yb] = i[c(af)], (function(n) {
                return Object[PG[$f]](n);
            })[so](void 0, r[yb]));
        }while (i[Ru]);
        i[Nb] = [], i[Su] = CG[ko], i[hf] = i[wo];
        for(; i[e(ef)] < i[hf][CG[Kf]]; i[Su]++)i[c(of)] = i[hf][i[Su]], i[c(sf)] = CG[Hb](CG[Ju](i[Au]), i[c(of)]), r[yf] = i[e(sf)], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, r[yf]) ? (r[mf] = i[c(sf)][CG[Ul]], (function(n) {
            return !CG[Xb](n);
        })[so](void 0, r[mf]) ? i[mb] = i[To][CG[Ul]][CG[Fu]]() : (function(n) {
            return !CG[Xb](n);
        })[so](void 0, i[To][CG[cd]]) && (i[mb] = i[To][CG[cd]][CG[Fu]]())) : i[mb] = PG[$o], i[Nb][CG[Cf]](CG[Wo][CG[bf]](i[Iu], s(f(29062, 29070)))[CG[bf]](i[mb]));
        return i[Nb];
    }, PG[e(t(f(29070, 29080), Tr))] = a(f(29080, 29104)), PG[Ws] = a(f(29104, 29120)), PG[_s] = l(f(29120, 29152)), CG[wT] = function(n, r) {
        switch(n[PG[_s]](r[CG[tv]]("'", CG[yu]))){
            case PG[Js]:
                return CG[Df];
            case PG[Ws]:
                return CG[Zf];
            case PG[$o]:
                return CG[ko];
            default:
                return CG[yv];
        }
    }, CG[AT] = function(n, r) {
        var i = CG[Wo][CG[e(Zv)]](PG[Rf], CG[Nu])[CG[bf]](r);
        switch(n[PG[_s]](i[CG[tv]]("'", CG[yu]))){
            case PG[Js]:
                return CG[Df];
            case PG[Ws]:
                return CG[Zf];
            case PG[$o]:
                return CG[ko];
            default:
                return CG[yv];
        }
    }, CG[FT] = function(n, r) {
        var i = CG[Wo][CG[bf]](PG[Uf], CG[Nu])[CG[bf]](r);
        switch(n[PG[_s]](i[CG[tv]]("'", CG[yu]))){
            case PG[Js]:
                return CG[Df];
            case PG[Ws]:
                return CG[Zf];
            case PG[$o]:
                return CG[ko];
            default:
                return CG[yv];
        }
    }, PG[Gs] = a(f(29152, 29160)), PG[xs] = a(f(29160, 29168)), PG[Rs] = l(f(29168, 29184)), PG[Us] = s(f(29184, 29200)), PG[Ss] = CG[Wo][CG[bf]](PG[Gs], CG[Sl])[CG[bf]](PG[Us], CG[Il])[CG[bf]](PG[Rs], CG[yu]), PG[Is] = s(f(29200, 29212)), PG[e(t(f(29212, 29221), Tr))] = CG[Wo][CG[bf]](PG[xs], CG[Sl])[CG[bf]](PG[Us], a(f(29221, 29229))), PG[Ds] = l(f(29229, 29245)), PG[c(t(f(29245, 29256), Tr))] = s(f(29256, 29264)), CG[1611] = function(n) {
        var r = [];
        var i = [];
        return i[wo] = CG[dp](n, PG[Rf]), [
            (r[wo] = i[c(xu)], (function(n, r) {
                return CG[wT](n, CG[Wo][CG[bf]](PG[Rf], CG[Nu])[CG[bf]](r));
            })[so](void 0, r[wo], PG[qs])),
            (function(n, r) {
                return CG[wT](n, CG[Wo][CG[bf]](PG[Rf], CG[Nu])[CG[bf]](r));
            })[so](void 0, i[wo], PG[Ds]),
            (function(n, r) {
                return CG[wT](n, CG[Wo][CG[bf]](PG[Rf], CG[Nu])[CG[bf]](r));
            })[so](void 0, i[e(xu)], PG[Bs]),
            (function(n, r) {
                return CG[wT](n, CG[Wo][CG[bf]](PG[Rf], CG[Nu])[CG[bf]](r));
            })[so](void 0, i[wo], PG[Is]),
            (function(n, r) {
                return CG[wT](n, CG[Wo][CG[bf]](PG[Rf], CG[Nu])[CG[bf]](r));
            })[so](void 0, i[wo], PG[Ss])
        ];
    }, PG[c(ET)] = a(f(29264, 29280)), PG[$s] = l(f(29280, 29312)), PG[mu] = s(f(29312, 29344)), PG[Ks] = l(f(29344, 29352)), PG[Vs] = a(f(29352, 29364)), PG[Cs] = CG[Wo][CG[bf]](PG[Gs], CG[Sl])[CG[bf]](PG[Us], CG[Il])[CG[bf]](PG[c(ET)], CG[yu]), PG[Ps] = CG[Wo][CG[bf]](PG[Ks], CG[Sl])[CG[bf]](PG[Us], CG[Il])[CG[bf]](PG[$s], CG[yu]), PG[Ys] = CG[Wo][CG[bf]](PG[Vs], CG[Sl])[CG[bf]](PG[Us], CG[Il])[CG[bf]](PG[mu], CG[yu]), CG[t(f(29364, 29368), Tr)] = function(n) {
        var r = [];
        return r[wo] = CG[dp](n, PG[Uf]), [
            (function(n, r) {
                return CG[wT](n, CG[Wo][CG[bf]](PG[Uf], CG[Nu])[CG[bf]](r));
            })[so](void 0, r[wo], PG[Ys]),
            (function(n, r) {
                return CG[wT](n, CG[Wo][CG[e(Zv)]](PG[Uf], CG[Nu])[CG[bf]](r));
            })[so](void 0, r[wo], PG[Ps]),
            (function(n, r) {
                return CG[wT](n, CG[Wo][CG[bf]](PG[Uf], CG[Nu])[CG[bf]](r));
            })[so](void 0, r[e(xu)], PG[Cs])
        ];
    }, CG[OT] = function(n) {
        try {
            return (function(n) {
                var r = [];
                return r[wo] = CG[dp](n, PG[Uf]), [
                    CG[FT](r[e(xu)], PG[Ys]),
                    CG[FT](r[wo], PG[Ps]),
                    CG[FT](r[wo], PG[Cs])
                ];
            })[so](void 0, n)[CG[bf]]((function(n) {
                var r = [];
                return r[wo] = CG[dp](n, PG[Rf]), [
                    CG[AT](r[c(e(ff))], PG[qs]),
                    CG[AT](r[wo], PG[Ds]),
                    CG[AT](r[wo], PG[Bs]),
                    CG[AT](r[wo], PG[Is]),
                    CG[AT](r[wo], PG[Ss])
                ];
            })[so](void 0, n));
        } catch (n) {
            return [];
        }
    }, CG[XT] = function(n) {
        var r = [];
        r[wo] = CG[Gj](), r[wo][CG[ka]] && r[c(xu)][CG[ka]](n);
    }, CG[jT] = function(n) {
        try {
            return n();
        } catch (n) {
            (function(n) {
                var r = [];
                r[wo] = CG[e(t(f(29368, 29377), Tr))](), r[wo][CG[ka]] && r[c(xu)][CG[ka]](n);
            })[so](void 0, n);
        }
    }, CG[gT] = function() {
        PG[rh]++, CG[gT]();
    }, CG[TT] = function() {
        PG[rh] = CG[ko];
        try {
            CG[gT]();
        } catch (n) {
            return {
                Lu: PG[rh],
                Ru: n[CG[ll]],
                Ou: n[CG[Jf]],
                Pu: n[CG[Bl]] ? n[CG[Bl]][CG[Fu]]()[CG[Kf]] : PG[xv]
            };
        }
        return {
            Lu: PG[xv],
            Ru: PG[$o],
            Ou: PG[$o],
            Pu: PG[xv]
        };
    }, CG[ZT] = function() {
        var n;
        try {
            return [][wo][CG[qo]], CG[Wo];
        } catch (n) {
            return n[CG[ll]];
        }
    }, CG[LT] = function() {
        try {
            throw CG[Wo];
        } catch (n) {
            try {
                return n[l(f(29377, 29401))](), !0;
            } catch (n) {}
        }
        return !1;
    }, PG[ih] = s(f(29401, 29489)), PG[th] = CG[Wo][CG[bf]](PG[ih], CG[Ro]), PG[oh] = a(f(29489, 29537)), PG[uh] = s(f(29537, 29637)), PG[e(t(f(29637, 29646), Tr))] = a(f(29646, 29702)), PG[eh] = l(f(29702, 29842)), PG[ch] = l(f(29842, 29974)), PG[dh] = s(f(29974, 29990)), PG[ah] = l(f(29990, 30014))[CG[bf]](PG[dh]), PG[lh] = a(f(30014, 30030))[CG[bf]](PG[c(t(f(30030, 30039), Tr))]), PG[sh] = CG[Zf], PG[hh] = CG[Df], PG[yh] = CG[yv], PG[Nh] = CG[Xv], PG[c(HT)] = CG[re], PG[bh] = CG[gf], PG[ph] = CG[xw], CG[t(f(30039, 30043), Tr)] = function(n, r) {
        var i = [];
        i[0] = r;
        var t = [];
        t[wo] = i[0];
        var o = [];
        o[wo] = t[wo];
        var u = [];
        return u[wo] = (((n & CG[Dl]) << CG[yv] | o[wo] & CG[xw]) & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + u[wo])[CG[iv]](-CG[Df]);
    }, CG[kT] = function(n, r, i, t) {
        return CG[Gb](CG[$M]((n & CG[Dl]) << CG[yv] | r & CG[xw]))[CG[Jo]](function(o) {
            var u = [];
            var f = [];
            switch(r){
                case PG[bh]:
                    return CG[QM](o, (u[wo] = CG[qM](CG[AM](i * CG[mv]), PG[xv], CG[Xf]), (function(n) {
                        var r = [];
                        return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
                    })[so](void 0, u[wo])));
                case PG[yh]:
                    return CG[QM](o, (function(n) {
                        var r = [];
                        return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
                    })[so](void 0, i));
                case PG[e(HT)]:
                    return f[wo] = CG[qM](i, -CG[zl], CG[zl]) & CG[zl], CG[QM](o, f[wo] > CG[$l] ? (u[Au] = CG[Zf] << CG[Mv] | f[c(xu)], (function(n, r) {
                        var i = [];
                        i[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * r) - CG[Zf], n), i[Au] = PG[$o], i[Ru] = r * CG[Df];
                        for(; i[wo] > CG[ko];)i[Au] = CG[$M](i[wo]) + i[Au], i[wo] = i[wo] >>> CG[wv];
                        if (i[e(af)]) for(; i[Au][CG[Kf]] < i[Ru];)i[Au] = CG[QM](CG[Io], i[Au]);
                        return i[Au];
                    })[so](void 0, u[Au], CG[Df])) : (function(n) {
                        var r = [];
                        return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
                    })[so](void 0, f[wo]));
                case PG[Nh]:
                    return CG[QM](o, CG[fA](i, [
                        n
                    ][CG[bf]](t)));
                case PG[ph]:
                    return CG[QM](o, i);
                default:
                    return o;
            }
        })[CG[Zo]]();
    }, PG[Mh] = CG[ko], PG[Ah] = CG[Zf], PG[Fh] = CG[Df], PG[Eh] = CG[yv], PG[Oh] = CG[Xv], PG[Xh] = CG[re], PG[c(t(f(30043, 30052), Tr))] = CG[gf], PG[gh] = CG[xw], PG[c(t(f(30052, 30063), Tr))] = CG[wv], PG[Zh] = CG[Te], PG[Lh] = CG[mv], PG[Hh] = CG[Le], PG[c(kh)] = CG[Cv], PG[Jh] = CG[ke], PG[Wh] = CG[Tv], PG[_h] = CG[Mv], PG[Gh] = CG[bv], PG[xh] = CG[fl], PG[Rh] = CG[Yv], PG[Uh] = CG[el], PG[Sh] = CG[Na], PG[Ih] = CG[Vl], PG[Bh] = CG[e(Ij)], PG[484] = CG[gu], PG[Dh] = CG[Ev], PG[qh] = CG[Ql], PG[zh] = CG[ns], PG[$h] = CG[rs], PG[Kh] = CG[ts], PG[Vh] = CG[us], PG[Ch] = CG[pa], PG[Ph] = CG[Dl], PG[Qh] = CG[ko], PG[Yh] = CG[Zf], PG[ny] = CG[Df], PG[ry] = CG[re], PG[iy] = CG[gf], PG[ty] = CG[mv], PG[oy] = CG[Le], PG[uy] = CG[Cv], PG[fy] = CG[ke], PG[vy] = CG[Tv], PG[ey] = CG[Mv], PG[cy] = CG[bv], PG[dy] = CG[fl], PG[JT] = CG[Yv], PG[ay] = CG[el], PG[ly] = CG[Na], PG[sy] = CG[Vl], PG[hy] = CG[Zl], PG[yy] = CG[gu], PG[Ny] = CG[Ev], PG[my] = CG[Ql], PG[by] = CG[ns], PG[py] = CG[rs], PG[c(t(f(30063, 30073), Tr))] = CG[ts], PG[wy] = CG[us], PG[bu] = CG[pa], PG[Ay] = CG[ko], PG[c(t(f(30073, 30084), Tr))] = CG[Zf], PG[Ey] = CG[Df], PG[Oy] = CG[yv], PG[Xy] = CG[Xv], PG[jy] = CG[re], PG[gy] = CG[gf], PG[Ty] = CG[xw], PG[Zy] = CG[wv], PG[528] = CG[Te], PG[Ly] = CG[mv], PG[Hy] = CG[Le], PG[c(t(f(30084, 30093), Tr))] = CG[Cv], PG[Jy] = CG[ke], PG[WT] = CG[Tv], PG[Wy] = CG[Mv], PG[_y] = CG[bv], PG[c(t(f(30093, 30104), Tr))] = CG[fl], PG[xy] = CG[Yv], PG[Ry] = CG[el], PG[Uy] = CG[Na], PG[Sy] = CG[Vl], PG[Iy] = CG[Zl], PG[By] = CG[gu], PG[Dy] = CG[Ev], PG[qy] = CG[Ql], PG[zy] = CG[ns], PG[c(_T)] = CG[rs], PG[Ky] = CG[ts], PG[Vy] = CG[Zf], PG[Cy] = CG[Df], PG[Py] = CG[yv], PG[Qy] = CG[Xv], PG[Yy] = CG[re], PG[nN] = CG[gf], PG[rN] = CG[xw], PG[iN] = CG[wv], PG[tN] = CG[Te], PG[oN] = CG[mv], PG[c(t(f(30104, 30114), Tr))] = CG[Le], PG[fN] = CG[Cv], PG[vN] = CG[ke], PG[eN] = CG[Tv], PG[cN] = CG[Mv], PG[dN] = CG[bv], PG[aN] = CG[fl], PG[lN] = CG[Yv], PG[pu] = CG[el], PG[sN] = CG[Na], PG[hN] = CG[Vl], PG[c(t(f(30114, 30124), Tr))] = CG[gu], PG[NN] = CG[Ev], PG[mN] = CG[Ql], PG[bN] = CG[ns], PG[pN] = CG[ts], PG[MN] = CG[us], PG[c(GT)] = CG[pa], PG[c(xT)] = CG[Dl], PG[FN] = CG[e(Yl)], PG[EN] = CG[Zf], PG[ON] = CG[Df], PG[XN] = CG[yv], PG[e(t(f(30124, 30135), Tr))] = CG[Xv], PG[gN] = CG[re], PG[TN] = CG[gf], PG[ZN] = CG[xw], PG[LN] = CG[wv], PG[HN] = CG[Te], PG[kN] = CG[mv], PG[JN] = CG[Le], PG[WN] = CG[Cv], PG[_N] = CG[ke], PG[GN] = CG[Tv], PG[xN] = CG[Mv], PG[RN] = CG[bv], PG[UN] = CG[fl], PG[SN] = CG[Yv], PG[IN] = CG[el], PG[BN] = CG[Na], PG[c(RT)] = CG[Vl], PG[c(UT)] = CG[Zl], PG[zN] = CG[gu], PG[$N] = CG[Ev], PG[KN] = CG[Ql], PG[VN] = CG[ns], PG[CN] = CG[rs], PG[PN] = CG[ts], PG[QN] = CG[us], PG[YN] = CG[pa], PG[nm] = CG[Dl], PG[rm] = {
        au: !1,
        Ge: !1,
        ju: !1,
        Hu: !1
    }, CG[ST] = function(n) {
        var r = [];
        var i = [];
        i[wo] = CG[Gj](), PG[rm][CG[Ia]] = i[wo][CG[Ia]], PG[rm][CG[Ua]] = i[wo][CG[Ua]], r[wo] = function() {
            CG[IT](n);
        }, (function(n) {
            setTimeout(n, CG[ko]);
        })[so](void 0, r[wo]);
    }, CG[IT] = function(n) {
        var r = [];
        PG[rm][CG[vs]] = !!n[PG[we]], r[wo] = function() {
            PG[rm][CG[vs]] && (PG[rm][a(f(30135, 30143))] = !0);
        }, (function(n, r, i, t) {
            var o = [];
            try {
                o[wo] = n[PG[we]], o[wo] || t(), o[wo][CG[Wv]](r, i), o[wo][CG[_v]](r) !== i && (o[wo][CG[Gv]](r), t());
            } catch (n) {
                t();
            }
        })[so](void 0, n, PG[dl], PG[al], r[wo]), (function(n, r) {
            var i = [];
            try {
                if (i[wo] = n[PG[we]], !i[wo]) return;
                return i[wo][CG[Gv]](r);
            } catch (n) {}
        })[so](void 0, n, PG[dl]);
    }, CG[BT] = function() {
        return PG[rm];
    }, PG[im] = l(f(30143, 30199)), CG[DT] = function(n, r, i) {
        var t = [];
        try {
            if (!n) return void i(PG[Eu]);
            PG[im] in n ? (t[wo] = n[PG[im]](r), t[wo][CG[Pc]](function(n) {
                i(n);
            }, function() {
                i(PG[Rv]);
            })) : i(PG[Eu]);
        } catch (n) {
            i(PG[Rv]);
        }
    }, PG[tm] = CG[dM](l(f(30199, 30223)), CG[Fu]), PG[om] = {}, CG[qT] = function() {
        return !1;
    }, CG[zT] = function() {
        return !1;
    }, CG[$T] = function() {
        return {
            data: {},
            total: CG[ko]
        };
    }, CG[KT] = function() {
        return PG[um];
    }, CG[VT] = function() {
        PG[Tu] = !!(function() {
            return !1;
        })[so](void 0, void 0), PG[Zu] = !!(function() {
            return !1;
        })[so](void 0, void 0, void 0);
    }, CG[CT] = function() {}, CG[PT] = function() {
        var n = [];
        n[wo] = CG[KT](), (function(n) {
            n && n[CG[Rf]] && n[CG[Rf]][CG[xf]](n);
        })[so](void 0, n[wo]);
    }, PG[fm] = l(f(30223, 30231)), PG[vm] = a(f(30231, 30307)), PG[em] = s(f(30307, 30331)), CG[QT] = function(n, r) {
        return n[PG[e(t(f(30331, 30342), Tr))]] && (function(n) {
            return typeof n === CG[zf];
        })[so](void 0, n[PG[fm]][CG[es]]) && n[PG[fm]][CG[es]](r);
    }, CG[t(f(30342, 30346), Tr)] = function(n) {
        var r = n;
        var i = PG[Uo];
        return r[PG[fm]] && CG[Lp](r[PG[fm]][CG[es]]) && r[PG[fm]][CG[es]](i);
    }, CG[t(f(30346, 30350), Tr)] = function(n) {
        var r = [];
        return r[wo] = CG[tF](n), !(!r[wo] || !r[e(xu)][CG[Cc]]);
    }, CG[YT] = function(n, r) {
        return CG[Rb](n)[CG[oM](PG[Yf])][CG[Cc]]({
            name: PG[Qf][CG[nv]]() + CG[Po]
        })[CG[Pc]](function(i) {
            var t = [];
            r(i[CG[Qc]] == PG[Go] && (t[wo] = n, PG[e(jX)] in t[wo] && t[wo][PG[Qf]][nZ] === PG[cv]));
        })[CG[Yc]](function() {
            return r(!1);
        });
    }, CG[rZ] = function(n) {
        return PG[Qf] in n && n[PG[Qf]][nZ] === PG[cv];
    }, CG[iZ] = function(n, r, i, o) {
        var u = [];
        var v = [];
        if (CG[eg]() !== PG[Nu] || i) return !1;
        v[wo] = r;
        try {
            return r || (v[wo] = (function(n, r) {
                return CG[Sb](n)[s(ap)](r);
            })[so](void 0, n, PG[Gf]), u[Au] = CG[$b](n), (function(n, r) {
                n && n[a(ep)](r);
            })[so](void 0, u[Au], v[wo])), !!v[wo] && !!n[CG[cs]] && (o ? (function(n, r, i) {
                return n[s(fp)](r, i);
            })[so](void 0, v[wo], PG[Jf], PG[em]) : (u[Ru] = PG[c(t(f(30350, 30360), Tr))], (function(n, r, i) {
                return n[s(fp)](r, i);
            })[so](void 0, v[wo], PG[kf], u[Ru])), v[Au] = n[CG[e(kl)]](v[wo])[l(f(30360, 30400))], v[Au] === CG[Wo][CG[bf]](PG[Fv], a(f(30400, 30416)))[CG[bf]](PG[xv], CG[Ne])[CG[bf]](PG[xv], CG[hu]));
        } finally{
            r || (u[Du] = CG[$b](n), (function(n, r) {
                n && n[CG[xf]](r);
            })[so](void 0, u[Du], v[e(xu)]));
        }
    }, CG[t(f(30416, 30420), Tr)] = function(n) {
        var r = n;
        var i = PG[fv];
        return CG[e(Dw)](r[CG[Rl]]) && 0 != r[CG[Rl]](i)[l(yT)];
    }, CG[tZ] = function(n, r) {
        return CG[DT](n, [], function(n) {
            var i = [];
            r((i[wo] = n, CG[Ob](i[wo]) && i[wo] !== PG[Eu] ? n[PG[Be]] === PG[$o] : null));
        });
    }, CG[oZ] = function(n) {
        var r = [];
        return r[wo] = CG[Rb](n), PG[Io] in r[wo] && !1 === r[wo][PG[Io]];
    }, CG[uZ] = function(n) {
        return (n[l(Vb)] || CG[ko]) === (CG[Ib](n)[CG[be]] || CG[ko]) && (n[l(rp)] || CG[ko]) === (CG[Ib](n)[CG[_f]] || CG[ko]) || n[PG[qf]] && ~~n[PG[qf]][CG[be]] === (CG[Ib](n)[CG[be]] || CG[ko]) && ~~n[PG[qf]][CG[_f]] === (CG[Ib](n)[CG[_f]] || CG[ko]);
    }, CG[fZ] = function() {
        return !!PG[om][(function(n, r) {
            return n + CG[Ro] + r;
        })[so](void 0, PG[nv], PG[mv])];
    }, CG[vZ] = function(n) {
        var r = [];
        var i = [];
        return i[wo] = CG[Rb](n), CG[eg]() === PG[Nu] && (r[wo] = n, (function(n, r) {
            return n[PG[fm]] && CG[Lp](n[PG[fm]][CG[es]]) && n[PG[fm]][CG[es]](r);
        })[so](void 0, r[wo], PG[Ro])) && (!(PG[qo] in i[c(xu)]) || !(PG[c(wX)] in i[wo]));
    }, PG[eZ] = l(f(30420, 30464)), PG[cm] = l(f(30464, 30512)), CG[cZ] = function(n) {
        var r = [];
        return CG[eg]() !== PG[Nu] ? {} : (r[wo] = function() {
            return CG[dZ](n);
        }, (function(n) {
            try {
                return n();
            } catch (n) {}
        })[so](void 0, r[wo]) || {});
    }, CG[dZ] = function(n) {
        var r = [];
        return r[wo] = PG[wb] in n[PG[eZ]][PG[Wo]], r[c(df)] = CG[QT](n, PG[tv]), r[Ru] = PG[ev] in n, r[yb] = PG[vv] in n, r[Du] = n[PG[cm]] && PG[av] in (n[PG[e(t(f(30512, 30523), Tr))]][PG[Wo]] || {}), {
            Bu: r[Au] && !r[Ru],
            qu: r[wo] && !r[yb],
            Ku: !r[c(vf)]
        };
    }, CG[aZ] = function(n) {
        return n;
    }, PG[dm] = CG[Bp]([
        PG[$e],
        PG[Ie],
        PG[fc],
        PG[Ye],
        PG[Qe],
        PG[Qe] + CG[Po],
        PG[dc],
        PG[Be],
        PG[qe],
        PG[De],
        PG[vc],
        PG[nc],
        PG[ws]
    ], function(n) {
        return PG[nv] + CG[Ro] + n;
    }), PG[am] = CG[Bp]([
        CG[aZ](CG[be]),
        CG[aZ](CG[_f]),
        CG[aZ](CG[pe]),
        CG[aZ](CG[Me]),
        CG[aZ](CG[le]),
        CG[aZ](CG[se])
    ], function(n) {
        var r = [];
        return r[wo] = CG[aZ](CG[ds]), r[wo] + CG[Ro] + n;
    }), PG[lm] = [
        CG[dM](l(f(30523, 30535)), PG[ks]),
        CG[dM](l(f(30535, 30599)), PG[Nc]),
        CG[dM](s(f(30599, 30651)), PG[Nc])
    ], PG[sm] = [
        CG[dM](s(f(30651, 30667)), CG[aZ](l(f(30667, 30703))))
    ], PG[hm] = CG[Bp]([
        CG[aZ](CG[as]),
        CG[aZ](a(f(30703, 30719))),
        CG[aZ](CG[ls])
    ], function(n) {
        var r = [];
        return r[wo] = CG[aZ](s(f(30719, 30743))), r[wo] + CG[Ro] + n;
    })[CG[bf]](PG[sm])[CG[bf]]([
        CG[dM](l(f(30743, 30795)), CG[aZ](CG[Uf])),
        CG[dM](l(f(30795, 30835)), CG[e(t(f(30835, 30844), Tr))](CG[Uf]))
    ]), PG[ym] = CG[Bp]([
        CG[aZ](CG[e(Jj)]),
        CG[aZ](CG[pl])
    ], function(n) {
        var r = [];
        return r[wo] = CG[aZ](CG[ss]), r[wo] + CG[Ro] + n;
    }), PG[Nm] = PG[ym][CG[bf]]([]), CG[Au] = [
        CG[aZ](CG[wl]),
        CG[aZ](CG[Al]),
        CG[aZ](l(f(30844, 30904)))
    ], CG[Ru] = function(n) {
        PG[Nm][CG[Cf]](CG[dM](CG[aZ](a(f(30904, 30960))), n)), PG[Nm][CG[Cf]](CG[dM](CG[aZ](a(f(30960, 31020))), n));
    }, (function(n, r) {
        var i = [];
        i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
        for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
    })[so](void 0, CG[Au], CG[Ru]), PG[mm] = CG[Bp]([
        CG[aZ](a(f(31020, 31084))),
        CG[aZ](a(f(31084, 31148))),
        CG[aZ](a(f(31148, 31204))),
        CG[aZ](s(f(31204, 31264))),
        CG[aZ](a(f(31264, 31320))),
        CG[aZ](l(f(31320, 31380))),
        CG[aZ](CG[be])
    ], function(n) {
        var r = [];
        return r[wo] = CG[aZ](l(f(31380, 31412))), r[wo] + CG[Ro] + n;
    }), PG[Mu] = CG[Bp]([
        CG[aZ](CG[Fl]),
        CG[aZ](CG[e(t(f(31412, 31421), Tr))]),
        CG[aZ](CG[Xl]),
        CG[aZ](l(f(31421, 31449)))
    ], function(n) {
        var r = [];
        return r[wo] = CG[aZ](a(f(31449, 31513))), r[wo] + CG[Ro] + n;
    })[CG[bf]](PG[mm])[CG[bf]](PG[ym])[CG[bf]](PG[sm]), PG[bm] = CG[Bp]([
        CG[aZ](l(f(31513, 31553))),
        CG[aZ](a(f(31553, 31593)))
    ], function(n) {
        var r = [];
        return r[wo] = CG[aZ](a(f(31593, 31625))), r[wo] + CG[Ro] + n;
    }), CG[lZ] = function(n) {
        return (function(n, r) {
            var i = [];
            i[wo] = [], i[c(df)] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[c(af)][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[Au]], r(i[yb]) && i[wo][CG[Cf]](i[yb]);
            return i[wo];
        })[so](void 0, n, function(n) {
            return PG[om][n];
        })[CG[Kf]];
    }, CG[sZ] = function() {
        var r = [
            PG[dm],
            PG[e(t(f(31625, 31635), Tr))],
            PG[lm],
            PG[hm],
            PG[Nm],
            PG[c(t(f(31635, 31646), Tr))],
            PG[mm],
            PG[bm]
        ];
        var n = [];
        n[wo] = [], n[Au] = CG[ko], n[Ru] = r;
        for(; n[Au] < n[Ru][CG[Kf]]; n[c(df)]++)n[yb] = n[Ru][n[c(df)]], n[wo][CG[Cf]]((function(n) {
            return CG[lZ](n);
        })[so](void 0, n[yb]));
        return n[wo];
    }, CG[hZ] = function(n) {
        var r = [];
        if (r[c(xu)] = CG[tp](n), r[Au] = CG[Ib](n), r[Ru] = CG[dg]() && r[c(xu)] != CG[Zf], !r[Ru]) return r[yb] = CG[1589](n, "("[CG[bf]](PG[Se], s(f(31646, 31666)))[CG[bf]](r[Au][CG[be]])[CG[bf]](PG[Bf], s(f(31666, 31686)))[CG[bf]](PG[Se], l(f(31686, 31710)))[CG[e(Zv)]](r[Au][CG[_f]])[CG[bf]](PG[Bf], CG[hu]), !0), !!r[c(Nv)];
    }, CG[t(f(31710, 31714), Tr)] = function(n) {
        var r = [];
        if (r[wo] = CG[tp](n), r[Au] = CG[1589](n, a(f(31714, 31746))[CG[bf]](r[wo], a(f(31746, 31754)))[CG[bf]](PG[Bf], CG[hu]), !0), CG[eg]() !== PG[Il]) return !!r[Au];
    }, CG[yZ] = function(n) {
        var r = [];
        return r[wo] = CG[Ib](n), r[Au] = !(r[wo][CG[be]] - r[wo][CG[pe]] || r[wo][CG[_f]] - r[wo][CG[Me]]), r[wo][CG[be]] > CG[hs] && r[e(df)];
    }, CG[NZ] = function(n, r) {
        var i = [];
        var t = [];
        return t[wo] = !1, i[wo] = function(n) {
            var r = [];
            try {
                r[wo] = CG[Ju](n[CG[ko]])[CG[kf]][CG[Jf]] == s(f(31754, 31778)), r[wo] || (t[wo] = !0);
            } catch (n) {
                t[wo] = !0;
            }
        }, (function(n, r) {
            var i = [];
            i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
        })[so](void 0, n, i[wo]), t[Au] = CG[Rp](CG[ku](r), function(n) {
            return isNaN(+n);
        }), t[Ru] = CG[Bp](n, function(n) {
            return CG[rM]((function(n) {
                var r = [];
                if (CG[Pf] in Object) return Object[CG[Pf]](n);
                var i;
                for(i in r[wo] = [], n)CG[Zb](n, i) && r[wo][CG[Cf]](n[i]);
                return r[wo];
            })[so](void 0, n));
        }), t[yb] = CG[Bp](t[Ru], function(n) {
            return n && n[CG[we]];
        }), i[Au] = function(n) {
            CG[Pp](t[Au], n) || CG[Yp](t[c(df)], n);
        }, (function(n, r) {
            var i = [];
            i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
        })[so](void 0, t[yb], i[Au]), i[Ru] = function(n) {
            var r = [];
            r[wo] = CG[Bp](CG[qp](n), function(n) {
                return n && n[CG[we]];
            }), CG[Dp](r[wo], function(n) {
                CG[Pp](t[Au], n) || (t[wo] = !0);
            });
        }, (function(n, r) {
            var i = [];
            i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
        })[so](void 0, n, i[Ru]), t[wo];
    }, CG[mZ] = function(n) {
        var i = [];
        try {
            return i[wo] = CG[dp](n, PG[Hf]), i[wo][l(f(31778, 31794))] = (function(n) {
                var i = [];
                if (n[PG[Re]]) {
                    if (n[PG[Re]][PG[Ue]] && n[PG[Re]][PG[xe]]) return CG[sA](n);
                    n[PG[Re]][PG[Ge]] && (i[wo] = CG[lA](n));
                }
                return i[wo] || (i[wo] = CG[aA]()[CG[Yf]](PG[$o])), i[wo][CG[Cv]] = CG[Vo], i[wo][CG[bv]] = CG[YM](r(i[wo][CG[bv]], CG[bv]) & CG[yv] | CG[wv]), i[wo][CG[jf]](PG[$o]);
            })[so](void 0, n), !!i[c(xu)][CG[ys]];
        } catch (n) {
            return !0;
        }
    }, CG[bZ] = function(n) {
        var r = [];
        var i = [];
        return i[wo] = -CG[yl], r[wo] = CG[Kp](n)[CG[iv]](i[wo]), (function(n, r) {
            var i = [];
            i[wo] = CG[ko];
            for(; i[wo] < n[CG[Kf]]; i[wo]++)if (n[i[wo]] === r) return !0;
            return !1;
        })[so](void 0, r[wo], PG[lc]) && (r[Au] = CG[ku](n)[CG[iv]](i[c(xu)]), (function(n, r) {
            var i = [];
            i[wo] = CG[ko];
            for(; i[wo] < n[CG[Kf]]; i[wo]++)if (n[i[wo]] === r) return !0;
            return !1;
        })[so](void 0, r[Au], PG[lc]));
    }, CG[pZ] = function(n) {
        var r = [];
        if (!CG[Lb](n, PG[lc]) || !(PG[Cf] in n[PG[c(t(f(31794, 31804), Tr))]])) return !1;
        try {
            return r[wo] = n[PG[lc]][PG[Cf]], PG[Wo] in r[wo][CG[Ns]] || PG[Wo] in r[wo][CG[ms]] || (new r[wo][CG[Ns]], new r[wo][CG[e(t(f(31804, 31815), Tr))]]), !0;
        } catch (n) {
            return (function(n) {
                if (CG[jb](n)) return n[CG[kf]][CG[Jf]];
            })[so](void 0, n) !== PG[xf];
        }
    }, CG[MZ] = function() {
        return !!PG[om][PG[tm]];
    }, PG[pm] = a(f(31815, 31827)), PG[Mm] = l(f(31827, 31875)), CG[wZ] = function(n) {
        var r = [];
        return r[wo] = CG[Rb](n), r[Au] = CG[cM](PG[sc]), r[Ru] = a(f(31875, 31883))[CG[bf]](r[Au]), r[yb] = CG[MF](r[wo]) && CG[Jb](CG[Ju](r[wo][PG[sc]])) == r[Au] && CG[NM](r[wo][PG[sc]][r[Ru]]) == l(f(31883, 31907))[CG[bf]](r[Ru], a(f(31907, 31923)))[CG[bf]](PG[If], l(f(31923, 31931))), r[yb];
    }, CG[t(f(31931, 31935), Tr)] = function(n) {
        var r = [];
        return CG[eg]() === PG[Nu] && PG[pm] in Array[PG[Wo]] && (r[wo] = n, r[Au] = PG[Mm], !(function(n, r) {
            return r in n && !!n[r];
        })[so](void 0, r[wo], r[Au]));
    }, CG[AZ] = function(n) {
        return CG[cg]() && PG[pm] in Array[PG[Wo]] && !CG[Lb](n, PG[Mm]) && CG[Rb](n)[PG[c(zA)]] === PG[Eu];
    }, CG[FZ] = function() {}, CG[EZ] = function() {}, CG[OZ] = function(n) {
        return {
            Uu: !1,
            zu: PG[xv],
            Vu: PG[xv],
            Gu: !1,
            Wu: !1,
            Xu: !1,
            Ju: PG[Rv],
            Zu: PG[Rv],
            $u: n
        };
    }, CG[XZ] = function(n) {
        n[CG[bs]] = !0, n[CG[ps]] && n[CG[ps]]();
    }, CG[jZ] = function(n) {
        n[CG[Ms]] && n[CG[Ms]]();
    }, CG[gZ] = function(n) {
        n[CG[ws]] = !0, n[CG[As]] === PG[xv] ? (function(n) {
            n[CG[bs]] = !0, n[CG[ps]] && n[CG[ps]]();
        })[so](void 0, n) : setTimeout(function() {
            var r = n;
            r[a(TZ)] = !0, !r[CG[bs]] && r[CG[ws]] && CG[XZ](r);
        }, n.$u);
    }, CG[t(f(31935, 31939), Tr)] = function(n, r, i) {
        n[CG[As]] = n[CG[As]] - CG[Zf], r && r(i), n[CG[As]] === PG[xv] ? n[CG[bs]] ? (function(n) {
            n[CG[Ms]] && n[CG[Ms]]();
        })[so](void 0, n) : (function(n) {
            n[CG[bs]] = !0, n[CG[ps]] && n[CG[ps]]();
        })[so](void 0, n) : n[CG[bs]] && (function(n) {
            n[CG[Ms]] && n[CG[Ms]]();
        })[so](void 0, n);
    }, CG[t(f(31939, 31943), Tr)] = function(n, r, i) {
        n[CG[Fs]] = n[CG[Fs]] - CG[Zf], r && r(i), n[CG[Fs]] === PG[c(SM)] && CG[gZ](n);
    }, CG[ZZ] = function(n, r, i, t) {
        var o = [];
        n[CG[Fs]] = n[CG[Fs]] + CG[Zf], o[wo] = function(r) {
            (function(n, r, i) {
                n[CG[Fs]] = n[CG[Fs]] - CG[Zf], r && r(i), n[CG[Fs]] === PG[c(SM)] && CG[gZ](n);
            })[so](void 0, n, t, r);
        };
        try {
            r[CG[$v]](PG[Eu], i[CG[bf]]([
                o[wo]
            ]));
        } catch (n) {
            o[wo](PG[Rv]);
        }
    }, CG[LZ] = function(n, r, i, t, o) {
        var u = [];
        n[CG[As]] = n[CG[As]] + (o && o[a(f(31943, 31951))] || CG[Zf]), u[wo] = function(r) {
            (function(n, r, i) {
                n[CG[As]] = n[CG[As]] - CG[Zf], r && r(i), n[CG[As]] === PG[xv] ? n[CG[bs]] ? CG[jZ](n) : CG[XZ](n) : n[CG[bs]] && CG[jZ](n);
            })[so](void 0, n, t, r);
        };
        try {
            r[CG[$v]](PG[Eu], i[CG[bf]]([
                u[wo]
            ]));
        } catch (n) {
            u[wo](PG[Rv]);
        }
    }, CG[t(f(31951, 31955), Tr)] = function(n) {
        n[a(TZ)] = !0, !n[CG[bs]] && n[CG[ws]] && (function(n) {
            n[CG[bs]] = !0, n[CG[ps]] && n[CG[ps]]();
        })[so](void 0, n);
    }, CG[t(f(31955, 31959), Tr)] = function(n, r) {
        n[CG[Es]] || (n[CG[Es]] = !0, r());
    }, PG[wm] = [], CG[HZ] = function(n) {
        var r = [];
        r[wo] = CG[ko], r[Au] = PG[wm][r[wo]++];
        for(; r[Au];)r[Au](n), r[Au] = PG[wm][r[wo]++];
        (function(n) {
            n[CG[Vf]](CG[ko], n[CG[Kf]]);
        })[so](void 0, PG[wm]);
    }, CG[t(f(31959, 31963), Tr)] = function(n) {
        PG[Lu] || (PG[Lu] = !0, (function(n) {
            var r = [];
            r[wo] = CG[ko], r[Au] = PG[wm][r[wo]++];
            for(; r[Au];)r[Au](n), r[Au] = PG[wm][r[wo]++];
            CG[xp](PG[wm]);
        })[so](void 0, n));
    }, PG[Fm] = l(f(31963, 32007)), PG[Em] = CG[as], CG[kZ] = function(n) {
        var r = [];
        var i = [];
        i[wo] = CG[Sb](n), PG[e(t(f(32007, 32017), Tr))] = function(r) {
            var o = [];
            var u = [];
            u[wo] = CG[jw](n) ? r || n[a(f(32017, 32033))] : r, (u[wo] && u[wo][CG[we]] !== PG[Fm] || i[wo][CG[Os]] === PG[jf]) && (n[PG[c(Aw)]] && (function(n, r, i, o) {
                CG[e(t(f(32033, 32043), Tr))](n) ? n[PG[c(Ew)]](r, i, !o) : CG[jw](n) && n[PG[be]](CG[Wo][CG[bf]](PG[c(Ow)])[CG[bf]](r), i);
            })[so](void 0, i[wo], PG[Xf], PG[Am], void 0), o[Au] = i[c(xu)], (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[c(Ew)]](r, i, !t) : CG[e(JZ)](n) && n[PG[be]](CG[Wo][CG[bf]](PG[c(Ow)])[CG[bf]](r), i);
            })[so](void 0, o[Au], PG[Fm], PG[Am], void 0), (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[c(Ew)]](r, i, !t) : CG[e(JZ)](n) && n[PG[be]](CG[Wo][CG[bf]](PG[c(Ow)])[CG[bf]](r), i);
            })[so](void 0, n, PG[Em], PG[Am], void 0), (function(n) {
                PG[e(t(f(32043, 32053), Tr))] || (PG[Lu] = !0, CG[HZ](n));
            })[so](void 0, n));
        }, n[PG[c(Aw)]] && (function(n, r, i, t) {
            CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
        })[so](void 0, i[wo], PG[Xf], PG[Am], void 0), (function(n, r, i, t) {
            CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
        })[so](void 0, i[wo], PG[Fm], PG[Am], void 0), (function(n, r, i, t) {
            CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
        })[so](void 0, n, PG[Em], PG[Am], void 0), (i[wo][CG[Os]] === PG[jf] || i[wo][CG[Os]] === PG[gf] && (r[wo] = CG[kA](n), !(function(n, r) {
            return n[CG[ov]](r) > -CG[Zf];
        })[so](void 0, r[wo], PG[Zf]))) && (function(n) {
            PG[Lu] || (PG[Lu] = !0, CG[HZ](n));
        })[so](void 0, n);
    }, CG[WZ] = function(n, r) {
        PG[Lu] ? r(n) : PG[e(t(f(32053, 32062), Tr))][CG[Cf]](r);
    }, PG[Om] = s(f(32062, 34814)), PG[c(t(f(34814, 34825), Tr))] = l(f(34825, 37129)), PG[e(_Z)] = a(f(37129, 37141)), PG[gm] = l(f(37141, 37149)), PG[Tm] = l(f(37149, 37165)), PG[Zm] = a(f(37165, 37189)), PG[Lm] = d(t(f(37189, 37198), Tr)), PG[Hm] = d(t(f(37198, 37208), Tr)), PG[km] = CG[Zf], PG[Jm] = CG[Df], PG[c(t(f(37208, 37218), Tr))] = CG[yv], PG[_m] = CG[Xv], PG[Gm] = CG[re], CG[GZ] = function(n) {
        var r = [];
        return r[c(xu)] = [
            CG[QA](n),
            CG[Wb](function() {
                var n = [];
                n[wo] = l(f(37218, 37254));
                var r = Element[PG[Wo]];
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = a(f(37254, 37278));
                var r = Element[PG[Wo]];
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = a(f(37278, 37310));
                var r = Intl;
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = s(f(37310, 37350));
                var r = Element[PG[Wo]];
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var r = [];
                return !(!n[CG[Fe]] || (r[wo] = n[CG[Fe]], !(function(n, r) {
                    return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
                })[so](void 0, r[wo], CG[Xs])));
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = s(f(37350, 37374));
                var r = Intl;
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = a(f(37374, 37382));
                var r = Array[PG[Wo]];
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = s(f(37382, 37398));
                var r = Object;
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = s(f(37398, 37422));
                var r = WebAssembly;
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = l(f(37422, 37446));
                var r = Array[PG[Wo]];
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = a(f(37446, 37494));
                var r = Intl;
                var i = n[c(xu)];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var r = [];
                return r[wo] = s(f(37494, 37530)), !(!n[CG[Ef]][r[wo]] && null !== n[CG[Ef]][r[wo]]);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = l(f(37530, 37570));
                var r = Element[PG[Wo]];
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = l(f(37570, 37614));
                var r = Element[PG[Wo]];
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = a(f(37614, 37638));
                var r = AudioContext[PG[Wo]];
                var i = n[c(xu)];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = s(f(37638, 37670));
                var r = String[PG[Wo]];
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = a(f(37670, 37694));
                var r = ArrayBuffer[PG[Wo]];
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var n = [];
                return n[wo] = AbortSignal, !(!CG[e($p)](n[wo]) || !(CG[Hf] in n[wo])) && n[wo][CG[Hf]](CG[Xs]);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = s(f(37694, 37714));
                var r = Object;
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var r = [];
                var i = [];
                return i[wo] = a(f(37714, 37750)), !(!n[CG[Fe]] || (r[wo] = n[CG[Fe]], !(function(n, r) {
                    return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
                })[so](void 0, r[wo], i[wo])));
            }),
            CG[Wb](function() {
                var r = [];
                return r[c(xu)] = a(f(37750, 37794)), !!n[CG[Ef]][r[wo]];
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = a(f(37794, 37818));
                var r = Array;
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var r = [];
                return r[wo] = l(f(37818, 37914)), r[wo] in n;
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = a(f(37914, 37950));
                var r = Element[PG[Wo]];
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var r = [];
                return r[wo] = a(f(37950, 37994)), r[wo] in n;
            }),
            CG[Wb](function() {
                var r = [];
                r[c(df)] = CG[js];
                var i = null === (r[wo] = n[a(f(37994, 38022))]) || r[c(xu)] === void CG[ko] ? void CG[ko] : r[wo][PG[Wo]];
                var t = r[Au];
                return !(!CG[jb](i) || !(CG[Hf] in i)) && i[CG[Hf]](t);
            }),
            CG[Wb](function() {
                var r = [];
                return r[wo] = a(f(38022, 38082)), !!n[CG[Ef]][r[wo]];
            }),
            CG[Wb](function() {
                var n = [];
                n[c(xu)] = a(f(38082, 38122));
                var r = Intl;
                var i = n[wo];
                return !(!CG[jb](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                var r = [];
                r[Au] = s(f(38122, 38146));
                var i = null === (r[wo] = n[a(f(38146, 38174))]) || r[c(xu)] === void CG[ko] ? void CG[ko] : r[wo][PG[Wo]];
                var t = r[Au];
                return !(!CG[jb](i) || !(CG[Hf] in i)) && i[CG[Hf]](t);
            }),
            CG[Wb](function() {
                var r = [];
                r[Au] = s(f(38174, 38218));
                var i = null === (r[wo] = n[l(f(38218, 38262))]) || r[wo] === void CG[e(Yl)] ? void CG[ko] : r[wo][PG[c(XX)]];
                var t = r[Au];
                return !(!CG[jb](i) || !(CG[Hf] in i)) && i[CG[Hf]](t);
            }),
            CG[Wb](function() {
                var n = [];
                n[wo] = s(f(38262, 38278));
                var r = Request[PG[c(XX)]];
                var i = n[c(xu)];
                return !(!CG[e($p)](r) || !(CG[Hf] in r)) && r[CG[Hf]](i);
            }),
            CG[Wb](function() {
                return !(function(n) {
                    return typeof n == typeof PG[Rv];
                })[so](void 0, n[PG[lc]]);
            }),
            CG[Wb](function() {
                var r = [];
                var i = [];
                return i[wo] = l(f(38278, 38310)), r[wo] = CG[Sb](n)[i[wo]], !(function(n) {
                    return typeof n == typeof PG[Rv];
                })[so](void 0, r[wo]);
            }),
            CG[Wb](function() {
                var r = [];
                return r[wo] = CG[DA](n), !(typeof r[wo] == typeof PG[Rv]);
            }),
            CG[Wb](function() {
                var r = [];
                return r[wo] = CG[ig](n), !(typeof r[wo] == typeof PG[Rv]);
            }),
            CG[Wb](function() {
                var r = [];
                return r[wo] = CG[aF](n), !(typeof r[wo] == typeof PG[Rv]);
            }),
            CG[Wb](function() {
                var r = [];
                return r[wo] = a(f(38310, 38350)), r[wo] in n;
            }),
            CG[Wb](function() {
                var r = [];
                var i = [];
                return i[c(xu)] = l(f(38350, 38386)), r[wo] = CG[Sb](n)[i[wo]], !(function(n) {
                    return typeof n == typeof PG[Rv];
                })[so](void 0, r[wo]);
            }),
            CG[Wb](function() {
                var r = [];
                r[wo] = a(f(38386, 38418));
                var t = CG[e(xZ)](n);
                var o = r[wo];
                var i = [];
                i[wo] = CG[ko];
                for(; i[wo] < t[CG[Kf]]; i[wo]++)if (t[i[wo]] === o) return !0;
                return !1;
            }),
            CG[Wb](function() {
                var r = [];
                return r[wo] = a(f(38418, 38434)), !(function(n) {
                    return typeof n == typeof PG[Rv];
                })[so](void 0, n[r[wo]]);
            }),
            CG[Wb](function() {
                var r = [];
                return r[e(xu)] = a(f(38434, 38522)), !(function(n) {
                    return typeof n == typeof PG[Rv];
                })[so](void 0, n[r[wo]]);
            }),
            CG[Wb](function() {
                var r = [];
                var i = [];
                return i[wo] = a(f(38522, 38550)), r[wo] = CG[Rb](n)[i[wo]], !(function(n) {
                    return typeof n == typeof PG[Rv];
                })[so](void 0, r[wo]);
            }),
            CG[Wb](function() {
                var r = [];
                return r[wo] = s(f(38550, 38650)), !(function(n) {
                    return typeof n == typeof PG[Rv];
                })[so](void 0, n[r[wo]]);
            }),
            CG[Wb](function() {
                var r = [];
                return r[wo] = CG[Rb](n)[PG[c(RZ)]], !(function(n) {
                    return typeof n == typeof PG[Rv];
                })[so](void 0, r[wo]);
            }),
            CG[Wb](function() {
                var r = [];
                return r[wo] = CG[Rb](n)[PG[sc]], (function(n) {
                    return CG[_u](n) && !CG[gp](n);
                })[so](void 0, r[wo]) && (r[Au] = CG[Rb](n)[PG[c(RZ)]][a(f(38650, 38658))], (function(n) {
                    return typeof n === CG[zf];
                })[so](void 0, r[Au]));
            })
        ], r[wo];
    }, CG[UZ] = function(n) {
        var r = [];
        var i = [];
        if (i[wo] = CG[ag](n), r[wo] = i[wo], (function(n) {
            return CG[hg](n) && !!(CG[Ml] in n);
        })[so](void 0, r[wo]) && (i[c(df)] = CG[_g](i[wo], CG[ha], CG[ma]), i[Au])) return i[Ru] = [
            l(f(38658, 38670)),
            s(f(38670, 38694)),
            s(f(38694, 38714))
        ], r[Au] = s(f(38714, 38746)), (function(n, r) {
            n[CG[El]] = r;
        })[so](void 0, i[Au], r[Au]), i[Au][a(f(38746, 38770))] = s(f(38770, 38786)), i[Au][CG[jl]] = l(f(38786, 38802)), (function(n, r, i, t) {
            n[CG[Fl]](r, i, t);
        })[so](void 0, i[Au], i[Ru][CG[ko]], CG[ko], CG[pa]), (function(n, r, i, t) {
            n[CG[Fl]](r, i, t);
        })[so](void 0, i[Au], i[Ru][CG[Zf]], CG[gs], CG[pa]), (function(n, r, i, t) {
            n[CG[Fl]](r, i, t);
        })[so](void 0, i[Au], i[Ru][CG[Df]], CG[ma], CG[pa]), i[wo][CG[Ml]]()[CG[Kf]];
    }, CG[SZ] = function(n, r) {
        var i = [];
        var t = [];
        return t[wo] = CG[ko], i[wo] = CG[qp](r), i[Au] = function(r) {
            CG[Up](r, function(r) {
                return CG[IZ](n, r);
            }) && t[wo]++;
        }, (function(n, r) {
            var i = [];
            i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
        })[so](void 0, i[wo], i[Au]), t[wo];
    }, CG[IZ] = function(n, r) {
        var i = [];
        var t = [];
        if (t[wo] = s(f(38802, 38838)), t[Au] = a(f(38838, 38854)), t[Ru] = [
            PG[Wv],
            PG[_v],
            PG[Gv]
        ], t[yb] = CG[ag](n), i[wo] = t[yb], (function(n) {
            return !(!n || !n[CG[pl]]);
        })[so](void 0, i[wo])) {
            t[Du] = CG[_g](t[yb], CG[Zs], CG[Hs]), t[Iu] = {}, t[Nb] = CG[ko];
            for(; t[Nb] < t[Ru][CG[Kf]]; t[Nb]++)i[yf] = CG[Wo][CG[bf]](t[Au], CG[Uo])[CG[bf]](t[c(af)][t[Nb]]), (function(n, r) {
                n[CG[El]] = r;
            })[so](void 0, t[Du], i[yf]), t[Iu][t[Ru][t[Nb]]] = t[c(vf)][CG[ks]](t[wo])[CG[be]];
            return i[Au] = CG[Wo][CG[bf]](t[Au], CG[Uo])[CG[bf]](r, CG[Ne])[CG[bf]](PG[Wv]), (function(n, r) {
                n[CG[El]] = r;
            })[so](void 0, t[Du], i[Au]), t[mb] = t[Du][CG[ks]](t[wo])[CG[be]], i[Ru] = CG[Wo][CG[bf]](t[Au], CG[Uo])[CG[bf]](r, CG[Ne])[CG[bf]](PG[_v]), (function(n, r) {
                n[CG[El]] = r;
            })[so](void 0, t[Du], i[Ru]), t[Su] = t[Du][CG[ks]](t[wo])[CG[be]], i[yb] = CG[Wo][CG[bf]](t[Au], CG[e(Tl)])[CG[bf]](r, CG[Ne])[CG[bf]](PG[Gv]), (function(n, r) {
                n[CG[El]] = r;
            })[so](void 0, t[Du], i[yb]), t[hf] = t[Du][CG[ks]](t[wo])[CG[be]], t[mb] !== t[Iu][PG[Wv]] || t[Su] !== t[c(of)][PG[_v]] || t[hf] !== t[Iu][PG[Gv]];
        }
    }, CG[BZ] = function(n, r, i) {
        n[r] = i || [
            r
        ];
    }, CG[DZ] = function(n) {
        return n;
    }, PG[xm] = {}, PG[Rm] = {}, PG[Um] = {}, CG[yb] = [
        [
            CG[DZ](CG[Js]),
            [
                CG[DZ](CG[Js]),
                CG[DZ](s(f(38854, 38886)))
            ]
        ],
        [
            CG[DZ](s(f(38886, 38910)))
        ],
        [
            CG[DZ](a(f(38910, 38938))),
            [
                CG[DZ](f(38938, 38953)),
                CG[DZ](a(f(38953, 38997))),
                CG[DZ](s(f(38997, 39037)))
            ]
        ],
        [
            CG[DZ](a(f(39037, 39061))),
            [
                CG[DZ](l(f(39061, 39109))),
                CG[DZ](a(f(39109, 39149))),
                CG[DZ](s(f(39149, 39189))),
                CG[DZ](l(f(39189, 39229)))
            ]
        ],
        [
            CG[DZ](CG[Ws])
        ],
        [
            CG[DZ](CG[_s])
        ],
        [
            CG[DZ](s(f(39229, 39245))),
            [
                CG[DZ](a(f(39245, 39281))),
                CG[DZ](a(f(39281, 39329))),
                CG[DZ](a(f(39329, 39365)))
            ]
        ],
        [
            CG[DZ](s(f(39365, 39389)))
        ],
        [
            CG[DZ](f(39389, 39396)),
            [
                CG[DZ](a(f(39396, 39428))),
                CG[DZ](l(f(39428, 39468)))
            ]
        ],
        [
            CG[DZ](a(f(39468, 39480))),
            [
                CG[DZ](a(f(39480, 39504))),
                CG[DZ](a(f(39504, 39528))),
                CG[DZ](l(f(39528, 39552)))
            ]
        ],
        [
            CG[DZ](CG[Ws])
        ],
        [
            CG[DZ](CG[_s])
        ],
        [
            CG[DZ](l(f(39552, 39572)))
        ]
    ], CG[Du] = function(n) {
        return CG[BZ](PG[xm], n[CG[ko]], n[CG[Zf]]);
    }, (function(n, r) {
        var i = [];
        i[e(xu)] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
        for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
    })[so](void 0, CG[yb], CG[Du]), CG[Iu] = [
        CG[DZ](a(f(39572, 39596))),
        CG[DZ](s(f(39596, 39628))),
        CG[DZ](s(f(39628, 39660))),
        CG[DZ](s(f(39660, 39680))),
        CG[DZ](s(f(39680, 39700))),
        CG[DZ](s(f(39700, 39724))),
        CG[DZ](l(f(39724, 39740))),
        CG[DZ](l(f(39740, 39776))),
        CG[DZ](s(f(39776, 39812))),
        CG[DZ](a(f(39812, 39860))),
        CG[DZ](s(f(39860, 39892))),
        CG[DZ](l(f(39892, 39908))),
        CG[DZ](l(f(39908, 39936))),
        CG[DZ](l(f(39936, 39952))),
        CG[DZ](l(f(39952, 39968))),
        CG[DZ](a(f(39968, 40016)))
    ], CG[Nb] = function(n) {
        return CG[BZ](PG[Rm], n);
    }, (function(n, r) {
        var i = [];
        i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
        for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[e(Nv)], i[wo]++);
    })[so](void 0, CG[Iu], CG[Nb]), CG[mb] = [
        CG[DZ](l(f(40016, 40052))),
        CG[DZ](l(f(40052, 40068))),
        CG[DZ](l(f(40068, 40096))),
        CG[DZ](l(f(40096, 40112))),
        CG[DZ](s(f(40112, 40128))),
        CG[DZ](a(f(40128, 40180))),
        CG[DZ](l(f(40180, 40220))),
        CG[DZ](a(f(40220, 40260))),
        CG[DZ](s(f(40260, 40292))),
        CG[DZ](s(f(40292, 40320))),
        CG[DZ](l(f(40320, 40372))),
        CG[DZ](l(f(40372, 40404))),
        CG[DZ](a(f(40404, 40428)))
    ], CG[Su] = function(n) {
        return CG[BZ](PG[Um], n);
    }, (function(n, r) {
        var i = [];
        i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
        for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
    })[so](void 0, CG[mb], CG[Su]), CG[eg]() !== PG[Sl] ? (CG[qZ] = PG[c(t(f(40428, 40438), Tr))], CG[zZ] = CG[DZ](CG[Gs]), CG[e(t(f(40438, 40448), Tr))] = [
        CG[DZ](s(f(40448, 40480))),
        CG[DZ](l(f(40480, 40512))),
        CG[e(t(f(40512, 40522), Tr))](CG[xs])
    ], (function(n, r, i) {
        n[r] = i || [
            r
        ];
    })[so](void 0, CG[qZ], CG[zZ], CG[t(f(40522, 40526), Tr)]), CG[$Z] = CG[DZ](s(f(40526, 40590))), (function(n, r, i) {
        n[r] = i || [
            r
        ];
    })[so](void 0, PG[Um], CG[$Z], void 0), CG[KZ] = PG[c(t(f(40590, 40599), Tr))], CG[VZ] = CG[DZ](a(f(40599, 40651))), (function(n, r, i) {
        n[r] = i || [
            r
        ];
    })[so](void 0, CG[KZ], CG[VZ], void 0)) : (CG[CZ] = CG[DZ](CG[Gs]), CG[PZ] = [
        CG[DZ](CG[xs])
    ], (function(n, r, i) {
        n[r] = i || [
            r
        ];
    })[so](void 0, PG[xm], CG[CZ], CG[PZ])), CG[QZ] = function(n) {
        var r = [];
        try {
            return r[wo] = CG[SZ](n, PG[xm]), r[Au] = CG[SZ](n, PG[Um]), r[Ru] = CG[SZ](n, PG[Rm]), r[yb] = CG[UZ](n), {
                ri: r[wo],
                ni: r[Au],
                ai: r[Ru],
                ti: r[yb]
            };
        } catch (n) {
            return {};
        }
    }, CG[YZ] = function(n, r) {
        var i = [];
        var t = [];
        if (t[Au] = !1, CG[eg]() !== PG[Nu]) return !1;
        t[wo] = CG[dp](n, PG[Hf]), r ? (i[Du] = PG[c(qX)], (function(n, r, i) {
            return n[s(fp)](r, i);
        })[so](void 0, t[wo], i[Du], PG[Jv])) : (function(n, r, i) {
            return n[s(fp)](r, i);
        })[so](void 0, t[wo], PG[kf], PG[kv]), i[wo] = a(f(40651, 40671)), i[Au] = s(f(40671, 40707)), (function(n, r, i) {
            return n[s(fp)](r, i);
        })[so](void 0, t[wo], i[wo], i[Au]), i[Ru] = CG[$b](n), (function(n, r) {
            n && n[a(ep)](r);
        })[so](void 0, i[Ru], t[wo]);
        try {
            (function(n) {
                return n[s(Ub)];
            })[so](void 0, t[wo][CG[ys]]), t[Au] = !0;
        } catch (n) {
            t[Au] = !1;
        } finally{
            t[wo][a(f(40707, 40723))]();
        }
        return t[Au];
    }, CG[nL] = function(n) {
        var r = [];
        if (r[c(xu)] = CG[Uw](n), r[wo] && (function(n) {
            return typeof n === CG[zf];
        })[so](void 0, r[wo][CG[Rs]]) && (r[c(df)] = r[wo][CG[Rs]](a(f(40723, 40751)))[CG[ko]], r[Au])) return {
            ei: r[Au][s(f(40751, 40783))] - r[Au][s(f(40783, 40819))],
            ui: r[Au][l(f(40819, 40859))] - r[Au][a(f(40859, 40907))],
            ii: r[Au][CG[Us]] - r[Au][s(f(40907, 40939))],
            fi: r[e(df)][CG[Ss]] > CG[ko] ? r[Au][CG[Us]] - r[e(df)][CG[Ss]] : CG[ko],
            oi: r[Au][CG[Is]] - r[Au][l(f(40939, 40975))],
            ci: r[Au][CG[Bs]] > CG[ko] ? r[Au][CG[Is]] - r[Au][CG[Bs]] : CG[ko],
            li: r[Au][CG[Ds]] > CG[ko] ? r[Au][CG[Is]] - r[Au][CG[Ds]] : CG[ko],
            si: r[Au][CG[qs]] > CG[ko] ? r[Au][CG[Is]] - r[Au][CG[qs]] : CG[ko],
            _i: r[Au][s(f(40975, 40999))]
        };
    }, CG[t(f(40999, 41003), Tr)] = function(n) {
        return [
            n[l(rL)],
            n[l(iL)],
            n[a(tL)],
            n[a(oL)],
            n[a(uL)],
            n[a(fL)],
            n[s(vL)],
            n[l(eL)],
            n[a(cL)]
        ];
    }, CG[dL] = function(n) {
        var r = [];
        var i = [];
        i[wo] = {
            di: !1,
            hi: !1,
            pi: !1,
            mi: !1,
            yi: null
        };
        try {
            i[wo][CG[zs]] = (r[Au] = HTMLCanvasElement[PG[c(XX)]][CG[Ml]][CG[Fu]](), !(function(n, r) {
                return n[CG[ov]](r) > -CG[Zf];
            })[so](void 0, r[Au], PG[Sf]));
        } catch (n) {}
        try {
            i[wo][CG[$s]] = (r[Ru] = CanvasRenderingContext2D[PG[Wo]][CG[Xl]][CG[Fu]](), !(function(n, r) {
                return n[CG[ov]](r) > -CG[Zf];
            })[so](void 0, r[Ru], PG[Sf]));
        } catch (n) {}
        try {
            CanvasRenderingContext2D[PG[Wo]][CG[Xl]][CG[$v]](void 0, [
                CG[ko],
                CG[ko],
                CG[Zf],
                CG[Zf]
            ]);
        } catch (n) {
            i[wo][CG[mu]] = n[CG[ll]];
        }
        if (CG[eg]() !== PG[Nu]) return i[wo];
        try {
            i[wo][CG[Ks]] = !0, Object[PG[Kf]](HTMLCanvasElement[PG[Wo]][CG[Ml]], HTMLCanvasElement[PG[c(XX)]][CG[Ml]]);
        } catch (n) {
            (function(n, r) {
                return n[CG[ov]](r) > -CG[Zf];
            })[so](void 0, n[CG[ll]], CG[Vs]) && (i[wo][CG[Ks]] = !1);
        }
        try {
            i[wo][CG[Cs]] = !0, Object[PG[Kf]](CanvasRenderingContext2D[PG[Wo]][CG[Xl]], CanvasRenderingContext2D[PG[Wo]][CG[Xl]]);
        } catch (n) {
            (function(n, r) {
                return n[CG[ov]](r) > -CG[Zf];
            })[so](void 0, n[CG[ll]], CG[Vs]) && (i[wo][CG[Cs]] = !1);
        }
        return i[wo];
    }, CG[1915] = function() {
        var n = [];
        n[wo] = CG[gl], n[Au] = Array(n[wo]);
        for(; n[wo]--;)n[Au][n[wo]] = String[CG[Fv]](n[wo] + (n[wo] < CG[mv] ? CG[Ps] : n[wo] < d(bb) ? CG[Ys] : d(c(t(f(41003, 41013), Tr))))), n[Ru] = CG[IM]() * (n[wo] + CG[Zf]) | PG[xv], n[yb] = n[Au][n[wo]], n[Au][n[wo]] = n[c(df)][n[Ru]], n[Au][n[Ru]] = n[yb];
        return n[Au][CG[jf]](CG[Wo]);
    }, CG[aL] = function(n) {
        var r = [];
        var i = [];
        if (i[wo] = CG[ag](n), r[wo] = i[wo], (function(n) {
            return CG[hg](n) && !!(CG[Ml] in n);
        })[so](void e(xu), r[wo]) && (i[Au] = CG[_g](i[wo], CG[_e], CG[_e]), i[Au] && (r[Au] = l(f(41013, 41069)), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, i[Au], r[Au]), i[Ru] = [
            CG[ko],
            CG[$l],
            CG[Xf],
            CG[Xf]
        ], (function(n, r, i, t, o) {
            n[a(Xg)](r, i, t, o);
        })[so](void 0, i[Au], CG[ko], CG[ko], i[wo][CG[be]], i[wo][CG[_f]]), i[yb] = CG[Gg](i[Au], CG[ko], CG[ko], i[wo][CG[be]], i[wo][CG[_f]]), i[c(Nv)]))) {
            i[Du] = CG[ko];
            for(; i[Du] < i[yb][CG[Kf]]; i[Du] += CG[Zf])if (i[yb][i[Du]] !== i[Ru][i[Du] % CG[Xv]]) return !1;
            return !0;
        }
    }, CG[lL] = function(n) {
        var r = [];
        var i = [];
        if (i[wo] = CG[ag](n), r[wo] = i[wo], (function(n) {
            return !(!n || !n[CG[pl]]);
        })[so](void 0, r[wo]) && (i[Au] = CG[_g](i[wo], CG[hs], CG[Mv]), i[Au] && (i[Ru] = CG[1915](), (function(n, r, i, t) {
            n[CG[Fl]](r, i, t);
        })[so](void 0, i[Au], i[Ru], CG[Na], CG[mv]), i[yb] = CG[FM](i[Au][CG[ks]](i[c(af)])[CG[be]]), i[Du] = CG[Gg](i[c(df)], CG[ko], CG[ko], i[yb], CG[Mv]), i[Du] && (i[Iu] = CG[ag](n), i[Nb] = CG[_g](i[c(of)], CG[hs], CG[Mv]), i[Nb][CG[Fl]](i[Ru] + CG[Uo] + i[Ru], CG[Na], CG[mv]), i[mb] = CG[e(t(f(41069, 41079), Tr))](i[Nb], CG[ko], CG[ko], i[yb], CG[Mv]), i[mb])))) {
            i[Su] = CG[ko], i[hf] = CG[ko];
            for(; i[hf] < i[Du][CG[Kf]]; i[hf]++)i[Su] += (r[yf] = i[Du][i[hf]] - i[c(ge)][i[hf]], CG[wM]()[PG[re]](r[yf]));
            return i[Su];
        }
    }, CG[sL] = function(n, r) {
        var i = [];
        var t = [];
        if (t[wo] = CG[ag](n), i[wo] = t[c(xu)], (function(n) {
            return CG[hg](n) && !!(CG[Ml] in n);
        })[so](void 0, i[wo])) {
            if (t[Au] = CG[_g](t[e(xu)], CG[mv], CG[mv]), t[Au]) {
                t[Ru] = CG[ko], t[yb] = t[c(df)][s(f(41079, 41119))](t[wo][CG[be]], t[wo][CG[_f]]), t[Du] = CG[e(Yl)];
                for(; t[Du] < t[yb][CG[Qd]][CG[Kf]]; t[c(vf)] += CG[Xv])t[c(of)] = CG[BM](CG[sl]), t[Nb] = CG[BM](CG[sl]), t[mb] = CG[BM](CG[sl]), t[Ru] += t[Iu] + t[Nb] + t[mb], t[yb][CG[Qd]][t[Du]] = t[c(of)], t[yb][CG[Qd]][t[Du] + CG[Zf]] = t[Nb], t[yb][CG[Qd]][t[Du] + CG[Df]] = t[mb], t[yb][CG[Qd]][t[Du] + CG[yv]] = CG[Xf];
                t[Au][s(f(41119, 41151))](t[yb], CG[ko], CG[ko]), t[Su] = new Image, t[Su][CG[rh]] = function() {
                    var n = [];
                    var i = [];
                    try {
                        t[Au][CG[ih]](t[Su], CG[ko], CG[ko]), i[wo] = (n[wo] = t[c(df)], (function(n, r, i, t, o) {
                            if (n) try {
                                return n[CG[Xl]](r, i, t, o)[CG[Qd]];
                            } catch (n) {
                                return;
                            }
                        })[so](void 0, n[wo], CG[ko], CG[ko], t[wo][CG[be]], t[wo][CG[_f]])), i[Au] = CG[ko], i[c(af)] = CG[ko];
                        for(; i[Ru] < i[wo][CG[Kf]]; i[Ru] += CG[Xv])i[Au] += i[wo][i[Ru]] + i[wo][i[Ru] + CG[Zf]] + i[wo][i[e(af)] + CG[e(bw)]];
                        r(CG[wM]()[PG[re]](i[Au] - t[Ru]));
                    } catch (n) {
                        r(PG[Rv]);
                    }
                }, t[Su][CG[th]] = t[wo][CG[Ml]]();
            } else r(PG[Rv]);
        } else r(PG[Rv]);
    }, CG[hL] = function(n, r) {
        var i = [];
        var t = [];
        if (t[c(xu)] = CG[ag](n), i[wo] = t[wo], (function(n) {
            return CG[hg](n) && !!(CG[Ml] in n);
        })[so](void 0, i[wo])) {
            if (t[c(df)] = CG[_g](t[wo], CG[_e], CG[_e]), t[Au]) {
                if ((function(n, r) {
                    n[s(Eg)] = r;
                })[so](void 0, t[Au], CG[oh]), (function(n, r, i, t, o) {
                    n[a(Xg)](r, i, t, o);
                })[so](void 0, t[Au], CG[mv], CG[mv], CG[yl], CG[yl]), (function(n, r) {
                    n[s(Eg)] = r;
                })[so](void 0, t[Au], CG[uh]), (function(n, r, i, t, o) {
                    n[a(Xg)](r, i, t, o);
                })[so](void 0, t[Au], CG[fh], CG[mv], CG[yl], CG[yl]), i[Au] = t[c(df)], (function(n, r) {
                    n[s(Eg)] = r;
                })[so](void 0, i[Au], CG[eh]), i[Ru] = t[c(df)], (function(n, r, i, t, o) {
                    n[a(Xg)](r, i, t, o);
                })[so](void 0, i[Ru], CG[ch], CG[mv], CG[yl], CG[yl]), (function(n, r) {
                    n[s(Eg)] = r;
                })[so](void 0, t[Au], CG[dh]), i[yb] = t[c(df)], (function(n, r, i, t, o) {
                    n[a(Xg)](r, i, t, o);
                })[so](void 0, i[yb], CG[gs], CG[fh], CG[yl], CG[yl]), (function(n, r) {
                    n[s(Eg)] = r;
                })[so](void 0, t[e(df)], CG[ah]), (function(n, r, i, t, o) {
                    n[a(Xg)](r, i, t, o);
                })[so](void 0, t[Au], CG[Fc], CG[fh], CG[yl], CG[yl]), i[Du] = l(f(41151, 41179)), (function(n, r) {
                    n[CG[El]] = r;
                })[so](void 0, t[Au], i[Du]), i[Iu] = s(f(41179, 41199)), (function(n, r) {
                    n[s(Eg)] = r;
                })[so](void e(xu), t[Au], i[Iu]), (function(n, r, i, t) {
                    n[CG[Fl]](r, i, t);
                })[so](void 0, t[Au], CG[lh], CG[Na], CG[Hs]), (function(n, r) {
                    n[CG[El]] = r;
                })[so](void 0, t[Au], CG[sh]), (function(n, r) {
                    n[s(Eg)] = r;
                })[so](void 0, t[Au], CG[hh]), (function(n, r, i, t) {
                    n[CG[Fl]](r, i, t);
                })[so](void 0, t[Au], CG[yh], CG[Fc], CG[Hs]), t[Au][CG[Ol]](), t[Au][CG[Nh]] = s(f(41199, 41219)), t[Au][CG[e(HT)]](CG[Na], CG[Ce]), t[Au][CG[bh]](CG[Na], CG[Fc], CG[Fc], CG[Fc], CG[Fc], CG[Ce]), t[Au][CG[ph]](), t[Au][CG[Ol]](), t[Au][CG[Nh]] = a(f(41219, 41239)), t[Au][CG[mh]](CG[Fc], CG[Ce]), t[Au][CG[bh]](CG[Fc], CG[Mh], CG[Ce], CG[Mh], CG[Ce], CG[Ce]), t[Au][CG[ph]](), t[Ru] = CG[ag](n), t[yb] = CG[_g](t[Ru], t[wo][CG[be]], t[wo][CG[_f]]), t[Du] = new Image, t[Du][CG[th]] = t[wo][CG[Ml]](), t[Iu] = CG[Gg](t[Au], CG[ko], CG[ko], t[wo][CG[be]], t[wo][CG[_f]]), t[Du][CG[rh]] = function() {
                    var n = [];
                    var i = [];
                    try {
                        if (!t[e(Nv)]) return void r(PG[Rv]);
                        if (t[yb][CG[ih]](t[Du], CG[ko], CG[ko]), i[wo] = CG[Gg](t[yb], CG[ko], CG[ko], t[wo][CG[be]], t[wo][CG[_f]]), !t[Iu] || !i[wo]) return void r(PG[c(IE)]);
                        if (t[Iu][CG[Kf]] !== i[wo][CG[Kf]]) return void r(PG[Rv]);
                        i[Au] = CG[ko], i[Ru] = CG[ko];
                        for(; i[Ru] < t[Iu][CG[Kf]]; i[Ru]++)t[Iu][i[Ru]] !== i[wo][i[Ru]] && (i[Au] += (n[yb] = t[c(of)][i[Ru]] - i[wo][i[Ru]], CG[wM]()[PG[re]](n[yb])));
                        r(i[Au]);
                    } catch (n) {
                        r(PG[Rv]);
                    }
                }, t[c(Tf)] = [], t[Iu]) {
                    t[mb] = CG[ko];
                    for(; t[mb] < t[Iu][CG[Kf]]; t[mb]++)t[Nb][CG[Cf]](t[Iu][t[mb]][CG[e(fj)]]());
                }
            } else r(PG[Rv]);
        } else r(PG[Rv]);
    }, CG[yL] = function(n) {
        var r = [];
        var i = [];
        if (PG[ds] in n && (i[wo] = CG[ag](n), r[wo] = i[wo], (function(n) {
            return CG[hg](n) && !!(CG[Ml] in n);
        })[so](void 0, r[wo]) && (i[Au] = CG[_g](i[wo], CG[_e], CG[yl]), i[Au] && ((function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, i[Au], CG[oh]), (function(n, r, i, t, o) {
            n[a(Xg)](r, i, t, o);
        })[so](void 0, i[Au], CG[mv], CG[mv], CG[yl], CG[yl]), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, i[Au], CG[uh]), (function(n, r, i, t, o) {
            n[a(Xg)](r, i, t, o);
        })[so](void 0, i[Au], CG[fh], CG[mv], CG[yl], CG[yl]), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, i[Au], CG[eh]), (function(n, r, i, t, o) {
            n[a(Xg)](r, i, t, o);
        })[so](void 0, i[e(df)], CG[ch], CG[mv], CG[yl], CG[yl]), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, i[Au], CG[dh]), (function(n, r, i, t, o) {
            n[a(Xg)](r, i, t, o);
        })[so](void 0, i[Au], CG[gs], CG[fh], CG[yl], CG[yl]), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, i[Au], CG[ah]), (function(n, r, i, t, o) {
            n[a(Xg)](r, i, t, o);
        })[so](void 0, i[Au], CG[Fc], CG[fh], CG[yl], CG[yl]), r[Au] = i[c(df)], (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, r[Au], CG[Ah]), (function(n, r) {
            n[CG[El]] = r;
        })[so](void 0, i[Au], CG[Fh]), (function(n, r, i, t) {
            n[CG[Fl]](r, i, t);
        })[so](void 0, i[Au], CG[lh], -CG[mv], CG[Ys]), (function(n, r) {
            n[CG[El]] = r;
        })[so](void e(xu), i[Au], CG[sh]), r[Ru] = i[c(df)], (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, r[Ru], CG[hh]), r[yb] = i[c(df)], (function(n, r, i, t) {
            n[CG[Fl]](r, i, t);
        })[so](void 0, r[yb], CG[yh], CG[ma], CG[Na]), i[Ru] = CG[lg](n, CG[_e], CG[yl]), r[Du] = i[Ru], (function(n) {
            return !(!n || !n[CG[pl]]);
        })[so](void 0, r[Du]) && (i[yb] = i[Ru][CG[pl]](PG[ns]), i[yb] && ((function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, i[yb], CG[oh]), r[Iu] = i[c(Nv)], (function(n, r, i, t, o) {
            n[a(Xg)](r, i, t, o);
        })[so](void 0, r[Iu], CG[mv], CG[mv], CG[yl], CG[yl]), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, i[yb], CG[uh]), (function(n, r, i, t, o) {
            n[a(Xg)](r, i, t, o);
        })[so](void 0, i[yb], CG[fh], CG[mv], CG[yl], CG[yl]), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, i[yb], CG[eh]), (function(n, r, i, t, o) {
            n[a(Xg)](r, i, t, o);
        })[so](void 0, i[yb], CG[ch], CG[mv], CG[yl], CG[yl]), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, i[yb], CG[dh]), (function(n, r, i, t, o) {
            n[a(Xg)](r, i, t, o);
        })[so](void 0, i[yb], CG[gs], CG[fh], CG[yl], CG[yl]), r[Nb] = i[c(Nv)], (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, r[Nb], CG[ah]), (function(n, r, i, t, o) {
            n[a(Xg)](r, i, t, o);
        })[so](void 0, i[yb], CG[Fc], CG[fh], CG[yl], CG[yl]), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, i[yb], CG[Ah]), (function(n, r) {
            n[CG[El]] = r;
        })[so](void 0, i[yb], CG[Fh]), (function(n, r, i, t) {
            n[CG[Fl]](r, i, t);
        })[so](void 0, i[yb], CG[lh], -CG[mv], CG[Ys]), (function(n, r) {
            n[CG[El]] = r;
        })[so](void 0, i[yb], CG[sh]), (function(n, r) {
            n[s(Eg)] = r;
        })[so](void 0, i[yb], CG[hh]), (function(n, r, i, t) {
            n[CG[Fl]](r, i, t);
        })[so](void 0, i[yb], CG[yh], CG[ma], CG[Na]), i[Du] = CG[ag](n), i[Iu] = CG[_g](i[c(vf)], CG[_e], CG[yl]), i[Iu])))))) return i[Iu][CG[ih]](i[Ru], CG[ko], CG[ko]), i[Du][CG[Ml]]() === i[wo][CG[Ml]]();
    }, CG[NL] = function(n, r, i) {
        var t = [];
        return (t[wo] = function(n) {
            return CG[mM](n[i || CG[th]], r);
        }, (function(n, r) {
            var i = [];
            i[wo] = [], i[c(df)] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[c(af)][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[Au]], r(i[yb]) && i[wo][CG[Cf]](i[yb]);
            return i[wo];
        })[so](void 0, n, t[wo]))[CG[Kf]] > CG[ko];
    }, CG[t(f(41239, 41243), Tr)] = function(n) {
        var r = [];
        var i = [];
        i[Af] = f(41243, 41275), i[wo] = {
            gi: !1,
            bi: !1,
            wi: !1,
            Ni: !1,
            Mi: !1,
            ki: !1,
            xi: !1,
            Ai: !1,
            Si: !1,
            Ei: !1,
            Fi: !1,
            Ci: !1,
            Ti: !1,
            Ii: !1,
            Di: !1,
            Li: !1,
            Ri: !1,
            Oi: !1,
            Pi: !1,
            ji: !1,
            Hi: !1,
            Bi: !1,
            qi: !1,
            Ki: !1,
            Ui: !1,
            zi: !1,
            Vi: !1,
            Gi: !1,
            Wi: !1,
            Xi: !1,
            Ji: !1,
            Zi: !1,
            $i: !1,
            Qi: !1,
            Yi: !1,
            rv: !1,
            nv: !1,
            av: !1,
            tv: !1,
            ev: !1,
            uv: !1,
            iv: !1,
            vv: !1
        }, i[Au] = a(f(41275, 41331)), i[Ru] = l(f(41331, 41355)), i[yb] = l(f(41355, 41403)), i[Du] = a(f(41403, 41451)), i[Iu] = s(f(41451, 41499)), i[Nb] = a(f(41499, 41547)), i[mb] = l(f(41547, 41571)), i[Su] = s(f(41571, 41611)), i[hf] = a(f(41611, 41643)), i[To] = l(f(41643, 41691)), i[yf] = CG[Rv], i[Nf] = s(f(41691, 41707)), i[mf] = a(f(41707, 41779)), i[c(Zv)] = l(f(41779, 41819)), i[pf] = a(f(41819, 41855)), i[Zo] = l(f(41855, 41903)), i[Lo] = a(f(41903, 41927)), i[Ho] = l(f(41927, 41947)), i[Mf] = l(f(41947, 42003)), i[wf] = s(f(42003, 42039)), i[Ff] = l(f(42039, 42059)), i[Ef] = s(f(42059, 42095)), i[Of] = a(f(42095, 42135)), i[c(Yl)] = a(f(42135, 42175)), i[Xf] = s(f(42175, 42255)), i[jf] = l(f(42255, 42327)), i[gf] = s(f(42327, 42367)), i[Zf] = a(f(42367, 42415)), i[Hf] = a(f(42415, 42443)), i[kf] = s(f(42443, 42487)), i[Jf] = l(f(42487, 42543)), i[Wf] = s(f(42543, 42615)), i[Jo] = a(f(42615, 42647)), i[e(AX)] = l(f(42647, 42707)), i[c(bb)] = l(f(42707, 42795)), i[xf] = s(f(42795, 42815)), i[Rf] = s(f(42815, 42871)), i[Uf] = CG[Eh], i[Sf] = l(f(42871, 42919)), i[If] = l(f(42919, 42967)), i[Wo] = a(f(42967, 43023)), i[Go] = l(f(43023, 43079)), i[Bf] = s(f(43079, 43095)), i[Df] = l(f(43095, 43131)), i[Fu] = a(f(43131, 43195)), i[qf] = a(f(43195, 43263)), i[zf] = a(f(43263, 43319)), i[$f] = s(f(43319, 43367)), i[Kf] = a(f(43367, 43407)), i[xo] = a(f(43407, 43447)), i[Vf] = CG[Oh];
        try {
            i[Cf] = CG[Sb](n), i[Pf] = CG[$b](n), i[Qf] = n[PG[we]], i[Yf] = n[s(f(43447, 43487))], i[wo][CG[Xh]] = (function(n, r) {
                return n[PG[bs]] ? n[PG[c(iT)]](r) : !(!n[PG[ps]][r] || !n[PG[ps]][r][s(rT)]);
            })[so](void 0, i[Pf], i[Au]), i[wo][CG[jh]] = (function(n, r) {
                return n[PG[bs]] ? n[PG[c(iT)]](r) : !(!n[PG[ps]][r] || !n[PG[ps]][r][s(rT)]);
            })[so](void 0, i[Pf], i[Ru]), i[wo][CG[gh]] = !(!n[CG[Th]] || !n[CG[Th]][a(f(43487, 43495))]), i[nv] = i[Cf][CG[Zh]](PG[_f]), i[wo][CG[Lh]] = CG[NL](i[nv], i[yb]), i[wo][CG[Hh]] = CG[NL](i[nv], i[Du]), i[c(xu)][CG[mL]] = CG[NL](i[nv], i[Iu]), i[rv] = i[Cf][CG[Zh]](PG[Hf]), i[wo][CG[Jh]] = CG[NL](i[rv], i[Nb]), i[wo][CG[Wh]] = !!i[Cf][CG[e(t(f(43495, 43505), Tr))]](i[mb]), i[wo][CG[e(bL)]] = !!i[Cf][CG[_h]](i[Su]), i[wo][CG[xh]] = !!i[Cf][CG[Rh]](i[hf]), i[c(xu)][CG[Uh]] = null !== (function(n, r) {
                if (n[CG[Gf]]) return n[CG[Gf]](r);
            })[so](void 0, i[Pf], i[To]);
            try {
                i[wo][CG[Sh]] = !(!i[Qf] || !i[c(e(nh))][i[yf]] || i[Qf][i[yf]][CG[ov]](i[c(e(t(f(43505, 43515), Tr)))]) !== CG[ko]), i[wo][CG[Ih]] = !(!i[Yf] || !(function(n) {
                    return typeof n === l(Jp);
                })[so](void 0, i[Yf][i[mf]])), i[e(xu)][CG[Bh]] = !!(i[Qf] && i[Qf][i[bf]] && (function(n, r) {
                    return n[CG[ov]](r) > -CG[Zf];
                })[so](void 0, i[Qf][i[bf]], i[pf])), i[wo][CG[484]] = !(!i[c(MX)] || !(function(n) {
                    return typeof n === l(Jp);
                })[so](void 0, i[Yf][i[Zo]]));
            } catch (n) {}
            i[wo][CG[Dh]] = !!i[Cf][CG[Rh]](i[Lo]), i[wo][CG[qh]] = i[Ho] in n && (r[Cf] = n[l(f(43515, 43523))][CG[Fu]](), (function(n, r) {
                return n[CG[ov]](r) > -CG[Zf];
            })[so](void 0, r[Cf], i[Mf])), i[wo][CG[zh]] = i[wf] in n, i[wo][CG[$h]] = !!n[CG[_h]](s(f(43523, 43547))[CG[bf]](i[c(Cl)], l(f(43547, 43555)))), i[wo][CG[Kh]] = i[Ff] in n && i[Ef] in n && i[Of] in n, i[wo][CG[Vh]] = !!n[CG[_h]](i[ko]), i[wo][CG[Ch]] = i[Xf] in n || i[jf] in n, i[wo][CG[Ph]] = !!i[Cf][CG[Rh]](i[gf]), i[wo][CG[Qh]] = i[Zf] in n && i[c(FX)] in n, i[c(xu)][CG[Yh]] = i[Cf][CG[Zh]](i[kf])[CG[Kf]] > CG[Zf], i[wo][CG[ny]] = !!i[Cf][CG[Rh]](i[c(qX)]) || !!i[Cf][CG[Rh]](i[Wf]), i[wo][CG[ry]] = !!i[Cf][CG[_h]](i[Jo]), i[wo][CG[iy]] = !!i[c(Ip)][CG[_h]](i[_f]), i[c(xu)][CG[ty]] = !!i[Cf][CG[Rh]](i[Gf]), i[wo][CG[oy]] = !!i[Cf][CG[_h]](i[xf]), i[wo][CG[uy]] = !!i[Cf][CG[Rh]](i[Rf]), i[wo][CG[fy]] = !!i[Cf][CG[_h]](l(f(43555, 43659))), i[iv] = i[Cf][CG[_h]](i[Uf]), i[iv] && (i[wo][CG[vy]] = (function(n, r) {
                return n[PG[bs]] ? n[PG[c(iT)]](r) : !(!n[PG[ps]][r] || !n[PG[ps]][r][s(rT)]);
            })[so](void 0, i[iv], i[Sf]), i[c(xu)][CG[ey]] = (function(n, r) {
                return n[PG[bs]] ? n[PG[c(iT)]](r) : !(!n[PG[ps]][r] || !n[PG[ps]][r][s(rT)]);
            })[so](void 0, i[iv], i[If])), i[wo][CG[cy]] = !!i[Cf][CG[Rh]](i[Wo]), i[wo][CG[dy]] = !!i[Cf][CG[_h]](i[Go]), i[wo][CG[JT]] = i[c(EX)] in n && i[Df] in n[l(f(43659, 43667))], i[wo][CG[ay]] = !!i[Cf][CG[Rh]](i[Fu]), i[c(xu)][CG[ly]] = !!i[Cf][CG[Rh]](i[qf]), i[wo][CG[sy]] = !!i[Cf][CG[Rh]](i[zf]), i[wo][CG[hy]] = !!i[Cf][CG[Rh]](i[$f]), i[wo][CG[yy]] = (r[Pf] = i[Pf][a(f(43667, 43691))], r[Qf] = i[c(Nl)], (function(n, r) {
                return !!n && CG[_p](n, r) >= CG[ko];
            })[so](void 0, r[Pf], r[Qf])), i[Ro] = n[CG[Zh]](l(f(43691, 43703))), i[wo][CG[Ny]] = CG[NL](i[Ro], i[xo], i[Vf]);
        } catch (n) {}
        return i[wo];
    }, CG[pL] = function(n) {
        return [
            n[CG[Xh]],
            n[CG[gh]],
            n[CG[Lh]],
            n[CG[Hh]],
            n[CG[Jh]],
            n[CG[Wh]],
            n[CG[Gh]],
            n[CG[xh]],
            n[CG[Uh]],
            n[CG[Sh]],
            n[CG[Dh]],
            n[CG[qh]],
            n[CG[zh]],
            n[CG[Ih]],
            n[CG[$h]],
            n[CG[Kh]],
            n[CG[Vh]],
            n[CG[Ch]],
            n[CG[Ph]],
            n[CG[mL]],
            n[CG[Qh]],
            n[CG[Yh]],
            n[CG[e(ML)]],
            n[CG[ry]],
            n[CG[iy]],
            n[CG[ty]],
            n[CG[Bh]],
            n[CG[oy]],
            n[CG[484]],
            n[CG[uy]],
            n[CG[fy]],
            n[CG[vy]],
            n[CG[cy]],
            n[CG[dy]],
            n[CG[JT]],
            n[CG[ay]],
            n[CG[jh]],
            n[CG[ly]],
            n[CG[sy]],
            n[CG[hy]],
            n[CG[ey]],
            n[CG[yy]],
            n[CG[Ny]]
        ];
    }, PG[Sm] = a(f(43703, 43767)), PG[Im] = s(f(43767, 43807)), PG[Bm] = l(f(43807, 43931)), PG[Dm] = l(f(43931, 43995)), CG[wL] = function(n) {
        var r = [];
        var i = [];
        var o;
        for(o in i[wo] = {
            sv: PG[Sm] in n,
            _v: PG[Im] in n,
            dv: []
        }, n){
            i[c(df)] = PG[c(IE)];
            try {
                i[Ru] = CG[Hb](n, o), i[Au] = i[Ru] && (function(n) {
                    return typeof n === CG[zf];
                })[so](void 0, i[Ru][CG[cd]]);
            } catch (n) {}
            !i[c(df)] && (function(n) {
                return typeof n === CG[zf];
            })[so](void 0, n[o]) && (function(n) {
                return typeof n === CG[e(Qs)];
            })[so](void 0, n[o][CG[Fu]]) && (r[yb] = n[o][CG[Fu]](), r[Du] = PG[c(t(f(43995, 44004), Tr))], (function(n, r) {
                return n[CG[ov]](r) > -CG[Zf];
            })[so](void 0, r[yb], r[Du]) ? (i[wo][CG[my]] = !0, i[wo][CG[by]][CG[Cf]](o)) : (r[Iu] = n[o][CG[e(fj)]](), (function(n, r) {
                return n[CG[ov]](r) > -CG[Zf];
            })[so](void 0, r[Iu], PG[Dm]) && (i[c(xu)][CG[py]] = !0, i[c(xu)][CG[by]][CG[Cf]](o))));
        }
        return i[wo];
    }, PG[qm] = CG[My], PG[zm] = s(f(44004, 44084)), CG[AL] = function(n, r) {
        PG[qm] in n[s(Ub)] ? n[s(Ub)][CG[My]][s(f(44084, 44124))]()[CG[Pc]](function(n) {
            var i = [];
            if (n) {
                i[wo] = CG[Kp](CG[Ju](n[CG[wy]])), (function(n, r) {
                    var i = [];
                    i[wo] = CG[ko];
                    for(; i[wo] < n[CG[Kf]];)n[i[wo]] === r ? n[CG[Vf]](i[wo], CG[Zf]) : i[wo]++;
                    return n;
                })[so](void 0, i[wo], PG[zm]), i[Au] = [], i[Ru] = CG[ko], i[yb] = i[wo];
                for(; i[Ru] < i[yb][CG[Kf]]; i[Ru]++)i[Du] = i[yb][i[Ru]], i[Au][CG[Cf]](i[Du] + n[CG[wy]][i[Du]]);
                i[Iu] = i[Au][CG[jf]](CG[xo]), i[Nb] = CG[ko], i[mb] = CG[ko];
                for(; i[mb] < i[Iu][CG[Kf]]; i[c(ge)]++)i[Su] = i[Iu][CG[pv]](i[mb]), i[Nb] = (i[Nb] << CG[re]) - i[c(Tf)] + i[Su], i[Nb] |= CG[ko];
                r({
                    mv: n[CG[js]][CG[oe]],
                    yv: n[CG[js]][CG[ye]],
                    gv: n[l(f(44124, 44148))][a(f(44148, 44160))],
                    bv: n[l(f(44160, 44208))],
                    wv: i[Nb][CG[Fu]](),
                    Nv: PG[xv]
                });
            } else r(PG[c(IE)]);
        })[CG[Yc]](function() {
            r(PG[Rv]);
        }) : r(PG[Rv]);
    }, PG[wu] = [
        PG[xc],
        PG[Rc],
        PG[Bc],
        PG[Ic],
        PG[Sc]
    ], PG[$m] = s(f(44208, 44232)), CG[FL] = function(n) {
        var r = [];
        var i = [];
        if (n[CG[Kf]]) {
            i[wo] = {
                Mv: [
                    a(f(44232, 44248)),
                    l(f(44248, 44260)),
                    l(f(44260, 44284)),
                    s(f(44284, 44308))
                ],
                kv: [
                    a(f(44308, 44332))
                ],
                xv: [
                    l(f(44332, 44356))
                ],
                Av: [
                    s(f(44356, 44376))
                ]
            }, i[Au] = [
                {
                    Sv: PG[xc],
                    Ev: RegExp(i[wo][l(f(44376, 44384))][CG[jf]](CG[tu]), CG[bu])
                },
                {
                    Sv: PG[Rc],
                    Ev: RegExp(i[wo][s(f(44384, 44392))][CG[jf]](CG[tu]), CG[bu])
                },
                {
                    Sv: PG[Bc],
                    Ev: RegExp(i[c(xu)][l(f(44392, 44400))][CG[jf]](CG[tu]), CG[bu])
                },
                {
                    Sv: PG[Ic],
                    Ev: RegExp(i[wo][s(f(44400, 44408))][CG[jf]](CG[tu]), CG[bu])
                }
            ], r[Ru] = function(r) {
                var i = [];
                if (i[wo] = function(n) {
                    return r[s(f(44408, 44416))][CG[ie]](n[CG[Jf]]);
                }, (function(n, r) {
                    var i = [];
                    i[wo] = CG[ko], i[Au] = n;
                    for(; i[wo] < i[Au][CG[Kf]]; i[c(xu)]++)if (i[Ru] = i[Au][i[wo]], r(i[Ru])) return !0;
                    return !1;
                })[so](void 0, n, i[wo])) return {
                    value: r[CG[Ay]]
                };
            }, i[Ru] = CG[ko], i[yb] = i[Au];
            for(; i[Ru] < i[yb][CG[Kf]]; i[Ru]++)if (i[Du] = i[yb][i[Ru]], i[Iu] = r[Ru](i[Du]), typeof i[Iu] === CG[$f]) return i[Iu][CG[Ul]];
            return PG[Sc];
        }
    }, CG[EL] = function(n, r, i) {
        var t = [];
        var o = [];
        r && (function(n) {
            return typeof n === CG[zf];
        })[so](void 0, r[PG[$m]]) ? (o[wo] = r[PG[$m]](), o[c(df)] = o[wo] && o[wo][CG[Fa]] && o[wo][CG[Fa]](function(n) {
            return n[s(f(44416, 44436))];
        }), o[Ru] = {}, o[Au] && (o[Ru][CG[Fy]] = o[Au][a(f(44436, 44448))][CG[Yf]](CG[su])[CG[ko]]), o[Ru][CG[Ey]] = o[wo][CG[Kf]], o[Ru][CG[Oy]] = (t[wo] = function(n) {
            return n[l(f(44448, 44480))];
        }, (function(n, r) {
            var i = [];
            i[wo] = [], i[c(df)] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[c(af)][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[Au]], r(i[yb]) && i[wo][CG[Cf]](i[yb]);
            return i[wo];
        })[so](void 0, o[wo], t[wo]))[CG[Kf]], o[Ru][CG[Xy]] = (t[Au] = function(n) {
            return CG[mM](n[CG[Jf]], PG[Lc]);
        }, (function(n, r) {
            var i = [];
            i[wo] = [], i[c(df)] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[c(af)][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[Au]], r(i[yb]) && i[wo][CG[Cf]](i[yb]);
            return i[wo];
        })[so](void 0, o[wo], t[Au]))[CG[Kf]], o[Ru][CG[Ay]] = CG[FL](o[c(xu)]), i(o[Ru])) : i(PG[Rv]);
    }, CG[OL] = function(n, r) {
        var i = [];
        var t = [];
        t[wo] = n[PG[Pf]], t[wo] && (i[wo] = t[c(xu)][PG[$m]], (function(n) {
            return typeof n === CG[zf];
        })[so](void 0, i[wo])) && CG[jy] in t[wo] ? (CG[EL](n, t[wo], r), t[wo][CG[jy]] = function() {
            try {
                CG[EL](n, t[wo], r);
            } catch (n) {
                r(PG[Rv]);
            }
        }) : r(PG[Rv]);
    }, CG[XL] = function(n$jscomp$0) {
        var r = [];
        var i = [];
        if (!(function(n) {
            return typeof n == typeof PG[Rv];
        })[so](void 0, n$jscomp$0[CG[ss]]) && (i[wo] = CG[ag](n$jscomp$0), r[wo] = i[wo], (function(n) {
            return CG[hg](n) && !!(CG[Ml] in n);
        })[so](void 0, r[wo]) && (i[Au] = CG[_g](i[wo], d(t(f(44480, 44490), Tr)), CG[bv]), i[Au]))) {
            r[Au] = i[c(df)], r[Ru] = a(f(44490, 44502))[CG[bf]](PG[_v]), (function(n, r) {
                n[CG[El]] = r;
            })[so](void 0, r[Au], r[Ru]), i[Ru] = [
                a(f(44502, 44510)),
                a(f(44510, 44518)),
                l(f(44518, 44526)),
                s(f(44526, 44534)),
                a(f(44534, 44542)),
                s(f(44542, 44550)),
                a(f(44550, 44558)),
                CG[gy],
                CG[Ty],
                s(f(44558, 44566)),
                s(f(44566, 44574)),
                s(f(44574, 44582)),
                s(f(44582, 44590)),
                s(f(44590, 44598)),
                CG[Zy],
                l(f(44598, 44606)),
                l(f(44606, 44614)),
                l(f(44614, 44622)),
                l(f(44622, 44630)),
                a(f(44630, 44638)),
                s(f(44638, 44646)),
                CG[Zy],
                CG[Ty],
                CG[gy],
                s(f(44646, 44654)),
                a(f(44654, 44662)),
                s(f(44662, 44670)),
                l(f(44670, 44678)),
                a(f(44678, 44686)),
                a(f(44686, 44694)),
                s(f(44694, 44702)),
                a(f(44702, 44710)),
                s(f(44710, 44718)),
                l(f(44718, 44726)),
                l(f(44726, 44734)),
                l(f(44734, 44742)),
                s(f(44742, 44750)),
                a(f(44750, 44758)),
                a(f(44758, 44766)),
                l(f(44766, 44774)),
                s(f(44774, 44782)),
                s(f(44782, 44790)),
                s(f(44790, 44798)),
                l(f(44798, 44806)),
                l("OflDog=="),
                "\ud83c\udf53",
                a(f(44806, 44814)),
                s(f(44814, 44822)),
                s(f(44822, 44830)),
                l(f(44830, 44838)),
                a(f(44838, 44846)),
                l(f(44846, 44854)),
                l(f(44854, 44862)),
                a(f(44862, 44870)),
                a(f(44870, 44878)),
                a(f(44878, 44886)),
                l(f(44886, 44894)),
                a(f(44894, 44902)),
                s(f(44902, 44910)),
                l(f(44910, 44918)),
                s(f(44918, 44926)),
                a(f(44926, 44934)),
                l(f(44934, 44942)),
                s(f(44942, 44950)),
                a(f(44950, 44958)),
                a(f(44958, 44966)),
                s(f(44966, 44974)),
                a(f(44974, 44982)),
                s(f(44982, 44990)),
                s(f(44990, 44998)),
                a(f(44998, 45006)),
                l(f(45006, 45014)),
                a(f(45014, 45022)),
                l(f(45022, 45030)),
                s(f(45030, 45038)),
                l(f(45038, 45046))
            ], CG[eg]() !== PG[Sl] && i[Ru][CG[Cf]]("\u26bd", s(f(45046, 45054)), l(f(45054, 45062)), l(f(45062, 45070)), a(f(45070, 45078)), s(f(45078, 45086)), a(f(45086, 45094)), s(f(45094, 45102)), a(f(45102, 45110)), l(f(45110, 45118)), s(f(45118, 45126)), l(f(45126, 45134))), r[yb] = function(n, r) {
                var t = [];
                t[wo] = CG[wv] * (r + CG[Zf]), t[Au] = CG[wv], CG[jg](i[c(df)], n, t[wo], t[Au]);
            }, (function(n, r) {
                var i = [];
                i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
                for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
            })[so](void 0, i[e(af)], r[yb]);
            var n = i[wo];
            var o = [];
            if (o[c(xu)] = n[CG[Ml]](), o[wo]) return CG[1488](o[wo])[CG[Fu]](CG[bv]);
        }
    }, CG[jL] = function(n) {
        var r = [];
        if ((function(n) {
            var r = [];
            return r[wo] = CG[Uw](n), !(!r[c(xu)] || !r[e(xu)][PG[c(Rw)]]);
        })[so](void 0, n) && (r[wo] = CG[Iw](n), r[c(xu)] && r[wo][CG[he]])) return {
            Dv: r[wo][CG[he]],
            Lv: r[wo][s(f(45134, 45174))]
        };
    }, CG[t(f(45174, 45178), Tr)] = function(n) {
        return [
            n[l(gL)],
            n[a(TL)]
        ];
    }, CG[kL] = function(n$jscomp$0) {
        var r = [];
        if ((function(n) {
            var r = [];
            return r[wo] = CG[Uw](n), !(!r[c(xu)] || !CG[Lp](r[wo][PG[Po]]));
        })[so](void e(xu), n$jscomp$0) && !(function(n) {
            return typeof n == typeof PG[Rv];
        })[so](void 0, n$jscomp$0[CG[ss]])) {
            r[wo] = CG[Uw](n$jscomp$0), (function(n, r, i) {
                var t = [];
                if (t[wo] = CG[ag](n), CG[hg](t[c(xu)]) && (t[Au] = CG[_g](t[wo], CG[528], CG[528], {
                    willReadFrequently: i
                }), t[Au])) {
                    CG[gg](t[Au], s(ZL)[CG[bf]](PG[_v])), CG[Fg](t[Au], a(LL)), t[Ru] = CG[ko];
                    for(; t[Ru] < r; t[Ru]++)O(t[Au], a(HL), -CG[Zf], CG[528], CG[GM](CG[ha] * CG[IM]()), CG[GM](CG[ha] * CG[IM]()));
                }
            })[so](void 0, n$jscomp$0, CG[yv], !0), r[Au] = r[wo][CG[Uv]](), (function(n, r, i) {
                var o = [];
                if (o[wo] = CG[ag](n), CG[hg](o[c(xu)]) && (o[Au] = CG[_g](o[wo], CG[528], CG[528], {
                    willReadFrequently: i
                }), o[Au])) {
                    CG[gg](o[Au], s(ZL)[CG[bf]](PG[_v])), CG[Fg](o[Au], a(LL)), o[Ru] = CG[e(Yl)];
                    for(; o[Ru] < r; o[Ru]++)O(o[Au], a(HL), -CG[Zf], CG[528], CG[GM](CG[ha] * CG[e(t(f(45178, 45188), Tr))]()), CG[GM](CG[ha] * CG[IM]()));
                }
            })[so](void 0, n$jscomp$0, CG[xw], !0), r[Ru] = r[wo][CG[Uv]]() - r[Au], r[yb] = r[wo][CG[Uv]](), (function(n, r, i) {
                var o = [];
                if (o[wo] = CG[ag](n), CG[hg](o[c(xu)]) && (o[Au] = CG[_g](o[wo], CG[528], CG[528], {
                    willReadFrequently: i
                }), o[Au])) {
                    CG[gg](o[Au], s(ZL)[CG[bf]](PG[e(t(f(45188, 45198), Tr))])), CG[Fg](o[Au], a(LL)), o[Ru] = CG[ko];
                    for(; o[Ru] < r; o[Ru]++)O(o[Au], a(HL), -CG[Zf], CG[528], CG[GM](CG[ha] * CG[IM]()), CG[GM](CG[ha] * CG[IM]()));
                }
            })[so](void 0, n$jscomp$0, CG[xw], !1), r[Du] = r[c(xu)][CG[Uv]]() - r[yb], r[c(of)] = r[Du] !== CG[ko] && r[Ru] !== CG[ko] ? r[Du] / r[Ru] : CG[ko];
            var n = r[Iu];
            var t$jscomp$0 = CG[yv];
            var i = [];
            return t$jscomp$0 === void CG[ko] && (t$jscomp$0 = CG[yv]), CG[jb](n) && isFinite(n) ? (i[wo] = CG[XM](CG[mv], t$jscomp$0), CG[AM](n * i[wo]) / i[wo]) : PG[Eu];
        }
    }, CG[t(f(45198, 45202), Tr)] = function(n, i, t, o) {
        var u = [];
        var f = [];
        if (i || !(CG[cs] in n)) return PG[c(Ec)];
        f[Au] = CG[dp](n, PG[Gf]);
        try {
            f[Ru] = CG[dp](n, PG[kf]), f[yb] = a(JL)[CG[bf]](t, CG[Ly])[CG[bf]](o, a(WL))[CG[bf]](t, CG[Ly])[CG[bf]](o, l(_L)), f[Ru][a(GL)] = f[yb], u[Ru] = f[c(df)], (function(n, r) {
                n && n[a(ep)](r);
            })[so](void 0, u[Ru], f[Ru]), u[yb] = CG[$b](n), (function(n, r) {
                n && n[a(ep)](r);
            })[so](void 0, u[yb], f[Au]), f[Du] = n[CG[cs]](CG[$b](n)), f[c(xu)] = (u[Du] = f[Du][a(xL)](l(RL)[CG[bf]](t)), u[Du][CG[tv]](/^\s+|\s+$/g, CG[Wo]));
        } catch (n) {} finally{
            u[Su] = CG[$b](n), (function(n, r) {
                n && n[CG[xf]](r);
            })[so](void 0, u[Su], f[Au]);
        }
        return f[wo] ? r(f[wo]) : PG[Eu];
    }, CG[UL] = function(n, i) {
        var o = [];
        var u = [];
        u[wo] = CG[Ib](n), u[Au] = CG[_A](n), u[Ru] = CG[GA](n), u[yb] = {}, u[c(Nv)][CG[Hy]] = !!u[c(e(ff))][a(f(45202, 45230))], u[yb][CG[ky]] = (CG[Ib](n)[CG[pe]] || CG[ko]) > u[Au] || (CG[Ib](n)[CG[Me]] || CG[ko]) > u[Ru], u[yb][CG[Jy]] = CG[Sb](n)[s(zb)][l(f(45230, 45262))] > u[Au] || CG[Sb](n)[s(zb)][a(f(45262, 45294))] > u[Ru], u[yb][CG[WT]] = (n[l(Vb)] || CG[ko]) > u[Au] || (n[a(Pb)] || CG[ko]) > u[Ru], u[yb][CG[Wy]] = (n[l(Yb)] || CG[ko]) > u[Au], u[yb][CG[_y]] = !((function(n, i, o, u) {
            var v = [];
            if (i || !(CG[cs] in n)) return PG[c(e(t(f(45294, 45304), Tr)))];
            v[Au] = CG[dp](n, PG[Gf]);
            try {
                v[Ru] = CG[dp](n, PG[kf]), v[yb] = a(JL)[CG[bf]](o, CG[Ly])[CG[bf]](u, a(WL))[CG[bf]](o, CG[Ly])[CG[bf]](u, l(_L)), v[Ru][a(GL)] = v[yb], CG[vp](v[c(df)], v[Ru]), CG[vp](CG[$b](n), v[e(df)]), v[Du] = n[CG[cs]](CG[$b](n)), v[c(xu)] = CG[hM](v[Du][a(xL)](l(RL)[CG[bf]](o)));
            } catch (n) {} finally{
                CG[cp](CG[$b](n), v[Au]);
            }
            return v[wo] ? r(v[wo]) : PG[Eu];
        })[so](void 0, n, i, CG[be], u[Au]) === u[Au] && (function(n, i, t, o) {
            var u = [];
            if (i || !(CG[cs] in n)) return PG[c(Ec)];
            u[Au] = CG[dp](n, PG[Gf]);
            try {
                u[Ru] = CG[dp](n, PG[kf]), u[yb] = a(JL)[CG[bf]](t, CG[Ly])[CG[bf]](o, a(WL))[CG[bf]](t, CG[Ly])[CG[bf]](o, l(_L)), u[Ru][a(GL)] = u[yb], CG[vp](u[c(df)], u[Ru]), CG[vp](CG[$b](n), u[Au]), u[Du] = n[CG[cs]](CG[$b](n)), u[c(xu)] = CG[hM](u[Du][a(xL)](l(RL)[CG[bf]](t)));
            } catch (n) {} finally{
                CG[cp](CG[$b](n), u[Au]);
            }
            return u[wo] ? r(u[wo]) : PG[Eu];
        })[so](void 0, n, i, CG[_f], u[Ru]) === u[Ru]), u[Iu] = d(MX);
        for(; u[Iu] < d(t(f(45304, 45314), Tr)); u[c(of)]++)if (o[Nb] = n, o[mb] = l(f(45314, 45362)) + u[Iu] + s(f(45362, 45374)), CG[Lp](o[Nb][CG[Rl]]) && 0 != o[Nb][CG[Rl]](o[mb])[l(yT)]) {
            u[Du] = u[Iu];
            break;
        }
        return u[yb][CG[Gy]] = u[Du] !== n[PG[Fu]] * CG[528], u[yb][CG[xy]] = n[CG[Ef]][a(f(45374, 45422))] !== PG[Eu], u[yb];
    }, CG[SL] = function(n) {
        var r = [];
        if (r[wo] = CG[Ib](n), r[c(df)] = r[wo][CG[Ry]], r[Au]) return {
            Uv: r[Au][CG[we]],
            zv: r[Au][l(f(45422, 45438))]
        };
    }, CG[t(f(45438, 45442), Tr)] = function() {
        return {
            Vv: PG[xv],
            Gv: PG[xv]
        };
    }, CG[IL] = function(n) {
        return RegExp(PG[yv])[CG[ie]](n);
    }, CG[BL] = function(n) {
        return RegExp(PG[zo])[CG[ie]](n);
    }, CG[DL] = function(n, r) {
        return !(!n || !r) && n !== r;
    }, CG[qL] = function(n, r) {
        return !(!n || !r) && n !== r;
    }, CG[zL] = function(n, r) {
        return !(!n || !r) && n !== r;
    }, CG[$L] = function(n, r) {
        return !(!n || !r) && n !== r;
    }, CG[KL] = function(n, r) {
        return !(!n || !r) && JSON[a(pM)](n) !== JSON[a(pM)](r);
    }, CG[VL] = function(n, r, i) {
        return !(!n || !i) && r !== i;
    }, CG[CL] = function(n, r) {
        return !(!n || !r) && n !== r;
    }, PG[Km] = CG[ko], PG[Vm] = CG[Zf], PG[Cm] = CG[Df], PG[Pm] = CG[yv], PG[Qm] = CG[Xv], PG[Ym] = CG[re], PG[nb] = CG[gf], PG[rb] = CG[xw], PG[e(t(f(45442, 45452), Tr))] = CG[wv], PG[tb] = CG[Te], PG[c(t(f(45452, 45461), Tr))] = CG[Df], PG[ub] = CG[Df], PG[fb] = CG[yv], PG[vb] = CG[Xv], PG[eb] = CG[re], PG[cb] = CG[gf], PG[db] = CG[xw], PG[c(t(f(45461, 45470), Tr))] = CG[wv], PG[lb] = CG[Te], PG[c(t(f(45470, 45480), Tr))] = CG[mv], PG[hb] = CG[Le], PG[PL] = CG[Cv], PG[QL] = CG[Df], CG[YL] = function(n, r, i) {
        var o = [];
        try {
            if (o[Au] = n(), !o[Au]) return void i({
                Wv: !0
            });
            o[Au][CG[Uy]] = function(n) {
                var u = [];
                if (!(function(n) {
                    var r = [];
                    return r[c(xu)] = Array[s(Tp)], CG[Lp](r[wo]) ? r[c(xu)](n) : Object[PG[Wo]][CG[Fu]][CG[qf]](n) === l(Zp);
                })[so](void 0, n[CG[Qd]])) return clearTimeout(o[wo]), void (o[c(df)] && o[Au][CG[Sy]]());
                u[wo] = n[CG[Qd]][PG[c(t(f(45480, 45489), Tr))]], u[Au] = n[CG[Qd]][PG[Km]] === PG[c(t(f(45489, 45498), Tr))], !r[CG[e(t(f(45498, 45507), Tr))]] && u[wo] || (clearTimeout(o[wo]), o[Au] && o[e(df)][CG[Sy]]()), u[Au] ? i({
                    Wv: !0
                }) : i({
                    Jv: n[CG[Qd]]
                });
            }, o[Au][CG[By]](PG[c(JO)]), o[wo] = setTimeout(function() {
                o[Au] && o[Au][CG[Sy]](), i({
                    Zv: !0
                });
            }, r[CG[Dy]]);
        } catch (n) {
            (function(n) {
                var r = [];
                r[wo] = CG[Gj](), r[wo][CG[ka]] && r[c(xu)][CG[ka]](n);
            })[so](void 0, n), clearTimeout(o[wo]), o[Au] && o[Au][CG[Sy]](), i({
                Wv: !0
            });
        }
    }, CG[nH] = function(n, r, i) {
        var t = [];
        try {
            if (t[Au] = n(), !t[Au]) return void i({
                Wv: !0
            });
            t[Ru] = t[Au][a(f(45507, 45519))], t[Ru][CG[Uy]] = function(n) {
                var o = [];
                !(function(n) {
                    var r = [];
                    return r[c(xu)] = Array[s(Tp)], CG[Lp](r[wo]) ? r[c(xu)](n) : Object[PG[Wo]][CG[Fu]][CG[qf]](n) === l(Zp);
                })[so](void 0, n[CG[Qd]]) ? (function() {
                    clearTimeout(t[c(xu)]), t[Ru] && t[Ru][CG[qy]]();
                })[so](void 0) : (o[wo] = n[CG[Qd]][PG[Vm]], o[Au] = n[CG[Qd]][PG[Km]] === PG[Gm], !r[CG[Iy]] && o[wo] || (function() {
                    clearTimeout(t[c(xu)]), t[Ru] && t[Ru][CG[qy]]();
                })[so](void 0), n[CG[Qd]] && !o[Au] ? i({
                    Jv: n[CG[Qd]]
                }) : i({
                    Wv: !0
                }));
            }, t[Ru][CG[Id]](), t[Ru][CG[By]](CG[Id]), t[wo] = setTimeout(function() {
                (function() {
                    clearTimeout(t[c(xu)]), t[Ru] && t[Ru][CG[qy]]();
                })[so](void 0), i({
                    Zv: !0
                });
            }, r[CG[Dy]]);
        } catch (n) {
            (function(n) {
                var r = [];
                r[wo] = CG[Gj](), r[wo][CG[ka]] && r[c(xu)][CG[ka]](n);
            })[so](void 0, n), (function() {
                clearTimeout(t[c(xu)]), t[Ru] && t[Ru][CG[qy]]();
            })[so](void 0), i({
                Wv: !0
            });
        }
    }, CG[t(f(45519, 45523), Tr)] = function(n, r) {
        if (n[CG[Wf]][CG[zy]] == CG[$y] && n[CG[Ky]]) return new n[CG[Vy]](r);
    }, CG[t(f(45523, 45527), Tr)] = function(n, r) {
        if (n[CG[Wf]][CG[zy]] == CG[$y] && n[CG[Ky]] && n[CG[Cy]]) return new n[CG[Cy]](r);
    }, PG[rH] = s(f(45527, 45555)), CG[t(f(45555, 45559), Tr)] = function(n, r) {
        var i = [];
        if (n[CG[Wf]][CG[zy]] == CG[$y] && n[CG[Ky]]) return i[wo] = new n[CG[Py]]([
            r
        ], {
            type: CG[Qy][CG[bf]](PG[rH])
        }), i[Au] = n[CG[Yy]][CG[nN]](i[c(xu)]), new n[CG[Vy]](i[Au]);
    }, CG[t(f(45559, 45563), Tr)] = function(n, r) {
        var i = [];
        if (n[CG[Wf]][CG[zy]] == CG[$y] && n[CG[Ky]] && n[CG[Cy]]) return i[wo] = new n[CG[e(t(f(45563, 45573), Tr))]]([
            r
        ], {
            type: CG[Qy][CG[bf]](PG[rH])
        }), i[Au] = n[CG[Yy]][CG[nN]](i[wo]), new n[CG[Cy]](i[c(df)]);
    }, PG[iH] = a(f(45573, 45653)), PG[tH] = CG[Ta] * CG[Ta], PG[oH] = s(f(45653, 45701)), PG[c(t(f(45701, 45711), Tr))] = s(f(45711, 45751)), CG[uH] = function(n, r) {
        var i = [];
        i[wo] = CG[hA](n);
        try {
            i[Au] = CG[cF](n)[CG[rN]](i[wo], CG[Zf]), i[Au][a(f(45751, 45791))] = function(o) {
                var u = [];
                u[wo] = o[CG[iN]] && o[CG[iN]][CG[tN]] ? o[CG[iN]][CG[tN]] : PG[Rv];
                try {
                    u[wo][PG[oH]](PG[dl], {
                        autoIncrement: !0
                    })[l(f(45791, 45799))](new Blob), r(!1);
                } catch (n) {
                    return u[Au] = n, n instanceof Error && (u[Au] = n[CG[ll]] ? n[CG[ll]] : n), (function(n) {
                        return typeof n === l(Jp);
                    })[so](void 0, u[Au]) ? (u[Ru] = RegExp(PG[iH])[CG[ie]](u[Au]), r(u[Ru])) : r(!1);
                } finally{
                    u[wo][CG[qy]](), n[PG[Mc]][PG[t(f(45799, 45802), Tr)]](i[wo]);
                }
            };
        } catch (n) {
            return r(!1);
        }
    }, CG[fH] = function(n, r) {
        var i = [];
        i[wo] = CG[dF](n), i[Au] = n[PG[we]];
        try {
            i[wo](PG[e(Ec)], PG[Eu], PG[Eu], PG[Eu]);
        } catch (n) {
            return r(!0);
        }
        try {
            i[Au][CG[Wv]](PG[dl], CG[Co]), i[Au][CG[Gv]](PG[dl]);
        } catch (n) {
            return r(!0);
        }
        r(!1);
    }, CG[t(f(45802, 45806), Tr)] = function(n, r) {
        n[s(Ub)][PG[ws]] !== PG[Rv] ? CG[uH](n, r) : (function(n, r) {
            var i = [];
            i[wo] = CG[dF](n), i[Au] = n[PG[we]];
            try {
                i[wo](PG[Eu], PG[Eu], PG[Eu], PG[Eu]);
            } catch (n) {
                return r(!0);
            }
            try {
                i[Au][CG[Wv]](PG[dl], CG[Co]), i[Au][CG[Gv]](PG[dl]);
            } catch (n) {
                return r(!0);
            }
            r(!1);
        })[so](void 0, n, r);
    }, CG[vH] = function(n) {
        var r = [];
        return (function(n) {
            var r = [];
            return r[wo] = CG[Uw](n), !(!r[c(xu)] || !r[wo][PG[c(Rw)]]);
        })[so](void 0, n) && (r[wo] = CG[Iw](n), r[wo] && r[c(xu)][PG[Ac]] !== PG[Rv]) ? r[wo][PG[Ac]] : d(t(f(45806, 45815), Tr));
    }, PG[eH] = l(f(45815, 45863)), CG[cH] = function(n, r) {
        CG[Rb](n)[PG[Fc]][PG[eH]](function(i, t) {
            var o = [];
            o[wo] = CG[AM](t / PG[tH]), o[Au] = CG[AM](CG[vH](n) / PG[tH]) * CG[Df], r(o[wo] < o[Au]);
        }, function() {
            r(!1);
        });
    }, CG[dH] = function(n, r) {
        var i = [];
        var t = [];
        t[wo] = CG[lF](n), i[Au] = function() {
            r(!1);
        }, i[Ru] = function() {
            r(!0);
        }, t[wo](CG[ko], CG[Zf], i[Au], i[Ru]);
    }, CG[t(f(45863, 45867), Tr)] = function(n, r) {
        n[CG[Fe]] !== PG[Rv] && n[CG[Fe]][CG[Ae]] !== PG[Rv] ? CG[cH](n, r) : CG[dH](n, r);
    }, CG[t(f(45867, 45871), Tr)] = function(n, r) {
        var i = [];
        r((i[wo] = CG[uF](n), i[wo] === PG[Rv]));
    }, CG[t(f(45871, 45875), Tr)] = function(n, r) {
        var i = [];
        r((i[wo] = CG[cF](n), i[wo] === PG[Rv]));
    }, CG[aH] = function(n, r) {
        try {
            if (CG[eg]() === PG[Il]) {
                var i = n;
                var t$jscomp$0 = r;
                CG[Rb](i)[PG[ws]] !== PG[Rv] ? CG[uH](i, t$jscomp$0) : CG[fH](i, t$jscomp$0);
            }
            if (CG[eg]() === PG[Nu]) {
                var i$jscomp$0 = n;
                var t$jscomp$1 = r;
                i$jscomp$0[CG[Fe]] !== PG[Rv] && i$jscomp$0[CG[Fe]][CG[Ae]] !== PG[Rv] ? CG[cH](i$jscomp$0, t$jscomp$1) : CG[dH](i$jscomp$0, t$jscomp$1);
            }
            CG[e(t(f(45875, 45886), Tr))]() === PG[Sl] && r(CG[Xb](CG[uF](n))), CG[ug](n) === PG[Bl] && r(CG[Xb](CG[cF](n))), r(!1);
        } catch (n) {
            r(!1);
        }
    }, PG[lH] = l(f(45886, 45934)), PG[sH] = a(f(45934, 45990)), PG[hH] = l(f(45990, 46142)), CG[yH] = function(n) {
        var r = [];
        r[Ru] = RegExp(PG[lH], CG[bu])[CG[oN]](n), r[yb] = r[Ru][CG[Zf]] || void 0, r[Du] = RegExp(PG[sH], CG[Xh]);
        for(; r[Iu] = r[Du][CG[oN]](r[Ru][CG[Df]]), r[Iu];)switch(r[Nb] = r[Iu][CG[ko]], r[Nb][CG[ko]]){
            case CG[Ro]:
                return [
                    r[yb],
                    PG[Jf],
                    r[Nb][CG[iv]](CG[Zf])
                ];
            case "#":
                return [
                    r[yb],
                    CG[uN],
                    r[Nb][CG[iv]](CG[Zf])
                ];
            case CG[Lo]:
                if (r[mb] = RegExp(PG[hH])[CG[oN]](r[Nb]), r[c(ge)]) return [
                    r[yb],
                    r[mb][CG[Zf]],
                    null !== (r[Au] = null !== (r[wo] = r[c(ge)][CG[Xv]]) && r[c(xu)] !== void CG[ko] ? r[wo] : r[mb][CG[re]]) && r[Au] !== void CG[ko] ? r[Au] : PG[$o]
                ];
        }
        return [
            r[yb],
            void 0,
            void 0
        ];
    }, CG[NH] = function(n, r) {
        var i = [];
        return i[wo] = CG[yH](r), i[c(df)] = i[wo][CG[ko]], i[Ru] = i[wo][CG[Zf]], i[yb] = i[wo][CG[Df]], i[Du] = CG[dp](n, null !== i[Au] && i[Au] !== void CG[ko] ? i[Au] : PG[c(bb)]), i[Ru] && i[yb] && (function(n, r, i) {
            return n[s(fp)](r, i);
        })[so](void 0, i[Du], i[Ru], i[yb]), i[Du];
    }, CG[mH] = function(n) {
        return n;
    }, CG[bH] = function() {
        return [
            [
                CG[mH](s(f(46142, 46182))),
                CG[mH](s(f(46182, 46214))),
                CG[mH](s(f(46214, 46254)))
            ],
            [
                CG[mH](s(f(46254, 46286))),
                CG[mH](a(f(46286, 46326))),
                CG[mH](s(f(46326, 46366)))
            ],
            [
                CG[mH](s(f(46366, 46398))),
                CG[mH](a(f(46398, 46438))),
                CG[mH](s(f(46438, 46462)))
            ],
            [
                CG[mH](a(f(46462, 46506))),
                CG[mH](a(f(46506, 46546))),
                CG[mH](a(f(46546, 46578)))
            ],
            [
                CG[mH](s(f(46578, 46606))),
                CG[mH](a(f(46606, 46638))),
                CG[mH](l(f(46638, 46674)))
            ],
            [
                CG[mH](l(f(46674, 46690))),
                CG[mH](l(f(46690, 46706))),
                CG[mH](a(f(46706, 46730)))
            ],
            [
                CG[mH](s(f(46730, 46758)))
            ],
            [
                CG[mH](l(f(46758, 46782))),
                CG[mH](a(f(46782, 46798))),
                CG[mH](s(f(46798, 46822)))
            ],
            [
                CG[mH](a(f(46822, 46918)))
            ],
            [
                CG[mH](l(f(46918, 46942))),
                CG[mH](s(f(46942, 46978))),
                CG[mH](a(f(46978, 46998)))
            ],
            [
                CG[mH](l(f(46998, 47038))),
                CG[mH](l(f(47038, 47058))),
                CG[mH](s(f(47058, 47094)))
            ],
            [
                CG[mH](l(f(47094, 47106))),
                CG[mH](l(f(47106, 47122))),
                CG[mH](s(f(47122, 47146)))
            ],
            [
                CG[mH](a(f(47146, 47182))),
                CG[mH](s(f(47182, 47218))),
                CG[mH](s(f(47218, 47242)))
            ],
            [
                CG[mH](a(f(47242, 47274))),
                CG[mH](l(f(47274, 47306))),
                CG[mH](l(f(47306, 47346)))
            ],
            [
                CG[mH](l(f(47346, 47386))),
                CG[mH](l(f(47386, 47426))),
                CG[mH](l(f(47426, 47478)))
            ],
            [
                CG[mH](f(47478, 47492)),
                CG[mH](s(f(47492, 47512))),
                CG[mH](a(f(47512, 47536)))
            ],
            [
                CG[mH](a(f(47536, 47576))),
                CG[mH](l(f(47576, 47632))),
                CG[mH](s(f(47632, 47672)))
            ],
            [
                CG[mH](l(f(47672, 47704))),
                CG[mH](l(f(47704, 47744))),
                CG[mH](l(f(47744, 47756)))
            ],
            [
                CG[mH](a(f(47756, 47788))),
                CG[mH](s(f(47788, 47812))),
                CG[mH](l(f(47812, 47836)))
            ],
            [
                CG[mH](l(f(47836, 47872))),
                CG[mH](s(f(47872, 47916))),
                CG[mH](l(f(47916, 47944)))
            ],
            [
                CG[mH](s(f(47944, 47972))),
                CG[mH](a(f(47972, 48012))),
                CG[mH](s(f(48012, 48052)))
            ],
            [
                CG[mH](s(f(48052, 48084))),
                CG[mH](s(f(48084, 48116))),
                CG[mH](s(f(48116, 48140)))
            ],
            [
                CG[mH](s(f(48140, 48172))),
                CG[mH](l(f(48172, 48212))),
                CG[mH](l(f(48212, 48236)))
            ],
            [
                CG[mH](s(f(48236, 48268))),
                CG[mH](s(f(48268, 48288))),
                CG[mH](l(f(48288, 48320)))
            ],
            [
                CG[mH](l(f(48320, 48344))),
                CG[mH](a(f(48344, 48392))),
                CG[mH](s(f(48392, 48436)))
            ],
            [
                CG[mH](a(f(48436, 48500))),
                CG[mH](a(f(48500, 48568)))
            ],
            [
                CG[mH](l(f(48568, 48608)))
            ],
            [
                CG[mH](l(f(48608, 48656))),
                CG[mH](a(f(48656, 48700))),
                CG[mH](a(f(48700, 48732)))
            ],
            [
                CG[mH](s(f(48732, 48820)))
            ],
            [
                CG[mH](a(f(48820, 48844))),
                CG[mH](s(f(48844, 48892))),
                CG[mH](a(f(48892, 48936)))
            ],
            [
                CG[mH](s(f(48936, 48956))),
                CG[mH](s(f(48956, 48984))),
                CG[mH](s(f(48984, 49012)))
            ],
            [
                CG[mH](l(f(49012, 49032))),
                CG[e(pH)](a(f(49032, 49068))),
                CG[mH](a(f(49068, 49108)))
            ],
            [
                CG[mH](l(f(49108, 49132))),
                CG[mH](l(f(49132, 49156))),
                CG[mH](s(f(49156, 49188)))
            ],
            [
                CG[e(pH)](a(f(49188, 49232))),
                CG[mH](a(f(49232, 49288))),
                CG[mH](l(f(49288, 49328)))
            ],
            [
                CG[mH](a(f(49328, 49452)))
            ],
            [
                CG[mH](l(f(49452, 49508))),
                CG[mH](l(f(49508, 49584))),
                CG[mH](s(f(49584, 49648)))
            ],
            [
                CG[mH](s(f(49648, 49664))),
                CG[mH](a(f(49664, 49680))),
                CG[mH](f(49680, 49688))
            ],
            [
                CG[mH](a(f(49688, 49736))),
                CG[mH](l(f(49736, 49772)))
            ],
            [
                CG[mH](l(f(49772, 49788))),
                CG[mH](s(f(49788, 49804))),
                CG[mH](a(f(49804, 49832)))
            ],
            [
                CG[mH](s(f(49832, 49844))),
                CG[mH](l(f(49844, 49876))),
                CG[mH](a(f(49876, 49908)))
            ],
            [
                CG[mH](a(f(49908, 49920))),
                CG[mH](a(f(49920, 49944))),
                CG[mH](a(f(49944, 49968)))
            ],
            [
                CG[mH](s(f(49968, 5E4))),
                CG[mH](l(f(5E4, 50016))),
                CG[mH](s(f(50016, 50048)))
            ]
        ];
    }, CG[MH] = function(n, r) {
        var i = [];
        try {
            i[c(xu)] = CG[bH](), i[Au] = CG[Gu](i[wo], function(n, r) {
                return n[CG[bf]](r);
            }, []), CG[wH](n, i[Au], function(n) {
                r((function(n, r) {
                    var i = [];
                    i[e(df)] = CG[ko];
                    for(; i[Au] < n[CG[Kf]]; i[Au]++)CG[AH](n[i[Au]], r) && (i[wo] || (i[wo] = []), i[wo][CG[Cf]](i[Au]));
                    return i[wo];
                })[so](void 0, i[wo], n));
            });
        } catch (n) {
            r(void 0);
        }
    }, CG[t(f(50048, 50052), Tr)] = function(n, r) {
        var i = [];
        i[Au] = CG[ko];
        for(; i[Au] < n[CG[Kf]]; i[Au]++)(function(n, r) {
            var i = [];
            i[wo] = CG[ko], i[Au] = n;
            for(; i[wo] < i[c(df)][CG[Kf]]; i[wo]++)if (i[Ru] = i[Au][i[wo]], r[i[Ru]]) return !0;
            return !1;
        })[so](void 0, n[i[Au]], r) && (i[wo] || (i[wo] = []), i[wo][CG[Cf]](i[Au]));
        return i[wo];
    }, CG[AH] = function(n, r) {
        var i = [];
        i[wo] = CG[ko], i[Au] = n;
        for(; i[wo] < i[c(df)][CG[Kf]]; i[wo]++)if (i[Ru] = i[Au][i[wo]], r[i[Ru]]) return !0;
        return !1;
    }, CG[wH] = function(n, r, i) {
        var t = [];
        var o = [];
        o[wo] = CG[dp](n, PG[c(bb)]), (function(n) {
            CG[sp](n, a(Np), CG[Sf]), CG[sp](n, a(mp), a(bp));
        })[so](void 0, o[wo]), o[Au] = Array(r[CG[Kf]]), o[Ru] = CG[ko];
        for(; o[c(af)] < r[CG[Kf]]; ++o[e(af)])o[yb] = CG[NH](n, r[o[Ru]]), o[c(vf)] = CG[dp](n, PG[Gf]), (function(n) {
            CG[sp](n, a(Np), CG[Sf]), CG[sp](n, a(mp), a(bp));
        })[so](void 0, o[Du]), t[Iu] = o[c(Nv)], (function(n, r) {
            n && n[a(ep)](r);
        })[so](void 0, o[Du], t[Iu]), (function(n, r) {
            n && n[a(ep)](r);
        })[so](void 0, o[wo], o[yb]), o[Au][o[Ru]] = o[yb];
        t[wo] = CG[$b](n), (function(n, r) {
            n && n[a(ep)](r);
        })[so](void 0, t[wo], o[wo]), o[Iu] = {}, t[Au] = function() {
            var n = [];
            try {
                n[wo] = CG[ko];
                for(; n[wo] < r[CG[Kf]]; ++n[wo])o[Au][n[wo]][a(f(50052, 50084))] || (o[c(of)][r[n[wo]]] = !0);
            } finally{
                CG[lp](o[c(xu)]);
            }
            i(o[c(of)]);
        }, (function(n) {
            setTimeout(n, CG[ko]);
        })[so](void 0, t[Au]);
    }, PG[FH] = {
        email: !1,
        hidden: !1,
        password: !1,
        tel: !1,
        text: !1
    }, PG[EH] = l(f(50084, 50124)), PG[OH] = a(f(50124, 50180)), PG[t(f(50180, 50183), Tr)] = CG[fN], CG[e(t(f(50183, 50194), Tr))] = function(n) {
        if (n[CG[iN]] && n[CG[iN]][CG[Ul]] && n[CG[iN]][CG[we]] && n[CG[iN]][CG[we]] in PG[FH] && (PG[OH] === n[CG[Yd]] || !(CG[Qd] in n) || PG[EH] === n[s(XH)])) return !0;
    }, CG[jH] = function() {
        return PG[FH];
    }, CG[t(f(50194, 50198), Tr)] = function(n, r) {
        (function(n) {
            if (n[CG[iN]] && n[CG[iN]][CG[Ul]] && n[CG[iN]][CG[we]] && n[CG[iN]][CG[we]] in PG[FH] && (PG[OH] === n[CG[Yd]] || !(CG[Qd] in n) || PG[EH] === n[s(XH)])) return !0;
        })[so](void 0, n) && (PG[FH][n[CG[iN]][CG[e(t(f(50198, 50207), Tr))]]] = !0, r(n));
    }, CG[gH] = function(n, r) {
        var i = [];
        var o = [];
        o[wo] = CG[Sb](n), i[Ru] = function(n) {
            try {
                var i = n;
                CG[TH](i) && (PG[FH][i[CG[iN]][CG[we]]] = !0, r(i));
            } catch (n) {}
        }, i[wo] = PG[c(t(f(50207, 50217), Tr))], (function(n, r, i, t) {
            CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
        })[so](void 0, o[wo], i[wo], i[Ru], void 0), (function(n, r, i, t) {
            CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
        })[so](void 0, o[wo], PG[Df], i[Ru], void 0);
    }, PG[ZH] = CG[Bl], CG[LH] = function(n) {
        var r = [];
        return r[wo] = !1, CG[eg]() === PG[Nu] && (r[c(df)] = Error(), Object[PG[Vf]](r[Au], PG[ZH], {
            get: function() {
                return r[wo] = !0, PG[$o];
            }
        }), (function(n, r, i) {
            var t = [];
            CG[Zb](n, PG[Ae]) && (t[wo] = n[PG[Ae]], CG[Zb](t[wo], r) && t[wo][r](i));
        })[so](void 0, n, PG[Ee], r[Au])), r[c(xu)];
    }, CG[HH] = function(n) {
        var r = [];
        var i = [];
        try {
            return i[wo] = n[CG[Fu]](), i[Au] = Error[CG[vN]], Error[CG[vN]] = function() {
                return i[wo] = this[CG[Fu]](), i[Au];
            }, i[Ru] = Error(PG[$o]), (function(n, r, i) {
                var t = [];
                CG[Zb](n, PG[Ae]) && (t[wo] = n[PG[Ae]], CG[Zb](t[wo], r) && t[wo][r](i));
            })[so](void 0, n, PG[Ee], i[Ru]), Error[CG[vN]] = i[Au], (r[wo] = i[wo] + "", (function(n, r) {
                var i = [];
                i[wo] = n[CG[Kf]] & CG[yv], i[Au] = n[CG[Kf]] - i[wo], i[Ru] = r, i[yb] = d(Vj), i[Du] = d(Cj), i[Iu] = CG[ko], i[Nb] = CG[ko];
                for(; i[Iu] < i[Au];)i[Nb] = n[CG[pv]](i[Iu]) & CG[Xf] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[wv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[bv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[Ev], ++i[Iu], i[Nb] = (i[Nb] & CG[e(Ej)]) * i[yb] + (((i[Nb] >>> CG[bv]) * i[yb] & CG[ga]) << CG[bv]) & CG[ul], i[e(Tf)] = i[Nb] << CG[Mv] | i[Nb] >>> CG[fl], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[e(rg)]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb], i[Ru] = i[Ru] << CG[ke] | i[Ru] >>> CG[el], i[mb] = (i[c(af)] & CG[ga]) * CG[re] + (((i[Ru] >>> CG[bv]) * CG[re] & CG[e(Ej)]) << CG[bv]) & CG[ul], i[Ru] = (i[mb] & CG[ga]) + d(Pj) + (((i[mb] >>> CG[bv]) + d(c(Qj)) & CG[ga]) << CG[bv]);
                switch(i[Nb] = CG[ko], i[wo]){
                    case CG[yv]:
                        i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Df]) & CG[Xf]) << CG[bv];
                    case CG[Df]:
                        i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Zf]) & CG[Xf]) << CG[wv];
                    case CG[Zf]:
                        i[Nb] ^= n[CG[pv]](i[Iu]) & CG[Xf], i[Nb] = (i[Nb] & CG[ga]) * i[yb] + (((i[c(Tf)] >>> CG[bv]) * i[yb] & CG[ga]) << CG[bv]) & CG[ul], i[Nb] = i[Nb] << CG[Mv] | i[Nb] >>> CG[e(Ag)], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb];
                }
                return i[Ru] ^= n[CG[Kf]], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] = (i[Ru] & CG[ga]) * CG[dl] + (((i[Ru] >>> CG[bv]) * CG[dl] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[c(af)] >>> CG[ke], i[c(af)] = (i[Ru] & CG[ga]) * CG[al] + (((i[Ru] >>> CG[bv]) * CG[al] & CG[ga]) << CG[e(rg)]) & CG[ul], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] >>> CG[ko];
            })[so](void 0, r[wo], void 0))[CG[Fu]](CG[bv]);
        } catch (i) {
            return (r[Du] = CG[Sb](n)[CG[Fu]]() + "", (function(n, r) {
                var i = [];
                i[wo] = n[CG[Kf]] & CG[yv], i[Au] = n[CG[Kf]] - i[wo], i[Ru] = r, i[yb] = d(Vj), i[Du] = d(Cj), i[Iu] = CG[ko], i[Nb] = CG[ko];
                for(; i[Iu] < i[Au];)i[Nb] = n[CG[pv]](i[Iu]) & CG[Xf] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[wv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[bv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[Ev], ++i[Iu], i[Nb] = (i[Nb] & CG[ga]) * i[yb] + (((i[Nb] >>> CG[bv]) * i[yb] & CG[ga]) << CG[bv]) & CG[ul], i[Nb] = i[Nb] << CG[Mv] | i[Nb] >>> CG[fl], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb], i[Ru] = i[Ru] << CG[ke] | i[Ru] >>> CG[el], i[mb] = (i[c(af)] & CG[ga]) * CG[re] + (((i[Ru] >>> CG[bv]) * CG[re] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] = (i[mb] & CG[ga]) + d(Pj) + (((i[mb] >>> CG[bv]) + d(c(Qj)) & CG[ga]) << CG[bv]);
                switch(i[Nb] = CG[ko], i[wo]){
                    case CG[yv]:
                        i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Df]) & CG[Xf]) << CG[bv];
                    case CG[Df]:
                        i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Zf]) & CG[Xf]) << CG[wv];
                    case CG[Zf]:
                        i[Nb] ^= n[CG[pv]](i[Iu]) & CG[Xf], i[Nb] = (i[Nb] & CG[ga]) * i[yb] + (((i[c(Tf)] >>> CG[bv]) * i[yb] & CG[e(Ej)]) << CG[bv]) & CG[ul], i[Nb] = i[Nb] << CG[Mv] | i[Nb] >>> CG[fl], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb];
                }
                return i[Ru] ^= n[CG[Kf]], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] = (i[Ru] & CG[ga]) * CG[dl] + (((i[Ru] >>> CG[bv]) * CG[dl] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[c(af)] >>> CG[ke], i[c(af)] = (i[Ru] & CG[ga]) * CG[al] + (((i[Ru] >>> CG[bv]) * CG[al] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] >>> CG[ko];
            })[so](void 0, r[Du], void 0))[CG[Fu]](CG[bv]);
        }
    }, CG[t(f(50217, 50221), Tr)] = function(n) {
        var r = n;
        var i = PG[sv];
        return CG[Lp](r[CG[Rl]]) && 0 != r[CG[Rl]](i)[l(yT)];
    }, CG[kH] = function(n) {
        var r = [];
        var i = [];
        return i[wo] = [
            {
                $v: n[CG[Af]][PG[Wo]],
                Qv: [
                    a(f(50221, 50245)),
                    CG[ve],
                    CG[ae],
                    CG[ce],
                    CG[ee],
                    CG[ue],
                    CG[Of],
                    CG[fe],
                    CG[te],
                    CG[xl]
                ]
            },
            {
                $v: n[CG[ds]][PG[Wo]],
                Qv: [
                    CG[le],
                    CG[se],
                    CG[be],
                    CG[_f],
                    CG[pe],
                    CG[Me],
                    CG[eN],
                    CG[cN],
                    CG[Ry]
                ]
            }
        ], i[Au] = [], r[wo] = function(n) {
            CG[Dp](n[s(f(50245, 50253))], function(r) {
                var t = [];
                var o = [];
                o[wo] = (t[0] = n[s(f(50253, 50261))], (function(n, r) {
                    var i = [];
                    try {
                        return i[wo] = CG[Hb](n, r), !((null === i[wo] || i[wo] === void CG[ko] ? void CG[ko] : i[wo][CG[Ul]]) === PG[Rv]);
                    } catch (n) {}
                })[so](void 0, t[0], r)), o[e(xu)] && i[Au][CG[Cf]](r);
            });
        }, (function(n, r) {
            var i = [];
            i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
        })[so](void 0, i[wo], r[wo]), i[Au];
    }, CG[JH] = function(n) {
        var r = [];
        r[wo] = !1, r[Au] = !1;
        try {
            CG[dN] in n && PG[Wo] in n[CG[dN]] && (function(n) {
                return typeof n === CG[zf];
            })[so](void 0, n[CG[dN]][PG[Wo]][PG[_s]]) && n[CG[dN]][PG[Wo]][PG[_s]]({
                trim: function() {
                    return r[wo] = !0, CG[Wo];
                }
            });
        } catch (n) {}
        try {
            n[CG[dN]][PG[Wo]][PG[_s]]({
                split: function(n) {
                    return r[Au] = !0, n[CG[Yf]](CG[xo]);
                }
            });
        } catch (n) {}
        return {
            Yv: r[wo],
            rf: r[Au]
        };
    }, CG[WH] = function(n) {
        var r = [];
        var i = [];
        return i[wo] = [
            PG[Qe] + CG[Po],
            PG[Qe],
            PG[vc],
            PG[nc],
            PG[Ye],
            PG[qe],
            PG[mv],
            PG[ze],
            PG[Ie],
            PG[c(t(f(50261, 50272), Tr))],
            PG[ic],
            PG[Ce],
            PG[Ke],
            PG[Ve]
        ], i[Au] = {}, r[wo] = function(r) {
            try {
                CG[Hb](CG[Ju](CG[Rb](n)), r)[CG[cd]][CG[$v]](d(t(f(50272, 50281), Tr)));
            } catch (n) {
                i[Au][r] = n[CG[Bl]];
            }
        }, (function(n, r) {
            var i = [];
            i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
        })[so](void 0, i[wo], r[wo]), i[Ru] = [], i[c(af)][CG[Cf]](i[Au][PG[c(t(f(50281, 50291), Tr))]]), i[Ru][CG[Cf]](i[Au][PG[Ce]]), i[Ru][CG[Cf]](i[Au][PG[Ke]]), i[Ru][CG[Cf]](i[Au][PG[Ve]]), i[yb] = [], r[Au] = CG[qp](i[Au]), r[Ru] = function(n) {
            i[yb][CG[Cf]](n);
        }, (function(n, r) {
            var i = [];
            i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
        })[so](void 0, r[Au], r[Ru]), i[Du] = CG[Qp](i[yb]), i[Iu] = CG[Qp](i[Ru]), i[Nb] = PG[Eu], i[Iu][CG[Kf]] === CG[Zf] && (i[Nb] = i[c(df)][PG[ic]]), i[Nb] === PG[c(Ec)] ? PG[c(t(f(50291, 50302), Tr))] : (i[mb] = i[wo][CG[fd]](function(n) {
            return i[Au][n] !== i[Nb];
        }), {
            af: i[Du][CG[Kf]],
            tf: i[mb]
        });
    }, CG[_H] = function(n) {
        var r = [];
        var i = [];
        return i[wo] = CG[ag](n), r[wo] = i[wo], (function(n) {
            return !(!n || !n[CG[pl]]);
        })[so](void 0, r[wo]) ? (i[Au] = i[wo][CG[pl]](PG[rs]) || CG[Ng](i[wo]), i[Au] ? CG[eg]() !== PG[Sl] && (i[Ru] = i[Au][CG[Al]](PG[us]), i[Ru]) ? i[c(df)][CG[wl]](a(f(50302, 50318))) : PG[gm] : PG[c(_Z)]) : PG[jm];
    }, CG[t(f(50318, 50322), Tr)] = function(n) {
        var r = [];
        r[yb] = !1, r[Du] = !1, r[wo] = CG[mM](n[CG[aN]][PG[Vf]][CG[Fu]](), PG[Sf]), r[Au] = n[CG[aN]][PG[Vf]][CG[Fu]][CG[Fu]]()[CG[tv]](l(GH), "()") === Function[PG[Wo]][CG[Fu]](), r[Ru] = n[CG[aN]][PG[Vf]][CG[Fu]][CG[Jf]];
        try {
            new n[CG[aN]][PG[Vf]][CG[Fu]];
        } catch (n) {
            r[c(Nv)] = !0;
        }
        try {
            n[CG[aN]][PG[Kf]](n[CG[aN]][PG[c(oA)]][CG[Fu]], n[CG[aN]][PG[Vf]][CG[Fu]]), r[Du] = !0;
        } catch (n) {
            r[c(vf)] = !1;
        }
        return {
            ef: r[wo],
            uf: r[Au],
            if: r[e(af)],
            ff: r[yb],
            cf: r[Du]
        };
    }, CG[xH] = function(n) {
        var r = [];
        if (r[wo] = PG[gm], CG[Gw] in n) {
            r[wo] = PG[Zm];
            try {
                Object[PG[c(Nl)]](n[CG[Gw]], n[CG[Gw]]);
            } catch (n) {
                r[wo] = n[CG[Bl]][CG[Yf]]("\n")[CG[ko]][CG[iv]](CG[ko], CG[yl]);
            }
        }
        return r[wo];
    }, CG[RH] = function(n) {
        var r = [];
        r[wo] = !1, r[Au] = !1;
        try {
            n[CG[aN]][PG[c(Nl)]](n[CG[aN]][PG[xo]](n[CG[aN]][PG[c(Lj)]](screen), CG[be])[CG[cd]], n[CG[aN]][PG[xo]](n[CG[aN]][PG[$f]](screen), CG[be])[CG[cd]]);
        } catch (n) {
            r[c(xu)] = !0;
        }
        try {
            n[CG[aN]][PG[c(Zj)]](n[CG[aN]][PG[$f]](screen), CG[be])[CG[cd]][CG[lN]] = CG[pu], n[CG[aN]][PG[Kf]](n[CG[aN]][PG[xo]](n[CG[aN]][PG[$f]](screen), CG[be])[CG[cd]], n[CG[aN]][PG[xo]](n[CG[aN]][PG[$f]](screen), CG[be])[CG[cd]]), delete n[CG[aN]][PG[xo]](n[CG[aN]][PG[$f]](screen), CG[be])[CG[cd]][CG[lN]];
        } catch (n) {
            r[Au] = !0;
        }
        return r[wo] && !r[c(df)];
    }, CG[UH] = function(n, r) {
        var i = [];
        return i[c(xu)] = CG[NM](n), i[Au] = r < CG[vM](i[wo]) ? r : CG[ko], i[Ru] = CG[eM](i[wo], i[Au]), i[Ru] < CG[Io] || i[Ru] > CG[To] ? CG[ko] : i[Ru][CG[pv]](CG[ko]) - CG[Ps];
    }, CG[SH] = function(n, r) {
        var i = [];
        return i[wo] = (n << CG[Zf]) + n + r & CG[Mv], i[Au] = (i[wo] ^ CG[xw]) & CG[Mv], i[Ru] = (i[Au] << CG[yv]) + i[Au] & CG[Xf] & CG[Mv], i[c(af)] % CG[mv];
    }, CG[IH] = function(n, r, i) {
        var t = [];
        return t[wo] = (n << CG[yv] ^ r << CG[Zf] ^ i & CG[Xf]) & CG[Xf], t[wo] & CG[Mv];
    }, CG[t(f(50322, 50326), Tr)] = function(n, r, i, t) {
        var o = [];
        o[wo] = {
            sf: CG[ko],
            _f: CG[Wo],
            df: CG[Wo]
        };
        try {
            if (o[wo][CG[sN]] = (function(n) {
                var r = [];
                if (r[wo] = CG[sg](n), CG[hg](r[wo])) return r[Au] = r[wo][CG[pl]](PG[rs]) || CG[Ng](r[wo]), CG[dg]() ? r[Au][CG[wl]](r[Au][s(bg)]) : (r[Ru] = r[Au] && r[Au][CG[Al]](PG[c(pg)]), r[Ru] ? r[Au][CG[wl]](r[Ru][a(Mg)]) : void 0);
            })[so](void 0, n) || PG[gm], o[wo][CG[sN]] === PG[gm]) return -CG[Zf];
            o[wo][l(BH)] = CG[Wo][CG[bf]](r, CG[su])[CG[bf]](i, CG[su])[CG[bf]](t), o[Au] = d(oO), o[Ru] = CG[1488](o[wo][CG[sN]], o[Au]), o[yb] = (r << CG[wv] | i << CG[Xv] | t & CG[Mv]) & CG[ga], o[Du] = (o[Ru] ^ o[yb]) & CG[ga], o[wo][CG[hN]] = o[Du] % CG[Ea] + CG[Zf];
        } catch (n) {
            return -CG[Zf];
        }
        return o[wo][CG[hN]];
    }, CG[t(f(50326, 50330), Tr)] = function(n, r, i) {
        var t = [];
        return t[wo] = CG[IH](n, r, i), t[Au] = CG[UH](n, CG[ko]), t[Ru] = CG[UH](r, CG[ko]), t[yb] = CG[UH](i, CG[yv]), t[Du] = CG[SH](t[Au], t[wo]), t[Iu] = CG[SH](t[Ru], (t[wo] + CG[yv]) % CG[mv]), t[c(Tf)] = CG[SH](t[yb], (t[wo] + CG[xw]) % CG[mv]), t[mb] = CG[GM](CG[IM]() * CG[mv]), t[Su] = CG[GM](CG[IM]() * CG[e(RM)]), t[c(Ze)] = CG[GM](CG[IM]() * CG[mv]), t[To] = CG[GM](CG[IM]() * CG[mv]), t[yf] = CG[GM](CG[IM]() * CG[mv]), t[Nf] = CG[GM](CG[IM]() * CG[mv]), t[c(Je)] = CG[GM](CG[IM]() * CG[mv]), t[bf] = CG[GM](CG[IM]() * CG[mv]), t[pf] = CG[Wo][CG[bf]](t[mb])[CG[bf]](t[Du])[CG[bf]](t[c(ef)])[CG[bf]](t[hf])[CG[bf]](t[To])[CG[bf]](t[yf])[CG[bf]](t[e(of)])[CG[bf]](t[e(Pv)])[CG[bf]](t[mf])[CG[bf]](t[Nb])[CG[bf]](t[bf]), t[pf];
    }, CG[t(f(50330, 50334), Tr)] = function(n, r) {
        var i = [];
        var t = [];
        t[wo] = {
            pf: CG[ko],
            yf: !1,
            gf: !1,
            wf: CG[Wo],
            kf: CG[Wo]
        };
        try {
            if (t[Au] = CG[sg](n), t[Au][CG[be]] = CG[Zf], t[c(df)][CG[_f]] = CG[Zf], t[Ru] = t[c(df)][CG[pl]](PG[rs]) || CG[Ng](t[c(df)]), !t[Ru]) return t[wo][CG[yN]] = !0, -CG[Zf];
            if (t[wo][CG[NN]] = !0, t[yb] = [
                CG[ZA](n),
                CG[JA](n),
                (CG[UA](n) || PG[gm])[CG[Fu]](),
                (CG[SA](n) || PG[gm])[CG[Fu]](),
                r
            ], t[wo][a(DH)] = r, t[Du] = d(qH), t[wo][CG[mN]] = (i[Au] = t[yb][CG[jf]](CG[xo]), (function(n, r) {
                var i = [];
                i[wo] = n[CG[Kf]] & CG[yv], i[Au] = n[CG[e(Nl)]] - i[wo], i[Ru] = r, i[yb] = d(Vj), i[Du] = d(Cj), i[Iu] = CG[ko], i[Nb] = CG[ko];
                for(; i[Iu] < i[Au];)i[Nb] = n[CG[pv]](i[Iu]) & CG[Xf] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[wv] | (n[CG[pv]](++i[Iu]) & CG[e(fw)]) << CG[bv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[Ev], ++i[Iu], i[Nb] = (i[Nb] & CG[e(Ej)]) * i[yb] + (((i[Nb] >>> CG[bv]) * i[yb] & CG[ga]) << CG[bv]) & CG[ul], i[Nb] = i[Nb] << CG[Mv] | i[Nb] >>> CG[fl], i[Nb] = (i[e(Tf)] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb], i[Ru] = i[Ru] << CG[ke] | i[Ru] >>> CG[el], i[mb] = (i[c(af)] & CG[ga]) * CG[re] + (((i[Ru] >>> CG[bv]) * CG[re] & CG[ga]) << CG[e(rg)]) & CG[ul], i[Ru] = (i[mb] & CG[ga]) + d(Pj) + (((i[mb] >>> CG[bv]) + d(c(Qj)) & CG[ga]) << CG[bv]);
                switch(i[Nb] = CG[ko], i[wo]){
                    case CG[yv]:
                        i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Df]) & CG[Xf]) << CG[bv];
                    case CG[Df]:
                        i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Zf]) & CG[Xf]) << CG[wv];
                    case CG[Zf]:
                        i[Nb] ^= n[CG[pv]](i[Iu]) & CG[Xf], i[Nb] = (i[Nb] & CG[ga]) * i[yb] + (((i[c(Tf)] >>> CG[bv]) * i[yb] & CG[ga]) << CG[bv]) & CG[ul], i[Nb] = i[Nb] << CG[Mv] | i[Nb] >>> CG[fl], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb];
                }
                return i[Ru] ^= n[CG[Kf]], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] = (i[Ru] & CG[ga]) * CG[dl] + (((i[Ru] >>> CG[bv]) * CG[dl] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[c(af)] >>> CG[ke], i[c(af)] = (i[Ru] & CG[ga]) * CG[al] + (((i[Ru] >>> CG[bv]) * CG[al] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] >>> CG[ko];
            })[so](void 0, i[Au], t[Du]))[CG[Fu]](CG[bv]), t[Iu] = CG[1488](t[wo][CG[mN]] + CG[Co], t[Du]) % CG[Ql], t[Nb] = CG[1488](t[wo][CG[mN]] + "2", t[Du]) % CG[Ql], t[mb] = CG[1488](t[e(xu)][CG[mN]] + CG[pu], t[c(vf)]) % CG[Ql], t[Su] = CG[1488](t[wo][CG[mN]] + CG[Vo], t[Du]) % CG[Ql], t[hf] = CG[1488](t[wo][CG[mN]] + "5", t[c(vf)]) % CG[Ql], t[To] = l(zH), t[yf] = a($H), t[Nf] = t[Ru][CG[bN]](t[Ru][a(KH)]), t[c(af)][CG[pN]](t[Nf], t[To]), t[Ru][CG[MN]](t[c(Pv)]), t[mf] = t[c(af)][CG[bN]](t[Ru][l(VH)]), t[Ru][CG[pN]](t[mf], t[yf]), t[Ru][CG[MN]](t[mf]), !t[Ru][CG[e(GT)]](t[Nf], t[c(af)][CG[AN]])) return t[wo][CG[yN]] = !0, -CG[Zf];
            if (!t[Ru][CG[wN]](t[mf], t[Ru][CG[AN]])) return t[wo][CG[yN]] = !0, -CG[Zf];
            if (t[bf] = t[Ru][a(CH)](), t[Ru][CG[FN]](t[e(Zv)], t[c(Pv)]), t[Ru][CG[FN]](t[bf], t[mf]), t[Ru][a(PH)](t[bf]), !t[Ru][s(QH)](t[bf], t[Ru][l(YH)])) return t[wo][CG[yN]] = !0, -CG[Zf];
            t[Ru][a(nk)](t[bf]), t[Ru][a(rk)](CG[ko], CG[ko], CG[Zf], CG[Zf]), t[pf] = t[Ru][s(ik)](), t[Ru][l(tk)](t[Ru][CG[EN]], t[pf]), t[Ru][a(ok)](t[Ru][CG[EN]], new Float32Array([
                CG[ko],
                CG[ko]
            ]), t[Ru][s(uk)]), t[Zo] = t[c(af)][l(fk)](t[bf], l(vk)), t[Lo] = t[Ru][CG[ON]](t[c(Zv)], l(ek)), t[c(ne)] = t[Ru][CG[ON]](t[bf], l(ck)), t[c(cl)] = t[Ru][CG[ON]](t[bf], l(dk)), t[wf] = t[Ru][CG[ON]](t[bf], a(ak)), t[Af] = t[Ru][CG[ON]](t[bf], l(lk)), t[Ru][CG[XN]](t[Lo], t[Iu]), t[Ru][CG[XN]](t[Ho], t[Nb]), t[Ru][CG[XN]](t[Mf], t[mb]), t[Ru][CG[XN]](t[wf], t[Su]), t[Ru][CG[XN]](t[Af], t[hf]), t[Ru][s(sk)](t[c(uf)]), t[Ru][a(hk)](t[Zo], CG[Df], t[Ru][a(yk)], !1, CG[ko], CG[ko]), t[Ru][s(Nk)](CG[ko], CG[ko], CG[ko], CG[Zf]), t[Ru][CG[zv]](t[Ru][a(mk)]), t[Ru][l(bk)](t[Ru][a(pk)], CG[ko], CG[Zf]), t[Ff] = new Uint8Array(CG[Xv]), t[Ru][s(Mk)](CG[ko], CG[ko], CG[Zf], CG[Zf], t[Ru][l(wk)], t[Ru][l(Ak)], t[Ff]), t[c(Pl)] = t[Ff][CG[ko]] / CG[Xf], t[wo][CG[jN]] = Math[CG[uv]](t[Ef] * CG[Xf]), t[c(af)][s(Fk)](t[c(bX)]), t[c(af)][CG[gN]](t[Nf]), t[c(af)][CG[gN]](t[mf]), t[Ru][a(Ek)](t[bf]);
        } catch (n) {
            return t[wo][CG[yN]] = !0, -CG[Zf];
        }
        return t[wo][CG[yN]] || !t[wo][CG[NN]] ? -CG[Zf] : t[wo][CG[jN]];
    }, CG[Ok] = function(n, r) {
        var i = [];
        var t = [];
        return t[c(xu)] = CG[Zw](), t[c(df)] = t[wo][l(f(50334, 50354))](), t[Ru] = t[wo][CG[Xe]]() + CG[Zf], t[yb] = t[wo][a(f(50354, 50386))](), r ? {
            Af: t[Au],
            Sf: t[Ru],
            Tf: t[yb]
        } : {
            Af: t[Au],
            Sf: t[Ru],
            Tf: t[yb],
            If: (i[wo] = t[c(af)], (function(n, r, i) {
                var t = [];
                return t[wo] = CG[IH](n, r, i), t[Au] = CG[UH](n, CG[ko]), t[Ru] = CG[UH](r, CG[ko]), t[yb] = CG[UH](i, CG[yv]), t[Du] = CG[SH](t[Au], t[wo]), t[Iu] = CG[SH](t[Ru], (t[wo] + CG[yv]) % CG[mv]), t[c(Tf)] = CG[SH](t[yb], (t[wo] + CG[xw]) % CG[mv]), t[mb] = CG[GM](CG[IM]() * CG[mv]), t[Su] = CG[GM](CG[IM]() * CG[mv]), t[c(Ze)] = CG[GM](CG[IM]() * CG[mv]), t[To] = CG[GM](CG[IM]() * CG[mv]), t[yf] = CG[GM](CG[IM]() * CG[mv]), t[Nf] = CG[GM](CG[IM]() * CG[mv]), t[c(Je)] = CG[GM](CG[IM]() * CG[mv]), t[bf] = CG[GM](CG[IM]() * CG[mv]), t[pf] = CG[Wo][CG[bf]](t[e(ge)])[CG[bf]](t[Du])[CG[bf]](t[c(ef)])[CG[bf]](t[hf])[CG[bf]](t[To])[CG[bf]](t[yf])[CG[bf]](t[Iu])[CG[bf]](t[Nf])[CG[e(Zv)]](t[mf])[CG[bf]](t[Nb])[CG[bf]](t[bf]), t[pf];
            })[so](void 0, t[Au], i[wo], t[yb])),
            Df: (i[Au] = t[c(af)], (function(n, r, i, t) {
                var o = [];
                o[wo] = {
                    sf: CG[ko],
                    _f: CG[Wo],
                    df: CG[Wo]
                };
                try {
                    if (o[wo][CG[sN]] = CG[mg](n) || PG[gm], o[wo][CG[sN]] === PG[gm]) return -CG[Zf];
                    o[wo][l(BH)] = CG[Wo][CG[bf]](r, CG[su])[CG[bf]](i, CG[su])[CG[bf]](t), o[Au] = d(oO), o[Ru] = CG[1488](o[wo][CG[sN]], o[Au]), o[yb] = (r << CG[wv] | i << CG[Xv] | t & CG[Mv]) & CG[ga], o[Du] = (o[Ru] ^ o[e(Nv)]) & CG[ga], o[wo][CG[hN]] = o[Du] % CG[Ea] + CG[e(fs)];
                } catch (n) {
                    return -CG[Zf];
                }
                return o[wo][CG[hN]];
            })[so](void 0, n, t[Au], i[Au], t[yb])),
            Rf: (i[Ru] = t[Au][CG[Fu]](), (function(n, r) {
                var i = [];
                i[wo] = {
                    pf: CG[ko],
                    yf: !1,
                    gf: !1,
                    wf: CG[Wo],
                    kf: CG[Wo]
                };
                try {
                    if (i[Au] = CG[sg](n), i[Au][CG[be]] = CG[Zf], i[c(df)][CG[_f]] = CG[Zf], i[Ru] = i[c(df)][CG[pl]](PG[rs]) || CG[Ng](i[c(e(Lf))]), !i[Ru]) return i[wo][CG[yN]] = !0, -CG[Zf];
                    if (i[wo][CG[NN]] = !0, i[yb] = [
                        CG[ZA](n),
                        CG[JA](n),
                        (CG[UA](n) || PG[gm])[CG[Fu]](),
                        (CG[SA](n) || PG[gm])[CG[Fu]](),
                        r
                    ], i[wo][a(DH)] = r, i[Du] = d(qH), i[wo][CG[mN]] = CG[1488](i[yb][CG[jf]](CG[xo]), i[Du])[CG[Fu]](CG[bv]), i[Iu] = CG[1488](i[wo][CG[mN]] + CG[Co], i[Du]) % CG[Ql], i[Nb] = CG[1488](i[wo][CG[mN]] + "2", i[Du]) % CG[Ql], i[mb] = CG[1488](i[wo][CG[mN]] + CG[pu], i[c(vf)]) % CG[Ql], i[Su] = CG[1488](i[wo][CG[mN]] + CG[Vo], i[Du]) % CG[Ql], i[hf] = CG[1488](i[wo][CG[mN]] + "5", i[c(vf)]) % CG[Ql], i[To] = l(zH), i[yf] = a($H), i[Nf] = i[Ru][CG[bN]](i[Ru][a(KH)]), i[c(af)][CG[pN]](i[Nf], i[To]), i[Ru][CG[MN]](i[c(Pv)]), i[mf] = i[c(af)][CG[bN]](i[Ru][l(VH)]), i[Ru][CG[pN]](i[mf], i[yf]), i[Ru][CG[MN]](i[mf]), !i[Ru][CG[wN]](i[Nf], i[c(af)][CG[AN]])) return i[wo][CG[yN]] = !0, -CG[Zf];
                    if (!i[e(af)][CG[wN]](i[mf], i[Ru][CG[AN]])) return i[wo][CG[yN]] = !0, -CG[Zf];
                    if (i[bf] = i[Ru][a(CH)](), i[Ru][CG[FN]](i[bf], i[c(Pv)]), i[Ru][CG[FN]](i[bf], i[mf]), i[Ru][a(PH)](i[bf]), !i[Ru][s(QH)](i[bf], i[Ru][l(YH)])) return i[wo][CG[yN]] = !0, -CG[Zf];
                    i[Ru][a(nk)](i[bf]), i[Ru][a(rk)](CG[ko], CG[ko], CG[Zf], CG[Zf]), i[pf] = i[Ru][s(ik)](), i[Ru][l(tk)](i[Ru][CG[EN]], i[pf]), i[Ru][a(ok)](i[Ru][CG[EN]], new Float32Array([
                        CG[ko],
                        CG[ko]
                    ]), i[Ru][s(uk)]), i[Zo] = i[c(af)][l(fk)](i[bf], l(vk)), i[Lo] = i[Ru][CG[ON]](i[c(Zv)], l(ek)), i[c(ne)] = i[Ru][CG[ON]](i[bf], l(ck)), i[c(cl)] = i[Ru][CG[ON]](i[bf], l(dk)), i[wf] = i[Ru][CG[ON]](i[bf], a(ak)), i[Af] = i[Ru][CG[ON]](i[bf], l(lk)), i[Ru][CG[XN]](i[Lo], i[Iu]), i[Ru][CG[XN]](i[Ho], i[Nb]), i[Ru][CG[XN]](i[Mf], i[mb]), i[Ru][CG[XN]](i[wf], i[Su]), i[Ru][CG[XN]](i[Af], i[hf]), i[Ru][s(sk)](i[c(uf)]), i[Ru][a(hk)](i[Zo], CG[Df], i[Ru][a(yk)], !1, CG[ko], CG[ko]), i[Ru][s(Nk)](CG[ko], CG[ko], CG[e(Yl)], CG[Zf]), i[Ru][CG[zv]](i[e(af)][a(mk)]), i[Ru][l(bk)](i[Ru][a(pk)], CG[ko], CG[Zf]), i[Ff] = new Uint8Array(CG[Xv]), i[Ru][s(Mk)](CG[ko], CG[ko], CG[Zf], CG[Zf], i[Ru][l(wk)], i[Ru][l(Ak)], i[Ff]), i[c(Pl)] = i[Ff][CG[ko]] / CG[Xf], i[wo][CG[jN]] = Math[CG[uv]](i[Ef] * CG[Xf]), i[c(af)][s(Fk)](i[c(bX)]), i[c(af)][CG[gN]](i[Nf]), i[c(af)][CG[gN]](i[mf]), i[Ru][a(Ek)](i[bf]);
                } catch (n) {
                    return i[wo][CG[yN]] = !0, -CG[Zf];
                }
                return i[wo][CG[yN]] || !i[wo][CG[NN]] ? -CG[Zf] : i[wo][CG[jN]];
            })[so](void 0, n, i[Ru]))
        };
    }, CG[Xk] = function(n) {
        var r = [];
        var i = [];
        if (i[wo] = {
            jf: -CG[Zf],
            Bf: -CG[Zf],
            Kf: -CG[Zf],
            Uf: -CG[Zf],
            Vf: PG[gm]
        }, i[Au] = CG[Sb](n), !i[Au]) return i[wo];
        i[Ru] = i[Au][CG[Zh]](CG[Wo][CG[bf]](PG[Wf], CG[Ne])[CG[bf]](PG[kf], CG[Ne])[CG[bf]](PG[_f], CG[Ne])[CG[bf]](PG[c(Tj)])), i[yb] = CG[ko], i[Du] = CG[ko], i[Iu] = CG[ko], i[Nb] = CG[ko], i[mb] = CG[ko];
        for(; i[mb] < i[Ru][CG[Kf]]; i[mb]++)i[Su] = i[Ru][i[mb]][s(f(50386, 50410))], i[Su] === PG[Wf] ? i[yb]++ : i[Su] === PG[kf] ? i[Du]++ : i[c(ef)] === PG[_f] ? i[Iu]++ : i[Su] === PG[Jo] && i[Nb]++;
        return i[wo][CG[TN]] = i[yb], i[wo][CG[ZN]] = i[Du], i[wo][CG[LN]] = i[Iu], i[wo][CG[HN]] = i[Nb], i[wo][CG[kN]] = (r[wo] = i[yb][CG[Fu]]() + i[e(vf)][CG[Fu]]() + i[Iu][CG[Fu]]() + i[Nb][CG[Fu]](), (function(n, r) {
            var i = [];
            i[wo] = n[CG[Kf]] & CG[yv], i[Au] = n[CG[Kf]] - i[wo], i[Ru] = r, i[yb] = d(Vj), i[Du] = d(Cj), i[Iu] = CG[ko], i[Nb] = CG[ko];
            for(; i[Iu] < i[Au];)i[Nb] = n[CG[pv]](i[Iu]) & CG[Xf] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[wv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[bv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[Ev], ++i[Iu], i[Nb] = (i[Nb] & CG[ga]) * i[yb] + (((i[Nb] >>> CG[bv]) * i[yb] & CG[ga]) << CG[bv]) & CG[ul], i[Nb] = i[Nb] << CG[Mv] | i[Nb] >>> CG[fl], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb], i[Ru] = i[Ru] << CG[ke] | i[Ru] >>> CG[el], i[mb] = (i[c(af)] & CG[ga]) * CG[re] + (((i[Ru] >>> CG[bv]) * CG[re] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] = (i[mb] & CG[ga]) + d(Pj) + (((i[mb] >>> CG[bv]) + d(c(Qj)) & CG[ga]) << CG[bv]);
            switch(i[Nb] = CG[ko], i[wo]){
                case CG[yv]:
                    i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Df]) & CG[Xf]) << CG[bv];
                case CG[Df]:
                    i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Zf]) & CG[Xf]) << CG[wv];
                case CG[Zf]:
                    i[Nb] ^= n[CG[pv]](i[Iu]) & CG[Xf], i[Nb] = (i[Nb] & CG[ga]) * i[yb] + (((i[c(Tf)] >>> CG[bv]) * i[yb] & CG[e(Ej)]) << CG[bv]) & CG[ul], i[Nb] = i[Nb] << CG[Mv] | i[Nb] >>> CG[fl], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb];
            }
            return i[Ru] ^= n[CG[Kf]], i[Ru] ^= i[Ru] >>> CG[e(rg)], i[Ru] = (i[Ru] & CG[ga]) * CG[dl] + (((i[Ru] >>> CG[bv]) * CG[dl] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[c(af)] >>> CG[ke], i[c(af)] = (i[Ru] & CG[ga]) * CG[al] + (((i[Ru] >>> CG[bv]) * CG[al] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] >>> CG[ko];
        })[so](void 0, r[wo], void 0))[CG[Fu]](CG[bv]), i[wo];
    }, CG[jk] = function(n) {
        var r = [];
        return r[wo] = n[CG[aN]][CG[Qf]](n), r[c(df)] = {
            Wf: r[wo][CG[Kf]],
            Xf: CG[1488](r[wo][CG[jf]](CG[xo]))[CG[Fu]](CG[bv])
        }, r[Au];
    }, PG[gk] = CG[Zs], PG[c(Tk)] = CG[ko], PG[c(Zk)] = CG[Zf], PG[c(e(t(f(50410, 50419), Tr)))] = CG[Df], PG[Lk] = CG[yv], PG[Hk] = CG[Xv], PG[kk] = {}, PG[kk][PG[Jk]] = {}, PG[kk][PG[Wk]] = {}, PG[kk][PG[_k]] = {}, PG[kk][PG[Lk]] = {}, PG[kk][PG[Hk]] = {}, PG[c(t(f(50419, 50429), Tr))] = {}, PG[Gk] = CG[OZ](PG[gk]), CG[xk] = function(n, r, i, o) {
        var u = [];
        PG[Rk] = o, u[wo] = function() {
            var o = [];
            PG[Gk][CG[ps]] = function() {
                CG[e(t(f(50429, 50439), Tr))](n), r();
            }, PG[Gk][CG[Ms]] = i, o[wo] = CG[Gj](), o[Au] = CG[AZ](n), CG[ZZ](PG[Gk], function(n, r, i) {
                CG[_b](function() {
                    CG[Uk](n, r), i();
                });
            }, [
                n,
                o[wo]
            ]), CG[ZZ](PG[Gk], function(n, r, i) {
                CG[_b](function() {
                    CG[Sk](n, r), i();
                });
            }, [
                n,
                o[Au]
            ]), CG[ZZ](PG[Gk], function(n, r, i, o) {
                CG[_b](function() {
                    CG[e(t(f(50439, 50449), Tr))](n, r, i), o();
                });
            }, [
                n,
                o[wo],
                o[Au]
            ]), CG[_b](function() {
                CG[Ik](n);
            });
        }, (function(n, r) {
            n[CG[Es]] || (n[CG[Es]] = !0, r());
        })[so](void 0, PG[Gk], u[wo]);
    }, CG[Bk] = function(n, r, i, t) {
        return PG[Rk] && PG[Rk](n, r, i, t), i;
    }, CG[Dk] = function(n, r, i, t) {
        var o = [];
        o[wo] = t, CG[Ob](o[wo]) && o[e(xu)] !== PG[Eu] && (PG[kk][n][r] = CG[kT](r, i, t, [
            PG[Xe][CG[e(JO)]] >>> CG[ko]
        ])), i != PG[ph] && (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, n, r, t, void 0);
    }, CG[qk] = function(n, r, i, t) {
        i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, n, r, i, void 0);
    }, CG[$k] = function(n) {
        var i = function(n, r) {
            var i = [];
            return CG[QM](n, (i[wo] = CG[qM](r, PG[c(SM)], CG[ga]), (function(n, r) {
                var i = [];
                i[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * r) - CG[Zf], n), i[Au] = PG[$o], i[Ru] = r * CG[Df];
                for(; i[wo] > CG[ko];)i[Au] = CG[$M](i[wo]) + i[Au], i[wo] = i[wo] >>> CG[wv];
                if (i[Ru]) for(; i[Au][CG[Kf]] < i[Ru];)i[Au] = CG[QM](CG[Io], i[Au]);
                return i[Au];
            })[so](void 0, i[wo], CG[Df])));
        };
        var t = PG[$o];
        var r = [];
        r[wo] = t, r[Au] = CG[ko], r[Ru] = CG[ko], r[yb] = n;
        for(; r[Ru] < r[c(Nv)][CG[Kf]]; r[Ru]++)r[Du] = r[c(e(Aj))][r[Ru]], r[wo] = i(r[c(xu)], r[Du], r[Au]), r[c(df)]++;
        return r[wo];
    }, CG[Kk] = function(n) {
        var i = function(n, r) {
            return CG[QM](n, (function(n, r) {
                var i = [];
                return i[c(xu)] = (CG[Zf] << r * CG[wv] - CG[Zf]) - CG[Zf], i[Au] = CG[Zf] << r * CG[wv] - CG[Zf], i[Ru] = CG[qM](n, -i[wo], i[wo]), CG[nw]((n < PG[c(SM)] ? i[Au] : PG[xv]) | CG[OM](i[Ru]), r);
            })[so](void 0, r, CG[Df]));
        };
        var t = PG[$o];
        var r = [];
        r[wo] = t, r[Au] = CG[ko], r[Ru] = CG[ko], r[yb] = n;
        for(; r[Ru] < r[c(Nv)][CG[Kf]]; r[Ru]++)r[Du] = r[c(Nv)][r[Ru]], r[wo] = i(r[c(xu)], r[Du], r[Au]), r[c(df)]++;
        return r[wo];
    }, CG[Vk] = function(n, r, i) {
        var t = [];
        var o = [];
        i && i[CG[Kf]] && (o[wo] = (t[Au] = i[CG[id]]()[CG[jf]](PG[$o]), (function(n, r) {
            var i = [];
            i[wo] = n[CG[Kf]] & CG[e(bl)], i[Au] = n[CG[Kf]] - i[wo], i[Ru] = r, i[yb] = d(Vj), i[Du] = d(Cj), i[Iu] = CG[ko], i[Nb] = CG[ko];
            for(; i[Iu] < i[Au];)i[Nb] = n[CG[pv]](i[Iu]) & CG[Xf] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[wv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[bv] | (n[CG[pv]](++i[Iu]) & CG[Xf]) << CG[Ev], ++i[Iu], i[Nb] = (i[Nb] & CG[ga]) * i[yb] + (((i[Nb] >>> CG[bv]) * i[yb] & CG[ga]) << CG[bv]) & CG[ul], i[Nb] = i[Nb] << CG[Mv] | i[Nb] >>> CG[e(Ag)], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb], i[Ru] = i[Ru] << CG[ke] | i[Ru] >>> CG[el], i[mb] = (i[c(af)] & CG[ga]) * CG[re] + (((i[Ru] >>> CG[bv]) * CG[re] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] = (i[mb] & CG[ga]) + d(Pj) + (((i[mb] >>> CG[bv]) + d(c(Qj)) & CG[ga]) << CG[bv]);
            switch(i[Nb] = CG[ko], i[wo]){
                case CG[yv]:
                    i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Df]) & CG[Xf]) << CG[bv];
                case CG[Df]:
                    i[Nb] ^= (n[CG[pv]](i[Iu] + CG[Zf]) & CG[e(fw)]) << CG[wv];
                case CG[Zf]:
                    i[Nb] ^= n[CG[pv]](i[Iu]) & CG[Xf], i[Nb] = (i[Nb] & CG[ga]) * i[yb] + (((i[c(Tf)] >>> CG[bv]) * i[yb] & CG[ga]) << CG[bv]) & CG[ul], i[e(Tf)] = i[Nb] << CG[Mv] | i[Nb] >>> CG[fl], i[Nb] = (i[Nb] & CG[ga]) * i[Du] + (((i[Nb] >>> CG[bv]) * i[Du] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Nb];
            }
            return i[Ru] ^= n[CG[Kf]], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] = (i[Ru] & CG[ga]) * CG[dl] + (((i[Ru] >>> CG[bv]) * CG[dl] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[c(af)] >>> CG[ke], i[c(af)] = (i[Ru] & CG[ga]) * CG[al] + (((i[Ru] >>> CG[bv]) * CG[al] & CG[ga]) << CG[bv]) & CG[ul], i[Ru] ^= i[Ru] >>> CG[bv], i[Ru] >>> CG[ko];
        })[so](void e(xu), t[Au], void 0)), o[Au] = CG[QM](CG[$M](i[CG[Kf]]), CG[nw](o[wo], CG[Xv])), o[Ru] = CG[kT](r, PG[ph], o[Au]), PG[kk][n][r] = o[Ru]), i && (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, n, r, i, o[wo]);
    }, CG[Ck] = function(n) {
        var r = [];
        r[wo] = CG[sZ](), r[Au] = CG[Bp](r[wo], function(n) {
            var r = [];
            return r[wo] = CG[qM](n, PG[xv], CG[Mv]), (r[wo] & CG[Mv])[CG[Fu]](CG[bv]);
        })[CG[e(is)]](PG[c(JO)]), r[Ru] = CG[kT](n, PG[ph], r[e(df)]), PG[kk][PG[c(Zk)]][n] = r[c(af)], (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Wk], n, r[wo], r[Au]);
    }, CG[t(f(50449, 50453), Tr)] = function(n, r, i) {
        var t = [];
        t[wo] = i, CG[Ob](t[wo]) && t[wo] !== PG[Eu] && (PG[kk][n][r] = i > Pk ? CG[kT](r, PG[mh], CG[wM]()[PG[Vv]](i)) : CG[kT](r, PG[bh], i), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, n, r, i, void 0));
    }, CG[t(f(50453, 50457), Tr)] = function(n, r, i, t) {
        var o = [];
        var u = [];
        (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, n, r, i, void 0), o[e(xu)] = i, CG[Ob](o[wo]) && o[wo] !== PG[Eu] && (u[wo] = CG[_p](t, i), PG[kk][n][r] = u[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
            PG[Xe][CG[$o]] >>> CG[ko]
        ]) : CG[kT](r, PG[c(Qk)], u[wo]));
    }, CG[Yk] = function(n$jscomp$0, r$jscomp$0) {
        var i = [];
        if (i[wo] = n$jscomp$0 & CG[zl], i[Au] = r$jscomp$0 & CG[ga], i[wo] === i[Au]) {
            var n = i[c(xu)] | d(t(f(50457, 50468), Tr));
            var r = CG[Df];
            var o = [];
            o[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * r) - CG[Zf], n), o[Au] = PG[$o], o[Ru] = r * CG[Df];
            for(; o[wo] > CG[ko];)o[Au] = CG[$M](o[wo]) + o[Au], o[e(xu)] = o[wo] >>> CG[wv];
            if (o[Ru]) for(; o[Au][CG[Kf]] < o[Ru];)o[Au] = CG[QM](CG[Io], o[Au]);
            return o[Au];
        }
        return CG[QM]((function(n, r) {
            var i = [];
            i[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * r) - CG[Zf], n), i[Au] = PG[$o], i[Ru] = r * CG[Df];
            for(; i[wo] > CG[ko];)i[Au] = CG[$M](i[wo]) + i[Au], i[wo] = i[wo] >>> CG[wv];
            if (i[Ru]) for(; i[Au][CG[Kf]] < i[e(af)];)i[Au] = CG[QM](CG[Io], i[Au]);
            return i[Au];
        })[so](void 0, i[wo], CG[Df]), (function(n, r) {
            var i = [];
            i[wo] = CG[gM](CG[XM](CG[Df], CG[e(DX)] * r) - CG[Zf], n), i[Au] = PG[$o], i[Ru] = r * CG[Df];
            for(; i[wo] > CG[ko];)i[Au] = CG[$M](i[wo]) + i[Au], i[e(xu)] = i[wo] >>> CG[wv];
            if (i[Ru]) for(; i[Au][CG[Kf]] < i[Ru];)i[Au] = CG[QM](CG[Io], i[Au]);
            return i[Au];
        })[so](void 0, i[Au], CG[Df]));
    }, CG[t(f(50468, 50472), Tr)] = function(n, r) {
        var i = [];
        var t = [];
        t[c(xu)] = CG[Kb](n), t[Au] = CG[Qb](n), t[Ru] = CG[Cb](n), t[yb] = CG[np](n), t[Du] = CG[Yk](t[c(xu)], t[Au]), t[Iu] = CG[Yk](t[Ru], t[yb]), i[wo] = PG[c(nJ)], i[Au] = CG[QM](t[Du], t[c(of)]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, i[wo], r, PG[ph], i[Au]), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[_k], r, [
            t[wo],
            t[Au],
            t[Ru],
            t[yb]
        ], void 0);
    }, CG[t(f(50472, 50476), Tr)] = function(n, r) {
        var i = [];
        var t = [];
        t[wo] = CG[Ib](n), i[wo] = CG[Kk]([
            t[wo][CG[eN]],
            t[wo][CG[cN]]
        ]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[_k], r, PG[ph], i[wo]), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[_k], r, [
            t[wo][CG[eN]],
            t[wo][CG[cN]]
        ], void 0);
    }, CG[rJ] = function(n, r) {
        var i = [];
        var t = [];
        t[c(xu)] = CG[jT](function() {
            return {
                Vv: PG[xv],
                Gv: PG[xv]
            };
        }), t[wo] && (i[Au] = CG[Kk]([
            t[wo][CG[JN]],
            t[wo][CG[WN]]
        ]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[_k], r, PG[ph], i[Au]), (function(n, r, i, t) {
            return PG[e(iJ)] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[_k], r, [
            t[wo][CG[JN]],
            t[wo][CG[WN]]
        ], void 0));
    }, CG[t(f(50476, 50480), Tr)] = function(n, r) {
        var i = [];
        var t = [];
        t[c(xu)] = CG[_A](n), t[Au] = CG[xA](n), t[c(af)] = CG[GA](n), t[c(Nv)] = CG[RA](n), t[Du] = CG[Yk](t[c(xu)], t[Au]), t[c(of)] = CG[Yk](t[Ru], t[yb]), i[wo] = CG[QM](t[Du], t[c(of)]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], r, PG[ph], i[wo]), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Jk], r, [
            t[wo],
            t[yb],
            t[Ru],
            t[yb]
        ], void 0);
    }, CG[tJ] = function(n) {
        var i = CG[AM](n * CG[kv]);
        var t = CG[gf];
        var r = [];
        r[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * t) - CG[Zf], i), r[Au] = PG[$o], r[Ru] = t * CG[Df];
        for(; r[wo] > CG[ko];)r[Au] = CG[$M](r[e(xu)]) + r[Au], r[wo] = r[wo] >>> CG[wv];
        if (r[Ru]) for(; r[Au][CG[Kf]] < r[Ru];)r[Au] = CG[QM](CG[Io], r[Au]);
        return r[Au];
    }, CG[oJ] = function(n) {
        var r = [];
        var i = [];
        return i[wo] = CG[e(uJ)](n[CG[Kf]]), r[wo] = function(n) {
            i[wo] += CG[tJ](n);
        }, (function(n, r) {
            var i = [];
            i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
        })[so](void 0, n, r[wo]), i[wo];
    }, CG[fJ] = function(n, r) {
        var i = [];
        var t = [];
        t[wo] = CG[Qb](n) - CG[Kb](n), t[Au] = CG[np](n) - CG[Cb](n), i[wo] = CG[Kk]([
            t[wo],
            t[Au]
        ]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Wk], r, PG[ph], i[wo]), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Wk], r, [
            t[wo],
            t[Au]
        ], void 0);
    }, CG[t(f(50480, 50484), Tr)] = function(n, i) {
        var t = [];
        t[wo] = CG[sT](i), t[Au] = r(CG[Wo][CG[bf]](CG[Tb](t[wo][a(vJ)]))[CG[bf]](CG[Tb](t[wo][l(eJ)])), CG[Df]), t[Ru] = CG[$M]((t[c(xu)][a(cJ)] & CG[Vv]) << CG[Df] | t[Au]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], n, PG[ph], t[Ru]), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Jk], n, t[Au], void 0);
    }, CG[t(f(50484, 50488), Tr)] = function(n) {
        var r = [];
        r[wo] = CG[mT](), r[Au] = CG[bT](), r[Ru] = CG[QM](CG[$M](r[wo] / CG[Mv]), CG[$M](r[Au] / CG[Mv])), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[e(Tk)], n, PG[ph], r[Ru]), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Jk], n, [
            r[wo],
            r[Au]
        ], void 0);
    }, CG[t(f(50488, 50492), Tr)] = function(n, r) {
        var i = [];
        var t = [];
        r[CG[Kf]] && (t[wo] = [
            r[PG[gs]],
            r[PG[js]],
            r[PG[Xs]]
        ], i[wo] = CG[ng](t[wo]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], n, PG[ph], i[wo]), i[Au] = CG[dJ](t[wo]), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Jk], n, i[Au], void 0));
    }, CG[t(f(50492, 50496), Tr)] = function(n, i) {
        var t = [];
        i && i[CG[Kf]] && (t[wo] = CG[nw](r(CG[Bp](i, CG[aJ])[CG[jf]](PG[$o]), CG[Df]), CG[Df]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[e(Tk)], PG[Ph], PG[ph], t[wo]), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Jk], n, i, void 0));
    }, CG[t(f(50496, 50500), Tr)] = function(n, r) {
        var i = [];
        var o = [];
        o[wo] = [
            CG[LT](),
            CG[eF](n),
            CG[wF](n),
            CG[vF](n),
            CG[oT](n),
            CG[pF](n),
            CG[uF](n),
            CG[tF](n),
            CG[iF](n),
            CG[ig](n),
            CG[rF](n),
            CG[e(t(f(50500, 50509), Tr))](n)
        ], i[wo] = CG[ng](o[wo]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], r, PG[ph], i[wo]), i[Au] = CG[dJ](o[wo]), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Jk], r, i[Au], void 0);
    }, CG[lJ] = function(n, r) {
        var i = [];
        var t = [];
        t[wo] = [
            CG[sJ](n),
            CG[tT](n),
            CG[fT](n),
            CG[vT](n),
            CG[cT](n),
            CG[eT](n),
            CG[dT](n),
            CG[aT](n)
        ], i[wo] = CG[ng](t[c(xu)]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[e(hJ)]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], r, PG[ph], i[wo]), i[Au] = CG[dJ](t[wo]), (function(n, r, i, t) {
            return PG[e(iJ)] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Jk], r, i[Au], void 0);
    }, CG[yJ] = function(n, r) {
        var i = [];
        var t = [];
        t[wo] = CG[cZ](n), (function() {
            PG[Tu] = !!CG[zT](), PG[Zu] = !!CG[qT]();
        })[so](void 0, void 0), t[Au] = [
            CG[jT](function() {
                return CG[1589](n, PG[sv], !1);
            }),
            !PG[Zu] && !CG[dE](PG[gd]) && CG[jT](function() {
                return CG[LH](n);
            }),
            CG[bZ](n),
            CG[pZ](n),
            t[wo][a(f(50509, 50517))],
            t[c(xu)][a(f(50517, 50525))],
            t[wo][l(f(50525, 50533))],
            CG[lT](n),
            CG[rZ](n),
            CG[jT](function() {
                return CG[1589](n, PG[fv], !1);
            }),
            CG[oZ](n),
            CG[uZ](n),
            CG[vZ](n),
            CG[jT](function() {
                return CG[QT](n, PG[Uo]);
            }),
            CG[oT](n) == PG[Rv]
        ], i[wo] = CG[ng](t[Au]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Wk], r, PG[ph], i[wo]), i[Au] = CG[dJ](t[Au]), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Wk], r, i[Au], void 0);
    }, PG[NJ] = CG[_N], PG[mJ] = a(f(50533, 50541)), PG[bJ] = a(f(50541, 50557)), PG[pJ] = a(f(50557, 50581)), PG[MJ] = a(f(50581, 50597)), PG[wJ] = s(f(50597, 50613)), PG[AJ] = CG[Wo][CG[e(Zv)]](PG[Gc], CG[Uo])[CG[bf]](PG[NJ], l(f(50613, 50621))), PG[t(f(50621, 50624), Tr)] = s(f(50624, 50636)), PG[FJ] = CG[Wo][CG[bf]](PG[Gc], CG[Uo])[CG[bf]](PG[NJ], s(f(50636, 50644))), PG[EJ] = CG[Wo][CG[bf]](PG[Gc], CG[Uo])[CG[bf]](PG[bJ], CG[GN]), PG[OJ] = CG[Wo][CG[bf]](PG[Gc], CG[Uo])[CG[bf]](PG[mJ], s(f(50644, 50652))), PG[XJ] = CG[Wo][CG[bf]](PG[Gc], CG[Uo])[CG[bf]](PG[NJ], s(f(50652, 50660))), PG[jJ] = a(f(50660, 50672)), PG[gJ] = a(f(50672, 50684)), PG[TJ] = a(f(50684, 50696)), PG[ZJ] = a(f(50696, 50708)), PG[e(t(f(50708, 50718), Tr))] = l(f(50718, 50730)), PG[LJ] = s(f(50730, 50742)), PG[HJ] = s(f(50742, 50754)), PG[kJ] = l(f(50754, 50766)), PG[JJ] = a(f(50766, 50778)), PG[WJ] = s(f(50778, 50790)), PG[_J] = a(f(50790, 50802)), PG[GJ] = a(f(50802, 50814)), PG[xJ] = s(f(50814, 50826)), PG[RJ] = a(f(50826, 50846)), PG[c(t(f(50846, 50856), Tr))] = l(f(50856, 50868)), PG[UJ] = a(f(50868, 50892)), PG[c(t(f(50892, 50903), Tr))] = a(f(50903, 50927)), PG[SJ] = s(f(50927, 50947)), PG[IJ] = s(f(50947, 50979)), PG[BJ] = s(f(50979, 51011)), PG[DJ] = l(f(51011, 51035)), CG[t(f(51035, 51039), Tr)] = function(n) {
        var r = [];
        r[wo] = n[s(qJ)], (function(n, r, i, t) {
            i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
        })[so](void 0, PG[Lk], PG[lN], r[wo], !0), r[Au] = n[s(zJ)], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Lk], PG[pu], PG[bh], r[Au]), r[Ru] = n[a($J)], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Lk], PG[sN], PG[mh], r[Ru]), r[yb] = n[a(KJ)], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Lk], PG[hN], PG[mh], r[yb]);
    }, CG[VJ] = function(n) {
        var r = [];
        r[wo] = PG[c(CJ)], r[Au] = n[s(f(51039, 51047))], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, r[wo], PG[PN], PG[e(HT)], r[Au]), r[e(af)] = n[s(f(51047, 51055))], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Hk], PG[QN], PG[mh], r[Ru]), r[yb] = n[a(f(51055, 51063))], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[e(hJ)]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Hk], PG[YN], PG[mh], r[yb]), r[Du] = PG[c(e(t(f(51063, 51072), Tr)))], r[Iu] = n[s(f(51072, 51080))], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, r[Du], PG[BN], PG[Nh], r[Iu]), r[Nb] = PG[c(RT)], r[mb] = n[l(f(51080, 51088))], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[e(PJ)](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Hk], r[Nb], PG[mh], r[mb]), r[Su] = PG[c(CJ)], r[hf] = n[s(f(51088, 51096))], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, r[Su], PG[qN], PG[mh], r[hf]);
    }, CG[QJ] = function(n) {
        var r = [];
        r[wo] = PG[c(HT)], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Hk], PG[zN], r[wo], n[CG[TN]]), r[Au] = PG[c(t(f(51096, 51106), Tr))], r[Ru] = PG[c(HT)], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Hk], r[Au], r[Ru], n[CG[LN]]), r[yb] = PG[c(t(f(51106, 51115), Tr))], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Hk], r[yb], PG[mh], n[CG[ZN]]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Hk], PG[VN], PG[mh], n[CG[HN]]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Hk], PG[CN], PG[Nh], n[CG[kN]]);
    }, CG[YJ] = function(n) {
        var r = [];
        r[wo] = n[a(f(51115, 51123))], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Lk], PG[pN], PG[mh], r[wo]), r[Au] = n[l(f(51123, 51131))], (function(n, r, i, t) {
            CG[jb](t) && (PG[e(zk)][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Lk], PG[MN], PG[Nh], r[Au]);
    }, CG[nW] = function(n) {
        return n[CG[iv]](CG[Df]);
    }, CG[rW] = function(n) {
        return CG[QM](n[CG[iv]](CG[Df]), CG[su], n[CG[iv]](CG[Df], CG[Xv]));
    }, PG[iW] = [
        CG[Wo][CG[bf]](PG[RJ], CG[Nu])[CG[bf]](PG[UJ]),
        CG[Wo][CG[bf]](PG[RJ], CG[Nu])[CG[bf]](PG[t(f(51131, 51134), Tr)]),
        CG[Wo][CG[bf]](PG[RJ], CG[Nu])[CG[bf]](PG[SJ]),
        CG[Wo][CG[bf]](PG[RJ], CG[Nu])[CG[bf]](PG[IJ]),
        CG[Wo][CG[bf]](PG[RJ], CG[Nu])[CG[bf]](PG[BJ]),
        CG[Wo][CG[bf]](PG[t(f(51134, 51137), Tr)], CG[Nu])[CG[bf]](PG[DJ])
    ], PG[tW] = [
        CG[Wo][CG[bf]](CG[rW](PG[jJ]), CG[xo])[CG[bf]](CG[nW](PG[jJ])),
        CG[Wo][CG[bf]](CG[rW](PG[jJ])),
        CG[Wo][CG[bf]](CG[rW](PG[ZJ]), CG[xo])[CG[bf]](CG[nW](PG[ZJ]), CG[xo])[CG[bf]](CG[rW](PG[jJ]), CG[xo])[CG[bf]](CG[nW](PG[jJ])),
        CG[Wo][CG[bf]](CG[rW](PG[gJ]), CG[xo])[CG[bf]](CG[nW](PG[c(t(f(51137, 51147), Tr))])),
        CG[Wo][CG[bf]](CG[rW](PG[c(-1028712954)]), CG[xo])[CG[bf]](CG[nW](PG[kJ]))
    ], PG[oW] = {
        Jf: [
            a(f(51147, 51195)),
            l(f(51195, 51443)),
            l(f(51443, 51695))
        ],
        Zf: [
            a(f(51695, 51743)),
            l(f(51743, 51787)),
            a(f(51787, 51839)),
            s(f(51839, 51887))
        ],
        $f: [
            s(f(51887, 51903)),
            a(f(51903, 51919)),
            s(f(51919, 51947)),
            s(f(51947, 51967)),
            s(f(51967, 51983)),
            l(f(51983, 52011)),
            a(f(52011, 52035)),
            l(f(52035, 52055)),
            s(f(52055, 52075))
        ],
        Yf: [
            a(f(52075, 52091)),
            s(f(52091, 52099)),
            a(f(52099, 52115)),
            a(f(52115, 52139)),
            l(f(52139, 52155)),
            CG[_N]
        ]
    }, PG[e(t(f(52155, 52164), Tr))] = l(f(52164, 52204)), PG[uW] = [
        s(f(52204, 52228)),
        a(f(52228, 52252))
    ], PG[fW] = s(f(52252, 52288)), CG[Uk] = function(n, r) {
        var i = [];
        var o = [];
        (function(n) {
            PG[c(Dj)][CG[Ca]] = CG[AM](CG[Bw](n));
        })[so](void 0, n), o[wo] = r[CG[Xu]] ? [
            function() {
                var i = n;
                var t = r[CG[Xu]];
                if (CG[Db](i)[CG[zy]] == CG[$y] && i[CG[Ky]]) return new i[CG[Vy]](t);
            },
            {
                Zv: PG[Lm],
                Xv: !1
            }
        ] : [
            function() {
                var i = n;
                var o = PG[c(t(f(52288, 52298), Tr))];
                var r = [];
                if (CG[Db](i)[CG[zy]] == CG[$y] && i[CG[Ky]]) return r[wo] = new i[CG[Py]]([
                    o
                ], {
                    type: CG[Qy][CG[bf]](PG[rH])
                }), r[Au] = i[CG[Yy]][CG[nN]](r[c(xu)]), new i[CG[Vy]](r[Au]);
            },
            {
                Zv: PG[Hm],
                Xv: !1
            }
        ], o[Au] = r[CG[Ba]] ? [
            function() {
                var i = n;
                var t = r[CG[Ba]];
                if (CG[Db](i)[CG[zy]] == CG[$y] && i[CG[Ky]] && i[CG[Cy]]) return new i[CG[Cy]](t);
            },
            {
                Zv: PG[Lm],
                Xv: !0
            }
        ] : [
            function() {
                var i = n;
                var t = PG[Xm];
                var r = [];
                if (CG[Db](i)[CG[zy]] == CG[$y] && i[CG[Ky]] && i[CG[Cy]]) return r[wo] = new i[CG[Py]]([
                    t
                ], {
                    type: CG[Qy][CG[bf]](PG[rH])
                }), r[Au] = i[CG[Yy]][CG[nN]](r[wo]), new i[CG[Cy]](r[c(df)]);
            },
            {
                Zv: PG[Hm],
                Xv: !0
            }
        ], CG[LZ](PG[c(e(t(f(52298, 52309), Tr)))], CG[YL], o[c(xu)], function(r) {
            var i = [];
            var o = [];
            r[CG[xN]] ? (o[Au] = r[CG[xN]], o[Ru] = o[Au][PG[Km]], o[c(af)] === PG[km] ? (o[yb] = [
                CG[VL](o[Au][PG[ib]], o[Au][PG[c(eW)]], PG[cW]),
                CG[KL](o[Au][PG[rb]], CG[mF](n)),
                CG[$L](o[Au][PG[nb]], CG[JA](n)),
                CG[CL](o[Au][PG[Qm]], CG[SA](n)),
                CG[zL](o[Au][PG[Ym]], CG[UA](n)),
                CG[qL](o[Au][PG[Pm]], CG[e(t(f(52317, 52328), Tr))](n)),
                CG[DL](o[c(df)][PG[Cm]], CG[kA](n)),
                CG[BL](o[Au][PG[c(eW)]]),
                CG[IL](o[Au][PG[Cm]])
            ], i[Du] = CG[ng](o[yb]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Wk], PG[cy], PG[ph], i[Du]), i[Iu] = CG[dJ](o[yb]), (function(n, r, i, t) {
                return PG[Rk] && PG[Rk](n, r, i, t), i;
            })[so](void 0, PG[Wk], PG[cy], i[Iu], void 0)) : o[Ru] === PG[Wm] && (o[Du] = o[Au][PG[ob]], o[Iu] = [
                PG[Xc],
                PG[e(gA)],
                PG[Tc],
                PG[jc],
                PG[Zc],
                PG[e(Oj)]
            ], o[Nb] = !!o[c(vf)] && CG[Rp](o[Iu], function(n) {
                return o[Du][n] === PG[$o];
            })[CG[Kf]] === o[Iu][CG[Kf]], (function(n, r, i, t) {
                i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
            })[so](void 0, PG[Wk], PG[by], o[Nb], !0), o[Du] && (i[e(sf)] = o[Du][PG[c(t(f(52328, 52338), Tr))]], (function(n, r, i, t) {
                var o = [];
                CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                    CG[_w]() >>> CG[ko]
                ]) : CG[kT](r, PG[c(Qk)], o[wo]));
            })[so](void 0, PG[Wk], PG[My], i[To], [
                PG[NJ],
                PG[mJ]
            ]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Wk], PG[wy], PG[Nh], o[Du][PG[gc]]), i[yf] = PG[c(t(f(52338, 52348), Tr))], (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Wk], i[yf], PG[Nh], o[Du][PG[Yo]]), o[mb] = [
                o[c(vf)][PG[jc]] === CG[GN],
                o[Du][PG[jc]] === CG[hf],
                o[Du][PG[Zc]],
                o[Du][PG[nu]]
            ], i[Nf] = CG[ng](o[mb]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Wk], PG[py], PG[ph], i[Nf]), i[mf] = CG[dJ](o[mb]), (function(n, r, i, t) {
                return PG[Rk] && PG[Rk](n, r, i, t), i;
            })[so](void 0, PG[Wk], PG[py], i[mf], void 0), (function(n, r, i, t) {
                var o = [];
                CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                    CG[_w]() >>> CG[ko]
                ]) : CG[kT](r, PG[c(Qk)], o[wo]));
            })[so](void 0, PG[_k], PG[Ay], o[Du][PG[Be]], [
                PG[Ic],
                PG[_c],
                PG[xc],
                PG[e(t(f(52348, 52358), Tr))],
                PG[Rc],
                PG[Uc]
            ]), i[bf] = o[c(vf)][PG[Tc]], (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[_k], PG[Fy], PG[Nh], i[bf]), o[Su] = CG[tg](o[Du]), i[pf] = PG[c(t(f(52358, 52367), Tr))], (function(n, r, i, t) {
                var o = [];
                CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                    CG[_w]() >>> CG[ko]
                ]) : CG[kT](r, PG[c(Qk)], o[wo]));
            })[so](void 0, PG[_k], PG[Ey], o[Su], i[pf])))) : (o[wo] = CG[dJ]([
                r[a(f(52309, 52317))],
                r[CG[Dy]]
            ]), i[wo] = CG[ng](o[wo]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Wk], PG[yy], PG[e(vW)], i[wo]), (function(n, r, i, t) {
                return PG[Rk] && PG[Rk](n, r, i, t), i;
            })[so](void 0, PG[Wk], PG[yy], o[wo], void 0));
        }, {
            Qu: CG[Df]
        }), CG[eg]() === PG[Nu] && r[CG[Da]] && (o[c(af)] = CG[_e], CG[YL](function() {
            var i = n;
            var t = r[CG[Da]];
            if (CG[Db](i)[CG[zy]] == CG[$y] && i[CG[Ky]]) return new i[CG[Vy]](t);
        }, {
            Zv: o[Ru],
            Xv: !0
        }, function(n) {
            var r = [];
            var i = [];
            n[CG[xN]] ? (i[Au] = n[CG[xN]], i[Ru] = i[Au][PG[Km]], i[Ru] === PG[_m] && (i[yb] = i[Au][PG[QL]], r[yb] = i[yb], (function(n) {
                return CG[Ob](n) && n !== PG[Eu];
            })[so](void 0, r[yb]) && (i[wo] = (function(n) {
                return CG[wM]()[PG[c(e(t(f(52367, 52377), Tr)))]](n);
            })[so](void 0, i[yb])))) : n[CG[Dy]] && (i[wo] = o[Ru]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Wk], PG[my], PG[mh], i[wo]);
        })), CG[LZ](PG[Gk], CG[nH], o[Au], function(n) {
            var r = [];
            var i = [];
            i[wo] = n[CG[xN]], i[Ru] = i[wo], i[wo] && (i[Au] = i[wo][PG[Km]], i[Au] === PG[Jm] && ((function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Hk], PG[HN], PG[Nh], i[Ru][PG[ub]]), r[Ru] = CG[og](i[c(af)][PG[e(t(f(52377, 52388), Tr))]]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Hk], PG[kN], PG[Nh], r[Ru]), (function(n, r, i, t) {
                i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
            })[so](void 0, PG[Hk], PG[JN], i[Ru][PG[vb]], void 0), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Hk], PG[WN], PG[Nh], i[Ru][PG[eb]]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void e(xu), PG[Hk], PG[_N], PG[Nh], i[Ru][PG[cb]]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Hk], PG[GN], PG[Nh], i[Ru][PG[e(t(f(52388, 52398), Tr))]]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Hk], PG[xN], PG[Nh], i[Ru][PG[ab]]), r[yb] = PG[c(dW)], (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Hk], PG[RN], r[yb], i[Ru][PG[lb]]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Hk], PG[UN], PG[Nh], i[Ru][PG[sb]]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[e(Yl)]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Hk], PG[SN], PG[Nh], i[Ru][PG[hb]]), r[Du] = PG[c(t(f(52398, 52408), Tr))], (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Hk], r[Du], PG[Nh], i[Ru][PG[PL]])));
        }), CG[Gb]((i[wo] = function() {
            var r = [];
            return r[wo] = CG[Rb](n), r[wo][a(f(52408, 52428))] || r[wo][a(f(52428, 52436))] || r[wo][l(f(52436, 52444))] || r[wo][s(f(52444, 52452))];
        }, (function(n) {
            try {
                return n();
            } catch (n) {
                CG[XT](n);
            }
        })[so](void 0, i[wo])))[CG[ru]](function(r) {
            var i = [];
            r ? (function(n) {
                CG[qk](PG[Lk], PG[lN], n[s(qJ)], !0), CG[Dk](PG[Lk], PG[pu], PG[bh], n[s(zJ)]), CG[Dk](PG[Lk], PG[sN], PG[mh], n[a($J)]), CG[Dk](PG[Lk], PG[hN], PG[mh], n[a(KJ)]);
            })[so](void 0, r) : (i[wo] = CG[Rb](n)[CG[RN]], (function(n) {
                return typeof n === CG[zf];
            })[so](void 0, i[wo]) && CG[LZ](PG[Gk], function(n, r) {
                n[s(Ub)][CG[RN]]()[CG[Pc]](function(n) {
                    r(n);
                })[CG[Yc]](function() {
                    return r(null);
                });
            }, [
                n
            ], function(n) {
                n && (function(n) {
                    CG[qk](PG[Lk], PG[lN], n[s(qJ)], !0), CG[Dk](PG[Lk], PG[pu], PG[bh], n[s(zJ)]), CG[Dk](PG[Lk], PG[sN], PG[mh], n[a($J)]), CG[Dk](PG[Lk], PG[hN], PG[mh], n[a(KJ)]);
                })[so](void 0, n);
            }));
        }), CG[LZ](PG[Gk], CG[sL], [
            n
        ], function(n) {
            var r = [];
            r[wo] = PG[c(t(f(52452, 52462), Tr))], (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[e(vW)] && CG[Bk](n, r, t);
            })[so](void 0, PG[Lk], r[wo], PG[mh], n);
        }), CG[LZ](PG[Gk], CG[hL], [
            n
        ], function(n) {
            (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Lk], PG[vN], PG[mh], n);
        }), CG[LZ](PG[Gk], CG[OL], [
            n
        ], function(n) {
            var r = [];
            n && ((function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[e(PJ)](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[e(nJ)], PG[Dy], PG[Nh], n[CG[Fy]]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[_k], PG[qy], PG[mh], n[CG[Ey]]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[_k], PG[zy], PG[mh], n[CG[Oy]]), r[wo] = PG[c(_T)], (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[_k], r[wo], PG[mh], n[CG[Xy]]), (function(n, r, i, t) {
                var o = [];
                CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                    CG[_w]() >>> CG[ko]
                ]) : CG[kT](r, PG[c(Qk)], o[wo]));
            })[so](void 0, PG[_k], PG[Ky], n[CG[Ay]], PG[wu]));
        }), CG[LZ](PG[Gk], CG[AL], [
            n
        ], function(n) {
            var r = [];
            n && (r[wo] = PG[c(t(f(52462, 52472), Tr))], r[Au] = n[l(f(52472, 52480))], r[Ru] = PG[oW][s(f(52480, 52488))], (function(n, r, i, t) {
                var o = [];
                CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[e(PJ)](r, PG[Nh], i, [
                    CG[_w]() >>> CG[ko]
                ]) : CG[kT](r, PG[c(Qk)], o[wo]));
            })[so](void 0, PG[Lk], r[wo], r[Au], r[Ru]), r[yb] = n[l(f(52488, 52496))], r[Du] = PG[oW][a(f(52496, 52504))], (function(n, r, i, t) {
                var o = [];
                CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                    CG[_w]() >>> CG[ko]
                ]) : CG[kT](r, PG[c(Qk)], o[wo]));
            })[so](void 0, PG[Lk], PG[Cy], r[yb], r[Du]), r[Iu] = n[l(f(52504, 52512))], (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Lk], PG[Py], PG[mh], r[Iu]), r[Nb] = n[l(f(52512, 52520))], (function(n, r, i, t) {
                i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
            })[so](void 0, PG[Lk], PG[Qy], r[Nb], !0), r[mb] = PG[c(t(f(52520, 52531), Tr))], r[Su] = n[s(f(52531, 52539))], (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, r[mb], PG[Yy], PG[Nh], r[Su]), r[hf] = CG[tJ](n[CG[UN]]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Lk], PG[nN], PG[ph], r[hf]), (function(n, r, i, t) {
                return PG[Rk] && PG[Rk](n, r, i, t), i;
            })[so](void 0, PG[Lk], PG[nN], n[CG[UN]], void 0));
        }), CG[LZ](PG[Gk], CG[NT], [
            n
        ], function(n) {
            (function(n, r) {
                var i = [];
                r[CG[Kf]] && (i[wo] = [
                    r[PG[e(hT)]],
                    r[PG[js]],
                    r[PG[Xs]]
                ], CG[Dk](PG[Jk], n, PG[ph], CG[ng](i[wo])), CG[Bk](PG[e(Tk)], n, CG[dJ](i[wo])));
            })[so](void 0, PG[Wh], n);
        }), (function(n) {
            var r = [];
            return r[wo] = CG[tF](n), !(!r[wo] || !r[wo][CG[Cc]]);
        })[so](void 0, n) && CG[LZ](PG[Gk], CG[YT], [
            n
        ], function(n) {
            (function(n, r, i, t) {
                i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
            })[so](void 0, PG[Wk], PG[ey], n, void 0);
        }), CG[LZ](PG[e(t(f(52539, 52550), Tr))], CG[aH], [
            n
        ], function(n) {
            (function(n, r, i, t) {
                i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
            })[so](void 0, PG[Wk], PG[JT], n, !0);
        }), o[yb] = CG[DA](n), o[yb] && CG[LZ](PG[Gk], CG[tZ], [
            o[c(Nv)]
        ], function(n) {
            (function(n, r, i, t) {
                i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
            })[so](void 0, PG[Wk], PG[vy], n, !0);
        });
    }, CG[Sk] = function(n, i) {
        var o = [];
        var u = [];
        (function(n) {
            PG[Hl][CG[Qa]] = CG[AM](CG[Bw](n));
        })[so](void 0, n), o[wo] = function() {
            return CG[VJ](CG[Ok](n, !1));
        }, (function(n) {
            try {
                return n();
            } catch (n) {
                CG[XT](n);
            }
        })[so](void 0, o[wo]), o[Au] = function() {
            return CG[YJ](CG[jk](n));
        }, (function(n) {
            try {
                return n();
            } catch (n) {
                CG[XT](n);
            }
        })[so](void 0, o[Au]), o[Ru] = PG[c(Tk)], o[yb] = CG[ZA](n), o[Du] = [
            PG[pJ],
            PG[MJ],
            PG[wJ],
            PG[AJ],
            PG[c(t(f(52550, 52558), Tr))],
            PG[FJ],
            PG[EJ],
            PG[OJ],
            PG[XJ]
        ], (function(n, r, i, t) {
            var o = [];
            CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                CG[_w]() >>> CG[ko]
            ]) : CG[kT](r, PG[c(Qk)], o[wo]));
        })[so](void 0, o[Ru], PG[Mh], o[yb], o[Du]), o[Iu] = CG[LA](n), o[Nb] = [
            PG[Jc],
            PG[c(TA)]
        ], (function(n, r, i, t) {
            var o = [];
            CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                CG[_w]() >>> CG[ko]
            ]) : CG[kT](r, PG[c(Qk)], o[wo]));
        })[so](void 0, PG[Jk], PG[Ah], o[Iu], o[Nb]), o[mb] = CG[JA](n), o[Su] = [
            CG[rW](PG[jJ]),
            CG[rW](PG[gJ]),
            CG[rW](PG[TJ]),
            CG[rW](PG[ZJ]),
            CG[rW](PG[aW]),
            CG[rW](PG[LJ]),
            CG[rW](PG[HJ]),
            CG[oM](CG[rW](PG[jJ])),
            CG[oM](CG[rW](PG[aW])),
            CG[rW](PG[kJ]),
            CG[rW](PG[JJ]),
            CG[rW](PG[WJ]),
            CG[rW](PG[_J]),
            CG[rW](PG[GJ]),
            CG[rW](PG[xJ])
        ], (function(n, r, i, t) {
            var o = [];
            CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                CG[_w]() >>> CG[ko]
            ]) : CG[kT](r, PG[c(Qk)], o[wo]));
        })[so](void 0, PG[Jk], PG[Fh], o[mb], o[Su]), o[hf] = CG[SA](n), (function(n, r, i) {
            CG[jb](i) && (PG[kk][n][r] = i > Pk ? CG[kT](r, PG[mh], CG[AM](i)) : CG[kT](r, PG[bh], i), CG[Bk](n, r, i));
        })[so](void 0, PG[Jk], PG[Eh], o[hf]), (function(n, r) {
            var i = [];
            i[c(xu)] = CG[_A](n), i[Au] = CG[xA](n), i[c(af)] = CG[GA](n), i[c(Nv)] = CG[RA](n), i[Du] = CG[Yk](i[c(xu)], i[Au]), i[c(of)] = CG[Yk](i[Ru], i[yb]), CG[Dk](PG[Jk], r, PG[ph], CG[QM](i[Du], i[c(of)])), CG[Bk](PG[e(Tk)], r, [
                i[wo],
                i[yb],
                i[Ru],
                i[yb]
            ]);
        })[so](void 0, n, PG[Oh]), o[To] = CG[WA](n), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], PG[Xh], PG[e(HT)], o[To]), o[yf] = CG[UA](n), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], PG[jh], PG[mh], o[yf]), o[Nf] = CG[Yg](n), (function(n, r, i) {
            CG[jb](i) && (PG[kk][n][r] = i > Pk ? CG[kT](r, PG[mh], CG[AM](i)) : CG[kT](r, PG[bh], i), CG[Bk](n, r, i));
        })[so](void 0, PG[Jk], PG[gh], o[Nf]), (function(n) {
            var r = [];
            r[wo] = CG[mT](), r[Au] = CG[bT](), r[Ru] = CG[QM](CG[$M](r[wo] / CG[Mv]), CG[$M](r[Au] / CG[Mv])), CG[Dk](PG[Jk], n, PG[ph], r[Ru]), CG[Bk](PG[Jk], n, [
                r[wo],
                r[Au]
            ]);
        })[so](void 0, PG[Th]), o[mf] = PG[c(Tk)], o[bf] = CG[jT](function() {
            return CG[BA](n);
        }), (function(n, r, i) {
            var t = [];
            i && i[CG[Kf]] && (t[wo] = CG[1488](i[CG[id]]()[CG[jf]](PG[$o])), t[Au] = CG[QM](CG[$M](i[CG[Kf]]), CG[nw](t[wo], CG[Xv])), t[Ru] = CG[kT](r, PG[ph], t[e(df)]), PG[kk][n][r] = t[Ru]), i && CG[Bk](n, r, i, t[wo]);
        })[so](void 0, o[mf], PG[Zh], o[bf]), o[pf] = CG[jT](function() {
            return CG[$A](n);
        }), (function(n, r, i) {
            var t = [];
            i && i[CG[Kf]] && (t[wo] = CG[1488](i[CG[id]]()[CG[jf]](PG[$o])), t[Au] = CG[QM](CG[$M](i[CG[Kf]]), CG[nw](t[wo], CG[Xv])), t[Ru] = CG[kT](r, PG[ph], t[Au]), PG[kk][n][r] = t[Ru]), i && CG[Bk](n, r, i, t[wo]);
        })[so](void 0, PG[Jk], PG[Lh], o[pf]), (function(n, r) {
            var i = [];
            i[wo] = [
                CG[LT](),
                CG[eF](n),
                CG[wF](n),
                CG[vF](n),
                CG[oT](n),
                CG[e(t(f(52558, 52569), Tr))](n),
                CG[uF](n),
                CG[tF](n),
                CG[iF](n),
                CG[ig](n),
                CG[rF](n),
                CG[nF](n)
            ], CG[Dk](PG[Jk], r, PG[ph], CG[ng](i[wo])), CG[Bk](PG[Jk], r, CG[dJ](i[wo]));
        })[so](void 0, n, PG[Hh]), o[Zo] = PG[c(Tk)], o[Lo] = CG[kA](n), o[Ho] = d(t(f(52569, 52578), Tr)), (function(n, r, i, t) {
            CG[jb](i) && (CG[Dk](n, r, PG[ph], CG[vA](i, [
                r,
                CG[_w]() >>> CG[ko]
            ], t)), CG[Bk](n, r, i));
        })[so](void 0, o[Zo], PG[mL], o[Lo], o[Ho]), CG[Gb](CG[GZ](n))[CG[ru]](function(n) {
            var r = [];
            r[wo] = CG[ng](CG[nM](n)), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[_k], PG[Ty], PG[ph], r[wo]), (function(n, r, i, t) {
                return PG[Rk] && PG[Rk](n, r, i, t), i;
            })[so](void 0, PG[_k], PG[Ty], n, void 0);
        }), CG[Gb]((o[Mf] = function() {
            return CG[QZ](n);
        }, (function(n) {
            try {
                return n();
            } catch (n) {
                CG[XT](n);
            }
        })[so](void 0, o[Mf])))[CG[ru]](function(n) {
            var r = [];
            n && (r[wo] = n[a(f(52578, 52586))], (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[_k], PG[Zy], PG[mh], r[wo]), r[Au] = n[s(f(52586, 52594))], (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[_k], PG[528], PG[mh], r[Au]), r[Ru] = n[l(f(52594, 52602))], (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[_k], PG[Ly], PG[e(HT)], r[Ru]), r[e(Nv)] = n[a(f(52602, 52610))], (function(n, r, i, t) {
                CG[e($p)](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[e(hJ)]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[_k], PG[Hy], PG[mh], r[yb]));
        }), CG[Gb]((o[wf] = function() {
            return CG[nL](n);
        }, (function(n) {
            try {
                return n();
            } catch (n) {
                CG[XT](n);
            }
        })[so](void 0, o[wf])))[CG[ru]](function(n) {
            var r = [];
            n && CG[Gb]((r[wo] = n, [
                r[wo][l(rL)],
                r[wo][l(iL)],
                r[wo][a(tL)],
                r[wo][a(oL)],
                r[wo][a(uL)],
                r[wo][a(fL)],
                r[wo][s(vL)],
                r[wo][l(eL)],
                r[wo][a(cL)]
            ]))[CG[ru]](function(n) {
                var r = [];
                r[wo] = PG[c(vW)], r[Au] = CG[oJ](n), (function(n, r, i, t) {
                    CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                        CG[_w]() >>> CG[ko]
                    ])), i != PG[ph] && CG[Bk](n, r, t);
                })[so](void 0, PG[_k], PG[ky], r[wo], r[Au]), r[Ru] = PG[c(nJ)], r[yb] = CG[Bp](n, function(n) {
                    return CG[xM](n, CG[yv]);
                }), (function(n, r, i, t) {
                    return PG[Rk] && PG[Rk](n, r, i, t), i;
                })[so](void 0, r[Ru], PG[ky], r[e(Nv)], void 0);
            });
        }), o[Af] = CG[jT](function() {
            return CG[aL](n);
        }), (function(n, r, i, t) {
            i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
        })[so](void 0, PG[Lk], PG[uN], o[Af], void 0), o[Ff] = PG[c(t(f(52610, 52621), Tr))], o[Ef] = CG[jT](function() {
            return CG[lL](n);
        }), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Lk], o[Ff], PG[mh], o[e(Pl)]), CG[Gb]((o[Of] = function() {
            return CG[yL](n);
        }, (function(n) {
            try {
                return n();
            } catch (n) {
                CG[XT](n);
            }
        })[so](void 0, o[Of])))[CG[ru]](function(n) {
            (function(n, r, i, t) {
                i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
            })[so](void 0, PG[Lk], PG[fN], n, !0);
        }), CG[Gb]((o[ko] = function() {
            return CG[dL](n);
        }, (function(n) {
            try {
                return n();
            } catch (n) {
                CG[XT](n);
            }
        })[so](void 0, o[ko])))[CG[ru]](function(n) {
            var r = [];
            var i = [];
            n && (i[wo] = [
                n[CG[Cs]],
                n[CG[Ks]],
                n[CG[$s]],
                n[CG[zs]]
            ], r[wo] = CG[ng](i[wo]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[_k], PG[WT], PG[ph], r[wo]), (function(n, r, i, t) {
                return PG[Rk] && PG[Rk](n, r, i, t), i;
            })[so](void 0, PG[_k], PG[WT], i[wo], void 0), r[Au] = PG[oW][a(f(52621, 52629))], (function(n, r, i, t) {
                var o = [];
                CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[e(SM)] ? CG[kT](r, PG[Nh], i, [
                    CG[_w]() >>> CG[ko]
                ]) : CG[kT](r, PG[c(Qk)], o[wo]));
            })[so](void 0, PG[_k], PG[Wy], n[CG[mu]], r[Au]));
        }), CG[Gb]((o[Xf] = function() {
            return CG[jL](n);
        }, (function(n) {
            try {
                return n();
            } catch (n) {
                CG[XT](n);
            }
        })[so](void 0, o[Xf])))[CG[ru]](function(n) {
            var r = [];
            n && CG[Gb]((r[wo] = n, [
                r[wo][l(gL)],
                r[wo][a(TL)]
            ]))[CG[ru]](function(n) {
                var r = [];
                r[wo] = CG[oJ](n), (function(n, r, i, t) {
                    CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                        CG[_w]() >>> CG[ko]
                    ])), i != PG[ph] && CG[Bk](n, r, t);
                })[so](void 0, PG[_k], PG[_y], PG[ph], r[wo]), r[Au] = PG[c(t(f(52629, 52639), Tr))], (function(n, r, i, t) {
                    return PG[Rk] && PG[Rk](n, r, i, t), i;
                })[so](void 0, PG[_k], r[e(df)], n, void 0);
            });
        }), CG[Gb]((o[jf] = function() {
            return CG[SL](n);
        }, (function(n) {
            try {
                return n();
            } catch (n) {
                CG[XT](n);
            }
        })[so](void 0, o[jf])))[CG[ru]](function(n) {
            var r = [];
            n && (r[wo] = PG[c(t(f(52639, 52649), Tr))], r[Au] = n[a(f(52649, 52657))], (function(n, r, i, t) {
                var o = [];
                CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[e(eO)](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                    CG[_w]() >>> CG[ko]
                ]) : CG[kT](r, PG[c(Qk)], o[wo]));
            })[so](void 0, PG[_k], r[wo], r[Au], PG[oW].Zf), r[Ru] = n[a(f(52657, 52665))], (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[_k], PG[Sy], PG[mh], r[Ru]));
        }), (function(n, r) {
            var i = [];
            i[c(xu)] = CG[Kb](n), i[Au] = CG[Qb](n), i[Ru] = CG[Cb](n), i[yb] = CG[np](n), i[Du] = CG[Yk](i[c(xu)], i[Au]), i[Iu] = CG[Yk](i[Ru], i[yb]), CG[Dk](PG[c(nJ)], r, PG[ph], CG[QM](i[e(vf)], i[c(of)])), CG[Bk](PG[_k], r, [
                i[wo],
                i[Au],
                i[Ru],
                i[yb]
            ]);
        })[so](void 0, n, PG[xy]), (function(n, r) {
            var i = [];
            i[wo] = CG[Ib](n), CG[Dk](PG[_k], r, PG[ph], CG[Kk]([
                i[wo][CG[eN]],
                i[wo][CG[cN]]
            ])), CG[Bk](PG[_k], r, [
                i[wo][CG[eN]],
                i[wo][CG[cN]]
            ]);
        })[so](void 0, n, PG[Ry]), CG[e(t(f(52665, 52676), Tr))]((o[gf] = function() {
            return CG[kL](n);
        }, (function(n) {
            try {
                return n();
            } catch (n) {
                CG[XT](n);
            }
        })[so](void 0, o[gf])))[CG[ru]](function(n) {
            var r = [];
            n && (r[wo] = CG[tJ](n), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[_w]() >>> CG[e(Yl)]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[_k], PG[By], PG[ph], r[wo]), (function(n, r, i, t) {
                return PG[Rk] && PG[Rk](n, r, i, t), i;
            })[so](void 0, PG[_k], PG[By], n, void 0));
        }), o[Zf] = CG[jT](function() {
            return CG[RH](n);
        }), (function(n, r, i, t) {
            i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
        })[so](void 0, PG[Lk], PG[yN], o[Zf], !0), o[Hf] = CG[jT](function() {
            return CG[xH](n);
        }), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Lk], PG[NN], PG[Nh], o[Hf]), o[kf] = CG[jT](function() {
            return CG[bM](CG[kH](n));
        }), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Lk], PG[mN], PG[Nh], o[kf]), u[c(xu)] = CG[jT](function() {
            return CG[JH](n);
        }), u[wo] && (o[dv] = u[wo][a(f(52676, 52684))], (function(n, r, i, t) {
            i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
        })[so](void 0, PG[Hk], PG[ZN], o[dv], void 0), o[av] = u[wo][s(f(52684, 52692))], (function(n, r, i, t) {
            i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
        })[so](void 0, PG[Hk], PG[LN], o[av], void 0)), u[Au] = CG[jT](function() {
            return CG[WH](n);
        }), u[Au] && u[c(df)] !== PG[Tm] ? (o[sv] = PG[c(HT)], o[So] = u[Au][a(f(52692, 52700))], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Hk], PG[FN], o[sv], o[So]), o[wb] = PG[c(CJ)], o[yv] = CG[bM](u[c(df)][a(f(52700, 52708))]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, o[wb], PG[EN], PG[Nh], o[yv])) : ((function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Hk], PG[FN], PG[Nh], u[Au] || PG[e(t(f(52708, 52718), Tr))]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Hk], PG[EN], PG[Nh], PG[gm])), o[Jf] = CG[jT](function() {
            return CG[_H](n);
        }), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Lk], PG[bN], PG[Nh], o[Jf]), u[Ru] = CG[jT](function() {
            var i = n;
            var r = [];
            r[yb] = !1, r[Du] = !1, r[wo] = CG[mM](i[CG[aN]][PG[Vf]][CG[Fu]](), PG[Sf]), r[Au] = i[CG[aN]][PG[Vf]][CG[Fu]][CG[Fu]]()[CG[tv]](l(GH), "()") === Function[PG[Wo]][CG[Fu]](), r[Ru] = i[CG[aN]][PG[e(oA)]][CG[Fu]][CG[Jf]];
            try {
                new i[CG[aN]][PG[Vf]][CG[Fu]];
            } catch (n) {
                r[c(Nv)] = !0;
            }
            try {
                i[CG[aN]][PG[Kf]](i[CG[aN]][PG[c(oA)]][CG[Fu]], i[CG[aN]][PG[Vf]][CG[Fu]]), r[Du] = !0;
            } catch (n) {
                r[c(vf)] = !1;
            }
            return {
                ef: r[wo],
                uf: r[Au],
                if: r[Ru],
                ff: r[yb],
                cf: r[Du]
            };
        }), u[Ru] && (o[bv] = u[Ru][s(f(52718, 52726))], (function(n, r, i, t) {
            i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
        })[so](void 0, PG[Hk], PG[ON], o[bv], void 0), o[Io] = u[Ru][a(f(52726, 52734))], (function(n, r, i, t) {
            i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
        })[so](void 0, PG[Hk], PG[XN], o[Io], void 0), o[pv] = u[Ru][l(f(52734, 52742))], (function(n, r, i, t) {
            CG[jb](t) && (PG[e(zk)][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void e(xu), PG[Hk], PG[jN], PG[Nh], o[pv]), o[Mv] = u[Ru][s(f(52742, 52750))], (function(n, r, i, t) {
            i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
        })[so](void 0, PG[Hk], PG[gN], o[Mv], void 0), o[wv] = u[Ru][l(f(52750, 52758))], (function(n, r, i, t) {
            i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
        })[so](void 0, PG[Hk], PG[TN], o[wv], void 0)), o[Wf] = CG[HH](n), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Hk], PG[nm], PG[Nh], o[Wf]), u[yb] = CG[jT](function() {
            var r = [];
            if (r[wo] = CG[ag](n), r[Au] = CG[yg](r[wo]) ? r[wo][CG[pl]](PG[ns]) : PG[Rv], r[Au]) return {
                Au: CG[xg](r[wo], r[Au]),
                Su: CG[qg](r[wo], r[Au])
            };
        }), u[yb] && (o[Ev] = PG[c(t(f(52758, 52767), Tr))], o[Xv] = u[yb][a(f(52767, 52775))], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], o[Ev], PG[Nh], o[Xv]), o[jv] = u[yb][a("+Dp5EQ==")], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], PG[Rh], PG[Nh], o[jv])), PG[cW] = (o[Jo] = function() {
            return CG[mg](n);
        }, (function(n) {
            try {
                return n();
            } catch (n) {
                CG[XT](n);
            }
        })[so](void 0, o[Jo])), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], PG[Uh], PG[Nh], PG[cW]), o[_f] = CG[YA](n), (function(n, r, i, t) {
            i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
        })[so](void 0, PG[Jk], PG[_h], o[_f], !0), o[Gf] = PG[c(bL)], o[xf] = CG[jT](function() {
            return CG[CA](n);
        }), (function(n, r, i, t) {
            i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
        })[so](void 0, PG[Jk], o[Gf], o[xf], void 0), o[Rf] = CG[HA](n), (function(n, r, i, t) {
            var o = [];
            CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                CG[_w]() >>> CG[ko]
            ]) : CG[kT](r, PG[c(Qk)], o[wo]));
        })[so](void 0, PG[Jk], PG[xh], o[Rf], PG[uW]), o[Uf] = PG[c(t(f(52775, 52785), Tr))], o[Sf] = CG[sF](), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], o[Uf], PG[Nh], o[Sf]), o[If] = CG[ug](n), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], PG[Bh], PG[mh], o[If]), o[Wo] = PG[c(t(f(52785, 52795), Tr))], o[Go] = CG[fF](n), (function(n, r, i, t) {
            var o = [];
            CG[Bk](n, r, i), CG[e($p)](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                CG[_w]() >>> CG[ko]
            ]) : CG[kT](r, PG[c(Qk)], o[wo]));
        })[so](void 0, PG[Jk], o[Wo], o[Go], [
            PG[t(f(52795, 52798), Tr)]
        ]), u[Du] = CG[TT](), o[Bf] = u[Du][a(f(52798, 52806))], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Jk], PG[Dh], PG[mh], o[Bf]), o[Df] = PG[c(t(f(52806, 52816), Tr))], o[Fu] = u[Du][a(f(52816, 52824))], (function(n, r, i, t) {
            var o = [];
            CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                CG[_w]() >>> CG[ko]
            ]) : CG[kT](r, PG[c(Qk)], o[wo]));
        })[so](void 0, PG[Jk], o[Df], o[Fu], [
            PG[ih],
            PG[th],
            PG[oh]
        ]), o[qf] = u[Du][s(f(52824, 52832))], (function(n, r, i, t) {
            var o = [];
            CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                CG[_w]() >>> CG[ko]
            ]) : CG[kT](r, PG[c(Qk)], o[wo]));
        })[so](void 0, PG[Jk], PG[zh], o[qf], [
            PG[ah],
            PG[lh],
            PG[dh]
        ]), o[zf] = PG[c(Tk)], o[$f] = u[c(vf)][s(f(52832, 52840))], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, o[zf], PG[$h], PG[mh], o[$f]), (function(n, i) {
            var t = [];
            t[wo] = CG[sT](i), t[Au] = r(CG[Wo][CG[bf]](CG[Tb](t[wo][a(vJ)]))[CG[bf]](CG[Tb](t[wo][l(eJ)])), CG[Df]), t[Ru] = CG[$M]((t[c(xu)][a(cJ)] & CG[Vv]) << CG[Df] | t[Au]), CG[Dk](PG[Jk], n, PG[ph], t[Ru]), CG[Bk](PG[Jk], n, t[Au]);
        })[so](void 0, PG[Kh], n), o[Kf] = CG[ZT](), (function(n, r, i, t) {
            var o = [];
            CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                CG[_w]() >>> CG[ko]
            ]) : CG[kT](r, PG[c(Qk)], o[wo]));
        })[so](void 0, PG[Jk], PG[Vh], o[Kf], [
            PG[uh],
            PG[fh],
            PG[eh],
            PG[ch]
        ]), o[xo] = CG[MT](n), (function(n, r, i) {
            var t = [];
            i && i[CG[Kf]] && (t[wo] = CG[1488](i[CG[id]]()[CG[jf]](PG[$o])), t[Au] = CG[QM](CG[$M](i[CG[Kf]]), CG[nw](t[wo], CG[Xv])), t[Ru] = CG[kT](r, PG[ph], t[Au]), PG[kk][n][r] = t[Ru]), i && CG[Bk](n, r, i, t[wo]);
        })[so](void 0, PG[Jk], PG[Ch], o[xo]), o[Vf] = CG[OT](n), (function(n, i) {
            var t = [];
            i && i[CG[Kf]] && (t[wo] = CG[nw](r(CG[Bp](i, CG[aJ])[CG[e(is)]](PG[$o]), CG[Df]), CG[Df]), CG[Dk](PG[Jk], PG[Ph], PG[ph], t[wo]), CG[Bk](PG[Jk], n, i));
        })[so](void 0, PG[Ph], o[Vf]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Wk], PG[Qh], PG[yh], PG[tl]), o[Cf] = PG[c(Zk)], o[Pf] = PG[c(t(f(52840, 52850), Tr))], o[Qf] = CG[yF](n), (function(n, r, i, t) {
            var o = [];
            CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[e(dW)], i, [
                CG[_w]() >>> CG[ko]
            ]) : CG[kT](r, PG[c(Qk)], o[wo]));
        })[so](void 0, o[Cf], o[Pf], o[Qf], PG[iW]), o[Yf] = CG[bF](n), (function(n, r, i, t) {
            var o = [];
            CG[Bk](n, r, i), CG[jb](i) && (o[wo] = CG[_p](t, i), PG[kk][n][r] = o[wo] < PG[xv] ? CG[kT](r, PG[Nh], i, [
                CG[_w]() >>> CG[ko]
            ]) : CG[kT](r, PG[c(Qk)], o[wo]));
        })[so](void 0, PG[Wk], PG[e(ML)], o[Yf], PG[tW]), o[nv] = CG[NF](n), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Wk], PG[e(t(f(52850, 52860), Tr))], PG[Nh], o[nv]), o[rv] = PG[c(t(f(52860, 52871), Tr))], (function(n) {
            var r = [];
            r[wo] = CG[qp](CG[BT]()), CG[Dk](PG[Wk], n, PG[ph], CG[ng](r[wo])), CG[Bk](PG[Wk], n, r[wo]);
        })[so](void 0, o[rv]), o[iv] = CG[wZ](n), (function(n, r, i, t) {
            i ? PG[c(zk)][n][r] = CG[kT](r, PG[hh]) : t && !1 === i && (PG[kk][n][r] = CG[kT](r, PG[sh])), CG[Bk](n, r, i);
        })[so](void 0, PG[Wk], PG[oy], o[iv], void 0), o[Ro] = CG[eg](), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Wk], PG[uy], PG[mh], o[Ro]), o[tv] = CG[jT](function() {
            return CG[pT](n);
        }), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[_k], PG[Oy], PG[mh], o[tv]), i && (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Wk], PG[ry], PG[Nh], PG[sc]), o[Uo] = PG[c(t(f(52871, 52881), Tr))], o[ov] = CG[jT](function() {
            return CG[Lw](CG[_w]())[PG[fW]]();
        }), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[_k], o[Uo], PG[mh], o[ov]), o[uv] = PG[c(dW)], o[fv] = CG[jT](function() {
            return CG[XL](n);
        }), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Lk], PG[oN], o[uv], o[fv]), o[vv] = PG[c(dW)], o[ev] = CG[Db](n)[CG[SN]], (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[_k], PG[jy], o[vv], o[ev]), (function() {
            CG[lW](PG[_k], PG[gy], CG[bM](PG[sW]), CG[Kv]);
        })[so](void 0), (function(n) {
            PG[e(Dj)][CG[Ya]] = CG[AM](CG[Bw](n));
        })[so](void 0, n);
    }, CG[Ik] = function(n) {
        CG[gH](n, function() {
            var n = [];
            var r = [];
            r[wo] = CG[dJ](CG[qp](CG[jH]())), n[wo] = CG[ng](r[wo]), (function(n, r, i, t) {
                CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                    CG[e(hJ)]() >>> CG[ko]
                ])), i != PG[ph] && CG[Bk](n, r, t);
            })[so](void 0, PG[Wk], PG[ly], PG[ph], n[wo]), (function(n, r, i, t) {
                return PG[Rk] && PG[Rk](n, r, i, t), i;
            })[so](void 0, PG[Wk], PG[ly], r[wo], void 0);
        });
    }, CG[t(f(52881, 52885), Tr)] = function(n, r, i) {
        var o = [];
        o[wo] = function(n) {
            var o = [];
            CG[qj](n), CG[jT](function() {
                return CG[QJ](CG[Xk](n));
            }), CG[qk](PG[_k], PG[Jy], CG[jT](function() {
                return CG[YZ](n, r[CG[$a]]);
            }), !0), CG[Gb](CG[jT](function() {
                return CG[UL](n, r[CG[$a]]);
            }))[CG[ru]](function(n) {
                var r = [];
                n && (r[wo] = [
                    n[CG[xy]],
                    n[CG[Gy]],
                    n[CG[Hy]],
                    n[CG[_y]],
                    n[CG[Wy]],
                    n[CG[WT]],
                    n[CG[Jy]],
                    n[CG[ky]]
                ], CG[Dk](PG[_k], PG[Gy], PG[ph], CG[ng](r[wo])), CG[Bk](PG[_k], PG[Gy], r[c(xu)]));
            }), CG[rJ](n, PG[Iy], r[CG[$a]]);
            try {
                CG[Gb](CG[jT](function() {
                    return CG[wL](n);
                }))[CG[ru]](function(n) {
                    var r = [];
                    n && (r[c(xu)] = [
                        n[l(f(52885, 52893))],
                        n[a(f(52893, 52901))],
                        n[CG[py]],
                        n[CG[my]]
                    ], CG[Dk](PG[Lk], PG[dN], PG[ph], CG[e(t(f(52901, 52911), Tr))](r[wo])), CG[Bk](PG[Lk], PG[dN], r[c(xu)]), CG[Dk](PG[Lk], PG[aN], PG[Nh], n[CG[by]][CG[jf]](CG[xo])));
                }), o[wo] = CG[Sb](n), CG[VT](n), CG[jT](function() {
                    return CG[FZ](n);
                }), CG[CT](n, o[wo], r[CG[za]], r[CG[$a]]), o[Au] = CG[$T](), CG[Dk](PG[Wk], PG[iy], PG[mh], o[c(df)][a(f(52911, 52927))]), CG[Ck](PG[sy]), i || (o[Ru] = CG[jT](function() {
                    return CG[EZ]();
                }), CG[e(hW)](PG[c(Zk)], PG[ry], PG[Nh], o[Ru])), o[yb] = [
                    PG[Tu],
                    PG[Zu],
                    CG[jT](function() {
                        return CG[Qg](n);
                    }),
                    CG[jT](function() {
                        return CG[yZ](n);
                    }),
                    CG[jT](function() {
                        return CG[e(t(f(52927, 52938), Tr))](n);
                    }),
                    CG[jT](function() {
                        return CG[hZ](n);
                    }),
                    CG[jT](function() {
                        return CG[NZ](CG[qA](n), CG[IA](n));
                    }),
                    CG[mZ](n),
                    CG[jT](function() {
                        return CG[iZ](n, CG[KT](), r[CG[za]], r[CG[$a]]);
                    }),
                    CG[fZ](),
                    CG[MZ]()
                ], CG[Dk](PG[Wk], PG[fy], PG[ph], CG[ng](o[yb])), CG[Bk](PG[Wk], PG[fy], CG[dJ](o[yb])), CG[Gb](CG[e(t(f(52938, 52948), Tr))](n))[CG[ru]](function(n) {
                    var r = [];
                    r[wo] = CG[pL](n), CG[Dk](PG[Lk], PG[rN], PG[ph], CG[ng](CG[nM](r[wo]))), CG[Bk](PG[Lk], PG[rN], r[wo]), r[Au] = CG[Sp](r[wo])[CG[Kf]], CG[Dk](PG[Lk], PG[iN], PG[mh], r[Au]), CG[qk](PG[Lk], PG[tN], n[CG[Qh]]);
                });
            } finally{
                CG[PT]();
            }
            CG[MH](n, function(r) {
                CG[Vk](PG[Wk], PG[c(t(f(52948, 52959), Tr))], r), CG[zj](n);
            });
        }, (function(n, r) {
            PG[Lu] ? r(n) : PG[wm][CG[Cf]](r);
        })[so](void 0, n, o[wo]);
    }, CG[t(f(52959, 52963), Tr)] = function() {
        var n = [];
        n[wo] = CG[bM](PG[sW]), (function(n, r, i, t) {
            CG[jb](i) && (CG[e(hW)](n, r, PG[ph], CG[vA](i, [
                r,
                CG[_w]() >>> CG[ko]
            ], t)), CG[Bk](n, r, i));
        })[so](void 0, PG[_k], PG[gy], n[wo], CG[Kv]);
    }, CG[t(f(52963, 52967), Tr)] = function(n) {
        var r = [];
        var i = [];
        i[wo] = CG[qp](CG[BT]()), r[e(xu)] = CG[ng](i[wo]), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, PG[Wk], n, PG[ph], r[wo]), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Wk], n, i[wo], void 0);
    }, CG[lW] = function(n, r, i, t) {
        var o = [];
        o[wo] = i, CG[Ob](o[wo]) && o[wo] !== PG[Eu] && (o[Au] = CG[vA](i, [
            r,
            CG[_w]() >>> CG[ko]
        ], t), (function(n, r, i, t) {
            CG[jb](t) && (PG[kk][n][r] = CG[kT](r, i, t, [
                CG[_w]() >>> CG[ko]
            ])), i != PG[ph] && CG[Bk](n, r, t);
        })[so](void 0, n, r, PG[ph], o[Au]), (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, n, r, i, void 0));
    }, CG[yW] = function() {
        var i = PG[e(zk)][PG[Jk]];
        var n = [];
        if (CG[Pf] in Object) return Object[CG[Pf]](i);
        var r;
        for(r in n[wo] = [], i)CG[Zb](i, r) && n[wo][CG[Cf]](i[r]);
        return n[wo];
    }, CG[NW] = function() {
        var i = PG[kk][PG[Wk]];
        var n = [];
        if (CG[Pf] in Object) return Object[CG[Pf]](i);
        var r;
        for(r in n[wo] = [], i)CG[Zb](i, r) && n[wo][CG[Cf]](i[r]);
        return n[wo];
    }, CG[mW] = function() {
        var i = PG[kk][PG[_k]];
        var n = [];
        if (CG[Pf] in Object) return Object[CG[Pf]](i);
        var r;
        for(r in n[wo] = [], i)CG[Zb](i, r) && n[wo][CG[Cf]](i[r]);
        return n[wo];
    }, CG[bW] = function() {
        var i = PG[kk][PG[Lk]];
        var n = [];
        if (CG[Pf] in Object) return Object[CG[Pf]](i);
        var r;
        for(r in n[wo] = [], i)CG[Zb](i, r) && n[wo][CG[Cf]](i[r]);
        return n[wo];
    }, CG[pW] = function() {
        var i = PG[kk][PG[Hk]];
        var n = [];
        if (CG[Pf] in Object) return Object[CG[Pf]](i);
        var r;
        for(r in n[wo] = [], i)CG[Zb](i, r) && n[e(xu)][CG[Cf]](i[r]);
        return n[wo];
    }, CG[MW] = function(n) {
        return (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Lk], PG[wN], n, void 0), CG[kT](PG[c(GT)], PG[c(vW)], CG[$k](n), [
            PG[Xe][CG[$o]] >>> CG[ko]
        ]);
    }, CG[wW] = function(n) {
        return (function(n, r, i, t) {
            return PG[Rk] && PG[Rk](n, r, i, t), i;
        })[so](void 0, PG[Lk], PG[AN], n, void 0), CG[kT](PG[c(xT)], PG[ph], CG[$k](n), [
            PG[Xe][CG[$o]] >>> CG[ko]
        ]);
    }, CG[t(f(52967, 52971), Tr)] = function(n) {
        PG[Hu] || ((function(n, r) {
            var i = [];
            i[wo] = [
                CG[sJ](n),
                CG[tT](n),
                CG[fT](n),
                CG[vT](n),
                CG[cT](n),
                CG[eT](n),
                CG[dT](n),
                CG[aT](n)
            ], CG[Dk](PG[Jk], r, PG[ph], CG[ng](i[c(xu)])), CG[Bk](PG[Jk], r, CG[dJ](i[wo]));
        })[so](void 0, n, PG[Ih]), CG[yJ](n, PG[dy]), (function(n, r) {
            var i = [];
            i[wo] = CG[Qb](n) - CG[Kb](n), i[Au] = CG[np](n) - CG[Cb](n), CG[Dk](PG[Wk], r, PG[ph], CG[Kk]([
                i[wo],
                i[Au]
            ])), CG[Bk](PG[Wk], r, [
                i[wo],
                i[Au]
            ]);
        })[so](void 0, n, PG[Ny]), PG[Hu] = !0);
    }, CG[t(f(52971, 52975), Tr)] = function(n) {
        return !n[CG[IN]] || !!n[CG[BN]][CG[DN]] || !!n[CG[BN]][CG[qN]];
    }, CG[t(f(52975, 52979), Tr)] = function(n) {
        return !!n[CG[IN]] && n[CG[BN]][CG[DN]];
    }, CG[t(f(52979, 52983), Tr)] = function(n) {
        return !!n[CG[IN]] && n[CG[BN]][CG[qN]];
    }, CG[t(f(52983, 52987), Tr)] = function(n) {
        return n[CG[zN]] == PG[rv];
    }, CG[AW] = function(n, r) {
        return !n || r[CG[$N]] != n[CG[$N]] || r[CG[IN]] != n[CG[IN]];
    }, CG[FW] = function(n, r) {
        return !!n && r[CG[KN]] != n[CG[KN]];
    }, CG[EW] = function(n) {
        return n[CG[AF]] || String[CG[Fv]](n[s(OW)] || n[CG[Uc]]);
    }, CG[t(f(52987, 52991), Tr)] = function(n) {
        var r = [];
        switch(r[wo] = n, r[wo][CG[AF]] || String[CG[Fv]](r[wo][s(OW)] || r[wo][CG[Uc]])){
            case PG[wf]:
            case PG[Ff]:
            case PG[Af]:
            case PG[Ef]:
            case PG[Iu]:
            case PG[mb]:
            case PG[Nb]:
            case PG[Su]:
                return !0;
            default:
                return !1;
        }
    }, CG[XW] = function(n, r) {
        return r[CG[VN]] ? r[CG[VN]][CG[nv]]() : r === n ? PG[rv] : r === n[CG[Ef]] ? PG[c(jW)] : void 0;
    }, CG[gW] = function(n) {
        return n[CG[iN]] || n[CG[CN]];
    }, CG[t(f(52991, 52995), Tr)] = function(n) {
        var r = [];
        switch(r[wo] = {}, n + CG[Wo]){
            case PG[wo]:
            case PG[mf]:
                r[wo][CG[PN]] = !0;
                break;
            case PG[Au]:
            case PG[bf]:
                r[wo][CG[QN]] = !0;
                break;
            case PG[Ru]:
            case PG[pf]:
                r[wo][CG[YN]] = !0;
                break;
            case PG[yb]:
            case PG[Zo]:
                r[wo][CG[DN]] = !0;
                break;
            case PG[Du]:
            case PG[Lo]:
                r[wo][CG[qN]] = !0;
                break;
            case PG[hf]:
            case PG[To]:
            case PG[yf]:
            case PG[Nf]:
            case PG[Ho] + a(TW):
            case PG[Ho] + a(ZW):
            case PG[Ho] + s(LW):
            case PG[c(ne)] + a(HW):
                r[wo][CG[nm]] = !0;
        }
        return r[wo];
    }, CG[t(f(52995, 52999), Tr)] = function(n) {
        var r = [];
        return r[wo] = CG[EW](n), CG[kp](r[wo]) && CG[vM](r[wo]) === CG[Zf] && r[wo] === CG[uM](r[wo]) && r[wo] !== CG[oM](r[wo]);
    }, CG[kW] = function(n) {
        var r = [];
        return r[c(xu)] = {}, n[l(f(52999, 53015))] && (r[wo][CG[rm]] = !0), n[l(f(53015, 53035))] && (r[c(xu)][CG[im]] = !0), n[l(f(53035, 53055))] && (r[wo][CG[tm]] = !0), n[a(f(53055, 53079))] && (r[wo][CG[Tu]] = !0), n[CG[Zu]] && n[CG[Zu]](PG[Mf]) && (r[wo][CG[om]] = !0), r[wo];
    }, CG[JW] = function(n, r) {
        var i = [];
        var t = [];
        return t[wo] = {}, r && (t[Au] = r[CG[Jf]] || r[CG[uN]], t[Au] && (t[wo][CG[$N]] = (i[e(af)] = CG[sM](t[Au]), (function(n) {
            var r = [];
            r[c(xu)] = CG[ko], r[Au] = CG[ko];
            for(; r[Au] < n[CG[Kf]]; r[Au]++)r[wo] ^= n[CG[pv]](r[Au]);
            return r[wo] & CG[Xf];
        })[so](void 0, i[Ru])))), t[wo];
    }, CG[t(f(53079, 53083), Tr)] = function(n, r) {
        var i = [];
        return i[wo] = CG[JW](n, r), r && (i[c(xu)][CG[zN]] = (function(n, r) {
            return r[CG[VN]] ? CG[e(t(f(53083, 53093), Tr))](r[CG[VN]]) : r === n ? PG[rv] : r === CG[Sb](n) ? PG[c(jW)] : void 0;
        })[so](void 0, n, r), i[c(df)] = r[CG[we]], (function(n) {
            return typeof n === l(Jp);
        })[so](void 0, i[Au]) && (i[wo][CG[IN]] = (function(n) {
            return n[CG[nv]]();
        })[so](void 0, i[Au]))), i[wo];
    }, CG[WW] = function(n, r) {
        var t = n;
        var o = CG[gW](r);
        var i = [];
        return i[wo] = CG[JW](t, o), o && (i[c(xu)][CG[zN]] = CG[XW](t, o), i[c(df)] = o[CG[we]], CG[kp](i[Au]) && (i[wo][CG[IN]] = CG[oM](i[Au]))), i[wo];
    }, CG[_W] = function(n, r) {
        var n = CG[gW](r);
        var i = [];
        return i[wo] = {}, n && (i[Au] = n[CG[Jf]] || n[CG[uN]], i[Au] && (i[wo][CG[$N]] = CG[ew](CG[sM](i[Au])))), i[wo];
    }, PG[GW] = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/, PG[xW] = /(\+\d{1,3}\s?)?(\(\d{3}\)|\d{3})[\s.-]?\d{3}[\s.-]?\d{4}|^\+[1-9]\d{1,14}$/, PG[RW] = /\b(?!000|666|9\d{2})([0-8]\d{2}|7([0-6]\d|7[012]))([-]?)\d{2}\3(?!0000)\d{4}\b/, PG[c(t(f(53093, 53103), Tr))] = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/, CG[UW] = function(n, r) {
        var i = [];
        return i[wo] = CG[WW](n, r), r[CG[ra]] && r[CG[ra]][CG[ia]] && (i[e(df)] = r[CG[ra]][CG[ia]](a(f(53103, 53131))), i[Ru] = {}, i[Ru][CG[um]] = PG[GW][CG[ie]](i[Au]), i[Ru][CG[fm]] = PG[xW][CG[ie]](i[Au]), i[Ru][CG[vm]] = PG[RW][CG[ie]](i[Au]), i[Ru][CG[em]] = PG[t(f(53131, 53134), Tr)][CG[ie]](i[Au]), i[wo][CG[BN]] = i[c(af)]), i[wo];
    }, CG[SW] = function(n, r) {
        var i = [];
        return i[wo] = CG[WW](n, r), i[Au] = CG[kW](r), i[Au] = PG[$v](i[Au], (function(n) {
            var r = [];
            switch(r[wo] = {}, n + CG[Wo]){
                case PG[wo]:
                case PG[mf]:
                    r[wo][CG[PN]] = !0;
                    break;
                case PG[Au]:
                case PG[bf]:
                    r[wo][CG[QN]] = !0;
                    break;
                case PG[Ru]:
                case PG[pf]:
                    r[wo][CG[YN]] = !0;
                    break;
                case PG[yb]:
                case PG[Zo]:
                    r[wo][CG[DN]] = !0;
                    break;
                case PG[Du]:
                case PG[Lo]:
                    r[wo][CG[qN]] = !0;
                    break;
                case PG[hf]:
                case PG[To]:
                case PG[yf]:
                case PG[Nf]:
                case PG[Ho] + a(TW):
                case PG[Ho] + a(ZW):
                case PG[Ho] + s(LW):
                case PG[c(ne)] + a(HW):
                    r[wo][CG[nm]] = !0;
            }
            return r[wo];
        })[so](void 0, r[CG[Bc]] || r[CG[Uc]] || r[CG[Sc]])), CG[yM](CG[EW](r)) && (i[Au][CG[eZ]] = !0), i[wo][CG[BN]] = i[Au], i[wo];
    }, PG[IW] = CG[ko], PG[BW] = CG[Zf], PG[c(t(f(53134, 53143), Tr))] = CG[Df], PG[DW] = CG[yv], PG[qW] = CG[Xv], PG[c(t(f(53143, 53152), Tr))] = CG[re], PG[zW] = CG[gf], PG[$W] = CG[xw], PG[t(f(53152, 53155), Tr)] = CG[wv], PG[t(f(53155, 53158), Tr)] = CG[Te], PG[KW] = CG[mv], PG[e(t(f(53158, 53167), Tr))] = CG[Le], PG[VW] = CG[Cv], PG[CW] = CG[ke], PG[PW] = CG[Tv], PG[QW] = CG[Mv], PG[YW] = CG[bv], PG[n_] = CG[fl], PG[r_] = CG[Yv], PG[i_] = CG[el], PG[t_] = CG[Na], PG[o_] = CG[e(t(f(53167, 53177), Tr))], PG[u_] = CG[Zl], PG[f_] = CG[gu], PG[v_] = CG[Ev], PG[c(t(f(53177, 53187), Tr))] = CG[Ql], PG[e_] = CG[ns], PG[c_] = CG[rs], PG[d_] = d(t(f(53187, 53198), Tr)), PG[c(a_)] = CG[Vv], PG[l_] = PG[c(a_)], PG[c(t(f(53198, 53208), Tr))] = CG[Vv], PG[s_] = PG[t(f(53208, 53211), Tr)], PG[h_] = {
        Ao: [],
        So: PG[xv],
        Eo: PG[Rv],
        Fo: PG[xv],
        Co: !1
    }, PG[c(e(t(f(53211, 53222), Tr)))] = (PG[Fb] = {}, PG[Fb][PG[BW]] = {
        To: CG[_W],
        Io: [
            CG[$d]
        ]
    }, PG[e(y_)][PG[t(f(53222, 53225), Tr)]] = {
        To: CG[_W],
        Io: [
            CG[UE]
        ]
    }, PG[Fb][PG[DW]] = {
        To: CG[UW],
        Io: [
            CG[zd]
        ]
    }, PG[Fb][PG[qW]] = {
        Io: [
            CG[qd]
        ]
    }, PG[Fb][PG[e(t(f(53225, 53234), Tr))]] = {
        Io: [
            s(f(53234, 53278))
        ]
    }, PG[Fb][PG[e(t(f(53278, 53288), Tr))]] = {
        To: CG[WW],
        Io: [
            l(f(53288, 53304))
        ]
    }, PG[Fb][PG[KW]] = {
        Io: [
            l(f(53304, 53316))
        ]
    }, PG[Fb][PG[t(f(53316, 53319), Tr)]] = {
        Io: [
            s(f(53319, 53335))
        ]
    }, PG[Fb][PG[VW]] = {
        Io: [
            s(f(53335, 53367))
        ]
    }, PG[Fb][PG[IW]] = {
        To: CG[WW],
        Io: [
            f(53367, 53372)
        ]
    }, PG[Fb][PG[CW]] = {
        To: CG[WW],
        Io: [
            a(f(53372, 53404))
        ]
    }, PG[c(y_)][PG[PW]] = {
        To: CG[WW],
        Io: [
            a(f(53404, 53428))
        ]
    }, PG[Fb][PG[f_]] = {
        Do: function(n, r) {
            var i = [];
            return i[wo] = r, !!i[wo][CG[IN]] && i[wo][CG[BN]][CG[DN]] || (i[Au] = r, !!i[Au][CG[IN]] && i[Au][CG[BN]][CG[qN]]);
        },
        To: CG[SW],
        Io: [
            CG[Dd]
        ]
    }, PG[Fb][PG[zW]] = {
        To: CG[WW],
        Lo: !0,
        Io: [
            s(f(53428, 53440))
        ],
        Do: function(n, r) {
            return r[CG[zN]] == PG[rv];
        }
    }, PG[c(y_)][PG[t(f(53440, 53443), Tr)]] = {
        To: CG[WW],
        Lo: !0,
        Io: [
            CG[Vd]
        ],
        Do: function(n, r) {
            return r[CG[zN]] == PG[rv];
        }
    }, PG[Fb][PG[$W]] = {
        To: CG[WW],
        Io: [
            l(f(53443, 53463))
        ]
    }, PG[Fb][PG[QW]] = {
        Lo: !0,
        Io: [
            s(f(53463, 53483))
        ]
    }, PG[Fb][PG[YW]] = {
        Lo: !0,
        Io: [
            s(f(53483, 53499))
        ]
    }, PG[Fb][PG[n_]] = {
        Lo: !0,
        Io: [
            s(f(53499, 53527))
        ]
    }, PG[Fb][PG[r_]] = {
        Do: function(n) {
            return !!(function(n) {
                if (n[CG[iN]] && n[CG[iN]][CG[Ul]] && n[CG[iN]][CG[we]] && n[CG[iN]][CG[we]] in PG[FH] && (PG[OH] === n[CG[Yd]] || !(CG[Qd] in n) || PG[EH] === n[s(XH)])) return !0;
            })[so](void 0, n);
        },
        To: CG[_W],
        Io: [
            CG[fN],
            CG[wf]
        ]
    }, PG[Fb][PG[i_]] = {
        Do: function(n, r) {
            var i = [];
            return i[wo] = r, !(!i[wo][CG[IN]] || i[wo][CG[BN]][CG[DN]] || i[wo][CG[BN]][CG[qN]]);
        },
        To: CG[SW],
        Io: [
            CG[Dd]
        ]
    }, PG[Fb][PG[o_]] = {
        Io: [
            CG[Cd]
        ],
        Ro: CG[mv]
    }, PG[c(y_)][PG[t_]] = {
        Io: [
            CG[Gl],
            s(f(53527, 53551)),
            l(f(53551, 53575))
        ],
        Ro: CG[mv]
    }, PG[c(y_)][PG[v_]] = {
        Do: function(n, r, i) {
            return i[CG[Ef]][CG[Sf]];
        },
        Io: [
            s(f(53575, 53619))
        ]
    }, PG[Fb][PG[t(f(53619, 53622), Tr)]] = {
        Do: function(n, r, i) {
            var t = [];
            return CG[Gb]((t[wo] = CG[gW](n), (function(n, r) {
                return r[CG[VN]] ? CG[oM](r[CG[VN]]) : r === n ? PG[rv] : r === CG[Sb](n) ? PG[c(jW)] : void 0;
            })[so](void 0, i, t[wo]) === CG[Eh]))[CG[ru]](function() {
                PG[h_][CG[cm]] = !0;
            })[CG[Zo]]();
        },
        Io: [
            s(f(53622, 53650))
        ]
    }, PG[Fb][PG[e_]] = {
        Do: function(n, r, i) {
            var t = [];
            return CG[Gb](PG[h_][CG[cm]] && (t[wo] = CG[gW](n), (function(n, r) {
                return r[CG[VN]] ? CG[oM](r[CG[VN]]) : r === n ? PG[rv] : r === CG[Sb](n) ? PG[c(jW)] : void 0;
            })[so](void 0, i, t[wo]) === CG[Eh]))[CG[ru]](function() {
                PG[h_][CG[cm]] = !1;
            })[CG[Zo]]();
        },
        Io: [
            l(f(53650, 53678))
        ]
    }, PG[Fb][PG[c_]] = {
        Ro: CG[Zf],
        Lo: !0,
        Io: [
            l(f(53678, 53694))
        ]
    }, PG[Fb]), PG[N_] = CG[kv], CG[m_] = function(n) {
        var r = [];
        PG[h_][CG[dm]] = CG[ko], (null === (r[wo] = PG[h_][CG[am]]) || r[c(xu)] === void CG[ko] ? void CG[ko] : r[wo][CG[KN]]) === n[CG[KN]] && (PG[h_][CG[dm]] = PG[h_][CG[lm]]);
    }, CG[b_] = function(n) {
        var r = [];
        PG[h_][CG[dm]]++, (null === (r[wo] = PG[h_][CG[am]]) || r[wo] === void CG[ko] ? void CG[ko] : r[c(xu)][CG[KN]]) === n[CG[KN]] && PG[h_][CG[lm]]++;
    }, CG[p_] = function(n) {
        return PG[h_][CG[am]] ? PG[h_][CG[sm]] && PG[h_][CG[sm]][CG[KN]] === PG[h_][CG[am]][CG[KN]] ? n[CG[hm]] - PG[h_][CG[sm]][CG[hm]] : n[CG[hm]] - PG[h_][CG[am]][CG[hm]] : CG[ko];
    }, CG[M_] = function(n) {
        var r = [];
        r[wo] = CG[p_](n), r[wo] > PG[N_] && PG[h_][CG[ym]][CG[Cf]]({
            co: PG[u_],
            Po: n[CG[hm]],
            io: {
                jo: r[wo]
            }
        }), PG[h_][CG[ym]][CG[Cf]](n), PG[h_][CG[am]] = n, PG[c(w_)][CG[lm]] = PG[h_][CG[dm]];
    }, CG[e(t(f(53694, 53704), Tr))] = function(n) {
        var r = [];
        ((function(n, r) {
            return !n || r[CG[$N]] != n[CG[$N]] || r[CG[IN]] != n[CG[IN]];
        })[so](void 0, PG[h_][CG[sm]], n) || (r[wo] = PG[h_][CG[sm]], (function(n, r) {
            return !!n && r[CG[KN]] != n[CG[KN]];
        })[so](void 0, r[wo], n))) && (function(n) {
            var r = [];
            PG[h_][CG[dm]] = CG[ko], (null === (r[wo] = PG[h_][CG[am]]) || r[c(xu)] === void CG[ko] ? void CG[ko] : r[wo][CG[KN]]) === n[CG[KN]] && (PG[h_][CG[dm]] = PG[h_][CG[lm]]);
        })[so](void 0, n), (function(n) {
            var r = [];
            PG[h_][CG[dm]]++, (null === (r[e(xu)] = PG[h_][CG[am]]) || r[wo] === void CG[ko] ? void CG[ko] : r[c(xu)][CG[KN]]) === n[CG[KN]] && PG[h_][CG[lm]]++;
        })[so](void 0, n), PG[h_][CG[dm]] === CG[Zf] ? (function(n) {
            var r = [];
            r[wo] = CG[p_](n), r[wo] > PG[N_] && PG[e(w_)][CG[ym]][CG[Cf]]({
                co: PG[u_],
                Po: n[CG[hm]],
                io: {
                    jo: r[wo]
                }
            }), PG[h_][CG[ym]][CG[Cf]](n), PG[h_][CG[am]] = n, PG[c(w_)][CG[lm]] = PG[h_][CG[dm]];
        })[so](void 0, n) : PG[h_][CG[am]][CG[BN]] = PG[$v](PG[h_][CG[am]][CG[BN]], n[CG[BN]]);
    }, CG[t(f(53704, 53708), Tr)] = function(n, r) {
        var i = [];
        i[wo] = PG[h_][CG[sm]], (function(n, r) {
            return !!n && r[CG[KN]] != n[CG[KN]];
        })[so](void 0, i[wo], n) && (function(n) {
            var r = [];
            PG[h_][CG[dm]] = CG[ko], (null === (r[wo] = PG[h_][CG[am]]) || r[c(xu)] === void CG[ko] ? void CG[ko] : r[wo][CG[KN]]) === n[CG[KN]] && (PG[h_][CG[dm]] = PG[h_][CG[lm]]);
        })[so](void 0, n), (function(n) {
            var r = [];
            PG[h_][CG[dm]]++, (null === (r[wo] = PG[h_][CG[am]]) || r[wo] === void CG[ko] ? void CG[ko] : r[c(xu)][CG[KN]]) === n[CG[KN]] && PG[h_][CG[lm]]++;
        })[so](void 0, n), PG[h_][CG[dm]] === r[l(A_)] && (function(n) {
            var r = [];
            r[wo] = CG[p_](n), r[wo] > PG[N_] && PG[h_][CG[ym]][CG[Cf]]({
                co: PG[u_],
                Po: n[CG[hm]],
                io: {
                    jo: r[wo]
                }
            }), PG[h_][CG[ym]][CG[Cf]](n), PG[h_][CG[am]] = n, PG[c(w_)][CG[lm]] = PG[h_][CG[dm]];
        })[so](void 0, n);
    }, CG[t(f(53708, 53712), Tr)] = function(n) {
        (function(n) {
            var r = [];
            PG[h_][CG[dm]] = CG[ko], (null === (r[wo] = PG[h_][CG[am]]) || r[c(xu)] === void CG[ko] ? void CG[ko] : r[wo][CG[KN]]) === n[CG[KN]] && (PG[h_][CG[dm]] = PG[h_][CG[lm]]);
        })[so](void 0, n), (function(n) {
            var r = [];
            r[wo] = CG[p_](n), r[wo] > PG[N_] && PG[h_][CG[ym]][CG[Cf]]({
                co: PG[u_],
                Po: n[CG[e(t(f(53712, 53722), Tr))]],
                io: {
                    jo: r[wo]
                }
            }), PG[h_][CG[ym]][CG[Cf]](n), PG[h_][CG[am]] = n, PG[c(w_)][CG[lm]] = PG[h_][CG[dm]];
        })[so](void 0, n);
    }, CG[F_] = function(n, r, i, o, u) {
        var v = [];
        try {
            if ((function(n) {
                switch(CG[EW](n)){
                    case PG[wf]:
                    case PG[Ff]:
                    case PG[Af]:
                    case PG[Ef]:
                    case PG[Iu]:
                    case PG[mb]:
                    case PG[Nb]:
                    case PG[Su]:
                        return !0;
                    default:
                        return !1;
                }
            })[so](void 0, i)) return;
            if (v[wo] = PG[c(t(f(53722, 53732), Tr))][r], v[Au] = {
                co: r,
                Po: i[CG[Vc]]
            }, v[wo][CG[Nm]] && (v[Au] = PG[$v](v[Au], v[wo][CG[Nm]](n, i))), v[wo][CG[mm]] && !v[wo][CG[mm]](i, v[Au], n)) return;
            r == PG[i_] ? (function(n) {
                (CG[AW](PG[h_][CG[sm]], n) || CG[FW](PG[e(w_)][CG[sm]], n)) && CG[m_](n), CG[b_](n), PG[h_][CG[dm]] === CG[Zf] ? CG[M_](n) : PG[h_][CG[am]][CG[BN]] = PG[$v](PG[h_][CG[am]][CG[BN]], n[CG[BN]]);
            })[so](void 0, v[Au]) : r == PG[o_] || r == PG[c(t(f(53732, 53742), Tr))] || r == PG[c_] ? (function(n, r) {
                CG[FW](PG[h_][CG[sm]], n) && CG[m_](n), CG[b_](n), PG[h_][CG[dm]] === r[l(A_)] && CG[M_](n);
            })[so](void 0, v[Au], v[wo]) : (function(n) {
                CG[m_](n), CG[M_](n);
            })[so](void 0, v[Au]), u && u(n), PG[h_][CG[sm]] = v[Au];
        } catch (n) {
            o && o(n);
        }
    }, CG[E_] = function() {
        return PG[h_][CG[ym]];
    }, CG[O_] = function(n, r, i) {
        var t = [];
        var o = [];
        o[wo] = CG[Sb](n), t[wo] = CG[Kp](PG[X_]), t[Au] = function(t) {
            var u = [];
            u[wo] = PG[X_][t], u[c(df)] = u[wo][l(f(53742, 53750))] ? n : o[wo], CG[Dp](u[wo][a(f(53750, 53758))], function(o) {
                CG[ww](u[Au], o, function(o) {
                    CG[F_](n, t, o, r, i);
                });
            });
        }, (function(n, r) {
            var i = [];
            i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
        })[so](void 0, t[wo], t[Au]);
    }, CG[j_] = function(n) {
        var r = [];
        return r[wo] = PG[xv], r[Au] = n[CG[BN]], r[Au] && (r[Au][CG[um]] && (r[wo] |= CG[Zf]), r[Au][CG[fm]] && (r[wo] |= CG[Df]), r[Au][CG[em]] && (r[wo] |= CG[Xv]), r[e(df)][CG[vm]] && (r[wo] |= CG[wv])), [
            r[c(xu)]
        ];
    }, CG[e(t(f(53758, 53769), Tr))] = function(n) {
        var r = [];
        return r[wo] = PG[xv], r[Au] = n[CG[BN]], r[c(df)] && (r[e(df)][CG[DN]] && (r[wo] |= CG[Zf]), r[e(df)][CG[e(UT)]] && (r[c(xu)] |= CG[Df])), [
            r[c(xu)]
        ];
    }, CG[g_] = function(n) {
        var r = [];
        return r[wo] = PG[xv], r[c(df)] = PG[xv], r[Ru] = n[CG[BN]], r[Ru] && (r[Ru][CG[tm]] && (r[wo] |= CG[Zf]), r[c(af)][CG[rm]] && (r[wo] |= CG[Df]), r[Ru][CG[Tu]] && (r[c(xu)] |= CG[Xv]), r[Ru][CG[im]] && (r[wo] |= CG[wv]), r[Ru][CG[om]] && (r[wo] |= CG[bv]), r[Ru][CG[eZ]] && (r[wo] |= d(c(t(f(53769, 53780), Tr)))), r[Ru][CG[PN]] && (r[Au] |= CG[Zf]), r[Ru][CG[QN]] && (r[Au] |= CG[Df]), r[Ru][CG[YN]] && (r[Au] |= CG[Xv]), r[Ru][CG[nm]] && (r[Au] |= CG[wv])), [
            r[wo],
            r[Au]
        ];
    }, CG[T_] = function(n) {
        var r = [];
        return n[CG[BN]] ? (r[wo] = ~~(n[CG[BN]][l(f(53780, 53788))] / CG[kv]), [
            r[wo] > PG[Uv] ? PG[Uv] : r[wo]
        ]) : [
            PG[xv]
        ];
    }, PG[c(t(f(53788, 53798), Tr))] = (PG[Z_] = {}, PG[Z_][PG[DW]] = CG[j_], PG[Z_][PG[f_]] = CG[t(f(53798, 53802), Tr)], PG[Z_][PG[i_]] = CG[g_], PG[Z_][PG[u_]] = CG[T_], PG[e(t(f(53802, 53811), Tr))]), PG[t(f(53811, 53814), Tr)] = a(f(53814, 54318)), PG[Eb] = a(f(54318, 54782)), PG[Xb] = CG[tM](PG[c(t(f(54782, 54793), Tr))]), PG[c(t(f(54793, 54804), Tr))] = CG[tM](PG[Eb]), CG[L_] = function(n, r, i) {
        return r === PG[Rv] ? i : CG[Gb](r[CG[nv]]())[CG[Jo]](function(r) {
            return r in n ? n[r] : i;
        })[CG[Zo]]();
    }, CG[H_] = function(n) {
        var r = [];
        return r[wo] = n[CG[KN]], r[Nb] = r[c(xu)], r[c(df)] = PG[t(f(54804, 54807), Tr)][r[wo]], r[Ru] = !!r[Au], r[c(Nv)] = !!n[CG[zN]], r[c(vf)] = r[yb] && !!n[CG[IN]], r[Iu] = r[yb] && CG[jb](n[CG[$N]]), r[Ru] && (r[Nb] |= CG[gv]), r[yb] && (r[Nb] |= CG[Lv]), CG[Gb]([
            r[Nb]
        ])[CG[ru]](function(i) {
            var t = [];
            r[yb] && (t[wo] = CG[L_](PG[Ob], n[CG[zN]], PG[s_]), t[Au] = t[wo] & CG[Vv], r[Du] && (t[c(df)] |= CG[gv]), r[Iu] && (t[Au] |= CG[Lv]), i[CG[Cf]](t[Au]), r[Du] && (t[Ru] = CG[L_](PG[Xb], n[CG[IN]], PG[l_]), i[CG[Cf]](t[e(af)])));
        })[CG[Jo]](function(i) {
            var t = [];
            return r[Ru] ? (t[wo] = r[Au](n), (function(n, r) {
                return n || r ? r ? n ? n[CG[bf]](r) : r : n : [];
            })[so](void 0, i, t[wo])) : i;
        })[CG[ru]](function(i) {
            r[Iu] && i[CG[Cf]](n[CG[$N]] & CG[Xf]);
        })[CG[Jo]](function(n) {
            return CG[tw](n);
        })[CG[Zo]]();
    }, PG[c($p)] = CG[ko], CG[k_] = function(n) {
        var r = [];
        return n[CG[Vf]](CG[ko], n[CG[Kf]] - PG[d_]), (function(n) {
            var r = [];
            return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
        })[so](void 0, PG[jb]) + (function(n, r) {
            var i = [];
            i[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * r) - CG[Zf], n), i[Au] = PG[$o], i[Ru] = r * CG[Df];
            for(; i[wo] > CG[ko];)i[Au] = CG[$M](i[wo]) + i[Au], i[wo] = i[wo] >>> CG[wv];
            if (i[Ru]) for(; i[Au][CG[Kf]] < i[Ru];)i[Au] = CG[QM](CG[Io], i[Au]);
            return i[Au];
        })[so](void 0, n[CG[Kf]], CG[Df]) + (r[wo] = function(n) {
            return CG[H_](n);
        }, (function(n, r) {
            var i = [];
            i[wo] = [], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[c(df)]++)i[yb] = i[Ru][i[c(df)]], i[wo][CG[Cf]](r(i[yb]));
            return i[wo];
        })[so](void 0, n, r[wo]))[CG[jf]](CG[Wo]);
    }, PG[gb] = [
        CG[ko],
        CG[Xv],
        CG[xw],
        CG[wv],
        CG[Te]
    ], CG[e(t(f(54807, 54817), Tr))] = function(n) {
        var i = CG[Df];
        var r = [];
        r[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * i) - CG[Zf], n << CG[Le] | PG[il]), r[Au] = PG[$o], r[Ru] = i * CG[Df];
        for(; r[wo] > CG[ko];)r[Au] = CG[$M](r[wo]) + r[Au], r[wo] = r[e(xu)] >>> CG[wv];
        if (r[Ru]) for(; r[Au][CG[Kf]] < r[Ru];)r[Au] = CG[QM](CG[Io], r[Au]);
        return r[Au];
    }, CG[J_] = function(n, r, i, t) {
        return CG[Gb](CG[Df])[CG[Jo]](function(n) {
            return PG[El] << CG[Na] | n << CG[bv] | (function(n, r) {
                var i = [];
                i[c(xu)] = CG[ko], i[Au] = r && n[CG[Kf]] > r ? n[CG[iv]](CG[ko], r) : n, i[Ru] = i[Au][CG[Kf]], i[yb] = i[Ru] - CG[Zf];
                for(; i[yb] >= CG[ko]; i[yb]--)i[wo] |= (i[Au][i[yb]] ? CG[Zf] : CG[ko]) << i[Ru] - i[yb] - CG[Zf];
                return r && i[Ru] < r && (i[wo] = i[wo] << r - i[Ru]), i[wo];
            })[so](void 0, r, CG[bv]) & CG[ga];
        })[CG[Jo]](function(n) {
            return CG[QM]((function(n, r) {
                var i = [];
                i[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * r) - CG[Zf], n), i[Au] = PG[$o], i[Ru] = r * CG[Df];
                for(; i[wo] > CG[ko];)i[Au] = CG[$M](i[wo]) + i[Au], i[wo] = i[wo] >>> CG[wv];
                if (i[Ru]) for(; i[Au][CG[Kf]] < i[Ru];)i[Au] = CG[QM](CG[Io], i[Au]);
                return i[Au];
            })[so](void 0, n, CG[yv]), CG[yw](i), CG[tw](t), (function(n) {
                var r = [];
                return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
            })[so](void 0, t[CG[Kf]]));
        })[CG[Zo]]();
    }, CG[W_] = function(n, r) {
        var o = (n & d(c(t(f(54817, 54827), Tr)))) << CG[re] | r & CG[Dl];
        var u = CG[Df];
        var i = [];
        i[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * u) - CG[Zf], o), i[Au] = PG[$o], i[Ru] = u * CG[Df];
        for(; i[wo] > CG[ko];)i[Au] = CG[$M](i[wo]) + i[Au], i[wo] = i[wo] >>> CG[wv];
        if (i[Ru]) for(; i[Au][CG[Kf]] < i[Ru];)i[Au] = CG[QM](CG[Io], i[Au]);
        return i[Au];
    }, CG[__] = function() {
        var n = [];
        return n[wo] = CG[nj](), n[Au] = CG[jT](function() {
            var n = [];
            return n[wo] = CG[$X](!1), (n[wo] || [])[CG[td]](function(n) {
                return Number[CG[rd]](n) ? n : null;
            });
        }), n[Au] ? (Array[CG[Mf]][CG[Cf]][CG[$v]](n[wo], n[Au]), n[wo]) : n[wo];
    }, PG[Tb] = d(t(f(54827, 54838), Tr)), CG[G_] = function(n) {
        var r = [];
        return (r[wo] = function(r, i, t) {
            return r[CG[Cf]](CG[W_](PG[gb][t], n[t][CG[Kf]])), CG[Vp](r, n[t]);
        }, (function(n, r, i) {
            var t = [];
            t[wo] = i, t[Au] = CG[ko], t[Ru] = CG[ko], t[yb] = n;
            for(; t[Ru] < t[c(Nv)][CG[Kf]]; t[Ru]++)t[Du] = t[c(Nv)][t[Ru]], t[wo] = r(t[c(xu)], t[Du], t[Au]), t[c(df)]++;
            return t[wo];
        })[so](void 0, n, r[wo], []))[CG[jf]](PG[$o]);
    }, CG[x_] = function(n, i, o) {
        var u = [];
        var v = [];
        return (function(n) {
            PG[Hu] || (CG[lJ](n, PG[Ih]), CG[yJ](n, PG[dy]), CG[fJ](n, PG[Ny]), PG[Hu] = !0);
        })[so](void e(xu), n), v[wo] = CG[k_](CG[E_]()), v[c(df)] = CG[$M](CG[BM](PG[Uv] + CG[Zf])), v[c(af)] = CG[Gb](CG[_w]())[CG[Jo]](function(n) {
            return CG[Mw](CG[Nw](n), CG[nw](n % CG[kv], CG[Df]), (function() {
                return PG[Xe][CG[Sv]] || (PG[Xe][CG[e(mw)]] = CG[BM](CG[bv])), PG[Xe][CG[e(mw)]];
            })[so](void 0));
        })[CG[Zo]](), v[yb] = CG[t(f(54838, 54842), Tr)](PG[gb][CG[Kf]]), v[Du] = [
            CG[yW](),
            CG[NW](),
            CG[mW](),
            CG[bW](),
            CG[pW]()
        ], u[Iu] = function(r) {
            var i = [];
            return i[wo] = CG[MW](CG[$j](o, CG[Bw](n))), i[Au] = CG[wW](CG[Kj]()), r[CG[yv]] = r[CG[yv]][CG[bf]](i[wo], i[Au]), r;
        }, v[Iu] = CG[J_](n, CG[VX](), CG[__](), CG[kj]()), CG[Gb](CG[Gb](CG[Hw](PG[Oe]()))[CG[e(Tj)]](function(n) {
            return CG[Mw](CG[Nw](n), CG[nw](n % CG[kv], CG[Df]));
        })[CG[Zo]]())[CG[Jo]](function(n) {
            return [
                n,
                v[c(xu)]
            ];
        })[CG[Jo]](function(n) {
            var o = [];
            var d = [];
            return d[wo] = n[CG[ko]], d[Au] = n[CG[Zf]], CG[QM](v[Ru], v[yb], CG[Wj](!0), i, (o[wo] = CG[QM](d[wo], CG[e(t(f(54842, 54852), Tr))](CG[QM](CG[G_](u[Iu](v[Du])), CG[nw](v[wo][CG[Kf]] / CG[Df], CG[Df]), d[Au], v[Iu], CG[$M](CG[Xf])), d[wo], CG[Xv], CG[eM](d[c(xu)], CG[yv]))), o[Au] = CG[eM](i, CG[Te]), CG[cw](o[wo], CG[1001](i[CG[iv]](CG[ko], CG[wv]), r(o[Au], CG[bv])))));
        })[CG[Jo]](function(n) {
            return CG[Gb](CG[iw](n))[CG[Jo]](function(n) {
                var r = [];
                return [
                    n[CG[Kf]],
                    (r[wo] = y(n, [
                        PG[Dv],
                        PG[qv],
                        PG[Tb],
                        PG[zv]
                    ]), (function(n) {
                        var r = [];
                        r[wo] = [], r[c(df)] = CG[ko];
                        for(; r[Au] < n[CG[Kf]]; r[Au]++)r[Ru] = n[r[Au]] >>> CG[ko], r[wo][CG[Cf]](r[Ru] & CG[Xf], r[Ru] >> CG[wv] & CG[Xf], r[Ru] >> CG[bv] & CG[Xf], r[Ru] >> CG[Ev] & CG[Xf]);
                        return r[wo];
                    })[so](void 0, r[wo]))
                ];
            })[CG[Jo]](function(n) {
                return CG[QM](PG[Fl], (function(n) {
                    var r = [];
                    return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
                })[so](void 0, n[CG[Zf]][CG[Kf]] - n[CG[ko]]), CG[tw](n[CG[Zf]]));
            })[CG[Zo]]();
        })[CG[Jo]](function(r) {
            var t = CG[rw](CG[QM](v[Au], CG[cw](CG[QM](r, (function(n) {
                var r = [];
                return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
            })[so](void 0, r[CG[Kf]])), v[Au])));
            var i = [];
            return i[wo] = CG[Rj](n, t), null == i[wo] ? null : i[wo][CG[tv]](/\+/g, CG[su])[CG[tv]](/\//g, CG[ru])[CG[tv]](/=+$/, CG[Wo]);
        })[CG[Jo]](function(r) {
            var i = [];
            return PG[Xl][CG[Ja]] ? r + CG[Ro] + (i[wo] = CG[Bw](n), (function(n, r, i) {
                var t = [];
                return t[wo] = CG[$j](r, i), t[Au] = CG[bM]([
                    t[wo]
                ]), CG[Uj](n, t[Au]);
            })[so](void 0, n, o, i[wo])) : r;
        })[CG[Zo]]();
    }, CG[R_] = function() {
        return PG[Zb];
    }, CG[t(f(54852, 54856), Tr)] = function(n) {
        n && /\S+\.\S{2,}$/[CG[ie]](n) && (PG[Zb] = n);
    }, PG[Lb] = {}, PG[Hb] = [], CG[t(f(54856, 54860), Tr)] = function(n, r, i, t) {
        (function(n, r, i, t) {
            var o = [];
            try {
                o[wo] = n[PG[we]], o[wo] || t(), o[wo][CG[Wv]](r, i), o[wo][CG[_v]](r) !== i && (o[wo][CG[Gv]](r), t());
            } catch (n) {
                t();
            }
        })[so](void 0, n, r, i, t || CG[Fb]);
    }, CG[U_] = function(n, r, i, t) {
        var o = [];
        var u = [];
        u[wo] = CG[ko], u[c(df)] = CG[R_]() || CG[Db](n)[CG[SN]], u[Ru] = u[Au][CG[Yf]](CG[Ro]), u[yb] = u[Ru][CG[Kf]] === CG[Zf];
        for(; u[e(xu)] < u[Ru][CG[Kf]] - CG[Zf] || u[yb];)u[c(vf)] = u[Ru][CG[iv]](-CG[Zf] - ++u[wo])[CG[jf]](CG[Ro]), u[Iu] = u[c(vf)] ? l(S_)[CG[bf]](u[Du], CG[Mu]) : PG[$o], o[Du] = l(I_)[CG[bf]](t, CG[Mu])[CG[bf]](u[Iu]), (function(n, r, i, t) {
            var o = [];
            o[wo] = CG[Sb](n);
            try {
                o[wo][CG[If]] = CG[Wo][CG[bf]](r, CG[Go])[CG[bf]](i, l(Mp))[CG[bf]](t)[CG[bf]](l(wp));
            } catch (n) {}
        })[so](void 0, n, r, i, o[Du]), u[yb] = !1;
    }, CG[B_] = function(n, r, i) {
        var t = [];
        t[wo] = CG[Gj](), t[Au] = CG[Wo][CG[bf]](CG[Ww](t[wo][CG[La]][CG[xa]])), (function(n, r, i, t) {
            var o = [];
            o[wo] = CG[ko], o[c(df)] = CG[R_]() || CG[Db](n)[CG[SN]], o[Ru] = o[Au][CG[Yf]](CG[Ro]), o[yb] = o[Ru][CG[Kf]] === CG[Zf];
            for(; o[wo] < o[Ru][CG[Kf]] - CG[Zf] || o[yb];)o[c(vf)] = o[Ru][CG[iv]](-CG[Zf] - ++o[wo])[CG[jf]](CG[Ro]), o[Iu] = o[c(vf)] ? l(S_)[CG[bf]](o[Du], CG[Mu]) : PG[$o], CG[pp](n, r, i, l(I_)[CG[bf]](t, CG[Mu])[CG[bf]](o[Iu])), o[yb] = !1;
        })[so](void 0, n, r, i, t[Au], void 0);
    }, CG[D_] = function(n, r) {
        return (function(n, r) {
            var i = [];
            try {
                return i[wo] = n[PG[we]], i[wo] ? i[wo][CG[_v]](r) : PG[c(Ec)];
            } catch (n) {
                return PG[Eu];
            }
        })[so](void 0, n, r) || (function(n, r) {
            var i = [];
            i[wo] = CG[Sb](n);
            try {
                return (i[wo][CG[If]][CG[Bf]](l(Fp)[CG[bf]](r, l(Ep))) || CG[ko])[CG[Df]];
            } catch (n) {
                return null;
            }
        })[so](void 0, n, r);
    }, CG[t(f(54860, 54864), Tr)] = function(n) {
        var i = [];
        i[wo] = CG[Gj](), i[Au] = CG[D_](n, i[wo][CG[La]][CG[Ha]]), (function(n) {
            return !!n && RegExp(s(NA)[CG[bf]](PG[c(mA)], s(bA))[CG[bf]](PG[_e], a(pA))[CG[bf]](PG[_e], a(MA))[CG[bf]](PG[_e], s(wA))[CG[bf]](PG[_e], a(AA)))[CG[ie]](n);
        })[so](void 0, i[Au]) || (i[Au] = (function(n) {
            var i = [];
            if (n[PG[Re]]) {
                if (n[PG[Re]][PG[Ue]] && n[PG[Re]][PG[xe]]) return CG[sA](n);
                n[PG[Re]][PG[Ge]] && (i[wo] = CG[lA](n));
            }
            return i[wo] || (i[wo] = CG[aA]()[CG[Yf]](PG[$o])), i[wo][CG[Cv]] = CG[Vo], i[wo][CG[bv]] = CG[YM](r(i[wo][CG[bv]], CG[bv]) & CG[yv] | CG[wv]), i[wo][CG[jf]](PG[$o]);
        })[so](void 0, n)), CG[q_](n, {
            Ho: i[Au]
        }), PG[ku] = !0;
    }, CG[t(f(54864, 54868), Tr)] = function() {
        return PG[Ju];
    }, CG[2240] = function(n, r, i) {
        PG[e(z_)][CG[Cf]]([
            r,
            i
        ]);
    }, CG[t(f(54868, 54872), Tr)] = function(n) {
        var r = [];
        if (r[wo] = CG[Gj](), !r[wo][CG[Za]]) throw Error(PG[yl]);
        if (PG[e(xZ)]) {
            PG[Ju] = !0, r[Au] = PG[c(z_)][CG[Kf]], r[Ru] = CG[ko];
            for(; r[Ru] < r[Au]; r[Ru]++)CG[$_](n, PG[Hb][r[Ru]][CG[Zf]]), r[yb] = CG[e(t(f(54872, 54883), Tr))]()[CG[bm]], PG[Hb][r[Ru]][CG[ko]](r[yb]);
            PG[Hb][CG[Kf]] = CG[ko];
        }
    }, CG[K_] = function() {
        return PG[Lb][PG[fl]];
    }, CG[t(f(54883, 54887), Tr)] = function(n) {
        PG[Lb][PG[fl]] = n;
    }, CG[q_] = function(n, r) {
        var i = [];
        var t = [];
        (function(n) {
            PG[Lb][PG[fl]] = n;
        })[so](void 0, r), t[c(xu)] = CG[Gj](), t[wo][CG[Ua]] ? (i[Au] = function() {
            return CG[B_](n, t[wo][CG[La]][CG[Ha]], r[CG[pm]]);
        }, (function(n, r, i, t) {
            CG[gw](n, r, i, t || CG[Fb]);
        })[so](void 0, n, t[wo][CG[La]][CG[Ha]], r[CG[pm]], i[Au])) : ((function(n, r, i) {
            var t = [];
            t[wo] = CG[Gj](), t[Au] = CG[Wo][CG[bf]](CG[Ww](t[wo][CG[La]][CG[xa]])), CG[U_](n, r, i, t[Au]);
        })[so](void 0, n, t[wo][CG[La]][CG[Ha]], r[CG[pm]]), (function(n, r, i, t) {
            CG[gw](n, r, i, t || CG[Fb]);
        })[so](void 0, n, t[wo][CG[La]][CG[Ha]], r[CG[pm]], void 0));
    }, CG[V_] = function(n, i) {
        return PG[Lb][PG[fl]] || CG[C_](n, (function(n) {
            var i = [];
            if (n[PG[Re]]) {
                if (n[PG[Re]][PG[Ue]] && n[PG[Re]][PG[xe]]) return CG[sA](n);
                n[PG[Re]][PG[Ge]] && (i[wo] = CG[lA](n));
            }
            return i[wo] || (i[wo] = CG[aA]()[CG[Yf]](PG[$o])), i[wo][CG[Cv]] = CG[Vo], i[wo][CG[bv]] = CG[YM](r(i[wo][CG[bv]], CG[bv]) & CG[yv] | CG[wv]), i[wo][CG[jf]](PG[$o]);
        })[so](void 0, n), i);
    }, CG[t(f(54887, 54891), Tr)] = function(n, r) {
        var i = [];
        return PG[c(xZ)] ? (i[wo] = n, CG[K_]() || CG[C_](i[wo], CG[hA](i[e(xu)]), r))[CG[bm]] : PG[Rv];
    }, CG[C_] = function(n, r, i) {
        var t = [];
        return t[wo] = CG[Gj]()[CG[Za]] ? CG[x_](n, r, i) : PG[$o], CG[Gb]({
            Ho: r,
            Bo: t[wo]
        })[CG[ru]](function(n) {
            PG[Lb][PG[fl]] = n;
        })[CG[Zo]]();
    }, CG[$_] = function(n, r) {
        return CG[Gb](PG[Lb][PG[fl]])[CG[Jo]](function(i) {
            return i ? CG[C_](n, i[CG[pm]], r) : PG[Rv];
        })[CG[Zo]]();
    }, CG[t(f(54891, 54895), Tr)] = function(n) {
        CG[RO](n, PG[fd], PG[sd]), (function(n) {
            PG[Xu] || (PG[Xu] = new PG[Ia], PG[Xu][CG[Id]](n));
        })[so](void 0, n);
    }, CG[P_] = function(n) {
        var r = [];
        var i = [];
        i[wo] = CG[Mm], i[Ru] = [], r[yb] = function() {
            var n = [];
            for(; i[Ru][CG[Kf]];)n[wo] = i[Ru][CG[Ac]](), (function(n) {
                var r = [];
                if (i[c(xu)] !== CG[Mm]) try {
                    r[wo] = void CG[ko], i[wo] === CG[Lu] ? r[wo] = n[CG[wm]] ? n[CG[wm]](i[c(df)]) : i[Au] : r[wo] = n[CG[Am]] ? n[CG[Am]](i[Au]) : i[Au], r[wo] && CG[Lp](r[wo][CG[Pc]]) ? r[wo][CG[Pc]](n[CG[Fm]], n[CG[Em]]) : n[CG[Fm]](r[wo]);
                } catch (r) {
                    n[CG[e(Q_)]](r);
                }
                else i[Ru][CG[Cf]](n);
            })[so](void 0, n[wo]);
        }, r[Du] = function(n) {
            var r = [];
            if (i[c(xu)] !== CG[Mm]) try {
                r[wo] = void CG[ko], i[wo] === CG[Lu] ? r[wo] = n[CG[wm]] ? n[CG[wm]](i[c(df)]) : i[Au] : r[wo] = n[CG[Am]] ? n[CG[Am]](i[Au]) : i[Au], r[wo] && (function(n) {
                    return typeof n === CG[zf];
                })[so](void 0, r[wo][CG[Pc]]) ? r[wo][CG[Pc]](n[CG[Fm]], n[CG[Em]]) : n[CG[Fm]](r[wo]);
            } catch (r) {
                n[CG[Em]](r);
            }
            else i[Ru][CG[e(Ip)]](n);
        }, r[Iu] = function(n) {
            i[wo] === CG[Mm] && (i[wo] = CG[Lu], i[Au] = n, (function() {
                for(; i[Ru][CG[Kf]];)r[Du](i[Ru][CG[Ac]]());
            })[so](void 0));
        }, r[Nb] = function(n) {
            i[wo] === CG[Mm] && (i[wo] = s(Y_), i[Au] = n, (function() {
                for(; i[Ru][CG[Kf]];)r[Du](i[Ru][CG[Ac]]());
            })[so](void 0));
        }, r[mb] = function(n, i) {
            var t = [];
            return t[wo] = CG[P_](function() {}), r[Du]({
                qo: n,
                Ko: i,
                resolve: t[wo][CG[Fm]],
                reject: t[wo][CG[e(Q_)]]
            }), t[wo];
        }, r[Su] = function(n) {
            return r[mb](void 0, n);
        }, r[hf] = function(n) {
            return r[mb](function(r) {
                return n && n(), r;
            }, function(r) {
                throw n && n(), r;
            });
        };
        try {
            n(r[Iu], r[Nb]);
        } catch (n) {
            (function(n) {
                i[wo] === CG[Mm] && (i[wo] = s(Y_), i[Au] = n, r[yb]());
            })[so](void 0, n);
        }
        return {
            then: r[mb],
            catch: r[Su],
            finally: r[hf],
            resolve: r[Iu],
            reject: r[Nb]
        };
    }, CG[t(f(54895, 54899), Tr)] = function(n, r) {
        return CG[QA](n) ? new n[CG[Fe]](r) : CG[P_](r);
    }, CG[nG] = function(n, r) {
        var i = n;
        var t = function(n) {
            return n(r);
        };
        return CG[QA](i) ? new i[CG[Fe]](t) : CG[P_](t);
    }, PG[kb] = l(f(54899, 54947)), PG[Jb] = l(f(54947, 54991)), PG[Wb] = CG[Jf], CG[rG] = function(n, r) {
        var i = [];
        var t = [];
        if (typeof FormData == typeof PG[Rv]) return {};
        t[wo] = new FormData(r), t[Au] = {}, t[Ru] = CG[ko], t[c(Nv)] = r[CG[Zh]](CG[Lo][CG[bf]](PG[kb], CG[Ho]));
        for(; t[Ru] < t[yb][CG[Kf]]; t[Ru]++)t[Du] = t[yb][t[Ru]], t[Iu] = CG[Wu](t[Du], PG[kb]), t[Nb] = CG[Wu](t[c(vf)], PG[Wb]), t[mb] = t[c(xu)][CG[cd]](t[e(Tf)]), i[Du] = t[mb], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, i[Du]) && (t[Au][t[Iu]] = PG[$o] + t[mb]);
        return {
            name: (function(n, r) {
                if (n[CG[Gf]]) return n[CG[e(bb)]](r);
            })[so](void 0, r, PG[Jb]),
            values: t[Au]
        };
    }, CG[iG] = function(n, r, i) {
        var t = [];
        return t[Au] = null, t[c(xu)] = void 0, function() {
            var o = [];
            var u = [];
            u[c(xu)] = [], u[Au] = CG[ko];
            for(; u[Au] < arguments[CG[Kf]]; u[Au]++)u[e(xu)][u[Au]] = arguments[u[Au]];
            return o[Ru] = function() {
                if (t[Au] = null, !i) return t[wo] = n[CG[$v]](null, u[wo]), t[wo];
            }, null != t[Au] && clearTimeout(t[Au]), i ? t[wo] = n[CG[$v]](null, u[wo]) : t[Au] = setTimeout(o[Ru], r), t[wo];
        };
    }, PG[_b] = a(f(54991, 55003)), PG[Gb] = l(f(55003, 55043)), PG[xb] = CG[Xv], PG[tG] = CG[Zs], CG[t(f(55043, 55047), Tr)] = function() {
        var n = [];
        try {
            if (typeof XMLHttpRequest == typeof PG[Rv]) return;
            if (n[wo] = new XMLHttpRequest, PG[Gb] in n[wo]) return n[wo];
        } catch (n) {}
    }, CG[t(f(55047, 55051), Tr)] = function(n, r, i) {
        var t = [];
        if (i[CG[Om]] && (clearTimeout(i[CG[Om]]), i[CG[Om]] = PG[Rv]), (function(n) {
            return n === PG[Rv];
        })[so](void 0, i[CG[Xm]])) {
            t[wo] = n[CG[Kf]], t[Au] = CG[ko];
            for(; t[Au] < t[wo]; t[Au]++)n[t[Au]](r);
        }
        i[CG[Xm]] = r;
    }, CG[oG] = function(n, r) {
        n[CG[jm]](r);
    }, PG[c(uG)] = CG[iG](CG[oG], PG[tG]), PG[Sb] = s(f(55051, 55127)), PG[Ib] = l(f(55127, 55139)), CG[fG] = function(n, r$jscomp$0, i$jscomp$0, o, u, v) {
        var d = [];
        if (d[wo] = CG[e(t(f(55139, 55146), Tr))](), d[wo] && d[wo][CG[gm]]) {
            d[wo][CG[rN]](PG[_b], r$jscomp$0, !0), d[c(df)] = {
                zo: PG[Rv],
                Uo: PG[Rv]
            }, d[Ru] = [], d[wo][CG[gm]](a(f(55146, 55178)), CG[Qy][CG[bf]](PG[Ib])), d[wo][CG[gm]](PG[Sb], i$jscomp$0), d[wo][a(f(55178, 55226))] = function() {
                var n = [];
                var r = [];
                d[wo][CG[Os]] === PG[xb] && (r[wo] = d[wo][CG[ls]], r[wo] >= CG[_e] && r[c(xu)] < CG[Hl] ? (function(n, r, i) {
                    var t = [];
                    if (i[CG[Om]] && (clearTimeout(i[CG[Om]]), i[CG[Om]] = PG[Rv]), CG[Xb](i[CG[Xm]])) {
                        t[wo] = n[CG[Kf]], t[Au] = CG[ko];
                        for(; t[Au] < t[e(xu)]; t[Au]++)n[t[Au]](r);
                    }
                    i[CG[Xm]] = r;
                })[so](void 0, d[Ru], !0, d[Au]) : (n[Au] = d[c(df)], (function(n, r, i) {
                    var t = [];
                    if (i[CG[Om]] && (clearTimeout(i[CG[Om]]), i[CG[Om]] = PG[Rv]), CG[Xb](i[CG[Xm]])) {
                        t[wo] = n[CG[Kf]], t[Au] = CG[ko];
                        for(; t[Au] < t[wo]; t[Au]++)n[t[Au]](r);
                    }
                    i[CG[Xm]] = r;
                })[so](void 0, d[Ru], !1, n[Au])));
            }, o(function(n) {
                d[c(df)][CG[Om]] = setTimeout(function() {
                    (function(n, r, i) {
                        var t = [];
                        if (i[CG[Om]] && (clearTimeout(i[CG[Om]]), i[CG[Om]] = PG[Rv]), CG[Xb](i[CG[Xm]])) {
                            t[wo] = n[CG[Kf]], t[Au] = CG[ko];
                            for(; t[e(df)] < t[wo]; t[Au]++)n[t[Au]](r);
                        }
                        i[CG[Xm]] = r;
                    })[so](void 0, d[Ru], PG[Eu], d[Au]), d[c(xu)][s(f(55226, 55242))]();
                }, v), u(d[wo], JSON[a(pM)](n));
            });
            var r = n;
            var i = function(n) {
                d[Au][CG[Xm]] !== PG[Rv] ? n(d[Au][CG[Xm]]) : d[Ru][CG[Cf]](n);
            };
            return CG[QA](r) ? new r[CG[Fe]](i) : CG[P_](i);
        }
        return CG[nG](n, !1);
    }, PG[Db] = CG[ko], PG[qb] = CG[Zf], PG[$b] = CG[Df], PG[Kb] = CG[Xv], PG[Cb] = CG[re], PG[Qb] = CG[yv], CG[vG] = function(n) {
        return typeof n === l(Jp) ? n : JSON[a(pM)](n);
    }, CG[eG] = function(n, r, i, t, o, u) {
        return (function(n, r, i, t, o, u) {
            var f = [];
            f[wo] = [], f[Au] = u ? CG[vA] : CG[fA], f[Ru] = PG[xv];
            for(; f[Ru] < i[CG[Kf]]; f[Ru]++)if (f[yb] = i[f[Ru]], f[Du] = CG[_p](t, f[yb]) >= PG[c(SM)], f[Iu] = CG[_p](o, f[yb]) >= PG[xv], f[Nb] = CG[Zb](r, f[c(Nv)]) && CG[Eb](r[f[yb]]), f[Nb] || f[Du]) {
                if (f[mb] = void CG[ko], f[Du]) {
                    if (f[Su] = f[Nb] ? r[f[yb]] : f[c(of)] ? {} : PG[Rv], CG[Xb](f[Su])) continue;
                    f[hf] = CG[Cp](f[c(ef)]), f[To] = CG[Kp](f[e(Ze)])[CG[iv]](PG[xv], PG[c(KM)]), f[c(ge)] = CG[e(uJ)](f[To][CG[Kf]]), f[yf] = CG[ko], f[Nf] = f[To];
                    for(; f[yf] < f[Nf][CG[Kf]]; f[yf]++)f[mf] = f[Nf][f[yf]], f[mb] += CG[fA](CG[vG](f[mf]), PG[Rv]), f[mb] += CG[fA](CG[vG](f[hf][f[mf]]), PG[c(IE)]);
                } else f[mb] = f[Au](CG[vG](r[f[yb]]), PG[c(IE)]);
                f[wo][CG[Cf]](CG[$M](f[Ru]) + f[mb]);
            }
            return CG[QM](CG[$M](n), CG[$M](f[wo][CG[Kf]]), f[wo][CG[jf]](PG[$o]));
        })[so](void 0, r, i, t, o, o, u) + (function(n, r) {
            var i = [];
            i[wo] = CG[gM](CG[XM](CG[Df], CG[wv] * r) - CG[Zf], n), i[Au] = PG[$o], i[Ru] = r * CG[Df];
            for(; i[wo] > CG[ko];)i[Au] = CG[$M](i[wo]) + i[Au], i[wo] = i[wo] >>> CG[wv];
            if (i[Ru]) for(; i[Au][CG[Kf]] < i[Ru];)i[Au] = CG[QM](CG[Io], i[Au]);
            return i[Au];
        })[so](void 0, n[CG[Kf]], PG[Qb]) + CG[PM](n);
    }, CG[cG] = function(n, r, i, t, o, u) {
        var f = [];
        var v = [];
        v[wo] = [], v[Au] = u ? CG[vA] : CG[fA], v[Ru] = PG[e(SM)];
        for(; v[e(af)] < i[CG[Kf]]; v[Ru]++)if (v[yb] = i[v[Ru]], v[Du] = CG[_p](t, v[yb]) >= PG[c(SM)], v[Iu] = CG[_p](o, v[yb]) >= PG[xv], v[Nb] = CG[Zb](r, v[c(Nv)]) && CG[Eb](r[v[yb]]), v[Nb] || v[Du]) {
            if (v[mb] = void CG[ko], v[Du]) {
                if (v[Su] = v[Nb] ? r[v[yb]] : v[c(of)] ? {} : PG[Rv], (function(n) {
                    return n === PG[Rv];
                })[so](void 0, v[Su])) continue;
                v[hf] = CG[Cp](v[c(ef)]), v[To] = CG[Kp](v[hf])[CG[iv]](PG[xv], PG[c(KM)]), v[c(ge)] = (function(n) {
                    var r = [];
                    return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
                })[so](void 0, v[To][CG[Kf]]), v[yf] = CG[ko], v[Nf] = v[To];
                for(; v[yf] < v[Nf][CG[Kf]]; v[yf]++)v[mf] = v[Nf][v[yf]], v[mb] += CG[fA]((f[mf] = v[mf], (function(n) {
                    return CG[kp](n) ? n : CG[bM](n);
                })[so](void 0, f[mf])), PG[Rv]), v[mb] += CG[fA]((f[bf] = v[hf][v[mf]], (function(n) {
                    return CG[kp](n) ? n : CG[bM](n);
                })[so](void 0, f[bf])), PG[c(IE)]);
            } else v[mb] = v[Au]((f[e(uf)] = r[v[yb]], (function(n) {
                return CG[kp](n) ? n : CG[bM](n);
            })[so](void 0, f[Zo])), PG[c(IE)]);
            v[wo][CG[Cf]]((function(n) {
                var r = [];
                return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
            })[so](void 0, v[Ru]) + v[mb]);
        }
        return CG[QM]((function(n) {
            var r = [];
            return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
        })[so](void 0, n), (function(n) {
            var r = [];
            return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
        })[so](void 0, v[wo][CG[Kf]]), v[wo][CG[jf]](PG[$o]));
    }, PG[c(t(f(55242, 55252), Tr))] = CG[uN], PG[ip] = l(f(55252, 55268)), PG[tp] = l(f(55268, 55284)), PG[op] = s(f(55284, 55320)), PG[up] = a(f(55320, 55336)), PG[vp] = s(f(55336, 55356)), PG[cp] = CG[Jf], CG[dG] = function(n) {
        var i = PG[Db];
        var t = n;
        var o = [
            PG[np],
            PG[c(aG)],
            PG[tp],
            PG[op],
            PG[up],
            PG[Wu],
            PG[cp],
            PG[vp]
        ];
        var u = PG[Ko];
        var r = [];
        r[wo] = [], r[Au] = CG[fA], r[Ru] = PG[xv];
        for(; r[Ru] < o[CG[Kf]]; r[Ru]++)if (r[e(Nv)] = o[r[Ru]], r[Du] = CG[_p]([
            PG[up],
            PG[vp]
        ], r[yb]) >= PG[c(SM)], r[Iu] = CG[_p](u, r[yb]) >= PG[xv], r[Nb] = CG[Zb](t, r[c(Nv)]) && CG[Eb](t[r[yb]]), r[Nb] || r[e(vf)]) {
            if (r[mb] = void CG[ko], r[Du]) {
                if (r[Su] = r[Nb] ? t[r[yb]] : r[c(of)] ? {} : PG[Rv], CG[Xb](r[Su])) continue;
                r[hf] = CG[Cp](r[c(ef)]), r[To] = CG[Kp](r[hf])[CG[iv]](PG[xv], PG[c(KM)]), r[c(ge)] = CG[$M](r[To][CG[Kf]]), r[yf] = CG[ko], r[Nf] = r[To];
                for(; r[yf] < r[Nf][CG[Kf]]; r[yf]++)r[mf] = r[Nf][r[yf]], r[mb] += CG[fA](CG[vG](r[mf]), PG[Rv]), r[mb] += CG[fA](CG[vG](r[hf][r[mf]]), PG[c(IE)]);
            } else r[mb] = r[e(df)](CG[vG](t[r[yb]]), PG[c(IE)]);
            r[wo][CG[Cf]](CG[$M](r[Ru]) + r[mb]);
        }
        return CG[QM](CG[$M](i), CG[$M](r[wo][CG[Kf]]), r[wo][CG[jf]](PG[$o]));
    }, PG[dp] = a(f(55356, 55364)), CG[lG] = function(n) {
        var i = PG[Kb];
        var t = n;
        var o = [
            PG[dp]
        ];
        var u = PG[c(HX)];
        var f = PG[Ko];
        var r = [];
        r[wo] = [], r[Au] = CG[vA], r[Ru] = PG[xv];
        for(; r[Ru] < o[CG[Kf]]; r[Ru]++)if (r[yb] = o[r[Ru]], r[Du] = CG[_p](u, r[yb]) >= PG[c(SM)], r[Iu] = CG[_p](f, r[yb]) >= PG[xv], r[Nb] = CG[Zb](t, r[c(Nv)]) && CG[Eb](t[r[yb]]), r[Nb] || r[Du]) {
            if (r[mb] = void CG[ko], r[Du]) {
                if (r[Su] = r[Nb] ? t[r[yb]] : r[c(of)] ? {} : PG[Rv], CG[Xb](r[Su])) continue;
                r[hf] = CG[Cp](r[c(e(Av))]), r[To] = CG[Kp](r[hf])[CG[iv]](PG[xv], PG[c(KM)]), r[c(ge)] = CG[$M](r[To][CG[Kf]]), r[yf] = CG[ko], r[Nf] = r[To];
                for(; r[yf] < r[Nf][CG[e(Nl)]]; r[yf]++)r[mf] = r[Nf][r[yf]], r[mb] += CG[fA](CG[vG](r[mf]), PG[Rv]), r[mb] += CG[fA](CG[vG](r[hf][r[mf]]), PG[c(IE)]);
            } else r[mb] = r[Au](CG[vG](t[r[yb]]), PG[c(IE)]);
            r[wo][CG[Cf]](CG[$M](r[Ru]) + r[mb]);
        }
        return CG[QM](CG[$M](i), CG[$M](r[wo][CG[Kf]]), r[wo][CG[e(is)]](PG[$o]));
    }, PG[lp] = CG[yv], CG[sG] = function(n, i, t, o) {
        var u = [];
        return u[wo] = CG[$M](CG[BM](PG[c(KM)] + CG[Zf])), u[Au] = CG[pw](CG[Nw](CG[Jw]())), CG[Gb](o)[CG[Jo]](function(n) {
            return CG[QM](t, (function(n) {
                var r = [];
                return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
            })[so](void 0, n[CG[Kf]]), n[CG[jf]](PG[$o]));
        })[CG[Jo]](function(n) {
            var i = CG[QM](n, (function(n) {
                var r = [];
                return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
            })[so](void 0, n[CG[Kf]] & PG[Uv]));
            var t = u[Au];
            var o = CG[eM](u[Au], CG[yv]);
            return CG[cw](i, CG[1001](t[CG[iv]](CG[ko], CG[Xv]), r(o, CG[bv])));
        })[CG[Jo]](function(n) {
            var t = [];
            return t[wo] = CG[QM](u[Au], n), t[Au] = CG[VM](i[CG[iv]](CG[yv])), t[Ru] = CG[VM](i[CG[Cv]]), CG[cw](t[wo], CG[1001](t[Au][CG[iv]](CG[ko], CG[wv]), r(t[Ru], CG[bv])));
        })[CG[Jo]](function(n) {
            return CG[cw](CG[QM]((function(n) {
                var r = [];
                return r[wo] = (n & PG[c(KM)])[CG[Fu]](CG[bv]), (CG[Io] + r[wo])[CG[iv]](-CG[Df]);
            })[so](void 0, (PG[lp] & CG[Mv]) << CG[Xv]), n), u[wo]);
        })[CG[Jo]](function(r) {
            var t = CG[rw](CG[QM](u[wo], r));
            var i = [];
            return i[wo] = CG[Rj](n, t), null == i[wo] ? null : i[wo][CG[tv]](/\+/g, CG[su])[CG[tv]](/\//g, CG[ru])[CG[tv]](/=+$/, CG[Wo]);
        })[CG[Zo]]();
    }, PG[sp] = CG[Tm], PG[yp] = CG[Jf], PG[pp] = CG[Zm], CG[hG] = function(n, r, i, t) {
        var o = [];
        return CG[sG](n, r, t[CG[Lm]] ? CG[cG](PG[Kb], {
            jwt: t[CG[Lm]]
        }, [
            PG[dp]
        ], PG[c(HX)], PG[Ko], !0) : (function(n) {
            return CG[cG](PG[Db], n, [
                PG[np],
                PG[c(aG)],
                PG[tp],
                PG[op],
                PG[up],
                PG[Wu],
                PG[cp],
                PG[vp]
            ], [
                PG[up],
                PG[vp]
            ], PG[Ko], !1);
        })[so](void 0, t[CG[me]]), [
            (o[wo] = i, o[Au] = PG[Ko], (function(n, r, i, t, o, u) {
                return CG[cG](r, i, t, o, o, u) + CG[nw](n[CG[Kf]], PG[Qb]) + CG[PM](n);
            })[so](void 0, o[wo], PG[qb], t, [
                PG[yp],
                PG[sp],
                PG[pp]
            ], o[Au], !1))
        ]);
    }, CG[yG] = function(n, r, i) {
        var o = [];
        var u = [];
        if (u[wo] = CG[Gj](), !u[wo][CG[Za]]) throw Error(PG[c(t(f(55364, 55374), Tr))]);
        return o[wo] = i, CG[Ob](o[wo]) && o[wo] !== PG[Eu] && (o[Au] = i[CG[me]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, o[Au]) || (o[Ru] = i[CG[Lm]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, o[Ru]))) ? (u[c(df)] = CG[Zb](i, PG[sp]) ? i[PG[sp]] : CG[Db](n)[CG[Oh]], u[c(af)] = CG[Zb](i, PG[c(t(f(55374, 55384), Tr))]) ? i[PG[yp]] : CG[Sb](n)[s(f(55384, 55400))] || u[Au], u[yb] = CG[Zb](i, PG[pp]) ? i[PG[pp]] : CG[Sb](n)[CG[Zm]], o[mb] = function(t) {
            return r[CG[Pc]](function(r) {
                var o = [];
                o[wo] = CG[hG](n, u[e(xu)][CG[Za]], r, {
                    user: i[CG[me]],
                    userJwt: i[CG[Lm]],
                    name: u[Ru],
                    url: u[Au],
                    referrer: u[yb]
                }), t({
                    data: o[wo]
                });
            });
        }, CG[fG](n, u[wo][CG[Ou]], u[wo][CG[Za]], o[mb], PG[c(uG)], u[wo][CG[Sa]])) : (u[wo][CG[Ra]] && (function(n, r, i) {
            CG[Tw](n, r, PG[Co] + i);
        })[so](void 0, n, PG[Fe], PG[ml]), CG[nG](n, !1));
    }, PG[c(t(f(55400, 55411), Tr))] = CG[Jf], PG[835] = CG[Pf], CG[NG] = function(n, r, i, t) {
        var o = [];
        return CG[sG](n, r, t[CG[Lm]] ? CG[cG](PG[Kb], {
            jwt: t[CG[Lm]]
        }, [
            PG[dp]
        ], PG[c(HX)], PG[Ko], !0) : (function(n) {
            return CG[cG](PG[Db], n, [
                PG[np],
                PG[c(aG)],
                PG[tp],
                PG[op],
                PG[up],
                PG[Wu],
                PG[cp],
                PG[vp]
            ], [
                PG[up],
                PG[vp]
            ], PG[Ko], !1);
        })[so](void 0, t[CG[me]]), [
            (o[wo] = i, o[Au] = [
                PG[835]
            ], (function(n, r, i, t, o, u) {
                return CG[cG](r, i, t, o, o, u) + CG[nw](n[CG[Kf]], PG[Qb]) + CG[PM](n);
            })[so](void 0, o[wo], PG[$b], t, [
                PG[Ap],
                PG[835]
            ], o[Au], !1))
        ]);
    }, PG[Op] = CG[ko], PG[gp] = CG[Zs], CG[mG] = function(n, r, i) {
        var t = [];
        var o = [];
        if (o[wo] = CG[Gj](), !o[wo][CG[Za]]) throw Error(PG[yl]);
        return t[wo] = i, CG[Ob](t[wo]) && t[wo] !== PG[Eu] && (t[Au] = i[CG[me]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, t[Au]) || (t[Ru] = i[CG[Lm]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, t[Ru]))) && (t[yb] = i[CG[Jf]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, t[yb])) ? (o[Au] = PG[Oe](), o[Au] - PG[Op] < PG[gp] ? CG[nG](n, !1) : (t[Nb] = function(t) {
            return r[CG[Pc]](function(r) {
                var u = [];
                u[wo] = CG[NG](n, o[wo][CG[Za]], r, i), t({
                    data: u[wo]
                });
            });
        }, PG[Op] = o[Au], CG[fG](n, o[wo][CG[Ou]], o[wo][CG[Za]], t[Nb], CG[oG], o[wo][CG[Sa]]))) : (o[wo][CG[Ra]] && (function(n, r, i) {
            CG[Tw](n, r, PG[Co] + i);
        })[so](void 0, n, PG[Fe], PG[ml]), CG[nG](n, !1));
    }, PG[c(Dw)] = CG[Jf], CG[t(f(55411, 55415), Tr)] = function(n) {
        return n[CG[Lm]] ? CG[cG](PG[Kb], {
            jwt: n[CG[Lm]]
        }, [
            PG[dp]
        ], PG[c(HX)], PG[Ko], !0) : (function(n) {
            return CG[cG](PG[Db], n, [
                PG[np],
                PG[c(aG)],
                PG[tp],
                PG[op],
                PG[up],
                PG[Wu],
                PG[cp],
                PG[vp]
            ], [
                PG[up],
                PG[vp]
            ], PG[Ko], !1);
        })[so](void 0, n[CG[me]]);
    }, CG[t(f(55415, 55419), Tr)] = function(n, r) {
        var i = n;
        var t = PG[c(bG)];
        var o = [
            PG[Lp],
            PG[c(pG)]
        ];
        var u = [
            PG[_u]
        ];
        return CG[cG](t, r, o, u, u, !1) + CG[nw](i[CG[Kf]], PG[Qb]) + CG[PM](i);
    }, CG[MG] = function(n, r, i, t) {
        var o = [];
        return CG[sG](n, r, (o[wo] = t, o[wo][CG[Lm]] ? CG[lG]({
            jwt: o[wo][CG[Lm]]
        }) : CG[dG](o[wo][CG[me]])), [
            CG[eG](i, PG[c(bG)], t, [
                PG[Lp],
                PG[c(pG)]
            ], [
                PG[_u]
            ], !1)
        ]);
    }, PG[Hp] = {}, CG[t(f(55419, 55423), Tr)] = function(n) {
        PG[kp] = n;
    }, CG[wG] = function(n) {
        var r = [];
        return r[wo] = PG[Hp][n], r[e(xu)][CG[Hm]] ? (r[Au] = r[wo][CG[e(t(f(55423, 55434), Tr))]] - PG[Oe](), r[Au] > CG[ko] ? r[Au] : CG[ko]) : CG[ko];
    }, CG[AG] = function(n, r) {
        return function(i) {
            var t = [];
            t[wo] = PG[Hp][n], t[c(xu)][CG[km]] = t[wo][CG[Ge]][CG[Vf]](CG[ko], PG[Al]), t[e(df)] = CG[Bp](t[wo][CG[km]], function(n) {
                var r = n[CG[bm]];
                var i = n[CG[Jm]];
                return CG[eG](r, PG[c(bG)], i, [
                    PG[Lp],
                    PG[c(pG)]
                ], [
                    PG[_u]
                ], !1);
            }), t[Ru] = CG[sG](PG[kp], r, n, t[Au]), i({
                data: t[Ru]
            });
        };
    }, CG[FG] = function(n) {
        var r = [];
        if (r[wo] = PG[Hp][n], r[wo][CG[Wm]]) {
            var r$jscomp$0 = PG[kp];
            var i = function(r) {
                setTimeout(function() {
                    CG[FG](n)[CG[Pc]](function(n) {
                        r(n);
                    });
                }, PG[wl]);
            };
            return CG[QA](r$jscomp$0) ? new r$jscomp$0[CG[Fe]](i) : CG[P_](i);
        }
        return r[wo][CG[_m]] ? CG[nG](PG[kp], r[wo][CG[Gm]]) : (r[wo][CG[Wm]] = !0, r[wo][CG[_m]] = !1, r[wo][CG[Gm]] = PG[Rv], r[c(df)] = CG[Gj](), CG[fG](PG[kp], r[c(df)][CG[Ou]], r[c(df)][CG[Za]], CG[AG](n, r[Au][CG[Za]]), CG[oG], r[e(df)][CG[Sa]])[CG[Pc]](function(n) {
            return r[c(xu)][CG[Wm]] = !1, r[wo][CG[_m]] = !0, r[wo][CG[Gm]] = n, n;
        }));
    }, CG[EG] = function(n) {
        var r = [];
        r[wo] = PG[Hp][n], r[Au] = CG[wG](n), r[c(df)] === CG[ko] && (r[c(xu)][CG[Hm]] = PG[Oe]() + PG[wl]);
        var i = PG[c(t(f(55434, 55445), Tr))];
        var o = function(i) {
            var t = [];
            t[wo] = function() {
                CG[FG](n)[CG[Pc]](function(n) {
                    r[wo][CG[km]][a(f(55445, 55453))](), r[wo][CG[km]][CG[Kf]] === CG[ko] && (r[wo][CG[_m]] = !1, r[wo][CG[Gm]] = PG[c(IE)], r[wo][CG[Wm]] = !1), i(n);
                });
            }, r[Au] === CG[ko] ? t[wo]() : setTimeout(function() {
                t[wo]();
            }, r[c(df)]);
        };
        return CG[QA](i) ? new i[CG[Fe]](o) : CG[P_](o);
    }, CG[t(f(55453, 55457), Tr)] = function(n) {
        var r = [];
        return PG[Hp][n[CG[xm]]] || (PG[Hp][n[CG[xm]]] = {
            lr: [],
            Wo: [],
            Vo: CG[ko]
        }), r[c(xu)] = PG[Hp][n[CG[xm]]], r[wo][CG[Ge]][CG[Cf]]({
            Xo: n[CG[Jm]],
            Bo: n[CG[bm]]
        }), CG[EG](n[CG[xm]]);
    }, CG[t(f(55457, 55461), Tr)] = function(n) {
        var r = [];
        return r[wo] = n, !(CG[Ob](r[wo]) && r[wo] !== PG[Eu] && (r[Au] = n[CG[me]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, r[Au]) || (r[Ru] = n[CG[Lm]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, r[Ru]))) && (r[yb] = n[CG[Jf]], (function(n) {
            return CG[Ob](n) && n !== PG[Eu];
        })[so](void 0, r[yb])));
    }, CG[OG] = function(n, r, i) {
        var t = [];
        var o = [];
        if (o[wo] = CG[Gj](), !o[wo][CG[Za]]) throw Error(PG[yl]);
        return t[wo] = i, CG[jb](t[wo]) && (CG[jb](t[wo][CG[me]]) || CG[jb](t[wo][CG[Lm]])) && CG[jb](t[wo][CG[Jf]]) ? o[wo][CG[Ia]] ? r[CG[Pc]](function(n) {
            var r = [];
            var o = {
                Qo: (r[wo] = i, r[wo][CG[Lm]] ? CG[lG]({
                    jwt: r[wo][CG[Lm]]
                }) : CG[dG](r[wo][CG[me]])),
                Xo: i,
                Bo: n
            };
            var t = [];
            return PG[Hp][o[CG[xm]]] || (PG[Hp][o[CG[xm]]] = {
                lr: [],
                Wo: [],
                Vo: CG[ko]
            }), t[c(xu)] = PG[Hp][o[CG[xm]]], t[wo][CG[Ge]][CG[Cf]]({
                Xo: o[CG[Jm]],
                Bo: o[CG[bm]]
            }), CG[EG](o[CG[xm]]);
        }) : (t[Ru] = function(t) {
            return r[CG[Pc]](function(r) {
                var u = [];
                u[wo] = CG[MG](n, o[wo][CG[Za]], r, i), t({
                    data: u[wo]
                });
            });
        }, CG[fG](n, o[wo][CG[Ou]], o[c(xu)][CG[Za]], t[Ru], CG[oG], o[wo][CG[Sa]])) : (o[wo][CG[Ra]] && (function(n, r, i) {
            CG[Tw](n, r, PG[Co] + i);
        })[so](void 0, n, PG[Fe], PG[ml]), CG[nG](n, !1));
    }, PG[Wp] = CG[we], PG[_p] = CG[Sf], PG[Gp] = CG[Jf], CG[XG] = function(n) {
        typeof n[CG[Rm]] != typeof PG[Rv] && (function(n) {
            return typeof n === CG[zf];
        })[so](void 0, n[CG[Rm]]) ? n[CG[Rm]]() : typeof HTMLFormElement != typeof PG[Rv] && HTMLFormElement[PG[Wo]] && (function(n) {
            return typeof n === CG[zf];
        })[so](void 0, HTMLFormElement[PG[Wo]][CG[Rm]]) && HTMLFormElement[PG[Wo]][CG[Rm]][CG[qf]](n);
    }, CG[jG] = function(n, r) {
        var i = [];
        var o = [];
        o[wo] = CG[Gj](), o[Au] = o[wo][CG[qa]] || PG[ul], o[Ru] = r[a(f(55461, 55489))], o[yb] = CG[ko];
        for(; o[yb] < o[Ru][CG[Kf]]; o[yb]++)if (o[Du] = o[Ru][o[yb]], (function(n, r) {
            if (n[CG[Gf]]) return n[CG[Gf]](r);
        })[so](void 0, o[Du], PG[Gp]) === o[Au]) return o[Du];
        return o[Iu] = CG[e(t(f(55489, 55499), Tr))](n, CG[wf]), (function(n, r, i) {
            return n[s(fp)](r, i);
        })[so](void 0, o[Iu], PG[Wp], PG[_p]), i[wo] = o[c(of)], (function(n, r, i) {
            return n[s(fp)](r, i);
        })[so](void 0, i[wo], PG[Gp], o[Au]), (function(n, r) {
            n && n[a(ep)](r);
        })[so](void 0, r, o[Iu]), o[Iu];
    }, CG[gG] = function(n$jscomp$0) {
        var r = [];
        return r[wo] = {
            createRequestToken: function() {
                var r = n$jscomp$0;
                var i = function(r) {
                    var i = [];
                    i[wo] = CG[Bw](n$jscomp$0), PG[Ju] ? (CG[$_](n$jscomp$0, i[wo]), r((function(n, r) {
                        return PG[c(xZ)] ? CG[V_](n, r)[CG[bm]] : PG[Rv];
                    })[so](void 0, n$jscomp$0, i[wo]))) : (function(n, r, i) {
                        PG[Hb][CG[Cf]]([
                            r,
                            i
                        ]);
                    })[so](void 0, n$jscomp$0, r, i[wo]);
                };
                return CG[QA](r) ? new r[CG[Fe]](i) : CG[P_](i);
            },
            page: function(i) {
                return CG[yG](n$jscomp$0, r[wo][CG[Um]](), i);
            },
            form: function(i) {
                return CG[mG](n$jscomp$0, r[wo][CG[Um]](), i);
            },
            custom: function(i) {
                return CG[OG](n$jscomp$0, r[wo][CG[Um]](), i);
            },
            formEventOnSubmit: function(i, o, u, v) {
                var c = [];
                var d = [];
                return i[CG[Sm]] ? i[CG[Sm]]() : i[CG[Im]] = !1, d[wo] = i[CG[iN]] || i[CG[CN]], c[Au] = function(n$jscomp$0) {
                    if (u && u[a(f(55499, 55531))]) return r[wo][CG[Bm]](i, function(r) {
                        if (v) return v(r, n$jscomp$0);
                        var n = d[wo];
                        if (typeof n[CG[Rm]] != typeof PG[Rv] && CG[Lp](n[CG[Rm]])) return void n[CG[Rm]]();
                        typeof HTMLFormElement != typeof PG[Rv] && HTMLFormElement[PG[Wo]] && CG[Lp](HTMLFormElement[PG[Wo]][CG[Rm]]) && HTMLFormElement[PG[Wo]][CG[Rm]][CG[qf]](n);
                    });
                    if (v) return v(i, n$jscomp$0), n$jscomp$0;
                    var n = d[wo];
                    if (typeof n[CG[e(t(f(55531, 55542), Tr))]] != typeof PG[Rv] && CG[Lp](n[CG[Rm]])) return void n[CG[Rm]]();
                    typeof HTMLFormElement != typeof PG[Rv] && HTMLFormElement[PG[Wo]] && CG[Lp](HTMLFormElement[PG[Wo]][CG[Rm]]) && HTMLFormElement[PG[Wo]][CG[Rm]][CG[qf]](n);
                }, d[Au] = PG[$v](CG[kp](o) ? {
                    userJwt: o
                } : {
                    user: o || {}
                }, CG[rG](n$jscomp$0, d[wo])), r[wo][CG[Dm]](d[Au])[CG[Pc]](c[Au]);
            },
            injectTokenOnSubmit: function(i, t) {
                var o = [];
                return i[CG[Sm]] ? i[CG[Sm]]() : i[CG[Im]] = !1, o[wo] = i[CG[iN]] || i[CG[CN]], r[wo][CG[Um]]()[CG[Pc]](function(r) {
                    var u = [];
                    if (u[wo] = CG[jG](n$jscomp$0, o[wo]), u[wo][s(fp)](CG[Ul], r), t) return t(i);
                    var n = o[wo];
                    if (typeof n[CG[Rm]] != typeof PG[Rv] && CG[Lp](n[CG[Rm]])) return void n[CG[Rm]]();
                    typeof HTMLFormElement != typeof PG[Rv] && HTMLFormElement[PG[Wo]] && CG[Lp](HTMLFormElement[PG[Wo]][CG[Rm]]) && HTMLFormElement[PG[Wo]][CG[Rm]][CG[qf]](n);
                });
            }
        }, r[c(xu)];
    }, CG[TG] = function() {
        if (PG[xp]) return PG[c(ZG)];
        throw Error(PG[pl]);
    }, CG[t(f(55542, 55546), Tr)] = function(n) {
        PG[xp] = CG[gG](n);
    }, PG[c(t(f(55546, 55556), Tr))] = s(f(55556, 55572)), PG[Up] = l(f(55572, 55604)), PG[Sp] = l(f(55604, 55664)), PG[c(t(f(55664, 55673), Tr))] = a(f(55673, 55725)), CG[e(t(f(55725, 55734), Tr))] = function(n) {
        var r = [];
        try {
            n[PG[Bp]] && (r[wo] = new n[PG[Bp]](function(n) {
                var i = [];
                try {
                    i[wo] = CG[ko], i[Au] = n[s(f(55734, 55762))]();
                    for(; i[wo] < i[Au][CG[Kf]]; i[c(xu)]++)i[Ru] = i[Au][i[wo]], i[Ru][CG[Jf]] === PG[Up] ? (function(n) {
                        PG[c(Dj)][CG[tl]] || (PG[Hl][CG[tl]] = CG[AM](n));
                    })[so](void 0, i[Ru][CG[qs]]) : i[Ru][CG[Jf]] === PG[c(t(f(55762, 55772), Tr))] && (function(n) {
                        PG[Hl][CG[ol]] || (PG[Hl][CG[ol]] = CG[AM](n));
                    })[so](void 0, i[Ru][CG[qs]]);
                    (PG[Hl][CG[tl]] || PG[xv]) && (PG[Hl][CG[ol]] || PG[xv]) && r[wo][s(f(55772, 55800))]();
                } catch (n) {}
            }), r[wo][CG[Kc]]({
                type: PG[Rp],
                buffered: !0
            }));
        } catch (n) {}
    }, PG[Dp] = CG[Rm], PG[c(LG)] = CG[Wo][CG[bf]](PG[dl], a(f(55800, 55824))), CG[HG] = function(n, r) {
        r[PG[qp]] = !0;
    }, CG[kG] = function(n, r) {
        delete r[PG[qp]];
    }, CG[JG] = function(n, r) {
        var i = [];
        var o = [];
        try {
            return o[wo] = CG[Wu](r, a(f(55824, 55840))), i[wo] = o[wo], !!(function(n) {
                return CG[Ob](n) && n !== PG[Eu];
            })[so](void 0, i[wo]) && ((function(n, r) {
                r[PG[qp]] = !0;
            })[so](void 0, n, r), i[Ru] = PG[c(t(f(55840, 55851), Tr))], i[yb] = function(i) {
                return i[CG[Sm]] ? i[CG[Sm]]() : i[CG[Im]] = !1, CG[TG]()[CG[Um]]()[CG[Pc]](function(i) {
                    CG[up](CG[jG](n, r), CG[Ul], i), setTimeout(function() {
                        CG[kG](n, r), CG[XG](r), CG[HG](n, r);
                    }, CG[Zf]);
                })[CG[Yc]](function() {
                    CG[kG](n, r);
                }), !1;
            }, (function(n, r, i, t) {
                CG[Xw](n) ? n[PG[Ne]](r, i, !t) : CG[jw](n) && n[PG[c(Fw)]](CG[Wo][CG[bf]](PG[Me])[CG[bf]](r), i);
            })[so](void 0, r, i[Ru], i[yb], !1), !0);
        } catch (n) {
            return !1;
        }
    }, CG[WG] = function(n) {
        var r = [];
        r[wo] = CG[Sb](n), r[Au] = r[wo][CG[qm]](CG[Dm]), r[c(af)] = CG[ko];
        for(; r[Ru] < r[Au][CG[Kf]]; r[Ru]++)CG[JG](n, r[Au][r[Ru]]);
    }, CG[_G] = function(n) {
        var r = [];
        typeof MutationObserver != typeof PG[Rv] && (r[wo] = new MutationObserver(function(r) {
            var i = [];
            i[wo] = CG[ko];
            for(; i[wo] < r[CG[Kf]]; i[wo]++){
                i[e(df)] = r[i[wo]], i[Ru] = i[Au][s(f(55851, 55879))], i[yb] = CG[ko];
                for(; i[yb] < i[Ru][CG[Kf]]; i[yb]++){
                    i[Du] = i[Ru][i[yb]];
                    try {
                        if (i[Du][a(f(55879, 55903))] !== CG[Zf]) continue;
                        if (i[Du] instanceof Element && i[c(vf)][CG[zm]] && i[Du][CG[zm]][CG[nv]]() === CG[Dm]) {
                            CG[JG](n, i[c(vf)]);
                            continue;
                        }
                        if (i[Du] instanceof Element && (i[Iu] = i[c(vf)][CG[qm]] && i[Du][CG[qm]](CG[Dm]), i[Iu] && i[e(of)][CG[Kf]])) {
                            i[Nb] = CG[ko];
                            for(; i[Nb] < i[Iu][CG[Kf]]; i[c(Tf)]++)CG[JG](n, i[Iu][i[Nb]]);
                        }
                    } catch (n) {}
                }
            }
        }), r[Au] = CG[$b](n), r[Au] && r[wo][CG[Kc]](r[Au], {
            childList: !0,
            subtree: !0
        }));
    }, CG[GG] = function() {
        var n = [];
        try {
            return !(typeof HTMLFormElement == typeof PG[Rv] || !HTMLFormElement[PG[Wo]] || (n[wo] = HTMLFormElement[PG[e(XX)]][CG[Rm]], HTMLFormElement[PG[Wo]][CG[Rm]] = function() {
                return !0 !== this[PG[c(LG)]] && n[c(xu)][CG[$v]](this, arguments);
            }, 0));
        } catch (n) {
            return !1;
        }
    }, CG[xG] = function(n) {
        var r = [];
        return n ? (r[wo] = n[CG[Yf]](CG[Ro]), r[wo][CG[Kf]] < CG[Df] ? n : r[wo][CG[iv]](-CG[Df])[CG[jf]](CG[Ro])) : CG[Wo];
    }, CG[t(f(55903, 55907), Tr)] = function(n, r) {
        var i = [];
        var t = [];
        try {
            return null != n && (t[e(xu)] = CG[kp](n) ? n : n[CG[e(fj)]](), !(t[wo] !== CG[Wo] && (function(n, r) {
                return n[CG[ov]](r) > -CG[Zf];
            })[so](void 0, t[wo], CG[wu]) && (i[Au] = l(RG), !(function(n, r) {
                return n[CG[ov]](r) > -CG[Zf];
            })[so](void 0, t[wo], i[Au]) || (t[c(df)] = t[wo][CG[Yf]](CG[Nu]), t[Au][CG[e(Nl)]] < CG[yv] || (t[Ru] = t[c(df)][CG[Df]][CG[Yf]](CG[wu])[CG[ko]], !t[Ru] || (t[yb] = CG[xG](CG[Db](r)[CG[SN]]), t[Du] = CG[xG](t[Ru]), t[Du] !== t[yb] || t[Du] === CG[Wo]))))));
        } catch (n) {
            return !1;
        }
    }, PG[Kp] = CG[Wo][CG[bf]](PG[dl], l(f(55907, 55919))), CG[UG] = function(n) {
        var r = [];
        typeof XMLHttpRequest != typeof PG[c(IE)] && (r[wo] = XMLHttpRequest[PG[Wo]][CG[rN]], r[Au] = XMLHttpRequest[PG[Wo]][CG[jm]], XMLHttpRequest[PG[Wo]][CG[rN]] = function(n, i, o, u, v) {
            try {
                this[PG[e(t(f(55919, 55928), Tr))]] = i;
            } catch (n) {} finally{
                return r[wo][CG[$v]](this, arguments);
            }
        }, XMLHttpRequest[PG[c(XX)]][CG[jm]] = function(i) {
            var t = [];
            t[wo] = this, t[Au] = arguments;
            try {
                return t[Ru] = t[wo][PG[Kp]], (function(n, r) {
                    var i = [];
                    try {
                        return null != n && (i[wo] = CG[kp](n) ? n : n[CG[Fu]](), i[wo] === CG[Wo] || !CG[mM](i[wo], CG[wu]) || !!CG[mM](i[wo], l(RG)) && (i[c(df)] = i[wo][CG[Yf]](CG[Nu]), i[Au][CG[Kf]] >= CG[yv] && (i[Ru] = i[c(df)][CG[Df]][CG[Yf]](CG[wu])[CG[ko]], !!i[Ru] && (i[yb] = CG[xG](CG[Db](r)[CG[SN]]), i[Du] = CG[xG](i[Ru]), i[Du] === i[yb] && i[Du] !== CG[Wo]))));
                    } catch (n) {
                        return !1;
                    }
                })[so](void 0, t[Ru], n) ? (function() {
                    if (PG[xp]) return PG[c(ZG)];
                    throw Error(PG[pl]);
                })[so](void 0)[CG[Um]]()[CG[Pc]](function(n) {
                    t[wo][CG[gm]](PG[ol], n), r[Au][CG[qf]](t[wo], i);
                })[CG[Yc]](function() {
                    return r[Au][CG[$v]](t[wo], t[Au]);
                }) : r[Au][CG[$v]](t[wo], t[Au]);
            } catch (n) {
                return r[Au][CG[$v]](t[wo], t[Au]);
            }
        });
    }, CG[SG] = function(n) {
        var r = [];
        (function(n) {
            return typeof n === CG[zf];
        })[so](void 0, n[CG[$m]]) && (r[wo] = CG[Lp](n[CG[$m]][CG[jd]]) ? n[CG[$m]][CG[jd]](n) : n[CG[$m]], n[CG[$m]] = function(i, t) {
            var o = [];
            try {
                return o[wo] = t || {}, o[Au] = CG[kp](i), o[c(af)] = CG[_u](i) && CG[Tm] in i, o[yb] = o[Au] ? i : o[Ru] ? i[CG[Tm]] : null, (function(n, r) {
                    var i = [];
                    try {
                        return null != n && (i[wo] = CG[kp](n) ? n : n[CG[Fu]](), i[wo] === CG[Wo] || !CG[mM](i[wo], CG[wu]) || !!CG[mM](i[wo], l(RG)) && (i[c(df)] = i[wo][CG[Yf]](CG[Nu]), i[e(df)][CG[Kf]] >= CG[e(bl)] && (i[Ru] = i[c(df)][CG[Df]][CG[Yf]](CG[wu])[CG[ko]], !!i[Ru] && (i[yb] = CG[xG](CG[Db](r)[CG[SN]]), i[Du] = CG[xG](i[Ru]), i[Du] === i[yb] && i[Du] !== CG[Wo]))));
                    } catch (n) {
                        return !1;
                    }
                })[so](void 0, o[yb], n) ? (function() {
                    if (PG[xp]) return PG[c(ZG)];
                    throw Error(PG[pl]);
                })[so](void e(xu))[CG[Um]]()[CG[Pc]](function(n) {
                    var t = [];
                    try {
                        o[wo][CG[Km]] && (function(n) {
                            return typeof n === CG[$f];
                        })[so](void 0, o[wo][CG[Km]]) && CG[ed] in o[wo][CG[Km]] ? o[wo][CG[Km]][CG[ed]](PG[ol], n) : o[wo][CG[Km]] = PG[$v](o[wo][CG[Km]] || {}, (t[wo] = {}, t[wo][PG[ol]] = n, t[wo]));
                    } catch (n) {}
                    return r[wo](i, o[wo]);
                })[CG[Yc]](function() {
                    return r[e(xu)](i, o[wo]);
                }) : r[wo](i, o[wo]);
            } catch (n) {
                return r[c(xu)](i, t);
            }
        });
    }, CG[IG] = function(n, r) {
        return (function() {
            if (PG[xp]) return PG[c(ZG)];
            throw Error(PG[pl]);
        })[so](void 0)[CG[Bm]](n, r);
    }, CG[BG] = function() {
        return (function() {
            if (PG[xp]) return PG[c(ZG)];
            throw Error(PG[pl]);
        })[so](void 0)[CG[Um]]();
    }, CG[DG] = function(n) {
        var r = [];
        var i = [];
        (function() {
            PG[Xe][CG[$o]] || (PG[Xe][CG[$o]] = CG[Jw]());
        })[so](void 0), (function(n) {
            PG[Hl][CG[Ka]] = CG[AM](CG[Bw](n));
        })[so](void 0, n), CG[kZ](n), r[wo] = function(n) {
            CG[Bj](n);
        }, (function(n, r) {
            PG[Lu] ? r(n) : PG[wm][CG[Cf]](r);
        })[so](void 0, n, r[wo]), (function(n) {
            PG[xp] = CG[gG](n);
        })[so](void 0, n), (function(n) {
            PG[kp] = n;
        })[so](void 0, n), r[Au] = function(n) {
            return n();
        }, (function(n, r) {
            var i = [];
            i[wo] = CG[ko], i[Au] = CG[ko], i[Ru] = n;
            for(; i[Au] < i[Ru][CG[Kf]]; i[Au]++)i[yb] = i[Ru][i[Au]], r(i[yb], i[wo]++);
        })[so](void 0, [
            CG[eE],
            CG[GE],
            CG[wE]
        ], r[Au]), (function(n) {
            CG[RO](n, PG[fd], PG[sd]), CG[zX](n);
        })[so](void 0, n), r[Ru] = function() {
            return CG[O_](n, CG[XT], i[e(xu)]);
        }, (function(n) {
            try {
                return n();
            } catch (n) {
                CG[XT](n);
            }
        })[so](void 0, r[Ru]), PG[Xl][CG[_a]] && (CG[UG](n), CG[SG](n)), CG[Sj](n), CG[xk](n, function() {
            (function(n) {
                var r = [];
                r[wo] = CG[Gj](), r[Au] = CG[D_](n, r[wo][CG[La]][CG[Ha]]), CG[yA](r[Au]) || (r[Au] = CG[hA](n)), CG[q_](n, {
                    Ho: r[Au]
                }), PG[ku] = !0;
            })[so](void 0, n), (function(n) {
                var r = [];
                if (r[wo] = CG[Gj](), !r[wo][CG[Za]]) throw Error(PG[yl]);
                if (PG[ku]) {
                    PG[Ju] = !0, r[Au] = PG[c(z_)][CG[Kf]], r[Ru] = CG[ko];
                    for(; r[Ru] < r[Au]; r[Ru]++)CG[$_](n, PG[Hb][r[Ru]][CG[Zf]]), r[yb] = CG[K_]()[CG[bm]], PG[Hb][r[Ru]][CG[ko]](r[yb]);
                    PG[Hb][CG[Kf]] = CG[ko];
                }
            })[so](void 0, n);
        }, function() {
            CG[$_](n, (function(n) {
                return CG[Sw](n) ? CG[Uw](n)[PG[Po]]() : PG[Oe]();
            })[so](void 0, n));
        }), r[yb] = function() {
            CG[t(f(55928, 55932), Tr)](n), CG[ST](n), CG[Gj]()[CG[e(t(f(55932, 55941), Tr))]] && CG[WZ](n, function(n) {
                CG[jT](function() {
                    CG[GG](n), CG[WG](n), CG[_G](n);
                });
            });
        }, (function(n) {
            setTimeout(n, CG[ko]);
        })[so](void 0, r[yb]), (function(n) {
            PG[Hl][CG[il]] = CG[AM](CG[Bw](n));
        })[so](void 0, n), PG[Gu] = !1;
    }, CG[qG] = function(n) {
        var r = [];
        var i = [];
        if (i[e(xu)] = n || {}, r[wo] = i[wo], (function(n, r) {
            return !(!CG[e($p)](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[wo], PG[rv]) && (i[c(df)] = i[wo][CG[Ff]]), i[Au] || typeof window != typeof PG[Rv] && (i[Au] = window), !i[Au]) throw Error(PG[c(t(f(55941, 55952), Tr))]);
        if (r[Au] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[Au], CG[Vm]) && (function(n) {
            n && (PG[Xl][CG[La]][CG[Ha]] = n);
        })[so](void 0, i[wo][CG[Vm]]), r[Ru] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[Ru], CG[e(dw)]) && (function(n) {
            n && (n[CG[Jf]] && (PG[Xl][CG[e(OO)]][CG[Ha]] = n[CG[Jf]]), CG[Op](n[CG[Ga]]) && (PG[Xl][CG[La]][CG[xa]] = n[CG[Ga]]));
        })[so](void 0, i[wo][CG[de]]), r[yb] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[yb], CG[Cm]) && (function(n) {
            PG[Xl][CG[Wa]] = n;
        })[so](void 0, !!i[wo][CG[Cm]]), r[Du] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[Du], CG[Pm]) && (function(n) {
            PG[Xl][CG[_a]] = n;
        })[so](void 0, !!i[wo][CG[Pm]]), r[Iu] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[Iu], CG[Qm]) && (function(n) {
            PG[Xl][CG[Ua]] = n;
        })[so](void 0, !!i[wo][CG[Qm]]), r[Nb] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[Nb], CG[Ym]) && (function(n) {
            n && /\S+\.\S{2,}$/[CG[ie]](n) && (PG[Zb] = n);
        })[so](void 0, i[wo][CG[Ym]]), r[mb] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[mb], CG[nb]) && (function(n) {
            PG[Xl][CG[ka]] = n;
        })[so](void 0, i[wo][CG[nb]]), r[Su] = i[wo], r[hf] = s(f(55952, 55960)), (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[Su], r[hf]) && (r[Ef] = i[wo][a(f(55960, 55968))], (function(n) {
            PG[c(_j)][CG[Ja]] = n;
        })[so](void 0, r[Ef])), r[To] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[To], CG[rb]) && (r[Of] = i[c(xu)][CG[rb]], (function(n) {
            CG[jb](n) && (PG[Xl][CG[Xu]] = n);
        })[so](void 0, r[Of])), r[yf] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[yf], CG[ib]) && (function(n) {
            CG[jb](n) && (PG[Xl][CG[Ba]] = n);
        })[so](void 0, i[wo][CG[ib]]), r[Nf] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[Nf], CG[tb]) && (function(n) {
            CG[jb](n) && (PG[Xl][CG[Da]] = n);
        })[so](void 0, i[wo][CG[tb]]), r[mf] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[mf], CG[ob]) && (function(n) {
            PG[Xl][CG[qa]] = n;
        })[so](void 0, i[wo][CG[ob]]), r[bf] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[bf], CG[ub]) && (function(n) {
            CG[jb](n) && (PG[Xl][CG[za]] = n);
        })[so](void 0, i[wo][CG[ub]]), r[pf] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[pf], CG[fb]) && (function(n) {
            CG[e($p)](n) && (PG[Xl][CG[$a]] = n);
        })[so](void 0, i[wo][CG[fb]]), r[Zo] = i[wo], (function(n, r) {
            return !(!CG[e($p)](n) || !(CG[e(FX)] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[Zo], CG[vb]) && (function(n) {
            if (!CG[Eb](n) || n[CG[Kf]] !== d(AX) || n[CG[iv]](CG[ko], CG[yv]) !== l(xj)) throw Error(PG[yl]);
            PG[Xl][CG[Za]] = n;
        })[so](void 0, i[wo][CG[vb]]), r[Lo] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[Lo], CG[eb]) && (function(n) {
            n && (PG[Xl][CG[Ou]] = n);
        })[so](void 0, i[wo][CG[eb]]), r[Ho] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[Ho], CG[cb]) && (function(n) {
            CG[835](n) && (PG[c(_j)][CG[Sa]] = n);
        })[so](void 0, i[wo][CG[cb]]), r[Mf] = i[c(xu)], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[Mf], CG[db]) && (function(n) {
            PG[Xl][CG[Ra]] = n;
        })[so](void 0, !!i[wo][CG[db]]), r[wf] = i[wo], (function(n, r) {
            return !(!CG[jb](n) || !(CG[Hf] in n)) && n[CG[Hf]](r);
        })[so](void 0, r[wf], CG[ab]) && (function(n) {
            CG[jb](n) && (PG[Xl][CG[Ia]] = n);
        })[so](void 0, i[wo][CG[ab]]), PG[Gu]) {
            if (!PG[Xl][CG[Za]]) throw Error(PG[yl]);
            CG[DG](i[c(df)]);
        }
        return PG[Ab];
    }, CG[zG] = function(n, r, i, t) {
        return (function() {
            if (PG[xp]) return PG[c(ZG)];
            throw Error(PG[pl]);
        })[so](void 0)[CG[lb]](n, r, i, t);
    }, CG[$G] = function(n) {
        return (function() {
            if (PG[xp]) return PG[c(ZG)];
            throw Error(PG[pl]);
        })[so](void 0)[CG[sb]](n);
    }, CG[KG] = function(n) {
        return (function() {
            if (PG[xp]) return PG[c(ZG)];
            throw Error(PG[pl]);
        })[so](void 0)[CG[Dm]](n);
    }, CG[VG] = function(n) {
        return (function() {
            if (PG[xp]) return PG[c(ZG)];
            throw Error(PG[pl]);
        })[so](void 0)[CG[hb]](n);
    }, PG[Ab] = {
        formEventOnSubmit: CG[zG],
        page: CG[$G],
        form: CG[KG],
        custom: CG[VG],
        configure: CG[qG],
        createRequestToken: CG[BG],
        injectTokenOnSubmit: CG[IG]
    }, n[a(f(55968, 55992))] = CG[qG], n[CG[Um]] = CG[BG], n[CG[hb]] = CG[VG], n[CG[Dm]] = CG[KG], n[CG[lb]] = CG[zG], n[CG[Bm]] = CG[IG], n[CG[sb]] = CG[$G];
}, $4d3b2a13d1f459bf$var$r(module.exports);

});



parcelRegister("a09DY", function(module, exports) {
$parcel$export(module.exports, "connect", function () { return (parcelRequire("36uoy")).default; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("gGx1I")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("e98UA")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("d9nZl")).useSelector; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $5BT2W = parcelRequire("5BT2W");

var $1Fmvo = parcelRequire("1Fmvo");
parcelRequire("iQYvs");
var $9ZCME = parcelRequire("9ZCME");

var $42qeY = parcelRequire("42qeY");

var $d9nZl = parcelRequire("d9nZl");

var $36uoy = parcelRequire("36uoy");
parcelRequire("7EeC6");
(0, $d9nZl.initializeUseSelector)((0, $1Fmvo.useSyncExternalStoreWithSelector));
(0, $36uoy.initializeConnect)((0, $5BT2W.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $42qeY.setBatch)((0, $9ZCME.unstable_batchedUpdates));

});
parcelRegister("1Fmvo", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ebwKZ"));

});

parcelRegister("iQYvs", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("9ZCME")).unstable_batchedUpdates; });

var $9ZCME = parcelRequire("9ZCME");

});

parcelRegister("42qeY", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $2f0bb428ce670a1c$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $2f0bb428ce670a1c$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $2f0bb428ce670a1c$var$defaultNoopBatch(callback) {
    callback();
}
let $2f0bb428ce670a1c$var$batch = $2f0bb428ce670a1c$var$defaultNoopBatch; // Allow injecting another batching function later
const $2f0bb428ce670a1c$export$4b9874722d0da7bc = (newBatch)=>$2f0bb428ce670a1c$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $2f0bb428ce670a1c$export$fc47d4c0ba3bd2c6 = ()=>$2f0bb428ce670a1c$var$batch;

});

parcelRegister("d9nZl", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", function () { return $992eb935cd9508f0$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $992eb935cd9508f0$export$2105062e25df4afe; });

var $dNMDr = parcelRequire("dNMDr");

var $1qYc7 = parcelRequire("1qYc7");

var $hMX8m = parcelRequire("hMX8m");

var $7ZhuK = parcelRequire("7ZhuK");
let $992eb935cd9508f0$var$useSyncExternalStoreWithSelector = (0, $7ZhuK.notInitialized);
const $992eb935cd9508f0$export$e2e6e3f3f3b782e3 = (fn)=>{
    $992eb935cd9508f0$var$useSyncExternalStoreWithSelector = fn;
};
const $992eb935cd9508f0$var$refEquality = (a, b)=>a === b;
function $992eb935cd9508f0$export$2b53f90d2bd1cbfb(context = (0, $hMX8m.ReactReduxContext)) {
    const useReduxContext = context === (0, $hMX8m.ReactReduxContext) ? (0, $1qYc7.useReduxContext) : (0, $1qYc7.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $992eb935cd9508f0$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $dNMDr.useRef)(true);
        const wrappedSelector = (0, $dNMDr.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $992eb935cd9508f0$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $dNMDr.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $992eb935cd9508f0$export$2105062e25df4afe = /*#__PURE__*/ $992eb935cd9508f0$export$2b53f90d2bd1cbfb();

});
parcelRegister("1qYc7", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", function () { return $10b6e989646d7cc8$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $10b6e989646d7cc8$export$c1275ca9a6fd3ec5; });

var $dNMDr = parcelRequire("dNMDr");

var $hMX8m = parcelRequire("hMX8m");
function $10b6e989646d7cc8$export$d4d6226d5fc61558(context = (0, $hMX8m.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $dNMDr.useContext)(context);
        return contextValue;
    };
}
const $10b6e989646d7cc8$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $10b6e989646d7cc8$export$d4d6226d5fc61558();

});
parcelRegister("hMX8m", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $cf34ca22a258c22f$export$cc80c08dc91f1c00; });

var $dNMDr = parcelRequire("dNMDr");
const $cf34ca22a258c22f$var$ContextKey = Symbol.for(`react-redux-context`);
const $cf34ca22a258c22f$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $cf34ca22a258c22f$var$getContext() {
    var _gT$ContextKey;
    if (!$dNMDr.createContext) return {};
    const contextMap = (_gT$ContextKey = $cf34ca22a258c22f$var$gT[$cf34ca22a258c22f$var$ContextKey]) != null ? _gT$ContextKey : $cf34ca22a258c22f$var$gT[$cf34ca22a258c22f$var$ContextKey] = new Map();
    let realContext = contextMap.get($dNMDr.createContext);
    if (!realContext) {
        realContext = $dNMDr.createContext(null);
        contextMap.set($dNMDr.createContext, realContext);
    }
    return realContext;
}
const $cf34ca22a258c22f$export$cc80c08dc91f1c00 = /*#__PURE__*/ $cf34ca22a258c22f$var$getContext();
var $cf34ca22a258c22f$export$2e2bcd8739ae039 = $cf34ca22a258c22f$export$cc80c08dc91f1c00;

});


parcelRegister("7ZhuK", function(module, exports) {

$parcel$export(module.exports, "notInitialized", function () { return $5d0bcd0e0e2cfb6a$export$20656a4825650bd0; });
const $5d0bcd0e0e2cfb6a$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("36uoy", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", function () { return $24298274948bb162$export$36d45daa6a4925b8; });
$parcel$export(module.exports, "default", function () { return $24298274948bb162$export$2e2bcd8739ae039; });

var $lqyXr = parcelRequire("lqyXr");

var $4wTfY = parcelRequire("4wTfY");

var $cy8cW = parcelRequire("cy8cW");

var $dNMDr = parcelRequire("dNMDr");

var $2nQAO = parcelRequire("2nQAO");

var $9VgFV = parcelRequire("9VgFV");

var $IPsd7 = parcelRequire("IPsd7");

var $4jFp7 = parcelRequire("4jFp7");

var $ZSIry = parcelRequire("ZSIry");

var $4BGCo = parcelRequire("4BGCo");

var $joghy = parcelRequire("joghy");

var $8vohe = parcelRequire("8vohe");
parcelRequire("aRiTB");

var $hMX8m = parcelRequire("hMX8m");

var $7ZhuK = parcelRequire("7ZhuK");
const $24298274948bb162$var$_excluded = [
    "reactReduxForwardedRef"
];
let $24298274948bb162$var$useSyncExternalStore = (0, $7ZhuK.notInitialized);
const $24298274948bb162$export$36d45daa6a4925b8 = (fn)=>{
    $24298274948bb162$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $24298274948bb162$var$EMPTY_ARRAY = [
    null,
    0
];
const $24298274948bb162$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $24298274948bb162$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $24298274948bb162$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $joghy.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $24298274948bb162$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $24298274948bb162$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $24298274948bb162$var$initStateUpdates = ()=>$24298274948bb162$var$EMPTY_ARRAY;
function $24298274948bb162$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $24298274948bb162$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $24298274948bb162$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $24298274948bb162$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $8vohe.default), areStatePropsEqual: areStatePropsEqual = (0, $8vohe.default), areMergedPropsEqual: areMergedPropsEqual = (0, $8vohe.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $hMX8m.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $4jFp7.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $IPsd7.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $ZSIry.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $dNMDr.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $4wTfY.default)(props, $24298274948bb162$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $dNMDr.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $2nQAO.isContextConsumer)(/*#__PURE__*/ $dNMDr.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $dNMDr.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $dNMDr.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $9VgFV.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $dNMDr.useMemo(()=>{
                if (!shouldHandleStateChanges) return $24298274948bb162$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $4BGCo.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $dNMDr.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $lqyXr.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $dNMDr.useRef();
            const lastWrapperProps = $dNMDr.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $dNMDr.useRef();
            const renderIsScheduled = $dNMDr.useRef(false);
            const isProcessingDispatch = $dNMDr.useRef(false);
            const isMounted = $dNMDr.useRef(false);
            const latestSubscriptionCallbackError = $dNMDr.useRef();
            (0, $joghy.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $dNMDr.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $dNMDr.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $24298274948bb162$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $24298274948bb162$var$useIsomorphicLayoutEffectWithArgs($24298274948bb162$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $24298274948bb162$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $joghy.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $dNMDr.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $dNMDr.createElement(WrappedComponent, (0, $lqyXr.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $dNMDr.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $dNMDr.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $dNMDr.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $dNMDr.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $dNMDr.createElement(Connect, (0, $lqyXr.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cy8cW)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($cy8cW)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $24298274948bb162$export$2e2bcd8739ae039 = $24298274948bb162$var$connect;

});
parcelRegister("4wTfY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34c50363f6c4c7fe$export$2e2bcd8739ae039; });
function $34c50363f6c4c7fe$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("2nQAO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6JeVJ"));

});

parcelRegister("9VgFV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73965f457458c590$export$2e2bcd8739ae039; });

var $4wTfY = parcelRequire("4wTfY");
parcelRequire("3AQg9");
const $73965f457458c590$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $73965f457458c590$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $73965f457458c590$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $4wTfY.default)(_ref, $73965f457458c590$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $73965f457458c590$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("3AQg9", function(module, exports) {

var $aRiTB = parcelRequire("aRiTB");
function $29dd4586d50c656a$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $aRiTB.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $29dd4586d50c656a$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $29dd4586d50c656a$var$verify(mapStateToProps, 'mapStateToProps');
    $29dd4586d50c656a$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $29dd4586d50c656a$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("aRiTB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e7d82ef633128d1$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $7e7d82ef633128d1$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("IPsd7", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $086c05dec0b48221$export$b69a785ceac019a6; });

var $cot3L = parcelRequire("cot3L");

var $iKuFp = parcelRequire("iKuFp");

var $5CRk5 = parcelRequire("5CRk5");
function $086c05dec0b48221$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $iKuFp.wrapMapToPropsConstant)((dispatch)=>(0, $cot3L.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $iKuFp.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $iKuFp.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $5CRk5.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("cot3L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $905e448e605fdedf$export$2e2bcd8739ae039; });
function $905e448e605fdedf$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("iKuFp", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $da644fb0d4efca00$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $da644fb0d4efca00$export$8d46c7f53c8c602f; });
parcelRequire("4uD5c");
function $da644fb0d4efca00$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $da644fb0d4efca00$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $da644fb0d4efca00$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $da644fb0d4efca00$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $da644fb0d4efca00$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("4uD5c", function(module, exports) {

var $dBQG2 = parcelRequire("dBQG2");

var $aRiTB = parcelRequire("aRiTB");
function $345847cf9933a21a$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $dBQG2.default)(value)) (0, $aRiTB.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("dBQG2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e8797a1e58c80a0$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $9e8797a1e58c80a0$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("5CRk5", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", function () { return $4189dd364214f783$export$19ef7b929f7e2559; });
function $4189dd364214f783$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("4jFp7", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $32490dc36a05ec72$export$e00e93951827eda7; });

var $iKuFp = parcelRequire("iKuFp");

var $5CRk5 = parcelRequire("5CRk5");
function $32490dc36a05ec72$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $iKuFp.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $iKuFp.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $5CRk5.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("ZSIry", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", function () { return $0ba0240b22a8f92d$export$17457cf6fa742f84; });

var $lqyXr = parcelRequire("lqyXr");
parcelRequire("4uD5c");

var $5CRk5 = parcelRequire("5CRk5");
function $0ba0240b22a8f92d$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $lqyXr.default)({}, ownProps, stateProps, dispatchProps);
}
function $0ba0240b22a8f92d$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $0ba0240b22a8f92d$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$0ba0240b22a8f92d$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $0ba0240b22a8f92d$export$5b105939c84b5234(mergeProps) : (0, $5CRk5.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("4BGCo", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $35abad3b10bb7a54$export$d567d2b9af322f8f; });

var $42qeY = parcelRequire("42qeY");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $35abad3b10bb7a54$var$createListenerCollection() {
    const batch = (0, $42qeY.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $35abad3b10bb7a54$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $35abad3b10bb7a54$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $35abad3b10bb7a54$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $35abad3b10bb7a54$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $35abad3b10bb7a54$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("joghy", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $e1dce38349d8a417$export$700979bc83e7db82; });

var $dNMDr = parcelRequire("dNMDr");
const $e1dce38349d8a417$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $e1dce38349d8a417$export$700979bc83e7db82 = $e1dce38349d8a417$export$71594e8a50f746f4 ? $dNMDr.useLayoutEffect : $dNMDr.useEffect;

});

parcelRegister("8vohe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63140cda2bf9a4da$export$2e2bcd8739ae039; });
function $63140cda2bf9a4da$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $63140cda2bf9a4da$export$2e2bcd8739ae039(objA, objB) {
    if ($63140cda2bf9a4da$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$63140cda2bf9a4da$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("7EeC6", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("gGx1I")).default; });
$parcel$export(module.exports, "connect", function () { return (parcelRequire("36uoy")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("e98UA")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("d9nZl")).useSelector; });

var $gGx1I = parcelRequire("gGx1I");

var $36uoy = parcelRequire("36uoy");

var $hMX8m = parcelRequire("hMX8m");

var $e98UA = parcelRequire("e98UA");

var $d9nZl = parcelRequire("d9nZl");

var $jRvGh = parcelRequire("jRvGh");

var $8vohe = parcelRequire("8vohe");
parcelRequire("fCSTD");

});
parcelRegister("gGx1I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c25a30049680ed92$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $hMX8m = parcelRequire("hMX8m");

var $4BGCo = parcelRequire("4BGCo");

var $joghy = parcelRequire("joghy");
function $c25a30049680ed92$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $dNMDr.useMemo(()=>{
        const subscription = (0, $4BGCo.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $dNMDr.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $joghy.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $hMX8m.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $dNMDr.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $c25a30049680ed92$export$2e2bcd8739ae039 = $c25a30049680ed92$var$Provider;

});

parcelRegister("e98UA", function(module, exports) {

$parcel$export(module.exports, "useDispatch", function () { return $a4c8d1a63babf2cd$export$8ad76b76a4c905f8; });

var $hMX8m = parcelRequire("hMX8m");

var $jRvGh = parcelRequire("jRvGh");
function $a4c8d1a63babf2cd$export$bc9b55530897c558(context = (0, $hMX8m.ReactReduxContext)) {
    const useStore = context === (0, $hMX8m.ReactReduxContext) ? (0, $jRvGh.useStore) : (0, $jRvGh.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $a4c8d1a63babf2cd$export$8ad76b76a4c905f8 = /*#__PURE__*/ $a4c8d1a63babf2cd$export$bc9b55530897c558();

});
parcelRegister("jRvGh", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $e75b8ab6b72965fa$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $e75b8ab6b72965fa$export$6ccbb43953eebf8; });

var $hMX8m = parcelRequire("hMX8m");

var $1qYc7 = parcelRequire("1qYc7");
function $e75b8ab6b72965fa$export$671dba69185d0304(context = (0, $hMX8m.ReactReduxContext)) {
    const useReduxContext = context === (0, $hMX8m.ReactReduxContext) ? (0, $1qYc7.useReduxContext) : (0, $1qYc7.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $e75b8ab6b72965fa$export$6ccbb43953eebf8 = /*#__PURE__*/ $e75b8ab6b72965fa$export$671dba69185d0304();

});


parcelRegister("fCSTD", function(module, exports) {

});




parcelRegister("fRBl4", function(module, exports) {

$parcel$export(module.exports, "getFfsId", function () { return $9911f5926766078d$export$3b0e089e98b45efa; });

var $aEip0 = parcelRequire("aEip0");
const $9911f5926766078d$var$FFS_ID_KEY = 'atlassian.account.ffs.id';
function $9911f5926766078d$export$3b0e089e98b45efa() {
    const ffsId = (0, (/*@__PURE__*/$parcel$interopDefault($aEip0))).get($9911f5926766078d$var$FFS_ID_KEY);
    return ffsId && ffsId.replace(/(^")|("$)/g, '');
}

});

parcelRegister("jknxz", function(module, exports) {

$parcel$export(module.exports, "FeatureGatesInit", function () { return $cfca0930bc1b8a7d$export$8bae65f5bd3fcf07; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $1xneb = parcelRequire("1xneb");

var $d1oup = parcelRequire("d1oup");

var $hhYxc = parcelRequire("hhYxc");

var $lDj5O = parcelRequire("lDj5O");
const $cfca0930bc1b8a7d$var$getLocalMode = ()=>(0, $hhYxc.currentEnv) === 'local';
const $cfca0930bc1b8a7d$var$getEnv = ()=>{
    switch(0, $hhYxc.currentEnv){
        case 'dev':
        case 'local':
            return (0, $d1oup.FeatureGateEnvironment).Development;
        case 'stg':
        case 'stg-fedm':
        case 'stg-ic':
            return (0, $d1oup.FeatureGateEnvironment).Staging;
        case 'prod':
        case 'prod-fedm':
        case 'prod-ic':
        default:
            return (0, $d1oup.FeatureGateEnvironment).Production;
    }
};
const $cfca0930bc1b8a7d$var$options = {
    targetApp: (0, $lDj5O.statsigTargetApp),
    environment: $cfca0930bc1b8a7d$var$getEnv(),
    apiKey: (0, $lDj5O.getStatsigApiKey)(),
    localMode: $cfca0930bc1b8a7d$var$getLocalMode()
};
const $cfca0930bc1b8a7d$export$8bae65f5bd3fcf07 = ({ identifiers: identifiers, onReady: onReady })=>{
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $1xneb.FeatureGatesInitialization), {
        enabled: true,
        identifiers: identifiers,
        options: $cfca0930bc1b8a7d$var$options,
        onReady: onReady
    });
};

});
parcelRegister("1xneb", function(module, exports) {
"use strict";
var $11eae4094f14027d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $11eae4094f14027d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $11eae4094f14027d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$11eae4094f14027d$var$__exportStar((parcelRequire("UDOGI")), module.exports);

$11eae4094f14027d$var$__exportStar((parcelRequire("iPdaF")), module.exports);

$11eae4094f14027d$var$__exportStar((parcelRequire("lgR43")), module.exports);

$11eae4094f14027d$var$__exportStar((parcelRequire("c2UMn")), module.exports);

$11eae4094f14027d$var$__exportStar((parcelRequire("a4hR9")), module.exports);

});
parcelRegister("UDOGI", function(module, exports) {
"use strict";
var $0aa41dd0789126c2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useExperimentValue = module.exports.useFeatureGate = void 0;

var $dNMDr = parcelRequire("dNMDr");

const $0aa41dd0789126c2$var$feature_gate_js_client_1 = $0aa41dd0789126c2$var$__importDefault((parcelRequire("homdr")));
const $0aa41dd0789126c2$var$useFeatureGate = (gateName, options = {})=>{
    const [gate, setGate] = (0, $dNMDr.useState)(()=>$0aa41dd0789126c2$var$feature_gate_js_client_1.default.checkGate(gateName, options));
    (0, $dNMDr.useEffect)(()=>{
        const onGateChange = (newValue)=>setGate(newValue);
        return $0aa41dd0789126c2$var$feature_gate_js_client_1.default.onGateUpdated(gateName, onGateChange, options);
    }, [
        gateName,
        options
    ]);
    return gate;
};
module.exports.useFeatureGate = $0aa41dd0789126c2$var$useFeatureGate;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $0aa41dd0789126c2$var$useExperimentValue = (experimentName, parameterName, defaultValue, options = {})=>{
    const [experimentValue, setExperimentValue] = (0, $dNMDr.useState)(()=>$0aa41dd0789126c2$var$feature_gate_js_client_1.default.getExperimentValue(experimentName, parameterName, defaultValue, options));
    (0, $dNMDr.useEffect)(()=>{
        const onExperimentValueChange = (newValue)=>setExperimentValue(newValue);
        return $0aa41dd0789126c2$var$feature_gate_js_client_1.default.onExperimentValueUpdated(experimentName, parameterName, defaultValue, onExperimentValueChange, options);
    }, [
        experimentName,
        parameterName,
        defaultValue,
        options
    ]);
    return experimentValue;
};
module.exports.useExperimentValue = $0aa41dd0789126c2$var$useExperimentValue;

});
parcelRegister("homdr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("emS9l")).default; });
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return (parcelRequire("d1oup")).FeatureGateEnvironment; });
$parcel$export(module.exports, "PerimeterType", function () { return (parcelRequire("d1oup")).PerimeterType; });
$parcel$export(module.exports, "CLIENT_VERSION", function () { return (parcelRequire("aXEvm")).CLIENT_VERSION; });
$parcel$export(module.exports, "DynamicConfig", function () { return (parcelRequire("kkEAg")).DynamicConfig; });
$parcel$export(module.exports, "Layer", function () { return (parcelRequire("hfnjj")).Layer; });
$parcel$export(module.exports, "EvaluationReason", function () { return (parcelRequire("NtwyG")).EvaluationReason; });
parcelRequire("emS9l");
var $aXEvm = parcelRequire("aXEvm");
var $emS9l = parcelRequire("emS9l");
var $d1oup = parcelRequire("d1oup");

var $kkEAg = parcelRequire("kkEAg");

var $hfnjj = parcelRequire("hfnjj");

var $NtwyG = parcelRequire("NtwyG");

});


parcelRegister("iPdaF", function(module, exports) {
"use strict";
var $db4734e34bb8a259$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $dNMDr = parcelRequire("dNMDr");

const $db4734e34bb8a259$var$feature_gate_js_client_1 = $db4734e34bb8a259$var$__importDefault((parcelRequire("homdr")));

var $dm0bl = parcelRequire("dm0bl");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $db4734e34bb8a259$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $dNMDr.useState)(!overrides && (0, $dm0bl.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $dNMDr.useRef)(options);
    (0, $dNMDr.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (enabled) {
            if ((0, $dm0bl.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $dm0bl.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $db4734e34bb8a259$var$feature_gate_js_client_1.default.initializeCalled() ? $db4734e34bb8a259$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $db4734e34bb8a259$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $dm0bl.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $dm0bl.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $dm0bl.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $dm0bl.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $db4734e34bb8a259$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("dm0bl", function(module, exports) {
"use strict";
var $9b8d788eaceac09a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isClientAlreadyInCorrectState = $9b8d788eaceac09a$var$isClientAlreadyInCorrectState;
module.exports.pickChildToRender = $9b8d788eaceac09a$var$pickChildToRender;
module.exports.toError = $9b8d788eaceac09a$var$toError;
module.exports.applyOverrides = $9b8d788eaceac09a$var$applyOverrides;
module.exports.clearOverrides = $9b8d788eaceac09a$var$clearOverrides;

const $9b8d788eaceac09a$var$react_1 = $9b8d788eaceac09a$var$__importDefault((parcelRequire("dNMDr")));

const $9b8d788eaceac09a$var$feature_gate_js_client_1 = $9b8d788eaceac09a$var$__importDefault((parcelRequire("homdr")));
let $9b8d788eaceac09a$var$hasWarnedAboutMissingOverrideSupport = false;
function $9b8d788eaceac09a$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $9b8d788eaceac09a$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($9b8d788eaceac09a$var$feature_gate_js_client_1.default)) && ((_b = $9b8d788eaceac09a$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($9b8d788eaceac09a$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
function $9b8d788eaceac09a$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $9b8d788eaceac09a$var$react_1.default.createElement($9b8d788eaceac09a$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $9b8d788eaceac09a$var$react_1.default.createElement($9b8d788eaceac09a$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
function $9b8d788eaceac09a$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
function $9b8d788eaceac09a$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$9b8d788eaceac09a$var$feature_gate_js_client_1.default.overrideGate || !$9b8d788eaceac09a$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$9b8d788eaceac09a$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn('Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+');
            $9b8d788eaceac09a$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $9b8d788eaceac09a$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($9b8d788eaceac09a$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $9b8d788eaceac09a$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($9b8d788eaceac09a$var$feature_gate_js_client_1.default, configName, values);
    });
}
function $9b8d788eaceac09a$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $9b8d788eaceac09a$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($9b8d788eaceac09a$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $9b8d788eaceac09a$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($9b8d788eaceac09a$var$feature_gate_js_client_1.default, configName);
    });
}

});


parcelRegister("lgR43", function(module, exports) {
"use strict";
var $f7c4411a0ba70abf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithProvider = void 0;

var $dNMDr = parcelRequire("dNMDr");

const $f7c4411a0ba70abf$var$feature_gate_js_client_1 = $f7c4411a0ba70abf$var$__importDefault((parcelRequire("homdr")));

var $dm0bl = parcelRequire("dm0bl");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $f7c4411a0ba70abf$var$FeatureGatesInitializationWithProvider = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady, provider: provider })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $dNMDr.useState)(!overrides && (0, $dm0bl.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options and provider, so that we can use them within the following useEffect
    // without adding options and provider as dependencies.
    // This avoids the user updating every time an option or provider is attempted to be changed.
    const optionsRef = (0, $dNMDr.useRef)(options);
    const providerRef = (0, $dNMDr.useRef)(provider);
    (0, $dNMDr.useEffect)(()=>{
        optionsRef.current = options;
        providerRef.current = provider;
    }, [
        options,
        provider
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (enabled) {
            if ((0, $dm0bl.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $dm0bl.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $f7c4411a0ba70abf$var$feature_gate_js_client_1.default.initializeCalled() ? $f7c4411a0ba70abf$var$feature_gate_js_client_1.default.updateUserWithProvider(identifiers, customAttributes) : $f7c4411a0ba70abf$var$feature_gate_js_client_1.default.initializeWithProvider(options, provider, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $dm0bl.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $dm0bl.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $dm0bl.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $dm0bl.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitializationWithProvider = $f7c4411a0ba70abf$var$FeatureGatesInitializationWithProvider;
module.exports.default = module.exports.FeatureGatesInitializationWithProvider;

});

parcelRegister("c2UMn", function(module, exports) {
"use strict";
var $8c51b718e7080078$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $dNMDr = parcelRequire("dNMDr");

const $8c51b718e7080078$var$feature_gate_js_client_1 = $8c51b718e7080078$var$__importDefault((parcelRequire("homdr")));

var $dm0bl = parcelRequire("dm0bl");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $8c51b718e7080078$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $dNMDr.useState)(!overrides && (0, $dm0bl.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $dNMDr.useRef)(options);
    (0, $dNMDr.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (enabled) {
            if ((0, $dm0bl.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $dm0bl.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $8c51b718e7080078$var$feature_gate_js_client_1.default.initializeCalled() ? $8c51b718e7080078$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $8c51b718e7080078$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: 'client-default-key'
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.catch((err)=>(0, $dm0bl.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $dm0bl.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $dm0bl.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $dm0bl.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $8c51b718e7080078$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("a4hR9", function(module, exports) {
"use strict";
var $754820f9b0260257$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $dNMDr = parcelRequire("dNMDr");

const $754820f9b0260257$var$feature_gate_js_client_1 = $754820f9b0260257$var$__importDefault((parcelRequire("homdr")));

var $dm0bl = parcelRequire("dm0bl");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $754820f9b0260257$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $dNMDr.useState)(!overrides && (0, $dm0bl.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $dNMDr.useRef)(options);
    (0, $dNMDr.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (enabled) {
            if ((0, $dm0bl.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $dm0bl.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $754820f9b0260257$var$feature_gate_js_client_1.default.initializeCalled() ? $754820f9b0260257$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $754820f9b0260257$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.catch((err)=>(0, $dm0bl.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $dm0bl.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $dm0bl.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $dm0bl.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $754820f9b0260257$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});


parcelRegister("lDj5O", function(module, exports) {

$parcel$export(module.exports, "statsigTargetApp", function () { return $9e08a6841eb6f575$export$c0273fbd336e77ca; });
$parcel$export(module.exports, "getStatsigApiKey", function () { return $9e08a6841eb6f575$export$2f2c106effb3792; });
$parcel$export(module.exports, "getBooleanDynamicConfigValueOrDefault", function () { return $9e08a6841eb6f575$export$ca7b7b70279af0; });

var $hhYxc = parcelRequire("hhYxc");
const $9e08a6841eb6f575$export$c0273fbd336e77ca = 'aid-frontend_web';
const $9e08a6841eb6f575$export$2f2c106effb3792 = ()=>{
    // Provided by https://developer.atlassian.com/platform/frontend-feature-flags/resources/api-keys/
    switch(0, $hhYxc.currentEnv){
        case 'dev':
        case 'local':
            return 'f0f574a2-4bcc-4049-a7d3-6a08637916e0';
        case 'stg':
        case 'stg-ic':
            return 'de816d56-15e9-402b-8d1b-09ab6175bb1c';
        case 'stg-fedm':
            return '487d67c3-d876-46d4-ac06-7a4b066e5b78';
        case 'prod-fedm':
            return 'e8a35d9c-f310-4842-9141-66e28cd0d395';
        case 'prod':
        case 'prod-ic':
        default:
            return 'af2669c5-bf1e-48d6-b37d-a8514b7073d2';
    }
};
const $9e08a6841eb6f575$export$ca7b7b70279af0 = (dynamicConfigs, configKey)=>{
    const configResult = dynamicConfigs.getBoolean(configKey);
    if ('value' in configResult) return configResult.value;
    return false;
};

});


parcelRegister("ei3NI", function(module, exports) {

$parcel$export(module.exports, "initializeDynamicConfigs", function () { return $cffb733ff60ef715$export$d00723e9d793f99d; });
$parcel$export(module.exports, "DynamicConfigsContext", function () { return $cffb733ff60ef715$export$70e7649e6de93d3; });
$parcel$export(module.exports, "useDynamicConfigs", function () { return $cffb733ff60ef715$export$d18460a0831bab92; });

var $dNMDr = parcelRequire("dNMDr");

var $7GQWp = parcelRequire("7GQWp");
var $k6WCb = parcelRequire("k6WCb");

var $lDj5O = parcelRequire("lDj5O");

var $hqddj = parcelRequire("hqddj");

var $hhYxc = parcelRequire("hhYxc");

var $2v29v = parcelRequire("2v29v");
const $cffb733ff60ef715$var$getDynamicConfigsClientBaseUrl = ()=>{
    const env = (0, $hhYxc.getCurrentEnv)();
    const getIcUrl = ()=>{
        const icLabel = (0, $2v29v.getIcLabel)();
        if (icLabel) return env === 'stg-ic' ? `https://api.${icLabel}.oasis-stg.com/flags` : `https://api.${icLabel}.atlassian-isolated.net/flags`;
        console.warn(`IC label not found for ${env} IC environment`);
        return null;
    };
    // Provided by https://atlaskit.atlassian.com/packages/measurement/web-config-client
    switch(env){
        case 'dev':
        case 'local':
            return 'https://api.dev.atlassian.com/flags';
        case 'stg':
            return 'https://api.stg.atlassian.com/flags';
        case 'stg-ic':
            return getIcUrl();
        case 'stg-fedm':
        case 'prod-fedm':
            // see https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-74313/about to track FedRAMP availability
            return null;
        case 'prod-ic':
            return getIcUrl();
        case 'prod':
        default:
            return 'https://api.atlassian.com/flags';
    }
};
const $cffb733ff60ef715$export$f636ae968f78fa38 = 10000;
const $cffb733ff60ef715$export$d00723e9d793f99d = async (analyticsAnonymousId)=>{
    if ((0, $hhYxc.isFedM)()) {
        console.warn('Statsig dynamic configs are disabled for this environment');
        return (0, $k6WCb.ConfigCollection).empty();
    }
    const baseUrl = $cffb733ff60ef715$var$getDynamicConfigsClientBaseUrl();
    if (baseUrl === null) return (0, $k6WCb.ConfigCollection).empty();
    try {
        return await (0, $7GQWp.ConfigClient).fetch({
            ffsBaseUrl: baseUrl,
            ffsApiKey: (0, $lDj5O.getStatsigApiKey)(),
            context: {
                namespace: (0, $lDj5O.statsigTargetApp),
                // this uses a subset of the identifiers that the feature gates client uses. We can add more in future if they are needed.
                identifiers: {
                    analyticsAnonymousId: analyticsAnonymousId
                },
                metadata: {}
            },
            fetch: (input, init)=>fetch(input, {
                    ...init,
                    signal: AbortSignal?.timeout?.($cffb733ff60ef715$export$f636ae968f78fa38)
                })
        });
    } catch (error) {
        (0, $hqddj.captureException)(error);
        console.error('Error creating Statsig dynamic config collection. Falling back to empty collection.');
        return (0, $k6WCb.ConfigCollection).empty();
    }
};
const $cffb733ff60ef715$export$70e7649e6de93d3 = (0, $dNMDr.createContext)(undefined);
const $cffb733ff60ef715$export$d18460a0831bab92 = ()=>{
    const context = (0, $dNMDr.useContext)($cffb733ff60ef715$export$70e7649e6de93d3);
    if (!context) throw new Error('useDynamicConfigsClient used outside of DynamicConfigsClientProvider.');
    return context;
};

});
parcelRegister("7GQWp", function(module, exports) {

$parcel$export(module.exports, "ConfigClient", function () { return $599585aa0f847960$export$8489e2f039bfcc4c; });

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $axdfd = parcelRequire("axdfd");

var $k6WCb = parcelRequire("k6WCb");
var $599585aa0f847960$export$8489e2f039bfcc4c = /*#__PURE__*/ function() {
    function ConfigClient() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ConfigClient);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ConfigClient, null, [
        {
            key: "fetch",
            value: function() {
                var _fetch = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(options) {
                    var _options$fetch;
                    var fetch, response, valuesPayload;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                fetch = (_options$fetch = options.fetch) !== null && _options$fetch !== void 0 ? _options$fetch : globalThis.fetch;
                                _context.next = 3;
                                return fetch("".concat(options.ffsBaseUrl, "/api/v2/configurations"), {
                                    method: 'POST',
                                    body: JSON.stringify(options.context),
                                    headers: {
                                        'content-type': 'application/json',
                                        'x-api-key': options.ffsApiKey
                                    }
                                });
                            case 3:
                                response = _context.sent;
                                if (response.ok) {
                                    _context.next = 12;
                                    break;
                                }
                                _context.t0 = Error;
                                _context.t1 = "Unexpected response ".concat(response.status, ": ");
                                _context.next = 9;
                                return response.text();
                            case 9:
                                _context.t2 = _context.sent;
                                _context.t3 = _context.t1.concat.call(_context.t1, _context.t2);
                                throw new _context.t0(_context.t3);
                            case 12:
                                _context.next = 14;
                                return response.text();
                            case 14:
                                valuesPayload = _context.sent;
                                return _context.abrupt("return", (0, $k6WCb.ConfigCollection).fromValues(valuesPayload));
                            case 16:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function fetch(_x) {
                    return _fetch.apply(this, arguments);
                }
                return fetch;
            }()
        }
    ]);
}();

});
parcelRegister("k6WCb", function(module, exports) {

$parcel$export(module.exports, "ConfigCollection", function () { return $ea41d5e0d54d3cb6$export$2be5653e4dada0a3; });

var $c9XBY = parcelRequire("c9XBY");

var $lPkGR = parcelRequire("lPkGR");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $enV8I = parcelRequire("enV8I");

var $6Vj56 = parcelRequire("6Vj56");

var $fhxuY = parcelRequire("fhxuY");
function $ea41d5e0d54d3cb6$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $ea41d5e0d54d3cb6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $ea41d5e0d54d3cb6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ea41d5e0d54d3cb6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ea41d5e0d54d3cb6$export$f9c837a54db411d = /*#__PURE__*/ function(_Error) {
    function ParseError(message, cause) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ParseError);
        _this = $ea41d5e0d54d3cb6$var$_callSuper(this, ParseError, [
            message
        ]);
        _this.cause = cause;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(ParseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ParseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Vj56)))(Error));
function $ea41d5e0d54d3cb6$var$safeParse(json) {
    try {
        return {
            data: (0, $fhxuY.AnyConfigSchema).parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $ea41d5e0d54d3cb6$export$f9c837a54db411d('An unknown error occurred during parsing', error)
        };
    }
}
var $ea41d5e0d54d3cb6$export$2be5653e4dada0a3 = /*#__PURE__*/ function() {
    function ConfigCollection(config) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ConfigCollection);
        this.config = config;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ConfigCollection, [
        {
            key: "toJson",
            value: function toJson(format) {
                switch(format){
                    case 'standard':
                        return JSON.stringify((0, $fhxuY.mapToStandard)(this.config));
                    case 'minimal':
                        return JSON.stringify((0, $fhxuY.mapToMinimal)(this.config));
                }
            }
        },
        {
            key: "getBoolean",
            value: function getBoolean(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $fhxuY.ConfigError).NotFound
                };
                var value = config.value;
                if (typeof value !== 'boolean') return {
                    error: (0, $fhxuY.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getString",
            value: function getString(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $fhxuY.ConfigError).NotFound
                };
                var value = config.value;
                if (typeof value !== 'string') return {
                    error: (0, $fhxuY.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getNumber",
            value: function getNumber(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $fhxuY.ConfigError).NotFound
                };
                var value = config.value;
                if (typeof value !== 'number') return {
                    error: (0, $fhxuY.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getStringList",
            value: function getStringList(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $fhxuY.ConfigError).NotFound
                };
                var value = config.value;
                if (!Array.isArray(value) || !value.every(function(x) {
                    return typeof x === 'string';
                })) return {
                    error: (0, $fhxuY.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getNumberList",
            value: function getNumberList(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $fhxuY.ConfigError).NotFound
                };
                var value = config.value;
                if (!Array.isArray(value) || !value.every(function(x) {
                    return typeof x === 'number';
                })) return {
                    error: (0, $fhxuY.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        }
    ], [
        {
            key: "fromValues",
            value: function fromValues(values, options) {
                var result = $ea41d5e0d54d3cb6$var$safeParse(values);
                if (!result.success) {
                    var parseError = new $ea41d5e0d54d3cb6$export$f9c837a54db411d('Failed to deserialize config', result.error);
                    if (options !== null && options !== void 0 && options.throw) throw parseError;
                    // eslint-disable-next-line no-console
                    console.error(parseError);
                    return ConfigCollection.empty();
                }
                return new ConfigCollection(Array.isArray(result.data) ? (0, $fhxuY.minimalToMap)(result.data) : (0, $fhxuY.standardToMap)(result.data));
            }
        },
        {
            key: "empty",
            value: function empty() {
                return new ConfigCollection(new Map());
            }
        }
    ]);
}();

});
parcelRegister("fhxuY", function(module, exports) {

$parcel$export(module.exports, "ConfigError", function () { return $b2026da6ed4569f1$export$c5fb415882705cf4; });
$parcel$export(module.exports, "AnyConfigSchema", function () { return $b2026da6ed4569f1$export$960d45de79bd7d81; });
$parcel$export(module.exports, "minimalToMap", function () { return $b2026da6ed4569f1$export$c29ba52779f58587; });
$parcel$export(module.exports, "standardToMap", function () { return $b2026da6ed4569f1$export$be5b69ecb011d7cc; });
$parcel$export(module.exports, "mapToMinimal", function () { return $b2026da6ed4569f1$export$460f06addafd9f86; });
$parcel$export(module.exports, "mapToStandard", function () { return $b2026da6ed4569f1$export$9d0101ad8235e092; });

var $a3ftr = parcelRequire("a3ftr");

var $82V4i = parcelRequire("82V4i");

var $erSnm = parcelRequire("erSnm");
function $b2026da6ed4569f1$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b2026da6ed4569f1$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b2026da6ed4569f1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b2026da6ed4569f1$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b2026da6ed4569f1$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b2026da6ed4569f1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b2026da6ed4569f1$export$c5fb415882705cf4 = /*#__PURE__*/ function(ConfigError) {
    ConfigError["NotFound"] = "not_found";
    ConfigError["InvalidState"] = "state_invalid";
    ConfigError["IncorrectType"] = "incorrect_type";
    return ConfigError;
}({});
var $b2026da6ed4569f1$export$e94ee64b2671e155 = $erSnm.record($erSnm.string(), $erSnm.object({
    value: $erSnm.union([
        $erSnm.boolean(),
        $erSnm.string(),
        $erSnm.number(),
        $erSnm.string().array(),
        $erSnm.number().array()
    ])
}));
var $b2026da6ed4569f1$export$e38f7b10db0e126a = $erSnm.tuple([
    // list of boolean configs which are on
    $erSnm.string().array(),
    // list of string config tuples
    $erSnm.array($erSnm.string()).refine(function(arr) {
        return arr.length % 2 === 0;
    }),
    // list of number config tuples
    $erSnm.array($erSnm.union([
        $erSnm.string(),
        $erSnm.number()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== 'string') return false;
            if (typeof arr[i + 1] !== 'number') return false;
        }
        return true;
    }),
    // list of string list config tuples
    $erSnm.array($erSnm.union([
        $erSnm.string(),
        $erSnm.string().array()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            var key = arr[i];
            var val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every(function(x) {
                return typeof x === 'string';
            })) return false;
        }
        return true;
    }),
    // list of number list config tuples
    $erSnm.array($erSnm.union([
        $erSnm.string(),
        $erSnm.number().array()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            var key = arr[i];
            var val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every(function(x) {
                return typeof x === 'number';
            })) return false;
        }
        return true;
    })
]);
var $b2026da6ed4569f1$export$960d45de79bd7d81 = $erSnm.union([
    $b2026da6ed4569f1$export$e94ee64b2671e155,
    $b2026da6ed4569f1$export$e38f7b10db0e126a
]);
var $b2026da6ed4569f1$export$ac2e9c88ba5d7cbb = $erSnm.map($erSnm.string(), $erSnm.object({
    value: $erSnm.union([
        $erSnm.boolean(),
        $erSnm.string(),
        $erSnm.number(),
        $erSnm.string().array(),
        $erSnm.number().array()
    ])
}));
function $b2026da6ed4569f1$var$pairs(arr, fn) {
    for(var i = 0; i < arr.length; i += 2){
        var key = arr[i];
        var val = arr[i + 1];
        if (typeof key !== 'string') throw new Error("Expected a string while iterating pairs, got: ".concat(arr[i]));
        fn(key, val);
    }
}
function $b2026da6ed4569f1$export$c29ba52779f58587(minimal) {
    var map = new Map();
    minimal[0].forEach(function(boolean) {
        return map.set(boolean, {
            value: true
        });
    });
    $b2026da6ed4569f1$var$pairs(minimal[1], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $b2026da6ed4569f1$var$pairs(minimal[2], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $b2026da6ed4569f1$var$pairs(minimal[3], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $b2026da6ed4569f1$var$pairs(minimal[4], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    return map;
}
function $b2026da6ed4569f1$export$be5b69ecb011d7cc(standard) {
    var map = new Map();
    Object.entries(standard).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        return map.set(key, value);
    });
    return map;
}
function $b2026da6ed4569f1$export$460f06addafd9f86(map) {
    var minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    var _iterator = $b2026da6ed4569f1$var$_createForOfIteratorHelper(map.entries()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_step.value, 2), key = _step$value[0], value = _step$value[1].value;
            switch((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(value)){
                case 'boolean':
                    if (value) minimal[0].push(key);
                    break;
                case 'string':
                    minimal[1].push(key, value);
                    break;
                case 'number':
                    minimal[2].push(key, value);
                    break;
                default:
                    if (!Array.isArray(value)) throw new Error("Unexpected configuration value: ".concat(value));
                    var allStrings = value.every(function(x) {
                        return typeof x === 'string';
                    });
                    if (allStrings) {
                        minimal[3].push(key, value);
                        break;
                    }
                    var allNumbers = value.every(function(x) {
                        return typeof x === 'number';
                    });
                    if (allNumbers) {
                        minimal[4].push(key, value);
                        break;
                    }
                    throw new Error("Unexpected configuration value: ".concat(value));
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return minimal;
}
function $b2026da6ed4569f1$export$9d0101ad8235e092(map) {
    return Object.fromEntries(map.entries());
}

});
parcelRegister("erSnm", function(module, exports) {

$parcel$export(module.exports, "string", function () { return $a84dc42f63a10edf$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $a84dc42f63a10edf$export$98e628dec113755e; });
$parcel$export(module.exports, "boolean", function () { return $a84dc42f63a10edf$export$4a21f16c33752377; });
$parcel$export(module.exports, "array", function () { return $a84dc42f63a10edf$export$2f23118c22fb2630; });
$parcel$export(module.exports, "object", function () { return $a84dc42f63a10edf$export$be5493f9613cbbe; });
$parcel$export(module.exports, "union", function () { return $a84dc42f63a10edf$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "tuple", function () { return $a84dc42f63a10edf$export$65e3907585753458; });
$parcel$export(module.exports, "record", function () { return $a84dc42f63a10edf$export$e5185e241753e543; });
$parcel$export(module.exports, "map", function () { return $a84dc42f63a10edf$export$871de8747c9eaa88; });

var $aK6zQ = parcelRequire("aK6zQ");
parcelRequire("gjtAo");
var $9Noby = parcelRequire("9Noby");
var $gjtAo = parcelRequire("gjtAo");

var $5Vwu6 = parcelRequire("5Vwu6");

var $jqJZD = parcelRequire("jqJZD");

var $km89X = parcelRequire("km89X");
class $a84dc42f63a10edf$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $a84dc42f63a10edf$var$handleResult = (ctx, result)=>{
    if ((0, $jqJZD.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new (0, $aK6zQ.ZodError)(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $a84dc42f63a10edf$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, $km89X.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, $km89X.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new (0, $jqJZD.ParseStatus)(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, $km89X.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, $jqJZD.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $km89X.getParsedType)(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $a84dc42f63a10edf$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $km89X.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return (0, $jqJZD.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>(0, $jqJZD.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $km89X.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, $jqJZD.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $a84dc42f63a10edf$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: (0, $aK6zQ.ZodIssueCode).custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $a84dc42f63a10edf$export$a60af00cc0ce2582({
            schema: this,
            typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $a84dc42f63a10edf$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $a84dc42f63a10edf$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $a84dc42f63a10edf$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $a84dc42f63a10edf$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $a84dc42f63a10edf$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $a84dc42f63a10edf$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $a84dc42f63a10edf$export$a60af00cc0ce2582({
            ...$a84dc42f63a10edf$var$processCreateParams(this._def),
            schema: this,
            typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $a84dc42f63a10edf$export$bb19b37874861e7e({
            ...$a84dc42f63a10edf$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $a84dc42f63a10edf$export$66b0c798a395271f({
            typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$a84dc42f63a10edf$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $a84dc42f63a10edf$export$75a44ec6249ac76b({
            ...$a84dc42f63a10edf$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $a84dc42f63a10edf$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $a84dc42f63a10edf$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $a84dc42f63a10edf$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $a84dc42f63a10edf$var$cuid2Regex = /^[0-9a-z]+$/;
const $a84dc42f63a10edf$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $a84dc42f63a10edf$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $a84dc42f63a10edf$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $a84dc42f63a10edf$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $a84dc42f63a10edf$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $a84dc42f63a10edf$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $a84dc42f63a10edf$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $a84dc42f63a10edf$var$emojiRegex;
// faster, simpler, safer
const $a84dc42f63a10edf$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $a84dc42f63a10edf$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $a84dc42f63a10edf$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $a84dc42f63a10edf$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $a84dc42f63a10edf$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $a84dc42f63a10edf$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $a84dc42f63a10edf$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $a84dc42f63a10edf$var$dateRegex = new RegExp(`^${$a84dc42f63a10edf$var$dateRegexSource}$`);
function $a84dc42f63a10edf$var$timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function $a84dc42f63a10edf$var$timeRegex(args) {
    return new RegExp(`^${$a84dc42f63a10edf$var$timeRegexSource(args)}$`);
}
function $a84dc42f63a10edf$export$a4b563879add27a(args) {
    let regex = `${$a84dc42f63a10edf$var$dateRegexSource}T${$a84dc42f63a10edf$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $a84dc42f63a10edf$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $a84dc42f63a10edf$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $a84dc42f63a10edf$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $a84dc42f63a10edf$var$isValidJWT(jwt, alg) {
    if (!$a84dc42f63a10edf$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function $a84dc42f63a10edf$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $a84dc42f63a10edf$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $a84dc42f63a10edf$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $a84dc42f63a10edf$export$1230eb29b8d3b502 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $km89X.ZodParsedType).string) {
            const ctx = this._getOrReturnCtx(input);
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).string,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        const status = new (0, $jqJZD.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$a84dc42f63a10edf$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "email",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$a84dc42f63a10edf$var$emojiRegex) $a84dc42f63a10edf$var$emojiRegex = new RegExp($a84dc42f63a10edf$var$_emojiRegex, "u");
                if (!$a84dc42f63a10edf$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$a84dc42f63a10edf$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$a84dc42f63a10edf$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$a84dc42f63a10edf$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$a84dc42f63a10edf$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$a84dc42f63a10edf$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, $jqJZD.addIssueToContext)(ctx, {
                    validation: "url",
                    code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $a84dc42f63a10edf$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $a84dc42f63a10edf$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $a84dc42f63a10edf$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$a84dc42f63a10edf$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$a84dc42f63a10edf$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$a84dc42f63a10edf$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$a84dc42f63a10edf$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$a84dc42f63a10edf$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$a84dc42f63a10edf$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: (0, $aK6zQ.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $km89X.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: (0, $aK6zQ.ZodIssueCode).invalid_string,
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    _addCheck(check) {
        return new $a84dc42f63a10edf$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...(0, $5Vwu6.errorUtil).errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...(0, $5Vwu6.errorUtil).errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...(0, $5Vwu6.errorUtil).errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...(0, $5Vwu6.errorUtil).errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...(0, $5Vwu6.errorUtil).errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...(0, $5Vwu6.errorUtil).errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...(0, $5Vwu6.errorUtil).errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, (0, $5Vwu6.errorUtil).errToObj(message));
    }
    trim() {
        return new $a84dc42f63a10edf$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $a84dc42f63a10edf$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $a84dc42f63a10edf$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$a84dc42f63a10edf$export$1230eb29b8d3b502.create = (params)=>{
    return new $a84dc42f63a10edf$export$1230eb29b8d3b502({
        checks: [],
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodString,
        coerce: params?.coerce ?? false,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $a84dc42f63a10edf$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class $a84dc42f63a10edf$export$5b070a55c0c43e09 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $km89X.ZodParsedType).number) {
            const ctx = this._getOrReturnCtx(input);
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).number,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        let ctx = undefined;
        const status = new (0, $jqJZD.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!(0, $km89X.util).isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($a84dc42f63a10edf$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $km89X.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $5Vwu6.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $5Vwu6.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $5Vwu6.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $5Vwu6.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $a84dc42f63a10edf$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $5Vwu6.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $a84dc42f63a10edf$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: (0, $5Vwu6.errorUtil).toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && (0, $km89X.util).isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$a84dc42f63a10edf$export$5b070a55c0c43e09.create = (params)=>{
    return new $a84dc42f63a10edf$export$5b070a55c0c43e09({
        checks: [],
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodNumber,
        coerce: params?.coerce || false,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$67d741fd70ff98f4 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== (0, $km89X.ZodParsedType).bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new (0, $jqJZD.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $km89X.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $jqJZD.addIssueToContext)(ctx, {
            code: (0, $aK6zQ.ZodIssueCode).invalid_type,
            expected: (0, $km89X.ZodParsedType).bigint,
            received: ctx.parsedType
        });
        return 0, $jqJZD.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $5Vwu6.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $5Vwu6.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $5Vwu6.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $5Vwu6.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $a84dc42f63a10edf$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $5Vwu6.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $a84dc42f63a10edf$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$a84dc42f63a10edf$export$67d741fd70ff98f4.create = (params)=>{
    return new $a84dc42f63a10edf$export$67d741fd70ff98f4({
        checks: [],
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$723d146f80596191 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $km89X.ZodParsedType).boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).boolean,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        return (0, $jqJZD.OK)(input.data);
    }
}
$a84dc42f63a10edf$export$723d146f80596191.create = (params)=>{
    return new $a84dc42f63a10edf$export$723d146f80596191({
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodBoolean,
        coerce: params?.coerce || false,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$e974be33bdc55521 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $km89X.ZodParsedType).date) {
            const ctx = this._getOrReturnCtx(input);
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).date,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_date
            });
            return 0, $jqJZD.INVALID;
        }
        const status = new (0, $jqJZD.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else (0, $km89X.util).assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $a84dc42f63a10edf$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: (0, $5Vwu6.errorUtil).toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$a84dc42f63a10edf$export$e974be33bdc55521.create = (params)=>{
    return new $a84dc42f63a10edf$export$e974be33bdc55521({
        checks: [],
        coerce: params?.coerce || false,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodDate,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$bcc3b40f6b638044 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $km89X.ZodParsedType).symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).symbol,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        return (0, $jqJZD.OK)(input.data);
    }
}
$a84dc42f63a10edf$export$bcc3b40f6b638044.create = (params)=>{
    return new $a84dc42f63a10edf$export$bcc3b40f6b638044({
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodSymbol,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$4e780e961c30340d extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $km89X.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).undefined,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        return (0, $jqJZD.OK)(input.data);
    }
}
$a84dc42f63a10edf$export$4e780e961c30340d.create = (params)=>{
    return new $a84dc42f63a10edf$export$4e780e961c30340d({
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodUndefined,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$a96281f914484f2d extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $km89X.ZodParsedType).null) {
            const ctx = this._getOrReturnCtx(input);
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).null,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        return (0, $jqJZD.OK)(input.data);
    }
}
$a84dc42f63a10edf$export$a96281f914484f2d.create = (params)=>{
    return new $a84dc42f63a10edf$export$a96281f914484f2d({
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodNull,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$b9d1edb536b4e4eb extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, $jqJZD.OK)(input.data);
    }
}
$a84dc42f63a10edf$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $a84dc42f63a10edf$export$b9d1edb536b4e4eb({
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodAny,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$ef3b1bb1630977ae extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, $jqJZD.OK)(input.data);
    }
}
$a84dc42f63a10edf$export$ef3b1bb1630977ae.create = (params)=>{
    return new $a84dc42f63a10edf$export$ef3b1bb1630977ae({
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodUnknown,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$1e576a20c3ce9fb5 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $jqJZD.addIssueToContext)(ctx, {
            code: (0, $aK6zQ.ZodIssueCode).invalid_type,
            expected: (0, $km89X.ZodParsedType).never,
            received: ctx.parsedType
        });
        return 0, $jqJZD.INVALID;
    }
}
$a84dc42f63a10edf$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $a84dc42f63a10edf$export$1e576a20c3ce9fb5({
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodNever,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$7d39f5df85f21031 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $km89X.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).void,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        return (0, $jqJZD.OK)(input.data);
    }
}
$a84dc42f63a10edf$export$7d39f5df85f21031.create = (params)=>{
    return new $a84dc42f63a10edf$export$7d39f5df85f21031({
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodVoid,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$7acfc3e64785411 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== (0, $km89X.ZodParsedType).array) {
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, $jqJZD.addIssueToContext)(ctx, {
                    code: tooBig ? (0, $aK6zQ.ZodIssueCode).too_big : (0, $aK6zQ.ZodIssueCode).too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, $jqJZD.addIssueToContext)(ctx, {
                    code: (0, $aK6zQ.ZodIssueCode).too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, $jqJZD.addIssueToContext)(ctx, {
                    code: (0, $aK6zQ.ZodIssueCode).too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $a84dc42f63a10edf$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return (0, $jqJZD.ParseStatus).mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $a84dc42f63a10edf$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return (0, $jqJZD.ParseStatus).mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $a84dc42f63a10edf$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: (0, $5Vwu6.errorUtil).toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $a84dc42f63a10edf$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: (0, $5Vwu6.errorUtil).toString(message)
            }
        });
    }
    length(len, message) {
        return new $a84dc42f63a10edf$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: (0, $5Vwu6.errorUtil).toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$a84dc42f63a10edf$export$7acfc3e64785411.create = (schema, params)=>{
    return new $a84dc42f63a10edf$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodArray,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
function $a84dc42f63a10edf$var$deepPartialify(schema) {
    if (schema instanceof $a84dc42f63a10edf$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $a84dc42f63a10edf$export$aa56fec1e9d629b8.create($a84dc42f63a10edf$var$deepPartialify(fieldSchema));
        }
        return new $a84dc42f63a10edf$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $a84dc42f63a10edf$export$7acfc3e64785411) return new $a84dc42f63a10edf$export$7acfc3e64785411({
        ...schema._def,
        type: $a84dc42f63a10edf$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $a84dc42f63a10edf$export$aa56fec1e9d629b8) return $a84dc42f63a10edf$export$aa56fec1e9d629b8.create($a84dc42f63a10edf$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $a84dc42f63a10edf$export$aaac0b8b429cef5) return $a84dc42f63a10edf$export$aaac0b8b429cef5.create($a84dc42f63a10edf$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $a84dc42f63a10edf$export$e2a18bb771d8e6a3) return $a84dc42f63a10edf$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$a84dc42f63a10edf$var$deepPartialify(item)));
    else return schema;
}
class $a84dc42f63a10edf$export$736315c5b55efbad extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = (0, $km89X.util).objectKeys(shape);
        this._cached = {
            shape: shape,
            keys: keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $km89X.ZodParsedType).object) {
            const ctx = this._getOrReturnCtx(input);
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $a84dc42f63a10edf$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $a84dc42f63a10edf$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $a84dc42f63a10edf$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, $jqJZD.addIssueToContext)(ctx, {
                        code: (0, $aK6zQ.ZodIssueCode).unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $a84dc42f63a10edf$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return (0, $jqJZD.ParseStatus).mergeObjectSync(status, syncPairs);
        });
        else return (0, $jqJZD.ParseStatus).mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        (0, $5Vwu6.errorUtil).errToObj;
        return new $a84dc42f63a10edf$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (0, $5Vwu6.errorUtil).errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $a84dc42f63a10edf$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $a84dc42f63a10edf$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $a84dc42f63a10edf$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $a84dc42f63a10edf$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $a84dc42f63a10edf$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of (0, $km89X.util).objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new $a84dc42f63a10edf$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of (0, $km89X.util).objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new $a84dc42f63a10edf$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $a84dc42f63a10edf$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of (0, $km89X.util).objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new $a84dc42f63a10edf$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of (0, $km89X.util).objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof $a84dc42f63a10edf$export$aa56fec1e9d629b8)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new $a84dc42f63a10edf$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $a84dc42f63a10edf$var$createZodEnum((0, $km89X.util).objectKeys(this.shape));
    }
}
$a84dc42f63a10edf$export$736315c5b55efbad.create = (shape, params)=>{
    return new $a84dc42f63a10edf$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $a84dc42f63a10edf$export$1e576a20c3ce9fb5.create(),
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodObject,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
$a84dc42f63a10edf$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $a84dc42f63a10edf$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $a84dc42f63a10edf$export$1e576a20c3ce9fb5.create(),
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodObject,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
$a84dc42f63a10edf$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $a84dc42f63a10edf$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $a84dc42f63a10edf$export$1e576a20c3ce9fb5.create(),
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodObject,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$a8b236cb5070a311 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new (0, $aK6zQ.ZodError)(result.ctx.common.issues));
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $jqJZD.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new (0, $aK6zQ.ZodError)(issues));
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $jqJZD.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
$a84dc42f63a10edf$export$a8b236cb5070a311.create = (types, params)=>{
    return new $a84dc42f63a10edf$export$a8b236cb5070a311({
        options: types,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodUnion,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $a84dc42f63a10edf$var$getDiscriminator = (type)=>{
    if (type instanceof $a84dc42f63a10edf$export$378d0cfce37406e6) return $a84dc42f63a10edf$var$getDiscriminator(type.schema);
    else if (type instanceof $a84dc42f63a10edf$export$a60af00cc0ce2582) return $a84dc42f63a10edf$var$getDiscriminator(type.innerType());
    else if (type instanceof $a84dc42f63a10edf$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $a84dc42f63a10edf$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $a84dc42f63a10edf$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return (0, $km89X.util).objectValues(type.enum);
    else if (type instanceof $a84dc42f63a10edf$export$bb19b37874861e7e) return $a84dc42f63a10edf$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $a84dc42f63a10edf$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $a84dc42f63a10edf$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $a84dc42f63a10edf$export$aa56fec1e9d629b8) return [
        undefined,
        ...$a84dc42f63a10edf$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $a84dc42f63a10edf$export$aaac0b8b429cef5) return [
        null,
        ...$a84dc42f63a10edf$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $a84dc42f63a10edf$export$66b0c798a395271f) return $a84dc42f63a10edf$var$getDiscriminator(type.unwrap());
    else if (type instanceof $a84dc42f63a10edf$export$5d1f7ef05c4e493a) return $a84dc42f63a10edf$var$getDiscriminator(type.unwrap());
    else if (type instanceof $a84dc42f63a10edf$export$75a44ec6249ac76b) return $a84dc42f63a10edf$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $a84dc42f63a10edf$export$5ef2424805ac76a3 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $km89X.ZodParsedType).object) {
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return 0, $jqJZD.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $a84dc42f63a10edf$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $a84dc42f63a10edf$export$5ef2424805ac76a3({
            typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$a84dc42f63a10edf$var$processCreateParams(params)
        });
    }
}
function $a84dc42f63a10edf$var$mergeValues(a, b) {
    const aType = (0, $km89X.getParsedType)(a);
    const bType = (0, $km89X.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === (0, $km89X.ZodParsedType).object && bType === (0, $km89X.ZodParsedType).object) {
        const bKeys = (0, $km89X.util).objectKeys(b);
        const sharedKeys = (0, $km89X.util).objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $a84dc42f63a10edf$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === (0, $km89X.ZodParsedType).array && bType === (0, $km89X.ZodParsedType).array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $a84dc42f63a10edf$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === (0, $km89X.ZodParsedType).date && bType === (0, $km89X.ZodParsedType).date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $a84dc42f63a10edf$export$c02deaf0bb5203d4 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, $jqJZD.isAborted)(parsedLeft) || (0, $jqJZD.isAborted)(parsedRight)) return 0, $jqJZD.INVALID;
            const merged = $a84dc42f63a10edf$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, $jqJZD.addIssueToContext)(ctx, {
                    code: (0, $aK6zQ.ZodIssueCode).invalid_intersection_types
                });
                return 0, $jqJZD.INVALID;
            }
            if ((0, $jqJZD.isDirty)(parsedLeft) || (0, $jqJZD.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$a84dc42f63a10edf$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $a84dc42f63a10edf$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodIntersection,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$e2a18bb771d8e6a3 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $km89X.ZodParsedType).array) {
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return 0, $jqJZD.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $a84dc42f63a10edf$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return (0, $jqJZD.ParseStatus).mergeArray(status, results);
        });
        else return (0, $jqJZD.ParseStatus).mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $a84dc42f63a10edf$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$a84dc42f63a10edf$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $a84dc42f63a10edf$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$a2acc09968cb4b7f extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $km89X.ZodParsedType).object) {
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $a84dc42f63a10edf$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $a84dc42f63a10edf$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return (0, $jqJZD.ParseStatus).mergeObjectAsync(status, pairs);
        else return (0, $jqJZD.ParseStatus).mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $a84dc42f63a10edf$export$2afb8ab49d4b92c0) return new $a84dc42f63a10edf$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodRecord,
            ...$a84dc42f63a10edf$var$processCreateParams(third)
        });
        return new $a84dc42f63a10edf$export$a2acc09968cb4b7f({
            keyType: $a84dc42f63a10edf$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodRecord,
            ...$a84dc42f63a10edf$var$processCreateParams(second)
        });
    }
}
class $a84dc42f63a10edf$export$163b6a2b712d9542 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $km89X.ZodParsedType).map) {
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).map,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $a84dc42f63a10edf$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $a84dc42f63a10edf$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return 0, $jqJZD.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return 0, $jqJZD.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$a84dc42f63a10edf$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $a84dc42f63a10edf$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodMap,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$977057706f816712 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $km89X.ZodParsedType).set) {
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).set,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, $jqJZD.addIssueToContext)(ctx, {
                    code: (0, $aK6zQ.ZodIssueCode).too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, $jqJZD.addIssueToContext)(ctx, {
                    code: (0, $aK6zQ.ZodIssueCode).too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return 0, $jqJZD.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $a84dc42f63a10edf$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $a84dc42f63a10edf$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: (0, $5Vwu6.errorUtil).toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $a84dc42f63a10edf$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: (0, $5Vwu6.errorUtil).toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$a84dc42f63a10edf$export$977057706f816712.create = (valueType, params)=>{
    return new $a84dc42f63a10edf$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodSet,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$d4602ba55673f53c extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $km89X.ZodParsedType).function) {
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).function,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, $jqJZD.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $gjtAo.getErrorMap)(),
                    (0, $9Noby.default)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $aK6zQ.ZodIssueCode).invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, $jqJZD.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $gjtAo.getErrorMap)(),
                    (0, $9Noby.default)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $aK6zQ.ZodIssueCode).invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $a84dc42f63a10edf$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $jqJZD.OK)(async function(...args) {
                const error = new (0, $aK6zQ.ZodError)([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $jqJZD.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new (0, $aK6zQ.ZodError)([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new (0, $aK6zQ.ZodError)([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $a84dc42f63a10edf$export$d4602ba55673f53c({
            ...this._def,
            args: $a84dc42f63a10edf$export$e2a18bb771d8e6a3.create(items).rest($a84dc42f63a10edf$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $a84dc42f63a10edf$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $a84dc42f63a10edf$export$d4602ba55673f53c({
            args: args ? args : $a84dc42f63a10edf$export$e2a18bb771d8e6a3.create([]).rest($a84dc42f63a10edf$export$ef3b1bb1630977ae.create()),
            returns: returns || $a84dc42f63a10edf$export$ef3b1bb1630977ae.create(),
            typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodFunction,
            ...$a84dc42f63a10edf$var$processCreateParams(params)
        });
    }
}
class $a84dc42f63a10edf$export$378d0cfce37406e6 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$a84dc42f63a10edf$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $a84dc42f63a10edf$export$378d0cfce37406e6({
        getter: getter,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodLazy,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$7e44096782a165d3 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, $jqJZD.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $aK6zQ.ZodIssueCode).invalid_literal,
                expected: this._def.value
            });
            return 0, $jqJZD.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$a84dc42f63a10edf$export$7e44096782a165d3.create = (value, params)=>{
    return new $a84dc42f63a10edf$export$7e44096782a165d3({
        value: value,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodLiteral,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
function $a84dc42f63a10edf$var$createZodEnum(values, params) {
    return new $a84dc42f63a10edf$export$d325d1f0e1c20179({
        values: values,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodEnum,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
}
class $a84dc42f63a10edf$export$d325d1f0e1c20179 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $jqJZD.addIssueToContext)(ctx, {
                expected: (0, $km89X.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $aK6zQ.ZodIssueCode).invalid_type
            });
            return 0, $jqJZD.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $jqJZD.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $aK6zQ.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, $jqJZD.INVALID;
        }
        return (0, $jqJZD.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $a84dc42f63a10edf$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $a84dc42f63a10edf$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$a84dc42f63a10edf$export$d325d1f0e1c20179.create = $a84dc42f63a10edf$var$createZodEnum;
class $a84dc42f63a10edf$export$370b2e8d6d6f5c56 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const nativeEnumValues = (0, $km89X.util).getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== (0, $km89X.ZodParsedType).string && ctx.parsedType !== (0, $km89X.ZodParsedType).number) {
            const expectedValues = (0, $km89X.util).objectValues(nativeEnumValues);
            (0, $jqJZD.addIssueToContext)(ctx, {
                expected: (0, $km89X.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $aK6zQ.ZodIssueCode).invalid_type
            });
            return 0, $jqJZD.INVALID;
        }
        if (!this._cache) this._cache = new Set((0, $km89X.util).getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = (0, $km89X.util).objectValues(nativeEnumValues);
            (0, $jqJZD.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $aK6zQ.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, $jqJZD.INVALID;
        }
        return (0, $jqJZD.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$a84dc42f63a10edf$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $a84dc42f63a10edf$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodNativeEnum,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$3f196b0127d6e50a extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $km89X.ZodParsedType).promise && ctx.common.async === false) {
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).promise,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        const promisified = ctx.parsedType === (0, $km89X.ZodParsedType).promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, $jqJZD.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$a84dc42f63a10edf$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $a84dc42f63a10edf$export$3f196b0127d6e50a({
        type: schema,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodPromise,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$a60af00cc0ce2582 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $a84dc42f63a10edf$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, $jqJZD.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return 0, $jqJZD.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $jqJZD.INVALID;
                if (result.status === "dirty") return (0, $jqJZD.DIRTY)(result.value);
                if (status.value === "dirty") return (0, $jqJZD.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return 0, $jqJZD.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $jqJZD.INVALID;
                if (result.status === "dirty") return (0, $jqJZD.DIRTY)(result.value);
                if (status.value === "dirty") return (0, $jqJZD.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return 0, $jqJZD.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return 0, $jqJZD.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, $jqJZD.isValid)(base)) return 0, $jqJZD.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, $jqJZD.isValid)(base)) return 0, $jqJZD.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        (0, $km89X.util).assertNever(effect);
    }
}
$a84dc42f63a10edf$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $a84dc42f63a10edf$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
$a84dc42f63a10edf$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $a84dc42f63a10edf$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodEffects,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$aa56fec1e9d629b8 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $km89X.ZodParsedType).undefined) return (0, $jqJZD.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$a84dc42f63a10edf$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $a84dc42f63a10edf$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodOptional,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$aaac0b8b429cef5 extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $km89X.ZodParsedType).null) return (0, $jqJZD.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$a84dc42f63a10edf$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $a84dc42f63a10edf$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodNullable,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$bb19b37874861e7e extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === (0, $km89X.ZodParsedType).undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$a84dc42f63a10edf$export$bb19b37874861e7e.create = (type, params)=>{
    return new $a84dc42f63a10edf$export$bb19b37874861e7e({
        innerType: type,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$75a44ec6249ac76b extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, $jqJZD.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new (0, $aK6zQ.ZodError)(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new (0, $aK6zQ.ZodError)(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$a84dc42f63a10edf$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $a84dc42f63a10edf$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
class $a84dc42f63a10edf$export$26ccfa0145e8511f extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $km89X.ZodParsedType).nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, $jqJZD.addIssueToContext)(ctx, {
                code: (0, $aK6zQ.ZodIssueCode).invalid_type,
                expected: (0, $km89X.ZodParsedType).nan,
                received: ctx.parsedType
            });
            return 0, $jqJZD.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$a84dc42f63a10edf$export$26ccfa0145e8511f.create = (params)=>{
    return new $a84dc42f63a10edf$export$26ccfa0145e8511f({
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodNaN,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
const $a84dc42f63a10edf$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $a84dc42f63a10edf$export$66b0c798a395271f extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $a84dc42f63a10edf$export$a3c3ef8a0e95c6da extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return 0, $jqJZD.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, $jqJZD.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return 0, $jqJZD.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $a84dc42f63a10edf$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $a84dc42f63a10edf$export$5d1f7ef05c4e493a extends $a84dc42f63a10edf$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, $jqJZD.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, $jqJZD.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$a84dc42f63a10edf$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $a84dc42f63a10edf$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $a84dc42f63a10edf$export$558106ce543bd011.ZodReadonly,
        ...$a84dc42f63a10edf$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $a84dc42f63a10edf$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $a84dc42f63a10edf$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $a84dc42f63a10edf$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = $a84dc42f63a10edf$var$cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $a84dc42f63a10edf$var$cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $a84dc42f63a10edf$export$b9d1edb536b4e4eb.create();
}
const $a84dc42f63a10edf$export$1ee8ee30835eab8b = {
    object: $a84dc42f63a10edf$export$736315c5b55efbad.lazycreate
};
var $a84dc42f63a10edf$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($a84dc42f63a10edf$export$558106ce543bd011 || ($a84dc42f63a10edf$export$558106ce543bd011 = {}));
// requires TS 4.4+
class $a84dc42f63a10edf$var$Class {
    constructor(..._){}
}
const $a84dc42f63a10edf$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$a84dc42f63a10edf$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $a84dc42f63a10edf$export$22b082955e083ec3 = $a84dc42f63a10edf$export$1230eb29b8d3b502.create;
const $a84dc42f63a10edf$export$98e628dec113755e = $a84dc42f63a10edf$export$5b070a55c0c43e09.create;
const $a84dc42f63a10edf$export$9e06de0973666692 = $a84dc42f63a10edf$export$26ccfa0145e8511f.create;
const $a84dc42f63a10edf$export$a0f65b52274bcc00 = $a84dc42f63a10edf$export$67d741fd70ff98f4.create;
const $a84dc42f63a10edf$export$4a21f16c33752377 = $a84dc42f63a10edf$export$723d146f80596191.create;
const $a84dc42f63a10edf$export$324d90190a8b822a = $a84dc42f63a10edf$export$e974be33bdc55521.create;
const $a84dc42f63a10edf$export$8f701197936bc2a6 = $a84dc42f63a10edf$export$bcc3b40f6b638044.create;
const $a84dc42f63a10edf$export$1db45310990710a5 = $a84dc42f63a10edf$export$4e780e961c30340d.create;
const $a84dc42f63a10edf$export$7b1b591b262c240 = $a84dc42f63a10edf$export$a96281f914484f2d.create;
const $a84dc42f63a10edf$export$4154a199d7d90455 = $a84dc42f63a10edf$export$b9d1edb536b4e4eb.create;
const $a84dc42f63a10edf$export$19282c40b967aec6 = $a84dc42f63a10edf$export$ef3b1bb1630977ae.create;
const $a84dc42f63a10edf$export$b3e22bcfd64c1022 = $a84dc42f63a10edf$export$1e576a20c3ce9fb5.create;
const $a84dc42f63a10edf$export$490e536ee7389aeb = $a84dc42f63a10edf$export$7d39f5df85f21031.create;
const $a84dc42f63a10edf$export$2f23118c22fb2630 = $a84dc42f63a10edf$export$7acfc3e64785411.create;
const $a84dc42f63a10edf$export$be5493f9613cbbe = $a84dc42f63a10edf$export$736315c5b55efbad.create;
const $a84dc42f63a10edf$export$8fb0df5f40d0b477 = $a84dc42f63a10edf$export$736315c5b55efbad.strictCreate;
const $a84dc42f63a10edf$export$971dd5b0dfd021b6 = $a84dc42f63a10edf$export$a8b236cb5070a311.create;
const $a84dc42f63a10edf$export$4b888e40c4ee26dd = $a84dc42f63a10edf$export$5ef2424805ac76a3.create;
const $a84dc42f63a10edf$export$bc86dfbf7795668c = $a84dc42f63a10edf$export$c02deaf0bb5203d4.create;
const $a84dc42f63a10edf$export$65e3907585753458 = $a84dc42f63a10edf$export$e2a18bb771d8e6a3.create;
const $a84dc42f63a10edf$export$e5185e241753e543 = $a84dc42f63a10edf$export$a2acc09968cb4b7f.create;
const $a84dc42f63a10edf$export$871de8747c9eaa88 = $a84dc42f63a10edf$export$163b6a2b712d9542.create;
const $a84dc42f63a10edf$export$adaa4cf7ef1b65be = $a84dc42f63a10edf$export$977057706f816712.create;
const $a84dc42f63a10edf$export$44e51c8aac7c2deb = $a84dc42f63a10edf$export$d4602ba55673f53c.create;
const $a84dc42f63a10edf$export$488013bae63b21da = $a84dc42f63a10edf$export$378d0cfce37406e6.create;
const $a84dc42f63a10edf$export$c8ec6e1ec9fefcb0 = $a84dc42f63a10edf$export$7e44096782a165d3.create;
const $a84dc42f63a10edf$export$78a99c8d44d72635 = $a84dc42f63a10edf$export$d325d1f0e1c20179.create;
const $a84dc42f63a10edf$export$6fe7eca19ebe5199 = $a84dc42f63a10edf$export$370b2e8d6d6f5c56.create;
const $a84dc42f63a10edf$export$c957ef27a0ebfd4 = $a84dc42f63a10edf$export$3f196b0127d6e50a.create;
const $a84dc42f63a10edf$export$dc573d8a6576cdb3 = $a84dc42f63a10edf$export$a60af00cc0ce2582.create;
const $a84dc42f63a10edf$export$516e28dec6a4b6d4 = $a84dc42f63a10edf$export$aa56fec1e9d629b8.create;
const $a84dc42f63a10edf$export$133fc36489ac9add = $a84dc42f63a10edf$export$aaac0b8b429cef5.create;
const $a84dc42f63a10edf$export$fc37fe19dfda43ee = $a84dc42f63a10edf$export$a60af00cc0ce2582.createWithPreprocess;
const $a84dc42f63a10edf$export$43f28b24e1eb8181 = $a84dc42f63a10edf$export$a3c3ef8a0e95c6da.create;
const $a84dc42f63a10edf$export$3b3d07727c5b702c = ()=>$a84dc42f63a10edf$export$22b082955e083ec3().optional();
const $a84dc42f63a10edf$export$eb150471a61fced6 = ()=>$a84dc42f63a10edf$export$98e628dec113755e().optional();
const $a84dc42f63a10edf$export$269251733cdcbbf1 = ()=>$a84dc42f63a10edf$export$4a21f16c33752377().optional();
const $a84dc42f63a10edf$export$8c14e57e778d3873 = {
    string: (arg)=>$a84dc42f63a10edf$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$a84dc42f63a10edf$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$a84dc42f63a10edf$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$a84dc42f63a10edf$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$a84dc42f63a10edf$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $a84dc42f63a10edf$export$96c94437c95d7862 = (0, $jqJZD.INVALID);

});
parcelRegister("aK6zQ", function(module, exports) {

$parcel$export(module.exports, "ZodIssueCode", function () { return $7d234d57dc0d16d0$export$5ba560653e4a1035; });
$parcel$export(module.exports, "ZodError", function () { return $7d234d57dc0d16d0$export$f98dac4b251ab333; });

var $km89X = parcelRequire("km89X");
const $7d234d57dc0d16d0$export$5ba560653e4a1035 = (0, $km89X.util).arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $7d234d57dc0d16d0$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $7d234d57dc0d16d0$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $7d234d57dc0d16d0$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, (0, $km89X.util).jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$7d234d57dc0d16d0$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $7d234d57dc0d16d0$export$f98dac4b251ab333(issues);
    return error;
};

});
parcelRegister("km89X", function(module, exports) {

$parcel$export(module.exports, "util", function () { return $ed1c31101e745971$export$7debb50ef11d5e0b; });
$parcel$export(module.exports, "ZodParsedType", function () { return $ed1c31101e745971$export$5716da67bfaa244d; });
$parcel$export(module.exports, "getParsedType", function () { return $ed1c31101e745971$export$3e9057828ebd5c7a; });
var $ed1c31101e745971$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($ed1c31101e745971$export$7debb50ef11d5e0b || ($ed1c31101e745971$export$7debb50ef11d5e0b = {}));
var $ed1c31101e745971$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($ed1c31101e745971$export$4aa2142c225fd5c7 || ($ed1c31101e745971$export$4aa2142c225fd5c7 = {}));
const $ed1c31101e745971$export$5716da67bfaa244d = $ed1c31101e745971$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $ed1c31101e745971$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $ed1c31101e745971$export$5716da67bfaa244d.undefined;
        case "string":
            return $ed1c31101e745971$export$5716da67bfaa244d.string;
        case "number":
            return Number.isNaN(data) ? $ed1c31101e745971$export$5716da67bfaa244d.nan : $ed1c31101e745971$export$5716da67bfaa244d.number;
        case "boolean":
            return $ed1c31101e745971$export$5716da67bfaa244d.boolean;
        case "function":
            return $ed1c31101e745971$export$5716da67bfaa244d.function;
        case "bigint":
            return $ed1c31101e745971$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $ed1c31101e745971$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $ed1c31101e745971$export$5716da67bfaa244d.array;
            if (data === null) return $ed1c31101e745971$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $ed1c31101e745971$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $ed1c31101e745971$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $ed1c31101e745971$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $ed1c31101e745971$export$5716da67bfaa244d.date;
            return $ed1c31101e745971$export$5716da67bfaa244d.object;
        default:
            return $ed1c31101e745971$export$5716da67bfaa244d.unknown;
    }
};

});


parcelRegister("gjtAo", function(module, exports) {

$parcel$export(module.exports, "getErrorMap", function () { return $be055ee01f5c0372$export$32f27c719778d4c4; });
$parcel$export(module.exports, "defaultErrorMap", function () { return (parcelRequire("9Noby")).default; });

var $9Noby = parcelRequire("9Noby");
let $be055ee01f5c0372$var$overrideErrorMap = (0, $9Noby.default);
function $be055ee01f5c0372$export$1097a8289cfd22d7(map) {
    $be055ee01f5c0372$var$overrideErrorMap = map;
}
function $be055ee01f5c0372$export$32f27c719778d4c4() {
    return $be055ee01f5c0372$var$overrideErrorMap;
}

});
parcelRegister("9Noby", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $721b73602e4735ea$export$2e2bcd8739ae039; });

var $aK6zQ = parcelRequire("aK6zQ");

var $km89X = parcelRequire("km89X");
const $721b73602e4735ea$var$errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case (0, $aK6zQ.ZodIssueCode).invalid_type:
            if (issue.received === (0, $km89X.ZodParsedType).undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case (0, $aK6zQ.ZodIssueCode).invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, (0, $km89X.util).jsonStringifyReplacer)}`;
            break;
        case (0, $aK6zQ.ZodIssueCode).unrecognized_keys:
            message = `Unrecognized key(s) in object: ${(0, $km89X.util).joinValues(issue.keys, ", ")}`;
            break;
        case (0, $aK6zQ.ZodIssueCode).invalid_union:
            message = `Invalid input`;
            break;
        case (0, $aK6zQ.ZodIssueCode).invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${(0, $km89X.util).joinValues(issue.options)}`;
            break;
        case (0, $aK6zQ.ZodIssueCode).invalid_enum_value:
            message = `Invalid enum value. Expected ${(0, $km89X.util).joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case (0, $aK6zQ.ZodIssueCode).invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case (0, $aK6zQ.ZodIssueCode).invalid_return_type:
            message = `Invalid function return type`;
            break;
        case (0, $aK6zQ.ZodIssueCode).invalid_date:
            message = `Invalid date`;
            break;
        case (0, $aK6zQ.ZodIssueCode).invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else (0, $km89X.util).assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case (0, $aK6zQ.ZodIssueCode).too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case (0, $aK6zQ.ZodIssueCode).too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case (0, $aK6zQ.ZodIssueCode).custom:
            message = `Invalid input`;
            break;
        case (0, $aK6zQ.ZodIssueCode).invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case (0, $aK6zQ.ZodIssueCode).not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case (0, $aK6zQ.ZodIssueCode).not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            (0, $km89X.util).assertNever(issue);
    }
    return {
        message: message
    };
};
var $721b73602e4735ea$export$2e2bcd8739ae039 = $721b73602e4735ea$var$errorMap;

});


parcelRegister("5Vwu6", function(module, exports) {

$parcel$export(module.exports, "errorUtil", function () { return $450b795f1e3cf13c$export$b9faa7f0c32cb80d; });
var $450b795f1e3cf13c$export$b9faa7f0c32cb80d;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})($450b795f1e3cf13c$export$b9faa7f0c32cb80d || ($450b795f1e3cf13c$export$b9faa7f0c32cb80d = {}));

});

parcelRegister("jqJZD", function(module, exports) {

$parcel$export(module.exports, "makeIssue", function () { return $e2541f50d46f51cf$export$244a85fde9c419ed; });
$parcel$export(module.exports, "addIssueToContext", function () { return $e2541f50d46f51cf$export$db7caee60e5d514d; });
$parcel$export(module.exports, "ParseStatus", function () { return $e2541f50d46f51cf$export$5b20a5c3d05c1f6f; });
$parcel$export(module.exports, "INVALID", function () { return $e2541f50d46f51cf$export$9a105a556e65c2c0; });
$parcel$export(module.exports, "DIRTY", function () { return $e2541f50d46f51cf$export$325a211da9693fcf; });
$parcel$export(module.exports, "OK", function () { return $e2541f50d46f51cf$export$c6813a8d51f77eaf; });
$parcel$export(module.exports, "isAborted", function () { return $e2541f50d46f51cf$export$afa861e3c5730743; });
$parcel$export(module.exports, "isDirty", function () { return $e2541f50d46f51cf$export$910b6cdd390341b3; });
$parcel$export(module.exports, "isValid", function () { return $e2541f50d46f51cf$export$1ea939691cdc45b8; });
$parcel$export(module.exports, "isAsync", function () { return $e2541f50d46f51cf$export$aefee5ebe1dcfd9e; });

var $gjtAo = parcelRequire("gjtAo");

var $9Noby = parcelRequire("9Noby");
const $e2541f50d46f51cf$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $e2541f50d46f51cf$export$1526d2e05f74572 = [];
function $e2541f50d46f51cf$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = (0, $gjtAo.getErrorMap)();
    const issue = $e2541f50d46f51cf$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === (0, $9Noby.default) ? undefined : (0, $9Noby.default)
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $e2541f50d46f51cf$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $e2541f50d46f51cf$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $e2541f50d46f51cf$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $e2541f50d46f51cf$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $e2541f50d46f51cf$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $e2541f50d46f51cf$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $e2541f50d46f51cf$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $e2541f50d46f51cf$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $e2541f50d46f51cf$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $e2541f50d46f51cf$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $e2541f50d46f51cf$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $e2541f50d46f51cf$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;

});





parcelRegister("2v29v", function(module, exports) {

$parcel$export(module.exports, "getIcLabel", function () { return $be02eed721537857$export$5a482be733d8a1f4; });
// GlobalEdge IC cookie header names as per documentation
// https://dogfooding.atlassian-us-gov-mod.net/wiki/spaces/IP1/pages/130187649/LDR+Information+about+Isolation+Context+will+propagate+to+fronted+through+Cookie
const $be02eed721537857$var$PERIMETER_COOKIE = 'Atl-Ctx-Perimeter';
const $be02eed721537857$var$ISOLATION_CONTEXT_ID_COOKIE = 'Atl-Ctx-Isolation-Context-Id';
const $be02eed721537857$var$ISOLATION_CONTEXT_DOMAIN_COOKIE = 'Atl-Ctx-Isolation-Context-Domain';
/**
 * Helper function to get a specific cookie value
 */ const $be02eed721537857$var$getCookieValue = (cookieName)=>{
    if (typeof document === 'undefined') return null;
    const cookies = document.cookie.split(';');
    const cookie = cookies.find((cookie)=>cookie.trim().startsWith(`${cookieName}=`));
    if (!cookie) return null;
    try {
        const cookieValue = cookie.split('=', 2)[1];
        return decodeURIComponent(cookieValue);
    } catch (error) {
        console.warn(`Failed to parse ${cookieName} cookie:`, error);
        return null;
    }
};
const $be02eed721537857$var$parseIcLabel = ()=>{
    const cookieValue = $be02eed721537857$var$getCookieValue($be02eed721537857$var$ISOLATION_CONTEXT_DOMAIN_COOKIE);
    if (!cookieValue || cookieValue.trim() === '') return null;
    const splitDomain = cookieValue.trim().split('.');
    return splitDomain.length > 0 ? splitDomain[0] : null;
};
const $be02eed721537857$export$db6717a97cef0b32 = ()=>{
    const isolationContextDomain = $be02eed721537857$var$getCookieValue($be02eed721537857$var$ISOLATION_CONTEXT_DOMAIN_COOKIE);
    const isolationContextId = $be02eed721537857$var$getCookieValue($be02eed721537857$var$ISOLATION_CONTEXT_ID_COOKIE);
    const perimeter = $be02eed721537857$var$getCookieValue($be02eed721537857$var$PERIMETER_COOKIE);
    const icLabel = $be02eed721537857$var$parseIcLabel();
    return {
        icLabel: icLabel,
        icDomain: isolationContextDomain,
        isolationContextId: isolationContextId,
        perimeter: perimeter
    };
};
const $be02eed721537857$export$5a482be733d8a1f4 = ()=>{
    // icLabel maps to the parsed IC domain identifier (pear, apple, etc.)
    return $be02eed721537857$var$parseIcLabel();
};
const $be02eed721537857$export$bc97faed795b738 = ()=>{
    // icDomain returns the raw IC base domain (pear.oasis-stg.com, apple.atlassian-isolated.net)
    return $be02eed721537857$var$getCookieValue($be02eed721537857$var$ISOLATION_CONTEXT_DOMAIN_COOKIE);
};
const $be02eed721537857$export$66dd0ce1b5363c0f = ()=>{
    // The unique IC ID
    return $be02eed721537857$var$getCookieValue($be02eed721537857$var$ISOLATION_CONTEXT_ID_COOKIE);
};
const $be02eed721537857$export$fef3cea563e0943 = ()=>{
    // Get perimeter information (fedramp-moderate | commercial)
    return $be02eed721537857$var$getCookieValue($be02eed721537857$var$PERIMETER_COOKIE);
};

});


parcelRegister("50wm1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a560cb5a866d3cb$export$2e2bcd8739ae039; });
function $3a560cb5a866d3cb$export$2e2bcd8739ae039() {
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});





parcelRegister("4903M", function(module, exports) {

$parcel$export(module.exports, "getPageLoadMetric", function () { return $0ee93ea5082ba1f4$export$74b8bc7a2c5f037b; });

var $1qlo3 = parcelRequire("1qlo3");

var $9ULaf = parcelRequire("9ULaf");
const $0ee93ea5082ba1f4$var$cachedMetrics = new Map();
const $0ee93ea5082ba1f4$export$74b8bc7a2c5f037b = (pageId)=>{
    // Convert to kebab case to comply with naming convention:
    // https://hello.atlassian.net/wiki/spaces/APD/pages/1435310934/RUNBOOK+Get+the+Experience+Event+Key#Naming-conventions
    const page = pageId.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-').toLowerCase();
    let metric = $0ee93ea5082ba1f4$var$cachedMetrics.get(page);
    if (!metric) {
        metric = (0, $1qlo3.metrics).pageLoad({
            key: page,
            custom: {
                isServedByBifrost: (0, $9ULaf.default)()
            }
        });
        $0ee93ea5082ba1f4$var$cachedMetrics.set(page, metric);
    }
    return metric;
};

});
parcelRegister("1qlo3", function(module, exports) {

$parcel$export(module.exports, "metrics", function () { return $1098cf2607c60957$export$b0c5c2fac8144e54; });

var $afNXq = parcelRequire("afNXq");

var $jL4e3 = parcelRequire("jL4e3");
var $1098cf2607c60957$export$b0c5c2fac8144e54 = {
    pageLoad: (0, $jL4e3.pageLoad),
    pageSegmentLoad: (0, $jL4e3.pageSegmentLoad),
    interaction: (0, $jL4e3.interaction),
    custom: (0, $jL4e3.custom),
    concurrent: (0, $afNXq.concurrent)
};

});
parcelRegister("afNXq", function(module, exports) {

$parcel$export(module.exports, "concurrent", function () { return $77720e981806c8f6$export$370df09ecc3de059; });

var $91FVG = parcelRequire("91FVG");

var $bo0Gu = parcelRequire("bo0Gu");

var $jL4e3 = parcelRequire("jL4e3");
function $77720e981806c8f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77720e981806c8f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77720e981806c8f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77720e981806c8f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $77720e981806c8f6$var$concurrentMetrics = {};
var $77720e981806c8f6$var$getKey = function getKey(config, type) {
    return "".concat(type, "--").concat(config.key);
};
var $77720e981806c8f6$var$validateConfig = function validateConfig(config) {
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
var $77720e981806c8f6$var$ensurePath = function ensurePath(config, type) {
    var key = $77720e981806c8f6$var$getKey(config, type);
    if (!(key in $77720e981806c8f6$var$concurrentMetrics)) $77720e981806c8f6$var$concurrentMetrics[key] = {};
};
var $77720e981806c8f6$var$getMetricFromCache = function getMetricFromCache(concurrentId, config, type) {
    var concurrentKey = $77720e981806c8f6$var$getKey(config, type);
    if (concurrentKey in $77720e981806c8f6$var$concurrentMetrics && $77720e981806c8f6$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $77720e981806c8f6$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $77720e981806c8f6$var$concurrentMetrics)) $77720e981806c8f6$var$concurrentMetrics[concurrentKey] = {};
};
var $77720e981806c8f6$var$makeConcurrentMetric = function makeConcurrentMetric(concurrentId, config, type) {
    $77720e981806c8f6$var$validateConfig(config);
    $77720e981806c8f6$var$ensurePath(config, type);
    var metricFromCache = $77720e981806c8f6$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    var metricFactory = type === (0, $bo0Gu.BMEventsType).INLINE_RESULT ? (0, $jL4e3.interaction) : (0, $jL4e3.custom);
    var metric = metricFactory(config);
    $77720e981806c8f6$var$concurrentMetrics[$77720e981806c8f6$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
var $77720e981806c8f6$export$370df09ecc3de059 = {
    pageSegmentLoad: function pageSegmentLoad(config) {
        return function(concurrentId) {
            return $77720e981806c8f6$var$makeConcurrentMetric(concurrentId, $77720e981806c8f6$var$_objectSpread({}, config), (0, $bo0Gu.BMEventsType).PAGE_SEGMENT_LOAD);
        };
    },
    interaction: function interaction(config) {
        return function(concurrentId) {
            return $77720e981806c8f6$var$makeConcurrentMetric(concurrentId, $77720e981806c8f6$var$_objectSpread({}, config), (0, $bo0Gu.BMEventsType).INLINE_RESULT);
        };
    },
    custom: function custom(config) {
        return function(concurrentId) {
            return $77720e981806c8f6$var$makeConcurrentMetric(concurrentId, $77720e981806c8f6$var$_objectSpread({}, config), (0, $bo0Gu.BMEventsType).CUSTOM);
        };
    }
};

});
parcelRegister("jL4e3", function(module, exports) {

$parcel$export(module.exports, "pageLoad", function () { return $e625af3e917196ba$export$791d520f7e8058a5; });
$parcel$export(module.exports, "pageSegmentLoad", function () { return $e625af3e917196ba$export$94114666844d5f66; });
$parcel$export(module.exports, "interaction", function () { return $e625af3e917196ba$export$92473e6020ad89b4; });
$parcel$export(module.exports, "custom", function () { return $e625af3e917196ba$export$4c00f665f0d4b443; });

var $91FVG = parcelRequire("91FVG");

var $xC4tb = parcelRequire("xC4tb");

var $lga4w = parcelRequire("lga4w");

var $8JI5v = parcelRequire("8JI5v");

var $bo0Gu = parcelRequire("bo0Gu");
function $e625af3e917196ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e625af3e917196ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e625af3e917196ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e625af3e917196ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e625af3e917196ba$export$791d520f7e8058a5 = function pageLoad(config) {
    return new (0, $lga4w.PageLoadMetric)($e625af3e917196ba$var$_objectSpread($e625af3e917196ba$var$_objectSpread({}, config), {}, {
        type: (0, $bo0Gu.BMEventsType).PAGE_LOAD
    }));
};
var $e625af3e917196ba$export$94114666844d5f66 = function pageSegmentLoad(config) {
    return new (0, $8JI5v.PageSegmentLoadMetric)($e625af3e917196ba$var$_objectSpread($e625af3e917196ba$var$_objectSpread({}, config), {}, {
        type: (0, $bo0Gu.BMEventsType).PAGE_SEGMENT_LOAD
    }));
};
var $e625af3e917196ba$export$92473e6020ad89b4 = function interaction(config) {
    return new (0, $xC4tb.Metric)($e625af3e917196ba$var$_objectSpread($e625af3e917196ba$var$_objectSpread({}, config), {}, {
        type: (0, $bo0Gu.BMEventsType).INLINE_RESULT
    }));
};
var $e625af3e917196ba$export$4c00f665f0d4b443 = function custom(config) {
    return new (0, $xC4tb.Metric)($e625af3e917196ba$var$_objectSpread($e625af3e917196ba$var$_objectSpread({}, config), {}, {
        type: (0, $bo0Gu.BMEventsType).CUSTOM
    }));
};

});
parcelRegister("xC4tb", function(module, exports) {

$parcel$export(module.exports, "Metric", function () { return $06509d4eccac6126$export$efdd3e096bc27746; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $XdI2U = parcelRequire("XdI2U");

var $enV8I = parcelRequire("enV8I");

var $4WJqA = parcelRequire("4WJqA");

var $9Ut6b = parcelRequire("9Ut6b");

var $1nojc = parcelRequire("1nojc");
function $06509d4eccac6126$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $06509d4eccac6126$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $06509d4eccac6126$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($06509d4eccac6126$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $06509d4eccac6126$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($XdI2U)))((0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $06509d4eccac6126$export$efdd3e096bc27746 = /*#__PURE__*/ function(_BaseMetric) {
    function Metric() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, Metric);
        return $06509d4eccac6126$var$_callSuper(this, Metric, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(Metric, _BaseMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(Metric, [
        {
            key: "start",
            value: function start() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, startTime = _ref.startTime;
                $06509d4eccac6126$var$_superPropGet(Metric, "start", this, 3)([
                    {
                        startTime: startTime
                    }
                ]);
                this.route = (0, $4WJqA.Route).getRoute();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var stoppedSuccessfully = $06509d4eccac6126$var$_superPropGet(Metric, "stop", this, 3)([
                    params
                ]);
                if (stoppedSuccessfully && !this.config.virtual) (0, $9Ut6b.submitter).queue(this.getData());
                return stoppedSuccessfully;
            }
        }
    ]);
}((0, $1nojc.BaseMetric));

});

parcelRegister("lga4w", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", function () { return $f7a2e7afe1c91015$export$3c51073271a9eac3; });

var $k7uol = parcelRequire("k7uol");

var $91FVG = parcelRequire("91FVG");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $XdI2U = parcelRequire("XdI2U");

var $enV8I = parcelRequire("enV8I");

var $axdfd = parcelRequire("axdfd");

var $i6ikd = parcelRequire("i6ikd");

var $1grIu = parcelRequire("1grIu");

var $4WJqA = parcelRequire("4WJqA");

var $9Ut6b = parcelRequire("9Ut6b");

var $bo0Gu = parcelRequire("bo0Gu");

var $hDoVW = parcelRequire("hDoVW");

var $hougm = parcelRequire("hougm");

var $85AzO = parcelRequire("85AzO");
function $f7a2e7afe1c91015$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7a2e7afe1c91015$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7a2e7afe1c91015$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7a2e7afe1c91015$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f7a2e7afe1c91015$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $f7a2e7afe1c91015$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $f7a2e7afe1c91015$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f7a2e7afe1c91015$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f7a2e7afe1c91015$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($XdI2U)))((0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $f7a2e7afe1c91015$export$3c51073271a9eac3 = /*#__PURE__*/ function(_BasePageLoadMetric) {
    function PageLoadMetric() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, PageLoadMetric);
        return $f7a2e7afe1c91015$var$_callSuper(this, PageLoadMetric, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(PageLoadMetric, _BasePageLoadMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(PageLoadMetric, [
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false
                };
                (0, $hougm.pageLoadMetaMetric).startPageLoad($f7a2e7afe1c91015$var$_objectSpread($f7a2e7afe1c91015$var$_objectSpread({}, params), {}, {
                    cancelStarted: 'startTime' in params
                }));
                this.watchUntil();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$config$ssr;
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var stopTime = params.stopTime || window.performance.now();
                var pageLoadData = (0, $hougm.pageLoadMetaMetric).getDataToMerge();
                var metaMetricStopped = (0, $hougm.pageLoadMetaMetric).stop(params);
                if (!metaMetricStopped) return false;
                if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
                    if (!this.marks[(0, $hDoVW.BasePageLoadMetric).FMP]) {
                        var mark = (0, $i6ikd.SSRGetDoneMark).getDoneMark();
                        if (mark) (0, $hougm.pageLoadMetaMetric).markFMP(mark);
                    } else (0, $hougm.pageLoadMetaMetric).markFMP(this.marks[(0, $hDoVW.BasePageLoadMetric).FMP]);
                }
                this.route = (0, $4WJqA.Route).getRoute();
                var metricStopped = this.stopPageLoad(pageLoadData, $f7a2e7afe1c91015$var$_objectSpread($f7a2e7afe1c91015$var$_objectSpread({}, params), {}, {
                    stopTime: stopTime
                }));
                if (!metricStopped) return false;
                var data = this.getData();
                if (!this.config.virtual) (0, $9Ut6b.submitter).queue(data);
                (0, $1grIu.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
                this.enqueueWebVitals();
                return true;
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                (0, $hougm.pageLoadMetaMetric).mark(_mark, timestamp);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                (0, $hougm.pageLoadMetaMetric).markFMP(timestamp);
            }
        },
        {
            key: "getData",
            value: function getData() {
                var pageLoadMetaData = (0, $hougm.pageLoadMetaMetric).getData();
                return $f7a2e7afe1c91015$var$_objectSpread($f7a2e7afe1c91015$var$_objectSpread({}, $f7a2e7afe1c91015$var$_superPropGet(PageLoadMetric, "getData", this, 3)([])), {}, {
                    // marks and explicitTimings are available only in pageLoadMeta
                    marks: pageLoadMetaData.marks,
                    explicitTimings: pageLoadMetaData.explicitTimings
                });
            }
        },
        {
            key: "enqueueWebVitals",
            value: function() {
                var _enqueueWebVitals = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee() {
                    var _configChunk$BMEvents;
                    var configChunk, webVitalMetric;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(this.config.virtual || !this.isInitial)) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 2:
                                _context.next = 4;
                                return (0, $9Ut6b.submitter).config.configChunk;
                            case 4:
                                configChunk = _context.sent;
                                if (configChunk !== null && configChunk !== void 0 && (_configChunk$BMEvents = configChunk[(0, $bo0Gu.BMEventsType).WEB_VITALS].webVitals) !== null && _configChunk$BMEvents !== void 0 && _configChunk$BMEvents.enabled) {
                                    _context.next = 7;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 7:
                                webVitalMetric = new (0, $85AzO.WebVitalsMetric)({
                                    key: this.config.key,
                                    route: this.route,
                                    startTime: this.startTime,
                                    stopTime: this.stopTime,
                                    pageVisibleState: this.pageVisibleState
                                });
                                (0, $9Ut6b.submitter).queue(webVitalMetric.getData());
                                (0, $1grIu.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
                                return _context.abrupt("return", true);
                            case 11:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function enqueueWebVitals() {
                    return _enqueueWebVitals.apply(this, arguments);
                }
                return enqueueWebVitals;
            }()
        }
    ]);
}((0, $hDoVW.BasePageLoadMetric));

});
parcelRegister("85AzO", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", function () { return $5e3b29baa0b28175$export$dc0d85d4d6503cd7; });

var $c9XBY = parcelRequire("c9XBY");

var $lPkGR = parcelRequire("lPkGR");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $enV8I = parcelRequire("enV8I");

var $bo0Gu = parcelRequire("bo0Gu");

var $1nojc = parcelRequire("1nojc");
function $5e3b29baa0b28175$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $5e3b29baa0b28175$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $5e3b29baa0b28175$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5e3b29baa0b28175$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5e3b29baa0b28175$export$dc0d85d4d6503cd7 = /*#__PURE__*/ function(_BaseMetric) {
    function WebVitalsMetric(_ref) {
        var _this;
        var key = _ref.key, route = _ref.route, startTime = _ref.startTime, stopTime = _ref.stopTime, pageVisibleState = _ref.pageVisibleState;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, WebVitalsMetric);
        _this = $5e3b29baa0b28175$var$_callSuper(this, WebVitalsMetric, [
            {
                type: (0, $bo0Gu.BMEventsType).WEB_VITALS,
                key: key
            }
        ]);
        _this.route = route;
        _this.startTime = startTime;
        _this.stopTime = stopTime;
        _this.state = (0, $1nojc.MetricState).FINISHED;
        _this.pageVisibleState = pageVisibleState;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(WebVitalsMetric, _BaseMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(WebVitalsMetric);
}((0, $1nojc.BaseMetric));

});


parcelRegister("8JI5v", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", function () { return $65c4b9a45d082922$export$24c8bfcd77494cc1; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $XdI2U = parcelRequire("XdI2U");

var $enV8I = parcelRequire("enV8I");

var $91FVG = parcelRequire("91FVG");

var $i6ikd = parcelRequire("i6ikd");

var $bo0Gu = parcelRequire("bo0Gu");

var $1nojc = parcelRequire("1nojc");

var $xC4tb = parcelRequire("xC4tb");

var $hougm = parcelRequire("hougm");
function $65c4b9a45d082922$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $65c4b9a45d082922$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $65c4b9a45d082922$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $65c4b9a45d082922$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $65c4b9a45d082922$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $65c4b9a45d082922$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $65c4b9a45d082922$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($65c4b9a45d082922$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $65c4b9a45d082922$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($XdI2U)))((0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $65c4b9a45d082922$export$24c8bfcd77494cc1 = /*#__PURE__*/ function(_Metric) {
    function PageSegmentLoadMetric(config) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, PageSegmentLoadMetric);
        _this = $65c4b9a45d082922$var$_callSuper(this, PageSegmentLoadMetric, [
            config
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(_this, "isInitial", true);
        _this.config = config;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(PageSegmentLoadMetric, _Metric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(PageSegmentLoadMetric, [
        {
            key: "startFromPageLoad",
            value: function startFromPageLoad() {
                var _pageLoadMetaData$sta;
                var pageLoadMetaData = (0, $hougm.pageLoadMetaMetric).getData();
                this.start({
                    startTime: (_pageLoadMetaData$sta = pageLoadMetaData.start) !== null && _pageLoadMetaData$sta !== void 0 ? _pageLoadMetaData$sta : undefined
                });
                this.isInitial = pageLoadMetaData.isInitial;
                this.pageVisibleState = pageLoadMetaData.pageVisibleState;
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                if (_mark === PageSegmentLoadMetric.FMP) return;
                $65c4b9a45d082922$var$_superPropGet(PageSegmentLoadMetric, "mark", this, 3)([
                    _mark,
                    timestamp
                ]);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                $65c4b9a45d082922$var$_superPropGet(PageSegmentLoadMetric, "mark", this, 3)([
                    PageSegmentLoadMetric.FMP,
                    timestamp
                ]);
            }
        },
        {
            key: "getPageSegmentLoadData",
            value: function getPageSegmentLoadData() {
                return {
                    isInitial: this.isInitial
                };
            }
        },
        {
            key: "getData",
            value: function getData() {
                return $65c4b9a45d082922$var$_objectSpread($65c4b9a45d082922$var$_objectSpread({}, $65c4b9a45d082922$var$_superPropGet(PageSegmentLoadMetric, "getData", this, 3)([])), this.getPageSegmentLoadData());
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $65c4b9a45d082922$var$_objectSpread($65c4b9a45d082922$var$_objectSpread({}, $65c4b9a45d082922$var$_superPropGet(PageSegmentLoadMetric, "getDataToMerge", this, 3)([])), this.getPageSegmentLoadData());
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                $65c4b9a45d082922$var$_superPropGet(PageSegmentLoadMetric, "merge", this, 3)([
                    mergeData
                ]);
                this.isInitial = mergeData.isInitial;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$config$ssr, _this2 = this;
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var pageLoadData = (0, $hougm.pageLoadMetaMetric).getData();
                if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
                    if (!this.marks[PageSegmentLoadMetric.FMP]) {
                        var mark = (0, $i6ikd.SSRGetDoneMark).getDoneMark();
                        if (mark) this.markFMP(mark);
                    }
                }
                if (this.config.includePageLoadTimings !== (0, $bo0Gu.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $1nojc.MetricState).FINISHED) return $65c4b9a45d082922$var$_superPropGet(PageSegmentLoadMetric, "stop", this, 3)([
                    params
                ]);
                var now = performance.now();
                if (pageLoadData.state === (0, $1nojc.MetricState).STARTED) (0, $hougm.pageLoadMetaMetric).onStop(function() {
                    $65c4b9a45d082922$var$_superPropGet(PageSegmentLoadMetric, "stop", _this2, 3)([
                        $65c4b9a45d082922$var$_objectSpread($65c4b9a45d082922$var$_objectSpread({}, params), {}, {
                            stopTime: params.stopTime || now
                        })
                    ]);
                }, function() {
                    _this2.cancel();
                });
                return true;
            }
        }
    ]);
}((0, $xC4tb.Metric));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($65c4b9a45d082922$export$24c8bfcd77494cc1, "FMP", 'fmp');

});




parcelRegister("9ULaf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df92f7a22ed0e1e6$export$2e2bcd8739ae039; });
const $df92f7a22ed0e1e6$var$EMPTY_APP_STATE_VALUE = '{{data_app_state}}';
const $df92f7a22ed0e1e6$var$hasNoInjectedServerState = ()=>{
    const data = document.body.getAttribute('data-app-state');
    const dataNotInjectedDueToTestContext = data === null;
    return data === $df92f7a22ed0e1e6$var$EMPTY_APP_STATE_VALUE || dataNotInjectedDueToTestContext;
};
var $df92f7a22ed0e1e6$export$2e2bcd8739ae039 = $df92f7a22ed0e1e6$var$hasNoInjectedServerState;

});




parcelRegister("8GnY0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $326c16464793b305$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $hqddj = parcelRequire("hqddj");
/**
 * Logging to debug SLO burn in fedramp. Wrapped in component because we are
 * debugging the runtime value of a built-in react hook (useId).
 *
 * For detail see: https://hello.jira.atlassian.cloud/browse/KIRBY-10780
 */ const $326c16464793b305$var$FedrampUseIdProbe = ({ context: context })=>{
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).useId?.();
    (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).useEffect(()=>{
        try {
            const valueType = typeof value;
            (0, $hqddj.addBreadcrumb)({
                level: 'info',
                message: 'FedRAMP React.useId probe',
                data: {
                    context: context,
                    reactVersion: (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).version,
                    useIdResultType: valueType,
                    useIdResultConstructor: value && value.constructor?.name,
                    useIdResult: valueType === 'string' ? value : String(value),
                    useId: (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr)))?.useId,
                    useIdType: typeof (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr)))?.useId,
                    useIdToString: (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr)))?.useId?.toString()
                }
            });
        } catch (error) {
            (0, $hqddj.captureException)(error);
        }
    }, [
        context,
        value
    ]);
    return null;
};
var $326c16464793b305$export$2e2bcd8739ae039 = $326c16464793b305$var$FedrampUseIdProbe;

});


parcelRegister("4Gte9", function(module, exports) {

$parcel$export(module.exports, "fetchApi", function () { return $4c00e6056093601f$export$adb4bb4243526aef; });
$parcel$export(module.exports, "ServerErrorException", function () { return $4c00e6056093601f$export$173e0be89ecf9709; });
$parcel$export(module.exports, "FetchTimeoutError", function () { return $4c00e6056093601f$export$3cd6da4e8233bb34; });
$parcel$export(module.exports, "fetchApiWithRetry", function () { return $4c00e6056093601f$export$e6fd9819353dbfa6; });

var $hqddj = parcelRequire("hqddj");
const $4c00e6056093601f$export$adb4bb4243526aef = async (url, headers)=>{
    const response = await fetch(url, {
        headers: {
            'Content-Type': 'application/json',
            ...headers
        }
    });
    if (response.status >= 500) {
        const data = await response.json();
        const message = `Failed to fetch ${url} [${response.status} status]`;
        const errorType = data?.error || {
            error: 'internal_server_error'
        };
        (0, $hqddj.captureErrorMessage)(message, data);
        throw new $4c00e6056093601f$export$173e0be89ecf9709(message, response.status, errorType);
    }
    return response;
};
class $4c00e6056093601f$export$173e0be89ecf9709 extends Error {
    constructor(message, status, errorType){
        super(message), this.message = message, this.status = status, this.errorType = errorType;
        this.name = 'ServerErrorException';
    }
}
class $4c00e6056093601f$export$3cd6da4e8233bb34 extends Error {
    constructor(originalError){
        const message = originalError instanceof Error ? `FetchTimeoutError: ${originalError.message}` : 'FetchTimeoutError';
        super(message), this.originalError = originalError;
        this.name = 'FetchTimeoutError';
    }
}
async function $4c00e6056093601f$export$e6fd9819353dbfa6(url, headers, delayMs = 1000, retries = 2) {
    try {
        return await $4c00e6056093601f$export$adb4bb4243526aef(url, headers);
    } catch (error) {
        if (error instanceof $4c00e6056093601f$export$173e0be89ecf9709) throw error;
        if (retries <= 0) {
            (0, $hqddj.captureErrorMessage)(`Unexpected error while loading AppState in Bifrost: ${error}`);
            throw new $4c00e6056093601f$export$3cd6da4e8233bb34(error);
        }
        await new Promise((resolve)=>setTimeout(resolve, delayMs));
        return $4c00e6056093601f$export$e6fd9819353dbfa6(url, headers, delayMs * 2, retries - 1);
    }
}

});

parcelRegister("i6A4M", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("ilxvQ")).then(()=>parcelRequire('lv8Z6'));

});

parcelRegister("b7mNj", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("x1rx7")).then(()=>parcelRequire('4KUL1'));

});

parcelRegister("lTHrZ", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("3Lm6O")).then(()=>parcelRequire('8PLbe'));

});

parcelRegister("c2MMA", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("fTpNJ")).then(()=>parcelRequire('3vOVH'));

});

parcelRegister("fCGKV", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("iPmMD")).then(()=>parcelRequire('cHJWP'));

});

parcelRegister("gcR07", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("lOU6n")).then(()=>parcelRequire('cB4bh'));

});

parcelRegister("eVTeT", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("cNF11")).then(()=>parcelRequire('136CB'));

});

parcelRegister("3ZPE5", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("9Q3PI")).then(()=>parcelRequire('4Rsv0'));

});

parcelRegister("gMXqC", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("9Dj5I")).then(()=>parcelRequire('dtyXi'));

});

parcelRegister("jf0pv", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("dE5wW")).then(()=>parcelRequire('jkcnu'));

});

parcelRegister("1KYmT", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("8MBE7")).then(()=>parcelRequire('1DsCU'));

});

parcelRegister("drjc9", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("2yZSu")).then(()=>parcelRequire('946gj'));

});

parcelRegister("2DGyD", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("bJaMY")).then(()=>parcelRequire('lqx5g'));

});

parcelRegister("3ECH4", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("hOU1D")).then(()=>parcelRequire('eFvWb'));

});

parcelRegister("76W9C", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("ie85Y")).then(()=>parcelRequire('cWDWq'));

});

parcelRegister("9iquk", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("edy5m")).then(()=>parcelRequire('gWVKg'));

});

parcelRegister("kdUZk", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("c4W6g")).then(()=>parcelRequire('1jif2'));

});

parcelRegister("41Mg3", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("fOkpb")).then(()=>parcelRequire('GoOMS'));

});

parcelRegister("ikC6M", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("laeVL")).then(()=>parcelRequire('1GWKZ'));

});

parcelRegister("dY5GJ", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("5uTtl")).then(()=>parcelRequire('8sAFJ'));

});

parcelRegister("goWNu", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("5ta27")).then(()=>parcelRequire('bGyJU'));

});

parcelRegister("62P2k", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("eqkmD")).then(()=>parcelRequire('2lQ5F'));

});

parcelRegister("34ThY", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("dS9Ar")).then(()=>parcelRequire('h1hag'));

});

parcelRegister("kcSWi", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("3Wyuy")).then(()=>parcelRequire('6ZuyC'));

});

parcelRegister("l0GNM", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("kqHhv")).then(()=>parcelRequire('defRV'));

});

parcelRegister("9xnDg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f1987070d2c65be$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");

var $gQLDR = parcelRequire("gQLDR");

var $ggrj9 = parcelRequire("ggrj9");

var $r8LtT = parcelRequire("r8LtT");

var $4FO3R = parcelRequire("4FO3R");

var $2zXdR = parcelRequire("2zXdR");

var $guOpQ = parcelRequire("guOpQ");

var $ll5tc = parcelRequire("ll5tc");

var $grcbH = parcelRequire("grcbH");
function $6f1987070d2c65be$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6f1987070d2c65be$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6f1987070d2c65be$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6f1987070d2c65be$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6f1987070d2c65be$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6f1987070d2c65be$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6f1987070d2c65be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f1987070d2c65be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f1987070d2c65be$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f1987070d2c65be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $6f1987070d2c65be$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($6f1987070d2c65be$var$_objectSpread($6f1987070d2c65be$var$_objectSpread({}, (0, $r8LtT.themeStateDefaults)), {}, {
                        typography: (0, $r8LtT.themeStateDefaults)['typography'],
                        shape: (0, $r8LtT.themeStateDefaults)['shape'](),
                        motion: (0, $r8LtT.themeStateDefaults)['motion']()
                    }, (0, $ggrj9.default)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $r8LtT.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $r8LtT.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $r8LtT.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $r8LtT.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $r8LtT.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $r8LtT.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $r8LtT.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $r8LtT.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $r8LtT.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $gQLDR.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $ll5tc.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $grcbH.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $4FO3R.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $r8LtT.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $guOpQ.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("ihQIC"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 11;
                    return Promise.all(loadingTasks);
                case 11:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $ll5tc.getThemeOverridePreferences)(themeState);
                    _iterator = $6f1987070d2c65be$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 13;
                    _iterator.s();
                case 15:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 21;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 19;
                    return loadingStrategy(themeId);
                case 19:
                    _context3.next = 15;
                    break;
                case 21:
                    _context3.next = 26;
                    break;
                case 23:
                    _context3.prev = 23;
                    _context3.t0 = _context3["catch"](13);
                    _iterator.e(_context3.t0);
                case 26:
                    _context3.prev = 26;
                    _iterator.f();
                    return _context3.finish(26);
                case 29:
                    autoUnbind = (0, $2zXdR.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 31:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                13,
                23,
                26,
                29
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $6f1987070d2c65be$export$2e2bcd8739ae039 = $6f1987070d2c65be$var$setGlobalTheme;

});
parcelRegister("ggrj9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $030e3f4526ab9f37$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $d4N04 = parcelRequire("d4N04");

var $r8LtT = parcelRequire("r8LtT");

var $FF4Xo = parcelRequire("FF4Xo");
function $030e3f4526ab9f37$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $030e3f4526ab9f37$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $030e3f4526ab9f37$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $030e3f4526ab9f37$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $030e3f4526ab9f37$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $r8LtT.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $030e3f4526ab9f37$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $d4N04.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $d4N04.THEME_DATA_ATTRIBUTE)) || '';
    return $030e3f4526ab9f37$var$_objectSpread($030e3f4526ab9f37$var$_objectSpread({}, (0, $FF4Xo.themeStringToObject)(theme)), $030e3f4526ab9f37$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $030e3f4526ab9f37$export$2e2bcd8739ae039 = $030e3f4526ab9f37$var$getGlobalTheme;

});
parcelRegister("d4N04", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $9851a8813925f525$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $9851a8813925f525$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $9851a8813925f525$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $9851a8813925f525$export$352e418ed5b6193a; });
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", function () { return $9851a8813925f525$export$dddac1532e822863; });
var $9851a8813925f525$export$4ef52930e33717cd = 'data-theme';
var $9851a8813925f525$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $9851a8813925f525$export$a00eac3f8684bcd0 = 'data-color-mode';
var $9851a8813925f525$export$2112803007239c61 = 'data-contrast-mode';
var $9851a8813925f525$export$352e418ed5b6193a = 'data-custom-theme';
var $9851a8813925f525$export$6f0c6fb8c80fcc92 = 'ds';
var $9851a8813925f525$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $9851a8813925f525$export$dddac1532e822863 = "--".concat($9851a8813925f525$export$6f0c6fb8c80fcc92, "-token-not-found");
var $9851a8813925f525$export$9d7b58831ae93caa = "--".concat($9851a8813925f525$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("r8LtT", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $0519523e1d940910$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $0519523e1d940910$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $0519523e1d940910$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $0519523e1d940910$export$2e2bcd8739ae039; });

var $gQLDR = parcelRequire("gQLDR");
var $0519523e1d940910$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $0519523e1d940910$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $0519523e1d940910$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $0519523e1d940910$var$themeOverrideIds = [];
var $0519523e1d940910$export$92ba366331403db2 = [].concat($0519523e1d940910$export$7d43e72a58e3283f, $0519523e1d940910$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $0519523e1d940910$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
/**
 * ThemeOptionsSchema: additional configuration options used to customize Atlassian's themes
 */ /**
 * ThemeState: the standard representation of an app's current theme and preferences
 */ /**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $0519523e1d940910$var$getShapeDefault() {
    if ((0, $gQLDR.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $0519523e1d940910$var$getMotionDefault() {
    if ((0, $gQLDR.fg)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
var $0519523e1d940910$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $0519523e1d940910$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $0519523e1d940910$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $0519523e1d940910$export$2e2bcd8739ae039 = $0519523e1d940910$var$themeConfig;

});

parcelRegister("FF4Xo", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $07d3b1dfbe79ee15$export$f19b488f7c0547ee; });
$parcel$export(module.exports, "themeObjectToString", function () { return $07d3b1dfbe79ee15$export$62c37ab81302621a; });

var $a3ftr = parcelRequire("a3ftr");

var $82V4i = parcelRequire("82V4i");

var $r8LtT = parcelRequire("r8LtT");
var $07d3b1dfbe79ee15$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $07d3b1dfbe79ee15$var$customThemeOptions = 'UNSAFE_themeOptions';
var $07d3b1dfbe79ee15$var$isThemeKind = function isThemeKind(themeKind) {
    return $07d3b1dfbe79ee15$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $07d3b1dfbe79ee15$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $r8LtT.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $07d3b1dfbe79ee15$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $07d3b1dfbe79ee15$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $07d3b1dfbe79ee15$var$isColorMode(id)) themeObject[kind] = id;
        if ($07d3b1dfbe79ee15$var$isThemeKind(kind) && $07d3b1dfbe79ee15$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $07d3b1dfbe79ee15$var$customThemeOptions) try {
            themeObject[$07d3b1dfbe79ee15$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $07d3b1dfbe79ee15$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $07d3b1dfbe79ee15$var$isColorMode(id) || // custom theme state
        kind === $07d3b1dfbe79ee15$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(id) === 'object' || // other theme states
        $07d3b1dfbe79ee15$var$isThemeKind(kind) && typeof id === 'string' && $07d3b1dfbe79ee15$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});


parcelRegister("4FO3R", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $3671d2dc9e868ca5$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $3671d2dc9e868ca5$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $3671d2dc9e868ca5$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $3671d2dc9e868ca5$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $3671d2dc9e868ca5$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $3671d2dc9e868ca5$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $3671d2dc9e868ca5$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $3671d2dc9e868ca5$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $3671d2dc9e868ca5$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $3671d2dc9e868ca5$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $3671d2dc9e868ca5$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $3671d2dc9e868ca5$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $3671d2dc9e868ca5$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $3671d2dc9e868ca5$export$b36dbdb4f463f05c(hex) {
    if (!$3671d2dc9e868ca5$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $3671d2dc9e868ca5$export$1212645cf40ebf71(hex)
    ];
}
function $3671d2dc9e868ca5$export$5a544e13ad4e1fa5(hex) {
    if (!$3671d2dc9e868ca5$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $3671d2dc9e868ca5$export$47ea145a83f50dc0(hex) {
    if (!$3671d2dc9e868ca5$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $3671d2dc9e868ca5$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $3671d2dc9e868ca5$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $3671d2dc9e868ca5$export$d061e26956a60b0a(foreground, background) {
    if (!$3671d2dc9e868ca5$var$isValidHex(foreground) || !$3671d2dc9e868ca5$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $3671d2dc9e868ca5$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $3671d2dc9e868ca5$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $3671d2dc9e868ca5$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $3671d2dc9e868ca5$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $3671d2dc9e868ca5$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $3671d2dc9e868ca5$var$rgbToLab(rgbA);
    var labB = $3671d2dc9e868ca5$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $3671d2dc9e868ca5$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("2zXdR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e0cca023bf96f44$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $gQLDR = parcelRequire("gQLDR");

var $cFIvN = parcelRequire("cFIvN");

var $cuUqX = parcelRequire("cuUqX");

var $f6H8l = parcelRequire("f6H8l");
function $1e0cca023bf96f44$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $cuUqX.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $cuUqX.default).bind();
    } else (0, $cuUqX.default).unbind();
    if ((0, $gQLDR.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $f6H8l.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $f6H8l.default).bind();
        } else (0, $f6H8l.default).unbind();
    }
    var themeAttributes = (0, $cFIvN.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $cuUqX.default).unbind();
        if ((0, $gQLDR.fg)('platform_increased-contrast-themes')) (0, $f6H8l.default).unbind();
    };
}

});
parcelRegister("cFIvN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939bd785576cf365$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $gQLDR = parcelRequire("gQLDR");

var $d4N04 = parcelRequire("d4N04");

var $r8LtT = parcelRequire("r8LtT");

var $FF4Xo = parcelRequire("FF4Xo");

var $4FO3R = parcelRequire("4FO3R");

var $9ydR5 = parcelRequire("9ydR5");
function $939bd785576cf365$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $939bd785576cf365$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $939bd785576cf365$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $939bd785576cf365$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $939bd785576cf365$var$defaultColorMode = 'light';
var $939bd785576cf365$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $939bd785576cf365$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $r8LtT.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $r8LtT.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $r8LtT.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $r8LtT.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $r8LtT.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $r8LtT.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $r8LtT.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $r8LtT.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $r8LtT.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $FF4Xo.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $d4N04.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $d4N04.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $939bd785576cf365$var$defaultColorMode : colorMode);
    if ((0, $gQLDR.fg)('platform_increased-contrast-themes')) result = $939bd785576cf365$var$_objectSpread($939bd785576cf365$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $d4N04.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $939bd785576cf365$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $4FO3R.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $9ydR5.hash)(optionString);
        result[0, $d4N04.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $939bd785576cf365$export$2e2bcd8739ae039 = $939bd785576cf365$var$getThemeHtmlAttrs;

});
parcelRegister("9ydR5", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $6f42096277ee5574$export$d6af199866bfb566; });
var $6f42096277ee5574$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("cuUqX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91940ff3e1fb6806$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $40QgJ = parcelRequire("40QgJ");

var $d4N04 = parcelRequire("d4N04");

var $grcbH = parcelRequire("grcbH");
var $91940ff3e1fb6806$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $91940ff3e1fb6806$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $d4N04.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $91940ff3e1fb6806$var$darkModeMql = $91940ff3e1fb6806$var$isMatchMediaAvailable && window.matchMedia((0, $grcbH.darkModeMediaQuery));
var $91940ff3e1fb6806$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$91940ff3e1fb6806$var$darkModeMql) return 'light';
                return $91940ff3e1fb6806$var$darkModeMql !== null && $91940ff3e1fb6806$var$darkModeMql !== void 0 && $91940ff3e1fb6806$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($91940ff3e1fb6806$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $40QgJ.bind)($91940ff3e1fb6806$var$darkModeMql, {
                    type: 'change',
                    listener: $91940ff3e1fb6806$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $91940ff3e1fb6806$var$SingletonColorModeObserver = new $91940ff3e1fb6806$var$ColorModeObserver();
var $91940ff3e1fb6806$export$2e2bcd8739ae039 = $91940ff3e1fb6806$var$SingletonColorModeObserver;

});
parcelRegister("grcbH", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $bf789f31e6ddb092$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $bf789f31e6ddb092$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $bf789f31e6ddb092$export$8662df6937d86fcb; });

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");

var $4ZjBQ = parcelRequire("4ZjBQ");

var $d4N04 = parcelRequire("d4N04");
var $bf789f31e6ddb092$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $d4N04.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $d4N04.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $bf789f31e6ddb092$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $bf789f31e6ddb092$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $4ZjBQ.default)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $bf789f31e6ddb092$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $bf789f31e6ddb092$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("4ZjBQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a1c11ee6274b380$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









var $3a1c11ee6274b380$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("47PzD"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("eyJdQ"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("evti7"));
    },
    'dark': function dark() {
        return (parcelRequire("9LEFX"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("hX0DW"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("fcEIs"));
    },
    'spacing': function spacing() {
        return (parcelRequire("escq7"));
    },
    'typography': function typography() {
        return (parcelRequire("cSbQI"));
    },
    'shape': function shape() {
        return (parcelRequire("gQzlz"));
    },
    'motion': function motion() {
        return (parcelRequire("jk26F"));
    }
};
var $3a1c11ee6274b380$export$2e2bcd8739ae039 = $3a1c11ee6274b380$var$themeImportsMap;

});
parcelRegister("47PzD", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("dvlQd")).then(()=>parcelRequire('EQECR'));

});

parcelRegister("eyJdQ", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("6zHu3")).then(()=>parcelRequire('d6kTk'));

});

parcelRegister("evti7", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("eV5Jf")).then(()=>parcelRequire('i3Xwy'));

});

parcelRegister("9LEFX", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("eiTOL")).then(()=>parcelRequire('fNL71'));

});

parcelRegister("hX0DW", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("bibVY")).then(()=>parcelRequire('lqu5z'));

});

parcelRegister("fcEIs", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("ffA4W")).then(()=>parcelRequire('1Uqbe'));

});

parcelRegister("escq7", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("jpCfe")).then(()=>parcelRequire('bN130'));

});

parcelRegister("cSbQI", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("eIocy")).then(()=>parcelRequire('aRm0F'));

});

parcelRegister("gQzlz", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("6xJS1")).then(()=>parcelRequire('5WayR'));

});

parcelRegister("jk26F", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("eEqOZ")).then(()=>parcelRequire('bokoO'));

});




parcelRegister("f6H8l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aff8dffdfc733bfc$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $40QgJ = parcelRequire("40QgJ");

var $d4N04 = parcelRequire("d4N04");

var $grcbH = parcelRequire("grcbH");
var $aff8dffdfc733bfc$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $aff8dffdfc733bfc$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $d4N04.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $aff8dffdfc733bfc$var$contrastModeMql = $aff8dffdfc733bfc$var$isMatchMediaAvailable && window.matchMedia((0, $grcbH.moreContrastMediaQuery));
var $aff8dffdfc733bfc$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$aff8dffdfc733bfc$var$contrastModeMql) return 'no-preference';
                return $aff8dffdfc733bfc$var$contrastModeMql !== null && $aff8dffdfc733bfc$var$contrastModeMql !== void 0 && $aff8dffdfc733bfc$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($aff8dffdfc733bfc$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $40QgJ.bind)($aff8dffdfc733bfc$var$contrastModeMql, {
                    type: 'change',
                    listener: $aff8dffdfc733bfc$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $aff8dffdfc733bfc$var$SingletonContrastModeObserver = new $aff8dffdfc733bfc$var$ContrastModeObserver();
var $aff8dffdfc733bfc$export$2e2bcd8739ae039 = $aff8dffdfc733bfc$var$SingletonContrastModeObserver;

});


parcelRegister("guOpQ", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $c0268e3487069227$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $c0268e3487069227$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $c0268e3487069227$export$e673f367da2ff23e; });

var $82V4i = parcelRequire("82V4i");

var $62ppy = parcelRequire("62ppy");

var $g8vme = parcelRequire("g8vme");

var $d4N04 = parcelRequire("d4N04");

var $9ydR5 = parcelRequire("9ydR5");
function $c0268e3487069227$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $9ydR5.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $d4N04.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $d4N04.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $c0268e3487069227$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(Array.from(document.head.querySelectorAll("style[".concat((0, $d4N04.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $d4N04.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $c0268e3487069227$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $g8vme.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("g8vme", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbf5b7a7f6ae4172$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1de8a9439d40392e3e4945ecf9d9214>>
 * @codegenCommand yarn build tokens
 */ var $bbf5b7a7f6ae4172$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $bbf5b7a7f6ae4172$export$2e2bcd8739ae039 = $bbf5b7a7f6ae4172$var$tokens;

});


parcelRegister("ll5tc", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", function () { return $f88fcd590f4e262f$export$dd6aeb7c823fc03d; });
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $f88fcd590f4e262f$export$5d76d7014f4a5d08; });

var $62ppy = parcelRequire("62ppy");

var $gQLDR = parcelRequire("gQLDR");

var $eOLIw = parcelRequire("eOLIw");
var $f88fcd590f4e262f$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $gQLDR.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $eOLIw.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $gQLDR.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $eOLIw.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(new Set(themePreferences));
};
var $f88fcd590f4e262f$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(new Set(themeOverridePreferences));
};

});
parcelRegister("eOLIw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac9abfd2b7ec16e3$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $r8LtT = parcelRequire("r8LtT");
function $ac9abfd2b7ec16e3$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $r8LtT.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});


parcelRegister("ihQIC", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("eNhc7")).then(()=>parcelRequire('l0zHX'));

});


parcelRegister("cpaps", function(module, exports) {

$parcel$export(module.exports, "Helmet", function () { return $907fe4f333c4ac9d$export$dcef8f9bb9a41431; }, function (v) { return $907fe4f333c4ac9d$export$dcef8f9bb9a41431 = v; });
$parcel$export(module.exports, "default", function () { return $907fe4f333c4ac9d$export$2e2bcd8739ae039; }, function (v) { return $907fe4f333c4ac9d$export$2e2bcd8739ae039 = v; });
var $907fe4f333c4ac9d$export$1e511d4a378977f5;
var $907fe4f333c4ac9d$export$dcef8f9bb9a41431;
var $907fe4f333c4ac9d$export$2e2bcd8739ae039;
$907fe4f333c4ac9d$export$1e511d4a378977f5 = true;
$907fe4f333c4ac9d$export$dcef8f9bb9a41431 = undefined;
var $907fe4f333c4ac9d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $907fe4f333c4ac9d$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dNMDr = parcelRequire("dNMDr");
var $907fe4f333c4ac9d$var$_react2 = $907fe4f333c4ac9d$var$_interopRequireDefault($dNMDr);

var $Jc9ZC = parcelRequire("Jc9ZC");
var $907fe4f333c4ac9d$var$_propTypes2 = $907fe4f333c4ac9d$var$_interopRequireDefault($Jc9ZC);

var $gi4l3 = parcelRequire("gi4l3");
var $907fe4f333c4ac9d$var$_reactSideEffect2 = $907fe4f333c4ac9d$var$_interopRequireDefault($gi4l3);

var $aWh3U = parcelRequire("aWh3U");
var $907fe4f333c4ac9d$var$_reactFastCompare2 = $907fe4f333c4ac9d$var$_interopRequireDefault($aWh3U);

var $e6oxt = parcelRequire("e6oxt");

var $9jY2H = parcelRequire("9jY2H");
function $907fe4f333c4ac9d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $907fe4f333c4ac9d$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $907fe4f333c4ac9d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $907fe4f333c4ac9d$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $907fe4f333c4ac9d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $907fe4f333c4ac9d$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $907fe4f333c4ac9d$var$_inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $907fe4f333c4ac9d$var$_classCallCheck(this, HelmetWrapper);
            return $907fe4f333c4ac9d$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, $907fe4f333c4ac9d$var$_reactFastCompare2.default)(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $9jY2H.TAG_NAMES.SCRIPT:
                case $9jY2H.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $9jY2H.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $907fe4f333c4ac9d$var$_extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $907fe4f333c4ac9d$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _extends2));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $9jY2H.TAG_NAMES.TITLE:
                    return $907fe4f333c4ac9d$var$_extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = $907fe4f333c4ac9d$var$_extends({}, newChildProps), _extends3));
                case $9jY2H.TAG_NAMES.BODY:
                    return $907fe4f333c4ac9d$var$_extends({}, newProps, {
                        bodyAttributes: $907fe4f333c4ac9d$var$_extends({}, newChildProps)
                    });
                case $9jY2H.TAG_NAMES.HTML:
                    return $907fe4f333c4ac9d$var$_extends({}, newProps, {
                        htmlAttributes: $907fe4f333c4ac9d$var$_extends({}, newChildProps)
                    });
            }
            return $907fe4f333c4ac9d$var$_extends({}, newProps, (_extends4 = {}, _extends4[child.type] = $907fe4f333c4ac9d$var$_extends({}, newChildProps), _extends4));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $907fe4f333c4ac9d$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _extends5;
                newFlattenedProps = $907fe4f333c4ac9d$var$_extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            $907fe4f333c4ac9d$var$_react2.default.Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $907fe4f333c4ac9d$var$_objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = (0, $e6oxt.convertReactPropstoHtmlAttributes)(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $9jY2H.TAG_NAMES.LINK:
                    case $9jY2H.TAG_NAMES.META:
                    case $9jY2H.TAG_NAMES.NOSCRIPT:
                    case $9jY2H.TAG_NAMES.SCRIPT:
                    case $9jY2H.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $907fe4f333c4ac9d$var$_objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $907fe4f333c4ac9d$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return $907fe4f333c4ac9d$var$_react2.default.createElement(Component, newProps);
        };
        $907fe4f333c4ac9d$var$_createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }($907fe4f333c4ac9d$var$_react2.default.Component), _class.propTypes = {
        base: $907fe4f333c4ac9d$var$_propTypes2.default.object,
        bodyAttributes: $907fe4f333c4ac9d$var$_propTypes2.default.object,
        children: $907fe4f333c4ac9d$var$_propTypes2.default.oneOfType([
            $907fe4f333c4ac9d$var$_propTypes2.default.arrayOf($907fe4f333c4ac9d$var$_propTypes2.default.node),
            $907fe4f333c4ac9d$var$_propTypes2.default.node
        ]),
        defaultTitle: $907fe4f333c4ac9d$var$_propTypes2.default.string,
        defer: $907fe4f333c4ac9d$var$_propTypes2.default.bool,
        encodeSpecialCharacters: $907fe4f333c4ac9d$var$_propTypes2.default.bool,
        htmlAttributes: $907fe4f333c4ac9d$var$_propTypes2.default.object,
        link: $907fe4f333c4ac9d$var$_propTypes2.default.arrayOf($907fe4f333c4ac9d$var$_propTypes2.default.object),
        meta: $907fe4f333c4ac9d$var$_propTypes2.default.arrayOf($907fe4f333c4ac9d$var$_propTypes2.default.object),
        noscript: $907fe4f333c4ac9d$var$_propTypes2.default.arrayOf($907fe4f333c4ac9d$var$_propTypes2.default.object),
        onChangeClientState: $907fe4f333c4ac9d$var$_propTypes2.default.func,
        script: $907fe4f333c4ac9d$var$_propTypes2.default.arrayOf($907fe4f333c4ac9d$var$_propTypes2.default.object),
        style: $907fe4f333c4ac9d$var$_propTypes2.default.arrayOf($907fe4f333c4ac9d$var$_propTypes2.default.object),
        title: $907fe4f333c4ac9d$var$_propTypes2.default.string,
        titleAttributes: $907fe4f333c4ac9d$var$_propTypes2.default.object,
        titleTemplate: $907fe4f333c4ac9d$var$_propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = (0, $e6oxt.mapStateOnServer)({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $907fe4f333c4ac9d$var$NullComponent = function NullComponent() {
    return null;
};
var $907fe4f333c4ac9d$var$HelmetSideEffects = (0, $907fe4f333c4ac9d$var$_reactSideEffect2.default)($e6oxt.reducePropsToState, $e6oxt.handleClientStateChange, $e6oxt.mapStateOnServer)($907fe4f333c4ac9d$var$NullComponent);
var $907fe4f333c4ac9d$var$HelmetExport = $907fe4f333c4ac9d$var$Helmet($907fe4f333c4ac9d$var$HelmetSideEffects);
$907fe4f333c4ac9d$var$HelmetExport.renderStatic = $907fe4f333c4ac9d$var$HelmetExport.rewind;
$907fe4f333c4ac9d$export$dcef8f9bb9a41431 = $907fe4f333c4ac9d$var$HelmetExport;
$907fe4f333c4ac9d$export$2e2bcd8739ae039 = $907fe4f333c4ac9d$var$HelmetExport;

});
parcelRegister("Jc9ZC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $087da2d74ee16cd8$var$ReactIs, $087da2d74ee16cd8$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("caltG"))();

});
parcelRegister("caltG", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $fVZXc = parcelRequire("fVZXc");
function $8db7144490c863bd$var$emptyFunction() {}
function $8db7144490c863bd$var$emptyFunctionWithReset() {}
$8db7144490c863bd$var$emptyFunctionWithReset.resetWarningCache = $8db7144490c863bd$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $fVZXc) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $8db7144490c863bd$var$emptyFunctionWithReset,
        resetWarningCache: $8db7144490c863bd$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("fVZXc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $b99c3c9d3db120cc$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $b99c3c9d3db120cc$var$ReactPropTypesSecret;

});



parcelRegister("gi4l3", function(module, exports) {
'use strict';
function $bdc1b157b562e5a2$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $dNMDr = parcelRequire("dNMDr");
var $bdc1b157b562e5a2$var$React__default = $bdc1b157b562e5a2$var$_interopDefault($dNMDr);

var $bdc1b157b562e5a2$var$shallowEqual = $bdc1b157b562e5a2$var$_interopDefault((parcelRequire("5oYzy")));
function $bdc1b157b562e5a2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bdc1b157b562e5a2$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $bdc1b157b562e5a2$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $bdc1b157b562e5a2$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $bdc1b157b562e5a2$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$bdc1b157b562e5a2$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $bdc1b157b562e5a2$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($dNMDr.Component);
        $bdc1b157b562e5a2$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $bdc1b157b562e5a2$var$_defineProperty(SideEffect, "canUseDOM", $bdc1b157b562e5a2$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $bdc1b157b562e5a2$var$withSideEffect;

});
parcelRegister("5oYzy", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});


parcelRegister("aWh3U", function(module, exports) {
'use strict';
var $7f6c8e5767b0a39e$var$isArray = Array.isArray;
var $7f6c8e5767b0a39e$var$keyList = Object.keys;
var $7f6c8e5767b0a39e$var$hasProp = Object.prototype.hasOwnProperty;
var $7f6c8e5767b0a39e$var$hasElementType = typeof Element !== 'undefined';
function $7f6c8e5767b0a39e$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $7f6c8e5767b0a39e$var$isArray(a), arrB = $7f6c8e5767b0a39e$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$7f6c8e5767b0a39e$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $7f6c8e5767b0a39e$var$keyList(a);
        length = keys.length;
        if (length !== $7f6c8e5767b0a39e$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$7f6c8e5767b0a39e$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($7f6c8e5767b0a39e$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$7f6c8e5767b0a39e$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $7f6c8e5767b0a39e$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("e6oxt", function(module, exports) {

$parcel$export(module.exports, "reducePropsToState", function () { return $a444a9233d3bbdf6$export$bfed3b07ff81c934; }, function (v) { return $a444a9233d3bbdf6$export$bfed3b07ff81c934 = v; });
$parcel$export(module.exports, "mapStateOnServer", function () { return $a444a9233d3bbdf6$export$971402543ca2bd1d; }, function (v) { return $a444a9233d3bbdf6$export$971402543ca2bd1d = v; });
$parcel$export(module.exports, "handleClientStateChange", function () { return $a444a9233d3bbdf6$export$8e0854f6f2040fff; }, function (v) { return $a444a9233d3bbdf6$export$8e0854f6f2040fff = v; });
$parcel$export(module.exports, "convertReactPropstoHtmlAttributes", function () { return $a444a9233d3bbdf6$export$8f437c7c6568a694; }, function (v) { return $a444a9233d3bbdf6$export$8f437c7c6568a694 = v; });
var $a444a9233d3bbdf6$export$1e511d4a378977f5;
var $a444a9233d3bbdf6$export$c106dd0671a0fc2d;
var $a444a9233d3bbdf6$export$6cb2c4c0a22909c0;
var $a444a9233d3bbdf6$export$bfed3b07ff81c934;
var $a444a9233d3bbdf6$export$971402543ca2bd1d;
var $a444a9233d3bbdf6$export$8e0854f6f2040fff;
var $a444a9233d3bbdf6$export$8f437c7c6568a694;
$a444a9233d3bbdf6$export$1e511d4a378977f5 = true;
$a444a9233d3bbdf6$export$c106dd0671a0fc2d = $a444a9233d3bbdf6$export$6cb2c4c0a22909c0 = $a444a9233d3bbdf6$export$bfed3b07ff81c934 = $a444a9233d3bbdf6$export$971402543ca2bd1d = $a444a9233d3bbdf6$export$8e0854f6f2040fff = $a444a9233d3bbdf6$export$8f437c7c6568a694 = undefined;
var $a444a9233d3bbdf6$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $a444a9233d3bbdf6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $dNMDr = parcelRequire("dNMDr");
var $a444a9233d3bbdf6$var$_react2 = $a444a9233d3bbdf6$var$_interopRequireDefault($dNMDr);

var $48q3c = parcelRequire("48q3c");
var $a444a9233d3bbdf6$var$_objectAssign2 = $a444a9233d3bbdf6$var$_interopRequireDefault($48q3c);

var $9jY2H = parcelRequire("9jY2H");
function $a444a9233d3bbdf6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a444a9233d3bbdf6$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $a444a9233d3bbdf6$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $a444a9233d3bbdf6$var$getInnermostProperty(propsList, $9jY2H.TAG_NAMES.TITLE);
    var innermostTemplate = $a444a9233d3bbdf6$var$getInnermostProperty(propsList, $9jY2H.HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return innermostTitle;
    });
    var innermostDefaultTitle = $a444a9233d3bbdf6$var$getInnermostProperty(propsList, $9jY2H.HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $a444a9233d3bbdf6$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $a444a9233d3bbdf6$var$getInnermostProperty(propsList, $9jY2H.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $a444a9233d3bbdf6$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $a444a9233d3bbdf6$var$_extends({}, tagAttrs, current);
    }, {});
};
var $a444a9233d3bbdf6$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$9jY2H.TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$9jY2H.TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $a444a9233d3bbdf6$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $a444a9233d3bbdf6$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $a444a9233d3bbdf6$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $9jY2H.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $9jY2H.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $9jY2H.TAG_PROPERTIES.INNER_HTML || attributeKey === $9jY2H.TAG_PROPERTIES.CSS_TEXT || attributeKey === $9jY2H.TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, $a444a9233d3bbdf6$var$_objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $a444a9233d3bbdf6$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $a444a9233d3bbdf6$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $a444a9233d3bbdf6$var$getBaseTagFromPropsList([
            $9jY2H.TAG_PROPERTIES.HREF
        ], propsList),
        bodyAttributes: $a444a9233d3bbdf6$var$getAttributesFromPropsList($9jY2H.ATTRIBUTE_NAMES.BODY, propsList),
        defer: $a444a9233d3bbdf6$var$getInnermostProperty(propsList, $9jY2H.HELMET_PROPS.DEFER),
        encode: $a444a9233d3bbdf6$var$getInnermostProperty(propsList, $9jY2H.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $a444a9233d3bbdf6$var$getAttributesFromPropsList($9jY2H.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $a444a9233d3bbdf6$var$getTagsFromPropsList($9jY2H.TAG_NAMES.LINK, [
            $9jY2H.TAG_PROPERTIES.REL,
            $9jY2H.TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $a444a9233d3bbdf6$var$getTagsFromPropsList($9jY2H.TAG_NAMES.META, [
            $9jY2H.TAG_PROPERTIES.NAME,
            $9jY2H.TAG_PROPERTIES.CHARSET,
            $9jY2H.TAG_PROPERTIES.HTTPEQUIV,
            $9jY2H.TAG_PROPERTIES.PROPERTY,
            $9jY2H.TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $a444a9233d3bbdf6$var$getTagsFromPropsList($9jY2H.TAG_NAMES.NOSCRIPT, [
            $9jY2H.TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $a444a9233d3bbdf6$var$getOnChangeClientState(propsList),
        scriptTags: $a444a9233d3bbdf6$var$getTagsFromPropsList($9jY2H.TAG_NAMES.SCRIPT, [
            $9jY2H.TAG_PROPERTIES.SRC,
            $9jY2H.TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $a444a9233d3bbdf6$var$getTagsFromPropsList($9jY2H.TAG_NAMES.STYLE, [
            $9jY2H.TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $a444a9233d3bbdf6$var$getTitleFromPropsList(propsList),
        titleAttributes: $a444a9233d3bbdf6$var$getAttributesFromPropsList($9jY2H.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $a444a9233d3bbdf6$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $a444a9233d3bbdf6$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $a444a9233d3bbdf6$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $a444a9233d3bbdf6$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $a444a9233d3bbdf6$var$rafPolyfill : $parcel$global.requestAnimationFrame || $a444a9233d3bbdf6$var$rafPolyfill;
var $a444a9233d3bbdf6$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $a444a9233d3bbdf6$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $a444a9233d3bbdf6$var$cafPolyfill;
var $a444a9233d3bbdf6$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $a444a9233d3bbdf6$var$_helmetCallback = null;
var $a444a9233d3bbdf6$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($a444a9233d3bbdf6$var$_helmetCallback) $a444a9233d3bbdf6$var$cancelAnimationFrame($a444a9233d3bbdf6$var$_helmetCallback);
    if (newState.defer) $a444a9233d3bbdf6$var$_helmetCallback = $a444a9233d3bbdf6$var$requestAnimationFrame(function() {
        $a444a9233d3bbdf6$var$commitTagChanges(newState, function() {
            $a444a9233d3bbdf6$var$_helmetCallback = null;
        });
    });
    else {
        $a444a9233d3bbdf6$var$commitTagChanges(newState);
        $a444a9233d3bbdf6$var$_helmetCallback = null;
    }
};
var $a444a9233d3bbdf6$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $a444a9233d3bbdf6$var$updateAttributes($9jY2H.TAG_NAMES.BODY, bodyAttributes);
    $a444a9233d3bbdf6$var$updateAttributes($9jY2H.TAG_NAMES.HTML, htmlAttributes);
    $a444a9233d3bbdf6$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $a444a9233d3bbdf6$var$updateTags($9jY2H.TAG_NAMES.BASE, baseTag),
        linkTags: $a444a9233d3bbdf6$var$updateTags($9jY2H.TAG_NAMES.LINK, linkTags),
        metaTags: $a444a9233d3bbdf6$var$updateTags($9jY2H.TAG_NAMES.META, metaTags),
        noscriptTags: $a444a9233d3bbdf6$var$updateTags($9jY2H.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $a444a9233d3bbdf6$var$updateTags($9jY2H.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $a444a9233d3bbdf6$var$updateTags($9jY2H.TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $a444a9233d3bbdf6$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $a444a9233d3bbdf6$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $a444a9233d3bbdf6$var$flattenArray(title);
    $a444a9233d3bbdf6$var$updateAttributes($9jY2H.TAG_NAMES.TITLE, attributes);
};
var $a444a9233d3bbdf6$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($9jY2H.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($9jY2H.HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($9jY2H.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($9jY2H.HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $a444a9233d3bbdf6$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($9jY2H.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $9jY2H.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $9jY2H.TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $9jY2H.TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($9jY2H.HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $a444a9233d3bbdf6$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $a444a9233d3bbdf6$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $a444a9233d3bbdf6$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $a444a9233d3bbdf6$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $9jY2H.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $a444a9233d3bbdf6$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $9jY2H.HELMET_ATTRIBUTE + "=\"true\">" + $a444a9233d3bbdf6$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $a444a9233d3bbdf6$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $9jY2H.TAG_PROPERTIES.INNER_HTML || attribute === $9jY2H.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $a444a9233d3bbdf6$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $9jY2H.SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $9jY2H.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $a444a9233d3bbdf6$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$9jY2H.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $a444a9233d3bbdf6$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$9jY2H.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $a444a9233d3bbdf6$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$9jY2H.HELMET_ATTRIBUTE] = true, _initProps);
    var props = $a444a9233d3bbdf6$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        $a444a9233d3bbdf6$var$_react2.default.createElement($9jY2H.TAG_NAMES.TITLE, props, title)
    ];
};
var $a444a9233d3bbdf6$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$9jY2H.HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $9jY2H.REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $9jY2H.TAG_PROPERTIES.INNER_HTML || mappedAttribute === $9jY2H.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return $a444a9233d3bbdf6$var$_react2.default.createElement(type, mappedTag);
    });
};
var $a444a9233d3bbdf6$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $9jY2H.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $a444a9233d3bbdf6$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $a444a9233d3bbdf6$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $9jY2H.ATTRIBUTE_NAMES.BODY:
        case $9jY2H.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $a444a9233d3bbdf6$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $a444a9233d3bbdf6$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $a444a9233d3bbdf6$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $a444a9233d3bbdf6$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $a444a9233d3bbdf6$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $a444a9233d3bbdf6$var$getMethodsForTag($9jY2H.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $a444a9233d3bbdf6$var$getMethodsForTag($9jY2H.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $a444a9233d3bbdf6$var$getMethodsForTag($9jY2H.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $a444a9233d3bbdf6$var$getMethodsForTag($9jY2H.TAG_NAMES.LINK, linkTags, encode),
        meta: $a444a9233d3bbdf6$var$getMethodsForTag($9jY2H.TAG_NAMES.META, metaTags, encode),
        noscript: $a444a9233d3bbdf6$var$getMethodsForTag($9jY2H.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $a444a9233d3bbdf6$var$getMethodsForTag($9jY2H.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $a444a9233d3bbdf6$var$getMethodsForTag($9jY2H.TAG_NAMES.STYLE, styleTags, encode),
        title: $a444a9233d3bbdf6$var$getMethodsForTag($9jY2H.TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
$a444a9233d3bbdf6$export$8f437c7c6568a694 = $a444a9233d3bbdf6$var$convertReactPropstoHtmlAttributes;
$a444a9233d3bbdf6$export$8e0854f6f2040fff = $a444a9233d3bbdf6$var$handleClientStateChange;
$a444a9233d3bbdf6$export$971402543ca2bd1d = $a444a9233d3bbdf6$var$mapStateOnServer;
$a444a9233d3bbdf6$export$bfed3b07ff81c934 = $a444a9233d3bbdf6$var$reducePropsToState;
$a444a9233d3bbdf6$export$6cb2c4c0a22909c0 = $a444a9233d3bbdf6$var$requestAnimationFrame;
$a444a9233d3bbdf6$export$c106dd0671a0fc2d = $a444a9233d3bbdf6$var$warn;

});
parcelRegister("9jY2H", function(module, exports) {

$parcel$export(module.exports, "ATTRIBUTE_NAMES", function () { return $6c94769d1bb46036$export$8b4d23abccee6cc2; }, function (v) { return $6c94769d1bb46036$export$8b4d23abccee6cc2 = v; });
$parcel$export(module.exports, "TAG_NAMES", function () { return $6c94769d1bb46036$export$7e674a85a2656dce; }, function (v) { return $6c94769d1bb46036$export$7e674a85a2656dce = v; });
$parcel$export(module.exports, "TAG_PROPERTIES", function () { return $6c94769d1bb46036$export$55a55363959ee034; }, function (v) { return $6c94769d1bb46036$export$55a55363959ee034 = v; });
$parcel$export(module.exports, "REACT_TAG_MAP", function () { return $6c94769d1bb46036$export$f5ab464b3d67ea9c; }, function (v) { return $6c94769d1bb46036$export$f5ab464b3d67ea9c = v; });
$parcel$export(module.exports, "HELMET_PROPS", function () { return $6c94769d1bb46036$export$6bb0645fb3f2618c; }, function (v) { return $6c94769d1bb46036$export$6bb0645fb3f2618c = v; });
$parcel$export(module.exports, "HTML_TAG_MAP", function () { return $6c94769d1bb46036$export$3fedf55cd3a4e6fa; }, function (v) { return $6c94769d1bb46036$export$3fedf55cd3a4e6fa = v; });
$parcel$export(module.exports, "SELF_CLOSING_TAGS", function () { return $6c94769d1bb46036$export$7f7c530a82f07f20; }, function (v) { return $6c94769d1bb46036$export$7f7c530a82f07f20 = v; });
$parcel$export(module.exports, "HELMET_ATTRIBUTE", function () { return $6c94769d1bb46036$export$1f547d7d8e831b2b; }, function (v) { return $6c94769d1bb46036$export$1f547d7d8e831b2b = v; });
var $6c94769d1bb46036$export$1e511d4a378977f5;
var $6c94769d1bb46036$export$8b4d23abccee6cc2;
var $6c94769d1bb46036$export$7e674a85a2656dce;
var $6c94769d1bb46036$export$7a7b396eb62fa0f9;
var $6c94769d1bb46036$export$55a55363959ee034;
var $6c94769d1bb46036$export$f5ab464b3d67ea9c;
var $6c94769d1bb46036$export$6bb0645fb3f2618c;
var $6c94769d1bb46036$export$3fedf55cd3a4e6fa;
var $6c94769d1bb46036$export$7f7c530a82f07f20;
var $6c94769d1bb46036$export$1f547d7d8e831b2b;
$6c94769d1bb46036$export$1e511d4a378977f5 = true;
var $6c94769d1bb46036$var$ATTRIBUTE_NAMES = $6c94769d1bb46036$export$8b4d23abccee6cc2 = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $6c94769d1bb46036$var$TAG_NAMES = $6c94769d1bb46036$export$7e674a85a2656dce = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $6c94769d1bb46036$var$VALID_TAG_NAMES = $6c94769d1bb46036$export$7a7b396eb62fa0f9 = Object.keys($6c94769d1bb46036$var$TAG_NAMES).map(function(name) {
    return $6c94769d1bb46036$var$TAG_NAMES[name];
});
var $6c94769d1bb46036$var$TAG_PROPERTIES = $6c94769d1bb46036$export$55a55363959ee034 = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};
var $6c94769d1bb46036$var$REACT_TAG_MAP = $6c94769d1bb46036$export$f5ab464b3d67ea9c = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $6c94769d1bb46036$var$HELMET_PROPS = $6c94769d1bb46036$export$6bb0645fb3f2618c = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $6c94769d1bb46036$var$HTML_TAG_MAP = $6c94769d1bb46036$export$3fedf55cd3a4e6fa = Object.keys($6c94769d1bb46036$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$6c94769d1bb46036$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $6c94769d1bb46036$var$SELF_CLOSING_TAGS = $6c94769d1bb46036$export$7f7c530a82f07f20 = [
    $6c94769d1bb46036$var$TAG_NAMES.NOSCRIPT,
    $6c94769d1bb46036$var$TAG_NAMES.SCRIPT,
    $6c94769d1bb46036$var$TAG_NAMES.STYLE
];
var $6c94769d1bb46036$var$HELMET_ATTRIBUTE = $6c94769d1bb46036$export$1f547d7d8e831b2b = "data-react-helmet";

});



parcelRegister("2eVHl", function(module, exports) {

$parcel$export(module.exports, "SimpleCobranding", function () { return $c87b121964dbc330$export$d04480ee89603948; });
$parcel$export(module.exports, "AdvancedCobranding", function () { return $c87b121964dbc330$export$6e3d039ab597dde7; });
$parcel$export(module.exports, "isSimpleCobranding", function () { return $c87b121964dbc330$export$4289c1cc8b535433; });
$parcel$export(module.exports, "isAdvancedCobranding", function () { return $c87b121964dbc330$export$4d91d2f372f755c7; });
$parcel$export(module.exports, "getCurrentCobranding", function () { return $c87b121964dbc330$export$7a6337ee64e317c4; });
$parcel$export(module.exports, "CobrandingProvider", function () { return $c87b121964dbc330$export$c5b813538c5440a9; });
$parcel$export(module.exports, "useCobranding", function () { return $c87b121964dbc330$export$808c37e33518fa32; });

var $dNMDr = parcelRequire("dNMDr");

var $fcxz7 = parcelRequire("fcxz7");

var $4qLQH = parcelRequire("4qLQH");

var $84ZjZ = parcelRequire("84ZjZ");

var $cBB3b = parcelRequire("cBB3b");

var $5qeve = parcelRequire("5qeve");

var $hQbnq = parcelRequire("hQbnq");

var $fvS7F = parcelRequire("fvS7F");
var $c87b121964dbc330$export$d04480ee89603948 = /*#__PURE__*/ function(SimpleCobranding) {
    SimpleCobranding["ADMIN"] = "admin";
    SimpleCobranding["ATLAS"] = "atlas";
    SimpleCobranding["BITBUCKET"] = "bitbucket";
    SimpleCobranding["COMMUNITY"] = "community";
    SimpleCobranding["COMPASS"] = "compass";
    SimpleCobranding["CONFLUENCE"] = "confluence";
    SimpleCobranding["JIRA"] = "jira";
    SimpleCobranding["JIRA_ALIGN"] = "jira-align";
    SimpleCobranding["LOOM"] = "loom";
    SimpleCobranding["NO_COBRANDING"] = "no-cobranding";
    SimpleCobranding["OPSGENIE"] = "opsgenie";
    SimpleCobranding["PRT"] = "prt";
    SimpleCobranding["ROVO"] = "rovo";
    SimpleCobranding["SAC"] = "sac";
    SimpleCobranding["STATUSPAGE"] = "statuspage";
    SimpleCobranding["SUPPORT"] = "support";
    SimpleCobranding["TRELLO"] = "trello";
    SimpleCobranding["WAC"] = "wac";
    return SimpleCobranding;
}({});
var $c87b121964dbc330$export$6e3d039ab597dde7 = /*#__PURE__*/ function(AdvancedCobranding) {
    AdvancedCobranding["ACCOUNT_LINKING"] = "account-linking";
    AdvancedCobranding["ATLAS_66195"] = "atlas-66195";
    AdvancedCobranding["CFIND_2409"] = "cfind-2409";
    AdvancedCobranding["CONFLUENCE_ATLAS_75650"] = "confluence-atlas-75650";
    AdvancedCobranding["DEMO"] = "demo";
    AdvancedCobranding["ENTRY_AUTH"] = "entry-auth";
    AdvancedCobranding["CHAMPION_APPLY"] = "champion-apply";
    AdvancedCobranding["CHAMPION_CONSENT"] = "champion-consent";
    AdvancedCobranding["ISOLATED_CLOUD"] = "ic";
    AdvancedCobranding["JIRA_ATLAS_75650"] = "jira-atlas-75650";
    AdvancedCobranding["LOOM"] = "default";
    AdvancedCobranding["PRT_DEMO"] = "prt-demo";
    AdvancedCobranding["SERVICE_COLLECTION"] = "service-collection";
    AdvancedCobranding["TEAMWORK_COLLECTION"] = "teamwork-collection";
    AdvancedCobranding["TRELLO"] = "direct-signup";
    AdvancedCobranding["TWCG_1160_CONFLUENCE"] = "twcg-1160-confluence";
    AdvancedCobranding["TWCG_1160_JIRA"] = "twcg-1160-jira";
    AdvancedCobranding["TWCG_1293_FTA_OTP"] = "twcg-1293-fta-otp";
    AdvancedCobranding["TWCG_786_PRIORITISE_SSO_ON_LOGIN_PAGE"] = "twcg-786-prioritise-sso";
    AdvancedCobranding["WAC_JPD"] = "jpd";
    AdvancedCobranding["WAC_JSM"] = "jsm";
    AdvancedCobranding["WAC_LOOM"] = "loom-cobranding";
    return AdvancedCobranding;
}({});
const $c87b121964dbc330$export$4289c1cc8b535433 = (value)=>Object.values($c87b121964dbc330$export$d04480ee89603948).includes(value);
const $c87b121964dbc330$export$4d91d2f372f755c7 = (value)=>Object.values($c87b121964dbc330$export$6e3d039ab597dde7).includes(value);
const $c87b121964dbc330$var$getDisabledApplicationKeys = (dynamicConfigs)=>{
    const disabledApplicationKeys = dynamicConfigs.getStringList((0, $4qLQH.AidFrontendDynamicConfig).DISABLED_COBRANDING_APPLICATION_KEYS);
    if ('value' in disabledApplicationKeys) return disabledApplicationKeys.value;
    return [];
};
const $c87b121964dbc330$var$getApplicationKey = (applicationData)=>{
    return `${applicationData.coreApplication}${applicationData.experience ? `--${applicationData.experience}` : ''}`;
};
function $c87b121964dbc330$export$7a6337ee64e317c4(cobranding, dynamicConfigs, analyticsClient) {
    const applicationData = (0, $fcxz7.lookupApplication)(cobranding);
    if (applicationData) {
        const disabledApplicationKeys = $c87b121964dbc330$var$getDisabledApplicationKeys(dynamicConfigs);
        const applicationKey = $c87b121964dbc330$var$getApplicationKey(applicationData);
        if (disabledApplicationKeys.includes(applicationKey)) {
            console.log(`Cobranding disabled for application: ${applicationKey}`);
            return "no-cobranding";
        }
        switch(applicationData.coreApplication){
            case 'admin':
                switch(applicationData.experience){
                    case 'jira-atlas-75650':
                        return "jira-atlas-75650";
                    case 'confluence-atlas-75650':
                        return "confluence-atlas-75650";
                    default:
                        if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                        return "no-cobranding";
                }
            case 'atlas':
                if (applicationData.experience === 'twcg-786-prioritise-sso') return "twcg-786-prioritise-sso";
                if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                return "atlas";
            case 'bitbucket':
                if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                return "bitbucket";
            case 'community':
                switch(applicationData.experience){
                    case 'account-linking':
                        return "account-linking";
                    case 'entry-auth':
                        return "entry-auth";
                    case 'champion-apply':
                        return "champion-apply";
                    case 'champion-consent':
                        return "champion-consent";
                    default:
                        if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                        return "community";
                }
            case 'compass':
                return "compass";
            case 'confluence':
                switch(applicationData.experience){
                    case 'twcg-1160':
                        if ((0, $84ZjZ.checkFeatureGate)((0, $cBB3b.AidFrontendFeatureGate).TWCG_1160_CONTEXTUAL_BACKGROUNDS)) return "twcg-1160-confluence";
                        return "confluence";
                    case 'mobile-ios-ic':
                    case 'mobile-android-ic':
                        return "ic";
                    default:
                        if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                        return "confluence";
                }
            case 'jira':
                switch(applicationData.experience){
                    case 'twcg-1293-fta-otp':
                        return "twcg-1293-fta-otp";
                    case 'twcg-1160':
                        if ((0, $84ZjZ.checkFeatureGate)((0, $cBB3b.AidFrontendFeatureGate).TWCG_1160_CONTEXTUAL_BACKGROUNDS)) return "twcg-1160-jira";
                        return "jira";
                    case 'mobile-ios-ic':
                    case 'mobile-android-ic':
                        return "ic";
                    case 'twcg-786-prioritise-sso':
                        return "twcg-786-prioritise-sso";
                    default:
                        if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                        return "jira";
                }
            case 'jira-align':
                if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                return "jira-align";
            case 'loom':
                if (applicationData.experience === 'default') return "default";
                if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                return "loom";
            case 'mpac':
                if (applicationData.experience === 'ic') return "ic";
                if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                return "no-cobranding";
            case 'opsgenie':
                if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                return "opsgenie";
            case 'pollinator':
                if (applicationData.experience) {
                    if (applicationData.experience.startsWith('jira')) return "jira";
                    if (applicationData.experience.startsWith('confluence')) return "confluence";
                    if (applicationData.experience === 'demo') return "demo";
                }
                return "no-cobranding";
            case 'prt':
                if (applicationData.experience === 'demo') return "prt-demo";
                if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                return "prt";
            case 'rovo':
                if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                return "rovo";
            case 'sac':
                if (applicationData.experience === 'ic') return "ic";
                if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                return "no-cobranding";
            case 'statuspage':
                if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                return "statuspage";
            case 'support':
                if (applicationData.experience === 'ic') return "ic";
                if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                return "no-cobranding";
            case 'trello':
                switch(applicationData.experience){
                    case 'direct-signup':
                        if ((0, $hQbnq.checkDirectSignupExperiment)({
                            applicationData: applicationData,
                            analyticsClient: analyticsClient
                        }) && (0, $fvS7F.isDirectSignup)()) return "direct-signup";
                        return "trello";
                    default:
                        if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                        return "trello";
                }
            case 'wac':
                switch(applicationData.experience){
                    case 'otp-jira':
                    case 'atlas-66195':
                        return "atlas-66195";
                    case 'otp-confluence':
                    case 'cfind-2409':
                        return "cfind-2409";
                    case 'loom':
                        return "loom-cobranding";
                    case 'jpd':
                        return "jpd";
                    case 'jsm':
                        return "jsm";
                    case 'service-collection':
                        return "service-collection";
                    case 'teamwork-collection':
                        return "teamwork-collection";
                    case 'ic':
                        return "ic";
                    default:
                        if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
                        return "no-cobranding";
                }
        }
    }
    if ((0, $5qeve.checkAndActivateTWCG786Experiment)(applicationData, analyticsClient)) return "twcg-786-prioritise-sso";
    return "no-cobranding";
}
const $c87b121964dbc330$var$CobrandingContext = /*#__PURE__*/ (0, $dNMDr.createContext)({
    cobranding: "no-cobranding",
    isMobileApp: false
});
const $c87b121964dbc330$export$c5b813538c5440a9 = $c87b121964dbc330$var$CobrandingContext.Provider;
const $c87b121964dbc330$export$b9c89a068720407f = $c87b121964dbc330$var$CobrandingContext.Consumer;
const $c87b121964dbc330$export$808c37e33518fa32 = ()=>(0, $dNMDr.useContext)($c87b121964dbc330$var$CobrandingContext);

});
parcelRegister("4qLQH", function(module, exports) {

$parcel$export(module.exports, "AidFrontendDynamicConfig", function () { return $c819ce6fac8eb4fb$export$72c0add96dbeed4e; });
var $c819ce6fac8eb4fb$export$72c0add96dbeed4e = /*#__PURE__*/ function(AidFrontendDynamicConfig) {
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_disabled_cobranding_application_keys
    AidFrontendDynamicConfig["DISABLED_COBRANDING_APPLICATION_KEYS"] = "aid-frontend_disabled_cobranding_application_keys";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/google_login_outage_advisory
    AidFrontendDynamicConfig["GOOGLE_LOGIN_OUTAGE_ADVISORY"] = "google_login_outage_advisory";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_apple_login_outage_advisory
    AidFrontendDynamicConfig["APPLE_LOGIN_OUTAGE_ADVISORY"] = "aid-frontend_apple_login_outage_advisory";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_slack_login_outage_advisory
    AidFrontendDynamicConfig["SLACK_LOGIN_OUTAGE_ADVISORY"] = "aid-frontend_slack_login_outage_advisory";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_microsoft_login_outage_advisory
    AidFrontendDynamicConfig["MICROSOFT_LOGIN_OUTAGE_ADVISORY"] = "aid-frontend_microsoft_login_outage_advisory";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_google_one_tap_kill_switch
    AidFrontendDynamicConfig["GOOGLE_ONE_TAP_KILL_SWITCH"] = "aid-frontend_google_one_tap_kill_switch";
    return AidFrontendDynamicConfig;
}({});

});

parcelRegister("cBB3b", function(module, exports) {

$parcel$export(module.exports, "AidFrontendFeatureGate", function () { return $86a0b3a91c17f37b$export$e2b0cf8c8e2eb757; });
$parcel$export(module.exports, "AidFrontendExperiment", function () { return $86a0b3a91c17f37b$export$32c261e7d1dff436; });
var $86a0b3a91c17f37b$export$e2b0cf8c8e2eb757 = /*#__PURE__*/ function(AidFrontendFeatureGate) {
    // Stable test-only entry. Use this in unit tests so they don't break when real gates are added or removed.
    AidFrontendFeatureGate["TEST_GATE"] = "test_gate";
    // https://switcheroo.atlassian.com/ui/gates/c2e09b58-639a-4260-89de-4b390ac2b746/key/identity-aid-frontend-sms-enrollment-new-captcha
    // https://hello.atlassian.net/wiki/spaces/I/pages/4492639544/22-11-2025+Current+State+of+UniCAPTCHA+rollout
    AidFrontendFeatureGate["SMS_ENROLLMENT_UNICAPTCHA"] = "identity-aid-frontend-sms-enrollment-new-captcha";
    // !! IMPORTANT !! Make sure to update integration test mocks to use the new endpoints when this is updated/removed/added
    // https://switcheroo.atlassian.com/ui/gates/fc7e9434-0ffa-46ba-9831-43c4cba66cdc/key/id-frontend-use-state-data-loaders
    AidFrontendFeatureGate["USE_STATE_DATA_LOADERS"] = "id-frontend-use-state-data-loaders";
    // https://switcheroo.atlassian.com/ui/gates/e2f249e8-68ad-46fe-8617-c903b90bf375/key/kirby-7873_new_json_endpoint_for_verify-email
    AidFrontendFeatureGate["ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL"] = "kirby-7873_new_json_endpoint_for_verify-email";
    // https://switcheroo.atlassian.com/ui/gates/c8c89cad-01ec-4f62-860b-f8d1c824d9e3/key/twcg-1160_contextual_backgrounds_idac_-_gate
    AidFrontendFeatureGate["TWCG_1160_CONTEXTUAL_BACKGROUNDS"] = "twcg-1160_contextual_backgrounds_idac_-_gate";
    // https://switcheroo.atlassian.com/ui/gates/e453edbd-fac6-473a-9c80-8f0f65225db3/key/twcg-786-prioritise-sso-gate
    AidFrontendFeatureGate["TWCG_786_PRIORITISE_SSO_ON_LOGIN_PAGE_GATE"] = "twcg-786-prioritise-sso-gate";
    // https://switcheroo.atlassian.com/ui/gates/a565fcb4-3217-46f8-805d-b457c3b9f765/key/twcg-786-prioritise-sso-on-login-page
    AidFrontendFeatureGate["TWCG_786_PRIORITISE_SSO_ON_LOGIN_PAGE"] = "twcg-786-prioritise-sso-on-login-page";
    AidFrontendFeatureGate["CFIND_4831_PRODUCT_OVERLAY_MODAL_VISUAL_UPDATES"] = "cfind_4831_product_overlay_modal_visual_updates";
    // https://switcheroo.atlassian.com/ui/gates/8448999d-2aa7-4b02-9d30-08f8cca46365/key/id-frontend-enable-aws-waf-captcha
    AidFrontendFeatureGate["ENABLE_AWS_WAF_CAPTCHA"] = "id-frontend-enable-aws-waf-captcha";
    // https://switcheroo.atlassian.com/ui/gates/173e80a9-c83a-473c-b04a-52e10980b2c1/key/id-frontend-remove-recaptcha-tos-references
    AidFrontendFeatureGate["REMOVE_RECAPTCHA_TOS_REFS"] = "id-frontend-remove-recaptcha-tos-references";
    AidFrontendFeatureGate["CFIND_5480_TWC_SIGNUP_OVERLAY"] = "cfind-5480-twc-signup-overlay";
    return AidFrontendFeatureGate;
}({});
var $86a0b3a91c17f37b$export$32c261e7d1dff436 = /*#__PURE__*/ function(AidFrontendExperiment) {
    // Stable test-only entry. Use this in unit tests so they don't break when real experiments are added or removed.
    AidFrontendExperiment["TEST_EXPERIMENT"] = "test_experiment";
    // https://switcheroo.atlassian.com/ui/gates/6bfb6ca5-bcb2-436e-af68-ca7bbff05426/key/ghost_advanced_cobranding_direct_signup
    AidFrontendExperiment["GHOST_ADVANCED_COBRANDING_DIRECT_SIGNUP"] = "ghost_advanced_cobranding_direct_signup";
    // https://switcheroo.atlassian.com/ui/gates/d87004f4-e204-4701-b20d-63ed683fdc22/key/twcg-1160_contextual_backgrounds_invite_email_-_ab
    AidFrontendExperiment["TWCG_1160_CONTEXTUAL_BACKGROUNDS_INVITE_EMAIL"] = "twcg-1160_contextual_backgrounds_invite_email_-_ab";
    return AidFrontendExperiment;
}({});

});

parcelRegister("5qeve", function(module, exports) {

$parcel$export(module.exports, "getActiveExperimentConfig", function () { return $0028e260f091dfe7$export$bf07689d5703c1b6; });
$parcel$export(module.exports, "checkAndActivateTWCG786Experiment", function () { return $0028e260f091dfe7$export$78e3a97ba5b40a8f; });

var $g099A = parcelRequire("g099A");

var $84ZjZ = parcelRequire("84ZjZ");

var $cBB3b = parcelRequire("cBB3b");

var $2eVHl = parcelRequire("2eVHl");

var $hhYxc = parcelRequire("hhYxc");
const $0028e260f091dfe7$var$TWCG_786_EXPERIMENT_KEY = 'twcg-786-prioritise-sso-on-login-page';
/** Guard: fire exposure event at most once per page load (resets on full reload). */ let $0028e260f091dfe7$var$twcg786ExposureEventFired = false;
/**
 * The resolved config for the active experiment session.
 * Cleared at the start of checkAndActivateTWCG786Experiment() on each cobranding
 * resolution, then set by activateTWCG786ExperimentForApplication() if the user is
 * in the variation cohort.
 */ let $0028e260f091dfe7$var$activeExperimentConfig;
const $0028e260f091dfe7$export$bf07689d5703c1b6 = ()=>$0028e260f091dfe7$var$activeExperimentConfig;
/**
 * Per-application config for the TWCG-786 experiment.
 * Add an entry here when onboarding a new application to the experiment.
 *
 * Defined as a function to avoid a circular-dependency initialisation issue:
 * experiment-utils.ts and cobranding.tsx import each other, so referencing
 * SimpleCobranding at module scope would resolve before cobranding.tsx finishes
 * evaluating. Wrapping it in a function defers the access to call time.
 */ const $0028e260f091dfe7$var$getConfigByApplication = ()=>({
        admin: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).NO_COBRANDING,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        },
        atlas: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).ATLAS,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        },
        bitbucket: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).BITBUCKET,
            textColor: 'color.text.inverse',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'inverse',
            logoVersionMobile: 'neutral'
        },
        community: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).COMMUNITY,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        },
        confluence: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).CONFLUENCE,
            textColor: 'color.text.inverse',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'inverse',
            logoVersionMobile: 'neutral'
        },
        jira: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).JIRA,
            textColor: 'color.text.inverse',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'inverse',
            logoVersionMobile: 'neutral'
        },
        'jira-align': {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).JIRA_ALIGN,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        },
        loom: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).LOOM,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        },
        mpac: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).NO_COBRANDING,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        },
        opsgenie: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).OPSGENIE,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        },
        prt: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).PRT,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        },
        rovo: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).ROVO,
            textColor: 'color.text.inverse',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'inverse',
            logoVersionMobile: 'neutral'
        },
        sac: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).NO_COBRANDING,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        },
        statuspage: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).STATUSPAGE,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        },
        support: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).NO_COBRANDING,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        },
        trello: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).TRELLO,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        },
        wac: {
            simpleCobranding: (0, $2eVHl.SimpleCobranding).NO_COBRANDING,
            textColor: 'color.text.subtle',
            textColorMobile: 'color.text.subtle',
            logoVersion: 'neutral',
            logoVersionMobile: 'neutral'
        }
    });
function $0028e260f091dfe7$export$78e3a97ba5b40a8f(applicationData, analyticsClient) {
    $0028e260f091dfe7$var$activeExperimentConfig = undefined;
    const defaultConfig = {
        simpleCobranding: (0, $2eVHl.SimpleCobranding).NO_COBRANDING,
        textColor: 'color.text.subtle',
        textColorMobile: 'color.text.subtle',
        logoVersion: 'neutral',
        logoVersionMobile: 'neutral'
    };
    const config = applicationData ? $0028e260f091dfe7$var$getConfigByApplication()[applicationData.coreApplication] : defaultConfig;
    if (!config) return false;
    if ($0028e260f091dfe7$export$f9aca5f1a2ba36a0(applicationData, analyticsClient)) {
        $0028e260f091dfe7$var$activeExperimentConfig = config;
        return true;
    }
    return false;
}
function $0028e260f091dfe7$export$f9aca5f1a2ba36a0(applicationData, analyticsClient) {
    try {
        const twcg768GateEnabled = (0, $84ZjZ.checkFeatureGate)((0, $cBB3b.AidFrontendFeatureGate).TWCG_786_PRIORITISE_SSO_ON_LOGIN_PAGE_GATE);
        const currentUrl = new URL(window.location.href);
        if (!twcg768GateEnabled || currentUrl.pathname !== '/login' || (0, $hhYxc.isIsolatedCloud)() || (0, $hhYxc.isFedM)()) return false;
        const cohortValue = (0, $g099A.default).getExperimentValue($0028e260f091dfe7$var$TWCG_786_EXPERIMENT_KEY, 'cohort', 'not-enrolled');
        if (analyticsClient && !$0028e260f091dfe7$var$twcg786ExposureEventFired) {
            $0028e260f091dfe7$var$twcg786ExposureEventFired = true;
            analyticsClient.trackingEvent({
                page: 'login-page',
                action: 'exposed',
                subject: $0028e260f091dfe7$var$TWCG_786_EXPERIMENT_KEY,
                attributes: {
                    flagKey: $0028e260f091dfe7$var$TWCG_786_EXPERIMENT_KEY,
                    group: cohortValue,
                    application: applicationData?.coreApplication,
                    experience: applicationData?.experience
                }
            });
        }
        return twcg768GateEnabled && cohortValue === 'variation';
    } catch (error) {
        analyticsClient?.operationalEvent({
            page: 'login-page',
            action: 'failed',
            subject: $0028e260f091dfe7$var$TWCG_786_EXPERIMENT_KEY,
            attributes: {
                flagKey: $0028e260f091dfe7$var$TWCG_786_EXPERIMENT_KEY,
                application: applicationData?.coreApplication,
                experience: applicationData?.experience,
                errorName: error?.name,
                errorStack: error?.stack,
                errorMessage: error?.message,
                errorCode: error?.code
            }
        });
        return false;
    }
}

});
parcelRegister("g099A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba63bf23de62d461$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $htLHv = parcelRequire("htLHv");

var $9ZmSt = parcelRequire("9ZmSt");



var $ba63bf23de62d461$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $ba63bf23de62d461$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$ba63bf23de62d461$var$_FeatureGates = $ba63bf23de62d461$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "client", new (0, $htLHv.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$ba63bf23de62d461$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $ba63bf23de62d461$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $ba63bf23de62d461$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$ba63bf23de62d461$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $ba63bf23de62d461$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $ba63bf23de62d461$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "initializeCalled", $ba63bf23de62d461$var$_FeatureGates.client.initializeCalled.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "initializeCompleted", $ba63bf23de62d461$var$_FeatureGates.client.initializeCompleted.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "initialize", $ba63bf23de62d461$var$_FeatureGates.client.initialize.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "initializeWithProvider", $ba63bf23de62d461$var$_FeatureGates.client.initializeWithProvider.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "initializeFromValues", $ba63bf23de62d461$var$_FeatureGates.client.initializeFromValues.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "manuallyLogGateExposure", $ba63bf23de62d461$var$_FeatureGates.client.manuallyLogGateExposure.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "getExperiment", $ba63bf23de62d461$var$_FeatureGates.client.getExperiment.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "manuallyLogExperimentExposure", $ba63bf23de62d461$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "manuallyLogLayerExposure", $ba63bf23de62d461$var$_FeatureGates.client.manuallyLogLayerExposure.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "shutdownStatsig", $ba63bf23de62d461$var$_FeatureGates.client.shutdownStatsig.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "overrideGate", $ba63bf23de62d461$var$_FeatureGates.client.overrideGate.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "clearGateOverride", $ba63bf23de62d461$var$_FeatureGates.client.clearGateOverride.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "overrideConfig", $ba63bf23de62d461$var$_FeatureGates.client.overrideConfig.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "clearConfigOverride", $ba63bf23de62d461$var$_FeatureGates.client.clearConfigOverride.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "setOverrides", $ba63bf23de62d461$var$_FeatureGates.client.setOverrides.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "getOverrides", $ba63bf23de62d461$var$_FeatureGates.client.getOverrides.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "clearAllOverrides", $ba63bf23de62d461$var$_FeatureGates.client.clearAllOverrides.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "isCurrentUser", $ba63bf23de62d461$var$_FeatureGates.client.isCurrentUser.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "onGateUpdated", $ba63bf23de62d461$var$_FeatureGates.client.onGateUpdated.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "onExperimentValueUpdated", $ba63bf23de62d461$var$_FeatureGates.client.onExperimentValueUpdated.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "onAnyUpdated", $ba63bf23de62d461$var$_FeatureGates.client.onAnyUpdated.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "updateUser", $ba63bf23de62d461$var$_FeatureGates.client.updateUser.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "updateUserWithProvider", $ba63bf23de62d461$var$_FeatureGates.client.updateUserWithProvider.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "updateUserWithValues", $ba63bf23de62d461$var$_FeatureGates.client.updateUserWithValues.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "getPackageVersion", $ba63bf23de62d461$var$_FeatureGates.client.getPackageVersion.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "getLayer", $ba63bf23de62d461$var$_FeatureGates.client.getLayer.bind($ba63bf23de62d461$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($ba63bf23de62d461$var$FeatureGates, "getLayerValue", $ba63bf23de62d461$var$_FeatureGates.client.getLayerValue.bind($ba63bf23de62d461$var$_FeatureGates.client));
var $ba63bf23de62d461$var$boundFGJS = $ba63bf23de62d461$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $ba63bf23de62d461$var$FeatureGates;
    else {
        var $ba63bf23de62d461$var$_boundFGJS, $ba63bf23de62d461$var$_boundFGJS$getPackage;
        $ba63bf23de62d461$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $ba63bf23de62d461$var$boundVersion = (($ba63bf23de62d461$var$_boundFGJS = $ba63bf23de62d461$var$boundFGJS) === null || $ba63bf23de62d461$var$_boundFGJS === void 0 || ($ba63bf23de62d461$var$_boundFGJS$getPackage = $ba63bf23de62d461$var$_boundFGJS.getPackageVersion) === null || $ba63bf23de62d461$var$_boundFGJS$getPackage === void 0 ? void 0 : $ba63bf23de62d461$var$_boundFGJS$getPackage.call($ba63bf23de62d461$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($ba63bf23de62d461$var$boundVersion !== (0, $9ZmSt.CLIENT_VERSION)) {
            var $ba63bf23de62d461$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($ba63bf23de62d461$var$boundVersion, " when module version ").concat((0, $9ZmSt.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($ba63bf23de62d461$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $ba63bf23de62d461$export$2e2bcd8739ae039 = $ba63bf23de62d461$var$boundFGJS;

});
parcelRegister("htLHv", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $cb9a2571c405e6c2$export$1f2bb630327ac4b6; });

var $bM2vx = parcelRequire("bM2vx");

var $82V4i = parcelRequire("82V4i");

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $axdfd = parcelRequire("axdfd");

var $7i2Oo = parcelRequire("7i2Oo");

var $eSkwt = parcelRequire("eSkwt");

var $cWthB = parcelRequire("cWthB");

var $lpnyp = parcelRequire("lpnyp");

var $gRKOT = parcelRequire("gRKOT");

var $ktJnU = parcelRequire("ktJnU");

var $gjFm9 = parcelRequire("gjFm9");

var $3E4f9 = parcelRequire("3E4f9");

var $4JkHe = parcelRequire("4JkHe");

var $j1hPH = parcelRequire("j1hPH");

var $9ZmSt = parcelRequire("9ZmSt");
var $cb9a2571c405e6c2$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $cb9a2571c405e6c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cb9a2571c405e6c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cb9a2571c405e6c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cb9a2571c405e6c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cb9a2571c405e6c2$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $cb9a2571c405e6c2$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $cb9a2571c405e6c2$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $3E4f9.LOCAL_STORAGE_KEY) : _ref$localStorageKey;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "subscriptions", new (0, $eSkwt.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "dataAdapter", new (0, $gjFm9.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = new (0, $3E4f9.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $j1hPH.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $j1hPH.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $j1hPH.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $j1hPH.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $9ZmSt.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $cb9a2571c405e6c2$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $9ZmSt.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $4JkHe.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $j1hPH.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $j1hPH.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $j1hPH.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $ktJnU.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $cWthB.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $cWthB.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $gRKOT.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $j1hPH.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $j1hPH.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $cb9a2571c405e6c2$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $ktJnU.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $ktJnU.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $cb9a2571c405e6c2$var$_objectSpread($cb9a2571c405e6c2$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23, _x24) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $j1hPH.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $cb9a2571c405e6c2$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $cb9a2571c405e6c2$var$_objectSpread($cb9a2571c405e6c2$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $cb9a2571c405e6c2$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $4JkHe.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(newClientOptions, $cb9a2571c405e6c2$var$_excluded);
                                this.sdkKey = sdkKey;
                                this.user = (0, $j1hPH.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
                                statsigOptions = $cb9a2571c405e6c2$var$_objectSpread($cb9a2571c405e6c2$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter
                                });
                                _context9.prev = 12;
                                this.statsigClient = new (0, $7i2Oo.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $7i2Oo.StatsigClient)($cb9a2571c405e6c2$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x25, _x26, _x27) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context11.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 5;
                                    break;
                                }
                                return _context11.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context11.prev = 6;
                                _context11.next = 9;
                                return this.initPromise;
                            case 9:
                                _context11.next = 13;
                                break;
                            case 11:
                                _context11.prev = 11;
                                _context11.t0 = _context11["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x28, _x29, _x30) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context12.prev = 1;
                                _context12.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context12.sent;
                                user = (0, $j1hPH.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
                                _context12.next = 13;
                                break;
                            case 8:
                                _context12.prev = 8;
                                _context12.t0 = _context12["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context12.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context12.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                _context12.next = 20;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 20:
                                _context12.next = 26;
                                break;
                            case 22:
                                _context12.prev = 22;
                                _context12.t1 = _context12["catch"](15);
                                success = false;
                                errorMessage = String(_context12.t1);
                            case 26:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context12.next = 33;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context12.next = 34;
                                break;
                            case 33:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 34:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            22
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x31, _x32, _x33) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $9ZmSt.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $lpnyp.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $lpnyp.Layer).fromLayer((0, $7i2Oo._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("eSkwt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad4607393625fede$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $eMtSV = parcelRequire("eMtSV");
function $ad4607393625fede$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad4607393625fede$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad4607393625fede$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad4607393625fede$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ad4607393625fede$export$a66cbd9b2289cd78 = '@all-features';
var $ad4607393625fede$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "eventToValue", new Map());
        this.emitter = new (0, $eMtSV.EventEmitter2)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $ad4607393625fede$var$_objectSpread($ad4607393625fede$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $ad4607393625fede$var$_objectSpread($ad4607393625fede$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $ad4607393625fede$var$_objectSpread($ad4607393625fede$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $ad4607393625fede$var$_objectSpread($ad4607393625fede$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($ad4607393625fede$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($ad4607393625fede$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($ad4607393625fede$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $ad4607393625fede$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("eMtSV", function(module, exports) {

var $4ilBr = parcelRequire("4ilBr");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $4ilBr !== 'undefined' && $4ilBr.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $4ilBr.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});


parcelRegister("cWthB", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", function () { return $96c19dc476c445df$export$6dc24881a3d96325; });

var $a3ftr = parcelRequire("a3ftr");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $j1hPH = parcelRequire("j1hPH");
var $96c19dc476c445df$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $j1hPH.migrateEvaluationDetails)(experiment.details), (_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures, (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("j1hPH", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $dd8bf1875e8125d7$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $dd8bf1875e8125d7$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $dd8bf1875e8125d7$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $dd8bf1875e8125d7$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $dd8bf1875e8125d7$export$18ad168d3dbac899; });

var $bM2vx = parcelRequire("bM2vx");

var $82V4i = parcelRequire("82V4i");

var $91FVG = parcelRequire("91FVG");

var $7i2Oo = parcelRequire("7i2Oo");

var $eMC8C = parcelRequire("eMC8C");

var $gRKOT = parcelRequire("gRKOT");

var $4JkHe = parcelRequire("4JkHe");
var $dd8bf1875e8125d7$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $dd8bf1875e8125d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd8bf1875e8125d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd8bf1875e8125d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd8bf1875e8125d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dd8bf1875e8125d7$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $dd8bf1875e8125d7$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $eMC8C.isFedRamp)() ? (0, $4JkHe.PerimeterType).FEDRAMP_MODERATE : (0, $4JkHe.PerimeterType).COMMERCIAL
    }, options);
};
var $dd8bf1875e8125d7$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $dd8bf1875e8125d7$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes, sdkKey) {
    var user = {
        customIDs: !(customAttributes !== null && customAttributes !== void 0 && customAttributes.stableID) && sdkKey ? $dd8bf1875e8125d7$var$_objectSpread({
            stableID: (0, $7i2Oo.StableID).get(sdkKey)
        }, identifiers) : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $dd8bf1875e8125d7$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(options, $dd8bf1875e8125d7$var$_excluded);
    return $dd8bf1875e8125d7$var$_objectSpread($dd8bf1875e8125d7$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $dd8bf1875e8125d7$var$evaluationReasonMappings = Object.entries((0, $gRKOT.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $dd8bf1875e8125d7$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $dd8bf1875e8125d7$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $gRKOT.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("eMC8C", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $ac3321cb4d0bd3d7$export$64d6499adf9b2e51; });

var $60mhr = parcelRequire("60mhr");
function $ac3321cb4d0bd3d7$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $60mhr.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("60mhr", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $45f4068c3623ba99$export$ce553301d55c2fd8; });
var $45f4068c3623ba99$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $45f4068c3623ba99$export$f005e2e9f707cb5f = 'commercial';
var $45f4068c3623ba99$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $45f4068c3623ba99$export$a739cd5aac835909 = 'stg';
var $45f4068c3623ba99$export$42dd0cdd351a4a9 = 'prod';
var $45f4068c3623ba99$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("gRKOT", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", function () { return $c475ea0901dd0b39$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $c475ea0901dd0b39$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("4JkHe", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $371b6b3b24a6c750$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $371b6b3b24a6c750$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $371b6b3b24a6c750$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $371b6b3b24a6c750$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $371b6b3b24a6c750$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("lpnyp", function(module, exports) {

$parcel$export(module.exports, "Layer", function () { return $f95e34154848af58$export$936d0764594b6eb3; });

var $a3ftr = parcelRequire("a3ftr");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $j1hPH = parcelRequire("j1hPH");
var $f95e34154848af58$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $j1hPH.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures, (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures, (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("ktJnU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee89b88348471437$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $axdfd = parcelRequire("axdfd");

var $4JkHe = parcelRequire("4JkHe");

var $9ZmSt = parcelRequire("9ZmSt");

var $gPpB6 = parcelRequire("gPpB6");
function $ee89b88348471437$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ee89b88348471437$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ee89b88348471437$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ee89b88348471437$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ee89b88348471437$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $ee89b88348471437$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $ee89b88348471437$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $ee89b88348471437$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $ee89b88348471437$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $ee89b88348471437$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $ee89b88348471437$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $ee89b88348471437$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $gPpB6.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $gPpB6.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $ee89b88348471437$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $4JkHe.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $4JkHe.FeatureGateEnvironment).Production:
                        return $ee89b88348471437$export$18c93900db9358a4;
                    case (0, $4JkHe.FeatureGateEnvironment).Staging:
                        return $ee89b88348471437$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $4JkHe.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $4JkHe.FeatureGateEnvironment).Development:
                        return $ee89b88348471437$export$f058dbf75c3bc647;
                    case (0, $4JkHe.FeatureGateEnvironment).Staging:
                        return $ee89b88348471437$export$942ba04389b0d5a2;
                    default:
                        return $ee89b88348471437$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $ee89b88348471437$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $ee89b88348471437$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $9ZmSt.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();

});
parcelRegister("9ZmSt", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $745b8e9159c51f21$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $745b8e9159c51f21$export$a59f8d67326bd1cb = "4.26.5";

});

parcelRegister("gPpB6", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $c40543e48b41ab5e$export$286baf652d0b1206; });

var $c9XBY = parcelRequire("c9XBY");

var $lPkGR = parcelRequire("lPkGR");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $enV8I = parcelRequire("enV8I");

var $6Vj56 = parcelRequire("6Vj56");
function $c40543e48b41ab5e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $c40543e48b41ab5e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $c40543e48b41ab5e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c40543e48b41ab5e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c40543e48b41ab5e$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ResponseError);
        return $c40543e48b41ab5e$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Vj56)))(Error));

});


parcelRegister("gjFm9", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $be0e802caed97a30$export$55fffef3474104af; });

var $k7uol = parcelRequire("k7uol");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $XdI2U = parcelRequire("XdI2U");

var $enV8I = parcelRequire("enV8I");

var $91FVG = parcelRequire("91FVG");

var $axdfd = parcelRequire("axdfd");

var $7i2Oo = parcelRequire("7i2Oo");
function $be0e802caed97a30$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $be0e802caed97a30$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $be0e802caed97a30$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $be0e802caed97a30$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $be0e802caed97a30$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $be0e802caed97a30$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $be0e802caed97a30$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($be0e802caed97a30$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $be0e802caed97a30$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($XdI2U)))((0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $be0e802caed97a30$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, NoFetchDataAdapter);
        _this = $be0e802caed97a30$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $7i2Oo.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $be0e802caed97a30$var$_objectSpread($be0e802caed97a30$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $7i2Oo._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $be0e802caed97a30$var$_objectSpread($be0e802caed97a30$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $7i2Oo._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $7i2Oo._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $7i2Oo.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $be0e802caed97a30$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $be0e802caed97a30$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $7i2Oo.DataAdapterCore));

});

parcelRegister("3E4f9", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $2a7866263e061228$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $2a7866263e061228$export$bcb28fbac1def494; });

var $91FVG = parcelRequire("91FVG");

var $82V4i = parcelRequire("82V4i");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $5SovT = parcelRequire("5SovT");
function $2a7866263e061228$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a7866263e061228$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a7866263e061228$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a7866263e061228$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2a7866263e061228$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2a7866263e061228$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $2a7866263e061228$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2a7866263e061228$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2a7866263e061228$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2a7866263e061228$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $2a7866263e061228$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $2a7866263e061228$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $2a7866263e061228$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $2a7866263e061228$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $2a7866263e061228$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $2a7866263e061228$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, PersistentOverrideAdapter);
        this._overrides = $2a7866263e061228$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $2a7866263e061228$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $2a7866263e061228$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $2a7866263e061228$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($2a7866263e061228$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($2a7866263e061228$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $2a7866263e061228$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $5SovT._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $2a7866263e061228$var$_objectSpread($2a7866263e061228$var$_objectSpread({}, $2a7866263e061228$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($2a7866263e061228$var$djb2MapKey((0, $5SovT._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($2a7866263e061228$var$djb2MapKey((0, $5SovT._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($2a7866263e061228$var$djb2MapKey((0, $5SovT._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($2a7866263e061228$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $2a7866263e061228$var$_objectSpread($2a7866263e061228$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $2a7866263e061228$var$_objectSpread($2a7866263e061228$var$_objectSpread({}, current.details), {}, {
                        reason: $2a7866263e061228$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($2a7866263e061228$var$djb2MapKey((0, $5SovT._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($2a7866263e061228$var$djb2MapKey((0, $5SovT._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($2a7866263e061228$var$djb2MapKey((0, $5SovT._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($2a7866263e061228$var$djb2MapKey((0, $5SovT._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($2a7866263e061228$var$djb2MapKey((0, $5SovT._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($2a7866263e061228$var$djb2MapKey((0, $5SovT._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $2a7866263e061228$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($2a7866263e061228$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $2a7866263e061228$var$_objectSpread($2a7866263e061228$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $5SovT._makeTypedGet)(current.name, overridden),
                    details: $2a7866263e061228$var$_objectSpread($2a7866263e061228$var$_objectSpread({}, current.details), {}, {
                        reason: $2a7866263e061228$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($2a7866263e061228$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $2a7866263e061228$var$_objectSpread($2a7866263e061228$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $5SovT._makeTypedGet)(current.name, overridden),
                    details: $2a7866263e061228$var$_objectSpread($2a7866263e061228$var$_objectSpread({}, current.details), {}, {
                        reason: $2a7866263e061228$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});




parcelRegister("hQbnq", function(module, exports) {

$parcel$export(module.exports, "checkDirectSignupExperiment", function () { return $3eaa3f4afc2c5a71$export$f3ef85a58e90873f; });

var $emS9l = parcelRequire("emS9l");

var $cBB3b = parcelRequire("cBB3b");
const $3eaa3f4afc2c5a71$export$f3ef85a58e90873f = ({ applicationData: applicationData, analyticsClient: analyticsClient })=>{
    const experimentKey = (0, $cBB3b.AidFrontendExperiment).GHOST_ADVANCED_COBRANDING_DIRECT_SIGNUP;
    try {
        const cohortValue = (0, $emS9l.default).getExperimentValue(experimentKey, 'cohort', 'not-enrolled');
        analyticsClient?.trackingEvent({
            page: 'trello-direct-signup',
            action: 'exposed',
            subject: experimentKey,
            attributes: {
                flagKey: experimentKey,
                group: cohortValue,
                application: applicationData?.coreApplication,
                experience: applicationData?.experience
            }
        });
        return cohortValue === 'variation';
    } catch (error) {
        analyticsClient?.operationalEvent({
            page: 'trello-direct-signup',
            action: 'failed',
            subject: experimentKey,
            attributes: {
                flagKey: experimentKey,
                application: applicationData?.coreApplication,
                experience: applicationData?.experience,
                errorName: error?.name,
                errorStack: error?.stack,
                errorMessage: error?.message,
                errorCode: error?.code
            }
        });
        console.error(`Error checking ${experimentKey}`, error);
        return false;
    }
};

});

parcelRegister("fvS7F", function(module, exports) {

$parcel$export(module.exports, "isDirectSignup", function () { return $76b1868ec0ffc386$export$f3e6a0f51a1476af; });
const $76b1868ec0ffc386$export$f3e6a0f51a1476af = ()=>{
    const continueParam = new URLSearchParams(window.location.search).get('continue');
    if (!continueParam) return true;
    try {
        const inviteURL = new URL(continueParam);
        const returnUrl = inviteURL.searchParams.get('returnUrl');
        return returnUrl !== '/invite/accept-board' && returnUrl !== '/invite/accept-team';
    } catch (error) {
        console.error('Error parsing continue param', error);
        return true;
    }
};

});


parcelRegister("9vljA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eb78b0392e4311f$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $6eb78b0392e4311f$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("02D9g", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $007e8e1487a7cb79$export$a4687b0234b40e28; });

var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");

var $3SI82 = parcelRequire("3SI82");

var $kCbFU = parcelRequire("kCbFU");
function $007e8e1487a7cb79$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $007e8e1487a7cb79$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $007e8e1487a7cb79$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $007e8e1487a7cb79$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $007e8e1487a7cb79$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $3SI82.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $kCbFU.useTrackedRef)(analyticsData);
    var fnRef = (0, $kCbFU.useTrackedRef)(fn);
    var handler = (0, $dNMDr.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $007e8e1487a7cb79$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("3SI82", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $2d38a53faddac19a$export$5bf35293e545f20c; });

var $dmAha = parcelRequire("dmAha");

var $j5gxF = parcelRequire("j5gxF");

var $94DdO = parcelRequire("94DdO");
function $2d38a53faddac19a$export$5bf35293e545f20c() {
    var analyticsContext = (0, $94DdO.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dmAha.useCallbackOne)(function(payload) {
        return new (0, $j5gxF.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("dmAha", function(module, exports) {

$parcel$export(module.exports, "useCallbackOne", function () { return $9ba9780d4dbc134b$export$33752cf3ee811995; });

var $dNMDr = parcelRequire("dNMDr");
function $9ba9780d4dbc134b$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $9ba9780d4dbc134b$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $dNMDr.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $dNMDr.useRef)(true);
    var committed = (0, $dNMDr.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $9ba9780d4dbc134b$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $dNMDr.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $9ba9780d4dbc134b$export$33752cf3ee811995(callback, inputs) {
    return $9ba9780d4dbc134b$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $9ba9780d4dbc134b$export$1538c33de8887b59 = $9ba9780d4dbc134b$export$b6feb8998cd9b342;
var $9ba9780d4dbc134b$export$35808ee640e87ca7 = $9ba9780d4dbc134b$export$33752cf3ee811995;

});

parcelRegister("j5gxF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de4b50dc7b328e33$export$2e2bcd8739ae039; });

var $62ppy = parcelRequire("62ppy");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $icZb3 = parcelRequire("icZb3");

var $4yELe = parcelRequire("4yELe");

var $XdI2U = parcelRequire("XdI2U");

var $enV8I = parcelRequire("enV8I");

var $91FVG = parcelRequire("91FVG");

var $94qtg = parcelRequire("94qtg");
function $de4b50dc7b328e33$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($icZb3)))(t, $de4b50dc7b328e33$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(t).constructor) : o.apply(t, e));
}
function $de4b50dc7b328e33$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($de4b50dc7b328e33$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $de4b50dc7b328e33$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($XdI2U)))((0, (/*@__PURE__*/$parcel$interopDefault($4yELe)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $de4b50dc7b328e33$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $de4b50dc7b328e33$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $de4b50dc7b328e33$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, UIAnalyticsEvent);
        _this = $de4b50dc7b328e33$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($enV8I)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $de4b50dc7b328e33$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $94qtg.default));

});
parcelRegister("94qtg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69a9055f6b2d8356$export$2e2bcd8739ae039; });

var $a3ftr = parcelRequire("a3ftr");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");
function $69a9055f6b2d8356$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $69a9055f6b2d8356$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $69a9055f6b2d8356$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $69a9055f6b2d8356$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $69a9055f6b2d8356$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $69a9055f6b2d8356$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $69a9055f6b2d8356$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $69a9055f6b2d8356$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(updater) === 'object') this.payload = $69a9055f6b2d8356$var$_objectSpread($69a9055f6b2d8356$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("94DdO", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $69b2e9629f3eaf7b$export$d1f587f82ad51c4; });

var $dNMDr = parcelRequire("dNMDr");

var $Os97k = parcelRequire("Os97k");
var $69b2e9629f3eaf7b$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dNMDr.useContext)((0, $Os97k.default));
};

});
parcelRegister("Os97k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $097a80d88771a5ca$export$2e2bcd8739ae039; });

var $4CiPV = parcelRequire("4CiPV");
var $097a80d88771a5ca$export$2e2bcd8739ae039 = (0, $4CiPV.default);

});
parcelRegister("4CiPV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35c9529714e4e544$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");
var $35c9529714e4e544$var$AnalyticsNextContext = (0, $dNMDr.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $35c9529714e4e544$export$2e2bcd8739ae039 = $35c9529714e4e544$var$AnalyticsNextContext;

});




parcelRegister("kCbFU", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $f02069a4c5b17da8$export$1d27a74659855e44; });

var $dNMDr = parcelRequire("dNMDr");
var $f02069a4c5b17da8$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dNMDr.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("kugzw", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $eea376d8582ce351$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("dNMDr");


var $aAhVt = parcelRequire("aAhVt");
var $eea376d8582ce351$var$strictApi = (0, $aAhVt.createStrictAPI)();
var $eea376d8582ce351$export$dbf350e5966cf602 = $eea376d8582ce351$var$strictApi.css;
var $eea376d8582ce351$export$eb1ecd84a24ee424 = $eea376d8582ce351$var$strictApi.cssMap;
$eea376d8582ce351$var$strictApi.cssMap;
var $eea376d8582ce351$export$a274e22fb40f762e = $eea376d8582ce351$var$strictApi.cx;
var $eea376d8582ce351$var$XCSSProp = $eea376d8582ce351$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("aAhVt", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $7b4b2be92cc7ad3c$export$39716b4af53f4ad; });

var $jBe2z = parcelRequire("jBe2z");

var $icVF1 = parcelRequire("icVF1");
function $7b4b2be92cc7ad3c$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $jBe2z.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $jBe2z.createStrictSetupError)();
        },
        cx: $icVF1.cx,
        XCSSProp () {
            throw (0, $jBe2z.createStrictSetupError)();
        }
    };
}

});
parcelRegister("jBe2z", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $e44c5d28c5c13f58$export$c4df1cb0c2b4d77c; });
const $e44c5d28c5c13f58$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $e44c5d28c5c13f58$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("icVF1", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $d4161331f0a2975b$export$a274e22fb40f762e; });

var $affTb = parcelRequire("affTb");
const $d4161331f0a2975b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $affTb.default)(actualStyles);
};

});



parcelRegister("c3KQG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c7a1b0420d938f3$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $8c7a1b0420d938f3$export$2e2bcd8739ae039() {}

});

parcelRegister("dWOVN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a27833080aa6b539$export$2e2bcd8739ae039; });
/* heading.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $hEh1s = parcelRequire("hEh1s");

var $bB3G7 = parcelRequire("bB3G7");

var $4KFuL = parcelRequire("4KFuL");

var $4ilBr = parcelRequire("4ilBr");
var $a27833080aa6b539$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $a27833080aa6b539$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $a27833080aa6b539$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $a27833080aa6b539$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var $a27833080aa6b539$var$useColor = function useColor(colorProp) {
    var surface = (0, $bB3G7.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $hEh1s.inverseColorMap).hasOwnProperty(surface)) return (0, $hEh1s.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $a27833080aa6b539$var$Heading = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $4ilBr;
    var _useHeading = (0, $4KFuL.useHeading)($a27833080aa6b539$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $a27833080aa6b539$var$useColor(colorProp);
    return /*#__PURE__*/ $dNMDr.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $affTb.default)([
            $a27833080aa6b539$var$styles.reset,
            $a27833080aa6b539$var$headingSizeStyles[size],
            $a27833080aa6b539$var$headingColorStyles[color]
        ])
    }, children);
});
var $a27833080aa6b539$export$2e2bcd8739ae039 = $a27833080aa6b539$var$Heading;

});
parcelRegister("hEh1s", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $cd93606f636678bb$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $cd93606f636678bb$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $cd93606f636678bb$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $cd93606f636678bb$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $cd93606f636678bb$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $cd93606f636678bb$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $cd93606f636678bb$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $cd93606f636678bb$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $cd93606f636678bb$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $cd93606f636678bb$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $cd93606f636678bb$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $cd93606f636678bb$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $cd93606f636678bb$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $cd93606f636678bb$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $cd93606f636678bb$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $cd93606f636678bb$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $cd93606f636678bb$export$e7af83bafe7f9e63; });

var $91FVG = parcelRequire("91FVG");

var $8Govx = parcelRequire("8Govx");

var $a7eRo = parcelRequire("a7eRo");
function $cd93606f636678bb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd93606f636678bb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd93606f636678bb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd93606f636678bb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cd93606f636678bb$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $cd93606f636678bb$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $cd93606f636678bb$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $cd93606f636678bb$export$632685d741f3dbbf = $cd93606f636678bb$var$_objectSpread($cd93606f636678bb$var$_objectSpread({}, $cd93606f636678bb$export$958d0ae7f2977ae4), $cd93606f636678bb$export$d2dc61f58390201c);
var $cd93606f636678bb$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $cd93606f636678bb$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $cd93606f636678bb$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $cd93606f636678bb$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $cd93606f636678bb$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $cd93606f636678bb$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $cd93606f636678bb$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $cd93606f636678bb$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $cd93606f636678bb$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $cd93606f636678bb$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $cd93606f636678bb$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $cd93606f636678bb$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // @deprecated
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $cd93606f636678bb$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $cd93606f636678bb$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $cd93606f636678bb$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $cd93606f636678bb$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $cd93606f636678bb$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $cd93606f636678bb$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $cd93606f636678bb$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $8Govx.css)((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $cd93606f636678bb$export$e615f061ca585a6c = $cd93606f636678bb$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $cd93606f636678bb$export$ca0f9c2de39ffed7(spacingProperty, $cd93606f636678bb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $cd93606f636678bb$export$bf46c3f9eeafc71f = $cd93606f636678bb$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $cd93606f636678bb$export$ca0f9c2de39ffed7(spacingProperty, $cd93606f636678bb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $cd93606f636678bb$export$e7af83bafe7f9e63 = $cd93606f636678bb$export$ca0f9c2de39ffed7('backgroundColor', $cd93606f636678bb$export$d1d79bf68ac056bd);
var $cd93606f636678bb$export$3a1bcba60b23d7f0 = $cd93606f636678bb$export$ca0f9c2de39ffed7('color', $cd93606f636678bb$export$8473307aa00d6ea1);
var $cd93606f636678bb$export$45f3f4fe16f9f7d5 = $cd93606f636678bb$export$ca0f9c2de39ffed7('fontWeight', $cd93606f636678bb$export$303e322c6b1ed114);
var $cd93606f636678bb$export$68cc305da27dbaa4 = $cd93606f636678bb$export$ca0f9c2de39ffed7('fontFamily', $cd93606f636678bb$export$3c7e9587132614b4);
var $cd93606f636678bb$export$128f10c238242f83 = $cd93606f636678bb$export$ca0f9c2de39ffed7('font', $cd93606f636678bb$export$6ffa317d5e70375);
var $cd93606f636678bb$export$219d364c0da35ae4 = $cd93606f636678bb$export$ca0f9c2de39ffed7('font', $cd93606f636678bb$export$236bfe3a33ef1292);
var $cd93606f636678bb$export$38845ca010b93505 = $cd93606f636678bb$export$ca0f9c2de39ffed7('fontWeight', $cd93606f636678bb$export$855cfd311192d666);
var $cd93606f636678bb$export$ff257d957d48c421 = $cd93606f636678bb$export$ca0f9c2de39ffed7((0, $a7eRo.CURRENT_SURFACE_CSS_VAR), $cd93606f636678bb$export$41a358c9c2356760);
var $cd93606f636678bb$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $cd93606f636678bb$export$41a358c9c2356760[color] !== undefined;
};
var $cd93606f636678bb$export$7001ce64d9ff7c7f = $cd93606f636678bb$export$ca0f9c2de39ffed7('font', $cd93606f636678bb$export$b805719bc8cb376);

});

parcelRegister("bB3G7", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $871600de288c039c$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $871600de288c039c$export$1aeb4f6b93c4540d; });

var $dNMDr = parcelRequire("dNMDr");
var $871600de288c039c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dNMDr.createContext)('elevation.surface');
var $871600de288c039c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dNMDr.useContext)($871600de288c039c$export$1ca2a26fecb070ae);
};
$871600de288c039c$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("4KFuL", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $375ba56000bf63e4$export$97a37b1befbbf9b1; });

var $dNMDr = parcelRequire("dNMDr");
// Allows support for heading levels 1-9 via aria-level
var $375ba56000bf63e4$var$HeadingLevelContext = /*#__PURE__*/ (0, $dNMDr.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $375ba56000bf63e4$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $dNMDr.useContext)($375ba56000bf63e4$var$HeadingLevelContext);
};
var $375ba56000bf63e4$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $375ba56000bf63e4$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $375ba56000bf63e4$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $375ba56000bf63e4$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($375ba56000bf63e4$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $375ba56000bf63e4$export$2e2bcd8739ae039 = $375ba56000bf63e4$var$HeadingLevelContextProvider;

});


parcelRegister("l69Tm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5c1d4d62b4f6416$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $bB3G7 = parcelRequire("bB3G7");
var $f5c1d4d62b4f6416$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $f5c1d4d62b4f6416$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $f5c1d4d62b4f6416$var$baseStyles = null;
var $f5c1d4d62b4f6416$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $f5c1d4d62b4f6416$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $f5c1d4d62b4f6416$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $f5c1d4d62b4f6416$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $f5c1d4d62b4f6416$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $f5c1d4d62b4f6416$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $f5c1d4d62b4f6416$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $f5c1d4d62b4f6416$var$Box = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $f5c1d4d62b4f6416$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(htmlAttributes, $f5c1d4d62b4f6416$var$_excluded2);
    var node = /*#__PURE__*/ $dNMDr.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        style: style,
        ref: ref,
        className: (0, $affTb.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $f5c1d4d62b4f6416$var$backgroundColorMap[backgroundColor],
            backgroundColor && $f5c1d4d62b4f6416$var$isSurfaceToken(backgroundColor) && $f5c1d4d62b4f6416$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $f5c1d4d62b4f6416$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $f5c1d4d62b4f6416$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $f5c1d4d62b4f6416$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $f5c1d4d62b4f6416$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $dNMDr.createElement((0, $bB3G7.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $f5c1d4d62b4f6416$export$2e2bcd8739ae039 = $f5c1d4d62b4f6416$var$Box;
function $f5c1d4d62b4f6416$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $f5c1d4d62b4f6416$var$setSurfaceTokenMap;
}

});

parcelRegister("eS3uG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad38d1a257357b65$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $kugzw = parcelRequire("kugzw");

var $1EqrL = parcelRequire("1EqrL");
var $ad38d1a257357b65$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $ad38d1a257357b65$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $ad38d1a257357b65$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        className: (0, $affTb.default)([
            $ad38d1a257357b65$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $ad38d1a257357b65$var$Inline = /*#__PURE__*/ (0, $dNMDr.memo)(/*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref2, $ad38d1a257357b65$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $dNMDr.createElement($ad38d1a257357b65$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $dNMDr.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $dNMDr.createElement((0, $dNMDr.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $dNMDr.createElement((0, $1EqrL.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $kugzw.cx)(grow === 'hug' && $ad38d1a257357b65$var$styles.hug, grow === 'fill' && $ad38d1a257357b65$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$ad38d1a257357b65$var$Inline.displayName = 'Inline';
var $ad38d1a257357b65$export$2e2bcd8739ae039 = $ad38d1a257357b65$var$Inline;

});
parcelRegister("1EqrL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $133e0aa92307c779$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
var $133e0aa92307c779$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $133e0aa92307c779$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $133e0aa92307c779$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $133e0aa92307c779$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $133e0aa92307c779$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $133e0aa92307c779$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $133e0aa92307c779$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $133e0aa92307c779$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $133e0aa92307c779$var$Flex = /*#__PURE__*/ (0, $dNMDr.memo)(/*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $133e0aa92307c779$var$_excluded);
    return /*#__PURE__*/ $dNMDr.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, ariaAttributes, {
        role: role,
        className: (0, $affTb.default)([
            $133e0aa92307c779$var$styles.root,
            gap && $133e0aa92307c779$var$columnGapMap[gap],
            columnGap && $133e0aa92307c779$var$columnGapMap[columnGap],
            gap && $133e0aa92307c779$var$rowGapMap[gap],
            rowGap && $133e0aa92307c779$var$rowGapMap[rowGap],
            alignItems && $133e0aa92307c779$var$alignItemsMap[alignItems],
            direction && $133e0aa92307c779$var$flexDirectionMap[direction],
            justifyContent && $133e0aa92307c779$var$justifyContentMap[justifyContent],
            wrap && $133e0aa92307c779$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$133e0aa92307c779$var$Flex.displayName = 'Flex';
var $133e0aa92307c779$export$2e2bcd8739ae039 = $133e0aa92307c779$var$Flex;

});


parcelRegister("3FKQn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ac989a5f5b35555$export$2e2bcd8739ae039; });
/* stack.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");


var $kugzw = parcelRequire("kugzw");

var $1EqrL = parcelRequire("1EqrL");
var $2ac989a5f5b35555$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $2ac989a5f5b35555$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $2ac989a5f5b35555$var$Stack = /*#__PURE__*/ (0, $dNMDr.memo)(/*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $2ac989a5f5b35555$var$_excluded);
    return /*#__PURE__*/ $dNMDr.createElement((0, $1EqrL.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $kugzw.cx)(grow === 'hug' && $2ac989a5f5b35555$var$styles.hug, grow === 'fill' && $2ac989a5f5b35555$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$2ac989a5f5b35555$var$Stack.displayName = 'Stack';
var $2ac989a5f5b35555$export$2e2bcd8739ae039 = $2ac989a5f5b35555$var$Stack;

});

parcelRegister("iRhvt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbaac1b54874bafc$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
var $dbaac1b54874bafc$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $dbaac1b54874bafc$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $affTb.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$dbaac1b54874bafc$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $dbaac1b54874bafc$export$2e2bcd8739ae039 = $dbaac1b54874bafc$var$VisuallyHidden;

});

parcelRegister("5v6LX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("eoNpW")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("eoNpW")).Icon; });

var $eoNpW = parcelRequire("eoNpW");

});
parcelRegister("eoNpW", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $a7b9a3d5e2a7a337$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $a7b9a3d5e2a7a337$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $a7b9a3d5e2a7a337$var$svgStyles = null;
var $a7b9a3d5e2a7a337$var$iconStyles = null;
var $a7b9a3d5e2a7a337$var$smallIconStyles = null;
var $a7b9a3d5e2a7a337$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $a7b9a3d5e2a7a337$var$baseHcmStyles = null;
var $a7b9a3d5e2a7a337$var$scaleSize = null;
var $a7b9a3d5e2a7a337$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $a7b9a3d5e2a7a337$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $a7b9a3d5e2a7a337$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $a7b9a3d5e2a7a337$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dNMDr.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $a7b9a3d5e2a7a337$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $affTb.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $dNMDr.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $affTb.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $a7b9a3d5e2a7a337$var$coreSizeSmall[spacing] : $a7b9a3d5e2a7a337$var$coreSizeMedium[spacing]
        ])
    }));
});
var $a7b9a3d5e2a7a337$export$2e2bcd8739ae039 = $a7b9a3d5e2a7a337$export$f04a61298a47a40f;

});


parcelRegister("grvIM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf87c6239657ad4b$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $bf87c6239657ad4b$var$ATOMIC_GROUP_LENGTH = 5;
function $bf87c6239657ad4b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $bf87c6239657ad4b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("3VzmS", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $2dc22151ea16407d$export$4ef52930e33717cd; });
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", function () { return $2dc22151ea16407d$export$cb374d25ded7f6ab; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $2dc22151ea16407d$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $2dc22151ea16407d$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $2dc22151ea16407d$export$352e418ed5b6193a; });
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", function () { return $2dc22151ea16407d$export$dddac1532e822863; });
var $2dc22151ea16407d$export$4ef52930e33717cd = 'data-theme';
var $2dc22151ea16407d$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $2dc22151ea16407d$export$a00eac3f8684bcd0 = 'data-color-mode';
var $2dc22151ea16407d$export$2112803007239c61 = 'data-contrast-mode';
var $2dc22151ea16407d$export$352e418ed5b6193a = 'data-custom-theme';
var $2dc22151ea16407d$export$6f0c6fb8c80fcc92 = 'ds';
var $2dc22151ea16407d$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $2dc22151ea16407d$export$dddac1532e822863 = "--".concat($2dc22151ea16407d$export$6f0c6fb8c80fcc92, "-token-not-found");
var $2dc22151ea16407d$export$9d7b58831ae93caa = "--".concat($2dc22151ea16407d$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("29xYv", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $1916c6be30560aad$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $1916c6be30560aad$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $1916c6be30560aad$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $1916c6be30560aad$export$2e2bcd8739ae039; });

var $gQLDR = parcelRequire("gQLDR");
var $1916c6be30560aad$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $1916c6be30560aad$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $1916c6be30560aad$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $1916c6be30560aad$var$themeOverrideIds = [];
var $1916c6be30560aad$export$92ba366331403db2 = [].concat($1916c6be30560aad$export$7d43e72a58e3283f, $1916c6be30560aad$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $1916c6be30560aad$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    }
};
var $1916c6be30560aad$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: function shape() {
        if ((0, $gQLDR.fg)('platform-dst-shape-theme-default')) return 'shape';
        return undefined;
    },
    spacing: 'spacing',
    typography: 'typography',
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $1916c6be30560aad$export$2e2bcd8739ae039 = $1916c6be30560aad$var$themeConfig;

});

parcelRegister("ypmSI", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $0676daa884153777$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $0676daa884153777$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $0676daa884153777$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $0676daa884153777$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $0676daa884153777$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $0676daa884153777$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $0676daa884153777$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $0676daa884153777$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $0676daa884153777$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $0676daa884153777$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $0676daa884153777$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $0676daa884153777$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $0676daa884153777$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $0676daa884153777$export$b36dbdb4f463f05c(hex) {
    if (!$0676daa884153777$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $0676daa884153777$export$1212645cf40ebf71(hex)
    ];
}
function $0676daa884153777$export$5a544e13ad4e1fa5(hex) {
    if (!$0676daa884153777$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $0676daa884153777$export$47ea145a83f50dc0(hex) {
    if (!$0676daa884153777$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $0676daa884153777$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $0676daa884153777$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $0676daa884153777$export$d061e26956a60b0a(foreground, background) {
    if (!$0676daa884153777$var$isValidHex(foreground) || !$0676daa884153777$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $0676daa884153777$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $0676daa884153777$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $0676daa884153777$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $0676daa884153777$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $0676daa884153777$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $0676daa884153777$var$rgbToLab(rgbA);
    var labB = $0676daa884153777$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $0676daa884153777$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("1id0X", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $0f119141fcaab173$export$d6af199866bfb566; });
var $0f119141fcaab173$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("4awVG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3091a3ad02eddf77$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");

var $gQLDR = parcelRequire("gQLDR");

var $clwPg = parcelRequire("clwPg");

var $29xYv = parcelRequire("29xYv");

var $ypmSI = parcelRequire("ypmSI");

var $5AWHz = parcelRequire("5AWHz");

var $7Au4J = parcelRequire("7Au4J");

var $eTwRm = parcelRequire("eTwRm");

var $aqFBm = parcelRequire("aqFBm");
function $3091a3ad02eddf77$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $3091a3ad02eddf77$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $3091a3ad02eddf77$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3091a3ad02eddf77$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3091a3ad02eddf77$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3091a3ad02eddf77$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3091a3ad02eddf77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3091a3ad02eddf77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3091a3ad02eddf77$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3091a3ad02eddf77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $3091a3ad02eddf77$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($3091a3ad02eddf77$var$_objectSpread($3091a3ad02eddf77$var$_objectSpread({}, (0, $29xYv.themeStateDefaults)), {}, {
                        typography: (0, $29xYv.themeStateDefaults)['typography'],
                        shape: (0, $29xYv.themeStateDefaults)['shape']()
                    }, (0, $clwPg.default)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $29xYv.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $29xYv.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $29xYv.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $29xYv.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $29xYv.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $29xYv.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $29xYv.themeStateDefaults)['typography'] : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $29xYv.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $gQLDR.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $eTwRm.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $aqFBm.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $ypmSI.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $29xYv.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $7Au4J.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("6IYYz"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 11;
                    return Promise.all(loadingTasks);
                case 11:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $eTwRm.getThemeOverridePreferences)(themeState);
                    _iterator = $3091a3ad02eddf77$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 13;
                    _iterator.s();
                case 15:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 21;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 19;
                    return loadingStrategy(themeId);
                case 19:
                    _context3.next = 15;
                    break;
                case 21:
                    _context3.next = 26;
                    break;
                case 23:
                    _context3.prev = 23;
                    _context3.t0 = _context3["catch"](13);
                    _iterator.e(_context3.t0);
                case 26:
                    _context3.prev = 26;
                    _iterator.f();
                    return _context3.finish(26);
                case 29:
                    autoUnbind = (0, $5AWHz.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 31:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                13,
                23,
                26,
                29
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $3091a3ad02eddf77$export$2e2bcd8739ae039 = $3091a3ad02eddf77$var$setGlobalTheme;

});
parcelRegister("clwPg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fd0e8c091f2aaff$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $3VzmS = parcelRequire("3VzmS");

var $29xYv = parcelRequire("29xYv");

var $22JeC = parcelRequire("22JeC");
function $8fd0e8c091f2aaff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8fd0e8c091f2aaff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8fd0e8c091f2aaff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8fd0e8c091f2aaff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8fd0e8c091f2aaff$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $29xYv.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $8fd0e8c091f2aaff$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $3VzmS.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $3VzmS.THEME_DATA_ATTRIBUTE)) || '';
    return $8fd0e8c091f2aaff$var$_objectSpread($8fd0e8c091f2aaff$var$_objectSpread({}, (0, $22JeC.themeStringToObject)(theme)), $8fd0e8c091f2aaff$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $8fd0e8c091f2aaff$export$2e2bcd8739ae039 = $8fd0e8c091f2aaff$var$getGlobalTheme;

});
parcelRegister("22JeC", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $17cedb60d589c339$export$f19b488f7c0547ee; });
$parcel$export(module.exports, "themeObjectToString", function () { return $17cedb60d589c339$export$62c37ab81302621a; });

var $a3ftr = parcelRequire("a3ftr");

var $82V4i = parcelRequire("82V4i");

var $29xYv = parcelRequire("29xYv");
var $17cedb60d589c339$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $17cedb60d589c339$var$customThemeOptions = 'UNSAFE_themeOptions';
var $17cedb60d589c339$var$isThemeKind = function isThemeKind(themeKind) {
    return $17cedb60d589c339$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $17cedb60d589c339$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $29xYv.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $17cedb60d589c339$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $17cedb60d589c339$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $17cedb60d589c339$var$isColorMode(id)) themeObject[kind] = id;
        if ($17cedb60d589c339$var$isThemeKind(kind) && $17cedb60d589c339$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $17cedb60d589c339$var$customThemeOptions) try {
            themeObject[$17cedb60d589c339$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $17cedb60d589c339$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $17cedb60d589c339$var$isColorMode(id) || // custom theme state
        kind === $17cedb60d589c339$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(id) === 'object' || // other theme states
        $17cedb60d589c339$var$isThemeKind(kind) && typeof id === 'string' && $17cedb60d589c339$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});


parcelRegister("5AWHz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $010d2069559e41b9$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $gQLDR = parcelRequire("gQLDR");

var $eLta5 = parcelRequire("eLta5");

var $20Ywg = parcelRequire("20Ywg");

var $cp3DE = parcelRequire("cp3DE");
function $010d2069559e41b9$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $20Ywg.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $20Ywg.default).bind();
    } else (0, $20Ywg.default).unbind();
    if ((0, $gQLDR.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $cp3DE.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $cp3DE.default).bind();
        } else (0, $cp3DE.default).unbind();
    }
    var themeAttributes = (0, $eLta5.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $20Ywg.default).unbind();
        if ((0, $gQLDR.fg)('platform_increased-contrast-themes')) (0, $cp3DE.default).unbind();
    };
}

});
parcelRegister("eLta5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abfc136287f68450$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $gQLDR = parcelRequire("gQLDR");

var $3VzmS = parcelRequire("3VzmS");

var $29xYv = parcelRequire("29xYv");

var $22JeC = parcelRequire("22JeC");

var $ypmSI = parcelRequire("ypmSI");

var $1id0X = parcelRequire("1id0X");
function $abfc136287f68450$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $abfc136287f68450$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $abfc136287f68450$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $abfc136287f68450$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $abfc136287f68450$var$defaultColorMode = 'light';
var $abfc136287f68450$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $abfc136287f68450$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $29xYv.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $29xYv.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $29xYv.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $29xYv.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $29xYv.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $29xYv.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $29xYv.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $29xYv.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $22JeC.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $3VzmS.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $3VzmS.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $abfc136287f68450$var$defaultColorMode : colorMode);
    if ((0, $gQLDR.fg)('platform_increased-contrast-themes')) result = $abfc136287f68450$var$_objectSpread($abfc136287f68450$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $3VzmS.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $abfc136287f68450$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $ypmSI.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $1id0X.hash)(optionString);
        result[0, $3VzmS.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $abfc136287f68450$export$2e2bcd8739ae039 = $abfc136287f68450$var$getThemeHtmlAttrs;

});

parcelRegister("20Ywg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $177a86bea50eafb5$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $40QgJ = parcelRequire("40QgJ");

var $3VzmS = parcelRequire("3VzmS");

var $aqFBm = parcelRequire("aqFBm");
var $177a86bea50eafb5$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $177a86bea50eafb5$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $3VzmS.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $177a86bea50eafb5$var$darkModeMql = $177a86bea50eafb5$var$isMatchMediaAvailable && window.matchMedia((0, $aqFBm.darkModeMediaQuery));
var $177a86bea50eafb5$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$177a86bea50eafb5$var$darkModeMql) return 'light';
                return $177a86bea50eafb5$var$darkModeMql !== null && $177a86bea50eafb5$var$darkModeMql !== void 0 && $177a86bea50eafb5$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($177a86bea50eafb5$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $40QgJ.bind)($177a86bea50eafb5$var$darkModeMql, {
                    type: 'change',
                    listener: $177a86bea50eafb5$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $177a86bea50eafb5$var$SingletonColorModeObserver = new $177a86bea50eafb5$var$ColorModeObserver();
var $177a86bea50eafb5$export$2e2bcd8739ae039 = $177a86bea50eafb5$var$SingletonColorModeObserver;

});
parcelRegister("aqFBm", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $797c9a4f88b17d6f$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $797c9a4f88b17d6f$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $797c9a4f88b17d6f$export$8662df6937d86fcb; });

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");

var $bMW75 = parcelRequire("bMW75");

var $3VzmS = parcelRequire("3VzmS");
var $797c9a4f88b17d6f$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $3VzmS.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $3VzmS.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $797c9a4f88b17d6f$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $797c9a4f88b17d6f$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $bMW75.default)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $797c9a4f88b17d6f$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $797c9a4f88b17d6f$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("bMW75", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89514180e6008a82$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::926662cc712c2c412c8b6b4cdcd8d64f>>
 * @codegenCommand yarn build tokens
 */ 










var $89514180e6008a82$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("69C93"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("jPcfp"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("1XYft"));
    },
    'dark': function dark() {
        return (parcelRequire("6VlpJ"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("kLiGA"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("jJozG"));
    },
    'legacy-light': function legacyLight() {
        return (parcelRequire("kwewn"));
    },
    'legacy-dark': function legacyDark() {
        return (parcelRequire("haKix"));
    },
    'spacing': function spacing() {
        return (parcelRequire("bjGds"));
    },
    'typography': function typography() {
        return (parcelRequire("hoo1o"));
    },
    'shape': function shape() {
        return (parcelRequire("97wj1"));
    }
};
var $89514180e6008a82$export$2e2bcd8739ae039 = $89514180e6008a82$var$themeImportsMap;

});
parcelRegister("69C93", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("93SJv")).then(()=>parcelRequire('fxlam'));

});

parcelRegister("jPcfp", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("4nn3b")).then(()=>parcelRequire('i2zEh'));

});

parcelRegister("1XYft", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("fTWq6")).then(()=>parcelRequire('9PpXc'));

});

parcelRegister("6VlpJ", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("fIUtI")).then(()=>parcelRequire('4dQ7y'));

});

parcelRegister("kLiGA", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("63e8g")).then(()=>parcelRequire('jRpBo'));

});

parcelRegister("jJozG", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("ivfVh")).then(()=>parcelRequire('3NYHJ'));

});

parcelRegister("kwewn", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("l1Arw")).then(()=>parcelRequire('i9mPH'));

});

parcelRegister("haKix", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("glsfC")).then(()=>parcelRequire('1ovWJ'));

});

parcelRegister("bjGds", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("4EyWU")).then(()=>parcelRequire('cf1ba'));

});

parcelRegister("hoo1o", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("57cME")).then(()=>parcelRequire('i5jLB'));

});

parcelRegister("97wj1", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("l4Jcr")).then(()=>parcelRequire('5Svtr'));

});




parcelRegister("cp3DE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $907aa463c23b9417$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $40QgJ = parcelRequire("40QgJ");

var $3VzmS = parcelRequire("3VzmS");

var $aqFBm = parcelRequire("aqFBm");
var $907aa463c23b9417$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $907aa463c23b9417$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $3VzmS.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $907aa463c23b9417$var$contrastModeMql = $907aa463c23b9417$var$isMatchMediaAvailable && window.matchMedia((0, $aqFBm.moreContrastMediaQuery));
var $907aa463c23b9417$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$907aa463c23b9417$var$contrastModeMql) return 'no-preference';
                return $907aa463c23b9417$var$contrastModeMql !== null && $907aa463c23b9417$var$contrastModeMql !== void 0 && $907aa463c23b9417$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($907aa463c23b9417$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $40QgJ.bind)($907aa463c23b9417$var$contrastModeMql, {
                    type: 'change',
                    listener: $907aa463c23b9417$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $907aa463c23b9417$var$SingletonContrastModeObserver = new $907aa463c23b9417$var$ContrastModeObserver();
var $907aa463c23b9417$export$2e2bcd8739ae039 = $907aa463c23b9417$var$SingletonContrastModeObserver;

});


parcelRegister("7Au4J", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $5863398ac2e1e6d0$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $5863398ac2e1e6d0$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $5863398ac2e1e6d0$export$e673f367da2ff23e; });

var $82V4i = parcelRequire("82V4i");

var $62ppy = parcelRequire("62ppy");

var $7ckH8 = parcelRequire("7ckH8");

var $3VzmS = parcelRequire("3VzmS");

var $1id0X = parcelRequire("1id0X");
function $5863398ac2e1e6d0$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $1id0X.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $3VzmS.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $3VzmS.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $5863398ac2e1e6d0$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(Array.from(document.head.querySelectorAll("style[".concat((0, $3VzmS.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $3VzmS.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $5863398ac2e1e6d0$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $7ckH8.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("7ckH8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53d9b4e8da658cad$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71ab6af4453c6807be4d4249ca7614bc>>
 * @codegenCommand yarn build tokens
 */ var $53d9b4e8da658cad$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $53d9b4e8da658cad$export$2e2bcd8739ae039 = $53d9b4e8da658cad$var$tokens;

});


parcelRegister("eTwRm", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", function () { return $ad7fb0f6f64329b7$export$dd6aeb7c823fc03d; });
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $ad7fb0f6f64329b7$export$5d76d7014f4a5d08; });

var $62ppy = parcelRequire("62ppy");

var $gQLDR = parcelRequire("gQLDR");

var $dsMEd = parcelRequire("dsMEd");
var $ad7fb0f6f64329b7$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $gQLDR.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $dsMEd.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $gQLDR.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $dsMEd.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(new Set(themePreferences));
};
var $ad7fb0f6f64329b7$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(new Set(themeOverridePreferences));
};

});
parcelRegister("dsMEd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cd3a051960d9c7d$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $29xYv = parcelRequire("29xYv");
function $9cd3a051960d9c7d$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $29xYv.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});


parcelRegister("6IYYz", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("7DL2I")).then(()=>parcelRequire('iiLax'));

});


parcelRegister("dpTxl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c48b0985f4a7d21$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $gTgRL = parcelRequire("gTgRL");

var $1f6ly = parcelRequire("1f6ly");

var $iRhvt = parcelRequire("iRhvt");

var $dqFFZ = parcelRequire("dqFFZ");

var $cb5Ng = parcelRequire("cb5Ng");

var $hK1dY = parcelRequire("hK1dY");
var $9c48b0985f4a7d21$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $9c48b0985f4a7d21$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $9c48b0985f4a7d21$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $9c48b0985f4a7d21$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(unsafeRest, $9c48b0985f4a7d21$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dqFFZ.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $cb5Ng.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $hK1dY.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $iRhvt.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1f6ly.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dqFFZ.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $gTgRL.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $cb5Ng.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $hK1dY.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $iRhvt.default), null, label)));
    });
}));
$9c48b0985f4a7d21$var$IconButton.displayName = 'IconButton';
var $9c48b0985f4a7d21$export$2e2bcd8739ae039 = $9c48b0985f4a7d21$var$IconButton;

});
parcelRegister("gTgRL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4bedda8471b803b$export$2e2bcd8739ae039; });

var $a3ftr = parcelRequire("a3ftr");
function $c4bedda8471b803b$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(ref) === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("1f6ly", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e7c1d7817f98110$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $82V4i = parcelRequire("82V4i");

var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");

var $40QgJ = parcelRequire("40QgJ");

var $4VUbn = parcelRequire("4VUbn");

var $c3KQG = parcelRequire("c3KQG");

var $ge9M2 = parcelRequire("ge9M2");

var $k3Tbu = parcelRequire("k3Tbu");

var $Xcbzo = parcelRequire("Xcbzo");

var $bnv12 = parcelRequire("bnv12");
var $5fkkM = parcelRequire("5fkkM");

var $gQLDR = parcelRequire("gQLDR");

var $ePfkq = parcelRequire("ePfkq");

var $1w48L = parcelRequire("1w48L");

var $gWqO2 = parcelRequire("gWqO2");

var $9192t = parcelRequire("9192t");

var $e0BD0 = parcelRequire("e0BD0");

var $fOgZ3 = parcelRequire("fOgZ3");

var $k66AC = parcelRequire("k66AC");

var $j46FI = parcelRequire("j46FI");
function $0e7c1d7817f98110$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e7c1d7817f98110$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e7c1d7817f98110$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e7c1d7817f98110$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0e7c1d7817f98110$var$tooltipZIndex = (0, $gWqO2.layers).tooltip();
var $0e7c1d7817f98110$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.14.5"
};
// Inverts motion direction
var $0e7c1d7817f98110$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $0e7c1d7817f98110$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $0e7c1d7817f98110$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $k66AC.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $c3KQG.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $c3KQG.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $4VUbn.usePlatformLeafSyntheticEventHandler)($0e7c1d7817f98110$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $0e7c1d7817f98110$var$analyticsAttributes));
    var onHideHandler = (0, $4VUbn.usePlatformLeafSyntheticEventHandler)($0e7c1d7817f98110$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $0e7c1d7817f98110$var$analyticsAttributes));
    var apiRef = (0, $dNMDr.useRef)(null);
    var _useState = (0, $dNMDr.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $dNMDr.useRef)(null);
    var containerRef = (0, $dNMDr.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $dNMDr.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $k3Tbu.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $k3Tbu.default)(onShowHandler);
    var onHideHandlerStable = (0, $k3Tbu.default)(onHideHandler);
    var delayStable = (0, $k3Tbu.default)(delay);
    var canAppearStable = (0, $k3Tbu.default)(canAppear);
    var hasCalledShowHandler = (0, $dNMDr.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $k3Tbu.default)(shouldAlwaysFadeIn);
    var start = (0, $dNMDr.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $dNMDr.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $dNMDr.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $dNMDr.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $dNMDr.useRef)(false);
    (0, $dNMDr.useEffect)(function() {
        return (0, $9192t.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $dNMDr.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: (0, $gQLDR.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? shouldAlwaysFadeInStable.current : false
        };
        var api = (0, $e0BD0.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $dNMDr.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $ge9M2.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $dNMDr.useEffect)(function() {
        if (state === 'hide') return 0, $c3KQG.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $40QgJ.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $dNMDr.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $dNMDr.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $dNMDr.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            // Removing old `mouse` behind gate because it stored a function.
            // With the gate we just store the coords which are easier to work with.
            mouse: (0, $gQLDR.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : (0, $j46FI.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            }),
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $dNMDr.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) {
            if (!(0, $gQLDR.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) apiRef.current.mousePosition = (0, $j46FI.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            });
            apiRef.current.mousePos = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    } : undefined;
    var onMouseOverTooltip = (0, $dNMDr.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $dNMDr.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $dNMDr.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $dNMDr.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $dNMDr.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $Xcbzo.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5, _apiRef$current6;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current && (0, $gQLDR.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) return (0, $j46FI.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePosition && !(0, $gQLDR.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) {
            var _apiRef$current7;
            return (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $fOgZ3.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $dNMDr.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent && (0, $gQLDR.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? (0, $dNMDr.Fragment) : $0e7c1d7817f98110$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).Fragment, null, children($0e7c1d7817f98110$var$_objectSpread($0e7c1d7817f98110$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $ePfkq.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $0e7c1d7817f98110$var$invertedDirection[$0e7c1d7817f98110$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $bnv12.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $5fkkM.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $0e7c1d7817f98110$var$_objectSpread($0e7c1d7817f98110$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $0e7c1d7817f98110$export$2e2bcd8739ae039 = $0e7c1d7817f98110$var$Tooltip;
var $0e7c1d7817f98110$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1w48L.default), {
        zIndex: $0e7c1d7817f98110$var$tooltipZIndex
    }, children);
};

});
parcelRegister("4VUbn", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $397810fbbd249686$export$1a04351537078b55; });

var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");

var $3SI82 = parcelRequire("3SI82");

var $kCbFU = parcelRequire("kCbFU");
function $397810fbbd249686$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $397810fbbd249686$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $397810fbbd249686$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $397810fbbd249686$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $397810fbbd249686$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $3SI82.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $kCbFU.useTrackedRef)(analyticsData);
    var fnRef = (0, $kCbFU.useTrackedRef)(fn);
    var handler = (0, $dNMDr.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $397810fbbd249686$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("ge9M2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd058903f3207208$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $40QgJ = parcelRequire("40QgJ");

var $7AbKs = parcelRequire("7AbKs");
function $bd058903f3207208$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $dNMDr.useRef)(false);
    var onKeyDown = (0, $dNMDr.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $7AbKs.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $dNMDr.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $dNMDr.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $40QgJ.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("7AbKs", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", function () { return $5855022ff158b353$export$390330c10ff2b9a1; });
$parcel$export(module.exports, "KEY_DOWN", function () { return $5855022ff158b353$export$a80636c6f41931fe; });
$parcel$export(module.exports, "KEY_LEFT", function () { return $5855022ff158b353$export$fc4577f2a2af0ae3; });
$parcel$export(module.exports, "KEY_RIGHT", function () { return $5855022ff158b353$export$c40f9845adc73fb5; });
$parcel$export(module.exports, "KEY_HOME", function () { return $5855022ff158b353$export$4af703091671bc; });
$parcel$export(module.exports, "KEY_END", function () { return $5855022ff158b353$export$e2bc30913faa5db7; });
$parcel$export(module.exports, "KEY_TAB", function () { return $5855022ff158b353$export$10f6869ed0a7d75b; });
$parcel$export(module.exports, "KEY_ENTER", function () { return $5855022ff158b353$export$8152f929a25a0ff4; });
$parcel$export(module.exports, "KEY_SPACE", function () { return $5855022ff158b353$export$e51a3576c045c8d5; });
$parcel$export(module.exports, "ESCAPE", function () { return $5855022ff158b353$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $5855022ff158b353$export$390330c10ff2b9a1 = 'ArrowUp';
var $5855022ff158b353$export$a80636c6f41931fe = 'ArrowDown';
var $5855022ff158b353$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $5855022ff158b353$export$c40f9845adc73fb5 = 'ArrowRight';
var $5855022ff158b353$export$4af703091671bc = 'Home';
var $5855022ff158b353$export$e2bc30913faa5db7 = 'End';
var $5855022ff158b353$export$10f6869ed0a7d75b = 'Tab';
var $5855022ff158b353$export$8152f929a25a0ff4 = 'Enter';
var $5855022ff158b353$export$e51a3576c045c8d5 = 'Space';
var $5855022ff158b353$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("k3Tbu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9aee4ea6df71c7c$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");
function $e9aee4ea6df71c7c$export$2e2bcd8739ae039(value) {
    var ref = (0, $dNMDr.useRef)(value);
    (0, $dNMDr.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("Xcbzo", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $0b1ef69c6a39cf79$export$469bb693f11edc7f; });

var $dNMDr = parcelRequire("dNMDr");

var $7SAQE = parcelRequire("7SAQE");

var $7Bf7Q = parcelRequire("7Bf7Q");
function $0b1ef69c6a39cf79$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $dNMDr.useContext)((0, $7SAQE.OpenLayerObserverContext));
    var namespace = (0, $7Bf7Q.useOpenLayerObserverNamespace)();
    (0, $dNMDr.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("7SAQE", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $5bca28d153d56876$export$5fbf4d7fae6cdc00; });

var $dNMDr = parcelRequire("dNMDr");
var $5bca28d153d56876$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $dNMDr.createContext)(null);

});

parcelRegister("7Bf7Q", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserverNamespace", function () { return $5887b8bb702d2ab6$export$1d57e79091cc3046; });

var $dNMDr = parcelRequire("dNMDr");

var $86Krx = parcelRequire("86Krx");
function $5887b8bb702d2ab6$export$1d57e79091cc3046() {
    var namespace = (0, $dNMDr.useContext)((0, $86Krx.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("86Krx", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", function () { return $5e72e8e75bf2e33a$export$644a49f3b8c50fcd; });

var $dNMDr = parcelRequire("dNMDr");
var $5e72e8e75bf2e33a$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $dNMDr.createContext)(null);

});



parcelRegister("bnv12", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $8489e6c1ff688338$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $8489e6c1ff688338$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $8489e6c1ff688338$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $8489e6c1ff688338$var$ExitingContext = /*#__PURE__*/ (0, $dNMDr.createContext)($8489e6c1ff688338$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $8489e6c1ff688338$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $8489e6c1ff688338$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($8489e6c1ff688338$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $8489e6c1ff688338$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $dNMDr.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $8489e6c1ff688338$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $8489e6c1ff688338$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $8489e6c1ff688338$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $8489e6c1ff688338$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $8489e6c1ff688338$var$ExitingPersistence = /*#__PURE__*/ (0, $dNMDr.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $dNMDr.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $dNMDr.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $dNMDr.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $dNMDr.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $8489e6c1ff688338$var$childrenToArray(previousChildren);
    var current = $8489e6c1ff688338$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $8489e6c1ff688338$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $8489e6c1ff688338$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $8489e6c1ff688338$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $8489e6c1ff688338$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $8489e6c1ff688338$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $dNMDr.useContext)($8489e6c1ff688338$var$ExitingContext);
};
$8489e6c1ff688338$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $8489e6c1ff688338$export$2e2bcd8739ae039 = $8489e6c1ff688338$var$ExitingPersistence;

});

parcelRegister("5fkkM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d1e206dcdb3bf29$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $kGMtM = parcelRequire("kGMtM");
var $3d1e206dcdb3bf29$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $3d1e206dcdb3bf29$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $3d1e206dcdb3bf29$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $kGMtM.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $3d1e206dcdb3bf29$export$2e2bcd8739ae039 = $3d1e206dcdb3bf29$var$FadeIn;

});
parcelRegister("kGMtM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0fd55e58587f19d$export$2e2bcd8739ae039; });
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $grvIM = parcelRequire("grvIM");

var $1mHwG = parcelRequire("1mHwG");

var $6Tk8u = parcelRequire("6Tk8u");

var $bRdAZ = parcelRequire("bRdAZ");

var $bnv12 = parcelRequire("bnv12");

var $ichiA = parcelRequire("ichiA");
var $f0fd55e58587f19d$var$zoomIn = null;
var $f0fd55e58587f19d$var$zoomOut = null;
var $f0fd55e58587f19d$var$fadeIn = null;
var $f0fd55e58587f19d$var$fadeOut = null;
var $f0fd55e58587f19d$var$fadeInFromTop = null;
var $f0fd55e58587f19d$var$fadeOutFromTop = null;
var $f0fd55e58587f19d$var$fadeInFromLeft = null;
var $f0fd55e58587f19d$var$fadeOutFromLeft = null;
var $f0fd55e58587f19d$var$fadeInFromBottom = null;
var $f0fd55e58587f19d$var$fadeOutFromBottom = null;
var $f0fd55e58587f19d$var$fadeInFromRight = null;
var $f0fd55e58587f19d$var$fadeOutFromRight = null;
var $f0fd55e58587f19d$var$fadeInFromTopConstant = null;
var $f0fd55e58587f19d$var$fadeOutFromTopConstant = null;
var $f0fd55e58587f19d$var$fadeInFromLeftConstant = null;
var $f0fd55e58587f19d$var$fadeOutFromLeftConstant = null;
var $f0fd55e58587f19d$var$fadeInFromBottomConstant = null;
var $f0fd55e58587f19d$var$fadeOutFromBottomConstant = null;
var $f0fd55e58587f19d$var$fadeInFromRightConstant = null;
var $f0fd55e58587f19d$var$fadeOutFromRightConstant = null;
var $f0fd55e58587f19d$var$slideInFromTop = null;
var $f0fd55e58587f19d$var$slideOutFromTop = null;
var $f0fd55e58587f19d$var$slideInFromRight = null;
var $f0fd55e58587f19d$var$slideOutFromRight = null;
var $f0fd55e58587f19d$var$slideInFromBottom = null;
var $f0fd55e58587f19d$var$slideOutFromBottom = null;
var $f0fd55e58587f19d$var$slideInFromLeft = null;
var $f0fd55e58587f19d$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $f0fd55e58587f19d$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $ichiA.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $bnv12.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $bRdAZ.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $dNMDr.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $dNMDr.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $1mHwG.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $6Tk8u.exitingDurations)[duration] : (0, $6Tk8u.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $grvIM.default)([
            (0, $grvIM.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $grvIM.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $grvIM.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $grvIM.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $grvIM.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $grvIM.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $grvIM.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $grvIM.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $grvIM.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $grvIM.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $grvIM.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $grvIM.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $grvIM.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $grvIM.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $grvIM.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $grvIM.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $grvIM.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $grvIM.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $grvIM.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $grvIM.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $grvIM.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $grvIM.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $grvIM.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $grvIM.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $grvIM.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $grvIM.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $grvIM.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $grvIM.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $grvIM.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $grvIM.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $grvIM.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $grvIM.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $grvIM.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $grvIM.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $grvIM.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $grvIM.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $grvIM.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $grvIM.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $grvIM.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $grvIM.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $grvIM.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $grvIM.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $grvIM.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $grvIM.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $grvIM.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $grvIM.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $grvIM.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $grvIM.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $grvIM.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $grvIM.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $grvIM.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $f0fd55e58587f19d$export$2e2bcd8739ae039 = $f0fd55e58587f19d$var$EnteringMotion;

});
parcelRegister("1mHwG", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $0fe99be8d8478e9d$export$b7baf7667a68d87c; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $40QgJ = parcelRequire("40QgJ");
var $0fe99be8d8478e9d$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $0fe99be8d8478e9d$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$0fe99be8d8478e9d$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $0fe99be8d8478e9d$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $dNMDr.useState)($0fe99be8d8478e9d$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $dNMDr.useEffect)(function() {
        if (!$0fe99be8d8478e9d$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $40QgJ.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $0fe99be8d8478e9d$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $0fe99be8d8478e9d$export$ff7706047246b98b = function prefersReducedMotion() {
    return $0fe99be8d8478e9d$export$f0f789643ba5a83c;
};

});

parcelRegister("6Tk8u", function(module, exports) {

$parcel$export(module.exports, "durations", function () { return $50477fb40202cd74$export$38b928a7167ce124; });
$parcel$export(module.exports, "exitingDurations", function () { return $50477fb40202cd74$export$30fa1a2e62ae150c; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $50477fb40202cd74$export$368bacef0dacbe05 = 25;
var $50477fb40202cd74$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $50477fb40202cd74$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $50477fb40202cd74$export$30fa1a2e62ae150c = {
    none: $50477fb40202cd74$export$38b928a7167ce124.none,
    small: $50477fb40202cd74$export$38b928a7167ce124.small * $50477fb40202cd74$var$EXITING_MOTION_MULTIPLIER,
    medium: $50477fb40202cd74$export$38b928a7167ce124.medium * $50477fb40202cd74$var$EXITING_MOTION_MULTIPLIER,
    large: $50477fb40202cd74$export$38b928a7167ce124.large * $50477fb40202cd74$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("bRdAZ", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $8a1f30c5654da54e$export$4f34107a2b00f39c; });

var $dNMDr = parcelRequire("dNMDr");
// Handle both browser and Node.js environments
var $8a1f30c5654da54e$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $8a1f30c5654da54e$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $dNMDr.useRef)([]);
    (0, $dNMDr.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8a1f30c5654da54e$var$getHookDeps(opts));
    return (0, $dNMDr.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $8a1f30c5654da54e$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $dNMDr.useRef)([]);
    (0, $dNMDr.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8a1f30c5654da54e$var$getHookDeps(opts));
    return (0, $dNMDr.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("ichiA", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $d3f6c426654c18e3$export$25c7213fc07ec080; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $c3KQG = parcelRequire("c3KQG");

var $7Zla3 = parcelRequire("7Zla3");

var $azxJz = parcelRequire("azxJz");
var $d3f6c426654c18e3$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $dNMDr.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $c3KQG.default)
    };
});
var $d3f6c426654c18e3$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $azxJz.useUniqueId)();
    var context = (0, $dNMDr.useContext)($d3f6c426654c18e3$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $d3f6c426654c18e3$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $dNMDr.useRef)([]);
    var indexes = [];
    var _useState = (0, $dNMDr.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $7Zla3.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($d3f6c426654c18e3$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $d3f6c426654c18e3$export$2e2bcd8739ae039 = $d3f6c426654c18e3$var$StaggeredEntrance;

});
parcelRegister("7Zla3", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $5d0ea51306b33e16$export$e5c5a5f917a5871c; });

var $dNMDr = parcelRequire("dNMDr");
var $5d0ea51306b33e16$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $dNMDr.useEffect) : (0, $dNMDr.useLayoutEffect);

});

parcelRegister("azxJz", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $7b27571e52d43644$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $dNMDr = parcelRequire("dNMDr");
function $7b27571e52d43644$export$c485849f2e393253() {
    var identifier = (0, $dNMDr.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("ePfkq", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $acb1b80441cd410b$export$badac9ada3a0bdf9; });

var $62ppy = parcelRequire("62ppy");

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $fNXes = parcelRequire("fNXes");

var $2YFPp = parcelRequire("2YFPp");

// Export types from PopperJS / React Popper
var $acb1b80441cd410b$var$viewportPadding = 5;
var $acb1b80441cd410b$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $acb1b80441cd410b$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $acb1b80441cd410b$var$defaultChildrenFn() {
    return null;
}
var $acb1b80441cd410b$var$defaultOffset = [
    0,
    8
];
function $acb1b80441cd410b$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $acb1b80441cd410b$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $acb1b80441cd410b$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $dNMDr.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $acb1b80441cd410b$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $2YFPp.getMaxSizeModifiers)({
            viewportPadding: $acb1b80441cd410b$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($acb1b80441cd410b$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $dNMDr.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fNXes.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("fNXes", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $b81960e38876122b$export$badac9ada3a0bdf9; });

var $dNMDr = parcelRequire("dNMDr");

var $kxRx6 = parcelRequire("kxRx6");

var $glObX = parcelRequire("glObX");

var $6jBdW = parcelRequire("6jBdW");
var $b81960e38876122b$var$NOOP = function NOOP() {
    return void 0;
};
var $b81960e38876122b$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $b81960e38876122b$var$EMPTY_MODIFIERS = [];
function $b81960e38876122b$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $b81960e38876122b$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $dNMDr.useContext((0, $kxRx6.ManagerReferenceNodeContext));
    var _React$useState = $dNMDr.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $dNMDr.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $dNMDr.useEffect(function() {
        (0, $glObX.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $dNMDr.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $6jBdW.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $dNMDr.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $b81960e38876122b$var$NOOP,
            update: update || $b81960e38876122b$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $glObX.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("kxRx6", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $ef506a42e3468148$export$3dbd3405086fec7b; });
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", function () { return $ef506a42e3468148$export$cbabb21c2529b130; });
$parcel$export(module.exports, "Manager", function () { return $ef506a42e3468148$export$d0d38e7dec7a1a61; });

var $dNMDr = parcelRequire("dNMDr");
var $ef506a42e3468148$export$3dbd3405086fec7b = $dNMDr.createContext();
var $ef506a42e3468148$export$cbabb21c2529b130 = $dNMDr.createContext();
function $ef506a42e3468148$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $dNMDr.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $dNMDr.useRef(false);
    $dNMDr.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $dNMDr.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $dNMDr.createElement($ef506a42e3468148$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $dNMDr.createElement($ef506a42e3468148$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("glObX", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", function () { return $be758a9177335018$export$f52c55943429c8b6; });
$parcel$export(module.exports, "safeInvoke", function () { return $be758a9177335018$export$3dfa7c28635fe028; });
$parcel$export(module.exports, "setRef", function () { return $be758a9177335018$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $be758a9177335018$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $be758a9177335018$export$700979bc83e7db82; });

var $dNMDr = parcelRequire("dNMDr");
var $be758a9177335018$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $be758a9177335018$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $be758a9177335018$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $be758a9177335018$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $be758a9177335018$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $be758a9177335018$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $dNMDr.useLayoutEffect : $dNMDr.useEffect;

});

parcelRegister("6jBdW", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $4991644acd4c9e5b$export$f4d5bf230a36dd6e; });

var $dNMDr = parcelRequire("dNMDr");

var $9ZCME = parcelRequire("9ZCME");

var $2Q2vn = parcelRequire("2Q2vn");

var $cAvKi = parcelRequire("cAvKi");

var $glObX = parcelRequire("glObX");
var $4991644acd4c9e5b$var$EMPTY_MODIFIERS = [];
var $4991644acd4c9e5b$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $dNMDr.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $4991644acd4c9e5b$var$EMPTY_MODIFIERS
    };
    var _React$useState = $dNMDr.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $dNMDr.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $9ZCME.flushSync(function() {
                    setState({
                        styles: (0, $glObX.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $glObX.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $dNMDr.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cAvKi)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $dNMDr.useRef();
    (0, $glObX.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $glObX.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $2Q2vn.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("2Q2vn", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $21126190e2927392$export$8f7491d57c8f97a9; });

var $ayCcr = parcelRequire("ayCcr");

var $l2LBN = parcelRequire("l2LBN");

var $04REW = parcelRequire("04REW");

var $8sZJv = parcelRequire("8sZJv");

var $6r6tx = parcelRequire("6r6tx");

var $I2XzR = parcelRequire("I2XzR");

var $1saXK = parcelRequire("1saXK");

var $aQn6H = parcelRequire("aQn6H");

var $fepyj = parcelRequire("fepyj");

var $kTm5I = parcelRequire("kTm5I");


var $21126190e2927392$export$d34966752335dd47 = [
    (0, $l2LBN.default),
    (0, $04REW.default),
    (0, $8sZJv.default),
    (0, $6r6tx.default),
    (0, $I2XzR.default),
    (0, $1saXK.default),
    (0, $aQn6H.default),
    (0, $fepyj.default),
    (0, $kTm5I.default)
];
var $21126190e2927392$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $ayCcr.popperGenerator)({
    defaultModifiers: $21126190e2927392$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("ayCcr", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $7afab608686613e5$export$ed5e13716264f202; });

var $fvKo6 = parcelRequire("fvKo6");

var $fB1vx = parcelRequire("fB1vx");

var $2ahGC = parcelRequire("2ahGC");

var $02PLs = parcelRequire("02PLs");

var $dOnPq = parcelRequire("dOnPq");

var $knYaJ = parcelRequire("knYaJ");

var $lwnlb = parcelRequire("lwnlb");


var $hsoFI = parcelRequire("hsoFI");
var $7afab608686613e5$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $7afab608686613e5$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $7afab608686613e5$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $7afab608686613e5$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $7afab608686613e5$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $hsoFI.isElement)(reference) ? (0, $2ahGC.default)(reference) : reference.contextElement ? (0, $2ahGC.default)(reference.contextElement) : [],
                    popper: (0, $2ahGC.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $dOnPq.default)((0, $lwnlb.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$7afab608686613e5$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $fvKo6.default)(reference, (0, $02PLs.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $fB1vx.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $knYaJ.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$7afab608686613e5$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $7afab608686613e5$export$8f7491d57c8f97a9 = /*#__PURE__*/ $7afab608686613e5$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("fvKo6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4adbbebcf1c4aa6$export$2e2bcd8739ae039; });

var $lBBRH = parcelRequire("lBBRH");

var $5vW70 = parcelRequire("5vW70");

var $91OBl = parcelRequire("91OBl");

var $hsoFI = parcelRequire("hsoFI");

var $abH1f = parcelRequire("abH1f");

var $XBcww = parcelRequire("XBcww");

var $izZNB = parcelRequire("izZNB");

var $2AMbN = parcelRequire("2AMbN");
function $b4adbbebcf1c4aa6$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $2AMbN.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $2AMbN.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b4adbbebcf1c4aa6$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $hsoFI.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $hsoFI.isHTMLElement)(offsetParent) && $b4adbbebcf1c4aa6$var$isElementScaled(offsetParent);
    var documentElement = (0, $XBcww.default)(offsetParent);
    var rect = (0, $lBBRH.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $91OBl.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $izZNB.default)(documentElement)) scroll = (0, $5vW70.default)(offsetParent);
        if ((0, $hsoFI.isHTMLElement)(offsetParent)) {
            offsets = (0, $lBBRH.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $abH1f.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("lBBRH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbaa6ce4c1828e69$export$2e2bcd8739ae039; });

var $hsoFI = parcelRequire("hsoFI");

var $2AMbN = parcelRequire("2AMbN");

var $je5P4 = parcelRequire("je5P4");

var $7kiWD = parcelRequire("7kiWD");
function $fbaa6ce4c1828e69$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $hsoFI.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $2AMbN.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $2AMbN.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $hsoFI.isElement)(element) ? (0, $je5P4.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $7kiWD.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("hsoFI", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $cb5830804b5a9123$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $cb5830804b5a9123$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $cb5830804b5a9123$export$af51f0f06c0f328a; });

var $je5P4 = parcelRequire("je5P4");
function $cb5830804b5a9123$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $je5P4.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $cb5830804b5a9123$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $je5P4.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $cb5830804b5a9123$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $je5P4.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("je5P4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dff3d76151c957ce$export$2e2bcd8739ae039; });
function $dff3d76151c957ce$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("2AMbN", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $1e3452f47d3ec795$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $1e3452f47d3ec795$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $1e3452f47d3ec795$export$2077e0241d6afd3c; });
var $1e3452f47d3ec795$export$8960430cfd85939f = Math.max;
var $1e3452f47d3ec795$export$96ec731ed4dcb222 = Math.min;
var $1e3452f47d3ec795$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("7kiWD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $555918b1e94c7cad$export$2e2bcd8739ae039; });

var $aBTgI = parcelRequire("aBTgI");
function $555918b1e94c7cad$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $aBTgI.default)());
}

});
parcelRegister("aBTgI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b983b4b9a9a17c1$export$2e2bcd8739ae039; });
function $7b983b4b9a9a17c1$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("5vW70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $403cecd85826cb49$export$2e2bcd8739ae039; });

var $grPHo = parcelRequire("grPHo");

var $je5P4 = parcelRequire("je5P4");

var $hsoFI = parcelRequire("hsoFI");

var $6YmLN = parcelRequire("6YmLN");
function $403cecd85826cb49$export$2e2bcd8739ae039(node) {
    if (node === (0, $je5P4.default)(node) || !(0, $hsoFI.isHTMLElement)(node)) return (0, $grPHo.default)(node);
    else return (0, $6YmLN.default)(node);
}

});
parcelRegister("grPHo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf97454daae3d788$export$2e2bcd8739ae039; });

var $je5P4 = parcelRequire("je5P4");
function $bf97454daae3d788$export$2e2bcd8739ae039(node) {
    var win = (0, $je5P4.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("6YmLN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $513a02482a151abb$export$2e2bcd8739ae039; });
function $513a02482a151abb$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("91OBl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $692b75704a3ed66a$export$2e2bcd8739ae039; });
function $692b75704a3ed66a$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("abH1f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76ac4d2c2384f7e9$export$2e2bcd8739ae039; });

var $lBBRH = parcelRequire("lBBRH");

var $XBcww = parcelRequire("XBcww");

var $grPHo = parcelRequire("grPHo");
function $76ac4d2c2384f7e9$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $lBBRH.default)((0, $XBcww.default)(element)).left + (0, $grPHo.default)(element).scrollLeft;
}

});
parcelRegister("XBcww", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b325e250d1ee23e$export$2e2bcd8739ae039; });

var $hsoFI = parcelRequire("hsoFI");
function $0b325e250d1ee23e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $hsoFI.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("izZNB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d86b6ee7920efa8f$export$2e2bcd8739ae039; });

var $kc3qA = parcelRequire("kc3qA");
function $d86b6ee7920efa8f$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $kc3qA.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("kc3qA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb379650ef6e6825$export$2e2bcd8739ae039; });

var $je5P4 = parcelRequire("je5P4");
function $eb379650ef6e6825$export$2e2bcd8739ae039(element) {
    return (0, $je5P4.default)(element).getComputedStyle(element);
}

});



parcelRegister("fB1vx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5ab7b1ada16fc30$export$2e2bcd8739ae039; });

var $lBBRH = parcelRequire("lBBRH");
function $b5ab7b1ada16fc30$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $lBBRH.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("2ahGC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $193a3c17576953d2$export$2e2bcd8739ae039; });

var $av45J = parcelRequire("av45J");

var $auHaX = parcelRequire("auHaX");

var $je5P4 = parcelRequire("je5P4");

var $izZNB = parcelRequire("izZNB");
function $193a3c17576953d2$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $av45J.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $je5P4.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $izZNB.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($193a3c17576953d2$export$2e2bcd8739ae039((0, $auHaX.default)(target)));
}

});
parcelRegister("av45J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a4ff91d815cd9e3$export$2e2bcd8739ae039; });

var $auHaX = parcelRequire("auHaX");

var $izZNB = parcelRequire("izZNB");

var $91OBl = parcelRequire("91OBl");

var $hsoFI = parcelRequire("hsoFI");
function $7a4ff91d815cd9e3$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $91OBl.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $hsoFI.isHTMLElement)(node) && (0, $izZNB.default)(node)) return node;
    return $7a4ff91d815cd9e3$export$2e2bcd8739ae039((0, $auHaX.default)(node));
}

});
parcelRegister("auHaX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a3e32873e726b1b$export$2e2bcd8739ae039; });

var $91OBl = parcelRequire("91OBl");

var $XBcww = parcelRequire("XBcww");

var $hsoFI = parcelRequire("hsoFI");
function $7a3e32873e726b1b$export$2e2bcd8739ae039(element) {
    if ((0, $91OBl.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $hsoFI.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $XBcww.default)(element) // fallback
    );
}

});



parcelRegister("02PLs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00885761f0263c96$export$2e2bcd8739ae039; });

var $je5P4 = parcelRequire("je5P4");

var $91OBl = parcelRequire("91OBl");

var $kc3qA = parcelRequire("kc3qA");

var $hsoFI = parcelRequire("hsoFI");

var $lrv9h = parcelRequire("lrv9h");

var $auHaX = parcelRequire("auHaX");

var $aBTgI = parcelRequire("aBTgI");
function $00885761f0263c96$var$getTrueOffsetParent(element) {
    if (!(0, $hsoFI.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $kc3qA.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $00885761f0263c96$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $aBTgI.default)());
    var isIE = /Trident/i.test((0, $aBTgI.default)());
    if (isIE && (0, $hsoFI.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $kc3qA.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $auHaX.default)(element);
    if ((0, $hsoFI.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $hsoFI.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $91OBl.default)(currentNode)) < 0){
        var css = (0, $kc3qA.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $00885761f0263c96$export$2e2bcd8739ae039(element) {
    var window = (0, $je5P4.default)(element);
    var offsetParent = $00885761f0263c96$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lrv9h.default)(offsetParent) && (0, $kc3qA.default)(offsetParent).position === 'static')offsetParent = $00885761f0263c96$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $91OBl.default)(offsetParent) === 'html' || (0, $91OBl.default)(offsetParent) === 'body' && (0, $kc3qA.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $00885761f0263c96$var$getContainingBlock(element) || window;
}

});
parcelRegister("lrv9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9c44814ffffb7af$export$2e2bcd8739ae039; });

var $91OBl = parcelRequire("91OBl");
function $f9c44814ffffb7af$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $91OBl.default)(element)) >= 0;
}

});


parcelRegister("dOnPq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0e26db5ee0ee02e$export$2e2bcd8739ae039; });

var $lA3HP = parcelRequire("lA3HP");
function $a0e26db5ee0ee02e$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $a0e26db5ee0ee02e$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $a0e26db5ee0ee02e$var$order(modifiers); // order based on phase
    return (0, $lA3HP.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("lA3HP", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $fb5fd5adffb6c489$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $fb5fd5adffb6c489$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $fb5fd5adffb6c489$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $fb5fd5adffb6c489$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $fb5fd5adffb6c489$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $fb5fd5adffb6c489$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $fb5fd5adffb6c489$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $fb5fd5adffb6c489$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $fb5fd5adffb6c489$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $fb5fd5adffb6c489$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $fb5fd5adffb6c489$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $fb5fd5adffb6c489$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $fb5fd5adffb6c489$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $fb5fd5adffb6c489$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $fb5fd5adffb6c489$export$d087d3878fdf71d5; });
var $fb5fd5adffb6c489$export$1e95b668f3b82d = 'top';
var $fb5fd5adffb6c489$export$40e543e69a8b3fbb = 'bottom';
var $fb5fd5adffb6c489$export$79ffe56a765070d2 = 'right';
var $fb5fd5adffb6c489$export$eabcd2c8791e7bf4 = 'left';
var $fb5fd5adffb6c489$export$dfb5619354ba860 = 'auto';
var $fb5fd5adffb6c489$export$aec2ce47c367b8c3 = [
    $fb5fd5adffb6c489$export$1e95b668f3b82d,
    $fb5fd5adffb6c489$export$40e543e69a8b3fbb,
    $fb5fd5adffb6c489$export$79ffe56a765070d2,
    $fb5fd5adffb6c489$export$eabcd2c8791e7bf4
];
var $fb5fd5adffb6c489$export$b3571188c770cc5a = 'start';
var $fb5fd5adffb6c489$export$bd5df0f255a350f8 = 'end';
var $fb5fd5adffb6c489$export$390fd549c5303b4d = 'clippingParents';
var $fb5fd5adffb6c489$export$d7b7311ec04a3e8f = 'viewport';
var $fb5fd5adffb6c489$export$ae5ab1c730825774 = 'popper';
var $fb5fd5adffb6c489$export$ca50aac9f3ba507f = 'reference';
var $fb5fd5adffb6c489$export$368f9a87e87fa4e1 = /*#__PURE__*/ $fb5fd5adffb6c489$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $fb5fd5adffb6c489$export$b3571188c770cc5a,
        placement + "-" + $fb5fd5adffb6c489$export$bd5df0f255a350f8
    ]);
}, []);
var $fb5fd5adffb6c489$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($fb5fd5adffb6c489$export$aec2ce47c367b8c3, [
    $fb5fd5adffb6c489$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $fb5fd5adffb6c489$export$b3571188c770cc5a,
        placement + "-" + $fb5fd5adffb6c489$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $fb5fd5adffb6c489$export$421679a7c3d56e = 'beforeRead';
var $fb5fd5adffb6c489$export$aafa59e2e03f2942 = 'read';
var $fb5fd5adffb6c489$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $fb5fd5adffb6c489$export$c65e99957a05207c = 'beforeMain';
var $fb5fd5adffb6c489$export$f22da7240b7add18 = 'main';
var $fb5fd5adffb6c489$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $fb5fd5adffb6c489$export$8d4d2d70e7d46032 = 'beforeWrite';
var $fb5fd5adffb6c489$export$68d8715fc104d294 = 'write';
var $fb5fd5adffb6c489$export$70a6e5159acce2e6 = 'afterWrite';
var $fb5fd5adffb6c489$export$d087d3878fdf71d5 = [
    $fb5fd5adffb6c489$export$421679a7c3d56e,
    $fb5fd5adffb6c489$export$aafa59e2e03f2942,
    $fb5fd5adffb6c489$export$6964f6c886723980,
    $fb5fd5adffb6c489$export$c65e99957a05207c,
    $fb5fd5adffb6c489$export$f22da7240b7add18,
    $fb5fd5adffb6c489$export$bab79516f2d662fe,
    $fb5fd5adffb6c489$export$8d4d2d70e7d46032,
    $fb5fd5adffb6c489$export$68d8715fc104d294,
    $fb5fd5adffb6c489$export$70a6e5159acce2e6
];

});


parcelRegister("knYaJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed74a1905e8369d7$export$2e2bcd8739ae039; });
function $ed74a1905e8369d7$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("lwnlb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faaeb1170b1cc8fc$export$2e2bcd8739ae039; });
function $faaeb1170b1cc8fc$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("l2LBN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f51eb6f438d1b15b$export$2e2bcd8739ae039; });

var $je5P4 = parcelRequire("je5P4");
var $f51eb6f438d1b15b$var$passive = {
    passive: true
};
function $f51eb6f438d1b15b$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $je5P4.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $f51eb6f438d1b15b$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $f51eb6f438d1b15b$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $f51eb6f438d1b15b$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $f51eb6f438d1b15b$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $f51eb6f438d1b15b$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $f51eb6f438d1b15b$var$effect,
    data: {}
};

});

parcelRegister("04REW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00e9ff797112c398$export$2e2bcd8739ae039; });

var $9JlEt = parcelRequire("9JlEt");
function $00e9ff797112c398$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9JlEt.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $00e9ff797112c398$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $00e9ff797112c398$var$popperOffsets,
    data: {}
};

});
parcelRegister("9JlEt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71591c9a2630205e$export$2e2bcd8739ae039; });

var $cdnWT = parcelRequire("cdnWT");

var $4djmm = parcelRequire("4djmm");

var $4CBLJ = parcelRequire("4CBLJ");

var $lA3HP = parcelRequire("lA3HP");
function $71591c9a2630205e$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $cdnWT.default)(placement) : null;
    var variation = placement ? (0, $4djmm.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $lA3HP.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $lA3HP.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $lA3HP.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $lA3HP.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $4CBLJ.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $lA3HP.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $lA3HP.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("cdnWT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e4946b36f858387$export$2e2bcd8739ae039; });

function $8e4946b36f858387$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("4djmm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $311764bb96029553$export$2e2bcd8739ae039; });
function $311764bb96029553$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("4CBLJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35d80226d301d8f8$export$2e2bcd8739ae039; });
function $35d80226d301d8f8$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("8sZJv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62a0d3255c721975$export$2e2bcd8739ae039; });

var $lA3HP = parcelRequire("lA3HP");

var $02PLs = parcelRequire("02PLs");

var $je5P4 = parcelRequire("je5P4");

var $XBcww = parcelRequire("XBcww");

var $kc3qA = parcelRequire("kc3qA");

var $cdnWT = parcelRequire("cdnWT");

var $4djmm = parcelRequire("4djmm");

var $2AMbN = parcelRequire("2AMbN");
var $62a0d3255c721975$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $62a0d3255c721975$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $2AMbN.round)(x * dpr) / dpr || 0,
        y: (0, $2AMbN.round)(y * dpr) / dpr || 0
    };
}
function $62a0d3255c721975$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $lA3HP.left);
    var sideY = (0, $lA3HP.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $02PLs.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $je5P4.default)(popper)) {
            offsetParent = (0, $XBcww.default)(popper);
            if ((0, $kc3qA.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $lA3HP.top) || (placement === (0, $lA3HP.left) || placement === (0, $lA3HP.right)) && variation === (0, $lA3HP.end)) {
            sideY = (0, $lA3HP.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $lA3HP.left) || (placement === (0, $lA3HP.top) || placement === (0, $lA3HP.bottom)) && variation === (0, $lA3HP.end)) {
            sideX = (0, $lA3HP.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $62a0d3255c721975$var$unsetSides);
    var _ref4 = roundOffsets === true ? $62a0d3255c721975$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $je5P4.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $62a0d3255c721975$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $cdnWT.default)(state.placement),
        variation: (0, $4djmm.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $62a0d3255c721975$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $62a0d3255c721975$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $62a0d3255c721975$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $62a0d3255c721975$var$computeStyles,
    data: {}
};

});

parcelRegister("6r6tx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4afa4997a6b39b5c$export$2e2bcd8739ae039; });

var $91OBl = parcelRequire("91OBl");

var $hsoFI = parcelRequire("hsoFI");
// and applies them to the HTMLElements such as popper and arrow
function $4afa4997a6b39b5c$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $hsoFI.isHTMLElement)(element) || !(0, $91OBl.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $4afa4997a6b39b5c$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $hsoFI.isHTMLElement)(element) || !(0, $91OBl.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $4afa4997a6b39b5c$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $4afa4997a6b39b5c$var$applyStyles,
    effect: $4afa4997a6b39b5c$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("I2XzR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $084667f498f8d42a$export$2e2bcd8739ae039; });

var $cdnWT = parcelRequire("cdnWT");

var $lA3HP = parcelRequire("lA3HP");
function $084667f498f8d42a$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $cdnWT.default)(placement);
    var invertDistance = [
        (0, $lA3HP.left),
        (0, $lA3HP.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $lA3HP.left),
        (0, $lA3HP.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $084667f498f8d42a$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $lA3HP.placements).reduce(function(acc, placement) {
        acc[placement] = $084667f498f8d42a$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $084667f498f8d42a$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $084667f498f8d42a$var$offset
};

});

parcelRegister("1saXK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10f0e8ea86341167$export$2e2bcd8739ae039; });

var $5nK9o = parcelRequire("5nK9o");

var $cdnWT = parcelRequire("cdnWT");

var $7MUYO = parcelRequire("7MUYO");

var $dqN1P = parcelRequire("dqN1P");

var $eGigA = parcelRequire("eGigA");

var $lA3HP = parcelRequire("lA3HP");

var $4djmm = parcelRequire("4djmm");
function $10f0e8ea86341167$var$getExpandedFallbackPlacements(placement) {
    if ((0, $cdnWT.default)(placement) === (0, $lA3HP.auto)) return [];
    var oppositePlacement = (0, $5nK9o.default)(placement);
    return [
        (0, $7MUYO.default)(placement),
        oppositePlacement,
        (0, $7MUYO.default)(oppositePlacement)
    ];
}
function $10f0e8ea86341167$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $cdnWT.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $5nK9o.default)(preferredPlacement)
    ] : $10f0e8ea86341167$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $cdnWT.default)(placement) === (0, $lA3HP.auto) ? (0, $eGigA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $cdnWT.default)(placement);
        var isStartVariation = (0, $4djmm.default)(placement) === (0, $lA3HP.start);
        var isVertical = [
            (0, $lA3HP.top),
            (0, $lA3HP.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $dqN1P.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $lA3HP.right) : (0, $lA3HP.left) : isStartVariation ? (0, $lA3HP.bottom) : (0, $lA3HP.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $5nK9o.default)(mainVariationSide);
        var altVariationSide = (0, $5nK9o.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $10f0e8ea86341167$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $10f0e8ea86341167$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("5nK9o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3eb2e6426de37038$export$2e2bcd8739ae039; });
var $3eb2e6426de37038$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $3eb2e6426de37038$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $3eb2e6426de37038$var$hash[matched];
    });
}

});

parcelRegister("7MUYO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ab9371fe8f38906$export$2e2bcd8739ae039; });
var $5ab9371fe8f38906$var$hash = {
    start: 'end',
    end: 'start'
};
function $5ab9371fe8f38906$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5ab9371fe8f38906$var$hash[matched];
    });
}

});

parcelRegister("dqN1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c73bc1caf59f168$export$2e2bcd8739ae039; });

var $5s7Tu = parcelRequire("5s7Tu");

var $XBcww = parcelRequire("XBcww");

var $lBBRH = parcelRequire("lBBRH");

var $9JlEt = parcelRequire("9JlEt");

var $iIXJ6 = parcelRequire("iIXJ6");

var $lA3HP = parcelRequire("lA3HP");

var $hsoFI = parcelRequire("hsoFI");

var $fqP2d = parcelRequire("fqP2d");

var $d7FqL = parcelRequire("d7FqL");
function $9c73bc1caf59f168$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $lA3HP.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $lA3HP.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $lA3HP.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $fqP2d.default)(typeof padding !== 'number' ? padding : (0, $d7FqL.default)(padding, (0, $lA3HP.basePlacements)));
    var altContext = elementContext === (0, $lA3HP.popper) ? (0, $lA3HP.reference) : (0, $lA3HP.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5s7Tu.default)((0, $hsoFI.isElement)(element) ? element : element.contextElement || (0, $XBcww.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $lBBRH.default)(state.elements.reference);
    var popperOffsets = (0, $9JlEt.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $iIXJ6.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $lA3HP.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $lA3HP.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $lA3HP.right),
                (0, $lA3HP.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $lA3HP.top),
                (0, $lA3HP.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5s7Tu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f85b0def910917f$export$2e2bcd8739ae039; });

var $lA3HP = parcelRequire("lA3HP");

var $k1UIi = parcelRequire("k1UIi");

var $elkCM = parcelRequire("elkCM");

var $2ahGC = parcelRequire("2ahGC");

var $02PLs = parcelRequire("02PLs");

var $XBcww = parcelRequire("XBcww");

var $kc3qA = parcelRequire("kc3qA");

var $hsoFI = parcelRequire("hsoFI");

var $lBBRH = parcelRequire("lBBRH");

var $auHaX = parcelRequire("auHaX");

var $95f56 = parcelRequire("95f56");

var $91OBl = parcelRequire("91OBl");

var $iIXJ6 = parcelRequire("iIXJ6");

var $2AMbN = parcelRequire("2AMbN");
function $3f85b0def910917f$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $lBBRH.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $3f85b0def910917f$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $lA3HP.viewport) ? (0, $iIXJ6.default)((0, $k1UIi.default)(element, strategy)) : (0, $hsoFI.isElement)(clippingParent) ? $3f85b0def910917f$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $iIXJ6.default)((0, $elkCM.default)((0, $XBcww.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $3f85b0def910917f$var$getClippingParents(element) {
    var clippingParents = (0, $2ahGC.default)((0, $auHaX.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $kc3qA.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $hsoFI.isHTMLElement)(element) ? (0, $02PLs.default)(element) : element;
    if (!(0, $hsoFI.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $hsoFI.isElement)(clippingParent) && (0, $95f56.default)(clippingParent, clipperElement) && (0, $91OBl.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $3f85b0def910917f$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $3f85b0def910917f$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $3f85b0def910917f$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $2AMbN.max)(rect.top, accRect.top);
        accRect.right = (0, $2AMbN.min)(rect.right, accRect.right);
        accRect.bottom = (0, $2AMbN.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $2AMbN.max)(rect.left, accRect.left);
        return accRect;
    }, $3f85b0def910917f$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("k1UIi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e94fe4bf85e69eb5$export$2e2bcd8739ae039; });

var $je5P4 = parcelRequire("je5P4");

var $XBcww = parcelRequire("XBcww");

var $abH1f = parcelRequire("abH1f");

var $7kiWD = parcelRequire("7kiWD");
function $e94fe4bf85e69eb5$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $je5P4.default)(element);
    var html = (0, $XBcww.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $7kiWD.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $abH1f.default)(element),
        y: y
    };
}

});

parcelRegister("elkCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a71306710e3274a5$export$2e2bcd8739ae039; });

var $XBcww = parcelRequire("XBcww");

var $kc3qA = parcelRequire("kc3qA");

var $abH1f = parcelRequire("abH1f");

var $grPHo = parcelRequire("grPHo");

var $2AMbN = parcelRequire("2AMbN");
function $a71306710e3274a5$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $XBcww.default)(element);
    var winScroll = (0, $grPHo.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $2AMbN.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $2AMbN.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $abH1f.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $kc3qA.default)(body || html).direction === 'rtl') x += (0, $2AMbN.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("95f56", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69d0478582e24e85$export$2e2bcd8739ae039; });

var $hsoFI = parcelRequire("hsoFI");
function $69d0478582e24e85$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $hsoFI.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("iIXJ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da1aaa831029c8c9$export$2e2bcd8739ae039; });
function $da1aaa831029c8c9$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("fqP2d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3c0df263d1ffa84$export$2e2bcd8739ae039; });

var $9koMu = parcelRequire("9koMu");
function $b3c0df263d1ffa84$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $9koMu.default)(), paddingObject);
}

});
parcelRegister("9koMu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ca9344ec884c3cd$export$2e2bcd8739ae039; });
function $6ca9344ec884c3cd$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("d7FqL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98dc111a9c323d22$export$2e2bcd8739ae039; });
function $98dc111a9c323d22$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("eGigA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab03284b0753be5f$export$2e2bcd8739ae039; });

var $4djmm = parcelRequire("4djmm");

var $lA3HP = parcelRequire("lA3HP");

var $dqN1P = parcelRequire("dqN1P");

var $cdnWT = parcelRequire("cdnWT");
function $ab03284b0753be5f$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $lA3HP.placements) : _options$allowedAutoP;
    var variation = (0, $4djmm.default)(placement);
    var placements = variation ? flipVariations ? (0, $lA3HP.variationPlacements) : (0, $lA3HP.variationPlacements).filter(function(placement) {
        return (0, $4djmm.default)(placement) === variation;
    }) : (0, $lA3HP.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $dqN1P.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $cdnWT.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("aQn6H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e50af49e2e2a7ba$export$2e2bcd8739ae039; });

var $lA3HP = parcelRequire("lA3HP");

var $cdnWT = parcelRequire("cdnWT");

var $4CBLJ = parcelRequire("4CBLJ");

var $2RYNo = parcelRequire("2RYNo");

var $5vhj4 = parcelRequire("5vhj4");

var $fB1vx = parcelRequire("fB1vx");

var $02PLs = parcelRequire("02PLs");

var $dqN1P = parcelRequire("dqN1P");

var $4djmm = parcelRequire("4djmm");

var $9koMu = parcelRequire("9koMu");

var $2AMbN = parcelRequire("2AMbN");
function $7e50af49e2e2a7ba$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $dqN1P.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $cdnWT.default)(state.placement);
    var variation = (0, $4djmm.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $4CBLJ.default)(basePlacement);
    var altAxis = (0, $2RYNo.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $lA3HP.top) : (0, $lA3HP.left);
        var altSide = mainAxis === 'y' ? (0, $lA3HP.bottom) : (0, $lA3HP.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $lA3HP.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $lA3HP.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $fB1vx.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $9koMu.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $5vhj4.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $02PLs.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $5vhj4.within)(tether ? (0, $2AMbN.min)(min, tetherMin) : min, offset, tether ? (0, $2AMbN.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $lA3HP.top) : (0, $lA3HP.left);
        var _altSide = mainAxis === 'x' ? (0, $lA3HP.bottom) : (0, $lA3HP.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $lA3HP.top),
            (0, $lA3HP.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $5vhj4.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $5vhj4.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7e50af49e2e2a7ba$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $7e50af49e2e2a7ba$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("2RYNo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $216fb0c4db23a9be$export$2e2bcd8739ae039; });
function $216fb0c4db23a9be$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("5vhj4", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $401d45bfc6c66922$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $401d45bfc6c66922$export$86c8af6d3ef0b4a; });

var $2AMbN = parcelRequire("2AMbN");
function $401d45bfc6c66922$export$f28d906d67a997f3(min, value, max) {
    return (0, $2AMbN.max)(min, (0, $2AMbN.min)(value, max));
}
function $401d45bfc6c66922$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $401d45bfc6c66922$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("fepyj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b16bfc02bbf43c49$export$2e2bcd8739ae039; });

var $cdnWT = parcelRequire("cdnWT");

var $fB1vx = parcelRequire("fB1vx");

var $95f56 = parcelRequire("95f56");

var $02PLs = parcelRequire("02PLs");

var $4CBLJ = parcelRequire("4CBLJ");

var $5vhj4 = parcelRequire("5vhj4");

var $fqP2d = parcelRequire("fqP2d");

var $d7FqL = parcelRequire("d7FqL");

var $lA3HP = parcelRequire("lA3HP");
var $b16bfc02bbf43c49$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $fqP2d.default)(typeof padding !== 'number' ? padding : (0, $d7FqL.default)(padding, (0, $lA3HP.basePlacements)));
};
function $b16bfc02bbf43c49$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $cdnWT.default)(state.placement);
    var axis = (0, $4CBLJ.default)(basePlacement);
    var isVertical = [
        (0, $lA3HP.left),
        (0, $lA3HP.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $b16bfc02bbf43c49$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $fB1vx.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $lA3HP.top) : (0, $lA3HP.left);
    var maxProp = axis === 'y' ? (0, $lA3HP.bottom) : (0, $lA3HP.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $02PLs.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $5vhj4.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $b16bfc02bbf43c49$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $95f56.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $b16bfc02bbf43c49$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $b16bfc02bbf43c49$var$arrow,
    effect: $b16bfc02bbf43c49$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("kTm5I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f35a148ea3dff79e$export$2e2bcd8739ae039; });

var $lA3HP = parcelRequire("lA3HP");

var $dqN1P = parcelRequire("dqN1P");
function $f35a148ea3dff79e$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $f35a148ea3dff79e$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $lA3HP.top),
        (0, $lA3HP.right),
        (0, $lA3HP.bottom),
        (0, $lA3HP.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $f35a148ea3dff79e$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $dqN1P.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $dqN1P.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $f35a148ea3dff79e$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $f35a148ea3dff79e$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $f35a148ea3dff79e$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $f35a148ea3dff79e$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $f35a148ea3dff79e$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $f35a148ea3dff79e$var$hide
};

});


parcelRegister("cAvKi", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $92a178e27377b903$var$hasElementType = typeof Element !== 'undefined';
var $92a178e27377b903$var$hasMap = typeof Map === 'function';
var $92a178e27377b903$var$hasSet = typeof Set === 'function';
var $92a178e27377b903$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $92a178e27377b903$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$92a178e27377b903$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($92a178e27377b903$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$92a178e27377b903$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($92a178e27377b903$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($92a178e27377b903$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($92a178e27377b903$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$92a178e27377b903$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $92a178e27377b903$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("2YFPp", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $22b1a193b1ef1197$export$6d8c2b45c99d6e3f; });

var $82V4i = parcelRequire("82V4i");
function $22b1a193b1ef1197$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("1w48L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11abfdc7dada69f7$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $gQLDR = parcelRequire("gQLDR");

var $dSJWG = parcelRequire("dSJWG");

var $6KDRA = parcelRequire("6KDRA");

var $3LGo3 = parcelRequire("3LGo3");

var $i1zGr = parcelRequire("i1zGr");
function $11abfdc7dada69f7$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $3LGo3.default)(mountStrategy);
    (0, $i1zGr.default)(zIndex);
    return !(0, $gQLDR.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dSJWG.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $6KDRA.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("dSJWG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1b3f553a044ec26$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $9ZCME = parcelRequire("9ZCME");

var $3EVJS = parcelRequire("3EVJS");
var $31Sei = parcelRequire("31Sei");

var $gQLDR = parcelRequire("gQLDR");

var $fc9eu = parcelRequire("fc9eu");
function $a1b3f553a044ec26$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $dNMDr.useMemo)(function() {
        return (0, $fc9eu.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $31Sei.useColorMode)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $fc9eu.appendPortalContainerIfNotAppended)(container);
    (0, $dNMDr.useEffect)(function() {
        return function() {
            (0, $fc9eu.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $9ZCME.createPortal)(colorMode && (0, $gQLDR.fg)('platform_dst_subtree_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3EVJS.default), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

});
parcelRegister("3EVJS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aa1e5450698758f$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $k7uol = parcelRequire("k7uol");

var $91FVG = parcelRequire("91FVG");

var $82V4i = parcelRequire("82V4i");

var $grvIM = parcelRequire("grvIM");

var $axdfd = parcelRequire("axdfd");

var $dNMDr = parcelRequire("dNMDr");

var $40QgJ = parcelRequire("40QgJ");

var $gQLDR = parcelRequire("gQLDR");

var $eLta5 = parcelRequire("eLta5");
var $4awVG = parcelRequire("4awVG");
var $3VzmS = parcelRequire("3VzmS");

var $elt8p = parcelRequire("elt8p");

var $3rQv5 = parcelRequire("3rQv5");

var $iFjoV = parcelRequire("iFjoV");

var $2FhvS = parcelRequire("2FhvS");

var $icMqW = parcelRequire("icMqW");

var $lMCgi = parcelRequire("lMCgi");
function $2aa1e5450698758f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2aa1e5450698758f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2aa1e5450698758f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2aa1e5450698758f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2aa1e5450698758f$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $2aa1e5450698758f$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $2aa1e5450698758f$var$prefersDarkModeMql = $2aa1e5450698758f$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $2aa1e5450698758f$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $2aa1e5450698758f$var$prefersDarkModeMql !== null && $2aa1e5450698758f$var$prefersDarkModeMql !== void 0 && $2aa1e5450698758f$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $2aa1e5450698758f$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $2aa1e5450698758f$var$ThemeProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $dNMDr.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $dNMDr.useState)($2aa1e5450698758f$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $dNMDr.useState)(function() {
        return $2aa1e5450698758f$var$_objectSpread($2aa1e5450698758f$var$_objectSpread({}, $2aa1e5450698758f$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $dNMDr.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($2aa1e5450698758f$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $dNMDr.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $2aa1e5450698758f$var$_objectSpread($2aa1e5450698758f$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $dNMDr.useRef)(null);
    var isInsideAppProvider = (0, $elt8p.useIsInsideAppProvider)();
    var isInsideThemeProvider = (0, $icMqW.useIsInsideThemeProvider)();
    var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider;
    var shouldUseGlobalTheming = /**
   * When not behind feature flag, partially revert to legacy behavior.
   * This only affects theme providers that are not inside an AppProvider or a ThemeProvider,
   * as we still need to set global theme state to prevent breaking existing apps,
   * but also prevent multiple theme providers from loading conflicting theme states.
   *
   * At some point this should be removed as we will
   * only support sub-tree theming when used inside of AppProvider.
   */ !(0, $gQLDR.fg)('platform_dst_subtree_theming') && !isInsideAppProvider && !isInsideThemeProvider || /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ isRootThemeProvider;
    (0, $dNMDr.useEffect)(function() {
        if (shouldUseGlobalTheming) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 3;
                                return lastSetGlobalThemePromiseRef.current;
                            case 3:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return cleanupLastFnCall();
                            case 2:
                                promise = (0, $4awVG.default)($2aa1e5450698758f$var$_objectSpread($2aa1e5450698758f$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $lMCgi.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        shouldUseGlobalTheming,
        theme
    ]);
    (0, $dNMDr.useEffect)(function() {
        if (!$2aa1e5450698758f$var$prefersDarkModeMql) return;
        var unbindListener = (0, $40QgJ.bind)($2aa1e5450698758f$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $2aa1e5450698758f$var$_objectSpread($2aa1e5450698758f$var$_objectSpread({}, (0, $eLta5.default)($2aa1e5450698758f$var$_objectSpread($2aa1e5450698758f$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $3VzmS.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $iFjoV.InsideThemeProviderContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3rQv5.ColorModeContext).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3rQv5.SetColorModeContext).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $2FhvS.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $2FhvS.SetThemeContext).Provider, {
        value: setPartialTheme
    }, !shouldUseGlobalTheming && (0, $gQLDR.fg)('platform_dst_subtree_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, attrs, {
        className: (0, $grvIM.default)([
            $2aa1e5450698758f$var$contentStyles.body
        ])
    }), children) : children)))));
}
var $2aa1e5450698758f$export$2e2bcd8739ae039 = $2aa1e5450698758f$var$ThemeProvider;

});
parcelRegister("elt8p", function(module, exports) {

$parcel$export(module.exports, "InsideAppProviderContext", function () { return $a719a05d51b0dc19$export$7981b2444296e410; });
$parcel$export(module.exports, "useIsInsideAppProvider", function () { return $a719a05d51b0dc19$export$26aa23367bfbab0e; });

var $dNMDr = parcelRequire("dNMDr");
var $a719a05d51b0dc19$export$7981b2444296e410 = /*#__PURE__*/ (0, $dNMDr.createContext)(false);
var $a719a05d51b0dc19$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $dNMDr.useContext)($a719a05d51b0dc19$export$7981b2444296e410);
};

});

parcelRegister("3rQv5", function(module, exports) {

$parcel$export(module.exports, "ColorModeContext", function () { return $282c9e317a89f2fb$export$49ddd74a6729fdb0; });
$parcel$export(module.exports, "SetColorModeContext", function () { return $282c9e317a89f2fb$export$b06130bad0bbc70f; });

var $dNMDr = parcelRequire("dNMDr");
var $282c9e317a89f2fb$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $dNMDr.createContext)(undefined);
var $282c9e317a89f2fb$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $dNMDr.createContext)(undefined);

});

parcelRegister("iFjoV", function(module, exports) {

$parcel$export(module.exports, "InsideThemeProviderContext", function () { return $d96b1afc742ad13f$export$332347eeb335453c; });

var $dNMDr = parcelRequire("dNMDr");
var $d96b1afc742ad13f$export$332347eeb335453c = /*#__PURE__*/ (0, $dNMDr.createContext)(false);

});

parcelRegister("2FhvS", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", function () { return $1f0cfedae0284873$export$2c657da244d00bd6; });
$parcel$export(module.exports, "SetThemeContext", function () { return $1f0cfedae0284873$export$f7a97b47760e2a13; });

var $dNMDr = parcelRequire("dNMDr");
var $1f0cfedae0284873$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $dNMDr.createContext)(undefined);
var $1f0cfedae0284873$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $dNMDr.createContext)(undefined);

});

parcelRegister("icMqW", function(module, exports) {

$parcel$export(module.exports, "useIsInsideThemeProvider", function () { return $d40eeae265070296$export$7ca11437599d653d; });

var $dNMDr = parcelRequire("dNMDr");

var $iFjoV = parcelRequire("iFjoV");
var $d40eeae265070296$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $dNMDr.useContext)((0, $iFjoV.InsideThemeProviderContext))) !== null && _useContext !== void 0 ? _useContext : false;
};

});

parcelRegister("lMCgi", function(module, exports) {

$parcel$export(module.exports, "loadAndMountThemes", function () { return $fdbbc2adb9934135$export$7d4a7e812d176b24; });

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");

var $gHhQa = parcelRequire("gHhQa");

var $bMW75 = parcelRequire("bMW75");

var $lU82V = parcelRequire("lU82V");
var $fdbbc2adb9934135$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $lU82V.isThemeMounted)(themeId)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return (0, $bMW75.default)[themeId]();
                case 6:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $fdbbc2adb9934135$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $gHhQa.getDocument)();
                    if (doc) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return");
                case 3:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $lU82V.isThemeMounted)(themeId)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return");
                case 8:
                    doc.head.appendChild(style);
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $fdbbc2adb9934135$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return $fdbbc2adb9934135$var$loadThemeCss(themeId);
                case 2:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 5;
                        break;
                    }
                    return _context3.abrupt("return");
                case 5:
                    $fdbbc2adb9934135$var$mountThemeCss(themeCss, themeId);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $fdbbc2adb9934135$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($fdbbc2adb9934135$var$loadAndMountThemeCss);
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();

});
parcelRegister("gHhQa", function(module, exports) {

$parcel$export(module.exports, "getDocument", function () { return $c27e8035a3ee51cc$export$f65ca476c09acec0; });
var $c27e8035a3ee51cc$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};

});

parcelRegister("lU82V", function(module, exports) {

$parcel$export(module.exports, "isThemeMounted", function () { return $ff2511c153952f80$export$835a0dc855d02822; });

var $gHhQa = parcelRequire("gHhQa");

var $3VzmS = parcelRequire("3VzmS");
function $ff2511c153952f80$export$835a0dc855d02822(themeId) {
    var doc = (0, $gHhQa.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $3VzmS.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}

});



parcelRegister("31Sei", function(module, exports) {

$parcel$export(module.exports, "useColorMode", function () { return $234b87f580f79033$export$20f3076712c8dfa; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $clwPg = parcelRequire("clwPg");
var $6xuOU = parcelRequire("6xuOU");

var $3rQv5 = parcelRequire("3rQv5");
function $234b87f580f79033$export$20f3076712c8dfa() {
    var value = (0, $dNMDr.useContext)((0, $3rQv5.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $clwPg.default)();
    var _useState = (0, $dNMDr.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $dNMDr.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $6xuOU.default)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("6xuOU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c2dbb64a40387ba$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $3VzmS = parcelRequire("3VzmS");

var $clwPg = parcelRequire("clwPg");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $4c2dbb64a40387ba$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $clwPg.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $3VzmS.THEME_DATA_ATTRIBUTE),
                            (0, $3VzmS.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($4c2dbb64a40387ba$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))($4c2dbb64a40387ba$export$2e2bcd8739ae039, "callbacks", new Set());

});


parcelRegister("fc9eu", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $b0ff236ed098590b$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $b0ff236ed098590b$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $b0ff236ed098590b$export$c582005add11e141; });
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $b0ff236ed098590b$export$fef014d7cef9e543; });
$parcel$export(module.exports, "createPortalParent", function () { return $b0ff236ed098590b$export$95029ca7aca2989e; });

var $iwBgJ = parcelRequire("iwBgJ");
var $b0ff236ed098590b$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $iwBgJ.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $b0ff236ed098590b$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $b0ff236ed098590b$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $iwBgJ.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $iwBgJ.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $b0ff236ed098590b$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $b0ff236ed098590b$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $b0ff236ed098590b$var$getPortalParent().removeChild(container);
};
var $b0ff236ed098590b$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $b0ff236ed098590b$var$getPortalParent().appendChild(container);
};
var $b0ff236ed098590b$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $b0ff236ed098590b$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($b0ff236ed098590b$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $iwBgJ.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $b0ff236ed098590b$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($b0ff236ed098590b$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $iwBgJ.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $iwBgJ.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $b0ff236ed098590b$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});
parcelRegister("iwBgJ", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $d7c81ff98feaa637$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $d7c81ff98feaa637$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $d7c81ff98feaa637$export$13f57c02915787b3; });
var $d7c81ff98feaa637$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $d7c81ff98feaa637$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $d7c81ff98feaa637$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("6KDRA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ea5f5fbdac45dcf$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $9ZCME = parcelRequire("9ZCME");

var $3EVJS = parcelRequire("3EVJS");
var $31Sei = parcelRequire("31Sei");

var $gQLDR = parcelRequire("gQLDR");

var $6wNa0 = parcelRequire("6wNa0");

var $fc9eu = parcelRequire("fc9eu");
function $4ea5f5fbdac45dcf$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $dNMDr.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $31Sei.useColorMode)();
    (0, $6wNa0.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $fc9eu.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $fc9eu.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dNMDr.Suspense), {
        fallback: null
    }, colorMode && (0, $gQLDR.fg)('platform_dst_subtree_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3EVJS.default), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $9ZCME.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("6wNa0", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $4c0bdd718c64b9fb$export$700979bc83e7db82; });

var $dNMDr = parcelRequire("dNMDr");
var $4c0bdd718c64b9fb$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $dNMDr.useLayoutEffect) : (0, $dNMDr.useEffect);

});


parcelRegister("3LGo3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2be6a40bc5c1fef0$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $6wNa0 = parcelRequire("6wNa0");
var $2be6a40bc5c1fef0$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $dNMDr.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $dNMDr.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $6wNa0.useIsomorphicLayoutEffect) : (0, $dNMDr.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $2be6a40bc5c1fef0$export$2e2bcd8739ae039 = $2be6a40bc5c1fef0$var$useIsSubsequentRender;

});

parcelRegister("i1zGr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1f3ffff51b35fd6$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $i2KuV = parcelRequire("i2KuV");

var $kjiwe = parcelRequire("kjiwe");
var $d1f3ffff51b35fd6$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $dNMDr.useEffect)(function() {
        (0, $kjiwe.default)((0, $i2KuV.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $kjiwe.default)((0, $i2KuV.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $d1f3ffff51b35fd6$export$2e2bcd8739ae039 = $d1f3ffff51b35fd6$var$useFirePortalEvent;

});
parcelRegister("i2KuV", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $d22c7b5f3edf63b8$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $d22c7b5f3edf63b8$export$80816bd900e5bd00; });
var $d22c7b5f3edf63b8$export$ed5835cc67e87f72 = 'akPortalMount';
var $d22c7b5f3edf63b8$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("kjiwe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec93f26fec3648b3$export$2e2bcd8739ae039; });
var $ec93f26fec3648b3$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $ec93f26fec3648b3$var$getLayerName = function getLayerName(zIndex) {
    return $ec93f26fec3648b3$var$zIndexToName.hasOwnProperty(zIndex) ? $ec93f26fec3648b3$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $ec93f26fec3648b3$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $ec93f26fec3648b3$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $ec93f26fec3648b3$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $ec93f26fec3648b3$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("gWqO2", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $c556db444fe89d16$export$7be255094ccdc533; });

var $ejTTJ = parcelRequire("ejTTJ");

var $2Mjap = parcelRequire("2Mjap");
var $c556db444fe89d16$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $c556db444fe89d16$export$c93026a968943f95 = 'light';
var $c556db444fe89d16$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $c556db444fe89d16$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $2Mjap.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $ejTTJ.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $c556db444fe89d16$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $c556db444fe89d16$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $c556db444fe89d16$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $ejTTJ.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $c556db444fe89d16$export$ba1d834b86d72a09 = $c556db444fe89d16$export$a1b3edb637fb4f35;
var $c556db444fe89d16$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $2Mjap.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $2Mjap.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $2Mjap.N30A), ")")
            }
        }
    };
};

});

parcelRegister("9192t", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $690b37fca4c8e24c$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $40QgJ = parcelRequire("40QgJ");
var $690b37fca4c8e24c$var$registrations = new Set();
var $690b37fca4c8e24c$var$cleanupEndEventListeners = null;
function $690b37fca4c8e24c$var$onDragStart() {
    if ($690b37fca4c8e24c$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $690b37fca4c8e24c$var$cleanupEndEventListeners = (0, $40QgJ.bindAll)(window, [
        {
            type: 'dragend',
            listener: $690b37fca4c8e24c$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $690b37fca4c8e24c$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $690b37fca4c8e24c$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($690b37fca4c8e24c$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $690b37fca4c8e24c$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $690b37fca4c8e24c$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $690b37fca4c8e24c$var$cleanupEndEventListeners = null;
    var clone = Array.from($690b37fca4c8e24c$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $690b37fca4c8e24c$var$bindStartEvents() {
    return (0, $40QgJ.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $690b37fca4c8e24c$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $690b37fca4c8e24c$var$onDragStart
        }
    ]);
}
var $690b37fca4c8e24c$var$cleanupStartEventListeners = null;
function $690b37fca4c8e24c$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$690b37fca4c8e24c$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $690b37fca4c8e24c$var$cleanupStartEventListeners = $690b37fca4c8e24c$var$bindStartEvents();
    $690b37fca4c8e24c$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $690b37fca4c8e24c$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $690b37fca4c8e24c$var$registrations.delete(registration);
        if ($690b37fca4c8e24c$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $690b37fca4c8e24c$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $690b37fca4c8e24c$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("e0BD0", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $a32e40f4e605f431$export$57bf213be019eeb0; });

var $gQLDR = parcelRequire("gQLDR");

var $39DKj = parcelRequire("39DKj");
// This file is a singleton for managing tooltips
var $a32e40f4e605f431$var$active = null;
function $a32e40f4e605f431$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($a32e40f4e605f431$var$active && $a32e40f4e605f431$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $39DKj.clearScheduled)();
            $a32e40f4e605f431$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $39DKj.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $39DKj.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $39DKj.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var shouldAlwaysFadeIn = (0, $gQLDR.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? entry.shouldAlwaysFadeIn : false;
        var showImmediately = Boolean($a32e40f4e605f431$var$active && $a32e40f4e605f431$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($a32e40f4e605f431$var$active) {
            (0, $39DKj.clearScheduled)();
            $a32e40f4e605f431$var$active.entry.hide({
                isImmediate: true
            });
            $a32e40f4e605f431$var$active.entry.done();
            $a32e40f4e605f431$var$active = null;
        }
        // this tooltip is now the active tooltip
        $a32e40f4e605f431$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $39DKj.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        // Removing old `mousePosition` behind gate because it stored a function.
        // With the gate we just store the coords which are easier to work with.
        mousePosition: (0, $gQLDR.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : getInitialMouse(),
        mousePos: entry.source.type === 'mouse' && (0, $gQLDR.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});
parcelRegister("39DKj", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $24c10b0ffb6a0e08$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $24c10b0ffb6a0e08$export$5f4d6617421d489b; });
var $24c10b0ffb6a0e08$var$delayId = null;
function $24c10b0ffb6a0e08$export$eaf678f6f93f5250() {
    if ($24c10b0ffb6a0e08$var$delayId != null) {
        window.clearTimeout($24c10b0ffb6a0e08$var$delayId);
        $24c10b0ffb6a0e08$var$delayId = null;
    }
}
function $24c10b0ffb6a0e08$export$5f4d6617421d489b(fn, delay) {
    $24c10b0ffb6a0e08$export$eaf678f6f93f5250();
    $24c10b0ffb6a0e08$var$delayId = window.setTimeout(function() {
        $24c10b0ffb6a0e08$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("fOgZ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b828b32534599654$export$2e2bcd8739ae039; });

var $hGahQ = parcelRequire("hGahQ");
function $b828b32534599654$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $hGahQ.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("hGahQ", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $cdee56a90f023f76$export$f680877a34711e37; });
$parcel$export(module.exports, "useIdSeed", function () { return $cdee56a90f023f76$export$6ee17796e3d70de2; });

var $a3ftr = parcelRequire("a3ftr");

var $dNMDr = parcelRequire("dNMDr");

var $ipTg3 = parcelRequire("ipTg3");

var $gQLDR = parcelRequire("gQLDR");
var $cdee56a90f023f76$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $cdee56a90f023f76$var$react18UseId = ($cdee56a90f023f76$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).useId) !== null && $cdee56a90f023f76$var$_React$useId !== void 0 ? $cdee56a90f023f76$var$_React$useId : undefined;
function $cdee56a90f023f76$export$f680877a34711e37() {
    if ($cdee56a90f023f76$var$react18UseId && (0, $gQLDR.fg)('platform-dst-react-18-use-id')) {
        if ((0, $gQLDR.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $cdee56a90f023f76$var$react18UseId().replace(/[:«»]/g, '_');
        return $cdee56a90f023f76$var$react18UseId();
    }
    return "uid".concat((0, $ipTg3.useUID)());
}
var $cdee56a90f023f76$export$6be90bcb437e928f = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($cdee56a90f023f76$export$f680877a34711e37()).concat(postfix);
    (0, $dNMDr.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $cdee56a90f023f76$export$6ee17796e3d70de2() {
    if ($cdee56a90f023f76$var$react18UseId && (0, $gQLDR.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $cdee56a90f023f76$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $ipTg3.useUIDSeed)();
}

});
parcelRegister("ipTg3", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $d6856ce07d778d07$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $d6856ce07d778d07$export$bb5ca5fba6fb4f1f; });

var $dNMDr = parcelRequire("dNMDr");

var $3ZHAX = parcelRequire("3ZHAX");
var $d6856ce07d778d07$var$generateUID = function(context) {
    var quartz = context || (0, $3ZHAX.counter);
    var prefix = (0, $3ZHAX.getPrefix)(quartz);
    var id = (0, $3ZHAX.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $d6856ce07d778d07$var$useUIDState = function() {
    var context = (0, $dNMDr.useContext)((0, $3ZHAX.source));
    var uid = (0, $dNMDr.useState)(function() {
        return $d6856ce07d778d07$var$generateUID(context);
    })[0];
    return uid;
};
var $d6856ce07d778d07$export$87d05f07e65211f1 = function() {
    var uid = $d6856ce07d778d07$var$useUIDState().uid;
    return uid;
};
var $d6856ce07d778d07$export$bb5ca5fba6fb4f1f = function() {
    var gen = $d6856ce07d778d07$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("3ZHAX", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $2e88e2b12f219781$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $2e88e2b12f219781$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $2e88e2b12f219781$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $2e88e2b12f219781$export$36e24695f02d4503; });

var $dNMDr = parcelRequire("dNMDr");

var $9z2qy = parcelRequire("9z2qy");
var $2e88e2b12f219781$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $9z2qy.generateUID)()
    };
};
var $2e88e2b12f219781$export$e575061ef2a070eb = $2e88e2b12f219781$export$1921362e86c73c88();
var $2e88e2b12f219781$export$b4d5da5f34fb77ad = $dNMDr.createContext($2e88e2b12f219781$export$1921362e86c73c88());
var $2e88e2b12f219781$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $2e88e2b12f219781$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("9z2qy", function(module, exports) {

$parcel$export(module.exports, "generateUID", function () { return $6f6943f9740d19ba$export$bdbb4cbb3078e58d; });
$parcel$export(module.exports, "uid", function () { return $6f6943f9740d19ba$export$e2a22331486dcca0; });
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $6f6943f9740d19ba$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $6f6943f9740d19ba$export$e2a22331486dcca0 = $6f6943f9740d19ba$export$bdbb4cbb3078e58d();

});





parcelRegister("k66AC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea197ac3b631bbbd$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $grvIM = parcelRequire("grvIM");

var $5EdKY = parcelRequire("5EdKY");
var $ea197ac3b631bbbd$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $ea197ac3b631bbbd$var$TooltipContainer = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $dNMDr.createElement((0, $5EdKY.default), {
        ref: ref,
        style: style,
        className: (0, $grvIM.default)([
            $ea197ac3b631bbbd$var$styles.base,
            truncate && $ea197ac3b631bbbd$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$ea197ac3b631bbbd$var$TooltipContainer.displayName = 'TooltipContainer';
var $ea197ac3b631bbbd$export$2e2bcd8739ae039 = $ea197ac3b631bbbd$var$TooltipContainer;

});
parcelRegister("5EdKY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41cb5bf6e3617bb9$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $grvIM = parcelRequire("grvIM");

var $8HaSB = parcelRequire("8HaSB");
var $41cb5bf6e3617bb9$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $41cb5bf6e3617bb9$var$TooltipPrimitive = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $dNMDr.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $dNMDr.createElement("div", {
        role: "tooltip",
        className: (0, $grvIM.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $dNMDr.createElement((0, $8HaSB.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$41cb5bf6e3617bb9$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $41cb5bf6e3617bb9$export$2e2bcd8739ae039 = $41cb5bf6e3617bb9$var$TooltipPrimitive;

});
parcelRegister("8HaSB", function(module, exports) {

$parcel$export(module.exports, "TooltipShortcut", function () { return $654ac75d8c45af36$export$5bcbc43c84236222; });
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $grvIM = parcelRequire("grvIM");
var $654ac75d8c45af36$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $654ac75d8c45af36$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $dNMDr.createElement("div", {
        className: (0, $grvIM.default)([
            $654ac75d8c45af36$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $dNMDr.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $grvIM.default)([
                $654ac75d8c45af36$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};

});



parcelRegister("j46FI", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $de1390ebc8e65929$export$642213d516a9b928; });
$parcel$export(module.exports, "getVirtualElementFromMousePos", function () { return $de1390ebc8e65929$export$2e68479e0a5d8746; });
function $de1390ebc8e65929$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}
function $de1390ebc8e65929$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}

});


parcelRegister("dqFFZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c6e0817a6498825$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $affTb = parcelRequire("affTb");

var $dNMDr = parcelRequire("dNMDr");

var $kugzw = parcelRequire("kugzw");

var $gTgRL = parcelRequire("gTgRL");

var $lm7lB = parcelRequire("lm7lB");

var $hGahQ = parcelRequire("hGahQ");

var $gQLDR = parcelRequire("gQLDR");

var $aMk5E = parcelRequire("aMk5E");

var $iRhvt = parcelRequire("iRhvt");

var $jK4MU = parcelRequire("jK4MU");

var $2Q5PX = parcelRequire("2Q5PX");

var $4032P = parcelRequire("4032P");
var $9c6e0817a6498825$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $9c6e0817a6498825$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $9c6e0817a6498825$var$LOADING_LABEL = ', Loading';
var $9c6e0817a6498825$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBeforeWithHack: "_bozgu2gc",
    buttonIconAfterWithHack: "_y4tiu2gc",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $9c6e0817a6498825$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $9c6e0817a6498825$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $9c6e0817a6498825$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $9c6e0817a6498825$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $9c6e0817a6498825$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $9c6e0817a6498825$var$subtleStyles = {
    root: "_bfhkqtfy _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr34mfv _30l3azsu _1di619qy _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $9c6e0817a6498825$var$selectedStyles = {
    root: "_bfhk15s3 _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $9c6e0817a6498825$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $9c6e0817a6498825$var$_excluded);
    var localRef = (0, $dNMDr.useRef)(null);
    var splitButtonContext = (0, $jK4MU.useSplitButtonContext)();
    var loadingLabelId = (0, $hGahQ.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $lm7lB.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(unsafeRest, $9c6e0817a6498825$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $aMk5E.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $gTgRL.default)([
            localRef,
            ref
        ]),
        xcss: (0, $kugzw.cx)($9c6e0817a6498825$var$styles.base, (0, $gQLDR.fg)('platform-dst-shape-theme-default') && $9c6e0817a6498825$var$styles.baseT26Shape, appearance === 'default' && $9c6e0817a6498825$var$defaultStyles.root, appearance === 'default' && isInteractive && $9c6e0817a6498825$var$defaultStyles.interactive, appearance === 'primary' && $9c6e0817a6498825$var$primaryStyles.root, appearance === 'primary' && isInteractive && $9c6e0817a6498825$var$primaryStyles.interactive, appearance === 'warning' && $9c6e0817a6498825$var$warningStyles.root, appearance === 'warning' && isInteractive && $9c6e0817a6498825$var$warningStyles.interactive, appearance === 'danger' && $9c6e0817a6498825$var$dangerStyles.root, appearance === 'danger' && isInteractive && $9c6e0817a6498825$var$dangerStyles.interactive, appearance === 'discovery' && $9c6e0817a6498825$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $9c6e0817a6498825$var$discoveryStyles.interactive, appearance === 'subtle' && $9c6e0817a6498825$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $9c6e0817a6498825$var$subtleStyles.interactive, $9c6e0817a6498825$var$styles.linkDecorationUnset, isSelected && $9c6e0817a6498825$var$selectedStyles.root, isSelected && isSplitButton && $9c6e0817a6498825$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $9c6e0817a6498825$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $9c6e0817a6498825$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $9c6e0817a6498825$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $9c6e0817a6498825$var$selectedStyles.discovery, isDisabled && $9c6e0817a6498825$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $9c6e0817a6498825$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $9c6e0817a6498825$var$defaultStyles.disabled, isCircle && !isSplitButton && $9c6e0817a6498825$var$styles.circle, spacing === 'compact' && $9c6e0817a6498825$var$styles.spacingCompact, spacing === 'compact' && (0, $gQLDR.fg)('platform-dst-shape-theme-default') && $9c6e0817a6498825$var$styles.spacingCompactT26Shape, shouldFitContainer && $9c6e0817a6498825$var$styles.fullWidth, hasIconBefore && !(0, $gQLDR.fg)('platform-button-icon-spacing-cleanup') && $9c6e0817a6498825$var$styles.buttonIconBeforeWithHack, //TODO Remove when platform-button-icon-spacing-cleanup is removed
        hasIconAfter && !(0, $gQLDR.fg)('platform-button-icon-spacing-cleanup') && $9c6e0817a6498825$var$styles.buttonIconAfterWithHack, //TODO Remove when platform-button-icon-spacing-cleanup is removed
        hasIconBefore && (0, $gQLDR.fg)('platform-button-icon-spacing-cleanup') && $9c6e0817a6498825$var$styles.buttonIconBefore, //to keep when platform-button-icon-spacing-cleanup is removed
        hasIconAfter && (0, $gQLDR.fg)('platform-button-icon-spacing-cleanup') && $9c6e0817a6498825$var$styles.buttonIconAfter, //to keep when platform-button-icon-spacing-cleanup is removed
        isIconButton && $9c6e0817a6498825$var$styles.iconButton, isIconButton && spacing === 'compact' && $9c6e0817a6498825$var$styles.iconButtonCompact, isLoading && $9c6e0817a6498825$var$styles.loading, isSplitButton && $9c6e0817a6498825$var$styles.splitButton, isNavigationSplitButton && $9c6e0817a6498825$var$styles.navigationSplitButton),
        isDisabled: (0, $gQLDR.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $gQLDR.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $gQLDR.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($9c6e0817a6498825$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $2Q5PX.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $jK4MU.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("span", {
        className: (0, $affTb.default)([
            $9c6e0817a6498825$var$styles.loadingOverlay
        ])
    }, (0, $4032P.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $iRhvt.default), {
        id: loadingLabelId
    }, $9c6e0817a6498825$var$LOADING_LABEL)));
});
var $9c6e0817a6498825$export$2e2bcd8739ae039 = $9c6e0817a6498825$var$ButtonBase;

});
parcelRegister("lm7lB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8c15a1a7ede0524$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");
function $f8c15a1a7ede0524$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $dNMDr.useRef)(true);
    (0, $dNMDr.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("aMk5E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d8df891ea041443$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");


var $icVF1 = parcelRequire("icVF1");

var $02D9g = parcelRequire("02D9g");

var $lcjNF = parcelRequire("lcjNF");

var $c3KQG = parcelRequire("c3KQG");

var $hMip0 = parcelRequire("hMip0");

var $aZGMH = parcelRequire("aZGMH");
var $7d8df891ea041443$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $7d8df891ea041443$var$_excluded2 = [
    "className"
];
var $7d8df891ea041443$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $7d8df891ea041443$var$Pressable = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $c3KQG.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $7d8df891ea041443$var$_excluded);
    var interactionContext = (0, $dNMDr.useContext)((0, $hMip0.default));
    var handleClick = (0, $dNMDr.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $02D9g.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(htmlAttributes, $7d8df891ea041443$var$_excluded2);
    return /*#__PURE__*/ $dNMDr.createElement((0, $aZGMH.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $lcjNF.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $icVF1.cx)($7d8df891ea041443$var$styles.root, isDisabled && $7d8df891ea041443$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $7d8df891ea041443$export$2e2bcd8739ae039 = $7d8df891ea041443$var$Pressable;

});
parcelRegister("lcjNF", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $f6ea13de5f8ea6c4$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isAppleDevice", function () { return $f6ea13de5f8ea6c4$export$e1865c3bedcd822b; });
function $f6ea13de5f8ea6c4$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $f6ea13de5f8ea6c4$var$isIPhone() {
    return $f6ea13de5f8ea6c4$var$testPlatform(/^iPhone/i);
}
function $f6ea13de5f8ea6c4$var$isMac() {
    return $f6ea13de5f8ea6c4$var$testPlatform(/^Mac/i);
}
function $f6ea13de5f8ea6c4$var$isIPad() {
    return $f6ea13de5f8ea6c4$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $f6ea13de5f8ea6c4$var$isMac() && navigator.maxTouchPoints > 1;
}
function $f6ea13de5f8ea6c4$var$isIOS() {
    return $f6ea13de5f8ea6c4$var$isIPhone() || $f6ea13de5f8ea6c4$var$isIPad();
}
function $f6ea13de5f8ea6c4$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $f6ea13de5f8ea6c4$export$e1865c3bedcd822b() {
    return $f6ea13de5f8ea6c4$var$isMac() || $f6ea13de5f8ea6c4$var$isIOS();
}

});

parcelRegister("aZGMH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8010c9fb85133bd2$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
var $8010c9fb85133bd2$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $8010c9fb85133bd2$var$_excluded2 = [
    "className"
];
var $8010c9fb85133bd2$var$focusRingStyles = null;
var $8010c9fb85133bd2$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $8010c9fb85133bd2$var$Focusable = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $8010c9fb85133bd2$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(htmlAttributes, $8010c9fb85133bd2$var$_excluded2);
    return /*#__PURE__*/ $dNMDr.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $affTb.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $8010c9fb85133bd2$export$2e2bcd8739ae039 = $8010c9fb85133bd2$var$Focusable;

});


parcelRegister("jK4MU", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", function () { return $e5f606f6326167da$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $e5f606f6326167da$export$47e2c6fdb142d947; });

var $dNMDr = parcelRequire("dNMDr");
var $e5f606f6326167da$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $dNMDr.createContext)(undefined);
var $e5f606f6326167da$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $dNMDr.useContext)($e5f606f6326167da$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("2Q5PX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2114f735ef4596fb$export$2e2bcd8739ae039; });
function $2114f735ef4596fb$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $2114f735ef4596fb$var$tabKeyCode = 9;
function $2114f735ef4596fb$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $2114f735ef4596fb$var$tabKeyCode) return;
    $2114f735ef4596fb$var$abort(event);
}
function $2114f735ef4596fb$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $2114f735ef4596fb$var$abort,
        onMouseUpCapture: $2114f735ef4596fb$var$abort,
        onKeyDownCapture: $2114f735ef4596fb$var$onKey,
        onKeyUpCapture: $2114f735ef4596fb$var$onKey,
        onTouchStartCapture: $2114f735ef4596fb$var$abort,
        onTouchEndCapture: $2114f735ef4596fb$var$abort,
        onPointerDownCapture: $2114f735ef4596fb$var$abort,
        onPointerUpCapture: $2114f735ef4596fb$var$abort,
        onClickCapture: $2114f735ef4596fb$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $2114f735ef4596fb$var$abort
    } : events;
}

});

parcelRegister("4032P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e9986177481f74b$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $3Wc5s = parcelRequire("3Wc5s");
function $2e9986177481f74b$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $2e9986177481f74b$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $2e9986177481f74b$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3Wc5s.default), {
        size: $2e9986177481f74b$var$getIconSpacing(spacing),
        appearance: $2e9986177481f74b$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});


parcelRegister("cb5Ng", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ddb01933c9b8507$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $affTb = parcelRequire("affTb");

var $dNMDr = parcelRequire("dNMDr");

var $gQLDR = parcelRequire("gQLDR");
var $8ddb01933c9b8507$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $8ddb01933c9b8507$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("span", {
        className: (0, $affTb.default)([
            $8ddb01933c9b8507$var$styles.common,
            type === 'text' && $8ddb01933c9b8507$var$styles.text,
            type === 'icon' && $8ddb01933c9b8507$var$styles.icon,
            isLoading && $8ddb01933c9b8507$var$styles.fade,
            !(0, $gQLDR.fg)('platform-button-icon-spacing-cleanup') && position === 'before' && $8ddb01933c9b8507$var$styles.beforeIcon,
            !(0, $gQLDR.fg)('platform-button-icon-spacing-cleanup') && position === 'after' && $8ddb01933c9b8507$var$styles.afterIcon
        ])
    }, children);
};
var $8ddb01933c9b8507$export$2e2bcd8739ae039 = $8ddb01933c9b8507$var$Content;

});

parcelRegister("hK1dY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cea7aeaca6b395f6$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $gQLDR = parcelRequire("gQLDR");
function $cea7aeaca6b395f6$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $cea7aeaca6b395f6$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $cea7aeaca6b395f6$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $gQLDR.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(Icon, iconProps));
};
var $cea7aeaca6b395f6$export$2e2bcd8739ae039 = $cea7aeaca6b395f6$var$IconRenderer;

});


parcelRegister("jJCD4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5e02f4057a6d100$var$_react = $e5e02f4057a6d100$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $e5e02f4057a6d100$var$_baseNew = $e5e02f4057a6d100$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $e5e02f4057a6d100$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e5e02f4057a6d100$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $e5e02f4057a6d100$var$_react.default.createElement($e5e02f4057a6d100$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$e5e02f4057a6d100$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $e5e02f4057a6d100$var$_default = module.exports.default = $e5e02f4057a6d100$var$ChevronDownIcon;

});

parcelRegister("dP4Xn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a103e219776ce4aa$var$_react = $a103e219776ce4aa$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $a103e219776ce4aa$var$_baseNew = $a103e219776ce4aa$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $a103e219776ce4aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a103e219776ce4aa$var$CrossIcon = (props)=>/*#__PURE__*/ $a103e219776ce4aa$var$_react.default.createElement($a103e219776ce4aa$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$a103e219776ce4aa$var$CrossIcon.displayName = 'CrossIcon';
var $a103e219776ce4aa$var$_default = module.exports.default = $a103e219776ce4aa$var$CrossIcon;

});

parcelRegister("gsWOv", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $bfcce20c31a3fbfe$export$3cfb73f70dfca966; });

var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $gQLDR = parcelRequire("gQLDR");

var $fnvhn = parcelRequire("fnvhn");
var $bfcce20c31a3fbfe$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $bfcce20c31a3fbfe$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $bfcce20c31a3fbfe$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $dNMDr.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $bfcce20c31a3fbfe$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $gQLDR.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (iconSize === 'small' || iconSize === 'medium') && !(0, $gQLDR.fg)('platform-visual-refresh-icons-facade-removal')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, props, {
                spacing: (0, $gQLDR.fg)('platform-visual-refresh-icons-facade-button-fix') ? $bfcce20c31a3fbfe$var$sizeSpacingMap['utility'][iconSize] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, props, {
                size: iconSize,
                spacing: $bfcce20c31a3fbfe$var$sizeSpacingMap['core'][iconSize],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fnvhn.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("fnvhn", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $b321446eafd897e6$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
function $b321446eafd897e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b321446eafd897e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b321446eafd897e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b321446eafd897e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $b321446eafd897e6$var$iconStyles = null;
var $b321446eafd897e6$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $b321446eafd897e6$var$baseHcmStyles = null;
var $b321446eafd897e6$var$primaryEqualsSecondaryHcmStyles = null;
var $b321446eafd897e6$var$secondaryTransparentHcmStyles = null;
var $b321446eafd897e6$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dNMDr.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $dNMDr.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $dNMDr.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $b321446eafd897e6$var$_objectSpread($b321446eafd897e6$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $affTb.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $b321446eafd897e6$var$sizeStyles[size]
        ])
    }));
});
var $b321446eafd897e6$export$2e2bcd8739ae039 = $b321446eafd897e6$export$f04a61298a47a40f;

});


parcelRegister("dRrxv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8cc756abdbbefcea85e2842ee2eda39e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a175965d17045684$var$_react = $a175965d17045684$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $a175965d17045684$var$_baseNew = $a175965d17045684$var$_interopRequireDefault((parcelRequire("9LaLF")));
function $a175965d17045684$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a175965d17045684$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $a175965d17045684$var$_react.default.createElement($a175965d17045684$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$a175965d17045684$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $a175965d17045684$var$_default = module.exports.default = $a175965d17045684$var$StatusSuccessIcon;

});
parcelRegister("9LaLF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("kSZ9i")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("kSZ9i")).Icon; });

var $kSZ9i = parcelRequire("kSZ9i");

});
parcelRegister("kSZ9i", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $f34848b75946a781$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $f34848b75946a781$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $gQLDR = parcelRequire("gQLDR");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $f34848b75946a781$var$svgStyles = null;
var $f34848b75946a781$var$iconStyles = null;
var $f34848b75946a781$var$utilityIconStyles = null;
var $f34848b75946a781$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $f34848b75946a781$var$baseHcmStyles = null;
var $f34848b75946a781$var$scaleSize = null;
var $f34848b75946a781$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f34848b75946a781$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f34848b75946a781$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f34848b75946a781$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $f34848b75946a781$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $f34848b75946a781$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dNMDr.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $gQLDR.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $dNMDr.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    var baseSize = $f34848b75946a781$var$baseSizeMap[type];
    var viewBoxPadding = $f34848b75946a781$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $affTb.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $dNMDr.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $affTb.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $f34848b75946a781$var$utilSizes[spacing] : size === 'small' ? $f34848b75946a781$var$coreSizeSmall[spacing] : $f34848b75946a781$var$coreSizeMedium[spacing]
        ])
    }));
});
var $f34848b75946a781$export$2e2bcd8739ae039 = $f34848b75946a781$export$f04a61298a47a40f;

});



parcelRegister("8qQ4w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $623924d1801877f8$var$_react = $623924d1801877f8$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $gsWOv = parcelRequire("gsWOv");

var $623924d1801877f8$var$_statusError = $623924d1801877f8$var$_interopRequireDefault((parcelRequire("8ueJI")));
function $623924d1801877f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $623924d1801877f8$var$ErrorIcon = (props)=>/*#__PURE__*/ $623924d1801877f8$var$_react.default.createElement($gsWOv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $623924d1801877f8$var$_statusError.default
    }));
$623924d1801877f8$var$ErrorIcon.displayName = 'ErrorIcon';
var $623924d1801877f8$var$_default = module.exports.default = $623924d1801877f8$var$ErrorIcon;

});
parcelRegister("8ueJI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f99ea99a006a4f29d6a537b27790dcf5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62dc8e6c15694540$var$_react = $62dc8e6c15694540$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $62dc8e6c15694540$var$_baseNew = $62dc8e6c15694540$var$_interopRequireDefault((parcelRequire("9LaLF")));
function $62dc8e6c15694540$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62dc8e6c15694540$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $62dc8e6c15694540$var$_react.default.createElement($62dc8e6c15694540$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$62dc8e6c15694540$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $62dc8e6c15694540$var$_default = module.exports.default = $62dc8e6c15694540$var$StatusErrorIcon;

});


parcelRegister("1XgdC", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("jGSOn")).then(()=>parcelRequire('hklRT'));

});

parcelRegister("Ztrmq", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("noc2z")).then(()=>parcelRequire('aBHNs'));

});

parcelRegister("1RDNp", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("1q9Bw")).then(()=>parcelRequire('dVLQc'));

});

parcelRegister("g91KU", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("gutJf")).then(()=>parcelRequire('7KG4n'));

});

parcelRegister("49VRM", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("hMBjB")).then(()=>parcelRequire('lg0oJ'));

});

parcelRegister("dW5Hd", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("1NZsv")).then(()=>parcelRequire('jpwiA'));

});

parcelRegister("9kJTa", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("cjCz5")).then(()=>parcelRequire('f19MM'));

});

parcelRegister("ce4A9", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("lE7Tx")).then(()=>parcelRequire('kE1cb'));

});

parcelRegister("4E5Mb", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("ebOv8")).then(()=>parcelRequire('1Mj3V'));

});

parcelRegister("a0YJb", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("gFQec")).then(()=>parcelRequire('4mjSe'));

});

parcelRegister("8vZ29", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("grAbA")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("g2WlZ"))
]).then(()=>parcelRequire('5D6cz'));

});

parcelRegister("3P2hn", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("aZY3H")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("f7SVq")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("grAbA")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("986Qf"))
]).then(()=>parcelRequire('i9DKH'));

});

parcelRegister("9Db1u", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("f7SVq")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("grAbA")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("anpZJ"))
]).then(()=>parcelRequire('8K38r'));

});

parcelRegister("iHefQ", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("f7SVq")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("grAbA")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("8AAEq"))
]).then(()=>parcelRequire('i2xet'));

});

parcelRegister("f9TqQ", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("agGGW")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("f7SVq")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("grAbA")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("8TVxa"))
]).then(()=>parcelRequire('dlLII'));

});

parcelRegister("7doeZ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("8NPbe")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("lkOUq"))
]).then(()=>parcelRequire('ckmCx'));

});

parcelRegister("BK9e4", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("agGGW")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("3Y0YN"))
]).then(()=>parcelRequire('3vEOh'));

});

parcelRegister("cxM5C", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("lUTn9")).then(()=>parcelRequire('gDyyo'));

});

parcelRegister("1AiSC", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("3UJH3")).then(()=>parcelRequire('cJCLn'));

});

parcelRegister("1hgxS", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("6xguF")).then(()=>parcelRequire('18chP'));

});

parcelRegister("9U307", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("6lSHy")).then(()=>parcelRequire('kSHTn'));

});

parcelRegister("jj6uj", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("knNbb")).then(()=>parcelRequire('9ZUJm'));

});

parcelRegister("9TtX1", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("4bz2D")).then(()=>parcelRequire('5y56S'));

});

parcelRegister("f5VlY", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("03IvR")).then(()=>parcelRequire('cnnNv'));

});

parcelRegister("bxNSr", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("alN9y")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("1PclR")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("8NPbe")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("aZY3H")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("iUMj0"))
]).then(()=>parcelRequire('4jAAn'));

});

parcelRegister("3OcYn", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("aZY3H")),
    (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("1S2Aa"))
]).then(()=>parcelRequire('l5UaI'));

});

parcelRegister("h4v4M", function(module, exports) {

$parcel$export(module.exports, "useNavigateSoftOrHard", function () { return $57c79436ab18f1cf$export$51346bfefbea0096; });

var $dNMDr = parcelRequire("dNMDr");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $9sFLW = parcelRequire("9sFLW");

var $lUetB = parcelRequire("lUetB");
const $57c79436ab18f1cf$var$isToExternalHost = (to)=>{
    try {
        const url = new URL(to);
        return url.hostname !== window.location.hostname;
    } catch (e) {
        // "to" can also validly be a path without a hostname
        return false;
    }
};
// react-router breaks if it is provided with domain information (e.g. https://id.atlassian.com:443)
// so we need to remove it
const $57c79436ab18f1cf$var$removeDomainInformation = (to)=>{
    let pathname;
    try {
        const url = new URL(to);
        pathname = url.pathname + url.search + url.hash;
    } catch (e) {
        // "to" can also validly be a path without a hostname
        pathname = to;
    }
    return pathname;
};
// this is needed because the parameters of Partial<Path> are a subset of URL, but if we
// pass a URL to react-router's navigate function, it may break.
const $57c79436ab18f1cf$var$stringifyIfUrl = (to)=>{
    if (to instanceof URL) return to.toString();
    return to;
};
const $57c79436ab18f1cf$export$51346bfefbea0096 = ()=>{
    const softNavigate = (0, $cVnBY.useNavigate)();
    return (0, $dNMDr.useCallback)((to, options)=>{
        const destination = $57c79436ab18f1cf$var$stringifyIfUrl(to);
        if (typeof destination === 'number') return softNavigate(destination);
        if (typeof destination !== 'string') // destination is a Partial<Path>
        return softNavigate(destination, options);
        if (options) return softNavigate(destination, options);
        if ($57c79436ab18f1cf$var$isToExternalHost(destination)) return window.location.assign(destination);
        const pathname = $57c79436ab18f1cf$var$removeDomainInformation(destination);
        // if the pathname matches the frontend App router then we can soft navigate
        const routeMatches = (0, $9sFLW.matchRoutes)((0, $lUetB.router).routes, pathname);
        if (routeMatches && routeMatches.length > 0) return softNavigate(pathname);
        return window.location.assign(destination);
    }, [
        softNavigate
    ]);
};

});
parcelRegister("lUetB", function(module, exports) {

$parcel$export(module.exports, "router", function () { return $9b95e63dc9052845$export$5375cda95f0b0eb4; });

var $6CtE1 = parcelRequire("6CtE1");


var $9xnDg = parcelRequire("9xnDg");

var $dNMDr = parcelRequire("dNMDr");

var $cpaps = parcelRequire("cpaps");

var $ko1o6 = parcelRequire("ko1o6");

var $lwrli = parcelRequire("lwrli");parcelRequire("cVnBY");
var $9sFLW = parcelRequire("9sFLW");
var $cVnBY = parcelRequire("cVnBY");

var $4s8Fj = parcelRequire("4s8Fj");

var $aMBBA = parcelRequire("aMBBA");

var $2eVHl = parcelRequire("2eVHl");

var $4SKFz = parcelRequire("4SKFz");

var $gLZcX = parcelRequire("gLZcX");

var $hTMPL = parcelRequire("hTMPL");

var $hhYxc = parcelRequire("hhYxc");

var $9LF2L = parcelRequire("9LF2L");

var $4ljBU = parcelRequire("4ljBU");

var $bzQ2t = parcelRequire("bzQ2t");

var $ei3NI = parcelRequire("ei3NI");

var $493Hj = parcelRequire("493Hj");

var $aFaYc = parcelRequire("aFaYc");

var $3Q4FK = parcelRequire("3Q4FK");
parcelRequire("9mgZH");
var $9UUcJ = parcelRequire("9UUcJ");

var $j31XW = parcelRequire("j31XW");

var $4NPio = parcelRequire("4NPio");

var $5vEwV = parcelRequire("5vEwV");

var $7zuqn = parcelRequire("7zuqn");

var $fQs0N = parcelRequire("fQs0N");

var $1OnM8 = parcelRequire("1OnM8");

var $k9mWX = parcelRequire("k9mWX");

var $kabQ0 = parcelRequire("kabQ0");

var $ganXz = parcelRequire("ganXz");

var $eX172 = parcelRequire("eX172");

var $5WYPj = parcelRequire("5WYPj");

var $lChtt = parcelRequire("lChtt");

var $jXtDs = parcelRequire("jXtDs");

var $humZM = parcelRequire("humZM");

var $jqdEu = parcelRequire("jqdEu");

var $5oaMR = parcelRequire("5oaMR");

var $cTHs9 = parcelRequire("cTHs9");

var $dWvY5 = parcelRequire("dWvY5");

var $hADis = parcelRequire("hADis");

var $f3CY8 = parcelRequire("f3CY8");

var $gbv4C = parcelRequire("gbv4C");

var $eho9X = parcelRequire("eho9X");

var $7aPz9 = parcelRequire("7aPz9");

var $4V2aG = parcelRequire("4V2aG");

var $6CVdn = parcelRequire("6CVdn");

var $jBZ5L = parcelRequire("jBZ5L");

var $jvWWI = parcelRequire("jvWWI");

var $84ZjZ = parcelRequire("84ZjZ");

var $cBB3b = parcelRequire("cBB3b");
parcelRequire("ch0QI");

var $2q0hh = parcelRequire("2q0hh");

var $go9mp = parcelRequire("go9mp");
function $9b95e63dc9052845$export$86fbec116b87613f() {
    (0, $dNMDr.useLayoutEffect)(()=>{
        (0, $9xnDg.default)({
            colorMode: 'light',
            typography: 'typography'
        });
    }, []);
    (0, $4ljBU.useGlobalPageState)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const defaultTitle = formatMessage((0, $4SKFz.default).headTitle);
    const microbranding = (0, $aMBBA.useAppSelector)((state)=>state.microbranding);
    const cobranding = (0, $aMBBA.useAppSelector)((state)=>state.cobranding);
    const dynamicConfigs = (0, $ei3NI.useDynamicConfigs)();
    const isGlobalStateLoading = (0, $aMBBA.useAppSelector)((state)=>state.globalStateLoading);
    if (isGlobalStateLoading) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $493Hj.FullScreenSpinnerWrapper), {
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $493Hj.LoadingSpinner), {
            testId: "global-state-loading-spinner"
        })
    });
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $j31XW.default), {
        analyticsClient: analyticsClient,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $aFaYc.default), {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3Q4FK.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $9UUcJ.BrowserMetricsBoundary), {
                    children: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $dNMDr.Suspense), {
                        fallback: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $493Hj.LoadingSpinner), {
                            testId: "suspense-loading-spinner"
                        }),
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                                defaultTitle: defaultTitle,
                                titleTemplate: `%s - ${defaultTitle}`
                            }, "helmet"),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $9LF2L.default), {}),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2eVHl.CobrandingProvider), {
                                value: {
                                    cobranding: (0, $2eVHl.getCurrentCobranding)(cobranding, dynamicConfigs, analyticsClient),
                                    isMobileApp: microbranding.isMobileApp
                                },
                                children: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $4s8Fj.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cVnBY.Outlet), {}),
                                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gLZcX.default), {}),
                                        false
                                    ]
                                }, "screenSizeListener")
                            })
                        ]
                    })
                })
            })
        })
    });
}
/**
 * Temporary loader to handle edge cases for paths that always redirect to a different path.
 * Currently SIS returns the redirects to the different path.
 * In the future these will be removed when idproxy directs traffic directly to SIS (as opposed to id-frontend first)
 * to return a redirect to those paths.
 */ const $9b95e63dc9052845$var$temporaryRedirectLoader = async ({ request: request })=>{
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchFast5GlobalPageState)(request.url);
};
const $9b95e63dc9052845$export$5375cda95f0b0eb4 = (0, $lwrli.createBrowserRouter)([
    {
        element: /*#__PURE__*/ (0, $6CtE1.jsx)($9b95e63dc9052845$export$86fbec116b87613f, {}),
        errorElement: /*#__PURE__*/ (0, $6CtE1.jsx)($9b95e63dc9052845$var$RouterErrorElement, {}),
        children: (0, $bzQ2t.wrapRoutesWithPageStateReduxSyncer)([
            {
                path: '/2step',
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.MfaAppsPage), {})
                    },
                    {
                        path: 'enrollment',
                        children: [
                            {
                                index: true,
                                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.MfaEnrollmentPage), {})
                            },
                            {
                                path: '1-get-app',
                                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.ChooseMethodPage), {})
                            },
                            {
                                path: '2-configure-app',
                                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.ConfigureAppPage), {})
                            },
                            {
                                path: '2-configure-phone',
                                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.ConfigurePhonePage), {})
                            },
                            {
                                path: '2-register-security-key',
                                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.RegisterSecurityKeyPage), {})
                            },
                            {
                                path: '3-connect-phone',
                                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.ConfigureAppPage), {
                                    isConnectPhone: true
                                })
                            },
                            {
                                path: '4-save-recovery-key',
                                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.SaveRecoveryKeyPage), {})
                            },
                            {
                                path: 'add',
                                // These pages are for enrolling multiple methods of MFA
                                // for now these are dummy pages, and is subject to move (path, content, and/or location)
                                children: [
                                    {
                                        path: 'security-key',
                                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.MultiMfaEnrollmentAddSecurityKeyPage), {})
                                    },
                                    {
                                        path: 'authenticator',
                                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.MultiMfaEnrollmentAddAuthenticatorPage), {})
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'recover',
                        children: [
                            {
                                index: true,
                                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.RecoveryPage), {}),
                                loader: (0, $k9mWX.recoverLoader)
                            },
                            {
                                path: 'expired',
                                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.MultiFactorPage), {
                                    isExpired: true
                                }),
                                loader: (0, $eX172.recoverExpiredLoader)
                            }
                        ]
                    }
                ]
            },
            {
                path: '/error',
                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.AuthCallbackErrorPage), {})
            },
            {
                path: '/login',
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.LoginPage), {}),
                        loader: (0, $7zuqn.loginLoader)
                    },
                    {
                        path: 'cancel-account-deletion',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.CancelAccountDeletionPage), {}),
                        loader: (0, $1OnM8.cancelAccountDeletionLoader)
                    },
                    {
                        path: 'changepassword',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.ChangePasswordPage), {}),
                        loader: (0, $humZM.changePasswordLoader)
                    },
                    {
                        path: 'changepassword/p/*',
                        // Used for deeplinking for auth on the mobile apps
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.ChangePasswordPage), {}),
                        loader: (0, $humZM.changePasswordLoader)
                    },
                    {
                        path: 'consent',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.LoginConsentNoticePage), {}),
                        loader: (0, $5oaMR.consentLoader)
                    },
                    {
                        path: 'continue-as',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.ContinueAsPage), {}),
                        loader: (0, $jqdEu.continueAsLoader)
                    },
                    {
                        path: 'deletion-request-confirmation',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.DeletionRequestConfirmationPage), {})
                    },
                    {
                        path: 'inactive',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.InactiveAccountPage), {})
                    },
                    {
                        path: 'mfa',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.MultiFactorPage), {
                            isExpired: false
                        }),
                        loader: (0, $eX172.mfaLoader)
                    },
                    {
                        path: 'pending-deletion',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.PendingDeletionPage), {})
                    },
                    {
                        path: 'remove-account',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.RemoveAccountPage), {}),
                        loader: (0, $gbv4C.removeAccountLoader)
                    },
                    {
                        path: 'resetexpiredpassword',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.ExpiredPasswordPage), {}),
                        loader: (0, $7aPz9.resetExpiredPasswordLoader)
                    },
                    {
                        path: 'resetpassword',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.ResetPasswordPage), {})
                    },
                    {
                        path: 'select-account',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.SelectAccountPage), {}),
                        loader: (0, $cTHs9.selectAccountLoader)
                    },
                    {
                        path: 'security-screen',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.MfaPromotePage), {}),
                        loader: (0, $f3CY8.securityScreenLoader)
                    },
                    {
                        path: 'social/confirmation',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.CreateAccountConfirmationPage), {}),
                        loader: (0, $eho9X.socialConfirmationLoader)
                    }
                ]
            },
            {
                path: '/logout',
                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.LogoutPage), {}),
                loader: (0, $ganXz.logoutLoader)
            },
            {
                path: '/mf',
                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.MultiFactorPage), {
                    isExpired: false
                })
            },
            {
                path: '/security',
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2q0hh.NavigateToLogin), {})
                    },
                    {
                        // KIRBY-7724: This endpoint doesn't render anything,
                        // but we need to call the backend to get a redirect.
                        // This will be replaced with logic in idproxy to handle the redirect of requests to this path
                        // directly to SIS (to immediately return the redirect result) instead of id-frontend as it's being handled now.
                        path: 'auth-alert-action',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $bzQ2t.PageStateReduxSyncer), {}),
                        loader: $9b95e63dc9052845$var$temporaryRedirectLoader
                    },
                    {
                        path: 'expiredlink',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.SecurityExpiredLinkPage), {})
                    },
                    {
                        path: 'successfulreset',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.SecuritySuccessPage), {
                            successType: "password-reset"
                        })
                    },
                    {
                        path: 'successfulverification',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.SecuritySuccessPage), {
                            successType: "verification"
                        })
                    },
                    {
                        path: 'dagterminal',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.OAuthDAGTerminalPage), {})
                    }
                ]
            },
            {
                path: '/signup',
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)($9b95e63dc9052845$var$SignupCommercial, {}),
                        loader: (0, $fQs0N.signupLoader)
                    },
                    {
                        path: 'onboard',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)($9b95e63dc9052845$var$SignupOnboardCommercial, {})
                    },
                    {
                        // KIRBY-7259: SIS redirects /signup/invite/* to /signup/welcome/*
                        // This is a temporary fix to handle the redirect for SAS Fast5
                        // This will be replaced with logic in idproxy to handle the redirect of requests to this path
                        // directly to SIS (to immediately return the redirect result) instead of id-frontend as it's being handled now.
                        path: 'invite/*',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $bzQ2t.PageStateReduxSyncer), {}),
                        loader: $9b95e63dc9052845$var$temporaryRedirectLoader
                    },
                    {
                        path: 'migrate-confirmation',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.MigrateAccountConfirmationPage), {}),
                        loader: (0, $4V2aG.migrateConfirmationLoader)
                    },
                    {
                        path: 'welcome',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.WelcomePage), {}),
                        loader: (0, $jBZ5L.welcomeLoader)
                    },
                    /**
     * The standalone `/welcome/p/loom-create-workspace` page is a step in Loom's signup
     * flow where an existing Atlassian user creates a Loom workspace when creating a new Loom account.
     * In the more common Loom signup flow path where a user is new to Atlassian and Loom,
     * the workspace creation step is shown on the `/welcome` route after a user fills in their name and password.
     * If a user is new to Loom but already exists in Atlassian, this step needs to be hosted
     * on its own page since the login flow requires a redirect.
     *
     * This page will be moved to be hosted on Loom and removed from IDAC once Loom has integrated
     * with Atlassian Identity and can make authenticated requests via Edge Authenticator.
     * See epic: https://useloom.atlassian.net/browse/ID-256
     */ {
                        path: 'welcome/p/loom-create-workspace',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.AuthenticatedLoomWorkspaceCreationPage), {})
                    },
                    {
                        path: 'welcome/p/*',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.WelcomePage), {}),
                        loader: (0, $jBZ5L.welcomeLoader)
                    },
                    // Used for deeplinking for auth on the mobile apps
                    {
                        path: 'welcome/sent',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.WelcomeSentPage), {}),
                        loader: (0, $jvWWI.welcomeSentLoader)
                    },
                    {
                        path: 'verify-email/otp',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $go9mp.MaybeComponentOrRedirectToLogin), {
                            component: (0, $hTMPL.VerifyEmailOtpPage),
                            condition: ()=>(0, $hhYxc.getCurrentCloudType)() === 'commercial'
                        }),
                        loader: (0, $6CVdn.signupVerifyEmailOtpLoader)
                    }
                ]
            },
            {
                path: '/social/recovery',
                element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.SocialLoginRecoveryPage), {}),
                loader: (0, $kabQ0.socialRecoveryLoader)
            },
            {
                path: '/step-up',
                children: [
                    {
                        path: 'start',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.StepUpStartPage), {}),
                        loader: (0, $lChtt.stepUpStartLoader)
                    },
                    {
                        path: 'sso',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.StepUpSsoPage), {}),
                        loader: (0, $jXtDs.stepUpSsoLoader)
                    }
                ]
            },
            {
                path: '/verify-email/*',
                children: [
                    {
                        path: 'change-email',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.EmailConfirmationPage), {}),
                        loader: (0, $5WYPj.changeEmailLoader)
                    },
                    {
                        path: 'sent',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.VerifyOrReverifyEmailSentPage), {}),
                        loader: (0, $hADis.verifyEmailSentLoader)
                    },
                    {
                        path: '*',
                        element: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.VerifyOrReverifyEmailErrorPage), {}),
                        loader: (0, $dWvY5.verifyEmailLoader)
                    }
                ]
            }
        ])
    }
], {
    future: (0, $5vEwV.reactRouterFutureFlags)
});
function $9b95e63dc9052845$var$SignupCommercial() {
    if ((0, $hhYxc.getCurrentCloudType)() === 'commercial') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.SignupPage), {});
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2q0hh.NavigateToLogin), {});
}
function $9b95e63dc9052845$var$SignupOnboardCommercial() {
    if ((0, $hhYxc.getCurrentCloudType)() === 'commercial') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hTMPL.SignupOnboardPage), {});
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2q0hh.NavigateToLogin), {});
}
function $9b95e63dc9052845$var$RouterErrorElement() {
    const error = (0, $cVnBY.useRouteError)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    if ((0, $9sFLW.isRouteErrorResponse)(error) && error.status === 404) {
        analyticsClient.trackingEvent({
            page: 'RouterErrorElement',
            action: 'error',
            subject: 'routeNotFound'
        });
        return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2q0hh.NavigateToLogin), {});
    }
    // rethrow to let the parent error boundary handle it
    throw error;
}

});
parcelRegister("4s8Fj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1d85de03813309c$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $fbSBq = parcelRequire("fbSBq");

var $dNMDr = parcelRequire("dNMDr");
parcelRequire("a09DY");
var $36uoy = parcelRequire("36uoy");

var $j0VD5 = parcelRequire("j0VD5");

var $fKKTy = parcelRequire("fKKTy");
const $f1d85de03813309c$var$FullHeightContainer = (0, $fbSBq.default).div`
  height: 100%;
`;
const $f1d85de03813309c$var$DeviceTypeListener = ({ dispatch: dispatch, children: children })=>{
    (0, $dNMDr.useEffect)(()=>{
        if (!(0, $j0VD5.screenSizeMatcher)) return;
        const onScreenSizeUpdated = ({ matches: matches })=>{
            dispatch((0, $fKKTy.screenSizeUpdated)(matches ? 'mobile' : 'desktop'));
        };
        try {
            /**
       * Improved API but supported by only ~94.2% of browsers
       * https://caniuse.com/mdn-api_mediaquerylist_change_event
       */ (0, $j0VD5.screenSizeMatcher).addEventListener('change', onScreenSizeUpdated);
            return ()=>(0, $j0VD5.screenSizeMatcher).removeEventListener('change', onScreenSizeUpdated);
        } catch (e) {
            /**
       * These methods are deprecated but needed as fallbacks for browsers older than:
       * - Edge 79 (released 2020-01)
       * - Safari 14 (released 2020-09)
       * - Safari on iOS 14 (released 2020-09)
       *
       * All other browsers have had support since 2014-2017.
       * https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/change_event
       */ (0, $j0VD5.screenSizeMatcher).addListener(onScreenSizeUpdated);
            return ()=>(0, $j0VD5.screenSizeMatcher).removeListener(onScreenSizeUpdated);
        }
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)($f1d85de03813309c$var$FullHeightContainer, {
        children: children
    });
};
var $f1d85de03813309c$export$2e2bcd8739ae039 = (0, $36uoy.default)()($f1d85de03813309c$var$DeviceTypeListener);

});
parcelRegister("fKKTy", function(module, exports) {

$parcel$export(module.exports, "screenSizeUpdated", function () { return $a6cdb0c52d59451d$export$92b52f782097f1e7; });
const $a6cdb0c52d59451d$export$92b52f782097f1e7 = (screenSize)=>({
        type: 'SCREEN_SIZE_UPDATED',
        screenSize: screenSize
    });

});


parcelRegister("4SKFz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9137a50d587a26e6$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $9137a50d587a26e6$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    headTitle: {
        id: 'default.head.title',
        defaultMessage: 'Log in with Atlassian account'
    }
});

});

parcelRegister("gLZcX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f869fa8192d1005a$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $6hTL4 = parcelRequire("6hTL4");
var $k3Lhn = parcelRequire("k3Lhn");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $dWJmc = parcelRequire("dWJmc");

var $8qQ4w = parcelRequire("8qQ4w");

var $ko1o6 = parcelRequire("ko1o6");

var $7lC8o = parcelRequire("7lC8o");

var $aMBBA = parcelRequire("aMBBA");
// We need to wrap the flag in a div to apply responsive styles so
// the flag are always visible on smaller viewports.
const $f869fa8192d1005a$var$ResponsiveFlagWrapper = (0, $fbSBq.default).div`
  [role='alert'] {
    max-width: calc(100vw - ${(0, $68HQw.gridSize)() * 11}px);
  }
`;
const $f869fa8192d1005a$export$1fe549a730923236 = ()=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const flags = (0, $aMBBA.useAppSelector)((state)=>state.flags.flags);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const toFlagComponent = (flag)=>{
        const icon = flag.type === 'success' ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dWJmc))), {
            label: "Success",
            primaryColor: (0, $l4KzN).G300
        }) : /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8qQ4w))), {
            label: "Error",
            primaryColor: (0, $l4KzN).R300
        });
        return /*#__PURE__*/ (0, $6CtE1.jsx)($f869fa8192d1005a$var$ResponsiveFlagWrapper, {
            id: flag.id,
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6hTL4.default), {
                id: flag.id || '',
                title: formatMessage(flag.title),
                description: formatMessage(flag.description),
                icon: icon,
                onDismissed: ()=>dispatch((0, $7lC8o.dismissFlag)())
            })
        }, flag.id);
    };
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $k3Lhn.default), {
        children: flags.map(toFlagComponent)
    });
};
var $f869fa8192d1005a$export$2e2bcd8739ae039 = $f869fa8192d1005a$export$1fe549a730923236;

});
parcelRegister("6hTL4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $493f950af233b255$export$2e2bcd8739ae039; });
/* flag.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $91FVG = parcelRequire("91FVG");

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
var $9vljA = parcelRequire("9vljA");

var $02D9g = parcelRequire("02D9g");

var $kugzw = parcelRequire("kugzw");

var $c3KQG = parcelRequire("c3KQG");

var $dWOVN = parcelRequire("dWOVN");

var $gQLDR = parcelRequire("gQLDR");

var $l69Tm = parcelRequire("l69Tm");
var $eS3uG = parcelRequire("eS3uG");
var $3FKQn = parcelRequire("3FKQn");

var $iRhvt = parcelRequire("iRhvt");

var $jtXIO = parcelRequire("jtXIO");

var $3vUjM = parcelRequire("3vUjM");

var $k3Lhn = parcelRequire("k3Lhn");

var $9Jn9G = parcelRequire("9Jn9G");
var $jp3LP = parcelRequire("jp3LP");

var $cxfJ7 = parcelRequire("cxfJ7");
function $493f950af233b255$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $493f950af233b255$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $493f950af233b255$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $493f950af233b255$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $493f950af233b255$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs8sq4 _1pbyni7l _1bsb1osq",
    flagT26Shape: "_2rko1mok"
};
var $493f950af233b255$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
var $493f950af233b255$var$descriptionStyles = null;
var $493f950af233b255$var$iconWrapperStyles = null;
var $493f950af233b255$var$flagWrapperStyles = null;
var $493f950af233b255$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "@atlaskit/flag",
    packageVersion: "17.8.6"
};
var $493f950af233b255$var$transitionStyles = null;
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $493f950af233b255$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $jtXIO.DEFAULT_APPEARANCE) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $c3KQG.default) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $c3KQG.default) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $c3KQG.default) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $dNMDr.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $k3Lhn.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $dNMDr.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $dNMDr.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $02D9g.usePlatformLeafEventHandler)($493f950af233b255$var$_objectSpread({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext
    }, $493f950af233b255$var$analyticsAttributes));
    var isBold = appearance !== (0, $jtXIO.DEFAULT_APPEARANCE);
    var toggleExpand = (0, $dNMDr.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $dNMDr.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $dNMDr.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $dNMDr.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $02D9g.usePlatformLeafEventHandler)($493f950af233b255$var$_objectSpread({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext
    }, $493f950af233b255$var$analyticsAttributes));
    var onBlurAnalytics = (0, $02D9g.usePlatformLeafEventHandler)($493f950af233b255$var$_objectSpread({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext
    }, $493f950af233b255$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $cxfJ7.flagTextColor)[appearance];
    var iconColor = (0, $cxfJ7.flagIconColor)[appearance];
    var iconGlyph = (0, $cxfJ7.flagIconGlyph)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ $dNMDr.createElement((0, $iRhvt.default), null, title, description) : undefined;
    return /*#__PURE__*/ $dNMDr.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        role: "alert",
        "data-testid": testId
    }, autoDismissProps, {
        className: (0, $affTb.default)([
            "_1bsb1osq"
        ])
    }), /*#__PURE__*/ $dNMDr.createElement((0, $l69Tm.default), {
        padding: "space.200",
        backgroundColor: (0, $cxfJ7.flagBackgroundColor)[appearance],
        xcss: (0, $kugzw.cx)($493f950af233b255$var$styles.flag, (0, $gQLDR.fg)('platform-dst-shape-theme-default') && $493f950af233b255$var$styles.flagT26Shape)
    }, /*#__PURE__*/ $dNMDr.createElement((0, $eS3uG.default), {
        alignBlock: "start",
        space: "space.200"
    }, /*#__PURE__*/ $dNMDr.createElement("div", {
        "data-testid": testId && "".concat(testId, "-icon-container"),
        className: (0, $affTb.default)([
            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz16r9"
        ]),
        style: $493f950af233b255$var$_objectSpread($493f950af233b255$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, $493f950af233b255$var$CSS_VAR_ICON_COLOR, iconColor)), {}, {
            "--_11v68d2": (0, $9vljA.default)("var(".concat($493f950af233b255$var$CSS_VAR_ICON_COLOR, ")"))
        })
    }, icon || iconGlyph), /*#__PURE__*/ $dNMDr.createElement("span", {
        className: (0, $affTb.default)([
            "_v5641hdc _16jlkb7n"
        ])
    }, /*#__PURE__*/ $dNMDr.createElement((0, $3FKQn.default), {
        space: shouldRenderGap ? 'space.100' : 'space.0' // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, isDelayToAnnounce && delayedAnnouncement, /*#__PURE__*/ $dNMDr.createElement((0, $eS3uG.default), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ $dNMDr.createElement((0, $l69Tm.default), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $493f950af233b255$var$styles.overflowWrap
    }, /*#__PURE__*/ $dNMDr.createElement((0, $dWOVN.default), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, /*#__PURE__*/ $dNMDr.createElement("span", {
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce
    }, title))), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ $dNMDr.createElement((0, $9Jn9G.default), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ $dNMDr.createElement((0, $jp3LP.default), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ $dNMDr.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $cxfJ7.flagTextColorToken)[appearance]
        },
        "data-testid": testId && "".concat(testId, "-description"),
        "aria-hidden": isDelayToAnnounce,
        className: (0, $affTb.default)([
            "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
        ])
    }, description), /*#__PURE__*/ $dNMDr.createElement((0, $3vUjM.default), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $493f950af233b255$export$2e2bcd8739ae039 = $493f950af233b255$var$Flag;

});
parcelRegister("jtXIO", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_APPEARANCE", function () { return $e2ef0d3c69e602aa$export$d6830277b06edd6; });
var $e2ef0d3c69e602aa$export$d6830277b06edd6 = 'normal';

});

parcelRegister("3vUjM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28eff3ea59b020be$export$2e2bcd8739ae039; });
/* flag-actions.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $aQTlX = parcelRequire("aQTlX");

var $eS3uG = parcelRequire("eS3uG");

var $jtXIO = parcelRequire("jtXIO");

var $cxfJ7 = parcelRequire("cxfJ7");
var $28eff3ea59b020be$var$buttonStyles = null;
var $28eff3ea59b020be$var$fontStyles = null;
var $28eff3ea59b020be$var$appearanceNormalButtonStyles = null;
var $28eff3ea59b020be$var$appearanceNormalActionsContainerStyles = null;
var $28eff3ea59b020be$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $jtXIO.DEFAULT_APPEARANCE) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $jtXIO.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        className: (0, $affTb.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ])
    }, /*#__PURE__*/ $dNMDr.createElement((0, $eS3uG.default), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        return /*#__PURE__*/ $dNMDr.createElement((0, $aQTlX.default), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                '--color': (0, $cxfJ7.actionTextColor)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color': (0, $cxfJ7.actionBackgroundColor)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-hover': (0, $cxfJ7.actionBackgroundColor)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-active': (0, $cxfJ7.actionBackgroundColor)[appearance].active
            },
            className: (0, $affTb.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                appearance === (0, $jtXIO.DEFAULT_APPEARANCE) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ])
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$28eff3ea59b020be$export$2e2bcd8739ae039 = $28eff3ea59b020be$var$FlagActions;

});
parcelRegister("aQTlX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e69b2b012c9781d$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $82V4i = parcelRequire("82V4i");

var $91FVG = parcelRequire("91FVG");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $fMw77 = parcelRequire("fMw77");

var $gQMs5 = parcelRequire("gQMs5");

var $iqYCZ = parcelRequire("iqYCZ");

var $6gA4U = parcelRequire("6gA4U");

var $jhtQ6 = parcelRequire("jhtQ6");
var $7e69b2b012c9781d$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $7e69b2b012c9781d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7e69b2b012c9781d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7e69b2b012c9781d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7e69b2b012c9781d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7e69b2b012c9781d$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
var $7e69b2b012c9781d$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $7e69b2b012c9781d$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $jhtQ6.defaultThemeFn) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref2, $7e69b2b012c9781d$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $7e69b2b012c9781d$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $dNMDr.useState)($7e69b2b012c9781d$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $dNMDr.useCallback)(function(event) {
        setState(function(current) {
            return $7e69b2b012c9781d$var$_objectSpread($7e69b2b012c9781d$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $dNMDr.useCallback)(function(event) {
        setState(function(current) {
            return $7e69b2b012c9781d$var$_objectSpread($7e69b2b012c9781d$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $dNMDr.useCallback)(function(event) {
        setState(function(current) {
            return $7e69b2b012c9781d$var$_objectSpread($7e69b2b012c9781d$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $dNMDr.useCallback)(function(event) {
        setState(function(current) {
            return $7e69b2b012c9781d$var$_objectSpread($7e69b2b012c9781d$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $dNMDr.useCallback)(function(event) {
        setState(function(current) {
            return $7e69b2b012c9781d$var$_objectSpread($7e69b2b012c9781d$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $dNMDr.useCallback)(function(event) {
        setState(function(current) {
            return $7e69b2b012c9781d$var$_objectSpread($7e69b2b012c9781d$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $jhtQ6.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fMw77.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $jhtQ6.default).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
            mode: mode,
            state: $7e69b2b012c9781d$var$getInteractionState($7e69b2b012c9781d$var$_objectSpread($7e69b2b012c9781d$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $iqYCZ.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $gQMs5.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $6gA4U.default), restProps) : null,
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $jhtQ6.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$7e69b2b012c9781d$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $7e69b2b012c9781d$export$2e2bcd8739ae039 = $7e69b2b012c9781d$var$CustomThemeButton;

});
parcelRegister("fMw77", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7d43fd641b7b65a$export$2e2bcd8739ae039; });

var $7z7KZ = parcelRequire("7z7KZ");
// Create default global light theme
var $b7d43fd641b7b65a$var$dest = (0, $7z7KZ.createTheme)(function() {
    return {
        mode: 'light'
    };
});
var $b7d43fd641b7b65a$var$Provider = $b7d43fd641b7b65a$var$dest.Provider;
var $b7d43fd641b7b65a$var$Consumer = $b7d43fd641b7b65a$var$dest.Consumer;
var $b7d43fd641b7b65a$export$7692396083754928 = $b7d43fd641b7b65a$var$dest.useTheme;
var $b7d43fd641b7b65a$var$Theme = {
    Provider: $b7d43fd641b7b65a$var$Provider,
    Consumer: $b7d43fd641b7b65a$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b7d43fd641b7b65a$export$2e2bcd8739ae039 = $b7d43fd641b7b65a$var$Theme;

});
parcelRegister("7z7KZ", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $5821d19f5c75058c$export$25d302a5b900a763; });

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");
var $5821d19f5c75058c$var$_excluded = [
    "children"
];
function $5821d19f5c75058c$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $dNMDr.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $dNMDr.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(props, $5821d19f5c75058c$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $dNMDr.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $dNMDr.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("gQMs5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c447163916b8577f$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $8Govx = parcelRequire("8Govx");

var $02D9g = parcelRequire("02D9g");

var $c3KQG = parcelRequire("c3KQG");

var $lm7lB = parcelRequire("lm7lB");

var $lhlCM = parcelRequire("lhlCM");

var $hMip0 = parcelRequire("hMip0");

var $2Mjap = parcelRequire("2Mjap");

var $epioT = parcelRequire("epioT");

var $fCAFh = parcelRequire("fCAFh");

var $68DLO = parcelRequire("68DLO");
var $c447163916b8577f$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $c447163916b8577f$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $c447163916b8577f$var$iconBeforeSpacingFixStyle = (0, $8Govx.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $c447163916b8577f$var$iconAfterSpacingFixStyle = (0, $8Govx.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $c447163916b8577f$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $68DLO.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $c447163916b8577f$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $68DLO.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $8Govx.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $c447163916b8577f$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $c3KQG.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $c3KQG.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(props, $c447163916b8577f$var$_excluded);
    var ourRef = (0, $dNMDr.useRef)();
    var setRef = (0, $dNMDr.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $lm7lB.default)(ourRef, autoFocus);
    var interactionContext = (0, $dNMDr.useContext)((0, $hMip0.default));
    var handleClick = (0, $dNMDr.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $02D9g.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $dNMDr.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $dNMDr.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $8Govx.css)((0, $fCAFh.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $2Mjap.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $2Mjap.N500), ")"), " !important")
        }
    };
    return (0, $8Govx.jsx)((0, $lhlCM.default), null, (0, $8Govx.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $c447163916b8577f$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $epioT.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $8Govx.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $fCAFh.getIconStyle)({
                spacing: spacing
            }),
            $c447163916b8577f$var$getSpacingFix(children, $c447163916b8577f$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $c447163916b8577f$var$getChildren(children, [
        fadeStyles,
        (0, $fCAFh.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $8Govx.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $fCAFh.getIconStyle)({
                spacing: spacing
            }),
            $c447163916b8577f$var$getSpacingFix(children, $c447163916b8577f$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $8Govx.jsx)("span", {
        css: [
            (0, $fCAFh.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c447163916b8577f$export$2e2bcd8739ae039 = $c447163916b8577f$var$ButtonBase;

});
parcelRegister("lhlCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7dbf5aa318732fa$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $8Govx = parcelRequire("8Govx");
var $f7dbf5aa318732fa$var$BORDER_WIDTH = 2;
var $f7dbf5aa318732fa$var$baseFocusOutsideStyles = (0, $8Govx.css)({
    outline: "var(--ds-border-width-focused, 2px)".concat(" solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $f7dbf5aa318732fa$var$BORDER_WIDTH
});
var $f7dbf5aa318732fa$var$baseInsetStyles = (0, $8Govx.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$f7dbf5aa318732fa$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
var $f7dbf5aa318732fa$var$focusRingStyles = (0, $8Govx.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $f7dbf5aa318732fa$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $f7dbf5aa318732fa$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid")
        }
    }
});
var $f7dbf5aa318732fa$var$insetFocusRingStyles = (0, $8Govx.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $f7dbf5aa318732fa$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $f7dbf5aa318732fa$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid"),
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $f7dbf5aa318732fa$var$FocusRing = /*#__PURE__*/ (0, $dNMDr.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $f7dbf5aa318732fa$var$baseInsetStyles : $f7dbf5aa318732fa$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $f7dbf5aa318732fa$var$insetFocusRingStyles : $f7dbf5aa318732fa$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $8Govx.jsx)((0, $8Govx.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $dNMDr.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $dNMDr.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$f7dbf5aa318732fa$var$FocusRing.displayName = 'FocusRing';
var $f7dbf5aa318732fa$export$2e2bcd8739ae039 = $f7dbf5aa318732fa$var$FocusRing;

});

parcelRegister("epioT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7d1ac775d982986$export$2e2bcd8739ae039; });
function $a7d1ac775d982986$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $a7d1ac775d982986$var$tabKeyCode = 9;
function $a7d1ac775d982986$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $a7d1ac775d982986$var$tabKeyCode) return;
    $a7d1ac775d982986$var$abort(event);
}
var $a7d1ac775d982986$var$block = {
    onMouseDownCapture: $a7d1ac775d982986$var$abort,
    onMouseUpCapture: $a7d1ac775d982986$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $a7d1ac775d982986$var$onKey,
    onKeyUpCapture: $a7d1ac775d982986$var$onKey,
    onTouchStartCapture: $a7d1ac775d982986$var$abort,
    onTouchEndCapture: $a7d1ac775d982986$var$abort,
    onPointerDownCapture: $a7d1ac775d982986$var$abort,
    onPointerUpCapture: $a7d1ac775d982986$var$abort,
    onClickCapture: $a7d1ac775d982986$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $a7d1ac775d982986$var$abort
};
var $a7d1ac775d982986$var$doNotBlock = {};
function $a7d1ac775d982986$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $a7d1ac775d982986$var$doNotBlock : $a7d1ac775d982986$var$block;
}

});

parcelRegister("fCAFh", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $b5f6d880857b42f4$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $b5f6d880857b42f4$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $b5f6d880857b42f4$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $b5f6d880857b42f4$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $b5f6d880857b42f4$export$1a9fe1b84c876bb5; });

var $91FVG = parcelRequire("91FVG");

var $8Govx = parcelRequire("8Govx");

var $gQLDR = parcelRequire("gQLDR");
function $b5f6d880857b42f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b5f6d880857b42f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b5f6d880857b42f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b5f6d880857b42f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b5f6d880857b42f4$var$gridSize = 8;
var $b5f6d880857b42f4$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $b5f6d880857b42f4$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $b5f6d880857b42f4$var$lineHeights = {
    default: $b5f6d880857b42f4$var$heights.default,
    compact: $b5f6d880857b42f4$var$heights.compact,
    none: 'inherit'
};
var $b5f6d880857b42f4$var$padding = {
    // 10px gutter
    default: "0 ".concat($b5f6d880857b42f4$var$gridSize + $b5f6d880857b42f4$var$gridSize / 4, "px"),
    compact: "0 ".concat($b5f6d880857b42f4$var$gridSize + $b5f6d880857b42f4$var$gridSize / 4, "px"),
    none: '0'
};
var $b5f6d880857b42f4$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($b5f6d880857b42f4$var$gridSize / 4, "px"),
    default: "0 ".concat($b5f6d880857b42f4$var$gridSize / 4, "px"),
    none: '0'
};
var $b5f6d880857b42f4$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $b5f6d880857b42f4$var$innerMargin = {
    content: "0 ".concat($b5f6d880857b42f4$var$gridSize / 4, "px"),
    icon: "0 ".concat($b5f6d880857b42f4$var$gridSize / 4, "px")
};
var $b5f6d880857b42f4$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $b5f6d880857b42f4$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $b5f6d880857b42f4$var$_objectSpread($b5f6d880857b42f4$var$_objectSpread({}, $b5f6d880857b42f4$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $b5f6d880857b42f4$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $b5f6d880857b42f4$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $b5f6d880857b42f4$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $b5f6d880857b42f4$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $b5f6d880857b42f4$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $b5f6d880857b42f4$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $b5f6d880857b42f4$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $b5f6d880857b42f4$var$_objectSpread($b5f6d880857b42f4$var$_objectSpread({}, $b5f6d880857b42f4$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var $b5f6d880857b42f4$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $b5f6d880857b42f4$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $b5f6d880857b42f4$var$_objectSpread($b5f6d880857b42f4$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $gQLDR.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $b5f6d880857b42f4$var$heights[spacing],
        lineHeight: $b5f6d880857b42f4$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $b5f6d880857b42f4$var$singleIconPadding[spacing] : $b5f6d880857b42f4$var$padding[spacing],
        verticalAlign: $b5f6d880857b42f4$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $b5f6d880857b42f4$var$selectedStyles : $b5f6d880857b42f4$var$_objectSpread($b5f6d880857b42f4$var$_objectSpread($b5f6d880857b42f4$var$_objectSpread($b5f6d880857b42f4$var$_objectSpread($b5f6d880857b42f4$var$_objectSpread($b5f6d880857b42f4$var$_objectSpread($b5f6d880857b42f4$var$_objectSpread($b5f6d880857b42f4$var$_objectSpread({}, appearance === 'default' && $b5f6d880857b42f4$var$defaultStyles), appearance === 'primary' && $b5f6d880857b42f4$var$primaryStyles), appearance === 'link' && $b5f6d880857b42f4$var$linkStyles), appearance === 'subtle' && $b5f6d880857b42f4$var$subtleStyles), appearance === 'subtle-link' && $b5f6d880857b42f4$var$subtleLinkStyles), appearance === 'warning' && $b5f6d880857b42f4$var$warningStyles), appearance === 'danger' && $b5f6d880857b42f4$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $b5f6d880857b42f4$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $b5f6d880857b42f4$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $b5f6d880857b42f4$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            }
        }
    }, $b5f6d880857b42f4$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $b5f6d880857b42f4$export$864eea3f4ec3368f(_ref2) {
    var spacing = _ref2.spacing;
    return (0, $8Govx.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $b5f6d880857b42f4$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $b5f6d880857b42f4$export$7ad0316cc0dd65a(_ref3) {
    var spacing = _ref3.spacing;
    return (0, $8Govx.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $b5f6d880857b42f4$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $b5f6d880857b42f4$export$1b5827d324e945b1(_ref4) {
    var hasOverlay = _ref4.hasOverlay;
    return (0, $8Govx.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $b5f6d880857b42f4$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});

parcelRegister("68DLO", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $478256f15e052bee$export$20bbd2efb0d734c4; });

var $dNMDr = parcelRequire("dNMDr");

var $iRhvt = parcelRequire("iRhvt");
var $478256f15e052bee$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $dNMDr.isValidElement)(children) && children.type === (0, $iRhvt.default);
};

});


parcelRegister("iqYCZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6b9af2650a26faf$export$2e2bcd8739ae039; });

var $68DLO = parcelRequire("68DLO");
function $d6b9af2650a26faf$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $68DLO.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("6gA4U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49003912470c80e7$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $3Wc5s = parcelRequire("3Wc5s");
function $49003912470c80e7$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $49003912470c80e7$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3Wc5s.default), {
        size: size,
        label: ", Loading",
        appearance: $49003912470c80e7$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("jhtQ6", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $e096c056556702d1$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $e096c056556702d1$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $e096c056556702d1$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $7z7KZ = parcelRequire("7z7KZ");

var $fCAFh = parcelRequire("fCAFh");
function $e096c056556702d1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e096c056556702d1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e096c056556702d1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e096c056556702d1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e096c056556702d1$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $e096c056556702d1$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $fCAFh.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    var selector = $e096c056556702d1$var$stateToSelectorMap[state];
    if (selector) result = $e096c056556702d1$var$_objectSpread($e096c056556702d1$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $e096c056556702d1$var$_objectSpread($e096c056556702d1$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $e096c056556702d1$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $e096c056556702d1$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $e096c056556702d1$var$Theme = (0, $7z7KZ.createTheme)(function(themeProps) {
    return {
        buttonStyles: $e096c056556702d1$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e096c056556702d1$export$2e2bcd8739ae039 = $e096c056556702d1$var$Theme;

});


parcelRegister("cxfJ7", function(module, exports) {

$parcel$export(module.exports, "flagBackgroundColor", function () { return $9204c41caa3b6e3a$export$59e42969c95d314; });
$parcel$export(module.exports, "flagIconColor", function () { return $9204c41caa3b6e3a$export$7f70afe2167f8235; });
$parcel$export(module.exports, "flagIconGlyph", function () { return $9204c41caa3b6e3a$export$73f08aee70487cd4; });
$parcel$export(module.exports, "flagTextColor", function () { return $9204c41caa3b6e3a$export$f50075b2584087f; });
$parcel$export(module.exports, "flagTextColorToken", function () { return $9204c41caa3b6e3a$export$13b42cd9d596bfe0; });
$parcel$export(module.exports, "actionBackgroundColor", function () { return $9204c41caa3b6e3a$export$81ba6b63eedb299f; });
$parcel$export(module.exports, "actionTextColor", function () { return $9204c41caa3b6e3a$export$7bcfe3cca4dd78b6; });

var $dNMDr = parcelRequire("dNMDr");

var $fGClI = parcelRequire("fGClI");

var $eZLWJ = parcelRequire("eZLWJ");

var $2MiNU = parcelRequire("2MiNU");

var $fIC9d = parcelRequire("fIC9d");

var $2Mjap = parcelRequire("2Mjap");
var $9204c41caa3b6e3a$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
var $9204c41caa3b6e3a$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};
var $9204c41caa3b6e3a$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fGClI))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eZLWJ))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eZLWJ))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MiNU))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fIC9d))), {
        label: ""
    })
};
var $9204c41caa3b6e3a$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
var $9204c41caa3b6e3a$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, ".concat((0, $2Mjap.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $2Mjap.N0), ")"),
    normal: "var(--ds-text, ".concat((0, $2Mjap.N800), ")"),
    success: "var(--ds-text-inverse, ".concat((0, $2Mjap.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $2Mjap.N700), ")")
};
var $9204c41caa3b6e3a$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $2Mjap.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $2Mjap.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $2Mjap.N30A), ")")
    },
    info: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $2Mjap.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $2Mjap.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $2Mjap.N30A), ")")
    },
    error: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $2Mjap.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $2Mjap.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $2Mjap.N30A), ")")
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $2Mjap.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $2Mjap.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $2Mjap.N30A), ")")
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
var $9204c41caa3b6e3a$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, ".concat((0, $2Mjap.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $2Mjap.N0), ")"),
    error: "var(--ds-text-inverse, ".concat((0, $2Mjap.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $2Mjap.N700), ")"),
    normal: "var(--ds-link, ".concat((0, $2Mjap.B400), ")")
};

});
parcelRegister("fGClI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6b8869f6d5dcb78$var$_react = $b6b8869f6d5dcb78$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $b6b8869f6d5dcb78$var$_baseNew = $b6b8869f6d5dcb78$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $b6b8869f6d5dcb78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6b8869f6d5dcb78$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $b6b8869f6d5dcb78$var$_react.default.createElement($b6b8869f6d5dcb78$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$b6b8869f6d5dcb78$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $b6b8869f6d5dcb78$var$_default = module.exports.default = $b6b8869f6d5dcb78$var$StatusErrorIcon;

});

parcelRegister("eZLWJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aeabf45a56da01cb$var$_react = $aeabf45a56da01cb$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $aeabf45a56da01cb$var$_baseNew = $aeabf45a56da01cb$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $aeabf45a56da01cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aeabf45a56da01cb$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $aeabf45a56da01cb$var$_react.default.createElement($aeabf45a56da01cb$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$aeabf45a56da01cb$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $aeabf45a56da01cb$var$_default = module.exports.default = $aeabf45a56da01cb$var$StatusInformationIcon;

});

parcelRegister("2MiNU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $205ea690f19f9fa7$var$_react = $205ea690f19f9fa7$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $205ea690f19f9fa7$var$_baseNew = $205ea690f19f9fa7$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $205ea690f19f9fa7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $205ea690f19f9fa7$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $205ea690f19f9fa7$var$_react.default.createElement($205ea690f19f9fa7$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$205ea690f19f9fa7$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $205ea690f19f9fa7$var$_default = module.exports.default = $205ea690f19f9fa7$var$StatusSuccessIcon;

});

parcelRegister("fIC9d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7188e689e01c358$var$_react = $b7188e689e01c358$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $b7188e689e01c358$var$_baseNew = $b7188e689e01c358$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $b7188e689e01c358$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b7188e689e01c358$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $b7188e689e01c358$var$_react.default.createElement($b7188e689e01c358$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$b7188e689e01c358$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $b7188e689e01c358$var$_default = module.exports.default = $b7188e689e01c358$var$StatusWarningIcon;

});



parcelRegister("k3Lhn", function(module, exports) {

$parcel$export(module.exports, "useFlagGroup", function () { return $e9a8c32972357fe7$export$e91ea202abb66350; });
$parcel$export(module.exports, "default", function () { return $e9a8c32972357fe7$export$2e2bcd8739ae039; });
/* flag-group.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $a3ftr = parcelRequire("a3ftr");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $c3KQG = parcelRequire("c3KQG");

var $bnv12 = parcelRequire("bnv12");
var $8EO4h = parcelRequire("8EO4h");

var $1w48L = parcelRequire("1w48L");

var $gWqO2 = parcelRequire("gWqO2");

var $iRhvt = parcelRequire("iRhvt");
var $e9a8c32972357fe7$export$1eee5ddc4f6d41c5 = 400;
var $e9a8c32972357fe7$var$defaultFlagGroupContext = {
    onDismissed: (0, $c3KQG.default),
    isDismissAllowed: false
};
var $e9a8c32972357fe7$export$c57ba665aaa722be = /*#__PURE__*/ (0, $dNMDr.createContext)($e9a8c32972357fe7$var$defaultFlagGroupContext);
function $e9a8c32972357fe7$export$e91ea202abb66350() {
    return (0, $dNMDr.useContext)($e9a8c32972357fe7$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $e9a8c32972357fe7$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $e9a8c32972357fe7$var$dismissAllowedStyles = null;
var $e9a8c32972357fe7$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $e9a8c32972357fe7$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? 'Flag notifications' : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? 'h2' : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $c3KQG.default) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $dNMDr.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(children) === 'object' ? (0, $dNMDr.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return /*#__PURE__*/ $dNMDr.createElement((0, $8EO4h.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in"
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return /*#__PURE__*/ $dNMDr.createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $affTb.default)([
                        $e9a8c32972357fe7$var$groupStyles.root,
                        index === 0 && $e9a8c32972357fe7$var$groupStyles.first,
                        index === 1 && $e9a8c32972357fe7$var$groupStyles.second,
                        index >= 1 && $e9a8c32972357fe7$var$groupStyles.nth,
                        index >= 2 && $e9a8c32972357fe7$var$groupStyles.hidden,
                        isDismissAllowed && "_12a7luct",
                        className
                    ]),
                    ref: ref,
                    "data-vc-oob": true
                }, /*#__PURE__*/ $dNMDr.createElement($e9a8c32972357fe7$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $e9a8c32972357fe7$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    var flags = /*#__PURE__*/ $dNMDr.createElement("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $affTb.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ])
    }, hasFlags ? /*#__PURE__*/ $dNMDr.createElement((0, $iRhvt.default), null, /*#__PURE__*/ $dNMDr.createElement(LabelTag, null, label)) : null, /*#__PURE__*/ $dNMDr.createElement((0, $bnv12.default), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : /*#__PURE__*/ $dNMDr.createElement((0, $1w48L.default), {
        zIndex: (0, $gWqO2.layers).flag()
    }, flags);
};
var $e9a8c32972357fe7$export$2e2bcd8739ae039 = $e9a8c32972357fe7$var$FlagGroup;

});
parcelRegister("8EO4h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64d8e5a0b3e90a46$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $kGMtM = parcelRequire("kGMtM");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $64d8e5a0b3e90a46$var$SlideIn = function SlideIn(_ref) {
    var children = _ref.children, enterFrom = _ref.enterFrom, exitTo = _ref.exitTo, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'medium' : _ref$duration, isPaused = _ref.isPaused, onFinish = _ref.onFinish, _ref$animationTimingF = _ref.animationTimingFunction, animationTimingFunction = _ref$animationTimingF === void 0 ? 'ease-out' : _ref$animationTimingF, _ref$animationTimingF2 = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF2 === void 0 ? 'ease-in' : _ref$animationTimingF2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $kGMtM.default), {
        duration: duration,
        enteringAnimation: "slide-in-from-".concat(enterFrom),
        exitingAnimation: "slide-out-from-".concat(exitTo || enterFrom),
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $64d8e5a0b3e90a46$export$2e2bcd8739ae039 = $64d8e5a0b3e90a46$var$SlideIn;

});


parcelRegister("9Jn9G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $715a47246dbdedcd$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $dNMDr = parcelRequire("dNMDr");

var $dpTxl = parcelRequire("dpTxl");

var $jJCD4 = parcelRequire("jJCD4");

var $jXq7t = parcelRequire("jXq7t");

var $dP4Xn = parcelRequire("dP4Xn");

var $cxfJ7 = parcelRequire("cxfJ7");
var $715a47246dbdedcd$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($dP4Xn)));
    var buttonLabel = 'Dismiss';
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($jXq7t))) : (0, (/*@__PURE__*/$parcel$interopDefault($jJCD4)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dpTxl.default), {
        icon: function icon(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(ButtonIcon, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, iconProps, {
                size: "small",
                label: "",
                color: (0, $cxfJ7.flagTextColorToken)[appearance]
            }));
        },
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
var $715a47246dbdedcd$var$DismissButton = /*#__PURE__*/ (0, $dNMDr.memo)($715a47246dbdedcd$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$715a47246dbdedcd$export$2e2bcd8739ae039 = $715a47246dbdedcd$var$DismissButton;

});
parcelRegister("jXq7t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6f832dcdc2d7a1f91afd5e9b90e10b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e877c9c847731d9f$var$_react = $e877c9c847731d9f$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $e877c9c847731d9f$var$_baseNew = $e877c9c847731d9f$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $e877c9c847731d9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e877c9c847731d9f$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $e877c9c847731d9f$var$_react.default.createElement($e877c9c847731d9f$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$e877c9c847731d9f$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $e877c9c847731d9f$var$_default = module.exports.default = $e877c9c847731d9f$var$ChevronUpIcon;

});


parcelRegister("jp3LP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e20346dc8eeb76ca$export$2e2bcd8739ae039; });
/* expander.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $dNMDr = parcelRequire("dNMDr");


var $bnv12 = parcelRequire("bnv12");
var $5fkkM = parcelRequire("5fkkM");

var $l69Tm = parcelRequire("l69Tm");
var $3FKQn = parcelRequire("3FKQn");
var $e20346dc8eeb76ca$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
var $e20346dc8eeb76ca$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ $dNMDr.createElement((0, $l69Tm.default), {
        xcss: $e20346dc8eeb76ca$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ $dNMDr.createElement((0, $bnv12.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ $dNMDr.createElement((0, $5fkkM.default), null, function(props) {
        return /*#__PURE__*/ $dNMDr.createElement((0, $l69Tm.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
            xcss: $e20346dc8eeb76ca$var$styles.container
        }, props), /*#__PURE__*/ $dNMDr.createElement((0, $3FKQn.default), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e20346dc8eeb76ca$export$2e2bcd8739ae039 = $e20346dc8eeb76ca$var$Expander;

});


parcelRegister("dWJmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $029ec5ade4904cf5$var$_react = $029ec5ade4904cf5$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $gsWOv = parcelRequire("gsWOv");

var $029ec5ade4904cf5$var$_statusSuccess = $029ec5ade4904cf5$var$_interopRequireDefault((parcelRequire("dRrxv")));
function $029ec5ade4904cf5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $029ec5ade4904cf5$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $029ec5ade4904cf5$var$_react.default.createElement($gsWOv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $029ec5ade4904cf5$var$_statusSuccess.default
    }));
$029ec5ade4904cf5$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $029ec5ade4904cf5$var$_default = module.exports.default = $029ec5ade4904cf5$var$CheckCircleIcon;

});


parcelRegister("hTMPL", function(module, exports) {

$parcel$export(module.exports, "MfaAppsPage", function () { return $678802ae1ffe9b58$export$f8df0673716775fc; });
$parcel$export(module.exports, "ExpiredPasswordPage", function () { return $678802ae1ffe9b58$export$f8dc9833cdc832ea; });
$parcel$export(module.exports, "MfaEnrollmentPage", function () { return $678802ae1ffe9b58$export$1feb78d7c7eef8e6; });
$parcel$export(module.exports, "MfaPromotePage", function () { return $678802ae1ffe9b58$export$84ed94b8c66e0057; });
$parcel$export(module.exports, "MultiFactorPage", function () { return $678802ae1ffe9b58$export$d5523937d2306712; });
$parcel$export(module.exports, "LoginConsentNoticePage", function () { return $678802ae1ffe9b58$export$68f39a5ef8cea54d; });
$parcel$export(module.exports, "CancelAccountDeletionPage", function () { return $678802ae1ffe9b58$export$ffebed914bd6a6c9; });
$parcel$export(module.exports, "InactiveAccountPage", function () { return $678802ae1ffe9b58$export$ad79d74b0908a012; });
$parcel$export(module.exports, "PendingDeletionPage", function () { return $678802ae1ffe9b58$export$40b885b03094ae2d; });
$parcel$export(module.exports, "DeletionRequestConfirmationPage", function () { return $678802ae1ffe9b58$export$467fb294f057077d; });
$parcel$export(module.exports, "ChangePasswordPage", function () { return $678802ae1ffe9b58$export$8ec0fb1e4323236d; });
$parcel$export(module.exports, "SocialLoginRecoveryPage", function () { return $678802ae1ffe9b58$export$ee564d35600efee8; });
$parcel$export(module.exports, "VerifyOrReverifyEmailSentPage", function () { return $678802ae1ffe9b58$export$980c3b624c0da509; });
$parcel$export(module.exports, "VerifyOrReverifyEmailErrorPage", function () { return $678802ae1ffe9b58$export$647c199e9f3e1159; });
$parcel$export(module.exports, "WelcomeSentPage", function () { return $678802ae1ffe9b58$export$9feca1f6b3b10306; });
$parcel$export(module.exports, "LogoutPage", function () { return $678802ae1ffe9b58$export$ae5920452e7cb547; });
$parcel$export(module.exports, "StepUpSsoPage", function () { return $678802ae1ffe9b58$export$61fae207a78c2e53; });
$parcel$export(module.exports, "StepUpStartPage", function () { return $678802ae1ffe9b58$export$e561dacd818ab41; });
$parcel$export(module.exports, "EmailConfirmationPage", function () { return $678802ae1ffe9b58$export$98b365c355bab28e; });
$parcel$export(module.exports, "AuthCallbackErrorPage", function () { return $678802ae1ffe9b58$export$beb41ed376add573; });
$parcel$export(module.exports, "SecurityExpiredLinkPage", function () { return $678802ae1ffe9b58$export$f5edf646533475ec; });
$parcel$export(module.exports, "SecuritySuccessPage", function () { return $678802ae1ffe9b58$export$8d7d33e241ae6c52; });
$parcel$export(module.exports, "OAuthDAGTerminalPage", function () { return $678802ae1ffe9b58$export$fd3e8d2c69efe115; });
$parcel$export(module.exports, "RemoveAccountPage", function () { return $678802ae1ffe9b58$export$66bcaaca6b1eddac; });
$parcel$export(module.exports, "SelectAccountPage", function () { return $678802ae1ffe9b58$export$134466789cb44107; });
$parcel$export(module.exports, "ContinueAsPage", function () { return $678802ae1ffe9b58$export$a4ce1932d7e73468; });
$parcel$export(module.exports, "MigrateAccountConfirmationPage", function () { return $678802ae1ffe9b58$export$3432bb22f729c42b; });
$parcel$export(module.exports, "RecoveryPage", function () { return $678802ae1ffe9b58$export$280a36f5ba1cc19f; });
$parcel$export(module.exports, "ChooseMethodPage", function () { return $678802ae1ffe9b58$export$d137eda0ebcc3948; });
$parcel$export(module.exports, "ConfigurePhonePage", function () { return $678802ae1ffe9b58$export$717e3b31ee3d8960; });
$parcel$export(module.exports, "ConfigureAppPage", function () { return $678802ae1ffe9b58$export$d316ce63fb222131; });
$parcel$export(module.exports, "SaveRecoveryKeyPage", function () { return $678802ae1ffe9b58$export$70105507d801662a; });
$parcel$export(module.exports, "RegisterSecurityKeyPage", function () { return $678802ae1ffe9b58$export$bfd6201eae0d5333; });
$parcel$export(module.exports, "MultiMfaEnrollmentAddAuthenticatorPage", function () { return $678802ae1ffe9b58$export$db2cf97d4f19249; });
$parcel$export(module.exports, "MultiMfaEnrollmentAddSecurityKeyPage", function () { return $678802ae1ffe9b58$export$6e18f48b7564d95d; });
$parcel$export(module.exports, "LoginPage", function () { return $678802ae1ffe9b58$export$f14c0e3f98d164c0; });
$parcel$export(module.exports, "CreateAccountConfirmationPage", function () { return $678802ae1ffe9b58$export$74ab7a9a192e1a7a; });
$parcel$export(module.exports, "WelcomePage", function () { return $678802ae1ffe9b58$export$630ad10f0e1a953d; });
$parcel$export(module.exports, "VerifyEmailOtpPage", function () { return $678802ae1ffe9b58$export$a16cb21d1f9bc820; });
$parcel$export(module.exports, "ResetPasswordPage", function () { return $678802ae1ffe9b58$export$da4433e8d8a5678; });
$parcel$export(module.exports, "SignupPage", function () { return $678802ae1ffe9b58$export$a2f4b65ede167ce5; });
$parcel$export(module.exports, "SignupOnboardPage", function () { return $678802ae1ffe9b58$export$1c7442c86b06b50c; });
$parcel$export(module.exports, "AuthenticatedLoomWorkspaceCreationPage", function () { return $678802ae1ffe9b58$export$f296423b4e837594; });

var $dNMDr = parcelRequire("dNMDr");

const $678802ae1ffe9b58$export$f8df0673716775fc = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("1XgdC")));

const $678802ae1ffe9b58$export$8860bd3f7903e57e = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("bsMjt"))));

const $678802ae1ffe9b58$export$357c630eb6814495 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("dGtec"))));

const $678802ae1ffe9b58$export$f8dc9833cdc832ea = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("7aPz9"))));

const $678802ae1ffe9b58$export$1feb78d7c7eef8e6 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("Ztrmq")));

const $678802ae1ffe9b58$export$84ed94b8c66e0057 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("f3CY8"))));

const $678802ae1ffe9b58$export$d5523937d2306712 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("eX172"))));

const $678802ae1ffe9b58$export$68f39a5ef8cea54d = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("1RDNp")));

const $678802ae1ffe9b58$export$ffebed914bd6a6c9 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("1OnM8"))));

const $678802ae1ffe9b58$export$ad79d74b0908a012 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("g91KU")));

const $678802ae1ffe9b58$export$40b885b03094ae2d = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("49VRM")));

const $678802ae1ffe9b58$export$467fb294f057077d = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("dW5Hd")));

const $678802ae1ffe9b58$export$8ec0fb1e4323236d = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("humZM"))));

const $678802ae1ffe9b58$export$ee564d35600efee8 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("kabQ0"))));

const $678802ae1ffe9b58$export$980c3b624c0da509 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("hADis"))));

const $678802ae1ffe9b58$export$647c199e9f3e1159 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("dWvY5"))));

const $678802ae1ffe9b58$export$9feca1f6b3b10306 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("jvWWI"))));

const $678802ae1ffe9b58$export$ae5920452e7cb547 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("ganXz"))));

const $678802ae1ffe9b58$export$61fae207a78c2e53 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("jXtDs"))));

const $678802ae1ffe9b58$export$e561dacd818ab41 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("lChtt"))));

const $678802ae1ffe9b58$export$98b365c355bab28e = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("5WYPj"))));

const $678802ae1ffe9b58$export$beb41ed376add573 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("9kJTa")));

const $678802ae1ffe9b58$export$f5edf646533475ec = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("ce4A9")));

const $678802ae1ffe9b58$export$8d7d33e241ae6c52 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("4E5Mb")));

const $678802ae1ffe9b58$export$fd3e8d2c69efe115 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("a0YJb")));

const $678802ae1ffe9b58$export$66bcaaca6b1eddac = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("gbv4C"))));

const $678802ae1ffe9b58$export$134466789cb44107 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("cTHs9"))));

const $678802ae1ffe9b58$export$a4ce1932d7e73468 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("jqdEu"))));

const $678802ae1ffe9b58$export$3432bb22f729c42b = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("4V2aG"))));

const $678802ae1ffe9b58$export$280a36f5ba1cc19f = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>Promise.resolve((parcelRequire("k9mWX"))));

const $678802ae1ffe9b58$export$d137eda0ebcc3948 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("8vZ29")));

const $678802ae1ffe9b58$export$717e3b31ee3d8960 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("3P2hn")));

const $678802ae1ffe9b58$export$d316ce63fb222131 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("9Db1u")));

const $678802ae1ffe9b58$export$70105507d801662a = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("iHefQ")));

const $678802ae1ffe9b58$export$bfd6201eae0d5333 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("f9TqQ")));

const $678802ae1ffe9b58$export$db2cf97d4f19249 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("7doeZ")));

const $678802ae1ffe9b58$export$6e18f48b7564d95d = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("BK9e4")));

const $678802ae1ffe9b58$export$f14c0e3f98d164c0 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("cxM5C")));

const $678802ae1ffe9b58$export$74ab7a9a192e1a7a = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("1AiSC")));

const $678802ae1ffe9b58$export$630ad10f0e1a953d = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("1hgxS")));

const $678802ae1ffe9b58$export$a16cb21d1f9bc820 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("9U307")));

const $678802ae1ffe9b58$export$da4433e8d8a5678 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("jj6uj")));

const $678802ae1ffe9b58$export$a2f4b65ede167ce5 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("9TtX1")));

const $678802ae1ffe9b58$export$1c7442c86b06b50c = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("f5VlY")));

const $678802ae1ffe9b58$export$f296423b4e837594 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("bxNSr")));

const $678802ae1ffe9b58$export$ce4f2d43cbb062f9 = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("3OcYn")));

});
parcelRegister("bsMjt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "VerifyEmailSentPage", function () { return $1a673b93f2c692a2$export$8860bd3f7903e57e; });
$parcel$export(module.exports, "default", function () { return $1a673b93f2c692a2$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $lwrli = parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $cpaps = parcelRequire("cpaps");

var $kJPFV = parcelRequire("kJPFV");

var $1JRGy = parcelRequire("1JRGy");

var $7lC8o = parcelRequire("7lC8o");

var $fcxz7 = parcelRequire("fcxz7");

var $eTWY7 = parcelRequire("eTWY7");

var $8PbSs = parcelRequire("8PbSs");

var $gP3MD = parcelRequire("gP3MD");

var $Q6OOA = parcelRequire("Q6OOA");

var $4NPio = parcelRequire("4NPio");

var $aMBBA = parcelRequire("aMBBA");
const $1a673b93f2c692a2$var$pageId = 'verifyEmailScreen';
const $1a673b93f2c692a2$export$8860bd3f7903e57e = ()=>{
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const location = (0, $cVnBY.useLocation)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const dispatchAddFlag = (flag)=>{
        dispatch((0, $7lC8o.addFlag)(flag.type, flag.title, flag.description));
    };
    const email = (0, $aMBBA.useAppSelector)((state)=>state.user.email);
    const showBrowserWarning = (0, $aMBBA.useAppSelector)((state)=>state.verifyEmailSent.showBrowserWarning);
    (0, $4NPio.usePageViewedEvent)($1a673b93f2c692a2$var$pageId, {
        browserWarningMessageShown: showBrowserWarning
    });
    const handleResendVerificationEmail = async ()=>{
        analyticsClient.buttonClickedEvent($1a673b93f2c692a2$var$pageId, 'resendVerificationEmail');
        try {
            const response = await fetch(`/rest/resend-email${location.search}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 204) addSuccessFlag();
            else addErrorFlag();
        } catch  {
            addErrorFlag();
        }
    };
    const handleReturnToLogin = ()=>{
        analyticsClient.buttonClickedEvent($1a673b93f2c692a2$var$pageId, 'verifyEmailReturnLoginLink');
    };
    const addSuccessFlag = ()=>{
        dispatchAddFlag({
            type: 'success',
            title: (0, $gP3MD.default).verifyEmailFlagSuccessTitle,
            description: (0, $gP3MD.default).verifyEmailFlagSuccessDesc
        });
    };
    const addErrorFlag = ()=>{
        dispatchAddFlag({
            type: 'error',
            title: (0, $gP3MD.default).verifyEmailFlagErrorTitle,
            description: (0, $gP3MD.default).verifyEmailFlagErrorDesc
        });
    };
    const renderWhiteboxFooter = ()=>{
        const returnLoginLink = `/login?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search),
            email: email
        })}`;
        const returnToLoginLink = (0, $fcxz7.isTrelloDesktop)() ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.Link), {
            id: "return-login-button",
            to: returnLoginLink,
            onClick: handleReturnToLogin,
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "return.to.log.in",
                defaultMessage: "Return to log in"
            })
        }) : null;
        return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)("ul", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                            id: "send-validation-submit",
                            spacing: "none",
                            className: "link-color-override",
                            onClick: handleResendVerificationEmail,
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                id: "verify.email.resend.signup.link",
                                defaultMessage: "Resend signup link"
                            })
                        })
                    })
                }),
                returnToLoginLink && /*#__PURE__*/ (0, $6CtE1.jsx)("ul", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                        children: returnToLoginLink
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        // @ts-ignore no id
        id: "email-sent-page",
        pageId: $1a673b93f2c692a2$var$pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "verify.email.title",
            tagName: "h5",
            defaultMessage: "Check your inbox to finish signup"
        }),
        whiteboxFooter: renderWhiteboxFooter(),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                title: formatMessage((0, $gP3MD.default).headTitle)
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8PbSs.default), {
                email: email,
                message: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "verify.email.sent.signup.link",
                    tagName: "p",
                    defaultMessage: "We sent a signup link to:",
                    description: "Telling user that a verification link has been sent. This message is followed by the user's email address on the next line."
                }),
                warningMessage: showBrowserWarning && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kJPFV.default), {
                    testId: "browser-warning",
                    appearance: "information",
                    children: formatMessage((0, $gP3MD.default).browserWarning)
                })
            })
        ]
    });
};
var $1a673b93f2c692a2$export$2e2bcd8739ae039 = $1a673b93f2c692a2$export$8860bd3f7903e57e;

});
parcelRegister("kJPFV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f19018425826fb36$export$2e2bcd8739ae039; });
/* section-message.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $grvIM = parcelRequire("grvIM");

var $dpTxl = parcelRequire("dpTxl");

var $dWOVN = parcelRequire("dWOVN");

var $dP4Xn = parcelRequire("dP4Xn");

var $gQLDR = parcelRequire("gQLDR");

var $eS3uG = parcelRequire("eS3uG");
var $3FKQn = parcelRequire("3FKQn");

var $jsJTC = parcelRequire("jsJTC");
var $f19018425826fb36$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    containerT26Shape: "_2rko1mok",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
var $f19018425826fb36$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $f19018425826fb36$var$SectionMessage = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'information' : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, isDismissible = _ref.isDismissible, onDismiss = _ref.onDismiss, testId = _ref.testId;
    var _useState = (0, $dNMDr.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), dismissed = _useState2[0], setDismissed = _useState2[1];
    var handleDismiss = (0, $dNMDr.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    var _getAppearanceIconSty = (0, $jsJTC.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, $dNMDr.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, $dNMDr.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $dNMDr.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $grvIM.default)([
            $f19018425826fb36$var$sectionMessageStyles.container,
            (0, $gQLDR.fg)('platform-dst-shape-theme-default') && $f19018425826fb36$var$sectionMessageStyles.containerT26Shape,
            $f19018425826fb36$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $dNMDr.createElement((0, $eS3uG.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $dNMDr.createElement("div", {
        className: (0, $grvIM.default)([
            $f19018425826fb36$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $dNMDr.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $dNMDr.createElement((0, $3FKQn.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content"),
        xcss: $f19018425826fb36$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $dNMDr.createElement((0, $dWOVN.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ $dNMDr.createElement("div", {
        className: (0, $grvIM.default)([
            $f19018425826fb36$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $dNMDr.createElement((0, $eS3uG.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xB7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? 'list' : undefined,
        xcss: $f19018425826fb36$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return(/*#__PURE__*/ // Only use a listitem role if more than one action is present
        $dNMDr.createElement((0, $eS3uG.default), {
            role: actionsArray.length > 1 ? 'listitem' : undefined,
            key: id
        }, action));
    }))), isDismissible && /*#__PURE__*/ $dNMDr.createElement("div", {
        className: (0, $grvIM.default)([
            $f19018425826fb36$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $dNMDr.createElement((0, $dpTxl.default), {
        testId: testId && "".concat(testId, "--dismiss-button"),
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dP4Xn))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$f19018425826fb36$var$SectionMessage.displayName = 'SectionMessage';
var $f19018425826fb36$export$2e2bcd8739ae039 = $f19018425826fb36$var$SectionMessage;

});
parcelRegister("jsJTC", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", function () { return $e2b43bd3712f4ad0$export$e9b82d2e21ac0c1f; });

var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");

var $8liw4 = parcelRequire("8liw4");

var $fGClI = parcelRequire("fGClI");

var $eZLWJ = parcelRequire("eZLWJ");

var $2MiNU = parcelRequire("2MiNU");

var $fIC9d = parcelRequire("fIC9d");

var $2Mjap = parcelRequire("2Mjap");
function $e2b43bd3712f4ad0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e2b43bd3712f4ad0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e2b43bd3712f4ad0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e2b43bd3712f4ad0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e2b43bd3712f4ad0$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $2Mjap.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eZLWJ))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $2Mjap.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $2Mjap.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fIC9d))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $2Mjap.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $2Mjap.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fGClI))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $2Mjap.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $2Mjap.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MiNU))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $2Mjap.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $2Mjap.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8liw4))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $2Mjap.P500), ")")
    }
};
function $e2b43bd3712f4ad0$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $e2b43bd3712f4ad0$var$appearanceIconSchema[appearance] || $e2b43bd3712f4ad0$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var primaryColor = _ref.primaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $e2b43bd3712f4ad0$var$_objectSpread($e2b43bd3712f4ad0$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRegister("8liw4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b3613c7e18556761a1c0b5ad2c9a88f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $612ea5dcdd897053$var$_react = $612ea5dcdd897053$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $612ea5dcdd897053$var$_baseNew = $612ea5dcdd897053$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $612ea5dcdd897053$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $612ea5dcdd897053$var$StatusDiscoveryIcon = (props)=>/*#__PURE__*/ $612ea5dcdd897053$var$_react.default.createElement($612ea5dcdd897053$var$_baseNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>`
    }, props));
$612ea5dcdd897053$var$StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var $612ea5dcdd897053$var$_default = module.exports.default = $612ea5dcdd897053$var$StatusDiscoveryIcon;

});



parcelRegister("eTWY7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2817ca3ce06e2267$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $cTzf6 = parcelRequire("cTzf6");

var $fbSBq = parcelRequire("fbSBq");
parcelRequire("dNMDr");
const $2817ca3ce06e2267$var$StyledButton = (0, $fbSBq.default)((0, $cTzf6.default))`
  span {
    font-weight: 400;
  }
`;
const $2817ca3ce06e2267$var$ButtonLink = (props)=>{
    const { appearance: appearance, ...rest } = props;
    return /*#__PURE__*/ (0, $6CtE1.jsx)($2817ca3ce06e2267$var$StyledButton, {
        appearance: appearance || 'link',
        ...rest
    });
};
var $2817ca3ce06e2267$export$2e2bcd8739ae039 = $2817ca3ce06e2267$var$ButtonLink;

});
parcelRegister("cTzf6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9635f58739430cc3$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $82V4i = parcelRequire("82V4i");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $c3KQG = parcelRequire("c3KQG");

var $gQMs5 = parcelRequire("gQMs5");

var $fCAFh = parcelRequire("fCAFh");

var $iqYCZ = parcelRequire("iqYCZ");
var $9635f58739430cc3$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $9635f58739430cc3$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $9635f58739430cc3$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $c3KQG.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $c3KQG.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $9635f58739430cc3$var$_excluded);
    var isOnlySingleIcon = (0, $iqYCZ.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $dNMDr.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $dNMDr.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($9635f58739430cc3$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $dNMDr.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($9635f58739430cc3$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $dNMDr.useMemo)(function() {
        return (0, $fCAFh.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $gQMs5.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$9635f58739430cc3$var$Button.displayName = 'Button';
var $9635f58739430cc3$export$2e2bcd8739ae039 = $9635f58739430cc3$var$Button;

});


parcelRegister("8PbSs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb17c811c9aa2eef$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $i691S = parcelRequire("i691S");

var $68HQw = parcelRequire("68HQw");

var $7DUKO = parcelRequire("7DUKO");
const $fb17c811c9aa2eef$var$imgHeight = 88;
const $fb17c811c9aa2eef$var$EmailSentImageContainer = (0, $fbSBq.default).div`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($i691S)))}) no-repeat center bottom;
  height: ${$fb17c811c9aa2eef$var$imgHeight}px;
  margin: ${(0, $68HQw.gridSize)()}px 0 ${(0, $68HQw.gridSize)() * 2}px;
`;
const $fb17c811c9aa2eef$var$EmailSentDescriptionContainer = (0, $fbSBq.default).div`
  text-align: left;
`;
const $fb17c811c9aa2eef$var$EmailWarningContainer = (0, $fbSBq.default).div`
  text-align: left;
  margin-top: ${(0, $68HQw.gridSize)() * 2}px;
`;
const $fb17c811c9aa2eef$var$Email = (0, $fbSBq.default).p`
  font: ${(0, $7DUKO.default)('font.heading.small')};
  text-align: left;
  overflow-wrap: break-word;
  & {
    margin-top: ${(0, $68HQw.gridSize)()}px;
  }
`;
function $fb17c811c9aa2eef$export$2e2bcd8739ae039(props) {
    const { children: children, email: email, message: message, warningMessage: warningMessage, onRender: onRender, withEmailSentImage: withEmailSentImage = true } = props;
    (0, $dNMDr.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
        id: "email-sent-page",
        children: [
            withEmailSentImage && /*#__PURE__*/ (0, $6CtE1.jsx)($fb17c811c9aa2eef$var$EmailSentImageContainer, {}),
            /*#__PURE__*/ (0, $6CtE1.jsx)($fb17c811c9aa2eef$var$EmailSentDescriptionContainer, {
                children: message
            }),
            email && /*#__PURE__*/ (0, $6CtE1.jsx)($fb17c811c9aa2eef$var$Email, {
                children: email
            }),
            warningMessage && /*#__PURE__*/ (0, $6CtE1.jsx)($fb17c811c9aa2eef$var$EmailWarningContainer, {
                children: warningMessage
            }),
            children
        ]
    });
}

});
parcelRegister("i691S", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "check-your-email-open-letter.6c704b97.svg";

});

parcelRegister("7DUKO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $590833117eaeb62b$export$2e2bcd8739ae039; });


var $g8vme = parcelRequire("g8vme");

var $d4N04 = parcelRequire("d4N04");

var $4ilBr = parcelRequire("4ilBr");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $590833117eaeb62b$var$token(path, fallback) {
    var token = (0, $g8vme.default)[path];
    typeof $4ilBr;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $d4N04.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $590833117eaeb62b$export$2e2bcd8739ae039 = $590833117eaeb62b$var$token;

});


parcelRegister("gP3MD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5554ff1d03363d27$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $5554ff1d03363d27$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    // Flags
    verifyEmailFlagSuccessTitle: {
        id: 'verify.email.sent.flag.success.title',
        defaultMessage: "We've sent you an email!",
        description: ''
    },
    verifyEmailFlagSuccessDesc: {
        id: 'verify.email.sent.flag.success.description',
        defaultMessage: 'The verification email is on its way!',
        description: ''
    },
    verifyEmailFlagErrorTitle: {
        id: 'verify.email.sent.flag.error.title',
        defaultMessage: 'Something went wrong.',
        description: ''
    },
    verifyEmailFlagErrorDesc: {
        id: 'verify.email.sent.flag.error.description',
        defaultMessage: 'Please try again later.',
        description: ''
    },
    headTitle: {
        id: 'verify.email.sent.head.title',
        defaultMessage: 'Verify your email'
    },
    migrationVerifyHeader: {
        id: 'migration.welcome.sent.title',
        defaultMessage: 'Check your inbox to log in',
        description: 'Informing the user to check their inbox to login.'
    },
    migrationVerifyMessage: {
        id: 'migration.welcome.sent.signup.link',
        defaultMessage: "To complete setup and log in, click the verification link in the email we\u2019ve sent to",
        description: 'Informing user that another welcome email has been sent for migration.'
    },
    resumeMigrationVerifyMessage: {
        id: 'resume.migration.welcome.sent.signup.link',
        defaultMessage: 'Your {product} account now requires you to log in with your new Atlassian account.',
        description: 'Informing migrating user that they need to log in with their Atlassian account'
    },
    button: {
        id: 'welcome.sent.resend.signup.link',
        defaultMessage: 'Resend verification email',
        description: 'Text telling the user that they can resend the welcome email again for migration.'
    },
    browserWarning: {
        id: 'welcome.email.sent.browser.warning',
        defaultMessage: 'Make sure to verify your email on this device and browser.',
        description: 'Telling the user to open the verification email sent by this page on the same device and browser'
    }
});

});

parcelRegister("Q6OOA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84f1b6f2637f73c4$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $a6oyj = parcelRequire("a6oyj");

var $68HQw = parcelRequire("68HQw");

var $7DUKO = parcelRequire("7DUKO");

var $85EiT = parcelRequire("85EiT");

var $iHqPX = parcelRequire("iHqPX");

var $2eVHl = parcelRequire("2eVHl");

var $dwXRl = parcelRequire("dwXRl");

var $1u5P2 = parcelRequire("1u5P2");

var $4M4Zx = parcelRequire("4M4Zx");

var $dwGfa = parcelRequire("dwGfa");

var $493Hj = parcelRequire("493Hj");
const $84f1b6f2637f73c4$export$bad5896fb5d45c0b = (0, $fbSBq.default).div`
  color: ${(0, $7DUKO.default)('color.text.subtle')};
  margin-top: ${(0, $68HQw.gridSize)() * 3}px;
  font-size: 14px;
  text-align: center;
  line-height: 20px;

  ${(0, $4M4Zx.listStyles)}
`;
const $84f1b6f2637f73c4$export$ba9d4abe45514a38 = (0, $fbSBq.default).footer`
  color: ${(0, $7DUKO.default)('color.text.subtle')};
  padding-top: ${(0, $68HQw.gridSize)() * 2}px;
  font-size: 11px;
  text-align: center;
  line-height: 14px;

  ${(0, $4M4Zx.listStyles)}
`;
const $84f1b6f2637f73c4$var$Whitebox = (0, $fbSBq.default).div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: ${({ width: width })=>width || (0, $4M4Zx.whiteboxWidthDesktop)};
  padding: ${(0, $68HQw.gridSize)() * 4}px ${(0, $68HQw.gridSize)() * 5}px;

  background: ${(0, $iHqPX.colorPalette).primaryWhite};
  border-radius: ${(0, $68HQw.borderRadius)()}px;
  box-shadow: ${({ noBorder: noBorder })=>noBorder ? 'none' : '0 0 10px rgba(0, 0, 0, 0.1)'};
  box-sizing: border-box;
  color: ${(0, $7DUKO.default)('color.text.subtle')};

  ${(0, $85EiT.media).below.sm} {
    padding: ${(0, $68HQw.gridSize)() * 4}px ${(0, $68HQw.gridSize)() * 2}px;
    background: transparent;
    box-shadow: none;
    min-height: 100%;
    width: ${(0, $4M4Zx.whiteboxWidthHandheld)};
  }

  ${(0, $85EiT.media).below.xs} {
    padding: ${(0, $68HQw.gridSize)() * 2}px ${(0, $68HQw.gridSize)() * 2}px;
  }
`;
const $84f1b6f2637f73c4$var$Container = (0, $fbSBq.default).div`
  min-height: calc(100% - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 50px 0;

  ${(0, $85EiT.media).below.sm} {
    height: 100%;
    margin: 0;
    justify-content: flex-start;
  }
`;
const $84f1b6f2637f73c4$var$FooterSpacer = (0, $fbSBq.default).div`
  ${(0, $85EiT.media).below.sm} {
    margin: auto;
  }
`;
const $84f1b6f2637f73c4$export$c0881a38d60c6658 = ({ header: header, children: children, footer: footer, whiteboxFooter: whiteboxFooter, isLoading: isLoading, pageId: pageId, noCobranding: noCobranding })=>{
    const { cobranding: cobranding, isMobileApp: isMobileApp } = (0, $2eVHl.useCobranding)();
    const resolvedCobranding = noCobranding ? (0, $2eVHl.SimpleCobranding).NO_COBRANDING : cobranding;
    const { background: Background, logo: logo, footerProducts: footerProducts, whiteboxWidth: whiteboxWidth, hideWhiteboxBorder: hideWhiteboxBorder } = (0, $dwXRl.getCobrandedComponents)(resolvedCobranding);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $a6oyj.default), {
        children: /*#__PURE__*/ (0, $6CtE1.jsx)(Background, {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)($84f1b6f2637f73c4$var$Container, {
                id: "WhiteboxContainer",
                children: /*#__PURE__*/ (0, $6CtE1.jsxs)($84f1b6f2637f73c4$var$Whitebox, {
                    width: whiteboxWidth,
                    noBorder: hideWhiteboxBorder,
                    children: [
                        /*#__PURE__*/ (0, $6CtE1.jsx)("section", {
                            role: "main",
                            children: isLoading ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $493Hj.LoadingSpinner), {
                                testId: "whitebox-loading-spinner"
                            }) : /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $1u5P2.ProductHeading), {
                                        suffix: header,
                                        children: logo && (0, $4M4Zx.renderProductLogo)(logo)
                                    }),
                                    children,
                                    whiteboxFooter && /*#__PURE__*/ (0, $6CtE1.jsx)($84f1b6f2637f73c4$export$bad5896fb5d45c0b, {
                                        children: whiteboxFooter
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $6CtE1.jsx)($84f1b6f2637f73c4$var$FooterSpacer, {}),
                        /*#__PURE__*/ (0, $6CtE1.jsxs)($84f1b6f2637f73c4$export$ba9d4abe45514a38, {
                            children: [
                                footerProducts && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dwGfa.default), {
                                    renderText: !isMobileApp,
                                    pageId: pageId,
                                    footerProducts: footerProducts
                                }),
                                footer
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $84f1b6f2637f73c4$export$2e2bcd8739ae039 = $84f1b6f2637f73c4$export$c0881a38d60c6658;

});
parcelRegister("a6oyj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75ad8283052c66df$export$2e2bcd8739ae039; });

var $aCGQL = parcelRequire("aCGQL");

var $aGJFa = parcelRequire("aGJFa");

var $3LyKt = parcelRequire("3LyKt");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$75ad8283052c66df$export$2e2bcd8739ae039 = (0, $aCGQL.default);

});
parcelRegister("aCGQL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bbeb11a81d8a29f$export$2e2bcd8739ae039; });
/* page.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $eOb4y = parcelRequire("eOb4y");
var $7bbeb11a81d8a29f$var$styles = {
    banner: "_1bsb1osq _kqsw1n9t",
    bannerContainer: "_16jlkb7n _1o9zidpf _i0dl1wug _v564evma _1bsb1osq _kqswh2mm _1pby11wp",
    pageContent: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _kqswh2mm _1pbykb7n",
    wrapper: "_1e0c1txw _1bsb1osq _1tke1osq _2lx21bp4",
    mainContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw",
    navigation: "_kqswh2mm _1pbycs5v"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $7bbeb11a81d8a29f$var$Page = function Page(_ref) {
    var _ref$isBannerOpen = _ref.isBannerOpen, isBannerOpen = _ref$isBannerOpen === void 0 ? false : _ref$isBannerOpen, _ref$bannerHeight = _ref.bannerHeight, bannerHeight = _ref$bannerHeight === void 0 ? (0, $eOb4y.defaultBannerHeight) : _ref$bannerHeight, banner = _ref.banner, navigation = _ref.navigation, children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $dNMDr.createElement("div", {
        "data-testid": testId,
        className: (0, $affTb.default)([
            $7bbeb11a81d8a29f$var$styles.wrapper
        ])
    }, banner ? /*#__PURE__*/ $dNMDr.createElement("div", {
        style: {
            height: isBannerOpen ? "".concat(bannerHeight, "px") : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? "".concat(testId, "--banner-container") : undefined,
        className: (0, $affTb.default)([
            $7bbeb11a81d8a29f$var$styles.bannerContainer
        ])
    }, /*#__PURE__*/ $dNMDr.createElement("div", {
        className: (0, $affTb.default)([
            $7bbeb11a81d8a29f$var$styles.banner
        ])
    }, banner)) : null, /*#__PURE__*/ $dNMDr.createElement("div", {
        className: (0, $affTb.default)([
            $7bbeb11a81d8a29f$var$styles.mainContainer
        ])
    }, /*#__PURE__*/ $dNMDr.createElement("div", {
        className: (0, $affTb.default)([
            $7bbeb11a81d8a29f$var$styles.navigation
        ])
    }, navigation), /*#__PURE__*/ $dNMDr.createElement("div", {
        className: (0, $affTb.default)([
            $7bbeb11a81d8a29f$var$styles.pageContent
        ])
    }, children)));
};
var $7bbeb11a81d8a29f$export$2e2bcd8739ae039 = $7bbeb11a81d8a29f$var$Page;

});
parcelRegister("eOb4y", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", function () { return $ac7e52fbcfb2707c$export$74797698e12f8baa; });
$parcel$export(module.exports, "spacingMapping", function () { return $ac7e52fbcfb2707c$export$2a89a65a43bab52d; });
$parcel$export(module.exports, "defaultSpacing", function () { return $ac7e52fbcfb2707c$export$8ec7372efd74b753; });
$parcel$export(module.exports, "defaultBannerHeight", function () { return $ac7e52fbcfb2707c$export$d77f83c3d17a7b8a; });
$parcel$export(module.exports, "defaultMedium", function () { return $ac7e52fbcfb2707c$export$f8725d21f81f3e01; });
$parcel$export(module.exports, "defaultLayout", function () { return $ac7e52fbcfb2707c$export$2303d2bd9eeff99a; });
var $ac7e52fbcfb2707c$var$defaultGridSize = 8;
var $ac7e52fbcfb2707c$export$74797698e12f8baa = 12;
var $ac7e52fbcfb2707c$export$b8241a1616ab1b96 = $ac7e52fbcfb2707c$var$defaultGridSize * 10;
var $ac7e52fbcfb2707c$export$2a89a65a43bab52d = {
    comfortable: $ac7e52fbcfb2707c$var$defaultGridSize * 5,
    cosy: $ac7e52fbcfb2707c$var$defaultGridSize * 2,
    compact: $ac7e52fbcfb2707c$var$defaultGridSize * 0.5
};
var $ac7e52fbcfb2707c$export$8ec7372efd74b753 = 'cosy';
var $ac7e52fbcfb2707c$export$d77f83c3d17a7b8a = 52;
var $ac7e52fbcfb2707c$export$f8725d21f81f3e01 = 0;
var $ac7e52fbcfb2707c$export$2303d2bd9eeff99a = 'fixed';
var $ac7e52fbcfb2707c$export$9ddc3632bbfb8966 = '--ds-columns-num';
var $ac7e52fbcfb2707c$export$8b7e31f391e6e681 = '--ds-column-span';
var $ac7e52fbcfb2707c$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("aGJFa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c813f56ddabe871$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $eOb4y = parcelRequire("eOb4y");

var $dspQ6 = parcelRequire("dspQ6");

var $3LyKt = parcelRequire("3LyKt");

var $8JZOS = parcelRequire("8JZOS");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $7c813f56ddabe871$var$GridWrapper = function GridWrapper(_ref) {
    var _ref2, _ref3, _theme$isNestedGrid;
    var spacingProp = _ref.spacing, columnsProp = _ref.columns, layout = _ref.layout, testId = _ref.testId, children = _ref.children, theme = _ref.theme;
    /**
   * isRoot is `true` only in the default context (i.e. no ancestor Grid).
   */ var _useContext = (0, $dNMDr.useContext)((0, $8JZOS.GridContext)), isRoot = _useContext.isRoot;
    var _useContext2 = (0, $dNMDr.useContext)((0, $3LyKt.GridColumnContext)), medium = _useContext2.medium;
    /**
   * The colspan of the current containing GridColumn provides
   * the default amount of columns in a nested grid.
   */ var defaultColumns = medium > 0 ? medium : (0, $eOb4y.defaultGridColumns);
    /**
   * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
   * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
   */ var spacing = (_ref2 = spacingProp !== null && spacingProp !== void 0 ? spacingProp : theme === null || theme === void 0 ? void 0 : theme.spacing) !== null && _ref2 !== void 0 ? _ref2 : (0, $eOb4y.defaultSpacing);
    var columns = (_ref3 = columnsProp !== null && columnsProp !== void 0 ? columnsProp : theme === null || theme === void 0 ? void 0 : theme.columns) !== null && _ref3 !== void 0 ? _ref3 : defaultColumns;
    var isNested = (_theme$isNestedGrid = theme === null || theme === void 0 ? void 0 : theme.isNestedGrid) !== null && _theme$isNestedGrid !== void 0 ? _theme$isNestedGrid : !isRoot;
    var contextValue = (0, $dNMDr.useMemo)(function() {
        return {
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        };
    }, [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $8JZOS.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dspQ6.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $7c813f56ddabe871$export$2e2bcd8739ae039 = $7c813f56ddabe871$var$GridWrapper;

});
parcelRegister("dspQ6", function(module, exports) {

$parcel$export(module.exports, "Grid", function () { return $9cc1ef09d29f6045$export$ef2184bd89960b14; });
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $eOb4y = parcelRequire("eOb4y");

var $8JZOS = parcelRequire("8JZOS");
var $9cc1ef09d29f6045$var$defaultGridColumnWidth = 80;
/**
 * The number of available columns in each row.
 */ var $9cc1ef09d29f6045$var$varColumnsNum = '--ds-columns-num';
/**
 * The spacing (in `px`) between each column.
 */ var $9cc1ef09d29f6045$var$varGridSpacing = '--ds-grid-spacing';
var $9cc1ef09d29f6045$var$styles = {
    grid: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3wx3y _n3tdidpf _19bvwx3y _1e0c1txw _kqswh2mm _4cvr1y6m _1n261g80",
    nestedGrid: "_19pkidpf _2hwx1un2 _otyridpf _18u01un2"
};
var $9cc1ef09d29f6045$var$gridLayoutMapStyles = {
    fixed: "_p12fgkkb",
    fluid: "_p12f1osq"
};
var $9cc1ef09d29f6045$export$ef2184bd89960b14 = function Grid(_ref) {
    var _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? (0, $eOb4y.defaultLayout) : _ref$layout, testId = _ref.testId, children = _ref.children;
    var _useContext = (0, $dNMDr.useContext)((0, $8JZOS.GridContext)), isNested = _useContext.isNested, columns = _useContext.columns, spacing = _useContext.spacing;
    return /*#__PURE__*/ $dNMDr.createElement("div", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, $9cc1ef09d29f6045$var$varColumnsNum, columns), $9cc1ef09d29f6045$var$varGridSpacing, "".concat((0, $eOb4y.spacingMapping)[spacing], "px")),
        "data-testid": testId,
        className: (0, $affTb.default)([
            $9cc1ef09d29f6045$var$styles.grid,
            $9cc1ef09d29f6045$var$gridLayoutMapStyles[layout],
            isNested && $9cc1ef09d29f6045$var$styles.nestedGrid
        ])
    }, children);
};

});
parcelRegister("8JZOS", function(module, exports) {

$parcel$export(module.exports, "GridContext", function () { return $65d27acb436ffcfa$export$11cae3e04ab99fae; });

var $dNMDr = parcelRequire("dNMDr");

var $eOb4y = parcelRequire("eOb4y");
var $65d27acb436ffcfa$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $dNMDr.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $eOb4y.defaultSpacing),
    columns: (0, $eOb4y.defaultGridColumns)
});

});


parcelRegister("3LyKt", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", function () { return $2be0b739df58c8d5$export$1229ad7112b989f5; });
$parcel$export(module.exports, "default", function () { return $2be0b739df58c8d5$export$2e2bcd8739ae039; });
/* grid-column.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $eOb4y = parcelRequire("eOb4y");

var $8JZOS = parcelRequire("8JZOS");
/**
 * Determines the method by which column width is calculated.
 */ var $2be0b739df58c8d5$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($2be0b739df58c8d5$var$ColumnVariant || {});
/**
 * The spacing (in `px`) between each column.
 */ var $2be0b739df58c8d5$var$varGridSpacing = '--ds-grid-spacing';
/**
 * The number of columns that a `GridColumn` covers.
 */ var $2be0b739df58c8d5$var$varColumnSpan = '--ds-column-span';
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ var $2be0b739df58c8d5$var$singleColumnWidth = "(99.9999% / var(--ds-columns-num))";
var $2be0b739df58c8d5$var$styles = {
    gridColumn: "_19pkidpf _2hwxwx3y _otyridpf _18u0wx3y _1ul9hrtj _16jlkb7n _1o9zidpf _slp31hna"
};
var $2be0b739df58c8d5$var$gridColumnWidthMapStyles = {
    auto: "_p12f1ho1 _i0dl1wug",
    bounded: "_p12fpg3g _i0dl1osq",
    fullWidth: "_p12f1ho1 _i0dl1osq"
};
var $2be0b739df58c8d5$var$getVariant = function getVariant(_ref) {
    var medium = _ref.medium, columns = _ref.columns;
    if (medium === (0, $eOb4y.defaultMedium)) return $2be0b739df58c8d5$var$ColumnVariant.Auto;
    else if (medium < columns) return $2be0b739df58c8d5$var$ColumnVariant.Bounded;
    return $2be0b739df58c8d5$var$ColumnVariant.FullWidth;
};
var $2be0b739df58c8d5$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $dNMDr.createContext)({
    medium: (0, $eOb4y.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $2be0b739df58c8d5$var$GridColumn = function GridColumn(_ref2) {
    var _ref2$medium = _ref2.medium, medium = _ref2$medium === void 0 ? (0, $eOb4y.defaultMedium) : _ref2$medium, children = _ref2.children, testId = _ref2.testId;
    var _useContext = (0, $dNMDr.useContext)((0, $8JZOS.GridContext)), columns = _useContext.columns;
    var contextValue = (0, $dNMDr.useMemo)(function() {
        return {
            medium: medium
        };
    }, [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ var colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ var variant = $2be0b739df58c8d5$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ $dNMDr.createElement($2be0b739df58c8d5$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $dNMDr.createElement("div", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, $2be0b739df58c8d5$var$varColumnSpan, variant === $2be0b739df58c8d5$var$ColumnVariant.Auto ? 'auto' : colSpan),
        "data-testid": testId,
        className: (0, $affTb.default)([
            $2be0b739df58c8d5$var$styles.gridColumn,
            $2be0b739df58c8d5$var$gridColumnWidthMapStyles[variant]
        ])
    }, children));
};
var $2be0b739df58c8d5$export$2e2bcd8739ae039 = $2be0b739df58c8d5$var$GridColumn;

});



parcelRegister("85EiT", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $5e3e0dd9f03045e7$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $5e3e0dd9f03045e7$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});

parcelRegister("iHqPX", function(module, exports) {

$parcel$export(module.exports, "colorPalette", function () { return $96221664a21acb4e$export$569885e57444f84a; });

var $l4KzN = parcelRequire("l4KzN");
const $96221664a21acb4e$export$569885e57444f84a = {
    primaryNavy: (0, $l4KzN).N800,
    primaryBlue: (0, $l4KzN).B500,
    primaryWhite: (0, $l4KzN).N0,
    secondaryRed: (0, $l4KzN).R300,
    secondaryYellow: (0, $l4KzN).Y300,
    secondaryGreen: (0, $l4KzN).G300,
    secondaryCyan: (0, $l4KzN).P300,
    secondaryPurple: (0, $l4KzN).T300
};

});

parcelRegister("dwXRl", function(module, exports) {

$parcel$export(module.exports, "getCobrandedComponents", function () { return $3fc9373b585c3d54$export$7f88f5c61e80b9ef; });

var $2eVHl = parcelRequire("2eVHl");

var $c0cu2 = parcelRequire("c0cu2");

var $4iy0T = parcelRequire("4iy0T");

var $4umpV = parcelRequire("4umpV");

var $kvSD4 = parcelRequire("kvSD4");

var $3CKf4 = parcelRequire("3CKf4");

var $jAWjL = parcelRequire("jAWjL");

var $kEvck = parcelRequire("kEvck");

var $l63uI = parcelRequire("l63uI");

var $2sa3K = parcelRequire("2sa3K");

var $60pxs = parcelRequire("60pxs");

var $akcow = parcelRequire("akcow");

var $3ltyG = parcelRequire("3ltyG");

var $8njUs = parcelRequire("8njUs");

var $efbp7 = parcelRequire("efbp7");

var $9P5Ni = parcelRequire("9P5Ni");

var $br6ws = parcelRequire("br6ws");
const $3fc9373b585c3d54$var$cobrandingMap = {
    [(0, $2eVHl.SimpleCobranding).ADMIN]: (0, $c0cu2.default),
    [(0, $2eVHl.SimpleCobranding).ATLAS]: (0, $akcow.default),
    [(0, $2eVHl.SimpleCobranding).BITBUCKET]: (0, $4iy0T.default),
    [(0, $2eVHl.SimpleCobranding).COMMUNITY]: (0, $3CKf4.default),
    [(0, $2eVHl.SimpleCobranding).COMPASS]: (0, $4umpV.default),
    [(0, $2eVHl.SimpleCobranding).CONFLUENCE]: (0, $kvSD4.default),
    [(0, $2eVHl.SimpleCobranding).JIRA]: (0, $jAWjL.default),
    [(0, $2eVHl.SimpleCobranding).JIRA_ALIGN]: (0, $8njUs.default),
    [(0, $2eVHl.SimpleCobranding).LOOM]: (0, $3ltyG.default),
    [(0, $2eVHl.SimpleCobranding).NO_COBRANDING]: (0, $c0cu2.default),
    [(0, $2eVHl.SimpleCobranding).OPSGENIE]: (0, $kEvck.default),
    [(0, $2eVHl.SimpleCobranding).PRT]: (0, $c0cu2.default),
    [(0, $2eVHl.SimpleCobranding).ROVO]: (0, $br6ws.default),
    [(0, $2eVHl.SimpleCobranding).SAC]: (0, $c0cu2.default),
    [(0, $2eVHl.SimpleCobranding).STATUSPAGE]: (0, $l63uI.default),
    [(0, $2eVHl.SimpleCobranding).SUPPORT]: (0, $c0cu2.default),
    [(0, $2eVHl.SimpleCobranding).TRELLO]: (0, $2sa3K.default),
    [(0, $2eVHl.SimpleCobranding).WAC]: (0, $60pxs.default),
    // Advanced Cobranding
    [(0, $2eVHl.AdvancedCobranding).ACCOUNT_LINKING]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).ATLAS_66195]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).CFIND_2409]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).CONFLUENCE_ATLAS_75650]: (0, $9P5Ni.default),
    [(0, $2eVHl.AdvancedCobranding).DEMO]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).ENTRY_AUTH]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).CHAMPION_APPLY]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).CHAMPION_CONSENT]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).ISOLATED_CLOUD]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).JIRA_ATLAS_75650]: (0, $efbp7.default),
    [(0, $2eVHl.AdvancedCobranding).PRT_DEMO]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).SERVICE_COLLECTION]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).TEAMWORK_COLLECTION]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).TWCG_1160_CONFLUENCE]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).TWCG_1160_JIRA]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).TWCG_786_PRIORITISE_SSO_ON_LOGIN_PAGE]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).TWCG_1293_FTA_OTP]: (0, $jAWjL.default),
    [(0, $2eVHl.AdvancedCobranding).WAC_JPD]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).TRELLO]: (0, $2sa3K.default),
    [(0, $2eVHl.AdvancedCobranding).WAC_JSM]: (0, $c0cu2.default),
    [(0, $2eVHl.AdvancedCobranding).WAC_LOOM]: (0, $c0cu2.default),
    default: (0, $c0cu2.default)
};
const $3fc9373b585c3d54$export$7f88f5c61e80b9ef = (cobranding)=>{
    if ((0, $2eVHl.isSimpleCobranding)(cobranding) || (0, $2eVHl.isAdvancedCobranding)(cobranding)) return $3fc9373b585c3d54$var$cobrandingMap[cobranding];
    else {
        console.warn(`[COBRANDING] ${cobranding} is globally configured for advanced-cobranding but corresponding configuration for ${window.location.pathname} was not provided. Loading SimpleCobranding.NO_BRANDING as fallback.`);
        return $3fc9373b585c3d54$var$cobrandingMap[(0, $2eVHl.SimpleCobranding).NO_COBRANDING];
    }
};

});
parcelRegister("c0cu2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2837801687cca16$export$2e2bcd8739ae039; });

var $723m6 = parcelRequire("723m6");

var $4M4Zx = parcelRequire("4M4Zx");

var $pCpQH = parcelRequire("pCpQH");

var $bvi9r = parcelRequire("bvi9r");
const $e2837801687cca16$export$f2683fd6d2de1a37 = (0, $4M4Zx.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($pCpQH))), (0, (/*@__PURE__*/$parcel$interopDefault($bvi9r))));
const $e2837801687cca16$var$DefaultCobranding = {
    background: $e2837801687cca16$export$f2683fd6d2de1a37,
    logo: {
        component: (0, $723m6.AtlassianLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $e2837801687cca16$export$2e2bcd8739ae039 = $e2837801687cca16$var$DefaultCobranding;

});
parcelRegister("4M4Zx", function(module, exports) {

$parcel$export(module.exports, "whiteboxWidthDesktop", function () { return $00b250aa1dd9ec13$export$4dacb4c23fc28876; });
$parcel$export(module.exports, "whiteboxWidthHandheld", function () { return $00b250aa1dd9ec13$export$6bfb439877eddd98; });
$parcel$export(module.exports, "linkStyles", function () { return $00b250aa1dd9ec13$export$4ea5976125a01ffa; });
$parcel$export(module.exports, "listStyles", function () { return $00b250aa1dd9ec13$export$f9b6c540022859c0; });
$parcel$export(module.exports, "DefaultBackground", function () { return $00b250aa1dd9ec13$export$cffd0b81d0e051b1; });
$parcel$export(module.exports, "backgroundWithSideImages", function () { return $00b250aa1dd9ec13$export$c9af51660ef2db22; });
$parcel$export(module.exports, "backgroundWithImage", function () { return $00b250aa1dd9ec13$export$860f6dae4486c905; });
$parcel$export(module.exports, "renderProductLogo", function () { return $00b250aa1dd9ec13$export$390d73d0230797c4; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $j0VD5 = parcelRequire("j0VD5");

var $iHqPX = parcelRequire("iHqPX");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");
const $00b250aa1dd9ec13$export$4dacb4c23fc28876 = `${(0, $68HQw.gridSize)() * 50}px`;
const $00b250aa1dd9ec13$export$6bfb439877eddd98 = `${(0, $68HQw.gridSize)() * 40}px`;
const $00b250aa1dd9ec13$export$7970b24609d80d2d = (0, $fbSBq.default).div`
  ${(0, $j0VD5.media).handheld`
    display: none;
  `};
`;
const $00b250aa1dd9ec13$export$97b346657ff4770f = (0, $fbSBq.default).div`
  display: none;

  ${(0, $j0VD5.media).handheld`
    display: inline-block;
  `};
`;
const $00b250aa1dd9ec13$export$4ea5976125a01ffa = (color)=>`
   a {
      color: ${color};

      &:hover {
        color: ${color};
      }
      &.hover {
        color: ${color};
      }
   }
`;
const $00b250aa1dd9ec13$export$f9b6c540022859c0 = `
    ul {
      display: flex;
      justify-content: center;
      list-style: none;
      padding: 0;
    }
`;
const $00b250aa1dd9ec13$export$cffd0b81d0e051b1 = (0, $fbSBq.default).div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: ${(0, $l4KzN).N10};
  ${(0, $j0VD5.media).handheld`
    background: ${(0, $iHqPX.colorPalette).primaryWhite};
    color: ${(0, $iHqPX.colorPalette).primaryNavy};
  `}
`;
function $00b250aa1dd9ec13$export$c9af51660ef2db22(leftImageSrc, rightImageSrc) {
    const scalingImagesMaxWidth = `${(0, $68HQw.gridSize)() * 150}px`; //50 grid size for whitebox + 2 * 50 grid size for images
    const widescreenBackgroundImageSize = `calc((100vw - ${$00b250aa1dd9ec13$export$4dacb4c23fc28876})/2 - ${(0, $68HQw.gridSize)() * 4}px) auto`;
    return (0, $fbSBq.default)($00b250aa1dd9ec13$export$cffd0b81d0e051b1)`
    background-image: url(${leftImageSrc}), url(${rightImageSrc});
    background-repeat: no-repeat, no-repeat;
    background-attachment: fixed, fixed;
    background-size: ${(0, $68HQw.gridSize)() * 46}px auto, ${(0, $68HQw.gridSize)() * 46}px auto;
    background-position: left bottom, right bottom;

    @media (max-width: ${scalingImagesMaxWidth}) {
      background-size: ${widescreenBackgroundImageSize}, ${widescreenBackgroundImageSize}, cover;
    }

    ${(0, $j0VD5.media).handheld`
      background: ${(0, $iHqPX.colorPalette).primaryWhite};
      color: ${(0, $iHqPX.colorPalette).primaryNavy};
    `}
  `;
}
function $00b250aa1dd9ec13$export$860f6dae4486c905(bgImageSrc) {
    return (0, $fbSBq.default)($00b250aa1dd9ec13$export$cffd0b81d0e051b1)`
    background-image: url(${bgImageSrc});
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;

    ${(0, $j0VD5.media).handheld`
      background: ${(0, $iHqPX.colorPalette).primaryWhite};
      color: ${(0, $iHqPX.colorPalette).primaryNavy};
    `}
  `;
}
const $00b250aa1dd9ec13$export$390d73d0230797c4 = (props)=>{
    if ('renderLogo' in props) // is a custom logo
    return props.renderLogo();
    const { component: AtlaskitLogo } = props;
    return /*#__PURE__*/ (0, $6CtE1.jsx)(AtlaskitLogo, {
        appearance: "brand",
        size: "large",
        shouldUseNewLogoDesign: true
    });
};

});

parcelRegister("pCpQH", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "default_left.558fbf68.svg";

});

parcelRegister("bvi9r", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "default_right.f8462257.svg";

});


parcelRegister("4iy0T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80bd653d4ba9d2ea$export$2e2bcd8739ae039; });

var $hZQpa = parcelRequire("hZQpa");

var $NenZ7 = parcelRequire("NenZ7");
const $80bd653d4ba9d2ea$var$BitbucketCobranding = {
    background: (0, $NenZ7.BitbucketBackground),
    logo: {
        component: (0, $hZQpa.BitbucketLogo)
    },
    footerProducts: 'Bitbucket, Jira, Confluence'
};
var $80bd653d4ba9d2ea$export$2e2bcd8739ae039 = $80bd653d4ba9d2ea$var$BitbucketCobranding;

});
parcelRegister("hZQpa", function(module, exports) {

$parcel$export(module.exports, "HomeLogo", function () { return $d1a0c8b1ef47fbc1$export$d5648119d5b68e90; });
$parcel$export(module.exports, "BitbucketIcon", function () { return $d1a0c8b1ef47fbc1$export$5fc1066e677788d4; });
$parcel$export(module.exports, "BitbucketLogo", function () { return $d1a0c8b1ef47fbc1$export$bd40525f5333524b; });
$parcel$export(module.exports, "CompassLogo", function () { return $d1a0c8b1ef47fbc1$export$eb7d748e4f9c9676; });
$parcel$export(module.exports, "ConfluenceIcon", function () { return $d1a0c8b1ef47fbc1$export$68f3db7f6af48bcb; });
$parcel$export(module.exports, "ConfluenceLogo", function () { return $d1a0c8b1ef47fbc1$export$1b2e4fe6ef471556; });
$parcel$export(module.exports, "JiraAlignLogo", function () { return $d1a0c8b1ef47fbc1$export$ee11e928d3d045fd; });
$parcel$export(module.exports, "JiraIcon", function () { return $d1a0c8b1ef47fbc1$export$c4b5b1f965d8b3eb; });
$parcel$export(module.exports, "JiraLogo", function () { return $d1a0c8b1ef47fbc1$export$17d3acb0b4379d02; });
$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $d1a0c8b1ef47fbc1$export$21bfbeb62fdcce8d; });
$parcel$export(module.exports, "JiraProductDiscoveryLogo", function () { return $d1a0c8b1ef47fbc1$export$c49a2b642fe9eef4; });
$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $d1a0c8b1ef47fbc1$export$3c6158790f5e01c4; });
$parcel$export(module.exports, "JiraServiceManagementLogo", function () { return $d1a0c8b1ef47fbc1$export$dabef2be6cd28c20; });
$parcel$export(module.exports, "LoomLogo", function () { return $d1a0c8b1ef47fbc1$export$94e206806e36c2ec; });
$parcel$export(module.exports, "OpsgenieLogo", function () { return $d1a0c8b1ef47fbc1$export$a1c6484cdecc2c4b; });
$parcel$export(module.exports, "StatuspageLogo", function () { return $d1a0c8b1ef47fbc1$export$bb4ae5b41b43be04; });
$parcel$export(module.exports, "TrelloLogo", function () { return $d1a0c8b1ef47fbc1$export$60e26212f3b61a28; });
$parcel$export(module.exports, "RovoIcon", function () { return $d1a0c8b1ef47fbc1$export$e23ae35269442b4f; });
$parcel$export(module.exports, "RovoLogo", function () { return $d1a0c8b1ef47fbc1$export$a0f6cb8061290bbb; });

var $gmT5h = parcelRequire("gmT5h");
var $6s7Mu = parcelRequire("6s7Mu");

var $3c64L = parcelRequire("3c64L");
var $8YZSX = parcelRequire("8YZSX");

var $brOGF = parcelRequire("brOGF");
var $c72nZ = parcelRequire("c72nZ");

var $90q7Y = parcelRequire("90q7Y");
var $8pC02 = parcelRequire("8pC02");

var $jylyi = parcelRequire("jylyi");
var $5dQzk = parcelRequire("5dQzk");

var $66W9l = parcelRequire("66W9l");
var $6rNlQ = parcelRequire("6rNlQ");

var $7z4Yy = parcelRequire("7z4Yy");
var $1cJQG = parcelRequire("1cJQG");

var $9snFG = parcelRequire("9snFG");
var $g95yP = parcelRequire("g95yP");

var $iSBY8 = parcelRequire("iSBY8");
var $fdtsy = parcelRequire("fdtsy");

var $jM9Tj = parcelRequire("jM9Tj");
var $97zqD = parcelRequire("97zqD");

var $aqOQp = parcelRequire("aqOQp");
var $b33vU = parcelRequire("b33vU");

var $7D32i = parcelRequire("7D32i");
var $eppq9 = parcelRequire("eppq9");

var $jSWn9 = parcelRequire("jSWn9");
var $azXpi = parcelRequire("azXpi");

var $63Bd1 = parcelRequire("63Bd1");
var $eWVVV = parcelRequire("eWVVV");

var $bHp0G = parcelRequire("bHp0G");

var $fw4qJ = parcelRequire("fw4qJ");
var $jOiCV = parcelRequire("jOiCV");

var $TcXzV = parcelRequire("TcXzV");
var $jZYnH = parcelRequire("jZYnH");

var $iimwL = parcelRequire("iimwL");
var $2Y5sL = parcelRequire("2Y5sL");

var $a7KWX = parcelRequire("a7KWX");
var $kU0Ro = parcelRequire("kU0Ro");

var $dDN4j = parcelRequire("dDN4j");
var $8TOE0 = parcelRequire("8TOE0");

var $6oIdM = parcelRequire("6oIdM");
var $4moWO = parcelRequire("4moWO");

var $h09wv = parcelRequire("h09wv");
var $2xOsu = parcelRequire("2xOsu");

var $7j0uU = parcelRequire("7j0uU");
var $QkWKb = parcelRequire("QkWKb");

var $9WmEC = parcelRequire("9WmEC");
var $bhguv = parcelRequire("bhguv");

var $jN93Q = parcelRequire("jN93Q");
var $3iwKC = parcelRequire("3iwKC");

var $1F0p0 = parcelRequire("1F0p0");
var $c6flR = parcelRequire("c6flR");

var $kxKxH = parcelRequire("kxKxH");

var $ldRHo = parcelRequire("ldRHo");
var $40xaM = parcelRequire("40xaM");

var $eSWUM = parcelRequire("eSWUM");
var $asErn = parcelRequire("asErn");

var $adgI9 = parcelRequire("adgI9");
var $7iDcJ = parcelRequire("7iDcJ");

var $hRc7Y = parcelRequire("hRc7Y");
var $4fPIx = parcelRequire("4fPIx");

var $85J9d = parcelRequire("85J9d");
var $8vS8J = parcelRequire("8vS8J");

var $7euW2 = parcelRequire("7euW2");
var $6Orwr = parcelRequire("6Orwr");

var $kr1t0 = parcelRequire("kr1t0");
var $2aEpX = parcelRequire("2aEpX");

var $T9m1r = parcelRequire("T9m1r");
var $ghgPR = parcelRequire("ghgPR");

var $5UQfy = parcelRequire("5UQfy");
var $fGMRc = parcelRequire("fGMRc");

var $bjjwo = parcelRequire("bjjwo");
var $kKaGJ = parcelRequire("kKaGJ");

var $l3aHx = parcelRequire("l3aHx");
var $9h4B2 = parcelRequire("9h4B2");

var $iTWHB = parcelRequire("iTWHB");
var $882kU = parcelRequire("882kU");

var $8D2aP = parcelRequire("8D2aP");
var $62tJk = parcelRequire("62tJk");

var $8LuO2 = parcelRequire("8LuO2");
var $ftCkt = parcelRequire("ftCkt");

var $fgHZI = parcelRequire("fgHZI");
var $8uu6Y = parcelRequire("8uu6Y");

var $lQm3x = parcelRequire("lQm3x");
var $afkKc = parcelRequire("afkKc");

var $fi4B8 = parcelRequire("fi4B8");
var $24DdC = parcelRequire("24DdC");

var $1aygb = parcelRequire("1aygb");
var $goOsv = parcelRequire("goOsv");

var $djyDV = parcelRequire("djyDV");
var $a2IuZ = parcelRequire("a2IuZ");

var $9QN60 = parcelRequire("9QN60");
var $1TaAG = parcelRequire("1TaAG");

var $gd41c = parcelRequire("gd41c");
var $exRVd = parcelRequire("exRVd");

var $1M4Uw = parcelRequire("1M4Uw");
var $7fJSi = parcelRequire("7fJSi");

var $22DqA = parcelRequire("22DqA");
var $fFWp2 = parcelRequire("fFWp2");

var $9lD8w = parcelRequire("9lD8w");
var $6fM0U = parcelRequire("6fM0U");

var $bLGDU = parcelRequire("bLGDU");
var $6wQv8 = parcelRequire("6wQv8");

var $bGjtm = parcelRequire("bGjtm");
var $kW7SU = parcelRequire("kW7SU");

var $bJp6k = parcelRequire("bJp6k");
var $73xRJ = parcelRequire("73xRJ");

var $awyVU = parcelRequire("awyVU");
var $icHzk = parcelRequire("icHzk");

var $93yWJ = parcelRequire("93yWJ");
var $4hujc = parcelRequire("4hujc");

var $bpkb7 = parcelRequire("bpkb7");
var $doffx = parcelRequire("doffx");

var $vXFdf = parcelRequire("vXFdf");
var $hv1FQ = parcelRequire("hv1FQ");

var $3vfCH = parcelRequire("3vfCH");
var $cymz4 = parcelRequire("cymz4");

var $9MViD = parcelRequire("9MViD");
var $f4jmm = parcelRequire("f4jmm");





var $723m6 = parcelRequire("723m6");


var $ksDXb = parcelRequire("ksDXb");
/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $d1a0c8b1ef47fbc1$export$ef8e5f836dd989d3 = (0, $ksDXb.tempSizeWrapper)((0, $gmT5h.AdminIcon));
var $d1a0c8b1ef47fbc1$export$ebcd30672e67406 = (0, $ksDXb.tempSizeWrapper)((0, $6s7Mu.AdminLogoCS));
var $d1a0c8b1ef47fbc1$export$af3460f51ce3602a = (0, $ksDXb.tempSizeWrapper)((0, $brOGF.AnalyticsIcon));
var $d1a0c8b1ef47fbc1$export$c8415b6abe4a8587 = (0, $ksDXb.tempSizeWrapper)((0, $c72nZ.AnalyticsLogoCS));
var $d1a0c8b1ef47fbc1$export$d89497e7f33ca6f5 = (0, $ksDXb.tempSizeWrapper)((0, $90q7Y.AssetsIcon));
var $d1a0c8b1ef47fbc1$export$48ca930f3071e3e4 = (0, $ksDXb.tempSizeWrapper)((0, $8pC02.AssetsLogoCS));
var $d1a0c8b1ef47fbc1$export$52cd484a7ef4f2b9 = (0, $ksDXb.teamEUFlaggedIcon)((0, $9snFG.ChatIcon), (0, $iSBY8.ChatNewIcon));
var $d1a0c8b1ef47fbc1$export$9ca9881809919df8 = (0, $ksDXb.teamEUFlaggedIcon)((0, $g95yP.ChatLogoCS), (0, $fdtsy.ChatNewLogoCS));
/**
 * __Customer Service Management icon__
 *
 * The Customer service management icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $d1a0c8b1ef47fbc1$export$6da5aa77c402ba0f = (0, $ksDXb.tempSizeWrapper)((0, $63Bd1.CustomerServiceManagementIcon));
var $d1a0c8b1ef47fbc1$export$abc95e6180bb1d88 = (0, $ksDXb.tempSizeWrapper)((0, $eWVVV.CustomerServiceManagementLogoCS));
var $d1a0c8b1ef47fbc1$export$9eb74917ea768ed4 = (0, $ksDXb.tempSizeWrapper)((0, $TcXzV.GoalsIcon));
var $d1a0c8b1ef47fbc1$export$d2577aa28451395f = (0, $ksDXb.tempSizeWrapper)((0, $jZYnH.GoalsLogoCS));
var $d1a0c8b1ef47fbc1$export$92c8767b874048d = (0, $ksDXb.tempSizeWrapper)((0, $a7KWX.HomeIcon));
var $d1a0c8b1ef47fbc1$export$d5648119d5b68e90 = (0, $ksDXb.tempSizeWrapper)((0, $kU0Ro.HomeLogoCS));
var $d1a0c8b1ef47fbc1$export$80b8b269d8b5014e = (0, $ksDXb.tempSizeWrapper)((0, $dDN4j.HubIcon));
var $d1a0c8b1ef47fbc1$export$fc9bd6687b80fe3b = (0, $ksDXb.tempSizeWrapper)((0, $8TOE0.HubLogoCS));
var $d1a0c8b1ef47fbc1$export$5ed3e1bb3b04fc02 = (0, $ksDXb.tempSizeWrapper)((0, $adgI9.ProjectsIcon));
var $d1a0c8b1ef47fbc1$export$aeefab651bcf2338 = (0, $ksDXb.tempSizeWrapper)((0, $7iDcJ.ProjectsLogoCS));
var $d1a0c8b1ef47fbc1$export$8b784b3227531b3e = (0, $ksDXb.tempSizeWrapper)((0, $85J9d.RovoDevIcon));
var $d1a0c8b1ef47fbc1$export$f0750468d67c6902 = (0, $ksDXb.tempSizeWrapper)((0, $8vS8J.RovoDevLogoCS));
var $d1a0c8b1ef47fbc1$export$813cff80931d9dbf = (0, $ksDXb.tempSizeWrapper)((0, $7euW2.RovoDevAgentIcon));
var $d1a0c8b1ef47fbc1$export$409b7a5b7f180eba = (0, $ksDXb.tempSizeWrapper)((0, $6Orwr.RovoDevAgentLogoCS));
var $d1a0c8b1ef47fbc1$export$82eafebb825fc23f = (0, $ksDXb.teamEUFlaggedIcon)((0, $T9m1r.SearchIcon), (0, $5UQfy.SearchNewIcon));
var $d1a0c8b1ef47fbc1$export$e4c5487c9a8ae3b1 = (0, $ksDXb.teamEUFlaggedIcon)((0, $ghgPR.SearchLogoCS), (0, $fGMRc.SearchNewLogoCS));
var $d1a0c8b1ef47fbc1$export$290a0f24614cde9f = (0, $ksDXb.teamEUFlaggedIcon)((0, $l3aHx.StudioIcon), (0, $iTWHB.StudioNewIcon));
var $d1a0c8b1ef47fbc1$export$8aceb78c659789b6 = (0, $ksDXb.teamEUFlaggedIcon)((0, $9h4B2.StudioLogoCS), (0, $882kU.StudioNewLogoCS));
/**
 * __Talent icon__
 *
 * The Talent icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $d1a0c8b1ef47fbc1$export$4b05688514531169 = (0, $ksDXb.tempSizeWrapper)((0, $8D2aP.TalentIcon));
var $d1a0c8b1ef47fbc1$export$4f6453e012279f89 = (0, $ksDXb.tempSizeWrapper)((0, $62tJk.TalentLogoCS));
var $d1a0c8b1ef47fbc1$export$1bcbc9c337da86da = (0, $ksDXb.tempSizeWrapper)((0, $8LuO2.TeamsIcon));
var $d1a0c8b1ef47fbc1$export$9b1a0a0c574cec2a = (0, $ksDXb.tempSizeWrapper)((0, $ftCkt.TeamsLogoCS));
var $d1a0c8b1ef47fbc1$export$e812398311cab9a3 = (0, $ksDXb.tempSizeWrapper)((0, $jylyi.BambooIcon));
var $d1a0c8b1ef47fbc1$export$765f5afcc1a5a7e3 = (0, $ksDXb.tempSizeWrapper)((0, $5dQzk.BambooLogoCS));
var $d1a0c8b1ef47fbc1$export$d3ab16bbf4f954ee = (0, $ksDXb.tempSizeWrapper)((0, $7z4Yy.BitbucketDataCenterIcon));
var $d1a0c8b1ef47fbc1$export$36044946916e84a0 = (0, $ksDXb.tempSizeWrapper)((0, $1cJQG.BitbucketDataCenterLogoCS));
var $d1a0c8b1ef47fbc1$export$53305f1f2855d3be = (0, $ksDXb.tempSizeWrapper)((0, $7D32i.ConfluenceDataCenterIcon));
var $d1a0c8b1ef47fbc1$export$5e06396bce773a3 = (0, $ksDXb.tempSizeWrapper)((0, $eppq9.ConfluenceDataCenterLogoCS));
var $d1a0c8b1ef47fbc1$export$eaf73f391f7103bd = (0, $ksDXb.tempSizeWrapper)((0, $jSWn9.CrowdIcon));
var $d1a0c8b1ef47fbc1$export$6128b385660fd3c6 = (0, $ksDXb.tempSizeWrapper)((0, $azXpi.CrowdLogoCS));
var $d1a0c8b1ef47fbc1$export$f8455b5667a3ee0c = (0, $ksDXb.tempSizeWrapper)((0, $h09wv.JiraDataCenterIcon));
var $d1a0c8b1ef47fbc1$export$eb152ab3801b2ae3 = (0, $ksDXb.tempSizeWrapper)((0, $2xOsu.JiraDataCenterLogoCS));
var $d1a0c8b1ef47fbc1$export$65fae0eaf343f2ca = (0, $ksDXb.tempSizeWrapper)((0, $jN93Q.JiraServiceManagementDataCenterIcon));
var $d1a0c8b1ef47fbc1$export$fffc0d480fb1ebf1 = (0, $ksDXb.tempSizeWrapper)((0, $3iwKC.JiraServiceManagementDataCenterLogoCS));
var $d1a0c8b1ef47fbc1$export$74517ed253186308 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $fi4B8.AtlassianAdministrationIcon), (0, $gmT5h.AdminIcon));
var $d1a0c8b1ef47fbc1$export$833abe6c2ce5ebfd = (0, $ksDXb.createFeatureFlaggedComponent)((0, $24DdC.AtlassianAdministrationLogo), (0, $6s7Mu.AdminLogoCS));
var $d1a0c8b1ef47fbc1$export$84109e099492cb5f = (0, $ksDXb.createFeatureFlaggedComponent)((0, $lQm3x.AtlassianAdminIcon), (0, $gmT5h.AdminIcon));
var $d1a0c8b1ef47fbc1$export$f845d9b9254f0541 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $afkKc.AtlassianAdminLogo), (0, $6s7Mu.AdminLogoCS));
var $d1a0c8b1ef47fbc1$export$c42ad8a0b925c762 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $1aygb.AtlassianAnalyticsIcon), (0, $brOGF.AnalyticsIcon));
var $d1a0c8b1ef47fbc1$export$e6470bfc39010cc4 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $goOsv.AtlassianAnalyticsLogo), (0, $c72nZ.AnalyticsLogoCS));
var $d1a0c8b1ef47fbc1$export$5fc1066e677788d4 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $djyDV.BitbucketIcon), (0, $66W9l.BitbucketIcon));
var $d1a0c8b1ef47fbc1$export$bd40525f5333524b = (0, $ksDXb.createFeatureFlaggedComponent)((0, $a2IuZ.BitbucketLogo), (0, $6rNlQ.BitbucketLogoCS));
var $d1a0c8b1ef47fbc1$export$f7857fe64d7161d9 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $9QN60.CompassIcon), (0, $jM9Tj.CompassIcon));
var $d1a0c8b1ef47fbc1$export$eb7d748e4f9c9676 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $1TaAG.CompassLogo), (0, $97zqD.CompassLogoCS));
var $d1a0c8b1ef47fbc1$export$9951d02c2d848122 = (0, $ksDXb.tempSizeWrapper)((0, $bHp0G.DxIcon));
var $d1a0c8b1ef47fbc1$export$68f3db7f6af48bcb = (0, $ksDXb.createFeatureFlaggedComponent)((0, $gd41c.ConfluenceIcon), (0, $aqOQp.ConfluenceIcon));
var $d1a0c8b1ef47fbc1$export$1b2e4fe6ef471556 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $exRVd.ConfluenceLogo), (0, $b33vU.ConfluenceLogoCS));
var $d1a0c8b1ef47fbc1$export$70a0c2f5862937b6 = (0, $ksDXb.tempSizeWrapper)((0, $3c64L.AlignIcon));
var $d1a0c8b1ef47fbc1$export$1b8596b4b0ef673b = (0, $ksDXb.tempSizeWrapper)((0, $8YZSX.AlignLogoCS));
var $d1a0c8b1ef47fbc1$export$407687b2dd89cc68 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $bLGDU.JiraAlignIcon), (0, $3c64L.AlignIcon));
var $d1a0c8b1ef47fbc1$export$ee11e928d3d045fd = (0, $ksDXb.createFeatureFlaggedComponent)((0, $6wQv8.JiraAlignLogo), (0, $8YZSX.AlignLogoCS));
var $d1a0c8b1ef47fbc1$export$c4b5b1f965d8b3eb = (0, $ksDXb.createFeatureFlaggedComponent)((0, $9lD8w.JiraIcon), (0, $6oIdM.JiraIcon));
var $d1a0c8b1ef47fbc1$export$17d3acb0b4379d02 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $6fM0U.JiraLogo), (0, $4moWO.JiraLogoCS));
var $d1a0c8b1ef47fbc1$export$21bfbeb62fdcce8d = (0, $ksDXb.createFeatureFlaggedComponent)((0, $bGjtm.JiraProductDiscoveryIcon), (0, $7j0uU.JiraProductDiscoveryIcon));
var $d1a0c8b1ef47fbc1$export$c49a2b642fe9eef4 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $kW7SU.JiraProductDiscoveryLogo), (0, $QkWKb.JiraProductDiscoveryLogoCS));
var $d1a0c8b1ef47fbc1$export$3c6158790f5e01c4 = (0, $ksDXb.createFeatureFlaggedServiceCollectionComponent)((0, $bJp6k.JiraServiceManagementIcon), (0, $9WmEC.JiraServiceManagementIcon));
var $d1a0c8b1ef47fbc1$export$dabef2be6cd28c20 = (0, $ksDXb.createFeatureFlaggedServiceCollectionComponent)((0, $73xRJ.JiraServiceManagementLogo), (0, $bhguv.JiraServiceManagementLogoCS));
var $d1a0c8b1ef47fbc1$export$8d789f76fde3e05 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $awyVU.LoomIcon), (0, $1F0p0.LoomIcon));
var $d1a0c8b1ef47fbc1$export$94e206806e36c2ec = (0, $ksDXb.createFeatureFlaggedComponent)((0, $icHzk.LoomLogo), (0, $c6flR.LoomLogoCS));
var $d1a0c8b1ef47fbc1$export$1bf47cdade1a9fcb = (0, $ksDXb.createFeatureFlaggedComponent)((0, $93yWJ.LoomAttributionIcon), (0, $1F0p0.LoomIcon));
var $d1a0c8b1ef47fbc1$export$6e87ce8d41eda665 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $4hujc.LoomAttributionLogo), (0, $kxKxH.LoomAttributionLogoCS));
var $d1a0c8b1ef47fbc1$export$e84e925618e0e5bc = (0, $ksDXb.tempSizeWrapper)((0, $40xaM.LoomInternalLogoCS));
var $d1a0c8b1ef47fbc1$export$1940ba72c868b663 = (0, $ksDXb.tempSizeWrapper)((0, $ldRHo.LoomInternalIcon));
var $d1a0c8b1ef47fbc1$export$eeccc49dc7a12d9f = (0, $ksDXb.createFeatureFlaggedServiceCollectionComponent)((0, $bpkb7.OpsgenieIcon), (0, $eSWUM.OpsgenieIcon));
var $d1a0c8b1ef47fbc1$export$a1c6484cdecc2c4b = (0, $ksDXb.createFeatureFlaggedServiceCollectionComponent)((0, $doffx.OpsgenieLogo), (0, $asErn.OpsgenieLogoCS));
var $d1a0c8b1ef47fbc1$export$f3f5aa321d88adf9 = (0, $ksDXb.createFeatureFlaggedServiceCollectionComponent)((0, $3vfCH.StatuspageIcon), (0, $bjjwo.StatuspageIcon));
var $d1a0c8b1ef47fbc1$export$bb4ae5b41b43be04 = (0, $ksDXb.createFeatureFlaggedServiceCollectionComponent)((0, $cymz4.StatuspageLogo), (0, $kKaGJ.StatuspageLogoCS));
var $d1a0c8b1ef47fbc1$export$4384da9b8b140bf4 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $9MViD.TrelloIcon), (0, $fgHZI.TrelloIcon));
var $d1a0c8b1ef47fbc1$export$60e26212f3b61a28 = (0, $ksDXb.createFeatureFlaggedComponent)((0, $f4jmm.TrelloLogo), (0, $8uu6Y.TrelloLogoCS));
var $d1a0c8b1ef47fbc1$export$e23ae35269442b4f = (0, $ksDXb.createFeatureFlaggedRovoComponent)((0, $vXFdf.RovoIcon), (0, $hRc7Y.RovoIcon), (0, $kr1t0.RovoHexIcon));
var $d1a0c8b1ef47fbc1$export$a0f6cb8061290bbb = (0, $ksDXb.createFeatureFlaggedRovoComponent)((0, $hv1FQ.RovoLogo), (0, $4fPIx.RovoLogoCS), (0, $2aEpX.RovoHexLogoCS));
var $d1a0c8b1ef47fbc1$export$3f95fcfdc25a741d = (0, $ksDXb.createFeatureFlaggedComponent)((0, $22DqA.GuardIcon), (0, $iimwL.GuardIcon));
var $d1a0c8b1ef47fbc1$export$a4a891d202775deb = (0, $ksDXb.createFeatureFlaggedComponent)((0, $fFWp2.GuardLogo), (0, $2Y5sL.GuardLogoCS));
var $d1a0c8b1ef47fbc1$export$1e02e7298035a77c = (0, $ksDXb.createFeatureFlaggedComponent)((0, $1M4Uw.FocusIcon), (0, $fw4qJ.FocusIcon));
var $d1a0c8b1ef47fbc1$export$33908560ea1b226d = (0, $ksDXb.createFeatureFlaggedComponent)((0, $7fJSi.FocusLogo), (0, $jOiCV.FocusLogoCS));

});
parcelRegister("gmT5h", function(module, exports) {

$parcel$export(module.exports, "AdminIcon", function () { return $bea96dfca8f76800$export$ef8e5f836dd989d3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ced2179e9e0992ccb4af61b51b4f10a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $bea96dfca8f76800$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $bea96dfca8f76800$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $bea96dfca8f76800$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("fHHq9", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", function () { return $b6ec8d9e2abbbbbc$export$be58b4326e23250f; });
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $gQLDR = parcelRequire("gQLDR");

var $6RMty = parcelRequire("6RMty");
var $b6ec8d9e2abbbbbc$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $b6ec8d9e2abbbbbc$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $b6ec8d9e2abbbbbc$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $b6ec8d9e2abbbbbc$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $b6ec8d9e2abbbbbc$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $b6ec8d9e2abbbbbc$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $b6ec8d9e2abbbbbc$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $b6ec8d9e2abbbbbc$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $b6ec8d9e2abbbbbc$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $affTb.default)([
            $b6ec8d9e2abbbbbc$var$styles.root,
            $b6ec8d9e2abbbbbc$var$sizeMap[size],
            colorMode === 'dark' ? $b6ec8d9e2abbbbbc$var$dataCenterDarkAppearanceMap[appearance] : $b6ec8d9e2abbbbbc$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $b6ec8d9e2abbbbbc$var$rovoDarkAppearanceMap[appearance] : $b6ec8d9e2abbbbbc$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $b6ec8d9e2abbbbbc$var$cloudDarkAppearanceMap[appearance] : $b6ec8d9e2abbbbbc$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $gQLDR.fg)('assets-platform-branding') && $b6ec8d9e2abbbbbc$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("6s7Mu", function(module, exports) {

$parcel$export(module.exports, "AdminLogoCS", function () { return $4b2b64c4c850f43f$export$61afcb38c001e19; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58c9ee3b4e44f14aa5c8a2e33c7dac51>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4b2b64c4c850f43f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4b2b64c4c850f43f$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $4b2b64c4c850f43f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("51aii", function(module, exports) {

$parcel$export(module.exports, "LogoWrapper", function () { return $3a7507f1d6d8afe2$export$f827d3c5a9c3f644; });
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $gQLDR = parcelRequire("gQLDR");

var $6RMty = parcelRequire("6RMty");
var $3a7507f1d6d8afe2$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $3a7507f1d6d8afe2$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $3a7507f1d6d8afe2$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $3a7507f1d6d8afe2$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $3a7507f1d6d8afe2$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $3a7507f1d6d8afe2$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $3a7507f1d6d8afe2$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $3a7507f1d6d8afe2$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $3a7507f1d6d8afe2$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $3a7507f1d6d8afe2$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $3a7507f1d6d8afe2$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $3a7507f1d6d8afe2$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $affTb.default)([
            $3a7507f1d6d8afe2$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $3a7507f1d6d8afe2$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $3a7507f1d6d8afe2$var$sizeMap[size],
            colorMode === 'dark' ? $3a7507f1d6d8afe2$var$textDarkAppearanceMap[appearance] : $3a7507f1d6d8afe2$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $3a7507f1d6d8afe2$var$dataCenterDarkAppearanceMap[appearance] : $3a7507f1d6d8afe2$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $3a7507f1d6d8afe2$var$rovoDarkAppearanceMap[appearance] : $3a7507f1d6d8afe2$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $3a7507f1d6d8afe2$var$cloudDarkAppearanceMap[appearance] : $3a7507f1d6d8afe2$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $gQLDR.fg)('assets-platform-branding') && $3a7507f1d6d8afe2$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("3c64L", function(module, exports) {

$parcel$export(module.exports, "AlignIcon", function () { return $2537349fb9e3a1c3$export$70a0c2f5862937b6; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c308d558bb8f01b0a6c887a98e5347d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $2537349fb9e3a1c3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $2537349fb9e3a1c3$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $2537349fb9e3a1c3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8YZSX", function(module, exports) {

$parcel$export(module.exports, "AlignLogoCS", function () { return $68a3ee7b9aa5e53e$export$8b5103382c06639c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d1c9f8765265019cd33e94ea5235515>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $68a3ee7b9aa5e53e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $68a3ee7b9aa5e53e$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $68a3ee7b9aa5e53e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("brOGF", function(module, exports) {

$parcel$export(module.exports, "AnalyticsIcon", function () { return $855988bce941048c$export$af3460f51ce3602a; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5edf47443601d30b199c36fbcc7b1d7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $855988bce941048c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $855988bce941048c$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $855988bce941048c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("c72nZ", function(module, exports) {

$parcel$export(module.exports, "AnalyticsLogoCS", function () { return $8d17fd4629dc1524$export$f0bac2b7ac3e3504; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::843c7beab94f5191123277c61cbca79e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8d17fd4629dc1524$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $8d17fd4629dc1524$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $8d17fd4629dc1524$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("90q7Y", function(module, exports) {

$parcel$export(module.exports, "AssetsIcon", function () { return $68e861886bb21ec3$export$d89497e7f33ca6f5; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ef8f48b1d072b5b8a0869540d1f52a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $68e861886bb21ec3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $68e861886bb21ec3$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $68e861886bb21ec3$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $68e861886bb21ec3$var$svg,
        customThemeSvg: $68e861886bb21ec3$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8pC02", function(module, exports) {

$parcel$export(module.exports, "AssetsLogoCS", function () { return $61fe2273a93e01e5$export$81c47abe19675c4c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e04e8bc884193d0eee2f110efb35733>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $61fe2273a93e01e5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $61fe2273a93e01e5$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $61fe2273a93e01e5$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jylyi", function(module, exports) {

$parcel$export(module.exports, "BambooIcon", function () { return $e3c1e91c697bcf69$export$e812398311cab9a3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74f0ca66b8bc3995f7a9817f08a67d6f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e3c1e91c697bcf69$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $e3c1e91c697bcf69$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $e3c1e91c697bcf69$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5dQzk", function(module, exports) {

$parcel$export(module.exports, "BambooLogoCS", function () { return $3cd6f1b236b56eb2$export$7c51958462d750e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5436ab9ea17c11b656095d6ae713006c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3cd6f1b236b56eb2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $3cd6f1b236b56eb2$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $3cd6f1b236b56eb2$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("66W9l", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", function () { return $473068eb0ae8c28a$export$5fc1066e677788d4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $473068eb0ae8c28a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $473068eb0ae8c28a$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $473068eb0ae8c28a$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $473068eb0ae8c28a$var$svg,
        customThemeSvg: $473068eb0ae8c28a$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6rNlQ", function(module, exports) {

$parcel$export(module.exports, "BitbucketLogoCS", function () { return $4b1b8bdbbc4ab62b$export$f7ef5e5488e4b430; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4b1b8bdbbc4ab62b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $4b1b8bdbbc4ab62b$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $4b1b8bdbbc4ab62b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7z4Yy", function(module, exports) {

$parcel$export(module.exports, "BitbucketDataCenterIcon", function () { return $581fa95d1145e21c$export$d3ab16bbf4f954ee; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61dd349b817df11b196de45b8945fcdf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $581fa95d1145e21c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $581fa95d1145e21c$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $581fa95d1145e21c$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1cJQG", function(module, exports) {

$parcel$export(module.exports, "BitbucketDataCenterLogoCS", function () { return $0e0a7a0fb0ac39dc$export$cc55e2a4c4b40552; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68c2bbf4fd6874e93c78c51b9065dc7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0e0a7a0fb0ac39dc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $0e0a7a0fb0ac39dc$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $0e0a7a0fb0ac39dc$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9snFG", function(module, exports) {

$parcel$export(module.exports, "ChatIcon", function () { return $6e29173194d8cade$export$52cd484a7ef4f2b9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a833c6410fabd244b1134a630f9a005>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $6e29173194d8cade$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $6e29173194d8cade$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $6e29173194d8cade$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("g95yP", function(module, exports) {

$parcel$export(module.exports, "ChatLogoCS", function () { return $bc11ccd631ee17a9$export$a529e78951cd6709; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3a55f079b563dca3c91045ce0a761dc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $bc11ccd631ee17a9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $bc11ccd631ee17a9$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $bc11ccd631ee17a9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iSBY8", function(module, exports) {

$parcel$export(module.exports, "ChatNewIcon", function () { return $dbeab8f7d72da132$export$402a257da320c93c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad5b8ef64559dc5207c779379dec44c9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $dbeab8f7d72da132$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $dbeab8f7d72da132$export$402a257da320c93c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $dbeab8f7d72da132$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fdtsy", function(module, exports) {

$parcel$export(module.exports, "ChatNewLogoCS", function () { return $b13eebf759099429$export$a3af32a9109d706d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1eb74baaf9574600817f9bd5473029df>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b13eebf759099429$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b13eebf759099429$export$a3af32a9109d706d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $b13eebf759099429$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jM9Tj", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", function () { return $e65a2c2c95db6748$export$f7857fe64d7161d9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e65a2c2c95db6748$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $e65a2c2c95db6748$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $e65a2c2c95db6748$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("97zqD", function(module, exports) {

$parcel$export(module.exports, "CompassLogoCS", function () { return $6a403fde79988b0e$export$a16f50a81d183ce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6a403fde79988b0e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $6a403fde79988b0e$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $6a403fde79988b0e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("aqOQp", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", function () { return $7983c5bb9217d821$export$68f3db7f6af48bcb; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7983c5bb9217d821$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $7983c5bb9217d821$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $7983c5bb9217d821$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $7983c5bb9217d821$var$svg,
        customThemeSvg: $7983c5bb9217d821$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("b33vU", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogoCS", function () { return $80b2b347a344d939$export$a88b0b0da9ef63ce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $80b2b347a344d939$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $80b2b347a344d939$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $80b2b347a344d939$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7D32i", function(module, exports) {

$parcel$export(module.exports, "ConfluenceDataCenterIcon", function () { return $58de87d4d6ba81d1$export$53305f1f2855d3be; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daf8acf7c1707ab5f837689f4e92f4a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $58de87d4d6ba81d1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $58de87d4d6ba81d1$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $58de87d4d6ba81d1$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eppq9", function(module, exports) {

$parcel$export(module.exports, "ConfluenceDataCenterLogoCS", function () { return $a7d71e890f65e0ed$export$b3e508cb103e1f93; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86f2cdcf615e24dd3ad3f9b48bca5bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a7d71e890f65e0ed$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $a7d71e890f65e0ed$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $a7d71e890f65e0ed$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jSWn9", function(module, exports) {

$parcel$export(module.exports, "CrowdIcon", function () { return $e7a056fd0e2f38b7$export$eaf73f391f7103bd; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9928c9b96accda0f9234a11fc7ddaca0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e7a056fd0e2f38b7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $e7a056fd0e2f38b7$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $e7a056fd0e2f38b7$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("azXpi", function(module, exports) {

$parcel$export(module.exports, "CrowdLogoCS", function () { return $7b3b41425fd88e3f$export$3c371bdbcdfcdce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::206fa44ab9c6427ebeb6aaad7e53b58f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7b3b41425fd88e3f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $7b3b41425fd88e3f$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $7b3b41425fd88e3f$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("63Bd1", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementIcon", function () { return $468fe2d68f50c7da$export$6da5aa77c402ba0f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cbaafcea60527c20df8d8395e491b95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $468fe2d68f50c7da$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $468fe2d68f50c7da$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $468fe2d68f50c7da$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $468fe2d68f50c7da$var$svg,
        customThemeSvg: $468fe2d68f50c7da$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eWVVV", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementLogoCS", function () { return $ae236bce5822a167$export$f597f0f7fadce0b9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b7476897879e097648c054d2783409e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ae236bce5822a167$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $ae236bce5822a167$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $ae236bce5822a167$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bHp0G", function(module, exports) {

$parcel$export(module.exports, "DxIcon", function () { return $88471c5a1194e05d$export$9951d02c2d848122; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe1275028f179c85adabcde30f1dc14d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $88471c5a1194e05d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z\"/>\n</svg>\n";
function $88471c5a1194e05d$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Dx' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $88471c5a1194e05d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fw4qJ", function(module, exports) {

$parcel$export(module.exports, "FocusIcon", function () { return $b4bd47ef50cfff74$export$1e02e7298035a77c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $b4bd47ef50cfff74$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $b4bd47ef50cfff74$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $b4bd47ef50cfff74$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jOiCV", function(module, exports) {

$parcel$export(module.exports, "FocusLogoCS", function () { return $e6c122b5b74324d1$export$3a6e8b37e069a69d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e6c122b5b74324d1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $e6c122b5b74324d1$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $e6c122b5b74324d1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("TcXzV", function(module, exports) {

$parcel$export(module.exports, "GoalsIcon", function () { return $0a5f30be4594bf0a$export$9eb74917ea768ed4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::691ffc068fd79d2f7585ba74e9375893>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0a5f30be4594bf0a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $0a5f30be4594bf0a$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $0a5f30be4594bf0a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jZYnH", function(module, exports) {

$parcel$export(module.exports, "GoalsLogoCS", function () { return $e8f28d45c3a39bb1$export$c527a545aa426db3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fcd237a4e74e8fc6ee2ed98ecae9d02>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e8f28d45c3a39bb1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $e8f28d45c3a39bb1$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $e8f28d45c3a39bb1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iimwL", function(module, exports) {

$parcel$export(module.exports, "GuardIcon", function () { return $d51b61e7db6b8313$export$3f95fcfdc25a741d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d51b61e7db6b8313$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $d51b61e7db6b8313$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $d51b61e7db6b8313$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2Y5sL", function(module, exports) {

$parcel$export(module.exports, "GuardLogoCS", function () { return $22956c3438769ea0$export$2b896c4d595a4331; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $22956c3438769ea0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $22956c3438769ea0$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $22956c3438769ea0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("a7KWX", function(module, exports) {

$parcel$export(module.exports, "HomeIcon", function () { return $75eefa201f91b134$export$92c8767b874048d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dae141e789f6f860676eab772d48c16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $75eefa201f91b134$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $75eefa201f91b134$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $75eefa201f91b134$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kU0Ro", function(module, exports) {

$parcel$export(module.exports, "HomeLogoCS", function () { return $f379b46919327e28$export$8b6b7f1b1b2367d3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f61715fd61f2481e52a0f7c7611f421f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f379b46919327e28$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $f379b46919327e28$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $f379b46919327e28$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dDN4j", function(module, exports) {

$parcel$export(module.exports, "HubIcon", function () { return $9ee4fade3a73c6c8$export$80b8b269d8b5014e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::459e9cba95b1e0b094b9b0a89db30ecd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $9ee4fade3a73c6c8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $9ee4fade3a73c6c8$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $9ee4fade3a73c6c8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8TOE0", function(module, exports) {

$parcel$export(module.exports, "HubLogoCS", function () { return $67aabeb08f1bf48b$export$7a38180641471460; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edd23980285704c09d78f5241a37a99c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $67aabeb08f1bf48b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $67aabeb08f1bf48b$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $67aabeb08f1bf48b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6oIdM", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", function () { return $4a87495d838c30ae$export$c4b5b1f965d8b3eb; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $4a87495d838c30ae$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $4a87495d838c30ae$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $4a87495d838c30ae$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $4a87495d838c30ae$var$svg,
        customThemeSvg: $4a87495d838c30ae$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4moWO", function(module, exports) {

$parcel$export(module.exports, "JiraLogoCS", function () { return $32cc91918e84869d$export$bf4c5f97b468e8d6; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $32cc91918e84869d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $32cc91918e84869d$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $32cc91918e84869d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("h09wv", function(module, exports) {

$parcel$export(module.exports, "JiraDataCenterIcon", function () { return $c609d2e204ff0982$export$f8455b5667a3ee0c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61edfa3e375524991498620530471e0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $c609d2e204ff0982$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $c609d2e204ff0982$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $c609d2e204ff0982$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2xOsu", function(module, exports) {

$parcel$export(module.exports, "JiraDataCenterLogoCS", function () { return $1da5cdd8089ebff4$export$3224b07bc93ef23e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::193cafbd0d66aed78a8eae06654a150d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1da5cdd8089ebff4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $1da5cdd8089ebff4$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $1da5cdd8089ebff4$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7j0uU", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $551ab19237c3dba3$export$21bfbeb62fdcce8d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $551ab19237c3dba3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $551ab19237c3dba3$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $551ab19237c3dba3$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $551ab19237c3dba3$var$svg,
        customThemeSvg: $551ab19237c3dba3$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("QkWKb", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogoCS", function () { return $09d51afa7f8bbaf3$export$602140a6a10b02bf; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $09d51afa7f8bbaf3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $09d51afa7f8bbaf3$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $09d51afa7f8bbaf3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9WmEC", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $73cb1a7833e1229a$export$3c6158790f5e01c4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $73cb1a7833e1229a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $73cb1a7833e1229a$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $73cb1a7833e1229a$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $73cb1a7833e1229a$var$svg,
        customThemeSvg: $73cb1a7833e1229a$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bhguv", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogoCS", function () { return $835e13009bca939f$export$de148263c75d2bc1; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $835e13009bca939f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $835e13009bca939f$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $835e13009bca939f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jN93Q", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementDataCenterIcon", function () { return $e6899f3d89710b21$export$65fae0eaf343f2ca; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b3684e2355c28ec62827d09d362b6cf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e6899f3d89710b21$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $e6899f3d89710b21$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $e6899f3d89710b21$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3iwKC", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementDataCenterLogoCS", function () { return $266c752f1839a0ff$export$f64bc7a7f04428d0; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d19396c378541211d8225aae490bcbcf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $266c752f1839a0ff$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $266c752f1839a0ff$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $266c752f1839a0ff$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1F0p0", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", function () { return $1359eea6a7d8cde1$export$8d789f76fde3e05; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1359eea6a7d8cde1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $1359eea6a7d8cde1$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $1359eea6a7d8cde1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("c6flR", function(module, exports) {

$parcel$export(module.exports, "LoomLogoCS", function () { return $8cf1f41496af8953$export$78c0b4d8be34c9b2; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8cf1f41496af8953$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $8cf1f41496af8953$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $8cf1f41496af8953$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kxKxH", function(module, exports) {

$parcel$export(module.exports, "LoomAttributionLogoCS", function () { return $ef4afe11f1661f34$export$68d7391318cdef11; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ef4afe11f1661f34$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $ef4afe11f1661f34$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $ef4afe11f1661f34$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ldRHo", function(module, exports) {

$parcel$export(module.exports, "LoomInternalIcon", function () { return $f734775f3f734548$export$38c7b37a3e5e8d70; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c3b4b2f73587dee325566fc7978684>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $f734775f3f734548$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $f734775f3f734548$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $f734775f3f734548$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("40xaM", function(module, exports) {

$parcel$export(module.exports, "LoomInternalLogoCS", function () { return $2eb0e4f07305215f$export$71743a944cb62e48; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4fa46a3d520008396bf538a250ebef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2eb0e4f07305215f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $2eb0e4f07305215f$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $2eb0e4f07305215f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eSWUM", function(module, exports) {

$parcel$export(module.exports, "OpsgenieIcon", function () { return $ad63cf13cf623e42$export$eeccc49dc7a12d9f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $ad63cf13cf623e42$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $ad63cf13cf623e42$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $ad63cf13cf623e42$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("asErn", function(module, exports) {

$parcel$export(module.exports, "OpsgenieLogoCS", function () { return $01f728d4f157a900$export$a5b9122e89b32ad3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $01f728d4f157a900$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $01f728d4f157a900$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $01f728d4f157a900$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("adgI9", function(module, exports) {

$parcel$export(module.exports, "ProjectsIcon", function () { return $76f814bcedcfe31b$export$5ed3e1bb3b04fc02; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bab74cd77291828d528d124967c3552>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $76f814bcedcfe31b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $76f814bcedcfe31b$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $76f814bcedcfe31b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7iDcJ", function(module, exports) {

$parcel$export(module.exports, "ProjectsLogoCS", function () { return $5508a0011f1cb0dd$export$e3d1678155aaab99; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::820b1edb3bac4a2b82da6f532724cb11>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5508a0011f1cb0dd$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $5508a0011f1cb0dd$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $5508a0011f1cb0dd$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hRc7Y", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", function () { return $d000cb3623c76232$export$e23ae35269442b4f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c09aee6cc96e54887271dd42a7eae172>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d000cb3623c76232$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $d000cb3623c76232$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $d000cb3623c76232$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4fPIx", function(module, exports) {

$parcel$export(module.exports, "RovoLogoCS", function () { return $3190ae26b85ffd65$export$b0e15f0a1c9f4c55; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29265478015ee48ec34dc1fd6eae4b81>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3190ae26b85ffd65$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $3190ae26b85ffd65$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $3190ae26b85ffd65$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("85J9d", function(module, exports) {

$parcel$export(module.exports, "RovoDevIcon", function () { return $5e41cfbb58e66149$export$8b784b3227531b3e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0424c604e8fb1e51fac762a4e1efa562>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $5e41cfbb58e66149$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75\"/>\n</svg>\n";
function $5e41cfbb58e66149$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $5e41cfbb58e66149$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8vS8J", function(module, exports) {

$parcel$export(module.exports, "RovoDevLogoCS", function () { return $632b37015416642a$export$4145bd793c9ed1d0; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0f280d200b0e27835aec655dfa5a41e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $632b37015416642a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 165 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $632b37015416642a$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $632b37015416642a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7euW2", function(module, exports) {

$parcel$export(module.exports, "RovoDevAgentIcon", function () { return $5441d647597e8d5a$export$813cff80931d9dbf; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c56e9a05bb3a4c70bfd4cbcb5fa54ba2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $5441d647597e8d5a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $5441d647597e8d5a$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $5441d647597e8d5a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6Orwr", function(module, exports) {

$parcel$export(module.exports, "RovoDevAgentLogoCS", function () { return $4f5cc2efc635ac3f$export$58747af448450872; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca2d332c134816706ee434029a355d3c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4f5cc2efc635ac3f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 160 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4f5cc2efc635ac3f$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $4f5cc2efc635ac3f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kr1t0", function(module, exports) {

$parcel$export(module.exports, "RovoHexIcon", function () { return $ee07779211a44c6d$export$9e62346a60cfb459; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1fdf93317430cb701429972e6c41dc4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $ee07779211a44c6d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ee07779211a44c6d$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $ee07779211a44c6d$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2aEpX", function(module, exports) {

$parcel$export(module.exports, "RovoHexLogoCS", function () { return $194bde0b9a0090cc$export$5e38d02efdb45577; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e01ef8caae93929e35d346a5091c5ef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $194bde0b9a0090cc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $194bde0b9a0090cc$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $194bde0b9a0090cc$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("T9m1r", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", function () { return $0a5c64b7c348efb0$export$82eafebb825fc23f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88ee37f21199df8c4f6de50b597bc415>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0a5c64b7c348efb0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $0a5c64b7c348efb0$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $0a5c64b7c348efb0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ghgPR", function(module, exports) {

$parcel$export(module.exports, "SearchLogoCS", function () { return $bd9b4b05da5b58a8$export$fa08cbfe393f2a68; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4165d5d8279c6abbf1ec41290594700b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $bd9b4b05da5b58a8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $bd9b4b05da5b58a8$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $bd9b4b05da5b58a8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5UQfy", function(module, exports) {

$parcel$export(module.exports, "SearchNewIcon", function () { return $44eab678fd86d570$export$3599582ddc9fc5cf; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fb81b6548e62d67fc83daf888114f8f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $44eab678fd86d570$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $44eab678fd86d570$export$3599582ddc9fc5cf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $44eab678fd86d570$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fGMRc", function(module, exports) {

$parcel$export(module.exports, "SearchNewLogoCS", function () { return $b6c0ad405e16d1ac$export$d669f6cbbb67e061; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::12cecbe0aa290ffe5232721f12ef458f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b6c0ad405e16d1ac$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b6c0ad405e16d1ac$export$d669f6cbbb67e061(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $b6c0ad405e16d1ac$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bjjwo", function(module, exports) {

$parcel$export(module.exports, "StatuspageIcon", function () { return $83c09c99e886d6f0$export$f3f5aa321d88adf9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $83c09c99e886d6f0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $83c09c99e886d6f0$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $83c09c99e886d6f0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kKaGJ", function(module, exports) {

$parcel$export(module.exports, "StatuspageLogoCS", function () { return $f1a0650243366fa3$export$2bc88a281410ffa7; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f1a0650243366fa3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $f1a0650243366fa3$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $f1a0650243366fa3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("l3aHx", function(module, exports) {

$parcel$export(module.exports, "StudioIcon", function () { return $f5322dd169bc70ec$export$290a0f24614cde9f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2be4b98bf6f70e39467c5c4d0f75c6d5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $f5322dd169bc70ec$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.7 11.222V19h7.8v-7.778z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z\"/>\n</svg>\n";
function $f5322dd169bc70ec$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $f5322dd169bc70ec$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9h4B2", function(module, exports) {

$parcel$export(module.exports, "StudioLogoCS", function () { return $6c09445229f866c9$export$273fd56580e523ae; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a96e3d2d2d3910fdbea7d20bda091bd2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6c09445229f866c9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.125 14.125V24.75H24.75V14.125z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $6c09445229f866c9$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $6c09445229f866c9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iTWHB", function(module, exports) {

$parcel$export(module.exports, "StudioNewIcon", function () { return $dc2ae61be0e28c89$export$8bb9894377e04e04; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6df92ef654dd711bfb690d95b2c06d7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $dc2ae61be0e28c89$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z\"/>\n</svg>\n";
function $dc2ae61be0e28c89$export$8bb9894377e04e04(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $dc2ae61be0e28c89$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("882kU", function(module, exports) {

$parcel$export(module.exports, "StudioNewLogoCS", function () { return $5eb0e1fe9596b220$export$170353c338ac5f4a; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88f184410a9d6dcf22f1ca1246d077a0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5eb0e1fe9596b220$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $5eb0e1fe9596b220$export$170353c338ac5f4a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $5eb0e1fe9596b220$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8D2aP", function(module, exports) {

$parcel$export(module.exports, "TalentIcon", function () { return $6483a6df53ac97c6$export$4b05688514531169; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1d8fa09e3a068fb57474a844fe5ab56>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $6483a6df53ac97c6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $6483a6df53ac97c6$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $6483a6df53ac97c6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("62tJk", function(module, exports) {

$parcel$export(module.exports, "TalentLogoCS", function () { return $4659fdc3541902b3$export$1b3979d995ebbc6e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4af27131cfc453f0f255c3cbe65f158e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4659fdc3541902b3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $4659fdc3541902b3$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $4659fdc3541902b3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8LuO2", function(module, exports) {

$parcel$export(module.exports, "TeamsIcon", function () { return $661a9bf21669e2de$export$1bcbc9c337da86da; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cfe9311dc5f8070530ce9772b12f3fc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $661a9bf21669e2de$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $661a9bf21669e2de$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $661a9bf21669e2de$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ftCkt", function(module, exports) {

$parcel$export(module.exports, "TeamsLogoCS", function () { return $b4474bcf0bd27fec$export$bfd8d1c4da84ce71; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9a7a0d4583e5a9f22d08a0d2f6ac1f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b4474bcf0bd27fec$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $b4474bcf0bd27fec$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $b4474bcf0bd27fec$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fgHZI", function(module, exports) {

$parcel$export(module.exports, "TrelloIcon", function () { return $b1da7a02de3967fc$export$4384da9b8b140bf4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $fHHq9 = parcelRequire("fHHq9");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $b1da7a02de3967fc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $b1da7a02de3967fc$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $b1da7a02de3967fc$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fHHq9.IconWrapper), {
        svg: $b1da7a02de3967fc$var$svg,
        customThemeSvg: $b1da7a02de3967fc$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8uu6Y", function(module, exports) {

$parcel$export(module.exports, "TrelloLogoCS", function () { return $62e87b926c502b50$export$1b13139dfc0336af; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $51aii = parcelRequire("51aii");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $62e87b926c502b50$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $62e87b926c502b50$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $51aii.LogoWrapper), {
        svg: $62e87b926c502b50$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lQm3x", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdminIcon", function () { return $fe6f9030288c7637$export$84109e099492cb5f; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $fe6f9030288c7637$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $fe6f9030288c7637$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        svg: $fe6f9030288c7637$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("afkKc", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdminLogo", function () { return $775b6575b77ecaf0$export$f845d9b9254f0541; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $775b6575b77ecaf0$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $775b6575b77ecaf0$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $775b6575b77ecaf0$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fi4B8", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdministrationIcon", function () { return $b21c1a7cc88b6293$export$74517ed253186308; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $b21c1a7cc88b6293$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $b21c1a7cc88b6293$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        svg: $b21c1a7cc88b6293$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("24DdC", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdministrationLogo", function () { return $182a607f13934085$export$833abe6c2ce5ebfd; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $182a607f13934085$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $182a607f13934085$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $182a607f13934085$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1aygb", function(module, exports) {

$parcel$export(module.exports, "AtlassianAnalyticsIcon", function () { return $0da14cefb661a4d9$export$c42ad8a0b925c762; });

var $dNMDr = parcelRequire("dNMDr");

var $hGahQ = parcelRequire("hGahQ");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $0da14cefb661a4d9$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $0da14cefb661a4d9$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $hGahQ.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $0da14cefb661a4d9$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("goOsv", function(module, exports) {

$parcel$export(module.exports, "AtlassianAnalyticsLogo", function () { return $bf060747bad3ce50$export$e6470bfc39010cc4; });

var $dNMDr = parcelRequire("dNMDr");

var $hGahQ = parcelRequire("hGahQ");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $bf060747bad3ce50$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $bf060747bad3ce50$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $hGahQ.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $bf060747bad3ce50$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("djyDV", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", function () { return $9b17ec0f0c77d4a4$export$5fc1066e677788d4; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $9b17ec0f0c77d4a4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $9b17ec0f0c77d4a4$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $9b17ec0f0c77d4a4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("a2IuZ", function(module, exports) {

$parcel$export(module.exports, "BitbucketLogo", function () { return $74fc9bd347131f96$export$bd40525f5333524b; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $74fc9bd347131f96$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $74fc9bd347131f96$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $74fc9bd347131f96$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9QN60", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", function () { return $72bf0dd236c6a287$export$f7857fe64d7161d9; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $72bf0dd236c6a287$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $72bf0dd236c6a287$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $72bf0dd236c6a287$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1TaAG", function(module, exports) {

$parcel$export(module.exports, "CompassLogo", function () { return $16032494d9543606$export$eb7d748e4f9c9676; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $16032494d9543606$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $16032494d9543606$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $16032494d9543606$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gd41c", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", function () { return $bcd0fa2cbd87808b$export$68f3db7f6af48bcb; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $bcd0fa2cbd87808b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $bcd0fa2cbd87808b$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $bcd0fa2cbd87808b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("exRVd", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogo", function () { return $a96df98347f8400c$export$1b2e4fe6ef471556; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $a96df98347f8400c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $a96df98347f8400c$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $a96df98347f8400c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1M4Uw", function(module, exports) {

$parcel$export(module.exports, "FocusIcon", function () { return $14ae1550870292c3$export$1e02e7298035a77c; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $14ae1550870292c3$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $14ae1550870292c3$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $14ae1550870292c3$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7fJSi", function(module, exports) {

$parcel$export(module.exports, "FocusLogo", function () { return $547d84de8bf1d947$export$33908560ea1b226d; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $547d84de8bf1d947$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $547d84de8bf1d947$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $547d84de8bf1d947$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("22DqA", function(module, exports) {

$parcel$export(module.exports, "GuardIcon", function () { return $17ca5a3ab7e04975$export$3f95fcfdc25a741d; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $17ca5a3ab7e04975$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $17ca5a3ab7e04975$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        svg: $17ca5a3ab7e04975$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fFWp2", function(module, exports) {

$parcel$export(module.exports, "GuardLogo", function () { return $b697fcf0e626be35$export$a4a891d202775deb; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $b697fcf0e626be35$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $b697fcf0e626be35$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $b697fcf0e626be35$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9lD8w", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", function () { return $6ce46ee76598a78e$export$c4b5b1f965d8b3eb; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $6ce46ee76598a78e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $6ce46ee76598a78e$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $6ce46ee76598a78e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6fM0U", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", function () { return $48d9634a0d6d22ad$export$17d3acb0b4379d02; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $48d9634a0d6d22ad$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $48d9634a0d6d22ad$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $48d9634a0d6d22ad$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bLGDU", function(module, exports) {

$parcel$export(module.exports, "JiraAlignIcon", function () { return $8915296ebd226851$export$407687b2dd89cc68; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $8915296ebd226851$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $8915296ebd226851$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $8915296ebd226851$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6wQv8", function(module, exports) {

$parcel$export(module.exports, "JiraAlignLogo", function () { return $4c0e74e1e5395545$export$ee11e928d3d045fd; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $4c0e74e1e5395545$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $4c0e74e1e5395545$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $4c0e74e1e5395545$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bGjtm", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $8812b8c6e671e22a$export$21bfbeb62fdcce8d; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $8812b8c6e671e22a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $8812b8c6e671e22a$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $8812b8c6e671e22a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kW7SU", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", function () { return $f3df5727e2786842$export$c49a2b642fe9eef4; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $f3df5727e2786842$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $f3df5727e2786842$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $f3df5727e2786842$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bJp6k", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $88a75e3434162b3f$export$3c6158790f5e01c4; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $88a75e3434162b3f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $88a75e3434162b3f$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $88a75e3434162b3f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("73xRJ", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogo", function () { return $5233153f0601c285$export$dabef2be6cd28c20; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $5233153f0601c285$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $5233153f0601c285$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5233153f0601c285$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("awyVU", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", function () { return $7a97fd7e9923ad98$export$8d789f76fde3e05; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $7a97fd7e9923ad98$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsForLoom)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $7a97fd7e9923ad98$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $7a97fd7e9923ad98$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("icHzk", function(module, exports) {

$parcel$export(module.exports, "LoomLogo", function () { return $d40b24d28dcec633$export$94e206806e36c2ec; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $d40b24d28dcec633$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsForLoom)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $d40b24d28dcec633$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d40b24d28dcec633$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("93yWJ", function(module, exports) {

$parcel$export(module.exports, "LoomAttributionIcon", function () { return $697f807db315a6d1$export$1bf47cdade1a9fcb; });

var $dNMDr = parcelRequire("dNMDr");

var $lCwoP = parcelRequire("lCwoP");

var $awyVU = parcelRequire("awyVU");
var $697f807db315a6d1$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $awyVU.LoomIcon), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};

});

parcelRegister("4hujc", function(module, exports) {

$parcel$export(module.exports, "LoomAttributionLogo", function () { return $31e0429c5352fdde$export$6e87ce8d41eda665; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $31e0429c5352fdde$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsForLoom)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $31e0429c5352fdde$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $31e0429c5352fdde$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bpkb7", function(module, exports) {

$parcel$export(module.exports, "OpsgenieIcon", function () { return $84e1ae81b7cec2ab$export$eeccc49dc7a12d9f; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $84e1ae81b7cec2ab$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $84e1ae81b7cec2ab$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        svg: $84e1ae81b7cec2ab$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("doffx", function(module, exports) {

$parcel$export(module.exports, "OpsgenieLogo", function () { return $9bf958864b0876a8$export$a1c6484cdecc2c4b; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $9bf958864b0876a8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $9bf958864b0876a8$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $9bf958864b0876a8$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("vXFdf", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", function () { return $06012d563dafa3a8$export$e23ae35269442b4f; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $06012d563dafa3a8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $06012d563dafa3a8$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        svg: $06012d563dafa3a8$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hv1FQ", function(module, exports) {

$parcel$export(module.exports, "RovoLogo", function () { return $cbd6a153cc93fb55$export$a0f6cb8061290bbb; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $cbd6a153cc93fb55$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $cbd6a153cc93fb55$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $cbd6a153cc93fb55$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3vfCH", function(module, exports) {

$parcel$export(module.exports, "StatuspageIcon", function () { return $28d062c4f04673ea$export$f3f5aa321d88adf9; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $28d062c4f04673ea$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $28d062c4f04673ea$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $28d062c4f04673ea$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cymz4", function(module, exports) {

$parcel$export(module.exports, "StatuspageLogo", function () { return $923a29df525b2995$export$bb4ae5b41b43be04; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $923a29df525b2995$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $923a29df525b2995$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $923a29df525b2995$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9MViD", function(module, exports) {

$parcel$export(module.exports, "TrelloIcon", function () { return $72050b440957b2fb$export$4384da9b8b140bf4; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $72050b440957b2fb$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $72050b440957b2fb$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        svg: $72050b440957b2fb$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("f4jmm", function(module, exports) {

$parcel$export(module.exports, "TrelloLogo", function () { return $af863f2f54c1dd86$export$60e26212f3b61a28; });

var $dNMDr = parcelRequire("dNMDr");

var $6RMty = parcelRequire("6RMty");

var $lCwoP = parcelRequire("lCwoP");

var $9mSNu = parcelRequire("9mSNu");

var $68kpH = parcelRequire("68kpH");
var $af863f2f54c1dd86$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $68kpH.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $af863f2f54c1dd86$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $lCwoP.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $lCwoP.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $lCwoP.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $6RMty.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9mSNu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $af863f2f54c1dd86$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ksDXb", function(module, exports) {

$parcel$export(module.exports, "createFeatureFlaggedComponent", function () { return $ee556a24c9c76993$export$e30d2ddc605f6bb; });
$parcel$export(module.exports, "createFeatureFlaggedServiceCollectionComponent", function () { return $ee556a24c9c76993$export$436fcf6e31fbacea; });
$parcel$export(module.exports, "createFeatureFlaggedRovoComponent", function () { return $ee556a24c9c76993$export$2469203854060337; });
$parcel$export(module.exports, "tempSizeWrapper", function () { return $ee556a24c9c76993$export$667425256e2e7296; });
$parcel$export(module.exports, "teamEUFlaggedIcon", function () { return $ee556a24c9c76993$export$3fe521abfbbe6ab3; });

var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $gQLDR = parcelRequire("gQLDR");
var $ee556a24c9c76993$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $ee556a24c9c76993$var$_excluded2 = [
    "size",
    "shouldUseNewLogoDesign"
], $ee556a24c9c76993$var$_excluded3 = [
    "shouldUseHexLogo"
], $ee556a24c9c76993$var$_excluded4 = [
    "size"
];
/**
 * Creates a feature flagged component that renders the legacy logo or the new logo
 * based on the platform-logo-rebrand feature flag.
 *
 * @param LegacyComponent - The legacy logo component.
 * @param NewComponent - The new logo component.
 * @returns A feature flagged component that renders the legacy logo or the new logo.
 */ var $ee556a24c9c76993$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $ee556a24c9c76993$var$_excluded);
        if ((0, $gQLDR.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
            size: size
        }, props));
    };
};
var $ee556a24c9c76993$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref2) {
        var size = _ref2.size, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref2, $ee556a24c9c76993$var$_excluded2);
        if ((0, $gQLDR.fg)('platform-logo-rebrand-servco') || (0, $gQLDR.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
            size: size
        }, props));
    };
};
var $ee556a24c9c76993$export$2469203854060337 = function createFeatureFlaggedRovoComponent(LegacyComponent, NewComponent, NewHexComponent) {
    var RovoHexWrapped = $ee556a24c9c76993$export$667425256e2e7296(NewHexComponent);
    var RovoServiceCollectionWrapped = $ee556a24c9c76993$export$436fcf6e31fbacea(LegacyComponent, NewComponent);
    return function(_ref3) {
        var shouldUseHexLogo = _ref3.shouldUseHexLogo, props = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref3, $ee556a24c9c76993$var$_excluded3);
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $gQLDR.fg)('platform-logo-rebrand-rovo-hex') || shouldUseHexLogo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(RovoHexWrapped, props);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(RovoServiceCollectionWrapped, props);
    };
};
var $ee556a24c9c76993$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref4) {
        var size = _ref4.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref4, $ee556a24c9c76993$var$_excluded4);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
            size: size || 'medium'
        }, props));
    };
};
var $ee556a24c9c76993$export$3fe521abfbbe6ab3 = function teamEUFlaggedIcon(LegacyComponent, NewComponent) {
    return function(props) {
        var Logo = (0, $gQLDR.fg)('platform-logo-rebrand-team-eu') ? $ee556a24c9c76993$export$667425256e2e7296(NewComponent) : $ee556a24c9c76993$export$667425256e2e7296(LegacyComponent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(Logo, props);
    };
};
var $ee556a24c9c76993$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'rovo-hex',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'dx',
        type: 'new',
        category: 'app',
        skipLogo: true
    },
    {
        name: 'rovo-dev',
        type: 'new',
        category: 'app'
    },
    {
        name: 'rovo-dev-agent',
        type: 'new',
        category: 'agent'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
var $ee556a24c9c76993$export$62e1212796a86b1b = $ee556a24c9c76993$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'program' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $ee556a24c9c76993$export$e0dee4a765830f4d = $ee556a24c9c76993$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'app' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $ee556a24c9c76993$export$a13ce90e90d7bfc1 = $ee556a24c9c76993$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'agent' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
}) || [];
var $ee556a24c9c76993$export$516fce44c502c1d3 = $ee556a24c9c76993$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'legacy';
});
var $ee556a24c9c76993$export$b805fae8e798ed39 = $ee556a24c9c76993$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'migration';
});
var $ee556a24c9c76993$export$3f9abd26214cd85f = $ee556a24c9c76993$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'new';
});

});


parcelRegister("NenZ7", function(module, exports) {

$parcel$export(module.exports, "BitbucketBackground", function () { return $093fbc72dba57051$export$7a8deb158bc23a3c; });

var $dNMDr = parcelRequire("dNMDr");

var $gs8Tm = parcelRequire("gs8Tm");

var $CDTqH = parcelRequire("CDTqH");

var $1qxnH = parcelRequire("1qxnH");
var $093fbc72dba57051$export$7a8deb158bc23a3c = function BitbucketBackground(_ref) {
    var children = _ref.children;
    // We don't yet have dark mode assets for Bitbucket, so we'll use the light theme by default.
    (0, $gs8Tm.default)({
        colorMode: 'light',
        dark: 'light',
        light: 'light'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1qxnH.DesktopOnlyBackground), {
        background: (0, $CDTqH.BitbucketLightTheme)
    }, children);
};

});
parcelRegister("gs8Tm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfa6289fec9eb9d0$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");

var $gQLDR = parcelRequire("gQLDR");

var $3J65S = parcelRequire("3J65S");

var $58oBY = parcelRequire("58oBY");

var $5VBMO = parcelRequire("5VBMO");

var $j2u8s = parcelRequire("j2u8s");

var $lmWPF = parcelRequire("lmWPF");

var $jexQz = parcelRequire("jexQz");

var $elV5x = parcelRequire("elV5x");
function $bfa6289fec9eb9d0$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $bfa6289fec9eb9d0$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $bfa6289fec9eb9d0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $bfa6289fec9eb9d0$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $bfa6289fec9eb9d0$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $bfa6289fec9eb9d0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $bfa6289fec9eb9d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bfa6289fec9eb9d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bfa6289fec9eb9d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bfa6289fec9eb9d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $bfa6289fec9eb9d0$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($bfa6289fec9eb9d0$var$_objectSpread($bfa6289fec9eb9d0$var$_objectSpread({}, (0, $58oBY.themeStateDefaults)), {}, {
                        typography: (0, $58oBY.themeStateDefaults)['typography'],
                        shape: (0, $58oBY.themeStateDefaults)['shape'](),
                        motion: (0, $58oBY.themeStateDefaults)['motion']()
                    }, (0, $3J65S.default)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $58oBY.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $58oBY.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $58oBY.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $58oBY.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $58oBY.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $58oBY.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $58oBY.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $58oBY.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $58oBY.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $gQLDR.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $jexQz.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $elV5x.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $5VBMO.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $58oBY.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $lmWPF.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("7WeUJ"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 11;
                    return Promise.all(loadingTasks);
                case 11:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $jexQz.getThemeOverridePreferences)(themeState);
                    _iterator = $bfa6289fec9eb9d0$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 13;
                    _iterator.s();
                case 15:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 21;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 19;
                    return loadingStrategy(themeId);
                case 19:
                    _context3.next = 15;
                    break;
                case 21:
                    _context3.next = 26;
                    break;
                case 23:
                    _context3.prev = 23;
                    _context3.t0 = _context3["catch"](13);
                    _iterator.e(_context3.t0);
                case 26:
                    _context3.prev = 26;
                    _iterator.f();
                    return _context3.finish(26);
                case 29:
                    autoUnbind = (0, $j2u8s.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 31:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                13,
                23,
                26,
                29
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $bfa6289fec9eb9d0$export$2e2bcd8739ae039 = $bfa6289fec9eb9d0$var$setGlobalTheme;

});
parcelRegister("5VBMO", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $450f96369c136a0e$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $450f96369c136a0e$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $450f96369c136a0e$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $450f96369c136a0e$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $450f96369c136a0e$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $450f96369c136a0e$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $450f96369c136a0e$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $450f96369c136a0e$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $450f96369c136a0e$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $450f96369c136a0e$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $450f96369c136a0e$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $450f96369c136a0e$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $450f96369c136a0e$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $450f96369c136a0e$export$b36dbdb4f463f05c(hex) {
    if (!$450f96369c136a0e$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $450f96369c136a0e$export$1212645cf40ebf71(hex)
    ];
}
function $450f96369c136a0e$export$5a544e13ad4e1fa5(hex) {
    if (!$450f96369c136a0e$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $450f96369c136a0e$export$47ea145a83f50dc0(hex) {
    if (!$450f96369c136a0e$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $450f96369c136a0e$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $450f96369c136a0e$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $450f96369c136a0e$export$d061e26956a60b0a(foreground, background) {
    if (!$450f96369c136a0e$var$isValidHex(foreground) || !$450f96369c136a0e$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $450f96369c136a0e$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $450f96369c136a0e$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $450f96369c136a0e$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $450f96369c136a0e$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $450f96369c136a0e$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $450f96369c136a0e$var$rgbToLab(rgbA);
    var labB = $450f96369c136a0e$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $450f96369c136a0e$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("j2u8s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddc594812c0f9097$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $gQLDR = parcelRequire("gQLDR");

var $bvVYb = parcelRequire("bvVYb");

var $4U5h0 = parcelRequire("4U5h0");

var $dTQmG = parcelRequire("dTQmG");
function $ddc594812c0f9097$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $4U5h0.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $4U5h0.default).bind();
    } else (0, $4U5h0.default).unbind();
    if ((0, $gQLDR.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $dTQmG.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $dTQmG.default).bind();
        } else (0, $dTQmG.default).unbind();
    }
    var themeAttributes = (0, $bvVYb.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $4U5h0.default).unbind();
        if ((0, $gQLDR.fg)('platform_increased-contrast-themes')) (0, $dTQmG.default).unbind();
    };
}

});
parcelRegister("bvVYb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0229cc9f182a92ba$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $gQLDR = parcelRequire("gQLDR");

var $a7eRo = parcelRequire("a7eRo");

var $58oBY = parcelRequire("58oBY");

var $aHxvj = parcelRequire("aHxvj");

var $5VBMO = parcelRequire("5VBMO");

var $80vO9 = parcelRequire("80vO9");
function $0229cc9f182a92ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0229cc9f182a92ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0229cc9f182a92ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0229cc9f182a92ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0229cc9f182a92ba$var$defaultColorMode = 'light';
var $0229cc9f182a92ba$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $0229cc9f182a92ba$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $58oBY.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $58oBY.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $58oBY.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $58oBY.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $58oBY.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $58oBY.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $58oBY.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $58oBY.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $58oBY.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $aHxvj.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $a7eRo.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $a7eRo.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $0229cc9f182a92ba$var$defaultColorMode : colorMode);
    if ((0, $gQLDR.fg)('platform_increased-contrast-themes')) result = $0229cc9f182a92ba$var$_objectSpread($0229cc9f182a92ba$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $a7eRo.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $0229cc9f182a92ba$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $5VBMO.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $80vO9.hash)(optionString);
        result[0, $a7eRo.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $0229cc9f182a92ba$export$2e2bcd8739ae039 = $0229cc9f182a92ba$var$getThemeHtmlAttrs;

});
parcelRegister("80vO9", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $5d46ff2f33dbb045$export$d6af199866bfb566; });
var $5d46ff2f33dbb045$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("4U5h0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39207b90daaa92ea$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $40QgJ = parcelRequire("40QgJ");

var $a7eRo = parcelRequire("a7eRo");

var $elV5x = parcelRequire("elV5x");
var $39207b90daaa92ea$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $39207b90daaa92ea$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $a7eRo.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $39207b90daaa92ea$var$darkModeMql = $39207b90daaa92ea$var$isMatchMediaAvailable && window.matchMedia((0, $elV5x.darkModeMediaQuery));
var $39207b90daaa92ea$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$39207b90daaa92ea$var$darkModeMql) return 'light';
                return $39207b90daaa92ea$var$darkModeMql !== null && $39207b90daaa92ea$var$darkModeMql !== void 0 && $39207b90daaa92ea$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($39207b90daaa92ea$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $40QgJ.bind)($39207b90daaa92ea$var$darkModeMql, {
                    type: 'change',
                    listener: $39207b90daaa92ea$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $39207b90daaa92ea$var$SingletonColorModeObserver = new $39207b90daaa92ea$var$ColorModeObserver();
var $39207b90daaa92ea$export$2e2bcd8739ae039 = $39207b90daaa92ea$var$SingletonColorModeObserver;

});
parcelRegister("elV5x", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $a72f4f64fdb6414b$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $a72f4f64fdb6414b$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $a72f4f64fdb6414b$export$8662df6937d86fcb; });

var $k7uol = parcelRequire("k7uol");

var $axdfd = parcelRequire("axdfd");

var $eHWOp = parcelRequire("eHWOp");

var $a7eRo = parcelRequire("a7eRo");
var $a72f4f64fdb6414b$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $a7eRo.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $a7eRo.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $a72f4f64fdb6414b$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $a72f4f64fdb6414b$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($k7uol)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($axdfd))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $eHWOp.default)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $a72f4f64fdb6414b$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $a72f4f64fdb6414b$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("eHWOp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab52b3b6e9968ed9$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









var $ab52b3b6e9968ed9$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("aO1HB"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("eSM2t"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("4rINr"));
    },
    'dark': function dark() {
        return (parcelRequire("jqj3J"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("8Kyma"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("gxidu"));
    },
    'spacing': function spacing() {
        return (parcelRequire("7KyEH"));
    },
    'typography': function typography() {
        return (parcelRequire("aOeSk"));
    },
    'shape': function shape() {
        return (parcelRequire("5NLzh"));
    },
    'motion': function motion() {
        return (parcelRequire("cg5hq"));
    }
};
var $ab52b3b6e9968ed9$export$2e2bcd8739ae039 = $ab52b3b6e9968ed9$var$themeImportsMap;

});
parcelRegister("aO1HB", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("7fhrL")).then(()=>parcelRequire('7l1ei'));

});

parcelRegister("eSM2t", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("bbLkl")).then(()=>parcelRequire('8I2s8'));

});

parcelRegister("4rINr", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("axwlS")).then(()=>parcelRequire('jpHdp'));

});

parcelRegister("jqj3J", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("ey9yq")).then(()=>parcelRequire('dvtKy'));

});

parcelRegister("8Kyma", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("2zMtf")).then(()=>parcelRequire('7mp3V'));

});

parcelRegister("gxidu", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("jjNRK")).then(()=>parcelRequire('84HTS'));

});

parcelRegister("7KyEH", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("LeMdV")).then(()=>parcelRequire('61IwL'));

});

parcelRegister("aOeSk", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("ezwib")).then(()=>parcelRequire('bUT1s'));

});

parcelRegister("5NLzh", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("99Zh2")).then(()=>parcelRequire('isjWS'));

});

parcelRegister("cg5hq", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("16lAV")).then(()=>parcelRequire('2VJr6'));

});




parcelRegister("dTQmG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1e907feb6811d63$export$2e2bcd8739ae039; });

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");

var $91FVG = parcelRequire("91FVG");

var $40QgJ = parcelRequire("40QgJ");

var $a7eRo = parcelRequire("a7eRo");

var $elV5x = parcelRequire("elV5x");
var $a1e907feb6811d63$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $a1e907feb6811d63$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $a7eRo.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $a1e907feb6811d63$var$contrastModeMql = $a1e907feb6811d63$var$isMatchMediaAvailable && window.matchMedia((0, $elV5x.moreContrastMediaQuery));
var $a1e907feb6811d63$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$a1e907feb6811d63$var$contrastModeMql) return 'no-preference';
                return $a1e907feb6811d63$var$contrastModeMql !== null && $a1e907feb6811d63$var$contrastModeMql !== void 0 && $a1e907feb6811d63$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($a1e907feb6811d63$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $40QgJ.bind)($a1e907feb6811d63$var$contrastModeMql, {
                    type: 'change',
                    listener: $a1e907feb6811d63$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $a1e907feb6811d63$var$SingletonContrastModeObserver = new $a1e907feb6811d63$var$ContrastModeObserver();
var $a1e907feb6811d63$export$2e2bcd8739ae039 = $a1e907feb6811d63$var$SingletonContrastModeObserver;

});


parcelRegister("lmWPF", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $f8e949eb31181035$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $f8e949eb31181035$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $f8e949eb31181035$export$e673f367da2ff23e; });

var $82V4i = parcelRequire("82V4i");

var $62ppy = parcelRequire("62ppy");

var $cmsut = parcelRequire("cmsut");

var $a7eRo = parcelRequire("a7eRo");

var $80vO9 = parcelRequire("80vO9");
function $f8e949eb31181035$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $80vO9.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $a7eRo.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $a7eRo.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $f8e949eb31181035$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(Array.from(document.head.querySelectorAll("style[".concat((0, $a7eRo.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $a7eRo.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $f8e949eb31181035$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $cmsut.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("cmsut", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ffda3b986439923$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::921c184d9a6e3b52bd2ab053939ce9ad>>
 * @codegenCommand yarn build tokens
 */ var $8ffda3b986439923$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.content.enter.long': '--ds-content-enter-long',
    'motion.content.enter.medium': '--ds-content-enter-medium',
    'motion.content.enter.short': '--ds-content-enter-short',
    'motion.content.exit.long': '--ds-content-exit-long',
    'motion.content.exit.medium': '--ds-content-exit-medium',
    'motion.content.exit.short': '--ds-content-exit-short',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $8ffda3b986439923$export$2e2bcd8739ae039 = $8ffda3b986439923$var$tokens;

});


parcelRegister("jexQz", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", function () { return $e009946fd6108092$export$dd6aeb7c823fc03d; });
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $e009946fd6108092$export$5d76d7014f4a5d08; });

var $62ppy = parcelRequire("62ppy");

var $gQLDR = parcelRequire("gQLDR");

var $2EA2Y = parcelRequire("2EA2Y");
var $e009946fd6108092$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $gQLDR.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $2EA2Y.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $gQLDR.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $2EA2Y.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(new Set(themePreferences));
};
var $e009946fd6108092$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(new Set(themeOverridePreferences));
};

});
parcelRegister("2EA2Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eeb475aec48685d$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $58oBY = parcelRequire("58oBY");
function $1eeb475aec48685d$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $58oBY.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});


parcelRegister("7WeUJ", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("aEErV")).then(()=>parcelRequire('I4G1B'));

});


parcelRegister("CDTqH", function(module, exports) {

$parcel$export(module.exports, "BitbucketLightTheme", function () { return $07427ea61800d6dc$export$880f50d5c5924242; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $eS3uG = parcelRequire("eS3uG");
var $3FKQn = parcelRequire("3FKQn");

var $iRKFZ = parcelRequire("iRKFZ");

var $eg0Tg = parcelRequire("eg0Tg");

var $dyM3I = parcelRequire("dyM3I");

var $gjjrB = parcelRequire("gjjrB");

var $5DRUL = parcelRequire("5DRUL");

var $4EJ8x = parcelRequire("4EJ8x");

var $4iAU6 = parcelRequire("4iAU6");
var $07427ea61800d6dc$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    content: "_19bvxy5q"
};
var $07427ea61800d6dc$export$880f50d5c5924242 = function BitbucketLightTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eg0Tg.Background), {
        testId: "testId-bitbucket-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dyM3I.TopNav), {
        product: (0, $iRKFZ.Products).BITBUCKET
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $4iAU6.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3FKQn.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $07427ea61800d6dc$var$styles.actions,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $gjjrB.Breadcrumbs), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $07427ea61800d6dc$var$styles.content,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $5DRUL.Content), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $4EJ8x.DetailsPanel), null)));
};

});
parcelRegister("iRKFZ", function(module, exports) {

$parcel$export(module.exports, "Products", function () { return $dbc162278bd9bbee$export$92e44ea1079b9ec6; });
var $dbc162278bd9bbee$export$92e44ea1079b9ec6 = {
    JIRA: 'jira',
    CONFLUENCE: 'confluence',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_SERVICE_MANAGEMENT: 'jira-service-management',
    BITBUCKET: 'bitbucket'
};

});

parcelRegister("eg0Tg", function(module, exports) {

$parcel$export(module.exports, "Background", function () { return $a613401e70f01f6c$export$668799e4797757a8; });
/* background.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $3FKQn = parcelRequire("3FKQn");
var $a613401e70f01f6c$var$styles = {
    background: "_bfhkvuon _4t3i1osq"
};
var $a613401e70f01f6c$export$668799e4797757a8 = function Background(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3FKQn.default), {
        xcss: $a613401e70f01f6c$var$styles.background,
        testId: testId
    }, children);
};

});

parcelRegister("dyM3I", function(module, exports) {

$parcel$export(module.exports, "TopNav", function () { return $9df3bad26ceee06f$export$41d0d88a6b0e456f; });
/* top-nav.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $91FVG = parcelRequire("91FVG");


var $dNMDr = parcelRequire("dNMDr");

var $ae8Qu = parcelRequire("ae8Qu");

var $gueos = parcelRequire("gueos");

var $gZevS = parcelRequire("gZevS");

var $9aWhF = parcelRequire("9aWhF");

var $3cJ1t = parcelRequire("3cJ1t");

var $dQtes = parcelRequire("dQtes");

var $9U2ah = parcelRequire("9U2ah");

var $hZQpa = parcelRequire("hZQpa");

var $l69Tm = parcelRequire("l69Tm");
var $eS3uG = parcelRequire("eS3uG");

var $iRKFZ = parcelRequire("iRKFZ");

var $h9WhW = parcelRequire("h9WhW");
var $9df3bad26ceee06f$var$styles = {
    wrapper: "_18zrv47k _n7zlia51 _1tkeckbl _1bsb1osq",
    search: "_195goahv _1bsb1osq",
    searchBar: "_2rko12b0 _19itia51 _4t3izwfg _1bsb1osq _p12fcv93 _1ul91178",
    createButton: "_2rko12b0 _4t3izwfg _1bsbys9h _bfhk1dy8",
    createButtonText: "_2rko12b0 _4t3ii2wt _1bsb1ady",
    chatButton: "_2rko12b0 _19itia51 _4t3izwfg _1bsbcae7",
    chatButtonText: "_2rko12b0 _4t3ii2wt _1bsbzwfg"
};
var $9df3bad26ceee06f$var$ProductLogos = (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $iRKFZ.Products).JIRA, (0, $hZQpa.JiraLogo)), (0, $iRKFZ.Products).CONFLUENCE, (0, $hZQpa.ConfluenceLogo)), (0, $iRKFZ.Products).JIRA_PRODUCT_DISCOVERY, (0, $hZQpa.JiraProductDiscoveryLogo)), (0, $iRKFZ.Products).JIRA_SERVICE_MANAGEMENT, (0, $hZQpa.JiraServiceManagementLogo)), (0, $iRKFZ.Products).BITBUCKET, (0, $hZQpa.BitbucketLogo));
var $9df3bad26ceee06f$var$ProductIcons = (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $iRKFZ.Products).JIRA, (0, $hZQpa.JiraIcon)), (0, $iRKFZ.Products).CONFLUENCE, (0, $hZQpa.ConfluenceIcon)), (0, $iRKFZ.Products).JIRA_PRODUCT_DISCOVERY, (0, $hZQpa.JiraProductDiscoveryIcon)), (0, $iRKFZ.Products).JIRA_SERVICE_MANAGEMENT, (0, $hZQpa.JiraServiceManagementIcon)), (0, $iRKFZ.Products).BITBUCKET, (0, $hZQpa.BitbucketIcon));
var $9df3bad26ceee06f$export$41d0d88a6b0e456f = function TopNav(_ref) {
    var product = _ref.product;
    var Logo = $9df3bad26ceee06f$var$ProductLogos[product];
    var Icon = $9df3bad26ceee06f$var$ProductIcons[product];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $9df3bad26ceee06f$var$styles.wrapper,
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9U2ah))), {
        label: "Sidebar collapse",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ae8Qu))), {
        label: "App switcher",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9WhW.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(Logo, {
        appearance: "brand",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9WhW.BelowMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(Icon, {
        appearance: "brand",
        size: "small"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $9df3bad26ceee06f$var$styles.search,
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $9df3bad26ceee06f$var$styles.searchBar,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3cJ1t))), {
        label: "Search",
        color: "var(--ds-icon-subtle, #505258)",
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $9df3bad26ceee06f$var$styles.createButton,
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $9df3bad26ceee06f$var$styles.createButtonText,
        backgroundColor: "color.background.accent.blue.subtler.hovered"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $9df3bad26ceee06f$var$styles.chatButton,
        alignBlock: "center",
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $hZQpa.RovoIcon), {
        size: "xxsmall",
        appearance: "neutral"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $9df3bad26ceee06f$var$styles.chatButtonText,
        backgroundColor: "color.background.accent.gray.subtlest.hovered"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gueos))), {
        label: "Notifications",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aWhF))), {
        label: "Help",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dQtes))), {
        label: "Settings",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gZevS))), {
        label: "User",
        color: "var(--ds-icon-subtle, #505258)"
    })));
};

});
parcelRegister("ae8Qu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55422f7c50559ad266d0694af3ada2f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $772212b91fcfb015$var$_react = $772212b91fcfb015$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $772212b91fcfb015$var$_baseNew = $772212b91fcfb015$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $772212b91fcfb015$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $772212b91fcfb015$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $772212b91fcfb015$var$_react.default.createElement($772212b91fcfb015$var$_baseNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$772212b91fcfb015$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $772212b91fcfb015$var$_default = module.exports.default = $772212b91fcfb015$var$AppSwitcherIcon;

});

parcelRegister("gueos", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45233a62a3f56b9e4911deb2a2339447>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c00a9cef355423a9$var$_react = $c00a9cef355423a9$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $c00a9cef355423a9$var$_baseNew = $c00a9cef355423a9$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $c00a9cef355423a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global app navigation and within app screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c00a9cef355423a9$var$NotificationIcon = (props)=>/*#__PURE__*/ $c00a9cef355423a9$var$_react.default.createElement($c00a9cef355423a9$var$_baseNew.default, Object.assign({
        name: "NotificationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.42 13.5a1.748 1.748 0 0 0 3.16 0zM4.5 8.636c0 .215-.06.426-.175.608L2.603 12h10.795l-1.723-2.756a1.15 1.15 0 0 1-.175-.608V5a3.5 3.5 0 0 0-7 0zm8.5-.1 1.788 2.86a1.375 1.375 0 0 1-1.166 2.104h-2.46a3.25 3.25 0 0 1-6.324 0h-2.46a1.375 1.375 0 0 1-1.166-2.104L3 8.537V5a5 5 0 0 1 10 0z"/>`
    }, props));
$c00a9cef355423a9$var$NotificationIcon.displayName = 'NotificationIcon';
var $c00a9cef355423a9$var$_default = module.exports.default = $c00a9cef355423a9$var$NotificationIcon;

});

parcelRegister("gZevS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5a2b32fe863ac429d199dc8b174e3b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c5dd99ddeb661b85$var$_react = $c5dd99ddeb661b85$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $c5dd99ddeb661b85$var$_baseNew = $c5dd99ddeb661b85$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $c5dd99ddeb661b85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c5dd99ddeb661b85$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $c5dd99ddeb661b85$var$_react.default.createElement($c5dd99ddeb661b85$var$_baseNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$c5dd99ddeb661b85$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $c5dd99ddeb661b85$var$_default = module.exports.default = $c5dd99ddeb661b85$var$PersonAvatarIcon;

});

parcelRegister("9aWhF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb31d7b8eb39bae440b5a0002b7aa63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ae2423473286543$var$_react = $6ae2423473286543$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $6ae2423473286543$var$_baseNew = $6ae2423473286543$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $6ae2423473286543$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ae2423473286543$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $6ae2423473286543$var$_react.default.createElement($6ae2423473286543$var$_baseNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$6ae2423473286543$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $6ae2423473286543$var$_default = module.exports.default = $6ae2423473286543$var$QuestionCircleIcon;

});

parcelRegister("3cJ1t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ed30ba2fe598b1c691c4159780db191>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25556ab0e7c4cace$var$_react = $25556ab0e7c4cace$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $25556ab0e7c4cace$var$_baseNew = $25556ab0e7c4cace$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $25556ab0e7c4cace$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25556ab0e7c4cace$var$SearchIcon = (props)=>/*#__PURE__*/ $25556ab0e7c4cace$var$_react.default.createElement($25556ab0e7c4cace$var$_baseNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$25556ab0e7c4cace$var$SearchIcon.displayName = 'SearchIcon';
var $25556ab0e7c4cace$var$_default = module.exports.default = $25556ab0e7c4cace$var$SearchIcon;

});

parcelRegister("dQtes", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6207a690a69d1b6395dc313a9a74c2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a146ce93ab10c7b6$var$_react = $a146ce93ab10c7b6$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $a146ce93ab10c7b6$var$_baseNew = $a146ce93ab10c7b6$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $a146ce93ab10c7b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a146ce93ab10c7b6$var$SettingsIcon = (props)=>/*#__PURE__*/ $a146ce93ab10c7b6$var$_react.default.createElement($a146ce93ab10c7b6$var$_baseNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$a146ce93ab10c7b6$var$SettingsIcon.displayName = 'SettingsIcon';
var $a146ce93ab10c7b6$var$_default = module.exports.default = $a146ce93ab10c7b6$var$SettingsIcon;

});

parcelRegister("9U2ah", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7c03d2728886be26240ae9af453c127>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $735b05e7da98dec6$var$_react = $735b05e7da98dec6$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $735b05e7da98dec6$var$_baseNew = $735b05e7da98dec6$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $735b05e7da98dec6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $735b05e7da98dec6$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $735b05e7da98dec6$var$_react.default.createElement($735b05e7da98dec6$var$_baseNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$735b05e7da98dec6$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $735b05e7da98dec6$var$_default = module.exports.default = $735b05e7da98dec6$var$SidebarCollapseIcon;

});

parcelRegister("h9WhW", function(module, exports) {

$parcel$export(module.exports, "AboveMediumScreen", function () { return $c7e07dc8afb758ae$export$1bc531f284926080; });
$parcel$export(module.exports, "AboveSmallScreen", function () { return $c7e07dc8afb758ae$export$f238340b7c0c9a5b; });
$parcel$export(module.exports, "BelowMediumScreen", function () { return $c7e07dc8afb758ae$export$7dc4de1155708460; });
/* css-media-queries.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
// note: can't use imported values in a cssMap (otherwise would use media.above.sm/md here)
var $c7e07dc8afb758ae$var$styles = {
    aboveMediumScreen: "_4t3i1osq _dm251txw _1mjbglyw",
    aboveSmallScreen: "_4t3i1osq _181n1ule _sugaglyw",
    belowMediumScreen: "_4t3i1osq _dm25glyw _1mjb1txw",
    belowSmallScreen: "_4t3i1osq _181nglyw _suga1ule"
};
var $c7e07dc8afb758ae$export$1bc531f284926080 = function AboveMediumScreen(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $c7e07dc8afb758ae$var$styles.aboveMediumScreen,
        testId: "above-medium-screen",
        "aria-hidden": true,
        tabIndex: -1
    }, children);
};
var $c7e07dc8afb758ae$export$f238340b7c0c9a5b = function AboveSmallScreen(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $c7e07dc8afb758ae$var$styles.aboveSmallScreen,
        testId: "above-small-screen",
        "aria-hidden": true,
        tabIndex: -1
    }, children);
};
var $c7e07dc8afb758ae$export$7dc4de1155708460 = function BelowMediumScreen(_ref3) {
    var children = _ref3.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $c7e07dc8afb758ae$var$styles.belowMediumScreen,
        testId: "below-medium-screen",
        "aria-hidden": true,
        tabIndex: -1
    }, children);
};
var $c7e07dc8afb758ae$export$683c905d63c7331e = function BelowSmallScreen(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $c7e07dc8afb758ae$var$styles.belowSmallScreen,
        testId: "below-small-screen",
        "aria-hidden": true,
        tabIndex: -1
    }, children);
};

});


parcelRegister("gjjrB", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $bdfd80eb6d6d2afd$export$2dc68d50d56fbbd; });

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $bdfd80eb6d6d2afd$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($bdfd80eb6d6d2afd$var$Illustration, null));
};
var $bdfd80eb6d6d2afd$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 167,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#8590A2",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }));
};

});

parcelRegister("5DRUL", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $41ba6a95c06eac0d$export$7c6e2c02157bb7d2; });

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $41ba6a95c06eac0d$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($41ba6a95c06eac0d$var$Illustration, null));
};
var $41ba6a95c06eac0d$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "820",
        height: "619",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#PageContentA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#B2D4FF",
        d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#0065FF",
        d: "M24.466 25.316ZM17.472 30.51l.026-.105.023-.095-1.26.653 1.308-.87c.018-.098.029-.195.026-.29a.653.653 0 0 0-.059-.256c-.115-.038-.202-.168-.205-.33-.002-.197.118-.358.267-.363.084 0 .156.046.207.123.223.148.343.435.374.711l3.67-2.442c1.862-.822 2.445-1.505 2.607-1.935h.005-.005c.117-.31.018-.487.018-.487-.136-1.2-.799-1.85-1.587-2.191-1.01.602-2.494 1.093-3.07.632l.036.497c.015.023.054.066.105.12l.025.028c.07.075.151.167.22.251.09.113.152.215.113.256-.171.085-.343.18-.512.287-1.664 1.03-3.228 2.908-3.725 3.558-.028-.02-.069-.053-.12-.094-.576-.74-2.13-2.563-3.76-3.53a5.293 5.293 0 0 0-.62-.32c-.008-.013-.013-.026-.02-.039a.234.234 0 0 1 .074-.077c.002 0 .005-.005.01-.007l.059-.039c.15-.084.358-.15.407-.228l.118-1.54s-.008 0-.02-.006c-.006.264-.024.556-.057.873-.566.476-2.056-.015-3.072-.617-.78.343-1.439.988-1.572 2.184 0 0-.102.179.02.491-1.251.4-2.521.873-3.417 1.38a15.954 15.954 0 0 0 10.056 5.192c-.029-.482-.093-.906-.203-1.226l-.035-.1c-.085-.236-.18-.502-.17-.791 0-.029.006-.057.01-.085L6.355 25.87c.397-.151.812-.295 1.229-.433.228.43.865 1.063 2.547 1.805l3.679 2.253c.056-.17.156-.328.297-.448a.387.387 0 0 1 .358-.213c.213.005.379.167.374.364-.005.197-.18.353-.392.348h-.008a.426.426 0 0 0-.092.243v.036l1.452.888s.005.013.01.02l-1.441-.739c.025.118.066.238.112.366l.039.105c.138.4.215.911.24 1.475.41.03.825.053 1.245.053.468 0 .931-.025 1.39-.064-.031-.555-.01-1.052.082-1.426l-.003.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#0065FF",
        d: "M18.181 29.97c-.015.205-.064.397-.11.581l-.026.102c-.076.313-.094.738-.069 1.222a15.969 15.969 0 0 0 9.92-5.177 13.857 13.857 0 0 0-1.815-.822l-7.897 4.094h-.003Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "url(#PageContentB)",
        d: "M20.2 24.164c-.068-.085-.15-.174-.22-.251a.155.155 0 0 1-.015-.013c-.002 0-.007-.01-.01-.013a1.6 1.6 0 0 1-.105-.12l-.036-.497-.012-.007a12.55 12.55 0 0 1-.057-.817c-.005-.033-.005-.064-.008-.092-.04-.522-.076-1.1-.104-1.626-.59.569-1.411 1.13-2.57 1.582a2.062 2.062 0 0 1-.748.154h-1.08c-.262 0-.512-.061-.748-.154-.952-.37-1.677-.816-2.232-1.28-.013.382-.031.781-.052 1.16V22.39c.013 0-.094 1.543-.094 1.543-.049.077-.256.144-.407.228l-.06.039c-.002 0-.004.005-.01.007a.263.263 0 0 0-.074.077c.008.013.013.026.02.039.208.092.413.2.62.32 1.631.967 3.185 2.787 3.761 3.53l.12.095c.497-.653 2.061-2.53 3.725-3.559.17-.105.34-.2.512-.287.039-.04-.023-.14-.113-.256l-.002-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#0747A6",
        d: "M14.48 30.367a2.964 2.964 0 0 1-.113-.366l1.441.74-.01-.021-1.452-.888v-.036a.42.42 0 0 1 .092-.243h.008c.213.005.387-.151.392-.349.005-.197-.164-.358-.374-.363a.387.387 0 0 0-.358.212.962.962 0 0 0-.297.448L10.13 27.25c-1.682-.743-2.32-1.372-2.547-1.805-.417.138-.832.281-1.229.433l7.414 3.814c-.003.028-.008.056-.01.084-.01.29.084.556.169.791l.035.1c.11.318.177.745.203 1.226.197.024.396.041.596.057-.026-.566-.102-1.075-.24-1.475l-.039-.105-.003-.002ZM18.045 30.653l.026-.102c.049-.187.095-.379.11-.581l7.898-4.093c-.52-.2-1.068-.387-1.61-.561h-.011c-.164.43-.745 1.113-2.606 1.935l-3.67 2.442c-.029-.279-.152-.563-.375-.711-.05-.075-.125-.126-.207-.123-.151.005-.271.166-.266.363.002.164.09.292.205.33.03.062.056.15.058.257 0 .094-.007.19-.025.289l-1.308.87 1.26-.652c-.009.03-.016.06-.024.094l-.025.105c-.093.374-.113.868-.082 1.426.197-.018.391-.038.586-.061-.023-.482-.008-.91.069-1.221l-.003-.006Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#172B4D",
        d: "M12.145 23.26c.036-.317.05-.61.056-.873V22.188c.02-.38.038-.779.051-1.16-1.779-1.485-1.797-3.149-1.797-3.149-.008-.08-.015-.154-.02-.23h-.082c-.5-2.128-.855-3.91-.031-3.828a.81.81 0 0 1 .24.062c.034-.036.267-.512.423-.812a.684.684 0 0 1 .39-.338c.836-.286 1.453-.15 1.453-.15.044-.2.103-.387.172-.564.156-.32.396-.763.722-1.18a4.685 4.685 0 0 1 1.51-1.131c.077-.021.156-.036.236-.047 1.812.067 4.669 2.517 5.273 4.053.123.31.305.261.484.125.171-.13.335-.343.433-.391.035.023.074.046.105.074.34.673.291 1.564.048 2.57-.051.18-.1.34-.146.474-.21.601-.302.937-.55 1.042a9.71 9.71 0 0 1-.026.274s-.015 1.449-1.459 2.849a69.25 69.25 0 0 0 .113 1.718 12.744 12.744 0 0 0 .056.817l.013.007c.576.463 2.06-.03 3.07-.632.647-.387 1.1-.814.987-1.065a2.796 2.796 0 0 1-.166-.52c-.03-.535-.064-1.093-.102-1.664.025-1.556.156-3.63-.745-6.438-.057-.295-.113-.592-.177-.884-.274-1.236-.793-2.516-1.602-3.591a6.662 6.662 0 0 0-5.464-2.852c-2.82 0-5.232 1.759-6.215 4.247a9.924 9.924 0 0 0-.755 2.196c-.228 1.027-.3 2.084-.308 3.141-.53 3.037.32 5.051-.268 6.367-.113.251.345.684 1 1.07 1.017.602 2.504 1.093 3.073.617l.005-.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#A96935",
        d: "M21.12 17.603c.248-.108.34-.443.55-1.042.047-.13.098-.295.146-.474.244-1.006.292-1.897-.048-2.57a.512.512 0 0 0-.105-.074c-.097.048-.261.26-.433.391.023.305.036.615.036.924 0 1.05-.059 1.905-.146 2.845ZM10.325 13.816c-.822-.08-.469 1.7.03 3.827.026.003.054 0 .082 0a30.21 30.21 0 0 1-.148-2.89c0-.317.013-.632.036-.942v.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#C4743D",
        d: "M15.237 22.461h1.08c.262 0 .512-.061.748-.153 1.157-.45 1.982-1.011 2.57-1.582 1.447-1.398 1.46-2.85 1.46-2.85.007-.092.017-.184.025-.273.087-.943.146-1.795.146-2.845 0-.312-.013-.62-.036-.924-.177.136-.36.185-.484-.125-.604-1.539-3.463-3.989-5.273-4.053-.08.01-.159.026-.236.046-.26.12-.93.469-1.51 1.132-.323.417-.566.86-.722 1.18-.07.177-.126.364-.172.563 0 0-.617-.135-1.454.151a.684.684 0 0 0-.389.338c-.156.3-.392.776-.422.812a.921.921 0 0 0-.24-.062c-.024.31-.037.625-.037.942 0 1.068.062 1.93.149 2.89l.02.231s.016 1.667 1.797 3.149c.556.463 1.28.909 2.233 1.28.235.092.489.153.747.153Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "160",
        height: "32",
        x: "40",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "120",
        height: "6",
        x: "48",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M171 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M179.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "32",
        height: "32",
        x: "208",
        fill: "#fff",
        fillOpacity: ".01",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M212 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M223.793 9.793a.993.993 0 0 0-.217 1.09c.05.121.124.231.217.324L227.586 15H218a1 1 0 1 0 0 2h9.586l-3.793 3.793a.994.994 0 0 0-.217 1.09 1.002 1.002 0 0 0 1.632.324l5.499-5.5a.997.997 0 0 0 .293-.679v-.057a.995.995 0 0 0-.293-.678l-5.499-5.5a.997.997 0 0 0-1.09-.217.997.997 0 0 0-.325.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "100",
        height: "32",
        x: "248",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "60",
        height: "6",
        x: "256",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M319 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M327.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "99",
        height: "32",
        x: "720",
        fill: "#B3D4FF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "59",
        height: "6",
        x: "728",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M790 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".25",
        fillRule: "evenodd",
        d: "M798.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "52",
        height: "14",
        x: "40",
        y: "44",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "44",
        height: "6",
        x: "44",
        y: "48",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "206",
        height: "6",
        x: "108",
        y: "48",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "53",
        height: "6",
        y: "90",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M0 106h77v2H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "53",
        height: "6",
        x: "77",
        y: "90",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M77 106h77v2H77z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "53",
        height: "6",
        x: "154",
        y: "90",
        fill: "#4C9AFF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#4C9AFF",
        d: "M154 106h77v2h-77z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M231 106h589v2H231z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "160",
        height: "32",
        y: "132",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "120",
        height: "6",
        x: "8",
        y: "145",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M131 136h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M139.292 146.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#PageContentC)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#FAFBFC",
        d: "M268 230h62v389h-62z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "250",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "250",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "272",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "294",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "294",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "316",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "316",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "295",
        y: "344",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3",
        transform: "rotate(-180 295 344)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "360",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "360",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "456",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "456",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "500",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "500",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#F4F5F7",
        d: "M268 188h551v42H268z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M280 197h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M288.292 207.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "312",
        y: "206",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "10",
        height: "10",
        x: "676",
        y: "204",
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "48",
        height: "6",
        x: "695",
        y: "206",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M751 197h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M765 201.187a10.734 10.734 0 0 0-2-.187c-4.963 0-9 3.37-9 7.513s4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003c.053.02.108.031.164.033a.52.52 0 0 0 .429-.231.516.516 0 0 0 .045-.485v-.002s-1.563-2.26-.766-3.116l-.037.02c1.227-1.284 1.966-2.907 1.966-4.673 0-.171-.006-.342-.02-.513h-2.008c.02.169.03.34.03.513 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51 0-3.038 3.141-5.51 7.002-5.51.695 0 1.366.08 2 .229v-2.045Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M770 202a1 1 0 0 0-2 0v4a1 1 0 0 0 2 0v-4Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M771 203h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M783 197h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M795 211a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122A1.503 1.503 0 0 1 795 211Zm-4.5 0a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122 1.503 1.503 0 0 1-1.061.439Zm9 0a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122 1.503 1.503 0 0 1-1.061.439Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#PageContentD)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 228h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: "350",
        cy: "240",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "75",
        height: "6",
        x: "370",
        y: "237",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#E3FCEF",
        d: "M330 250h489v20H330z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M344 254h12v12h-12z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M350.5 259.5v-2a.504.504 0 0 0-.146-.354.504.504 0 0 0-.708 0 .504.504 0 0 0-.146.354v2h-2a.504.504 0 0 0-.354.146.504.504 0 0 0 0 .708.504.504 0 0 0 .354.146h2v2c0 .133.053.26.146.354a.504.504 0 0 0 .708 0 .504.504 0 0 0 .146-.354v-2h2c.133 0 .26-.053.354-.146a.504.504 0 0 0 0-.708.504.504 0 0 0-.354-.146h-2Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "131",
        height: "6",
        x: "370",
        y: "257",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#PageContentE)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 288h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: "350",
        cy: "300",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "209",
        height: "6",
        x: "370",
        y: "297",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#PageContentF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 308h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: "350",
        cy: "320",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "135",
        height: "6",
        x: "370",
        y: "317",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#FFEBE6",
        d: "M330 330h489v20H330z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "6",
        height: "2",
        x: "347",
        y: "339",
        fill: "#D9D9D9",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "83",
        height: "6",
        x: "370",
        y: "337",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#E3FCEF",
        d: "M330 350h489v100H330z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M344 354h12v12h-12z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M350.5 359.5v-2a.504.504 0 0 0-.146-.354.504.504 0 0 0-.708 0 .504.504 0 0 0-.146.354v2h-2a.504.504 0 0 0-.354.146.504.504 0 0 0 0 .708.504.504 0 0 0 .354.146h2v2c0 .133.053.26.146.354a.504.504 0 0 0 .708 0 .504.504 0 0 0 .146-.354v-2h2c.133 0 .26-.053.354-.146a.504.504 0 0 0 0-.708.504.504 0 0 0-.354-.146h-2Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "131",
        height: "6",
        x: "370",
        y: "357",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M344 374h465v68H344z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#PageContentG)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#C0B6F2",
        d: "M375.904 393.998c0-6.574-5.33-11.904-11.904-11.904s-11.904 5.33-11.904 11.904 5.33 11.904 11.904 11.904 11.904-5.33 11.904-11.904Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#998DD9",
        d: "M369.098 403.32a3.41 3.41 0 0 1-2.116-3.151 3.324 3.324 0 0 1 1.171-2.565c4.694-3.942 1.782-11.574-4.276-11.453-5.935.102-8.634 7.592-4.03 11.453a3.324 3.324 0 0 1 1.171 2.565 3.408 3.408 0 0 1-2.116 3.151c-.368.153-.731.322-1.088.505-.098.051-.194.109-.292.165a11.85 11.85 0 0 0 6.476 1.918c2.391 0 4.616-.709 6.482-1.922a15.005 15.005 0 0 0-.518-.271 12.696 12.696 0 0 0-.866-.393l.002-.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "119",
        height: "6",
        x: "388",
        y: "391",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "303.948",
        height: "6",
        x: "352",
        y: "414",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "191.135",
        height: "6",
        x: "352",
        y: "428",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#PageContentH)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 448h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: "350",
        cy: "460",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "135",
        height: "6",
        x: "370",
        y: "457",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#PageContentI)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 488h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: "350",
        cy: "500",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "105",
        height: "6",
        x: "370",
        y: "497",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#091E42",
        strokeOpacity: ".13",
        d: "M268.5 188.5h550v430h-550z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "80",
        height: "32",
        x: "739",
        y: "132",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "64",
        height: "6",
        x: "747",
        y: "145",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 196h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M24.292 206.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "131",
        height: "6",
        x: "56",
        y: "205",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 236h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 246.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "245",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "184",
        height: "20",
        x: "48",
        y: "278",
        fill: "#091E42",
        fillOpacity: ".04",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "79",
        height: "6",
        x: "80",
        y: "285",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M46 276h24v24H46z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M54.292 286.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 316h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M24.292 326.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "131",
        height: "6",
        x: "56",
        y: "325",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 356h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 366.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "365",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 396h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M24.292 406.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "131",
        height: "6",
        x: "56",
        y: "405",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 436h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 446.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "445",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 476h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 486.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "485",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#091E42",
        strokeOpacity: ".13",
        d: "M.5 188.5h239v430H.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "PageContentA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M0 0h32v32H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "PageContentC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M268 188h551v431H268z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "PageContentD"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M330 230h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "PageContentE"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M330 290h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "PageContentF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M330 310h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "PageContentG"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M352 382h24v24h-24z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "PageContentH"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M330 450h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "PageContentI"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M330 490h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("linearGradient", {
        id: "PageContentB",
        x1: "15.944",
        x2: "15.944",
        y1: "35.84",
        y2: "20.992",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("stop", {
        stopColor: "#C4743D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("stop", {
        offset: ".43",
        stopColor: "#BB703A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("stop", {
        offset: "1",
        stopColor: "#A96935"
    }))));
};

});

parcelRegister("4EJ8x", function(module, exports) {

$parcel$export(module.exports, "DetailsPanel", function () { return $363de9105f601c46$export$e54a7f2505304e20; });
/* details-panel.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");

var $h9WhW = parcelRequire("h9WhW");
var $363de9105f601c46$var$styles = {
    wrapper: "_1kl7ia51 _18u0utpp _4t3i1osq"
};
var $363de9105f601c46$export$e54a7f2505304e20 = function DetailsPanel() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9WhW.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $363de9105f601c46$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($363de9105f601c46$var$Illustration, null)));
};
var $363de9105f601c46$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "333",
        height: "776",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M0 0h333v776H0V0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "32",
        y: "40",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        filter: "url(#SidebarA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M32 70h269v175H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "81",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "78",
        height: "6",
        x: "80",
        y: "90",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 81h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M273.292 91.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M32 117h269v-1H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#SidebarB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#B2D4FF",
        d: "M71.944 135.997c0-6.597-5.348-11.945-11.945-11.945s-11.945 5.348-11.945 11.945 5.348 11.945 11.945 11.945 11.945-5.348 11.945-11.945Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#2684FF",
        d: "M65.115 145.352a3.421 3.421 0 0 1-2.124-3.16 3.338 3.338 0 0 1 1.177-2.575c4.71-3.955 1.788-11.614-4.29-11.491-5.957.102-8.666 7.619-4.044 11.491a3.344 3.344 0 0 1 1.177 2.575 3.416 3.416 0 0 1-2.124 3.16c-.37.154-.733.325-1.092.505-.1.052-.194.112-.292.165a11.882 11.882 0 0 0 6.499 1.926c2.4 0 4.633-.71 6.503-1.928a13.607 13.607 0 0 0-1.388-.668h-.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "130",
        height: "6",
        x: "80",
        y: "133",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#SidebarC)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#B2D4FF",
        d: "M72 176c0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12 12-5.373 12-12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#2684FF",
        d: "M65.12 185.395a3.43 3.43 0 0 1-1.77-1.648l3.01.006c.719.004 1.212-.818.853-1.448a5.53 5.53 0 0 1-.622-2.561v-4.867a6.833 6.833 0 0 0-1.758-4.662c-3.493-3.825-9.956-2.25-11.202 2.838-.44 1.194-.196 5.357-.253 6.666a5.478 5.478 0 0 1-.628 2.561.983.983 0 0 0 .854 1.452l3.015.006a3.431 3.431 0 0 1-1.776 1.658c-.292.125-.586.252-.87.396-.175.084-.346.177-.515.269a11.943 11.943 0 0 0 6.544 1.943c2.407 0 4.646-.711 6.524-1.932a10.607 10.607 0 0 0-.538-.28 13.187 13.187 0 0 0-.87-.396l.003-.001Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "130",
        height: "6",
        x: "80",
        y: "173",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M48 204h24v24H48z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M61 215v-7.007a.996.996 0 0 0-1-.993c-.556 0-1 .445-1 .993V215h-7.007a.999.999 0 0 0-.993 1c0 .557.445 1 .993 1H59v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V217h7.007a.998.998 0 0 0 .993-1c0-.556-.445-1-.993-1H61Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "90",
        height: "6",
        x: "80",
        y: "213",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        filter: "url(#SidebarD)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M32 261h269v174H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "272",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "281",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#F4F5F7",
        fillRule: "evenodd",
        d: "M218 292a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 272h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M273.292 282.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M32 307.731h269v-.994H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#F4F5F7",
        fillRule: "evenodd",
        d: "M60 335a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "170",
        height: "6",
        x: "80",
        y: "324",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#F4F5F7",
        fillRule: "evenodd",
        d: "M60 375a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "139",
        height: "6",
        x: "80",
        y: "364",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M50 397h20v20H50z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#36B37E",
        fillRule: "evenodd",
        d: "M68.333 407a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0Zm-10.514-.776a.833.833 0 0 1 .27.187l1.078 1.077 2.744-2.744a.847.847 0 0 1 .27-.187.846.846 0 0 1 .645-.005.838.838 0 0 1 .517.778.837.837 0 0 1-.254.593l-3.333 3.333a.834.834 0 0 1-1.179 0l-1.666-1.667a.84.84 0 0 1-.255-.592.834.834 0 0 1 1.163-.773Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "194",
        height: "6",
        x: "80",
        y: "404",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        filter: "url(#SidebarE)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M32 452h269v174H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "463",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "472",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 463h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M273.292 473.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M32 498.731h269v-.994H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "12",
        height: "12",
        x: "48",
        y: "512",
        fill: "#0052CC",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M57.207 515.793a1 1 0 0 1 0 1.414l-3.5 3.5a1 1 0 0 1-1.414 0l-1.5-1.5a1 1 0 1 1 1.414-1.414l.793.793 2.793-2.793a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "71",
        height: "6",
        x: "76",
        y: "515",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "12",
        height: "12",
        x: "48",
        y: "552",
        fill: "#fff",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "10",
        height: "10",
        x: "49",
        y: "553",
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "131",
        height: "6",
        x: "76",
        y: "555",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "12",
        height: "12",
        x: "48",
        y: "592",
        fill: "#fff",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "10",
        height: "10",
        x: "49",
        y: "593",
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "71",
        height: "6",
        x: "76",
        y: "595",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        filter: "url(#SidebarF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M32 643h269v48H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "654",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "663",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 678v-24h24v24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M275.293 669.708a1.009 1.009 0 0 0 1.419 0l2.965-2.939c.215-.218.322-.5.322-.779s-.107-.556-.322-.769l-2.955-2.93a1.008 1.008 0 0 0-1.637.322.996.996 0 0 0 0 .762c.051.121.125.23.218.322l2.317 2.298-2.327 2.307a.99.99 0 0 0 0 1.406Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        filter: "url(#SidebarG)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M32 707h269v48H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "718",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "727",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 742v-24h24v24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M275.293 733.708a1.009 1.009 0 0 0 1.419 0l2.965-2.939c.215-.218.322-.5.322-.779s-.107-.556-.322-.769l-2.955-2.93a1.008 1.008 0 0 0-1.637.322.996.996 0 0 0 0 .762c.051.121.125.23.218.322l2.317 2.298-2.327 2.307a.99.99 0 0 0 0 1.406Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("filter", {
        id: "SidebarA",
        width: "271",
        height: "179",
        x: "31",
        y: "68",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("filter", {
        id: "SidebarD",
        width: "271",
        height: "178",
        x: "31",
        y: "259",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("filter", {
        id: "SidebarE",
        width: "271",
        height: "178",
        x: "31",
        y: "450",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("filter", {
        id: "SidebarF",
        width: "271",
        height: "52",
        x: "31",
        y: "641",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("filter", {
        id: "SidebarG",
        width: "271",
        height: "52",
        x: "31",
        y: "705",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "SidebarB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M48 124h24v24H48z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "SidebarC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M48 164h24v24H48z"
    }))));
};

});

parcelRegister("4iAU6", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $32157833451e3707$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");

var $h9WhW = parcelRequire("h9WhW");
var $32157833451e3707$var$styles = {
    background: "_1s7zia51 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $32157833451e3707$export$1a35787d6353cf6a = function SideNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9WhW.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $32157833451e3707$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($32157833451e3707$var$Illustration, null)));
};
var $32157833451e3707$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 296,
        height: 473,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M265.25 151.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 150.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M285.5 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 72,
        height: 9,
        x: 20,
        y: 189,
        fill: "#B3B9C4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 278,
        height: 43,
        x: 18,
        y: 215,
        fill: "#E9F2FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 220.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 224,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#1868DB",
        d: "M18 229h2.66v15.96H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 232.5,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M259.25 237.25v4.25h1.5v-4.25H265v-1.5h-4.25v-4.25h-1.5v4.25H255v1.5h4.25ZM279.25 236.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M279.5 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM284.25 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM289 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 263.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 267,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 275.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 306.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 310,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 318.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M20 349.5h32v32H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M39 360.5H25V359h14v1.5Zm0 5.25H25v-1.5h14v1.5ZM32 371h-7v-1.5h7v1.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 64,
        y: 361.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 392.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 396.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 404.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 408.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 435.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M9.667 451.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 451a1.667 1.667 0 1 1 3.335 0A1.667 1.667 0 0 1 8 451Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 451a1.667 1.667 0 1 1 3.335 0 1.667 1.667 0 0 1-3.335 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 451A1.667 1.667 0 1 1 24 451a1.667 1.667 0 0 1-3.334 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M10 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 451a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 447.5,
        fill: "#DCDFE4",
        rx: 3.99
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M0 0h296v473H0z"
    }))));
};

});


parcelRegister("1qxnH", function(module, exports) {

$parcel$export(module.exports, "DesktopOnlyBackground", function () { return $10a21cf8170cf41f$export$5e40b6732fa22ace; });

var $dNMDr = parcelRequire("dNMDr");

var $h9WhW = parcelRequire("h9WhW");

var $dlfBm = parcelRequire("dlfBm");
var $10a21cf8170cf41f$export$5e40b6732fa22ace = function DesktopOnlyBackground(_ref) {
    var Background = _ref.background, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9WhW.AboveSmallScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(Background, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dlfBm.DesktopOnlyBlanket), null, children));
};

});
parcelRegister("dlfBm", function(module, exports) {

$parcel$export(module.exports, "DesktopOnlyBlanket", function () { return $9b6956b2ce5a6dba$export$a2dbb796fb00a8aa; });
/* desktop-only-blanket.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $grvIM = parcelRequire("grvIM");

var $dNMDr = parcelRequire("dNMDr");

var $fBYfd = parcelRequire("fBYfd");

var $gQLDR = parcelRequire("gQLDR");

var $l69Tm = parcelRequire("l69Tm");
var $9b6956b2ce5a6dba$var$styles = {
    blanket: "_e7o8idpf _1rqi1n9t _1gw0bfng _1jb31i5c _1bv01wug _1nwk1wug",
    hideAtlaskitBlanketOnSmallScreen: "_i2nb1j28"
};
var $9b6956b2ce5a6dba$export$a2dbb796fb00a8aa = function DesktopOnlyBlanket(_ref) {
    var children = _ref.children;
    if ((0, $gQLDR.fg)('cfind_4831_product_overlay_modal_visual_updates')) // Hide blanket using CSS so it can render in SSR
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
        className: (0, $grvIM.default)([
            $9b6956b2ce5a6dba$var$styles.hideAtlaskitBlanketOnSmallScreen
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fBYfd.default), {
        isTinted: true
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        role: "presentation",
        xcss: $9b6956b2ce5a6dba$var$styles.blanket
    }, children);
};

});
parcelRegister("fBYfd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5d90afdcdd0fff3$export$2e2bcd8739ae039; });
/* blanket.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
var $9vljA = parcelRequire("9vljA");

var $02D9g = parcelRequire("02D9g");

var $c3KQG = parcelRequire("c3KQG");

var $2Mjap = parcelRequire("2Mjap");

function $b5d90afdcdd0fff3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b5d90afdcdd0fff3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b5d90afdcdd0fff3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b5d90afdcdd0fff3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b5d90afdcdd0fff3$var$packageName = "@atlaskit/blanket";
var $b5d90afdcdd0fff3$var$packageVersion = "0.0.0-development";
var $b5d90afdcdd0fff3$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $b5d90afdcdd0fff3$var$packageName,
    packageVersion: $b5d90afdcdd0fff3$var$packageVersion
};
var $b5d90afdcdd0fff3$var$baseStyles = null;
var $b5d90afdcdd0fff3$var$shouldAllowClickThroughStyles = null;
var $b5d90afdcdd0fff3$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $b5d90afdcdd0fff3$var$Blanket = /*#__PURE__*/ (0, $dNMDr.memo)(/*#__PURE__*/ (0, $dNMDr.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $c3KQG.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $dNMDr.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $02D9g.usePlatformLeafEventHandler)($b5d90afdcdd0fff3$var$_objectSpread({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $b5d90afdcdd0fff3$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $dNMDr.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $dNMDr.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $dNMDr.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $affTb.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $9vljA.default)("var(--ds-blanket, ".concat((0, $2Mjap.N100A), ")"))
        }
    }, children);
}));
$b5d90afdcdd0fff3$var$Blanket.displayName = 'Blanket';
var $b5d90afdcdd0fff3$export$2e2bcd8739ae039 = $b5d90afdcdd0fff3$var$Blanket;

});





parcelRegister("4umpV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2920e5e0225f37a$export$2e2bcd8739ae039; });

var $pCpQH = parcelRequire("pCpQH");

var $bvi9r = parcelRequire("bvi9r");

var $hZQpa = parcelRequire("hZQpa");

var $4M4Zx = parcelRequire("4M4Zx");
const $f2920e5e0225f37a$export$a882740fcd1752cc = (0, $4M4Zx.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($pCpQH))), (0, (/*@__PURE__*/$parcel$interopDefault($bvi9r))));
const $f2920e5e0225f37a$var$CompassCobranding = {
    background: $f2920e5e0225f37a$export$a882740fcd1752cc,
    logo: {
        component: (0, $hZQpa.CompassLogo)
    },
    footerProducts: 'Trello, Jira, Confluence'
};
var $f2920e5e0225f37a$export$2e2bcd8739ae039 = $f2920e5e0225f37a$var$CompassCobranding;

});

parcelRegister("kvSD4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50303ff5a4521a45$export$2e2bcd8739ae039; });

var $hZQpa = parcelRequire("hZQpa");

var $hM3sg = parcelRequire("hM3sg");
const $50303ff5a4521a45$var$ConfluenceCobranding = {
    background: (0, $hM3sg.ConfluenceBackground),
    logo: {
        component: (0, $hZQpa.ConfluenceLogo)
    },
    footerProducts: 'Confluence, Jira, Trello'
};
var $50303ff5a4521a45$export$2e2bcd8739ae039 = $50303ff5a4521a45$var$ConfluenceCobranding;

});
parcelRegister("hM3sg", function(module, exports) {

$parcel$export(module.exports, "ConfluenceBackground", function () { return $cf09996f704ef457$export$b0d291b61d581ffd; });

var $dNMDr = parcelRequire("dNMDr");

var $3J65S = parcelRequire("3J65S");

var $gZDhs = parcelRequire("gZDhs");

var $2Qcf1 = parcelRequire("2Qcf1");

var $1qxnH = parcelRequire("1qxnH");
var $cf09996f704ef457$export$b0d291b61d581ffd = function ConfluenceBackground(_ref) {
    var children = _ref.children;
    var isDarkMode = (0, $3J65S.default)().colorMode === 'dark';
    var Background = isDarkMode ? (0, $gZDhs.ConfluenceDarkTheme) : (0, $2Qcf1.ConfluenceLightTheme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1qxnH.DesktopOnlyBackground), {
        background: Background
    }, children);
};

});
parcelRegister("gZDhs", function(module, exports) {

$parcel$export(module.exports, "ConfluenceDarkTheme", function () { return $c5f0d02b4f430530$export$42b780ab52e6a23f; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $eS3uG = parcelRequire("eS3uG");
var $3FKQn = parcelRequire("3FKQn");

var $iRKFZ = parcelRequire("iRKFZ");

var $eg0Tg = parcelRequire("eg0Tg");

var $dyM3I = parcelRequire("dyM3I");

var $kJtAq = parcelRequire("kJtAq");

var $2uSGw = parcelRequire("2uSGw");

var $6blbH = parcelRequire("6blbH");

var $gXX5Z = parcelRequire("gXX5Z");

var $1gi7k = parcelRequire("1gi7k");
var $c5f0d02b4f430530$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
var $c5f0d02b4f430530$export$42b780ab52e6a23f = function ConfluenceDarkTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eg0Tg.Background), {
        testId: "testId-confluence-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dyM3I.TopNav), {
        product: (0, $iRKFZ.Products).CONFLUENCE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1gi7k.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3FKQn.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $c5f0d02b4f430530$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $2uSGw.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $kJtAq.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $6blbH.Content), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $gXX5Z.FloatingActions), null));
};

});
parcelRegister("kJtAq", function(module, exports) {

$parcel$export(module.exports, "Actions", function () { return $f17ef5dacde2e793$export$b52183d5cfb26dc9; });

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $f17ef5dacde2e793$export$b52183d5cfb26dc9 = function Actions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($f17ef5dacde2e793$var$Illustration, null));
};
var $f17ef5dacde2e793$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: 331,
        height: 32,
        viewBox: "0 0 331 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#clip0_211_10675)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5858 8.85361C12.3668 8.07256 13.6332 8.07256 14.4142 8.85361L15.1464 9.58584C15.9275 10.3669 15.9275 11.6332 15.1464 12.4143L10.0094 17.5513C9.76903 17.7917 9.47141 17.9668 9.1446 18.0602L5.95604 18.9712C5.69415 19.046 5.41227 18.973 5.21967 18.7804C5.02707 18.5878 4.95403 18.3059 5.02886 18.044L5.93987 14.8555C6.03325 14.5286 6.20837 14.231 6.44871 13.9907L11.5858 8.85361ZM13.3536 9.91427C13.1583 9.71901 12.8417 9.71901 12.6464 9.91427L12.0607 10.5001L13.5 11.9394L14.0858 11.3536C14.281 11.1583 14.281 10.8418 14.0858 10.6465L13.3536 9.91427ZM12.4393 13.0001L11 11.5607L7.50937 15.0513C7.44928 15.1114 7.4055 15.1858 7.38216 15.2675L6.84202 17.158L8.73251 16.6179C8.81422 16.5946 8.88862 16.5508 8.94871 16.4907L12.4393 13.0001ZM3 10.5012C2.72386 10.5012 2.5 10.725 2.5 11.0012V21.0012C2.5 21.2773 2.72386 21.5012 3 21.5012H13C13.2761 21.5012 13.5 21.2773 13.5 21.0012V18.0001H15V21.0012C15 22.1057 14.1046 23.0012 13 23.0012H3C1.89543 23.0012 1 22.1057 1 21.0012V11.0012C1 9.89659 1.89543 9.00115 3 9.00115H6V10.5012H3Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 13,
        width: 40,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 131,
        y: 3,
        width: 26,
        height: 26,
        rx: 13,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 131,
        y: 3,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#454F59",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M140.566 21V19.9746L143.848 16.5225C144.281 16.0667 144.618 15.693 144.859 15.4014C145.105 15.1051 145.276 14.8408 145.372 14.6084C145.472 14.3714 145.522 14.1208 145.522 13.8564V13.8359C145.522 13.5124 145.452 13.2253 145.311 12.9746C145.169 12.7194 144.969 12.5189 144.709 12.373C144.449 12.2227 144.137 12.1475 143.772 12.1475C143.403 12.1475 143.08 12.2249 142.802 12.3799C142.524 12.5303 142.307 12.7422 142.152 13.0156C141.997 13.2845 141.92 13.6012 141.92 13.9658L141.913 13.9863L140.491 13.9795L140.478 13.9658C140.482 13.3643 140.628 12.8333 140.915 12.373C141.202 11.9128 141.599 11.5527 142.104 11.293C142.615 11.0286 143.201 10.8965 143.861 10.8965C144.467 10.8965 145.01 11.0173 145.488 11.2588C145.971 11.4958 146.35 11.8262 146.623 12.25C146.901 12.6693 147.04 13.1501 147.04 13.6924V13.7129C147.04 14.082 146.972 14.4421 146.835 14.793C146.698 15.1439 146.464 15.529 146.131 15.9482C145.798 16.3675 145.331 16.8757 144.729 17.4727L142.241 19.9678L142.631 19.2842V19.9678L142.241 19.708H147.197V21H140.566Z",
        fill: "#738496"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 122,
        cy: 16,
        r: 13,
        fill: "url(#pattern0_211_10675)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 100,
        cy: 16,
        r: 13,
        fill: "url(#pattern1_211_10675)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("mask", {
        id: "path-7-inside-1_211_10675",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M176 4C176 1.79086 177.791 0 180 0H262V32H180C177.791 32 176 30.2091 176 28V4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M175 4C175 1.23858 177.239 -1 180 -1H262V1H180C178.343 1 177 2.34315 177 4H175ZM262 33H180C177.239 33 175 30.7614 175 28H177C177 29.6569 178.343 31 180 31H262V33ZM180 33C177.239 33 175 30.7614 175 28V4C175 1.23858 177.239 -1 180 -1V1C178.343 1 177 2.34315 177 4V28C177 29.6569 178.343 31 180 31V33ZM262 0V32V0Z",
        fill: "#A1BDD9",
        fillOpacity: 0.08,
        mask: "url(#path-7-inside-1_211_10675)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M196 9.5C194.619 9.5 193.5 10.6193 193.5 12V15H200C201.105 15 202 15.8954 202 17V22C202 23.1046 201.105 24 200 24H192C190.895 24 190 23.1046 190 22V17C190 15.8954 190.895 15 192 15V12C192 9.79086 193.791 8 196 8C198.209 8 200 9.79086 200 12H198.5C198.5 10.6193 197.381 9.5 196 9.5ZM192 16.5C191.724 16.5 191.5 16.7239 191.5 17V22C191.5 22.2761 191.724 22.5 192 22.5H200C200.276 22.5 200.5 22.2761 200.5 22V17C200.5 16.7239 200.276 16.5 200 16.5H192Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 210,
        y: 13,
        width: 40,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M262 32V0H263V32H262Z",
        fill: "#A1BDD9",
        fillOpacity: 0.08
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("mask", {
        id: "path-12-inside-2_211_10675",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M263 0H291C293.209 0 295 1.79086 295 4V28C295 30.2091 293.209 32 291 32H263V0Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M263 -1H291C293.761 -1 296 1.23858 296 4H294C294 2.34315 292.657 1 291 1H263V-1ZM296 28C296 30.7614 293.761 33 291 33H263V31H291C292.657 31 294 29.6569 294 28H296ZM263 32V0V32ZM291 -1C293.761 -1 296 1.23858 296 4V28C296 30.7614 293.761 33 291 33V31C292.657 31 294 29.6569 294 28V4C294 2.34315 292.657 1 291 1V-1Z",
        fill: "#A1BDD9",
        fillOpacity: 0.08,
        mask: "url(#path-12-inside-2_211_10675)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M278.22 10.2198C279.756 8.68423 282.245 8.68423 283.781 10.2198C285.316 11.7553 285.316 14.2449 283.781 15.7804L281.531 18.0304L280.47 16.9698L282.72 14.7198C283.67 13.77 283.67 12.2302 282.72 11.2804C281.77 10.3307 280.23 10.3307 279.281 11.2804L277.031 13.5304L275.97 12.4698L278.22 10.2198ZM281.281 13.7804L275.781 19.2804L274.72 18.2198L280.22 12.7198L281.281 13.7804ZM272.22 16.2198L274.47 13.9698L275.531 15.0304L273.281 17.2804C272.331 18.2302 272.331 19.77 273.281 20.7198C274.23 21.6695 275.77 21.6695 276.72 20.7198L278.97 18.4698L280.031 19.5304L277.781 21.7804C276.245 23.316 273.756 23.316 272.22 21.7804C270.684 20.2449 270.684 17.7553 272.22 16.2198Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 299,
        width: 32,
        height: 32,
        rx: 3,
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M307 16C307 15.1716 307.672 14.5 308.5 14.5C309.328 14.5 310 15.1716 310 16C310 16.8284 309.328 17.5 308.5 17.5C307.672 17.5 307 16.8284 307 16ZM313.5 16C313.5 15.1716 314.172 14.5 315 14.5C315.828 14.5 316.5 15.1716 316.5 16C316.5 16.8284 315.828 17.5 315 17.5C314.172 17.5 313.5 16.8284 313.5 16ZM320 16C320 15.1716 320.672 14.5 321.5 14.5C322.328 14.5 323 15.1716 323 16C323 16.8284 322.328 17.5 321.5 17.5C320.672 17.5 320 16.8284 320 16Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("pattern", {
        id: "pattern0_211_10675",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("use", {
        xlinkHref: "#image0_211_10675",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("pattern", {
        id: "pattern1_211_10675",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("use", {
        xlinkHref: "#image1_211_10675",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "clip0_211_10675"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 331,
        height: 32,
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("image", {
        id: "image0_211_10675",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,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"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("image", {
        id: "image1_211_10675",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,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"
    })));
};

});

parcelRegister("2uSGw", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $1d18cd61c5013f31$export$2dc68d50d56fbbd; });

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $1d18cd61c5013f31$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($1d18cd61c5013f31$var$Illustration, null));
};
var $1d18cd61c5013f31$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 203,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#6B778C",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M195 2a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.381 2.818 1.25 4.662a.748.748 0 0 1-1.148.813L195 14.159l-3.951 2.71a.75.75 0 0 1-1.148-.813l1.25-4.662-3.381-2.818a.749.749 0 0 1 .423-1.324l4.402-.338L194.3 2.48A.75.75 0 0 1 195 2Zm0 2.84-1.345 3.496-3.506.27 2.7 2.25-.973 3.627L195 12.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27L195 4.84Z",
        clipRule: "evenodd"
    }));
};

});

parcelRegister("6blbH", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $48043493c70d8542$export$7c6e2c02157bb7d2; });

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $48043493c70d8542$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($48043493c70d8542$var$Illustration, null));
};
var $48043493c70d8542$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: 762,
        height: 618,
        viewBox: "0 0 762 618",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        width: 503,
        height: 20,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#clip0_211_10701)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 46,
        y: 60,
        width: 192,
        height: 6,
        rx: 3,
        fill: "#454F59"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 46,
        y: 48,
        width: 119,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 18,
        cy: 60,
        r: 17,
        fill: "url(#pattern0_211_10701)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 100,
        width: 760,
        height: 86,
        rx: 5,
        fill: "#1C2B41"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(18 116)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 128C18 121.373 23.3726 116 30 116C36.6274 116 42 121.373 42 128C42 134.627 36.6274 140 30 140C23.3726 140 18 134.627 18 128ZM27.75 126.125H30C30.6213 126.125 31.125 126.629 31.125 127.25V134.75H28.875V128.375H27.75V126.125ZM30 124.25C30.8284 124.25 31.5 123.578 31.5 122.75C31.5 121.922 30.8284 121.25 30 121.25C29.1716 121.25 28.5 121.922 28.5 122.75C28.5 123.578 29.1716 124.25 30 124.25Z",
        fill: "#579DFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 68,
        y: 126,
        width: 659,
        height: 12,
        rx: 3,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 68,
        y: 148,
        width: 325,
        height: 12,
        rx: 3,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 218,
        width: 32,
        height: 32,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 46,
        y: 228,
        width: 143,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M14.7402 278.6C11.2129 278.6 8.97754 276.385 8.97754 272.898V272.885C8.97754 269.508 11.2744 267.19 14.624 267.19C17.8574 267.19 20.1064 269.255 20.1064 272.215V272.229C20.1064 274.45 19.1084 275.865 17.5361 275.865C16.75 275.865 16.1484 275.421 16.0391 274.758L16.0322 274.717H15.9229C15.6289 275.414 15.0137 275.804 14.2139 275.804C12.792 275.804 11.835 274.635 11.835 272.905V272.892C11.835 271.237 12.8125 270.075 14.2139 270.075C14.9316 270.075 15.5469 270.444 15.8135 271.039H15.9229V270.205H16.9551V274.218C16.9551 274.696 17.2354 274.977 17.7275 274.977C18.5889 274.977 19.1426 273.89 19.1426 272.215V272.201C19.1426 269.74 17.2695 268.052 14.5352 268.052C11.8623 268.052 9.94141 270.089 9.94141 272.926V272.939C9.94141 275.852 11.8281 277.731 14.7539 277.731C15.6904 277.731 16.6133 277.602 17.0439 277.403V278.265C16.4287 278.477 15.6016 278.6 14.7402 278.6ZM14.3711 274.84C15.3076 274.84 15.9092 274.095 15.9092 272.933V272.919C15.9092 271.757 15.3145 271.019 14.3848 271.019C13.4688 271.019 12.9287 271.729 12.9287 272.919V272.933C12.9287 274.115 13.4756 274.84 14.3711 274.84Z",
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 23.5,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 108.5,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M121.24 278.6C117.713 278.6 115.478 276.385 115.478 272.898V272.885C115.478 269.508 117.774 267.19 121.124 267.19C124.357 267.19 126.606 269.255 126.606 272.215V272.229C126.606 274.45 125.608 275.865 124.036 275.865C123.25 275.865 122.648 275.421 122.539 274.758L122.532 274.717H122.423C122.129 275.414 121.514 275.804 120.714 275.804C119.292 275.804 118.335 274.635 118.335 272.905V272.892C118.335 271.237 119.312 270.075 120.714 270.075C121.432 270.075 122.047 270.444 122.313 271.039H122.423V270.205H123.455V274.218C123.455 274.696 123.735 274.977 124.228 274.977C125.089 274.977 125.643 273.89 125.643 272.215V272.201C125.643 269.74 123.77 268.052 121.035 268.052C118.362 268.052 116.441 270.089 116.441 272.926V272.939C116.441 275.852 118.328 277.731 121.254 277.731C122.19 277.731 123.113 277.602 123.544 277.403V278.265C122.929 278.477 122.102 278.6 121.24 278.6ZM120.871 274.84C121.808 274.84 122.409 274.095 122.409 272.933V272.919C122.409 271.757 121.814 271.019 120.885 271.019C119.969 271.019 119.429 271.729 119.429 272.919V272.933C119.429 274.115 119.976 274.84 120.871 274.84Z",
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 130,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 215,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M227.74 278.6C224.213 278.6 221.978 276.385 221.978 272.898V272.885C221.978 269.508 224.274 267.19 227.624 267.19C230.857 267.19 233.106 269.255 233.106 272.215V272.229C233.106 274.45 232.108 275.865 230.536 275.865C229.75 275.865 229.148 275.421 229.039 274.758L229.032 274.717H228.923C228.629 275.414 228.014 275.804 227.214 275.804C225.792 275.804 224.835 274.635 224.835 272.905V272.892C224.835 271.237 225.812 270.075 227.214 270.075C227.932 270.075 228.547 270.444 228.813 271.039H228.923V270.205H229.955V274.218C229.955 274.696 230.235 274.977 230.728 274.977C231.589 274.977 232.143 273.89 232.143 272.215V272.201C232.143 269.74 230.27 268.052 227.535 268.052C224.862 268.052 222.941 270.089 222.941 272.926V272.939C222.941 275.852 224.828 277.731 227.754 277.731C228.69 277.731 229.613 277.602 230.044 277.403V278.265C229.429 278.477 228.602 278.6 227.74 278.6ZM227.371 274.84C228.308 274.84 228.909 274.095 228.909 272.933V272.919C228.909 271.757 228.314 271.019 227.385 271.019C226.469 271.019 225.929 271.729 225.929 272.919V272.933C225.929 274.115 226.476 274.84 227.371 274.84Z",
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 236.5,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 314,
        width: 290,
        height: 20,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 350,
        width: 730,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 378,
        width: 730,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 406,
        width: 343,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 444H28C29.1046 444 30 444.895 30 446V454C30 455.105 29.1046 456 28 456H20C18.8954 456 18 455.105 18 454V446C18 444.895 18.8954 444 20 444ZM21.3824 449.069C21.5044 449.121 21.6148 449.198 21.707 449.293L23 450.586L26.293 447.293C26.3852 447.198 26.4956 447.121 26.6176 447.069C26.7396 447.017 26.8708 446.989 27.0036 446.988C27.1364 446.987 27.2681 447.012 27.391 447.062C27.5139 447.112 27.6255 447.187 27.7194 447.281C27.8133 447.375 27.8875 447.486 27.9378 447.609C27.9881 447.732 28.0134 447.864 28.0123 447.996C28.0111 448.129 27.9835 448.26 27.9311 448.382C27.8787 448.504 27.8025 448.615 27.707 448.707L23.707 452.707C23.5195 452.894 23.2652 453 23 453C22.7348 453 22.4805 452.894 22.293 452.707L20.293 450.707C20.1975 450.615 20.1213 450.504 20.0689 450.382C20.0165 450.26 19.9889 450.129 19.9878 449.996C19.9866 449.864 20.0119 449.732 20.0622 449.609C20.1125 449.486 20.1867 449.375 20.2806 449.281C20.3745 449.187 20.4862 449.112 20.609 449.062C20.7319 449.012 20.8636 448.987 20.9964 448.988C21.1292 448.989 21.2604 449.017 21.3824 449.069Z",
        fill: "#579DFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 38,
        y: 447,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 18,
        y: 476,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 38,
        y: 479,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 18,
        y: 508,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 38,
        y: 511,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 18,
        y: 540,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 38,
        y: 543,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 578,
        width: 730,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 606,
        width: 522,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("pattern", {
        id: "pattern0_211_10701",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("use", {
        xlinkHref: "#image0_211_10701",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "clip0_211_10701"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 192,
        height: 6,
        fill: "white",
        transform: "translate(46 60)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("image", {
        id: "image0_211_10701",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,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"
    })));
};

});

parcelRegister("gXX5Z", function(module, exports) {

$parcel$export(module.exports, "FloatingActions", function () { return $c59fff3612cdcc88$export$babdd492df2e202d; });
/* floating-actions.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $c59fff3612cdcc88$var$styles = {
    wrapper: "_kqsw1n9t _94n512x7 _1xi212x7"
};
var $c59fff3612cdcc88$export$babdd492df2e202d = function FloatingActions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $c59fff3612cdcc88$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($c59fff3612cdcc88$var$Illustration, null));
};
var $c59fff3612cdcc88$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: 63,
        height: 339,
        viewBox: "0 0 63 339",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        filter: "url(#filter0_dd_211_10747)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M8 80C8 66.7452 18.7452 56 32 56C45.2548 56 56 66.7452 56 80V253C56 266.255 45.2548 277 32 277C18.7452 277 8 266.255 8 253V80Z",
        fill: "#22272B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 75.125C24 73.6753 25.1753 72.5 26.625 72.5H37.375C38.8247 72.5 40 73.6753 40 75.125V83.375C40 84.8247 38.8247 86 37.375 86H28.4492L25.1221 87.9012C24.89 88.0338 24.6048 88.0329 24.3736 87.8987C24.1423 87.7645 24 87.5174 24 87.25V75.125ZM26.625 74C26.0037 74 25.5 74.5037 25.5 75.125V85.9576L28.0508 84.5H37.375C37.9963 84.5 38.5 83.9963 38.5 83.375V75.125C38.5 74.5037 37.9963 74 37.375 74H26.625ZM36.0002 78.4998H28.0002V76.9998H36.0002V78.4998ZM33.0002 81.4998H28.0002V79.9998H33.0002V81.4998Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 41,
        cy: 72,
        r: 5,
        fill: "#0055CC",
        stroke: "#1D2125",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39 115.5L25 115.5L25 114L39 114L39 115.5ZM39 120.75L25 120.75L25 119.25L39 119.25L39 120.75ZM32 126L25 126L25 124.5L32 124.5L32 126Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 20,
        y: 146,
        width: 24,
        height: 1,
        fill: "#0B1228",
        fillOpacity: 0.14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26 168.5C25.7239 168.5 25.5 168.724 25.5 169V177C25.5 177.276 25.7239 177.5 26 177.5H34C34.2761 177.5 34.5 177.276 34.5 177V169C34.5 168.724 34.2761 168.5 34 168.5H26ZM24 169C24 167.895 24.8954 167 26 167H34C35.1046 167 36 167.895 36 169V169.786L38.191 168.691C39.0221 168.275 40 168.88 40 169.809V176.191C40 177.12 39.0221 177.725 38.191 177.309L36 176.214V177C36 178.105 35.1046 179 34 179H26C24.8954 179 24 178.105 24 177V169ZM36 174.536L38.5 175.786V170.214L36 171.464V174.536Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.3774 205.102C34.6716 205.273 34.8136 205.621 34.723 205.949L32.9849 212.25H37.25C37.5534 212.25 37.8268 212.433 37.9429 212.713C38.059 212.993 37.9949 213.316 37.7804 213.53L30.5304 220.78C30.2896 221.021 29.9169 221.069 29.6226 220.898C29.3284 220.727 29.1865 220.379 29.277 220.051L31.0151 213.75H26.75C26.4467 213.75 26.1732 213.567 26.0571 213.287C25.941 213.007 26.0052 212.684 26.2197 212.47L33.4697 205.22C33.7104 204.979 34.0832 204.931 34.3774 205.102ZM31.4289 212.25L32.5216 208.289L28.5607 212.25H31.4289ZM32.5711 213.75L31.4785 217.711L35.4394 213.75H32.5711Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 248C25 246.895 25.8954 246 27 246H29C30.1046 246 31 246.895 31 248V250C31 251.105 30.1046 252 29 252H27C25.8954 252 25 251.105 25 250V248ZM27 247.5C26.7239 247.5 26.5 247.724 26.5 248V250C26.5 250.276 26.7239 250.5 27 250.5H29C29.2761 250.5 29.5 250.276 29.5 250V248C29.5 247.724 29.2761 247.5 29 247.5H27ZM33 248C33 246.895 33.8954 246 35 246H37C38.1046 246 39 246.895 39 248V250C39 251.105 38.1046 252 37 252H35C33.8954 252 33 251.105 33 250V248ZM35 247.5C34.7239 247.5 34.5 247.724 34.5 248V250C34.5 250.276 34.7239 250.5 35 250.5H37C37.2761 250.5 37.5 250.276 37.5 250V248C37.5 247.724 37.2761 247.5 37 247.5H35ZM25 256C25 254.895 25.8954 254 27 254H29C30.1046 254 31 254.895 31 256V258C31 259.105 30.1046 260 29 260H27C25.8954 260 25 259.105 25 258V256ZM27 255.5C26.7239 255.5 26.5 255.724 26.5 256V258C26.5 258.276 26.7239 258.5 27 258.5H29C29.2761 258.5 29.5 258.276 29.5 258V256C29.5 255.724 29.2761 255.5 29 255.5H27ZM35.25 256.25V254H36.75V256.25H39V257.75H36.75V260H35.25V257.75H33V256.25H35.25Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        filter: "url(#filter1_dd_211_10747)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 8,
        y: 285,
        width: 48,
        height: 48,
        rx: 24,
        fill: "#22272B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.25 305V302H32.75V305H31.25ZM29.4697 307.53L25.4697 303.53L26.5303 302.47L30.5303 306.47L29.4697 307.53ZM33.4697 306.47L37.4697 302.47L38.5303 303.53L34.5303 307.53L33.4697 306.47ZM25 308.25H28V309.75H25V308.25ZM36 308.25H39V309.75H36V308.25ZM25.4697 314.47L29.4697 310.47L30.5303 311.53L26.5303 315.53L25.4697 314.47ZM37.4697 315.53L33.4697 311.53L34.5303 310.47L38.5303 314.47L37.4697 315.53ZM31.25 316V313H32.75V316H31.25Z",
        fill: "#738496"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("filter", {
        id: "filter0_dd_211_10747",
        x: 7,
        y: 55,
        width: 50,
        height: 224,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0117647 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_211_10747"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0117647 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_211_10747",
        result: "effect2_dropShadow_211_10747"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_211_10747",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("filter", {
        id: "filter1_dd_211_10747",
        x: 7,
        y: 284,
        width: 50,
        height: 51,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0117647 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_211_10747"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0117647 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_211_10747",
        result: "effect2_dropShadow_211_10747"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_211_10747",
        result: "shape"
    }))));
};

});

parcelRegister("1gi7k", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $0eb556c6322b1bb2$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");

var $h9WhW = parcelRequire("h9WhW");
var $0eb556c6322b1bb2$var$styles = {
    background: "_1s7zia51 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $0eb556c6322b1bb2$export$1a35787d6353cf6a = function SideNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9WhW.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $0eb556c6322b1bb2$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($0eb556c6322b1bb2$var$Illustration, null)));
};
var $0eb556c6322b1bb2$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 308,
        height: 705,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 177.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 181,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 189.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m7.94 236.5-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 24,
        y: 232.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 263.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M9.667 279.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 279a1.667 1.667 0 1 1 3.333 0A1.667 1.667 0 0 1 8 279Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 279a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 279A1.667 1.667 0 1 1 24 279a1.667 1.667 0 0 1-3.333 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M10 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 279a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 275.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("mask", {
        id: "a",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M0 301h308v404H0V301Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#A1BDD9",
        fillOpacity: 0.08,
        d: "M0 302h308v-2H0v2Z",
        mask: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 306.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 310,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 318.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 361.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 365,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 373.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 404.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 408.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 416.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M265.25 421.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 420.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M285.5 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 270,
        height: 32,
        x: 13,
        y: 450,
        fill: "#22272B",
        stroke: "#A1BDD9",
        strokeOpacity: 0.08,
        strokeWidth: 1.5,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M34 465a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.523 4.891a6 6 0 1 1 1.414-1.414l2.816 2.816a1 1 0 1 1-1.414 1.414l-2.816-2.816ZM27.94 511.5l-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 507.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m22.03 552.47 3.97 3.969 3.97-3.969 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5 1.06-1.06Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 550.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 279,
        height: 43,
        x: 17,
        y: 576,
        fill: "#1C2B41",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 37,
        cy: 597.5,
        r: 2,
        fill: "#05C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 61,
        y: 593.5,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#1868DB",
        d: "M17 589h2.66v15.96H17z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 36,
        cy: 640.5,
        r: 2,
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 60,
        y: 636.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 36,
        cy: 683.5,
        r: 2,
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 60,
        y: 679.5,
        fill: "#454F59",
        rx: 3.99
    }));
};

});


parcelRegister("2Qcf1", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLightTheme", function () { return $2119eef7871b9460$export$d4cbd1e5e91e64ff; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $eS3uG = parcelRequire("eS3uG");
var $3FKQn = parcelRequire("3FKQn");

var $iRKFZ = parcelRequire("iRKFZ");

var $eg0Tg = parcelRequire("eg0Tg");

var $dyM3I = parcelRequire("dyM3I");

var $bv8mD = parcelRequire("bv8mD");

var $9nv8a = parcelRequire("9nv8a");

var $aNxZV = parcelRequire("aNxZV");

var $eu48o = parcelRequire("eu48o");

var $1Rj5e = parcelRequire("1Rj5e");
var $2119eef7871b9460$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
var $2119eef7871b9460$export$d4cbd1e5e91e64ff = function ConfluenceLightTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eg0Tg.Background), {
        testId: "testId-confluence-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dyM3I.TopNav), {
        product: (0, $iRKFZ.Products).CONFLUENCE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1Rj5e.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3FKQn.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $2119eef7871b9460$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $9nv8a.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $bv8mD.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $aNxZV.Content), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eu48o.FloatingActions), null));
};

});
parcelRegister("bv8mD", function(module, exports) {

$parcel$export(module.exports, "Actions", function () { return $85f913e0e37754fe$export$b52183d5cfb26dc9; });

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $85f913e0e37754fe$export$b52183d5cfb26dc9 = function Actions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($85f913e0e37754fe$var$Illustration, null));
};
var $85f913e0e37754fe$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: 331,
        height: 32,
        viewBox: "0 0 331 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5858 8.85361C12.3668 8.07256 13.6332 8.07256 14.4142 8.85361L15.1464 9.58584C15.9275 10.3669 15.9275 11.6332 15.1464 12.4143L10.0094 17.5513C9.76903 17.7917 9.47141 17.9668 9.1446 18.0602L5.95604 18.9712C5.69415 19.046 5.41227 18.973 5.21967 18.7804C5.02707 18.5878 4.95403 18.3059 5.02886 18.044L5.93987 14.8555C6.03325 14.5286 6.20837 14.231 6.44871 13.9907L11.5858 8.85361ZM13.3536 9.91427C13.1583 9.71901 12.8417 9.71901 12.6464 9.91427L12.0607 10.5001L13.5 11.9394L14.0858 11.3536C14.281 11.1583 14.281 10.8418 14.0858 10.6465L13.3536 9.91427ZM12.4393 13.0001L11 11.5607L7.50937 15.0513C7.44928 15.1114 7.4055 15.1858 7.38216 15.2675L6.84202 17.158L8.73251 16.6179C8.81422 16.5946 8.88862 16.5508 8.94871 16.4907L12.4393 13.0001ZM3 10.5012C2.72386 10.5012 2.5 10.725 2.5 11.0012V21.0012C2.5 21.2773 2.72386 21.5012 3 21.5012H13C13.2761 21.5012 13.5 21.2773 13.5 21.0012V18.0001H15V21.0012C15 22.1057 14.1046 23.0012 13 23.0012H3C1.89543 23.0012 1 22.1057 1 21.0012V11.0012C1 9.89659 1.89543 9.00115 3 9.00115H6V10.5012H3Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 13,
        width: 40,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 131,
        y: 3,
        width: 26,
        height: 26,
        rx: 13,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 131,
        y: 3,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#DCDFE4",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M140.566 21V19.9746L143.848 16.5225C144.281 16.0667 144.618 15.693 144.859 15.4014C145.105 15.1051 145.276 14.8408 145.372 14.6084C145.472 14.3714 145.522 14.1208 145.522 13.8564V13.8359C145.522 13.5124 145.452 13.2253 145.311 12.9746C145.169 12.7194 144.969 12.5189 144.709 12.373C144.449 12.2227 144.137 12.1475 143.772 12.1475C143.403 12.1475 143.08 12.2249 142.802 12.3799C142.524 12.5303 142.307 12.7422 142.152 13.0156C141.997 13.2845 141.92 13.6012 141.92 13.9658L141.913 13.9863L140.491 13.9795L140.478 13.9658C140.482 13.3643 140.628 12.8333 140.915 12.373C141.202 11.9128 141.599 11.5527 142.104 11.293C142.615 11.0286 143.201 10.8965 143.861 10.8965C144.467 10.8965 145.01 11.0173 145.488 11.2588C145.971 11.4958 146.35 11.8262 146.623 12.25C146.901 12.6693 147.04 13.1501 147.04 13.6924V13.7129C147.04 14.082 146.972 14.4421 146.835 14.793C146.698 15.1439 146.464 15.529 146.131 15.9482C145.798 16.3675 145.331 16.8757 144.729 17.4727L142.241 19.9678L142.631 19.2842V19.9678L142.241 19.708H147.197V21H140.566Z",
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 122,
        cy: 16,
        r: 13,
        fill: "url(#pattern0_211_9747)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 100,
        cy: 16,
        r: 13,
        fill: "url(#pattern1_211_9747)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("mask", {
        id: "path-7-inside-1_211_9747",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M176 4C176 1.79086 177.791 0 180 0H262V32H180C177.791 32 176 30.2091 176 28V4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M175 4C175 1.23858 177.239 -1 180 -1H262V1H180C178.343 1 177 2.34315 177 4H175ZM262 33H180C177.239 33 175 30.7614 175 28H177C177 29.6569 178.343 31 180 31H262V33ZM180 33C177.239 33 175 30.7614 175 28V4C175 1.23858 177.239 -1 180 -1V1C178.343 1 177 2.34315 177 4V28C177 29.6569 178.343 31 180 31V33ZM262 0V32V0Z",
        fill: "#091E42",
        fillOpacity: 0.06,
        mask: "url(#path-7-inside-1_211_9747)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M196 9.5C194.619 9.5 193.5 10.6193 193.5 12V15H200C201.105 15 202 15.8954 202 17V22C202 23.1046 201.105 24 200 24H192C190.895 24 190 23.1046 190 22V17C190 15.8954 190.895 15 192 15V12C192 9.79086 193.791 8 196 8C198.209 8 200 9.79086 200 12H198.5C198.5 10.6193 197.381 9.5 196 9.5ZM192 16.5C191.724 16.5 191.5 16.7239 191.5 17V22C191.5 22.2761 191.724 22.5 192 22.5H200C200.276 22.5 200.5 22.2761 200.5 22V17C200.5 16.7239 200.276 16.5 200 16.5H192Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 210,
        y: 13,
        width: 40,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M262 32V0H263V32H262Z",
        fill: "#091E42",
        fillOpacity: 0.06
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("mask", {
        id: "path-12-inside-2_211_9747",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M263 0H291C293.209 0 295 1.79086 295 4V28C295 30.2091 293.209 32 291 32H263V0Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M263 -1H291C293.761 -1 296 1.23858 296 4H294C294 2.34315 292.657 1 291 1H263V-1ZM296 28C296 30.7614 293.761 33 291 33H263V31H291C292.657 31 294 29.6569 294 28H296ZM263 32V0V32ZM291 -1C293.761 -1 296 1.23858 296 4V28C296 30.7614 293.761 33 291 33V31C292.657 31 294 29.6569 294 28V4C294 2.34315 292.657 1 291 1V-1Z",
        fill: "#091E42",
        fillOpacity: 0.06,
        mask: "url(#path-12-inside-2_211_9747)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M278.22 10.2196C279.756 8.68411 282.245 8.68411 283.781 10.2196C285.316 11.7552 285.316 14.2448 283.781 15.7803L281.531 18.0303L280.47 16.9696L282.72 14.7196C283.67 13.7699 283.67 12.2301 282.72 11.2803C281.77 10.3306 280.23 10.3306 279.281 11.2803L277.031 13.5303L275.97 12.4696L278.22 10.2196ZM281.281 13.7803L275.781 19.2803L274.72 18.2196L280.22 12.7196L281.281 13.7803ZM272.22 16.2196L274.47 13.9696L275.531 15.0303L273.281 17.2803C272.331 18.2301 272.331 19.7699 273.281 20.7196C274.23 21.6694 275.77 21.6694 276.72 20.7196L278.97 18.4696L280.031 19.5303L277.781 21.7803C276.245 23.3158 273.756 23.3158 272.22 21.7803C270.684 20.2448 270.684 17.7552 272.22 16.2196Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 299,
        width: 32,
        height: 32,
        rx: 3,
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M307 16C307 15.1716 307.672 14.5 308.5 14.5C309.328 14.5 310 15.1716 310 16C310 16.8284 309.328 17.5 308.5 17.5C307.672 17.5 307 16.8284 307 16ZM313.5 16C313.5 15.1716 314.172 14.5 315 14.5C315.828 14.5 316.5 15.1716 316.5 16C316.5 16.8284 315.828 17.5 315 17.5C314.172 17.5 313.5 16.8284 313.5 16ZM320 16C320 15.1716 320.672 14.5 321.5 14.5C322.328 14.5 323 15.1716 323 16C323 16.8284 322.328 17.5 321.5 17.5C320.672 17.5 320 16.8284 320 16Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("pattern", {
        id: "pattern0_211_9747",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("use", {
        xlinkHref: "#image0_211_9747",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("pattern", {
        id: "pattern1_211_9747",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("use", {
        xlinkHref: "#image1_211_9747",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("image", {
        id: "image0_211_9747",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("image", {
        id: "image1_211_9747",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABQACBAYHAwj/xAAtEAABAwMDAwIEBwAAAAAAAAABAgMEAAURBhIhMUFRBxNhgaHBFDJCcZGx8P/EABcBAAMBAAAAAAAAAAAAAAAAAAQGBwX/xAAtEQABBAECAwQLAAAAAAAAAAABAAIDEQQhMQYSEyJBsfEFFBUyQlFxkcHh8P/aAAwDAQACEQMRAD8AKUqVBNX3ZdotBdYwJDqvbbJ/SepPyFOz3BjS4qIY8D8iVsUe5NIrIlx42PxL7LOenuLCf7pzD7UhG5h1t1PlCgofSsQeccfdU68tTjijkqWck/OnRJL8N9L0V1bLieikHFAev6+7om48JdjSXtfTTxW40qr+kL+LzFUh8JTMZA3gcBQ7KH3FWCj2PD28zUpZONJiymGUUQlUaLbGr9rTT1tcYVIQ28qVITtylLQSRlXwKsCpNV+53u66Q1HGv9rSlxlbQjSW1pylSQrdg+M9j5obP5jA4M3Wtw2I/aMZkNAX962W1r9NtHOOlxWnYG4nJASQP4BxQnWPpdpybpyei1WSNHuKWVKjLjjYr3AMpHXBBPHPmrrYrtDvtoi3K2uh2LIRvQodR5B8EHgjyK63SfFtVukTp7yWYkdBcccV0AH3+FJokkDtzashjjIuhS8h6RiT7Xq2PHmxZEV1aFpU282UHGD2PxFabQCHqSXrbV8y8TghDcVr2IrSRj20KUTz5Vgcmj9OGAHdEF3epDxS9js8tZ8IA/PgUqiXWKJttkxi4Gw6goKyM7Qe+KlEgAk9BzQSVJW+s5JCM8Jot5FUVhwNdzhzTVarTfQ6xOWTTcrE1UiNIkFxoEABOBhXGe5H0ot6sWM37RUuKZKmENqQ+ojHIQckc/7ismtF6uNnWpVuluMbvzJHKVfuDxXW8ahut4QEXCY462DkN8JTnzgcUvu9GPOR1ARV3/eaoUfFEYwui4OMlVem/wA/1SGaa081Z3nHo0115DqdqkqQAD4PHerBQGO+theUHjuOxo4hQWhKk9CMit6INaOVqQs2SWaTqymye/yX/9k="
    })));
};

});

parcelRegister("9nv8a", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $6d3e68f25e96af08$export$2dc68d50d56fbbd; });

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $6d3e68f25e96af08$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($6d3e68f25e96af08$var$Illustration, null));
};
var $6d3e68f25e96af08$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 203,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#6B778C",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M195 2a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.381 2.818 1.25 4.662a.748.748 0 0 1-1.148.813L195 14.159l-3.951 2.71a.75.75 0 0 1-1.148-.813l1.25-4.662-3.381-2.818a.749.749 0 0 1 .423-1.324l4.402-.338L194.3 2.48A.75.75 0 0 1 195 2Zm0 2.84-1.345 3.496-3.506.27 2.7 2.25-.973 3.627L195 12.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27L195 4.84Z",
        clipRule: "evenodd"
    }));
};

});

parcelRegister("aNxZV", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $7dc8da385b00be29$export$7c6e2c02157bb7d2; });

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $7dc8da385b00be29$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($7dc8da385b00be29$var$Illustration, null));
};
var $7dc8da385b00be29$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: 612,
        height: 562,
        viewBox: "0 0 612 562",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        width: 503,
        height: 20,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 40,
        y: 60,
        width: 155,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 40,
        y: 48,
        width: 96,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 18,
        cy: 60,
        r: 17,
        fill: "url(#pattern0_138_18776)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 100,
        width: 605,
        height: 86,
        rx: 5,
        fill: "#E9F2FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(18 116)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 128C18 121.373 23.3726 116 30 116C36.6274 116 42 121.373 42 128C42 134.627 36.6274 140 30 140C23.3726 140 18 134.627 18 128ZM27.75 126.125H30C30.6213 126.125 31.125 126.629 31.125 127.25V134.75H28.875V128.375H27.75V126.125ZM30 124.25C30.8284 124.25 31.5 123.578 31.5 122.75C31.5 121.922 30.8284 121.25 30 121.25C29.1716 121.25 28.5 121.922 28.5 122.75C28.5 123.578 29.1716 124.25 30 124.25Z",
        fill: "#0C66E4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 68,
        y: 126,
        width: 529,
        height: 12,
        rx: 3,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 68,
        y: 148,
        width: 261,
        height: 12,
        rx: 3,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 218,
        width: 32,
        height: 32,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 46,
        y: 228,
        width: 115,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M14.7402 278.6C11.2129 278.6 8.97754 276.385 8.97754 272.898V272.885C8.97754 269.508 11.2744 267.19 14.624 267.19C17.8574 267.19 20.1064 269.255 20.1064 272.215V272.229C20.1064 274.45 19.1084 275.865 17.5361 275.865C16.75 275.865 16.1484 275.421 16.0391 274.758L16.0322 274.717H15.9229C15.6289 275.414 15.0137 275.804 14.2139 275.804C12.792 275.804 11.835 274.635 11.835 272.905V272.892C11.835 271.237 12.8125 270.075 14.2139 270.075C14.9316 270.075 15.5469 270.444 15.8135 271.039H15.9229V270.205H16.9551V274.218C16.9551 274.696 17.2354 274.977 17.7275 274.977C18.5889 274.977 19.1426 273.89 19.1426 272.215V272.201C19.1426 269.74 17.2695 268.052 14.5352 268.052C11.8623 268.052 9.94141 270.089 9.94141 272.926V272.939C9.94141 275.852 11.8281 277.731 14.7539 277.731C15.6904 277.731 16.6133 277.602 17.0439 277.403V278.265C16.4287 278.477 15.6016 278.6 14.7402 278.6ZM14.3711 274.84C15.3076 274.84 15.9092 274.095 15.9092 272.933V272.919C15.9092 271.757 15.3145 271.019 14.3848 271.019C13.4688 271.019 12.9287 271.729 12.9287 272.919V272.933C12.9287 274.115 13.4756 274.84 14.3711 274.84Z",
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 23.5,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 108.5,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M121.24 278.6C117.713 278.6 115.478 276.385 115.478 272.898V272.885C115.478 269.508 117.774 267.19 121.124 267.19C124.357 267.19 126.606 269.255 126.606 272.215V272.229C126.606 274.45 125.608 275.865 124.036 275.865C123.25 275.865 122.648 275.421 122.539 274.758L122.532 274.717H122.423C122.129 275.414 121.514 275.804 120.714 275.804C119.292 275.804 118.335 274.635 118.335 272.905V272.892C118.335 271.237 119.312 270.075 120.714 270.075C121.432 270.075 122.047 270.444 122.313 271.039H122.423V270.205H123.455V274.218C123.455 274.696 123.735 274.977 124.228 274.977C125.089 274.977 125.643 273.89 125.643 272.215V272.201C125.643 269.74 123.77 268.052 121.035 268.052C118.362 268.052 116.441 270.089 116.441 272.926V272.939C116.441 275.852 118.328 277.731 121.254 277.731C122.19 277.731 123.113 277.602 123.544 277.403V278.265C122.929 278.477 122.102 278.6 121.24 278.6ZM120.871 274.84C121.808 274.84 122.409 274.095 122.409 272.933V272.919C122.409 271.757 121.814 271.019 120.885 271.019C119.969 271.019 119.429 271.729 119.429 272.919V272.933C119.429 274.115 119.976 274.84 120.871 274.84Z",
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 130,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 215,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M227.74 278.6C224.213 278.6 221.978 276.385 221.978 272.898V272.885C221.978 269.508 224.274 267.19 227.624 267.19C230.857 267.19 233.106 269.255 233.106 272.215V272.229C233.106 274.45 232.108 275.865 230.536 275.865C229.75 275.865 229.148 275.421 229.039 274.758L229.032 274.717H228.923C228.629 275.414 228.014 275.804 227.214 275.804C225.792 275.804 224.835 274.635 224.835 272.905V272.892C224.835 271.237 225.812 270.075 227.214 270.075C227.932 270.075 228.547 270.444 228.813 271.039H228.923V270.205H229.955V274.218C229.955 274.696 230.235 274.977 230.728 274.977C231.589 274.977 232.143 273.89 232.143 272.215V272.201C232.143 269.74 230.27 268.052 227.535 268.052C224.862 268.052 222.941 270.089 222.941 272.926V272.939C222.941 275.852 224.828 277.731 227.754 277.731C228.69 277.731 229.613 277.602 230.044 277.403V278.265C229.429 278.477 228.602 278.6 227.74 278.6ZM227.371 274.84C228.308 274.84 228.909 274.095 228.909 272.933V272.919C228.909 271.757 228.314 271.019 227.385 271.019C226.469 271.019 225.929 271.729 225.929 272.919V272.933C225.929 274.115 226.476 274.84 227.371 274.84Z",
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 236.5,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 314,
        width: 234,
        height: 20,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 350,
        width: 590,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 378,
        width: 590,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 2,
        y: 406,
        width: 277,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 444H28C29.1046 444 30 444.895 30 446V454C30 455.105 29.1046 456 28 456H20C18.8954 456 18 455.105 18 454V446C18 444.895 18.8954 444 20 444ZM21.3824 449.069C21.5044 449.121 21.6148 449.198 21.707 449.293L23 450.586L26.293 447.293C26.3852 447.198 26.4956 447.121 26.6176 447.069C26.7396 447.017 26.8708 446.989 27.0036 446.988C27.1364 446.987 27.2681 447.012 27.391 447.062C27.5139 447.112 27.6255 447.187 27.7194 447.281C27.8133 447.375 27.8875 447.486 27.9378 447.609C27.9881 447.732 28.0134 447.864 28.0123 447.996C28.0111 448.129 27.9835 448.26 27.9311 448.382C27.8787 448.504 27.8025 448.615 27.707 448.707L23.707 452.707C23.5195 452.894 23.2652 453 23 453C22.7348 453 22.4805 452.894 22.293 452.707L20.293 450.707C20.1975 450.615 20.1213 450.504 20.0689 450.382C20.0165 450.26 19.9889 450.129 19.9878 449.996C19.9866 449.864 20.0119 449.732 20.0622 449.609C20.1125 449.486 20.1867 449.375 20.2806 449.281C20.3745 449.187 20.4862 449.112 20.609 449.062C20.7319 449.012 20.8636 448.987 20.9964 448.988C21.1292 448.989 21.2604 449.017 21.3824 449.069Z",
        fill: "#0C66E4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 38,
        y: 447,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 18,
        y: 476,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 38,
        y: 479,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 18,
        y: 508,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 38,
        y: 511,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 18,
        y: 540,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 38,
        y: 543,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("pattern", {
        id: "pattern0_138_18776",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("use", {
        xlinkHref: "#image0_138_18776",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("image", {
        id: "image0_138_18776",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABQACBAYHAwj/xAAtEAABAwMDAwIEBwAAAAAAAAABAgMEAAURBhIhMUFRBxNhgaHBFDJCcZGx8P/EABcBAAMBAAAAAAAAAAAAAAAAAAQGBwX/xAAtEQABBAECAwQLAAAAAAAAAAABAAIDEQQhMQYSEyJBsfEFFBUyQlFxkcHh8P/aAAwDAQACEQMRAD8AKUqVBNX3ZdotBdYwJDqvbbJ/SepPyFOz3BjS4qIY8D8iVsUe5NIrIlx42PxL7LOenuLCf7pzD7UhG5h1t1PlCgofSsQeccfdU68tTjijkqWck/OnRJL8N9L0V1bLieikHFAev6+7om48JdjSXtfTTxW40qr+kL+LzFUh8JTMZA3gcBQ7KH3FWCj2PD28zUpZONJiymGUUQlUaLbGr9rTT1tcYVIQ28qVITtylLQSRlXwKsCpNV+53u66Q1HGv9rSlxlbQjSW1pylSQrdg+M9j5obP5jA4M3Wtw2I/aMZkNAX962W1r9NtHOOlxWnYG4nJASQP4BxQnWPpdpybpyei1WSNHuKWVKjLjjYr3AMpHXBBPHPmrrYrtDvtoi3K2uh2LIRvQodR5B8EHgjyK63SfFtVukTp7yWYkdBcccV0AH3+FJokkDtzashjjIuhS8h6RiT7Xq2PHmxZEV1aFpU282UHGD2PxFabQCHqSXrbV8y8TghDcVr2IrSRj20KUTz5Vgcmj9OGAHdEF3epDxS9js8tZ8IA/PgUqiXWKJttkxi4Gw6goKyM7Qe+KlEgAk9BzQSVJW+s5JCM8Jot5FUVhwNdzhzTVarTfQ6xOWTTcrE1UiNIkFxoEABOBhXGe5H0ot6sWM37RUuKZKmENqQ+ojHIQckc/7ismtF6uNnWpVuluMbvzJHKVfuDxXW8ahut4QEXCY462DkN8JTnzgcUvu9GPOR1ARV3/eaoUfFEYwui4OMlVem/wA/1SGaa081Z3nHo0115DqdqkqQAD4PHerBQGO+theUHjuOxo4hQWhKk9CMit6INaOVqQs2SWaTqymye/yX/9k="
    })));
};

});

parcelRegister("eu48o", function(module, exports) {

$parcel$export(module.exports, "FloatingActions", function () { return $a8b71304cb1a74d5$export$babdd492df2e202d; });
/* floating-actions.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $a8b71304cb1a74d5$var$styles = {
    wrapper: "_kqsw1n9t _94n512x7 _1xi212x7"
};
var $a8b71304cb1a74d5$export$babdd492df2e202d = function FloatingActions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $a8b71304cb1a74d5$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($a8b71304cb1a74d5$var$Illustration, null));
};
var $a8b71304cb1a74d5$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: 63,
        height: 339,
        viewBox: "0 0 63 339",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        filter: "url(#filter0_dd_211_9818)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M8 80C8 66.7452 18.7452 56 32 56C45.2548 56 56 66.7452 56 80V253C56 266.255 45.2548 277 32 277C18.7452 277 8 266.255 8 253V80Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 75.125C24 73.6753 25.1753 72.5 26.625 72.5H37.375C38.8247 72.5 40 73.6753 40 75.125V83.375C40 84.8247 38.8247 86 37.375 86H28.4492L25.1221 87.9012C24.89 88.0338 24.6048 88.0329 24.3736 87.8987C24.1423 87.7645 24 87.5174 24 87.25V75.125ZM26.625 74C26.0037 74 25.5 74.5037 25.5 75.125V85.9576L28.0508 84.5H37.375C37.9963 84.5 38.5 83.9963 38.5 83.375V75.125C38.5 74.5037 37.9963 74 37.375 74H26.625ZM36.0002 78.4998H28.0002V76.9998H36.0002V78.4998ZM33.0002 81.4998H28.0002V79.9998H33.0002V81.4998Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 41,
        cy: 72,
        r: 5,
        fill: "#85B8FF",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39 115.5L25 115.5L25 114L39 114L39 115.5ZM39 120.75L25 120.75L25 119.25L39 119.25L39 120.75ZM32 126L25 126L25 124.5L32 124.5L32 126Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 20,
        y: 146,
        width: 24,
        height: 1,
        fill: "#0B1228",
        fillOpacity: 0.14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26 168.5C25.7239 168.5 25.5 168.724 25.5 169V177C25.5 177.276 25.7239 177.5 26 177.5H34C34.2761 177.5 34.5 177.276 34.5 177V169C34.5 168.724 34.2761 168.5 34 168.5H26ZM24 169C24 167.895 24.8954 167 26 167H34C35.1046 167 36 167.895 36 169V169.786L38.191 168.691C39.0221 168.275 40 168.88 40 169.809V176.191C40 177.12 39.0221 177.725 38.191 177.309L36 176.214V177C36 178.105 35.1046 179 34 179H26C24.8954 179 24 178.105 24 177V169ZM36 174.536L38.5 175.786V170.214L36 171.464V174.536Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.3774 205.102C34.6716 205.273 34.8136 205.621 34.723 205.949L32.9849 212.25H37.25C37.5534 212.25 37.8268 212.433 37.9429 212.713C38.059 212.993 37.9949 213.316 37.7804 213.53L30.5304 220.78C30.2896 221.021 29.9169 221.069 29.6226 220.898C29.3284 220.727 29.1865 220.379 29.277 220.051L31.0151 213.75H26.75C26.4467 213.75 26.1732 213.567 26.0571 213.287C25.941 213.007 26.0052 212.684 26.2197 212.47L33.4697 205.22C33.7104 204.979 34.0832 204.931 34.3774 205.102ZM31.4289 212.25L32.5216 208.289L28.5607 212.25H31.4289ZM32.5711 213.75L31.4785 217.711L35.4394 213.75H32.5711Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 248C25 246.895 25.8954 246 27 246H29C30.1046 246 31 246.895 31 248V250C31 251.105 30.1046 252 29 252H27C25.8954 252 25 251.105 25 250V248ZM27 247.5C26.7239 247.5 26.5 247.724 26.5 248V250C26.5 250.276 26.7239 250.5 27 250.5H29C29.2761 250.5 29.5 250.276 29.5 250V248C29.5 247.724 29.2761 247.5 29 247.5H27ZM33 248C33 246.895 33.8954 246 35 246H37C38.1046 246 39 246.895 39 248V250C39 251.105 38.1046 252 37 252H35C33.8954 252 33 251.105 33 250V248ZM35 247.5C34.7239 247.5 34.5 247.724 34.5 248V250C34.5 250.276 34.7239 250.5 35 250.5H37C37.2761 250.5 37.5 250.276 37.5 250V248C37.5 247.724 37.2761 247.5 37 247.5H35ZM25 256C25 254.895 25.8954 254 27 254H29C30.1046 254 31 254.895 31 256V258C31 259.105 30.1046 260 29 260H27C25.8954 260 25 259.105 25 258V256ZM27 255.5C26.7239 255.5 26.5 255.724 26.5 256V258C26.5 258.276 26.7239 258.5 27 258.5H29C29.2761 258.5 29.5 258.276 29.5 258V256C29.5 255.724 29.2761 255.5 29 255.5H27ZM35.25 256.25V254H36.75V256.25H39V257.75H36.75V260H35.25V257.75H33V256.25H35.25Z",
        fill: "#091E42",
        fillOpacity: 0.31
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        filter: "url(#filter1_dd_211_9818)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 8,
        y: 285,
        width: 48,
        height: 48,
        rx: 24,
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.25 305V302H32.75V305H31.25ZM29.4697 307.53L25.4697 303.53L26.5303 302.47L30.5303 306.47L29.4697 307.53ZM33.4697 306.47L37.4697 302.47L38.5303 303.53L34.5303 307.53L33.4697 306.47ZM25 308.25H28V309.75H25V308.25ZM36 308.25H39V309.75H36V308.25ZM25.4697 314.47L29.4697 310.47L30.5303 311.53L26.5303 315.53L25.4697 314.47ZM37.4697 315.53L33.4697 311.53L34.5303 310.47L38.5303 314.47L37.4697 315.53ZM31.25 316V313H32.75V316H31.25Z",
        fill: "#8590A2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("filter", {
        id: "filter0_dd_211_9818",
        x: 7,
        y: 55,
        width: 50,
        height: 224,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_211_9818"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_211_9818",
        result: "effect2_dropShadow_211_9818"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_211_9818",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("filter", {
        id: "filter1_dd_211_9818",
        x: 7,
        y: 284,
        width: 50,
        height: 51,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_211_9818"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_211_9818",
        result: "effect2_dropShadow_211_9818"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_211_9818",
        result: "shape"
    }))));
};

});

parcelRegister("1Rj5e", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $15a98b3a7864b7ee$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");

var $h9WhW = parcelRequire("h9WhW");
var $15a98b3a7864b7ee$var$styles = {
    background: "_1s7zia51 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $15a98b3a7864b7ee$export$1a35787d6353cf6a = function SideNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9WhW.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $15a98b3a7864b7ee$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($15a98b3a7864b7ee$var$Illustration, null)));
};
var $15a98b3a7864b7ee$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 308,
        height: 705,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 177.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 181,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 189.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m7.94 236.5-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 24,
        y: 232.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 263.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M9.667 279.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 279a1.667 1.667 0 1 1 3.335 0A1.667 1.667 0 0 1 8 279Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 279a1.667 1.667 0 1 1 3.335 0 1.667 1.667 0 0 1-3.335 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 279A1.667 1.667 0 1 1 24 279a1.667 1.667 0 0 1-3.334 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M10 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 279a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 275.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("mask", {
        id: "a",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M0 301h308v404H0V301Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.06,
        d: "M0 302h308v-2H0v2Z",
        mask: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 306.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 310,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 318.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 361.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 365,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 373.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 404.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 408.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 416.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M265.25 421.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 420.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M285.5 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 270,
        height: 32,
        x: 13,
        y: 450,
        fill: "#fff",
        stroke: "#091E42",
        strokeOpacity: 0.06,
        strokeWidth: 1.5,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M34 465a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.523 4.891a6 6 0 1 1 1.414-1.414l2.816 2.816a1 1 0 1 1-1.414 1.414l-2.816-2.816ZM27.94 511.5l-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 507.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m22.03 552.47 3.97 3.969 3.97-3.969 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5 1.06-1.06Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 550.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 279,
        height: 43,
        x: 17,
        y: 576,
        fill: "#E9F2FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 37,
        cy: 597.5,
        r: 2,
        fill: "#85B8FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 61,
        y: 593.5,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#1868DB",
        d: "M17 589h2.66v15.96H17z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 36,
        cy: 640.5,
        r: 2,
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 60,
        y: 636.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 36,
        cy: 683.5,
        r: 2,
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 60,
        y: 679.5,
        fill: "#DCDFE4",
        rx: 3.99
    }));
};

});




parcelRegister("3CKf4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $405d4dc516e18d1e$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $4M4Zx = parcelRequire("4M4Zx");

var $1pUJ6 = parcelRequire("1pUJ6");

var $723m6 = parcelRequire("723m6");
const $405d4dc516e18d1e$var$logoWrapperStyles = {
    display: 'flex',
    gap: '8px'
};
const $405d4dc516e18d1e$var$CommunityCobranding = {
    background: (0, $4M4Zx.DefaultBackground),
    logo: {
        renderLogo: ()=>/*#__PURE__*/ (0, $6CtE1.jsxs)("span", {
                style: $405d4dc516e18d1e$var$logoWrapperStyles,
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $723m6.AtlassianLogo), {
                        appearance: "brand",
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)("span", {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $1pUJ6.CommunityLogo), {})
                    })
                ]
            })
    },
    footerProducts: 'Community, Jira, Confluence'
};
var $405d4dc516e18d1e$export$2e2bcd8739ae039 = $405d4dc516e18d1e$var$CommunityCobranding;

});
parcelRegister("1pUJ6", function(module, exports) {

$parcel$export(module.exports, "CommunityLogo", function () { return $f799923faf3aca14$export$311e5e9ca09eea69; });
/* CommunityLogo.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable react/no-unknown-property */ 
var $6CtE1 = parcelRequire("6CtE1");

var $grvIM = parcelRequire("grvIM");
parcelRequire("dNMDr");
const $f799923faf3aca14$export$311e5e9ca09eea69 = ()=>/*#__PURE__*/ (0, $6CtE1.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "127",
        height: "24",
        viewBox: "0 0 127 24",
        fill: "none",
        className: (0, $grvIM.default)([
            "_1bsb1osq _4t3i1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)("path", {
                d: "M119.728 17.303H118.315L113.75 5.33594H116.07L120.106 16.2801L124.141 5.33594H126.462L121.695 17.7121C120.282 21.3687 119.475 23.2609 116.272 23.2609C115.188 23.2609 114.582 23.1586 113.952 22.9029V21.0107C114.683 21.2408 115.516 21.3176 116.146 21.3176C117.912 21.3176 118.693 20.0902 119.728 17.303Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("path", {
                d: "M109.789 14.1534C109.789 15.2785 110.444 16.0457 111.781 16.0457C112.286 16.0457 112.765 15.9434 113.143 15.8667V17.989C112.765 18.0913 112.336 18.1936 111.68 18.1936C108.981 18.1936 107.67 16.5826 107.67 14.2046V7.37722H105.627V5.33158H107.67V2.62109H109.789V5.33158H113.143V7.37722H109.789V14.1534Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("path", {
                d: "M100.939 1.96002C100.939 0.988335 101.57 0.425781 102.453 0.425781C103.336 0.425781 103.966 0.988335 103.966 1.96002C103.966 2.9317 103.336 3.49425 102.453 3.49425C101.57 3.49425 100.939 2.9317 100.939 1.96002ZM101.343 18.1206V5.33533H103.512V18.1206H101.343Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("path", {
                d: "M98.3189 10.6269V18.1191H96.1498V10.3968C96.1498 8.09545 95.2419 7.07263 93.1737 7.07263C91.1559 7.07263 89.7687 8.42787 89.7687 11.0105V18.1191H87.5996V5.33383H89.7687V7.43062C90.5758 5.92195 92.0639 5.07812 93.7538 5.07812C96.6543 5.07812 98.3189 7.0982 98.3189 10.6269Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("path", {
                d: "M73.6016 12.8281V5.33594H75.7707V13.0583C75.7707 15.3596 76.6786 16.3824 78.7468 16.3824C80.7646 16.3824 82.1518 15.0272 82.1518 12.4446V5.33594H84.3209V18.1212H82.1518V16.0244C81.3447 17.5331 79.8566 18.3769 78.1667 18.3769C75.2662 18.3769 73.6016 16.3569 73.6016 12.8281Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("path", {
                d: "M62.2838 11.0105V18.1191H60.1147V10.3968C60.1147 8.09545 59.2067 7.07263 57.1385 7.07263C55.1207 7.07263 53.7335 8.42787 53.7335 11.0105V18.1191H51.5645V5.33383H53.7335V7.43062C54.5406 5.92195 56.0287 5.07812 57.7186 5.07812C59.8625 5.07812 61.3253 6.17766 61.9559 8.19774C62.6621 6.2288 64.352 5.07812 66.4454 5.07812C69.2703 5.07812 70.834 7.02149 70.834 10.6269V18.1191H68.6649V11.0105C68.6649 8.37673 67.7569 7.07263 65.6887 7.07263C63.671 7.07263 62.2838 8.42787 62.2838 11.0105Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("path", {
                d: "M39.9928 11.0105V18.1191H37.8237V10.3968C37.8237 8.09545 36.9157 7.07263 34.8475 7.07263C32.8297 7.07263 31.4425 8.42787 31.4425 11.0105V18.1191H29.2734V5.33383H31.4425V7.43062C32.2496 5.92195 33.7377 5.07812 35.4276 5.07812C37.5715 5.07812 39.0343 6.17766 39.6649 8.19774C40.3711 6.2288 42.061 5.07812 44.1544 5.07812C46.9792 5.07812 48.543 7.02149 48.543 10.6269V18.1191H46.3739V11.0105C46.3739 8.37673 45.4659 7.07263 43.3977 7.07263C41.38 7.07263 39.9928 8.42787 39.9928 11.0105Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("path", {
                d: "M20.7997 18.3748C17.0164 18.3748 14.7969 15.5365 14.7969 11.7009C14.7969 7.86532 17.0164 5.07812 20.7997 5.07812C24.5578 5.07812 26.7521 7.86532 26.7521 11.7009C26.7521 15.5365 24.5578 18.3748 20.7997 18.3748ZM20.7997 7.12377C18.1009 7.12377 16.9155 9.2717 16.9155 11.7009C16.9155 14.1301 18.1009 16.3292 20.7997 16.3292C23.4732 16.3292 24.6334 14.1301 24.6334 11.7009C24.6334 9.2717 23.4732 7.12377 20.7997 7.12377Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("path", {
                d: "M13.2066 15.1558V17.3804C12.1725 18.0708 10.5331 18.3777 8.81798 18.3777C3.37004 18.3777 0.292969 15.0535 0.292969 9.76041C0.292969 4.64629 3.37004 1.06641 8.76754 1.06641C10.3817 1.06641 11.9959 1.37325 13.1814 2.24265V4.46729C11.9959 3.70018 10.6844 3.29105 8.76754 3.29105C4.88336 3.29105 2.56294 5.89925 2.56294 9.76041C2.56294 13.6216 4.95903 16.1786 8.89365 16.1786C10.634 16.1786 11.9959 15.7695 13.2066 15.1558Z",
                fill: "#101214"
            })
        ]
    });
const $f799923faf3aca14$var$svgStyles = null;

});


parcelRegister("jAWjL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f513b63cba3c9219$export$2e2bcd8739ae039; });

var $hZQpa = parcelRequire("hZQpa");

var $aool1 = parcelRequire("aool1");
const $f513b63cba3c9219$var$JiraCobranding = {
    background: (0, $aool1.JiraBackground),
    logo: {
        component: (0, $hZQpa.JiraLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $f513b63cba3c9219$export$2e2bcd8739ae039 = $f513b63cba3c9219$var$JiraCobranding;

});
parcelRegister("aool1", function(module, exports) {

$parcel$export(module.exports, "JiraBackground", function () { return $790f064f6bcb59f1$export$2ccb200c5de09b24; });

var $dNMDr = parcelRequire("dNMDr");

var $3J65S = parcelRequire("3J65S");

var $18Tos = parcelRequire("18Tos");

var $2uYV5 = parcelRequire("2uYV5");

var $1qxnH = parcelRequire("1qxnH");
var $790f064f6bcb59f1$export$2ccb200c5de09b24 = function JiraBackground(_ref) {
    var children = _ref.children;
    var isDarkMode = (0, $3J65S.default)().colorMode === 'dark';
    var Background = isDarkMode ? (0, $18Tos.JiraDarkTheme) : (0, $2uYV5.JiraLightTheme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1qxnH.DesktopOnlyBackground), {
        background: Background
    }, children);
};

});
parcelRegister("18Tos", function(module, exports) {

$parcel$export(module.exports, "JiraDarkTheme", function () { return $0d5181d07301aacf$export$24eb0206407d5744; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $gQLDR = parcelRequire("gQLDR");

var $eS3uG = parcelRequire("eS3uG");
var $3FKQn = parcelRequire("3FKQn");

var $iRKFZ = parcelRequire("iRKFZ");

var $eg0Tg = parcelRequire("eg0Tg");

var $5lvXZ = parcelRequire("5lvXZ");

var $dyM3I = parcelRequire("dyM3I");

var $2SFjF = parcelRequire("2SFjF");

var $gxfKC = parcelRequire("gxfKC");

var $8JMlV = parcelRequire("8JMlV");

var $02WwK = parcelRequire("02WwK");

var $1blxE = parcelRequire("1blxE");
var $0d5181d07301aacf$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    content: "_19bvxy5q"
};
var $0d5181d07301aacf$export$24eb0206407d5744 = function JiraDarkTheme() {
    if ((0, $gQLDR.fg)('cfind_4831_product_overlay_modal_visual_updates')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eg0Tg.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $5lvXZ.TopNav), {
        product: (0, $iRKFZ.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1blxE.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3FKQn.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $0d5181d07301aacf$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $gxfKC.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $2SFjF.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $0d5181d07301aacf$var$styles.content,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $8JMlV.Content), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $02WwK.DetailsPanel), null)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eg0Tg.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dyM3I.TopNav), {
        product: (0, $iRKFZ.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1blxE.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3FKQn.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $0d5181d07301aacf$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $gxfKC.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $2SFjF.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $0d5181d07301aacf$var$styles.content,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $8JMlV.Content), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $02WwK.DetailsPanel), null)))));
};

});
parcelRegister("5lvXZ", function(module, exports) {

$parcel$export(module.exports, "TopNav", function () { return $3e47b5d0e495b236$export$41d0d88a6b0e456f; });
/* top-nav.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $91FVG = parcelRequire("91FVG");


var $dNMDr = parcelRequire("dNMDr");

var $hZQpa = parcelRequire("hZQpa");

var $eS3uG = parcelRequire("eS3uG");

var $iRKFZ = parcelRequire("iRKFZ");

var $h9WhW = parcelRequire("h9WhW");
var $3e47b5d0e495b236$var$leftMenuSvg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
    width: "71",
    height: "30",
    viewBox: "0 0 71 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "29",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
    x: "41.5",
    y: "0.5",
    width: "29",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
}));
var $3e47b5d0e495b236$var$jiraLogoTextSvg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
    width: "35",
    height: "25",
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
    d: "M4.77661 19.1709C3.49487 19.1709 2.47803 18.8291 1.72607 18.1455C0.974121 17.4562 0.598145 16.4736 0.598145 15.1975V14.4456H3.03345V15.2317C3.03345 15.8583 3.1901 16.3368 3.50342 16.6672C3.81673 16.9919 4.24113 17.1543 4.77661 17.1543C5.3064 17.1543 5.7251 16.9919 6.03271 16.6672C6.34603 16.3368 6.50269 15.8555 6.50269 15.2231V6.26807H8.93799V15.2061C8.93799 16.4764 8.56486 17.4562 7.8186 18.1455C7.07804 18.8291 6.06405 19.1709 4.77661 19.1709ZM11.2109 19V9.54932H13.6035V19H11.2109ZM11.1682 8.16504V5.96899H13.6377V8.16504H11.1682ZM15.791 19V9.54932H18.1067V11.1643H18.1921C18.363 10.5946 18.6507 10.1646 19.0552 9.87402C19.4653 9.5778 19.9438 9.42969 20.4907 9.42969C20.6274 9.42969 20.767 9.43538 20.9094 9.44678C21.0575 9.45817 21.1857 9.47526 21.2939 9.49805V11.6428C21.1971 11.6143 21.0433 11.5887 20.8325 11.5659C20.6217 11.5431 20.4195 11.5317 20.2258 11.5317C19.8328 11.5317 19.4796 11.6172 19.1663 11.7881C18.8586 11.959 18.6165 12.1982 18.4399 12.5059C18.269 12.8078 18.1836 13.1667 18.1836 13.5825V19H15.791ZM25.2075 19.1794C24.6037 19.1794 24.0625 19.0741 23.584 18.8633C23.1055 18.6525 22.7266 18.3363 22.4475 17.9148C22.1741 17.4932 22.0374 16.9692 22.0374 16.3425C22.0374 15.8127 22.1342 15.3741 22.3279 15.0266C22.5273 14.6734 22.795 14.3914 23.1311 14.1807C23.4729 13.9642 23.8574 13.8018 24.2847 13.6936C24.7176 13.5854 25.1676 13.5056 25.6348 13.4543C26.193 13.3974 26.6402 13.3461 26.9763 13.3005C27.3181 13.2493 27.5659 13.1724 27.7197 13.0698C27.8792 12.9673 27.959 12.8135 27.959 12.6084V12.5571C27.959 12.278 27.8963 12.0387 27.771 11.8394C27.6514 11.64 27.4748 11.489 27.2412 11.3865C27.0076 11.2782 26.7228 11.2241 26.3867 11.2241C26.0392 11.2241 25.7373 11.2782 25.481 11.3865C25.2303 11.489 25.0224 11.6286 24.8572 11.8052C24.6977 11.9761 24.5866 12.1698 24.5239 12.3862L22.3108 12.0615C22.4589 11.4919 22.7209 11.0105 23.0969 10.6174C23.4729 10.2244 23.94 9.92814 24.4983 9.72876C25.0623 9.52368 25.6946 9.42114 26.3953 9.42114C26.9023 9.42114 27.3922 9.48096 27.865 9.60059C28.3378 9.72021 28.7594 9.9082 29.1296 10.1646C29.5056 10.4209 29.8018 10.7542 30.0183 11.1643C30.2348 11.5688 30.343 12.0615 30.343 12.6426V19H28.053V17.6841H27.9761C27.828 17.9689 27.6286 18.2253 27.3779 18.4531C27.133 18.6753 26.8311 18.8519 26.4722 18.9829C26.1133 19.1139 25.6917 19.1794 25.2075 19.1794ZM25.8569 17.4619C26.2842 17.4619 26.6545 17.3793 26.9678 17.2141C27.2868 17.0432 27.5346 16.8182 27.7112 16.5391C27.8878 16.2542 27.9761 15.9409 27.9761 15.5991V14.5481C27.902 14.5994 27.7852 14.6478 27.6257 14.6934C27.4719 14.7389 27.2982 14.7817 27.1045 14.8215C26.9108 14.8557 26.7171 14.887 26.5234 14.9155C26.3298 14.944 26.1532 14.9696 25.9937 14.9924C25.6746 15.038 25.3898 15.1121 25.1392 15.2146C24.8885 15.3171 24.692 15.4567 24.5496 15.6333C24.4071 15.8042 24.3359 16.0264 24.3359 16.2998C24.3359 16.5505 24.4014 16.7641 24.5325 16.9407C24.6635 17.1116 24.8429 17.2426 25.0708 17.3337C25.2987 17.4192 25.5607 17.4619 25.8569 17.4619Z",
    fill: "#292A2E"
}));
// TODO
var $3e47b5d0e495b236$var$confluenceLogoTextSvg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", null);
var $3e47b5d0e495b236$var$searchSvg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
    width: "455",
    height: "30",
    viewBox: "0 0 455 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "364",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
    x: "374",
    width: "81",
    height: "30",
    rx: "5",
    fill: "#1868DB"
}));
var $3e47b5d0e495b236$var$rightMenuSvg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
    width: "204",
    height: "30",
    viewBox: "0 0 204 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
    x: "92.5",
    y: "0.5",
    width: "29",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
    x: "133.5",
    y: "0.5",
    width: "29",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
    x: "174.5",
    y: "0.5",
    width: "29",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "80",
    height: "29",
    rx: "4.5",
    stroke: "black",
    strokeOpacity: "0.2"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
    x: "1",
    y: "1",
    width: "34",
    height: "34",
    rx: "17",
    fill: "#DDDEE1"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
    x: "1",
    y: "1",
    width: "34",
    height: "34",
    rx: "17",
    stroke: "white",
    strokeWidth: "2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
    d: "M11.0001 27.5L11 25.0001C10.9999 22.7909 12.7908 21 15 21H21C23.2091 21 24.9999 22.7908 25 24.9999L25.0001 27.5M22.4999 13C22.4999 15.4853 20.4852 17.5 17.9999 17.5C15.5146 17.5 13.4999 15.4853 13.4999 13C13.4999 10.5147 15.5146 8.5 17.9999 8.5C20.4852 8.5 22.4999 10.5147 22.4999 13Z",
    stroke: "#505258",
    strokeWidth: "2"
})));
var $3e47b5d0e495b236$var$styles = {
    wrapper: "_18zrv47k _n7zlia51 _1tkeymf6 _1bsb1osq",
    search: "_195goahv _1bsb1osq",
    searchBar: "_2rko12b0 _19itia51 _4t3izwfg _1bsb1osq _p12fcv93 _1ul91178",
    createButton: "_2rko12b0 _4t3izwfg _1bsbys9h _bfhk1dy8",
    createButtonText: "_2rko12b0 _4t3ii2wt _1bsb1ady",
    chatButton: "_2rko12b0 _19itia51 _4t3izwfg _1bsbcae7",
    chatButtonText: "_2rko12b0 _4t3ii2wt _1bsbzwfg",
    logoText: "_195g12x7"
};
var $3e47b5d0e495b236$var$ProductIcons = (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $iRKFZ.Products).JIRA, (0, $hZQpa.JiraIcon)), (0, $iRKFZ.Products).CONFLUENCE, (0, $hZQpa.ConfluenceIcon));
var $3e47b5d0e495b236$var$productLogoTextSvgs = (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $iRKFZ.Products).JIRA, $3e47b5d0e495b236$var$jiraLogoTextSvg), (0, $iRKFZ.Products).CONFLUENCE, $3e47b5d0e495b236$var$confluenceLogoTextSvg);
var $3e47b5d0e495b236$export$41d0d88a6b0e456f = function TopNav(_ref) {
    var product = _ref.product;
    var logoTextSvg = $3e47b5d0e495b236$var$productLogoTextSvgs[product];
    var Icon = $3e47b5d0e495b236$var$ProductIcons[product];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $3e47b5d0e495b236$var$styles.wrapper,
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignBlock: "center",
        space: "space.200"
    }, $3e47b5d0e495b236$var$leftMenuSvg, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9WhW.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(Icon, {
        appearance: "brand",
        size: "small",
        shouldUseNewLogoDesign: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $3e47b5d0e495b236$var$styles.logoText
    }, logoTextSvg)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9WhW.BelowMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(Icon, {
        appearance: "brand",
        size: "small",
        shouldUseNewLogoDesign: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $3e47b5d0e495b236$var$styles.search,
        alignInline: "center",
        space: "space.100"
    }, $3e47b5d0e495b236$var$searchSvg), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignBlock: "center",
        space: "space.200"
    }, $3e47b5d0e495b236$var$rightMenuSvg));
};

});

parcelRegister("2SFjF", function(module, exports) {

$parcel$export(module.exports, "Actions", function () { return $2190ac6edc0850ab$export$b52183d5cfb26dc9; });

var $dNMDr = parcelRequire("dNMDr");

var $99x4j = parcelRequire("99x4j");

var $cOXsp = parcelRequire("cOXsp");

var $dBkL2 = parcelRequire("dBkL2");

var $jFRBQ = parcelRequire("jFRBQ");

var $6uLZv = parcelRequire("6uLZv");

var $eS3uG = parcelRequire("eS3uG");
var $2190ac6edc0850ab$export$b52183d5cfb26dc9 = function Actions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOXsp))), {
        label: "Lock Unlocked",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99x4j))), {
        label: "Eye Open",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uLZv))), {
        label: "Thumbs Up",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dBkL2))), {
        label: "Share",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jFRBQ))), {
        label: "Show More Horizontal",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};

});
parcelRegister("99x4j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4381d46d56f0396feef6421a091c8f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a9e9b0d05c37a67$var$_react = $6a9e9b0d05c37a67$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $6a9e9b0d05c37a67$var$_baseNew = $6a9e9b0d05c37a67$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $6a9e9b0d05c37a67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a9e9b0d05c37a67$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $6a9e9b0d05c37a67$var$_react.default.createElement($6a9e9b0d05c37a67$var$_baseNew.default, Object.assign({
        name: "EyeOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$6a9e9b0d05c37a67$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $6a9e9b0d05c37a67$var$_default = module.exports.default = $6a9e9b0d05c37a67$var$EyeOpenIcon;

});

parcelRegister("cOXsp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5c5d989acf678b87189f6f5a97917ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0268a64c63da964a$var$_react = $0268a64c63da964a$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $0268a64c63da964a$var$_baseNew = $0268a64c63da964a$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $0268a64c63da964a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0268a64c63da964a$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $0268a64c63da964a$var$_react.default.createElement($0268a64c63da964a$var$_baseNew.default, Object.assign({
        name: "LockUnlockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$0268a64c63da964a$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $0268a64c63da964a$var$_default = module.exports.default = $0268a64c63da964a$var$LockUnlockedIcon;

});

parcelRegister("dBkL2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0eee459540e5ec28215a3b80df0172>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e6ed51a977056be$var$_react = $9e6ed51a977056be$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $9e6ed51a977056be$var$_baseNew = $9e6ed51a977056be$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $9e6ed51a977056be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e6ed51a977056be$var$ShareIcon = (props)=>/*#__PURE__*/ $9e6ed51a977056be$var$_react.default.createElement($9e6ed51a977056be$var$_baseNew.default, Object.assign({
        name: "ShareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$9e6ed51a977056be$var$ShareIcon.displayName = 'ShareIcon';
var $9e6ed51a977056be$var$_default = module.exports.default = $9e6ed51a977056be$var$ShareIcon;

});

parcelRegister("jFRBQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a789640350a4d3b29556a43626f35de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e52b6e6195dd6c49$var$_react = $e52b6e6195dd6c49$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $e52b6e6195dd6c49$var$_baseNew = $e52b6e6195dd6c49$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $e52b6e6195dd6c49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e52b6e6195dd6c49$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $e52b6e6195dd6c49$var$_react.default.createElement($e52b6e6195dd6c49$var$_baseNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$e52b6e6195dd6c49$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $e52b6e6195dd6c49$var$_default = module.exports.default = $e52b6e6195dd6c49$var$ShowMoreHorizontalIcon;

});

parcelRegister("6uLZv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bf82c15bca1a56d27012abd5cecbc7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4baac572887bd438$var$_react = $4baac572887bd438$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $4baac572887bd438$var$_baseNew = $4baac572887bd438$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $4baac572887bd438$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4baac572887bd438$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $4baac572887bd438$var$_react.default.createElement($4baac572887bd438$var$_baseNew.default, Object.assign({
        name: "ThumbsUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$4baac572887bd438$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $4baac572887bd438$var$_default = module.exports.default = $4baac572887bd438$var$ThumbsUpIcon;

});


parcelRegister("gxfKC", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $c09bf23ae0164ce4$export$2dc68d50d56fbbd; });

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $c09bf23ae0164ce4$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($c09bf23ae0164ce4$var$Illustration, null));
};
var $c09bf23ae0164ce4$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 167,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#738496",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }));
};

});

parcelRegister("8JMlV", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $65c808812d5fba02$export$7c6e2c02157bb7d2; });

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $65c808812d5fba02$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($65c808812d5fba02$var$Illustration, null));
};
var $65c808812d5fba02$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: 640,
        height: 427,
        viewBox: "0 0 640 427",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 640,
        height: 20,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        y: 40,
        width: 60,
        height: 32,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 8,
        y: 53,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 68,
        y: 40,
        width: 99,
        height: 32,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 76,
        y: 53,
        width: 59,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(138 44)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M146.292 54.2929C146.105 54.4818 146 54.7368 146 55.0024C146 55.2681 146.105 55.523 146.292 55.7119L149.231 58.6769C149.449 58.8919 149.731 58.9989 150.01 58.9989C150.289 58.9989 150.566 58.8919 150.779 58.6769L153.709 55.7219C153.895 55.5329 154 55.278 154 55.0124C154 54.7469 153.895 54.492 153.709 54.3029C153.617 54.2098 153.507 54.1358 153.387 54.0853C153.266 54.0347 153.136 54.0087 153.006 54.0087C152.875 54.0087 152.745 54.0347 152.625 54.0853C152.504 54.1358 152.394 54.2098 152.303 54.3029L150.005 56.6199L147.698 54.2929C147.606 54.2001 147.496 54.1264 147.375 54.0762C147.255 54.0259 147.125 54 146.995 54C146.864 54 146.734 54.0259 146.614 54.0762C146.493 54.1264 146.384 54.2001 146.292 54.2929Z",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        y: 92,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        y: 120,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        y: 148,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        y: 200,
        width: 180,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 4,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 60,
        y: 232,
        width: 85,
        height: 20,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 64,
        y: 239,
        width: 77,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 153,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 157,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 213,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 217,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 14,
        y: 282,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 27,
        cy: 295,
        r: 12,
        fill: "url(#pattern0_233_7702)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 46,
        y: 279,
        width: 591,
        height: 40,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 54,
        y: 295,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 44.2764,
        y: 385,
        width: 425.66,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 44.2764,
        y: 403,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 44.2764,
        y: 421,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 44,
        y: 356,
        width: 119,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 10,
        y: 346,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 23,
        cy: 359,
        r: 12,
        fill: "url(#pattern1_233_7702)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("pattern", {
        id: "pattern0_233_7702",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("use", {
        xlinkHref: "#image0_233_7702",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("pattern", {
        id: "pattern1_233_7702",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("use", {
        xlinkHref: "#image1_233_7702",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("image", {
        id: "image0_233_7702",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAwYCBAUACAf/xAAuEAACAQMCBAQGAgMAAAAAAAABAgMABAUGERITITEHQVFhFCJCcYGRMuFiobH/xAAXAQEBAQEAAAAAAAAAAAAAAAAGBwUE/8QAKREAAQMDAgQGAwAAAAAAAAAAAgEDEQAEEgVBBiExURMUInGB8JGx0f/aAAwDAQACEQMRAD8ASqjI6xozuwVFG5J7AVKlzWN0UghtkO3MPE32HYfv/lWK9uUtWCeXb91PrZlX3EbTeoXmqArlbOEMo+uQ7b/ioW2qX4wLq3Xg9Yz1H4NYWNsbrJ5C3sbCB57u4cRxRIN2ZjVrUuEvdOZy7xOUi5d3bPwsPJh5Mp81I6g0IXW7xTnP4hIpMmmW+EY/NO9tcRXUCywOHjbsRRaT9IXTR3z2xPySqSB/kP6pwplp155xhHYhei+9HLy38u6obbV1A0Tp4as8UbS0vbZp8VDKi3Q3IUJwkhSR1HEw26Uesu3z2R0dqqHK4925EskUk0X0y8tgeE/72+5rN4lBwrP0bL/a7NFIBufX2r1tpvR2ndNMz4LD2dlKw2aSNN3I9OI7nb80bUGl8HqJUGcxNnfFBsjTRAso9A3cfurGn8zY6gw1rlMVMJrO5QOjDuPVT6EHoR6irl1cQ2ltLcXUqQwRKXkkc7Kigbkk+QqVqpZSvWqCgjjy6V5R8btI22kddY+4wdktriZ0iAWMnhWXdgy9Tv1A3/dUfOh651bca913PNA8gwlvMHt4yNhwoOEOfdup28t6JVN4VbcG2JT3WgmvGBPogdq6g3VrFewmCZONW8vPf296MASQB1Jp1xOKhso1dlDXBHVj9J9BW/cuAAQaTO1ZDQkpSKxFNfgBgMlp7Tt/zpX+FurkSwROOoAXZiR7nb9VreNmFympdES2ljMUCTJNNGvTmRrvuO/XqQdj6VgYrMX2LLfBTlFbqyEBlP4NFyueyOUj5d3PvF35aKFU/fbvU+c0NwrzxhjCZjn07fVpeGsNpa+EqLlETy/P1K+N2eOjxkZt442Rgfn4v5E+9WKe8jjoL+MiRQJNvlcdx/VIsiFHZG6MpIP3p/aOAQYAkRtRF4SyyJZmv//Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("image", {
        id: "image1_233_7702",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABAADBQYHAQL/xAApEAABAwMDAwQCAwAAAAAAAAABAgMEAAUREiFBBlFxBzFCYROBkdHh/8QAFwEBAQEBAAAAAAAAAAAAAAAABgcEBf/EACkRAAEDAwIFAwUAAAAAAAAAAAECAxEABCEFEgYxUXGRIjLRQaHB4fD/2gAMAwEAAhEDEQA/AH6VKirXCXcJzUds4KjursOTTRa0tpK1GAKizTS3lpbbEqJgdzQoBJwASfquqSUnCgQfsVp9ut0a3tBEZoA8rIypXk07LiMTGi3JaS4k9xuPB4o2eJUb4DZ29Zz4/dO08BulqVPAL6RjzP4rKqVSV/thtc4tglTSxqbUe3Y/YqNpGy6l5AcQZBoPc2zlq6pl0QpJg0qs3QjeZ8hzAwlvT/J/yqzRMCfJt7inIa0pWRjChkHyKz6gwt+3W03zNbdFumrO+bfe9qT9O3zWp0qpULrV+54j2qzuv3FIy60t1KUIA98H3O/1XuR1m9anvxdQ2h6GtadTQacS7qHY+2Kn5tHQdsZ6SJ8VbhdNEbgcdcx5ojr1GY8RzHspSc+QP6qm0dc7vKuykrkANoGShofAHgnk/dA070q3Xb2qW3OfzmozxFeNXuoOPM8sDvAie2KVMyX0x2itW/AA5p6oqfAdWsuNrLmfio7jxW9ZIGK47SUqV6jFWprpJi8QIlwizFRZimxqWydSc/ogg42O9e4/RsS3OG4Xq5KfLe4U5skHjJJJOO1A+mocavT6XVuNthknQThKjkDcc131LbccvEb8LjjqFM50A5SggkbDjNFF2dyq5LZUdpzMfaqa1rVo3p6XEoG9MJiegif7zUew8h9GtB2zinaioEB1Cw44st4+KTufNStK0EkZqZupSFek1//Z"
    })));
};

});

parcelRegister("02WwK", function(module, exports) {

$parcel$export(module.exports, "DetailsPanel", function () { return $008d964c4e596ba9$export$e54a7f2505304e20; });
/* details-panel.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $008d964c4e596ba9$var$styles = {
    wrapper: "_kqsw1n9t _1xi2ze3t _19bvutpp _u5f3xy5q"
};
var $008d964c4e596ba9$export$e54a7f2505304e20 = function DetailsPanel() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $008d964c4e596ba9$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($008d964c4e596ba9$var$Illustration, null));
};
var $008d964c4e596ba9$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: 328,
        height: 597,
        viewBox: "0 0 328 597",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 80,
        height: 32,
        rx: 3,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 17,
        y: 13,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#0055CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M0 52C0 47.5817 3.58172 44 8 44H320C324.418 44 328 47.5817 328 52V597H0V52Z",
        fill: "#1D2125"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M0.5 52C0.5 47.8579 3.85786 44.5 8 44.5H320C324.142 44.5 327.5 47.8579 327.5 52V596.5H0.5V52Z",
        stroke: "#A1BDD9",
        strokeOpacity: 0.08
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 77,
        width: 253,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(280 68)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M288.292 78.2929C288.105 78.4818 288 78.7368 288 79.0024C288 79.2681 288.105 79.523 288.292 79.7119L291.231 82.6769C291.449 82.8919 291.731 82.9989 292.01 82.9989C292.289 82.9989 292.566 82.8919 292.779 82.6769L295.709 79.7219C295.895 79.5329 296 79.278 296 79.0124C296 78.7469 295.895 78.492 295.709 78.3029C295.617 78.2098 295.507 78.1358 295.387 78.0853C295.266 78.0347 295.136 78.0087 295.006 78.0087C294.875 78.0087 294.745 78.0347 294.625 78.0853C294.504 78.1358 294.394 78.2098 294.303 78.3029L292.005 80.6199L289.698 78.2929C289.606 78.2001 289.496 78.1264 289.375 78.0762C289.255 78.0259 289.125 78 288.995 78C288.864 78 288.734 78.0259 288.614 78.0762C288.493 78.1264 288.384 78.2001 288.292 78.2929Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 121,
        width: 79,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 159,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 197,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 235,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 273,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 311,
        width: 110,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 349,
        width: 100,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 387,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 425,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 463,
        width: 95,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(178 112)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M190.522 131.853L190.625 131.781L195.625 127.781C196.056 127.436 196.126 126.807 195.781 126.375C195.462 125.977 194.902 125.887 194.478 126.147L194.375 126.219L190 129.72L185.625 126.219C185.227 125.901 184.66 125.936 184.304 126.282L184.219 126.375C183.901 126.773 183.936 127.34 184.282 127.696L184.375 127.781L189.375 131.781C189.707 132.046 190.166 132.071 190.522 131.853Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M190.522 126.853L190.625 126.781L195.625 122.781C196.056 122.436 196.126 121.807 195.781 121.375C195.462 120.977 194.902 120.887 194.478 121.147L194.375 121.219L190 124.72L185.625 121.219C185.227 120.901 184.66 120.936 184.304 121.282L184.219 121.375C183.901 121.773 183.936 122.34 184.282 122.696L184.375 122.781L189.375 126.781C189.707 127.046 190.166 127.071 190.522 126.853Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M190.522 121.853L190.625 121.781L195.625 117.781C196.056 117.436 196.126 116.807 195.781 116.375C195.462 115.977 194.902 115.887 194.478 116.147L194.375 116.219L190 119.72L185.625 116.219C185.227 115.901 184.66 115.936 184.304 116.282L184.219 116.375C183.901 116.773 183.936 117.34 184.282 117.696L184.375 117.781L189.375 121.781C189.707 122.046 190.166 122.071 190.522 121.853Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 210,
        y: 121,
        width: 66,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 159,
        width: 98,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 188,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 182,
        y: 195,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        opacity: 0.8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 177,
        y: 230,
        width: 18,
        height: 18,
        rx: 9,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 186,
        cy: 239,
        r: 8,
        fill: "url(#pattern0_233_7667)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 202,
        y: 236,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 273,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 311,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 349,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 387,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 425,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 463,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("pattern", {
        id: "pattern0_233_7667",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("use", {
        xlinkHref: "#image0_233_7667",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("image", {
        id: "image0_233_7667",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    })));
};

});

parcelRegister("1blxE", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $0dc78742c6a898b7$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");

var $h9WhW = parcelRequire("h9WhW");
var $0dc78742c6a898b7$var$styles = {
    background: "_1s7zia51 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $0dc78742c6a898b7$export$1a35787d6353cf6a = function SideNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9WhW.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $0dc78742c6a898b7$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($0dc78742c6a898b7$var$Illustration, null)));
};
var $0dc78742c6a898b7$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 296,
        height: 473,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M265.25 151.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 150.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M285.5 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 72,
        height: 9,
        x: 20,
        y: 189,
        fill: "#596773",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 278,
        height: 43,
        x: 18,
        y: 215,
        fill: "#1C2B41",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 220.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 224,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#1868DB",
        d: "M18 229h2.66v15.96H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 232.5,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M259.25 237.25v4.25h1.5v-4.25H265v-1.5h-4.25v-4.25h-1.5v4.25H255v1.5h4.25ZM279.25 236.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M279.5 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM284.25 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM289 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 263.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 267,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 275.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 306.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 310,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 318.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M20 349.5h32v32H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M39 360.5H25V359h14v1.5Zm0 5.25H25v-1.5h14v1.5ZM32 371h-7v-1.5h7v1.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 64,
        y: 361.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 392.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 396.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 404.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 408.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 435.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M9.667 451.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 451a1.667 1.667 0 1 1 3.333 0A1.667 1.667 0 0 1 8 451Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 451a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 451A1.667 1.667 0 1 1 24 451a1.667 1.667 0 0 1-3.333 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M10 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 451a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 447.5,
        fill: "#454F59",
        rx: 3.99
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M0 0h296v473H0z"
    }))));
};

});


parcelRegister("2uYV5", function(module, exports) {

$parcel$export(module.exports, "JiraLightTheme", function () { return $1d1da3866c8fe547$export$8e2414c6a082747f; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $gQLDR = parcelRequire("gQLDR");

var $eS3uG = parcelRequire("eS3uG");
var $3FKQn = parcelRequire("3FKQn");

var $iRKFZ = parcelRequire("iRKFZ");

var $eg0Tg = parcelRequire("eg0Tg");

var $5lvXZ = parcelRequire("5lvXZ");

var $dyM3I = parcelRequire("dyM3I");

var $2SFjF = parcelRequire("2SFjF");

var $c442A = parcelRequire("c442A");

var $99TgD = parcelRequire("99TgD");

var $2X49D = parcelRequire("2X49D");

var $2gU06 = parcelRequire("2gU06");

var $hwIVJ = parcelRequire("hwIVJ");

var $kJ0Sl = parcelRequire("kJ0Sl");

var $32KEc = parcelRequire("32KEc");
var $1d1da3866c8fe547$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    content: "_19bvxy5q",
    container: "_1reo15vq"
};
var $1d1da3866c8fe547$export$8e2414c6a082747f = function JiraLightTheme() {
    if ((0, $gQLDR.fg)('cfind_4831_product_overlay_modal_visual_updates')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eg0Tg.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3FKQn.default), {
        xcss: $1d1da3866c8fe547$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $5lvXZ.TopNav), {
        product: (0, $iRKFZ.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $2X49D.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3FKQn.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $99TgD.BodyNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $c442A.Board), null)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eg0Tg.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dyM3I.TopNav), {
        product: (0, $iRKFZ.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $32KEc.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3FKQn.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $1d1da3866c8fe547$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $2gU06.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $2SFjF.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $1d1da3866c8fe547$var$styles.content,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $hwIVJ.Content), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $kJ0Sl.DetailsPanel), null)))));
};

});
parcelRegister("c442A", function(module, exports) {

$parcel$export(module.exports, "Board", function () { return $8c88fe2dec66907b$export$dc537a3a3893548e; });
/* board.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $grvIM = parcelRequire("grvIM");

var $dNMDr = parcelRequire("dNMDr");

var $eS3uG = parcelRequire("eS3uG");
var $8c88fe2dec66907b$var$styles = {
    rowSpacing: "_ca0qxy5q _u5f3xy5q _19bvxy5q",
    boardImage: "_1reoewfl _18m9ewfl"
};
var $8c88fe2dec66907b$export$dc537a3a3893548e = function Board() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $8c88fe2dec66907b$var$styles.rowSpacing,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($8c88fe2dec66907b$var$SearchAndAvatarsImage, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($8c88fe2dec66907b$var$OptionsImage, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $8c88fe2dec66907b$var$styles.rowSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($8c88fe2dec66907b$var$BoardImage, null)));
};
var $8c88fe2dec66907b$var$SearchAndAvatarsImage = function SearchAndAvatarsImage() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: "176",
        height: "34",
        viewBox: "0 0 176 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "0.5",
        y: "2.5",
        width: "110",
        height: "29",
        rx: "4.5",
        stroke: "black",
        strokeOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "146.625",
        y: "2.625",
        width: "28.75",
        height: "28.75",
        rx: "14.375",
        stroke: "#0B1228",
        strokeOpacity: "0.14",
        strokeWidth: "1.25"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M161.938 16.0625V9.5H160.062V16.0625H153.5V17.9375H160.062V24.5H161.937V17.9375H168.5V16.0625H161.938Z",
        fill: "#D2D2D2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "118.5",
        y: "0.5",
        width: "33",
        height: "33",
        rx: "16.5",
        fill: "#DDDEE1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "118.5",
        y: "0.5",
        width: "33",
        height: "33",
        rx: "16.5",
        stroke: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M128 26.5L128 24.0001C128 21.7909 129.791 20 132 20H138C140.209 20 142 21.7908 142 23.9999L142 26.5M139.5 12C139.5 14.4853 137.485 16.5 135 16.5C132.515 16.5 130.5 14.4853 130.5 12C130.5 9.51472 132.515 7.5 135 7.5C137.485 7.5 139.5 9.51472 139.5 12Z",
        stroke: "#505258",
        strokeWidth: "2"
    }));
};
var $8c88fe2dec66907b$var$OptionsImage = function OptionsImage() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: "194",
        height: "30",
        viewBox: "0 0 194 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "110",
        height: "29",
        rx: "4.5",
        stroke: "black",
        strokeOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "124.5",
        y: "0.5",
        width: "29",
        height: "29",
        rx: "4.5",
        stroke: "black",
        strokeOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "164.5",
        y: "0.5",
        width: "29",
        height: "29",
        rx: "4.5",
        stroke: "black",
        strokeOpacity: "0.2"
    }));
};
var $8c88fe2dec66907b$var$BoardImage = function BoardImage() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: "1377",
        height: "494",
        viewBox: "0 0 1377 494",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $grvIM.default)([
            $8c88fe2dec66907b$var$styles.boardImage
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "260",
        height: "494",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "75",
        height: "12",
        x: "12",
        y: "13",
        fill: "#d2d2d2",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "14",
        height: "14",
        x: "189",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "14",
        height: "14",
        x: "210",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "36",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m212.597 126.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m22.655 130.28 3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 123a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "119",
        fill: "url(#a)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "119.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "119.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 132.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "48",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "69",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "124",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "150",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m207.708 239.078 4.889 3.111a.75.75 0 0 0 .805 0l4.889-3.111-.805-1.266-4.486 2.855-4.486-2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m207.708 243.522 4.889 3.111c.246.156.56.156.806 0l4.888-3.111-.805-1.266-4.486 2.855-4.486-2.855zM22.655 244.28l3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 237a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "233",
        fill: "url(#b)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 246.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 246.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "162",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "183",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "238",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "264",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m212.597 354.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m22.655 358.28 3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 351a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "347",
        fill: "url(#c)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "347.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "347.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 360.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "276",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "297",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "352",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "378",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m207.597 464.367-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.888-3.111a.75.75 0 0 0-.806 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m207.597 468.812-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.888-3.111a.75.75 0 0 0-.806 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m202.708 476.367 4.889-3.111a.75.75 0 0 1 .805 0l4.889 3.111-.805 1.266-4.486-2.855-4.486 2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m22.655 472.28 3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 465a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "461",
        fill: "url(#d)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "461.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "461.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 474.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "390",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "411",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "466",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "260",
        height: "494",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "75",
        height: "12",
        x: "12",
        y: "13",
        fill: "#d2d2d2",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "14",
        height: "14",
        x: "189",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "14",
        height: "14",
        x: "210",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "36",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m212.597 126.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m22.655 130.28 3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 123a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "119",
        fill: "url(#e)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "119.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "119.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 132.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "48",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "69",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "124",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "150",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m207.708 239.078 4.889 3.111a.75.75 0 0 0 .805 0l4.889-3.111-.805-1.266-4.486 2.855-4.486-2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m207.708 243.522 4.889 3.111c.246.156.56.156.806 0l4.888-3.111-.805-1.266-4.486 2.855-4.486-2.855zM22.655 244.28l3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 237a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "233",
        fill: "url(#f)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 246.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 246.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "162",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "183",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "238",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "264",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m212.597 354.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m22.655 358.28 3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 351a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "347",
        fill: "url(#g)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "347.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "347.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 360.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "276",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "297",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "352",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "4",
        y: "378",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m207.597 464.367-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.888-3.111a.75.75 0 0 0-.806 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m207.597 468.812-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.888-3.111a.75.75 0 0 0-.806 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m202.708 476.367 4.889-3.111a.75.75 0 0 1 .805 0l4.889 3.111-.805 1.266-4.486-2.855-4.486 2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m22.655 472.28 3.938-3.937-1.06-1.061-3.408 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M16 465a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "228",
        y: "461",
        fill: "url(#h)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "461.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "228.5",
        y: "461.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M233.5 474.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "13",
        y: "390",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "13",
        y: "411",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "38",
        y: "466",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "260",
        height: "378",
        x: "1117",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "75",
        height: "12",
        x: "1129",
        y: "13",
        fill: "#d2d2d2",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "14",
        height: "14",
        x: "1306",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "14",
        height: "14",
        x: "1327",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "1121",
        y: "36",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m1329.6 126.756-4.89 3.111.8 1.266 4.49-2.855 4.49 2.855.8-1.266-4.89-3.111a.74.74 0 0 0-.8 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m1139.66 130.28 3.93-3.937-1.06-1.061-3.41 3.407-1.21-1.219-1.07 1.06 1.75 1.75c.3.293.77.293 1.07 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M1133 123c0-1.105.9-2 2-2h10c1.1 0 2 .895 2 2v10c0 1.105-.9 2-2 2h-10c-1.1 0-2-.895-2-2zm2-.5h10c.28 0 .5.224.5.5v10c0 .276-.22.5-.5.5h-10c-.28 0-.5-.224-.5-.5v-10c0-.276.22-.5.5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1345",
        y: "119",
        fill: "url(#i)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "119.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "119.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M1350.5 132.75v-1.25c0-1.105.9-2 2-2h3c1.1 0 2 .895 2 2v1.25m-1.25-7.25c0 1.243-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25c0-1.243 1.01-2.25 2.25-2.25s2.25 1.007 2.25 2.25Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "1130",
        y: "48",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "1130",
        y: "69",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "1155",
        y: "124",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "1121",
        y: "150",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m1324.71 239.078 4.89 3.111c.24.156.56.156.8 0l4.89-3.111-.8-1.266-4.49 2.855-4.49-2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m1324.71 243.522 4.89 3.111c.24.156.56.156.8 0l4.89-3.111-.8-1.266-4.49 2.855-4.49-2.855zM1139.66 244.28l3.93-3.937-1.06-1.061-3.41 3.407-1.21-1.219-1.07 1.06 1.75 1.75c.3.293.77.293 1.07 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M1133 237c0-1.105.9-2 2-2h10c1.1 0 2 .895 2 2v10c0 1.105-.9 2-2 2h-10c-1.1 0-2-.895-2-2zm2-.5h10c.28 0 .5.224.5.5v10c0 .276-.22.5-.5.5h-10c-.28 0-.5-.224-.5-.5v-10c0-.276.22-.5.5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1345",
        y: "233",
        fill: "url(#j)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M1350.5 246.75v-1.25c0-1.105.9-2 2-2h3c1.1 0 2 .895 2 2v1.25m-1.25-7.25c0 1.243-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25c0-1.243 1.01-2.25 2.25-2.25s2.25 1.007 2.25 2.25Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M1350.5 246.75v-1.25c0-1.105.9-2 2-2h3c1.1 0 2 .895 2 2v1.25m-1.25-7.25c0 1.243-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25c0-1.243 1.01-2.25 2.25-2.25s2.25 1.007 2.25 2.25Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "1130",
        y: "162",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "1130",
        y: "183",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "1155",
        y: "238",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "1121",
        y: "264",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m1329.6 354.756-4.89 3.111.8 1.266 4.49-2.855 4.49 2.855.8-1.266-4.89-3.111a.74.74 0 0 0-.8 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m1139.66 358.28 3.93-3.937-1.06-1.061-3.41 3.407-1.21-1.219-1.07 1.06 1.75 1.75c.3.293.77.293 1.07 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M1133 351c0-1.105.9-2 2-2h10c1.1 0 2 .895 2 2v10c0 1.105-.9 2-2 2h-10c-1.1 0-2-.895-2-2zm2-.5h10c.28 0 .5.224.5.5v10c0 .276-.22.5-.5.5h-10c-.28 0-.5-.224-.5-.5v-10c0-.276.22-.5.5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1345",
        y: "347",
        fill: "url(#k)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "347.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1345.5",
        y: "347.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M1350.5 360.75v-1.25c0-1.105.9-2 2-2h3c1.1 0 2 .895 2 2v1.25m-1.25-7.25c0 1.243-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25c0-1.243 1.01-2.25 2.25-2.25s2.25 1.007 2.25 2.25Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "1130",
        y: "276",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "1130",
        y: "297",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "1155",
        y: "352",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "260",
        height: "494",
        x: "280",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "103",
        height: "12",
        x: "292",
        y: "13",
        fill: "#d2d2d2",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "14",
        height: "14",
        x: "469",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "14",
        height: "14",
        x: "490",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "284",
        y: "36",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m492.597 126.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m302.655 130.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M296 123a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "508",
        y: "119",
        fill: "url(#l)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "119.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "119.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M513.5 132.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "293",
        y: "48",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "293",
        y: "69",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "318",
        y: "124",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "284",
        y: "150",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m487.708 239.078 4.889 3.111a.75.75 0 0 0 .805 0l4.889-3.111-.805-1.266-4.486 2.855-4.486-2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m487.708 243.522 4.889 3.111c.246.156.56.156.806 0l4.888-3.111-.805-1.266-4.486 2.855-4.486-2.855zM302.655 244.28l3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M296 237a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "508",
        y: "233",
        fill: "url(#m)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M513.5 246.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "293",
        y: "162",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "293",
        y: "183",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "318",
        y: "238",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "284",
        y: "264",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m492.597 354.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m302.655 358.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M296 351a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "508",
        y: "347",
        fill: "url(#n)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "347.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "347.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M513.5 360.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "293",
        y: "276",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "293",
        y: "297",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "318",
        y: "352",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "284",
        y: "378",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m492.597 468.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m302.655 472.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M296 465a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "508",
        y: "461",
        fill: "url(#o)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "461.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "508.5",
        y: "461.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M513.5 474.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "293",
        y: "390",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "293",
        y: "411",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "318",
        y: "466",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "260",
        height: "494",
        x: "559",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "75",
        height: "12",
        x: "571",
        y: "13",
        fill: "#d2d2d2",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "14",
        height: "14",
        x: "748",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "14",
        height: "14",
        x: "769",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "563",
        y: "36",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m771.597 126.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m581.655 130.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M575 123a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "787",
        y: "119",
        fill: "url(#p)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "119.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "119.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M792.5 132.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "572",
        y: "48",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "572",
        y: "69",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "597",
        y: "124",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "563",
        y: "150",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m766.708 239.078 4.889 3.111a.75.75 0 0 0 .805 0l4.889-3.111-.805-1.266-4.486 2.855-4.486-2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m766.708 243.522 4.889 3.111c.246.156.56.156.806 0l4.888-3.111-.805-1.266-4.486 2.855-4.486-2.855zM581.655 244.28l3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M575 237a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "787",
        y: "233",
        fill: "url(#q)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "787",
        y: "233",
        fill: "#fff",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "787",
        y: "233",
        stroke: "#fff",
        strokeWidth: "2",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: "796",
        cy: "242",
        r: "8",
        fill: "url(#r)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M792.5 246.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "572",
        y: "162",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "572",
        y: "183",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "597",
        y: "238",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "563",
        y: "264",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m771.597 354.756-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.889-3.111a.75.75 0 0 0-.805 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m581.655 358.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M575 351a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "787",
        y: "347",
        fill: "url(#s)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "347.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "347.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M792.5 360.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "572",
        y: "276",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "572",
        y: "297",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "597",
        y: "352",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "563",
        y: "378",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m766.597 464.367-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.888-3.111a.75.75 0 0 0-.806 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m766.597 468.812-4.889 3.111.806 1.266 4.486-2.855 4.486 2.855.805-1.266-4.888-3.111a.75.75 0 0 0-.806 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m761.708 476.367 4.889-3.111a.75.75 0 0 1 .805 0l4.889 3.111-.805 1.266-4.486-2.855-4.486 2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m581.655 472.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M575 465a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "787",
        y: "461",
        fill: "url(#t)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "461.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "787.5",
        y: "461.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M792.5 474.75v-1.25a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25m-1.25-7.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "572",
        y: "390",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "572",
        y: "411",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "597",
        y: "466",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "260",
        height: "264",
        x: "837",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "41",
        height: "12",
        x: "849",
        y: "13",
        fill: "#d2d2d2",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#6a9a23",
        d: "m908.061 17.06-6.308 6.309a.75.75 0 0 1-1.061 0l-2.753-2.753 1.061-1.06 2.222 2.222L907 16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "14",
        height: "14",
        x: "1026",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "14",
        height: "14",
        x: "1047",
        y: "12",
        fill: "#d2d2d2",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "841",
        y: "36",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#e2483d",
        d: "m1049.6 126.756-4.89 3.111.8 1.266 4.49-2.855 4.49 2.855.8-1.266-4.89-3.111a.74.74 0 0 0-.8 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m859.655 130.28 3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M853 123a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1065",
        y: "119",
        fill: "url(#u)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1065.5",
        y: "119.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1065.5",
        y: "119.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M1070.5 132.75v-1.25c0-1.105.9-2 2-2h3c1.1 0 2 .895 2 2v1.25m-1.25-7.25c0 1.243-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25c0-1.243 1.01-2.25 2.25-2.25s2.25 1.007 2.25 2.25Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "850",
        y: "48",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "850",
        y: "69",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "875",
        y: "124",
        fill: "#eee",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "252",
        height: "110",
        x: "841",
        y: "150",
        fill: "#fff",
        rx: "2.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m1044.71 239.078 4.89 3.111c.24.156.56.156.8 0l4.89-3.111-.8-1.266-4.49 2.855-4.49-2.855z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        d: "m1044.71 243.522 4.89 3.111c.24.156.56.156.8 0l4.89-3.111-.8-1.266-4.49 2.855-4.49-2.855zM859.655 244.28l3.938-3.937-1.061-1.061-3.407 3.407-1.22-1.219-1.06 1.06 1.75 1.75a.75.75 0 0 0 1.06 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#357de8",
        fillRule: "evenodd",
        d: "M853 237a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zm2-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1065",
        y: "233",
        fill: "url(#v)",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1065",
        y: "233",
        fill: "#fff",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "18",
        height: "18",
        x: "1065",
        y: "233",
        stroke: "#fff",
        strokeWidth: "2",
        rx: "9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: "1074",
        cy: "242",
        r: "8",
        fill: "url(#w)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1065.5",
        y: "233.5",
        fill: "#dddee1",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "17",
        height: "17",
        x: "1065.5",
        y: "233.5",
        stroke: "#fff",
        rx: "8.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        stroke: "#505258",
        d: "M1070.5 246.75v-1.25c0-1.105.9-2 2-2h3c1.1 0 2 .895 2 2v1.25m-1.25-7.25c0 1.243-1.01 2.25-2.25 2.25a2.25 2.25 0 0 1-2.25-2.25c0-1.243 1.01-2.25 2.25-2.25s2.25 1.007 2.25 2.25Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "168",
        height: "12",
        x: "850",
        y: "162",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "141",
        height: "12",
        x: "850",
        y: "183",
        fill: "#eee",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "54",
        height: "8",
        x: "875",
        y: "238",
        fill: "#eee",
        rx: "4"
    }));
};

});

parcelRegister("99TgD", function(module, exports) {

$parcel$export(module.exports, "BodyNav", function () { return $6aafd33e8bbc47ef$export$d62bc198d96fc76d; });
/* body-nav.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $grvIM = parcelRequire("grvIM");

var $dNMDr = parcelRequire("dNMDr");

var $kugzw = parcelRequire("kugzw");

var $eS3uG = parcelRequire("eS3uG");
var $6aafd33e8bbc47ef$var$styles = {
    rowSpacing: "_ca0qxy5q _u5f3xy5q _19bvxy5q",
    lastRow: "_n3tdxy5q _1doce4h9 _1il9nqa1 _1o3i14ap",
    image4Wrapper: "_4t3i1ou6"
};
var $6aafd33e8bbc47ef$export$d62bc198d96fc76d = function BodyNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $6aafd33e8bbc47ef$var$styles.rowSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($6aafd33e8bbc47ef$var$Image1, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $6aafd33e8bbc47ef$var$styles.rowSpacing,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($6aafd33e8bbc47ef$var$Image2, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($6aafd33e8bbc47ef$var$Image3, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: (0, $kugzw.cx)($6aafd33e8bbc47ef$var$styles.rowSpacing, $6aafd33e8bbc47ef$var$styles.lastRow)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
        className: (0, $grvIM.default)([
            $6aafd33e8bbc47ef$var$styles.image4Wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($6aafd33e8bbc47ef$var$Image4, null))));
};
var $6aafd33e8bbc47ef$var$Image1 = function Image1() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: "84",
        height: "12",
        viewBox: "0 0 84 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "84",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }));
};
var $6aafd33e8bbc47ef$var$Image2 = function Image2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: "179",
        height: "8",
        viewBox: "0 0 179 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M-0.000390768 3.57603C-0.000390768 2.88803 0.159609 2.28003 0.479609 1.75203C0.783609 1.20803 1.20761 0.784029 1.75161 0.480029C2.27961 0.160029 2.88761 2.86102e-05 3.57561 2.86102e-05H17.1116C17.7996 2.86102e-05 18.4076 0.160029 18.9356 0.480029C19.4796 0.784029 19.9036 1.20803 20.2076 1.75203C20.5276 2.28003 20.6876 2.88803 20.6876 3.57603V3.62403C20.6876 4.31203 20.5276 4.92803 20.2076 5.47203C19.9036 6.00003 19.4796 6.42403 18.9356 6.74403C18.4076 7.04803 17.7996 7.20003 17.1116 7.20003H3.57561C2.88761 7.20003 2.27961 7.04803 1.75161 6.74403C1.20761 6.42403 0.783609 6.00003 0.479609 5.47203C0.159609 4.92803 -0.000390768 4.31203 -0.000390768 3.62403V3.57603ZM14.1256 3.57603C14.1256 2.88803 14.2856 2.28003 14.6056 1.75203C14.9096 1.20803 15.3336 0.784029 15.8776 0.480029C16.4056 0.160029 17.0136 2.86102e-05 17.7016 2.86102e-05H31.2376C31.9256 2.86102e-05 32.5336 0.160029 33.0616 0.480029C33.6056 0.784029 34.0296 1.20803 34.3336 1.75203C34.6536 2.28003 34.8136 2.88803 34.8136 3.57603V3.62403C34.8136 4.31203 34.6536 4.92803 34.3336 5.47203C34.0296 6.00003 33.6056 6.42403 33.0616 6.74403C32.5336 7.04803 31.9256 7.20003 31.2376 7.20003H17.7016C17.0136 7.20003 16.4056 7.04803 15.8776 6.74403C15.3336 6.42403 14.9096 6.00003 14.6056 5.47203C14.2856 4.92803 14.1256 4.31203 14.1256 3.62403V3.57603ZM28.2516 3.57603C28.2516 2.88803 28.4116 2.28003 28.7316 1.75203C29.0356 1.20803 29.4596 0.784029 30.0036 0.480029C30.5316 0.160029 31.1396 2.86102e-05 31.8276 2.86102e-05H45.3636C46.0516 2.86102e-05 46.6596 0.160029 47.1876 0.480029C47.7316 0.784029 48.1556 1.20803 48.4596 1.75203C48.7796 2.28003 48.9396 2.88803 48.9396 3.57603V3.62403C48.9396 4.31203 48.7796 4.92803 48.4596 5.47203C48.1556 6.00003 47.7316 6.42403 47.1876 6.74403C46.6596 7.04803 46.0516 7.20003 45.3636 7.20003H31.8276C31.1396 7.20003 30.5316 7.04803 30.0036 6.74403C29.4596 6.42403 29.0356 6.00003 28.7316 5.47203C28.4116 4.92803 28.2516 4.31203 28.2516 3.62403V3.57603ZM42.3776 3.57603C42.3776 2.88803 42.5376 2.28003 42.8576 1.75203C43.1616 1.20803 43.5856 0.784029 44.1296 0.480029C44.6576 0.160029 45.2656 2.86102e-05 45.9536 2.86102e-05H59.4896C60.1776 2.86102e-05 60.7856 0.160029 61.3136 0.480029C61.8576 0.784029 62.2816 1.20803 62.5856 1.75203C62.9056 2.28003 63.0656 2.88803 63.0656 3.57603V3.62403C63.0656 4.31203 62.9056 4.92803 62.5856 5.47203C62.2816 6.00003 61.8576 6.42403 61.3136 6.74403C60.7856 7.04803 60.1776 7.20003 59.4896 7.20003H45.9536C45.2656 7.20003 44.6576 7.04803 44.1296 6.74403C43.5856 6.42403 43.1616 6.00003 42.8576 5.47203C42.5376 4.92803 42.3776 4.31203 42.3776 3.62403V3.57603ZM56.5036 3.57603C56.5036 2.88803 56.6636 2.28003 56.9836 1.75203C57.2876 1.20803 57.7116 0.784029 58.2556 0.480029C58.7836 0.160029 59.3916 2.86102e-05 60.0796 2.86102e-05H66.9916C67.6796 2.86102e-05 68.2876 0.160029 68.8156 0.480029C69.3596 0.784029 69.7836 1.20803 70.0876 1.75203C70.4076 2.28003 70.5676 2.88803 70.5676 3.57603V3.62403C70.5676 4.31203 70.4076 4.92803 70.0876 5.47203C69.7836 6.00003 69.3596 6.42403 68.8156 6.74403C68.2876 7.04803 67.6796 7.20003 66.9916 7.20003H60.0796C59.3916 7.20003 58.7836 7.04803 58.2556 6.74403C57.7116 6.42403 57.2876 6.00003 56.9836 5.47203C56.6636 4.92803 56.5036 4.31203 56.5036 3.62403V3.57603ZM64.0203 3.57603C64.0203 2.88803 64.1803 2.28003 64.5003 1.75203C64.8043 1.20803 65.2283 0.784029 65.7723 0.480029C66.3003 0.160029 66.9083 2.86102e-05 67.5963 2.86102e-05H81.1323C81.8203 2.86102e-05 82.4283 0.160029 82.9563 0.480029C83.5003 0.784029 83.9243 1.20803 84.2283 1.75203C84.5483 2.28003 84.7083 2.88803 84.7083 3.57603V3.62403C84.7083 4.31203 84.5483 4.92803 84.2283 5.47203C83.9243 6.00003 83.5003 6.42403 82.9563 6.74403C82.4283 7.04803 81.8203 7.20003 81.1323 7.20003H67.5963C66.9083 7.20003 66.3003 7.04803 65.7723 6.74403C65.2283 6.42403 64.8043 6.00003 64.5003 5.47203C64.1803 4.92803 64.0203 4.31203 64.0203 3.62403V3.57603ZM93.1864 3.57603C93.1864 2.88803 93.3464 2.28003 93.6664 1.75203C93.9704 1.20803 94.3944 0.784029 94.9384 0.480029C95.4664 0.160029 96.0744 2.86102e-05 96.7624 2.86102e-05H110.298C110.986 2.86102e-05 111.594 0.160029 112.122 0.480029C112.666 0.784029 113.09 1.20803 113.394 1.75203C113.714 2.28003 113.874 2.88803 113.874 3.57603V3.62403C113.874 4.31203 113.714 4.92803 113.394 5.47203C113.09 6.00003 112.666 6.42403 112.122 6.74403C111.594 7.04803 110.986 7.20003 110.298 7.20003H96.7624C96.0744 7.20003 95.4664 7.04803 94.9384 6.74403C94.3944 6.42403 93.9704 6.00003 93.6664 5.47203C93.3464 4.92803 93.1864 4.31203 93.1864 3.62403V3.57603ZM107.312 3.57603C107.312 2.88803 107.472 2.28003 107.792 1.75203C108.096 1.20803 108.52 0.784029 109.064 0.480029C109.592 0.160029 110.2 2.86102e-05 110.888 2.86102e-05H117.8C118.488 2.86102e-05 119.096 0.160029 119.624 0.480029C120.168 0.784029 120.592 1.20803 120.896 1.75203C121.216 2.28003 121.376 2.88803 121.376 3.57603V3.62403C121.376 4.31203 121.216 4.92803 120.896 5.47203C120.592 6.00003 120.168 6.42403 119.624 6.74403C119.096 7.04803 118.488 7.20003 117.8 7.20003H110.888C110.2 7.20003 109.592 7.04803 109.064 6.74403C108.52 6.42403 108.096 6.00003 107.792 5.47203C107.472 4.92803 107.312 4.31203 107.312 3.62403V3.57603ZM114.829 3.57603C114.829 2.88803 114.989 2.28003 115.309 1.75203C115.613 1.20803 116.037 0.784029 116.581 0.480029C117.109 0.160029 117.717 2.86102e-05 118.405 2.86102e-05H131.941C132.629 2.86102e-05 133.237 0.160029 133.765 0.480029C134.309 0.784029 134.733 1.20803 135.037 1.75203C135.357 2.28003 135.517 2.88803 135.517 3.57603V3.62403C135.517 4.31203 135.357 4.92803 135.037 5.47203C134.733 6.00003 134.309 6.42403 133.765 6.74403C133.237 7.04803 132.629 7.20003 131.941 7.20003H118.405C117.717 7.20003 117.109 7.04803 116.581 6.74403C116.037 6.42403 115.613 6.00003 115.309 5.47203C114.989 4.92803 114.829 4.31203 114.829 3.62403V3.57603ZM128.955 3.57603C128.955 2.88803 129.115 2.28003 129.435 1.75203C129.739 1.20803 130.163 0.784029 130.707 0.480029C131.235 0.160029 131.843 2.86102e-05 132.531 2.86102e-05H139.443C140.131 2.86102e-05 140.739 0.160029 141.267 0.480029C141.811 0.784029 142.235 1.20803 142.539 1.75203C142.859 2.28003 143.019 2.88803 143.019 3.57603V3.62403C143.019 4.31203 142.859 4.92803 142.539 5.47203C142.235 6.00003 141.811 6.42403 141.267 6.74403C140.739 7.04803 140.131 7.20003 139.443 7.20003H132.531C131.843 7.20003 131.235 7.04803 130.707 6.74403C130.163 6.42403 129.739 6.00003 129.435 5.47203C129.115 4.92803 128.955 4.31203 128.955 3.62403V3.57603ZM136.472 3.57603C136.472 2.88803 136.632 2.28003 136.952 1.75203C137.256 1.20803 137.68 0.784029 138.224 0.480029C138.752 0.160029 139.36 2.86102e-05 140.048 2.86102e-05H153.584C154.272 2.86102e-05 154.88 0.160029 155.408 0.480029C155.952 0.784029 156.376 1.20803 156.68 1.75203C157 2.28003 157.16 2.88803 157.16 3.57603V3.62403C157.16 4.31203 157 4.92803 156.68 5.47203C156.376 6.00003 155.952 6.42403 155.408 6.74403C154.88 7.04803 154.272 7.20003 153.584 7.20003H140.048C139.36 7.20003 138.752 7.04803 138.224 6.74403C137.68 6.42403 137.256 6.00003 136.952 5.47203C136.632 4.92803 136.472 4.31203 136.472 3.62403V3.57603ZM150.598 3.57603C150.598 2.88803 150.758 2.28003 151.078 1.75203C151.382 1.20803 151.806 0.784029 152.35 0.480029C152.878 0.160029 153.486 2.86102e-05 154.174 2.86102e-05H167.71C168.398 2.86102e-05 169.006 0.160029 169.534 0.480029C170.078 0.784029 170.502 1.20803 170.806 1.75203C171.126 2.28003 171.286 2.88803 171.286 3.57603V3.62403C171.286 4.31203 171.126 4.92803 170.806 5.47203C170.502 6.00003 170.078 6.42403 169.534 6.74403C169.006 7.04803 168.398 7.20003 167.71 7.20003H154.174C153.486 7.20003 152.878 7.04803 152.35 6.74403C151.806 6.42403 151.382 6.00003 151.078 5.47203C150.758 4.92803 150.598 4.31203 150.598 3.62403V3.57603ZM164.724 3.57603C164.724 2.88803 164.884 2.28003 165.204 1.75203C165.508 1.20803 165.932 0.784029 166.476 0.480029C167.004 0.160029 167.612 2.86102e-05 168.3 2.86102e-05H175.212C175.9 2.86102e-05 176.508 0.160029 177.036 0.480029C177.58 0.784029 178.004 1.20803 178.308 1.75203C178.628 2.28003 178.788 2.88803 178.788 3.57603V3.62403C178.788 4.31203 178.628 4.92803 178.308 5.47203C178.004 6.00003 177.58 6.42403 177.036 6.74403C176.508 7.04803 175.9 7.20003 175.212 7.20003H168.3C167.612 7.20003 167.004 7.04803 166.476 6.74403C165.932 6.42403 165.508 6.00003 165.204 5.47203C164.884 4.92803 164.724 4.31203 164.724 3.62403V3.57603Z",
        fill: "#EEEEEE"
    }));
};
var $6aafd33e8bbc47ef$var$Image3 = function Image3() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: "70",
        height: "30",
        viewBox: "0 0 70 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "29",
        height: "29",
        rx: "4.5",
        stroke: "black",
        strokeOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "40.5",
        y: "0.5",
        width: "29",
        height: "29",
        rx: "4.5",
        stroke: "black",
        strokeOpacity: "0.2"
    }));
};
var $6aafd33e8bbc47ef$var$Image4 = function Image4() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: "988",
        height: "26",
        viewBox: "0 0 988 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "150",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "300",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#669DF1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "414",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "564",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "714",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "864",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "39",
        y: "7",
        width: "85",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "189",
        y: "7",
        width: "85",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "339",
        y: "7",
        width: "51",
        height: "12",
        rx: "5",
        fill: "#E9F2FE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "453",
        y: "7",
        width: "85",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "603",
        y: "7",
        width: "85",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "753",
        y: "7",
        width: "85",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "903",
        y: "7",
        width: "85",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }));
};

});

parcelRegister("2X49D", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $2264506f846d5711$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $eS3uG = parcelRequire("eS3uG");

var $h9WhW = parcelRequire("h9WhW");
var $2264506f846d5711$var$styles = {
    borderRight: "_hr4je4h9 _1apgnqa1 _mowc14ap"
};
var $2264506f846d5711$export$1a35787d6353cf6a = function SideNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9WhW.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eS3uG.default), {
        xcss: $2264506f846d5711$var$styles.borderRight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($2264506f846d5711$var$Illustration, {
        alt: ""
    })));
};
var $2264506f846d5711$var$Illustration = function Illustration(_) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: "262",
        height: "748",
        viewBox: "0 0 262 748",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "27",
        y: "26",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "27",
        y: "80",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "27",
        y: "134",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "27",
        y: "188",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "27",
        y: "242",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "27",
        y: "296",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "27",
        y: "386",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "27",
        y: "439",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "27",
        y: "492",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "27",
        y: "545",
        width: "26",
        height: "26",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "66",
        y: "33",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "66",
        y: "87",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "66",
        y: "141",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "66",
        y: "195",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "66",
        y: "249",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "66",
        y: "303",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "66",
        y: "393",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "66",
        y: "446",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "66",
        y: "499",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "66",
        y: "552",
        width: "168",
        height: "12",
        rx: "5",
        fill: "#EEEEEE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "63",
        y: "336",
        width: "176",
        height: "35",
        rx: "5",
        fill: "#E9F2FE"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: "71",
        y: "344",
        width: "18",
        height: "18",
        rx: "5",
        fill: "#669DF1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M94.6 354.864C94.6 354.405 94.7067 354 94.92 353.648C95.1227 353.285 95.4053 353.003 95.768 352.8C96.12 352.587 96.5253 352.48 96.984 352.48H106.008C106.467 352.48 106.872 352.587 107.224 352.8C107.587 353.003 107.869 353.285 108.072 353.648C108.285 354 108.392 354.405 108.392 354.864V354.896C108.392 355.355 108.285 355.765 108.072 356.128C107.869 356.48 107.587 356.763 107.224 356.976C106.872 357.179 106.467 357.28 106.008 357.28H96.984C96.5253 357.28 96.12 357.179 95.768 356.976C95.4053 356.763 95.1227 356.48 94.92 356.128C94.7067 355.765 94.6 355.355 94.6 354.896V354.864ZM104.234 354.864C104.234 354.405 104.34 354 104.554 353.648C104.756 353.285 105.039 353.003 105.402 352.8C105.754 352.587 106.159 352.48 106.618 352.48H115.642C116.1 352.48 116.506 352.587 116.858 352.8C117.22 353.003 117.503 353.285 117.706 353.648C117.919 354 118.026 354.405 118.026 354.864V354.896C118.026 355.355 117.919 355.765 117.706 356.128C117.503 356.48 117.22 356.763 116.858 356.976C116.506 357.179 116.1 357.28 115.642 357.28H106.618C106.159 357.28 105.754 357.179 105.402 356.976C105.039 356.763 104.756 356.48 104.554 356.128C104.34 355.765 104.234 355.355 104.234 354.896V354.864ZM113.868 354.864C113.868 354.405 113.974 354 114.188 353.648C114.39 353.285 114.673 353.003 115.036 352.8C115.388 352.587 115.793 352.48 116.252 352.48H125.276C125.734 352.48 126.14 352.587 126.492 352.8C126.854 353.003 127.137 353.285 127.34 353.648C127.553 354 127.66 354.405 127.66 354.864V354.896C127.66 355.355 127.553 355.765 127.34 356.128C127.137 356.48 126.854 356.763 126.492 356.976C126.14 357.179 125.734 357.28 125.276 357.28H116.252C115.793 357.28 115.388 357.179 115.036 356.976C114.673 356.763 114.39 356.48 114.188 356.128C113.974 355.765 113.868 355.355 113.868 354.896V354.864ZM123.501 354.864C123.501 354.405 123.608 354 123.821 353.648C124.024 353.285 124.307 353.003 124.669 352.8C125.021 352.587 125.427 352.48 125.885 352.48H134.909C135.368 352.48 135.773 352.587 136.125 352.8C136.488 353.003 136.771 353.285 136.973 353.648C137.187 354 137.293 354.405 137.293 354.864V354.896C137.293 355.355 137.187 355.765 136.973 356.128C136.771 356.48 136.488 356.763 136.125 356.976C135.773 357.179 135.368 357.28 134.909 357.28H125.885C125.427 357.28 125.021 357.179 124.669 356.976C124.307 356.763 124.024 356.48 123.821 356.128C123.608 355.765 123.501 355.355 123.501 354.896V354.864ZM133.135 354.864C133.135 354.405 133.242 354 133.455 353.648C133.658 353.285 133.941 353.003 134.303 352.8C134.655 352.587 135.061 352.48 135.519 352.48H140.127C140.586 352.48 140.991 352.587 141.343 352.8C141.706 353.003 141.989 353.285 142.191 353.648C142.405 354 142.511 354.405 142.511 354.864V354.896C142.511 355.355 142.405 355.765 142.191 356.128C141.989 356.48 141.706 356.763 141.343 356.976C140.991 357.179 140.586 357.28 140.127 357.28H135.519C135.061 357.28 134.655 357.179 134.303 356.976C133.941 356.763 133.658 356.48 133.455 356.128C133.242 355.765 133.135 355.355 133.135 354.896V354.864ZM138.363 354.864C138.363 354.405 138.47 354 138.683 353.648C138.886 353.285 139.168 353.003 139.531 352.8C139.883 352.587 140.288 352.48 140.747 352.48H149.771C150.23 352.48 150.635 352.587 150.987 352.8C151.35 353.003 151.632 353.285 151.835 353.648C152.048 354 152.155 354.405 152.155 354.864V354.896C152.155 355.355 152.048 355.765 151.835 356.128C151.632 356.48 151.35 356.763 150.987 356.976C150.635 357.179 150.23 357.28 149.771 357.28H140.747C140.288 357.28 139.883 357.179 139.531 356.976C139.168 356.763 138.886 356.48 138.683 356.128C138.47 355.765 138.363 355.355 138.363 354.896V354.864ZM158.24 354.864C158.24 354.405 158.347 354 158.56 353.648C158.763 353.285 159.045 353.003 159.408 352.8C159.76 352.587 160.165 352.48 160.624 352.48H169.648C170.107 352.48 170.512 352.587 170.864 352.8C171.227 353.003 171.509 353.285 171.712 353.648C171.925 354 172.032 354.405 172.032 354.864V354.896C172.032 355.355 171.925 355.765 171.712 356.128C171.509 356.48 171.227 356.763 170.864 356.976C170.512 357.179 170.107 357.28 169.648 357.28H160.624C160.165 357.28 159.76 357.179 159.408 356.976C159.045 356.763 158.763 356.48 158.56 356.128C158.347 355.765 158.24 355.355 158.24 354.896V354.864ZM167.874 354.864C167.874 354.405 167.98 354 168.194 353.648C168.396 353.285 168.679 353.003 169.042 352.8C169.394 352.587 169.799 352.48 170.258 352.48H174.866C175.324 352.48 175.73 352.587 176.082 352.8C176.444 353.003 176.727 353.285 176.93 353.648C177.143 354 177.25 354.405 177.25 354.864V354.896C177.25 355.355 177.143 355.765 176.93 356.128C176.727 356.48 176.444 356.763 176.082 356.976C175.73 357.179 175.324 357.28 174.866 357.28H170.258C169.799 357.28 169.394 357.179 169.042 356.976C168.679 356.763 168.396 356.48 168.194 356.128C167.98 355.765 167.874 355.355 167.874 354.896V354.864ZM173.101 354.864C173.101 354.405 173.208 354 173.421 353.648C173.624 353.285 173.907 353.003 174.269 352.8C174.621 352.587 175.027 352.48 175.485 352.48H184.509C184.968 352.48 185.373 352.587 185.725 352.8C186.088 353.003 186.371 353.285 186.573 353.648C186.787 354 186.893 354.405 186.893 354.864V354.896C186.893 355.355 186.787 355.765 186.573 356.128C186.371 356.48 186.088 356.763 185.725 356.976C185.373 357.179 184.968 357.28 184.509 357.28H175.485C175.027 357.28 174.621 357.179 174.269 356.976C173.907 356.763 173.624 356.48 173.421 356.128C173.208 355.765 173.101 355.355 173.101 354.896V354.864ZM182.735 354.864C182.735 354.405 182.842 354 183.055 353.648C183.258 353.285 183.54 353.003 183.903 352.8C184.255 352.587 184.66 352.48 185.119 352.48H189.727C190.186 352.48 190.591 352.587 190.943 352.8C191.306 353.003 191.588 353.285 191.791 353.648C192.004 354 192.111 354.405 192.111 354.864V354.896C192.111 355.355 192.004 355.765 191.791 356.128C191.588 356.48 191.306 356.763 190.943 356.976C190.591 357.179 190.186 357.28 189.727 357.28H185.119C184.66 357.28 184.255 357.179 183.903 356.976C183.54 356.763 183.258 356.48 183.055 356.128C182.842 355.765 182.735 355.355 182.735 354.896V354.864ZM187.963 354.864C187.963 354.405 188.069 354 188.283 353.648C188.485 353.285 188.768 353.003 189.131 352.8C189.483 352.587 189.888 352.48 190.347 352.48H199.371C199.829 352.48 200.235 352.587 200.587 352.8C200.949 353.003 201.232 353.285 201.435 353.648C201.648 354 201.755 354.405 201.755 354.864V354.896C201.755 355.355 201.648 355.765 201.435 356.128C201.232 356.48 200.949 356.763 200.587 356.976C200.235 357.179 199.829 357.28 199.371 357.28H190.347C189.888 357.28 189.483 357.179 189.131 356.976C188.768 356.763 188.485 356.48 188.283 356.128C188.069 355.765 187.963 355.355 187.963 354.896V354.864ZM197.596 354.864C197.596 354.405 197.703 354 197.916 353.648C198.119 353.285 198.402 353.003 198.764 352.8C199.116 352.587 199.522 352.48 199.98 352.48H209.004C209.463 352.48 209.868 352.587 210.22 352.8C210.583 353.003 210.866 353.285 211.068 353.648C211.282 354 211.388 354.405 211.388 354.864V354.896C211.388 355.355 211.282 355.765 211.068 356.128C210.866 356.48 210.583 356.763 210.22 356.976C209.868 357.179 209.463 357.28 209.004 357.28H199.98C199.522 357.28 199.116 357.179 198.764 356.976C198.402 356.763 198.119 356.48 197.916 356.128C197.703 355.765 197.596 355.355 197.596 354.896V354.864ZM207.23 354.864C207.23 354.405 207.337 354 207.55 353.648C207.753 353.285 208.036 353.003 208.398 352.8C208.75 352.587 209.156 352.48 209.614 352.48H214.222C214.681 352.48 215.086 352.587 215.438 352.8C215.801 353.003 216.084 353.285 216.286 353.648C216.5 354 216.606 354.405 216.606 354.864V354.896C216.606 355.355 216.5 355.765 216.286 356.128C216.084 356.48 215.801 356.763 215.438 356.976C215.086 357.179 214.681 357.28 214.222 357.28H209.614C209.156 357.28 208.75 357.179 208.398 356.976C208.036 356.763 207.753 356.48 207.55 356.128C207.337 355.765 207.23 355.355 207.23 354.896V354.864Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("filter", {
        id: "filter0_d_8258_51034",
        x: "0",
        y: "0",
        width: "262",
        height: "828",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feOffset", {
        dx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_8258_51034"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_8258_51034",
        result: "shape"
    }))));
};

});

parcelRegister("2gU06", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $1a7883fa595d9300$export$2dc68d50d56fbbd; });

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $1a7883fa595d9300$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($1a7883fa595d9300$var$Illustration, null));
};
var $1a7883fa595d9300$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 167,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#8590A2",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }));
};

});

parcelRegister("hwIVJ", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $cc28470404607b6e$export$7c6e2c02157bb7d2; });

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $cc28470404607b6e$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($cc28470404607b6e$var$Illustration, null));
};
var $cc28470404607b6e$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: 640,
        height: 427,
        viewBox: "0 0 640 427",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 640,
        height: 20,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        y: 40,
        width: 60,
        height: 32,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 8,
        y: 53,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 68,
        y: 40,
        width: 99,
        height: 32,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 76,
        y: 53,
        width: 59,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(138 44)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M146.292 54.2929C146.105 54.4818 146 54.7368 146 55.0024C146 55.2681 146.105 55.523 146.292 55.7119L149.231 58.6769C149.449 58.8919 149.731 58.9989 150.01 58.9989C150.289 58.9989 150.566 58.8919 150.779 58.6769L153.709 55.7219C153.895 55.5329 154 55.278 154 55.0124C154 54.7469 153.895 54.492 153.709 54.3029C153.617 54.2098 153.507 54.1358 153.387 54.0853C153.266 54.0347 153.136 54.0087 153.006 54.0087C152.875 54.0087 152.745 54.0347 152.625 54.0853C152.504 54.1358 152.394 54.2098 152.303 54.3029L150.005 56.6199L147.698 54.2929C147.606 54.2001 147.496 54.1264 147.375 54.0762C147.255 54.0259 147.125 54 146.995 54C146.864 54 146.734 54.0259 146.614 54.0762C146.493 54.1264 146.384 54.2001 146.292 54.2929Z",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        y: 92,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        y: 120,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        y: 148,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        y: 200,
        width: 180,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 4,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 60,
        y: 232,
        width: 85,
        height: 20,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 64,
        y: 239,
        width: 77,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 153,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 157,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 213,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 217,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 14,
        y: 282,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 27,
        cy: 295,
        r: 12,
        fill: "url(#pattern0_233_6340)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 46,
        y: 279,
        width: 591,
        height: 40,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 54,
        y: 295,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 44.2764,
        y: 385,
        width: 425.66,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 44.2764,
        y: 403,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 44.2764,
        y: 421,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 44,
        y: 356,
        width: 119,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 10,
        y: 346,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 23,
        cy: 359,
        r: 12,
        fill: "url(#pattern1_233_6340)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("pattern", {
        id: "pattern0_233_6340",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("use", {
        xlinkHref: "#image0_233_6340",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("pattern", {
        id: "pattern1_233_6340",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("use", {
        xlinkHref: "#image1_233_6340",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("image", {
        id: "image0_233_6340",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAwYCBAUACAf/xAAuEAACAQMCBAQGAgMAAAAAAAABAgMABAUGERITITEHQVFhFCJCcYGRMuFiobH/xAAXAQEBAQEAAAAAAAAAAAAAAAAGBwUE/8QAKREAAQMDAgQGAwAAAAAAAAAAAgEDEQAEEgVBBiExURMUInGB8JGx0f/aAAwDAQACEQMRAD8ASqjI6xozuwVFG5J7AVKlzWN0UghtkO3MPE32HYfv/lWK9uUtWCeXb91PrZlX3EbTeoXmqArlbOEMo+uQ7b/ioW2qX4wLq3Xg9Yz1H4NYWNsbrJ5C3sbCB57u4cRxRIN2ZjVrUuEvdOZy7xOUi5d3bPwsPJh5Mp81I6g0IXW7xTnP4hIpMmmW+EY/NO9tcRXUCywOHjbsRRaT9IXTR3z2xPySqSB/kP6pwplp155xhHYhei+9HLy38u6obbV1A0Tp4as8UbS0vbZp8VDKi3Q3IUJwkhSR1HEw26Uesu3z2R0dqqHK4925EskUk0X0y8tgeE/72+5rN4lBwrP0bL/a7NFIBufX2r1tpvR2ndNMz4LD2dlKw2aSNN3I9OI7nb80bUGl8HqJUGcxNnfFBsjTRAso9A3cfurGn8zY6gw1rlMVMJrO5QOjDuPVT6EHoR6irl1cQ2ltLcXUqQwRKXkkc7Kigbkk+QqVqpZSvWqCgjjy6V5R8btI22kddY+4wdktriZ0iAWMnhWXdgy9Tv1A3/dUfOh651bca913PNA8gwlvMHt4yNhwoOEOfdup28t6JVN4VbcG2JT3WgmvGBPogdq6g3VrFewmCZONW8vPf296MASQB1Jp1xOKhso1dlDXBHVj9J9BW/cuAAQaTO1ZDQkpSKxFNfgBgMlp7Tt/zpX+FurkSwROOoAXZiR7nb9VreNmFympdES2ljMUCTJNNGvTmRrvuO/XqQdj6VgYrMX2LLfBTlFbqyEBlP4NFyueyOUj5d3PvF35aKFU/fbvU+c0NwrzxhjCZjn07fVpeGsNpa+EqLlETy/P1K+N2eOjxkZt442Rgfn4v5E+9WKe8jjoL+MiRQJNvlcdx/VIsiFHZG6MpIP3p/aOAQYAkRtRF4SyyJZmv//Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("image", {
        id: "image1_233_6340",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABAADBQYHAQL/xAApEAABAwMDAwQCAwAAAAAAAAABAgMEAAUREiFBBlFxBzFCYROBkdHh/8QAFwEBAQEBAAAAAAAAAAAAAAAABgcEBf/EACkRAAEDAwIFAwUAAAAAAAAAAAECAxEABCEFEgYxUXGRIjLRQaHB4fD/2gAMAwEAAhEDEQA/AH6VKirXCXcJzUds4KjursOTTRa0tpK1GAKizTS3lpbbEqJgdzQoBJwASfquqSUnCgQfsVp9ut0a3tBEZoA8rIypXk07LiMTGi3JaS4k9xuPB4o2eJUb4DZ29Zz4/dO08BulqVPAL6RjzP4rKqVSV/thtc4tglTSxqbUe3Y/YqNpGy6l5AcQZBoPc2zlq6pl0QpJg0qs3QjeZ8hzAwlvT/J/yqzRMCfJt7inIa0pWRjChkHyKz6gwt+3W03zNbdFumrO+bfe9qT9O3zWp0qpULrV+54j2qzuv3FIy60t1KUIA98H3O/1XuR1m9anvxdQ2h6GtadTQacS7qHY+2Kn5tHQdsZ6SJ8VbhdNEbgcdcx5ojr1GY8RzHspSc+QP6qm0dc7vKuykrkANoGShofAHgnk/dA070q3Xb2qW3OfzmozxFeNXuoOPM8sDvAie2KVMyX0x2itW/AA5p6oqfAdWsuNrLmfio7jxW9ZIGK47SUqV6jFWprpJi8QIlwizFRZimxqWydSc/ogg42O9e4/RsS3OG4Xq5KfLe4U5skHjJJJOO1A+mocavT6XVuNthknQThKjkDcc131LbccvEb8LjjqFM50A5SggkbDjNFF2dyq5LZUdpzMfaqa1rVo3p6XEoG9MJiegif7zUew8h9GtB2zinaioEB1Cw44st4+KTufNStK0EkZqZupSFek1//Z"
    })));
};

});

parcelRegister("kJ0Sl", function(module, exports) {

$parcel$export(module.exports, "DetailsPanel", function () { return $f168b07d7e485edd$export$e54a7f2505304e20; });
/* details-panel.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $f168b07d7e485edd$var$styles = {
    wrapper: "_kqsw1n9t _1xi2ze3t _19bvutpp _u5f3xy5q"
};
var $f168b07d7e485edd$export$e54a7f2505304e20 = function DetailsPanel() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $f168b07d7e485edd$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($f168b07d7e485edd$var$Illustration, null));
};
var $f168b07d7e485edd$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        width: 328,
        height: 597,
        viewBox: "0 0 328 597",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 80,
        height: 32,
        rx: 3,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 17,
        y: 13,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#85B8FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M0 52C0 47.5817 3.58172 44 8 44H320C324.418 44 328 47.5817 328 52V597H0V52Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M0.5 52C0.5 47.8579 3.85786 44.5 8 44.5H320C324.142 44.5 327.5 47.8579 327.5 52V596.5H0.5V52Z",
        stroke: "#091E42",
        strokeOpacity: 0.06
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 77,
        width: 253,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(280 68)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M288.292 78.2929C288.105 78.4818 288 78.7368 288 79.0024C288 79.2681 288.105 79.523 288.292 79.7119L291.231 82.6769C291.449 82.8919 291.731 82.9989 292.01 82.9989C292.289 82.9989 292.566 82.8919 292.779 82.6769L295.709 79.7219C295.895 79.5329 296 79.278 296 79.0124C296 78.7469 295.895 78.492 295.709 78.3029C295.617 78.2098 295.507 78.1358 295.387 78.0853C295.266 78.0347 295.136 78.0087 295.006 78.0087C294.875 78.0087 294.745 78.0347 294.625 78.0853C294.504 78.1358 294.394 78.2098 294.303 78.3029L292.005 80.6199L289.698 78.2929C289.606 78.2001 289.496 78.1264 289.375 78.0762C289.255 78.0259 289.125 78 288.995 78C288.864 78 288.734 78.0259 288.614 78.0762C288.493 78.1264 288.384 78.2001 288.292 78.2929Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 121,
        width: 79,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 159,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 197,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 235,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 273,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 311,
        width: 110,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 349,
        width: 100,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 387,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 425,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 24,
        y: 463,
        width: 95,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(178 112)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M190.522 131.853L190.625 131.781L195.625 127.781C196.056 127.436 196.126 126.807 195.781 126.375C195.462 125.977 194.902 125.887 194.478 126.147L194.375 126.219L190 129.72L185.625 126.219C185.227 125.901 184.66 125.936 184.304 126.282L184.219 126.375C183.901 126.773 183.936 127.34 184.282 127.696L184.375 127.781L189.375 131.781C189.707 132.046 190.166 132.071 190.522 131.853Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M190.522 126.853L190.625 126.781L195.625 122.781C196.056 122.436 196.126 121.807 195.781 121.375C195.462 120.977 194.902 120.887 194.478 121.147L194.375 121.219L190 124.72L185.625 121.219C185.227 120.901 184.66 120.936 184.304 121.282L184.219 121.375C183.901 121.773 183.936 122.34 184.282 122.696L184.375 122.781L189.375 126.781C189.707 127.046 190.166 127.071 190.522 126.853Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        d: "M190.522 121.853L190.625 121.781L195.625 117.781C196.056 117.436 196.126 116.807 195.781 116.375C195.462 115.977 194.902 115.887 194.478 116.147L194.375 116.219L190 119.72L185.625 116.219C185.227 115.901 184.66 115.936 184.304 116.282L184.219 116.375C183.901 116.773 183.936 117.34 184.282 117.696L184.375 117.781L189.375 121.781C189.707 122.046 190.166 122.071 190.522 121.853Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 210,
        y: 121,
        width: 66,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 159,
        width: 98,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 188,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 182,
        y: 195,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        opacity: 0.8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 177,
        y: 230,
        width: 18,
        height: 18,
        rx: 9,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("circle", {
        cx: 186,
        cy: 239,
        r: 8,
        fill: "url(#pattern0_233_6342)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 202,
        y: 236,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 273,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 311,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 349,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 387,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 425,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        x: 178,
        y: 463,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("pattern", {
        id: "pattern0_233_6342",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("use", {
        xlinkHref: "#image0_233_6342",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("image", {
        id: "image0_233_6342",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    })));
};

});

parcelRegister("32KEc", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $2375be38faca8544$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");

var $h9WhW = parcelRequire("h9WhW");
var $2375be38faca8544$var$styles = {
    background: "_1s7zia51 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $2375be38faca8544$export$1a35787d6353cf6a = function SideNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9WhW.AboveMediumScreen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        xcss: $2375be38faca8544$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($2375be38faca8544$var$Illustration, null)));
};
var $2375be38faca8544$var$Illustration = function Illustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 296,
        height: 473,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M265.25 151.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 150.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M285.5 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 72,
        height: 9,
        x: 20,
        y: 189,
        fill: "#B3B9C4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 278,
        height: 43,
        x: 18,
        y: 215,
        fill: "#E9F2FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 220.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 224,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#1868DB",
        d: "M18 229h2.66v15.96H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 232.5,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M259.25 237.25v4.25h1.5v-4.25H265v-1.5h-4.25v-4.25h-1.5v4.25H255v1.5h4.25ZM279.25 236.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M279.5 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM284.25 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM289 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 263.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 267,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 275.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 306.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 310,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 318.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M20 349.5h32v32H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M39 360.5H25V359h14v1.5Zm0 5.25H25v-1.5h14v1.5ZM32 371h-7v-1.5h7v1.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 64,
        y: 361.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 392.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 396.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 404.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 408.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 435.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M9.667 451.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 451a1.667 1.667 0 1 1 3.335 0A1.667 1.667 0 0 1 8 451Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 451a1.667 1.667 0 1 1 3.335 0 1.667 1.667 0 0 1-3.335 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 451A1.667 1.667 0 1 1 24 451a1.667 1.667 0 0 1-3.334 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M10 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 451a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 447.5,
        fill: "#DCDFE4",
        rx: 3.99
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("path", {
        fill: "#fff",
        d: "M0 0h296v473H0z"
    }))));
};

});




parcelRegister("kEvck", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d27c1f785a75d5e7$export$2e2bcd8739ae039; });

var $8JiHl = parcelRequire("8JiHl");

var $gbAXx = parcelRequire("gbAXx");

var $hZQpa = parcelRequire("hZQpa");

var $4M4Zx = parcelRequire("4M4Zx");
const $d27c1f785a75d5e7$export$29decb186c8152a6 = (0, $4M4Zx.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($8JiHl))), (0, (/*@__PURE__*/$parcel$interopDefault($gbAXx))));
const $d27c1f785a75d5e7$var$OpsgenieCobranding = {
    background: $d27c1f785a75d5e7$export$29decb186c8152a6,
    logo: {
        component: (0, $hZQpa.OpsgenieLogo)
    },
    footerProducts: 'Opsgenie, Jira, Confluence'
};
var $d27c1f785a75d5e7$export$2e2bcd8739ae039 = $d27c1f785a75d5e7$var$OpsgenieCobranding;

});
parcelRegister("8JiHl", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "opsgenie-left.24f4de51.svg";

});

parcelRegister("gbAXx", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "opsgenie-right.1d06aa5c.svg";

});


parcelRegister("l63uI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e08cb4250462cebf$export$2e2bcd8739ae039; });

var $4pmQF = parcelRequire("4pmQF");

var $jrQ1O = parcelRequire("jrQ1O");

var $hZQpa = parcelRequire("hZQpa");

var $4M4Zx = parcelRequire("4M4Zx");
const $e08cb4250462cebf$export$f35613b2e8bb1b7f = (0, $4M4Zx.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($4pmQF))), (0, (/*@__PURE__*/$parcel$interopDefault($jrQ1O))));
const $e08cb4250462cebf$var$StatuspageCobranding = {
    background: $e08cb4250462cebf$export$f35613b2e8bb1b7f,
    logo: {
        component: (0, $hZQpa.StatuspageLogo)
    },
    footerProducts: 'Statuspage, Jira, Confluence'
};
var $e08cb4250462cebf$export$2e2bcd8739ae039 = $e08cb4250462cebf$var$StatuspageCobranding;

});
parcelRegister("4pmQF", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "statuspage-left.a78d710b.svg";

});

parcelRegister("jrQ1O", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "statuspage-right.afc5eca0.svg";

});


parcelRegister("2sa3K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ff7117733f0b1ed$export$2e2bcd8739ae039; });

var $aXZCy = parcelRequire("aXZCy");

var $7WniX = parcelRequire("7WniX");

var $hZQpa = parcelRequire("hZQpa");

var $4M4Zx = parcelRequire("4M4Zx");
const $5ff7117733f0b1ed$export$7995c4de8f2b3003 = (0, $4M4Zx.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($aXZCy))), (0, (/*@__PURE__*/$parcel$interopDefault($7WniX))));
const $5ff7117733f0b1ed$var$TrelloCobranding = {
    background: $5ff7117733f0b1ed$export$7995c4de8f2b3003,
    logo: {
        component: (0, $hZQpa.TrelloLogo)
    },
    footerProducts: 'Trello, Jira, Confluence'
};
var $5ff7117733f0b1ed$export$2e2bcd8739ae039 = $5ff7117733f0b1ed$var$TrelloCobranding;

});
parcelRegister("aXZCy", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "trello-left.fd2ac4a6.svg";

});

parcelRegister("7WniX", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "trello-right.8236b2f3.svg";

});


parcelRegister("60pxs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69c939b99647da66$export$2e2bcd8739ae039; });

var $723m6 = parcelRequire("723m6");

var $gzyGJ = parcelRequire("gzyGJ");

var $4M4Zx = parcelRequire("4M4Zx");
const $69c939b99647da66$export$911a80ac761af24c = (0, $4M4Zx.backgroundWithImage)((0, (/*@__PURE__*/$parcel$interopDefault($gzyGJ))));
const $69c939b99647da66$var$WacCobranding = {
    background: $69c939b99647da66$export$911a80ac761af24c,
    logo: {
        component: (0, $723m6.AtlassianLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $69c939b99647da66$export$2e2bcd8739ae039 = $69c939b99647da66$var$WacCobranding;

});
parcelRegister("gzyGJ", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "wac.d0cc6ec7.svg";

});


parcelRegister("akcow", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23d59c1c17945b89$export$2e2bcd8739ae039; });

var $pCpQH = parcelRequire("pCpQH");

var $bvi9r = parcelRequire("bvi9r");

var $hZQpa = parcelRequire("hZQpa");

var $4M4Zx = parcelRequire("4M4Zx");
const $23d59c1c17945b89$export$14ae77d7d7e2d26f = (0, $4M4Zx.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($pCpQH))), (0, (/*@__PURE__*/$parcel$interopDefault($bvi9r))));
const $23d59c1c17945b89$var$AtlasCobranding = {
    background: $23d59c1c17945b89$export$14ae77d7d7e2d26f,
    logo: {
        component: (0, $hZQpa.HomeLogo)
    },
    footerProducts: 'Trello, Jira, Confluence'
};
var $23d59c1c17945b89$export$2e2bcd8739ae039 = $23d59c1c17945b89$var$AtlasCobranding;

});

parcelRegister("3ltyG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4f535a4514baf13$export$2e2bcd8739ae039; });

var $hZQpa = parcelRequire("hZQpa");

var $4M4Zx = parcelRequire("4M4Zx");

var $fbSBq = parcelRequire("fbSBq");
const $e4f535a4514baf13$export$4fcb21def34701d = (0, $fbSBq.default)((0, $4M4Zx.DefaultBackground))`
  background-color: #fff;
`;
const $e4f535a4514baf13$var$LoomCobranding = {
    background: $e4f535a4514baf13$export$4fcb21def34701d,
    logo: {
        component: (0, $hZQpa.LoomLogo)
    },
    footerProducts: 'Loom, Confluence, Jira'
};
var $e4f535a4514baf13$export$2e2bcd8739ae039 = $e4f535a4514baf13$var$LoomCobranding;

});

parcelRegister("8njUs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70212e35d352be59$export$2e2bcd8739ae039; });

var $hZQpa = parcelRequire("hZQpa");

var $4M4Zx = parcelRequire("4M4Zx");

var $fbSBq = parcelRequire("fbSBq");
const $70212e35d352be59$export$69d75365d6a52225 = (0, $fbSBq.default)((0, $4M4Zx.DefaultBackground))`
  background-color: #fff;
`;
const $70212e35d352be59$var$JiraAlignCobranding = {
    background: $70212e35d352be59$export$69d75365d6a52225,
    logo: {
        component: (0, $hZQpa.JiraAlignLogo)
    },
    footerProducts: 'Jira Align, Confluence, Jira'
};
var $70212e35d352be59$export$2e2bcd8739ae039 = $70212e35d352be59$var$JiraAlignCobranding;

});

parcelRegister("efbp7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57fd34d4e16debcb$export$2e2bcd8739ae039; });

var $hZQpa = parcelRequire("hZQpa");

var $aool1 = parcelRequire("aool1");
const $57fd34d4e16debcb$var$AdminExperimentForJira = {
    background: (0, $aool1.JiraBackground),
    logo: {
        component: (0, $hZQpa.JiraLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $57fd34d4e16debcb$export$2e2bcd8739ae039 = $57fd34d4e16debcb$var$AdminExperimentForJira;

});

parcelRegister("9P5Ni", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f029d291074fe200$export$2e2bcd8739ae039; });

var $hZQpa = parcelRequire("hZQpa");

var $hM3sg = parcelRequire("hM3sg");
const $f029d291074fe200$var$AdminExperimentForConfluence = {
    background: (0, $hM3sg.ConfluenceBackground),
    logo: {
        component: (0, $hZQpa.ConfluenceLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $f029d291074fe200$export$2e2bcd8739ae039 = $f029d291074fe200$var$AdminExperimentForConfluence;

});

parcelRegister("br6ws", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52256d3f146fad11$export$2e2bcd8739ae039; });

var $hZQpa = parcelRequire("hZQpa");

var $hM3sg = parcelRequire("hM3sg");
const $52256d3f146fad11$var$RovoCobranding = {
    background: (0, $hM3sg.ConfluenceBackground),
    logo: {
        component: (0, $hZQpa.RovoLogo)
    },
    footerProducts: 'Confluence, Jira, Trello'
};
var $52256d3f146fad11$export$2e2bcd8739ae039 = $52256d3f146fad11$var$RovoCobranding;

});


parcelRegister("1u5P2", function(module, exports) {

$parcel$export(module.exports, "ProductHeading", function () { return $db114c22845490b7$export$bb672d3ab4980938; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");
const $db114c22845490b7$export$6fe455b424bdaa07 = (0, $fbSBq.default).div`
  display: flex;
  flex-direction: column;
  padding-top: ${(0, $68HQw.gridSize)() * 3}px;
  align-items: center;

  h5 {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: ${(0, $l4KzN).N800};
  }
`;
const $db114c22845490b7$var$ProductHeadingWrapper = (0, $fbSBq.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: ${(0, $68HQw.gridSize)() * 2}px;
`;
const $db114c22845490b7$export$bb672d3ab4980938 = ({ suffix: suffix, children: children })=>{
    return /*#__PURE__*/ (0, $6CtE1.jsxs)($db114c22845490b7$var$ProductHeadingWrapper, {
        "data-testid": "header",
        id: "ProductHeading",
        children: [
            children,
            /*#__PURE__*/ (0, $6CtE1.jsx)($db114c22845490b7$export$6fe455b424bdaa07, {
                "data-testid": "header-suffix",
                id: "ProductHeadingSuffix",
                children: suffix
            })
        ]
    });
};

});

parcelRegister("dwGfa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0297325303ee77b$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $j0VD5 = parcelRequire("j0VD5");

var $3YSXY = parcelRequire("3YSXY");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $723m6 = parcelRequire("723m6");

var $4M4Zx = parcelRequire("4M4Zx");

var $5pCRv = parcelRequire("5pCRv");

var $4NPio = parcelRequire("4NPio");
const $e0297325303ee77b$var$PageFooter = (0, $fbSBq.default).div`
  background: transparent;
  display: flex;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  flex-direction: column;
  margin: 0 auto;
  border-top: 1px solid ${(0, $l4KzN).N50};
  padding-top: ${(0, $68HQw.gridSize)() * 3}px;
  font-size: 11px;
  color: ${(props)=>props.footerMessageTextColor};
  ${(props)=>(0, $4M4Zx.linkStyles)(props.textColor)}
  ${(0, $4M4Zx.listStyles)}

  ${(0, $j0VD5.media).handheld`
     line-height: inherit;
     background-color: transparent;
  `}
`;
const $e0297325303ee77b$var$SubText = (0, $fbSBq.default).div`
  padding-top: ${(0, $68HQw.gridSize)()}px;
`;
const $e0297325303ee77b$var$FooterComponent = ({ renderText: renderText, footerProducts: footerProducts, pageId: pageId })=>{
    const onLinkClicked = (0, $4NPio.useButtonClickedEvent)(pageId, 'learnMoreAtlassianAccount');
    return /*#__PURE__*/ (0, $6CtE1.jsxs)($e0297325303ee77b$var$PageFooter, {
        "data-testid": "page-footer",
        textColor: (0, $l4KzN).B400,
        footerMessageTextColor: (0, $l4KzN).N800,
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $723m6.AtlassianLogo), {
                appearance: "neutral",
                size: "small"
            }),
            renderText && /*#__PURE__*/ (0, $6CtE1.jsx)($e0297325303ee77b$var$SubText, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "footer.cobranding.text",
                    defaultMessage: "One account for {products} and {link}.",
                    description: "{products} is a comma-separated list of products. {link} is a hyperlink that will be filled with a separately translated string: more",
                    values: {
                        products: footerProducts,
                        link: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.LearnMoreAboutAtlassianAccountLink), {
                            onClick: onLinkClicked
                        })
                    }
                })
            })
        ]
    });
};
var $e0297325303ee77b$export$2e2bcd8739ae039 = $e0297325303ee77b$var$FooterComponent;

});
parcelRegister("5pCRv", function(module, exports) {

$parcel$export(module.exports, "SELF_SERVICE_LINK_URL", function () { return $5fa1ee8893e388df$export$86be5cde852cdd25; });
$parcel$export(module.exports, "SelfServiceLink", function () { return $5fa1ee8893e388df$export$a817dad308d44854; });
$parcel$export(module.exports, "SupportLink", function () { return $5fa1ee8893e388df$export$a6b83d54334dba9f; });
$parcel$export(module.exports, "PRIVACY_POLICY_URL_MOBILE", function () { return $5fa1ee8893e388df$export$e6483b6b5710900e; });
$parcel$export(module.exports, "PRIVACY_POLICY_URL", function () { return $5fa1ee8893e388df$export$30786e8ac20c09d8; });
$parcel$export(module.exports, "PrivacyPolicyLink", function () { return $5fa1ee8893e388df$export$fdd773f48aebb8ab; });
$parcel$export(module.exports, "CLOUD_TERMS_OF_SERVICE_URL_MOBILE", function () { return $5fa1ee8893e388df$export$4f1e847a8e64f5b; });
$parcel$export(module.exports, "CLOUD_TERMS_OF_SERVICE_URL", function () { return $5fa1ee8893e388df$export$b6aa5b30b55e4e21; });
$parcel$export(module.exports, "UserNoticeLink", function () { return $5fa1ee8893e388df$export$afb6ca8138b3e5a3; });
$parcel$export(module.exports, "LearnMoreAboutAtlassianAccountLink", function () { return $5fa1ee8893e388df$export$694937257991c79; });
$parcel$export(module.exports, "RequestAccessLink", function () { return $5fa1ee8893e388df$export$5ce617bd6fde7ab8; });
$parcel$export(module.exports, "PASSWORD_LEAKED_LINK", function () { return $5fa1ee8893e388df$export$4b69c758417d5b1b; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $eTWY7 = parcelRequire("eTWY7");

var $e2mzU = parcelRequire("e2mzU");

var $hhYxc = parcelRequire("hhYxc");
const $5fa1ee8893e388df$export$86be5cde852cdd25 = 'https://support.atlassian.com/atlassian-account/docs/troubleshoot-login-issues-with-your-atlassian-account/';
function $5fa1ee8893e388df$export$a817dad308d44854(props) {
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $e2mzU.default), {
        href: $5fa1ee8893e388df$export$86be5cde852cdd25,
        id: "self-service-link",
        target: "_blank",
        rel: "noopener noreferrer",
        // https://mathiasbynens.github.io/rel-noopener
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "resetpassword.self.service",
            defaultMessage: "Login help"
        })
    });
}
const $5fa1ee8893e388df$export$56321425bd50535f = 'https://support.atlassian.com/';
function $5fa1ee8893e388df$export$a6b83d54334dba9f(props) {
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $e2mzU.default), {
        href: $5fa1ee8893e388df$export$56321425bd50535f,
        id: "support-link",
        target: "_blank",
        rel: "noopener noreferrer",
        // https://mathiasbynens.github.io/rel-noopener
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "resetpassword.support",
            defaultMessage: "Contact Support"
        })
    });
}
const $5fa1ee8893e388df$export$e6483b6b5710900e = 'https://www.atlassian.com/legal/privacy-policy/mobile';
const $5fa1ee8893e388df$export$30786e8ac20c09d8 = 'https://www.atlassian.com/legal/privacy-policy';
function $5fa1ee8893e388df$export$fdd773f48aebb8ab(props) {
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const privacyPolicyUrl = props.isMobileLink ? $5fa1ee8893e388df$export$e6483b6b5710900e : $5fa1ee8893e388df$export$30786e8ac20c09d8;
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $e2mzU.default), {
        href: privacyPolicyUrl,
        target: "_blank",
        rel: "noreferrer noopener",
        "aria-label": formatMessage({
            id: 'common.atlassian.privacy.policy.link.aria.label',
            defaultMessage: 'Atlassian Privacy Policy',
            description: "Aria label for link to let users learn more about Atlassian's Privacy Policy."
        }),
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "common.privacy.policy",
            defaultMessage: "Privacy Policy"
        })
    });
}
const $5fa1ee8893e388df$export$4f1e847a8e64f5b = 'https://www.atlassian.com/legal/customer-agreement/mobile';
const $5fa1ee8893e388df$export$b6aa5b30b55e4e21 = 'https://www.atlassian.com/legal/cloud-terms-of-service';
const $5fa1ee8893e388df$export$5e45d5d0eb34696e = 'https://www.atlassian.com/legal/user-notice/mobile';
const $5fa1ee8893e388df$export$b6eec8592d48b4f1 = 'https://www.atlassian.com/legal/user-notice';
function $5fa1ee8893e388df$export$afb6ca8138b3e5a3(props) {
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const userNoticeUrl = props.isMobileLink ? $5fa1ee8893e388df$export$5e45d5d0eb34696e : $5fa1ee8893e388df$export$b6eec8592d48b4f1;
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $e2mzU.default), {
        href: userNoticeUrl,
        target: "_blank",
        rel: "noreferrer noopener",
        "aria-label": formatMessage({
            id: 'common.atlassian.user.notice.link.aria.label',
            defaultMessage: 'Atlassian User Notice',
            description: "Aria label for link to let users learn more about Atlassian's User Notice."
        }),
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "common.user.notice",
            defaultMessage: "User Notice",
            description: "Link that takes users to the Atlassian User Notice"
        })
    });
}
function $5fa1ee8893e388df$export$694937257991c79(props) {
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $e2mzU.default), {
        target: "_blank",
        rel: "noreferrer noopener",
        onClick: props.onClick,
        "aria-label": formatMessage({
            id: 'cobranding.footer.learn.more.about.atlassian.account.link.aria.label',
            defaultMessage: 'Learn more about Atlassian Account',
            description: 'Aria label for short link to let users learn more about what an Atlassian Account is.'
        }),
        href: "https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-account/",
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "cobranding.footer.learn.more.about.atlassian.account.link",
            defaultMessage: "more",
            description: "Short link to let users learn more about using one account for multiple products. e.g. One account for {products} and more."
        })
    });
}
function $5fa1ee8893e388df$export$5ce617bd6fde7ab8(props) {
    const { destUrl: destUrl, applicationDestination: applicationDestination } = props;
    const continueUrl = encodeURIComponent(`https://${applicationDestination.destinationHostname}/login?application=${applicationDestination.applicationName.toLowerCase()}` + '&permission-violation=true' + '&preferred-redirect=request-access' + (destUrl ? `&dest-url=${encodeURIComponent(destUrl)}` : ''));
    const redirectUrl = `${(0, $hhYxc.idacOrigin)}/login?continue=${continueUrl}`;
    const buttonText = /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
        id: "select.account.request.access.to.product",
        defaultMessage: "Request access to {productName}",
        values: {
            productName: applicationDestination.applicationName
        }
    });
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
        id: "redirect-to-request-access",
        href: redirectUrl,
        onClick: props.onClick,
        children: buttonText
    });
}
const $5fa1ee8893e388df$export$4b69c758417d5b1b = 'https://support.atlassian.com/atlassian-account/docs/protect-your-atlassian-account/';

});
parcelRegister("e2mzU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a382c424324e675e$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $kugzw = parcelRequire("kugzw");

var $gQLDR = parcelRequire("gQLDR");

var $97OWz = parcelRequire("97OWz");
var $l69Tm = parcelRequire("l69Tm");
var $a382c424324e675e$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $a382c424324e675e$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $a382c424324e675e$var$iconStyles = null;
var $a382c424324e675e$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $a382c424324e675e$var$_excluded);
    return /*#__PURE__*/ $dNMDr.createElement((0, $97OWz.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $kugzw.cx)($a382c424324e675e$var$styles.base, (0, $gQLDR.fg)('platform-dst-shape-theme-default') && $a382c424324e675e$var$styles.baseT26Shape, appearance === 'default' && $a382c424324e675e$var$styles.defaultAppearance, appearance === 'subtle' && $a382c424324e675e$var$styles.subtleAppearance, appearance === 'inverse' && $a382c424324e675e$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $a382c424324e675e$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $dNMDr.createElement((0, $l69Tm.default), {
        as: "span",
        xcss: $a382c424324e675e$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $dNMDr.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $affTb.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $dNMDr.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $a382c424324e675e$var$Link = /*#__PURE__*/ (0, $dNMDr.forwardRef)($a382c424324e675e$var$LinkWithoutRef);
var $a382c424324e675e$export$2e2bcd8739ae039 = $a382c424324e675e$var$Link;

});
parcelRegister("97OWz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a4c48d6a8cf1d50$export$2e2bcd8739ae039; });
/* anchor.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $a3ftr = parcelRequire("a3ftr");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");


var $icVF1 = parcelRequire("icVF1");

var $3kWa2 = parcelRequire("3kWa2");

var $02D9g = parcelRequire("02D9g");

var $k87WV = parcelRequire("k87WV");

var $c3KQG = parcelRequire("c3KQG");

var $hGahQ = parcelRequire("hGahQ");

var $hMip0 = parcelRequire("hMip0");

var $iRhvt = parcelRequire("iRhvt");

var $aZGMH = parcelRequire("aZGMH");
var $6a4c48d6a8cf1d50$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $6a4c48d6a8cf1d50$var$_excluded2 = [
    "className"
];
var $6a4c48d6a8cf1d50$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $6a4c48d6a8cf1d50$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $6a4c48d6a8cf1d50$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $6a4c48d6a8cf1d50$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $c3KQG.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $6a4c48d6a8cf1d50$var$_excluded);
    var interactionContext = (0, $dNMDr.useContext)((0, $hMip0.default));
    var handleClick = (0, $dNMDr.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $hGahQ.useId)();
    var onClick = (0, $02D9g.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(htmlAttributes, $6a4c48d6a8cf1d50$var$_excluded2);
    var RouterLink = (0, $k87WV.default)();
    var isExternal = typeof href === 'string' && $6a4c48d6a8cf1d50$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $6a4c48d6a8cf1d50$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(href) === 'object';
    (0, $3kWa2.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $dNMDr.createElement((0, $aZGMH.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $icVF1.cx)($6a4c48d6a8cf1d50$var$styles.root, $6a4c48d6a8cf1d50$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $dNMDr.createElement((0, $iRhvt.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $6a4c48d6a8cf1d50$var$Anchor = /*#__PURE__*/ (0, $dNMDr.forwardRef)($6a4c48d6a8cf1d50$var$AnchorNoRef);
var $6a4c48d6a8cf1d50$export$2e2bcd8739ae039 = $6a4c48d6a8cf1d50$var$Anchor;

});
parcelRegister("3kWa2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26e05ae28db8dc8e$export$2e2bcd8739ae039; });
var $26e05ae28db8dc8e$var$isProduction = true;
var $26e05ae28db8dc8e$var$prefix = 'Invariant failed';
function $26e05ae28db8dc8e$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($26e05ae28db8dc8e$var$isProduction) throw new Error($26e05ae28db8dc8e$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($26e05ae28db8dc8e$var$prefix, ": ").concat(provided) : $26e05ae28db8dc8e$var$prefix;
    throw new Error(value);
}

});

parcelRegister("k87WV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea7ab899da227a3b$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $iOto8 = parcelRequire("iOto8");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $ea7ab899da227a3b$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $dNMDr.useContext)((0, $iOto8.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $ea7ab899da227a3b$export$2e2bcd8739ae039 = $ea7ab899da227a3b$var$useRouterLink;

});
parcelRegister("iOto8", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $db23b16536a290e8$export$2931e0ee690eee88; });
$parcel$export(module.exports, "default", function () { return $db23b16536a290e8$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");
var $db23b16536a290e8$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $dNMDr.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $db23b16536a290e8$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($db23b16536a290e8$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $db23b16536a290e8$export$2e2bcd8739ae039 = $db23b16536a290e8$var$RouterLinkProvider;

});






parcelRegister("493Hj", function(module, exports) {

$parcel$export(module.exports, "FullScreenSpinnerWrapper", function () { return $d9302459c082ad56$export$439279e039f7af42; });
$parcel$export(module.exports, "LoadingSpinner", function () { return $d9302459c082ad56$export$b08b517936747730; });

var $6CtE1 = parcelRequire("6CtE1");

var $3Wc5s = parcelRequire("3Wc5s");

var $68HQw = parcelRequire("68HQw");

var $fbSBq = parcelRequire("fbSBq");
parcelRequire("dNMDr");
const $d9302459c082ad56$export$439279e039f7af42 = (0, $fbSBq.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;
const $d9302459c082ad56$var$SpinnerContainer = (0, $fbSBq.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(0, $68HQw.gridSize)() * 3}px;
`;
const $d9302459c082ad56$export$b08b517936747730 = ({ testId: testId })=>{
    return /*#__PURE__*/ (0, $6CtE1.jsx)($d9302459c082ad56$var$SpinnerContainer, {
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3Wc5s.default), {
            testId: testId,
            size: "large"
        })
    });
};

});



parcelRegister("dGtec", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ReverifyEmailSentPage", function () { return $2e1693d38b594c00$export$357c630eb6814495; });
$parcel$export(module.exports, "default", function () { return $2e1693d38b594c00$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $cpaps = parcelRequire("cpaps");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $8PbSs = parcelRequire("8PbSs");

var $eTWY7 = parcelRequire("eTWY7");

var $7lC8o = parcelRequire("7lC8o");

var $2YdXx = parcelRequire("2YdXx");

var $Q6OOA = parcelRequire("Q6OOA");

var $4NPio = parcelRequire("4NPio");

var $aMBBA = parcelRequire("aMBBA");

var $dWOVN = parcelRequire("dWOVN");
const $2e1693d38b594c00$var$pageId = 'reverifyEmailSentScreen';
const $2e1693d38b594c00$export$357c630eb6814495 = ()=>{
    const email = (0, $aMBBA.useAppSelector)((state)=>state.user.email);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const location = (0, $cVnBY.useLocation)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    (0, $4NPio.usePageViewedEvent)($2e1693d38b594c00$var$pageId);
    const addSuccessFlag = ()=>{
        const flag = {
            type: 'success',
            title: (0, $2YdXx.default).reverifyEmailFlagSuccessTitle,
            description: (0, $2YdXx.default).reverifyEmailFlagSuccessDesc
        };
        dispatch((0, $7lC8o.addFlag)(flag.type, flag.title, flag.description));
    };
    const addErrorFlag = ()=>{
        const flag = {
            type: 'error',
            title: (0, $2YdXx.default).reverifyEmailFlagErrorTitle,
            description: (0, $2YdXx.default).reverifyEmailFlagErrorDesc
        };
        dispatch((0, $7lC8o.addFlag)(flag.type, flag.title, flag.description));
    };
    const handleResendVerificationEmail = ()=>{
        analyticsClient.buttonClickedEvent($2e1693d38b594c00$var$pageId, 'resendReverificationEmail');
        return fetch(`/rest/resend-email${location.search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>{
            if (response.status === 204) addSuccessFlag();
            else addErrorFlag();
        }).catch(()=>{
            addErrorFlag();
        });
    };
    const header = ()=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "reverify.email.title",
                defaultMessage: "Check your inbox to verify your email"
            })
        });
    const whiteboxFooter = ()=>{
        return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
            id: "send-validation-submit",
            spacing: "none",
            className: "link-color-override",
            onClick: handleResendVerificationEmail,
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "verify.email.resend.reverification.link",
                defaultMessage: "Resend verification link"
            })
        });
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        // @ts-ignore no id
        id: "reverify-email-sent-page",
        pageId: $2e1693d38b594c00$var$pageId,
        header: header(),
        whiteboxFooter: whiteboxFooter(),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                title: formatMessage((0, $2YdXx.default).headTitle)
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8PbSs.default), {
                email: email,
                message: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "reverify.email.sent.verification.link",
                    tagName: "p",
                    defaultMessage: "We sent a verification link to:",
                    description: "Telling user that a verification link has been sent. This message is followed by the user's email address on the next line."
                })
            })
        ]
    });
};
var $2e1693d38b594c00$export$2e2bcd8739ae039 = $2e1693d38b594c00$export$357c630eb6814495;

});
parcelRegister("2YdXx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb3a4af10be7665c$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $bb3a4af10be7665c$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    // Flags
    reverifyEmailFlagSuccessTitle: {
        id: 'reverify.email.sent.flag.success.title',
        defaultMessage: "We've sent you an email!"
    },
    reverifyEmailFlagSuccessDesc: {
        id: 'reverify.email.sent.flag.success.description',
        defaultMessage: 'The verification email is on its way!'
    },
    reverifyEmailFlagErrorTitle: {
        id: 'reverify.email.sent.flag.error.title',
        defaultMessage: 'Something went wrong.'
    },
    reverifyEmailFlagErrorDesc: {
        id: 'reverify.email.sent.flag.error.description',
        defaultMessage: 'Please try again later.'
    },
    headTitle: {
        id: 'reverify.email.sent.head.title',
        defaultMessage: 'Verify your email'
    }
});

});


parcelRegister("7aPz9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "resetExpiredPasswordLoader", function () { return $bc063e11bb84173a$export$92394b370142461a; });
$parcel$export(module.exports, "ExpiredPasswordPage", function () { return $bc063e11bb84173a$export$f8dc9833cdc832ea; });
$parcel$export(module.exports, "default", function () { return $bc063e11bb84173a$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $ko1o6 = parcelRequire("ko1o6");

var $cpaps = parcelRequire("cpaps");

var $1JRGy = parcelRequire("1JRGy");

var $jUqAC = parcelRequire("jUqAC");

var $lD9TK = parcelRequire("lD9TK");

var $2byD0 = parcelRequire("2byD0");

var $79HVl = parcelRequire("79HVl");

var $fqdIF = parcelRequire("fqdIF");

var $7lC8o = parcelRequire("7lC8o");

var $Q6OOA = parcelRequire("Q6OOA");

var $4NPio = parcelRequire("4NPio");
parcelRequire("jM5Ly");
var $hMPjy = parcelRequire("hMPjy");

var $4ljBU = parcelRequire("4ljBU");

var $aMBBA = parcelRequire("aMBBA");

var $h4v4M = parcelRequire("h4v4M");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");
const $bc063e11bb84173a$var$pageId = 'expiredpassword';
async function $bc063e11bb84173a$export$92394b370142461a({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/login/resetexpiredpassword/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--reset-password'
        ]
    });
}
const $bc063e11bb84173a$export$f8dc9833cdc832ea = ()=>{
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const location = (0, $cVnBY.useLocation)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const email = (0, $aMBBA.useAppSelector)((state)=>state.user.email);
    const { error: error, isLoading: isLoading, isComplete: isComplete } = (0, $aMBBA.useAppSelector)((state)=>state.expiredPassword);
    const dispatchResetPassword = (0, $dNMDr.useCallback)(()=>{
        const { token: token } = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search);
        dispatch((0, $fqdIF.requestResetExpiredPassword)(token || ''));
    }, [
        dispatch,
        location.search
    ]);
    const previousIsComplete = (0, $hMPjy.usePrevious)(isComplete);
    (0, $4NPio.usePageViewedEvent)($bc063e11bb84173a$var$pageId, {
        redirectReason: 'adminForcedReset'
    });
    (0, $dNMDr.useEffect)(()=>{
        if (!previousIsComplete && isComplete) switch(error){
            case null:
                dispatch((0, $7lC8o.addFlag)('success', (0, $lD9TK.default).emailSentFlagSuccessTitle, (0, $lD9TK.default).emailSentFlagSuccessDesc));
                break;
            case 'invalid_token':
                navigate(`/login?email=${encodeURIComponent(email)}`);
                dispatch((0, $7lC8o.addFlag)('error', (0, $lD9TK.default).emailSentFlagFailedTitle, (0, $lD9TK.default).emailSentFlagFailedDesc));
                break;
            case 'too_many_requests':
                dispatch((0, $7lC8o.addFlag)('error', (0, $lD9TK.default).emailSentFlagFailedTitle, (0, $lD9TK.default).emailSentFlagTooManyEmailsDesc));
                break;
            default:
                dispatch((0, $7lC8o.addFlag)('error', (0, $lD9TK.default).emailSentFlagFailedTitle, (0, $lD9TK.default).emailSentFlagFailedDesc));
                break;
        }
    }, [
        dispatch,
        email,
        error,
        isComplete,
        previousIsComplete,
        navigate
    ]);
    const headerMessage = formatMessage((0, $lD9TK.default).title);
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        // @ts-ignore no id
        id: "expired-password-page",
        pageId: $bc063e11bb84173a$var$pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)("h5", {
            children: headerMessage
        }),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                title: formatMessage((0, $lD9TK.default).headTitle)
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $jUqAC.default), {
                header: formatMessage((0, $lD9TK.default).headTitle),
                message: formatMessage((0, $lD9TK.default).contentText),
                email: email
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                    appearance: "primary",
                    id: "send-password-reset-email",
                    type: "submit",
                    isFullWidth: true,
                    isLoading: isLoading,
                    onClick: ()=>{
                        dispatchResetPassword();
                        analyticsClient.buttonClickedEvent($bc063e11bb84173a$var$pageId, 'resetExpiredPasswordButton');
                    },
                    children: formatMessage((0, $lD9TK.default).sendResetEmailButton)
                })
            })
        ]
    });
};
var $bc063e11bb84173a$export$2e2bcd8739ae039 = $bc063e11bb84173a$export$f8dc9833cdc832ea;

});
parcelRegister("jUqAC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9bbfb1d103f4bb2$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $7DUKO = parcelRequire("7DUKO");

var $aTW32 = parcelRequire("aTW32");
const $f9bbfb1d103f4bb2$var$imgHeight = 92;
const $f9bbfb1d103f4bb2$var$PasswordExpiredContainer = (0, $fbSBq.default).div`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($aTW32)))}) no-repeat center top;
  background-size: 50% 50%;
  padding-top: ${$f9bbfb1d103f4bb2$var$imgHeight + (0, $68HQw.gridSize)() * 8}px;
`;
const $f9bbfb1d103f4bb2$var$Header = (0, $fbSBq.default).h5`
  font: ${(0, $7DUKO.default)('font.heading.small')};
  color: ${(0, $l4KzN).N300};
  text-align: left;
`;
const $f9bbfb1d103f4bb2$var$Message = (0, $fbSBq.default).p`
  margin: ${(0, $68HQw.gridSize)()}px 0;
`;
const $f9bbfb1d103f4bb2$var$Email = (0, $fbSBq.default).p`
  font: ${(0, $7DUKO.default)('font.heading.small')};
  margin-top: ${(0, $68HQw.gridSize)()}px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $f9bbfb1d103f4bb2$var$PasswordExpiredNotice = (props)=>{
    const { header: header, children: children, email: email, message: message } = props;
    return /*#__PURE__*/ (0, $6CtE1.jsxs)($f9bbfb1d103f4bb2$var$PasswordExpiredContainer, {
        id: "password-expired-notice",
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)($f9bbfb1d103f4bb2$var$Header, {
                id: "password-expired-header",
                children: header
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)($f9bbfb1d103f4bb2$var$Message, {
                id: "password-expired-message",
                children: message
            }),
            email && /*#__PURE__*/ (0, $6CtE1.jsx)($f9bbfb1d103f4bb2$var$Email, {
                children: email
            }),
            children
        ]
    });
};
var $f9bbfb1d103f4bb2$export$2e2bcd8739ae039 = $f9bbfb1d103f4bb2$var$PasswordExpiredNotice;

});
parcelRegister("aTW32", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "trust-and-security.e4fed227.svg";

});


parcelRegister("lD9TK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c71706ed1a369f38$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $c71706ed1a369f38$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    title: {
        id: 'expired.password.title',
        defaultMessage: 'Reset your password'
    },
    headTitle: {
        id: 'expired.password.head.title',
        defaultMessage: 'Security request from your admin'
    },
    contentText: {
        id: 'expired.password.email.content',
        defaultMessage: 'Your admin wants you to set a new password before you log back in. We will send the password reset link to your email address:'
    },
    sendResetEmailButton: {
        id: 'expired.password.button.send',
        defaultMessage: 'Send password reset email'
    },
    emailSentFlagFailedTitle: {
        id: 'expired.password.email.flag.error.title',
        defaultMessage: 'Unable to send email'
    },
    emailSentFlagFailedDesc: {
        id: 'expired.password.email.flag.general.error.desc',
        defaultMessage: 'Something went wrong when we tried to send the password reset link. Try again.'
    },
    emailSentFlagTooManyEmailsDesc: {
        id: 'expired.password.email.flag.toomanyemails.error.desc',
        defaultMessage: "We've sent too many emails, please try again later."
    },
    emailSentFlagSuccessTitle: {
        id: 'expired.password.email.flag.success.title',
        defaultMessage: 'Email successfully sent'
    },
    emailSentFlagSuccessDesc: {
        id: 'expired.password.email.flag.success.desc',
        defaultMessage: 'Check your email for the password reset link.'
    }
});

});

parcelRegister("2byD0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18badf07de51c40c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "TallLinkButton", function () { return $18badf07de51c40c$export$549de15399e8aa5a; });

var $6CtE1 = parcelRequire("6CtE1");

var $fbSBq = parcelRequire("fbSBq");

var $eczk8 = parcelRequire("eczk8");

var $ePN9Y = parcelRequire("ePN9Y");
parcelRequire("dNMDr");
const $18badf07de51c40c$var$StyledButton = (0, $fbSBq.default)((0, $eczk8.default))`
  height: 40px !important;
  line-height: 40px !important;

  div,
  span {
    display: flex !important;
    justify-content: center;
  }
`;
const $18badf07de51c40c$var$StyledLinkButtonWrapper = (0, $fbSBq.default).div`
  a {
    display: inline-flex;
    height: 40px !important;
    align-items: center;
  }
`;
function $18badf07de51c40c$export$2e2bcd8739ae039(props) {
    const { isFullWidth: isFullWidth, ...rest } = props;
    return /*#__PURE__*/ (0, $6CtE1.jsx)($18badf07de51c40c$var$StyledButton, {
        ...rest,
        shouldFitContainer: isFullWidth
    });
}
const $18badf07de51c40c$export$549de15399e8aa5a = (props)=>{
    const { isFullWidth: isFullWidth, ...rest } = props;
    return /*#__PURE__*/ (0, $6CtE1.jsx)($18badf07de51c40c$var$StyledLinkButtonWrapper, {
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ePN9Y.default), {
            ...rest,
            shouldFitContainer: isFullWidth
        })
    });
};

});
parcelRegister("eczk8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a56d9637fefcd48a$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $cTzf6 = parcelRequire("cTzf6");

var $6gA4U = parcelRequire("6gA4U");
var $a56d9637fefcd48a$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $a56d9637fefcd48a$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $a56d9637fefcd48a$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $cTzf6.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $6gA4U.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$a56d9637fefcd48a$var$LoadingButton.displayName = 'LoadingButton';
var $a56d9637fefcd48a$export$2e2bcd8739ae039 = $a56d9637fefcd48a$var$LoadingButton;

});

parcelRegister("ePN9Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $accbf640b074abd7$export$2e2bcd8739ae039; });
/* link.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");


var $kugzw = parcelRequire("kugzw");

var $gTgRL = parcelRequire("gTgRL");

var $lm7lB = parcelRequire("lm7lB");

var $gQLDR = parcelRequire("gQLDR");

var $97OWz = parcelRequire("97OWz");

var $cb5Ng = parcelRequire("cb5Ng");

var $hK1dY = parcelRequire("hK1dY");
var $accbf640b074abd7$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "href",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId"
], $accbf640b074abd7$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $accbf640b074abd7$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhkby5v _syaz1gmx _aetrglyw _irr3by5v _30l31gmx _1di6by5v _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBeforeWithHack: "_bozgu2gc",
    buttonIconAfterWithHack: "_y4tiu2gc",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    fullWidth: "_1bsb1osq"
};
var $accbf640b074abd7$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
var $accbf640b074abd7$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
var $accbf640b074abd7$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
var $accbf640b074abd7$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
var $accbf640b074abd7$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
var $accbf640b074abd7$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
var $accbf640b074abd7$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $accbf640b074abd7$var$LinkButtonBase = function LinkButtonBase(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $accbf640b074abd7$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(unsafeRest, $accbf640b074abd7$var$_excluded2);
    var hasIconAfter = Boolean(iconAfter);
    var hasIconBefore = Boolean(iconBefore);
    var localRef = (0, $dNMDr.useRef)(null);
    (0, $lm7lB.default)(localRef, autoFocus);
    var combinedRef = (0, $gTgRL.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ $dNMDr.createElement((0, $97OWz.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        analyticsContext: analyticsContext,
        ref: combinedRef,
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName
    }, saferRest, {
        xcss: (0, $kugzw.cx)($accbf640b074abd7$var$styles.base, (0, $gQLDR.fg)('platform-dst-shape-theme-default') && $accbf640b074abd7$var$styles.baseT26Shape, appearance === 'default' && $accbf640b074abd7$var$defaultStyles.root, appearance === 'primary' && $accbf640b074abd7$var$primaryStyles.root, appearance === 'warning' && $accbf640b074abd7$var$warningStyles.root, appearance === 'danger' && $accbf640b074abd7$var$dangerStyles.root, appearance === 'discovery' && $accbf640b074abd7$var$discoveryStyles.root, appearance === 'subtle' && $accbf640b074abd7$var$subtleStyles.root, $accbf640b074abd7$var$styles.linkDecorationUnset, isSelected && $accbf640b074abd7$var$selectedStyles.root, isSelected && appearance === 'danger' && $accbf640b074abd7$var$selectedStyles.danger, isSelected && appearance === 'warning' && $accbf640b074abd7$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $accbf640b074abd7$var$selectedStyles.discovery, isDisabled && $accbf640b074abd7$var$styles.disabled, spacing === 'compact' && $accbf640b074abd7$var$styles.spacingCompact, hasIconBefore && !(0, $gQLDR.fg)('platform-button-icon-spacing-cleanup') && $accbf640b074abd7$var$styles.buttonIconBeforeWithHack, //to remove when platform-button-icon-spacing-cleanup is removed
        hasIconAfter && !(0, $gQLDR.fg)('platform-button-icon-spacing-cleanup') && $accbf640b074abd7$var$styles.buttonIconAfterWithHack, //to remove when platform-button-icon-spacing-cleanup is removed
        hasIconBefore && (0, $gQLDR.fg)('platform-button-icon-spacing-cleanup') && $accbf640b074abd7$var$styles.buttonIconBefore, //to keep when platform-button-icon-spacing-cleanup is removed
        hasIconAfter && (0, $gQLDR.fg)('platform-button-icon-spacing-cleanup') && $accbf640b074abd7$var$styles.buttonIconAfter, //to keep when platform-button-icon-spacing-cleanup is removed
        shouldFitContainer && $accbf640b074abd7$var$styles.fullWidth)
    }), iconBefore && /*#__PURE__*/ $dNMDr.createElement((0, $cb5Ng.default), {
        type: "icon",
        position: "before",
        isLoading: false
    }, /*#__PURE__*/ $dNMDr.createElement((0, $hK1dY.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ $dNMDr.createElement((0, $cb5Ng.default), {
        isLoading: false
    }, children), iconAfter && /*#__PURE__*/ $dNMDr.createElement((0, $cb5Ng.default), {
        type: "icon",
        position: "after",
        isLoading: false
    }, /*#__PURE__*/ $dNMDr.createElement((0, $hK1dY.default), {
        icon: iconAfter
    })));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $accbf640b074abd7$var$LinkButton = /*#__PURE__*/ (0, $dNMDr.forwardRef)($accbf640b074abd7$var$LinkButtonBase);
$accbf640b074abd7$var$LinkButton.displayName = 'LinkButton';
var $accbf640b074abd7$export$2e2bcd8739ae039 = $accbf640b074abd7$var$LinkButton;

});


parcelRegister("79HVl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $855ba7dcacfa9bd5$export$2e2bcd8739ae039; });

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");
const $855ba7dcacfa9bd5$var$ButtonContainer = (0, $fbSBq.default).div`
  width: 100%;
  padding-top: ${(0, $68HQw.gridSize)() * 2}px;
`;
var $855ba7dcacfa9bd5$export$2e2bcd8739ae039 = $855ba7dcacfa9bd5$var$ButtonContainer;

});

parcelRegister("fqdIF", function(module, exports) {

$parcel$export(module.exports, "requestResetExpiredPassword", function () { return $19e10504e694b3a0$export$21fe95b80217f58c; });

var $hqddj = parcelRequire("hqddj");
const $19e10504e694b3a0$export$2cd8252107eb640b = ()=>({
        type: 'EXPIRED_PASSWORD_RESET_REQUEST_INITIATE'
    });
const $19e10504e694b3a0$export$4098f8ed622a8e6c = ()=>({
        type: 'EXPIRED_PASSWORD_RESET_REQUEST_SUCCESS'
    });
const $19e10504e694b3a0$export$7ee4ab4cd9f42c10 = (error)=>({
        type: 'EXPIRED_PASSWORD_RESET_REQUEST_FAILED',
        error: error
    });
const $19e10504e694b3a0$export$21fe95b80217f58c = (token)=>(dispatch)=>{
        dispatch($19e10504e694b3a0$export$2cd8252107eb640b());
        return fetch('/rest/resetexpiredpassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token
            })
        }).then((response)=>{
            if (response.status === 200) return response.json();
            return Promise.reject(new Error(response.status.toString()));
        }).then(({ isSuccessful: isSuccessful })=>{
            if (isSuccessful === true) dispatch($19e10504e694b3a0$export$4098f8ed622a8e6c());
            else dispatch($19e10504e694b3a0$export$7ee4ab4cd9f42c10('invalid_token'));
        }).catch((error)=>{
            switch(error.message){
                case '401':
                    dispatch($19e10504e694b3a0$export$7ee4ab4cd9f42c10('invalid_token'));
                    break;
                case '429':
                    dispatch($19e10504e694b3a0$export$7ee4ab4cd9f42c10('too_many_requests'));
                    break;
                default:
                    dispatch($19e10504e694b3a0$export$7ee4ab4cd9f42c10('generic_error'));
                    (0, $hqddj.captureException)(error);
                    break;
            }
        });
    };

});

parcelRegister("jM5Ly", function(module, exports) {
$parcel$export(module.exports, "useForceRedirect", function () { return (parcelRequire("04aYR")).useForceRedirect; });
$parcel$export(module.exports, "usePrevious", function () { return (parcelRequire("hMPjy")).usePrevious; });
$parcel$export(module.exports, "useGoogleLoginHandler", function () { return (parcelRequire("kKzDC")).useGoogleLoginHandler; });
$parcel$export(module.exports, "useSocialLoginHandlers", function () { return (parcelRequire("kKzDC")).useSocialLoginHandlers; });
$parcel$export(module.exports, "useRecaptchaChallengeObserver", function () { return (parcelRequire("jId0c")).useRecaptchaChallengeObserver; });
parcelRequire("04aYR");
parcelRequire("3u9Eh");
parcelRequire("hMPjy");
parcelRequire("kKzDC");
parcelRequire("jId0c");

});
parcelRegister("04aYR", function(module, exports) {

$parcel$export(module.exports, "useForceRedirect", function () { return $53d30015957b0674$export$20eacf679bc57a60; });

var $dNMDr = parcelRequire("dNMDr");

var $h4v4M = parcelRequire("h4v4M");
const $53d30015957b0674$export$20eacf679bc57a60 = ({ redirectTo: redirectTo })=>{
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    (0, $dNMDr.useEffect)(()=>{
        if (redirectTo) try {
            const url = new URL(redirectTo);
            navigate(url.toString());
        } catch (e) {
            console.log('Caught error while trying to redirect...');
            console.log(e);
        }
    }, [
        redirectTo,
        navigate
    ]);
};

});

parcelRegister("3u9Eh", function(module, exports) {

var $dNMDr = parcelRequire("dNMDr");
const $eff76385413418a0$export$820558710db2d9c6 = (callback)=>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $dNMDr.useEffect)(()=>callback(), []);
};

});

parcelRegister("hMPjy", function(module, exports) {

$parcel$export(module.exports, "usePrevious", function () { return $a6b21bd10e3e8c4e$export$5cae361ad82dce8b; });

var $dNMDr = parcelRequire("dNMDr");
function $a6b21bd10e3e8c4e$export$5cae361ad82dce8b(newValue) {
    const previousRef = (0, $dNMDr.useRef)();
    (0, $dNMDr.useEffect)(()=>{
        previousRef.current = newValue;
    });
    return previousRef.current;
}

});

parcelRegister("kKzDC", function(module, exports) {

$parcel$export(module.exports, "useGoogleLoginHandler", function () { return $99618768a293229b$export$c5e89b4acf71d8e2; });
$parcel$export(module.exports, "useSocialLoginHandlers", function () { return $99618768a293229b$export$3388df9a8c5125bf; });

var $dNMDr = parcelRequire("dNMDr");

var $4NPio = parcelRequire("4NPio");

var $7SvfM = parcelRequire("7SvfM");
const $99618768a293229b$export$c5e89b4acf71d8e2 = ({ pageId: pageId, redirectType: redirectType, redirectParams: redirectParams })=>{
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    return (0, $dNMDr.useCallback)(()=>{
        analyticsClient.buttonClickedEvent(pageId, 'googleLoginButton', {
            redirectType: redirectType
        });
        (0, $7SvfM.redirectToGoogleLogin)(redirectParams);
    }, [
        analyticsClient,
        pageId,
        redirectType,
        redirectParams
    ]);
};
const $99618768a293229b$export$3388df9a8c5125bf = ({ pageId: pageId, redirectType: redirectType, redirectParams: redirectParams })=>{
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const handleSocialLogin = (0, $dNMDr.useCallback)((redirectFn, buttonId)=>{
        analyticsClient.buttonClickedEvent(pageId, buttonId, {
            redirectType: redirectType
        });
        redirectFn(redirectParams);
    }, [
        analyticsClient,
        pageId,
        redirectType,
        redirectParams
    ]);
    const handleMicrosoftLogin = (0, $dNMDr.useCallback)(()=>handleSocialLogin((0, $7SvfM.redirectToMicrosoftLogin), 'microsoftLoginButton'), [
        handleSocialLogin
    ]);
    const handleAppleLogin = (0, $dNMDr.useCallback)(()=>handleSocialLogin((0, $7SvfM.redirectToAppleLogin), 'appleLoginButton'), [
        handleSocialLogin
    ]);
    const handleSlackLogin = (0, $dNMDr.useCallback)(()=>handleSocialLogin((0, $7SvfM.redirectToSlackLogin), 'slackLoginButton'), [
        handleSocialLogin
    ]);
    return {
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleAppleLogin: handleAppleLogin,
        handleSlackLogin: handleSlackLogin
    };
};

});
parcelRegister("7SvfM", function(module, exports) {

$parcel$export(module.exports, "LoginType", function () { return $5a9848478f5901c9$export$7ecae1a0f094da22; });
$parcel$export(module.exports, "buildState", function () { return $5a9848478f5901c9$export$13c6022a038eeeb6; });
$parcel$export(module.exports, "redirectToGoogleLogin", function () { return $5a9848478f5901c9$export$d6e924a711e9e261; });
$parcel$export(module.exports, "redirectToMicrosoftLogin", function () { return $5a9848478f5901c9$export$a2375491e360a04f; });
$parcel$export(module.exports, "redirectToAppleLogin", function () { return $5a9848478f5901c9$export$be4d35cbb0c7d143; });
$parcel$export(module.exports, "isAppleHiddenEmail", function () { return $5a9848478f5901c9$export$3fed42f6cd70c2bc; });
$parcel$export(module.exports, "redirectToSlackLogin", function () { return $5a9848478f5901c9$export$bdab6d1697fcd9e9; });
$parcel$export(module.exports, "isGoogleLoginOutageAdvisoryEnabled", function () { return $5a9848478f5901c9$export$20fa47fc379f30f3; });
$parcel$export(module.exports, "isAppleLoginOutageAdvisoryEnabled", function () { return $5a9848478f5901c9$export$2fcd6c2fe8f717c4; });
$parcel$export(module.exports, "isMicrosoftLoginOutageAdvisoryEnabled", function () { return $5a9848478f5901c9$export$9c936482818cd3df; });
$parcel$export(module.exports, "isSlackLoginOutageAdvisoryEnabled", function () { return $5a9848478f5901c9$export$94fcb0c439ca8c06; });
/* eslint-disable max-params */ 
var $1JRGy = parcelRequire("1JRGy");

var $6795A = parcelRequire("6795A");

var $4qLQH = parcelRequire("4qLQH");

var $lDj5O = parcelRequire("lDj5O");
var $5a9848478f5901c9$export$7ecae1a0f094da22 = /*#__PURE__*/ function(LoginType) {
    LoginType["Apple"] = "appleLogin";
    LoginType["Slack"] = "slackLogin";
    LoginType["Microsoft"] = "microsoftLogin";
    LoginType["GoogleButton"] = "googleButton";
    LoginType["GoogleOneTap"] = "googleYolo";
    LoginType["SSO"] = "ssoLogin";
    return LoginType;
}({});
const $5a9848478f5901c9$export$13c6022a038eeeb6 = ({ location: location, csrfToken: csrfToken, source: source, loginType: loginType, anonymousId: anonymousId, userFlow: userFlow, recoveryOptions: recoveryOptions })=>(0, $6795A.Base64).encode(JSON.stringify({
        csrfToken: csrfToken,
        query: location.search || undefined,
        source: source,
        loginType: loginType,
        anonymousId: anonymousId,
        userFlow: userFlow,
        expects: recoveryOptions?.expectedEmail,
        recovery: recoveryOptions?.recoveryToken
    }));
const $5a9848478f5901c9$export$d6e924a711e9e261 = ({ location: location, source: source, recoveryOptions: recoveryOptions })=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search);
    const filteredParams = Object.fromEntries(Object.entries(searchParams).filter(([key])=>key !== 'login_hint'));
    const { userFlow: userFlow } = filteredParams;
    const params = {
        ...filteredParams,
        prompt: 'select_account',
        source: source,
        loginType: "googleButton",
        userFlow: userFlow,
        recovery: recoveryOptions?.recoveryToken
    };
    location.assign(`${location.protocol}//${location.host}/login/initiate/google?` + (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(params));
};
const $5a9848478f5901c9$var$redirectToSocialLoginInitiate = ({ location: location, source: source, recoveryOptions: recoveryOptions, loginType: loginType, loginHint: loginHint })=>{
    const initiateParams = {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search),
        loginType: loginType,
        source: source,
        recovery: recoveryOptions?.recoveryToken,
        prompt: 'select_account',
        login_hint: loginHint
    };
    let initiateUriSuffix;
    switch(loginType){
        case "appleLogin":
            initiateUriSuffix = 'apple';
            break;
        case "microsoftLogin":
            initiateUriSuffix = 'microsoft';
            break;
        case "slackLogin":
            initiateUriSuffix = 'slack';
            break;
    }
    location.assign(`${location.protocol}//${location.host}/login/initiate/${initiateUriSuffix}?` + (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(initiateParams));
};
const $5a9848478f5901c9$export$a2375491e360a04f = (params)=>{
    const { location: location, source: source, recoveryOptions: recoveryOptions, email: email } = params;
    $5a9848478f5901c9$var$redirectToSocialLoginInitiate({
        location: location,
        source: source,
        recoveryOptions: recoveryOptions,
        loginType: "microsoftLogin",
        loginHint: email
    });
};
const $5a9848478f5901c9$export$be4d35cbb0c7d143 = (params)=>{
    const { location: location, source: source, recoveryOptions: recoveryOptions, email: email } = params;
    $5a9848478f5901c9$var$redirectToSocialLoginInitiate({
        location: location,
        source: source,
        recoveryOptions: recoveryOptions,
        loginType: "appleLogin",
        loginHint: email
    });
};
const $5a9848478f5901c9$export$3fed42f6cd70c2bc = (email)=>{
    if (!email) return false;
    // Hidden email as defined by <unique-alphanumeric-string>@privaterelay.appleid.com
    const hiddenEmailDomainIdentifier = 'privaterelay.appleid.com';
    const [domain] = email.split('@').slice(-1);
    return domain === hiddenEmailDomainIdentifier;
};
const $5a9848478f5901c9$export$bdab6d1697fcd9e9 = (params)=>{
    const { location: location, source: source, recoveryOptions: recoveryOptions } = params;
    $5a9848478f5901c9$var$redirectToSocialLoginInitiate({
        location: location,
        source: source,
        recoveryOptions: recoveryOptions,
        loginType: "slackLogin",
        // Slack's OIDC implementation expects login_hint to be a JWT and blows up if it's not. If
        // Slack ever supports using an email as the login_hint (like other OIDC providers) then we
        // should remove this line.
        loginHint: undefined
    });
};
const $5a9848478f5901c9$export$20fa47fc379f30f3 = (dynamicConfigs)=>(0, $lDj5O.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $4qLQH.AidFrontendDynamicConfig).GOOGLE_LOGIN_OUTAGE_ADVISORY);
const $5a9848478f5901c9$export$2fcd6c2fe8f717c4 = (dynamicConfigs)=>(0, $lDj5O.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $4qLQH.AidFrontendDynamicConfig).APPLE_LOGIN_OUTAGE_ADVISORY);
const $5a9848478f5901c9$export$9c936482818cd3df = (dynamicConfigs)=>(0, $lDj5O.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $4qLQH.AidFrontendDynamicConfig).MICROSOFT_LOGIN_OUTAGE_ADVISORY);
const $5a9848478f5901c9$export$94fcb0c439ca8c06 = (dynamicConfigs)=>(0, $lDj5O.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $4qLQH.AidFrontendDynamicConfig).SLACK_LOGIN_OUTAGE_ADVISORY);

});
parcelRegister("6795A", function(module, exports) {
(function(global1, factory) {
    module.exports = factory(global1);
})(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : module.exports, function(global1) {
    'use strict';
    // existing version for noConflict()
    global1 = global1 || {};
    var _Base64 = global1.Base64;
    var version = "2.6.4";
    // constants
    var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function(bin) {
        var t = {};
        for(var i = 0, l = bin.length; i < l; i++)t[bin.charAt(i)] = i;
        return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        } else {
            var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
            return fromCharCode(0xf0 | cc >>> 18 & 0x07) + fromCharCode(0x80 | cc >>> 12 & 0x3f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function(ccc) {
        var padlen = [
            0,
            2,
            1
        ][ccc.length % 3], ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0), chars = [
            b64chars.charAt(ord >>> 18),
            b64chars.charAt(ord >>> 12 & 63),
            padlen >= 2 ? '=' : b64chars.charAt(ord >>> 6 & 63),
            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
        ];
        return chars.join('');
    };
    var btoa = global1.btoa && typeof global1.btoa == 'function' ? function(b) {
        return global1.btoa(b);
    } : function(b) {
        if (b.match(/[^\x00-\xFF]/)) throw new RangeError('The string contains invalid characters.');
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = function(u) {
        return btoa(utob(String(u)));
    };
    var mkUriSafe = function(b64) {
        return b64.replace(/[+\/]/g, function(m0) {
            return m0 == '+' ? '-' : '_';
        }).replace(/=/g, '');
    };
    var encode = function(u, urisafe) {
        return urisafe ? mkUriSafe(_encode(u)) : _encode(u);
    };
    var encodeURI = function(u) {
        return encode(u, true);
    };
    var fromUint8Array;
    if (global1.Uint8Array) fromUint8Array = function(a, urisafe) {
        // return btoa(fromCharCode.apply(null, a));
        var b64 = '';
        for(var i = 0, l = a.length; i < l; i += 3){
            var a0 = a[i], a1 = a[i + 1], a2 = a[i + 2];
            var ord = a0 << 16 | a1 << 8 | a2;
            b64 += b64chars.charAt(ord >>> 18) + b64chars.charAt(ord >>> 12 & 63) + (typeof a1 != 'undefined' ? b64chars.charAt(ord >>> 6 & 63) : '=') + (typeof a2 != 'undefined' ? b64chars.charAt(ord & 63) : '=');
        }
        return urisafe ? mkUriSafe(b64) : b64;
    };
    // decoder stuff
    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
    var cb_btou = function(cccc) {
        switch(cccc.length){
            case 4:
                var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
                return fromCharCode((offset >>> 10) + 0xD800) + fromCharCode((offset & 0x3FF) + 0xDC00);
            case 3:
                return fromCharCode((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
            default:
                return fromCharCode((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
        }
    };
    var btou = function(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function(cccc) {
        var len = cccc.length, padlen = len % 4, n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0) | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0) | (len > 2 ? b64tab[cccc.charAt(2)] << 6 : 0) | (len > 3 ? b64tab[cccc.charAt(3)] : 0), chars = [
            fromCharCode(n >>> 16),
            fromCharCode(n >>> 8 & 0xff),
            fromCharCode(n & 0xff)
        ];
        chars.length -= [
            0,
            0,
            2,
            1
        ][padlen];
        return chars.join('');
    };
    var _atob = global1.atob && typeof global1.atob == 'function' ? function(a) {
        return global1.atob(a);
    } : function(a) {
        return a.replace(/\S{1,4}/g, cb_decode);
    };
    var atob = function(a) {
        return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
    };
    var _decode = function(a) {
        return btou(_atob(a));
    };
    var _fromURI = function(a) {
        return String(a).replace(/[-_]/g, function(m0) {
            return m0 == '-' ? '+' : '/';
        }).replace(/[^A-Za-z0-9\+\/]/g, '');
    };
    var decode = function(a) {
        return _decode(_fromURI(a));
    };
    var toUint8Array;
    if (global1.Uint8Array) toUint8Array = function(a) {
        return Uint8Array.from(atob(_fromURI(a)), function(c) {
            return c.charCodeAt(0);
        });
    };
    var noConflict = function() {
        var Base641 = global1.Base64;
        global1.Base64 = _Base64;
        return Base641;
    };
    // export Base64
    global1.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict,
        fromUint8Array: fromUint8Array,
        toUint8Array: toUint8Array
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function(v) {
            return {
                value: v,
                enumerable: false,
                writable: true,
                configurable: true
            };
        };
        global1.Base64.extendString = function() {
            Object.defineProperty(String.prototype, 'fromBase64', noEnum(function() {
                return decode(this);
            }));
            Object.defineProperty(String.prototype, 'toBase64', noEnum(function(urisafe) {
                return encode(this, urisafe);
            }));
            Object.defineProperty(String.prototype, 'toBase64URI', noEnum(function() {
                return encode(this, true);
            }));
        };
    }
    //
    // export Base64 to the namespace
    //
    if (global1['Meteor']) Base64 = global1.Base64;
    // module.exports and AMD are mutually exclusive.
    // module.exports has precedence.
    if (0, module.exports) module.exports.Base64 = global1.Base64;
    else if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], function() {
        return global1.Base64;
    });
    // that's it!
    return {
        Base64: global1.Base64
    };
});

});



parcelRegister("jId0c", function(module, exports) {

$parcel$export(module.exports, "useRecaptchaChallengeObserver", function () { return $1941a95adef6e3a8$export$4cc6b1f2fa5dc3f4; });

var $dNMDr = parcelRequire("dNMDr");

var $4NPio = parcelRequire("4NPio");
const $1941a95adef6e3a8$var$recaptchaIframeTitle = 'recaptcha challenge';
const $1941a95adef6e3a8$export$4cc6b1f2fa5dc3f4 = (pageId)=>{
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const bodyObserver = (0, $dNMDr.useRef)();
    const attributeObserver = (0, $dNMDr.useRef)();
    (0, $dNMDr.useEffect)(()=>{
        /*
      To determine if user has been presented with a Google reCAPTCHA challenge, we need to listen to DOM events and check if an <iframe> was injected.
      Said <iframe> will have 'src' attribute containing 'google.com/recaptcha/api2/bframe'. Unfortunately, that is not enough
      because Google will inject the <iframe> even if they're not gonna show the challenge. So we attach another observer,
      looking for a change on the 'style' attribute of the outmost containing <div>. If style.target.visibility is 'visible',
      then we send analytics event.
    */ const outerContainerAttributeObserver = ()=>{
            return new MutationObserver((records)=>{
                const visibleEvent = Array.from(records).find((mutation)=>mutation.attributeName === 'style' && mutation.target.style.visibility === 'visible');
                if (visibleEvent) {
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'challenge',
                        subject: 'googleRecaptcha'
                    });
                    attributeObserver.current?.disconnect();
                }
            });
        };
        if (window.MutationObserver) {
            bodyObserver.current = new MutationObserver((records)=>{
                records.forEach((mutation)=>{
                    mutation.addedNodes.forEach((node)=>{
                        if (!(node instanceof Element)) return;
                        const recaptchaIframe = node.querySelector(`iframe[title*='${$1941a95adef6e3a8$var$recaptchaIframeTitle}']`);
                        if (recaptchaIframe) {
                            bodyObserver.current?.disconnect();
                            const recaptchaOuterDiv = recaptchaIframe.parentNode?.parentNode;
                            if (recaptchaOuterDiv) {
                                attributeObserver.current = outerContainerAttributeObserver();
                                attributeObserver.current?.observe(recaptchaOuterDiv, {
                                    attributes: true
                                });
                            }
                        }
                    });
                });
            });
            bodyObserver.current?.observe(window.document.body, {
                childList: true
            });
        }
        return ()=>{
            bodyObserver.current?.disconnect();
            attributeObserver.current?.disconnect();
        };
    }, [
        analyticsClient,
        pageId
    ]);
};

});


parcelRegister("4ljBU", function(module, exports) {

$parcel$export(module.exports, "useGlobalPageState", function () { return $8749d5cb67d5c266$export$c0c5e20150fdb34a; });
$parcel$export(module.exports, "fetchFast5GlobalPageState", function () { return $8749d5cb67d5c266$export$ad35c91c010f31a8; });
$parcel$export(module.exports, "fetchPageState", function () { return $8749d5cb67d5c266$export$8d3833b13cc689f5; });

var $aMBBA = parcelRequire("aMBBA");

var $76XtE = parcelRequire("76XtE");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $iy2Wm = parcelRequire("iy2Wm");

var $dNMDr = parcelRequire("dNMDr");

var $9ULaf = parcelRequire("9ULaf");

var $4Gte9 = parcelRequire("4Gte9");

var $hqddj = parcelRequire("hqddj");

var $5ao9L = parcelRequire("5ao9L");

var $84ZjZ = parcelRequire("84ZjZ");

var $cBB3b = parcelRequire("cBB3b");

var $h4v4M = parcelRequire("h4v4M");
const $8749d5cb67d5c266$var$SAS_FAST_FIVE_FETCH_HEADER = 'sas-fast-five-fetch';
const $8749d5cb67d5c266$var$EXCLUDED_PATHS = {
    previousReduxStore: [
        '/2step/enrollment/',
        '/signup/welcome/p/loom-create-workspace',
        '/aws-captcha-test'
    ]
};
const $8749d5cb67d5c266$export$c0c5e20150fdb34a = ()=>{
    const location = (0, $cVnBY.useLocation)();
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    (0, $dNMDr.useEffect)(()=>{
        const fetchData = async ()=>{
            if (await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return;
            // For non-bifrost pages (i.e. injected state from sign-in-service), use the existing non-sas
            // behaviour. This could mean we may have old injected state which doesn't get
            // refreshed from here on page navigation, but that matches existing behaviour
            const hasInjectedServerState = !(0, $9ULaf.default)();
            if (hasInjectedServerState) return;
            const requiresStateFromPreviousReduxStore = $8749d5cb67d5c266$var$EXCLUDED_PATHS.previousReduxStore.some((path)=>location.pathname.startsWith(path));
            if (requiresStateFromPreviousReduxStore) return;
            dispatch((0, $76XtE.setGlobalStateLoading)(true));
            try {
                const url = location.pathname + location.search;
                const data = await $8749d5cb67d5c266$export$ad35c91c010f31a8(url);
                if ($8749d5cb67d5c266$export$4cb830d4f7e56898(data)) {
                    navigate(data.redirectTo);
                    return;
                }
                const fullState = await (0, $iy2Wm.buildInitialState)(data);
                dispatch((0, $76XtE.resetAppState)(fullState.initialStoreState));
            } catch (error) {
                let errorType = {
                    type: 'internal_server_error'
                };
                if (error instanceof (0, $4Gte9.ServerErrorException)) {
                    errorType = error.errorType;
                    (0, $hqddj.captureErrorMessage)(`Failed to load AppState in Bifrost: ${error.message}`);
                } else (0, $hqddj.captureErrorMessage)(`Unexpected error while loading AppState in Bifrost: ${error}`);
                dispatch((0, $5ao9L.setServerError)(errorType));
            }
            dispatch((0, $76XtE.setGlobalStateLoading)(false));
        };
        fetchData();
    // re-fetch whenever we change page, i.e. the fixed route
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.pathname
    ]);
};
const $8749d5cb67d5c266$export$4cb830d4f7e56898 = (data)=>Boolean(data && 'redirectTo' in data);
const $8749d5cb67d5c266$export$ad35c91c010f31a8 = async (fullPageUrl)=>{
    const headers = {
        [$8749d5cb67d5c266$var$SAS_FAST_FIVE_FETCH_HEADER]: 'true'
    };
    const response = await (0, $4Gte9.fetchApi)(fullPageUrl, headers);
    const data = await response.json();
    return data;
};
const $8749d5cb67d5c266$export$8d3833b13cc689f5 = async (restStateEndpoint, request, tags)=>{
    const url = new URL(request.url);
    const response = await (0, $4Gte9.fetchApiWithRetry)(restStateEndpoint + url.search);
    if (response.status === 404 || response.status >= 500) (0, $hqddj.captureTaggedException)('Error fetching page state', {
        capabilities: tags.capabilities,
        extraProperties: {
            restStateEndpoint: restStateEndpoint,
            responseStatus: response.status
        }
    });
    try {
        return await response.json();
    } catch (parseError) {
        (0, $hqddj.captureErrorMessage)(`Unexpected error while parsing AppState in Bifrost: ${parseError}`);
        return null;
    }
};

});
parcelRegister("5ao9L", function(module, exports) {

$parcel$export(module.exports, "setServerError", function () { return $c7cc8c3eee960a65$export$222f8d3ac9d63890; });
const $c7cc8c3eee960a65$export$222f8d3ac9d63890 = (error)=>({
        type: 'SERVER_ERROR_UPDATE',
        error: error
    });

});



parcelRegister("f3CY8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "securityScreenLoader", function () { return $c92a074d6d33783c$export$a4b1a0446670c4d3; });
$parcel$export(module.exports, "MfaPromotePage", function () { return $c92a074d6d33783c$export$84ed94b8c66e0057; });
$parcel$export(module.exports, "default", function () { return $c92a074d6d33783c$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $52XHP = parcelRequire("52XHP");

var $68HQw = parcelRequire("68HQw");

var $fbSBq = parcelRequire("fbSBq");

var $Q6OOA = parcelRequire("Q6OOA");

var $2byD0 = parcelRequire("2byD0");

var $79HVl = parcelRequire("79HVl");

var $eTWY7 = parcelRequire("eTWY7");

var $3YSXY = parcelRequire("3YSXY");

var $4NPio = parcelRequire("4NPio");

var $d5THV = parcelRequire("d5THV");

var $c8IJ3 = parcelRequire("c8IJ3");
parcelRequire("jM5Ly");
var $04aYR = parcelRequire("04aYR");

var $4ljBU = parcelRequire("4ljBU");

var $aMBBA = parcelRequire("aMBBA");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");

var $dWOVN = parcelRequire("dWOVN");

var $8IkGb = parcelRequire("8IkGb");

var $j2wBm = parcelRequire("j2wBm");
const $c92a074d6d33783c$var$MfaPromoteContainer = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $c92a074d6d33783c$var$MfaImg = (0, $fbSBq.default).img`
  height: ${(0, $68HQw.gridSize)() * 14}px;
  display: block;
  margin: 0 auto;
  padding: ${(0, $68HQw.gridSize)()}px 0;
`;
const $c92a074d6d33783c$var$ContentBody = (0, $fbSBq.default).p`
  margin: ${(0, $68HQw.gridSize)()}px 0;
`;
const $c92a074d6d33783c$var$pageId = 'mfaPromotePage';
async function $c92a074d6d33783c$export$a4b1a0446670c4d3({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/login/security-screen/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa-promote'
        ]
    });
}
const $c92a074d6d33783c$export$84ed94b8c66e0057 = ()=>{
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const redirectTo = (0, $aMBBA.useAppSelector)((state)=>state.mfaPromote.redirectTo);
    (0, $04aYR.useForceRedirect)({
        redirectTo: redirectTo
    });
    (0, $4NPio.usePageViewedEvent)($c92a074d6d33783c$var$pageId);
    (0, $4NPio.useOperationalEvent)({
        page: $c92a074d6d33783c$var$pageId,
        action: `loadMfaPromotePageSuccessful`,
        subject: 'sli'
    });
    const { search: search } = (0, $cVnBY.useLocation)();
    const trackMfaContinueButtonClicked = (0, $4NPio.useButtonClickedEvent)($c92a074d6d33783c$var$pageId, 'MfaPromoteContinue');
    const trackMfaLeanMoreLinkClicked = (0, $4NPio.useButtonClickedEvent)($c92a074d6d33783c$var$pageId, 'MfaPromoteLearnMore');
    const trackDismissButtonClicked = (0, $4NPio.useButtonClickedEvent)($c92a074d6d33783c$var$pageId, 'MfaPromoteDismiss');
    const onMfaContinueButtonClicked = ()=>{
        trackMfaContinueButtonClicked();
        dispatch((0, $c8IJ3.handleMfaPromoteUserSelection)('edit_mfa', search));
    };
    const onDismissButtonClicked = ()=>{
        trackDismissButtonClicked();
        dispatch((0, $c8IJ3.handleMfaPromoteUserSelection)('dismiss', search));
    };
    const { getUrlSearchEntriesForTaskSession: getUrlSearchEntriesForTaskSession } = (0, $j2wBm.usePasskeyEnrollmentTaskSession)();
    const trackPasskeysLeanMoreLinkClicked = (0, $4NPio.useButtonClickedEvent)($c92a074d6d33783c$var$pageId, 'PasskeysPromoteLearnMore');
    const trackPasskeysContinueButtonClicked = (0, $4NPio.useButtonClickedEvent)($c92a074d6d33783c$var$pageId, 'PasskeysPromoteContinue');
    const onPasskeysContinueButtonClicked = ()=>{
        trackPasskeysContinueButtonClicked();
        dispatch((0, $c8IJ3.handleMfaPromoteUserSelection)('edit_passkey', search, {
            additionalSearchParamsEntries: getUrlSearchEntriesForTaskSession()
        }));
    };
    const hasPasskeys = (0, $aMBBA.useAppSelector)((state)=>state.mfaPromote.hasPasskeys);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $Q6OOA.default), {
        pageId: "mfaPromotePage",
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $d5THV.default).promoteMfaPasskeysHeader
            })
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                    id: "mfa-promote-learn-more",
                    onClick: trackMfaLeanMoreLinkClicked,
                    href: "https://support.atlassian.com/atlassian-account/docs/manage-two-step-verification-for-your-atlassian-account/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    shouldFitContainer: true,
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $d5THV.default).promoteMfaLearnMore
                    })
                }),
                !hasPasskeys && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                    id: "passkeys-promote-learn-more",
                    onClick: trackPasskeysLeanMoreLinkClicked,
                    href: "https://support.atlassian.com/atlassian-account/docs/access-your-atlassian-account-with-a-passkey/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    shouldFitContainer: true,
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $d5THV.default).promotePasskeysLearnMore
                    })
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $6CtE1.jsxs)($c92a074d6d33783c$var$MfaPromoteContainer, {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)($c92a074d6d33783c$var$MfaImg, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($52XHP)))
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)($c92a074d6d33783c$var$ContentBody, {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $d5THV.default).promoteMfaMessageBody
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                        appearance: "primary",
                        id: "mfa-promote-continue",
                        type: "submit",
                        isFullWidth: true,
                        onClick: onMfaContinueButtonClicked,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            ...(0, $d5THV.default).promoteMfaContinue
                        })
                    })
                }, "mfa.promote.continue.container"),
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                        appearance: "default",
                        id: "mfa-promote-dismiss",
                        testId: "mfa-promote-dismiss-idf-testid",
                        type: "submit",
                        isFullWidth: true,
                        onClick: onDismissButtonClicked,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            ...(0, $d5THV.default).promoteMfaDismiss
                        })
                    })
                }, "mfa.promote.dismiss.container"),
                !hasPasskeys && /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $8IkGb.default), {
                    paddingBlockStart: "space.300",
                    children: [
                        /*#__PURE__*/ (0, $6CtE1.jsx)($c92a074d6d33783c$var$ContentBody, {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                ...(0, $d5THV.default).promotePasskeysMessageBody
                            })
                        }),
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                                appearance: "default",
                                id: "passkeys-promote-continue",
                                testId: "mfa-promote-passkey-idf-testid",
                                type: "submit",
                                isFullWidth: true,
                                onClick: onPasskeysContinueButtonClicked,
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    ...(0, $d5THV.default).promotePasskeysContinue
                                })
                            })
                        }, "passkeys.promote.continue.container")
                    ]
                })
            ]
        })
    });
};
var $c92a074d6d33783c$export$2e2bcd8739ae039 = $c92a074d6d33783c$export$84ed94b8c66e0057;

});
parcelRegister("52XHP", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "mfa-enable.f2e108a8.png";

});

parcelRegister("d5THV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49a473bae1d4365e$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $49a473bae1d4365e$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    // olf mfa promote page
    promoteMfaHeader: {
        id: 'mfa.promote.header',
        defaultMessage: 'Enable two-step verification',
        description: 'Header to promote two-step verification'
    },
    promoteMfaMessageBody: {
        id: 'mfa.promote.message',
        defaultMessage: 'To keep your account secure, two-step verification adds another step when logging in with your username and password.',
        description: 'Main message to promote two-step verification'
    },
    promoteMfaLearnMore: {
        id: 'mfa.promote.learn',
        defaultMessage: 'Learn more about two-step verification',
        description: 'Text on link to learn more about two-step verification'
    },
    promoteMfaContinue: {
        id: 'mfa.promote.continue',
        defaultMessage: 'Enable two-step verification',
        description: 'Button text for continue to setup two-step verification'
    },
    promoteMfaDismiss: {
        id: 'mfa.promote.dismiss',
        defaultMessage: 'Continue without two-step verification',
        description: 'Button text for continuing without setting up two-step verification'
    },
    // new 'security review' page with mfa and passkeys
    promoteMfaPasskeysHeader: {
        id: 'mfa-passkeys.promote.header',
        defaultMessage: 'Security review',
        description: 'Header to promote two-step verification and passkeys'
    },
    promotePasskeysMessageBody: {
        id: 'passkeys.promote.message',
        defaultMessage: 'A passkey allows you to log in securely without additional steps.',
        description: 'Main message to promote passkeys'
    },
    promotePasskeysContinue: {
        id: 'passkeys.promote.continue',
        defaultMessage: 'Create a passkey',
        description: 'Button text for continue to setup passkeys'
    },
    promotePasskeysLearnMore: {
        id: 'passkeys.promote.learn',
        defaultMessage: 'Learn more about passkeys',
        description: 'Text on link to learn more about passkeys'
    }
});

});

parcelRegister("c8IJ3", function(module, exports) {

$parcel$export(module.exports, "handleMfaPromoteUserSelection", function () { return $0a05a06152c4f911$export$7eaa2fa4de4c2034; });

var $hqddj = parcelRequire("hqddj");
const $0a05a06152c4f911$var$loginPathWithErrorMessage = ()=>{
    const params = new URLSearchParams({
        errorCode: 'invalid.session.token',
        prompt: 'true'
    }).toString();
    return `${window.location.origin}/login?${params}`;
};
const $0a05a06152c4f911$export$7eaa2fa4de4c2034 = (choice, queryParams, continueUrlOptions)=>(dispatch)=>{
        return fetch(`/v2/mfa/promote${queryParams || ''}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                choice: choice
            })
        }).then((response)=>{
            if (response.status === 200) return response.json();
            else throw new Error(`${response.status} ${response.statusText}: /v2/mfa/promote`);
        }).then((body)=>{
            if (!body?.redirectTo) {
                (0, $hqddj.captureTaggedException)('/v2/mfa/promote did not return a redirectTo', {
                    capabilities: [
                        'capability-name--mfa-promote'
                    ]
                });
                dispatch($0a05a06152c4f911$export$d184870662dd3111($0a05a06152c4f911$var$loginPathWithErrorMessage()));
                return;
            }
            // Immediate redirect URL to /login/authorize, for session distribution
            const redirectUrl = new URL(body.redirectTo);
            // Ultimate destination URL (encoded under 'continue' search param on the redirect URL)
            const continueUrlParam = redirectUrl.searchParams.get('continue');
            if (continueUrlParam && continueUrlOptions?.additionalSearchParamsEntries) // Unwrap continue URL, add search params (e.g. around analytics), and re-wrap it.
            try {
                const continueUrl = new URL(continueUrlParam);
                continueUrlOptions.additionalSearchParamsEntries.forEach(([name, value])=>{
                    continueUrl.searchParams.append(name, value);
                });
                redirectUrl.searchParams.set('continue', continueUrl.toString());
            } catch (error) {
                (0, $hqddj.addBreadcrumb)({
                    category: 'mfa-promote.redirect',
                    message: 'Failed to add search params to the continue URL',
                    level: 'error'
                });
                (0, $hqddj.captureTaggedException)(error, {
                    capabilities: [
                        'capability-name--mfa-promote'
                    ]
                });
            }
            dispatch($0a05a06152c4f911$export$d184870662dd3111(redirectUrl.toString()));
        }).catch((error)=>{
            (0, $hqddj.captureTaggedException)(error, {
                capabilities: [
                    'capability-name--mfa-promote'
                ]
            });
            dispatch($0a05a06152c4f911$export$d184870662dd3111($0a05a06152c4f911$var$loginPathWithErrorMessage()));
        });
    };
const $0a05a06152c4f911$export$d184870662dd3111 = (redirectTo)=>({
        type: 'MFA_PROMOTE_REDIRECT',
        redirectTo: redirectTo
    });

});

parcelRegister("8IkGb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6582794e67b9570c$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $8Govx = parcelRequire("8Govx");

var $crcLK = parcelRequire("crcLK");

var $hnZEJ = parcelRequire("hnZEJ");

var $d433K = parcelRequire("d433K");
var $6582794e67b9570c$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $6582794e67b9570c$var$_excluded2 = [
    "className"
];
var $6582794e67b9570c$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $6582794e67b9570c$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(htmlAttributes, $6582794e67b9570c$var$_excluded2);
    var resolvedStyles = (0, $d433K.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $8Govx.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $6582794e67b9570c$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $hnZEJ.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $hnZEJ.isSurfaceColorToken)(backgroundColor) && (0, $hnZEJ.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $hnZEJ.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $hnZEJ.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $hnZEJ.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $hnZEJ.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $hnZEJ.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $hnZEJ.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $hnZEJ.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $8Govx.jsx)((0, $crcLK.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $6582794e67b9570c$export$2e2bcd8739ae039 = $6582794e67b9570c$export$e71c4d32a2263218;
var $6582794e67b9570c$var$baseStyles = (0, $8Govx.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("crcLK", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $90e1e953327af193$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $90e1e953327af193$export$1aeb4f6b93c4540d; });

var $dNMDr = parcelRequire("dNMDr");
var $90e1e953327af193$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dNMDr.createContext)('elevation.surface');
var $90e1e953327af193$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dNMDr.useContext)($90e1e953327af193$export$1ca2a26fecb070ae);
};
$90e1e953327af193$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("hnZEJ", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $ca84693cabe112b0$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $ca84693cabe112b0$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $ca84693cabe112b0$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $ca84693cabe112b0$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $ca84693cabe112b0$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $ca84693cabe112b0$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $ca84693cabe112b0$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $ca84693cabe112b0$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $ca84693cabe112b0$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $ca84693cabe112b0$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $ca84693cabe112b0$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $ca84693cabe112b0$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $ca84693cabe112b0$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $ca84693cabe112b0$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $ca84693cabe112b0$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $ca84693cabe112b0$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $ca84693cabe112b0$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $ca84693cabe112b0$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $ca84693cabe112b0$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "textSizeStylesMap", function () { return $ca84693cabe112b0$export$219d364c0da35ae4; });
$parcel$export(module.exports, "textWeightStylesMap", function () { return $ca84693cabe112b0$export$38845ca010b93505; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $ca84693cabe112b0$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $ca84693cabe112b0$export$5e65a44e5b6ecadb; });

var $91FVG = parcelRequire("91FVG");

var $8Govx = parcelRequire("8Govx");

var $3dreC = parcelRequire("3dreC");
function $ca84693cabe112b0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ca84693cabe112b0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ca84693cabe112b0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ca84693cabe112b0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ca84693cabe112b0$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $ca84693cabe112b0$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $ca84693cabe112b0$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $ca84693cabe112b0$export$632685d741f3dbbf = $ca84693cabe112b0$var$_objectSpread($ca84693cabe112b0$var$_objectSpread({}, $ca84693cabe112b0$export$958d0ae7f2977ae4), $ca84693cabe112b0$export$d2dc61f58390201c);
var $ca84693cabe112b0$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $ca84693cabe112b0$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $ca84693cabe112b0$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $ca84693cabe112b0$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $ca84693cabe112b0$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $ca84693cabe112b0$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $ca84693cabe112b0$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $ca84693cabe112b0$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $ca84693cabe112b0$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $ca84693cabe112b0$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    // @deprecated
    'border.width.0': "var(--ds-border-width-0, 0px)",
    // @deprecated
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    // @deprecated
    'border.width.outline': "var(--ds-border-width-outline, 2px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $ca84693cabe112b0$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)",
    // @deprecated
    'border.radius': "var(--ds-border-radius, 3px)",
    // @deprecated
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    // @deprecated
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    // @deprecated
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    // @deprecated
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    // @deprecated
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    // @deprecated
    'border.radius.circle': "var(--ds-border-radius-circle, 9999px)"
};
var $ca84693cabe112b0$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $ca84693cabe112b0$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $ca84693cabe112b0$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $ca84693cabe112b0$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $ca84693cabe112b0$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $ca84693cabe112b0$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $ca84693cabe112b0$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $ca84693cabe112b0$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $8Govx.css)((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $ca84693cabe112b0$export$e615f061ca585a6c = $ca84693cabe112b0$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ca84693cabe112b0$export$ca0f9c2de39ffed7(spacingProperty, $ca84693cabe112b0$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ca84693cabe112b0$export$bf46c3f9eeafc71f = $ca84693cabe112b0$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ca84693cabe112b0$export$ca0f9c2de39ffed7(spacingProperty, $ca84693cabe112b0$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ca84693cabe112b0$export$e7af83bafe7f9e63 = $ca84693cabe112b0$export$ca0f9c2de39ffed7('backgroundColor', $ca84693cabe112b0$export$d1d79bf68ac056bd);
var $ca84693cabe112b0$export$3a1bcba60b23d7f0 = $ca84693cabe112b0$export$ca0f9c2de39ffed7('color', $ca84693cabe112b0$export$8473307aa00d6ea1);
var $ca84693cabe112b0$export$45f3f4fe16f9f7d5 = $ca84693cabe112b0$export$ca0f9c2de39ffed7('fontWeight', $ca84693cabe112b0$export$303e322c6b1ed114);
var $ca84693cabe112b0$export$68cc305da27dbaa4 = $ca84693cabe112b0$export$ca0f9c2de39ffed7('fontFamily', $ca84693cabe112b0$export$3c7e9587132614b4);
var $ca84693cabe112b0$export$128f10c238242f83 = $ca84693cabe112b0$export$ca0f9c2de39ffed7('font', $ca84693cabe112b0$export$6ffa317d5e70375);
var $ca84693cabe112b0$export$219d364c0da35ae4 = $ca84693cabe112b0$export$ca0f9c2de39ffed7('font', $ca84693cabe112b0$export$236bfe3a33ef1292);
var $ca84693cabe112b0$export$38845ca010b93505 = $ca84693cabe112b0$export$ca0f9c2de39ffed7('fontWeight', $ca84693cabe112b0$export$855cfd311192d666);
var $ca84693cabe112b0$export$ff257d957d48c421 = $ca84693cabe112b0$export$ca0f9c2de39ffed7((0, $3dreC.CURRENT_SURFACE_CSS_VAR), $ca84693cabe112b0$export$41a358c9c2356760);
var $ca84693cabe112b0$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $ca84693cabe112b0$export$41a358c9c2356760[color] !== undefined;
};
var $ca84693cabe112b0$export$7001ce64d9ff7c7f = $ca84693cabe112b0$export$ca0f9c2de39ffed7('font', $ca84693cabe112b0$export$b805719bc8cb376);

});
parcelRegister("3dreC", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $2577b640a14a0440$export$9d7b58831ae93caa; });
var $2577b640a14a0440$export$4ef52930e33717cd = 'data-theme';
var $2577b640a14a0440$export$a00eac3f8684bcd0 = 'data-color-mode';
var $2577b640a14a0440$export$2112803007239c61 = 'data-contrast-mode';
var $2577b640a14a0440$export$352e418ed5b6193a = 'data-custom-theme';
var $2577b640a14a0440$export$6f0c6fb8c80fcc92 = 'ds';
var $2577b640a14a0440$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $2577b640a14a0440$export$dddac1532e822863 = "--".concat($2577b640a14a0440$export$6f0c6fb8c80fcc92, "-token-not-found");
var $2577b640a14a0440$export$9d7b58831ae93caa = "--".concat($2577b640a14a0440$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("d433K", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $982e05a60db288d6$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $982e05a60db288d6$export$f6c783d06584602c; });

var $62ppy = parcelRequire("62ppy");

var $91FVG = parcelRequire("91FVG");

var $82V4i = parcelRequire("82V4i");

var $a3ftr = parcelRequire("a3ftr");

var $8Govx = parcelRequire("8Govx");

var $hnZEJ = parcelRequire("hnZEJ");

var $4ilBr = parcelRequire("4ilBr");
function $982e05a60db288d6$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $982e05a60db288d6$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $982e05a60db288d6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $982e05a60db288d6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $982e05a60db288d6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $982e05a60db288d6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $982e05a60db288d6$export$9a199fbafee0014e = {
    backgroundColor: (0, $hnZEJ.backgroundColorMap),
    blockSize: (0, $hnZEJ.dimensionMap),
    borderBlockColor: (0, $hnZEJ.borderColorMap),
    borderBlockEndColor: (0, $hnZEJ.borderColorMap),
    borderBlockEndWidth: (0, $hnZEJ.borderWidthMap),
    borderBlockStartColor: (0, $hnZEJ.borderColorMap),
    borderBlockStartWidth: (0, $hnZEJ.borderWidthMap),
    borderBlockWidth: (0, $hnZEJ.borderWidthMap),
    borderBottomColor: (0, $hnZEJ.borderColorMap),
    borderBottomLeftRadius: (0, $hnZEJ.borderRadiusMap),
    borderBottomRightRadius: (0, $hnZEJ.borderRadiusMap),
    borderBottomWidth: (0, $hnZEJ.borderWidthMap),
    borderColor: (0, $hnZEJ.borderColorMap),
    borderEndEndRadius: (0, $hnZEJ.borderRadiusMap),
    borderEndStartRadius: (0, $hnZEJ.borderRadiusMap),
    borderInlineColor: (0, $hnZEJ.borderColorMap),
    borderInlineEndColor: (0, $hnZEJ.borderColorMap),
    borderInlineEndWidth: (0, $hnZEJ.borderWidthMap),
    borderInlineStartColor: (0, $hnZEJ.borderColorMap),
    borderInlineStartWidth: (0, $hnZEJ.borderWidthMap),
    borderInlineWidth: (0, $hnZEJ.borderWidthMap),
    borderLeftColor: (0, $hnZEJ.borderColorMap),
    borderLeftWidth: (0, $hnZEJ.borderWidthMap),
    borderRadius: (0, $hnZEJ.borderRadiusMap),
    borderRightColor: (0, $hnZEJ.borderColorMap),
    borderRightWidth: (0, $hnZEJ.borderWidthMap),
    borderStartEndRadius: (0, $hnZEJ.borderRadiusMap),
    borderStartStartRadius: (0, $hnZEJ.borderRadiusMap),
    borderTopColor: (0, $hnZEJ.borderColorMap),
    borderTopLeftRadius: (0, $hnZEJ.borderRadiusMap),
    borderTopRightRadius: (0, $hnZEJ.borderRadiusMap),
    borderTopWidth: (0, $hnZEJ.borderWidthMap),
    borderWidth: (0, $hnZEJ.borderWidthMap),
    bottom: (0, $hnZEJ.allSpaceMap),
    boxShadow: (0, $hnZEJ.shadowMap),
    color: (0, $hnZEJ.textColorMap),
    columnGap: (0, $hnZEJ.positiveSpaceMap),
    font: (0, $hnZEJ.fontMap),
    fontFamily: (0, $hnZEJ.fontFamilyMap),
    fontWeight: (0, $hnZEJ.fontWeightMap),
    gap: (0, $hnZEJ.positiveSpaceMap),
    height: (0, $hnZEJ.dimensionMap),
    inlineSize: (0, $hnZEJ.dimensionMap),
    inset: (0, $hnZEJ.allSpaceMap),
    insetBlock: (0, $hnZEJ.allSpaceMap),
    insetBlockEnd: (0, $hnZEJ.allSpaceMap),
    insetBlockStart: (0, $hnZEJ.allSpaceMap),
    insetInline: (0, $hnZEJ.allSpaceMap),
    insetInlineEnd: (0, $hnZEJ.allSpaceMap),
    insetInlineStart: (0, $hnZEJ.allSpaceMap),
    left: (0, $hnZEJ.allSpaceMap),
    margin: (0, $hnZEJ.allSpaceMap),
    marginBlock: (0, $hnZEJ.allSpaceMap),
    marginBlockEnd: (0, $hnZEJ.allSpaceMap),
    marginBlockStart: (0, $hnZEJ.allSpaceMap),
    marginBottom: (0, $hnZEJ.allSpaceMap),
    marginInline: (0, $hnZEJ.allSpaceMap),
    marginInlineEnd: (0, $hnZEJ.allSpaceMap),
    marginInlineStart: (0, $hnZEJ.allSpaceMap),
    marginLeft: (0, $hnZEJ.allSpaceMap),
    marginRight: (0, $hnZEJ.allSpaceMap),
    marginTop: (0, $hnZEJ.allSpaceMap),
    maxBlockSize: (0, $hnZEJ.dimensionMap),
    maxHeight: (0, $hnZEJ.dimensionMap),
    maxInlineSize: (0, $hnZEJ.dimensionMap),
    maxWidth: (0, $hnZEJ.dimensionMap),
    minBlockSize: (0, $hnZEJ.dimensionMap),
    minHeight: (0, $hnZEJ.dimensionMap),
    minInlineSize: (0, $hnZEJ.dimensionMap),
    minWidth: (0, $hnZEJ.dimensionMap),
    opacity: (0, $hnZEJ.opacityMap),
    outlineColor: (0, $hnZEJ.borderColorMap),
    outlineOffset: (0, $hnZEJ.allSpaceMap),
    outlineWidth: (0, $hnZEJ.borderWidthMap),
    padding: (0, $hnZEJ.positiveSpaceMap),
    paddingBlock: (0, $hnZEJ.positiveSpaceMap),
    paddingBlockEnd: (0, $hnZEJ.positiveSpaceMap),
    paddingBlockStart: (0, $hnZEJ.positiveSpaceMap),
    paddingBottom: (0, $hnZEJ.positiveSpaceMap),
    paddingInline: (0, $hnZEJ.positiveSpaceMap),
    paddingInlineEnd: (0, $hnZEJ.positiveSpaceMap),
    paddingInlineStart: (0, $hnZEJ.positiveSpaceMap),
    paddingLeft: (0, $hnZEJ.positiveSpaceMap),
    paddingRight: (0, $hnZEJ.positiveSpaceMap),
    paddingTop: (0, $hnZEJ.positiveSpaceMap),
    right: (0, $hnZEJ.allSpaceMap),
    rowGap: (0, $hnZEJ.positiveSpaceMap),
    top: (0, $hnZEJ.allSpaceMap),
    width: (0, $hnZEJ.dimensionMap),
    zIndex: (0, $hnZEJ.layerMap)
};
var $982e05a60db288d6$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $982e05a60db288d6$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $4ilBr === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))($4ilBr)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))($4ilBr.env) === 'object' && false;
};
var $982e05a60db288d6$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $982e05a60db288d6$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $982e05a60db288d6$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($982e05a60db288d6$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(value) === 'object' && $982e05a60db288d6$var$safeSelectors.test(key)) {
            styleObj[key] = $982e05a60db288d6$var$_transformStyles(value);
            return;
        }
        if ($982e05a60db288d6$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($982e05a60db288d6$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $982e05a60db288d6$export$9a199fbafee0014e)) return;
        var tokenValue = $982e05a60db288d6$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $982e05a60db288d6$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $982e05a60db288d6$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, $982e05a60db288d6$var$uniqueSymbol, (0, $8Govx.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $982e05a60db288d6$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $982e05a60db288d6$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $982e05a60db288d6$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$982e05a60db288d6$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $982e05a60db288d6$export$f6c783d06584602c(style) {
    return $982e05a60db288d6$var$baseXcss(style);
}

});


parcelRegister("j2wBm", function(module, exports) {

$parcel$export(module.exports, "usePasskeyEnrollmentTaskSession", function () { return $083e88d096a3be73$export$ba44034e00de1c2f; });

var $dNMDr = parcelRequire("dNMDr");

var $4NPio = parcelRequire("4NPio");
const $083e88d096a3be73$export$a8f6c6b2df34b7c6 = 'passkey-enroll';
const $083e88d096a3be73$export$69567f7eb03d717 = 'X-Task-Session-Id';
const $083e88d096a3be73$export$ba44034e00de1c2f = ()=>{
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const [taskSessionId, setTaskSessionId] = (0, $dNMDr.useState)();
    (0, $dNMDr.useEffect)(()=>{
        if (taskSessionId) return;
        const awc = analyticsClient.getInstance();
        const sessionId = awc.task.createTaskSession($083e88d096a3be73$export$a8f6c6b2df34b7c6);
        setTaskSessionId(sessionId);
    }, [
        taskSessionId,
        analyticsClient
    ]);
    const getUrlSearchEntriesForTaskSession = (0, $dNMDr.useCallback)(()=>{
        if (!taskSessionId) return [];
        const taskSessionParamKey = `awc.${$083e88d096a3be73$export$a8f6c6b2df34b7c6}`;
        return [
            [
                taskSessionParamKey,
                taskSessionId
            ]
        ];
    }, [
        taskSessionId
    ]);
    return {
        getUrlSearchEntriesForTaskSession: getUrlSearchEntriesForTaskSession
    };
};

});


parcelRegister("eX172", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "mfaLoader", function () { return $9f39f973d90b2ea9$export$8902dd3d9caf7997; });
$parcel$export(module.exports, "recoverExpiredLoader", function () { return $9f39f973d90b2ea9$export$bd26e265ac7ee3e1; });
$parcel$export(module.exports, "MultiFactorPage", function () { return $9f39f973d90b2ea9$export$d5523937d2306712; });
$parcel$export(module.exports, "default", function () { return $9f39f973d90b2ea9$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $cpaps = parcelRequire("cpaps");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $dWOVN = parcelRequire("dWOVN");

var $7lC8o = parcelRequire("7lC8o");

var $doMYO = parcelRequire("doMYO");

var $9IARI = parcelRequire("9IARI");

var $ln5Gj = parcelRequire("ln5Gj");

var $iZRuI = parcelRequire("iZRuI");

var $2uMua = parcelRequire("2uMua");

var $duAyH = parcelRequire("duAyH");

var $eTWY7 = parcelRequire("eTWY7");

var $5pCRv = parcelRequire("5pCRv");

var $Q6OOA = parcelRequire("Q6OOA");

var $idMOo = parcelRequire("idMOo");

var $737na = parcelRequire("737na");

var $aMBBA = parcelRequire("aMBBA");

var $4NPio = parcelRequire("4NPio");

var $bi5Lm = parcelRequire("bi5Lm");
parcelRequire("jM5Ly");
var $hMPjy = parcelRequire("hMPjy");

var $j1629 = parcelRequire("j1629");

var $h4v4M = parcelRequire("h4v4M");

var $4ljBU = parcelRequire("4ljBU");

var $eZOsi = parcelRequire("eZOsi");

var $84ZjZ = parcelRequire("84ZjZ");

var $cBB3b = parcelRequire("cBB3b");

var $cFZwW = parcelRequire("cFZwW");
const $9f39f973d90b2ea9$var$pageId = 'multiFactorPage';
const $9f39f973d90b2ea9$var$challengeId = '2svChallengeScreen';
const $9f39f973d90b2ea9$var$expireId = '2svRecoveryLinkExpiredScreen';
const $9f39f973d90b2ea9$var$emergencyRecoveryKey = '2svRecoveryKeyScreen';
const $9f39f973d90b2ea9$var$saveNewRecoveryKey = '2svSaveNewRecoveryKey';
const $9f39f973d90b2ea9$var$accountRecovery = '2svAccountRecoveryScreen';
const $9f39f973d90b2ea9$var$recoveryEmailSent = '2svRecoveryEmailSentScreen';
async function $9f39f973d90b2ea9$export$8902dd3d9caf7997({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/login/mfa/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
async function $9f39f973d90b2ea9$export$bd26e265ac7ee3e1({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/2step/recover/expired/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $9f39f973d90b2ea9$export$d5523937d2306712 = ({ isExpired: isExpired })=>{
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const { isExecuting: isExecuting, executeWithTracking: executeWithTracking } = (0, $eZOsi.useExecutionTracker)();
    const isEmbedded = (0, $aMBBA.useAppSelector)((state)=>state.microbranding.isEmbedded);
    const { method: multifactorMethod, phoneNumber: phoneNumber, isLoading: isLoading, isManaged: isManaged, isRecoveryEmailSent: isRecoveryEmailSent, recoveryEmailError: recoveryEmailError, fieldErrors: fieldErrors, recoveryCode: recoveryCode, clearInputTrigger: clearInputTrigger } = (0, $aMBBA.useAppSelector)((state)=>state.multiFactor);
    const email = (0, $aMBBA.useAppSelector)((state)=>{
        const mfEmail = state.multiFactor.email;
        const userEmail = state.user.email;
        return mfEmail && mfEmail.length > 0 ? mfEmail : userEmail;
    });
    const { search: search } = (0, $cVnBY.useLocation)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    (0, $4NPio.usePageViewedEvent)($9f39f973d90b2ea9$var$pageId);
    (0, $4NPio.useOperationalEvent)({
        page: $9f39f973d90b2ea9$var$pageId,
        action: `loadMultiFactorPageSuccessful`,
        subject: 'sli'
    });
    const isInitialRender = (0, $dNMDr.useRef)(true);
    const mfaEventAttributes = (0, $dNMDr.useMemo)(()=>({
            multifactorMethod: multifactorMethod
        }), [
        multifactorMethod
    ]);
    // User will initially be prompted for the challenged factor, but can switch to the "Recovery code" screen,
    // or futher from there, the "Account recovery" screen.
    // This mode is to keep track of which screen the user is on.
    const [mode, setMode] = (0, $dNMDr.useState)('CHALLENGED_FACTOR');
    const previousMode = (0, $hMPjy.usePrevious)(mode);
    (0, $dNMDr.useEffect)(()=>{
        // After initial render, whenever the mode changes we want to trigger pageViewedEvents:
        if (isInitialRender.current) return;
        isInitialRender.current = false;
        if (mode !== previousMode) switch(mode){
            case 'RECOVERY_EMAIL':
                analyticsClient.pageViewedEvent($9f39f973d90b2ea9$var$accountRecovery);
                break;
            case 'RECOVERY_CODE':
                analyticsClient.pageViewedEvent($9f39f973d90b2ea9$var$emergencyRecoveryKey, mfaEventAttributes);
                break;
            case 'CHALLENGED_FACTOR':
                analyticsClient.pageViewedEvent($9f39f973d90b2ea9$var$challengeId, mfaEventAttributes);
                break;
        }
    }, [
        mode,
        analyticsClient,
        multifactorMethod,
        mfaEventAttributes,
        previousMode
    ]);
    const trackConfirmedRecoveryCode = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$saveNewRecoveryKey, '2svSavedNewRecoveryKey');
    const dispatchConfirmedRecoveryCode = (0, $dNMDr.useCallback)(()=>{
        trackConfirmedRecoveryCode();
        dispatch((0, $doMYO.confirmedRecoveryCode)(search, analyticsClient, navigate));
    }, [
        trackConfirmedRecoveryCode,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const trackVerifyOtpCode = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$challengeId, '2svChallengeLogin', mfaEventAttributes);
    const dispatchVerifyOtpCode = (0, $dNMDr.useCallback)((otpCode)=>{
        trackVerifyOtpCode();
        dispatch((0, $doMYO.verifyOtpCode)(search, otpCode, analyticsClient, navigate));
    }, [
        trackVerifyOtpCode,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const trackVerifyRecoveryCode = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$emergencyRecoveryKey, '2svRecoveryKeyLogin', mfaEventAttributes);
    const verifyRecoveryCode = (0, $dNMDr.useCallback)((recoveryCode)=>{
        trackVerifyRecoveryCode();
        dispatch((0, $doMYO.recoverAccount)(search, recoveryCode, analyticsClient, navigate));
    }, [
        trackVerifyRecoveryCode,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const trackResendSms = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$challengeId, '2svResendSms');
    const resendOtpSms = (0, $dNMDr.useCallback)(()=>{
        trackResendSms();
        dispatch((0, $doMYO.resendOtp)(search, analyticsClient, navigate, multifactorMethod));
    }, [
        trackResendSms,
        dispatch,
        search,
        analyticsClient,
        navigate,
        multifactorMethod
    ]);
    const trackResendEmailOtp = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$challengeId, '2svResendEmailOtp');
    const resendOtpEmail = (0, $dNMDr.useCallback)(()=>{
        trackResendEmailOtp();
        dispatch((0, $doMYO.resendOtp)(search, analyticsClient, navigate, multifactorMethod));
    }, [
        trackResendEmailOtp,
        dispatch,
        search,
        analyticsClient,
        navigate,
        multifactorMethod
    ]);
    const trackUseOtpCode = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$emergencyRecoveryKey, 'usePhone', mfaEventAttributes);
    const trackUseSecurityKey = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$emergencyRecoveryKey, 'useSecurityKey', mfaEventAttributes);
    const useOtpCode = (0, $dNMDr.useCallback)(()=>{
        trackUseOtpCode();
        setMode('CHALLENGED_FACTOR');
    }, [
        trackUseOtpCode
    ]);
    const useSecurityKey = (0, $dNMDr.useCallback)(()=>{
        trackUseSecurityKey();
        setMode('CHALLENGED_FACTOR');
    }, [
        trackUseSecurityKey
    ]);
    const trackUseRecoveryCode = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$accountRecovery, '2svAccountRecoveryScreen');
    const trackCantUsePhone = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$challengeId, 'cantUsePhone');
    const trackCantUseSecurityKey = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$challengeId, 'cantUseSecurityKey');
    const useRecoveryCode = (0, $dNMDr.useCallback)(()=>{
        switch(mode){
            case 'RECOVERY_EMAIL':
                trackUseRecoveryCode();
                break;
            case 'CHALLENGED_FACTOR':
                if (multifactorMethod === 'security-key') trackCantUseSecurityKey();
                else trackCantUsePhone();
                break;
        }
        setMode('RECOVERY_CODE');
    }, [
        trackUseRecoveryCode,
        trackCantUsePhone,
        trackCantUseSecurityKey,
        mode,
        multifactorMethod
    ]);
    const trackUseRecoveryEmail = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$emergencyRecoveryKey, 'noRecoveryKey');
    const useRecoveryEmail = (0, $dNMDr.useCallback)(()=>{
        trackUseRecoveryEmail();
        setMode('RECOVERY_EMAIL');
    }, [
        trackUseRecoveryEmail
    ]);
    const navigateToLogin = (0, $bi5Lm.useNavigateToLoginPrompt)();
    const trackReturnToLogin = (0, $4NPio.useLinkClickedEvent)($9f39f973d90b2ea9$var$pageId, 'returnToLogin');
    const handleReturnToLogin = (0, $dNMDr.useCallback)(()=>{
        trackReturnToLogin();
        navigateToLogin();
    }, [
        trackReturnToLogin,
        navigateToLogin
    ]);
    const renderMainContentFooter = ()=>{
        if (mode === 'RECOVERY_EMAIL' && !isRecoveryEmailSent && !isExpired) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
            id: "two-step-verification-enter-back-recovery-key",
            onClick: useRecoveryCode,
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "mf.backtouserecoverycode",
                defaultMessage: "Enter your recovery key"
            })
        });
        else if (isRecoveryEmailSent || isExpired) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
            id: "two-step-verification-switch-challenge-type",
            onClick: resendEmail,
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "mf.resendrecoveryemail",
                defaultMessage: "Resend recovery email"
            })
        });
        else if (mode === 'CHALLENGED_FACTOR') {
            if (multifactorMethod === 'security-key') return /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cFZwW.default), {
                        screenId: $9f39f973d90b2ea9$var$challengeId,
                        isSwitching: isExecuting,
                        switchWithTracking: executeWithTracking
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                        id: "two-step-verification-switch-challenge-type-1",
                        testId: "two-step-verification-switch-challenge-type-idf-testid",
                        onClick: useRecoveryCode,
                        isDisabled: isExecuting,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            ...(0, $737na.default).mfSwitchToRecoveryCode
                        })
                    })
                ]
            });
            else if (multifactorMethod === 'sms' || multifactorMethod === 'otp') return /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cFZwW.default), {
                        screenId: $9f39f973d90b2ea9$var$challengeId,
                        isSwitching: isExecuting,
                        switchWithTracking: executeWithTracking
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                        id: "two-step-verification-switch-challenge-type",
                        testId: "two-step-verification-switch-challenge-type-idf-testid",
                        onClick: useRecoveryCode,
                        isDisabled: isExecuting,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            ...(0, $737na.default).mfSwitchToRecoveryCode
                        })
                    })
                ]
            });
            else // email-otp should never call this function
            return null;
        } else if (mode === 'RECOVERY_CODE') return /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
            children: [
                isManaged === false && /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                        id: "two-step-verification-switch-challenge-type",
                        onClick: useRecoveryEmail,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "mf.userecoveryemail",
                            defaultMessage: "Can't find your recovery key?"
                        })
                    })
                }),
                multifactorMethod === 'security-key' ? /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                        onClick: useSecurityKey,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "mf.useyoursecuritykey",
                            defaultMessage: "Use your security key instead"
                        })
                    })
                }) : /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                        onClick: useOtpCode,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "mf.backtouseotpcode.sms",
                            defaultMessage: "Use SMS instead"
                        })
                    })
                })
            ]
        });
        else if (!isEmbedded) return /*#__PURE__*/ (0, $6CtE1.jsx)("a", {
            href: "https://confluence.atlassian.com/cloud/secure-your-account-with-two-step-verification-939505063.html#Secureyouraccountwithtwo-stepverification-Recoveryouraccount",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "mf.gethelp",
                defaultMessage: "Help for two-step verification"
            })
        });
    };
    const renderFooter = ()=>{
        if (!isEmbedded) return /*#__PURE__*/ (0, $6CtE1.jsxs)("ul", {
            className: "fine-print",
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.PrivacyPolicyLink), {
                        isMobileLink: false
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $idMOo.default), {}),
                /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.UserNoticeLink), {
                        isMobileLink: false
                    })
                })
            ]
        });
    };
    const renderHeader = ()=>{
        if (isExpired) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "login.title.recoverylinkexpired",
                defaultMessage: "Your recovery link expired"
            })
        });
        else if (mode === 'CHALLENGED_FACTOR' || mode === 'RECOVERY_CODE') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "continue.with.two.step.verification",
                defaultMessage: "Continue with two-step verification"
            })
        });
        else return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "mf.title.norecoverycode",
                defaultMessage: "Recover your account"
            })
        });
    };
    const trackSendRecoveryEmail = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$accountRecovery, 'sendRecoveryEmail');
    const sendEmail = (0, $dNMDr.useCallback)(()=>{
        trackSendRecoveryEmail();
        dispatch((0, $doMYO.sendRecoveryEmail)(email));
    }, [
        trackSendRecoveryEmail,
        dispatch,
        email
    ]);
    const trackResendEmail = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$recoveryEmailSent, 'resendEmail');
    const trackResendEmailExpired = (0, $4NPio.useButtonClickedEvent)($9f39f973d90b2ea9$var$expireId, 'resendEmail');
    const resendEmail = (0, $dNMDr.useCallback)(()=>{
        sendEmail();
        if (isExpired) trackResendEmailExpired();
        else trackResendEmail();
        if (isRecoveryEmailSent) dispatch((0, $7lC8o.addFlag)('success', (0, $737na.default).mfRecoveryEmailResentSuccessTitle, (0, $737na.default).mfRecoveryEmailResentSuccessDesc));
        else dispatch((0, $7lC8o.addFlag)('error', (0, $737na.default).mfRecoveryEmailResentErrorTitle, (0, $737na.default).mfRecoveryEmailResentErrorDesc));
    }, [
        sendEmail,
        isExpired,
        isRecoveryEmailSent,
        trackResendEmailExpired,
        trackResendEmail,
        dispatch
    ]);
    const renderWhiteboxPageContent = ()=>{
        if (isRecoveryEmailSent || isExpired) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $iZRuI.default), {
            email: email,
            isExpired: isExpired,
            expirePageId: $9f39f973d90b2ea9$var$expireId,
            emailSentPageId: $9f39f973d90b2ea9$var$recoveryEmailSent
        });
        if (mode === 'CHALLENGED_FACTOR') {
            if (multifactorMethod === 'sms' || multifactorMethod === 'otp') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $9IARI.default), {
                verifyOtpCode: dispatchVerifyOtpCode,
                resendOtp: resendOtpSms,
                isLoading: isLoading,
                otpError: fieldErrors.otpCode,
                multifactorMethod: multifactorMethod,
                phoneNumber: phoneNumber,
                clearInputTrigger: clearInputTrigger
            });
            if (multifactorMethod === 'security-key') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $9IARI.default), {
                isLoading: isLoading,
                multifactorMethod: multifactorMethod,
                clearInputTrigger: clearInputTrigger
            });
        } else if (mode === 'RECOVERY_CODE') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2uMua.default), {
            recoverAccount: verifyRecoveryCode,
            isLoading: isLoading,
            multifactorMethod: multifactorMethod,
            recoveryError: fieldErrors.recoveryCode
        });
        else if (mode === 'RECOVERY_EMAIL') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ln5Gj.default), {
            email: email,
            sendEmail: sendEmail,
            recoveryEmailError: recoveryEmailError
        });
    };
    const renderGenericExperience = ()=>{
        return !recoveryCode ? /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
            pageId: $9f39f973d90b2ea9$var$pageId,
            header: renderHeader(),
            whiteboxFooter: renderMainContentFooter(),
            footer: renderFooter(),
            noCobranding: true,
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)("title", {
                        children: formatMessage((0, $737na.default).loginHeadTitle)
                    })
                }),
                renderWhiteboxPageContent()
            ]
        }) : /*#__PURE__*/ (0, $6CtE1.jsx)((0, $duAyH.default), {
            recoveryCode: recoveryCode,
            onComplete: dispatchConfirmedRecoveryCode,
            isEmbedded: isEmbedded
        });
    };
    const verifyEmailOtpErrorCodeMapping = {
        invalid_otp: 'invalid_otp',
        invalid_token: 'invalid_token',
        invalid_otp_format: 'invalid_otp_length'
    };
    const renderEmailOtpExperience = ()=>{
        const otpErrorCode = fieldErrors?.otpCode?.errorCode;
        const verifyEmailOtpErrorCode = !otpErrorCode ? undefined : verifyEmailOtpErrorCodeMapping[otpErrorCode] || 'unexpected_error';
        return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $j1629.default), {
            pageId: $9f39f973d90b2ea9$var$pageId,
            flow: "login-challenge",
            email: email,
            isLoading: isLoading,
            errorCode: verifyEmailOtpErrorCode,
            onVerifyEmailOtp: dispatchVerifyOtpCode,
            onResendEmailOtp: resendOtpEmail,
            additionalWhiteboxFooter: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                id: "two-step-verification-return-to-login",
                onClick: handleReturnToLogin,
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "mf.emailotp.return.to.login",
                    defaultMessage: "Log in to a different account"
                })
            })
        });
    };
    if (multifactorMethod === 'email-otp') return renderEmailOtpExperience();
    else return renderGenericExperience();
};
var $9f39f973d90b2ea9$export$2e2bcd8739ae039 = $9f39f973d90b2ea9$export$d5523937d2306712;

});
parcelRegister("9IARI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7dd7274c45a0f9cf$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $fbSBq = parcelRequire("fbSBq");

var $cr5CS = parcelRequire("cr5CS");

var $68HQw = parcelRequire("68HQw");

var $cTzf6 = parcelRequire("cTzf6");

var $crWLR = parcelRequire("crWLR");

var $2byD0 = parcelRequire("2byD0");

var $8dLb0 = parcelRequire("8dLb0");

var $8LYpt = parcelRequire("8LYpt");

var $8PbSs = parcelRequire("8PbSs");

var $dH3qM = parcelRequire("dH3qM");

var $5Fj6z = parcelRequire("5Fj6z");
const $7dd7274c45a0f9cf$var$ButtonContainer = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $7dd7274c45a0f9cf$var$ResendButton = (0, $fbSBq.default)((0, $cTzf6.default))`
  span {
    text-align: left;
    white-space: normal;
  }
`;
const $7dd7274c45a0f9cf$var$MultiFactorForm = ({ email: email, isLoading: isLoading, multifactorMethod: multifactorMethod, otpError: otpError, phoneNumber: phoneNumber, resendOtp: resendOtp, verifyOtpCode: verifyOtpCode, clearInputTrigger: clearInputTrigger })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const helpTooltip = (method, phoneNumber, email)=>{
        if (method === 'sms') {
            const resendButton = /*#__PURE__*/ (0, $6CtE1.jsx)($7dd7274c45a0f9cf$var$ResendButton, {
                id: "resend-sms",
                appearance: "link",
                onClick: resendOtp,
                spacing: "none",
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "mf.mfform.sms.resend",
                    defaultMessage: "Resend the text message."
                })
            });
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "mf.mfform.getsms.tooltip",
                tagName: "p",
                defaultMessage: "We've sent a text message (SMS) with the verification code to {mobileNumber}. Didn't get it? {resendButton}",
                values: {
                    mobileNumber: /*#__PURE__*/ (0, $6CtE1.jsx)("b", {
                        children: phoneNumber
                    }),
                    resendButton: resendButton
                }
            });
        }
        if (method === 'email-otp') {
            const resendButton = /*#__PURE__*/ (0, $6CtE1.jsx)($7dd7274c45a0f9cf$var$ResendButton, {
                id: "resend-email-otp",
                appearance: "link",
                onClick: resendOtp,
                spacing: "none",
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "mf.mfform.emailotp.resend",
                    defaultMessage: "Resend the verification code."
                })
            });
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "mf.mfform.emailotp.tooltip",
                tagName: "p",
                defaultMessage: "We've sent the verification code to {email}. Didn't get it? {resendButton}",
                values: {
                    email: /*#__PURE__*/ (0, $6CtE1.jsx)("b", {
                        children: email
                    }),
                    resendButton: resendButton
                }
            });
        }
        if (method === 'security-key') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "mf.mfform.securitykey.tooltip",
            tagName: "p",
            defaultMessage: "Use any security key you registered with Atlassian"
        });
        return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "mf.mfform.getcode.tooltip",
            tagName: "p",
            defaultMessage: "Open the verification app on your phone to get your verification code."
        });
    };
    const handleFormSubmit = (0, $dNMDr.useCallback)((e)=>{
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const otpCode = formData.get('otpCode')?.toString() ?? '';
        verifyOtpCode?.(otpCode);
    }, [
        verifyOtpCode
    ]);
    const otpPromptMessage = (0, $dNMDr.useMemo)(()=>{
        switch(multifactorMethod){
            case 'sms':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...(0, $5Fj6z.default).mfSmsPrompt
                });
            case 'otp':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...(0, $5Fj6z.default).mfTotpPrompt
                });
            case 'email-otp':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...(0, $5Fj6z.default).mfEmailPrompt
                });
            default:
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "mf.mfform.getcode",
                    defaultMessage: "Enter your verification code to continue."
                });
        }
    }, [
        multifactorMethod
    ]);
    const renderOtpForm = (codeLength, codeType)=>{
        return /*#__PURE__*/ (0, $6CtE1.jsxs)("form", {
            autoComplete: "off",
            onSubmit: handleFormSubmit,
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $8LYpt.InputMessage), {
                    children: [
                        otpPromptMessage,
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8LYpt.InlineMessageContainer), {
                            "data-testid": "mfform-tooltip-icon",
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cr5CS.default), {
                                appearance: "info",
                                placement: "bottom-end",
                                iconLabel: formatMessage({
                                    id: 'mf.mfform.getcode.tooltip.icon.label',
                                    defaultMessage: 'More info',
                                    description: 'Icon label for the help tooltip'
                                }),
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8LYpt.StyledMessage), {
                                    children: helpTooltip(multifactorMethod, phoneNumber, email)
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $crWLR.default), {
                    id: "two-step-verification-otp-code-input",
                    disabled: isLoading,
                    fieldErrorFromParent: otpError,
                    codeLength: codeLength,
                    codeType: codeType,
                    clearInputTrigger: clearInputTrigger
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)($7dd7274c45a0f9cf$var$ButtonContainer, {
                    id: "two-step-verification-submit",
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                        appearance: "primary",
                        type: "submit",
                        isFullWidth: true,
                        isLoading: isLoading,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "common.login",
                            defaultMessage: "Log in"
                        })
                    })
                })
            ]
        });
    };
    if (multifactorMethod === 'email-otp') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8PbSs.default), {
        children: renderOtpForm(6, 'alphanumeric')
    });
    else if (multifactorMethod === 'security-key') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dH3qM.default), {});
    else {
        const securityWallStyle = multifactorMethod === 'otp' ? 'totp' : 'default';
        return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8dLb0.SecurityWall), {
            id: "two-step-verification-form",
            securityWallStyle: securityWallStyle,
            children: renderOtpForm(6, 'numeric')
        });
    }
};
var $7dd7274c45a0f9cf$export$2e2bcd8739ae039 = $7dd7274c45a0f9cf$var$MultiFactorForm;

});
parcelRegister("cr5CS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90dc5ed7e65c0bcf$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $icVF1 = parcelRequire("icVF1");

var $hGahQ = parcelRequire("hGahQ");

var $gQLDR = parcelRequire("gQLDR");

var $2NKAr = parcelRequire("2NKAr");

var $l69Tm = parcelRequire("l69Tm");
var $eS3uG = parcelRequire("eS3uG");
var $aMk5E = parcelRequire("aMk5E");
var $eTcBP = parcelRequire("eTcBP");


var $5S5x3 = parcelRequire("5S5x3");
var $90dc5ed7e65c0bcf$var$_excluded = [
    "ref"
];
var $90dc5ed7e65c0bcf$var$styles = {
    contentStyles: "_bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi",
    heightAndWidthConstraints: "_1reo1wug _18m91wug _p12flti4 _c71llti4",
    rootStyles: "_1e0c1o8l _p12f1osq _1yyu1kum _y2mv1w7i",
    pressableStyles: "_2rko1qi0 _11c8fhey _1rjcze3t _18zrze3t _1e0c116y _bfhksm61 _syazazsu _o5721q9c _kqswh2mm _4cvr1q9y _p12f1osq _4t3i1wug _1bsb1wug _s7n41q9y _9oik1r31 _1bnx8stv _jf4cnqa1"
};
var $90dc5ed7e65c0bcf$var$iconColor = {
    connectivity: "_x5v91r2e",
    confirmation: "_x5v91fgg",
    info: "_x5v913wx",
    warning: "_x5v9f6ss",
    error: "_x5v9k8x7"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ var $90dc5ed7e65c0bcf$var$InlineMessage = function InlineMessage(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$secondaryText = _ref.secondaryText, secondaryText = _ref$secondaryText === void 0 ? '' : _ref$secondaryText, _ref$title = _ref.title, title = _ref$title === void 0 ? '' : _ref$title, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'connectivity' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'spacious' : _ref$spacing, children = _ref.children, testId = _ref.testId, iconLabel = _ref.iconLabel, fallbackPlacements = _ref.fallbackPlacements;
    var _useState = (0, $dNMDr.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var id = (0, $hGahQ.useId)();
    var toggleDialog = (0, $dNMDr.useCallback)(function() {
        setIsOpen(function(oldState) {
            return !oldState;
        });
    }, [
        setIsOpen
    ]);
    var onCloseDialog = (0, $dNMDr.useCallback)(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]);
    return /*#__PURE__*/ $dNMDr.createElement("div", {
        "data-testid": testId,
        className: (0, $affTb.default)([
            $90dc5ed7e65c0bcf$var$styles.rootStyles,
            $90dc5ed7e65c0bcf$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $dNMDr.createElement((0, $2NKAr.default), {
        onClose: onCloseDialog,
        content: function content() {
            return /*#__PURE__*/ $dNMDr.createElement((0, $l69Tm.default), {
                xcss: (0, $icVF1.cx)($90dc5ed7e65c0bcf$var$styles.contentStyles, (0, $gQLDR.fg)('add-max-width-and-height-to-inline-message') && $90dc5ed7e65c0bcf$var$styles.heightAndWidthConstraints)
            }, children);
        },
        isOpen: isOpen,
        placement: placement,
        testId: testId && "".concat(testId, "--popup"),
        fallbackPlacements: fallbackPlacements,
        shouldRenderToParent: true,
        role: "dialog",
        titleId: id,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, triggerProps = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref2, $90dc5ed7e65c0bcf$var$_excluded);
            return /*#__PURE__*/ $dNMDr.createElement((0, $aMk5E.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, triggerProps, {
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && "".concat(testId, "--button"),
                xcss: $90dc5ed7e65c0bcf$var$styles.pressableStyles,
                "aria-expanded": isOpen
            }), /*#__PURE__*/ $dNMDr.createElement((0, $eS3uG.default), {
                as: "span",
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $dNMDr.createElement((0, $5S5x3.default), {
                isOpen: isOpen,
                appearance: appearance,
                label: iconLabel,
                spacing: spacing
            }), /*#__PURE__*/ $dNMDr.createElement((0, $eS3uG.default), {
                as: "span",
                space: "space.100"
            }, title && /*#__PURE__*/ $dNMDr.createElement((0, $eTcBP.default), {
                weight: "medium",
                testId: testId && "".concat(testId, "--title")
            }, title), secondaryText && /*#__PURE__*/ $dNMDr.createElement((0, $eTcBP.default), {
                weight: "medium",
                color: "color.text.subtlest",
                maxLines: 1,
                testId: testId && "".concat(testId, "--text")
            }, secondaryText))));
        }
    }));
};
var $90dc5ed7e65c0bcf$export$2e2bcd8739ae039 = $90dc5ed7e65c0bcf$var$InlineMessage;

});
parcelRegister("2NKAr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20a44b8e76a7774d$export$2e2bcd8739ae039; });

var $385w7 = parcelRequire("385w7");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$20a44b8e76a7774d$export$2e2bcd8739ae039 = (0, $385w7.Popup);

});
parcelRegister("385w7", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return $24766600b3bbbf93$export$129a32eedafa97c5; });
/* popup.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");


var $hGahQ = parcelRequire("hGahQ");

var $3WqMD = parcelRequire("3WqMD");

var $Xcbzo = parcelRequire("Xcbzo");

var $gQLDR = parcelRequire("gQLDR");

var $kxRx6 = parcelRequire("kxRx6");
var $8PPcT = parcelRequire("8PPcT");

var $1w48L = parcelRequire("1w48L");

var $l69Tm = parcelRequire("l69Tm");

var $fXLFN = parcelRequire("fXLFN");

var $kPOSV = parcelRequire("kPOSV");

var $6LLiz = parcelRequire("6LLiz");

var $jjXzZ = parcelRequire("jjXzZ");
var $24766600b3bbbf93$var$defaultLayer = 400;
var $24766600b3bbbf93$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $24766600b3bbbf93$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $dNMDr.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $24766600b3bbbf93$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $dNMDr.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $6LLiz.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $jjXzZ.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $hGahQ.useId)();
    var _usePopupAppearance = (0, $kPOSV.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $dNMDr.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $Xcbzo.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    var renderPopperWrapper = /*#__PURE__*/ $dNMDr.createElement((0, $3WqMD.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $dNMDr.createElement((0, $fXLFN.default), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $dNMDr.createElement((0, $kxRx6.Manager), null, /*#__PURE__*/ $dNMDr.createElement((0, $8PPcT.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $gQLDR.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $gQLDR.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $dNMDr.createElement((0, $1w48L.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return /*#__PURE__*/ $dNMDr.createElement((0, $l69Tm.default), {
        xcss: $24766600b3bbbf93$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});

});
parcelRegister("3WqMD", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $2deb9080891ab595$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "LevelNodeContext", function () { return $2deb9080891ab595$export$18f4d8b5b3a77f59; });
$parcel$export(module.exports, "RootNodeContext", function () { return $2deb9080891ab595$export$fa973f110e8f6ca8; });
$parcel$export(module.exports, "Layering", function () { return $2deb9080891ab595$export$7c885f891c940977; });

var $dNMDr = parcelRequire("dNMDr");

var $ci8Pj = parcelRequire("ci8Pj");
var $2deb9080891ab595$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $dNMDr.createContext)(0);
var $2deb9080891ab595$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $dNMDr.createContext)({
    current: null
});
var $2deb9080891ab595$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $dNMDr.createContext)({
    current: null
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $2deb9080891ab595$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $dNMDr.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($2deb9080891ab595$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($2deb9080891ab595$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
var $2deb9080891ab595$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $dNMDr.useContext)($2deb9080891ab595$export$650d12d3c2ddb8fc);
    var parentNode = (0, $dNMDr.useContext)($2deb9080891ab595$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $dNMDr.useRef)(new (0, $ci8Pj.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($2deb9080891ab595$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($2deb9080891ab595$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};

});
parcelRegister("ci8Pj", function(module, exports) {

$parcel$export(module.exports, "LayerNode", function () { return $8f2e0344ac0f8c51$export$da4f61fd78d35243; });

var $62ppy = parcelRequire("62ppy");

var $lPkGR = parcelRequire("lPkGR");

var $c9XBY = parcelRequire("c9XBY");
var $8f2e0344ac0f8c51$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($lPkGR)))(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9XBY)))(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});


parcelRegister("8PPcT", function(module, exports) {

$parcel$export(module.exports, "Reference", function () { return $66eacec6b9d67337$export$e0be378c32fb70a7; });

var $dNMDr = parcelRequire("dNMDr");

var $9pog3 = parcelRequire("9pog3");

var $kxRx6 = parcelRequire("kxRx6");

var $glObX = parcelRequire("glObX");
function $66eacec6b9d67337$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $dNMDr.useContext((0, $kxRx6.ManagerReferenceNodeSetterContext));
    var refHandler = $dNMDr.useCallback(function(node) {
        (0, $glObX.setRef)(innerRef, node);
        (0, $glObX.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $dNMDr.useEffect(function() {
        return function() {
            return (0, $glObX.setRef)(innerRef, null);
        };
    }, []);
    $dNMDr.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9pog3)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $glObX.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("9pog3", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $6d9943f5df729a63$var$__DEV__ = false;
var $6d9943f5df729a63$var$warning = function() {};
if ($6d9943f5df729a63$var$__DEV__) {
    var $6d9943f5df729a63$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $6d9943f5df729a63$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $6d9943f5df729a63$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $6d9943f5df729a63$var$warning;

});


parcelRegister("fXLFN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9f15891c0a490ff$export$2e2bcd8739ae039; });
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $62ppy = parcelRequire("62ppy");

var $82V4i = parcelRequire("82V4i");

var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $i2T7w = parcelRequire("i2T7w");

var $gQLDR = parcelRequire("gQLDR");

var $ePfkq = parcelRequire("ePfkq");

var $fOzyY = parcelRequire("fOzyY");

var $1Od8f = parcelRequire("1Od8f");

var $1YzB6 = parcelRequire("1YzB6");
var $b9f15891c0a490ff$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden",
    "shouldFitViewport"
];
var $b9f15891c0a490ff$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $b9f15891c0a490ff$var$fullWidthStyles = null;
var $b9f15891c0a490ff$var$wrapperStyles = {
    root: "_2rko12b0 _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    rootT26Shape: "_2rko1mok"
};
var $b9f15891c0a490ff$var$scrollableStyles = null;
var $b9f15891c0a490ff$var$blanketStyles = null;
var $b9f15891c0a490ff$var$modalStyles = null;
var $b9f15891c0a490ff$var$newModalStyles = null;
var $b9f15891c0a490ff$var$focusRingStyles = {
    root: "_mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
var $b9f15891c0a490ff$var$DefaultPopupComponent = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, _isReferenceHidden = props.isReferenceHidden, shouldFitViewport = props.shouldFitViewport, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(props, $b9f15891c0a490ff$var$_excluded);
    return /*#__PURE__*/ $dNMDr.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $affTb.default)([
            $b9f15891c0a490ff$var$wrapperStyles.root,
            (0, $gQLDR.fg)('platform-dst-shape-theme-default') && $b9f15891c0a490ff$var$wrapperStyles.rootT26Shape,
            appearance === 'UNSAFE_modal-below-sm' && !(0, $gQLDR.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            appearance === 'UNSAFE_modal-below-sm' && (0, $gQLDR.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport && (0, $gQLDR.fg)('platform_dst_nav4_flyoutmenuitem_render_to_parent')) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $b9f15891c0a490ff$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $b9f15891c0a490ff$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $dNMDr.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $dNMDr.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $1YzB6.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $1Od8f.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $i2T7w.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $dNMDr.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $dNMDr.createElement((0, $ePfkq.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $dNMDr.createElement(PopupContainer, {
            className: (0, $affTb.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && (0, $gQLDR.fg)('platform-design-system-apply-popup-wrapper-focus') && $b9f15891c0a490ff$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $dNMDr.createElement((0, $fOzyY.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return /*#__PURE__*/ $dNMDr.createElement((0, $dNMDr.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $dNMDr.createElement("div", {
            className: (0, $affTb.default)([
                "_1r04idpf _kqsw1n9t _bfhk1i5c"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b9f15891c0a490ff$export$2e2bcd8739ae039 = $b9f15891c0a490ff$var$PopperWrapper;

});
parcelRegister("i2T7w", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", function () { return $d2332ba92c1b6950$export$4a4bf067ea9e7886; });
$parcel$export(module.exports, "useLayering", function () { return $d2332ba92c1b6950$export$c8b4d54e03dee6ed; });

var $dNMDr = parcelRequire("dNMDr");

var $40QgJ = parcelRequire("40QgJ");

var $3WqMD = parcelRequire("3WqMD");
var $d2332ba92c1b6950$var$ESCAPE = 'Escape';
function $d2332ba92c1b6950$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $dNMDr.useRef)(false);
    var _useLayering = $d2332ba92c1b6950$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $dNMDr.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $d2332ba92c1b6950$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $dNMDr.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $dNMDr.useEffect)(function() {
        return (0, $40QgJ.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $d2332ba92c1b6950$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $dNMDr.useContext)((0, $3WqMD.LevelContext));
    var layerNode = (0, $dNMDr.useContext)((0, $3WqMD.LevelNodeContext));
    var rootNode = (0, $dNMDr.useContext)((0, $3WqMD.RootNodeContext));
    var isLayerDisabled = (0, $dNMDr.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $dNMDr.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});

parcelRegister("fOzyY", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", function () { return $b8371ca198c68406$export$51eddd7655ca235a; });

var $dNMDr = parcelRequire("dNMDr");
var $b8371ca198c68406$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $dNMDr.useRef)(true);
    (0, $dNMDr.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dNMDr.Fragment), null, children);
};

});

parcelRegister("1Od8f", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", function () { return $1514a5b51233cc8d$export$92dae2778ae88f9d; });
// eslint-disable-next-line no-duplicate-imports

var $dNMDr = parcelRequire("dNMDr");

var $40QgJ = parcelRequire("40QgJ");

var $c3KQG = parcelRequire("c3KQG");

var $i2T7w = parcelRequire("i2T7w");

var $gQLDR = parcelRequire("gQLDR");

var $lTK2l = parcelRequire("lTK2l");

var $b9CVj = parcelRequire("b9CVj");
var $1514a5b51233cc8d$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $i2T7w.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $b9CVj.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var mouseDownTarget = (0, $dNMDr.useRef)(null);
    (0, $dNMDr.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $c3KQG.default;
        var closePopup = function closePopup(event) {
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest, _event$target$closest2;
                    _currentLevel = (_event$target$closest = (_event$target$closest2 = event.target.closest("[data-ds--level]")) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.getAttribute('data-ds--level')) !== null && _event$target$closest !== void 0 ? _event$target$closest : null;
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $gQLDR.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            var didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $lTK2l.isInteractiveElement)(document.activeElement) && (0, $gQLDR.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onMouseDown = function onMouseDown(event) {
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        var onKeyDown = function onKeyDown(event) {
            var key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $gQLDR.fg)('platform_dst_nested_escape')) {
                var _eventTarget$closest;
                var eventTarget = event.target instanceof HTMLElement ? event.target : null;
                var layeredAncestor = eventTarget === null || eventTarget === void 0 || (_eventTarget$closest = eventTarget.closest) === null || _eventTarget$closest === void 0 ? void 0 : _eventTarget$closest.call(eventTarget, '[data-ds--level]');
                var levelStr = layeredAncestor === null || layeredAncestor === void 0 ? void 0 : layeredAncestor.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $gQLDR.fg)('platform_dst_popup-disable-focuslock')) {
                var shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        var unbind = (0, $c3KQG.default);
        if ((0, $gQLDR.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $40QgJ.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $40QgJ.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $c3KQG.default);
        unbindBlur = (0, $40QgJ.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            if ((0, $gQLDR.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("lTK2l", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", function () { return $ff1271f82d9feb6e$export$3dee5e4542c672d9; });
var $ff1271f82d9feb6e$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $ff1271f82d9feb6e$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($ff1271f82d9feb6e$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("b9CVj", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrame", function () { return $81eeba5c394ac2b4$export$641fa9c94086b46e; });

var $dNMDr = parcelRequire("dNMDr");
var $81eeba5c394ac2b4$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $dNMDr.useRef)([]);
    var requestFrame = (0, $dNMDr.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $dNMDr.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $dNMDr.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("1YzB6", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", function () { return $170701f37804eaee$export$10c5169755ce7bd7; });

var $dNMDr = parcelRequire("dNMDr");

var $2ipGY = parcelRequire("2ipGY");

var $c3KQG = parcelRequire("c3KQG");

var $i2T7w = parcelRequire("i2T7w");

var $gQLDR = parcelRequire("gQLDR");

var $b9CVj = parcelRequire("b9CVj");
var $170701f37804eaee$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $b9CVj.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $i2T7w.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $dNMDr.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $c3KQG.default;
        if (shouldDisableFocusTrap && (0, $gQLDR.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $c3KQG.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $gQLDR.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($2ipGY)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});
parcelRegister("2ipGY", function(module, exports) {

var $hz3Ct = parcelRequire("hz3Ct");
var $1ac1311c2c6cdd00$var$listeningFocusTrap = null;
function $1ac1311c2c6cdd00$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $1ac1311c2c6cdd00$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($1ac1311c2c6cdd00$var$listeningFocusTrap) $1ac1311c2c6cdd00$var$listeningFocusTrap.pause();
        $1ac1311c2c6cdd00$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $1ac1311c2c6cdd00$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $1ac1311c2c6cdd00$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $1ac1311c2c6cdd00$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $1ac1311c2c6cdd00$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $1ac1311c2c6cdd00$var$tryFocus(lastTabbableNode);
            return $1ac1311c2c6cdd00$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $1ac1311c2c6cdd00$var$tryFocus(firstTabbableNode);
        $1ac1311c2c6cdd00$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $hz3Ct(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $1ac1311c2c6cdd00$var$tryFocus(lastTabbableNode);
        $1ac1311c2c6cdd00$var$tryFocus(firstTabbableNode);
    }
}
function $1ac1311c2c6cdd00$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $1ac1311c2c6cdd00$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $1ac1311c2c6cdd00$var$focusTrap;

});
parcelRegister("hz3Ct", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $034cc84fc79b33a1$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $034cc84fc79b33a1$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});




parcelRegister("kPOSV", function(module, exports) {

$parcel$export(module.exports, "usePopupAppearance", function () { return $f2b00abef82cb5b5$export$4065aef1d79a5730; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $FSpo6 = parcelRequire("FSpo6");
function $f2b00abef82cb5b5$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $FSpo6.UNSAFE_useMediaQuery)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $dNMDr.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("FSpo6", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $07de08d7267d8017$export$49e55ae2c03d6045; });

var $dNMDr = parcelRequire("dNMDr");

var $40QgJ = parcelRequire("40QgJ");

var $gEPvE = parcelRequire("gEPvE");
var $07de08d7267d8017$var$_window, $07de08d7267d8017$var$_window$matchMedia, $07de08d7267d8017$var$_window2, $07de08d7267d8017$var$_window2$matchMedia, $07de08d7267d8017$var$_window3, $07de08d7267d8017$var$_window3$matchMedia, $07de08d7267d8017$var$_window4, $07de08d7267d8017$var$_window4$matchMedia, $07de08d7267d8017$var$_window5, $07de08d7267d8017$var$_window5$matchMedia, $07de08d7267d8017$var$_window6, $07de08d7267d8017$var$_window6$matchMedia, $07de08d7267d8017$var$_window7, $07de08d7267d8017$var$_window7$matchMedia, $07de08d7267d8017$var$_window8, $07de08d7267d8017$var$_window8$matchMedia, $07de08d7267d8017$var$_window9, $07de08d7267d8017$var$_window9$matchMedia, $07de08d7267d8017$var$_window0, $07de08d7267d8017$var$_window0$matchMedia, $07de08d7267d8017$var$_window1, $07de08d7267d8017$var$_window1$matchMedia;
var $07de08d7267d8017$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($07de08d7267d8017$var$_window = window) === null || $07de08d7267d8017$var$_window === void 0 || ($07de08d7267d8017$var$_window$matchMedia = $07de08d7267d8017$var$_window.matchMedia) === null || $07de08d7267d8017$var$_window$matchMedia === void 0 ? void 0 : $07de08d7267d8017$var$_window$matchMedia.call($07de08d7267d8017$var$_window, (0, $gEPvE.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($07de08d7267d8017$var$_window2 = window) === null || $07de08d7267d8017$var$_window2 === void 0 || ($07de08d7267d8017$var$_window2$matchMedia = $07de08d7267d8017$var$_window2.matchMedia) === null || $07de08d7267d8017$var$_window2$matchMedia === void 0 ? void 0 : $07de08d7267d8017$var$_window2$matchMedia.call($07de08d7267d8017$var$_window2, (0, $gEPvE.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($07de08d7267d8017$var$_window3 = window) === null || $07de08d7267d8017$var$_window3 === void 0 || ($07de08d7267d8017$var$_window3$matchMedia = $07de08d7267d8017$var$_window3.matchMedia) === null || $07de08d7267d8017$var$_window3$matchMedia === void 0 ? void 0 : $07de08d7267d8017$var$_window3$matchMedia.call($07de08d7267d8017$var$_window3, (0, $gEPvE.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($07de08d7267d8017$var$_window4 = window) === null || $07de08d7267d8017$var$_window4 === void 0 || ($07de08d7267d8017$var$_window4$matchMedia = $07de08d7267d8017$var$_window4.matchMedia) === null || $07de08d7267d8017$var$_window4$matchMedia === void 0 ? void 0 : $07de08d7267d8017$var$_window4$matchMedia.call($07de08d7267d8017$var$_window4, (0, $gEPvE.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($07de08d7267d8017$var$_window5 = window) === null || $07de08d7267d8017$var$_window5 === void 0 || ($07de08d7267d8017$var$_window5$matchMedia = $07de08d7267d8017$var$_window5.matchMedia) === null || $07de08d7267d8017$var$_window5$matchMedia === void 0 ? void 0 : $07de08d7267d8017$var$_window5$matchMedia.call($07de08d7267d8017$var$_window5, (0, $gEPvE.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($07de08d7267d8017$var$_window6 = window) === null || $07de08d7267d8017$var$_window6 === void 0 || ($07de08d7267d8017$var$_window6$matchMedia = $07de08d7267d8017$var$_window6.matchMedia) === null || $07de08d7267d8017$var$_window6$matchMedia === void 0 ? void 0 : $07de08d7267d8017$var$_window6$matchMedia.call($07de08d7267d8017$var$_window6, (0, $gEPvE.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($07de08d7267d8017$var$_window7 = window) === null || $07de08d7267d8017$var$_window7 === void 0 || ($07de08d7267d8017$var$_window7$matchMedia = $07de08d7267d8017$var$_window7.matchMedia) === null || $07de08d7267d8017$var$_window7$matchMedia === void 0 ? void 0 : $07de08d7267d8017$var$_window7$matchMedia.call($07de08d7267d8017$var$_window7, (0, $gEPvE.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($07de08d7267d8017$var$_window8 = window) === null || $07de08d7267d8017$var$_window8 === void 0 || ($07de08d7267d8017$var$_window8$matchMedia = $07de08d7267d8017$var$_window8.matchMedia) === null || $07de08d7267d8017$var$_window8$matchMedia === void 0 ? void 0 : $07de08d7267d8017$var$_window8$matchMedia.call($07de08d7267d8017$var$_window8, (0, $gEPvE.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($07de08d7267d8017$var$_window9 = window) === null || $07de08d7267d8017$var$_window9 === void 0 || ($07de08d7267d8017$var$_window9$matchMedia = $07de08d7267d8017$var$_window9.matchMedia) === null || $07de08d7267d8017$var$_window9$matchMedia === void 0 ? void 0 : $07de08d7267d8017$var$_window9$matchMedia.call($07de08d7267d8017$var$_window9, (0, $gEPvE.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($07de08d7267d8017$var$_window0 = window) === null || $07de08d7267d8017$var$_window0 === void 0 || ($07de08d7267d8017$var$_window0$matchMedia = $07de08d7267d8017$var$_window0.matchMedia) === null || $07de08d7267d8017$var$_window0$matchMedia === void 0 ? void 0 : $07de08d7267d8017$var$_window0$matchMedia.call($07de08d7267d8017$var$_window0, (0, $gEPvE.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($07de08d7267d8017$var$_window1 = window) === null || $07de08d7267d8017$var$_window1 === void 0 || ($07de08d7267d8017$var$_window1$matchMedia = $07de08d7267d8017$var$_window1.matchMedia) === null || $07de08d7267d8017$var$_window1$matchMedia === void 0 ? void 0 : $07de08d7267d8017$var$_window1$matchMedia.call($07de08d7267d8017$var$_window1, (0, $gEPvE.media).below.xl.replace('@media ', '').trim())
};
var $07de08d7267d8017$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $dNMDr.useRef)(listener);
    (0, $dNMDr.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $07de08d7267d8017$var$queries[queryString];
    (0, $dNMDr.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $40QgJ.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("gEPvE", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $c208567ce4956b10$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $c208567ce4956b10$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("6LLiz", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $4edbd25d9c3d5786$export$7cc5c058dd769dff; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $92vrF = parcelRequire("92vrF");
var $4edbd25d9c3d5786$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $dNMDr.useState)(function() {
        return (0, $92vrF.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("jjXzZ", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", function () { return $e10e01ef6f8f9ed3$export$5d3a2de79e07b376; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $92vrF = parcelRequire("92vrF");
var $e10e01ef6f8f9ed3$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $dNMDr.useState)(function() {
        return (0, $92vrF.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("eTcBP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad6ffbab61f1a098$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $3kWa2 = parcelRequire("3kWa2");

var $hzfsN = parcelRequire("hzfsN");

var $bB3G7 = parcelRequire("bB3G7");
var $ad6ffbab61f1a098$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $ad6ffbab61f1a098$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $bB3G7.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($ad6ffbab61f1a098$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $ad6ffbab61f1a098$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $ad6ffbab61f1a098$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $ad6ffbab61f1a098$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $ad6ffbab61f1a098$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $ad6ffbab61f1a098$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $ad6ffbab61f1a098$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $ad6ffbab61f1a098$var$Text = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $3kWa2.default)($ad6ffbab61f1a098$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $hzfsN.useHasTextAncestor)();
    var color = $ad6ffbab61f1a098$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $dNMDr.createElement(Component, {
        id: id,
        className: (0, $affTb.default)([
            $ad6ffbab61f1a098$var$styles.root,
            size && $ad6ffbab61f1a098$var$fontSizeMap[size],
            color && $ad6ffbab61f1a098$var$textColorMap[color],
            maxLines && $ad6ffbab61f1a098$var$styles.truncation,
            maxLines === 1 && $ad6ffbab61f1a098$var$styles.breakAll,
            align && $ad6ffbab61f1a098$var$styles["textAlign.".concat(align)],
            weight && $ad6ffbab61f1a098$var$fontWeightMap[weight],
            Component === 'em' && $ad6ffbab61f1a098$var$styles['as.em'],
            Component === 'strong' && $ad6ffbab61f1a098$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $dNMDr.createElement((0, $hzfsN.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $ad6ffbab61f1a098$export$2e2bcd8739ae039 = $ad6ffbab61f1a098$var$Text;

});
parcelRegister("hzfsN", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", function () { return $cca1b33fd98b0b45$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $cca1b33fd98b0b45$export$ae933c6cbe5643ad; });

var $dNMDr = parcelRequire("dNMDr");
var $cca1b33fd98b0b45$var$HasTextAncestorContext = /*#__PURE__*/ (0, $dNMDr.createContext)(false);
var $cca1b33fd98b0b45$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $dNMDr.useContext)($cca1b33fd98b0b45$var$HasTextAncestorContext);
};
var $cca1b33fd98b0b45$export$ae933c6cbe5643ad = $cca1b33fd98b0b45$var$HasTextAncestorContext.Provider;

});


parcelRegister("5S5x3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $446649793d573a00$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");


var $jwQ8w = parcelRequire("jwQ8w");
var $446649793d573a00$var$iconColor = {
    connectivity: "_1b3i1c86",
    confirmation: "_1b3icdx1",
    info: "_1b3ige5s",
    warning: "_1b3i1n6p",
    error: "_1b3i1378"
};
var $446649793d573a00$var$iconWrapperStyles = null;
var $446649793d573a00$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ var $446649793d573a00$var$SelectedIcon = function SelectedIcon(_ref) {
    var appearance = _ref.appearance, isOpen = _ref.isOpen, label = _ref.label, spacing = _ref.spacing;
    var _typesMapping$appeara = (0, $jwQ8w.typesMapping)[appearance], Icon = _typesMapping$appeara.icon, defaultLabel = _typesMapping$appeara.defaultLabel;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $affTb.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $446649793d573a00$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $dNMDr.createElement(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        color: "currentColor",
        spacing: spacing
    }));
};
var $446649793d573a00$export$2e2bcd8739ae039 = $446649793d573a00$var$SelectedIcon;

});
parcelRegister("jwQ8w", function(module, exports) {

$parcel$export(module.exports, "typesMapping", function () { return $e37972b3b5a87874$export$4d111645c0b39d5d; });

var $fGClI = parcelRequire("fGClI");

var $eZLWJ = parcelRequire("eZLWJ");

var $2MiNU = parcelRequire("2MiNU");

var $fIC9d = parcelRequire("fIC9d");
var $e37972b3b5a87874$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fIC9d))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MiNU))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eZLWJ))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fIC9d))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fGClI))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("crWLR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bacdf1ccd8e374a3$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $kvy9X = parcelRequire("kvy9X");

var $79HVl = parcelRequire("79HVl");

var $2byD0 = parcelRequire("2byD0");

var $6osFG = parcelRequire("6osFG");
parcelRequire("jM5Ly");
var $hMPjy = parcelRequire("hMPjy");
const $bacdf1ccd8e374a3$var$getAcceptableCharsRegex = (codeType)=>{
    switch(codeType){
        case 'numeric':
            return '\\d';
        case 'alphanumeric':
            return '[A-Za-z\\d]';
        default:
            return '.';
    }
};
const $bacdf1ccd8e374a3$var$sanitizeInput = (input, acceptableCharsRegex)=>{
    return input.match(new RegExp(acceptableCharsRegex, 'g'))?.join('') || '';
};
const $bacdf1ccd8e374a3$var$getInputValidation = (codeType, codeLength, acceptableCharsRegex, formatMessage)=>{
    if (codeLength === undefined) return {
        label: formatMessage((0, $6osFG.default).mfFormLabel),
        pattern: `${acceptableCharsRegex}+`,
        maxLength: undefined
    };
    else {
        const descriptor = codeType == 'numeric' ? (0, $6osFG.default).mfFormLabelNDigits : (0, $6osFG.default).mfFormLabelNCharacters;
        return {
            label: formatMessage(descriptor, {
                codeLength: codeLength
            }),
            pattern: `${acceptableCharsRegex}{${codeLength}}`,
            maxLength: codeLength
        };
    }
};
const $bacdf1ccd8e374a3$var$OtpCodeField = ({ codeLength: codeLength, codeType: codeType, disabled: disabled, fieldErrorFromParent: fieldErrorFromParent, id: id, onChange: onChange, clearInputTrigger: clearInputTrigger })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const fieldTextRef = (0, $dNMDr.useRef)(null);
    const [fieldValue, setFieldValue] = (0, $dNMDr.useState)('');
    const [fieldError, setFieldError] = (0, $dNMDr.useState)(fieldErrorFromParent);
    const previousFieldErrorFromParent = (0, $hMPjy.usePrevious)(fieldErrorFromParent);
    const previousFieldValue = (0, $hMPjy.usePrevious)(fieldValue);
    const previousClearInputTrigger = (0, $hMPjy.usePrevious)(clearInputTrigger);
    const acceptableCharsRegex = $bacdf1ccd8e374a3$var$getAcceptableCharsRegex(codeType);
    const { maxLength: maxLength, pattern: pattern, label: label } = $bacdf1ccd8e374a3$var$getInputValidation(codeType, codeLength, acceptableCharsRegex, formatMessage);
    (0, $dNMDr.useEffect)(()=>{
        if (!previousFieldErrorFromParent && fieldErrorFromParent) {
            setFieldError(fieldErrorFromParent);
            fieldTextRef.current && fieldTextRef.current.select();
        }
    }, [
        fieldErrorFromParent,
        previousFieldErrorFromParent
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (clearInputTrigger && clearInputTrigger !== previousClearInputTrigger) {
            setFieldValue('');
            setFieldError(undefined);
        }
    }, [
        clearInputTrigger,
        previousClearInputTrigger
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (fieldValue !== previousFieldValue) onChange && onChange({
            target: fieldTextRef.current
        });
    }, [
        fieldValue,
        previousFieldValue,
        onChange
    ]);
    const handlePaste = (0, $dNMDr.useCallback)((e)=>{
        const target = e.target;
        const selectionStart = target.selectionStart || 0;
        const selectionEnd = target.selectionEnd || target.value.length;
        const start = target.value.substr(0, selectionStart);
        const clipboardData = (e.clipboardData || window.clipboardData).getData('text/plain');
        const sanitized = $bacdf1ccd8e374a3$var$sanitizeInput(clipboardData, acceptableCharsRegex);
        const middle = codeLength === undefined ? sanitized : sanitized.substr(0, target.maxLength - target.value.length - selectionStart + selectionEnd);
        const end = target.value.substr(selectionEnd);
        //timeout to allow input update UI
        setTimeout(()=>setFieldValue(start + middle + end));
    }, [
        codeLength,
        acceptableCharsRegex
    ]);
    const handleChange = (0, $dNMDr.useCallback)((e)=>{
        setFieldValue($bacdf1ccd8e374a3$var$sanitizeInput(e.currentTarget.value, acceptableCharsRegex));
        setFieldError(undefined);
    }, [
        acceptableCharsRegex
    ]);
    const handleInvalid = (0, $dNMDr.useCallback)((e)=>{
        e.preventDefault();
        setFieldError({
            errorCode: 'invalid_otp_pattern'
        });
    }, []);
    (0, $dNMDr.useEffect)(()=>{
        const input = fieldTextRef.current;
        if (input) {
            input.addEventListener('invalid', handleInvalid);
            input.addEventListener('paste', handlePaste);
        }
        return ()=>{
            if (input) {
                input.removeEventListener('invalid', handleInvalid);
                input.removeEventListener('paste', handlePaste);
            }
        };
    }, [
        handleInvalid,
        handlePaste
    ]);
    const errorContent = (error)=>{
        switch(error && error.errorCode){
            case 'invalid_otp':
                return formatMessage((0, $6osFG.default).errorsInvalidOtp);
            case 'invalid_otp_format':
                return formatMessage((0, $6osFG.default).errorsInvalidOtpFormat);
            case 'invalid_otp_pattern':
                return formatMessage((0, $6osFG.default).errorsInvalidOtpPattern, {
                    codeLength: codeLength
                });
            case 'expired_otp':
                return formatMessage((0, $6osFG.default).errorsExpiredOtp);
            case 'too_many_requests':
                return formatMessage((0, $6osFG.default).errorsInvalidOtp);
            case 'unknown':
                return formatMessage((0, $6osFG.default).errorsUnknown);
            case 'invalid_token':
                return /*#__PURE__*/ (0, $6CtE1.jsxs)("form", {
                    onSubmit: ()=>window.location.reload(),
                    children: [
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "mf.mfform.errors.invalid_token",
                            defaultMessage: "Your session has expired. Please refresh the page and try again."
                        }),
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                                type: "submit",
                                isFullWidth: true,
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    id: "common.refresh",
                                    defaultMessage: "Refresh"
                                })
                            })
                        })
                    ]
                });
            default:
                return undefined;
        }
    };
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kvy9X.default), {
        id: id,
        name: "otpCode",
        type: codeType === 'numeric' ? 'tel' : 'text',
        label: label,
        autoFocus: true,
        maxLength: maxLength,
        pattern: pattern,
        onChange: handleChange,
        isInvalid: !!fieldError,
        invalidMessage: !disabled && fieldError && errorContent(fieldError),
        value: fieldValue,
        isDisabled: disabled,
        isRequired: true,
        ref: fieldTextRef
    });
};
var $bacdf1ccd8e374a3$export$2e2bcd8739ae039 = $bacdf1ccd8e374a3$var$OtpCodeField;

});
parcelRegister("kvy9X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $173bec6785d6fe8b$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $1lkpU = parcelRequire("1lkpU");

var $7imrD = parcelRequire("7imrD");
var $aij7o = parcelRequire("aij7o");

var $ccbHt = parcelRequire("ccbHt");
const $173bec6785d6fe8b$var$FormTextField = ({ name: name, label: label, isLabelHidden: isLabelHidden, invalidMessage: invalidMessage, testId: testId, isRequired: isRequired, elemAfterInput: elemAfterInput, ...props }, ref)=>{
    const ariaDescribedBy = (fieldProps)=>{
        const invalidMessageError = invalidMessage ? `${fieldProps.id}-error` : '';
        const ariaDescribedByMessage = props['aria-describedby'] ?? '';
        return invalidMessageError.concat(' ', ariaDescribedByMessage);
    };
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $aij7o.default), {
        name: name,
        label: !isLabelHidden && label,
        isRequired: isRequired,
        "aria-required": isRequired,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $6CtE1.jsxs)((0, $dNMDr.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ccbHt.default), {
                        alignBlock: "center",
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $1lkpU.default), {
                            ...fieldProps,
                            ...props,
                            isInvalid: !!invalidMessage,
                            "aria-describedby": ariaDescribedBy(fieldProps),
                            testId: testId,
                            ref: ref,
                            elemAfterInput: elemAfterInput
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7imrD.MessageWrapper), {
                        children: invalidMessage && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7imrD.ErrorMessage), {
                            testId: "form-text-field--input-invalid-error-message-field--idf-testid",
                            children: invalidMessage
                        })
                    })
                ]
            })
    });
};
var $173bec6785d6fe8b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).forwardRef($173bec6785d6fe8b$var$FormTextField);

});
parcelRegister("1lkpU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fa796f9d009560e$export$2e2bcd8739ae039; });
/* text-field.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $a3ftr = parcelRequire("a3ftr");

var $91FVG = parcelRequire("91FVG");

var $bM2vx = parcelRequire("bM2vx");

var $affTb = parcelRequire("affTb");

var $dNMDr = parcelRequire("dNMDr");

var $02D9g = parcelRequire("02D9g");

var $gQLDR = parcelRequire("gQLDR");
var $0fa796f9d009560e$var$_excluded = [
    "appearance",
    "className",
    "elemAfterInput",
    "elemBeforeInput",
    "isCompact",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "isReadOnly",
    "isRequired",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "placeholder",
    "testId",
    "width"
];
function $0fa796f9d009560e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0fa796f9d009560e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0fa796f9d009560e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0fa796f9d009560e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0fa796f9d009560e$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
var $0fa796f9d009560e$var$inputMediaDisabled = null;
var $0fa796f9d009560e$var$analyticsParams = {
    componentName: 'textField',
    packageName: "@atlaskit/textfield",
    packageVersion: "0.0.0-development"
};
var $0fa796f9d009560e$var$disabledStyle = {
    standard: "_1h6dby5v _bfhkby5v _syaz1gmx _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf"
};
var $0fa796f9d009560e$var$invalidStyle = null;
var $0fa796f9d009560e$var$focusWithinStyle = {
    standard: "_1p9x1v1w _qao9r01l _q433vyy1",
    subtle: "_1p9x1v1w _qao9r01l _q433vyy1",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
var $0fa796f9d009560e$var$hoverStyle = {
    standard: "_4cvxrsbi _irr3l4ek",
    subtle: "_4cvxrsbi _irr3l4ek",
    none: "_4cvx1j28 _irr31j28"
};
var $0fa796f9d009560e$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6drsbi _1dqonqa1 _syazi7uo _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syazi7uo _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syazi7uo _80om1kdv _16hg1j28 _msj6gir2"
};
var $0fa796f9d009560e$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
var $0fa796f9d009560e$var$getMaxWidth = function getMaxWidth(width) {
    return !width ? "100%" : width in $0fa796f9d009560e$var$widthMap ? "".concat($0fa796f9d009560e$var$widthMap[width], "px") : "".concat(+width, "px");
};
var $0fa796f9d009560e$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
var $0fa796f9d009560e$var$containerStyles = null;
var $0fa796f9d009560e$var$containerStylesT26Shape = null;
var $0fa796f9d009560e$var$inputDisabledStyle = null;
var $0fa796f9d009560e$var$inputCompactStyle = null;
var $0fa796f9d009560e$var$inputMonospacedStyle = null;
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textfield uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
var $0fa796f9d009560e$var$inputStyle = null;
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ var $0fa796f9d009560e$var$Textfield = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'standard' : _props$appearance, className = props.className, elemAfterInput = props.elemAfterInput, elemBeforeInput = props.elemBeforeInput, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseDown = props.onMouseDown, placeholder = props.placeholder, testId = props.testId, width = props.width, spreadProps = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(props, $0fa796f9d009560e$var$_excluded);
    var inputRef = (0, $dNMDr.useRef)(null);
    var handleOnFocus = (0, $02D9g.usePlatformLeafEventHandler)($0fa796f9d009560e$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, $0fa796f9d009560e$var$analyticsParams));
    var handleOnBlur = (0, $02D9g.usePlatformLeafEventHandler)($0fa796f9d009560e$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, $0fa796f9d009560e$var$analyticsParams));
    var handleOnMouseDown = (0, $dNMDr.useCallback)(function(event) {
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        var target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    var setInputRef = (0, $dNMDr.useCallback)(function(inputElement) {
        inputRef.current = inputElement;
        if (!ref) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(ref) === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && "".concat(testId, "-container"),
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: "".concat($0fa796f9d009560e$var$getMaxWidth(width))
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $affTb.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c8fhey _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnqfajl",
            (0, $gQLDR.fg)('platform-dst-shape-theme-default') && "_1tnq1qi0",
            $0fa796f9d009560e$var$getContainerTextBgAndBorderColor[appearance],
            $0fa796f9d009560e$var$containerStyleAppearance[appearance],
            !isDisabled && $0fa796f9d009560e$var$focusWithinStyle[appearance],
            !isDisabled && $0fa796f9d009560e$var$hoverStyle[appearance],
            isDisabled && $0fa796f9d009560e$var$containerMedia.disabled,
            isDisabled && $0fa796f9d009560e$var$disabledStyle[appearance],
            isInvalid && $0fa796f9d009560e$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ])
    }, elemBeforeInput, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, spreadProps, {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired,
        className: (0, $affTb.default)([
            "_19itidpf _11c81d4k _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr1rpy _1tn2fhey _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
            isMonospaced && "_ect4zzfg _14mdzzfg",
            isCompact && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
            isDisabled && "_syaz1gmx _1idr1gmx",
            isDisabled && "_1fnx18qt"
        ])
    })), elemAfterInput);
});
var $0fa796f9d009560e$export$2e2bcd8739ae039 = $0fa796f9d009560e$var$Textfield;

});

parcelRegister("7imrD", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", function () { return $54fb9fe55325956e$export$8fbe3c7d0ed2c683; });
$parcel$export(module.exports, "ErrorMessage", function () { return $54fb9fe55325956e$export$915e9e7bd4f0f96d; });
$parcel$export(module.exports, "ValidMessage", function () { return $54fb9fe55325956e$export$5505afb209a532c8; });
$parcel$export(module.exports, "MessageWrapper", function () { return $54fb9fe55325956e$export$ec445f12f63100a5; });
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $grvIM = parcelRequire("grvIM");

var $6vgaN = parcelRequire("6vgaN");

var $3qO8r = parcelRequire("3qO8r");

var $gQLDR = parcelRequire("gQLDR");

var $cbMXR = parcelRequire("cbMXR");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $54fb9fe55325956e$var$messageStyles = null;
var $54fb9fe55325956e$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
var $54fb9fe55325956e$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
var $54fb9fe55325956e$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        className: (0, $grvIM.default)([
            $54fb9fe55325956e$var$iconWrapperStyles.root
        ])
    }, children);
};
var $54fb9fe55325956e$var$messageIcons = {
    error: /*#__PURE__*/ $dNMDr.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6vgaN))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ $dNMDr.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3qO8r))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
var $54fb9fe55325956e$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $54fb9fe55325956e$var$messageIcons[appearance];
    var _useContext = (0, $dNMDr.useContext)($54fb9fe55325956e$var$MessageWrapperContext), isWrapper = _useContext.isWrapper;
    var _useState = (0, $dNMDr.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), shouldRenderAfterDelay = _useState2[0], setShouldRenderAfterDelay = _useState2[1];
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    var isDelayRenderEnabled = (0, $gQLDR.fg)('platform_dst_form_screenreader_message_fix') && !isWrapper;
    (0, $dNMDr.useEffect)(function() {
        if (isDelayRenderEnabled) {
            // Only delay rendering if there is no wrapper and feature flag is enabled
            var timer = setTimeout(function() {
                setShouldRenderAfterDelay(true);
            }, 10);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        isDelayRenderEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === 'string' ? children : /*#__PURE__*/ $dNMDr.createElement("span", null, children);
    var childrenToRender = /*#__PURE__*/ $dNMDr.createElement((0, $dNMDr.Fragment), null, icon && /*#__PURE__*/ $dNMDr.createElement($54fb9fe55325956e$var$IconWrapper, null, icon), content);
    return /*#__PURE__*/ $dNMDr.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        "aria-live": !isWrapper ? 'polite' : undefined,
        className: (0, $grvIM.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $54fb9fe55325956e$var$messageAppearanceStyles[appearance]
        ])
    }, isDelayRenderEnabled ? shouldRenderAfterDelay && childrenToRender : childrenToRender);
};
var $54fb9fe55325956e$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $dNMDr.createElement((0, $cbMXR.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $dNMDr.createElement($54fb9fe55325956e$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $54fb9fe55325956e$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return /*#__PURE__*/ $dNMDr.createElement((0, $cbMXR.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $dNMDr.createElement($54fb9fe55325956e$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $54fb9fe55325956e$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return /*#__PURE__*/ $dNMDr.createElement((0, $cbMXR.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $dNMDr.createElement($54fb9fe55325956e$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ var $54fb9fe55325956e$var$MessageWrapperContext = /*#__PURE__*/ (0, $dNMDr.createContext)({
    isWrapper: false
});
var $54fb9fe55325956e$export$ec445f12f63100a5 = function MessageWrapper(_ref6) {
    var children = _ref6.children;
    var contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ $dNMDr.createElement($54fb9fe55325956e$var$MessageWrapperContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $dNMDr.createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("6vgaN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0138cf358b8960eb$var$_react = $0138cf358b8960eb$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $0138cf358b8960eb$var$_statusError = $0138cf358b8960eb$var$_interopRequireDefault((parcelRequire("jlNOu")));

var $0138cf358b8960eb$var$_error = $0138cf358b8960eb$var$_interopRequireDefault((parcelRequire("1THBX")));
function $0138cf358b8960eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0138cf358b8960eb$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $0138cf358b8960eb$var$_react.default.createElement($0138cf358b8960eb$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $0138cf358b8960eb$var$_error.default
    }, props));
$0138cf358b8960eb$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $0138cf358b8960eb$var$_default = module.exports.default = $0138cf358b8960eb$var$StatusErrorIcon;

});
parcelRegister("jlNOu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1669e65bfa0163d$var$_react = $e1669e65bfa0163d$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $e1669e65bfa0163d$var$_baseNew = $e1669e65bfa0163d$var$_interopRequireDefault((parcelRequire("3Cur0")));
function $e1669e65bfa0163d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e1669e65bfa0163d$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $e1669e65bfa0163d$var$_react.default.createElement($e1669e65bfa0163d$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$e1669e65bfa0163d$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $e1669e65bfa0163d$var$_default = module.exports.default = $e1669e65bfa0163d$var$StatusErrorIcon;

});
parcelRegister("3Cur0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("4OOpf")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("4OOpf")).Icon; });

var $4OOpf = parcelRequire("4OOpf");

});
parcelRegister("4OOpf", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $3822ee913fa9f2be$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $3822ee913fa9f2be$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $gQLDR = parcelRequire("gQLDR");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $3822ee913fa9f2be$var$svgStyles = null;
var $3822ee913fa9f2be$var$iconStyles = null;
var $3822ee913fa9f2be$var$utilityIconStyles = null;
var $3822ee913fa9f2be$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $3822ee913fa9f2be$var$baseHcmStyles = null;
var $3822ee913fa9f2be$var$scaleSize = null;
var $3822ee913fa9f2be$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $3822ee913fa9f2be$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $3822ee913fa9f2be$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $3822ee913fa9f2be$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $3822ee913fa9f2be$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $3822ee913fa9f2be$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dNMDr.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $gQLDR.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $dNMDr.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $3822ee913fa9f2be$var$baseSizeMap[type];
    var viewBoxPadding = $3822ee913fa9f2be$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $affTb.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $dNMDr.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $affTb.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $3822ee913fa9f2be$var$utilSizes[spacing] : size === 'small' ? $3822ee913fa9f2be$var$coreSizeSmall[spacing] : $3822ee913fa9f2be$var$coreSizeMedium[spacing]
        ])
    }));
});
var $3822ee913fa9f2be$export$2e2bcd8739ae039 = $3822ee913fa9f2be$export$f04a61298a47a40f;

});



parcelRegister("1THBX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $161cc1cafa885ec4$var$_react = $161cc1cafa885ec4$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $8Hgmn = parcelRequire("8Hgmn");
function $161cc1cafa885ec4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $161cc1cafa885ec4$var$ErrorIcon = (props)=>/*#__PURE__*/ $161cc1cafa885ec4$var$_react.default.createElement($8Hgmn.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$161cc1cafa885ec4$var$ErrorIcon.displayName = 'ErrorIcon';
var $161cc1cafa885ec4$var$_default = module.exports.default = $161cc1cafa885ec4$var$ErrorIcon;

});
parcelRegister("8Hgmn", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $654f079dea9792de$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
function $654f079dea9792de$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $654f079dea9792de$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $654f079dea9792de$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $654f079dea9792de$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $654f079dea9792de$var$iconStyles = null;
var $654f079dea9792de$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $654f079dea9792de$var$baseHcmStyles = null;
var $654f079dea9792de$var$primaryEqualsSecondaryHcmStyles = null;
var $654f079dea9792de$var$secondaryTransparentHcmStyles = null;
var $654f079dea9792de$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dNMDr.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $dNMDr.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $dNMDr.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $654f079dea9792de$var$_objectSpread($654f079dea9792de$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $affTb.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $654f079dea9792de$var$sizeStyles[size]
        ])
    }));
});
var $654f079dea9792de$export$2e2bcd8739ae039 = $654f079dea9792de$export$f04a61298a47a40f;

});



parcelRegister("3qO8r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27fab09fa183b4a4$var$_react = $27fab09fa183b4a4$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $27fab09fa183b4a4$var$_statusSuccess = $27fab09fa183b4a4$var$_interopRequireDefault((parcelRequire("iv34T")));

var $27fab09fa183b4a4$var$_success = $27fab09fa183b4a4$var$_interopRequireDefault((parcelRequire("1CDuY")));
function $27fab09fa183b4a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27fab09fa183b4a4$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $27fab09fa183b4a4$var$_react.default.createElement($27fab09fa183b4a4$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $27fab09fa183b4a4$var$_success.default
    }, props));
$27fab09fa183b4a4$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $27fab09fa183b4a4$var$_default = module.exports.default = $27fab09fa183b4a4$var$StatusSuccessIcon;

});
parcelRegister("iv34T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d77d826f9d424b76$var$_react = $d77d826f9d424b76$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $d77d826f9d424b76$var$_baseNew = $d77d826f9d424b76$var$_interopRequireDefault((parcelRequire("3Cur0")));
function $d77d826f9d424b76$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d77d826f9d424b76$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $d77d826f9d424b76$var$_react.default.createElement($d77d826f9d424b76$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$d77d826f9d424b76$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $d77d826f9d424b76$var$_default = module.exports.default = $d77d826f9d424b76$var$StatusSuccessIcon;

});

parcelRegister("1CDuY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12e7faa60e5d32c9$var$_react = $12e7faa60e5d32c9$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $8Hgmn = parcelRequire("8Hgmn");
function $12e7faa60e5d32c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $12e7faa60e5d32c9$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $12e7faa60e5d32c9$var$_react.default.createElement($8Hgmn.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$12e7faa60e5d32c9$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $12e7faa60e5d32c9$var$_default = module.exports.default = $12e7faa60e5d32c9$var$EditorSuccessIcon;

});


parcelRegister("cbMXR", function(module, exports) {

$parcel$export(module.exports, "FieldId", function () { return $8dfc7e6c10036ef0$export$3c4232819458a302; });

var $dNMDr = parcelRequire("dNMDr");
var $8dfc7e6c10036ef0$export$3c4232819458a302 = /*#__PURE__*/ (0, $dNMDr.createContext)(undefined);

});


parcelRegister("aij7o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77ea6a4ced65e304$export$2e2bcd8739ae039; });
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $91FVG = parcelRequire("91FVG");

var $82V4i = parcelRequire("82V4i");

var $a3ftr = parcelRequire("a3ftr");

var $grvIM = parcelRequire("grvIM");

var $dNMDr = parcelRequire("dNMDr");

var $hGahQ = parcelRequire("hGahQ");

var $gQLDR = parcelRequire("gQLDR");

var $cbMXR = parcelRequire("cbMXR");

var $iMw87 = parcelRequire("iMw87");

var $dFAHD = parcelRequire("dFAHD");

var $7imrD = parcelRequire("7imrD");

var $8crfR = parcelRequire("8crfR");
function $77ea6a4ced65e304$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77ea6a4ced65e304$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77ea6a4ced65e304$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77ea6a4ced65e304$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $77ea6a4ced65e304$var$fieldWrapperStyles = null;
function $77ea6a4ced65e304$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $77ea6a4ced65e304$var$isFunction(x) {
    return typeof x === 'function';
}
// Must be exported to satisfy error TS4023 from Jira builds
// src/packages/servicedesk/virtual-agent/common/src/ui/base-text-field/index.tsx(10,14):
// error TS4023: Exported variable `BaseTextField` has or is using name
// `FieldComponentProps` from external module
// `/opt/atlassian/pipelines/agent/build/jira/tsDist/@atlaskit__form/app/src/field`
// but cannot be named.
function $77ea6a4ced65e304$var$usePreviousRef(current) {
    var ref = (0, $dNMDr.useRef)(current);
    // will be updated on the next render
    (0, $dNMDr.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $77ea6a4ced65e304$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(previousValue) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(currentValue) === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $77ea6a4ced65e304$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _props$children = props.children, children = _props$children === void 0 ? function() {
        return null;
    } : _props$children, component = props.component;
    var _useContext = (0, $dNMDr.useContext)((0, $iMw87.FormContext)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $dNMDr.useContext)((0, $iMw87.IsDisabledContext)) || props.isDisabled || false;
    var defaultValue = $77ea6a4ced65e304$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $77ea6a4ced65e304$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$77ea6a4ced65e304$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $dNMDr.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explicitly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $77ea6a4ced65e304$var$usePreviousRef(state);
    (0, $dNMDr.useEffect)(function() {
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $77ea6a4ced65e304$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($77ea6a4ced65e304$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var uid = (0, $hGahQ.useId)();
    var fieldId = (0, $dNMDr.useMemo)(function() {
        return props.id ? props.id : "".concat(props.name, "-").concat(uid);
    }, [
        props.id,
        props.name,
        uid
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = '';
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $77ea6a4ced65e304$var$_objectSpread($77ea6a4ced65e304$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': "".concat(fieldId, "-label"),
        id: fieldId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
        "data-testid": props.testId,
        className: (0, $grvIM.default)([
            "_1pfhu2gc"
        ])
    }, props.label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dFAHD.Label), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $8crfR.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $cbMXR.FieldId).Provider, {
        value: fieldId
    }, component && (0, $gQLDR.fg)('platform_design-system-team_field-upgrade') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).Fragment, null, component && component({
        fieldProps: extendedFieldProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $7imrD.MessageWrapper), null, props.helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $7imrD.HelperMessage), null, props.helperMessage), state.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $7imrD.ErrorMessage), null, props.errorMessage || state.error), state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $7imrD.ValidMessage), null, props.validMessage))) : children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("iMw87", function(module, exports) {

$parcel$export(module.exports, "FormContext", function () { return $dac5a20440014b31$export$c24727297075ec6a; });
$parcel$export(module.exports, "IsDisabledContext", function () { return $dac5a20440014b31$export$c17cf6b332a82dbc; });
$parcel$export(module.exports, "default", function () { return $dac5a20440014b31$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $91FVG = parcelRequire("91FVG");

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $kakIY = parcelRequire("kakIY");

var $buxW3 = parcelRequire("buxW3");

var $4zSeo = parcelRequire("4zSeo");

var $gQLDR = parcelRequire("gQLDR");

var $fAysD = parcelRequire("fAysD");
function $dac5a20440014b31$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dac5a20440014b31$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dac5a20440014b31$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dac5a20440014b31$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dac5a20440014b31$export$c24727297075ec6a = /*#__PURE__*/ (0, $dNMDr.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var $dac5a20440014b31$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $dNMDr.createContext)(false);
function $dac5a20440014b31$export$2e2bcd8739ae039(props) {
    var userProvidedFormProps = props.formProps, onSubmit = props.onSubmit, testId = props.testId;
    var formRef = (0, $dNMDr.useRef)(null);
    var onSubmitRef = (0, $dNMDr.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    var _useState = (0, $dNMDr.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $kakIY.createForm)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($4zSeo)))(initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($4zSeo)))(values, name, _value);
                    }
                }
            }
        });
        (0, $buxW3.default)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [];
        }, (0, $gQLDR.fg)('platform-form-field-error-focus') ? (0, $fAysD.getFirstErrorField) : undefined)(finalForm);
        return finalForm;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $dNMDr.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $dNMDr.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $dNMDr.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $dNMDr.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $dNMDr.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    // Abstracting so we can use the same for both rendering patterns
    var formProps = $dac5a20440014b31$var$_objectSpread({
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: formRef
    }, testId && {
        'data-testid': testId
    });
    var childrenContent = function() {
        if (typeof children === 'function') {
            var result = children.length > 0 ? children($dac5a20440014b31$var$_objectSpread({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: function getState() {
                    return form.getState();
                },
                getValues: function getValues() {
                    return form.getState().values;
                },
                setFieldValue: form.change
            }, (0, $gQLDR.fg)('platform-form-reset-field-state') && {
                resetFieldState: form.resetFieldState
            })) : children();
            return result === undefined ? null : result;
        } else return (0, $gQLDR.fg)('platform_design-system-team_form-upgrade') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("form", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, formProps, userProvidedFormProps), children) : children;
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($dac5a20440014b31$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($dac5a20440014b31$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, childrenContent));
}

});
parcelRegister("kakIY", function(module, exports) {

$parcel$export(module.exports, "getIn", function () { return $eae4d14370eff5f4$export$c52e5867d5879e24; });
$parcel$export(module.exports, "createForm", function () { return $eae4d14370eff5f4$export$f681a8129d2e9d28; });

var $lqyXr = parcelRequire("lqyXr");

var $4wTfY = parcelRequire("4wTfY");
//      
var $eae4d14370eff5f4$var$charCodeOfDot = ".".charCodeAt(0);
var $eae4d14370eff5f4$var$reEscapeChar = /\\(\\)?/g;
var $eae4d14370eff5f4$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $eae4d14370eff5f4$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $eae4d14370eff5f4$var$charCodeOfDot) result.push("");
    string.replace($eae4d14370eff5f4$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($eae4d14370eff5f4$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $eae4d14370eff5f4$var$keysCache = {};
var $eae4d14370eff5f4$var$keysRegex = /[.[\]]+/;
var $eae4d14370eff5f4$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($eae4d14370eff5f4$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $eae4d14370eff5f4$var$keysCache[key] = key.split($eae4d14370eff5f4$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $eae4d14370eff5f4$var$keysCache[key] = $eae4d14370eff5f4$var$stringToPath(key);
    }
    return $eae4d14370eff5f4$var$keysCache[key];
};
//      
var $eae4d14370eff5f4$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $eae4d14370eff5f4$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $eae4d14370eff5f4$var$_toPropertyKey(arg) {
    var key = $eae4d14370eff5f4$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $eae4d14370eff5f4$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $eae4d14370eff5f4$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $4wTfY.default)(current, [
                key
            ].map($eae4d14370eff5f4$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $lqyXr.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $eae4d14370eff5f4$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $eae4d14370eff5f4$var$setInRecursor(state, 0, $eae4d14370eff5f4$var$toPath(key), value1, destroyArrays);
};
var $eae4d14370eff5f4$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $eae4d14370eff5f4$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $eae4d14370eff5f4$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $eae4d14370eff5f4$export$c52e5867d5879e24(values, name);
    var error = $eae4d14370eff5f4$export$c52e5867d5879e24(errors, name);
    if (error && error[$eae4d14370eff5f4$export$735bebc8ffabf28a]) error = error[$eae4d14370eff5f4$export$735bebc8ffabf28a];
    var submitError = submitErrors && $eae4d14370eff5f4$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $eae4d14370eff5f4$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($eae4d14370eff5f4$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $eae4d14370eff5f4$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $eae4d14370eff5f4$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $eae4d14370eff5f4$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$eae4d14370eff5f4$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $eae4d14370eff5f4$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $eae4d14370eff5f4$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $eae4d14370eff5f4$var$subscriptionFilter(result, state, previousState, subscription, $eae4d14370eff5f4$export$41e855cb628c1b55, $eae4d14370eff5f4$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $eae4d14370eff5f4$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $eae4d14370eff5f4$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $eae4d14370eff5f4$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $eae4d14370eff5f4$var$subscriptionFilter(result, state, previousState, subscription, $eae4d14370eff5f4$export$f1ff97b9d1c7a3c3, $eae4d14370eff5f4$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $eae4d14370eff5f4$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$eae4d14370eff5f4$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $eae4d14370eff5f4$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $eae4d14370eff5f4$export$83d89fbfd8236492 = "4.20.10";
var $eae4d14370eff5f4$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $eae4d14370eff5f4$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $eae4d14370eff5f4$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $eae4d14370eff5f4$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $eae4d14370eff5f4$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $eae4d14370eff5f4$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $eae4d14370eff5f4$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $eae4d14370eff5f4$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($eae4d14370eff5f4$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $eae4d14370eff5f4$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $lqyXr.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $lqyXr.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $eae4d14370eff5f4$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $eae4d14370eff5f4$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $lqyXr.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $lqyXr.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $lqyXr.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $eae4d14370eff5f4$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $eae4d14370eff5f4$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $eae4d14370eff5f4$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $eae4d14370eff5f4$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $eae4d14370eff5f4$export$e6bdf135a54e021b,
                    shallowEqual: $eae4d14370eff5f4$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $lqyXr.default)({}, state.formState.values)); // clone to avoid writing
            if ($eae4d14370eff5f4$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($eae4d14370eff5f4$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $eae4d14370eff5f4$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $eae4d14370eff5f4$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $lqyXr.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $lqyXr.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $eae4d14370eff5f4$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $eae4d14370eff5f4$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $eae4d14370eff5f4$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$eae4d14370eff5f4$export$735bebc8ffabf28a]) {
                    var existing = $eae4d14370eff5f4$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$eae4d14370eff5f4$export$735bebc8ffabf28a] = error[$eae4d14370eff5f4$export$735bebc8ffabf28a];
                    merged = $eae4d14370eff5f4$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$eae4d14370eff5f4$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$eae4d14370eff5f4$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $lqyXr.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $eae4d14370eff5f4$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $eae4d14370eff5f4$var$notify(fieldSubscriber, fieldState, lastFieldState, $eae4d14370eff5f4$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $eae4d14370eff5f4$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $lqyXr.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($eae4d14370eff5f4$export$c52e5867d5879e24(formState.values, key), $eae4d14370eff5f4$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($eae4d14370eff5f4$export$c52e5867d5879e24(formState.values, key), $eae4d14370eff5f4$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$eae4d14370eff5f4$var$hasAnyError(formState.errors) && !(formState.submitErrors && $eae4d14370eff5f4$var$hasAnyError(formState.submitErrors));
        var nextFormState = $eae4d14370eff5f4$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $eae4d14370eff5f4$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $eae4d14370eff5f4$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $eae4d14370eff5f4$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $eae4d14370eff5f4$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $eae4d14370eff5f4$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $eae4d14370eff5f4$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $eae4d14370eff5f4$var$notify(state.subscribers, nextFormState, lastFormState, $eae4d14370eff5f4$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $lqyXr.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($eae4d14370eff5f4$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $lqyXr.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $lqyXr.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($eae4d14370eff5f4$export$c52e5867d5879e24(formState.values, key), $eae4d14370eff5f4$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $eae4d14370eff5f4$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $eae4d14370eff5f4$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $eae4d14370eff5f4$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $eae4d14370eff5f4$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $eae4d14370eff5f4$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $eae4d14370eff5f4$export$c52e5867d5879e24(state.formState.values, name) === $eae4d14370eff5f4$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $eae4d14370eff5f4$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $eae4d14370eff5f4$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $eae4d14370eff5f4$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $eae4d14370eff5f4$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $eae4d14370eff5f4$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $eae4d14370eff5f4$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $lqyXr.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $lqyXr.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $lqyXr.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $eae4d14370eff5f4$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$eae4d14370eff5f4$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $lqyXr.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $eae4d14370eff5f4$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $eae4d14370eff5f4$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $eae4d14370eff5f4$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $eae4d14370eff5f4$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("buxW3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85dcd1e9a09a5335$export$2e2bcd8739ae039; });

var $kakIY = parcelRequire("kakIY");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $85dcd1e9a09a5335$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $85dcd1e9a09a5335$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($85dcd1e9a09a5335$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $85dcd1e9a09a5335$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $kakIY.getIn)(errors, input.name);
    });
};
//      
var $85dcd1e9a09a5335$var$noop = function noop() {};
var $85dcd1e9a09a5335$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $85dcd1e9a09a5335$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $85dcd1e9a09a5335$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $85dcd1e9a09a5335$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $85dcd1e9a09a5335$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($85dcd1e9a09a5335$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$85dcd1e9a09a5335$export$2e2bcd8739ae039 = $85dcd1e9a09a5335$var$createDecorator;

});

parcelRegister("4zSeo", function(module, exports) {

var $kWocC = parcelRequire("kWocC");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $35547f7632f3b4d7$var$set(object, path, value) {
    return object == null ? object : $kWocC(object, path, value);
}
module.exports = $35547f7632f3b4d7$var$set;

});
parcelRegister("kWocC", function(module, exports) {

var $gJdt3 = parcelRequire("gJdt3");

var $eiWAm = parcelRequire("eiWAm");

var $2TWvm = parcelRequire("2TWvm");

var $d72yL = parcelRequire("d72yL");

var $gXjya = parcelRequire("gXjya");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $f3ebff8fee9baa5d$var$baseSet(object, path, value, customizer) {
    if (!$d72yL(object)) return object;
    path = $eiWAm(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $gXjya(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $d72yL(objValue) ? objValue : $2TWvm(path[index + 1]) ? [] : {};
        }
        $gJdt3(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $f3ebff8fee9baa5d$var$baseSet;

});
parcelRegister("gJdt3", function(module, exports) {

var $8QJYV = parcelRequire("8QJYV");

var $ewZge = parcelRequire("ewZge");
/** Used for built-in method references. */ var $c2db4bb53c54533d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c2db4bb53c54533d$var$hasOwnProperty = $c2db4bb53c54533d$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $c2db4bb53c54533d$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($c2db4bb53c54533d$var$hasOwnProperty.call(object, key) && $ewZge(objValue, value)) || value === undefined && !(key in object)) $8QJYV(object, key, value);
}
module.exports = $c2db4bb53c54533d$var$assignValue;

});
parcelRegister("8QJYV", function(module, exports) {

var $2vBly = parcelRequire("2vBly");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $6716d91503242f9e$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $2vBly) $2vBly(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $6716d91503242f9e$var$baseAssignValue;

});
parcelRegister("2vBly", function(module, exports) {

var $5TPm8 = parcelRequire("5TPm8");
var $1d3b724a371787e4$var$defineProperty = function() {
    try {
        var func = $5TPm8(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $1d3b724a371787e4$var$defineProperty;

});
parcelRegister("5TPm8", function(module, exports) {

var $iOnLu = parcelRequire("iOnLu");

var $2GxUs = parcelRequire("2GxUs");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $44b9ed0d72ec01d3$var$getNative(object, key) {
    var value = $2GxUs(object, key);
    return $iOnLu(value) ? value : undefined;
}
module.exports = $44b9ed0d72ec01d3$var$getNative;

});
parcelRegister("iOnLu", function(module, exports) {

var $2fNnB = parcelRequire("2fNnB");

var $5vHYv = parcelRequire("5vHYv");

var $d72yL = parcelRequire("d72yL");

var $1aPAE = parcelRequire("1aPAE");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $db1f54c1833333a6$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $db1f54c1833333a6$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $db1f54c1833333a6$var$funcProto = Function.prototype, $db1f54c1833333a6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $db1f54c1833333a6$var$funcToString = $db1f54c1833333a6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $db1f54c1833333a6$var$hasOwnProperty = $db1f54c1833333a6$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $db1f54c1833333a6$var$reIsNative = RegExp('^' + $db1f54c1833333a6$var$funcToString.call($db1f54c1833333a6$var$hasOwnProperty).replace($db1f54c1833333a6$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $db1f54c1833333a6$var$baseIsNative(value) {
    if (!$d72yL(value) || $5vHYv(value)) return false;
    var pattern = $2fNnB(value) ? $db1f54c1833333a6$var$reIsNative : $db1f54c1833333a6$var$reIsHostCtor;
    return pattern.test($1aPAE(value));
}
module.exports = $db1f54c1833333a6$var$baseIsNative;

});
parcelRegister("2fNnB", function(module, exports) {

var $7OwNS = parcelRequire("7OwNS");

var $d72yL = parcelRequire("d72yL");
/** `Object#toString` result references. */ var $1a43493e03beb147$var$asyncTag = '[object AsyncFunction]', $1a43493e03beb147$var$funcTag = '[object Function]', $1a43493e03beb147$var$genTag = '[object GeneratorFunction]', $1a43493e03beb147$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $1a43493e03beb147$var$isFunction(value) {
    if (!$d72yL(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $7OwNS(value);
    return tag == $1a43493e03beb147$var$funcTag || tag == $1a43493e03beb147$var$genTag || tag == $1a43493e03beb147$var$asyncTag || tag == $1a43493e03beb147$var$proxyTag;
}
module.exports = $1a43493e03beb147$var$isFunction;

});
parcelRegister("7OwNS", function(module, exports) {

var $6T2od = parcelRequire("6T2od");

var $5qsHJ = parcelRequire("5qsHJ");

var $4cgCI = parcelRequire("4cgCI");
/** `Object#toString` result references. */ var $5b06a604dc16ced0$var$nullTag = '[object Null]', $5b06a604dc16ced0$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $5b06a604dc16ced0$var$symToStringTag = $6T2od ? $6T2od.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $5b06a604dc16ced0$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $5b06a604dc16ced0$var$undefinedTag : $5b06a604dc16ced0$var$nullTag;
    return $5b06a604dc16ced0$var$symToStringTag && $5b06a604dc16ced0$var$symToStringTag in Object(value) ? $5qsHJ(value) : $4cgCI(value);
}
module.exports = $5b06a604dc16ced0$var$baseGetTag;

});
parcelRegister("6T2od", function(module, exports) {

var $cqd90 = parcelRequire("cqd90");
/** Built-in value references. */ var $5039bba1760b3ccb$var$Symbol = $cqd90.Symbol;
module.exports = $5039bba1760b3ccb$var$Symbol;

});
parcelRegister("cqd90", function(module, exports) {

var $j8Ymh = parcelRequire("j8Ymh");
/** Detect free variable `self`. */ var $90b21bf1ed0adcbd$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $90b21bf1ed0adcbd$var$root = $j8Ymh || $90b21bf1ed0adcbd$var$freeSelf || Function('return this')();
module.exports = $90b21bf1ed0adcbd$var$root;

});
parcelRegister("j8Ymh", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $defd959967e18847$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $defd959967e18847$var$freeGlobal;

});



parcelRegister("5qsHJ", function(module, exports) {

var $6T2od = parcelRequire("6T2od");
/** Used for built-in method references. */ var $3f35a58ae88cb458$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3f35a58ae88cb458$var$hasOwnProperty = $3f35a58ae88cb458$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3f35a58ae88cb458$var$nativeObjectToString = $3f35a58ae88cb458$var$objectProto.toString;
/** Built-in value references. */ var $3f35a58ae88cb458$var$symToStringTag = $6T2od ? $6T2od.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3f35a58ae88cb458$var$getRawTag(value) {
    var isOwn = $3f35a58ae88cb458$var$hasOwnProperty.call(value, $3f35a58ae88cb458$var$symToStringTag), tag = value[$3f35a58ae88cb458$var$symToStringTag];
    try {
        value[$3f35a58ae88cb458$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3f35a58ae88cb458$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3f35a58ae88cb458$var$symToStringTag] = tag;
        else delete value[$3f35a58ae88cb458$var$symToStringTag];
    }
    return result;
}
module.exports = $3f35a58ae88cb458$var$getRawTag;

});

parcelRegister("4cgCI", function(module, exports) {
/** Used for built-in method references. */ var $30e52d7c2322db49$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $30e52d7c2322db49$var$nativeObjectToString = $30e52d7c2322db49$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $30e52d7c2322db49$var$objectToString(value) {
    return $30e52d7c2322db49$var$nativeObjectToString.call(value);
}
module.exports = $30e52d7c2322db49$var$objectToString;

});


parcelRegister("d72yL", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $98bdea19f74a6aac$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $98bdea19f74a6aac$var$isObject;

});


parcelRegister("5vHYv", function(module, exports) {

var $2z1Mk = parcelRequire("2z1Mk");
/** Used to detect methods masquerading as native. */ var $4031f5830b01c3c2$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($2z1Mk && $2z1Mk.keys && $2z1Mk.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $4031f5830b01c3c2$var$isMasked(func) {
    return !!$4031f5830b01c3c2$var$maskSrcKey && $4031f5830b01c3c2$var$maskSrcKey in func;
}
module.exports = $4031f5830b01c3c2$var$isMasked;

});
parcelRegister("2z1Mk", function(module, exports) {

var $cqd90 = parcelRequire("cqd90");
/** Used to detect overreaching core-js shims. */ var $1de03ad94fcc6d70$var$coreJsData = $cqd90["__core-js_shared__"];
module.exports = $1de03ad94fcc6d70$var$coreJsData;

});


parcelRegister("1aPAE", function(module, exports) {
/** Used for built-in method references. */ var $0daebe5402cc8b87$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $0daebe5402cc8b87$var$funcToString = $0daebe5402cc8b87$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $0daebe5402cc8b87$var$toSource(func) {
    if (func != null) {
        try {
            return $0daebe5402cc8b87$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $0daebe5402cc8b87$var$toSource;

});


parcelRegister("2GxUs", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $1f49cebd23a28e10$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $1f49cebd23a28e10$var$getValue;

});




parcelRegister("ewZge", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $a94392f92071c4f6$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $a94392f92071c4f6$var$eq;

});


parcelRegister("eiWAm", function(module, exports) {

var $gouN5 = parcelRequire("gouN5");

var $jh8Mq = parcelRequire("jh8Mq");

var $RnFFp = parcelRequire("RnFFp");

var $eCfG9 = parcelRequire("eCfG9");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $a6a030ff773b05b5$var$castPath(value, object) {
    if ($gouN5(value)) return value;
    return $jh8Mq(value, object) ? [
        value
    ] : $RnFFp($eCfG9(value));
}
module.exports = $a6a030ff773b05b5$var$castPath;

});
parcelRegister("gouN5", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $bef6c5a486fb2aa5$var$isArray = Array.isArray;
module.exports = $bef6c5a486fb2aa5$var$isArray;

});

parcelRegister("jh8Mq", function(module, exports) {

var $gouN5 = parcelRequire("gouN5");

var $jvuTL = parcelRequire("jvuTL");
/** Used to match property names within property paths. */ var $e0866a640bc02fc9$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $e0866a640bc02fc9$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $e0866a640bc02fc9$var$isKey(value, object) {
    if ($gouN5(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $jvuTL(value)) return true;
    return $e0866a640bc02fc9$var$reIsPlainProp.test(value) || !$e0866a640bc02fc9$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $e0866a640bc02fc9$var$isKey;

});
parcelRegister("jvuTL", function(module, exports) {

var $7OwNS = parcelRequire("7OwNS");

var $hjzfM = parcelRequire("hjzfM");
/** `Object#toString` result references. */ var $e338e159f9e0997b$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e338e159f9e0997b$var$isSymbol(value) {
    return typeof value == 'symbol' || $hjzfM(value) && $7OwNS(value) == $e338e159f9e0997b$var$symbolTag;
}
module.exports = $e338e159f9e0997b$var$isSymbol;

});
parcelRegister("hjzfM", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c9af8e9bdbab3aad$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $c9af8e9bdbab3aad$var$isObjectLike;

});



parcelRegister("RnFFp", function(module, exports) {

var $gQaiS = parcelRequire("gQaiS");
/** Used to match property names within property paths. */ var $0a074fedbd43c324$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $0a074fedbd43c324$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $0a074fedbd43c324$var$stringToPath = $gQaiS(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($0a074fedbd43c324$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($0a074fedbd43c324$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $0a074fedbd43c324$var$stringToPath;

});
parcelRegister("gQaiS", function(module, exports) {

var $iD6fY = parcelRequire("iD6fY");
/** Used as the maximum memoize cache size. */ var $c4297eb7ff08d521$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $c4297eb7ff08d521$var$memoizeCapped(func) {
    var result = $iD6fY(func, function(key) {
        if (cache.size === $c4297eb7ff08d521$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $c4297eb7ff08d521$var$memoizeCapped;

});
parcelRegister("iD6fY", function(module, exports) {

var $gYutR = parcelRequire("gYutR");
/** Error message constants. */ var $d900b8f7f46431a1$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $d900b8f7f46431a1$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($d900b8f7f46431a1$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($d900b8f7f46431a1$var$memoize.Cache || $gYutR);
    return memoized;
}
// Expose `MapCache`.
$d900b8f7f46431a1$var$memoize.Cache = $gYutR;
module.exports = $d900b8f7f46431a1$var$memoize;

});
parcelRegister("gYutR", function(module, exports) {

var $gla2T = parcelRequire("gla2T");

var $c7jpy = parcelRequire("c7jpy");

var $aXs5M = parcelRequire("aXs5M");

var $QseiY = parcelRequire("QseiY");

var $litM8 = parcelRequire("litM8");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c5b9e4c309b6d29d$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$c5b9e4c309b6d29d$var$MapCache.prototype.clear = $gla2T;
$c5b9e4c309b6d29d$var$MapCache.prototype['delete'] = $c7jpy;
$c5b9e4c309b6d29d$var$MapCache.prototype.get = $aXs5M;
$c5b9e4c309b6d29d$var$MapCache.prototype.has = $QseiY;
$c5b9e4c309b6d29d$var$MapCache.prototype.set = $litM8;
module.exports = $c5b9e4c309b6d29d$var$MapCache;

});
parcelRegister("gla2T", function(module, exports) {

var $8SvLH = parcelRequire("8SvLH");

var $9D3Ud = parcelRequire("9D3Ud");

var $6jPia = parcelRequire("6jPia");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $be566658d66f78b5$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $8SvLH,
        'map': new ($6jPia || $9D3Ud),
        'string': new $8SvLH
    };
}
module.exports = $be566658d66f78b5$var$mapCacheClear;

});
parcelRegister("8SvLH", function(module, exports) {

var $1cWSZ = parcelRequire("1cWSZ");

var $iix7X = parcelRequire("iix7X");

var $aVgzX = parcelRequire("aVgzX");

var $5Gf8I = parcelRequire("5Gf8I");

var $eYl0V = parcelRequire("eYl0V");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $676c0262b5ba463f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$676c0262b5ba463f$var$Hash.prototype.clear = $1cWSZ;
$676c0262b5ba463f$var$Hash.prototype['delete'] = $iix7X;
$676c0262b5ba463f$var$Hash.prototype.get = $aVgzX;
$676c0262b5ba463f$var$Hash.prototype.has = $5Gf8I;
$676c0262b5ba463f$var$Hash.prototype.set = $eYl0V;
module.exports = $676c0262b5ba463f$var$Hash;

});
parcelRegister("1cWSZ", function(module, exports) {

var $j9mtW = parcelRequire("j9mtW");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $0e1496f927c442b8$var$hashClear() {
    this.__data__ = $j9mtW ? $j9mtW(null) : {};
    this.size = 0;
}
module.exports = $0e1496f927c442b8$var$hashClear;

});
parcelRegister("j9mtW", function(module, exports) {

var $5TPm8 = parcelRequire("5TPm8");
/* Built-in method references that are verified to be native. */ var $df104c0cf286a70e$var$nativeCreate = $5TPm8(Object, 'create');
module.exports = $df104c0cf286a70e$var$nativeCreate;

});


parcelRegister("iix7X", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d5239ad4d72483c8$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $d5239ad4d72483c8$var$hashDelete;

});

parcelRegister("aVgzX", function(module, exports) {

var $j9mtW = parcelRequire("j9mtW");
/** Used to stand-in for `undefined` hash values. */ var $7f3c167e9b1e4162$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $7f3c167e9b1e4162$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7f3c167e9b1e4162$var$hasOwnProperty = $7f3c167e9b1e4162$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7f3c167e9b1e4162$var$hashGet(key) {
    var data = this.__data__;
    if ($j9mtW) {
        var result = data[key];
        return result === $7f3c167e9b1e4162$var$HASH_UNDEFINED ? undefined : result;
    }
    return $7f3c167e9b1e4162$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $7f3c167e9b1e4162$var$hashGet;

});

parcelRegister("5Gf8I", function(module, exports) {

var $j9mtW = parcelRequire("j9mtW");
/** Used for built-in method references. */ var $422c9e67085d3b07$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $422c9e67085d3b07$var$hasOwnProperty = $422c9e67085d3b07$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $422c9e67085d3b07$var$hashHas(key) {
    var data = this.__data__;
    return $j9mtW ? data[key] !== undefined : $422c9e67085d3b07$var$hasOwnProperty.call(data, key);
}
module.exports = $422c9e67085d3b07$var$hashHas;

});

parcelRegister("eYl0V", function(module, exports) {

var $j9mtW = parcelRequire("j9mtW");
/** Used to stand-in for `undefined` hash values. */ var $ae66f83461f67a08$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $ae66f83461f67a08$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $j9mtW && value === undefined ? $ae66f83461f67a08$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $ae66f83461f67a08$var$hashSet;

});


parcelRegister("9D3Ud", function(module, exports) {

var $ipY5q = parcelRequire("ipY5q");

var $bEg8X = parcelRequire("bEg8X");

var $5UoEb = parcelRequire("5UoEb");

var $gxG6T = parcelRequire("gxG6T");

var $cfhqd = parcelRequire("cfhqd");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $01cf2446d6f46491$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$01cf2446d6f46491$var$ListCache.prototype.clear = $ipY5q;
$01cf2446d6f46491$var$ListCache.prototype['delete'] = $bEg8X;
$01cf2446d6f46491$var$ListCache.prototype.get = $5UoEb;
$01cf2446d6f46491$var$ListCache.prototype.has = $gxG6T;
$01cf2446d6f46491$var$ListCache.prototype.set = $cfhqd;
module.exports = $01cf2446d6f46491$var$ListCache;

});
parcelRegister("ipY5q", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $d6892bbac1bf0d34$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $d6892bbac1bf0d34$var$listCacheClear;

});

parcelRegister("bEg8X", function(module, exports) {

var $1OZFm = parcelRequire("1OZFm");
/** Used for built-in method references. */ var $87aff3e50f4d4a3d$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $87aff3e50f4d4a3d$var$splice = $87aff3e50f4d4a3d$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $87aff3e50f4d4a3d$var$listCacheDelete(key) {
    var data = this.__data__, index = $1OZFm(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $87aff3e50f4d4a3d$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $87aff3e50f4d4a3d$var$listCacheDelete;

});
parcelRegister("1OZFm", function(module, exports) {

var $ewZge = parcelRequire("ewZge");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $153a4b8a8462cac5$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($ewZge(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $153a4b8a8462cac5$var$assocIndexOf;

});


parcelRegister("5UoEb", function(module, exports) {

var $1OZFm = parcelRequire("1OZFm");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $44d54d248e9de7e9$var$listCacheGet(key) {
    var data = this.__data__, index = $1OZFm(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $44d54d248e9de7e9$var$listCacheGet;

});

parcelRegister("gxG6T", function(module, exports) {

var $1OZFm = parcelRequire("1OZFm");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c0b0649d8d19fb99$var$listCacheHas(key) {
    return $1OZFm(this.__data__, key) > -1;
}
module.exports = $c0b0649d8d19fb99$var$listCacheHas;

});

parcelRegister("cfhqd", function(module, exports) {

var $1OZFm = parcelRequire("1OZFm");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $8ea466629a3f6c6b$var$listCacheSet(key, value) {
    var data = this.__data__, index = $1OZFm(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $8ea466629a3f6c6b$var$listCacheSet;

});


parcelRegister("6jPia", function(module, exports) {

var $5TPm8 = parcelRequire("5TPm8");

var $cqd90 = parcelRequire("cqd90");
/* Built-in method references that are verified to be native. */ var $499c4df84291953a$var$Map = $5TPm8($cqd90, 'Map');
module.exports = $499c4df84291953a$var$Map;

});


parcelRegister("c7jpy", function(module, exports) {

var $6TXj9 = parcelRequire("6TXj9");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8d2532252599598f$var$mapCacheDelete(key) {
    var result = $6TXj9(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $8d2532252599598f$var$mapCacheDelete;

});
parcelRegister("6TXj9", function(module, exports) {

var $kGgS6 = parcelRequire("kGgS6");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $5065e2726323a1bd$var$getMapData(map, key) {
    var data = map.__data__;
    return $kGgS6(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $5065e2726323a1bd$var$getMapData;

});
parcelRegister("kGgS6", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $f0e4d141d22a064d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $f0e4d141d22a064d$var$isKeyable;

});



parcelRegister("aXs5M", function(module, exports) {

var $6TXj9 = parcelRequire("6TXj9");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7fa534972ef44610$var$mapCacheGet(key) {
    return $6TXj9(this, key).get(key);
}
module.exports = $7fa534972ef44610$var$mapCacheGet;

});

parcelRegister("QseiY", function(module, exports) {

var $6TXj9 = parcelRequire("6TXj9");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $09dac14758dac66f$var$mapCacheHas(key) {
    return $6TXj9(this, key).has(key);
}
module.exports = $09dac14758dac66f$var$mapCacheHas;

});

parcelRegister("litM8", function(module, exports) {

var $6TXj9 = parcelRequire("6TXj9");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $f8126030e7a57ed3$var$mapCacheSet(key, value) {
    var data = $6TXj9(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $f8126030e7a57ed3$var$mapCacheSet;

});





parcelRegister("eCfG9", function(module, exports) {

var $j1Uth = parcelRequire("j1Uth");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $aa40c6cc2266701a$var$toString(value) {
    return value == null ? '' : $j1Uth(value);
}
module.exports = $aa40c6cc2266701a$var$toString;

});
parcelRegister("j1Uth", function(module, exports) {

var $6T2od = parcelRequire("6T2od");

var $iQ2tr = parcelRequire("iQ2tr");

var $gouN5 = parcelRequire("gouN5");

var $jvuTL = parcelRequire("jvuTL");
/** Used as references for various `Number` constants. */ var $dda9ea55af8c9db1$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $dda9ea55af8c9db1$var$symbolProto = $6T2od ? $6T2od.prototype : undefined, $dda9ea55af8c9db1$var$symbolToString = $dda9ea55af8c9db1$var$symbolProto ? $dda9ea55af8c9db1$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $dda9ea55af8c9db1$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($gouN5(value)) // Recursively convert values (susceptible to call stack limits).
    return $iQ2tr(value, $dda9ea55af8c9db1$var$baseToString) + '';
    if ($jvuTL(value)) return $dda9ea55af8c9db1$var$symbolToString ? $dda9ea55af8c9db1$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$dda9ea55af8c9db1$var$INFINITY ? '-0' : result;
}
module.exports = $dda9ea55af8c9db1$var$baseToString;

});
parcelRegister("iQ2tr", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $db6f00957dd0b3e0$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $db6f00957dd0b3e0$var$arrayMap;

});




parcelRegister("2TWvm", function(module, exports) {
/** Used as references for various `Number` constants. */ var $21ce19aebbea89c3$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $21ce19aebbea89c3$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $21ce19aebbea89c3$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $21ce19aebbea89c3$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $21ce19aebbea89c3$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $21ce19aebbea89c3$var$isIndex;

});

parcelRegister("gXjya", function(module, exports) {

var $jvuTL = parcelRequire("jvuTL");
/** Used as references for various `Number` constants. */ var $c58152415fb9658e$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $c58152415fb9658e$var$toKey(value) {
    if (typeof value == 'string' || $jvuTL(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$c58152415fb9658e$var$INFINITY ? '-0' : result;
}
module.exports = $c58152415fb9658e$var$toKey;

});



parcelRegister("fAysD", function(module, exports) {

$parcel$export(module.exports, "getFirstErrorField", function () { return $b594f30a326798eb$export$fc06342dc8588d3b; });

var $kakIY = parcelRequire("kakIY");
var $b594f30a326798eb$export$fc06342dc8588d3b = function getFirstErrorField(inputs, errors) {
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    var htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $kakIY.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $kakIY.getIn)(errors, input.name);
    });
};

});


parcelRegister("dFAHD", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $9f3b931ba204ee42$export$b04be29aa201d4f5; });
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $grvIM = parcelRequire("grvIM");
var $9f3b931ba204ee42$var$fieldsetLabelStyles = null;
var $9f3b931ba204ee42$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return /*#__PURE__*/ $dNMDr.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $grvIM.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};
var $9f3b931ba204ee42$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $dNMDr.createElement("legend", {
        className: (0, $grvIM.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};

});

parcelRegister("8crfR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f8495f1cb5128f4$export$2e2bcd8739ae039; });
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $grvIM = parcelRequire("grvIM");
var $5f8495f1cb5128f4$var$requiredIndicatorStyles = null;
function $5f8495f1cb5128f4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $grvIM.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ])
    }, "*");
}

});


parcelRegister("ccbHt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e0fae6b27f16d7d$export$2e2bcd8739ae039; });

var $62ppy = parcelRequire("62ppy");

var $dNMDr = parcelRequire("dNMDr");

var $8Govx = parcelRequire("8Govx");

var $d433K = parcelRequire("d433K");

var $4JRmj = parcelRequire("4JRmj");
var $8e0fae6b27f16d7d$var$flexGrowMap = {
    hug: (0, $d433K.xcss)({
        flexGrow: 0
    }),
    fill: (0, $d433K.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $8e0fae6b27f16d7d$var$separatorStyles = (0, $8Govx.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $8e0fae6b27f16d7d$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $8Govx.jsx)("span", {
        css: $8e0fae6b27f16d7d$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $8e0fae6b27f16d7d$var$Inline = /*#__PURE__*/ (0, $dNMDr.memo)(/*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $8Govx.jsx)($8e0fae6b27f16d7d$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $dNMDr.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $8Govx.jsx)((0, $dNMDr.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $8e0fae6b27f16d7d$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $8Govx.jsx)((0, $4JRmj.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$8e0fae6b27f16d7d$var$Inline.displayName = 'Inline';
var $8e0fae6b27f16d7d$export$2e2bcd8739ae039 = $8e0fae6b27f16d7d$var$Inline;

});
parcelRegister("4JRmj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3734c16050451370$export$2e2bcd8739ae039; });

var $62ppy = parcelRequire("62ppy");

var $dNMDr = parcelRequire("dNMDr");

var $8Govx = parcelRequire("8Govx");

var $hnZEJ = parcelRequire("hnZEJ");

var $d433K = parcelRequire("d433K");
var $3734c16050451370$var$justifyContentMap = {
    start: (0, $8Govx.css)({
        justifyContent: 'start'
    }),
    center: (0, $8Govx.css)({
        justifyContent: 'center'
    }),
    end: (0, $8Govx.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $8Govx.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $8Govx.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $8Govx.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $8Govx.css)({
        justifyContent: 'stretch'
    })
};
var $3734c16050451370$var$flexDirectionMap = {
    column: (0, $8Govx.css)({
        flexDirection: 'column'
    }),
    row: (0, $8Govx.css)({
        flexDirection: 'row'
    })
};
var $3734c16050451370$var$flexWrapMap = {
    wrap: (0, $8Govx.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $8Govx.css)({
        flexWrap: 'nowrap'
    })
};
var $3734c16050451370$var$alignItemsMap = {
    start: (0, $8Govx.css)({
        alignItems: 'start'
    }),
    center: (0, $8Govx.css)({
        alignItems: 'center'
    }),
    baseline: (0, $8Govx.css)({
        alignItems: 'baseline'
    }),
    end: (0, $8Govx.css)({
        alignItems: 'end'
    }),
    stretch: (0, $8Govx.css)({
        alignItems: 'stretch'
    })
};
var $3734c16050451370$var$baseStyles = (0, $8Govx.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $3734c16050451370$var$Flex = /*#__PURE__*/ (0, $dNMDr.memo)(/*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $d433K.parseXcss)(xcss);
    return (0, $8Govx.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $3734c16050451370$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $hnZEJ.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $hnZEJ.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $hnZEJ.spaceStylesMap).rowGap[rowGap],
            alignItems && $3734c16050451370$var$alignItemsMap[alignItems],
            direction && $3734c16050451370$var$flexDirectionMap[direction],
            justifyContent && $3734c16050451370$var$justifyContentMap[justifyContent],
            wrap && $3734c16050451370$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$3734c16050451370$var$Flex.displayName = 'Flex';
var $3734c16050451370$export$2e2bcd8739ae039 = $3734c16050451370$var$Flex;

});



parcelRegister("6osFG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97f3219114a1680b$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $97f3219114a1680b$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    mfFormLabel: {
        id: 'mf.mfform.placeholder.generic',
        defaultMessage: 'Verification code',
        description: 'Placeholder hint for the verification code textfield when the expected code length is unknown'
    },
    mfFormLabelNDigits: {
        id: 'mf.mfform.placeholder.ndigits',
        defaultMessage: '{codeLength}-digit verification code',
        description: ''
    },
    mfFormLabelNCharacters: {
        id: 'mf.mfform.placeholder.ncharacters',
        defaultMessage: '{codeLength, plural, one {# character} other {# characters}} verification code',
        description: ''
    },
    errorsInvalidOtp: {
        id: 'mf.mfform.errors.invalid_otp',
        defaultMessage: 'You entered an incorrect verification code.'
    },
    errorsInvalidOtpFormat: {
        id: 'mf.mfform.errors.invalid_otp_format',
        defaultMessage: 'You entered an invalid verification code.'
    },
    errorsInvalidOtpPattern: {
        id: 'mf.mfform.errors.invalid_otp_pattern',
        defaultMessage: 'Your verification code needs to be {codeLength, plural, one {# character} other {# characters}}.'
    },
    errorsExpiredOtp: {
        id: 'mf.mfform.errors.expired_otp',
        defaultMessage: 'Your verification code has expired.'
    },
    errorsUnknown: {
        id: 'mf.mfform.errors.unknown',
        defaultMessage: 'Unknown error occurred. Please try again.'
    }
});

});


parcelRegister("8dLb0", function(module, exports) {

$parcel$export(module.exports, "SecurityWall", function () { return $2f072800123815d7$export$4584cd3084bcd78; });

var $6CtE1 = parcelRequire("6CtE1");

var $fbSBq = parcelRequire("fbSBq");

var $1Loe4 = parcelRequire("1Loe4");

var $52XHP = parcelRequire("52XHP");

var $j0VD5 = parcelRequire("j0VD5");

var $68HQw = parcelRequire("68HQw");

var $dNMDr = parcelRequire("dNMDr");
const $2f072800123815d7$var$DefaultSecurityWallContainer = (0, $fbSBq.default).div`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($1Loe4)))}) no-repeat center 0 / ${(0, $68HQw.gridSize)() * 14.5}px;
  min-width: 100%;
  margin-top: ${(0, $68HQw.gridSize)()}px;
  padding-top: ${(0, $68HQw.gridSize)() * 18}px;
  box-sizing: border-box;

  ${(0, $j0VD5.media).handheld`
    background: 0;
    padding: 0;
  `}
`;
const $2f072800123815d7$var$TotpChallengeContainer = (0, $fbSBq.default).div`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($52XHP)))}) no-repeat center 0 / ${(0, $68HQw.gridSize)() * 30}px;
  min-width: 100%;
  margin-top: ${(0, $68HQw.gridSize)()}px;
  padding-top: ${(0, $68HQw.gridSize)() * 18}px;
  box-sizing: border-box;

  ${(0, $j0VD5.media).handheld`
    background: none;
    padding: 0;
  `}
`;
const $2f072800123815d7$var$SuccessfulResetSecurityWallContainer = (0, $fbSBq.default).div`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($1Loe4)))}) no-repeat center;
  height: ${(0, $68HQw.gridSize)() * 14.5}px;
  margin-top: ${(0, $68HQw.gridSize)() * 1}px;
  margin-bottom: ${(0, $68HQw.gridSize)() * 1.5}px;
`;
const $2f072800123815d7$export$4584cd3084bcd78 = ({ children: children, id: id, securityWallStyle: securityWallStyle })=>{
    const WallComponent = (0, $dNMDr.useMemo)(()=>{
        switch(securityWallStyle){
            case 'password-reset':
                return $2f072800123815d7$var$SuccessfulResetSecurityWallContainer;
            case 'totp':
                return $2f072800123815d7$var$TotpChallengeContainer;
            default:
                return $2f072800123815d7$var$DefaultSecurityWallContainer;
        }
    }, [
        securityWallStyle
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)(WallComponent, {
        id: id,
        children: children
    });
};

});
parcelRegister("1Loe4", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "security-wall.93111abc.svg";

});


parcelRegister("8LYpt", function(module, exports) {

$parcel$export(module.exports, "InlineMessageContainer", function () { return $824bc1dc9bd71630$export$327fb3a223d00cf3; });
$parcel$export(module.exports, "StyledMessage", function () { return $824bc1dc9bd71630$export$ca8581ef51d2f0a9; });
$parcel$export(module.exports, "InputMessage", function () { return $824bc1dc9bd71630$export$d2966f371054ad4a; });

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");
const $824bc1dc9bd71630$export$327fb3a223d00cf3 = (0, $fbSBq.default).div`
  margin-left: 4px;
  display: inline-block;
  vertical-align: middle;
`;
const $824bc1dc9bd71630$export$ca8581ef51d2f0a9 = (0, $fbSBq.default).div`
  width: calc(50vw - ${(0, $68HQw.gridSize)() * 6}px);
  max-width: ${(0, $68HQw.gridSize)() * 34}px;
  margin-left: -${(0, $68HQw.gridSize)()}px;
  margin-right: -${(0, $68HQw.gridSize)()}px;
`;
const $824bc1dc9bd71630$export$d2966f371054ad4a = (0, $fbSBq.default).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

});

parcelRegister("dH3qM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e7993561f46078f$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");
parcelRequire("hpnxO");
var $g7WC8 = parcelRequire("g7WC8");

var $7ozrG = parcelRequire("7ozrG");

var $8LYpt = parcelRequire("8LYpt");

var $cr5CS = parcelRequire("cr5CS");

var $kJPFV = parcelRequire("kJPFV");

var $2byD0 = parcelRequire("2byD0");

var $iw8NJ = parcelRequire("iw8NJ");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $7DUKO = parcelRequire("7DUKO");

var $fbSBq = parcelRequire("fbSBq");

var $f8jwK = parcelRequire("f8jwK");

var $h4v4M = parcelRequire("h4v4M");
const $6e7993561f46078f$var$baseSpacing = (0, $7DUKO.default)('space.100');
const $6e7993561f46078f$var$PAGE_ID = 'MfaChallengeSecurityKey';
const $6e7993561f46078f$var$ErrorMessageWrapper = (0, $fbSBq.default).div`
  margin: calc(${$6e7993561f46078f$var$baseSpacing} * 2) 0;
`;
const $6e7993561f46078f$var$MfaChallengeSecurityKey = ()=>{
    const [errorMessage, setErrorMessage] = (0, $dNMDr.useState)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const challengeErrorMessages = (0, $dNMDr.useMemo)(()=>({
            // WebAuthn errors
            [(0, $f8jwK.WebAuthnAuthenticationErrorCode).WebAuthnNotSupported]: formatMessage((0, $7ozrG.default).webauthnNotSupportedMessage),
            [(0, $f8jwK.WebAuthnAuthenticationErrorCode).InvalidRequestOptions]: formatMessage((0, $7ozrG.default).webAuthnMalformedConfiguration // server returned bad options?
            ),
            [(0, $f8jwK.WebAuthnAuthenticationErrorCode).Aborted]: formatMessage((0, $7ozrG.default).webAuthnAborted),
            [(0, $f8jwK.WebAuthnAuthenticationErrorCode).NotAllowed]: formatMessage((0, $7ozrG.default).webAuthnAuthenticationIncomplete // eg. timeout, user cancelled
            ),
            [(0, $f8jwK.WebAuthnAuthenticationErrorCode).InvalidDomain]: formatMessage((0, $7ozrG.default).webAuthnInvalidDomain),
            [(0, $f8jwK.WebAuthnAuthenticationErrorCode).InvalidRpId]: formatMessage((0, $7ozrG.default).webAuthnMalformedConfiguration // server returned bad options?
            ),
            [(0, $f8jwK.WebAuthnAuthenticationErrorCode).UnknownError]: formatMessage((0, $7ozrG.default).webauthnAuthenticationFailed),
            // API errors
            [(0, $g7WC8.ChallengeApiError).tooManyRequests]: formatMessage((0, $7ozrG.default).securityKeyTooManyAttemptsMessage),
            [(0, $g7WC8.ChallengeApiError).transactionTokenNotFound]: formatMessage((0, $7ozrG.default).failedToUseKeyMessage),
            [(0, $g7WC8.ChallengeApiError).challengeFailure]: formatMessage((0, $7ozrG.default).failedToUseKeyMessage)
        }), [
        formatMessage
    ]);
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const { challengeSecurityKey: challengeSecurityKey, authenticating: authenticating } = (0, $g7WC8.useChallengeSecurityKey)($6e7993561f46078f$var$PAGE_ID, (responseData)=>{
        const redirectUri = responseData.redirectUri;
        navigate(redirectUri.toString());
    }, (error)=>{
        setErrorMessage(challengeErrorMessages[error] || formatMessage((0, $7ozrG.default).failedToUseKeyMessage));
    });
    const invokeChallengeSecurityKey = ()=>{
        setErrorMessage(undefined);
        challengeSecurityKey();
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $iw8NJ.SecurityKey), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $8LYpt.InputMessage), {
                style: {
                    margin: `${$6e7993561f46078f$var$baseSpacing} 0`
                },
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "mf.mfform.securitykey.authenticate",
                        defaultMessage: "Use your security key to continue."
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8LYpt.InlineMessageContainer), {
                        "data-testid": "mfform-tooltip-icon",
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cr5CS.default), {
                            appearance: "info",
                            placement: "bottom-end",
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8LYpt.StyledMessage), {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    id: "mf.mfform.securitykey.tooltip",
                                    defaultMessage: "Use any security key you registered with Atlassian"
                                })
                            })
                        })
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, $6CtE1.jsx)($6e7993561f46078f$var$ErrorMessageWrapper, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kJPFV.default), {
                    appearance: "warning",
                    children: errorMessage
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                id: "challenge-security-key",
                appearance: "primary",
                isFullWidth: true,
                onClick: invokeChallengeSecurityKey,
                isLoading: authenticating,
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "mf.mfform.securitykey",
                    defaultMessage: "Log in"
                })
            })
        ]
    });
};
var $6e7993561f46078f$export$2e2bcd8739ae039 = $6e7993561f46078f$var$MfaChallengeSecurityKey;

});
parcelRegister("hpnxO", function(module, exports) {
$parcel$export(module.exports, "useCreateAccountConfirmationPageState", function () { return (parcelRequire("k3As7")).useCreateAccountConfirmationPageState; });
$parcel$export(module.exports, "ChallengeApiError", function () { return (parcelRequire("g7WC8")).ChallengeApiError; });
$parcel$export(module.exports, "useChallengeSecurityKey", function () { return (parcelRequire("g7WC8")).useChallengeSecurityKey; });
parcelRequire("k3As7");
parcelRequire("bw1Na");
parcelRequire("gexpH");

});
parcelRegister("k3As7", function(module, exports) {

$parcel$export(module.exports, "useCreateAccountConfirmationPageState", function () { return $6f95ccda6cfdb25e$export$9d9b63d777a078f3; });

var $aMBBA = parcelRequire("aMBBA");
parcelRequire("65XXq");
var $aMRBJ = parcelRequire("aMRBJ");
const $6f95ccda6cfdb25e$var$selectMarketingConsent = (state)=>state.marketingConsent;
const $6f95ccda6cfdb25e$var$selectHashedCsrfToken = (state)=>state.hashedCsrfToken;
const $6f95ccda6cfdb25e$var$selectMicrobranding = (state)=>state.microbranding;
const $6f95ccda6cfdb25e$var$selectAppConfig = (state)=>state.appConfig;
const $6f95ccda6cfdb25e$var$selectCreateAccount = (state)=>state.createAccount;
const $6f95ccda6cfdb25e$export$9d9b63d777a078f3 = ()=>{
    return (0, $aMBBA.useAppSelector)((0, $aMRBJ.createSelector)([
        $6f95ccda6cfdb25e$var$selectMarketingConsent,
        $6f95ccda6cfdb25e$var$selectHashedCsrfToken,
        $6f95ccda6cfdb25e$var$selectMicrobranding,
        $6f95ccda6cfdb25e$var$selectAppConfig,
        $6f95ccda6cfdb25e$var$selectCreateAccount
    ], (marketingConsent, hashedCsrfToken, microbranding, appConfig, createAccount)=>{
        const { config: marketingConsentConfig } = marketingConsent;
        const { recaptchaEnterpriseInvisibleKeySite: recaptchaEnterpriseInvisibleKeySite } = appConfig;
        const { formError: formError, fieldErrors: fieldErrors, redirectTo: redirectTo, isLoading: isLoading } = createAccount;
        const { isEmbedded: isEmbedded, oidcContext: oidcContext } = microbranding;
        const baseState = {
            formError: formError,
            fieldErrors: fieldErrors,
            marketingConsentConfig: marketingConsentConfig,
            redirectTo: redirectTo,
            isLoading: isLoading,
            isEmbedded: isEmbedded,
            oidcContext: oidcContext,
            recaptchaEnterpriseInvisibleKeySite: recaptchaEnterpriseInvisibleKeySite
        };
        const { loginType: loginType, displayName: displayName, email: email, userFlow: userFlow, confirmationToken: confirmationToken, mfaToken: mfaToken, createNeeded: createNeeded, verifyNeeded: verifyNeeded } = createAccount;
        return {
            ...baseState,
            loginType: loginType,
            displayName: displayName,
            email: email,
            createNeeded: createNeeded,
            verifyNeeded: verifyNeeded,
            userFlow: userFlow,
            confirmationToken: confirmationToken,
            mfaToken: mfaToken,
            hashedCsrfToken: hashedCsrfToken
        };
    }));
};

});

parcelRegister("bw1Na", function(module, exports) {
$parcel$export(module.exports, "EnrollApiErrorType", function () { return (parcelRequire("d7FKg")).EnrollApiErrorType; });
$parcel$export(module.exports, "useEnrollSecurityKey", function () { return (parcelRequire("d7FKg")).useEnrollSecurityKey; });
parcelRequire("d7FKg");

});
parcelRegister("d7FKg", function(module, exports) {

$parcel$export(module.exports, "EnrollApiErrorType", function () { return $9b45c3e68d9fb944$export$ed8612e4d0d57df6; });
$parcel$export(module.exports, "useEnrollSecurityKey", function () { return $9b45c3e68d9fb944$export$b31ee8addd49a620; });

var $dNMDr = parcelRequire("dNMDr");

var $aMBBA = parcelRequire("aMBBA");

var $jAT79 = parcelRequire("jAT79");

var $l3Xwq = parcelRequire("l3Xwq");

var $4NPio = parcelRequire("4NPio");

var $hqddj = parcelRequire("hqddj");

var $f8jwK = parcelRequire("f8jwK");

var $1JRGy = parcelRequire("1JRGy");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $h4v4M = parcelRequire("h4v4M");
const $9b45c3e68d9fb944$var$X_CSRF_TOKEN_HEADER = 'X-CSRF-TOKEN';
class $9b45c3e68d9fb944$var$EnrollError extends Error {
    constructor(message, type){
        super(message);
        this.type = type;
    }
}
var $9b45c3e68d9fb944$export$ed8612e4d0d57df6 = /*#__PURE__*/ function(EnrollApiErrorType) {
    EnrollApiErrorType["deviceNameLengthError"] = "deviceNameLengthError";
    EnrollApiErrorType["rateLimitedError"] = "rateLimited";
    EnrollApiErrorType["enrollFailure"] = "enrollFailure";
    EnrollApiErrorType["invalidSecurityKeyError"] = "invalidSecurityKeyError";
    return EnrollApiErrorType;
}({});
const $9b45c3e68d9fb944$var$parseErrorResponse = (errorResponse)=>{
    // These responses are from id-management class MfaSecurityKeyFailure
    switch(errorResponse.type){
        case 'invalid-device-name':
            return "deviceNameLengthError";
        case 'invalid-security-key':
            return "invalidSecurityKeyError";
        default:
            return "enrollFailure";
    }
};
const $9b45c3e68d9fb944$var$initialize = async ({ deviceName: deviceName, csrfToken: csrfToken, token: token })=>{
    try {
        const response = await fetch(`/manage/rest/two-step-verification/start-security-key?token=${token}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                [$9b45c3e68d9fb944$var$X_CSRF_TOKEN_HEADER]: csrfToken
            },
            body: JSON.stringify({
                deviceName: deviceName
            })
        });
        switch(response.status){
            case 200:
                return response.json();
            case 400:
                const errorResponse = await response.json();
                const errorType = $9b45c3e68d9fb944$var$parseErrorResponse(errorResponse);
                throw new $9b45c3e68d9fb944$var$EnrollError(`/manage/rest/two-step-verification/confirm-security key retruns unexpected status code ${response.status}`, errorType);
            case 429:
                throw new $9b45c3e68d9fb944$var$EnrollError(`/manage/rest/two-step-verification/start-security key retruns unexpected status code ${response.status}`, "rateLimited");
            default:
                throw new $9b45c3e68d9fb944$var$EnrollError(`/manage/rest/two-step-verification/start-security key retruns unexpected status code ${response.status}`, "enrollFailure");
        }
    } catch (error) {
        if (error instanceof $9b45c3e68d9fb944$var$EnrollError) throw error;
        throw new $9b45c3e68d9fb944$var$EnrollError(error.message, "enrollFailure");
    }
};
const $9b45c3e68d9fb944$var$createCredentialsOnAuthenticator = async (securityKeyEnrollmentDetails)=>{
    try {
        const options = (0, $jAT79.parseCreationOptionsFromJSON)({
            publicKey: {
                ...securityKeyEnrollmentDetails.creationOptions,
                timeout: 60000
            }
        });
        try {
            const securityKeyCredential = await (0, $jAT79.create)(options);
            return securityKeyCredential.toJSON();
        } catch (error) {
            (0, $hqddj.captureErrorMessage)('Security key credential creation failed', {
                webauthnError: {
                    name: error.name,
                    message: JSON.stringify(error.message)
                }
            });
            const errorCode = (0, $f8jwK.translateRegistrationError)({
                error: error,
                options: options
            });
            throw new $9b45c3e68d9fb944$var$EnrollError(`Failed to create credentials on authenticator: ${error.message}`, errorCode);
        }
    } catch (error) {
        if (error instanceof $9b45c3e68d9fb944$var$EnrollError) throw error;
        (0, $hqddj.captureErrorMessage)('Failed to parse creation options for security key', {
            webauthnError: {
                name: error.name,
                message: JSON.stringify(error.message)
            }
        });
        throw new $9b45c3e68d9fb944$var$EnrollError(`Failed to parse creation options: ${error.message}`, (0, $f8jwK.WebAuthnRegistrationErrorCode).InvalidCreationOptions);
    }
};
const $9b45c3e68d9fb944$var$confirm = async ({ transactionToken: transactionToken, csrfToken: csrfToken, token: token, continueUrl: continueUrl, ...attestationJson })=>{
    const clientExtensionResultsJsonString = JSON.stringify(attestationJson.clientExtensionResults);
    try {
        const confirmUrl = `/manage/rest/two-step-verification/confirm-security-key?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify({
            transactionToken: transactionToken,
            token: token,
            continue: continueUrl
        })}`;
        const response = await fetch(confirmUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                [$9b45c3e68d9fb944$var$X_CSRF_TOKEN_HEADER]: csrfToken
            },
            body: JSON.stringify({
                ...attestationJson,
                clientExtensionResults: clientExtensionResultsJsonString
            })
        });
        switch(response.status){
            case 200:
                {
                    const body = await response.json();
                    const { enrollmentActionType: enrollmentActionType, redirectUrl: redirectUrl } = body;
                    if (enrollmentActionType === 'added') {
                        // `added` - user is enrolling security key as addition factor
                        // This action is called by the enrollment wizard which is designed only for enrolling the first MFA factor.
                        // If a user manually visit the url of the wizard while already have MFA enabled, the enrollment may succeed.
                        // In that case, we want to redirect them directly to the continue URL instead of showing the recovery code,
                        // which is only valid for first MFA factor enrollment.
                        // Note: `redirectUrl` is the url to `idac/login/authorize` to force session rotation before redirecting the
                        //       user to `continueUrl`, and will not be return as part of the `added` call.
                        const url = continueUrl || '/manage-profile/security/two-step-verification';
                        return {
                            redirectUrl: url,
                            immediateRedirect: true
                        };
                    } else // `created` - user is enrolling security key as their first MFA factor
                    // Show recovery page with button to redirect to `redirectUrl` at `idac/login/authorize` to force session rotation.
                    return {
                        redirectUrl: redirectUrl,
                        immediateRedirect: false
                    };
                }
            case 429:
                throw new $9b45c3e68d9fb944$var$EnrollError(`/manage/rest/two-step-verification/confirm-security key retruns unexpected status code ${response.status}`, "rateLimited");
            default:
                throw new $9b45c3e68d9fb944$var$EnrollError(`/manage/rest/two-step-verification/confirm-security key retruns unexpected status code ${response.status}`, "enrollFailure");
        }
    } catch (error) {
        if (error instanceof $9b45c3e68d9fb944$var$EnrollError) throw error;
        throw new $9b45c3e68d9fb944$var$EnrollError(error.message, "enrollFailure");
    }
};
const $9b45c3e68d9fb944$export$b31ee8addd49a620 = (analyticsPageId, onSuccess, onError)=>{
    const csrfToken = (0, $aMBBA.useAppSelector)((state)=>state.csrfToken);
    const token = (0, $aMBBA.useAppSelector)((state)=>state.mfaEnrollment.token) || '';
    const isSupported = (0, $f8jwK.isWebAuthnSupported)();
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const location = (0, $cVnBY.useLocation)();
    const search = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search);
    const [confirmingEnrollment, setConfirmingEnrollment] = (0, $dNMDr.useState)(false);
    const enrollSecurityKey = (0, $dNMDr.useCallback)(async (deviceName)=>{
        analyticsClient.trackingEvent({
            page: analyticsPageId,
            subject: '2svEnrolRegisterSecurityKey',
            action: 'started'
        });
        if (!isSupported) {
            analyticsClient.trackingEvent({
                page: analyticsPageId,
                action: 'failed',
                subject: '2svEnrolRegisterSecurityKey',
                attributes: {
                    reason: (0, $f8jwK.WebAuthnRegistrationErrorCode).WebAuthnNotSupported
                }
            });
            return onError((0, $f8jwK.WebAuthnRegistrationErrorCode).WebAuthnNotSupported);
        }
        try {
            setConfirmingEnrollment(true);
            const securityKeyEnrollmentDetails = await $9b45c3e68d9fb944$var$initialize({
                deviceName: deviceName,
                csrfToken: csrfToken,
                token: token
            });
            dispatch((0, $l3Xwq.confirmSecurityKeyEnrollment)(securityKeyEnrollmentDetails.recoveryCode));
            const securityKeyCredentialJson = await $9b45c3e68d9fb944$var$createCredentialsOnAuthenticator(securityKeyEnrollmentDetails);
            const { immediateRedirect: immediateRedirect, redirectUrl: redirectUrl } = await $9b45c3e68d9fb944$var$confirm({
                transactionToken: securityKeyEnrollmentDetails.transactionToken,
                csrfToken: csrfToken,
                token: token,
                continueUrl: search.continue,
                ...securityKeyCredentialJson
            });
            if (immediateRedirect) navigate(redirectUrl);
            else dispatch((0, $l3Xwq.confirmEnrollResponse)(redirectUrl));
            analyticsClient.trackingEvent({
                page: analyticsPageId,
                subject: '2svEnrolRegisterSecurityKey',
                action: 'succeeded'
            });
            return onSuccess();
        } catch (e) {
            setConfirmingEnrollment(false);
            analyticsClient.trackingEvent({
                page: analyticsPageId,
                subject: '2svEnrolRegisterSecurityKey',
                action: 'failed',
                attributes: {
                    reason: e.type || "enrollFailure"
                }
            });
            return onError(e.type || "enrollFailure");
        }
    }, [
        isSupported,
        analyticsClient,
        onError,
        dispatch,
        onSuccess,
        csrfToken,
        search.continue,
        token,
        analyticsPageId,
        navigate
    ]);
    return {
        enrollSecurityKey: enrollSecurityKey,
        confirmingEnrollment: confirmingEnrollment
    };
};

});
parcelRegister("jAT79", function(module, exports) {

$parcel$export(module.exports, "parseCreationOptionsFromJSON", function () { return $e43c21aace265bfc$export$edb10dc0152a1b65; });
$parcel$export(module.exports, "parseRequestOptionsFromJSON", function () { return $e43c21aace265bfc$export$c89152b37af49fa1; });
$parcel$export(module.exports, "create", function () { return $e43c21aace265bfc$export$185802fd694ee1f5; });
$parcel$export(module.exports, "get", function () { return $e43c21aace265bfc$export$3988ae62b71be9a3; });
// src/webauthn-json/base64url.ts
function $e43c21aace265bfc$var$base64urlToBuffer(baseurl64String) {
    const padding = "==".slice(0, (4 - baseurl64String.length % 4) % 4);
    const base64String = baseurl64String.replace(/-/g, "+").replace(/_/g, "/") + padding;
    const str = atob(base64String);
    const buffer = new ArrayBuffer(str.length);
    const byteView = new Uint8Array(buffer);
    for(let i = 0; i < str.length; i++)byteView[i] = str.charCodeAt(i);
    return buffer;
}
function $e43c21aace265bfc$var$bufferToBase64url(buffer) {
    const byteView = new Uint8Array(buffer);
    let str = "";
    for (const charCode of byteView)str += String.fromCharCode(charCode);
    const base64String = btoa(str);
    const base64urlString = base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    return base64urlString;
}
// src/webauthn-json/convert.ts
var $e43c21aace265bfc$var$copyValue = "copy";
var $e43c21aace265bfc$var$convertValue = "convert";
function $e43c21aace265bfc$var$convert(conversionFn, schema, input) {
    if (schema === $e43c21aace265bfc$var$copyValue) return input;
    if (schema === $e43c21aace265bfc$var$convertValue) return conversionFn(input);
    if (schema instanceof Array) return input.map((v)=>$e43c21aace265bfc$var$convert(conversionFn, schema[0], v));
    if (schema instanceof Object) {
        const output = {};
        for (const [key, schemaField] of Object.entries(schema)){
            if (schemaField.derive) {
                const v = schemaField.derive(input);
                if (v !== void 0) input[key] = v;
            }
            if (!(key in input)) {
                if (schemaField.required) throw new Error(`Missing key: ${key}`);
                continue;
            }
            if (input[key] == null) {
                output[key] = null;
                continue;
            }
            output[key] = $e43c21aace265bfc$var$convert(conversionFn, schemaField.schema, input[key]);
        }
        return output;
    }
}
function $e43c21aace265bfc$var$derived(schema, derive) {
    return {
        required: true,
        schema: schema,
        derive: derive
    };
}
function $e43c21aace265bfc$var$required(schema) {
    return {
        required: true,
        schema: schema
    };
}
function $e43c21aace265bfc$var$optional(schema) {
    return {
        required: false,
        schema: schema
    };
}
// src/webauthn-json/basic/schema.ts
var $e43c21aace265bfc$var$publicKeyCredentialDescriptorSchema = {
    type: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$copyValue),
    id: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$convertValue),
    transports: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue)
};
var $e43c21aace265bfc$var$simplifiedExtensionsSchema = {
    appid: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
    appidExclude: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
    credProps: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue)
};
var $e43c21aace265bfc$var$simplifiedClientExtensionResultsSchema = {
    appid: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
    appidExclude: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
    credProps: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue)
};
var $e43c21aace265bfc$var$credentialCreationOptions = {
    publicKey: $e43c21aace265bfc$var$required({
        rp: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$copyValue),
        user: $e43c21aace265bfc$var$required({
            id: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$convertValue),
            name: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$copyValue),
            displayName: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$copyValue)
        }),
        challenge: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$convertValue),
        pubKeyCredParams: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$copyValue),
        timeout: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
        excludeCredentials: $e43c21aace265bfc$var$optional([
            $e43c21aace265bfc$var$publicKeyCredentialDescriptorSchema
        ]),
        authenticatorSelection: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
        attestation: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
        extensions: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$simplifiedExtensionsSchema)
    }),
    signal: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue)
};
var $e43c21aace265bfc$var$publicKeyCredentialWithAttestation = {
    type: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$copyValue),
    id: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$copyValue),
    rawId: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$convertValue),
    authenticatorAttachment: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
    response: $e43c21aace265bfc$var$required({
        clientDataJSON: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$convertValue),
        attestationObject: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$convertValue),
        transports: $e43c21aace265bfc$var$derived($e43c21aace265bfc$var$copyValue, (response)=>{
            var _a;
            return ((_a = response.getTransports) == null ? void 0 : _a.call(response)) || [];
        })
    }),
    clientExtensionResults: $e43c21aace265bfc$var$derived($e43c21aace265bfc$var$simplifiedClientExtensionResultsSchema, (pkc)=>pkc.getClientExtensionResults())
};
var $e43c21aace265bfc$var$credentialRequestOptions = {
    mediation: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
    publicKey: $e43c21aace265bfc$var$required({
        challenge: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$convertValue),
        timeout: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
        rpId: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
        allowCredentials: $e43c21aace265bfc$var$optional([
            $e43c21aace265bfc$var$publicKeyCredentialDescriptorSchema
        ]),
        userVerification: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
        extensions: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$simplifiedExtensionsSchema)
    }),
    signal: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue)
};
var $e43c21aace265bfc$var$publicKeyCredentialWithAssertion = {
    type: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$copyValue),
    id: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$copyValue),
    rawId: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$convertValue),
    authenticatorAttachment: $e43c21aace265bfc$var$optional($e43c21aace265bfc$var$copyValue),
    response: $e43c21aace265bfc$var$required({
        clientDataJSON: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$convertValue),
        authenticatorData: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$convertValue),
        signature: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$convertValue),
        userHandle: $e43c21aace265bfc$var$required($e43c21aace265bfc$var$convertValue)
    }),
    clientExtensionResults: $e43c21aace265bfc$var$derived($e43c21aace265bfc$var$simplifiedClientExtensionResultsSchema, (pkc)=>pkc.getClientExtensionResults())
};
// src/webauthn-json/basic/api.ts
function $e43c21aace265bfc$export$edb10dc0152a1b65(requestJSON) {
    return $e43c21aace265bfc$var$convert($e43c21aace265bfc$var$base64urlToBuffer, $e43c21aace265bfc$var$credentialCreationOptions, requestJSON);
}
function $e43c21aace265bfc$var$createResponseToJSON(credential) {
    return $e43c21aace265bfc$var$convert($e43c21aace265bfc$var$bufferToBase64url, $e43c21aace265bfc$var$publicKeyCredentialWithAttestation, credential);
}
function $e43c21aace265bfc$export$c89152b37af49fa1(requestJSON) {
    return $e43c21aace265bfc$var$convert($e43c21aace265bfc$var$base64urlToBuffer, $e43c21aace265bfc$var$credentialRequestOptions, requestJSON);
}
function $e43c21aace265bfc$var$getResponseToJSON(credential) {
    return $e43c21aace265bfc$var$convert($e43c21aace265bfc$var$bufferToBase64url, $e43c21aace265bfc$var$publicKeyCredentialWithAssertion, credential);
}
// src/webauthn-json/basic/supported.ts
function $e43c21aace265bfc$export$5f747a46dc0eb6ee() {
    return !!(navigator.credentials && navigator.credentials.create && navigator.credentials.get && window.PublicKeyCredential);
}
// src/webauthn-json/browser-ponyfill.ts
async function $e43c21aace265bfc$export$185802fd694ee1f5(options) {
    const response = await navigator.credentials.create(options);
    response.toJSON = ()=>$e43c21aace265bfc$var$createResponseToJSON(response);
    return response;
}
async function $e43c21aace265bfc$export$3988ae62b71be9a3(options) {
    const response = await navigator.credentials.get(options);
    response.toJSON = ()=>$e43c21aace265bfc$var$getResponseToJSON(response);
    return response;
}

});

parcelRegister("l3Xwq", function(module, exports) {

$parcel$export(module.exports, "startEnroll", function () { return $bef1b03e9b228265$export$7c9dff46f0231dac; });
$parcel$export(module.exports, "confirmEnrollResponse", function () { return $bef1b03e9b228265$export$d0b229b11a2b0436; });
$parcel$export(module.exports, "confirmEnroll", function () { return $bef1b03e9b228265$export$d7fcff46f05bc313; });
$parcel$export(module.exports, "resetSmsEnrollError", function () { return $bef1b03e9b228265$export$11470e604dac27df; });
$parcel$export(module.exports, "startSmsEnroll", function () { return $bef1b03e9b228265$export$cc095becfa9fc392; });
$parcel$export(module.exports, "fetchUnsupportedCountries", function () { return $bef1b03e9b228265$export$275825b5052968f8; });
$parcel$export(module.exports, "smsEnrollmentCaptchaFailure", function () { return $bef1b03e9b228265$export$5d71d66cd3287216; });
$parcel$export(module.exports, "startSecurityKeyEnroll", function () { return $bef1b03e9b228265$export$a68b4a7d4e20cc56; });
$parcel$export(module.exports, "confirmSecurityKeyEnrollment", function () { return $bef1b03e9b228265$export$8adf731e4230fb01; });

var $1JRGy = parcelRequire("1JRGy");

var $hqddj = parcelRequire("hqddj");
const $bef1b03e9b228265$export$31554e24efe6c842 = (transactionToken, emailAddress, totpSecret, recoveryCode, totpUri)=>({
        type: 'START_ENROLL_RESPONSE',
        transactionToken: transactionToken,
        emailAddress: emailAddress,
        totpSecret: totpSecret,
        recoveryCode: recoveryCode,
        totpUri: totpUri
    });
const $bef1b03e9b228265$export$90c618a494cc13d3 = (token)=>({
        type: 'START_ENROLL',
        token: token
    });
const $bef1b03e9b228265$export$7c9dff46f0231dac = (token)=>(dispatch, getState)=>{
        dispatch($bef1b03e9b228265$export$90c618a494cc13d3(token));
        const { csrfToken: csrfToken } = getState();
        return fetch(`/manage/rest/two-step-verification/start-enroll?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify({
            token: token
        })}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        }).then((response)=>response.json().then((data)=>{
                if (response.ok) return data;
                else throw new Error(`${response.status} ${response.statusText}: /manage/rest/two-step-verification/start-enroll`);
            })).then(({ transactionToken: transactionToken, emailAddress: emailAddress, totpSecret: totpSecret, recoveryCode: recoveryCode, totpUri: totpUri })=>{
            dispatch($bef1b03e9b228265$export$31554e24efe6c842(transactionToken, emailAddress, totpSecret, recoveryCode, totpUri));
        });
    };
const $bef1b03e9b228265$export$d0b229b11a2b0436 = (redirectUrl)=>({
        type: 'CONFIRM_ENROLL_RESPONSE',
        redirectUrl: redirectUrl
    });
const $bef1b03e9b228265$export$5727292bf8b89d3 = ()=>({
        type: 'CONFIRM_ENROLL_ERROR'
    });
const $bef1b03e9b228265$export$3c756426338d3bb7 = (otpCode, continueUrl)=>({
        type: 'CONFIRM_ENROLL',
        otpCode: otpCode,
        continueUrl: continueUrl
    });
const $bef1b03e9b228265$export$d7fcff46f05bc313 = (otpCode, continueUrl, navigate)=>(dispatch, getState)=>{
        dispatch($bef1b03e9b228265$export$3c756426338d3bb7(otpCode, continueUrl));
        const { csrfToken: csrfToken, mfaEnrollment: mfaEnrollment } = getState();
        return fetch(`/manage/rest/two-step-verification/confirm-enroll?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify({
            token: mfaEnrollment.token,
            continue: continueUrl
        })}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify({
                transactionToken: mfaEnrollment.transactionToken,
                otpCode: otpCode
            }),
            credentials: 'same-origin'
        }).then((response)=>{
            switch(response.status){
                case 200:
                    return response.json();
                case 204:
                    return Promise.resolve({
                        redirectUrl: null
                    });
                default:
                    throw response;
            }
        }).then(({ enrollmentActionType: enrollmentActionType, redirectUrl: redirectUrl })=>{
            if (enrollmentActionType === 'added') // `added` - user is enrolling TOTP as addition factor
            // This action is called by the enrollment wizard which is designed only for enrolling the first MFA factor.
            // If a user manually visit the url of the wizard while already have MFA enabled, the enrollment may succeed.
            // In that case, we want to redirect them directly to the continue URL instead of showing the recovery code,
            // which is only valid for first MFA factor enrollment.
            // Note: `redirectUrl` is the url to `idac/login/authorize` to force session rotation before redirecting the
            //       user to `continueUrl`, and will not be return as part of the `added` call.
            navigate(continueUrl || '/manage-profile/security/two-step-verification');
            else // `created` - user is enrolling TOTP as their first MFA factor
            // Show recovery page with button to redirect to `redirectUrl` at `idac/login/authorize` to force session rotation.
            dispatch($bef1b03e9b228265$export$d0b229b11a2b0436(redirectUrl));
        }, (response)=>{
            dispatch($bef1b03e9b228265$export$5727292bf8b89d3());
            throw new Error(`${response.status} ${response.statusText}: /manage/rest/two-step-verification/confirm-enroll`);
        });
    };
const $bef1b03e9b228265$export$854ee8e5ea8056b6 = (transactionToken, recoveryCode, phoneNumber)=>({
        type: 'START_SMS_ENROLL_RESPONSE',
        transactionToken: transactionToken,
        recoveryCode: recoveryCode,
        phoneNumber: phoneNumber
    });
const $bef1b03e9b228265$export$4586154d8ae4818b = (smsEnrollError)=>({
        type: 'START_SMS_ENROLL_ERROR',
        smsEnrollError: smsEnrollError
    });
const $bef1b03e9b228265$export$11470e604dac27df = ()=>({
        type: 'RESET_SMS_ENROLL_ERROR'
    });
const $bef1b03e9b228265$export$3b42004cef4b7302 = (phoneNumber, token)=>({
        type: 'START_SMS_ENROLL',
        token: token,
        phoneNumber: phoneNumber
    });
const $bef1b03e9b228265$export$cc095becfa9fc392 = (phoneNumber, token, captchaToken)=>(dispatch, getState)=>{
        dispatch($bef1b03e9b228265$export$3b42004cef4b7302(phoneNumber, token));
        const { csrfToken: csrfToken } = getState();
        return fetch(`/manage/rest/two-step-verification/start-enroll-sms?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify({
            token: token
        })}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify({
                phoneNumber: phoneNumber,
                captchaToken: captchaToken
            }),
            credentials: 'same-origin'
        }).then((response)=>{
            switch(response.status){
                case 200:
                    return response.json();
                default:
                    throw response;
            }
        }).then(({ transactionToken: transactionToken, recoveryCode: recoveryCode })=>{
            dispatch($bef1b03e9b228265$export$854ee8e5ea8056b6(transactionToken, recoveryCode, phoneNumber));
        }, async (response)=>{
            const errorFromBadRequest = (response)=>response.json().then((body)=>{
                    switch(body.type){
                        case 'invalidPhoneNumber':
                            return 'invalid_phone_number';
                        case 'phoneNumberNotEligible':
                            return 'phone_number_not_eligible';
                        default:
                            return 'generic_error';
                    }
                }).catch(()=>'generic_error');
            const error = (response)=>{
                switch(response.status){
                    case 400:
                        return errorFromBadRequest(response);
                    case 429:
                        return 'too_many_sms';
                    default:
                        return 'generic_error';
                }
            };
            const errorLabel = await error(response);
            dispatch($bef1b03e9b228265$export$4586154d8ae4818b(errorLabel));
            if (errorLabel === 'generic_error') (0, $hqddj.captureErrorMessage)(`${response.status} ${response.statusText}: /manage/rest/two-step-verification/start-enroll-sms`);
        });
    };
const $bef1b03e9b228265$export$d6651cd2d476e6a1 = (unsupportedCountries = [])=>({
        type: 'UPDATE_SMS_ENROLLMENT_UNSUPPORTED_COUNTRIES',
        unsupportedCountries: unsupportedCountries
    });
const $bef1b03e9b228265$export$275825b5052968f8 = ()=>(dispatch)=>{
        return fetch(`/v2/mfa/enroll-sms/countries`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin'
        }).then((response)=>{
            switch(response.status){
                case 200:
                    return response.json();
                default:
                    return [];
            }
        }).then((body)=>{
            dispatch($bef1b03e9b228265$export$d6651cd2d476e6a1(body.unsupportedCountries || []));
        }, ()=>{
            dispatch($bef1b03e9b228265$export$d6651cd2d476e6a1([]));
        });
    };
const $bef1b03e9b228265$export$5d71d66cd3287216 = (isOnline)=>$bef1b03e9b228265$export$4586154d8ae4818b(isOnline ? 'captcha' : 'generic_error');
const $bef1b03e9b228265$export$a68b4a7d4e20cc56 = (token)=>({
        type: 'START_SECURITY_KEY_ENROLL',
        token: token
    });
const $bef1b03e9b228265$export$8adf731e4230fb01 = (recoveryCode)=>({
        type: 'CONFIRM_SECURITY_KEY_ENROLLMENT',
        recoveryCode: recoveryCode
    });

});

parcelRegister("f8jwK", function(module, exports) {

$parcel$export(module.exports, "WebAuthnRegistrationErrorCode", function () { return $5bf1fccd31a1d933$export$99a3b8eef897cf04; });
$parcel$export(module.exports, "WebAuthnAuthenticationErrorCode", function () { return $5bf1fccd31a1d933$export$d73d3e8fcbb706b6; });
$parcel$export(module.exports, "isWebAuthnSupported", function () { return $5bf1fccd31a1d933$export$b48b2572c8b3a543; });
$parcel$export(module.exports, "translateRegistrationError", function () { return $5bf1fccd31a1d933$export$b31dc4fbcb20b129; });
$parcel$export(module.exports, "translateAuthenticationError", function () { return $5bf1fccd31a1d933$export$dafd1cf90bfb0daf; });
$parcel$export(module.exports, "challengeWithAuthenticator", function () { return $5bf1fccd31a1d933$export$70714cff41fa01ec; });

var $hqddj = parcelRequire("hqddj");

var $9Nhk2 = parcelRequire("9Nhk2");
var $5bf1fccd31a1d933$export$99a3b8eef897cf04 = /*#__PURE__*/ function(WebAuthnRegistrationErrorCode) {
    WebAuthnRegistrationErrorCode["WebAuthnNotSupported"] = "webauthn_not_supported";
    WebAuthnRegistrationErrorCode["InvalidCreationOptions"] = "invalid_creation_options";
    WebAuthnRegistrationErrorCode["Aborted"] = "aborted";
    WebAuthnRegistrationErrorCode["DiscoverableCredentialSupportRequired"] = "discoverable_credential_support_required";
    WebAuthnRegistrationErrorCode["UserVerificationSupportRequired"] = "user_verification_support_required";
    WebAuthnRegistrationErrorCode["PreviouslyRegistered"] = "previously_registered";
    WebAuthnRegistrationErrorCode["NotAllowed"] = "not_allowed";
    WebAuthnRegistrationErrorCode["MalformedPubKeyCredParams"] = "malformed_pub_key_cred_params";
    WebAuthnRegistrationErrorCode["NoSupportedPubKeyCredParamsAlgorithm"] = "no_supported_pub_key_cred_params_algorithm";
    WebAuthnRegistrationErrorCode["InvalidDomain"] = "invalid_domain";
    WebAuthnRegistrationErrorCode["InvalidRpId"] = "invalid_rp_id";
    WebAuthnRegistrationErrorCode["InvalidUserIdLength"] = "invalid_user_id_length";
    WebAuthnRegistrationErrorCode["UnknownError"] = "unknown_error";
    return WebAuthnRegistrationErrorCode;
}({});
var $5bf1fccd31a1d933$export$d73d3e8fcbb706b6 = /*#__PURE__*/ function(WebAuthnAuthenticationErrorCode) {
    WebAuthnAuthenticationErrorCode["WebAuthnNotSupported"] = "webauthn_not_supported";
    WebAuthnAuthenticationErrorCode["InvalidRequestOptions"] = "invalid_request_options";
    WebAuthnAuthenticationErrorCode["Aborted"] = "aborted";
    WebAuthnAuthenticationErrorCode["NotAllowed"] = "not_allowed";
    WebAuthnAuthenticationErrorCode["InvalidDomain"] = "invalid_domain";
    WebAuthnAuthenticationErrorCode["InvalidRpId"] = "invalid_rp_id";
    WebAuthnAuthenticationErrorCode["UnknownError"] = "unknown_error";
    return WebAuthnAuthenticationErrorCode;
}({});
const $5bf1fccd31a1d933$export$b48b2572c8b3a543 = ()=>!!window.PublicKeyCredential;
/**
 * Source: https://github.com/MasterKale/SimpleWebAuthn/blob/master/packages/browser/src/helpers/isValidDomain.ts
 *
 * A simple test to determine if a hostname is a properly-formatted domain name
 *
 * Regex sourced from here:
 * https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch08s15.html
 *
 * This regex is checking if a given string is a valid domain name.
 * It should start with a series of alphanumeric characters (can be separated by hyphens), followed by one or more dots, and end with a top-level domain of at least two alphabetic characters.
 */ const $5bf1fccd31a1d933$var$isValidDomain = (hostname)=>hostname === 'localhost' || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname);
const $5bf1fccd31a1d933$export$b31dc4fbcb20b129 = ({ error: error, options: options })=>{
    const { publicKey: publicKey } = options;
    if (!publicKey) return "invalid_creation_options";
    switch(error.name){
        case 'AbortError':
            if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
            return "aborted";
            break;
        case 'ConstraintError':
            if (publicKey.authenticatorSelection?.requireResidentKey === true) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 4)
            return "discoverable_credential_support_required";
            if (publicKey.authenticatorSelection?.userVerification === 'required') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 5)
            return "user_verification_support_required";
            break;
        case 'InvalidStateError':
            // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 20)
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 3)
            return "previously_registered";
        case 'NotAllowedError':
            // Platforms are overloading this error beyond what the spec defines
            // https://stackoverflow.com/questions/77448336/handling-user-cancellation-when-creating-credentials-with-webauthn-api
            return "not_allowed";
        case 'NotSupportedError':
            const hasValidPubKeyCredParams = publicKey.pubKeyCredParams.some((param)=>param.type === 'public-key') || false;
            if (!hasValidPubKeyCredParams) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
            return "malformed_pub_key_cred_params";
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
            return "no_supported_pub_key_cred_params_algorithm";
        case 'SecurityError':
            const effectiveDomain = window.location.hostname;
            if (!$5bf1fccd31a1d933$var$isValidDomain(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 7)
            return "invalid_domain";
            if (publicKey.rp.id !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 8)
            return "invalid_rp_id";
            break;
        case 'TypeError':
            if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 5)
            return "invalid_user_id_length";
            break;
        case 'UnknownError':
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 1)
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 8)
            return "unknown_error";
    }
    // for anything else, return unknown error
    return "unknown_error";
};
const $5bf1fccd31a1d933$export$dafd1cf90bfb0daf = ({ error: error, options: options })=>{
    const { publicKey: publicKey } = options;
    if (!publicKey) return "invalid_request_options";
    switch(error.name){
        case 'AbortError':
            if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
            return "aborted";
            break;
        case 'NotAllowedError':
            // Platforms are overloading this error beyond what the spec defines
            return "not_allowed";
        case 'SecurityError':
            const effectiveDomain = window.location.hostname;
            if (!$5bf1fccd31a1d933$var$isValidDomain(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 5)
            return "invalid_domain";
            if (publicKey.rpId !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 6)
            return "invalid_rp_id";
            break;
        case 'UnknownError':
            // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 1)
            // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 12)
            return "unknown_error";
    }
    // for anything else, return unknown error
    return "unknown_error";
};
function $5bf1fccd31a1d933$var$serializePublicKeyCredential(credential) {
    const response = credential.response;
    return {
        id: credential.id,
        rawId: (0, $9Nhk2.bufferToBase64url)(credential.rawId),
        response: {
            authenticatorData: (0, $9Nhk2.bufferToBase64url)(response.authenticatorData),
            clientDataJSON: (0, $9Nhk2.bufferToBase64url)(response.clientDataJSON),
            signature: (0, $9Nhk2.bufferToBase64url)(response.signature),
            userHandle: response.userHandle ? (0, $9Nhk2.bufferToBase64url)(response.userHandle) : undefined,
            clientExtensionJson: credential.getClientExtensionResults()
        },
        type: credential.type
    };
}
const $5bf1fccd31a1d933$export$70714cff41fa01ec = async (requestOptions)=>{
    const publicKey = {
        ...requestOptions,
        challenge: (0, $9Nhk2.base64urlToBuffer)(requestOptions.challenge)
    };
    try {
        const credential = await navigator.credentials.get({
            publicKey: publicKey
        });
        const serializedCredential = $5bf1fccd31a1d933$var$serializePublicKeyCredential(credential);
        return {
            success: true,
            data: serializedCredential
        };
    } catch (error) {
        (0, $hqddj.captureErrorMessage)('Authentication failed', {
            webauthnError: {
                name: error.name,
                message: JSON.stringify(error)
            }
        });
        // https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/get#exceptions
        switch(error.name){
            case 'AbortError':
                return {
                    success: false,
                    error: "aborted"
                };
            case 'NotAllowedError':
                return {
                    success: false,
                    error: "not_allowed"
                };
            case 'SecurityError':
                return {
                    success: false,
                    error: "invalid_domain"
                };
            case 'IdentityCredentialError':
            case 'NetworkError':
                return {
                    success: false,
                    error: "unknown_error"
                };
            default:
                return {
                    success: false,
                    error: "unknown_error"
                };
        }
    }
};

});
parcelRegister("9Nhk2", function(module, exports) {

$parcel$export(module.exports, "base64urlToBuffer", function () { return $9fea46dd034dbb23$export$d203bea30aac4ae7; });
$parcel$export(module.exports, "bufferToBase64url", function () { return $9fea46dd034dbb23$export$35dc1b4ac9cc4512; });
// Original author: https://github.com/github/webauthn-json/blob/main/src/webauthn-json/base64url.ts
function $9fea46dd034dbb23$export$d203bea30aac4ae7(baseurl64String) {
    // Base64url to Base64
    const padding = '=='.slice(0, (4 - baseurl64String.length % 4) % 4);
    const base64String = baseurl64String.replace(/-/g, '+').replace(/_/g, '/') + padding;
    // Base64 to binary string
    const str = atob(base64String);
    // Binary string to buffer
    const buffer = new ArrayBuffer(str.length);
    const byteView = new Uint8Array(buffer);
    for(let i = 0; i < str.length; i++)byteView[i] = str.charCodeAt(i);
    return buffer;
}
function $9fea46dd034dbb23$export$35dc1b4ac9cc4512(buffer) {
    // Buffer to binary string
    const byteView = new Uint8Array(buffer);
    let str = '';
    for (const charCode of byteView)str += String.fromCharCode(charCode);
    // Binary string to base64
    const base64String = btoa(str);
    // Base64 to base64url
    // We assume that the base64url string is well-formed.
    const base64urlString = base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    return base64urlString;
}

});




parcelRegister("gexpH", function(module, exports) {
$parcel$export(module.exports, "ChallengeApiError", function () { return (parcelRequire("g7WC8")).ChallengeApiError; });
$parcel$export(module.exports, "useChallengeSecurityKey", function () { return (parcelRequire("g7WC8")).useChallengeSecurityKey; });
parcelRequire("g7WC8");

});
parcelRegister("g7WC8", function(module, exports) {

$parcel$export(module.exports, "ChallengeApiError", function () { return $0428691a48be56ba$export$eba107851027d37; });
$parcel$export(module.exports, "useChallengeSecurityKey", function () { return $0428691a48be56ba$export$9b0f7f7d25e7c579; });

var $dNMDr = parcelRequire("dNMDr");

var $jAT79 = parcelRequire("jAT79");

var $4NPio = parcelRequire("4NPio");

var $1JRGy = parcelRequire("1JRGy");

var $f8jwK = parcelRequire("f8jwK");

var $hqddj = parcelRequire("hqddj");

var $h4v4M = parcelRequire("h4v4M");

var $fcxz7 = parcelRequire("fcxz7");
const $0428691a48be56ba$var$ANALYTIC_EVENT_SUBJECT_ID = 'challengeSecurityKey';
var $0428691a48be56ba$export$eba107851027d37 = /*#__PURE__*/ function(ChallengeApiError) {
    ChallengeApiError["transactionTokenNotFound"] = "transactionTokenNotFound";
    ChallengeApiError["challengeFailure"] = "challengeFailure";
    ChallengeApiError["tooManyRequests"] = "tooManyRequests";
    return ChallengeApiError;
}({});
const $0428691a48be56ba$var$challenge = async ({ transactionToken: transactionToken })=>{
    try {
        const response = await fetch(`/v2/mfa/security-key/challenge?transactionToken=${transactionToken}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        switch(response.status){
            case 200:
                const challengeResponse = await response.json();
                return {
                    success: true,
                    data: challengeResponse
                };
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error from fetch: /v2/mfa/security-key/challenge`);
    }
};
const $0428691a48be56ba$var$authorize = async ({ transactionToken: transactionToken })=>{
    try {
        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(window.location.search);
        queryParams.transactionToken = transactionToken;
        const response = await fetch(`/rest/mfa/authorize?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(queryParams)}`);
        switch(response.status){
            case 200:
                const authorizeResponse = await response.json();
                return {
                    success: true,
                    data: authorizeResponse
                };
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error from fetch: /rest/mfa/authorize`);
    }
};
const $0428691a48be56ba$var$challengeWithAuthenticator = async (requestOptions)=>{
    try {
        const options = (0, $jAT79.parseRequestOptionsFromJSON)({
            publicKey: {
                ...requestOptions,
                timeout: 60000
            }
        });
        try {
            const securityKeyCredential = await (0, $jAT79.get)(options);
            return {
                success: true,
                data: securityKeyCredential.toJSON()
            };
        } catch (error) {
            (0, $hqddj.captureErrorMessage)('Security key authentication failed', {
                webauthnError: {
                    name: error.name,
                    message: JSON.stringify(error.message)
                }
            });
            const errorCode = (0, $f8jwK.translateAuthenticationError)({
                error: error,
                options: options
            });
            return {
                success: false,
                error: errorCode
            };
        }
    } catch (error) {
        (0, $hqddj.captureErrorMessage)('Failed to parse authenticate options for security key', {
            webauthnError: {
                name: error.name,
                message: JSON.stringify(error.message)
            }
        });
        return {
            success: false,
            error: (0, $f8jwK.WebAuthnAuthenticationErrorCode).InvalidRequestOptions
        };
    }
};
const $0428691a48be56ba$var$verify = async ({ transactionToken: transactionToken, assertionJson: assertionJson, analyticsClient: analyticsClient, pageId: pageId })=>{
    try {
        const clientExtensionResultsJsonString = JSON.stringify(assertionJson.clientExtensionResults);
        const response = await fetch(`/v2/mfa/security-key/verify?transactionToken=${transactionToken}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...assertionJson,
                clientExtensionResults: clientExtensionResultsJsonString
            })
        });
        switch(response.status){
            case 200:
                {
                    const { transactionToken: transactionToken } = await response.json();
                    const verifyResponseResult = await $0428691a48be56ba$var$authorize({
                        transactionToken: transactionToken
                    });
                    if (!verifyResponseResult.success) switch(verifyResponseResult.error){
                        case 'too_many_requests':
                            return {
                                success: false,
                                error: 'too_many_requests'
                            };
                        default:
                            throw new Error('error during verification of security key');
                    }
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'succeeded',
                        subject: $0428691a48be56ba$var$ANALYTIC_EVENT_SUBJECT_ID
                    });
                    return {
                        success: true,
                        data: verifyResponseResult.data
                    };
                }
            case 400:
                {
                    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(window.location.search);
                    const redirectUri = $0428691a48be56ba$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        pageId: pageId,
                        currentQueryParams: queryParams
                    });
                    return {
                        success: true,
                        data: {
                            redirectUri: redirectUri
                        }
                    };
                }
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error during verification of security key`);
    }
};
const $0428691a48be56ba$export$9b0f7f7d25e7c579 = (pageId, onSuccess, onError)=>{
    const isSupported = (0, $f8jwK.isWebAuthnSupported)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const [authenticating, setAuthenticating] = (0, $dNMDr.useState)(false);
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const onErrorWithTrackingAnalytics = (0, $dNMDr.useCallback)((error)=>{
        analyticsClient.trackingEvent({
            page: pageId,
            action: 'failed',
            subject: $0428691a48be56ba$var$ANALYTIC_EVENT_SUBJECT_ID,
            attributes: {
                reason: error
            }
        });
        onError(error);
    }, [
        analyticsClient,
        onError,
        pageId
    ]);
    const challengeSecurityKey = (0, $dNMDr.useCallback)(async ()=>{
        analyticsClient.trackingEvent({
            page: pageId,
            action: 'started',
            subject: $0428691a48be56ba$var$ANALYTIC_EVENT_SUBJECT_ID
        });
        if (!isSupported) return onErrorWithTrackingAnalytics((0, $f8jwK.WebAuthnAuthenticationErrorCode).WebAuthnNotSupported);
        const transactionToken = new URLSearchParams(window.location.search).get('transactionToken');
        if (!transactionToken) return onErrorWithTrackingAnalytics("transactionTokenNotFound");
        try {
            setAuthenticating(true);
            const securityKeyChallengeResponseResult = await $0428691a48be56ba$var$challenge({
                transactionToken: transactionToken
            });
            if (!securityKeyChallengeResponseResult.success) {
                setAuthenticating(false);
                switch(securityKeyChallengeResponseResult.error){
                    case 'too_many_requests':
                        return onErrorWithTrackingAnalytics("tooManyRequests");
                    default:
                        return onErrorWithTrackingAnalytics("challengeFailure");
                }
            }
            const { requestOptions: requestOptions, transactionToken: newTransactionToken } = securityKeyChallengeResponseResult.data;
            // This updates the search query params in the address bar, but does not trigger
            // a page reload due to the pathname remains unchanged
            // Setting this would ensure the user loads the page with the updated token should
            // they refresh (eg. F5) the page
            navigate({
                search: (0, $fcxz7.replaceQueryParam)('transactionToken', newTransactionToken)
            });
            const authenticatorChallengeResult = await $0428691a48be56ba$var$challengeWithAuthenticator(requestOptions);
            if (!authenticatorChallengeResult.success) {
                setAuthenticating(false);
                return onErrorWithTrackingAnalytics(authenticatorChallengeResult.error);
            }
            const securityKeyCredentialJson = authenticatorChallengeResult.data;
            const verifyResponseResult = await $0428691a48be56ba$var$verify({
                transactionToken: newTransactionToken,
                assertionJson: securityKeyCredentialJson,
                analyticsClient: analyticsClient,
                pageId: pageId
            });
            if (!verifyResponseResult.success) {
                setAuthenticating(false);
                switch(verifyResponseResult.error){
                    case 'too_many_requests':
                        return onErrorWithTrackingAnalytics("tooManyRequests");
                    default:
                        return onErrorWithTrackingAnalytics("challengeFailure");
                }
            }
            return onSuccess(verifyResponseResult.data);
        } catch (e) {
            setAuthenticating(false);
            return onErrorWithTrackingAnalytics("challengeFailure");
        }
    }, [
        isSupported,
        analyticsClient,
        onSuccess,
        pageId,
        onErrorWithTrackingAnalytics,
        navigate
    ]);
    return {
        challengeSecurityKey: challengeSecurityKey,
        authenticating: authenticating
    };
};
function $0428691a48be56ba$var$redirectToLoginErrorOn400IncorrectTokenResponse({ analyticsClient: analyticsClient, pageId: pageId, currentQueryParams: currentQueryParams }) {
    analyticsClient.trackingEvent({
        page: pageId,
        subject: $0428691a48be56ba$var$ANALYTIC_EVENT_SUBJECT_ID,
        action: 'failed',
        attributes: {
            reason: 'login_redirect_invalid_token'
        }
    });
    delete currentQueryParams.transactionToken;
    const currentQueryString = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(currentQueryParams);
    const extraParamsString = currentQueryString === '' ? '' : `&${currentQueryString}`;
    return new URL(`/login?prompt=true&errorCode=login.form.token.expired${extraParamsString}`, window.location.origin);
}

});



parcelRegister("7ozrG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b04b86160f763e4$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $9b04b86160f763e4$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    failedToUseKeyMessage: {
        id: 'mfa.challenge.securitykey.failedtousekey.label',
        defaultMessage: "We\u2019re not sure what went wrong. Try again. If this keeps happening, contact support."
    },
    securityKeyTooManyAttemptsMessage: {
        id: 'mfa.challenge.securitykey.toomanyattempts.label',
        defaultMessage: "You\u2019ve reached your rate limit. Try again in a few minutes."
    },
    webauthnNotSupportedMessage: {
        id: 'mfa.challenge.securitykey.not-supported.label',
        defaultMessage: "We\u2019re unable to verify your security key. Make sure your browser supports WebAuthn."
    },
    webAuthnMalformedConfiguration: {
        id: 'mfa.challenge.webauthn.malformed-configuration.label',
        defaultMessage: "We\u2019re unable to authenticate with your security key. Try again. If this keeps happening, contact support.",
        description: 'Error message displayed when security key challenge failed due to failure to initiate the security key challenge process due to invalid configurations passed to the WebAuthN API and authenticator.'
    },
    webAuthnAborted: {
        id: 'mfa.challenge.webauthn.aborted.label',
        defaultMessage: "We\u2019re unable to detect your authentication signal. Try again. If this keeps happening, contact support.",
        description: 'Error message displayed when security key challenge failed due to the WebAuthn authentication ceremony receiving an abort signal'
    },
    webAuthnAuthenticationIncomplete: {
        id: 'mfa.challenge.webauthn.authentication-incomplete.label',
        defaultMessage: 'You did not complete the authentication process. Try again.',
        description: 'Error message displayed when security key challenge failed due to failure to complete the process. This is commonly seen if the user cancel out of the authentication, or the process went timeout.'
    },
    webAuthnInvalidDomain: {
        id: 'mfa.challenge.webauthn.invalid-domain.label',
        defaultMessage: 'Your domain does not match the Atlassian domain.',
        description: 'Error message displayed when security key challenge failed due to the current domain the user is on is invalid'
    },
    webauthnAuthenticationFailed: {
        id: 'mfa.challenge.webauthn.authenticaton-failed.label',
        defaultMessage: "Your security key couldn\u2019t complete the authentication. Try again. If this keeps happening, contact support.",
        description: 'Error message displayed when security key challenge failed due to the authenticator failed to complete the authentication step for unidentifiable reasons'
    }
});

});

parcelRegister("iw8NJ", function(module, exports) {

$parcel$export(module.exports, "SecurityKey", function () { return $5586b839f0bd085a$export$9dccf97bc0beb20b; });

var $6CtE1 = parcelRequire("6CtE1");

var $fbSBq = parcelRequire("fbSBq");

var $arnOv = parcelRequire("arnOv");

var $j0VD5 = parcelRequire("j0VD5");
parcelRequire("dNMDr");

var $7DUKO = parcelRequire("7DUKO");
const $5586b839f0bd085a$var$baseSpacing = (0, $7DUKO.default)('space.100');
const $5586b839f0bd085a$var$DefaultSecurityKeyContainer = (0, $fbSBq.default).div`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($arnOv)))}) no-repeat center 0 / calc(${$5586b839f0bd085a$var$baseSpacing} * 14.5);
  min-width: 100%;
  margin-top: ${$5586b839f0bd085a$var$baseSpacing};
  padding-top: calc(${$5586b839f0bd085a$var$baseSpacing} * 18);

  box-sizing: border-box;

  ${(0, $j0VD5.media).handheld`
    background: 0;
    padding: 0;
  `}
`;
const $5586b839f0bd085a$export$9dccf97bc0beb20b = ({ children: children, id: id })=>{
    return /*#__PURE__*/ (0, $6CtE1.jsx)($5586b839f0bd085a$var$DefaultSecurityKeyContainer, {
        id: id,
        children: children
    });
};

});
parcelRegister("arnOv", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "lock-closed.186e8c46.svg";

});



parcelRegister("5Fj6z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ade56c49c7d384af$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $ade56c49c7d384af$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    mfTotpPrompt: {
        id: 'mf.totp.prompt',
        defaultMessage: 'Enter the code from your authenticator app.',
        description: 'Message shown on the 2SV challenge screen to prompt the user to enter the code from their authenticator app'
    },
    mfSmsPrompt: {
        id: 'mf.sms.prompt',
        defaultMessage: 'Enter the code you received by SMS.',
        description: 'Message shown on the 2SV challenge screen to prompt the user to enter the code sent to their SMS'
    },
    mfEmailPrompt: {
        id: 'mf.email.prompt',
        defaultMessage: 'Enter the code from your email.',
        description: 'Message shown on the 2SV challenge screen to prompt the user to enter the code sent to their email'
    }
});

});


parcelRegister("ln5Gj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e457629b807d1502$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $fbSBq = parcelRequire("fbSBq");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $79HVl = parcelRequire("79HVl");

var $2byD0 = parcelRequire("2byD0");

var $8dLb0 = parcelRequire("8dLb0");
const $e457629b807d1502$var$ErrorMessage = (0, $fbSBq.default).div`
  color: ${(0, $l4KzN).R500};
  margin-bottom: ${(0, $68HQw.gridSize)() * 2}px;
`;
const $e457629b807d1502$var$RecoveryEmailForm = ({ email: email, recoveryEmailError: recoveryEmailError, sendEmail: sendEmail })=>{
    const [loading, setLoading] = (0, $dNMDr.useState)(false);
    const sendRecoveryEmail = ()=>{
        setLoading(true);
        sendEmail();
    };
    (0, $dNMDr.useEffect)(()=>{
        if (recoveryEmailError) setLoading(false);
    }, [
        recoveryEmailError
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $8dLb0.SecurityWall), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "mf.recoveryemailform.desc",
                tagName: "p",
                defaultMessage: "We'll email you at {email} with instructions for how to recover access to your account.",
                values: {
                    email: /*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                        children: email
                    })
                }
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "mf.recoveryemailform.security.desc",
                tagName: "p",
                defaultMessage: "For security reasons, this process will take some time to complete, and you may be contacted by our Support team for verification."
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $79HVl.default), {
                children: [
                    recoveryEmailError && /*#__PURE__*/ (0, $6CtE1.jsx)($e457629b807d1502$var$RecoveryEmailErrorMessage, {
                        recoveryEmailError: recoveryEmailError
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                        id: "send-recovery-email-button",
                        appearance: "primary",
                        isFullWidth: true,
                        onClick: sendRecoveryEmail,
                        isDisabled: loading,
                        isLoading: loading,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "mf.recoveryemailform.sendemail",
                            defaultMessage: "Send recovery email"
                        })
                    })
                ]
            })
        ]
    });
};
const $e457629b807d1502$var$RecoveryEmailErrorMessage = ({ recoveryEmailError: recoveryEmailError })=>{
    if (!recoveryEmailError) return null;
    switch(recoveryEmailError){
        case 'alreadyRequested':
            return /*#__PURE__*/ (0, $6CtE1.jsx)($e457629b807d1502$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "mf.recoveryemailform.error.alreadyRequested",
                    defaultMessage: "You have already requested account recovery instructions. If the account exists, these instructions will be sent to your email address. Note that this may take some time to complete."
                })
            });
        case 'userIsManaged':
        case 'userNotFound':
            return /*#__PURE__*/ (0, $6CtE1.jsx)($e457629b807d1502$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "mf.recoveryemailform.error.genericExpected",
                    defaultMessage: "Your recovery request can't be processed. Please <support-link>contact support</support-link>.",
                    values: {
                        'support-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("a", {
                                href: 'https://www.atlassian.com/company/contact/general-inquiries',
                                children: chunks
                            })
                    }
                })
            });
        case 'unknown':
        default:
            return /*#__PURE__*/ (0, $6CtE1.jsx)($e457629b807d1502$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "mf.recoveryemailform.error.unknown",
                    defaultMessage: "Unexpected error happened. Please <support-link>contact support</support-link>.",
                    values: {
                        'support-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("a", {
                                href: 'https://www.atlassian.com/company/contact/general-inquiries',
                                children: chunks
                            })
                    }
                })
            });
    }
};
var $e457629b807d1502$export$2e2bcd8739ae039 = $e457629b807d1502$var$RecoveryEmailForm;

});

parcelRegister("iZRuI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0de86e8c85fdd63f$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $fbSBq = parcelRequire("fbSBq");

var $bBDZx = parcelRequire("bBDZx");

var $68HQw = parcelRequire("68HQw");

var $7DUKO = parcelRequire("7DUKO");

var $4NPio = parcelRequire("4NPio");
const $0de86e8c85fdd63f$var$EmailSentImg = (0, $fbSBq.default).img`
  height: ${(0, $68HQw.gridSize)() * 16}px;
  display: block;
  margin: ${(0, $68HQw.gridSize)()}px auto ${(0, $68HQw.gridSize)() * 2}px;
`;
const $0de86e8c85fdd63f$var$Email = (0, $fbSBq.default).p`
  font: ${(0, $7DUKO.default)('font.heading.small')};
  margin-top: ${(0, $68HQw.gridSize)()}px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $0de86e8c85fdd63f$var$TextWrapper = (0, $fbSBq.default).div`
  p {
    margin: 0;
  }
`;
const $0de86e8c85fdd63f$var$RecoveryEmailSent = ({ email: email, emailSentPageId: emailSentPageId, expirePageId: expirePageId, isExpired: isExpired })=>{
    (0, $4NPio.usePageViewedEvent)(isExpired ? expirePageId : emailSentPageId);
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)($0de86e8c85fdd63f$var$EmailSentImg, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($bBDZx)))
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)($0de86e8c85fdd63f$var$TextWrapper, {
                children: [
                    isExpired && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "mf.recoveryemailsent.expired",
                        tagName: "p",
                        defaultMessage: "Your recovery link expired."
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "mf.recoveryemailsent",
                        tagName: "p",
                        defaultMessage: "We've emailed instructions to:"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)($0de86e8c85fdd63f$var$Email, {
                children: email
            })
        ]
    });
};
var $0de86e8c85fdd63f$export$2e2bcd8739ae039 = $0de86e8c85fdd63f$var$RecoveryEmailSent;

});
parcelRegister("bBDZx", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "check-your-email.078c11ba.svg";

});


parcelRegister("2uMua", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53eb33d48c638f6a$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $fbSBq = parcelRequire("fbSBq");

var $kvy9X = parcelRequire("kvy9X");

var $cr5CS = parcelRequire("cr5CS");

var $68HQw = parcelRequire("68HQw");

var $6i4Wm = parcelRequire("6i4Wm");

var $2byD0 = parcelRequire("2byD0");

var $goICH = parcelRequire("goICH");

var $8dLb0 = parcelRequire("8dLb0");

var $8LYpt = parcelRequire("8LYpt");
parcelRequire("jM5Ly");
var $hMPjy = parcelRequire("hMPjy");
const $53eb33d48c638f6a$var$ButtonContainer = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $53eb33d48c638f6a$var$MessageWrapper = (0, $fbSBq.default).div`
  padding-bottom: ${(0, $68HQw.gridSize)() * 1.5}px;
`;
const $53eb33d48c638f6a$var$RecoveryCodeField = ({ disabled: disabled, fieldErrorFromParent: fieldErrorFromParent, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const fieldTextRef = (0, $dNMDr.useRef)(null);
    const [fieldValue, setFieldValue] = (0, $dNMDr.useState)('');
    const [fieldError, setFieldError] = (0, $dNMDr.useState)(fieldErrorFromParent);
    const previousFieldValue = (0, $hMPjy.usePrevious)(fieldValue);
    const previousFieldErrorFromParent = (0, $hMPjy.usePrevious)(fieldErrorFromParent);
    const handlePaste = (e)=>{
        const target = e.target;
        const selectionStart = target.selectionStart || 0;
        const selectionEnd = target.selectionEnd || target.value.length;
        const start = target.value.substr(0, selectionStart);
        const middle = (e.clipboardData || window.clipboardData).getData('text/plain').replace(/\W/g, '').substr(0, target.maxLength - target.value.length - selectionStart + selectionEnd);
        const end = target.value.substr(selectionEnd);
        //timeout to allow input update UI
        setTimeout(()=>setFieldValue(start + middle + end));
    };
    const handleChange = (e)=>{
        setFieldValue(e.currentTarget.value.replace(/\W/g, '').toUpperCase());
        setFieldError(null);
    };
    const handleInvalid = (e)=>{
        e.preventDefault();
        setFieldError({
            errorCode: 'invalid_otp_pattern'
        });
    };
    (0, $dNMDr.useEffect)(()=>{
        const input = fieldTextRef.current;
        if (input) {
            input.addEventListener('invalid', handleInvalid);
            input.addEventListener('paste', handlePaste);
        }
        return ()=>{
            if (input) {
                input.removeEventListener('invalid', handleInvalid);
                input.removeEventListener('paste', handlePaste);
            }
        };
    }, []);
    (0, $dNMDr.useEffect)(()=>{
        if (!previousFieldErrorFromParent && fieldErrorFromParent) {
            setFieldError(fieldErrorFromParent);
            fieldTextRef.current && fieldTextRef.current.select();
        }
    }, [
        fieldErrorFromParent,
        previousFieldErrorFromParent
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (fieldValue !== previousFieldValue) onChange && onChange({
            target: fieldTextRef.current
        });
    }, [
        fieldValue,
        previousFieldValue,
        onChange
    ]);
    const errorContent = (error)=>{
        const errorMessages = {
            invalid_recovery_code: formatMessage((0, $goICH.default).errorsInvalidRecoverCode),
            invalid_recovery_code_format: formatMessage((0, $goICH.default).errorsInvalidRecoveryCodeFormat),
            field_required: formatMessage((0, $goICH.default).errorsNoRecoveryCode),
            invalid_token: /*#__PURE__*/ (0, $6CtE1.jsxs)("form", {
                onSubmit: ()=>window.location.reload(),
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "mf.mfform.errors.invalid_token",
                        defaultMessage: "Your session has expired. Please refresh the page and try again."
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)($53eb33d48c638f6a$var$ButtonContainer, {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                            type: "submit",
                            isFullWidth: true,
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                id: "common.refresh",
                                defaultMessage: "Refresh"
                            })
                        })
                    })
                ]
            }),
            invalid_otp_pattern: formatMessage((0, $goICH.default).errorsInvalidOtpPattern)
        };
        return error && // @ts-ignore genuine TypeScript screw up, need to turn RecoveryCodeFieldError into a genuine discriminated union
        (errorMessages[error.errorCode] || error.message && typeof error.message === 'string');
    };
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6i4Wm.default), {
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kvy9X.default), {
            name: "recoveryCode",
            type: "text",
            label: formatMessage((0, $goICH.default).mfRecoveryFormPlaceholder),
            autoFocus: true,
            onChange: handleChange,
            isInvalid: !!fieldError,
            invalidMessage: !disabled && fieldError && errorContent(fieldError),
            value: fieldValue,
            isDisabled: disabled,
            pattern: "\\w{24}",
            maxLength: 24,
            isRequired: true,
            ref: fieldTextRef
        })
    });
};
const $53eb33d48c638f6a$var$RecoveryForm = ({ isLoading: isLoading, recoverAccount: recoverAccount, multifactorMethod: multifactorMethod, recoveryError: recoveryError })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const handleInputChange = (e)=>{
        const target = e.target;
        if (target && target.value.length === target.maxLength) recoverAccount(target.value);
    };
    const handleFormSubmit = (e)=>{
        e.preventDefault();
        // @ts-ignore check that recoveryCode is actually on the target
        recoverAccount(e.target.recoveryCode.value);
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $8dLb0.SecurityWall), {
        id: "two-step-verification-recovery-form",
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $8LYpt.InputMessage), {
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)($53eb33d48c638f6a$var$MessageWrapper, {
                        children: multifactorMethod === 'security-key' ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "mf.recoveryform.usekey.securitykey",
                            defaultMessage: "If you can't use your security key, log in with your emergency recovery key."
                        }) : /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "mf.recoveryform.usekey",
                            defaultMessage: "If you can't use your phone, log in with your emergency recovery key."
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8LYpt.InlineMessageContainer), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cr5CS.default), {
                            appearance: "info",
                            placement: "bottom-end",
                            iconLabel: formatMessage({
                                id: 'mf.recoveryform.help.inline-message.button.label',
                                defaultMessage: 'More info',
                                description: 'Icon button label for the inline message'
                            }),
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8LYpt.StyledMessage), {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    id: "mf.recoveryform.help",
                                    defaultMessage: "We asked you to save your emergency recovery key when you enabled two-step verification. You might have saved it in a local file or printed it out."
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)("form", {
                autoComplete: "off",
                onSubmit: handleFormSubmit,
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)($53eb33d48c638f6a$var$RecoveryCodeField, {
                        disabled: isLoading,
                        fieldErrorFromParent: recoveryError,
                        onChange: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)($53eb33d48c638f6a$var$ButtonContainer, {
                        id: "two-step-verification-recovery-submit",
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                            appearance: "primary",
                            type: "submit",
                            isFullWidth: true,
                            isLoading: isLoading,
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                id: "common.login",
                                defaultMessage: "Log in"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $53eb33d48c638f6a$export$2e2bcd8739ae039 = $53eb33d48c638f6a$var$RecoveryForm;

});
parcelRegister("6i4Wm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $714a2eac6558926d$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");
const $714a2eac6558926d$var$FieldGroupStyled = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-top, opacity, transform;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;

  /* Offset @atlaskit/form/Field margin-top */
  &:first-of-type {
    margin-top: ${-(0, $68HQw.gridSize)()}px;
  }

  &.hidden {
    height: 0;
    margin-top: 0;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    overflow: hidden;
  }
`;
function $714a2eac6558926d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $6CtE1.jsx)($714a2eac6558926d$var$FieldGroupStyled, {
        ...props,
        className: `${props.className ? props.className : ''} ${props.isHidden ? 'hidden' : ''}`
    });
}

});

parcelRegister("goICH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $367e379cca823170$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $367e379cca823170$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    mfRecoveryFormPlaceholder: {
        id: 'mf.recoveryform.placeholder',
        defaultMessage: '24-character emergency recovery key',
        description: ''
    },
    errorsInvalidRecoverCode: {
        id: 'mf.recoveryform.errors.invalid_recovery_code',
        defaultMessage: 'You entered an incorrect emergency recovery key.'
    },
    errorsInvalidRecoveryCodeFormat: {
        id: 'mf.recoveryform.errors.invalid_recovery_code_format',
        defaultMessage: 'You entered an invalid emergency recovery key.'
    },
    errorsNoRecoveryCode: {
        id: 'mf.recoveryform.errors.no_recovery_code',
        defaultMessage: 'Please enter your emergency recovery key.'
    },
    errorsInvalidOtpPattern: {
        id: 'mf.recoveryform.errors.invalid_otp_pattern',
        defaultMessage: 'Your emergency recovery key needs to be 24 characters.'
    }
});

});


parcelRegister("duAyH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5508de362cc00a8$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $fbSBq = parcelRequire("fbSBq");

var $8Govx = parcelRequire("8Govx");

var $cTzf6 = parcelRequire("cTzf6");

var $a6oyj = parcelRequire("a6oyj");

var $iII4N = parcelRequire("iII4N");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $7DUKO = parcelRequire("7DUKO");

var $79HVl = parcelRequire("79HVl");

var $d7npf = parcelRequire("d7npf");

var $2byD0 = parcelRequire("2byD0");

var $l3eIX = parcelRequire("l3eIX");

var $j0VD5 = parcelRequire("j0VD5");

var $7lC8o = parcelRequire("7lC8o");

var $ydRrs = parcelRequire("ydRrs");

var $kmdKm = parcelRequire("kmdKm");
var $57txs = parcelRequire("57txs");
var $eEp70 = parcelRequire("eEp70");

var $5g8os = parcelRequire("5g8os");

var $aMBBA = parcelRequire("aMBBA");
const $b5508de362cc00a8$var$imageWidth = 359;
const $b5508de362cc00a8$var$Container = (0, $fbSBq.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: ${(0, $68HQw.gridSize)() * 82}px;
  min-height: ${(0, $68HQw.gridSize)() * 80}px;
  height: calc(100vh - ${(0, $68HQw.gridSize)()}px);
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($l3eIX)))}) bottom center/ ${$b5508de362cc00a8$var$imageWidth}px no-repeat;

  ${(0, $j0VD5.media).handheld`
    width: ${(0, $68HQw.gridSize)() * 44}px;
    background: none;
    padding-bottom: 0;
  `}
`;
const $b5508de362cc00a8$var$Subcontainer = (0, $fbSBq.default).div`
  display: flex;
  flex-direction: column;
  width: ${(0, $68HQw.gridSize)() * 52}px;

  ${(0, $j0VD5.media).handheld`
    width: ${(0, $68HQw.gridSize)() * 44}px;
  `}
`;
const $b5508de362cc00a8$var$Heading = (0, $fbSBq.default).h2`
  display: flex;
  justify-content: center;
  margin-top: ${(0, $68HQw.gridSize)() * 5}px !important;

  ${(0, $j0VD5.media).handheld`
    display: none;
  `}
`;
const $b5508de362cc00a8$var$Subheading = (0, $fbSBq.default).h3`
  display: flex;
  align-items: center;
  margin-top: ${(0, $68HQw.gridSize)() * 3.5}px !important;

  &::before {
    counter-increment: counter;
    content: counter(counter) '. ';
    margin-right: ${(0, $68HQw.gridSize)() * 0.5}px;
  }
`;
const $b5508de362cc00a8$var$DesktopSubheading = (0, $fbSBq.default)($b5508de362cc00a8$var$Subheading)`
  ${(0, $j0VD5.media).handheld`
    display: none;
  `}
`;
const $b5508de362cc00a8$var$MobileSubheading = (0, $fbSBq.default)($b5508de362cc00a8$var$Subheading)`
  display: none;
  justify-content: center;
  font-size: 16px;

  ${(0, $j0VD5.media).handheld`
    display: flex;
  `}

  &::before {
    content: '';
    margin: 0;
  }
`;
const $b5508de362cc00a8$var$RecoveryCode = (0, $fbSBq.default).div`
  display: flex;
  justify-content: space-between;
  font: ${(0, $7DUKO.default)('font.code')};
  font-size: 24px;
  font-weight: bold;
  color: ${(0, $l4KzN).N300};
  margin-top: ${(0, $68HQw.gridSize)() * 2}px;

  ${(0, $j0VD5.media).handheld`
    display: none;
  `}
`;
const $b5508de362cc00a8$var$MobileRecoveryCode = (0, $fbSBq.default)((0, $d7npf.default))`
  display: none;
  text-align: center;
  font: ${(0, $7DUKO.default)('font.code')};
  font-size: 20px;
  color: ${(0, $l4KzN).N300};
  margin-top: ${(0, $68HQw.gridSize)() * 2}px;

  ${(0, $j0VD5.media).handheld`
    display: block;
  `}
`;
const $b5508de362cc00a8$var$DropdownMenuContainer = (0, $fbSBq.default).div`
  display: flex;
  justify-content: flex-end;

  ${(0, $j0VD5.media).handheld`
    display: none;
  `}
`;
const $b5508de362cc00a8$var$StyledButton = (0, $fbSBq.default)((0, $cTzf6.default))`
  font-size: 14px !important;
  margin-left: auto !important;
  padding: 0 16px !important;
`;
const $b5508de362cc00a8$var$MobileButtonContainer = (0, $fbSBq.default)((0, $79HVl.default))`
  display: none;

  ${(0, $j0VD5.media).handheld`
    display: block;
  `}
`;
const $b5508de362cc00a8$var$DesktopParagraph = (0, $fbSBq.default).p`
  ${(0, $j0VD5.media).handheld`
    display: none;
  `}
`;
const $b5508de362cc00a8$var$MobileParagraph = (0, $fbSBq.default).p`
  display: none;

  ${(0, $j0VD5.media).handheld`
    display: block;
  `}
`;
const $b5508de362cc00a8$var$RecoveryPage = ({ isEmbedded: isEmbedded, recoveryCode: recoveryCode, onComplete: onComplete })=>{
    const [newCodeSaved, setNewCodeSaved] = (0, $dNMDr.useState)(false);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    (0, $dNMDr.useEffect)(()=>{
        window.onbeforeunload = null;
    }, []);
    const onClickOnRecovery = (0, $dNMDr.useCallback)(()=>{
        const success = (0, (/*@__PURE__*/$parcel$interopDefault($iII4N)))(recoveryCode);
        if (success) {
            const flag = {
                type: 'success',
                title: (0, $ydRrs.default).mfRecoveryCopiedTitle,
                description: (0, $ydRrs.default).mfRecoveryCopiedDesc
            };
            dispatch((0, $7lC8o.addFlag)(flag.type, flag.title, flag.description));
            setNewCodeSaved(true);
        }
    }, [
        dispatch,
        recoveryCode
    ]);
    const onRecoveryPrint = (0, $dNMDr.useCallback)(()=>{
        // Invocation of this method will freeze the page in React 16 in development mode.
        // It does not affect production mode. The development mode bug is fixed in React 17:
        // https://github.com/facebook/react/issues/16734
        setTimeout(window.print);
        setNewCodeSaved(true);
    }, []);
    const onRecoverySkip = (0, $dNMDr.useCallback)(()=>{
        setNewCodeSaved(true);
    }, []);
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $a6oyj.default), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8Govx.Global), {
                styles: (0, $8Govx.css)`
          body {
            counter-reset: counter;
          }
        `
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)($b5508de362cc00a8$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)($b5508de362cc00a8$var$Heading, {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "mf.recovery.heading",
                            defaultMessage: "We created a new emergency recovery key for you"
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsxs)($b5508de362cc00a8$var$Subcontainer, {
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)($b5508de362cc00a8$var$DesktopSubheading, {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    id: "mf.recovery.savekey",
                                    defaultMessage: "Save this emergency recovery key"
                                })
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)($b5508de362cc00a8$var$MobileSubheading, {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    id: "mf.recovery.savekey.mobile",
                                    defaultMessage: "Save recovery key"
                                })
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)($b5508de362cc00a8$var$DesktopParagraph, {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    id: "mf.recovery.savekey.desc",
                                    defaultMessage: "If you lose access to your phone, you won't be able to log in to your account without this key. Print, copy or write down this key without letting anyone see it."
                                })
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)($b5508de362cc00a8$var$MobileParagraph, {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    id: "mf.recovery.savekey.desc.mobile",
                                    defaultMessage: "If you lose access to your phone, you won't be able to log in to your account without the key. Save this key without letting anyone see it."
                                })
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)($b5508de362cc00a8$var$RecoveryCode, {
                                id: "recovery-code",
                                children: (recoveryCode.match(/.{4}/g) || []).map((item, index)=>/*#__PURE__*/ (0, $6CtE1.jsx)("span", {
                                        children: item
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)("input", {
                                id: "recovery-code-assistive",
                                className: "assistive",
                                value: recoveryCode,
                                readOnly: true
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)($b5508de362cc00a8$var$MobileRecoveryCode, {
                                value: (recoveryCode.match(/.{4}/g) || []).join(' ')
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)($b5508de362cc00a8$var$DropdownMenuContainer, {
                                id: "mf-save-options",
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kmdKm.default), {
                                    trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $cTzf6.default), {
                                            ...props,
                                            ref: triggerRef,
                                            iconAfter: /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5g8os))), {
                                                label: ""
                                            }),
                                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                                id: "mf.recovery.saveoptions",
                                                defaultMessage: "Save options"
                                            })
                                        }),
                                    children: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $eEp70.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $57txs.default), {
                                                onClick: onClickOnRecovery,
                                                children: /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                                                    id: "mf-copy-key",
                                                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                                        id: "mf.recovery.copy",
                                                        defaultMessage: "Copy to clipboard"
                                                    })
                                                })
                                            }),
                                            !isEmbedded && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $57txs.default), {
                                                onClick: onRecoveryPrint,
                                                children: /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                                                    id: "mf-print-key",
                                                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                                        id: "mf.recovery.print",
                                                        defaultMessage: "Print"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $57txs.default), {
                                                onClick: onRecoverySkip,
                                                children: /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                                                    id: "mf-wrote-key",
                                                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                                        id: "mf.recovery.skip",
                                                        defaultMessage: "I wrote it down"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsxs)($b5508de362cc00a8$var$DesktopSubheading, {
                                children: [
                                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                        id: "mf.recovery.seriously",
                                        defaultMessage: "Seriously, save this key!"
                                    }),
                                    /*#__PURE__*/ (0, $6CtE1.jsx)($b5508de362cc00a8$var$StyledButton, {
                                        id: "two-step-verification-save-recovery-code-continue",
                                        isDisabled: !newCodeSaved,
                                        onClick: onComplete,
                                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                            id: "mf.recovery.saved",
                                            defaultMessage: "Saved, let's go"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)($b5508de362cc00a8$var$MobileButtonContainer, {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                                    appearance: "primary",
                                    isFullWidth: true,
                                    onClick: onComplete,
                                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                        id: "mf.recovery.saved",
                                        defaultMessage: "Saved, let's go"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $b5508de362cc00a8$export$2e2bcd8739ae039 = $b5508de362cc00a8$var$RecoveryPage;

});
parcelRegister("iII4N", function(module, exports) {
"use strict";

var $giJYA = parcelRequire("giJYA");
var $da0e86ae47e0a7d0$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $da0e86ae47e0a7d0$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $da0e86ae47e0a7d0$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $da0e86ae47e0a7d0$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $giJYA();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $da0e86ae47e0a7d0$var$clipboardToIE11Formatting[options.format] || $da0e86ae47e0a7d0$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $da0e86ae47e0a7d0$var$format("message" in options ? options.message : $da0e86ae47e0a7d0$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = $da0e86ae47e0a7d0$var$copy;

});
parcelRegister("giJYA", function(module, exports) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

});


parcelRegister("d7npf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a41bbe619386dd8f$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");
const $a41bbe619386dd8f$var$StyledInput = (0, $fbSBq.default).input`
  border: 0;
  padding: 0;
  font-size: 16px;
  width: 100%;
`;
const $a41bbe619386dd8f$var$handleClick = (e)=>{
    e.target.select(); // HTMLInputElement.setSelectionRange() doesn't work in some desktop browsers
    e.target.setSelectionRange(0, e.target.value.length); // HTMLInputElement.select() doesn't work on iOS
};
var $a41bbe619386dd8f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $6CtE1.jsx)($a41bbe619386dd8f$var$StyledInput, {
        ...props,
        readOnly: true,
        onClick: $a41bbe619386dd8f$var$handleClick
    });

});

parcelRegister("l3eIX", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "save-recovery-key.36d66881.svg";

});

parcelRegister("ydRrs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff3bbbfe3a49539f$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $ff3bbbfe3a49539f$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    // Flags
    mfRecoveryCopiedTitle: {
        id: 'mf.recovery.copied',
        defaultMessage: 'Emergency recovery key is in your clipboard',
        description: ''
    },
    mfRecoveryCopiedDesc: {
        id: 'mf.recovery.copied.desc',
        defaultMessage: 'Paste it into a text file and save.',
        description: ''
    }
});

});

parcelRegister("kmdKm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed20868b4d048d7e$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $91FVG = parcelRequire("91FVG");

var $bM2vx = parcelRequire("bM2vx");

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $40QgJ = parcelRequire("40QgJ");

var $e8kIe = parcelRequire("e8kIe");

var $7AbKs = parcelRequire("7AbKs");

var $gTgRL = parcelRequire("gTgRL");

var $c3KQG = parcelRequire("c3KQG");

var $fZFhP = parcelRequire("fZFhP");

var $bBTcT = parcelRequire("bBTcT");

var $jJCD4 = parcelRequire("jJCD4");

var $i2T7w = parcelRequire("i2T7w");

var $gQLDR = parcelRequire("gQLDR");

var $2NKAr = parcelRequire("2NKAr");

var $gWqO2 = parcelRequire("gWqO2");

var $1K8XT = parcelRequire("1K8XT");

var $lWJik = parcelRequire("lWJik");

var $h9OvM = parcelRequire("h9OvM");

var $jtqDq = parcelRequire("jtqDq");

var $lB2kk = parcelRequire("lB2kk");
var $ed20868b4d048d7e$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $ed20868b4d048d7e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ed20868b4d048d7e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ed20868b4d048d7e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ed20868b4d048d7e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ed20868b4d048d7e$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $ed20868b4d048d7e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $ed20868b4d048d7e$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($ed20868b4d048d7e$var$opposites[crossAxis]),
            "".concat($ed20868b4d048d7e$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($ed20868b4d048d7e$var$opposites[mainAxis]),
            "".concat($ed20868b4d048d7e$var$opposites[mainAxis], "-").concat($ed20868b4d048d7e$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($ed20868b4d048d7e$var$opposites[mainAxis]),
        "".concat($ed20868b4d048d7e$var$opposites[mainAxis], "-start"),
        "".concat($ed20868b4d048d7e$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
function $ed20868b4d048d7e$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $ed20868b4d048d7e$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $c3KQG.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $gWqO2.layers).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy, menuLabel = _ref.menuLabel, _ref$shouldPreventEsc = _ref.shouldPreventEscapePropagation, shouldPreventEscapePropagation = _ref$shouldPreventEsc === void 0 ? false : _ref$shouldPreventEsc;
    var _useControlledState = (0, $fZFhP.default)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $dNMDr.useRef)(null);
    var _useState = (0, $dNMDr.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $lB2kk.default)();
    var itemRef = (0, $jtqDq.default)();
    var _useLayering = (0, $i2T7w.useLayering)(), currentLevel = _useLayering.currentLevel;
    var fallbackPlacements = (0, $dNMDr.useMemo)(function() {
        return $ed20868b4d048d7e$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $dNMDr.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $dNMDr.useCallback)(function(event, currentLevel) {
        var _event$target$closest, _event$target;
        var isTabLeftOrEscapeKey = $ed20868b4d048d7e$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $7AbKs.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $ed20868b4d048d7e$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $7AbKs.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $lB2kk.PREFIX), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($ed20868b4d048d7e$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $7AbKs.KEY_LEFT))) requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            var isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            var shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(function() {
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    var _useFocus = (0, $bBTcT.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $dNMDr.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $c3KQG.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $c3KQG.default;
        return (0, $40QgJ.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $lB2kk.PREFIX), "] [aria-haspopup]"));
                if (e.key === (0, $7AbKs.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $7AbKs.KEY_SPACE) || e.key === (0, $7AbKs.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $7AbKs.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h9OvM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $2NKAr.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 && (0, $gQLDR.fg)('platform-dst-nested-dropdown-menu-role') ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref2, $ed20868b4d048d7e$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($ed20868b4d048d7e$var$_objectSpread($ed20868b4d048d7e$var$_objectSpread($ed20868b4d048d7e$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $gTgRL.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $e8kIe.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, bindFocus, {
                ref: (0, $gTgRL.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: function iconAfter(iconProps) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jJCD4))), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, iconProps, {
                        size: "small"
                    }));
                },
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label,
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1K8XT.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $lWJik.default), {
                spacing: spacing,
                maxHeight: $ed20868b4d048d7e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper"),
                menuLabel: menuLabel
            }, children));
        }
    })));
};
var $ed20868b4d048d7e$export$2e2bcd8739ae039 = $ed20868b4d048d7e$var$DropdownMenu;

});
parcelRegister("e8kIe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4a1e11405e8030d$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $dqFFZ = parcelRequire("dqFFZ");

var $cb5Ng = parcelRequire("cb5Ng");

var $hK1dY = parcelRequire("hK1dY");
var $a4a1e11405e8030d$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $a4a1e11405e8030d$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $a4a1e11405e8030d$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $a4a1e11405e8030d$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(unsafeRest, $a4a1e11405e8030d$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dqFFZ.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $cb5Ng.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $hK1dY.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $cb5Ng.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $cb5Ng.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $hK1dY.default), {
        icon: iconAfter
    })));
}));
$a4a1e11405e8030d$var$Button.displayName = 'Button';
var $a4a1e11405e8030d$export$2e2bcd8739ae039 = $a4a1e11405e8030d$var$Button;

});

parcelRegister("fZFhP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba4c9426cbbd1356$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");
function $ba4c9426cbbd1356$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $dNMDr.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $dNMDr.useRef)(isControlled);
    (0, $dNMDr.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $dNMDr.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("bBTcT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $873df95d0c0f5403$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");
function $873df95d0c0f5403$export$2e2bcd8739ae039() {
    var _useState = (0, $dNMDr.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $dNMDr.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $dNMDr.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("1K8XT", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", function () { return $14510a9c4f545daf$export$f18c1d4fc7326096; });
$parcel$export(module.exports, "default", function () { return $14510a9c4f545daf$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $40QgJ = parcelRequire("40QgJ");

var $c3KQG = parcelRequire("c3KQG");

var $i2T7w = parcelRequire("i2T7w");

var $2BSxq = parcelRequire("2BSxq");
var $14510a9c4f545daf$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $dNMDr.createContext)({
    menuItemRefs: [],
    registerRef: (0, $c3KQG.default)
});
/**
 * Focus manager logic.
 */ var $14510a9c4f545daf$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $dNMDr.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $dNMDr.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $dNMDr.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $dNMDr.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $i2T7w.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    var isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $dNMDr.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $dNMDr.useEffect)(function() {
        return (0, $40QgJ.bind)(window, {
            type: 'keydown',
            listener: (0, $2BSxq.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        });
    }, [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($14510a9c4f545daf$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $14510a9c4f545daf$export$2e2bcd8739ae039 = $14510a9c4f545daf$var$FocusManager;

});
parcelRegister("2BSxq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e695798678befe9$export$2e2bcd8739ae039; });

var $91FVG = parcelRequire("91FVG");

var $7AbKs = parcelRequire("7AbKs");

var $gQLDR = parcelRequire("gQLDR");

var $lB2kk = parcelRequire("lB2kk");
var $1e695798678befe9$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, (0, $7AbKs.KEY_DOWN), 'next'), (0, $7AbKs.KEY_UP), 'prev'), (0, $7AbKs.KEY_HOME), 'first'), (0, $7AbKs.KEY_END), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $1e695798678befe9$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $1e695798678befe9$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $1e695798678befe9$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    var isNestedMenu = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $gQLDR.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $lB2kk.PREFIX), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $7AbKs.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $7AbKs.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $7AbKs.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $7AbKs.KEY_RIGHT)) {
            var activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        var action = $1e695798678befe9$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var nextFocusableElement = $1e695798678befe9$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var prevFocusableElement = $1e695798678befe9$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var firstFocusableElement = $1e695798678befe9$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var lastFocusableElement = $1e695798678befe9$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("lB2kk", function(module, exports) {

$parcel$export(module.exports, "PREFIX", function () { return $fb8edbb8231fe27f$export$8a682ae47622dbb9; });
$parcel$export(module.exports, "default", function () { return $fb8edbb8231fe27f$export$2e2bcd8739ae039; });

var $hGahQ = parcelRequire("hGahQ");
var $fb8edbb8231fe27f$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $fb8edbb8231fe27f$export$2e2bcd8739ae039() {
    var id = (0, $hGahQ.useId)();
    return "".concat($fb8edbb8231fe27f$export$8a682ae47622dbb9).concat(id);
}

});



parcelRegister("lWJik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffa2265224db848b$export$2e2bcd8739ae039; });
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $dNMDr = parcelRequire("dNMDr");


var $8witO = parcelRequire("8witO");

var $gQLDR = parcelRequire("gQLDR");

var $l69Tm = parcelRequire("l69Tm");

var $3Wc5s = parcelRequire("3Wc5s");

var $9yvrH = parcelRequire("9yvrH");

var $bJhf3 = parcelRequire("bJhf3");

var $1K8XT = parcelRequire("1K8XT");
var $ffa2265224db848b$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
var $ffa2265224db848b$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return /*#__PURE__*/ $dNMDr.createElement((0, $l69Tm.default), {
        xcss: $ffa2265224db848b$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $dNMDr.createElement((0, $3Wc5s.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $ffa2265224db848b$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus, menuLabel = _ref2.menuLabel;
    var _useContext = (0, $dNMDr.useContext)((0, $1K8XT.FocusManagerContext)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $9yvrH.default)(menuItem) || (0, $bJhf3.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $dNMDr.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $dNMDr.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (((0, $gQLDR.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $dNMDr.createElement((0, $8witO.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group"),
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $dNMDr.createElement($ffa2265224db848b$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $ffa2265224db848b$export$2e2bcd8739ae039 = $ffa2265224db848b$var$MenuWrapper;

});
parcelRegister("8witO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $633fa59617c820ad$export$2e2bcd8739ae039; });
/* menu-group.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $gFLow = parcelRequire("gFLow");
var $633fa59617c820ad$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "menuLabel",
    "className"
];
var $633fa59617c820ad$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $633fa59617c820ad$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, menuLabel = _ref.menuLabel, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $633fa59617c820ad$var$_excluded);
    return /*#__PURE__*/ $dNMDr.createElement((0, $gFLow.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ $dNMDr.createElement((0, $gFLow.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ $dNMDr.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $affTb.default)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel
    }, rest))));
};
var $633fa59617c820ad$export$2e2bcd8739ae039 = $633fa59617c820ad$var$MenuGroup;

});
parcelRegister("gFLow", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", function () { return $c2353d38d609964a$export$443076ec7ebce042; });
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $c2353d38d609964a$export$9ca534b70725964d; });

var $dNMDr = parcelRequire("dNMDr");
var $c2353d38d609964a$export$443076ec7ebce042 = /*#__PURE__*/ (0, $dNMDr.createContext)('cozy');
var $c2353d38d609964a$export$9ca534b70725964d = /*#__PURE__*/ (0, $dNMDr.createContext)('border');

});


parcelRegister("9yvrH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f4fae8232793d6e$export$2e2bcd8739ae039; });
function $6f4fae8232793d6e$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("bJhf3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88a14586a08c526b$export$2e2bcd8739ae039; });
function $88a14586a08c526b$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("h9OvM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7da7576a068206a$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $c3KQG = parcelRequire("c3KQG");
var $c7da7576a068206a$export$756f795847463ebd = /*#__PURE__*/ (0, $dNMDr.createContext)({
    setItemState: (0, $c3KQG.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $c3KQG.default),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $c7da7576a068206a$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $dNMDr.useRef)({});
    var context = (0, $dNMDr.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement($c7da7576a068206a$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $c7da7576a068206a$export$2e2bcd8739ae039 = $c7da7576a068206a$var$SelectionStore;

});

parcelRegister("jtqDq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2d562e9c285deef$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $gQLDR = parcelRequire("gQLDR");

var $1K8XT = parcelRequire("1K8XT");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $e2d562e9c285deef$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $dNMDr.useContext)((0, $1K8XT.FocusManagerContext)), registerRef = _useContext.registerRef;
    var itemRef = (0, $dNMDr.useRef)(null);
    (0, $dNMDr.useEffect)(function() {
        if (hasPopup && (0, $gQLDR.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $e2d562e9c285deef$export$2e2bcd8739ae039 = $e2d562e9c285deef$var$useRegisterItemWithFocusManager;

});


parcelRegister("57txs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ba484f85262dc63$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $gTgRL = parcelRequire("gTgRL");

var $8TEKm = parcelRequire("8TEKm");

var $eeY6y = parcelRequire("eeY6y");

var $3n7uR = parcelRequire("3n7uR");

var $jtqDq = parcelRequire("jtqDq");
var $3ba484f85262dc63$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName",
    "role"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $3ba484f85262dc63$var$DropdownMenuItem = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, role = _ref.role, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $3ba484f85262dc63$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, $jtqDq.default)(!!rest['aria-haspopup']);
    var handleItemClick = (0, $dNMDr.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $eeY6y.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $gTgRL.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3n7uR.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $gTgRL.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $8TEKm.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $gTgRL.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
});
var $3ba484f85262dc63$export$2e2bcd8739ae039 = $3ba484f85262dc63$var$DropdownMenuItem;

});
parcelRegister("8TEKm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a311429c5037f7$export$2e2bcd8739ae039; });
/* button-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");


var $hMip0 = parcelRequire("hMip0");

var $gKhoX = parcelRequire("gKhoX");
var $67a311429c5037f7$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $67a311429c5037f7$var$ButtonItem = /*#__PURE__*/ (0, $dNMDr.memo)(/*#__PURE__*/ (0, $dNMDr.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(props, $67a311429c5037f7$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $dNMDr.useContext)((0, $hMip0.default));
    var handleClick = (0, $dNMDr.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $dNMDr.createElement((0, $gKhoX.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $dNMDr.createElement("button", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
            "data-testid": testId,
            "aria-current": isSelected ? 'true' : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $67a311429c5037f7$export$2e2bcd8739ae039 = $67a311429c5037f7$var$ButtonItem;

});
parcelRegister("gKhoX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c30e70cea6c4d6e0$export$2e2bcd8739ae039; });
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $eS3uG = parcelRequire("eS3uG");

var $gFLow = parcelRequire("gFLow");
var $c30e70cea6c4d6e0$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $dNMDr.createElement(Component, props));
};
var $c30e70cea6c4d6e0$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt75194a _mizu194a _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1wmz",
    disabledDescription: "_syaz2oi6",
    unselected: "_bfhkqtfy _syaz1r31 _10531r31 _irr31dko _30l31r31 _1di61dko _9h8h1r31",
    disabled: "_80om13gf _bfhkqtfy _syaz2oi6 _irr3qtfy _30l32oi6 _1di6qtfy _9h8h2oi6",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rus67is _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rus67is _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk1q4k _syazhu5v _1053hu5v _irr32seo _30l316ov _1di6guph _9h8hhu5v",
    selectedOld: "_30l3hu5v"
};
var $c30e70cea6c4d6e0$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $c30e70cea6c4d6e0$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $c30e70cea6c4d6e0$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $dNMDr.useContext)((0, $gFLow.SpacingContext));
    var selectionStyle = (0, $dNMDr.useContext)((0, $gFLow.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $affTb.default)([
                (0, $affTb.default)([
                    $c30e70cea6c4d6e0$var$styles.root,
                    $c30e70cea6c4d6e0$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $c30e70cea6c4d6e0$var$styles.unselected,
                    !isDisabled && isSelected && $c30e70cea6c4d6e0$var$styles.selected,
                    !isDisabled && isSelected && $c30e70cea6c4d6e0$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $c30e70cea6c4d6e0$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $c30e70cea6c4d6e0$var$styles.selectedNotch,
                    isDisabled && $c30e70cea6c4d6e0$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $dNMDr.createElement((0, $eS3uG.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $c30e70cea6c4d6e0$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $dNMDr.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $affTb.default)([
                    $c30e70cea6c4d6e0$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $dNMDr.createElement("div", {
                className: (0, $affTb.default)([
                    $c30e70cea6c4d6e0$var$styles.content
                ])
            }, $c30e70cea6c4d6e0$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $affTb.default)([
                    $c30e70cea6c4d6e0$var$styles.title,
                    shouldTitleWrap ? $c30e70cea6c4d6e0$var$styles.wordBreak : $c30e70cea6c4d6e0$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $dNMDr.createElement("span", {
                "data-item-description": true,
                className: (0, $affTb.default)([
                    $c30e70cea6c4d6e0$var$styles.description,
                    isDisabled && $c30e70cea6c4d6e0$var$styles.disabledDescription,
                    shouldDescriptionWrap && $c30e70cea6c4d6e0$var$styles.wordBreak,
                    !shouldDescriptionWrap && $c30e70cea6c4d6e0$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $dNMDr.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $affTb.default)([
                    $c30e70cea6c4d6e0$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $c30e70cea6c4d6e0$export$2e2bcd8739ae039 = $c30e70cea6c4d6e0$var$MenuItemPrimitive;

});


parcelRegister("eeY6y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5e0ff0869e6dc25$export$2e2bcd8739ae039; });
/* custom-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");


var $hMip0 = parcelRequire("hMip0");

var $gKhoX = parcelRequire("gKhoX");
var $a5e0ff0869e6dc25$var$_excluded = [
    "component",
    "isDisabled",
    "isSelected",
    "isTitleHeading",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $a5e0ff0869e6dc25$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $a5e0ff0869e6dc25$var$CustomItem = /*#__PURE__*/ (0, $dNMDr.memo)(/*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $a5e0ff0869e6dc25$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $dNMDr.useContext)((0, $hMip0.default));
    var handleClick = (0, $dNMDr.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $dNMDr.createElement((0, $gKhoX.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        className: UNSAFE_className
    }, rest, {
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return /*#__PURE__*/ $dNMDr.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $a5e0ff0869e6dc25$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $a5e0ff0869e6dc25$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $a5e0ff0869e6dc25$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $a5e0ff0869e6dc25$export$2e2bcd8739ae039 = $a5e0ff0869e6dc25$var$CustomItem;

});

parcelRegister("3n7uR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $274955c2fe4974db$export$2e2bcd8739ae039; });
/* link-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");


var $k87WV = parcelRequire("k87WV");

var $hMip0 = parcelRequire("hMip0");

var $gKhoX = parcelRequire("gKhoX");
var $274955c2fe4974db$var$_excluded = [
    "children",
    "href",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $274955c2fe4974db$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $274955c2fe4974db$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $274955c2fe4974db$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $274955c2fe4974db$var$LinkItem = /*#__PURE__*/ (0, $dNMDr.memo)(/*#__PURE__*/ (0, $dNMDr.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(props, $274955c2fe4974db$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $k87WV.default)();
    var interactionContext = (0, $dNMDr.useContext)((0, $hMip0.default));
    var handleClick = (0, $dNMDr.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $274955c2fe4974db$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $274955c2fe4974db$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $dNMDr.createElement((0, $gKhoX.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $dNMDr.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $274955c2fe4974db$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $274955c2fe4974db$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $274955c2fe4974db$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $274955c2fe4974db$export$2e2bcd8739ae039 = $274955c2fe4974db$var$LinkItem;

});


parcelRegister("eEp70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aaa847cfc134853a$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $hGahQ = parcelRequire("hGahQ");

var $ihp8L = parcelRequire("ihp8L");

var $fo6gh = parcelRequire("fo6gh");
var $aaa847cfc134853a$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $aaa847cfc134853a$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $aaa847cfc134853a$var$_excluded);
    var uid = (0, $hGahQ.useId)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $ihp8L.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $fo6gh.default), {
        id: titleId,
        title: title
    }), children);
});
var $aaa847cfc134853a$export$2e2bcd8739ae039 = $aaa847cfc134853a$var$DropdownMenuItemGroup;

});
parcelRegister("ihp8L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4ed50def6f1db68$export$2e2bcd8739ae039; });
/* section.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $3bSvu = parcelRequire("3bSvu");
var $d4ed50def6f1db68$var$_excluded = [
    "children",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "isSideNavSection",
    "label",
    "className"
];
var $d4ed50def6f1db68$var$itemHeadingTopMargin = 20;
var $d4ed50def6f1db68$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $d4ed50def6f1db68$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $d4ed50def6f1db68$var$skeletonHeadingHeight = 8;
var $d4ed50def6f1db68$var$skeletonHeadingMarginOffset = 3;
var $d4ed50def6f1db68$var$skeletonHeadingTopMargin = $d4ed50def6f1db68$var$itemHeadingTopMargin + ($d4ed50def6f1db68$var$itemHeadingContentHeight - $d4ed50def6f1db68$var$skeletonHeadingHeight) - $d4ed50def6f1db68$var$skeletonHeadingMarginOffset;
var $d4ed50def6f1db68$var$sectionPaddingTopBottom = 6;
var $d4ed50def6f1db68$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm21ag2",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $d4ed50def6f1db68$var$Section = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var children = _ref.children, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, _ref$isSideNavSection = _ref.isSideNavSection, isSideNavSection = _ref$isSideNavSection === void 0 ? false : _ref$isSideNavSection, label = _ref.label, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $d4ed50def6f1db68$var$_excluded);
    var content = isList ? /*#__PURE__*/ $dNMDr.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $dNMDr.Children).map((0, $dNMDr.Children).toArray(children), function(child, index) {
        return /*#__PURE__*/ $dNMDr.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ $dNMDr.createElement((0, $dNMDr.Fragment), null, /*#__PURE__*/ $dNMDr.createElement((0, $3bSvu.default), {
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true,
        className: (0, $affTb.default)([
            isSideNavSection && $d4ed50def6f1db68$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $dNMDr.createElement((0, $dNMDr.Fragment), null, content);
    return /*#__PURE__*/ $dNMDr.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $affTb.default)([
            $d4ed50def6f1db68$var$styles.root,
            isScrollable ? $d4ed50def6f1db68$var$styles.scrollable : $d4ed50def6f1db68$var$styles.unscrollable,
            hasSeparator ? $d4ed50def6f1db68$var$styles.thinSeparator : $d4ed50def6f1db68$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $d4ed50def6f1db68$export$2e2bcd8739ae039 = $d4ed50def6f1db68$var$Section;

});
parcelRegister("3bSvu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $252cae1f4b1fa8f9$export$2e2bcd8739ae039; });
/* heading-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
var $9vljA = parcelRequire("9vljA");

var $2Mjap = parcelRequire("2Mjap");
var $252cae1f4b1fa8f9$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "className"
];
var $252cae1f4b1fa8f9$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $252cae1f4b1fa8f9$var$HeadingItem = /*#__PURE__*/ (0, $dNMDr.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $252cae1f4b1fa8f9$var$_excluded);
    return /*#__PURE__*/ $dNMDr.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $affTb.default)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syaz1vvm",
            UNSAFE_className
        ])
    }, rest, {
        style: {
            "--_bbz764": (0, $9vljA.default)("var(--ds-text-subtle, ".concat((0, $2Mjap.N300), ")"))
        }
    }), children);
});
var $252cae1f4b1fa8f9$export$2e2bcd8739ae039 = $252cae1f4b1fa8f9$var$HeadingItem;

});


parcelRegister("fo6gh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b33df4560c2f8752$export$2e2bcd8739ae039; });
/* group-title.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $dNMDr = parcelRequire("dNMDr");

var $l69Tm = parcelRequire("l69Tm");
var $b33df4560c2f8752$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $b33df4560c2f8752$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $l69Tm.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $b33df4560c2f8752$var$styles.heading
    }, title);
};
var $b33df4560c2f8752$export$2e2bcd8739ae039 = $b33df4560c2f8752$var$GroupTitle;

});


parcelRegister("5g8os", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d44f526fb6c13a9$var$_react = $3d44f526fb6c13a9$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $gsWOv = parcelRequire("gsWOv");

var $3d44f526fb6c13a9$var$_chevronDown = $3d44f526fb6c13a9$var$_interopRequireDefault((parcelRequire("fpsRW")));
function $3d44f526fb6c13a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3d44f526fb6c13a9$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $3d44f526fb6c13a9$var$_react.default.createElement($gsWOv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $3d44f526fb6c13a9$var$_chevronDown.default
    }));
$3d44f526fb6c13a9$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $3d44f526fb6c13a9$var$_default = module.exports.default = $3d44f526fb6c13a9$var$ChevronDownIcon;

});
parcelRegister("fpsRW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b37f959508569bea$var$_react = $b37f959508569bea$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $b37f959508569bea$var$_baseNew = $b37f959508569bea$var$_interopRequireDefault((parcelRequire("9LaLF")));
function $b37f959508569bea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b37f959508569bea$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $b37f959508569bea$var$_react.default.createElement($b37f959508569bea$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$b37f959508569bea$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $b37f959508569bea$var$_default = module.exports.default = $b37f959508569bea$var$ChevronDownIcon;

});



parcelRegister("idMOo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00950b7543e866be$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");
const $00950b7543e866be$var$SeparatorContainer = (0, $fbSBq.default).li`
  margin: 0px 8px;

  + li {
    margin-top: 0px;
  }
`;
const $00950b7543e866be$var$Bull = ()=>/*#__PURE__*/ (0, $6CtE1.jsx)($00950b7543e866be$var$SeparatorContainer, {
        role: "presentation",
        children: "\u2022"
    });
var $00950b7543e866be$export$2e2bcd8739ae039 = $00950b7543e866be$var$Bull;

});

parcelRegister("bi5Lm", function(module, exports) {

$parcel$export(module.exports, "useNavigateToLoginPrompt", function () { return $5a5028086010c2de$export$87a5fad76d200f12; });

var $lCnOB = parcelRequire("lCnOB");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $dNMDr = parcelRequire("dNMDr");

var $h4v4M = parcelRequire("h4v4M");
const $5a5028086010c2de$export$87a5fad76d200f12 = ()=>{
    const { search: search } = (0, $cVnBY.useLocation)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const loginHint = (0, $lCnOB.useLoginHint)();
    const queryParams = (0, $dNMDr.useMemo)(()=>new URLSearchParams(search), [
        search
    ]);
    return (0, $dNMDr.useCallback)(()=>{
        // Remove MFA transaction token
        queryParams.delete('transactionToken');
        // Remove inverted login hint
        if (loginHint?.type === (0, $lCnOB.LoginHintType).NotEmailAddress) queryParams.delete('login_hint');
        return navigate({
            pathname: '/login',
            search: `prompt=login&${queryParams}`
        });
    }, [
        loginHint?.type,
        navigate,
        queryParams
    ]);
};

});
parcelRegister("lCnOB", function(module, exports) {

$parcel$export(module.exports, "LoginHintType", function () { return $406f87ca90cf2994$export$39d1212c3512cb3a; });
$parcel$export(module.exports, "useLoginHint", function () { return $406f87ca90cf2994$export$76b5c17694a141a; });
$parcel$export(module.exports, "getEmailFromLoginHint", function () { return $406f87ca90cf2994$export$a738b9016987c561; });

var $dNMDr = parcelRequire("dNMDr");

var $cVnBY = parcelRequire("cVnBY");
var $406f87ca90cf2994$export$39d1212c3512cb3a = /*#__PURE__*/ function(LoginHintType) {
    LoginHintType["EmailAddress"] = "email-address";
    LoginHintType["NotEmailAddress"] = "not-email-address";
    return LoginHintType;
}({});
const $406f87ca90cf2994$var$NEGATED_EMAIL_PREFIX = 'not:';
function $406f87ca90cf2994$var$parseLoginHint(loginHint) {
    if (!loginHint) return undefined;
    if (loginHint.startsWith($406f87ca90cf2994$var$NEGATED_EMAIL_PREFIX)) return {
        type: "not-email-address",
        value: loginHint.substring($406f87ca90cf2994$var$NEGATED_EMAIL_PREFIX.length)
    };
    return {
        type: "email-address",
        value: loginHint
    };
}
const $406f87ca90cf2994$export$76b5c17694a141a = ()=>{
    const { search: search } = (0, $cVnBY.useLocation)();
    return (0, $dNMDr.useMemo)(()=>{
        const loginHint = new URLSearchParams(search).get('login_hint');
        return $406f87ca90cf2994$var$parseLoginHint(loginHint);
    }, [
        search
    ]);
};
const $406f87ca90cf2994$export$a738b9016987c561 = (loginHint)=>{
    if (loginHint?.type === "email-address") return loginHint.value;
};

});


parcelRegister("j1629", function(module, exports) {

$parcel$export(module.exports, "VerifyEmailOtp", function () { return $7b56cf3ebd421b4c$export$fce66dd1dcb31ce2; });
$parcel$export(module.exports, "default", function () { return $7b56cf3ebd421b4c$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $eTWY7 = parcelRequire("eTWY7");

var $8PbSs = parcelRequire("8PbSs");

var $8qQ4w = parcelRequire("8qQ4w");

var $3KCQs = parcelRequire("3KCQs");

var $dNMDr = parcelRequire("dNMDr");

var $2byD0 = parcelRequire("2byD0");

var $Q6OOA = parcelRequire("Q6OOA");

var $iJjQ1 = parcelRequire("iJjQ1");

var $fbSBq = parcelRequire("fbSBq");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $cpaps = parcelRequire("cpaps");

var $7aAOa = parcelRequire("7aAOa");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $hqddj = parcelRequire("hqddj");
const $7b56cf3ebd421b4c$var$OtpError = (0, $fbSBq.default).div`
  margin-top: 4px;
  margin-bottom: 0;
  display: inline-flex;
  align-items: center;
  font-size: 12px !important;
  color: ${(0, $l4KzN).R500};
`;
const $7b56cf3ebd421b4c$var$OtpInputWrapper = (0, $fbSBq.default).div`
  display: flex;
  align-content: center;
  justify-content: center;
  padding: ${(0, $68HQw.gridSize)() * 3}px 0 0 0;
`;
const $7b56cf3ebd421b4c$var$EMPTY_OTP_STATE = ' '.repeat((0, $7aAOa.OTP_CODE_FULL_LENGTH));
const $7b56cf3ebd421b4c$var$removePlaceholders = (otp)=>otp.replace(/ /g, '');
const $7b56cf3ebd421b4c$export$fce66dd1dcb31ce2 = ({ pageId: pageId, flow: flow, email: email, isLoading: isLoading, errorCode: errorCode, additionalWhiteboxFooter: footer, onVerifyEmailOtp: onVerifyEmailOtp, onResendEmailOtp: onResendEmailOtp, onInvalidEmailOtpLength: onInvalidEmailOtpLength })=>{
    const [otp, setOtp] = (0, $dNMDr.useState)($7b56cf3ebd421b4c$var$EMPTY_OTP_STATE);
    const [isInvalidOtpLength, setInvalidOtpLength] = (0, $dNMDr.useState)(false);
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const handleOtpChange = (otp)=>{
        setOtp(otp);
        const sanitisedOtp = $7b56cf3ebd421b4c$var$removePlaceholders(otp);
        if (sanitisedOtp.length === (0, $7aAOa.OTP_CODE_FULL_LENGTH)) {
            setInvalidOtpLength(false);
            onVerifyEmailOtp(sanitisedOtp);
        }
    };
    const handleSubmit = ()=>{
        const sanitisedOtp = $7b56cf3ebd421b4c$var$removePlaceholders(otp);
        if (sanitisedOtp.length === (0, $7aAOa.OTP_CODE_FULL_LENGTH)) {
            setInvalidOtpLength(false);
            onVerifyEmailOtp(sanitisedOtp);
        } else {
            setInvalidOtpLength(true);
            onInvalidEmailOtpLength?.(sanitisedOtp);
        }
    };
    const otpMessageDescriptor = (0, $dNMDr.useMemo)(()=>{
        switch(flow){
            case 'sign-up':
                return (0, $iJjQ1.default).signUpOtpMessage;
            case 'login-challenge':
                return (0, $iJjQ1.default).loginChallengeOtpMessage;
            default:
                (0, $hqddj.captureErrorMessage)(`No OTP message defined for VerifyEmailOtp flow "${flow}", falling back to default message`);
                return (0, $iJjQ1.default).defaultOtpMessage;
        }
    }, [
        flow
    ]);
    const errorMessageDescriptor = (0, $dNMDr.useMemo)(()=>{
        if (isInvalidOtpLength) return (0, $iJjQ1.default).invalidOtpLengthErrorMessage;
        if (!errorCode) return undefined;
        switch(errorCode){
            case 'invalid_otp':
                return (0, $iJjQ1.default).invalidOtpErrorMessage;
            case 'invalid_otp_length':
                return (0, $iJjQ1.default).invalidOtpLengthErrorMessage;
            case 'invalid_token':
                return (0, $iJjQ1.default).invalidTokenErrorMessage;
            case 'expired_token':
                return (0, $iJjQ1.default).expiredTokenErrorMessage;
            case 'rate_limited':
                return (0, $iJjQ1.default).rateLimitedErrorMessage;
            case 'unexpected_error':
                return (0, $iJjQ1.default).unexpectedErrorErrorMessage;
            default:
                return (0, $iJjQ1.default).unexpectedErrorErrorMessage;
        }
    }, [
        errorCode,
        isInvalidOtpLength
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (errorCode === 'invalid_otp') setOtp($7b56cf3ebd421b4c$var$EMPTY_OTP_STATE);
    }, [
        errorCode
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            tagName: "h2",
            ...(0, $iJjQ1.default).headOtpTitle
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                    id: "otp-resend",
                    spacing: "none",
                    onClick: onResendEmailOtp,
                    children: formatMessage((0, $iJjQ1.default).resendOtpButton)
                }),
                footer
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.Helmet), {
                title: formatMessage((0, $iJjQ1.default).headOtpTitle)
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8PbSs.default), {
                email: email,
                message: formatMessage(otpMessageDescriptor),
                withEmailSentImage: false
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)($7b56cf3ebd421b4c$var$OtpInputWrapper, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3KCQs.default), {
                    otpCodeFullLength: (0, $7aAOa.OTP_CODE_FULL_LENGTH),
                    onChange: handleOtpChange,
                    otp: otp,
                    isLoading: isLoading,
                    isError: !!errorCode
                })
            }),
            !!errorMessageDescriptor && /*#__PURE__*/ (0, $6CtE1.jsxs)($7b56cf3ebd421b4c$var$OtpError, {
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8qQ4w))), {
                        label: 'Error message icon',
                        size: 'small'
                    }),
                    formatMessage(errorMessageDescriptor)
                ]
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                id: "otp-submit",
                appearance: 'primary',
                type: "submit",
                isFullWidth: true,
                style: {
                    marginTop: '30px'
                },
                onClick: handleSubmit,
                isLoading: isLoading,
                children: formatMessage((0, $iJjQ1.default).submitButton)
            })
        ]
    });
};
var $7b56cf3ebd421b4c$export$2e2bcd8739ae039 = $7b56cf3ebd421b4c$export$fce66dd1dcb31ce2;

});
parcelRegister("3KCQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e5dd49dad2a1c1d$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $1lkpU = parcelRequire("1lkpU");

var $fbSBq = parcelRequire("fbSBq");

var $hqddj = parcelRequire("hqddj");

var $68HQw = parcelRequire("68HQw");
const $1e5dd49dad2a1c1d$export$a21f0385582d981d = [
    ' ',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
];
const $1e5dd49dad2a1c1d$var$InputWrapper = (0, $fbSBq.default).div`
  display: flex;
  gap: ${(0, $68HQw.gridSize)()}px;

  input {
    text-align: center;
    font-size: 20px;
  }
`;
const $1e5dd49dad2a1c1d$var$OtpInput = ({ otp: otp, otpCodeFullLength: otpCodeFullLength, onChange: onChange, isLoading: isLoading, isError: isError })=>{
    const [focusedInputIndex, setFocusedInputIndex] = (0, $dNMDr.useState)(0);
    const inputRefs = (0, $dNMDr.useRef)([]);
    const otpCodeArray = $1e5dd49dad2a1c1d$var$parseOtp(otp);
    (0, $dNMDr.useEffect)(()=>{
        inputRefs.current = inputRefs.current.slice(0, otpCodeFullLength);
    }, [
        otpCodeFullLength
    ]);
    (0, $dNMDr.useEffect)(()=>{
        inputRefs.current[0]?.focus();
    }, []);
    const isInputValueValid = (value)=>value.trim().length === 1 && $1e5dd49dad2a1c1d$var$isOtpCodeCharacter(value);
    const handleChange = (event)=>{
        const value = event.target.value.toUpperCase();
        if (isInputValueValid(value)) {
            changeOtpCodeAtFocus(value);
            focusInput(focusedInputIndex + 1);
        } else {
            const { nativeEvent: nativeEvent } = event;
            // @ts-expect-error - This was added previosly to handle and edge case
            // for dealing with keyCode "229 Unidentified" on Android. Check if this is
            // still needed.
            if (nativeEvent.data === null && nativeEvent.inputType === 'deleteContentBackward') {
                event.preventDefault();
                changeOtpCodeAtFocus(' ');
                focusInput(focusedInputIndex - 1);
            }
        }
    };
    const handleFocus = (index)=>(event)=>{
            focusInput(index);
            event.target.select();
        };
    const handleBlur = ()=>{
        setFocusedInputIndex(focusedInputIndex - 1);
    };
    const handleBackspace = (event)=>{
        event.preventDefault();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = event.target;
        if (selectionStart === 0 && selectionEnd === 0) {
            if (focusedInputIndex > 0) {
                const newFocusedIndex = focusedInputIndex - 1;
                focusInput(newFocusedIndex);
                changeOtpCodeAtIndex(newFocusedIndex, ' ');
            }
        } else changeOtpCodeAtFocus(' ');
    };
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'Delete':
                event.preventDefault();
                changeOtpCodeAtFocus(' ');
                break;
            case 'Backspace':
                handleBackspace(event);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                focusInput(focusedInputIndex - 1);
                break;
            case 'ArrowRight':
                event.preventDefault();
                focusInput(focusedInputIndex + 1);
                break;
            case 'Space':
            case 'Spacebar':
            case 'ArrowUp':
            case 'ArrowDown':
                event.preventDefault();
                break;
            default:
                // React does not trigger onChange when the same value is entered
                // again. So we need to focus the next input manually in this case.
                if (event.key === otpCodeArray[focusedInputIndex]) {
                    event.preventDefault();
                    focusInput(focusedInputIndex + 1);
                }
        }
    };
    const focusInput = (index)=>{
        const indexToFocusInput = Math.max(Math.min(otpCodeFullLength - 1, index), 0);
        inputRefs.current[indexToFocusInput]?.focus();
        inputRefs.current[indexToFocusInput]?.select();
        setFocusedInputIndex(indexToFocusInput);
    };
    const changeOtpCodeAtIndex = (index, value)=>{
        otpCodeArray[index] = value;
        onChange($1e5dd49dad2a1c1d$var$otpCodeArrayToString(otpCodeArray));
    };
    const changeOtpCodeAtFocus = (value)=>changeOtpCodeAtIndex(focusedInputIndex, value);
    const handlePaste = (event)=>{
        event.preventDefault();
        // Get dataToPaste in an array of max size (num of inputs - current position)
        const dataToPaste = event.clipboardData.getData('text/plain').slice(0, otpCodeFullLength - focusedInputIndex).toUpperCase().split('');
        // Prevent pasting if the clipboard data contains non-alphanumeric values for number inputs
        if (dataToPaste.some((value)=>!$1e5dd49dad2a1c1d$var$isOtpCodeCharacter(value))) return;
        // Paste data from focused input onwards
        let indexToPaste = focusedInputIndex;
        while(indexToPaste < otpCodeFullLength && dataToPaste.length > 0){
            otpCodeArray[indexToPaste] = dataToPaste.shift();
            indexToPaste++;
        }
        focusInput(indexToPaste);
        onChange($1e5dd49dad2a1c1d$var$otpCodeArrayToString(otpCodeArray));
    };
    return /*#__PURE__*/ (0, $6CtE1.jsx)($1e5dd49dad2a1c1d$var$InputWrapper, {
        children: otpCodeArray.map((otpCodeDigitValue, index)=>/*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $1lkpU.default), {
                    isDisabled: isLoading,
                    isInvalid: isError,
                    value: otpCodeDigitValue === ' ' ? '' : otpCodeDigitValue,
                    ref: (element)=>inputRefs.current[index] = element,
                    onChange: handleChange,
                    onFocus: handleFocus(index),
                    onBlur: handleBlur,
                    onKeyDown: handleKeyDown,
                    onPaste: handlePaste,
                    autoComplete: "off",
                    maxLength: 1,
                    "aria-label": `Please enter OTP character ${index + 1}`,
                    type: "text",
                    testId: `otp-input-index-${index}`
                })
            }, `otp-div-index-${index}`))
    });
};
const $1e5dd49dad2a1c1d$var$isOtpCodeCharacter = (c)=>$1e5dd49dad2a1c1d$export$a21f0385582d981d.includes(c);
const $1e5dd49dad2a1c1d$var$parseOtp = (otp)=>{
    const otpCodeArray = otp.split('').filter($1e5dd49dad2a1c1d$var$isOtpCodeCharacter);
    if (otp.length !== otpCodeArray.length) (0, $hqddj.captureErrorMessage)('Error parsing OTP - received invalid OTP character', {
        otp: otp
    });
    return otpCodeArray;
};
const $1e5dd49dad2a1c1d$var$otpCodeArrayToString = (otpCodeArray)=>otpCodeArray.join('');
var $1e5dd49dad2a1c1d$export$2e2bcd8739ae039 = $1e5dd49dad2a1c1d$var$OtpInput;

});

parcelRegister("iJjQ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0166139001a4d32$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $b0166139001a4d32$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    defaultOtpMessage: {
        id: 'verify.email.sent.body.otp.default.message',
        defaultMessage: "To proceed, enter the code we've sent to:",
        description: 'Text telling the user to enter the OTP sent to their email to verify their account to proceed to the next step'
    },
    signUpOtpMessage: {
        id: 'verify.email.sent.body.otp.sign-up.message',
        defaultMessage: "To complete your account setup, enter the code we've sent to:",
        description: 'Text telling the user to enter the OTP sent to their email to verify their account and complete account setup'
    },
    loginChallengeOtpMessage: {
        id: 'verify.email.sent.body.otp.login-challenge.message',
        defaultMessage: 'We require additional verification to protect your account. Check your email to continue:',
        description: 'Text telling the user to enter the OTP sent to their email to verify their account to proceed with the login'
    },
    invalidOtpErrorMessage: {
        id: 'verify.email.error-message.invalid-otp',
        defaultMessage: 'Provided verification code is invalid',
        description: 'Error message informing the user that the OTP code they have entered is incorrect'
    },
    invalidOtpLengthErrorMessage: {
        id: 'verify.email.error-message.invalid-otp-length',
        defaultMessage: 'Complete the verification code',
        description: 'Error message informing the user that the OTP code they have entered is of an incorrect length'
    },
    invalidTokenErrorMessage: {
        id: 'verify.email.error-message.invalid-token',
        defaultMessage: 'Invalid token',
        description: 'Error message returned when the token associated with the verification transaction is invalid'
    },
    expiredTokenErrorMessage: {
        id: 'verify.email.error-message.expired-token',
        defaultMessage: 'Token expired',
        description: 'Error message returned when the token associated with the verification transaction is expired'
    },
    rateLimitedErrorMessage: {
        id: 'verify.email.error-message.rate-limited',
        defaultMessage: 'Rate limit exceeded. Try again in a couple of minutes.',
        description: 'Error message returned when rate limited due to too many requests'
    },
    unexpectedErrorErrorMessage: {
        id: 'verify.email.error-message.unexpected',
        defaultMessage: 'Unexpected error',
        description: 'Error message returned when there is an unexpected error'
    },
    emailOtpVerifyHeader: {
        id: 'verify.email.otp.sent.title',
        defaultMessage: `We've sent you an email!`,
        description: 'Title of the component that lets them input the code to verify their email'
    },
    resendOtpButton: {
        id: 'welcome.sent.resend.signup.otp',
        defaultMessage: `Didn't receive an email? Resend email`,
        description: 'Text telling the user that they can resend the welcome OTP email again for verification.'
    },
    headOtpTitle: {
        id: 'verify.email.sent.otp.head.title',
        defaultMessage: `We've emailed you a code`,
        description: 'Text telling the user that they were sent an email with an OTP'
    },
    submitButton: {
        id: 'verify.email.signup.submit',
        defaultMessage: 'Verify',
        description: 'Text used for the button that submits the OTP for verification.'
    }
});

});

parcelRegister("7aAOa", function(module, exports) {

$parcel$export(module.exports, "OTP_CODE_FULL_LENGTH", function () { return $acef47b19ed45a4f$export$d9c80c0582b65520; });
const $acef47b19ed45a4f$export$d9c80c0582b65520 = 6;

});


parcelRegister("eZOsi", function(module, exports) {

$parcel$export(module.exports, "useExecutionTracker", function () { return $51a7726464d46305$export$a5531e57774c1d12; });

var $dNMDr = parcelRequire("dNMDr");
const $51a7726464d46305$export$a5531e57774c1d12 = ()=>{
    const [isExecuting, setIsExecuting] = (0, $dNMDr.useState)(false);
    const executeWithTracking = (0, $dNMDr.useCallback)(async (asyncOperation)=>{
        setIsExecuting(true);
        try {
            return await asyncOperation();
        } finally{
            setIsExecuting(false);
        }
    }, []);
    return {
        isExecuting: isExecuting,
        executeWithTracking: executeWithTracking
    };
};

});

parcelRegister("cFZwW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ec274cda8de5424$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $doMYO = parcelRequire("doMYO");

var $eTWY7 = parcelRequire("eTWY7");

var $737na = parcelRequire("737na");

var $aMBBA = parcelRequire("aMBBA");

var $4NPio = parcelRequire("4NPio");

var $h4v4M = parcelRequire("h4v4M");

var $8IkGb = parcelRequire("8IkGb");
const $3ec274cda8de5424$export$cf34b8e1c360d82b = ({ screenId: screenId, isSwitching: isSwitching, switchWithTracking: switchWithTracking })=>{
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const { method: multifactorMethod, additionalMfaFactors: additionalMfaFactors } = (0, $aMBBA.useAppSelector)((state)=>state.multiFactor);
    const { search: search } = (0, $cVnBY.useLocation)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const trackSwitchToSms = (0, $4NPio.useButtonClickedEvent)(screenId, 'switchToSms');
    const trackSwitchToTotp = (0, $4NPio.useButtonClickedEvent)(screenId, 'switchToTotp');
    const trackSwitchToSecurityKey = (0, $4NPio.useButtonClickedEvent)(screenId, 'switchToSecurityKey');
    const onSwitchToSms = (0, $dNMDr.useCallback)(()=>{
        trackSwitchToSms();
        switchWithTracking(async ()=>await dispatch((0, $doMYO.switchMfaFactor)(search, 'SMS', analyticsClient, navigate)));
    }, [
        trackSwitchToSms,
        switchWithTracking,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const onSwitchToTotp = (0, $dNMDr.useCallback)(()=>{
        trackSwitchToTotp();
        switchWithTracking(async ()=>await dispatch((0, $doMYO.switchMfaFactor)(search, 'TOTP', analyticsClient, navigate)));
    }, [
        trackSwitchToTotp,
        switchWithTracking,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const onSwitchToSecurityKey = (0, $dNMDr.useCallback)(()=>{
        trackSwitchToSecurityKey();
        switchWithTracking(async ()=>await dispatch((0, $doMYO.switchMfaFactor)(search, 'SecurityKey', analyticsClient, navigate)));
    }, [
        trackSwitchToSecurityKey,
        switchWithTracking,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const switchableFactors = (0, $dNMDr.useMemo)(()=>[
            {
                method: 'security-key',
                buttonLabel: (0, $737na.default).mfSwitchToSecurityKey,
                onClick: onSwitchToSecurityKey
            },
            {
                method: 'otp',
                buttonLabel: (0, $737na.default).mfSwitchToTotp,
                onClick: onSwitchToTotp
            },
            {
                method: 'sms',
                buttonLabel: (0, $737na.default).mfSwitchToSms,
                onClick: onSwitchToSms
            }
        ], [
        onSwitchToSecurityKey,
        onSwitchToTotp,
        onSwitchToSms
    ]);
    if (!additionalMfaFactors || additionalMfaFactors.length === 0) return null;
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8IkGb.default), {
                paddingBlockEnd: "space.150",
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    tagName: "p",
                    id: "mf.switch-to-other-factor-help-text",
                    defaultMessage: "Use alternate method",
                    description: "Text indicating the purposes the buttons to switch factor when being challenged on login"
                })
            }),
            switchableFactors.flatMap((factor)=>{
                if (!additionalMfaFactors.includes(factor.method) || factor.method === multifactorMethod) return [];
                else return [
                    /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                            id: `two-step-verification-switch-factor-${factor.method}`,
                            testId: `two-step-verification-switch-factor-${factor.method}`,
                            onClick: factor.onClick,
                            isDisabled: isSwitching,
                            children: formatMessage(factor.buttonLabel)
                        })
                    }, `switch-factor-${factor.method}-wrapper`)
                ];
            })
        ]
    });
};
var $3ec274cda8de5424$export$2e2bcd8739ae039 = $3ec274cda8de5424$export$cf34b8e1c360d82b;

});


parcelRegister("1OnM8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "cancelAccountDeletionLoader", function () { return $097dadc2abd61cc6$export$bb55274e034e60c0; });
$parcel$export(module.exports, "CancelAccountDeletionPageComponent", function () { return $097dadc2abd61cc6$export$429c4af0f87478e0; });
$parcel$export(module.exports, "default", function () { return $097dadc2abd61cc6$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $79HVl = parcelRequire("79HVl");

var $1JRGy = parcelRequire("1JRGy");

var $2byD0 = parcelRequire("2byD0");

var $cpaps = parcelRequire("cpaps");

var $71vEH = parcelRequire("71vEH");

var $lwrli = parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $7lC8o = parcelRequire("7lC8o");

var $fGqsb = parcelRequire("fGqsb");

var $khKfk = parcelRequire("khKfk");

var $Q6OOA = parcelRequire("Q6OOA");

var $fbSBq = parcelRequire("fbSBq");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $aMBBA = parcelRequire("aMBBA");

var $h4v4M = parcelRequire("h4v4M");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");

var $dWOVN = parcelRequire("dWOVN");
const $097dadc2abd61cc6$var$SubtleLinkWrapper = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
  a {
    color: ${(0, $l4KzN).N800};

    &:hover {
      color: ${(0, $l4KzN).N800};
    }
  }
`;
const $097dadc2abd61cc6$var$pageId = 'cancelAccountDeletionPage';
async function $097dadc2abd61cc6$export$bb55274e034e60c0({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/login/cancel-account-deletion/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--cancel-account-deletion'
        ]
    });
}
const $097dadc2abd61cc6$export$429c4af0f87478e0 = ()=>{
    const { search: search } = (0, $cVnBY.useLocation)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const deleteOn = (0, $aMBBA.useAppSelector)((state)=>state.cancelDeletion.deleteOn);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const cancelDeletion = (0, $dNMDr.useCallback)(()=>{
        const { token: token } = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(search);
        return fetch(`/rest/cancel-account-deletion${search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token
            })
        }).then((response)=>{
            if (response.status === 200) return response.json();
            else throw response;
        }).then(({ redirectTo: redirectTo })=>{
            navigate(redirectTo);
        }).catch(()=>{
            const flag = {
                type: 'error',
                title: (0, $fGqsb.default).cancelAccountDeletionFlagErrorTitle,
                description: (0, $fGqsb.default).cancelAccountDeletionFlagErrorDesc
            };
            dispatch((0, $7lC8o.addFlag)(flag.type, flag.title, flag.description));
        });
    }, [
        dispatch,
        search,
        navigate
    ]);
    const signupLink = '/signup' + search;
    const loginLink = '/login' + search;
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: $097dadc2abd61cc6$var$pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $fGqsb.default).headTitle
            })
        }),
        footer: /*#__PURE__*/ (0, $6CtE1.jsx)($097dadc2abd61cc6$var$SubtleLinkWrapper, {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.Link), {
                id: "signup-for-new-account",
                to: signupLink,
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...(0, $fGqsb.default).cancelAccountDeletionSignupMessage
                })
            })
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.Link), {
            to: loginLink,
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $fGqsb.default).cancelAccountDeletionLogout
            })
        }),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                title: formatMessage((0, $fGqsb.default).headTitle)
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $71vEH.default), {
                message: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...(0, $fGqsb.default).cancelAccountDeletionInfo,
                    tagName: "p",
                    values: {
                        deleteOn: (0, (/*@__PURE__*/$parcel$interopDefault($khKfk)))(deleteOn).format('DD MMMM YYYY')
                    }
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                    appearance: "primary",
                    id: "login-submit",
                    type: "submit",
                    isFullWidth: true,
                    onClick: cancelDeletion,
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $fGqsb.default).cancelAccountDeletionButton
                    })
                })
            })
        ]
    });
};
var $097dadc2abd61cc6$export$2e2bcd8739ae039 = $097dadc2abd61cc6$export$429c4af0f87478e0;

});
parcelRegister("71vEH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $223636dc9e72d843$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $2QZYv = parcelRequire("2QZYv");

var $68HQw = parcelRequire("68HQw");
const $223636dc9e72d843$var$imgHeight = 150;
const $223636dc9e72d843$var$CancelDeletionContainer = (0, $fbSBq.default).div`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($2QZYv)))}) no-repeat center top;
  background-size: auto ${$223636dc9e72d843$var$imgHeight}px;
  padding-top: ${$223636dc9e72d843$var$imgHeight + (0, $68HQw.gridSize)() * 2}px;
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $223636dc9e72d843$var$CancelDeletion = ({ children: children, message: message })=>/*#__PURE__*/ (0, $6CtE1.jsxs)($223636dc9e72d843$var$CancelDeletionContainer, {
        id: "cancel-account-deletion-page",
        children: [
            message,
            children
        ]
    });
var $223636dc9e72d843$export$2e2bcd8739ae039 = $223636dc9e72d843$var$CancelDeletion;

});
parcelRegister("2QZYv", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "cancel-deletion-hourglass.2bcc1f2b.svg";

});


parcelRegister("fGqsb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64449b4e47efbe9e$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $64449b4e47efbe9e$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    // Flags
    cancelAccountDeletionFlagErrorTitle: {
        id: 'cancel.account.deletion.flag.error.title',
        defaultMessage: 'Something went wrong.',
        description: ''
    },
    cancelAccountDeletionFlagErrorDesc: {
        id: 'cancel.account.deletion.flag.error.description',
        defaultMessage: 'Please try again later.',
        description: ''
    },
    headTitle: {
        id: 'cancel.account.deletion.title',
        defaultMessage: 'Cancel the deletion of your account',
        description: ''
    },
    cancelAccountDeletionSignupMessage: {
        id: 'cancel.account.deletion.signup',
        defaultMessage: 'Sign up for a new account',
        description: 'Button text for signing up for a new account'
    },
    cancelAccountDeletionInfo: {
        id: 'cancel.account.deletion.info',
        defaultMessage: 'Your account will be permanently deleted. You can cancel the deletion before {deleteOn}.',
        description: 'Deletion info in the text box'
    },
    cancelAccountDeletionButton: {
        id: 'cancel.account.deletion.button',
        defaultMessage: 'Cancel deletion',
        description: 'Text for cancel deletion button'
    },
    cancelAccountDeletionLogout: {
        id: 'cancel.account.deletion.log.out',
        defaultMessage: 'Log out (and delete your account as scheduled)',
        description: 'Text for log out button'
    }
});

});

parcelRegister("khKfk", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});


parcelRegister("humZM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "changePasswordLoader", function () { return $c883c8d2d10d7182$export$86843e04562221a8; });
$parcel$export(module.exports, "ChangePasswordPage", function () { return $c883c8d2d10d7182$export$8ec0fb1e4323236d; });
$parcel$export(module.exports, "default", function () { return $c883c8d2d10d7182$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $cpaps = parcelRequire("cpaps");

var $1JRGy = parcelRequire("1JRGy");

var $fbSBq = parcelRequire("fbSBq");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $68HQw = parcelRequire("68HQw");

var $1GshQ = parcelRequire("1GshQ");

var $2byD0 = parcelRequire("2byD0");

var $hqddj = parcelRequire("hqddj");

var $Q6OOA = parcelRequire("Q6OOA");

var $ckdYh = parcelRequire("ckdYh");

var $7Xy0r = parcelRequire("7Xy0r");

var $6i4Wm = parcelRequire("6i4Wm");

var $bQ3TY = parcelRequire("bQ3TY");

var $5pCRv = parcelRequire("5pCRv");

var $fcxz7 = parcelRequire("fcxz7");

var $aTW32 = parcelRequire("aTW32");

var $idMOo = parcelRequire("idMOo");

var $gre8I = parcelRequire("gre8I");

var $4NPio = parcelRequire("4NPio");

var $aMBBA = parcelRequire("aMBBA");

var $4yl6n = parcelRequire("4yl6n");

var $h4v4M = parcelRequire("h4v4M");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");

var $dWOVN = parcelRequire("dWOVN");
const $c883c8d2d10d7182$var$TRANSITION_DURATION = 400;
const $c883c8d2d10d7182$var$SecurityContainer = (0, $fbSBq.default).div`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($aTW32)))}) no-repeat center;
  height: ${(0, $68HQw.gridSize)() * 14.5}px;
  transition: visibility ${$c883c8d2d10d7182$var$TRANSITION_DURATION}ms;
  margin-bottom: ${(0, $68HQw.gridSize)() * 1.5}px;
`;
const $c883c8d2d10d7182$var$Form = (0, $fbSBq.default).form`
  margin-top: 0;
`;
const $c883c8d2d10d7182$var$knownMessageKeys = [
    'change_email',
    'security_wasme_reset',
    'security_wasnotme_reset'
];
function $c883c8d2d10d7182$var$chooseTitle(message) {
    switch(message){
        case 'security_wasme_reset':
            return (0, $1GshQ.default).securityResetTitle;
        case 'security_wasnotme_reset':
            return (0, $1GshQ.default).securityResetTitle;
        default:
            return (0, $1GshQ.default).title;
    }
}
function $c883c8d2d10d7182$var$chooseButtonText(message) {
    switch(message){
        case 'security_wasme_reset':
            return (0, $1GshQ.default).button;
        case 'security_wasnotme_reset':
            return (0, $1GshQ.default).button;
        default:
            return (0, $1GshQ.default).button;
    }
}
function $c883c8d2d10d7182$var$chooseAnalyticsEventName(message) {
    switch(message){
        case 'security_wasme_reset':
            return 'suspiciousWasUser';
        case 'security_wasnotme_reset':
            return 'suspiciousWasNotUser';
        case 'change_email':
            return 'changeEmail';
        default:
            return 'userRequest';
    }
}
function $c883c8d2d10d7182$var$chooseChangePasswordType(message) {
    switch(message){
        case 'security_wasme_reset':
            return 'security-password-reset';
        case 'security_wasnotme_reset':
            return 'security-password-reset';
        default:
            return 'password-reset';
    }
}
const $c883c8d2d10d7182$var$pageId = 'setNewPasswordScreen';
async function $c883c8d2d10d7182$export$86843e04562221a8({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/login/changepassword/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--change-password'
        ]
    });
}
const $c883c8d2d10d7182$export$8ec0fb1e4323236d = ()=>{
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const email = (0, $aMBBA.useAppSelector)((state)=>state.changePassword.email);
    const displayName = (0, $aMBBA.useAppSelector)((state)=>state.changePassword.displayName);
    const isLoading = (0, $aMBBA.useAppSelector)((state)=>state.changePassword.isLoading);
    const error = (0, $aMBBA.useAppSelector)((state)=>state.changePassword.error);
    const csrfToken = (0, $aMBBA.useAppSelector)((state)=>state.csrfToken);
    const intl = (0, $ko1o6.default)();
    const passwordFieldError = (0, $aMBBA.useAppSelector)((state)=>state.changePassword.fieldErrors.password);
    const translatedPasswordFieldError = (0, $4yl6n.useTranslateFormErrorIfAvailable)(passwordFieldError);
    const location = (0, $cVnBY.useLocation)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const [password, setPassword] = (0, $dNMDr.useState)('');
    const passwordInputRef = (0, $dNMDr.useRef)(null);
    const query = (0, $dNMDr.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search);
    }, [
        location.search
    ]);
    (0, $4NPio.usePageViewedEvent)($c883c8d2d10d7182$var$pageId, {
        origin: $c883c8d2d10d7182$var$chooseAnalyticsEventName(query.message)
    });
    (0, $dNMDr.useEffect)(()=>{
        if (query.message && !$c883c8d2d10d7182$var$knownMessageKeys.includes(query.message)) (0, $hqddj.captureErrorMessage)('change_password_missing_error_message', {
            key: query.message
        });
    }, [
        query.message
    ]);
    const renderPasswordChangeError = (error)=>{
        switch(error){
            case 'unknown':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.unknown",
                    defaultMessage: "Something went wrong while attempting to change your password. Please try again."
                });
            case 'request_error':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.request_error",
                    defaultMessage: "Unable to connect. Check your internet connection or the network settings for your browser and try again."
                });
            case 'passwordLeaked':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changepassword.password.leaked.paragraph.xml",
                    defaultMessage: "<p>This password has appeared in an external data breach. To continue, enter another password. <learn-more-link>Learn more</learn-more-link></p>",
                    tagName: "p",
                    values: {
                        p: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("p", {
                                children: chunks
                            }),
                        'learn-more-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("a", {
                                href: (0, $5pCRv.PASSWORD_LEAKED_LINK),
                                children: chunks
                            })
                    }
                });
            case 'passwordCommon':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.passwordCommon",
                    defaultMessage: "This password is too widely used. Choose a password that's harder to guess."
                });
            case 'invalidPassword':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.invalidPassword",
                    defaultMessage: "Invalid password"
                });
            case 'passwordCaseError':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.passwordCaseError",
                    defaultMessage: "Your password must contain at least one uppercase and one lowercase letter."
                });
            case 'passwordDigitOrSpecialError':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.passwordDigitOrSpecialError",
                    defaultMessage: "Your password must contain at least one digit or special character."
                });
            case 'passwordLengthError':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.passwordLengthError",
                    defaultMessage: "Your password must be between 8 and 72 characters long."
                });
            case 'passwordUsedBefore':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.passwordUsedBefore",
                    defaultMessage: "You've used that password before. Please choose a different one."
                });
            case 'passwordStrengthErrorWeak':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.passwordStrengthErrorWeak",
                    defaultMessage: "Your password must have a minimum strength of weak."
                });
            case 'passwordStrengthErrorFair':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.passwordStrengthErrorFair",
                    defaultMessage: "Your password must have a minimum strength of fair."
                });
            case 'passwordStrengthErrorGood':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.passwordStrengthErrorGood",
                    defaultMessage: "Your password must have a minimum strength of good."
                });
            case 'passwordStrengthErrorStrong':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.passwordStrengthErrorStrong",
                    defaultMessage: "Your password must have a minimum strength of strong."
                });
            case 'passwordStrengthErrorVeryStrong':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.error.passwordStrengthErrorVeryStrong",
                    defaultMessage: "Your password must have a minimum strength of very strong."
                });
            default:
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changePassword.form.random.error",
                    defaultMessage: "An error occurred while attempting to sign up: {error}. Please try again or reach out to Atlassian Support.",
                    values: {
                        error: error
                    }
                });
        }
    };
    const renderWhiteboxFooter = ()=>{
        return /*#__PURE__*/ (0, $6CtE1.jsx)("a", {
            id: "changepassword-selfservice-link",
            href: (0, $5pCRv.SELF_SERVICE_LINK_URL),
            onClick: ()=>analyticsClient.linkClickedEvent($c883c8d2d10d7182$var$pageId, 'stillHavingTroubleLogin'),
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "changepassword.self.service",
                defaultMessage: "Still having trouble logging in?"
            })
        });
    };
    const renderFooter = ()=>{
        return /*#__PURE__*/ (0, $6CtE1.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.SupportLink), {})
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $idMOo.default), {}),
                /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.UserNoticeLink), {
                        isMobileLink: false
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $idMOo.default), {}),
                /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.PrivacyPolicyLink), {
                        isMobileLink: false
                    })
                })
            ]
        });
    };
    const handlePasswordChange = (0, $dNMDr.useCallback)((e)=>{
        setPassword(e.currentTarget.value);
    }, [
        setPassword
    ]);
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const handleSubmit = (0, $dNMDr.useCallback)((e)=>{
        e.preventDefault();
        const { signature: signature, message: message } = query;
        analyticsClient.buttonClickedEvent($c883c8d2d10d7182$var$pageId, 'continueToSetNewPassword', {
            origin: $c883c8d2d10d7182$var$chooseAnalyticsEventName(message)
        });
        dispatch((0, $bQ3TY.requestChangePassword)({
            signature: signature || '',
            csrfToken: csrfToken,
            password: password,
            resetType: $c883c8d2d10d7182$var$chooseChangePasswordType(message),
            microbranding: (0, $fcxz7.getMicrobrandingFromUrl)(location),
            intl: intl,
            analyticsClient: analyticsClient
        }, navigate));
    }, [
        query,
        analyticsClient,
        dispatch,
        csrfToken,
        password,
        location,
        intl,
        navigate
    ]);
    const { formatMessage: formatMessage } = intl;
    const { message: message } = query;
    const title = formatMessage($c883c8d2d10d7182$var$chooseTitle(message));
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: $c883c8d2d10d7182$var$pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            size: "small",
            as: "h1",
            children: title
        }),
        footer: renderFooter(),
        whiteboxFooter: renderWhiteboxFooter(),
        children: [
            (message === 'security_wasme_reset' || message === 'security_wasnotme_reset') && /*#__PURE__*/ (0, $6CtE1.jsx)($c883c8d2d10d7182$var$SecurityContainer, {}),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                title: formatMessage($c883c8d2d10d7182$var$chooseTitle(message))
            }),
            error && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gre8I.SectionError), {
                children: renderPasswordChangeError(error)
            }),
            message === 'security_wasme_reset' && /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                id: "security-wasme-reset-message",
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changepassword.security.wasme.reset.paragraph.xml",
                    defaultMessage: "<p>Thanks for helping us keep your account secure.</p><p>To prevent unauthorized access to your account, your password has been invalidated.</p><p>Create a new, unique password to access your account:</p><p-email>{email}</p-email>",
                    values: {
                        email: email,
                        p: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("p", {
                                children: chunks
                            }),
                        'p-email': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("p", {
                                style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                                    children: chunks
                                })
                            })
                    }
                })
            }),
            message === 'security_wasnotme_reset' && /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                id: "security-wasnotme-reset-message",
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "changepassword.security.wasnotme.reset.paragraph.xml",
                    defaultMessage: "<p>To prevent unauthorized access to your account, your password has been invalidated.</p><p>Create a new, unique password to access your account: </p><p-email>{email}</p-email>",
                    values: {
                        email: email,
                        p: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("p", {
                                children: chunks
                            }),
                        'p-email': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("p", {
                                style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                                    children: chunks
                                })
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)($c883c8d2d10d7182$var$Form, {
                autoComplete: "on",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6i4Wm.default), {
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ckdYh.default), {
                                id: "password",
                                testId: "password" // used in pollinators
                                ,
                                name: "password",
                                autoComplete: "new-password",
                                "aria-describedby": (0, $7Xy0r.passwordStrengthMessageId),
                                placeholder: formatMessage((0, $1GshQ.default).passwordPlaceholder),
                                label: formatMessage((0, $1GshQ.default).passwordLabel),
                                isInvalid: !!translatedPasswordFieldError,
                                invalidMessage: translatedPasswordFieldError,
                                onChange: handlePasswordChange,
                                value: password,
                                ref: passwordInputRef,
                                smallPlaceholder: true
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7Xy0r.PasswordStrengthMeter), {
                                password: password,
                                email: email,
                                displayName: displayName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                        appearance: "primary",
                        id: "change-password",
                        type: "submit",
                        isFullWidth: true,
                        isLoading: isLoading,
                        children: formatMessage($c883c8d2d10d7182$var$chooseButtonText(message))
                    })
                ]
            })
        ]
    });
};
var $c883c8d2d10d7182$export$2e2bcd8739ae039 = $c883c8d2d10d7182$export$8ec0fb1e4323236d;

});
parcelRegister("1GshQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28c6ce047b9b7515$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $28c6ce047b9b7515$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    title: {
        id: 'changepassword.title',
        defaultMessage: 'Choose a new password'
    },
    button: {
        id: 'changepassword.button',
        defaultMessage: 'Continue'
    },
    passwordPlaceholder: {
        id: 'changepassword.password.placeholder',
        defaultMessage: 'Enter new password'
    },
    passwordLabel: {
        id: 'changepassword.password.label',
        defaultMessage: 'Password'
    },
    errorMessage: {
        id: 'changepassword.error.message',
        defaultMessage: 'Something went wrong while attempting to change your password. Please try again.'
    },
    emptyPasswordErrorMessage: {
        id: 'changepassword.error.password.empty.message',
        defaultMessage: 'Please enter a password'
    },
    securityResetTitle: {
        id: 'changepassword.security.reset.title',
        defaultMessage: 'Reset your password'
    }
});

});

parcelRegister("ckdYh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29e056242c7a5d7a$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $kvy9X = parcelRequire("kvy9X");

var $fbSBq = parcelRequire("fbSBq");

var $aBYLx = parcelRequire("aBYLx");

var $jhTbl = parcelRequire("jhTbl");

var $dpTxl = parcelRequire("dpTxl");

var $ko1o6 = parcelRequire("ko1o6");
const $29e056242c7a5d7a$export$d25f95f50a0dfdf9 = (0, $fbSBq.default).div`
  padding: 3px;
  margin-left: -1px;
`;
const $29e056242c7a5d7a$var$StyledDiv = (0, $fbSBq.default).div`
  input {
    ${(props)=>props.smallPlaceholder && 'font-size: 14px !important;'}
  }
`;
const $29e056242c7a5d7a$var$PasswordField = (props, ref)=>{
    const inputRef = (0, $dNMDr.useRef)(null);
    const [type, setType] = (0, $dNMDr.useState)('password');
    (0, $dNMDr.useImperativeHandle)(ref, ()=>inputRef.current, []);
    const handleVisibilityToggle = ()=>{
        setType(type === 'password' ? 'text' : 'password');
        inputRef.current?.focus();
    };
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    return /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
        children: /*#__PURE__*/ (0, $6CtE1.jsx)($29e056242c7a5d7a$var$StyledDiv, {
            smallPlaceholder: props.smallPlaceholder,
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kvy9X.default), {
                ...props,
                type: type,
                autoComplete: type === 'password' ? props.autoComplete || 'off' : 'off',
                spellCheck: false,
                ref: inputRef,
                elemAfterInput: /*#__PURE__*/ (0, $6CtE1.jsx)($29e056242c7a5d7a$export$d25f95f50a0dfdf9, {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dpTxl.default), {
                        appearance: "subtle",
                        icon: type === 'text' ? (0, (/*@__PURE__*/$parcel$interopDefault($jhTbl))) : (0, (/*@__PURE__*/$parcel$interopDefault($aBYLx))),
                        label: type === 'text' ? formatMessage({
                            id: 'password.field.password.hide',
                            defaultMessage: 'Hide password'
                        }) : formatMessage({
                            id: 'password.field.password.show',
                            defaultMessage: 'Show password'
                        }),
                        onClick: handleVisibilityToggle
                    })
                })
            })
        })
    });
};
var $29e056242c7a5d7a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).forwardRef($29e056242c7a5d7a$var$PasswordField);

});
parcelRegister("aBYLx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b9c7ee406b92c59$var$_react = $7b9c7ee406b92c59$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $gsWOv = parcelRequire("gsWOv");

var $7b9c7ee406b92c59$var$_eyeOpen = $7b9c7ee406b92c59$var$_interopRequireDefault((parcelRequire("7ZQWN")));
function $7b9c7ee406b92c59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7b9c7ee406b92c59$var$WatchIcon = (props)=>/*#__PURE__*/ $7b9c7ee406b92c59$var$_react.default.createElement($gsWOv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.978 13.984c-1.104 0-2-.897-2-2s.896-2 2-2c1.103 0 2 .897 2 2s-.897 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.793 4 4 4 4-1.794 4-4-1.794-4-4-4"/></g></svg>`
    }, props, {
        newIcon: $7b9c7ee406b92c59$var$_eyeOpen.default
    }));
$7b9c7ee406b92c59$var$WatchIcon.displayName = 'WatchIcon';
var $7b9c7ee406b92c59$var$_default = module.exports.default = $7b9c7ee406b92c59$var$WatchIcon;

});
parcelRegister("7ZQWN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d274d283cda20b9$var$_react = $5d274d283cda20b9$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $5d274d283cda20b9$var$_baseNew = $5d274d283cda20b9$var$_interopRequireDefault((parcelRequire("9LaLF")));
function $5d274d283cda20b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d274d283cda20b9$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $5d274d283cda20b9$var$_react.default.createElement($5d274d283cda20b9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$5d274d283cda20b9$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $5d274d283cda20b9$var$_default = module.exports.default = $5d274d283cda20b9$var$EyeOpenIcon;

});


parcelRegister("jhTbl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0aa68d92b3d6074$var$_react = $e0aa68d92b3d6074$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $gsWOv = parcelRequire("gsWOv");

var $e0aa68d92b3d6074$var$_eyeOpenFilled = $e0aa68d92b3d6074$var$_interopRequireDefault((parcelRequire("jygXE")));
function $e0aa68d92b3d6074$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e0aa68d92b3d6074$var$WatchFilledIcon = (props)=>/*#__PURE__*/ $e0aa68d92b3d6074$var$_react.default.createElement($gsWOv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.983 15.984a4.005 4.005 0 0 1-4.002-4c0-2.206 1.795-4 4.002-4a4.005 4.005 0 0 1 4.002 4c0 2.206-1.795 4-4.002 4M12 4C6.48 4 2 8.84 2 12c0 3.086 4.577 8 10 8s10-4.914 10-8c0-3.16-4.481-8-10-8"/><circle cx="12" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $e0aa68d92b3d6074$var$_eyeOpenFilled.default
    }));
$e0aa68d92b3d6074$var$WatchFilledIcon.displayName = 'WatchFilledIcon';
var $e0aa68d92b3d6074$var$_default = module.exports.default = $e0aa68d92b3d6074$var$WatchFilledIcon;

});
parcelRegister("jygXE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::895be44c60961cd5e7ff3bf0ce94ca85>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03ac5c48098d3927$var$_react = $03ac5c48098d3927$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $03ac5c48098d3927$var$_baseNew = $03ac5c48098d3927$var$_interopRequireDefault((parcelRequire("9LaLF")));
function $03ac5c48098d3927$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watched pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03ac5c48098d3927$var$EyeOpenFilledIcon = (props)=>/*#__PURE__*/ $03ac5c48098d3927$var$_react.default.createElement($03ac5c48098d3927$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M8 2C4.433 2 1.319 4.232.167 7.38c-.146.4-.146.84 0 1.24C1.32 11.768 4.433 14 8 14c3.566 0 6.681-2.232 7.833-5.38.146-.4.146-.84 0-1.24C14.68 4.232 11.566 2 8 2m0 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>`
    }, props));
$03ac5c48098d3927$var$EyeOpenFilledIcon.displayName = 'EyeOpenFilledIcon';
var $03ac5c48098d3927$var$_default = module.exports.default = $03ac5c48098d3927$var$EyeOpenFilledIcon;

});



parcelRegister("7Xy0r", function(module, exports) {

$parcel$export(module.exports, "passwordStrengthMessageId", function () { return $a27f1cd212a1227d$export$2609c3dd954de874; });
$parcel$export(module.exports, "PasswordStrengthMeter", function () { return $a27f1cd212a1227d$export$eebfb7c0549090; });
/* PasswordStrengthMeter.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable react/no-unknown-property */ 
var $6CtE1 = parcelRequire("6CtE1");

var $grvIM = parcelRequire("grvIM");

var $dNMDr = parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $l4KzN = parcelRequire("l4KzN");

var $fZRrO = parcelRequire("fZRrO");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $fRDIL = parcelRequire("fRDIL");

var $iRhvt = parcelRequire("iRhvt");

var $eyunW = parcelRequire("eyunW");
var $bNVXQ = parcelRequire("bNVXQ");
const $a27f1cd212a1227d$var$barWidths = [
    '0%',
    '20%',
    '40%',
    '60%',
    '80%',
    '100%'
];
const $a27f1cd212a1227d$var$Wrapper = (0, $fbSBq.default).div`
  margin-bottom: ${"var(--ds-space-100, 8px)"};
`;
const $a27f1cd212a1227d$var$textStyles = null;
const $a27f1cd212a1227d$export$2609c3dd954de874 = 'password-strength-meter';
const $a27f1cd212a1227d$var$Bar = (0, $fbSBq.default).div`
  background: ${"var(--ds-border, #0B120E24)"};
  height: 2px;
  margin-top: 5px;
  position: relative;

  &::before {
    background: ${(props)=>props.score === null ? "var(--ds-border, #0B120E24)" : $a27f1cd212a1227d$var$barColours[props.score]};
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    top: 0;
    transition: all 0.2s ease-out;
    width: ${(props)=>props.score === null ? 0 : $a27f1cd212a1227d$var$barWidths[props.score]};
  }
`;
const $a27f1cd212a1227d$var$barColours = [
    "var(--ds-border, #0B120E24)",
    (0, $l4KzN).R500,
    (0, $l4KzN).R300,
    (0, $l4KzN).Y300,
    (0, $l4KzN).G300,
    (0, $l4KzN).G400
];
const $a27f1cd212a1227d$var$Container = (props)=>/*#__PURE__*/ (0, $6CtE1.jsx)($a27f1cd212a1227d$var$Wrapper, {
        children: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $eyunW.default), {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)($a27f1cd212a1227d$var$Bar, {
                    score: props.score,
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)($a27f1cd212a1227d$var$Dividers, {})
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                    role: "status",
                    children: props.title && /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $eyunW.default), {
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $iRhvt.default), {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    id: "password.strength.accessibility.hint",
                                    defaultMessage: "Password strength: ",
                                    description: "Text that precedes the password strength hint. Hidden except for screen reader users."
                                })
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)("span", {
                                id: $a27f1cd212a1227d$export$2609c3dd954de874,
                                className: (0, $grvIM.default)([
                                    "_y3gn1h6o _p0ov18aq"
                                ]),
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $bNVXQ.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    align: "center",
                                    children: props.title
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
const $a27f1cd212a1227d$var$Dividers = (0, $fbSBq.default).span`
  border-left: 5px solid #fff;
  border-right: 5px solid #fff;
  bottom: 0;
  left: 19%;
  position: absolute;
  right: 19%;
  top: 0;

  &::after {
    border-left: 5px solid #fff;
    border-right: 5px solid #fff;
    bottom: 0;
    content: '';
    left: 30%;
    position: absolute;
    right: 30%;
    top: 0;
  }
`;
const $a27f1cd212a1227d$export$eebfb7c0549090 = ({ displayName: displayName, email: email, i18nLevels: i18nLevels, i18nNoValue: i18nNoValue, i18nNoZxcvbn: i18nNoZxcvbn, password: password })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const strengthLevelMessages = (0, $dNMDr.useMemo)(()=>i18nLevels || [
            (0, $fZRrO.default).passwordStrengthMinimumRequirement,
            (0, $fZRrO.default).passwordStrengthLevel1,
            (0, $fZRrO.default).passwordStrengthLevel2,
            (0, $fZRrO.default).passwordStrengthLevel3,
            (0, $fZRrO.default).passwordStrengthLevel4,
            (0, $fZRrO.default).passwordStrengthLevel5
        ].map((message)=>formatMessage(message)), [
        formatMessage,
        i18nLevels
    ]);
    const noValueMessage = i18nNoValue || formatMessage((0, $fZRrO.default).passwordStrengthMinimumRequirement);
    const noZxcvbnMessage = i18nNoZxcvbn || formatMessage((0, $fZRrO.default).passwordStrengthUnavailable);
    const { score: score } = (0, $fRDIL.usePasswordScore)({
        displayName: displayName,
        email: email,
        password: password
    });
    const getStrengthText = ()=>{
        if (!password) return noValueMessage;
        else if (password.length < 8) return strengthLevelMessages[0];
        else if (password === email) return formatMessage((0, $fZRrO.default).passwordStrengthCantMatchEmail);
        else if (password === displayName) return formatMessage((0, $fZRrO.default).passwordStrengthCantMatchDisplayName);
        else if ((0, $fRDIL.atlassianKeywords).includes(password)) return formatMessage((0, $fZRrO.default).passwordStrengthCantMatchAtlassianKeyword);
        else return typeof score === 'number' ? strengthLevelMessages[score] : noZxcvbnMessage;
    };
    return /*#__PURE__*/ (0, $6CtE1.jsx)($a27f1cd212a1227d$var$Container, {
        title: getStrengthText(),
        score: score
    });
};

});
parcelRegister("fZRrO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74037bc65bad0eeb$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $74037bc65bad0eeb$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    passwordStrengthAccessibilityHint: {
        id: 'password.strength.accessibility.hint',
        defaultMessage: 'Password strength:'
    },
    passwordStrengthMinimumRequirement: {
        id: 'password.strength.level.minimum',
        defaultMessage: 'Password must have at least 8 characters'
    },
    passwordStrengthLevel1: {
        id: 'password.strength.level.1',
        defaultMessage: 'Weak'
    },
    passwordStrengthLevel2: {
        id: 'password.strength.level.2',
        defaultMessage: 'Fair'
    },
    passwordStrengthLevel3: {
        id: 'password.strength.level.3',
        defaultMessage: 'Good'
    },
    passwordStrengthLevel4: {
        id: 'password.strength.level.4',
        defaultMessage: 'Strong'
    },
    passwordStrengthLevel5: {
        id: 'password.strength.level.5',
        defaultMessage: 'Very strong'
    },
    passwordStrengthUnavailable: {
        id: 'password.strength.unavailable',
        defaultMessage: 'Password strength unavailable'
    },
    passwordStrengthCantMatchEmail: {
        id: 'password.strength.cant.match.email',
        defaultMessage: "Password can't match email address"
    },
    passwordStrengthCantMatchDisplayName: {
        id: 'password.strength.cant.match.display.name',
        defaultMessage: "Password can't match display name"
    },
    passwordStrengthCantMatchAtlassianKeyword: {
        id: 'password.strength.cant.match.atlassian.keyword',
        defaultMessage: "Password can't match Atlassian keyword"
    },
    weakPasswordAdvice: {
        id: 'password.strength.weak.advice',
        defaultMessage: 'Avoid common phrases or try adding more characters',
        description: 'Advice given to users when their password is weak'
    },
    weakPassword: {
        id: 'password.strength.weak',
        defaultMessage: 'Weak password',
        description: "Message shown below a user's password entry to indicate it is weak"
    },
    fairPassword: {
        id: 'password.strength.fair',
        defaultMessage: 'Fair password',
        description: "Message shown below a user's password entry to indicate it is a fair strength"
    },
    goodPassword: {
        id: 'password.strength.good',
        defaultMessage: 'Good password',
        description: "Message shown below a user's password entry to indicate it is a good strength"
    },
    strongPassword: {
        id: 'password.strength.strong',
        defaultMessage: 'Strong password',
        description: "Message shown below a user's password entry to indicate it is strong"
    },
    veryStrongPassword: {
        id: 'password.strength.veryStrong',
        defaultMessage: 'Very strong password',
        description: "Message shown below a user's password entry to indicate it is very strong"
    }
});

});

parcelRegister("fRDIL", function(module, exports) {

$parcel$export(module.exports, "atlassianKeywords", function () { return $d655792fab7b6233$export$d1feeaf01c705d52; });
$parcel$export(module.exports, "usePasswordScore", function () { return $d655792fab7b6233$export$d135f8f04a83150a; });
/* usePasswordScore.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable react/no-unknown-property */ 
var $dNMDr = parcelRequire("dNMDr");

var $3n1na = parcelRequire("3n1na");
const $d655792fab7b6233$var$SPLITTER = /\W+/;
const $d655792fab7b6233$export$d1feeaf01c705d52 = [
    'atlassian',
    'bitbucket',
    'confluence',
    'jira',
    'opsgenie',
    'statuspage',
    'trello'
];
const $d655792fab7b6233$export$d135f8f04a83150a = ({ displayName: displayName, email: email, password: password })=>{
    const zxcvbn = (0, $3n1na.useZxcvbn)();
    const scoreWords = (0, $dNMDr.useMemo)(()=>{
        return $d655792fab7b6233$export$9e2ea7bf181a4f5([
            email,
            displayName,
            ...$d655792fab7b6233$export$d1feeaf01c705d52
        ]);
    }, [
        displayName,
        email
    ]);
    const zxcvbnResult = (0, $dNMDr.useMemo)(()=>{
        return zxcvbn && password ? zxcvbn(password, scoreWords) : null;
    }, [
        zxcvbn,
        password,
        scoreWords
    ]);
    const score = (0, $dNMDr.useMemo)(()=>{
        if (password.length < 8 || [
            email,
            displayName,
            ...$d655792fab7b6233$export$d1feeaf01c705d52
        ].includes(password)) return 0;
        else {
            const baseScore = zxcvbnResult?.score;
            return typeof baseScore === 'number' ? baseScore + 1 : null;
        }
    }, [
        password,
        displayName,
        email,
        zxcvbnResult
    ]);
    return {
        score: score
    };
};
const $d655792fab7b6233$var$addUnique = (seen, chunk)=>seen.includes(chunk) ? seen : [
        ...seen,
        chunk
    ];
function $d655792fab7b6233$export$9e2ea7bf181a4f5(strings) {
    const deduped = strings.reduce($d655792fab7b6233$var$addUnique, []);
    return deduped.reduce((arr, str)=>str.split($d655792fab7b6233$var$SPLITTER).reduce($d655792fab7b6233$var$addUnique, arr), deduped);
}

});
parcelRegister("3n1na", function(module, exports) {

$parcel$export(module.exports, "useZxcvbn", function () { return $48157458a288fc42$export$edb73e506c7a3f1d; });

var $dNMDr = parcelRequire("dNMDr");

var $hqddj = parcelRequire("hqddj");

function $48157458a288fc42$export$edb73e506c7a3f1d() {
    const [zxcvbn, setZxcvbn] = (0, $dNMDr.useState)();
    (0, $dNMDr.useEffect)(()=>{
        let isMounted = true;
        // asynchronously imported as package is very large
        (parcelRequire("i5jM5")).then((zxcvbn)=>{
            if (isMounted) setZxcvbn(()=>{
                /**
             * We have this divergence since we use Webpack for Jest testing and Parcel for dev/prod.
             * Webpack dynamic import returns: { default: fn }
             * Parcel dynamic import returns: fn
             * Why can't we use Parcel for Jest? See: https://parceljs.org/languages/javascript/#usage-with-other-tools
             */ return typeof zxcvbn === 'function' ? zxcvbn : zxcvbn.default;
            });
        }).catch((e)=>{
            (0, $hqddj.captureErrorMessage)('Error while importing zxcvbn library', e);
            setZxcvbn(undefined);
        });
        return ()=>{
            isMounted = false;
        };
    }, []);
    return zxcvbn;
}

});
parcelRegister("i5jM5", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("hAw8i")).then(()=>parcelRequire('lL0wG'));

});



parcelRegister("eyunW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a98bcf8831b48390$export$2e2bcd8739ae039; });

var $62ppy = parcelRequire("62ppy");

var $dNMDr = parcelRequire("dNMDr");

var $8Govx = parcelRequire("8Govx");

var $d433K = parcelRequire("d433K");

var $4JRmj = parcelRequire("4JRmj");
var $a98bcf8831b48390$var$flexGrowMap = {
    hug: (0, $d433K.xcss)({
        flexGrow: 0
    }),
    fill: (0, $d433K.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $a98bcf8831b48390$var$Stack = /*#__PURE__*/ (0, $dNMDr.memo)(/*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, id = _ref.id;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $a98bcf8831b48390$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $8Govx.jsx)((0, $4JRmj.default), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$a98bcf8831b48390$var$Stack.displayName = 'Stack';
var $a98bcf8831b48390$export$2e2bcd8739ae039 = $a98bcf8831b48390$var$Stack;

});

parcelRegister("bNVXQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89813bc8e2a8fbba$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $8Govx = parcelRequire("8Govx");

var $3kWa2 = parcelRequire("3kWa2");

var $2m42R = parcelRequire("2m42R");

var $crcLK = parcelRequire("crcLK");

var $hnZEJ = parcelRequire("hnZEJ");
var $89813bc8e2a8fbba$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $89813bc8e2a8fbba$var$resetStyles = (0, $8Govx.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $89813bc8e2a8fbba$var$strongStyles = (0, $8Govx.css)({
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
var $89813bc8e2a8fbba$var$emStyles = (0, $8Govx.css)({
    fontStyle: 'italic'
});
var $89813bc8e2a8fbba$var$textAlignMap = {
    center: (0, $8Govx.css)({
        textAlign: 'center'
    }),
    end: (0, $8Govx.css)({
        textAlign: 'end'
    }),
    start: (0, $8Govx.css)({
        textAlign: 'start'
    })
};
var $89813bc8e2a8fbba$var$truncationStyles = (0, $8Govx.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $89813bc8e2a8fbba$var$wordBreakMap = {
    breakAll: (0, $8Govx.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $89813bc8e2a8fbba$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $crcLK.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $hnZEJ.inverseColorMap).hasOwnProperty(surface)) return (0, $hnZEJ.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $89813bc8e2a8fbba$var$Text = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $3kWa2.default)($89813bc8e2a8fbba$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $2m42R.useHasTextAncestor)();
    var color = $89813bc8e2a8fbba$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $8Govx.jsx)(Component, {
        ref: ref,
        css: [
            $89813bc8e2a8fbba$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $hnZEJ.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $hnZEJ.textColorStylesMap)[color],
            maxLines && $89813bc8e2a8fbba$var$truncationStyles,
            maxLines === 1 && $89813bc8e2a8fbba$var$wordBreakMap.breakAll,
            align && $89813bc8e2a8fbba$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $hnZEJ.textWeightStylesMap)[weight],
            Component === 'em' && $89813bc8e2a8fbba$var$emStyles,
            Component === 'strong' && $89813bc8e2a8fbba$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $8Govx.jsx)((0, $2m42R.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $89813bc8e2a8fbba$export$2e2bcd8739ae039 = $89813bc8e2a8fbba$var$Text;

});
parcelRegister("2m42R", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", function () { return $1b70c61d523bc0d8$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $1b70c61d523bc0d8$export$ae933c6cbe5643ad; });

var $dNMDr = parcelRequire("dNMDr");
var $1b70c61d523bc0d8$var$HasTextAncestorContext = /*#__PURE__*/ (0, $dNMDr.createContext)(false);
var $1b70c61d523bc0d8$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $dNMDr.useContext)($1b70c61d523bc0d8$var$HasTextAncestorContext);
};
var $1b70c61d523bc0d8$export$ae933c6cbe5643ad = $1b70c61d523bc0d8$var$HasTextAncestorContext.Provider;

});



parcelRegister("bQ3TY", function(module, exports) {

$parcel$export(module.exports, "requestChangePassword", function () { return $25d2d113a16ef495$export$5f18b9a6eb1df9f8; });

var $1JRGy = parcelRequire("1JRGy");

var $bXVRR = parcelRequire("bXVRR");

var $1GshQ = parcelRequire("1GshQ");

var $hqddj = parcelRequire("hqddj");
const $25d2d113a16ef495$export$b7b281ad44bfa6c7 = ()=>({
        type: 'CHANGE_PASSWORD_REQUEST_INITIATE'
    });
const $25d2d113a16ef495$export$592a066e988f52df = ()=>({
        type: 'CHANGE_PASSWORD_REQUEST_SUCCESS'
    });
const $25d2d113a16ef495$export$a60289eb7ee45981 = (error)=>({
        type: 'CHANGE_PASSWORD_REQUEST_FAILED',
        error: error
    });
const $25d2d113a16ef495$export$ff1769767bfc512b = (fieldErrors)=>({
        type: 'CHANGE_PASSWORD_REQUEST_FIELD_ERRORS',
        fieldErrors: fieldErrors
    });
const $25d2d113a16ef495$export$5f18b9a6eb1df9f8 = (requestParams, navigate)=>(dispatch)=>{
        const changePasswordAnalyticsError = {
            passwordCaseError: 'passwordResetDoesntMeetPolicy',
            passwordDigitOrSpecialError: 'passwordResetDoesntMeetPolicy',
            passwordLengthError: 'passwordResetDoesntMeetPolicy',
            passwordUsedBefore: 'passwordResetPreviouslyUsed',
            passwordLeaked: 'passwordLeaked',
            passwordCommon: 'passwordCommon',
            invalidPassword: 'invalidPassword',
            unexpectedError: 'passwordResetUnexpectedError',
            passwordStrengthErrorWeak: 'passwordResetDoesntMeetPolicy',
            passwordStrengthErrorFair: 'passwordResetDoesntMeetPolicy',
            passwordStrengthErrorGood: 'passwordResetDoesntMeetPolicy',
            passwordStrengthErrorStrong: 'passwordResetDoesntMeetPolicy',
            passwordStrengthErrorVeryStrong: 'passwordResetDoesntMeetPolicy'
        };
        const { signature: signature, password: password, resetType: resetType, csrfToken: csrfToken, microbranding: microbranding, intl: intl, analyticsClient: analyticsClient } = requestParams;
        const qs = microbranding && Object.keys(microbranding).length ? `?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(microbranding)}` : '';
        dispatch($25d2d113a16ef495$export$b7b281ad44bfa6c7());
        if (!password) {
            const message = intl.formatMessage((0, $1GshQ.default).emptyPasswordErrorMessage);
            dispatch($25d2d113a16ef495$export$ff1769767bfc512b({
                password: message
            }));
            return Promise.resolve();
        }
        const request = {
            password: password,
            resetType: resetType,
            signature: signature
        };
        return fetch(`/rest/changepassword${qs}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(request)
        }).then((response)=>response.json()).then((response)=>{
            if (response.redirectTo !== undefined) {
                dispatch($25d2d113a16ef495$export$592a066e988f52df());
                navigate(response.redirectTo);
            } else {
                const { csrfToken: csrfToken, uiErrors: uiErrors, fieldErrors: fieldErrors } = response;
                // SIS doesn't set a new CSRF token on every request (like aid-signup does), and so it
                // doesn't return one. We need to handle both cases though.
                if (csrfToken) dispatch((0, $bXVRR.updateCsrfToken)(csrfToken));
                if (uiErrors && uiErrors.length) {
                    const subjectId = changePasswordAnalyticsError[uiErrors[0].key] || 'passwordResetUnknownUiError';
                    analyticsClient.errorShownEvent('accountRecoveryScreen', subjectId);
                    dispatch($25d2d113a16ef495$export$a60289eb7ee45981(uiErrors[0].key));
                }
                if (Object.entries(fieldErrors).length) dispatch($25d2d113a16ef495$export$ff1769767bfc512b(fieldErrors));
            }
        }).catch((error)=>{
            dispatch($25d2d113a16ef495$export$a60289eb7ee45981('unknown'));
            (0, $hqddj.captureErrorMessage)('Change password failed', error);
        });
    };

});
parcelRegister("bXVRR", function(module, exports) {

$parcel$export(module.exports, "updateCsrfToken", function () { return $6d596af1c297485e$export$527f2c21586e0a0e; });
const $6d596af1c297485e$export$527f2c21586e0a0e = (csrfToken)=>({
        type: 'CSRF_TOKEN_UPDATE',
        csrfToken: csrfToken
    });
const $6d596af1c297485e$export$32d195f109b250f4 = (hashedCsrfToken)=>({
        type: 'HASHED_CSRF_TOKEN_UPDATE',
        hashedCsrfToken: hashedCsrfToken
    });

});


parcelRegister("gre8I", function(module, exports) {

$parcel$export(module.exports, "FormErrorWrapper", function () { return $041f1b76a1537a56$export$21ea266f0fa7d7c3; });
$parcel$export(module.exports, "default", function () { return $041f1b76a1537a56$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "SectionError", function () { return $041f1b76a1537a56$export$1142f7f46d50535e; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $kJPFV = parcelRequire("kJPFV");
const $041f1b76a1537a56$export$21ea266f0fa7d7c3 = (0, $fbSBq.default).div`
  margin-bottom: ${(0, $68HQw.gridSize)() * 2}px;
`;
const $041f1b76a1537a56$var$SectionErrorWrapper = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
  margin-bottom: ${(0, $68HQw.gridSize)()}px;
`;
function $041f1b76a1537a56$export$2e2bcd8739ae039({ testId: testId, title: title, children: children, appearance: appearance = 'warning' }) {
    return children ? /*#__PURE__*/ (0, $6CtE1.jsx)($041f1b76a1537a56$export$21ea266f0fa7d7c3, {
        role: "alert",
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kJPFV.default), {
            testId: testId || 'form-error',
            appearance: appearance,
            title: title,
            children: children
        })
    }) : null;
}
function $041f1b76a1537a56$export$1142f7f46d50535e({ id: id, testId: testId, title: title, children: children }) {
    return children ? /*#__PURE__*/ (0, $6CtE1.jsx)($041f1b76a1537a56$var$SectionErrorWrapper, {
        id: id,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kJPFV.default), {
            testId: testId || 'form-error',
            appearance: "warning",
            title: title,
            children: children
        })
    }) : null;
}

});

parcelRegister("4yl6n", function(module, exports) {

$parcel$export(module.exports, "useTranslateFormErrorIfAvailable", function () { return $55e647f844ad29ee$export$61b698e3c147347c; });

var $2CYmK = parcelRequire("2CYmK");
var $ko1o6 = parcelRequire("ko1o6");

var $dNMDr = parcelRequire("dNMDr");
const $55e647f844ad29ee$export$61b698e3c147347c = (formError)=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const message = (0, $dNMDr.useMemo)(()=>Object.values($55e647f844ad29ee$var$formValidationMessages).find(({ id: id })=>id === formError), [
        formError
    ]);
    if (message) return formatMessage(message);
    else return formError;
};
const $55e647f844ad29ee$var$formValidationMessages = (0, $2CYmK.defineMessages)({
    unknownError: {
        id: 'com.atlassian.profile.unknownError',
        defaultMessage: 'An unknown error occurred'
    },
    errorRequiredField: {
        id: 'error.required',
        defaultMessage: 'This field is required'
    },
    loginFormNoPassword: {
        id: 'login.form.no.password',
        defaultMessage: 'Enter your password'
    },
    loginFormPasswordTooLong: {
        id: 'login.form.password.too.long',
        defaultMessage: 'Password length capped at 100 characters'
    },
    loginFormPasswordTooShort: {
        id: 'login.form.password.too.short',
        defaultMessage: 'The password is too short.'
    },
    resetPasswordGenericError: {
        id: 'resetPassword.error',
        defaultMessage: 'An error occurred while attempting to reset your password.'
    },
    resetPasswordEmailFormatError: {
        id: 'requestPasswordReset.email.format.error',
        defaultMessage: 'Please enter a valid email address'
    },
    signupDisplayNameEmpty: {
        id: 'signup.display.name.empty',
        defaultMessage: 'Full name must not be empty'
    },
    signupDisplayNameTooLong: {
        id: 'signup.display.name.too.long',
        defaultMessage: 'Full name must not be greater than 255 characters'
    },
    signupEmailFormatError: {
        id: 'signup.email.format.error',
        defaultMessage: 'Email is required to be in correct format'
    },
    signupEmailReachedMaxAliases: {
        id: 'signup.email.reached.max.aliases',
        defaultMessage: 'Email aliases are rate limited'
    },
    signupEmailRestrictedDomain: {
        id: 'signup.email.restricted.domain.error',
        defaultMessage: 'The provided email address is not allowed, please use a different one'
    },
    signupEmailBansNotAllowed: {
        id: 'signup.email.bans.not.allowed',
        defaultMessage: 'The provided email address is not allowed, please use a different one'
    },
    signupGenericFailure: {
        id: 'signup.failure',
        defaultMessage: 'We are unable to sign you up. Please contact support.'
    },
    signupCaptchaResponseError: {
        id: 'signup.captcha.response.required.error',
        defaultMessage: "Are you sure you're not a robot?"
    }
});

});


parcelRegister("kabQ0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "pageId", function () { return $53e3b21e36747eae$export$703ba2e7ea526c1b; });
$parcel$export(module.exports, "socialRecoveryLoader", function () { return $53e3b21e36747eae$export$5e59ec17884bc552; });
$parcel$export(module.exports, "SocialLoginRecoveryPage", function () { return $53e3b21e36747eae$export$ee564d35600efee8; });
$parcel$export(module.exports, "default", function () { return $53e3b21e36747eae$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $1JRGy = parcelRequire("1JRGy");

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $fcxz7 = parcelRequire("fcxz7");

var $Q6OOA = parcelRequire("Q6OOA");

var $8Cc4v = parcelRequire("8Cc4v");

var $4txQf = parcelRequire("4txQf");

var $2byD0 = parcelRequire("2byD0");

var $79HVl = parcelRequire("79HVl");

var $cuZAx = parcelRequire("cuZAx");

var $4NPio = parcelRequire("4NPio");

var $aMBBA = parcelRequire("aMBBA");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");

var $h4v4M = parcelRequire("h4v4M");
const $53e3b21e36747eae$var$Image = (0, $fbSBq.default).img`
  margin: ${(0, $68HQw.gridSize)()}px auto ${(0, $68HQw.gridSize)()}px;
  width: 100px;
`;
const $53e3b21e36747eae$var$Messsage = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
  overflow-wrap: break-word;
`;
const $53e3b21e36747eae$var$ErrorMesssage = (0, $fbSBq.default)($53e3b21e36747eae$var$Messsage)`
  text-align: center;
`;
const $53e3b21e36747eae$var$ExpectedEmailWrapper = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)() * 0.75}px;
  font-weight: bold;
`;
const $53e3b21e36747eae$export$703ba2e7ea526c1b = 'atlassianAccountSocialLoginRecoveryScreen';
async function $53e3b21e36747eae$export$5e59ec17884bc552({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/social/recovery/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-subgroup--social-login'
        ]
    });
}
const $53e3b21e36747eae$export$ee564d35600efee8 = ()=>{
    const product = (0, $dNMDr.useMemo)(()=>{
        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(window.location.search);
        return queryParams.application && (0, $fcxz7.applicationsMetadata)[queryParams.application];
    }, []);
    const { error: error, expectedEmail: expectedEmail, foundEmail: foundEmail, recoveryUrl: recoveryUrl } = (0, $aMBBA.useAppSelector)((state)=>state.socialLoginRecovery);
    const isMobileApp = (0, $aMBBA.useAppSelector)((state)=>(0, $cuZAx.isMobileOidc)(state.microbranding.oidcContext) || state.microbranding.isEmbedded);
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    (0, $4NPio.usePageViewedEvent)($53e3b21e36747eae$export$703ba2e7ea526c1b, error && {
        errorCode: error
    });
    const recover = (recoveryUrl)=>{
        analyticsClient.buttonClickedEvent($53e3b21e36747eae$export$703ba2e7ea526c1b, 'tryAgainButton');
        navigate(recoveryUrl.toString());
    };
    const renderWhiteboxFooter = ()=>{
        return isMobileApp ? null : /*#__PURE__*/ (0, $6CtE1.jsx)("a", {
            id: "social-login-recovery-documentation-link",
            target: "_blank",
            rel: "noreferrer noopener",
            onClick: ()=>analyticsClient.linkClickedEvent($53e3b21e36747eae$export$703ba2e7ea526c1b, 'documentationLink'),
            href: "https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-an-incorrect-email-address-error/",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $4txQf.default).documentationLinkMessage
            })
        });
    };
    const renderRecoveryPage = (recoveryUrl, expectedEmail, foundEmail)=>{
        const destinationProduct = product ? product.name : formatMessage((0, $4txQf.default).productFallback);
        return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
            pageId: $53e3b21e36747eae$export$703ba2e7ea526c1b,
            header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $4txQf.default).title,
                tagName: "h5"
            }),
            whiteboxFooter: renderWhiteboxFooter(),
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)($53e3b21e36747eae$var$Image, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8Cc4v))),
                    alt: ""
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)($53e3b21e36747eae$var$Messsage, {
                    children: foundEmail ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $4txQf.default).bodyMessageUnableToLoginWithFoundEmail,
                        values: {
                            product: destinationProduct,
                            foundEmail: foundEmail
                        }
                    }) : /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $4txQf.default).bodyMessageUnableToLoginWithThisEmailAddress,
                        values: {
                            product: destinationProduct
                        }
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsxs)($53e3b21e36747eae$var$Messsage, {
                    children: [
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "social.recovery.body.try.again",
                            defaultMessage: "To continue, select <b>Try again</b> and use",
                            description: `Message instructing the user that they logged in via a social
          provider (eg. Log in with Google) and selected an account that we didn't expect.
          This occurs when we know that we want the user to log in with myemail@gmail.com, but
          in the social provider they log in with otheraccount@gmail.com. They should press the Try again button and use the expected email address.`,
                            values: {
                                b: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                                        children: chunks
                                    })
                            }
                        }),
                        /*#__PURE__*/ (0, $6CtE1.jsx)($53e3b21e36747eae$var$ExpectedEmailWrapper, {
                            children: expectedEmail
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                        appearance: "primary",
                        id: "recovery-button",
                        isFullWidth: true,
                        onClick: ()=>recover(recoveryUrl),
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            ...(0, $4txQf.default).buttonText
                        })
                    })
                })
            ]
        });
    };
    const renderRecoveryError = (error)=>{
        const errorMessage = ()=>{
            switch(error){
                case 'expired_token':
                    return (0, $4txQf.default).expiredTokenErrorMessage;
                case 'future_issued_token':
                case 'invalid_token':
                    return (0, $4txQf.default).tokenErrorMessage;
                default:
                    return (0, $4txQf.default).unknownErrorMessage;
            }
        };
        return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
            pageId: $53e3b21e36747eae$export$703ba2e7ea526c1b,
            header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $4txQf.default).errorTitle,
                tagName: "h5"
            }),
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)($53e3b21e36747eae$var$Image, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8Cc4v))),
                    alt: ""
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)($53e3b21e36747eae$var$ErrorMesssage, {
                    "data-testid": "default-error-message",
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...errorMessage()
                    })
                })
            ]
        });
    };
    if (expectedEmail && recoveryUrl) return renderRecoveryPage(recoveryUrl, expectedEmail, foundEmail);
    else if (error) return renderRecoveryError(error);
    else return renderRecoveryError('unknown_error');
};
var $53e3b21e36747eae$export$2e2bcd8739ae039 = $53e3b21e36747eae$export$ee564d35600efee8;

});
parcelRegister("4txQf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28f20f0e05754500$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $28f20f0e05754500$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    bodyMessageUnableToLoginWithThisEmailAddress: {
        id: 'social.recovery.body.unable.with.this.email.address',
        defaultMessage: "We\u2019re unable to log you in to {product} with this email address.",
        description: `Message describing to the user that when they logged in via a social
      provider (eg. Log in with Google) they selected an account that we didn't expect.
      This occurs when we know that we want the user to log in with myemail@gmail.com, but
      in the social provider they log in with otheraccount@gmail.com.
      If we can't detect the product, we use 'your Atlassian account' as {product}.
      `
    },
    bodyMessageUnableToLoginWithFoundEmail: {
        id: 'social.recovery.body.unable.with.found.email',
        defaultMessage: "We\u2019re unable to log you in to {product} with {foundEmail}.",
        description: `Message describing to the user that when they logged in via a social
      provider (eg. Log in with Google) they selected an account that we didn't expect.
      This occurs when we know that we want the user to log in with myemail@gmail.com, but
      in the social provider they log in with otheraccount@gmail.com.
      If we can't detect the product, we use 'your Atlassian account' as {product}.
      `
    },
    documentationLinkMessage: {
        id: 'social.recovery.documentation.link',
        defaultMessage: 'Get login help',
        description: 'Link to documentation page with help information'
    },
    productFallback: {
        id: 'social.recovery.product-fallback',
        defaultMessage: 'your Atlassian account',
        description: `If we can't determine the product the user is attempting to land on, then we
    will fall back to this value. Usage: We\u{2019}re unable to log you in to your Atlassian account with unexpectedemail@example.com`
    },
    buttonText: {
        id: 'social.recovery.button',
        defaultMessage: 'Try again',
        description: 'Button for user to try log in again.'
    },
    unknownErrorMessage: {
        id: 'social.recovery.error.unknown',
        defaultMessage: 'Try again later.'
    },
    tokenErrorMessage: {
        id: 'social.recovery.error.token-error',
        defaultMessage: "We're unable to service your request. Please try again."
    },
    expiredTokenErrorMessage: {
        id: 'social.recovery.error.token-expired',
        defaultMessage: 'Your session has expired. Please try again.'
    },
    title: {
        id: 'social.recovery.title',
        defaultMessage: 'Try again with another email address'
    },
    errorTitle: {
        id: 'social.recovery.title.error',
        defaultMessage: 'Something went wrong'
    }
});

});


parcelRegister("hADis", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "verifyEmailSentLoader", function () { return $f8b86a47f43a83ce$export$fae024edc929c93e; });
$parcel$export(module.exports, "VerifyOrReverifyEmailSentPage", function () { return $f8b86a47f43a83ce$export$980c3b624c0da509; });
$parcel$export(module.exports, "default", function () { return $f8b86a47f43a83ce$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $4ljBU = parcelRequire("4ljBU");

var $bsMjt = parcelRequire("bsMjt");

var $dGtec = parcelRequire("dGtec");

var $chJxj = parcelRequire("chJxj");

var $aMBBA = parcelRequire("aMBBA");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");
async function $f8b86a47f43a83ce$export$fae024edc929c93e({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/verify-email/sent/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $f8b86a47f43a83ce$export$980c3b624c0da509 = ()=>{
    const verificationType = (0, $aMBBA.useAppSelector)((state)=>state.verifyEmailSent.verificationType);
    return verificationType === (0, $chJxj.VerificationType).Verify ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $bsMjt.default), {}) : /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dGtec.default), {});
};
var $f8b86a47f43a83ce$export$2e2bcd8739ae039 = $f8b86a47f43a83ce$export$980c3b624c0da509;

});

parcelRegister("dWvY5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "verifyEmailLoader", function () { return $8f4408d0546840b7$export$4af04dd5c668b91a; });
$parcel$export(module.exports, "VerifyOrReverifyEmailErrorPage", function () { return $8f4408d0546840b7$export$647c199e9f3e1159; });
$parcel$export(module.exports, "default", function () { return $8f4408d0546840b7$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $chJxj = parcelRequire("chJxj");

var $bZLKS = parcelRequire("bZLKS");

var $8oqIV = parcelRequire("8oqIV");

var $eiYN1 = parcelRequire("eiYN1");

var $aMBBA = parcelRequire("aMBBA");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");
async function $8f4408d0546840b7$export$4af04dd5c668b91a({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/verify-email/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $8f4408d0546840b7$export$647c199e9f3e1159 = ()=>{
    const { error: error, url: url, verificationType: verificationType } = (0, $aMBBA.useAppSelector)((state)=>state.verifyEmail);
    switch(error){
        case (0, $chJxj.VerifyOrReverifyEmailError).ExpiredToken:
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $bZLKS.default), {
                recoverUrl: url,
                verificationType: verificationType
            });
        case (0, $chJxj.VerifyOrReverifyEmailError).InvalidToken:
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eiYN1.default), {
                recoverUrl: url,
                verificationType: verificationType
            });
        case (0, $chJxj.VerifyOrReverifyEmailError).RateLimitExceeded:
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8oqIV.default), {
                recoverUrl: url,
                verificationType: verificationType
            });
        default:
            return null;
    }
};
var $8f4408d0546840b7$export$2e2bcd8739ae039 = $8f4408d0546840b7$export$647c199e9f3e1159;

});
parcelRegister("bZLKS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3be620db958f7f6c$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $Q6OOA = parcelRequire("Q6OOA");

var $3YSXY = parcelRequire("3YSXY");

var $8Cc4v = parcelRequire("8Cc4v");

var $2byD0 = parcelRequire("2byD0");

var $79HVl = parcelRequire("79HVl");

var $fbSBq = parcelRequire("fbSBq");

var $4NPio = parcelRequire("4NPio");

var $h4v4M = parcelRequire("h4v4M");
const $3be620db958f7f6c$var$MessageContainer = (0, $fbSBq.default).div`
  margin-bottom: 24px;
`;
const $3be620db958f7f6c$export$f9171eab4ea79921 = ({ recoverUrl: recoverUrl, verificationType: verificationType })=>{
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const pageId = 'verifyEmailExpiredTokenErrorPage';
    (0, $4NPio.usePageViewedEvent)(pageId, {
        flow: verificationType
    });
    const recover = ()=>{
        analyticsClient.buttonClickedEvent(pageId, 'resendVerificationEmail', {
            flow: verificationType
        });
        navigate(recoverUrl);
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)($3be620db958f7f6c$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "reverify.email.expire.title",
                        defaultMessage: "Resend verification email",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8Cc4v))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "reverify.email.expire.body",
                defaultMessage: "The link to verify your account has expired."
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                    appearance: "primary",
                    id: "reverify.email.expire.button",
                    isFullWidth: true,
                    onClick: recover,
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "reverify.email.expire.button",
                        defaultMessage: "Resend verification email"
                    })
                })
            })
        ]
    });
};
var $3be620db958f7f6c$export$2e2bcd8739ae039 = $3be620db958f7f6c$export$f9171eab4ea79921;

});

parcelRegister("8oqIV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69c915db63773bb7$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $79HVl = parcelRequire("79HVl");

var $3YSXY = parcelRequire("3YSXY");

var $8Cc4v = parcelRequire("8Cc4v");

var $Q6OOA = parcelRequire("Q6OOA");

var $2byD0 = parcelRequire("2byD0");

var $fbSBq = parcelRequire("fbSBq");

var $4NPio = parcelRequire("4NPio");

var $h4v4M = parcelRequire("h4v4M");
const $69c915db63773bb7$var$MessageContainer = (0, $fbSBq.default).div`
  margin-bottom: 24px;
`;
const $69c915db63773bb7$var$pageId = 'reverifyEmailRateLimitExceededErrorPage';
const $69c915db63773bb7$export$1b84bfc67fc5d43a = ({ recoverUrl: recoverUrl, verificationType: verificationType })=>{
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const displayRecoverUrl = (0, $dNMDr.useMemo)(()=>new URL(recoverUrl).hostname, [
        recoverUrl
    ]);
    (0, $4NPio.usePageViewedEvent)($69c915db63773bb7$var$pageId, {
        flow: verificationType
    });
    const recover = ()=>{
        analyticsClient.buttonClickedEvent($69c915db63773bb7$var$pageId, 'backToStartButton', {
            flow: verificationType
        });
        navigate(recoverUrl);
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: $69c915db63773bb7$var$pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)($69c915db63773bb7$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "reverify.email.rate-limit-exceeded.error.title",
                        defaultMessage: "We couldn't verify your email",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8Cc4v))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "reverify.email.rate-limit-exceeded.error.main-action",
                defaultMessage: "There have been too many attempts to reverify your account in the past hour. You'll need to try again later.",
                description: "Telling the user that they have exceeded welcome email limit"
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                    appearance: "primary",
                    id: "go-back-button",
                    isFullWidth: true,
                    onClick: recover,
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "reverify.email.rate-limit-exceeded.error.button-text",
                        defaultMessage: "Go back to {startUrl}",
                        values: {
                            startUrl: displayRecoverUrl
                        }
                    })
                })
            })
        ]
    });
};
var $69c915db63773bb7$export$2e2bcd8739ae039 = $69c915db63773bb7$export$1b84bfc67fc5d43a;

});

parcelRegister("eiYN1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a056958b9b10fbc$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $79HVl = parcelRequire("79HVl");

var $3YSXY = parcelRequire("3YSXY");

var $8Cc4v = parcelRequire("8Cc4v");

var $Q6OOA = parcelRequire("Q6OOA");

var $2byD0 = parcelRequire("2byD0");

var $fbSBq = parcelRequire("fbSBq");

var $4NPio = parcelRequire("4NPio");

var $h4v4M = parcelRequire("h4v4M");
const $1a056958b9b10fbc$var$MessageContainer = (0, $fbSBq.default).div`
  margin-bottom: 24px;
`;
const $1a056958b9b10fbc$export$4ad664360e6dde74 = ({ recoverUrl: recoverUrl, verificationType: verificationType })=>{
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const pageId = 'verifyEmailInvalidTokenErrorPage';
    (0, $4NPio.usePageViewedEvent)(pageId, {
        flow: verificationType
    });
    const recover = ()=>{
        analyticsClient.buttonClickedEvent(pageId, 'startAgain', {
            flow: verificationType
        });
        navigate(recoverUrl);
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)($1a056958b9b10fbc$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "reverify.email.invalid-token.error.title",
                        defaultMessage: "We couldn't verify your email",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8Cc4v))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "reverify.email.invalid-token.error.main-action",
                defaultMessage: "Something went wrong while trying to validate your email."
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                    appearance: "primary",
                    id: "go-back-button",
                    isFullWidth: true,
                    onClick: recover,
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "reverify.email.invalid-token.error.button-text",
                        defaultMessage: "Go back to verify your email"
                    })
                })
            })
        ]
    });
};
var $1a056958b9b10fbc$export$2e2bcd8739ae039 = $1a056958b9b10fbc$export$4ad664360e6dde74;

});


parcelRegister("jvWWI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "welcomeSentLoader", function () { return $bd4a17d13866330a$export$518566b71566715e; });
$parcel$export(module.exports, "WelcomeSentPage", function () { return $bd4a17d13866330a$export$9feca1f6b3b10306; });
$parcel$export(module.exports, "default", function () { return $bd4a17d13866330a$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $aMBBA = parcelRequire("aMBBA");

var $chJxj = parcelRequire("chJxj");

var $c0AaV = parcelRequire("c0AaV");

var $bMPIi = parcelRequire("bMPIi");

var $b5Ma3 = parcelRequire("b5Ma3");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");
async function $bd4a17d13866330a$export$518566b71566715e({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/signup/welcome/sent/state', request, {
        capabilities: [
            'capability-group--signup',
            'capability-name--signup'
        ]
    });
}
const $bd4a17d13866330a$export$9feca1f6b3b10306 = ()=>{
    const error = (0, $aMBBA.useAppSelector)((state)=>state.welcomeSent.error);
    if (error === (0, $chJxj.WelcomeSentError).InvalidToken) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $c0AaV.default), {});
    else if (error === (0, $chJxj.WelcomeSentError).ExpiredToken) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $bMPIi.default), {});
    else return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $b5Ma3.default), {});
};
var $bd4a17d13866330a$export$2e2bcd8739ae039 = $bd4a17d13866330a$export$9feca1f6b3b10306;

});
parcelRegister("c0AaV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b05d33d205146a3b$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $8Cc4v = parcelRequire("8Cc4v");

var $Q6OOA = parcelRequire("Q6OOA");

var $fbSBq = parcelRequire("fbSBq");

var $4NPio = parcelRequire("4NPio");
const $b05d33d205146a3b$var$MessageContainer = (0, $fbSBq.default).div`
  margin-bottom: 24px;
`;
const $b05d33d205146a3b$export$703ba2e7ea526c1b = 'welcomeSentInvalidTokenErrorPage';
const $b05d33d205146a3b$export$5592c2a3db83a69d = ()=>{
    (0, $4NPio.usePageViewedEvent)($b05d33d205146a3b$export$703ba2e7ea526c1b);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $Q6OOA.default), {
        pageId: $b05d33d205146a3b$export$703ba2e7ea526c1b,
        header: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)($b05d33d205146a3b$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "welcome.send.invalid-token.error.title",
                        defaultMessage: "We couldn't verify your email",
                        description: "Telling the user that there is an error and they're not verified. The error is caused if the user tampers with the token.",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8Cc4v))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "welcome.send.invalid-token.error.main-action",
            defaultMessage: "Something went wrong while trying to validate your email. Try again from a verification email in your inbox.",
            description: "Telling the user that there was an error while trying to send the welcome link. The error is caused if the user tampers with the token."
        })
    });
};
var $b05d33d205146a3b$export$2e2bcd8739ae039 = $b05d33d205146a3b$export$5592c2a3db83a69d;

});

parcelRegister("bMPIi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9965ac1c8c70694a$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $8Cc4v = parcelRequire("8Cc4v");

var $Q6OOA = parcelRequire("Q6OOA");

var $fbSBq = parcelRequire("fbSBq");

var $4NPio = parcelRequire("4NPio");
const $9965ac1c8c70694a$var$MessageContainer = (0, $fbSBq.default).div`
  margin-bottom: 24px;
`;
const $9965ac1c8c70694a$export$703ba2e7ea526c1b = 'welcomeSentExpiredTokenErrorPage';
const $9965ac1c8c70694a$export$807f21bb9e47b82c = ()=>{
    (0, $4NPio.usePageViewedEvent)($9965ac1c8c70694a$export$703ba2e7ea526c1b);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $Q6OOA.default), {
        pageId: $9965ac1c8c70694a$export$703ba2e7ea526c1b,
        header: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)($9965ac1c8c70694a$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "welcome.sent.expire.title",
                        defaultMessage: "The link has expired",
                        description: "Telling the user that there is an error with the welcome link. The error is caused by submitting the resend link again after the token has expired.",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8Cc4v))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "welcome.sent.expire.body",
            defaultMessage: "Check your inbox for the verification email.",
            description: "Telling the user that the welcome resend link is expired and they're not verified. The error is caused by submitting the resend link again after the token has expired. The user should try again by clicking the link in their email."
        })
    });
};
var $9965ac1c8c70694a$export$2e2bcd8739ae039 = $9965ac1c8c70694a$export$807f21bb9e47b82c;

});

parcelRegister("b5Ma3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdf3b8eac84e0d20$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $cpaps = parcelRequire("cpaps");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $1JRGy = parcelRequire("1JRGy");

var $kJPFV = parcelRequire("kJPFV");

var $7lC8o = parcelRequire("7lC8o");

var $8PbSs = parcelRequire("8PbSs");

var $eTWY7 = parcelRequire("eTWY7");

var $Q6OOA = parcelRequire("Q6OOA");

var $gP3MD = parcelRequire("gP3MD");

var $aMBBA = parcelRequire("aMBBA");

var $4NPio = parcelRequire("4NPio");

var $fcxz7 = parcelRequire("fcxz7");

var $dWOVN = parcelRequire("dWOVN");
const $bdf3b8eac84e0d20$export$703ba2e7ea526c1b = 'welcomeSentScreen';
const $bdf3b8eac84e0d20$export$e3675ba991d10a22 = 'resendWelcomeSentEmail';
const $bdf3b8eac84e0d20$export$cb17d40f6b542a55 = ()=>{
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const { email: email, redirectType: redirectType, migratingApplications: migratingApplications, showBrowserWarning: showBrowserWarning } = (0, $aMBBA.useAppSelector)((state)=>state.welcomeSent);
    const location = (0, $cVnBY.useLocation)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    (0, $4NPio.usePageViewedEvent)($bdf3b8eac84e0d20$export$703ba2e7ea526c1b, {
        browserWarningMessageShown: showBrowserWarning,
        redirectType: redirectType
    });
    function handleResendVerificationEmail() {
        const { token: token } = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search);
        analyticsClient.buttonClickedEvent($bdf3b8eac84e0d20$export$703ba2e7ea526c1b, $bdf3b8eac84e0d20$export$e3675ba991d10a22, {
            redirectType: redirectType
        });
        return fetch(`/rest/signup/welcome/resend${location.search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token
            })
        }).then((response)=>{
            if (response.status === 204) dispatch((0, $7lC8o.addFlag)('success', (0, $gP3MD.default).verifyEmailFlagSuccessTitle, (0, $gP3MD.default).verifyEmailFlagSuccessDesc));
            else throw new Error($bdf3b8eac84e0d20$export$703ba2e7ea526c1b + ' Invalid Token');
        }).catch(()=>{
            dispatch((0, $7lC8o.addFlag)('error', (0, $gP3MD.default).verifyEmailFlagErrorTitle, (0, $gP3MD.default).verifyEmailFlagErrorDesc));
        });
    }
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: $bdf3b8eac84e0d20$export$703ba2e7ea526c1b,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $gP3MD.default).migrationVerifyHeader
            })
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
            id: "welcome-send-validation-submit",
            spacing: "none",
            className: "link-color-override",
            onClick: handleResendVerificationEmail,
            children: formatMessage((0, $gP3MD.default).button)
        }),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                title: formatMessage((0, $gP3MD.default).headTitle)
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8PbSs.default), {
                email: email,
                message: /*#__PURE__*/ (0, $6CtE1.jsx)($bdf3b8eac84e0d20$var$MigrationVerifyMessage, {
                    migratingApplications: migratingApplications
                }),
                warningMessage: showBrowserWarning && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kJPFV.default), {
                    testId: "browser-warning",
                    appearance: "information",
                    children: formatMessage((0, $gP3MD.default).browserWarning)
                })
            })
        ]
    });
};
var $bdf3b8eac84e0d20$export$2e2bcd8739ae039 = $bdf3b8eac84e0d20$export$cb17d40f6b542a55;
const $bdf3b8eac84e0d20$var$MigrationVerifyMessage = ({ migratingApplications: migratingApplications })=>{
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
        children: [
            migratingApplications !== undefined && /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $gP3MD.default).resumeMigrationVerifyMessage,
                        values: {
                            product: migratingApplications.includes('trello') ? (0, $fcxz7.applicationsMetadata)['trello'].name : (0, $fcxz7.applicationsMetadata)[migratingApplications[0]]?.name ?? migratingApplications[0]
                        }
                    }),
                    ' '
                ]
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $gP3MD.default).migrationVerifyMessage
            })
        ]
    });
};

});


parcelRegister("ganXz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "logoutLoader", function () { return $40774097dcf4df40$export$fe06aa2603bb1f9a; });
$parcel$export(module.exports, "LogoutPage", function () { return $40774097dcf4df40$export$ae5920452e7cb547; });
$parcel$export(module.exports, "default", function () { return $40774097dcf4df40$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $fbSBq = parcelRequire("fbSBq");

var $cpaps = parcelRequire("cpaps");

var $68HQw = parcelRequire("68HQw");

var $Q6OOA = parcelRequire("Q6OOA");

var $2byD0 = parcelRequire("2byD0");

var $5pCRv = parcelRequire("5pCRv");

var $cuZAx = parcelRequire("cuZAx");

var $7ci1C = parcelRequire("7ci1C");

var $8Atax = parcelRequire("8Atax");

var $idMOo = parcelRequire("idMOo");

var $4NPio = parcelRequire("4NPio");

var $gre8I = parcelRequire("gre8I");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $lpuXD = parcelRequire("lpuXD");

var $aMBBA = parcelRequire("aMBBA");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");

var $dWOVN = parcelRequire("dWOVN");
const $40774097dcf4df40$var$AccountWrapper = (0, $fbSBq.default).div`
  > * {
    padding-bottom: ${(0, $68HQw.gridSize)()}px !important;
    border-bottom: none !important;
  }
`;
const $40774097dcf4df40$var$Form = (0, $fbSBq.default).form`
  margin-top: 0;
`;
const $40774097dcf4df40$var$ButtonContainer = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $40774097dcf4df40$var$pageId = 'logoutPage';
async function $40774097dcf4df40$export$fe06aa2603bb1f9a({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/logout/state', request, {
        capabilities: [
            'capability-group--logout'
        ]
    });
}
const $40774097dcf4df40$export$ae5920452e7cb547 = ()=>{
    const autoSubmit = (0, $aMBBA.useAppSelector)((state)=>state.logout.autoSubmit);
    return autoSubmit ? /*#__PURE__*/ (0, $6CtE1.jsx)($40774097dcf4df40$var$LogoutAutoSubmit, {}) : /*#__PURE__*/ (0, $6CtE1.jsx)($40774097dcf4df40$var$LogoutConfirmationPage, {});
};
const $40774097dcf4df40$var$LogoutAutoSubmit = ()=>{
    const dispatch = (0, $aMBBA.useAppDispatch)();
    (0, $dNMDr.useEffect)(()=>{
        dispatch((0, $lpuXD.doLogout)());
    }, [
        dispatch
    ]);
    // When the browser loads the logout page the user will see the spinner on that page so we don't
    // want to show anything on this page, not even a spinner, to make the redirect more transparent.
    return null;
};
const $40774097dcf4df40$var$LogoutConfirmationPage = ()=>{
    const { isEmbedded: isEmbedded, oidcContext: oidcContext } = (0, $aMBBA.useAppSelector)((state)=>state.microbranding);
    const { userData: userData, formError: formError } = (0, $aMBBA.useAppSelector)((state)=>state.logout);
    const location = (0, $cVnBY.useLocation)();
    const intl = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    (0, $4NPio.usePageViewedEvent)($40774097dcf4df40$var$pageId, {
        isAuthenticatedUser: !!userData
    });
    const buildHeader = ()=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            as: "h1",
            size: "small",
            children: !userData || userData.associatedSessions.length === 0 ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "logout.title",
                defaultMessage: "Log out of your Atlassian account"
            }) : /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "logout.title.multiple",
                defaultMessage: "Log out of your Atlassian accounts"
            })
        });
    const buildFooter = ()=>{
        return isEmbedded ? undefined : /*#__PURE__*/ (0, $6CtE1.jsxs)("ul", {
            className: "fine-print",
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.PrivacyPolicyLink), {
                        isMobileLink: (0, $cuZAx.isMobileOidc)(oidcContext)
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $idMOo.default), {}),
                /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.UserNoticeLink), {
                        isMobileLink: (0, $cuZAx.isMobileOidc)(oidcContext)
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)("title", {
                    children: intl.formatMessage((0, $8Atax.default).logoutTitle)
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
                pageId: $40774097dcf4df40$var$pageId,
                header: buildHeader(),
                footer: buildFooter(),
                whiteboxFooter: /*#__PURE__*/ (0, $6CtE1.jsx)("a", {
                    href: '/login/select-account' + location.search,
                    onClick: ()=>{
                        analyticsClient.linkClickedEvent($40774097dcf4df40$var$pageId, 'selectAccount');
                    },
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "logout.switch-account",
                        defaultMessage: "Log in to another account"
                    })
                }),
                children: [
                    !!formError && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gre8I.SectionError), {
                        children: formError
                    }),
                    !!userData && userData.associatedSessions.length === 0 && /*#__PURE__*/ (0, $6CtE1.jsx)($40774097dcf4df40$var$AccountWrapper, {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.default), {
                            primary: true,
                            avatarUrl: userData.avatarUrl,
                            displayName: userData.displayName,
                            email: userData.email,
                            isolatedCloudLabel: userData.icLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)($40774097dcf4df40$var$LogoutForm, {})
                ]
            })
        ]
    });
};
const $40774097dcf4df40$var$LogoutForm = ()=>{
    const userData = (0, $aMBBA.useAppSelector)((state)=>state.logout.userData);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const [submitting, setSubmitting] = (0, $dNMDr.useState)(false);
    return /*#__PURE__*/ (0, $6CtE1.jsx)($40774097dcf4df40$var$Form, {
        onSubmit: (event)=>{
            event.preventDefault();
            setSubmitting(true);
            analyticsClient.formSubmittedEvent($40774097dcf4df40$var$pageId, 'logout');
            dispatch((0, $lpuXD.doLogout)());
        },
        "data-testid": "logout-form",
        children: /*#__PURE__*/ (0, $6CtE1.jsx)($40774097dcf4df40$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                appearance: "primary",
                id: "logout-submit",
                type: "submit",
                isFullWidth: true,
                isLoading: submitting,
                testId: "logout-button",
                children: !userData || userData.associatedSessions.length === 0 ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "logout.confirm",
                    defaultMessage: "Log out"
                }) : /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "logout.confirm.multiple",
                    defaultMessage: "Log out of all accounts"
                })
            })
        })
    });
};
var $40774097dcf4df40$export$2e2bcd8739ae039 = $40774097dcf4df40$export$ae5920452e7cb547;

});
parcelRegister("7ci1C", function(module, exports) {

$parcel$export(module.exports, "AccountContainer", function () { return $30a0212ff7629751$export$5baee99c5c7ba187; });
$parcel$export(module.exports, "AvatarContainer", function () { return $30a0212ff7629751$export$6027454d331df3c4; });
$parcel$export(module.exports, "RowButtonContainer", function () { return $30a0212ff7629751$export$fadcaf242d6ed62f; });
$parcel$export(module.exports, "TextContainer", function () { return $30a0212ff7629751$export$762240c6611b6ed2; });
$parcel$export(module.exports, "default", function () { return $30a0212ff7629751$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $krqPI = parcelRequire("krqPI");

var $fbSBq = parcelRequire("fbSBq");

var $8Govx = parcelRequire("8Govx");

var $4JRmj = parcelRequire("4JRmj");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $7DUKO = parcelRequire("7DUKO");

var $k6UX2 = parcelRequire("k6UX2");
const $30a0212ff7629751$export$5baee99c5c7ba187 = (0, $fbSBq.default).button`
  /* reset button styles */
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  width: 100%;
  text-align: left;

  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: ${(props)=>props.primary ? '0' : '16px'};
  padding-bottom: ${(props)=>props.primary ? '24px' : '16px'};

  &:last-child {
    border-bottom: 1px solid ${(0, $l4KzN).N30A};
    ${(props)=>props.noBorder && (0, $8Govx.css)`
        border-bottom: none;
        margin-bottom: ${-(0, $68HQw.gridSize)() * 3}px;
      `}
  }

  ${(props)=>props.primary && `  &:only-child {
        margin-bottom: 0;
        border-bottom: 0;
        padding: 8px 0;
    }
      `}

  ${(props)=>props.onClick ? `&:hover, &:focus {
      border-radius: 3px;
      transition: background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);
      cursor: pointer;
      background-color: ${(0, $l4KzN).N30A};
    }` : ''}
`;
const $30a0212ff7629751$var$primaryAvatarSize = '72px';
const $30a0212ff7629751$var$defaultAvatarSize = '36px';
const $30a0212ff7629751$export$6027454d331df3c4 = (0, $fbSBq.default).div`
  margin: 0 0 0 ${(props)=>props.primary ? '0' : '8px'};
  width: ${(props)=>props.primary ? $30a0212ff7629751$var$primaryAvatarSize : $30a0212ff7629751$var$defaultAvatarSize};
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props)=>props.primary && `padding-left: 8px;`}

  ${(props)=>props.primary && `
    div, span {
      padding: 0;
      width: ${$30a0212ff7629751$var$primaryAvatarSize} !important;
      height: ${$30a0212ff7629751$var$primaryAvatarSize} !important;
    }
  `}
`;
const $30a0212ff7629751$var$Avatar = (props)=>/*#__PURE__*/ (0, $6CtE1.jsx)($30a0212ff7629751$export$6027454d331df3c4, {
        primary: props.primary,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $krqPI.default), {
            appearance: "circle",
            src: props.avatarUrl,
            size: props.primary ? 'xlarge' : 'medium'
        })
    });
const $30a0212ff7629751$export$a9754b3c8daa5172 = (0, $fbSBq.default).section`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;
const $30a0212ff7629751$export$fadcaf242d6ed62f = (0, $fbSBq.default)($30a0212ff7629751$export$a9754b3c8daa5172)`
  padding: 8px 0;
`;
const $30a0212ff7629751$export$762240c6611b6ed2 = (0, $fbSBq.default).section`
  flex-grow: 1;

  min-width: 0;
  // IE11 expands width to the parent container until the overflow kicks in
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    width: 0;
  }

  display: inline-block;
  margin: 0 16px;
`;
const $30a0212ff7629751$var$DisplayNameOrEmail = (0, $fbSBq.default).span`
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $30a0212ff7629751$export$8b251419efc915eb = (0, $fbSBq.default).span`
  display: flex;
  gap: ${(0, $7DUKO.default)('space.050')};
  align-items: center;
  font: ${(props)=>props.primary ? (0, $7DUKO.default)('font.heading.medium') : (0, $7DUKO.default)('font.heading.xsmall')};
  font-size: ${(props)=>props.primary ? '20px' : '14px'};
  line-height: ${(props)=>props.primary ? '24px' : '20px'};
  color: ${(0, $l4KzN).N800};
  overflow-wrap: break-word;
`;
const $30a0212ff7629751$export$5a6b8595f311cbb0 = (0, $fbSBq.default).p`
  font-size: 14px;
  line-height: 20px;
  color: ${(0, $l4KzN).N700};
  margin-top: ${(props)=>props.primary ? '4px' : '0'};
  overflow-wrap: break-word;
`;
const $30a0212ff7629751$export$8f314e512d92575f = (0, $fbSBq.default).section`
  margin-right: 8px;
`;
/**
 * Representation of an account in a row format, used for rendering lists of accounts, e.g. for switching an account
 * or selecting one to log in
 */ const $30a0212ff7629751$var$Account = ({ avatarUrl: avatarUrl, children: children, displayName: displayName, email: email, header: header, icon: icon, isolatedCloudLabel: isolatedCloudLabel, id: id, onClick: onClick, primary: primary })=>/*#__PURE__*/ (0, $6CtE1.jsxs)($30a0212ff7629751$export$5baee99c5c7ba187, {
        id: id,
        className: "account-entry" // account-entry used by pollinators
        ,
        "data-testid": "account-entry",
        as: primary ? 'div' : 'button',
        primary: primary,
        onClick: onClick,
        children: [
            header,
            /*#__PURE__*/ (0, $6CtE1.jsxs)($30a0212ff7629751$export$a9754b3c8daa5172, {
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)($30a0212ff7629751$var$Avatar, {
                        avatarUrl: avatarUrl,
                        primary: primary
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsxs)($30a0212ff7629751$export$762240c6611b6ed2, {
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsxs)($30a0212ff7629751$export$8b251419efc915eb, {
                                primary: primary,
                                children: [
                                    /*#__PURE__*/ (0, $6CtE1.jsx)($30a0212ff7629751$var$DisplayNameOrEmail, {
                                        "data-testid": "email",
                                        children: displayName ? displayName : email
                                    }),
                                    isolatedCloudLabel && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $4JRmj.default), {
                                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $k6UX2.default), {
                                            maxWidth: "130px",
                                            children: isolatedCloudLabel
                                        })
                                    })
                                ]
                            }),
                            displayName && /*#__PURE__*/ (0, $6CtE1.jsx)($30a0212ff7629751$export$5a6b8595f311cbb0, {
                                primary: primary,
                                children: email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)($30a0212ff7629751$export$8f314e512d92575f, {
                        children: icon
                    })
                ]
            }),
            children
        ]
    });
var $30a0212ff7629751$export$2e2bcd8739ae039 = $30a0212ff7629751$var$Account;

});
parcelRegister("krqPI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee1b24c0de7ee015$export$2e2bcd8739ae039; });
/* avatar.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $3SI82 = parcelRequire("3SI82");

var $hGahQ = parcelRequire("hGahQ");

var $iusIG = parcelRequire("iusIG");

var $6bOq1 = parcelRequire("6bOq1");

var $jVY13 = parcelRequire("jVY13");

var $ijbOp = parcelRequire("ijbOp");

var $4ehNd = parcelRequire("4ehNd");

var $3t9bU = parcelRequire("3t9bU");
function $ee1b24c0de7ee015$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ee1b24c0de7ee015$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ee1b24c0de7ee015$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ee1b24c0de7ee015$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ee1b24c0de7ee015$var$packageName = "@atlaskit/avatar";
var $ee1b24c0de7ee015$var$packageVersion = "25.8.1";
var $ee1b24c0de7ee015$var$containerStyles = null;
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $ee1b24c0de7ee015$var$Avatar = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'circle' : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? 'div' : _ref$as, _ref$isDecorative = _ref.isDecorative, isDecorative = _ref$isDecorative === void 0 ? false : _ref$isDecorative, imgLoading = _ref.imgLoading, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHasPopup = _ref['aria-haspopup'];
    var _useAnalyticsEvents = (0, $3SI82.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $6bOq1.useAvatarContext)();
    var size = sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium';
    var customPresenceNode = /*#__PURE__*/ (0, $dNMDr.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $dNMDr.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    var lastAnalytics = (0, $dNMDr.useRef)(analyticsContext);
    var labelId = (0, $hGahQ.useId)();
    (0, $dNMDr.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $dNMDr.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $ee1b24c0de7ee015$var$packageName,
                packageVersion: $ee1b24c0de7ee015$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $ee1b24c0de7ee015$var$_objectSpread({
            componentName: 'avatar',
            packageName: $ee1b24c0de7ee015$var$packageName,
            packageVersion: $ee1b24c0de7ee015$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled || ariaHasPopup;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $dNMDr.createElement((0, $6bOq1.EnsureIsInsideAvatarContext).Provider, {
        value: true
    }, /*#__PURE__*/ $dNMDr.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $affTb.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $dNMDr.createElement((0, $6bOq1.AvatarContentContext).Provider, {
        value: {
            as: (0, $3t9bU.getCustomElement)(isDisabled, href, onClick, ariaHasPopup),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            'aria-controls': ariaControls,
            'aria-expanded': ariaExpanded,
            'aria-haspopup': ariaHasPopup,
            avatarImage: /*#__PURE__*/ $dNMDr.createElement((0, $jVY13.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $dNMDr.createElement((0, $iusIG.AvatarContent), null)), isPresence && /*#__PURE__*/ $dNMDr.createElement((0, $ijbOp.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $dNMDr.createElement((0, $4ehNd.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $dNMDr.createElement("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$ee1b24c0de7ee015$var$Avatar.displayName = 'Avatar';
var $ee1b24c0de7ee015$export$2e2bcd8739ae039 = $ee1b24c0de7ee015$var$Avatar;

});
parcelRegister("iusIG", function(module, exports) {

$parcel$export(module.exports, "AvatarContent", function () { return $d7614e7718e6bc30$export$47fbc0b44cae5559; });
/* avatar-content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $gQLDR = parcelRequire("gQLDR");

var $6bOq1 = parcelRequire("6bOq1");
var $d7614e7718e6bc30$var$boxShadowCssVar = '--avatar-box-shadow';
var $d7614e7718e6bc30$var$bgColorCssVar = '--avatar-bg-color';
var $d7614e7718e6bc30$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu194a _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
var $d7614e7718e6bc30$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1g4v _ez1ykb7n _gcm1182g _eeh8kb7n _jlxit94y"
};
var $d7614e7718e6bc30$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $d7614e7718e6bc30$var$marginAdjustmentMap = {
    xsmall: "_195gcwjc",
    small: "_195gcwjc",
    medium: "_195gs7t4",
    large: "_195gs7t4",
    xlarge: "_195g8ocb",
    xxlarge: "_195g1ukp"
};
var $d7614e7718e6bc30$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rko12b0 _14mj12b0",
    large: "_2rko12b0 _14mj12b0",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
var $d7614e7718e6bc30$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $6bOq1.useEnsureIsInsideAvatar)();
    var _useAvatarContent = (0, $6bOq1.useAvatarContent)(), Container = _useAvatarContent.as, appearance = _useAvatarContent.appearance, avatarImage = _useAvatarContent.avatarImage, _useAvatarContent$bor = _useAvatarContent.borderColor, borderColor = _useAvatarContent$bor === void 0 ? "var(--ds-surface, #FFFFFF)" : _useAvatarContent$bor, href = _useAvatarContent.href, isDisabled = _useAvatarContent.isDisabled, label = _useAvatarContent.label, onClick = _useAvatarContent.onClick, contextRef = _useAvatarContent.ref, tabIndex = _useAvatarContent.tabIndex, target = _useAvatarContent.target, testId = _useAvatarContent.testId, size = _useAvatarContent.size, stackIndex = _useAvatarContent.stackIndex, ariaControls = _useAvatarContent['aria-controls'], ariaExpanded = _useAvatarContent['aria-expanded'], ariaHasPopup = _useAvatarContent['aria-haspopup'];
    var isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    var renderedContent = /*#__PURE__*/ $dNMDr.createElement(Container, (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        style: (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, $d7614e7718e6bc30$var$bgColorCssVar, borderColor), $d7614e7718e6bc30$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }, {
        className: (0, $affTb.default)([
            $d7614e7718e6bc30$var$unboundStyles.root,
            $d7614e7718e6bc30$var$styles.root,
            !(0, $gQLDR.fg)('platform_dst_avatar_tile') && !(0, $gQLDR.fg)('platform_dst_avatar_tile_stage2') && $d7614e7718e6bc30$var$borderRadiusMap[size],
            appearance === 'square' && ((0, $gQLDR.fg)('platform_dst_avatar_tile') || (0, $gQLDR.fg)('platform_dst_avatar_tile_stage2')) && $d7614e7718e6bc30$var$styles.square,
            appearance === 'circle' && $d7614e7718e6bc30$var$styles.circle,
            appearance === 'hexagon' && $d7614e7718e6bc30$var$unboundStyles.hexagon,
            $d7614e7718e6bc30$var$widthHeightMap[size],
            stackIndex !== undefined && $d7614e7718e6bc30$var$styles.positionRelative,
            isInteractive && !isDisabled && $d7614e7718e6bc30$var$unboundStyles.interactive,
            isDisabled && $d7614e7718e6bc30$var$styles.disabled
        ])
    }), children || avatarImage);
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ $dNMDr.createElement("div", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))((0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, $d7614e7718e6bc30$var$bgColorCssVar, borderColor), $d7614e7718e6bc30$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        "data-testid": testId ? "".concat(testId, "-hexagon-focus-container") : 'hexagon-focus-container',
        className: (0, $affTb.default)([
            $d7614e7718e6bc30$var$unboundStyles.hexagonFocusContainer,
            $d7614e7718e6bc30$var$marginAdjustmentMap[size]
        ])
    }, /*#__PURE__*/ $dNMDr.createElement("div", {
        "data-testid": testId ? "".concat(testId, "-hexagon-border-container") : 'hexagon-border-container',
        className: (0, $affTb.default)([
            $d7614e7718e6bc30$var$unboundStyles.hexagonBorderContainer
        ])
    }, renderedContent));
});

});
parcelRegister("6bOq1", function(module, exports) {

$parcel$export(module.exports, "useAvatarContext", function () { return $481ae144482769f0$export$b50b87a1c4086b23; });
$parcel$export(module.exports, "AvatarContentContext", function () { return $481ae144482769f0$export$b983474ddd0b6d28; });
$parcel$export(module.exports, "useAvatarContent", function () { return $481ae144482769f0$export$79d078b69b7e4842; });
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", function () { return $481ae144482769f0$export$6b4cbd90d24955ad; });
$parcel$export(module.exports, "useEnsureIsInsideAvatar", function () { return $481ae144482769f0$export$7db5c57474082dd9; });

var $dNMDr = parcelRequire("dNMDr");
var $481ae144482769f0$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $dNMDr.createContext)(undefined);
var $481ae144482769f0$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $dNMDr.useContext)($481ae144482769f0$export$a20dad690e1279e2);
};
var $481ae144482769f0$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
var $481ae144482769f0$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $dNMDr.createContext)($481ae144482769f0$var$defaultAvatarContentProps);
var $481ae144482769f0$export$79d078b69b7e4842 = function useAvatarContent() {
    return (0, $dNMDr.useContext)($481ae144482769f0$export$b983474ddd0b6d28);
};
var $481ae144482769f0$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $dNMDr.createContext)(false);
var $481ae144482769f0$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $dNMDr.useContext)($481ae144482769f0$export$6b4cbd90d24955ad);
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});


parcelRegister("jVY13", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e831e521d07ffbf5$export$2e2bcd8739ae039; });
/* avatar-image.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $29sI2 = parcelRequire("29sI2");

var $3248Q = parcelRequire("3248Q");

var $dcrYk = parcelRequire("dcrYk");
var $e831e521d07ffbf5$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
var $e831e521d07ffbf5$var$borderRadiusMap = {
    xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
var $e831e521d07ffbf5$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $e831e521d07ffbf5$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? '' : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId, imgLoading = _ref.imgLoading;
    var _useState = (0, $dNMDr.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    // If src changes, reset state
    (0, $dNMDr.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        var renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ $dNMDr.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3248Q))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--person"),
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ $dNMDr.createElement((0, (/*@__PURE__*/$parcel$interopDefault($29sI2))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--agent"),
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ $dNMDr.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcrYk))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--ship"),
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ $dNMDr.createElement("span", {
            className: (0, $affTb.default)([
                $e831e521d07ffbf5$var$styles.icon,
                $e831e521d07ffbf5$var$nestedSvgStylesMap[size]
            ])
        }, renderedIcon);
    }
    return /*#__PURE__*/ $dNMDr.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $affTb.default)([
            $e831e521d07ffbf5$var$styles.image,
            $e831e521d07ffbf5$var$borderRadiusMap[size],
            appearance === 'circle' && $e831e521d07ffbf5$var$styles.circle,
            appearance === 'hexagon' && $e831e521d07ffbf5$var$styles.hexagon
        ])
    });
};
var $e831e521d07ffbf5$export$2e2bcd8739ae039 = $e831e521d07ffbf5$var$AvatarImage;

});
parcelRegister("29sI2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e079be55658218810235742dfafa5bd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1912b116b65c3fb8$var$_react = $1912b116b65c3fb8$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $1912b116b65c3fb8$var$_baseNew = $1912b116b65c3fb8$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $1912b116b65c3fb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1912b116b65c3fb8$var$AiAgentIcon = (props)=>/*#__PURE__*/ $1912b116b65c3fb8$var$_react.default.createElement($1912b116b65c3fb8$var$_baseNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$1912b116b65c3fb8$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $1912b116b65c3fb8$var$_default = module.exports.default = $1912b116b65c3fb8$var$AiAgentIcon;

});

parcelRegister("3248Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc4353a18034f564a0b3573d4163ea60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2354c56dd7e2e280$var$_react = $2354c56dd7e2e280$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $2354c56dd7e2e280$var$_baseNew = $2354c56dd7e2e280$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $2354c56dd7e2e280$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2354c56dd7e2e280$var$PersonIcon = (props)=>/*#__PURE__*/ $2354c56dd7e2e280$var$_react.default.createElement($2354c56dd7e2e280$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$2354c56dd7e2e280$var$PersonIcon.displayName = 'PersonIcon';
var $2354c56dd7e2e280$var$_default = module.exports.default = $2354c56dd7e2e280$var$PersonIcon;

});

parcelRegister("dcrYk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b008ccfed50bccf7a8bb78b89f8a48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99c21808ab43bb51$var$_react = $99c21808ab43bb51$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $99c21808ab43bb51$var$_baseNew = $99c21808ab43bb51$var$_interopRequireDefault((parcelRequire("5v6LX")));
function $99c21808ab43bb51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99c21808ab43bb51$var$ReleaseIcon = (props)=>/*#__PURE__*/ $99c21808ab43bb51$var$_react.default.createElement($99c21808ab43bb51$var$_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$99c21808ab43bb51$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $99c21808ab43bb51$var$_default = module.exports.default = $99c21808ab43bb51$var$ReleaseIcon;

});


parcelRegister("ijbOp", function(module, exports) {

$parcel$export(module.exports, "PresenceWrapper", function () { return $d54329f2d31ce8ce$export$972c5e90200fa0ef; });
/* presence.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $2Mjap = parcelRequire("2Mjap");

var $9oL8j = parcelRequire("9oL8j");
var $d54329f2d31ce8ce$var$BusyIndicator = /*#__PURE__*/ $dNMDr.createElement((0, $dNMDr.Fragment), null, /*#__PURE__*/ $dNMDr.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $2Mjap.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $dNMDr.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $2Mjap.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $d54329f2d31ce8ce$var$FocusIndicator = /*#__PURE__*/ $dNMDr.createElement((0, $dNMDr.Fragment), null, /*#__PURE__*/ $dNMDr.createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $2Mjap.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $d54329f2d31ce8ce$var$OfflineIndicator = /*#__PURE__*/ $dNMDr.createElement((0, $dNMDr.Fragment), null, /*#__PURE__*/ $dNMDr.createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $2Mjap.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $dNMDr.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $2Mjap.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $d54329f2d31ce8ce$var$OnlineIndicator = /*#__PURE__*/ $dNMDr.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $2Mjap.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $d54329f2d31ce8ce$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $d54329f2d31ce8ce$var$BusyIndicator;
        case 'focus':
            return $d54329f2d31ce8ce$var$FocusIndicator;
        case 'offline':
            return $d54329f2d31ce8ce$var$OfflineIndicator;
        case 'online':
            return $d54329f2d31ce8ce$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $d54329f2d31ce8ce$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ $dNMDr.createElement((0, $9oL8j.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $dNMDr.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $d54329f2d31ce8ce$var$getPresence(presence)) : children);
};
var $d54329f2d31ce8ce$export$2e2bcd8739ae039 = $d54329f2d31ce8ce$var$AvatarPresence;
var $d54329f2d31ce8ce$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
var $d54329f2d31ce8ce$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $d54329f2d31ce8ce$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
var $d54329f2d31ce8ce$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
var $d54329f2d31ce8ce$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
var $d54329f2d31ce8ce$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        className: (0, $affTb.default)([
            $d54329f2d31ce8ce$var$styles.root,
            $d54329f2d31ce8ce$var$iconSizeMap[size],
            $d54329f2d31ce8ce$var$circleIconOffsetMap[size],
            appearance === 'square' && $d54329f2d31ce8ce$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $d54329f2d31ce8ce$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $dNMDr.createElement($d54329f2d31ce8ce$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("9oL8j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d7aea99ca70acdd$export$2e2bcd8739ae039; });
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
var $6d7aea99ca70acdd$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var $6d7aea99ca70acdd$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $6d7aea99ca70acdd$var$IconWrapper = function IconWrapper(_ref) {
    var bgColor = _ref.bgColor, children = _ref.children;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $affTb.default)([
            $6d7aea99ca70acdd$var$styles.root,
            $6d7aea99ca70acdd$var$unboundStyles.root
        ])
    }, children);
};
var $6d7aea99ca70acdd$export$2e2bcd8739ae039 = $6d7aea99ca70acdd$var$IconWrapper;

});


parcelRegister("4ehNd", function(module, exports) {

$parcel$export(module.exports, "StatusWrapper", function () { return $31464588ce7166bc$export$8045894f255f9726; });
/* status.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $2Mjap = parcelRequire("2Mjap");

var $9oL8j = parcelRequire("9oL8j");
var $31464588ce7166bc$var$styles = {
    root: "_kqswstnw"
};
var $31464588ce7166bc$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $31464588ce7166bc$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
var $31464588ce7166bc$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
var $31464588ce7166bc$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
var $31464588ce7166bc$var$ApprovedIndicator = /*#__PURE__*/ $dNMDr.createElement((0, $dNMDr.Fragment), null, /*#__PURE__*/ $dNMDr.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $2Mjap.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $dNMDr.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $2Mjap.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $31464588ce7166bc$var$DeclinedIndicator = /*#__PURE__*/ $dNMDr.createElement((0, $dNMDr.Fragment), null, /*#__PURE__*/ $dNMDr.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $2Mjap.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $dNMDr.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $2Mjap.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $31464588ce7166bc$var$LockedIndicator = /*#__PURE__*/ $dNMDr.createElement((0, $dNMDr.Fragment), null, /*#__PURE__*/ $dNMDr.createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $2Mjap.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $dNMDr.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $2Mjap.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $31464588ce7166bc$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $31464588ce7166bc$var$ApprovedIndicator;
        case 'declined':
            return $31464588ce7166bc$var$DeclinedIndicator;
        case 'locked':
            return $31464588ce7166bc$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $31464588ce7166bc$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ $dNMDr.createElement((0, $9oL8j.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $dNMDr.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $31464588ce7166bc$var$getStatus(status)) : children);
};
var $31464588ce7166bc$export$2e2bcd8739ae039 = $31464588ce7166bc$var$AvatarStatus;
var $31464588ce7166bc$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        className: (0, $affTb.default)([
            $31464588ce7166bc$var$styles.root,
            $31464588ce7166bc$var$iconSizeMap[size],
            $31464588ce7166bc$var$circleIconOffsetMap[size],
            appearance === 'square' && $31464588ce7166bc$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $31464588ce7166bc$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $dNMDr.createElement($31464588ce7166bc$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("3t9bU", function(module, exports) {

$parcel$export(module.exports, "getCustomElement", function () { return $286b35b5dfbcdc8c$export$83ee468102cdf04c; });
var $286b35b5dfbcdc8c$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick, ariaHasPopup) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
function $286b35b5dfbcdc8c$export$6b45b5bd2259198a(appType) {
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
}

});


parcelRegister("k6UX2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea408b7fde598914$export$2e2bcd8739ae039; });
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $grvIM = parcelRequire("grvIM");

var $gQLDR = parcelRequire("gQLDR");

var $dwiAI = parcelRequire("dwiAI");
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $ea408b7fde598914$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
var $ea408b7fde598914$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
var $ea408b7fde598914$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
var $ea408b7fde598914$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $ea408b7fde598914$var$LegacyLozenge = /*#__PURE__*/ (0, $dNMDr.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, $dNMDr.useMemo)(function() {
        return $ea408b7fde598914$var$appearanceTypes.includes(appearance) || $ea408b7fde598914$var$newSemanticColors.includes(appearance) ? $ea408b7fde598914$var$appearanceMapping[appearance] : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $grvIM.default)([
            $ea408b7fde598914$var$styles.container,
            $ea408b7fde598914$var$styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && $ea408b7fde598914$var$styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && $ea408b7fde598914$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $dNMDr.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $grvIM.default)([
            $ea408b7fde598914$var$styles.text,
            (0, $gQLDR.fg)('platform-lozenge-custom-letterspacing') && $ea408b7fde598914$var$styles.customLetterspacing,
            $ea408b7fde598914$var$styles["text.".concat(appearanceStyle)]
        ])
    }, children));
});
$ea408b7fde598914$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var $ea408b7fde598914$var$LozengeWrapper = /*#__PURE__*/ (0, $dNMDr.memo)(function(props) {
    if ((0, $gQLDR.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ $dNMDr.createElement((0, $dwiAI.default), props);
    return /*#__PURE__*/ $dNMDr.createElement($ea408b7fde598914$var$LegacyLozenge, props);
});
$ea408b7fde598914$var$LozengeWrapper.displayName = 'Lozenge';
var $ea408b7fde598914$export$2e2bcd8739ae039 = $ea408b7fde598914$var$LozengeWrapper;

});
parcelRegister("dwiAI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d7caf58908e003a$export$2e2bcd8739ae039; });
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $dNMDr = parcelRequire("dNMDr");


var $rnyVb = parcelRequire("rnyVb");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $9d7caf58908e003a$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $dNMDr.createElement((0, $rnyVb.default), baseProps, children);
};
$9d7caf58908e003a$var$Lozenge.displayName = 'Lozenge';
var $9d7caf58908e003a$export$2e2bcd8739ae039 = $9d7caf58908e003a$var$Lozenge;

});
parcelRegister("rnyVb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0524ccb3d15ff44c$export$2e2bcd8739ae039; });
/* lozenge-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $91FVG = parcelRequire("91FVG");

var $dNMDr = parcelRequire("dNMDr");

var $grvIM = parcelRequire("grvIM");

var $6UE4a = parcelRequire("6UE4a");

var $kugzw = parcelRequire("kugzw");

var $jJCD4 = parcelRequire("jJCD4");

var $7cDRu = parcelRequire("7cDRu");

var $3Wc5s = parcelRequire("3Wc5s");

var $jTt39 = parcelRequire("jTt39");

var $86sLD = parcelRequire("86sLD");
function $0524ccb3d15ff44c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0524ccb3d15ff44c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0524ccb3d15ff44c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0524ccb3d15ff44c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $0524ccb3d15ff44c$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $0524ccb3d15ff44c$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'metric.semantic.success': "_1bn8d6jc _4ayg1wl5",
    'metric.semantic.warning': "_1bn8bkku _4aygzr32",
    'metric.semantic.danger': "_1bn8jkmi _4ayg1r4b",
    'metric.semantic.information': "_1bn8ar1y _4ayg1c1j",
    'metric.semantic.neutral': "_1bn814je _4ayg1fkg _iymy8hz0 _16burnys",
    'metric.semantic.discovery': "_1bn85usi _4ayg18vq",
    'metric.inverse': "_1bn8vuon _4aygvuon",
    'semantic.success': "_1b3i4pcx _3wu01mps _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_1b3iervl _3wu01xiv _bfhk10f4 _syazmgs1",
    'semantic.danger': "_1b3is4qr _3wu01bqt _bfhk18wg _syaz1blx",
    'semantic.information': "_1b3iyhbg _3wu0vbh5 _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_1b3i1cv2 _3wu01ihb _bfhki8nm _syazi7uo",
    'semantic.discovery': "_1b3iqm1h _3wu0v30g _bfhke670 _syaz1g72",
    'accent.red': "_1b3inbxb _3wu016y8 _bfhk1rtt _syazhwvp",
    'accent.orange': "_1b3i1j6y _3wu01b2s _bfhk165s _syaz7i1p",
    'accent.yellow': "_1b3i1oqg _3wu0feiv _bfhk1773 _syazekll",
    'accent.lime': "_1b3i8645 _3wu0nf89 _bfhkz2ec _syaz1ik3",
    'accent.green': "_1b3i17hp _3wu01crs _bfhk1wnw _syaz1y78",
    'accent.teal': "_1b3i8uof _3wu01h3o _bfhk1a17 _syaz12v7",
    'accent.blue': "_1b3i6txe _3wu01w55 _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_1b3iuq3u _3wu01hqq _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_1b3iv8hk _3wu0uwd0 _bfhkv9ra _syaz1qur",
    'accent.gray': "_1b3i1diz _3wu08yml _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6dzs9d _4uq11yqs _1k671038 _m71tr3uz _13muu67f _168qx19p _oe6mmko7 _189qkb7n _u8p61h4e _1t75u67f _hg5mr3uz _1f28f1ug _1xe213rw _1easxmrh _1r9r1ss3",
    iconBorderInteractiveFilter: "_1iel6xdd _111i1h4e _18dicjiy _hyog26zw _fdt01r5k _46v5hwvj _ylgq1r5k _bg3q9by0 _196p1btq _18mn783i _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _4cvx7ddx _1cp21w66 _q4zt1csi _1gqs1mvc _75gv2l9f _1lh71sfd _ui3h1ct7 _11o31cha",
    containerSelected: "_1xe213kw",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadge: "_1ftrbpke",
    containerBadgeInteractive: "_1axm1bqy"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $0524ccb3d15ff44c$var$LozengeBase = /*#__PURE__*/ (0, $dNMDr.memo)(/*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHaspopup = _ref['aria-haspopup'], ariaLabel = _ref['aria-label'];
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $86sLD.resolveLozengeColor)(appearance) || 'neutral';
    var _getThemeStyles = (0, $86sLD.getThemeStyles)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $86sLD.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    var metricBadgeAppearance = resolvedTrailingMetricAppearance === 'inverse' ? 'inverse' : resolvedTrailingMetricAppearance != null && resolvedTrailingMetricAppearance.startsWith('accent-') ? 'neutral' : resolvedTrailingMetricAppearance !== null && resolvedTrailingMetricAppearance !== void 0 ? resolvedTrailingMetricAppearance : 'neutral';
    var metricStyleKey = resolvedTrailingMetricAppearance === 'inverse' ? 'metric.inverse' : resolvedTrailingMetricAppearance != null && !resolvedTrailingMetricAppearance.startsWith('accent-') ? "metric.semantic.".concat((0, $86sLD.getThemeStyles)(resolvedTrailingMetricAppearance).key) : 'metric.semantic.neutral';
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        maxWidth: maxWidthIsPc ? maxWidth : '100%'
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    var innerContent = /*#__PURE__*/ $dNMDr.createElement("span", {
        style: {
            // When maxWidth is a percentage, constrain the content wrapper
            // so text truncation works correctly within the flex layout
            maxWidth: maxWidthIsPc ? '100%' : undefined
        },
        className: (0, $grvIM.default)([
            $0524ccb3d15ff44c$var$styles.content,
            spacing === 'spacious' && $0524ccb3d15ff44c$var$styles.contentSpacious,
            isLoading && $0524ccb3d15ff44c$var$styles.loadingContent
        ])
    }, iconBefore && /*#__PURE__*/ $dNMDr.createElement((0, $jTt39.default), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $dNMDr.createElement("span", {
        style: {
            maxWidth: maxWidthIsPc ? undefined : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $grvIM.default)([
            $0524ccb3d15ff44c$var$styles.text,
            spacing === 'spacious' && $0524ccb3d15ff44c$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $dNMDr.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $grvIM.default)([
            $0524ccb3d15ff44c$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $dNMDr.createElement((0, $6UE4a.default), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $dNMDr.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jJCD4))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $dNMDr.createElement((0, $7cDRu.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        ref: ref,
        xcss: (0, $kugzw.cx)($0524ccb3d15ff44c$var$styles.container, spacing === 'spacious' && $0524ccb3d15ff44c$var$styles.containerSpacious, !isSelected && $0524ccb3d15ff44c$var$styles.iconBorderFilter, !isLoading && $0524ccb3d15ff44c$var$styles.iconBorderInteractiveFilter, $0524ccb3d15ff44c$var$styles[colorStyleKey], !isLoading && $0524ccb3d15ff44c$var$styles[interactiveStyleKey], isSelected && $0524ccb3d15ff44c$var$styles.containerSelected, hasTrailingMetric && $0524ccb3d15ff44c$var$styles.containerBadge, hasTrailingMetric && $0524ccb3d15ff44c$var$styles.containerBadgeInteractive, hasTrailingMetric && $0524ccb3d15ff44c$var$styles[metricStyleKey])
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $0524ccb3d15ff44c$var$_objectSpread($0524ccb3d15ff44c$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? 'oklch(from var(--border-color) calc(l * var(--border-pressed-l-factor)) c h) !important' : 'transparent'),
            backgroundColor: isSelected ? $0524ccb3d15ff44c$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }), innerContent, isLoading && /*#__PURE__*/ $dNMDr.createElement("span", {
        className: (0, $grvIM.default)([
            $0524ccb3d15ff44c$var$styles.loadingOverlay
        ])
    }, /*#__PURE__*/ $dNMDr.createElement((0, $3Wc5s.default), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $grvIM.default)([
            $0524ccb3d15ff44c$var$styles.container,
            spacing === 'spacious' && $0524ccb3d15ff44c$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $0524ccb3d15ff44c$var$styles.containerBadgePadding,
            $0524ccb3d15ff44c$var$styles[colorStyleKey],
            hasTrailingMetric && $0524ccb3d15ff44c$var$styles[metricStyleKey],
            $0524ccb3d15ff44c$var$styles.iconBorderFilter,
            $0524ccb3d15ff44c$var$styles.containerBadge
        ])
    }, innerContent);
}));
var $0524ccb3d15ff44c$export$2e2bcd8739ae039 = $0524ccb3d15ff44c$var$LozengeBase;

});
parcelRegister("6UE4a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50870d55c789339a$export$2e2bcd8739ae039; });
/* badge.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $gQLDR = parcelRequire("gQLDR");

var $eTcBP = parcelRequire("eTcBP");

var $63en7 = parcelRequire("63en7");

var $eqt7X = parcelRequire("eqt7X");
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ var $50870d55c789339a$var$neutral300 = '#DDDEE1';
var $50870d55c789339a$var$red300 = '#FD9891';
var $50870d55c789339a$var$blue300 = '#8FB8F6';
var $50870d55c789339a$var$neutral1000 = '#292A2E';
var $50870d55c789339a$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
var $50870d55c789339a$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && typeof max === 'number' ? (0, $eqt7X.formatValueWithNegativeSupport)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $50870d55c789339a$var$Badge = /*#__PURE__*/ (0, $dNMDr.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    if ((0, $gQLDR.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        var newAppearance = (0, $63en7.appearanceMapping)[appearance];
        return /*#__PURE__*/ $dNMDr.createElement((0, $63en7.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children);
    }
    var oldAppearance = (0, $63en7.appearanceMappingToOld)[appearance];
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $affTb.default)([
            $50870d55c789339a$var$styles.root,
            $50870d55c789339a$var$styles[oldAppearance]
        ])
    }, /*#__PURE__*/ $dNMDr.createElement((0, $eTcBP.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $50870d55c789339a$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $50870d55c789339a$export$2e2bcd8739ae039 = $50870d55c789339a$var$Badge;

});
parcelRegister("63en7", function(module, exports) {

$parcel$export(module.exports, "appearanceMapping", function () { return $467e2bde9c778e98$export$d21bba0569254935; });
$parcel$export(module.exports, "appearanceMappingToOld", function () { return $467e2bde9c778e98$export$16f8cc7ac3541e83; });
$parcel$export(module.exports, "default", function () { return $467e2bde9c778e98$export$2e2bcd8739ae039; });
/* badge-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $eTcBP = parcelRequire("eTcBP");

var $eqt7X = parcelRequire("eqt7X");
var $467e2bde9c778e98$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral'
};
var $467e2bde9c778e98$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default'
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $467e2bde9c778e98$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $467e2bde9c778e98$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $eqt7X.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 */ var $467e2bde9c778e98$var$BadgeNew = /*#__PURE__*/ (0, $dNMDr.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $affTb.default)([
            $467e2bde9c778e98$var$stylesNew.root,
            $467e2bde9c778e98$var$stylesNew[appearance]
        ])
    }, /*#__PURE__*/ $dNMDr.createElement((0, $eTcBP.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $467e2bde9c778e98$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $467e2bde9c778e98$export$2e2bcd8739ae039 = $467e2bde9c778e98$var$BadgeNew;

});
parcelRegister("eqt7X", function(module, exports) {

$parcel$export(module.exports, "formatValueWithNegativeSupport", function () { return $a80a167bb99e9b6d$export$4b844743568d5983; });
$parcel$export(module.exports, "formatValue", function () { return $a80a167bb99e9b6d$export$7c4d25c0c3217d8c; });
function $a80a167bb99e9b6d$var$getSafeValueWithNegativeSupport() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $a80a167bb99e9b6d$export$4b844743568d5983(value, max) {
    var safeValue = $a80a167bb99e9b6d$var$getSafeValueWithNegativeSupport(value);
    var safeMax = $a80a167bb99e9b6d$var$getSafeValueWithNegativeSupport(max);
    var hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $a80a167bb99e9b6d$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a80a167bb99e9b6d$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $a80a167bb99e9b6d$var$getSafeValue(value);
    var safeMax = $a80a167bb99e9b6d$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});



parcelRegister("7cDRu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53e89314240745d3$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $62ppy = parcelRequire("62ppy");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $8Govx = parcelRequire("8Govx");

var $02D9g = parcelRequire("02D9g");

var $c3KQG = parcelRequire("c3KQG");

var $hMip0 = parcelRequire("hMip0");

var $hEh1s = parcelRequire("hEh1s");

var $6LPEe = parcelRequire("6LPEe");
var $53e89314240745d3$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $53e89314240745d3$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $53e89314240745d3$var$focusRingStyles = (0, $8Govx.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $hEh1s.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $hEh1s.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $hEh1s.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $hEh1s.borderWidthMap)['border.width'], " solid")
        }
    }
});
var $53e89314240745d3$var$baseStyles = (0, $8Govx.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $53e89314240745d3$var$enabledStyles = (0, $8Govx.css)({
    cursor: 'pointer'
});
var $53e89314240745d3$var$disabledStyles = (0, $8Govx.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $53e89314240745d3$var$Pressable = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $c3KQG.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $53e89314240745d3$var$_excluded);
    var interactionContext = (0, $dNMDr.useContext)((0, $hMip0.default));
    var handleClick = (0, $dNMDr.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $02D9g.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(htmlAttributes, $53e89314240745d3$var$_excluded2);
    var resolvedStyles = (0, $6LPEe.parseXcss)(xcss);
    return (0, $8Govx.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $53e89314240745d3$var$baseStyles,
            $53e89314240745d3$var$focusRingStyles,
            isDisabled ? $53e89314240745d3$var$disabledStyles : $53e89314240745d3$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $hEh1s.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $hEh1s.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $hEh1s.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $hEh1s.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $hEh1s.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $hEh1s.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $hEh1s.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $hEh1s.paddingStylesMap).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var $53e89314240745d3$export$2e2bcd8739ae039 = $53e89314240745d3$var$Pressable;

});
parcelRegister("6LPEe", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $4edf3214ffdd74dc$export$a9c84988c8f81f2d; });

var $62ppy = parcelRequire("62ppy");

var $91FVG = parcelRequire("91FVG");

var $82V4i = parcelRequire("82V4i");

var $a3ftr = parcelRequire("a3ftr");

var $8Govx = parcelRequire("8Govx");

var $hEh1s = parcelRequire("hEh1s");

var $4ilBr = parcelRequire("4ilBr");
function $4edf3214ffdd74dc$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $4edf3214ffdd74dc$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $4edf3214ffdd74dc$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4edf3214ffdd74dc$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4edf3214ffdd74dc$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4edf3214ffdd74dc$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $4edf3214ffdd74dc$export$9a199fbafee0014e = {
    backgroundColor: (0, $hEh1s.backgroundColorMap),
    blockSize: (0, $hEh1s.dimensionMap),
    borderBlockColor: (0, $hEh1s.borderColorMap),
    borderBlockEndColor: (0, $hEh1s.borderColorMap),
    borderBlockEndWidth: (0, $hEh1s.borderWidthMap),
    borderBlockStartColor: (0, $hEh1s.borderColorMap),
    borderBlockStartWidth: (0, $hEh1s.borderWidthMap),
    borderBlockWidth: (0, $hEh1s.borderWidthMap),
    borderBottomColor: (0, $hEh1s.borderColorMap),
    borderBottomLeftRadius: (0, $hEh1s.borderRadiusMap),
    borderBottomRightRadius: (0, $hEh1s.borderRadiusMap),
    borderBottomWidth: (0, $hEh1s.borderWidthMap),
    borderColor: (0, $hEh1s.borderColorMap),
    borderEndEndRadius: (0, $hEh1s.borderRadiusMap),
    borderEndStartRadius: (0, $hEh1s.borderRadiusMap),
    borderInlineColor: (0, $hEh1s.borderColorMap),
    borderInlineEndColor: (0, $hEh1s.borderColorMap),
    borderInlineEndWidth: (0, $hEh1s.borderWidthMap),
    borderInlineStartColor: (0, $hEh1s.borderColorMap),
    borderInlineStartWidth: (0, $hEh1s.borderWidthMap),
    borderInlineWidth: (0, $hEh1s.borderWidthMap),
    borderLeftColor: (0, $hEh1s.borderColorMap),
    borderLeftWidth: (0, $hEh1s.borderWidthMap),
    borderRadius: (0, $hEh1s.borderRadiusMap),
    borderRightColor: (0, $hEh1s.borderColorMap),
    borderRightWidth: (0, $hEh1s.borderWidthMap),
    borderStartEndRadius: (0, $hEh1s.borderRadiusMap),
    borderStartStartRadius: (0, $hEh1s.borderRadiusMap),
    borderTopColor: (0, $hEh1s.borderColorMap),
    borderTopLeftRadius: (0, $hEh1s.borderRadiusMap),
    borderTopRightRadius: (0, $hEh1s.borderRadiusMap),
    borderTopWidth: (0, $hEh1s.borderWidthMap),
    borderWidth: (0, $hEh1s.borderWidthMap),
    bottom: (0, $hEh1s.allSpaceMap),
    boxShadow: (0, $hEh1s.shadowMap),
    color: (0, $hEh1s.textColorMap),
    columnGap: (0, $hEh1s.positiveSpaceMap),
    font: (0, $hEh1s.fontMap),
    fontFamily: (0, $hEh1s.fontFamilyMap),
    fontWeight: (0, $hEh1s.fontWeightMap),
    gap: (0, $hEh1s.positiveSpaceMap),
    height: (0, $hEh1s.dimensionMap),
    inlineSize: (0, $hEh1s.dimensionMap),
    inset: (0, $hEh1s.allSpaceMap),
    insetBlock: (0, $hEh1s.allSpaceMap),
    insetBlockEnd: (0, $hEh1s.allSpaceMap),
    insetBlockStart: (0, $hEh1s.allSpaceMap),
    insetInline: (0, $hEh1s.allSpaceMap),
    insetInlineEnd: (0, $hEh1s.allSpaceMap),
    insetInlineStart: (0, $hEh1s.allSpaceMap),
    left: (0, $hEh1s.allSpaceMap),
    margin: (0, $hEh1s.allSpaceMap),
    marginBlock: (0, $hEh1s.allSpaceMap),
    marginBlockEnd: (0, $hEh1s.allSpaceMap),
    marginBlockStart: (0, $hEh1s.allSpaceMap),
    marginBottom: (0, $hEh1s.allSpaceMap),
    marginInline: (0, $hEh1s.allSpaceMap),
    marginInlineEnd: (0, $hEh1s.allSpaceMap),
    marginInlineStart: (0, $hEh1s.allSpaceMap),
    marginLeft: (0, $hEh1s.allSpaceMap),
    marginRight: (0, $hEh1s.allSpaceMap),
    marginTop: (0, $hEh1s.allSpaceMap),
    maxBlockSize: (0, $hEh1s.dimensionMap),
    maxHeight: (0, $hEh1s.dimensionMap),
    maxInlineSize: (0, $hEh1s.dimensionMap),
    maxWidth: (0, $hEh1s.dimensionMap),
    minBlockSize: (0, $hEh1s.dimensionMap),
    minHeight: (0, $hEh1s.dimensionMap),
    minInlineSize: (0, $hEh1s.dimensionMap),
    minWidth: (0, $hEh1s.dimensionMap),
    opacity: (0, $hEh1s.opacityMap),
    outlineColor: (0, $hEh1s.borderColorMap),
    outlineOffset: (0, $hEh1s.allSpaceMap),
    outlineWidth: (0, $hEh1s.borderWidthMap),
    padding: (0, $hEh1s.positiveSpaceMap),
    paddingBlock: (0, $hEh1s.positiveSpaceMap),
    paddingBlockEnd: (0, $hEh1s.positiveSpaceMap),
    paddingBlockStart: (0, $hEh1s.positiveSpaceMap),
    paddingBottom: (0, $hEh1s.positiveSpaceMap),
    paddingInline: (0, $hEh1s.positiveSpaceMap),
    paddingInlineEnd: (0, $hEh1s.positiveSpaceMap),
    paddingInlineStart: (0, $hEh1s.positiveSpaceMap),
    paddingLeft: (0, $hEh1s.positiveSpaceMap),
    paddingRight: (0, $hEh1s.positiveSpaceMap),
    paddingTop: (0, $hEh1s.positiveSpaceMap),
    right: (0, $hEh1s.allSpaceMap),
    rowGap: (0, $hEh1s.positiveSpaceMap),
    top: (0, $hEh1s.allSpaceMap),
    width: (0, $hEh1s.dimensionMap),
    zIndex: (0, $hEh1s.layerMap)
};
var $4edf3214ffdd74dc$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $4edf3214ffdd74dc$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $4ilBr === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))($4ilBr)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))($4ilBr.env) === 'object' && false;
};
var $4edf3214ffdd74dc$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $4edf3214ffdd74dc$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $4edf3214ffdd74dc$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($4edf3214ffdd74dc$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(value) === 'object' && $4edf3214ffdd74dc$var$safeSelectors.test(key)) {
            styleObj[key] = $4edf3214ffdd74dc$var$_transformStyles(value);
            return;
        }
        if ($4edf3214ffdd74dc$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($4edf3214ffdd74dc$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $4edf3214ffdd74dc$export$9a199fbafee0014e)) return;
        var tokenValue = $4edf3214ffdd74dc$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $4edf3214ffdd74dc$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $4edf3214ffdd74dc$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))({}, $4edf3214ffdd74dc$var$uniqueSymbol, (0, $8Govx.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $4edf3214ffdd74dc$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $4edf3214ffdd74dc$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $4edf3214ffdd74dc$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$4edf3214ffdd74dc$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $4edf3214ffdd74dc$export$f6c783d06584602c(style) {
    return $4edf3214ffdd74dc$var$baseXcss(style);
}

});


parcelRegister("jTt39", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7b9b00da40fb26b$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");
// Map lozenge colors to appropriate icon colors
var $e7b9b00da40fb26b$var$getIconColor = function getIconColor(color) {
    // For semantic colors, use corresponding semantic icon colors
    switch(color){
        case 'success':
            return "var(--ds-icon-success, #6A9A23)";
        case 'warning':
            return "var(--ds-icon-warning, #E06C00)";
        case 'danger':
            return "var(--ds-icon-danger, #C9372C)";
        case 'information':
            return "var(--ds-icon-information, #357DE8)";
        case 'neutral':
            return "var(--ds-icon-subtlest, #6B6E76)";
        case 'discovery':
            return "var(--ds-icon-discovery, #AF59E1)";
        // For accent colors, use corresponding accent icon colors
        case 'accent-red':
            return "var(--ds-icon-accent-red, #C9372C)";
        case 'accent-orange':
            return "var(--ds-icon-accent-orange, #E06C00)";
        case 'accent-yellow':
            return "var(--ds-icon-accent-yellow, #B38600)";
        case 'accent-lime':
            return "var(--ds-icon-accent-lime, #6A9A23)";
        case 'accent-green':
            return "var(--ds-icon-accent-green, #22A06B)";
        case 'accent-teal':
            return "var(--ds-icon-accent-teal, #2898BD)";
        case 'accent-blue':
            return "var(--ds-icon-accent-blue, #357DE8)";
        case 'accent-purple':
            return "var(--ds-icon-accent-purple, #AF59E1)";
        case 'accent-magenta':
            return "var(--ds-icon-accent-magenta, #CD519D)";
        case 'accent-gray':
            return "var(--ds-icon-accent-gray, #7D818A)";
        default:
            return "var(--ds-icon-subtlest, #6B6E76)";
    }
};
var $e7b9b00da40fb26b$export$32ff197eed95e568 = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $e7b9b00da40fb26b$var$getIconColor(color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var $e7b9b00da40fb26b$export$2e2bcd8739ae039 = $e7b9b00da40fb26b$export$32ff197eed95e568;

});

parcelRegister("86sLD", function(module, exports) {

$parcel$export(module.exports, "resolveLozengeColor", function () { return $5e6532de3b22fede$export$acf5d2b7dc999bda; });
$parcel$export(module.exports, "getThemeStyles", function () { return $5e6532de3b22fede$export$a3fc04b8551e006a; });
// Map legacy appearance to new color values
var $5e6532de3b22fede$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var $5e6532de3b22fede$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    return (_legacyAppearanceMap$ = $5e6532de3b22fede$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};
var $5e6532de3b22fede$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});





parcelRegister("8Atax", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fee44716b54b15ca$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $fee44716b54b15ca$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    logoutTitle: {
        id: 'logout.title',
        defaultMessage: 'Log out of your Atlassian account'
    }
});

});

parcelRegister("lpuXD", function(module, exports) {

$parcel$export(module.exports, "manageSession", function () { return $89e916cea1a27aaf$export$66e31b319f474a64; });
$parcel$export(module.exports, "continueWithCurrentSession", function () { return $89e916cea1a27aaf$export$5e0dba42c9dac553; });
$parcel$export(module.exports, "doLogout", function () { return $89e916cea1a27aaf$export$61d11f3cbabcb5f4; });

var $1JRGy = parcelRequire("1JRGy");

var $hH6uU = parcelRequire("hH6uU");

var $hqddj = parcelRequire("hqddj");
const $89e916cea1a27aaf$export$66e31b319f474a64 = (request, navigate, additionalParameters = {})=>(dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        dispatch({
            type: 'SESSION_REQUEST'
        });
        return fetch(`/rest/session`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(request)
        }).then((response)=>response.json().then((data)=>{
                if (response.ok) {
                    const redirectUrl = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parseUrl(data.redirectUrl);
                    const currentParameters = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(window.location.search);
                    const mergedQuery = {
                        ...currentParameters,
                        ...additionalParameters,
                        ...redirectUrl.query
                    };
                    return navigate(`${redirectUrl.url}?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(mergedQuery)}`);
                } else (0, $hqddj.captureErrorMessage)('manageSession failed', {
                    statusCode: response.status,
                    formErrors: data.formErrors
                });
            }));
    };
const $89e916cea1a27aaf$export$5e0dba42c9dac553 = (navigate)=>async ()=>{
        navigate(`/login${$89e916cea1a27aaf$var$getSanitizedQueryString()}`);
    };
const $89e916cea1a27aaf$export$61d11f3cbabcb5f4 = (continueUrl)=>async (dispatch, getState)=>{
        const state = getState();
        // [KIRBY-7902] TODO: replace with `submitFormHackReplacement` once the backend endpoint is ready.
        (0, $hH6uU.default)({
            method: 'POST',
            action: `/logout${$89e916cea1a27aaf$var$getSanitizedQueryString(continueUrl)}`,
            payload: {
                csrfToken: state.hashedCsrfToken
            }
        });
    };
const $89e916cea1a27aaf$var$getSanitizedQueryString = (continueUrl)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(window.location.search);
    delete params.login_hint;
    delete params.prompt;
    if (continueUrl) params.continue = continueUrl;
    const paramsString = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(params);
    return paramsString && `?${paramsString}`;
};

});
parcelRegister("hH6uU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2b483a4c9f43181$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "submitFormHackReplacement", function () { return $d2b483a4c9f43181$export$79d03e6f07528b0a; });
/**
 * This is the type definition for the submitFormHack as-is, so that I can re-use it in the replacement function.
 */ function $d2b483a4c9f43181$export$2e2bcd8739ae039({ method: method, action: action = '', payload: payload, skipSanitizationKeys: skipSanitizationKeys = [] }) {
    const form = document.createElement('form');
    form.style.display = 'none';
    form.method = method;
    form.action = action;
    if (payload) Object.entries(payload).filter(([, value])=>value != null).forEach(([name, value])=>{
        const input = document.createElement('input');
        input.name = $d2b483a4c9f43181$var$sanitizeInput(name);
        input.value = skipSanitizationKeys.includes(name) ? String(value) : $d2b483a4c9f43181$var$sanitizeInput(String(value));
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}
/**
 * This function takes an input string, assigns it to the textContent property of a newly created div,
 * and then returns the sanitized HTML content of the div. Since textContent does not parse HTML,
 * any harmful tags or scripts in the input will be treated as plain text, not as code.
 *
 * i.e.:
 * sanitizeInput("<script>window.alert('hi')</script>") -> "&lt;script&gt;window.alert('hi')&lt;/script&gt;"
 *
 * https://asecurityteam.atlassian.net/browse/VULN-1229071
 */ function $d2b483a4c9f43181$var$sanitizeInput(input) {
    const div = document.createElement('div');
    div.textContent = input;
    return div.innerHTML;
}
function $d2b483a4c9f43181$export$79d03e6f07528b0a({ method: method = 'POST', action: action = '', payload: payload, csrfToken: csrfToken, enablePassingCookies: enablePassingCookies = false }) {
    const requestPromise = fetch(action, {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            ...csrfToken ? {
                'X-CSRF-TOKEN': csrfToken
            } : {},
            ...enablePassingCookies ? {
                credentials: 'same-origin'
            } : {}
        },
        body: JSON.stringify(payload)
    });
    return requestPromise;
}

});



parcelRegister("jXtDs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "pageId", function () { return $58ec41ce673e9ea8$export$703ba2e7ea526c1b; });
$parcel$export(module.exports, "stepUpSsoLoader", function () { return $58ec41ce673e9ea8$export$947a31480e10f4f8; });
$parcel$export(module.exports, "StepUpSsoPage", function () { return $58ec41ce673e9ea8$export$61fae207a78c2e53; });
$parcel$export(module.exports, "default", function () { return $58ec41ce673e9ea8$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $cpaps = parcelRequire("cpaps");

var $Q6OOA = parcelRequire("Q6OOA");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $5pCRv = parcelRequire("5pCRv");

var $idMOo = parcelRequire("idMOo");

var $cuZAx = parcelRequire("cuZAx");

var $aMBBA = parcelRequire("aMBBA");

var $6zOZE = parcelRequire("6zOZE");

var $lwrli = parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $4NPio = parcelRequire("4NPio");

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $2byD0 = parcelRequire("2byD0");

var $arnOv = parcelRequire("arnOv");

var $79HVl = parcelRequire("79HVl");

var $hqddj = parcelRequire("hqddj");

var $9snhd = parcelRequire("9snhd");
var $lupi5 = parcelRequire("lupi5");
var $dPurX = parcelRequire("dPurX");
var $ihPx0 = parcelRequire("ihPx0");
var $8Du6M = parcelRequire("8Du6M");
var $lgmV7 = parcelRequire("lgmV7");

var $cTzf6 = parcelRequire("cTzf6");

var $h4v4M = parcelRequire("h4v4M");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");
const $58ec41ce673e9ea8$export$703ba2e7ea526c1b = 'stepUpSsoScreen';
const $58ec41ce673e9ea8$var$SecondaryLinkWrapper = (0, $fbSBq.default).ul`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $58ec41ce673e9ea8$var$PadlockImageContainer = (0, $fbSBq.default).div`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($arnOv)))}) no-repeat center bottom;
  background-size: contain;
  height: 140px;
  margin: ${(0, $68HQw.gridSize)()}px 0 ${(0, $68HQw.gridSize)() * 2}px;
`;
async function $58ec41ce673e9ea8$export$947a31480e10f4f8({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/step-up/sso/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $58ec41ce673e9ea8$export$61fae207a78c2e53 = ()=>{
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const oidcContext = (0, $aMBBA.useAppSelector)((state)=>state.microbranding.oidcContext);
    const ssoSamlRedirectUrl = (0, $aMBBA.useAppSelector)((state)=>state.stepUpSso.ssoRedirectUrl);
    const idpDetails = (0, $aMBBA.useAppSelector)((state)=>state.stepUpSso.idp);
    const isMobile = (0, $cuZAx.isMobileOidc)(oidcContext);
    const { search: search } = (0, $cVnBY.useLocation)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const returnLoginLink = `/login/select-account${search}`;
    const intl = (0, $ko1o6.default)();
    const [isWarningModalOpen, setWarningModalOpen] = (0, $dNMDr.useState)(false);
    const eventFlowValue = idpDetails.trusted ? 'trusted-idp' : 'untrusted-idp';
    const shouldOpenWarningModalOnVerify = !idpDetails.trusted && ssoSamlRedirectUrl;
    (0, $4NPio.usePageViewedEvent)($58ec41ce673e9ea8$export$703ba2e7ea526c1b, {
        flow: eventFlowValue
    });
    (0, $4NPio.useOperationalEvent)({
        page: $58ec41ce673e9ea8$export$703ba2e7ea526c1b,
        action: `loadStepUpSsoPageSuccessful`,
        subject: 'sli'
    });
    const handleVerify = ()=>{
        analyticsClient.buttonClickedEvent($58ec41ce673e9ea8$export$703ba2e7ea526c1b, 'verify', {
            flow: eventFlowValue
        });
        if (ssoSamlRedirectUrl) navigate(ssoSamlRedirectUrl);
        else {
            (0, $hqddj.captureErrorMessage)('StepUpSsoPage verify failed: ssoSamlRedirectUrl not available');
            navigate('/login?errorCode=step_up_sso_saml_redirect_url_not_available');
        }
    };
    const openWarningModal = (0, $dNMDr.useCallback)(()=>{
        analyticsClient.buttonClickedEvent($58ec41ce673e9ea8$export$703ba2e7ea526c1b, 'verify', {
            flow: eventFlowValue
        });
        setWarningModalOpen(true);
    }, [
        analyticsClient,
        eventFlowValue
    ]);
    const closeWarningModal = (0, $dNMDr.useCallback)(()=>{
        analyticsClient.buttonClickedEvent($58ec41ce673e9ea8$export$703ba2e7ea526c1b, 'close-warning-modal');
        setWarningModalOpen(false);
    }, [
        analyticsClient
    ]);
    const handleReturnToLogin = ()=>{
        analyticsClient.linkClickedEvent($58ec41ce673e9ea8$export$703ba2e7ea526c1b, 'switchAccount');
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)("title", {
                    children: intl.formatMessage((0, $6zOZE.default).stepUpSsoHeader)
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
                pageId: $58ec41ce673e9ea8$export$703ba2e7ea526c1b,
                header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...(0, $6zOZE.default).stepUpSsoHeader,
                    tagName: "h5"
                }),
                footer: /*#__PURE__*/ (0, $6CtE1.jsxs)("ul", {
                    className: "fine-print",
                    children: [
                        /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.PrivacyPolicyLink), {
                                isMobileLink: isMobile
                            })
                        }),
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $idMOo.default), {}),
                        /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.UserNoticeLink), {
                                isMobileLink: isMobile
                            })
                        })
                    ]
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6CtE1.Fragment), {
                    children: !isMobile && /*#__PURE__*/ (0, $6CtE1.jsx)("ul", {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)($58ec41ce673e9ea8$var$SecondaryLinkWrapper, {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.Link), {
                                    id: "return-to-login",
                                    "data-testid": "return-to-login",
                                    to: returnLoginLink,
                                    onClick: handleReturnToLogin,
                                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                        ...(0, $6zOZE.default).stepUpSsoReturnToLogin
                                    })
                                })
                            })
                        })
                    })
                }),
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)($58ec41ce673e9ea8$var$PadlockImageContainer, {}),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $6zOZE.default).stepUpSsoDescription1,
                        tagName: "p"
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $6zOZE.default).stepUpSsoDescription2,
                        tagName: "p"
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                            id: "step-up-sso-button",
                            appearance: "primary",
                            type: 'button',
                            onClick: shouldOpenWarningModalOnVerify ? openWarningModal : handleVerify,
                            isFullWidth: true,
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                ...(0, $6zOZE.default).stepUpSsoVerifyButton
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lgmV7.default), {
                children: isWarningModalOpen && /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $9snhd.default), {
                    onClose: closeWarningModal,
                    width: "small",
                    children: [
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ihPx0.default), {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8Du6M.default), {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    ...(0, $6zOZE.default).stepUpSsoWarningModalHeader
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $lupi5.default), {
                            children: [
                                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    ...(0, $6zOZE.default).stepUpSsoWarningModalDescription1,
                                    tagName: "p",
                                    values: {
                                        idpRedirectLocation: /*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                                            children: idpDetails.humanReadableRedirectLocation
                                        })
                                    }
                                }),
                                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    ...(0, $6zOZE.default).stepUpSsoWarningModalDescription2,
                                    tagName: "p"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $dPurX.default), {
                            children: [
                                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cTzf6.default), {
                                    appearance: "subtle",
                                    onClick: closeWarningModal,
                                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                        ...(0, $6zOZE.default).stepUpWarningCancelButton
                                    })
                                }),
                                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cTzf6.default), {
                                    id: "continue-step-up",
                                    appearance: "primary",
                                    onClick: handleVerify,
                                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                        ...(0, $6zOZE.default).stepUpSsoWarningLogInButton
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $58ec41ce673e9ea8$export$2e2bcd8739ae039 = $58ec41ce673e9ea8$export$61fae207a78c2e53;

});
parcelRegister("6zOZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8da5eee0eaa1083$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $b8da5eee0eaa1083$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    stepUpSsoHeader: {
        id: 'stepUp.sso.header',
        defaultMessage: 'Verify your identity'
    },
    stepUpSsoReturnToLogin: {
        id: 'stepUp.sso.return.to.login',
        defaultMessage: 'Need to log in to a different account?'
    },
    stepUpSsoDescription1: {
        id: 'stepUp.sso.description1',
        defaultMessage: 'To access this content, you need to log in with single sign-on and verify your identity.'
    },
    stepUpSsoDescription2: {
        id: 'stepUp.sso.description2',
        defaultMessage: "If you\u2019re unable to log in, contact the admin."
    },
    stepUpSsoVerifyButton: {
        id: 'stepUp.sso.button.verify',
        defaultMessage: 'Verify'
    },
    stepUpSsoWarningModalHeader: {
        id: 'stepUp.sso.warning.modal.header',
        defaultMessage: 'Log in to verify identity'
    },
    stepUpSsoWarningModalDescription1: {
        id: 'stepUp.sso.warning.modal.description',
        defaultMessage: "You\u2019re about to leave Atlassian with this external link {idpRedirectLocation}"
    },
    stepUpSsoWarningModalDescription2: {
        id: 'stepUp.sso.warning.modal.description2',
        defaultMessage: 'If you trust the link, then continue to log in with single sign-on.'
    },
    stepUpSsoWarningLogInButton: {
        id: 'stepUp.sso.warning.log.in.button',
        defaultMessage: 'Log in'
    },
    stepUpWarningCancelButton: {
        id: 'stepUp.warning.cancel.button',
        defaultMessage: 'Cancel'
    }
});

});

parcelRegister("9snhd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e28c8de006c4a25$export$2e2bcd8739ae039; });

var $aFyVI = parcelRequire("aFyVI");

var $dNMDr = parcelRequire("dNMDr");

var $4R9sa = parcelRequire("4R9sa");
function $6e28c8de006c4a25$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $4R9sa.default), (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, props, {
        isFullScreen: false
    }));
}

});
parcelRegister("4R9sa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $389371e9e31764ff$export$2e2bcd8739ae039; });
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $5YXBW = parcelRequire("5YXBW");

var $bYxNM = parcelRequire("bYxNM");

var $02D9g = parcelRequire("02D9g");

var $fBYfd = parcelRequire("fBYfd");

var $c3KQG = parcelRequire("c3KQG");

var $3WqMD = parcelRequire("3WqMD");

var $Xcbzo = parcelRequire("Xcbzo");

var $5fkkM = parcelRequire("5fkkM");

var $1w48L = parcelRequire("1w48L");

var $gWqO2 = parcelRequire("gWqO2");

var $4SHCx = parcelRequire("4SHCx");

var $68Qpe = parcelRequire("68Qpe");

var $iYO6y = parcelRequire("iYO6y");
var $389371e9e31764ff$var$fillScreenStyles = null;
var $389371e9e31764ff$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $389371e9e31764ff$var$InternalModalWrapper = function InternalModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $c3KQG.default) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId, isFullScreen = props.isFullScreen;
    var calculatedStackIndex = (0, $4SHCx.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    var onCloseHandler = (0, $02D9g.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $c3KQG.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "14.11.1"
    });
    var onBlanketClicked = (0, $dNMDr.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $dNMDr.useCallback)(function(element) {
        return $389371e9e31764ff$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $68Qpe.default)();
    (0, $Xcbzo.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Modal dialog is conditionally rendered when visible, so when this runs it is always open.
        isOpen: true,
        // Passing a no-op for now, as there isn't a real use case for closing the modal dialog programmatically
        // by the OpenLayerObserver. The only current use case is closing layers when resizing the nav layout,
        // which cannot happen while a modal dialog is open.
        onClose: (0, $c3KQG.default)
    });
    var modalDialogWithBlanket = /*#__PURE__*/ $dNMDr.createElement((0, $fBYfd.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, /*#__PURE__*/ $dNMDr.createElement((0, $iYO6y.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ $dNMDr.createElement((0, $3WqMD.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $dNMDr.createElement((0, $1w48L.default), {
        zIndex: (0, $gWqO2.layers).modal()
    }, /*#__PURE__*/ $dNMDr.createElement((0, $5fkkM.default), null, function(fadeInProps) {
        return /*#__PURE__*/ $dNMDr.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, fadeInProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $affTb.default)([
                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }), /*#__PURE__*/ $dNMDr.createElement((0, $5YXBW.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $dNMDr.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bYxNM))), null), shouldScrollInViewport ? /*#__PURE__*/ $dNMDr.createElement((0, $bYxNM.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $389371e9e31764ff$export$2e2bcd8739ae039 = $389371e9e31764ff$var$InternalModalWrapper;

});
parcelRegister("5YXBW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45b0cbd9db230fde$export$2e2bcd8739ae039; });

var $1vFDx = parcelRequire("1vFDx");

var $45b0cbd9db230fde$export$2e2bcd8739ae039 = (0, $1vFDx.default);

});
parcelRegister("1vFDx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1198fbdb473ee11b$export$2e2bcd8739ae039; });

var $4wTfY = parcelRequire("4wTfY");

var $lqyXr = parcelRequire("lqyXr");

var $dNMDr = parcelRequire("dNMDr");

var $h6vuf = parcelRequire("h6vuf");

var $6waqU = parcelRequire("6waqU");
var $1198fbdb473ee11b$var$FocusLockCombination = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $h6vuf.default), (0, $lqyXr.default)({
        sideCar: (0, $6waqU.default),
        ref: ref
    }, props));
});
var $1198fbdb473ee11b$var$_ref = (0, $h6vuf.default).propTypes || {}, $1198fbdb473ee11b$var$sideCar = $1198fbdb473ee11b$var$_ref.sideCar, $1198fbdb473ee11b$var$propTypes = (0, $4wTfY.default)($1198fbdb473ee11b$var$_ref, [
    "sideCar"
]);
$1198fbdb473ee11b$var$FocusLockCombination.propTypes = {};
var $1198fbdb473ee11b$export$2e2bcd8739ae039 = $1198fbdb473ee11b$var$FocusLockCombination;

});
parcelRegister("h6vuf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c73b6bdad044d9cb$export$2e2bcd8739ae039; });

var $lqyXr = parcelRequire("lqyXr");

var $dNMDr = parcelRequire("dNMDr");


var $kvebB = parcelRequire("kvebB");

var $1xw1k = parcelRequire("1xw1k");

var $hX9H1 = parcelRequire("hX9H1");

var $iDHRL = parcelRequire("iDHRL");

var $5q4MI = parcelRequire("5q4MI");
var $c73b6bdad044d9cb$var$emptyArray = [];
var $c73b6bdad044d9cb$var$FocusLock = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $dNMDr.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $dNMDr.useRef)();
    var isActive = (0, $dNMDr.useRef)(false);
    var originalFocusedElement = (0, $dNMDr.useRef)(null);
    var _useState2 = (0, $dNMDr.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $c73b6bdad044d9cb$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $dNMDr.useState)({}), id = _useState3[0];
    var onActivation = (0, $dNMDr.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $dNMDr.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $dNMDr.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $dNMDr.useCallback)(function(event) {
        if (isActive.current) (0, $iDHRL.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $iDHRL.mediumBlur).useMedium;
    var setObserveNode = (0, $dNMDr.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $lqyXr.default)((_extends2 = {}, _extends2[0, $kvebB.FOCUS_DISABLED] = disabled && 'disabled', _extends2[0, $kvebB.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $1xw1k.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $dNMDr.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            get active () {
                return isActive.current;
            }
        };
    }, [
        disabled,
        isActive,
        shards,
        observed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dNMDr.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $hX9H1.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $hX9H1.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(SideCar, {
        id: id,
        sideCar: (0, $iDHRL.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(Container, (0, $lqyXr.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $5q4MI.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $hX9H1.hiddenGuard)
    }));
});
$c73b6bdad044d9cb$var$FocusLock.propTypes = {};
var $c73b6bdad044d9cb$export$2e2bcd8739ae039 = $c73b6bdad044d9cb$var$FocusLock;

});
parcelRegister("kvebB", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", function () { return $eed1b4f2d6a84fa1$export$4f9a06cb7441a087; });
$parcel$export(module.exports, "FOCUS_DISABLED", function () { return $eed1b4f2d6a84fa1$export$aeda8252e54b50f7; });
$parcel$export(module.exports, "FOCUS_ALLOW", function () { return $eed1b4f2d6a84fa1$export$54ecf528c58f9ef6; });
$parcel$export(module.exports, "FOCUS_AUTO", function () { return $eed1b4f2d6a84fa1$export$70e9b4a1820af101; });
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", function () { return $eed1b4f2d6a84fa1$export$134ebef29fd94853; });
/**
 * defines a focus group
 */ var $eed1b4f2d6a84fa1$export$4f9a06cb7441a087 = 'data-focus-lock';
var $eed1b4f2d6a84fa1$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $eed1b4f2d6a84fa1$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $eed1b4f2d6a84fa1$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $eed1b4f2d6a84fa1$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("1xw1k", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $11f1b61fefead238$export$74665b213cb5c4cf; });

var $dNMDr = parcelRequire("dNMDr");

var $713F5 = parcelRequire("713F5");

var $lSzjE = parcelRequire("lSzjE");
var $11f1b61fefead238$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $dNMDr.useLayoutEffect : $dNMDr.useEffect;
var $11f1b61fefead238$var$currentValues = new WeakMap();
function $11f1b61fefead238$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $lSzjE.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $713F5.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $11f1b61fefead238$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $11f1b61fefead238$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $713F5.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $713F5.assignRef)(ref, current_1);
            });
        }
        $11f1b61fefead238$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("713F5", function(module, exports) {

$parcel$export(module.exports, "assignRef", function () { return $51bb7782f9b94613$export$d734136a7b018efe; });
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $51bb7782f9b94613$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("lSzjE", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", function () { return $feda091f1e2ba3eb$export$25bec8c6f54ee79a; });

var $dNMDr = parcelRequire("dNMDr");
function $feda091f1e2ba3eb$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $dNMDr.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("hX9H1", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", function () { return $d11f772a0deed532$export$b8c7b07253306600; });

var $dNMDr = parcelRequire("dNMDr");

var $d11f772a0deed532$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $d11f772a0deed532$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dNMDr.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $d11f772a0deed532$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $d11f772a0deed532$export$b8c7b07253306600
    }));
};
$d11f772a0deed532$var$InFocusGuard.propTypes = {};
var $d11f772a0deed532$export$2e2bcd8739ae039 = $d11f772a0deed532$var$InFocusGuard;

});

parcelRegister("iDHRL", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", function () { return $d91de56940350a69$export$5733e022b1d538cb; });
$parcel$export(module.exports, "mediumBlur", function () { return $d91de56940350a69$export$b3e9a9312f73723c; });
$parcel$export(module.exports, "mediumEffect", function () { return $d91de56940350a69$export$3a1d52767cbc07b8; });
$parcel$export(module.exports, "mediumSidecar", function () { return $d91de56940350a69$export$892cbf28e5518020; });

var $fmR4f = parcelRequire("fmR4f");
var $d91de56940350a69$export$5733e022b1d538cb = (0, $fmR4f.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $d91de56940350a69$export$b3e9a9312f73723c = (0, $fmR4f.createMedium)();
var $d91de56940350a69$export$3a1d52767cbc07b8 = (0, $fmR4f.createMedium)();
var $d91de56940350a69$export$892cbf28e5518020 = (0, $fmR4f.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("fmR4f", function(module, exports) {

$parcel$export(module.exports, "createMedium", function () { return $b30213302500cb04$export$9ffbfcaf067b02c6; });
$parcel$export(module.exports, "createSidecarMedium", function () { return $b30213302500cb04$export$e13ec7dd7a14088d; });

var $hwth3 = parcelRequire("hwth3");
function $b30213302500cb04$var$ItoI(a) {
    return a;
}
function $b30213302500cb04$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $b30213302500cb04$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $b30213302500cb04$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $b30213302500cb04$var$ItoI;
    return $b30213302500cb04$var$innerCreateMedium(defaults, middleware);
}
function $b30213302500cb04$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $b30213302500cb04$var$innerCreateMedium(null);
    medium.options = (0, $hwth3.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("5q4MI", function(module, exports) {

$parcel$export(module.exports, "focusScope", function () { return $3f231795a578f019$export$f5272e9b1168239c; });

var $dNMDr = parcelRequire("dNMDr");
var $3f231795a578f019$export$f5272e9b1168239c = /*#__PURE__*/ (0, $dNMDr.createContext)(undefined);

});


parcelRegister("6waqU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bedd30721a46a54$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");


var $jC87y = parcelRequire("jC87y");

var $dufEp = parcelRequire("dufEp");
var $4wF70 = parcelRequire("4wF70");
var $7t3ll = parcelRequire("7t3ll");
var $ieTuz = parcelRequire("ieTuz");
var $hh2Ah = parcelRequire("hh2Ah");
var $4PLeF = parcelRequire("4PLeF");parcelRequire("lGcEY");
var $19Yys = parcelRequire("19Yys");

var $6r3Qw = parcelRequire("6r3Qw");

var $iDHRL = parcelRequire("iDHRL");
var $4bedd30721a46a54$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $4bedd30721a46a54$var$isFreeFocus = function isFreeFocus() {
    return $4bedd30721a46a54$var$focusOnBody() || (0, $hh2Ah.focusIsHidden)();
};
var $4bedd30721a46a54$var$lastActiveTrap = null;
var $4bedd30721a46a54$var$lastActiveFocus = null;
var $4bedd30721a46a54$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $4bedd30721a46a54$var$lastPortaledElement = null;
var $4bedd30721a46a54$var$focusWasOutsideWindow = false;
var $4bedd30721a46a54$var$windowFocused = false;
var $4bedd30721a46a54$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $4bedd30721a46a54$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($4bedd30721a46a54$var$lastActiveTrap.whiteList || $4bedd30721a46a54$var$defaultWhitelist)(activeElement);
};
var $4bedd30721a46a54$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $4bedd30721a46a54$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $4bedd30721a46a54$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $4bedd30721a46a54$var$lastPortaledElement && $4bedd30721a46a54$var$lastPortaledElement.portaledElement === element;
};
function $4bedd30721a46a54$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $4bedd30721a46a54$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($4bedd30721a46a54$var$focusWasOutsideWindow);
    return $4bedd30721a46a54$var$focusWasOutsideWindow === 'meanwhile';
};
var $4bedd30721a46a54$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $4bedd30721a46a54$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $4bedd30721a46a54$var$checkInHost(activeElement, area, area);
    });
};
var $4bedd30721a46a54$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $4PLeF.getFocusableNodes)(nodes, new Map());
};
var $4bedd30721a46a54$var$isNotFocusable = function isNotFocusable(node) {
    return !$4bedd30721a46a54$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $4bedd30721a46a54$var$activateTrap = function activateTrap() {
    var result = false;
    if ($4bedd30721a46a54$var$lastActiveTrap) {
        var _lastActiveTrap = $4bedd30721a46a54$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $4bedd30721a46a54$var$lastPortaledElement && $4bedd30721a46a54$var$lastPortaledElement.portaledElement;
        if ($4bedd30721a46a54$var$focusOnBody() && $4bedd30721a46a54$var$lastActiveFocus && $4bedd30721a46a54$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($4bedd30721a46a54$var$lastActiveFocus) || $4bedd30721a46a54$var$isNotFocusable($4bedd30721a46a54$var$lastActiveFocus)) {
                var newTarget = $4bedd30721a46a54$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $6r3Qw.extractRef)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$4bedd30721a46a54$var$focusWasOutside(crossFrame) || !noFocusGuards || !$4bedd30721a46a54$var$lastActiveFocus || $4bedd30721a46a54$var$windowFocused) return false;
                var nodes = $4bedd30721a46a54$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $4bedd30721a46a54$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $4bedd30721a46a54$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$4bedd30721a46a54$var$isFreeFocus() || !$4bedd30721a46a54$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $ieTuz.focusInside)(workingArea) || activeElement && $4bedd30721a46a54$var$withinHost(activeElement, workingArea) || $4bedd30721a46a54$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$4bedd30721a46a54$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $19Yys.moveFocusInside)(workingArea, $4bedd30721a46a54$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $4bedd30721a46a54$var$lastPortaledElement = {};
                        }
                    }
                    $4bedd30721a46a54$var$lastActiveFocus = document && document.activeElement;
                    if ($4bedd30721a46a54$var$lastActiveFocus !== document.body) $4bedd30721a46a54$var$tryRestoreFocus = (0, $dufEp.captureFocusRestore)($4bedd30721a46a54$var$lastActiveFocus);
                    $4bedd30721a46a54$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $4wF70.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $4bedd30721a46a54$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $4bedd30721a46a54$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $4bedd30721a46a54$var$onTrap = function onTrap(event) {
    if ($4bedd30721a46a54$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $4bedd30721a46a54$var$onBlur = function onBlur() {
    return (0, $6r3Qw.deferAction)($4bedd30721a46a54$var$activateTrap);
};
var $4bedd30721a46a54$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $4bedd30721a46a54$var$recordPortal(currentNode, source);
};
var $4bedd30721a46a54$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $4bedd30721a46a54$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
        onBlur: $4bedd30721a46a54$var$onBlur,
        onFocus: $4bedd30721a46a54$var$onFocus
    }, children);
};
$4bedd30721a46a54$var$FocusTrap.propTypes = {};
var $4bedd30721a46a54$var$onWindowFocus = function onWindowFocus() {
    $4bedd30721a46a54$var$windowFocused = true;
};
var $4bedd30721a46a54$var$onWindowBlur = function onWindowBlur() {
    $4bedd30721a46a54$var$windowFocused = false;
    $4bedd30721a46a54$var$focusWasOutsideWindow = 'just';
    (0, $6r3Qw.deferAction)(function() {
        $4bedd30721a46a54$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $4bedd30721a46a54$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $4bedd30721a46a54$var$onTrap);
    document.addEventListener('focusout', $4bedd30721a46a54$var$onBlur);
    window.addEventListener('focus', $4bedd30721a46a54$var$onWindowFocus);
    window.addEventListener('blur', $4bedd30721a46a54$var$onWindowBlur);
};
var $4bedd30721a46a54$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $4bedd30721a46a54$var$onTrap);
    document.removeEventListener('focusout', $4bedd30721a46a54$var$onBlur);
    window.removeEventListener('focus', $4bedd30721a46a54$var$onWindowFocus);
    window.removeEventListener('blur', $4bedd30721a46a54$var$onWindowBlur);
};
function $4bedd30721a46a54$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $4bedd30721a46a54$var$focusLockAPI = {
    moveFocusInside: (0, $19Yys.moveFocusInside),
    focusInside: (0, $ieTuz.focusInside),
    focusNextElement: (0, $7t3ll.focusNextElement),
    focusPrevElement: (0, $7t3ll.focusPrevElement),
    focusFirstElement: (0, $7t3ll.focusFirstElement),
    focusLastElement: (0, $7t3ll.focusLastElement),
    captureFocusRestore: (0, $dufEp.captureFocusRestore)
};
function $4bedd30721a46a54$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$4bedd30721a46a54$var$lastActiveTrap) $4bedd30721a46a54$var$attachHandler();
    var lastTrap = $4bedd30721a46a54$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $4bedd30721a46a54$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $4bedd30721a46a54$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($4bedd30721a46a54$var$focusLockAPI);
        $4bedd30721a46a54$var$activateTrap(true);
        (0, $6r3Qw.deferAction)($4bedd30721a46a54$var$activateTrap);
    } else {
        $4bedd30721a46a54$var$detachHandler();
        $4bedd30721a46a54$var$lastActiveFocus = null;
    }
}
(0, $iDHRL.mediumFocus).assignSyncMedium($4bedd30721a46a54$var$onFocus);
(0, $iDHRL.mediumBlur).assignMedium($4bedd30721a46a54$var$onBlur);
(0, $iDHRL.mediumEffect).assignMedium(function(cb) {
    return cb($4bedd30721a46a54$var$focusLockAPI);
});
var $4bedd30721a46a54$export$2e2bcd8739ae039 = (0, $jC87y.default)($4bedd30721a46a54$var$reducePropsToState, $4bedd30721a46a54$var$handleStateChangeOnClient)($4bedd30721a46a54$var$FocusWatcher);

});
parcelRegister("jC87y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e477dd9483dc5fbb$export$2e2bcd8739ae039; });

var $j78Lj = parcelRequire("j78Lj");

var $dlog4 = parcelRequire("dlog4");

var $dNMDr = parcelRequire("dNMDr");
function $e477dd9483dc5fbb$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $j78Lj.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $dNMDr.PureComponent));
        (0, $dlog4.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $e477dd9483dc5fbb$export$2e2bcd8739ae039 = $e477dd9483dc5fbb$var$withSideEffect;

});
parcelRegister("j78Lj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dea577b87921fa1b$export$2e2bcd8739ae039; });

var $7vgmz = parcelRequire("7vgmz");
function $dea577b87921fa1b$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $7vgmz.default)(t, o);
}

});
parcelRegister("7vgmz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57681f00f73c6b44$export$2e2bcd8739ae039; });
function $57681f00f73c6b44$export$2e2bcd8739ae039(t, e) {
    return $57681f00f73c6b44$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $57681f00f73c6b44$export$2e2bcd8739ae039(t, e);
}

});



parcelRegister("dufEp", function(module, exports) {

$parcel$export(module.exports, "captureFocusRestore", function () { return $9d1a3799349fac90$export$d357db6e554ff59a; });

var $4PLeF = parcelRequire("4PLeF");
function $9d1a3799349fac90$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $9d1a3799349fac90$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $9d1a3799349fac90$var$weakRef(currentElement),
            parent: $9d1a3799349fac90$var$weakRef(currentElement.parentElement),
            left: $9d1a3799349fac90$var$weakRef(currentElement.previousElementSibling),
            right: $9d1a3799349fac90$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $9d1a3799349fac90$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $9d1a3799349fac90$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $4PLeF.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $9d1a3799349fac90$export$d357db6e554ff59a = function(targetElement) {
    var location = $9d1a3799349fac90$export$5061a7725be48ff9(targetElement);
    return function() {
        return $9d1a3799349fac90$var$restoreFocusTo(location);
    };
};

});
parcelRegister("4PLeF", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", function () { return $385090d497cc7175$export$2f70373d403a5d2b; });
$parcel$export(module.exports, "getTabbableNodes", function () { return $385090d497cc7175$export$3738e313571e2ad2; });
$parcel$export(module.exports, "getFocusableNodes", function () { return $385090d497cc7175$export$493d05a3a8e6532d; });
$parcel$export(module.exports, "parentAutofocusables", function () { return $385090d497cc7175$export$dc26309a71d1ce47; });
$parcel$export(module.exports, "contains", function () { return $385090d497cc7175$export$2344b14b097df817; });

var $4ojrw = parcelRequire("4ojrw");

var $dD9Yr = parcelRequire("dD9Yr");

var $3qnhL = parcelRequire("3qnhL");

var $jwK2n = parcelRequire("jwK2n");
var $385090d497cc7175$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $4ojrw.toArray)(nodes).filter(function(node) {
        return (0, $dD9Yr.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $dD9Yr.notHiddenInput)(node);
    });
};
var $385090d497cc7175$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $4ojrw.toArray)(nodes).filter(function(node) {
        return (0, $dD9Yr.isAutoFocusAllowedCached)(cache, node);
    });
};
var $385090d497cc7175$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $3qnhL.orderByTabIndex)($385090d497cc7175$export$6266a5cd5915dc33((0, $jwK2n.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $385090d497cc7175$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $3qnhL.orderByTabIndex)($385090d497cc7175$export$6266a5cd5915dc33((0, $jwK2n.getFocusables)(topNodes), visibilityCache), false);
};
var $385090d497cc7175$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $385090d497cc7175$export$6266a5cd5915dc33((0, $jwK2n.getParentAutofocusables)(topNode), visibilityCache);
};
var $385090d497cc7175$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $385090d497cc7175$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $4ojrw.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $385090d497cc7175$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $385090d497cc7175$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("4ojrw", function(module, exports) {

$parcel$export(module.exports, "toArray", function () { return $33287c48df3660dc$export$45b10814cc054894; });
$parcel$export(module.exports, "asArray", function () { return $33287c48df3660dc$export$75093a47a9fa838d; });
$parcel$export(module.exports, "getFirst", function () { return $33287c48df3660dc$export$bcd7afcd904dce14; });
/*
IE11 support
 */ var $33287c48df3660dc$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $33287c48df3660dc$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $33287c48df3660dc$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("dD9Yr", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", function () { return $9ec6a779d2292f11$export$3c9dc299685ad160; });
$parcel$export(module.exports, "isAutoFocusAllowedCached", function () { return $9ec6a779d2292f11$export$bcaa50628f6a736e; });
$parcel$export(module.exports, "getDataset", function () { return $9ec6a779d2292f11$export$698b339b0c8edae3; });
$parcel$export(module.exports, "isRadioElement", function () { return $9ec6a779d2292f11$export$9d74f6fbc6f469d0; });
$parcel$export(module.exports, "notHiddenInput", function () { return $9ec6a779d2292f11$export$8197b0ea56b3b055; });
$parcel$export(module.exports, "isGuard", function () { return $9ec6a779d2292f11$export$d94b8b58ec2f30eb; });
$parcel$export(module.exports, "isNotAGuard", function () { return $9ec6a779d2292f11$export$602e5a0d338d7750; });
$parcel$export(module.exports, "isDefined", function () { return $9ec6a779d2292f11$export$4e62c701997796c1; });

var $kvebB = parcelRequire("kvebB");
var $9ec6a779d2292f11$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $9ec6a779d2292f11$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $9ec6a779d2292f11$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $9ec6a779d2292f11$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $9ec6a779d2292f11$var$isVisibleUncached = function(node, checkParent) {
    return !node || $9ec6a779d2292f11$var$isTopNode(node) || !$9ec6a779d2292f11$var$isElementHidden(node) && !$9ec6a779d2292f11$var$isInert(node) && checkParent($9ec6a779d2292f11$var$getParentNode(node));
};
var $9ec6a779d2292f11$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $9ec6a779d2292f11$var$isVisibleUncached(node, $9ec6a779d2292f11$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $9ec6a779d2292f11$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$9ec6a779d2292f11$var$isTopNode(node) ? $9ec6a779d2292f11$export$b8550e27de209d85(node) ? checkParent($9ec6a779d2292f11$var$getParentNode(node)) : false : true;
};
var $9ec6a779d2292f11$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $9ec6a779d2292f11$var$isAutoFocusAllowedUncached(node, $9ec6a779d2292f11$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $9ec6a779d2292f11$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $9ec6a779d2292f11$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $9ec6a779d2292f11$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $9ec6a779d2292f11$export$9d74f6fbc6f469d0 = function(node) {
    return $9ec6a779d2292f11$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $9ec6a779d2292f11$export$8197b0ea56b3b055 = function(node) {
    return !(($9ec6a779d2292f11$export$88a6ceeed5737ba3(node) || $9ec6a779d2292f11$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $9ec6a779d2292f11$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $kvebB.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $9ec6a779d2292f11$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $9ec6a779d2292f11$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $9ec6a779d2292f11$export$602e5a0d338d7750 = function(node) {
    return !$9ec6a779d2292f11$export$d94b8b58ec2f30eb(node);
};
var $9ec6a779d2292f11$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("3qnhL", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", function () { return $27e5dcd385c0c43d$export$cb40ee071f0d5226; });

var $4ojrw = parcelRequire("4ojrw");
var $27e5dcd385c0c43d$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $27e5dcd385c0c43d$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $27e5dcd385c0c43d$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $4ojrw.toArray)(nodes).map(function(node, index) {
        var tabIndex = $27e5dcd385c0c43d$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($27e5dcd385c0c43d$export$350ee6c095d98996);
};

});

parcelRegister("jwK2n", function(module, exports) {

$parcel$export(module.exports, "getFocusables", function () { return $e374b78c69aa47fc$export$f6768025e418420e; });
$parcel$export(module.exports, "getParentAutofocusables", function () { return $e374b78c69aa47fc$export$853fa94d922e78b9; });

var $kvebB = parcelRequire("kvebB");

var $4ojrw = parcelRequire("4ojrw");

var $gvAwd = parcelRequire("gvAwd");
var $e374b78c69aa47fc$var$queryTabbables = (0, $gvAwd.tabbables).join(',');
var $e374b78c69aa47fc$var$queryGuardTabbables = "".concat($e374b78c69aa47fc$var$queryTabbables, ", [data-focus-guard]");
var $e374b78c69aa47fc$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $4ojrw.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $e374b78c69aa47fc$var$queryGuardTabbables : $e374b78c69aa47fc$var$queryTabbables) ? [
            child
        ] : [], $e374b78c69aa47fc$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $e374b78c69aa47fc$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $e374b78c69aa47fc$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $e374b78c69aa47fc$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $e374b78c69aa47fc$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $e374b78c69aa47fc$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $4ojrw.toArray)(parent.parentNode.querySelectorAll($e374b78c69aa47fc$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $e374b78c69aa47fc$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $kvebB.FOCUS_AUTO), "]"));
    return (0, $4ojrw.toArray)(parentFocus).map(function(node) {
        return $e374b78c69aa47fc$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("gvAwd", function(module, exports) {

$parcel$export(module.exports, "tabbables", function () { return $c04bde66b0acfd1f$export$8555f4622e95784; });
/**
 * list of the object to be considered as focusable
 */ var $c04bde66b0acfd1f$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("4wF70", function(module, exports) {

$parcel$export(module.exports, "expandFocusableNodes", function () { return $34ba0a91564b6586$export$f89ac71e91767111; });

var $jh0iF = parcelRequire("jh0iF");

var $dD9Yr = parcelRequire("dD9Yr");

var $bFIix = parcelRequire("bFIix");

var $3qnhL = parcelRequire("3qnhL");

var $jwK2n = parcelRequire("jwK2n");
var $34ba0a91564b6586$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $jh0iF.getAllAffectedNodes)(topNode).filter((0, $dD9Yr.isNotAGuard));
    var commonParent = (0, $bFIix.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $3qnhL.orderByTabIndex)((0, $jwK2n.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $jwK2n.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $dD9Yr.isGuard)(node)
        };
    });
};

});
parcelRegister("jh0iF", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", function () { return $e07fd6755dce04fb$export$7e87c4720b9b279b; });

var $kvebB = parcelRequire("kvebB");

var $4ojrw = parcelRequire("4ojrw");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $e07fd6755dce04fb$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $e07fd6755dce04fb$var$getTopParent = function(node) {
    return node.parentNode ? $e07fd6755dce04fb$var$getTopParent(node.parentNode) : node;
};
var $e07fd6755dce04fb$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $4ojrw.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $kvebB.FOCUS_GROUP));
        acc.push.apply(acc, group ? $e07fd6755dce04fb$var$filterNested((0, $4ojrw.toArray)($e07fd6755dce04fb$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $kvebB.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $kvebB.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("bFIix", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", function () { return $87f5e2b9080604e9$export$a9a7252b5f2e280e; });
$parcel$export(module.exports, "allParentAutofocusables", function () { return $87f5e2b9080604e9$export$8f99714c70a37db1; });

var $4PLeF = parcelRequire("4PLeF");

var $4ojrw = parcelRequire("4ojrw");
var $87f5e2b9080604e9$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $87f5e2b9080604e9$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $87f5e2b9080604e9$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $87f5e2b9080604e9$var$getParents(nodeA);
    var parentsB = $87f5e2b9080604e9$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $87f5e2b9080604e9$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $4ojrw.asArray)(baseActiveElement);
    var leftEntries = (0, $4ojrw.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $87f5e2b9080604e9$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $87f5e2b9080604e9$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $4PLeF.contains)(common, topCommon)) topCommon = common;
                else topCommon = $87f5e2b9080604e9$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $87f5e2b9080604e9$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $4PLeF.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("7t3ll", function(module, exports) {

$parcel$export(module.exports, "focusNextElement", function () { return $56fdd5c39588ecad$export$3b0237e8566c8d65; });
$parcel$export(module.exports, "focusPrevElement", function () { return $56fdd5c39588ecad$export$33b47db07a82b2fb; });
$parcel$export(module.exports, "focusFirstElement", function () { return $56fdd5c39588ecad$export$2a791d8097a66406; });
$parcel$export(module.exports, "focusLastElement", function () { return $56fdd5c39588ecad$export$6a79073ddabfd6c3; });

var $iqtSA = parcelRequire("iqtSA");

var $4PLeF = parcelRequire("4PLeF");

var $4ojrw = parcelRequire("4ojrw");
var $56fdd5c39588ecad$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $4ojrw.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $4PLeF.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $4PLeF.getTabbableNodes)(shards, new Map()) : (0, $4PLeF.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $56fdd5c39588ecad$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $4PLeF.getTabbableNodes)((0, $4ojrw.asArray)(shards), new Map()) : (0, $4PLeF.getFocusableNodes)((0, $4ojrw.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $56fdd5c39588ecad$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $56fdd5c39588ecad$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $56fdd5c39588ecad$var$defaultOptions(options);
    var solution = $56fdd5c39588ecad$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $iqtSA.focusOn)(target.node, newOptions.focusOptions);
};
var $56fdd5c39588ecad$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $56fdd5c39588ecad$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $56fdd5c39588ecad$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $56fdd5c39588ecad$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $56fdd5c39588ecad$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $56fdd5c39588ecad$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $iqtSA.focusOn)(node.node, options.focusOptions);
};
var $56fdd5c39588ecad$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $56fdd5c39588ecad$var$pickBoundary(scope, options, 'first');
};
var $56fdd5c39588ecad$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $56fdd5c39588ecad$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("iqtSA", function(module, exports) {

$parcel$export(module.exports, "focusOn", function () { return $d6a1d51e33b35cf6$export$c12b3da842c43a8; });
var $d6a1d51e33b35cf6$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("ieTuz", function(module, exports) {

$parcel$export(module.exports, "focusInside", function () { return $d4749462b4ca2070$export$20115f8da7baa6fa; });

var $4PLeF = parcelRequire("4PLeF");

var $jh0iF = parcelRequire("jh0iF");

var $4ojrw = parcelRequire("4ojrw");

var $gbkAX = parcelRequire("gbkAX");
var $d4749462b4ca2070$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $d4749462b4ca2070$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $4ojrw.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $d4749462b4ca2070$var$focusInFrame(node, activeElement);
    }));
};
var $d4749462b4ca2070$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $gbkAX.getActiveElement)((0, $4ojrw.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $jh0iF.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $4PLeF.contains)(node, activeElement) || $d4749462b4ca2070$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("gbkAX", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", function () { return $bc7da6278acdc49d$export$cd4e5573fbe2b576; });
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $8afra = parcelRequire("8afra");
var $bc7da6278acdc49d$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $bc7da6278acdc49d$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $8afra.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $bc7da6278acdc49d$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("8afra", function(module, exports) {

$parcel$export(module.exports, "safeProbe", function () { return $5f1b3b61b1cbbc4d$export$78d20aae35adef88; });
var $5f1b3b61b1cbbc4d$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("hh2Ah", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", function () { return $c9360762a61cb011$export$be6b21806d3fd485; });

var $kvebB = parcelRequire("kvebB");

var $4PLeF = parcelRequire("4PLeF");

var $4ojrw = parcelRequire("4ojrw");

var $gbkAX = parcelRequire("gbkAX");
var $c9360762a61cb011$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $gbkAX.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $4ojrw.toArray)(inDocument.querySelectorAll("[".concat((0, $kvebB.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $4PLeF.contains)(node, activeElement);
    });
};

});

parcelRegister("lGcEY", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", function () { return (parcelRequire("19Yys")).moveFocusInside; });

var $kvebB = parcelRequire("kvebB");

var $ieTuz = parcelRequire("ieTuz");

var $hh2Ah = parcelRequire("hh2Ah");


var $4wF70 = parcelRequire("4wF70");

var $19Yys = parcelRequire("19Yys");

var $dufEp = parcelRequire("dufEp");

var $7t3ll = parcelRequire("7t3ll");

var $4PLeF = parcelRequire("4PLeF");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $fc87572f5e3045dc$export$1a988e7317c65621 = $kvebB;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $fc87572f5e3045dc$var$deprecated_default_moveFocusInside = (0, $19Yys.moveFocusInside);
var $fc87572f5e3045dc$export$2e2bcd8739ae039 //
 = $fc87572f5e3045dc$var$deprecated_default_moveFocusInside;

});
parcelRegister("19Yys", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", function () { return $0d859a99b4f61439$export$cd599851e879a025; });

var $iqtSA = parcelRequire("iqtSA");

var $xUnFz = parcelRequire("xUnFz");
var $0d859a99b4f61439$var$guardCount = 0;
var $0d859a99b4f61439$var$lockDisabled = false;
var $0d859a99b4f61439$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $xUnFz.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($0d859a99b4f61439$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($0d859a99b4f61439$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $0d859a99b4f61439$var$lockDisabled = true;
            setTimeout(function() {
                $0d859a99b4f61439$var$lockDisabled = false;
            }, 1);
            return;
        }
        $0d859a99b4f61439$var$guardCount++;
        (0, $iqtSA.focusOn)(focusable.node, options.focusOptions);
        $0d859a99b4f61439$var$guardCount--;
    }
};

});
parcelRegister("xUnFz", function(module, exports) {

$parcel$export(module.exports, "focusSolver", function () { return $065ed13a63acea7e$export$305758c744b57f6f; });

var $f7D2G = parcelRequire("f7D2G");

var $4PLeF = parcelRequire("4PLeF");

var $jh0iF = parcelRequire("jh0iF");

var $4ojrw = parcelRequire("4ojrw");

var $3C2wL = parcelRequire("3C2wL");

var $gbkAX = parcelRequire("gbkAX");

var $dD9Yr = parcelRequire("dD9Yr");

var $bFIix = parcelRequire("bFIix");
var $065ed13a63acea7e$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $dD9Yr.isDefined));
};
var $065ed13a63acea7e$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $gbkAX.getActiveElement)((0, $4ojrw.asArray)(topNode).length > 0 ? document : (0, $4ojrw.getFirst)(topNode).ownerDocument);
    var entries = (0, $jh0iF.getAllAffectedNodes)(topNode).filter((0, $dD9Yr.isNotAGuard));
    var commonParent = (0, $bFIix.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $4PLeF.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $dD9Yr.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $4PLeF.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $065ed13a63acea7e$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $f7D2G.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $f7D2G.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $3C2wL.pickAutofocus)(anyFocusable, innerTabbable, (0, $bFIix.allParentAutofocusables)(entries, visibilityCache)) || (0, $3C2wL.pickAutofocus)(anyFocusable, innerFocusables, (0, $bFIix.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("f7D2G", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", function () { return $b025cb77f97b4cb8$export$85710b12cf912438; });
$parcel$export(module.exports, "newFocus", function () { return $b025cb77f97b4cb8$export$65842178e9bb4205; });

var $5oMeV = parcelRequire("5oMeV");

var $7w9pd = parcelRequire("7w9pd");

var $dD9Yr = parcelRequire("dD9Yr");
var $b025cb77f97b4cb8$export$85710b12cf912438 = 'NEW_FOCUS';
var $b025cb77f97b4cb8$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $dD9Yr.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $b025cb77f97b4cb8$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $b025cb77f97b4cb8$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $5oMeV.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $7w9pd.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $7w9pd.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("5oMeV", function(module, exports) {

$parcel$export(module.exports, "correctNode", function () { return $0103aff3dfb68ed4$export$5261662167ad7ced; });
$parcel$export(module.exports, "correctNodes", function () { return $0103aff3dfb68ed4$export$4a5a72a7124e45f9; });

var $dD9Yr = parcelRequire("dD9Yr");
var $0103aff3dfb68ed4$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $dD9Yr.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $0103aff3dfb68ed4$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $dD9Yr.isRadioElement)(node) && node.name) return $0103aff3dfb68ed4$var$findSelectedRadio(node, nodes);
    return node;
};
var $0103aff3dfb68ed4$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($0103aff3dfb68ed4$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("7w9pd", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", function () { return $5792d15b7c7cccf7$export$f4e86cfa0679b9cc; });
$parcel$export(module.exports, "pickFocusable", function () { return $5792d15b7c7cccf7$export$e06728ee87c96122; });

var $5oMeV = parcelRequire("5oMeV");
var $5792d15b7c7cccf7$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $5oMeV.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $5792d15b7c7cccf7$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $5oMeV.correctNode)(node, nodes));
};

});


parcelRegister("3C2wL", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", function () { return $2a16e199f15e5e3e$export$cfb742983e257555; });

var $4PLeF = parcelRequire("4PLeF");

var $7w9pd = parcelRequire("7w9pd");

var $dD9Yr = parcelRequire("dD9Yr");
var $2a16e199f15e5e3e$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $dD9Yr.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $2a16e199f15e5e3e$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $4PLeF.filterAutoFocusable)(nodes.filter($2a16e199f15e5e3e$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $7w9pd.pickFirstFocus)(autoFocusable);
    return (0, $7w9pd.pickFirstFocus)((0, $4PLeF.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("6r3Qw", function(module, exports) {

$parcel$export(module.exports, "deferAction", function () { return $4af83f7a6802c107$export$6523025722806278; });
$parcel$export(module.exports, "extractRef", function () { return $4af83f7a6802c107$export$c613fed06e332533; });
function $4af83f7a6802c107$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $4af83f7a6802c107$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $4af83f7a6802c107$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("bYxNM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9OW3F = parcelRequire("9OW3F");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $8b7f84ad773a3de5$var$_interopRequireDefault($9OW3F).default;
    }
});

var $9vRPb = parcelRequire("9vRPb");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $9vRPb.TouchScrollable;
    }
});
function $8b7f84ad773a3de5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("9OW3F", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7265d1b71caf7a6b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dNMDr = parcelRequire("dNMDr");
var $7265d1b71caf7a6b$var$_react2 = $7265d1b71caf7a6b$var$_interopRequireDefault($dNMDr);

var $gDCKh = parcelRequire("gDCKh");

var $9vRPb = parcelRequire("9vRPb");

var $kIaZW = parcelRequire("kIaZW");
var $7265d1b71caf7a6b$var$_withLockSheet2 = $7265d1b71caf7a6b$var$_interopRequireDefault($kIaZW);

var $anjxg = parcelRequire("anjxg");
var $7265d1b71caf7a6b$var$_withTouchListeners2 = $7265d1b71caf7a6b$var$_interopRequireDefault($anjxg);

var $KuyHs = parcelRequire("KuyHs");
function $7265d1b71caf7a6b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7265d1b71caf7a6b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7265d1b71caf7a6b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7265d1b71caf7a6b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $7265d1b71caf7a6b$var$ScrollLock = function(_PureComponent) {
    $7265d1b71caf7a6b$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $7265d1b71caf7a6b$var$_classCallCheck(this, ScrollLock);
        return $7265d1b71caf7a6b$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $7265d1b71caf7a6b$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$gDCKh.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $7265d1b71caf7a6b$var$_react2.default.createElement($9vRPb.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($dNMDr.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $7265d1b71caf7a6b$var$compose = (0, $KuyHs.pipe)($7265d1b71caf7a6b$var$_withTouchListeners2.default, $7265d1b71caf7a6b$var$_withLockSheet2.default);
var $7265d1b71caf7a6b$var$SheetLock = $7265d1b71caf7a6b$var$compose($7265d1b71caf7a6b$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $7265d1b71caf7a6b$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $7265d1b71caf7a6b$var$_react2.default.createElement($7265d1b71caf7a6b$var$SheetLock, props) : props.children;
};
$7265d1b71caf7a6b$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $7265d1b71caf7a6b$var$LockToggle;

});
parcelRegister("gDCKh", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("9vRPb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $6ed0c2bbec55554e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $6ed0c2bbec55554e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dNMDr = parcelRequire("dNMDr");

var $gDCKh = parcelRequire("gDCKh");

var $KuyHs = parcelRequire("KuyHs");
function $6ed0c2bbec55554e$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $6ed0c2bbec55554e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6ed0c2bbec55554e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $6ed0c2bbec55554e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $6ed0c2bbec55554e$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $6ed0c2bbec55554e$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $6ed0c2bbec55554e$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $6ed0c2bbec55554e$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $6ed0c2bbec55554e$var$_possibleConstructorReturn(_this, _ret);
    }
    $6ed0c2bbec55554e$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$gDCKh.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $KuyHs.preventInertiaScroll, $KuyHs.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $KuyHs.allowTouchMove, $KuyHs.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$gDCKh.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $KuyHs.preventInertiaScroll, $KuyHs.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $KuyHs.allowTouchMove, $KuyHs.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $6ed0c2bbec55554e$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $dNMDr.cloneElement)(children, $6ed0c2bbec55554e$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($dNMDr.PureComponent);

});
parcelRegister("KuyHs", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $08bc004f184bf2f4$var$preventTouchMove;
module.exports.allowTouchMove = $08bc004f184bf2f4$var$allowTouchMove;
module.exports.preventInertiaScroll = $08bc004f184bf2f4$var$preventInertiaScroll;
module.exports.isTouchDevice = $08bc004f184bf2f4$var$isTouchDevice;
module.exports.camelToKebab = $08bc004f184bf2f4$var$camelToKebab;
module.exports.parse = $08bc004f184bf2f4$var$parse;
module.exports.getPadding = $08bc004f184bf2f4$var$getPadding;
module.exports.getWindowHeight = $08bc004f184bf2f4$var$getWindowHeight;
module.exports.getDocumentHeight = $08bc004f184bf2f4$var$getDocumentHeight;
module.exports.makeStyleTag = $08bc004f184bf2f4$var$makeStyleTag;
module.exports.injectStyles = $08bc004f184bf2f4$var$injectStyles;
module.exports.insertStyleTag = $08bc004f184bf2f4$var$insertStyleTag;

var $gDCKh = parcelRequire("gDCKh");
var $08bc004f184bf2f4$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $08bc004f184bf2f4$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $08bc004f184bf2f4$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $08bc004f184bf2f4$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $08bc004f184bf2f4$var$isTouchDevice() {
    if (!$gDCKh.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $08bc004f184bf2f4$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $08bc004f184bf2f4$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $08bc004f184bf2f4$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $08bc004f184bf2f4$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($08bc004f184bf2f4$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $08bc004f184bf2f4$var$getPadding() {
    if (!$gDCKh.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $08bc004f184bf2f4$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($gDCKh.canUseDOM) return window.innerHeight * multiplier;
}
function $08bc004f184bf2f4$var$getDocumentHeight() {
    if ($gDCKh.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $08bc004f184bf2f4$var$makeStyleTag() {
    if (!$gDCKh.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $08bc004f184bf2f4$var$injectStyles(tag, css) {
    if (!$gDCKh.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $08bc004f184bf2f4$var$insertStyleTag(tag) {
    if (!$gDCKh.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("kIaZW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f14072b33b23a751$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $f14072b33b23a751$var$withLockSheet;

var $dNMDr = parcelRequire("dNMDr");
var $f14072b33b23a751$var$_react2 = $f14072b33b23a751$var$_interopRequireDefault($dNMDr);

var $KuyHs = parcelRequire("KuyHs");
function $f14072b33b23a751$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f14072b33b23a751$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f14072b33b23a751$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $f14072b33b23a751$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $f14072b33b23a751$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $f14072b33b23a751$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $f14072b33b23a751$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $f14072b33b23a751$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $KuyHs.makeStyleTag)();
                if (!sheet) return;
                (0, $KuyHs.injectStyles)(sheet, styles);
                (0, $KuyHs.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $KuyHs.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $KuyHs.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $f14072b33b23a751$var$_possibleConstructorReturn(_this, _ret);
        }
        $f14072b33b23a751$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $f14072b33b23a751$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($dNMDr.PureComponent);
}

});

parcelRegister("anjxg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $78db34b1d21f78b9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $78db34b1d21f78b9$var$withTouchListeners;

var $dNMDr = parcelRequire("dNMDr");
var $78db34b1d21f78b9$var$_react2 = $78db34b1d21f78b9$var$_interopRequireDefault($dNMDr);

var $gDCKh = parcelRequire("gDCKh");

var $KuyHs = parcelRequire("KuyHs");
function $78db34b1d21f78b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $78db34b1d21f78b9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $78db34b1d21f78b9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $78db34b1d21f78b9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $78db34b1d21f78b9$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $78db34b1d21f78b9$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $78db34b1d21f78b9$var$_classCallCheck(this, TouchProvider);
            return $78db34b1d21f78b9$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $78db34b1d21f78b9$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$gDCKh.canUseDOM || !(0, $KuyHs.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $KuyHs.preventTouchMove, $KuyHs.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$gDCKh.canUseDOM || !(0, $KuyHs.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $KuyHs.preventTouchMove, $KuyHs.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $78db34b1d21f78b9$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($dNMDr.PureComponent);
}

});



parcelRegister("4SHCx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38de0ab71219d4a5$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $fv0xi = parcelRequire("fv0xi");

var $h6mPa = parcelRequire("h6mPa");

var $boEHe = parcelRequire("boEHe");

var $bnv12 = parcelRequire("bnv12");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $38de0ab71219d4a5$var$modalStackRegister = [];
function $38de0ab71219d4a5$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $bnv12.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $boEHe.default)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $h6mPa.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $fv0xi.default)(function() {
        var newStackIndex = $38de0ab71219d4a5$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $dNMDr.useEffect)(function() {
        var currentStackIndex = $38de0ab71219d4a5$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $38de0ab71219d4a5$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $38de0ab71219d4a5$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $38de0ab71219d4a5$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $dNMDr.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $38de0ab71219d4a5$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $38de0ab71219d4a5$var$modalStackRegister.splice(currentStackIndex, 1);
                $38de0ab71219d4a5$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $dNMDr.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("fv0xi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b48a2ab8557be581$export$2e2bcd8739ae039; });

var $f69cP = parcelRequire("f69cP");
function $b48a2ab8557be581$export$2e2bcd8739ae039(callback) {
    var ref = (0, $f69cP.default)(function() {
        return callback;
    });
    return ref.current;
}

});
parcelRegister("f69cP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afde8ea87c62c2b0$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");
var $afde8ea87c62c2b0$var$uniqueReferencedValue = {};
function $afde8ea87c62c2b0$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $dNMDr.useRef)($afde8ea87c62c2b0$var$uniqueReferencedValue);
    if (ref.current === $afde8ea87c62c2b0$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("h6mPa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c734b3a52a8aa1a3$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");
function $c734b3a52a8aa1a3$export$2e2bcd8739ae039(value) {
    var ref = (0, $dNMDr.useRef)();
    (0, $dNMDr.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("boEHe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84c18106ab6543a1$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");
function $84c18106ab6543a1$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $dNMDr.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $dNMDr.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("68Qpe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $478c24297a3f4e4f$export$2e2bcd8739ae039; });

var $82V4i = parcelRequire("82V4i");

var $dNMDr = parcelRequire("dNMDr");

var $40QgJ = parcelRequire("40QgJ");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $478c24297a3f4e4f$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $478c24297a3f4e4f$export$2e2bcd8739ae039() {
    var _useState = (0, $dNMDr.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $dNMDr.useLayoutEffect)(function() {
        setScrollTopOffset($478c24297a3f4e4f$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $dNMDr.useCallback)(function() {
        if ($478c24297a3f4e4f$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $dNMDr.useEffect)(function() {
        return (0, $40QgJ.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("iYO6y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd14b259f5a4ce3f$export$2e2bcd8739ae039; });
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $82V4i = parcelRequire("82V4i");

var $a3ftr = parcelRequire("a3ftr");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $gTgRL = parcelRequire("gTgRL");

var $lm7lB = parcelRequire("lm7lB");

var $hGahQ = parcelRequire("hGahQ");

var $i2T7w = parcelRequire("i2T7w");

var $5fkkM = parcelRequire("5fkkM");

var $gQLDR = parcelRequire("gQLDR");
parcelRequire("2RcWZ");
var $aBODl = parcelRequire("aBODl");

var $aD0VR = parcelRequire("aD0VR");

var $2g5pJ = parcelRequire("2g5pJ");

var $9o0A6 = parcelRequire("9o0A6");

var $iTq1k = parcelRequire("iTq1k");

var $eAFlt = parcelRequire("eAFlt");

var $8nm5G = parcelRequire("8nm5G");

var $cTM9A = parcelRequire("cTM9A");
var $dd14b259f5a4ce3f$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $dd14b259f5a4ce3f$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl",
    borderRadiusT26Shape: "_epkxpb1k"
};
var $dd14b259f5a4ce3f$var$viewportScrollStyles = null;
var $dd14b259f5a4ce3f$var$bodyScrollStyles = null;
var $dd14b259f5a4ce3f$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, providedAutoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId, _props$isFullScreen = props.isFullScreen, isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen;
    var id = (0, $hGahQ.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    var defaultTestId = testId || 'modal-dialog';
    // https://product-fabric.atlassian.net/browse/DSP-24307
    // If flag and falsy, use true instead.
    // When we remove boolean `autoFocus`, we won't have to worry about this
    var autoFocus = !providedAutoFocus ? true : providedAutoFocus;
    (0, $dNMDr.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $aBODl.combine)((0, $9o0A6.disableDraggingToCrossOriginIFramesForElement)(), (0, $eAFlt.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $iTq1k.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $lm7lB.default)((0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($a3ftr)))(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $2g5pJ.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $dNMDr.useMemo)(function() {
        return {
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        };
    }, [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $i2T7w.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $i2T7w.useLayering)(), currentLevel = _useLayering.currentLevel;
    return /*#__PURE__*/ $dNMDr.createElement((0, $cTM9A.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ $dNMDr.createElement((0, $aD0VR.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $dNMDr.createElement((0, $aD0VR.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, /*#__PURE__*/ $dNMDr.createElement((0, $5fkkM.default), {
        entranceDirection: isFullScreen ? undefined : 'bottom',
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return /*#__PURE__*/ $dNMDr.createElement("section", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $gTgRL.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $8nm5G.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $8nm5G.dialogHeight)(height)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $affTb.default)([
                $dd14b259f5a4ce3f$var$dialogStyles.root,
                !isFullScreen && $dd14b259f5a4ce3f$var$dialogStyles.borderRadius,
                !isFullScreen && (0, $gQLDR.fg)('platform-dst-shape-theme-default') && $dd14b259f5a4ce3f$var$dialogStyles.borderRadiusT26Shape,
                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children);
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dd14b259f5a4ce3f$export$2e2bcd8739ae039 = $dd14b259f5a4ce3f$var$ModalDialog;

});
parcelRegister("2RcWZ", function(module, exports) {

$parcel$export(module.exports, "combine", function () { return (parcelRequire("aBODl")).combine; });

var $aBODl = parcelRequire("aBODl");

});
parcelRegister("aBODl", function(module, exports) {

$parcel$export(module.exports, "combine", function () { return $7b94a2df26c9fc1a$export$1be1fc439b849fdf; });
/** Create a new combined function that will call all the provided functions */ function $7b94a2df26c9fc1a$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

});


parcelRegister("aD0VR", function(module, exports) {

$parcel$export(module.exports, "ModalContext", function () { return $7bce45027002fb0b$export$ab57792b9b6974a6; });
$parcel$export(module.exports, "ScrollContext", function () { return $7bce45027002fb0b$export$dece24112a937f92; });

var $dNMDr = parcelRequire("dNMDr");
var $7bce45027002fb0b$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $dNMDr.createContext)(null);
var $7bce45027002fb0b$export$dece24112a937f92 = /*#__PURE__*/ (0, $dNMDr.createContext)(null);

});

parcelRegister("2g5pJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a5146836c9e47d8$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");
function $1a5146836c9e47d8$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $dNMDr.useRef)(null);
    var onMotionFinish = (0, $dNMDr.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("9o0A6", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", function () { return $6d56ce6234f7c55d$export$ec28e97c7d8b1b35; });

var $40QgJ = parcelRequire("40QgJ");
parcelRequire("2RcWZ");
var $aBODl = parcelRequire("aBODl");
parcelRequire("bpJH3");
var $7A6Zy = parcelRequire("7A6Zy");

var $5P22X = parcelRequire("5P22X");
function $6d56ce6234f7c55d$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $40QgJ.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $7A6Zy.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $aBODl.combine)(unbindEvents, unbindMonitor);
}
function $6d56ce6234f7c55d$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $40QgJ.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $6d56ce6234f7c55d$var$api = (0, $5P22X.makeFixForAdapter)({
    watchForInteractionStart: $6d56ce6234f7c55d$var$watchForInteractionStart,
    watchForInteractionEnd: $6d56ce6234f7c55d$var$watchForInteractionEnd
});
function $6d56ce6234f7c55d$export$ec28e97c7d8b1b35() {
    return $6d56ce6234f7c55d$var$api.registerUsage();
}

});
parcelRegister("bpJH3", function(module, exports) {

$parcel$export(module.exports, "draggable", function () { return (parcelRequire("7A6Zy")).draggable; });
$parcel$export(module.exports, "dropTargetForElements", function () { return (parcelRequire("7A6Zy")).dropTargetForElements; });
$parcel$export(module.exports, "monitorForElements", function () { return (parcelRequire("7A6Zy")).monitorForElements; });

var $7A6Zy = parcelRequire("7A6Zy");
 // Payload for the draggable being dragged

});
parcelRegister("7A6Zy", function(module, exports) {

$parcel$export(module.exports, "dropTargetForElements", function () { return $5851519b16f20dff$export$e7140b68045b5036; });
$parcel$export(module.exports, "monitorForElements", function () { return $5851519b16f20dff$export$59a074bac4c54f54; });
$parcel$export(module.exports, "draggable", function () { return $5851519b16f20dff$export$c746a5152d4ba26c; });

var $82V4i = parcelRequire("82V4i");

var $40QgJ = parcelRequire("40QgJ");

var $aQnYg = parcelRequire("aQnYg");

var $ca9ZT = parcelRequire("ca9ZT");

var $JEGNE = parcelRequire("JEGNE");

var $aBODl = parcelRequire("aBODl");

var $4K2UC = parcelRequire("4K2UC");

var $bsQS7 = parcelRequire("bsQS7");

var $72Vkp = parcelRequire("72Vkp");

var $dtgq9 = parcelRequire("dtgq9");

var $eYhDY = parcelRequire("eYhDY");

var $8IiGv = parcelRequire("8IiGv");

var $dPgDA = parcelRequire("dPgDA");
var $5851519b16f20dff$var$draggableRegistry = new WeakMap();
function $5851519b16f20dff$var$addToRegistry(args) {
    $5851519b16f20dff$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $5851519b16f20dff$var$draggableRegistry.delete(args.element);
    };
}
var $5851519b16f20dff$var$honeyPotFix = (0, $ca9ZT.makeHoneyPotFix)();
var $5851519b16f20dff$var$adapter = (0, $JEGNE.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $aBODl.combine)($5851519b16f20dff$var$honeyPotFix.bindEvents(), (0, $40QgJ.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                var entry = $5851519b16f20dff$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $dtgq9.getInput)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $aQnYg.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $72Vkp.isAndroid)() && !event.dataTransfer.types.includes((0, $eYhDY.textMediaType)) && !event.dataTransfer.types.includes((0, $8IiGv.URLMediaType))) event.dataTransfer.setData((0, $eYhDY.textMediaType), (0, $72Vkp.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $dPgDA.elementAdapterNativeDataKey), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $5851519b16f20dff$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $5851519b16f20dff$var$honeyPotFix.getOnPostDispatch()
});
var $5851519b16f20dff$export$e7140b68045b5036 = $5851519b16f20dff$var$adapter.dropTarget;
var $5851519b16f20dff$export$59a074bac4c54f54 = $5851519b16f20dff$var$adapter.monitor;
function $5851519b16f20dff$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $aBODl.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $5851519b16f20dff$var$adapter.registerUsage(), $5851519b16f20dff$var$addToRegistry(args), (0, $bsQS7.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $4K2UC.once)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 

});
parcelRegister("aQnYg", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", function () { return $7e515ad62b5de402$export$81d0353f25f5dd; });

var $82V4i = parcelRequire("82V4i");

var $5NjSR = parcelRequire("5NjSR");
function $7e515ad62b5de402$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $5NjSR.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

});
parcelRegister("5NjSR", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", function () { return $4380f3db92542af2$export$821bdcd739a2706b; });

var $c74lR = parcelRequire("c74lR");
function $4380f3db92542af2$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $c74lR.honeyPotDataAttribute));
}

});
parcelRegister("c74lR", function(module, exports) {

$parcel$export(module.exports, "honeyPotDataAttribute", function () { return $8d19839ca462a7c9$export$6eafea55f7947469; });
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $8d19839ca462a7c9$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("ca9ZT", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", function () { return $8dae2c73a9853d3d$export$8ecad27c959e89e0; });

var $91FVG = parcelRequire("91FVG");

var $40QgJ = parcelRequire("40QgJ");

var $eIJQV = parcelRequire("eIJQV");

var $c74lR = parcelRequire("c74lR");
function $8dae2c73a9853d3d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8dae2c73a9853d3d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8dae2c73a9853d3d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8dae2c73a9853d3d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8dae2c73a9853d3d$var$honeyPotSize = 2;
var $8dae2c73a9853d3d$var$halfHoneyPotSize = $8dae2c73a9853d3d$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $8dae2c73a9853d3d$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $8dae2c73a9853d3d$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $8dae2c73a9853d3d$var$halfHoneyPotSize,
        y: point.y - $8dae2c73a9853d3d$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $8dae2c73a9853d3d$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $8dae2c73a9853d3d$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $8dae2c73a9853d3d$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $8dae2c73a9853d3d$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $8dae2c73a9853d3d$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $8dae2c73a9853d3d$var$preventGoingForwardsOffScreen($8dae2c73a9853d3d$var$preventGoingBackwardsOffScreen($8dae2c73a9853d3d$var$pullBackByHalfHoneyPotSize($8dae2c73a9853d3d$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $8dae2c73a9853d3d$var$honeyPotSize,
        height: $8dae2c73a9853d3d$var$honeyPotSize
    });
}
function $8dae2c73a9853d3d$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $8dae2c73a9853d3d$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $8dae2c73a9853d3d$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $c74lR.honeyPotDataAttribute), 'true');
    // can shift during the drag thanks to Firefox
    var clientRect = $8dae2c73a9853d3d$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $8dae2c73a9853d3d$var$_objectSpread($8dae2c73a9853d3d$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box'
    }, $8dae2c73a9853d3d$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $eIJQV.maxZIndex)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $40QgJ.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $8dae2c73a9853d3d$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $8dae2c73a9853d3d$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($8dae2c73a9853d3d$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $40QgJ.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $8dae2c73a9853d3d$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $40QgJ.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $8dae2c73a9853d3d$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("eIJQV", function(module, exports) {

$parcel$export(module.exports, "maxZIndex", function () { return $ab78be1cea15d563$export$7d0a15ee70427305; });
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $ab78be1cea15d563$export$7d0a15ee70427305 = 2147483647;

});


parcelRegister("JEGNE", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", function () { return $0893c422936d4db6$export$2aa3a33160990d96; });

var $96Qmv = parcelRequire("96Qmv");

var $gF0lI = parcelRequire("gF0lI");

var $66App = parcelRequire("66App");

var $8P1nN = parcelRequire("8P1nN");
function $0893c422936d4db6$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $8P1nN.makeMonitor)();
    var dropTargetAPI = (0, $66App.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $96Qmv.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $96Qmv.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $gF0lI.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("96Qmv", function(module, exports) {

$parcel$export(module.exports, "lifecycle", function () { return $6a1d4a997c95990c$export$3efdceeb8ca25c51; });

var $62ppy = parcelRequire("62ppy");

var $40QgJ = parcelRequire("40QgJ");

var $aQnYg = parcelRequire("aQnYg");

var $5NjSR = parcelRequire("5NjSR");

var $kd35x = parcelRequire("kd35x");

var $apphO = parcelRequire("apphO");

var $dtgq9 = parcelRequire("dtgq9");

var $2cJ4A = parcelRequire("2cJ4A");
var $6a1d4a997c95990c$var$globalState = {
    isActive: false
};
function $6a1d4a997c95990c$var$canStart() {
    return !$6a1d4a997c95990c$var$globalState.isActive;
}
function $6a1d4a997c95990c$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $6a1d4a997c95990c$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $6a1d4a997c95990c$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$6a1d4a997c95990c$var$canStart()) return;
    var initial = $6a1d4a997c95990c$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $6a1d4a997c95990c$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $6a1d4a997c95990c$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $2cJ4A.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $6a1d4a997c95990c$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $dtgq9.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $5NjSR.isHoneyPotElement)(event.target) ? (0, $aQnYg.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $6a1d4a997c95990c$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $6a1d4a997c95990c$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $40QgJ.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $kd35x.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $dtgq9.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $6a1d4a997c95990c$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $dtgq9.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))((0, $apphO.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $6a1d4a997c95990c$var$getNativeSetDragImage(event)
    });
}
function $6a1d4a997c95990c$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $6a1d4a997c95990c$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $dtgq9.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $6a1d4a997c95990c$export$3efdceeb8ca25c51 = {
    canStart: $6a1d4a997c95990c$var$canStart,
    start: $6a1d4a997c95990c$var$start
};

});
parcelRegister("kd35x", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", function () { return $eb676acfa9e56df6$export$57d220c74e84a273; });

var $1bnP3 = parcelRequire("1bnP3");

var $fGpYV = parcelRequire("fGpYV");

var $e4l25 = parcelRequire("e4l25");

var $8Q9aS = parcelRequire("8Q9aS");
function $eb676acfa9e56df6$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $fGpYV.isSafari)()) return (0, $e4l25.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $1bnP3.isFirefox)()) return (0, $8Q9aS.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("1bnP3", function(module, exports) {

$parcel$export(module.exports, "isFirefox", function () { return $0dc94c2c25d47b6d$export$b7d78993b74f766d; });

var $4K2UC = parcelRequire("4K2UC");
var $0dc94c2c25d47b6d$export$b7d78993b74f766d = (0, $4K2UC.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("4K2UC", function(module, exports) {

$parcel$export(module.exports, "once", function () { return $373db79e3873938e$export$d2de3aaeafa91619; });
/** Provide a function that you only ever want to be called a single time */ function $373db79e3873938e$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("fGpYV", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $b6aeeeade5a135e8$export$95df08bae54cb4df; });

var $4K2UC = parcelRequire("4K2UC");
var $b6aeeeade5a135e8$export$95df08bae54cb4df = (0, $4K2UC.once)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("e4l25", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindowInSafari", function () { return $a3e1c114125e98f5$export$de68634bd94ed596; });
$parcel$export(module.exports, "isLeavingWindowInSafari", function () { return $a3e1c114125e98f5$export$f21837c338005454; });

var $40QgJ = parcelRequire("40QgJ");

var $fGpYV = parcelRequire("fGpYV");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $a3e1c114125e98f5$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $a3e1c114125e98f5$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $fGpYV.isSafari)()) return false;
    return dragEnter.hasOwnProperty($a3e1c114125e98f5$var$symbols.isEnteringWindow);
}
function $a3e1c114125e98f5$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $fGpYV.isSafari)()) return false;
    return dragLeave.hasOwnProperty($a3e1c114125e98f5$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $fGpYV.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $40QgJ.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$a3e1c114125e98f5$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$a3e1c114125e98f5$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("8Q9aS", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", function () { return $66fa4bebd45b7df8$export$e46810fef53b5b0e; });
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $66fa4bebd45b7df8$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $66fa4bebd45b7df8$export$e46810fef53b5b0e(eventTarget) {
    return $66fa4bebd45b7df8$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("apphO", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", function () { return $793fda8893a9607d$export$ac5e5b0daf997b2; });
function $793fda8893a9607d$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("dtgq9", function(module, exports) {

$parcel$export(module.exports, "getInput", function () { return $9ceab8a41cba3b2e$export$7c112ceec8941e67; });
function $9ceab8a41cba3b2e$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("2cJ4A", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", function () { return $19afaa539dbe4755$export$9f13ecc44e83d682; });

var $hRtNQ = parcelRequire("hRtNQ");
var $19afaa539dbe4755$var$scheduleOnDrag = (0, $hRtNQ.default)(function(fn) {
    return fn();
});
var $19afaa539dbe4755$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $19afaa539dbe4755$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $19afaa539dbe4755$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $19afaa539dbe4755$var$dragStart.flush();
            $19afaa539dbe4755$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $19afaa539dbe4755$var$scheduleOnDrag(function() {
                $19afaa539dbe4755$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $19afaa539dbe4755$var$dragStart.flush();
            $19afaa539dbe4755$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("hRtNQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d00e812c695a9afc$export$2e2bcd8739ae039; });
var $d00e812c695a9afc$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $d00e812c695a9afc$export$2e2bcd8739ae039 = $d00e812c695a9afc$var$rafSchd;

});



parcelRegister("gF0lI", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $c210bf0abe1ebfed$export$6503ec6e8aabbaf; });
// Extending `Map` to allow us to link Key and Values together
var $c210bf0abe1ebfed$var$ledger = new Map();
function $c210bf0abe1ebfed$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $c210bf0abe1ebfed$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $c210bf0abe1ebfed$var$ledger.set(typeKey, initial);
    return initial;
}
function $c210bf0abe1ebfed$export$6503ec6e8aabbaf(args) {
    var entry = $c210bf0abe1ebfed$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $c210bf0abe1ebfed$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("66App", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", function () { return $0125ab8afb6aa083$export$47d10e7bd9c81890; });

var $91FVG = parcelRequire("91FVG");

var $62ppy = parcelRequire("62ppy");

var $aBODl = parcelRequire("aBODl");

var $4K2UC = parcelRequire("4K2UC");

var $bsQS7 = parcelRequire("bsQS7");
function $0125ab8afb6aa083$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0125ab8afb6aa083$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0125ab8afb6aa083$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0125ab8afb6aa083$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0125ab8afb6aa083$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0125ab8afb6aa083$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0125ab8afb6aa083$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0125ab8afb6aa083$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0125ab8afb6aa083$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0125ab8afb6aa083$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $0125ab8afb6aa083$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $0125ab8afb6aa083$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $aBODl.combine)((0, $bsQS7.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $4K2UC.once)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $0125ab8afb6aa083$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $0125ab8afb6aa083$var$_objectSpread($0125ab8afb6aa083$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $0125ab8afb6aa083$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $0125ab8afb6aa083$var$_objectSpread($0125ab8afb6aa083$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $0125ab8afb6aa083$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $0125ab8afb6aa083$var$_objectSpread($0125ab8afb6aa083$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $0125ab8afb6aa083$var$copyReverse(current);
        var actualCaptureOrdered = $0125ab8afb6aa083$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($0125ab8afb6aa083$var$_objectSpread($0125ab8afb6aa083$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $0125ab8afb6aa083$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("bsQS7", function(module, exports) {

$parcel$export(module.exports, "addAttribute", function () { return $858b52801be5c1c5$export$5dcb5c23b6ba980a; });
function $858b52801be5c1c5$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

});


parcelRegister("8P1nN", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", function () { return $66c428bb84701003$export$5dd4ed888d5b12ca; });

var $91FVG = parcelRequire("91FVG");

var $4K2UC = parcelRequire("4K2UC");
function $66c428bb84701003$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $66c428bb84701003$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $66c428bb84701003$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $66c428bb84701003$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $66c428bb84701003$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $66c428bb84701003$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $66c428bb84701003$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $66c428bb84701003$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $66c428bb84701003$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($91FVG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $66c428bb84701003$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $66c428bb84701003$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $66c428bb84701003$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $4K2UC.once)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $66c428bb84701003$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("72Vkp", function(module, exports) {

$parcel$export(module.exports, "isAndroid", function () { return $5215307a39cf8fd1$export$a11b0059900ceec8; });
$parcel$export(module.exports, "androidFallbackText", function () { return $5215307a39cf8fd1$export$aceb3ed8b7f7bd2c; });

var $4K2UC = parcelRequire("4K2UC");
var $5215307a39cf8fd1$export$a11b0059900ceec8 = (0, $4K2UC.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $5215307a39cf8fd1$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("eYhDY", function(module, exports) {

$parcel$export(module.exports, "textMediaType", function () { return $ae645af13e50db08$export$fd3d00026297c0ad; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $ae645af13e50db08$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("8IiGv", function(module, exports) {

$parcel$export(module.exports, "URLMediaType", function () { return $6580ed23975b897f$export$4c44a460f123106; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $6580ed23975b897f$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("dPgDA", function(module, exports) {

$parcel$export(module.exports, "elementAdapterNativeDataKey", function () { return $a10cf1a8517f33ec$export$c9c4cc54e73b125d; });
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $a10cf1a8517f33ec$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});



parcelRegister("5P22X", function(module, exports) {

$parcel$export(module.exports, "makeFixForAdapter", function () { return $43d34d9568183426$export$a74bff2507e6126b; });

var $62ppy = parcelRequire("62ppy");
parcelRequire("2RcWZ");
var $aBODl = parcelRequire("aBODl");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $43d34d9568183426$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $43d34d9568183426$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (_unused) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $43d34d9568183426$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$43d34d9568183426$var$hasSameOrigin(window.location.href, iframe.src);
}
var $43d34d9568183426$var$registry = new Map();
function $43d34d9568183426$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($43d34d9568183426$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $43d34d9568183426$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $43d34d9568183426$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $43d34d9568183426$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $43d34d9568183426$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $aBODl.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $43d34d9568183426$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $43d34d9568183426$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("iTq1k", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", function () { return $dc118c28b7dca328$export$27d79116d3a4e7d5; });
parcelRequire("d5YrK");
var $5PG1M = parcelRequire("5PG1M");

var $5P22X = parcelRequire("5P22X");
function $dc118c28b7dca328$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $5PG1M.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $dc118c28b7dca328$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $5PG1M.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $dc118c28b7dca328$var$api = (0, $5P22X.makeFixForAdapter)({
    watchForInteractionStart: $dc118c28b7dca328$var$watchForInteractionStart,
    watchForInteractionEnd: $dc118c28b7dca328$var$watchForInteractionEnd
});
function $dc118c28b7dca328$export$27d79116d3a4e7d5() {
    return $dc118c28b7dca328$var$api.registerUsage();
}

});
parcelRegister("d5YrK", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", function () { return (parcelRequire("5PG1M")).monitorForExternal; });

var $5PG1M = parcelRequire("5PG1M");
 // The data that is being dragged

});
parcelRegister("5PG1M", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", function () { return $43f251062376546b$export$bb1740f3194979c1; });

var $62ppy = parcelRequire("62ppy");

var $40QgJ = parcelRequire("40QgJ");

var $JEGNE = parcelRequire("JEGNE");

var $72Vkp = parcelRequire("72Vkp");

var $l15j5 = parcelRequire("l15j5");

var $apphO = parcelRequire("apphO");

var $eYhDY = parcelRequire("eYhDY");

var $dPgDA = parcelRequire("dPgDA");
function $43f251062376546b$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $dPgDA.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $eYhDY.textMediaType) && value === (0, $72Vkp.androidFallbackText)) return false;
    return true;
}
function $43f251062376546b$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $43f251062376546b$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $43f251062376546b$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || $43f251062376546b$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $43f251062376546b$var$didDragStartLocally = false;
var $43f251062376546b$var$adapter = (0, $JEGNE.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $40QgJ.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($43f251062376546b$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $l15j5.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $43f251062376546b$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $43f251062376546b$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$43f251062376546b$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $43f251062376546b$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $43f251062376546b$var$adapter.dropTarget(args);
}
function $43f251062376546b$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $43f251062376546b$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $43f251062376546b$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $43f251062376546b$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $40QgJ.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($62ppy)))((0, $apphO.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $40QgJ.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $43f251062376546b$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("l15j5", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindow", function () { return $f4cdcec8563a9321$export$d1c6f249e893cdf4; });

var $1bnP3 = parcelRequire("1bnP3");

var $fGpYV = parcelRequire("fGpYV");

var $e4l25 = parcelRequire("e4l25");

var $8Q9aS = parcelRequire("8Q9aS");
function $f4cdcec8563a9321$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, $fGpYV.isSafari)()) return (0, $e4l25.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $1bnP3.isFirefox)()) return (0, $8Q9aS.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});




parcelRegister("eAFlt", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", function () { return $a9f47fce1736c5e8$export$9c0606fcefb5d1e2; });

var $40QgJ = parcelRequire("40QgJ");
parcelRequire("2RcWZ");
var $aBODl = parcelRequire("aBODl");
parcelRequire("cG977");
var $3w4Wp = parcelRequire("3w4Wp");

var $5P22X = parcelRequire("5P22X");
function $a9f47fce1736c5e8$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $40QgJ.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $3w4Wp.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $aBODl.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $a9f47fce1736c5e8$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $40QgJ.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $a9f47fce1736c5e8$var$api = (0, $5P22X.makeFixForAdapter)({
    watchForInteractionStart: $a9f47fce1736c5e8$var$watchForInteractionStart,
    watchForInteractionEnd: $a9f47fce1736c5e8$var$watchForInteractionEnd
});
function $a9f47fce1736c5e8$export$9c0606fcefb5d1e2() {
    return $a9f47fce1736c5e8$var$api.registerUsage();
}

});
parcelRegister("cG977", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", function () { return (parcelRequire("3w4Wp")).monitorForTextSelection; });

var $3w4Wp = parcelRequire("3w4Wp");
 // Payload for the text selection being dragged

});
parcelRegister("3w4Wp", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", function () { return $28f831760707270e$export$2e178e3647f5e6e9; });

var $40QgJ = parcelRequire("40QgJ");

var $ca9ZT = parcelRequire("ca9ZT");

var $JEGNE = parcelRequire("JEGNE");

var $aBODl = parcelRequire("aBODl");

var $fGpYV = parcelRequire("fGpYV");

var $getag = parcelRequire("getag");

var $eYhDY = parcelRequire("eYhDY");

var $dPgDA = parcelRequire("dPgDA");
function $28f831760707270e$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $fGpYV.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $eYhDY.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $28f831760707270e$var$honeyPotFix = (0, $ca9ZT.makeHoneyPotFix)();
var $28f831760707270e$var$adapter = (0, $JEGNE.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $aBODl.combine)($28f831760707270e$var$honeyPotFix.bindEvents(), (0, $40QgJ.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $dPgDA.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $eYhDY.textMediaType))) return;
                var target = $28f831760707270e$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $eYhDY.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $getag.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $28f831760707270e$var$honeyPotFix.getOnPostDispatch()
});
function $28f831760707270e$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $28f831760707270e$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $28f831760707270e$var$adapter.registerUsage();
})();
function $28f831760707270e$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $28f831760707270e$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("getag", function(module, exports) {

$parcel$export(module.exports, "HTMLMediaType", function () { return $bd1493a17fb2912d$export$338a9f6c7a1f02b0; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $bd1493a17fb2912d$export$338a9f6c7a1f02b0 = 'text/html';

});




parcelRegister("8nm5G", function(module, exports) {

$parcel$export(module.exports, "dialogWidth", function () { return $61919b72438a82c3$export$a3da89b899389ed8; });
$parcel$export(module.exports, "dialogHeight", function () { return $61919b72438a82c3$export$ceba93bf0bdd16f2; });
var $61919b72438a82c3$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
var $61919b72438a82c3$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = $61919b72438a82c3$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($61919b72438a82c3$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $61919b72438a82c3$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};

});

parcelRegister("cTM9A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $963ff9682c8ec904$export$2e2bcd8739ae039; });
/* positioner.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $eZCOV = parcelRequire("eZCOV");

var $6Tk8u = parcelRequire("6Tk8u");

// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $963ff9682c8ec904$var$positionerStyles = null;
var $963ff9682c8ec904$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
var $963ff9682c8ec904$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $963ff9682c8ec904$var$getScrollBehavior(_ref) {
    var isFullScreen = _ref.isFullScreen, shouldScrollInViewport = _ref.shouldScrollInViewport;
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
var $963ff9682c8ec904$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId, isFullScreen = props.isFullScreen;
    var scrollBehavior = $963ff9682c8ec904$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $dNMDr.createElement("div", {
        style: {
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: "".concat((0, $6Tk8u.durations).medium, "ms"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $eZCOV.easeInOut)
        },
        "data-testid": testId && "".concat(testId, "--positioner"),
        className: (0, $affTb.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            $963ff9682c8ec904$var$stackStyles.stackTransition,
            stackIndex > 0 ? $963ff9682c8ec904$var$stackStyles.stackTransform : $963ff9682c8ec904$var$stackStyles.stackIdle,
            $963ff9682c8ec904$var$scrollStyles[scrollBehavior]
        ])
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$963ff9682c8ec904$export$2e2bcd8739ae039 = $963ff9682c8ec904$var$Positioner;

});
parcelRegister("eZCOV", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $aea4e021446be462$export$c07234257a03d5e9; });
var $aea4e021446be462$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $aea4e021446be462$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $aea4e021446be462$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $aea4e021446be462$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $aea4e021446be462$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $aea4e021446be462$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $aea4e021446be462$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});





parcelRegister("lupi5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa5004837be6db39$export$2e2bcd8739ae039; });
/* modal-body.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $affTb = parcelRequire("affTb");

var $dNMDr = parcelRequire("dNMDr");

var $bYxNM = parcelRequire("bYxNM");

var $hp94Z = parcelRequire("hp94Z");

var $aJCFr = parcelRequire("aJCFr");

var $12HCw = parcelRequire("12HCw");
var $fa5004837be6db39$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _11c8fhey",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $fa5004837be6db39$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasInlinePaddi = props.hasInlinePadding, hasInlinePadding = _props$hasInlinePaddi === void 0 ? true : _props$hasInlinePaddi;
    var _useModal = (0, $hp94Z.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $12HCw.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
        "data-testid": testId,
        className: (0, $affTb.default)([
            $fa5004837be6db39$var$styles.root,
            hasInlinePadding && $fa5004837be6db39$var$styles.paddingInline
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $bYxNM.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $aJCFr.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
        "data-testid": testId,
        className: (0, $affTb.default)([
            $fa5004837be6db39$var$styles.root,
            /**
     * Adding block padding for scroll keylines, which are only shown when the scrolling
     * is on the container.
     */ $fa5004837be6db39$var$styles.paddingBlock,
            hasInlinePadding && $fa5004837be6db39$var$styles.paddingInline
        ])
    }, children)));
};
var $fa5004837be6db39$export$2e2bcd8739ae039 = $fa5004837be6db39$var$ModalBody;

});
parcelRegister("hp94Z", function(module, exports) {

$parcel$export(module.exports, "useModal", function () { return $cabbd076b2d9e002$export$33ffd74ebf07f060; });

var $dNMDr = parcelRequire("dNMDr");

var $aD0VR = parcelRequire("aD0VR");
var $cabbd076b2d9e002$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $dNMDr.useContext)((0, $aD0VR.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("aJCFr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d0c19e445a92e3f$export$2e2bcd8739ae039; });
/* scroll-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $82V4i = parcelRequire("82V4i");


var $dNMDr = parcelRequire("dNMDr");

var $40QgJ = parcelRequire("40QgJ");

var $hRtNQ = parcelRequire("hRtNQ");

var $kugzw = parcelRequire("kugzw");

var $gTgRL = parcelRequire("gTgRL");

var $c3KQG = parcelRequire("c3KQG");

var $fv0xi = parcelRequire("fv0xi");

var $aZGMH = parcelRequire("aZGMH");
var $7d0c19e445a92e3f$var$keylineColor = "var(--ds-border, #0B120E24)";
var $7d0c19e445a92e3f$var$styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm21uh4",
    bottomKeyline: "_179r1uh4"
};
var $7d0c19e445a92e3f$var$keylineHeight = 2;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $7d0c19e445a92e3f$var$ScrollContainer = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $dNMDr.useRef)(null);
    var _useState = (0, $dNMDr.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $dNMDr.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $dNMDr.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $dNMDr.useEffect)(function() {
        var schedule = (0, $hRtNQ.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $fv0xi.default)((0, $hRtNQ.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $7d0c19e445a92e3f$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $7d0c19e445a92e3f$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $dNMDr.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $40QgJ.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $40QgJ.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $c3KQG.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $aZGMH.default), {
        as: "div",
        isInset: true,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && "".concat(testId, "--scrollable"),
        ref: (0, $gTgRL.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $kugzw.cx)($7d0c19e445a92e3f$var$styles.base, showTopKeyline && $7d0c19e445a92e3f$var$styles.topKeyline, showBottomKeyline && $7d0c19e445a92e3f$var$styles.bottomKeyline)
    }, children);
});
$7d0c19e445a92e3f$var$ScrollContainer.displayName = 'ScrollContainer';
var $7d0c19e445a92e3f$export$2e2bcd8739ae039 = $7d0c19e445a92e3f$var$ScrollContainer;

});

parcelRegister("12HCw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c27d06eb93f61a7$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $aD0VR = parcelRequire("aD0VR");
function $0c27d06eb93f61a7$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $dNMDr.useContext)((0, $aD0VR.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("dPurX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a117a882ef23b800$export$2e2bcd8739ae039; });
/* modal-footer.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $hp94Z = parcelRequire("hp94Z");
var $a117a882ef23b800$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $a117a882ef23b800$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $hp94Z.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return /*#__PURE__*/ $dNMDr.createElement("div", {
        "data-testid": testId,
        className: (0, $affTb.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ])
    }, children);
};
var $a117a882ef23b800$export$2e2bcd8739ae039 = $a117a882ef23b800$var$ModalFooter;

});

parcelRegister("ihPx0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d501c98ffff29838$export$2e2bcd8739ae039; });
/* modal-header.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $affTb = parcelRequire("affTb");

var $dNMDr = parcelRequire("dNMDr");

var $1EqrL = parcelRequire("1EqrL");

var $kb9LE = parcelRequire("kb9LE");

var $hp94Z = parcelRequire("hp94Z");
var $d501c98ffff29838$var$styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $d501c98ffff29838$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $hp94Z.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement("div", {
        "data-testid": testId,
        className: (0, $affTb.default)([
            $d501c98ffff29838$var$styles.header
        ])
    }, shouldShowCloseButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1EqrL.default), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $d501c98ffff29838$var$styles.flex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1EqrL.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $kb9LE.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $1EqrL.default), {
        justifyContent: "start",
        alignItems: "center",
        xcss: $d501c98ffff29838$var$styles.titleContainer
    }, children)) : children);
};
var $d501c98ffff29838$export$2e2bcd8739ae039 = $d501c98ffff29838$var$ModalHeader;

});
parcelRegister("kb9LE", function(module, exports) {

$parcel$export(module.exports, "CloseButton", function () { return $eb0c695801757397$export$de65de8213222d10; });

var $dNMDr = parcelRequire("dNMDr");

var $dpTxl = parcelRequire("dpTxl");

var $dP4Xn = parcelRequire("dP4Xn");
var $eb0c695801757397$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onBlur = _ref.onBlur, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $dpTxl.default), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dP4Xn))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
};

});


parcelRegister("8Du6M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $649952250cbf05d1$export$2e2bcd8739ae039; });
/* modal-title.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $fGClI = parcelRequire("fGClI");

var $fIC9d = parcelRequire("fIC9d");

var $hp94Z = parcelRequire("hp94Z");
var $649952250cbf05d1$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
var $649952250cbf05d1$var$iconStyles = null;
var $649952250cbf05d1$var$titleStyles = null;
var $649952250cbf05d1$var$textStyles = null;
var $649952250cbf05d1$var$truncatedTextStyles = null;
var $649952250cbf05d1$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($fGClI))) : (0, (/*@__PURE__*/$parcel$interopDefault($fIC9d)));
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        className: (0, $affTb.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ])
    }, /*#__PURE__*/ $dNMDr.createElement(Icon, {
        label: appearance,
        color: $649952250cbf05d1$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $649952250cbf05d1$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $hp94Z.useModal)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return /*#__PURE__*/ $dNMDr.createElement("h1", {
        "data-testid": testId,
        className: (0, $affTb.default)([
            "_zulpu2gc _11c81af2 _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ])
    }, appearance && /*#__PURE__*/ $dNMDr.createElement($649952250cbf05d1$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ $dNMDr.createElement("span", {
        id: titleId,
        "data-testid": testId && "".concat(testId, "-text"),
        className: (0, $affTb.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _slp31hna",
            !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
var $649952250cbf05d1$export$2e2bcd8739ae039 = $649952250cbf05d1$var$ModalTitle;

});

parcelRegister("lgmV7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7acdf0fa3a61332$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $bnv12 = parcelRequire("bnv12");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $f7acdf0fa3a61332$var$ModalTransition = function ModalTransition(props) {
    var _props$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $bnv12.default), {
        appear: true
    }, (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : null);
};
var $f7acdf0fa3a61332$export$2e2bcd8739ae039 = $f7acdf0fa3a61332$var$ModalTransition;

});


parcelRegister("lChtt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "pageId", function () { return $0b7f0a96fe5061ae$export$703ba2e7ea526c1b; });
$parcel$export(module.exports, "stepUpStartLoader", function () { return $0b7f0a96fe5061ae$export$3661a07f17c95cba; });
$parcel$export(module.exports, "StepUpStartPage", function () { return $0b7f0a96fe5061ae$export$e561dacd818ab41; });
$parcel$export(module.exports, "default", function () { return $0b7f0a96fe5061ae$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $cpaps = parcelRequire("cpaps");

var $lwrli = parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $Q6OOA = parcelRequire("Q6OOA");

var $2byD0 = parcelRequire("2byD0");

var $5pCRv = parcelRequire("5pCRv");

var $cuZAx = parcelRequire("cuZAx");

var $2CzSe = parcelRequire("2CzSe");

var $8PbSs = parcelRequire("8PbSs");

var $crWLR = parcelRequire("crWLR");

var $eTWY7 = parcelRequire("eTWY7");

var $7lC8o = parcelRequire("7lC8o");

var $d2egb = parcelRequire("d2egb");

var $idMOo = parcelRequire("idMOo");

var $4NPio = parcelRequire("4NPio");

var $aMBBA = parcelRequire("aMBBA");

var $h4v4M = parcelRequire("h4v4M");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");
const $0b7f0a96fe5061ae$export$703ba2e7ea526c1b = 'stepUpOtpChallengeScreen';
const $0b7f0a96fe5061ae$var$OTP_CODE_LENGTH = 8;
const $0b7f0a96fe5061ae$var$Form = (0, $fbSBq.default).form`
  margin: ${(0, $68HQw.gridSize)()}px 0 0;
`;
const $0b7f0a96fe5061ae$var$ButtonContainer = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $0b7f0a96fe5061ae$var$RequestPasscodeButtonContainer = (0, $fbSBq.default).div`
  margin-top: ${3 * (0, $68HQw.gridSize)()}px;
`;
const $0b7f0a96fe5061ae$var$SecondaryLinkWrapper = (0, $fbSBq.default).ul`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
/**
 * This restores the state from session storage and saves it to session storage if it changes.
 */ function $0b7f0a96fe5061ae$var$useSyncWithSessionStorage(sessionStorageKey, sessionStorageValue, onStorageUpdate) {
    (0, $dNMDr.useEffect)(()=>{
        const storageListener = (event)=>{
            if (event.key === sessionStorageKey) {
                if (event.newValue !== sessionStorageValue) onStorageUpdate(event.newValue);
            }
        };
        window.addEventListener('storage', storageListener);
        const sessionStorageItem = window.sessionStorage.getItem(sessionStorageKey);
        if (sessionStorageItem) onStorageUpdate(sessionStorageItem);
        return ()=>{
            window.removeEventListener('storage', storageListener);
        };
    // This code looks intended to only run on component mount. Missing deps assumed okay at the
    // time the linting rule was added, but may need further investigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $dNMDr.useEffect)(()=>{
        if (sessionStorageValue) window.sessionStorage.setItem(sessionStorageKey, sessionStorageValue);
    }, [
        sessionStorageValue,
        sessionStorageKey
    ]);
    const clearSessionStorage = (0, $dNMDr.useCallback)(()=>{
        window.sessionStorage.removeItem(sessionStorageKey);
    }, [
        sessionStorageKey
    ]);
    return [
        clearSessionStorage
    ];
}
async function $0b7f0a96fe5061ae$export$3661a07f17c95cba({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/step-up/start/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $0b7f0a96fe5061ae$export$e561dacd818ab41 = ()=>{
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const intl = (0, $ko1o6.default)();
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const oidcContext = (0, $aMBBA.useAppSelector)((state)=>state.microbranding.oidcContext);
    const isMobile = (0, $cuZAx.isMobileOidc)(oidcContext);
    const email = (0, $aMBBA.useAppSelector)((state)=>state.stepUp.email);
    const mfaToken = (0, $aMBBA.useAppSelector)((state)=>state.stepUp.mfaToken);
    const dispatchAddFlag = (0, $dNMDr.useCallback)((flag)=>dispatch((0, $7lC8o.addFlag)(flag.type, flag.title, flag.description)), [
        dispatch
    ]);
    const [otpCode, setOtpCode] = (0, $dNMDr.useState)('');
    const [isLoading, setLoading] = (0, $dNMDr.useState)(false);
    const [verificationError, setVerificationError] = (0, $dNMDr.useState)();
    const { hash: hash, search: search } = (0, $cVnBY.useLocation)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const setHash = (0, $dNMDr.useCallback)((hash)=>navigate(search + '#' + hash, {
            replace: true
        }), [
        navigate,
        search
    ]);
    const [clearSessionStorageMfaToken] = $0b7f0a96fe5061ae$var$useSyncWithSessionStorage('mfaToken', mfaToken, (mfaToken)=>{
        dispatch((0, $d2egb.updateFromSessionStorage)(mfaToken));
    });
    const [manualOtpCodeTriggerMode, setManualOtpCodeTriggerMode] = (0, $dNMDr.useState)(()=>{
        return document.visibilityState === 'hidden';
    });
    (0, $4NPio.usePageViewedEvent)($0b7f0a96fe5061ae$export$703ba2e7ea526c1b, {
        value: manualOtpCodeTriggerMode ? 'manualOtpSend' : 'autoOtpSend'
    });
    (0, $4NPio.useOperationalEvent)({
        page: $0b7f0a96fe5061ae$export$703ba2e7ea526c1b,
        action: `loadStepUpStartPageSuccessful`,
        subject: 'sli'
    });
    const triggerCodeSend = (0, $dNMDr.useCallback)(async ()=>{
        const codeSendResult = await dispatch((0, $d2egb.sendCode)());
        if (codeSendResult.success) {
            analyticsClient.trackingEvent({
                page: $0b7f0a96fe5061ae$export$703ba2e7ea526c1b,
                subject: 'sendCode',
                action: 'succeed'
            });
            setHash('sent');
        } else if (codeSendResult.errorCode === 'too_many_requests') {
            dispatchAddFlag({
                type: 'error',
                title: (0, $2CzSe.default).stepUpStartFlagErrorRateLimitTitle,
                description: (0, $2CzSe.default).stepUpStartFlagErrorRateLimitDesc
            });
            analyticsClient.errorShownEvent($0b7f0a96fe5061ae$export$703ba2e7ea526c1b, 'sendCode', {
                errorCode: codeSendResult.errorCode
            });
        } else {
            dispatchAddFlag({
                type: 'error',
                title: (0, $2CzSe.default).stepUpStartFlagErrorTitle,
                description: (0, $2CzSe.default).stepUpStartFlagErrorDesc
            });
            analyticsClient.errorShownEvent($0b7f0a96fe5061ae$export$703ba2e7ea526c1b, 'sendCode', {
                errorCode: codeSendResult.errorCode
            });
        }
    }, [
        analyticsClient,
        dispatch,
        dispatchAddFlag,
        setHash
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (hash === '#sent') analyticsClient.trackingEvent({
            page: $0b7f0a96fe5061ae$export$703ba2e7ea526c1b,
            subject: 'sendCode',
            action: 'skipped',
            attributes: {
                reason: 'already sent'
            }
        });
        else if (manualOtpCodeTriggerMode) analyticsClient.trackingEvent({
            page: $0b7f0a96fe5061ae$export$703ba2e7ea526c1b,
            subject: 'sendCode',
            action: 'skipped',
            attributes: {
                reason: 'opened in background'
            }
        });
        else triggerCodeSend().catch(()=>dispatchAddFlag({
                type: 'error',
                title: (0, $2CzSe.default).stepUpStartFlagErrorTitle,
                description: (0, $2CzSe.default).stepUpStartFlagErrorDesc
            }));
    // We only want to ever trigger this effect once.
    // Otherwise we risk triggering multiple email code sends due to race conditions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleSubmit = (0, $dNMDr.useCallback)(async (e)=>{
        if (e) e.preventDefault();
        analyticsClient.uiEvent({
            page: $0b7f0a96fe5061ae$export$703ba2e7ea526c1b,
            subject: 'form',
            subjectId: 'otpForm',
            action: 'submitted'
        });
        setLoading(true);
        try {
            const result = await dispatch((0, $d2egb.verifyOtpCode)(otpCode));
            if ('redirectUri' in result) {
                clearSessionStorageMfaToken();
                analyticsClient.trackingEvent({
                    page: $0b7f0a96fe5061ae$export$703ba2e7ea526c1b,
                    action: 'succeeded',
                    subject: 'stepUpChallenge'
                });
                navigate(result.redirectUri);
            } else {
                analyticsClient.trackingEvent({
                    page: $0b7f0a96fe5061ae$export$703ba2e7ea526c1b,
                    action: 'failed',
                    subject: 'stepUpChallenge',
                    attributes: {
                        errorCode: result.errorCode
                    }
                });
                setVerificationError(result);
            }
        } catch (e) {
            const errorCode = 'unknown';
            analyticsClient.trackingEvent({
                page: $0b7f0a96fe5061ae$export$703ba2e7ea526c1b,
                action: 'failed',
                subject: 'stepUpChallenge',
                attributes: {
                    errorCode: errorCode
                }
            });
            setVerificationError({
                errorCode: errorCode
            });
        } finally{
            setLoading(false);
        }
    }, [
        analyticsClient,
        dispatch,
        otpCode,
        clearSessionStorageMfaToken,
        navigate
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (otpCode.length === $0b7f0a96fe5061ae$var$OTP_CODE_LENGTH) handleSubmit();
    }, [
        handleSubmit,
        otpCode
    ]);
    const handleInputChange = (e)=>{
        setVerificationError(undefined);
        setOtpCode(e.target.value);
    };
    const handleResendCode = async ()=>{
        analyticsClient.linkClickedEvent($0b7f0a96fe5061ae$export$703ba2e7ea526c1b, 'resendOtp');
        const result = await dispatch(mfaToken ? (0, $d2egb.resendCode)() : (0, $d2egb.sendCode)());
        if (result.success) dispatchAddFlag({
            type: 'success',
            title: (0, $2CzSe.default).stepUpStartFlagSuccessTitle,
            description: (0, $2CzSe.default).stepUpStartFlagSuccessDesc
        });
        else dispatchAddFlag({
            type: 'error',
            title: (0, $2CzSe.default).stepUpStartFlagErrorTitle,
            description: (0, $2CzSe.default).stepUpStartFlagErrorDesc
        });
    };
    const handleVerify = ()=>{
        analyticsClient.buttonClickedEvent($0b7f0a96fe5061ae$export$703ba2e7ea526c1b, 'verifyOtp');
    };
    const handleReturnToLogin = ()=>{
        analyticsClient.linkClickedEvent($0b7f0a96fe5061ae$export$703ba2e7ea526c1b, 'switchAccount');
    };
    const handleSendOtpCode = async ()=>{
        analyticsClient.buttonClickedEvent($0b7f0a96fe5061ae$export$703ba2e7ea526c1b, 'sendOtpCode');
        await triggerCodeSend().catch(()=>dispatchAddFlag({
                type: 'error',
                title: (0, $2CzSe.default).stepUpStartFlagErrorTitle,
                description: (0, $2CzSe.default).stepUpStartFlagErrorDesc
            }));
        setManualOtpCodeTriggerMode(false);
    };
    const returnLoginLink = `/login/select-account${search}`;
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)("title", {
                    children: intl.formatMessage((0, $2CzSe.default).stepUpStartTitle)
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
                pageId: $0b7f0a96fe5061ae$export$703ba2e7ea526c1b,
                header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...manualOtpCodeTriggerMode ? (0, $2CzSe.default).stepUpOpenedInBackgroundHeader : (0, $2CzSe.default).stepUpStartTitle,
                    tagName: "h5"
                }),
                footer: /*#__PURE__*/ (0, $6CtE1.jsxs)("ul", {
                    className: "fine-print",
                    children: [
                        /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.PrivacyPolicyLink), {
                                isMobileLink: isMobile
                            })
                        }),
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $idMOo.default), {}),
                        /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.UserNoticeLink), {
                                isMobileLink: isMobile
                            })
                        })
                    ]
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $6CtE1.jsx)("ul", {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                                children: !manualOtpCodeTriggerMode && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                                    id: "resend-code",
                                    spacing: "none",
                                    onClick: handleResendCode,
                                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                        ...(0, $2CzSe.default).stepUpStartResendCode
                                    })
                                })
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0, $6CtE1.jsx)($0b7f0a96fe5061ae$var$SecondaryLinkWrapper, {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.Link), {
                                    id: "return-to-login",
                                    "data-testid": "return-to-login",
                                    to: returnLoginLink,
                                    onClick: handleReturnToLogin,
                                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                        ...(0, $2CzSe.default).stepUpStartReturnToLogin
                                    })
                                })
                            })
                        })
                    ]
                }),
                children: [
                    !manualOtpCodeTriggerMode && /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8PbSs.default), {
                                email: email,
                                message: intl.formatMessage((0, $2CzSe.default).stepUpStartEmailSentHeader)
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsxs)($0b7f0a96fe5061ae$var$Form, {
                                autoComplete: "off",
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $crWLR.default), {
                                        id: "otp-code-input",
                                        disabled: isLoading,
                                        fieldErrorFromParent: verificationError,
                                        onChange: handleInputChange,
                                        codeLength: $0b7f0a96fe5061ae$var$OTP_CODE_LENGTH,
                                        codeType: "numeric"
                                    }),
                                    /*#__PURE__*/ (0, $6CtE1.jsx)($0b7f0a96fe5061ae$var$ButtonContainer, {
                                        id: "verify-submit",
                                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                                            appearance: "primary",
                                            type: "submit",
                                            isFullWidth: true,
                                            isLoading: isLoading,
                                            onClick: handleVerify,
                                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                                ...(0, $2CzSe.default).stepUpStartVerify
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    manualOtpCodeTriggerMode && /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8PbSs.default), {
                                email: email,
                                message: intl.formatMessage((0, $2CzSe.default).stepUpOpenedInBackgroundMessage)
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)($0b7f0a96fe5061ae$var$RequestPasscodeButtonContainer, {
                                id: "send-otp-code",
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isFullWidth: true,
                                    onClick: handleSendOtpCode,
                                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                        ...(0, $2CzSe.default).stepUpStartSendCode
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $0b7f0a96fe5061ae$export$2e2bcd8739ae039 = $0b7f0a96fe5061ae$export$e561dacd818ab41;

});
parcelRegister("2CzSe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $921f1433c3897c8a$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $921f1433c3897c8a$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    stepUpStartTitle: {
        id: 'stepUp.start.title',
        defaultMessage: 'Verify your identity'
    },
    stepUpStartFlagSuccessTitle: {
        id: 'stepUp.start.sent.flag.success.title',
        defaultMessage: 'Email resent'
    },
    stepUpStartFlagSuccessDesc: {
        id: 'stepUp.start.sent.flag.success.description',
        defaultMessage: 'You should have a new code waiting for you in your inbox.'
    },
    stepUpStartFlagErrorTitle: {
        id: 'stepUp.start.sent.flag.error.title',
        defaultMessage: 'Something went wrong.'
    },
    stepUpStartFlagErrorDesc: {
        id: 'stepUp.start.sent.flag.error.description',
        defaultMessage: 'Please try again later.'
    },
    stepUpStartFlagErrorRateLimitTitle: {
        id: 'stepUp.start.sent.flag.error.rate.limit.title',
        defaultMessage: 'Something went wrong.'
    },
    stepUpStartFlagErrorRateLimitDesc: {
        id: 'stepUp.start.sent.flag.error.rate.limit.description',
        defaultMessage: 'Wait for a few minutes, then try again.'
    },
    stepUpStartResendCode: {
        id: 'stepUp.start.resend.code',
        defaultMessage: "Didn't get the code? Resend it"
    },
    stepUpStartReturnToLogin: {
        id: 'stepUp.start.return.to.login',
        defaultMessage: 'Need to log in to a different account?'
    },
    stepUpStartEmailSentHeader: {
        id: 'stepUp.start.email.sent.header',
        defaultMessage: 'To access, enter the verification code that we emailed to:'
    },
    stepUpStartVerify: {
        id: 'stepUp.start.verify',
        defaultMessage: 'Verify'
    },
    stepUpStartSendCode: {
        id: 'stepUp.start.sendCode',
        defaultMessage: 'Request passcode'
    },
    stepUpOpenedInBackgroundHeader: {
        id: 'stepUp.start.opened.in.background.header',
        defaultMessage: 'Request one-time passcode'
    },
    stepUpOpenedInBackgroundMessage: {
        id: 'stepUp.start.opened.in.background.message',
        defaultMessage: 'To verify your identity, request a one-time passcode that we send to:'
    }
});

});

parcelRegister("d2egb", function(module, exports) {

$parcel$export(module.exports, "updateFromSessionStorage", function () { return $fe75d7613e21d5b5$export$60734d01582497d4; });
$parcel$export(module.exports, "sendCode", function () { return $fe75d7613e21d5b5$export$74ede56a84543af4; });
$parcel$export(module.exports, "resendCode", function () { return $fe75d7613e21d5b5$export$90e3d721ed7e24a8; });
$parcel$export(module.exports, "verifyOtpCode", function () { return $fe75d7613e21d5b5$export$a5c568dd7addf7ae; });

var $1JRGy = parcelRequire("1JRGy");
const $fe75d7613e21d5b5$export$dc6765fdde20a9c1 = (mfaToken)=>({
        type: 'STEP_UP_SEND_CODE_SUCCESS',
        mfaToken: mfaToken
    });
const $fe75d7613e21d5b5$export$72ac8a8529ba0de5 = (mfaToken)=>({
        type: 'STEP_UP_RESEND_CODE_SUCCESS',
        mfaToken: mfaToken
    });
const $fe75d7613e21d5b5$export$60734d01582497d4 = (mfaToken)=>({
        type: 'STEP_UP_MFA_TOKEN_LOAD_FROM_SESSION_STORAGE',
        mfaToken: mfaToken
    });
const $fe75d7613e21d5b5$export$74ede56a84543af4 = ()=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken, stepUp: { token: token } } = getState();
        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(window.location.search);
        const response = await fetch('/rest/step-up/start', {
            method: 'POST',
            body: JSON.stringify({
                continue: queryParams.continue,
                application: queryParams.application,
                token: token
            }),
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            }
        });
        if (response.ok) {
            const responseBody = await response.json();
            dispatch($fe75d7613e21d5b5$export$dc6765fdde20a9c1(responseBody.transactionToken));
            return {
                success: true
            };
        } else if (response.status === 429) return {
            success: false,
            errorCode: 'too_many_requests'
        };
        else return {
            success: false,
            errorCode: 'unknown_error'
        };
    };
const $fe75d7613e21d5b5$export$90e3d721ed7e24a8 = ()=>async (dispatch, getState)=>{
        const { stepUp: { mfaToken: mfaToken }, csrfToken: csrfToken } = getState();
        try {
            const response = await fetch(`/rest/mfa/resend?transactionToken=${mfaToken}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                }
            });
            if (response.ok) {
                const responseBody = await response.json();
                dispatch($fe75d7613e21d5b5$export$72ac8a8529ba0de5(responseBody.transactionToken));
                return {
                    success: true
                };
            } else return {
                success: false,
                errorCode: 'resend_failed'
            };
        } catch (error) {
            return {
                success: false,
                errorCode: 'resend_failed'
            };
        }
    };
const $fe75d7613e21d5b5$export$a5c568dd7addf7ae = (otpCode)=>async (dispatch, getState)=>{
        const { stepUp: stepUp, csrfToken: csrfToken } = getState();
        const continueUrl = new URLSearchParams(window.location.search).get('continue');
        try {
            const response = await fetch(`/rest/mfa/verify?transactionToken=${stepUp.mfaToken}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify({
                    otpCode: otpCode
                })
            });
            if (response.ok) {
                const responseBody = await response.json();
                const loginAuthorizeResp = await fetch(`/rest/mfa/authorize?transactionToken=${responseBody.transactionToken}`);
                if (loginAuthorizeResp.ok) {
                    const loginAuthorizeUrl = new URL((await loginAuthorizeResp.json()).redirectUri);
                    if (continueUrl !== null) loginAuthorizeUrl.searchParams.append('continue', continueUrl);
                    return {
                        redirectUri: loginAuthorizeUrl.toString()
                    };
                } else return {
                    errorCode: 'invalid_otp'
                };
            } else switch(response.status){
                case 400:
                    const body = await response.json();
                    if (body.context.reason === 'invalid_transaction_token') return {
                        errorCode: 'expired_otp'
                    };
                    else return {
                        errorCode: 'invalid_otp'
                    };
                case 403:
                    return {
                        errorCode: 'invalid_otp'
                    };
                case 429:
                    return {
                        errorCode: 'too_many_requests'
                    };
                default:
                    return {
                        errorCode: 'unknown'
                    };
            }
        } catch (error) {
            return {
                errorCode: 'unknown'
            };
        }
    };

});


parcelRegister("5WYPj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "changeEmailLoader", function () { return $10f87cfecadaa864$export$6d7f213d69a144e5; });
$parcel$export(module.exports, "EmailConfirmationPage", function () { return $10f87cfecadaa864$export$98b365c355bab28e; });
$parcel$export(module.exports, "default", function () { return $10f87cfecadaa864$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $6OVQQ = parcelRequire("6OVQQ");

var $8gw6F = parcelRequire("8gw6F");

var $6Fpr0 = parcelRequire("6Fpr0");

var $aMBBA = parcelRequire("aMBBA");

var $84ZjZ = parcelRequire("84ZjZ");

var $cBB3b = parcelRequire("cBB3b");

var $4ljBU = parcelRequire("4ljBU");
async function $10f87cfecadaa864$export$6d7f213d69a144e5({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/verify-email/change-email/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--change-email'
        ]
    });
}
const $10f87cfecadaa864$export$98b365c355bab28e = ()=>{
    const error = (0, $aMBBA.useAppSelector)((state)=>state.changeEmail.error);
    const isFeatureGateEnabled = (0, $84ZjZ.checkFeatureGate)((0, $cBB3b.AidFrontendFeatureGate).ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL);
    if (error === 'invalid_token') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6OVQQ.default), {});
    if (isFeatureGateEnabled) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8gw6F.default), {});
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6Fpr0.default), {});
};
var $10f87cfecadaa864$export$2e2bcd8739ae039 = $10f87cfecadaa864$export$98b365c355bab28e;

});
parcelRegister("6OVQQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a772409b3425295d$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $cU73R = parcelRequire("cU73R");

var $e8kIe = parcelRequire("e8kIe");

var $4NPio = parcelRequire("4NPio");

var $dSMnQ = parcelRequire("dSMnQ");

var $lwrli = parcelRequire("lwrli");
const $a772409b3425295d$export$703ba2e7ea526c1b = 'emailConfirmationInvalidTokenErrorPage';
const $a772409b3425295d$export$de2e70c0e2bb29f5 = ()=>{
    (0, $4NPio.usePageViewedEvent)($a772409b3425295d$export$703ba2e7ea526c1b);
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $cU73R.default), {
        title: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            ...(0, $dSMnQ.default).invalidTokenTitle
        }),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)("p", {
                "data-testid": "email-confirmation-error-container-idf-testid",
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...(0, $dSMnQ.default).invalidTokenDescription
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("p", {
                className: "error-action",
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.Link), {
                    to: "/login",
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $e8kIe.default), {
                        appearance: "primary",
                        testId: "email-confirmation-error-page-button-idf-testid",
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            ...(0, $dSMnQ.default).invalidTokenReturnToLoginButton
                        })
                    })
                })
            })
        ]
    });
};
var $a772409b3425295d$export$2e2bcd8739ae039 = $a772409b3425295d$export$de2e70c0e2bb29f5;

});
parcelRegister("dSMnQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3312c6257d797d2$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $e3312c6257d797d2$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    invalidTokenTitle: {
        id: 'email-confirmation.invalid-token.title',
        defaultMessage: 'Unable to verify your email address'
    },
    invalidTokenDescription: {
        id: 'email-confirmation.invalid-token.description',
        defaultMessage: 'Something went wrong while trying to validate your email. The link you followed may have expired or be broken. Please log in to try again.'
    },
    invalidTokenReturnToLoginButton: {
        id: 'email-confirmation.invalid-token.return-login-button',
        defaultMessage: 'Return to log in'
    }
});

});


parcelRegister("8gw6F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5848b1251777aa9d$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $lwrli = parcelRequire("lwrli");

var $dWOVN = parcelRequire("dWOVN");

var $1JRGy = parcelRequire("1JRGy");

var $aewR3 = parcelRequire("aewR3");

var $Q6OOA = parcelRequire("Q6OOA");

var $5at20 = parcelRequire("5at20");

var $4NPio = parcelRequire("4NPio");

var $aMBBA = parcelRequire("aMBBA");

var $7qE2F = parcelRequire("7qE2F");
parcelRequire("jM5Ly");
var $04aYR = parcelRequire("04aYR");

var $hhYxc = parcelRequire("hhYxc");
const $5848b1251777aa9d$var$pageId = 'EmailConfirmationPage';
const $5848b1251777aa9d$export$b1860081753d8e7a = ()=>{
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const { email: email, newEmail: newEmail, error: error, isLoading: isLoading, redirectTo: redirectTo } = (0, $aMBBA.useAppSelector)((state)=>state.changeEmail);
    const handleEmailChangeConfirmationSubmitClick = (0, $4NPio.useButtonClickedEvent)($5848b1251777aa9d$var$pageId, 'EmailConfirmationSubmit');
    (0, $4NPio.usePageViewedEvent)($5848b1251777aa9d$var$pageId);
    // These values are provided by SIS in the email that's sent to verify the user's email address.
    // We need to pass them in the URL of the API call.
    const { token: token, userId: userId, source: source = '' } = $1JRGy.parse(window.location.search);
    const handleSubmit = (0, $dNMDr.useCallback)((newEmail, password)=>{
        // If the user gets here without the token - something went really wrong
        // This should have been caught by the initial page load
        if (!token) {
            dispatch((0, $5at20.changeEmailRequestFailedAction)('invalid_token'));
            return;
        }
        if (!userId) {
            dispatch((0, $5at20.changeEmailRequestFailedAction)('unknown_error'));
            return;
        }
        dispatch((0, $5at20.changeEmailConfirmation)(newEmail, password, token, userId, source));
    }, [
        dispatch,
        source,
        token,
        userId
    ]);
    const resetPasswordLink = '/login/resetpassword?' + new URLSearchParams([
        [
            'redirectedFrom',
            'change-email'
        ],
        [
            'email',
            email
        ],
        [
            'continue',
            window.location.href
        ]
    ]);
    const resetPasswordLinkEnabled = !(0, $hhYxc.isIsolatedCloud)();
    // `redirectTo` is set in the success case of the email change flow.
    (0, $04aYR.useForceRedirect)({
        redirectTo: redirectTo
    });
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $Q6OOA.default), {
        pageId: $5848b1251777aa9d$var$pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            as: 'h1',
            size: 'small',
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $7qE2F.default).title
            })
        }),
        whiteboxFooter: resetPasswordLinkEnabled ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.Link), {
            to: resetPasswordLink,
            id: "resetPassword",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "having.trouble.logging.in",
                defaultMessage: "Having trouble logging in?"
            })
        }) : null,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $aewR3.default), {
            email: newEmail,
            isLoading: isLoading,
            error: error,
            onSubmitButtonClick: handleEmailChangeConfirmationSubmitClick,
            onSubmit: handleSubmit
        })
    });
};
var $5848b1251777aa9d$export$2e2bcd8739ae039 = $5848b1251777aa9d$export$b1860081753d8e7a;

});
parcelRegister("aewR3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bebfa815eed2a0c5$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $fbSBq = parcelRequire("fbSBq");

var $kvy9X = parcelRequire("kvy9X");

var $gre8I = parcelRequire("gre8I");

var $6i4Wm = parcelRequire("6i4Wm");

var $ckdYh = parcelRequire("ckdYh");

var $hXPGK = parcelRequire("hXPGK");

var $kpuOE = parcelRequire("kpuOE");

var $7DUKO = parcelRequire("7DUKO");

var $e8kIe = parcelRequire("e8kIe");

var $7qE2F = parcelRequire("7qE2F");
const $bebfa815eed2a0c5$var$StyledForm = (0, $fbSBq.default).form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(0, $7DUKO.default)('space.100')}px;
`;
const $bebfa815eed2a0c5$var$ErrorContent = ({ error: error })=>{
    switch(error){
        case 'invalid_password':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "recovery.error.change-email.password.incorrect",
                defaultMessage: "The password you entered is incorrect. Please try again."
            });
        case 'invalid_token':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "recovery.error.change-email.invalid_token",
                defaultMessage: "Something went wrong. Please try again later."
            });
        case 'unknown_error':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "recovery.error.change-email.unknown_error",
                defaultMessage: "Something went wrong while attempting to change your email. Please try again."
            });
        default:
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "recovery.error.change-email.unknown",
                defaultMessage: "Something went wrong while attempting to change your email. Please try again."
            });
    }
};
const $bebfa815eed2a0c5$var$ChangeEmailForm = ({ email: email, isLoading: isLoading, error: error, onSubmit: onSubmit, onSubmitButtonClick: onSubmitButtonClick })=>{
    const intl = (0, $ko1o6.default)();
    const [password, setPassword] = (0, $dNMDr.useState)('');
    const [passwordFieldError, setPasswordFieldError] = (0, $dNMDr.useState)(null);
    const emailInputRef = (0, $dNMDr.useRef)(null);
    const passwordInputRef = (0, $dNMDr.useRef)(null);
    const handleSubmit = (e)=>{
        // Reset the error state to let the validation happen again.
        setPasswordFieldError(null);
        // Prevent submission/default behaviour. We return early in the cases of validation errors, but otherwise call the submit function
        e.preventDefault();
        if (isLoading) return;
        if (password.trim() === '') {
            setPasswordFieldError(intl.formatMessage((0, $hXPGK.default).passwordEmpty));
            return;
        }
        if (error === 'invalid_password') {
            setPasswordFieldError(intl.formatMessage((0, $7qE2F.default).incorrectPassword));
            return;
        }
        onSubmit(email, password);
    };
    const handlePasswordChange = (e)=>{
        setPasswordFieldError(null);
        setPassword(e.currentTarget.value);
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
        "data-testid": "email-verification-page-idf-testid",
        children: [
            error && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gre8I.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)($bebfa815eed2a0c5$var$ErrorContent, {
                    error: error
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)($bebfa815eed2a0c5$var$StyledForm, {
                onSubmit: handleSubmit,
                id: "form-change-email",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6i4Wm.default), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kvy9X.default), {
                            id: "email",
                            name: "email",
                            type: "email",
                            autoComplete: "off",
                            placeholder: intl.formatMessage((0, $hXPGK.default).emailEmpty),
                            label: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                ...(0, $7qE2F.default).emailLabel
                            }),
                            value: email,
                            ref: emailInputRef,
                            isDisabled: true,
                            isRequired: true
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6i4Wm.default), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ckdYh.default), {
                            name: "password",
                            autoComplete: "current-password",
                            id: "password",
                            testId: "password" // used in pollinators
                            ,
                            placeholder: intl.formatMessage((0, $hXPGK.default).passwordEmpty),
                            label: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                ...(0, $kpuOE.default).passwordLabel
                            }),
                            autoFocus: true,
                            isInvalid: !!passwordFieldError,
                            invalidMessage: passwordFieldError,
                            onChange: handlePasswordChange,
                            value: password,
                            ref: passwordInputRef,
                            isRequired: true
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $e8kIe.default), {
                        appearance: "primary",
                        type: "submit",
                        testId: "change-email-submit-button-idf-testid",
                        onClick: onSubmitButtonClick,
                        isLoading: isLoading,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "common.confirm",
                            defaultMessage: "Confirm"
                        })
                    })
                ]
            })
        ]
    });
};
var $bebfa815eed2a0c5$export$2e2bcd8739ae039 = $bebfa815eed2a0c5$var$ChangeEmailForm;

});
parcelRegister("hXPGK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1014f585d27f49d4$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $1014f585d27f49d4$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    unexpectedErrorHappened: {
        id: 'login.form.sso.check.unknown.error',
        defaultMessage: 'Unexpected error happened.',
        description: ''
    },
    emailPlaceholder: {
        id: 'login.form.email.placeholder',
        defaultMessage: 'Enter your email'
    },
    emailEmpty: {
        id: 'login.form.email.empty',
        defaultMessage: 'Enter an email address'
    },
    emailInvalid: {
        id: 'login.form.email.invalid',
        defaultMessage: "Email address must contain text before and after an '@' symbol"
    },
    passwordEmpty: {
        id: 'login.form.password.empty',
        defaultMessage: 'Enter your password'
    },
    migrateAccountInfo: {
        id: 'login.form.info.migrate.account',
        defaultMessage: "It looks like you already have an Atlassian account with other products such as Jira or Confluence. Log in to finish migrating your {application} account.",
        description: 'Login form info container message'
    },
    existingUserSignupAttemptInfo: {
        id: 'login.form.info.existing.user.signup.attempt',
        defaultMessage: "It looks like you've already got an account associated with this email. Log in instead or reset your password if you've forgotten it",
        description: 'Login form info container message for existing user signup attempt'
    },
    rateLimitErrorMessage: {
        id: 'login.form.email.rate-limit-exceeded.error',
        defaultMessage: 'There have been too many attempts to reverify your account in the past hour. Please try again later.',
        description: 'Telling the user that they have exceeded welcome email limit'
    },
    rememberMeCheckboxLabel: {
        id: 'login.form.remember.me.checkbox.label',
        defaultMessage: 'Remember me',
        description: "Label for the checkbox that will enable the behaviour to remember a user's account on this device"
    },
    rememberMeMoreInfoLabel: {
        id: 'login.form.remember.me.moreinfo.label',
        defaultMessage: 'More info about Remember Me.',
        description: 'Label for info icon that describes what Remember Me is'
    },
    rememberMeTooltip: {
        id: 'login.form.remember.me.tooltip',
        defaultMessage: 'We remember your account information for the next time you log in.',
        description: 'Tooltip content for the remember me checkbox'
    }
});

});

parcelRegister("kpuOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d31ac08f0bdcc5d7$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $d31ac08f0bdcc5d7$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    passwordPlaceholder: {
        id: 'login.form.password.placeholder',
        defaultMessage: 'Enter password'
    },
    passwordLabel: {
        id: 'login.form.password.label',
        defaultMessage: 'Password'
    }
});

});

parcelRegister("7qE2F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f3cb1b97771d67e$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $4f3cb1b97771d67e$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    title: {
        id: 'email-confirmation.title',
        defaultMessage: 'Enter your password to confirm your updated email'
    },
    emailLabel: {
        id: 'account.verification.form.emailField.label',
        defaultMessage: 'Updated email',
        description: 'The label shown above a disabled email field when the user is confirming that they have updated their email.'
    },
    incorrectPassword: {
        id: 'email-confirmation.form.incorrect-password',
        defaultMessage: 'Your password was incorrect'
    },
    unknownError: {
        id: 'email-confirmation.form.unknown_error',
        defaultMessage: 'An unknown error occurred, please try again later.'
    }
});

});


parcelRegister("5at20", function(module, exports) {

$parcel$export(module.exports, "changeEmailRequestFailedAction", function () { return $c958867e4ec62dd5$export$85474e738669d18a; });
$parcel$export(module.exports, "changeEmailConfirmation", function () { return $c958867e4ec62dd5$export$c78d0a07bbf517cd; });

var $cBB3b = parcelRequire("cBB3b");

var $hH6uU = parcelRequire("hH6uU");

var $84ZjZ = parcelRequire("84ZjZ");
const $c958867e4ec62dd5$export$593c8d2584e1aebe = ()=>({
        type: 'CHANGE_EMAIL_RESET_STATE'
    });
const $c958867e4ec62dd5$export$377eca5680d6a582 = ()=>({
        type: 'CHANGE_EMAIL_REQUEST'
    });
const $c958867e4ec62dd5$export$85474e738669d18a = (error)=>({
        type: 'CHANGE_EMAIL_REQUEST_FAILED',
        error: error
    });
const $c958867e4ec62dd5$export$17c00f40906a7c06 = (redirectTo)=>({
        type: 'CHANGE_EMAIL_REQUEST_SUCCEEDED',
        redirectTo: redirectTo
    });
const $c958867e4ec62dd5$export$98860bcb84091494 = (backendState)=>({
        type: 'CHANGE_EMAIL_STATE_UPDATE',
        backendState: backendState
    });
const $c958867e4ec62dd5$var$CHANGE_EMAIL_REST_ENDPOINT = '/rest/verify-email/change-email';
const $c958867e4ec62dd5$export$c78d0a07bbf517cd = (email, password, token, userId, source)=>async (dispatch, getState)=>{
        // Fork to use either the old submitFormHack or new submitFormHackReplacement function, well as the old or new endpoint
        // old endpoint: /verify-email/change-email (submitFormHack - form submission with input div manipulation)
        // new endpoint: /rest/verify-email/change-email (submitFormHackReplacement - REST POST request with JSON payload)
        if (!(0, $84ZjZ.checkFeatureGate)((0, $cBB3b.AidFrontendFeatureGate).ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL)) {
            (0, $hH6uU.default)({
                method: 'POST',
                payload: {
                    email: email,
                    password: password
                },
                skipSanitizationKeys: [
                    'password'
                ]
            });
            return;
        }
        try {
            const csrfToken = getState().csrfToken;
            const res = await (0, $hH6uU.submitFormHackReplacement)({
                method: 'POST',
                // These three parameters are included in the link from the verification email, therefore including to match existing functionality.
                action: `${$c958867e4ec62dd5$var$CHANGE_EMAIL_REST_ENDPOINT}?token=${token}&userId=${userId}&source=${source}`,
                payload: {
                    email: email,
                    password: password
                },
                csrfToken: csrfToken
            });
            // This indicates the backend is not behaving as expected
            // since even in error cases, we expect the backend endpoint to return a 200
            if (!res.ok) {
                dispatch($c958867e4ec62dd5$export$85474e738669d18a('unknown_error'));
                return;
            }
            const response = await res.json();
            // We have state from the backend, which we want to ensure is updated in the FE state.
            if (response.changeEmail) {
                // Want to make sure the response is a valid object.
                const isChangeEmailObject = typeof response.changeEmail === 'object' && !Array.isArray(response.changeEmail);
                dispatch($c958867e4ec62dd5$export$98860bcb84091494(isChangeEmailObject ? response.changeEmail : {}));
            }
            if (response?.changeEmail?.error) {
                const error = response.changeEmail.error;
                const validErrorTypes = [
                    'invalid_token',
                    'invalid_password',
                    'unknown_error'
                ];
                if (!validErrorTypes.includes(error)) {
                    dispatch($c958867e4ec62dd5$export$85474e738669d18a('unknown_error'));
                    return;
                }
                dispatch($c958867e4ec62dd5$export$85474e738669d18a(error));
                return;
            }
            // The types on the FE define the response to always be under `changeEmail` for this endpoint
            // but in practice the BE returns in some cases (i.e. success) in a different format
            // so we want to handle that
            const redirectTo = response?.changeEmail?.redirectTo || response?.redirectTo;
            if (!redirectTo) {
                // If we don't get a redirect URL from the BE _and_ we haven't been able to understand the error
                // we don't know where to send the user and there aren't enough details of the error (or they aren't in the expected format) so we are assuming the request failed.
                dispatch($c958867e4ec62dd5$export$85474e738669d18a('unknown_error'));
                return;
            }
            dispatch($c958867e4ec62dd5$export$17c00f40906a7c06(redirectTo));
            return;
        } catch (error) {
            dispatch($c958867e4ec62dd5$export$85474e738669d18a('unknown_error'));
        }
    };

});


parcelRegister("6Fpr0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0edbc80cf96782a2$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $lwrli = parcelRequire("lwrli");

var $dWOVN = parcelRequire("dWOVN");

var $1JRGy = parcelRequire("1JRGy");

var $7k3dJ = parcelRequire("7k3dJ");

var $Q6OOA = parcelRequire("Q6OOA");

var $5at20 = parcelRequire("5at20");

var $4NPio = parcelRequire("4NPio");

var $fI5yH = parcelRequire("fI5yH");

var $aMBBA = parcelRequire("aMBBA");
const $0edbc80cf96782a2$var$pageId = 'EmailConfirmationPage';
const $0edbc80cf96782a2$export$b1860081753d8e7a = ()=>{
    const intl = (0, $ko1o6.default)();
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const { email: email, newEmail: newEmail, error: error } = (0, $aMBBA.useAppSelector)((state)=>state.changeEmail);
    const [fieldErrors, setFieldErrors] = (0, $dNMDr.useState)(error === 'invalid_password' ? {
        password: intl.formatMessage((0, $fI5yH.default).incorrectPassword)
    } : {});
    const [isLoading, setIsLoading] = (0, $dNMDr.useState)(false);
    const handleLoginClick = (0, $4NPio.useButtonClickedEvent)($0edbc80cf96782a2$var$pageId, 'EmailConfirmationSubmit');
    (0, $4NPio.usePageViewedEvent)($0edbc80cf96782a2$var$pageId);
    // In the URL from the verification email, but used by SIS to validate that they have access to the email address.
    // These three are included in the URL
    const { token: token = '', userId: userId = '', source: source = '' } = $1JRGy.parse(window.location.search);
    const handleChangePassword = (newEmail, password)=>{
        setIsLoading(true);
        dispatch((0, $5at20.changeEmailConfirmation)(newEmail, password, token, userId, source));
    };
    const resetPasswordLink = '/login/resetpassword?' + new URLSearchParams([
        [
            'redirectedFrom',
            'change-email'
        ],
        [
            'email',
            email
        ],
        [
            'continue',
            window.location.href
        ]
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $Q6OOA.default), {
        pageId: $0edbc80cf96782a2$var$pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            as: 'h1',
            size: 'small',
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $fI5yH.default).title
            })
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.Link), {
            to: resetPasswordLink,
            id: "resetPassword",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "having.trouble.logging.in",
                defaultMessage: "Having trouble logging in?"
            })
        }),
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7k3dJ.default), {
            email: newEmail,
            emailFieldLabel: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $fI5yH.default).emailLabel
            }),
            isLoading: isLoading,
            fieldErrors: fieldErrors,
            onValidationError: setFieldErrors,
            submitButtonText: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "common.confirm",
                defaultMessage: "Confirm"
            }),
            onSubmitClick: handleLoginClick,
            onSubmit: handleChangePassword
        })
    });
};
var $0edbc80cf96782a2$export$2e2bcd8739ae039 = $0edbc80cf96782a2$export$b1860081753d8e7a;

});
parcelRegister("7k3dJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28c17445773be488$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $kvy9X = parcelRequire("kvy9X");

var $gre8I = parcelRequire("gre8I");

var $6i4Wm = parcelRequire("6i4Wm");

var $ckdYh = parcelRequire("ckdYh");

var $2byD0 = parcelRequire("2byD0");

var $hXPGK = parcelRequire("hXPGK");

var $kpuOE = parcelRequire("kpuOE");

var $4yl6n = parcelRequire("4yl6n");
const $28c17445773be488$var$Form = (0, $fbSBq.default).form`
  margin: 0;
`;
const $28c17445773be488$var$ButtonContainer = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $28c17445773be488$var$ErrorContent = ({ error: error })=>{
    switch(error){
        case 'tsvForm.password.valid':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "recovery.error.password.incorrect",
                defaultMessage: "The password you entered is incorrect. Please try again."
            });
        case 'tsvForm.password.error':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "recovery.error.unexpected",
                defaultMessage: "Something went wrong while trying to contact the server. Please refresh the page and try again."
            });
        default:
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "recovery.error.unknown",
                defaultMessage: "Something went wrong while attempting to login. Please try again."
            });
    }
};
const $28c17445773be488$var$AccountVerificationForm = (props)=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const passwordFieldError = (0, $4yl6n.useTranslateFormErrorIfAvailable)(props.fieldErrors.password);
    const email = props.email || '';
    const previousPasswordFieldError = (0, $dNMDr.useRef)(undefined);
    const [password, setPassword] = (0, $dNMDr.useState)('');
    const emailInputRef = (0, $dNMDr.useRef)(null);
    const passwordInputRef = (0, $dNMDr.useRef)(null);
    const handleSubmit = (e)=>{
        const { isLoading: isLoading, onValidationError: onValidationError } = props;
        const validationErrors = {};
        e.preventDefault();
        if (isLoading) return;
        if (password.trim() === '') validationErrors.password = formatMessage((0, $hXPGK.default).passwordEmpty);
        if (Object.keys(validationErrors).length) {
            onValidationError(validationErrors);
            return;
        }
        props.onSubmit && props.onSubmit(email, password);
    };
    const handlePasswordChange = (e)=>{
        props.onValidationError({}); // clear validation errors
        setPassword(e.currentTarget.value);
    };
    (0, $dNMDr.useEffect)(()=>{
        const passwordError = passwordFieldError && passwordFieldError !== previousPasswordFieldError.current;
        if (passwordError) passwordInputRef.current?.focus();
        previousPasswordFieldError.current = passwordFieldError;
    }, [
        props.fieldErrors.password,
        passwordFieldError
    ]);
    const { error: error, title: title, emailFieldLabel: emailFieldLabel } = props;
    return /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
        "data-testid": "email-verification-page-old-idf-testid",
        children: [
            error && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gre8I.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)($28c17445773be488$var$ErrorContent, {
                    error: error
                })
            }),
            title && /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                children: title
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)($28c17445773be488$var$Form, {
                onSubmit: handleSubmit,
                id: "form-accountverification-up",
                onClick: props.onFormClick,
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6i4Wm.default), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kvy9X.default), {
                            id: "email",
                            name: "email",
                            type: "email",
                            autoComplete: "off",
                            placeholder: formatMessage((0, $hXPGK.default).emailEmpty),
                            label: emailFieldLabel,
                            value: email,
                            ref: emailInputRef,
                            isDisabled: true,
                            isRequired: true
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6i4Wm.default), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ckdYh.default), {
                            name: "password",
                            autoComplete: "new-password",
                            id: "password",
                            testId: "password" // used in pollinators
                            ,
                            placeholder: formatMessage((0, $hXPGK.default).passwordEmpty),
                            label: formatMessage((0, $kpuOE.default).passwordLabel),
                            autoFocus: true,
                            isInvalid: !!props.fieldErrors.password,
                            invalidMessage: props.fieldErrors.password,
                            onChange: handlePasswordChange,
                            value: password,
                            ref: passwordInputRef,
                            isRequired: true
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)($28c17445773be488$var$ButtonContainer, {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                            appearance: "primary",
                            type: "submit",
                            isFullWidth: true,
                            id: "tsvrecovery-submit" // used in pollinators
                            ,
                            onClick: ()=>props.onSubmitClick && props.onSubmitClick(),
                            isLoading: props.isLoading,
                            children: props.submitButtonText
                        })
                    })
                ]
            })
        ]
    });
};
var $28c17445773be488$export$2e2bcd8739ae039 = $28c17445773be488$var$AccountVerificationForm;

});

parcelRegister("fI5yH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $074de6449fef9fb0$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $074de6449fef9fb0$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    title: {
        id: 'email-confirmation.title',
        defaultMessage: 'Enter your password to confirm your updated email'
    },
    emailLabel: {
        id: 'account.verification.form.emailField.label',
        defaultMessage: 'Updated email',
        description: 'The label shown above a disabled email field when the user is confirming that they have updated their email.'
    },
    incorrectPassword: {
        id: 'email-confirmation.form.incorrect-password',
        defaultMessage: 'Your password was incorrect'
    },
    invalidTokenTitle: {
        id: 'email-confirmation.invalid-token.title',
        defaultMessage: 'Unable to verify your email address'
    },
    invalidTokenDescription: {
        id: 'email-confirmation.invalid-token.description',
        defaultMessage: 'Something went wrong while trying to validate your email. The link you followed may have expired or be broken. Please log in to try again.'
    },
    invalidTokenReturnToLoginButton: {
        id: 'email-confirmation.invalid-token.return-login-button',
        defaultMessage: 'Return to log in'
    }
});

});



parcelRegister("gbv4C", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "removeAccountLoader", function () { return $b29d2b894cfac453$export$d62f2a9a504f29d1; });
$parcel$export(module.exports, "RemoveAccountPage", function () { return $b29d2b894cfac453$export$66bcaaca6b1eddac; });
$parcel$export(module.exports, "Paragraph", function () { return $b29d2b894cfac453$export$358a232cca1ab2ac; });
$parcel$export(module.exports, "default", function () { return $b29d2b894cfac453$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $cTzf6 = parcelRequire("cTzf6");

var $fbSBq = parcelRequire("fbSBq");

var $chJxj = parcelRequire("chJxj");

var $lpuXD = parcelRequire("lpuXD");

var $bi5Lm = parcelRequire("bi5Lm");

var $4NPio = parcelRequire("4NPio");

var $g9d4P = parcelRequire("g9d4P");

var $9snhd = parcelRequire("9snhd");
var $lupi5 = parcelRequire("lupi5");
var $dPurX = parcelRequire("dPurX");
var $ihPx0 = parcelRequire("ihPx0");
var $8Du6M = parcelRequire("8Du6M");

var $7ci1C = parcelRequire("7ci1C");

var $3hgMJ = parcelRequire("3hgMJ");

var $2iv3W = parcelRequire("2iv3W");

var $isI3S = parcelRequire("isI3S");

var $eTWY7 = parcelRequire("eTWY7");

var $Q6OOA = parcelRequire("Q6OOA");

var $cuZAx = parcelRequire("cuZAx");

var $lCnOB = parcelRequire("lCnOB");

var $aMBBA = parcelRequire("aMBBA");

var $h4v4M = parcelRequire("h4v4M");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");

var $dWOVN = parcelRequire("dWOVN");

var $l4KzN = parcelRequire("l4KzN");
const $b29d2b894cfac453$var$pageId = 'forgetAccountFromBrowserScreen';
async function $b29d2b894cfac453$export$d62f2a9a504f29d1({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/login/remove-account/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--remove-account'
        ]
    });
}
const $b29d2b894cfac453$export$66bcaaca6b1eddac = ()=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const loginHint = (0, $lCnOB.useLoginHint)();
    const { search: search } = (0, $cVnBY.useLocation)();
    const navigateToLoginPrompt = (0, $bi5Lm.useNavigateToLoginPrompt)();
    const [modalDialog, setModalDialog] = (0, $dNMDr.useState)(null);
    const sessions = (0, $aMBBA.useAppSelector)((state)=>(0, $3hgMJ.sessionsSelector)(state, search, loginHint));
    const oidcContext = (0, $aMBBA.useAppSelector)((state)=>state.microbranding.oidcContext);
    const isLoading = (0, $aMBBA.useAppSelector)((state)=>state.selectAccount.isLoading);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const eventAttributes = (0, $dNMDr.useMemo)(()=>({
            accountCount: sessions.length
        }), [
        sessions.length
    ]);
    (0, $4NPio.usePageViewedEvent)($b29d2b894cfac453$var$pageId, eventAttributes);
    const renderFooter = ()=>{
        if ((0, $cuZAx.isOidcDisplayMode)(oidcContext, (0, $chJxj.OidcDisplay).ManageSessions)) return null;
        return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
            id: "navigate-to-select-account",
            onClick: ()=>{
                analyticsClient.buttonClickedEvent($b29d2b894cfac453$var$pageId, 'dismissAccountSwitcher', eventAttributes);
                navigate({
                    pathname: '/login/select-account',
                    search: search
                });
            },
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "remove.account.footer.navigate.to.select.account",
                defaultMessage: "Done"
            })
        });
    };
    const handleSessionClick = (0, $dNMDr.useCallback)((session, eventAttributes)=>{
        return ()=>{
            const handleDissociate = ()=>{
                analyticsClient.buttonClickedEvent($b29d2b894cfac453$var$pageId, 'confirmForgetAccount', eventAttributes);
                dispatch((0, $lpuXD.manageSession)({
                    sessionId: session.sessionId,
                    command: 'dissociate'
                }, navigate, {
                    continue: window.location.href
                }));
            };
            const handleCloseModalDialog = ()=>{
                analyticsClient.buttonClickedEvent($b29d2b894cfac453$var$pageId, 'cancelForgetAccount', eventAttributes);
                setModalDialog(null);
            };
            const modalDialogElement = /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $9snhd.default), {
                width: "small",
                onClose: handleCloseModalDialog,
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ihPx0.default), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8Du6M.default), {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                id: "remove.account.dialog.header",
                                defaultMessage: "Remove account"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lupi5.default), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "remove.account.dialog.body",
                            defaultMessage: "You can always add the account for <strong>{email}</strong> back to this browser when you're ready to use it again.",
                            values: {
                                strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                                        children: chunks
                                    }),
                                email: session.email
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $dPurX.default), {
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cTzf6.default), {
                                appearance: "subtle",
                                onClick: handleCloseModalDialog,
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    ...(0, $g9d4P.default).removeAccountDialogClose
                                })
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cTzf6.default), {
                                appearance: "primary",
                                onClick: handleDissociate,
                                autoFocus: true,
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    ...(0, $g9d4P.default).removeAccountDialogConfirm
                                })
                            })
                        ]
                    })
                ]
            });
            analyticsClient.buttonClickedEvent($b29d2b894cfac453$var$pageId, 'forgetAccountFromBrowser', eventAttributes);
            setModalDialog(modalDialogElement);
        };
    }, [
        analyticsClient,
        dispatch,
        navigate
    ]);
    const handleLogoutClick = (0, $dNMDr.useCallback)(()=>{
        const handleCloseModalDialog = ()=>{
            analyticsClient.buttonClickedEvent($b29d2b894cfac453$var$pageId, 'cancelForgetAllAccounts', eventAttributes);
            setModalDialog(null);
        };
        const modalDialogElement = /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $9snhd.default), {
            width: "small",
            onClose: handleCloseModalDialog,
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ihPx0.default), {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8Du6M.default), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "remove.account.logout.dialog.header",
                            defaultMessage: "Remove all accounts"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lupi5.default), {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "remove.account.logout.dialog.body",
                        defaultMessage: "You can always add the accounts back to this browser when you're ready to use any of them again."
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $dPurX.default), {
                    children: [
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cTzf6.default), {
                            appearance: "subtle",
                            onClick: handleCloseModalDialog,
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                ...(0, $g9d4P.default).removeAccountDialogClose
                            })
                        }),
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cTzf6.default), {
                            appearance: "primary",
                            onClick: async ()=>{
                                await analyticsClient.buttonClickedEvent($b29d2b894cfac453$var$pageId, 'confirmForgetAllAccounts', eventAttributes);
                                const continueUrl = (0, $cuZAx.isOidcDisplayMode)(oidcContext, (0, $chJxj.OidcDisplay).ManageSessions) ? window.location.href : undefined;
                                await dispatch((0, $lpuXD.doLogout)(continueUrl));
                            },
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                ...(0, $g9d4P.default).removeAccountDialogConfirm
                            })
                        })
                    ]
                })
            ]
        });
        analyticsClient.buttonClickedEvent($b29d2b894cfac453$var$pageId, 'forgetAllAccounts', eventAttributes);
        setModalDialog(modalDialogElement);
    }, [
        analyticsClient,
        dispatch,
        eventAttributes,
        oidcContext
    ]);
    const renderAccounts = ()=>{
        const accounts = sessions.map((session, index)=>{
            const { accountId: accountId, displayName: displayName, email: email } = session;
            const handleOnClick = handleSessionClick(session, {
                ...eventAttributes,
                accountIndex: index
            });
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.default), {
                id: `account-${accountId}`,
                onClick: handleOnClick,
                avatarUrl: session.avatarUrl,
                displayName: displayName,
                email: email,
                icon: /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isI3S))), {
                    label: formatMessage((0, $g9d4P.default).removeAccountIconLabel),
                    size: "small"
                })
            }, `account-${accountId}`);
        });
        accounts.push(/*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.AccountContainer), {
            id: "redirect-to-logout",
            onClick: handleLogoutClick,
            children: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $7ci1C.RowButtonContainer), {
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.AvatarContainer), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isI3S))), {
                            label: formatMessage((0, $g9d4P.default).removeAccountIconLabel)
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.TextContainer), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)($b29d2b894cfac453$export$358a232cca1ab2ac, {
                            id: "remove-all",
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                id: "remove.account.all",
                                defaultMessage: "Remove all accounts"
                            })
                        })
                    })
                ]
            })
        }, "redirect-to-logout"));
        return accounts;
    };
    if (sessions.length > 0) return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: $b29d2b894cfac453$var$pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "remove.account.title",
                defaultMessage: "Remove accounts from this browser"
            })
        }),
        footer: true,
        whiteboxFooter: renderFooter(),
        isLoading: isLoading,
        children: [
            modalDialog,
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2iv3W.default), {
                children: renderAccounts()
            })
        ]
    });
    else if ((0, $cuZAx.isOidcDisplayMode)(oidcContext, (0, $chJxj.OidcDisplay).ManageSessions)) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $Q6OOA.default), {
        pageId: $b29d2b894cfac453$var$pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "manage.sessions.no.sessions.header",
                defaultMessage: "You're logged out of all accounts on this browser"
            })
        }),
        children: /*#__PURE__*/ (0, $6CtE1.jsx)($b29d2b894cfac453$var$CenterText, {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                tagName: "p",
                id: "manage.sessions.no.sessions.body",
                defaultMessage: "Close this page to return to the app."
            })
        })
    });
    else {
        navigateToLoginPrompt();
        return null;
    }
};
const $b29d2b894cfac453$var$CenterText = (0, $fbSBq.default).div`
  text-align: center;
`;
const $b29d2b894cfac453$export$358a232cca1ab2ac = (0, $fbSBq.default).p`
  font-size: 14px;
  line-height: 20px;
  color: ${(0, $l4KzN).N700};
  margin-top: 0px;
  overflow-wrap: break-word;
`;
var $b29d2b894cfac453$export$2e2bcd8739ae039 = $b29d2b894cfac453$export$66bcaaca6b1eddac;

});
parcelRegister("g9d4P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e58a7fbe24fb4e5$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $8e58a7fbe24fb4e5$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    removeAccountIconLabel: {
        id: 'remove.account.icon.label',
        defaultMessage: 'Remove account',
        description: ''
    },
    removeAccountDialogConfirm: {
        id: 'remove.account.dialog.confirm',
        defaultMessage: 'Remove',
        description: ''
    },
    removeAccountDialogClose: {
        id: 'remove.account.dialog.close',
        defaultMessage: 'Cancel',
        description: ''
    }
});

});

parcelRegister("3hgMJ", function(module, exports) {

$parcel$export(module.exports, "sessionsSelector", function () { return $16af778597c29b0a$export$28c41c0d40d1bdce; });
$parcel$export(module.exports, "default", function () { return $16af778597c29b0a$export$2e2bcd8739ae039; });
parcelRequire("65XXq");
var $aMRBJ = parcelRequire("aMRBJ");

var $1JRGy = parcelRequire("1JRGy");

var $lCnOB = parcelRequire("lCnOB");
const $16af778597c29b0a$export$28c41c0d40d1bdce = (0, $aMRBJ.createSelector)([
    (state)=>state.selectAccount.sessions,
    (_state, search)=>search,
    (_state, _search, loginHint)=>loginHint
], (sessions, search, loginHint)=>{
    if (!sessions) return [];
    const { suggested: suggested } = $1JRGy.parse(search);
    const combined = sessions.associated.map((session)=>{
        return {
            ...session,
            current: false,
            suggested: false
        };
    });
    combined.unshift({
        ...sessions.current,
        current: true,
        suggested: false
    });
    return combined.reduce((sorted, session)=>{
        if (loginHint && loginHint.value === session.email) switch(loginHint.type){
            case (0, $lCnOB.LoginHintType).EmailAddress:
            case (0, $lCnOB.LoginHintType).NotEmailAddress:
                sorted.unshift({
                    ...session,
                    hint: loginHint.type
                });
                break;
            default:
                sorted.push(session);
        }
        else sorted.push({
            ...session,
            suggested: session.email === suggested
        });
        return sorted;
    }, []);
});
var $16af778597c29b0a$export$2e2bcd8739ae039 = $16af778597c29b0a$export$28c41c0d40d1bdce;

});

parcelRegister("2iv3W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9f7b2741675251d$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $l4KzN = parcelRequire("l4KzN");
const $c9f7b2741675251d$var$Accounts = (0, $fbSBq.default).div`
  > * + * {
    border-top: 1px solid ${(0, $l4KzN).N30A} !important;
  }
`;
var $c9f7b2741675251d$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $6CtE1.jsx)($c9f7b2741675251d$var$Accounts, {
        className: "accounts-list",
        children: props.children
    });

});

parcelRegister("isI3S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d70d053a08ab9181$var$_react = $d70d053a08ab9181$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $gsWOv = parcelRequire("gsWOv");

var $d70d053a08ab9181$var$_logOut = $d70d053a08ab9181$var$_interopRequireDefault((parcelRequire("1Olux")));
function $d70d053a08ab9181$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d70d053a08ab9181$var$SignOutIcon = (props)=>/*#__PURE__*/ $d70d053a08ab9181$var$_react.default.createElement($gsWOv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.977 11A.99.99 0 0 0 4 12c0 .551.437 1 .977 1h11.046A.99.99 0 0 0 17 12a.99.99 0 0 0-.977-1z"/><path d="M6.23 8.31 3.3 11.27a1.05 1.05 0 0 0 0 1.48l2.93 2.96a1.03 1.03 0 0 0 1.47 0 1.05 1.05 0 0 0 0-1.48L5.5 12l2.2-2.22a1.05 1.05 0 0 0 0-1.48 1.03 1.03 0 0 0-1.47 0M15.5 3H12v2h7v14h-7v2h7.01c1.1 0 1.99-.89 1.99-1.99V5a1.99 1.99 0 0 0-1.99-2z"/></g></svg>`
    }, props, {
        newIcon: $d70d053a08ab9181$var$_logOut.default
    }));
$d70d053a08ab9181$var$SignOutIcon.displayName = 'SignOutIcon';
var $d70d053a08ab9181$var$_default = module.exports.default = $d70d053a08ab9181$var$SignOutIcon;

});
parcelRegister("1Olux", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b0ad8e82692fcbf05d6af098ca724db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $151b21beddc4bce2$var$_react = $151b21beddc4bce2$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $151b21beddc4bce2$var$_baseNew = $151b21beddc4bce2$var$_interopRequireDefault((parcelRequire("9LaLF")));
function $151b21beddc4bce2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $151b21beddc4bce2$var$LogOutIcon = (props)=>/*#__PURE__*/ $151b21beddc4bce2$var$_react.default.createElement($151b21beddc4bce2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$151b21beddc4bce2$var$LogOutIcon.displayName = 'LogOutIcon';
var $151b21beddc4bce2$var$_default = module.exports.default = $151b21beddc4bce2$var$LogOutIcon;

});



parcelRegister("cTHs9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "selectAccountLoader", function () { return $b2351f55bf358162$export$f44e7fa0a0dba44f; });
$parcel$export(module.exports, "SelectAccountPage", function () { return $b2351f55bf358162$export$134466789cb44107; });
$parcel$export(module.exports, "default", function () { return $b2351f55bf358162$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $lpuXD = parcelRequire("lpuXD");

var $bi5Lm = parcelRequire("bi5Lm");

var $4NPio = parcelRequire("4NPio");

var $1JRGy = parcelRequire("1JRGy");

var $lCnOB = parcelRequire("lCnOB");

var $40q5T = parcelRequire("40q5T");

var $aIFdP = parcelRequire("aIFdP");

var $7ci1C = parcelRequire("7ci1C");

var $3hgMJ = parcelRequire("3hgMJ");

var $iBXUB = parcelRequire("iBXUB");

var $eTWY7 = parcelRequire("eTWY7");

var $2iv3W = parcelRequire("2iv3W");

var $jwSzA = parcelRequire("jwSzA");

var $Q6OOA = parcelRequire("Q6OOA");

var $2byD0 = parcelRequire("2byD0");

var $79HVl = parcelRequire("79HVl");

var $cuZAx = parcelRequire("cuZAx");

var $5pCRv = parcelRequire("5pCRv");

var $kJPFV = parcelRequire("kJPFV");

var $fbSBq = parcelRequire("fbSBq");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $cVnBY = parcelRequire("cVnBY");

var $aMBBA = parcelRequire("aMBBA");

var $h4v4M = parcelRequire("h4v4M");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");

var $dWOVN = parcelRequire("dWOVN");
const $b2351f55bf358162$var$MAXIMUM_ASSOCIATED_SESSIONS = 9;
const $b2351f55bf358162$var$ButtonWrapper = (0, $fbSBq.default).div`
  padding-bottom: 0;
`;
const $b2351f55bf358162$var$SectionMessageWrapper = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)() * 2}px;
`;
const $b2351f55bf358162$var$UnauthorizedWrapper = (0, $fbSBq.default).div`
  padding-top: ${(0, $68HQw.gridSize)() * 2}px;
`;
const $b2351f55bf358162$var$UnauthorizedHeader = (0, $fbSBq.default).div`
  padding-bottom: ${(0, $68HQw.gridSize)() * 2}px;
`;
const $b2351f55bf358162$var$AccountsList = (0, $fbSBq.default).ul`
  margin-top: 0px;
  padding: 0px;
  list-style-type: none;
`;
const $b2351f55bf358162$var$AccountsListItem = (0, $fbSBq.default).li`
  margin-top: 0px;
`;
const $b2351f55bf358162$var$pageId = 'selectAccountScreen';
const $b2351f55bf358162$var$generateDestUrl = (parsedUrl)=>{
    let destUrl = '';
    if (parsedUrl.pathname) destUrl += parsedUrl.pathname;
    if (parsedUrl.search) destUrl += parsedUrl.search;
    return destUrl;
};
async function $b2351f55bf358162$export$f44e7fa0a0dba44f({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/login/select-account/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--select-account'
        ]
    });
}
const $b2351f55bf358162$export$134466789cb44107 = ()=>{
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const { search: search } = (0, $cVnBY.useLocation)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const loginHint = (0, $lCnOB.useLoginHint)();
    const sessions = (0, $aMBBA.useAppSelector)((state)=>(0, $3hgMJ.default)(state, search, loginHint));
    const applicationDestination = (0, $aMBBA.useAppSelector)((state)=>(0, $iBXUB.applicationDestinationSelector)(state, search));
    const hideLogout = (0, $aMBBA.useAppSelector)((state)=>(0, $cuZAx.isMobileOidc)(state.microbranding.oidcContext) || state.microbranding.isEmbedded);
    const isLoading = (0, $aMBBA.useAppSelector)((state)=>state.selectAccount.isLoading);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const shouldShowRequestAccessLink = (0, $dNMDr.useCallback)(()=>{
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(search);
        let parsedUrl = '';
        try {
            parsedUrl = $b2351f55bf358162$var$generateDestUrl(new URL(decodeURIComponent(params.continue || '')));
        } catch (error) {
        // Do nothing
        }
        return params.showRequestAccessLink === 'true' && applicationDestination !== null && parsedUrl !== '';
    }, [
        applicationDestination,
        search
    ]);
    const eventAttributes = (0, $dNMDr.useMemo)(()=>({
            accountCount: sessions.length,
            loginHintType: loginHint ? loginHint.type : undefined,
            hideLogout: hideLogout,
            requestAccessLinkShown: shouldShowRequestAccessLink(),
            suggestedAccountShown: sessions.some((session)=>session.suggested)
        }), [
        hideLogout,
        loginHint,
        sessions,
        shouldShowRequestAccessLink
    ]);
    (0, $4NPio.usePageViewedEvent)($b2351f55bf358162$var$pageId, {
        ...eventAttributes,
        noAccess: !!loginHint && loginHint.type === (0, $lCnOB.LoginHintType).NotEmailAddress,
        accounts: sessions.map((session)=>session.accountId)
    });
    const renderHeader = ()=>{
        const suggestedAccount = getSuggestedAccount();
        if (sessions.length === 1 && sessions[0].hint === (0, $lCnOB.LoginHintType).NotEmailAddress) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "try.another.account.title",
                defaultMessage: "Try a different account"
            })
        });
        else if (suggestedAccount) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "select.account.switch.title",
                defaultMessage: "Switch account"
            })
        });
        else return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "select.account.title",
                defaultMessage: "Choose or add another account"
            })
        });
    };
    const handleClickRequestAccessLink = (0, $4NPio.useLinkClickedEvent)($b2351f55bf358162$var$pageId, 'requestAccessLink');
    const renderMainContentFooter = ()=>{
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(search);
        let destUrl = '';
        try {
            destUrl = $b2351f55bf358162$var$generateDestUrl(new URL(decodeURIComponent(params.continue || '')));
        } catch (error) {
        //
        }
        const requestAccessLink = shouldShowRequestAccessLink() && applicationDestination && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.RequestAccessLink), {
            onClick: handleClickRequestAccessLink,
            destUrl: destUrl,
            applicationDestination: applicationDestination
        });
        if (hideLogout) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6CtE1.Fragment), {});
        if (requestAccessLink) return requestAccessLink;
        else {
            if (sessions.length <= 1) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                id: "redirect-to-logout",
                onClick: async ()=>{
                    await analyticsClient.buttonClickedEvent($b2351f55bf358162$var$pageId, 'forgetAllAccounts', eventAttributes);
                    await dispatch((0, $lpuXD.doLogout)());
                },
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "select.account.footer.redirect.to.logout",
                    defaultMessage: "Log out"
                })
            });
        }
    };
    const handleSessionClick = (0, $dNMDr.useCallback)((session, eventAttributes)=>{
        return ()=>{
            if (session.current) (async ()=>{
                await analyticsClient.buttonClickedEvent($b2351f55bf358162$var$pageId, 'continueWithCurrentAccount', eventAttributes);
                await dispatch((0, $lpuXD.continueWithCurrentSession)(navigate));
            })();
            else {
                analyticsClient.buttonClickedEvent($b2351f55bf358162$var$pageId, 'switchToAccount', eventAttributes);
                const request = {
                    sessionId: session.sessionId,
                    command: 'switch'
                };
                dispatch((0, $lpuXD.manageSession)(request, navigate));
            }
        };
    }, [
        analyticsClient,
        dispatch,
        navigate
    ]);
    const navigateToLogin = (0, $bi5Lm.useNavigateToLoginPrompt)();
    const navigateToLoginPrompt = (0, $dNMDr.useCallback)(()=>{
        analyticsClient.buttonClickedEvent($b2351f55bf358162$var$pageId, 'addAccount', eventAttributes);
        navigateToLogin();
    }, [
        analyticsClient,
        navigateToLogin,
        eventAttributes
    ]);
    const navigateToRemoveAccountPrompt = (0, $dNMDr.useCallback)(()=>{
        analyticsClient.buttonClickedEvent($b2351f55bf358162$var$pageId, 'removeAccountFromList', eventAttributes);
        navigate({
            pathname: '/login/remove-account',
            search: search
        });
    }, [
        analyticsClient,
        eventAttributes,
        navigate,
        search
    ]);
    const LoginHintNotEmailAddress = ({ index: index, suggestedAccount: suggestedAccount, session: session })=>{
        return suggestedAccount ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.default), {
            id: `account-${suggestedAccount.accountId}`,
            primary: true,
            avatarUrl: suggestedAccount.avatarUrl,
            displayName: suggestedAccount.displayName,
            email: suggestedAccount.email,
            isolatedCloudLabel: suggestedAccount.icLabel,
            header: /*#__PURE__*/ (0, $6CtE1.jsx)($b2351f55bf358162$var$UnauthorizedHeader, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $jwSzA.default), {
                    applicationDestination: applicationDestination,
                    emailAddress: session.email,
                    suggested: true
                })
            }),
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                    appearance: "primary",
                    onClick: handleSessionClick(suggestedAccount, {
                        ...eventAttributes,
                        accountIndex: index
                    }) || undefined,
                    isFullWidth: true,
                    id: "continue",
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "select.account.continue",
                        defaultMessage: "Continue"
                    })
                })
            })
        }, `session-${suggestedAccount.sessionId}`) : /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.default), {
                    id: `account-${session.accountId}`,
                    primary: true,
                    avatarUrl: session.avatarUrl,
                    displayName: session.displayName,
                    isolatedCloudLabel: session.icLabel,
                    email: session.email,
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)($b2351f55bf358162$var$UnauthorizedWrapper, {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $jwSzA.default), {
                            applicationDestination: applicationDestination,
                            emailAddress: session.email,
                            suggested: false
                        })
                    })
                }, `session-${session.sessionId}`),
                sessions.length === 1 && /*#__PURE__*/ (0, $6CtE1.jsx)($b2351f55bf358162$var$ButtonWrapper, {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                        id: "navigate-to-login-prompt",
                        appearance: "primary",
                        isFullWidth: true,
                        onClick: navigateToLoginPrompt,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "select.account.add",
                            defaultMessage: "Log in to another account"
                        })
                    })
                })
            ]
        });
    };
    const LoginHint = ({ session: session, index: index, suggestedAccount: suggestedAccount, handleOnClick: handleOnClick })=>{
        if (!session.hint) return null;
        switch(session.hint){
            case (0, $lCnOB.LoginHintType).EmailAddress:
                if (handleOnClick) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.default), {
                    id: `account-${session.accountId}`,
                    primary: true,
                    avatarUrl: session.avatarUrl,
                    displayName: session.displayName,
                    isolatedCloudLabel: session.icLabel,
                    email: session.email,
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                            appearance: "primary",
                            onClick: handleOnClick,
                            isFullWidth: true,
                            id: "continue",
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                id: "select.account.continue",
                                defaultMessage: "Continue"
                            })
                        })
                    })
                }, `session-${session.sessionId}`);
                break;
            case (0, $lCnOB.LoginHintType).NotEmailAddress:
                return /*#__PURE__*/ (0, $6CtE1.jsx)(LoginHintNotEmailAddress, {
                    index: index,
                    suggestedAccount: suggestedAccount,
                    session: session
                });
            default:
                return null;
        }
        return null;
    };
    const renderAccounts = ()=>{
        const suggestedAccount = getSuggestedAccount();
        const accountsList = sessions.map((session, index)=>{
            const { accountId: accountId, displayName: displayName, email: email, icLabel: icLabel } = session;
            const handleOnClick = handleSessionClick(session, {
                ...eventAttributes,
                accountIndex: index
            });
            return session.hint ? /*#__PURE__*/ (0, $6CtE1.jsx)(LoginHint, {
                session: session,
                index: index,
                suggestedAccount: suggestedAccount,
                handleOnClick: handleOnClick
            }, "session-hint") : !session.suggested && /*#__PURE__*/ (0, $6CtE1.jsx)($b2351f55bf358162$var$AccountsListItem, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.default), {
                    id: `account-${accountId}`,
                    onClick: handleOnClick || undefined,
                    avatarUrl: session.avatarUrl,
                    displayName: displayName,
                    email: email,
                    isolatedCloudLabel: icLabel
                })
            }, `session-${session.sessionId}`);
        });
        const hasMultipleSessions = sessions.length > 1;
        const noLoginHint = sessions.length >= 1 && sessions[0].hint !== (0, $lCnOB.LoginHintType).NotEmailAddress;
        const canAddSessions = (hasMultipleSessions || noLoginHint) && sessions.length <= $b2351f55bf358162$var$MAXIMUM_ASSOCIATED_SESSIONS;
        if (canAddSessions) accountsList.push(/*#__PURE__*/ (0, $6CtE1.jsx)($b2351f55bf358162$var$AccountsListItem, {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.AccountContainer), {
                id: "navigate-to-login-prompt",
                onClick: navigateToLoginPrompt,
                children: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $7ci1C.RowButtonContainer), {
                    children: [
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.AvatarContainer), {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($40q5T))), {
                                label: "",
                                size: "medium"
                            })
                        }),
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.TextContainer), {
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)($b2351f55bf358162$var$Paragraph, {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    id: "select.account.another",
                                    defaultMessage: "Add another account"
                                })
                            })
                        })
                    ]
                })
            })
        }, "navigate-to-login-prompt"));
        if (hasMultipleSessions) {
            const showRequestAccessLink = shouldShowRequestAccessLink();
            const showMaximumSessionsText = sessions.length > $b2351f55bf358162$var$MAXIMUM_ASSOCIATED_SESSIONS;
            const noBorder = !showMaximumSessionsText && !showRequestAccessLink;
            accountsList.push(/*#__PURE__*/ (0, $6CtE1.jsx)($b2351f55bf358162$var$AccountsListItem, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.AccountContainer), {
                    id: "navigate-to-remove-account-prompt",
                    noBorder: noBorder,
                    onClick: navigateToRemoveAccountPrompt,
                    children: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $7ci1C.RowButtonContainer), {
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.AvatarContainer), {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aIFdP))), {
                                    label: "",
                                    size: "medium"
                                })
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.TextContainer), {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)($b2351f55bf358162$var$Paragraph, {
                                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                        id: "select.account.footer.navigate.to.remove.account",
                                        defaultMessage: "Remove accounts from this browser"
                                    })
                                })
                            })
                        ]
                    })
                })
            }, "navigate-to-remove-account-prompt"));
        }
        const loginHintAccountIndex = sessions.findIndex((session)=>session.hint);
        const loginHintAccount = loginHintAccountIndex >= 0 ? accountsList.splice(loginHintAccountIndex, 1) : [];
        const accounts = loginHintAccount.concat(/*#__PURE__*/ (0, $6CtE1.jsx)($b2351f55bf358162$var$AccountsList, {
            children: accountsList
        }));
        return accounts;
    };
    const getSuggestedAccount = ()=>sessions.find((session)=>session.suggested);
    if (sessions.length > 0) return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: $b2351f55bf358162$var$pageId,
        header: renderHeader(),
        whiteboxFooter: renderMainContentFooter(),
        isLoading: isLoading,
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2iv3W.default), {
                children: renderAccounts()
            }),
            sessions.length > $b2351f55bf358162$var$MAXIMUM_ASSOCIATED_SESSIONS && /*#__PURE__*/ (0, $6CtE1.jsx)($b2351f55bf358162$var$SectionMessageWrapper, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kJPFV.default), {
                    testId: "selectaccountmaximumassociatedsessions",
                    appearance: "warning",
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "select.account.maximum.associated.sessions",
                        defaultMessage: "You can only add up to 10 accounts. Remove at least one account from this browser to add another."
                    })
                })
            })
        ]
    });
    navigateToLoginPrompt();
    return null;
};
const $b2351f55bf358162$var$Paragraph = (0, $fbSBq.default).p`
  font-size: 14px;
  line-height: 20px;
  color: ${(0, $l4KzN).N700};
  margin-top: 0px;
  overflow-wrap: break-word;
`;
var $b2351f55bf358162$export$2e2bcd8739ae039 = $b2351f55bf358162$export$134466789cb44107;

});
parcelRegister("40q5T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2eab6742949cd110$var$_react = $2eab6742949cd110$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $gsWOv = parcelRequire("gsWOv");

var $2eab6742949cd110$var$_personAvatar = $2eab6742949cd110$var$_interopRequireDefault((parcelRequire("k0m4w")));
function $2eab6742949cd110$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2eab6742949cd110$var$UserAvatarCircleIcon = (props)=>/*#__PURE__*/ $2eab6742949cd110$var$_react.default.createElement($gsWOv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="9" r="3" fill="inherit"/><path fill="inherit" fill-rule="nonzero" d="M7 18.245A7.97 7.97 0 0 0 12 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2z"/></g></svg>`
    }, props, {
        newIcon: $2eab6742949cd110$var$_personAvatar.default
    }));
$2eab6742949cd110$var$UserAvatarCircleIcon.displayName = 'UserAvatarCircleIcon';
var $2eab6742949cd110$var$_default = module.exports.default = $2eab6742949cd110$var$UserAvatarCircleIcon;

});
parcelRegister("k0m4w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aedef9bb726854d64999097926d2fc86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e904edc5cd13da63$var$_react = $e904edc5cd13da63$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $e904edc5cd13da63$var$_baseNew = $e904edc5cd13da63$var$_interopRequireDefault((parcelRequire("9LaLF")));
function $e904edc5cd13da63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e904edc5cd13da63$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $e904edc5cd13da63$var$_react.default.createElement($e904edc5cd13da63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$e904edc5cd13da63$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $e904edc5cd13da63$var$_default = module.exports.default = $e904edc5cd13da63$var$PersonAvatarIcon;

});


parcelRegister("aIFdP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7cddfd4ca1053d54$var$_react = $7cddfd4ca1053d54$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $gsWOv = parcelRequire("gsWOv");

var $7cddfd4ca1053d54$var$_crossCircle = $7cddfd4ca1053d54$var$_interopRequireDefault((parcelRequire("gjySt")));
function $7cddfd4ca1053d54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7cddfd4ca1053d54$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $7cddfd4ca1053d54$var$_react.default.createElement($gsWOv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $7cddfd4ca1053d54$var$_crossCircle.default
    }));
$7cddfd4ca1053d54$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $7cddfd4ca1053d54$var$_default = module.exports.default = $7cddfd4ca1053d54$var$CrossCircleIcon;

});
parcelRegister("gjySt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70e4741cbfa8f6087ac64902b38a7366>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be0979a845043448$var$_react = $be0979a845043448$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $be0979a845043448$var$_baseNew = $be0979a845043448$var$_interopRequireDefault((parcelRequire("9LaLF")));
function $be0979a845043448$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be0979a845043448$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $be0979a845043448$var$_react.default.createElement($be0979a845043448$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$be0979a845043448$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $be0979a845043448$var$_default = module.exports.default = $be0979a845043448$var$CrossCircleIcon;

});


parcelRegister("iBXUB", function(module, exports) {

$parcel$export(module.exports, "applicationDestinationSelector", function () { return $a6da6bc324a9e723$export$2305087f4689eaf8; });

var $1JRGy = parcelRequire("1JRGy");

var $fcxz7 = parcelRequire("fcxz7");
parcelRequire("65XXq");
var $aMRBJ = parcelRequire("aMRBJ");
const $a6da6bc324a9e723$var$parseContinueUrl = (search)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(search);
    if (params.continue) try {
        return new URL(params.continue);
    } catch  {
    //
    }
    return null;
};
const $a6da6bc324a9e723$export$2305087f4689eaf8 = (0, $aMRBJ.createSelector)([
    (0, $fcxz7.applicationSelector),
    (_state, search)=>search
], (applicationData, search)=>{
    const continueUrl = $a6da6bc324a9e723$var$parseContinueUrl(search);
    const destinationHostname = continueUrl && continueUrl.hostname || null;
    if (applicationData) {
        if (applicationData.coreApplication === 'jira' || applicationData.coreApplication === 'confluence') return {
            destinationHostname: destinationHostname,
            applicationName: applicationData.name
        };
        return {
            destinationHostname: null,
            applicationName: applicationData.name
        };
    }
    return null;
});
var $a6da6bc324a9e723$export$2e2bcd8739ae039 = $a6da6bc324a9e723$export$2305087f4689eaf8;

});

parcelRegister("jwSzA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6d4fdf9ee8d857e$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $kJPFV = parcelRequire("kJPFV");
const $e6d4fdf9ee8d857e$var$Message = ({ applicationDestination: applicationDestination, emailAddress: emailAddress, suggested: suggested })=>{
    if (!applicationDestination) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
        id: "login.unauthorized.email.body",
        defaultMessage: "<strong>{email}</strong> doesn't have access to this content.",
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                    children: chunks
                }),
            email: emailAddress
        }
    });
    if (applicationDestination.destinationHostname) {
        if (suggested) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "login.unauthorized.host.suggested.body",
            defaultMessage: "<strong>{email}</strong> doesn't have access to <strong>{host}</strong>. Switch to the below account to continue.",
            values: {
                strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                        children: chunks
                    }),
                email: emailAddress,
                host: applicationDestination.destinationHostname
            }
        });
        return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "login.unauthorized.host.body",
            defaultMessage: "<strong>{email}</strong> doesn't have access to {application} on <strong>{host}</strong>.",
            values: {
                strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                        children: chunks
                    }),
                application: applicationDestination.applicationName,
                email: emailAddress,
                host: applicationDestination.destinationHostname
            }
        });
    }
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
        id: "login.unauthorized.application.body",
        defaultMessage: "<strong>{email}</strong> doesn't have access to this content on <strong>{application}</strong>.",
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                    children: chunks
                }),
            application: applicationDestination.applicationName,
            email: emailAddress
        }
    });
};
const $e6d4fdf9ee8d857e$var$UnauthorizedComponent = ({ applicationDestination: applicationDestination, emailAddress: emailAddress, suggested: suggested })=>{
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kJPFV.default), {
        testId: "unauthorized-user",
        appearance: "warning",
        children: /*#__PURE__*/ (0, $6CtE1.jsx)($e6d4fdf9ee8d857e$var$Message, {
            applicationDestination: applicationDestination,
            emailAddress: emailAddress,
            suggested: !!suggested
        })
    });
};
var $e6d4fdf9ee8d857e$export$2e2bcd8739ae039 = $e6d4fdf9ee8d857e$var$UnauthorizedComponent;

});


parcelRegister("jqdEu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "continueAsLoader", function () { return $6ad74989cfa0a133$export$643f9a1ed27aa5c4; });
$parcel$export(module.exports, "ContinueAsPage", function () { return $6ad74989cfa0a133$export$a4ce1932d7e73468; });
$parcel$export(module.exports, "default", function () { return $6ad74989cfa0a133$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $5d9yI = parcelRequire("5d9yI");

var $eTWY7 = parcelRequire("eTWY7");

var $2byD0 = parcelRequire("2byD0");

var $7ci1C = parcelRequire("7ci1C");

var $fbSBq = parcelRequire("fbSBq");

var $chJxj = parcelRequire("chJxj");

var $cuZAx = parcelRequire("cuZAx");

var $Q6OOA = parcelRequire("Q6OOA");

var $68HQw = parcelRequire("68HQw");

var $4NPio = parcelRequire("4NPio");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $aMBBA = parcelRequire("aMBBA");

var $h4v4M = parcelRequire("h4v4M");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");
const $6ad74989cfa0a133$var$AccountWrapper = (0, $fbSBq.default).div`
  .account-entry {
    padding-bottom: ${(0, $68HQw.gridSize)() * 2}px;
    border-bottom: none;
  }
`;
const $6ad74989cfa0a133$var$pageId = 'continueAsScreen';
async function $6ad74989cfa0a133$export$643f9a1ed27aa5c4({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/login/continue-as/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--continue-as'
        ]
    });
}
const $6ad74989cfa0a133$export$a4ce1932d7e73468 = ()=>{
    const [isLoading, setIsLoading] = (0, $dNMDr.useState)(false);
    const { avatarUrl: avatarUrl, continueUrl: continueUrl, displayName: displayName, email: email } = (0, $aMBBA.useAppSelector)((state)=>state.continueAs);
    const oidcContext = (0, $aMBBA.useAppSelector)((state)=>state.microbranding.oidcContext);
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const location = (0, $cVnBY.useLocation)();
    (0, $4NPio.usePageViewedEvent)($6ad74989cfa0a133$var$pageId);
    const trackContinueButtonClicked = (0, $4NPio.useButtonClickedEvent)($6ad74989cfa0a133$var$pageId, 'continueAsButton');
    const handleContinueButton = (0, $dNMDr.useCallback)(()=>{
        trackContinueButtonClicked();
        setIsLoading(true);
        navigate(continueUrl);
    }, [
        continueUrl,
        trackContinueButtonClicked,
        navigate
    ]);
    const trackLoginWithOtherAccountClicked = (0, $4NPio.useButtonClickedEvent)($6ad74989cfa0a133$var$pageId, 'loginWithOtherAccount');
    const whiteboxFooter = ()=>{
        const operand = location.search && location.search.length > 0 ? '&' : '?';
        const loginLink = `/login${location.search}${operand}prompt=true`;
        if (!(0, $cuZAx.isOidcDisplayMode)(oidcContext, (0, $chJxj.OidcDisplay).Continue)) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6CtE1.Fragment), {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                onClick: trackLoginWithOtherAccountClicked,
                href: loginLink,
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "continue.as.login.with.another.account",
                    defaultMessage: "Login with a different account"
                })
            })
        });
        return null;
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: $6ad74989cfa0a133$var$pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5d9yI.default), {
            displayName: displayName
        }),
        whiteboxFooter: whiteboxFooter(),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)($6ad74989cfa0a133$var$AccountWrapper, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7ci1C.default), {
                    primary: true,
                    avatarUrl: avatarUrl,
                    displayName: displayName,
                    email: email
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                appearance: "primary",
                id: "login-submit",
                type: "submit",
                isFullWidth: true,
                isLoading: isLoading,
                onClick: handleContinueButton,
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "continue.as.button",
                    defaultMessage: "Continue"
                })
            })
        ]
    });
};
var $6ad74989cfa0a133$export$2e2bcd8739ae039 = $6ad74989cfa0a133$export$a4ce1932d7e73468;

});
parcelRegister("5d9yI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1250b25ddcf24fbb$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dWOVN = parcelRequire("dWOVN");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
const $1250b25ddcf24fbb$var$ContinueAsHeader = ({ displayName: displayName })=>{
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).Fragment, {
        children: displayName ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "continue.as.title.as",
                defaultMessage: "Continue as"
            })
        }) : /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "continue.as.title.as.application",
            tagName: "div",
            defaultMessage: "Continue to the application"
        })
    });
};
var $1250b25ddcf24fbb$export$2e2bcd8739ae039 = $1250b25ddcf24fbb$var$ContinueAsHeader;

});


parcelRegister("4V2aG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "migrateConfirmationLoader", function () { return $ec28299a84d22c5e$export$14853815c59b96ba; });
$parcel$export(module.exports, "MigrateAccountConfirmationPage", function () { return $ec28299a84d22c5e$export$3432bb22f729c42b; });
$parcel$export(module.exports, "default", function () { return $ec28299a84d22c5e$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $cpaps = parcelRequire("cpaps");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $7DUKO = parcelRequire("7DUKO");

var $16fXT = parcelRequire("16fXT");

var $79HVl = parcelRequire("79HVl");

var $2byD0 = parcelRequire("2byD0");

var $bbtxM = parcelRequire("bbtxM");

var $Q6OOA = parcelRequire("Q6OOA");

var $fcxz7 = parcelRequire("fcxz7");

var $4NPio = parcelRequire("4NPio");

var $aMBBA = parcelRequire("aMBBA");

var $h4v4M = parcelRequire("h4v4M");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");

var $dWOVN = parcelRequire("dWOVN");
const $ec28299a84d22c5e$var$MigrateAccountConfirmationSubHeading = (0, $fbSBq.default).p`
  font: ${(0, $7DUKO.default)('font.body')};
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $ec28299a84d22c5e$var$pageId = 'accountMigrationSuccessfulScreen';
async function $ec28299a84d22c5e$export$14853815c59b96ba({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/signup/migrate-confirmation/state', request, {
        capabilities: []
    });
}
const $ec28299a84d22c5e$export$3432bb22f729c42b = ()=>{
    const cobranding = (0, $aMBBA.useAppSelector)((state)=>state.cobranding);
    const redirectTo = (0, $aMBBA.useAppSelector)((state)=>state.migrateConfirmation.redirectTo);
    const location = (0, $cVnBY.useLocation)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const { infoCode: infoCode } = (0, (/*@__PURE__*/$parcel$interopDefault($16fXT))).parse(location.search.slice(1));
    const migratingUserInfoCode = infoCode || null;
    const pageViewedAttributes = migratingUserInfoCode ? {
        reasonViewingScreen: migratingUserInfoCode
    } : {};
    (0, $4NPio.usePageViewedEvent)($ec28299a84d22c5e$var$pageId, pageViewedAttributes);
    const trackContinueToProduct = (0, $4NPio.useButtonClickedEvent)($ec28299a84d22c5e$var$pageId, 'continueToProduct');
    const handleOnClick = ()=>{
        trackContinueToProduct();
        navigate(redirectTo);
    };
    const productDisplayName = cobranding && cobranding.application && (0, $fcxz7.applicationsMetadata)[cobranding.application] ? (0, $fcxz7.applicationsMetadata)[cobranding.application].name : 'Product';
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: $ec28299a84d22c5e$var$pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $bbtxM.default).migrateAccountConfirmationTitle
            })
        }),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)($ec28299a84d22c5e$var$MigrateAccountConfirmationSubHeading, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...(0, $bbtxM.default).migrateAccountConfirmationSummaryText,
                    values: {
                        productDisplayName: productDisplayName
                    }
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                    appearance: "primary",
                    id: "continue-submit",
                    type: "submit",
                    isFullWidth: true,
                    onClick: handleOnClick,
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $bbtxM.default).migrateAccountConfirmationButtonText,
                        values: {
                            productDisplayName: productDisplayName
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                title: formatMessage((0, $bbtxM.default).headTitle)
            })
        ]
    });
};
var $ec28299a84d22c5e$export$2e2bcd8739ae039 = $ec28299a84d22c5e$export$3432bb22f729c42b;

});
parcelRegister("16fXT", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $0cd2bc4b70042544$export$2f872c0f2117be69; }, function (v) { return $0cd2bc4b70042544$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "parse", function () { return $0cd2bc4b70042544$export$98e6a39c04603d36; }, function (v) { return $0cd2bc4b70042544$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "encode", function () { return $0cd2bc4b70042544$export$c564cdbbe6da493; }, function (v) { return $0cd2bc4b70042544$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "stringify", function () { return $0cd2bc4b70042544$export$fac44ee5b035f737; }, function (v) { return $0cd2bc4b70042544$export$fac44ee5b035f737 = v; });
var $0cd2bc4b70042544$export$2f872c0f2117be69;
var $0cd2bc4b70042544$export$98e6a39c04603d36;
var $0cd2bc4b70042544$export$c564cdbbe6da493;
var $0cd2bc4b70042544$export$fac44ee5b035f737;
'use strict';

$0cd2bc4b70042544$export$2f872c0f2117be69 = $0cd2bc4b70042544$export$98e6a39c04603d36 = (parcelRequire("bXKuM"));

$0cd2bc4b70042544$export$c564cdbbe6da493 = $0cd2bc4b70042544$export$fac44ee5b035f737 = (parcelRequire("7Y7Cf"));

});
parcelRegister("bXKuM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $8b594567fd15f272$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$8b594567fd15f272$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($8b594567fd15f272$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $8b594567fd15f272$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("7Y7Cf", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5cd40b61ea9a41fb$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $5cd40b61ea9a41fb$var$map($5cd40b61ea9a41fb$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($5cd40b61ea9a41fb$var$stringifyPrimitive(k)) + eq;
        if ($5cd40b61ea9a41fb$var$isArray(obj[k])) return $5cd40b61ea9a41fb$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($5cd40b61ea9a41fb$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($5cd40b61ea9a41fb$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($5cd40b61ea9a41fb$var$stringifyPrimitive(name)) + eq + encodeURIComponent($5cd40b61ea9a41fb$var$stringifyPrimitive(obj));
};
var $5cd40b61ea9a41fb$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $5cd40b61ea9a41fb$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $5cd40b61ea9a41fb$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});


parcelRegister("bbtxM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d3440c4b16aa012$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $9d3440c4b16aa012$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    migrateAccountConfirmationTitle: {
        id: 'migrate.account.confirmation.title',
        defaultMessage: "We've migrated your account!",
        description: 'Page heading'
    },
    migrateAccountConfirmationButtonText: {
        id: 'migrate.account.confirmation.button.text',
        defaultMessage: 'Continue to {productDisplayName}',
        description: 'Button text'
    },
    migrateAccountConfirmationSummaryText: {
        id: 'migrate.account.confirmation.summary.text',
        defaultMessage: "Your {productDisplayName} password has expired. From now on, use your Atlassian account to access {productDisplayName}.",
        description: 'Summary text'
    },
    headTitle: {
        id: 'migrate.account.confirmation.head.title',
        defaultMessage: 'Confirmed'
    }
});

});


parcelRegister("k9mWX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "recoverLoader", function () { return $3768ab0975fea6a9$export$1e2056400c8bd3bc; });
$parcel$export(module.exports, "RecoveryPage", function () { return $3768ab0975fea6a9$export$280a36f5ba1cc19f; });
$parcel$export(module.exports, "default", function () { return $3768ab0975fea6a9$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $cpaps = parcelRequire("cpaps");

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $dWOVN = parcelRequire("dWOVN");

var $7k3dJ = parcelRequire("7k3dJ");

var $2whP3 = parcelRequire("2whP3");

var $fFbFo = parcelRequire("fFbFo");

var $Q6OOA = parcelRequire("Q6OOA");

var $d1ZAH = parcelRequire("d1ZAH");

var $4NPio = parcelRequire("4NPio");

var $aMBBA = parcelRequire("aMBBA");

var $h4v4M = parcelRequire("h4v4M");

var $4ljBU = parcelRequire("4ljBU");

var $84ZjZ = parcelRequire("84ZjZ");

var $cBB3b = parcelRequire("cBB3b");
const $3768ab0975fea6a9$var$FormWrapper = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $3768ab0975fea6a9$var$pageId = '2svRecoveryLoginScreen';
async function $3768ab0975fea6a9$export$1e2056400c8bd3bc({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/2step/recover/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa-recover'
        ]
    });
}
const $3768ab0975fea6a9$export$280a36f5ba1cc19f = ()=>{
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    (0, $4NPio.usePageViewedEvent)($3768ab0975fea6a9$var$pageId);
    const { error: error, fieldErrors: fieldErrors, redirectTo: redirectTo, isLoading: isLoading } = (0, $aMBBA.useAppSelector)((state)=>state.recovery);
    const email = (0, $aMBBA.useAppSelector)((state)=>state.user.email);
    (0, $dNMDr.useEffect)(()=>{
        return ()=>{
            dispatch((0, $d1ZAH.reset)());
        };
    }, [
        dispatch
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (redirectTo) navigate(redirectTo);
    }, [
        redirectTo,
        navigate
    ]);
    const handleValidationError = (0, $dNMDr.useCallback)((errors)=>{
        dispatch((0, $d1ZAH.showFieldErrors)(errors));
    }, [
        dispatch
    ]);
    const handleLogIn = (0, $dNMDr.useCallback)((username, password)=>{
        dispatch((0, $d1ZAH.loginRecovery)({
            username: username,
            password: password,
            location: window.location,
            pageId: $3768ab0975fea6a9$var$pageId,
            analyticsClient: analyticsClient
        }));
    }, [
        dispatch,
        analyticsClient
    ]);
    const buildHeader = ()=>{
        return /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
                size: "small",
                as: "h1",
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "recovery.title",
                    defaultMessage: "Login to your Atlassian account"
                })
            })
        });
    };
    const onTsvLoginClick = (0, $4NPio.useButtonClickedEvent)($3768ab0975fea6a9$var$pageId, '2svRecoveryLogin');
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: $3768ab0975fea6a9$var$pageId,
        header: buildHeader(),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                title: formatMessage((0, $2whP3.RecoveryPageMessages).headTitle)
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)($3768ab0975fea6a9$var$FormWrapper, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7k3dJ.default), {
                    email: email,
                    emailFieldLabel: formatMessage((0, $fFbFo.default).loginFormUsernameLabel),
                    error: error,
                    fieldErrors: fieldErrors,
                    isLoading: isLoading,
                    onValidationError: handleValidationError,
                    submitButtonText: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "common.login",
                        defaultMessage: "Log in"
                    }),
                    onSubmitClick: onTsvLoginClick,
                    onSubmit: handleLogIn
                })
            })
        ]
    });
};
var $3768ab0975fea6a9$export$2e2bcd8739ae039 = $3768ab0975fea6a9$export$280a36f5ba1cc19f;

});
parcelRegister("2whP3", function(module, exports) {

$parcel$export(module.exports, "RecoveryPageMessages", function () { return $224a232ce87690a2$export$d587a18b8a3f34fa; });

var $2CYmK = parcelRequire("2CYmK");
const $224a232ce87690a2$export$d587a18b8a3f34fa = (0, $2CYmK.defineMessages)({
    headTitle: {
        id: 'login.head.title',
        defaultMessage: 'Log in to continue'
    }
});

});

parcelRegister("fFbFo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $718e63a3e9c9cca4$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $718e63a3e9c9cca4$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    loginFormUsernamePlaceholder: {
        id: 'login.form.username.placeholder',
        defaultMessage: 'Enter email'
    },
    loginFormUsernameLabel: {
        id: 'login.form.username.label',
        defaultMessage: 'Email'
    },
    loginFormReadOnlyUsernameAriaLabel: {
        id: 'login.form.readonly.username.aria.label',
        defaultMessage: 'Edit email'
    }
});

});

parcelRegister("d1ZAH", function(module, exports) {

$parcel$export(module.exports, "reset", function () { return $aa554020ba24134f$export$aad8462122ac592b; });
$parcel$export(module.exports, "showFieldErrors", function () { return $aa554020ba24134f$export$f17d5fd8029ff8d7; });
$parcel$export(module.exports, "loginRecovery", function () { return $aa554020ba24134f$export$29e90b35a0be5386; });
const $aa554020ba24134f$export$aad8462122ac592b = ()=>({
        type: 'TSV_RECOVERY_RESET'
    });
const $aa554020ba24134f$export$808a667858638948 = (redirectTo)=>({
        type: 'TSV_RECOVERY_LOGIN_REQUEST_LINK_REDIRECT',
        redirectTo: redirectTo
    });
const $aa554020ba24134f$export$51ae2c0618607c9f = (error)=>({
        type: 'TSV_RECOVERY_REQUEST_FAILED',
        error: error
    });
const $aa554020ba24134f$export$f17d5fd8029ff8d7 = (error)=>({
        type: 'TSV_RECOVERY_SHOW_FIELD_ERRORS',
        error: error
    });
const $aa554020ba24134f$export$29e90b35a0be5386 = ({ location: location, password: password, pageId: pageId, analyticsClient: analyticsClient })=>(dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        dispatch($aa554020ba24134f$export$aad8462122ac592b());
        return fetch(`/2step/recover${location.search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify({
                password: password
            })
        }).then((res)=>res.json()).then(({ fieldErrors: fieldErrors, uiErrors: uiErrors, redirectTo: redirectTo })=>{
            if (redirectTo) dispatch($aa554020ba24134f$export$808a667858638948(redirectTo));
            else {
                if (fieldErrors && Object.keys(fieldErrors).length) dispatch($aa554020ba24134f$export$f17d5fd8029ff8d7(fieldErrors));
                else if (uiErrors && uiErrors.length) {
                    const uiError = uiErrors[0];
                    if (uiError.key === 'password') analyticsClient.errorShownEvent(pageId, '2svRecoveryIncorrectPassword');
                    else analyticsClient.errorShownEvent(pageId, '2svRecoveryUnexpectedError');
                    dispatch($aa554020ba24134f$export$51ae2c0618607c9f(uiError.error));
                }
            }
        }).catch(()=>{
            analyticsClient.errorShownEvent(pageId, '2svRecoveryUnexpectedError');
            dispatch($aa554020ba24134f$export$51ae2c0618607c9f('unknown'));
        });
    };

});



parcelRegister("9LF2L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fbd2da933ba639c$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $cpaps = parcelRequire("cpaps");

var $lwrli = parcelRequire("lwrli");

var $hhYxc = parcelRequire("hhYxc");
const $0fbd2da933ba639c$var$mobileAppToUrlPatterns = {
    jira: [
        '/secure',
        '/issues',
        '/browse',
        '#issue',
        '#myjirahome',
        '#browse'
    ],
    confluence: [
        '/wiki'
    ]
};
const $0fbd2da933ba639c$var$iosAppId = {
    jira: '1006972087',
    confluence: '1006971684'
};
const $0fbd2da933ba639c$var$slackAppId = {
    jira: 'A2RPP3NFR',
    confluence: 'AC23SDS77'
};
/**
 * Checks if the continueUrl contains the specified pattern.
 * Additionally searches for the url encoded form of the pattern,
 * which can be encoded up to 3 times e.g. openId continue urls.
 */ const $0fbd2da933ba639c$var$checkForPattern = (continueUrl, pattern)=>{
    if (continueUrl.includes(pattern)) return true;
    const encode1 = encodeURIComponent(pattern);
    const encode2 = encodeURIComponent(encode1);
    const encode3 = encodeURIComponent(encode2);
    return continueUrl.includes(encode1) || continueUrl.includes(encode2) || continueUrl.includes(encode3);
};
/**
 * Adds mobile app meta tags to the document head if the continueUrl matches a pattern configured for mobile apps.
 */ const $0fbd2da933ba639c$var$MobileAppMetaTags = ()=>{
    const [queryParams] = (0, $lwrli.useSearchParams)();
    const continueUrl = queryParams.get('continue');
    const maybeMobileApp = (0, $dNMDr.useMemo)(()=>{
        if (!continueUrl) return null;
        for (const [mobileApp, urlPatterns] of Object.entries($0fbd2da933ba639c$var$mobileAppToUrlPatterns)){
            if (urlPatterns.find((urlPattern)=>$0fbd2da933ba639c$var$checkForPattern(continueUrl, urlPattern))) return mobileApp;
        }
        return null;
    }, [
        continueUrl
    ]);
    return maybeMobileApp && /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $cpaps.default), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)("meta", {
                name: "apple-itunes-app",
                content: `app-id=${$0fbd2da933ba639c$var$iosAppId[maybeMobileApp]}`
            }),
            (0, $hhYxc.getCurrentCloudType)() === 'commercial' && /*#__PURE__*/ (0, $6CtE1.jsx)("meta", {
                name: "slack-app-id",
                content: $0fbd2da933ba639c$var$slackAppId[maybeMobileApp]
            })
        ]
    });
};
var $0fbd2da933ba639c$export$2e2bcd8739ae039 = $0fbd2da933ba639c$var$MobileAppMetaTags;

});

parcelRegister("bzQ2t", function(module, exports) {

$parcel$export(module.exports, "PageStateReduxSyncer", function () { return $b053dbb3dca02a00$export$ad9e3e33174e4279; });
$parcel$export(module.exports, "wrapRoutesWithPageStateReduxSyncer", function () { return $b053dbb3dca02a00$export$155d0117198f4d25; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $cVnBY = parcelRequire("cVnBY");parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $hMPjy = parcelRequire("hMPjy");

var $aMBBA = parcelRequire("aMBBA");

var $4Gte9 = parcelRequire("4Gte9");

var $iy2Wm = parcelRequire("iy2Wm");

var $76XtE = parcelRequire("76XtE");

var $hqddj = parcelRequire("hqddj");

var $5ao9L = parcelRequire("5ao9L");
const $b053dbb3dca02a00$var$isRedirect = (data)=>Boolean(data && 'redirectTo' in data);
const $b053dbb3dca02a00$export$ba70a3168af79c5a = ()=>{
    const [isPageStateSyncedRedux, setIsPageStateSyncedRedux] = (0, $dNMDr.useState)(false);
    const location = (0, $cVnBY.useLocation)();
    const previousLocation = (0, $hMPjy.usePrevious)(location.pathname);
    const data = (0, $cVnBY.useLoaderData)();
    const dispatch = (0, $aMBBA.useAppDispatch)();
    (0, $dNMDr.useLayoutEffect)(()=>{
        if (previousLocation === location.pathname) // Component re-renders can cause this hook to reset the Redux app state unnecessarily.
        // This condition ensures we only ever fetch state and reset Redux when only the pathname
        // and not the search, nor other route states, changes.
        return;
        // No data could mean Feature Gate is disabled and useGlobalPageState is handling the state
        // Or there was a parsing error in the JSON response in `fetchPageState`
        if (!data) {
            // TODO: throw descriptive error here for handling in fine-grained error boundaries KIRBY-9124
            setIsPageStateSyncedRedux(true);
            return;
        }
        if ($b053dbb3dca02a00$var$isRedirect(data)) {
            window.location.assign(data.redirectTo);
            dispatch((0, $76XtE.setGlobalStateLoading)(true));
            return;
        }
        setIsPageStateSyncedRedux(false);
        (0, $iy2Wm.buildInitialState)(data).then((fullState)=>{
            dispatch((0, $76XtE.resetAppState)(fullState.initialStoreState));
        }).catch((error)=>{
            let errorType = {
                type: 'internal_server_error'
            };
            if (error instanceof (0, $4Gte9.ServerErrorException)) {
                errorType = error.errorType;
                (0, $hqddj.captureErrorMessage)(`Failed to load AppState in Bifrost: ${error.message}`);
            } else (0, $hqddj.captureErrorMessage)(`Unexpected error while loading AppState in Bifrost: ${error}`);
            dispatch((0, $5ao9L.setServerError)(errorType));
        }).finally(()=>setIsPageStateSyncedRedux(true));
    }, [
        data,
        dispatch,
        location.pathname,
        previousLocation
    ]);
    return {
        isPageStateSyncedRedux: isPageStateSyncedRedux
    };
};
const $b053dbb3dca02a00$export$ad9e3e33174e4279 = ({ children: children = ()=>null })=>{
    const { isPageStateSyncedRedux: isPageStateSyncedRedux } = $b053dbb3dca02a00$export$ba70a3168af79c5a();
    // This component is used to sync the page state with the Redux store which should take a few milliseconds.
    // Visual loading state is not required, the data loading is handled by React Router's loader.
    return isPageStateSyncedRedux ? children() : null;
};
const $b053dbb3dca02a00$export$155d0117198f4d25 = (routes)=>{
    return routes.map((route)=>{
        if (route.loader && route.element) {
            const element = route.element;
            route.element = /*#__PURE__*/ (0, $6CtE1.jsx)($b053dbb3dca02a00$export$ad9e3e33174e4279, {
                children: ()=>element
            });
        }
        // Recursively wrap child routes with PageStateReduxSyncer
        if (route.children) route.children = $b053dbb3dca02a00$export$155d0117198f4d25(route.children);
        return route;
    });
}; /**
 * Migration hook: attempts to read a value from React Router's loader data,
 * falling back to Redux if the value is not available.

 * TODO: PreloadedAppState and RootState have different shapes. Some selectors
 * will return undefined from loader data today (e.g. state.login?.isUsernameChecked
 * only exists in Redux). As we remove Redux state from the app, this hook will gradually start returning loader values.

  * Replace Redux useAppSelector:
  * - const isUsernameChecked = useAppSelector(state => state.login?.isUsernameChecked)
  * + const isUsernameChecked = usePageStateLoader(state => state.login?.isUsernameChecked)

export function usePageStateLoader<T>(selector: (state: RootState) => T): T {
  const analyticsClient = useAnalyticsClient();
  const loaderData = useLoaderData() as PreloadedAppState | ServerSideRedirect | null;
  const reduxValue = useAppSelector(selector);

  if (loaderData && !isRedirect(loaderData)) {
    try {
      const loaderValue = selector(loaderData);
      if (loaderValue !== undefined) {
        return loaderValue;
      }
    } catch {
      // Selector shape mismatch - fall through to Redux
    }
  }

  analyticsClient.trackingEvent({
    action: 'fallback',
    subject: 'pageStateReduxSyncer',
    subjectId: selector.toString(),
  });

  return reduxValue;
}
*/ 

});

parcelRegister("aFaYc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78d245465b8ae2bb$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $cU73R = parcelRequire("cU73R");

var $brOSo = parcelRequire("brOSo");

var $jj1EI = parcelRequire("jj1EI");

var $aMBBA = parcelRequire("aMBBA");
const $78d245465b8ae2bb$export$f90bece7989dfdb6 = ({ children: children })=>{
    const intl = (0, $ko1o6.default)();
    const serverError = (0, $aMBBA.useAppSelector)((state)=>state.serverError);
    if (serverError) {
        if (serverError.type === 'not_found') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cU73R.default), {
            title: intl.formatMessage((0, $jj1EI.default).notFoundTitle)
        });
        else if (serverError.type === 'internal_server_error') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cU73R.default), {
            title: intl.formatMessage((0, $jj1EI.default).internalServerErrorTitle),
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $jj1EI.default).internalServerErrorDescription
            })
        });
        else if (serverError.type === 'bad_request') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cU73R.default), {
            title: intl.formatMessage((0, $jj1EI.default).badRequestTitle),
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "error.badrequest.desc.xml",
                defaultMessage: "Often, clearing your browsers cache and restarting your browser will solve this problem.{br}If that doesn't work, please <support-link>contact support</support-link>.",
                values: {
                    br: /*#__PURE__*/ (0, $6CtE1.jsx)("br", {}),
                    'support-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("a", {
                            href: "https://support.atlassian.com/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: chunks
                        })
                }
            })
        });
        else if (serverError.type === 'csrf_token_mismatch') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $brOSo.default), {});
        else throw new Error(serverError.type || 'ServerError');
    }
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6CtE1.Fragment), {
        children: children
    });
};
var $78d245465b8ae2bb$export$2e2bcd8739ae039 = $78d245465b8ae2bb$export$f90bece7989dfdb6;

});
parcelRegister("brOSo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e3e312213a099fb$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $1JRGy = parcelRequire("1JRGy");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $8Cc4v = parcelRequire("8Cc4v");

var $eonuo = parcelRequire("eonuo");

var $Q6OOA = parcelRequire("Q6OOA");

var $2byD0 = parcelRequire("2byD0");

var $79HVl = parcelRequire("79HVl");

var $4NPio = parcelRequire("4NPio");

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $h4v4M = parcelRequire("h4v4M");

var $dWOVN = parcelRequire("dWOVN");
const $3e3e312213a099fb$var$pageId = 'atlassianAccountCsrfTokenMismatchErrorScreen';
const $3e3e312213a099fb$var$StyledOptions = (0, $fbSBq.default).ul`
  padding-left: ${3 * (0, $68HQw.gridSize)()}px;
`;
const $3e3e312213a099fb$export$2529ac9c93e3a3c2 = ()=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const preservedParamsKeys = [
        'application',
        'continue',
        'display',
        'email',
        'login_hint',
        'tenant'
    ];
    const originalParams = $1JRGy.parse(window.location.search);
    const preservedParams = Object.keys(originalParams).filter((key)=>preservedParamsKeys.includes(key)).reduce((obj, key)=>{
        obj[key] = originalParams[key];
        return obj;
    }, {});
    (0, $4NPio.usePageViewedEvent)($3e3e312213a099fb$var$pageId, {
        application: preservedParams.application
    });
    const tryLoginAgainAction = ()=>{
        analyticsClient.buttonClickedEvent($3e3e312213a099fb$var$pageId, 'csrfTokenMismatchTryAgainButton', {
            application: preservedParams.application
        });
        const queryParamsString = $1JRGy.stringify(preservedParams);
        navigate('/login' + (queryParamsString ? `?${queryParamsString}` : ''));
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: $3e3e312213a099fb$var$pageId,
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $eonuo.default).csrfMismatchTitle
            })
        }),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($8Cc4v))),
                height: "150",
                alt: "",
                className: "error-image"
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("br", {}),
            /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
                className: "error-description",
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $eonuo.default).csrfMismatchDescriptionFirstLine
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsxs)($3e3e312213a099fb$var$StyledOptions, {
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    id: "error.csrfmismatch.description.secondline",
                                    defaultMessage: "Close any <b>{siteName}</b> windows in your browser",
                                    values: {
                                        b: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                                                children: chunks
                                            }),
                                        siteName: window.location.hostname
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    ...(0, $eonuo.default).csrfMismatchDescriptionThirdLine
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                    appearance: "primary",
                    id: "try-again-button",
                    isFullWidth: true,
                    onClick: tryLoginAgainAction,
                    children: formatMessage((0, $eonuo.default).csrfMismatchButtonText)
                })
            })
        ]
    });
};
var $3e3e312213a099fb$export$2e2bcd8739ae039 = $3e3e312213a099fb$export$2529ac9c93e3a3c2;

});
parcelRegister("eonuo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44a814f39211797b$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $44a814f39211797b$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    csrfMismatchTitle: {
        id: 'error.csrfmismatch.title',
        defaultMessage: "We couldn't log you in"
    },
    csrfMismatchDescriptionFirstLine: {
        id: 'error.csrfmismatch.description.firstline',
        defaultMessage: 'Before trying again:'
    },
    csrfMismatchDescriptionThirdLine: {
        id: 'error.csrfmismatch.description.thirdline',
        defaultMessage: 'Check your browser settings and disable any extensions that may interfere with cookies.'
    },
    csrfMismatchButtonText: {
        id: 'error.csrfmismatch.button',
        defaultMessage: 'Try logging in again'
    }
});

});


parcelRegister("jj1EI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6984f50f6ab79df5$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $6984f50f6ab79df5$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    genericErrorTitle: {
        id: 'error.title',
        defaultMessage: 'Something went wrong.'
    },
    internalServerErrorTitle: {
        id: 'error.internalservererror.title',
        defaultMessage: 'Something went wrong while executing your request.'
    },
    internalServerErrorDescription: {
        id: 'error.internalservererror.desc',
        defaultMessage: "We're working on it, please try again shortly."
    },
    notFoundTitle: {
        id: 'error.notfound.title',
        defaultMessage: 'Page Not Found'
    },
    badRequestTitle: {
        id: 'error.badrequest.title',
        defaultMessage: "Oops, you've made a malformed request."
    }
});

});


parcelRegister("3Q4FK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2bc16c6727c954a$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $cuZAx = parcelRequire("cuZAx");

var $cU73R = parcelRequire("cU73R");

var $aMBBA = parcelRequire("aMBBA");
const $d2bc16c6727c954a$var$isUnSupportedMobileBrowser = ()=>{
    return /UC.*Browser|UCWEB/.test(window.navigator.userAgent);
};
const $d2bc16c6727c954a$export$3746f9f8319adede = ({ children: children })=>{
    const oidcContext = (0, $aMBBA.useAppSelector)((state)=>state.microbranding.oidcContext);
    if ((0, $cuZAx.isMobileOidc)(oidcContext) && $d2bc16c6727c954a$var$isUnSupportedMobileBrowser()) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cU73R.default), {
        title: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "unsupported.mobile.browser.error.message.heading",
            defaultMessage: "We\u2019re unable to log you in"
        }),
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "unsupported.mobile.browser.error.message.content",
            defaultMessage: "You are currently using an unsupported browser. Please use a supported browser such as Chrome, Firefox, Opera or Samsung Internet."
        })
    });
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6CtE1.Fragment), {
        children: children
    });
};
var $d2bc16c6727c954a$export$2e2bcd8739ae039 = $d2bc16c6727c954a$export$3746f9f8319adede;

});

parcelRegister("j31XW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48dcb72a91bf3567$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "UnexpectedApplicationErrorPage", function () { return $48dcb72a91bf3567$export$4f726a446dcd19f1; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $cU73R = parcelRequire("cU73R");

var $3YSXY = parcelRequire("3YSXY");

var $hqddj = parcelRequire("hqddj");

var $4Gte9 = parcelRequire("4Gte9");
class $48dcb72a91bf3567$export$2e2bcd8739ae039 extends (0, $dNMDr.Component) {
    constructor(props){
        super(props);
        this.state = {};
    }
    componentDidCatch(error, errorInfo) {
        // Handle case where the error is not specific enough for SLO but we still want to know about it
        // Example: build tools result in Event being thrown instead of Error, for failures to load
        // dynamically imported modules - should not burn SLO but is worth alerting via Sentry.
        if (!(error instanceof Error)) {
            this.setState({
                errorType: 'unexpected'
            });
            (0, $hqddj.captureMalformedError)(new Error(`Caught object that is not of type Error: ${error}`), {
                error: error
            }, 'not-an-instance-of-error');
            return;
        }
        // Thrown when all retry attempts are exhausted by fetchApiWithNetworkRetry
        if (error instanceof (0, $4Gte9.FetchTimeoutError)) {
            this.setState({
                errorType: 'network'
            });
            return;
        }
        // Failed to fetch dynamically imported module:
        // Importing a module script failed.
        // error loading dynamically imported module:
        // Cannot find module
        if (/(import|find).*.module/i.test(error.message)) {
            this.setState({
                errorType: 'network'
            });
            return;
        }
        this.setState({
            errorType: 'unexpected'
        });
        if (this.props.skipAnalytics) return;
        const page = window.location.pathname;
        const attributes = {
            errorName: error.name,
            errorMessage: error.message,
            errorComponentStack: errorInfo.componentStack || undefined,
            errorStack: error.stack
        };
        (0, $hqddj.captureTaggedReactException)(error, errorInfo, {
            capabilities: this.props.capabilities || [],
            extraProperties: {
                'ErrorBoundary.action': 'loadPageFailure',
                'ErrorBoundary.pageId': page
            }
        });
        this.props.analyticsClient.operationalEvent({
            page: page,
            action: 'loadPageFailure',
            subject: 'sli',
            attributes: attributes
        });
    }
    render() {
        const { errorType: errorType } = this.state;
        const anonymousId = this.props.analyticsClient.getAnonymousId();
        if (errorType === 'network') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cU73R.BaseErrorPage), {
            title: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "error.boundary.error.title",
                defaultMessage: "Something went wrong"
            }),
            anonymousId: anonymousId,
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "error.boundary.network.error",
                defaultMessage: "We were unable to load this page, possibly due to a network connectivity issue. Please check your network connection and try again.",
                tagName: "p"
            })
        });
        if (errorType === 'unexpected') return /*#__PURE__*/ (0, $6CtE1.jsx)($48dcb72a91bf3567$export$4f726a446dcd19f1, {
            anonymousId: anonymousId
        });
        return this.props.children;
    }
}
const $48dcb72a91bf3567$export$4f726a446dcd19f1 = ({ anonymousId: anonymousId })=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $cU73R.BaseErrorPage), {
        title: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "error.boundary.error.title",
            defaultMessage: "Something went wrong"
        }),
        anonymousId: anonymousId,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "error.boundary.unexpected.error",
            defaultMessage: "An unexpected error occurred. We are looking into it. Please try again later.",
            tagName: "p"
        })
    });

});

parcelRegister("5vEwV", function(module, exports) {

$parcel$export(module.exports, "reactRouterFutureFlags", function () { return $3902ac6ee8abbb1a$export$d4ead9fca2c685ee; });
const $3902ac6ee8abbb1a$export$d4ead9fca2c685ee = {
    // Enabled all future flags for v7 upgrade: https://reactrouter.com/6.29.0/upgrading/future
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_relativeSplatPath: true,
    v7_skipActionErrorRevalidation: true
};

});

parcelRegister("7zuqn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "loginLoader", function () { return $5a2c3bec29e5d1d5$export$b2919fa8ecdd2f51; });
$parcel$export(module.exports, "default", function () { return $5a2c3bec29e5d1d5$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $cpaps = parcelRequire("cpaps");

var $ko1o6 = parcelRequire("ko1o6");

var $bVs8G = parcelRequire("bVs8G");

var $2sBCi = parcelRequire("2sBCi");

var $kQxOX = parcelRequire("kQxOX");

var $Q6OOA = parcelRequire("Q6OOA");

var $5A0kF = parcelRequire("5A0kF");

var $aMBBA = parcelRequire("aMBBA");

var $fSUge = parcelRequire("fSUge");

var $2G8Xj = parcelRequire("2G8Xj");

var $31L3B = parcelRequire("31L3B");

var $7zp9r = parcelRequire("7zp9r");

var $gTjux = parcelRequire("gTjux");

var $bw067 = parcelRequire("bw067");

var $hqddj = parcelRequire("hqddj");

var $hhYxc = parcelRequire("hhYxc");

var $7FWgq = parcelRequire("7FWgq");

var $iQDyE = parcelRequire("iQDyE");

var $8rkLA = parcelRequire("8rkLA");

var $k3nfW = parcelRequire("k3nfW");

var $7ZYGf = parcelRequire("7ZYGf");

var $2tsIC = parcelRequire("2tsIC");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");

var $cOw4T = parcelRequire("cOw4T");

var $7hGwi = parcelRequire("7hGwi");

var $2EOHn = parcelRequire("2EOHn");
async function $5a2c3bec29e5d1d5$export$b2919fa8ecdd2f51({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/login/state', request, {
        capabilities: [
            'capability-group--login'
        ]
    });
}
const $5a2c3bec29e5d1d5$var$LoginPage = ()=>{
    const { oidcContext: oidcContext, isEmbedded: isEmbedded, isMobileApp: isMobileApp, screenSize: screenSize } = (0, $fSUge.useMicrobranding)();
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const { isPasswordlessAllowed: isPasswordlessAllowed, checkUsername: checkUsername, isUsernameChecked: isUsernameChecked, checkUsernameError: checkUsernameError, error: loginError, redirectType: redirectType, isRestrictedEmail: isRestrictedEmail, isCheckUsernameLoading: isCheckUsernameLoading, resetLogin: resetLogin, infoCode: infoCode, rememberMeEnabled: rememberMeEnabled, isRememberMeChecked: isRememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox } = (0, $iQDyE.useLogin)();
    const { isLoading: isLoading, onLogin: handleLogIn, onPasswordlessLogin: handlePasswordlessLogIn } = (0, $8rkLA.useLoginSubmission)();
    const { onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin, onMicrosoftLogin: onMicrosoftLogin, onGoogleSocialLogin: onGoogleSocialLogin, onDismissGoogleOneTap: onDismissGoogleOneTap, socialLoginEligibility: socialLoginEligibility, envSupportsSocialLogin: envSupportsSocialLogin, isSocialBlocked: isSocialBlocked } = (0, $k3nfW.useSocialLogin)();
    const { onPasskeyLogin: onPasskeyLogin, authenticating: authenticating } = (0, $7hGwi.usePasskeyLogin)();
    const { redirectToSingleSignOn: redirectToSingleSignOn } = (0, $2EOHn.useOrgLoginConfig)();
    const cobrandingApplication = (0, $7FWgq.useCobrandingApplication)();
    const isLoginSecondStep = isUsernameChecked;
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const emailFromSearchParams = (0, $7FWgq.useEmailFromSearchParams)();
    const [email, setEmail] = (0, $dNMDr.useState)(()=>emailFromSearchParams || '');
    // Sync state with query params
    // In the case when the query params change after the component is first rendered
    (0, $dNMDr.useEffect)(()=>{
        if (emailFromSearchParams) setEmail(emailFromSearchParams);
    }, [
        emailFromSearchParams
    ]);
    (0, $7ZYGf.useGoogleOneTap)({
        email: email
    });
    const { highlightedSocialProvider: highlightedSocialProvider = null, isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly = null } = socialLoginEligibility || {};
    const showSocialLoginOnly = isLoginSecondStep && isEligibleForSocialLoginOnly && highlightedSocialProvider && envSupportsSocialLogin;
    const handleGoogleSocialLogin = (0, $dNMDr.useCallback)(()=>{
        if (envSupportsSocialLogin) onGoogleSocialLogin(email);
    }, [
        email,
        onGoogleSocialLogin,
        envSupportsSocialLogin
    ]);
    const handleMicrosoftLogin = (0, $dNMDr.useCallback)(()=>{
        if (envSupportsSocialLogin) onMicrosoftLogin(email);
    }, [
        email,
        onMicrosoftLogin,
        envSupportsSocialLogin
    ]);
    const handleAppleLogin = (0, $dNMDr.useCallback)(()=>{
        if (envSupportsSocialLogin) onAppleLogin(email);
    }, [
        email,
        onAppleLogin,
        envSupportsSocialLogin
    ]);
    const handleSlackLogin = (0, $dNMDr.useCallback)(()=>{
        if (envSupportsSocialLogin) onSlackLogin(email);
    }, [
        email,
        onSlackLogin,
        envSupportsSocialLogin
    ]);
    const handlePasskeyLogin = (0, $dNMDr.useCallback)(()=>{
        onPasskeyLogin();
    }, [
        onPasskeyLogin
    ]);
    const handleValidationError = (0, $dNMDr.useCallback)((errors)=>dispatch((0, $bVs8G.showFormErrors)(errors)), [
        dispatch
    ]);
    const handleContinue = (email)=>{
        checkUsername(email);
    };
    const handleFormClick = (0, $dNMDr.useCallback)(()=>{
        if (envSupportsSocialLogin && screenSize === 'mobile') onDismissGoogleOneTap();
    }, [
        onDismissGoogleOneTap,
        screenSize,
        envSupportsSocialLogin
    ]);
    const handleEmailChange = (0, $dNMDr.useCallback)((email)=>{
        setEmail(email);
        if ((0, $hhYxc.isFedM)()) (0, $hqddj.addBreadcrumb)({
            level: 'debug',
            message: 'FedRAMP login email input change',
            category: 'ui',
            data: {
                emailLength: email.length,
                emailType: typeof email,
                emailConstructor: email && email.constructor ? email.constructor.name : undefined
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)("title", {
                    children: formatMessage((0, $5A0kF.LoginPageMessages).headTitle)
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $Q6OOA.default), {
                pageId: (0, $bw067.loginPageId),
                header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $31L3B.default), {
                    highlightedSocialProvider: highlightedSocialProvider,
                    showSocialLoginOnly: showSocialLoginOnly
                }),
                footer: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2G8Xj.default), {
                    oidcContext: oidcContext,
                    isEmbedded: isEmbedded
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gTjux.default), {
                    showSocialLoginOnly: showSocialLoginOnly,
                    isMobileApp: isMobileApp,
                    oidcContext: oidcContext
                }),
                children: showSocialLoginOnly ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kQxOX.default), {
                    email: email,
                    highlightedSocialProvider: highlightedSocialProvider,
                    handleGoogleLogin: handleGoogleSocialLogin,
                    handleMicrosoftLogin: handleMicrosoftLogin,
                    handleAppleLogin: handleAppleLogin,
                    handleSlackLogin: handleSlackLogin
                }) : /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2sBCi.default), {
                            application: cobrandingApplication || null,
                            redirectType: !isLoginSecondStep ? redirectType : null,
                            isRedirecting: redirectType !== null,
                            isSecondStep: isLoginSecondStep,
                            isPasswordlessAllowed: isPasswordlessAllowed,
                            isLoading: isLoading,
                            isCheckUsernameLoading: isCheckUsernameLoading,
                            onContinue: handleContinue,
                            onLogIn: handleLogIn,
                            onPasswordlessLogIn: handlePasswordlessLogIn,
                            error: loginError,
                            info: infoCode,
                            fieldErrors: {
                                email: checkUsernameError
                            },
                            email: email,
                            onValidationError: handleValidationError,
                            onEditEmail: resetLogin,
                            onFormClick: handleFormClick,
                            restrictedEmail: isRestrictedEmail,
                            pageId: (0, $bw067.loginPageId),
                            onEmailChange: handleEmailChange,
                            showRememberMeCheckbox: rememberMeEnabled,
                            rememberMeChecked: isRememberMeChecked,
                            onToggleRememberMeCheckbox: onToggleRememberMeCheckbox,
                            onRedirectToSingleSignOn: redirectToSingleSignOn
                        }),
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cOw4T.default), {
                            onPasskeyLogin: handlePasskeyLogin,
                            authenticating: authenticating
                        }),
                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7zp9r.default), {
                            isEmbedded: isEmbedded,
                            envSupportsSocialLogin: envSupportsSocialLogin,
                            isSocialBlocked: isSocialBlocked,
                            onSlackLogin: handleSlackLogin,
                            onAppleLogin: handleAppleLogin,
                            onMicrosoftLogin: handleMicrosoftLogin,
                            onGoogleLogin: handleGoogleSocialLogin
                        })
                    ]
                })
            })
        ]
    });
};
function $5a2c3bec29e5d1d5$var$LoginRoute() {
    // TODO: KIRBY-8427: tidy up this double check.
    const { shouldShowRememberedAccounts: shouldShowRememberedAccounts } = (0, $iQDyE.useLogin)();
    if (shouldShowRememberedAccounts) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2tsIC.default), {});
    return /*#__PURE__*/ (0, $6CtE1.jsx)($5a2c3bec29e5d1d5$var$LoginPage, {});
}
var $5a2c3bec29e5d1d5$export$2e2bcd8739ae039 = $5a2c3bec29e5d1d5$var$LoginRoute;

});
parcelRegister("bVs8G", function(module, exports) {

$parcel$export(module.exports, "requestCheckUsername", function () { return $c7957229311cbfcd$export$46a04796807ec7cb; });
$parcel$export(module.exports, "requestIsolatedCloudCheckUsername", function () { return $c7957229311cbfcd$export$d330728921b32f16; });
$parcel$export(module.exports, "selectCheckUsernameAccount", function () { return $c7957229311cbfcd$export$862edb984b0b0b17; });
$parcel$export(module.exports, "requestCheckUsernameSucceeded", function () { return $c7957229311cbfcd$export$80cce12ca79dd0df; });
$parcel$export(module.exports, "checkUsernameCaptchaFailure", function () { return $c7957229311cbfcd$export$c48d28459d63299c; });
$parcel$export(module.exports, "resetLoginForm", function () { return $c7957229311cbfcd$export$6a45e1ba06bcfd40; });
$parcel$export(module.exports, "resetRememberMeState", function () { return $c7957229311cbfcd$export$f89c906644f34324; });
$parcel$export(module.exports, "showFormErrors", function () { return $c7957229311cbfcd$export$f89084e6f067bb43; });
$parcel$export(module.exports, "setRememberMeCheckbox", function () { return $c7957229311cbfcd$export$8eb90c84b47e7339; });
$parcel$export(module.exports, "toggleRememberMeCheckbox", function () { return $c7957229311cbfcd$export$64749aae889ad7b0; });
$parcel$export(module.exports, "checkUsername", function () { return $c7957229311cbfcd$export$4929d86c6e4e281e; });
$parcel$export(module.exports, "isolatedCloudCheckUsername", function () { return $c7957229311cbfcd$export$3c1990c0236969b7; });
$parcel$export(module.exports, "loginUsernamePassword", function () { return $c7957229311cbfcd$export$5391cc01902916c6; });
$parcel$export(module.exports, "loginPasswordless", function () { return $c7957229311cbfcd$export$a6eaf375001ea98a; });

var $1JRGy = parcelRequire("1JRGy");

var $4zSeo = parcelRequire("4zSeo");

var $8po8T = parcelRequire("8po8T");

var $hqddj = parcelRequire("hqddj");

var $chJxj = parcelRequire("chJxj");

var $aDvvX = parcelRequire("aDvvX");

var $bw067 = parcelRequire("bw067");

var $aTnCk = parcelRequire("aTnCk");

var $bXVRR = parcelRequire("bXVRR");

var $btezy = parcelRequire("btezy");
const $c7957229311cbfcd$export$9cdc46fdb2ee9975 = (response)=>response.ok ? response : response.text().then((error)=>{
        throw new Error(error || response.statusText);
    });
const $c7957229311cbfcd$export$46a04796807ec7cb = ()=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME'
    });
const $c7957229311cbfcd$export$2edff4284d04f803 = (userAction)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_REDIRECT',
        redirectUrl: userAction.redirect_uri,
        redirectType: userAction.redirect_type
    });
const $c7957229311cbfcd$export$e22c6bb1d0d5743a = (userAction)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_ISOLATED_CLOUD_REDIRECT',
        redirect_uri: userAction.redirect_uri
    });
const $c7957229311cbfcd$export$d330728921b32f16 = ()=>({
        type: 'LOGIN_REQUEST_ISOLATED_CLOUD_CHECK_USERNAME'
    });
const $c7957229311cbfcd$export$bc4012779ed85c1 = (userActions)=>({
        type: 'LOGIN_REQUEST_ISOLATED_CLOUD_CHECK_USERNAME_SUCCEEDED',
        userActions: userActions
    });
const $c7957229311cbfcd$export$5cc9c4683c14face = ()=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_SIGNUP'
    });
const $c7957229311cbfcd$export$c7d021a470828fad = (userAction)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_NO_ACTION',
        passwordless: userAction.passwordless || (0, $chJxj.CheckUserNamePasswordlessType).Disallowed,
        social: userAction.social || 'allowed'
    });
const $c7957229311cbfcd$export$862edb984b0b0b17 = (userAction)=>({
        type: 'LOGIN_SELECT_CHECK_USERNAME_USER_ACTION',
        userAction: userAction
    });
const $c7957229311cbfcd$export$a7eb3c2b6fb70d6e = (userAction)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_SOCIAL_LOGIN',
        passwordless: userAction.passwordless || (0, $chJxj.CheckUserNamePasswordlessType).Disallowed,
        identities: userAction.identities
    });
const $c7957229311cbfcd$export$80cce12ca79dd0df = (usernameCheckParams, userAction)=>(dispatch)=>{
        switch(userAction.action){
            case 'redirect':
                dispatch($c7957229311cbfcd$export$2edff4284d04f803(userAction));
                break;
            case 'signup':
                dispatch($c7957229311cbfcd$export$5cc9c4683c14face());
                break;
            case 'no_action':
                dispatch($c7957229311cbfcd$export$c7d021a470828fad(userAction));
                break;
            case 'social_login':
                if (!userAction.identities || userAction.identities.password === undefined) // this event is needed for growth team's experiment slo
                // we want to silently fire this event and not show any error
                // this will just not enrol user in the experiment
                usernameCheckParams.analyticsClient.operationalEvent({
                    page: (0, $bw067.loginPageId),
                    action: 'loadSocialLoginPage',
                    subject: 'sli',
                    attributes: {
                        hasError: true,
                        errorName: 'identities not as expected'
                    }
                });
                dispatch($c7957229311cbfcd$export$a7eb3c2b6fb70d6e(userAction));
                break;
            case 'continue_required':
                dispatch($c7957229311cbfcd$export$f640318460f9993(usernameCheckParams));
                break;
            case 'ic_redirect':
                dispatch($c7957229311cbfcd$export$e22c6bb1d0d5743a(userAction));
                break;
        }
        return Promise.resolve();
    };
const $c7957229311cbfcd$export$c48d28459d63299c = (isOnline)=>$c7957229311cbfcd$export$c445752097d9b598({
        code: isOnline ? 'captcha' : 'request_error'
    });
const $c7957229311cbfcd$export$9cd96a2b004cc2f1 = (error)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_FAILED',
        error: error
    });
const $c7957229311cbfcd$export$c445752097d9b598 = (error)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_ERROR',
        error: error
    });
const $c7957229311cbfcd$export$6a45e1ba06bcfd40 = ()=>({
        type: 'LOGIN_RESET'
    });
const $c7957229311cbfcd$export$f89c906644f34324 = ()=>({
        type: 'RESET_REMEMBER_ME_STATE'
    });
const $c7957229311cbfcd$export$8a7c7d5c19ae03dc = ()=>({
        type: 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN'
    });
const $c7957229311cbfcd$export$e35197b32bd33011 = ()=>({
        type: 'LOGIN_REQUEST_PASSWORDLESS_LOGIN'
    });
const $c7957229311cbfcd$export$2195b30ff9688f1f = ()=>({
        type: 'LOGIN_REQUEST_PASSWORDLESS_LOGIN_SUCCESS'
    });
const $c7957229311cbfcd$export$9fbe8d742e3cfe1f = (error)=>({
        type: 'LOGIN_REQUEST_PASSWORDLESS_LOGIN_FAILED',
        error: error
    });
const $c7957229311cbfcd$export$8d0d1628cde4bf96 = (redirectUrl = '')=>({
        type: 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_SUCCESS',
        redirectUrl: redirectUrl
    });
const $c7957229311cbfcd$export$72f5cc903fa26407 = (error)=>({
        type: 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_FAILED',
        error: error
    });
const $c7957229311cbfcd$export$7598c3f25ced4803 = (redirectUrl)=>({
        type: 'LOGIN_REDIRECT_USER',
        redirectUrl: redirectUrl
    });
const $c7957229311cbfcd$export$84085369fb3df1bc = (nextAttempt)=>({
        type: 'UPDATE_LOGIN_ATTEMPT_DETAILS',
        nextAttempt: nextAttempt
    });
const $c7957229311cbfcd$export$3e87c66a234f33b9 = (isCaptchaRequired)=>({
        type: 'LOGIN_UPDATE_CAPTCHA_REQUIREMENT',
        isCaptchaRequired: isCaptchaRequired
    });
const $c7957229311cbfcd$export$f89084e6f067bb43 = (errors)=>({
        type: 'LOGIN_SHOW_LOGIN_FORM_ERRORS',
        errors: errors
    });
const $c7957229311cbfcd$export$8eb90c84b47e7339 = (checked)=>({
        type: 'REMEMBER_ME_CHECKBOX_UPDATE',
        payload: {
            enabled: checked
        }
    });
const $c7957229311cbfcd$export$64749aae889ad7b0 = ()=>({
        type: 'REMEMBER_ME_CHECKBOX_TOGGLE'
    });
const $c7957229311cbfcd$var$usernameCheck = ({ username: username, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse, destinationOrgId: destinationOrgId })=>async (dispatch, getState)=>{
        dispatch($c7957229311cbfcd$export$46a04796807ec7cb());
        (0, $hqddj.addBreadcrumb)({
            category: 'login.check_username',
            message: 'Check username API call initiated',
            level: 'info',
            data: {
                hasRecoveryToken: !!recoveryToken,
                hasChallengeResponse: !!challengeResponse,
                challengeType: challengeResponse?.type
            }
        });
        let response;
        try {
            response = await fetch(`/rest/check-username${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getState().csrfToken
                },
                body: JSON.stringify({
                    username: username,
                    recoveryToken: recoveryToken,
                    'challenge-response': (0, $btezy.toChallengeRequest)(challengeResponse),
                    destinationOrgId: destinationOrgId
                })
            });
        } catch (networkError) {
            (0, $hqddj.addBreadcrumb)({
                category: 'login.check_username',
                message: 'Network error during check-username',
                level: 'error',
                data: {
                    isOnline: navigator.onLine
                }
            });
            (0, $hqddj.captureTaggedException)(networkError, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--username-password-login',
                    'capability-name--login-with-username-password'
                ],
                extraProperties: {
                    description: 'Network failure during check-username API call',
                    isOnline: navigator.onLine,
                    endpoint: '/rest/check-username'
                }
            });
            dispatch($c7957229311cbfcd$export$c445752097d9b598({
                code: 'request_error'
            }));
            return;
        }
        let analyticsAction;
        let analyticsAttributes = {};
        if (response.ok) try {
            const userAction = await response.json();
            dispatch($c7957229311cbfcd$export$80cce12ca79dd0df({
                username: username,
                params: params,
                analyticsClient: analyticsClient,
                recoveryToken: recoveryToken,
                challengeResponse: challengeResponse
            }, userAction));
            // Set context with auth method details
            (0, $hqddj.setContext)('login.checkUsername', {
                action: userAction?.action,
                redirectType: userAction?.action === 'redirect' && userAction?.redirect_type,
                passwordless: userAction?.action === 'no_action' && userAction?.passwordless,
                social: userAction?.action === 'no_action' && userAction?.social,
                hasRecoveryToken: !!recoveryToken,
                challengeType: challengeResponse?.type || null
            });
            (0, $hqddj.addBreadcrumb)({
                category: 'login.check_username',
                message: 'Check username succeeded',
                level: 'info',
                data: {
                    action: userAction.action,
                    redirectType: userAction.action === 'redirect' && userAction.redirect_type
                }
            });
            analyticsAction = 'checkUsernameSuccessful';
        } catch (parseError) {
            dispatch($c7957229311cbfcd$export$c445752097d9b598({
                code: 'unknown'
            }));
            analyticsAction = 'checkUsernameFailure';
            analyticsAttributes = {
                ...analyticsAttributes,
                reason: 'response_parsing_error'
            };
            (0, $hqddj.captureTaggedException)(parseError, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--username-password-login',
                    'capability-name--login-with-username-password'
                ],
                extraProperties: {
                    description: 'Check-username response OK but failed to parse it'
                }
            });
        }
        else {
            analyticsAction = 'checkUsernameFailure';
            let responseErrorText = null;
            (0, $hqddj.addBreadcrumb)({
                category: 'login.check_username',
                message: 'Check username HTTP error',
                level: 'error',
                data: {
                    statusCode: response.status
                }
            });
            try {
                analyticsAttributes = {
                    ...analyticsAttributes,
                    reason: 'http_error',
                    httpStatus: response.status
                };
                if (response.status === 429) dispatch($c7957229311cbfcd$export$c445752097d9b598({
                    code: 'too_many_username_requests'
                }));
                else if (response.status === 400) {
                    const { uiErrors: uiErrors } = await response.json();
                    if (uiErrors && uiErrors.length) dispatch($c7957229311cbfcd$export$c445752097d9b598({
                        code: uiErrors[0].key || 'unknown'
                    }));
                } else {
                    responseErrorText = await response.text() || response.statusText;
                    const extractedError = JSON.parse(responseErrorText).formErrors[0];
                    analyticsAttributes = {
                        ...analyticsAttributes,
                        description: extractedError
                    };
                    dispatch($c7957229311cbfcd$export$9cd96a2b004cc2f1(extractedError));
                }
            } catch (error) {
                const description = 'Failed to handle non-OK response from check-username';
                (0, $hqddj.captureTaggedException)(error, {
                    capabilities: [
                        'capability-group--login',
                        'capability-subgroup--username-password-login',
                        'capability-name--login-with-username-password'
                    ],
                    extraProperties: {
                        description: description,
                        responseStatus: response.status,
                        responseErrorText: responseErrorText
                    }
                });
                analyticsAttributes = {
                    ...analyticsAttributes,
                    reason: 'unknown',
                    description: description
                };
                dispatch($c7957229311cbfcd$export$c445752097d9b598({
                    code: 'unknown'
                }));
            }
        }
        analyticsClient.operationalEvent({
            page: (0, $bw067.loginPageId),
            action: analyticsAction,
            subject: 'sli',
            attributes: analyticsAttributes
        });
    };
const $c7957229311cbfcd$export$4929d86c6e4e281e = ({ username: username, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse, destinationOrgId: destinationOrgId })=>(dispatch)=>{
        analyticsClient.operationalEvent({
            page: (0, $bw067.loginPageId),
            action: 'checkUsernameStart',
            subject: 'sli'
        });
        return dispatch($c7957229311cbfcd$var$usernameCheck({
            username: username,
            params: params,
            analyticsClient: analyticsClient,
            recoveryToken: recoveryToken,
            challengeResponse: challengeResponse,
            destinationOrgId: destinationOrgId
        }));
    };
const $c7957229311cbfcd$export$3c1990c0236969b7 = ({ username: username, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse, awsCaptchaToken: awsCaptchaToken, destinationOrgId: destinationOrgId })=>async (dispatch, getState)=>{
        dispatch($c7957229311cbfcd$export$d330728921b32f16());
        (0, $hqddj.addBreadcrumb)({
            category: 'login.check_username',
            message: 'Check isolated cloud username API call initiated',
            level: 'info',
            data: {
                hasRecoveryToken: !!recoveryToken,
                hasChallengeResponse: !!challengeResponse,
                challengeType: challengeResponse?.type
            }
        });
        analyticsClient.operationalEvent({
            page: (0, $bw067.loginPageId),
            action: 'checkIsolatedCloudUsernameStart',
            subject: 'sli'
        });
        const csrfToken = getState().csrfToken;
        let response;
        try {
            response = await fetch(`/rest/v2/check-username${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                    ...awsCaptchaToken ? {
                        'aws-waf-token': awsCaptchaToken
                    } : {}
                },
                body: JSON.stringify({
                    username: username,
                    recoveryToken: recoveryToken,
                    'challenge-response': (0, $btezy.toChallengeRequest)(challengeResponse),
                    destinationOrgId: destinationOrgId
                })
            });
        } catch (networkError) {
            (0, $hqddj.addBreadcrumb)({
                category: 'login.check_username',
                message: 'Network error during check-username Isolated Cloud',
                level: 'error',
                data: {
                    isOnline: navigator.onLine
                }
            });
            (0, $hqddj.captureTaggedException)(networkError, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--username-password-login',
                    'capability-name--login-with-username-password'
                ],
                extraProperties: {
                    description: 'Network failure during check-username Isolated Cloud API call',
                    isOnline: navigator.onLine,
                    endpoint: '/rest/v2/check-username'
                }
            });
            dispatch($c7957229311cbfcd$export$c445752097d9b598({
                code: 'request_error'
            }));
            return;
        }
        let analyticsAction;
        let analyticsAttributes = {};
        if (response.ok) try {
            const userActions = await response.json();
            dispatch($c7957229311cbfcd$export$bc4012779ed85c1(userActions));
            if (userActions.length === 1) {
                // If there is only a single user action, automatically select it
                dispatch($c7957229311cbfcd$export$80cce12ca79dd0df({
                    username: username,
                    params: params,
                    analyticsClient: analyticsClient,
                    recoveryToken: recoveryToken,
                    challengeResponse: challengeResponse
                }, userActions[0]));
                dispatch($c7957229311cbfcd$export$862edb984b0b0b17(userActions[0]));
                (0, $hqddj.setContext)('login.checkUsername', {
                    action: userActions[0]?.action,
                    redirectType: userActions[0]?.action === 'redirect' && userActions[0]?.redirect_type,
                    passwordless: userActions[0]?.action === 'no_action' && userActions[0]?.passwordless,
                    social: userActions[0]?.action === 'no_action' && userActions[0]?.social,
                    hasRecoveryToken: !!recoveryToken,
                    challengeType: challengeResponse?.type || null
                });
            }
            (0, $hqddj.addBreadcrumb)({
                category: 'login.check_username',
                message: 'Check isolated cloud username succeeded',
                level: 'info',
                data: {
                    userActionsCount: userActions.length
                }
            });
            analyticsAction = 'checkIsolatedCloudUsernameSuccessful';
        } catch (parseError) {
            dispatch($c7957229311cbfcd$export$c445752097d9b598({
                code: 'unknown'
            }));
            analyticsAction = 'checkIsolatedCloudUsernameFailure';
            analyticsAttributes = {
                ...analyticsAttributes,
                reason: 'response_parsing_error'
            };
            (0, $hqddj.captureTaggedException)(parseError, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--username-password-login',
                    'capability-name--login-with-username-password'
                ],
                extraProperties: {
                    description: 'Check-username Isolated Cloud response OK but failed to parse it'
                }
            });
        }
        else {
            analyticsAction = 'checkIsolatedCloudUsernameFailure';
            let responseErrorText = null;
            (0, $hqddj.addBreadcrumb)({
                category: 'login.check_username',
                message: 'Check isolated cloud username HTTP error',
                level: 'error',
                data: {
                    statusCode: response.status
                }
            });
            try {
                analyticsAttributes = {
                    ...analyticsAttributes,
                    reason: 'http_error',
                    httpStatus: response.status
                };
                if (response.status === 429) dispatch($c7957229311cbfcd$export$c445752097d9b598({
                    code: 'too_many_username_requests'
                }));
                else if (response.status === 400) {
                    const { uiErrors: uiErrors } = await response.json();
                    if (uiErrors && uiErrors.length) dispatch($c7957229311cbfcd$export$c445752097d9b598({
                        code: uiErrors[0].key || 'unknown'
                    }));
                } else {
                    responseErrorText = await response.text() || response.statusText;
                    const extractedError = JSON.parse(responseErrorText).formErrors[0];
                    analyticsAttributes = {
                        ...analyticsAttributes,
                        description: extractedError
                    };
                    dispatch($c7957229311cbfcd$export$9cd96a2b004cc2f1(extractedError));
                }
            } catch (parseError) {
                const description = 'Failed to handle non-OK response from check-username Isolated Cloud';
                (0, $hqddj.captureTaggedException)(parseError, {
                    capabilities: [
                        'capability-group--login',
                        'capability-subgroup--username-password-login',
                        'capability-name--login-with-username-password'
                    ],
                    extraProperties: {
                        description: description,
                        responseStatus: response.status,
                        responseErrorText: responseErrorText
                    }
                });
                analyticsAttributes = {
                    ...analyticsAttributes,
                    reason: 'unknown',
                    description: description
                };
                dispatch($c7957229311cbfcd$export$c445752097d9b598({
                    code: 'unknown'
                }));
            }
        }
        analyticsClient.operationalEvent({
            page: (0, $bw067.loginPageId),
            action: analyticsAction,
            subject: 'sli',
            attributes: analyticsAttributes
        });
    };
const $c7957229311cbfcd$export$f640318460f9993 = ({ username: username, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse, destinationOrgId: destinationOrgId })=>async (dispatch, getState)=>{
        const csrfToken = getState().csrfToken;
        analyticsClient.operationalEvent({
            page: (0, $bw067.loginPageId),
            action: 'checkIsolatedCloudUsernameContinueRequiredStart',
            subject: 'sli'
        });
        let analyticsAction;
        let response;
        try {
            response = await fetch(`/rest/v2/check-username/continue${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify({
                    username: username,
                    recoveryToken: recoveryToken,
                    'challenge-response': (0, $btezy.toChallengeRequest)(challengeResponse),
                    destinationOrgId: destinationOrgId
                })
            });
        } catch (networkError) {
            analyticsClient.operationalEvent({
                page: (0, $bw067.loginPageId),
                action: 'checkIsolatedCloudUsernameContinueRequiredFailure',
                subject: 'sli'
            });
            dispatch($c7957229311cbfcd$export$c445752097d9b598({
                code: 'request_error'
            }));
            return;
        }
        if (response.ok) {
            const userAction = await response.json();
            dispatch($c7957229311cbfcd$export$2edff4284d04f803(userAction));
            analyticsAction = 'checkIsolatedCloudUsernameContinueRequiredSuccessful';
        } else {
            let responseErrorText = null;
            try {
                if (response.status === 429) dispatch($c7957229311cbfcd$export$c445752097d9b598({
                    code: 'too_many_username_requests'
                }));
                else if (response.status === 400) {
                    const { uiErrors: uiErrors } = await response.json();
                    if (uiErrors && uiErrors.length) dispatch($c7957229311cbfcd$export$c445752097d9b598({
                        code: uiErrors[0].key || 'unknown'
                    }));
                } else {
                    responseErrorText = await response.text() || response.statusText;
                    const extractedError = JSON.parse(responseErrorText).formErrors[0];
                    dispatch($c7957229311cbfcd$export$9cd96a2b004cc2f1(extractedError));
                }
            } catch (parseError) {
                (0, $hqddj.captureTaggedException)(parseError, {
                    capabilities: [
                        'capability-group--login',
                        'capability-subgroup--username-password-login',
                        'capability-name--login-with-username-password'
                    ],
                    extraProperties: {
                        description: 'Failed to handle non-OK response from check-username Isolated Cloud',
                        responseStatus: response.status,
                        responseErrorText: responseErrorText
                    }
                });
            }
            analyticsAction = 'checkIsolatedCloudUsernameContinueRequiredFailure';
        }
        analyticsClient.operationalEvent({
            page: (0, $bw067.loginPageId),
            action: analyticsAction,
            subject: 'sli'
        });
    };
function $c7957229311cbfcd$var$reportFrontendError(error) {
    function removeField(obj, fieldName) {
        for(const prop in obj){
            if (prop === fieldName) delete obj[prop];
            else if (typeof obj[prop] === 'object') removeField(obj[prop], fieldName);
        }
    }
    function decodeJsonField(obj, path) {
        const val = (0, (/*@__PURE__*/$parcel$interopDefault($8po8T)))(obj, path);
        if (val !== 'undefined') try {
            (0, (/*@__PURE__*/$parcel$interopDefault($4zSeo)))(obj, path, JSON.parse(val));
        } catch (_) {}
    }
    removeField(error, 'password');
    decodeJsonField(error, 'original.response.text');
    const errorCode = error['error'];
    (0, $hqddj.captureTaggedException)(error, {
        capabilities: [
            'capability-group--login',
            'capability-subgroup--username-password-login',
            'capability-name--login-with-username-password'
        ],
        extraProperties: {
            description: error?.error_description || 'Failed to login for an unexpected reason',
            code: errorCode
        }
    });
}
function $c7957229311cbfcd$var$parseAdditionalData(err) {
    try {
        return JSON.parse(atob(err.error_description));
    } catch (e) {
        return {};
    }
}
function $c7957229311cbfcd$var$handleLoginError(err, username, application, dispatch, getState, onLoginError) {
    const additionalData = $c7957229311cbfcd$var$parseAdditionalData(err);
    const code = (additionalData['custom_error'] || err['error'] || '').toLowerCase();
    const isBitbucket = application && application.toLowerCase() === 'bitbucket';
    (0, $hqddj.addBreadcrumb)({
        category: 'login.password_login',
        message: 'Password login failed',
        level: 'error',
        data: {
            errorCode: code,
            hasApplication: !!application,
            isBitbucket: isBitbucket,
            attemptNumber: getState().login.nextAttempt
        }
    });
    if (code === 'too_many_attempts' || code === 'invalid_captcha') {
        dispatch($c7957229311cbfcd$export$3e87c66a234f33b9(true));
        dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
            code: 'captcha'
        }));
    } else if (code === 'access_denied') {
        dispatch($c7957229311cbfcd$export$84085369fb3df1bc(getState().login.nextAttempt + 1));
        dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
            code: 'invalid_user_password'
        }));
    } else if (code === 'ambiguous_user') dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
        code: 'ambiguous_user'
    }));
    else if (code === 'no_email_on_remote_user') dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
        code: 'no_email_on_remote_user',
        args: {
            username: username
        }
    }));
    else if (code === 'username_is_not_email') {
        const errorCode = isBitbucket ? 'bitbucket_username_is_not_email' : 'username_is_not_email';
        dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
            code: errorCode,
            args: {
                username: additionalData['email']
            }
        }));
    } else if (code === 'email_is_not_primary') {
        const errorCode = isBitbucket ? 'bitbucket_email_is_not_primary' : 'email_is_not_primary';
        dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
            code: errorCode,
            args: {
                username: additionalData['email']
            }
        }));
    } else if (code === 'too_many_logins') dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
        code: 'too_many_logins'
    }));
    else if (code === 'password_leaked') dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
        code: 'password_leaked'
    }));
    else if (code === 'blocked_user') {
        const redirectURL = application ? `/login/inactive?application=${application}` : '/login/inactive';
        dispatch($c7957229311cbfcd$export$7598c3f25ced4803(redirectURL));
    } else if (code === 'client_ip_not_allowed') dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
        code: 'client_ip_not_allowed'
    }));
    else if (code === 'client_ip_missing') dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
        code: 'client_ip_missing'
    }));
    else if (code === 'request_error') // 'request_error' auth0-js: connection fails due to offline or cross domain issue
    dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
        code: 'request_error'
    }));
    else if (code === 'invalid.session.token') dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
        code: 'invalid.session.token'
    }));
    else {
        $c7957229311cbfcd$var$reportFrontendError(err);
        dispatch($c7957229311cbfcd$export$72f5cc903fa26407({
            code: 'unknown'
        }));
    }
    if (code !== 'too_many_attempts' && code !== 'invalid_captcha') dispatch($c7957229311cbfcd$export$3e87c66a234f33b9(false));
    onLoginError(code);
}
function $c7957229311cbfcd$var$verifyCaptchaIfRequired(captchaValue, username) {
    if (!captchaValue) return Promise.resolve();
    (0, $hqddj.addBreadcrumb)({
        category: 'login.captcha',
        message: 'Verifying captcha response',
        level: 'info'
    });
    return fetch('/rest/captcha/verify', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            'g-recaptcha-response': captchaValue,
            email: username
        })
    }).then($c7957229311cbfcd$export$9cdc46fdb2ee9975).catch(()=>{
        (0, $hqddj.addBreadcrumb)({
            category: 'login.captcha',
            message: 'Captcha verification failed',
            level: 'error'
        });
        return Promise.reject(new Error('invalid_captcha'));
    });
}
const $c7957229311cbfcd$export$beb986ec1c64324 = (csrfToken, config, marketingConsentState, anonymousId, userFlow)=>{
    let state = {
        csrfToken: csrfToken,
        anonymousId: anonymousId,
        userFlow: userFlow
    };
    const marketingConsent = (0, $aDvvX.buildMarketingConsent)(config, marketingConsentState);
    if (marketingConsent) state = {
        ...state,
        marketingConsent: marketingConsent
    };
    return state;
};
const $c7957229311cbfcd$export$5391cc01902916c6 = (loginParams, navigate)=>(dispatch, getState)=>{
        const { location: location, username: username, password: password, captchaValue: captchaValue, onLoginError: onLoginError, anonymousId: anonymousId } = loginParams;
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search);
        const { application: application, userFlow: userFlow } = params;
        const state = getState();
        const { isRememberMeChecked: isRememberMeChecked } = state.login;
        const { csrfToken: csrfToken, marketingConsent: marketingConsent } = state;
        dispatch($c7957229311cbfcd$export$8a7c7d5c19ae03dc());
        (0, $hqddj.addBreadcrumb)({
            category: 'login.password_login',
            message: 'Password login initiated',
            level: 'info',
            data: {
                hasCaptcha: !!captchaValue,
                isRememberMeChecked: isRememberMeChecked,
                hasApplication: !!application,
                hasUserFlow: !!userFlow
            }
        });
        (0, $hqddj.setContext)('login.passwordLogin', {
            hasCaptcha: !!captchaValue,
            isRememberMeChecked: isRememberMeChecked,
            application: application,
            userFlow: userFlow,
            attemptNumber: state.login.nextAttempt
        });
        const loginState = $c7957229311cbfcd$export$beb986ec1c64324(csrfToken, marketingConsent.config, loginParams.marketingConsent, anonymousId, userFlow);
        // This passes the `remember` flag to the backend, "remembering" the account that we're logging into.
        if (isRememberMeChecked) params.remember = 'true';
        const query = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(params);
        const loginWithAtlassianAuth = (navigate)=>(0, $aTnCk.login)({
                username: username,
                password: password,
                state: loginState,
                query: `?${query}${location.hash}`
            }).then((result)=>{
                switch(result.kind){
                    case 'failure':
                        {
                            const err = {
                                error: result.reason
                            };
                            return $c7957229311cbfcd$var$handleLoginError(err, username, application, dispatch, getState, onLoginError);
                        }
                    case 'success':
                        (0, $hqddj.addBreadcrumb)({
                            category: 'login.password_login',
                            message: 'Password login succeeded',
                            level: 'info'
                        });
                        return navigate(result.redirectUri);
                }
            });
        return $c7957229311cbfcd$var$verifyCaptchaIfRequired(captchaValue, username).then(()=>loginWithAtlassianAuth(navigate)).catch((err)=>{
            (0, $hqddj.captureTaggedException)(err, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--username-password-login',
                    'capability-name--login-with-username-password'
                ],
                extraProperties: {
                    description: 'Failed to login'
                }
            });
            $c7957229311cbfcd$var$handleLoginError(err, username, application, dispatch, getState, onLoginError);
        });
    };
const $c7957229311cbfcd$export$a6eaf375001ea98a = ({ email: email, captchaValue: captchaValue, location: location })=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken, login: { isRememberMeChecked: isRememberMeChecked } } = getState();
        dispatch($c7957229311cbfcd$export$e35197b32bd33011());
        (0, $hqddj.addBreadcrumb)({
            category: 'login.passwordless',
            message: 'Passwordless login initiated',
            level: 'info',
            data: {
                hasCaptcha: !!captchaValue,
                isRememberMeChecked: isRememberMeChecked
            }
        });
        (0, $hqddj.setContext)('login.passwordlessLogin', {
            hasCaptcha: !!captchaValue,
            isRememberMeChecked: isRememberMeChecked
        });
        const urlParams = new URLSearchParams(location.search);
        if (isRememberMeChecked) urlParams.set('remember', 'true');
        const apiParams = urlParams.toString();
        try {
            const response = await fetch(`/rest/login/passwordless?${apiParams}`, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    captchaValue: captchaValue
                })
            });
            const { csrfToken: newCsrfToken } = await response.json();
            if (newCsrfToken) dispatch((0, $bXVRR.updateCsrfToken)(newCsrfToken));
            if (response.ok) {
                (0, $hqddj.addBreadcrumb)({
                    category: 'login.passwordless',
                    message: 'Passwordless login succeeded',
                    level: 'info'
                });
                dispatch($c7957229311cbfcd$export$2195b30ff9688f1f());
                return {
                    success: true
                };
            } else {
                (0, $hqddj.addBreadcrumb)({
                    category: 'login.passwordless',
                    message: 'Passwordless login failed',
                    level: 'error',
                    data: {
                        statusCode: response.status
                    }
                });
                dispatch($c7957229311cbfcd$export$9fbe8d742e3cfe1f({
                    code: 'unknown'
                }));
                return {
                    success: false
                };
            }
        } catch (error) {
            (0, $hqddj.captureTaggedException)(error, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--passwordless-login',
                    'capability-name--passwordless-login'
                ],
                extraProperties: {
                    description: 'Failed passwordless login'
                }
            });
            dispatch($c7957229311cbfcd$export$9fbe8d742e3cfe1f({
                code: 'request_error'
            }));
            return {
                success: false
            };
        }
    };

});
parcelRegister("8po8T", function(module, exports) {

var $jnJBa = parcelRequire("jnJBa");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $61f362b53ad0a6ac$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $jnJBa(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $61f362b53ad0a6ac$var$get;

});
parcelRegister("jnJBa", function(module, exports) {

var $eiWAm = parcelRequire("eiWAm");

var $gXjya = parcelRequire("gXjya");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $e1c3892faf70336d$var$baseGet(object, path) {
    path = $eiWAm(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$gXjya(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $e1c3892faf70336d$var$baseGet;

});


parcelRegister("aDvvX", function(module, exports) {

$parcel$export(module.exports, "IMPLICIT_CONSENT_TEXT", function () { return $d58ac74bb624527c$export$a18e359a3f598d3b; });
$parcel$export(module.exports, "buildMarketingConsent", function () { return $d58ac74bb624527c$export$689cf67bd4c05bd3; });

var $1JRGy = parcelRequire("1JRGy");
const $d58ac74bb624527c$export$a18e359a3f598d3b = 'general consent captured';
const $d58ac74bb624527c$export$689cf67bd4c05bd3 = (config, checkboxState, privacyPolicyText)=>{
    let marketingConsent = null;
    if (config && config.locale) {
        const hasConsent = checkboxState.state !== 'not_shown' || config.implicitConsent;
        if (hasConsent) {
            const consent = checkboxState.state === 'checked' || config.implicitConsent;
            // @ts-ignore
            const marketingConsentText = checkboxState.consentText || $d58ac74bb624527c$export$a18e359a3f598d3b;
            marketingConsent = {
                consent: consent,
                locale: config.locale,
                marketingConsentText: marketingConsentText
            };
            if (privacyPolicyText) marketingConsent = {
                ...marketingConsent,
                privacyPolicyText: privacyPolicyText
            };
        }
    }
    return marketingConsent;
};
const $d58ac74bb624527c$var$FORCE_SHOW_MARKETING_CONSENT_PARAM = 'showMarketingConsent';
const $d58ac74bb624527c$export$44896947615de4a4 = (location)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search);
    return $d58ac74bb624527c$var$FORCE_SHOW_MARKETING_CONSENT_PARAM in params;
};

});

parcelRegister("bw067", function(module, exports) {

$parcel$export(module.exports, "loginPageId", function () { return $d4e392511e1789d9$export$bb0bd0af2c24d0c1; });
const $d4e392511e1789d9$export$bb0bd0af2c24d0c1 = 'loginScreen';

});

parcelRegister("aTnCk", function(module, exports) {

$parcel$export(module.exports, "login", function () { return $53fbb9db2ca649a5$export$596d806903d1f59e; });

var $1JRGy = parcelRequire("1JRGy");

var $dJpcp = parcelRequire("dJpcp");
var $53fbb9db2ca649a5$export$db7ad81c1149bb91 = /*#__PURE__*/ function(LoginFailureReason) {
    LoginFailureReason["AccessDenied"] = "access_denied";
    LoginFailureReason["PasswordLeaked"] = "password_leaked";
    LoginFailureReason["BlockedUser"] = "blocked_user";
    LoginFailureReason["TooManyAttempts"] = "too_many_attempts";
    LoginFailureReason["TooManyLogins"] = "too_many_logins";
    LoginFailureReason["ClientIpNotAllowed"] = "client_ip_not_allowed";
    LoginFailureReason["ClientIpMissing"] = "client_ip_missing";
    return LoginFailureReason;
}({});
var $53fbb9db2ca649a5$export$5e64a9683d127ef6 = /*#__PURE__*/ function(LoginError) {
    LoginError["PreconditionFailed"] = "precondition_failed";
    LoginError["UnexpectedError"] = "unexpected_error";
    return LoginError;
}({});
function $53fbb9db2ca649a5$var$failure(reason) {
    return {
        kind: 'failure',
        reason: reason
    };
}
function $53fbb9db2ca649a5$var$success(redirectUri) {
    return {
        kind: 'success',
        redirectUri: redirectUri
    };
}
async function $53fbb9db2ca649a5$export$596d806903d1f59e({ state: state, username: username, password: password, query: query }) {
    const castleToken = await (0, $dJpcp.getCastleRequestToken)([
        'capability-group--login',
        'capability-name--login-with-username-password'
    ]);
    const token = castleToken || 'dummy-token'; // a token is expected by id-auth in IC and disabled entirely within FedRAMP
    return fetch(`/rest/authenticate${query}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            username: username,
            password: password,
            state: state,
            token: token
        })
    }).then((response)=>{
        switch(response.status){
            case 200:
                return response.json().then((r)=>$53fbb9db2ca649a5$var$success(r.redirectUri));
            case 403:
                return response.json().then((r)=>{
                    switch(r.error){
                        case 'access_denied':
                            return $53fbb9db2ca649a5$var$failure("access_denied");
                        case 'blocked_user':
                            return $53fbb9db2ca649a5$var$failure("blocked_user");
                        case 'password_leaked':
                            return $53fbb9db2ca649a5$var$failure("password_leaked");
                        case 'too_many_attempts':
                            return $53fbb9db2ca649a5$var$failure("too_many_attempts");
                        case 'client_ip_not_allowed':
                            return $53fbb9db2ca649a5$var$failure("client_ip_not_allowed");
                        case 'client_ip_missing':
                            return $53fbb9db2ca649a5$var$failure("client_ip_missing");
                        default:
                            return Promise.reject(new Error("unexpected_error"));
                    }
                });
            case 429:
                return response.json().then((r)=>r.error === 'too_many_logins' ? $53fbb9db2ca649a5$var$failure("too_many_logins") : Promise.reject(new Error("unexpected_error")));
            case 412:
                return response.json().then((r)=>{
                    switch(r.error){
                        case 'mfa_required':
                            {
                                const currentQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(window.location.search);
                                currentQueryParams.transactionToken = r.token;
                                const currentQueryString = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(currentQueryParams);
                                return $53fbb9db2ca649a5$var$success(`/login/mfa?${currentQueryString}`);
                            }
                        default:
                            return Promise.reject(new Error("precondition_failed"));
                    }
                });
            default:
                return Promise.reject(new Error("unexpected_error", {
                    cause: {
                        description: 'Unexpected response status',
                        response: response
                    }
                }));
        }
    });
}

});

parcelRegister("btezy", function(module, exports) {

$parcel$export(module.exports, "toChallengeRequest", function () { return $a07a0963e6a3d5ea$export$79b8871c3ed7cc2a; });
function $a07a0963e6a3d5ea$export$79b8871c3ed7cc2a(response) {
    if (!response) return null;
    return {
        'challenge-kind': response.challengeKind,
        token: {
            value: response.token
        },
        type: response.type
    };
}

});


parcelRegister("2sBCi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccc4e3949cf7b086$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $3Wc5s = parcelRequire("3Wc5s");

var $fbSBq = parcelRequire("fbSBq");

var $gODCJ = parcelRequire("gODCJ");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $6i4Wm = parcelRequire("6i4Wm");

var $hfwZH = parcelRequire("hfwZH");

var $8LTuC = parcelRequire("8LTuC");

var $2byD0 = parcelRequire("2byD0");

var $gre8I = parcelRequire("gre8I");

var $9TeuV = parcelRequire("9TeuV");

var $4Cmcw = parcelRequire("4Cmcw");

var $hXPGK = parcelRequire("hXPGK");

var $chJxj = parcelRequire("chJxj");

var $fcxz7 = parcelRequire("fcxz7");

var $4NPio = parcelRequire("4NPio");

var $bw067 = parcelRequire("bw067");

var $iQMMg = parcelRequire("iQMMg");

var $kcNti = parcelRequire("kcNti");

var $3v21n = parcelRequire("3v21n");

var $4yl6n = parcelRequire("4yl6n");

var $5bOZS = parcelRequire("5bOZS");

var $8IkGb = parcelRequire("8IkGb");
var $4JRmj = parcelRequire("4JRmj");

var $cr5CS = parcelRequire("cr5CS");

var $8GnY0 = parcelRequire("8GnY0");

var $hhYxc = parcelRequire("hhYxc");
const $ccc4e3949cf7b086$export$d55ce944e082b58f = (0, $fbSBq.default).div`
  align-items: center;
  color: ${(0, $l4KzN).N90};
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 0 8px;
`;
const $ccc4e3949cf7b086$export$a7fed597f4b8afd8 = (0, $fbSBq.default).form`
  margin: 0;
`;
const $ccc4e3949cf7b086$var$InputsWrapper = (0, $fbSBq.default).div`
  margin-bottom: ${(0, $68HQw.gridSize)()}px;
`;
const $ccc4e3949cf7b086$var$getEmailFieldViewType = (restrictedEmail, redirectType, isSecondStep, isLoading)=>{
    if (restrictedEmail || redirectType === (0, $chJxj.CheckUserNameRedirectType).Sso) return (0, $hfwZH.FieldViewType).Restricted;
    else if (isSecondStep || isLoading) return (0, $hfwZH.FieldViewType).ReadOnlyWithEditButton;
    return (0, $hfwZH.FieldViewType).Editable;
};
const $ccc4e3949cf7b086$export$1f58f750f20f344b = ({ application: application, email: email, error: error, fieldErrors: fieldErrors, info: info, isLoading: isLoading, isPasswordlessAllowed: isPasswordlessAllowed, isRedirecting: isRedirecting, isSecondStep: isSecondStep, isCheckUsernameLoading: isCheckUsernameLoading, onContinue: onContinue, onEditEmail: onEditEmail, onEmailChange: onEmailChange, onFormClick: onFormClick, onLogIn: onLogIn, onPasswordlessLogIn: onPasswordlessLogIn, onValidationError: onValidationError, pageId: pageId, redirectType: redirectType, restrictedEmail: restrictedEmail, showRememberMeCheckbox: showRememberMeCheckbox, rememberMeChecked: rememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox, onRedirectToSingleSignOn: onRedirectToSingleSignOn })=>{
    const intl = (0, $ko1o6.default)();
    const translatedEmailFieldError = (0, $4yl6n.useTranslateFormErrorIfAvailable)(fieldErrors.email);
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const [password, setPassword] = (0, $dNMDr.useState)('');
    const [buttonClicked, setButtonClicked] = (0, $dNMDr.useState)('submit');
    const inputRef = (0, $dNMDr.useRef)(null);
    const [passwordFieldError, setPasswordFieldError] = (0, $dNMDr.useState)(null);
    const onEmailClick = (0, $dNMDr.useCallback)(()=>{
        setPassword('');
        setPasswordFieldError(null);
        onEditEmail();
    }, [
        onEditEmail
    ]);
    const { captchaValue: captchaValue, isRequired: isTooManyAttemptsRecaptchaRequired } = (0, $kcNti.useLoginTooManyAttemptsRecaptchaContext)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        const trimmedEmail = email.trim();
        const emailEmpty = trimmedEmail === '';
        const emailInvalid = !trimmedEmail.match(/.+@.+/);
        const passwordEmpty = password === '';
        // Ignore submission of form while the app is loading.
        if (isLoading) return;
        setButtonClicked('submit');
        analyticsClient.buttonClickedEvent(pageId, isSecondStep ? 'login' : 'continueToLogin');
        if (emailEmpty) {
            inputRef.current?.focus();
            const emailValidationError = formatMessage((0, $hXPGK.default).emailEmpty);
            analyticsClient.errorShownEvent((0, $bw067.loginPageId), 'validationError');
            onValidationError({
                email: emailValidationError
            });
            return;
        }
        if (emailInvalid) {
            inputRef.current?.focus();
            const emailValidationError = formatMessage((0, $hXPGK.default).emailInvalid);
            analyticsClient.errorShownEvent((0, $bw067.loginPageId), 'validationError');
            onValidationError({
                email: emailValidationError
            });
            return;
        }
        if (isSecondStep && passwordEmpty) {
            setPasswordFieldError(formatMessage((0, $hXPGK.default).passwordEmpty));
            return;
        }
        if (!isSecondStep) onContinue(trimmedEmail);
        else onLogIn(trimmedEmail, password);
    };
    const handlePasswordlessButtonClick = async ()=>{
        const trimmedEmail = email.trim();
        if (isLoading || !trimmedEmail) return;
        setButtonClicked('passwordless');
        onPasswordlessLogIn(trimmedEmail);
    };
    const handlePasswordChange = (0, $dNMDr.useCallback)((e)=>{
        if (passwordFieldError) setPasswordFieldError(null);
        setPassword(e.currentTarget.value);
    }, [
        passwordFieldError,
        setPasswordFieldError,
        setPassword
    ]);
    const buttonContent = ()=>{
        if (!isSecondStep) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "login.form.continue",
            defaultMessage: "Continue"
        });
        if (isPasswordlessAllowed) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "common.login.with.password",
            defaultMessage: "Log in with password"
        });
        return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "common.login",
            defaultMessage: "Log in"
        });
    };
    const infoContent = ()=>{
        const { formatMessage: formatMessage } = intl;
        const applicationName = application ? (0, $fcxz7.applicationsMetadata)[application].name : 'Product';
        const testId = 'login-info-test-id';
        if (info) switch(info.code){
            case 'migratingExistingUser':
                {
                    const summary = formatMessage((0, $hXPGK.default).migrateAccountInfo, {
                        application: applicationName
                    });
                    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $9TeuV.default), {
                        id: "login-info",
                        "data-testid": testId,
                        children: summary
                    });
                }
            case 'existingUserSignupAttempt':
                {
                    const summary = formatMessage((0, $hXPGK.default).existingUserSignupAttemptInfo);
                    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $9TeuV.default), {
                        id: "login-info",
                        "data-testid": testId,
                        children: summary
                    });
                }
            default:
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $9TeuV.default), {
                    id: "login-info",
                    "data-testid": testId,
                    isHidden: true,
                    children: ' '
                });
        }
    };
    (0, $dNMDr.useEffect)(()=>{
        analyticsClient.stopInitialLoadApdexEvent('viewLoginPage');
    }, [
        analyticsClient
    ]);
    const emailError = ()=>{
        switch(fieldErrors.email){
            case 'unknown':
                return intl.formatMessage((0, $hXPGK.default).unexpectedErrorHappened);
            case 'rate_limit_exceeded_message':
                return intl.formatMessage((0, $hXPGK.default).rateLimitErrorMessage);
            default:
                return translatedEmailFieldError;
        }
    };
    const renderExperimentButtons = ()=>{
        if (redirectType === (0, $chJxj.CheckUserNameRedirectType).Sso) return /*#__PURE__*/ (0, $6CtE1.jsxs)($ccc4e3949cf7b086$export$d55ce944e082b58f, {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "login.form.opening.sso",
                    defaultMessage: "Opening your single sign-on provider"
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3Wc5s.default), {})
            ]
        });
        else return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
            appearance: "primary",
            id: "login-submit",
            testId: "login-submit-idf-testid",
            type: "submit",
            isFullWidth: true,
            isDisabled: isSecondStep && isTooManyAttemptsRecaptchaRequired && !captchaValue,
            isLoading: buttonClicked === 'submit' && (!!isRedirecting || isLoading || isCheckUsernameLoading),
            children: buttonContent()
        });
    };
    const { formatMessage: formatMessage } = intl;
    return /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
        children: [
            (0, $hhYxc.isFedM)() && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8GnY0.default), {
                context: "login-form"
            }),
            error && !isLoading && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gre8I.default), {
                children: error?.message
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("span", {
                children: infoContent()
            }),
            onRedirectToSingleSignOn && !isSecondStep && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8IkGb.default), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                    testId: "login-single-sign-on-button-idf-testid",
                    type: "button",
                    onClick: onRedirectToSingleSignOn,
                    isFullWidth: true,
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "login.form.button.redirect.sso",
                        defaultMessage: "Log in with single sign-on"
                    })
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)($ccc4e3949cf7b086$export$a7fed597f4b8afd8, {
                id: "form-login",
                "data-testid": "form-login",
                onSubmit: handleSubmit,
                onClick: onFormClick,
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsxs)($ccc4e3949cf7b086$var$InputsWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hfwZH.default), {
                                fieldViewType: $ccc4e3949cf7b086$var$getEmailFieldViewType(restrictedEmail, redirectType, isSecondStep, isLoading),
                                fieldError: emailError(),
                                onChange: onEmailChange,
                                value: email,
                                onEmailClick: onEmailClick,
                                placeholderOverride: formatMessage((0, $hXPGK.default).emailPlaceholder),
                                inputRef: inputRef
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8LTuC.default), {
                                isHidden: !isSecondStep,
                                fieldError: passwordFieldError || undefined,
                                onChange: handlePasswordChange,
                                value: password,
                                className: `field-group password-field ${isSecondStep ? 'expanded' : 'hidden'}`,
                                isRequired: isSecondStep
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $iQMMg.LoginRecaptcha), {}),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3v21n.LoginMarketingConsent), {}),
                            showRememberMeCheckbox && redirectType !== (0, $chJxj.CheckUserNameRedirectType).Sso && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8IkGb.default), {
                                paddingBlockStart: "space.100",
                                paddingBlockEnd: "space.100",
                                children: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $4JRmj.default), {
                                    direction: "row",
                                    gap: "space.050",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5bOZS.default), {
                                            testId: "remember-me-checkbox",
                                            isChecked: rememberMeChecked,
                                            onClick: onToggleRememberMeCheckbox,
                                            name: "remember",
                                            label: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                                ...(0, $hXPGK.default).rememberMeCheckboxLabel
                                            }),
                                            // During the redirect process (and while loading), we want to disable the checkbox so that the user doesn't interact with the checkbox.
                                            isDisabled: buttonClicked === 'submit' && (!!isRedirecting || isLoading || isCheckUsernameLoading)
                                        }),
                                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cr5CS.default), {
                                            spacing: "compact",
                                            appearance: "info",
                                            iconLabel: formatMessage((0, $hXPGK.default).rememberMeMoreInfoLabel),
                                            placement: "right",
                                            fallbackPlacements: [
                                                'bottom'
                                            ],
                                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                                ...(0, $hXPGK.default).rememberMeTooltip
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    renderExperimentButtons(),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6i4Wm.default), {
                        isHidden: !isSecondStep || !isPasswordlessAllowed,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $4Cmcw.StyledSocialLoginButton), {
                            id: "passwordless-button",
                            iconBefore: /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gODCJ))), {
                                label: "email"
                            }),
                            iconAfter: /*#__PURE__*/ (0, $6CtE1.jsx)("span", {
                                style: {
                                    width: 24
                                }
                            }),
                            isFullWidth: true,
                            advisoryEnabled: false,
                            onClick: handlePasswordlessButtonClick,
                            isLoading: buttonClicked === 'passwordless' && (!!isRedirecting || isLoading),
                            isDisabled: isTooManyAttemptsRecaptchaRequired && !captchaValue || isLoading || isRedirecting,
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                id: "login.form.passwordless.button",
                                defaultMessage: "Log in with email"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $ccc4e3949cf7b086$export$2e2bcd8739ae039 = $ccc4e3949cf7b086$export$1f58f750f20f344b;

});
parcelRegister("gODCJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3e00d51f4b7a932$var$_react = $c3e00d51f4b7a932$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $gsWOv = parcelRequire("gsWOv");

var $c3e00d51f4b7a932$var$_email = $c3e00d51f4b7a932$var$_interopRequireDefault((parcelRequire("l6XI2")));
function $c3e00d51f4b7a932$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c3e00d51f4b7a932$var$EmailIcon = (props)=>/*#__PURE__*/ $c3e00d51f4b7a932$var$_react.default.createElement($gsWOv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $c3e00d51f4b7a932$var$_email.default
    }));
$c3e00d51f4b7a932$var$EmailIcon.displayName = 'EmailIcon';
var $c3e00d51f4b7a932$var$_default = module.exports.default = $c3e00d51f4b7a932$var$EmailIcon;

});
parcelRegister("l6XI2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5e8798c55e4c483$var$_react = $f5e8798c55e4c483$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $f5e8798c55e4c483$var$_baseNew = $f5e8798c55e4c483$var$_interopRequireDefault((parcelRequire("9LaLF")));
function $f5e8798c55e4c483$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5e8798c55e4c483$var$EmailIcon = (props)=>/*#__PURE__*/ $f5e8798c55e4c483$var$_react.default.createElement($f5e8798c55e4c483$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$f5e8798c55e4c483$var$EmailIcon.displayName = 'EmailIcon';
var $f5e8798c55e4c483$var$_default = module.exports.default = $f5e8798c55e4c483$var$EmailIcon;

});


parcelRegister("hfwZH", function(module, exports) {

$parcel$export(module.exports, "FieldViewType", function () { return $25be098454f76f30$export$63009c89ca139043; });
$parcel$export(module.exports, "default", function () { return $25be098454f76f30$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $kvy9X = parcelRequire("kvy9X");

var $6i4Wm = parcelRequire("6i4Wm");

var $fFbFo = parcelRequire("fFbFo");

var $ko1o6 = parcelRequire("ko1o6");
parcelRequire("jM5Ly");
var $hMPjy = parcelRequire("hMPjy");

var $dpTxl = parcelRequire("dpTxl");

var $5hZmm = parcelRequire("5hZmm");
const $25be098454f76f30$var$IconButtonWrapper = (0, $fbSBq.default).div`
  padding: 3px;
  margin-left: -1px;
`;
var $25be098454f76f30$export$63009c89ca139043 = /*#__PURE__*/ function(FieldViewType) {
    FieldViewType["Editable"] = "editable";
    FieldViewType["ReadOnlyWithEditButton"] = "read-only-with-edit-button";
    FieldViewType["Restricted"] = "restricted";
    return FieldViewType;
}({});
const $25be098454f76f30$var$EmailContainer = ({ fieldError: fieldError, fieldViewType: fieldViewType, onChange: onChange, onEmailClick: onEmailClick, placeholderOverride: placeholderOverride, value: value, inputRef: inputRef })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const isEditable = fieldViewType === "editable";
    const prevIsReadOnly = (0, $hMPjy.usePrevious)(!isEditable);
    (0, $dNMDr.useEffect)(()=>{
        if (isEditable && prevIsReadOnly) inputRef.current?.focus();
    }, [
        isEditable,
        prevIsReadOnly,
        inputRef
    ]);
    const handleChange = (e)=>{
        const newValue = e.currentTarget.value;
        onChange(newValue);
    };
    const placeholder = placeholderOverride || formatMessage((0, $fFbFo.default).loginFormUsernamePlaceholder);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6i4Wm.default), {
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kvy9X.default), {
            testId: "username" // used in pollinators
            ,
            name: "username",
            autoComplete: "username",
            type: "email",
            placeholder: placeholder,
            label: formatMessage((0, $fFbFo.default).loginFormUsernameLabel),
            autoFocus: isEditable,
            onChange: handleChange,
            isInvalid: !!fieldError,
            invalidMessage: fieldError,
            value: value,
            ref: inputRef,
            isRequired: true,
            isDisabled: !isEditable,
            elemAfterInput: fieldViewType === "read-only-with-edit-button" && /*#__PURE__*/ (0, $6CtE1.jsx)($25be098454f76f30$var$IconButtonWrapper, {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dpTxl.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5hZmm))),
                    label: formatMessage((0, $fFbFo.default).loginFormReadOnlyUsernameAriaLabel),
                    onClick: onEmailClick,
                    appearance: "subtle"
                })
            })
        })
    });
};
var $25be098454f76f30$export$2e2bcd8739ae039 = $25be098454f76f30$var$EmailContainer;

});
parcelRegister("5hZmm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d9e230282ba7d60$var$_react = $3d9e230282ba7d60$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $gsWOv = parcelRequire("gsWOv");

var $3d9e230282ba7d60$var$_edit = $3d9e230282ba7d60$var$_interopRequireDefault((parcelRequire("cxK6n")));
function $3d9e230282ba7d60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3d9e230282ba7d60$var$EditIcon = (props)=>/*#__PURE__*/ $3d9e230282ba7d60$var$_react.default.createElement($gsWOv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $3d9e230282ba7d60$var$_edit.default
    }));
$3d9e230282ba7d60$var$EditIcon.displayName = 'EditIcon';
var $3d9e230282ba7d60$var$_default = module.exports.default = $3d9e230282ba7d60$var$EditIcon;

});
parcelRegister("cxK6n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $921c53f9b45c4ab6$var$_react = $921c53f9b45c4ab6$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $921c53f9b45c4ab6$var$_baseNew = $921c53f9b45c4ab6$var$_interopRequireDefault((parcelRequire("9LaLF")));
function $921c53f9b45c4ab6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $921c53f9b45c4ab6$var$EditIcon = (props)=>/*#__PURE__*/ $921c53f9b45c4ab6$var$_react.default.createElement($921c53f9b45c4ab6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$921c53f9b45c4ab6$var$EditIcon.displayName = 'EditIcon';
var $921c53f9b45c4ab6$var$_default = module.exports.default = $921c53f9b45c4ab6$var$EditIcon;

});



parcelRegister("8LTuC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $676223b129f04821$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $6i4Wm = parcelRequire("6i4Wm");

var $ckdYh = parcelRequire("ckdYh");

var $kpuOE = parcelRequire("kpuOE");

var $ko1o6 = parcelRequire("ko1o6");
parcelRequire("jM5Ly");
var $hMPjy = parcelRequire("hMPjy");
const $676223b129f04821$var$PasswordContainer = ({ className: className, fieldError: fieldError, isHidden: isHidden, onChange: onChange, value: value, isRequired: isRequired = false })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const inputRef = (0, $dNMDr.useRef)(null);
    const wasHidden = (0, $hMPjy.usePrevious)(isHidden);
    (0, $dNMDr.useEffect)(()=>{
        if (!isHidden && wasHidden) inputRef.current?.focus();
    }, [
        isHidden,
        wasHidden
    ]);
    const fieldErrorNode = fieldError && /*#__PURE__*/ (0, $6CtE1.jsx)("span", {
        id: "password-error",
        "data-testid": "password-error-idf-testid" // used in pollinators
        ,
        children: fieldError
    });
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6i4Wm.default), {
        isHidden: isHidden,
        className: className,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ckdYh.default), {
            id: "password",
            testId: "password" // used in pollinators
            ,
            name: "password",
            autoComplete: "current-password",
            placeholder: formatMessage((0, $kpuOE.default).passwordPlaceholder),
            label: formatMessage((0, $kpuOE.default).passwordLabel),
            autoFocus: !isHidden,
            onChange: onChange,
            isInvalid: !!fieldError,
            invalidMessage: fieldErrorNode,
            value: value,
            ref: inputRef,
            isRequired: isRequired
        })
    });
};
var $676223b129f04821$export$2e2bcd8739ae039 = $676223b129f04821$var$PasswordContainer;

});

parcelRegister("9TeuV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1218dbf1565bb6b$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");
const $d1218dbf1565bb6b$var$FormInfo = (0, $fbSBq.default).div`
  color: ${(0, $l4KzN).N700};
  font-size: 13px;
  line-height: 17px;
  margin-bottom: 24px;
  margin-top: -4px;
  transform: rotateX(0deg);
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-bottom, opacity, transform, padding;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;
  text-align: center;

  &.hidden {
    height: 0;
    margin-bottom: 0;
    opacity: 0;
    padding: 0 ${(0, $68HQw.gridSize)() * 2}px;
    pointer-events: none;
    transform: rotateX(-90deg);
    visibility: hidden;
  }
`;
const $d1218dbf1565bb6b$var$FormInfoComponent = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $6CtE1.jsx)($d1218dbf1565bb6b$var$FormInfo, {
        role: "alert",
        ...props,
        className: props.isHidden ? 'hidden' : '',
        children: children
    });
};
var $d1218dbf1565bb6b$export$2e2bcd8739ae039 = $d1218dbf1565bb6b$var$FormInfoComponent;

});

parcelRegister("4Cmcw", function(module, exports) {

$parcel$export(module.exports, "SocialLoginOptionWrapper", function () { return $12055e79a0aeb7eb$export$84dac62724cf046; });
$parcel$export(module.exports, "SocialLoginButton", function () { return $12055e79a0aeb7eb$export$e42ebbbcc1226808; });
$parcel$export(module.exports, "SocialLoginButtonRowGroup", function () { return $12055e79a0aeb7eb$export$b2f108f5851fd592; });
$parcel$export(module.exports, "SocialLoginPanelWrapper", function () { return $12055e79a0aeb7eb$export$e61ba37bbdbb1966; });
$parcel$export(module.exports, "StyledSocialLoginButton", function () { return $12055e79a0aeb7eb$export$27110045cf7ea8db; });
$parcel$export(module.exports, "default", function () { return $12055e79a0aeb7eb$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");
parcelRequire("dNMDr");

var $ko1o6 = parcelRequire("ko1o6");

var $fbSBq = parcelRequire("fbSBq");

var $iEoRg = parcelRequire("iEoRg");

var $ef3n6 = parcelRequire("ef3n6");

var $4lIXK = parcelRequire("4lIXK");

var $jwUri = parcelRequire("jwUri");

var $7SvfM = parcelRequire("7SvfM");

var $bjwN5 = parcelRequire("bjwN5");

var $2byD0 = parcelRequire("2byD0");

var $kJPFV = parcelRequire("kJPFV");

var $6fFGM = parcelRequire("6fFGM");

var $1f6ly = parcelRequire("1f6ly");

var $ei3NI = parcelRequire("ei3NI");
const $12055e79a0aeb7eb$export$969af4902a13348e = ({ handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const dynamicConfigs = (0, $ei3NI.useDynamicConfigs)();
    const googleOutageEnabled = (0, $7SvfM.isGoogleLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const microsoftOutageEnabled = (0, $7SvfM.isMicrosoftLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const appleOutageEnabled = (0, $7SvfM.isAppleLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const slackOutageEnabled = (0, $7SvfM.isSlackLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const isSocialLoginOutage = googleOutageEnabled || microsoftOutageEnabled || appleOutageEnabled || slackOutageEnabled;
    const getAdvisorySectionMessage = ()=>{
        const multipleOutages = [
            googleOutageEnabled,
            microsoftOutageEnabled,
            appleOutageEnabled,
            slackOutageEnabled
        ].filter(Boolean).length > 1;
        const sectionMessageTitle = multipleOutages ? formatMessage((0, $bjwN5.default).someOutageTitle) : getAdvisorySectionMessageTitle();
        const sectionMessageDescription = multipleOutages ? formatMessage((0, $bjwN5.default).someOutageDescription) : getAdvisorySectionMessageDescription();
        return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kJPFV.default), {
            testId: "social-login-outage-section-message",
            title: sectionMessageTitle,
            appearance: "warning",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)("p", {
                children: sectionMessageDescription
            })
        });
    };
    const getAdvisorySectionMessageTitle = ()=>googleOutageEnabled ? formatMessage((0, $bjwN5.default).googleOutageTitle) : microsoftOutageEnabled ? formatMessage((0, $bjwN5.default).microsoftOutageTitle) : appleOutageEnabled ? formatMessage((0, $bjwN5.default).appleOutageTitle) : slackOutageEnabled ? formatMessage((0, $bjwN5.default).slackOutageTitle) : formatMessage((0, $bjwN5.default).someOutageTitle);
    const getAdvisorySectionMessageDescription = ()=>googleOutageEnabled ? formatMessage((0, $bjwN5.default).googleOutageDescription) : microsoftOutageEnabled ? formatMessage((0, $bjwN5.default).microsoftOutageDescription) : appleOutageEnabled ? formatMessage((0, $bjwN5.default).appleOutageDescription) : slackOutageEnabled ? formatMessage((0, $bjwN5.default).slackOutageDescription) : formatMessage((0, $bjwN5.default).someOutageDescription);
    const handleGoogleLoginOnClick = ()=>{
        handleGoogleLogin();
    };
    const GoogleButton = ()=>/*#__PURE__*/ (0, $6CtE1.jsx)($12055e79a0aeb7eb$export$84dac62724cf046, {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)($12055e79a0aeb7eb$export$e42ebbbcc1226808, {
                id: "google-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($ef3n6))),
                onClick: handleGoogleLoginOnClick,
                advisoryEnabled: googleOutageEnabled,
                outageTooltipMessage: formatMessage((0, $bjwN5.default).googleOutageDescription),
                children: "Google"
            })
        });
    const MicrosoftButton = ()=>/*#__PURE__*/ (0, $6CtE1.jsx)($12055e79a0aeb7eb$export$84dac62724cf046, {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)($12055e79a0aeb7eb$export$e42ebbbcc1226808, {
                id: "microsoft-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($4lIXK))),
                onClick: handleMicrosoftLogin,
                advisoryEnabled: microsoftOutageEnabled,
                outageTooltipMessage: formatMessage((0, $bjwN5.default).microsoftOutageDescription),
                children: "Microsoft"
            })
        });
    const AppleButton = ()=>/*#__PURE__*/ (0, $6CtE1.jsx)($12055e79a0aeb7eb$export$84dac62724cf046, {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)($12055e79a0aeb7eb$export$e42ebbbcc1226808, {
                id: "apple-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($iEoRg))),
                onClick: handleAppleLogin,
                advisoryEnabled: appleOutageEnabled,
                outageTooltipMessage: formatMessage((0, $bjwN5.default).appleOutageDescription),
                children: "Apple"
            })
        });
    const SlackButton = ()=>/*#__PURE__*/ (0, $6CtE1.jsx)($12055e79a0aeb7eb$export$84dac62724cf046, {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)($12055e79a0aeb7eb$export$e42ebbbcc1226808, {
                id: "slack-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($jwUri))),
                onClick: handleSlackLogin,
                advisoryEnabled: slackOutageEnabled,
                outageTooltipMessage: formatMessage((0, $bjwN5.default).slackOutageDescription),
                children: "Slack"
            })
        });
    const showButtonsGridLayout = ()=>/*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsxs)($12055e79a0aeb7eb$export$b2f108f5851fd592, {
                    "data-testid": "social-login-button-row",
                    children: [
                        GoogleButton(),
                        MicrosoftButton()
                    ]
                }),
                /*#__PURE__*/ (0, $6CtE1.jsxs)($12055e79a0aeb7eb$export$b2f108f5851fd592, {
                    "data-testid": "social-login-button-row",
                    children: [
                        AppleButton(),
                        SlackButton()
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $6CtE1.jsxs)($12055e79a0aeb7eb$export$e61ba37bbdbb1966, {
        role: "list",
        "data-i18n-or": formatMessage((0, $bjwN5.default).socialAuthOr),
        "data-i18n-continue": formatMessage((0, $bjwN5.default).socialAuthOrContinueWith),
        className: "google-login social-login",
        "data-testid": "social-login-wrapper",
        children: [
            showButtonsGridLayout(),
            isSocialLoginOutage && getAdvisorySectionMessage()
        ]
    });
};
const $12055e79a0aeb7eb$export$e61ba37bbdbb1966 = (0, $fbSBq.default).ul`
  margin-top: ${(0, $68HQw.gridSize)() * 3}px;
  list-style: none;
  padding-inline: 0;
  margin-block-end: 0;
  &::before {
    color: ${(0, $l4KzN).N300};
    content: attr(data-i18n-continue);
    display: block;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: ${(0, $68HQw.gridSize)() * 2}px;
    font-weight: 600;
    text-align: center;
  }
`;
const $12055e79a0aeb7eb$export$b2f108f5851fd592 = (0, $fbSBq.default).div`
  &:not(:last-child) {
    margin-bottom: ${(0, $68HQw.gridSize)() * 2}px;
  }
`;
const $12055e79a0aeb7eb$export$84dac62724cf046 = (0, $fbSBq.default).li`
  &:not(:last-child) {
    margin-bottom: ${(0, $68HQw.gridSize)() * 2}px;
  }
`;
const $12055e79a0aeb7eb$export$e42ebbbcc1226808 = ({ children: children, logo: logo, advisoryEnabled: advisoryEnabled, outageTooltipMessage: outageTooltipMessage, ...props })=>{
    const commonProps = {
        isFullWidth: true,
        iconBefore: logo ? /*#__PURE__*/ (0, $6CtE1.jsx)("img", {
            src: logo,
            alt: ""
        }) : undefined
    };
    if (advisoryEnabled) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $1f6ly.default), {
        testId: "social-auth-button-tooltip",
        content: outageTooltipMessage,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)($12055e79a0aeb7eb$export$27110045cf7ea8db, {
            advisoryEnabled: true,
            iconAfter: /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6fFGM))), {
                testId: "social-auth-button-warning-icon",
                label: "",
                primaryColor: (0, $l4KzN).Y500,
                secondaryColor: (0, $l4KzN).Y50
            }),
            ...commonProps,
            ...props,
            children: children
        })
    });
    else return /*#__PURE__*/ (0, $6CtE1.jsx)($12055e79a0aeb7eb$export$27110045cf7ea8db, {
        advisoryEnabled: false,
        ...commonProps,
        ...props,
        children: children
    });
};
const $12055e79a0aeb7eb$export$27110045cf7ea8db = (0, $fbSBq.default)((0, $2byD0.default), {
    shouldForwardProp: (propName)=>![
            'advisoryEnabled'
        ].includes(propName)
})`
  background: ${(props)=>props.advisoryEnabled ? (0, $l4KzN).Y50 : (0, $l4KzN).N0} !important;
  box-shadow: none;
  font-weight: bold;
  border: 1px solid ${(0, $l4KzN).N50};
  border-radius: 3px;
  color: ${(0, $l4KzN).N800};
  span {
    flex-grow: unset;
  }

  &:not(:last-child) {
    margin-bottom: ${(0, $68HQw.gridSize)() * 0.5}px;
  }

  &:hover {
    background: ${(0, $l4KzN).N10A} !important;
  }
  &:active {
    background: ${(0, $l4KzN).N20A} !important;
    color: ${(0, $l4KzN).N400} !important;
  }
  &:focus {
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.2), 0 0 0 2px rgba(38, 132, 255, 0.6) !important;
  }
  img {
    height: 24px;
    width: 24px;
    margin-right: 6px;
  }
`;
var $12055e79a0aeb7eb$export$2e2bcd8739ae039 = $12055e79a0aeb7eb$export$969af4902a13348e;

});
parcelRegister("iEoRg", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "apple-logo.23825a4f.svg";

});

parcelRegister("ef3n6", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "google-logo.5462b711.svg";

});

parcelRegister("4lIXK", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "microsoft-logo.c73d8dca.svg";

});

parcelRegister("jwUri", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "slack-logo.9621bf1a.svg";

});

parcelRegister("bjwN5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a725780e8fd198fa$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $a725780e8fd198fa$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    socialAuthOr: {
        id: 'social.auth.or',
        defaultMessage: 'or'
    },
    socialAuthOrContinueWith: {
        id: 'social.auth.or-continue-with',
        defaultMessage: 'Or continue with:'
    },
    socialAuthContinue: {
        id: 'social.auth.continue',
        defaultMessage: 'Or continue with',
        description: `Precedes third party login buttons. For example, "Or continue with Google"`
    },
    someOutageTitle: {
        id: 'some.outage.title',
        defaultMessage: 'Issues with some login options',
        description: 'Message to the user that there are currently issues logging in with some providers due to an outage'
    },
    googleOutageTitle: {
        id: 'google.outage.title',
        defaultMessage: 'Issues with Google login',
        description: 'Message to the user that there are currently issues logging in with Google due to an outage'
    },
    microsoftOutageTitle: {
        id: 'microsoft.outage.title',
        defaultMessage: 'Issues with Microsoft login',
        description: 'Message to the user that there are currently issues logging in with Microsoft due to an outage'
    },
    appleOutageTitle: {
        id: 'apple.outage.title',
        defaultMessage: 'Issues with Apple login',
        description: 'Message to the user that there are currently issues logging in with Apple due to an outage'
    },
    slackOutageTitle: {
        id: 'slack.outage.title',
        defaultMessage: 'Issues with Slack login',
        description: 'Message to the user that there are currently issues logging in with Slack due to an outage'
    },
    someOutageDescription: {
        id: 'some.outage.description',
        defaultMessage: 'Some login options are experiencing issues at the moment. You may be able to log in or sign up with your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with due to a login provider outage'
    },
    googleOutageDescription: {
        id: 'google.outage.description',
        defaultMessage: 'There are issues with Google login and signup at the moment. If you are unable to continue with Google, you may be able to use your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with Google due to an outage'
    },
    microsoftOutageDescription: {
        id: 'microsoft.outage.description',
        defaultMessage: 'There are issues with Microsoft login and signup at the moment. If you are unable to continue with Microsoft, you may be able to use your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with Microsoft due to an outage'
    },
    appleOutageDescription: {
        id: 'apple.outage.description',
        defaultMessage: 'There are issues with Apple login and signup at the moment. If you are unable to continue with Apple, you may be able to use your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with Apple due to an outage'
    },
    slackOutageDescription: {
        id: 'slack.outage.description',
        defaultMessage: 'There are issues with Slack login and signup at the moment. If you are unable to continue with Slack, you may be able to use your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with Slack due to an outage'
    }
});

});

parcelRegister("6fFGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48d47b5817344319$var$_react = $48d47b5817344319$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $gsWOv = parcelRequire("gsWOv");

var $48d47b5817344319$var$_statusWarning = $48d47b5817344319$var$_interopRequireDefault((parcelRequire("dmvR6")));
function $48d47b5817344319$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $48d47b5817344319$var$WarningIcon = (props)=>/*#__PURE__*/ $48d47b5817344319$var$_react.default.createElement($gsWOv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $48d47b5817344319$var$_statusWarning.default
    }));
$48d47b5817344319$var$WarningIcon.displayName = 'WarningIcon';
var $48d47b5817344319$var$_default = module.exports.default = $48d47b5817344319$var$WarningIcon;

});
parcelRegister("dmvR6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435e803a057e79e21a0d31c5b12f3f81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ba60a4c753cb81f$var$_react = $9ba60a4c753cb81f$var$_interopRequireDefault((parcelRequire("dNMDr")));

var $9ba60a4c753cb81f$var$_baseNew = $9ba60a4c753cb81f$var$_interopRequireDefault((parcelRequire("9LaLF")));
function $9ba60a4c753cb81f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ba60a4c753cb81f$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $9ba60a4c753cb81f$var$_react.default.createElement($9ba60a4c753cb81f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$9ba60a4c753cb81f$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $9ba60a4c753cb81f$var$_default = module.exports.default = $9ba60a4c753cb81f$var$StatusWarningIcon;

});



parcelRegister("iQMMg", function(module, exports) {

$parcel$export(module.exports, "LoginRecaptcha", function () { return $3d2e2d133b68ff4a$export$1e978f900466132e; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $aMBBA = parcelRequire("aMBBA");

var $e9NKT = parcelRequire("e9NKT");

var $fhwYP = parcelRequire("fhwYP");

var $hzllM = parcelRequire("hzllM");

var $kcNti = parcelRequire("kcNti");
parcelRequire("jM5Ly");
var $hMPjy = parcelRequire("hMPjy");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");
const $3d2e2d133b68ff4a$export$1e978f900466132e = ()=>{
    (0, $kfOJC.useRegisterComponent)($3d2e2d133b68ff4a$export$1e978f900466132e.name);
    const { enabled: recaptchaEnabled, component: recaptchaComponent } = (0, $hzllM.useRecaptchaContext)();
    const isSecondStep = (0, $aMBBA.useAppSelector)((state)=>state.login?.isUsernameChecked);
    const isCaptchaRequired = (0, $aMBBA.useAppSelector)((state)=>state.login?.isCaptchaRequired);
    const shouldRenderCheckUsernameRecaptcha = !isSecondStep && recaptchaEnabled && recaptchaComponent;
    const { setCaptchaValue: setCaptchaValue } = (0, $kcNti.useLoginTooManyAttemptsRecaptchaContext)();
    const shouldRenderTooManyAttemptsRecaptcha = isSecondStep && isCaptchaRequired;
    const prevIsCaptchaRequired = (0, $hMPjy.usePrevious)(isCaptchaRequired);
    (0, $dNMDr.useEffect)(()=>{
        if (prevIsCaptchaRequired && !isCaptchaRequired) setCaptchaValue(null);
    }, [
        isCaptchaRequired,
        prevIsCaptchaRequired,
        setCaptchaValue
    ]);
    const isCaptchaEnabledByConfig = (0, $aMBBA.useAppSelector)((state)=>state.appConfig?.recaptchaEnable);
    const recaptchaEnterpriseCheckboxKeySite = (0, $aMBBA.useAppSelector)((state)=>state.appConfig?.recaptchaEnterpriseCheckboxKeySite);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6CtE1.Fragment), {
        children: isCaptchaEnabledByConfig && (shouldRenderCheckUsernameRecaptcha ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $fhwYP.default), {
            children: recaptchaComponent
        }) : shouldRenderTooManyAttemptsRecaptcha && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $fhwYP.default), {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $e9NKT.default), {
                sitekey: recaptchaEnterpriseCheckboxKeySite,
                onChange: setCaptchaValue
            })
        }))
    });
};

});
parcelRegister("e9NKT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc5d3bdea20fc63b$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $5adZ3 = parcelRequire("5adZ3");

var $hqddj = parcelRequire("hqddj");
const $bc5d3bdea20fc63b$export$c8e68dd3bf26af81 = /*#__PURE__*/ (0, $dNMDr.forwardRef)(function ReCAPTCHAEnterprise(props, ref) {
    const { grecaptcha: grecaptcha, onChange: onChange, onErrored: onErrored, onExpired: onExpired, size: size, sitekey: sitekey, action: action } = props;
    const enterprise = grecaptcha?.enterprise;
    const [widgetId, setWidgetId] = (0, $dNMDr.useState)();
    const containerRef = (0, $dNMDr.useRef)(null);
    const hasRendered = (0, $dNMDr.useRef)(false);
    /**
     * The execution callbacks and states (hasRequest, resetRequired) etc.
     * are being tracked in a useRef since we don't want to react to its changes
     * but need to track it in-between renders.
     */ const executionRef = (0, $dNMDr.useRef)({
        hasRequested: false,
        resetRequired: false
    });
    const resetExecutionHandlers = (0, $dNMDr.useCallback)(()=>{
        delete executionRef.current.onResolve;
        delete executionRef.current.onReject;
    }, []);
    const reset = (0, $dNMDr.useCallback)(()=>{
        if (enterprise && typeof widgetId === 'number') enterprise.reset(widgetId);
    }, [
        enterprise,
        widgetId
    ]);
    const handleError = (0, $dNMDr.useCallback)((cause)=>{
        if (onErrored) onErrored();
        if (executionRef.current?.onReject) {
            executionRef.current.onReject(new Error(`ReCAPTCHAEnterprise rejected due to: ${cause}`, {
                cause: cause
            }));
            resetExecutionHandlers();
        }
    }, [
        onErrored,
        resetExecutionHandlers
    ]);
    const handleChange = (0, $dNMDr.useCallback)((token)=>{
        if (onChange) onChange(token);
        if (!token) handleError('no-token');
        else if (executionRef.current?.onResolve) {
            executionRef.current.onResolve(token);
            resetExecutionHandlers();
        }
    }, [
        handleError,
        onChange,
        resetExecutionHandlers
    ]);
    const handleExpired = (0, $dNMDr.useCallback)(()=>{
        if (onExpired) {
            onExpired();
            if (executionRef.current?.onReject) {
                executionRef.current.onReject(new Error('ReCAPTCHAEnterprise rejected due to expired token'));
                resetExecutionHandlers();
            }
        } else handleChange(null);
    }, [
        handleChange,
        onExpired,
        resetExecutionHandlers
    ]);
    const execute = (0, $dNMDr.useCallback)((targetWidgetId)=>{
        const id = typeof targetWidgetId === 'undefined' ? widgetId : targetWidgetId;
        if (enterprise && id !== undefined) {
            // Tokens are cached, reset is needed after first execute
            if (executionRef.current?.resetRequired) reset();
            executionRef.current.resetRequired = true;
            enterprise.execute(id);
        } else executionRef.current.hasRequested = true;
    }, [
        enterprise,
        reset,
        widgetId
    ]);
    const renderExplicit = (0, $dNMDr.useCallback)(()=>{
        if (!sitekey) {
            (0, $hqddj.captureErrorMessage)('ReCAPTCHAEnterprise: recaptcha enterprise site key not provided');
            return;
        }
        // Check if grecaptcha is available and if it hasn't been rendered already
        if (!enterprise?.render || widgetId !== undefined || hasRendered.current) return;
        const wrapper = document.createElement('div');
        const id = enterprise.render(wrapper, {
            sitekey: sitekey,
            action: action,
            size: size,
            callback: handleChange,
            'expired-callback': handleExpired,
            'error-callback': ()=>// NOTE: recaptcha script does not provide a value to this callback: https://cloud.google.com/recaptcha/docs/api-ref-checkbox-keys#attributes_parameters
                // This is just our own error handler
                handleError('script invoked error-callback')
        });
        setWidgetId(id);
        containerRef.current.appendChild(wrapper);
        if (executionRef.current?.hasRequested) {
            executionRef.current.hasRequested = false;
            execute(id);
        }
        hasRendered.current = true;
    }, [
        action,
        enterprise,
        execute,
        handleChange,
        handleError,
        handleExpired,
        sitekey,
        size,
        widgetId
    ]);
    (0, $dNMDr.useEffect)(()=>{
        /**
       * This has to run on every render, hence why there is no dependency array.
       * renderExplicit was called on componentDidMount & componentDidUpdate when it was a class component.
       */ renderExplicit();
    });
    (0, $dNMDr.useEffect)(()=>{
        const delayOfCaptchaIframeRemoving = ()=>{
            const temporaryNode = document.createElement('div');
            document.body.appendChild(temporaryNode);
            temporaryNode.style.display = 'none';
            // move of the recaptcha to a temporary node
            while(containerRef.current?.firstChild)temporaryNode.appendChild(containerRef.current.firstChild);
            // delete the temporary node after reset will be done
            setTimeout(()=>document.body.removeChild(temporaryNode), 5000);
        };
        return ()=>{
            if (widgetId !== undefined) {
                delayOfCaptchaIframeRemoving();
                reset();
                hasRendered.current = false;
            }
        };
    }, [
        reset,
        widgetId
    ]);
    (0, $dNMDr.useImperativeHandle)(ref, ()=>({
            executeAsync () {
                return new Promise((resolve, reject)=>{
                    executionRef.current.onResolve = resolve;
                    executionRef.current.onReject = reject;
                    execute();
                });
            }
        }), [
        execute
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
        "data-testid": "ReCAPTCHAEnterprise",
        ref: containerRef
    });
});
var $bc5d3bdea20fc63b$export$2e2bcd8739ae039 = (0, $5adZ3.default)(()=>'https://www.recaptcha.net/recaptcha/enterprise.js?onload=onloadcallback&render=explicit', {
    callbackName: 'onloadcallback',
    globalName: 'grecaptcha'
})($bc5d3bdea20fc63b$export$c8e68dd3bf26af81);

});
parcelRegister("5adZ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c28bbcbae54a390$export$2e2bcd8739ae039; });

var $dNMDr = parcelRequire("dNMDr");

var $Jc9ZC = parcelRequire("Jc9ZC");

var $cy8cW = parcelRequire("cy8cW");
function $3c28bbcbae54a390$var$_extends() {
    $3c28bbcbae54a390$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3c28bbcbae54a390$var$_extends.apply(this, arguments);
}
function $3c28bbcbae54a390$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3c28bbcbae54a390$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3c28bbcbae54a390$var$SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var $3c28bbcbae54a390$var$idCount = 0;
function $3c28bbcbae54a390$export$2e2bcd8739ae039(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            $3c28bbcbae54a390$var$_inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + $3c28bbcbae54a390$var$idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = $3c28bbcbae54a390$var$SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") $3c28bbcbae54a390$var$SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if ($3c28bbcbae54a390$var$SCRIPT_MAP[scriptURL]) {
                    var entry = $3c28bbcbae54a390$var$SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                $3c28bbcbae54a390$var$SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                for(var attribute in options.attributes)script.setAttribute(attribute, options.attributes[attribute]);
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if ($3c28bbcbae54a390$var$SCRIPT_MAP[scriptURL]) {
                        var mapEntry = $3c28bbcbae54a390$var$SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = $3c28bbcbae54a390$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = $3c28bbcbae54a390$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = $3c28bbcbae54a390$var$SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete $3c28bbcbae54a390$var$SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = $3c28bbcbae54a390$var$_objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, $dNMDr.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, $dNMDr.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, $dNMDr.forwardRef)(function(props, ref) {
            return (0, $dNMDr.createElement)(AsyncScriptLoader, $3c28bbcbae54a390$var$_extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, (/*@__PURE__*/$parcel$interopDefault($Jc9ZC))).func
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($cy8cW)))(ForwardedComponent, WrappedComponent);
    };
}

});


parcelRegister("fhwYP", function(module, exports) {

$parcel$export(module.exports, "RecaptchaNotice", function () { return $0a65693fce1309be$export$4faf58f44fb24e61; });
$parcel$export(module.exports, "default", function () { return $0a65693fce1309be$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");
parcelRequire("dNMDr");

var $e2mzU = parcelRequire("e2mzU");

var $hhYxc = parcelRequire("hhYxc");

var $84ZjZ = parcelRequire("84ZjZ");

var $cBB3b = parcelRequire("cBB3b");
const $0a65693fce1309be$var$ReCaptchaContainer = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
const $0a65693fce1309be$export$4faf58f44fb24e61 = ()=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    // removing recaptcha references associated with google TOS and privacy policy
    // https://hello.jira.atlassian.cloud/browse/KIRBY-10271
    const shouldNotRenderRecaptchaNotice = (0, $84ZjZ.checkFeatureGate)((0, $cBB3b.AidFrontendFeatureGate).REMOVE_RECAPTCHA_TOS_REFS);
    if ((0, $hhYxc.isIsolatedCloud)() || shouldNotRenderRecaptchaNotice) return null;
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
        id: "signup.form.recaptcha.notice.xml",
        defaultMessage: "This site is protected by reCAPTCHA and the Google <google-pp-link>Privacy Policy</google-pp-link> and <google-tos-link>Terms of Service</google-tos-link> apply.",
        values: {
            'google-pp-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $e2mzU.default), {
                    href: "https://policies.google.com/privacy",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    "aria-label": formatMessage({
                        id: 'signup.form.recaptcha.notice.google.pp.link.aria.label',
                        defaultMessage: 'Google Privacy Policy',
                        description: "Aria label for link to let users learn more about Google's Privacy Policy."
                    }),
                    children: chunks
                }),
            'google-tos-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $e2mzU.default), {
                    href: "https://policies.google.com/terms",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    "aria-label": formatMessage({
                        id: 'signup.form.recaptcha.notice.google.tos.link.aria.label',
                        defaultMessage: 'Google Terms of Service',
                        description: "Aria label for link to let users learn more about Google's Terms of Service."
                    }),
                    children: chunks
                })
        }
    });
};
var $0a65693fce1309be$export$2e2bcd8739ae039 = $0a65693fce1309be$var$ReCaptchaContainer;

});

parcelRegister("hzllM", function(module, exports) {

$parcel$export(module.exports, "useRecaptchaContext", function () { return $2702d8bcd13fb159$export$744a1a543fe96347; });
$parcel$export(module.exports, "RecaptchaContextProvider", function () { return $2702d8bcd13fb159$export$3f8996f6160b8ff2; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $ddozE = parcelRequire("ddozE");
const $2702d8bcd13fb159$export$2b9e9205883624e = /*#__PURE__*/ (0, $dNMDr.createContext)(null);
const $2702d8bcd13fb159$export$744a1a543fe96347 = ()=>{
    const context = (0, $dNMDr.useContext)($2702d8bcd13fb159$export$2b9e9205883624e);
    if (!context) throw new Error('useRecaptchaContext must be used within a RecaptchaContextProvider');
    return context;
};
const $2702d8bcd13fb159$export$3f8996f6160b8ff2 = ({ children: children, pageId: pageId, type: type, action: action, enabledProp: enabledProp })=>{
    const { isLoaded: isLoaded, enabled: enabled, errorMessage: errorMessage, component: component, fetchToken: baseFetchToken } = (0, $ddozE.useRecaptcha)({
        pageId: pageId,
        type: type,
        action: action,
        enabledProp: enabledProp
    });
    const fetchToken = (0, $dNMDr.useCallback)(baseFetchToken, [
        baseFetchToken
    ]);
    const state = (0, $dNMDr.useMemo)(()=>({
            isLoaded: isLoaded,
            enabled: enabled,
            errorMessage: errorMessage,
            component: component,
            fetchToken: fetchToken,
            recaptchaType: type
        }), [
        isLoaded,
        enabled,
        errorMessage,
        component,
        fetchToken,
        type
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)($2702d8bcd13fb159$export$2b9e9205883624e.Provider, {
        value: state,
        children: children
    });
};

});
parcelRegister("ddozE", function(module, exports) {

$parcel$export(module.exports, "useRecaptcha", function () { return $7780bee9f66ddaab$export$f7242fdfba1703e8; });

var $dNMDr = parcelRequire("dNMDr");

var $fvh09 = parcelRequire("fvh09");

var $aUSmM = parcelRequire("aUSmM");

var $aMBBA = parcelRequire("aMBBA");

var $hqddj = parcelRequire("hqddj");
const $7780bee9f66ddaab$var$noOpScoreConfig = {
    sitekey: '',
    pageId: '',
    enabled: false
};
const $7780bee9f66ddaab$var$noOpCheckboxConfig = {
    sitekey: '',
    pageId: '',
    enabled: false,
    action: ''
};
const $7780bee9f66ddaab$export$f7242fdfba1703e8 = (props)=>{
    const { pageId: pageId, type: type, enabledProp: enabledProp = true, action: action } = props;
    const { config: config } = $7780bee9f66ddaab$export$9b70e8251564d9ec(pageId, type, enabledProp, action);
    const isScore = type === 'score';
    const isCheckbox = type === 'checkbox';
    const scoreRecaptcha = (0, $aUSmM.useScoreRecaptcha)(isScore ? config : $7780bee9f66ddaab$var$noOpScoreConfig);
    const checkboxRecaptcha = (0, $fvh09.useCheckboxRecaptcha)(isCheckbox ? config : $7780bee9f66ddaab$var$noOpCheckboxConfig);
    return (0, $dNMDr.useMemo)(()=>isScore ? $7780bee9f66ddaab$var$handleScore(scoreRecaptcha, action) : $7780bee9f66ddaab$var$handleCheckbox(checkboxRecaptcha), [
        isScore,
        scoreRecaptcha,
        checkboxRecaptcha,
        action
    ]);
};
function $7780bee9f66ddaab$export$9b70e8251564d9ec(pageId, type, enabledProp, action) {
    const captchaEnabledByConfig = (0, $aMBBA.useAppSelector)((state)=>state.appConfig.recaptchaEnable);
    const scoreSitekey = (0, $aMBBA.useAppSelector)((state)=>state.appConfig.recaptchaEnterpriseScoreKeySite);
    const checkboxSitekey = (0, $aMBBA.useAppSelector)((state)=>state.appConfig.recaptchaEnterpriseCheckboxKeySite);
    const enabled = captchaEnabledByConfig && enabledProp;
    const commonConfig = {
        pageId: pageId,
        enabled: enabled,
        action: action
    };
    const scoreConfig = {
        ...commonConfig,
        sitekey: scoreSitekey,
        displayBadge: false
    };
    const checkboxConfig = {
        ...commonConfig,
        sitekey: checkboxSitekey,
        action: action ?? 'unknown'
    };
    const policyConfig = {
        ...commonConfig,
        sitekey: ''
    };
    switch(type){
        case 'score':
            return {
                type: type,
                config: scoreConfig
            };
        case 'checkbox':
            return {
                type: type,
                config: checkboxConfig
            };
        case 'policy':
            return {
                type: type,
                config: policyConfig
            };
        default:
            (0, $hqddj.captureTaggedException)(new Error(`Unexpected captcha type: ${type}`), {
                capabilities: action === 'signup' ? [
                    'capability-group--signup'
                ] : [],
                tags: {
                    recaptcha: 'unexpected_captcha_type'
                }
            });
            return {
                type: type,
                config: {
                    ...commonConfig,
                    sitekey: '',
                    enabled: false
                }
            };
    }
}
const $7780bee9f66ddaab$var$handleCheckbox = (checkboxRecaptcha)=>{
    const wrapToken = ()=>{
        return Promise.resolve({
            token: checkboxRecaptcha.token || '',
            type: 'checkbox',
            challengeKind: 'recaptcha'
        });
    };
    const isLoaded = checkboxRecaptcha.isLoaded;
    const enabled = checkboxRecaptcha?.enabled;
    const errorMessage = checkboxRecaptcha?.error?.message ?? undefined;
    const component = checkboxRecaptcha.component;
    const onFetchToken = async ()=>{
        const response = await wrapToken();
        // TODO once the flag is cleaned up, the type of response will always be truthy so we can change the check to response.token === ''
        if ((!response || !response.token) && enabled) (0, $hqddj.captureRecaptchaMessage)(errorMessage ?? 'no token returned from checkbox recaptcha', {}, 'no_token_checkbox');
        return response;
    };
    return {
        fetchToken: onFetchToken,
        isLoaded: isLoaded || false,
        enabled: enabled || false,
        errorMessage: errorMessage,
        component: component
    };
};
const $7780bee9f66ddaab$var$handleScore = (scoreRecaptcha, action)=>{
    const fetchAndWrapToken = (action)=>scoreRecaptcha.fetchRecaptchaToken(action).then((token)=>{
            return {
                token: token || '',
                type: 'score',
                challengeKind: 'recaptcha'
            };
        });
    const isLoaded = scoreRecaptcha.isLoaded;
    const enabled = scoreRecaptcha?.enabled;
    const errorMessage = scoreRecaptcha?.loadRecaptchaErrorReason ?? undefined;
    const onFetchToken = async ()=>{
        const response = await fetchAndWrapToken(action);
        // TODO once the flag is cleaned up, the type of response will always be truthy so we can change the check to response.token === ''
        if ((!response || !response.token) && enabled) (0, $hqddj.captureRecaptchaMessage)(errorMessage ?? 'no token returned from score recaptcha', {}, 'no_token_score');
        return response;
    };
    return {
        fetchToken: onFetchToken,
        isLoaded: isLoaded || false,
        enabled: enabled || false,
        errorMessage: errorMessage
    };
};

});
parcelRegister("fvh09", function(module, exports) {

$parcel$export(module.exports, "useCheckboxRecaptcha", function () { return $7d60378567e5d80e$export$25db2ae7b91eff3b; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $5s9ia = parcelRequire("5s9ia");

var $hqddj = parcelRequire("hqddj");

var $4NPio = parcelRequire("4NPio");

var $1nKUu = parcelRequire("1nKUu");
const $7d60378567e5d80e$export$25db2ae7b91eff3b = (config)=>{
    const [instanceId, setInstanceId] = (0, $dNMDr.useState)();
    const [token, setToken] = (0, $dNMDr.useState)('');
    const [isLoaded, setIsLoaded] = (0, $dNMDr.useState)(false);
    const [isExpired, setIsExpired] = (0, $dNMDr.useState)(false);
    const [error, setError] = (0, $dNMDr.useState)();
    const { sitekey: sitekey, action: action, enabled: enabled, pageId: pageId } = config;
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const scriptLogic = (0, $5s9ia.useCheckboxRecaptchaScripts)();
    const sendTrackingEvent = (0, $dNMDr.useCallback)((action, errorType)=>{
        analyticsClient.trackingEvent({
            page: pageId,
            action: action,
            subject: 'checkbox-recaptcha',
            ...errorType && {
                attributes: {
                    hasError: true,
                    errorName: errorType
                }
            }
        });
    }, [
        analyticsClient,
        pageId
    ]);
    const handleVerify = (0, $dNMDr.useCallback)((newToken)=>{
        setToken(newToken);
        setIsExpired(false);
        sendTrackingEvent('checkbox-completed');
    }, [
        sendTrackingEvent
    ]);
    const handleExpire = (0, $dNMDr.useCallback)(()=>{
        setToken('');
        setIsExpired(true);
        sendTrackingEvent('expired-callback', 'recaptcha-script-error');
    }, [
        sendTrackingEvent
    ]);
    const handleError = (0, $dNMDr.useCallback)(()=>{
        const newError = (0, $1nKUu.RecaptchaError).fromMessage('Failed to load recaptcha script');
        setError(newError);
        (0, $hqddj.captureRecaptchaException)(newError, {}, 'no_token_checkbox');
        sendTrackingEvent('error-callback', 'recaptcha-script-error');
    }, [
        sendTrackingEvent
    ]);
    const handleOnLoad = (0, $dNMDr.useCallback)(()=>{
        sendTrackingEvent('loaded-recaptcha');
        setIsLoaded(true);
    }, [
        sendTrackingEvent
    ]);
    // This callback is used for rendering recaptcha into the ref associated HTML Element.
    // The recaptcha script is loaded, if not done already, and then rendered.
    const refCallback = (0, $dNMDr.useCallback)(async (node)=>{
        if (!node) return;
        try {
            // Dynamically loads the recaptcha script when needed.
            await scriptLogic.injectRecaptchaScript();
            handleOnLoad();
            // Renders the recaptcha component into the given node.
            const newInstanceId = scriptLogic.getRecaptchaMethods().render(node, {
                sitekey: sitekey,
                action: action,
                callback: handleVerify,
                'expired-callback': handleExpire,
                'error-callback': handleError
            });
            setInstanceId(newInstanceId);
        } catch (error) {
            const newError = (0, $1nKUu.RecaptchaError).fromMessage('Failed to load recaptcha script');
            setError(newError);
            (0, $hqddj.captureRecaptchaException)(newError, {}, 'no_token_checkbox');
            sendTrackingEvent('load-recaptcha-failed', 'recaptcha-window-error');
        }
    }, [
        scriptLogic,
        handleOnLoad,
        sitekey,
        action,
        handleVerify,
        handleExpire,
        handleError,
        sendTrackingEvent
    ]);
    const component = (0, $dNMDr.useMemo)(()=>enabled ? /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
            id: "checkbox-recaptcha-hook",
            ref: refCallback
        }) : null, [
        enabled,
        refCallback
    ]);
    const reset = (0, $dNMDr.useCallback)(()=>{
        if (instanceId === undefined) return;
        scriptLogic.getRecaptchaMethods().reset(instanceId);
        setToken('');
        setIsLoaded(false);
        setIsExpired(false);
    }, [
        instanceId,
        scriptLogic
    ]);
    const getResponse = (0, $dNMDr.useCallback)(()=>{
        return instanceId !== undefined ? scriptLogic.getRecaptchaMethods().getResponse(instanceId) : '';
    }, [
        instanceId,
        scriptLogic
    ]);
    return {
        component: component,
        reset: reset,
        token: token,
        error: error,
        getResponse: getResponse,
        enabled: enabled,
        isLoaded: isLoaded,
        isExpired: isExpired
    };
};

});
parcelRegister("5s9ia", function(module, exports) {

$parcel$export(module.exports, "useScoreRecaptchaScripts", function () { return $95aeb2b93e717582$export$4b37d6e6c5707b8a; });
$parcel$export(module.exports, "useCheckboxRecaptchaScripts", function () { return $95aeb2b93e717582$export$b48db21c95021cdf; });

var $hqddj = parcelRequire("hqddj");

var $dNMDr = parcelRequire("dNMDr");

var $1nKUu = parcelRequire("1nKUu");
const $95aeb2b93e717582$var$RECAPTCHA_SCRIPT_DOMAIN = 'www.recaptcha.net';
const $95aeb2b93e717582$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE = 'Failed to load grecaptcha enterprise.';
const $95aeb2b93e717582$export$3bfe7d4134a81119 = ()=>window.grecaptcha?.enterprise;
/**
 * Loads the reCAPTCHA script if it hasn't been loaded already.
 *
 * Loading states:
 *  0. Script <src> element does not exist on the DOM.
 *  1. Script is asynchronously downloading and the reCAPTCHA methods are not available yet.
 *  2. Script has been downloaded and a 'load' event is fired for the DOM element and the reCAPTCHA methods are now available.
 *  3. Google fires a 'ready' event when the reCAPTCHA methods are available.
 *      Recaptcha can be considered to be fully ready to use at this point.
 *  4. Extra dependencies and scripts are downloaded asynchronously.
 *      This extra step should not be relevant to checkbox or score, but may be relevant for invisible.
 */ // Keep a track of all loaded scripts so the promise can be re-used by different React components/hooks:
const $95aeb2b93e717582$var$scriptCache = new Map();
const $95aeb2b93e717582$export$62fae4128d19343d = (scriptId)=>$95aeb2b93e717582$var$scriptCache.delete(scriptId);
const $95aeb2b93e717582$export$c80de0a5a6afcd7c = async (scriptId, scriptSrc)=>{
    let scriptPromise = $95aeb2b93e717582$var$scriptCache.get(scriptId);
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject)=>{
            const scriptElement = document.createElement('script');
            scriptElement.id = scriptId;
            scriptElement.src = `https://${$95aeb2b93e717582$var$RECAPTCHA_SCRIPT_DOMAIN}${scriptSrc}`;
            scriptElement.async = true;
            scriptElement.defer = true;
            scriptElement.addEventListener('load', ()=>{
                if (window && window.grecaptcha && window.grecaptcha.enterprise) // reCAPTCHA script was injected and library 'finished' loading once ready() completes
                $95aeb2b93e717582$export$3bfe7d4134a81119().ready(()=>resolve());
                else {
                    (0, $hqddj.captureErrorMessage)($95aeb2b93e717582$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
                    reject((0, $1nKUu.RecaptchaError).fromMessage($95aeb2b93e717582$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE));
                }
            });
            // investigate - error undefined
            scriptElement.addEventListener('error', (errorEvent)=>{
                (0, $hqddj.captureException)(errorEvent.error);
                reject((0, $1nKUu.RecaptchaError).fromError(errorEvent.error || new Error($95aeb2b93e717582$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE)));
            });
            document.head.appendChild(scriptElement);
        });
        $95aeb2b93e717582$var$scriptCache.set(scriptId, scriptPromise);
    }
    return scriptPromise;
};
const $95aeb2b93e717582$export$a0a588829684d44 = (scriptId)=>{
    const script = document.getElementById(scriptId);
    return script !== null;
};
const $95aeb2b93e717582$export$924e44702e93d253 = (scriptId)=>{
    const id = `${scriptId}-styles`;
    if (document.getElementById(id)) return;
    const styleElement = document.createElement('style');
    styleElement.id = id;
    styleElement.innerText = '.grecaptcha-badge { visibility: hidden; }';
    document.head.appendChild(styleElement);
};
const $95aeb2b93e717582$export$684246aaf6783333 = (scriptId)=>{
    const scriptElement = document.getElementById(scriptId);
    if (scriptElement) scriptElement.remove();
};
const $95aeb2b93e717582$export$42b99ab155dad274 = (scriptId)=>{
    const styleElement = document.getElementById(`${scriptId}-styles`);
    if (styleElement) styleElement.remove();
};
const $95aeb2b93e717582$export$f124d412b77f93b3 = ()=>{
    document.querySelectorAll('.grecaptcha-badge').forEach((element)=>element.remove());
};
const $95aeb2b93e717582$export$4b37d6e6c5707b8a = ({ sitekey: sitekey })=>{
    const scriptSrc = `/recaptcha/enterprise.js?render=${sitekey}`;
    return (0, $dNMDr.useMemo)(()=>({
            injectRecaptchaScript: ()=>$95aeb2b93e717582$export$c80de0a5a6afcd7c(sitekey, scriptSrc),
            getRecaptchaMethods: ()=>$95aeb2b93e717582$export$3bfe7d4134a81119(),
            hideRecaptchaBadge: ()=>$95aeb2b93e717582$export$924e44702e93d253(sitekey),
            unloadRecaptcha () {
                $95aeb2b93e717582$export$684246aaf6783333(sitekey);
                $95aeb2b93e717582$export$42b99ab155dad274(sitekey);
                $95aeb2b93e717582$export$f124d412b77f93b3();
                $95aeb2b93e717582$export$62fae4128d19343d(sitekey);
            }
        }), [
        sitekey,
        scriptSrc
    ]);
};
const $95aeb2b93e717582$export$b48db21c95021cdf = ()=>{
    const scriptId = 'checkbox-recaptcha';
    const scriptSrc = '/recaptcha/enterprise.js?render=explicit';
    return (0, $dNMDr.useMemo)(()=>({
            injectRecaptchaScript: ()=>$95aeb2b93e717582$export$c80de0a5a6afcd7c(scriptId, scriptSrc),
            getRecaptchaMethods: ()=>$95aeb2b93e717582$export$3bfe7d4134a81119()
        }), []);
};

});
parcelRegister("1nKUu", function(module, exports) {

$parcel$export(module.exports, "RecaptchaError", function () { return $27b80f7b63938c6b$export$e037dc82f45cc746; });
class $27b80f7b63938c6b$export$e037dc82f45cc746 extends Error {
    constructor(message){
        super(message);
        this.name = 'RecaptchaError';
    }
    static fromError(error) {
        const instance = new $27b80f7b63938c6b$export$e037dc82f45cc746(error.message);
        instance.stack = error.stack;
        return instance;
    }
    static fromMessage(message) {
        const instance = new $27b80f7b63938c6b$export$e037dc82f45cc746(message);
        instance.stack = new Error().stack;
        return instance;
    }
}

});



parcelRegister("aUSmM", function(module, exports) {

$parcel$export(module.exports, "useScoreRecaptcha", function () { return $5753d4c09599e374$export$afce2c1d72c48fc5; });

var $dNMDr = parcelRequire("dNMDr");

var $4NPio = parcelRequire("4NPio");

var $hqddj = parcelRequire("hqddj");

var $5s9ia = parcelRequire("5s9ia");

var $1nKUu = parcelRequire("1nKUu");
const $5753d4c09599e374$var$RECAPTCHA_ENTERPRISE_EXECUTE_UNAVAILABLE = 'Failed to invoke grecaptcha execute function as it is not ready.';
const $5753d4c09599e374$export$afce2c1d72c48fc5 = (config)=>{
    const [loadRecaptchaErrorReason, setLoadRecaptchaErrorReason] = (0, $dNMDr.useState)();
    const [isLoaded, setIsLoaded] = (0, $dNMDr.useState)(false);
    const scriptInitializationRef = (0, $dNMDr.useRef)();
    const { sitekey: sitekey, enabled: enabled, displayBadge: displayBadge = false, pageId: pageId } = config;
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const scriptLogic = (0, $5s9ia.useScoreRecaptchaScripts)({
        sitekey: sitekey
    });
    const sendTrackingEvent = (0, $dNMDr.useCallback)((action, errorType)=>{
        analyticsClient.trackingEvent({
            page: pageId,
            action: action,
            subject: 'score-recaptcha',
            ...errorType && {
                attributes: {
                    hasError: true,
                    errorName: errorType
                }
            }
        });
    }, [
        analyticsClient,
        pageId
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (!enabled) return;
        const initRecaptcha = async ()=>{
            try {
                await scriptLogic.injectRecaptchaScript();
                sendTrackingEvent('loaded-recaptcha');
                if (!displayBadge) scriptLogic.hideRecaptchaBadge();
                setIsLoaded(true);
            } catch (error) {
                const errorMessage = String(error);
                setLoadRecaptchaErrorReason(errorMessage);
                (0, $hqddj.captureException)(error);
                sendTrackingEvent('load-recaptcha-failed', 'recaptcha-script-error');
            }
        };
        scriptInitializationRef.current = initRecaptcha();
        return ()=>{
            scriptLogic.unloadRecaptcha();
            setLoadRecaptchaErrorReason(undefined);
            scriptInitializationRef.current = undefined;
        };
    }, [
        displayBadge,
        sitekey,
        pageId,
        enabled,
        analyticsClient,
        sendTrackingEvent,
        scriptLogic
    ]);
    const fetchRecaptchaToken = (0, $dNMDr.useCallback)(async (action)=>{
        if (!enabled) return '';
        if (scriptInitializationRef.current) await scriptInitializationRef.current;
        if (!window?.grecaptcha?.enterprise?.execute) {
            (0, $hqddj.captureRecaptchaException)((0, $1nKUu.RecaptchaError).fromMessage($5753d4c09599e374$var$RECAPTCHA_ENTERPRISE_EXECUTE_UNAVAILABLE), {}, 'no_token_score');
            sendTrackingEvent('get-recaptcha-token', 'recaptcha-window-error');
            return '';
        }
        try {
            return await window.grecaptcha.enterprise.execute(sitekey, {
                action: action
            });
        } catch (err) {
            (0, $hqddj.captureRecaptchaException)((0, $1nKUu.RecaptchaError).fromError(err), {}, 'no_token_score');
            sendTrackingEvent('get-recaptcha-token', 'recaptcha-script-error');
            return '';
        }
    }, [
        enabled,
        sendTrackingEvent,
        sitekey
    ]);
    return {
        isLoaded: isLoaded,
        fetchRecaptchaToken: fetchRecaptchaToken,
        loadRecaptchaErrorReason: loadRecaptchaErrorReason,
        enabled: enabled
    };
};

});



parcelRegister("kcNti", function(module, exports) {

$parcel$export(module.exports, "LoginTooManyAttemptsRecaptchaContextProvider", function () { return $773faec48bc258ee$export$b27cbe0302f9b08b; });
$parcel$export(module.exports, "useLoginTooManyAttemptsRecaptchaContext", function () { return $773faec48bc258ee$export$5c1b73ca6a070fab; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $aMBBA = parcelRequire("aMBBA");
const $773faec48bc258ee$export$d98a10b0f5602870 = /*#__PURE__*/ (0, $dNMDr.createContext)(null);
const $773faec48bc258ee$export$b27cbe0302f9b08b = ({ children: children })=>{
    const [captchaValue, setCaptchaValue] = (0, $dNMDr.useState)(null);
    const tooManyFailedLogins = (0, $aMBBA.useAppSelector)((state)=>state.login?.isCaptchaRequired);
    const recaptchaEnabled = (0, $aMBBA.useAppSelector)((state)=>state.appConfig.recaptchaEnable);
    const isCaptchaRequired = tooManyFailedLogins && recaptchaEnabled;
    const value = (0, $dNMDr.useMemo)(()=>({
            isRequired: isCaptchaRequired,
            captchaValue: captchaValue,
            setCaptchaValue: setCaptchaValue
        }), [
        captchaValue,
        setCaptchaValue,
        isCaptchaRequired
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)($773faec48bc258ee$export$d98a10b0f5602870.Provider, {
        value: value,
        children: children
    });
};
const $773faec48bc258ee$export$5c1b73ca6a070fab = ()=>{
    const context = (0, $dNMDr.useContext)($773faec48bc258ee$export$d98a10b0f5602870);
    if (!context) throw new Error('useLoginTooManyAttemptsRecaptchaContext must be used within a LoginTooManyAttemptsRecaptchaContextProvider');
    return context;
};

});

parcelRegister("H2Y2l", function(module, exports) {
$parcel$export(module.exports, "useRegisterComponent", function () { return (parcelRequire("kfOJC")).useRegisterComponent; });
$parcel$export(module.exports, "PageOrchestrator", function () { return (parcelRequire("1fxeN")).PageOrchestrator; });
$parcel$export(module.exports, "useShouldOrchestrate", function () { return (parcelRequire("4jozl")).useShouldOrchestrate; });
parcelRequire("kfOJC");
parcelRequire("4wsWe");
parcelRequire("1fxeN");
parcelRequire("gVWMf");

});
parcelRegister("kfOJC", function(module, exports) {

$parcel$export(module.exports, "AdvancedCobrandingContext", function () { return $a13ce62d9afd02cf$export$5253ee94c7927efc; });
$parcel$export(module.exports, "useAdvancedCobrandingContext", function () { return $a13ce62d9afd02cf$export$12168a8568483640; });
$parcel$export(module.exports, "useRegisterComponent", function () { return $a13ce62d9afd02cf$export$24eaf8ff4dcf9c58; });

var $dNMDr = parcelRequire("dNMDr");
const $a13ce62d9afd02cf$export$5253ee94c7927efc = (0, $dNMDr.createContext)(undefined);
const $a13ce62d9afd02cf$export$12168a8568483640 = ()=>{
    const context = (0, $dNMDr.useContext)($a13ce62d9afd02cf$export$5253ee94c7927efc);
    if (!context) throw new Error('useAdvancedCobrandingContext used outside of AdvancedCobrandingContext');
    return context;
};
const $a13ce62d9afd02cf$export$24eaf8ff4dcf9c58 = (name)=>{
    const registered = (0, $dNMDr.useRef)(false);
    const context = (0, $dNMDr.useContext)($a13ce62d9afd02cf$export$5253ee94c7927efc);
    (0, $dNMDr.useEffect)(()=>{
        if (registered.current) return;
        if (!context) return;
        registered.current = true;
        context.registerComponent(name);
    }, [
        context,
        name
    ]);
};

});

parcelRegister("4wsWe", function(module, exports) {

});

parcelRegister("1fxeN", function(module, exports) {

$parcel$export(module.exports, "PageOrchestrator", function () { return $1b3e81fb89775f05$export$ab5ed25a9459596a; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $2eVHl = parcelRequire("2eVHl");

var $4NPio = parcelRequire("4NPio");

var $kfOJC = parcelRequire("kfOJC");

var $cmdmL = parcelRequire("cmdmL");

var $j31XW = parcelRequire("j31XW");
const $1b3e81fb89775f05$export$ab5ed25a9459596a = ({ fallback: fallback, pages: pages, requiredComponents: requiredComponents })=>{
    const [registrationStarted, setRegistrationStarted] = (0, $dNMDr.useState)(false);
    const [components, setComponents] = (0, $dNMDr.useState)();
    const { cobranding: cobranding } = (0, $2eVHl.useCobranding)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const page = (0, $dNMDr.useMemo)(()=>{
        return pages.find((page)=>page.experience === cobranding);
    }, [
        pages,
        cobranding
    ]);
    const Component = (0, $dNMDr.useMemo)(()=>{
        return page?.Component || fallback;
    }, [
        page,
        fallback
    ]);
    // The fallback is the base page. This occurs when there is a cobranding defined, but not for the page that the user is requesting
    const isUsingFallback = !page?.Component;
    const registerComponent = (0, $dNMDr.useCallback)((component)=>{
        setComponents((components)=>{
            return components ? [
                ...components,
                component
            ] : [
                component
            ];
        });
    }, []);
    const value = (0, $dNMDr.useMemo)(()=>({
            components: components,
            registerComponent: registerComponent
        }), [
        components,
        registerComponent
    ]);
    (0, $dNMDr.useEffect)(()=>{
        setTimeout(()=>setRegistrationStarted(true), 0);
    }, []);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kfOJC.AdvancedCobrandingContext).Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cmdmL.PageGuard), {
            requiredComponents: requiredComponents,
            registrationStarted: registrationStarted,
            skipRequiredChecks: isUsingFallback,
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $j31XW.default), {
                analyticsClient: analyticsClient,
                capabilities: [
                    'non-kirby-code'
                ],
                skipAnalytics: true,
                children: /*#__PURE__*/ (0, $6CtE1.jsx)(Component, {})
            })
        })
    });
};

});
parcelRegister("cmdmL", function(module, exports) {

$parcel$export(module.exports, "PageGuard", function () { return $b0a27b763af6b163$export$c2e3d7bea8403012; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $2eVHl = parcelRequire("2eVHl");

var $kfOJC = parcelRequire("kfOJC");

var $3Wc5s = parcelRequire("3Wc5s");

var $hqddj = parcelRequire("hqddj");
const $b0a27b763af6b163$export$a303b4f7b8d504d8 = 2000;
/**
 * Whether or not to show the missing component error overlay. We do not want to show this in production (to real users).
 * The overlay is for developers to see the missing components and debug the issue
 */ const $b0a27b763af6b163$var$canShowOverlay = false;
const $b0a27b763af6b163$export$c2e3d7bea8403012 = ({ children: children, requiredComponents: requiredComponents, registrationStarted: registrationStarted, skipRequiredChecks: skipRequiredChecks = false })=>{
    const { cobranding: cobranding } = (0, $2eVHl.useCobranding)();
    const { components: components } = (0, $kfOJC.useAdvancedCobrandingContext)();
    const [registrationTimedOut, setRegistrationTimedOut] = (0, $dNMDr.useState)(false);
    const missingComponents = (0, $dNMDr.useMemo)(()=>{
        return requiredComponents.filter((requiredComponent)=>!components?.includes(requiredComponent));
    }, [
        requiredComponents,
        components
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (!registrationStarted) return;
        const timeout = setTimeout(()=>{
            setRegistrationTimedOut(true);
        }, $b0a27b763af6b163$export$a303b4f7b8d504d8);
        return ()=>clearTimeout(timeout);
    }, [
        registrationStarted
    ]);
    const hasRegisteredAllRequiredComponents = missingComponents.length === 0;
    const isWaitingForRegistration = !registrationTimedOut;
    (0, $dNMDr.useEffect)(()=>{
        if (!hasRegisteredAllRequiredComponents && !isWaitingForRegistration && !$b0a27b763af6b163$var$canShowOverlay) console.warn(`[COBRANDING] ${window.location.pathname} has not registered all required components.`);
    }, [
        cobranding,
        hasRegisteredAllRequiredComponents,
        isWaitingForRegistration
    ]);
    // skipRequiredChecks:
    // We want to skip these checks if we are using a fallback (i.e. a base page/non cobranded page) and we do not want to
    // enforce the required components. This is at least until we either audit all of the fallback pages, or we start
    // dogfooding the cobranding orchestrator in our base pages, to ensure that we are not breaking any pages.
    // hasRegisteredAllRequiredComponents:
    // If all required components have been registered, we can safely render the children without any further checks.
    if (skipRequiredChecks || hasRegisteredAllRequiredComponents) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dNMDr.Suspense), {
        fallback: /*#__PURE__*/ (0, $6CtE1.jsx)($b0a27b763af6b163$var$LoadingOverlay, {}),
        children: /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
            style: {
                height: '100%'
            },
            "data-testid": "registration-complete",
            children: children
        })
    });
    if (isWaitingForRegistration) // Displays the loading overlay while the page is lazy-loading and while the registration is in progress.
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $dNMDr.Suspense), {
        fallback: /*#__PURE__*/ (0, $6CtE1.jsx)($b0a27b763af6b163$var$LoadingOverlay, {}),
        children: [
            children,
            /*#__PURE__*/ (0, $6CtE1.jsx)($b0a27b763af6b163$var$LoadingOverlay, {})
        ]
    });
    // This handles the case where the registration has timed out and the required components are still not registered
    return /*#__PURE__*/ (0, $6CtE1.jsx)($b0a27b763af6b163$var$PageGuardMissingComponent, {
        canShowOverlay: $b0a27b763af6b163$var$canShowOverlay,
        missingComponents: missingComponents,
        children: children
    });
};
/**
 * Responsible for rendering the children component (which is either the cobranded page or the fallback/non-cobranded/default/base page)
 * and checking that the page includes the components that the relevant page level cobranded config declares that it needs
 * When running locally, it also renders details of the missing components to let the developers know as well as aid with debugging the issue.
 * In production we do not show this to the user.
 * In all cases, we render the children despite it missing some details as a fallback.
 *
 * @note We send an event to Sentry in the case that this component is rendered, because we should _not_ see this in customer facing code.
 */ const $b0a27b763af6b163$var$PageGuardMissingComponent = ({ children: children, canShowOverlay: canShowOverlay, missingComponents: missingComponents })=>{
    const { cobranding: cobranding } = (0, $2eVHl.useCobranding)();
    // Generating here so that cobranding does not become a dependency of the useEffect. errorMessage will be, but it won't run again unless the string itself has changed.
    const errorMessage = `Cobranding experience missing required components after registration waiting period ${cobranding}`;
    (0, $dNMDr.useEffect)(()=>{
        // If we get to this point, it means that after waiting for REGISTRATION_TIMEOUT_MS the required components are still not present
        (0, $hqddj.captureTaggedException)(new Error(errorMessage), {
            capabilities: [
                'non-kirby-code'
            ],
            tags: {
                cobrandingOrchestrator: 'missing_required_components'
            }
        });
    }, [
        errorMessage
    ]);
    if (canShowOverlay) return /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
        "data-testid": "registration-complete",
        children: /*#__PURE__*/ (0, $6CtE1.jsx)($b0a27b763af6b163$var$MissingComponentErrorDisplay, {
            cobranding: cobranding,
            missingComponents: missingComponents,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dNMDr.Suspense), {
        fallback: /*#__PURE__*/ (0, $6CtE1.jsx)($b0a27b763af6b163$var$LoadingOverlay, {}),
        children: /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
            style: {
                height: '100%'
            },
            "data-testid": "registration-complete",
            children: children
        })
    });
};
const $b0a27b763af6b163$var$MissingComponentErrorDisplay = ({ cobranding: cobranding, missingComponents: missingComponents, children: children })=>{
    const search = new URLSearchParams(window.location.search);
    search.delete('token');
    return /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
        style: {
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
                style: {
                    position: 'fixed',
                    zIndex: 100,
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                        style: {
                            position: 'fixed',
                            zIndex: -1,
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            opacity: 0.25,
                            backgroundColor: '#FFADB0'
                        }
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '1rem',
                            padding: '4rem',
                            borderRadius: '0.5rem',
                            background: '#FFADB0',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.25rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $6CtE1.jsx)("h2", {
                                        style: {
                                            fontWeight: 'bold'
                                        },
                                        children: "Advanced Cobranding"
                                    }),
                                    /*#__PURE__*/ (0, $6CtE1.jsx)("p", {
                                        children: "Unable to render page due to missing required components:"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.1rem',
                                    padding: '1rem',
                                    borderRadius: '0.25rem',
                                    color: 'white',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#c92216'
                                },
                                children: missingComponents.map((component)=>/*#__PURE__*/ (0, $6CtE1.jsx)("p", {
                                        style: {
                                            margin: 0
                                        },
                                        children: /*#__PURE__*/ (0, $6CtE1.jsx)("span", {
                                            "data-testid": "missing-component",
                                            children: component
                                        })
                                    }, component))
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.25rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $6CtE1.jsxs)("p", {
                                        style: {
                                            margin: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                                                children: "Cobranding"
                                            }),
                                            ": ",
                                            cobranding
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $6CtE1.jsxs)("p", {
                                        style: {
                                            margin: 0,
                                            display: 'flex',
                                            flexWrap: 'wrap'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                                                children: "URL"
                                            }),
                                            ": ",
                                            `${window.location.pathname}?${search}`
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};
const $b0a27b763af6b163$var$LoadingOverlay = ()=>/*#__PURE__*/ (0, $6CtE1.jsx)("div", {
        style: {
            position: 'fixed',
            top: 0,
            zIndex: 2,
            pointerEvents: 'none',
            left: 0,
            right: 0,
            bottom: 0,
            flexDirection: 'column',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white'
        },
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3Wc5s.default), {})
    });

});


parcelRegister("gVWMf", function(module, exports) {
$parcel$export(module.exports, "useShouldOrchestrate", function () { return (parcelRequire("4jozl")).useShouldOrchestrate; });
parcelRequire("4jozl");

});
parcelRegister("4jozl", function(module, exports) {

$parcel$export(module.exports, "useShouldOrchestrate", function () { return $1de5a1a5dabba332$export$eab7ff4ea760bf6a; });

var $2eVHl = parcelRequire("2eVHl");
const $1de5a1a5dabba332$export$eab7ff4ea760bf6a = ()=>{
    const { cobranding: cobranding } = (0, $2eVHl.useCobranding)();
    const forceOrchestration = (0, $2eVHl.isAdvancedCobranding)(cobranding);
    return forceOrchestration;
};

});




parcelRegister("3v21n", function(module, exports) {

$parcel$export(module.exports, "LoginMarketingConsent", function () { return $48ba598457a09dde$export$7f3ec3ad6a2266d2; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $aMBBA = parcelRequire("aMBBA");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $6JqFM = parcelRequire("6JqFM");

var $7C1Rq = parcelRequire("7C1Rq");
const $48ba598457a09dde$var$StyledMarketingConsentWrapper = (0, $fbSBq.default).div`
  padding-top: ${(0, $68HQw.gridSize)() * 2}px;
`;
const $48ba598457a09dde$export$7f3ec3ad6a2266d2 = ()=>{
    (0, $kfOJC.useRegisterComponent)($48ba598457a09dde$export$7f3ec3ad6a2266d2.name);
    const config = (0, $aMBBA.useAppSelector)((state)=>state.marketingConsent?.config);
    const isUsernameChecked = (0, $aMBBA.useAppSelector)((state)=>state.login?.isUsernameChecked);
    const { setMarketingConsent: setMarketingConsent } = (0, $6JqFM.useMarketingConsentContext)();
    if (!isUsernameChecked) return null;
    return /*#__PURE__*/ (0, $6CtE1.jsx)($48ba598457a09dde$var$StyledMarketingConsentWrapper, {
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7C1Rq.default), {
            config: config,
            onConsentChange: setMarketingConsent
        })
    });
};

});
parcelRegister("6JqFM", function(module, exports) {

$parcel$export(module.exports, "MarketingConsentContextProvider", function () { return $b59ac75d9e731227$export$a01df84c5b0bda88; });
$parcel$export(module.exports, "useMarketingConsentContext", function () { return $b59ac75d9e731227$export$3bf9eae4cd157a8c; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");
const $b59ac75d9e731227$var$MarketingConsentContext = /*#__PURE__*/ (0, $dNMDr.createContext)(null);
const $b59ac75d9e731227$export$a01df84c5b0bda88 = ({ children: children })=>{
    const [marketingConsent, setMarketingConsent] = (0, $dNMDr.useState)(undefined);
    const value = (0, $dNMDr.useMemo)(()=>({
            marketingConsent: marketingConsent,
            setMarketingConsent: setMarketingConsent
        }), [
        marketingConsent,
        setMarketingConsent
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)($b59ac75d9e731227$var$MarketingConsentContext.Provider, {
        value: value,
        children: children
    });
};
const $b59ac75d9e731227$export$3bf9eae4cd157a8c = ()=>{
    const context = (0, $dNMDr.useContext)($b59ac75d9e731227$var$MarketingConsentContext);
    if (!context) throw new Error('useMarketingConsentContext must be used within MarketingConsentContextProvider');
    return context;
};

});

parcelRegister("7C1Rq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd20939823a24a71$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $5bOZS = parcelRequire("5bOZS");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $fbSBq = parcelRequire("fbSBq");

var $ko1o6 = parcelRequire("ko1o6");

var $FiINT = parcelRequire("FiINT");
parcelRequire("jM5Ly");
var $hMPjy = parcelRequire("hMPjy");
const $bd20939823a24a71$var$MarketingConsentWrapper = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
  div {
    align-items: flex-start;
  }
  [aria-label='checkboxIcon'] {
    margin-left: -8px;
    margin-top: -4px;
  }
  label {
    font-size: 12px;
    line-height: 16px;
    color: ${(0, $l4KzN).N300};
  }
`;
const $bd20939823a24a71$var$MarketingConsentCheckbox = ({ className: className, config: config, forceShow: forceShow, onConsentChange: onConsentChange })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const previousConfig = (0, $hMPjy.usePrevious)(config);
    const consentText = formatMessage((0, $FiINT.default).marketingConsentPromptText);
    const notifyConsentChange = (0, $dNMDr.useCallback)(()=>{
        let consent = {
            state: 'not_shown'
        };
        if (config && config.showCheckbox) consent = {
            state: 'unchecked',
            consentText: consentText
        };
        onConsentChange(consent);
    }, [
        config,
        consentText,
        onConsentChange
    ]);
    (0, $dNMDr.useEffect)(()=>{
        notifyConsentChange();
    }, [
        notifyConsentChange
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (previousConfig !== config) notifyConsentChange();
    }, [
        previousConfig,
        config,
        notifyConsentChange
    ]);
    const consentCheckboxChanged = (e)=>{
        const state = e.target.checked ? 'checked' : 'unchecked';
        onConsentChange({
            state: state,
            consentText: consentText
        });
    };
    if (!config || !config.showCheckbox && !forceShow) return null;
    return /*#__PURE__*/ (0, $6CtE1.jsx)($bd20939823a24a71$var$MarketingConsentWrapper, {
        className: className,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5bOZS.default), {
            testId: "marketing-consent-checkbox",
            id: "marketing-consent-checkbox",
            label: consentText,
            onChange: consentCheckboxChanged
        })
    });
};
var $bd20939823a24a71$export$2e2bcd8739ae039 = $bd20939823a24a71$var$MarketingConsentCheckbox;

});
parcelRegister("5bOZS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c7589cc8f64736c$export$2e2bcd8739ae039; });
/* checkbox.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $aFyVI = parcelRequire("aFyVI");

var $82V4i = parcelRequire("82V4i");

var $bM2vx = parcelRequire("bM2vx");

var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");

var $02D9g = parcelRequire("02D9g");

var $gTgRL = parcelRequire("gTgRL");

var $3TDrO = parcelRequire("3TDrO");
var $eIDJZ = parcelRequire("eIDJZ");
var $utfbM = parcelRequire("utfbM");
var $1fQgz = parcelRequire("1fQgz");
var $3c7589cc8f64736c$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ var $3c7589cc8f64736c$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $3c7589cc8f64736c$var$Checkbox = /*#__PURE__*/ (0, $dNMDr.memo)(/*#__PURE__*/ (0, $dNMDr.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($bM2vx)))(_ref, $3c7589cc8f64736c$var$_excluded);
    var _useState = (0, $dNMDr.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($82V4i)))(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $dNMDr.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $02D9g.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "17.3.4"
    });
    var internalRef = (0, $dNMDr.useRef)(null);
    var mergedRefs = (0, $gTgRL.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $dNMDr.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $dNMDr.createElement((0, $eIDJZ.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $dNMDr.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($aFyVI)))({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $affTb.default)([
            $3c7589cc8f64736c$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? 'true' : undefined
    })), /*#__PURE__*/ $dNMDr.createElement((0, $3TDrO.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $dNMDr.createElement((0, $utfbM.default), null, label, isRequired && /*#__PURE__*/ $dNMDr.createElement((0, $1fQgz.default), null)));
}));
$3c7589cc8f64736c$var$Checkbox.displayName = 'Checkbox';
var $3c7589cc8f64736c$export$2e2bcd8739ae039 = $3c7589cc8f64736c$var$Checkbox;

});
parcelRegister("3TDrO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d651ba3f50e2ced$export$2e2bcd8739ae039; });
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ var $2d651ba3f50e2ced$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $2d651ba3f50e2ced$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $dNMDr.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $dNMDr.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $2d651ba3f50e2ced$var$CheckboxIcon = /*#__PURE__*/ (0, $dNMDr.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $dNMDr.useMemo)(function() {
        return $2d651ba3f50e2ced$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $dNMDr.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $affTb.default)([
            $2d651ba3f50e2ced$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $dNMDr.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $dNMDr.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $affTb.default)([
            $2d651ba3f50e2ced$var$svgStyles.rect
        ])
    }), icon));
});
var $2d651ba3f50e2ced$export$2e2bcd8739ae039 = $2d651ba3f50e2ced$var$CheckboxIcon;

});

parcelRegister("eIDJZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab740070f74499af$export$2e2bcd8739ae039; });
/* label.tsx generated by @compiled/babel-plugin v0.38.1 */ /**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
var $ab740070f74499af$var$baseStyles = null;
var $ab740070f74499af$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
var $ab740070f74499af$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
var $ab740070f74499af$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
var $ab740070f74499af$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
var $ab740070f74499af$var$disabledCheckedStyles = null;
function $ab740070f74499af$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, isChecked = _ref.isChecked, isIndeterminate = _ref.isIndeterminate, isInvalid = _ref.isInvalid, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $dNMDr.createElement("label", {
        className: (0, $affTb.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1tvo _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("utfbM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05b97cb3c73234eb$export$2e2bcd8739ae039; });
/* label-text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
var $05b97cb3c73234eb$var$labelTextStyles = null;
function $05b97cb3c73234eb$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        className: (0, $affTb.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

});

parcelRegister("1fQgz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e9fbc23626114d6$export$2e2bcd8739ae039; });
/* required-indicator.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $dNMDr = parcelRequire("dNMDr");

var $affTb = parcelRequire("affTb");
var $9vljA = parcelRequire("9vljA");

var $2Mjap = parcelRequire("2Mjap");
var $0e9fbc23626114d6$var$requiredIndicatorStyles = null;
function $0e9fbc23626114d6$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $dNMDr.createElement("span", {
        "aria-hidden": true,
        className: (0, $affTb.default)([
            "_syaz1ml5 _bozgv77o"
        ]),
        style: {
            "--_1xw92dq": (0, $9vljA.default)("var(--ds-text-danger, ".concat((0, $2Mjap.R500), ")"))
        }
    }, "*");
}

});


parcelRegister("FiINT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd84ef7dd22b21d5$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $bd84ef7dd22b21d5$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    marketingConsentPromptText: {
        id: 'marketing.consent.text',
        defaultMessage: 'Yes! Send me news and offers from Atlassian about products, events, and more.',
        description: ''
    }
});

});




parcelRegister("kQxOX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cfc070e67c865a1$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $l4KzN = parcelRequire("l4KzN");

var $2byD0 = parcelRequire("2byD0");

var $2AKKZ = parcelRequire("2AKKZ");

var $ef3n6 = parcelRequire("ef3n6");

var $4lIXK = parcelRequire("4lIXK");

var $iEoRg = parcelRequire("iEoRg");

var $jwUri = parcelRequire("jwUri");

var $chJxj = parcelRequire("chJxj");
const $6cfc070e67c865a1$var$SocialLoginBlock = (0, $fbSBq.default).div`
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${(0, $68HQw.gridSize)() * 1.5}px;

  border: 1px solid ${(0, $l4KzN.N50)};
  border-radius: 3px;
`;
const $6cfc070e67c865a1$var$Header = (0, $fbSBq.default).div`
  display: flex;
  align-self: center;
  justify-content: center;

  width: 100%;
  padding-bottom: ${(0, $68HQw.gridSize)() * 1.5}px;
`;
const $6cfc070e67c865a1$var$Email = (0, $fbSBq.default).div`
  font-weight: 600;
  font-size: 14px;
  line-height: ${(0, $68HQw.gridSize)() * 3}px;
  color: ${(0, $l4KzN.N800)};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $6cfc070e67c865a1$var$Logo = (0, $fbSBq.default).img`
  height: ${(0, $68HQw.gridSize)() * 3}px;
  padding-right: ${(0, $68HQw.gridSize)()}px;
`;
const $6cfc070e67c865a1$var$getLogo = (highlightedSocialProvider)=>{
    switch(highlightedSocialProvider){
        case (0, $chJxj.SocialProvider).Google:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ef3n6));
        case (0, $chJxj.SocialProvider).Microsoft:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4lIXK));
        case (0, $chJxj.SocialProvider).Apple:
            return 0, (/*@__PURE__*/$parcel$interopDefault($iEoRg));
        case (0, $chJxj.SocialProvider).Slack:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jwUri));
    }
};
const $6cfc070e67c865a1$var$getSocialLoginHandler = ({ highlightedSocialProvider: highlightedSocialProvider, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    switch(highlightedSocialProvider){
        case (0, $chJxj.SocialProvider).Google:
            return handleGoogleLogin;
        case (0, $chJxj.SocialProvider).Microsoft:
            return handleMicrosoftLogin;
        case (0, $chJxj.SocialProvider).Apple:
            return handleAppleLogin;
        case (0, $chJxj.SocialProvider).Slack:
            return handleSlackLogin;
    }
};
const $6cfc070e67c865a1$var$SocialLoginForm = (props)=>{
    const { highlightedSocialProvider: highlightedSocialProvider, email: email } = props;
    const handleSocialLogin = $6cfc070e67c865a1$var$getSocialLoginHandler(props);
    return /*#__PURE__*/ (0, $6CtE1.jsxs)($6cfc070e67c865a1$var$SocialLoginBlock, {
        "data-testid": "social-login-form",
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsxs)($6cfc070e67c865a1$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)($6cfc070e67c865a1$var$Logo, {
                        src: $6cfc070e67c865a1$var$getLogo(highlightedSocialProvider),
                        alt: `${highlightedSocialProvider} logo`
                    }),
                    email && /*#__PURE__*/ (0, $6CtE1.jsx)($6cfc070e67c865a1$var$Email, {
                        children: email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                isFullWidth: true,
                id: "social-login-submit",
                appearance: "primary",
                onClick: handleSocialLogin,
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...(0, $2AKKZ.default).continueWith,
                    values: {
                        socialProviderName: highlightedSocialProvider.replace(/^./, (str)=>str.toUpperCase())
                    }
                })
            })
        ]
    });
};
var $6cfc070e67c865a1$export$2e2bcd8739ae039 = $6cfc070e67c865a1$var$SocialLoginForm;

});
parcelRegister("2AKKZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc0357f284d3341a$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $bc0357f284d3341a$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    continueWith: {
        id: 'social.login.form.continue-button',
        defaultMessage: 'Continue with {socialProviderName}',
        description: 'Button label that is a CTA for users to continue logging in using the selected social provider.'
    }
});

});


parcelRegister("5A0kF", function(module, exports) {

$parcel$export(module.exports, "LoginPageMessages", function () { return $599a963b63078358$export$81a860015c7169ad; });

var $2CYmK = parcelRequire("2CYmK");
const $599a963b63078358$export$81a860015c7169ad = (0, $2CYmK.defineMessages)({
    headTitle: {
        id: 'login.head.title',
        defaultMessage: 'Log in to continue'
    },
    contextualTitle: {
        id: 'login.contextual.title',
        defaultMessage: 'Continue to',
        description: `Precedes a page title or issue number. For example, "Continue to Sarah's Blogpost" or "Continue to TED-1024"`
    },
    socialAuthOr: {
        id: 'social.auth.or',
        defaultMessage: 'or'
    },
    socialAuthOrContinueWith: {
        id: 'social.auth.or-continue-with',
        defaultMessage: 'Or continue with:'
    },
    createAnAccount: {
        id: 'login.create.an.account',
        defaultMessage: 'Create an account'
    },
    passwordlessSuccessTitle: {
        id: 'login.passwordless.success.title',
        defaultMessage: 'Email sent'
    },
    passwordlessSuccessDescription: {
        id: 'login.passwordless.success.description',
        defaultMessage: "We've sent you an email to log in."
    },
    socialFormHeader: {
        id: 'login.social.form.header',
        defaultMessage: 'Log in',
        description: 'Subtle header shown on the social login form which allows users to login with the chosen social provider'
    },
    socialFormTitle: {
        id: 'login.social.form.title',
        defaultMessage: 'You logged in with your {socialProviderName} account before',
        description: 'Title shown on the social login form which allows users to login with the chosen social provider'
    },
    socialFormUseDifferentLoginMethod: {
        id: 'login.social.form.use-different-login-method',
        defaultMessage: 'Use a different login method',
        description: 'Button label shown on the social login form which allows users to login using another method. Takes the user back to the original login form.'
    },
    continueAs: {
        id: 'continue.as.title.as',
        defaultMessage: 'Continue as',
        description: 'This is a page title that will be followed by an avatar hero with name and email'
    }
});

});

parcelRegister("fSUge", function(module, exports) {

$parcel$export(module.exports, "useMicrobranding", function () { return $f529642493867a65$export$139a16219e014c9b; });

var $aMBBA = parcelRequire("aMBBA");
const $f529642493867a65$var$selectMicrobranding = (state)=>state.microbranding;
const $f529642493867a65$export$139a16219e014c9b = ()=>{
    const microbranding = (0, $aMBBA.useAppSelector)($f529642493867a65$var$selectMicrobranding);
    return {
        oidcContext: microbranding.oidcContext,
        isEmbedded: Boolean(microbranding.isEmbedded),
        isMobileApp: microbranding.isMobileApp,
        isAnyMobile: microbranding.isAnyMobile,
        screenSize: microbranding.screenSize
    };
};

});

parcelRegister("2G8Xj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea99b5c562adacac$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $idMOo = parcelRequire("idMOo");

var $5pCRv = parcelRequire("5pCRv");

var $fhwYP = parcelRequire("fhwYP");

var $cuZAx = parcelRequire("cuZAx");

var $hhYxc = parcelRequire("hhYxc");

var $4NPio = parcelRequire("4NPio");

var $bw067 = parcelRequire("bw067");

var $iZvty = parcelRequire("iZvty");
const $ea99b5c562adacac$var$Footer = ({ isEmbedded: isEmbedded, oidcContext: oidcContext })=>{
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    if (isEmbedded) return null;
    const showHelpLinks = (0, $hhYxc.isIsolatedCloud)() || (0, $hhYxc.isFedM)();
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
        children: [
            showHelpLinks && /*#__PURE__*/ (0, $6CtE1.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.SelfServiceLink), {
                            onClick: ()=>analyticsClient.linkClickedEvent((0, $bw067.loginPageId), 'loginHelpLink')
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $idMOo.default), {}),
                    /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.SupportLink), {
                            onClick: ()=>analyticsClient.linkClickedEvent((0, $bw067.loginPageId), 'contactSupportLink')
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)("ul", {
                className: "fine-print",
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.PrivacyPolicyLink), {
                            isMobileLink: (0, $cuZAx.isMobileOidc)(oidcContext)
                        })
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $idMOo.default), {}),
                    /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5pCRv.UserNoticeLink), {
                            isMobileLink: (0, $cuZAx.isMobileOidc)(oidcContext)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $iZvty.RecaptchaNoticeContainer), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $fhwYP.RecaptchaNotice), {})
            })
        ]
    });
};
var $ea99b5c562adacac$export$2e2bcd8739ae039 = $ea99b5c562adacac$var$Footer;

});
parcelRegister("iZvty", function(module, exports) {

$parcel$export(module.exports, "RecaptchaNoticeContainer", function () { return $ce9b54f3d876ecb1$export$e55f3ed22cb4599; });

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");
const $ce9b54f3d876ecb1$export$e55f3ed22cb4599 = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;

});


parcelRegister("31L3B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04df4a44a4a96a65$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $5A0kF = parcelRequire("5A0kF");

var $dWOVN = parcelRequire("dWOVN");
const $04df4a44a4a96a65$var$Header = ({ highlightedSocialProvider: highlightedSocialProvider, showSocialLoginOnly: showSocialLoginOnly })=>{
    if (showSocialLoginOnly) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
        size: "small",
        as: "h1",
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            ...(0, $5A0kF.LoginPageMessages).socialFormTitle,
            values: {
                socialProviderName: highlightedSocialProvider?.replace(/^./, (str)=>str.toUpperCase())
            }
        })
    });
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
        size: "small",
        as: "h1",
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            ...(0, $5A0kF.LoginPageMessages).headTitle
        })
    });
};
var $04df4a44a4a96a65$export$2e2bcd8739ae039 = $04df4a44a4a96a65$var$Header;

});

parcelRegister("7zp9r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46f10a4861cac161$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $4Cmcw = parcelRequire("4Cmcw");
const $46f10a4861cac161$var$MaybeSocialLoginPanel = ({ isEmbedded: isEmbedded, isSocialBlocked: isSocialBlocked, envSupportsSocialLogin: envSupportsSocialLogin, onGoogleLogin: onGoogleLogin, onMicrosoftLogin: onMicrosoftLogin, onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin })=>{
    if (!envSupportsSocialLogin || isEmbedded || isSocialBlocked) return null;
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $4Cmcw.default), {
        handleGoogleLogin: onGoogleLogin,
        handleMicrosoftLogin: onMicrosoftLogin,
        handleAppleLogin: onAppleLogin,
        handleSlackLogin: onSlackLogin
    });
};
var $46f10a4861cac161$export$2e2bcd8739ae039 = $46f10a4861cac161$var$MaybeSocialLoginPanel;

});

parcelRegister("gTjux", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $beb63275d19c41a4$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $1JRGy = parcelRequire("1JRGy");

var $aMBBA = parcelRequire("aMBBA");

var $bVs8G = parcelRequire("bVs8G");

var $idMOo = parcelRequire("idMOo");

var $eTWY7 = parcelRequire("eTWY7");

var $chJxj = parcelRequire("chJxj");

var $cuZAx = parcelRequire("cuZAx");

var $hhYxc = parcelRequire("hhYxc");

var $5A0kF = parcelRequire("5A0kF");

var $bw067 = parcelRequire("bw067");

var $clE7j = parcelRequire("clE7j");

var $bYQDX = parcelRequire("bYQDX");

var $4NPio = parcelRequire("4NPio");
const $beb63275d19c41a4$var$WhiteboxFooter = ({ isMobileApp: isMobileApp, oidcContext: oidcContext, showSocialLoginOnly: showSocialLoginOnly })=>{
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const isCommercial = (0, $hhYxc.getCurrentCloudType)() === 'commercial';
    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search);
    const signupLinkEnabled = (0, $dNMDr.useMemo)(()=>{
        // Due to Apple Store rules, we don't want sign up link on login page in Mobile OAuth case, unless we provide redirection from login to signup
        const shouldRenderSignupLink = isCommercial && (!isMobileApp || (0, $cuZAx.isOidcDisplayMode)(oidcContext, (0, $chJxj.OidcDisplay).LoginWithRedirect));
        return queryParams.shide !== 'true' && shouldRenderSignupLink;
    }, [
        isCommercial,
        isMobileApp,
        oidcContext,
        queryParams.shide
    ]);
    if (showSocialLoginOnly) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
        id: "use-a-different-login-method",
        spacing: "none",
        onClick: ()=>{
            dispatch((0, $bVs8G.resetLoginForm)());
        },
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            ...(0, $5A0kF.LoginPageMessages).socialFormUseDifferentLoginMethod
        })
    });
    const resetPasswordLinkEnabled = !(0, $hhYxc.isIsolatedCloud)() && !(0, $hhYxc.isFedM)();
    return /*#__PURE__*/ (0, $6CtE1.jsxs)("ul", {
        children: [
            resetPasswordLinkEnabled && /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $clE7j.ResetPasswordLink), {
                    onClick: ()=>analyticsClient.linkClickedEvent((0, $bw067.loginPageId), 'cantLoginLink'),
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "trouble.logging.in",
                        defaultMessage: "Can't log in?"
                    })
                })
            }),
            signupLinkEnabled && /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
                children: [
                    resetPasswordLinkEnabled && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $idMOo.default), {}),
                    /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $bYQDX.LinkToSignupPage), {
                            onClick: ()=>analyticsClient.linkClickedEvent((0, $bw067.loginPageId), 'signUpLink'),
                            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                ...(0, $5A0kF.LoginPageMessages).createAnAccount
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $beb63275d19c41a4$export$2e2bcd8739ae039 = $beb63275d19c41a4$var$WhiteboxFooter;

});
parcelRegister("clE7j", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordLink", function () { return $746621cfb69a105e$export$67fc22a75e0cc5ca; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $e2mzU = parcelRequire("e2mzU");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");
const $746621cfb69a105e$export$67fc22a75e0cc5ca = ({ children: children, onClick: onClick })=>{
    (0, $kfOJC.useRegisterComponent)($746621cfb69a105e$export$67fc22a75e0cc5ca.name);
    const { search: search } = (0, $cVnBY.useLocation)();
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $e2mzU.default), {
        href: '/login/resetpassword' + search,
        id: "resetPassword",
        onClick: onClick,
        children: children
    });
};

});

parcelRegister("bYQDX", function(module, exports) {

$parcel$export(module.exports, "LinkToSignupPage", function () { return $1b09652f298bd92b$export$d592e43397b27498; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $e2mzU = parcelRequire("e2mzU");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");
const $1b09652f298bd92b$export$d592e43397b27498 = ({ children: children, onClick: onClick })=>{
    const { search: search } = (0, $cVnBY.useLocation)();
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $e2mzU.default), {
        href: '/signup' + search,
        id: "signup",
        onClick: onClick,
        children: children
    });
};

});


parcelRegister("7FWgq", function(module, exports) {

$parcel$export(module.exports, "useLoginRecoveryOptions", function () { return $3ec991e61eceafa7$export$7355ce4dcfe6714; });
$parcel$export(module.exports, "useCobrandingApplication", function () { return $3ec991e61eceafa7$export$1d0a4295a0540e3; });
$parcel$export(module.exports, "useSearchParamCodes", function () { return $3ec991e61eceafa7$export$e66bdd3af3ee2b13; });
$parcel$export(module.exports, "useEmailFromSearchParams", function () { return $3ec991e61eceafa7$export$79b4d72483651c8e; });
$parcel$export(module.exports, "useAppendReasonViewingScreen", function () { return $3ec991e61eceafa7$export$833646c3f87e042d; });

var $dNMDr = parcelRequire("dNMDr");

var $cVnBY = parcelRequire("cVnBY");

var $lwrli = parcelRequire("lwrli");

var $fcxz7 = parcelRequire("fcxz7");

var $lCnOB = parcelRequire("lCnOB");

var $aMBBA = parcelRequire("aMBBA");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");
const $3ec991e61eceafa7$export$7355ce4dcfe6714 = ()=>{
    const login = (0, $aMBBA.useAppSelector)((state)=>state.login);
    const loginRecoveryOptions = (0, $dNMDr.useCallback)((email)=>{
        return login?.recoveryToken && email ? {
            expectedEmail: email,
            recoveryToken: login.recoveryToken
        } : undefined;
    }, [
        login?.recoveryToken
    ]);
    return loginRecoveryOptions;
};
const $3ec991e61eceafa7$export$1d0a4295a0540e3 = ()=>{
    const cobranding = (0, $aMBBA.useAppSelector)((state)=>state.cobranding);
    const applicationData = (0, $dNMDr.useMemo)(()=>{
        if (cobranding === undefined) return null;
        return (0, $fcxz7.lookupApplication)(cobranding);
    }, [
        cobranding
    ]);
    return applicationData?.coreApplication;
};
const $3ec991e61eceafa7$export$e66bdd3af3ee2b13 = ()=>{
    const location = (0, $cVnBY.useLocation)();
    const queryParams = Object.fromEntries(new URLSearchParams(location.search).entries());
    const infoCode = (0, $dNMDr.useMemo)(()=>queryParams.infoCode ? {
            code: queryParams.infoCode
        } : null, [
        queryParams.infoCode
    ]);
    const errorCode = (0, $dNMDr.useMemo)(()=>queryParams.errorCode ? {
            code: queryParams.errorCode
        } : null, [
        queryParams.errorCode
    ]);
    return {
        errorCode: errorCode,
        infoCode: infoCode
    };
};
const $3ec991e61eceafa7$export$79b4d72483651c8e = ()=>{
    (0, $kfOJC.useRegisterComponent)($3ec991e61eceafa7$export$79b4d72483651c8e.name);
    const loginHint = (0, $lCnOB.useLoginHint)();
    const [queryParams] = (0, $lwrli.useSearchParams)();
    return (0, $lCnOB.getEmailFromLoginHint)(loginHint) || queryParams.get('email') || '';
};
const $3ec991e61eceafa7$export$833646c3f87e042d = ()=>{
    const { search: search } = (0, $cVnBY.useLocation)();
    const infoCode = (0, $dNMDr.useMemo)(()=>{
        const queryParams = new URLSearchParams(search);
        return queryParams.has('infoCode') ? {
            code: queryParams.get('infoCode')
        } : null;
    }, [
        search
    ]);
    const appendReasonViewingScreen = (0, $dNMDr.useCallback)((eventAttributes)=>{
        if (infoCode) switch(infoCode.code){
            case 'migratingExistingUser':
                return {
                    ...eventAttributes,
                    reasonViewingScreen: 'migratingUser'
                };
            case 'existingUserSignupAttempt':
                return {
                    ...eventAttributes,
                    reasonViewingScreen: 'existingUserSignupAttempt'
                };
            case 'invitedUser':
                return {
                    ...eventAttributes,
                    reasonViewingScreen: 'invitedUser'
                };
            default:
                return eventAttributes;
        }
        return eventAttributes;
    }, [
        infoCode
    ]);
    return appendReasonViewingScreen;
};

});

parcelRegister("iQDyE", function(module, exports) {

$parcel$export(module.exports, "useLogin", function () { return $b7542e639d4c380d$export$d4e22f05f73ea56b; });

var $dNMDr = parcelRequire("dNMDr");

var $cVnBY = parcelRequire("cVnBY");

var $bVs8G = parcelRequire("bVs8G");

var $da2qN = parcelRequire("da2qN");

var $hzllM = parcelRequire("hzllM");

var $aMBBA = parcelRequire("aMBBA");

var $chJxj = parcelRequire("chJxj");

var $4NPio = parcelRequire("4NPio");

var $cuZAx = parcelRequire("cuZAx");

var $bw067 = parcelRequire("bw067");

var $7FWgq = parcelRequire("7FWgq");

var $c7MmN = parcelRequire("c7MmN");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $ko1o6 = parcelRequire("ko1o6");

var $4nAxm = parcelRequire("4nAxm");

var $YVS07 = parcelRequire("YVS07");

var $21HHk = parcelRequire("21HHk");

var $h4v4M = parcelRequire("h4v4M");
const $b7542e639d4c380d$export$d4e22f05f73ea56b = ({ autoCheckUsername: autoCheckUsername = true } = {
    autoCheckUsername: true
})=>{
    (0, $kfOJC.useRegisterComponent)($b7542e639d4c380d$export$d4e22f05f73ea56b.name);
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const location = (0, $cVnBY.useLocation)();
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const queryParams = (0, $dNMDr.useMemo)(()=>Object.fromEntries(new URLSearchParams(location.search).entries()), [
        location.search
    ]);
    const { rememberMeEnabled: rememberMeEnabled, rememberedAccounts: rememberedAccounts, isRememberMeChecked: isRememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox } = (0, $21HHk.useRememberMe)();
    const isUsernameChecked = (0, $aMBBA.useAppSelector)((state)=>state.login?.isUsernameChecked);
    const isCheckingUsername = (0, $aMBBA.useAppSelector)((state)=>state.login?.isCheckingUsername);
    const isLoggingIn = (0, $aMBBA.useAppSelector)((state)=>state.login?.isLoggingIn);
    const passwordless = (0, $aMBBA.useAppSelector)((state)=>state.login?.passwordless);
    const usernameExists = (0, $aMBBA.useAppSelector)((state)=>state.login?.usernameExists);
    const nextAttemptCount = (0, $aMBBA.useAppSelector)((state)=>state.login?.nextAttempt);
    const redirectUrl = (0, $aMBBA.useAppSelector)((state)=>state.login?.redirectUrl);
    const redirectType = (0, $aMBBA.useAppSelector)((state)=>state.login?.redirectType);
    const isMobileApp = (0, $aMBBA.useAppSelector)((state)=>state.microbranding.isMobileApp);
    const isAnyMobile = (0, $aMBBA.useAppSelector)((state)=>state.microbranding.isAnyMobile);
    const restrictedEmail = (0, $aMBBA.useAppSelector)((state)=>state.login?.restrictedEmail);
    const error = (0, $aMBBA.useAppSelector)((state)=>state.login?.error);
    const checkUsernameError = (0, $aMBBA.useAppSelector)((state)=>state.login?.fieldErrors?.email);
    const destinationOrgId = (0, $aMBBA.useAppSelector)((state)=>state.orgLoginConfig.organisationId);
    const orgLoginConfigSaml = (0, $aMBBA.useAppSelector)((state)=>state.orgLoginConfig.samlConnectionId);
    const orgLoginConfigAutoRedirect = (0, $aMBBA.useAppSelector)((state)=>state.orgLoginConfig.autoRedirect);
    const isRestrictedEmail = restrictedEmail || queryParams?.restrict === 'true';
    const isLoading = isCheckingUsername || isLoggingIn;
    const oidcContext = (0, $aMBBA.useAppSelector)((state)=>state.microbranding.oidcContext);
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const loginRecoveryOptions = (0, $7FWgq.useLoginRecoveryOptions)();
    const application = (0, $7FWgq.useCobrandingApplication)();
    const loginPrompt = queryParams?.prompt;
    // redirect
    (0, $dNMDr.useEffect)(()=>{
        const shouldRedirect = !isMobileApp || (0, $cuZAx.isOidcDisplayMode)(oidcContext, (0, $chJxj.OidcDisplay).LoginWithRedirect);
        if (redirectUrl) navigate(redirectUrl);
        else if (!isLoading && isUsernameChecked && !usernameExists && shouldRedirect) {
            dispatch((0, $bVs8G.resetLoginForm)());
            analyticsClient.operationalEvent({
                page: (0, $bw067.loginPageId),
                subject: 'loginAttempt',
                action: 'redirectedToSignup'
            });
            if (location.search.length === 0) navigate('/signup?redirectedFrom=login');
            else navigate(`/signup${location.search}&redirectedFrom=login`);
        }
    }, [
        analyticsClient,
        application,
        dispatch,
        navigate,
        isAnyMobile,
        isLoading,
        isMobileApp,
        isUsernameChecked,
        oidcContext,
        redirectUrl,
        usernameExists,
        location.search
    ]);
    const [isCheckUsernameCaptchaLoading, setIsCheckUsernameCaptchaLoading] = (0, $dNMDr.useState)(false);
    const { errorCode: errorCode, infoCode: infoCode } = (0, $7FWgq.useSearchParamCodes)();
    // This 'combines' multiple error sources into one for easier consumption downstream.
    // 1. redux store (page state from API)
    // 2. Any error code set externally via URL search param.
    const combinedError = (0, $dNMDr.useMemo)(()=>error || errorCode, [
        error,
        errorCode
    ]);
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const signupLink = (0, $YVS07.useSignupLink)();
    const combinedErrorWithMessage = (0, $dNMDr.useMemo)(()=>{
        if (!combinedError) return;
        const message = (0, $4nAxm.buildLoginErrorMessage)({
            error: combinedError,
            formatMessage: formatMessage,
            signupLink: signupLink,
            nextAttempt: nextAttemptCount,
            application: application
        });
        return {
            ...combinedError,
            message: message
        };
    }, [
        combinedError,
        formatMessage,
        signupLink,
        nextAttemptCount,
        application
    ]);
    const { isLoaded: recaptchaIsLoaded, recaptchaType: recaptchaType, fetchToken: fetchToken } = (0, $hzllM.useRecaptchaContext)();
    const dispatchCaptchaFailure = (0, $dNMDr.useCallback)(()=>{
        dispatch((0, $bVs8G.checkUsernameCaptchaFailure)(navigator.onLine));
    }, [
        dispatch
    ]);
    const fetchRecaptchaToken = (0, $dNMDr.useCallback)(async ()=>{
        try {
            setIsCheckUsernameCaptchaLoading(true);
            (0, $da2qN.recaptchaCheckUsernameFetchTokenInteraction).start();
            const challengeResponse = await fetchToken();
            (0, $da2qN.recaptchaCheckUsernameFetchTokenInteraction).stop({
                customData: {
                    restrict: isRestrictedEmail
                }
            });
            return challengeResponse;
        } catch (error) {
            analyticsClient.errorShownEvent((0, $bw067.loginPageId), 'recaptchaError', {
                errorMessage: error.message
            });
            dispatchCaptchaFailure();
            return null;
        } finally{
            setIsCheckUsernameCaptchaLoading(false);
        }
    }, [
        analyticsClient,
        dispatchCaptchaFailure,
        isRestrictedEmail,
        fetchToken
    ]);
    const onValidationError = (0, $dNMDr.useCallback)((errors)=>dispatch((0, $bVs8G.showFormErrors)(errors)), [
        dispatch
    ]);
    /**
   * @param username username to check the redirect that's required (e.g. SSO). Usually an email address.
   * @param rememberOverride used to override the current states value for the remember me checkbox. Used when selecting an SSO user from the remembered accounts page.
   */ const checkUsername = (0, $dNMDr.useCallback)(async (username, rememberOverride)=>{
        let challengeResponse = null;
        const remember = rememberOverride ?? isRememberMeChecked;
        const query = {
            ...queryParams,
            email: username
        };
        if (remember) dispatch((0, $bVs8G.setRememberMeCheckbox)(true));
        delete query.errorCode;
        const searchParams = new URLSearchParams(query);
        navigate(`/login?${searchParams.toString()}${location.hash}`);
        // Using the state to "hack" loading state for selecting a remembered account.
        dispatch((0, $bVs8G.requestCheckUsername)());
        if (recaptchaIsLoaded) challengeResponse = await fetchRecaptchaToken();
        analyticsClient.formSubmittedEvent((0, $bw067.loginPageId), 'checkUsername', {
            recaptchaType: challengeResponse?.type,
            rememberMeChecked: !!remember
        });
        const checkUsernameParams = new URLSearchParams(location.search);
        // if remember me is enabled, then we also include `remember`
        if (remember) checkUsernameParams.append('remember', 'true');
        dispatch((0, $bVs8G.checkUsername)({
            analyticsClient: analyticsClient,
            username: username,
            params: `?${checkUsernameParams.toString()}`,
            recoveryToken: loginRecoveryOptions(username)?.recoveryToken,
            challengeResponse: challengeResponse,
            destinationOrgId: destinationOrgId
        }));
        dispatch((0, $c7MmN.fetchConsentConfig)(username));
    }, [
        isRememberMeChecked,
        queryParams,
        navigate,
        location.hash,
        location.search,
        dispatch,
        recaptchaIsLoaded,
        analyticsClient,
        loginRecoveryOptions,
        fetchRecaptchaToken,
        destinationOrgId
    ]);
    const emailFromSearchParams = (0, $7FWgq.useEmailFromSearchParams)();
    // This code is intended to auto-submit the check-username request if email is restricted
    (0, $dNMDr.useEffect)(()=>{
        const handleMount = async ()=>{
            if (!recaptchaIsLoaded) return;
            if (!autoCheckUsername) return;
            if (!isRestrictedEmail) return;
            const emailWithDefault = emailFromSearchParams || '';
            if (!emailWithDefault) return;
            // recaptchaType 'checkbox' should not be auto-submitted
            if (recaptchaType === 'score') await checkUsername(emailWithDefault);
        };
        handleMount();
    // We only want this to run when the component mounts or
    // when recaptcha.isLoaded becomes true (if it was false)
    // We need to investigate why `useRecaptcha` always returns a new object,
    // So we can remove this eslint-disable rule and add all the correct dependencies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        recaptchaIsLoaded
    ]);
    const resetLogin = (0, $dNMDr.useCallback)(()=>dispatch((0, $bVs8G.resetLoginForm)()), [
        dispatch
    ]);
    const isPasswordlessAllowed = passwordless !== (0, $chJxj.CheckUserNamePasswordlessType).Disallowed && !(0, $cuZAx.isMobileOidc)(oidcContext);
    const isCheckUsernameLoading = isCheckingUsername || isCheckUsernameCaptchaLoading;
    // This prevents redirecting to the list of remembered accounts in certain situations.
    // TODO: KIRBY-8427: consider moving this check into a separate hook to avoid calling
    //                   `useLogin` for the check in the login OrchestratedPage.
    const shouldShowRememberedAccounts = rememberMeEnabled && emailFromSearchParams === '' && // Account has been selected in query params
    !isCheckUsernameLoading && // Email in query params can get removed while checking username
    ![
        'true',
        'login'
    ].includes(loginPrompt || '') && // Login page is not forced to render
    !(orgLoginConfigSaml && orgLoginConfigAutoRedirect) && // Org Login Config SAML is configured and auto redirect is enabled, we need to redirect to SAML login page
    rememberedAccounts && rememberedAccounts.length > 0;
    return {
        isPasswordlessAllowed: /**
     * Indicates whether the user is eligible to log in via a link emailed to them.
     * */ isPasswordlessAllowed,
        isUsernameChecked: /**
     * Reflects the state of the first essential step of the login process.
     *
     * Will be false until `checkUsername` has been called. True thereafter (until reset via
     * a call to `resetLogin`).
     *
     * */ isUsernameChecked,
        isCheckUsernameLoading: /**
     * Reflects loading state following a call to `checkUsername`.
     * */ isCheckUsernameLoading,
        checkUsernameError: /**
     * Indicates the reason `checkUsername` has failed. See type definition for details.
     * */ checkUsernameError,
        isRestrictedEmail: /**
     * Indicates whether the user's username/email has been deemed restricted. In such cases,
     * `checkUsername` will be called automatically for this username, unless opted out by setting
     * the `autoCheckUsername` option to `false` in the args to `useLogin`.
     *
     * For example, the username may be restricted by admins in the user's org.
     * */ isRestrictedEmail,
        checkUsername: /**
     * This is the essential first step of the login process.
     *
     * @warning NOTE: Until this handler has been called, username and password submission will not work.
     *
     * This function handles the `checkUsername` API call to sign-in-service, which we use to handle the redirect for a user given their
     * configuration (e.g. password user, SSO user, social user, etc).
     *
     * This must be called by any cobranding that implements the login page.
     * */ checkUsername,
        loginPrompt: /**
     * Login "prompt" query parameter. If set, shows the email input to the user.
     * In case of `select_account` value, the user is redirected to the account switcher.
     * */ loginPrompt,
        /**
     * Indicates that login has failed for a particular reason. See type definition for details.
     * */ error: combinedErrorWithMessage,
        infoCode: /**
     * An externally set code indicating a message for the user may need to be rendered. See type
     * definition for details.
     * */ infoCode,
        nextAttemptCount: /**
     * The number of times the user will have attempted to login (at their next attempt). After a
     * certain number of attempts, it may be desirable to render a message directing the user to try
     * to reset their password.
     *
     * (The base login experience does this when the count is greater than 4).
     * */ nextAttemptCount,
        redirectUrl: /**
     * The URL to which the user ought to be redirected, as indicated by the server. This
     * redirection will be automatic unless opted out in the args to `useLogin`.
     * */ redirectUrl,
        redirectType: /**
     * Indicates the reason given by the server for redirecting the user. Useful for rendering
     * relevant UI while the redirect is taking place (e.g. SSO).
     * */ redirectType,
        resetLogin: /**
     * Resets the state of the login process back to the first step (where `checkUsername` must be
     * called again).
     *
     * Should be called when user has chosen to enter a different username than the one they had
     * already entered.
     * */ resetLogin,
        rememberMeEnabled: /**
     * Whether or not the `remember me` feature is enabled.
     *
     * Re-exported from `useRememberMe` hook for convenience.
     * */ rememberMeEnabled,
        rememberedAccounts: /**
     * The list of accounts that have been remembered by the user.
     *
     * Re-exported from `useRememberMe` hook for convenience.
     * */ rememberedAccounts,
        shouldShowRememberedAccounts: /**
     * Whether or not to show the remembered accounts list.
     */ shouldShowRememberedAccounts,
        isRememberMeChecked: /**
     * Whether or not the remember me checkbox is checked. Used to pre-check the checkbox when selecting a remembered account.
     *
     * Re-exported from `useRememberMe` hook for convenience.
     */ isRememberMeChecked,
        onToggleRememberMeCheckbox: /**
     * Toggles the remember me checkbox.'
     *
     * Re-exported from `useRememberMe` hook for convenience.
     */ onToggleRememberMeCheckbox,
        onValidationError: /**
     * Used to provide any additional errors (i.e. ones that aren't provided directly by this hook) that should be rendered on the login page.
     *
     * @param errors any errors that should be shown in the login form.
     */ onValidationError
    };
};

});
parcelRegister("da2qN", function(module, exports) {

$parcel$export(module.exports, "recaptchaCheckUsernameFetchTokenInteraction", function () { return $5b3ad845e21bdc52$export$b7874a5a14992cfe; });

var $1qlo3 = parcelRequire("1qlo3");
const $5b3ad845e21bdc52$export$b7874a5a14992cfe = (0, $1qlo3.metrics).interaction({
    key: 'aid-frontend-recaptcha-fetch-token-check-username'
});

});

parcelRegister("c7MmN", function(module, exports) {

$parcel$export(module.exports, "fetchConsentConfig", function () { return $9e81a211e25afc93$export$58e2aa80c90a0ce1; });

var $hqddj = parcelRequire("hqddj");
const $9e81a211e25afc93$export$cff006d34f7616ad = (config)=>({
        type: 'UPDATE_MARKETING_CONSENT_CONFIG',
        config: config
    });
const $9e81a211e25afc93$export$58e2aa80c90a0ce1 = (email)=>(dispatch)=>{
        return fetch('/rest/marketing-consent/config', {
            method: 'POST',
            credentials: 'omit',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email
            })
        }).then((response)=>{
            if (response.status === 200) return response.json().then((cfg)=>dispatch($9e81a211e25afc93$export$cff006d34f7616ad(cfg)));
            else if (response.status === 204) {
                // No response from ConsentHub for some reason
                const level = 'warning';
                (0, $hqddj.captureMessage)('Unable to retrieve marketing consent config', {
                    status: response.status,
                    reason: 'no_content'
                }, level);
            } else if (response.status === 400) {
                // Signup was unable to extract IP
                const level = 'warning';
                (0, $hqddj.captureMessage)('Unable to retrieve marketing consent config', {
                    status: response.status,
                    reason: 'cannot_extract_ip'
                }, level);
            } else return response.text().then((error)=>{
                throw new Error(error || response.statusText);
            });
        }).catch((0, $hqddj.captureException));
    };

});

parcelRegister("4nAxm", function(module, exports) {

$parcel$export(module.exports, "buildLoginErrorMessage", function () { return $3257c2c35efac076$export$7a0831816210b6bb; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $e2mzU = parcelRequire("e2mzU");

var $5pCRv = parcelRequire("5pCRv");

var $hhYxc = parcelRequire("hhYxc");

var $clE7j = parcelRequire("clE7j");
const $3257c2c35efac076$export$7a0831816210b6bb = ({ error: error, formatMessage: formatMessage, signupLink: signupLink, nextAttempt: nextAttempt, application: application })=>{
    if (!error) return;
    const { args: args = {} } = error;
    switch(error?.code){
        case 'captcha':
            return formatMessage({
                id: 'login.error.captcha',
                defaultMessage: 'We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support.'
            });
        case 'captchaScoreTooLow':
            return formatMessage({
                id: 'login.error.captcha.score_too_low',
                defaultMessage: "We'd like to make sure it's really you. Please confirm you're not a robot.",
                description: 'Message asking user to tick the reCAPTCHA checkbox and resubmit the form'
            });
        case 'invalid_user_password':
            return $3257c2c35efac076$var$incorrectCredentialsErrorMessage(formatMessage, nextAttempt, signupLink, application);
        case 'ambiguous_user':
            return formatMessage({
                id: 'login.error.details.ambiguous',
                defaultMessage: 'It seems that you have multiple accounts associated with your email. Please contact your administrator to remove the duplicate.'
            });
        case 'no_email_on_remote_user':
            return formatMessage({
                id: 'login.error.remote.user.no.email',
                defaultMessage: "Your {username} user doesn't have an associated email address, so we can't create your Atlassian account. Please contact support."
            }, {
                ...args
            });
        case 'bitbucket_username_is_not_email':
            return formatMessage({
                id: 'login.error.remote.user.using.username',
                defaultMessage: 'You can no longer log in with a username. Use your primary email address {username} instead.'
            }, {
                ...args
            });
        case 'username_is_not_email':
            return formatMessage({
                id: 'login.error.email.not.username',
                defaultMessage: 'You must use your email address to log in. Did you mean to use {username}?'
            }, {
                ...args
            });
        case 'bitbucket_email_is_not_primary':
            return formatMessage({
                id: 'login.error.remote.user.using.alias',
                defaultMessage: 'You can no longer log in with an email alias. Use your primary email address {username} instead.'
            }, {
                ...args
            });
        case 'bitbucket_mfa_enforced':
            return formatMessage({
                id: 'login.error.user.mfa.enforced',
                defaultMessage: 'Your organization wants you to secure your account by setting up two-step verification.'
            }, {
                ...args
            });
        case 'bitbucket_mfa_required':
            return formatMessage({
                id: 'login.error.user.mfa.required',
                defaultMessage: 'For added security, your organization wants you to log in with two-step verification.'
            }, {
                ...args
            });
        case 'bitbucket_saml_user':
            return formatMessage({
                id: 'login.error.saml.user',
                defaultMessage: 'For added security, your organization wants you to log in with single sign-on.'
            }, {
                ...args
            });
        case 'email_is_not_primary':
            return formatMessage({
                id: 'login.error.email.not.username',
                defaultMessage: 'You must use your email address to log in. Did you mean to use {username}?'
            }, {
                ...args
            });
        case 'too_many_logins':
        case 'too_many_requests':
            return formatMessage({
                id: 'login.error.too.many.logins',
                defaultMessage: "For security purposes, we've temporarily locked your account due to multiple log in attempts within a short period of time. Please try again in a few minutes. If this issue persists, please contact Atlassian Support."
            });
        case 'multiple_google_accounts':
            return formatMessage({
                id: 'login.error.google.auth.contact.support',
                defaultMessage: "We've encountered problems signing you in with your Google Account. Please contact support to resolve this problem."
            });
        case 'unable_to_verify_google_token':
            return formatMessage({
                id: 'login.error.unable.to.verify.google.token',
                defaultMessage: 'We were unable to verify your Google Account. Please try again later.'
            });
        case 'google_email_change_not_allowed_by_auth_policy':
            return formatMessage({
                id: 'login.error.google.email.change.not.allowed.by.auth.policy',
                defaultMessage: "Sorry, we detected an email change that is not supported by your organization's authentication policy. Please log in with an email address that matches your account."
            });
        case 'google_email_change_not_allowed_by_user_managed_status':
            return formatMessage({
                id: 'login.error.google.email.change.not.allowed.by.user.managed.status',
                defaultMessage: 'We detected an email change that would remove you from your organization. Contact your organization admin to check your account is configured correctly or try to log in a different way.'
            });
        case 'social_login_missing_email':
            return formatMessage({
                id: 'login.error.social.missing.email',
                defaultMessage: 'We did not receive a valid email address from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_missing_email_verified':
            return formatMessage({
                id: 'login.error.social.missing.email.verified',
                defaultMessage: 'We did not receive a valid email verification from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_unexpected_login_type':
            return formatMessage({
                id: 'login.error.social.unexpected.login.type',
                defaultMessage: 'We did not receive valid information from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_missing_slack_email_date_verified':
            return formatMessage({
                id: 'login.error.slack.missing.email.date.verified',
                defaultMessage: 'We did not receive a valid email date verified from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_invalid_social_id':
            return formatMessage({
                id: 'login.error.social.invalid.social.id',
                defaultMessage: 'We did not receive valid id from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'slack_login_invalid_team_id':
            return formatMessage({
                id: 'login.error.slack.invalid.team.id',
                defaultMessage: 'We did not receive valid team id from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_managed_user':
            return formatMessage({
                id: 'login.error.social.managed.user',
                defaultMessage: "Hmm... we're having trouble logging you in. Please try again with a different authentication method."
            });
        case 'social_login_requires_password_change':
            return formatMessage({
                id: 'login.error.social.requires.password.change',
                defaultMessage: 'Your current password has expired, so you need to reset your password to continue.'
            });
        case 'social_login_hide_email_change_not_allowed_to_bypass_policy':
            return formatMessage({
                id: 'login.error.social.hide.email.change.not.allowed.to.bypass.policy',
                defaultMessage: 'Sorry, you cannot hide your email once you are part of an organization. Please ensure that you share your real email.'
            });
        case 'social_login_email_change_not_allowed_to_bypass_policy':
            return formatMessage({
                id: 'login.error.social.email.change.not.allowed.to.bypass.policy',
                defaultMessage: "Sorry, we detected an email change that is not supported by your organization's authentication policy. Please log in with a email address that matches your account."
            });
        case 'social_login_email_change_not_allowed':
            return formatMessage({
                id: 'login.error.social.email.change.not.allowed',
                defaultMessage: 'We detected an email change that would remove you from your organization. Contact your organization admin to check your account is configured correctly or try to log in a different way.'
            });
        case 'social_login_consent_required':
            return formatMessage({
                id: 'login.error.social.login.consent.required',
                defaultMessage: 'Please grant access to your account details if you wish to login to your Atlassian account.'
            });
        case 'user_is_blocked':
            return formatMessage({
                id: 'login.error.user.blocked',
                defaultMessage: 'This account has been deactivated. Please contact your organization admin.'
            });
        case 'social_login_banned':
            return formatMessage({
                id: 'login.error.social.login.banned',
                defaultMessage: 'Your admin has blocked third-party login. Log in with your email address instead.'
            });
        case 'apple_login_disabled':
            return formatMessage({
                id: 'login.error.apple.login.disabled',
                defaultMessage: 'Sorry, it is not possible to log in with Apple at this time. We are working on it.'
            });
        case 'microsoft_login_disabled':
            return formatMessage({
                id: 'login.error.microsoft.login.disabled',
                defaultMessage: 'Sorry, it is not possible to log in with Microsoft at this time. We are working on it.'
            });
        case 'slack_login_disabled':
            return formatMessage({
                id: 'login.error.slack.login.disabled',
                defaultMessage: 'Sorry, it is not possible to log in with Slack at this time. We are working on it.'
            });
        case 'password_leaked':
            // In IC environments, don't show reset password link
            if ((0, $hhYxc.isIsolatedCloud)()) return formatMessage({
                id: 'login.error.password.leaked.ic',
                defaultMessage: 'You must change your password to log in. Your current password has appeared in an external data breach and your Atlassian account is at risk. Please contact your administrator. <password-leaked-link>Learn more</password-leaked-link>'
            }, {
                'password-leaked-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("a", {
                        href: (0, $5pCRv.PASSWORD_LEAKED_LINK),
                        children: chunks
                    })
            });
            return formatMessage({
                id: 'login.error.password.leaked.xml',
                defaultMessage: 'You must <reset-password-link>change your password</reset-password-link> to log in. Your current password has appeared in an external data breach and your Atlassian account is at risk. <password-leaked-link>Learn more</password-leaked-link>'
            }, {
                'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $clE7j.ResetPasswordLink), {
                        children: chunks
                    }),
                'password-leaked-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("a", {
                        href: (0, $5pCRv.PASSWORD_LEAKED_LINK),
                        children: chunks
                    })
            });
        case 'client_ip_not_allowed':
        case 'client_ip_missing':
            return formatMessage({
                id: 'login.error.client.ip.not.allowed',
                defaultMessage: 'Your IP address is not allowed to log in to this account. Please contact your organization admin for assistance.'
            });
        case 'login.form.token.expired':
            return formatMessage({
                id: 'login.error.token.expired',
                defaultMessage: 'Your login request has expired.'
            });
        case 'login.form.problem.encountered':
            return formatMessage({
                id: 'login.error.problem.encountered',
                defaultMessage: "We've encountered a problem. Please try again in a few minutes."
            });
        case 'login.form.email.does.not.match.loggedin.user':
            return formatMessage({
                id: 'login.form.email.does.not.match.loggedin.user',
                defaultMessage: "You're currently logged in as {username}, logging in as another user will log you out of your current session."
            }, {
                ...args
            });
        case 'hosted_domain_mismatch':
            return formatMessage({
                id: 'google.hosted.domain.mismatch',
                defaultMessage: 'Unable to log in with Google. Contact your admin to check your account is configured correctly or try to log in a different way.'
            });
        case 'switch.session.expired':
            return formatMessage({
                id: 'session.switch.error.expired',
                defaultMessage: 'Your account session expired. Log in again to continue.'
            });
        case 'request_error':
            return formatMessage({
                id: 'network.request.error',
                defaultMessage: 'Unable to connect. Check your internet connection or the network settings for your browser and try again.'
            });
        case 'invalid.session.token':
            return formatMessage({
                id: 'invalid.session.token',
                defaultMessage: 'Your session token is invalid. Log in again to continue.'
            });
        case 'verify.email.expired':
            return formatMessage({
                id: 'verify.email.expired',
                defaultMessage: 'Your email verification attempt has expired. Enter your email address and try again.'
            });
        case 'verify.email.error':
            return formatMessage({
                id: 'verify.email.error',
                defaultMessage: 'Something went wrong while verifying your email address. Enter your email address and try again.'
            });
        case 'too_many_username_requests':
            return formatMessage({
                id: 'check.username.rate.limit.exceeded',
                defaultMessage: 'Too many login attempts detected. Please wait for a few minutes before trying again.'
            });
        case 'generic-consent-error':
            return formatMessage({
                id: 'generic-consent-error',
                defaultMessage: 'To access this page, you must accept the Privacy Notice.'
            });
        case 'consent-validation-error':
            return formatMessage({
                id: 'consent-validation-error',
                defaultMessage: 'Something went wrong while attempting to validate your consent. Try logging in again later.'
            });
        case 'consent-loading-error':
            return formatMessage({
                id: 'consent-loading-error',
                defaultMessage: 'Something went wrong while loading the consent screen. Try logging in again later.'
            });
        case 'remember-me-cookie-error':
            return formatMessage({
                id: 'remember-me-cookie-error',
                defaultMessage: 'Something went wrong while loading your remembered accounts. Log in again to continue.'
            });
        case 'invalid_passkey':
            return formatMessage({
                id: 'invalid-passkey-error',
                defaultMessage: 'The provided passkey is invalid. Please try again with a different authentication method.'
            });
        case 'passkey_managed_account':
            return formatMessage({
                id: 'managed-account-passkey-error',
                defaultMessage: "Hmm... we're having trouble logging you in. Please try again with a different authentication method."
            });
        case 'webauthn_not_supported':
            return formatMessage({
                id: 'webauthn-not-supported-error',
                defaultMessage: "We\u2019re unable to verify your passkey. Make sure your browser supports WebAuthn."
            });
        case 'webauthn_challenge_failed':
            return formatMessage({
                id: 'webauthn-challenge-failed-error',
                defaultMessage: "Your passkey couldn\u2019t complete the authentication. Try again. If this keeps happening, contact support."
            });
        case 'contactOrgAdmin':
            return formatMessage({
                id: 'login.error.contact.org.admin',
                defaultMessage: 'Something went wrong. Contact your organization admin for assistance.'
            });
        default:
            return formatMessage({
                id: 'login.error.unknown',
                defaultMessage: 'Something went wrong while attempting to validate your credentials.'
            });
    }
};
const $3257c2c35efac076$var$incorrectCredentialsErrorMessage = (formatMessage, nextAttempt, signupLink, application)=>{
    // IC environments don't have self-serve password reset
    if ((0, $hhYxc.isIsolatedCloud)()) return formatMessage({
        id: 'login.error.invalid.credentials.ic',
        defaultMessage: 'Incorrect email address and/or password. Try again.'
    });
    if (nextAttempt > 4) return formatMessage({
        id: 'login.error.invalid.credentials.more.help.xml',
        defaultMessage: "We've recently made changes to the login page. If you are having difficulty logging in, <reset-password-link>reset your password</reset-password-link>."
    }, {
        'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $clE7j.ResetPasswordLink), {
                children: chunks
            })
    });
    else if (application === 'trello') return formatMessage({
        id: 'login.error.invalid.credentials.trello.specific.help.xml',
        defaultMessage: 'Incorrect email address and / or password. If you recently migrated your Trello account to an Atlassian account, you will need to use your Atlassian account password. Alternatively, you can get help <reset-password-link>logging in</reset-password-link>.'
    }, {
        'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $clE7j.ResetPasswordLink), {
                children: chunks
            })
    });
    else {
        // Fedramp doesn't have a sign up flow, so we don't want to show the sign up link.
        if ((0, $hhYxc.isFedM)()) return formatMessage({
            id: 'login.error.invalid.credentials.xml',
            defaultMessage: 'Incorrect email address and/or password. Try again or <reset-password-link>reset your password</reset-password-link>.'
        }, {
            'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $clE7j.ResetPasswordLink), {
                    children: chunks
                })
        });
        const invalidCredentials = formatMessage({
            id: 'login.error.invalid.credentials.xml',
            defaultMessage: 'Incorrect email address and/or password. Try again or <reset-password-link>reset your password</reset-password-link>.'
        }, {
            'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $clE7j.ResetPasswordLink), {
                    children: chunks
                })
        });
        const signupSuffix = formatMessage({
            id: 'login.error.invalid.credentials.xml.sign_up',
            defaultMessage: '<sign-up-link>Sign up</sign-up-link> for an Atlassian account.'
        }, {
            'sign-up-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $e2mzU.default), {
                    href: signupLink,
                    children: chunks
                })
        });
        return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
            children: [
                invalidCredentials,
                /*#__PURE__*/ (0, $6CtE1.jsx)("br", {}),
                signupSuffix
            ]
        });
    }
};

});

parcelRegister("YVS07", function(module, exports) {

$parcel$export(module.exports, "useSignupLink", function () { return $8cc447774542b305$export$2608a74d725f1f9f; });
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");
const $8cc447774542b305$export$2608a74d725f1f9f = ()=>{
    const location = (0, $cVnBY.useLocation)();
    // Note: location.search includes the leading `?` character.
    return `/signup${location.search}`;
};

});

parcelRegister("21HHk", function(module, exports) {

$parcel$export(module.exports, "useRememberMe", function () { return $b027aca71f4cd331$export$a988c57eb90dc982; });

var $dNMDr = parcelRequire("dNMDr");

var $cVnBY = parcelRequire("cVnBY");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $lwrli = parcelRequire("lwrli");

var $aMBBA = parcelRequire("aMBBA");

var $4NPio = parcelRequire("4NPio");

var $yEovt = parcelRequire("yEovt");

var $bVs8G = parcelRequire("bVs8G");

var $h4v4M = parcelRequire("h4v4M");
const $b027aca71f4cd331$export$a988c57eb90dc982 = ()=>{
    (0, $kfOJC.useRegisterComponent)($b027aca71f4cd331$export$a988c57eb90dc982.name);
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const location = (0, $cVnBY.useLocation)();
    const [searchParams] = (0, $lwrli.useSearchParams)();
    const [isDeleteModeEnabled, setIsDeleteModeEnabled] = (0, $dNMDr.useState)(false);
    const rememberMeEnabled = (0, $aMBBA.useAppSelector)((state)=>state.login.rememberMeEnabled);
    const rememberedAccounts = (0, $aMBBA.useAppSelector)((state)=>state.login.rememberedAccounts);
    const isRememberMeChecked = (0, $aMBBA.useAppSelector)((state)=>state.login.isRememberMeChecked);
    const rememberedAccountsResponseCodes = (0, $aMBBA.useAppSelector)((state)=>state.login.rememberedAccountsResponseCodes);
    const onAddAccountSelected = (0, $dNMDr.useCallback)(()=>{
        searchParams.set('prompt', 'login');
        dispatch((0, $bVs8G.resetRememberMeState)());
        navigate({
            pathname: '/login',
            search: `?${searchParams.toString()}`,
            hash: location.hash
        });
    }, [
        searchParams,
        dispatch,
        navigate,
        location.hash
    ]);
    const onEnableDeleteMode = (0, $dNMDr.useCallback)(()=>{
        setIsDeleteModeEnabled(true);
    }, []);
    const onDeleteAccount = (0, $dNMDr.useCallback)((account)=>{
        // The backend supports deleting multiple accounts at once, so we need to provide accountIds not just the one.
        const accountIds = [
            account.accountId
        ];
        dispatch((0, $yEovt.requestRemoveRememberedAccount)({
            accountIds: accountIds,
            analyticsClient: analyticsClient
        }));
    }, [
        analyticsClient,
        dispatch
    ]);
    const onDisableDeleteMode = (0, $dNMDr.useCallback)(()=>{
        dispatch((0, $yEovt.resetRememberMeResponseCodes)());
        setIsDeleteModeEnabled(false);
    }, [
        dispatch
    ]);
    const onToggleRememberMeCheckbox = (0, $dNMDr.useCallback)(()=>{
        dispatch((0, $bVs8G.toggleRememberMeCheckbox)());
    }, [
        dispatch
    ]);
    return {
        onAddAccountSelected: onAddAccountSelected,
        onEnableDeleteMode: onEnableDeleteMode,
        rememberMeEnabled: rememberMeEnabled,
        rememberedAccounts: rememberedAccounts,
        onDeleteAccount: onDeleteAccount,
        onDisableDeleteMode: onDisableDeleteMode,
        isDeleteModeEnabled: isDeleteModeEnabled,
        isRememberMeChecked: isRememberMeChecked,
        onToggleRememberMeCheckbox: onToggleRememberMeCheckbox,
        rememberedAccountsResponseCodes: rememberedAccountsResponseCodes
    };
};

});
parcelRegister("yEovt", function(module, exports) {

$parcel$export(module.exports, "resetRememberMeResponseCodes", function () { return $80e95f97eef93e9e$export$d13bbaa5ba2d003d; });
$parcel$export(module.exports, "requestRemoveRememberedAccount", function () { return $80e95f97eef93e9e$export$d1be4757a4663fa7; });

var $hqddj = parcelRequire("hqddj");

var $8UHLa = parcelRequire("8UHLa");
const $80e95f97eef93e9e$export$d13bbaa5ba2d003d = ()=>({
        type: 'RESET_REMEMBERED_ACCOUNT_RESPONSE_CODES'
    });
const $80e95f97eef93e9e$export$a939d190fcd5712b = (accountIds)=>({
        type: 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_INITIATE',
        payload: {
            accountIds: accountIds
        }
    });
const $80e95f97eef93e9e$export$7e60d7595a30bdee = (accountIds, success)=>({
        type: 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_SUCCESS',
        payload: {
            accountIds: accountIds,
            response: success
        }
    });
const $80e95f97eef93e9e$export$701cdcf57b5adbcd = (error)=>({
        type: 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_FAILED',
        payload: {
            response: error
        }
    });
const $80e95f97eef93e9e$var$ValidResponseValues = [
    'success',
    'cookie_removed'
];
/**
 * Helper function to type guard the response from the remove remembered account API.
 */ function $80e95f97eef93e9e$var$isRemoveRememberedAccountSuccessResponse(response) {
    if ('result' in response) return $80e95f97eef93e9e$var$ValidResponseValues.includes(response.result);
    return false;
}
const $80e95f97eef93e9e$var$REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS = {
    bad_request: 'removeRememberedAccountBadRequest',
    invalid_cookie: 'removeRememberedAccountCookieInvalid',
    rate_limited: 'removeRememberedAccountRateLimited',
    unexpected_error: 'removeRememberedAccountUnexpectedError'
};
const $80e95f97eef93e9e$export$d1be4757a4663fa7 = ({ accountIds: accountIds, analyticsClient: analyticsClient })=>(dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        dispatch($80e95f97eef93e9e$export$a939d190fcd5712b(accountIds));
        if (!accountIds || accountIds.length === 0) {
            dispatch($80e95f97eef93e9e$export$701cdcf57b5adbcd('bad_request'));
            return Promise.resolve();
        }
        const request = {
            accountIds: accountIds
        };
        analyticsClient.trackingEvent({
            page: (0, $8UHLa.PAGE_ID),
            action: 'removeRememberedAccountInitiate',
            subject: 'account'
        });
        return fetch(`/rest/remember/remove`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(request)
        }).then((response)=>response.json()).then((response)=>{
            // Successful case
            if ($80e95f97eef93e9e$var$isRemoveRememberedAccountSuccessResponse(response)) {
                analyticsClient.trackingEvent({
                    page: (0, $8UHLa.PAGE_ID),
                    action: 'removeRememberedAccountSuccess',
                    subject: 'account'
                });
                // Success, UI will update with the new values assuming state is updated.
                dispatch($80e95f97eef93e9e$export$7e60d7595a30bdee(accountIds, response.result));
                return;
            }
            const analyticsErrorType = $80e95f97eef93e9e$var$REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS[response?.errorCode] ?? 'removeRememberedAccountError';
            analyticsClient.trackingEvent({
                page: (0, $8UHLa.PAGE_ID),
                action: analyticsErrorType,
                subject: 'account'
            });
            // Handle errors, depending on the result
            dispatch($80e95f97eef93e9e$export$701cdcf57b5adbcd(response.errorCode));
        }).catch((error)=>{
            dispatch($80e95f97eef93e9e$export$701cdcf57b5adbcd('unexpected_error'));
            analyticsClient.trackingEvent({
                page: (0, $8UHLa.PAGE_ID),
                action: $80e95f97eef93e9e$var$REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS.unexpected_error,
                subject: 'account'
            });
            (0, $hqddj.captureErrorMessage)('Remove Remembered Account failure', error);
        });
    };

});
parcelRegister("8UHLa", function(module, exports) {

$parcel$export(module.exports, "PAGE_ID", function () { return $d0b361209f834dae$export$e8b953ecde3e0a56; });
const $d0b361209f834dae$export$e8b953ecde3e0a56 = 'rememberMeAccountSelectScreen';

});




parcelRegister("8rkLA", function(module, exports) {

$parcel$export(module.exports, "useLoginSubmission", function () { return $e0971ee2ddc75d7a$export$b40fe35861b4a878; });

var $dNMDr = parcelRequire("dNMDr");

var $jjyqs = parcelRequire("jjyqs");

var $aMBBA = parcelRequire("aMBBA");

var $4NPio = parcelRequire("4NPio");

var $bw067 = parcelRequire("bw067");

var $kcNti = parcelRequire("kcNti");

var $bVs8G = parcelRequire("bVs8G");

var $7lC8o = parcelRequire("7lC8o");

var $5A0kF = parcelRequire("5A0kF");

var $7FWgq = parcelRequire("7FWgq");

var $6JqFM = parcelRequire("6JqFM");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $h4v4M = parcelRequire("h4v4M");
const $e0971ee2ddc75d7a$export$b40fe35861b4a878 = ({ onFailure: onFailure, onSuccess: onSuccess } = {})=>{
    (0, $kfOJC.useRegisterComponent)($e0971ee2ddc75d7a$export$b40fe35861b4a878.name);
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const anonymousId = (0, $4NPio.useAnalyticsAnonymousId)();
    const isUsernameChecked = (0, $aMBBA.useAppSelector)((state)=>state.login?.isUsernameChecked);
    const isCheckingUsername = (0, $aMBBA.useAppSelector)((state)=>state.login?.isCheckingUsername);
    const isLoggingIn = (0, $aMBBA.useAppSelector)((state)=>state.login?.isLoggingIn);
    const isLoading = isCheckingUsername || isLoggingIn;
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const appendReasonViewingScreen = (0, $7FWgq.useAppendReasonViewingScreen)();
    const { captchaValue: captchaValue } = (0, $kcNti.useLoginTooManyAttemptsRecaptchaContext)();
    const { marketingConsent: marketingConsent } = (0, $6JqFM.useMarketingConsentContext)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    // Wrap redirect to call onSuccess before redirecting
    const redirectWithCallback = (0, $dNMDr.useCallback)((url)=>{
        onSuccess?.();
        navigate(url);
    }, [
        onSuccess,
        navigate
    ]);
    const handleLogIn = (0, $dNMDr.useCallback)((username, password)=>{
        if (!marketingConsent) {
            console.error('Form cannot be submitted without showing Marketing Consent');
            onFailure?.();
            return;
        }
        if (!isUsernameChecked) {
            console.error('Cannot submit a username & password login attempt until check-username endpoint has been called');
            onFailure?.();
            return;
        }
        analyticsClient.formSubmittedEvent((0, $bw067.loginPageId), 'loginForm', appendReasonViewingScreen({
            marketingConsent: (0, $jjyqs.dangerouslyCreateSafeString)(marketingConsent.state)
        }));
        const onLoginError = (code)=>{
            onFailure?.();
            analyticsClient.trackingEvent({
                page: (0, $bw067.loginPageId),
                action: 'submitted',
                subject: 'credentials',
                attributes: {
                    successfulAuthentication: false,
                    errorCode: code
                }
            });
        };
        dispatch((0, $bVs8G.loginUsernamePassword)({
            username: username,
            password: password,
            captchaValue: captchaValue,
            location: window.location,
            onLoginError: onLoginError,
            marketingConsent: marketingConsent,
            anonymousId: anonymousId
        }, redirectWithCallback));
    }, [
        analyticsClient,
        anonymousId,
        appendReasonViewingScreen,
        captchaValue,
        dispatch,
        isUsernameChecked,
        marketingConsent,
        onFailure,
        redirectWithCallback
    ]);
    const handlePasswordlessLogIn = (0, $dNMDr.useCallback)(async (email)=>{
        const { success: success } = await dispatch((0, $bVs8G.loginPasswordless)({
            email: email,
            captchaValue: captchaValue,
            location: window.location
        }));
        if (success) dispatch((0, $7lC8o.addFlag)('success', (0, $5A0kF.LoginPageMessages).passwordlessSuccessTitle, (0, $5A0kF.LoginPageMessages).passwordlessSuccessDescription));
    }, [
        dispatch,
        captchaValue
    ]);
    return {
        isLoading: /**
     * Indicates whether username & password submission is in progress.
     * */ isLoading,
        /**
     * Errors around the username (email) and password fields.
     * */ onPasswordlessLogin: handlePasswordlessLogIn,
        /**
     * Handle login with username and password.
     *
     * Note: this will be a no-op if the username (email) has not been checked by calling
     * `checkUsername` before calling `onLogin`.
     *
     * For accessing the state and handlers around working with `checkUsername`, see:
     * {@link file://./useLogin.ts}.
     * */ onLogin: handleLogIn
    };
};

});

parcelRegister("k3nfW", function(module, exports) {

$parcel$export(module.exports, "useSocialLogin", function () { return $85d5dbfe4b2e866f$export$c599a88026ac50ef; });

var $dNMDr = parcelRequire("dNMDr");

var $f6exR = parcelRequire("f6exR");

var $aMBBA = parcelRequire("aMBBA");

var $chJxj = parcelRequire("chJxj");

var $4NPio = parcelRequire("4NPio");

var $hhYxc = parcelRequire("hhYxc");

var $7SvfM = parcelRequire("7SvfM");

var $k7EuG = parcelRequire("k7EuG");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $bw067 = parcelRequire("bw067");

var $7FWgq = parcelRequire("7FWgq");

var $ei3NI = parcelRequire("ei3NI");
const $85d5dbfe4b2e866f$export$c599a88026ac50ef = ()=>{
    (0, $kfOJC.useRegisterComponent)($85d5dbfe4b2e866f$export$c599a88026ac50ef.name);
    const isCommercial = (0, $hhYxc.getCurrentCloudType)() === 'commercial';
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const appendReasonViewingScreen = (0, $7FWgq.useAppendReasonViewingScreen)();
    const isUsernameChecked = (0, $aMBBA.useAppSelector)((state)=>state.login?.isUsernameChecked);
    const identities = (0, $aMBBA.useAppSelector)((state)=>state.login?.identities);
    const isLoginSecondStep = isUsernameChecked;
    const isGoogleOneTapDismissed = (0, $aMBBA.useAppSelector)((state)=>state?.googleOneTap?.dismissed);
    const isSocialBlocked = (0, $aMBBA.useAppSelector)((state)=>state.login?.isSocialBlocked);
    const { errorCode: errorCode } = (0, $7FWgq.useSearchParamCodes)();
    const appConfig = (0, $aMBBA.useAppSelector)((state)=>state.appConfig);
    const csrfToken = (0, $aMBBA.useAppSelector)((state)=>state.csrfToken);
    const application = (0, $7FWgq.useCobrandingApplication)();
    const dynamicConfigs = (0, $ei3NI.useDynamicConfigs)();
    const socialLoginEligibility = (0, $dNMDr.useMemo)(()=>(0, $k7EuG.getSocialLoginEligibility)(identities, application, dynamicConfigs), [
        application,
        identities,
        dynamicConfigs
    ]);
    const { highlightedSocialProvider: highlightedSocialProvider, isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly } = socialLoginEligibility;
    const showSocialLoginOnly = isLoginSecondStep && isEligibleForSocialLoginOnly && highlightedSocialProvider && isCommercial;
    const socialButtonClickedEvent = (0, $dNMDr.useCallback)((socialProvider)=>{
        analyticsClient.buttonClickedEvent(showSocialLoginOnly ? 'socialLoginForm' : (0, $bw067.loginPageId), `${socialProvider}LoginButton`, appendReasonViewingScreen({}));
    }, [
        analyticsClient,
        appendReasonViewingScreen,
        showSocialLoginOnly
    ]);
    const loginRecoveryOptions = (0, $7FWgq.useLoginRecoveryOptions)();
    const handleGoogleSocialLogin = (0, $dNMDr.useCallback)((email)=>{
        socialButtonClickedEvent((0, $chJxj.SocialProvider).Google);
        (0, $7SvfM.redirectToGoogleLogin)({
            location: window.location,
            source: (0, $bw067.loginPageId),
            recoveryOptions: loginRecoveryOptions(email)
        });
    }, [
        loginRecoveryOptions,
        socialButtonClickedEvent
    ]);
    const handleAuth0SocialLogin = (0, $dNMDr.useCallback)((socialProvider, email, redirectFn)=>{
        socialButtonClickedEvent(socialProvider);
        redirectFn({
            location: window.location,
            auth0Config: appConfig?.auth0Config,
            csrfToken: csrfToken ?? 'token-should-be-loaded',
            source: (0, $bw067.loginPageId),
            email: email || undefined,
            recoveryOptions: loginRecoveryOptions(email)
        });
    }, [
        appConfig?.auth0Config,
        csrfToken,
        loginRecoveryOptions,
        socialButtonClickedEvent
    ]);
    const handleMicrosoftLogin = (0, $dNMDr.useCallback)((email)=>handleAuth0SocialLogin((0, $chJxj.SocialProvider).Microsoft, email, (0, $7SvfM.redirectToMicrosoftLogin)), [
        handleAuth0SocialLogin
    ]);
    const handleAppleLogin = (0, $dNMDr.useCallback)((email)=>handleAuth0SocialLogin((0, $chJxj.SocialProvider).Apple, email, (0, $7SvfM.redirectToAppleLogin)), [
        handleAuth0SocialLogin
    ]);
    const handleSlackLogin = (0, $dNMDr.useCallback)((email)=>handleAuth0SocialLogin((0, $chJxj.SocialProvider).Slack, email, (0, $7SvfM.redirectToSlackLogin)), [
        handleAuth0SocialLogin
    ]);
    const onDismissGoogleOneTap = (0, $dNMDr.useCallback)(()=>dispatch((0, $f6exR.dismissGoogleOneTap)()), [
        dispatch
    ]);
    const isCheckingUsername = (0, $aMBBA.useAppSelector)((state)=>state.login?.isCheckingUsername);
    const isLoggingIn = (0, $aMBBA.useAppSelector)((state)=>state.login?.isLoggingIn);
    const usernameExists = (0, $aMBBA.useAppSelector)((state)=>state.login?.usernameExists);
    const isLoading = isCheckingUsername || isLoggingIn;
    (0, $dNMDr.useEffect)(()=>{
        if (!isLoading && isLoginSecondStep && usernameExists && identities) analyticsClient.trackingEvent({
            page: (0, $bw067.loginPageId),
            action: 'triggered',
            subject: 'loginSecondStep',
            attributes: {
                eligibility: socialLoginEligibility
            }
        });
    }, [
        analyticsClient,
        identities,
        isLoading,
        isLoginSecondStep,
        socialLoginEligibility,
        usernameExists
    ]);
    if (isCommercial) return {
        envSupportsSocialLogin: true,
        socialLoginEligibility: socialLoginEligibility,
        onAppleLogin: handleAppleLogin,
        onSlackLogin: handleSlackLogin,
        onMicrosoftLogin: handleMicrosoftLogin,
        onGoogleSocialLogin: handleGoogleSocialLogin,
        onDismissGoogleOneTap: onDismissGoogleOneTap,
        isGoogleOneTapDismissed: isGoogleOneTapDismissed,
        isSocialBlocked: isSocialBlocked || errorCode?.code === 'social_login_banned'
    };
    return {
        envSupportsSocialLogin: false,
        socialLoginEligibility: null,
        onAppleLogin: null,
        onSlackLogin: null,
        onMicrosoftLogin: null,
        onGoogleSocialLogin: null,
        onDismissGoogleOneTap: null,
        isGoogleOneTapDismissed: null,
        isSocialBlocked: false
    };
};

});
parcelRegister("f6exR", function(module, exports) {

$parcel$export(module.exports, "dismissGoogleOneTap", function () { return $8b933915dfa3afb1$export$7634a565805a5f09; });
const $8b933915dfa3afb1$export$7634a565805a5f09 = ()=>({
        type: 'GOOGLE_ONE_TAP_DISMISS'
    });

});

parcelRegister("k7EuG", function(module, exports) {

$parcel$export(module.exports, "getSocialLoginEligibility", function () { return $9b3fd524cf9b9424$export$e8b4b1bf168dca09; });

var $chJxj = parcelRequire("chJxj");

var $7SvfM = parcelRequire("7SvfM");
const $9b3fd524cf9b9424$export$c612d878ad73a6c0 = [
    (0, $chJxj.SocialProvider).Google,
    (0, $chJxj.SocialProvider).Microsoft,
    (0, $chJxj.SocialProvider).Apple,
    (0, $chJxj.SocialProvider).Slack
];
const $9b3fd524cf9b9424$export$94af6b531db26586 = (dynamicConfigs)=>{
    const highPriority = [];
    const lowPriority = [];
    const isProviderEnabled = {
        [(0, $chJxj.SocialProvider).Google]: !(0, $7SvfM.isGoogleLoginOutageAdvisoryEnabled)(dynamicConfigs),
        [(0, $chJxj.SocialProvider).Microsoft]: !(0, $7SvfM.isMicrosoftLoginOutageAdvisoryEnabled)(dynamicConfigs),
        [(0, $chJxj.SocialProvider).Apple]: !(0, $7SvfM.isAppleLoginOutageAdvisoryEnabled)(dynamicConfigs),
        [(0, $chJxj.SocialProvider).Slack]: !(0, $7SvfM.isSlackLoginOutageAdvisoryEnabled)(dynamicConfigs)
    };
    $9b3fd524cf9b9424$export$c612d878ad73a6c0.forEach((provider)=>{
        if (!isProviderEnabled[provider]) lowPriority.push(provider);
        else // If it's enabled or undefined (not in the record), it's high priority
        highPriority.push(provider);
    });
    return [
        ...highPriority,
        ...lowPriority
    ];
};
const $9b3fd524cf9b9424$export$47bb6da133b3804e = (connected, dynamicConfigs)=>{
    const rankedSocialProviders = $9b3fd524cf9b9424$export$94af6b531db26586(dynamicConfigs);
    for (const socialProvider of rankedSocialProviders){
        if (connected.includes(socialProvider)) return socialProvider;
    }
    return null;
};
const $9b3fd524cf9b9424$export$e5abae2d758ca82f = (identities)=>{
    if (!identities) return [];
    return Object.values((0, $chJxj.SocialProvider)).filter((provider)=>!!identities?.[provider]);
};
const $9b3fd524cf9b9424$export$55a908504dbef32d = (socialProvider, application, hasPassword = true)=>Boolean(socialProvider && !hasPassword && application !== 'trello');
const $9b3fd524cf9b9424$export$e8b4b1bf168dca09 = (identities, application, dynamicConfigs)=>{
    const connectedSocialProviders = $9b3fd524cf9b9424$export$e5abae2d758ca82f(identities);
    const highlightedSocialProvider = $9b3fd524cf9b9424$export$47bb6da133b3804e(connectedSocialProviders, dynamicConfigs);
    const hasPassword = identities?.password;
    const isEligibleForSocialLoginOnly = $9b3fd524cf9b9424$export$55a908504dbef32d(highlightedSocialProvider, application, hasPassword);
    return {
        isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly,
        highlightedSocialProvider: highlightedSocialProvider,
        connectedSocialProviders: connectedSocialProviders,
        enabledSocialButtons: $9b3fd524cf9b9424$export$c612d878ad73a6c0,
        firstProductAccessed: application || 'unknown',
        hasPassword: hasPassword
    };
};

});


parcelRegister("7ZYGf", function(module, exports) {

$parcel$export(module.exports, "useGoogleOneTap", function () { return $5de79a872e019b19$export$84fc8ad34c97e462; });

var $dNMDr = parcelRequire("dNMDr");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $jydZs = parcelRequire("jydZs");

var $7FWgq = parcelRequire("7FWgq");
const $5de79a872e019b19$export$84fc8ad34c97e462 = ({ email: email })=>{
    (0, $kfOJC.useRegisterComponent)($5de79a872e019b19$export$84fc8ad34c97e462.name);
    const { setLoginRecoveryOptions: setLoginRecoveryOptions } = (0, $jydZs.useLoginRecoveryOptionsContext)();
    const buildLoginRecoveryOptions = (0, $7FWgq.useLoginRecoveryOptions)();
    (0, $dNMDr.useEffect)(()=>{
        if (!email) return;
        const loginRecoveryOptions = buildLoginRecoveryOptions(email);
        setLoginRecoveryOptions(loginRecoveryOptions);
    }, [
        email,
        setLoginRecoveryOptions,
        buildLoginRecoveryOptions
    ]);
};

});
parcelRegister("jydZs", function(module, exports) {

$parcel$export(module.exports, "LoginRecoveryOptionsContextProvider", function () { return $fd66ce59b35750f7$export$4df382a2361d8131; });
$parcel$export(module.exports, "useLoginRecoveryOptionsContext", function () { return $fd66ce59b35750f7$export$402ee3e11776bab7; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");
const $fd66ce59b35750f7$export$84bd9b573c96976b = /*#__PURE__*/ (0, $dNMDr.createContext)(null);
const $fd66ce59b35750f7$export$4df382a2361d8131 = ({ children: children })=>{
    const [loginRecoveryOptions, setLoginRecoveryOptions] = (0, $dNMDr.useState)();
    const value = (0, $dNMDr.useMemo)(()=>({
            loginRecoveryOptions: loginRecoveryOptions,
            setLoginRecoveryOptions: setLoginRecoveryOptions
        }), [
        loginRecoveryOptions
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)($fd66ce59b35750f7$export$84bd9b573c96976b.Provider, {
        value: value,
        children: children
    });
};
const $fd66ce59b35750f7$export$402ee3e11776bab7 = ()=>{
    const context = (0, $dNMDr.useContext)($fd66ce59b35750f7$export$84bd9b573c96976b);
    if (!context) throw new Error('useLoginRecoveryOptionsContext must be used within a LoginRecoveryOptionsContextProvider');
    return context;
};

});


parcelRegister("2tsIC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cbb04dd857feda2$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

const $4cbb04dd857feda2$var$BaseRememberedAccountsPage = /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("j3hhn")));
const $4cbb04dd857feda2$var$RememberedAccountsPage = ()=>{
    return /*#__PURE__*/ (0, $6CtE1.jsx)($4cbb04dd857feda2$var$BaseRememberedAccountsPage, {});
};
var $4cbb04dd857feda2$export$2e2bcd8739ae039 = $4cbb04dd857feda2$var$RememberedAccountsPage;

});
parcelRegister("j3hhn", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("9meHj")).then(()=>parcelRequire('gL1Et'));

});


parcelRegister("cOw4T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19ed9b0ee6fbb9f1$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $4qndc = parcelRequire("4qndc");

var $hhYxc = parcelRequire("hhYxc");
const $19ed9b0ee6fbb9f1$var$MaybePasskeyLoginPanel = ({ onPasskeyLogin: onPasskeyLogin, authenticating: authenticating })=>{
    const isCommercial = (0, $hhYxc.getCurrentCloudType)() === 'commercial';
    if (!isCommercial) return null;
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $4qndc.default), {
        handlePasskeyLogin: onPasskeyLogin,
        authenticating: authenticating
    });
};
var $19ed9b0ee6fbb9f1$export$2e2bcd8739ae039 = $19ed9b0ee6fbb9f1$var$MaybePasskeyLoginPanel;

});
parcelRegister("4qndc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e4d9b5df6444b5f$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $ko1o6 = parcelRequire("ko1o6");

var $aDHKy = parcelRequire("aDHKy");

var $bpFCS = parcelRequire("bpFCS");

var $4Cmcw = parcelRequire("4Cmcw");
const $7e4d9b5df6444b5f$export$a40fa4dfd66c03fa = ({ handlePasskeyLogin: handlePasskeyLogin, authenticating: authenticating = false })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $4Cmcw.SocialLoginPanelWrapper), {
        role: "list",
        "data-i18n-or": formatMessage((0, $bpFCS.default).passkeyAuthOrLoginWith),
        "data-i18n-continue": formatMessage((0, $bpFCS.default).passkeyAuthOrLoginWith),
        className: "passkey-login",
        "data-testid": "passkey-login-wrapper-idf-testid",
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $4Cmcw.SocialLoginButtonRowGroup), {
            "data-testid": "passkey-login-idf-testid",
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $4Cmcw.SocialLoginOptionWrapper), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $4Cmcw.SocialLoginButton), {
                    id: "passkey-auth-button",
                    advisoryEnabled: false,
                    isLoading: authenticating,
                    logo: (0, (/*@__PURE__*/$parcel$interopDefault($aDHKy))),
                    onClick: handlePasskeyLogin,
                    children: "Passkey"
                })
            })
        })
    });
};
var $7e4d9b5df6444b5f$export$2e2bcd8739ae039 = $7e4d9b5df6444b5f$export$a40fa4dfd66c03fa;

});
parcelRegister("aDHKy", function(module, exports) {

module.exports = (parcelRequire("4XRWO")).getBundleURL('ejQSx') + "key-logo.6d28e5f0.svg";

});

parcelRegister("bpFCS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad613249c27d2489$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $ad613249c27d2489$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    passkeyAuthOrLoginWith: {
        id: 'passkey.auth.or-login-with',
        defaultMessage: 'Or login with:'
    }
});

});



parcelRegister("7hGwi", function(module, exports) {

$parcel$export(module.exports, "usePasskeyLogin", function () { return $ed8a691dc5cd927b$export$8649dfc50d6433ff; });

var $dNMDr = parcelRequire("dNMDr");

var $4NPio = parcelRequire("4NPio");

var $f8jwK = parcelRequire("f8jwK");

var $h4v4M = parcelRequire("h4v4M");

var $bw067 = parcelRequire("bw067");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $7FWgq = parcelRequire("7FWgq");

var $lwrli = parcelRequire("lwrli");

var $dJpcp = parcelRequire("dJpcp");
const $ed8a691dc5cd927b$export$8649dfc50d6433ff = ({ onSuccess: onSuccess } = {})=>{
    (0, $kfOJC.useRegisterComponent)($ed8a691dc5cd927b$export$8649dfc50d6433ff.name);
    const [searchParams] = (0, $lwrli.useSearchParams)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const appendReasonViewingScreen = (0, $7FWgq.useAppendReasonViewingScreen)();
    const [authenticating, setAuthenticating] = (0, $dNMDr.useState)(false);
    const passkeyButtonClickedEvent = (0, $dNMDr.useCallback)(()=>{
        analyticsClient.buttonClickedEvent((0, $bw067.loginPageId), `PasskeyLoginButton`, appendReasonViewingScreen({}));
    }, [
        analyticsClient,
        appendReasonViewingScreen
    ]);
    const redirectWithCallback = (0, $dNMDr.useCallback)((url)=>{
        onSuccess?.();
        navigate(url);
    }, [
        onSuccess,
        navigate
    ]);
    const onErrorWithTrackingAnalytics = (0, $dNMDr.useCallback)((error)=>{
        analyticsClient.trackingEvent({
            page: (0, $bw067.loginPageId),
            action: 'failed',
            subject: $ed8a691dc5cd927b$var$ANALYTIC_EVENT_SUBJECT_ID,
            attributes: {
                reason: error
            }
        });
    }, [
        analyticsClient
    ]);
    const startPasskeyChallenge = (0, $dNMDr.useCallback)(async ()=>{
        const isSupported = (0, $f8jwK.isWebAuthnSupported)();
        analyticsClient.trackingEvent({
            page: (0, $bw067.loginPageId),
            action: 'started',
            subject: $ed8a691dc5cd927b$var$ANALYTIC_EVENT_SUBJECT_ID
        });
        if (!isSupported) {
            const redirectUri = $ed8a691dc5cd927b$var$redirectToErrorPage({
                analyticsClient: analyticsClient,
                loginError: 'webauthn_not_supported',
                currentQueryParams: searchParams
            });
            return redirectWithCallback(redirectUri);
        }
        try {
            setAuthenticating(true);
            const castleToken = await (0, $dJpcp.getCastleRequestToken)([
                'capability-group--login',
                'capability-name--login-with-passkey'
            ]);
            const token = castleToken || 'dummy-token'; // a token is expected by id-auth in IC and disabled entirely within FedRAMP
            const passkeyChallengeResponseResult = await $ed8a691dc5cd927b$var$challenge();
            if (!passkeyChallengeResponseResult.success) {
                const redirectUri = $ed8a691dc5cd927b$var$redirectToErrorPage({
                    analyticsClient: analyticsClient,
                    loginError: passkeyChallengeResponseResult.error,
                    currentQueryParams: searchParams
                });
                return redirectWithCallback(redirectUri);
            }
            const { requestOptions: requestOptions, transactionToken: transactionToken } = passkeyChallengeResponseResult.data;
            const authenticatorChallengeResult = await (0, $f8jwK.challengeWithAuthenticator)(requestOptions);
            if (!authenticatorChallengeResult.success) {
                const redirectUri = $ed8a691dc5cd927b$var$redirectToErrorPage({
                    analyticsClient: analyticsClient,
                    loginError: 'webauthn_challenge_failed',
                    currentQueryParams: searchParams,
                    webAuthnError: authenticatorChallengeResult.error
                });
                return redirectWithCallback(redirectUri);
            }
            const passkeyCredentialJson = authenticatorChallengeResult.data;
            const verifyResponseResult = await $ed8a691dc5cd927b$var$verify({
                transactionToken: transactionToken,
                assertionJson: passkeyCredentialJson,
                analyticsClient: analyticsClient,
                token: token
            });
            if (!verifyResponseResult.success) {
                const redirectUri = $ed8a691dc5cd927b$var$redirectToErrorPage({
                    analyticsClient: analyticsClient,
                    loginError: verifyResponseResult.error,
                    currentQueryParams: searchParams
                });
                return redirectWithCallback(redirectUri);
            }
            return redirectWithCallback(verifyResponseResult.data.redirectUri);
        } catch (e) {
            return onErrorWithTrackingAnalytics("challengeFailure");
        } finally{
            setAuthenticating(false);
        }
    }, [
        analyticsClient,
        onErrorWithTrackingAnalytics,
        redirectWithCallback,
        searchParams
    ]);
    const handlePasskeyLogin = (0, $dNMDr.useCallback)(()=>{
        passkeyButtonClickedEvent();
        startPasskeyChallenge();
    }, [
        passkeyButtonClickedEvent,
        startPasskeyChallenge
    ]);
    return {
        onPasskeyLogin: handlePasskeyLogin,
        authenticating: authenticating
    };
};
const $ed8a691dc5cd927b$var$ANALYTIC_EVENT_SUBJECT_ID = 'challengePasskey';
var $ed8a691dc5cd927b$var$PasskeyChallengeApiError = /*#__PURE__*/ function(PasskeyChallengeApiError) {
    PasskeyChallengeApiError["challengeFailure"] = "challengeFailure";
    PasskeyChallengeApiError["tooManyRequests"] = "tooManyRequests";
    return PasskeyChallengeApiError;
}($ed8a691dc5cd927b$var$PasskeyChallengeApiError || {});
const $ed8a691dc5cd927b$var$challenge = async ()=>{
    try {
        const response = await fetch(`/v2/passkey/challenge${location.search}`, {
            method: 'GET'
        });
        switch(response.status){
            case 200:
                const challengeResponse = await response.json();
                return {
                    success: true,
                    data: challengeResponse
                };
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            case 400:
                return {
                    success: false,
                    error: await $ed8a691dc5cd927b$var$errorFromBadRequest(response)
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error from fetch: /v2/passkey/challenge`);
    }
};
const $ed8a691dc5cd927b$var$verify = async ({ transactionToken: transactionToken, assertionJson: assertionJson, token: token })=>{
    try {
        const query = location.search ? `${location.search}&transactionToken=${transactionToken}` : '?transactionToken=' + transactionToken;
        const response = await fetch(`/v2/passkey/verify${query}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...assertionJson,
                token: token
            })
        });
        switch(response.status){
            case 200:
                const verifyResponse = await response.json();
                return {
                    success: true,
                    data: verifyResponse
                };
            case 400:
                return {
                    success: false,
                    error: await $ed8a691dc5cd927b$var$errorFromBadRequest(response)
                };
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error during verification of passkey`);
    }
};
const $ed8a691dc5cd927b$var$errorFromBadRequest = (response)=>response.json().then((body)=>{
        switch(body.context.reason){
            case 'bad_request':
                return 'unknown';
            case 'unknown':
                return 'unknown';
            case 'login.form.token.expired':
                return 'login.form.token.expired';
            case 'login.form.invalid_token':
                return 'unknown';
            case 'invalid_passkey':
                return 'invalid_passkey';
            case 'passkey_managed_account':
                return 'passkey_managed_account';
            default:
                return 'unknown';
        }
    }).catch(()=>'unknown');
function $ed8a691dc5cd927b$var$redirectToErrorPage({ analyticsClient: analyticsClient, loginError: loginError, currentQueryParams: currentQueryParams, webAuthnError: webAuthnError }) {
    if (webAuthnError) analyticsClient.trackingEvent({
        page: (0, $bw067.loginPageId),
        action: 'failed',
        subject: $ed8a691dc5cd927b$var$ANALYTIC_EVENT_SUBJECT_ID,
        attributes: {
            reason: webAuthnError
        }
    });
    else analyticsClient.trackingEvent({
        page: (0, $bw067.loginPageId),
        subject: $ed8a691dc5cd927b$var$ANALYTIC_EVENT_SUBJECT_ID,
        action: 'failed',
        attributes: {
            reason: loginError
        }
    });
    currentQueryParams.delete('errorCode');
    currentQueryParams.set('errorCode', loginError);
    return new URL(`/login?${currentQueryParams.toString()}`, window.location.origin);
}

});

parcelRegister("2EOHn", function(module, exports) {

$parcel$export(module.exports, "useOrgLoginConfig", function () { return $34eed62fb3b8792e$export$d7c7e036e139be68; });

var $dNMDr = parcelRequire("dNMDr");

var $lwrli = parcelRequire("lwrli");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $aMBBA = parcelRequire("aMBBA");

var $h4v4M = parcelRequire("h4v4M");

var $76XtE = parcelRequire("76XtE");
const $34eed62fb3b8792e$export$d7c7e036e139be68 = ()=>{
    (0, $kfOJC.useRegisterComponent)($34eed62fb3b8792e$export$d7c7e036e139be68.name);
    const [searchParams] = (0, $lwrli.useSearchParams)();
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const orgLoginConfigAutoRedirect = (0, $aMBBA.useAppSelector)((state)=>state.orgLoginConfig.autoRedirect);
    const orgLoginConfigSamlConnectionId = (0, $aMBBA.useAppSelector)((state)=>state.orgLoginConfig.samlConnectionId);
    const redirectToSingleSignOn = (0, $dNMDr.useMemo)(()=>orgLoginConfigSamlConnectionId ? ()=>{
            // Set global state loading to true to keep the page in a loading state during the redirect
            dispatch((0, $76XtE.setGlobalStateLoading)(true));
            const queryParams = new URLSearchParams([
                [
                    'connection',
                    orgLoginConfigSamlConnectionId
                ],
                ...searchParams
            ]);
            navigate(`/login/saml/start?${queryParams}`);
        } : undefined, [
        dispatch,
        navigate,
        orgLoginConfigSamlConnectionId,
        searchParams
    ]);
    (0, $dNMDr.useEffect)(()=>{
        if (redirectToSingleSignOn && orgLoginConfigAutoRedirect) redirectToSingleSignOn();
    }, [
        orgLoginConfigAutoRedirect,
        redirectToSingleSignOn
    ]);
    return {
        redirectToSingleSignOn: redirectToSingleSignOn
    };
};

});


parcelRegister("fQs0N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "signupLoader", function () { return $2a99393d10916b77$export$f820bc2fe9d1bd78; });
$parcel$export(module.exports, "SignupPage", function () { return $2a99393d10916b77$export$a2f4b65ede167ce5; });
$parcel$export(module.exports, "default", function () { return $2a99393d10916b77$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $cpaps = parcelRequire("cpaps");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $f6exR = parcelRequire("f6exR");

var $4eVYs = parcelRequire("4eVYs");
parcelRequire("bUwsE");
var $hiOqT = parcelRequire("hiOqT");
var $lSnCh = parcelRequire("lSnCh");

var $4Cmcw = parcelRequire("4Cmcw");

var $Q6OOA = parcelRequire("Q6OOA");

var $jBrXs = parcelRequire("jBrXs");

var $4NPio = parcelRequire("4NPio");

var $aMBBA = parcelRequire("aMBBA");

var $fSUge = parcelRequire("fSUge");

var $8iNb4 = parcelRequire("8iNb4");

var $eTJEU = parcelRequire("eTJEU");

var $ivYOl = parcelRequire("ivYOl");

var $7Nd87 = parcelRequire("7Nd87");

var $46hMy = parcelRequire("46hMy");

var $2z6E1 = parcelRequire("2z6E1");

var $gfuQh = parcelRequire("gfuQh");

var $4ljBU = parcelRequire("4ljBU");

var $84ZjZ = parcelRequire("84ZjZ");

var $cBB3b = parcelRequire("cBB3b");

var $dWOVN = parcelRequire("dWOVN");
const $2a99393d10916b77$var$subjectIds = {
    email: 'selfSignupNoEmail'
};
async function $2a99393d10916b77$export$f820bc2fe9d1bd78({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/signup/state', request, {
        capabilities: [
            'capability-group--signup',
            'capability-name--signup'
        ]
    });
}
const $2a99393d10916b77$export$a2f4b65ede167ce5 = ()=>{
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const { screenSize: screenSize } = (0, $fSUge.useMicrobranding)();
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const { error: error, userJourneyContextError: userJourneyContextError } = (0, $gfuQh.useSignup)();
    const { onSignup: onSignup, email: email, fieldErrors: fieldErrors, shouldDisableEmailInput: shouldDisableEmailInput } = (0, $46hMy.useSignupSubmit)();
    const handleValidationError = (0, $dNMDr.useCallback)((errors)=>{
        const errorEventNames = Object.keys(errors).map((error)=>$2a99393d10916b77$var$subjectIds[error] || 'selfSignupUnknownUiError');
        errorEventNames.forEach((eventName)=>analyticsClient.errorShownEvent((0, $ivYOl.pageId), eventName));
        dispatch((0, $4eVYs.showFieldErrors)(errors));
    }, [
        analyticsClient,
        dispatch
    ]);
    const handleFormClick = (0, $dNMDr.useCallback)(()=>{
        if (screenSize === 'mobile') dispatch((0, $f6exR.dismissGoogleOneTap)());
    }, [
        dispatch,
        screenSize
    ]);
    const onSubmitClick = (0, $dNMDr.useCallback)(async ()=>{
        const isWebAuthnSupported = async ()=>{
            try {
                return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
            } catch (err) {
                return false;
            }
        };
        analyticsClient.buttonClickedEvent((0, $ivYOl.pageId), 'signupFormSubmit', {
            isWebAuthnSupported: await isWebAuthnSupported()
        });
    }, [
        analyticsClient
    ]);
    const { envSupportsSocialSignup: envSupportsSocialSignup, handleAppleLogin: handleAppleLogin, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleSlackLogin: handleSlackLogin } = (0, $2z6E1.useSocialSignup)();
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                title: formatMessage((0, $jBrXs.default).headTitle)
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
                pageId: (0, $ivYOl.pageId),
                header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
                    as: "h1",
                    size: "small",
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $jBrXs.default).headerTitle
                    })
                }),
                footer: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTJEU.FooterLogoWrapper), {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lSnCh.SignupRecaptchaNotice), {})
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hiOqT.LoginLink), {}),
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7Nd87.default), {
                        email: email,
                        error: error,
                        userJourneyContextError: userJourneyContextError,
                        fieldErrors: fieldErrors,
                        onSignup: onSignup,
                        onValidationError: handleValidationError,
                        onFormClick: handleFormClick,
                        onSubmitClick: onSubmitClick,
                        disableEmailInput: Boolean(email && shouldDisableEmailInput),
                        privacyPolicy: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8iNb4.SignupPrivacyPolicy), {})
                    }),
                    envSupportsSocialSignup && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $4Cmcw.default), {
                        handleGoogleLogin: handleGoogleLogin,
                        handleMicrosoftLogin: handleMicrosoftLogin,
                        handleAppleLogin: handleAppleLogin,
                        handleSlackLogin: handleSlackLogin
                    })
                ]
            })
        ]
    });
};
var $2a99393d10916b77$export$2e2bcd8739ae039 = $2a99393d10916b77$export$a2f4b65ede167ce5;

});
parcelRegister("4eVYs", function(module, exports) {

$parcel$export(module.exports, "reset", function () { return $8f5306dcc5c2ee7b$export$aad8462122ac592b; });
$parcel$export(module.exports, "showFieldErrors", function () { return $8f5306dcc5c2ee7b$export$f17d5fd8029ff8d7; });
$parcel$export(module.exports, "signupCaptchaFailure", function () { return $8f5306dcc5c2ee7b$export$f4ba837a66b5be0a; });
$parcel$export(module.exports, "signup", function () { return $8f5306dcc5c2ee7b$export$7200a869094fec36; });

var $1JRGy = parcelRequire("1JRGy");

var $fcxz7 = parcelRequire("fcxz7");

var $btezy = parcelRequire("btezy");

var $dJpcp = parcelRequire("dJpcp");
const $8f5306dcc5c2ee7b$export$aad8462122ac592b = ()=>({
        type: 'SIGNUP_RESET'
    });
const $8f5306dcc5c2ee7b$export$e786d9c820defe79 = ()=>({
        type: 'SIGNUP_REQUEST'
    });
const $8f5306dcc5c2ee7b$export$99986585b9b9a16 = (redirectTo)=>({
        type: 'SIGNUP_REQUEST_SUCCESS',
        redirectTo: redirectTo
    });
const $8f5306dcc5c2ee7b$export$addc2691c91f42be = (error)=>({
        type: 'SIGNUP_REQUEST_FAILED',
        error: error
    });
const $8f5306dcc5c2ee7b$export$f17d5fd8029ff8d7 = (errors)=>({
        type: 'SIGNUP_SHOW_FIELD_ERRORS',
        errors: errors
    });
const $8f5306dcc5c2ee7b$export$f4ba837a66b5be0a = (isOnline)=>$8f5306dcc5c2ee7b$export$addc2691c91f42be(isOnline ? 'captcha' : 'request_error');
const $8f5306dcc5c2ee7b$export$7200a869094fec36 = (signupParams, location = window.location, options)=>async (dispatch, getState)=>{
        const { email: email, challengeResponse: challengeResponse } = signupParams;
        const { display: display } = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search);
        const { cobranding: { productHint: productHint } } = getState();
        const microbranding = (0, $fcxz7.getMicrobrandingFromUrl)(location);
        const qs = microbranding && Object.keys(microbranding).length ? `?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(microbranding)}` : '';
        const castleToken = await (0, $dJpcp.getCastleRequestToken)([
            'capability-group--signup',
            'capability-name--signup'
        ]);
        dispatch($8f5306dcc5c2ee7b$export$e786d9c820defe79());
        // TODO: confirm whether we should be including privacy policy text in the payload
        // https://hello.jira.atlassian.cloud/browse/KIRBY-7103
        const payload = {
            'challenge-response': (0, $btezy.toChallengeRequest)(challengeResponse),
            email: email,
            productHint: productHint,
            display: display || null,
            castleToken: castleToken
        };
        let response;
        try {
            response = await fetch(`/rest/signup${qs}`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
        } catch (networkError) {
            dispatch($8f5306dcc5c2ee7b$export$addc2691c91f42be('request_error'));
            return;
        }
        try {
            const { fieldErrors: fieldErrors, uiErrors: uiErrors, redirectTo: redirectTo } = await response.json();
            if (redirectTo) {
                const fullRedirectUrl = new URL(redirectTo);
                const redirectUrlParams = new URLSearchParams(fullRedirectUrl.search);
                const continueUrlFromParams = redirectUrlParams.get('continue');
                if (options?.addParamsToContinueUrl && continueUrlFromParams) {
                    const continueUrl = new URL(continueUrlFromParams);
                    const paramsToAdd = options.addParamsToContinueUrl({
                        fullRedirectUrl: fullRedirectUrl,
                        continueUrl: continueUrl
                    });
                    const updatedRedirectTo = $8f5306dcc5c2ee7b$var$updateRedirectContinueUrlParams({
                        fullRedirectUrlValue: redirectTo,
                        continueUrlValue: continueUrlFromParams,
                        paramsToAdd: paramsToAdd
                    });
                    dispatch($8f5306dcc5c2ee7b$export$99986585b9b9a16(updatedRedirectTo));
                    return;
                }
                dispatch($8f5306dcc5c2ee7b$export$99986585b9b9a16(redirectTo));
            } else {
                if (uiErrors && uiErrors.length) dispatch($8f5306dcc5c2ee7b$export$addc2691c91f42be(uiErrors[0].key || 'unknown'));
                else if (fieldErrors && Object.keys(fieldErrors).length) dispatch($8f5306dcc5c2ee7b$export$f17d5fd8029ff8d7(fieldErrors));
                else dispatch($8f5306dcc5c2ee7b$export$addc2691c91f42be('unknown'));
            }
        } catch (error) {
            dispatch($8f5306dcc5c2ee7b$export$addc2691c91f42be('unknown'));
        }
    };
/**
 * This function allows additive changes only to continue URL search params.
 *
 * The full redirect URL often has a continue URL defined in its search params, usually pointing to
 * a destination product, like Loom. This continue URL, in turn, may have search params of its own.
 *
 * In some cases, consumers of the signup function may want to include certain additional params
 * inside the continue URL, based on what happened during the signup flow. This is useful to be able
 * to make decisions once the user lands on the product's domain.
 *
 * For example, a product may want to include a param to indicate that the user attempted to sign
 * up, but was redirected to /login on IDAC because they already have an account. They can include a
 * param in the continue URL to indicate that this was the case.
 */ const $8f5306dcc5c2ee7b$var$updateRedirectContinueUrlParams = ({ fullRedirectUrlValue: fullRedirectUrlValue, paramsToAdd: paramsToAdd, continueUrlValue: continueUrlValue })=>{
    const fullRedirectUrl = new URL(fullRedirectUrlValue);
    const redirectUrlParams = new URLSearchParams(fullRedirectUrl.search);
    const continueUrl = new URL(continueUrlValue);
    // update the params of the continue URL
    const existingParams = new URLSearchParams(continueUrl.search);
    const combinedParams = new URLSearchParams([
        ...existingParams,
        ...paramsToAdd
    ]);
    continueUrl.search = combinedParams.toString();
    // update the continue param of the full redirect URL
    redirectUrlParams.set('continue', continueUrl.toString());
    fullRedirectUrl.search = redirectUrlParams.toString();
    return fullRedirectUrl.toString();
};

});

parcelRegister("bUwsE", function(module, exports) {
$parcel$export(module.exports, "LoginLink", function () { return (parcelRequire("hiOqT")).LoginLink; });
$parcel$export(module.exports, "SignupPrivacyPolicy", function () { return (parcelRequire("8iNb4")).SignupPrivacyPolicy; });
$parcel$export(module.exports, "SignupRecaptcha", function () { return (parcelRequire("8X74v")).SignupRecaptcha; });
$parcel$export(module.exports, "SignupRecaptchaNotice", function () { return (parcelRequire("lSnCh")).SignupRecaptchaNotice; });
parcelRequire("hiOqT");
parcelRequire("7Nd87");
parcelRequire("hKGfs");
parcelRequire("8iNb4");
parcelRequire("9TT4m");

});
parcelRegister("hiOqT", function(module, exports) {

$parcel$export(module.exports, "LoginLink", function () { return $67c4124cea7dd71f$export$ae88ed303b99c258; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $lwrli = parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $fSUge = parcelRequire("fSUge");

var $chJxj = parcelRequire("chJxj");

var $cuZAx = parcelRequire("cuZAx");

var $3YSXY = parcelRequire("3YSXY");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");
const $67c4124cea7dd71f$export$ae88ed303b99c258 = ({ children: children })=>{
    (0, $kfOJC.useRegisterComponent)($67c4124cea7dd71f$export$ae88ed303b99c258.name);
    const location = (0, $cVnBY.useLocation)();
    const { isEmbedded: isEmbedded, oidcContext: oidcContext } = (0, $fSUge.useMicrobranding)();
    const loginLink = '/login' + location.search;
    if (isEmbedded) return null;
    if ((0, $cuZAx.isOidcDisplayMode)(oidcContext, (0, $chJxj.OidcDisplay).Signup)) return null;
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.Link), {
        id: "already-have-an-account",
        to: loginLink,
        children: children || /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6CtE1.Fragment), {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "signup.already.have.account.log.in",
                defaultMessage: "Already have an Atlassian account? Log in"
            })
        })
    });
};

});

parcelRegister("7Nd87", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1797fa57be7cbb64$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $kJPFV = parcelRequire("kJPFV");

var $kvy9X = parcelRequire("kvy9X");

var $gre8I = parcelRequire("gre8I");

var $2byD0 = parcelRequire("2byD0");

var $8ak8k = parcelRequire("8ak8k");

var $hqddj = parcelRequire("hqddj");
parcelRequire("jM5Ly");
var $hMPjy = parcelRequire("hMPjy");
parcelRequire("9TT4m");
var $8X74v = parcelRequire("8X74v");

var $eTJEU = parcelRequire("eTJEU");
const $1797fa57be7cbb64$export$cc15cfe224a6a69b = ({ title: title, email: emailProp, onEmailChange: onEmailChange, error: error, userJourneyContextError: userJourneyContextError, fieldErrors: fieldErrors, onSignup: onSignup, onSubmitClick: onSubmitClick, onFormClick: onFormClick, hideEmailInput: hideEmailInput, disableEmailInput: disableEmailInput, onValidationError: onValidationError, privacyPolicy: privacyPolicy })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const [email, setEmail] = (0, $dNMDr.useState)(emailProp || '');
    const [shouldShowSpinner, setShouldShowSpinner] = (0, $dNMDr.useState)(false);
    const emailInputRef = (0, $dNMDr.useRef)(null);
    const currentEmailError = fieldErrors.email?.message;
    const previousEmailError = (0, $hMPjy.usePrevious)(currentEmailError);
    (0, $dNMDr.useEffect)(()=>{
        const emailError = currentEmailError && currentEmailError !== previousEmailError;
        if (emailError) emailInputRef.current?.focus();
    }, [
        currentEmailError,
        previousEmailError
    ]);
    const handleSubmit = (0, $dNMDr.useCallback)(async ()=>{
        const validationErrors = {};
        if (shouldShowSpinner) return;
        if (!hideEmailInput && email.trim() === '') validationErrors.email = formatMessage((0, $8ak8k.SignupFormMessages).emailEmpty);
        if (Object.keys(validationErrors).length) {
            onValidationError(validationErrors);
            const hasEmailError = validationErrors.email;
            if (hasEmailError) emailInputRef.current?.focus();
            return;
        }
        setShouldShowSpinner(true);
        try {
            await onSignup({
                email: email
            });
        } catch (e) {
            (0, $hqddj.captureException)(e);
        }
        setShouldShowSpinner(false);
    }, [
        shouldShowSpinner,
        hideEmailInput,
        email,
        formatMessage,
        onValidationError,
        onSignup
    ]);
    const handleEmailChange = (e)=>{
        const email = e.currentTarget.value;
        setEmail(email);
        if (onEmailChange) onEmailChange(email);
    };
    const renderPrivacyPolicy = ()=>{
        return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6CtE1.Fragment), {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTJEU.PrivacyPolicyContainer), {
                children: privacyPolicy
            })
        });
    };
    const renderSubmitButton = ()=>{
        return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTJEU.SignUpButtonWrapper), {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                appearance: "primary",
                type: "submit",
                isFullWidth: true,
                id: "signup-submit",
                isLoading: shouldShowSpinner,
                onClick: ()=>onSubmitClick && onSubmitClick(),
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "signup.form.submit.verify",
                    defaultMessage: "Sign up"
                })
            })
        });
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
        children: [
            userJourneyContextError && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gre8I.FormErrorWrapper), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kJPFV.default), {
                    testId: 'redirect-from-resetPassword-error',
                    appearance: "information",
                    children: userJourneyContextError.errorMessage
                })
            }),
            error ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gre8I.default), {
                children: error.errorMessage
            }) : null,
            title && /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                children: title
            }),
            /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $eTJEU.Form), {
                onSubmit: (e)=>{
                    e.preventDefault();
                    handleSubmit();
                },
                id: "form-sign-up",
                onClick: onFormClick,
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTJEU.EmailFieldGroup), {
                        isHidden: hideEmailInput,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kvy9X.default), {
                            testId: "signup-email-idf-testid",
                            name: "email",
                            autoComplete: hideEmailInput ? 'off' : 'username',
                            type: "email",
                            placeholder: formatMessage((0, $8ak8k.SignupFormMessages).emailPlaceholder),
                            label: formatMessage((0, $8ak8k.SignupFormMessages).emailLabel),
                            autoFocus: !email,
                            isInvalid: !!currentEmailError,
                            invalidMessage: currentEmailError,
                            onChange: handleEmailChange,
                            value: email,
                            ref: emailInputRef,
                            isDisabled: disableEmailInput
                        })
                    }),
                    renderPrivacyPolicy(),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8X74v.SignupRecaptcha), {}),
                    renderSubmitButton()
                ]
            })
        ]
    });
};
var $1797fa57be7cbb64$export$2e2bcd8739ae039 = $1797fa57be7cbb64$export$cc15cfe224a6a69b;

});
parcelRegister("8ak8k", function(module, exports) {

$parcel$export(module.exports, "SignupFormMessages", function () { return $edebfe5a89ee1593$export$ef21cebdb5785715; });

var $2CYmK = parcelRequire("2CYmK");
const $edebfe5a89ee1593$export$ef21cebdb5785715 = (0, $2CYmK.defineMessages)({
    emailEmpty: {
        id: 'signup.form.email.empty',
        defaultMessage: 'Please enter an email address',
        description: ''
    },
    emailPlaceholder: {
        id: 'signup.form.email.placeholder',
        defaultMessage: 'Enter your email',
        description: ''
    },
    emailLabel: {
        id: 'signup.form.email.label',
        defaultMessage: 'Email',
        description: 'Label for the email input'
    },
    signupDisplayNameEmpty: {
        id: 'signup.display.name.empty',
        defaultMessage: 'Full name must not be empty'
    },
    signupDisplayNameTooLong: {
        id: 'signup.display.name.too.long',
        defaultMessage: 'Full name must not be greater than 255 characters'
    },
    signupEmailFormatError: {
        id: 'signup.email.format.error',
        defaultMessage: 'Email is required to be in correct format'
    },
    signupEmailReachedMaxAliases: {
        id: 'signup.email.reached.max.aliases',
        defaultMessage: 'Email aliases are rate limited'
    },
    signupEmailRestrictedDomain: {
        id: 'signup.email.restricted.domain.error',
        defaultMessage: 'The provided email address is not allowed, please use a different one'
    },
    signupEmailBansNotAllowed: {
        id: 'signup.email.bans.not.allowed',
        defaultMessage: 'The provided email address is not allowed, please use a different one'
    },
    signupGenericFailure: {
        id: 'signup.failure',
        defaultMessage: 'We are unable to sign you up. Please contact support and provide this message: {0}'
    },
    signupCaptchaResponseError: {
        id: 'signup.captcha.response.required.error',
        defaultMessage: "Are you sure you're not a robot?"
    }
});

});

parcelRegister("9TT4m", function(module, exports) {
$parcel$export(module.exports, "SignupRecaptcha", function () { return (parcelRequire("8X74v")).SignupRecaptcha; });
$parcel$export(module.exports, "SignupRecaptchaNotice", function () { return (parcelRequire("lSnCh")).SignupRecaptchaNotice; });
parcelRequire("8X74v");
parcelRequire("lSnCh");

});
parcelRegister("8X74v", function(module, exports) {

$parcel$export(module.exports, "SignupRecaptcha", function () { return $80c46aad7463e9bd$export$650ffb8b3f19a565; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $hzllM = parcelRequire("hzllM");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $N2Fno = parcelRequire("N2Fno");
const $80c46aad7463e9bd$export$650ffb8b3f19a565 = ()=>{
    (0, $kfOJC.useRegisterComponent)($80c46aad7463e9bd$export$650ffb8b3f19a565.name);
    const { enabled: recaptchaEnabled, component: recaptchaComponent } = (0, $hzllM.useRecaptchaContext)();
    const shouldShow = recaptchaEnabled && recaptchaComponent;
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $N2Fno.SignupRecaptchaContainer), {
        children: recaptchaComponent
    });
};

});
parcelRegister("N2Fno", function(module, exports) {

$parcel$export(module.exports, "SignupRecaptchaContainer", function () { return $77d272ab1f182aa4$export$7f3c0d51ba2e627e; });

var $fbSBq = parcelRequire("fbSBq");

var $fhwYP = parcelRequire("fhwYP");
const $77d272ab1f182aa4$export$7f3c0d51ba2e627e = (0, $fbSBq.default)((0, $fhwYP.default))`
  .grecaptcha-badge {
    display: none;
  }
`;

});


parcelRegister("lSnCh", function(module, exports) {

$parcel$export(module.exports, "SignupRecaptchaNotice", function () { return $84240cc369321789$export$3ce9549b7ed98745; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fhwYP = parcelRequire("fhwYP");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");
const $84240cc369321789$export$3ce9549b7ed98745 = ()=>{
    (0, $kfOJC.useRegisterComponent)($84240cc369321789$export$3ce9549b7ed98745.name);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $fhwYP.RecaptchaNotice), {});
};

});


parcelRegister("eTJEU", function(module, exports) {

$parcel$export(module.exports, "FooterLogoWrapper", function () { return $9cb224e4aced0719$export$648d5009980d0c69; });
$parcel$export(module.exports, "PrivacyPolicyContainer", function () { return $9cb224e4aced0719$export$6b077d087ec15a10; });
$parcel$export(module.exports, "SignUpButtonWrapper", function () { return $9cb224e4aced0719$export$5d58eaf357166f34; });
$parcel$export(module.exports, "Form", function () { return $9cb224e4aced0719$export$a7fed597f4b8afd8; });
$parcel$export(module.exports, "EmailFieldGroup", function () { return $9cb224e4aced0719$export$2ad90a8dcd76cc44; });

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $6i4Wm = parcelRequire("6i4Wm");
const $9cb224e4aced0719$export$648d5009980d0c69 = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)}px;
`;
const $9cb224e4aced0719$export$6b077d087ec15a10 = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
  text-align: left;
  padding-left: 0;
`;
const $9cb224e4aced0719$export$5d58eaf357166f34 = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $9cb224e4aced0719$export$a7fed597f4b8afd8 = (0, $fbSBq.default).form`
  margin: 0;
`;
const $9cb224e4aced0719$export$2ad90a8dcd76cc44 = (0, $fbSBq.default)((0, $6i4Wm.default))`
  margin-bottom: ${(0, $68HQw.gridSize)()}px;
`;

});


parcelRegister("hKGfs", function(module, exports) {

$parcel$export(module.exports, "SignupGoogleOneTap", function () { return $45903092a2f1c77c$export$afc76af3b27474ba; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $4q9sb = parcelRequire("4q9sb");

var $aMBBA = parcelRequire("aMBBA");

var $ivYOl = parcelRequire("ivYOl");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $ei3NI = parcelRequire("ei3NI");

var $4qLQH = parcelRequire("4qLQH");

var $lDj5O = parcelRequire("lDj5O");
const $45903092a2f1c77c$export$afc76af3b27474ba = ({ children: children })=>{
    (0, $kfOJC.useRegisterComponent)($45903092a2f1c77c$export$afc76af3b27474ba.name);
    const dynamicConfigs = (0, $ei3NI.useDynamicConfigs)();
    const googleOneTapDismissed = (0, $aMBBA.useAppSelector)((state)=>state.googleOneTap.dismissed);
    const hashedCsrfToken = (0, $aMBBA.useAppSelector)((state)=>state.hashedCsrfToken);
    const { googleAuthClientId: googleAuthClientId } = (0, $aMBBA.useAppSelector)((state)=>state.appConfig);
    const disableOneTap = googleOneTapDismissed || (0, $lDj5O.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $4qLQH.AidFrontendDynamicConfig).GOOGLE_ONE_TAP_KILL_SWITCH);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $4q9sb.default), {
        csrfToken: hashedCsrfToken,
        googleAuthClientId: googleAuthClientId,
        source: (0, $ivYOl.pageId),
        enabled: !disableOneTap,
        children: children
    });
};

});
parcelRegister("4q9sb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $696c72299f66c192$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $5adZ3 = parcelRequire("5adZ3");

var $7SvfM = parcelRequire("7SvfM");

var $1JRGy = parcelRequire("1JRGy");

var $hH6uU = parcelRequire("hH6uU");

var $4NPio = parcelRequire("4NPio");

var $hhYxc = parcelRequire("hhYxc");
const $696c72299f66c192$var$oneTapClientUrl = 'https://accounts.google.com/gsi/client';
const $696c72299f66c192$export$dc57f6202fda5ffc = ({ children: children, csrfToken: csrfToken, enabled: enabled, google: google, googleAuthClientId: googleAuthClientId, recoveryOptions: recoveryOptions, source: source })=>{
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    (0, $dNMDr.useEffect)(()=>{
        const isCommercial = (0, $hhYxc.currentCloudType) === 'commercial';
        if (google?.accounts?.id && enabled && isCommercial) {
            google.accounts.id.initialize({
                client_id: googleAuthClientId,
                cancel_on_tap_outside: false,
                use_fedcm_for_prompt: true,
                itp_support: false,
                callback: (credentialResponse)=>{
                    analyticsClient.buttonClickedEvent(source, 'googleYoloAccountSelected');
                    const { userFlow: userFlow } = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(window.location.search);
                    // [KIRBY-7902] TODO: use feature flag to determine if we should use the new endpoint (and submitFormHackReplacement) or the old one
                    // Backend URL and endpoint to be in a new place if it requires changes to accept and response with JSON, but the owner of the service is outside of Kirby.
                    const callbackBase = `${window.location.origin}/login/google`;
                    const callbackParams = {
                        state: (0, $7SvfM.buildState)({
                            location: window.location,
                            csrfToken: csrfToken,
                            source: source,
                            loginType: (0, $7SvfM.LoginType).GoogleOneTap,
                            anonymousId: analyticsClient.getAnonymousId(),
                            userFlow: userFlow,
                            recoveryOptions: recoveryOptions
                        })
                    };
                    // [KIRBY-7902] TODO: replace with `submitFormHackReplacement` once the backend endpoint is ready.
                    (0, $hH6uU.default)({
                        method: 'POST',
                        action: `${callbackBase}?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(callbackParams)}`,
                        payload: {
                            id_token: credentialResponse.credential
                        }
                    });
                }
            });
            google.accounts.id.prompt((notification)=>{
                if (notification.isDismissedMoment()) {
                    const reason = notification.getDismissedReason();
                    analyticsClient.buttonClickedEvent(source, 'googleYoloDismissed', {
                        reason: reason
                    });
                }
            });
        }
        return ()=>google?.accounts?.id?.cancel();
    }, [
        google,
        enabled,
        googleAuthClientId,
        csrfToken,
        analyticsClient,
        source,
        recoveryOptions
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6CtE1.Fragment), {
        children: children
    });
};
var $696c72299f66c192$export$2e2bcd8739ae039 = (0, $5adZ3.default)($696c72299f66c192$var$oneTapClientUrl, {
    globalName: 'google',
    attributes: {
        nonce: window.cspNonce
    }
})($696c72299f66c192$export$dc57f6202fda5ffc);

});

parcelRegister("ivYOl", function(module, exports) {

$parcel$export(module.exports, "pageId", function () { return $3a077488016e24be$export$703ba2e7ea526c1b; });
const $3a077488016e24be$export$703ba2e7ea526c1b = 'atlassianAccountSignupScreen';

});


parcelRegister("8iNb4", function(module, exports) {

$parcel$export(module.exports, "SignupPrivacyPolicy", function () { return $a0a676667fe56001$export$873af88187638697; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $d3AOE = parcelRequire("d3AOE");

var $cuZAx = parcelRequire("cuZAx");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $ivYOl = parcelRequire("ivYOl");

var $7CsWu = parcelRequire("7CsWu");

var $fSUge = parcelRequire("fSUge");
const $a0a676667fe56001$export$873af88187638697 = ()=>{
    (0, $kfOJC.useRegisterComponent)($a0a676667fe56001$export$873af88187638697.name);
    const privacyPolicyMessageRef = (0, $dNMDr.useRef)(null);
    const { isEmbedded: isEmbedded, oidcContext: oidcContext } = (0, $fSUge.useMicrobranding)();
    const { setPrivacyPolicyText: setPrivacyPolicyText } = (0, $7CsWu.useSignupPageContext)();
    (0, $dNMDr.useEffect)(()=>{
        const privacyPolicyText = privacyPolicyMessageRef.current?.innerHTML || '';
        if (privacyPolicyText) setPrivacyPolicyText(privacyPolicyText);
    }, [
        privacyPolicyMessageRef.current?.innerHTML,
        setPrivacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $d3AOE.default), {
        isEmbedded: isEmbedded,
        isMobileOidc: (0, $cuZAx.isMobileOidc)(oidcContext),
        pageId: (0, $ivYOl.pageId),
        privacyPolicyText: (0, $d3AOE.PrivacyPolicyText).passwordSignup,
        ref: privacyPolicyMessageRef
    });
};

});
parcelRegister("d3AOE", function(module, exports) {

$parcel$export(module.exports, "PrivacyPolicyText", function () { return $29cffba308dbf0d6$export$e6f99b88cb37902d; });
$parcel$export(module.exports, "default", function () { return $29cffba308dbf0d6$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $fbSBq = parcelRequire("fbSBq");

var $5pCRv = parcelRequire("5pCRv");

var $4NPio = parcelRequire("4NPio");

var $e2mzU = parcelRequire("e2mzU");
const $29cffba308dbf0d6$var$SignupLegal = (0, $fbSBq.default).p`
  font-size: 12px;
`;
var $29cffba308dbf0d6$export$e6f99b88cb37902d = /*#__PURE__*/ function(PrivacyPolicyText) {
    PrivacyPolicyText["passwordSignup"] = "passwordSignup";
    PrivacyPolicyText["oauthSignup"] = "oauthSignup";
    return PrivacyPolicyText;
}({});
const $29cffba308dbf0d6$var$PrivacyPolicy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).forwardRef(({ isEmbedded: isEmbedded, isMobileOidc: isMobileOidc, pageId: pageId, privacyPolicyText: privacyPolicyText }, ref)=>{
    const cloudTOSLinkClicked = (0, $4NPio.useLinkClickedEvent)(pageId, 'cloudTermsOfService');
    const privacyPolicyLinkClicked = (0, $4NPio.useLinkClickedEvent)(pageId, 'privacyPolicy');
    const privacyPolicyMessage = (0, $dNMDr.useMemo)(()=>{
        const shouldUseMobileLinks = isEmbedded || isMobileOidc;
        const privacyPolicyUrl = shouldUseMobileLinks ? (0, $5pCRv.PRIVACY_POLICY_URL_MOBILE) : (0, $5pCRv.PRIVACY_POLICY_URL);
        const cloudTermsOfServiceUrl = shouldUseMobileLinks ? (0, $5pCRv.CLOUD_TERMS_OF_SERVICE_URL_MOBILE) : (0, $5pCRv.CLOUD_TERMS_OF_SERVICE_URL);
        const messageValues = {
            'cloud-tos-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $e2mzU.default), {
                    href: cloudTermsOfServiceUrl,
                    target: "_blank",
                    rel: "noreferrer noopener",
                    onClick: cloudTOSLinkClicked,
                    children: chunks
                }),
            'privacy-policy-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $e2mzU.default), {
                    href: privacyPolicyUrl,
                    target: "_blank",
                    rel: "noreferrer noopener",
                    onClick: privacyPolicyLinkClicked,
                    children: chunks
                })
        };
        return privacyPolicyText === "passwordSignup" ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "signup.form.legal.updated.password.xml",
            defaultMessage: "By signing up, I accept the Atlassian <cloud-tos-link>Cloud Terms of Service</cloud-tos-link> and acknowledge the <privacy-policy-link>Privacy Policy</privacy-policy-link>.",
            description: "Cloud Terms of Service and Privacy Policy notice displayed to users when signing up for an Atlassian account",
            values: messageValues
        }) : /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "signup.form.legal.updated.Oauth.xml",
            defaultMessage: "By creating an account, I accept the Atlassian <cloud-tos-link>Cloud Terms of Service</cloud-tos-link> and acknowledge the <privacy-policy-link>Privacy Policy</privacy-policy-link>.",
            description: "Cloud Terms of Service and Privacy Policy notice displayed to users when creating an Atlassian account",
            values: messageValues
        });
    }, [
        cloudTOSLinkClicked,
        privacyPolicyLinkClicked,
        isEmbedded,
        isMobileOidc,
        privacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)($29cffba308dbf0d6$var$SignupLegal, {
        "data-testid": "legal-message",
        ref: ref,
        children: privacyPolicyMessage
    });
});
$29cffba308dbf0d6$var$PrivacyPolicy.displayName = 'PrivacyPolicy';
var $29cffba308dbf0d6$export$2e2bcd8739ae039 = $29cffba308dbf0d6$var$PrivacyPolicy;

});

parcelRegister("7CsWu", function(module, exports) {

$parcel$export(module.exports, "useSignupPageContext", function () { return $9bf7144172b0cd58$export$ca302230e223e610; });
$parcel$export(module.exports, "SignupPageContextProvider", function () { return $9bf7144172b0cd58$export$840533f74aa75441; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");
const $9bf7144172b0cd58$export$77a8faae8f9f5eab = /*#__PURE__*/ (0, $dNMDr.createContext)(null);
const $9bf7144172b0cd58$export$ca302230e223e610 = ()=>{
    const context = (0, $dNMDr.useContext)($9bf7144172b0cd58$export$77a8faae8f9f5eab);
    if (!context) throw new Error('useSignupPageContext must be used within a SignupPageContextProvider');
    return context;
};
const $9bf7144172b0cd58$export$840533f74aa75441 = ({ children: children })=>{
    const [privacyPolicyText, setPrivacyPolicyText] = (0, $dNMDr.useState)();
    const state = (0, $dNMDr.useMemo)(()=>({
            privacyPolicyText: privacyPolicyText,
            setPrivacyPolicyText: setPrivacyPolicyText
        }), [
        privacyPolicyText,
        setPrivacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)($9bf7144172b0cd58$export$77a8faae8f9f5eab.Provider, {
        value: state,
        children: children
    });
};

});



parcelRegister("jBrXs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c8e924767ff48e5$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $4c8e924767ff48e5$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    headTitle: {
        id: 'signup.head.title',
        defaultMessage: 'Sign up'
    },
    contextualHeadTitle: {
        id: 'signup.contextual.head.title',
        defaultMessage: 'Sign up to continue to',
        description: `Precedes a page title or issue number. For example, "Sign up to continue to Sarah's Blogpost"`
    },
    socialAuthOr: {
        id: 'social.auth.or',
        defaultMessage: 'or'
    },
    socialAuthOrContinueWith: {
        id: 'social.auth.or-continue-with',
        defaultMessage: 'Or continue with:'
    },
    headerTitle: {
        id: 'signup.header.title',
        defaultMessage: 'Sign up to continue',
        description: 'Shown before the login form. e.g. "Sign up first then we will show you the content you requested"'
    },
    startCollaboratingHeaderTitle: {
        id: 'signup.header.start.collaborating.title',
        defaultMessage: 'Sign up to start collaborating',
        description: 'Shown before the signup form. e.g. "Sign up first then we will show you the content you requested"'
    }
});

});

parcelRegister("46hMy", function(module, exports) {

$parcel$export(module.exports, "useSignupSubmit", function () { return $345739755232b668$export$5757fd9e6194326b; });

var $dNMDr = parcelRequire("dNMDr");

var $lwrli = parcelRequire("lwrli");

var $4eVYs = parcelRequire("4eVYs");

var $aMBBA = parcelRequire("aMBBA");

var $4NPio = parcelRequire("4NPio");

var $lCnOB = parcelRequire("lCnOB");

var $ivYOl = parcelRequire("ivYOl");

var $7CsWu = parcelRequire("7CsWu");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $hzllM = parcelRequire("hzllM");

var $4yl6n = parcelRequire("4yl6n");

var $hqddj = parcelRequire("hqddj");
const $345739755232b668$var$useEmailFromSearchParams = ()=>{
    const loginHint = (0, $lCnOB.useLoginHint)();
    const [queryParams] = (0, $lwrli.useSearchParams)();
    const email = (0, $lCnOB.getEmailFromLoginHint)(loginHint) || queryParams.get('email');
    const shouldDisableEmailInput = queryParams.get('disableEmailInput') === 'true';
    return {
        email: email,
        shouldDisableEmailInput: shouldDisableEmailInput
    };
};
const $345739755232b668$export$5757fd9e6194326b = ({ autoSubmit: autoSubmitOption = true } = {})=>{
    (0, $kfOJC.useRegisterComponent)($345739755232b668$export$5757fd9e6194326b.name);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const [hasAutoSubmitted, setHasAutoSubmitted] = (0, $dNMDr.useState)(false);
    const { privacyPolicyText: privacyPolicyText = '' } = (0, $7CsWu.useSignupPageContext)();
    const [_, setQueryParams] = (0, $lwrli.useSearchParams)();
    const { fetchToken: fetchToken, recaptchaType: recaptchaType } = (0, $hzllM.useRecaptchaContext)();
    const fieldErrors = (0, $aMBBA.useAppSelector)((state)=>state.signup?.fieldErrors);
    const autoSubmitDefault = (0, $aMBBA.useAppSelector)((state)=>state.signup?.autoSubmit);
    const autoSubmit = (0, $dNMDr.useMemo)(()=>autoSubmitDefault && autoSubmitOption, [
        autoSubmitDefault,
        autoSubmitOption
    ]);
    const onSignup = (0, $dNMDr.useCallback)(async (signupData, options)=>{
        try {
            const challengeResponse = await fetchToken();
            setQueryParams((urlParams)=>{
                urlParams.delete('errorCode');
                if (urlParams.has('email')) urlParams.delete('email');
                urlParams.append('email', signupData.email);
                return urlParams;
            });
            analyticsClient.formSubmittedEvent((0, $ivYOl.pageId), 'signupForm', {
                autoSubmit: autoSubmit,
                recaptchaType: recaptchaType
            });
            return dispatch((0, $4eVYs.signup)({
                ...signupData,
                challengeResponse: challengeResponse,
                privacyPolicyText: privacyPolicyText
            }, undefined, options));
        } catch (e) {
            (0, $hqddj.captureException)(e);
            dispatch((0, $4eVYs.signupCaptchaFailure)(navigator.onLine));
        }
    }, [
        setQueryParams,
        analyticsClient,
        dispatch,
        fetchToken,
        recaptchaType,
        privacyPolicyText,
        autoSubmit
    ]);
    const { email: email, shouldDisableEmailInput: shouldDisableEmailInput } = $345739755232b668$var$useEmailFromSearchParams();
    (0, $dNMDr.useEffect)(()=>{
        if (autoSubmit && email && !hasAutoSubmitted) {
            onSignup({
                email: email
            });
            setHasAutoSubmitted(true);
        }
    }, [
        autoSubmit,
        email,
        onSignup,
        hasAutoSubmitted,
        setHasAutoSubmitted
    ]);
    const emailTranslation = (0, $4yl6n.useTranslateFormErrorIfAvailable)(fieldErrors.email);
    const fieldErrorsWithTranslations = (0, $dNMDr.useCallback)((fieldErrors)=>{
        // fieldErrors.email could either be a code or a pre-translated message.
        const emailErrorIsCode = fieldErrors.email !== emailTranslation;
        return {
            ...fieldErrors.email && {
                email: {
                    code: emailErrorIsCode ? fieldErrors.email : undefined,
                    // TODO [KIRBY-7532]: remove fallback to empty string after removing useTranslateFormErrorIfAvailable.
                    //   emailTranslation will always be defined if fieldErrors.email is defined.
                    message: emailTranslation || ''
                }
            }
        };
    }, [
        emailTranslation
    ]);
    return {
        onSignup: onSignup,
        fieldErrors: fieldErrorsWithTranslations(fieldErrors),
        email: email,
        shouldDisableEmailInput: shouldDisableEmailInput
    };
};

});

parcelRegister("2z6E1", function(module, exports) {

$parcel$export(module.exports, "useSocialSignup", function () { return $70e2253556eabfed$export$a4d24b27d4eb9a3e; });

var $dNMDr = parcelRequire("dNMDr");

var $aMBBA = parcelRequire("aMBBA");

var $4NPio = parcelRequire("4NPio");

var $kKzDC = parcelRequire("kKzDC");

var $7SvfM = parcelRequire("7SvfM");

var $ivYOl = parcelRequire("ivYOl");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $hhYxc = parcelRequire("hhYxc");
const $70e2253556eabfed$export$a4d24b27d4eb9a3e = ()=>{
    (0, $kfOJC.useRegisterComponent)($70e2253556eabfed$export$a4d24b27d4eb9a3e.name);
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const handleGoogleLogin = (0, $dNMDr.useCallback)((analyticsAttributes = {})=>{
        analyticsClient.buttonClickedEvent((0, $ivYOl.pageId), 'googleLoginButton', analyticsAttributes);
        (0, $7SvfM.redirectToGoogleLogin)({
            location: window.location,
            source: (0, $ivYOl.pageId)
        });
    }, [
        analyticsClient
    ]);
    const auth0Config = (0, $aMBBA.useAppSelector)((state)=>state.appConfig?.auth0Config);
    const csrfToken = (0, $aMBBA.useAppSelector)((state)=>state.csrfToken);
    const { handleAppleLogin: handleAppleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleSlackLogin: handleSlackLogin } = (0, $kKzDC.useSocialLoginHandlers)({
        pageId: $ivYOl.pageId,
        redirectParams: {
            location: window.location,
            auth0Config: auth0Config,
            csrfToken: csrfToken,
            source: (0, $ivYOl.pageId)
        }
    });
    const { isEmbedded: isEmbedded } = (0, $aMBBA.useAppSelector)((state)=>state.microbranding);
    const isCommercial = (0, $hhYxc.getCurrentCloudType)() === 'commercial';
    const envSupportsSocialSignup = (0, $dNMDr.useMemo)(()=>!isEmbedded && isCommercial, [
        isEmbedded,
        isCommercial
    ]);
    if (!envSupportsSocialSignup) return {
        envSupportsSocialSignup: false,
        handleGoogleLogin: null,
        handleAppleLogin: null,
        handleMicrosoftLogin: null,
        handleSlackLogin: null
    };
    return {
        envSupportsSocialSignup: true,
        handleGoogleLogin: handleGoogleLogin,
        handleAppleLogin: handleAppleLogin,
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleSlackLogin: handleSlackLogin
    };
};

});

parcelRegister("gfuQh", function(module, exports) {

$parcel$export(module.exports, "useSignup", function () { return $fd7674dc978348e6$export$da8941e4c91255e0; });

var $dNMDr = parcelRequire("dNMDr");

var $lwrli = parcelRequire("lwrli");

var $ko1o6 = parcelRequire("ko1o6");

var $4eVYs = parcelRequire("4eVYs");

var $aMBBA = parcelRequire("aMBBA");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $h4v4M = parcelRequire("h4v4M");
const $fd7674dc978348e6$export$da8941e4c91255e0 = ({ forceRedirect: forceRedirect = true } = {})=>{
    (0, $kfOJC.useRegisterComponent)($fd7674dc978348e6$export$da8941e4c91255e0.name);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const errorCode = (0, $aMBBA.useAppSelector)((state)=>state.signup?.error);
    const redirectTo = (0, $aMBBA.useAppSelector)((state)=>state.signup?.redirectTo);
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    (0, $dNMDr.useEffect)(()=>{
        if (redirectTo && forceRedirect) try {
            const url = new URL(redirectTo);
            navigate(url.toString());
        } catch (e) {
        // invalid URL provided
        }
    }, [
        redirectTo,
        forceRedirect,
        navigate
    ]);
    (0, $dNMDr.useEffect)(()=>{
        // On unmount, dispatch reset:
        return ()=>{
            dispatch((0, $4eVYs.reset)());
        };
    }, [
        dispatch
    ]);
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const error = (0, $dNMDr.useMemo)(()=>{
        return errorCode ? {
            errorCode: errorCode,
            errorMessage: $fd7674dc978348e6$var$signupErrorMessageFromCode(errorCode, formatMessage)
        } : undefined;
    }, [
        errorCode,
        formatMessage
    ]);
    const [queryParams] = (0, $lwrli.useSearchParams)();
    const isRedirectFromResetPassord = queryParams.get('errorCode') === 'account_does_not_exist';
    const userJourneyContextError = isRedirectFromResetPassord ? {
        errorCode: 'account_does_not_exist',
        errorMessage: formatMessage({
            id: 'signup.form.redirect.account.does.not.exist.error',
            defaultMessage: "We can't find an account for that email address.",
            description: 'Error message shown when user tries to reset password for account that does not exist and is redirected to sign up'
        })
    } : undefined;
    return {
        error: /**
     * An error resulting from the user's actions on the signup page (often server error from
     * submitting the form).
     * */ error,
        redirectTo: /** URL to redirect to, if opted out of forced redirect */ redirectTo,
        userJourneyContextError: /**
     * An error within the wider context of the user's journey, during which they have been
     * redirected to or otherwise landed on the signup page (i.e. not a result of something they did
     * while on the page).
     * */ userJourneyContextError
    };
};
const $fd7674dc978348e6$var$signupErrorMessageFromCode = (errorCode, formatMessage)=>{
    switch(errorCode){
        case 'unknown':
            return formatMessage({
                id: 'signup.error.unknown',
                defaultMessage: 'Something went wrong while attempting to sign up. Please try again.'
            });
        case 'captcha':
            return formatMessage({
                id: 'signup.error.captcha',
                defaultMessage: 'We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support.'
            });
        case 'captchaScoreTooLow':
            return formatMessage({
                id: 'signup.error.captcha.score_too_low',
                defaultMessage: "We'd like to make sure it's really you creating your account. Please confirm you're not a robot.",
                description: 'Message asking user to tick the reCAPTCHA checkbox and resubmit the form'
            });
        case 'request_error':
            return formatMessage({
                id: 'signup.error.request_error',
                defaultMessage: 'Unable to connect. Check your internet connection or the network settings for your browser and try again.'
            });
        case 'unexpectedError':
            return formatMessage({
                id: 'signup.error.unexpected_error',
                defaultMessage: "We couldn't create your account. Try again in a few minutes."
            });
        default:
            return formatMessage({
                id: 'signup.form.random.error',
                defaultMessage: 'An error occurred while attempting to sign up: {error}. Please try again or reach out to Atlassian Support.'
            }, {
                error: errorCode
            });
    }
};

});


parcelRegister("5oaMR", function(module, exports) {

$parcel$export(module.exports, "consentLoader", function () { return $aeeaac957b0c719c$export$51cb5cf91bb86b88; });
$parcel$export(module.exports, "default", function () { return $aeeaac957b0c719c$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $a6oyj = parcelRequire("a6oyj");

var $dNMDr = parcelRequire("dNMDr");
parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");

var $dwXRl = parcelRequire("dwXRl");

var $aMBBA = parcelRequire("aMBBA");

var $2eVHl = parcelRequire("2eVHl");

var $h4v4M = parcelRequire("h4v4M");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");

var $hqddj = parcelRequire("hqddj");




const $aeeaac957b0c719c$var$consentComponents = {
    fedramp: /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("6a6YG"))),
    'a53d6b63-3k57-1408-j79d-0b60b08kb685-privacy': /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("i30DB"))),
    '2a85b822-1ba4-44ec-968a-c2f95bf4b469-privacy': /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("l0QPl"))),
    '6e62b4f0-a2f3-4cb5-b61c-1bd397640f04-privacy': /*#__PURE__*/ (0, $dNMDr.lazy)(()=>(parcelRequire("kYIG9")))
};
async function $aeeaac957b0c719c$export$51cb5cf91bb86b88({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/login/consent/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--consent-screen'
        ]
    });
}
const $aeeaac957b0c719c$export$68f39a5ef8cea54d = ()=>{
    const { cobranding: cobranding } = (0, $2eVHl.useCobranding)();
    const csrfToken = (0, $aMBBA.useAppSelector)((state)=>state.csrfToken);
    const { background: Background } = (0, $dwXRl.getCobrandedComponents)(cobranding);
    const { organisationId: organisationId, consentType: consentType } = (0, $aMBBA.useAppSelector)((state)=>state.loginConsent);
    const { search: search } = (0, $cVnBY.useLocation)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const handleRedirectToLogin = (0, $dNMDr.useCallback)((errorKey)=>{
        const existingQueryParams = new URLSearchParams(search);
        existingQueryParams.set('errorCode', errorKey);
        const queryParamsWithErrorCode = existingQueryParams.toString();
        navigate(`/login?prompt=true&${queryParamsWithErrorCode}`);
    }, [
        search,
        navigate
    ]);
    const handleOnAccept = (0, $dNMDr.useCallback)(async ()=>{
        const requestPayload = {
            consent: 'provided'
        };
        const response = await fetch(`/v2/login/authorize/consent${search}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(requestPayload)
        });
        switch(response.status){
            case 200:
                const responseBody = await response.json();
                navigate(responseBody.uri);
                break;
            case 400:
                handleRedirectToLogin('consent-validation-error');
                break;
            default:
                handleRedirectToLogin('consent-validation-error');
                break;
        }
    }, [
        csrfToken,
        search,
        handleRedirectToLogin,
        navigate
    ]);
    const handleOnCancel = (0, $dNMDr.useCallback)(()=>{
        const existingQueryParams = new URLSearchParams(search);
        existingQueryParams.delete('token');
        existingQueryParams.set('prompt', 'true');
        existingQueryParams.set('errorCode', 'generic-consent-error');
        const queryParamsWithErrorCode = existingQueryParams.toString();
        navigate(`/login?${queryParamsWithErrorCode}`);
    }, [
        search,
        navigate
    ]);
    const consentId = (0, $dNMDr.useMemo)(()=>{
        if (organisationId) return `${organisationId}-${consentType}`;
        return consentType;
    }, [
        consentType,
        organisationId
    ]);
    const ConsentComponent = consentId && $aeeaac957b0c719c$var$consentComponents[consentId];
    (0, $dNMDr.useEffect)(()=>{
        if (!ConsentComponent) {
            (0, $hqddj.captureTaggedException)(`[ConsentScreen] no component rendered for organisation: ${organisationId}. Redirected to /login instead.`, {
                capabilities: [
                    'capability-group--login',
                    'capability-name--consent-screen'
                ]
            });
            handleRedirectToLogin('consent-loading-error');
        }
    }, [
        ConsentComponent,
        handleRedirectToLogin,
        organisationId
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $a6oyj.default), {
        children: /*#__PURE__*/ (0, $6CtE1.jsx)(Background, {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dNMDr.Suspense), {
                fallback: null,
                children: ConsentComponent ? /*#__PURE__*/ (0, $6CtE1.jsx)(ConsentComponent, {
                    onAccept: handleOnAccept,
                    onCancel: handleOnCancel
                }) : null
            })
        })
    });
};
var $aeeaac957b0c719c$export$2e2bcd8739ae039 = $aeeaac957b0c719c$export$68f39a5ef8cea54d;

});
parcelRegister("6a6YG", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("kv6pp")).then(()=>parcelRequire('qI2np'));

});

parcelRegister("i30DB", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("bXE8Y")).then(()=>parcelRequire('iuRvT'));

});

parcelRegister("l0QPl", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("611Eg")).then(()=>parcelRequire('6pxWu'));

});

parcelRegister("kYIG9", function(module, exports) {


module.exports = (parcelRequire("44cko"))((parcelRequire("k8vLt")).resolve("dg7tT")).then(()=>parcelRequire('be7Uy'));

});


parcelRegister("eho9X", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "socialConfirmationLoader", function () { return $5160daf33e2561f3$export$1e349fd991386427; });
$parcel$export(module.exports, "CreateAccountConfirmationPage", function () { return $5160daf33e2561f3$export$74ab7a9a192e1a7a; });
$parcel$export(module.exports, "default", function () { return $5160daf33e2561f3$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $Q6OOA = parcelRequire("Q6OOA");

var $4NPio = parcelRequire("4NPio");
parcelRequire("jM5Ly");
var $jId0c = parcelRequire("jId0c");
parcelRequire("hpnxO");
var $k3As7 = parcelRequire("k3As7");

var $fI1iv = parcelRequire("fI1iv");

var $4ljBU = parcelRequire("4ljBU");

var $3EDWx = parcelRequire("3EDWx");

var $gKKqe = parcelRequire("gKKqe");

var $iJkmO = parcelRequire("iJkmO");

var $decyi = parcelRequire("decyi");

var $jGDgP = parcelRequire("jGDgP");

var $79Fhd = parcelRequire("79Fhd");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");
async function $5160daf33e2561f3$export$1e349fd991386427({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/login/social/confirmation/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-subgroup--social-login'
        ]
    });
}
const $5160daf33e2561f3$export$74ab7a9a192e1a7a = ()=>{
    const pageState = (0, $k3As7.useCreateAccountConfirmationPageState)();
    const { createNeeded: createNeeded, isEmbedded: isEmbedded, isLoading: isLoading, loginType: loginType, oidcContext: oidcContext, verifyNeeded: verifyNeeded } = pageState;
    // TODO: move to our recaptcha component for this page?
    (0, $jId0c.useRecaptchaChallengeObserver)((0, $gKKqe.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID));
    const onSubmitClick = (0, $4NPio.useButtonClickedEvent)((0, $gKKqe.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'confirmationSignup');
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $Q6OOA.default), {
        pageId: (0, $gKKqe.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID),
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $iJkmO.Header), {
            createNeeded: createNeeded
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $jGDgP.WhiteboxFooter), {
            loginType: loginType,
            verifyNeeded: verifyNeeded,
            createNeeded: createNeeded,
            isEmbedded: isEmbedded,
            oidcContext: oidcContext
        }),
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3EDWx.default), {
            isEmbedded: isEmbedded,
            isLoading: isLoading,
            privacyPolicy: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $fI1iv.CreateAccountConfirmationPrivacyPolicy), {}),
            onSubmitClick: onSubmitClick,
            title: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $decyi.TitleText), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79Fhd.ConfirmationFormTitleText), {
                    loginType: loginType,
                    createNeeded: createNeeded
                })
            })
        })
    });
};
var $5160daf33e2561f3$export$2e2bcd8739ae039 = $5160daf33e2561f3$export$74ab7a9a192e1a7a;

});
parcelRegister("fI1iv", function(module, exports) {

$parcel$export(module.exports, "CreateAccountConfirmationPrivacyPolicy", function () { return $01ad4111bcf7c71e$export$4f3ec0472a168e52; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $d3AOE = parcelRequire("d3AOE");

var $cuZAx = parcelRequire("cuZAx");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $gKKqe = parcelRequire("gKKqe");

var $fwoPi = parcelRequire("fwoPi");

var $aMBBA = parcelRequire("aMBBA");
const $01ad4111bcf7c71e$export$4f3ec0472a168e52 = ()=>{
    (0, $kfOJC.useRegisterComponent)($01ad4111bcf7c71e$export$4f3ec0472a168e52.name);
    const privacyPolicyMessageRef = (0, $dNMDr.useRef)(null);
    const oidcContext = (0, $aMBBA.useAppSelector)((state)=>state?.microbranding?.oidcContext);
    const isEmbedded = (0, $aMBBA.useAppSelector)((state)=>Boolean(state.microbranding.isEmbedded));
    const { setPrivacyPolicyText: setPrivacyPolicyText } = (0, $fwoPi.useCreateAccountConfirmationPageContext)();
    const privacyPolicyText = privacyPolicyMessageRef.current?.innerHTML || '';
    (0, $dNMDr.useEffect)(()=>{
        if (privacyPolicyText) setPrivacyPolicyText(privacyPolicyText);
    }, [
        privacyPolicyText,
        setPrivacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $d3AOE.default), {
        isEmbedded: isEmbedded,
        isMobileOidc: (0, $cuZAx.isMobileOidc)(oidcContext),
        pageId: (0, $gKKqe.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID),
        privacyPolicyText: (0, $d3AOE.PrivacyPolicyText).oauthSignup,
        ref: privacyPolicyMessageRef
    });
};

});
parcelRegister("gKKqe", function(module, exports) {

$parcel$export(module.exports, "CREATE_ACCOUNT_CONFIRMATION_PAGE_ID", function () { return $ab45d56222afba0f$export$eda9461179ec043e; });
const $ab45d56222afba0f$export$eda9461179ec043e = 'confirmCreateAccountIdpScreen';

});

parcelRegister("fwoPi", function(module, exports) {

$parcel$export(module.exports, "useCreateAccountConfirmationPageContext", function () { return $5156216b456a50ac$export$4b772b7a2dc6f7e0; });
$parcel$export(module.exports, "CreateAccountConfirmationPageProvider", function () { return $5156216b456a50ac$export$a212ad9eda3f2daa; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");
const $5156216b456a50ac$export$3906f31e8e2451c7 = /*#__PURE__*/ (0, $dNMDr.createContext)(null);
const $5156216b456a50ac$export$4b772b7a2dc6f7e0 = ()=>{
    const context = (0, $dNMDr.useContext)($5156216b456a50ac$export$3906f31e8e2451c7);
    if (!context) throw new Error('useCreateAccountConfirmationPageContext must be used within a CreateAccountConfirmationPageContext provider');
    return context;
};
const $5156216b456a50ac$export$a212ad9eda3f2daa = ({ children: children })=>{
    const [privacyPolicyText, setPrivacyPolicyText] = (0, $dNMDr.useState)();
    const [marketingConsent, setMarketingConsent] = (0, $dNMDr.useState)({
        state: 'not_shown'
    });
    const state = (0, $dNMDr.useMemo)(()=>({
            privacyPolicyText: privacyPolicyText,
            setPrivacyPolicyText: setPrivacyPolicyText,
            marketingConsent: marketingConsent,
            setMarketingConsent: setMarketingConsent
        }), [
        marketingConsent,
        privacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)($5156216b456a50ac$export$3906f31e8e2451c7.Provider, {
        value: state,
        children: children
    });
};

});


parcelRegister("3EDWx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adeca705db4e893b$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $1lkpU = parcelRequire("1lkpU");

var $1Cwlx = parcelRequire("1Cwlx");

var $2byD0 = parcelRequire("2byD0");

var $79HVl = parcelRequire("79HVl");

var $gre8I = parcelRequire("gre8I");

var $fbSBq = parcelRequire("fbSBq");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $6i4Wm = parcelRequire("6i4Wm");

var $7SvfM = parcelRequire("7SvfM");

var $7imrD = parcelRequire("7imrD");
var $aij7o = parcelRequire("aij7o");

var $hUFEA = parcelRequire("hUFEA");

var $d3Hua = parcelRequire("d3Hua");

var $9p1uE = parcelRequire("9p1uE");
const $adeca705db4e893b$export$6b077d087ec15a10 = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
  text-align: left;
`;
const $adeca705db4e893b$var$ConsentAndLegalContainer = (0, $fbSBq.default)((0, $6i4Wm.default))`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $adeca705db4e893b$export$9951c1d20fa87009 = (0, $fbSBq.default).div`
  display: flex;
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $adeca705db4e893b$var$StyledForm = (0, $fbSBq.default).form`
  margin: 0;
`;
const $adeca705db4e893b$export$60374ee25b7d5e87 = (0, $fbSBq.default).div`
  font-weight: bold;
  color: ${(0, $l4KzN).N800};
  word-wrap: break-word;
`;
const $adeca705db4e893b$var$VerificationWrapper = (0, $fbSBq.default).div`
  margin: ${(0, $68HQw.gridSize)() * 2}px 0 0;
`;
const $adeca705db4e893b$export$ca6de4c099a9b97d = ({ isLoading: isLoading, onSubmitClick: onSubmitClick, privacyPolicy: privacyPolicy, title: title })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const { onCreateAccountConfirmation: onCreateAccountConfirmation, createAccountNeeded: createNeeded, verifyEmailNeeded: verifyNeeded, email: email, displayName: initialDisplayName, canEditDisplayName: canEditDisplayName, formError: formError, fieldErrors: fieldErrors } = (0, $d3Hua.useCreateAccountConfirmation)({});
    const [code, setCode] = (0, $dNMDr.useState)('');
    const [displayName, setDisplayName] = (0, $dNMDr.useState)('');
    (0, $dNMDr.useEffect)(()=>{
        if (initialDisplayName && displayName === '') setDisplayName(initialDisplayName);
    }, [
        initialDisplayName,
        displayName
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        await onCreateAccountConfirmation({
            displayName: displayName,
            code: code
        });
    };
    const handleDisplayNameChange = (e)=>{
        const displayName = e.currentTarget.value;
        setDisplayName(displayName);
    };
    const handleCodeChange = (e)=>{
        const code = e.currentTarget.value;
        setCode(code);
    };
    const submitButtonText = ()=>{
        if (createNeeded) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "confirmation.form.submit.create",
            defaultMessage: "Create your account",
            description: "Button to submit form and create account"
        });
        else return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "confirmation.form.submit.verify",
            defaultMessage: "Verify your account",
            description: "Button to submit form and verify account"
        });
    };
    const renderHiddenEmailWarning = ()=>{
        return /*#__PURE__*/ (0, $6CtE1.jsx)($adeca705db4e893b$export$9951c1d20fa87009, {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gre8I.default), {
                title: formatMessage((0, $1Cwlx.default).hiddenEmailWarningTitle),
                children: /*#__PURE__*/ (0, $6CtE1.jsx)("p", {
                    "data-testid": "hidden-email-warning",
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "confirmation.form.hiddenemailwarning.message",
                        defaultMessage: "Your team may not recognize you and you won't receive their updates. When you are ready to work with a team, just update your Apple ID settings to share your real email."
                    })
                })
            })
        });
    };
    const renderCodeError = (error)=>{
        switch(error){
            case 'invalid_code':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "confirmation.form.code.invalid.server",
                    defaultMessage: "Provided verification code is invalid"
                });
            case 'invalid_length':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "confirmation.form.code.invalid.length",
                    defaultMessage: "Your verification code needs to be {length, plural, one {# digit} other {# digits}} or longer",
                    values: {
                        length: 8
                    }
                });
            case 'empty_code':
                return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    id: "confirmation.form.code.empty",
                    defaultMessage: "Please enter a verification code"
                });
        }
    };
    const displayNameError = fieldErrors && fieldErrors.displayName;
    const codeError = fieldErrors && fieldErrors.code;
    return /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
        children: [
            formError && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gre8I.default), {
                children: formError?.message
            }),
            title && /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                children: title
            }),
            email && (0, $7SvfM.isAppleHiddenEmail)(email) && renderHiddenEmailWarning(),
            /*#__PURE__*/ (0, $6CtE1.jsxs)($adeca705db4e893b$var$StyledForm, {
                onSubmit: handleSubmit,
                id: "confirmation-form",
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $aij7o.default), {
                        name: "email",
                        label: formatMessage((0, $1Cwlx.default).emailLabel),
                        children: ()=>/*#__PURE__*/ (0, $6CtE1.jsx)($adeca705db4e893b$export$60374ee25b7d5e87, {
                                children: email
                            })
                    }),
                    createNeeded && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $aij7o.default), {
                        name: "displayName",
                        label: formatMessage((0, $1Cwlx.default).displayNameLabel),
                        children: ({ fieldProps: fieldProps })=>!canEditDisplayName ? /*#__PURE__*/ (0, $6CtE1.jsx)($adeca705db4e893b$export$60374ee25b7d5e87, {
                                role: "caption",
                                children: initialDisplayName
                            }) : /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $1lkpU.default), {
                                        ...fieldProps,
                                        placeholder: formatMessage((0, $1Cwlx.default).displayNamePlaceholder),
                                        type: "text",
                                        defaultValue: initialDisplayName,
                                        onChange: handleDisplayNameChange,
                                        isInvalid: !!displayNameError,
                                        autoFocus: !!email && !initialDisplayName
                                    }),
                                    !!displayNameError && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7imrD.ErrorMessage), {
                                        children: displayNameError
                                    })
                                ]
                            })
                    }),
                    verifyNeeded && /*#__PURE__*/ (0, $6CtE1.jsx)($adeca705db4e893b$var$VerificationWrapper, {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $aij7o.default), {
                            name: "code",
                            label: formatMessage((0, $1Cwlx.default).codeLabel),
                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $1lkpU.default), {
                                            ...fieldProps,
                                            id: "code",
                                            placeholder: formatMessage((0, $1Cwlx.default).codePlaceHolder),
                                            type: "text",
                                            onChange: handleCodeChange,
                                            isInvalid: !!codeError,
                                            "aria-describedby": codeError ? `${fieldProps.id}-error` : undefined,
                                            spellCheck: false,
                                            autoComplete: "off",
                                            maxLength: 16
                                        }),
                                        /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7imrD.MessageWrapper), {
                                            children: !!codeError && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7imrD.ErrorMessage), {
                                                children: renderCodeError(codeError)
                                            })
                                        })
                                    ]
                                })
                        })
                    }),
                    createNeeded && /*#__PURE__*/ (0, $6CtE1.jsxs)($adeca705db4e893b$var$ConsentAndLegalContainer, {
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $hUFEA.CreateAccountConfirmationMarketingConsent), {}),
                            /*#__PURE__*/ (0, $6CtE1.jsx)($adeca705db4e893b$export$6b077d087ec15a10, {
                                children: privacyPolicy
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $9p1uE.CreateAccountConfirmationRecaptcha), {}),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $79HVl.default), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                            appearance: "primary",
                            id: "login-submit",
                            type: "submit",
                            isFullWidth: true,
                            isLoading: isLoading,
                            onClick: onSubmitClick,
                            children: submitButtonText()
                        })
                    })
                ]
            })
        ]
    });
};
var $adeca705db4e893b$export$2e2bcd8739ae039 = $adeca705db4e893b$export$ca6de4c099a9b97d;

});
parcelRegister("1Cwlx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecad08605653cf74$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $ecad08605653cf74$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    displayNameEmpty: {
        id: 'confirmation.form.displayName.empty',
        defaultMessage: 'Please enter a name',
        description: ''
    },
    displayNamePlaceholder: {
        id: 'confirmation.form.displayName.placeholder',
        defaultMessage: 'Enter full name',
        description: ''
    },
    displayNameLabel: {
        id: 'confirmation.form.displayName.label',
        defaultMessage: 'Full name',
        description: ''
    },
    codePlaceHolder: {
        id: 'confirmation.form.code.placeholder',
        defaultMessage: 'Enter the code sent to your email',
        description: 'Placeholder for text input'
    },
    codeLabel: {
        id: 'confirmation.form.code.label',
        defaultMessage: 'Verification code',
        description: 'Label for text input'
    },
    emailLabel: {
        id: 'confirmation.form.emailaddress.label',
        defaultMessage: 'Email address',
        description: ''
    },
    hiddenEmailWarningTitle: {
        id: 'confirmation.form.hiddenemailwarning.title',
        defaultMessage: "You're hiding your real email",
        description: ''
    }
});

});

parcelRegister("hUFEA", function(module, exports) {

$parcel$export(module.exports, "CreateAccountConfirmationMarketingConsent", function () { return $baacf9dbe906fc18$export$3340e585d36bf8e8; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $fwoPi = parcelRequire("fwoPi");

var $7C1Rq = parcelRequire("7C1Rq");

var $aMBBA = parcelRequire("aMBBA");

var $c7MmN = parcelRequire("c7MmN");
const $baacf9dbe906fc18$var$marketingConsentSelector = (state)=>state.marketingConsent.config;
const $baacf9dbe906fc18$var$createAccountEmailSelector = (state)=>state.createAccount.email;
const $baacf9dbe906fc18$export$3340e585d36bf8e8 = ()=>{
    (0, $kfOJC.useRegisterComponent)($baacf9dbe906fc18$export$3340e585d36bf8e8.name);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const { setMarketingConsent: setMarketingConsent } = (0, $fwoPi.useCreateAccountConfirmationPageContext)();
    const marketingConsentConfig = (0, $aMBBA.useAppSelector)($baacf9dbe906fc18$var$marketingConsentSelector);
    const email = (0, $aMBBA.useAppSelector)($baacf9dbe906fc18$var$createAccountEmailSelector);
    (0, $dNMDr.useEffect)(()=>{
        if (email) dispatch((0, $c7MmN.fetchConsentConfig)(email));
    }, [
        dispatch,
        email
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7C1Rq.default), {
        config: marketingConsentConfig,
        onConsentChange: setMarketingConsent
    });
};

});

parcelRegister("d3Hua", function(module, exports) {

$parcel$export(module.exports, "useCreateAccountConfirmation", function () { return $7fb0266014e1cfbe$export$e91af0855b7bcb2e; });

var $dNMDr = parcelRequire("dNMDr");

var $fwoPi = parcelRequire("fwoPi");
parcelRequire("hpnxO");
var $k3As7 = parcelRequire("k3As7");

var $1Cwlx = parcelRequire("1Cwlx");

var $ko1o6 = parcelRequire("ko1o6");

var $cElKX = parcelRequire("cElKX");

var $hzllM = parcelRequire("hzllM");

var $aMBBA = parcelRequire("aMBBA");

var $btezy = parcelRequire("btezy");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $4NPio = parcelRequire("4NPio");

var $gKKqe = parcelRequire("gKKqe");

var $7SvfM = parcelRequire("7SvfM");

var $h4v4M = parcelRequire("h4v4M");
parcelRequire("jM5Ly");
var $04aYR = parcelRequire("04aYR");
const $7fb0266014e1cfbe$export$e91af0855b7bcb2e = ({ onFailure: onFailure, onSubmit: onSubmit, autoRedirect: autoRedirect = true } = {
    autoRedirect: true
})=>{
    (0, $kfOJC.useRegisterComponent)($7fb0266014e1cfbe$export$e91af0855b7bcb2e.name);
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const pageState = (0, $k3As7.useCreateAccountConfirmationPageState)();
    const { redirectTo: redirectTo, createNeeded: createNeeded, displayName: displayName, email: email, verifyNeeded: verifyNeeded, fieldErrors: fieldErrors, formError: formError, isLoading: isLoading, loginType: loginType } = pageState;
    const { fetchToken: fetchToken, recaptchaType: recaptchaType } = (0, $hzllM.useRecaptchaContext)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    // Prevent redirect if the autoRedirect flag is true
    // Used in cases where cobranding wants to redirect the user themselves.
    // NOTE: `autoRedirect` is deprecated, please do not use
    // @see: UseCreateAccountConfirmationHookProps['autoRedirect']
    (0, $04aYR.useForceRedirect)({
        redirectTo: autoRedirect ? redirectTo : undefined
    });
    const { marketingConsent: marketingConsent, privacyPolicyText: privacyPolicyText = '' } = (0, $fwoPi.useCreateAccountConfirmationPageContext)();
    const getEventAttributes = (0, $dNMDr.useCallback)((verificationCodeEntered)=>{
        return {
            loginType: loginType,
            confirmationCreateAccountNeeded: createNeeded,
            confirmationVerifyEmailNeeded: verifyNeeded,
            verificationCodeEntered: verificationCodeEntered,
            formError: formError,
            recaptchaType: recaptchaType
        };
    }, [
        createNeeded,
        formError,
        loginType,
        recaptchaType,
        verifyNeeded
    ]);
    const onValidationErrorAnalytics = (0, $dNMDr.useCallback)((errors, verificationCodeEntered)=>{
        if (errors.displayName) {
            const errorBooleanMap = Object.keys(errors).reduce((acc, val)=>({
                    ...acc,
                    [val + 'Error']: true
                }), {});
            analyticsClient.uiEvent({
                page: (0, $gKKqe.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID),
                action: 'shown',
                subject: 'error',
                subjectId: 'confirmCreateAccountIdpNoName',
                attributes: {
                    errors: errorBooleanMap
                }
            });
        }
        if (errors.code === 'empty_code') analyticsClient.errorShownEvent((0, $gKKqe.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'emptyCode', getEventAttributes(verificationCodeEntered));
        else if (errors.code === 'invalid_length') analyticsClient.errorShownEvent((0, $gKKqe.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'invalidCodeLength', getEventAttributes(verificationCodeEntered));
    }, [
        analyticsClient,
        getEventAttributes
    ]);
    const onSubmitAnalytics = (0, $dNMDr.useCallback)((verificationCodeEntered)=>{
        analyticsClient.checkboxChangedEvent((0, $gKKqe.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'marketingConsent', {
            ...getEventAttributes(verificationCodeEntered),
            status: marketingConsent?.state
        });
        analyticsClient.formSubmittedEvent((0, $gKKqe.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'confirmCreateAccountIdp', getEventAttributes(verificationCodeEntered));
    }, [
        analyticsClient,
        getEventAttributes,
        marketingConsent?.state
    ]);
    const handleSubmit = (0, $dNMDr.useCallback)((confirmationData)=>{
        navigate(location.pathname + location.search + location.hash);
        const challengeRequest = (0, $btezy.toChallengeRequest)(confirmationData.challengeResponse);
        const { loginType: loginType, hashedCsrfToken: hashedCsrfToken, confirmationToken: confirmationToken, mfaToken: mfaToken } = pageState;
        dispatch((0, $cElKX.inHouseSocialConfirmation)({
            ...confirmationData,
            privacyPolicyText: privacyPolicyText,
            hashedCsrfToken: hashedCsrfToken,
            mfaToken: mfaToken,
            confirmationToken: confirmationToken,
            loginType: loginType,
            challengeRequest: challengeRequest
        }));
    }, [
        navigate,
        pageState,
        dispatch,
        privacyPolicyText
    ]);
    const onCreateAccountConfirmation = (0, $dNMDr.useCallback)(async ({ displayName: displayName, code: code })=>{
        const validationErrors = {};
        if (isLoading) return;
        if (createNeeded && (!displayName || displayName.trim() === '')) validationErrors.displayName = formatMessage((0, $1Cwlx.default).displayNameEmpty); // TODO: do we want to create message codes here like in the OTP page?
        if (verifyNeeded) {
            if (!code || code.trim() === '') validationErrors.code = 'empty_code';
            else if (code.trim().length < 7) // Codes could be length 8 or 16, see HOT-94320 changes.
            // Condition of < 7 to allow for flexibility if further code length changes are needed.
            validationErrors.code = 'invalid_length';
        }
        const verificationCodeEntered = Boolean(code);
        if (Object.keys(validationErrors).length) {
            dispatch((0, $cElKX.showFieldErrors)(validationErrors));
            onValidationErrorAnalytics(validationErrors, verificationCodeEntered);
            onFailure?.(validationErrors);
            return;
        }
        const challengeResponse = await fetchToken();
        onSubmitAnalytics(verificationCodeEntered);
        onSubmit?.();
        if (createNeeded && verifyNeeded) handleSubmit({
            displayName: displayName,
            code: code,
            marketingConsentState: marketingConsent,
            challengeResponse: challengeResponse
        });
        else if (createNeeded) handleSubmit({
            displayName: displayName,
            marketingConsentState: marketingConsent,
            challengeResponse: challengeResponse
        });
        else handleSubmit({
            code: code,
            challengeResponse: challengeResponse
        });
    }, [
        isLoading,
        createNeeded,
        verifyNeeded,
        fetchToken,
        onSubmitAnalytics,
        onSubmit,
        formatMessage,
        dispatch,
        onValidationErrorAnalytics,
        onFailure,
        handleSubmit,
        marketingConsent
    ]);
    const canEditDisplayName = (0, $dNMDr.useMemo)(()=>{
        return loginType === (0, $7SvfM.LoginType).Apple || loginType === (0, $7SvfM.LoginType).Slack || loginType === (0, $7SvfM.LoginType).Microsoft;
    }, [
        loginType
    ]);
    const formErrorWithMessage = (0, $dNMDr.useMemo)(()=>{
        if (!formError) return;
        const message = $7fb0266014e1cfbe$var$errorMessageFromCode(formError, formatMessage);
        return {
            code: formError,
            message: message
        };
    }, [
        formError,
        formatMessage
    ]);
    return {
        createAccountNeeded: createNeeded,
        canEditDisplayName: canEditDisplayName,
        displayName: displayName,
        verifyEmailNeeded: verifyNeeded,
        onCreateAccountConfirmation: onCreateAccountConfirmation,
        email: email,
        fieldErrors: fieldErrors,
        formError: formErrorWithMessage,
        isLoading: isLoading,
        redirectTo: redirectTo
    };
};
const $7fb0266014e1cfbe$var$errorMessageFromCode = (errorCode, formatMessage)=>{
    switch(errorCode){
        case 'captcha_not_loaded':
        case 'captcha_failed':
            return formatMessage({
                id: 'confirmation.error.captcha.failed',
                defaultMessage: 'We are having trouble verifying ReCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support.'
            });
        case 'captchaScoreTooLow':
            return formatMessage({
                id: 'confirmation.error.captcha.score_too_low',
                defaultMessage: "We'd like to make sure it's really you creating your account. Please confirm you're not a robot.",
                description: 'Message asking user to tick the reCAPTCHA checkbox and resubmit the form'
            });
        case 'request_error':
            return formatMessage({
                id: 'confirmation.error.offline',
                defaultMessage: 'We seem to have lost the connection. Check your network settings, then try again. '
            });
        default:
            return formatMessage({
                id: 'confirmation.error.unknown',
                defaultMessage: 'Something went wrong while trying to create your account. Wait a few moments, then try again.'
            });
    }
};

});
parcelRegister("cElKX", function(module, exports) {

$parcel$export(module.exports, "showFieldErrors", function () { return $a5152e132a43bbe2$export$f17d5fd8029ff8d7; });
$parcel$export(module.exports, "inHouseSocialConfirmation", function () { return $a5152e132a43bbe2$export$fc20e580ac82d1bc; });
$parcel$export(module.exports, "resendInHouseVerificationCode", function () { return $a5152e132a43bbe2$export$1b8c49d1a252ff84; });

var $aDvvX = parcelRequire("aDvvX");

var $hH6uU = parcelRequire("hH6uU");

var $1JRGy = parcelRequire("1JRGy");

var $dJpcp = parcelRequire("dJpcp");
const $a5152e132a43bbe2$export$aad8462122ac592b = ()=>({
        type: 'CONFIRMATION_RESET'
    });
const $a5152e132a43bbe2$export$ff19f4caed0eaf31 = ()=>({
        type: 'CONFIRMATION_REQUEST'
    });
const $a5152e132a43bbe2$export$1cb045489d712953 = (redirectTo)=>({
        type: 'CONFIRMATION_REQUEST_SUCCESS',
        redirectTo: redirectTo
    });
const $a5152e132a43bbe2$export$bf1ddd88318577cc = (error)=>({
        type: 'CONFIRMATION_REQUEST_FAILED',
        error: error
    });
const $a5152e132a43bbe2$export$bd2309d55d5d70da = (backendState)=>({
        type: 'CONFIRMATION_STATE_UPDATE',
        backendState: backendState
    });
const $a5152e132a43bbe2$export$f17d5fd8029ff8d7 = (errors)=>({
        type: 'CONFIRMATION_SHOW_FIELD_ERROR',
        errors: errors
    });
const $a5152e132a43bbe2$export$4b98afed05a66101 = (mfaToken)=>({
        type: 'CONFIRMATION_RESEND_SUCCESS',
        mfaToken: mfaToken
    });
const $a5152e132a43bbe2$var$buildBaseConfirmationJsonPayload = (confirmationParams, state)=>{
    const { source: source, displayName: displayName, marketingConsentState: marketingConsentState, privacyPolicyText: privacyPolicyText } = confirmationParams;
    const payload = {
        fullName: displayName,
        source: source,
        atlassianAccountCreationConfirmed: true
    };
    if (marketingConsentState) {
        const marketingConsent = (0, $aDvvX.buildMarketingConsent)(state.marketingConsent.config, marketingConsentState, privacyPolicyText);
        if (marketingConsent) payload.marketingConsent = marketingConsent;
    }
    return payload;
};
const $a5152e132a43bbe2$export$fc20e580ac82d1bc = (confirmationParams)=>async (dispatch, getState)=>{
        const { loginType: loginType, confirmationToken: confirmationToken, mfaToken: mfaToken, hashedCsrfToken: hashedCsrfToken, code: code, challengeRequest: challengeRequest } = confirmationParams;
        dispatch($a5152e132a43bbe2$export$ff19f4caed0eaf31());
        const castleToken = await (0, $dJpcp.getCastleRequestToken)([
            'capability-group--signup',
            'capability-name--signup'
        ]);
        try {
            const payload = {
                ...$a5152e132a43bbe2$var$buildBaseConfirmationJsonPayload(confirmationParams, getState()),
                challengeResponse: challengeRequest,
                loginType: loginType,
                csrfToken: hashedCsrfToken,
                confirmationToken: confirmationToken,
                mfaToken: mfaToken,
                code: code,
                castleToken: castleToken
            };
            const csrfToken = getState().csrfToken;
            const params = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search);
            const ENDPOINT_PATH = '/rest/login/social/confirmation';
            // These are used by SIS to redirect the user to the correct place.
            // In the "old" implementation (i.e. `submitFormHack`)
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify({
                // Only include the query parameter if the value exists
                ...params.continue ? {
                    continue: params.continue
                } : {},
                ...params.application ? {
                    application: params.application
                } : {}
            });
            // Only include the query parameters if any exist on the url
            const qs = queryParams.length > 0 ? `?${queryParams}` : '';
            const action = `${ENDPOINT_PATH}${qs}`;
            const res = await (0, $hH6uU.submitFormHackReplacement)({
                method: 'POST',
                action: action,
                payload: payload,
                csrfToken: csrfToken,
                enablePassingCookies: true
            });
            const response = await res.json();
            const hasCreateAccountSpecificState = !!response.createAccount;
            // We have state from the backend, which we want to ensure is updated in the FE state.
            if (hasCreateAccountSpecificState) {
                // Want to make sure that it's the shape that we expect before updating the state
                const isCreateAccountObject = typeof response.createAccount === 'object' && !Array.isArray(response.createAccount);
                dispatch($a5152e132a43bbe2$export$bd2309d55d5d70da(isCreateAccountObject ? response.createAccount : {}));
            }
            const hasError = !!response?.createAccount?.formError;
            if (hasError) {
                dispatch($a5152e132a43bbe2$export$bf1ddd88318577cc(response.createAccount.formError));
                return;
            }
            // This indicates the backend is not behaving as expected
            // since even in error cases, we expect the backend endpoint to return a 200
            if (!res.ok) {
                dispatch($a5152e132a43bbe2$export$bf1ddd88318577cc('unknown'));
                return;
            }
            // The types on the FE define the response to always be under `createAccount` for this endpoint
            // but in practice the BE returns in some cases (i.e. success) in a different format
            // so we want to handle that
            const redirectTo = response?.createAccount?.redirectTo || response?.redirectTo;
            const hasRedirect = !!redirectTo;
            if (!hasRedirect) {
                // If we don't get a redirect URL from the BE _and_ we haven't been able to understand the error
                // we don't know where to send the user and there aren't enough details of the error (or they aren't in the expected format) so we are assuming the request failed.
                dispatch($a5152e132a43bbe2$export$bf1ddd88318577cc('unknown'));
                return;
            }
            dispatch($a5152e132a43bbe2$export$1cb045489d712953(redirectTo));
        } catch (error) {
            dispatch($a5152e132a43bbe2$export$bf1ddd88318577cc('unknown'));
        }
    };
const $a5152e132a43bbe2$export$1b8c49d1a252ff84 = (mfaToken)=>(dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        return fetch(`/rest/mfa/resend?transactionToken=${mfaToken}`, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        }).then((res)=>{
            if (res.ok) return res.json().then((json)=>{
                dispatch($a5152e132a43bbe2$export$4b98afed05a66101(json.transactionToken));
            });
            else return Promise.reject(new Error(`Failed to resend MFA code: ${res.status} ${res.statusText}`));
        });
    };

});


parcelRegister("9p1uE", function(module, exports) {

$parcel$export(module.exports, "CreateAccountConfirmationRecaptcha", function () { return $0fc39aebf8b531a2$export$4803e5c20b611abd; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $hzllM = parcelRequire("hzllM");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $jZPkR = parcelRequire("jZPkR");
const $0fc39aebf8b531a2$export$4803e5c20b611abd = ()=>{
    (0, $kfOJC.useRegisterComponent)($0fc39aebf8b531a2$export$4803e5c20b611abd.name);
    const { enabled: recaptchaEnabled, component: recaptchaComponent } = (0, $hzllM.useRecaptchaContext)();
    // TODO: confirm if server can tell this page to skip recaptcha by including a boolean flag in
    // the state, as it can for other pages (like Welcome)
    const shouldShow = recaptchaEnabled && recaptchaComponent;
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $jZPkR.CreateAccountConfirmationRecaptchaContainer), {
        children: recaptchaComponent
    });
};

});
parcelRegister("jZPkR", function(module, exports) {

$parcel$export(module.exports, "CreateAccountConfirmationRecaptchaContainer", function () { return $cd311453f50922ed$export$35fe2d48d1cfa8a6; });

var $fbSBq = parcelRequire("fbSBq");

var $fhwYP = parcelRequire("fhwYP");
const $cd311453f50922ed$export$35fe2d48d1cfa8a6 = (0, $fbSBq.default)((0, $fhwYP.default))`
  .grecaptcha-badge {
    display: none;
  }
`;

});



parcelRegister("iJkmO", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $e07cb93b5e81344c$export$8b251419efc915eb; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
const $e07cb93b5e81344c$export$8b251419efc915eb = ({ createNeeded: createNeeded })=>{
    if (createNeeded) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
        id: "account.creation.confirmation.title",
        defaultMessage: "Create your account",
        description: "Title of form for creating an account",
        tagName: "h5"
    });
    else return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
        id: "account.verification.title",
        defaultMessage: "Verify your email",
        description: "Title of form for verifying an account",
        tagName: "h5"
    });
};

});

parcelRegister("decyi", function(module, exports) {

$parcel$export(module.exports, "TitleText", function () { return $812d3a9cb3f4064d$export$5c707c04c5c45fff; });
$parcel$export(module.exports, "LoginLinkWrapper", function () { return $812d3a9cb3f4064d$export$daf565b81da2dd58; });

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");
const $812d3a9cb3f4064d$export$5c707c04c5c45fff = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
  margin-bottom: 16px;
`;
const $812d3a9cb3f4064d$export$daf565b81da2dd58 = (0, $fbSBq.default).div`
  margin-top: ${({ addTopMargin: addTopMargin })=>addTopMargin ? `${(0, $68HQw.gridSize)()}px` : 'initial'};
`;

});

parcelRegister("jGDgP", function(module, exports) {

$parcel$export(module.exports, "WhiteboxFooter", function () { return $35c0e0e9f01b1581$export$bad5896fb5d45c0b; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $lwrli = parcelRequire("lwrli");

var $3YSXY = parcelRequire("3YSXY");

var $1JRGy = parcelRequire("1JRGy");

var $chJxj = parcelRequire("chJxj");

var $cuZAx = parcelRequire("cuZAx");

var $4NPio = parcelRequire("4NPio");

var $faaZT = parcelRequire("faaZT");

var $gKKqe = parcelRequire("gKKqe");

var $decyi = parcelRequire("decyi");

var $eTWY7 = parcelRequire("eTWY7");
const $35c0e0e9f01b1581$export$bad5896fb5d45c0b = ({ loginType: loginType, createNeeded: createNeeded, isEmbedded: isEmbedded, oidcContext: oidcContext, verifyNeeded: verifyNeeded })=>{
    const showLoginLink = createNeeded && !isEmbedded && !(0, $cuZAx.isOidcDisplayMode)(oidcContext, (0, $chJxj.OidcDisplay).Signup);
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const handleOnLoginLinkClick = (0, $dNMDr.useCallback)(async ()=>{
        const eventAttributes = {
            loginType: loginType,
            confirmationCreateAccountNeeded: createNeeded,
            confirmationVerifyEmailNeeded: verifyNeeded
        };
        await analyticsClient.linkClickedEvent((0, $gKKqe.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'alreadyHaveAccountCreateAccountIdp', eventAttributes);
    }, [
        loginType,
        createNeeded,
        verifyNeeded,
        analyticsClient
    ]);
    const { resendVerificationCode: resendVerificationCode } = (0, $faaZT.useRetryAccountCreation)();
    const stripAuth0StateToken = (0, $dNMDr.useCallback)((search)=>{
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(search);
        delete params.state;
        return Object.keys(params).length ? '?' + (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(params) : '';
    }, []);
    // TODO: encapsulate in our hook, to ensure the auth0 state token is stripped?
    const loginLink = '/login' + stripAuth0StateToken(location.search);
    if (showLoginLink || verifyNeeded) return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
        children: [
            verifyNeeded && /*#__PURE__*/ (0, $6CtE1.jsx)("ul", {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $eTWY7.default), {
                        id: "didnt-get-an-email-start-again",
                        spacing: "none",
                        className: "link-color-override",
                        onClick: resendVerificationCode,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            id: "accountcreationconfirmation.resend.verification.code",
                            defaultMessage: "Resend verification code",
                            description: "Link button to resend the verification code if the user did not receive an email"
                        })
                    })
                })
            }),
            showLoginLink && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $decyi.LoginLinkWrapper), {
                addTopMargin: verifyNeeded,
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.Link), {
                    id: "already-have-an-account",
                    to: loginLink,
                    onClick: handleOnLoginLinkClick,
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "accountcreationconfirmation.already.have.account.log.in",
                        defaultMessage: "Already have an Atlassian account? Log in"
                    })
                })
            })
        ]
    });
    return null;
};

});
parcelRegister("faaZT", function(module, exports) {

$parcel$export(module.exports, "useRetryAccountCreation", function () { return $f60ccb6e93f9a3b2$export$1afab6e7aab1dd93; });

var $dNMDr = parcelRequire("dNMDr");

var $cElKX = parcelRequire("cElKX");

var $4NPio = parcelRequire("4NPio");

var $7lC8o = parcelRequire("7lC8o");

var $hqddj = parcelRequire("hqddj");

var $aMBBA = parcelRequire("aMBBA");
parcelRequire("hpnxO");
var $k3As7 = parcelRequire("k3As7");

var $cPPOr = parcelRequire("cPPOr");

var $gKKqe = parcelRequire("gKKqe");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");
const $f60ccb6e93f9a3b2$export$1afab6e7aab1dd93 = ()=>{
    (0, $kfOJC.useRegisterComponent)($f60ccb6e93f9a3b2$export$1afab6e7aab1dd93.name);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const pageState = (0, $k3As7.useCreateAccountConfirmationPageState)();
    const { createNeeded: createNeeded, verifyNeeded: verifyNeeded, loginType: loginType } = pageState;
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const dispatchAddFlag = (0, $dNMDr.useCallback)((flag)=>dispatch((0, $7lC8o.addFlag)(flag.type, flag.title, flag.description)), [
        dispatch
    ]);
    const resendVerificationCode = async ()=>{
        analyticsClient.linkClickedEvent((0, $gKKqe.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'startAgainCreateAccountIdp', {
            loginType: loginType,
            confirmationCreateAccountNeeded: createNeeded,
            confirmationVerifyEmailNeeded: verifyNeeded
        });
        const { mfaToken: mfaToken } = pageState;
        if (!mfaToken) {
            (0, $hqddj.captureErrorMessage)('MFA token missing');
            return;
        }
        await dispatch((0, $cElKX.resendInHouseVerificationCode)(mfaToken));
        dispatchAddFlag({
            type: 'success',
            title: (0, $cPPOr.default).resendVerificationCodeSuccessTitle,
            description: (0, $cPPOr.default).resendVerificationCodeSuccessDesc
        });
    };
    return {
        resendVerificationCode: resendVerificationCode
    };
};

});
parcelRegister("cPPOr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38529b38ed300be5$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $38529b38ed300be5$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    resendVerificationCodeSuccessTitle: {
        id: 'account.creation.confirmation.email.sent.title',
        defaultMessage: 'Email sent'
    },
    resendVerificationCodeSuccessDesc: {
        id: 'account.creation.confirmation.email.sent.desc',
        defaultMessage: 'We sent you another verification code'
    },
    resendVerificationCodeFailureTitle: {
        id: 'account.creation.confirmation.email.error.title',
        defaultMessage: 'Error'
    },
    resendVerificationCodeFailureDesc: {
        id: 'account.creation.confirmation.email.error.body',
        defaultMessage: "We couldn\u2019t send the verification code. Please try again."
    }
});

});



parcelRegister("79Fhd", function(module, exports) {

$parcel$export(module.exports, "ConfirmationFormTitleText", function () { return $12aafff52ce95c62$export$4306c5e98031f4d1; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $7SvfM = parcelRequire("7SvfM");
const $12aafff52ce95c62$export$4306c5e98031f4d1 = ({ loginType: loginType, createNeeded: createNeeded })=>{
    switch(loginType){
        case (0, $7SvfM.LoginType).GoogleButton:
        case (0, $7SvfM.LoginType).GoogleOneTap:
            if (createNeeded) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "account.creation.confirmation.explanation.google",
                defaultMessage: "We'll use your details from Google to create an account:"
            });
            else return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "account.verification.confirmation.explanation.google",
                defaultMessage: "To keep your account secure, please verify your login."
            });
        case (0, $7SvfM.LoginType).Apple:
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "account.creation.confirmation.explanation.apple",
                defaultMessage: "We'll use your details from Apple to create an account:"
            });
        case (0, $7SvfM.LoginType).Slack:
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "account.creation.confirmation.explanation.slack",
                defaultMessage: "We'll use your details from Slack to create an account for:",
                description: "Message shown to the user when they're creating an account using their Slack credentials"
            });
        case (0, $7SvfM.LoginType).Microsoft:
            if (createNeeded) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "account.creation.confirmation.explanation.microsoft",
                defaultMessage: "We'll use your details from Microsoft to create an account:"
            });
            else return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "account.verification.confirmation.explanation.microsoft",
                defaultMessage: "We were unable to verify the email associated with your Microsoft account, so let's do that now."
            });
        case (0, $7SvfM.LoginType).SSO:
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "account.creation.confirmation.explanation.sso",
                defaultMessage: "We'll use the details from your single sign-on provider to create an account. Contact your administrator if you want to change them."
            });
        default:
            return null;
    }
};

});


parcelRegister("6CVdn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "signupVerifyEmailOtpLoader", function () { return $56c6e1def449741f$export$ee12460ca2fbd2d1; });
$parcel$export(module.exports, "VerifyEmailOtpPage", function () { return $56c6e1def449741f$export$a16cb21d1f9bc820; });
$parcel$export(module.exports, "default", function () { return $56c6e1def449741f$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");
parcelRequire("jAwqE");
var $hnbS9 = parcelRequire("hnbS9");
var $azzBc = parcelRequire("azzBc");
var $dqKoq = parcelRequire("dqKoq");

var $j1629 = parcelRequire("j1629");

var $5seSI = parcelRequire("5seSI");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");
const $56c6e1def449741f$var$verifyEmailOtpErrorCodeMapping = {
    invalid_otp: 'invalid_otp',
    invalid_otp_length: 'invalid_otp_length',
    invalid_token: 'invalid_token',
    expired_token: 'expired_token',
    rate_limit_exceeded: 'rate_limited',
    internal_server_error: 'unexpected_error',
    unexpected_error: 'unexpected_error',
    'Too many requests. Please inspect Retry-After header.': 'rate_limited'
};
async function $56c6e1def449741f$export$ee12460ca2fbd2d1({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/signup/verify-email/otp/state', request, {
        capabilities: [
            'capability-group--signup',
            'capability-name--verify-email'
        ]
    });
}
const $56c6e1def449741f$export$a16cb21d1f9bc820 = ()=>{
    const { onVerifyEmailOtp: onVerifyEmailOtp, onInvalidEmailOtpLength: onInvalidEmailOtpLength, isLoading: isLoading, error: error } = (0, $dqKoq.useVerifyEmailOtp)();
    const { onResendEmailOtp: onResendEmailOtp } = (0, $hnbS9.useResendEmailOtp)();
    const { email: email } = (0, $azzBc.useSignupVerifyEmailOtpState)();
    const verifyEmailOtpErrorCode = !error?.errorCode ? undefined : $56c6e1def449741f$var$verifyEmailOtpErrorCodeMapping[error?.errorCode] || 'unexpected_error';
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $j1629.VerifyEmailOtp), {
        pageId: (0, $5seSI.VERIFY_EMAIL_OTP_PAGE_ID),
        flow: "sign-up",
        email: email,
        isLoading: isLoading,
        errorCode: verifyEmailOtpErrorCode,
        onVerifyEmailOtp: onVerifyEmailOtp,
        onResendEmailOtp: onResendEmailOtp,
        onInvalidEmailOtpLength: onInvalidEmailOtpLength
    });
};
var $56c6e1def449741f$export$2e2bcd8739ae039 = $56c6e1def449741f$export$a16cb21d1f9bc820;

});
parcelRegister("jAwqE", function(module, exports) {
$parcel$export(module.exports, "useVerifyEmailOtp", function () { return (parcelRequire("dqKoq")).useVerifyEmailOtp; });
$parcel$export(module.exports, "useResendEmailOtp", function () { return (parcelRequire("hnbS9")).useResendEmailOtp; });
$parcel$export(module.exports, "useSignupVerifyEmailOtpState", function () { return (parcelRequire("azzBc")).useSignupVerifyEmailOtpState; });
parcelRequire("dqKoq");
parcelRequire("hnbS9");
parcelRequire("azzBc");

});
parcelRegister("dqKoq", function(module, exports) {

$parcel$export(module.exports, "useVerifyEmailOtp", function () { return $63dbf1e651978c7a$export$dbb09362ea05a8a7; });

var $dNMDr = parcelRequire("dNMDr");

var $aMBBA = parcelRequire("aMBBA");

var $4NPio = parcelRequire("4NPio");

var $H2GiC = parcelRequire("H2GiC");

var $ko1o6 = parcelRequire("ko1o6");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $7aAOa = parcelRequire("7aAOa");

var $5seSI = parcelRequire("5seSI");

var $h4v4M = parcelRequire("h4v4M");
const $63dbf1e651978c7a$var$verifyEmailOtpSelectorFn = (state)=>state.verifyEmailOtp;
const $63dbf1e651978c7a$export$dbb09362ea05a8a7 = ({ onSubmit: onSubmit, onFailure: onFailure, onSuccess: onSuccess, autoRedirect: autoRedirect = true } = {})=>{
    (0, $kfOJC.useRegisterComponent)($63dbf1e651978c7a$export$dbb09362ea05a8a7.name);
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const { redirectType: redirectType, error: errorCode, isLoading: isLoading, redirectTo: redirectTo } = (0, $aMBBA.useAppSelector)($63dbf1e651978c7a$var$verifyEmailOtpSelectorFn);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    (0, $dNMDr.useEffect)(()=>{
        if (redirectTo && autoRedirect) navigate(redirectTo);
    }, [
        autoRedirect,
        redirectTo,
        navigate
    ]);
    const trackSubmitEmailOtp = (0, $4NPio.useFormSubmittedEvent)((0, $5seSI.VERIFY_EMAIL_OTP_PAGE_ID), 'verifyEmailOtp', {
        signupType: redirectType,
        source: 'emailOtpScreen'
    });
    const trackSubmissionFailure = (0, $4NPio.useFormSubmittedEvent)((0, $5seSI.VERIFY_EMAIL_OTP_PAGE_ID), 'verifyEmailOtp', {
        signupType: redirectType,
        result: 'invalid_otp_length'
    });
    const onVerifyEmailOtp = (0, $dNMDr.useCallback)((otp)=>{
        onSubmit?.();
        if (otp.length !== (0, $7aAOa.OTP_CODE_FULL_LENGTH)) {
            const error = 'invalid_otp_length';
            onFailure?.();
            trackSubmissionFailure();
            dispatch((0, $H2GiC.verifyEmailOtpFailure)(error));
        } else {
            onSuccess?.();
            trackSubmitEmailOtp();
            dispatch((0, $H2GiC.verifyEmailOtp)(otp, (0, $5seSI.VERIFY_EMAIL_OTP_PAGE_ID), analyticsClient));
        }
    }, [
        analyticsClient,
        dispatch,
        onFailure,
        onSubmit,
        onSuccess,
        trackSubmissionFailure,
        trackSubmitEmailOtp
    ]);
    const error = (0, $dNMDr.useMemo)(()=>errorCode ? {
            errorCode: errorCode,
            errorMessage: $63dbf1e651978c7a$var$otpErrorMessage(errorCode, formatMessage)
        } : undefined, [
        errorCode,
        formatMessage
    ]);
    return {
        onVerifyEmailOtp: onVerifyEmailOtp,
        onInvalidEmailOtpLength: trackSubmissionFailure,
        redirectTo: redirectTo,
        error: error,
        isLoading: isLoading
    };
};
const $63dbf1e651978c7a$var$otpErrorMessage = (errorCode, formatMessage)=>{
    switch(errorCode){
        case 'invalid_otp_length':
            return formatMessage({
                id: 'validate.email.otp.error.otp_length',
                defaultMessage: 'Complete the verification code'
            });
        case 'invalid_otp':
            return formatMessage({
                id: 'validate.email.otp.error.invalid_otp',
                defaultMessage: 'Provided verification code is invalid'
            });
        case 'invalid_token':
            return formatMessage({
                id: 'validate.email.otp.error.invalid_token',
                defaultMessage: 'Invalid token'
            });
        case 'expired_token':
            return formatMessage({
                id: 'validate.email.otp.error.expired_token',
                defaultMessage: 'Token expired'
            });
        case 'internal_server_error':
            return formatMessage({
                id: 'validate.email.otp.error.internal_server_error',
                defaultMessage: 'Internal server error'
            });
        case 'rate_limit_exceeded':
        case 'Too many requests. Please inspect Retry-After header.':
            return formatMessage({
                id: 'validate.email.otp.error.rate_limit_exceeded',
                defaultMessage: 'Rate limit exceeded. Try again in a couple of minutes.'
            });
        case 'unexpected_error':
        default:
            return formatMessage({
                id: 'validate.email.otp.error.unexpected_error',
                defaultMessage: 'Unexpected error'
            });
    }
};

});
parcelRegister("H2GiC", function(module, exports) {

$parcel$export(module.exports, "verifyEmailOtpFailure", function () { return $25ffd485c801c634$export$3871df646f7b1bd; });
$parcel$export(module.exports, "verifyEmailOtp", function () { return $25ffd485c801c634$export$f73803bb4b67b64c; });
$parcel$export(module.exports, "resendEmailOtp", function () { return $25ffd485c801c634$export$7738159be2c9b2bf; });

var $1JRGy = parcelRequire("1JRGy");

var $7lC8o = parcelRequire("7lC8o");

var $2CYmK = parcelRequire("2CYmK");

var $fcxz7 = parcelRequire("fcxz7");

var $hqddj = parcelRequire("hqddj");
const $25ffd485c801c634$export$43047bab95c658dd = (redirectTo)=>({
        type: 'VERIFY_EMAIL_OTP_SUCCESS',
        redirectTo: redirectTo
    });
const $25ffd485c801c634$export$3871df646f7b1bd = (error)=>({
        type: 'VERIFY_EMAIL_OTP_FAILURE',
        error: error
    });
const $25ffd485c801c634$export$840a1b6b804c3952 = ()=>({
        type: 'VERIFY_EMAIL_OTP_REQUEST'
    });
const $25ffd485c801c634$export$f73803bb4b67b64c = (otp, pageId, analyticsClient)=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken, cobranding: { productHint: productHint }, verifyEmailOtp: { redirectType: redirectType } } = getState();
        const { token: token } = $1JRGy.parse(window.location.search);
        const params = (0, $fcxz7.cobrandingURLParams)(window.location, productHint);
        const payload = {
            otpCode: otp,
            token: token
        };
        dispatch($25ffd485c801c634$export$840a1b6b804c3952());
        return fetch('/rest/signup/verify-email/otp', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json().then(({ error: error, token: token })=>{
                if (token) {
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'submitted',
                        subject: 'otp_submission',
                        attributes: {
                            result: 'success',
                            signupType: redirectType
                        }
                    });
                    const redirectToUrl = new URLSearchParams({
                        token: token,
                        ...params
                    });
                    const redirectTo = `/signup/welcome?${redirectToUrl.toString()}`;
                    dispatch($25ffd485c801c634$export$43047bab95c658dd(redirectTo));
                } else {
                    const result = error || 'internal_server_error';
                    dispatch($25ffd485c801c634$export$3871df646f7b1bd(result));
                    (0, $hqddj.captureTaggedException)(error, {
                        capabilities: [
                            'capability-group--signup',
                            'capability-name--verify-email'
                        ],
                        tags: {
                            otp: 'otp_submission'
                        }
                    });
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'submitted',
                        subject: 'otp_submission',
                        attributes: {
                            result: result,
                            signupType: redirectType
                        }
                    });
                }
            })).catch((err)=>{
            dispatch($25ffd485c801c634$export$3871df646f7b1bd('unexpected_error'));
            (0, $hqddj.captureTaggedException)(err, {
                capabilities: [
                    'capability-group--signup',
                    'capability-name--verify-email'
                ],
                tags: {
                    otp: 'otp_submission'
                }
            });
            analyticsClient.trackingEvent({
                page: pageId,
                action: 'submitted',
                subject: 'otp_submission',
                attributes: {
                    result: 'unexpected_error',
                    signupType: redirectType
                }
            });
        });
    };
const $25ffd485c801c634$export$7738159be2c9b2bf = (pageId, analyticsClient, navigate)=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken, cobranding: { productHint: productHint }, verifyEmailOtp: { redirectType: redirectType } } = getState();
        const { token: token } = $1JRGy.parse(window.location.search);
        const params = (0, $fcxz7.cobrandingURLParams)(window.location, productHint);
        const loginRedirectWithError = (error)=>{
            // @ts-expect-error URLSearchParams types aren't up to date
            const url = new URLSearchParams({
                ...params,
                errorCode: error,
                prompt: true
            });
            return url.toString();
        };
        const payload = {
            token: token
        };
        return fetch('/rest/signup/verify-email/otp/resend', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json().then(({ error: error, token: token })=>{
                if (response.status === 200) {
                    const urlWithNewToken = new URLSearchParams({
                        token: token,
                        ...params
                    });
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'link clicked',
                        subject: 'resend_otp',
                        attributes: {
                            result: 'success',
                            signupType: redirectType
                        }
                    });
                    dispatch((0, $7lC8o.addFlag)('success', $25ffd485c801c634$export$ca00cef23f46407b.resendEmailOtpSuccessTitle, $25ffd485c801c634$export$ca00cef23f46407b.resendEmailOtpSuccessBody));
                    return window.history.replaceState(window.history.state, '', `/signup/verify-email/otp?${urlWithNewToken.toString()}`);
                }
                if (response.status === 400) {
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'link clicked',
                        subject: 'resend_otp',
                        attributes: {
                            result: error,
                            signupType: redirectType
                        }
                    });
                    (0, $hqddj.captureTaggedException)(error, {
                        capabilities: [
                            'capability-group--signup',
                            'capability-name--verify-email'
                        ],
                        tags: {
                            otp: 'resend_otp'
                        }
                    });
                    if (error === 'expired_token') return navigate(`/login?${loginRedirectWithError('verify.email.expired')}`);
                    else return navigate(`/login?${loginRedirectWithError('verify.email.error')}`);
                }
                if (response.status === 429) {
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'link clicked',
                        subject: 'resend_otp',
                        attributes: {
                            result: error,
                            signupType: redirectType
                        }
                    });
                    return dispatch((0, $7lC8o.addFlag)('error', $25ffd485c801c634$export$ca00cef23f46407b.emailSentFailFlagTitle, $25ffd485c801c634$export$ca00cef23f46407b.emailSentFailFlagBody));
                }
            }).catch((err)=>{
                analyticsClient.trackingEvent({
                    page: pageId,
                    action: 'link clicked',
                    subject: 'resend_otp',
                    attributes: {
                        result: 'unexpected_error',
                        signupType: redirectType
                    }
                });
                (0, $hqddj.captureTaggedException)(err, {
                    capabilities: [
                        'capability-group--signup',
                        'capability-name--verify-email'
                    ],
                    tags: {
                        otp: 'resend_otp'
                    }
                });
                return navigate(`/login?${loginRedirectWithError('verify.email.error')}`);
            }));
    };
const $25ffd485c801c634$export$ca00cef23f46407b = (0, $2CYmK.defineMessages)({
    emailSentFailFlagTitle: {
        id: 'signup.verify-email.otp.resend.rate.limit.exceeded.title',
        description: 'Title of flag to show that the request for a new one time code failed due to a rate limit error',
        defaultMessage: 'Too many attempts.'
    },
    emailSentFailFlagBody: {
        id: 'signup.verify-email.otp.resend.rate.limit.exceeded.body',
        description: 'Body of flag to show that the request for a new one time code failed due to a rate limit error',
        defaultMessage: 'Try again later.'
    },
    resendEmailOtpSuccessTitle: {
        id: 'signup.verify-email.otp.resend.success.title',
        description: 'Title of flag to show that the request for a new one time code was successful',
        defaultMessage: 'Email sent with new code'
    },
    resendEmailOtpSuccessBody: {
        id: 'signup.verify-email.otp.resend.success.body',
        description: 'Body of flag to show that the request for a new one time code was successful',
        defaultMessage: 'Please check your inbox.'
    }
});

});

parcelRegister("5seSI", function(module, exports) {

$parcel$export(module.exports, "VERIFY_EMAIL_OTP_PAGE_ID", function () { return $e9cd977946694f09$export$7a9d926185563d77; });
const $e9cd977946694f09$export$7a9d926185563d77 = 'emailOtpScreen';

});


parcelRegister("hnbS9", function(module, exports) {

$parcel$export(module.exports, "useResendEmailOtp", function () { return $0fad7d0cd232487c$export$43b5c30416b6c2b8; });

var $dNMDr = parcelRequire("dNMDr");

var $4NPio = parcelRequire("4NPio");

var $5seSI = parcelRequire("5seSI");

var $aMBBA = parcelRequire("aMBBA");

var $H2GiC = parcelRequire("H2GiC");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $h4v4M = parcelRequire("h4v4M");
const $0fad7d0cd232487c$export$43b5c30416b6c2b8 = ({ onResend: onResend } = {})=>{
    (0, $kfOJC.useRegisterComponent)($0fad7d0cd232487c$export$43b5c30416b6c2b8.name);
    const { redirectType: redirectType } = (0, $aMBBA.useAppSelector)((state)=>state.verifyEmailOtp);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const trackResendEmailOtp = (0, $4NPio.useLinkClickedEvent)((0, $5seSI.VERIFY_EMAIL_OTP_PAGE_ID), 'resentEmailOtp', {
        signupType: redirectType,
        source: 'emailOtpScreen'
    });
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const onResendEmailOtp = (0, $dNMDr.useCallback)(()=>{
        onResend?.();
        trackResendEmailOtp();
        dispatch((0, $H2GiC.resendEmailOtp)((0, $5seSI.VERIFY_EMAIL_OTP_PAGE_ID), analyticsClient, navigate));
    }, [
        onResend,
        trackResendEmailOtp,
        dispatch,
        analyticsClient,
        navigate
    ]);
    return {
        onResendEmailOtp: onResendEmailOtp
    };
};

});

parcelRegister("azzBc", function(module, exports) {

$parcel$export(module.exports, "useSignupVerifyEmailOtpState", function () { return $9bd44b5235a1e168$export$2a002f6397be0f3; });

var $aMBBA = parcelRequire("aMBBA");
const $9bd44b5235a1e168$export$2a002f6397be0f3 = ()=>{
    const email = (0, $aMBBA.useAppSelector)((state)=>state.verifyEmailOtp.email);
    return {
        email: email
    };
};

});



parcelRegister("jBZ5L", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "welcomeLoader", function () { return $1cd928bba07398d7$export$eaf9dac678ad1491; });
$parcel$export(module.exports, "WelcomePage", function () { return $1cd928bba07398d7$export$630ad10f0e1a953d; });
$parcel$export(module.exports, "default", function () { return $1cd928bba07398d7$export$2e2bcd8739ae039; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $ko1o6 = parcelRequire("ko1o6");

var $cpaps = parcelRequire("cpaps");

var $chJxj = parcelRequire("chJxj");

var $4Cmcw = parcelRequire("4Cmcw");

var $Q6OOA = parcelRequire("Q6OOA");

var $1WM7o = parcelRequire("1WM7o");
parcelRequire("eWYtP");
var $MxQlJ = parcelRequire("MxQlJ");
var $7gUMu = parcelRequire("7gUMu");
var $5CI2J = parcelRequire("5CI2J");
var $3lba8 = parcelRequire("3lba8");

var $fzMIt = parcelRequire("fzMIt");
parcelRequire("e3grL");
var $ikiBc = parcelRequire("ikiBc");
parcelRequire("8wGBJ");
var $1KX2Q = parcelRequire("1KX2Q");
var $dYBx0 = parcelRequire("dYBx0");
var $i3v1l = parcelRequire("i3v1l");

var $jxlid = parcelRequire("jxlid");

var $4NPio = parcelRequire("4NPio");

var $4ljBU = parcelRequire("4ljBU");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");

var $fSUge = parcelRequire("fSUge");
async function $1cd928bba07398d7$export$eaf9dac678ad1491({ request: request }) {
    if (!await (0, $84ZjZ.checkFeatureGateOnceInitialized)((0, $cBB3b.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $4ljBU.fetchPageState)('/rest/signup/welcome/state', request, {
        capabilities: [
            'capability-group--signup',
            'capability-name--signup'
        ]
    });
}
const $1cd928bba07398d7$export$630ad10f0e1a953d = ()=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const { isEmbedded: isEmbedded } = (0, $fSUge.useMicrobranding)();
    const { displayName: displayName, email: email } = (0, $dYBx0.useWelcomeState)();
    const { onWelcomeSubmit: onWelcomeSubmit, isLoading: isLoading, formError: formError, fieldErrors: fieldErrors, error: error, redirectType: redirectType } = (0, $i3v1l.useWelcomeSubmission)();
    const onWelcomeClick = (0, $4NPio.useButtonClickedEvent)((0, $jxlid.WELCOME_PAGE_ID), 'welcomeSignup', {
        redirectType: redirectType
    });
    const { handleAppleLogin: handleAppleLogin, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleSlackLogin: handleSlackLogin } = (0, $1KX2Q.useWelcomePageActions)();
    if (error === (0, $chJxj.WelcomeError).RateLimitExceeded) return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $5CI2J.WelcomeRateLimitExceededError), {});
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $Q6OOA.default), {
        pageId: (0, $jxlid.WELCOME_PAGE_ID),
        header: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ikiBc.WelcomeHeader), {
            redirectType: redirectType
        }),
        footer: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $1WM7o.FooterLogoWrapper), {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3lba8.WelcomeRecaptchaNotice), {})
        }),
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cpaps.default), {
                title: formatMessage((0, $fzMIt.default).subheadingResumeSignup)
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $MxQlJ.WelcomeForm), {
                redirectType: redirectType,
                fieldErrors: fieldErrors,
                formError: formError,
                isLoading: isLoading,
                onSubmit: onWelcomeSubmit,
                onWelcomeClick: onWelcomeClick,
                email: email,
                displayName: displayName,
                privacyPolicy: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7gUMu.WelcomePrivacyPolicy), {})
            }),
            isEmbedded ? null : redirectType === (0, $chJxj.RedirectType).Migration && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $4Cmcw.default), {
                handleGoogleLogin: handleGoogleLogin,
                handleMicrosoftLogin: handleMicrosoftLogin,
                handleAppleLogin: handleAppleLogin,
                handleSlackLogin: handleSlackLogin
            })
        ]
    });
};
var $1cd928bba07398d7$export$2e2bcd8739ae039 = $1cd928bba07398d7$export$630ad10f0e1a953d;

});
parcelRegister("1WM7o", function(module, exports) {

$parcel$export(module.exports, "FooterLogoWrapper", function () { return $05d16c284eb7ffb9$export$648d5009980d0c69; });

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");
const $05d16c284eb7ffb9$export$648d5009980d0c69 = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)}px;
`;

});

parcelRegister("eWYtP", function(module, exports) {
$parcel$export(module.exports, "emailRegex", function () { return (parcelRequire("7DOAh")).emailRegex; });
$parcel$export(module.exports, "WelcomeForm", function () { return (parcelRequire("MxQlJ")).WelcomeForm; });
$parcel$export(module.exports, "WelcomeRateLimitExceededError", function () { return (parcelRequire("5CI2J")).WelcomeRateLimitExceededError; });
$parcel$export(module.exports, "WelcomePrivacyPolicy", function () { return (parcelRequire("7gUMu")).WelcomePrivacyPolicy; });
$parcel$export(module.exports, "WelcomeRecaptcha", function () { return (parcelRequire("6jOwx")).WelcomeRecaptcha; });
$parcel$export(module.exports, "WelcomeRecaptchaNotice", function () { return (parcelRequire("3lba8")).WelcomeRecaptchaNotice; });
parcelRequire("jsuEI");
parcelRequire("fqtbA");
parcelRequire("4cspC");
parcelRequire("kgdFR");

});
parcelRegister("jsuEI", function(module, exports) {
$parcel$export(module.exports, "WelcomeForm", function () { return (parcelRequire("MxQlJ")).WelcomeForm; });
$parcel$export(module.exports, "emailRegex", function () { return (parcelRequire("7DOAh")).emailRegex; });
parcelRequire("MxQlJ");
parcelRequire("7DOAh");

});
parcelRegister("MxQlJ", function(module, exports) {

$parcel$export(module.exports, "WelcomeForm", function () { return $3191049c608842f5$export$aed3bcf545666c02; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");
parcelRequire("JVN5R");
var $7Xy0r = parcelRequire("7Xy0r");

var $6i4Wm = parcelRequire("6i4Wm");

var $gre8I = parcelRequire("gre8I");

var $kvy9X = parcelRequire("kvy9X");

var $ckdYh = parcelRequire("ckdYh");

var $2byD0 = parcelRequire("2byD0");

var $3nNSq = parcelRequire("3nNSq");

var $eSfr6 = parcelRequire("eSfr6");
parcelRequire("bw9AH");
var $gZYe6 = parcelRequire("gZYe6");
var $2q39S = parcelRequire("2q39S");
parcelRequire("3UrA0");
var $1NjB7 = parcelRequire("1NjB7");
parcelRequire("kgdFR");
var $6jOwx = parcelRequire("6jOwx");

var $4yl6n = parcelRequire("4yl6n");
const $3191049c608842f5$export$aed3bcf545666c02 = ({ displayName: displayName, email: email, fieldErrors: fieldErrors, formError: formError, isLoading: isLoading, onSubmit: onSubmit, onWelcomeClick: onWelcomeClick, privacyPolicy: privacyPolicy, redirectType: redirectType })=>{
    const intl = (0, $ko1o6.default)();
    const [fullName, setFullName] = (0, $dNMDr.useState)(()=>displayName || '');
    const [password, setPassword] = (0, $dNMDr.useState)('');
    const displayNameInputRef = (0, $dNMDr.useRef)(null);
    const passwordInputRef = (0, $dNMDr.useRef)(null);
    const fieldErrorPassword = (0, $4yl6n.useTranslateFormErrorIfAvailable)(fieldErrors.password);
    const fieldErrorDisplayName = (0, $4yl6n.useTranslateFormErrorIfAvailable)(fieldErrors.displayName);
    (0, $dNMDr.useEffect)(()=>{
        const { displayName: displayName, emailUsedAsName: emailUsedAsName, passwordUsedAsName: passwordUsedAsName } = fieldErrors;
        const displayNameError = displayName || emailUsedAsName || passwordUsedAsName;
        const passwordError = fieldErrors.password;
        if (displayNameError) displayNameInputRef.current?.focus();
        else if (passwordError) passwordInputRef.current?.focus();
    }, [
        fieldErrors
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (isLoading) return;
        await onSubmit({
            displayName: fullName,
            password: password
        });
    };
    return /*#__PURE__*/ (0, $6CtE1.jsxs)("div", {
        children: [
            formError && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gre8I.default), {
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2q39S.WelcomeFormErrors), {
                    error: formError
                })
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3nNSq.StyledForm), {
                onSubmit: handleSubmit,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $6CtE1.jsxs)("form", {
                        ...formProps,
                        id: "form-sign-up",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gZYe6.EmailVerified), {
                                email: email,
                                redirectType: redirectType,
                                iconLabel: intl.formatMessage((0, $eSfr6.default).emailAddressVerifiedLabel)
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6i4Wm.default), {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $kvy9X.default), {
                                    testId: "displayName" // used in pollinators
                                    ,
                                    name: "displayName",
                                    isRequired: true,
                                    autoComplete: 'name',
                                    placeholder: intl.formatMessage((0, $eSfr6.default).displayNamePlaceholder),
                                    label: intl.formatMessage((0, $eSfr6.default).fullNameLabel),
                                    autoFocus: !!email && !displayName,
                                    isLabelHidden: false,
                                    isInvalid: !!fieldErrorDisplayName || !!fieldErrors.emailUsedAsName || !!fieldErrors.passwordUsedAsName,
                                    invalidMessage: fieldErrorDisplayName || fieldErrors.emailUsedAsName || fieldErrors.passwordUsedAsName,
                                    onChange: (e)=>setFullName(e.currentTarget.value),
                                    value: fullName,
                                    ref: displayNameInputRef
                                })
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $3nNSq.PasswordFieldGroup), {
                                children: [
                                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $ckdYh.default), {
                                        testId: "password" // used in pollinators
                                        ,
                                        name: "password",
                                        isRequired: true,
                                        autoComplete: "new-password",
                                        "aria-describedby": (0, $7Xy0r.passwordStrengthMessageId),
                                        placeholder: intl.formatMessage((0, $eSfr6.default).passwordPlaceholder),
                                        label: intl.formatMessage((0, $eSfr6.default).passwordLabelNew),
                                        autoFocus: !!email && !!displayName,
                                        isLabelHidden: false,
                                        isInvalid: !!fieldErrorPassword,
                                        invalidMessage: fieldErrorPassword,
                                        onChange: (e)=>setPassword(e.currentTarget.value),
                                        value: password,
                                        ref: passwordInputRef
                                    }),
                                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7Xy0r.PasswordStrengthMeter), {
                                        password: password,
                                        email: email,
                                        displayName: fullName,
                                        "data-testid": "password-strength-meter"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $1NjB7.WelcomeMarketingConsent), {}),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3nNSq.PrivacyPolicyContainer), {
                                children: privacyPolicy
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6jOwx.WelcomeRecaptcha), {}),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3nNSq.WelcomeButtonWrapper), {
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2byD0.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isFullWidth: true,
                                    id: "signup-submit",
                                    isLoading: isLoading,
                                    onClick: onWelcomeClick,
                                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                        id: "welcome.form.submit.continue",
                                        defaultMessage: "Continue"
                                    })
                                })
                            })
                        ]
                    })
            })
        ]
    });
};

});
parcelRegister("JVN5R", function(module, exports) {
$parcel$export(module.exports, "passwordStrengthMessageId", function () { return (parcelRequire("7Xy0r")).passwordStrengthMessageId; });
$parcel$export(module.exports, "PasswordStrengthMeter", function () { return (parcelRequire("7Xy0r")).PasswordStrengthMeter; });
$parcel$export(module.exports, "PasswordStrengthMeterExperimental", function () { return (parcelRequire("cwIUK")).PasswordStrengthMeterExperimental; });
parcelRequire("7Xy0r");
parcelRequire("cwIUK");

});
parcelRegister("cwIUK", function(module, exports) {

$parcel$export(module.exports, "PasswordStrengthMeterExperimental", function () { return $237ddafeb7c20fdf$export$f3f4fe3da2813049; });
/* PasswordStrengthMeterExperimental.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable react/no-unknown-property */ 
var $6CtE1 = parcelRequire("6CtE1");

var $grvIM = parcelRequire("grvIM");
var $fRuRx = parcelRequire("fRuRx");

var $dNMDr = parcelRequire("dNMDr");

var $fbSBq = parcelRequire("fbSBq");

var $l4KzN = parcelRequire("l4KzN");
var $68HQw = parcelRequire("68HQw");

var $fZRrO = parcelRequire("fZRrO");

var $ko1o6 = parcelRequire("ko1o6");

var $fRDIL = parcelRequire("fRDIL");

var $cBB3b = parcelRequire("cBB3b");

var $84ZjZ = parcelRequire("84ZjZ");
const $237ddafeb7c20fdf$var$barWidths = [
    '0%',
    '20%',
    '40%',
    '60%',
    '80%',
    '100%'
];
const $237ddafeb7c20fdf$var$Wrapper = (0, $fbSBq.default).div`
  margin-bottom: ${(0, $68HQw.gridSize)()}px;
  padding-inline: 10px;
`;
const $237ddafeb7c20fdf$var$Bar = (0, $fbSBq.default).div`
  background: ${(0, $l4KzN).N40};
  height: 4px;
  margin-top: 8px;
  margin-bottom: 4px;
  position: relative;
  border-radius: 2px;

  &::before {
    background: ${(props)=>props.score === null ? (0, $l4KzN).N40 : $237ddafeb7c20fdf$var$barColours[props.score]};
    bottom: 0;
    content: '';
    left: 0;
    border-radius: 2px;
    position: absolute;
    top: 0;
    transition: all 0.2s ease-out;
    width: ${(props)=>props.score === null ? 0 : $237ddafeb7c20fdf$var$barWidths[props.score]};
  }
`;
const $237ddafeb7c20fdf$var$barColours = [
    (0, $l4KzN).N40,
    "var(--ds-text-accent-red, #AE2E24)",
    // Weak
    '#FFC716',
    // Fair
    '#94C748',
    // Good
    '#6A9A23',
    // Strong
    '#678933' // Very strong
];
const $237ddafeb7c20fdf$var$hintStyles = null;
const $237ddafeb7c20fdf$var$hintStylesV2 = null;
const $237ddafeb7c20fdf$var$errorStyle = null;
const $237ddafeb7c20fdf$var$Hint = ({ score: score, errorText: errorText, strengthText: strengthText })=>{
    const isCfind4831 = (0, $84ZjZ.checkFeatureGate)((0, $cBB3b.AidFrontendFeatureGate).CFIND_4831_PRODUCT_OVERLAY_MODAL_VISUAL_UPDATES);
    const styleAsError = !!errorText || score === 1;
    const textToDisplay = errorText || strengthText;
    return textToDisplay ? /*#__PURE__*/ (0, $6CtE1.jsx)("p", {
        className: (0, $grvIM.default)([
            !isCfind4831 && "_syaz1k2n _1wyb1crf _4t3i7vkz _19pk1y44 _kqswh2mm _ect418aq",
            styleAsError && "_syaz166f",
            isCfind4831 && "_1wyb1crf _4t3i7vkz _19pk1y44 _kqswh2mm"
        ]),
        style: {
            "--_w5zcw3": (0, $fRuRx.default)((0, $l4KzN).N90)
        },
        children: textToDisplay
    }) : null;
};
const $237ddafeb7c20fdf$var$Container = (props)=>{
    return /*#__PURE__*/ (0, $6CtE1.jsxs)($237ddafeb7c20fdf$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsx)($237ddafeb7c20fdf$var$Bar, {
                score: props.score
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)("div", {
                role: "status",
                children: /*#__PURE__*/ (0, $6CtE1.jsx)($237ddafeb7c20fdf$var$Hint, {
                    score: props.score || 0,
                    errorText: props.errorText,
                    strengthText: props.strengthText
                })
            })
        ]
    });
};
const $237ddafeb7c20fdf$export$f3f4fe3da2813049 = ({ displayName: displayName, email: email, i18nLevels: i18nLevels, i18nNoValue: i18nNoValue, i18nNoZxcvbn: i18nNoZxcvbn, password: password, errorText: errorText, passwordSelected: passwordSelected })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const strengthLevelMessages = (0, $dNMDr.useMemo)(()=>i18nLevels || [
            (0, $fZRrO.default).passwordStrengthMinimumRequirement,
            (0, $fZRrO.default).weakPasswordAdvice,
            (0, $fZRrO.default).fairPassword,
            (0, $fZRrO.default).goodPassword,
            (0, $fZRrO.default).strongPassword,
            (0, $fZRrO.default).veryStrongPassword
        ].map((message)=>formatMessage(message)), [
        formatMessage,
        i18nLevels
    ]);
    const noValueMessage = i18nNoValue || '';
    const noZxcvbnMessage = i18nNoZxcvbn || formatMessage((0, $fZRrO.default).passwordStrengthUnavailable);
    const { score: score } = (0, $fRDIL.usePasswordScore)({
        displayName: displayName,
        email: email,
        password: password
    });
    const getStrengthText = ()=>{
        if (!password && !passwordSelected) return noValueMessage;
        return typeof score === 'number' ? strengthLevelMessages[score] : noZxcvbnMessage;
    };
    return /*#__PURE__*/ (0, $6CtE1.jsx)($237ddafeb7c20fdf$var$Container, {
        errorText: errorText,
        strengthText: getStrengthText(),
        score: score
    });
};

});
parcelRegister("fRuRx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8c3beee0bbd7430$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $b8c3beee0bbd7430$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});



parcelRegister("3nNSq", function(module, exports) {

$parcel$export(module.exports, "PrivacyPolicyContainer", function () { return $1899ce512497a922$export$6b077d087ec15a10; });
$parcel$export(module.exports, "PasswordFieldGroup", function () { return $1899ce512497a922$export$fc9115768a73fd6d; });
$parcel$export(module.exports, "WelcomeButtonWrapper", function () { return $1899ce512497a922$export$610e57aac9703b0f; });
$parcel$export(module.exports, "StyledForm", function () { return $1899ce512497a922$export$71655785c758526a; });

var $fbSBq = parcelRequire("fbSBq");

var $68HQw = parcelRequire("68HQw");

var $iMw87 = parcelRequire("iMw87");

var $6i4Wm = parcelRequire("6i4Wm");
const $1899ce512497a922$export$6b077d087ec15a10 = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
  text-align: left;
  margin-left: 6px;
`;
const $1899ce512497a922$export$fc9115768a73fd6d = (0, $fbSBq.default)((0, $6i4Wm.default))`
  padding-top: ${({ isHidden: isHidden })=>isHidden ? `${(0, $68HQw.gridSize)() * 2}px` : 0};
`;
const $1899ce512497a922$export$610e57aac9703b0f = (0, $fbSBq.default).div`
  margin-top: ${(0, $68HQw.gridSize)()}px;
`;
const $1899ce512497a922$export$585a3b23e887288b = (0, $fbSBq.default).div`
  text-align: center;
  padding-top: 4px;
`;
const $1899ce512497a922$export$71655785c758526a = (0, $fbSBq.default)((0, $iMw87.default))`
  margin: 0;
`;

});

parcelRegister("eSfr6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2fde730ae84ee8c$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $b2fde730ae84ee8c$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    displayNamePlaceholder: {
        id: 'signup.form.displayName.placeholder',
        defaultMessage: 'Enter full name'
    },
    fullNameLabel: {
        id: 'signup.form.fullName.label',
        defaultMessage: 'Full name'
    },
    emailAddressVerifiedLabel: {
        id: 'welcome.form.email.address.verified.label',
        defaultMessage: 'Verified'
    },
    passwordPlaceholder: {
        id: 'signup.form.password.placeholder',
        defaultMessage: 'Create password'
    },
    passwordLabelNew: {
        id: 'signup.form.password.label.new',
        defaultMessage: 'Password'
    }
});

});

parcelRegister("bw9AH", function(module, exports) {
$parcel$export(module.exports, "EmailVerified", function () { return (parcelRequire("gZYe6")).EmailVerified; });
$parcel$export(module.exports, "WelcomeFormErrors", function () { return (parcelRequire("2q39S")).WelcomeFormErrors; });
$parcel$export(module.exports, "WelcomeFormErrorsExperimental", function () { return (parcelRequire("c1ejr")).WelcomeFormErrorsExperimental; });
parcelRequire("hYHlB");
parcelRequire("iPiBo");

});
parcelRegister("hYHlB", function(module, exports) {
$parcel$export(module.exports, "EmailVerified", function () { return (parcelRequire("gZYe6")).EmailVerified; });
parcelRequire("gZYe6");

});
parcelRegister("gZYe6", function(module, exports) {

$parcel$export(module.exports, "EmailVerified", function () { return $0b1f4540bd6a3c6a$export$320c6c46c464dd37; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $dFAHD = parcelRequire("dFAHD");

var $dWJmc = parcelRequire("dWJmc");

var $chJxj = parcelRequire("chJxj");

var $gOi41 = parcelRequire("gOi41");

var $f1kUZ = parcelRequire("f1kUZ");

var $3YSXY = parcelRequire("3YSXY");
const $0b1f4540bd6a3c6a$export$320c6c46c464dd37 = ({ email: email, iconLabel: iconLabel, redirectType: redirectType })=>{
    return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $gOi41.VerifiedEmailWrapper), {
        children: [
            /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $dFAHD.Label), {
                htmlFor: "email-verified",
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        ...(0, $f1kUZ.default).emailAddressLabel
                    }),
                    redirectType !== (0, $chJxj.RedirectType).Signup && redirectType !== (0, $chJxj.RedirectType).ResumeSignup && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gOi41.VerifiedIconWrapper), {
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dWJmc))), {
                            label: iconLabel,
                            size: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $gOi41.BoldEmailWrapper), {
                id: "email-verified",
                children: email
            })
        ]
    });
};

});
parcelRegister("gOi41", function(module, exports) {

$parcel$export(module.exports, "VerifiedEmailWrapper", function () { return $8cb81bc20eab9664$export$6b03a82aa573dee0; });
$parcel$export(module.exports, "BoldEmailWrapper", function () { return $8cb81bc20eab9664$export$33307c8166f2d281; });
$parcel$export(module.exports, "VerifiedIconWrapper", function () { return $8cb81bc20eab9664$export$caa84cc45eb72ca8; });

var $fbSBq = parcelRequire("fbSBq");

var $l4KzN = parcelRequire("l4KzN");
const $8cb81bc20eab9664$export$6b03a82aa573dee0 = (0, $fbSBq.default).div`
  margin-top: 10px;
  color: ${(0, $l4KzN).N800};
`;
const $8cb81bc20eab9664$export$33307c8166f2d281 = (0, $fbSBq.default).p`
  font-weight: bold;
  overflow-wrap: break-word;
  margin: 0;
`;
const $8cb81bc20eab9664$export$caa84cc45eb72ca8 = (0, $fbSBq.default).span`
  padding: 0 4px;
  color: ${(0, $l4KzN).G400};
`;

});

parcelRegister("f1kUZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba1647a99541ddaf$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $ba1647a99541ddaf$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    emailAddressLabel: {
        id: 'welcome.form.email.verified.label',
        defaultMessage: 'Email address'
    }
});

});



parcelRegister("iPiBo", function(module, exports) {
$parcel$export(module.exports, "WelcomeFormErrors", function () { return (parcelRequire("2q39S")).WelcomeFormErrors; });
$parcel$export(module.exports, "WelcomeFormErrorsExperimental", function () { return (parcelRequire("c1ejr")).WelcomeFormErrorsExperimental; });
parcelRequire("2q39S");
parcelRequire("c1ejr");

});
parcelRegister("2q39S", function(module, exports) {

$parcel$export(module.exports, "WelcomeFormErrors", function () { return $14fb54042c80557e$export$647bfbe5c6b51f7d; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $5pCRv = parcelRequire("5pCRv");

var $b0mt7 = parcelRequire("b0mt7");
const $14fb54042c80557e$export$647bfbe5c6b51f7d = ({ error: error })=>{
    switch(error){
        case 'unknown':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.unknown",
                defaultMessage: "Something went wrong while attempting to sign up. Please try again."
            });
        case 'captcha':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.captcha",
                defaultMessage: "We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support."
            });
        case 'captchaScoreTooLow':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.captcha.score_too_low",
                defaultMessage: "We'd like to make sure it's really you creating your account. Please confirm you're not a robot.",
                description: "Message asking user to tick the reCAPTCHA checkbox and resubmit the form"
            });
        case 'request_error':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.request_error",
                defaultMessage: "Unable to connect. Check your internet connection or the network settings for your browser and try again."
            });
        case 'passwordLeaked':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $b0mt7.default).passwordLeakedXML,
                tagName: "p",
                values: {
                    'password-leaked-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("a", {
                            href: (0, $5pCRv.PASSWORD_LEAKED_LINK),
                            children: chunks
                        })
                }
            });
        case 'passwordCommon':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordCommon",
                defaultMessage: "This password is too widely used. Choose a password that's harder to guess."
            });
        case 'invalidPassword':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.invalidPassword",
                defaultMessage: "Invalid password"
            });
        case 'passwordCaseError':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordCaseError",
                defaultMessage: "Your password must contain at least one uppercase and one lowercase letter."
            });
        case 'passwordDigitOrSpecialError':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordDigitOrSpecialError",
                defaultMessage: "Your password must contain at least one digit or special character."
            });
        case 'passwordLengthError':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordLengthError",
                defaultMessage: "Your password must be between 8 and 72 characters long."
            });
        case 'passwordUsedBefore':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordUsedBefore",
                defaultMessage: "You've used that password before. Please choose a different one."
            });
        case 'usernameMustBeEmail':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.usernameMustBeEmail",
                defaultMessage: "Your account username must be a valid email address."
            });
        case 'passwordStrengthErrorWeak':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordStrengthErrorWeak",
                defaultMessage: "Your password must have a minimum strength of weak."
            });
        case 'passwordStrengthErrorFair':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordStrengthErrorFair",
                defaultMessage: "Your password must have a minimum strength of fair."
            });
        case 'passwordStrengthErrorGood':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordStrengthErrorGood",
                defaultMessage: "Your password must have a minimum strength of good."
            });
        case 'passwordStrengthErrorStrong':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordStrengthErrorStrong",
                defaultMessage: "Your password must have a minimum strength of strong."
            });
        case 'passwordStrengthErrorVeryStrong':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordStrengthErrorVeryStrong",
                defaultMessage: "Your password must have a minimum strength of very strong."
            });
        default:
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.form.random.error",
                defaultMessage: "An error occurred while attempting to sign up: {error}. Please try again or reach out to Atlassian Support.",
                values: {
                    error: error
                }
            });
    }
};

});
parcelRegister("b0mt7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $522dcffa912a0433$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $522dcffa912a0433$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    passwordLeakedXML: {
        id: 'signup.form.password.leaked.xml',
        defaultMessage: 'This password has appeared in an external data breach. To continue, enter another password. <password-leaked-link>Learn more</password-leaked-link>'
    }
});

});


parcelRegister("c1ejr", function(module, exports) {

$parcel$export(module.exports, "WelcomeFormErrorsExperimental", function () { return $8350ed26de6b77b9$export$f51e84a78cbc2d9b; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $2CYmK = parcelRequire("2CYmK");
var $3YSXY = parcelRequire("3YSXY");
var $ko1o6 = parcelRequire("ko1o6");

var $5pCRv = parcelRequire("5pCRv");

var $b0mt7 = parcelRequire("b0mt7");
const $8350ed26de6b77b9$var$invalidPasswordTradukiDescription = 'Reason why a password is invalid';
const $8350ed26de6b77b9$var$errorWithAdvice = (0, $2CYmK.defineMessage)({
    id: 'welcome.error.adviceWrapper',
    defaultMessage: '{errorDescriptionSentence} Avoid common phrases and predictable sequences, and use a mix of characters.',
    description: 'Error describing why a password is invalid, followed by advice on how to fix it'
});
const $8350ed26de6b77b9$export$f51e84a78cbc2d9b = ({ error: error, hintError: hintError })=>{
    const { formatMessage: formatMessage } = (0, $ko1o6.default)();
    const withAdvice = (errorDescriptionSentence)=>/*#__PURE__*/ (0, $6CtE1.jsx)((0, $6CtE1.Fragment), {
            children: formatMessage($8350ed26de6b77b9$var$errorWithAdvice, {
                errorDescriptionSentence: errorDescriptionSentence
            })
        });
    const welcomeError = hintError ?? error;
    switch(welcomeError){
        case 'passwordStrengthCantMatchDisplayName':
        case 'passwordMatchesDisplayNameError':
            return withAdvice(formatMessage({
                id: 'welcome.error.passwordMatchesDisplayName',
                defaultMessage: "Your password can't match your <strong>display name</strong>.",
                description: $8350ed26de6b77b9$var$invalidPasswordTradukiDescription
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthCantMatchAtlassianKeyword':
        case 'passwordMatchesAtlassianKeywordError':
            return withAdvice(formatMessage({
                id: 'welcome.error.passwordMatchesAtlassianKeyword',
                defaultMessage: "Your password can't match an <strong>Atlassian keyword</strong>.",
                description: $8350ed26de6b77b9$var$invalidPasswordTradukiDescription
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthCantMatchEmail':
        case 'passwordMatchesEmailError':
            return withAdvice(formatMessage({
                id: 'welcome.error.passwordMatchesEmail',
                defaultMessage: "Your password can't match your <strong>email address</strong>.",
                description: $8350ed26de6b77b9$var$invalidPasswordTradukiDescription
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'unknown':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.unknown",
                defaultMessage: "Something went wrong while attempting to sign up. Please try again."
            });
        case 'captcha':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.captcha",
                defaultMessage: "We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support."
            });
        case 'captchaScoreTooLow':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.captcha.score_too_low",
                defaultMessage: "We'd like to make sure it's really you creating your account. Please confirm you're not a robot.",
                description: "Message asking user to tick the reCAPTCHA checkbox and resubmit the form"
            });
        case 'request_error':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.request_error",
                defaultMessage: "Unable to connect. Check your internet connection or the network settings for your browser and try again."
            });
        case 'passwordLeaked':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                ...(0, $b0mt7.default).passwordLeakedXML,
                tagName: "p",
                values: {
                    'password-leaked-link': (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("a", {
                            href: (0, $5pCRv.PASSWORD_LEAKED_LINK),
                            children: chunks
                        })
                }
            });
        case 'passwordCommon':
            return withAdvice(formatMessage({
                id: 'welcome.error.passwordIsCommon',
                defaultMessage: 'This is a <strong>common password</strong>.',
                description: $8350ed26de6b77b9$var$invalidPasswordTradukiDescription
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'invalidPassword':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.invalidPassword",
                defaultMessage: "Invalid password"
            });
        case 'passwordCaseError':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordCaseError",
                defaultMessage: "Your password must contain at least one uppercase and one lowercase letter."
            });
        case 'passwordDigitOrSpecialError':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordDigitOrSpecialError",
                defaultMessage: "Your password must contain at least one digit or special character."
            });
        case 'passwordLengthError':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordLengthError",
                defaultMessage: "Your password must be between 8 and 72 characters long."
            });
        case 'passwordUsedBefore':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.passwordUsedBefore",
                defaultMessage: "You've used that password before. Please choose a different one."
            });
        case 'usernameMustBeEmail':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.error.usernameMustBeEmail",
                defaultMessage: "Your account username must be a valid email address."
            });
        case 'passwordStrengthErrorWeak':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorWeak',
                defaultMessage: 'Your password must have a minimum strength of <strong>weak</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthErrorFair':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorFair',
                defaultMessage: 'Your password must have a minimum strength of <strong>fair</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthErrorGood':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorGood',
                defaultMessage: 'Your password must have a minimum strength of <strong>good</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthErrorStrong':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorStrong',
                defaultMessage: 'Your password must have a minimum strength of <strong>strong</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthErrorVeryStrong':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorVeryStrong',
                defaultMessage: 'Your password must have a minimum strength of <strong>very strong</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6CtE1.jsx)("strong", {
                        children: chunks
                    })
            }));
        default:
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                id: "welcome.form.random.error",
                defaultMessage: "An error occurred while attempting to sign up: {error}. Please try again or reach out to Atlassian Support.",
                values: {
                    error: error
                }
            });
    }
};

});



parcelRegister("3UrA0", function(module, exports) {
$parcel$export(module.exports, "WelcomeMarketingConsent", function () { return (parcelRequire("1NjB7")).WelcomeMarketingConsent; });
parcelRequire("1NjB7");

});
parcelRegister("1NjB7", function(module, exports) {

$parcel$export(module.exports, "WelcomeMarketingConsent", function () { return $268c5f364a7d5460$export$2ba9993ec03b7ee5; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");
parcelRequire("jyAWB");
var $aI10X = parcelRequire("aI10X");

var $7C1Rq = parcelRequire("7C1Rq");

var $aMBBA = parcelRequire("aMBBA");

var $c7MmN = parcelRequire("c7MmN");
const $268c5f364a7d5460$var$marketingConsentSelector = (state)=>state.marketingConsent.config;
const $268c5f364a7d5460$var$welcomeEmailSelector = (state)=>state.welcome.email;
const $268c5f364a7d5460$export$2ba9993ec03b7ee5 = ()=>{
    (0, $kfOJC.useRegisterComponent)($268c5f364a7d5460$export$2ba9993ec03b7ee5.name);
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const { setMarketingConsent: setMarketingConsent } = (0, $aI10X.useWelcomePageContext)();
    const marketingConsentConfig = (0, $aMBBA.useAppSelector)($268c5f364a7d5460$var$marketingConsentSelector);
    const email = (0, $aMBBA.useAppSelector)($268c5f364a7d5460$var$welcomeEmailSelector);
    (0, $dNMDr.useEffect)(()=>{
        if (email !== '') dispatch((0, $c7MmN.fetchConsentConfig)(email));
    }, [
        dispatch,
        email
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $7C1Rq.default), {
        config: marketingConsentConfig,
        onConsentChange: setMarketingConsent
    });
};

});
parcelRegister("jyAWB", function(module, exports) {
$parcel$export(module.exports, "useWelcomePageContext", function () { return (parcelRequire("aI10X")).useWelcomePageContext; });
$parcel$export(module.exports, "WelcomePageProvider", function () { return (parcelRequire("aI10X")).WelcomePageProvider; });
parcelRequire("aI10X");

});
parcelRegister("aI10X", function(module, exports) {

$parcel$export(module.exports, "useWelcomePageContext", function () { return $65d4e517d55c3dff$export$417cf5d67969d32f; });
$parcel$export(module.exports, "WelcomePageProvider", function () { return $65d4e517d55c3dff$export$96494047c552bc09; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");
const $65d4e517d55c3dff$export$46030b7a3a8bf13f = /*#__PURE__*/ (0, $dNMDr.createContext)(null);
const $65d4e517d55c3dff$export$417cf5d67969d32f = ()=>{
    const context = (0, $dNMDr.useContext)($65d4e517d55c3dff$export$46030b7a3a8bf13f);
    if (!context) throw new Error('useWelcomePageContext must be used within a WelcomePageContextProvider');
    return context;
};
const $65d4e517d55c3dff$export$96494047c552bc09 = ({ children: children })=>{
    const [privacyPolicyText, setPrivacyPolicyText] = (0, $dNMDr.useState)();
    const [marketingConsent, setMarketingConsent] = (0, $dNMDr.useState)({
        state: 'not_shown'
    });
    const state = (0, $dNMDr.useMemo)(()=>({
            privacyPolicyText: privacyPolicyText,
            setPrivacyPolicyText: setPrivacyPolicyText,
            marketingConsent: marketingConsent,
            setMarketingConsent: setMarketingConsent
        }), [
        marketingConsent,
        privacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)($65d4e517d55c3dff$export$46030b7a3a8bf13f.Provider, {
        value: state,
        children: children
    });
};

});




parcelRegister("kgdFR", function(module, exports) {
$parcel$export(module.exports, "WelcomeRecaptcha", function () { return (parcelRequire("6jOwx")).WelcomeRecaptcha; });
$parcel$export(module.exports, "WelcomeRecaptchaNotice", function () { return (parcelRequire("3lba8")).WelcomeRecaptchaNotice; });
parcelRequire("6jOwx");
parcelRequire("3lba8");

});
parcelRegister("6jOwx", function(module, exports) {

$parcel$export(module.exports, "WelcomeRecaptcha", function () { return $67b3a969e5ce9bfa$export$288894e7e6fbc9f; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $hzllM = parcelRequire("hzllM");

var $aMBBA = parcelRequire("aMBBA");

var $74Cy0 = parcelRequire("74Cy0");
const $67b3a969e5ce9bfa$export$288894e7e6fbc9f = ()=>{
    (0, $kfOJC.useRegisterComponent)($67b3a969e5ce9bfa$export$288894e7e6fbc9f.name);
    const { enabled: recaptchaEnabled, component: recaptchaComponent } = (0, $hzllM.useRecaptchaContext)();
    const recaptchaEnable = (0, $aMBBA.useAppSelector)((state)=>state.appConfig.recaptchaEnable);
    const shouldSkipCaptcha = (0, $aMBBA.useAppSelector)((state)=>state.welcome.shouldSkipCaptcha);
    const shouldShow = recaptchaEnable && !shouldSkipCaptcha && recaptchaEnabled && recaptchaComponent;
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $74Cy0.WelcomeRecaptchaContainer), {
        children: recaptchaComponent
    });
};

});
parcelRegister("74Cy0", function(module, exports) {

$parcel$export(module.exports, "WelcomeRecaptchaContainer", function () { return $cda3838540fee17a$export$bb84fe97ed03d9ef; });

var $fbSBq = parcelRequire("fbSBq");

var $fhwYP = parcelRequire("fhwYP");
const $cda3838540fee17a$export$bb84fe97ed03d9ef = (0, $fbSBq.default)((0, $fhwYP.default))`
  .grecaptcha-badge {
    display: none;
  }
`;

});


parcelRegister("3lba8", function(module, exports) {

$parcel$export(module.exports, "WelcomeRecaptchaNotice", function () { return $d5646cacfae0c7b2$export$de0d13e777a02b5b; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $fhwYP = parcelRequire("fhwYP");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");
const $d5646cacfae0c7b2$export$de0d13e777a02b5b = ()=>{
    (0, $kfOJC.useRegisterComponent)($d5646cacfae0c7b2$export$de0d13e777a02b5b.name);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $fhwYP.RecaptchaNotice), {});
};

});



parcelRegister("7DOAh", function(module, exports) {

$parcel$export(module.exports, "emailRegex", function () { return $b8f627389e86cc73$export$976c37132e9c6a10; });
// Identity accepted email validator
const $b8f627389e86cc73$var$regexLiteral = /([a-z0-9._%\-+!#$&/=?^|~ ]+)@([a-z0-9 -]+\.)+ *[a-z]+/;
const $b8f627389e86cc73$export$976c37132e9c6a10 = new RegExp($b8f627389e86cc73$var$regexLiteral);

});


parcelRegister("fqtbA", function(module, exports) {
$parcel$export(module.exports, "WelcomeRateLimitExceededError", function () { return (parcelRequire("5CI2J")).WelcomeRateLimitExceededError; });
parcelRequire("5CI2J");

});
parcelRegister("5CI2J", function(module, exports) {

$parcel$export(module.exports, "WelcomeRateLimitExceededError", function () { return $737d39bb450bed5f$export$30b9e8215a118df0; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $fbSBq = parcelRequire("fbSBq");

var $8Cc4v = parcelRequire("8Cc4v");

var $Q6OOA = parcelRequire("Q6OOA");

var $4NPio = parcelRequire("4NPio");
const $737d39bb450bed5f$var$MessageContainer = (0, $fbSBq.default).div`
  margin-bottom: 24px;
`;
const $737d39bb450bed5f$export$703ba2e7ea526c1b = 'welcomeRateLimitExceededErrorPage';
const $737d39bb450bed5f$export$30b9e8215a118df0 = ()=>{
    (0, $4NPio.usePageViewedEvent)($737d39bb450bed5f$export$703ba2e7ea526c1b);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $Q6OOA.default), {
        pageId: $737d39bb450bed5f$export$703ba2e7ea526c1b,
        header: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $6CtE1.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6CtE1.jsx)($737d39bb450bed5f$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                        id: "welcome.rate-limit-exceeded.error.title",
                        defaultMessage: "We couldn't verify your email",
                        description: "Telling the user that there is an error and they're not verified. The error is caused by too many attempts submitting the link.",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $6CtE1.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8Cc4v))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
            id: "welcome.rate-limit-exceeded.error.main-action",
            defaultMessage: "There have been too many attempts to verify your account in the past hour. Please try again after an hour.",
            description: "Telling the user that there has been too many attempts on the welcome link and to try again later by refreshing or clicking the link again."
        })
    });
};
var $737d39bb450bed5f$export$2e2bcd8739ae039 = $737d39bb450bed5f$export$30b9e8215a118df0;

});


parcelRegister("4cspC", function(module, exports) {
$parcel$export(module.exports, "WelcomePrivacyPolicy", function () { return (parcelRequire("7gUMu")).WelcomePrivacyPolicy; });
parcelRequire("7gUMu");

});
parcelRegister("7gUMu", function(module, exports) {

$parcel$export(module.exports, "WelcomePrivacyPolicy", function () { return $9af351d5a20f677e$export$3c67e645c8f59d72; });

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $d3AOE = parcelRequire("d3AOE");

var $cuZAx = parcelRequire("cuZAx");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $jxlid = parcelRequire("jxlid");
parcelRequire("jyAWB");
var $aI10X = parcelRequire("aI10X");

var $fSUge = parcelRequire("fSUge");
const $9af351d5a20f677e$export$3c67e645c8f59d72 = ()=>{
    (0, $kfOJC.useRegisterComponent)($9af351d5a20f677e$export$3c67e645c8f59d72.name);
    const privacyPolicyMessageRef = (0, $dNMDr.useRef)(null);
    const { oidcContext: oidcContext, isEmbedded: isEmbedded } = (0, $fSUge.useMicrobranding)();
    const { setPrivacyPolicyText: setPrivacyPolicyText } = (0, $aI10X.useWelcomePageContext)();
    const privacyPolicyText = privacyPolicyMessageRef.current?.innerHTML || '';
    (0, $dNMDr.useEffect)(()=>{
        if (privacyPolicyText) setPrivacyPolicyText(privacyPolicyText);
    }, [
        privacyPolicyText,
        setPrivacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $d3AOE.default), {
        isEmbedded: isEmbedded,
        isMobileOidc: (0, $cuZAx.isMobileOidc)(oidcContext),
        pageId: (0, $jxlid.WELCOME_PAGE_ID),
        privacyPolicyText: (0, $d3AOE.PrivacyPolicyText).passwordSignup,
        ref: privacyPolicyMessageRef
    });
};

});
parcelRegister("jxlid", function(module, exports) {

$parcel$export(module.exports, "WELCOME_PAGE_ID", function () { return $c2add15b7d3469ca$export$ce43a0b457ba42a3; });
const $c2add15b7d3469ca$export$ce43a0b457ba42a3 = 'welcomeScreen';

});




parcelRegister("fzMIt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $810f8a9e6e030d92$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $810f8a9e6e030d92$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    headTitle: {
        id: 'welcome.head.title',
        defaultMessage: 'Sign up'
    },
    subheadingResumeSignup: {
        id: 'welcome.signup.subheading.title',
        defaultMessage: 'Finish setting up your account',
        description: 'Shown before the login form. e.g. "Sign up first then we will show you the content you requested"'
    },
    subheadingMigration: {
        id: 'welcome.migration.subheading.title',
        defaultMessage: 'Complete your migration'
    },
    emailVerifiedTitle: {
        id: 'resume.signup.head.title',
        defaultMessage: 'Email address verified'
    },
    contextualHeadTitle: {
        id: 'signup.contextual.head.title',
        defaultMessage: 'Sign up to continue to',
        description: `Precedes a page title or issue number. For example, "Sign up to continue to Sarah's Blogpost"`
    },
    socialAuthOr: {
        id: 'social.auth.or',
        defaultMessage: 'or'
    },
    socialAuthOrContinueWith: {
        id: 'social.auth.or-continue-with',
        defaultMessage: 'Or continue with:'
    },
    headerTitle: {
        id: 'signup.header.title',
        defaultMessage: 'Sign up to continue',
        description: 'Shown before the login form. e.g. "Sign up first then we will show you the content you requested"'
    },
    startCollaboratingHeaderTitle: {
        id: 'welcome.header.start.collaborating.title',
        defaultMessage: 'Sign up to start collaborating',
        description: 'Shown before the signup form. e.g. "Sign up first then we will show you the content you requested"'
    },
    headerWACExperiment: {
        id: 'welcome.signup.wac.header.title',
        defaultMessage: 'Add your account details',
        description: 'Heading for the signup form'
    },
    subheadingWACExperiment: {
        id: 'welcome.signup.wac.subheading.title',
        defaultMessage: 'This account can be used for {productName} and any other Atlassian product you add in the future.',
        description: 'Subheading for the signup form. productName is the name of the product the user is signing up for, e.g. "This account can be used for Jira and ..."'
    }
});

});

parcelRegister("e3grL", function(module, exports) {
$parcel$export(module.exports, "WelcomeHeader", function () { return (parcelRequire("ikiBc")).WelcomeHeader; });
parcelRequire("ikiBc");

});
parcelRegister("ikiBc", function(module, exports) {

$parcel$export(module.exports, "WelcomeHeader", function () { return $4cb0bad6cbc063de$export$8e8630c5f5e8e2b0; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $3YSXY = parcelRequire("3YSXY");

var $dWJmc = parcelRequire("dWJmc");

var $dWOVN = parcelRequire("dWOVN");

var $3uLi5 = parcelRequire("3uLi5");

var $fzMIt = parcelRequire("fzMIt");

var $1Jp74 = parcelRequire("1Jp74");
const $4cb0bad6cbc063de$export$8e8630c5f5e8e2b0 = ({ redirectType: redirectType })=>{
    switch(redirectType){
        case 'signup':
        case 'resume_signup':
            return /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $1Jp74.HeaderWrapper), {
                children: [
                    /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $1Jp74.TitleWrapper), {
                        children: [
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
                                as: 'h1',
                                size: 'small',
                                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                                    ...(0, $fzMIt.default).emailVerifiedTitle
                                })
                            }),
                            /*#__PURE__*/ (0, $6CtE1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dWJmc))), {
                                size: "small",
                                label: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
                        as: 'h2',
                        size: 'xxsmall',
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                            ...(0, $fzMIt.default).subheadingResumeSignup
                        })
                    })
                ]
            });
        case 'invite':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
                as: 'h1',
                size: 'small',
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...(0, $3uLi5.default).inviteTitle
                })
            });
        case 'migration':
        case 'resume_migration':
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
                as: 'h1',
                size: 'small',
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...(0, $fzMIt.default).subheadingMigration
                })
            });
        default:
            return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $dWOVN.default), {
                as: 'h1',
                size: 'small',
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3YSXY.default), {
                    ...(0, $fzMIt.default).subheadingResumeSignup
                })
            });
    }
};

});
parcelRegister("3uLi5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e5e80db7d37f6d9$export$2e2bcd8739ae039; });

var $2CYmK = parcelRequire("2CYmK");
var $0e5e80db7d37f6d9$export$2e2bcd8739ae039 = (0, $2CYmK.defineMessages)({
    headTitle: {
        id: 'signup.head.title',
        defaultMessage: 'Sign up'
    },
    inviteTitle: {
        id: 'signup.invite.title',
        defaultMessage: 'Sign up to join your team'
    },
    titleNormal: {
        id: 'invitesignup.title.normal',
        defaultMessage: 'We need a few details, to create an account for {email}'
    }
});

});

parcelRegister("1Jp74", function(module, exports) {

$parcel$export(module.exports, "HeaderWrapper", function () { return $86bc11904dee6ad7$export$960a49cc3d27a090; });
$parcel$export(module.exports, "TitleWrapper", function () { return $86bc11904dee6ad7$export$585a3b23e887288b; });

var $fbSBq = parcelRequire("fbSBq");

var $l4KzN = parcelRequire("l4KzN");
const $86bc11904dee6ad7$export$960a49cc3d27a090 = (0, $fbSBq.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
`;
const $86bc11904dee6ad7$export$585a3b23e887288b = (0, $fbSBq.default).div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  svg {
    margin-left: 4px;
    color: ${(0, $l4KzN).G400};
  }
`;

});



parcelRegister("8wGBJ", function(module, exports) {
$parcel$export(module.exports, "useWelcomePageActions", function () { return (parcelRequire("1KX2Q")).useWelcomePageActions; });
$parcel$export(module.exports, "useWelcomeSubmission", function () { return (parcelRequire("i3v1l")).useWelcomeSubmission; });
$parcel$export(module.exports, "useWelcomeState", function () { return (parcelRequire("dYBx0")).useWelcomeState; });
parcelRequire("1KX2Q");
parcelRequire("i3v1l");
parcelRequire("dYBx0");

});
parcelRegister("1KX2Q", function(module, exports) {

$parcel$export(module.exports, "useWelcomePageActions", function () { return $37ff9076c98d6b86$export$a7ba34b740a66255; });

var $dNMDr = parcelRequire("dNMDr");

var $aMBBA = parcelRequire("aMBBA");
parcelRequire("jM5Ly");
var $kKzDC = parcelRequire("kKzDC");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $jxlid = parcelRequire("jxlid");
const $37ff9076c98d6b86$export$a7ba34b740a66255 = ()=>{
    (0, $kfOJC.useRegisterComponent)($37ff9076c98d6b86$export$a7ba34b740a66255.name);
    const auth0Config = (0, $aMBBA.useAppSelector)((state)=>state.appConfig.auth0Config);
    const csrfToken = (0, $aMBBA.useAppSelector)((state)=>state.csrfToken);
    const email = (0, $aMBBA.useAppSelector)((state)=>state.welcome.email);
    const recoveryToken = (0, $aMBBA.useAppSelector)((state)=>state.welcome.recoveryToken);
    const redirectType = (0, $aMBBA.useAppSelector)((state)=>state.welcome.redirectType);
    const recoveryOptions = (0, $dNMDr.useMemo)(()=>{
        return recoveryToken && email ? {
            expectedEmail: email,
            recoveryToken: recoveryToken
        } : undefined;
    }, [
        email,
        recoveryToken
    ]);
    const handleGoogleLogin = (0, $kKzDC.useGoogleLoginHandler)({
        pageId: (0, $jxlid.WELCOME_PAGE_ID),
        redirectType: redirectType,
        redirectParams: {
            location: window.location,
            source: (0, $jxlid.WELCOME_PAGE_ID),
            recoveryOptions: recoveryOptions
        }
    });
    const { handleAppleLogin: handleAppleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleSlackLogin: handleSlackLogin } = (0, $kKzDC.useSocialLoginHandlers)({
        pageId: (0, $jxlid.WELCOME_PAGE_ID),
        redirectType: redirectType,
        redirectParams: {
            location: window.location,
            auth0Config: auth0Config,
            csrfToken: csrfToken,
            source: (0, $jxlid.WELCOME_PAGE_ID),
            email: email,
            recoveryOptions: recoveryOptions
        }
    });
    return {
        handleAppleLogin: handleAppleLogin,
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleSlackLogin: handleSlackLogin,
        handleGoogleLogin: handleGoogleLogin
    };
};

});

parcelRegister("i3v1l", function(module, exports) {

$parcel$export(module.exports, "useWelcomeSubmission", function () { return $20a20633741a8514$export$1a7f914df8351aa8; });

var $dNMDr = parcelRequire("dNMDr");

var $1JRGy = parcelRequire("1JRGy");

var $jjyqs = parcelRequire("jjyqs");

var $2CYmK = parcelRequire("2CYmK");
var $ko1o6 = parcelRequire("ko1o6");

var $aMBBA = parcelRequire("aMBBA");

var $enm1p = parcelRequire("enm1p");

var $fcxz7 = parcelRequire("fcxz7");

var $4NPio = parcelRequire("4NPio");

var $4eVYs = parcelRequire("4eVYs");

var $hqddj = parcelRequire("hqddj");

var $hzllM = parcelRequire("hzllM");
parcelRequire("jyAWB");
var $aI10X = parcelRequire("aI10X");
parcelRequire("H2Y2l");
var $kfOJC = parcelRequire("kfOJC");

var $jxlid = parcelRequire("jxlid");
parcelRequire("eWYtP");
var $7DOAh = parcelRequire("7DOAh");
parcelRequire("jM5Ly");
var $04aYR = parcelRequire("04aYR");

var $h4v4M = parcelRequire("h4v4M");
const $20a20633741a8514$var$subjectIds = {
    displayName: 'welcomeSignupNoName',
    password: 'welcomeSignupNoPassword',
    emailUsedAsName: 'welcomeSignupEmailUsedAsName',
    passwordUsedAsName: 'welcomeSignupPasswordUsedAsName'
};
const $20a20633741a8514$var$messages = (0, $2CYmK.defineMessages)({
    displayNameEmpty: {
        id: 'signup.form.displayName.empty',
        defaultMessage: 'Please enter a name'
    },
    displayNameIsEmail: {
        id: 'signup.form.displayName.is.email',
        defaultMessage: 'Please ensure your full name is not an email address'
    },
    displayNameIsPassword: {
        id: 'signup.form.displayName.is.password',
        defaultMessage: 'Please ensure your full name is not your password'
    },
    passwordEmpty: {
        id: 'signup.form.password.empty',
        defaultMessage: 'Please enter a password'
    },
    passwordMinimumRequirement: {
        id: 'signup.form.password.minimum',
        defaultMessage: 'Password must have at least 8 characters'
    }
});
const $20a20633741a8514$export$6f63e37550343081 = 8;
const $20a20633741a8514$export$1a7f914df8351aa8 = ({ autoRedirect: autoRedirect = true } = {})=>{
    (0, $kfOJC.useRegisterComponent)($20a20633741a8514$export$1a7f914df8351aa8.name);
    const navigate = (0, $h4v4M.useNavigateSoftOrHard)();
    const dispatch = (0, $aMBBA.useAppDispatch)();
    const analyticsClient = (0, $4NPio.useAnalyticsClient)();
    const intl = (0, $ko1o6.default)();
    const { fetchToken: fetchToken, recaptchaType: recaptchaType } = (0, $hzllM.useRecaptchaContext)();
    const { marketingConsent: marketingConsent } = (0, $aI10X.useWelcomePageContext)();
    const csrfToken = (0, $aMBBA.useAppSelector)((state)=>state.csrfToken);
    const redirectType = (0, $aMBBA.useAppSelector)((state)=>state.welcome.redirectType);
    const error = (0, $aMBBA.useAppSelector)((state)=>state.welcome.error);
    const fieldErrors = (0, $aMBBA.useAppSelector)((state)=>state.welcome.fieldErrors);
    const formError = (0, $aMBBA.useAppSelector)((state)=>state.welcome.formError);
    const isLoading = (0, $aMBBA.useAppSelector)((state)=>state.welcome.isLoading) ?? false;
    const redirectTo = (0, $aMBBA.useAppSelector)((state)=>state.welcome.redirectTo) ?? null;
    (0, $04aYR.useForceRedirect)({
        redirectTo: autoRedirect ? redirectTo : undefined
    });
    const { privacyPolicyText: privacyPolicyText } = (0, $aI10X.useWelcomePageContext)();
    const onWelcomeInputValidate = (0, $dNMDr.useCallback)((data)=>{
        const validationErrors = {};
        const { displayName: displayName, password: password } = data;
        const hasDisplayName = typeof displayName !== 'undefined';
        const hasPassword = typeof password !== 'undefined';
        if (hasDisplayName && displayName.trim() === '') validationErrors.displayName = intl.formatMessage($20a20633741a8514$var$messages.displayNameEmpty);
        if (hasPassword) {
            if (password.trim() === '') validationErrors.password = intl.formatMessage($20a20633741a8514$var$messages.passwordEmpty);
            else if (password.length < $20a20633741a8514$export$6f63e37550343081) validationErrors.password = intl.formatMessage($20a20633741a8514$var$messages.passwordMinimumRequirement);
        }
        if (hasDisplayName && (0, $7DOAh.emailRegex).test(displayName.trim())) validationErrors.emailUsedAsName = intl.formatMessage($20a20633741a8514$var$messages.displayNameIsEmail);
        if (hasDisplayName && hasPassword && displayName.toLowerCase().trim() === password.toLowerCase().trim()) validationErrors.passwordUsedAsName = intl.formatMessage($20a20633741a8514$var$messages.displayNameIsPassword);
        return validationErrors;
    }, [
        intl
    ]);
    const onWelcomeSubmit = (0, $dNMDr.useCallback)(async (data)=>{
        try {
            if (!privacyPolicyText) {
                console.error('Form cannot be submitted without showing Privacy Policy');
                return;
            }
            if (!marketingConsent) {
                console.error('Form cannot be submitted without showing Marketing Consent');
                return;
            }
            const validationErrors = onWelcomeInputValidate(data);
            if (Object.keys(validationErrors).length) {
                Object.keys(validationErrors).forEach((errorKey)=>analyticsClient.errorShownEvent((0, $jxlid.WELCOME_PAGE_ID), $20a20633741a8514$var$subjectIds[errorKey] || 'welcomeSignupUnknownUiError'));
                dispatch((0, $enm1p.showFieldErrors)(validationErrors));
                return;
            }
            const challengeResponse = await fetchToken();
            const { signature: signature, token: token } = (0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search);
            const welcomeToken = token || signature;
            const query = {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).parse(location.search)
            };
            navigate(`/signup/welcome?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(query)}`);
            const microbrandingParams = (0, $fcxz7.getMicrobrandingFromUrl)(location);
            analyticsClient.formSubmittedEvent((0, $jxlid.WELCOME_PAGE_ID), 'welcomeForm', {
                marketingConsent: (0, $jjyqs.dangerouslyCreateSafeString)(marketingConsent.state),
                redirectType: redirectType,
                recaptchaType: recaptchaType
            });
            await dispatch((0, $enm1p.welcome)({
                ...data,
                marketingConsentState: marketingConsent,
                privacyPolicyText: privacyPolicyText,
                microbrandingParams: microbrandingParams,
                challengeResponse: challengeResponse,
                password: data.password || '',
                token: welcomeToken || '',
                // TODO: Should not need this non-null assertion
                csrfToken: csrfToken
            }));
        } catch (e) {
            (0, $hqddj.captureException)(e);
            dispatch((0, $4eVYs.signupCaptchaFailure)(navigator.onLine));
        }
    }, [
        analyticsClient,
        csrfToken,
        dispatch,
        marketingConsent,
        navigate,
        onWelcomeInputValidate,
        privacyPolicyText,
        fetchToken,
        recaptchaType,
        redirectType
    ]);
    return {
        onWelcomeSubmit: onWelcomeSubmit,
        onWelcomeInputValidate: onWelcomeInputValidate,
        isLoading: isLoading,
        redirectTo: redirectTo,
        redirectType: redirectType,
        formError: formError,
        fieldErrors: fieldErrors,
        error: error
    };
};

});
parcelRegister("enm1p", function(module, exports) {

$parcel$export(module.exports, "showFieldErrors", function () { return $59976c802f9d6963$export$f17d5fd8029ff8d7; });
$parcel$export(module.exports, "welcome", function () { return $59976c802f9d6963$export$424aefd0ddb3521d; });

var $1JRGy = parcelRequire("1JRGy");

var $aDvvX = parcelRequire("aDvvX");

var $btezy = parcelRequire("btezy");

var $dJpcp = parcelRequire("dJpcp");
const $59976c802f9d6963$export$aad8462122ac592b = ()=>({
        type: 'WELCOME_SIGNUP_RESET'
    });
const $59976c802f9d6963$export$41790ce653e273fc = ()=>({
        type: 'WELCOME_SIGNUP_REQUEST'
    });
const $59976c802f9d6963$export$4d8221b509914ddc = (redirectTo)=>({
        type: 'WELCOME_SIGNUP_REQUEST_SUCCESS',
        redirectTo: redirectTo
    });
const $59976c802f9d6963$export$cacbe64ca8591e58 = (formError)=>({
        type: 'WELCOME_SIGNUP_REQUEST_FAILED',
        formError: formError
    });
const $59976c802f9d6963$export$f17d5fd8029ff8d7 = (errors)=>({
        type: 'WELCOME_SIGNUP_SHOW_FIELD_ERRORS',
        errors: errors
    });
const $59976c802f9d6963$export$424aefd0ddb3521d = (welcomeParams)=>async (dispatch, getState)=>{
        const { displayName: displayName, password: password, token: token, microbrandingParams: microbrandingParams, challengeResponse: challengeResponse, marketingConsentState: marketingConsentState, privacyPolicyText: privacyPolicyText, csrfToken: csrfToken } = welcomeParams;
        const castleToken = await (0, $dJpcp.getCastleRequestToken)([
            'capability-group--signup',
            'capability-name--signup'
        ]);
        const qs = microbrandingParams && Object.keys(microbrandingParams).length ? `?${(0, (/*@__PURE__*/$parcel$interopDefault($1JRGy))).stringify(microbrandingParams)}` : '';
        dispatch($59976c802f9d6963$export$41790ce653e273fc());
        let payload = {
            'challenge-response': (0, $btezy.toChallengeRequest)(challengeResponse),
            displayName: displayName,
            password: password,
            token: token,
            display: null,
            castleToken: castleToken
        };
        const marketingConsent = (0, $aDvvX.buildMarketingConsent)(getState().marketingConsent.config, marketingConsentState, privacyPolicyText);
        if (marketingConsent) payload = {
            ...payload,
            marketingConsent: marketingConsent
        };
        return fetch(`/rest/signup/welcome${qs}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json()).then(({ fieldErrors: fieldErrors, uiErrors: uiErrors, redirectTo: redirectTo })=>{
            if (redirectTo) dispatch($59976c802f9d6963$export$4d8221b509914ddc(redirectTo));
            else {
                if (uiErrors && uiErrors.length) dispatch($59976c802f9d6963$export$cacbe64ca8591e58(uiErrors[0].key));
                else if (fieldErrors && Object.keys(fieldErrors).length) dispatch($59976c802f9d6963$export$f17d5fd8029ff8d7(fieldErrors));
                else dispatch($59976c802f9d6963$export$cacbe64ca8591e58('unknown'));
            }
        }).catch(()=>{
            dispatch($59976c802f9d6963$export$cacbe64ca8591e58('unknown'));
        });
    };

});


parcelRegister("dYBx0", function(module, exports) {

$parcel$export(module.exports, "useWelcomeState", function () { return $21ccfecefd8a9f08$export$ac89f9e632e22c81; });

var $aMBBA = parcelRequire("aMBBA");
const $21ccfecefd8a9f08$export$ac89f9e632e22c81 = ()=>{
    const email = (0, $aMBBA.useAppSelector)((state)=>state.welcome.email);
    const displayName = (0, $aMBBA.useAppSelector)((state)=>state.welcome.displayName);
    return {
        displayName: displayName,
        email: email
    };
};

});



parcelRegister("ch0QI", function(module, exports) {
/**
 * True when the page was opened under Playwright integration tests.
 * Set from tests/playwright-test-fixtures.ts via addInitScript (before the app bundle runs).
 *
 * Prefer this over process.env.PW_TEST in UI code: Parcel only inlines env at bundle time, and a
 * locally reused dev server often does not have PW_TEST set.
 */ function $c80c3c2a74ff6595$export$ffec78b77e23aebc() {
    return typeof window !== 'undefined' && window.__IDAC_PLAYWRIGHT_INTEGRATION__ === true;
}

});

parcelRegister("2q0hh", function(module, exports) {

$parcel$export(module.exports, "NavigateToLogin", function () { return $60e0b7398bb82d11$export$596e9b679f1cf60f; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $cVnBY = parcelRequire("cVnBY");parcelRequire("lwrli");
var $cVnBY = parcelRequire("cVnBY");
function $60e0b7398bb82d11$export$596e9b679f1cf60f() {
    const { search: search } = (0, $cVnBY.useLocation)();
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $cVnBY.Navigate), {
        to: {
            pathname: '/login',
            search: search
        },
        replace: true
    });
}

});

parcelRegister("go9mp", function(module, exports) {

$parcel$export(module.exports, "MaybeComponentOrRedirectToLogin", function () { return $233564513618f48c$export$f05e44e3868f01f4; });

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $2q0hh = parcelRequire("2q0hh");
function $233564513618f48c$export$f05e44e3868f01f4({ component: Component, condition: _condition }) {
    // Ensure the condition at runtime is an expected type/shape to prevent issues at runtime
    if (typeof _condition !== 'function' && typeof _condition !== 'boolean') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2q0hh.NavigateToLogin), {});
    const condition = typeof _condition === 'function' ? _condition() : _condition;
    if (condition) return /*#__PURE__*/ (0, $6CtE1.jsx)(Component, {});
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $2q0hh.NavigateToLogin), {});
}

});



parcelRegister("djndf", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $9b0f0e44ff7e8ec7$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $9b0f0e44ff7e8ec7$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $9b0f0e44ff7e8ec7$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $9b0f0e44ff7e8ec7$export$e539f754e934e270; });
$parcel$export(module.exports, "timeUntilStale", function () { return $9b0f0e44ff7e8ec7$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "parseQueryArgs", function () { return $9b0f0e44ff7e8ec7$export$8a11fbc2c8ea08fd; });
$parcel$export(module.exports, "parseMutationArgs", function () { return $9b0f0e44ff7e8ec7$export$b646c531ea475334; });
$parcel$export(module.exports, "parseFilterArgs", function () { return $9b0f0e44ff7e8ec7$export$18e8f4b987e6c111; });
$parcel$export(module.exports, "matchQuery", function () { return $9b0f0e44ff7e8ec7$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $9b0f0e44ff7e8ec7$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $9b0f0e44ff7e8ec7$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $9b0f0e44ff7e8ec7$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashQueryKey", function () { return $9b0f0e44ff7e8ec7$export$5fcb678681417b54; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $9b0f0e44ff7e8ec7$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $9b0f0e44ff7e8ec7$export$e772c8ff12451969; });
$parcel$export(module.exports, "scheduleMicrotask", function () { return $9b0f0e44ff7e8ec7$export$4304cb76768ca134; });
$parcel$export(module.exports, "getAbortController", function () { return $9b0f0e44ff7e8ec7$export$382ca5d13a8f252c; });
$parcel$export(module.exports, "replaceData", function () { return $9b0f0e44ff7e8ec7$export$17619bac5b909b23; });
// TYPES
// UTILS
const $9b0f0e44ff7e8ec7$export$6acf61af03e62db = typeof window === 'undefined' || 'Deno' in window;
function $9b0f0e44ff7e8ec7$export$8793edee2d425525() {
    return undefined;
}
function $9b0f0e44ff7e8ec7$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $9b0f0e44ff7e8ec7$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $9b0f0e44ff7e8ec7$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $9b0f0e44ff7e8ec7$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $9b0f0e44ff7e8ec7$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $9b0f0e44ff7e8ec7$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$9b0f0e44ff7e8ec7$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $9b0f0e44ff7e8ec7$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($9b0f0e44ff7e8ec7$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === 'function') return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $9b0f0e44ff7e8ec7$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $9b0f0e44ff7e8ec7$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $9b0f0e44ff7e8ec7$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $9b0f0e44ff7e8ec7$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $9b0f0e44ff7e8ec7$export$c5d1efe363797780(filters, query) {
    const { type: type = 'all', exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($9b0f0e44ff7e8ec7$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $9b0f0e44ff7e8ec7$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$9b0f0e44ff7e8ec7$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== 'all') {
        const isActive = query.isActive();
        if (type === 'active' && !isActive) return false;
        if (type === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $9b0f0e44ff7e8ec7$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($9b0f0e44ff7e8ec7$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($9b0f0e44ff7e8ec7$export$5fcb678681417b54(mutation.options.mutationKey) !== $9b0f0e44ff7e8ec7$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$9b0f0e44ff7e8ec7$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $9b0f0e44ff7e8ec7$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $9b0f0e44ff7e8ec7$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $9b0f0e44ff7e8ec7$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$9b0f0e44ff7e8ec7$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $9b0f0e44ff7e8ec7$export$2f07189bb9fa26a7(a, b) {
    return $9b0f0e44ff7e8ec7$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $9b0f0e44ff7e8ec7$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some((key)=>!$9b0f0e44ff7e8ec7$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $9b0f0e44ff7e8ec7$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $9b0f0e44ff7e8ec7$export$7a8558113332b71e(a) && $9b0f0e44ff7e8ec7$export$7a8558113332b71e(b);
    if (array || $9b0f0e44ff7e8ec7$export$53b83ca8eaab0383(a) && $9b0f0e44ff7e8ec7$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $9b0f0e44ff7e8ec7$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $9b0f0e44ff7e8ec7$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $9b0f0e44ff7e8ec7$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $9b0f0e44ff7e8ec7$export$53b83ca8eaab0383(o) {
    if (!$9b0f0e44ff7e8ec7$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$9b0f0e44ff7e8ec7$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $9b0f0e44ff7e8ec7$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $9b0f0e44ff7e8ec7$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $9b0f0e44ff7e8ec7$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $9b0f0e44ff7e8ec7$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $9b0f0e44ff7e8ec7$export$4304cb76768ca134(callback) {
    $9b0f0e44ff7e8ec7$export$e772c8ff12451969(0).then(callback);
}
function $9b0f0e44ff7e8ec7$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
    return;
}
function $9b0f0e44ff7e8ec7$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === 'function') return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $9b0f0e44ff7e8ec7$export$77a71fc411098696(prevData, data);
    return data;
}

});

parcelRegister("8AhoM", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $63ff2e8b65f597d0$export$520687f44db6e1ab; });

var $djndf = parcelRequire("djndf");
function $63ff2e8b65f597d0$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $djndf.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $djndf.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $63ff2e8b65f597d0$export$520687f44db6e1ab = $63ff2e8b65f597d0$export$316a8efd03cd1458();

});

parcelRegister("6riFM", function(module, exports) {

$parcel$export(module.exports, "canFetch", function () { return $4b03bfc24d8c2df5$export$61b92f63f30245cf; });
$parcel$export(module.exports, "isCancelledError", function () { return $4b03bfc24d8c2df5$export$986cc6445c1d323; });
$parcel$export(module.exports, "createRetryer", function () { return $4b03bfc24d8c2df5$export$2cbd00fe8a2c8d85; });

var $guyFK = parcelRequire("guyFK");

var $4l6Tp = parcelRequire("4l6Tp");

var $djndf = parcelRequire("djndf");
function $4b03bfc24d8c2df5$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $4b03bfc24d8c2df5$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : 'online') === 'online' ? (0, $4l6Tp.onlineManager).isOnline() : true;
}
class $4b03bfc24d8c2df5$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $4b03bfc24d8c2df5$export$986cc6445c1d323(value) {
    return value instanceof $4b03bfc24d8c2df5$export$a8430ed4188f35a9;
}
function $4b03bfc24d8c2df5$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $4b03bfc24d8c2df5$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $guyFK.focusManager).isFocused() || config.networkMode !== 'always' && !(0, $4l6Tp.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $4b03bfc24d8c2df5$var$defaultRetryDelay;
            const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $djndf.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($4b03bfc24d8c2df5$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}

});
parcelRegister("guyFK", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $c01a57de6f76f4a0$export$6bf54661be5b02cf; });

var $3zGFk = parcelRequire("3zGFk");

var $djndf = parcelRequire("djndf");
class $c01a57de6f76f4a0$export$86f1af424b2ca4de extends (0, $3zGFk.Subscribable) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $djndf.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === 'boolean') this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    }
}
const $c01a57de6f76f4a0$export$6bf54661be5b02cf = new $c01a57de6f76f4a0$export$86f1af424b2ca4de();

});
parcelRegister("3zGFk", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $29a5bc7a39fee108$export$d26086b469ecdbcc; });
class $29a5bc7a39fee108$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}

});


parcelRegister("4l6Tp", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $328e785c2f360256$export$b113e788b2dd3fdc; });

var $3zGFk = parcelRequire("3zGFk");

var $djndf = parcelRequire("djndf");
const $328e785c2f360256$var$onlineEvents = [
    'online',
    'offline'
];
class $328e785c2f360256$export$58774fb55d5ff7fc extends (0, $3zGFk.Subscribable) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $djndf.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $328e785c2f360256$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $328e785c2f360256$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === 'boolean') this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    }
}
const $328e785c2f360256$export$b113e788b2dd3fdc = new $328e785c2f360256$export$58774fb55d5ff7fc();

});


parcelRegister("8h0co", function(module, exports) {

$parcel$export(module.exports, "Mutation", function () { return $606010bd50c64994$export$17b8b19c814bcf56; });
$parcel$export(module.exports, "getDefaultState", function () { return $606010bd50c64994$export$a1659b54bac3252a; });

var $1GcI8 = parcelRequire("1GcI8");

var $8AhoM = parcelRequire("8AhoM");

var $7JLTe = parcelRequire("7JLTe");

var $6riFM = parcelRequire("6riFM");
// CLASS
class $606010bd50c64994$export$17b8b19c814bcf56 extends (0, $7JLTe.Removable) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $1GcI8.defaultLogger);
        this.observers = [];
        this.state = config.state || $606010bd50c64994$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: 'observerAdded',
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: 'observerRemoved',
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === 'loading') this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $6riFM.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject('No mutationFn found');
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: 'failed',
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: 'pause'
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: 'continue'
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === 'loading';
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: 'loading',
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: 'error',
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        isPaused: true
                    };
                case 'continue':
                    return {
                        ...state,
                        isPaused: false
                    };
                case 'loading':
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $6riFM.canFetch)(this.options.networkMode),
                        status: 'loading',
                        variables: action.variables
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: 'success',
                        isPaused: false
                    };
                case 'error':
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: 'error'
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $8AhoM.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: 'updated',
                action: action
            });
        });
    }
}
function $606010bd50c64994$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}

});
parcelRegister("1GcI8", function(module, exports) {

$parcel$export(module.exports, "defaultLogger", function () { return $139392c7803f0e67$export$1cf3d545f2d4635c; });
const $139392c7803f0e67$export$1cf3d545f2d4635c = console;

});

parcelRegister("7JLTe", function(module, exports) {

$parcel$export(module.exports, "Removable", function () { return $5a21e250e4705dfc$export$e09608847fcc8c59; });

var $djndf = parcelRequire("djndf");
class $5a21e250e4705dfc$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $djndf.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $djndf.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

});


parcelRegister("11Ih9", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $0bf83aa529f2cf6a$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $0bf83aa529f2cf6a$export$45604f0cc8ae667b; });

var $dNMDr = parcelRequire("dNMDr");
'use client';
const $0bf83aa529f2cf6a$export$2fba198b5b2e37fa = /*#__PURE__*/ $dNMDr.createContext(undefined);
const $0bf83aa529f2cf6a$var$QueryClientSharingContext = /*#__PURE__*/ $dNMDr.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $0bf83aa529f2cf6a$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $0bf83aa529f2cf6a$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $0bf83aa529f2cf6a$export$2fba198b5b2e37fa;
}
const $0bf83aa529f2cf6a$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $dNMDr.useContext($0bf83aa529f2cf6a$var$getQueryClientContext(context, $dNMDr.useContext($0bf83aa529f2cf6a$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
const $0bf83aa529f2cf6a$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $dNMDr.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $0bf83aa529f2cf6a$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $dNMDr.createElement($0bf83aa529f2cf6a$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $dNMDr.createElement(Context.Provider, {
        value: client
    }, children));
};

});

var $ccdb0c931c9a0b61$exports = {};


(parcelRequire("k8vLt")).register((parcelRequire("4XRWO")).getBundleURL('ejQSx'), JSON.parse("[\"ejQSx\",\"index.bd17a93a.js\",\"h8LzF\",\"Error.7c4adcd3.svg\",\"bwi3C\",\"web-vitals.40aef2f5.js\",\"lJ1c6\",\"tti-polyfill.ccd17b18.js\",\"ilxvQ\",\"pt-BR.cdfe4870.js\",\"x1rx7\",\"en-ZZ.3bb4411b.js\",\"3Lm6O\",\"en-GB.82d8f9ec.js\",\"fTpNJ\",\"zh-CN.76e5bac6.js\",\"iPmMD\",\"zh-TW.2970c0d4.js\",\"lOU6n\",\"cs-CZ.bb0c86e7.js\",\"cNF11\",\"da-DK.00d72a41.js\",\"9Q3PI\",\"de-DE.4655a462.js\",\"9Dj5I\",\"en.04e2ee84.js\",\"dE5wW\",\"es.0bbbc585.js\",\"8MBE7\",\"fi-FI.458b699a.js\",\"2yZSu\",\"fr-FR.73a41fa9.js\",\"bJaMY\",\"hu-HU.ba20a29d.js\",\"hOU1D\",\"it-IT.2e18d74d.js\",\"ie85Y\",\"ja-JP.c170566c.js\",\"edy5m\",\"ko-KR.a0c83503.js\",\"c4W6g\",\"nb-NO.a3d27816.js\",\"fOkpb\",\"nl-NL.53ad0348.js\",\"laeVL\",\"pl-PL.b6549fbf.js\",\"5uTtl\",\"ru-RU.69c267ae.js\",\"5ta27\",\"sv-SE.9ed9cb95.js\",\"eqkmD\",\"th-TH.b1e8f4ea.js\",\"dS9Ar\",\"tr-TR.9eed5338.js\",\"3Wyuy\",\"uk-UA.eb0d1f6d.js\",\"kqHhv\",\"vi-VN.105c5f75.js\",\"dvlQd\",\"atlassian-light.9cb27768.js\",\"6zHu3\",\"atlassian-light-future.8e3ec27e.js\",\"eV5Jf\",\"atlassian-light-increased-contrast.26d2c109.js\",\"eiTOL\",\"atlassian-dark.29f7afcc.js\",\"bibVY\",\"atlassian-dark-future.5ce0e158.js\",\"ffA4W\",\"atlassian-dark-increased-contrast.49f551db.js\",\"jpCfe\",\"atlassian-spacing.26f52570.js\",\"eIocy\",\"atlassian-typography.3b641beb.js\",\"6xJS1\",\"atlassian-shape.6e1730dc.js\",\"eEqOZ\",\"atlassian-motion.c40cc678.js\",\"eNhc7\",\"custom-theme.e515b016.js\",\"93SJv\",\"atlassian-light.cc33fa1c.js\",\"4nn3b\",\"atlassian-light-future.7dd4ec6f.js\",\"fTWq6\",\"atlassian-light-increased-contrast.d3a11f87.js\",\"fIUtI\",\"atlassian-dark.2bf05f84.js\",\"63e8g\",\"atlassian-dark-future.61996895.js\",\"ivfVh\",\"atlassian-dark-increased-contrast.48aea0f5.js\",\"l1Arw\",\"atlassian-legacy-light.a8ae6995.js\",\"glsfC\",\"atlassian-legacy-dark.4c29b82e.js\",\"4EyWU\",\"atlassian-spacing.32048554.js\",\"57cME\",\"atlassian-typography.39172880.js\",\"l4Jcr\",\"atlassian-shape.5818dcee.js\",\"7DL2I\",\"custom-theme.fba6cdf2.js\",\"jGSOn\",\"MfaAppsPage.c47d6e15.js\",\"e6IET\",\"authy_icon.814b7ffa.png\",\"30oZI\",\"duo_icon.b136e666.png\",\"4oN1l\",\"google_authenticator_icon.e16260d2.png\",\"6485k\",\"other_app_icon.ccdea6b6.svg\",\"4ITbN\",\"check-your-email-open-letter.6c704b97.svg\",\"lC8NK\",\"default_left.558fbf68.svg\",\"eGxph\",\"default_right.f8462257.svg\",\"7fhrL\",\"atlassian-light.09218d20.js\",\"bbLkl\",\"atlassian-light-future.5ba9d8fc.js\",\"axwlS\",\"atlassian-light-increased-contrast.36198b62.js\",\"ey9yq\",\"atlassian-dark.b12740df.js\",\"2zMtf\",\"atlassian-dark-future.15b00cff.js\",\"jjNRK\",\"atlassian-dark-increased-contrast.eedd72a1.js\",\"LeMdV\",\"atlassian-spacing.34e69e82.js\",\"ezwib\",\"atlassian-typography.dfbfb485.js\",\"99Zh2\",\"atlassian-shape.b7d00461.js\",\"16lAV\",\"atlassian-motion.6e112c30.js\",\"aEErV\",\"custom-theme.fb16ad71.js\",\"5acau\",\"opsgenie-left.24f4de51.svg\",\"gNrPj\",\"opsgenie-right.1d06aa5c.svg\",\"adwFy\",\"statuspage-left.a78d710b.svg\",\"jcyKK\",\"statuspage-right.afc5eca0.svg\",\"iF6yP\",\"trello-left.fd2ac4a6.svg\",\"kGfFN\",\"trello-right.8236b2f3.svg\",\"jgfT9\",\"wac.d0cc6ec7.svg\",\"01MUY\",\"trust-and-security.e4fed227.svg\",\"noc2z\",\"MfaEnrollmentPage.bb065395.js\",\"2XL8w\",\"mfa-enable.f2e108a8.png\",\"4EJvY\",\"security-wall.93111abc.svg\",\"i5uGN\",\"lock-closed.186e8c46.svg\",\"avucS\",\"check-your-email.078c11ba.svg\",\"l8BDm\",\"save-recovery-key.36d66881.svg\",\"1q9Bw\",\"LoginConsentNoticePage.dc5b4308.js\",\"kv6pp\",\"fedramp.9e38ebea.js\",\"bXE8Y\",\"a53d6b63-3k57-1408-j79d-0b60b08kb685-privacy.79868fea.js\",\"611Eg\",\"2a85b822-1ba4-44ec-968a-c2f95bf4b469-privacy.dc3920ea.js\",\"dg7tT\",\"6e62b4f0-a2f3-4cb5-b61c-1bd397640f04-privacy.d25ac3c5.js\",\"g7gjK\",\"cancel-deletion-hourglass.2bcc1f2b.svg\",\"gutJf\",\"InactiveAccountPage.4188d733.js\",\"3oFDR\",\"lock.0922a994.svg\",\"hMBjB\",\"PendingDeletionPage.3089375a.js\",\"1NZsv\",\"DeletionRequestConfirmationPage.6d1b628f.js\",\"hAw8i\",\"main.291dfbb1.js\",\"cjCz5\",\"AuthCallbackErrorPage.c8378fcf.js\",\"lE7Tx\",\"SecurityExpiredLinkPage.31d26bec.js\",\"ebOv8\",\"SecuritySuccessPage.764c392d.js\",\"gFQec\",\"OAuthDAGTerminalPage.c6c2ee19.js\",\"g2WlZ\",\"MfaEnrollmentChooseMethodPage.374a3437.js\",\"grAbA\",\"MfaEnrollmentChooseMethodPage.c8de4709.js\",\"986Qf\",\"MfaEnrollmentConfigurePhonePage.75b5ce8d.js\",\"32KGK\",\"phone_black_message.b83c9523.png\",\"f7SVq\",\"MfaEnrollmentConfigurePhonePage.604f49ca.js\",\"aZY3H\",\"MfaEnrollmentConfigurePhonePage.d6038213.js\",\"anpZJ\",\"MfaEnrollmentConfigureAppPage.8097fa6f.js\",\"91ibQ\",\"configure_app_desktop.63617b37.svg\",\"8AAEq\",\"MfaEnrollmentSaveRecoveryKeyPage.a451b4f3.js\",\"8TVxa\",\"MfaEnrollmentRegisterSecurityKeyPage.26d569ce.js\",\"agGGW\",\"MfaEnrollmentRegisterSecurityKeyPage.e35fd2ed.js\",\"lkOUq\",\"MultiMfaEnrollmentAddAuthenticatorPage.217c3e29.js\",\"8NPbe\",\"MultiMfaEnrollmentAddAuthenticatorPage.d5b072d2.js\",\"3Y0YN\",\"MultiMfaEnrollmentAddSecurityKeyPage.7ea221d1.js\",\"lUTn9\",\"page.fba61f20.js\",\"fl6tH\",\"LoginPage.152614cc.js\",\"8UCkc\",\"LoginPage.56b8356f.js\",\"7DJ4a\",\"defaultPage.13c89ed6.js\",\"4Wkk5\",\"login-page.bb4778dc.js\",\"cXDVP\",\"login-page.facbc678.js\",\"cyZzM\",\"login-page.965ce0a4.js\",\"6RVpN\",\"login-page.92ffd28d.js\",\"bUA3n\",\"LoginPage.dcfacf23.js\",\"9bd5J\",\"apple-logo.23825a4f.svg\",\"3aQRN\",\"google-logo.5462b711.svg\",\"2DsdG\",\"microsoft-logo.c73d8dca.svg\",\"7cfGv\",\"slack-logo.9621bf1a.svg\",\"dan2M\",\"loom-atlassian-logo.db2a9cbc.svg\",\"1PclR\",\"LoginPage.161fdf6e.js\",\"1szxw\",\"loginPage.dabdbfb3.js\",\"cHqFA\",\"LoginPage.ed93f0d6.js\",\"3U19m\",\"key-logo.6d28e5f0.svg\",\"hoKVP\",\"LoginPage.62a3f9d8.js\",\"hhkAX\",\"LoginPage.9f8d9894.js\",\"72Tfu\",\"LoginPage.e63a7a4d.js\",\"9meHj\",\"BasePage.9cd55b4a.js\",\"3UJH3\",\"page.df408de0.js\",\"hSbuL\",\"CreateAccountConfirmationPage.5abdd337.js\",\"5KGj3\",\"defaultPage.ef3d5564.js\",\"JMDnk\",\"defaultPage.ca74532a.js\",\"2O4cc\",\"defaultPage.06ddb1e0.js\",\"hdvCV\",\"defaultPage.9062e6ea.js\",\"8py86\",\"defaultPage.ba36e02f.js\",\"h3CCS\",\"defaultPage.ad510016.css\",\"7Abv0\",\"defaultPage.6a7bcd9f.js\",\"hkCE2\",\"defaultPage.22aa4cf9.js\",\"fvRnT\",\"defaultPage.9137b798.css\",\"5jn2v\",\"SocialWelcomePage.4f03eba3.js\",\"9XZvs\",\"SocialWelcomePage.48a0d6cd.js\",\"gUvy1\",\"routing-middleware.d113d6ad.js\",\"hYZUb\",\"ajs-destination.f2983fae.js\",\"dQ3Ot\",\"legacy-video-plugins.a9ede3f5.js\",\"9qG7l\",\"index.umd.b35f00a7.js\",\"e91dT\",\"schema-filter.13b80391.js\",\"hT7Ou\",\"remote-middleware.0ecfb680.js\",\"fLmdS\",\"auto-track.e53f700d.js\",\"63lBy\",\"query-string.7d8891d9.js\",\"alN9y\",\"SocialWelcomePage.3d7e72bb.js\",\"5H3Mk\",\"SocialWelcomePage.6e775037.js\",\"hd4jx\",\"SocialWelcomePage.3680783e.css\",\"7DG6E\",\"SocialWelcomePage.806fb104.js\",\"1RuGY\",\"SocialWelcomePage.58caf56a.css\",\"ch3Tw\",\"SocialWelcomePage.1e9c26a9.js\",\"73R71\",\"SocialWelcomePage.69b06091.css\",\"jLxoV\",\"SocialWelcomePage.5373e752.js\",\"dX4rL\",\"SocialWelcomePage.87377f8c.css\",\"2lSir\",\"SocialWelcomePage.ad0b0d50.js\",\"bgnKH\",\"SocialWelcomePage.a6712b77.css\",\"6xguF\",\"page.9be40610.js\",\"42iMd\",\"WelcomePage.574bc978.js\",\"amrZt\",\"defaultPage.a86d63f3.js\",\"7CwGs\",\"defaultPage.4b160ac9.js\",\"eSAq4\",\"defaultPage.86d238f0.css\",\"91zOo\",\"defaultPage.d7556650.js\",\"giMms\",\"defaultPage.69abfbac.css\",\"gvUDN\",\"WelcomePage.75ae4384.js\",\"1IZ1R\",\"WelcomePage.729a6764.js\",\"aOhsw\",\"WelcomePage.0ea6f073.css\",\"1Paq8\",\"WelcomePage.a83f7020.js\",\"f4gAT\",\"WelcomePage.9730db88.css\",\"jW8Oe\",\"WelcomePage.8d760034.js\",\"jKsDI\",\"WelcomePage.0c635017.css\",\"kejWB\",\"WelcomePage.9a294a19.js\",\"btjXY\",\"WelcomePage.ac1870d2.css\",\"jJgRj\",\"WelcomePage.7137e87e.js\",\"joYeY\",\"WelcomePage.e9e069dd.css\",\"glyy8\",\"WelcomePage.53ac52fa.js\",\"ffYht\",\"WelcomePage.ed8cc5c6.js\",\"jJliJ\",\"WelcomePage.379d8db8.js\",\"6lSHy\",\"page.5ab557d1.js\",\"s8dk1\",\"OrchestratedPage.3738ce83.js\",\"2Kibw\",\"VerifyEmailOtpPage.f3869945.js\",\"i31bP\",\"defaultPage.38f221cd.js\",\"6GIAZ\",\"defaultPage.6e2a1965.js\",\"5grUq\",\"defaultPage.f89a9a38.css\",\"82NUH\",\"defaultPage.63904313.js\",\"jRQo6\",\"defaultPage.bbaba178.css\",\"eMe2m\",\"OtpPage.ae12e32a.js\",\"ecjVW\",\"OtpPage.6149f097.js\",\"3ZTVb\",\"OtpPage.dde72b48.css\",\"gdcac\",\"OtpPage.f6a364e7.js\",\"iIFUa\",\"OtpPage.e7cbcea2.css\",\"30Wfa\",\"OtpPage.7cc21f19.js\",\"gAUg9\",\"OtpPage.1c1dca19.css\",\"c6oQJ\",\"OtpPage.83d07a63.js\",\"eJjWJ\",\"OtpPage.4b037b50.css\",\"9NCMk\",\"OtpPage.9fadacd5.js\",\"gK2Gl\",\"OtpPage.e8ae9ef5.css\",\"hjZim\",\"OtpPage.26a450c8.js\",\"knNbb\",\"page.1b98f3da.js\",\"bUjne\",\"OrchestratedPage.3830e8e3.js\",\"e4OI3\",\"BasePage.047cc8cc.js\",\"4bz2D\",\"page.c4d34995.js\",\"fB1w6\",\"SignupPage.683494ff.js\",\"cMmrp\",\"SignupPage.8ea4426a.js\",\"9BnTK\",\"colby.9b10f128.png\",\"4FJFZ\",\"signup-page.c01045ea.js\",\"ieZI1\",\"signup-page.9353b813.js\",\"6630N\",\"signup-page.0dbce0b3.js\",\"CSTuO\",\"signup-page.327b647f.js\",\"9bCBn\",\"SignupPage.24a745ca.js\",\"4el7h\",\"trello-icon-dark-mode.077e35e8.svg\",\"4Pw0N\",\"trello-icon-light-mode.b5fd47d7.svg\",\"hUnyk\",\"trello-logo-dark-mode.7bc8846c.svg\",\"e2IQt\",\"trello-logo-light-mode.c315f5c7.svg\",\"4O9HQ\",\"taco-smile.f5298f56.png\",\"ggM3F\",\"intro-arrow.7fbe4c96.png\",\"ktNGV\",\"chrome-dark.5ec04c18.png\",\"fJjcC\",\"chrome-small-dark.efdd257f.png\",\"jt3t0\",\"chrome-small.08b91d16.png\",\"lADci\",\"chrome-x-small-dark.3a76d7fe.png\",\"esJNM\",\"chrome-x-small.edd0d843.png\",\"bhaIR\",\"chrome.7802e71a.png\",\"ewsRl\",\"email-dark.196a4dce.png\",\"4Gl7I\",\"email-no-arrow-dark.f6011cf1.png\",\"1KY9T\",\"email-no-arrow.d868ae6f.png\",\"2QU9S\",\"email-small-dark.c09080ab.png\",\"7PW4e\",\"email-small.a3eeee39.png\",\"9gNRL\",\"email.dabbdc9f.png\",\"2cArF\",\"eyelash5.088d2ad5.png\",\"d5WGI\",\"messaging-dark.13ecb00d.png\",\"dwrCJ\",\"messaging-small-dark.9f902689.png\",\"dQvUv\",\"messaging-small.851fcaef.png\",\"ihJfq\",\"messaging-x-small-dark.027eecc6.png\",\"amDrg\",\"messaging-x-small.a4f8fc6f.png\",\"2cGeU\",\"messaging.2adf3b63.png\",\"f9BuF\",\"mobile-dark.3ce03245.png\",\"5igPx\",\"mobile-small-dark.106bb245.png\",\"jwseD\",\"mobile-small.46c22ce8.png\",\"4IYkf\",\"mobile.410eb0f8.png\",\"QOsbs\",\"taco-celebrate.3e59946e.png\",\"8os6z\",\"taco-side.f5785c5f.png\",\"wdizF\",\"taco-tongue.59918be6.png\",\"kF6q6\",\"taco-wink.f3182c51.png\",\"6dyEY\",\"dnd-arrow.8c55a0c7.png\",\"bo734\",\"left-eyelash-light.1c1dbf4b.png\",\"4Dbs1\",\"left-eyelash-dark.2b961974.png\",\"igIdw\",\"right-eyelash-light.58601fc6.png\",\"ivLE0\",\"right-eyelash-dark.07eec4f7.png\",\"kzD6i\",\"done-arrow.93ece2c1.png\",\"iEL5y\",\"SignupPage.d4572648.js\",\"03IvR\",\"page.2ca67ad8.js\",\"4rpm2\",\"SignupOnboardPage.a39b9898.js\",\"P7JLC\",\"BasePage.4c45e397.js\",\"iUMj0\",\"LoomWorkspaceCreationPage.3cefdbd7.js\",\"1S2Aa\",\"FeatureGateDevPanel.92c4869d.js\",\"8LuZ4\",\"index.19f82625.css\"]"));


var $6CtE1 = parcelRequire("6CtE1");
/**
 * CoreJS https://github.com/zloirock/core-js
 * Our package.json['browserslist'] drives how Parcel/swc polyfills our application.
 * However we want to manually polyfill a handful of features that enables more of the application for more users.
 */ 

parcelRequire("dNMDr");
var $7135d72a7fc63708$export$882461b6382ed46c;
var $7135d72a7fc63708$export$757ceba2d55c277e;
'use strict';

var $9ZCME = parcelRequire("9ZCME");
var $7135d72a7fc63708$var$i;
$7135d72a7fc63708$export$882461b6382ed46c = $9ZCME.createRoot;
$7135d72a7fc63708$export$757ceba2d55c277e = $9ZCME.hydrateRoot;


parcelRequire("a09DY");
var $gGx1I = parcelRequire("gGx1I");

var $3Wc5s = parcelRequire("3Wc5s");

var $j31XW = parcelRequire("j31XW");

var $hqddj = parcelRequire("hqddj");

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $aC9Kp = parcelRequire("aC9Kp");

var $hqddj = parcelRequire("hqddj");

var $aMBBA = parcelRequire("aMBBA");

























const $0097bf9d8a41585c$var$languages = {
    'pt-BR': ()=>(parcelRequire("i6A4M")),
    'en-ZZ': ()=>(parcelRequire("b7mNj")),
    'en-GB': ()=>(parcelRequire("lTHrZ")),
    'zh-CN': ()=>(parcelRequire("c2MMA")),
    'zh-TW': ()=>(parcelRequire("fCGKV")),
    cs: ()=>(parcelRequire("gcR07")),
    da: ()=>(parcelRequire("eVTeT")),
    de: ()=>(parcelRequire("3ZPE5")),
    en: ()=>(parcelRequire("gMXqC")),
    es: ()=>(parcelRequire("jf0pv")),
    fi: ()=>(parcelRequire("1KYmT")),
    fr: ()=>(parcelRequire("drjc9")),
    hu: ()=>(parcelRequire("2DGyD")),
    it: ()=>(parcelRequire("3ECH4")),
    ja: ()=>(parcelRequire("76W9C")),
    ko: ()=>(parcelRequire("9iquk")),
    nb: ()=>(parcelRequire("kdUZk")),
    nl: ()=>(parcelRequire("41Mg3")),
    pl: ()=>(parcelRequire("ikC6M")),
    ru: ()=>(parcelRequire("dY5GJ")),
    sv: ()=>(parcelRequire("goWNu")),
    th: ()=>(parcelRequire("62P2k")),
    tr: ()=>(parcelRequire("34ThY")),
    uk: ()=>(parcelRequire("kcSWi")),
    vi: ()=>(parcelRequire("l0GNM"))
};
const $0097bf9d8a41585c$var$fetchLanguage = async (locale)=>{
    if (locale in $0097bf9d8a41585c$var$languages) {
        const messages = await $0097bf9d8a41585c$var$languages[locale]();
        return {
            locale: locale,
            messages: messages.default || messages
        };
    }
    throw new Error(`${locale} not found in languages config`);
};
const $0097bf9d8a41585c$var$LocaleSwitcher = ({ children: children })=>{
    const locale = (0, $aMBBA.useAppSelector)((state)=>state.locale);
    const [fallbackLocale] = locale.split('-', 1);
    const [{ loading: loading, messages: messages, derivedLocale: derivedLocale }, setState] = (0, $dNMDr.useState)({
        loading: true,
        messages: {},
        derivedLocale: locale
    });
    (0, $dNMDr.useEffect)(()=>{
        $0097bf9d8a41585c$var$fetchLanguage(locale).catch(()=>$0097bf9d8a41585c$var$fetchLanguage(fallbackLocale)).then((i18n)=>{
            setState({
                loading: false,
                messages: i18n.messages,
                derivedLocale: i18n.locale
            });
        }, ()=>{
            const content = `no translations were found for localeId ${locale} or fallbackLocale ${fallbackLocale}.`;
            console.debug(content);
            (0, $hqddj.captureErrorMessage)('i18n_fetch_language_error', {
                content: content,
                locale: locale,
                fallbackLocale: fallbackLocale
            });
            setState((prevState)=>({
                    ...prevState,
                    loading: false
                }));
        });
    }, [
        locale,
        fallbackLocale
    ]);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $aC9Kp.default), {
        locale: derivedLocale,
        messages: messages,
        children: loading ? /*#__PURE__*/ (0, $6CtE1.jsx)((0, $6CtE1.Fragment), {}) : children
    });
};
var $0097bf9d8a41585c$export$2e2bcd8739ae039 = $0097bf9d8a41585c$var$LocaleSwitcher;



var $iy2Wm = parcelRequire("iy2Wm");

var $dJpcp = parcelRequire("dJpcp");

var $6CtE1 = parcelRequire("6CtE1");
parcelRequire("dNMDr");

var $4NPio = parcelRequire("4NPio");

var $ko1o6 = parcelRequire("ko1o6");

var $aMBBA = parcelRequire("aMBBA");
const $9058de5c155267ae$var$AnalyticsClientProvider = ({ children: children })=>{
    const { locale: locale } = (0, $ko1o6.default)();
    const cobranding = (0, $aMBBA.useAppSelector)((state)=>state.cobranding);
    const microbranding = (0, $aMBBA.useAppSelector)((state)=>state.microbranding);
    const tenantCloudId = (0, $aMBBA.useAppSelector)((state)=>state.context.tenantCloudId);
    const userId = (0, $aMBBA.useAppSelector)((state)=>state.context.userId);
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $4NPio.AnalyticsClientContext).Provider, {
        value: new (0, $4NPio.AnalyticsClientImpl)({
            cobranding: cobranding,
            locale: locale,
            microbranding: microbranding,
            tenantCloudId: tenantCloudId,
            userId: userId
        }),
        children: children
    });
};
var $9058de5c155267ae$export$2e2bcd8739ae039 = $9058de5c155267ae$var$AnalyticsClientProvider;



var $lUetB = parcelRequire("lUetB");
parcelRequire("9mgZH");
var $lxj18 = parcelRequire("lxj18");

var $aMBBA = parcelRequire("aMBBA");

var $djndf = parcelRequire("djndf");

var $djndf = parcelRequire("djndf");

var $djndf = parcelRequire("djndf");

var $1GcI8 = parcelRequire("1GcI8");

var $8AhoM = parcelRequire("8AhoM");

var $6riFM = parcelRequire("6riFM");

var $7JLTe = parcelRequire("7JLTe");
// CLASS
class $cf96ec20258e5fb6$export$62297b13309008b2 extends (0, $7JLTe.Removable) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $1GcI8.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $cf96ec20258e5fb6$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === 'idle') this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $djndf.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $djndf.noop)).catch((0, $djndf.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $djndf.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== 'idle') {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $djndf.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, 'signal', {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $6riFM.isCancelledError)(error) && error.silent)) this.dispatch({
                type: 'error',
                error: error
            });
            if (!(0, $6riFM.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $6riFM.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === 'undefined') {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: 'failed',
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: 'pause'
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        fetchStatus: 'paused'
                    };
                case 'continue':
                    return {
                        ...state,
                        fetchStatus: 'fetching'
                    };
                case 'fetch':
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $6riFM.canFetch)(this.options.networkMode) ? 'fetching' : 'paused',
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: 'loading'
                        }
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: 'success',
                        ...!action.manual && {
                            fetchStatus: 'idle',
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case 'error':
                    const error = action.error;
                    if ((0, $6riFM.isCancelledError)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: 'idle'
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: 'idle',
                        status: 'error'
                    };
                case 'invalidate':
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $8AhoM.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: 'updated',
                action: action
            });
        });
    }
}
function $cf96ec20258e5fb6$var$getDefaultState(options) {
    const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    const hasData = typeof data !== 'undefined';
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? 'success' : 'loading',
        fetchStatus: 'idle'
    };
}



var $8AhoM = parcelRequire("8AhoM");

var $3zGFk = parcelRequire("3zGFk");
// CLASS
class $3e8fd0cb5d1f68b6$export$5dde0cd941da8468 extends (0, $3zGFk.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $djndf.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $cf96ec20258e5fb6$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'added',
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'removed',
                query: query
            });
        }
    }
    clear() {
        (0, $8AhoM.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ find(arg1, arg2) {
        const [filters] = (0, $djndf.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find((query)=>(0, $djndf.matchQuery)(filters, query));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ findAll(arg1, arg2) {
        const [filters] = (0, $djndf.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $djndf.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $8AhoM.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $8AhoM.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $8AhoM.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}



var $8AhoM = parcelRequire("8AhoM");

var $8h0co = parcelRequire("8h0co");

var $djndf = parcelRequire("djndf");

var $3zGFk = parcelRequire("3zGFk");
// CLASS
class $3c7b6f9c2a27f264$export$1fcfd9a244434844 extends (0, $3zGFk.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $8h0co.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: 'added',
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: 'removed',
            mutation: mutation
        });
    }
    clear() {
        (0, $8AhoM.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find((mutation)=>(0, $djndf.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $djndf.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $8AhoM.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $8AhoM.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $djndf.noop))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}



var $guyFK = parcelRequire("guyFK");

var $4l6Tp = parcelRequire("4l6Tp");

var $8AhoM = parcelRequire("8AhoM");
function $418dcb4fbce9695c$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, 'signal', {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener('abort', ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $418dcb4fbce9695c$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $418dcb4fbce9695c$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === 'undefined';
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $418dcb4fbce9695c$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $418dcb4fbce9695c$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $418dcb4fbce9695c$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $418dcb4fbce9695c$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $418dcb4fbce9695c$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $418dcb4fbce9695c$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $418dcb4fbce9695c$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



var $1GcI8 = parcelRequire("1GcI8");
// CLASS
class $05a1e223aeab3cd0$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $3e8fd0cb5d1f68b6$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $3c7b6f9c2a27f264$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $1GcI8.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $guyFK.focusManager).subscribe(()=>{
            if ((0, $guyFK.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $4l6Tp.onlineManager).subscribe(()=>{
            if ((0, $4l6Tp.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ isFetching(arg1, arg2) {
        const [filters] = (0, $djndf.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = 'fetching';
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    /**
   * @deprecated This method will accept only queryKey in the next major version.
   */ getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $djndf.parseQueryArgs)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $djndf.functionalUpdate)(updater, prevData);
        if (typeof data === 'undefined') return undefined;
        const parsedOptions = (0, $djndf.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $8AhoM.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, /**
   * @deprecated This filters will be removed in the next major version.
   */ filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ removeQueries(arg1, arg2) {
        const [filters] = (0, $djndf.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $8AhoM.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $djndf.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: 'active',
            ...filters
        };
        return (0, $8AhoM.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $djndf.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        const promises = (0, $8AhoM.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $djndf.noop)).catch((0, $djndf.noop));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $djndf.parseFilterArgs)(arg1, arg2, arg3);
        return (0, $8AhoM.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === 'none') return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $djndf.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, $8AhoM.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $djndf.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $djndf.noop));
        return promise;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $djndf.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $djndf.noop)).catch((0, $djndf.noop));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $djndf.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $418dcb4fbce9695c$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $djndf.noop)).catch((0, $djndf.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $djndf.hashQueryKey)(queryKey) === (0, $djndf.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $djndf.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $djndf.hashQueryKey)(mutationKey) === (0, $djndf.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $djndf.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $djndf.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === 'undefined') defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
        if (typeof defaultedOptions.useErrorBoundary === 'undefined') defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}


var $11Ih9 = parcelRequire("11Ih9");
parcelRequire("98ins");
var $33fjn = parcelRequire("33fjn");

var $fRBl4 = parcelRequire("fRBl4");

var $6CtE1 = parcelRequire("6CtE1");

var $dNMDr = parcelRequire("dNMDr");

var $dNMDr = parcelRequire("dNMDr");

var $elt8p = parcelRequire("elt8p");

var $iOto8 = parcelRequire("iOto8");

var $3EVJS = parcelRequire("3EVJS");
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $0896f84ebfcf6539$var$AppProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'light' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme, routerLinkComponent = _ref.routerLinkComponent, UNSAFE_isThemingDisabled = _ref.UNSAFE_isThemingDisabled;
    var isInsideAppProvider = (0, $elt8p.useIsInsideAppProvider)();
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    var routerLinkProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $iOto8.default), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $elt8p.InsideAppProviderContext).Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNMDr))).createElement((0, $3EVJS.default), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider));
}
var $0896f84ebfcf6539$export$2e2bcd8739ae039 = $0896f84ebfcf6539$var$AppProvider;



var $lwrli = parcelRequire("lwrli");
/**
 * This component is used to replace Atlaskit linking components with links that use react-router-dom for navigation.
 * The AppProvider determines when to use this component (it does not replace all Atlaskit linking components).
 * See https://atlassian.design/components/primitives/anchor/examples#router-links for more details.
 */ const $1e58661b2d1dafaa$var$RouterLinkComponent = /*#__PURE__*/ (0, $dNMDr.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    if (typeof href === 'string') return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.Link), {
        ref: ref,
        to: href,
        ...rest,
        children: children
    });
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.Link), {
        ref: ref,
        ...href,
        ...rest,
        children: children
    });
});
$1e58661b2d1dafaa$var$RouterLinkComponent.displayName = 'RouterLinkComponent';
const $1e58661b2d1dafaa$var$AppProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $6CtE1.jsx)((0, $0896f84ebfcf6539$export$2e2bcd8739ae039), {
        routerLinkComponent: $1e58661b2d1dafaa$var$RouterLinkComponent,
        children: children
    });
};
var $1e58661b2d1dafaa$export$2e2bcd8739ae039 = $1e58661b2d1dafaa$var$AppProvider;



var $lwrli = parcelRequire("lwrli");

var $8GnY0 = parcelRequire("8GnY0");

var $hhYxc = parcelRequire("hhYxc");
// Render a spinner to remove the "failed to load scripts" error while loading the app
const $d785722f721b4933$var$container = document.getElementById('root');
const $d785722f721b4933$var$root = (0, $7135d72a7fc63708$export$882461b6382ed46c)($d785722f721b4933$var$container);
$d785722f721b4933$var$root.render(/*#__PURE__*/ (0, $6CtE1.jsx)("div", {
    style: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $3Wc5s.default), {
        size: "large"
    })
}));
const $d785722f721b4933$var$preloadedState = (0, $iy2Wm.preloadAppState)();
(0, $iy2Wm.buildInitialState)($d785722f721b4933$var$preloadedState).then(async (initialState)=>{
    const { initialStoreState: initialStoreState, cspNonce: cspNonce } = initialState;
    (0, $hqddj.initClient)(initialStoreState.microbranding);
    const analyticsClient = (0, $iy2Wm.createAnalyticsClient)(initialState);
    const anonymousId = analyticsClient.getAnonymousId();
    (0, $hqddj.setUserId)(anonymousId);
    (0, $hqddj.setAnonymousIdTag)(anonymousId);
    (0, $iy2Wm.startupAnalyticEvent)(analyticsClient);
    (0, $lxj18.startBrowserMetrics)(analyticsClient);
    const ffsId = (0, $fRBl4.getFfsId)();
    if (ffsId) analyticsClient.setFfsId(ffsId);
    (0, $iy2Wm.pushGlobals)(initialStoreState.appConfig, cspNonce);
    const store = (0, $aMBBA.createAppStore)(initialStoreState);
    if (!initialStoreState.appConfig) (0, $hqddj.addBreadcrumb)({
        level: 'error',
        message: 'Unable to retrieve appConfig during buildInitialState'
    });
    (0, $dJpcp.initCastle)(initialStoreState.appConfig);
    const queryClient = new (0, $05a1e223aeab3cd0$export$405d0624ed55a03f)({
        defaultOptions: {
            queries: {
                retry: false
            }
        }
    });
    $d785722f721b4933$var$root.render(/*#__PURE__*/ (0, $6CtE1.jsx)((0, $gGx1I.default), {
        store: store,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $0097bf9d8a41585c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $j31XW.default), {
                analyticsClient: analyticsClient,
                children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $1e58661b2d1dafaa$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $11Ih9.QueryClientProvider), {
                        client: queryClient,
                        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $9058de5c155267ae$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $6CtE1.jsxs)((0, $33fjn.FeatureGateProvider), {
                                children: [
                                    (0, $hhYxc.isFedM)() && /*#__PURE__*/ (0, $6CtE1.jsx)((0, $8GnY0.default), {
                                        context: "root"
                                    }),
                                    /*#__PURE__*/ (0, $6CtE1.jsx)((0, $lwrli.RouterProvider), {
                                        router: (0, $lUetB.router)
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    }));
}).catch((error)=>{
    (0, $hqddj.captureException)(error);
    const emptyStore = (0, $aMBBA.createAppStore)({});
    $d785722f721b4933$var$root.render(/*#__PURE__*/ (0, $6CtE1.jsx)((0, $gGx1I.default), {
        store: emptyStore,
        children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $0097bf9d8a41585c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $6CtE1.jsx)((0, $j31XW.UnexpectedApplicationErrorPage), {})
        })
    }));
});

})();
//# sourceMappingURL=index.bd17a93a.js.map
